'use strict';
var $i_$002e$002fshowcase$002fapp$002fMontserrat$002dBlack$002ettf = require("./showcase/app/Montserrat-Black.ttf");
var $i_$002e$002fshowcase$002fapp$002fexpo$002epng = require("./showcase/app/expo.png");
var $i_$002e$002fshowcase$002fapp$002fuser$002epng = require("./showcase/app/user.png");
var $i_$0040expo$002fvector$002dicons = require("@expo/vector-icons");
var $i_$0040react$002dnative$002dpicker$002fpicker = require("@react-native-picker/picker");
var $i_$0040react$002dnavigation$002fbottom$002dtabs = require("@react-navigation/bottom-tabs");
var $i_$0040react$002dnavigation$002fnative = require("@react-navigation/native");
var $i_$0040react$002dnavigation$002fstack = require("@react-navigation/stack");
var $i_entities = require("entities");
var $i_expo$002dasset = require("expo-asset");
var $i_expo$002dav = require("expo-av");
var $i_expo$002dfont = require("expo-font");
var $i_expo$002dsqlite = require("expo-sqlite");
var $i_react = require("react");
var $i_react$002dnative = require("react-native");
var $i_react$002dnative$002dhtmlview = require("react-native-htmlview");
var $i_react$002dnative$002dsafe$002darea$002dcontext = require("react-native-safe-area-context");
var $i_react$002dnative$002dsvg = require("react-native-svg");
var $i_react$002dnative$002dsyntax$002dhighlighter = require("react-native-syntax-highlighter");
var $i_react$002dnative$002dwebview = require("react-native-webview");
var $i_react$002dredux = require("react-redux");
var $i_react$002dsyntax$002dhighlighter$002fstyles$002fhljs = require("react-syntax-highlighter/styles/hljs");
var $i_redux = require("redux");
var $linkingInfo = Object.freeze({
  "assumingES6": false,
  "productionMode": false,
  "linkerVersion": "1.5.1",
  "fileLevelThis": this
});
var $imul = (Math.imul || (function(a, b) {
  var ah = (a >>> 16);
  var al = (a & 65535);
  var bh = (b >>> 16);
  var bl = (b & 65535);
  return (((al * bl) + ((((ah * bl) + (al * bh)) << 16) >>> 0)) | 0)
}));
var $fround = (Math.fround || (function(v) {
  return (+v)
}));
var $clz32 = (Math.clz32 || (function(i) {
  if ((i === 0)) {
    return 32
  };
  var r = 1;
  if (((i & (-65536)) === 0)) {
    i = (i << 16);
    r = (r + 16)
  };
  if (((i & (-16777216)) === 0)) {
    i = (i << 8);
    r = (r + 8)
  };
  if (((i & (-268435456)) === 0)) {
    i = (i << 4);
    r = (r + 4)
  };
  if (((i & (-1073741824)) === 0)) {
    i = (i << 2);
    r = (r + 2)
  };
  return (r + (i >> 31))
}));
var $is = (Object.is || (function(x, y) {
  return ((x === y) ? ((x !== 0) || ((1 / x) === (1 / y))) : ((x !== x) && (y !== y)))
}));
var $privateJSFieldSymbol = (((typeof Symbol) !== "undefined") ? Symbol : (function(description) {
  function rand32() {
    var s = ((Math.random() * 4.294967296E9) | 0).toString(16);
    return ("00000000".substring(s.length) + s)
  }
  return (description + (((rand32() + rand32()) + rand32()) + rand32()))
}));
var $getOwnPropertyDescriptors = (Object.getOwnPropertyDescriptors || (function() {
  var ownKeysFun;
  if ((((typeof Reflect) !== "undefined") && Reflect.ownKeys)) {
    ownKeysFun = Reflect.ownKeys
  } else {
    var getOwnPropertySymbols = (Object.getOwnPropertySymbols || (function(o) {
      return []
    }));
    ownKeysFun = (function(o) {
      return Object.getOwnPropertyNames(o).concat(getOwnPropertySymbols(o))
    })
  };
  return (function(o) {
    var ownKeys = ownKeysFun(o);
    var descriptors = {};
    var len = (ownKeys.length | 0);
    var i = 0;
    while ((i !== len)) {
      var key = ownKeys[i];
      Object.defineProperty(descriptors, key, {
        "configurable": true,
        "enumerable": true,
        "writable": true,
        "value": Object.getOwnPropertyDescriptor(o, key)
      });
      i = ((i + 1) | 0)
    };
    return descriptors
  })
})());
var $L0;
function $propertyName(arg0) {
  for (var prop in arg0) {
    return prop
  }
}
function $Char(c) {
  this.c = c
}
$Char.prototype.toString = (function() {
  return String.fromCharCode(this.c)
});
function $throwClassCastException(arg0, arg1) {
  throw new $c_Lorg_scalajs_linker_runtime_UndefinedBehaviorError(new $c_jl_ClassCastException(((arg0 + " is not an instance of ") + arg1)))
}
function $throwArrayCastException(arg0, arg1, arg2) {
  while ((--arg2)) {
    arg1 = ("[" + arg1)
  };
  $throwClassCastException(arg0, arg1)
}
function $throwArrayIndexOutOfBoundsException(arg0) {
  throw new $c_Lorg_scalajs_linker_runtime_UndefinedBehaviorError($ct_jl_ArrayIndexOutOfBoundsException__T__(new $c_jl_ArrayIndexOutOfBoundsException(), ((arg0 === null) ? null : ("" + arg0))))
}
function $noIsInstance(arg0) {
  throw new TypeError("Cannot call isInstance() on a Class representing a JS trait/object")
}
function $newArrayObject(arg0, arg1) {
  return $newArrayObjectInternal(arg0, arg1, 0)
}
function $newArrayObjectInternal(arg0, arg1, arg2) {
  var result = new arg0.constr(arg1[arg2]);
  if ((arg2 < (arg1.length - 1))) {
    var subArrayClassData = arg0.componentData;
    var subLengthIndex = (arg2 + 1);
    var underlying = result.u;
    for (var i = 0; (i < underlying.length); (i++)) {
      underlying[i] = $newArrayObjectInternal(subArrayClassData, arg1, subLengthIndex)
    }
  };
  return result
}
function $objectClone(arg0) {
  return Object.create(Object.getPrototypeOf(arg0), $getOwnPropertyDescriptors(arg0))
}
function $objectOrArrayClone(arg0) {
  return (arg0.$classData.isArrayClass ? arg0.clone__O() : $objectClone(arg0))
}
function $objectGetClass(arg0) {
  switch ((typeof arg0)) {
    case "string": {
      return $d_T.getClassOf()
    }
    case "number": {
      if ($isInt(arg0)) {
        if ((((arg0 << 24) >> 24) === arg0)) {
          return $d_jl_Byte.getClassOf()
        } else if ((((arg0 << 16) >> 16) === arg0)) {
          return $d_jl_Short.getClassOf()
        } else {
          return $d_jl_Integer.getClassOf()
        }
      } else {
        return $d_jl_Float.getClassOf()
      }
    }
    case "boolean": {
      return $d_jl_Boolean.getClassOf()
    }
    case "undefined": {
      return $d_jl_Void.getClassOf()
    }
    default: {
      if ((arg0 === null)) {
        return arg0.getClass__jl_Class()
      } else if ((arg0 instanceof $c_RTLong)) {
        return $d_jl_Long.getClassOf()
      } else if ((arg0 instanceof $Char)) {
        return $d_jl_Character.getClassOf()
      } else if ((!(!(arg0 && arg0.$classData)))) {
        return arg0.$classData.getClassOf()
      } else {
        return null
      }
    }
  }
}
function $objectClassName(arg0) {
  switch ((typeof arg0)) {
    case "string": {
      return "java.lang.String"
    }
    case "number": {
      if ($isInt(arg0)) {
        if ((((arg0 << 24) >> 24) === arg0)) {
          return "java.lang.Byte"
        } else if ((((arg0 << 16) >> 16) === arg0)) {
          return "java.lang.Short"
        } else {
          return "java.lang.Integer"
        }
      } else {
        return "java.lang.Float"
      }
    }
    case "boolean": {
      return "java.lang.Boolean"
    }
    case "undefined": {
      return "java.lang.Void"
    }
    default: {
      if ((arg0 === null)) {
        return arg0.getClass__jl_Class()
      } else if ((arg0 instanceof $c_RTLong)) {
        return "java.lang.Long"
      } else if ((arg0 instanceof $Char)) {
        return "java.lang.Character"
      } else if ((!(!(arg0 && arg0.$classData)))) {
        return arg0.$classData.name
      } else {
        return null.getName__T()
      }
    }
  }
}
function $dp_charAt__I__C(instance, x0) {
  if (((typeof instance) === "string")) {
    return $f_T__charAt__I__C(instance, x0)
  } else {
    return instance.charAt__I__C(x0)
  }
}
function $dp_compareToIgnoreCase__T__I(instance, x0) {
  if (((typeof instance) === "string")) {
    return $f_T__compareToIgnoreCase__T__I(instance, x0)
  } else {
    return instance.compareToIgnoreCase__T__I(x0)
  }
}
function $dp_endsWith__T__Z(instance, x0) {
  if (((typeof instance) === "string")) {
    return $f_T__endsWith__T__Z(instance, x0)
  } else {
    return instance.endsWith__T__Z(x0)
  }
}
function $dp_equals__O__Z(instance, x0) {
  switch ((typeof instance)) {
    case "string": {
      return $f_T__equals__O__Z(instance, x0)
    }
    case "number": {
      return $f_jl_Double__equals__O__Z(instance, x0)
    }
    case "boolean": {
      return $f_jl_Boolean__equals__O__Z(instance, x0)
    }
    case "undefined": {
      return $f_jl_Void__equals__O__Z(instance, x0)
    }
    default: {
      if (((!(!(instance && instance.$classData))) || (instance === null))) {
        return instance.equals__O__Z(x0)
      } else if ((instance instanceof $Char)) {
        return $f_jl_Character__equals__O__Z(instance, x0)
      } else {
        return $c_O.prototype.equals__O__Z.call(instance, x0)
      }
    }
  }
}
function $dp_getChars__I__I__AC__I__V(instance, x0, x1, x2, x3) {
  if (((typeof instance) === "string")) {
    return $f_T__getChars__I__I__AC__I__V(instance, x0, x1, x2, x3)
  } else {
    return instance.getChars__I__I__AC__I__V(x0, x1, x2, x3)
  }
}
function $dp_hashCode__I(instance) {
  switch ((typeof instance)) {
    case "string": {
      return $f_T__hashCode__I(instance)
    }
    case "number": {
      return $f_jl_Double__hashCode__I(instance)
    }
    case "boolean": {
      return $f_jl_Boolean__hashCode__I(instance)
    }
    case "undefined": {
      return $f_jl_Void__hashCode__I(instance)
    }
    default: {
      if (((!(!(instance && instance.$classData))) || (instance === null))) {
        return instance.hashCode__I()
      } else if ((instance instanceof $Char)) {
        return $f_jl_Character__hashCode__I(instance)
      } else {
        return $c_O.prototype.hashCode__I.call(instance)
      }
    }
  }
}
function $dp_indexOf__I__I(instance, x0) {
  if (((typeof instance) === "string")) {
    return $f_T__indexOf__I__I(instance, x0)
  } else {
    return instance.indexOf__I__I(x0)
  }
}
function $dp_lastIndexOf__I__I(instance, x0) {
  if (((typeof instance) === "string")) {
    return $f_T__lastIndexOf__I__I(instance, x0)
  } else {
    return instance.lastIndexOf__I__I(x0)
  }
}
function $dp_length__I(instance) {
  if (((typeof instance) === "string")) {
    return $f_T__length__I(instance)
  } else {
    return instance.length__I()
  }
}
function $dp_split__T__I__AT(instance, x0, x1) {
  if (((typeof instance) === "string")) {
    return $f_T__split__T__I__AT(instance, x0, x1)
  } else {
    return instance.split__T__I__AT(x0, x1)
  }
}
function $dp_subSequence__I__I__jl_CharSequence(instance, x0, x1) {
  if (((typeof instance) === "string")) {
    return $f_T__subSequence__I__I__jl_CharSequence(instance, x0, x1)
  } else {
    return instance.subSequence__I__I__jl_CharSequence(x0, x1)
  }
}
function $dp_toCharArray__AC(instance) {
  if (((typeof instance) === "string")) {
    return $f_T__toCharArray__AC(instance)
  } else {
    return instance.toCharArray__AC()
  }
}
function $dp_toString__T(instance) {
  return ((instance === (void 0)) ? "undefined" : instance.toString())
}
function $dp_trim__T(instance) {
  if (((typeof instance) === "string")) {
    return $f_T__trim__T(instance)
  } else {
    return instance.trim__T()
  }
}
function $intDiv(arg0, arg1) {
  if ((arg1 === 0)) {
    throw new $c_jl_ArithmeticException("/ by zero")
  } else {
    return ((arg0 / arg1) | 0)
  }
}
function $intMod(arg0, arg1) {
  if ((arg1 === 0)) {
    throw new $c_jl_ArithmeticException("/ by zero")
  } else {
    return ((arg0 % arg1) | 0)
  }
}
function $doubleToInt(arg0) {
  return ((arg0 > 2147483647) ? 2147483647 : ((arg0 < (-2147483648)) ? (-2147483648) : (arg0 | 0)))
}
function $newJSObjectWithVarargs(arg0, arg1) {
  var instance = Object.create(arg0.prototype);
  var result = arg0.apply(instance, arg1);
  switch ((typeof result)) {
    case "string":
    case "number":
    case "boolean":
    case "undefined":
    case "symbol": {
      return instance
    }
    default: {
      return ((result === null) ? instance : result)
    }
  }
}
function $resolveSuperRef(arg0, arg1) {
  var getPrototypeOf = Object.getPrototyeOf;
  var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
  var superProto = arg0.prototype;
  while ((superProto !== null)) {
    var desc = getOwnPropertyDescriptor(superProto, arg1);
    if ((desc !== (void 0))) {
      return desc
    };
    superProto = getPrototypeOf(superProto)
  }
}
function $superGet(arg0, arg1, arg2) {
  var desc = $resolveSuperRef(arg0, arg2);
  if ((desc !== (void 0))) {
    var getter = desc.get;
    return ((getter !== (void 0)) ? getter.call(arg1) : getter.value)
  }
}
function $superSet(arg0, arg1, arg2, arg3) {
  var desc = $resolveSuperRef(arg0, arg2);
  if ((desc !== (void 0))) {
    var setter = desc.set;
    if ((setter !== (void 0))) {
      setter.call(arg1, arg3);
      return (void 0)
    }
  };
  throw new TypeError((("super has no setter '" + arg2) + "'."))
}
function $moduleDefault(arg0) {
  return (((arg0 && ((typeof arg0) === "object")) && ("default" in arg0)) ? arg0["default"] : arg0)
}
function $arraycopyCheckBounds(arg0, arg1, arg2, arg3, arg4) {
  if ((((((arg1 < 0) || (arg3 < 0)) || (arg4 < 0)) || (arg1 > ((arg0 - arg4) | 0))) || (arg3 > ((arg2 - arg4) | 0)))) {
    $throwArrayIndexOutOfBoundsException(null)
  }
}
function $arraycopyGeneric(arg0, arg1, arg2, arg3, arg4) {
  $arraycopyCheckBounds(arg0.length, arg1, arg2.length, arg3, arg4);
  if ((((arg0 !== arg2) || (arg3 < arg1)) || (((arg1 + arg4) | 0) < arg3))) {
    for (var i = 0; (i < arg4); i = ((i + 1) | 0)) {
      arg2[((arg3 + i) | 0)] = arg0[((arg1 + i) | 0)]
    }
  } else {
    for (var i = ((arg4 - 1) | 0); (i >= 0); i = ((i - 1) | 0)) {
      arg2[((arg3 + i) | 0)] = arg0[((arg1 + i) | 0)]
    }
  }
}
function $systemArraycopy(arg0, arg1, arg2, arg3, arg4) {
  $arraycopyGeneric(arg0.u, arg1, arg2.u, arg3, arg4)
}
var $lastIDHash = 0;
var $idHashCodeMap = (((typeof WeakMap) !== "undefined") ? new WeakMap() : null);
var $systemIdentityHashCode = (($idHashCodeMap !== null) ? (function(obj) {
  switch ((typeof obj)) {
    case "string": {
      return $f_T__hashCode__I(obj)
    }
    case "number": {
      return $f_jl_Double__hashCode__I(obj)
    }
    case "bigint": {
      var biHash = 0;
      if ((obj < BigInt(0))) {
        obj = (~obj)
      };
      while ((obj !== BigInt(0))) {
        biHash = (biHash ^ Number(BigInt.asIntN(32, obj)));
        obj = (obj >> BigInt(32))
      };
      return biHash
    }
    case "boolean": {
      return (obj ? 1231 : 1237)
    }
    case "undefined": {
      return 0
    }
    case "symbol": {
      var description = obj.description;
      return ((description === (void 0)) ? 0 : $f_T__hashCode__I(description))
    }
    default: {
      if ((obj === null)) {
        return 0
      } else {
        var hash = $idHashCodeMap.get(obj);
        if ((hash === (void 0))) {
          hash = (($lastIDHash + 1) | 0);
          $lastIDHash = hash;
          $idHashCodeMap.set(obj, hash)
        };
        return hash
      }
    }
  }
}) : (function(obj) {
  switch ((typeof obj)) {
    case "string": {
      return $f_T__hashCode__I(obj)
    }
    case "number": {
      return $f_jl_Double__hashCode__I(obj)
    }
    case "bigint": {
      var biHash = 0;
      if ((obj < BigInt(0))) {
        obj = (~obj)
      };
      while ((obj !== BigInt(0))) {
        biHash = (biHash ^ Number(BigInt.asIntN(32, obj)));
        obj = (obj >> BigInt(32))
      };
      return biHash
    }
    case "boolean": {
      return (obj ? 1231 : 1237)
    }
    case "undefined": {
      return 0
    }
    case "symbol": {
      var description = obj.description;
      return ((description === (void 0)) ? 0 : $f_T__hashCode__I(description))
    }
    default: {
      if ((!(!(obj && obj.$classData)))) {
        var hash = obj.$idHashCode$0;
        if ((hash !== (void 0))) {
          return hash
        } else if ((!Object.isSealed(obj))) {
          hash = (($lastIDHash + 1) | 0);
          $lastIDHash = hash;
          obj.$idHashCode$0 = hash;
          return hash
        } else {
          return 42
        }
      } else if ((obj === null)) {
        0
      } else {
        42
      }
    }
  }
}));
function $isByte(arg0) {
  return ((((typeof arg0) === "number") && (((arg0 << 24) >> 24) === arg0)) && ((1 / arg0) !== (1 / (-0))))
}
function $isShort(arg0) {
  return ((((typeof arg0) === "number") && (((arg0 << 16) >> 16) === arg0)) && ((1 / arg0) !== (1 / (-0))))
}
function $isInt(arg0) {
  return ((((typeof arg0) === "number") && ((arg0 | 0) === arg0)) && ((1 / arg0) !== (1 / (-0))))
}
function $bC(arg0) {
  return new $Char(arg0)
}
var $bC0 = $bC(0);
function $uV(arg0) {
  return (((arg0 === (void 0)) || (arg0 === null)) ? (void 0) : $throwClassCastException(arg0, "java.lang.Void"))
}
function $uZ(arg0) {
  return ((((typeof arg0) === "boolean") || (arg0 === null)) ? (!(!arg0)) : $throwClassCastException(arg0, "java.lang.Boolean"))
}
function $uC(arg0) {
  return (((arg0 instanceof $Char) || (arg0 === null)) ? ((arg0 === null) ? 0 : arg0.c) : $throwClassCastException(arg0, "java.lang.Character"))
}
function $uB(arg0) {
  return (($isByte(arg0) || (arg0 === null)) ? (arg0 | 0) : $throwClassCastException(arg0, "java.lang.Byte"))
}
function $uS(arg0) {
  return (($isShort(arg0) || (arg0 === null)) ? (arg0 | 0) : $throwClassCastException(arg0, "java.lang.Short"))
}
function $uI(arg0) {
  return (($isInt(arg0) || (arg0 === null)) ? (arg0 | 0) : $throwClassCastException(arg0, "java.lang.Integer"))
}
function $uJ(arg0) {
  return (((arg0 instanceof $c_RTLong) || (arg0 === null)) ? ((arg0 === null) ? $L0 : arg0) : $throwClassCastException(arg0, "java.lang.Long"))
}
function $uF(arg0) {
  return ((((typeof arg0) === "number") || (arg0 === null)) ? (+arg0) : $throwClassCastException(arg0, "java.lang.Float"))
}
function $uD(arg0) {
  return ((((typeof arg0) === "number") || (arg0 === null)) ? (+arg0) : $throwClassCastException(arg0, "java.lang.Double"))
}
function $uT(arg0) {
  return ((((typeof arg0) === "string") || (arg0 === null)) ? ((arg0 === null) ? "" : arg0) : $throwClassCastException(arg0, "java.lang.String"))
}
function $ct_O__($thiz) {
  return $thiz
}
/** @constructor */
function $c_O() {
  /*<skip>*/
}
$c_O.prototype.constructor = $c_O;
/** @constructor */
function $h_O() {
  /*<skip>*/
}
$h_O.prototype = $c_O.prototype;
$c_O.prototype.hashCode__I = (function() {
  return $systemIdentityHashCode(this)
});
$c_O.prototype.equals__O__Z = (function(that) {
  return (this === that)
});
$c_O.prototype.toString__T = (function() {
  var i = this.hashCode__I();
  return (($objectClassName(this) + "@") + $as_T($uD((i >>> 0)).toString(16)))
});
$c_O.prototype.toString = (function() {
  return this.toString__T()
});
function $ac_O(arg) {
  if (((typeof arg) === "number")) {
    this.u = new Array(arg);
    for (var i = 0; (i < arg); (i++)) {
      this.u[i] = null
    }
  } else {
    this.u = arg
  }
}
$ac_O.prototype = new $h_O();
$ac_O.prototype.constructor = $ac_O;
$ac_O.prototype.get = (function(i) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOfBoundsException(i)
  };
  return this.u[i]
});
$ac_O.prototype.set = (function(i, v) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOfBoundsException(i)
  };
  this.u[i] = v
});
$ac_O.prototype.clone__O = (function() {
  return new $ac_O(this.u.slice())
});
function $ah_O() {
  /*<skip>*/
}
$ah_O.prototype = $ac_O.prototype;
function $ac_Z(arg) {
  if (((typeof arg) === "number")) {
    this.u = new Array(arg);
    for (var i = 0; (i < arg); (i++)) {
      this.u[i] = false
    }
  } else {
    this.u = arg
  }
}
$ac_Z.prototype = new $h_O();
$ac_Z.prototype.constructor = $ac_Z;
$ac_Z.prototype.get = (function(i) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOfBoundsException(i)
  };
  return this.u[i]
});
$ac_Z.prototype.set = (function(i, v) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOfBoundsException(i)
  };
  this.u[i] = v
});
$ac_Z.prototype.clone__O = (function() {
  return new $ac_Z(this.u.slice())
});
function $ac_C(arg) {
  if (((typeof arg) === "number")) {
    this.u = new Array(arg);
    for (var i = 0; (i < arg); (i++)) {
      this.u[i] = 0
    }
  } else {
    this.u = arg
  }
}
$ac_C.prototype = new $h_O();
$ac_C.prototype.constructor = $ac_C;
$ac_C.prototype.get = (function(i) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOfBoundsException(i)
  };
  return this.u[i]
});
$ac_C.prototype.set = (function(i, v) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOfBoundsException(i)
  };
  this.u[i] = v
});
$ac_C.prototype.clone__O = (function() {
  return new $ac_C(this.u.slice())
});
function $ac_B(arg) {
  if (((typeof arg) === "number")) {
    this.u = new Array(arg);
    for (var i = 0; (i < arg); (i++)) {
      this.u[i] = 0
    }
  } else {
    this.u = arg
  }
}
$ac_B.prototype = new $h_O();
$ac_B.prototype.constructor = $ac_B;
$ac_B.prototype.get = (function(i) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOfBoundsException(i)
  };
  return this.u[i]
});
$ac_B.prototype.set = (function(i, v) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOfBoundsException(i)
  };
  this.u[i] = v
});
$ac_B.prototype.clone__O = (function() {
  return new $ac_B(this.u.slice())
});
function $ac_S(arg) {
  if (((typeof arg) === "number")) {
    this.u = new Array(arg);
    for (var i = 0; (i < arg); (i++)) {
      this.u[i] = 0
    }
  } else {
    this.u = arg
  }
}
$ac_S.prototype = new $h_O();
$ac_S.prototype.constructor = $ac_S;
$ac_S.prototype.get = (function(i) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOfBoundsException(i)
  };
  return this.u[i]
});
$ac_S.prototype.set = (function(i, v) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOfBoundsException(i)
  };
  this.u[i] = v
});
$ac_S.prototype.clone__O = (function() {
  return new $ac_S(this.u.slice())
});
function $ac_I(arg) {
  if (((typeof arg) === "number")) {
    this.u = new Array(arg);
    for (var i = 0; (i < arg); (i++)) {
      this.u[i] = 0
    }
  } else {
    this.u = arg
  }
}
$ac_I.prototype = new $h_O();
$ac_I.prototype.constructor = $ac_I;
$ac_I.prototype.get = (function(i) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOfBoundsException(i)
  };
  return this.u[i]
});
$ac_I.prototype.set = (function(i, v) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOfBoundsException(i)
  };
  this.u[i] = v
});
$ac_I.prototype.clone__O = (function() {
  return new $ac_I(this.u.slice())
});
function $ac_J(arg) {
  if (((typeof arg) === "number")) {
    this.u = new Array(arg);
    for (var i = 0; (i < arg); (i++)) {
      this.u[i] = $L0
    }
  } else {
    this.u = arg
  }
}
$ac_J.prototype = new $h_O();
$ac_J.prototype.constructor = $ac_J;
$ac_J.prototype.get = (function(i) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOfBoundsException(i)
  };
  return this.u[i]
});
$ac_J.prototype.set = (function(i, v) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOfBoundsException(i)
  };
  this.u[i] = v
});
$ac_J.prototype.clone__O = (function() {
  return new $ac_J(this.u.slice())
});
function $ac_F(arg) {
  if (((typeof arg) === "number")) {
    this.u = new Array(arg);
    for (var i = 0; (i < arg); (i++)) {
      this.u[i] = 0.0
    }
  } else {
    this.u = arg
  }
}
$ac_F.prototype = new $h_O();
$ac_F.prototype.constructor = $ac_F;
$ac_F.prototype.get = (function(i) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOfBoundsException(i)
  };
  return this.u[i]
});
$ac_F.prototype.set = (function(i, v) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOfBoundsException(i)
  };
  this.u[i] = v
});
$ac_F.prototype.clone__O = (function() {
  return new $ac_F(this.u.slice())
});
function $ac_D(arg) {
  if (((typeof arg) === "number")) {
    this.u = new Array(arg);
    for (var i = 0; (i < arg); (i++)) {
      this.u[i] = 0.0
    }
  } else {
    this.u = arg
  }
}
$ac_D.prototype = new $h_O();
$ac_D.prototype.constructor = $ac_D;
$ac_D.prototype.get = (function(i) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOfBoundsException(i)
  };
  return this.u[i]
});
$ac_D.prototype.set = (function(i, v) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOfBoundsException(i)
  };
  this.u[i] = v
});
$ac_D.prototype.clone__O = (function() {
  return new $ac_D(this.u.slice())
});
function $TypeData() {
  this.constr = (void 0);
  this.ancestors = null;
  this.componentData = null;
  this.arrayBase = null;
  this.arrayDepth = 0;
  this.zero = null;
  this.arrayEncodedName = "";
  this._classOf = (void 0);
  this._arrayOf = (void 0);
  this.isAssignableFromFun = (void 0);
  this.wrapArray = (void 0);
  this.name = "";
  this.isPrimitive = false;
  this.isInterface = false;
  this.isArrayClass = false;
  this.isJSClass = false;
  this.isInstance = (void 0)
}
$TypeData.prototype.initPrim = (function(zero, arrayEncodedName, displayName, arrayClass, typedArrayClass) {
  this.ancestors = {};
  this.zero = zero;
  this.arrayEncodedName = arrayEncodedName;
  var self = this;
  this.isAssignableFromFun = (function(that) {
    return (that === self)
  });
  this.name = displayName;
  this.isPrimitive = true;
  this.isInstance = (function(obj) {
    return false
  });
  if ((arrayClass !== (void 0))) {
    this._arrayOf = new $TypeData().initSpecializedArray(this, arrayClass, typedArrayClass)
  };
  return this
});
$TypeData.prototype.initClass = (function(internalNameObj, isInterface, fullName, ancestors, isJSType, parentData, isInstance) {
  var internalName = $propertyName(internalNameObj);
  this.ancestors = ancestors;
  this.arrayEncodedName = (("L" + fullName) + ";");
  this.isAssignableFromFun = (function(that) {
    return (!(!that.ancestors[internalName]))
  });
  this.isJSType = (!(!isJSType));
  this.name = fullName;
  this.isInterface = isInterface;
  this.isInstance = (isInstance || (function(obj) {
    return (!(!((obj && obj.$classData) && obj.$classData.ancestors[internalName])))
  }));
  return this
});
$TypeData.prototype.initSpecializedArray = (function(componentData, arrayClass, typedArrayClass, isAssignableFromFun) {
  arrayClass.prototype.$classData = this;
  var name = ("[" + componentData.arrayEncodedName);
  this.constr = arrayClass;
  this.ancestors = {
    O: 1,
    jl_Cloneable: 1,
    Ljava_io_Serializable: 1
  };
  this.componentData = componentData;
  this.arrayBase = componentData;
  this.arrayDepth = 1;
  this.arrayEncodedName = name;
  this.name = name;
  this.isArrayClass = true;
  var self = this;
  this.isAssignableFromFun = (isAssignableFromFun || (function(that) {
    return (self === that)
  }));
  this.wrapArray = (typedArrayClass ? (function(array) {
    return new arrayClass(new typedArrayClass(array))
  }) : (function(array) {
    return new arrayClass(array)
  }));
  this.isInstance = (function(obj) {
    return (obj instanceof arrayClass)
  });
  return this
});
$TypeData.prototype.initArray = (function(componentData) {
  function ArrayClass(arg) {
    if (((typeof arg) === "number")) {
      this.u = new Array(arg);
      for (var i = 0; (i < arg); (i++)) {
        this.u[i] = null
      }
    } else {
      this.u = arg
    }
  }
  ArrayClass.prototype = new $ah_O();
  ArrayClass.prototype.constructor = ArrayClass;
  ArrayClass.prototype.clone__O = (function() {
    return new ArrayClass(this.u.slice())
  });
  var arrayBase = (componentData.arrayBase || componentData);
  var arrayDepth = (componentData.arrayDepth + 1);
  ArrayClass.prototype.$classData = this;
  var name = ("[" + componentData.arrayEncodedName);
  this.constr = ArrayClass;
  this.ancestors = {
    O: 1,
    jl_Cloneable: 1,
    Ljava_io_Serializable: 1
  };
  this.componentData = componentData;
  this.arrayBase = arrayBase;
  this.arrayDepth = arrayDepth;
  this.arrayEncodedName = name;
  this.name = name;
  this.isArrayClass = true;
  var isAssignableFromFun = (function(that) {
    var thatDepth = that.arrayDepth;
    return ((thatDepth === arrayDepth) ? arrayBase.isAssignableFromFun(that.arrayBase) : ((thatDepth > arrayDepth) && (arrayBase === $d_O)))
  });
  this.isAssignableFromFun = isAssignableFromFun;
  this.wrapArray = (function(array) {
    return new ArrayClass(array)
  });
  var self = this;
  this.isInstance = (function(obj) {
    var data = (obj && obj.$classData);
    return ((!(!data)) && ((data === self) || isAssignableFromFun(data)))
  });
  return this
});
$TypeData.prototype.getArrayOf = (function() {
  if ((!this._arrayOf)) {
    this._arrayOf = new $TypeData().initArray(this)
  };
  return this._arrayOf
});
$TypeData.prototype.getClassOf = (function() {
  if ((!this._classOf)) {
    this._classOf = new $c_jl_Class(this)
  };
  return this._classOf
});
$TypeData.prototype.isAssignableFrom = (function(that) {
  return ((this === that) || this.isAssignableFromFun(that))
});
$TypeData.prototype.checkCast = (function(obj) {
  if ((((obj !== null) && (!this.isJSType)) && (!this.isInstance(obj)))) {
    $throwClassCastException(obj, this.name)
  }
});
$TypeData.prototype.getSuperclass = (function() {
  return (this.parentData ? this.parentData.getClassOf() : null)
});
$TypeData.prototype.getComponentType = (function() {
  return (this.componentData ? this.componentData.getClassOf() : null)
});
$TypeData.prototype.newArrayOfThisClass = (function(lengths) {
  var arrayClassData = this;
  for (var i = 0; (i < lengths.length); (i++)) {
    arrayClassData = arrayClassData.getArrayOf()
  };
  return $newArrayObject(arrayClassData, lengths)
});
function $isArrayOf_O(obj, depth) {
  var data = (obj && obj.$classData);
  if ((!data)) {
    return false
  } else {
    var arrayDepth = data.arrayDepth;
    return ((arrayDepth === depth) ? (!data.arrayBase.isPrimitive) : (arrayDepth > depth))
  }
}
function $isArrayOf_Z(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && (obj.$classData.arrayBase === $d_Z))))
}
function $isArrayOf_C(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && (obj.$classData.arrayBase === $d_C))))
}
function $isArrayOf_B(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && (obj.$classData.arrayBase === $d_B))))
}
function $isArrayOf_S(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && (obj.$classData.arrayBase === $d_S))))
}
function $isArrayOf_I(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && (obj.$classData.arrayBase === $d_I))))
}
function $isArrayOf_J(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && (obj.$classData.arrayBase === $d_J))))
}
function $isArrayOf_F(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && (obj.$classData.arrayBase === $d_F))))
}
function $isArrayOf_D(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && (obj.$classData.arrayBase === $d_D))))
}
function $asArrayOf_O(obj, depth) {
  if (($isArrayOf_O(obj, depth) || (obj === null))) {
    return obj
  } else {
    $throwArrayCastException(obj, "Ljava.lang.Object;", depth)
  }
}
function $asArrayOf_Z(obj, depth) {
  if (($isArrayOf_Z(obj, depth) || (obj === null))) {
    return obj
  } else {
    $throwArrayCastException(obj, "Z", depth)
  }
}
function $asArrayOf_C(obj, depth) {
  if (($isArrayOf_C(obj, depth) || (obj === null))) {
    return obj
  } else {
    $throwArrayCastException(obj, "C", depth)
  }
}
function $asArrayOf_B(obj, depth) {
  if (($isArrayOf_B(obj, depth) || (obj === null))) {
    return obj
  } else {
    $throwArrayCastException(obj, "B", depth)
  }
}
function $asArrayOf_S(obj, depth) {
  if (($isArrayOf_S(obj, depth) || (obj === null))) {
    return obj
  } else {
    $throwArrayCastException(obj, "S", depth)
  }
}
function $asArrayOf_I(obj, depth) {
  if (($isArrayOf_I(obj, depth) || (obj === null))) {
    return obj
  } else {
    $throwArrayCastException(obj, "I", depth)
  }
}
function $asArrayOf_J(obj, depth) {
  if (($isArrayOf_J(obj, depth) || (obj === null))) {
    return obj
  } else {
    $throwArrayCastException(obj, "J", depth)
  }
}
function $asArrayOf_F(obj, depth) {
  if (($isArrayOf_F(obj, depth) || (obj === null))) {
    return obj
  } else {
    $throwArrayCastException(obj, "F", depth)
  }
}
function $asArrayOf_D(obj, depth) {
  if (($isArrayOf_D(obj, depth) || (obj === null))) {
    return obj
  } else {
    $throwArrayCastException(obj, "D", depth)
  }
}
var $d_O = new $TypeData();
$d_O.ancestors = {
  O: 1
};
$d_O.arrayEncodedName = "Ljava.lang.Object;";
$d_O.isAssignableFromFun = (function(that) {
  return (!that.isPrimitive)
});
$d_O.name = "java.lang.Object";
$d_O.isInstance = (function(obj) {
  return (obj !== null)
});
$d_O._arrayOf = new $TypeData().initSpecializedArray($d_O, $ac_O, (void 0), (function(that) {
  var thatDepth = that.arrayDepth;
  return ((thatDepth === 1) ? (!that.arrayBase.isPrimitive) : (thatDepth > 1))
}));
$c_O.prototype.$classData = $d_O;
var $d_V = new $TypeData().initPrim((void 0), "V", "void", (void 0), (void 0));
var $d_Z = new $TypeData().initPrim(false, "Z", "boolean", $ac_Z, (void 0));
var $d_C = new $TypeData().initPrim(0, "C", "char", $ac_C, (void 0));
var $d_B = new $TypeData().initPrim(0, "B", "byte", $ac_B, (void 0));
var $d_S = new $TypeData().initPrim(0, "S", "short", $ac_S, (void 0));
var $d_I = new $TypeData().initPrim(0, "I", "int", $ac_I, (void 0));
var $d_J = new $TypeData().initPrim(null, "J", "long", $ac_J, (void 0));
var $d_F = new $TypeData().initPrim(0.0, "F", "float", $ac_F, (void 0));
var $d_D = new $TypeData().initPrim(0.0, "D", "double", $ac_D, (void 0));
/** @constructor */
function $c_Lio_github_shogowada_scalajs_reactjs_React$() {
  this.Lio_github_shogowada_scalajs_reactjs_React$__f_WrappedProperty = null;
  this.Lio_github_shogowada_scalajs_reactjs_React$__f_bitmap$init$0 = 0;
  $n_Lio_github_shogowada_scalajs_reactjs_React$ = this;
  this.Lio_github_shogowada_scalajs_reactjs_React$__f_WrappedProperty = "wrapped";
  this.Lio_github_shogowada_scalajs_reactjs_React$__f_bitmap$init$0 = (((1 | this.Lio_github_shogowada_scalajs_reactjs_React$__f_bitmap$init$0) << 24) >> 24)
}
$c_Lio_github_shogowada_scalajs_reactjs_React$.prototype = new $h_O();
$c_Lio_github_shogowada_scalajs_reactjs_React$.prototype.constructor = $c_Lio_github_shogowada_scalajs_reactjs_React$;
/** @constructor */
function $h_Lio_github_shogowada_scalajs_reactjs_React$() {
  /*<skip>*/
}
$h_Lio_github_shogowada_scalajs_reactjs_React$.prototype = $c_Lio_github_shogowada_scalajs_reactjs_React$.prototype;
$c_Lio_github_shogowada_scalajs_reactjs_React$.prototype.WrappedProperty__T = (function() {
  if (((((1 & this.Lio_github_shogowada_scalajs_reactjs_React$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scalajs-reactjs/scalajs-reactjs/core/src/main/scala/io/github/shogowada/scalajs/reactjs/React.scala: 17")
  };
  return this.Lio_github_shogowada_scalajs_reactjs_React$__f_WrappedProperty
});
$c_Lio_github_shogowada_scalajs_reactjs_React$.prototype.createElement__T__sjs_js_Any__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement = (function(tagName, attributes, children) {
  var $$x1 = $moduleDefault($i_react);
  return $$x1.createElement.apply($$x1, [tagName, attributes].concat($m_sjsr_Compat$().toJSVarArgsImpl__sci_Seq__sjs_js_Array(children)))
});
$c_Lio_github_shogowada_scalajs_reactjs_React$.prototype.createElement__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass__sjs_js_Any__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement = (function(reactClass, props, children) {
  var $$x1 = $moduleDefault($i_react);
  return $$x1.createElement.apply($$x1, [reactClass, props].concat($m_sjsr_Compat$().toJSVarArgsImpl__sci_Seq__sjs_js_Array(children)))
});
var $d_Lio_github_shogowada_scalajs_reactjs_React$ = new $TypeData().initClass({
  Lio_github_shogowada_scalajs_reactjs_React$: 0
}, false, "io.github.shogowada.scalajs.reactjs.React$", {
  Lio_github_shogowada_scalajs_reactjs_React$: 1,
  O: 1
});
$c_Lio_github_shogowada_scalajs_reactjs_React$.prototype.$classData = $d_Lio_github_shogowada_scalajs_reactjs_React$;
var $n_Lio_github_shogowada_scalajs_reactjs_React$;
function $m_Lio_github_shogowada_scalajs_reactjs_React$() {
  if ((!$n_Lio_github_shogowada_scalajs_reactjs_React$)) {
    $n_Lio_github_shogowada_scalajs_reactjs_React$ = new $c_Lio_github_shogowada_scalajs_reactjs_React$()
  };
  return $n_Lio_github_shogowada_scalajs_reactjs_React$
}
function $p_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$__htmlNameToReactNameMap$lzycompute__sci_Map($thiz) {
  if ((!$thiz.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$__f_bitmap$0)) {
    var this$70 = $m_s_Predef$().s_Predef$__f_Map;
    var array = [new $c_T2("accept-charset", "acceptCharset"), new $c_T2("accesskey", "accessKey"), new $c_T2("allowfullscreen", "allowFullScreen"), new $c_T2("autocomplete", "autoComplete"), new $c_T2("autofocus", "autoFocus"), new $c_T2("autoplay", "autoPlay"), new $c_T2("charset", "charSet"), new $c_T2("colspan", "colSpan"), new $c_T2("contenteditable", "contentEditable"), new $c_T2("contextmenu", "contextMenu"), new $c_T2("crossorigin", "crossOrigin"), new $c_T2("datetime", "dateTime"), new $c_T2("enctype", "encType"), new $c_T2("formaction", "formAction"), new $c_T2("formenctype", "formEncType"), new $c_T2("formmethod", "formMethod"), new $c_T2("formnovalidate", "formNoValidate"), new $c_T2("formtarget", "formTarget"), new $c_T2("hreflang", "hrefLang"), new $c_T2("http-equiv", "httpEquiv"), new $c_T2("inputmode", "inputMode"), new $c_T2("keytype", "keyType"), new $c_T2("maxlength", "maxLength"), new $c_T2("mediagroup", "mediaGroup"), new $c_T2("minlength", "minLength"), new $c_T2("novalidate", "noValidate"), new $c_T2("radiogroup", "radioGroup"), new $c_T2("spellcheck", "spellCheck"), new $c_T2("srcdoc", "srcDoc"), new $c_T2("srclang", "srcLang"), new $c_T2("srcset", "srcSet"), new $c_T2("tabindex", "tabIndex"), new $c_T2("usemap", "useMap")];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $thiz.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$__f_htmlNameToReactNameMap = this$70.from__sc_IterableOnce__sci_Map(elems);
    $thiz.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$__f_bitmap$0 = true
  };
  return $thiz.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$__f_htmlNameToReactNameMap
}
function $p_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$__htmlNameToReactNameMap__sci_Map($thiz) {
  return ((!$thiz.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$__f_bitmap$0) ? $p_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$__htmlNameToReactNameMap$lzycompute__sci_Map($thiz) : $thiz.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$__f_htmlNameToReactNameMap)
}
function $p_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$__toReactAttributeName__T__T($thiz, name) {
  return $as_T($p_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$__htmlNameToReactNameMap__sci_Map($thiz).getOrElse__O__F0__O(name, new $c_sjsr_AnonFunction0((function(this$1, name$1) {
    return (function() {
      return name$1
    })
  })($thiz, name))))
}
function $p_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$__attributeValueToReactAttributeValue__Lio_github_shogowada_statictags_Attribute__sjs_js_Any($thiz, attribute) {
  if ((attribute !== null)) {
    var value = attribute.Lio_github_shogowada_statictags_Attribute__f_value;
    var p3 = attribute.Lio_github_shogowada_statictags_Attribute__f_valueType;
    var x = $m_Lio_github_shogowada_statictags_AttributeValueType$CSS$();
    if ((x === p3)) {
      var this$2 = $m_sjs_js_JSConverters$JSRichMap$();
      var map = $as_sci_Map(value);
      var result = {};
      map.foreach__F1__V(new $c_sjsr_AnonFunction1((function(this$4, result$1) {
        return (function(x0$1$2) {
          var x0$1 = $as_T2(x0$1$2);
          if ((x0$1 !== null)) {
            var key = $as_T(x0$1._1__O());
            var value$1 = x0$1._2__O();
            result$1[key] = value$1
          } else {
            throw new $c_s_MatchError(x0$1)
          }
        })
      })(this$2, result)));
      return result
    }
  };
  if ((attribute !== null)) {
    var value$2 = attribute.Lio_github_shogowada_statictags_Attribute__f_value;
    var p5 = attribute.Lio_github_shogowada_statictags_Attribute__f_valueType;
    if (((typeof value$2) === "boolean")) {
      var x9 = $uZ(value$2);
      var x$3 = $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$();
      if ((x$3 === p5)) {
        return x9
      }
    }
  };
  if ((attribute !== null)) {
    var value$3 = attribute.Lio_github_shogowada_statictags_Attribute__f_value;
    var p7 = attribute.Lio_github_shogowada_statictags_Attribute__f_valueType;
    var x$5 = $m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMAttributes__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$().Type__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$().AS_IS__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$AS\uff3fIS$();
    if ((x$5 === p7)) {
      return value$3
    }
  };
  var s = attribute.valueToString__T();
  return s
}
function $p_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$__Type$lzycompute$1__V($thiz) {
  if (($thiz.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$__f_Type$module === null)) {
    $thiz.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$__f_Type$module = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$($thiz)
  }
}
/** @constructor */
function $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$(outer) {
  this.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$__f_WrappedPropsAttributeSpec$module = null;
  this.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$__f_PlainPropsAttributeSpec$module = null;
  this.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$__f_ReactClassAttributeSpec$module = null;
  this.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$__f_RefAttributeSpec$module = null;
  this.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$__f_RenderAttributeSpec$module = null;
  this.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$__f_Type$module = null;
  this.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$__f_htmlNameToReactNameMap = null;
  this.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$__f_bitmap$init$0 = 0;
  this.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$__f_bitmap$0 = false
}
$c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$.prototype = new $h_O();
$c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$.prototype.constructor = $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$;
/** @constructor */
function $h_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$() {
  /*<skip>*/
}
$h_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$.prototype = $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$.prototype;
$c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$.prototype.Type__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$ = (function() {
  if ((this.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$__f_Type$module === null)) {
    $p_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$__Type$lzycompute$1__V(this)
  };
  return this.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$__f_Type$module
});
$c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$.prototype.toReactAttributes__sc_Iterable__sjs_js_Dictionary = (function(attributes) {
  var result = {};
  attributes.foreach__F1__V(new $c_sjsr_AnonFunction1((function(this$2, result$1) {
    return (function(attribute$2) {
      var attribute = $as_Lio_github_shogowada_statictags_Attribute(attribute$2);
      if ((attribute.Lio_github_shogowada_statictags_Attribute__f_name === "plainProps")) {
        return Object.assign(result$1, attribute.Lio_github_shogowada_statictags_Attribute__f_value)
      } else {
        var name = $p_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$__toReactAttributeName__T__T(this$2, attribute.Lio_github_shogowada_statictags_Attribute__f_name);
        var value = $p_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$__attributeValueToReactAttributeValue__Lio_github_shogowada_statictags_Attribute__sjs_js_Any(this$2, attribute);
        result$1[name] = value;
        return (void 0)
      }
    })
  })(this, result)));
  return result
});
var $d_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$ = new $TypeData().initClass({
  Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$: 0
}, false, "io.github.shogowada.scalajs.reactjs.VirtualDOM$VirtualDOMAttributes$", {
  Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$: 1,
  O: 1
});
$c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$.prototype.$classData = $d_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$;
function $p_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$__AS_IS$lzycompute$1__V($thiz) {
  if (($thiz.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$__f_AS_IS$module === null)) {
    $thiz.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$__f_AS_IS$module = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$AS\uff3fIS$($thiz)
  }
}
/** @constructor */
function $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$(outer) {
  this.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$__f_AS_IS$module = null;
  this.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$__f_bitmap$init$0 = false
}
$c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$.prototype = new $h_O();
$c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$.prototype.constructor = $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$;
/** @constructor */
function $h_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$() {
  /*<skip>*/
}
$h_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$.prototype = $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$.prototype;
$c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$.prototype.AS_IS__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$AS\uff3fIS$ = (function() {
  if ((this.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$__f_AS_IS$module === null)) {
    $p_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$__AS_IS$lzycompute$1__V(this)
  };
  return this.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$__f_AS_IS$module
});
var $d_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$ = new $TypeData().initClass({
  Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$: 0
}, false, "io.github.shogowada.scalajs.reactjs.VirtualDOM$VirtualDOMAttributes$Type$", {
  Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$: 1,
  O: 1
});
$c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$.prototype.$classData = $d_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$;
function $p_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$__elementToReactElement__O__sjs_js_Any($thiz, content) {
  if (false) {
    var x2 = $as_Lio_github_shogowada_statictags_Element(content);
    var this$1 = $thiz.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$__f_$outer;
    return $f_Lio_github_shogowada_scalajs_reactjs_VirtualDOM__elementsToVirtualDOMs__Lio_github_shogowada_statictags_Element__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement(this$1, x2)
  } else {
    return content
  }
}
/** @constructor */
function $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(outer) {
  this.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$__f_ReactClassElementSpec$module = null;
  this.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$__f_bitmap$init$0 = false;
  this.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$__f_$outer = null;
  if ((outer === null)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(null)
  } else {
    this.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$__f_$outer = outer
  }
}
$c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$.prototype = new $h_O();
$c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$.prototype.constructor = $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$;
/** @constructor */
function $h_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$() {
  /*<skip>*/
}
$h_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$.prototype = $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$.prototype;
$c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$.prototype.toReactElements__sci_Seq__sci_Seq = (function(contents) {
  return $as_sci_Seq(contents.map__F1__O(new $c_sjsr_AnonFunction1((function(this$1) {
    return (function(content$2) {
      return $p_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$__elementToReactElement__O__sjs_js_Any(this$1, content$2)
    })
  })(this))))
});
var $d_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ = new $TypeData().initClass({
  Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$: 0
}, false, "io.github.shogowada.scalajs.reactjs.VirtualDOM$VirtualDOMElements$", {
  Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$: 1,
  O: 1
});
$c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$.prototype.$classData = $d_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$;
function $is_Lio_github_shogowada_scalajs_reactjs_redux_Action(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lio_github_shogowada_scalajs_reactjs_redux_Action)))
}
function $as_Lio_github_shogowada_scalajs_reactjs_redux_Action(obj) {
  return (($is_Lio_github_shogowada_scalajs_reactjs_redux_Action(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "io.github.shogowada.scalajs.reactjs.redux.Action"))
}
function $isArrayOf_Lio_github_shogowada_scalajs_reactjs_redux_Action(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_github_shogowada_scalajs_reactjs_redux_Action)))
}
function $asArrayOf_Lio_github_shogowada_scalajs_reactjs_redux_Action(obj, depth) {
  return (($isArrayOf_Lio_github_shogowada_scalajs_reactjs_redux_Action(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.github.shogowada.scalajs.reactjs.redux.Action;", depth))
}
/** @constructor */
function $c_Lio_github_shogowada_scalajs_reactjs_redux_ContainerComponentFactory(nativeFactory) {
  this.Lio_github_shogowada_scalajs_reactjs_redux_ContainerComponentFactory__f_nativeFactory = null;
  this.Lio_github_shogowada_scalajs_reactjs_redux_ContainerComponentFactory__f_nativeFactory = nativeFactory
}
$c_Lio_github_shogowada_scalajs_reactjs_redux_ContainerComponentFactory.prototype = new $h_O();
$c_Lio_github_shogowada_scalajs_reactjs_redux_ContainerComponentFactory.prototype.constructor = $c_Lio_github_shogowada_scalajs_reactjs_redux_ContainerComponentFactory;
/** @constructor */
function $h_Lio_github_shogowada_scalajs_reactjs_redux_ContainerComponentFactory() {
  /*<skip>*/
}
$h_Lio_github_shogowada_scalajs_reactjs_redux_ContainerComponentFactory.prototype = $c_Lio_github_shogowada_scalajs_reactjs_redux_ContainerComponentFactory.prototype;
$c_Lio_github_shogowada_scalajs_reactjs_redux_ContainerComponentFactory.prototype.apply__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass = (function(reactClass) {
  return (0, this.Lio_github_shogowada_scalajs_reactjs_redux_ContainerComponentFactory__f_nativeFactory)(reactClass)
});
var $d_Lio_github_shogowada_scalajs_reactjs_redux_ContainerComponentFactory = new $TypeData().initClass({
  Lio_github_shogowada_scalajs_reactjs_redux_ContainerComponentFactory: 0
}, false, "io.github.shogowada.scalajs.reactjs.redux.ContainerComponentFactory", {
  Lio_github_shogowada_scalajs_reactjs_redux_ContainerComponentFactory: 1,
  O: 1
});
$c_Lio_github_shogowada_scalajs_reactjs_redux_ContainerComponentFactory.prototype.$classData = $d_Lio_github_shogowada_scalajs_reactjs_redux_ContainerComponentFactory;
function $p_Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$__selectorFactoryToNative__F1__sjs_js_Function1($thiz, selectorFactory) {
  return (function(selectorFactory$1) {
    return (function(arg1$2) {
      return $m_Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$().io$github$shogowada$scalajs$reactjs$redux$ReactRedux$$$anonfun$selectorFactoryToNative$1__sjs_js_Function1__F1__sjs_js_Function2(arg1$2, selectorFactory$1)
    })
  })(selectorFactory)
}
function $p_Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$__selectorToNative__F2__sjs_js_Function2($thiz, selector) {
  return (function(selector$1) {
    return (function(arg1$2, arg2$2) {
      return $m_Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$().io$github$shogowada$scalajs$reactjs$redux$ReactRedux$$$anonfun$selectorToNative$1__O__sjs_js_Dynamic__F2__sjs_js_Any(arg1$2, arg2$2, selector$1)
    })
  })(selector)
}
function $p_Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$__clone__sjs_js_Dynamic__sjs_js_Dynamic($thiz, plainObject) {
  var fields = $m_sci_Nil$();
  var clonedPlainObject = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields);
  var keys = Object.keys(plainObject);
  var len = $uI(keys.length);
  var i = 0;
  while ((i < len)) {
    var arg1 = keys[i];
    var key = $as_T(arg1);
    clonedPlainObject[key] = plainObject[key];
    i = ((1 + i) | 0)
  };
  return clonedPlainObject
}
/** @constructor */
function $c_Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$() {
  this.Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$__f_bitmap$init$0 = false
}
$c_Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$.prototype = new $h_O();
$c_Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$.prototype.constructor = $c_Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$;
/** @constructor */
function $h_Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$() {
  /*<skip>*/
}
$h_Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$.prototype = $c_Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$.prototype;
$c_Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$.prototype.connectAdvanced__F1__Lio_github_shogowada_scalajs_reactjs_redux_ContainerComponentFactory = (function(selectorFactory) {
  var nativeSelectorFactory = $p_Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$__selectorFactoryToNative__F1__sjs_js_Function1(this, selectorFactory);
  var nativeFactory = $i_react$002dredux.connectAdvanced(nativeSelectorFactory);
  return new $c_Lio_github_shogowada_scalajs_reactjs_redux_ContainerComponentFactory(nativeFactory)
});
$c_Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$.prototype.io$github$shogowada$scalajs$reactjs$redux$ReactRedux$$$anonfun$selectorFactoryToNative$1__sjs_js_Function1__F1__sjs_js_Function2 = (function(nativeDispatch, selectorFactory$1) {
  var dispatch = $m_Lio_github_shogowada_scalajs_reactjs_redux_ReduxInternal$().dispatchFromNative__sjs_js_Function1__F1(nativeDispatch);
  var selector = $as_F2(selectorFactory$1.apply__O__O(dispatch));
  return $p_Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$__selectorToNative__F2__sjs_js_Function2($m_Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$(), selector)
});
$c_Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$.prototype.io$github$shogowada$scalajs$reactjs$redux$ReactRedux$$$anonfun$selectorToNative$1__O__sjs_js_Dynamic__F2__sjs_js_Any = (function(state, nativeOwnProps, selector$1) {
  var ownProps = new $c_Lio_github_shogowada_scalajs_reactjs_React$Props(nativeOwnProps);
  var wrappedProps = selector$1.apply__O__O__O(state, ownProps);
  var nativeProps = $p_Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$__clone__sjs_js_Dynamic__sjs_js_Dynamic($m_Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$(), nativeOwnProps);
  nativeProps[$m_Lio_github_shogowada_scalajs_reactjs_React$().WrappedProperty__T()] = wrappedProps;
  return nativeProps
});
var $d_Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ = new $TypeData().initClass({
  Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$: 0
}, false, "io.github.shogowada.scalajs.reactjs.redux.ReactRedux$", {
  Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$: 1,
  O: 1
});
$c_Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$.prototype.$classData = $d_Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$;
var $n_Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$;
function $m_Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$() {
  if ((!$n_Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$)) {
    $n_Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ = new $c_Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$()
  };
  return $n_Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$
}
function $p_Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMAttributes__store$lzycompute__Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMAttributes$StoreAttributeSpec($thiz) {
  if ((!$thiz.Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMAttributes__f_bitmap$0)) {
    $thiz.Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMAttributes__f_store = new $c_Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMAttributes$StoreAttributeSpec("store");
    $thiz.Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMAttributes__f_bitmap$0 = true
  };
  return $thiz.Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMAttributes__f_store
}
/** @constructor */
function $c_Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMAttributes(attributes) {
  this.Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMAttributes__f_store = null;
  this.Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMAttributes__f_bitmap$0 = false
}
$c_Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMAttributes.prototype = new $h_O();
$c_Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMAttributes.prototype.constructor = $c_Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMAttributes;
/** @constructor */
function $h_Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMAttributes() {
  /*<skip>*/
}
$h_Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMAttributes.prototype = $c_Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMAttributes.prototype;
$c_Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMAttributes.prototype.store__Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMAttributes$StoreAttributeSpec = (function() {
  return ((!this.Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMAttributes__f_bitmap$0) ? $p_Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMAttributes__store$lzycompute__Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMAttributes$StoreAttributeSpec(this) : this.Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMAttributes__f_store)
});
var $d_Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMAttributes = new $TypeData().initClass({
  Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMAttributes: 0
}, false, "io.github.shogowada.scalajs.reactjs.redux.ReactRedux$ReactReduxVirtualDOMAttributes", {
  Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMAttributes: 1,
  O: 1
});
$c_Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMAttributes.prototype.$classData = $d_Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMAttributes;
function $p_Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMElements__Provider$lzycompute__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($thiz) {
  if ((!$thiz.Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMElements__f_bitmap$0)) {
    var reactClass = $i_react$002dredux.Provider;
    $thiz.Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMElements__f_Provider = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass);
    $thiz.Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMElements__f_bitmap$0 = true
  };
  $thiz.Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMElements__f_elements = null;
  return $thiz.Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMElements__f_Provider
}
/** @constructor */
function $c_Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMElements(elements) {
  this.Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMElements__f_Provider = null;
  this.Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMElements__f_elements = null;
  this.Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMElements__f_bitmap$0 = false;
  this.Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMElements__f_elements = elements
}
$c_Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMElements.prototype = new $h_O();
$c_Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMElements.prototype.constructor = $c_Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMElements;
/** @constructor */
function $h_Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMElements() {
  /*<skip>*/
}
$h_Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMElements.prototype = $c_Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMElements.prototype;
$c_Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMElements.prototype.Provider__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec = (function() {
  return ((!this.Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMElements__f_bitmap$0) ? $p_Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMElements__Provider$lzycompute__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec(this) : this.Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMElements__f_Provider)
});
var $d_Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMElements = new $TypeData().initClass({
  Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMElements: 0
}, false, "io.github.shogowada.scalajs.reactjs.redux.ReactRedux$ReactReduxVirtualDOMElements", {
  Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMElements: 1,
  O: 1
});
$c_Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMElements.prototype.$classData = $d_Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMElements;
/** @constructor */
function $c_Lio_github_shogowada_scalajs_reactjs_redux_Redux$() {
  /*<skip>*/
}
$c_Lio_github_shogowada_scalajs_reactjs_redux_Redux$.prototype = new $h_O();
$c_Lio_github_shogowada_scalajs_reactjs_redux_Redux$.prototype.constructor = $c_Lio_github_shogowada_scalajs_reactjs_redux_Redux$;
/** @constructor */
function $h_Lio_github_shogowada_scalajs_reactjs_redux_Redux$() {
  /*<skip>*/
}
$h_Lio_github_shogowada_scalajs_reactjs_redux_Redux$.prototype = $c_Lio_github_shogowada_scalajs_reactjs_redux_Redux$.prototype;
$c_Lio_github_shogowada_scalajs_reactjs_redux_Redux$.prototype.createStore__F2__sjs_js_Any__Lio_github_shogowada_scalajs_reactjs_redux_Store = (function(reducer, enhancer) {
  var nativeReducer = $m_Lio_github_shogowada_scalajs_reactjs_redux_ReduxInternal$().reducerToNative__F2__sjs_js_Function2(reducer);
  var nativeStore = $i_redux.createStore(nativeReducer, enhancer);
  return new $c_Lio_github_shogowada_scalajs_reactjs_redux_Store(nativeStore)
});
var $d_Lio_github_shogowada_scalajs_reactjs_redux_Redux$ = new $TypeData().initClass({
  Lio_github_shogowada_scalajs_reactjs_redux_Redux$: 0
}, false, "io.github.shogowada.scalajs.reactjs.redux.Redux$", {
  Lio_github_shogowada_scalajs_reactjs_redux_Redux$: 1,
  O: 1
});
$c_Lio_github_shogowada_scalajs_reactjs_redux_Redux$.prototype.$classData = $d_Lio_github_shogowada_scalajs_reactjs_redux_Redux$;
var $n_Lio_github_shogowada_scalajs_reactjs_redux_Redux$;
function $m_Lio_github_shogowada_scalajs_reactjs_redux_Redux$() {
  if ((!$n_Lio_github_shogowada_scalajs_reactjs_redux_Redux$)) {
    $n_Lio_github_shogowada_scalajs_reactjs_redux_Redux$ = new $c_Lio_github_shogowada_scalajs_reactjs_redux_Redux$()
  };
  return $n_Lio_github_shogowada_scalajs_reactjs_redux_Redux$
}
/** @constructor */
function $c_Lio_github_shogowada_scalajs_reactjs_redux_ReduxInternal$() {
  /*<skip>*/
}
$c_Lio_github_shogowada_scalajs_reactjs_redux_ReduxInternal$.prototype = new $h_O();
$c_Lio_github_shogowada_scalajs_reactjs_redux_ReduxInternal$.prototype.constructor = $c_Lio_github_shogowada_scalajs_reactjs_redux_ReduxInternal$;
/** @constructor */
function $h_Lio_github_shogowada_scalajs_reactjs_redux_ReduxInternal$() {
  /*<skip>*/
}
$h_Lio_github_shogowada_scalajs_reactjs_redux_ReduxInternal$.prototype = $c_Lio_github_shogowada_scalajs_reactjs_redux_ReduxInternal$.prototype;
$c_Lio_github_shogowada_scalajs_reactjs_redux_ReduxInternal$.prototype.actionToNative__O__Lio_github_shogowada_scalajs_reactjs_redux_NativeAction = (function(action) {
  if ($is_Lio_github_shogowada_scalajs_reactjs_redux_Action(action)) {
    var x2 = $as_Lio_github_shogowada_scalajs_reactjs_redux_Action(action);
    var s = $objectGetClass(x2).getSimpleName__T();
    var array = [new $c_T2("type", s), new $c_T2("wrapped", x2)];
    var fields = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    return $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fields)
  } else {
    return action
  }
});
$c_Lio_github_shogowada_scalajs_reactjs_redux_ReduxInternal$.prototype.actionFromNative__sjs_js_Any__s_Option = (function(nativeAction) {
  var v = nativeAction.wrapped;
  if ((v === (void 0))) {
    return $m_s_None$()
  } else {
    var x1 = nativeAction.wrapped;
    return ($is_Lio_github_shogowada_scalajs_reactjs_redux_Action(x1) ? $m_s_Option$().apply__O__s_Option(x1) : $m_s_None$())
  }
});
$c_Lio_github_shogowada_scalajs_reactjs_redux_ReduxInternal$.prototype.reducerToNative__F2__sjs_js_Function2 = (function(reducer) {
  return (function(reducer$1) {
    return (function(arg1$2, arg2$2) {
      return $m_Lio_github_shogowada_scalajs_reactjs_redux_ReduxInternal$().io$github$shogowada$scalajs$reactjs$redux$ReduxInternal$$$anonfun$reducerToNative$1__sjs_js_Any__Lio_github_shogowada_scalajs_reactjs_redux_NativeAction__F2__sjs_js_Any(arg1$2, arg2$2, reducer$1)
    })
  })(reducer)
});
$c_Lio_github_shogowada_scalajs_reactjs_redux_ReduxInternal$.prototype.dispatchFromNative__sjs_js_Function1__F1 = (function(nativeDispatch) {
  return new $c_sjsr_AnonFunction1((function(this$1, nativeDispatch$1) {
    return (function(action$2) {
      if ($is_Lio_github_shogowada_scalajs_reactjs_redux_Action(action$2)) {
        var x2 = $as_Lio_github_shogowada_scalajs_reactjs_redux_Action(action$2);
        var nativeAction = $m_Lio_github_shogowada_scalajs_reactjs_redux_ReduxInternal$().actionToNative__O__Lio_github_shogowada_scalajs_reactjs_redux_NativeAction(x2);
        return nativeDispatch$1(nativeAction)
      } else {
        return nativeDispatch$1(action$2)
      }
    })
  })(this, nativeDispatch))
});
$c_Lio_github_shogowada_scalajs_reactjs_redux_ReduxInternal$.prototype.io$github$shogowada$scalajs$reactjs$redux$ReduxInternal$$$anonfun$reducerToNative$1__sjs_js_Any__Lio_github_shogowada_scalajs_reactjs_redux_NativeAction__F2__sjs_js_Any = (function(state, nativeAction, reducer$1) {
  var this$1 = $m_s_Option$().apply__O__s_Option(state);
  if (this$1.isEmpty__Z()) {
    var $$x1 = true
  } else {
    var arg1 = this$1.get__O();
    var $$x1 = (!(arg1 === (void 0)))
  };
  if ($$x1) {
    var this$3 = this$1
  } else {
    var this$3 = $m_s_None$()
  };
  if (this$3.isEmpty__Z()) {
    var maybeState = $m_s_None$()
  } else {
    var arg1$1 = this$3.get__O();
    var maybeState = new $c_s_Some(arg1$1)
  };
  var x1 = $m_Lio_github_shogowada_scalajs_reactjs_redux_ReduxInternal$().actionFromNative__sjs_js_Any__s_Option(nativeAction);
  if ((x1 instanceof $c_s_Some)) {
    var x2 = $as_s_Some(x1);
    var action = $as_Lio_github_shogowada_scalajs_reactjs_redux_Action(x2.s_Some__f_value);
    if ((action !== null)) {
      return reducer$1.apply__O__O__O(maybeState, action)
    }
  };
  return reducer$1.apply__O__O__O(maybeState, nativeAction)
});
var $d_Lio_github_shogowada_scalajs_reactjs_redux_ReduxInternal$ = new $TypeData().initClass({
  Lio_github_shogowada_scalajs_reactjs_redux_ReduxInternal$: 0
}, false, "io.github.shogowada.scalajs.reactjs.redux.ReduxInternal$", {
  Lio_github_shogowada_scalajs_reactjs_redux_ReduxInternal$: 1,
  O: 1
});
$c_Lio_github_shogowada_scalajs_reactjs_redux_ReduxInternal$.prototype.$classData = $d_Lio_github_shogowada_scalajs_reactjs_redux_ReduxInternal$;
var $n_Lio_github_shogowada_scalajs_reactjs_redux_ReduxInternal$;
function $m_Lio_github_shogowada_scalajs_reactjs_redux_ReduxInternal$() {
  if ((!$n_Lio_github_shogowada_scalajs_reactjs_redux_ReduxInternal$)) {
    $n_Lio_github_shogowada_scalajs_reactjs_redux_ReduxInternal$ = new $c_Lio_github_shogowada_scalajs_reactjs_redux_ReduxInternal$()
  };
  return $n_Lio_github_shogowada_scalajs_reactjs_redux_ReduxInternal$
}
/** @constructor */
function $c_Lio_github_shogowada_statictags_Attribute$RichBoolean(outer, value) {
  this.Lio_github_shogowada_statictags_Attribute$RichBoolean__f_value = false;
  this.Lio_github_shogowada_statictags_Attribute$RichBoolean__f_$outer = null;
  this.Lio_github_shogowada_statictags_Attribute$RichBoolean__f_value = value;
  if ((outer === null)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(null)
  } else {
    this.Lio_github_shogowada_statictags_Attribute$RichBoolean__f_$outer = outer
  }
}
$c_Lio_github_shogowada_statictags_Attribute$RichBoolean.prototype = new $h_O();
$c_Lio_github_shogowada_statictags_Attribute$RichBoolean.prototype.constructor = $c_Lio_github_shogowada_statictags_Attribute$RichBoolean;
/** @constructor */
function $h_Lio_github_shogowada_statictags_Attribute$RichBoolean() {
  /*<skip>*/
}
$h_Lio_github_shogowada_statictags_Attribute$RichBoolean.prototype = $c_Lio_github_shogowada_statictags_Attribute$RichBoolean.prototype;
$c_Lio_github_shogowada_statictags_Attribute$RichBoolean.prototype.fold__O__O__O = (function(trueValue, falseValue) {
  return (this.Lio_github_shogowada_statictags_Attribute$RichBoolean__f_value ? trueValue : falseValue)
});
var $d_Lio_github_shogowada_statictags_Attribute$RichBoolean = new $TypeData().initClass({
  Lio_github_shogowada_statictags_Attribute$RichBoolean: 0
}, false, "io.github.shogowada.statictags.Attribute$RichBoolean", {
  Lio_github_shogowada_statictags_Attribute$RichBoolean: 1,
  O: 1
});
$c_Lio_github_shogowada_statictags_Attribute$RichBoolean.prototype.$classData = $d_Lio_github_shogowada_statictags_Attribute$RichBoolean;
function $f_Lio_github_shogowada_statictags_StaticTags__$init$__V($thiz) {
  $thiz.io$github$shogowada$statictags$StaticTags$_setter_$$less_$eq__Lio_github_shogowada_statictags_StaticTags$Elements__V($ct_Lio_github_shogowada_statictags_StaticTags$Elements__Lio_github_shogowada_statictags_StaticTags__(new $c_Lio_github_shogowada_statictags_StaticTags$Elements(), $thiz));
  $thiz.io$github$shogowada$statictags$StaticTags$_setter_$$up_$eq__Lio_github_shogowada_statictags_StaticTags$Attributes__V($ct_Lio_github_shogowada_statictags_StaticTags$Attributes__Lio_github_shogowada_statictags_StaticTags__(new $c_Lio_github_shogowada_statictags_StaticTags$Attributes(), $thiz))
}
function $p_Lio_github_shogowada_statictags_StaticTags$Attributes__height$lzycompute__Lio_github_shogowada_statictags_IntegerAttributeSpec($thiz) {
  var b = $thiz.Lio_github_shogowada_statictags_StaticTags$Attributes__f_bitmap$0;
  var hi = (8192 & b.RTLong__f_hi);
  if ((hi === 0)) {
    $thiz.Lio_github_shogowada_statictags_StaticTags$Attributes__f_height = new $c_Lio_github_shogowada_statictags_IntegerAttributeSpec("height");
    var b$1 = $thiz.Lio_github_shogowada_statictags_StaticTags$Attributes__f_bitmap$0;
    var lo = b$1.RTLong__f_lo;
    var hi$1 = (8192 | b$1.RTLong__f_hi);
    $thiz.Lio_github_shogowada_statictags_StaticTags$Attributes__f_bitmap$0 = new $c_RTLong(lo, hi$1)
  };
  return $thiz.Lio_github_shogowada_statictags_StaticTags$Attributes__f_height
}
function $p_Lio_github_shogowada_statictags_StaticTags$Attributes__label$lzycompute__Lio_github_shogowada_statictags_StringAttributeSpec($thiz) {
  var b = $thiz.Lio_github_shogowada_statictags_StaticTags$Attributes__f_bitmap$0;
  var hi = (134217728 & b.RTLong__f_hi);
  if ((hi === 0)) {
    $thiz.Lio_github_shogowada_statictags_StaticTags$Attributes__f_label = new $c_Lio_github_shogowada_statictags_StringAttributeSpec("label");
    var b$1 = $thiz.Lio_github_shogowada_statictags_StaticTags$Attributes__f_bitmap$0;
    var lo = b$1.RTLong__f_lo;
    var hi$1 = (134217728 | b$1.RTLong__f_hi);
    $thiz.Lio_github_shogowada_statictags_StaticTags$Attributes__f_bitmap$0 = new $c_RTLong(lo, hi$1)
  };
  return $thiz.Lio_github_shogowada_statictags_StaticTags$Attributes__f_label
}
function $p_Lio_github_shogowada_statictags_StaticTags$Attributes__name$lzycompute__Lio_github_shogowada_statictags_StringAttributeSpec($thiz) {
  var b = $thiz.Lio_github_shogowada_statictags_StaticTags$Attributes__f_bitmap$1;
  var lo = (1024 & b.RTLong__f_lo);
  if ((lo === 0)) {
    $thiz.Lio_github_shogowada_statictags_StaticTags$Attributes__f_name = new $c_Lio_github_shogowada_statictags_StringAttributeSpec("name");
    var b$1 = $thiz.Lio_github_shogowada_statictags_StaticTags$Attributes__f_bitmap$1;
    var lo$1 = (1024 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lio_github_shogowada_statictags_StaticTags$Attributes__f_bitmap$1 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lio_github_shogowada_statictags_StaticTags$Attributes__f_name
}
function $p_Lio_github_shogowada_statictags_StaticTags$Attributes__title$lzycompute__Lio_github_shogowada_statictags_StringAttributeSpec($thiz) {
  var b = $thiz.Lio_github_shogowada_statictags_StaticTags$Attributes__f_bitmap$1;
  var hi = (16384 & b.RTLong__f_hi);
  if ((hi === 0)) {
    $thiz.Lio_github_shogowada_statictags_StaticTags$Attributes__f_title = new $c_Lio_github_shogowada_statictags_StringAttributeSpec("title");
    var b$1 = $thiz.Lio_github_shogowada_statictags_StaticTags$Attributes__f_bitmap$1;
    var lo = b$1.RTLong__f_lo;
    var hi$1 = (16384 | b$1.RTLong__f_hi);
    $thiz.Lio_github_shogowada_statictags_StaticTags$Attributes__f_bitmap$1 = new $c_RTLong(lo, hi$1)
  };
  return $thiz.Lio_github_shogowada_statictags_StaticTags$Attributes__f_title
}
function $p_Lio_github_shogowada_statictags_StaticTags$Attributes__value$lzycompute__Lio_github_shogowada_statictags_ValueAttributeSpec($thiz) {
  var b = $thiz.Lio_github_shogowada_statictags_StaticTags$Attributes__f_bitmap$1;
  var hi = (524288 & b.RTLong__f_hi);
  if ((hi === 0)) {
    $thiz.Lio_github_shogowada_statictags_StaticTags$Attributes__f_value = new $c_Lio_github_shogowada_statictags_ValueAttributeSpec("value");
    var b$1 = $thiz.Lio_github_shogowada_statictags_StaticTags$Attributes__f_bitmap$1;
    var lo = b$1.RTLong__f_lo;
    var hi$1 = (524288 | b$1.RTLong__f_hi);
    $thiz.Lio_github_shogowada_statictags_StaticTags$Attributes__f_bitmap$1 = new $c_RTLong(lo, hi$1)
  };
  return $thiz.Lio_github_shogowada_statictags_StaticTags$Attributes__f_value
}
function $p_Lio_github_shogowada_statictags_StaticTags$Attributes__width$lzycompute__Lio_github_shogowada_statictags_IntegerAttributeSpec($thiz) {
  var b = $thiz.Lio_github_shogowada_statictags_StaticTags$Attributes__f_bitmap$1;
  var hi = (1048576 & b.RTLong__f_hi);
  if ((hi === 0)) {
    $thiz.Lio_github_shogowada_statictags_StaticTags$Attributes__f_width = new $c_Lio_github_shogowada_statictags_IntegerAttributeSpec("width");
    var b$1 = $thiz.Lio_github_shogowada_statictags_StaticTags$Attributes__f_bitmap$1;
    var lo = b$1.RTLong__f_lo;
    var hi$1 = (1048576 | b$1.RTLong__f_hi);
    $thiz.Lio_github_shogowada_statictags_StaticTags$Attributes__f_bitmap$1 = new $c_RTLong(lo, hi$1)
  };
  return $thiz.Lio_github_shogowada_statictags_StaticTags$Attributes__f_width
}
function $ct_Lio_github_shogowada_statictags_StaticTags$Attributes__Lio_github_shogowada_statictags_StaticTags__($thiz, outer) {
  if ((outer === null)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(null)
  } else {
    $thiz.Lio_github_shogowada_statictags_StaticTags$Attributes__f_$outer = outer
  };
  return $thiz
}
/** @constructor */
function $c_Lio_github_shogowada_statictags_StaticTags$Attributes() {
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_abbr = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_accept = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_accept$minuscharset = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_accesskey = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_action = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_allowfullscreen = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_allowTransparency = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_alt = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_async = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_autocomplete = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_autofocus = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_autoplay = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_border = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_challenge = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_capture = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_charset = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_checked = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_cite = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_class = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_cols = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_colspan = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_content = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_contenteditable = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_contextmenu = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_controls = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_coords = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_crossorigin = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_data = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_datetime = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_default = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_defer = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_dir = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_dirname = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_disabled = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_download = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_draggable = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_enctype = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_for = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_form = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_formaction = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_formenctype = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_formmethod = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_formnovalidate = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_formtarget = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_headers = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_height = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_hidden = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_high = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_href = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_hreflang = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_http$minusequiv = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_icon = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_id = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_inputmode = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_integrity = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_is = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_ismap = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_keytype = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_kind = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_label = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_lang = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_list = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_loop = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_low = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_manifest = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_max = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_maxlength = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_media = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_mediagroup = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_method = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_min = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_minlength = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_multiple = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_muted = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_name = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_nonce = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_novalidate = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_open = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_optimum = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_pattern = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_placeholder = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_poster = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_preload = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_radiogroup = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_readonly = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_rel = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_required = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_reversed = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_role = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_rows = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_rowspan = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_sandbox = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_scope = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_scoped = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_seamless = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_selected = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_shape = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_size = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_sizes = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_span = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_spellcheck = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_src = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_srcdoc = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_srclang = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_srcset = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_start = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_step = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_style = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_tabindex = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_target = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_title = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_translate = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_type = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_typemustmatch = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_usemap = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_value = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_width = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_wmode = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_wrap = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_bitmap$0 = $L0;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_bitmap$1 = $L0;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_$outer = null
}
$c_Lio_github_shogowada_statictags_StaticTags$Attributes.prototype = new $h_O();
$c_Lio_github_shogowada_statictags_StaticTags$Attributes.prototype.constructor = $c_Lio_github_shogowada_statictags_StaticTags$Attributes;
/** @constructor */
function $h_Lio_github_shogowada_statictags_StaticTags$Attributes() {
  /*<skip>*/
}
$h_Lio_github_shogowada_statictags_StaticTags$Attributes.prototype = $c_Lio_github_shogowada_statictags_StaticTags$Attributes.prototype;
$c_Lio_github_shogowada_statictags_StaticTags$Attributes.prototype.height__Lio_github_shogowada_statictags_IntegerAttributeSpec = (function() {
  var b = this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_bitmap$0;
  var hi = (8192 & b.RTLong__f_hi);
  if ((hi === 0)) {
    return $p_Lio_github_shogowada_statictags_StaticTags$Attributes__height$lzycompute__Lio_github_shogowada_statictags_IntegerAttributeSpec(this)
  } else {
    return this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_height
  }
});
$c_Lio_github_shogowada_statictags_StaticTags$Attributes.prototype.label__Lio_github_shogowada_statictags_StringAttributeSpec = (function() {
  var b = this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_bitmap$0;
  var hi = (134217728 & b.RTLong__f_hi);
  if ((hi === 0)) {
    return $p_Lio_github_shogowada_statictags_StaticTags$Attributes__label$lzycompute__Lio_github_shogowada_statictags_StringAttributeSpec(this)
  } else {
    return this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_label
  }
});
$c_Lio_github_shogowada_statictags_StaticTags$Attributes.prototype.name__Lio_github_shogowada_statictags_StringAttributeSpec = (function() {
  var b = this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_bitmap$1;
  var lo = (1024 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lio_github_shogowada_statictags_StaticTags$Attributes__name$lzycompute__Lio_github_shogowada_statictags_StringAttributeSpec(this)
  } else {
    return this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_name
  }
});
$c_Lio_github_shogowada_statictags_StaticTags$Attributes.prototype.title__Lio_github_shogowada_statictags_StringAttributeSpec = (function() {
  var b = this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_bitmap$1;
  var hi = (16384 & b.RTLong__f_hi);
  if ((hi === 0)) {
    return $p_Lio_github_shogowada_statictags_StaticTags$Attributes__title$lzycompute__Lio_github_shogowada_statictags_StringAttributeSpec(this)
  } else {
    return this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_title
  }
});
$c_Lio_github_shogowada_statictags_StaticTags$Attributes.prototype.value__Lio_github_shogowada_statictags_ValueAttributeSpec = (function() {
  var b = this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_bitmap$1;
  var hi = (524288 & b.RTLong__f_hi);
  if ((hi === 0)) {
    return $p_Lio_github_shogowada_statictags_StaticTags$Attributes__value$lzycompute__Lio_github_shogowada_statictags_ValueAttributeSpec(this)
  } else {
    return this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_value
  }
});
$c_Lio_github_shogowada_statictags_StaticTags$Attributes.prototype.width__Lio_github_shogowada_statictags_IntegerAttributeSpec = (function() {
  var b = this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_bitmap$1;
  var hi = (1048576 & b.RTLong__f_hi);
  if ((hi === 0)) {
    return $p_Lio_github_shogowada_statictags_StaticTags$Attributes__width$lzycompute__Lio_github_shogowada_statictags_IntegerAttributeSpec(this)
  } else {
    return this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_width
  }
});
var $d_Lio_github_shogowada_statictags_StaticTags$Attributes = new $TypeData().initClass({
  Lio_github_shogowada_statictags_StaticTags$Attributes: 0
}, false, "io.github.shogowada.statictags.StaticTags$Attributes", {
  Lio_github_shogowada_statictags_StaticTags$Attributes: 1,
  O: 1
});
$c_Lio_github_shogowada_statictags_StaticTags$Attributes.prototype.$classData = $d_Lio_github_shogowada_statictags_StaticTags$Attributes;
function $ct_Lio_github_shogowada_statictags_StaticTags$Elements__Lio_github_shogowada_statictags_StaticTags__($thiz, outer) {
  if ((outer === null)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(null)
  } else {
    $thiz.Lio_github_shogowada_statictags_StaticTags$Elements__f_$outer = outer
  };
  return $thiz
}
/** @constructor */
function $c_Lio_github_shogowada_statictags_StaticTags$Elements() {
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_a = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_abbr = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_address = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_area = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_article = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_aside = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_audio = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_b = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_base = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_bdi = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_bdo = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_blockquote = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_body = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_br = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_button = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_canvas = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_caption = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_cite = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_code = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_col = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_colgroup = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_data = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_datalist = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_dd = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_del = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_dfn = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_div = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_dl = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_dt = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_em = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_embed = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_fieldset = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_figcaption = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_figure = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_footer = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_form = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_h1 = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_h2 = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_h3 = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_h4 = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_h5 = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_h6 = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_head = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_header = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_hr = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_html = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_i = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_iframe = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_img = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_input = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_ins = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_kbd = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_keygen = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_label = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_legend = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_li = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_link = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_main = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_map = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_mark = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_meta = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_meter = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_nav = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_noscript = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_object = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_ol = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_optgroup = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_option = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_output = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_p = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_param = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_pre = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_progress = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_q = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_rb = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_rp = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_rt = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_rtc = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_ruby = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_s = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_samp = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_script = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_section = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_select = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_small = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_source = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_span = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_strong = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_style = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_sub = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_sup = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_table = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_tbody = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_td = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_template = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_textarea = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_tfoot = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_th = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_thead = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_time = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_title = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_tr = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_track = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_u = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_ul = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_var = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_video = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_wbr = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_bitmap$0 = $L0;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_bitmap$1 = $L0;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_$outer = null
}
$c_Lio_github_shogowada_statictags_StaticTags$Elements.prototype = new $h_O();
$c_Lio_github_shogowada_statictags_StaticTags$Elements.prototype.constructor = $c_Lio_github_shogowada_statictags_StaticTags$Elements;
/** @constructor */
function $h_Lio_github_shogowada_statictags_StaticTags$Elements() {
  /*<skip>*/
}
$h_Lio_github_shogowada_statictags_StaticTags$Elements.prototype = $c_Lio_github_shogowada_statictags_StaticTags$Elements.prototype;
var $d_Lio_github_shogowada_statictags_StaticTags$Elements = new $TypeData().initClass({
  Lio_github_shogowada_statictags_StaticTags$Elements: 0
}, false, "io.github.shogowada.statictags.StaticTags$Elements", {
  Lio_github_shogowada_statictags_StaticTags$Elements: 1,
  O: 1
});
$c_Lio_github_shogowada_statictags_StaticTags$Elements.prototype.$classData = $d_Lio_github_shogowada_statictags_StaticTags$Elements;
function $p_jl_Class__computeCachedSimpleNameBestEffort__T($thiz) {
  if ($thiz.isArray__Z()) {
    return ($thiz.getComponentType__jl_Class().getSimpleName__T() + "[]")
  } else {
    var name = $as_T($thiz.jl_Class__f_data.name);
    var idx = (((-1) + $uI(name.length)) | 0);
    while (true) {
      if ((idx >= 0)) {
        var index = idx;
        var $$x1 = ((65535 & $uI(name.charCodeAt(index))) === 36)
      } else {
        var $$x1 = false
      };
      if ($$x1) {
        idx = (((-1) + idx) | 0)
      } else {
        break
      }
    };
    if ((idx >= 0)) {
      var index$1 = idx;
      var c = (65535 & $uI(name.charCodeAt(index$1)));
      var $$x2 = ((c >= 48) && (c <= 57))
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      idx = (((-1) + idx) | 0);
      while (true) {
        if ((idx >= 0)) {
          var index$2 = idx;
          var c$1 = (65535 & $uI(name.charCodeAt(index$2)));
          var $$x3 = ((c$1 >= 48) && (c$1 <= 57))
        } else {
          var $$x3 = false
        };
        if ($$x3) {
          idx = (((-1) + idx) | 0)
        } else {
          break
        }
      };
      while (true) {
        if ((idx >= 0)) {
          var index$3 = idx;
          var $$x4 = ((65535 & $uI(name.charCodeAt(index$3))) === 36)
        } else {
          var $$x4 = false
        };
        if ($$x4) {
          idx = (((-1) + idx) | 0)
        } else {
          break
        }
      }
    };
    while (true) {
      if ((idx >= 0)) {
        var index$4 = idx;
        var currChar = (65535 & $uI(name.charCodeAt(index$4)));
        var $$x5 = ((currChar !== 46) && (currChar !== 36))
      } else {
        var $$x5 = false
      };
      if ($$x5) {
        idx = (((-1) + idx) | 0)
      } else {
        break
      }
    };
    var beginIndex = ((1 + idx) | 0);
    return $as_T(name.substring(beginIndex))
  }
}
/** @constructor */
function $c_jl_Class(data0) {
  this.jl_Class__f_data = null;
  this.jl_Class__f_cachedSimpleName = null;
  this.jl_Class__f_data = data0
}
$c_jl_Class.prototype = new $h_O();
$c_jl_Class.prototype.constructor = $c_jl_Class;
/** @constructor */
function $h_jl_Class() {
  /*<skip>*/
}
$h_jl_Class.prototype = $c_jl_Class.prototype;
$c_jl_Class.prototype.toString__T = (function() {
  return ((this.isInterface__Z() ? "interface " : (this.isPrimitive__Z() ? "" : "class ")) + this.getName__T())
});
$c_jl_Class.prototype.isAssignableFrom__jl_Class__Z = (function(that) {
  return $uZ(this.jl_Class__f_data.isAssignableFrom(that.jl_Class__f_data))
});
$c_jl_Class.prototype.isInterface__Z = (function() {
  return $uZ(this.jl_Class__f_data.isInterface)
});
$c_jl_Class.prototype.isArray__Z = (function() {
  return $uZ(this.jl_Class__f_data.isArrayClass)
});
$c_jl_Class.prototype.isPrimitive__Z = (function() {
  return $uZ(this.jl_Class__f_data.isPrimitive)
});
$c_jl_Class.prototype.getName__T = (function() {
  return $as_T(this.jl_Class__f_data.name)
});
$c_jl_Class.prototype.getSimpleName__T = (function() {
  if ((this.jl_Class__f_cachedSimpleName === null)) {
    this.jl_Class__f_cachedSimpleName = $p_jl_Class__computeCachedSimpleNameBestEffort__T(this)
  };
  return this.jl_Class__f_cachedSimpleName
});
$c_jl_Class.prototype.getComponentType__jl_Class = (function() {
  return $as_jl_Class(this.jl_Class__f_data.getComponentType())
});
$c_jl_Class.prototype.newArrayOfThisClass__O__O = (function(dimensions) {
  return this.jl_Class__f_data.newArrayOfThisClass(dimensions)
});
function $as_jl_Class(obj) {
  return (((obj instanceof $c_jl_Class) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Class"))
}
function $isArrayOf_jl_Class(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Class)))
}
function $asArrayOf_jl_Class(obj, depth) {
  return (($isArrayOf_jl_Class(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Class;", depth))
}
var $d_jl_Class = new $TypeData().initClass({
  jl_Class: 0
}, false, "java.lang.Class", {
  jl_Class: 1,
  O: 1
});
$c_jl_Class.prototype.$classData = $d_jl_Class;
function $p_jl_FloatingPointBits$__doubleHashCodePolyfill__D__I($thiz, value) {
  if ((value !== value)) {
    var sef__s = false;
    var sef__e = 2047;
    var sef__f = 2.251799813685248E15
  } else if (((value === Infinity) || (value === (-Infinity)))) {
    var s = (value < 0.0);
    var sef__s = s;
    var sef__e = 2047;
    var sef__f = 0.0
  } else if ((value === 0.0)) {
    var s$1 = ((1.0 / value) === (-Infinity));
    var sef__s = s$1;
    var sef__e = 0;
    var sef__f = 0.0
  } else {
    var s$2 = (value < 0.0);
    var av = (s$2 ? (-value) : value);
    if ((av >= 2.2250738585072014E-308)) {
      var x = $uD(Math.floor(($uD(Math.log(av)) / 0.6931471805599453)));
      var e = $uI((x | 0));
      if ((e > 1023)) {
        e = 1023
      };
      var significand = (av / $uD(Math.pow(2.0, e)));
      if ((significand < 1.0)) {
        e = (((-1) + e) | 0);
        significand = (2.0 * significand)
      } else if ((significand >= 2.0)) {
        e = ((1 + e) | 0);
        significand = (significand / 2.0)
      };
      var n = (4.503599627370496E15 * (significand - 1.0));
      var f = ((4.9E-324 * n) / 4.9E-324);
      if ((f === 4.503599627370496E15)) {
        e = ((1 + e) | 0);
        f = 0.0
      };
      e = ((1023 + e) | 0);
      if ((e > 2046)) {
        e = 2047;
        f = 0.0
      };
      var e$1 = e;
      var f$1 = f;
      var sef__s = s$2;
      var sef__e = e$1;
      var sef__f = f$1
    } else {
      var n$1 = (av / 4.9E-324);
      var f$2 = ((4.9E-324 * n$1) / 4.9E-324);
      var sef__s = s$2;
      var sef__e = 0;
      var sef__f = f$2
    }
  };
  var x$1 = (sef__f / 4.294967296E9);
  var hif = $uI((x$1 | 0));
  var hi = (((sef__s ? (-2147483648) : 0) | (sef__e << 20)) | hif);
  var x$2 = sef__f;
  var lo = $uI((x$2 | 0));
  return (lo ^ hi)
}
function $p_jl_FloatingPointBits$__intBitsToFloatPolyfill__I__D($thiz, bits) {
  var s = (bits < 0);
  var e = (255 & (bits >> 23));
  var f = (8388607 & bits);
  var f$1 = f;
  if ((e === 255)) {
    var absResult = ((f$1 === 0.0) ? Infinity : (NaN))
  } else if ((e > 0)) {
    var b = (((-127) + e) | 0);
    var absResult = ($uD(Math.pow(2.0, b)) * (1.0 + (f$1 / 8388608.0)))
  } else {
    var absResult = (1.401298464324817E-45 * f$1)
  };
  return (s ? (-absResult) : absResult)
}
function $p_jl_FloatingPointBits$__floatToIntBitsPolyfill__D__I($thiz, value) {
  if ((value !== value)) {
    var sef__s = false;
    var sef__e = 255;
    var sef__f = 4194304.0
  } else if (((value === Infinity) || (value === (-Infinity)))) {
    var s = (value < 0.0);
    var sef__s = s;
    var sef__e = 255;
    var sef__f = 0.0
  } else if ((value === 0.0)) {
    var s$1 = ((1.0 / value) === (-Infinity));
    var sef__s = s$1;
    var sef__e = 0;
    var sef__f = 0.0
  } else {
    var s$2 = (value < 0.0);
    var av = (s$2 ? (-value) : value);
    if ((av >= 1.1754943508222875E-38)) {
      var x = $uD(Math.floor(($uD(Math.log(av)) / 0.6931471805599453)));
      var e = $uI((x | 0));
      if ((e > 1023)) {
        e = 1023
      };
      var significand = (av / $uD(Math.pow(2.0, e)));
      if ((significand < 1.0)) {
        e = (((-1) + e) | 0);
        significand = (2.0 * significand)
      } else if ((significand >= 2.0)) {
        e = ((1 + e) | 0);
        significand = (significand / 2.0)
      };
      var n = (8388608.0 * (significand - 1.0));
      var f = ((4.9E-324 * n) / 4.9E-324);
      if ((f === 8388608.0)) {
        e = ((1 + e) | 0);
        f = 0.0
      };
      e = ((127 + e) | 0);
      if ((e > 254)) {
        e = 255;
        f = 0.0
      };
      var e$1 = e;
      var f$1 = f;
      var sef__s = s$2;
      var sef__e = e$1;
      var sef__f = f$1
    } else {
      var n$1 = (av / 1.401298464324817E-45);
      var f$2 = ((4.9E-324 * n$1) / 4.9E-324);
      var sef__s = s$2;
      var sef__e = 0;
      var sef__f = f$2
    }
  };
  var x$1 = sef__f;
  return (((sef__s ? (-2147483648) : 0) | (sef__e << 23)) | $uI((x$1 | 0)))
}
function $p_jl_FloatingPointBits$__longBitsToDoublePolyfill__J__D($thiz, bits) {
  var hi = bits.RTLong__f_hi;
  var x = bits.RTLong__f_lo;
  var lo = $uD((x >>> 0));
  var s = (hi < 0);
  var e = (2047 & (hi >> 20));
  var f = ((4.294967296E9 * (1048575 & hi)) + lo);
  if ((e === 2047)) {
    var absResult = ((f === 0.0) ? Infinity : (NaN))
  } else if ((e > 0)) {
    var b = (((-1023) + e) | 0);
    var absResult = ($uD(Math.pow(2.0, b)) * (1.0 + (f / 4.503599627370496E15)))
  } else {
    var absResult = (4.9E-324 * f)
  };
  return (s ? (-absResult) : absResult)
}
function $p_jl_FloatingPointBits$__doubleToLongBitsPolyfill__D__J($thiz, value) {
  if ((value !== value)) {
    var sef__s = false;
    var sef__e = 2047;
    var sef__f = 2.251799813685248E15
  } else if (((value === Infinity) || (value === (-Infinity)))) {
    var s = (value < 0.0);
    var sef__s = s;
    var sef__e = 2047;
    var sef__f = 0.0
  } else if ((value === 0.0)) {
    var s$1 = ((1.0 / value) === (-Infinity));
    var sef__s = s$1;
    var sef__e = 0;
    var sef__f = 0.0
  } else {
    var s$2 = (value < 0.0);
    var av = (s$2 ? (-value) : value);
    if ((av >= 2.2250738585072014E-308)) {
      var x = $uD(Math.floor(($uD(Math.log(av)) / 0.6931471805599453)));
      var e = $uI((x | 0));
      if ((e > 1023)) {
        e = 1023
      };
      var significand = (av / $uD(Math.pow(2.0, e)));
      if ((significand < 1.0)) {
        e = (((-1) + e) | 0);
        significand = (2.0 * significand)
      } else if ((significand >= 2.0)) {
        e = ((1 + e) | 0);
        significand = (significand / 2.0)
      };
      var n = (4.503599627370496E15 * (significand - 1.0));
      var f = ((4.9E-324 * n) / 4.9E-324);
      if ((f === 4.503599627370496E15)) {
        e = ((1 + e) | 0);
        f = 0.0
      };
      e = ((1023 + e) | 0);
      if ((e > 2046)) {
        e = 2047;
        f = 0.0
      };
      var e$1 = e;
      var f$1 = f;
      var sef__s = s$2;
      var sef__e = e$1;
      var sef__f = f$1
    } else {
      var n$1 = (av / 4.9E-324);
      var f$2 = ((4.9E-324 * n$1) / 4.9E-324);
      var sef__s = s$2;
      var sef__e = 0;
      var sef__f = f$2
    }
  };
  var x$1 = (sef__f / 4.294967296E9);
  var hif = $uI((x$1 | 0));
  var hi = (((sef__s ? (-2147483648) : 0) | (sef__e << 20)) | hif);
  var x$2 = sef__f;
  var lo = $uI((x$2 | 0));
  return new $c_RTLong(lo, hi)
}
/** @constructor */
function $c_jl_FloatingPointBits$() {
  this.jl_FloatingPointBits$__f_java$lang$FloatingPointBits$$_areTypedArraysSupported = false;
  this.jl_FloatingPointBits$__f_arrayBuffer = null;
  this.jl_FloatingPointBits$__f_int32Array = null;
  this.jl_FloatingPointBits$__f_float32Array = null;
  this.jl_FloatingPointBits$__f_float64Array = null;
  this.jl_FloatingPointBits$__f_areTypedArraysBigEndian = false;
  this.jl_FloatingPointBits$__f_highOffset = 0;
  this.jl_FloatingPointBits$__f_lowOffset = 0;
  $n_jl_FloatingPointBits$ = this;
  this.jl_FloatingPointBits$__f_java$lang$FloatingPointBits$$_areTypedArraysSupported = (((($as_T((typeof ArrayBuffer)) !== "undefined") && ($as_T((typeof Int32Array)) !== "undefined")) && ($as_T((typeof Float32Array)) !== "undefined")) && ($as_T((typeof Float64Array)) !== "undefined"));
  this.jl_FloatingPointBits$__f_arrayBuffer = (this.jl_FloatingPointBits$__f_java$lang$FloatingPointBits$$_areTypedArraysSupported ? new ArrayBuffer(8) : null);
  this.jl_FloatingPointBits$__f_int32Array = (this.jl_FloatingPointBits$__f_java$lang$FloatingPointBits$$_areTypedArraysSupported ? new Int32Array(this.jl_FloatingPointBits$__f_arrayBuffer, 0, 2) : null);
  this.jl_FloatingPointBits$__f_float32Array = (this.jl_FloatingPointBits$__f_java$lang$FloatingPointBits$$_areTypedArraysSupported ? new Float32Array(this.jl_FloatingPointBits$__f_arrayBuffer, 0, 2) : null);
  this.jl_FloatingPointBits$__f_float64Array = (this.jl_FloatingPointBits$__f_java$lang$FloatingPointBits$$_areTypedArraysSupported ? new Float64Array(this.jl_FloatingPointBits$__f_arrayBuffer, 0, 1) : null);
  if ((!this.jl_FloatingPointBits$__f_java$lang$FloatingPointBits$$_areTypedArraysSupported)) {
    var $$x1 = true
  } else {
    this.jl_FloatingPointBits$__f_int32Array[0] = 16909060;
    var $$x1 = ($uB(new Int8Array(this.jl_FloatingPointBits$__f_arrayBuffer, 0, 8)[0]) === 1)
  };
  this.jl_FloatingPointBits$__f_areTypedArraysBigEndian = $$x1;
  this.jl_FloatingPointBits$__f_highOffset = (this.jl_FloatingPointBits$__f_areTypedArraysBigEndian ? 0 : 1);
  this.jl_FloatingPointBits$__f_lowOffset = (this.jl_FloatingPointBits$__f_areTypedArraysBigEndian ? 1 : 0)
}
$c_jl_FloatingPointBits$.prototype = new $h_O();
$c_jl_FloatingPointBits$.prototype.constructor = $c_jl_FloatingPointBits$;
/** @constructor */
function $h_jl_FloatingPointBits$() {
  /*<skip>*/
}
$h_jl_FloatingPointBits$.prototype = $c_jl_FloatingPointBits$.prototype;
$c_jl_FloatingPointBits$.prototype.numberHashCode__D__I = (function(value) {
  var iv = $uI((value | 0));
  if (((iv === value) && ((1.0 / value) !== (-Infinity)))) {
    return iv
  } else if (this.jl_FloatingPointBits$__f_java$lang$FloatingPointBits$$_areTypedArraysSupported) {
    this.jl_FloatingPointBits$__f_float64Array[0] = value;
    return ($uI(this.jl_FloatingPointBits$__f_int32Array[0]) ^ $uI(this.jl_FloatingPointBits$__f_int32Array[1]))
  } else {
    return $p_jl_FloatingPointBits$__doubleHashCodePolyfill__D__I(this, value)
  }
});
$c_jl_FloatingPointBits$.prototype.intBitsToFloat__I__F = (function(bits) {
  if (this.jl_FloatingPointBits$__f_java$lang$FloatingPointBits$$_areTypedArraysSupported) {
    this.jl_FloatingPointBits$__f_int32Array[0] = bits;
    return $uF(this.jl_FloatingPointBits$__f_float32Array[0])
  } else {
    return $fround($p_jl_FloatingPointBits$__intBitsToFloatPolyfill__I__D(this, bits))
  }
});
$c_jl_FloatingPointBits$.prototype.floatToIntBits__F__I = (function(value) {
  if (this.jl_FloatingPointBits$__f_java$lang$FloatingPointBits$$_areTypedArraysSupported) {
    this.jl_FloatingPointBits$__f_float32Array[0] = value;
    return $uI(this.jl_FloatingPointBits$__f_int32Array[0])
  } else {
    return $p_jl_FloatingPointBits$__floatToIntBitsPolyfill__D__I(this, value)
  }
});
$c_jl_FloatingPointBits$.prototype.longBitsToDouble__J__D = (function(bits) {
  if (this.jl_FloatingPointBits$__f_java$lang$FloatingPointBits$$_areTypedArraysSupported) {
    var $$x2 = this.jl_FloatingPointBits$__f_int32Array;
    var $$x1 = this.jl_FloatingPointBits$__f_highOffset;
    var hi = bits.RTLong__f_hi;
    $$x2[$$x1] = hi;
    this.jl_FloatingPointBits$__f_int32Array[this.jl_FloatingPointBits$__f_lowOffset] = bits.RTLong__f_lo;
    return $uD(this.jl_FloatingPointBits$__f_float64Array[0])
  } else {
    return $p_jl_FloatingPointBits$__longBitsToDoublePolyfill__J__D(this, bits)
  }
});
$c_jl_FloatingPointBits$.prototype.doubleToLongBits__D__J = (function(value) {
  if (this.jl_FloatingPointBits$__f_java$lang$FloatingPointBits$$_areTypedArraysSupported) {
    this.jl_FloatingPointBits$__f_float64Array[0] = value;
    var value$1 = $uI(this.jl_FloatingPointBits$__f_int32Array[this.jl_FloatingPointBits$__f_highOffset]);
    var value$2 = $uI(this.jl_FloatingPointBits$__f_int32Array[this.jl_FloatingPointBits$__f_lowOffset]);
    return new $c_RTLong(value$2, value$1)
  } else {
    return $p_jl_FloatingPointBits$__doubleToLongBitsPolyfill__D__J(this, value)
  }
});
var $d_jl_FloatingPointBits$ = new $TypeData().initClass({
  jl_FloatingPointBits$: 0
}, false, "java.lang.FloatingPointBits$", {
  jl_FloatingPointBits$: 1,
  O: 1
});
$c_jl_FloatingPointBits$.prototype.$classData = $d_jl_FloatingPointBits$;
var $n_jl_FloatingPointBits$;
function $m_jl_FloatingPointBits$() {
  if ((!$n_jl_FloatingPointBits$)) {
    $n_jl_FloatingPointBits$ = new $c_jl_FloatingPointBits$()
  };
  return $n_jl_FloatingPointBits$
}
/** @constructor */
function $c_jl_Long$StringRadixInfo(chunkLength, radixPowLength, paddingZeros, overflowBarrier) {
  this.jl_Long$StringRadixInfo__f_chunkLength = 0;
  this.jl_Long$StringRadixInfo__f_radixPowLength = $L0;
  this.jl_Long$StringRadixInfo__f_paddingZeros = null;
  this.jl_Long$StringRadixInfo__f_overflowBarrier = $L0;
  this.jl_Long$StringRadixInfo__f_chunkLength = chunkLength;
  this.jl_Long$StringRadixInfo__f_radixPowLength = radixPowLength;
  this.jl_Long$StringRadixInfo__f_paddingZeros = paddingZeros;
  this.jl_Long$StringRadixInfo__f_overflowBarrier = overflowBarrier
}
$c_jl_Long$StringRadixInfo.prototype = new $h_O();
$c_jl_Long$StringRadixInfo.prototype.constructor = $c_jl_Long$StringRadixInfo;
/** @constructor */
function $h_jl_Long$StringRadixInfo() {
  /*<skip>*/
}
$h_jl_Long$StringRadixInfo.prototype = $c_jl_Long$StringRadixInfo.prototype;
function $as_jl_Long$StringRadixInfo(obj) {
  return (((obj instanceof $c_jl_Long$StringRadixInfo) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Long$StringRadixInfo"))
}
function $isArrayOf_jl_Long$StringRadixInfo(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Long$StringRadixInfo)))
}
function $asArrayOf_jl_Long$StringRadixInfo(obj, depth) {
  return (($isArrayOf_jl_Long$StringRadixInfo(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Long$StringRadixInfo;", depth))
}
var $d_jl_Long$StringRadixInfo = new $TypeData().initClass({
  jl_Long$StringRadixInfo: 0
}, false, "java.lang.Long$StringRadixInfo", {
  jl_Long$StringRadixInfo: 1,
  O: 1
});
$c_jl_Long$StringRadixInfo.prototype.$classData = $d_jl_Long$StringRadixInfo;
/** @constructor */
function $c_jl_Math$() {
  /*<skip>*/
}
$c_jl_Math$.prototype = new $h_O();
$c_jl_Math$.prototype.constructor = $c_jl_Math$;
/** @constructor */
function $h_jl_Math$() {
  /*<skip>*/
}
$h_jl_Math$.prototype = $c_jl_Math$.prototype;
$c_jl_Math$.prototype.nextUp__F__F = (function(a) {
  if (((a !== a) || (a === Infinity))) {
    return a
  } else if ((a === (-0))) {
    return 1.401298464324817E-45
  } else {
    var abits = $m_jl_FloatingPointBits$().floatToIntBits__F__I(a);
    var rbits = ((a > 0.0) ? ((1 + abits) | 0) : (((-1) + abits) | 0));
    return $m_jl_FloatingPointBits$().intBitsToFloat__I__F(rbits)
  }
});
$c_jl_Math$.prototype.nextDown__F__F = (function(a) {
  if (((a !== a) || (a === (-Infinity)))) {
    return a
  } else if ((a === 0.0)) {
    return (-1.401298464324817E-45)
  } else {
    var abits = $m_jl_FloatingPointBits$().floatToIntBits__F__I(a);
    var rbits = ((a > 0.0) ? (((-1) + abits) | 0) : ((1 + abits) | 0));
    return $m_jl_FloatingPointBits$().intBitsToFloat__I__F(rbits)
  }
});
var $d_jl_Math$ = new $TypeData().initClass({
  jl_Math$: 0
}, false, "java.lang.Math$", {
  jl_Math$: 1,
  O: 1
});
$c_jl_Math$.prototype.$classData = $d_jl_Math$;
var $n_jl_Math$;
function $m_jl_Math$() {
  if ((!$n_jl_Math$)) {
    $n_jl_Math$ = new $c_jl_Math$()
  };
  return $n_jl_Math$
}
var $d_jl_Runnable = new $TypeData().initClass({
  jl_Runnable: 0
}, true, "java.lang.Runnable", {
  jl_Runnable: 1,
  O: 1
});
function $p_jl_StackTrace$__extract__O__Ajl_StackTraceElement($thiz, stackdata) {
  var lines = $p_jl_StackTrace$__normalizeStackTraceLines__O__O($thiz, stackdata);
  return $p_jl_StackTrace$__normalizedLinesToStackTrace__O__Ajl_StackTraceElement($thiz, lines)
}
function $p_jl_StackTrace$__normalizedLinesToStackTrace__O__Ajl_StackTraceElement($thiz, lines) {
  var NormalizedFrameLine = $m_jl_StackTrace$StringRE$().re$extension__T__O("^([^\\@]*)\\@(.*):([0-9]+)$");
  var NormalizedFrameLineWithColumn = $m_jl_StackTrace$StringRE$().re$extension__T__O("^([^\\@]*)\\@(.*):([0-9]+):([0-9]+)$");
  var trace = [];
  var i = 0;
  while ((i < $uI(lines.length))) {
    var line = $as_T(lines[i]);
    if ((line !== "")) {
      var mtch1 = NormalizedFrameLineWithColumn.exec(line);
      if ((mtch1 !== null)) {
        var x = mtch1[1];
        var classAndMethodName = $p_jl_StackTrace$__extractClassMethod__T__O($thiz, $as_T(x));
        var $$x3 = $as_T(classAndMethodName[0]);
        var $$x2 = $as_T(classAndMethodName[1]);
        var x$1 = mtch1[2];
        var $$x1 = $as_T(x$1);
        var x$2 = mtch1[3];
        var s = $as_T(x$2);
        var elem = new $c_jl_StackTraceElement($$x3, $$x2, $$x1, $uI(parseInt(s)));
        var x$3 = mtch1[4];
        var s$1 = $as_T(x$3);
        elem.jl_StackTraceElement__f_columnNumber = $uI(parseInt(s$1));
        $uI(trace.push(elem))
      } else {
        var mtch2 = NormalizedFrameLine.exec(line);
        if ((mtch2 !== null)) {
          var x$4 = mtch2[1];
          var classAndMethodName$2 = $p_jl_StackTrace$__extractClassMethod__T__O($thiz, $as_T(x$4));
          var $$x7 = $as_T(classAndMethodName$2[0]);
          var $$x6 = $as_T(classAndMethodName$2[1]);
          var x$5 = mtch2[2];
          var $$x5 = $as_T(x$5);
          var x$6 = mtch2[3];
          var s$2 = $as_T(x$6);
          var $$x4 = trace.push(new $c_jl_StackTraceElement($$x7, $$x6, $$x5, $uI(parseInt(s$2))));
          $uI($$x4)
        } else {
          $uI(trace.push(new $c_jl_StackTraceElement("<jscode>", line, null, (-1))))
        }
      }
    };
    i = ((1 + i) | 0)
  };
  var len = $uI(trace.length);
  var result = new ($d_jl_StackTraceElement.getArrayOf().constr)(len);
  i = 0;
  while ((i < len)) {
    result.set(i, $as_jl_StackTraceElement(trace[i]));
    i = ((1 + i) | 0)
  };
  return result
}
function $p_jl_StackTrace$__extractClassMethod__T__O($thiz, functionName) {
  var PatBC = $m_jl_StackTrace$StringRE$().re$extension__T__O("^(?:Object\\.|\\[object Object\\]\\.|Module\\.)?\\$[bc]_([^\\.]+)(?:\\.prototype)?\\.([^\\.]+)$");
  var PatS = $m_jl_StackTrace$StringRE$().re$extension__T__O("^(?:Object\\.|\\[object Object\\]\\.|Module\\.)?\\$(?:ps?|s|f)_((?:_[^_]|[^_])+)__([^\\.]+)$");
  var PatCT = $m_jl_StackTrace$StringRE$().re$extension__T__O("^(?:Object\\.|\\[object Object\\]\\.|Module\\.)?\\$ct_((?:_[^_]|[^_])+)__([^\\.]*)$");
  var PatN = $m_jl_StackTrace$StringRE$().re$extension__T__O("^new (?:Object\\.|\\[object Object\\]\\.|Module\\.)?\\$c_([^\\.]+)$");
  var PatM = $m_jl_StackTrace$StringRE$().re$extension__T__O("^(?:Object\\.|\\[object Object\\]\\.|Module\\.)?\\$m_([^\\.]+)$");
  var matchBC = PatBC.exec(functionName);
  var matchBCOrS = ((matchBC !== null) ? matchBC : PatS.exec(functionName));
  if ((matchBCOrS !== null)) {
    var x = matchBCOrS[1];
    var $$x1 = $p_jl_StackTrace$__decodeClassName__T__T($thiz, $as_T(x));
    var x$1 = matchBCOrS[2];
    return [$$x1, $p_jl_StackTrace$__decodeMethodName__T__T($thiz, $as_T(x$1))]
  } else {
    var matchCT = PatCT.exec(functionName);
    var matchCTOrN = ((matchCT !== null) ? matchCT : PatN.exec(functionName));
    if ((matchCTOrN !== null)) {
      var x$2 = matchCTOrN[1];
      return [$p_jl_StackTrace$__decodeClassName__T__T($thiz, $as_T(x$2)), "<init>"]
    } else {
      var matchM = PatM.exec(functionName);
      if ((matchM !== null)) {
        var x$3 = matchM[1];
        return [$p_jl_StackTrace$__decodeClassName__T__T($thiz, $as_T(x$3)), "<clinit>"]
      } else {
        return ["<jscode>", functionName]
      }
    }
  }
}
function $p_jl_StackTrace$__decodeClassName__T__T($thiz, encodedName) {
  var dict = $p_jl_StackTrace$__decompressedClasses__O($thiz);
  if ($uZ($m_jl_Utils$Cache$().jl_Utils$Cache$__f_safeHasOwnProperty.call(dict, encodedName))) {
    var dict$1 = $p_jl_StackTrace$__decompressedClasses__O($thiz);
    var base = $as_T(dict$1[encodedName])
  } else {
    var base = $p_jl_StackTrace$__loop$1__I__T__T($thiz, 0, encodedName)
  };
  var this$4 = $as_T(base.split("_").join("."));
  return $as_T(this$4.split("\uff3f").join("_"))
}
function $p_jl_StackTrace$__decompressedClasses$lzycompute__O($thiz) {
  if (((((1 & $thiz.jl_StackTrace$__f_bitmap$0) << 24) >> 24) === 0)) {
    var dict = {};
    dict.O = "java_lang_Object";
    dict.T = "java_lang_String";
    var index = 0;
    while ((index <= 22)) {
      if ((index >= 2)) {
        var key = ("T" + index);
        var value = ("scala_Tuple" + index);
        dict[key] = value
      };
      var key$1 = ("F" + index);
      var value$1 = ("scala_Function" + index);
      dict[key$1] = value$1;
      index = ((1 + index) | 0)
    };
    $thiz.jl_StackTrace$__f_decompressedClasses = dict;
    $thiz.jl_StackTrace$__f_bitmap$0 = (((1 | $thiz.jl_StackTrace$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.jl_StackTrace$__f_decompressedClasses
}
function $p_jl_StackTrace$__decompressedClasses__O($thiz) {
  return (((((1 & $thiz.jl_StackTrace$__f_bitmap$0) << 24) >> 24) === 0) ? $p_jl_StackTrace$__decompressedClasses$lzycompute__O($thiz) : $thiz.jl_StackTrace$__f_decompressedClasses)
}
function $p_jl_StackTrace$__decompressedPrefixes$lzycompute__O($thiz) {
  if (((((2 & $thiz.jl_StackTrace$__f_bitmap$0) << 24) >> 24) === 0)) {
    var dict = {};
    dict.sjsr_ = "scala_scalajs_runtime_";
    dict.sjs_ = "scala_scalajs_";
    dict.sci_ = "scala_collection_immutable_";
    dict.scm_ = "scala_collection_mutable_";
    dict.scg_ = "scala_collection_generic_";
    dict.sc_ = "scala_collection_";
    dict.sr_ = "scala_runtime_";
    dict.s_ = "scala_";
    dict.jl_ = "java_lang_";
    dict.ju_ = "java_util_";
    $thiz.jl_StackTrace$__f_decompressedPrefixes = dict;
    $thiz.jl_StackTrace$__f_bitmap$0 = (((2 | $thiz.jl_StackTrace$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.jl_StackTrace$__f_decompressedPrefixes
}
function $p_jl_StackTrace$__decompressedPrefixes__O($thiz) {
  return (((((2 & $thiz.jl_StackTrace$__f_bitmap$0) << 24) >> 24) === 0) ? $p_jl_StackTrace$__decompressedPrefixes$lzycompute__O($thiz) : $thiz.jl_StackTrace$__f_decompressedPrefixes)
}
function $p_jl_StackTrace$__compressedPrefixes$lzycompute__O($thiz) {
  if (((((4 & $thiz.jl_StackTrace$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.jl_StackTrace$__f_compressedPrefixes = Object.keys($p_jl_StackTrace$__decompressedPrefixes__O($thiz));
    $thiz.jl_StackTrace$__f_bitmap$0 = (((4 | $thiz.jl_StackTrace$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.jl_StackTrace$__f_compressedPrefixes
}
function $p_jl_StackTrace$__compressedPrefixes__O($thiz) {
  return (((((4 & $thiz.jl_StackTrace$__f_bitmap$0) << 24) >> 24) === 0) ? $p_jl_StackTrace$__compressedPrefixes$lzycompute__O($thiz) : $thiz.jl_StackTrace$__f_compressedPrefixes)
}
function $p_jl_StackTrace$__decodeMethodName__T__T($thiz, encodedName) {
  if ((($uI(encodedName.length) >= 0) && ($as_T(encodedName.substring(0, $uI("init___".length))) === "init___"))) {
    return "<init>"
  } else {
    var methodNameLen = $uI(encodedName.indexOf("__"));
    return ((methodNameLen < 0) ? encodedName : $as_T(encodedName.substring(0, methodNameLen)))
  }
}
function $p_jl_StackTrace$__normalizeStackTraceLines__O__O($thiz, e) {
  var x = (!e);
  if ($uZ((!(!x)))) {
    return []
  } else {
    var x$1 = (e.arguments && e.stack);
    if ($uZ((!(!x$1)))) {
      return $p_jl_StackTrace$__extractChrome__O__O($thiz, e)
    } else {
      var x$2 = (e.stack && e.sourceURL);
      if ($uZ((!(!x$2)))) {
        return $p_jl_StackTrace$__extractSafari__O__O($thiz, e)
      } else {
        var x$3 = (e.stack && e.number);
        if ($uZ((!(!x$3)))) {
          return $p_jl_StackTrace$__extractIE__O__O($thiz, e)
        } else {
          var x$4 = (e.stack && e.fileName);
          if ($uZ((!(!x$4)))) {
            return $p_jl_StackTrace$__extractFirefox__O__O($thiz, e)
          } else {
            var x$5 = (e.message && e["opera#sourceloc"]);
            if ($uZ((!(!x$5)))) {
              var x$6 = (!e.stacktrace);
              if ($uZ((!(!x$6)))) {
                return $p_jl_StackTrace$__extractOpera9__O__O($thiz, e)
              } else {
                var x$7 = ((e.message.indexOf("\n") > (-1.0)) && (e.message.split("\n").length > e.stacktrace.split("\n").length));
                if ($uZ((!(!x$7)))) {
                  return $p_jl_StackTrace$__extractOpera9__O__O($thiz, e)
                } else {
                  return $p_jl_StackTrace$__extractOpera10a__O__O($thiz, e)
                }
              }
            } else {
              var x$8 = ((e.message && e.stack) && e.stacktrace);
              if ($uZ((!(!x$8)))) {
                var x$9 = (e.stacktrace.indexOf("called from line") < 0.0);
                if ($uZ((!(!x$9)))) {
                  return $p_jl_StackTrace$__extractOpera10b__O__O($thiz, e)
                } else {
                  return $p_jl_StackTrace$__extractOpera11__O__O($thiz, e)
                }
              } else {
                var x$10 = (e.stack && (!e.fileName));
                if ($uZ((!(!x$10)))) {
                  return $p_jl_StackTrace$__extractChrome__O__O($thiz, e)
                } else {
                  return $p_jl_StackTrace$__extractOther__O__O($thiz, e)
                }
              }
            }
          }
        }
      }
    }
  }
}
function $p_jl_StackTrace$__extractChrome__O__O($thiz, e) {
  var x = ($as_T(e.stack) + "\n");
  var $$x6 = x.replace($m_jl_StackTrace$StringRE$().re$extension__T__O("^[\\s\\S]+?\\s+at\\s+"), " at ");
  var x$1 = $as_T($$x6);
  var $$x5 = x$1.replace($m_jl_StackTrace$StringRE$().re$extension__T__T__O("^\\s+(at eval )?at\\s+", "gm"), "");
  var x$2 = $as_T($$x5);
  var $$x4 = x$2.replace($m_jl_StackTrace$StringRE$().re$extension__T__T__O("^([^\\(]+?)([\\n])", "gm"), "{anonymous}() ($1)$2");
  var x$3 = $as_T($$x4);
  var $$x3 = x$3.replace($m_jl_StackTrace$StringRE$().re$extension__T__T__O("^Object.<anonymous>\\s*\\(([^\\)]+)\\)", "gm"), "{anonymous}() ($1)");
  var x$4 = $as_T($$x3);
  var $$x2 = x$4.replace($m_jl_StackTrace$StringRE$().re$extension__T__T__O("^([^\\(]+|\\{anonymous\\}\\(\\)) \\((.+)\\)$", "gm"), "$1@$2");
  var x$5 = $as_T($$x2);
  var $$x1 = x$5.split("\n");
  return $$x1.slice(0, (-1))
}
function $p_jl_StackTrace$__extractFirefox__O__O($thiz, e) {
  var x = $as_T(e.stack);
  var $$x2 = x.replace($m_jl_StackTrace$StringRE$().re$extension__T__T__O("(?:\\n@:0)?\\s+$", "m"), "");
  var x$1 = $as_T($$x2);
  var $$x1 = x$1.replace($m_jl_StackTrace$StringRE$().re$extension__T__T__O("^(?:\\((\\S*)\\))?@", "gm"), "{anonymous}($1)@");
  var x$2 = $as_T($$x1);
  return x$2.split("\n")
}
function $p_jl_StackTrace$__extractIE__O__O($thiz, e) {
  var x = $as_T(e.stack);
  var $$x3 = x.replace($m_jl_StackTrace$StringRE$().re$extension__T__T__O("^\\s*at\\s+(.*)$", "gm"), "$1");
  var x$1 = $as_T($$x3);
  var $$x2 = x$1.replace($m_jl_StackTrace$StringRE$().re$extension__T__T__O("^Anonymous function\\s+", "gm"), "{anonymous}() ");
  var x$2 = $as_T($$x2);
  var $$x1 = x$2.replace($m_jl_StackTrace$StringRE$().re$extension__T__T__O("^([^\\(]+|\\{anonymous\\}\\(\\))\\s+\\((.+)\\)$", "gm"), "$1@$2");
  var x$3 = $as_T($$x1);
  var qual$1 = x$3.split("\n");
  return qual$1.slice(1)
}
function $p_jl_StackTrace$__extractSafari__O__O($thiz, e) {
  var x = $as_T(e.stack);
  var $$x3 = x.replace($m_jl_StackTrace$StringRE$().re$extension__T__T__O("\\[native code\\]\\n", "m"), "");
  var x$1 = $as_T($$x3);
  var $$x2 = x$1.replace($m_jl_StackTrace$StringRE$().re$extension__T__T__O("^(?=\\w+Error\\:).*$\\n", "m"), "");
  var x$2 = $as_T($$x2);
  var $$x1 = x$2.replace($m_jl_StackTrace$StringRE$().re$extension__T__T__O("^@", "gm"), "{anonymous}()@");
  var x$3 = $as_T($$x1);
  return x$3.split("\n")
}
function $p_jl_StackTrace$__extractOpera9__O__O($thiz, e) {
  var lineRE = $m_jl_StackTrace$StringRE$().re$extension__T__T__O("Line (\\d+).*script (?:in )?(\\S+)", "i");
  var x = $as_T(e.message);
  var lines = x.split("\n");
  var result = [];
  var i = 2;
  var len = $uI(lines.length);
  while ((i < len)) {
    var mtch = lineRE.exec($as_T(lines[i]));
    if ((mtch !== null)) {
      var x$1 = mtch[2];
      var x$2 = mtch[1];
      var $$x1 = result.push(((("{anonymous}()@" + x$1) + ":") + x$2));
      $uI($$x1)
    };
    i = ((2 + i) | 0)
  };
  return result
}
function $p_jl_StackTrace$__extractOpera10a__O__O($thiz, e) {
  var lineRE = $m_jl_StackTrace$StringRE$().re$extension__T__T__O("Line (\\d+).*script (?:in )?(\\S+)(?:: In function (\\S+))?$", "i");
  var x = $as_T(e.stacktrace);
  var lines = x.split("\n");
  var result = [];
  var i = 0;
  var len = $uI(lines.length);
  while ((i < len)) {
    var mtch = lineRE.exec($as_T(lines[i]));
    if ((mtch !== null)) {
      var x$1 = mtch[3];
      var fnName = $as_T(((x$1 !== (void 0)) ? x$1 : "{anonymous}"));
      var x$2 = mtch[2];
      var x$3 = mtch[1];
      var $$x1 = result.push(((((fnName + "()@") + x$2) + ":") + x$3));
      $uI($$x1)
    };
    i = ((2 + i) | 0)
  };
  return result
}
function $p_jl_StackTrace$__extractOpera10b__O__O($thiz, e) {
  var lineRE = $m_jl_StackTrace$StringRE$().re$extension__T__O("^(.*)@(.+):(\\d+)$");
  var x = $as_T(e.stacktrace);
  var lines = x.split("\n");
  var result = [];
  var i = 0;
  var len = $uI(lines.length);
  while ((i < len)) {
    var mtch = lineRE.exec($as_T(lines[i]));
    if ((mtch !== null)) {
      var x$1 = mtch[1];
      if ((x$1 !== (void 0))) {
        var arg1 = $as_T(x$1);
        var $$x1 = $m_jl_StackTrace$().java$lang$StackTrace$$$anonfun$extractOpera10b$1__T__T(arg1)
      } else {
        var $$x1 = "global code"
      };
      var fnName = $as_T($$x1);
      var x$2 = mtch[2];
      var x$3 = mtch[3];
      var $$x2 = result.push(((((fnName + "@") + x$2) + ":") + x$3));
      $uI($$x2)
    };
    i = ((1 + i) | 0)
  };
  return result
}
function $p_jl_StackTrace$__extractOpera11__O__O($thiz, e) {
  var lineRE = $m_jl_StackTrace$StringRE$().re$extension__T__O("^.*line (\\d+), column (\\d+)(?: in (.+))? in (\\S+):$");
  var x = $as_T(e.stacktrace);
  var lines = x.split("\n");
  var result = [];
  var i = 0;
  var len = $uI(lines.length);
  while ((i < len)) {
    var mtch = lineRE.exec($as_T(lines[i]));
    if ((mtch !== null)) {
      var x$1 = mtch[4];
      var $$x1 = $as_T(x$1);
      var x$2 = mtch[1];
      var x$3 = mtch[2];
      var location = (((($$x1 + ":") + x$2) + ":") + x$3);
      var x$4 = mtch[2];
      var fnName0 = $as_T(((x$4 !== (void 0)) ? x$4 : "global code"));
      var x$5 = $as_T(fnName0.replace($m_jl_StackTrace$StringRE$().re$extension__T__O("<anonymous function: (\\S+)>"), "$1"));
      var $$x2 = x$5.replace($m_jl_StackTrace$StringRE$().re$extension__T__O("<anonymous function>"), "{anonymous}");
      var fnName = $as_T($$x2);
      $uI(result.push(((fnName + "@") + location)))
    };
    i = ((2 + i) | 0)
  };
  return result
}
function $p_jl_StackTrace$__extractOther__O__O($thiz, e) {
  return []
}
function $p_jl_StackTrace$__loop$1__I__T__T($thiz, i, encodedName$1) {
  while (true) {
    if ((i < $uI($p_jl_StackTrace$__compressedPrefixes__O($thiz).length))) {
      var prefix = $as_T($p_jl_StackTrace$__compressedPrefixes__O($thiz)[i]);
      if ((($uI(encodedName$1.length) >= 0) && ($as_T(encodedName$1.substring(0, $uI(prefix.length))) === prefix))) {
        var dict = $p_jl_StackTrace$__decompressedPrefixes__O($thiz);
        var $$x1 = $as_T(dict[prefix]);
        var beginIndex = $uI(prefix.length);
        return (("" + $$x1) + $as_T(encodedName$1.substring(beginIndex)))
      } else {
        i = ((1 + i) | 0)
      }
    } else {
      return ((($uI(encodedName$1.length) >= 0) && ($as_T(encodedName$1.substring(0, $uI("L".length))) === "L")) ? $as_T(encodedName$1.substring(1)) : encodedName$1)
    }
  }
}
/** @constructor */
function $c_jl_StackTrace$() {
  this.jl_StackTrace$__f_decompressedClasses = null;
  this.jl_StackTrace$__f_decompressedPrefixes = null;
  this.jl_StackTrace$__f_compressedPrefixes = null;
  this.jl_StackTrace$__f_bitmap$0 = 0
}
$c_jl_StackTrace$.prototype = new $h_O();
$c_jl_StackTrace$.prototype.constructor = $c_jl_StackTrace$;
/** @constructor */
function $h_jl_StackTrace$() {
  /*<skip>*/
}
$h_jl_StackTrace$.prototype = $c_jl_StackTrace$.prototype;
$c_jl_StackTrace$.prototype.java$lang$StackTrace$$$anonfun$extractOpera10b$1__T__T = (function(x$1) {
  return (x$1 + "()")
});
var $d_jl_StackTrace$ = new $TypeData().initClass({
  jl_StackTrace$: 0
}, false, "java.lang.StackTrace$", {
  jl_StackTrace$: 1,
  O: 1
});
$c_jl_StackTrace$.prototype.$classData = $d_jl_StackTrace$;
var $n_jl_StackTrace$;
function $m_jl_StackTrace$() {
  if ((!$n_jl_StackTrace$)) {
    $n_jl_StackTrace$ = new $c_jl_StackTrace$()
  };
  return $n_jl_StackTrace$
}
/** @constructor */
function $c_jl_StackTrace$StringRE$() {
  /*<skip>*/
}
$c_jl_StackTrace$StringRE$.prototype = new $h_O();
$c_jl_StackTrace$StringRE$.prototype.constructor = $c_jl_StackTrace$StringRE$;
/** @constructor */
function $h_jl_StackTrace$StringRE$() {
  /*<skip>*/
}
$h_jl_StackTrace$StringRE$.prototype = $c_jl_StackTrace$StringRE$.prototype;
$c_jl_StackTrace$StringRE$.prototype.re$extension__T__O = (function(this$) {
  return new RegExp(this$)
});
$c_jl_StackTrace$StringRE$.prototype.re$extension__T__T__O = (function(this$, mods) {
  return new RegExp(this$, mods)
});
var $d_jl_StackTrace$StringRE$ = new $TypeData().initClass({
  jl_StackTrace$StringRE$: 0
}, false, "java.lang.StackTrace$StringRE$", {
  jl_StackTrace$StringRE$: 1,
  O: 1
});
$c_jl_StackTrace$StringRE$.prototype.$classData = $d_jl_StackTrace$StringRE$;
var $n_jl_StackTrace$StringRE$;
function $m_jl_StackTrace$StringRE$() {
  if ((!$n_jl_StackTrace$StringRE$)) {
    $n_jl_StackTrace$StringRE$ = new $c_jl_StackTrace$StringRE$()
  };
  return $n_jl_StackTrace$StringRE$
}
/** @constructor */
function $c_jl_System$Streams$() {
  this.jl_System$Streams$__f_out = null;
  this.jl_System$Streams$__f_err = null;
  this.jl_System$Streams$__f_in = null;
  $n_jl_System$Streams$ = this;
  this.jl_System$Streams$__f_out = new $c_jl_JSConsoleBasedPrintStream(false);
  this.jl_System$Streams$__f_err = new $c_jl_JSConsoleBasedPrintStream(true);
  this.jl_System$Streams$__f_in = null
}
$c_jl_System$Streams$.prototype = new $h_O();
$c_jl_System$Streams$.prototype.constructor = $c_jl_System$Streams$;
/** @constructor */
function $h_jl_System$Streams$() {
  /*<skip>*/
}
$h_jl_System$Streams$.prototype = $c_jl_System$Streams$.prototype;
var $d_jl_System$Streams$ = new $TypeData().initClass({
  jl_System$Streams$: 0
}, false, "java.lang.System$Streams$", {
  jl_System$Streams$: 1,
  O: 1
});
$c_jl_System$Streams$.prototype.$classData = $d_jl_System$Streams$;
var $n_jl_System$Streams$;
function $m_jl_System$Streams$() {
  if ((!$n_jl_System$Streams$)) {
    $n_jl_System$Streams$ = new $c_jl_System$Streams$()
  };
  return $n_jl_System$Streams$
}
function $p_jl_System$SystemProperties$__loadSystemProperties__O($thiz) {
  var result = {};
  result["java.version"] = "1.8";
  result["java.vm.specification.version"] = "1.8";
  result["java.vm.specification.vendor"] = "Oracle Corporation";
  result["java.vm.specification.name"] = "Java Virtual Machine Specification";
  result["java.vm.name"] = "Scala.js";
  var value = $as_T($linkingInfo.linkerVersion);
  result["java.vm.version"] = value;
  result["java.specification.version"] = "1.8";
  result["java.specification.vendor"] = "Oracle Corporation";
  result["java.specification.name"] = "Java Platform API Specification";
  result["file.separator"] = "/";
  result["path.separator"] = ":";
  result["line.separator"] = "\n";
  return result
}
/** @constructor */
function $c_jl_System$SystemProperties$() {
  this.jl_System$SystemProperties$__f_dict = null;
  this.jl_System$SystemProperties$__f_properties = null;
  $n_jl_System$SystemProperties$ = this;
  this.jl_System$SystemProperties$__f_dict = $p_jl_System$SystemProperties$__loadSystemProperties__O(this);
  this.jl_System$SystemProperties$__f_properties = null
}
$c_jl_System$SystemProperties$.prototype = new $h_O();
$c_jl_System$SystemProperties$.prototype.constructor = $c_jl_System$SystemProperties$;
/** @constructor */
function $h_jl_System$SystemProperties$() {
  /*<skip>*/
}
$h_jl_System$SystemProperties$.prototype = $c_jl_System$SystemProperties$.prototype;
$c_jl_System$SystemProperties$.prototype.getProperty__T__T__T = (function(key, default$1) {
  return ((this.jl_System$SystemProperties$__f_dict !== null) ? $as_T($m_jl_Utils$().dictGetOrElse__O__T__O__O(this.jl_System$SystemProperties$__f_dict, key, default$1)) : this.jl_System$SystemProperties$__f_properties.getProperty__T__T__T(key, default$1))
});
var $d_jl_System$SystemProperties$ = new $TypeData().initClass({
  jl_System$SystemProperties$: 0
}, false, "java.lang.System$SystemProperties$", {
  jl_System$SystemProperties$: 1,
  O: 1
});
$c_jl_System$SystemProperties$.prototype.$classData = $d_jl_System$SystemProperties$;
var $n_jl_System$SystemProperties$;
function $m_jl_System$SystemProperties$() {
  if ((!$n_jl_System$SystemProperties$)) {
    $n_jl_System$SystemProperties$ = new $c_jl_System$SystemProperties$()
  };
  return $n_jl_System$SystemProperties$
}
/** @constructor */
function $c_jl_Thread$() {
  this.jl_Thread$__f_SingleThread = null;
  $n_jl_Thread$ = this;
  this.jl_Thread$__f_SingleThread = new $c_jl_Thread((void 0))
}
$c_jl_Thread$.prototype = new $h_O();
$c_jl_Thread$.prototype.constructor = $c_jl_Thread$;
/** @constructor */
function $h_jl_Thread$() {
  /*<skip>*/
}
$h_jl_Thread$.prototype = $c_jl_Thread$.prototype;
var $d_jl_Thread$ = new $TypeData().initClass({
  jl_Thread$: 0
}, false, "java.lang.Thread$", {
  jl_Thread$: 1,
  O: 1
});
$c_jl_Thread$.prototype.$classData = $d_jl_Thread$;
var $n_jl_Thread$;
function $m_jl_Thread$() {
  if ((!$n_jl_Thread$)) {
    $n_jl_Thread$ = new $c_jl_Thread$()
  };
  return $n_jl_Thread$
}
/** @constructor */
function $c_jl_ThreadLocal() {
  this.jl_ThreadLocal__f_hasValue = false;
  this.jl_ThreadLocal__f_v = null;
  this.jl_ThreadLocal__f_hasValue = false
}
$c_jl_ThreadLocal.prototype = new $h_O();
$c_jl_ThreadLocal.prototype.constructor = $c_jl_ThreadLocal;
/** @constructor */
function $h_jl_ThreadLocal() {
  /*<skip>*/
}
$h_jl_ThreadLocal.prototype = $c_jl_ThreadLocal.prototype;
$c_jl_ThreadLocal.prototype.get__O = (function() {
  if ((!this.jl_ThreadLocal__f_hasValue)) {
    this.set__O__V(null)
  };
  return this.jl_ThreadLocal__f_v
});
$c_jl_ThreadLocal.prototype.set__O__V = (function(o) {
  this.jl_ThreadLocal__f_v = o;
  this.jl_ThreadLocal__f_hasValue = true
});
var $d_jl_ThreadLocal = new $TypeData().initClass({
  jl_ThreadLocal: 0
}, false, "java.lang.ThreadLocal", {
  jl_ThreadLocal: 1,
  O: 1
});
$c_jl_ThreadLocal.prototype.$classData = $d_jl_ThreadLocal;
/** @constructor */
function $c_jl_Utils$() {
  /*<skip>*/
}
$c_jl_Utils$.prototype = new $h_O();
$c_jl_Utils$.prototype.constructor = $c_jl_Utils$;
/** @constructor */
function $h_jl_Utils$() {
  /*<skip>*/
}
$h_jl_Utils$.prototype = $c_jl_Utils$.prototype;
$c_jl_Utils$.prototype.dictGetOrElse__O__T__O__O = (function(dict, key, default$1) {
  return ($uZ($m_jl_Utils$Cache$().jl_Utils$Cache$__f_safeHasOwnProperty.call(dict, key)) ? dict[key] : default$1)
});
var $d_jl_Utils$ = new $TypeData().initClass({
  jl_Utils$: 0
}, false, "java.lang.Utils$", {
  jl_Utils$: 1,
  O: 1
});
$c_jl_Utils$.prototype.$classData = $d_jl_Utils$;
var $n_jl_Utils$;
function $m_jl_Utils$() {
  if ((!$n_jl_Utils$)) {
    $n_jl_Utils$ = new $c_jl_Utils$()
  };
  return $n_jl_Utils$
}
/** @constructor */
function $c_jl_Utils$Cache$() {
  this.jl_Utils$Cache$__f_safeHasOwnProperty = null;
  $n_jl_Utils$Cache$ = this;
  this.jl_Utils$Cache$__f_safeHasOwnProperty = Object.prototype.hasOwnProperty
}
$c_jl_Utils$Cache$.prototype = new $h_O();
$c_jl_Utils$Cache$.prototype.constructor = $c_jl_Utils$Cache$;
/** @constructor */
function $h_jl_Utils$Cache$() {
  /*<skip>*/
}
$h_jl_Utils$Cache$.prototype = $c_jl_Utils$Cache$.prototype;
var $d_jl_Utils$Cache$ = new $TypeData().initClass({
  jl_Utils$Cache$: 0
}, false, "java.lang.Utils$Cache$", {
  jl_Utils$Cache$: 1,
  O: 1
});
$c_jl_Utils$Cache$.prototype.$classData = $d_jl_Utils$Cache$;
var $n_jl_Utils$Cache$;
function $m_jl_Utils$Cache$() {
  if ((!$n_jl_Utils$Cache$)) {
    $n_jl_Utils$Cache$ = new $c_jl_Utils$Cache$()
  };
  return $n_jl_Utils$Cache$
}
function $f_jl_Void__equals__O__Z($thiz, that) {
  return ($thiz === that)
}
function $f_jl_Void__hashCode__I($thiz) {
  return 0
}
function $f_jl_Void__toString__T($thiz) {
  return "undefined"
}
function $as_jl_Void(obj) {
  return (((obj === (void 0)) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Void"))
}
function $isArrayOf_jl_Void(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Void)))
}
function $asArrayOf_jl_Void(obj, depth) {
  return (($isArrayOf_jl_Void(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Void;", depth))
}
var $d_jl_Void = new $TypeData().initClass({
  jl_Void: 0
}, false, "java.lang.Void", {
  jl_Void: 1,
  O: 1
}, (void 0), (void 0), (function(x) {
  return (x === (void 0))
}));
/** @constructor */
function $c_jl_reflect_Array$() {
  /*<skip>*/
}
$c_jl_reflect_Array$.prototype = new $h_O();
$c_jl_reflect_Array$.prototype.constructor = $c_jl_reflect_Array$;
/** @constructor */
function $h_jl_reflect_Array$() {
  /*<skip>*/
}
$h_jl_reflect_Array$.prototype = $c_jl_reflect_Array$.prototype;
$c_jl_reflect_Array$.prototype.newInstance__jl_Class__I__O = (function(componentType, length) {
  return componentType.newArrayOfThisClass__O__O([length])
});
$c_jl_reflect_Array$.prototype.getLength__O__I = (function(array) {
  if ((array instanceof $ac_O)) {
    var x2 = $asArrayOf_O(array, 1);
    return x2.u.length
  } else if ((array instanceof $ac_Z)) {
    var x3 = $asArrayOf_Z(array, 1);
    return x3.u.length
  } else if ((array instanceof $ac_C)) {
    var x4 = $asArrayOf_C(array, 1);
    return x4.u.length
  } else if ((array instanceof $ac_B)) {
    var x5 = $asArrayOf_B(array, 1);
    return x5.u.length
  } else if ((array instanceof $ac_S)) {
    var x6 = $asArrayOf_S(array, 1);
    return x6.u.length
  } else if ((array instanceof $ac_I)) {
    var x7 = $asArrayOf_I(array, 1);
    return x7.u.length
  } else if ((array instanceof $ac_J)) {
    var x8 = $asArrayOf_J(array, 1);
    return x8.u.length
  } else if ((array instanceof $ac_F)) {
    var x9 = $asArrayOf_F(array, 1);
    return x9.u.length
  } else if ((array instanceof $ac_D)) {
    var x10 = $asArrayOf_D(array, 1);
    return x10.u.length
  } else {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "argument type mismatch")
  }
});
var $d_jl_reflect_Array$ = new $TypeData().initClass({
  jl_reflect_Array$: 0
}, false, "java.lang.reflect.Array$", {
  jl_reflect_Array$: 1,
  O: 1
});
$c_jl_reflect_Array$.prototype.$classData = $d_jl_reflect_Array$;
var $n_jl_reflect_Array$;
function $m_jl_reflect_Array$() {
  if ((!$n_jl_reflect_Array$)) {
    $n_jl_reflect_Array$ = new $c_jl_reflect_Array$()
  };
  return $n_jl_reflect_Array$
}
/** @constructor */
function $c_Ljava_math_BigInteger$QuotAndRem(quot, rem) {
  this.Ljava_math_BigInteger$QuotAndRem__f_quot = null;
  this.Ljava_math_BigInteger$QuotAndRem__f_rem = null;
  this.Ljava_math_BigInteger$QuotAndRem__f_quot = quot;
  this.Ljava_math_BigInteger$QuotAndRem__f_rem = rem
}
$c_Ljava_math_BigInteger$QuotAndRem.prototype = new $h_O();
$c_Ljava_math_BigInteger$QuotAndRem.prototype.constructor = $c_Ljava_math_BigInteger$QuotAndRem;
/** @constructor */
function $h_Ljava_math_BigInteger$QuotAndRem() {
  /*<skip>*/
}
$h_Ljava_math_BigInteger$QuotAndRem.prototype = $c_Ljava_math_BigInteger$QuotAndRem.prototype;
$c_Ljava_math_BigInteger$QuotAndRem.prototype.toArray__ALjava_math_BigInteger = (function() {
  return new ($d_Ljava_math_BigInteger.getArrayOf().constr)([this.Ljava_math_BigInteger$QuotAndRem__f_quot, this.Ljava_math_BigInteger$QuotAndRem__f_rem])
});
var $d_Ljava_math_BigInteger$QuotAndRem = new $TypeData().initClass({
  Ljava_math_BigInteger$QuotAndRem: 0
}, false, "java.math.BigInteger$QuotAndRem", {
  Ljava_math_BigInteger$QuotAndRem: 1,
  O: 1
});
$c_Ljava_math_BigInteger$QuotAndRem.prototype.$classData = $d_Ljava_math_BigInteger$QuotAndRem;
/** @constructor */
function $c_Ljava_math_BitLevel$() {
  /*<skip>*/
}
$c_Ljava_math_BitLevel$.prototype = new $h_O();
$c_Ljava_math_BitLevel$.prototype.constructor = $c_Ljava_math_BitLevel$;
/** @constructor */
function $h_Ljava_math_BitLevel$() {
  /*<skip>*/
}
$h_Ljava_math_BitLevel$.prototype = $c_Ljava_math_BitLevel$.prototype;
$c_Ljava_math_BitLevel$.prototype.bitLength__Ljava_math_BigInteger__I = (function(bi) {
  if ((bi.Ljava_math_BigInteger__f_sign === 0)) {
    return 0
  } else {
    var bLength = (bi.Ljava_math_BigInteger__f_numberLength << 5);
    var highDigit = bi.Ljava_math_BigInteger__f_digits.get((((-1) + bi.Ljava_math_BigInteger__f_numberLength) | 0));
    if ((bi.Ljava_math_BigInteger__f_sign < 0)) {
      var i = bi.getFirstNonzeroDigit__I();
      if ((i === (((-1) + bi.Ljava_math_BigInteger__f_numberLength) | 0))) {
        highDigit = (((-1) + highDigit) | 0)
      }
    };
    var $$x1 = bLength;
    var i$1 = highDigit;
    bLength = (($$x1 - $clz32(i$1)) | 0);
    return bLength
  }
});
$c_Ljava_math_BitLevel$.prototype.shiftLeft__Ljava_math_BigInteger__I__Ljava_math_BigInteger = (function(source, count) {
  var intCount = (count >> 5);
  var andCount = (31 & count);
  var offset = ((andCount === 0) ? 0 : 1);
  var resLength = ((((source.Ljava_math_BigInteger__f_numberLength + intCount) | 0) + offset) | 0);
  var resDigits = new $ac_I(resLength);
  this.shiftLeft__AI__AI__I__I__V(resDigits, source.Ljava_math_BigInteger__f_digits, intCount, andCount);
  var result = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), source.Ljava_math_BigInteger__f_sign, resLength, resDigits);
  result.cutOffLeadingZeroes__V();
  return result
});
$c_Ljava_math_BitLevel$.prototype.shiftLeft__AI__AI__I__I__V = (function(result, source, intCount, count) {
  if ((count === 0)) {
    var length = ((result.u.length - intCount) | 0);
    $systemArraycopy(source, 0, result, intCount, length)
  } else {
    var rightShiftCount = ((32 - count) | 0);
    result.set((((-1) + result.u.length) | 0), 0);
    var i = (((-1) + result.u.length) | 0);
    while ((i > intCount)) {
      var ev$1 = i;
      result.set(ev$1, (result.get(ev$1) | ((source.get((((-1) + ((i - intCount) | 0)) | 0)) >>> rightShiftCount) | 0)));
      result.set((((-1) + i) | 0), (source.get((((-1) + ((i - intCount) | 0)) | 0)) << count));
      i = (((-1) + i) | 0)
    }
  };
  var i$1 = 0;
  while ((i$1 < intCount)) {
    var arg1 = i$1;
    result.set(arg1, 0);
    i$1 = ((1 + i$1) | 0)
  }
});
$c_Ljava_math_BitLevel$.prototype.shiftLeftOneBit__Ljava_math_BigInteger__Ljava_math_BigInteger = (function(source) {
  var srcLen = source.Ljava_math_BigInteger__f_numberLength;
  var resLen = ((1 + srcLen) | 0);
  var resDigits = new $ac_I(resLen);
  this.shiftLeftOneBit__AI__AI__I__V(resDigits, source.Ljava_math_BigInteger__f_digits, srcLen);
  var result = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), source.Ljava_math_BigInteger__f_sign, resLen, resDigits);
  result.cutOffLeadingZeroes__V();
  return result
});
$c_Ljava_math_BitLevel$.prototype.shiftLeftOneBit__AI__AI__I__V = (function(result, source, srcLen) {
  var elem = 0;
  elem = 0;
  var i = 0;
  while ((i < srcLen)) {
    var arg1 = i;
    var iVal = source.get(arg1);
    result.set(arg1, ((iVal << 1) | elem));
    elem = ((iVal >>> 31) | 0);
    i = ((1 + i) | 0)
  };
  if ((elem !== 0)) {
    result.set(srcLen, elem)
  }
});
$c_Ljava_math_BitLevel$.prototype.shiftRight__Ljava_math_BigInteger__I__Ljava_math_BigInteger = (function(source, count) {
  var intCount = (count >> 5);
  var andCount = (31 & count);
  if ((intCount >= source.Ljava_math_BigInteger__f_numberLength)) {
    return ((source.Ljava_math_BigInteger__f_sign < 0) ? $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_MINUS_ONE : $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ZERO)
  } else {
    var resLength = ((source.Ljava_math_BigInteger__f_numberLength - intCount) | 0);
    var resDigits = new $ac_I(((1 + resLength) | 0));
    this.shiftRight__AI__I__AI__I__I__Z(resDigits, resLength, source.Ljava_math_BigInteger__f_digits, intCount, andCount);
    if ((source.Ljava_math_BigInteger__f_sign < 0)) {
      var i = 0;
      while (((i < intCount) && (source.Ljava_math_BigInteger__f_digits.get(i) === 0))) {
        i = ((1 + i) | 0)
      };
      var cmp = ((source.Ljava_math_BigInteger__f_digits.get(i) << ((32 - andCount) | 0)) !== 0);
      if (((i < intCount) || ((andCount > 0) && cmp))) {
        i = 0;
        while (((i < resLength) && (resDigits.get(i) === (-1)))) {
          resDigits.set(i, 0);
          i = ((1 + i) | 0)
        };
        if ((i === resLength)) {
          resLength = ((1 + resLength) | 0)
        };
        var ev$1 = i;
        resDigits.set(ev$1, ((1 + resDigits.get(ev$1)) | 0))
      }
    };
    var result = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), source.Ljava_math_BigInteger__f_sign, resLength, resDigits);
    result.cutOffLeadingZeroes__V();
    return result
  }
});
$c_Ljava_math_BitLevel$.prototype.shiftRight__AI__I__AI__I__I__Z = (function(result, resultLen, source, intCount, count) {
  var i = 0;
  var allZero = true;
  while ((i < intCount)) {
    allZero = (!(!(allZero & (source.get(i) === 0))));
    i = ((1 + i) | 0)
  };
  if ((count === 0)) {
    $systemArraycopy(source, intCount, result, 0, resultLen)
  } else {
    var leftShiftCount = ((32 - count) | 0);
    allZero = (!(!(allZero & ((source.get(i) << leftShiftCount) === 0))));
    i = 0;
    while ((i < (((-1) + resultLen) | 0))) {
      result.set(i, (((source.get(((i + intCount) | 0)) >>> count) | 0) | (source.get(((1 + ((i + intCount) | 0)) | 0)) << leftShiftCount)));
      i = ((1 + i) | 0)
    };
    result.set(i, ((source.get(((i + intCount) | 0)) >>> count) | 0));
    i = ((1 + i) | 0)
  };
  return allZero
});
var $d_Ljava_math_BitLevel$ = new $TypeData().initClass({
  Ljava_math_BitLevel$: 0
}, false, "java.math.BitLevel$", {
  Ljava_math_BitLevel$: 1,
  O: 1
});
$c_Ljava_math_BitLevel$.prototype.$classData = $d_Ljava_math_BitLevel$;
var $n_Ljava_math_BitLevel$;
function $m_Ljava_math_BitLevel$() {
  if ((!$n_Ljava_math_BitLevel$)) {
    $n_Ljava_math_BitLevel$ = new $c_Ljava_math_BitLevel$()
  };
  return $n_Ljava_math_BitLevel$
}
function $p_Ljava_math_Conversion$__dropLeadingZeros__T__T($thiz, s) {
  var zeroPrefixLength = 0;
  var len = $uI(s.length);
  while (true) {
    if ((zeroPrefixLength < len)) {
      var index = zeroPrefixLength;
      var $$x1 = ((65535 & $uI(s.charCodeAt(index))) === 48)
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      zeroPrefixLength = ((1 + zeroPrefixLength) | 0)
    } else {
      break
    }
  };
  var beginIndex = zeroPrefixLength;
  return $as_T(s.substring(beginIndex))
}
/** @constructor */
function $c_Ljava_math_Conversion$() {
  this.Ljava_math_Conversion$__f_DigitFitInInt = null;
  this.Ljava_math_Conversion$__f_BigRadices = null;
  $n_Ljava_math_Conversion$ = this;
  this.Ljava_math_Conversion$__f_DigitFitInInt = new $ac_I([(-1), (-1), 31, 19, 15, 13, 11, 11, 10, 9, 9, 8, 8, 8, 8, 7, 7, 7, 7, 7, 7, 7, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 5]);
  this.Ljava_math_Conversion$__f_BigRadices = new $ac_I([(-2147483648), 1162261467, 1073741824, 1220703125, 362797056, 1977326743, 1073741824, 387420489, 1000000000, 214358881, 429981696, 815730721, 1475789056, 170859375, 268435456, 410338673, 612220032, 893871739, 1280000000, 1801088541, 113379904, 148035889, 191102976, 244140625, 308915776, 387420489, 481890304, 594823321, 729000000, 887503681, 1073741824, 1291467969, 1544804416, 1838265625, 60466176])
}
$c_Ljava_math_Conversion$.prototype = new $h_O();
$c_Ljava_math_Conversion$.prototype.constructor = $c_Ljava_math_Conversion$;
/** @constructor */
function $h_Ljava_math_Conversion$() {
  /*<skip>*/
}
$h_Ljava_math_Conversion$.prototype = $c_Ljava_math_Conversion$.prototype;
$c_Ljava_math_Conversion$.prototype.bigInteger2String__Ljava_math_BigInteger__I__T = (function(bi, radix) {
  var sign = bi.Ljava_math_BigInteger__f_sign;
  var numberLength = bi.Ljava_math_BigInteger__f_numberLength;
  var digits = bi.Ljava_math_BigInteger__f_digits;
  var radixOutOfBounds = ((radix < 2) || (radix > 36));
  if ((sign === 0)) {
    return "0"
  } else if ((numberLength === 1)) {
    var highDigit = digits.get((((-1) + numberLength) | 0));
    var v__lo = highDigit;
    var v__hi = 0;
    if ((sign < 0)) {
      var this$2__lo = v__lo;
      var this$2__hi = v__hi;
      var lo = this$2__lo;
      var hi$1 = this$2__hi;
      var lo$1 = ((-lo) | 0);
      var hi$2 = ((lo !== 0) ? (~hi$1) : ((-hi$1) | 0));
      var $$x1__lo = lo$1;
      var $$x1__hi = hi$2;
      v__lo = $$x1__lo;
      v__hi = $$x1__hi
    };
    var i__lo = v__lo;
    var i__hi = v__hi;
    var this$5 = $m_jl_Long$();
    return ((((radix === 10) || (radix < 2)) || (radix > 36)) ? $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toString__I__I__T(i__lo, i__hi) : this$5.java$lang$Long$$toStringImpl__J__I__T(new $c_RTLong(i__lo, i__hi), radix))
  } else if (((radix === 10) || radixOutOfBounds)) {
    return $m_Ljava_math_Conversion$().toDecimalScaledString__Ljava_math_BigInteger__T(bi)
  } else {
    var bitsForRadixDigit = 0.0;
    var a = radix;
    bitsForRadixDigit = ($uD(Math.log(a)) / $uD(Math.log(2.0)));
    var addForSign = ((sign < 0) ? 1 : 0);
    var this$8 = bi.abs__Ljava_math_BigInteger();
    var biAbsLen = $m_Ljava_math_BitLevel$().bitLength__Ljava_math_BigInteger__I(this$8);
    var resLenInChars = ((1 + $doubleToInt(((biAbsLen / bitsForRadixDigit) + addForSign))) | 0);
    var elem = null;
    elem = "";
    var elem$1 = 0;
    elem$1 = resLenInChars;
    var elem$2 = 0;
    elem$2 = 0;
    if ((radix !== 16)) {
      var temp = new $ac_I(numberLength);
      $systemArraycopy(digits, 0, temp, 0, numberLength);
      var elem$3 = 0;
      elem$3 = numberLength;
      var charsPerInt = this.Ljava_math_Conversion$__f_DigitFitInInt.get(radix);
      var bigRadix = this.Ljava_math_Conversion$__f_BigRadices.get((((-2) + radix) | 0));
      while (true) {
        elem$2 = $m_Ljava_math_Division$().divideArrayByInt__AI__AI__I__I__I(temp, temp, elem$3, bigRadix);
        var previous = elem$1;
        while (true) {
          elem$1 = (((-1) + elem$1) | 0);
          var digit = $intMod(elem$2, radix);
          var this$13 = $m_jl_Character$().forDigit__I__I__C(digit, radix);
          elem = (("" + $as_T(String.fromCharCode(this$13))) + $as_T(elem));
          elem$2 = $intDiv(elem$2, radix);
          if (((elem$2 !== 0) && (elem$1 !== 0))) {
            continue
          };
          break
        };
        var delta = ((((charsPerInt - previous) | 0) + elem$1) | 0);
        var i$1 = 0;
        while (((i$1 < delta) && (elem$1 > 0))) {
          elem$1 = (((-1) + elem$1) | 0);
          elem = ("0" + $as_T(elem));
          i$1 = ((1 + i$1) | 0)
        };
        i$1 = (((-1) + elem$3) | 0);
        while (((i$1 > 0) && (temp.get(i$1) === 0))) {
          i$1 = (((-1) + i$1) | 0)
        };
        elem$3 = ((1 + i$1) | 0);
        if ((!((elem$3 === 1) && (temp.get(0) === 0)))) {
          continue
        };
        break
      }
    } else {
      var i$2 = 0;
      while ((i$2 < numberLength)) {
        var arg1 = i$2;
        var j = 0;
        while (((j < 8) && (elem$1 > 0))) {
          elem$2 = (15 & (digits.get(arg1) >> (j << 2)));
          elem$1 = (((-1) + elem$1) | 0);
          var i$3 = elem$2;
          elem = (("" + $as_T($uD((i$3 >>> 0)).toString(16))) + $as_T(elem));
          j = ((1 + j) | 0)
        };
        i$2 = ((1 + i$2) | 0)
      }
    };
    var dropLen = 0;
    while (true) {
      var this$18 = $as_T(elem);
      var index = dropLen;
      if (((65535 & $uI(this$18.charCodeAt(index))) === 48)) {
        dropLen = ((1 + dropLen) | 0)
      } else {
        break
      }
    };
    if ((dropLen !== 0)) {
      var this$19 = $as_T(elem);
      var beginIndex = dropLen;
      elem = $as_T(this$19.substring(beginIndex))
    };
    return ((sign === (-1)) ? ("-" + $as_T(elem)) : $as_T(elem))
  }
});
$c_Ljava_math_Conversion$.prototype.toDecimalScaledString__Ljava_math_BigInteger__T = (function(bi) {
  var sign = bi.Ljava_math_BigInteger__f_sign;
  var numberLength = bi.Ljava_math_BigInteger__f_numberLength;
  var digits = bi.Ljava_math_BigInteger__f_digits;
  if ((sign === 0)) {
    return "0"
  } else if ((numberLength === 1)) {
    var i = digits.get(0);
    var absStr = $as_T($uD((i >>> 0)).toString(10));
    return ((sign < 0) ? ("-" + absStr) : absStr)
  } else {
    var result = "";
    var temp = new $ac_I(numberLength);
    var tempLen = numberLength;
    var length = tempLen;
    $systemArraycopy(digits, 0, temp, 0, length);
    while (true) {
      var rem = 0;
      var i$1 = (((-1) + tempLen) | 0);
      while ((i$1 >= 0)) {
        var value = rem;
        var value$1 = temp.get(i$1);
        var this$5 = $m_RTLong$();
        var lo = this$5.divideUnsignedImpl__I__I__I__I__I(value$1, value, 1000000000, 0);
        temp.set(i$1, lo);
        var hi$3 = (lo >> 31);
        var b0 = (65535 & lo);
        var b1 = ((lo >>> 16) | 0);
        var a0b0 = $imul(51712, b0);
        var a1b0 = $imul(15258, b0);
        var a0b1 = $imul(51712, b1);
        var lo$1 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
        var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
        var hi$4 = (((((($imul(1000000000, hi$3) + $imul(15258, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
        var lo$2 = ((value$1 - lo$1) | 0);
        rem = lo$2;
        i$1 = (((-1) + i$1) | 0)
      };
      var this$8 = rem;
      var remStr = ("" + this$8);
      var beginIndex = $uI(remStr.length);
      var padding = $as_T("000000000".substring(beginIndex));
      result = ((padding + remStr) + result);
      while (((tempLen !== 0) && (temp.get((((-1) + tempLen) | 0)) === 0))) {
        tempLen = (((-1) + tempLen) | 0)
      };
      if ((tempLen !== 0)) {
        /*<skip>*/
      } else {
        break
      }
    };
    result = $p_Ljava_math_Conversion$__dropLeadingZeros__T__T(this, result);
    return ((sign < 0) ? ("-" + result) : result)
  }
});
$c_Ljava_math_Conversion$.prototype.toDecimalScaledString__J__I__T = (function(value, scale) {
  if (((value.RTLong__f_lo === 0) && (value.RTLong__f_hi === 0))) {
    switch (scale) {
      case 0: {
        return "0";
        break
      }
      case 1: {
        return "0.0";
        break
      }
      case 2: {
        return "0.00";
        break
      }
      case 3: {
        return "0.000";
        break
      }
      case 4: {
        return "0.0000";
        break
      }
      case 5: {
        return "0.00000";
        break
      }
      case 6: {
        return "0.000000";
        break
      }
      default: {
        if ((scale === (-2147483648))) {
          var scaleVal = "2147483648"
        } else {
          var i = ((-scale) | 0);
          var scaleVal = ("" + i)
        };
        var result = ((scale < 0) ? "0E+" : "0E");
        return (result + scaleVal)
      }
    }
  } else {
    var ahi = value.RTLong__f_hi;
    var negNumber = (ahi < 0);
    var elem = null;
    elem = "";
    var currentChar = 18;
    if (negNumber) {
      var lo = value.RTLong__f_lo;
      var hi = value.RTLong__f_hi;
      var lo$1 = ((-lo) | 0);
      var hi$1 = ((lo !== 0) ? (~hi) : ((-hi) | 0));
      var x__lo = lo$1;
      var x__hi = hi$1;
      var t = new $c_RTLong(x__lo, x__hi)
    } else {
      var t = value
    };
    var lo$2 = t.RTLong__f_lo;
    var hi$2 = t.RTLong__f_hi;
    var v__lo = lo$2;
    var v__hi = hi$2;
    while (true) {
      var prev__lo = v__lo;
      var prev__hi = v__hi;
      var this$5__lo = v__lo;
      var this$5__hi = v__hi;
      var this$6 = $m_RTLong$();
      var lo$3 = this$6.divideImpl__I__I__I__I__I(this$5__lo, this$5__hi, 10, 0);
      var hi$3 = this$6.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      var $$x1__lo = lo$3;
      var $$x1__hi = hi$3;
      v__lo = $$x1__lo;
      v__hi = $$x1__hi;
      currentChar = (((-1) + currentChar) | 0);
      var b__lo = v__lo;
      var b__hi = v__hi;
      var blo = b__lo;
      var b0 = (65535 & blo);
      var b1 = ((blo >>> 16) | 0);
      var a0b0 = $imul(10, b0);
      var a0b1 = $imul(10, b1);
      var lo$4 = ((a0b0 + (a0b1 << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi$4 = (($imul(10, b__hi) + ((c1part >>> 16) | 0)) | 0);
      var alo = prev__lo;
      var ahi$1 = prev__hi;
      var lo$5 = ((alo - lo$4) | 0);
      elem = (("" + lo$5) + $as_T(elem));
      var this$9__lo = v__lo;
      var this$9__hi = v__hi;
      if ((!((this$9__lo === 0) && (this$9__hi === 0)))) {
        /*<skip>*/
      } else {
        break
      }
    };
    var value$1 = ((18 - currentChar) | 0);
    var hi$6 = (value$1 >> 31);
    var hi$7 = (scale >> 31);
    var lo$6 = ((value$1 - scale) | 0);
    var hi$8 = ((((-2147483648) ^ lo$6) > ((-2147483648) ^ value$1)) ? (((-1) + ((hi$6 - hi$7) | 0)) | 0) : ((hi$6 - hi$7) | 0));
    var lo$7 = (((-1) + lo$6) | 0);
    var hi$9 = ((lo$7 !== (-1)) ? hi$8 : (((-1) + hi$8) | 0));
    if (((scale > 0) && ((hi$9 === (-1)) ? (((-2147483648) ^ lo$7) >= 2147483642) : (hi$9 > (-1))))) {
      var index = ((1 + lo$7) | 0);
      if ((index > 0)) {
        var this$14 = $as_T(elem);
        var $$x2 = $as_T(this$14.substring(0, index));
        var this$15 = $as_T(elem);
        elem = (($$x2 + ".") + $as_T(this$15.substring(index)))
      } else {
        var end = ((-index) | 0);
        var i$1 = 0;
        while ((i$1 < end)) {
          elem = ("0" + $as_T(elem));
          i$1 = ((1 + i$1) | 0)
        };
        elem = ("0." + $as_T(elem))
      }
    } else if ((scale !== 0)) {
      var exponentStr = (((hi$9 === 0) ? (lo$7 !== 0) : (hi$9 > 0)) ? ("E+" + new $c_RTLong(lo$7, hi$9)) : ("E" + new $c_RTLong(lo$7, hi$9)));
      if ((((18 - currentChar) | 0) > 1)) {
        var this$19 = $as_T(elem);
        var $$x3 = $as_T(this$19.substring(0, 1));
        var this$20 = $as_T(elem);
        elem = ((($$x3 + ".") + $as_T(this$20.substring(1))) + exponentStr)
      } else {
        elem = ($as_T(elem) + exponentStr)
      }
    };
    return (negNumber ? ("-" + $as_T(elem)) : $as_T(elem))
  }
});
var $d_Ljava_math_Conversion$ = new $TypeData().initClass({
  Ljava_math_Conversion$: 0
}, false, "java.math.Conversion$", {
  Ljava_math_Conversion$: 1,
  O: 1
});
$c_Ljava_math_Conversion$.prototype.$classData = $d_Ljava_math_Conversion$;
var $n_Ljava_math_Conversion$;
function $m_Ljava_math_Conversion$() {
  if ((!$n_Ljava_math_Conversion$)) {
    $n_Ljava_math_Conversion$ = new $c_Ljava_math_Conversion$()
  };
  return $n_Ljava_math_Conversion$
}
/** @constructor */
function $c_Ljava_math_Division$() {
  /*<skip>*/
}
$c_Ljava_math_Division$.prototype = new $h_O();
$c_Ljava_math_Division$.prototype.constructor = $c_Ljava_math_Division$;
/** @constructor */
function $h_Ljava_math_Division$() {
  /*<skip>*/
}
$h_Ljava_math_Division$.prototype = $c_Ljava_math_Division$.prototype;
$c_Ljava_math_Division$.prototype.divide__AI__I__AI__I__AI__I__AI = (function(quot, quotLength, a, aLength, b, bLength) {
  var normA = new $ac_I(((1 + aLength) | 0));
  var normB = new $ac_I(((1 + bLength) | 0));
  var i = b.get((((-1) + bLength) | 0));
  var divisorShift = $clz32(i);
  if ((divisorShift !== 0)) {
    $m_Ljava_math_BitLevel$().shiftLeft__AI__AI__I__I__V(normB, b, 0, divisorShift);
    $m_Ljava_math_BitLevel$().shiftLeft__AI__AI__I__I__V(normA, a, 0, divisorShift)
  } else {
    $systemArraycopy(a, 0, normA, 0, aLength);
    $systemArraycopy(b, 0, normB, 0, bLength)
  };
  var firstDivisorDigit = normB.get((((-1) + bLength) | 0));
  var i$1 = (((-1) + quotLength) | 0);
  var elem = 0;
  elem = aLength;
  while ((i$1 >= 0)) {
    var elem$1 = 0;
    elem$1 = 0;
    if ((normA.get(elem) === firstDivisorDigit)) {
      elem$1 = (-1)
    } else {
      var value = normA.get(elem);
      var value$1 = normA.get((((-1) + elem) | 0));
      var this$7 = $m_RTLong$();
      var lo = this$7.divideUnsignedImpl__I__I__I__I__I(value$1, value, firstDivisorDigit, 0);
      var hi$3 = this$7.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      elem$1 = lo;
      var a0 = (65535 & lo);
      var a1 = ((lo >>> 16) | 0);
      var b0 = (65535 & firstDivisorDigit);
      var b1 = ((firstDivisorDigit >>> 16) | 0);
      var a0b0 = $imul(a0, b0);
      var a1b0 = $imul(a1, b0);
      var a0b1 = $imul(a0, b1);
      var lo$1 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi$4 = (((((($imul(hi$3, firstDivisorDigit) + $imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
      var lo$2 = ((value$1 - lo$1) | 0);
      var elem$2 = 0;
      elem$2 = lo$2;
      if ((elem$1 !== 0)) {
        elem$1 = ((1 + elem$1) | 0);
        while (true) {
          elem$1 = (((-1) + elem$1) | 0);
          var value$2 = elem$1;
          var value$3 = normB.get((((-2) + bLength) | 0));
          var a0$1 = (65535 & value$2);
          var a1$1 = ((value$2 >>> 16) | 0);
          var b0$1 = (65535 & value$3);
          var b1$1 = ((value$3 >>> 16) | 0);
          var a0b0$1 = $imul(a0$1, b0$1);
          var a1b0$1 = $imul(a1$1, b0$1);
          var a0b1$1 = $imul(a0$1, b1$1);
          var lo$3 = ((a0b0$1 + (((a1b0$1 + a0b1$1) | 0) << 16)) | 0);
          var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
          var hi$8 = (((($imul(a1$1, b1$1) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
          var value$4 = elem$2;
          var value$5 = normA.get((((-2) + elem) | 0));
          var value$6 = elem$2;
          var lo$4 = ((value$6 + firstDivisorDigit) | 0);
          var hi$13 = ((((-2147483648) ^ lo$4) < ((-2147483648) ^ value$6)) ? 1 : 0);
          if ((hi$13 === 0)) {
            elem$2 = lo$4;
            var hi$14 = ((-2147483648) ^ hi$8);
            var hi$15 = ((-2147483648) ^ value$4);
            if (((hi$14 === hi$15) ? (((-2147483648) ^ lo$3) > ((-2147483648) ^ value$5)) : (hi$14 > hi$15))) {
              continue
            }
          };
          break
        }
      }
    };
    if ((elem$1 !== 0)) {
      var borrow = $m_Ljava_math_Division$().multiplyAndSubtract__AI__I__AI__I__I__I(normA, ((elem - bLength) | 0), normB, bLength, elem$1);
      if ((borrow !== 0)) {
        elem$1 = (((-1) + elem$1) | 0);
        var elem$3__lo = 0;
        var elem$3__hi = 0;
        var $$x1__lo = 0;
        var $$x1__hi = 0;
        elem$3__lo = $$x1__lo;
        elem$3__hi = $$x1__hi;
        var i$2 = 0;
        while ((i$2 < bLength)) {
          var arg1 = i$2;
          var this$24__lo = elem$3__lo;
          var this$24__hi = elem$3__hi;
          var value$7 = normA.get(((((elem - bLength) | 0) + arg1) | 0));
          var value$8 = normB.get(arg1);
          var lo$5 = ((value$7 + value$8) | 0);
          var hi$18 = ((((-2147483648) ^ lo$5) < ((-2147483648) ^ value$7)) ? 1 : 0);
          var alo = this$24__lo;
          var ahi = this$24__hi;
          var lo$6 = ((alo + lo$5) | 0);
          var hi$19 = ((((-2147483648) ^ lo$6) < ((-2147483648) ^ alo)) ? ((1 + ((ahi + hi$18) | 0)) | 0) : ((ahi + hi$18) | 0));
          var $$x2__lo = lo$6;
          var $$x2__hi = hi$19;
          elem$3__lo = $$x2__lo;
          elem$3__hi = $$x2__hi;
          var $$x3 = elem;
          var this$26__lo = elem$3__lo;
          var this$26__hi = elem$3__hi;
          normA.set((((($$x3 - bLength) | 0) + arg1) | 0), this$26__lo);
          var this$27__lo = elem$3__lo;
          var this$27__hi = elem$3__hi;
          var hi$20 = this$27__hi;
          var $$x4__lo = hi$20;
          var $$x4__hi = 0;
          elem$3__lo = $$x4__lo;
          elem$3__hi = $$x4__hi;
          i$2 = ((1 + i$2) | 0)
        }
      }
    };
    if ((quot !== null)) {
      quot.set(i$1, elem$1)
    };
    elem = (((-1) + elem) | 0);
    i$1 = (((-1) + i$1) | 0)
  };
  if ((divisorShift !== 0)) {
    $m_Ljava_math_BitLevel$().shiftRight__AI__I__AI__I__I__Z(normB, bLength, normA, 0, divisorShift);
    return normB
  } else {
    $systemArraycopy(normA, 0, normB, 0, bLength);
    return normA
  }
});
$c_Ljava_math_Division$.prototype.divideAndRemainderByInteger__Ljava_math_BigInteger__I__I__Ljava_math_BigInteger$QuotAndRem = (function(bi, divisor, divisorSign) {
  var valDigits = bi.Ljava_math_BigInteger__f_digits;
  var valLen = bi.Ljava_math_BigInteger__f_numberLength;
  var valSign = bi.Ljava_math_BigInteger__f_sign;
  if ((valLen === 1)) {
    var valDigit = valDigits.get(0);
    if ((divisor === 0)) {
      var value = $intDiv(0, 0)
    } else {
      var n = ($uD((valDigit >>> 0)) / $uD((divisor >>> 0)));
      var value = $uI((n | 0))
    };
    var quo__lo = value;
    var quo__hi = 0;
    if ((divisor === 0)) {
      var value$1 = $intMod(0, 0)
    } else {
      var n$1 = ($uD((valDigit >>> 0)) % $uD((divisor >>> 0)));
      var value$1 = $uI((n$1 | 0))
    };
    var rem__lo = value$1;
    var rem__hi = 0;
    if ((valSign !== divisorSign)) {
      var this$5__lo = quo__lo;
      var this$5__hi = quo__hi;
      var lo = this$5__lo;
      var hi$2 = this$5__hi;
      var lo$1 = ((-lo) | 0);
      var hi$3 = ((lo !== 0) ? (~hi$2) : ((-hi$2) | 0));
      var $$x1__lo = lo$1;
      var $$x1__hi = hi$3;
      quo__lo = $$x1__lo;
      quo__hi = $$x1__hi
    };
    if ((valSign < 0)) {
      var this$8__lo = rem__lo;
      var this$8__hi = rem__hi;
      var lo$2 = this$8__lo;
      var hi$4 = this$8__hi;
      var lo$3 = ((-lo$2) | 0);
      var hi$5 = ((lo$2 !== 0) ? (~hi$4) : ((-hi$4) | 0));
      var $$x2__lo = lo$3;
      var $$x2__hi = hi$5;
      rem__lo = $$x2__lo;
      rem__hi = $$x2__hi
    };
    return new $c_Ljava_math_BigInteger$QuotAndRem($m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(new $c_RTLong(quo__lo, quo__hi)), $m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(new $c_RTLong(rem__lo, rem__hi)))
  } else {
    var quotientSign = ((valSign === divisorSign) ? 1 : (-1));
    var quotientDigits = new $ac_I(valLen);
    var div = this.divideArrayByInt__AI__AI__I__I__I(quotientDigits, valDigits, valLen, divisor);
    var remainderDigits = new $ac_I([div]);
    var result0 = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), quotientSign, valLen, quotientDigits);
    var result1 = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), valSign, 1, remainderDigits);
    result0.cutOffLeadingZeroes__V();
    result1.cutOffLeadingZeroes__V();
    return new $c_Ljava_math_BigInteger$QuotAndRem(result0, result1)
  }
});
$c_Ljava_math_Division$.prototype.divideArrayByInt__AI__AI__I__I__I = (function(dest, src, srcLength, divisor) {
  var rem = 0;
  var i = (((-1) + srcLength) | 0);
  while ((i >= 0)) {
    var value = rem;
    var value$1 = src.get(i);
    var this$4 = $m_RTLong$();
    var lo = this$4.divideUnsignedImpl__I__I__I__I__I(value$1, value, divisor, 0);
    var hi$3 = this$4.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var a0 = (65535 & lo);
    var a1 = ((lo >>> 16) | 0);
    var b0 = (65535 & divisor);
    var b1 = ((divisor >>> 16) | 0);
    var a0b0 = $imul(a0, b0);
    var a1b0 = $imul(a1, b0);
    var a0b1 = $imul(a0, b1);
    var lo$1 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$4 = (((((($imul(hi$3, divisor) + $imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
    var lo$2 = ((value$1 - lo$1) | 0);
    rem = lo$2;
    dest.set(i, lo);
    i = (((-1) + i) | 0)
  };
  return rem
});
$c_Ljava_math_Division$.prototype.multiplyAndSubtract__AI__I__AI__I__I__I = (function(a, start, b, bLen, c) {
  var elem = 0;
  elem = 0;
  var elem$1 = 0;
  elem$1 = 0;
  var i = 0;
  while ((i < bLen)) {
    var arg1 = i;
    $m_Ljava_math_Multiplication$();
    var a$1 = b.get(arg1);
    var c$1 = elem;
    var a0 = (65535 & a$1);
    var a1 = ((a$1 >>> 16) | 0);
    var b0 = (65535 & c);
    var b1 = ((c >>> 16) | 0);
    var a0b0 = $imul(a0, b0);
    var a1b0 = $imul(a1, b0);
    var a0b1 = $imul(a0, b1);
    var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$2 = (((($imul(a1, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
    var lo$1 = ((lo + c$1) | 0);
    var hi$4 = ((((-2147483648) ^ lo$1) < ((-2147483648) ^ lo)) ? ((1 + hi$2) | 0) : hi$2);
    var value = a.get(((start + arg1) | 0));
    var lo$2 = ((value - lo$1) | 0);
    var hi$6 = ((((-2147483648) ^ lo$2) > ((-2147483648) ^ value)) ? (-1) : 0);
    var value$1 = elem$1;
    var hi$7 = (value$1 >> 31);
    var lo$3 = ((lo$2 + value$1) | 0);
    var hi$8 = ((((-2147483648) ^ lo$3) < ((-2147483648) ^ lo$2)) ? ((1 + ((hi$6 + hi$7) | 0)) | 0) : ((hi$6 + hi$7) | 0));
    a.set(((start + arg1) | 0), lo$3);
    elem$1 = hi$8;
    elem = hi$4;
    i = ((1 + i) | 0)
  };
  var value$2 = a.get(((start + bLen) | 0));
  var value$3 = elem;
  var lo$4 = ((value$2 - value$3) | 0);
  var hi$13 = ((((-2147483648) ^ lo$4) > ((-2147483648) ^ value$2)) ? (-1) : 0);
  var value$4 = elem$1;
  var hi$14 = (value$4 >> 31);
  var lo$5 = ((lo$4 + value$4) | 0);
  var hi$15 = ((((-2147483648) ^ lo$5) < ((-2147483648) ^ lo$4)) ? ((1 + ((hi$13 + hi$14) | 0)) | 0) : ((hi$13 + hi$14) | 0));
  a.set(((start + bLen) | 0), lo$5);
  return hi$15
});
var $d_Ljava_math_Division$ = new $TypeData().initClass({
  Ljava_math_Division$: 0
}, false, "java.math.Division$", {
  Ljava_math_Division$: 1,
  O: 1
});
$c_Ljava_math_Division$.prototype.$classData = $d_Ljava_math_Division$;
var $n_Ljava_math_Division$;
function $m_Ljava_math_Division$() {
  if ((!$n_Ljava_math_Division$)) {
    $n_Ljava_math_Division$ = new $c_Ljava_math_Division$()
  };
  return $n_Ljava_math_Division$
}
function $p_Ljava_math_Elementary$__add__AI__I__AI__I__AI($thiz, a, aSize, b, bSize) {
  var res = new $ac_I(((1 + aSize) | 0));
  $p_Ljava_math_Elementary$__add__AI__AI__I__AI__I__V($thiz, res, a, aSize, b, bSize);
  return res
}
function $p_Ljava_math_Elementary$__add__AI__AI__I__AI__I__V($thiz, res, a, aSize, b, bSize) {
  var i = 1;
  var value = a.get(0);
  var value$1 = b.get(0);
  var lo = ((value + value$1) | 0);
  var hi$2 = ((((-2147483648) ^ lo) < ((-2147483648) ^ value)) ? 1 : 0);
  res.set(0, lo);
  var carry = hi$2;
  if ((aSize >= bSize)) {
    while ((i < bSize)) {
      var value$2 = a.get(i);
      var value$3 = b.get(i);
      var lo$1 = ((value$2 + value$3) | 0);
      var hi$6 = ((((-2147483648) ^ lo$1) < ((-2147483648) ^ value$2)) ? 1 : 0);
      var value$4 = carry;
      var lo$2 = ((lo$1 + value$4) | 0);
      var hi$8 = ((((-2147483648) ^ lo$2) < ((-2147483648) ^ lo$1)) ? ((1 + hi$6) | 0) : hi$6);
      res.set(i, lo$2);
      carry = hi$8;
      i = ((1 + i) | 0)
    };
    while ((i < aSize)) {
      var value$5 = a.get(i);
      var value$6 = carry;
      var lo$3 = ((value$5 + value$6) | 0);
      var hi$12 = ((((-2147483648) ^ lo$3) < ((-2147483648) ^ value$5)) ? 1 : 0);
      res.set(i, lo$3);
      carry = hi$12;
      i = ((1 + i) | 0)
    }
  } else {
    while ((i < aSize)) {
      var value$7 = a.get(i);
      var value$8 = b.get(i);
      var lo$4 = ((value$7 + value$8) | 0);
      var hi$16 = ((((-2147483648) ^ lo$4) < ((-2147483648) ^ value$7)) ? 1 : 0);
      var value$9 = carry;
      var lo$5 = ((lo$4 + value$9) | 0);
      var hi$18 = ((((-2147483648) ^ lo$5) < ((-2147483648) ^ lo$4)) ? ((1 + hi$16) | 0) : hi$16);
      res.set(i, lo$5);
      carry = hi$18;
      i = ((1 + i) | 0)
    };
    while ((i < bSize)) {
      var value$10 = b.get(i);
      var value$11 = carry;
      var lo$6 = ((value$10 + value$11) | 0);
      var hi$22 = ((((-2147483648) ^ lo$6) < ((-2147483648) ^ value$10)) ? 1 : 0);
      res.set(i, lo$6);
      carry = hi$22;
      i = ((1 + i) | 0)
    }
  };
  if ((carry !== 0)) {
    res.set(i, carry)
  }
}
function $p_Ljava_math_Elementary$__subtract__AI__I__AI__I__AI($thiz, a, aSize, b, bSize) {
  var res = new $ac_I(aSize);
  $p_Ljava_math_Elementary$__subtract__AI__AI__I__AI__I__V($thiz, res, a, aSize, b, bSize);
  return res
}
function $p_Ljava_math_Elementary$__subtract__AI__AI__I__AI__I__V($thiz, res, a, aSize, b, bSize) {
  var i = 0;
  var borrow = 0;
  while ((i < bSize)) {
    var value = a.get(i);
    var value$1 = b.get(i);
    var lo = ((value - value$1) | 0);
    var hi$2 = ((((-2147483648) ^ lo) > ((-2147483648) ^ value)) ? (-1) : 0);
    var value$2 = borrow;
    var hi$3 = (value$2 >> 31);
    var lo$1 = ((lo + value$2) | 0);
    var hi$4 = ((((-2147483648) ^ lo$1) < ((-2147483648) ^ lo)) ? ((1 + ((hi$2 + hi$3) | 0)) | 0) : ((hi$2 + hi$3) | 0));
    res.set(i, lo$1);
    borrow = hi$4;
    i = ((1 + i) | 0)
  };
  while ((i < aSize)) {
    var value$3 = a.get(i);
    var value$4 = borrow;
    var hi$7 = (value$4 >> 31);
    var lo$2 = ((value$3 + value$4) | 0);
    var hi$8 = ((((-2147483648) ^ lo$2) < ((-2147483648) ^ value$3)) ? ((1 + hi$7) | 0) : hi$7);
    res.set(i, lo$2);
    borrow = hi$8;
    i = ((1 + i) | 0)
  }
}
/** @constructor */
function $c_Ljava_math_Elementary$() {
  /*<skip>*/
}
$c_Ljava_math_Elementary$.prototype = new $h_O();
$c_Ljava_math_Elementary$.prototype.constructor = $c_Ljava_math_Elementary$;
/** @constructor */
function $h_Ljava_math_Elementary$() {
  /*<skip>*/
}
$h_Ljava_math_Elementary$.prototype = $c_Ljava_math_Elementary$.prototype;
$c_Ljava_math_Elementary$.prototype.add__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger = (function(op1, op2) {
  var op1Sign = op1.Ljava_math_BigInteger__f_sign;
  var op2Sign = op2.Ljava_math_BigInteger__f_sign;
  var op1Len = op1.Ljava_math_BigInteger__f_numberLength;
  var op2Len = op2.Ljava_math_BigInteger__f_numberLength;
  if ((op1Sign === 0)) {
    return op2
  } else if ((op2Sign === 0)) {
    return op1
  } else if ((((op1Len + op2Len) | 0) === 2)) {
    var value = op1.Ljava_math_BigInteger__f_digits.get(0);
    var value$1 = op2.Ljava_math_BigInteger__f_digits.get(0);
    if ((op1Sign === op2Sign)) {
      var lo = ((value + value$1) | 0);
      var hi$2 = ((((-2147483648) ^ lo) < ((-2147483648) ^ value)) ? 1 : 0);
      return ((hi$2 === 0) ? $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), op1Sign, lo) : $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), op1Sign, 2, new $ac_I([lo, hi$2])))
    } else {
      var $$x1 = $m_Ljava_math_BigInteger$();
      if ((op1Sign < 0)) {
        var lo$1 = ((value$1 - value) | 0);
        var hi$3 = ((((-2147483648) ^ lo$1) > ((-2147483648) ^ value$1)) ? (-1) : 0);
        var x__lo = lo$1;
        var x__hi = hi$3
      } else {
        var lo$2 = ((value - value$1) | 0);
        var hi$4 = ((((-2147483648) ^ lo$2) > ((-2147483648) ^ value)) ? (-1) : 0);
        var x__lo = lo$2;
        var x__hi = hi$4
      };
      return $$x1.valueOf__J__Ljava_math_BigInteger(new $c_RTLong(x__lo, x__hi))
    }
  } else {
    if ((op1Sign === op2Sign)) {
      var res$2 = ((op1Len >= op2Len) ? $p_Ljava_math_Elementary$__add__AI__I__AI__I__AI(this, op1.Ljava_math_BigInteger__f_digits, op1Len, op2.Ljava_math_BigInteger__f_digits, op2Len) : $p_Ljava_math_Elementary$__add__AI__I__AI__I__AI(this, op2.Ljava_math_BigInteger__f_digits, op2Len, op1.Ljava_math_BigInteger__f_digits, op1Len));
      var x1___1 = op1Sign;
      var x1___2 = res$2
    } else {
      var cmp = ((op1Len !== op2Len) ? ((op1Len > op2Len) ? 1 : (-1)) : this.compareArrays__AI__AI__I__I(op1.Ljava_math_BigInteger__f_digits, op2.Ljava_math_BigInteger__f_digits, op1Len));
      if ((cmp === 0)) {
        return $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ZERO
      };
      if ((cmp === 1)) {
        var _2 = $p_Ljava_math_Elementary$__subtract__AI__I__AI__I__AI(this, op1.Ljava_math_BigInteger__f_digits, op1Len, op2.Ljava_math_BigInteger__f_digits, op2Len);
        var x1___1 = op1Sign;
        var x1___2 = _2
      } else {
        var _2$1 = $p_Ljava_math_Elementary$__subtract__AI__I__AI__I__AI(this, op2.Ljava_math_BigInteger__f_digits, op2Len, op1.Ljava_math_BigInteger__f_digits, op1Len);
        var x1___1 = op2Sign;
        var x1___2 = _2$1
      }
    };
    var resSign = $uI(x1___1);
    var resDigits = $asArrayOf_I(x1___2, 1);
    var res$3 = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), resSign, resDigits.u.length, resDigits);
    res$3.cutOffLeadingZeroes__V();
    return res$3
  }
});
$c_Ljava_math_Elementary$.prototype.compareArrays__AI__AI__I__I = (function(a, b, size) {
  var i = (((-1) + size) | 0);
  while (((i >= 0) && (a.get(i) === b.get(i)))) {
    i = (((-1) + i) | 0)
  };
  if ((i < 0)) {
    return 0
  } else {
    var value = a.get(i);
    var value$1 = b.get(i);
    if ((((-2147483648) ^ value) < ((-2147483648) ^ value$1))) {
      return (-1)
    } else {
      return 1
    }
  }
});
$c_Ljava_math_Elementary$.prototype.inplaceAdd__AI__I__I__I = (function(a, aSize, addend) {
  var carry = addend;
  var i = 0;
  while (((carry !== 0) && (i < aSize))) {
    var value = carry;
    var value$1 = a.get(i);
    var lo = ((value + value$1) | 0);
    var hi$2 = ((((-2147483648) ^ lo) < ((-2147483648) ^ value)) ? 1 : 0);
    a.set(i, lo);
    carry = hi$2;
    i = ((1 + i) | 0)
  };
  return carry
});
$c_Ljava_math_Elementary$.prototype.subtract__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger = (function(op1, op2) {
  var op1Sign = op1.Ljava_math_BigInteger__f_sign;
  var op2Sign = op2.Ljava_math_BigInteger__f_sign;
  var op1Len = op1.Ljava_math_BigInteger__f_numberLength;
  var op2Len = op2.Ljava_math_BigInteger__f_numberLength;
  if ((op2Sign === 0)) {
    return op1
  } else if ((op1Sign === 0)) {
    return op2.negate__Ljava_math_BigInteger()
  } else if ((((op1Len + op2Len) | 0) === 2)) {
    var value = op1.Ljava_math_BigInteger__f_digits.get(0);
    var a__lo = value;
    var a__hi = 0;
    var value$1 = op2.Ljava_math_BigInteger__f_digits.get(0);
    var b__lo = value$1;
    var b__hi = 0;
    if ((op1Sign < 0)) {
      var this$3__lo = a__lo;
      var this$3__hi = a__hi;
      var lo = this$3__lo;
      var hi$2 = this$3__hi;
      var lo$1 = ((-lo) | 0);
      var hi$3 = ((lo !== 0) ? (~hi$2) : ((-hi$2) | 0));
      var $$x1__lo = lo$1;
      var $$x1__hi = hi$3;
      a__lo = $$x1__lo;
      a__hi = $$x1__hi
    };
    if ((op2Sign < 0)) {
      var this$6__lo = b__lo;
      var this$6__hi = b__hi;
      var lo$2 = this$6__lo;
      var hi$4 = this$6__hi;
      var lo$3 = ((-lo$2) | 0);
      var hi$5 = ((lo$2 !== 0) ? (~hi$4) : ((-hi$4) | 0));
      var $$x2__lo = lo$3;
      var $$x2__hi = hi$5;
      b__lo = $$x2__lo;
      b__hi = $$x2__hi
    };
    var $$x3 = $m_Ljava_math_BigInteger$();
    var this$9__lo = a__lo;
    var this$9__hi = a__hi;
    var b$1__lo = b__lo;
    var b$1__hi = b__hi;
    var alo = this$9__lo;
    var ahi = this$9__hi;
    var bhi = b$1__hi;
    var lo$4 = ((alo - b$1__lo) | 0);
    var hi$6 = ((((-2147483648) ^ lo$4) > ((-2147483648) ^ alo)) ? (((-1) + ((ahi - bhi) | 0)) | 0) : ((ahi - bhi) | 0));
    return $$x3.valueOf__J__Ljava_math_BigInteger(new $c_RTLong(lo$4, hi$6))
  } else {
    var cmp = ((op1Len !== op2Len) ? ((op1Len > op2Len) ? 1 : (-1)) : $m_Ljava_math_Elementary$().compareArrays__AI__AI__I__I(op1.Ljava_math_BigInteger__f_digits, op2.Ljava_math_BigInteger__f_digits, op1Len));
    if (((op1Sign === op2Sign) && (cmp === 0))) {
      return $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ZERO
    };
    if ((cmp === (-1))) {
      var res = ((op1Sign === op2Sign) ? $p_Ljava_math_Elementary$__subtract__AI__I__AI__I__AI(this, op2.Ljava_math_BigInteger__f_digits, op2Len, op1.Ljava_math_BigInteger__f_digits, op1Len) : $p_Ljava_math_Elementary$__add__AI__I__AI__I__AI(this, op2.Ljava_math_BigInteger__f_digits, op2Len, op1.Ljava_math_BigInteger__f_digits, op1Len));
      var _1 = ((-op2Sign) | 0);
      var x1___1 = _1;
      var x1___2 = res
    } else if ((op1Sign === op2Sign)) {
      var _2 = $p_Ljava_math_Elementary$__subtract__AI__I__AI__I__AI(this, op1.Ljava_math_BigInteger__f_digits, op1Len, op2.Ljava_math_BigInteger__f_digits, op2Len);
      var x1___1 = op1Sign;
      var x1___2 = _2
    } else {
      var _2$1 = $p_Ljava_math_Elementary$__add__AI__I__AI__I__AI(this, op1.Ljava_math_BigInteger__f_digits, op1Len, op2.Ljava_math_BigInteger__f_digits, op2Len);
      var x1___1 = op1Sign;
      var x1___2 = _2$1
    };
    var resSign = $uI(x1___1);
    var resDigits = $asArrayOf_I(x1___2, 1);
    var res$2 = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), resSign, resDigits.u.length, resDigits);
    res$2.cutOffLeadingZeroes__V();
    return res$2
  }
});
var $d_Ljava_math_Elementary$ = new $TypeData().initClass({
  Ljava_math_Elementary$: 0
}, false, "java.math.Elementary$", {
  Ljava_math_Elementary$: 1,
  O: 1
});
$c_Ljava_math_Elementary$.prototype.$classData = $d_Ljava_math_Elementary$;
var $n_Ljava_math_Elementary$;
function $m_Ljava_math_Elementary$() {
  if ((!$n_Ljava_math_Elementary$)) {
    $n_Ljava_math_Elementary$ = new $c_Ljava_math_Elementary$()
  };
  return $n_Ljava_math_Elementary$
}
/** @constructor */
function $c_Ljava_math_MathContext(setPrecision, setRoundingMode) {
  this.Ljava_math_MathContext__f_precision = 0;
  this.Ljava_math_MathContext__f_roundingMode = null;
  this.Ljava_math_MathContext__f_precision = setPrecision;
  this.Ljava_math_MathContext__f_roundingMode = setRoundingMode
}
$c_Ljava_math_MathContext.prototype = new $h_O();
$c_Ljava_math_MathContext.prototype.constructor = $c_Ljava_math_MathContext;
/** @constructor */
function $h_Ljava_math_MathContext() {
  /*<skip>*/
}
$h_Ljava_math_MathContext.prototype = $c_Ljava_math_MathContext.prototype;
$c_Ljava_math_MathContext.prototype.equals__O__Z = (function(x) {
  if ((x instanceof $c_Ljava_math_MathContext)) {
    var x2 = $as_Ljava_math_MathContext(x);
    if ((this.Ljava_math_MathContext__f_precision === x2.Ljava_math_MathContext__f_precision)) {
      var x$2 = this.Ljava_math_MathContext__f_roundingMode;
      var x$3 = x2.Ljava_math_MathContext__f_roundingMode;
      return (x$2 === x$3)
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Ljava_math_MathContext.prototype.hashCode__I = (function() {
  return ((this.Ljava_math_MathContext__f_precision << 3) | this.Ljava_math_MathContext__f_roundingMode.jl_Enum__f__ordinal)
});
$c_Ljava_math_MathContext.prototype.toString__T = (function() {
  return ((("precision=" + this.Ljava_math_MathContext__f_precision) + " roundingMode=") + this.Ljava_math_MathContext__f_roundingMode)
});
function $as_Ljava_math_MathContext(obj) {
  return (((obj instanceof $c_Ljava_math_MathContext) || (obj === null)) ? obj : $throwClassCastException(obj, "java.math.MathContext"))
}
function $isArrayOf_Ljava_math_MathContext(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_math_MathContext)))
}
function $asArrayOf_Ljava_math_MathContext(obj, depth) {
  return (($isArrayOf_Ljava_math_MathContext(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.math.MathContext;", depth))
}
var $d_Ljava_math_MathContext = new $TypeData().initClass({
  Ljava_math_MathContext: 0
}, false, "java.math.MathContext", {
  Ljava_math_MathContext: 1,
  O: 1
});
$c_Ljava_math_MathContext.prototype.$classData = $d_Ljava_math_MathContext;
/** @constructor */
function $c_Ljava_math_MathContext$() {
  this.Ljava_math_MathContext$__f_DECIMAL128 = null;
  this.Ljava_math_MathContext$__f_DECIMAL32 = null;
  this.Ljava_math_MathContext$__f_DECIMAL64 = null;
  this.Ljava_math_MathContext$__f_UNLIMITED = null;
  $n_Ljava_math_MathContext$ = this;
  $m_Ljava_math_MathContext$();
  var roundingMode = $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_HALF_EVEN;
  this.Ljava_math_MathContext$__f_DECIMAL128 = new $c_Ljava_math_MathContext(34, roundingMode);
  $m_Ljava_math_MathContext$();
  var roundingMode$1 = $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_HALF_EVEN;
  this.Ljava_math_MathContext$__f_DECIMAL32 = new $c_Ljava_math_MathContext(7, roundingMode$1);
  $m_Ljava_math_MathContext$();
  var roundingMode$2 = $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_HALF_EVEN;
  this.Ljava_math_MathContext$__f_DECIMAL64 = new $c_Ljava_math_MathContext(16, roundingMode$2);
  $m_Ljava_math_MathContext$();
  var roundingMode$3 = $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_HALF_UP;
  this.Ljava_math_MathContext$__f_UNLIMITED = new $c_Ljava_math_MathContext(0, roundingMode$3)
}
$c_Ljava_math_MathContext$.prototype = new $h_O();
$c_Ljava_math_MathContext$.prototype.constructor = $c_Ljava_math_MathContext$;
/** @constructor */
function $h_Ljava_math_MathContext$() {
  /*<skip>*/
}
$h_Ljava_math_MathContext$.prototype = $c_Ljava_math_MathContext$.prototype;
var $d_Ljava_math_MathContext$ = new $TypeData().initClass({
  Ljava_math_MathContext$: 0
}, false, "java.math.MathContext$", {
  Ljava_math_MathContext$: 1,
  O: 1
});
$c_Ljava_math_MathContext$.prototype.$classData = $d_Ljava_math_MathContext$;
var $n_Ljava_math_MathContext$;
function $m_Ljava_math_MathContext$() {
  if ((!$n_Ljava_math_MathContext$)) {
    $n_Ljava_math_MathContext$ = new $c_Ljava_math_MathContext$()
  };
  return $n_Ljava_math_MathContext$
}
function $p_Ljava_math_Multiplication$__initialiseArrays__V($thiz) {
  var elem__lo = 0;
  var elem__hi = 0;
  var $$x1__lo = 1;
  var $$x1__hi = 0;
  elem__lo = $$x1__lo;
  elem__hi = $$x1__hi;
  var i = 0;
  while ((i < 32)) {
    var arg1 = i;
    if ((arg1 <= 18)) {
      $m_Ljava_math_Multiplication$().Ljava_math_Multiplication$__f_BigFivePows.set(arg1, $m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(new $c_RTLong(elem__lo, elem__hi)));
      var $$x3 = $m_Ljava_math_Multiplication$().Ljava_math_Multiplication$__f_BigTenPows;
      var $$x2 = $m_Ljava_math_BigInteger$();
      var this$4__lo = elem__lo;
      var this$4__hi = elem__hi;
      var lo = this$4__lo;
      var lo$1 = (((32 & arg1) === 0) ? (lo << arg1) : 0);
      var hi = (((32 & arg1) === 0) ? (((((lo >>> 1) | 0) >>> ((31 - arg1) | 0)) | 0) | (this$4__hi << arg1)) : (lo << arg1));
      $$x3.set(arg1, $$x2.valueOf__J__Ljava_math_BigInteger(new $c_RTLong(lo$1, hi)));
      var b__lo = elem__lo;
      var b__hi = elem__hi;
      var blo = b__lo;
      var b0 = (65535 & blo);
      var b1 = ((blo >>> 16) | 0);
      var a0b0 = $imul(5, b0);
      var a0b1 = $imul(5, b1);
      var lo$2 = ((a0b0 + (a0b1 << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi$1 = (($imul(5, b__hi) + ((c1part >>> 16) | 0)) | 0);
      var $$x4__lo = lo$2;
      var $$x4__hi = hi$1;
      elem__lo = $$x4__lo;
      elem__hi = $$x4__hi
    } else {
      $m_Ljava_math_Multiplication$().Ljava_math_Multiplication$__f_BigFivePows.set(arg1, $m_Ljava_math_Multiplication$().Ljava_math_Multiplication$__f_BigFivePows.get((((-1) + arg1) | 0)).multiply__Ljava_math_BigInteger__Ljava_math_BigInteger($m_Ljava_math_Multiplication$().Ljava_math_Multiplication$__f_BigFivePows.get(1)));
      $m_Ljava_math_Multiplication$().Ljava_math_Multiplication$__f_BigTenPows.set(arg1, $m_Ljava_math_Multiplication$().Ljava_math_Multiplication$__f_BigTenPows.get((((-1) + arg1) | 0)).multiply__Ljava_math_BigInteger__Ljava_math_BigInteger($m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_TEN))
    };
    i = ((1 + i) | 0)
  }
}
function $p_Ljava_math_Multiplication$__multiplyByInt__AI__AI__I__I__I($thiz, res, a, aSize, factor) {
  var elem = 0;
  elem = 0;
  var i = 0;
  while ((i < aSize)) {
    var arg1 = i;
    $m_Ljava_math_Multiplication$();
    var a$1 = a.get(arg1);
    var c = elem;
    var a0 = (65535 & a$1);
    var a1 = ((a$1 >>> 16) | 0);
    var b0 = (65535 & factor);
    var b1 = ((factor >>> 16) | 0);
    var a0b0 = $imul(a0, b0);
    var a1b0 = $imul(a1, b0);
    var a0b1 = $imul(a0, b1);
    var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$2 = (((($imul(a1, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
    var lo$1 = ((lo + c) | 0);
    var hi$4 = ((((-2147483648) ^ lo$1) < ((-2147483648) ^ lo)) ? ((1 + hi$2) | 0) : hi$2);
    res.set(arg1, lo$1);
    elem = hi$4;
    i = ((1 + i) | 0)
  };
  return elem
}
function $p_Ljava_math_Multiplication$__multPAP__AI__AI__AI__I__I__V($thiz, a, b, t, aLen, bLen) {
  if (((a === b) && (aLen === bLen))) {
    $thiz.square__AI__I__AI__AI(a, aLen, t)
  } else {
    var i = 0;
    while ((i < aLen)) {
      var arg1 = i;
      var elem = 0;
      elem = 0;
      var aI = a.get(arg1);
      var i$1 = 0;
      while ((i$1 < bLen)) {
        var arg1$1 = i$1;
        $m_Ljava_math_Multiplication$();
        var b$1 = b.get(arg1$1);
        var c = t.get(((arg1 + arg1$1) | 0));
        var d = elem;
        var a0 = (65535 & aI);
        var a1 = ((aI >>> 16) | 0);
        var b0 = (65535 & b$1);
        var b1 = ((b$1 >>> 16) | 0);
        var a0b0 = $imul(a0, b0);
        var a1b0 = $imul(a1, b0);
        var a0b1 = $imul(a0, b1);
        var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
        var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
        var hi$2 = (((($imul(a1, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
        var lo$1 = ((lo + c) | 0);
        var hi$4 = ((((-2147483648) ^ lo$1) < ((-2147483648) ^ lo)) ? ((1 + hi$2) | 0) : hi$2);
        var lo$2 = ((lo$1 + d) | 0);
        var hi$6 = ((((-2147483648) ^ lo$2) < ((-2147483648) ^ lo$1)) ? ((1 + hi$4) | 0) : hi$4);
        t.set(((arg1 + arg1$1) | 0), lo$2);
        elem = hi$6;
        i$1 = ((1 + i$1) | 0)
      };
      t.set(((arg1 + bLen) | 0), elem);
      i = ((1 + i) | 0)
    }
  }
}
function $p_Ljava_math_Multiplication$__newArrayOfPows__I__I__AI($thiz, len, pow) {
  $m_s_reflect_ManifestFactory$IntManifest$();
  if ((len > 0)) {
    var array = new $ac_I(len);
    var acc = 1;
    var i = 1;
    array.set(0, $uI(acc));
    while ((i < len)) {
      var arg1 = acc;
      var x$2 = $uI(arg1);
      acc = $imul(x$2, pow);
      array.set(i, $uI(acc));
      i = ((1 + i) | 0)
    };
    return array
  } else {
    return new $ac_I(0)
  }
}
/** @constructor */
function $c_Ljava_math_Multiplication$() {
  this.Ljava_math_Multiplication$__f_TenPows = null;
  this.Ljava_math_Multiplication$__f_FivePows = null;
  this.Ljava_math_Multiplication$__f_BigTenPows = null;
  this.Ljava_math_Multiplication$__f_BigFivePows = null;
  $n_Ljava_math_Multiplication$ = this;
  this.Ljava_math_Multiplication$__f_TenPows = $p_Ljava_math_Multiplication$__newArrayOfPows__I__I__AI(this, 10, 10);
  this.Ljava_math_Multiplication$__f_FivePows = $p_Ljava_math_Multiplication$__newArrayOfPows__I__I__AI(this, 14, 5);
  this.Ljava_math_Multiplication$__f_BigTenPows = new ($d_Ljava_math_BigInteger.getArrayOf().constr)(32);
  this.Ljava_math_Multiplication$__f_BigFivePows = new ($d_Ljava_math_BigInteger.getArrayOf().constr)(32);
  $p_Ljava_math_Multiplication$__initialiseArrays__V(this)
}
$c_Ljava_math_Multiplication$.prototype = new $h_O();
$c_Ljava_math_Multiplication$.prototype.constructor = $c_Ljava_math_Multiplication$;
/** @constructor */
function $h_Ljava_math_Multiplication$() {
  /*<skip>*/
}
$h_Ljava_math_Multiplication$.prototype = $c_Ljava_math_Multiplication$.prototype;
$c_Ljava_math_Multiplication$.prototype.square__AI__I__AI__AI = (function(a, aLen, res) {
  var elem = 0;
  elem = 0;
  var i = 0;
  while ((i < aLen)) {
    var arg1 = i;
    elem = 0;
    var _\uff3fself = ((1 + arg1) | 0);
    var i$1 = _\uff3fself;
    while ((i$1 < aLen)) {
      var arg1$1 = i$1;
      $m_Ljava_math_Multiplication$();
      var a$1 = a.get(arg1);
      var b = a.get(arg1$1);
      var c = res.get(((arg1 + arg1$1) | 0));
      var d = elem;
      var a0 = (65535 & a$1);
      var a1 = ((a$1 >>> 16) | 0);
      var b0 = (65535 & b);
      var b1 = ((b >>> 16) | 0);
      var a0b0 = $imul(a0, b0);
      var a1b0 = $imul(a1, b0);
      var a0b1 = $imul(a0, b1);
      var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi$2 = (((($imul(a1, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
      var lo$1 = ((lo + c) | 0);
      var hi$4 = ((((-2147483648) ^ lo$1) < ((-2147483648) ^ lo)) ? ((1 + hi$2) | 0) : hi$2);
      var lo$2 = ((lo$1 + d) | 0);
      var hi$6 = ((((-2147483648) ^ lo$2) < ((-2147483648) ^ lo$1)) ? ((1 + hi$4) | 0) : hi$4);
      res.set(((arg1 + arg1$1) | 0), lo$2);
      elem = hi$6;
      i$1 = ((1 + i$1) | 0)
    };
    res.set(((arg1 + aLen) | 0), elem);
    i = ((1 + i) | 0)
  };
  $m_Ljava_math_BitLevel$().shiftLeftOneBit__AI__AI__I__V(res, res, (aLen << 1));
  elem = 0;
  var i$3 = 0;
  var index = 0;
  while ((i$3 < aLen)) {
    var a$2 = a.get(i$3);
    var b$1 = a.get(i$3);
    var c$1 = res.get(index);
    var d$1 = elem;
    var a0$1 = (65535 & a$2);
    var a1$1 = ((a$2 >>> 16) | 0);
    var b0$1 = (65535 & b$1);
    var b1$1 = ((b$1 >>> 16) | 0);
    var a0b0$1 = $imul(a0$1, b0$1);
    var a1b0$1 = $imul(a1$1, b0$1);
    var a0b1$1 = $imul(a0$1, b1$1);
    var lo$3 = ((a0b0$1 + (((a1b0$1 + a0b1$1) | 0) << 16)) | 0);
    var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
    var hi$9 = (((($imul(a1$1, b1$1) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
    var lo$4 = ((lo$3 + c$1) | 0);
    var hi$11 = ((((-2147483648) ^ lo$4) < ((-2147483648) ^ lo$3)) ? ((1 + hi$9) | 0) : hi$9);
    var lo$5 = ((lo$4 + d$1) | 0);
    var hi$13 = ((((-2147483648) ^ lo$5) < ((-2147483648) ^ lo$4)) ? ((1 + hi$11) | 0) : hi$11);
    res.set(index, lo$5);
    index = ((1 + index) | 0);
    var value = res.get(index);
    var lo$6 = ((hi$13 + value) | 0);
    var hi$15 = ((((-2147483648) ^ lo$6) < ((-2147483648) ^ hi$13)) ? 1 : 0);
    res.set(index, lo$6);
    elem = hi$15;
    i$3 = ((1 + i$3) | 0);
    index = ((1 + index) | 0)
  };
  return res
});
$c_Ljava_math_Multiplication$.prototype.karatsuba__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger = (function(val1, val2) {
  if ((val2.Ljava_math_BigInteger__f_numberLength > val1.Ljava_math_BigInteger__f_numberLength)) {
    var x1___1 = val2;
    var x1___2 = val1
  } else {
    var x1___1 = val1;
    var x1___2 = val2
  };
  var op1 = $as_Ljava_math_BigInteger(x1___1);
  var op2 = $as_Ljava_math_BigInteger(x1___2);
  if ((op2.Ljava_math_BigInteger__f_numberLength < 63)) {
    return this.multiplyPAP__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(op1, op2)
  } else {
    var ndiv2 = (((-2) & op1.Ljava_math_BigInteger__f_numberLength) << 4);
    var upperOp1 = op1.shiftRight__I__Ljava_math_BigInteger(ndiv2);
    var upperOp2 = op2.shiftRight__I__Ljava_math_BigInteger(ndiv2);
    var bi = upperOp1.shiftLeft__I__Ljava_math_BigInteger(ndiv2);
    var lowerOp1 = $m_Ljava_math_Elementary$().subtract__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(op1, bi);
    var bi$1 = upperOp2.shiftLeft__I__Ljava_math_BigInteger(ndiv2);
    var lowerOp2 = $m_Ljava_math_Elementary$().subtract__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(op2, bi$1);
    var upper = this.karatsuba__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(upperOp1, upperOp2);
    var lower = this.karatsuba__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(lowerOp1, lowerOp2);
    var middle = this.karatsuba__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger($m_Ljava_math_Elementary$().subtract__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(upperOp1, lowerOp1), $m_Ljava_math_Elementary$().subtract__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(lowerOp2, upperOp2));
    var this$1 = middle;
    var bi$2 = upper;
    var this$2 = $m_Ljava_math_Elementary$().add__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$1, bi$2);
    middle = $m_Ljava_math_Elementary$().add__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$2, lower);
    middle = middle.shiftLeft__I__Ljava_math_BigInteger(ndiv2);
    upper = upper.shiftLeft__I__Ljava_math_BigInteger((ndiv2 << 1));
    var this$3 = upper;
    var bi$3 = middle;
    var this$4 = $m_Ljava_math_Elementary$().add__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$3, bi$3);
    return $m_Ljava_math_Elementary$().add__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$4, lower)
  }
});
$c_Ljava_math_Multiplication$.prototype.multArraysPAP__AI__I__AI__I__AI__V = (function(aDigits, aLen, bDigits, bLen, resDigits) {
  if ((!((aLen === 0) || (bLen === 0)))) {
    if ((aLen === 1)) {
      resDigits.set(bLen, $p_Ljava_math_Multiplication$__multiplyByInt__AI__AI__I__I__I(this, resDigits, bDigits, bLen, aDigits.get(0)))
    } else if ((bLen === 1)) {
      resDigits.set(aLen, $p_Ljava_math_Multiplication$__multiplyByInt__AI__AI__I__I__I(this, resDigits, aDigits, aLen, bDigits.get(0)))
    } else {
      $p_Ljava_math_Multiplication$__multPAP__AI__AI__AI__I__I__V(this, aDigits, bDigits, resDigits, aLen, bLen)
    }
  }
});
$c_Ljava_math_Multiplication$.prototype.multiplyPAP__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger = (function(a, b) {
  var aLen = a.Ljava_math_BigInteger__f_numberLength;
  var bLen = b.Ljava_math_BigInteger__f_numberLength;
  var resLength = ((aLen + bLen) | 0);
  var resSign = ((a.Ljava_math_BigInteger__f_sign !== b.Ljava_math_BigInteger__f_sign) ? (-1) : 1);
  if ((resLength === 2)) {
    var a$1 = a.Ljava_math_BigInteger__f_digits.get(0);
    var b$1 = b.Ljava_math_BigInteger__f_digits.get(0);
    var a0 = (65535 & a$1);
    var a1 = ((a$1 >>> 16) | 0);
    var b0 = (65535 & b$1);
    var b1 = ((b$1 >>> 16) | 0);
    var a0b0 = $imul(a0, b0);
    var a1b0 = $imul(a1, b0);
    var a0b1 = $imul(a0, b1);
    var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$2 = (((($imul(a1, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
    return ((hi$2 === 0) ? $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), resSign, lo) : $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), resSign, 2, new $ac_I([lo, hi$2])))
  } else {
    var aDigits = a.Ljava_math_BigInteger__f_digits;
    var bDigits = b.Ljava_math_BigInteger__f_digits;
    var resDigits = new $ac_I(resLength);
    this.multArraysPAP__AI__I__AI__I__AI__V(aDigits, aLen, bDigits, bLen, resDigits);
    var result = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), resSign, resLength, resDigits);
    result.cutOffLeadingZeroes__V();
    return result
  }
});
$c_Ljava_math_Multiplication$.prototype.pow__Ljava_math_BigInteger__I__Ljava_math_BigInteger = (function(base, exponent) {
  var exp = exponent;
  var res = $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ONE;
  var acc = base;
  while ((exp > 1)) {
    var res2 = (((1 & exp) !== 0) ? res.multiply__Ljava_math_BigInteger__Ljava_math_BigInteger(acc) : res);
    if ((acc.Ljava_math_BigInteger__f_numberLength === 1)) {
      var acc2 = acc.multiply__Ljava_math_BigInteger__Ljava_math_BigInteger(acc)
    } else {
      var a = new $ac_I((acc.Ljava_math_BigInteger__f_numberLength << 1));
      var sq = this.square__AI__I__AI__AI(acc.Ljava_math_BigInteger__f_digits, acc.Ljava_math_BigInteger__f_numberLength, a);
      var acc2 = $ct_Ljava_math_BigInteger__I__AI__(new $c_Ljava_math_BigInteger(), 1, sq)
    };
    var temp$exp = (exp >> 1);
    exp = temp$exp;
    res = res2;
    acc = acc2
  };
  return res.multiply__Ljava_math_BigInteger__Ljava_math_BigInteger(acc)
});
$c_Ljava_math_Multiplication$.prototype.powerOf10__J__Ljava_math_BigInteger = (function(exp) {
  var value = this.Ljava_math_Multiplication$__f_BigTenPows.u.length;
  var hi = (value >> 31);
  var ahi = exp.RTLong__f_hi;
  if (((ahi === hi) ? (((-2147483648) ^ exp.RTLong__f_lo) < ((-2147483648) ^ value)) : (ahi < hi))) {
    return this.Ljava_math_Multiplication$__f_BigTenPows.get(exp.RTLong__f_lo)
  } else {
    var ahi$1 = exp.RTLong__f_hi;
    if (((ahi$1 === 0) ? (((-2147483648) ^ exp.RTLong__f_lo) <= (-2147483598)) : (ahi$1 < 0))) {
      return $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_TEN.pow__I__Ljava_math_BigInteger(exp.RTLong__f_lo)
    } else {
      var ahi$2 = exp.RTLong__f_hi;
      if (((ahi$2 === 0) ? (((-2147483648) ^ exp.RTLong__f_lo) <= (-1)) : (ahi$2 < 0))) {
        return this.Ljava_math_Multiplication$__f_BigFivePows.get(1).pow__I__Ljava_math_BigInteger(exp.RTLong__f_lo).shiftLeft__I__Ljava_math_BigInteger(exp.RTLong__f_lo)
      } else {
        var powerOfFive = this.Ljava_math_Multiplication$__f_BigFivePows.get(1).pow__I__Ljava_math_BigInteger(2147483647);
        var res = powerOfFive;
        var bhi = exp.RTLong__f_hi;
        var lo = (((-2147483647) + exp.RTLong__f_lo) | 0);
        var hi$1 = ((((-2147483648) ^ lo) < 1) ? bhi : (((-1) + bhi) | 0));
        var longExp__lo = lo;
        var longExp__hi = hi$1;
        var this$3 = $m_RTLong$();
        var lo$1 = this$3.remainderImpl__I__I__I__I__I(exp.RTLong__f_lo, exp.RTLong__f_hi, 2147483647, 0);
        while (true) {
          var this$4__lo = longExp__lo;
          var this$4__hi = longExp__hi;
          var ahi$3 = this$4__hi;
          if (((ahi$3 === 0) ? (((-2147483648) ^ this$4__lo) > (-1)) : (ahi$3 > 0))) {
            res = res.multiply__Ljava_math_BigInteger__Ljava_math_BigInteger(powerOfFive);
            var b__lo = longExp__lo;
            var b__hi = longExp__hi;
            var bhi$1 = b__hi;
            var lo$2 = (((-2147483647) + b__lo) | 0);
            var hi$3 = ((((-2147483648) ^ lo$2) < 1) ? bhi$1 : (((-1) + bhi$1) | 0));
            var $$x1__lo = lo$2;
            var $$x1__hi = hi$3;
            longExp__lo = $$x1__lo;
            longExp__hi = $$x1__hi
          } else {
            break
          }
        };
        res = res.multiply__Ljava_math_BigInteger__Ljava_math_BigInteger(this.Ljava_math_Multiplication$__f_BigFivePows.get(1).pow__I__Ljava_math_BigInteger(lo$1));
        res = res.shiftLeft__I__Ljava_math_BigInteger(2147483647);
        var bhi$2 = exp.RTLong__f_hi;
        var lo$3 = (((-2147483647) + exp.RTLong__f_lo) | 0);
        var hi$4 = ((((-2147483648) ^ lo$3) < 1) ? bhi$2 : (((-1) + bhi$2) | 0));
        var $$x2__lo = lo$3;
        var $$x2__hi = hi$4;
        longExp__lo = $$x2__lo;
        longExp__hi = $$x2__hi;
        while (true) {
          var this$7__lo = longExp__lo;
          var this$7__hi = longExp__hi;
          var ahi$4 = this$7__hi;
          if (((ahi$4 === 0) ? (((-2147483648) ^ this$7__lo) > (-1)) : (ahi$4 > 0))) {
            res = res.shiftLeft__I__Ljava_math_BigInteger(2147483647);
            var b$1__lo = longExp__lo;
            var b$1__hi = longExp__hi;
            var bhi$3 = b$1__hi;
            var lo$4 = (((-2147483647) + b$1__lo) | 0);
            var hi$5 = ((((-2147483648) ^ lo$4) < 1) ? bhi$3 : (((-1) + bhi$3) | 0));
            var $$x3__lo = lo$4;
            var $$x3__hi = hi$5;
            longExp__lo = $$x3__lo;
            longExp__hi = $$x3__hi
          } else {
            break
          }
        };
        return res.shiftLeft__I__Ljava_math_BigInteger(lo$1)
      }
    }
  }
});
var $d_Ljava_math_Multiplication$ = new $TypeData().initClass({
  Ljava_math_Multiplication$: 0
}, false, "java.math.Multiplication$", {
  Ljava_math_Multiplication$: 1,
  O: 1
});
$c_Ljava_math_Multiplication$.prototype.$classData = $d_Ljava_math_Multiplication$;
var $n_Ljava_math_Multiplication$;
function $m_Ljava_math_Multiplication$() {
  if ((!$n_Ljava_math_Multiplication$)) {
    $n_Ljava_math_Multiplication$ = new $c_Ljava_math_Multiplication$()
  };
  return $n_Ljava_math_Multiplication$
}
function $ct_Ljava_nio_Buffer__I__($thiz, _capacity) {
  $thiz.Ljava_nio_Buffer__f__capacity = _capacity;
  $thiz.Ljava_nio_Buffer__f__limit = $thiz.Ljava_nio_Buffer__f__capacity;
  $thiz.Ljava_nio_Buffer__f_java$nio$Buffer$$_position = 0;
  $thiz.Ljava_nio_Buffer__f__mark = (-1);
  return $thiz
}
/** @constructor */
function $c_Ljava_nio_Buffer() {
  this.Ljava_nio_Buffer__f__capacity = 0;
  this.Ljava_nio_Buffer__f__limit = 0;
  this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position = 0;
  this.Ljava_nio_Buffer__f__mark = 0
}
$c_Ljava_nio_Buffer.prototype = new $h_O();
$c_Ljava_nio_Buffer.prototype.constructor = $c_Ljava_nio_Buffer;
/** @constructor */
function $h_Ljava_nio_Buffer() {
  /*<skip>*/
}
$h_Ljava_nio_Buffer.prototype = $c_Ljava_nio_Buffer.prototype;
$c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer = (function(newPosition) {
  if (((newPosition < 0) || (newPosition > this.Ljava_nio_Buffer__f__limit))) {
    throw $ct_jl_IllegalArgumentException__(new $c_jl_IllegalArgumentException())
  };
  this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position = newPosition;
  if ((this.Ljava_nio_Buffer__f__mark > newPosition)) {
    this.Ljava_nio_Buffer__f__mark = (-1)
  };
  return this
});
$c_Ljava_nio_Buffer.prototype.limit__I__Ljava_nio_Buffer = (function(newLimit) {
  if (((newLimit < 0) || (newLimit > this.Ljava_nio_Buffer__f__capacity))) {
    throw $ct_jl_IllegalArgumentException__(new $c_jl_IllegalArgumentException())
  };
  this.Ljava_nio_Buffer__f__limit = newLimit;
  if ((this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position > newLimit)) {
    this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position = newLimit;
    if ((this.Ljava_nio_Buffer__f__mark > newLimit)) {
      this.Ljava_nio_Buffer__f__mark = (-1)
    }
  };
  return this
});
$c_Ljava_nio_Buffer.prototype.flip__Ljava_nio_Buffer = (function() {
  this.Ljava_nio_Buffer__f__mark = (-1);
  this.Ljava_nio_Buffer__f__limit = this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position;
  this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position = 0;
  return this
});
$c_Ljava_nio_Buffer.prototype.toString__T = (function() {
  return ((((((($objectClassName(this) + "[pos=") + this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) + " lim=") + this.Ljava_nio_Buffer__f__limit) + " cap=") + this.Ljava_nio_Buffer__f__capacity) + "]")
});
/** @constructor */
function $c_Ljava_nio_ByteBuffer$() {
  /*<skip>*/
}
$c_Ljava_nio_ByteBuffer$.prototype = new $h_O();
$c_Ljava_nio_ByteBuffer$.prototype.constructor = $c_Ljava_nio_ByteBuffer$;
/** @constructor */
function $h_Ljava_nio_ByteBuffer$() {
  /*<skip>*/
}
$h_Ljava_nio_ByteBuffer$.prototype = $c_Ljava_nio_ByteBuffer$.prototype;
$c_Ljava_nio_ByteBuffer$.prototype.allocate__I__Ljava_nio_ByteBuffer = (function(capacity) {
  var array = new $ac_B(capacity);
  var length = array.u.length;
  return $m_Ljava_nio_HeapByteBuffer$().wrap__AB__I__I__I__I__Z__Ljava_nio_ByteBuffer(array, 0, array.u.length, 0, length, false)
});
var $d_Ljava_nio_ByteBuffer$ = new $TypeData().initClass({
  Ljava_nio_ByteBuffer$: 0
}, false, "java.nio.ByteBuffer$", {
  Ljava_nio_ByteBuffer$: 1,
  O: 1
});
$c_Ljava_nio_ByteBuffer$.prototype.$classData = $d_Ljava_nio_ByteBuffer$;
var $n_Ljava_nio_ByteBuffer$;
function $m_Ljava_nio_ByteBuffer$() {
  if ((!$n_Ljava_nio_ByteBuffer$)) {
    $n_Ljava_nio_ByteBuffer$ = new $c_Ljava_nio_ByteBuffer$()
  };
  return $n_Ljava_nio_ByteBuffer$
}
/** @constructor */
function $c_Ljava_nio_CharBuffer$() {
  /*<skip>*/
}
$c_Ljava_nio_CharBuffer$.prototype = new $h_O();
$c_Ljava_nio_CharBuffer$.prototype.constructor = $c_Ljava_nio_CharBuffer$;
/** @constructor */
function $h_Ljava_nio_CharBuffer$() {
  /*<skip>*/
}
$h_Ljava_nio_CharBuffer$.prototype = $c_Ljava_nio_CharBuffer$.prototype;
$c_Ljava_nio_CharBuffer$.prototype.wrap__jl_CharSequence__I__I__Ljava_nio_CharBuffer = (function(csq, start, end) {
  return $m_Ljava_nio_StringCharBuffer$().wrap__jl_CharSequence__I__I__I__I__Ljava_nio_CharBuffer(csq, 0, $dp_length__I(csq), start, ((end - start) | 0))
});
var $d_Ljava_nio_CharBuffer$ = new $TypeData().initClass({
  Ljava_nio_CharBuffer$: 0
}, false, "java.nio.CharBuffer$", {
  Ljava_nio_CharBuffer$: 1,
  O: 1
});
$c_Ljava_nio_CharBuffer$.prototype.$classData = $d_Ljava_nio_CharBuffer$;
var $n_Ljava_nio_CharBuffer$;
function $m_Ljava_nio_CharBuffer$() {
  if ((!$n_Ljava_nio_CharBuffer$)) {
    $n_Ljava_nio_CharBuffer$ = new $c_Ljava_nio_CharBuffer$()
  };
  return $n_Ljava_nio_CharBuffer$
}
/** @constructor */
function $c_Ljava_nio_HeapByteBuffer$() {
  /*<skip>*/
}
$c_Ljava_nio_HeapByteBuffer$.prototype = new $h_O();
$c_Ljava_nio_HeapByteBuffer$.prototype.constructor = $c_Ljava_nio_HeapByteBuffer$;
/** @constructor */
function $h_Ljava_nio_HeapByteBuffer$() {
  /*<skip>*/
}
$h_Ljava_nio_HeapByteBuffer$.prototype = $c_Ljava_nio_HeapByteBuffer$.prototype;
$c_Ljava_nio_HeapByteBuffer$.prototype.wrap__AB__I__I__I__I__Z__Ljava_nio_ByteBuffer = (function(array, arrayOffset, capacity, initialPosition, initialLength, isReadOnly) {
  if ((((arrayOffset < 0) || (capacity < 0)) || (((arrayOffset + capacity) | 0) > array.u.length))) {
    throw $ct_jl_IndexOutOfBoundsException__(new $c_jl_IndexOutOfBoundsException())
  };
  var initialLimit = ((initialPosition + initialLength) | 0);
  if ((((initialPosition < 0) || (initialLength < 0)) || (initialLimit > capacity))) {
    throw $ct_jl_IndexOutOfBoundsException__(new $c_jl_IndexOutOfBoundsException())
  };
  return new $c_Ljava_nio_HeapByteBuffer(capacity, array, arrayOffset, initialPosition, initialLimit, isReadOnly)
});
var $d_Ljava_nio_HeapByteBuffer$ = new $TypeData().initClass({
  Ljava_nio_HeapByteBuffer$: 0
}, false, "java.nio.HeapByteBuffer$", {
  Ljava_nio_HeapByteBuffer$: 1,
  O: 1
});
$c_Ljava_nio_HeapByteBuffer$.prototype.$classData = $d_Ljava_nio_HeapByteBuffer$;
var $n_Ljava_nio_HeapByteBuffer$;
function $m_Ljava_nio_HeapByteBuffer$() {
  if ((!$n_Ljava_nio_HeapByteBuffer$)) {
    $n_Ljava_nio_HeapByteBuffer$ = new $c_Ljava_nio_HeapByteBuffer$()
  };
  return $n_Ljava_nio_HeapByteBuffer$
}
/** @constructor */
function $c_Ljava_nio_StringCharBuffer$() {
  /*<skip>*/
}
$c_Ljava_nio_StringCharBuffer$.prototype = new $h_O();
$c_Ljava_nio_StringCharBuffer$.prototype.constructor = $c_Ljava_nio_StringCharBuffer$;
/** @constructor */
function $h_Ljava_nio_StringCharBuffer$() {
  /*<skip>*/
}
$h_Ljava_nio_StringCharBuffer$.prototype = $c_Ljava_nio_StringCharBuffer$.prototype;
$c_Ljava_nio_StringCharBuffer$.prototype.wrap__jl_CharSequence__I__I__I__I__Ljava_nio_CharBuffer = (function(csq, csqOffset, capacity, initialPosition, initialLength) {
  if ((((csqOffset < 0) || (capacity < 0)) || (((csqOffset + capacity) | 0) > $dp_length__I(csq)))) {
    throw $ct_jl_IndexOutOfBoundsException__(new $c_jl_IndexOutOfBoundsException())
  };
  var initialLimit = ((initialPosition + initialLength) | 0);
  if ((((initialPosition < 0) || (initialLength < 0)) || (initialLimit > capacity))) {
    throw $ct_jl_IndexOutOfBoundsException__(new $c_jl_IndexOutOfBoundsException())
  };
  return new $c_Ljava_nio_StringCharBuffer(capacity, csq, csqOffset, initialPosition, initialLimit)
});
var $d_Ljava_nio_StringCharBuffer$ = new $TypeData().initClass({
  Ljava_nio_StringCharBuffer$: 0
}, false, "java.nio.StringCharBuffer$", {
  Ljava_nio_StringCharBuffer$: 1,
  O: 1
});
$c_Ljava_nio_StringCharBuffer$.prototype.$classData = $d_Ljava_nio_StringCharBuffer$;
var $n_Ljava_nio_StringCharBuffer$;
function $m_Ljava_nio_StringCharBuffer$() {
  if ((!$n_Ljava_nio_StringCharBuffer$)) {
    $n_Ljava_nio_StringCharBuffer$ = new $c_Ljava_nio_StringCharBuffer$()
  };
  return $n_Ljava_nio_StringCharBuffer$
}
function $p_Ljava_nio_charset_CharsetEncoder__grow$1__Ljava_nio_ByteBuffer__Ljava_nio_ByteBuffer($thiz, out) {
  if ((out.Ljava_nio_Buffer__f__capacity === 0)) {
    return $m_Ljava_nio_ByteBuffer$().allocate__I__Ljava_nio_ByteBuffer(1)
  } else {
    var result = $m_Ljava_nio_ByteBuffer$().allocate__I__Ljava_nio_ByteBuffer((out.Ljava_nio_Buffer__f__capacity << 1));
    $c_Ljava_nio_Buffer.prototype.flip__Ljava_nio_Buffer.call(out);
    result.put__Ljava_nio_ByteBuffer__Ljava_nio_ByteBuffer(out);
    return result
  }
}
function $ct_Ljava_nio_charset_CharsetEncoder__Ljava_nio_charset_Charset__F__F__AB__($thiz, cs, _averageBytesPerChar, _maxBytesPerChar, _replacement) {
  $thiz.Ljava_nio_charset_CharsetEncoder__f_cs = cs;
  $thiz.Ljava_nio_charset_CharsetEncoder__f__averageBytesPerChar = _averageBytesPerChar;
  $thiz.Ljava_nio_charset_CharsetEncoder__f__maxBytesPerChar = _maxBytesPerChar;
  $thiz.Ljava_nio_charset_CharsetEncoder__f__replacement = _replacement;
  $thiz.Ljava_nio_charset_CharsetEncoder__f__malformedInputAction = $m_Ljava_nio_charset_CodingErrorAction$().Ljava_nio_charset_CodingErrorAction$__f_REPORT;
  $thiz.Ljava_nio_charset_CharsetEncoder__f__unmappableCharacterAction = $m_Ljava_nio_charset_CodingErrorAction$().Ljava_nio_charset_CodingErrorAction$__f_REPORT;
  $thiz.Ljava_nio_charset_CharsetEncoder__f_status = 0;
  return $thiz
}
function $ct_Ljava_nio_charset_CharsetEncoder__Ljava_nio_charset_Charset__F__F__($thiz, cs, _averageBytesPerChar, _maxBytesPerChar) {
  $ct_Ljava_nio_charset_CharsetEncoder__Ljava_nio_charset_Charset__F__F__AB__($thiz, cs, _averageBytesPerChar, _maxBytesPerChar, new $ac_B([63]));
  return $thiz
}
/** @constructor */
function $c_Ljava_nio_charset_CharsetEncoder() {
  this.Ljava_nio_charset_CharsetEncoder__f_cs = null;
  this.Ljava_nio_charset_CharsetEncoder__f__averageBytesPerChar = 0.0;
  this.Ljava_nio_charset_CharsetEncoder__f__maxBytesPerChar = 0.0;
  this.Ljava_nio_charset_CharsetEncoder__f__replacement = null;
  this.Ljava_nio_charset_CharsetEncoder__f__malformedInputAction = null;
  this.Ljava_nio_charset_CharsetEncoder__f__unmappableCharacterAction = null;
  this.Ljava_nio_charset_CharsetEncoder__f_status = 0
}
$c_Ljava_nio_charset_CharsetEncoder.prototype = new $h_O();
$c_Ljava_nio_charset_CharsetEncoder.prototype.constructor = $c_Ljava_nio_charset_CharsetEncoder;
/** @constructor */
function $h_Ljava_nio_charset_CharsetEncoder() {
  /*<skip>*/
}
$h_Ljava_nio_charset_CharsetEncoder.prototype = $c_Ljava_nio_charset_CharsetEncoder.prototype;
$c_Ljava_nio_charset_CharsetEncoder.prototype.onMalformedInput__Ljava_nio_charset_CodingErrorAction__Ljava_nio_charset_CharsetEncoder = (function(newAction) {
  if ((newAction === null)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "null CodingErrorAction")
  };
  this.Ljava_nio_charset_CharsetEncoder__f__malformedInputAction = newAction;
  return this
});
$c_Ljava_nio_charset_CharsetEncoder.prototype.onUnmappableCharacter__Ljava_nio_charset_CodingErrorAction__Ljava_nio_charset_CharsetEncoder = (function(newAction) {
  if ((newAction === null)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "null CodingErrorAction")
  };
  this.Ljava_nio_charset_CharsetEncoder__f__unmappableCharacterAction = newAction;
  return this
});
$c_Ljava_nio_charset_CharsetEncoder.prototype.encode__Ljava_nio_CharBuffer__Ljava_nio_ByteBuffer__Z__Ljava_nio_charset_CoderResult = (function(in$1, out, endOfInput) {
  if (((this.Ljava_nio_charset_CharsetEncoder__f_status === 3) || ((!endOfInput) && (this.Ljava_nio_charset_CharsetEncoder__f_status === 2)))) {
    throw $ct_jl_IllegalStateException__(new $c_jl_IllegalStateException())
  };
  this.Ljava_nio_charset_CharsetEncoder__f_status = (endOfInput ? 2 : 1);
  while (true) {
    try {
      var result1 = this.encodeLoop__Ljava_nio_CharBuffer__Ljava_nio_ByteBuffer__Ljava_nio_charset_CoderResult(in$1, out)
    } catch (e) {
      var result1;
      if ((e instanceof $c_Ljava_nio_BufferOverflowException)) {
        var ex$2 = $as_Ljava_nio_BufferOverflowException(e);
        throw new $c_Ljava_nio_charset_CoderMalfunctionError(ex$2)
      } else if ((e instanceof $c_Ljava_nio_BufferUnderflowException)) {
        var ex = $as_Ljava_nio_BufferUnderflowException(e);
        throw new $c_Ljava_nio_charset_CoderMalfunctionError(ex)
      } else {
        throw e
      }
    };
    if ((result1.Ljava_nio_charset_CoderResult__f_java$nio$charset$CoderResult$$kind === 0)) {
      var remaining = ((in$1.Ljava_nio_Buffer__f__limit - in$1.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0);
      if ((endOfInput && (remaining > 0))) {
        var this$1 = $m_Ljava_nio_charset_CoderResult$();
        switch (remaining) {
          case 1: {
            var result2 = this$1.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed1;
            break
          }
          case 2: {
            var result2 = this$1.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed2;
            break
          }
          case 3: {
            var result2 = this$1.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed3;
            break
          }
          case 4: {
            var result2 = this$1.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed4;
            break
          }
          default: {
            var result2 = this$1.java$nio$charset$CoderResult$$malformedForLengthImpl__I__Ljava_nio_charset_CoderResult(remaining)
          }
        }
      } else {
        var result2 = result1
      }
    } else {
      var result2 = result1
    };
    if (((result2.Ljava_nio_charset_CoderResult__f_java$nio$charset$CoderResult$$kind === 0) || (result2.Ljava_nio_charset_CoderResult__f_java$nio$charset$CoderResult$$kind === 1))) {
      return result2
    } else {
      var action = ((result2.Ljava_nio_charset_CoderResult__f_java$nio$charset$CoderResult$$kind === 3) ? this.Ljava_nio_charset_CharsetEncoder__f__unmappableCharacterAction : this.Ljava_nio_charset_CharsetEncoder__f__malformedInputAction);
      var x = $m_Ljava_nio_charset_CodingErrorAction$().Ljava_nio_charset_CodingErrorAction$__f_REPLACE;
      if ((x === action)) {
        if ((((out.Ljava_nio_Buffer__f__limit - out.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0) < this.Ljava_nio_charset_CharsetEncoder__f__replacement.u.length)) {
          return $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_OVERFLOW
        } else {
          var src = this.Ljava_nio_charset_CharsetEncoder__f__replacement;
          out.put__AB__I__I__Ljava_nio_ByteBuffer(src, 0, src.u.length);
          var $$x1 = in$1.Ljava_nio_Buffer__f_java$nio$Buffer$$_position;
          var l = result2.Ljava_nio_charset_CoderResult__f_java$nio$charset$CoderResult$$_length;
          if ((l < 0)) {
            throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException())
          };
          var newPosition = (($$x1 + l) | 0);
          $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(in$1, newPosition)
        }
      } else {
        var x$3 = $m_Ljava_nio_charset_CodingErrorAction$().Ljava_nio_charset_CodingErrorAction$__f_REPORT;
        if ((x$3 === action)) {
          return result2
        } else {
          var x$5 = $m_Ljava_nio_charset_CodingErrorAction$().Ljava_nio_charset_CodingErrorAction$__f_IGNORE;
          if ((x$5 === action)) {
            var $$x2 = in$1.Ljava_nio_Buffer__f_java$nio$Buffer$$_position;
            var l$1 = result2.Ljava_nio_charset_CoderResult__f_java$nio$charset$CoderResult$$_length;
            if ((l$1 < 0)) {
              throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException())
            };
            var newPosition$1 = (($$x2 + l$1) | 0);
            $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(in$1, newPosition$1)
          } else {
            throw new $c_s_MatchError(action)
          }
        }
      }
    }
  }
});
$c_Ljava_nio_charset_CharsetEncoder.prototype.flush__Ljava_nio_ByteBuffer__Ljava_nio_charset_CoderResult = (function(out) {
  var x1 = this.Ljava_nio_charset_CharsetEncoder__f_status;
  switch (x1) {
    case 2: {
      var result = $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_UNDERFLOW;
      if ((result.Ljava_nio_charset_CoderResult__f_java$nio$charset$CoderResult$$kind === 0)) {
        this.Ljava_nio_charset_CharsetEncoder__f_status = 3
      };
      return result;
      break
    }
    case 3: {
      return $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_UNDERFLOW;
      break
    }
    default: {
      throw $ct_jl_IllegalStateException__(new $c_jl_IllegalStateException())
    }
  }
});
$c_Ljava_nio_charset_CharsetEncoder.prototype.reset__Ljava_nio_charset_CharsetEncoder = (function() {
  this.Ljava_nio_charset_CharsetEncoder__f_status = 0;
  return this
});
$c_Ljava_nio_charset_CharsetEncoder.prototype.encode__Ljava_nio_CharBuffer__Ljava_nio_ByteBuffer = (function(in$1) {
  if ((((in$1.Ljava_nio_Buffer__f__limit - in$1.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0) === 0)) {
    return $m_Ljava_nio_ByteBuffer$().allocate__I__Ljava_nio_ByteBuffer(0)
  } else {
    this.reset__Ljava_nio_charset_CharsetEncoder();
    var initLength = $doubleToInt($fround(($fround(((in$1.Ljava_nio_Buffer__f__limit - in$1.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0)) * this.Ljava_nio_charset_CharsetEncoder__f__averageBytesPerChar)));
    var out = $m_Ljava_nio_ByteBuffer$().allocate__I__Ljava_nio_ByteBuffer(initLength);
    var out$1;
    while (true) {
      var result = this.encode__Ljava_nio_CharBuffer__Ljava_nio_ByteBuffer__Z__Ljava_nio_charset_CoderResult(in$1, out, true);
      if ((result.Ljava_nio_charset_CoderResult__f_java$nio$charset$CoderResult$$kind !== 0)) {
        if ((result.Ljava_nio_charset_CoderResult__f_java$nio$charset$CoderResult$$kind === 1)) {
          out = $p_Ljava_nio_charset_CharsetEncoder__grow$1__Ljava_nio_ByteBuffer__Ljava_nio_ByteBuffer(this, out);
          continue
        };
        result.throwException__V();
        throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), "should not get here")
      };
      if ((in$1.Ljava_nio_Buffer__f_java$nio$Buffer$$_position !== in$1.Ljava_nio_Buffer__f__limit)) {
        throw $ct_jl_AssertionError__(new $c_jl_AssertionError())
      };
      var out$1 = out;
      break
    };
    var out$2;
    while (true) {
      var result$1 = this.flush__Ljava_nio_ByteBuffer__Ljava_nio_charset_CoderResult(out$1);
      if ((result$1.Ljava_nio_charset_CoderResult__f_java$nio$charset$CoderResult$$kind !== 0)) {
        if ((result$1.Ljava_nio_charset_CoderResult__f_java$nio$charset$CoderResult$$kind === 1)) {
          out$1 = $p_Ljava_nio_charset_CharsetEncoder__grow$1__Ljava_nio_ByteBuffer__Ljava_nio_ByteBuffer(this, out$1);
          continue
        };
        result$1.throwException__V();
        throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), "should not get here")
      };
      var out$2 = out$1;
      break
    };
    $c_Ljava_nio_Buffer.prototype.flip__Ljava_nio_Buffer.call(out$2);
    return out$2
  }
});
/** @constructor */
function $c_Ljava_nio_charset_CoderResult(kind, _length) {
  this.Ljava_nio_charset_CoderResult__f_java$nio$charset$CoderResult$$kind = 0;
  this.Ljava_nio_charset_CoderResult__f_java$nio$charset$CoderResult$$_length = 0;
  this.Ljava_nio_charset_CoderResult__f_java$nio$charset$CoderResult$$kind = kind;
  this.Ljava_nio_charset_CoderResult__f_java$nio$charset$CoderResult$$_length = _length
}
$c_Ljava_nio_charset_CoderResult.prototype = new $h_O();
$c_Ljava_nio_charset_CoderResult.prototype.constructor = $c_Ljava_nio_charset_CoderResult;
/** @constructor */
function $h_Ljava_nio_charset_CoderResult() {
  /*<skip>*/
}
$h_Ljava_nio_charset_CoderResult.prototype = $c_Ljava_nio_charset_CoderResult.prototype;
$c_Ljava_nio_charset_CoderResult.prototype.throwException__V = (function() {
  var x1 = this.Ljava_nio_charset_CoderResult__f_java$nio$charset$CoderResult$$kind;
  switch (x1) {
    case 1: {
      throw new $c_Ljava_nio_BufferOverflowException();
      break
    }
    case 0: {
      throw new $c_Ljava_nio_BufferUnderflowException();
      break
    }
    case 2: {
      throw new $c_Ljava_nio_charset_MalformedInputException(this.Ljava_nio_charset_CoderResult__f_java$nio$charset$CoderResult$$_length);
      break
    }
    case 3: {
      throw new $c_Ljava_nio_charset_UnmappableCharacterException(this.Ljava_nio_charset_CoderResult__f_java$nio$charset$CoderResult$$_length);
      break
    }
    default: {
      throw new $c_s_MatchError(x1)
    }
  }
});
function $as_Ljava_nio_charset_CoderResult(obj) {
  return (((obj instanceof $c_Ljava_nio_charset_CoderResult) || (obj === null)) ? obj : $throwClassCastException(obj, "java.nio.charset.CoderResult"))
}
function $isArrayOf_Ljava_nio_charset_CoderResult(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_nio_charset_CoderResult)))
}
function $asArrayOf_Ljava_nio_charset_CoderResult(obj, depth) {
  return (($isArrayOf_Ljava_nio_charset_CoderResult(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.nio.charset.CoderResult;", depth))
}
var $d_Ljava_nio_charset_CoderResult = new $TypeData().initClass({
  Ljava_nio_charset_CoderResult: 0
}, false, "java.nio.charset.CoderResult", {
  Ljava_nio_charset_CoderResult: 1,
  O: 1
});
$c_Ljava_nio_charset_CoderResult.prototype.$classData = $d_Ljava_nio_charset_CoderResult;
/** @constructor */
function $c_Ljava_nio_charset_CoderResult$() {
  this.Ljava_nio_charset_CoderResult$__f_OVERFLOW = null;
  this.Ljava_nio_charset_CoderResult$__f_UNDERFLOW = null;
  this.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed1 = null;
  this.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed2 = null;
  this.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed3 = null;
  this.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed4 = null;
  this.Ljava_nio_charset_CoderResult$__f_uniqueMalformed = null;
  this.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Unmappable1 = null;
  this.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Unmappable2 = null;
  this.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Unmappable3 = null;
  this.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Unmappable4 = null;
  this.Ljava_nio_charset_CoderResult$__f_uniqueUnmappable = null;
  $n_Ljava_nio_charset_CoderResult$ = this;
  this.Ljava_nio_charset_CoderResult$__f_OVERFLOW = new $c_Ljava_nio_charset_CoderResult(1, (-1));
  this.Ljava_nio_charset_CoderResult$__f_UNDERFLOW = new $c_Ljava_nio_charset_CoderResult(0, (-1));
  this.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed1 = new $c_Ljava_nio_charset_CoderResult(2, 1);
  this.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed2 = new $c_Ljava_nio_charset_CoderResult(2, 2);
  this.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed3 = new $c_Ljava_nio_charset_CoderResult(2, 3);
  this.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed4 = new $c_Ljava_nio_charset_CoderResult(2, 4);
  this.Ljava_nio_charset_CoderResult$__f_uniqueMalformed = [];
  this.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Unmappable1 = new $c_Ljava_nio_charset_CoderResult(3, 1);
  this.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Unmappable2 = new $c_Ljava_nio_charset_CoderResult(3, 2);
  this.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Unmappable3 = new $c_Ljava_nio_charset_CoderResult(3, 3);
  this.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Unmappable4 = new $c_Ljava_nio_charset_CoderResult(3, 4);
  this.Ljava_nio_charset_CoderResult$__f_uniqueUnmappable = []
}
$c_Ljava_nio_charset_CoderResult$.prototype = new $h_O();
$c_Ljava_nio_charset_CoderResult$.prototype.constructor = $c_Ljava_nio_charset_CoderResult$;
/** @constructor */
function $h_Ljava_nio_charset_CoderResult$() {
  /*<skip>*/
}
$h_Ljava_nio_charset_CoderResult$.prototype = $c_Ljava_nio_charset_CoderResult$.prototype;
$c_Ljava_nio_charset_CoderResult$.prototype.java$nio$charset$CoderResult$$malformedForLengthImpl__I__Ljava_nio_charset_CoderResult = (function(length) {
  var value = this.Ljava_nio_charset_CoderResult$__f_uniqueMalformed[length];
  if ((value === (void 0))) {
    var result = new $c_Ljava_nio_charset_CoderResult(2, length);
    $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_uniqueMalformed[length] = result;
    return result
  } else {
    var result$1 = $as_Ljava_nio_charset_CoderResult(value);
    return result$1
  }
});
var $d_Ljava_nio_charset_CoderResult$ = new $TypeData().initClass({
  Ljava_nio_charset_CoderResult$: 0
}, false, "java.nio.charset.CoderResult$", {
  Ljava_nio_charset_CoderResult$: 1,
  O: 1
});
$c_Ljava_nio_charset_CoderResult$.prototype.$classData = $d_Ljava_nio_charset_CoderResult$;
var $n_Ljava_nio_charset_CoderResult$;
function $m_Ljava_nio_charset_CoderResult$() {
  if ((!$n_Ljava_nio_charset_CoderResult$)) {
    $n_Ljava_nio_charset_CoderResult$ = new $c_Ljava_nio_charset_CoderResult$()
  };
  return $n_Ljava_nio_charset_CoderResult$
}
/** @constructor */
function $c_Ljava_nio_charset_CodingErrorAction(name) {
  this.Ljava_nio_charset_CodingErrorAction__f_name = null;
  this.Ljava_nio_charset_CodingErrorAction__f_name = name
}
$c_Ljava_nio_charset_CodingErrorAction.prototype = new $h_O();
$c_Ljava_nio_charset_CodingErrorAction.prototype.constructor = $c_Ljava_nio_charset_CodingErrorAction;
/** @constructor */
function $h_Ljava_nio_charset_CodingErrorAction() {
  /*<skip>*/
}
$h_Ljava_nio_charset_CodingErrorAction.prototype = $c_Ljava_nio_charset_CodingErrorAction.prototype;
$c_Ljava_nio_charset_CodingErrorAction.prototype.toString__T = (function() {
  return this.Ljava_nio_charset_CodingErrorAction__f_name
});
var $d_Ljava_nio_charset_CodingErrorAction = new $TypeData().initClass({
  Ljava_nio_charset_CodingErrorAction: 0
}, false, "java.nio.charset.CodingErrorAction", {
  Ljava_nio_charset_CodingErrorAction: 1,
  O: 1
});
$c_Ljava_nio_charset_CodingErrorAction.prototype.$classData = $d_Ljava_nio_charset_CodingErrorAction;
/** @constructor */
function $c_Ljava_nio_charset_CodingErrorAction$() {
  this.Ljava_nio_charset_CodingErrorAction$__f_IGNORE = null;
  this.Ljava_nio_charset_CodingErrorAction$__f_REPLACE = null;
  this.Ljava_nio_charset_CodingErrorAction$__f_REPORT = null;
  $n_Ljava_nio_charset_CodingErrorAction$ = this;
  this.Ljava_nio_charset_CodingErrorAction$__f_IGNORE = new $c_Ljava_nio_charset_CodingErrorAction("IGNORE");
  this.Ljava_nio_charset_CodingErrorAction$__f_REPLACE = new $c_Ljava_nio_charset_CodingErrorAction("REPLACE");
  this.Ljava_nio_charset_CodingErrorAction$__f_REPORT = new $c_Ljava_nio_charset_CodingErrorAction("REPORT")
}
$c_Ljava_nio_charset_CodingErrorAction$.prototype = new $h_O();
$c_Ljava_nio_charset_CodingErrorAction$.prototype.constructor = $c_Ljava_nio_charset_CodingErrorAction$;
/** @constructor */
function $h_Ljava_nio_charset_CodingErrorAction$() {
  /*<skip>*/
}
$h_Ljava_nio_charset_CodingErrorAction$.prototype = $c_Ljava_nio_charset_CodingErrorAction$.prototype;
var $d_Ljava_nio_charset_CodingErrorAction$ = new $TypeData().initClass({
  Ljava_nio_charset_CodingErrorAction$: 0
}, false, "java.nio.charset.CodingErrorAction$", {
  Ljava_nio_charset_CodingErrorAction$: 1,
  O: 1
});
$c_Ljava_nio_charset_CodingErrorAction$.prototype.$classData = $d_Ljava_nio_charset_CodingErrorAction$;
var $n_Ljava_nio_charset_CodingErrorAction$;
function $m_Ljava_nio_charset_CodingErrorAction$() {
  if ((!$n_Ljava_nio_charset_CodingErrorAction$)) {
    $n_Ljava_nio_charset_CodingErrorAction$ = new $c_Ljava_nio_charset_CodingErrorAction$()
  };
  return $n_Ljava_nio_charset_CodingErrorAction$
}
/** @constructor */
function $c_ju_Arrays$() {
  /*<skip>*/
}
$c_ju_Arrays$.prototype = new $h_O();
$c_ju_Arrays$.prototype.constructor = $c_ju_Arrays$;
/** @constructor */
function $h_ju_Arrays$() {
  /*<skip>*/
}
$h_ju_Arrays$.prototype = $c_ju_Arrays$.prototype;
$c_ju_Arrays$.prototype.binarySearch__AJ__J__I = (function(a, key) {
  var startIndex = 0;
  var endIndex = a.u.length;
  while (true) {
    if ((startIndex === endIndex)) {
      return (((-1) - startIndex) | 0)
    } else {
      var mid = ((((startIndex + endIndex) | 0) >>> 1) | 0);
      var t = a.get(mid);
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      var t$1 = $uJ(new $c_RTLong(lo, hi));
      var lo$1 = t$1.RTLong__f_lo;
      var hi$1 = t$1.RTLong__f_hi;
      var ahi = key.RTLong__f_hi;
      if (((ahi === hi$1) ? (((-2147483648) ^ key.RTLong__f_lo) < ((-2147483648) ^ lo$1)) : (ahi < hi$1))) {
        endIndex = mid
      } else if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, new $c_RTLong(lo, hi))) {
        return mid
      } else {
        startIndex = ((1 + mid) | 0)
      }
    }
  }
});
$c_ju_Arrays$.prototype.binarySearch__AI__I__I = (function(a, key) {
  var startIndex = 0;
  var endIndex = a.u.length;
  while (true) {
    if ((startIndex === endIndex)) {
      return (((-1) - startIndex) | 0)
    } else {
      var mid = ((((startIndex + endIndex) | 0) >>> 1) | 0);
      var elem = a.get(mid);
      if ((key < elem)) {
        endIndex = mid
      } else if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, elem)) {
        return mid
      } else {
        startIndex = ((1 + mid) | 0)
      }
    }
  }
});
$c_ju_Arrays$.prototype.equals__AJ__AJ__Z = (function(a, b) {
  if ((a === b)) {
    return true
  };
  if (((a === null) || (b === null))) {
    return false
  };
  var len = a.u.length;
  if ((b.u.length !== len)) {
    return false
  };
  var i = 0;
  while ((i !== len)) {
    var t = a.get(i);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var t$1 = b.get(i);
    var lo$1 = t$1.RTLong__f_lo;
    var hi$1 = t$1.RTLong__f_hi;
    if ((!$m_sr_BoxesRunTime$().equals__O__O__Z(new $c_RTLong(lo, hi), new $c_RTLong(lo$1, hi$1)))) {
      return false
    };
    i = ((1 + i) | 0)
  };
  return true
});
$c_ju_Arrays$.prototype.equals__AI__AI__Z = (function(a, b) {
  if ((a === b)) {
    return true
  };
  if (((a === null) || (b === null))) {
    return false
  };
  var len = a.u.length;
  if ((b.u.length !== len)) {
    return false
  };
  var i = 0;
  while ((i !== len)) {
    var x = a.get(i);
    var y = b.get(i);
    if ((!$m_sr_BoxesRunTime$().equals__O__O__Z(x, y))) {
      return false
    };
    i = ((1 + i) | 0)
  };
  return true
});
$c_ju_Arrays$.prototype.equals__AS__AS__Z = (function(a, b) {
  if ((a === b)) {
    return true
  };
  if (((a === null) || (b === null))) {
    return false
  };
  var len = a.u.length;
  if ((b.u.length !== len)) {
    return false
  };
  var i = 0;
  while ((i !== len)) {
    var x = a.get(i);
    var y = b.get(i);
    if ((!$m_sr_BoxesRunTime$().equals__O__O__Z(x, y))) {
      return false
    };
    i = ((1 + i) | 0)
  };
  return true
});
$c_ju_Arrays$.prototype.equals__AC__AC__Z = (function(a, b) {
  if ((a === b)) {
    return true
  };
  if (((a === null) || (b === null))) {
    return false
  };
  var len = a.u.length;
  if ((b.u.length !== len)) {
    return false
  };
  var i = 0;
  while ((i !== len)) {
    var x = a.get(i);
    var y = b.get(i);
    if ((!$m_sr_BoxesRunTime$().equals__O__O__Z($bC(x), $bC(y)))) {
      return false
    };
    i = ((1 + i) | 0)
  };
  return true
});
$c_ju_Arrays$.prototype.equals__AB__AB__Z = (function(a, b) {
  if ((a === b)) {
    return true
  };
  if (((a === null) || (b === null))) {
    return false
  };
  var len = a.u.length;
  if ((b.u.length !== len)) {
    return false
  };
  var i = 0;
  while ((i !== len)) {
    var x = a.get(i);
    var y = b.get(i);
    if ((!$m_sr_BoxesRunTime$().equals__O__O__Z(x, y))) {
      return false
    };
    i = ((1 + i) | 0)
  };
  return true
});
$c_ju_Arrays$.prototype.equals__AZ__AZ__Z = (function(a, b) {
  if ((a === b)) {
    return true
  };
  if (((a === null) || (b === null))) {
    return false
  };
  var len = a.u.length;
  if ((b.u.length !== len)) {
    return false
  };
  var i = 0;
  while ((i !== len)) {
    var x = a.get(i);
    var y = b.get(i);
    if ((!$m_sr_BoxesRunTime$().equals__O__O__Z(x, y))) {
      return false
    };
    i = ((1 + i) | 0)
  };
  return true
});
$c_ju_Arrays$.prototype.equals__AD__AD__Z = (function(a, b) {
  if ((a === b)) {
    return true
  };
  if (((a === null) || (b === null))) {
    return false
  };
  var len = a.u.length;
  if ((b.u.length !== len)) {
    return false
  };
  var i = 0;
  while ((i !== len)) {
    var x = a.get(i);
    var y = b.get(i);
    if ((!$m_sr_BoxesRunTime$().equals__O__O__Z(x, y))) {
      return false
    };
    i = ((1 + i) | 0)
  };
  return true
});
$c_ju_Arrays$.prototype.equals__AF__AF__Z = (function(a, b) {
  if ((a === b)) {
    return true
  };
  if (((a === null) || (b === null))) {
    return false
  };
  var len = a.u.length;
  if ((b.u.length !== len)) {
    return false
  };
  var i = 0;
  while ((i !== len)) {
    var x = a.get(i);
    var y = b.get(i);
    if ((!$m_sr_BoxesRunTime$().equals__O__O__Z(x, y))) {
      return false
    };
    i = ((1 + i) | 0)
  };
  return true
});
$c_ju_Arrays$.prototype.copyOf__AO__I__AO = (function(original, newLength) {
  var tagT = $m_s_reflect_ClassTag$().apply__jl_Class__s_reflect_ClassTag($objectGetClass(original).getComponentType__jl_Class());
  if ((newLength < 0)) {
    throw new $c_jl_NegativeArraySizeException()
  };
  var b = original.u.length;
  var copyLength = ((newLength < b) ? newLength : b);
  var ret = tagT.newArray__I__O(newLength);
  $systemArraycopy(original, 0, ret, 0, copyLength);
  return $asArrayOf_O(ret, 1)
});
$c_ju_Arrays$.prototype.copyOfRange__AO__I__I__AO = (function(original, from, to) {
  var evidence$6 = $m_s_reflect_ClassTag$().apply__jl_Class__s_reflect_ClassTag($objectGetClass(original).getComponentType__jl_Class());
  if ((from > to)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((from + " > ") + to))
  };
  var retLength = ((to - from) | 0);
  var b = ((original.u.length - from) | 0);
  var copyLength = ((retLength < b) ? retLength : b);
  var ret = evidence$6.newArray__I__O(retLength);
  $systemArraycopy(original, from, ret, 0, copyLength);
  return $asArrayOf_O(ret, 1)
});
var $d_ju_Arrays$ = new $TypeData().initClass({
  ju_Arrays$: 0
}, false, "java.util.Arrays$", {
  ju_Arrays$: 1,
  O: 1
});
$c_ju_Arrays$.prototype.$classData = $d_ju_Arrays$;
var $n_ju_Arrays$;
function $m_ju_Arrays$() {
  if ((!$n_ju_Arrays$)) {
    $n_ju_Arrays$ = new $c_ju_Arrays$()
  };
  return $n_ju_Arrays$
}
function $is_ju_Formattable(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.ju_Formattable)))
}
function $as_ju_Formattable(obj) {
  return (($is_ju_Formattable(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.util.Formattable"))
}
function $isArrayOf_ju_Formattable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_Formattable)))
}
function $asArrayOf_ju_Formattable(obj, depth) {
  return (($isArrayOf_ju_Formattable(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.util.Formattable;", depth))
}
/** @constructor */
function $c_ju_Formatter$() {
  this.ju_Formatter$__f_java$util$Formatter$$FormatSpecifier = null;
  this.ju_Formatter$__f_java$util$Formatter$$ConversionsIllegalFlags = null;
  $n_ju_Formatter$ = this;
  this.ju_Formatter$__f_java$util$Formatter$$FormatSpecifier = new RegExp("(?:(\\d+)\\$)?([-#+ 0,\\(<]*)(\\d+)?(?:\\.(\\d+))?[%A-Za-z]", "g");
  this.ju_Formatter$__f_java$util$Formatter$$ConversionsIllegalFlags = new $ac_I([96, 126, 638, 770, 32, 256, 2, 126, (-1), (-1), (-1), (-1), (-1), (-1), 800, (-1), (-1), (-1), 124, (-1), (-1), (-1), (-1), 544, (-1), (-1)])
}
$c_ju_Formatter$.prototype = new $h_O();
$c_ju_Formatter$.prototype.constructor = $c_ju_Formatter$;
/** @constructor */
function $h_ju_Formatter$() {
  /*<skip>*/
}
$h_ju_Formatter$.prototype = $c_ju_Formatter$.prototype;
$c_ju_Formatter$.prototype.java$util$Formatter$$strOfZeros__I__T = (function(count) {
  if ((count <= 20)) {
    return $as_T("00000000000000000000".substring(0, count))
  } else {
    var result = "";
    var remaining = count;
    while ((remaining > 20)) {
      result = (result + "00000000000000000000");
      remaining = (((-20) + remaining) | 0)
    };
    var $$x1 = result;
    var endIndex = remaining;
    return (("" + $$x1) + $as_T("00000000000000000000".substring(0, endIndex)))
  }
});
$c_ju_Formatter$.prototype.java$util$Formatter$$numberToDecimal__D__ju_Formatter$Decimal = (function(x) {
  if ((x === 0.0)) {
    var negative = ((1.0 / x) < 0.0);
    return new $c_ju_Formatter$Decimal(negative, "0", 0)
  } else {
    var negative$2 = (x < 0.0);
    var d = (negative$2 ? (-x) : x);
    var s = ("" + d);
    var ePos = $f_T__indexOf__I__I(s, 101);
    if ((ePos < 0)) {
      var e = 0
    } else {
      var $$x2 = parseInt;
      var beginIndex = ((1 + ePos) | 0);
      var s$1 = $as_T(s.substring(beginIndex));
      var $$x1 = $$x2(s$1);
      var e = $uI($$x1)
    };
    var significandEnd = ((ePos < 0) ? $uI(s.length) : ePos);
    var dotPos = $f_T__indexOf__I__I(s, 46);
    if ((dotPos < 0)) {
      var unscaledValue = $as_T(s.substring(0, significandEnd));
      var scale = ((-e) | 0);
      return new $c_ju_Formatter$Decimal(negative$2, unscaledValue, scale)
    } else {
      var $$x3 = $as_T(s.substring(0, dotPos));
      var beginIndex$1 = ((1 + dotPos) | 0);
      var digits = (("" + $$x3) + $as_T(s.substring(beginIndex$1, significandEnd)));
      var digitsLen = $uI(digits.length);
      var i = 0;
      while (true) {
        if ((i < digitsLen)) {
          var index = i;
          var $$x4 = ((65535 & $uI(digits.charCodeAt(index))) === 48)
        } else {
          var $$x4 = false
        };
        if ($$x4) {
          i = ((1 + i) | 0)
        } else {
          break
        }
      };
      var beginIndex$2 = i;
      var unscaledValue$2 = $as_T(digits.substring(beginIndex$2));
      var scale$2 = ((((-e) | 0) + ((significandEnd - ((1 + dotPos) | 0)) | 0)) | 0);
      return new $c_ju_Formatter$Decimal(negative$2, unscaledValue$2, scale$2)
    }
  }
});
$c_ju_Formatter$.prototype.java$util$Formatter$$bigDecimalToDecimal__Ljava_math_BigDecimal__ju_Formatter$Decimal = (function(x) {
  var this$1 = x.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
  var unscaledValueWithSign = $m_Ljava_math_Conversion$().toDecimalScaledString__Ljava_math_BigInteger__T(this$1);
  if ((unscaledValueWithSign === "0")) {
    return new $c_ju_Formatter$Decimal(false, "0", 0)
  } else {
    var negative = ((65535 & $uI(unscaledValueWithSign.charCodeAt(0))) === 45);
    var unscaledValue = (negative ? $as_T(unscaledValueWithSign.substring(1)) : unscaledValueWithSign);
    var scale = x.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
    return new $c_ju_Formatter$Decimal(negative, unscaledValue, scale)
  }
});
var $d_ju_Formatter$ = new $TypeData().initClass({
  ju_Formatter$: 0
}, false, "java.util.Formatter$", {
  ju_Formatter$: 1,
  O: 1
});
$c_ju_Formatter$.prototype.$classData = $d_ju_Formatter$;
var $n_ju_Formatter$;
function $m_ju_Formatter$() {
  if ((!$n_ju_Formatter$)) {
    $n_ju_Formatter$ = new $c_ju_Formatter$()
  };
  return $n_ju_Formatter$
}
function $p_ju_Formatter$Decimal__roundAtPos__I__ju_Formatter$Decimal($thiz, roundingPos) {
  var digits = $thiz.ju_Formatter$Decimal__f_unscaledValue;
  var digitsLen = $uI(digits.length);
  if ((roundingPos < 0)) {
    var negative = $thiz.ju_Formatter$Decimal__f_negative;
    return new $c_ju_Formatter$Decimal(negative, "0", 0)
  } else if ((roundingPos >= digitsLen)) {
    return $thiz
  } else if (((65535 & $uI(digits.charCodeAt(roundingPos))) < 53)) {
    if ((roundingPos === 0)) {
      var negative$1 = $thiz.ju_Formatter$Decimal__f_negative;
      return new $c_ju_Formatter$Decimal(negative$1, "0", 0)
    } else {
      return new $c_ju_Formatter$Decimal($thiz.ju_Formatter$Decimal__f_negative, $as_T(digits.substring(0, roundingPos)), (($thiz.ju_Formatter$Decimal__f_scale - ((digitsLen - roundingPos) | 0)) | 0))
    }
  } else {
    var lastNonNinePos = (((-1) + roundingPos) | 0);
    while (true) {
      if ((lastNonNinePos >= 0)) {
        var index = lastNonNinePos;
        var $$x1 = ((65535 & $uI(digits.charCodeAt(index))) === 57)
      } else {
        var $$x1 = false
      };
      if ($$x1) {
        lastNonNinePos = (((-1) + lastNonNinePos) | 0)
      } else {
        break
      }
    };
    if ((lastNonNinePos < 0)) {
      var newUnscaledValue = "1"
    } else {
      var endIndex = lastNonNinePos;
      var $$x2 = $as_T(digits.substring(0, endIndex));
      var index$1 = lastNonNinePos;
      var newUnscaledValue = (("" + $$x2) + $bC((65535 & ((1 + (65535 & $uI(digits.charCodeAt(index$1)))) | 0))))
    };
    var pos = ((1 + lastNonNinePos) | 0);
    var newScale = (($thiz.ju_Formatter$Decimal__f_scale - ((digitsLen - pos) | 0)) | 0);
    return new $c_ju_Formatter$Decimal($thiz.ju_Formatter$Decimal__f_negative, newUnscaledValue, newScale)
  }
}
/** @constructor */
function $c_ju_Formatter$Decimal(negative, unscaledValue, scale) {
  this.ju_Formatter$Decimal__f_negative = false;
  this.ju_Formatter$Decimal__f_unscaledValue = null;
  this.ju_Formatter$Decimal__f_scale = 0;
  this.ju_Formatter$Decimal__f_negative = negative;
  this.ju_Formatter$Decimal__f_unscaledValue = unscaledValue;
  this.ju_Formatter$Decimal__f_scale = scale
}
$c_ju_Formatter$Decimal.prototype = new $h_O();
$c_ju_Formatter$Decimal.prototype.constructor = $c_ju_Formatter$Decimal;
/** @constructor */
function $h_ju_Formatter$Decimal() {
  /*<skip>*/
}
$h_ju_Formatter$Decimal.prototype = $c_ju_Formatter$Decimal.prototype;
$c_ju_Formatter$Decimal.prototype.isZero__Z = (function() {
  return (this.ju_Formatter$Decimal__f_unscaledValue === "0")
});
$c_ju_Formatter$Decimal.prototype.round__I__ju_Formatter$Decimal = (function(precision) {
  $m_ju_Formatter$();
  var condition = (precision > 0);
  if ((!condition)) {
    throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), "Decimal.round() called with non-positive precision")
  };
  return $p_ju_Formatter$Decimal__roundAtPos__I__ju_Formatter$Decimal(this, precision)
});
$c_ju_Formatter$Decimal.prototype.setScale__I__ju_Formatter$Decimal = (function(newScale) {
  var this$1 = this.ju_Formatter$Decimal__f_unscaledValue;
  var roundingPos = (((($uI(this$1.length) + newScale) | 0) - this.ju_Formatter$Decimal__f_scale) | 0);
  var rounded = $p_ju_Formatter$Decimal__roundAtPos__I__ju_Formatter$Decimal(this, roundingPos);
  $m_ju_Formatter$();
  var condition = (rounded.isZero__Z() || (rounded.ju_Formatter$Decimal__f_scale <= newScale));
  if ((!condition)) {
    throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), "roundAtPos returned a non-zero value with a scale too large")
  };
  return ((rounded.isZero__Z() || (rounded.ju_Formatter$Decimal__f_scale === newScale)) ? rounded : new $c_ju_Formatter$Decimal(this.ju_Formatter$Decimal__f_negative, (("" + rounded.ju_Formatter$Decimal__f_unscaledValue) + $m_ju_Formatter$().java$util$Formatter$$strOfZeros__I__T(((newScale - rounded.ju_Formatter$Decimal__f_scale) | 0))), newScale))
});
$c_ju_Formatter$Decimal.prototype.toString__T = (function() {
  return (((((("Decimal(" + this.ju_Formatter$Decimal__f_negative) + ", ") + this.ju_Formatter$Decimal__f_unscaledValue) + ", ") + this.ju_Formatter$Decimal__f_scale) + ")")
});
var $d_ju_Formatter$Decimal = new $TypeData().initClass({
  ju_Formatter$Decimal: 0
}, false, "java.util.Formatter$Decimal", {
  ju_Formatter$Decimal: 1,
  O: 1
});
$c_ju_Formatter$Decimal.prototype.$classData = $d_ju_Formatter$Decimal;
/** @constructor */
function $c_ju_Formatter$LocaleInfo() {
  /*<skip>*/
}
$c_ju_Formatter$LocaleInfo.prototype = new $h_O();
$c_ju_Formatter$LocaleInfo.prototype.constructor = $c_ju_Formatter$LocaleInfo;
/** @constructor */
function $h_ju_Formatter$LocaleInfo() {
  /*<skip>*/
}
$h_ju_Formatter$LocaleInfo.prototype = $c_ju_Formatter$LocaleInfo.prototype;
function $is_ju_Map(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.ju_Map)))
}
function $as_ju_Map(obj) {
  return (($is_ju_Map(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.util.Map"))
}
function $isArrayOf_ju_Map(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_Map)))
}
function $asArrayOf_ju_Map(obj, depth) {
  return (($isArrayOf_ju_Map(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.util.Map;", depth))
}
function $is_ju_Map$Entry(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.ju_Map$Entry)))
}
function $as_ju_Map$Entry(obj) {
  return (($is_ju_Map$Entry(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.util.Map$Entry"))
}
function $isArrayOf_ju_Map$Entry(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_Map$Entry)))
}
function $asArrayOf_ju_Map$Entry(obj, depth) {
  return (($isArrayOf_ju_Map$Entry(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.util.Map$Entry;", depth))
}
/** @constructor */
function $c_Lplay_api_libs_functional_FunctionalBuilder(canBuild) {
  this.Lplay_api_libs_functional_FunctionalBuilder__f_play$api$libs$functional$FunctionalBuilder$$canBuild = null;
  this.Lplay_api_libs_functional_FunctionalBuilder__f_play$api$libs$functional$FunctionalBuilder$$canBuild = canBuild
}
$c_Lplay_api_libs_functional_FunctionalBuilder.prototype = new $h_O();
$c_Lplay_api_libs_functional_FunctionalBuilder.prototype.constructor = $c_Lplay_api_libs_functional_FunctionalBuilder;
/** @constructor */
function $h_Lplay_api_libs_functional_FunctionalBuilder() {
  /*<skip>*/
}
$h_Lplay_api_libs_functional_FunctionalBuilder.prototype = $c_Lplay_api_libs_functional_FunctionalBuilder.prototype;
var $d_Lplay_api_libs_functional_FunctionalBuilder = new $TypeData().initClass({
  Lplay_api_libs_functional_FunctionalBuilder: 0
}, false, "play.api.libs.functional.FunctionalBuilder", {
  Lplay_api_libs_functional_FunctionalBuilder: 1,
  O: 1
});
$c_Lplay_api_libs_functional_FunctionalBuilder.prototype.$classData = $d_Lplay_api_libs_functional_FunctionalBuilder;
/** @constructor */
function $c_Lplay_api_libs_functional_FunctionalBuilder$CanBuild2(outer, m1, m2) {
  this.Lplay_api_libs_functional_FunctionalBuilder$CanBuild2__f_m1 = null;
  this.Lplay_api_libs_functional_FunctionalBuilder$CanBuild2__f_m2 = null;
  this.Lplay_api_libs_functional_FunctionalBuilder$CanBuild2__f_$outer = null;
  this.Lplay_api_libs_functional_FunctionalBuilder$CanBuild2__f_m1 = m1;
  this.Lplay_api_libs_functional_FunctionalBuilder$CanBuild2__f_m2 = m2;
  if ((outer === null)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(null)
  } else {
    this.Lplay_api_libs_functional_FunctionalBuilder$CanBuild2__f_$outer = outer
  }
}
$c_Lplay_api_libs_functional_FunctionalBuilder$CanBuild2.prototype = new $h_O();
$c_Lplay_api_libs_functional_FunctionalBuilder$CanBuild2.prototype.constructor = $c_Lplay_api_libs_functional_FunctionalBuilder$CanBuild2;
/** @constructor */
function $h_Lplay_api_libs_functional_FunctionalBuilder$CanBuild2() {
  /*<skip>*/
}
$h_Lplay_api_libs_functional_FunctionalBuilder$CanBuild2.prototype = $c_Lplay_api_libs_functional_FunctionalBuilder$CanBuild2.prototype;
$c_Lplay_api_libs_functional_FunctionalBuilder$CanBuild2.prototype.$tilde__O__Lplay_api_libs_functional_FunctionalBuilder$CanBuild3 = (function(m3) {
  return new $c_Lplay_api_libs_functional_FunctionalBuilder$CanBuild3(this.Lplay_api_libs_functional_FunctionalBuilder$CanBuild2__f_$outer, this.Lplay_api_libs_functional_FunctionalBuilder$CanBuild2__f_$outer.Lplay_api_libs_functional_FunctionalBuilder__f_play$api$libs$functional$FunctionalBuilder$$canBuild.apply__O__O__O(this.Lplay_api_libs_functional_FunctionalBuilder$CanBuild2__f_m1, this.Lplay_api_libs_functional_FunctionalBuilder$CanBuild2__f_m2), m3)
});
var $d_Lplay_api_libs_functional_FunctionalBuilder$CanBuild2 = new $TypeData().initClass({
  Lplay_api_libs_functional_FunctionalBuilder$CanBuild2: 0
}, false, "play.api.libs.functional.FunctionalBuilder$CanBuild2", {
  Lplay_api_libs_functional_FunctionalBuilder$CanBuild2: 1,
  O: 1
});
$c_Lplay_api_libs_functional_FunctionalBuilder$CanBuild2.prototype.$classData = $d_Lplay_api_libs_functional_FunctionalBuilder$CanBuild2;
/** @constructor */
function $c_Lplay_api_libs_functional_FunctionalBuilder$CanBuild3(outer, m1, m2) {
  this.Lplay_api_libs_functional_FunctionalBuilder$CanBuild3__f_m1 = null;
  this.Lplay_api_libs_functional_FunctionalBuilder$CanBuild3__f_m2 = null;
  this.Lplay_api_libs_functional_FunctionalBuilder$CanBuild3__f_$outer = null;
  this.Lplay_api_libs_functional_FunctionalBuilder$CanBuild3__f_m1 = m1;
  this.Lplay_api_libs_functional_FunctionalBuilder$CanBuild3__f_m2 = m2;
  if ((outer === null)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(null)
  } else {
    this.Lplay_api_libs_functional_FunctionalBuilder$CanBuild3__f_$outer = outer
  }
}
$c_Lplay_api_libs_functional_FunctionalBuilder$CanBuild3.prototype = new $h_O();
$c_Lplay_api_libs_functional_FunctionalBuilder$CanBuild3.prototype.constructor = $c_Lplay_api_libs_functional_FunctionalBuilder$CanBuild3;
/** @constructor */
function $h_Lplay_api_libs_functional_FunctionalBuilder$CanBuild3() {
  /*<skip>*/
}
$h_Lplay_api_libs_functional_FunctionalBuilder$CanBuild3.prototype = $c_Lplay_api_libs_functional_FunctionalBuilder$CanBuild3.prototype;
$c_Lplay_api_libs_functional_FunctionalBuilder$CanBuild3.prototype.apply__F3__F1__Lplay_api_libs_functional_InvariantFunctor__O = (function(f1, f2, fu) {
  return fu.inmap__O__F1__F1__O(this.Lplay_api_libs_functional_FunctionalBuilder$CanBuild3__f_$outer.Lplay_api_libs_functional_FunctionalBuilder__f_play$api$libs$functional$FunctionalBuilder$$canBuild.apply__O__O__O(this.Lplay_api_libs_functional_FunctionalBuilder$CanBuild3__f_m1, this.Lplay_api_libs_functional_FunctionalBuilder$CanBuild3__f_m2), new $c_sjsr_AnonFunction1((function(this$1, f1$1) {
    return (function(x0$1$2) {
      var x0$1 = $as_Lplay_api_libs_functional_$tilde(x0$1$2);
      if ((x0$1 !== null)) {
        var p2 = $as_Lplay_api_libs_functional_$tilde(x0$1.Lplay_api_libs_functional_$tilde__f__1);
        var a3 = x0$1.Lplay_api_libs_functional_$tilde__f__2;
        if ((p2 !== null)) {
          var a1 = p2.Lplay_api_libs_functional_$tilde__f__1;
          var a2 = p2.Lplay_api_libs_functional_$tilde__f__2;
          return f1$1.apply__O__O__O__O(a1, a2, a3)
        }
      };
      throw new $c_s_MatchError(x0$1)
    })
  })(this, f1)), new $c_sjsr_AnonFunction1((function(this$2, f2$1) {
    return (function(b$2) {
      var x1 = $as_T3(f2$1.apply__O__O(b$2));
      if ((x1 === null)) {
        throw new $c_s_MatchError(x1)
      };
      var a1$1 = x1.T3__f__1;
      var a2$1 = x1.T3__f__2;
      var a3$1 = x1.T3__f__3;
      return new $c_Lplay_api_libs_functional_$tilde(new $c_Lplay_api_libs_functional_$tilde(a1$1, a2$1), a3$1)
    })
  })(this, f2)))
});
var $d_Lplay_api_libs_functional_FunctionalBuilder$CanBuild3 = new $TypeData().initClass({
  Lplay_api_libs_functional_FunctionalBuilder$CanBuild3: 0
}, false, "play.api.libs.functional.FunctionalBuilder$CanBuild3", {
  Lplay_api_libs_functional_FunctionalBuilder$CanBuild3: 1,
  O: 1
});
$c_Lplay_api_libs_functional_FunctionalBuilder$CanBuild3.prototype.$classData = $d_Lplay_api_libs_functional_FunctionalBuilder$CanBuild3;
/** @constructor */
function $c_Lplay_api_libs_functional_FunctionalBuilderOps(ma, fcb) {
  this.Lplay_api_libs_functional_FunctionalBuilderOps__f_ma = null;
  this.Lplay_api_libs_functional_FunctionalBuilderOps__f_fcb = null;
  this.Lplay_api_libs_functional_FunctionalBuilderOps__f_ma = ma;
  this.Lplay_api_libs_functional_FunctionalBuilderOps__f_fcb = fcb
}
$c_Lplay_api_libs_functional_FunctionalBuilderOps.prototype = new $h_O();
$c_Lplay_api_libs_functional_FunctionalBuilderOps.prototype.constructor = $c_Lplay_api_libs_functional_FunctionalBuilderOps;
/** @constructor */
function $h_Lplay_api_libs_functional_FunctionalBuilderOps() {
  /*<skip>*/
}
$h_Lplay_api_libs_functional_FunctionalBuilderOps.prototype = $c_Lplay_api_libs_functional_FunctionalBuilderOps.prototype;
$c_Lplay_api_libs_functional_FunctionalBuilderOps.prototype.$tilde__O__Lplay_api_libs_functional_FunctionalBuilder$CanBuild2 = (function(mb) {
  var b = new $c_Lplay_api_libs_functional_FunctionalBuilder(this.Lplay_api_libs_functional_FunctionalBuilderOps__f_fcb);
  return new $c_Lplay_api_libs_functional_FunctionalBuilder$CanBuild2(b, this.Lplay_api_libs_functional_FunctionalBuilderOps__f_ma, mb)
});
var $d_Lplay_api_libs_functional_FunctionalBuilderOps = new $TypeData().initClass({
  Lplay_api_libs_functional_FunctionalBuilderOps: 0
}, false, "play.api.libs.functional.FunctionalBuilderOps", {
  Lplay_api_libs_functional_FunctionalBuilderOps: 1,
  O: 1
});
$c_Lplay_api_libs_functional_FunctionalBuilderOps.prototype.$classData = $d_Lplay_api_libs_functional_FunctionalBuilderOps;
/** @constructor */
function $c_Lplay_api_libs_json_JsLookupResult$() {
  this.Lplay_api_libs_json_JsLookupResult$__f_PathMissing = null;
  $n_Lplay_api_libs_json_JsLookupResult$ = this;
  var err = new $c_sjsr_AnonFunction0((function(this$1) {
    return (function() {
      return "error.path.missing"
    })
  })(this));
  this.Lplay_api_libs_json_JsLookupResult$__f_PathMissing = new $c_Lplay_api_libs_json_JsUndefined(err)
}
$c_Lplay_api_libs_json_JsLookupResult$.prototype = new $h_O();
$c_Lplay_api_libs_json_JsLookupResult$.prototype.constructor = $c_Lplay_api_libs_json_JsLookupResult$;
/** @constructor */
function $h_Lplay_api_libs_json_JsLookupResult$() {
  /*<skip>*/
}
$h_Lplay_api_libs_json_JsLookupResult$.prototype = $c_Lplay_api_libs_json_JsLookupResult$.prototype;
var $d_Lplay_api_libs_json_JsLookupResult$ = new $TypeData().initClass({
  Lplay_api_libs_json_JsLookupResult$: 0
}, false, "play.api.libs.json.JsLookupResult$", {
  Lplay_api_libs_json_JsLookupResult$: 1,
  O: 1
});
$c_Lplay_api_libs_json_JsLookupResult$.prototype.$classData = $d_Lplay_api_libs_json_JsLookupResult$;
var $n_Lplay_api_libs_json_JsLookupResult$;
function $m_Lplay_api_libs_json_JsLookupResult$() {
  if ((!$n_Lplay_api_libs_json_JsLookupResult$)) {
    $n_Lplay_api_libs_json_JsLookupResult$ = new $c_Lplay_api_libs_json_JsLookupResult$()
  };
  return $n_Lplay_api_libs_json_JsLookupResult$
}
function $is_Lplay_api_libs_json_JsResult(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lplay_api_libs_json_JsResult)))
}
function $as_Lplay_api_libs_json_JsResult(obj) {
  return (($is_Lplay_api_libs_json_JsResult(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "play.api.libs.json.JsResult"))
}
function $isArrayOf_Lplay_api_libs_json_JsResult(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lplay_api_libs_json_JsResult)))
}
function $asArrayOf_Lplay_api_libs_json_JsResult(obj, depth) {
  return (($isArrayOf_Lplay_api_libs_json_JsResult(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lplay.api.libs.json.JsResult;", depth))
}
/** @constructor */
function $c_Lplay_api_libs_json_JsResult$() {
  this.Lplay_api_libs_json_JsResult$__f_applicativeJsResult = null;
  this.Lplay_api_libs_json_JsResult$__f_functorJsResult = null;
  $n_Lplay_api_libs_json_JsResult$ = this;
  this.Lplay_api_libs_json_JsResult$__f_applicativeJsResult = new $c_Lplay_api_libs_json_JsResult$$anon$2();
  this.Lplay_api_libs_json_JsResult$__f_functorJsResult = new $c_Lplay_api_libs_json_JsResult$$anon$3()
}
$c_Lplay_api_libs_json_JsResult$.prototype = new $h_O();
$c_Lplay_api_libs_json_JsResult$.prototype.constructor = $c_Lplay_api_libs_json_JsResult$;
/** @constructor */
function $h_Lplay_api_libs_json_JsResult$() {
  /*<skip>*/
}
$h_Lplay_api_libs_json_JsResult$.prototype = $c_Lplay_api_libs_json_JsResult$.prototype;
$c_Lplay_api_libs_json_JsResult$.prototype.fromTry__s_util_Try__F1__Lplay_api_libs_json_JsResult = (function(result, err) {
  if ((result instanceof $c_s_util_Success)) {
    var x2 = $as_s_util_Success(result);
    var v = x2.s_util_Success__f_value;
    return new $c_Lplay_api_libs_json_JsSuccess(v, $ct_Lplay_api_libs_json_JsPath__sci_List__(new $c_Lplay_api_libs_json_JsPath(), ($m_Lplay_api_libs_json_JsPath$(), $m_sci_Nil$())))
  } else if ((result instanceof $c_s_util_Failure)) {
    var x3 = $as_s_util_Failure(result);
    var e = x3.s_util_Failure__f_exception;
    return $as_Lplay_api_libs_json_JsResult(err.apply__O__O(e))
  } else {
    throw new $c_s_MatchError(result)
  }
});
$c_Lplay_api_libs_json_JsResult$.prototype.fromTry$default$2__F1 = (function() {
  return new $c_sjsr_AnonFunction1((function(this$1) {
    return (function(e$2) {
      var e = $as_jl_Throwable(e$2);
      return $m_Lplay_api_libs_json_JsError$().apply__T__Lplay_api_libs_json_JsError(e.getMessage__T())
    })
  })(this))
});
$c_Lplay_api_libs_json_JsResult$.prototype.repath__sc_Seq__Lplay_api_libs_json_JsPath__sc_Seq = (function(errors, path) {
  return $as_sc_Seq(errors.map__F1__O(new $c_sjsr_AnonFunction1((function(this$1, path$1) {
    return (function(x0$1$2) {
      var x0$1 = $as_T2(x0$1$2);
      if ((x0$1 !== null)) {
        var p = $as_Lplay_api_libs_json_JsPath(x0$1._1__O());
        var s = $as_sc_Seq(x0$1._2__O());
        var self = path$1.compose__Lplay_api_libs_json_JsPath__Lplay_api_libs_json_JsPath(p);
        return new $c_T2(self, s)
      } else {
        throw new $c_s_MatchError(x0$1)
      }
    })
  })(this, path))))
});
var $d_Lplay_api_libs_json_JsResult$ = new $TypeData().initClass({
  Lplay_api_libs_json_JsResult$: 0
}, false, "play.api.libs.json.JsResult$", {
  Lplay_api_libs_json_JsResult$: 1,
  O: 1
});
$c_Lplay_api_libs_json_JsResult$.prototype.$classData = $d_Lplay_api_libs_json_JsResult$;
var $n_Lplay_api_libs_json_JsResult$;
function $m_Lplay_api_libs_json_JsResult$() {
  if ((!$n_Lplay_api_libs_json_JsResult$)) {
    $n_Lplay_api_libs_json_JsResult$ = new $c_Lplay_api_libs_json_JsResult$()
  };
  return $n_Lplay_api_libs_json_JsResult$
}
/** @constructor */
function $c_Lplay_api_libs_json_JsonConfiguration$() {
  this.Lplay_api_libs_json_JsonConfiguration$__f_defaultDiscriminator = null;
  this.Lplay_api_libs_json_JsonConfiguration$__f_defaultDiscriminator = "_type"
}
$c_Lplay_api_libs_json_JsonConfiguration$.prototype = new $h_O();
$c_Lplay_api_libs_json_JsonConfiguration$.prototype.constructor = $c_Lplay_api_libs_json_JsonConfiguration$;
/** @constructor */
function $h_Lplay_api_libs_json_JsonConfiguration$() {
  /*<skip>*/
}
$h_Lplay_api_libs_json_JsonConfiguration$.prototype = $c_Lplay_api_libs_json_JsonConfiguration$.prototype;
var $d_Lplay_api_libs_json_JsonConfiguration$ = new $TypeData().initClass({
  Lplay_api_libs_json_JsonConfiguration$: 0
}, false, "play.api.libs.json.JsonConfiguration$", {
  Lplay_api_libs_json_JsonConfiguration$: 1,
  O: 1
});
$c_Lplay_api_libs_json_JsonConfiguration$.prototype.$classData = $d_Lplay_api_libs_json_JsonConfiguration$;
var $n_Lplay_api_libs_json_JsonConfiguration$;
function $m_Lplay_api_libs_json_JsonConfiguration$() {
  if ((!$n_Lplay_api_libs_json_JsonConfiguration$)) {
    $n_Lplay_api_libs_json_JsonConfiguration$ = new $c_Lplay_api_libs_json_JsonConfiguration$()
  };
  return $n_Lplay_api_libs_json_JsonConfiguration$
}
/** @constructor */
function $c_Lplay_api_libs_json_OFormat$() {
  this.Lplay_api_libs_json_OFormat$__f_invariantFunctorOFormat = null;
  $n_Lplay_api_libs_json_OFormat$ = this;
  this.Lplay_api_libs_json_OFormat$__f_invariantFunctorOFormat = new $c_Lplay_api_libs_json_OFormat$$anon$2()
}
$c_Lplay_api_libs_json_OFormat$.prototype = new $h_O();
$c_Lplay_api_libs_json_OFormat$.prototype.constructor = $c_Lplay_api_libs_json_OFormat$;
/** @constructor */
function $h_Lplay_api_libs_json_OFormat$() {
  /*<skip>*/
}
$h_Lplay_api_libs_json_OFormat$.prototype = $c_Lplay_api_libs_json_OFormat$.prototype;
var $d_Lplay_api_libs_json_OFormat$ = new $TypeData().initClass({
  Lplay_api_libs_json_OFormat$: 0
}, false, "play.api.libs.json.OFormat$", {
  Lplay_api_libs_json_OFormat$: 1,
  O: 1
});
$c_Lplay_api_libs_json_OFormat$.prototype.$classData = $d_Lplay_api_libs_json_OFormat$;
var $n_Lplay_api_libs_json_OFormat$;
function $m_Lplay_api_libs_json_OFormat$() {
  if ((!$n_Lplay_api_libs_json_OFormat$)) {
    $n_Lplay_api_libs_json_OFormat$ = new $c_Lplay_api_libs_json_OFormat$()
  };
  return $n_Lplay_api_libs_json_OFormat$
}
/** @constructor */
function $c_Lplay_api_libs_json_OWrites$MergedOWrites$() {
  /*<skip>*/
}
$c_Lplay_api_libs_json_OWrites$MergedOWrites$.prototype = new $h_O();
$c_Lplay_api_libs_json_OWrites$MergedOWrites$.prototype.constructor = $c_Lplay_api_libs_json_OWrites$MergedOWrites$;
/** @constructor */
function $h_Lplay_api_libs_json_OWrites$MergedOWrites$() {
  /*<skip>*/
}
$h_Lplay_api_libs_json_OWrites$MergedOWrites$.prototype = $c_Lplay_api_libs_json_OWrites$MergedOWrites$.prototype;
var $d_Lplay_api_libs_json_OWrites$MergedOWrites$ = new $TypeData().initClass({
  Lplay_api_libs_json_OWrites$MergedOWrites$: 0
}, false, "play.api.libs.json.OWrites$MergedOWrites$", {
  Lplay_api_libs_json_OWrites$MergedOWrites$: 1,
  O: 1
});
$c_Lplay_api_libs_json_OWrites$MergedOWrites$.prototype.$classData = $d_Lplay_api_libs_json_OWrites$MergedOWrites$;
var $n_Lplay_api_libs_json_OWrites$MergedOWrites$;
function $m_Lplay_api_libs_json_OWrites$MergedOWrites$() {
  if ((!$n_Lplay_api_libs_json_OWrites$MergedOWrites$)) {
    $n_Lplay_api_libs_json_OWrites$MergedOWrites$ = new $c_Lplay_api_libs_json_OWrites$MergedOWrites$()
  };
  return $n_Lplay_api_libs_json_OWrites$MergedOWrites$
}
function $f_Lplay_api_libs_json_OptionHandlers__formatHandler__Lplay_api_libs_json_JsPath__Lplay_api_libs_json_Format__Lplay_api_libs_json_OFormat($thiz, jsPath, format) {
  $m_Lplay_api_libs_json_OFormat$();
  var this$1 = $m_Lplay_api_libs_json_Reads$();
  var r = $f_Lplay_api_libs_json_PathReads__nullable__Lplay_api_libs_json_JsPath__Lplay_api_libs_json_Reads__Lplay_api_libs_json_Reads(this$1, jsPath, format);
  var this$2 = $m_Lplay_api_libs_json_Writes$();
  var w = $f_Lplay_api_libs_json_PathWrites__nullable__Lplay_api_libs_json_JsPath__Lplay_api_libs_json_Writes__Lplay_api_libs_json_OWrites(this$2, jsPath, format);
  return new $c_Lplay_api_libs_json_OFormat$$anon$4(r, w)
}
function $f_Lplay_api_libs_json_PathFormat__at__Lplay_api_libs_json_JsPath__Lplay_api_libs_json_Format__Lplay_api_libs_json_OFormat($thiz, path, f) {
  $m_Lplay_api_libs_json_OFormat$();
  var this$1 = $m_Lplay_api_libs_json_Reads$();
  var r = $f_Lplay_api_libs_json_PathReads__at__Lplay_api_libs_json_JsPath__Lplay_api_libs_json_Reads__Lplay_api_libs_json_Reads(this$1, path, f);
  var this$2 = $m_Lplay_api_libs_json_Writes$();
  var w = $f_Lplay_api_libs_json_PathWrites__at__Lplay_api_libs_json_JsPath__Lplay_api_libs_json_Writes__Lplay_api_libs_json_OWrites(this$2, path, f);
  return new $c_Lplay_api_libs_json_OFormat$$anon$4(r, w)
}
function $is_Lplay_api_libs_json_PathNode(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lplay_api_libs_json_PathNode)))
}
function $as_Lplay_api_libs_json_PathNode(obj) {
  return (($is_Lplay_api_libs_json_PathNode(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "play.api.libs.json.PathNode"))
}
function $isArrayOf_Lplay_api_libs_json_PathNode(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lplay_api_libs_json_PathNode)))
}
function $asArrayOf_Lplay_api_libs_json_PathNode(obj, depth) {
  return (($isArrayOf_Lplay_api_libs_json_PathNode(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lplay.api.libs.json.PathNode;", depth))
}
function $f_Lplay_api_libs_json_PathReads__at__Lplay_api_libs_json_JsPath__Lplay_api_libs_json_Reads__Lplay_api_libs_json_Reads($thiz, path, reads) {
  $m_Lplay_api_libs_json_Reads$();
  var f = new $c_sjsr_AnonFunction1((function(this$1, path$1, reads$1) {
    return (function(js$2) {
      var js = $as_Lplay_api_libs_json_JsValue(js$2);
      return path$1.asSingleJsResult__Lplay_api_libs_json_JsValue__Lplay_api_libs_json_JsResult(js).flatMap__F1__Lplay_api_libs_json_JsResult(new $c_sjsr_AnonFunction1((function(this$2, reads$1$1, path$1$1) {
        return (function(x$1$2) {
          var x$1 = $as_Lplay_api_libs_json_JsValue(x$1$2);
          return reads$1$1.reads__Lplay_api_libs_json_JsValue__Lplay_api_libs_json_JsResult(x$1).repath__Lplay_api_libs_json_JsPath__Lplay_api_libs_json_JsResult(path$1$1)
        })
      })(this$1, reads$1, path$1)))
    })
  })($thiz, path, reads));
  return new $c_Lplay_api_libs_json_Reads$$anon$6(f)
}
function $f_Lplay_api_libs_json_PathReads__nullable__Lplay_api_libs_json_JsPath__Lplay_api_libs_json_Reads__Lplay_api_libs_json_Reads($thiz, path, reads) {
  var defaultValue = new $c_sjsr_AnonFunction0((function(this$1) {
    return (function() {
      return $m_s_None$()
    })
  })($thiz));
  return $f_Lplay_api_libs_json_PathReads__nullableWithDefault__Lplay_api_libs_json_JsPath__F0__Lplay_api_libs_json_Reads__Lplay_api_libs_json_Reads($thiz, path, defaultValue, reads)
}
function $f_Lplay_api_libs_json_PathReads__nullableWithDefault__Lplay_api_libs_json_JsPath__F0__Lplay_api_libs_json_Reads__Lplay_api_libs_json_Reads($thiz, path, defaultValue, reads) {
  $m_Lplay_api_libs_json_Reads$();
  var f = new $c_sjsr_AnonFunction1((function(this$1, path$1, reads$1, defaultValue$1) {
    return (function(json$2) {
      var json = $as_Lplay_api_libs_json_JsValue(json$2);
      var rc9 = false;
      var x2 = null;
      var x1 = path$1.asSingleJson__Lplay_api_libs_json_JsValue__Lplay_api_libs_json_JsLookupResult(json);
      if ((x1 instanceof $c_Lplay_api_libs_json_JsDefined)) {
        rc9 = true;
        x2 = ((x1 === null) ? null : $as_Lplay_api_libs_json_JsDefined(x1).Lplay_api_libs_json_JsDefined__f_value);
        var p3 = x2;
        var x = $m_Lplay_api_libs_json_JsNull$();
        if ((x === p3)) {
          return new $c_Lplay_api_libs_json_JsSuccess($m_s_None$(), $ct_Lplay_api_libs_json_JsPath__sci_List__(new $c_Lplay_api_libs_json_JsPath(), ($m_Lplay_api_libs_json_JsPath$(), $m_sci_Nil$())))
        }
      };
      if (rc9) {
        var value = x2;
        return reads$1.reads__Lplay_api_libs_json_JsValue__Lplay_api_libs_json_JsResult(value).repath__Lplay_api_libs_json_JsPath__Lplay_api_libs_json_JsResult(path$1).map__F1__Lplay_api_libs_json_JsResult(new $c_sjsr_AnonFunction1((function(this$4) {
          return (function(x$3$2) {
            return new $c_s_Some(x$3$2)
          })
        })(this$1)))
      };
      if ((x1 !== null)) {
        if ((x1 instanceof $c_Lplay_api_libs_json_JsUndefined)) {
          return new $c_Lplay_api_libs_json_JsSuccess(defaultValue$1.apply__O(), $ct_Lplay_api_libs_json_JsPath__sci_List__(new $c_Lplay_api_libs_json_JsPath(), ($m_Lplay_api_libs_json_JsPath$(), $m_sci_Nil$())))
        }
      };
      throw new $c_s_MatchError(x1)
    })
  })($thiz, path, reads, defaultValue));
  return new $c_Lplay_api_libs_json_Reads$$anon$6(f)
}
function $f_Lplay_api_libs_json_PathWrites__at__Lplay_api_libs_json_JsPath__Lplay_api_libs_json_Writes__Lplay_api_libs_json_OWrites($thiz, path, wrs) {
  $m_Lplay_api_libs_json_OWrites$();
  var f = new $c_sjsr_AnonFunction1((function(this$1, path$1, wrs$1) {
    return (function(a$2) {
      var $$x1 = $m_Lplay_api_libs_json_JsPath$();
      var y = wrs$1.writes__O__Lplay_api_libs_json_JsValue(a$2);
      var array = [new $c_T2(path$1, y)];
      return $$x1.createObj__sci_Seq__Lplay_api_libs_json_JsObject($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
    })
  })($thiz, path, wrs));
  return new $c_Lplay_api_libs_json_OWrites$$anon$4(f)
}
function $f_Lplay_api_libs_json_PathWrites__nullable__Lplay_api_libs_json_JsPath__Lplay_api_libs_json_Writes__Lplay_api_libs_json_OWrites($thiz, path, wrs) {
  $m_Lplay_api_libs_json_OWrites$();
  var f = new $c_sjsr_AnonFunction1((function(this$1, path$1, wrs$1) {
    return (function(x0$1$2) {
      var x0$1 = $as_s_Option(x0$1$2);
      if ((x0$1 instanceof $c_s_Some)) {
        var x2 = $as_s_Some(x0$1);
        var a = x2.s_Some__f_value;
        var $$x1 = $m_Lplay_api_libs_json_JsPath$();
        var y = wrs$1.writes__O__Lplay_api_libs_json_JsValue(a);
        var array = [new $c_T2(path$1, y)];
        return $$x1.createObj__sci_Seq__Lplay_api_libs_json_JsObject($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
      } else {
        var x = $m_s_None$();
        if ((x === x0$1)) {
          return $m_Lplay_api_libs_json_JsObject$().apply__sc_Seq__Lplay_api_libs_json_JsObject($as_sc_Seq($m_sc_Seq$().empty__sc_SeqOps()))
        } else {
          throw new $c_s_MatchError(x0$1)
        }
      }
    })
  })($thiz, path, wrs));
  return new $c_Lplay_api_libs_json_OWrites$$anon$4(f)
}
function $f_Lplay_api_libs_json_Reads__map__F1__Lplay_api_libs_json_Reads($thiz, f) {
  $m_Lplay_api_libs_json_Reads$();
  var f$2 = new $c_sjsr_AnonFunction1((function(this$1, f$1) {
    return (function(x$1$2) {
      var x$1 = $as_Lplay_api_libs_json_JsValue(x$1$2);
      return this$1.reads__Lplay_api_libs_json_JsValue__Lplay_api_libs_json_JsResult(x$1).map__F1__Lplay_api_libs_json_JsResult(f$1)
    })
  })($thiz, f));
  return new $c_Lplay_api_libs_json_Reads$$anon$6(f$2)
}
function $is_Lplay_api_libs_json_Reads(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lplay_api_libs_json_Reads)))
}
function $as_Lplay_api_libs_json_Reads(obj) {
  return (($is_Lplay_api_libs_json_Reads(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "play.api.libs.json.Reads"))
}
function $isArrayOf_Lplay_api_libs_json_Reads(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lplay_api_libs_json_Reads)))
}
function $asArrayOf_Lplay_api_libs_json_Reads(obj, depth) {
  return (($isArrayOf_Lplay_api_libs_json_Reads(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lplay.api.libs.json.Reads;", depth))
}
function $p_Lplay_api_libs_json_StaticBinding$__str$1__Lplay_api_libs_json_JsValue__Z__I__F1__Z__T__T3__T($thiz, jsValue$1, escapeNonASCII$1, ilevel$1, indent$1, newline$1, fieldValueSep$1, arraySep$1) {
  var x = $m_Lplay_api_libs_json_JsNull$();
  if ((x === jsValue$1)) {
    return "null"
  } else if ((jsValue$1 instanceof $c_Lplay_api_libs_json_JsString)) {
    var x2 = $as_Lplay_api_libs_json_JsString(jsValue$1);
    var s = x2.Lplay_api_libs_json_JsString__f_value;
    return ((!escapeNonASCII$1) ? $as_T(JSON.stringify(s)) : $thiz.play$api$libs$json$StaticBinding$$escapeStr__T__T($as_T(JSON.stringify(s))))
  } else if ((jsValue$1 instanceof $c_Lplay_api_libs_json_JsNumber)) {
    var x3 = $as_Lplay_api_libs_json_JsNumber(jsValue$1);
    var n = x3.Lplay_api_libs_json_JsNumber__f_value;
    return n.s_math_BigDecimal__f_bigDecimal.toString__T()
  } else {
    var x$3 = $m_Lplay_api_libs_json_JsTrue$();
    if (x$3.equals__O__Z(jsValue$1)) {
      return "true"
    } else {
      var x$5 = $m_Lplay_api_libs_json_JsFalse$();
      if (x$5.equals__O__Z(jsValue$1)) {
        return "false"
      } else if ((jsValue$1 instanceof $c_Lplay_api_libs_json_JsArray)) {
        var x4 = $as_Lplay_api_libs_json_JsArray(jsValue$1);
        var items = x4.Lplay_api_libs_json_JsArray__f_value;
        var il = ((1 + ilevel$1) | 0);
        var this$5 = $as_sc_IterableOnceOps(items.map__F1__O(new $c_sjsr_AnonFunction1((function(this$3, escapeNonASCII$1$1, il$1, indent$1$1, newline$1$1, fieldValueSep$1$1, arraySep$1$1) {
          return (function(x$3$2$2) {
            var x$3$2 = $as_Lplay_api_libs_json_JsValue(x$3$2$2);
            var this$4 = $m_Lplay_api_libs_json_StaticBinding$();
            return $p_Lplay_api_libs_json_StaticBinding$__str$1__Lplay_api_libs_json_JsValue__Z__I__F1__Z__T__T3__T(this$4, x$3$2, escapeNonASCII$1$1, il$1, indent$1$1, newline$1$1, fieldValueSep$1$1, arraySep$1$1)
          })
        })($thiz, escapeNonASCII$1, il, indent$1, newline$1, fieldValueSep$1, arraySep$1))));
        var start = $as_T(arraySep$1.T3__f__1);
        var sep = $as_T(arraySep$1.T3__f__2);
        var end = $as_T(arraySep$1.T3__f__3);
        return $f_sc_IterableOnceOps__mkString__T__T__T__T(this$5, start, sep, end)
      } else if ((jsValue$1 instanceof $c_Lplay_api_libs_json_JsObject)) {
        var x5 = $as_Lplay_api_libs_json_JsObject(jsValue$1);
        var fields = x5.Lplay_api_libs_json_JsObject__f_underlying;
        var il$2 = ((1 + ilevel$1) | 0);
        if (newline$1) {
          var self = ("\n" + indent$1.apply__O__O(il$2));
          var y = (("\n" + indent$1.apply__O__O(ilevel$1)) + "}");
          var x1$2___1 = self;
          var x1$2___2 = y
        } else {
          var self$1 = indent$1.apply__O__O(il$2);
          var x1$2___1 = self$1;
          var x1$2___2 = "}"
        };
        var before = $as_T(x1$2___1);
        var after = $as_T(x1$2___2);
        var this$14 = $as_sc_IterableOnceOps(fields.map__F1__O(new $c_sjsr_AnonFunction1((function(this$2$1, escapeNonASCII$1$2, il$2$1, indent$1$2, newline$1$2, fieldValueSep$1$2, arraySep$1$2, before$2) {
          return (function(x0$1$2) {
            var x0$1 = $as_T2(x0$1$2);
            if ((x0$1 !== null)) {
              var k = $as_T(x0$1._1__O());
              var v = $as_Lplay_api_libs_json_JsValue(x0$1._2__O());
              var this$10 = $m_Lplay_api_libs_json_StaticBinding$();
              var $$x1 = ((!escapeNonASCII$1$2) ? $as_T(JSON.stringify(k)) : this$10.play$api$libs$json$StaticBinding$$escapeStr__T__T($as_T(JSON.stringify(k))));
              var this$13 = $m_Lplay_api_libs_json_StaticBinding$();
              return (((("" + before$2) + $$x1) + fieldValueSep$1$2) + $p_Lplay_api_libs_json_StaticBinding$__str$1__Lplay_api_libs_json_JsValue__Z__I__F1__Z__T__T3__T(this$13, v, escapeNonASCII$1$2, il$2$1, indent$1$2, newline$1$2, fieldValueSep$1$2, arraySep$1$2))
            } else {
              throw new $c_s_MatchError(x0$1)
            }
          })
        })($thiz, escapeNonASCII$1, il$2, indent$1, newline$1, fieldValueSep$1, arraySep$1, before))));
        return $f_sc_IterableOnceOps__mkString__T__T__T__T(this$14, "{", ",", after)
      } else {
        throw new $c_s_MatchError(jsValue$1)
      }
    }
  }
}
function $p_Lplay_api_libs_json_StaticBinding$__hexCode$1__I__T($thiz, code$1) {
  var $$x3 = $m_sc_StringOps$();
  var $$x2 = $m_sc_StringOps$();
  var $$x1 = $m_sc_StringOps$();
  var x = $as_T($uD((code$1 >>> 0)).toString(16));
  var x$1 = $$x1.reverse$extension__T__T(x);
  var x$2 = $$x2.padTo$extension__T__I__C__T(x$1, 4, 48);
  return $$x3.reverse$extension__T__T(x$2)
}
/** @constructor */
function $c_Lplay_api_libs_json_StaticBinding$() {
  /*<skip>*/
}
$c_Lplay_api_libs_json_StaticBinding$.prototype = new $h_O();
$c_Lplay_api_libs_json_StaticBinding$.prototype.constructor = $c_Lplay_api_libs_json_StaticBinding$;
/** @constructor */
function $h_Lplay_api_libs_json_StaticBinding$() {
  /*<skip>*/
}
$h_Lplay_api_libs_json_StaticBinding$.prototype = $c_Lplay_api_libs_json_StaticBinding$.prototype;
$c_Lplay_api_libs_json_StaticBinding$.prototype.generateFromJsValue__Lplay_api_libs_json_JsValue__Z__T = (function(jsValue, escapeNonASCII) {
  var indent = new $c_sjsr_AnonFunction1((function(this$1) {
    return (function(x$1$2) {
      $uI(x$1$2);
      return ""
    })
  })(this));
  var arraySep = new $c_T3("[", ",", "]");
  return $p_Lplay_api_libs_json_StaticBinding$__str$1__Lplay_api_libs_json_JsValue__Z__I__F1__Z__T__T3__T(this, jsValue, escapeNonASCII, 0, indent, false, ":", arraySep)
});
$c_Lplay_api_libs_json_StaticBinding$.prototype.play$api$libs$json$StaticBinding$$escapeStr__T__T = (function(s) {
  var len = $uI(s.length);
  var sb = $ct_jl_StringBuilder__(new $c_jl_StringBuilder());
  var i = 0;
  while ((i < len)) {
    var index = i;
    var arg1 = (65535 & $uI(s.charCodeAt(index)));
    var code = arg1;
    if (((code > 31) && (code < 127))) {
      var str = $as_T(String.fromCharCode(arg1))
    } else {
      var this$5 = $p_Lplay_api_libs_json_StaticBinding$__hexCode$1__I__T(this, code);
      var x = ("u" + $as_T(this$5.toUpperCase()));
      var str = $m_sc_StringOps$().prepended$extension__T__C__T(x, 92)
    };
    sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + sb.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str);
    i = ((1 + i) | 0)
  };
  return sb.jl_StringBuilder__f_java$lang$StringBuilder$$content
});
var $d_Lplay_api_libs_json_StaticBinding$ = new $TypeData().initClass({
  Lplay_api_libs_json_StaticBinding$: 0
}, false, "play.api.libs.json.StaticBinding$", {
  Lplay_api_libs_json_StaticBinding$: 1,
  O: 1
});
$c_Lplay_api_libs_json_StaticBinding$.prototype.$classData = $d_Lplay_api_libs_json_StaticBinding$;
var $n_Lplay_api_libs_json_StaticBinding$;
function $m_Lplay_api_libs_json_StaticBinding$() {
  if ((!$n_Lplay_api_libs_json_StaticBinding$)) {
    $n_Lplay_api_libs_json_StaticBinding$ = new $c_Lplay_api_libs_json_StaticBinding$()
  };
  return $n_Lplay_api_libs_json_StaticBinding$
}
function $f_Lplay_api_libs_json_Writes__contramap__F1__Lplay_api_libs_json_Writes($thiz, f) {
  $m_Lplay_api_libs_json_Writes$();
  var f$2 = new $c_sjsr_AnonFunction1((function(this$1, f$1) {
    return (function(b$2) {
      return this$1.writes__O__Lplay_api_libs_json_JsValue(f$1.apply__O__O(b$2))
    })
  })($thiz, f));
  return new $c_Lplay_api_libs_json_Writes$$anon$6(f$2)
}
/** @constructor */
function $c_s_Array$EmptyArrays$() {
  this.s_Array$EmptyArrays$__f_emptyBooleanArray = null;
  this.s_Array$EmptyArrays$__f_emptyByteArray = null;
  this.s_Array$EmptyArrays$__f_emptyCharArray = null;
  this.s_Array$EmptyArrays$__f_emptyDoubleArray = null;
  this.s_Array$EmptyArrays$__f_emptyFloatArray = null;
  this.s_Array$EmptyArrays$__f_emptyIntArray = null;
  this.s_Array$EmptyArrays$__f_emptyLongArray = null;
  this.s_Array$EmptyArrays$__f_emptyShortArray = null;
  this.s_Array$EmptyArrays$__f_emptyObjectArray = null;
  $n_s_Array$EmptyArrays$ = this;
  this.s_Array$EmptyArrays$__f_emptyBooleanArray = new $ac_Z(0);
  this.s_Array$EmptyArrays$__f_emptyByteArray = new $ac_B(0);
  this.s_Array$EmptyArrays$__f_emptyCharArray = new $ac_C(0);
  this.s_Array$EmptyArrays$__f_emptyDoubleArray = new $ac_D(0);
  this.s_Array$EmptyArrays$__f_emptyFloatArray = new $ac_F(0);
  this.s_Array$EmptyArrays$__f_emptyIntArray = new $ac_I(0);
  this.s_Array$EmptyArrays$__f_emptyLongArray = new $ac_J(0);
  this.s_Array$EmptyArrays$__f_emptyShortArray = new $ac_S(0);
  this.s_Array$EmptyArrays$__f_emptyObjectArray = new $ac_O(0)
}
$c_s_Array$EmptyArrays$.prototype = new $h_O();
$c_s_Array$EmptyArrays$.prototype.constructor = $c_s_Array$EmptyArrays$;
/** @constructor */
function $h_s_Array$EmptyArrays$() {
  /*<skip>*/
}
$h_s_Array$EmptyArrays$.prototype = $c_s_Array$EmptyArrays$.prototype;
var $d_s_Array$EmptyArrays$ = new $TypeData().initClass({
  s_Array$EmptyArrays$: 0
}, false, "scala.Array$EmptyArrays$", {
  s_Array$EmptyArrays$: 1,
  O: 1
});
$c_s_Array$EmptyArrays$.prototype.$classData = $d_s_Array$EmptyArrays$;
var $n_s_Array$EmptyArrays$;
function $m_s_Array$EmptyArrays$() {
  if ((!$n_s_Array$EmptyArrays$)) {
    $n_s_Array$EmptyArrays$ = new $c_s_Array$EmptyArrays$()
  };
  return $n_s_Array$EmptyArrays$
}
function $is_F1(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.F1)))
}
function $as_F1(obj) {
  return (($is_F1(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Function1"))
}
function $isArrayOf_F1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.F1)))
}
function $asArrayOf_F1(obj, depth) {
  return (($isArrayOf_F1(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Function1;", depth))
}
function $is_F2(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.F2)))
}
function $as_F2(obj) {
  return (($is_F2(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Function2"))
}
function $isArrayOf_F2(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.F2)))
}
function $asArrayOf_F2(obj, depth) {
  return (($isArrayOf_F2(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Function2;", depth))
}
/** @constructor */
function $c_s_LowPriorityImplicits2() {
  /*<skip>*/
}
$c_s_LowPriorityImplicits2.prototype = new $h_O();
$c_s_LowPriorityImplicits2.prototype.constructor = $c_s_LowPriorityImplicits2;
/** @constructor */
function $h_s_LowPriorityImplicits2() {
  /*<skip>*/
}
$h_s_LowPriorityImplicits2.prototype = $c_s_LowPriorityImplicits2.prototype;
/** @constructor */
function $c_s_PartialFunction$() {
  this.s_PartialFunction$__f_fallback_fn = null;
  this.s_PartialFunction$__f_scala$PartialFunction$$constFalse = null;
  this.s_PartialFunction$__f_empty_pf = null;
  $n_s_PartialFunction$ = this;
  this.s_PartialFunction$__f_fallback_fn = new $c_sjsr_AnonFunction1((function(this$1) {
    return (function(x$2$2) {
      return $m_s_PartialFunction$().s_PartialFunction$__f_fallback_fn
    })
  })(this));
  this.s_PartialFunction$__f_scala$PartialFunction$$constFalse = new $c_sjsr_AnonFunction1((function(this$2) {
    return (function(x$3$2) {
      return false
    })
  })(this));
  this.s_PartialFunction$__f_empty_pf = new $c_s_PartialFunction$$anon$1()
}
$c_s_PartialFunction$.prototype = new $h_O();
$c_s_PartialFunction$.prototype.constructor = $c_s_PartialFunction$;
/** @constructor */
function $h_s_PartialFunction$() {
  /*<skip>*/
}
$h_s_PartialFunction$.prototype = $c_s_PartialFunction$.prototype;
$c_s_PartialFunction$.prototype.unlifted__F1__s_PartialFunction = (function(f) {
  if (false) {
    var x2 = $as_s_PartialFunction$Lifted(f);
    return x2.pf__s_PartialFunction()
  } else {
    return new $c_s_PartialFunction$Unlifted(f)
  }
});
var $d_s_PartialFunction$ = new $TypeData().initClass({
  s_PartialFunction$: 0
}, false, "scala.PartialFunction$", {
  s_PartialFunction$: 1,
  O: 1
});
$c_s_PartialFunction$.prototype.$classData = $d_s_PartialFunction$;
var $n_s_PartialFunction$;
function $m_s_PartialFunction$() {
  if ((!$n_s_PartialFunction$)) {
    $n_s_PartialFunction$ = new $c_s_PartialFunction$()
  };
  return $n_s_PartialFunction$
}
function $f_s_Proxy__toString__T($thiz) {
  return ("" + $thiz.sr_RichLong__f_self)
}
/** @constructor */
function $c_sc_Factory$() {
  this.sc_Factory$__f_stringFactory = null;
  $n_sc_Factory$ = this;
  this.sc_Factory$__f_stringFactory = new $c_sc_Factory$StringFactory()
}
$c_sc_Factory$.prototype = new $h_O();
$c_sc_Factory$.prototype.constructor = $c_sc_Factory$;
/** @constructor */
function $h_sc_Factory$() {
  /*<skip>*/
}
$h_sc_Factory$.prototype = $c_sc_Factory$.prototype;
var $d_sc_Factory$ = new $TypeData().initClass({
  sc_Factory$: 0
}, false, "scala.collection.Factory$", {
  sc_Factory$: 1,
  O: 1
});
$c_sc_Factory$.prototype.$classData = $d_sc_Factory$;
var $n_sc_Factory$;
function $m_sc_Factory$() {
  if ((!$n_sc_Factory$)) {
    $n_sc_Factory$ = new $c_sc_Factory$()
  };
  return $n_sc_Factory$
}
/** @constructor */
function $c_sc_Hashing$() {
  /*<skip>*/
}
$c_sc_Hashing$.prototype = new $h_O();
$c_sc_Hashing$.prototype.constructor = $c_sc_Hashing$;
/** @constructor */
function $h_sc_Hashing$() {
  /*<skip>*/
}
$h_sc_Hashing$.prototype = $c_sc_Hashing$.prototype;
$c_sc_Hashing$.prototype.improve__I__I = (function(hcode) {
  var h = ((hcode + (~(hcode << 9))) | 0);
  h = (h ^ ((h >>> 14) | 0));
  h = ((h + (h << 4)) | 0);
  return (h ^ ((h >>> 10) | 0))
});
var $d_sc_Hashing$ = new $TypeData().initClass({
  sc_Hashing$: 0
}, false, "scala.collection.Hashing$", {
  sc_Hashing$: 1,
  O: 1
});
$c_sc_Hashing$.prototype.$classData = $d_sc_Hashing$;
var $n_sc_Hashing$;
function $m_sc_Hashing$() {
  if ((!$n_sc_Hashing$)) {
    $n_sc_Hashing$ = new $c_sc_Hashing$()
  };
  return $n_sc_Hashing$
}
function $is_sc_IterableOnce(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_IterableOnce)))
}
function $as_sc_IterableOnce(obj) {
  return (($is_sc_IterableOnce(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.IterableOnce"))
}
function $isArrayOf_sc_IterableOnce(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_IterableOnce)))
}
function $asArrayOf_sc_IterableOnce(obj, depth) {
  return (($isArrayOf_sc_IterableOnce(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.IterableOnce;", depth))
}
/** @constructor */
function $c_sc_IterableOnceExtensionMethods$() {
  /*<skip>*/
}
$c_sc_IterableOnceExtensionMethods$.prototype = new $h_O();
$c_sc_IterableOnceExtensionMethods$.prototype.constructor = $c_sc_IterableOnceExtensionMethods$;
/** @constructor */
function $h_sc_IterableOnceExtensionMethods$() {
  /*<skip>*/
}
$h_sc_IterableOnceExtensionMethods$.prototype = $c_sc_IterableOnceExtensionMethods$.prototype;
$c_sc_IterableOnceExtensionMethods$.prototype.isEmpty$extension__sc_IterableOnce__Z = (function(this$) {
  if ($is_sc_Iterable(this$)) {
    var x2 = $as_sc_Iterable(this$);
    return x2.isEmpty__Z()
  } else {
    var this$1 = this$.iterator__sc_Iterator();
    return (!this$1.hasNext__Z())
  }
});
var $d_sc_IterableOnceExtensionMethods$ = new $TypeData().initClass({
  sc_IterableOnceExtensionMethods$: 0
}, false, "scala.collection.IterableOnceExtensionMethods$", {
  sc_IterableOnceExtensionMethods$: 1,
  O: 1
});
$c_sc_IterableOnceExtensionMethods$.prototype.$classData = $d_sc_IterableOnceExtensionMethods$;
var $n_sc_IterableOnceExtensionMethods$;
function $m_sc_IterableOnceExtensionMethods$() {
  if ((!$n_sc_IterableOnceExtensionMethods$)) {
    $n_sc_IterableOnceExtensionMethods$ = new $c_sc_IterableOnceExtensionMethods$()
  };
  return $n_sc_IterableOnceExtensionMethods$
}
function $f_sc_IterableOnceOps__foreach__F1__V($thiz, f) {
  var it = $as_sc_IterableOnce($thiz).iterator__sc_Iterator();
  while (it.hasNext__Z()) {
    f.apply__O__O(it.next__O())
  }
}
function $f_sc_IterableOnceOps__forall__F1__Z($thiz, p) {
  var res = true;
  var it = $as_sc_IterableOnce($thiz).iterator__sc_Iterator();
  while ((res && it.hasNext__Z())) {
    res = $uZ(p.apply__O__O(it.next__O()))
  };
  return res
}
function $f_sc_IterableOnceOps__exists__F1__Z($thiz, p) {
  var res = false;
  var it = $as_sc_IterableOnce($thiz).iterator__sc_Iterator();
  while (((!res) && it.hasNext__Z())) {
    res = $uZ(p.apply__O__O(it.next__O()))
  };
  return res
}
function $f_sc_IterableOnceOps__foldLeft__O__F2__O($thiz, z, op) {
  var result = z;
  var it = $as_sc_IterableOnce($thiz).iterator__sc_Iterator();
  while (it.hasNext__Z()) {
    result = op.apply__O__O__O(result, it.next__O())
  };
  return result
}
function $f_sc_IterableOnceOps__isEmpty__Z($thiz) {
  return (!$as_sc_IterableOnce($thiz).iterator__sc_Iterator().hasNext__Z())
}
function $f_sc_IterableOnceOps__size__I($thiz) {
  if (($as_sc_IterableOnce($thiz).knownSize__I() >= 0)) {
    return $as_sc_IterableOnce($thiz).knownSize__I()
  } else {
    var it = $as_sc_IterableOnce($thiz).iterator__sc_Iterator();
    var len = 0;
    while (it.hasNext__Z()) {
      len = ((1 + len) | 0);
      it.next__O()
    };
    return len
  }
}
function $f_sc_IterableOnceOps__copyToArray__O__I__I__I($thiz, xs, start, len) {
  var it = $as_sc_IterableOnce($thiz).iterator__sc_Iterator();
  var i = start;
  var y = (($m_sr_ScalaRunTime$().array_length__O__I(xs) - start) | 0);
  var end = ((start + ((len < y) ? len : y)) | 0);
  while (((i < end) && it.hasNext__Z())) {
    $m_sr_ScalaRunTime$().array_update__O__I__O__V(xs, i, it.next__O());
    i = ((1 + i) | 0)
  };
  return ((i - start) | 0)
}
function $f_sc_IterableOnceOps__mkString__T__T__T__T($thiz, start, sep, end) {
  if ($thiz.isEmpty__Z()) {
    return (("" + start) + end)
  } else {
    var this$1 = $thiz.addString__scm_StringBuilder__T__T__T__scm_StringBuilder($ct_scm_StringBuilder__(new $c_scm_StringBuilder()), start, sep, end);
    return this$1.scm_StringBuilder__f_underlying.jl_StringBuilder__f_java$lang$StringBuilder$$content
  }
}
function $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder($thiz, b, start, sep, end) {
  var jsb = b.scm_StringBuilder__f_underlying;
  if (($uI(start.length) !== 0)) {
    jsb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + jsb.jl_StringBuilder__f_java$lang$StringBuilder$$content) + start)
  };
  var it = $as_sc_IterableOnce($thiz).iterator__sc_Iterator();
  if (it.hasNext__Z()) {
    var obj = it.next__O();
    jsb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + jsb.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj);
    while (it.hasNext__Z()) {
      jsb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + jsb.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
      var obj$1 = it.next__O();
      jsb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + jsb.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj$1)
    }
  };
  if (($uI(end.length) !== 0)) {
    jsb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + jsb.jl_StringBuilder__f_java$lang$StringBuilder$$content) + end)
  };
  return b
}
function $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O($thiz, evidence$2) {
  if (($as_sc_IterableOnce($thiz).knownSize__I() >= 0)) {
    var destination = evidence$2.newArray__I__O($as_sc_IterableOnce($thiz).knownSize__I());
    $thiz.copyToArray__O__I__I__I(destination, 0, 2147483647);
    return destination
  } else {
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    var elementClass = evidence$2.runtimeClass__jl_Class();
    capacity = 0;
    size = 0;
    var isCharArrayBuilder = (elementClass === $d_C.getClassOf());
    jsElems = [];
    var xs = $as_sc_IterableOnce($thiz);
    var it = xs.iterator__sc_Iterator();
    while (it.hasNext__Z()) {
      var elem = it.next__O();
      var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? elementClass.jl_Class__f_data.zero : elem));
      jsElems.push(unboxedElem)
    };
    var elemRuntimeClass = ((elementClass === $d_V.getClassOf()) ? $d_jl_Void.getClassOf() : (((elementClass === $d_sr_Null$.getClassOf()) || (elementClass === $d_sr_Nothing$.getClassOf())) ? $d_O.getClassOf() : elementClass));
    return elemRuntimeClass.jl_Class__f_data.getArrayOf().wrapArray(jsElems)
  }
}
function $is_sc_IterableOnceOps(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_IterableOnceOps)))
}
function $as_sc_IterableOnceOps(obj) {
  return (($is_sc_IterableOnceOps(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.IterableOnceOps"))
}
function $isArrayOf_sc_IterableOnceOps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_IterableOnceOps)))
}
function $asArrayOf_sc_IterableOnceOps(obj, depth) {
  return (($isArrayOf_sc_IterableOnceOps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.IterableOnceOps;", depth))
}
/** @constructor */
function $c_sc_Iterator$ConcatIteratorCell(head, tail) {
  this.sc_Iterator$ConcatIteratorCell__f_head = null;
  this.sc_Iterator$ConcatIteratorCell__f_tail = null;
  this.sc_Iterator$ConcatIteratorCell__f_head = head;
  this.sc_Iterator$ConcatIteratorCell__f_tail = tail
}
$c_sc_Iterator$ConcatIteratorCell.prototype = new $h_O();
$c_sc_Iterator$ConcatIteratorCell.prototype.constructor = $c_sc_Iterator$ConcatIteratorCell;
/** @constructor */
function $h_sc_Iterator$ConcatIteratorCell() {
  /*<skip>*/
}
$h_sc_Iterator$ConcatIteratorCell.prototype = $c_sc_Iterator$ConcatIteratorCell.prototype;
$c_sc_Iterator$ConcatIteratorCell.prototype.headIterator__sc_Iterator = (function() {
  return $as_sc_IterableOnce(this.sc_Iterator$ConcatIteratorCell__f_head.apply__O()).iterator__sc_Iterator()
});
var $d_sc_Iterator$ConcatIteratorCell = new $TypeData().initClass({
  sc_Iterator$ConcatIteratorCell: 0
}, false, "scala.collection.Iterator$ConcatIteratorCell", {
  sc_Iterator$ConcatIteratorCell: 1,
  O: 1
});
$c_sc_Iterator$ConcatIteratorCell.prototype.$classData = $d_sc_Iterator$ConcatIteratorCell;
/** @constructor */
function $c_sc_JavaConverters$AsScala(op) {
  this.sc_JavaConverters$AsScala__f_op = null;
  this.sc_JavaConverters$AsScala__f_op = op
}
$c_sc_JavaConverters$AsScala.prototype = new $h_O();
$c_sc_JavaConverters$AsScala.prototype.constructor = $c_sc_JavaConverters$AsScala;
/** @constructor */
function $h_sc_JavaConverters$AsScala() {
  /*<skip>*/
}
$h_sc_JavaConverters$AsScala.prototype = $c_sc_JavaConverters$AsScala.prototype;
$c_sc_JavaConverters$AsScala.prototype.asScala__O = (function() {
  return this.sc_JavaConverters$AsScala__f_op.apply__O()
});
var $d_sc_JavaConverters$AsScala = new $TypeData().initClass({
  sc_JavaConverters$AsScala: 0
}, false, "scala.collection.JavaConverters$AsScala", {
  sc_JavaConverters$AsScala: 1,
  O: 1
});
$c_sc_JavaConverters$AsScala.prototype.$classData = $d_sc_JavaConverters$AsScala;
function $p_sc_LinearSeqIterator$LazyCell__v$lzycompute__sc_LinearSeqOps($thiz) {
  if ((!$thiz.sc_LinearSeqIterator$LazyCell__f_bitmap$0)) {
    $thiz.sc_LinearSeqIterator$LazyCell__f_v = $as_sc_LinearSeqOps($thiz.sc_LinearSeqIterator$LazyCell__f_st.apply__O());
    $thiz.sc_LinearSeqIterator$LazyCell__f_bitmap$0 = true
  };
  $thiz.sc_LinearSeqIterator$LazyCell__f_st = null;
  return $thiz.sc_LinearSeqIterator$LazyCell__f_v
}
/** @constructor */
function $c_sc_LinearSeqIterator$LazyCell(outer, st) {
  this.sc_LinearSeqIterator$LazyCell__f_v = null;
  this.sc_LinearSeqIterator$LazyCell__f_st = null;
  this.sc_LinearSeqIterator$LazyCell__f_bitmap$0 = false;
  this.sc_LinearSeqIterator$LazyCell__f_st = st
}
$c_sc_LinearSeqIterator$LazyCell.prototype = new $h_O();
$c_sc_LinearSeqIterator$LazyCell.prototype.constructor = $c_sc_LinearSeqIterator$LazyCell;
/** @constructor */
function $h_sc_LinearSeqIterator$LazyCell() {
  /*<skip>*/
}
$h_sc_LinearSeqIterator$LazyCell.prototype = $c_sc_LinearSeqIterator$LazyCell.prototype;
$c_sc_LinearSeqIterator$LazyCell.prototype.v__sc_LinearSeqOps = (function() {
  return ((!this.sc_LinearSeqIterator$LazyCell__f_bitmap$0) ? $p_sc_LinearSeqIterator$LazyCell__v$lzycompute__sc_LinearSeqOps(this) : this.sc_LinearSeqIterator$LazyCell__f_v)
});
var $d_sc_LinearSeqIterator$LazyCell = new $TypeData().initClass({
  sc_LinearSeqIterator$LazyCell: 0
}, false, "scala.collection.LinearSeqIterator$LazyCell", {
  sc_LinearSeqIterator$LazyCell: 1,
  O: 1
});
$c_sc_LinearSeqIterator$LazyCell.prototype.$classData = $d_sc_LinearSeqIterator$LazyCell;
/** @constructor */
function $c_sc_SeqFactory$UnapplySeqWrapper(c) {
  this.sc_SeqFactory$UnapplySeqWrapper__f_scala$collection$SeqFactory$UnapplySeqWrapper$$c = null;
  this.sc_SeqFactory$UnapplySeqWrapper__f_scala$collection$SeqFactory$UnapplySeqWrapper$$c = c
}
$c_sc_SeqFactory$UnapplySeqWrapper.prototype = new $h_O();
$c_sc_SeqFactory$UnapplySeqWrapper.prototype.constructor = $c_sc_SeqFactory$UnapplySeqWrapper;
/** @constructor */
function $h_sc_SeqFactory$UnapplySeqWrapper() {
  /*<skip>*/
}
$h_sc_SeqFactory$UnapplySeqWrapper.prototype = $c_sc_SeqFactory$UnapplySeqWrapper.prototype;
$c_sc_SeqFactory$UnapplySeqWrapper.prototype.hashCode__I = (function() {
  var this$ = this.sc_SeqFactory$UnapplySeqWrapper__f_scala$collection$SeqFactory$UnapplySeqWrapper$$c;
  return this$.hashCode__I()
});
$c_sc_SeqFactory$UnapplySeqWrapper.prototype.equals__O__Z = (function(x$1) {
  return $m_sc_SeqFactory$UnapplySeqWrapper$().equals$extension__sc_SeqOps__O__Z(this.sc_SeqFactory$UnapplySeqWrapper__f_scala$collection$SeqFactory$UnapplySeqWrapper$$c, x$1)
});
function $as_sc_SeqFactory$UnapplySeqWrapper(obj) {
  return (((obj instanceof $c_sc_SeqFactory$UnapplySeqWrapper) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.SeqFactory$UnapplySeqWrapper"))
}
function $isArrayOf_sc_SeqFactory$UnapplySeqWrapper(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_SeqFactory$UnapplySeqWrapper)))
}
function $asArrayOf_sc_SeqFactory$UnapplySeqWrapper(obj, depth) {
  return (($isArrayOf_sc_SeqFactory$UnapplySeqWrapper(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.SeqFactory$UnapplySeqWrapper;", depth))
}
var $d_sc_SeqFactory$UnapplySeqWrapper = new $TypeData().initClass({
  sc_SeqFactory$UnapplySeqWrapper: 0
}, false, "scala.collection.SeqFactory$UnapplySeqWrapper", {
  sc_SeqFactory$UnapplySeqWrapper: 1,
  O: 1
});
$c_sc_SeqFactory$UnapplySeqWrapper.prototype.$classData = $d_sc_SeqFactory$UnapplySeqWrapper;
/** @constructor */
function $c_sc_SeqFactory$UnapplySeqWrapper$() {
  /*<skip>*/
}
$c_sc_SeqFactory$UnapplySeqWrapper$.prototype = new $h_O();
$c_sc_SeqFactory$UnapplySeqWrapper$.prototype.constructor = $c_sc_SeqFactory$UnapplySeqWrapper$;
/** @constructor */
function $h_sc_SeqFactory$UnapplySeqWrapper$() {
  /*<skip>*/
}
$h_sc_SeqFactory$UnapplySeqWrapper$.prototype = $c_sc_SeqFactory$UnapplySeqWrapper$.prototype;
$c_sc_SeqFactory$UnapplySeqWrapper$.prototype.equals$extension__sc_SeqOps__O__Z = (function(this$, x$1) {
  if ((x$1 instanceof $c_sc_SeqFactory$UnapplySeqWrapper)) {
    var UnapplySeqWrapper$1 = ((x$1 === null) ? null : $as_sc_SeqFactory$UnapplySeqWrapper(x$1).sc_SeqFactory$UnapplySeqWrapper__f_scala$collection$SeqFactory$UnapplySeqWrapper$$c);
    return ((this$ === null) ? (UnapplySeqWrapper$1 === null) : this$.equals__O__Z(UnapplySeqWrapper$1))
  } else {
    return false
  }
});
var $d_sc_SeqFactory$UnapplySeqWrapper$ = new $TypeData().initClass({
  sc_SeqFactory$UnapplySeqWrapper$: 0
}, false, "scala.collection.SeqFactory$UnapplySeqWrapper$", {
  sc_SeqFactory$UnapplySeqWrapper$: 1,
  O: 1
});
$c_sc_SeqFactory$UnapplySeqWrapper$.prototype.$classData = $d_sc_SeqFactory$UnapplySeqWrapper$;
var $n_sc_SeqFactory$UnapplySeqWrapper$;
function $m_sc_SeqFactory$UnapplySeqWrapper$() {
  if ((!$n_sc_SeqFactory$UnapplySeqWrapper$)) {
    $n_sc_SeqFactory$UnapplySeqWrapper$ = new $c_sc_SeqFactory$UnapplySeqWrapper$()
  };
  return $n_sc_SeqFactory$UnapplySeqWrapper$
}
/** @constructor */
function $c_sc_StringOps$() {
  /*<skip>*/
}
$c_sc_StringOps$.prototype = new $h_O();
$c_sc_StringOps$.prototype.constructor = $c_sc_StringOps$;
/** @constructor */
function $h_sc_StringOps$() {
  /*<skip>*/
}
$h_sc_StringOps$.prototype = $c_sc_StringOps$.prototype;
$c_sc_StringOps$.prototype.padTo$extension__T__I__C__T = (function(this$, len, elem) {
  var sLen = $uI(this$.length);
  if ((sLen >= len)) {
    return this$
  } else {
    var sb = $ct_jl_StringBuilder__I__(new $c_jl_StringBuilder(), len);
    sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + sb.jl_StringBuilder__f_java$lang$StringBuilder$$content) + this$);
    var i = sLen;
    while ((i < len)) {
      var str = $as_T(String.fromCharCode(elem));
      sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + sb.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str);
      i = ((1 + i) | 0)
    };
    return sb.jl_StringBuilder__f_java$lang$StringBuilder$$content
  }
});
$c_sc_StringOps$.prototype.prepended$extension__T__C__T = (function(this$, c) {
  var this$1 = $ct_jl_StringBuilder__I__(new $c_jl_StringBuilder(), ((1 + $uI(this$.length)) | 0));
  var str = $as_T(String.fromCharCode(c));
  this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str);
  this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content) + this$);
  return this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content
});
$c_sc_StringOps$.prototype.slice$extension__T__I__I__T = (function(this$, from, until) {
  var start = ((from > 0) ? from : 0);
  var that = $uI(this$.length);
  var end = ((until < that) ? until : that);
  return ((start >= end) ? "" : $as_T(this$.substring(start, end)))
});
$c_sc_StringOps$.prototype.stripSuffix$extension__T__T__T = (function(this$, suffix) {
  if ($f_T__endsWith__T__Z(this$, suffix)) {
    var endIndex = (($uI(this$.length) - $uI(suffix.length)) | 0);
    return $as_T(this$.substring(0, endIndex))
  } else {
    return this$
  }
});
$c_sc_StringOps$.prototype.stripMargin$extension__T__C__T = (function(this$, marginChar) {
  var sb = $ct_jl_StringBuilder__I__(new $c_jl_StringBuilder(), $uI(this$.length));
  var this$3 = new $c_sc_StringOps$$anon$1(this$, false);
  while ((this$3.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index < this$3.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$len)) {
    var arg1 = this$3.next__T();
    var len = $uI(arg1.length);
    var index = 0;
    while (true) {
      if ((index < len)) {
        var index$1 = index;
        var $$x1 = ((65535 & $uI(arg1.charCodeAt(index$1))) <= 32)
      } else {
        var $$x1 = false
      };
      if ($$x1) {
        index = ((1 + index) | 0)
      } else {
        break
      }
    };
    if ((index < len)) {
      var index$2 = index;
      var $$x2 = ((65535 & $uI(arg1.charCodeAt(index$2))) === marginChar)
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      var beginIndex = ((1 + index) | 0);
      var stripped = $as_T(arg1.substring(beginIndex))
    } else {
      var stripped = arg1
    };
    sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + sb.jl_StringBuilder__f_java$lang$StringBuilder$$content) + stripped)
  };
  return sb.jl_StringBuilder__f_java$lang$StringBuilder$$content
});
$c_sc_StringOps$.prototype.unwrapArg$extension__T__O__O = (function(this$, arg) {
  if ((arg instanceof $c_s_math_ScalaNumber)) {
    var x2 = $as_s_math_ScalaNumber(arg);
    return x2.underlying__O()
  } else {
    return arg
  }
});
$c_sc_StringOps$.prototype.format$extension__T__sci_Seq__T = (function(this$, args) {
  var args$1 = $asArrayOf_O($as_sc_IterableOnceOps(args.map__F1__O(new $c_sjsr_AnonFunction1((function(this$1, this$$1) {
    return (function(arg$2) {
      return $m_sc_StringOps$().unwrapArg$extension__T__O__O(this$$1, arg$2)
    })
  })(this, this$)))).toArray__s_reflect_ClassTag__O($m_s_reflect_ManifestFactory$ObjectManifest$()), 1);
  return $m_jl_String$().format__T__AO__T(this$, args$1)
});
$c_sc_StringOps$.prototype.reverse$extension__T__T = (function(this$) {
  return $ct_jl_StringBuilder__T__(new $c_jl_StringBuilder(), this$).reverse__jl_StringBuilder().jl_StringBuilder__f_java$lang$StringBuilder$$content
});
$c_sc_StringOps$.prototype.drop$extension__T__I__T = (function(this$, n) {
  var $$x1 = $m_sc_StringOps$();
  var y = $uI(this$.length);
  return $$x1.slice$extension__T__I__I__T(this$, ((n < y) ? n : y), $uI(this$.length))
});
var $d_sc_StringOps$ = new $TypeData().initClass({
  sc_StringOps$: 0
}, false, "scala.collection.StringOps$", {
  sc_StringOps$: 1,
  O: 1
});
$c_sc_StringOps$.prototype.$classData = $d_sc_StringOps$;
var $n_sc_StringOps$;
function $m_sc_StringOps$() {
  if ((!$n_sc_StringOps$)) {
    $n_sc_StringOps$ = new $c_sc_StringOps$()
  };
  return $n_sc_StringOps$
}
function $f_sc_convert_AsScalaConverters__asScala__ju_Map__scm_Map($thiz, m) {
  if ((m === null)) {
    return null
  } else if (false) {
    var x2 = $as_sc_convert_JavaCollectionWrappers$MutableMapWrapper(m);
    var wrapped = x2.underlying__scm_Map();
    return wrapped
  } else {
    return new $c_sc_convert_JavaCollectionWrappers$JMapWrapper(m)
  }
}
function $p_sci_ChampBaseIterator__initNodes__V($thiz) {
  if (($thiz.sci_ChampBaseIterator__f_nodeCursorsAndLengths === null)) {
    $thiz.sci_ChampBaseIterator__f_nodeCursorsAndLengths = new $ac_I(($m_sci_Node$().sci_Node$__f_MaxDepth << 1));
    $thiz.sci_ChampBaseIterator__f_nodes = new ($d_sci_Node.getArrayOf().constr)($m_sci_Node$().sci_Node$__f_MaxDepth)
  }
}
function $p_sci_ChampBaseIterator__setupPayloadNode__sci_Node__V($thiz, node) {
  $thiz.sci_ChampBaseIterator__f_currentValueNode = node;
  $thiz.sci_ChampBaseIterator__f_currentValueCursor = 0;
  $thiz.sci_ChampBaseIterator__f_currentValueLength = node.payloadArity__I()
}
function $p_sci_ChampBaseIterator__pushNode__sci_Node__V($thiz, node) {
  $p_sci_ChampBaseIterator__initNodes__V($thiz);
  $thiz.sci_ChampBaseIterator__f_currentStackLevel = ((1 + $thiz.sci_ChampBaseIterator__f_currentStackLevel) | 0);
  var cursorIndex = ($thiz.sci_ChampBaseIterator__f_currentStackLevel << 1);
  var lengthIndex = ((1 + ($thiz.sci_ChampBaseIterator__f_currentStackLevel << 1)) | 0);
  $thiz.sci_ChampBaseIterator__f_nodes.set($thiz.sci_ChampBaseIterator__f_currentStackLevel, node);
  $thiz.sci_ChampBaseIterator__f_nodeCursorsAndLengths.set(cursorIndex, 0);
  $thiz.sci_ChampBaseIterator__f_nodeCursorsAndLengths.set(lengthIndex, node.nodeArity__I())
}
function $p_sci_ChampBaseIterator__popNode__V($thiz) {
  $thiz.sci_ChampBaseIterator__f_currentStackLevel = (((-1) + $thiz.sci_ChampBaseIterator__f_currentStackLevel) | 0)
}
function $p_sci_ChampBaseIterator__searchNextValueNode__Z($thiz) {
  while (($thiz.sci_ChampBaseIterator__f_currentStackLevel >= 0)) {
    var cursorIndex = ($thiz.sci_ChampBaseIterator__f_currentStackLevel << 1);
    var lengthIndex = ((1 + ($thiz.sci_ChampBaseIterator__f_currentStackLevel << 1)) | 0);
    var nodeCursor = $thiz.sci_ChampBaseIterator__f_nodeCursorsAndLengths.get(cursorIndex);
    var nodeLength = $thiz.sci_ChampBaseIterator__f_nodeCursorsAndLengths.get(lengthIndex);
    if ((nodeCursor < nodeLength)) {
      var ev$1 = $thiz.sci_ChampBaseIterator__f_nodeCursorsAndLengths;
      ev$1.set(cursorIndex, ((1 + ev$1.get(cursorIndex)) | 0));
      var nextNode = $thiz.sci_ChampBaseIterator__f_nodes.get($thiz.sci_ChampBaseIterator__f_currentStackLevel).getNode__I__sci_Node(nodeCursor);
      if (nextNode.hasNodes__Z()) {
        $p_sci_ChampBaseIterator__pushNode__sci_Node__V($thiz, nextNode)
      };
      if (nextNode.hasPayload__Z()) {
        $p_sci_ChampBaseIterator__setupPayloadNode__sci_Node__V($thiz, nextNode);
        return true
      }
    } else {
      $p_sci_ChampBaseIterator__popNode__V($thiz)
    }
  };
  return false
}
function $ct_sci_ChampBaseIterator__($thiz) {
  $thiz.sci_ChampBaseIterator__f_currentValueCursor = 0;
  $thiz.sci_ChampBaseIterator__f_currentValueLength = 0;
  $thiz.sci_ChampBaseIterator__f_currentStackLevel = (-1);
  return $thiz
}
function $ct_sci_ChampBaseIterator__sci_Node__($thiz, rootNode) {
  $ct_sci_ChampBaseIterator__($thiz);
  if (rootNode.hasNodes__Z()) {
    $p_sci_ChampBaseIterator__pushNode__sci_Node__V($thiz, rootNode)
  };
  if (rootNode.hasPayload__Z()) {
    $p_sci_ChampBaseIterator__setupPayloadNode__sci_Node__V($thiz, rootNode)
  };
  return $thiz
}
/** @constructor */
function $c_sci_ChampBaseIterator() {
  this.sci_ChampBaseIterator__f_currentValueCursor = 0;
  this.sci_ChampBaseIterator__f_currentValueLength = 0;
  this.sci_ChampBaseIterator__f_currentValueNode = null;
  this.sci_ChampBaseIterator__f_currentStackLevel = 0;
  this.sci_ChampBaseIterator__f_nodeCursorsAndLengths = null;
  this.sci_ChampBaseIterator__f_nodes = null
}
$c_sci_ChampBaseIterator.prototype = new $h_O();
$c_sci_ChampBaseIterator.prototype.constructor = $c_sci_ChampBaseIterator;
/** @constructor */
function $h_sci_ChampBaseIterator() {
  /*<skip>*/
}
$h_sci_ChampBaseIterator.prototype = $c_sci_ChampBaseIterator.prototype;
$c_sci_ChampBaseIterator.prototype.hasNext__Z = (function() {
  return ((this.sci_ChampBaseIterator__f_currentValueCursor < this.sci_ChampBaseIterator__f_currentValueLength) || $p_sci_ChampBaseIterator__searchNextValueNode__Z(this))
});
function $p_sci_ChampBaseReverseIterator__setupPayloadNode__sci_Node__V($thiz, node) {
  $thiz.sci_ChampBaseReverseIterator__f_currentValueNode = node;
  $thiz.sci_ChampBaseReverseIterator__f_currentValueCursor = (((-1) + node.payloadArity__I()) | 0)
}
function $p_sci_ChampBaseReverseIterator__pushNode__sci_Node__V($thiz, node) {
  $thiz.sci_ChampBaseReverseIterator__f_currentStackLevel = ((1 + $thiz.sci_ChampBaseReverseIterator__f_currentStackLevel) | 0);
  $thiz.sci_ChampBaseReverseIterator__f_nodeStack.set($thiz.sci_ChampBaseReverseIterator__f_currentStackLevel, node);
  $thiz.sci_ChampBaseReverseIterator__f_nodeIndex.set($thiz.sci_ChampBaseReverseIterator__f_currentStackLevel, (((-1) + node.nodeArity__I()) | 0))
}
function $p_sci_ChampBaseReverseIterator__popNode__V($thiz) {
  $thiz.sci_ChampBaseReverseIterator__f_currentStackLevel = (((-1) + $thiz.sci_ChampBaseReverseIterator__f_currentStackLevel) | 0)
}
function $p_sci_ChampBaseReverseIterator__searchNextValueNode__Z($thiz) {
  while (($thiz.sci_ChampBaseReverseIterator__f_currentStackLevel >= 0)) {
    var nodeCursor = $thiz.sci_ChampBaseReverseIterator__f_nodeIndex.get($thiz.sci_ChampBaseReverseIterator__f_currentStackLevel);
    $thiz.sci_ChampBaseReverseIterator__f_nodeIndex.set($thiz.sci_ChampBaseReverseIterator__f_currentStackLevel, (((-1) + nodeCursor) | 0));
    if ((nodeCursor >= 0)) {
      var nextNode = $thiz.sci_ChampBaseReverseIterator__f_nodeStack.get($thiz.sci_ChampBaseReverseIterator__f_currentStackLevel).getNode__I__sci_Node(nodeCursor);
      $p_sci_ChampBaseReverseIterator__pushNode__sci_Node__V($thiz, nextNode)
    } else {
      var currNode = $thiz.sci_ChampBaseReverseIterator__f_nodeStack.get($thiz.sci_ChampBaseReverseIterator__f_currentStackLevel);
      $p_sci_ChampBaseReverseIterator__popNode__V($thiz);
      if (currNode.hasPayload__Z()) {
        $p_sci_ChampBaseReverseIterator__setupPayloadNode__sci_Node__V($thiz, currNode);
        return true
      }
    }
  };
  return false
}
function $ct_sci_ChampBaseReverseIterator__($thiz) {
  $thiz.sci_ChampBaseReverseIterator__f_currentValueCursor = (-1);
  $thiz.sci_ChampBaseReverseIterator__f_currentStackLevel = (-1);
  $thiz.sci_ChampBaseReverseIterator__f_nodeIndex = new $ac_I(((1 + $m_sci_Node$().sci_Node$__f_MaxDepth) | 0));
  $thiz.sci_ChampBaseReverseIterator__f_nodeStack = new ($d_sci_Node.getArrayOf().constr)(((1 + $m_sci_Node$().sci_Node$__f_MaxDepth) | 0));
  return $thiz
}
function $ct_sci_ChampBaseReverseIterator__sci_Node__($thiz, rootNode) {
  $ct_sci_ChampBaseReverseIterator__($thiz);
  $p_sci_ChampBaseReverseIterator__pushNode__sci_Node__V($thiz, rootNode);
  $p_sci_ChampBaseReverseIterator__searchNextValueNode__Z($thiz);
  return $thiz
}
/** @constructor */
function $c_sci_ChampBaseReverseIterator() {
  this.sci_ChampBaseReverseIterator__f_currentValueCursor = 0;
  this.sci_ChampBaseReverseIterator__f_currentValueNode = null;
  this.sci_ChampBaseReverseIterator__f_currentStackLevel = 0;
  this.sci_ChampBaseReverseIterator__f_nodeIndex = null;
  this.sci_ChampBaseReverseIterator__f_nodeStack = null
}
$c_sci_ChampBaseReverseIterator.prototype = new $h_O();
$c_sci_ChampBaseReverseIterator.prototype.constructor = $c_sci_ChampBaseReverseIterator;
/** @constructor */
function $h_sci_ChampBaseReverseIterator() {
  /*<skip>*/
}
$h_sci_ChampBaseReverseIterator.prototype = $c_sci_ChampBaseReverseIterator.prototype;
$c_sci_ChampBaseReverseIterator.prototype.hasNext__Z = (function() {
  return ((this.sci_ChampBaseReverseIterator__f_currentValueCursor >= 0) || $p_sci_ChampBaseReverseIterator__searchNextValueNode__Z(this))
});
function $p_sci_IndexedSeqDefaults$__liftedTree1$1__I($thiz) {
  try {
    var x = $m_jl_System$SystemProperties$().getProperty__T__T__T("scala.collection.immutable.IndexedSeq.defaultApplyPreferredMaxLength", "64");
    var this$4 = $m_jl_Integer$();
    return this$4.parseInt__T__I__I(x, 10)
  } catch (e) {
    if (false) {
      return 64
    } else {
      throw e
    }
  }
}
/** @constructor */
function $c_sci_IndexedSeqDefaults$() {
  this.sci_IndexedSeqDefaults$__f_defaultApplyPreferredMaxLength = 0;
  $n_sci_IndexedSeqDefaults$ = this;
  this.sci_IndexedSeqDefaults$__f_defaultApplyPreferredMaxLength = $p_sci_IndexedSeqDefaults$__liftedTree1$1__I(this)
}
$c_sci_IndexedSeqDefaults$.prototype = new $h_O();
$c_sci_IndexedSeqDefaults$.prototype.constructor = $c_sci_IndexedSeqDefaults$;
/** @constructor */
function $h_sci_IndexedSeqDefaults$() {
  /*<skip>*/
}
$h_sci_IndexedSeqDefaults$.prototype = $c_sci_IndexedSeqDefaults$.prototype;
var $d_sci_IndexedSeqDefaults$ = new $TypeData().initClass({
  sci_IndexedSeqDefaults$: 0
}, false, "scala.collection.immutable.IndexedSeqDefaults$", {
  sci_IndexedSeqDefaults$: 1,
  O: 1
});
$c_sci_IndexedSeqDefaults$.prototype.$classData = $d_sci_IndexedSeqDefaults$;
var $n_sci_IndexedSeqDefaults$;
function $m_sci_IndexedSeqDefaults$() {
  if ((!$n_sci_IndexedSeqDefaults$)) {
    $n_sci_IndexedSeqDefaults$ = new $c_sci_IndexedSeqDefaults$()
  };
  return $n_sci_IndexedSeqDefaults$
}
/** @constructor */
function $c_sci_LazyList$LazyBuilder$DeferredState() {
  this.sci_LazyList$LazyBuilder$DeferredState__f__state = null
}
$c_sci_LazyList$LazyBuilder$DeferredState.prototype = new $h_O();
$c_sci_LazyList$LazyBuilder$DeferredState.prototype.constructor = $c_sci_LazyList$LazyBuilder$DeferredState;
/** @constructor */
function $h_sci_LazyList$LazyBuilder$DeferredState() {
  /*<skip>*/
}
$h_sci_LazyList$LazyBuilder$DeferredState.prototype = $c_sci_LazyList$LazyBuilder$DeferredState.prototype;
$c_sci_LazyList$LazyBuilder$DeferredState.prototype.eval__sci_LazyList$State = (function() {
  var state = this.sci_LazyList$LazyBuilder$DeferredState__f__state;
  if ((state === null)) {
    throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "uninitialized")
  };
  return $as_sci_LazyList$State(state.apply__O())
});
$c_sci_LazyList$LazyBuilder$DeferredState.prototype.init__F0__V = (function(state) {
  if ((this.sci_LazyList$LazyBuilder$DeferredState__f__state !== null)) {
    throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "already initialized")
  };
  this.sci_LazyList$LazyBuilder$DeferredState__f__state = state
});
var $d_sci_LazyList$LazyBuilder$DeferredState = new $TypeData().initClass({
  sci_LazyList$LazyBuilder$DeferredState: 0
}, false, "scala.collection.immutable.LazyList$LazyBuilder$DeferredState", {
  sci_LazyList$LazyBuilder$DeferredState: 1,
  O: 1
});
$c_sci_LazyList$LazyBuilder$DeferredState.prototype.$classData = $d_sci_LazyList$LazyBuilder$DeferredState;
/** @constructor */
function $c_sci_MapNode$() {
  this.sci_MapNode$__f_EmptyMapNode = null;
  $n_sci_MapNode$ = this;
  this.sci_MapNode$__f_EmptyMapNode = new $c_sci_BitmapIndexedMapNode(0, 0, ($m_s_reflect_ManifestFactory$AnyManifest$(), new $ac_O(0)), ($m_s_reflect_ManifestFactory$IntManifest$(), new $ac_I(0)), 0, 0)
}
$c_sci_MapNode$.prototype = new $h_O();
$c_sci_MapNode$.prototype.constructor = $c_sci_MapNode$;
/** @constructor */
function $h_sci_MapNode$() {
  /*<skip>*/
}
$h_sci_MapNode$.prototype = $c_sci_MapNode$.prototype;
var $d_sci_MapNode$ = new $TypeData().initClass({
  sci_MapNode$: 0
}, false, "scala.collection.immutable.MapNode$", {
  sci_MapNode$: 1,
  O: 1
});
$c_sci_MapNode$.prototype.$classData = $d_sci_MapNode$;
var $n_sci_MapNode$;
function $m_sci_MapNode$() {
  if ((!$n_sci_MapNode$)) {
    $n_sci_MapNode$ = new $c_sci_MapNode$()
  };
  return $n_sci_MapNode$
}
function $p_sci_Node__arrayIndexOutOfBounds__O__I__jl_ArrayIndexOutOfBoundsException($thiz, as, ix) {
  return $ct_jl_ArrayIndexOutOfBoundsException__T__(new $c_jl_ArrayIndexOutOfBoundsException(), ((ix + " is out of bounds (min 0, max ") + (((-1) + $m_sr_ScalaRunTime$().array_length__O__I(as)) | 0)))
}
/** @constructor */
function $c_sci_Node() {
  /*<skip>*/
}
$c_sci_Node.prototype = new $h_O();
$c_sci_Node.prototype.constructor = $c_sci_Node;
/** @constructor */
function $h_sci_Node() {
  /*<skip>*/
}
$h_sci_Node.prototype = $c_sci_Node.prototype;
$c_sci_Node.prototype.removeElement__AI__I__AI = (function(as, ix) {
  if ((ix < 0)) {
    throw $p_sci_Node__arrayIndexOutOfBounds__O__I__jl_ArrayIndexOutOfBoundsException(this, as, ix)
  };
  if ((ix > (((-1) + as.u.length) | 0))) {
    throw $p_sci_Node__arrayIndexOutOfBounds__O__I__jl_ArrayIndexOutOfBoundsException(this, as, ix)
  };
  var result = new $ac_I((((-1) + as.u.length) | 0));
  $systemArraycopy(as, 0, result, 0, ix);
  var srcPos = ((1 + ix) | 0);
  var length = (((-1) + ((as.u.length - ix) | 0)) | 0);
  $systemArraycopy(as, srcPos, result, ix, length);
  return result
});
$c_sci_Node.prototype.insertElement__AI__I__I__AI = (function(as, ix, elem) {
  if ((ix < 0)) {
    throw $p_sci_Node__arrayIndexOutOfBounds__O__I__jl_ArrayIndexOutOfBoundsException(this, as, ix)
  };
  if ((ix > as.u.length)) {
    throw $p_sci_Node__arrayIndexOutOfBounds__O__I__jl_ArrayIndexOutOfBoundsException(this, as, ix)
  };
  var result = new $ac_I(((1 + as.u.length) | 0));
  $systemArraycopy(as, 0, result, 0, ix);
  result.set(ix, elem);
  var destPos = ((1 + ix) | 0);
  var length = ((as.u.length - ix) | 0);
  $systemArraycopy(as, ix, result, destPos, length);
  return result
});
var $d_sci_Node = new $TypeData().initClass({
  sci_Node: 0
}, false, "scala.collection.immutable.Node", {
  sci_Node: 1,
  O: 1
});
$c_sci_Node.prototype.$classData = $d_sci_Node;
/** @constructor */
function $c_sci_Node$() {
  this.sci_Node$__f_MaxDepth = 0;
  $n_sci_Node$ = this;
  this.sci_Node$__f_MaxDepth = $doubleToInt($uD(Math.ceil(6.4)))
}
$c_sci_Node$.prototype = new $h_O();
$c_sci_Node$.prototype.constructor = $c_sci_Node$;
/** @constructor */
function $h_sci_Node$() {
  /*<skip>*/
}
$h_sci_Node$.prototype = $c_sci_Node$.prototype;
$c_sci_Node$.prototype.maskFrom__I__I__I = (function(hash, shift) {
  return (31 & ((hash >>> shift) | 0))
});
$c_sci_Node$.prototype.bitposFrom__I__I = (function(mask) {
  return (1 << mask)
});
$c_sci_Node$.prototype.indexFrom__I__I__I = (function(bitmap, bitpos) {
  var i = (bitmap & (((-1) + bitpos) | 0));
  return $m_jl_Integer$().bitCount__I__I(i)
});
$c_sci_Node$.prototype.indexFrom__I__I__I__I = (function(bitmap, mask, bitpos) {
  return ((bitmap === (-1)) ? mask : this.indexFrom__I__I__I(bitmap, bitpos))
});
var $d_sci_Node$ = new $TypeData().initClass({
  sci_Node$: 0
}, false, "scala.collection.immutable.Node$", {
  sci_Node$: 1,
  O: 1
});
$c_sci_Node$.prototype.$classData = $d_sci_Node$;
var $n_sci_Node$;
function $m_sci_Node$() {
  if ((!$n_sci_Node$)) {
    $n_sci_Node$ = new $c_sci_Node$()
  };
  return $n_sci_Node$
}
/** @constructor */
function $c_sci_SetNode$() {
  this.sci_SetNode$__f_EmptySetNode = null;
  $n_sci_SetNode$ = this;
  this.sci_SetNode$__f_EmptySetNode = new $c_sci_BitmapIndexedSetNode(0, 0, ($m_s_reflect_ManifestFactory$AnyManifest$(), new $ac_O(0)), ($m_s_reflect_ManifestFactory$IntManifest$(), new $ac_I(0)), 0, 0)
}
$c_sci_SetNode$.prototype = new $h_O();
$c_sci_SetNode$.prototype.constructor = $c_sci_SetNode$;
/** @constructor */
function $h_sci_SetNode$() {
  /*<skip>*/
}
$h_sci_SetNode$.prototype = $c_sci_SetNode$.prototype;
var $d_sci_SetNode$ = new $TypeData().initClass({
  sci_SetNode$: 0
}, false, "scala.collection.immutable.SetNode$", {
  sci_SetNode$: 1,
  O: 1
});
$c_sci_SetNode$.prototype.$classData = $d_sci_SetNode$;
var $n_sci_SetNode$;
function $m_sci_SetNode$() {
  if ((!$n_sci_SetNode$)) {
    $n_sci_SetNode$ = new $c_sci_SetNode$()
  };
  return $n_sci_SetNode$
}
function $p_sci_VectorSliceBuilder__addSlice__I__AO__I__I__V($thiz, n, a, lo, hi) {
  while (true) {
    if ((n === 1)) {
      var a$1 = a;
      var start = lo;
      var end = hi;
      $p_sci_VectorSliceBuilder__add__I__AO__V($thiz, 1, (((start === 0) && (end === a$1.u.length)) ? a$1 : $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$1, start, end)))
    } else {
      var bitsN = $imul(5, (((-1) + n) | 0));
      var widthN = (1 << bitsN);
      var loN = ((lo >>> bitsN) | 0);
      var hiN = ((hi >>> bitsN) | 0);
      var loRest = (lo & (((-1) + widthN) | 0));
      var hiRest = (hi & (((-1) + widthN) | 0));
      if ((loRest === 0)) {
        if ((hiRest === 0)) {
          var $$x1 = n;
          var a$2 = a;
          $p_sci_VectorSliceBuilder__add__I__AO__V($thiz, $$x1, (((loN === 0) && (hiN === a$2.u.length)) ? a$2 : $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$2, loN, hiN)))
        } else {
          if ((hiN > loN)) {
            var $$x2 = n;
            var a$3 = a;
            $p_sci_VectorSliceBuilder__add__I__AO__V($thiz, $$x2, (((loN === 0) && (hiN === a$3.u.length)) ? a$3 : $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$3, loN, hiN)))
          };
          var temp$n = (((-1) + n) | 0);
          var temp$a = $asArrayOf_O(a.get(hiN), 1);
          n = temp$n;
          a = temp$a;
          lo = 0;
          hi = hiRest;
          continue
        }
      } else if ((hiN === loN)) {
        var temp$n$2 = (((-1) + n) | 0);
        var temp$a$2 = $asArrayOf_O(a.get(loN), 1);
        n = temp$n$2;
        a = temp$a$2;
        lo = loRest;
        hi = hiRest;
        continue
      } else {
        $p_sci_VectorSliceBuilder__addSlice__I__AO__I__I__V($thiz, (((-1) + n) | 0), $asArrayOf_O(a.get(loN), 1), loRest, widthN);
        if ((hiRest === 0)) {
          if ((hiN > ((1 + loN) | 0))) {
            var $$x3 = n;
            var a$4 = a;
            var start$1 = ((1 + loN) | 0);
            $p_sci_VectorSliceBuilder__add__I__AO__V($thiz, $$x3, (((start$1 === 0) && (hiN === a$4.u.length)) ? a$4 : $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$4, start$1, hiN)))
          }
        } else {
          if ((hiN > ((1 + loN) | 0))) {
            var $$x4 = n;
            var a$5 = a;
            var start$2 = ((1 + loN) | 0);
            $p_sci_VectorSliceBuilder__add__I__AO__V($thiz, $$x4, (((start$2 === 0) && (hiN === a$5.u.length)) ? a$5 : $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$5, start$2, hiN)))
          };
          var temp$n$3 = (((-1) + n) | 0);
          var temp$a$3 = $asArrayOf_O(a.get(hiN), 1);
          n = temp$n$3;
          a = temp$a$3;
          lo = 0;
          hi = hiRest;
          continue
        }
      }
    };
    return (void 0)
  }
}
function $p_sci_VectorSliceBuilder__add__I__AO__V($thiz, n, a) {
  if ((n <= $thiz.sci_VectorSliceBuilder__f_maxDim)) {
    var idx = ((11 - n) | 0)
  } else {
    $thiz.sci_VectorSliceBuilder__f_maxDim = n;
    var idx = (((-1) + n) | 0)
  };
  $thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.set(idx, a)
}
function $p_sci_VectorSliceBuilder__balancePrefix__I__V($thiz, n) {
  if (($thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get((((-1) + n) | 0)) === null)) {
    if ((n === $thiz.sci_VectorSliceBuilder__f_maxDim)) {
      $thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.set((((-1) + n) | 0), $thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(((11 - n) | 0)));
      $thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.set(((11 - n) | 0), null)
    } else {
      $p_sci_VectorSliceBuilder__balancePrefix__I__V($thiz, ((1 + n) | 0));
      var $$x1 = $thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices;
      var n$1 = ((1 + n) | 0);
      var preN1 = $asArrayOf_O($$x1.get((((-1) + n$1) | 0)), 2);
      $thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.set((((-1) + n) | 0), preN1.get(0));
      if ((preN1.u.length === 1)) {
        var $$x2 = $thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices;
        var n$2 = ((1 + n) | 0);
        $$x2.set((((-1) + n$2) | 0), null);
        if (($thiz.sci_VectorSliceBuilder__f_maxDim === ((1 + n) | 0))) {
          var $$x4 = $thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices;
          var n$3 = ((1 + n) | 0);
          var $$x3 = ($$x4.get(((11 - n$3) | 0)) === null)
        } else {
          var $$x3 = false
        };
        if ($$x3) {
          $thiz.sci_VectorSliceBuilder__f_maxDim = n
        }
      } else {
        var $$x5 = $thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices;
        var n$4 = ((1 + n) | 0);
        var to = preN1.u.length;
        $$x5.set((((-1) + n$4) | 0), $m_ju_Arrays$().copyOfRange__AO__I__I__AO(preN1, 1, to))
      }
    }
  }
}
function $p_sci_VectorSliceBuilder__balanceSuffix__I__V($thiz, n) {
  if (($thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(((11 - n) | 0)) === null)) {
    if ((n === $thiz.sci_VectorSliceBuilder__f_maxDim)) {
      $thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.set(((11 - n) | 0), $thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get((((-1) + n) | 0)));
      $thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.set((((-1) + n) | 0), null)
    } else {
      $p_sci_VectorSliceBuilder__balanceSuffix__I__V($thiz, ((1 + n) | 0));
      var $$x1 = $thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices;
      var n$1 = ((1 + n) | 0);
      var sufN1 = $asArrayOf_O($$x1.get(((11 - n$1) | 0)), 2);
      $thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.set(((11 - n) | 0), sufN1.get((((-1) + sufN1.u.length) | 0)));
      if ((sufN1.u.length === 1)) {
        var $$x2 = $thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices;
        var n$2 = ((1 + n) | 0);
        $$x2.set(((11 - n$2) | 0), null);
        if (($thiz.sci_VectorSliceBuilder__f_maxDim === ((1 + n) | 0))) {
          var $$x4 = $thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices;
          var n$3 = ((1 + n) | 0);
          var $$x3 = ($$x4.get((((-1) + n$3) | 0)) === null)
        } else {
          var $$x3 = false
        };
        if ($$x3) {
          $thiz.sci_VectorSliceBuilder__f_maxDim = n
        }
      } else {
        var $$x5 = $thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices;
        var n$4 = ((1 + n) | 0);
        var to = (((-1) + sufN1.u.length) | 0);
        $$x5.set(((11 - n$4) | 0), $m_ju_Arrays$().copyOfRange__AO__I__I__AO(sufN1, 0, to))
      }
    }
  }
}
/** @constructor */
function $c_sci_VectorSliceBuilder(lo, hi) {
  this.sci_VectorSliceBuilder__f_lo = 0;
  this.sci_VectorSliceBuilder__f_hi = 0;
  this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices = null;
  this.sci_VectorSliceBuilder__f_len = 0;
  this.sci_VectorSliceBuilder__f_pos = 0;
  this.sci_VectorSliceBuilder__f_maxDim = 0;
  this.sci_VectorSliceBuilder__f_lo = lo;
  this.sci_VectorSliceBuilder__f_hi = hi;
  this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices = new ($d_O.getArrayOf().getArrayOf().constr)(11);
  this.sci_VectorSliceBuilder__f_len = 0;
  this.sci_VectorSliceBuilder__f_pos = 0;
  this.sci_VectorSliceBuilder__f_maxDim = 0
}
$c_sci_VectorSliceBuilder.prototype = new $h_O();
$c_sci_VectorSliceBuilder.prototype.constructor = $c_sci_VectorSliceBuilder;
/** @constructor */
function $h_sci_VectorSliceBuilder() {
  /*<skip>*/
}
$h_sci_VectorSliceBuilder.prototype = $c_sci_VectorSliceBuilder.prototype;
$c_sci_VectorSliceBuilder.prototype.consider__I__AO__V = (function(n, a) {
  var count = $imul(a.u.length, (1 << $imul(5, (((-1) + n) | 0))));
  var a$1 = ((this.sci_VectorSliceBuilder__f_lo - this.sci_VectorSliceBuilder__f_pos) | 0);
  var lo0 = ((a$1 > 0) ? a$1 : 0);
  var a$2 = ((this.sci_VectorSliceBuilder__f_hi - this.sci_VectorSliceBuilder__f_pos) | 0);
  var hi0 = ((a$2 < count) ? a$2 : count);
  if ((hi0 > lo0)) {
    $p_sci_VectorSliceBuilder__addSlice__I__AO__I__I__V(this, n, a, lo0, hi0);
    this.sci_VectorSliceBuilder__f_len = ((this.sci_VectorSliceBuilder__f_len + ((hi0 - lo0) | 0)) | 0)
  };
  this.sci_VectorSliceBuilder__f_pos = ((this.sci_VectorSliceBuilder__f_pos + count) | 0)
});
$c_sci_VectorSliceBuilder.prototype.result__sci_Vector = (function() {
  if ((this.sci_VectorSliceBuilder__f_len <= 32)) {
    if ((this.sci_VectorSliceBuilder__f_len === 0)) {
      return $m_sci_Vector0$()
    } else {
      var prefix1 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(0);
      var suffix1 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(10);
      if ((prefix1 !== null)) {
        if ((suffix1 !== null)) {
          var newLength = ((prefix1.u.length + suffix1.u.length) | 0);
          var dest = $m_ju_Arrays$().copyOf__AO__I__AO(prefix1, newLength);
          var destPos = prefix1.u.length;
          var length = suffix1.u.length;
          $systemArraycopy(suffix1, 0, dest, destPos, length);
          var a = dest
        } else {
          var a = prefix1
        }
      } else if ((suffix1 !== null)) {
        var a = suffix1
      } else {
        var prefix2 = $asArrayOf_O(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(1), 2);
        if ((prefix2 !== null)) {
          var a = prefix2.get(0)
        } else {
          var suffix2 = $asArrayOf_O(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(9), 2);
          var a = suffix2.get(0)
        }
      };
      return new $c_sci_Vector1(a)
    }
  } else {
    $p_sci_VectorSliceBuilder__balancePrefix__I__V(this, 1);
    $p_sci_VectorSliceBuilder__balanceSuffix__I__V(this, 1);
    var resultDim = this.sci_VectorSliceBuilder__f_maxDim;
    if ((resultDim < 6)) {
      var $$x1 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices;
      var n = this.sci_VectorSliceBuilder__f_maxDim;
      var pre = $$x1.get((((-1) + n) | 0));
      var $$x2 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices;
      var n$1 = this.sci_VectorSliceBuilder__f_maxDim;
      var suf = $$x2.get(((11 - n$1) | 0));
      if (((pre !== null) && (suf !== null))) {
        if ((((pre.u.length + suf.u.length) | 0) <= 30)) {
          var $$x3 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices;
          var n$2 = this.sci_VectorSliceBuilder__f_maxDim;
          var newLength$1 = ((pre.u.length + suf.u.length) | 0);
          var dest$1 = $m_ju_Arrays$().copyOf__AO__I__AO(pre, newLength$1);
          var destPos$1 = pre.u.length;
          var length$1 = suf.u.length;
          $systemArraycopy(suf, 0, dest$1, destPos$1, length$1);
          $$x3.set((((-1) + n$2) | 0), dest$1);
          var $$x4 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices;
          var n$3 = this.sci_VectorSliceBuilder__f_maxDim;
          $$x4.set(((11 - n$3) | 0), null)
        } else {
          resultDim = ((1 + resultDim) | 0)
        }
      } else {
        var one = ((pre !== null) ? pre : suf);
        if ((one.u.length > 30)) {
          resultDim = ((1 + resultDim) | 0)
        }
      }
    };
    var prefix1$2 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(0);
    var suffix1$2 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(10);
    var len1 = prefix1$2.u.length;
    var x1 = resultDim;
    switch (x1) {
      case 2: {
        var a$1 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
        var p = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(1);
        if ((p !== null)) {
          var $$x5 = p
        } else {
          var s = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(9);
          var $$x5 = ((s !== null) ? s : a$1)
        };
        var data2 = $asArrayOf_O($$x5, 2);
        var res = new $c_sci_Vector2(prefix1$2, len1, data2, suffix1$2, this.sci_VectorSliceBuilder__f_len);
        break
      }
      case 3: {
        var a$2 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
        var p$1 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(1);
        var prefix2$2 = $asArrayOf_O(((p$1 !== null) ? p$1 : a$2), 2);
        var a$3 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
        var p$2 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(2);
        if ((p$2 !== null)) {
          var $$x6 = p$2
        } else {
          var s$1 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(8);
          var $$x6 = ((s$1 !== null) ? s$1 : a$3)
        };
        var data3 = $asArrayOf_O($$x6, 3);
        var a$4 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
        var s$2 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(9);
        var suffix2$2 = $asArrayOf_O(((s$2 !== null) ? s$2 : a$4), 2);
        var len12 = ((len1 + (prefix2$2.u.length << 5)) | 0);
        var res = new $c_sci_Vector3(prefix1$2, len1, prefix2$2, len12, data3, suffix2$2, suffix1$2, this.sci_VectorSliceBuilder__f_len);
        break
      }
      case 4: {
        var a$5 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
        var p$3 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(1);
        var prefix2$3 = $asArrayOf_O(((p$3 !== null) ? p$3 : a$5), 2);
        var a$6 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
        var p$4 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(2);
        var prefix3 = $asArrayOf_O(((p$4 !== null) ? p$4 : a$6), 3);
        var a$7 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
        var p$5 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(3);
        if ((p$5 !== null)) {
          var $$x7 = p$5
        } else {
          var s$3 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(7);
          var $$x7 = ((s$3 !== null) ? s$3 : a$7)
        };
        var data4 = $asArrayOf_O($$x7, 4);
        var a$8 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
        var s$4 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(8);
        var suffix3 = $asArrayOf_O(((s$4 !== null) ? s$4 : a$8), 3);
        var a$9 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
        var s$5 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(9);
        var suffix2$3 = $asArrayOf_O(((s$5 !== null) ? s$5 : a$9), 2);
        var len12$2 = ((len1 + (prefix2$3.u.length << 5)) | 0);
        var len123 = ((len12$2 + (prefix3.u.length << 10)) | 0);
        var res = new $c_sci_Vector4(prefix1$2, len1, prefix2$3, len12$2, prefix3, len123, data4, suffix3, suffix2$3, suffix1$2, this.sci_VectorSliceBuilder__f_len);
        break
      }
      case 5: {
        var a$10 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
        var p$6 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(1);
        var prefix2$4 = $asArrayOf_O(((p$6 !== null) ? p$6 : a$10), 2);
        var a$11 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
        var p$7 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(2);
        var prefix3$2 = $asArrayOf_O(((p$7 !== null) ? p$7 : a$11), 3);
        var a$12 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
        var p$8 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(3);
        var prefix4 = $asArrayOf_O(((p$8 !== null) ? p$8 : a$12), 4);
        var a$13 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty5;
        var p$9 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(4);
        if ((p$9 !== null)) {
          var $$x8 = p$9
        } else {
          var s$6 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(6);
          var $$x8 = ((s$6 !== null) ? s$6 : a$13)
        };
        var data5 = $asArrayOf_O($$x8, 5);
        var a$14 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
        var s$7 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(7);
        var suffix4 = $asArrayOf_O(((s$7 !== null) ? s$7 : a$14), 4);
        var a$15 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
        var s$8 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(8);
        var suffix3$2 = $asArrayOf_O(((s$8 !== null) ? s$8 : a$15), 3);
        var a$16 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
        var s$9 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(9);
        var suffix2$4 = $asArrayOf_O(((s$9 !== null) ? s$9 : a$16), 2);
        var len12$3 = ((len1 + (prefix2$4.u.length << 5)) | 0);
        var len123$2 = ((len12$3 + (prefix3$2.u.length << 10)) | 0);
        var len1234 = ((len123$2 + (prefix4.u.length << 15)) | 0);
        var res = new $c_sci_Vector5(prefix1$2, len1, prefix2$4, len12$3, prefix3$2, len123$2, prefix4, len1234, data5, suffix4, suffix3$2, suffix2$4, suffix1$2, this.sci_VectorSliceBuilder__f_len);
        break
      }
      case 6: {
        var a$17 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
        var p$10 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(1);
        var prefix2$5 = $asArrayOf_O(((p$10 !== null) ? p$10 : a$17), 2);
        var a$18 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
        var p$11 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(2);
        var prefix3$3 = $asArrayOf_O(((p$11 !== null) ? p$11 : a$18), 3);
        var a$19 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
        var p$12 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(3);
        var prefix4$2 = $asArrayOf_O(((p$12 !== null) ? p$12 : a$19), 4);
        var a$20 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty5;
        var p$13 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(4);
        var prefix5 = $asArrayOf_O(((p$13 !== null) ? p$13 : a$20), 5);
        var a$21 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty6;
        var p$14 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(5);
        if ((p$14 !== null)) {
          var $$x9 = p$14
        } else {
          var s$10 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(5);
          var $$x9 = ((s$10 !== null) ? s$10 : a$21)
        };
        var data6 = $asArrayOf_O($$x9, 6);
        var a$22 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty5;
        var s$11 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(6);
        var suffix5 = $asArrayOf_O(((s$11 !== null) ? s$11 : a$22), 5);
        var a$23 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
        var s$12 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(7);
        var suffix4$2 = $asArrayOf_O(((s$12 !== null) ? s$12 : a$23), 4);
        var a$24 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
        var s$13 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(8);
        var suffix3$3 = $asArrayOf_O(((s$13 !== null) ? s$13 : a$24), 3);
        var a$25 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
        var s$14 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(9);
        var suffix2$5 = $asArrayOf_O(((s$14 !== null) ? s$14 : a$25), 2);
        var len12$4 = ((len1 + (prefix2$5.u.length << 5)) | 0);
        var len123$3 = ((len12$4 + (prefix3$3.u.length << 10)) | 0);
        var len1234$2 = ((len123$3 + (prefix4$2.u.length << 15)) | 0);
        var len12345 = ((len1234$2 + (prefix5.u.length << 20)) | 0);
        var res = new $c_sci_Vector6(prefix1$2, len1, prefix2$5, len12$4, prefix3$3, len123$3, prefix4$2, len1234$2, prefix5, len12345, data6, suffix5, suffix4$2, suffix3$3, suffix2$5, suffix1$2, this.sci_VectorSliceBuilder__f_len);
        break
      }
      default: {
        var res;
        throw new $c_s_MatchError(x1)
      }
    };
    return res
  }
});
$c_sci_VectorSliceBuilder.prototype.toString__T = (function() {
  return (((((((((("VectorSliceBuilder(lo=" + this.sci_VectorSliceBuilder__f_lo) + ", hi=") + this.sci_VectorSliceBuilder__f_hi) + ", len=") + this.sci_VectorSliceBuilder__f_len) + ", pos=") + this.sci_VectorSliceBuilder__f_pos) + ", maxDim=") + this.sci_VectorSliceBuilder__f_maxDim) + ")")
});
var $d_sci_VectorSliceBuilder = new $TypeData().initClass({
  sci_VectorSliceBuilder: 0
}, false, "scala.collection.immutable.VectorSliceBuilder", {
  sci_VectorSliceBuilder: 1,
  O: 1
});
$c_sci_VectorSliceBuilder.prototype.$classData = $d_sci_VectorSliceBuilder;
/** @constructor */
function $c_sci_VectorStatics$() {
  this.sci_VectorStatics$__f_empty1 = null;
  this.sci_VectorStatics$__f_empty2 = null;
  this.sci_VectorStatics$__f_empty3 = null;
  this.sci_VectorStatics$__f_empty4 = null;
  this.sci_VectorStatics$__f_empty5 = null;
  this.sci_VectorStatics$__f_empty6 = null;
  $n_sci_VectorStatics$ = this;
  this.sci_VectorStatics$__f_empty1 = new $ac_O(0);
  this.sci_VectorStatics$__f_empty2 = new ($d_O.getArrayOf().getArrayOf().constr)(0);
  this.sci_VectorStatics$__f_empty3 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().constr)(0);
  this.sci_VectorStatics$__f_empty4 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(0);
  this.sci_VectorStatics$__f_empty5 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(0);
  this.sci_VectorStatics$__f_empty6 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(0)
}
$c_sci_VectorStatics$.prototype = new $h_O();
$c_sci_VectorStatics$.prototype.constructor = $c_sci_VectorStatics$;
/** @constructor */
function $h_sci_VectorStatics$() {
  /*<skip>*/
}
$h_sci_VectorStatics$.prototype = $c_sci_VectorStatics$.prototype;
$c_sci_VectorStatics$.prototype.copyAppend1__AO__O__AO = (function(a, elem) {
  var alen = a.u.length;
  var ac = new $ac_O(((1 + alen) | 0));
  $systemArraycopy(a, 0, ac, 0, alen);
  ac.set(alen, elem);
  return ac
});
$c_sci_VectorStatics$.prototype.copyAppend__AO__O__AO = (function(a, elem) {
  var newLength = ((1 + a.u.length) | 0);
  var ac = $m_ju_Arrays$().copyOf__AO__I__AO(a, newLength);
  ac.set((((-1) + ac.u.length) | 0), elem);
  return ac
});
$c_sci_VectorStatics$.prototype.copyPrepend1__O__AO__AO = (function(elem, a) {
  var ac = new $ac_O(((1 + a.u.length) | 0));
  var length = a.u.length;
  $systemArraycopy(a, 0, ac, 1, length);
  ac.set(0, elem);
  return ac
});
$c_sci_VectorStatics$.prototype.copyPrepend__O__AO__AO = (function(elem, a) {
  var componentType = $objectGetClass(a).getComponentType__jl_Class();
  var length = ((1 + a.u.length) | 0);
  var ac = $asArrayOf_O($m_jl_reflect_Array$().newInstance__jl_Class__I__O(componentType, length), 1);
  var length$1 = a.u.length;
  $systemArraycopy(a, 0, ac, 1, length$1);
  ac.set(0, elem);
  return ac
});
$c_sci_VectorStatics$.prototype.foreachRec__I__AO__F1__V = (function(level, a, f) {
  var i = 0;
  var len = a.u.length;
  if ((level === 0)) {
    while ((i < len)) {
      f.apply__O__O(a.get(i));
      i = ((1 + i) | 0)
    }
  } else {
    var l = (((-1) + level) | 0);
    while ((i < len)) {
      this.foreachRec__I__AO__F1__V(l, $asArrayOf_O(a.get(i), 1), f);
      i = ((1 + i) | 0)
    }
  }
});
$c_sci_VectorStatics$.prototype.mapElems1__AO__F1__AO = (function(a, f) {
  var i = 0;
  while ((i < a.u.length)) {
    var v1 = a.get(i);
    var v2 = f.apply__O__O(v1);
    if ((!$is(v1, v2))) {
      return this.mapElems1Rest__AO__F1__I__O__AO(a, f, i, v2)
    };
    i = ((1 + i) | 0)
  };
  return a
});
$c_sci_VectorStatics$.prototype.mapElems1Rest__AO__F1__I__O__AO = (function(a, f, at, v2) {
  var ac = new $ac_O(a.u.length);
  if ((at > 0)) {
    $systemArraycopy(a, 0, ac, 0, at)
  };
  ac.set(at, v2);
  var i = ((1 + at) | 0);
  while ((i < a.u.length)) {
    ac.set(i, f.apply__O__O(a.get(i)));
    i = ((1 + i) | 0)
  };
  return ac
});
$c_sci_VectorStatics$.prototype.mapElems__I__AO__F1__AO = (function(n, a, f) {
  if ((n === 1)) {
    return this.mapElems1__AO__F1__AO(a, f)
  } else {
    var i = 0;
    while ((i < a.u.length)) {
      var v1 = a.get(i);
      var v2 = this.mapElems__I__AO__F1__AO((((-1) + n) | 0), $asArrayOf_O(v1, 1), f);
      if ((v1 !== v2)) {
        return this.mapElemsRest__I__AO__F1__I__O__AO(n, a, f, i, v2)
      };
      i = ((1 + i) | 0)
    };
    return a
  }
});
$c_sci_VectorStatics$.prototype.mapElemsRest__I__AO__F1__I__O__AO = (function(n, a, f, at, v2) {
  var componentType = $objectGetClass(a).getComponentType__jl_Class();
  var length = a.u.length;
  var ac = $asArrayOf_O($m_jl_reflect_Array$().newInstance__jl_Class__I__O(componentType, length), 1);
  if ((at > 0)) {
    $systemArraycopy(a, 0, ac, 0, at)
  };
  ac.set(at, v2);
  var i = ((1 + at) | 0);
  while ((i < a.u.length)) {
    ac.set(i, this.mapElems__I__AO__F1__AO((((-1) + n) | 0), $asArrayOf_O(a.get(i), 1), f));
    i = ((1 + i) | 0)
  };
  return ac
});
$c_sci_VectorStatics$.prototype.append1IfSpace__AO__sc_IterableOnce__AO = (function(suffix1, xs) {
  if ($is_sci_Iterable(xs)) {
    var x2 = $as_sci_Iterable(xs);
    if ((x2.sizeCompare__I__I(((32 - suffix1.u.length) | 0)) <= 0)) {
      var x1$2 = x2.size__I();
      switch (x1$2) {
        case 0: {
          return null;
          break
        }
        case 1: {
          return this.copyAppend__AO__O__AO(suffix1, x2.head__O());
          break
        }
        default: {
          var newLength = ((suffix1.u.length + x1$2) | 0);
          var suffix1b = $m_ju_Arrays$().copyOf__AO__I__AO(suffix1, newLength);
          var start = suffix1.u.length;
          x2.copyToArray__O__I__I__I(suffix1b, start, 2147483647);
          return suffix1b
        }
      }
    } else {
      return null
    }
  } else {
    var s = xs.knownSize__I();
    if (((s > 0) && (s <= ((32 - suffix1.u.length) | 0)))) {
      var newLength$1 = ((suffix1.u.length + s) | 0);
      var suffix1b$2 = $m_ju_Arrays$().copyOf__AO__I__AO(suffix1, newLength$1);
      var this$1 = xs.iterator__sc_Iterator();
      var start$1 = suffix1.u.length;
      this$1.copyToArray__O__I__I__I(suffix1b$2, start$1, 2147483647);
      return suffix1b$2
    } else {
      return null
    }
  }
});
var $d_sci_VectorStatics$ = new $TypeData().initClass({
  sci_VectorStatics$: 0
}, false, "scala.collection.immutable.VectorStatics$", {
  sci_VectorStatics$: 1,
  O: 1
});
$c_sci_VectorStatics$.prototype.$classData = $d_sci_VectorStatics$;
var $n_sci_VectorStatics$;
function $m_sci_VectorStatics$() {
  if ((!$n_sci_VectorStatics$)) {
    $n_sci_VectorStatics$ = new $c_sci_VectorStatics$()
  };
  return $n_sci_VectorStatics$
}
/** @constructor */
function $c_scm_HashMap$Node(_key, _hash, _value, _next) {
  this.scm_HashMap$Node__f__key = null;
  this.scm_HashMap$Node__f__hash = 0;
  this.scm_HashMap$Node__f__value = null;
  this.scm_HashMap$Node__f__next = null;
  this.scm_HashMap$Node__f__key = _key;
  this.scm_HashMap$Node__f__hash = _hash;
  this.scm_HashMap$Node__f__value = _value;
  this.scm_HashMap$Node__f__next = _next
}
$c_scm_HashMap$Node.prototype = new $h_O();
$c_scm_HashMap$Node.prototype.constructor = $c_scm_HashMap$Node;
/** @constructor */
function $h_scm_HashMap$Node() {
  /*<skip>*/
}
$h_scm_HashMap$Node.prototype = $c_scm_HashMap$Node.prototype;
$c_scm_HashMap$Node.prototype.findNode__O__I__scm_HashMap$Node = (function(k, h) {
  var _$this = this;
  while (true) {
    if (((h === _$this.scm_HashMap$Node__f__hash) && $m_sr_BoxesRunTime$().equals__O__O__Z(k, _$this.scm_HashMap$Node__f__key))) {
      return _$this
    } else if (((_$this.scm_HashMap$Node__f__next === null) || (_$this.scm_HashMap$Node__f__hash > h))) {
      return null
    } else {
      _$this = _$this.scm_HashMap$Node__f__next
    }
  }
});
$c_scm_HashMap$Node.prototype.foreach__F1__V = (function(f) {
  var _$this = this;
  while (true) {
    f.apply__O__O(new $c_T2(_$this.scm_HashMap$Node__f__key, _$this.scm_HashMap$Node__f__value));
    if ((_$this.scm_HashMap$Node__f__next !== null)) {
      _$this = _$this.scm_HashMap$Node__f__next;
      continue
    };
    break
  }
});
$c_scm_HashMap$Node.prototype.toString__T = (function() {
  return ((((((("Node(" + this.scm_HashMap$Node__f__key) + ", ") + this.scm_HashMap$Node__f__value) + ", ") + this.scm_HashMap$Node__f__hash) + ") -> ") + this.scm_HashMap$Node__f__next)
});
function $as_scm_HashMap$Node(obj) {
  return (((obj instanceof $c_scm_HashMap$Node) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.HashMap$Node"))
}
function $isArrayOf_scm_HashMap$Node(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_HashMap$Node)))
}
function $asArrayOf_scm_HashMap$Node(obj, depth) {
  return (($isArrayOf_scm_HashMap$Node(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.HashMap$Node;", depth))
}
var $d_scm_HashMap$Node = new $TypeData().initClass({
  scm_HashMap$Node: 0
}, false, "scala.collection.mutable.HashMap$Node", {
  scm_HashMap$Node: 1,
  O: 1
});
$c_scm_HashMap$Node.prototype.$classData = $d_scm_HashMap$Node;
/** @constructor */
function $c_scm_MutationTracker$() {
  /*<skip>*/
}
$c_scm_MutationTracker$.prototype = new $h_O();
$c_scm_MutationTracker$.prototype.constructor = $c_scm_MutationTracker$;
/** @constructor */
function $h_scm_MutationTracker$() {
  /*<skip>*/
}
$h_scm_MutationTracker$.prototype = $c_scm_MutationTracker$.prototype;
$c_scm_MutationTracker$.prototype.checkMutations__I__I__T__V = (function(expectedCount, actualCount, message) {
  if ((actualCount !== expectedCount)) {
    throw new $c_ju_ConcurrentModificationException(message)
  }
});
var $d_scm_MutationTracker$ = new $TypeData().initClass({
  scm_MutationTracker$: 0
}, false, "scala.collection.mutable.MutationTracker$", {
  scm_MutationTracker$: 1,
  O: 1
});
$c_scm_MutationTracker$.prototype.$classData = $d_scm_MutationTracker$;
var $n_scm_MutationTracker$;
function $m_scm_MutationTracker$() {
  if ((!$n_scm_MutationTracker$)) {
    $n_scm_MutationTracker$ = new $c_scm_MutationTracker$()
  };
  return $n_scm_MutationTracker$
}
/** @constructor */
function $c_sc_package$$colon$plus$() {
  /*<skip>*/
}
$c_sc_package$$colon$plus$.prototype = new $h_O();
$c_sc_package$$colon$plus$.prototype.constructor = $c_sc_package$$colon$plus$;
/** @constructor */
function $h_sc_package$$colon$plus$() {
  /*<skip>*/
}
$h_sc_package$$colon$plus$.prototype = $c_sc_package$$colon$plus$.prototype;
var $d_sc_package$$colon$plus$ = new $TypeData().initClass({
  sc_package$$colon$plus$: 0
}, false, "scala.collection.package$$colon$plus$", {
  sc_package$$colon$plus$: 1,
  O: 1
});
$c_sc_package$$colon$plus$.prototype.$classData = $d_sc_package$$colon$plus$;
var $n_sc_package$$colon$plus$;
function $m_sc_package$$colon$plus$() {
  if ((!$n_sc_package$$colon$plus$)) {
    $n_sc_package$$colon$plus$ = new $c_sc_package$$colon$plus$()
  };
  return $n_sc_package$$colon$plus$
}
/** @constructor */
function $c_sc_package$$plus$colon$() {
  /*<skip>*/
}
$c_sc_package$$plus$colon$.prototype = new $h_O();
$c_sc_package$$plus$colon$.prototype.constructor = $c_sc_package$$plus$colon$;
/** @constructor */
function $h_sc_package$$plus$colon$() {
  /*<skip>*/
}
$h_sc_package$$plus$colon$.prototype = $c_sc_package$$plus$colon$.prototype;
var $d_sc_package$$plus$colon$ = new $TypeData().initClass({
  sc_package$$plus$colon$: 0
}, false, "scala.collection.package$$plus$colon$", {
  sc_package$$plus$colon$: 1,
  O: 1
});
$c_sc_package$$plus$colon$.prototype.$classData = $d_sc_package$$plus$colon$;
var $n_sc_package$$plus$colon$;
function $m_sc_package$$plus$colon$() {
  if ((!$n_sc_package$$plus$colon$)) {
    $n_sc_package$$plus$colon$ = new $c_sc_package$$plus$colon$()
  };
  return $n_sc_package$$plus$colon$
}
function $p_s_concurrent_BatchingExecutor$AbstractBatch__ensureCapacity__I__Ajl_Runnable($thiz, curSize) {
  var curOther = $thiz.s_concurrent_BatchingExecutor$AbstractBatch__f_other;
  var curLen = curOther.u.length;
  if ((curSize <= curLen)) {
    return curOther
  } else {
    var newLen = ((curLen === 0) ? 4 : (curLen << 1));
    if ((newLen <= curLen)) {
      throw new $c_jl_StackOverflowError(("Space limit of asynchronous stack reached: " + curLen))
    };
    var newOther = new ($d_jl_Runnable.getArrayOf().constr)(newLen);
    $systemArraycopy(curOther, 0, newOther, 0, curLen);
    $thiz.s_concurrent_BatchingExecutor$AbstractBatch__f_other = newOther;
    return newOther
  }
}
function $ct_s_concurrent_BatchingExecutor$AbstractBatch__s_concurrent_BatchingExecutor__jl_Runnable__Ajl_Runnable__I__($thiz, outer, first, other, size) {
  $thiz.s_concurrent_BatchingExecutor$AbstractBatch__f_first = first;
  $thiz.s_concurrent_BatchingExecutor$AbstractBatch__f_other = other;
  $thiz.s_concurrent_BatchingExecutor$AbstractBatch__f_size = size;
  if ((outer === null)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(null)
  } else {
    $thiz.s_concurrent_BatchingExecutor$AbstractBatch__f_$outer = outer
  };
  return $thiz
}
/** @constructor */
function $c_s_concurrent_BatchingExecutor$AbstractBatch() {
  this.s_concurrent_BatchingExecutor$AbstractBatch__f_first = null;
  this.s_concurrent_BatchingExecutor$AbstractBatch__f_other = null;
  this.s_concurrent_BatchingExecutor$AbstractBatch__f_size = 0;
  this.s_concurrent_BatchingExecutor$AbstractBatch__f_$outer = null
}
$c_s_concurrent_BatchingExecutor$AbstractBatch.prototype = new $h_O();
$c_s_concurrent_BatchingExecutor$AbstractBatch.prototype.constructor = $c_s_concurrent_BatchingExecutor$AbstractBatch;
/** @constructor */
function $h_s_concurrent_BatchingExecutor$AbstractBatch() {
  /*<skip>*/
}
$h_s_concurrent_BatchingExecutor$AbstractBatch.prototype = $c_s_concurrent_BatchingExecutor$AbstractBatch.prototype;
$c_s_concurrent_BatchingExecutor$AbstractBatch.prototype.push__jl_Runnable__V = (function(r) {
  var sz = this.s_concurrent_BatchingExecutor$AbstractBatch__f_size;
  if ((sz === 0)) {
    this.s_concurrent_BatchingExecutor$AbstractBatch__f_first = r
  } else {
    $p_s_concurrent_BatchingExecutor$AbstractBatch__ensureCapacity__I__Ajl_Runnable(this, sz).set((((-1) + sz) | 0), r)
  };
  this.s_concurrent_BatchingExecutor$AbstractBatch__f_size = ((1 + sz) | 0)
});
$c_s_concurrent_BatchingExecutor$AbstractBatch.prototype.runN__I__V = (function(n) {
  while (true) {
    if ((n > 0)) {
      var x1 = this.s_concurrent_BatchingExecutor$AbstractBatch__f_size;
      switch (x1) {
        case 0: {
          break
        }
        case 1: {
          var next = this.s_concurrent_BatchingExecutor$AbstractBatch__f_first;
          this.s_concurrent_BatchingExecutor$AbstractBatch__f_first = null;
          this.s_concurrent_BatchingExecutor$AbstractBatch__f_size = 0;
          next.run__V();
          n = (((-1) + n) | 0);
          continue;
          break
        }
        default: {
          var o = this.s_concurrent_BatchingExecutor$AbstractBatch__f_other;
          var next$2 = o.get((((-2) + x1) | 0));
          o.set((((-2) + x1) | 0), null);
          this.s_concurrent_BatchingExecutor$AbstractBatch__f_size = (((-1) + x1) | 0);
          next$2.run__V();
          n = (((-1) + n) | 0);
          continue
        }
      }
    };
    return (void 0)
  }
});
/** @constructor */
function $c_s_concurrent_BatchingExecutorStatics$() {
  this.s_concurrent_BatchingExecutorStatics$__f_emptyBatchArray = null;
  $n_s_concurrent_BatchingExecutorStatics$ = this;
  this.s_concurrent_BatchingExecutorStatics$__f_emptyBatchArray = new ($d_jl_Runnable.getArrayOf().constr)(0)
}
$c_s_concurrent_BatchingExecutorStatics$.prototype = new $h_O();
$c_s_concurrent_BatchingExecutorStatics$.prototype.constructor = $c_s_concurrent_BatchingExecutorStatics$;
/** @constructor */
function $h_s_concurrent_BatchingExecutorStatics$() {
  /*<skip>*/
}
$h_s_concurrent_BatchingExecutorStatics$.prototype = $c_s_concurrent_BatchingExecutorStatics$.prototype;
var $d_s_concurrent_BatchingExecutorStatics$ = new $TypeData().initClass({
  s_concurrent_BatchingExecutorStatics$: 0
}, false, "scala.concurrent.BatchingExecutorStatics$", {
  s_concurrent_BatchingExecutorStatics$: 1,
  O: 1
});
$c_s_concurrent_BatchingExecutorStatics$.prototype.$classData = $d_s_concurrent_BatchingExecutorStatics$;
var $n_s_concurrent_BatchingExecutorStatics$;
function $m_s_concurrent_BatchingExecutorStatics$() {
  if ((!$n_s_concurrent_BatchingExecutorStatics$)) {
    $n_s_concurrent_BatchingExecutorStatics$ = new $c_s_concurrent_BatchingExecutorStatics$()
  };
  return $n_s_concurrent_BatchingExecutorStatics$
}
function $p_s_concurrent_ExecutionContext$__global$lzycompute__s_concurrent_ExecutionContextExecutor($thiz) {
  if ((!$thiz.s_concurrent_ExecutionContext$__f_bitmap$0)) {
    $thiz.s_concurrent_ExecutionContext$__f_global = $m_sjs_concurrent_JSExecutionContext$().sjs_concurrent_JSExecutionContext$__f_queue;
    $thiz.s_concurrent_ExecutionContext$__f_bitmap$0 = true
  };
  return $thiz.s_concurrent_ExecutionContext$__f_global
}
/** @constructor */
function $c_s_concurrent_ExecutionContext$() {
  this.s_concurrent_ExecutionContext$__f_global = null;
  this.s_concurrent_ExecutionContext$__f_defaultReporter = null;
  this.s_concurrent_ExecutionContext$__f_bitmap$0 = false;
  $n_s_concurrent_ExecutionContext$ = this;
  this.s_concurrent_ExecutionContext$__f_defaultReporter = new $c_sjsr_AnonFunction1((function(this$1) {
    return (function(x$1$2) {
      var x$1 = $as_jl_Throwable(x$1$2);
      x$1.printStackTrace__Ljava_io_PrintStream__V($m_jl_System$Streams$().jl_System$Streams$__f_err)
    })
  })(this))
}
$c_s_concurrent_ExecutionContext$.prototype = new $h_O();
$c_s_concurrent_ExecutionContext$.prototype.constructor = $c_s_concurrent_ExecutionContext$;
/** @constructor */
function $h_s_concurrent_ExecutionContext$() {
  /*<skip>*/
}
$h_s_concurrent_ExecutionContext$.prototype = $c_s_concurrent_ExecutionContext$.prototype;
$c_s_concurrent_ExecutionContext$.prototype.global__s_concurrent_ExecutionContextExecutor = (function() {
  return ((!this.s_concurrent_ExecutionContext$__f_bitmap$0) ? $p_s_concurrent_ExecutionContext$__global$lzycompute__s_concurrent_ExecutionContextExecutor(this) : this.s_concurrent_ExecutionContext$__f_global)
});
var $d_s_concurrent_ExecutionContext$ = new $TypeData().initClass({
  s_concurrent_ExecutionContext$: 0
}, false, "scala.concurrent.ExecutionContext$", {
  s_concurrent_ExecutionContext$: 1,
  O: 1
});
$c_s_concurrent_ExecutionContext$.prototype.$classData = $d_s_concurrent_ExecutionContext$;
var $n_s_concurrent_ExecutionContext$;
function $m_s_concurrent_ExecutionContext$() {
  if ((!$n_s_concurrent_ExecutionContext$)) {
    $n_s_concurrent_ExecutionContext$ = new $c_s_concurrent_ExecutionContext$()
  };
  return $n_s_concurrent_ExecutionContext$
}
/** @constructor */
function $c_s_concurrent_Future$() {
  this.s_concurrent_Future$__f_toBoxed = null;
  this.s_concurrent_Future$__f__cachedId = null;
  this.s_concurrent_Future$__f_collectFailed = null;
  this.s_concurrent_Future$__f_filterFailure = null;
  this.s_concurrent_Future$__f_failedFailure = null;
  this.s_concurrent_Future$__f_failedFailureFuture = null;
  this.s_concurrent_Future$__f__failedFun = null;
  this.s_concurrent_Future$__f_recoverWithFailedMarker = null;
  this.s_concurrent_Future$__f_recoverWithFailed = null;
  this.s_concurrent_Future$__f__zipWithTuple2 = null;
  this.s_concurrent_Future$__f__addToBuilderFun = null;
  this.s_concurrent_Future$__f_unit = null;
  $n_s_concurrent_Future$ = this;
  var this$22 = $m_s_Predef$().s_Predef$__f_Map;
  var array = [new $c_T2($d_Z.getClassOf(), $d_jl_Boolean.getClassOf()), new $c_T2($d_B.getClassOf(), $d_jl_Byte.getClassOf()), new $c_T2($d_C.getClassOf(), $d_jl_Character.getClassOf()), new $c_T2($d_S.getClassOf(), $d_jl_Short.getClassOf()), new $c_T2($d_I.getClassOf(), $d_jl_Integer.getClassOf()), new $c_T2($d_J.getClassOf(), $d_jl_Long.getClassOf()), new $c_T2($d_F.getClassOf(), $d_jl_Float.getClassOf()), new $c_T2($d_D.getClassOf(), $d_jl_Double.getClassOf()), new $c_T2($d_V.getClassOf(), $d_jl_Void.getClassOf())];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.s_concurrent_Future$__f_toBoxed = this$22.from__sc_IterableOnce__sci_Map(elems);
  this.s_concurrent_Future$__f__cachedId = new $c_sjsr_AnonFunction1((function(this$23) {
    return (function(x$2) {
      return x$2
    })
  })(this));
  this.s_concurrent_Future$__f_collectFailed = new $c_sjsr_AnonFunction1((function(this$2$1) {
    return (function(t$2) {
      throw new $c_s_concurrent_Future$$anon$1(t$2)
    })
  })(this));
  this.s_concurrent_Future$__f_filterFailure = new $c_s_util_Failure(new $c_s_concurrent_Future$$anon$2());
  this.s_concurrent_Future$__f_failedFailure = new $c_s_util_Failure(new $c_s_concurrent_Future$$anon$3());
  this.s_concurrent_Future$__f_failedFailureFuture = $m_s_concurrent_Future$().fromTry__s_util_Try__s_concurrent_Future(this.s_concurrent_Future$__f_failedFailure);
  this.s_concurrent_Future$__f__failedFun = new $c_sjsr_AnonFunction1((function(this$3$1) {
    return (function(v$2) {
      var v = $as_s_util_Try(v$2);
      return ((v instanceof $c_s_util_Failure) ? new $c_s_util_Success($as_s_util_Failure(v).s_util_Failure__f_exception) : $m_s_concurrent_Future$().s_concurrent_Future$__f_failedFailure)
    })
  })(this));
  this.s_concurrent_Future$__f_recoverWithFailedMarker = $m_s_concurrent_Future$().failed__jl_Throwable__s_concurrent_Future(new $c_s_concurrent_Future$$anon$4());
  this.s_concurrent_Future$__f_recoverWithFailed = new $c_sjsr_AnonFunction1((function(this$4$1) {
    return (function(t$3$2) {
      $as_jl_Throwable(t$3$2);
      return $m_s_concurrent_Future$().s_concurrent_Future$__f_recoverWithFailedMarker
    })
  })(this));
  this.s_concurrent_Future$__f__zipWithTuple2 = new $c_sjsr_AnonFunction2((function(this$5$1) {
    return (function(_1$2, _2$2) {
      return new $c_T2(_1$2, _2$2)
    })
  })(this));
  this.s_concurrent_Future$__f__addToBuilderFun = new $c_sjsr_AnonFunction2((function(this$6$1) {
    return (function(b$2, e$2) {
      var b = $as_scm_Builder(b$2);
      return $as_scm_Builder(b.addOne__O__scm_Growable(e$2))
    })
  })(this));
  this.s_concurrent_Future$__f_unit = this.fromTry__s_util_Try__s_concurrent_Future(new $c_s_util_Success((void 0)))
}
$c_s_concurrent_Future$.prototype = new $h_O();
$c_s_concurrent_Future$.prototype.constructor = $c_s_concurrent_Future$;
/** @constructor */
function $h_s_concurrent_Future$() {
  /*<skip>*/
}
$h_s_concurrent_Future$.prototype = $c_s_concurrent_Future$.prototype;
$c_s_concurrent_Future$.prototype.failed__jl_Throwable__s_concurrent_Future = (function(exception) {
  return $m_s_concurrent_Promise$().failed__jl_Throwable__s_concurrent_Promise(exception)
});
$c_s_concurrent_Future$.prototype.successful__O__s_concurrent_Future = (function(result) {
  return $m_s_concurrent_Promise$().successful__O__s_concurrent_Promise(result)
});
$c_s_concurrent_Future$.prototype.fromTry__s_util_Try__s_concurrent_Future = (function(result) {
  return $ct_s_concurrent_impl_Promise$DefaultPromise__s_util_Try__(new $c_s_concurrent_impl_Promise$DefaultPromise(), result)
});
$c_s_concurrent_Future$.prototype.sequence__sc_IterableOnce__sc_BuildFrom__s_concurrent_ExecutionContext__s_concurrent_Future = (function(in$1, bf, executor) {
  var this$1 = in$1.iterator__sc_Iterator();
  var z = this.successful__O__s_concurrent_Future(bf.newBuilder__O__scm_Builder(in$1));
  var result = z;
  while (this$1.hasNext__Z()) {
    var arg1 = result;
    var arg2 = this$1.next__O();
    var fr = $as_s_concurrent_Future(arg1);
    var fa = $as_s_concurrent_Future(arg2);
    var f = $m_s_concurrent_Future$().s_concurrent_Future$__f__addToBuilderFun;
    result = $f_s_concurrent_Future__zipWith__s_concurrent_Future__F2__s_concurrent_ExecutionContext__s_concurrent_Future(fr, fa, f, executor)
  };
  return $as_s_concurrent_Future(result).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1((function(this$2) {
    return (function(x$6$2) {
      var x$6 = $as_scm_Builder(x$6$2);
      return x$6.result__O()
    })
  })(this)), ($is_s_concurrent_BatchingExecutor(executor) ? executor : $m_s_concurrent_ExecutionContext$parasitic$()))
});
var $d_s_concurrent_Future$ = new $TypeData().initClass({
  s_concurrent_Future$: 0
}, false, "scala.concurrent.Future$", {
  s_concurrent_Future$: 1,
  O: 1
});
$c_s_concurrent_Future$.prototype.$classData = $d_s_concurrent_Future$;
var $n_s_concurrent_Future$;
function $m_s_concurrent_Future$() {
  if ((!$n_s_concurrent_Future$)) {
    $n_s_concurrent_Future$ = new $c_s_concurrent_Future$()
  };
  return $n_s_concurrent_Future$
}
function $f_s_concurrent_Promise__complete__s_util_Try__s_concurrent_Promise($thiz, result) {
  if ($thiz.tryComplete__s_util_Try__Z(result)) {
    return $thiz
  } else {
    throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "Promise already completed.")
  }
}
function $f_s_concurrent_Promise__success__O__s_concurrent_Promise($thiz, value) {
  var result = new $c_s_util_Success(value);
  return $f_s_concurrent_Promise__complete__s_util_Try__s_concurrent_Promise($thiz, result)
}
function $f_s_concurrent_Promise__failure__jl_Throwable__s_concurrent_Promise($thiz, cause) {
  var result = new $c_s_util_Failure(cause);
  return $f_s_concurrent_Promise__complete__s_util_Try__s_concurrent_Promise($thiz, result)
}
/** @constructor */
function $c_s_concurrent_Promise$() {
  /*<skip>*/
}
$c_s_concurrent_Promise$.prototype = new $h_O();
$c_s_concurrent_Promise$.prototype.constructor = $c_s_concurrent_Promise$;
/** @constructor */
function $h_s_concurrent_Promise$() {
  /*<skip>*/
}
$h_s_concurrent_Promise$.prototype = $c_s_concurrent_Promise$.prototype;
$c_s_concurrent_Promise$.prototype.failed__jl_Throwable__s_concurrent_Promise = (function(exception) {
  var result = new $c_s_util_Failure(exception);
  return $ct_s_concurrent_impl_Promise$DefaultPromise__s_util_Try__(new $c_s_concurrent_impl_Promise$DefaultPromise(), result)
});
$c_s_concurrent_Promise$.prototype.successful__O__s_concurrent_Promise = (function(result) {
  var result$1 = new $c_s_util_Success(result);
  return $ct_s_concurrent_impl_Promise$DefaultPromise__s_util_Try__(new $c_s_concurrent_impl_Promise$DefaultPromise(), result$1)
});
var $d_s_concurrent_Promise$ = new $TypeData().initClass({
  s_concurrent_Promise$: 0
}, false, "scala.concurrent.Promise$", {
  s_concurrent_Promise$: 1,
  O: 1
});
$c_s_concurrent_Promise$.prototype.$classData = $d_s_concurrent_Promise$;
var $n_s_concurrent_Promise$;
function $m_s_concurrent_Promise$() {
  if ((!$n_s_concurrent_Promise$)) {
    $n_s_concurrent_Promise$ = new $c_s_concurrent_Promise$()
  };
  return $n_s_concurrent_Promise$
}
/** @constructor */
function $c_s_concurrent_duration_package$DurationInt$() {
  /*<skip>*/
}
$c_s_concurrent_duration_package$DurationInt$.prototype = new $h_O();
$c_s_concurrent_duration_package$DurationInt$.prototype.constructor = $c_s_concurrent_duration_package$DurationInt$;
/** @constructor */
function $h_s_concurrent_duration_package$DurationInt$() {
  /*<skip>*/
}
$h_s_concurrent_duration_package$DurationInt$.prototype = $c_s_concurrent_duration_package$DurationInt$.prototype;
$c_s_concurrent_duration_package$DurationInt$.prototype.equals$extension__I__O__Z = (function(this$, x$1) {
  if ((x$1 instanceof $c_s_concurrent_duration_package$DurationInt)) {
    var DurationInt$1 = $as_s_concurrent_duration_package$DurationInt(x$1).s_concurrent_duration_package$DurationInt__f_scala$concurrent$duration$DurationInt$$n;
    return (this$ === DurationInt$1)
  } else {
    return false
  }
});
var $d_s_concurrent_duration_package$DurationInt$ = new $TypeData().initClass({
  s_concurrent_duration_package$DurationInt$: 0
}, false, "scala.concurrent.duration.package$DurationInt$", {
  s_concurrent_duration_package$DurationInt$: 1,
  O: 1
});
$c_s_concurrent_duration_package$DurationInt$.prototype.$classData = $d_s_concurrent_duration_package$DurationInt$;
var $n_s_concurrent_duration_package$DurationInt$;
function $m_s_concurrent_duration_package$DurationInt$() {
  if ((!$n_s_concurrent_duration_package$DurationInt$)) {
    $n_s_concurrent_duration_package$DurationInt$ = new $c_s_concurrent_duration_package$DurationInt$()
  };
  return $n_s_concurrent_duration_package$DurationInt$
}
/** @constructor */
function $c_s_concurrent_impl_Promise$() {
  this.s_concurrent_impl_Promise$__f_scala$concurrent$impl$Promise$$Noop = null;
  $n_s_concurrent_impl_Promise$ = this;
  this.s_concurrent_impl_Promise$__f_scala$concurrent$impl$Promise$$Noop = $ct_s_concurrent_impl_Promise$Transformation__I__F1__s_concurrent_ExecutionContext__(new $c_s_concurrent_impl_Promise$Transformation(), 0, null, $m_s_concurrent_ExecutionContext$parasitic$())
}
$c_s_concurrent_impl_Promise$.prototype = new $h_O();
$c_s_concurrent_impl_Promise$.prototype.constructor = $c_s_concurrent_impl_Promise$;
/** @constructor */
function $h_s_concurrent_impl_Promise$() {
  /*<skip>*/
}
$h_s_concurrent_impl_Promise$.prototype = $c_s_concurrent_impl_Promise$.prototype;
$c_s_concurrent_impl_Promise$.prototype.scala$concurrent$impl$Promise$$resolve__s_util_Try__s_util_Try = (function(value) {
  if ((value === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  if ((value instanceof $c_s_util_Success)) {
    return value
  } else {
    var t = $as_s_util_Failure(value).s_util_Failure__f_exception;
    return (((false || false) || (t instanceof $c_jl_Error)) ? (false ? new $c_s_util_Success($as_sr_NonLocalReturnControl(t).value__O()) : new $c_s_util_Failure(new $c_ju_concurrent_ExecutionException("Boxed Exception", t))) : value)
  }
});
var $d_s_concurrent_impl_Promise$ = new $TypeData().initClass({
  s_concurrent_impl_Promise$: 0
}, false, "scala.concurrent.impl.Promise$", {
  s_concurrent_impl_Promise$: 1,
  O: 1
});
$c_s_concurrent_impl_Promise$.prototype.$classData = $d_s_concurrent_impl_Promise$;
var $n_s_concurrent_impl_Promise$;
function $m_s_concurrent_impl_Promise$() {
  if ((!$n_s_concurrent_impl_Promise$)) {
    $n_s_concurrent_impl_Promise$ = new $c_s_concurrent_impl_Promise$()
  };
  return $n_s_concurrent_impl_Promise$
}
function $is_s_concurrent_impl_Promise$Callbacks(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.s_concurrent_impl_Promise$Callbacks)))
}
function $as_s_concurrent_impl_Promise$Callbacks(obj) {
  return (($is_s_concurrent_impl_Promise$Callbacks(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.concurrent.impl.Promise$Callbacks"))
}
function $isArrayOf_s_concurrent_impl_Promise$Callbacks(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_concurrent_impl_Promise$Callbacks)))
}
function $asArrayOf_s_concurrent_impl_Promise$Callbacks(obj, depth) {
  return (($isArrayOf_s_concurrent_impl_Promise$Callbacks(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.concurrent.impl.Promise$Callbacks;", depth))
}
/** @constructor */
function $c_s_math_Ordered$() {
  /*<skip>*/
}
$c_s_math_Ordered$.prototype = new $h_O();
$c_s_math_Ordered$.prototype.constructor = $c_s_math_Ordered$;
/** @constructor */
function $h_s_math_Ordered$() {
  /*<skip>*/
}
$h_s_math_Ordered$.prototype = $c_s_math_Ordered$.prototype;
var $d_s_math_Ordered$ = new $TypeData().initClass({
  s_math_Ordered$: 0
}, false, "scala.math.Ordered$", {
  s_math_Ordered$: 1,
  O: 1
});
$c_s_math_Ordered$.prototype.$classData = $d_s_math_Ordered$;
var $n_s_math_Ordered$;
function $m_s_math_Ordered$() {
  if ((!$n_s_math_Ordered$)) {
    $n_s_math_Ordered$ = new $c_s_math_Ordered$()
  };
  return $n_s_math_Ordered$
}
function $f_s_math_ScalaNumericAnyConversions__unifiedPrimitiveHashcode__I($thiz) {
  var t = $thiz.longValue__J();
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  return ((((hi === (-1)) ? (((-2147483648) ^ lo) >= 0) : (hi > (-1))) && ((hi === 0) ? (((-2147483648) ^ lo) <= (-1)) : (hi < 0))) ? lo : $m_sr_Statics$().longHash__J__I(new $c_RTLong(lo, hi)))
}
function $f_s_math_ScalaNumericAnyConversions__unifiedPrimitiveEquals__O__Z($thiz, x) {
  if ((x instanceof $Char)) {
    var x2 = $uC(x);
    return ($thiz.isValidChar__Z() && ($thiz.intValue__I() === x2))
  } else if ($isByte(x)) {
    var x3 = $uB(x);
    return ($thiz.isValidByte__Z() && ($thiz.byteValue__B() === x3))
  } else if ($isShort(x)) {
    var x4 = $uS(x);
    return ($thiz.isValidShort__Z() && ($thiz.shortValue__S() === x4))
  } else if ($isInt(x)) {
    var x5 = $uI(x);
    return ($thiz.isValidInt__Z() && ($thiz.intValue__I() === x5))
  } else if ((x instanceof $c_RTLong)) {
    var t = $uJ(x);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var this$1 = $thiz.longValue__J();
    return ((this$1.RTLong__f_lo === lo) && (this$1.RTLong__f_hi === hi))
  } else if (((typeof x) === "number")) {
    var x7 = $uF(x);
    return ($thiz.floatValue__F() === x7)
  } else if (((typeof x) === "number")) {
    var x8 = $uD(x);
    return ($thiz.doubleValue__D() === x8)
  } else {
    return false
  }
}
function $p_s_package$__BigDecimal$lzycompute__s_math_BigDecimal$($thiz) {
  if (((((1 & $thiz.s_package$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.s_package$__f_BigDecimal = $m_s_math_BigDecimal$();
    $thiz.s_package$__f_bitmap$0 = (((1 | $thiz.s_package$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.s_package$__f_BigDecimal
}
/** @constructor */
function $c_s_package$() {
  this.s_package$__f_BigDecimal = null;
  this.s_package$__f_BigInt = null;
  this.s_package$__f_AnyRef = null;
  this.s_package$__f_Traversable = null;
  this.s_package$__f_Iterable = null;
  this.s_package$__f_Seq = null;
  this.s_package$__f_IndexedSeq = null;
  this.s_package$__f_Iterator = null;
  this.s_package$__f_List = null;
  this.s_package$__f_Nil = null;
  this.s_package$__f_$colon$colon = null;
  this.s_package$__f_$plus$colon = null;
  this.s_package$__f_$colon$plus = null;
  this.s_package$__f_Stream = null;
  this.s_package$__f_LazyList = null;
  this.s_package$__f_Vector = null;
  this.s_package$__f_StringBuilder = null;
  this.s_package$__f_Range = null;
  this.s_package$__f_Equiv = null;
  this.s_package$__f_Fractional = null;
  this.s_package$__f_Integral = null;
  this.s_package$__f_Numeric = null;
  this.s_package$__f_Ordered = null;
  this.s_package$__f_Ordering = null;
  this.s_package$__f_Either = null;
  this.s_package$__f_Left = null;
  this.s_package$__f_Right = null;
  this.s_package$__f_bitmap$0 = 0;
  $n_s_package$ = this;
  this.s_package$__f_AnyRef = new $c_s_package$$anon$1();
  this.s_package$__f_Traversable = $m_sc_Iterable$();
  this.s_package$__f_Iterable = $m_sc_Iterable$();
  this.s_package$__f_Seq = $m_sci_Seq$();
  this.s_package$__f_IndexedSeq = $m_sci_IndexedSeq$();
  this.s_package$__f_Iterator = $m_sc_Iterator$();
  this.s_package$__f_List = $m_sci_List$();
  this.s_package$__f_Nil = $m_sci_Nil$();
  this.s_package$__f_$colon$colon = $m_sci_$colon$colon$();
  this.s_package$__f_$plus$colon = $m_sc_package$$plus$colon$();
  this.s_package$__f_$colon$plus = $m_sc_package$$colon$plus$();
  this.s_package$__f_Stream = $m_sci_Stream$();
  this.s_package$__f_LazyList = $m_sci_LazyList$();
  this.s_package$__f_Vector = $m_sci_Vector$();
  this.s_package$__f_StringBuilder = $m_scm_StringBuilder$();
  this.s_package$__f_Range = $m_sci_Range$();
  this.s_package$__f_Equiv = $m_s_math_Equiv$();
  this.s_package$__f_Fractional = $m_s_math_Fractional$();
  this.s_package$__f_Integral = $m_s_math_Integral$();
  this.s_package$__f_Numeric = $m_s_math_Numeric$();
  this.s_package$__f_Ordered = $m_s_math_Ordered$();
  this.s_package$__f_Ordering = $m_s_math_Ordering$();
  this.s_package$__f_Either = $m_s_util_Either$();
  this.s_package$__f_Left = $m_s_util_Left$();
  this.s_package$__f_Right = $m_s_util_Right$()
}
$c_s_package$.prototype = new $h_O();
$c_s_package$.prototype.constructor = $c_s_package$;
/** @constructor */
function $h_s_package$() {
  /*<skip>*/
}
$h_s_package$.prototype = $c_s_package$.prototype;
$c_s_package$.prototype.BigDecimal__s_math_BigDecimal$ = (function() {
  return (((((1 & this.s_package$__f_bitmap$0) << 24) >> 24) === 0) ? $p_s_package$__BigDecimal$lzycompute__s_math_BigDecimal$(this) : this.s_package$__f_BigDecimal)
});
var $d_s_package$ = new $TypeData().initClass({
  s_package$: 0
}, false, "scala.package$", {
  s_package$: 1,
  O: 1
});
$c_s_package$.prototype.$classData = $d_s_package$;
var $n_s_package$;
function $m_s_package$() {
  if ((!$n_s_package$)) {
    $n_s_package$ = new $c_s_package$()
  };
  return $n_s_package$
}
/** @constructor */
function $c_s_reflect_ClassManifestFactory$() {
  this.s_reflect_ClassManifestFactory$__f_Byte = null;
  this.s_reflect_ClassManifestFactory$__f_Short = null;
  this.s_reflect_ClassManifestFactory$__f_Char = null;
  this.s_reflect_ClassManifestFactory$__f_Int = null;
  this.s_reflect_ClassManifestFactory$__f_Long = null;
  this.s_reflect_ClassManifestFactory$__f_Float = null;
  this.s_reflect_ClassManifestFactory$__f_Double = null;
  this.s_reflect_ClassManifestFactory$__f_Boolean = null;
  this.s_reflect_ClassManifestFactory$__f_Unit = null;
  this.s_reflect_ClassManifestFactory$__f_Any = null;
  this.s_reflect_ClassManifestFactory$__f_Object = null;
  this.s_reflect_ClassManifestFactory$__f_AnyVal = null;
  this.s_reflect_ClassManifestFactory$__f_Nothing = null;
  this.s_reflect_ClassManifestFactory$__f_Null = null;
  $n_s_reflect_ClassManifestFactory$ = this;
  this.s_reflect_ClassManifestFactory$__f_Byte = $m_s_reflect_ManifestFactory$ByteManifest$();
  this.s_reflect_ClassManifestFactory$__f_Short = $m_s_reflect_ManifestFactory$ShortManifest$();
  this.s_reflect_ClassManifestFactory$__f_Char = $m_s_reflect_ManifestFactory$CharManifest$();
  this.s_reflect_ClassManifestFactory$__f_Int = $m_s_reflect_ManifestFactory$IntManifest$();
  this.s_reflect_ClassManifestFactory$__f_Long = $m_s_reflect_ManifestFactory$LongManifest$();
  this.s_reflect_ClassManifestFactory$__f_Float = $m_s_reflect_ManifestFactory$FloatManifest$();
  this.s_reflect_ClassManifestFactory$__f_Double = $m_s_reflect_ManifestFactory$DoubleManifest$();
  this.s_reflect_ClassManifestFactory$__f_Boolean = $m_s_reflect_ManifestFactory$BooleanManifest$();
  this.s_reflect_ClassManifestFactory$__f_Unit = $m_s_reflect_ManifestFactory$UnitManifest$();
  this.s_reflect_ClassManifestFactory$__f_Any = $m_s_reflect_ManifestFactory$AnyManifest$();
  this.s_reflect_ClassManifestFactory$__f_Object = $m_s_reflect_ManifestFactory$ObjectManifest$();
  this.s_reflect_ClassManifestFactory$__f_AnyVal = $m_s_reflect_ManifestFactory$AnyValManifest$();
  this.s_reflect_ClassManifestFactory$__f_Nothing = $m_s_reflect_ManifestFactory$NothingManifest$();
  this.s_reflect_ClassManifestFactory$__f_Null = $m_s_reflect_ManifestFactory$NullManifest$()
}
$c_s_reflect_ClassManifestFactory$.prototype = new $h_O();
$c_s_reflect_ClassManifestFactory$.prototype.constructor = $c_s_reflect_ClassManifestFactory$;
/** @constructor */
function $h_s_reflect_ClassManifestFactory$() {
  /*<skip>*/
}
$h_s_reflect_ClassManifestFactory$.prototype = $c_s_reflect_ClassManifestFactory$.prototype;
var $d_s_reflect_ClassManifestFactory$ = new $TypeData().initClass({
  s_reflect_ClassManifestFactory$: 0
}, false, "scala.reflect.ClassManifestFactory$", {
  s_reflect_ClassManifestFactory$: 1,
  O: 1
});
$c_s_reflect_ClassManifestFactory$.prototype.$classData = $d_s_reflect_ClassManifestFactory$;
var $n_s_reflect_ClassManifestFactory$;
function $m_s_reflect_ClassManifestFactory$() {
  if ((!$n_s_reflect_ClassManifestFactory$)) {
    $n_s_reflect_ClassManifestFactory$ = new $c_s_reflect_ClassManifestFactory$()
  };
  return $n_s_reflect_ClassManifestFactory$
}
/** @constructor */
function $c_s_reflect_package$() {
  this.s_reflect_package$__f_ClassManifest = null;
  $n_s_reflect_package$ = this;
  this.s_reflect_package$__f_ClassManifest = $m_s_reflect_ClassManifestFactory$()
}
$c_s_reflect_package$.prototype = new $h_O();
$c_s_reflect_package$.prototype.constructor = $c_s_reflect_package$;
/** @constructor */
function $h_s_reflect_package$() {
  /*<skip>*/
}
$h_s_reflect_package$.prototype = $c_s_reflect_package$.prototype;
var $d_s_reflect_package$ = new $TypeData().initClass({
  s_reflect_package$: 0
}, false, "scala.reflect.package$", {
  s_reflect_package$: 1,
  O: 1
});
$c_s_reflect_package$.prototype.$classData = $d_s_reflect_package$;
var $n_s_reflect_package$;
function $m_s_reflect_package$() {
  if ((!$n_s_reflect_package$)) {
    $n_s_reflect_package$ = new $c_s_reflect_package$()
  };
  return $n_s_reflect_package$
}
/** @constructor */
function $c_sr_BoxesRunTime$() {
  /*<skip>*/
}
$c_sr_BoxesRunTime$.prototype = new $h_O();
$c_sr_BoxesRunTime$.prototype.constructor = $c_sr_BoxesRunTime$;
/** @constructor */
function $h_sr_BoxesRunTime$() {
  /*<skip>*/
}
$h_sr_BoxesRunTime$.prototype = $c_sr_BoxesRunTime$.prototype;
$c_sr_BoxesRunTime$.prototype.equals__O__O__Z = (function(x, y) {
  if ((x === y)) {
    return true
  } else if ($is_jl_Number(x)) {
    var x2 = $as_jl_Number(x);
    return this.equalsNumObject__jl_Number__O__Z(x2, y)
  } else if ((x instanceof $Char)) {
    var x3 = $as_jl_Character(x);
    return this.equalsCharObject__jl_Character__O__Z(x3, y)
  } else {
    return ((x === null) ? (y === null) : $dp_equals__O__Z(x, y))
  }
});
$c_sr_BoxesRunTime$.prototype.equalsNumObject__jl_Number__O__Z = (function(xn, y) {
  if ($is_jl_Number(y)) {
    var x2 = $as_jl_Number(y);
    return this.equalsNumNum__jl_Number__jl_Number__Z(xn, x2)
  } else if ((y instanceof $Char)) {
    var x3 = $as_jl_Character(y);
    if (((typeof xn) === "number")) {
      var x2$1 = $uD(xn);
      return (x2$1 === $uC(x3))
    } else if ((xn instanceof $c_RTLong)) {
      var t = $uJ(xn);
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      var value = $uC(x3);
      var hi$1 = (value >> 31);
      return ((lo === value) && (hi === hi$1))
    } else {
      return ((xn === null) ? (x3 === null) : $dp_equals__O__Z(xn, x3))
    }
  } else {
    return ((xn === null) ? (y === null) : $dp_equals__O__Z(xn, y))
  }
});
$c_sr_BoxesRunTime$.prototype.equalsNumNum__jl_Number__jl_Number__Z = (function(xn, yn) {
  if (((typeof xn) === "number")) {
    var x2 = $uD(xn);
    if (((typeof yn) === "number")) {
      var x2$2 = $uD(yn);
      return (x2 === x2$2)
    } else if ((yn instanceof $c_RTLong)) {
      var t = $uJ(yn);
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      return (x2 === $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toDouble__I__I__D(lo, hi))
    } else if ((yn instanceof $c_s_math_ScalaNumber)) {
      var x4 = $as_s_math_ScalaNumber(yn);
      return x4.equals__O__Z(x2)
    } else {
      return false
    }
  } else if ((xn instanceof $c_RTLong)) {
    var t$1 = $uJ(xn);
    var lo$1 = t$1.RTLong__f_lo;
    var hi$1 = t$1.RTLong__f_hi;
    if ((yn instanceof $c_RTLong)) {
      var t$2 = $uJ(yn);
      var lo$2 = t$2.RTLong__f_lo;
      var hi$2 = t$2.RTLong__f_hi;
      return ((lo$1 === lo$2) && (hi$1 === hi$2))
    } else if (((typeof yn) === "number")) {
      var x3$3 = $uD(yn);
      return ($m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toDouble__I__I__D(lo$1, hi$1) === x3$3)
    } else if ((yn instanceof $c_s_math_ScalaNumber)) {
      var x4$2 = $as_s_math_ScalaNumber(yn);
      return x4$2.equals__O__Z(new $c_RTLong(lo$1, hi$1))
    } else {
      return false
    }
  } else {
    return ((xn === null) ? (yn === null) : $dp_equals__O__Z(xn, yn))
  }
});
$c_sr_BoxesRunTime$.prototype.equalsCharObject__jl_Character__O__Z = (function(xc, y) {
  if ((y instanceof $Char)) {
    var x2 = $as_jl_Character(y);
    return ($uC(xc) === $uC(x2))
  } else if ($is_jl_Number(y)) {
    var x3 = $as_jl_Number(y);
    if (((typeof x3) === "number")) {
      var x2$1 = $uD(x3);
      return (x2$1 === $uC(xc))
    } else if ((x3 instanceof $c_RTLong)) {
      var t = $uJ(x3);
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      var value = $uC(xc);
      var hi$1 = (value >> 31);
      return ((lo === value) && (hi === hi$1))
    } else {
      return ((x3 === null) ? (xc === null) : $dp_equals__O__Z(x3, xc))
    }
  } else {
    return ((xc === null) && (y === null))
  }
});
var $d_sr_BoxesRunTime$ = new $TypeData().initClass({
  sr_BoxesRunTime$: 0
}, false, "scala.runtime.BoxesRunTime$", {
  sr_BoxesRunTime$: 1,
  O: 1
});
$c_sr_BoxesRunTime$.prototype.$classData = $d_sr_BoxesRunTime$;
var $n_sr_BoxesRunTime$;
function $m_sr_BoxesRunTime$() {
  if ((!$n_sr_BoxesRunTime$)) {
    $n_sr_BoxesRunTime$ = new $c_sr_BoxesRunTime$()
  };
  return $n_sr_BoxesRunTime$
}
var $d_sr_Null$ = new $TypeData().initClass({
  sr_Null$: 0
}, false, "scala.runtime.Null$", {
  sr_Null$: 1,
  O: 1
});
/** @constructor */
function $c_sr_RichLong$() {
  /*<skip>*/
}
$c_sr_RichLong$.prototype = new $h_O();
$c_sr_RichLong$.prototype.constructor = $c_sr_RichLong$;
/** @constructor */
function $h_sr_RichLong$() {
  /*<skip>*/
}
$h_sr_RichLong$.prototype = $c_sr_RichLong$.prototype;
$c_sr_RichLong$.prototype.isValidByte$extension__J__Z = (function(this$) {
  var value = ((this$.RTLong__f_lo << 24) >> 24);
  var hi = (value >> 31);
  return ((value === this$.RTLong__f_lo) && (hi === this$.RTLong__f_hi))
});
$c_sr_RichLong$.prototype.isValidShort$extension__J__Z = (function(this$) {
  var value = ((this$.RTLong__f_lo << 16) >> 16);
  var hi = (value >> 31);
  return ((value === this$.RTLong__f_lo) && (hi === this$.RTLong__f_hi))
});
$c_sr_RichLong$.prototype.isValidChar$extension__J__Z = (function(this$) {
  var value = (65535 & this$.RTLong__f_lo);
  var hi = (value >> 31);
  return ((value === this$.RTLong__f_lo) && (hi === this$.RTLong__f_hi))
});
$c_sr_RichLong$.prototype.isValidInt$extension__J__Z = (function(this$) {
  var value = this$.RTLong__f_lo;
  var hi = (value >> 31);
  return ((value === this$.RTLong__f_lo) && (hi === this$.RTLong__f_hi))
});
$c_sr_RichLong$.prototype.equals$extension__J__O__Z = (function(this$, x$1) {
  if ((x$1 instanceof $c_sr_RichLong)) {
    var t = $as_sr_RichLong(x$1).sr_RichLong__f_self;
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    return ((this$.RTLong__f_lo === lo) && (this$.RTLong__f_hi === hi))
  } else {
    return false
  }
});
var $d_sr_RichLong$ = new $TypeData().initClass({
  sr_RichLong$: 0
}, false, "scala.runtime.RichLong$", {
  sr_RichLong$: 1,
  O: 1
});
$c_sr_RichLong$.prototype.$classData = $d_sr_RichLong$;
var $n_sr_RichLong$;
function $m_sr_RichLong$() {
  if ((!$n_sr_RichLong$)) {
    $n_sr_RichLong$ = new $c_sr_RichLong$()
  };
  return $n_sr_RichLong$
}
/** @constructor */
function $c_sr_ScalaRunTime$() {
  /*<skip>*/
}
$c_sr_ScalaRunTime$.prototype = new $h_O();
$c_sr_ScalaRunTime$.prototype.constructor = $c_sr_ScalaRunTime$;
/** @constructor */
function $h_sr_ScalaRunTime$() {
  /*<skip>*/
}
$h_sr_ScalaRunTime$.prototype = $c_sr_ScalaRunTime$.prototype;
$c_sr_ScalaRunTime$.prototype.array_apply__O__I__O = (function(xs, idx) {
  if ((xs instanceof $ac_O)) {
    var x2 = $asArrayOf_O(xs, 1);
    return x2.get(idx)
  } else if ((xs instanceof $ac_I)) {
    var x3 = $asArrayOf_I(xs, 1);
    return x3.get(idx)
  } else if ((xs instanceof $ac_D)) {
    var x4 = $asArrayOf_D(xs, 1);
    return x4.get(idx)
  } else if ((xs instanceof $ac_J)) {
    var x5 = $asArrayOf_J(xs, 1);
    return x5.get(idx)
  } else if ((xs instanceof $ac_F)) {
    var x6 = $asArrayOf_F(xs, 1);
    return x6.get(idx)
  } else if ((xs instanceof $ac_C)) {
    var x7 = $asArrayOf_C(xs, 1);
    return $bC(x7.get(idx))
  } else if ((xs instanceof $ac_B)) {
    var x8 = $asArrayOf_B(xs, 1);
    return x8.get(idx)
  } else if ((xs instanceof $ac_S)) {
    var x9 = $asArrayOf_S(xs, 1);
    return x9.get(idx)
  } else if ((xs instanceof $ac_Z)) {
    var x10 = $asArrayOf_Z(xs, 1);
    return x10.get(idx)
  } else if ((xs === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  } else {
    throw new $c_s_MatchError(xs)
  }
});
$c_sr_ScalaRunTime$.prototype.array_update__O__I__O__V = (function(xs, idx, value) {
  if ((xs instanceof $ac_O)) {
    var x2 = $asArrayOf_O(xs, 1);
    x2.set(idx, value)
  } else if ((xs instanceof $ac_I)) {
    var x3 = $asArrayOf_I(xs, 1);
    x3.set(idx, $uI(value))
  } else if ((xs instanceof $ac_D)) {
    var x4 = $asArrayOf_D(xs, 1);
    x4.set(idx, $uD(value))
  } else if ((xs instanceof $ac_J)) {
    var x5 = $asArrayOf_J(xs, 1);
    x5.set(idx, $uJ(value))
  } else if ((xs instanceof $ac_F)) {
    var x6 = $asArrayOf_F(xs, 1);
    x6.set(idx, $uF(value))
  } else if ((xs instanceof $ac_C)) {
    var x7 = $asArrayOf_C(xs, 1);
    x7.set(idx, $uC(value))
  } else if ((xs instanceof $ac_B)) {
    var x8 = $asArrayOf_B(xs, 1);
    x8.set(idx, $uB(value))
  } else if ((xs instanceof $ac_S)) {
    var x9 = $asArrayOf_S(xs, 1);
    x9.set(idx, $uS(value))
  } else if ((xs instanceof $ac_Z)) {
    var x10 = $asArrayOf_Z(xs, 1);
    x10.set(idx, $uZ(value))
  } else if ((xs === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  } else {
    throw new $c_s_MatchError(xs)
  }
});
$c_sr_ScalaRunTime$.prototype.array_length__O__I = (function(xs) {
  return $m_jl_reflect_Array$().getLength__O__I(xs)
});
$c_sr_ScalaRunTime$.prototype._toString__s_Product__T = (function(x) {
  var this$1 = x.productIterator__sc_Iterator();
  var start = (x.productPrefix__T() + "(");
  return $f_sc_IterableOnceOps__mkString__T__T__T__T(this$1, start, ",", ")")
});
var $d_sr_ScalaRunTime$ = new $TypeData().initClass({
  sr_ScalaRunTime$: 0
}, false, "scala.runtime.ScalaRunTime$", {
  sr_ScalaRunTime$: 1,
  O: 1
});
$c_sr_ScalaRunTime$.prototype.$classData = $d_sr_ScalaRunTime$;
var $n_sr_ScalaRunTime$;
function $m_sr_ScalaRunTime$() {
  if ((!$n_sr_ScalaRunTime$)) {
    $n_sr_ScalaRunTime$ = new $c_sr_ScalaRunTime$()
  };
  return $n_sr_ScalaRunTime$
}
function $s_sr_Statics__releaseFence__V() {
  /*<skip>*/
}
/** @constructor */
function $c_sr_Statics$() {
  /*<skip>*/
}
$c_sr_Statics$.prototype = new $h_O();
$c_sr_Statics$.prototype.constructor = $c_sr_Statics$;
/** @constructor */
function $h_sr_Statics$() {
  /*<skip>*/
}
$h_sr_Statics$.prototype = $c_sr_Statics$.prototype;
$c_sr_Statics$.prototype.mix__I__I__I = (function(hash, data) {
  var h = this.mixLast__I__I__I(hash, data);
  var i = h;
  h = ((i << 13) | ((i >>> 19) | 0));
  return (((-430675100) + $imul(5, h)) | 0)
});
$c_sr_Statics$.prototype.mixLast__I__I__I = (function(hash, data) {
  var k = data;
  k = $imul((-862048943), k);
  var i = k;
  k = ((i << 15) | ((i >>> 17) | 0));
  k = $imul(461845907, k);
  return (hash ^ k)
});
$c_sr_Statics$.prototype.finalizeHash__I__I__I = (function(hash, length) {
  return this.avalanche__I__I((hash ^ length))
});
$c_sr_Statics$.prototype.avalanche__I__I = (function(h0) {
  var h = h0;
  h = (h ^ ((h >>> 16) | 0));
  h = $imul((-2048144789), h);
  h = (h ^ ((h >>> 13) | 0));
  h = $imul((-1028477387), h);
  h = (h ^ ((h >>> 16) | 0));
  return h
});
$c_sr_Statics$.prototype.longHash__J__I = (function(lv) {
  var lo = lv.RTLong__f_lo;
  var hi = lv.RTLong__f_hi;
  return ((hi === (lo >> 31)) ? lo : (lo ^ hi))
});
$c_sr_Statics$.prototype.doubleHash__D__I = (function(dv) {
  var iv = $doubleToInt(dv);
  if ((iv === dv)) {
    return iv
  } else {
    var this$1 = $m_RTLong$();
    var lo = this$1.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(dv);
    var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    return (($m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toDouble__I__I__D(lo, hi) === dv) ? (lo ^ hi) : $m_jl_FloatingPointBits$().numberHashCode__D__I(dv))
  }
});
$c_sr_Statics$.prototype.anyHash__O__I = (function(x) {
  if ((x === null)) {
    return 0
  } else if (((typeof x) === "number")) {
    var x3 = $uD(x);
    return this.doubleHash__D__I(x3)
  } else if ((x instanceof $c_RTLong)) {
    var t = $uJ(x);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    return this.longHash__J__I(new $c_RTLong(lo, hi))
  } else {
    return $dp_hashCode__I(x)
  }
});
$c_sr_Statics$.prototype.ioobe__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
var $d_sr_Statics$ = new $TypeData().initClass({
  sr_Statics$: 0
}, false, "scala.runtime.Statics$", {
  sr_Statics$: 1,
  O: 1
});
$c_sr_Statics$.prototype.$classData = $d_sr_Statics$;
var $n_sr_Statics$;
function $m_sr_Statics$() {
  if ((!$n_sr_Statics$)) {
    $n_sr_Statics$ = new $c_sr_Statics$()
  };
  return $n_sr_Statics$
}
/** @constructor */
function $c_sr_Statics$PFMarker$() {
  /*<skip>*/
}
$c_sr_Statics$PFMarker$.prototype = new $h_O();
$c_sr_Statics$PFMarker$.prototype.constructor = $c_sr_Statics$PFMarker$;
/** @constructor */
function $h_sr_Statics$PFMarker$() {
  /*<skip>*/
}
$h_sr_Statics$PFMarker$.prototype = $c_sr_Statics$PFMarker$.prototype;
var $d_sr_Statics$PFMarker$ = new $TypeData().initClass({
  sr_Statics$PFMarker$: 0
}, false, "scala.runtime.Statics$PFMarker$", {
  sr_Statics$PFMarker$: 1,
  O: 1
});
$c_sr_Statics$PFMarker$.prototype.$classData = $d_sr_Statics$PFMarker$;
var $n_sr_Statics$PFMarker$;
function $m_sr_Statics$PFMarker$() {
  if ((!$n_sr_Statics$PFMarker$)) {
    $n_sr_Statics$PFMarker$ = new $c_sr_Statics$PFMarker$()
  };
  return $n_sr_Statics$PFMarker$
}
/** @constructor */
function $c_sjs_concurrent_JSExecutionContext$() {
  this.sjs_concurrent_JSExecutionContext$__f_queue = null;
  $n_sjs_concurrent_JSExecutionContext$ = this;
  this.sjs_concurrent_JSExecutionContext$__f_queue = $m_sjs_concurrent_QueueExecutionContext$().apply__s_concurrent_ExecutionContextExecutor()
}
$c_sjs_concurrent_JSExecutionContext$.prototype = new $h_O();
$c_sjs_concurrent_JSExecutionContext$.prototype.constructor = $c_sjs_concurrent_JSExecutionContext$;
/** @constructor */
function $h_sjs_concurrent_JSExecutionContext$() {
  /*<skip>*/
}
$h_sjs_concurrent_JSExecutionContext$.prototype = $c_sjs_concurrent_JSExecutionContext$.prototype;
var $d_sjs_concurrent_JSExecutionContext$ = new $TypeData().initClass({
  sjs_concurrent_JSExecutionContext$: 0
}, false, "scala.scalajs.concurrent.JSExecutionContext$", {
  sjs_concurrent_JSExecutionContext$: 1,
  O: 1
});
$c_sjs_concurrent_JSExecutionContext$.prototype.$classData = $d_sjs_concurrent_JSExecutionContext$;
var $n_sjs_concurrent_JSExecutionContext$;
function $m_sjs_concurrent_JSExecutionContext$() {
  if ((!$n_sjs_concurrent_JSExecutionContext$)) {
    $n_sjs_concurrent_JSExecutionContext$ = new $c_sjs_concurrent_JSExecutionContext$()
  };
  return $n_sjs_concurrent_JSExecutionContext$
}
/** @constructor */
function $c_sjs_concurrent_JSExecutionContext$Implicits$() {
  this.sjs_concurrent_JSExecutionContext$Implicits$__f_queue = null;
  $n_sjs_concurrent_JSExecutionContext$Implicits$ = this;
  this.sjs_concurrent_JSExecutionContext$Implicits$__f_queue = $m_sjs_concurrent_JSExecutionContext$().sjs_concurrent_JSExecutionContext$__f_queue
}
$c_sjs_concurrent_JSExecutionContext$Implicits$.prototype = new $h_O();
$c_sjs_concurrent_JSExecutionContext$Implicits$.prototype.constructor = $c_sjs_concurrent_JSExecutionContext$Implicits$;
/** @constructor */
function $h_sjs_concurrent_JSExecutionContext$Implicits$() {
  /*<skip>*/
}
$h_sjs_concurrent_JSExecutionContext$Implicits$.prototype = $c_sjs_concurrent_JSExecutionContext$Implicits$.prototype;
var $d_sjs_concurrent_JSExecutionContext$Implicits$ = new $TypeData().initClass({
  sjs_concurrent_JSExecutionContext$Implicits$: 0
}, false, "scala.scalajs.concurrent.JSExecutionContext$Implicits$", {
  sjs_concurrent_JSExecutionContext$Implicits$: 1,
  O: 1
});
$c_sjs_concurrent_JSExecutionContext$Implicits$.prototype.$classData = $d_sjs_concurrent_JSExecutionContext$Implicits$;
var $n_sjs_concurrent_JSExecutionContext$Implicits$;
function $m_sjs_concurrent_JSExecutionContext$Implicits$() {
  if ((!$n_sjs_concurrent_JSExecutionContext$Implicits$)) {
    $n_sjs_concurrent_JSExecutionContext$Implicits$ = new $c_sjs_concurrent_JSExecutionContext$Implicits$()
  };
  return $n_sjs_concurrent_JSExecutionContext$Implicits$
}
/** @constructor */
function $c_sjs_concurrent_QueueExecutionContext$() {
  /*<skip>*/
}
$c_sjs_concurrent_QueueExecutionContext$.prototype = new $h_O();
$c_sjs_concurrent_QueueExecutionContext$.prototype.constructor = $c_sjs_concurrent_QueueExecutionContext$;
/** @constructor */
function $h_sjs_concurrent_QueueExecutionContext$() {
  /*<skip>*/
}
$h_sjs_concurrent_QueueExecutionContext$.prototype = $c_sjs_concurrent_QueueExecutionContext$.prototype;
$c_sjs_concurrent_QueueExecutionContext$.prototype.apply__s_concurrent_ExecutionContextExecutor = (function() {
  return (($as_T((typeof Promise)) === "undefined") ? new $c_sjs_concurrent_QueueExecutionContext$TimeoutsExecutionContext() : new $c_sjs_concurrent_QueueExecutionContext$PromisesExecutionContext())
});
var $d_sjs_concurrent_QueueExecutionContext$ = new $TypeData().initClass({
  sjs_concurrent_QueueExecutionContext$: 0
}, false, "scala.scalajs.concurrent.QueueExecutionContext$", {
  sjs_concurrent_QueueExecutionContext$: 1,
  O: 1
});
$c_sjs_concurrent_QueueExecutionContext$.prototype.$classData = $d_sjs_concurrent_QueueExecutionContext$;
var $n_sjs_concurrent_QueueExecutionContext$;
function $m_sjs_concurrent_QueueExecutionContext$() {
  if ((!$n_sjs_concurrent_QueueExecutionContext$)) {
    $n_sjs_concurrent_QueueExecutionContext$ = new $c_sjs_concurrent_QueueExecutionContext$()
  };
  return $n_sjs_concurrent_QueueExecutionContext$
}
/** @constructor */
function $c_sjs_js_$bar$() {
  /*<skip>*/
}
$c_sjs_js_$bar$.prototype = new $h_O();
$c_sjs_js_$bar$.prototype.constructor = $c_sjs_js_$bar$;
/** @constructor */
function $h_sjs_js_$bar$() {
  /*<skip>*/
}
$h_sjs_js_$bar$.prototype = $c_sjs_js_$bar$.prototype;
$c_sjs_js_$bar$.prototype.from__O__sjs_js_$bar$Evidence__sjs_js_$bar = (function(a, ev) {
  return a
});
$c_sjs_js_$bar$.prototype.undefOr2jsAny__sjs_js_$bar__F1__sjs_js_Any = (function(value, ev) {
  if ((value === (void 0))) {
    return (void 0)
  } else {
    var a = ev.apply__O__O(value);
    return a
  }
});
var $d_sjs_js_$bar$ = new $TypeData().initClass({
  sjs_js_$bar$: 0
}, false, "scala.scalajs.js.$bar$", {
  sjs_js_$bar$: 1,
  O: 1
});
$c_sjs_js_$bar$.prototype.$classData = $d_sjs_js_$bar$;
var $n_sjs_js_$bar$;
function $m_sjs_js_$bar$() {
  if ((!$n_sjs_js_$bar$)) {
    $n_sjs_js_$bar$ = new $c_sjs_js_$bar$()
  };
  return $n_sjs_js_$bar$
}
/** @constructor */
function $c_sjs_js_$bar$EvidenceLowestPrioImplicits() {
  /*<skip>*/
}
$c_sjs_js_$bar$EvidenceLowestPrioImplicits.prototype = new $h_O();
$c_sjs_js_$bar$EvidenceLowestPrioImplicits.prototype.constructor = $c_sjs_js_$bar$EvidenceLowestPrioImplicits;
/** @constructor */
function $h_sjs_js_$bar$EvidenceLowestPrioImplicits() {
  /*<skip>*/
}
$h_sjs_js_$bar$EvidenceLowestPrioImplicits.prototype = $c_sjs_js_$bar$EvidenceLowestPrioImplicits.prototype;
$c_sjs_js_$bar$EvidenceLowestPrioImplicits.prototype.right__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence = (function(ev) {
  return $m_sjs_js_$bar$ReusableEvidence$()
});
/** @constructor */
function $c_sjs_js_ArrayOps$() {
  /*<skip>*/
}
$c_sjs_js_ArrayOps$.prototype = new $h_O();
$c_sjs_js_ArrayOps$.prototype.constructor = $c_sjs_js_ArrayOps$;
/** @constructor */
function $h_sjs_js_ArrayOps$() {
  /*<skip>*/
}
$h_sjs_js_ArrayOps$.prototype = $c_sjs_js_ArrayOps$.prototype;
$c_sjs_js_ArrayOps$.prototype.headOption$extension__sjs_js_Array__s_Option = (function(this$) {
  return (($uI(this$.length) === 0) ? $m_s_None$() : new $c_s_Some(this$[0]))
});
var $d_sjs_js_ArrayOps$ = new $TypeData().initClass({
  sjs_js_ArrayOps$: 0
}, false, "scala.scalajs.js.ArrayOps$", {
  sjs_js_ArrayOps$: 1,
  O: 1
});
$c_sjs_js_ArrayOps$.prototype.$classData = $d_sjs_js_ArrayOps$;
var $n_sjs_js_ArrayOps$;
function $m_sjs_js_ArrayOps$() {
  if ((!$n_sjs_js_ArrayOps$)) {
    $n_sjs_js_ArrayOps$ = new $c_sjs_js_ArrayOps$()
  };
  return $n_sjs_js_ArrayOps$
}
/** @constructor */
function $c_sjs_js_JSConverters$JSRichMap$() {
  /*<skip>*/
}
$c_sjs_js_JSConverters$JSRichMap$.prototype = new $h_O();
$c_sjs_js_JSConverters$JSRichMap$.prototype.constructor = $c_sjs_js_JSConverters$JSRichMap$;
/** @constructor */
function $h_sjs_js_JSConverters$JSRichMap$() {
  /*<skip>*/
}
$h_sjs_js_JSConverters$JSRichMap$.prototype = $c_sjs_js_JSConverters$JSRichMap$.prototype;
var $d_sjs_js_JSConverters$JSRichMap$ = new $TypeData().initClass({
  sjs_js_JSConverters$JSRichMap$: 0
}, false, "scala.scalajs.js.JSConverters$JSRichMap$", {
  sjs_js_JSConverters$JSRichMap$: 1,
  O: 1
});
$c_sjs_js_JSConverters$JSRichMap$.prototype.$classData = $d_sjs_js_JSConverters$JSRichMap$;
var $n_sjs_js_JSConverters$JSRichMap$;
function $m_sjs_js_JSConverters$JSRichMap$() {
  if ((!$n_sjs_js_JSConverters$JSRichMap$)) {
    $n_sjs_js_JSConverters$JSRichMap$ = new $c_sjs_js_JSConverters$JSRichMap$()
  };
  return $n_sjs_js_JSConverters$JSRichMap$
}
/** @constructor */
function $c_sjs_js_Thenable$ThenableOps$() {
  /*<skip>*/
}
$c_sjs_js_Thenable$ThenableOps$.prototype = new $h_O();
$c_sjs_js_Thenable$ThenableOps$.prototype.constructor = $c_sjs_js_Thenable$ThenableOps$;
/** @constructor */
function $h_sjs_js_Thenable$ThenableOps$() {
  /*<skip>*/
}
$h_sjs_js_Thenable$ThenableOps$.prototype = $c_sjs_js_Thenable$ThenableOps$.prototype;
$c_sjs_js_Thenable$ThenableOps$.prototype.toFuture$extension__sjs_js_Thenable__s_concurrent_Future = (function(this$) {
  var p2 = $ct_s_concurrent_impl_Promise$DefaultPromise__(new $c_s_concurrent_impl_Promise$DefaultPromise());
  this$.then((function(p2$1) {
    return (function(arg1$2) {
      return $m_sjs_js_Thenable$ThenableOps$().scala$scalajs$js$Thenable$ThenableOps$$$anonfun$toFuture$1__O__s_concurrent_Promise__sjs_js_$bar(arg1$2, p2$1)
    })
  })(p2), $m_sjs_js_defined$().apply__O__sjs_js_$bar((function(p2$1$1) {
    return (function(arg1$2$1) {
      return $m_sjs_js_Thenable$ThenableOps$().scala$scalajs$js$Thenable$ThenableOps$$$anonfun$toFuture$2__O__s_concurrent_Promise__sjs_js_$bar(arg1$2$1, p2$1$1)
    })
  })(p2)));
  return p2
});
$c_sjs_js_Thenable$ThenableOps$.prototype.scala$scalajs$js$Thenable$ThenableOps$$$anonfun$toFuture$1__O__s_concurrent_Promise__sjs_js_$bar = (function(v, p2$1) {
  $f_s_concurrent_Promise__success__O__s_concurrent_Promise(p2$1, v)
});
$c_sjs_js_Thenable$ThenableOps$.prototype.scala$scalajs$js$Thenable$ThenableOps$$$anonfun$toFuture$2__O__s_concurrent_Promise__sjs_js_$bar = (function(e, p2$1) {
  if ((e instanceof $c_jl_Throwable)) {
    var x2 = $as_jl_Throwable(e);
    var cause = x2
  } else {
    var cause = new $c_sjs_js_JavaScriptException(e)
  };
  $f_s_concurrent_Promise__failure__jl_Throwable__s_concurrent_Promise(p2$1, cause)
});
var $d_sjs_js_Thenable$ThenableOps$ = new $TypeData().initClass({
  sjs_js_Thenable$ThenableOps$: 0
}, false, "scala.scalajs.js.Thenable$ThenableOps$", {
  sjs_js_Thenable$ThenableOps$: 1,
  O: 1
});
$c_sjs_js_Thenable$ThenableOps$.prototype.$classData = $d_sjs_js_Thenable$ThenableOps$;
var $n_sjs_js_Thenable$ThenableOps$;
function $m_sjs_js_Thenable$ThenableOps$() {
  if ((!$n_sjs_js_Thenable$ThenableOps$)) {
    $n_sjs_js_Thenable$ThenableOps$ = new $c_sjs_js_Thenable$ThenableOps$()
  };
  return $n_sjs_js_Thenable$ThenableOps$
}
/** @constructor */
function $c_sjs_js_WrappedDictionary$Cache$() {
  this.sjs_js_WrappedDictionary$Cache$__f_safeHasOwnProperty = null;
  $n_sjs_js_WrappedDictionary$Cache$ = this;
  this.sjs_js_WrappedDictionary$Cache$__f_safeHasOwnProperty = Object.prototype.hasOwnProperty
}
$c_sjs_js_WrappedDictionary$Cache$.prototype = new $h_O();
$c_sjs_js_WrappedDictionary$Cache$.prototype.constructor = $c_sjs_js_WrappedDictionary$Cache$;
/** @constructor */
function $h_sjs_js_WrappedDictionary$Cache$() {
  /*<skip>*/
}
$h_sjs_js_WrappedDictionary$Cache$.prototype = $c_sjs_js_WrappedDictionary$Cache$.prototype;
var $d_sjs_js_WrappedDictionary$Cache$ = new $TypeData().initClass({
  sjs_js_WrappedDictionary$Cache$: 0
}, false, "scala.scalajs.js.WrappedDictionary$Cache$", {
  sjs_js_WrappedDictionary$Cache$: 1,
  O: 1
});
$c_sjs_js_WrappedDictionary$Cache$.prototype.$classData = $d_sjs_js_WrappedDictionary$Cache$;
var $n_sjs_js_WrappedDictionary$Cache$;
function $m_sjs_js_WrappedDictionary$Cache$() {
  if ((!$n_sjs_js_WrappedDictionary$Cache$)) {
    $n_sjs_js_WrappedDictionary$Cache$ = new $c_sjs_js_WrappedDictionary$Cache$()
  };
  return $n_sjs_js_WrappedDictionary$Cache$
}
/** @constructor */
function $c_sjs_js_defined$() {
  /*<skip>*/
}
$c_sjs_js_defined$.prototype = new $h_O();
$c_sjs_js_defined$.prototype.constructor = $c_sjs_js_defined$;
/** @constructor */
function $h_sjs_js_defined$() {
  /*<skip>*/
}
$h_sjs_js_defined$.prototype = $c_sjs_js_defined$.prototype;
$c_sjs_js_defined$.prototype.apply__O__sjs_js_$bar = (function(a) {
  return a
});
var $d_sjs_js_defined$ = new $TypeData().initClass({
  sjs_js_defined$: 0
}, false, "scala.scalajs.js.defined$", {
  sjs_js_defined$: 1,
  O: 1
});
$c_sjs_js_defined$.prototype.$classData = $d_sjs_js_defined$;
var $n_sjs_js_defined$;
function $m_sjs_js_defined$() {
  if ((!$n_sjs_js_defined$)) {
    $n_sjs_js_defined$ = new $c_sjs_js_defined$()
  };
  return $n_sjs_js_defined$
}
/** @constructor */
function $c_sjs_js_special_package$() {
  /*<skip>*/
}
$c_sjs_js_special_package$.prototype = new $h_O();
$c_sjs_js_special_package$.prototype.constructor = $c_sjs_js_special_package$;
/** @constructor */
function $h_sjs_js_special_package$() {
  /*<skip>*/
}
$h_sjs_js_special_package$.prototype = $c_sjs_js_special_package$.prototype;
$c_sjs_js_special_package$.prototype.objectLiteral__sci_Seq__sjs_js_Object = (function(properties) {
  var result = {};
  properties.foreach__F1__V(new $c_sjsr_AnonFunction1((function(this$1, result$1) {
    return (function(pair$2) {
      var pair = $as_T2(pair$2);
      result$1[pair._1__O()] = pair._2__O()
    })
  })(this, result)));
  return result
});
var $d_sjs_js_special_package$ = new $TypeData().initClass({
  sjs_js_special_package$: 0
}, false, "scala.scalajs.js.special.package$", {
  sjs_js_special_package$: 1,
  O: 1
});
$c_sjs_js_special_package$.prototype.$classData = $d_sjs_js_special_package$;
var $n_sjs_js_special_package$;
function $m_sjs_js_special_package$() {
  if ((!$n_sjs_js_special_package$)) {
    $n_sjs_js_special_package$ = new $c_sjs_js_special_package$()
  };
  return $n_sjs_js_special_package$
}
/** @constructor */
function $c_sjsr_Compat$() {
  /*<skip>*/
}
$c_sjsr_Compat$.prototype = new $h_O();
$c_sjsr_Compat$.prototype.constructor = $c_sjsr_Compat$;
/** @constructor */
function $h_sjsr_Compat$() {
  /*<skip>*/
}
$h_sjsr_Compat$.prototype = $c_sjsr_Compat$.prototype;
$c_sjsr_Compat$.prototype.toJSVarArgsImpl__sci_Seq__sjs_js_Array = (function(seq) {
  if ((seq instanceof $c_sjsr_WrappedVarArgs)) {
    var x2 = $as_sjsr_WrappedVarArgs(seq);
    return x2.sjsr_WrappedVarArgs__f_scala$scalajs$runtime$WrappedVarArgs$$array
  } else {
    var result = [];
    seq.foreach__F1__V(new $c_sjsr_AnonFunction1((function(this$1, result$1) {
      return (function(x$2) {
        return $uI(result$1.push(x$2))
      })
    })(this, result)));
    return result
  }
});
var $d_sjsr_Compat$ = new $TypeData().initClass({
  sjsr_Compat$: 0
}, false, "scala.scalajs.runtime.Compat$", {
  sjsr_Compat$: 1,
  O: 1
});
$c_sjsr_Compat$.prototype.$classData = $d_sjsr_Compat$;
var $n_sjsr_Compat$;
function $m_sjsr_Compat$() {
  if ((!$n_sjsr_Compat$)) {
    $n_sjsr_Compat$ = new $c_sjsr_Compat$()
  };
  return $n_sjsr_Compat$
}
/** @constructor */
function $c_sjsr_package$() {
  /*<skip>*/
}
$c_sjsr_package$.prototype = new $h_O();
$c_sjsr_package$.prototype.constructor = $c_sjsr_package$;
/** @constructor */
function $h_sjsr_package$() {
  /*<skip>*/
}
$h_sjsr_package$.prototype = $c_sjsr_package$.prototype;
$c_sjsr_package$.prototype.wrapJavaScriptException__O__jl_Throwable = (function(e) {
  if ((e instanceof $c_jl_Throwable)) {
    var x2 = $as_jl_Throwable(e);
    return x2
  } else {
    return new $c_sjs_js_JavaScriptException(e)
  }
});
$c_sjsr_package$.prototype.unwrapJavaScriptException__jl_Throwable__O = (function(th) {
  if ((th instanceof $c_sjs_js_JavaScriptException)) {
    var x2 = $as_sjs_js_JavaScriptException(th);
    var e = x2.sjs_js_JavaScriptException__f_exception;
    return e
  } else {
    return th
  }
});
var $d_sjsr_package$ = new $TypeData().initClass({
  sjsr_package$: 0
}, false, "scala.scalajs.runtime.package$", {
  sjsr_package$: 1,
  O: 1
});
$c_sjsr_package$.prototype.$classData = $d_sjsr_package$;
var $n_sjsr_package$;
function $m_sjsr_package$() {
  if ((!$n_sjsr_package$)) {
    $n_sjsr_package$ = new $c_sjsr_package$()
  };
  return $n_sjsr_package$
}
/** @constructor */
function $c_s_util_DynamicVariable(init) {
  this.s_util_DynamicVariable__f_v = null;
  this.s_util_DynamicVariable__f_v = init
}
$c_s_util_DynamicVariable.prototype = new $h_O();
$c_s_util_DynamicVariable.prototype.constructor = $c_s_util_DynamicVariable;
/** @constructor */
function $h_s_util_DynamicVariable() {
  /*<skip>*/
}
$h_s_util_DynamicVariable.prototype = $c_s_util_DynamicVariable.prototype;
$c_s_util_DynamicVariable.prototype.toString__T = (function() {
  return (("DynamicVariable(" + this.s_util_DynamicVariable__f_v) + ")")
});
var $d_s_util_DynamicVariable = new $TypeData().initClass({
  s_util_DynamicVariable: 0
}, false, "scala.util.DynamicVariable", {
  s_util_DynamicVariable: 1,
  O: 1
});
$c_s_util_DynamicVariable.prototype.$classData = $d_s_util_DynamicVariable;
/** @constructor */
function $c_s_util_control_Exception$() {
  this.s_util_control_Exception$__f_nothingCatcher = null;
  this.s_util_control_Exception$__f_noCatch = null;
  $n_s_util_control_Exception$ = this;
  this.s_util_control_Exception$__f_nothingCatcher = this.mkThrowableCatcher__F1__F1__s_PartialFunction(new $c_sjsr_AnonFunction1((function(this$1) {
    return (function(x$5$2) {
      $as_jl_Throwable(x$5$2);
      return false
    })
  })(this)), new $c_sjsr_AnonFunction1((function(this$2) {
    return (function(x$6$2) {
      var x$6 = $as_jl_Throwable(x$6$2);
      throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(x$6)
    })
  })(this)));
  var this$4 = new $c_s_util_control_Exception$Catch(this.s_util_control_Exception$__f_nothingCatcher, $m_s_None$(), $m_s_util_control_Exception$Catch$().$lessinit$greater$default$3__F1());
  this.s_util_control_Exception$__f_noCatch = $as_s_util_control_Exception$Catch($f_s_util_control_Exception$Described__withDesc__T__s_util_control_Exception$Described(this$4, "<nothing>"))
}
$c_s_util_control_Exception$.prototype = new $h_O();
$c_s_util_control_Exception$.prototype.constructor = $c_s_util_control_Exception$;
/** @constructor */
function $h_s_util_control_Exception$() {
  /*<skip>*/
}
$h_s_util_control_Exception$.prototype = $c_s_util_control_Exception$.prototype;
$c_s_util_control_Exception$.prototype.mkThrowableCatcher__F1__F1__s_PartialFunction = (function(isDef, f) {
  var evidence$1 = new $c_s_reflect_ClassTag$GenericClassTag($d_jl_Throwable.getClassOf());
  return new $c_s_util_control_Exception$$anon$1(evidence$1, isDef, f)
});
$c_s_util_control_Exception$.prototype.shouldRethrow__jl_Throwable__Z = (function(x) {
  return (false || false)
});
$c_s_util_control_Exception$.prototype.catching__sci_Seq__s_util_control_Exception$Catch = (function(exceptions) {
  var this$4 = new $c_s_util_control_Exception$Catch(new $c_s_util_control_Exception$$anonfun$pfFromExceptions$1(exceptions), $m_s_None$(), $m_s_util_control_Exception$Catch$().$lessinit$greater$default$3__F1());
  var this$3 = $as_sc_IterableOnceOps(exceptions.map__F1__O(new $c_sjsr_AnonFunction1((function(this$2) {
    return (function(x$10$2) {
      var x$10 = $as_jl_Class(x$10$2);
      return x$10.getName__T()
    })
  })(this))));
  var s = $f_sc_IterableOnceOps__mkString__T__T__T__T(this$3, "", ", ", "");
  return $as_s_util_control_Exception$Catch($f_s_util_control_Exception$Described__withDesc__T__s_util_control_Exception$Described(this$4, s))
});
$c_s_util_control_Exception$.prototype.scala$util$control$Exception$$wouldMatch__jl_Throwable__sc_Seq__Z = (function(x, classes) {
  return classes.exists__F1__Z(new $c_sjsr_AnonFunction1((function(this$1, x$1) {
    return (function(x$15$2) {
      var x$15 = $as_jl_Class(x$15$2);
      return x$15.isAssignableFrom__jl_Class__Z($objectGetClass(x$1))
    })
  })(this, x)))
});
var $d_s_util_control_Exception$ = new $TypeData().initClass({
  s_util_control_Exception$: 0
}, false, "scala.util.control.Exception$", {
  s_util_control_Exception$: 1,
  O: 1
});
$c_s_util_control_Exception$.prototype.$classData = $d_s_util_control_Exception$;
var $n_s_util_control_Exception$;
function $m_s_util_control_Exception$() {
  if ((!$n_s_util_control_Exception$)) {
    $n_s_util_control_Exception$ = new $c_s_util_control_Exception$()
  };
  return $n_s_util_control_Exception$
}
/** @constructor */
function $c_s_util_control_Exception$Catch$() {
  /*<skip>*/
}
$c_s_util_control_Exception$Catch$.prototype = new $h_O();
$c_s_util_control_Exception$Catch$.prototype.constructor = $c_s_util_control_Exception$Catch$;
/** @constructor */
function $h_s_util_control_Exception$Catch$() {
  /*<skip>*/
}
$h_s_util_control_Exception$Catch$.prototype = $c_s_util_control_Exception$Catch$.prototype;
$c_s_util_control_Exception$Catch$.prototype.$lessinit$greater$default$3__F1 = (function() {
  return new $c_sjsr_AnonFunction1((function(this$1) {
    return (function(x$2) {
      var x = $as_jl_Throwable(x$2);
      return $m_s_util_control_Exception$().shouldRethrow__jl_Throwable__Z(x)
    })
  })(this))
});
var $d_s_util_control_Exception$Catch$ = new $TypeData().initClass({
  s_util_control_Exception$Catch$: 0
}, false, "scala.util.control.Exception$Catch$", {
  s_util_control_Exception$Catch$: 1,
  O: 1
});
$c_s_util_control_Exception$Catch$.prototype.$classData = $d_s_util_control_Exception$Catch$;
var $n_s_util_control_Exception$Catch$;
function $m_s_util_control_Exception$Catch$() {
  if ((!$n_s_util_control_Exception$Catch$)) {
    $n_s_util_control_Exception$Catch$ = new $c_s_util_control_Exception$Catch$()
  };
  return $n_s_util_control_Exception$Catch$
}
function $f_s_util_control_Exception$Described__withDesc__T__s_util_control_Exception$Described($thiz, s) {
  $thiz.s_util_control_Exception$Catch__f_scala$util$control$Exception$Described$$_desc = s;
  return $thiz
}
function $f_s_util_control_Exception$Described__toString__T($thiz) {
  return ((($thiz.s_util_control_Exception$Catch__f_name + "(") + $thiz.s_util_control_Exception$Catch__f_scala$util$control$Exception$Described$$_desc) + ")")
}
function $f_s_util_control_NoStackTrace__fillInStackTrace__jl_Throwable($thiz) {
  var this$1 = $m_s_util_control_NoStackTrace$();
  if (this$1.s_util_control_NoStackTrace$__f__noSuppression) {
    return $c_jl_Throwable.prototype.fillInStackTrace__jl_Throwable.call($thiz)
  } else {
    return $as_jl_Throwable($thiz)
  }
}
/** @constructor */
function $c_s_util_control_NonFatal$() {
  /*<skip>*/
}
$c_s_util_control_NonFatal$.prototype = new $h_O();
$c_s_util_control_NonFatal$.prototype.constructor = $c_s_util_control_NonFatal$;
/** @constructor */
function $h_s_util_control_NonFatal$() {
  /*<skip>*/
}
$h_s_util_control_NonFatal$.prototype = $c_s_util_control_NonFatal$.prototype;
$c_s_util_control_NonFatal$.prototype.apply__jl_Throwable__Z = (function(t) {
  return (!((t instanceof $c_jl_VirtualMachineError) || (false || (false || (false || false)))))
});
$c_s_util_control_NonFatal$.prototype.unapply__jl_Throwable__s_Option = (function(t) {
  return (this.apply__jl_Throwable__Z(t) ? new $c_s_Some(t) : $m_s_None$())
});
var $d_s_util_control_NonFatal$ = new $TypeData().initClass({
  s_util_control_NonFatal$: 0
}, false, "scala.util.control.NonFatal$", {
  s_util_control_NonFatal$: 1,
  O: 1
});
$c_s_util_control_NonFatal$.prototype.$classData = $d_s_util_control_NonFatal$;
var $n_s_util_control_NonFatal$;
function $m_s_util_control_NonFatal$() {
  if ((!$n_s_util_control_NonFatal$)) {
    $n_s_util_control_NonFatal$ = new $c_s_util_control_NonFatal$()
  };
  return $n_s_util_control_NonFatal$
}
/** @constructor */
function $c_s_util_hashing_MurmurHash3() {
  /*<skip>*/
}
$c_s_util_hashing_MurmurHash3.prototype = new $h_O();
$c_s_util_hashing_MurmurHash3.prototype.constructor = $c_s_util_hashing_MurmurHash3;
/** @constructor */
function $h_s_util_hashing_MurmurHash3() {
  /*<skip>*/
}
$h_s_util_hashing_MurmurHash3.prototype = $c_s_util_hashing_MurmurHash3.prototype;
$c_s_util_hashing_MurmurHash3.prototype.mix__I__I__I = (function(hash, data) {
  var h = this.mixLast__I__I__I(hash, data);
  var i = h;
  h = ((i << 13) | ((i >>> 19) | 0));
  return (((-430675100) + $imul(5, h)) | 0)
});
$c_s_util_hashing_MurmurHash3.prototype.mixLast__I__I__I = (function(hash, data) {
  var k = data;
  k = $imul((-862048943), k);
  var i = k;
  k = ((i << 15) | ((i >>> 17) | 0));
  k = $imul(461845907, k);
  return (hash ^ k)
});
$c_s_util_hashing_MurmurHash3.prototype.finalizeHash__I__I__I = (function(hash, length) {
  return this.scala$util$hashing$MurmurHash3$$avalanche__I__I((hash ^ length))
});
$c_s_util_hashing_MurmurHash3.prototype.scala$util$hashing$MurmurHash3$$avalanche__I__I = (function(hash) {
  var h = hash;
  h = (h ^ ((h >>> 16) | 0));
  h = $imul((-2048144789), h);
  h = (h ^ ((h >>> 13) | 0));
  h = $imul((-1028477387), h);
  h = (h ^ ((h >>> 16) | 0));
  return h
});
$c_s_util_hashing_MurmurHash3.prototype.tuple2Hash__I__I__I__I = (function(x, y, seed) {
  var h = seed;
  h = this.mix__I__I__I(h, $f_T__hashCode__I("Tuple2"));
  h = this.mix__I__I__I(h, x);
  h = this.mix__I__I__I(h, y);
  return this.finalizeHash__I__I__I(h, 2)
});
$c_s_util_hashing_MurmurHash3.prototype.productHash__s_Product__I__Z__I = (function(x, seed, ignorePrefix) {
  var arr = x.productArity__I();
  if ((arr === 0)) {
    return $f_T__hashCode__I(x.productPrefix__T())
  } else {
    var h = seed;
    if ((!ignorePrefix)) {
      h = this.mix__I__I__I(h, $f_T__hashCode__I(x.productPrefix__T()))
    };
    var i = 0;
    while ((i < arr)) {
      var $$x1 = h;
      var x$1 = x.productElement__I__O(i);
      h = this.mix__I__I__I($$x1, $m_sr_Statics$().anyHash__O__I(x$1));
      i = ((1 + i) | 0)
    };
    return this.finalizeHash__I__I__I(h, arr)
  }
});
$c_s_util_hashing_MurmurHash3.prototype.unorderedHash__sc_IterableOnce__I__I = (function(xs, seed) {
  var a = 0;
  var b = 0;
  var n = 0;
  var c = 1;
  var iterator = xs.iterator__sc_Iterator();
  while (iterator.hasNext__Z()) {
    var x = iterator.next__O();
    var h = $m_sr_Statics$().anyHash__O__I(x);
    a = ((a + h) | 0);
    b = (b ^ h);
    c = $imul(c, (1 | h));
    n = ((1 + n) | 0)
  };
  var h$2 = seed;
  h$2 = this.mix__I__I__I(h$2, a);
  h$2 = this.mix__I__I__I(h$2, b);
  h$2 = this.mixLast__I__I__I(h$2, c);
  return this.finalizeHash__I__I__I(h$2, n)
});
$c_s_util_hashing_MurmurHash3.prototype.orderedHash__sc_IterableOnce__I__I = (function(xs, seed) {
  var it = xs.iterator__sc_Iterator();
  var h = seed;
  if ((!it.hasNext__Z())) {
    return this.finalizeHash__I__I__I(h, 0)
  };
  var x0 = it.next__O();
  if ((!it.hasNext__Z())) {
    return this.finalizeHash__I__I__I(this.mix__I__I__I(h, $m_sr_Statics$().anyHash__O__I(x0)), 1)
  };
  var x1 = it.next__O();
  var initial = $m_sr_Statics$().anyHash__O__I(x0);
  h = this.mix__I__I__I(h, initial);
  var h0 = h;
  var prev = $m_sr_Statics$().anyHash__O__I(x1);
  var rangeDiff = ((prev - initial) | 0);
  var i = 2;
  while (it.hasNext__Z()) {
    h = this.mix__I__I__I(h, prev);
    var x = it.next__O();
    var hash = $m_sr_Statics$().anyHash__O__I(x);
    if ((rangeDiff !== ((hash - prev) | 0))) {
      h = this.mix__I__I__I(h, hash);
      i = ((1 + i) | 0);
      while (it.hasNext__Z()) {
        var $$x1 = h;
        var x$1 = it.next__O();
        h = this.mix__I__I__I($$x1, $m_sr_Statics$().anyHash__O__I(x$1));
        i = ((1 + i) | 0)
      };
      return this.finalizeHash__I__I__I(h, i)
    };
    prev = hash;
    i = ((1 + i) | 0)
  };
  return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(h0, rangeDiff), prev))
});
$c_s_util_hashing_MurmurHash3.prototype.arrayHash__O__I__I = (function(a, seed) {
  var h = seed;
  var l = $m_sr_ScalaRunTime$().array_length__O__I(a);
  switch (l) {
    case 0: {
      return this.finalizeHash__I__I__I(h, 0);
      break
    }
    case 1: {
      var $$x1 = h;
      var x = $m_sr_ScalaRunTime$().array_apply__O__I__O(a, 0);
      return this.finalizeHash__I__I__I(this.mix__I__I__I($$x1, $m_sr_Statics$().anyHash__O__I(x)), 1);
      break
    }
    default: {
      var x$1 = $m_sr_ScalaRunTime$().array_apply__O__I__O(a, 0);
      var initial = $m_sr_Statics$().anyHash__O__I(x$1);
      h = this.mix__I__I__I(h, initial);
      var h0 = h;
      var x$2 = $m_sr_ScalaRunTime$().array_apply__O__I__O(a, 1);
      var prev = $m_sr_Statics$().anyHash__O__I(x$2);
      var rangeDiff = ((prev - initial) | 0);
      var i = 2;
      while ((i < l)) {
        h = this.mix__I__I__I(h, prev);
        var x$3 = $m_sr_ScalaRunTime$().array_apply__O__I__O(a, i);
        var hash = $m_sr_Statics$().anyHash__O__I(x$3);
        if ((rangeDiff !== ((hash - prev) | 0))) {
          h = this.mix__I__I__I(h, hash);
          i = ((1 + i) | 0);
          while ((i < l)) {
            var $$x2 = h;
            var x$4 = $m_sr_ScalaRunTime$().array_apply__O__I__O(a, i);
            h = this.mix__I__I__I($$x2, $m_sr_Statics$().anyHash__O__I(x$4));
            i = ((1 + i) | 0)
          };
          return this.finalizeHash__I__I__I(h, l)
        };
        prev = hash;
        i = ((1 + i) | 0)
      };
      return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(h0, rangeDiff), prev))
    }
  }
});
$c_s_util_hashing_MurmurHash3.prototype.rangeHash__I__I__I__I__I = (function(start, step, last, seed) {
  return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(this.mix__I__I__I(seed, start), step), last))
});
$c_s_util_hashing_MurmurHash3.prototype.indexedSeqHash__sc_IndexedSeq__I__I = (function(a, seed) {
  var h = seed;
  var l = a.length__I();
  switch (l) {
    case 0: {
      return this.finalizeHash__I__I__I(h, 0);
      break
    }
    case 1: {
      var $$x1 = h;
      var x = a.apply__I__O(0);
      return this.finalizeHash__I__I__I(this.mix__I__I__I($$x1, $m_sr_Statics$().anyHash__O__I(x)), 1);
      break
    }
    default: {
      var x$1 = a.apply__I__O(0);
      var initial = $m_sr_Statics$().anyHash__O__I(x$1);
      h = this.mix__I__I__I(h, initial);
      var h0 = h;
      var x$2 = a.apply__I__O(1);
      var prev = $m_sr_Statics$().anyHash__O__I(x$2);
      var rangeDiff = ((prev - initial) | 0);
      var i = 2;
      while ((i < l)) {
        h = this.mix__I__I__I(h, prev);
        var x$3 = a.apply__I__O(i);
        var hash = $m_sr_Statics$().anyHash__O__I(x$3);
        if ((rangeDiff !== ((hash - prev) | 0))) {
          h = this.mix__I__I__I(h, hash);
          i = ((1 + i) | 0);
          while ((i < l)) {
            var $$x2 = h;
            var x$4 = a.apply__I__O(i);
            h = this.mix__I__I__I($$x2, $m_sr_Statics$().anyHash__O__I(x$4));
            i = ((1 + i) | 0)
          };
          return this.finalizeHash__I__I__I(h, l)
        };
        prev = hash;
        i = ((1 + i) | 0)
      };
      return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(h0, rangeDiff), prev))
    }
  }
});
$c_s_util_hashing_MurmurHash3.prototype.listHash__sci_List__I__I = (function(xs, seed) {
  var n = 0;
  var h = seed;
  var rangeState = 0;
  var rangeDiff = 0;
  var prev = 0;
  var initial = 0;
  var elems = xs;
  while ((!elems.isEmpty__Z())) {
    var head = elems.head__O();
    var tail = $as_sci_List(elems.tail__O());
    var hash = $m_sr_Statics$().anyHash__O__I(head);
    h = this.mix__I__I__I(h, hash);
    var x1 = rangeState;
    switch (x1) {
      case 0: {
        initial = hash;
        rangeState = 1;
        break
      }
      case 1: {
        rangeDiff = ((hash - prev) | 0);
        rangeState = 2;
        break
      }
      case 2: {
        if ((rangeDiff !== ((hash - prev) | 0))) {
          rangeState = 3
        };
        break
      }
    };
    prev = hash;
    n = ((1 + n) | 0);
    elems = tail
  };
  return ((rangeState === 2) ? this.rangeHash__I__I__I__I__I(initial, rangeDiff, prev, seed) : this.finalizeHash__I__I__I(h, n))
});
$c_s_util_hashing_MurmurHash3.prototype.arrayHash$mZc$sp__AZ__I__I = (function(a, seed) {
  var h = seed;
  var l = a.u.length;
  switch (l) {
    case 0: {
      return this.finalizeHash__I__I__I(h, 0);
      break
    }
    case 1: {
      return this.finalizeHash__I__I__I(this.mix__I__I__I(h, (a.get(0) ? 1231 : 1237)), 1);
      break
    }
    default: {
      var initial = (a.get(0) ? 1231 : 1237);
      h = this.mix__I__I__I(h, initial);
      var h0 = h;
      var prev = (a.get(1) ? 1231 : 1237);
      var rangeDiff = ((prev - initial) | 0);
      var i = 2;
      while ((i < l)) {
        h = this.mix__I__I__I(h, prev);
        var hash = (a.get(i) ? 1231 : 1237);
        if ((rangeDiff !== ((hash - prev) | 0))) {
          h = this.mix__I__I__I(h, hash);
          i = ((1 + i) | 0);
          while ((i < l)) {
            h = this.mix__I__I__I(h, (a.get(i) ? 1231 : 1237));
            i = ((1 + i) | 0)
          };
          return this.finalizeHash__I__I__I(h, l)
        };
        prev = hash;
        i = ((1 + i) | 0)
      };
      return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(h0, rangeDiff), prev))
    }
  }
});
$c_s_util_hashing_MurmurHash3.prototype.arrayHash$mBc$sp__AB__I__I = (function(a, seed) {
  var h = seed;
  var l = a.u.length;
  switch (l) {
    case 0: {
      return this.finalizeHash__I__I__I(h, 0);
      break
    }
    case 1: {
      return this.finalizeHash__I__I__I(this.mix__I__I__I(h, a.get(0)), 1);
      break
    }
    default: {
      var initial = a.get(0);
      h = this.mix__I__I__I(h, initial);
      var h0 = h;
      var prev = a.get(1);
      var rangeDiff = ((prev - initial) | 0);
      var i = 2;
      while ((i < l)) {
        h = this.mix__I__I__I(h, prev);
        var hash = a.get(i);
        if ((rangeDiff !== ((hash - prev) | 0))) {
          h = this.mix__I__I__I(h, hash);
          i = ((1 + i) | 0);
          while ((i < l)) {
            h = this.mix__I__I__I(h, a.get(i));
            i = ((1 + i) | 0)
          };
          return this.finalizeHash__I__I__I(h, l)
        };
        prev = hash;
        i = ((1 + i) | 0)
      };
      return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(h0, rangeDiff), prev))
    }
  }
});
$c_s_util_hashing_MurmurHash3.prototype.arrayHash$mCc$sp__AC__I__I = (function(a, seed) {
  var h = seed;
  var l = a.u.length;
  switch (l) {
    case 0: {
      return this.finalizeHash__I__I__I(h, 0);
      break
    }
    case 1: {
      return this.finalizeHash__I__I__I(this.mix__I__I__I(h, a.get(0)), 1);
      break
    }
    default: {
      var initial = a.get(0);
      h = this.mix__I__I__I(h, initial);
      var h0 = h;
      var prev = a.get(1);
      var rangeDiff = ((prev - initial) | 0);
      var i = 2;
      while ((i < l)) {
        h = this.mix__I__I__I(h, prev);
        var hash = a.get(i);
        if ((rangeDiff !== ((hash - prev) | 0))) {
          h = this.mix__I__I__I(h, hash);
          i = ((1 + i) | 0);
          while ((i < l)) {
            h = this.mix__I__I__I(h, a.get(i));
            i = ((1 + i) | 0)
          };
          return this.finalizeHash__I__I__I(h, l)
        };
        prev = hash;
        i = ((1 + i) | 0)
      };
      return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(h0, rangeDiff), prev))
    }
  }
});
$c_s_util_hashing_MurmurHash3.prototype.arrayHash$mDc$sp__AD__I__I = (function(a, seed) {
  var h = seed;
  var l = a.u.length;
  switch (l) {
    case 0: {
      return this.finalizeHash__I__I__I(h, 0);
      break
    }
    case 1: {
      var $$x1 = h;
      var dv = a.get(0);
      return this.finalizeHash__I__I__I(this.mix__I__I__I($$x1, $m_sr_Statics$().doubleHash__D__I(dv)), 1);
      break
    }
    default: {
      var dv$1 = a.get(0);
      var initial = $m_sr_Statics$().doubleHash__D__I(dv$1);
      h = this.mix__I__I__I(h, initial);
      var h0 = h;
      var dv$2 = a.get(1);
      var prev = $m_sr_Statics$().doubleHash__D__I(dv$2);
      var rangeDiff = ((prev - initial) | 0);
      var i = 2;
      while ((i < l)) {
        h = this.mix__I__I__I(h, prev);
        var dv$3 = a.get(i);
        var hash = $m_sr_Statics$().doubleHash__D__I(dv$3);
        if ((rangeDiff !== ((hash - prev) | 0))) {
          h = this.mix__I__I__I(h, hash);
          i = ((1 + i) | 0);
          while ((i < l)) {
            var $$x2 = h;
            var dv$4 = a.get(i);
            h = this.mix__I__I__I($$x2, $m_sr_Statics$().doubleHash__D__I(dv$4));
            i = ((1 + i) | 0)
          };
          return this.finalizeHash__I__I__I(h, l)
        };
        prev = hash;
        i = ((1 + i) | 0)
      };
      return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(h0, rangeDiff), prev))
    }
  }
});
$c_s_util_hashing_MurmurHash3.prototype.arrayHash$mFc$sp__AF__I__I = (function(a, seed) {
  var h = seed;
  var l = a.u.length;
  switch (l) {
    case 0: {
      return this.finalizeHash__I__I__I(h, 0);
      break
    }
    case 1: {
      var $$x1 = h;
      var fv = a.get(0);
      var this$1 = $m_sr_Statics$();
      return this.finalizeHash__I__I__I(this.mix__I__I__I($$x1, this$1.doubleHash__D__I(fv)), 1);
      break
    }
    default: {
      var fv$1 = a.get(0);
      var this$2 = $m_sr_Statics$();
      var initial = this$2.doubleHash__D__I(fv$1);
      h = this.mix__I__I__I(h, initial);
      var h0 = h;
      var fv$2 = a.get(1);
      var this$3 = $m_sr_Statics$();
      var prev = this$3.doubleHash__D__I(fv$2);
      var rangeDiff = ((prev - initial) | 0);
      var i = 2;
      while ((i < l)) {
        h = this.mix__I__I__I(h, prev);
        var fv$3 = a.get(i);
        var this$4 = $m_sr_Statics$();
        var hash = this$4.doubleHash__D__I(fv$3);
        if ((rangeDiff !== ((hash - prev) | 0))) {
          h = this.mix__I__I__I(h, hash);
          i = ((1 + i) | 0);
          while ((i < l)) {
            var $$x2 = h;
            var fv$4 = a.get(i);
            var this$5 = $m_sr_Statics$();
            h = this.mix__I__I__I($$x2, this$5.doubleHash__D__I(fv$4));
            i = ((1 + i) | 0)
          };
          return this.finalizeHash__I__I__I(h, l)
        };
        prev = hash;
        i = ((1 + i) | 0)
      };
      return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(h0, rangeDiff), prev))
    }
  }
});
$c_s_util_hashing_MurmurHash3.prototype.arrayHash$mIc$sp__AI__I__I = (function(a, seed) {
  var h = seed;
  var l = a.u.length;
  switch (l) {
    case 0: {
      return this.finalizeHash__I__I__I(h, 0);
      break
    }
    case 1: {
      return this.finalizeHash__I__I__I(this.mix__I__I__I(h, a.get(0)), 1);
      break
    }
    default: {
      var initial = a.get(0);
      h = this.mix__I__I__I(h, initial);
      var h0 = h;
      var prev = a.get(1);
      var rangeDiff = ((prev - initial) | 0);
      var i = 2;
      while ((i < l)) {
        h = this.mix__I__I__I(h, prev);
        var hash = a.get(i);
        if ((rangeDiff !== ((hash - prev) | 0))) {
          h = this.mix__I__I__I(h, hash);
          i = ((1 + i) | 0);
          while ((i < l)) {
            h = this.mix__I__I__I(h, a.get(i));
            i = ((1 + i) | 0)
          };
          return this.finalizeHash__I__I__I(h, l)
        };
        prev = hash;
        i = ((1 + i) | 0)
      };
      return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(h0, rangeDiff), prev))
    }
  }
});
$c_s_util_hashing_MurmurHash3.prototype.arrayHash$mJc$sp__AJ__I__I = (function(a, seed) {
  var h = seed;
  var l = a.u.length;
  switch (l) {
    case 0: {
      return this.finalizeHash__I__I__I(h, 0);
      break
    }
    case 1: {
      var $$x1 = h;
      var t = a.get(0);
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      return this.finalizeHash__I__I__I(this.mix__I__I__I($$x1, $m_sr_Statics$().longHash__J__I(new $c_RTLong(lo, hi))), 1);
      break
    }
    default: {
      var t$1 = a.get(0);
      var lo$1 = t$1.RTLong__f_lo;
      var hi$1 = t$1.RTLong__f_hi;
      var initial = $m_sr_Statics$().longHash__J__I(new $c_RTLong(lo$1, hi$1));
      h = this.mix__I__I__I(h, initial);
      var h0 = h;
      var t$2 = a.get(1);
      var lo$2 = t$2.RTLong__f_lo;
      var hi$2 = t$2.RTLong__f_hi;
      var prev = $m_sr_Statics$().longHash__J__I(new $c_RTLong(lo$2, hi$2));
      var rangeDiff = ((prev - initial) | 0);
      var i = 2;
      while ((i < l)) {
        h = this.mix__I__I__I(h, prev);
        var t$3 = a.get(i);
        var lo$3 = t$3.RTLong__f_lo;
        var hi$3 = t$3.RTLong__f_hi;
        var hash = $m_sr_Statics$().longHash__J__I(new $c_RTLong(lo$3, hi$3));
        if ((rangeDiff !== ((hash - prev) | 0))) {
          h = this.mix__I__I__I(h, hash);
          i = ((1 + i) | 0);
          while ((i < l)) {
            var $$x2 = h;
            var t$4 = a.get(i);
            var lo$4 = t$4.RTLong__f_lo;
            var hi$4 = t$4.RTLong__f_hi;
            h = this.mix__I__I__I($$x2, $m_sr_Statics$().longHash__J__I(new $c_RTLong(lo$4, hi$4)));
            i = ((1 + i) | 0)
          };
          return this.finalizeHash__I__I__I(h, l)
        };
        prev = hash;
        i = ((1 + i) | 0)
      };
      return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(h0, rangeDiff), prev))
    }
  }
});
$c_s_util_hashing_MurmurHash3.prototype.arrayHash$mSc$sp__AS__I__I = (function(a, seed) {
  var h = seed;
  var l = a.u.length;
  switch (l) {
    case 0: {
      return this.finalizeHash__I__I__I(h, 0);
      break
    }
    case 1: {
      return this.finalizeHash__I__I__I(this.mix__I__I__I(h, a.get(0)), 1);
      break
    }
    default: {
      var initial = a.get(0);
      h = this.mix__I__I__I(h, initial);
      var h0 = h;
      var prev = a.get(1);
      var rangeDiff = ((prev - initial) | 0);
      var i = 2;
      while ((i < l)) {
        h = this.mix__I__I__I(h, prev);
        var hash = a.get(i);
        if ((rangeDiff !== ((hash - prev) | 0))) {
          h = this.mix__I__I__I(h, hash);
          i = ((1 + i) | 0);
          while ((i < l)) {
            h = this.mix__I__I__I(h, a.get(i));
            i = ((1 + i) | 0)
          };
          return this.finalizeHash__I__I__I(h, l)
        };
        prev = hash;
        i = ((1 + i) | 0)
      };
      return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(h0, rangeDiff), prev))
    }
  }
});
$c_s_util_hashing_MurmurHash3.prototype.arrayHash$mVc$sp__Ajl_Void__I__I = (function(a, seed) {
  var h = seed;
  var l = a.u.length;
  switch (l) {
    case 0: {
      return this.finalizeHash__I__I__I(h, 0);
      break
    }
    case 1: {
      return this.finalizeHash__I__I__I(this.mix__I__I__I(h, 0), 1);
      break
    }
    default: {
      h = this.mix__I__I__I(h, 0);
      var h0 = h;
      var prev = 0;
      var rangeDiff = prev;
      var i = 2;
      while ((i < l)) {
        h = this.mix__I__I__I(h, prev);
        if ((rangeDiff !== ((-prev) | 0))) {
          h = this.mix__I__I__I(h, 0);
          i = ((1 + i) | 0);
          while ((i < l)) {
            h = this.mix__I__I__I(h, 0);
            i = ((1 + i) | 0)
          };
          return this.finalizeHash__I__I__I(h, l)
        };
        prev = 0;
        i = ((1 + i) | 0)
      };
      return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(h0, rangeDiff), prev))
    }
  }
});
function $is_Lscommons_api_ApiResponse(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lscommons_api_ApiResponse)))
}
function $as_Lscommons_api_ApiResponse(obj) {
  return (($is_Lscommons_api_ApiResponse(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scommons.api.ApiResponse"))
}
function $isArrayOf_Lscommons_api_ApiResponse(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscommons_api_ApiResponse)))
}
function $asArrayOf_Lscommons_api_ApiResponse(obj, depth) {
  return (($isArrayOf_Lscommons_api_ApiResponse(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscommons.api.ApiResponse;", depth))
}
/** @constructor */
function $c_Lscommons_expo_Asset$() {
  /*<skip>*/
}
$c_Lscommons_expo_Asset$.prototype = new $h_O();
$c_Lscommons_expo_Asset$.prototype.constructor = $c_Lscommons_expo_Asset$;
/** @constructor */
function $h_Lscommons_expo_Asset$() {
  /*<skip>*/
}
$h_Lscommons_expo_Asset$.prototype = $c_Lscommons_expo_Asset$.prototype;
$c_Lscommons_expo_Asset$.prototype.fromModule__Lscommons_reactnative_raw_StaticResource__Lscommons_expo_raw_Asset = (function(module) {
  return $i_expo$002dasset.Asset.fromModule(module)
});
$c_Lscommons_expo_Asset$.prototype.loadAsync__sci_Seq__s_concurrent_Future = (function(modules) {
  var $$x3 = $m_sjs_js_Thenable$ThenableOps$();
  var $$x2 = $i_expo$002dasset.Asset;
  var $$x1 = $m_sjsr_Compat$().toJSVarArgsImpl__sci_Seq__sjs_js_Array(modules);
  var p = $$x2.loadAsync($$x1);
  return $$x3.toFuture$extension__sjs_js_Thenable__s_concurrent_Future(p)
});
$c_Lscommons_expo_Asset$.prototype.loadAsync__Lscommons_reactnative_raw_StaticResource__s_concurrent_Future = (function(module) {
  var $$x1 = $m_sjs_js_Thenable$ThenableOps$();
  var p = $i_expo$002dasset.Asset.loadAsync(module);
  return $$x1.toFuture$extension__sjs_js_Thenable__s_concurrent_Future(p)
});
var $d_Lscommons_expo_Asset$ = new $TypeData().initClass({
  Lscommons_expo_Asset$: 0
}, false, "scommons.expo.Asset$", {
  Lscommons_expo_Asset$: 1,
  O: 1
});
$c_Lscommons_expo_Asset$.prototype.$classData = $d_Lscommons_expo_Asset$;
var $n_Lscommons_expo_Asset$;
function $m_Lscommons_expo_Asset$() {
  if ((!$n_Lscommons_expo_Asset$)) {
    $n_Lscommons_expo_Asset$ = new $c_Lscommons_expo_Asset$()
  };
  return $n_Lscommons_expo_Asset$
}
/** @constructor */
function $c_Lscommons_expo_Font$() {
  /*<skip>*/
}
$c_Lscommons_expo_Font$.prototype = new $h_O();
$c_Lscommons_expo_Font$.prototype.constructor = $c_Lscommons_expo_Font$;
/** @constructor */
function $h_Lscommons_expo_Font$() {
  /*<skip>*/
}
$h_Lscommons_expo_Font$.prototype = $c_Lscommons_expo_Font$.prototype;
$c_Lscommons_expo_Font$.prototype.loadAsync__sci_Seq__s_concurrent_Future = (function(fonts) {
  return this.loadAsync__sjs_js_Dictionary__s_concurrent_Future($m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(fonts))
});
$c_Lscommons_expo_Font$.prototype.loadAsync__sjs_js_Dictionary__s_concurrent_Future = (function(fonts) {
  var $$x1 = $m_sjs_js_Thenable$ThenableOps$();
  var p = $i_expo$002dfont.loadAsync(fonts);
  return $$x1.toFuture$extension__sjs_js_Thenable__s_concurrent_Future(p)
});
var $d_Lscommons_expo_Font$ = new $TypeData().initClass({
  Lscommons_expo_Font$: 0
}, false, "scommons.expo.Font$", {
  Lscommons_expo_Font$: 1,
  O: 1
});
$c_Lscommons_expo_Font$.prototype.$classData = $d_Lscommons_expo_Font$;
var $n_Lscommons_expo_Font$;
function $m_Lscommons_expo_Font$() {
  if ((!$n_Lscommons_expo_Font$)) {
    $n_Lscommons_expo_Font$ = new $c_Lscommons_expo_Font$()
  };
  return $n_Lscommons_expo_Font$
}
function $p_Lscommons_expo_av_package$ExpoAVAttributes__expoAVSource$lzycompute__Lscommons_expo_av_package$ExpoAVAttributes$ExpoAVSourceAttributeSpec($thiz) {
  if (((((1 & $thiz.Lscommons_expo_av_package$ExpoAVAttributes__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lscommons_expo_av_package$ExpoAVAttributes__f_expoAVSource = new $c_Lscommons_expo_av_package$ExpoAVAttributes$ExpoAVSourceAttributeSpec("source");
    $thiz.Lscommons_expo_av_package$ExpoAVAttributes__f_bitmap$0 = (((1 | $thiz.Lscommons_expo_av_package$ExpoAVAttributes__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lscommons_expo_av_package$ExpoAVAttributes__f_expoAVSource
}
function $p_Lscommons_expo_av_package$ExpoAVAttributes__shouldPlay$lzycompute__Lio_github_shogowada_statictags_BooleanAttributeSpec($thiz) {
  if (((((2 & $thiz.Lscommons_expo_av_package$ExpoAVAttributes__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lscommons_expo_av_package$ExpoAVAttributes__f_shouldPlay = new $c_Lio_github_shogowada_statictags_BooleanAttributeSpec("shouldPlay");
    $thiz.Lscommons_expo_av_package$ExpoAVAttributes__f_bitmap$0 = (((2 | $thiz.Lscommons_expo_av_package$ExpoAVAttributes__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lscommons_expo_av_package$ExpoAVAttributes__f_shouldPlay
}
function $p_Lscommons_expo_av_package$ExpoAVAttributes__useNativeControls$lzycompute__Lio_github_shogowada_statictags_BooleanAttributeSpec($thiz) {
  if (((((4 & $thiz.Lscommons_expo_av_package$ExpoAVAttributes__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lscommons_expo_av_package$ExpoAVAttributes__f_useNativeControls = new $c_Lio_github_shogowada_statictags_BooleanAttributeSpec("useNativeControls");
    $thiz.Lscommons_expo_av_package$ExpoAVAttributes__f_bitmap$0 = (((4 | $thiz.Lscommons_expo_av_package$ExpoAVAttributes__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lscommons_expo_av_package$ExpoAVAttributes__f_useNativeControls
}
/** @constructor */
function $c_Lscommons_expo_av_package$ExpoAVAttributes(attributes) {
  this.Lscommons_expo_av_package$ExpoAVAttributes__f_expoAVSource = null;
  this.Lscommons_expo_av_package$ExpoAVAttributes__f_shouldPlay = null;
  this.Lscommons_expo_av_package$ExpoAVAttributes__f_useNativeControls = null;
  this.Lscommons_expo_av_package$ExpoAVAttributes__f_bitmap$0 = 0
}
$c_Lscommons_expo_av_package$ExpoAVAttributes.prototype = new $h_O();
$c_Lscommons_expo_av_package$ExpoAVAttributes.prototype.constructor = $c_Lscommons_expo_av_package$ExpoAVAttributes;
/** @constructor */
function $h_Lscommons_expo_av_package$ExpoAVAttributes() {
  /*<skip>*/
}
$h_Lscommons_expo_av_package$ExpoAVAttributes.prototype = $c_Lscommons_expo_av_package$ExpoAVAttributes.prototype;
$c_Lscommons_expo_av_package$ExpoAVAttributes.prototype.expoAVSource__Lscommons_expo_av_package$ExpoAVAttributes$ExpoAVSourceAttributeSpec = (function() {
  return (((((1 & this.Lscommons_expo_av_package$ExpoAVAttributes__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lscommons_expo_av_package$ExpoAVAttributes__expoAVSource$lzycompute__Lscommons_expo_av_package$ExpoAVAttributes$ExpoAVSourceAttributeSpec(this) : this.Lscommons_expo_av_package$ExpoAVAttributes__f_expoAVSource)
});
$c_Lscommons_expo_av_package$ExpoAVAttributes.prototype.shouldPlay__Lio_github_shogowada_statictags_BooleanAttributeSpec = (function() {
  return (((((2 & this.Lscommons_expo_av_package$ExpoAVAttributes__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lscommons_expo_av_package$ExpoAVAttributes__shouldPlay$lzycompute__Lio_github_shogowada_statictags_BooleanAttributeSpec(this) : this.Lscommons_expo_av_package$ExpoAVAttributes__f_shouldPlay)
});
$c_Lscommons_expo_av_package$ExpoAVAttributes.prototype.useNativeControls__Lio_github_shogowada_statictags_BooleanAttributeSpec = (function() {
  return (((((4 & this.Lscommons_expo_av_package$ExpoAVAttributes__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lscommons_expo_av_package$ExpoAVAttributes__useNativeControls$lzycompute__Lio_github_shogowada_statictags_BooleanAttributeSpec(this) : this.Lscommons_expo_av_package$ExpoAVAttributes__f_useNativeControls)
});
var $d_Lscommons_expo_av_package$ExpoAVAttributes = new $TypeData().initClass({
  Lscommons_expo_av_package$ExpoAVAttributes: 0
}, false, "scommons.expo.av.package$ExpoAVAttributes", {
  Lscommons_expo_av_package$ExpoAVAttributes: 1,
  O: 1
});
$c_Lscommons_expo_av_package$ExpoAVAttributes.prototype.$classData = $d_Lscommons_expo_av_package$ExpoAVAttributes;
function $p_Lscommons_expo_av_package$ExpoAVElements__Video$lzycompute__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($thiz) {
  if ((!$thiz.Lscommons_expo_av_package$ExpoAVElements__f_bitmap$0)) {
    var reactClass = $i_expo$002dav.Video;
    $thiz.Lscommons_expo_av_package$ExpoAVElements__f_Video = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass);
    $thiz.Lscommons_expo_av_package$ExpoAVElements__f_bitmap$0 = true
  };
  $thiz.Lscommons_expo_av_package$ExpoAVElements__f_elements = null;
  return $thiz.Lscommons_expo_av_package$ExpoAVElements__f_Video
}
/** @constructor */
function $c_Lscommons_expo_av_package$ExpoAVElements(elements) {
  this.Lscommons_expo_av_package$ExpoAVElements__f_Video = null;
  this.Lscommons_expo_av_package$ExpoAVElements__f_elements = null;
  this.Lscommons_expo_av_package$ExpoAVElements__f_bitmap$0 = false;
  this.Lscommons_expo_av_package$ExpoAVElements__f_elements = elements
}
$c_Lscommons_expo_av_package$ExpoAVElements.prototype = new $h_O();
$c_Lscommons_expo_av_package$ExpoAVElements.prototype.constructor = $c_Lscommons_expo_av_package$ExpoAVElements;
/** @constructor */
function $h_Lscommons_expo_av_package$ExpoAVElements() {
  /*<skip>*/
}
$h_Lscommons_expo_av_package$ExpoAVElements.prototype = $c_Lscommons_expo_av_package$ExpoAVElements.prototype;
$c_Lscommons_expo_av_package$ExpoAVElements.prototype.Video__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec = (function() {
  return ((!this.Lscommons_expo_av_package$ExpoAVElements__f_bitmap$0) ? $p_Lscommons_expo_av_package$ExpoAVElements__Video$lzycompute__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec(this) : this.Lscommons_expo_av_package$ExpoAVElements__f_Video)
});
var $d_Lscommons_expo_av_package$ExpoAVElements = new $TypeData().initClass({
  Lscommons_expo_av_package$ExpoAVElements: 0
}, false, "scommons.expo.av.package$ExpoAVElements", {
  Lscommons_expo_av_package$ExpoAVElements: 1,
  O: 1
});
$c_Lscommons_expo_av_package$ExpoAVElements.prototype.$classData = $d_Lscommons_expo_av_package$ExpoAVElements;
function $p_Lscommons_expo_package$__VectorIcons$lzycompute__Lscommons_expo_raw_VectorIcons$($thiz) {
  if ((!$thiz.Lscommons_expo_package$__f_bitmap$0)) {
    $thiz.Lscommons_expo_package$__f_VectorIcons = $i_$0040expo$002fvector$002dicons;
    $thiz.Lscommons_expo_package$__f_bitmap$0 = true
  };
  return $thiz.Lscommons_expo_package$__f_VectorIcons
}
/** @constructor */
function $c_Lscommons_expo_package$() {
  this.Lscommons_expo_package$__f_VectorIcons = null;
  this.Lscommons_expo_package$__f_bitmap$0 = false
}
$c_Lscommons_expo_package$.prototype = new $h_O();
$c_Lscommons_expo_package$.prototype.constructor = $c_Lscommons_expo_package$;
/** @constructor */
function $h_Lscommons_expo_package$() {
  /*<skip>*/
}
$h_Lscommons_expo_package$.prototype = $c_Lscommons_expo_package$.prototype;
$c_Lscommons_expo_package$.prototype.VectorIcons__Lscommons_expo_raw_VectorIcons$ = (function() {
  return ((!this.Lscommons_expo_package$__f_bitmap$0) ? $p_Lscommons_expo_package$__VectorIcons$lzycompute__Lscommons_expo_raw_VectorIcons$(this) : this.Lscommons_expo_package$__f_VectorIcons)
});
var $d_Lscommons_expo_package$ = new $TypeData().initClass({
  Lscommons_expo_package$: 0
}, false, "scommons.expo.package$", {
  Lscommons_expo_package$: 1,
  O: 1
});
$c_Lscommons_expo_package$.prototype.$classData = $d_Lscommons_expo_package$;
var $n_Lscommons_expo_package$;
function $m_Lscommons_expo_package$() {
  if ((!$n_Lscommons_expo_package$)) {
    $n_Lscommons_expo_package$ = new $c_Lscommons_expo_package$()
  };
  return $n_Lscommons_expo_package$
}
function $f_Lscommons_expo_sqlite_SQLite__openDatabase__T__s_concurrent_Future($thiz, name) {
  var p = $ct_s_concurrent_impl_Promise$DefaultPromise__(new $c_s_concurrent_impl_Promise$DefaultPromise());
  try {
    var $$x1 = new $c_s_util_Success(new $c_Lscommons_websql_Database($i_expo$002dsqlite.openDatabase(name)))
  } catch (e) {
    var e$2 = $m_sjsr_package$().wrapJavaScriptException__O__jl_Throwable(e);
    if ((e$2 !== null)) {
      matchEnd8: {
        var $$x1;
        if ((e$2 !== null)) {
          var o11 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
          if ((!o11.isEmpty__Z())) {
            var e$3 = $as_jl_Throwable(o11.get__O());
            var $$x1 = new $c_s_util_Failure(e$3);
            break matchEnd8
          }
        };
        throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(e$2)
      }
    } else {
      var $$x1;
      throw e
    }
  };
  $$x1.fold__F1__F1__O(new $c_sjsr_AnonFunction1((function(this$2$1, p$1) {
    return (function(error$2) {
      var error = $as_jl_Throwable(error$2);
      return $f_s_concurrent_Promise__failure__jl_Throwable__s_concurrent_Promise(p$1, error)
    })
  })($thiz, p)), new $c_sjsr_AnonFunction1((function(this$3, p$2) {
    return (function(res$2) {
      var res = $as_Lscommons_websql_Database(res$2);
      return $f_s_concurrent_Promise__success__O__s_concurrent_Promise(p$2, res)
    })
  })($thiz, p)));
  return p
}
function $f_Lscommons_react_UiComponent__displayName__T($thiz) {
  var name = $objectClassName($thiz);
  var $$x1 = $m_sc_StringOps$();
  var x = $m_sc_StringOps$().drop$extension__T__I__T(name, ((1 + $f_T__lastIndexOf__I__I(name, 46)) | 0));
  return $$x1.stripSuffix$extension__T__T__T(x, "$")
}
function $f_Lscommons_react_hooks_UseEffect__useEffect__F0__sci_List__V($thiz, didUpdate, dependencies) {
  var $$x3 = $moduleDefault($i_react);
  var $$x2 = $m_sjs_js_Any$().fromFunction0__F0__sjs_js_Function0(didUpdate);
  var $$x1 = $m_sjsr_Compat$().toJSVarArgsImpl__sci_Seq__sjs_js_Array(dependencies);
  $$x3.useEffect($$x2, $$x1)
}
function $f_Lscommons_react_hooks_UseLayoutEffect__useLayoutEffect__F0__sci_List__V($thiz, didUpdate, dependencies) {
  var $$x3 = $moduleDefault($i_react);
  var $$x2 = $m_sjs_js_Any$().fromFunction0__F0__sjs_js_Function0(didUpdate);
  var $$x1 = $m_sjsr_Compat$().toJSVarArgsImpl__sci_Seq__sjs_js_Array(dependencies);
  $$x3.useLayoutEffect($$x2, $$x1)
}
function $f_Lscommons_react_hooks_UseMemo__useMemo__F0__sci_List__O($thiz, calculate, dependencies) {
  var $$x3 = $moduleDefault($i_react);
  var $$x2 = $m_sjs_js_Any$().fromFunction0__F0__sjs_js_Function0(calculate);
  var $$x1 = $m_sjsr_Compat$().toJSVarArgsImpl__sci_Seq__sjs_js_Array(dependencies);
  return $$x3.useMemo($$x2, $$x1)
}
function $f_Lscommons_react_hooks_UseState__useState__O__T2($thiz, initialState) {
  return $p_Lscommons_react_hooks_UseState__extractData__sjs_js_Array__T2($thiz, $moduleDefault($i_react).useState(initialState))
}
function $f_Lscommons_react_hooks_UseState__useStateUpdater__F0__T2($thiz, initialState) {
  return $p_Lscommons_react_hooks_UseState__extractUpdater__sjs_js_Array__T2($thiz, $moduleDefault($i_react).useState($m_sjs_js_Any$().fromFunction0__F0__sjs_js_Function0(initialState)))
}
function $p_Lscommons_react_hooks_UseState__extractData__sjs_js_Array__T2($thiz, data) {
  var value = data[0];
  var setState = data[1];
  return new $c_T2(value, setState)
}
function $p_Lscommons_react_hooks_UseState__extractUpdater__sjs_js_Array__T2($thiz, data) {
  var value = data[0];
  var setState = data[1];
  return new $c_T2(value, setState)
}
/** @constructor */
function $c_Lscommons_react_navigation_Navigation(navigation, route) {
  this.Lscommons_react_navigation_Navigation__f_navigation = null;
  this.Lscommons_react_navigation_Navigation__f_route = null;
  this.Lscommons_react_navigation_Navigation__f_navigation = navigation;
  this.Lscommons_react_navigation_Navigation__f_route = route
}
$c_Lscommons_react_navigation_Navigation.prototype = new $h_O();
$c_Lscommons_react_navigation_Navigation.prototype.constructor = $c_Lscommons_react_navigation_Navigation;
/** @constructor */
function $h_Lscommons_react_navigation_Navigation() {
  /*<skip>*/
}
$h_Lscommons_react_navigation_Navigation.prototype = $c_Lscommons_react_navigation_Navigation.prototype;
$c_Lscommons_react_navigation_Navigation.prototype.navigate__T__V = (function(name) {
  this.Lscommons_react_navigation_Navigation__f_navigation.navigate(name)
});
var $d_Lscommons_react_navigation_Navigation = new $TypeData().initClass({
  Lscommons_react_navigation_Navigation: 0
}, false, "scommons.react.navigation.Navigation", {
  Lscommons_react_navigation_Navigation: 1,
  O: 1
});
$c_Lscommons_react_navigation_Navigation.prototype.$classData = $d_Lscommons_react_navigation_Navigation;
/** @constructor */
function $c_Lscommons_react_navigation_Navigation$() {
  /*<skip>*/
}
$c_Lscommons_react_navigation_Navigation$.prototype = new $h_O();
$c_Lscommons_react_navigation_Navigation$.prototype.constructor = $c_Lscommons_react_navigation_Navigation$;
/** @constructor */
function $h_Lscommons_react_navigation_Navigation$() {
  /*<skip>*/
}
$h_Lscommons_react_navigation_Navigation$.prototype = $c_Lscommons_react_navigation_Navigation$.prototype;
$c_Lscommons_react_navigation_Navigation$.prototype.apply__Lio_github_shogowada_scalajs_reactjs_React$Props__Lscommons_react_navigation_Navigation = (function(props) {
  return new $c_Lscommons_react_navigation_Navigation(props.Lio_github_shogowada_scalajs_reactjs_React$Props__f_native.navigation, props.Lio_github_shogowada_scalajs_reactjs_React$Props__f_native.route)
});
var $d_Lscommons_react_navigation_Navigation$ = new $TypeData().initClass({
  Lscommons_react_navigation_Navigation$: 0
}, false, "scommons.react.navigation.Navigation$", {
  Lscommons_react_navigation_Navigation$: 1,
  O: 1
});
$c_Lscommons_react_navigation_Navigation$.prototype.$classData = $d_Lscommons_react_navigation_Navigation$;
var $n_Lscommons_react_navigation_Navigation$;
function $m_Lscommons_react_navigation_Navigation$() {
  if ((!$n_Lscommons_react_navigation_Navigation$)) {
    $n_Lscommons_react_navigation_Navigation$ = new $c_Lscommons_react_navigation_Navigation$()
  };
  return $n_Lscommons_react_navigation_Navigation$
}
function $f_Lscommons_react_navigation_ReactNavigation__getFocusedRouteNameFromRoute__Lscommons_react_navigation_raw_Route__s_Option($thiz, route) {
  var routeName = $thiz.native__Lscommons_react_navigation_raw_ReactNavigation().getFocusedRouteNameFromRoute(route);
  return (((routeName === (void 0)) || (routeName === null)) ? $m_s_None$() : new $c_s_Some($as_T(routeName)))
}
function $f_Lscommons_react_navigation_ReactNavigation__themeStyle__Lscommons_reactnative_Style__Lscommons_reactnative_Style__Lscommons_react_navigation_raw_Theme__Lio_github_shogowada_statictags_Attribute($thiz, light, dark, theme) {
  if ($uZ(theme.dark)) {
    var attributes = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
    var style = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__sjs_js_Array__Lio_github_shogowada_statictags_Attribute([light, dark])
  } else {
    var attributes$1 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
    var style = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$1).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__Lscommons_reactnative_Style__Lio_github_shogowada_statictags_Attribute(light)
  };
  return style
}
function $f_Lscommons_react_navigation_ReactNavigation__themeTextStyle__Lscommons_react_navigation_raw_Theme__Lscommons_reactnative_TextStyle($thiz, theme) {
  return $thiz.Lscommons_react_navigation_package$__f_scommons$react$navigation$ReactNavigation$$themeStyles.getOrElse__O__F0__O(theme, new $c_sjsr_AnonFunction0((function(this$1, theme$1) {
    return (function() {
      var style = (function(superClass$, arg$outer, theme$1$2) {
        return (function() {
          var this$2 = {};
          this$2.color = null;
          var a = $as_T(theme$1$2.colors.text);
          this$2.color = a;
          return this$2
        })
      })(Object, this$1, theme$1)();
      this$1.Lscommons_react_navigation_package$__f_scommons$react$navigation$ReactNavigation$$themeStyles = $as_sci_Map(this$1.Lscommons_react_navigation_package$__f_scommons$react$navigation$ReactNavigation$$themeStyles.updated__O__O__sci_MapOps(theme$1, style));
      return style
    })
  })($thiz, theme)))
}
function $f_Lscommons_react_navigation_ReactNavigation__$init$__V($thiz) {
  $thiz.Lscommons_react_navigation_package$__f_scommons$react$navigation$ReactNavigation$$themeStyles = $m_sci_Map$EmptyMap$()
}
function $p_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes__theme$lzycompute__Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ThemeAttributeSpec($thiz) {
  if (((((1 & $thiz.Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes__f_theme = new $c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ThemeAttributeSpec("theme");
    $thiz.Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes__f_bitmap$0 = (((1 | $thiz.Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes__f_theme
}
function $p_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes__initialRouteName$lzycompute__Lio_github_shogowada_statictags_StringAttributeSpec($thiz) {
  if (((((2 & $thiz.Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes__f_initialRouteName = new $c_Lio_github_shogowada_statictags_StringAttributeSpec("initialRouteName");
    $thiz.Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes__f_bitmap$0 = (((2 | $thiz.Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes__f_initialRouteName
}
function $p_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes__screenOptions$lzycompute__Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenOptionsAttributeSpec($thiz) {
  if (((((4 & $thiz.Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes__f_screenOptions = new $c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenOptionsAttributeSpec("screenOptions");
    $thiz.Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes__f_bitmap$0 = (((4 | $thiz.Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes__f_screenOptions
}
function $p_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes__component$lzycompute__Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenComponentAttributeSpec($thiz) {
  if (((((8 & $thiz.Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes__f_component = new $c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenComponentAttributeSpec("component");
    $thiz.Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes__f_bitmap$0 = (((8 | $thiz.Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes__f_component
}
function $p_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes__options$lzycompute__Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenOptionsAttributeSpec($thiz) {
  if (((((16 & $thiz.Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes__f_options = new $c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenOptionsAttributeSpec("options");
    $thiz.Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes__f_bitmap$0 = (((16 | $thiz.Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes__f_options
}
/** @constructor */
function $c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes(attributes) {
  this.Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes__f_theme = null;
  this.Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes__f_initialRouteName = null;
  this.Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes__f_screenOptions = null;
  this.Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes__f_component = null;
  this.Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes__f_options = null;
  this.Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes__f_initialParams = null;
  this.Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes__f_bitmap$0 = 0
}
$c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes.prototype = new $h_O();
$c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes.prototype.constructor = $c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes;
/** @constructor */
function $h_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes() {
  /*<skip>*/
}
$h_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes.prototype = $c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes.prototype;
$c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes.prototype.theme__Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ThemeAttributeSpec = (function() {
  return (((((1 & this.Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes__theme$lzycompute__Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ThemeAttributeSpec(this) : this.Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes__f_theme)
});
$c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes.prototype.initialRouteName__Lio_github_shogowada_statictags_StringAttributeSpec = (function() {
  return (((((2 & this.Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes__initialRouteName$lzycompute__Lio_github_shogowada_statictags_StringAttributeSpec(this) : this.Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes__f_initialRouteName)
});
$c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes.prototype.screenOptions__Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenOptionsAttributeSpec = (function() {
  return (((((4 & this.Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes__screenOptions$lzycompute__Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenOptionsAttributeSpec(this) : this.Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes__f_screenOptions)
});
$c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes.prototype.component__Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenComponentAttributeSpec = (function() {
  return (((((8 & this.Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes__component$lzycompute__Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenComponentAttributeSpec(this) : this.Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes__f_component)
});
$c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes.prototype.options__Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenOptionsAttributeSpec = (function() {
  return (((((16 & this.Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes__options$lzycompute__Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenOptionsAttributeSpec(this) : this.Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes__f_options)
});
var $d_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes = new $TypeData().initClass({
  Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes: 0
}, false, "scommons.react.navigation.package$NavigatorVirtualDOMAttributes", {
  Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes: 1,
  O: 1
});
$c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes.prototype.$classData = $d_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes;
function $p_Lscommons_react_navigation_package$ReactNavigationVirtualDOMElements__NavigationContainer$lzycompute__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($thiz) {
  if ((!$thiz.Lscommons_react_navigation_package$ReactNavigationVirtualDOMElements__f_bitmap$0)) {
    var reactClass = $m_Lscommons_react_navigation_package$().native__Lscommons_react_navigation_raw_ReactNavigation().NavigationContainer;
    $thiz.Lscommons_react_navigation_package$ReactNavigationVirtualDOMElements__f_NavigationContainer = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass);
    $thiz.Lscommons_react_navigation_package$ReactNavigationVirtualDOMElements__f_bitmap$0 = true
  };
  $thiz.Lscommons_react_navigation_package$ReactNavigationVirtualDOMElements__f_elements = null;
  return $thiz.Lscommons_react_navigation_package$ReactNavigationVirtualDOMElements__f_NavigationContainer
}
/** @constructor */
function $c_Lscommons_react_navigation_package$ReactNavigationVirtualDOMElements(elements) {
  this.Lscommons_react_navigation_package$ReactNavigationVirtualDOMElements__f_NavigationContainer = null;
  this.Lscommons_react_navigation_package$ReactNavigationVirtualDOMElements__f_elements = null;
  this.Lscommons_react_navigation_package$ReactNavigationVirtualDOMElements__f_bitmap$0 = false;
  this.Lscommons_react_navigation_package$ReactNavigationVirtualDOMElements__f_elements = elements
}
$c_Lscommons_react_navigation_package$ReactNavigationVirtualDOMElements.prototype = new $h_O();
$c_Lscommons_react_navigation_package$ReactNavigationVirtualDOMElements.prototype.constructor = $c_Lscommons_react_navigation_package$ReactNavigationVirtualDOMElements;
/** @constructor */
function $h_Lscommons_react_navigation_package$ReactNavigationVirtualDOMElements() {
  /*<skip>*/
}
$h_Lscommons_react_navigation_package$ReactNavigationVirtualDOMElements.prototype = $c_Lscommons_react_navigation_package$ReactNavigationVirtualDOMElements.prototype;
$c_Lscommons_react_navigation_package$ReactNavigationVirtualDOMElements.prototype.NavigationContainer__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec = (function() {
  return ((!this.Lscommons_react_navigation_package$ReactNavigationVirtualDOMElements__f_bitmap$0) ? $p_Lscommons_react_navigation_package$ReactNavigationVirtualDOMElements__NavigationContainer$lzycompute__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec(this) : this.Lscommons_react_navigation_package$ReactNavigationVirtualDOMElements__f_NavigationContainer)
});
var $d_Lscommons_react_navigation_package$ReactNavigationVirtualDOMElements = new $TypeData().initClass({
  Lscommons_react_navigation_package$ReactNavigationVirtualDOMElements: 0
}, false, "scommons.react.navigation.package$ReactNavigationVirtualDOMElements", {
  Lscommons_react_navigation_package$ReactNavigationVirtualDOMElements: 1,
  O: 1
});
$c_Lscommons_react_navigation_package$ReactNavigationVirtualDOMElements.prototype.$classData = $d_Lscommons_react_navigation_package$ReactNavigationVirtualDOMElements;
/** @constructor */
function $c_Lscommons_react_navigation_stack_package$() {
  /*<skip>*/
}
$c_Lscommons_react_navigation_stack_package$.prototype = new $h_O();
$c_Lscommons_react_navigation_stack_package$.prototype.constructor = $c_Lscommons_react_navigation_stack_package$;
/** @constructor */
function $h_Lscommons_react_navigation_stack_package$() {
  /*<skip>*/
}
$h_Lscommons_react_navigation_stack_package$.prototype = $c_Lscommons_react_navigation_stack_package$.prototype;
$c_Lscommons_react_navigation_stack_package$.prototype.createStackNavigator__Lscommons_react_navigation_stack_raw_StackNavigator = (function() {
  return $i_$0040react$002dnavigation$002fstack.createStackNavigator()
});
var $d_Lscommons_react_navigation_stack_package$ = new $TypeData().initClass({
  Lscommons_react_navigation_stack_package$: 0
}, false, "scommons.react.navigation.stack.package$", {
  Lscommons_react_navigation_stack_package$: 1,
  O: 1
});
$c_Lscommons_react_navigation_stack_package$.prototype.$classData = $d_Lscommons_react_navigation_stack_package$;
var $n_Lscommons_react_navigation_stack_package$;
function $m_Lscommons_react_navigation_stack_package$() {
  if ((!$n_Lscommons_react_navigation_stack_package$)) {
    $n_Lscommons_react_navigation_stack_package$ = new $c_Lscommons_react_navigation_stack_package$()
  };
  return $n_Lscommons_react_navigation_stack_package$
}
/** @constructor */
function $c_Lscommons_react_navigation_tab_TabBarOptions$LabelPosition$() {
  this.Lscommons_react_navigation_tab_TabBarOptions$LabelPosition$__f_beside$minusicon = null;
  this.Lscommons_react_navigation_tab_TabBarOptions$LabelPosition$__f_below$minusicon = null;
  this.Lscommons_react_navigation_tab_TabBarOptions$LabelPosition$__f_beside$minusicon = "beside-icon";
  this.Lscommons_react_navigation_tab_TabBarOptions$LabelPosition$__f_below$minusicon = "below-icon"
}
$c_Lscommons_react_navigation_tab_TabBarOptions$LabelPosition$.prototype = new $h_O();
$c_Lscommons_react_navigation_tab_TabBarOptions$LabelPosition$.prototype.constructor = $c_Lscommons_react_navigation_tab_TabBarOptions$LabelPosition$;
/** @constructor */
function $h_Lscommons_react_navigation_tab_TabBarOptions$LabelPosition$() {
  /*<skip>*/
}
$h_Lscommons_react_navigation_tab_TabBarOptions$LabelPosition$.prototype = $c_Lscommons_react_navigation_tab_TabBarOptions$LabelPosition$.prototype;
var $d_Lscommons_react_navigation_tab_TabBarOptions$LabelPosition$ = new $TypeData().initClass({
  Lscommons_react_navigation_tab_TabBarOptions$LabelPosition$: 0
}, false, "scommons.react.navigation.tab.TabBarOptions$LabelPosition$", {
  Lscommons_react_navigation_tab_TabBarOptions$LabelPosition$: 1,
  O: 1
});
$c_Lscommons_react_navigation_tab_TabBarOptions$LabelPosition$.prototype.$classData = $d_Lscommons_react_navigation_tab_TabBarOptions$LabelPosition$;
var $n_Lscommons_react_navigation_tab_TabBarOptions$LabelPosition$;
function $m_Lscommons_react_navigation_tab_TabBarOptions$LabelPosition$() {
  if ((!$n_Lscommons_react_navigation_tab_TabBarOptions$LabelPosition$)) {
    $n_Lscommons_react_navigation_tab_TabBarOptions$LabelPosition$ = new $c_Lscommons_react_navigation_tab_TabBarOptions$LabelPosition$()
  };
  return $n_Lscommons_react_navigation_tab_TabBarOptions$LabelPosition$
}
/** @constructor */
function $c_Lscommons_react_navigation_tab_package$() {
  /*<skip>*/
}
$c_Lscommons_react_navigation_tab_package$.prototype = new $h_O();
$c_Lscommons_react_navigation_tab_package$.prototype.constructor = $c_Lscommons_react_navigation_tab_package$;
/** @constructor */
function $h_Lscommons_react_navigation_tab_package$() {
  /*<skip>*/
}
$h_Lscommons_react_navigation_tab_package$.prototype = $c_Lscommons_react_navigation_tab_package$.prototype;
$c_Lscommons_react_navigation_tab_package$.prototype.createBottomTabNavigator__Lscommons_react_navigation_tab_raw_TabNavigator = (function() {
  return $i_$0040react$002dnavigation$002fbottom$002dtabs.createBottomTabNavigator()
});
var $d_Lscommons_react_navigation_tab_package$ = new $TypeData().initClass({
  Lscommons_react_navigation_tab_package$: 0
}, false, "scommons.react.navigation.tab.package$", {
  Lscommons_react_navigation_tab_package$: 1,
  O: 1
});
$c_Lscommons_react_navigation_tab_package$.prototype.$classData = $d_Lscommons_react_navigation_tab_package$;
var $n_Lscommons_react_navigation_tab_package$;
function $m_Lscommons_react_navigation_tab_package$() {
  if ((!$n_Lscommons_react_navigation_tab_package$)) {
    $n_Lscommons_react_navigation_tab_package$ = new $c_Lscommons_react_navigation_tab_package$()
  };
  return $n_Lscommons_react_navigation_tab_package$
}
function $p_Lscommons_react_package$__$less$lzycompute__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements($thiz) {
  if (((((1 & $thiz.Lscommons_react_package$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lscommons_react_package$__f_$less = $m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
    $thiz.Lscommons_react_package$__f_bitmap$0 = (((1 | $thiz.Lscommons_react_package$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lscommons_react_package$__f_$less
}
function $p_Lscommons_react_package$__$up$lzycompute__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes($thiz) {
  if (((((2 & $thiz.Lscommons_react_package$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lscommons_react_package$__f_$up = $m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
    $thiz.Lscommons_react_package$__f_bitmap$0 = (((2 | $thiz.Lscommons_react_package$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lscommons_react_package$__f_$up
}
/** @constructor */
function $c_Lscommons_react_package$() {
  this.Lscommons_react_package$__f_$less = null;
  this.Lscommons_react_package$__f_$up = null;
  this.Lscommons_react_package$__f_bitmap$0 = 0
}
$c_Lscommons_react_package$.prototype = new $h_O();
$c_Lscommons_react_package$.prototype.constructor = $c_Lscommons_react_package$;
/** @constructor */
function $h_Lscommons_react_package$() {
  /*<skip>*/
}
$h_Lscommons_react_package$.prototype = $c_Lscommons_react_package$.prototype;
$c_Lscommons_react_package$.prototype.$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements = (function() {
  return (((((1 & this.Lscommons_react_package$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lscommons_react_package$__$less$lzycompute__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements(this) : this.Lscommons_react_package$__f_$less)
});
$c_Lscommons_react_package$.prototype.$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes = (function() {
  return (((((2 & this.Lscommons_react_package$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lscommons_react_package$__$up$lzycompute__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes(this) : this.Lscommons_react_package$__f_$up)
});
var $d_Lscommons_react_package$ = new $TypeData().initClass({
  Lscommons_react_package$: 0
}, false, "scommons.react.package$", {
  Lscommons_react_package$: 1,
  O: 1
});
$c_Lscommons_react_package$.prototype.$classData = $d_Lscommons_react_package$;
var $n_Lscommons_react_package$;
function $m_Lscommons_react_package$() {
  if ((!$n_Lscommons_react_package$)) {
    $n_Lscommons_react_package$ = new $c_Lscommons_react_package$()
  };
  return $n_Lscommons_react_package$
}
function $p_Lscommons_react_package$ReactVirtualDOMElements__$greater$lzycompute__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($thiz) {
  if ((!$thiz.Lscommons_react_package$ReactVirtualDOMElements__f_bitmap$0)) {
    var reactClass = $moduleDefault($i_react).Fragment;
    $thiz.Lscommons_react_package$ReactVirtualDOMElements__f_$greater = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass);
    $thiz.Lscommons_react_package$ReactVirtualDOMElements__f_bitmap$0 = true
  };
  $thiz.Lscommons_react_package$ReactVirtualDOMElements__f_elements = null;
  return $thiz.Lscommons_react_package$ReactVirtualDOMElements__f_$greater
}
/** @constructor */
function $c_Lscommons_react_package$ReactVirtualDOMElements(elements) {
  this.Lscommons_react_package$ReactVirtualDOMElements__f_$greater = null;
  this.Lscommons_react_package$ReactVirtualDOMElements__f_elements = null;
  this.Lscommons_react_package$ReactVirtualDOMElements__f_bitmap$0 = false;
  this.Lscommons_react_package$ReactVirtualDOMElements__f_elements = elements
}
$c_Lscommons_react_package$ReactVirtualDOMElements.prototype = new $h_O();
$c_Lscommons_react_package$ReactVirtualDOMElements.prototype.constructor = $c_Lscommons_react_package$ReactVirtualDOMElements;
/** @constructor */
function $h_Lscommons_react_package$ReactVirtualDOMElements() {
  /*<skip>*/
}
$h_Lscommons_react_package$ReactVirtualDOMElements.prototype = $c_Lscommons_react_package$ReactVirtualDOMElements.prototype;
$c_Lscommons_react_package$ReactVirtualDOMElements.prototype.$greater__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec = (function() {
  return ((!this.Lscommons_react_package$ReactVirtualDOMElements__f_bitmap$0) ? $p_Lscommons_react_package$ReactVirtualDOMElements__$greater$lzycompute__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec(this) : this.Lscommons_react_package$ReactVirtualDOMElements__f_$greater)
});
var $d_Lscommons_react_package$ReactVirtualDOMElements = new $TypeData().initClass({
  Lscommons_react_package$ReactVirtualDOMElements: 0
}, false, "scommons.react.package$ReactVirtualDOMElements", {
  Lscommons_react_package$ReactVirtualDOMElements: 1,
  O: 1
});
$c_Lscommons_react_package$ReactVirtualDOMElements.prototype.$classData = $d_Lscommons_react_package$ReactVirtualDOMElements;
function $f_Lscommons_react_redux_BaseStateController__scommons$react$redux$BaseStateController$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz) {
  var $$x1 = $m_Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$().connectAdvanced__F1__Lio_github_shogowada_scalajs_reactjs_redux_ContainerComponentFactory(new $c_sjsr_AnonFunction1((function(this$1) {
    return (function(dispatch$2) {
      var dispatch = $as_F1(dispatch$2);
      return new $c_sjsr_AnonFunction2((function(this$2, dispatch$1) {
        return (function(state$2, props$2) {
          var props = $as_Lio_github_shogowada_scalajs_reactjs_React$Props(props$2);
          return this$2.mapStateToProps__F1__O__Lio_github_shogowada_scalajs_reactjs_React$Props__O(dispatch$1, state$2, props)
        })
      })(this$1, dispatch))
    })
  })($thiz)));
  var this$3 = $thiz.uiComponent__Lscommons_react_UiComponent();
  return $$x1.apply__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass(this$3.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass())
}
function $is_Lscommons_react_redux_task_AbstractTask(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lscommons_react_redux_task_AbstractTask)))
}
function $as_Lscommons_react_redux_task_AbstractTask(obj) {
  return (($is_Lscommons_react_redux_task_AbstractTask(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scommons.react.redux.task.AbstractTask"))
}
function $isArrayOf_Lscommons_react_redux_task_AbstractTask(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscommons_react_redux_task_AbstractTask)))
}
function $asArrayOf_Lscommons_react_redux_task_AbstractTask(obj, depth) {
  return (($isArrayOf_Lscommons_react_redux_task_AbstractTask(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscommons.react.redux.task.AbstractTask;", depth))
}
/** @constructor */
function $c_Lscommons_reactnative_ActivityIndicator$ActivityIndicatorSize$() {
  this.Lscommons_reactnative_ActivityIndicator$ActivityIndicatorSize$__f_small = null;
  this.Lscommons_reactnative_ActivityIndicator$ActivityIndicatorSize$__f_large = null;
  this.Lscommons_reactnative_ActivityIndicator$ActivityIndicatorSize$__f_small = "small";
  this.Lscommons_reactnative_ActivityIndicator$ActivityIndicatorSize$__f_large = "large"
}
$c_Lscommons_reactnative_ActivityIndicator$ActivityIndicatorSize$.prototype = new $h_O();
$c_Lscommons_reactnative_ActivityIndicator$ActivityIndicatorSize$.prototype.constructor = $c_Lscommons_reactnative_ActivityIndicator$ActivityIndicatorSize$;
/** @constructor */
function $h_Lscommons_reactnative_ActivityIndicator$ActivityIndicatorSize$() {
  /*<skip>*/
}
$h_Lscommons_reactnative_ActivityIndicator$ActivityIndicatorSize$.prototype = $c_Lscommons_reactnative_ActivityIndicator$ActivityIndicatorSize$.prototype;
var $d_Lscommons_reactnative_ActivityIndicator$ActivityIndicatorSize$ = new $TypeData().initClass({
  Lscommons_reactnative_ActivityIndicator$ActivityIndicatorSize$: 0
}, false, "scommons.reactnative.ActivityIndicator$ActivityIndicatorSize$", {
  Lscommons_reactnative_ActivityIndicator$ActivityIndicatorSize$: 1,
  O: 1
});
$c_Lscommons_reactnative_ActivityIndicator$ActivityIndicatorSize$.prototype.$classData = $d_Lscommons_reactnative_ActivityIndicator$ActivityIndicatorSize$;
var $n_Lscommons_reactnative_ActivityIndicator$ActivityIndicatorSize$;
function $m_Lscommons_reactnative_ActivityIndicator$ActivityIndicatorSize$() {
  if ((!$n_Lscommons_reactnative_ActivityIndicator$ActivityIndicatorSize$)) {
    $n_Lscommons_reactnative_ActivityIndicator$ActivityIndicatorSize$ = new $c_Lscommons_reactnative_ActivityIndicator$ActivityIndicatorSize$()
  };
  return $n_Lscommons_reactnative_ActivityIndicator$ActivityIndicatorSize$
}
function $p_Lscommons_reactnative_Alert$__defaultOptions$lzycompute__Lscommons_reactnative_raw_AlertOptions($thiz) {
  if ((!$thiz.Lscommons_reactnative_Alert$__f_bitmap$0)) {
    $thiz.Lscommons_reactnative_Alert$__f_defaultOptions = (function(superClass$) {
      return (function() {
        var this$1 = {};
        this$1.cancelable = null;
        this$1.cancelable = false;
        return this$1
      })
    })(Object)();
    $thiz.Lscommons_reactnative_Alert$__f_bitmap$0 = true
  };
  return $thiz.Lscommons_reactnative_Alert$__f_defaultOptions
}
function $p_Lscommons_reactnative_Alert$__defaultOptions__Lscommons_reactnative_raw_AlertOptions($thiz) {
  return ((!$thiz.Lscommons_reactnative_Alert$__f_bitmap$0) ? $p_Lscommons_reactnative_Alert$__defaultOptions$lzycompute__Lscommons_reactnative_raw_AlertOptions($thiz) : $thiz.Lscommons_reactnative_Alert$__f_defaultOptions)
}
/** @constructor */
function $c_Lscommons_reactnative_Alert$() {
  this.Lscommons_reactnative_Alert$__f_defaultOptions = null;
  this.Lscommons_reactnative_Alert$__f_bitmap$0 = false
}
$c_Lscommons_reactnative_Alert$.prototype = new $h_O();
$c_Lscommons_reactnative_Alert$.prototype.constructor = $c_Lscommons_reactnative_Alert$;
/** @constructor */
function $h_Lscommons_reactnative_Alert$() {
  /*<skip>*/
}
$h_Lscommons_reactnative_Alert$.prototype = $c_Lscommons_reactnative_Alert$.prototype;
$c_Lscommons_reactnative_Alert$.prototype.alert__T__T__sci_List__Lscommons_reactnative_raw_AlertOptions__V = (function(title, message, buttons, options) {
  var $$x3 = $i_react$002dnative.Alert;
  var f = (function(this$1) {
    return (function(btn$2) {
      var btn = $as_Lscommons_reactnative_Alert$AlertButton(btn$2);
      return (function(superClass$, btn$1$2) {
        return (function() {
          var this$2 = {};
          this$2.text = null;
          this$2.onPress = null;
          this$2.style = null;
          this$2.text = btn$1$2.Lscommons_reactnative_Alert$AlertButton__f_text;
          this$2.onPress = $m_sjs_js_Any$().fromFunction0__F0__sjs_js_Function0(btn$1$2.Lscommons_reactnative_Alert$AlertButton__f_onPress);
          var x1 = btn$1$2.Lscommons_reactnative_Alert$AlertButton__f_style;
          var x = $m_s_None$();
          if ((x === x1)) {
            var $$x2 = (void 0)
          } else if ((x1 instanceof $c_s_Some)) {
            var x2 = $as_s_Some(x1);
            var v = x2.s_Some__f_value;
            var $$x2 = v
          } else {
            var $$x2;
            throw new $c_s_MatchError(x1)
          };
          this$2.style = $$x2;
          return this$2
        })
      })(Object, btn)()
    })
  })(this);
  if ((buttons === $m_sci_Nil$())) {
    var seq = $m_sci_Nil$()
  } else {
    var arg1 = buttons.head__O();
    var h = new $c_sci_$colon$colon(f(arg1), $m_sci_Nil$());
    var t = h;
    var rest = $as_sci_List(buttons.tail__O());
    while ((rest !== $m_sci_Nil$())) {
      var arg1$1 = rest.head__O();
      var nx = new $c_sci_$colon$colon(f(arg1$1), $m_sci_Nil$());
      t.sci_$colon$colon__f_next = nx;
      t = nx;
      rest = $as_sci_List(rest.tail__O())
    };
    var seq = h
  };
  var $$x1 = $m_sjsr_Compat$().toJSVarArgsImpl__sci_Seq__sjs_js_Array(seq);
  $$x3.alert(title, message, $$x1, options)
});
var $d_Lscommons_reactnative_Alert$ = new $TypeData().initClass({
  Lscommons_reactnative_Alert$: 0
}, false, "scommons.reactnative.Alert$", {
  Lscommons_reactnative_Alert$: 1,
  O: 1
});
$c_Lscommons_reactnative_Alert$.prototype.$classData = $d_Lscommons_reactnative_Alert$;
var $n_Lscommons_reactnative_Alert$;
function $m_Lscommons_reactnative_Alert$() {
  if ((!$n_Lscommons_reactnative_Alert$)) {
    $n_Lscommons_reactnative_Alert$ = new $c_Lscommons_reactnative_Alert$()
  };
  return $n_Lscommons_reactnative_Alert$
}
/** @constructor */
function $c_Lscommons_reactnative_Alert$AlertButtonStyle$() {
  this.Lscommons_reactnative_Alert$AlertButtonStyle$__f_default = null;
  this.Lscommons_reactnative_Alert$AlertButtonStyle$__f_cancel = null;
  this.Lscommons_reactnative_Alert$AlertButtonStyle$__f_destructive = null;
  this.Lscommons_reactnative_Alert$AlertButtonStyle$__f_default = "default";
  this.Lscommons_reactnative_Alert$AlertButtonStyle$__f_cancel = "cancel";
  this.Lscommons_reactnative_Alert$AlertButtonStyle$__f_destructive = "destructive"
}
$c_Lscommons_reactnative_Alert$AlertButtonStyle$.prototype = new $h_O();
$c_Lscommons_reactnative_Alert$AlertButtonStyle$.prototype.constructor = $c_Lscommons_reactnative_Alert$AlertButtonStyle$;
/** @constructor */
function $h_Lscommons_reactnative_Alert$AlertButtonStyle$() {
  /*<skip>*/
}
$h_Lscommons_reactnative_Alert$AlertButtonStyle$.prototype = $c_Lscommons_reactnative_Alert$AlertButtonStyle$.prototype;
var $d_Lscommons_reactnative_Alert$AlertButtonStyle$ = new $TypeData().initClass({
  Lscommons_reactnative_Alert$AlertButtonStyle$: 0
}, false, "scommons.reactnative.Alert$AlertButtonStyle$", {
  Lscommons_reactnative_Alert$AlertButtonStyle$: 1,
  O: 1
});
$c_Lscommons_reactnative_Alert$AlertButtonStyle$.prototype.$classData = $d_Lscommons_reactnative_Alert$AlertButtonStyle$;
var $n_Lscommons_reactnative_Alert$AlertButtonStyle$;
function $m_Lscommons_reactnative_Alert$AlertButtonStyle$() {
  if ((!$n_Lscommons_reactnative_Alert$AlertButtonStyle$)) {
    $n_Lscommons_reactnative_Alert$AlertButtonStyle$ = new $c_Lscommons_reactnative_Alert$AlertButtonStyle$()
  };
  return $n_Lscommons_reactnative_Alert$AlertButtonStyle$
}
/** @constructor */
function $c_Lscommons_reactnative_IOSTextStyle$TextDecorationStyle$() {
  this.Lscommons_reactnative_IOSTextStyle$TextDecorationStyle$__f_solid = null;
  this.Lscommons_reactnative_IOSTextStyle$TextDecorationStyle$__f_double = null;
  this.Lscommons_reactnative_IOSTextStyle$TextDecorationStyle$__f_dotted = null;
  this.Lscommons_reactnative_IOSTextStyle$TextDecorationStyle$__f_dashed = null;
  this.Lscommons_reactnative_IOSTextStyle$TextDecorationStyle$__f_solid = "solid";
  this.Lscommons_reactnative_IOSTextStyle$TextDecorationStyle$__f_double = "double";
  this.Lscommons_reactnative_IOSTextStyle$TextDecorationStyle$__f_dotted = "dotted";
  this.Lscommons_reactnative_IOSTextStyle$TextDecorationStyle$__f_dashed = "dashed"
}
$c_Lscommons_reactnative_IOSTextStyle$TextDecorationStyle$.prototype = new $h_O();
$c_Lscommons_reactnative_IOSTextStyle$TextDecorationStyle$.prototype.constructor = $c_Lscommons_reactnative_IOSTextStyle$TextDecorationStyle$;
/** @constructor */
function $h_Lscommons_reactnative_IOSTextStyle$TextDecorationStyle$() {
  /*<skip>*/
}
$h_Lscommons_reactnative_IOSTextStyle$TextDecorationStyle$.prototype = $c_Lscommons_reactnative_IOSTextStyle$TextDecorationStyle$.prototype;
var $d_Lscommons_reactnative_IOSTextStyle$TextDecorationStyle$ = new $TypeData().initClass({
  Lscommons_reactnative_IOSTextStyle$TextDecorationStyle$: 0
}, false, "scommons.reactnative.IOSTextStyle$TextDecorationStyle$", {
  Lscommons_reactnative_IOSTextStyle$TextDecorationStyle$: 1,
  O: 1
});
$c_Lscommons_reactnative_IOSTextStyle$TextDecorationStyle$.prototype.$classData = $d_Lscommons_reactnative_IOSTextStyle$TextDecorationStyle$;
var $n_Lscommons_reactnative_IOSTextStyle$TextDecorationStyle$;
function $m_Lscommons_reactnative_IOSTextStyle$TextDecorationStyle$() {
  if ((!$n_Lscommons_reactnative_IOSTextStyle$TextDecorationStyle$)) {
    $n_Lscommons_reactnative_IOSTextStyle$TextDecorationStyle$ = new $c_Lscommons_reactnative_IOSTextStyle$TextDecorationStyle$()
  };
  return $n_Lscommons_reactnative_IOSTextStyle$TextDecorationStyle$
}
/** @constructor */
function $c_Lscommons_reactnative_Modal$AnimationType$() {
  this.Lscommons_reactnative_Modal$AnimationType$__f_none = null;
  this.Lscommons_reactnative_Modal$AnimationType$__f_slide = null;
  this.Lscommons_reactnative_Modal$AnimationType$__f_fade = null;
  this.Lscommons_reactnative_Modal$AnimationType$__f_none = "none";
  this.Lscommons_reactnative_Modal$AnimationType$__f_slide = "slide";
  this.Lscommons_reactnative_Modal$AnimationType$__f_fade = "fade"
}
$c_Lscommons_reactnative_Modal$AnimationType$.prototype = new $h_O();
$c_Lscommons_reactnative_Modal$AnimationType$.prototype.constructor = $c_Lscommons_reactnative_Modal$AnimationType$;
/** @constructor */
function $h_Lscommons_reactnative_Modal$AnimationType$() {
  /*<skip>*/
}
$h_Lscommons_reactnative_Modal$AnimationType$.prototype = $c_Lscommons_reactnative_Modal$AnimationType$.prototype;
var $d_Lscommons_reactnative_Modal$AnimationType$ = new $TypeData().initClass({
  Lscommons_reactnative_Modal$AnimationType$: 0
}, false, "scommons.reactnative.Modal$AnimationType$", {
  Lscommons_reactnative_Modal$AnimationType$: 1,
  O: 1
});
$c_Lscommons_reactnative_Modal$AnimationType$.prototype.$classData = $d_Lscommons_reactnative_Modal$AnimationType$;
var $n_Lscommons_reactnative_Modal$AnimationType$;
function $m_Lscommons_reactnative_Modal$AnimationType$() {
  if ((!$n_Lscommons_reactnative_Modal$AnimationType$)) {
    $n_Lscommons_reactnative_Modal$AnimationType$ = new $c_Lscommons_reactnative_Modal$AnimationType$()
  };
  return $n_Lscommons_reactnative_Modal$AnimationType$
}
function $is_Lscommons_reactnative_Platform(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lscommons_reactnative_Platform)))
}
function $as_Lscommons_reactnative_Platform(obj) {
  return (($is_Lscommons_reactnative_Platform(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scommons.reactnative.Platform"))
}
function $isArrayOf_Lscommons_reactnative_Platform(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscommons_reactnative_Platform)))
}
function $asArrayOf_Lscommons_reactnative_Platform(obj, depth) {
  return (($isArrayOf_Lscommons_reactnative_Platform(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscommons.reactnative.Platform;", depth))
}
/** @constructor */
function $c_Lscommons_reactnative_Platform$() {
  /*<skip>*/
}
$c_Lscommons_reactnative_Platform$.prototype = new $h_O();
$c_Lscommons_reactnative_Platform$.prototype.constructor = $c_Lscommons_reactnative_Platform$;
/** @constructor */
function $h_Lscommons_reactnative_Platform$() {
  /*<skip>*/
}
$h_Lscommons_reactnative_Platform$.prototype = $c_Lscommons_reactnative_Platform$.prototype;
$c_Lscommons_reactnative_Platform$.prototype.OS__Lscommons_reactnative_Platform = (function() {
  var x1 = $as_T($i_react$002dnative.Platform.OS);
  if ((x1 === "ios")) {
    return $m_Lscommons_reactnative_Platform$ios$()
  } else if ((x1 === "android")) {
    return $m_Lscommons_reactnative_Platform$android$()
  } else if ((x1 === "web")) {
    return $m_Lscommons_reactnative_Platform$web$()
  } else {
    throw new $c_s_MatchError(x1)
  }
});
$c_Lscommons_reactnative_Platform$.prototype.select__F1__O = (function(f) {
  return f.apply__O__O(this.OS__Lscommons_reactnative_Platform())
});
var $d_Lscommons_reactnative_Platform$ = new $TypeData().initClass({
  Lscommons_reactnative_Platform$: 0
}, false, "scommons.reactnative.Platform$", {
  Lscommons_reactnative_Platform$: 1,
  O: 1
});
$c_Lscommons_reactnative_Platform$.prototype.$classData = $d_Lscommons_reactnative_Platform$;
var $n_Lscommons_reactnative_Platform$;
function $m_Lscommons_reactnative_Platform$() {
  if ((!$n_Lscommons_reactnative_Platform$)) {
    $n_Lscommons_reactnative_Platform$ = new $c_Lscommons_reactnative_Platform$()
  };
  return $n_Lscommons_reactnative_Platform$
}
/** @constructor */
function $c_Lscommons_reactnative_ScrollView$KeyboardShouldPersistTaps$() {
  this.Lscommons_reactnative_ScrollView$KeyboardShouldPersistTaps$__f_never = null;
  this.Lscommons_reactnative_ScrollView$KeyboardShouldPersistTaps$__f_always = null;
  this.Lscommons_reactnative_ScrollView$KeyboardShouldPersistTaps$__f_handled = null;
  this.Lscommons_reactnative_ScrollView$KeyboardShouldPersistTaps$__f_never = "never";
  this.Lscommons_reactnative_ScrollView$KeyboardShouldPersistTaps$__f_always = "always";
  this.Lscommons_reactnative_ScrollView$KeyboardShouldPersistTaps$__f_handled = "handled"
}
$c_Lscommons_reactnative_ScrollView$KeyboardShouldPersistTaps$.prototype = new $h_O();
$c_Lscommons_reactnative_ScrollView$KeyboardShouldPersistTaps$.prototype.constructor = $c_Lscommons_reactnative_ScrollView$KeyboardShouldPersistTaps$;
/** @constructor */
function $h_Lscommons_reactnative_ScrollView$KeyboardShouldPersistTaps$() {
  /*<skip>*/
}
$h_Lscommons_reactnative_ScrollView$KeyboardShouldPersistTaps$.prototype = $c_Lscommons_reactnative_ScrollView$KeyboardShouldPersistTaps$.prototype;
var $d_Lscommons_reactnative_ScrollView$KeyboardShouldPersistTaps$ = new $TypeData().initClass({
  Lscommons_reactnative_ScrollView$KeyboardShouldPersistTaps$: 0
}, false, "scommons.reactnative.ScrollView$KeyboardShouldPersistTaps$", {
  Lscommons_reactnative_ScrollView$KeyboardShouldPersistTaps$: 1,
  O: 1
});
$c_Lscommons_reactnative_ScrollView$KeyboardShouldPersistTaps$.prototype.$classData = $d_Lscommons_reactnative_ScrollView$KeyboardShouldPersistTaps$;
var $n_Lscommons_reactnative_ScrollView$KeyboardShouldPersistTaps$;
function $m_Lscommons_reactnative_ScrollView$KeyboardShouldPersistTaps$() {
  if ((!$n_Lscommons_reactnative_ScrollView$KeyboardShouldPersistTaps$)) {
    $n_Lscommons_reactnative_ScrollView$KeyboardShouldPersistTaps$ = new $c_Lscommons_reactnative_ScrollView$KeyboardShouldPersistTaps$()
  };
  return $n_Lscommons_reactnative_ScrollView$KeyboardShouldPersistTaps$
}
/** @constructor */
function $c_Lscommons_reactnative_StatusBar$BarStyle$() {
  this.Lscommons_reactnative_StatusBar$BarStyle$__f_default = null;
  this.Lscommons_reactnative_StatusBar$BarStyle$__f_light$minuscontent = null;
  this.Lscommons_reactnative_StatusBar$BarStyle$__f_dark$minuscontent = null;
  this.Lscommons_reactnative_StatusBar$BarStyle$__f_default = "default";
  this.Lscommons_reactnative_StatusBar$BarStyle$__f_light$minuscontent = "light-content";
  this.Lscommons_reactnative_StatusBar$BarStyle$__f_dark$minuscontent = "dark-content"
}
$c_Lscommons_reactnative_StatusBar$BarStyle$.prototype = new $h_O();
$c_Lscommons_reactnative_StatusBar$BarStyle$.prototype.constructor = $c_Lscommons_reactnative_StatusBar$BarStyle$;
/** @constructor */
function $h_Lscommons_reactnative_StatusBar$BarStyle$() {
  /*<skip>*/
}
$h_Lscommons_reactnative_StatusBar$BarStyle$.prototype = $c_Lscommons_reactnative_StatusBar$BarStyle$.prototype;
var $d_Lscommons_reactnative_StatusBar$BarStyle$ = new $TypeData().initClass({
  Lscommons_reactnative_StatusBar$BarStyle$: 0
}, false, "scommons.reactnative.StatusBar$BarStyle$", {
  Lscommons_reactnative_StatusBar$BarStyle$: 1,
  O: 1
});
$c_Lscommons_reactnative_StatusBar$BarStyle$.prototype.$classData = $d_Lscommons_reactnative_StatusBar$BarStyle$;
var $n_Lscommons_reactnative_StatusBar$BarStyle$;
function $m_Lscommons_reactnative_StatusBar$BarStyle$() {
  if ((!$n_Lscommons_reactnative_StatusBar$BarStyle$)) {
    $n_Lscommons_reactnative_StatusBar$BarStyle$ = new $c_Lscommons_reactnative_StatusBar$BarStyle$()
  };
  return $n_Lscommons_reactnative_StatusBar$BarStyle$
}
/** @constructor */
function $c_Lscommons_reactnative_Style$BorderStyle$() {
  this.Lscommons_reactnative_Style$BorderStyle$__f_solid = null;
  this.Lscommons_reactnative_Style$BorderStyle$__f_dotted = null;
  this.Lscommons_reactnative_Style$BorderStyle$__f_dashed = null;
  this.Lscommons_reactnative_Style$BorderStyle$__f_solid = "solid";
  this.Lscommons_reactnative_Style$BorderStyle$__f_dotted = "dotted";
  this.Lscommons_reactnative_Style$BorderStyle$__f_dashed = "dashed"
}
$c_Lscommons_reactnative_Style$BorderStyle$.prototype = new $h_O();
$c_Lscommons_reactnative_Style$BorderStyle$.prototype.constructor = $c_Lscommons_reactnative_Style$BorderStyle$;
/** @constructor */
function $h_Lscommons_reactnative_Style$BorderStyle$() {
  /*<skip>*/
}
$h_Lscommons_reactnative_Style$BorderStyle$.prototype = $c_Lscommons_reactnative_Style$BorderStyle$.prototype;
$c_Lscommons_reactnative_Style$BorderStyle$.prototype.solid__Lscommons_reactnative_Style$BorderStyle = (function() {
  return this.Lscommons_reactnative_Style$BorderStyle$__f_solid
});
var $d_Lscommons_reactnative_Style$BorderStyle$ = new $TypeData().initClass({
  Lscommons_reactnative_Style$BorderStyle$: 0
}, false, "scommons.reactnative.Style$BorderStyle$", {
  Lscommons_reactnative_Style$BorderStyle$: 1,
  O: 1
});
$c_Lscommons_reactnative_Style$BorderStyle$.prototype.$classData = $d_Lscommons_reactnative_Style$BorderStyle$;
var $n_Lscommons_reactnative_Style$BorderStyle$;
function $m_Lscommons_reactnative_Style$BorderStyle$() {
  if ((!$n_Lscommons_reactnative_Style$BorderStyle$)) {
    $n_Lscommons_reactnative_Style$BorderStyle$ = new $c_Lscommons_reactnative_Style$BorderStyle$()
  };
  return $n_Lscommons_reactnative_Style$BorderStyle$
}
/** @constructor */
function $c_Lscommons_reactnative_Style$Color$() {
  this.Lscommons_reactnative_Style$Color$__f_transparent = null;
  this.Lscommons_reactnative_Style$Color$__f_aliceblue = null;
  this.Lscommons_reactnative_Style$Color$__f_antiquewhite = null;
  this.Lscommons_reactnative_Style$Color$__f_aqua = null;
  this.Lscommons_reactnative_Style$Color$__f_aquamarine = null;
  this.Lscommons_reactnative_Style$Color$__f_azure = null;
  this.Lscommons_reactnative_Style$Color$__f_beige = null;
  this.Lscommons_reactnative_Style$Color$__f_bisque = null;
  this.Lscommons_reactnative_Style$Color$__f_black = null;
  this.Lscommons_reactnative_Style$Color$__f_blanchedalmond = null;
  this.Lscommons_reactnative_Style$Color$__f_blue = null;
  this.Lscommons_reactnative_Style$Color$__f_blueviolet = null;
  this.Lscommons_reactnative_Style$Color$__f_brown = null;
  this.Lscommons_reactnative_Style$Color$__f_burlywood = null;
  this.Lscommons_reactnative_Style$Color$__f_cadetblue = null;
  this.Lscommons_reactnative_Style$Color$__f_chartreuse = null;
  this.Lscommons_reactnative_Style$Color$__f_chocolate = null;
  this.Lscommons_reactnative_Style$Color$__f_coral = null;
  this.Lscommons_reactnative_Style$Color$__f_cornflowerblue = null;
  this.Lscommons_reactnative_Style$Color$__f_cornsilk = null;
  this.Lscommons_reactnative_Style$Color$__f_crimson = null;
  this.Lscommons_reactnative_Style$Color$__f_cyan = null;
  this.Lscommons_reactnative_Style$Color$__f_darkblue = null;
  this.Lscommons_reactnative_Style$Color$__f_darkcyan = null;
  this.Lscommons_reactnative_Style$Color$__f_darkgoldenrod = null;
  this.Lscommons_reactnative_Style$Color$__f_darkgray = null;
  this.Lscommons_reactnative_Style$Color$__f_darkgreen = null;
  this.Lscommons_reactnative_Style$Color$__f_darkgrey = null;
  this.Lscommons_reactnative_Style$Color$__f_darkkhaki = null;
  this.Lscommons_reactnative_Style$Color$__f_darkmagenta = null;
  this.Lscommons_reactnative_Style$Color$__f_darkolivegreen = null;
  this.Lscommons_reactnative_Style$Color$__f_darkorange = null;
  this.Lscommons_reactnative_Style$Color$__f_darkorchid = null;
  this.Lscommons_reactnative_Style$Color$__f_darkred = null;
  this.Lscommons_reactnative_Style$Color$__f_darksalmon = null;
  this.Lscommons_reactnative_Style$Color$__f_darkseagreen = null;
  this.Lscommons_reactnative_Style$Color$__f_darkslateblue = null;
  this.Lscommons_reactnative_Style$Color$__f_darkslategrey = null;
  this.Lscommons_reactnative_Style$Color$__f_darkturquoise = null;
  this.Lscommons_reactnative_Style$Color$__f_darkviolet = null;
  this.Lscommons_reactnative_Style$Color$__f_deeppink = null;
  this.Lscommons_reactnative_Style$Color$__f_deepskyblue = null;
  this.Lscommons_reactnative_Style$Color$__f_dimgray = null;
  this.Lscommons_reactnative_Style$Color$__f_dimgrey = null;
  this.Lscommons_reactnative_Style$Color$__f_dodgerblue = null;
  this.Lscommons_reactnative_Style$Color$__f_firebrick = null;
  this.Lscommons_reactnative_Style$Color$__f_floralwhite = null;
  this.Lscommons_reactnative_Style$Color$__f_forestgreen = null;
  this.Lscommons_reactnative_Style$Color$__f_fuchsia = null;
  this.Lscommons_reactnative_Style$Color$__f_gainsboro = null;
  this.Lscommons_reactnative_Style$Color$__f_ghostwhite = null;
  this.Lscommons_reactnative_Style$Color$__f_gold = null;
  this.Lscommons_reactnative_Style$Color$__f_goldenrod = null;
  this.Lscommons_reactnative_Style$Color$__f_gray = null;
  this.Lscommons_reactnative_Style$Color$__f_green = null;
  this.Lscommons_reactnative_Style$Color$__f_greenyellow = null;
  this.Lscommons_reactnative_Style$Color$__f_grey = null;
  this.Lscommons_reactnative_Style$Color$__f_honeydew = null;
  this.Lscommons_reactnative_Style$Color$__f_hotpink = null;
  this.Lscommons_reactnative_Style$Color$__f_indianred = null;
  this.Lscommons_reactnative_Style$Color$__f_indigo = null;
  this.Lscommons_reactnative_Style$Color$__f_ivory = null;
  this.Lscommons_reactnative_Style$Color$__f_khaki = null;
  this.Lscommons_reactnative_Style$Color$__f_lavender = null;
  this.Lscommons_reactnative_Style$Color$__f_lavenderblush = null;
  this.Lscommons_reactnative_Style$Color$__f_lawngreen = null;
  this.Lscommons_reactnative_Style$Color$__f_lemonchiffon = null;
  this.Lscommons_reactnative_Style$Color$__f_lightblue = null;
  this.Lscommons_reactnative_Style$Color$__f_lightcoral = null;
  this.Lscommons_reactnative_Style$Color$__f_lightcyan = null;
  this.Lscommons_reactnative_Style$Color$__f_lightgoldenrodyellow = null;
  this.Lscommons_reactnative_Style$Color$__f_lightgray = null;
  this.Lscommons_reactnative_Style$Color$__f_lightgreen = null;
  this.Lscommons_reactnative_Style$Color$__f_lightgrey = null;
  this.Lscommons_reactnative_Style$Color$__f_lightpink = null;
  this.Lscommons_reactnative_Style$Color$__f_lightsalmon = null;
  this.Lscommons_reactnative_Style$Color$__f_lightseagreen = null;
  this.Lscommons_reactnative_Style$Color$__f_lightskyblue = null;
  this.Lscommons_reactnative_Style$Color$__f_lightslategrey = null;
  this.Lscommons_reactnative_Style$Color$__f_lightsteelblue = null;
  this.Lscommons_reactnative_Style$Color$__f_lightyellow = null;
  this.Lscommons_reactnative_Style$Color$__f_lime = null;
  this.Lscommons_reactnative_Style$Color$__f_limegreen = null;
  this.Lscommons_reactnative_Style$Color$__f_linen = null;
  this.Lscommons_reactnative_Style$Color$__f_magenta = null;
  this.Lscommons_reactnative_Style$Color$__f_maroon = null;
  this.Lscommons_reactnative_Style$Color$__f_mediumaquamarine = null;
  this.Lscommons_reactnative_Style$Color$__f_mediumblue = null;
  this.Lscommons_reactnative_Style$Color$__f_mediumorchid = null;
  this.Lscommons_reactnative_Style$Color$__f_mediumpurple = null;
  this.Lscommons_reactnative_Style$Color$__f_mediumseagreen = null;
  this.Lscommons_reactnative_Style$Color$__f_mediumslateblue = null;
  this.Lscommons_reactnative_Style$Color$__f_mediumspringgreen = null;
  this.Lscommons_reactnative_Style$Color$__f_mediumturquoise = null;
  this.Lscommons_reactnative_Style$Color$__f_mediumvioletred = null;
  this.Lscommons_reactnative_Style$Color$__f_midnightblue = null;
  this.Lscommons_reactnative_Style$Color$__f_mintcream = null;
  this.Lscommons_reactnative_Style$Color$__f_mistyrose = null;
  this.Lscommons_reactnative_Style$Color$__f_moccasin = null;
  this.Lscommons_reactnative_Style$Color$__f_navajowhite = null;
  this.Lscommons_reactnative_Style$Color$__f_navy = null;
  this.Lscommons_reactnative_Style$Color$__f_oldlace = null;
  this.Lscommons_reactnative_Style$Color$__f_olive = null;
  this.Lscommons_reactnative_Style$Color$__f_olivedrab = null;
  this.Lscommons_reactnative_Style$Color$__f_orange = null;
  this.Lscommons_reactnative_Style$Color$__f_orangered = null;
  this.Lscommons_reactnative_Style$Color$__f_orchid = null;
  this.Lscommons_reactnative_Style$Color$__f_palegoldenrod = null;
  this.Lscommons_reactnative_Style$Color$__f_palegreen = null;
  this.Lscommons_reactnative_Style$Color$__f_paleturquoise = null;
  this.Lscommons_reactnative_Style$Color$__f_palevioletred = null;
  this.Lscommons_reactnative_Style$Color$__f_papayawhip = null;
  this.Lscommons_reactnative_Style$Color$__f_peachpuff = null;
  this.Lscommons_reactnative_Style$Color$__f_peru = null;
  this.Lscommons_reactnative_Style$Color$__f_pink = null;
  this.Lscommons_reactnative_Style$Color$__f_plum = null;
  this.Lscommons_reactnative_Style$Color$__f_powderblue = null;
  this.Lscommons_reactnative_Style$Color$__f_purple = null;
  this.Lscommons_reactnative_Style$Color$__f_rebeccapurple = null;
  this.Lscommons_reactnative_Style$Color$__f_red = null;
  this.Lscommons_reactnative_Style$Color$__f_rosybrown = null;
  this.Lscommons_reactnative_Style$Color$__f_royalblue = null;
  this.Lscommons_reactnative_Style$Color$__f_saddlebrown = null;
  this.Lscommons_reactnative_Style$Color$__f_salmon = null;
  this.Lscommons_reactnative_Style$Color$__f_sandybrown = null;
  this.Lscommons_reactnative_Style$Color$__f_seagreen = null;
  this.Lscommons_reactnative_Style$Color$__f_seashell = null;
  this.Lscommons_reactnative_Style$Color$__f_sienna = null;
  this.Lscommons_reactnative_Style$Color$__f_silver = null;
  this.Lscommons_reactnative_Style$Color$__f_skyblue = null;
  this.Lscommons_reactnative_Style$Color$__f_slateblue = null;
  this.Lscommons_reactnative_Style$Color$__f_slategray = null;
  this.Lscommons_reactnative_Style$Color$__f_snow = null;
  this.Lscommons_reactnative_Style$Color$__f_springgreen = null;
  this.Lscommons_reactnative_Style$Color$__f_steelblue = null;
  this.Lscommons_reactnative_Style$Color$__f_tan = null;
  this.Lscommons_reactnative_Style$Color$__f_teal = null;
  this.Lscommons_reactnative_Style$Color$__f_thistle = null;
  this.Lscommons_reactnative_Style$Color$__f_tomato = null;
  this.Lscommons_reactnative_Style$Color$__f_turquoise = null;
  this.Lscommons_reactnative_Style$Color$__f_violet = null;
  this.Lscommons_reactnative_Style$Color$__f_wheat = null;
  this.Lscommons_reactnative_Style$Color$__f_white = null;
  this.Lscommons_reactnative_Style$Color$__f_whitesmoke = null;
  this.Lscommons_reactnative_Style$Color$__f_yellow = null;
  this.Lscommons_reactnative_Style$Color$__f_yellowgreen = null;
  this.Lscommons_reactnative_Style$Color$__f_transparent = "transparent";
  this.Lscommons_reactnative_Style$Color$__f_aliceblue = "aliceblue";
  this.Lscommons_reactnative_Style$Color$__f_antiquewhite = "antiquewhite";
  this.Lscommons_reactnative_Style$Color$__f_aqua = "aqua";
  this.Lscommons_reactnative_Style$Color$__f_aquamarine = "aquamarine";
  this.Lscommons_reactnative_Style$Color$__f_azure = "azure";
  this.Lscommons_reactnative_Style$Color$__f_beige = "beige";
  this.Lscommons_reactnative_Style$Color$__f_bisque = "bisque";
  this.Lscommons_reactnative_Style$Color$__f_black = "black";
  this.Lscommons_reactnative_Style$Color$__f_blanchedalmond = "blanchedalmond";
  this.Lscommons_reactnative_Style$Color$__f_blue = "blue";
  this.Lscommons_reactnative_Style$Color$__f_blueviolet = "blueviolet";
  this.Lscommons_reactnative_Style$Color$__f_brown = "brown";
  this.Lscommons_reactnative_Style$Color$__f_burlywood = "burlywood";
  this.Lscommons_reactnative_Style$Color$__f_cadetblue = "cadetblue";
  this.Lscommons_reactnative_Style$Color$__f_chartreuse = "chartreuse";
  this.Lscommons_reactnative_Style$Color$__f_chocolate = "chocolate";
  this.Lscommons_reactnative_Style$Color$__f_coral = "coral";
  this.Lscommons_reactnative_Style$Color$__f_cornflowerblue = "cornflowerblue";
  this.Lscommons_reactnative_Style$Color$__f_cornsilk = "cornsilk";
  this.Lscommons_reactnative_Style$Color$__f_crimson = "crimson";
  this.Lscommons_reactnative_Style$Color$__f_cyan = "cyan";
  this.Lscommons_reactnative_Style$Color$__f_darkblue = "darkblue";
  this.Lscommons_reactnative_Style$Color$__f_darkcyan = "darkcyan";
  this.Lscommons_reactnative_Style$Color$__f_darkgoldenrod = "darkgoldenrod";
  this.Lscommons_reactnative_Style$Color$__f_darkgray = "darkgray";
  this.Lscommons_reactnative_Style$Color$__f_darkgreen = "darkgreen";
  this.Lscommons_reactnative_Style$Color$__f_darkgrey = "darkgrey";
  this.Lscommons_reactnative_Style$Color$__f_darkkhaki = "darkkhaki";
  this.Lscommons_reactnative_Style$Color$__f_darkmagenta = "darkmagenta";
  this.Lscommons_reactnative_Style$Color$__f_darkolivegreen = "darkolivegreen";
  this.Lscommons_reactnative_Style$Color$__f_darkorange = "darkorange";
  this.Lscommons_reactnative_Style$Color$__f_darkorchid = "darkorchid";
  this.Lscommons_reactnative_Style$Color$__f_darkred = "darkred";
  this.Lscommons_reactnative_Style$Color$__f_darksalmon = "darksalmon";
  this.Lscommons_reactnative_Style$Color$__f_darkseagreen = "darkseagreen";
  this.Lscommons_reactnative_Style$Color$__f_darkslateblue = "darkslateblue";
  this.Lscommons_reactnative_Style$Color$__f_darkslategrey = "darkslategrey";
  this.Lscommons_reactnative_Style$Color$__f_darkturquoise = "darkturquoise";
  this.Lscommons_reactnative_Style$Color$__f_darkviolet = "darkviolet";
  this.Lscommons_reactnative_Style$Color$__f_deeppink = "deeppink";
  this.Lscommons_reactnative_Style$Color$__f_deepskyblue = "deepskyblue";
  this.Lscommons_reactnative_Style$Color$__f_dimgray = "dimgray";
  this.Lscommons_reactnative_Style$Color$__f_dimgrey = "dimgrey";
  this.Lscommons_reactnative_Style$Color$__f_dodgerblue = "dodgerblue";
  this.Lscommons_reactnative_Style$Color$__f_firebrick = "firebrick";
  this.Lscommons_reactnative_Style$Color$__f_floralwhite = "floralwhite";
  this.Lscommons_reactnative_Style$Color$__f_forestgreen = "forestgreen";
  this.Lscommons_reactnative_Style$Color$__f_fuchsia = "fuchsia";
  this.Lscommons_reactnative_Style$Color$__f_gainsboro = "gainsboro";
  this.Lscommons_reactnative_Style$Color$__f_ghostwhite = "ghostwhite";
  this.Lscommons_reactnative_Style$Color$__f_gold = "gold";
  this.Lscommons_reactnative_Style$Color$__f_goldenrod = "goldenrod";
  this.Lscommons_reactnative_Style$Color$__f_gray = "gray";
  this.Lscommons_reactnative_Style$Color$__f_green = "green";
  this.Lscommons_reactnative_Style$Color$__f_greenyellow = "greenyellow";
  this.Lscommons_reactnative_Style$Color$__f_grey = "grey";
  this.Lscommons_reactnative_Style$Color$__f_honeydew = "honeydew";
  this.Lscommons_reactnative_Style$Color$__f_hotpink = "hotpink";
  this.Lscommons_reactnative_Style$Color$__f_indianred = "indianred";
  this.Lscommons_reactnative_Style$Color$__f_indigo = "indigo";
  this.Lscommons_reactnative_Style$Color$__f_ivory = "ivory";
  this.Lscommons_reactnative_Style$Color$__f_khaki = "khaki";
  this.Lscommons_reactnative_Style$Color$__f_lavender = "lavender";
  this.Lscommons_reactnative_Style$Color$__f_lavenderblush = "lavenderblush";
  this.Lscommons_reactnative_Style$Color$__f_lawngreen = "lawngreen";
  this.Lscommons_reactnative_Style$Color$__f_lemonchiffon = "lemonchiffon";
  this.Lscommons_reactnative_Style$Color$__f_lightblue = "lightblue";
  this.Lscommons_reactnative_Style$Color$__f_lightcoral = "lightcoral";
  this.Lscommons_reactnative_Style$Color$__f_lightcyan = "lightcyan";
  this.Lscommons_reactnative_Style$Color$__f_lightgoldenrodyellow = "lightgoldenrodyellow";
  this.Lscommons_reactnative_Style$Color$__f_lightgray = "lightgray";
  this.Lscommons_reactnative_Style$Color$__f_lightgreen = "lightgreen";
  this.Lscommons_reactnative_Style$Color$__f_lightgrey = "lightgrey";
  this.Lscommons_reactnative_Style$Color$__f_lightpink = "lightpink";
  this.Lscommons_reactnative_Style$Color$__f_lightsalmon = "lightsalmon";
  this.Lscommons_reactnative_Style$Color$__f_lightseagreen = "lightseagreen";
  this.Lscommons_reactnative_Style$Color$__f_lightskyblue = "lightskyblue";
  this.Lscommons_reactnative_Style$Color$__f_lightslategrey = "lightslategrey";
  this.Lscommons_reactnative_Style$Color$__f_lightsteelblue = "lightsteelblue";
  this.Lscommons_reactnative_Style$Color$__f_lightyellow = "lightyellow";
  this.Lscommons_reactnative_Style$Color$__f_lime = "lime";
  this.Lscommons_reactnative_Style$Color$__f_limegreen = "limegreen";
  this.Lscommons_reactnative_Style$Color$__f_linen = "linen";
  this.Lscommons_reactnative_Style$Color$__f_magenta = "magenta";
  this.Lscommons_reactnative_Style$Color$__f_maroon = "maroon";
  this.Lscommons_reactnative_Style$Color$__f_mediumaquamarine = "mediumaquamarine";
  this.Lscommons_reactnative_Style$Color$__f_mediumblue = "mediumblue";
  this.Lscommons_reactnative_Style$Color$__f_mediumorchid = "mediumorchid";
  this.Lscommons_reactnative_Style$Color$__f_mediumpurple = "mediumpurple";
  this.Lscommons_reactnative_Style$Color$__f_mediumseagreen = "mediumseagreen";
  this.Lscommons_reactnative_Style$Color$__f_mediumslateblue = "mediumslateblue";
  this.Lscommons_reactnative_Style$Color$__f_mediumspringgreen = "mediumspringgreen";
  this.Lscommons_reactnative_Style$Color$__f_mediumturquoise = "mediumturquoise";
  this.Lscommons_reactnative_Style$Color$__f_mediumvioletred = "mediumvioletred";
  this.Lscommons_reactnative_Style$Color$__f_midnightblue = "midnightblue";
  this.Lscommons_reactnative_Style$Color$__f_mintcream = "mintcream";
  this.Lscommons_reactnative_Style$Color$__f_mistyrose = "mistyrose";
  this.Lscommons_reactnative_Style$Color$__f_moccasin = "moccasin";
  this.Lscommons_reactnative_Style$Color$__f_navajowhite = "navajowhite";
  this.Lscommons_reactnative_Style$Color$__f_navy = "navy";
  this.Lscommons_reactnative_Style$Color$__f_oldlace = "oldlace";
  this.Lscommons_reactnative_Style$Color$__f_olive = "olive";
  this.Lscommons_reactnative_Style$Color$__f_olivedrab = "olivedrab";
  this.Lscommons_reactnative_Style$Color$__f_orange = "orange";
  this.Lscommons_reactnative_Style$Color$__f_orangered = "orangered";
  this.Lscommons_reactnative_Style$Color$__f_orchid = "orchid";
  this.Lscommons_reactnative_Style$Color$__f_palegoldenrod = "palegoldenrod";
  this.Lscommons_reactnative_Style$Color$__f_palegreen = "palegreen";
  this.Lscommons_reactnative_Style$Color$__f_paleturquoise = "paleturquoise";
  this.Lscommons_reactnative_Style$Color$__f_palevioletred = "palevioletred";
  this.Lscommons_reactnative_Style$Color$__f_papayawhip = "papayawhip";
  this.Lscommons_reactnative_Style$Color$__f_peachpuff = "peachpuff";
  this.Lscommons_reactnative_Style$Color$__f_peru = "peru";
  this.Lscommons_reactnative_Style$Color$__f_pink = "pink";
  this.Lscommons_reactnative_Style$Color$__f_plum = "plum";
  this.Lscommons_reactnative_Style$Color$__f_powderblue = "powderblue";
  this.Lscommons_reactnative_Style$Color$__f_purple = "purple";
  this.Lscommons_reactnative_Style$Color$__f_rebeccapurple = "rebeccapurple";
  this.Lscommons_reactnative_Style$Color$__f_red = "red";
  this.Lscommons_reactnative_Style$Color$__f_rosybrown = "rosybrown";
  this.Lscommons_reactnative_Style$Color$__f_royalblue = "royalblue";
  this.Lscommons_reactnative_Style$Color$__f_saddlebrown = "saddlebrown";
  this.Lscommons_reactnative_Style$Color$__f_salmon = "salmon";
  this.Lscommons_reactnative_Style$Color$__f_sandybrown = "sandybrown";
  this.Lscommons_reactnative_Style$Color$__f_seagreen = "seagreen";
  this.Lscommons_reactnative_Style$Color$__f_seashell = "seashell";
  this.Lscommons_reactnative_Style$Color$__f_sienna = "sienna";
  this.Lscommons_reactnative_Style$Color$__f_silver = "silver";
  this.Lscommons_reactnative_Style$Color$__f_skyblue = "skyblue";
  this.Lscommons_reactnative_Style$Color$__f_slateblue = "slateblue";
  this.Lscommons_reactnative_Style$Color$__f_slategray = "slategray";
  this.Lscommons_reactnative_Style$Color$__f_snow = "snow";
  this.Lscommons_reactnative_Style$Color$__f_springgreen = "springgreen";
  this.Lscommons_reactnative_Style$Color$__f_steelblue = "steelblue";
  this.Lscommons_reactnative_Style$Color$__f_tan = "tan";
  this.Lscommons_reactnative_Style$Color$__f_teal = "teal";
  this.Lscommons_reactnative_Style$Color$__f_thistle = "thistle";
  this.Lscommons_reactnative_Style$Color$__f_tomato = "tomato";
  this.Lscommons_reactnative_Style$Color$__f_turquoise = "turquoise";
  this.Lscommons_reactnative_Style$Color$__f_violet = "violet";
  this.Lscommons_reactnative_Style$Color$__f_wheat = "wheat";
  this.Lscommons_reactnative_Style$Color$__f_white = "white";
  this.Lscommons_reactnative_Style$Color$__f_whitesmoke = "whitesmoke";
  this.Lscommons_reactnative_Style$Color$__f_yellow = "yellow";
  this.Lscommons_reactnative_Style$Color$__f_yellowgreen = "yellowgreen"
}
$c_Lscommons_reactnative_Style$Color$.prototype = new $h_O();
$c_Lscommons_reactnative_Style$Color$.prototype.constructor = $c_Lscommons_reactnative_Style$Color$;
/** @constructor */
function $h_Lscommons_reactnative_Style$Color$() {
  /*<skip>*/
}
$h_Lscommons_reactnative_Style$Color$.prototype = $c_Lscommons_reactnative_Style$Color$.prototype;
$c_Lscommons_reactnative_Style$Color$.prototype.black__T = (function() {
  return this.Lscommons_reactnative_Style$Color$__f_black
});
$c_Lscommons_reactnative_Style$Color$.prototype.darkgray__T = (function() {
  return this.Lscommons_reactnative_Style$Color$__f_darkgray
});
$c_Lscommons_reactnative_Style$Color$.prototype.gray__T = (function() {
  return this.Lscommons_reactnative_Style$Color$__f_gray
});
$c_Lscommons_reactnative_Style$Color$.prototype.grey__T = (function() {
  return this.Lscommons_reactnative_Style$Color$__f_grey
});
$c_Lscommons_reactnative_Style$Color$.prototype.lightgrey__T = (function() {
  return this.Lscommons_reactnative_Style$Color$__f_lightgrey
});
$c_Lscommons_reactnative_Style$Color$.prototype.red__T = (function() {
  return this.Lscommons_reactnative_Style$Color$__f_red
});
$c_Lscommons_reactnative_Style$Color$.prototype.white__T = (function() {
  return this.Lscommons_reactnative_Style$Color$__f_white
});
$c_Lscommons_reactnative_Style$Color$.prototype.yellow__T = (function() {
  return this.Lscommons_reactnative_Style$Color$__f_yellow
});
var $d_Lscommons_reactnative_Style$Color$ = new $TypeData().initClass({
  Lscommons_reactnative_Style$Color$: 0
}, false, "scommons.reactnative.Style$Color$", {
  Lscommons_reactnative_Style$Color$: 1,
  O: 1
});
$c_Lscommons_reactnative_Style$Color$.prototype.$classData = $d_Lscommons_reactnative_Style$Color$;
var $n_Lscommons_reactnative_Style$Color$;
function $m_Lscommons_reactnative_Style$Color$() {
  if ((!$n_Lscommons_reactnative_Style$Color$)) {
    $n_Lscommons_reactnative_Style$Color$ = new $c_Lscommons_reactnative_Style$Color$()
  };
  return $n_Lscommons_reactnative_Style$Color$
}
/** @constructor */
function $c_Lscommons_reactnative_Style$Position$() {
  this.Lscommons_reactnative_Style$Position$__f_relative = null;
  this.Lscommons_reactnative_Style$Position$__f_absolute = null;
  this.Lscommons_reactnative_Style$Position$__f_relative = "relative";
  this.Lscommons_reactnative_Style$Position$__f_absolute = "absolute"
}
$c_Lscommons_reactnative_Style$Position$.prototype = new $h_O();
$c_Lscommons_reactnative_Style$Position$.prototype.constructor = $c_Lscommons_reactnative_Style$Position$;
/** @constructor */
function $h_Lscommons_reactnative_Style$Position$() {
  /*<skip>*/
}
$h_Lscommons_reactnative_Style$Position$.prototype = $c_Lscommons_reactnative_Style$Position$.prototype;
$c_Lscommons_reactnative_Style$Position$.prototype.absolute__Lscommons_reactnative_Style$Position = (function() {
  return this.Lscommons_reactnative_Style$Position$__f_absolute
});
var $d_Lscommons_reactnative_Style$Position$ = new $TypeData().initClass({
  Lscommons_reactnative_Style$Position$: 0
}, false, "scommons.reactnative.Style$Position$", {
  Lscommons_reactnative_Style$Position$: 1,
  O: 1
});
$c_Lscommons_reactnative_Style$Position$.prototype.$classData = $d_Lscommons_reactnative_Style$Position$;
var $n_Lscommons_reactnative_Style$Position$;
function $m_Lscommons_reactnative_Style$Position$() {
  if ((!$n_Lscommons_reactnative_Style$Position$)) {
    $n_Lscommons_reactnative_Style$Position$ = new $c_Lscommons_reactnative_Style$Position$()
  };
  return $n_Lscommons_reactnative_Style$Position$
}
/** @constructor */
function $c_Lscommons_reactnative_StyleSheet$() {
  /*<skip>*/
}
$c_Lscommons_reactnative_StyleSheet$.prototype = new $h_O();
$c_Lscommons_reactnative_StyleSheet$.prototype.constructor = $c_Lscommons_reactnative_StyleSheet$;
/** @constructor */
function $h_Lscommons_reactnative_StyleSheet$() {
  /*<skip>*/
}
$h_Lscommons_reactnative_StyleSheet$.prototype = $c_Lscommons_reactnative_StyleSheet$.prototype;
$c_Lscommons_reactnative_StyleSheet$.prototype.create__sjs_js_Object__sjs_js_Object = (function(obj) {
  return $i_react$002dnative.StyleSheet.create(obj)
});
var $d_Lscommons_reactnative_StyleSheet$ = new $TypeData().initClass({
  Lscommons_reactnative_StyleSheet$: 0
}, false, "scommons.reactnative.StyleSheet$", {
  Lscommons_reactnative_StyleSheet$: 1,
  O: 1
});
$c_Lscommons_reactnative_StyleSheet$.prototype.$classData = $d_Lscommons_reactnative_StyleSheet$;
var $n_Lscommons_reactnative_StyleSheet$;
function $m_Lscommons_reactnative_StyleSheet$() {
  if ((!$n_Lscommons_reactnative_StyleSheet$)) {
    $n_Lscommons_reactnative_StyleSheet$ = new $c_Lscommons_reactnative_StyleSheet$()
  };
  return $n_Lscommons_reactnative_StyleSheet$
}
/** @constructor */
function $c_Lscommons_reactnative_TextStyle$FontStyle$() {
  this.Lscommons_reactnative_TextStyle$FontStyle$__f_normal = null;
  this.Lscommons_reactnative_TextStyle$FontStyle$__f_italic = null;
  this.Lscommons_reactnative_TextStyle$FontStyle$__f_normal = "normal";
  this.Lscommons_reactnative_TextStyle$FontStyle$__f_italic = "italic"
}
$c_Lscommons_reactnative_TextStyle$FontStyle$.prototype = new $h_O();
$c_Lscommons_reactnative_TextStyle$FontStyle$.prototype.constructor = $c_Lscommons_reactnative_TextStyle$FontStyle$;
/** @constructor */
function $h_Lscommons_reactnative_TextStyle$FontStyle$() {
  /*<skip>*/
}
$h_Lscommons_reactnative_TextStyle$FontStyle$.prototype = $c_Lscommons_reactnative_TextStyle$FontStyle$.prototype;
$c_Lscommons_reactnative_TextStyle$FontStyle$.prototype.italic__Lscommons_reactnative_TextStyle$FontStyle = (function() {
  return this.Lscommons_reactnative_TextStyle$FontStyle$__f_italic
});
var $d_Lscommons_reactnative_TextStyle$FontStyle$ = new $TypeData().initClass({
  Lscommons_reactnative_TextStyle$FontStyle$: 0
}, false, "scommons.reactnative.TextStyle$FontStyle$", {
  Lscommons_reactnative_TextStyle$FontStyle$: 1,
  O: 1
});
$c_Lscommons_reactnative_TextStyle$FontStyle$.prototype.$classData = $d_Lscommons_reactnative_TextStyle$FontStyle$;
var $n_Lscommons_reactnative_TextStyle$FontStyle$;
function $m_Lscommons_reactnative_TextStyle$FontStyle$() {
  if ((!$n_Lscommons_reactnative_TextStyle$FontStyle$)) {
    $n_Lscommons_reactnative_TextStyle$FontStyle$ = new $c_Lscommons_reactnative_TextStyle$FontStyle$()
  };
  return $n_Lscommons_reactnative_TextStyle$FontStyle$
}
/** @constructor */
function $c_Lscommons_reactnative_TextStyle$FontWeight$() {
  this.Lscommons_reactnative_TextStyle$FontWeight$__f_normal = null;
  this.Lscommons_reactnative_TextStyle$FontWeight$__f_bold = null;
  this.Lscommons_reactnative_TextStyle$FontWeight$__f_\u013100 = null;
  this.Lscommons_reactnative_TextStyle$FontWeight$__f_\u013200 = null;
  this.Lscommons_reactnative_TextStyle$FontWeight$__f_\u013300 = null;
  this.Lscommons_reactnative_TextStyle$FontWeight$__f_\u013400 = null;
  this.Lscommons_reactnative_TextStyle$FontWeight$__f_\u013500 = null;
  this.Lscommons_reactnative_TextStyle$FontWeight$__f_\u013600 = null;
  this.Lscommons_reactnative_TextStyle$FontWeight$__f_\u013700 = null;
  this.Lscommons_reactnative_TextStyle$FontWeight$__f_\u013800 = null;
  this.Lscommons_reactnative_TextStyle$FontWeight$__f_\u013900 = null;
  this.Lscommons_reactnative_TextStyle$FontWeight$__f_normal = "normal";
  this.Lscommons_reactnative_TextStyle$FontWeight$__f_bold = "bold";
  this.Lscommons_reactnative_TextStyle$FontWeight$__f_\u013100 = "100";
  this.Lscommons_reactnative_TextStyle$FontWeight$__f_\u013200 = "200";
  this.Lscommons_reactnative_TextStyle$FontWeight$__f_\u013300 = "300";
  this.Lscommons_reactnative_TextStyle$FontWeight$__f_\u013400 = "400";
  this.Lscommons_reactnative_TextStyle$FontWeight$__f_\u013500 = "500";
  this.Lscommons_reactnative_TextStyle$FontWeight$__f_\u013600 = "600";
  this.Lscommons_reactnative_TextStyle$FontWeight$__f_\u013700 = "700";
  this.Lscommons_reactnative_TextStyle$FontWeight$__f_\u013800 = "800";
  this.Lscommons_reactnative_TextStyle$FontWeight$__f_\u013900 = "900"
}
$c_Lscommons_reactnative_TextStyle$FontWeight$.prototype = new $h_O();
$c_Lscommons_reactnative_TextStyle$FontWeight$.prototype.constructor = $c_Lscommons_reactnative_TextStyle$FontWeight$;
/** @constructor */
function $h_Lscommons_reactnative_TextStyle$FontWeight$() {
  /*<skip>*/
}
$h_Lscommons_reactnative_TextStyle$FontWeight$.prototype = $c_Lscommons_reactnative_TextStyle$FontWeight$.prototype;
$c_Lscommons_reactnative_TextStyle$FontWeight$.prototype.bold__Lscommons_reactnative_TextStyle$FontWeight = (function() {
  return this.Lscommons_reactnative_TextStyle$FontWeight$__f_bold
});
var $d_Lscommons_reactnative_TextStyle$FontWeight$ = new $TypeData().initClass({
  Lscommons_reactnative_TextStyle$FontWeight$: 0
}, false, "scommons.reactnative.TextStyle$FontWeight$", {
  Lscommons_reactnative_TextStyle$FontWeight$: 1,
  O: 1
});
$c_Lscommons_reactnative_TextStyle$FontWeight$.prototype.$classData = $d_Lscommons_reactnative_TextStyle$FontWeight$;
var $n_Lscommons_reactnative_TextStyle$FontWeight$;
function $m_Lscommons_reactnative_TextStyle$FontWeight$() {
  if ((!$n_Lscommons_reactnative_TextStyle$FontWeight$)) {
    $n_Lscommons_reactnative_TextStyle$FontWeight$ = new $c_Lscommons_reactnative_TextStyle$FontWeight$()
  };
  return $n_Lscommons_reactnative_TextStyle$FontWeight$
}
/** @constructor */
function $c_Lscommons_reactnative_TextStyle$TextAlign$() {
  this.Lscommons_reactnative_TextStyle$TextAlign$__f_auto = null;
  this.Lscommons_reactnative_TextStyle$TextAlign$__f_center = null;
  this.Lscommons_reactnative_TextStyle$TextAlign$__f_right = null;
  this.Lscommons_reactnative_TextStyle$TextAlign$__f_left = null;
  this.Lscommons_reactnative_TextStyle$TextAlign$__f_justify = null;
  this.Lscommons_reactnative_TextStyle$TextAlign$__f_auto = "auto";
  this.Lscommons_reactnative_TextStyle$TextAlign$__f_center = "center";
  this.Lscommons_reactnative_TextStyle$TextAlign$__f_right = "right";
  this.Lscommons_reactnative_TextStyle$TextAlign$__f_left = "left";
  this.Lscommons_reactnative_TextStyle$TextAlign$__f_justify = "justify"
}
$c_Lscommons_reactnative_TextStyle$TextAlign$.prototype = new $h_O();
$c_Lscommons_reactnative_TextStyle$TextAlign$.prototype.constructor = $c_Lscommons_reactnative_TextStyle$TextAlign$;
/** @constructor */
function $h_Lscommons_reactnative_TextStyle$TextAlign$() {
  /*<skip>*/
}
$h_Lscommons_reactnative_TextStyle$TextAlign$.prototype = $c_Lscommons_reactnative_TextStyle$TextAlign$.prototype;
$c_Lscommons_reactnative_TextStyle$TextAlign$.prototype.center__Lscommons_reactnative_TextStyle$TextAlign = (function() {
  return this.Lscommons_reactnative_TextStyle$TextAlign$__f_center
});
var $d_Lscommons_reactnative_TextStyle$TextAlign$ = new $TypeData().initClass({
  Lscommons_reactnative_TextStyle$TextAlign$: 0
}, false, "scommons.reactnative.TextStyle$TextAlign$", {
  Lscommons_reactnative_TextStyle$TextAlign$: 1,
  O: 1
});
$c_Lscommons_reactnative_TextStyle$TextAlign$.prototype.$classData = $d_Lscommons_reactnative_TextStyle$TextAlign$;
var $n_Lscommons_reactnative_TextStyle$TextAlign$;
function $m_Lscommons_reactnative_TextStyle$TextAlign$() {
  if ((!$n_Lscommons_reactnative_TextStyle$TextAlign$)) {
    $n_Lscommons_reactnative_TextStyle$TextAlign$ = new $c_Lscommons_reactnative_TextStyle$TextAlign$()
  };
  return $n_Lscommons_reactnative_TextStyle$TextAlign$
}
/** @constructor */
function $c_Lscommons_reactnative_TextStyle$TextDecorationLine$() {
  this.Lscommons_reactnative_TextStyle$TextDecorationLine$__f_none = null;
  this.Lscommons_reactnative_TextStyle$TextDecorationLine$__f_underline = null;
  this.Lscommons_reactnative_TextStyle$TextDecorationLine$__f_line$minusthrough = null;
  this.Lscommons_reactnative_TextStyle$TextDecorationLine$__f_underline$u0020line$minusthrough = null;
  this.Lscommons_reactnative_TextStyle$TextDecorationLine$__f_none = "none";
  this.Lscommons_reactnative_TextStyle$TextDecorationLine$__f_underline = "underline";
  this.Lscommons_reactnative_TextStyle$TextDecorationLine$__f_line$minusthrough = "line-through";
  this.Lscommons_reactnative_TextStyle$TextDecorationLine$__f_underline$u0020line$minusthrough = "underline line-through"
}
$c_Lscommons_reactnative_TextStyle$TextDecorationLine$.prototype = new $h_O();
$c_Lscommons_reactnative_TextStyle$TextDecorationLine$.prototype.constructor = $c_Lscommons_reactnative_TextStyle$TextDecorationLine$;
/** @constructor */
function $h_Lscommons_reactnative_TextStyle$TextDecorationLine$() {
  /*<skip>*/
}
$h_Lscommons_reactnative_TextStyle$TextDecorationLine$.prototype = $c_Lscommons_reactnative_TextStyle$TextDecorationLine$.prototype;
var $d_Lscommons_reactnative_TextStyle$TextDecorationLine$ = new $TypeData().initClass({
  Lscommons_reactnative_TextStyle$TextDecorationLine$: 0
}, false, "scommons.reactnative.TextStyle$TextDecorationLine$", {
  Lscommons_reactnative_TextStyle$TextDecorationLine$: 1,
  O: 1
});
$c_Lscommons_reactnative_TextStyle$TextDecorationLine$.prototype.$classData = $d_Lscommons_reactnative_TextStyle$TextDecorationLine$;
var $n_Lscommons_reactnative_TextStyle$TextDecorationLine$;
function $m_Lscommons_reactnative_TextStyle$TextDecorationLine$() {
  if ((!$n_Lscommons_reactnative_TextStyle$TextDecorationLine$)) {
    $n_Lscommons_reactnative_TextStyle$TextDecorationLine$ = new $c_Lscommons_reactnative_TextStyle$TextDecorationLine$()
  };
  return $n_Lscommons_reactnative_TextStyle$TextDecorationLine$
}
/** @constructor */
function $c_Lscommons_reactnative_ViewStyle$AlignContent$() {
  this.Lscommons_reactnative_ViewStyle$AlignContent$__f_flex$minusstart = null;
  this.Lscommons_reactnative_ViewStyle$AlignContent$__f_flex$minusend = null;
  this.Lscommons_reactnative_ViewStyle$AlignContent$__f_stretch = null;
  this.Lscommons_reactnative_ViewStyle$AlignContent$__f_center = null;
  this.Lscommons_reactnative_ViewStyle$AlignContent$__f_space$minusbetween = null;
  this.Lscommons_reactnative_ViewStyle$AlignContent$__f_space$minusaround = null;
  this.Lscommons_reactnative_ViewStyle$AlignContent$__f_flex$minusstart = "flex-start";
  this.Lscommons_reactnative_ViewStyle$AlignContent$__f_flex$minusend = "flex-end";
  this.Lscommons_reactnative_ViewStyle$AlignContent$__f_stretch = "stretch";
  this.Lscommons_reactnative_ViewStyle$AlignContent$__f_center = "center";
  this.Lscommons_reactnative_ViewStyle$AlignContent$__f_space$minusbetween = "space-between";
  this.Lscommons_reactnative_ViewStyle$AlignContent$__f_space$minusaround = "space-around"
}
$c_Lscommons_reactnative_ViewStyle$AlignContent$.prototype = new $h_O();
$c_Lscommons_reactnative_ViewStyle$AlignContent$.prototype.constructor = $c_Lscommons_reactnative_ViewStyle$AlignContent$;
/** @constructor */
function $h_Lscommons_reactnative_ViewStyle$AlignContent$() {
  /*<skip>*/
}
$h_Lscommons_reactnative_ViewStyle$AlignContent$.prototype = $c_Lscommons_reactnative_ViewStyle$AlignContent$.prototype;
$c_Lscommons_reactnative_ViewStyle$AlignContent$.prototype.center__Lscommons_reactnative_ViewStyle$AlignContent = (function() {
  return this.Lscommons_reactnative_ViewStyle$AlignContent$__f_center
});
$c_Lscommons_reactnative_ViewStyle$AlignContent$.prototype.space$minusbetween__Lscommons_reactnative_ViewStyle$AlignContent = (function() {
  return this.Lscommons_reactnative_ViewStyle$AlignContent$__f_space$minusbetween
});
var $d_Lscommons_reactnative_ViewStyle$AlignContent$ = new $TypeData().initClass({
  Lscommons_reactnative_ViewStyle$AlignContent$: 0
}, false, "scommons.reactnative.ViewStyle$AlignContent$", {
  Lscommons_reactnative_ViewStyle$AlignContent$: 1,
  O: 1
});
$c_Lscommons_reactnative_ViewStyle$AlignContent$.prototype.$classData = $d_Lscommons_reactnative_ViewStyle$AlignContent$;
var $n_Lscommons_reactnative_ViewStyle$AlignContent$;
function $m_Lscommons_reactnative_ViewStyle$AlignContent$() {
  if ((!$n_Lscommons_reactnative_ViewStyle$AlignContent$)) {
    $n_Lscommons_reactnative_ViewStyle$AlignContent$ = new $c_Lscommons_reactnative_ViewStyle$AlignContent$()
  };
  return $n_Lscommons_reactnative_ViewStyle$AlignContent$
}
/** @constructor */
function $c_Lscommons_reactnative_ViewStyle$AlignItems$() {
  this.Lscommons_reactnative_ViewStyle$AlignItems$__f_stretch = null;
  this.Lscommons_reactnative_ViewStyle$AlignItems$__f_flex$minusstart = null;
  this.Lscommons_reactnative_ViewStyle$AlignItems$__f_flex$minusend = null;
  this.Lscommons_reactnative_ViewStyle$AlignItems$__f_center = null;
  this.Lscommons_reactnative_ViewStyle$AlignItems$__f_baseline = null;
  this.Lscommons_reactnative_ViewStyle$AlignItems$__f_stretch = "stretch";
  this.Lscommons_reactnative_ViewStyle$AlignItems$__f_flex$minusstart = "flex-start";
  this.Lscommons_reactnative_ViewStyle$AlignItems$__f_flex$minusend = "flex-end";
  this.Lscommons_reactnative_ViewStyle$AlignItems$__f_center = "center";
  this.Lscommons_reactnative_ViewStyle$AlignItems$__f_baseline = "baseline"
}
$c_Lscommons_reactnative_ViewStyle$AlignItems$.prototype = new $h_O();
$c_Lscommons_reactnative_ViewStyle$AlignItems$.prototype.constructor = $c_Lscommons_reactnative_ViewStyle$AlignItems$;
/** @constructor */
function $h_Lscommons_reactnative_ViewStyle$AlignItems$() {
  /*<skip>*/
}
$h_Lscommons_reactnative_ViewStyle$AlignItems$.prototype = $c_Lscommons_reactnative_ViewStyle$AlignItems$.prototype;
$c_Lscommons_reactnative_ViewStyle$AlignItems$.prototype.center__Lscommons_reactnative_ViewStyle$AlignItems = (function() {
  return this.Lscommons_reactnative_ViewStyle$AlignItems$__f_center
});
var $d_Lscommons_reactnative_ViewStyle$AlignItems$ = new $TypeData().initClass({
  Lscommons_reactnative_ViewStyle$AlignItems$: 0
}, false, "scommons.reactnative.ViewStyle$AlignItems$", {
  Lscommons_reactnative_ViewStyle$AlignItems$: 1,
  O: 1
});
$c_Lscommons_reactnative_ViewStyle$AlignItems$.prototype.$classData = $d_Lscommons_reactnative_ViewStyle$AlignItems$;
var $n_Lscommons_reactnative_ViewStyle$AlignItems$;
function $m_Lscommons_reactnative_ViewStyle$AlignItems$() {
  if ((!$n_Lscommons_reactnative_ViewStyle$AlignItems$)) {
    $n_Lscommons_reactnative_ViewStyle$AlignItems$ = new $c_Lscommons_reactnative_ViewStyle$AlignItems$()
  };
  return $n_Lscommons_reactnative_ViewStyle$AlignItems$
}
/** @constructor */
function $c_Lscommons_reactnative_ViewStyle$AlignSelf$() {
  this.Lscommons_reactnative_ViewStyle$AlignSelf$__f_auto = null;
  this.Lscommons_reactnative_ViewStyle$AlignSelf$__f_stretch = null;
  this.Lscommons_reactnative_ViewStyle$AlignSelf$__f_center = null;
  this.Lscommons_reactnative_ViewStyle$AlignSelf$__f_flex$minusstart = null;
  this.Lscommons_reactnative_ViewStyle$AlignSelf$__f_flex$minusend = null;
  this.Lscommons_reactnative_ViewStyle$AlignSelf$__f_auto = "auto";
  this.Lscommons_reactnative_ViewStyle$AlignSelf$__f_stretch = "stretch";
  this.Lscommons_reactnative_ViewStyle$AlignSelf$__f_center = "center";
  this.Lscommons_reactnative_ViewStyle$AlignSelf$__f_flex$minusstart = "flex-start";
  this.Lscommons_reactnative_ViewStyle$AlignSelf$__f_flex$minusend = "flex-end"
}
$c_Lscommons_reactnative_ViewStyle$AlignSelf$.prototype = new $h_O();
$c_Lscommons_reactnative_ViewStyle$AlignSelf$.prototype.constructor = $c_Lscommons_reactnative_ViewStyle$AlignSelf$;
/** @constructor */
function $h_Lscommons_reactnative_ViewStyle$AlignSelf$() {
  /*<skip>*/
}
$h_Lscommons_reactnative_ViewStyle$AlignSelf$.prototype = $c_Lscommons_reactnative_ViewStyle$AlignSelf$.prototype;
$c_Lscommons_reactnative_ViewStyle$AlignSelf$.prototype.center__Lscommons_reactnative_ViewStyle$AlignSelf = (function() {
  return this.Lscommons_reactnative_ViewStyle$AlignSelf$__f_center
});
var $d_Lscommons_reactnative_ViewStyle$AlignSelf$ = new $TypeData().initClass({
  Lscommons_reactnative_ViewStyle$AlignSelf$: 0
}, false, "scommons.reactnative.ViewStyle$AlignSelf$", {
  Lscommons_reactnative_ViewStyle$AlignSelf$: 1,
  O: 1
});
$c_Lscommons_reactnative_ViewStyle$AlignSelf$.prototype.$classData = $d_Lscommons_reactnative_ViewStyle$AlignSelf$;
var $n_Lscommons_reactnative_ViewStyle$AlignSelf$;
function $m_Lscommons_reactnative_ViewStyle$AlignSelf$() {
  if ((!$n_Lscommons_reactnative_ViewStyle$AlignSelf$)) {
    $n_Lscommons_reactnative_ViewStyle$AlignSelf$ = new $c_Lscommons_reactnative_ViewStyle$AlignSelf$()
  };
  return $n_Lscommons_reactnative_ViewStyle$AlignSelf$
}
/** @constructor */
function $c_Lscommons_reactnative_ViewStyle$FlexDirection$() {
  this.Lscommons_reactnative_ViewStyle$FlexDirection$__f_column = null;
  this.Lscommons_reactnative_ViewStyle$FlexDirection$__f_row = null;
  this.Lscommons_reactnative_ViewStyle$FlexDirection$__f_row$minusreverse = null;
  this.Lscommons_reactnative_ViewStyle$FlexDirection$__f_column$minusreverse = null;
  this.Lscommons_reactnative_ViewStyle$FlexDirection$__f_column = "column";
  this.Lscommons_reactnative_ViewStyle$FlexDirection$__f_row = "row";
  this.Lscommons_reactnative_ViewStyle$FlexDirection$__f_row$minusreverse = "row-reverse";
  this.Lscommons_reactnative_ViewStyle$FlexDirection$__f_column$minusreverse = "column-reverse"
}
$c_Lscommons_reactnative_ViewStyle$FlexDirection$.prototype = new $h_O();
$c_Lscommons_reactnative_ViewStyle$FlexDirection$.prototype.constructor = $c_Lscommons_reactnative_ViewStyle$FlexDirection$;
/** @constructor */
function $h_Lscommons_reactnative_ViewStyle$FlexDirection$() {
  /*<skip>*/
}
$h_Lscommons_reactnative_ViewStyle$FlexDirection$.prototype = $c_Lscommons_reactnative_ViewStyle$FlexDirection$.prototype;
$c_Lscommons_reactnative_ViewStyle$FlexDirection$.prototype.row__Lscommons_reactnative_ViewStyle$FlexDirection = (function() {
  return this.Lscommons_reactnative_ViewStyle$FlexDirection$__f_row
});
var $d_Lscommons_reactnative_ViewStyle$FlexDirection$ = new $TypeData().initClass({
  Lscommons_reactnative_ViewStyle$FlexDirection$: 0
}, false, "scommons.reactnative.ViewStyle$FlexDirection$", {
  Lscommons_reactnative_ViewStyle$FlexDirection$: 1,
  O: 1
});
$c_Lscommons_reactnative_ViewStyle$FlexDirection$.prototype.$classData = $d_Lscommons_reactnative_ViewStyle$FlexDirection$;
var $n_Lscommons_reactnative_ViewStyle$FlexDirection$;
function $m_Lscommons_reactnative_ViewStyle$FlexDirection$() {
  if ((!$n_Lscommons_reactnative_ViewStyle$FlexDirection$)) {
    $n_Lscommons_reactnative_ViewStyle$FlexDirection$ = new $c_Lscommons_reactnative_ViewStyle$FlexDirection$()
  };
  return $n_Lscommons_reactnative_ViewStyle$FlexDirection$
}
/** @constructor */
function $c_Lscommons_reactnative_ViewStyle$FlexWrap$() {
  this.Lscommons_reactnative_ViewStyle$FlexWrap$__f_nowrap = null;
  this.Lscommons_reactnative_ViewStyle$FlexWrap$__f_wrap = null;
  this.Lscommons_reactnative_ViewStyle$FlexWrap$__f_nowrap = "nowrap";
  this.Lscommons_reactnative_ViewStyle$FlexWrap$__f_wrap = "wrap"
}
$c_Lscommons_reactnative_ViewStyle$FlexWrap$.prototype = new $h_O();
$c_Lscommons_reactnative_ViewStyle$FlexWrap$.prototype.constructor = $c_Lscommons_reactnative_ViewStyle$FlexWrap$;
/** @constructor */
function $h_Lscommons_reactnative_ViewStyle$FlexWrap$() {
  /*<skip>*/
}
$h_Lscommons_reactnative_ViewStyle$FlexWrap$.prototype = $c_Lscommons_reactnative_ViewStyle$FlexWrap$.prototype;
$c_Lscommons_reactnative_ViewStyle$FlexWrap$.prototype.wrap__Lscommons_reactnative_ViewStyle$FlexWrap = (function() {
  return this.Lscommons_reactnative_ViewStyle$FlexWrap$__f_wrap
});
var $d_Lscommons_reactnative_ViewStyle$FlexWrap$ = new $TypeData().initClass({
  Lscommons_reactnative_ViewStyle$FlexWrap$: 0
}, false, "scommons.reactnative.ViewStyle$FlexWrap$", {
  Lscommons_reactnative_ViewStyle$FlexWrap$: 1,
  O: 1
});
$c_Lscommons_reactnative_ViewStyle$FlexWrap$.prototype.$classData = $d_Lscommons_reactnative_ViewStyle$FlexWrap$;
var $n_Lscommons_reactnative_ViewStyle$FlexWrap$;
function $m_Lscommons_reactnative_ViewStyle$FlexWrap$() {
  if ((!$n_Lscommons_reactnative_ViewStyle$FlexWrap$)) {
    $n_Lscommons_reactnative_ViewStyle$FlexWrap$ = new $c_Lscommons_reactnative_ViewStyle$FlexWrap$()
  };
  return $n_Lscommons_reactnative_ViewStyle$FlexWrap$
}
/** @constructor */
function $c_Lscommons_reactnative_ViewStyle$JustifyContent$() {
  this.Lscommons_reactnative_ViewStyle$JustifyContent$__f_flex$minusstart = null;
  this.Lscommons_reactnative_ViewStyle$JustifyContent$__f_flex$minusend = null;
  this.Lscommons_reactnative_ViewStyle$JustifyContent$__f_center = null;
  this.Lscommons_reactnative_ViewStyle$JustifyContent$__f_space$minusbetween = null;
  this.Lscommons_reactnative_ViewStyle$JustifyContent$__f_space$minusaround = null;
  this.Lscommons_reactnative_ViewStyle$JustifyContent$__f_space$minusevenly = null;
  this.Lscommons_reactnative_ViewStyle$JustifyContent$__f_flex$minusstart = "flex-start";
  this.Lscommons_reactnative_ViewStyle$JustifyContent$__f_flex$minusend = "flex-end";
  this.Lscommons_reactnative_ViewStyle$JustifyContent$__f_center = "center";
  this.Lscommons_reactnative_ViewStyle$JustifyContent$__f_space$minusbetween = "space-between";
  this.Lscommons_reactnative_ViewStyle$JustifyContent$__f_space$minusaround = "space-around";
  this.Lscommons_reactnative_ViewStyle$JustifyContent$__f_space$minusevenly = "space-evenly"
}
$c_Lscommons_reactnative_ViewStyle$JustifyContent$.prototype = new $h_O();
$c_Lscommons_reactnative_ViewStyle$JustifyContent$.prototype.constructor = $c_Lscommons_reactnative_ViewStyle$JustifyContent$;
/** @constructor */
function $h_Lscommons_reactnative_ViewStyle$JustifyContent$() {
  /*<skip>*/
}
$h_Lscommons_reactnative_ViewStyle$JustifyContent$.prototype = $c_Lscommons_reactnative_ViewStyle$JustifyContent$.prototype;
$c_Lscommons_reactnative_ViewStyle$JustifyContent$.prototype.center__Lscommons_reactnative_ViewStyle$JustifyContent = (function() {
  return this.Lscommons_reactnative_ViewStyle$JustifyContent$__f_center
});
$c_Lscommons_reactnative_ViewStyle$JustifyContent$.prototype.space$minusaround__Lscommons_reactnative_ViewStyle$JustifyContent = (function() {
  return this.Lscommons_reactnative_ViewStyle$JustifyContent$__f_space$minusaround
});
var $d_Lscommons_reactnative_ViewStyle$JustifyContent$ = new $TypeData().initClass({
  Lscommons_reactnative_ViewStyle$JustifyContent$: 0
}, false, "scommons.reactnative.ViewStyle$JustifyContent$", {
  Lscommons_reactnative_ViewStyle$JustifyContent$: 1,
  O: 1
});
$c_Lscommons_reactnative_ViewStyle$JustifyContent$.prototype.$classData = $d_Lscommons_reactnative_ViewStyle$JustifyContent$;
var $n_Lscommons_reactnative_ViewStyle$JustifyContent$;
function $m_Lscommons_reactnative_ViewStyle$JustifyContent$() {
  if ((!$n_Lscommons_reactnative_ViewStyle$JustifyContent$)) {
    $n_Lscommons_reactnative_ViewStyle$JustifyContent$ = new $c_Lscommons_reactnative_ViewStyle$JustifyContent$()
  };
  return $n_Lscommons_reactnative_ViewStyle$JustifyContent$
}
/** @constructor */
function $c_Lscommons_reactnative_app_AppTaskManagerUi$() {
  this.Lscommons_reactnative_app_AppTaskManagerUi$__f_errorHandler = null;
  this.Lscommons_reactnative_app_AppTaskManagerUi$__f_taskLoggerComp = null;
  this.Lscommons_reactnative_app_AppTaskManagerUi$__f_loadingPopup = null;
  this.Lscommons_reactnative_app_AppTaskManagerUi$__f_errorPopup = null;
  $n_Lscommons_reactnative_app_AppTaskManagerUi$ = this;
  this.Lscommons_reactnative_app_AppTaskManagerUi$__f_errorHandler = new $c_Lscommons_reactnative_app_AppTaskManagerUi$$anonfun$1();
  this.Lscommons_reactnative_app_AppTaskManagerUi$__f_taskLoggerComp = $m_Lscommons_reactnative_app_TaskLogger$();
  this.Lscommons_reactnative_app_AppTaskManagerUi$__f_loadingPopup = $m_Lscommons_reactnative_ui_popup_LoadingPopup$();
  this.Lscommons_reactnative_app_AppTaskManagerUi$__f_errorPopup = $m_Lscommons_reactnative_ui_popup_ErrorPopup$()
}
$c_Lscommons_reactnative_app_AppTaskManagerUi$.prototype = new $h_O();
$c_Lscommons_reactnative_app_AppTaskManagerUi$.prototype.constructor = $c_Lscommons_reactnative_app_AppTaskManagerUi$;
/** @constructor */
function $h_Lscommons_reactnative_app_AppTaskManagerUi$() {
  /*<skip>*/
}
$h_Lscommons_reactnative_app_AppTaskManagerUi$.prototype = $c_Lscommons_reactnative_app_AppTaskManagerUi$.prototype;
var $d_Lscommons_reactnative_app_AppTaskManagerUi$ = new $TypeData().initClass({
  Lscommons_reactnative_app_AppTaskManagerUi$: 0
}, false, "scommons.reactnative.app.AppTaskManagerUi$", {
  Lscommons_reactnative_app_AppTaskManagerUi$: 1,
  O: 1
});
$c_Lscommons_reactnative_app_AppTaskManagerUi$.prototype.$classData = $d_Lscommons_reactnative_app_AppTaskManagerUi$;
var $n_Lscommons_reactnative_app_AppTaskManagerUi$;
function $m_Lscommons_reactnative_app_AppTaskManagerUi$() {
  if ((!$n_Lscommons_reactnative_app_AppTaskManagerUi$)) {
    $n_Lscommons_reactnative_app_AppTaskManagerUi$ = new $c_Lscommons_reactnative_app_AppTaskManagerUi$()
  };
  return $n_Lscommons_reactnative_app_AppTaskManagerUi$
}
/** @constructor */
function $c_Lscommons_reactnative_highlighter_package$() {
  this.Lscommons_reactnative_highlighter_package$__f_HighlightJsStyles = null;
  $n_Lscommons_reactnative_highlighter_package$ = this;
  this.Lscommons_reactnative_highlighter_package$__f_HighlightJsStyles = $i_react$002dsyntax$002dhighlighter$002fstyles$002fhljs
}
$c_Lscommons_reactnative_highlighter_package$.prototype = new $h_O();
$c_Lscommons_reactnative_highlighter_package$.prototype.constructor = $c_Lscommons_reactnative_highlighter_package$;
/** @constructor */
function $h_Lscommons_reactnative_highlighter_package$() {
  /*<skip>*/
}
$h_Lscommons_reactnative_highlighter_package$.prototype = $c_Lscommons_reactnative_highlighter_package$.prototype;
$c_Lscommons_reactnative_highlighter_package$.prototype.getHighlightJsStyle__T__s_Option = (function(name) {
  var hljsStyle = $i_react$002dsyntax$002dhighlighter$002fstyles$002fhljs;
  var value = hljsStyle[name];
  return ((value === (void 0)) ? $m_s_None$() : new $c_s_Some(value))
});
var $d_Lscommons_reactnative_highlighter_package$ = new $TypeData().initClass({
  Lscommons_reactnative_highlighter_package$: 0
}, false, "scommons.reactnative.highlighter.package$", {
  Lscommons_reactnative_highlighter_package$: 1,
  O: 1
});
$c_Lscommons_reactnative_highlighter_package$.prototype.$classData = $d_Lscommons_reactnative_highlighter_package$;
var $n_Lscommons_reactnative_highlighter_package$;
function $m_Lscommons_reactnative_highlighter_package$() {
  if ((!$n_Lscommons_reactnative_highlighter_package$)) {
    $n_Lscommons_reactnative_highlighter_package$ = new $c_Lscommons_reactnative_highlighter_package$()
  };
  return $n_Lscommons_reactnative_highlighter_package$
}
function $p_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes__language$lzycompute__Lio_github_shogowada_statictags_StringAttributeSpec($thiz) {
  if (((((1 & $thiz.Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes__f_language = new $c_Lio_github_shogowada_statictags_StringAttributeSpec("language");
    $thiz.Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes__f_bitmap$0 = (((1 | $thiz.Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes__f_language
}
function $p_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes__customStyle$lzycompute__Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$CustomStyleAttributeSpec($thiz) {
  if (((((8 & $thiz.Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes__f_customStyle = new $c_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$CustomStyleAttributeSpec("customStyle");
    $thiz.Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes__f_bitmap$0 = (((8 | $thiz.Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes__f_customStyle
}
function $p_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes__highlighter$lzycompute__Lio_github_shogowada_statictags_StringAttributeSpec($thiz) {
  if (((((16 & $thiz.Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes__f_highlighter = new $c_Lio_github_shogowada_statictags_StringAttributeSpec("highlighter");
    $thiz.Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes__f_bitmap$0 = (((16 | $thiz.Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes__f_highlighter
}
function $p_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes__highlighterStyle$lzycompute__Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$HighlighterStyleAttribute($thiz) {
  if (((((32 & $thiz.Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes__f_highlighterStyle = new $c_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$HighlighterStyleAttribute("style");
    $thiz.Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes__f_bitmap$0 = (((32 | $thiz.Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes__f_highlighterStyle
}
function $p_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes__PreTag$lzycompute__Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$ReactClassAttribute($thiz) {
  if (((((64 & $thiz.Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes__f_PreTag = new $c_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$ReactClassAttribute("PreTag");
    $thiz.Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes__f_bitmap$0 = (((64 | $thiz.Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes__f_PreTag
}
function $p_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes__CodeTag$lzycompute__Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$ReactClassAttribute($thiz) {
  if (((((128 & $thiz.Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes__f_CodeTag = new $c_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$ReactClassAttribute("CodeTag");
    $thiz.Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes__f_bitmap$0 = (((128 | $thiz.Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes__f_CodeTag
}
/** @constructor */
function $c_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes(attributes) {
  this.Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes__f_language = null;
  this.Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes__f_fontFamily = null;
  this.Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes__f_fontSize = null;
  this.Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes__f_customStyle = null;
  this.Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes__f_highlighter = null;
  this.Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes__f_highlighterStyle = null;
  this.Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes__f_PreTag = null;
  this.Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes__f_CodeTag = null;
  this.Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes__f_bitmap$0 = 0
}
$c_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes.prototype = new $h_O();
$c_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes.prototype.constructor = $c_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes;
/** @constructor */
function $h_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes() {
  /*<skip>*/
}
$h_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes.prototype = $c_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes.prototype;
$c_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes.prototype.language__Lio_github_shogowada_statictags_StringAttributeSpec = (function() {
  return (((((1 & this.Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes__language$lzycompute__Lio_github_shogowada_statictags_StringAttributeSpec(this) : this.Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes__f_language)
});
$c_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes.prototype.customStyle__Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$CustomStyleAttributeSpec = (function() {
  return (((((8 & this.Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes__customStyle$lzycompute__Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$CustomStyleAttributeSpec(this) : this.Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes__f_customStyle)
});
$c_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes.prototype.highlighter__Lio_github_shogowada_statictags_StringAttributeSpec = (function() {
  return (((((16 & this.Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes__highlighter$lzycompute__Lio_github_shogowada_statictags_StringAttributeSpec(this) : this.Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes__f_highlighter)
});
$c_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes.prototype.highlighterStyle__Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$HighlighterStyleAttribute = (function() {
  return (((((32 & this.Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes__highlighterStyle$lzycompute__Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$HighlighterStyleAttribute(this) : this.Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes__f_highlighterStyle)
});
$c_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes.prototype.PreTag__Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$ReactClassAttribute = (function() {
  return (((((64 & this.Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes__PreTag$lzycompute__Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$ReactClassAttribute(this) : this.Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes__f_PreTag)
});
$c_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes.prototype.CodeTag__Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$ReactClassAttribute = (function() {
  return (((((128 & this.Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes__CodeTag$lzycompute__Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$ReactClassAttribute(this) : this.Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes__f_CodeTag)
});
var $d_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes = new $TypeData().initClass({
  Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes: 0
}, false, "scommons.reactnative.highlighter.package$SyntaxHighlighterVirtualDOMAttributes", {
  Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes: 1,
  O: 1
});
$c_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes.prototype.$classData = $d_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes;
function $p_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMElements__SyntaxHighlighter$lzycompute__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($thiz) {
  if ((!$thiz.Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMElements__f_bitmap$0)) {
    var reactClass = $moduleDefault($i_react$002dnative$002dsyntax$002dhighlighter);
    $thiz.Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMElements__f_SyntaxHighlighter = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass);
    $thiz.Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMElements__f_bitmap$0 = true
  };
  $thiz.Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMElements__f_elements = null;
  return $thiz.Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMElements__f_SyntaxHighlighter
}
/** @constructor */
function $c_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMElements(elements) {
  this.Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMElements__f_SyntaxHighlighter = null;
  this.Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMElements__f_elements = null;
  this.Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMElements__f_bitmap$0 = false;
  this.Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMElements__f_elements = elements
}
$c_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMElements.prototype = new $h_O();
$c_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMElements.prototype.constructor = $c_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMElements;
/** @constructor */
function $h_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMElements() {
  /*<skip>*/
}
$h_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMElements.prototype = $c_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMElements.prototype;
$c_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMElements.prototype.SyntaxHighlighter__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec = (function() {
  return ((!this.Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMElements__f_bitmap$0) ? $p_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMElements__SyntaxHighlighter$lzycompute__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec(this) : this.Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMElements__f_SyntaxHighlighter)
});
var $d_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMElements = new $TypeData().initClass({
  Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMElements: 0
}, false, "scommons.reactnative.highlighter.package$SyntaxHighlighterVirtualDOMElements", {
  Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMElements: 1,
  O: 1
});
$c_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMElements.prototype.$classData = $d_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMElements;
function $p_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes__textComponentProps$lzycompute__Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes$JsObjectAttribute($thiz) {
  if (((((1 & $thiz.Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes__f_textComponentProps = new $c_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes$JsObjectAttribute("textComponentProps");
    $thiz.Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes__f_bitmap$0 = (((1 | $thiz.Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes__f_textComponentProps
}
function $p_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes__stylesheet$lzycompute__Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes$JsObjectAttribute($thiz) {
  if (((((2 & $thiz.Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes__f_stylesheet = new $c_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes$JsObjectAttribute("stylesheet");
    $thiz.Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes__f_bitmap$0 = (((2 | $thiz.Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes__f_stylesheet
}
function $p_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes__renderNode$lzycompute__Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes$RenderNodeAttribute($thiz) {
  if (((((4 & $thiz.Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes__f_renderNode = new $c_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes$RenderNodeAttribute("renderNode");
    $thiz.Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes__f_bitmap$0 = (((4 | $thiz.Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes__f_renderNode
}
/** @constructor */
function $c_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes(attributes) {
  this.Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes__f_textComponentProps = null;
  this.Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes__f_stylesheet = null;
  this.Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes__f_renderNode = null;
  this.Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes__f_bitmap$0 = 0
}
$c_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes.prototype = new $h_O();
$c_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes.prototype.constructor = $c_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes;
/** @constructor */
function $h_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes() {
  /*<skip>*/
}
$h_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes.prototype = $c_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes.prototype;
$c_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes.prototype.textComponentProps__Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes$JsObjectAttribute = (function() {
  return (((((1 & this.Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes__textComponentProps$lzycompute__Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes$JsObjectAttribute(this) : this.Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes__f_textComponentProps)
});
$c_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes.prototype.stylesheet__Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes$JsObjectAttribute = (function() {
  return (((((2 & this.Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes__stylesheet$lzycompute__Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes$JsObjectAttribute(this) : this.Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes__f_stylesheet)
});
$c_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes.prototype.renderNode__Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes$RenderNodeAttribute = (function() {
  return (((((4 & this.Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes__renderNode$lzycompute__Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes$RenderNodeAttribute(this) : this.Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes__f_renderNode)
});
var $d_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes = new $TypeData().initClass({
  Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes: 0
}, false, "scommons.reactnative.htmlview.package$HTMLViewVirtualDOMAttributes", {
  Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes: 1,
  O: 1
});
$c_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes.prototype.$classData = $d_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes;
function $p_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMElements__HTMLView$lzycompute__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($thiz) {
  if ((!$thiz.Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMElements__f_bitmap$0)) {
    var reactClass = $moduleDefault($i_react$002dnative$002dhtmlview);
    $thiz.Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMElements__f_HTMLView = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass);
    $thiz.Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMElements__f_bitmap$0 = true
  };
  $thiz.Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMElements__f_elements = null;
  return $thiz.Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMElements__f_HTMLView
}
/** @constructor */
function $c_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMElements(elements) {
  this.Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMElements__f_HTMLView = null;
  this.Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMElements__f_elements = null;
  this.Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMElements__f_bitmap$0 = false;
  this.Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMElements__f_elements = elements
}
$c_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMElements.prototype = new $h_O();
$c_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMElements.prototype.constructor = $c_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMElements;
/** @constructor */
function $h_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMElements() {
  /*<skip>*/
}
$h_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMElements.prototype = $c_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMElements.prototype;
$c_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMElements.prototype.HTMLView__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec = (function() {
  return ((!this.Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMElements__f_bitmap$0) ? $p_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMElements__HTMLView$lzycompute__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec(this) : this.Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMElements__f_HTMLView)
});
var $d_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMElements = new $TypeData().initClass({
  Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMElements: 0
}, false, "scommons.reactnative.htmlview.package$HTMLViewVirtualDOMElements", {
  Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMElements: 1,
  O: 1
});
$c_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMElements.prototype.$classData = $d_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMElements;
/** @constructor */
function $c_Lscommons_reactnative_package$() {
  /*<skip>*/
}
$c_Lscommons_reactnative_package$.prototype = new $h_O();
$c_Lscommons_reactnative_package$.prototype.constructor = $c_Lscommons_reactnative_package$;
/** @constructor */
function $h_Lscommons_reactnative_package$() {
  /*<skip>*/
}
$h_Lscommons_reactnative_package$.prototype = $c_Lscommons_reactnative_package$.prototype;
$c_Lscommons_reactnative_package$.prototype.setTimeout__sjs_js_Function0__D__Lscommons_reactnative_raw_Timeout = (function(callback, delay) {
  return setTimeout(callback, delay)
});
var $d_Lscommons_reactnative_package$ = new $TypeData().initClass({
  Lscommons_reactnative_package$: 0
}, false, "scommons.reactnative.package$", {
  Lscommons_reactnative_package$: 1,
  O: 1
});
$c_Lscommons_reactnative_package$.prototype.$classData = $d_Lscommons_reactnative_package$;
var $n_Lscommons_reactnative_package$;
function $m_Lscommons_reactnative_package$() {
  if ((!$n_Lscommons_reactnative_package$)) {
    $n_Lscommons_reactnative_package$ = new $c_Lscommons_reactnative_package$()
  };
  return $n_Lscommons_reactnative_package$
}
function $p_Lscommons_reactnative_package$ReactNativeVirtualDOMElements__ActivityIndicator$lzycompute__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($thiz) {
  if (((1 & $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_bitmap$0) === 0)) {
    var reactClass = $i_react$002dnative.ActivityIndicator;
    $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_ActivityIndicator = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass);
    $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_bitmap$0 = (1 | $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_bitmap$0)
  };
  return $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_ActivityIndicator
}
function $p_Lscommons_reactnative_package$ReactNativeVirtualDOMElements__Button$lzycompute__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($thiz) {
  if (((2 & $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_bitmap$0) === 0)) {
    var reactClass = $i_react$002dnative.Button;
    $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_Button = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass);
    $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_bitmap$0 = (2 | $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_bitmap$0)
  };
  return $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_Button
}
function $p_Lscommons_reactnative_package$ReactNativeVirtualDOMElements__FlatList$lzycompute__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($thiz) {
  if (((4 & $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_bitmap$0) === 0)) {
    var reactClass = $i_react$002dnative.FlatList;
    $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_FlatList = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass);
    $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_bitmap$0 = (4 | $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_bitmap$0)
  };
  return $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_FlatList
}
function $p_Lscommons_reactnative_package$ReactNativeVirtualDOMElements__Image$lzycompute__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($thiz) {
  if (((8 & $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_bitmap$0) === 0)) {
    var reactClass = $i_react$002dnative.Image;
    $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_Image = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass);
    $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_bitmap$0 = (8 | $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_bitmap$0)
  };
  return $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_Image
}
function $p_Lscommons_reactnative_package$ReactNativeVirtualDOMElements__Modal$lzycompute__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($thiz) {
  if (((32 & $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_bitmap$0) === 0)) {
    var reactClass = $i_react$002dnative.Modal;
    $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_Modal = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass);
    $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_bitmap$0 = (32 | $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_bitmap$0)
  };
  return $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_Modal
}
function $p_Lscommons_reactnative_package$ReactNativeVirtualDOMElements__ScrollView$lzycompute__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($thiz) {
  if (((64 & $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_bitmap$0) === 0)) {
    var reactClass = $i_react$002dnative.ScrollView;
    $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_ScrollView = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass);
    $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_bitmap$0 = (64 | $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_bitmap$0)
  };
  return $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_ScrollView
}
function $p_Lscommons_reactnative_package$ReactNativeVirtualDOMElements__StatusBar$lzycompute__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($thiz) {
  if (((128 & $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_bitmap$0) === 0)) {
    var reactClass = $i_react$002dnative.StatusBar;
    $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_StatusBar = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass);
    $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_bitmap$0 = (128 | $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_bitmap$0)
  };
  return $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_StatusBar
}
function $p_Lscommons_reactnative_package$ReactNativeVirtualDOMElements__Switch$lzycompute__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($thiz) {
  if (((256 & $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_bitmap$0) === 0)) {
    var reactClass = $i_react$002dnative.Switch;
    $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_Switch = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass);
    $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_bitmap$0 = (256 | $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_bitmap$0)
  };
  return $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_Switch
}
function $p_Lscommons_reactnative_package$ReactNativeVirtualDOMElements__Text$lzycompute__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($thiz) {
  if (((512 & $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_bitmap$0) === 0)) {
    var reactClass = $i_react$002dnative.Text;
    $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_Text = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass);
    $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_bitmap$0 = (512 | $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_bitmap$0)
  };
  return $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_Text
}
function $p_Lscommons_reactnative_package$ReactNativeVirtualDOMElements__TouchableOpacity$lzycompute__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($thiz) {
  if (((4096 & $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_bitmap$0) === 0)) {
    var reactClass = $i_react$002dnative.TouchableOpacity;
    $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_TouchableOpacity = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass);
    $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_bitmap$0 = (4096 | $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_bitmap$0)
  };
  return $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_TouchableOpacity
}
function $p_Lscommons_reactnative_package$ReactNativeVirtualDOMElements__TouchableWithoutFeedback$lzycompute__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($thiz) {
  if (((8192 & $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_bitmap$0) === 0)) {
    var reactClass = $i_react$002dnative.TouchableWithoutFeedback;
    $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_TouchableWithoutFeedback = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass);
    $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_bitmap$0 = (8192 | $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_bitmap$0)
  };
  return $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_TouchableWithoutFeedback
}
function $p_Lscommons_reactnative_package$ReactNativeVirtualDOMElements__View$lzycompute__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($thiz) {
  if (((16384 & $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_bitmap$0) === 0)) {
    var reactClass = $i_react$002dnative.View;
    $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_View = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass);
    $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_bitmap$0 = (16384 | $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_bitmap$0)
  };
  return $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_View
}
/** @constructor */
function $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements) {
  this.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_ActivityIndicator = null;
  this.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_Button = null;
  this.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_FlatList = null;
  this.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_Image = null;
  this.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_KeyboardAvoidingView = null;
  this.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_Modal = null;
  this.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_ScrollView = null;
  this.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_StatusBar = null;
  this.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_Switch = null;
  this.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_Text = null;
  this.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_TextInput = null;
  this.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_TouchableHighlight = null;
  this.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_TouchableOpacity = null;
  this.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_TouchableWithoutFeedback = null;
  this.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_View = null;
  this.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_elements = null;
  this.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_bitmap$0 = 0;
  this.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_elements = elements
}
$c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements.prototype = new $h_O();
$c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements.prototype.constructor = $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements;
/** @constructor */
function $h_Lscommons_reactnative_package$ReactNativeVirtualDOMElements() {
  /*<skip>*/
}
$h_Lscommons_reactnative_package$ReactNativeVirtualDOMElements.prototype = $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements.prototype;
$c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements.prototype.ActivityIndicator__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec = (function() {
  return (((1 & this.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_bitmap$0) === 0) ? $p_Lscommons_reactnative_package$ReactNativeVirtualDOMElements__ActivityIndicator$lzycompute__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec(this) : this.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_ActivityIndicator)
});
$c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements.prototype.Button__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec = (function() {
  return (((2 & this.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_bitmap$0) === 0) ? $p_Lscommons_reactnative_package$ReactNativeVirtualDOMElements__Button$lzycompute__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec(this) : this.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_Button)
});
$c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements.prototype.FlatList__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec = (function() {
  return (((4 & this.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_bitmap$0) === 0) ? $p_Lscommons_reactnative_package$ReactNativeVirtualDOMElements__FlatList$lzycompute__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec(this) : this.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_FlatList)
});
$c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements.prototype.Image__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec = (function() {
  return (((8 & this.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_bitmap$0) === 0) ? $p_Lscommons_reactnative_package$ReactNativeVirtualDOMElements__Image$lzycompute__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec(this) : this.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_Image)
});
$c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements.prototype.Modal__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec = (function() {
  return (((32 & this.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_bitmap$0) === 0) ? $p_Lscommons_reactnative_package$ReactNativeVirtualDOMElements__Modal$lzycompute__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec(this) : this.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_Modal)
});
$c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements.prototype.ScrollView__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec = (function() {
  return (((64 & this.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_bitmap$0) === 0) ? $p_Lscommons_reactnative_package$ReactNativeVirtualDOMElements__ScrollView$lzycompute__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec(this) : this.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_ScrollView)
});
$c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements.prototype.StatusBar__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec = (function() {
  return (((128 & this.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_bitmap$0) === 0) ? $p_Lscommons_reactnative_package$ReactNativeVirtualDOMElements__StatusBar$lzycompute__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec(this) : this.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_StatusBar)
});
$c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements.prototype.Switch__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec = (function() {
  return (((256 & this.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_bitmap$0) === 0) ? $p_Lscommons_reactnative_package$ReactNativeVirtualDOMElements__Switch$lzycompute__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec(this) : this.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_Switch)
});
$c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements.prototype.Text__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec = (function() {
  return (((512 & this.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_bitmap$0) === 0) ? $p_Lscommons_reactnative_package$ReactNativeVirtualDOMElements__Text$lzycompute__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec(this) : this.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_Text)
});
$c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements.prototype.TouchableOpacity__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec = (function() {
  return (((4096 & this.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_bitmap$0) === 0) ? $p_Lscommons_reactnative_package$ReactNativeVirtualDOMElements__TouchableOpacity$lzycompute__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec(this) : this.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_TouchableOpacity)
});
$c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements.prototype.TouchableWithoutFeedback__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec = (function() {
  return (((8192 & this.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_bitmap$0) === 0) ? $p_Lscommons_reactnative_package$ReactNativeVirtualDOMElements__TouchableWithoutFeedback$lzycompute__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec(this) : this.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_TouchableWithoutFeedback)
});
$c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements.prototype.View__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec = (function() {
  return (((16384 & this.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_bitmap$0) === 0) ? $p_Lscommons_reactnative_package$ReactNativeVirtualDOMElements__View$lzycompute__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec(this) : this.Lscommons_reactnative_package$ReactNativeVirtualDOMElements__f_View)
});
var $d_Lscommons_reactnative_package$ReactNativeVirtualDOMElements = new $TypeData().initClass({
  Lscommons_reactnative_package$ReactNativeVirtualDOMElements: 0
}, false, "scommons.reactnative.package$ReactNativeVirtualDOMElements", {
  Lscommons_reactnative_package$ReactNativeVirtualDOMElements: 1,
  O: 1
});
$c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements.prototype.$classData = $d_Lscommons_reactnative_package$ReactNativeVirtualDOMElements;
function $p_Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes__onValueChange$lzycompute__Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes$OnValueChangeAttributeSpec($thiz) {
  if (((((1 & $thiz.Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes__f_onValueChange = new $c_Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes$OnValueChangeAttributeSpec("onValueChange");
    $thiz.Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes__f_bitmap$0 = (((1 | $thiz.Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes__f_onValueChange
}
function $p_Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes__selectedValue$lzycompute__Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes$SelectedValueAttributeSpec($thiz) {
  if (((((2 & $thiz.Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes__f_selectedValue = new $c_Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes$SelectedValueAttributeSpec("selectedValue");
    $thiz.Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes__f_bitmap$0 = (((2 | $thiz.Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes__f_selectedValue
}
/** @constructor */
function $c_Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes(attributes) {
  this.Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes__f_onValueChange = null;
  this.Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes__f_selectedValue = null;
  this.Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes__f_bitmap$0 = 0
}
$c_Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes.prototype = new $h_O();
$c_Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes.prototype.constructor = $c_Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes;
/** @constructor */
function $h_Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes() {
  /*<skip>*/
}
$h_Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes.prototype = $c_Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes.prototype;
$c_Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes.prototype.onValueChange__Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes$OnValueChangeAttributeSpec = (function() {
  return (((((1 & this.Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes__onValueChange$lzycompute__Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes$OnValueChangeAttributeSpec(this) : this.Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes__f_onValueChange)
});
$c_Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes.prototype.selectedValue__Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes$SelectedValueAttributeSpec = (function() {
  return (((((2 & this.Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes__selectedValue$lzycompute__Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes$SelectedValueAttributeSpec(this) : this.Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes__f_selectedValue)
});
var $d_Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes = new $TypeData().initClass({
  Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes: 0
}, false, "scommons.reactnative.picker.package$PickerVirtualDOMAttributes", {
  Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes: 1,
  O: 1
});
$c_Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes.prototype.$classData = $d_Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes;
function $p_Lscommons_reactnative_picker_package$PickerVirtualDOMElements__Picker$lzycompute__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($thiz) {
  if (((((1 & $thiz.Lscommons_reactnative_picker_package$PickerVirtualDOMElements__f_bitmap$0) << 24) >> 24) === 0)) {
    var reactClass = $i_$0040react$002dnative$002dpicker$002fpicker.Picker;
    $thiz.Lscommons_reactnative_picker_package$PickerVirtualDOMElements__f_Picker = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass);
    $thiz.Lscommons_reactnative_picker_package$PickerVirtualDOMElements__f_bitmap$0 = (((1 | $thiz.Lscommons_reactnative_picker_package$PickerVirtualDOMElements__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lscommons_reactnative_picker_package$PickerVirtualDOMElements__f_Picker
}
function $p_Lscommons_reactnative_picker_package$PickerVirtualDOMElements__PickerItem$lzycompute__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($thiz) {
  if (((((2 & $thiz.Lscommons_reactnative_picker_package$PickerVirtualDOMElements__f_bitmap$0) << 24) >> 24) === 0)) {
    var reactClass = $i_$0040react$002dnative$002dpicker$002fpicker.Picker.Item;
    $thiz.Lscommons_reactnative_picker_package$PickerVirtualDOMElements__f_PickerItem = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass);
    $thiz.Lscommons_reactnative_picker_package$PickerVirtualDOMElements__f_bitmap$0 = (((2 | $thiz.Lscommons_reactnative_picker_package$PickerVirtualDOMElements__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lscommons_reactnative_picker_package$PickerVirtualDOMElements__f_PickerItem
}
/** @constructor */
function $c_Lscommons_reactnative_picker_package$PickerVirtualDOMElements(elements) {
  this.Lscommons_reactnative_picker_package$PickerVirtualDOMElements__f_Picker = null;
  this.Lscommons_reactnative_picker_package$PickerVirtualDOMElements__f_PickerItem = null;
  this.Lscommons_reactnative_picker_package$PickerVirtualDOMElements__f_elements = null;
  this.Lscommons_reactnative_picker_package$PickerVirtualDOMElements__f_bitmap$0 = 0;
  this.Lscommons_reactnative_picker_package$PickerVirtualDOMElements__f_elements = elements
}
$c_Lscommons_reactnative_picker_package$PickerVirtualDOMElements.prototype = new $h_O();
$c_Lscommons_reactnative_picker_package$PickerVirtualDOMElements.prototype.constructor = $c_Lscommons_reactnative_picker_package$PickerVirtualDOMElements;
/** @constructor */
function $h_Lscommons_reactnative_picker_package$PickerVirtualDOMElements() {
  /*<skip>*/
}
$h_Lscommons_reactnative_picker_package$PickerVirtualDOMElements.prototype = $c_Lscommons_reactnative_picker_package$PickerVirtualDOMElements.prototype;
$c_Lscommons_reactnative_picker_package$PickerVirtualDOMElements.prototype.Picker__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec = (function() {
  return (((((1 & this.Lscommons_reactnative_picker_package$PickerVirtualDOMElements__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lscommons_reactnative_picker_package$PickerVirtualDOMElements__Picker$lzycompute__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec(this) : this.Lscommons_reactnative_picker_package$PickerVirtualDOMElements__f_Picker)
});
$c_Lscommons_reactnative_picker_package$PickerVirtualDOMElements.prototype.PickerItem__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec = (function() {
  return (((((2 & this.Lscommons_reactnative_picker_package$PickerVirtualDOMElements__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lscommons_reactnative_picker_package$PickerVirtualDOMElements__PickerItem$lzycompute__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec(this) : this.Lscommons_reactnative_picker_package$PickerVirtualDOMElements__f_PickerItem)
});
var $d_Lscommons_reactnative_picker_package$PickerVirtualDOMElements = new $TypeData().initClass({
  Lscommons_reactnative_picker_package$PickerVirtualDOMElements: 0
}, false, "scommons.reactnative.picker.package$PickerVirtualDOMElements", {
  Lscommons_reactnative_picker_package$PickerVirtualDOMElements: 1,
  O: 1
});
$c_Lscommons_reactnative_picker_package$PickerVirtualDOMElements.prototype.$classData = $d_Lscommons_reactnative_picker_package$PickerVirtualDOMElements;
/** @constructor */
function $c_Lscommons_reactnative_safearea_SafeArea$SafeAreaEdge$() {
  this.Lscommons_reactnative_safearea_SafeArea$SafeAreaEdge$__f_top = null;
  this.Lscommons_reactnative_safearea_SafeArea$SafeAreaEdge$__f_right = null;
  this.Lscommons_reactnative_safearea_SafeArea$SafeAreaEdge$__f_bottom = null;
  this.Lscommons_reactnative_safearea_SafeArea$SafeAreaEdge$__f_left = null;
  this.Lscommons_reactnative_safearea_SafeArea$SafeAreaEdge$__f_top = "top";
  this.Lscommons_reactnative_safearea_SafeArea$SafeAreaEdge$__f_right = "right";
  this.Lscommons_reactnative_safearea_SafeArea$SafeAreaEdge$__f_bottom = "bottom";
  this.Lscommons_reactnative_safearea_SafeArea$SafeAreaEdge$__f_left = "left"
}
$c_Lscommons_reactnative_safearea_SafeArea$SafeAreaEdge$.prototype = new $h_O();
$c_Lscommons_reactnative_safearea_SafeArea$SafeAreaEdge$.prototype.constructor = $c_Lscommons_reactnative_safearea_SafeArea$SafeAreaEdge$;
/** @constructor */
function $h_Lscommons_reactnative_safearea_SafeArea$SafeAreaEdge$() {
  /*<skip>*/
}
$h_Lscommons_reactnative_safearea_SafeArea$SafeAreaEdge$.prototype = $c_Lscommons_reactnative_safearea_SafeArea$SafeAreaEdge$.prototype;
var $d_Lscommons_reactnative_safearea_SafeArea$SafeAreaEdge$ = new $TypeData().initClass({
  Lscommons_reactnative_safearea_SafeArea$SafeAreaEdge$: 0
}, false, "scommons.reactnative.safearea.SafeArea$SafeAreaEdge$", {
  Lscommons_reactnative_safearea_SafeArea$SafeAreaEdge$: 1,
  O: 1
});
$c_Lscommons_reactnative_safearea_SafeArea$SafeAreaEdge$.prototype.$classData = $d_Lscommons_reactnative_safearea_SafeArea$SafeAreaEdge$;
var $n_Lscommons_reactnative_safearea_SafeArea$SafeAreaEdge$;
function $m_Lscommons_reactnative_safearea_SafeArea$SafeAreaEdge$() {
  if ((!$n_Lscommons_reactnative_safearea_SafeArea$SafeAreaEdge$)) {
    $n_Lscommons_reactnative_safearea_SafeArea$SafeAreaEdge$ = new $c_Lscommons_reactnative_safearea_SafeArea$SafeAreaEdge$()
  };
  return $n_Lscommons_reactnative_safearea_SafeArea$SafeAreaEdge$
}
/** @constructor */
function $c_Lscommons_reactnative_safearea_SafeArea$SafeAreaMode$() {
  this.Lscommons_reactnative_safearea_SafeArea$SafeAreaMode$__f_padding = null;
  this.Lscommons_reactnative_safearea_SafeArea$SafeAreaMode$__f_margin = null;
  this.Lscommons_reactnative_safearea_SafeArea$SafeAreaMode$__f_padding = "padding";
  this.Lscommons_reactnative_safearea_SafeArea$SafeAreaMode$__f_margin = "margin"
}
$c_Lscommons_reactnative_safearea_SafeArea$SafeAreaMode$.prototype = new $h_O();
$c_Lscommons_reactnative_safearea_SafeArea$SafeAreaMode$.prototype.constructor = $c_Lscommons_reactnative_safearea_SafeArea$SafeAreaMode$;
/** @constructor */
function $h_Lscommons_reactnative_safearea_SafeArea$SafeAreaMode$() {
  /*<skip>*/
}
$h_Lscommons_reactnative_safearea_SafeArea$SafeAreaMode$.prototype = $c_Lscommons_reactnative_safearea_SafeArea$SafeAreaMode$.prototype;
var $d_Lscommons_reactnative_safearea_SafeArea$SafeAreaMode$ = new $TypeData().initClass({
  Lscommons_reactnative_safearea_SafeArea$SafeAreaMode$: 0
}, false, "scommons.reactnative.safearea.SafeArea$SafeAreaMode$", {
  Lscommons_reactnative_safearea_SafeArea$SafeAreaMode$: 1,
  O: 1
});
$c_Lscommons_reactnative_safearea_SafeArea$SafeAreaMode$.prototype.$classData = $d_Lscommons_reactnative_safearea_SafeArea$SafeAreaMode$;
var $n_Lscommons_reactnative_safearea_SafeArea$SafeAreaMode$;
function $m_Lscommons_reactnative_safearea_SafeArea$SafeAreaMode$() {
  if ((!$n_Lscommons_reactnative_safearea_SafeArea$SafeAreaMode$)) {
    $n_Lscommons_reactnative_safearea_SafeArea$SafeAreaMode$ = new $c_Lscommons_reactnative_safearea_SafeArea$SafeAreaMode$()
  };
  return $n_Lscommons_reactnative_safearea_SafeArea$SafeAreaMode$
}
function $p_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes__edges$lzycompute__Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes$EdgesAttributeSpec($thiz) {
  if (((((1 & $thiz.Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes__f_edges = new $c_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes$EdgesAttributeSpec("edges");
    $thiz.Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes__f_bitmap$0 = (((1 | $thiz.Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes__f_edges
}
function $p_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes__mode$lzycompute__Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes$ModeAttributeSpec($thiz) {
  if (((((2 & $thiz.Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes__f_mode = new $c_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes$ModeAttributeSpec("mode");
    $thiz.Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes__f_bitmap$0 = (((2 | $thiz.Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes__f_mode
}
/** @constructor */
function $c_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes(attributes) {
  this.Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes__f_edges = null;
  this.Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes__f_mode = null;
  this.Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes__f_bitmap$0 = 0
}
$c_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes.prototype = new $h_O();
$c_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes.prototype.constructor = $c_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes;
/** @constructor */
function $h_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes() {
  /*<skip>*/
}
$h_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes.prototype = $c_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes.prototype;
$c_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes.prototype.edges__Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes$EdgesAttributeSpec = (function() {
  return (((((1 & this.Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes__edges$lzycompute__Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes$EdgesAttributeSpec(this) : this.Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes__f_edges)
});
$c_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes.prototype.mode__Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes$ModeAttributeSpec = (function() {
  return (((((2 & this.Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes__mode$lzycompute__Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes$ModeAttributeSpec(this) : this.Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes__f_mode)
});
var $d_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes = new $TypeData().initClass({
  Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes: 0
}, false, "scommons.reactnative.safearea.package$SafeAreaVirtualDOMAttributes", {
  Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes: 1,
  O: 1
});
$c_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes.prototype.$classData = $d_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes;
function $p_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMElements__SafeAreaProvider$lzycompute__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($thiz) {
  if (((((1 & $thiz.Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMElements__f_bitmap$0) << 24) >> 24) === 0)) {
    var reactClass = $m_Lscommons_reactnative_safearea_package$().native__Lscommons_reactnative_safearea_raw_SafeArea().SafeAreaProvider;
    $thiz.Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMElements__f_SafeAreaProvider = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass);
    $thiz.Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMElements__f_bitmap$0 = (((1 | $thiz.Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMElements__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMElements__f_SafeAreaProvider
}
function $p_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMElements__SafeAreaView$lzycompute__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($thiz) {
  if (((((2 & $thiz.Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMElements__f_bitmap$0) << 24) >> 24) === 0)) {
    var reactClass = $m_Lscommons_reactnative_safearea_package$().native__Lscommons_reactnative_safearea_raw_SafeArea().SafeAreaView;
    $thiz.Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMElements__f_SafeAreaView = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass);
    $thiz.Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMElements__f_bitmap$0 = (((2 | $thiz.Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMElements__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMElements__f_SafeAreaView
}
/** @constructor */
function $c_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMElements(elements) {
  this.Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMElements__f_SafeAreaProvider = null;
  this.Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMElements__f_SafeAreaView = null;
  this.Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMElements__f_elements = null;
  this.Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMElements__f_bitmap$0 = 0;
  this.Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMElements__f_elements = elements
}
$c_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMElements.prototype = new $h_O();
$c_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMElements.prototype.constructor = $c_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMElements;
/** @constructor */
function $h_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMElements() {
  /*<skip>*/
}
$h_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMElements.prototype = $c_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMElements.prototype;
$c_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMElements.prototype.SafeAreaProvider__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec = (function() {
  return (((((1 & this.Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMElements__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMElements__SafeAreaProvider$lzycompute__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec(this) : this.Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMElements__f_SafeAreaProvider)
});
$c_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMElements.prototype.SafeAreaView__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec = (function() {
  return (((((2 & this.Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMElements__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMElements__SafeAreaView$lzycompute__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec(this) : this.Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMElements__f_SafeAreaView)
});
var $d_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMElements = new $TypeData().initClass({
  Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMElements: 0
}, false, "scommons.reactnative.safearea.package$SafeAreaVirtualDOMElements", {
  Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMElements: 1,
  O: 1
});
$c_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMElements.prototype.$classData = $d_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMElements;
function $p_Lscommons_reactnative_svg_package$SvgVirtualDOMAttributes__xml$lzycompute__Lio_github_shogowada_statictags_StringAttributeSpec($thiz) {
  if ((!$thiz.Lscommons_reactnative_svg_package$SvgVirtualDOMAttributes__f_bitmap$0)) {
    $thiz.Lscommons_reactnative_svg_package$SvgVirtualDOMAttributes__f_xml = new $c_Lio_github_shogowada_statictags_StringAttributeSpec("xml");
    $thiz.Lscommons_reactnative_svg_package$SvgVirtualDOMAttributes__f_bitmap$0 = true
  };
  return $thiz.Lscommons_reactnative_svg_package$SvgVirtualDOMAttributes__f_xml
}
/** @constructor */
function $c_Lscommons_reactnative_svg_package$SvgVirtualDOMAttributes(attributes) {
  this.Lscommons_reactnative_svg_package$SvgVirtualDOMAttributes__f_xml = null;
  this.Lscommons_reactnative_svg_package$SvgVirtualDOMAttributes__f_bitmap$0 = false
}
$c_Lscommons_reactnative_svg_package$SvgVirtualDOMAttributes.prototype = new $h_O();
$c_Lscommons_reactnative_svg_package$SvgVirtualDOMAttributes.prototype.constructor = $c_Lscommons_reactnative_svg_package$SvgVirtualDOMAttributes;
/** @constructor */
function $h_Lscommons_reactnative_svg_package$SvgVirtualDOMAttributes() {
  /*<skip>*/
}
$h_Lscommons_reactnative_svg_package$SvgVirtualDOMAttributes.prototype = $c_Lscommons_reactnative_svg_package$SvgVirtualDOMAttributes.prototype;
$c_Lscommons_reactnative_svg_package$SvgVirtualDOMAttributes.prototype.xml__Lio_github_shogowada_statictags_StringAttributeSpec = (function() {
  return ((!this.Lscommons_reactnative_svg_package$SvgVirtualDOMAttributes__f_bitmap$0) ? $p_Lscommons_reactnative_svg_package$SvgVirtualDOMAttributes__xml$lzycompute__Lio_github_shogowada_statictags_StringAttributeSpec(this) : this.Lscommons_reactnative_svg_package$SvgVirtualDOMAttributes__f_xml)
});
var $d_Lscommons_reactnative_svg_package$SvgVirtualDOMAttributes = new $TypeData().initClass({
  Lscommons_reactnative_svg_package$SvgVirtualDOMAttributes: 0
}, false, "scommons.reactnative.svg.package$SvgVirtualDOMAttributes", {
  Lscommons_reactnative_svg_package$SvgVirtualDOMAttributes: 1,
  O: 1
});
$c_Lscommons_reactnative_svg_package$SvgVirtualDOMAttributes.prototype.$classData = $d_Lscommons_reactnative_svg_package$SvgVirtualDOMAttributes;
function $p_Lscommons_reactnative_svg_package$SvgVirtualDOMElements__SvgXml$lzycompute__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($thiz) {
  if (((((1 & $thiz.Lscommons_reactnative_svg_package$SvgVirtualDOMElements__f_bitmap$0) << 24) >> 24) === 0)) {
    var reactClass = $i_react$002dnative$002dsvg.SvgXml;
    $thiz.Lscommons_reactnative_svg_package$SvgVirtualDOMElements__f_SvgXml = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass);
    $thiz.Lscommons_reactnative_svg_package$SvgVirtualDOMElements__f_bitmap$0 = (((1 | $thiz.Lscommons_reactnative_svg_package$SvgVirtualDOMElements__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lscommons_reactnative_svg_package$SvgVirtualDOMElements__f_SvgXml
}
function $p_Lscommons_reactnative_svg_package$SvgVirtualDOMElements__SvgCss$lzycompute__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($thiz) {
  if (((((2 & $thiz.Lscommons_reactnative_svg_package$SvgVirtualDOMElements__f_bitmap$0) << 24) >> 24) === 0)) {
    var reactClass = $i_react$002dnative$002dsvg.SvgCss;
    $thiz.Lscommons_reactnative_svg_package$SvgVirtualDOMElements__f_SvgCss = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass);
    $thiz.Lscommons_reactnative_svg_package$SvgVirtualDOMElements__f_bitmap$0 = (((2 | $thiz.Lscommons_reactnative_svg_package$SvgVirtualDOMElements__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lscommons_reactnative_svg_package$SvgVirtualDOMElements__f_SvgCss
}
/** @constructor */
function $c_Lscommons_reactnative_svg_package$SvgVirtualDOMElements(elements) {
  this.Lscommons_reactnative_svg_package$SvgVirtualDOMElements__f_SvgXml = null;
  this.Lscommons_reactnative_svg_package$SvgVirtualDOMElements__f_SvgCss = null;
  this.Lscommons_reactnative_svg_package$SvgVirtualDOMElements__f_elements = null;
  this.Lscommons_reactnative_svg_package$SvgVirtualDOMElements__f_bitmap$0 = 0;
  this.Lscommons_reactnative_svg_package$SvgVirtualDOMElements__f_elements = elements
}
$c_Lscommons_reactnative_svg_package$SvgVirtualDOMElements.prototype = new $h_O();
$c_Lscommons_reactnative_svg_package$SvgVirtualDOMElements.prototype.constructor = $c_Lscommons_reactnative_svg_package$SvgVirtualDOMElements;
/** @constructor */
function $h_Lscommons_reactnative_svg_package$SvgVirtualDOMElements() {
  /*<skip>*/
}
$h_Lscommons_reactnative_svg_package$SvgVirtualDOMElements.prototype = $c_Lscommons_reactnative_svg_package$SvgVirtualDOMElements.prototype;
$c_Lscommons_reactnative_svg_package$SvgVirtualDOMElements.prototype.SvgXml__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec = (function() {
  return (((((1 & this.Lscommons_reactnative_svg_package$SvgVirtualDOMElements__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lscommons_reactnative_svg_package$SvgVirtualDOMElements__SvgXml$lzycompute__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec(this) : this.Lscommons_reactnative_svg_package$SvgVirtualDOMElements__f_SvgXml)
});
$c_Lscommons_reactnative_svg_package$SvgVirtualDOMElements.prototype.SvgCss__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec = (function() {
  return (((((2 & this.Lscommons_reactnative_svg_package$SvgVirtualDOMElements__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lscommons_reactnative_svg_package$SvgVirtualDOMElements__SvgCss$lzycompute__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec(this) : this.Lscommons_reactnative_svg_package$SvgVirtualDOMElements__f_SvgCss)
});
var $d_Lscommons_reactnative_svg_package$SvgVirtualDOMElements = new $TypeData().initClass({
  Lscommons_reactnative_svg_package$SvgVirtualDOMElements: 0
}, false, "scommons.reactnative.svg.package$SvgVirtualDOMElements", {
  Lscommons_reactnative_svg_package$SvgVirtualDOMElements: 1,
  O: 1
});
$c_Lscommons_reactnative_svg_package$SvgVirtualDOMElements.prototype.$classData = $d_Lscommons_reactnative_svg_package$SvgVirtualDOMElements;
function $p_Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes__htmlSource$lzycompute__Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes$HtmlSourceAttribute($thiz) {
  if (((((1 & $thiz.Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes__f_htmlSource = new $c_Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes$HtmlSourceAttribute("source");
    $thiz.Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes__f_bitmap$0 = (((1 | $thiz.Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes__f_htmlSource
}
function $p_Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes__originWhiteList$lzycompute__Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes$OriginWhiteListAttribute($thiz) {
  if (((((2 & $thiz.Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes__f_originWhiteList = new $c_Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes$OriginWhiteListAttribute("originWhiteList");
    $thiz.Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes__f_bitmap$0 = (((2 | $thiz.Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes__f_originWhiteList
}
/** @constructor */
function $c_Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes(attributes) {
  this.Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes__f_htmlSource = null;
  this.Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes__f_originWhiteList = null;
  this.Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes__f_bitmap$0 = 0
}
$c_Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes.prototype = new $h_O();
$c_Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes.prototype.constructor = $c_Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes;
/** @constructor */
function $h_Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes() {
  /*<skip>*/
}
$h_Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes.prototype = $c_Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes.prototype;
$c_Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes.prototype.htmlSource__Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes$HtmlSourceAttribute = (function() {
  return (((((1 & this.Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes__htmlSource$lzycompute__Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes$HtmlSourceAttribute(this) : this.Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes__f_htmlSource)
});
$c_Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes.prototype.originWhiteList__Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes$OriginWhiteListAttribute = (function() {
  return (((((2 & this.Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes__originWhiteList$lzycompute__Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes$OriginWhiteListAttribute(this) : this.Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes__f_originWhiteList)
});
var $d_Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes = new $TypeData().initClass({
  Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes: 0
}, false, "scommons.reactnative.webview.package$WebViewVirtualDOMAttributes", {
  Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes: 1,
  O: 1
});
$c_Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes.prototype.$classData = $d_Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes;
function $p_Lscommons_reactnative_webview_package$WebViewVirtualDOMElements__WebView$lzycompute__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($thiz) {
  if ((!$thiz.Lscommons_reactnative_webview_package$WebViewVirtualDOMElements__f_bitmap$0)) {
    var reactClass = $i_react$002dnative$002dwebview.WebView;
    $thiz.Lscommons_reactnative_webview_package$WebViewVirtualDOMElements__f_WebView = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass);
    $thiz.Lscommons_reactnative_webview_package$WebViewVirtualDOMElements__f_bitmap$0 = true
  };
  $thiz.Lscommons_reactnative_webview_package$WebViewVirtualDOMElements__f_elements = null;
  return $thiz.Lscommons_reactnative_webview_package$WebViewVirtualDOMElements__f_WebView
}
/** @constructor */
function $c_Lscommons_reactnative_webview_package$WebViewVirtualDOMElements(elements) {
  this.Lscommons_reactnative_webview_package$WebViewVirtualDOMElements__f_WebView = null;
  this.Lscommons_reactnative_webview_package$WebViewVirtualDOMElements__f_elements = null;
  this.Lscommons_reactnative_webview_package$WebViewVirtualDOMElements__f_bitmap$0 = false;
  this.Lscommons_reactnative_webview_package$WebViewVirtualDOMElements__f_elements = elements
}
$c_Lscommons_reactnative_webview_package$WebViewVirtualDOMElements.prototype = new $h_O();
$c_Lscommons_reactnative_webview_package$WebViewVirtualDOMElements.prototype.constructor = $c_Lscommons_reactnative_webview_package$WebViewVirtualDOMElements;
/** @constructor */
function $h_Lscommons_reactnative_webview_package$WebViewVirtualDOMElements() {
  /*<skip>*/
}
$h_Lscommons_reactnative_webview_package$WebViewVirtualDOMElements.prototype = $c_Lscommons_reactnative_webview_package$WebViewVirtualDOMElements.prototype;
$c_Lscommons_reactnative_webview_package$WebViewVirtualDOMElements.prototype.WebView__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec = (function() {
  return ((!this.Lscommons_reactnative_webview_package$WebViewVirtualDOMElements__f_bitmap$0) ? $p_Lscommons_reactnative_webview_package$WebViewVirtualDOMElements__WebView$lzycompute__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec(this) : this.Lscommons_reactnative_webview_package$WebViewVirtualDOMElements__f_WebView)
});
var $d_Lscommons_reactnative_webview_package$WebViewVirtualDOMElements = new $TypeData().initClass({
  Lscommons_reactnative_webview_package$WebViewVirtualDOMElements: 0
}, false, "scommons.reactnative.webview.package$WebViewVirtualDOMElements", {
  Lscommons_reactnative_webview_package$WebViewVirtualDOMElements: 1,
  O: 1
});
$c_Lscommons_reactnative_webview_package$WebViewVirtualDOMElements.prototype.$classData = $d_Lscommons_reactnative_webview_package$WebViewVirtualDOMElements;
/** @constructor */
function $c_Lscommons_websql_Database(db) {
  this.Lscommons_websql_Database__f_db = null;
  this.Lscommons_websql_Database__f_db = db
}
$c_Lscommons_websql_Database.prototype = new $h_O();
$c_Lscommons_websql_Database.prototype.constructor = $c_Lscommons_websql_Database;
/** @constructor */
function $h_Lscommons_websql_Database() {
  /*<skip>*/
}
$h_Lscommons_websql_Database.prototype = $c_Lscommons_websql_Database.prototype;
$c_Lscommons_websql_Database.prototype.transaction__F1__s_concurrent_Future = (function(callback) {
  var p = $ct_s_concurrent_impl_Promise$DefaultPromise__(new $c_s_concurrent_impl_Promise$DefaultPromise());
  this.Lscommons_websql_Database__f_db.transaction((function(arg$outer, callback$1) {
    return (function(arg1$2) {
      arg$outer.scommons$websql$Database$$$anonfun$transaction$1__Lscommons_websql_raw_WebSQLTransaction__F1__V(arg1$2, callback$1)
    })
  })(this, callback), (function(arg$outer$1, p$1) {
    return (function(arg1$2$1) {
      arg$outer$1.scommons$websql$Database$$$anonfun$transaction$3__sjs_js_Error__s_concurrent_Promise__V(arg1$2$1, p$1)
    })
  })(this, p), (function(arg$outer$2, p$1$1) {
    return (function() {
      $f_s_concurrent_Promise__success__O__s_concurrent_Promise(p$1$1, (void 0))
    })
  })(this, p));
  return p
});
$c_Lscommons_websql_Database.prototype.scommons$websql$Database$$$anonfun$transaction$1__Lscommons_websql_raw_WebSQLTransaction__F1__V = (function(tx, callback$1) {
  callback$1.apply__O__O(new $c_Lscommons_websql_Transaction(tx))
});
$c_Lscommons_websql_Database.prototype.scommons$websql$Database$$$anonfun$transaction$3__sjs_js_Error__s_concurrent_Promise__V = (function(error, p$1) {
  var cause = new $c_sjs_js_JavaScriptException(error);
  $f_s_concurrent_Promise__failure__jl_Throwable__s_concurrent_Promise(p$1, cause)
});
function $as_Lscommons_websql_Database(obj) {
  return (((obj instanceof $c_Lscommons_websql_Database) || (obj === null)) ? obj : $throwClassCastException(obj, "scommons.websql.Database"))
}
function $isArrayOf_Lscommons_websql_Database(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscommons_websql_Database)))
}
function $asArrayOf_Lscommons_websql_Database(obj, depth) {
  return (($isArrayOf_Lscommons_websql_Database(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscommons.websql.Database;", depth))
}
var $d_Lscommons_websql_Database = new $TypeData().initClass({
  Lscommons_websql_Database: 0
}, false, "scommons.websql.Database", {
  Lscommons_websql_Database: 1,
  O: 1
});
$c_Lscommons_websql_Database.prototype.$classData = $d_Lscommons_websql_Database;
function $p_Lscommons_websql_ResultSet__rows$lzycompute__sci_Seq($thiz) {
  if (((((4 & $thiz.Lscommons_websql_ResultSet__f_bitmap$0) << 24) >> 24) === 0)) {
    var value = $thiz.Lscommons_websql_ResultSet__f_underlying.rows;
    if ((value === (void 0))) {
      var value$1 = (void 0)
    } else {
      var array = value._array;
      var a = $m_sci_IndexedSeq$().from__sc_IterableOnce__sci_IndexedSeq($ct_sjs_js_WrappedArray__sjs_js_Array__(new $c_sjs_js_WrappedArray(), array));
      var value$1 = a
    };
    $thiz.Lscommons_websql_ResultSet__f_rows = $as_sci_Seq(((value$1 === (void 0)) ? $as_sci_Seq($m_s_package$().s_package$__f_Seq.empty__sc_SeqOps()) : value$1));
    $thiz.Lscommons_websql_ResultSet__f_bitmap$0 = (((4 | $thiz.Lscommons_websql_ResultSet__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lscommons_websql_ResultSet__f_rows
}
/** @constructor */
function $c_Lscommons_websql_ResultSet(underlying) {
  this.Lscommons_websql_ResultSet__f_insertId = null;
  this.Lscommons_websql_ResultSet__f_rowsAffected = $L0;
  this.Lscommons_websql_ResultSet__f_rows = null;
  this.Lscommons_websql_ResultSet__f_underlying = null;
  this.Lscommons_websql_ResultSet__f_bitmap$0 = 0;
  this.Lscommons_websql_ResultSet__f_underlying = underlying
}
$c_Lscommons_websql_ResultSet.prototype = new $h_O();
$c_Lscommons_websql_ResultSet.prototype.constructor = $c_Lscommons_websql_ResultSet;
/** @constructor */
function $h_Lscommons_websql_ResultSet() {
  /*<skip>*/
}
$h_Lscommons_websql_ResultSet.prototype = $c_Lscommons_websql_ResultSet.prototype;
$c_Lscommons_websql_ResultSet.prototype.rows__sci_Seq = (function() {
  return (((((4 & this.Lscommons_websql_ResultSet__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lscommons_websql_ResultSet__rows$lzycompute__sci_Seq(this) : this.Lscommons_websql_ResultSet__f_rows)
});
function $as_Lscommons_websql_ResultSet(obj) {
  return (((obj instanceof $c_Lscommons_websql_ResultSet) || (obj === null)) ? obj : $throwClassCastException(obj, "scommons.websql.ResultSet"))
}
function $isArrayOf_Lscommons_websql_ResultSet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscommons_websql_ResultSet)))
}
function $asArrayOf_Lscommons_websql_ResultSet(obj, depth) {
  return (($isArrayOf_Lscommons_websql_ResultSet(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscommons.websql.ResultSet;", depth))
}
var $d_Lscommons_websql_ResultSet = new $TypeData().initClass({
  Lscommons_websql_ResultSet: 0
}, false, "scommons.websql.ResultSet", {
  Lscommons_websql_ResultSet: 1,
  O: 1
});
$c_Lscommons_websql_ResultSet.prototype.$classData = $d_Lscommons_websql_ResultSet;
/** @constructor */
function $c_Lscommons_websql_Transaction(underlying) {
  this.Lscommons_websql_Transaction__f_underlying = null;
  this.Lscommons_websql_Transaction__f_underlying = underlying
}
$c_Lscommons_websql_Transaction.prototype = new $h_O();
$c_Lscommons_websql_Transaction.prototype.constructor = $c_Lscommons_websql_Transaction;
/** @constructor */
function $h_Lscommons_websql_Transaction() {
  /*<skip>*/
}
$h_Lscommons_websql_Transaction.prototype = $c_Lscommons_websql_Transaction.prototype;
$c_Lscommons_websql_Transaction.prototype.executeSql__T__sci_Seq__F2__F2__V = (function(sqlStatement, arguments$1, success, error) {
  var successFn = ((success === null) ? null : (function(arg$outer, success$1) {
    return (function(arg1$2, arg2$2) {
      arg$outer.scommons$websql$Transaction$$$anonfun$executeSql$1__Lscommons_websql_raw_WebSQLTransaction__Lscommons_websql_raw_WebSQLResultSet__F2__V(arg1$2, arg2$2, success$1)
    })
  })(this, success));
  var errorFn = ((error === null) ? null : (function(arg$outer$1, error$1) {
    return (function(arg1$2$1, arg2$2$1) {
      return $uZ(error$1.apply__O__O__O(arg$outer$1, arg2$2$1))
    })
  })(this, error));
  var $$x2 = this.Lscommons_websql_Transaction__f_underlying;
  var $$x1 = $m_sjsr_Compat$().toJSVarArgsImpl__sci_Seq__sjs_js_Array(arguments$1);
  $$x2.executeSql(sqlStatement, $$x1, successFn, errorFn)
});
$c_Lscommons_websql_Transaction.prototype.scommons$websql$Transaction$$$anonfun$executeSql$1__Lscommons_websql_raw_WebSQLTransaction__Lscommons_websql_raw_WebSQLResultSet__F2__V = (function(x$1, resultSet, success$1) {
  success$1.apply__O__O__O(this, new $c_Lscommons_websql_ResultSet(resultSet))
});
function $as_Lscommons_websql_Transaction(obj) {
  return (((obj instanceof $c_Lscommons_websql_Transaction) || (obj === null)) ? obj : $throwClassCastException(obj, "scommons.websql.Transaction"))
}
function $isArrayOf_Lscommons_websql_Transaction(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscommons_websql_Transaction)))
}
function $asArrayOf_Lscommons_websql_Transaction(obj, depth) {
  return (($isArrayOf_Lscommons_websql_Transaction(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscommons.websql.Transaction;", depth))
}
var $d_Lscommons_websql_Transaction = new $TypeData().initClass({
  Lscommons_websql_Transaction: 0
}, false, "scommons.websql.Transaction", {
  Lscommons_websql_Transaction: 1,
  O: 1
});
$c_Lscommons_websql_Transaction.prototype.$classData = $d_Lscommons_websql_Transaction;
function $ps_Lshowcase_PlatformDemo$Styles$$anon$2__$anonfun$fontFamily$1__Lshowcase_PlatformDemo$Styles$$anon$2__Lscommons_reactnative_Platform__sjs_js_$bar(this$1, x0$1) {
  var x = $m_Lscommons_reactnative_Platform$ios$();
  if ((x === x0$1)) {
    var $$x1 = true
  } else {
    var x$3 = $m_Lscommons_reactnative_Platform$web$();
    var $$x1 = (x$3 === x0$1)
  };
  if ($$x1) {
    return "American Typewriter"
  } else {
    var x$5 = $m_Lscommons_reactnative_Platform$android$();
    if ((x$5 === x0$1)) {
      return "monospace"
    } else {
      throw new $c_s_MatchError(x0$1)
    }
  }
}
function $f_Lshowcase_api_task_DemoTaskApi__timedoutExample__s_concurrent_Future($thiz) {
  var promise = $ct_s_concurrent_impl_Promise$DefaultPromise__(new $c_s_concurrent_impl_Promise$DefaultPromise());
  var handleId = new $c_sr_ObjectRef(null);
  var $$x3 = setTimeout;
  var $$x2 = $m_sjs_js_Any$().fromFunction0__F0__sjs_js_Function0(new $c_sjsr_AnonFunction0((function(this$3, handleId$1, promise$1) {
    return (function() {
      clearTimeout(handleId$1.sr_ObjectRef__f_elem);
      var cause = $ct_jl_Exception__T__(new $c_jl_Exception(), "Request timed out, unable to get timely response");
      return $f_s_concurrent_Promise__failure__jl_Throwable__s_concurrent_Promise(promise$1, cause)
    })
  })($thiz, handleId, promise)));
  var this$5 = new $c_s_concurrent_duration_package$DurationInt(2);
  var unit = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_SECONDS;
  var this$ = this$5.s_concurrent_duration_package$DurationInt__f_scala$concurrent$duration$DurationInt$$n;
  $m_s_concurrent_duration_Duration$();
  var hi = (this$ >> 31);
  var this$9 = new $c_s_concurrent_duration_FiniteDuration(new $c_RTLong(this$, hi), unit);
  var this$10 = this$9.s_concurrent_duration_FiniteDuration__f_unit.toMillis__J__J(this$9.s_concurrent_duration_FiniteDuration__f_length);
  var value = $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toDouble__I__I__D(this$10.RTLong__f_lo, this$10.RTLong__f_hi);
  var $$x1 = $$x3($$x2, value);
  handleId.sr_ObjectRef__f_elem = $$x1;
  return promise
}
function $f_Lshowcase_api_task_DemoTaskApi__failedExample__s_concurrent_Future($thiz) {
  return $m_s_concurrent_Future$().successful__O__s_concurrent_Future(new $c_Lscommons_api_StatusResponse($m_Lscommons_api_ApiStatus$().apply__I__T__T__Lscommons_api_ApiStatus(500, "Internal Server Error", "Some error occurred, try again later)")))
}
/** @constructor */
function $c_Lshowcase_app_ShowcaseFonts$() {
  /*<skip>*/
}
$c_Lshowcase_app_ShowcaseFonts$.prototype = new $h_O();
$c_Lshowcase_app_ShowcaseFonts$.prototype.constructor = $c_Lshowcase_app_ShowcaseFonts$;
/** @constructor */
function $h_Lshowcase_app_ShowcaseFonts$() {
  /*<skip>*/
}
$h_Lshowcase_app_ShowcaseFonts$.prototype = $c_Lshowcase_app_ShowcaseFonts$.prototype;
$c_Lshowcase_app_ShowcaseFonts$.prototype.fontsToPreload__sci_Seq = (function() {
  var $$x1 = $m_s_package$().s_package$__f_Seq;
  var self = $m_Lshowcase_app_ShowcaseFonts$MontserratBlack$().Lshowcase_app_ShowcaseFonts$MontserratBlack$__f_name;
  var y = $i_$002e$002fshowcase$002fapp$002fMontserrat$002dBlack$002ettf;
  var array = [new $c_T2(self, y)];
  return $as_sci_Seq($$x1.apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)))
});
var $d_Lshowcase_app_ShowcaseFonts$ = new $TypeData().initClass({
  Lshowcase_app_ShowcaseFonts$: 0
}, false, "showcase.app.ShowcaseFonts$", {
  Lshowcase_app_ShowcaseFonts$: 1,
  O: 1
});
$c_Lshowcase_app_ShowcaseFonts$.prototype.$classData = $d_Lshowcase_app_ShowcaseFonts$;
var $n_Lshowcase_app_ShowcaseFonts$;
function $m_Lshowcase_app_ShowcaseFonts$() {
  if ((!$n_Lshowcase_app_ShowcaseFonts$)) {
    $n_Lshowcase_app_ShowcaseFonts$ = new $c_Lshowcase_app_ShowcaseFonts$()
  };
  return $n_Lshowcase_app_ShowcaseFonts$
}
/** @constructor */
function $c_Lshowcase_app_ShowcaseFonts$MontserratBlack$() {
  this.Lshowcase_app_ShowcaseFonts$MontserratBlack$__f_name = null;
  this.Lshowcase_app_ShowcaseFonts$MontserratBlack$__f_name = "Montserrat-Black"
}
$c_Lshowcase_app_ShowcaseFonts$MontserratBlack$.prototype = new $h_O();
$c_Lshowcase_app_ShowcaseFonts$MontserratBlack$.prototype.constructor = $c_Lshowcase_app_ShowcaseFonts$MontserratBlack$;
/** @constructor */
function $h_Lshowcase_app_ShowcaseFonts$MontserratBlack$() {
  /*<skip>*/
}
$h_Lshowcase_app_ShowcaseFonts$MontserratBlack$.prototype = $c_Lshowcase_app_ShowcaseFonts$MontserratBlack$.prototype;
var $d_Lshowcase_app_ShowcaseFonts$MontserratBlack$ = new $TypeData().initClass({
  Lshowcase_app_ShowcaseFonts$MontserratBlack$: 0
}, false, "showcase.app.ShowcaseFonts$MontserratBlack$", {
  Lshowcase_app_ShowcaseFonts$MontserratBlack$: 1,
  O: 1
});
$c_Lshowcase_app_ShowcaseFonts$MontserratBlack$.prototype.$classData = $d_Lshowcase_app_ShowcaseFonts$MontserratBlack$;
var $n_Lshowcase_app_ShowcaseFonts$MontserratBlack$;
function $m_Lshowcase_app_ShowcaseFonts$MontserratBlack$() {
  if ((!$n_Lshowcase_app_ShowcaseFonts$MontserratBlack$)) {
    $n_Lshowcase_app_ShowcaseFonts$MontserratBlack$ = new $c_Lshowcase_app_ShowcaseFonts$MontserratBlack$()
  };
  return $n_Lshowcase_app_ShowcaseFonts$MontserratBlack$
}
/** @constructor */
function $c_Lshowcase_app_ShowcaseIcons$() {
  this.Lshowcase_app_ShowcaseIcons$__f_FontAwesome5 = null;
  this.Lshowcase_app_ShowcaseIcons$__f_Ionicons = null;
  $n_Lshowcase_app_ShowcaseIcons$ = this;
  this.Lshowcase_app_ShowcaseIcons$__f_FontAwesome5 = $m_Lscommons_expo_package$().VectorIcons__Lscommons_expo_raw_VectorIcons$().FontAwesome5;
  this.Lshowcase_app_ShowcaseIcons$__f_Ionicons = $m_Lscommons_expo_package$().VectorIcons__Lscommons_expo_raw_VectorIcons$().Ionicons
}
$c_Lshowcase_app_ShowcaseIcons$.prototype = new $h_O();
$c_Lshowcase_app_ShowcaseIcons$.prototype.constructor = $c_Lshowcase_app_ShowcaseIcons$;
/** @constructor */
function $h_Lshowcase_app_ShowcaseIcons$() {
  /*<skip>*/
}
$h_Lshowcase_app_ShowcaseIcons$.prototype = $c_Lshowcase_app_ShowcaseIcons$.prototype;
$c_Lshowcase_app_ShowcaseIcons$.prototype.iconsToPreload__sci_Seq = (function() {
  var dict = this.Lshowcase_app_ShowcaseIcons$__f_FontAwesome5.font;
  var this$2 = new $c_sjs_js_WrappedDictionary(dict);
  var this$5 = $m_sci_Seq$().from__sc_IterableOnce__sci_Seq(this$2);
  var dict$1 = this.Lshowcase_app_ShowcaseIcons$__f_Ionicons.font;
  var this$4 = new $c_sjs_js_WrappedDictionary(dict$1);
  var suffix = $m_sci_Seq$().from__sc_IterableOnce__sci_Seq(this$4);
  return $as_sci_Seq(this$5.appendedAll__sc_IterableOnce__O(suffix))
});
var $d_Lshowcase_app_ShowcaseIcons$ = new $TypeData().initClass({
  Lshowcase_app_ShowcaseIcons$: 0
}, false, "showcase.app.ShowcaseIcons$", {
  Lshowcase_app_ShowcaseIcons$: 1,
  O: 1
});
$c_Lshowcase_app_ShowcaseIcons$.prototype.$classData = $d_Lshowcase_app_ShowcaseIcons$;
var $n_Lshowcase_app_ShowcaseIcons$;
function $m_Lshowcase_app_ShowcaseIcons$() {
  if ((!$n_Lshowcase_app_ShowcaseIcons$)) {
    $n_Lshowcase_app_ShowcaseIcons$ = new $c_Lshowcase_app_ShowcaseIcons$()
  };
  return $n_Lshowcase_app_ShowcaseIcons$
}
/** @constructor */
function $c_Lshowcase_app_ShowcaseImages$() {
  /*<skip>*/
}
$c_Lshowcase_app_ShowcaseImages$.prototype = new $h_O();
$c_Lshowcase_app_ShowcaseImages$.prototype.constructor = $c_Lshowcase_app_ShowcaseImages$;
/** @constructor */
function $h_Lshowcase_app_ShowcaseImages$() {
  /*<skip>*/
}
$h_Lshowcase_app_ShowcaseImages$.prototype = $c_Lshowcase_app_ShowcaseImages$.prototype;
$c_Lshowcase_app_ShowcaseImages$.prototype.imagesToPreload__sci_Seq = (function() {
  var $$x1 = $m_s_package$().s_package$__f_Seq;
  var array = [$i_$002e$002fshowcase$002fapp$002fuser$002epng, $i_$002e$002fshowcase$002fapp$002fexpo$002epng];
  return $as_sci_Seq($$x1.apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)))
});
var $d_Lshowcase_app_ShowcaseImages$ = new $TypeData().initClass({
  Lshowcase_app_ShowcaseImages$: 0
}, false, "showcase.app.ShowcaseImages$", {
  Lshowcase_app_ShowcaseImages$: 1,
  O: 1
});
$c_Lshowcase_app_ShowcaseImages$.prototype.$classData = $d_Lshowcase_app_ShowcaseImages$;
var $n_Lshowcase_app_ShowcaseImages$;
function $m_Lshowcase_app_ShowcaseImages$() {
  if ((!$n_Lshowcase_app_ShowcaseImages$)) {
    $n_Lshowcase_app_ShowcaseImages$ = new $c_Lshowcase_app_ShowcaseImages$()
  };
  return $n_Lshowcase_app_ShowcaseImages$
}
/** @constructor */
function $c_Lshowcase_app_ShowcaseImages$Expo$() {
  this.Lshowcase_app_ShowcaseImages$Expo$__f_asset = null;
  $n_Lshowcase_app_ShowcaseImages$Expo$ = this;
  this.Lshowcase_app_ShowcaseImages$Expo$__f_asset = $m_Lscommons_expo_Asset$().fromModule__Lscommons_reactnative_raw_StaticResource__Lscommons_expo_raw_Asset($i_$002e$002fshowcase$002fapp$002fexpo$002epng)
}
$c_Lshowcase_app_ShowcaseImages$Expo$.prototype = new $h_O();
$c_Lshowcase_app_ShowcaseImages$Expo$.prototype.constructor = $c_Lshowcase_app_ShowcaseImages$Expo$;
/** @constructor */
function $h_Lshowcase_app_ShowcaseImages$Expo$() {
  /*<skip>*/
}
$h_Lshowcase_app_ShowcaseImages$Expo$.prototype = $c_Lshowcase_app_ShowcaseImages$Expo$.prototype;
var $d_Lshowcase_app_ShowcaseImages$Expo$ = new $TypeData().initClass({
  Lshowcase_app_ShowcaseImages$Expo$: 0
}, false, "showcase.app.ShowcaseImages$Expo$", {
  Lshowcase_app_ShowcaseImages$Expo$: 1,
  O: 1
});
$c_Lshowcase_app_ShowcaseImages$Expo$.prototype.$classData = $d_Lshowcase_app_ShowcaseImages$Expo$;
var $n_Lshowcase_app_ShowcaseImages$Expo$;
function $m_Lshowcase_app_ShowcaseImages$Expo$() {
  if ((!$n_Lshowcase_app_ShowcaseImages$Expo$)) {
    $n_Lshowcase_app_ShowcaseImages$Expo$ = new $c_Lshowcase_app_ShowcaseImages$Expo$()
  };
  return $n_Lshowcase_app_ShowcaseImages$Expo$
}
function $s_Lshowcase_app_ShowcaseRoot$$anon$2$$anon$4__showcase$app$ShowcaseRoot$$nestedInanon$2$$nestedInanon$4$$$anonfun$tabBarIcon$1__Lshowcase_app_ShowcaseRoot$$anon$2$$anon$4__Lscommons_react_navigation_tab_raw_TabBarIconParams__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement(this$1, params) {
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var reactClass = $m_Lshowcase_app_ShowcaseIcons$().Lshowcase_app_ShowcaseIcons$__f_FontAwesome5;
  var $$x3 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass);
  var this$3 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes().name__Lio_github_shogowada_statictags_StringAttributeSpec();
  var $$x2 = new $c_Lio_github_shogowada_statictags_Attribute(this$3.Lio_github_shogowada_statictags_StringAttributeSpec__f_name, "home", $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$());
  var attributes = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var $$x1 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes).rnSize__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeSizeAttributeSpec().$colon$eq__I__Lio_github_shogowada_statictags_Attribute($uI(params.size));
  var attributes$1 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var this$7 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$1).color__Lio_github_shogowada_statictags_StringAttributeSpec();
  var value = $as_T(params.color);
  var array = [$$x2, $$x1, new $c_Lio_github_shogowada_statictags_Attribute(this$7.Lio_github_shogowada_statictags_StringAttributeSpec__f_name, value, $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$())];
  return $$x3.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array), $m_sci_Nil$())
}
function $s_Lshowcase_app_ShowcaseRoot$$anon$2$$anon$5__showcase$app$ShowcaseRoot$$nestedInanon$2$$nestedInanon$5$$$anonfun$tabBarIcon$2__Lshowcase_app_ShowcaseRoot$$anon$2$$anon$5__Lscommons_react_navigation_tab_raw_TabBarIconParams__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement(this$1, params) {
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var reactClass = $m_Lshowcase_app_ShowcaseIcons$().Lshowcase_app_ShowcaseIcons$__f_FontAwesome5;
  var $$x3 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass);
  var this$3 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes().name__Lio_github_shogowada_statictags_StringAttributeSpec();
  var $$x2 = new $c_Lio_github_shogowada_statictags_Attribute(this$3.Lio_github_shogowada_statictags_StringAttributeSpec__f_name, "react", $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$());
  var attributes = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var $$x1 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes).rnSize__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeSizeAttributeSpec().$colon$eq__I__Lio_github_shogowada_statictags_Attribute($uI(params.size));
  var attributes$1 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var this$7 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$1).color__Lio_github_shogowada_statictags_StringAttributeSpec();
  var value = $as_T(params.color);
  var array = [$$x2, $$x1, new $c_Lio_github_shogowada_statictags_Attribute(this$7.Lio_github_shogowada_statictags_StringAttributeSpec__f_name, value, $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$())];
  return $$x3.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array), $m_sci_Nil$())
}
function $s_Lshowcase_app_ShowcaseRoot$$anon$2$$anon$6__showcase$app$ShowcaseRoot$$nestedInanon$2$$nestedInanon$6$$$anonfun$tabBarIcon$3__Lshowcase_app_ShowcaseRoot$$anon$2$$anon$6__Lscommons_react_navigation_tab_raw_TabBarIconParams__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement(this$1, params) {
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var reactClass = $m_Lshowcase_app_ShowcaseIcons$().Lshowcase_app_ShowcaseIcons$__f_FontAwesome5;
  var $$x3 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass);
  var this$3 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes().name__Lio_github_shogowada_statictags_StringAttributeSpec();
  var $$x2 = new $c_Lio_github_shogowada_statictags_Attribute(this$3.Lio_github_shogowada_statictags_StringAttributeSpec__f_name, "reacteurope", $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$());
  var attributes = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var $$x1 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes).rnSize__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeSizeAttributeSpec().$colon$eq__I__Lio_github_shogowada_statictags_Attribute($uI(params.size));
  var attributes$1 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var this$7 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$1).color__Lio_github_shogowada_statictags_StringAttributeSpec();
  var value = $as_T(params.color);
  var array = [$$x2, $$x1, new $c_Lio_github_shogowada_statictags_Attribute(this$7.Lio_github_shogowada_statictags_StringAttributeSpec__f_name, value, $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$())];
  return $$x3.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array), $m_sci_Nil$())
}
function $s_Lshowcase_app_ShowcaseRoot$$anon$2$$anon$7__showcase$app$ShowcaseRoot$$nestedInanon$2$$nestedInanon$7$$$anonfun$tabBarIcon$4__Lshowcase_app_ShowcaseRoot$$anon$2$$anon$7__Lscommons_react_navigation_tab_raw_TabBarIconParams__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement(this$1, params) {
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var reactClass = $m_Lshowcase_app_ShowcaseIcons$().Lshowcase_app_ShowcaseIcons$__f_Ionicons;
  var $$x3 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass);
  var this$3 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes().name__Lio_github_shogowada_statictags_StringAttributeSpec();
  var $$x2 = new $c_Lio_github_shogowada_statictags_Attribute(this$3.Lio_github_shogowada_statictags_StringAttributeSpec__f_name, "ios-apps", $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$());
  var attributes = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var $$x1 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes).rnSize__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeSizeAttributeSpec().$colon$eq__I__Lio_github_shogowada_statictags_Attribute($uI(params.size));
  var attributes$1 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var this$7 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$1).color__Lio_github_shogowada_statictags_StringAttributeSpec();
  var value = $as_T(params.color);
  var array = [$$x2, $$x1, new $c_Lio_github_shogowada_statictags_Attribute(this$7.Lio_github_shogowada_statictags_StringAttributeSpec__f_name, value, $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$())];
  return $$x3.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array), $m_sci_Nil$())
}
function $is_Lshowcase_app_ShowcaseStateDef(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lshowcase_app_ShowcaseStateDef)))
}
function $as_Lshowcase_app_ShowcaseStateDef(obj) {
  return (($is_Lshowcase_app_ShowcaseStateDef(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "showcase.app.ShowcaseStateDef"))
}
function $isArrayOf_Lshowcase_app_ShowcaseStateDef(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lshowcase_app_ShowcaseStateDef)))
}
function $asArrayOf_Lshowcase_app_ShowcaseStateDef(obj, depth) {
  return (($isArrayOf_Lshowcase_app_ShowcaseStateDef(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lshowcase.app.ShowcaseStateDef;", depth))
}
function $p_Lshowcase_app_ShowcaseStateReducer$__currentTaskReducer__s_Option__O__s_Option($thiz, currentTask, action) {
  if ($is_Lscommons_react_redux_task_TaskAction(action)) {
    var x2 = $as_Lscommons_react_redux_task_TaskAction(action);
    return new $c_s_Some(x2.task__Lscommons_react_redux_task_FutureTask())
  } else {
    return currentTask
  }
}
/** @constructor */
function $c_Lshowcase_app_ShowcaseStateReducer$() {
  /*<skip>*/
}
$c_Lshowcase_app_ShowcaseStateReducer$.prototype = new $h_O();
$c_Lshowcase_app_ShowcaseStateReducer$.prototype.constructor = $c_Lshowcase_app_ShowcaseStateReducer$;
/** @constructor */
function $h_Lshowcase_app_ShowcaseStateReducer$() {
  /*<skip>*/
}
$h_Lshowcase_app_ShowcaseStateReducer$.prototype = $c_Lshowcase_app_ShowcaseStateReducer$.prototype;
$c_Lshowcase_app_ShowcaseStateReducer$.prototype.reduce__s_Option__O__Lshowcase_app_ShowcaseState = (function(state, action) {
  if (state.isEmpty__Z()) {
    var $$x4 = $m_s_None$()
  } else {
    var arg1 = state.get__O();
    var x$1 = $as_Lshowcase_app_ShowcaseState(arg1);
    var $$x4 = x$1.Lshowcase_app_ShowcaseState__f_currentTask
  };
  var $$x3 = $p_Lshowcase_app_ShowcaseStateReducer$__currentTaskReducer__s_Option__O__s_Option(this, $$x4, action);
  var $$x2 = $m_Lshowcase_app_config_ShowcaseConfigReducer$();
  if (state.isEmpty__Z()) {
    var $$x1 = $m_s_None$()
  } else {
    var arg1$1 = state.get__O();
    var x$2 = $as_Lshowcase_app_ShowcaseState(arg1$1);
    var $$x1 = new $c_s_Some(x$2.Lshowcase_app_ShowcaseState__f_config)
  };
  return new $c_Lshowcase_app_ShowcaseState($$x3, $$x2.apply__s_Option__O__Lshowcase_app_config_ShowcaseConfig($$x1, action))
});
var $d_Lshowcase_app_ShowcaseStateReducer$ = new $TypeData().initClass({
  Lshowcase_app_ShowcaseStateReducer$: 0
}, false, "showcase.app.ShowcaseStateReducer$", {
  Lshowcase_app_ShowcaseStateReducer$: 1,
  O: 1
});
$c_Lshowcase_app_ShowcaseStateReducer$.prototype.$classData = $d_Lshowcase_app_ShowcaseStateReducer$;
var $n_Lshowcase_app_ShowcaseStateReducer$;
function $m_Lshowcase_app_ShowcaseStateReducer$() {
  if ((!$n_Lshowcase_app_ShowcaseStateReducer$)) {
    $n_Lshowcase_app_ShowcaseStateReducer$ = new $c_Lshowcase_app_ShowcaseStateReducer$()
  };
  return $n_Lshowcase_app_ShowcaseStateReducer$
}
function $f_Lshowcase_app_config_ShowcaseConfigActions__updateTheme__F1__Z__V($thiz, dispatch, darkTheme) {
  dispatch.apply__O__O(new $c_Lshowcase_app_config_ShowcaseConfigActions$ShowcaseThemeChangedAction(darkTheme))
}
function $p_Lshowcase_app_config_ShowcaseConfigReducer$__reduce__Lshowcase_app_config_ShowcaseConfig__O__Lshowcase_app_config_ShowcaseConfig($thiz, state, action) {
  if ((action instanceof $c_Lshowcase_app_config_ShowcaseConfigActions$ShowcaseThemeChangedAction)) {
    var x2 = $as_Lshowcase_app_config_ShowcaseConfigActions$ShowcaseThemeChangedAction(action);
    var darkTheme = x2.Lshowcase_app_config_ShowcaseConfigActions$ShowcaseThemeChangedAction__f_darkTheme;
    return new $c_Lshowcase_app_config_ShowcaseConfig(darkTheme)
  } else {
    return state
  }
}
/** @constructor */
function $c_Lshowcase_app_config_ShowcaseConfigReducer$() {
  /*<skip>*/
}
$c_Lshowcase_app_config_ShowcaseConfigReducer$.prototype = new $h_O();
$c_Lshowcase_app_config_ShowcaseConfigReducer$.prototype.constructor = $c_Lshowcase_app_config_ShowcaseConfigReducer$;
/** @constructor */
function $h_Lshowcase_app_config_ShowcaseConfigReducer$() {
  /*<skip>*/
}
$h_Lshowcase_app_config_ShowcaseConfigReducer$.prototype = $c_Lshowcase_app_config_ShowcaseConfigReducer$.prototype;
$c_Lshowcase_app_config_ShowcaseConfigReducer$.prototype.apply__s_Option__O__Lshowcase_app_config_ShowcaseConfig = (function(state, action) {
  return $p_Lshowcase_app_config_ShowcaseConfigReducer$__reduce__Lshowcase_app_config_ShowcaseConfig__O__Lshowcase_app_config_ShowcaseConfig(this, $as_Lshowcase_app_config_ShowcaseConfig((state.isEmpty__Z() ? new $c_Lshowcase_app_config_ShowcaseConfig(false) : state.get__O())), action)
});
var $d_Lshowcase_app_config_ShowcaseConfigReducer$ = new $TypeData().initClass({
  Lshowcase_app_config_ShowcaseConfigReducer$: 0
}, false, "showcase.app.config.ShowcaseConfigReducer$", {
  Lshowcase_app_config_ShowcaseConfigReducer$: 1,
  O: 1
});
$c_Lshowcase_app_config_ShowcaseConfigReducer$.prototype.$classData = $d_Lshowcase_app_config_ShowcaseConfigReducer$;
var $n_Lshowcase_app_config_ShowcaseConfigReducer$;
function $m_Lshowcase_app_config_ShowcaseConfigReducer$() {
  if ((!$n_Lshowcase_app_config_ShowcaseConfigReducer$)) {
    $n_Lshowcase_app_config_ShowcaseConfigReducer$ = new $c_Lshowcase_app_config_ShowcaseConfigReducer$()
  };
  return $n_Lshowcase_app_config_ShowcaseConfigReducer$
}
function $f_Lshowcase_app_task_DemoTaskActions__successfulAction__F1__Lshowcase_app_task_DemoTaskActions$SuccessfulFetchAction($thiz, dispatch) {
  var this$3 = $m_s_concurrent_Future$().successful__O__s_concurrent_Future("All good!");
  var pf = new $c_Lshowcase_app_task_DemoTaskActions$$anonfun$1($thiz, dispatch);
  var executor = $m_s_concurrent_ExecutionContext$().global__s_concurrent_ExecutionContextExecutor();
  var future = $f_s_concurrent_Future__andThen__s_PartialFunction__s_concurrent_ExecutionContext__s_concurrent_Future(this$3, pf, executor);
  return new $c_Lshowcase_app_task_DemoTaskActions$SuccessfulFetchAction(new $c_Lscommons_react_redux_task_FutureTask("Calling successful endpoint", future))
}
function $f_Lshowcase_app_task_DemoTaskActions__timedoutAction__Lshowcase_app_task_DemoTaskActions$FailingApiAction($thiz) {
  var this$1 = $thiz.Lshowcase_app_ShowcaseActions$__f_client;
  var future = $f_Lshowcase_api_task_DemoTaskApi__timedoutExample__s_concurrent_Future(this$1);
  return new $c_Lshowcase_app_task_DemoTaskActions$FailingApiAction(new $c_Lscommons_react_redux_task_FutureTask("Calling timedout endpoint", future))
}
function $f_Lshowcase_app_task_DemoTaskActions__failedAction__Lshowcase_app_task_DemoTaskActions$FailingApiAction($thiz) {
  var this$1 = $thiz.Lshowcase_app_ShowcaseActions$__f_client;
  var future = $f_Lshowcase_api_task_DemoTaskApi__failedExample__s_concurrent_Future(this$1);
  return new $c_Lshowcase_app_task_DemoTaskActions$FailingApiAction(new $c_Lscommons_react_redux_task_FutureTask("Calling failed endpoint", future))
}
function $f_Lio_github_shogowada_scalajs_reactjs_VirtualDOM__elementsToVirtualDOMs__Lio_github_shogowada_statictags_Element__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($thiz, element) {
  return $m_Lio_github_shogowada_scalajs_reactjs_React$().createElement__T__sjs_js_Any__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement(element.name__T(), $thiz.VirtualDOMAttributes__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$().toReactAttributes__sc_Iterable__sjs_js_Dictionary(element.flattenedAttributes__sc_Iterable()), $thiz.VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$().toReactElements__sci_Seq__sci_Seq(element.flattenedContents__sci_Seq()))
}
function $f_Lio_github_shogowada_scalajs_reactjs_VirtualDOM__$init$__V($thiz) {
  $thiz.io$github$shogowada$scalajs$reactjs$VirtualDOM$_setter_$$less_$eq__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements__V(new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements($thiz));
  $thiz.io$github$shogowada$scalajs$reactjs$VirtualDOM$_setter_$$up_$eq__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes__V(new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes($thiz))
}
function $is_Lio_github_shogowada_scalajs_reactjs_VirtualDOM(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lio_github_shogowada_scalajs_reactjs_VirtualDOM)))
}
function $as_Lio_github_shogowada_scalajs_reactjs_VirtualDOM(obj) {
  return (($is_Lio_github_shogowada_scalajs_reactjs_VirtualDOM(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "io.github.shogowada.scalajs.reactjs.VirtualDOM"))
}
function $isArrayOf_Lio_github_shogowada_scalajs_reactjs_VirtualDOM(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_github_shogowada_scalajs_reactjs_VirtualDOM)))
}
function $asArrayOf_Lio_github_shogowada_scalajs_reactjs_VirtualDOM(obj, depth) {
  return (($isArrayOf_Lio_github_shogowada_scalajs_reactjs_VirtualDOM(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.github.shogowada.scalajs.reactjs.VirtualDOM;", depth))
}
function $p_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes__key$lzycompute__Lio_github_shogowada_statictags_StringAttributeSpec($thiz) {
  if (((((8 & $thiz.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes__f_key = new $c_Lio_github_shogowada_statictags_StringAttributeSpec("key");
    $thiz.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes__f_bitmap$0 = (((8 | $thiz.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes__f_key
}
function $p_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes__wrapped$lzycompute__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$WrappedPropsAttributeSpec($thiz) {
  if (((((32 & $thiz.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes__f_wrapped = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$WrappedPropsAttributeSpec($as_Lio_github_shogowada_scalajs_reactjs_VirtualDOM($thiz.Lio_github_shogowada_statictags_StaticTags$Attributes__f_$outer).VirtualDOMAttributes__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$(), "wrapped");
    $thiz.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes__f_bitmap$0 = (((32 | $thiz.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes__f_wrapped
}
/** @constructor */
function $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes(outer) {
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_abbr = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_accept = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_accept$minuscharset = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_accesskey = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_action = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_allowfullscreen = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_allowTransparency = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_alt = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_async = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_autocomplete = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_autofocus = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_autoplay = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_border = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_challenge = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_capture = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_charset = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_checked = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_cite = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_class = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_cols = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_colspan = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_content = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_contenteditable = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_contextmenu = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_controls = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_coords = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_crossorigin = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_data = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_datetime = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_default = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_defer = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_dir = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_dirname = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_disabled = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_download = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_draggable = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_enctype = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_for = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_form = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_formaction = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_formenctype = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_formmethod = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_formnovalidate = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_formtarget = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_headers = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_height = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_hidden = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_high = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_href = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_hreflang = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_http$minusequiv = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_icon = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_id = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_inputmode = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_integrity = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_is = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_ismap = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_keytype = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_kind = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_label = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_lang = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_list = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_loop = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_low = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_manifest = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_max = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_maxlength = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_media = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_mediagroup = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_method = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_min = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_minlength = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_multiple = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_muted = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_name = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_nonce = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_novalidate = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_open = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_optimum = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_pattern = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_placeholder = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_poster = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_preload = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_radiogroup = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_readonly = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_rel = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_required = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_reversed = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_role = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_rows = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_rowspan = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_sandbox = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_scope = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_scoped = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_seamless = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_selected = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_shape = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_size = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_sizes = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_span = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_spellcheck = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_src = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_srcdoc = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_srclang = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_srcset = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_start = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_step = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_style = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_tabindex = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_target = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_title = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_translate = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_type = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_typemustmatch = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_usemap = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_value = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_width = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_wmode = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_wrap = null;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_bitmap$0 = $L0;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_bitmap$1 = $L0;
  this.Lio_github_shogowada_statictags_StaticTags$Attributes__f_$outer = null;
  this.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes__f_className = null;
  this.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes__f_for = null;
  this.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes__f_htmlFor = null;
  this.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes__f_key = null;
  this.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes__f_ref = null;
  this.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes__f_wrapped = null;
  this.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes__f_plain = null;
  this.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes__f_bitmap$0 = 0;
  $ct_Lio_github_shogowada_statictags_StaticTags$Attributes__Lio_github_shogowada_statictags_StaticTags__(this, outer)
}
$c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes.prototype = new $h_Lio_github_shogowada_statictags_StaticTags$Attributes();
$c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes.prototype.constructor = $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes;
/** @constructor */
function $h_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes() {
  /*<skip>*/
}
$h_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes.prototype = $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes.prototype;
$c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes.prototype.key__Lio_github_shogowada_statictags_StringAttributeSpec = (function() {
  return (((((8 & this.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes__key$lzycompute__Lio_github_shogowada_statictags_StringAttributeSpec(this) : this.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes__f_key)
});
$c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes.prototype.wrapped__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$WrappedPropsAttributeSpec = (function() {
  return (((((32 & this.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes__wrapped$lzycompute__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$WrappedPropsAttributeSpec(this) : this.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes__f_wrapped)
});
var $d_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes = new $TypeData().initClass({
  Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes: 0
}, false, "io.github.shogowada.scalajs.reactjs.VirtualDOM$VirtualDOMAttributes", {
  Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes: 1,
  Lio_github_shogowada_statictags_StaticTags$Attributes: 1,
  O: 1
});
$c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes.prototype.$classData = $d_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes;
/** @constructor */
function $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements(outer) {
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_a = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_abbr = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_address = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_area = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_article = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_aside = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_audio = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_b = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_base = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_bdi = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_bdo = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_blockquote = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_body = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_br = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_button = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_canvas = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_caption = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_cite = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_code = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_col = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_colgroup = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_data = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_datalist = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_dd = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_del = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_dfn = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_div = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_dl = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_dt = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_em = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_embed = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_fieldset = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_figcaption = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_figure = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_footer = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_form = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_h1 = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_h2 = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_h3 = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_h4 = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_h5 = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_h6 = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_head = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_header = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_hr = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_html = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_i = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_iframe = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_img = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_input = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_ins = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_kbd = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_keygen = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_label = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_legend = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_li = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_link = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_main = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_map = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_mark = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_meta = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_meter = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_nav = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_noscript = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_object = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_ol = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_optgroup = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_option = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_output = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_p = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_param = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_pre = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_progress = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_q = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_rb = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_rp = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_rt = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_rtc = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_ruby = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_s = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_samp = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_script = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_section = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_select = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_small = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_source = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_span = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_strong = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_style = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_sub = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_sup = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_table = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_tbody = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_td = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_template = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_textarea = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_tfoot = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_th = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_thead = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_time = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_title = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_tr = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_track = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_u = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_ul = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_var = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_video = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_wbr = null;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_bitmap$0 = $L0;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_bitmap$1 = $L0;
  this.Lio_github_shogowada_statictags_StaticTags$Elements__f_$outer = null;
  $ct_Lio_github_shogowada_statictags_StaticTags$Elements__Lio_github_shogowada_statictags_StaticTags__(this, outer)
}
$c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements.prototype = new $h_Lio_github_shogowada_statictags_StaticTags$Elements();
$c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements.prototype.constructor = $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements;
/** @constructor */
function $h_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements() {
  /*<skip>*/
}
$h_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements.prototype = $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements.prototype;
var $d_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements = new $TypeData().initClass({
  Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements: 0
}, false, "io.github.shogowada.scalajs.reactjs.VirtualDOM$VirtualDOMElements", {
  Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements: 1,
  Lio_github_shogowada_statictags_StaticTags$Elements: 1,
  O: 1
});
$c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements.prototype.$classData = $d_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements;
/** @constructor */
function $c_Lio_github_shogowada_statictags_Element$() {
  /*<skip>*/
}
$c_Lio_github_shogowada_statictags_Element$.prototype = new $h_O();
$c_Lio_github_shogowada_statictags_Element$.prototype.constructor = $c_Lio_github_shogowada_statictags_Element$;
/** @constructor */
function $h_Lio_github_shogowada_statictags_Element$() {
  /*<skip>*/
}
$h_Lio_github_shogowada_statictags_Element$.prototype = $c_Lio_github_shogowada_statictags_Element$.prototype;
$c_Lio_github_shogowada_statictags_Element$.prototype.flattenAttributes__sc_Iterable__sc_Iterable = (function(attributes) {
  return $as_sc_Iterable(this.flatten__sc_Iterable__sc_Iterable(attributes).map__F1__O(new $c_sjsr_AnonFunction1((function(this$1) {
    return (function(x$1$2) {
      return $as_Lio_github_shogowada_statictags_Attribute(x$1$2)
    })
  })(this))))
});
$c_Lio_github_shogowada_statictags_Element$.prototype.flattenContents__sci_Seq__sci_Seq = (function(contents) {
  return this.flatten__sc_Iterable__sc_Iterable(contents).toSeq__sci_Seq()
});
$c_Lio_github_shogowada_statictags_Element$.prototype.flatten__sc_Iterable__sc_Iterable = (function(items) {
  var this$1 = $m_scm_ArrayBuffer$();
  var elems = $m_sci_Nil$();
  var buffer = this$1.from__sc_IterableOnce__scm_ArrayBuffer(elems);
  items.foreach__F1__V(new $c_sjsr_AnonFunction1((function(this$2, buffer$1) {
    return (function(x0$1$2) {
      if ($is_sc_Iterable(x0$1$2)) {
        var x3 = $as_sc_Iterable(x0$1$2);
        var xs = $m_Lio_github_shogowada_statictags_Element$().flatten__sc_Iterable__sc_Iterable(x3);
        return buffer$1.addAll__sc_IterableOnce__scm_ArrayBuffer(xs)
      } else if ((x0$1$2 instanceof $c_s_Some)) {
        var x2 = $as_s_Some(x0$1$2);
        var item = x2.s_Some__f_value;
        return buffer$1.addOne__O__scm_ArrayBuffer(item)
      } else {
        var x = $m_s_None$();
        if ((x === x0$1$2)) {
          return (void 0)
        } else {
          return buffer$1.addOne__O__scm_ArrayBuffer(x0$1$2)
        }
      }
    })
  })(this, buffer)));
  return buffer
});
var $d_Lio_github_shogowada_statictags_Element$ = new $TypeData().initClass({
  Lio_github_shogowada_statictags_Element$: 0
}, false, "io.github.shogowada.statictags.Element$", {
  Lio_github_shogowada_statictags_Element$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_github_shogowada_statictags_Element$.prototype.$classData = $d_Lio_github_shogowada_statictags_Element$;
var $n_Lio_github_shogowada_statictags_Element$;
function $m_Lio_github_shogowada_statictags_Element$() {
  if ((!$n_Lio_github_shogowada_statictags_Element$)) {
    $n_Lio_github_shogowada_statictags_Element$ = new $c_Lio_github_shogowada_statictags_Element$()
  };
  return $n_Lio_github_shogowada_statictags_Element$
}
function $p_jl_Character$__nonASCIIZeroDigitCodePoints$lzycompute__AI($thiz) {
  if (((((32 & $thiz.jl_Character$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.jl_Character$__f_nonASCIIZeroDigitCodePoints = new $ac_I([1632, 1776, 1984, 2406, 2534, 2662, 2790, 2918, 3046, 3174, 3302, 3430, 3664, 3792, 3872, 4160, 4240, 6112, 6160, 6470, 6608, 6784, 6800, 6992, 7088, 7232, 7248, 42528, 43216, 43264, 43472, 43600, 44016, 65296, 66720, 69734, 69872, 69942, 70096, 71360, 120782, 120792, 120802, 120812, 120822]);
    $thiz.jl_Character$__f_bitmap$0 = (((32 | $thiz.jl_Character$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.jl_Character$__f_nonASCIIZeroDigitCodePoints
}
function $p_jl_Character$__nonASCIIZeroDigitCodePoints__AI($thiz) {
  return (((((32 & $thiz.jl_Character$__f_bitmap$0) << 24) >> 24) === 0) ? $p_jl_Character$__nonASCIIZeroDigitCodePoints$lzycompute__AI($thiz) : $thiz.jl_Character$__f_nonASCIIZeroDigitCodePoints)
}
/** @constructor */
function $c_jl_Character$() {
  this.jl_Character$__f_java$lang$Character$$charTypesFirst256 = null;
  this.jl_Character$__f_charTypeIndices = null;
  this.jl_Character$__f_charTypes = null;
  this.jl_Character$__f_isMirroredIndices = null;
  this.jl_Character$__f_combiningClassNoneOrAboveOrOtherIndices = null;
  this.jl_Character$__f_nonASCIIZeroDigitCodePoints = null;
  this.jl_Character$__f_bitmap$0 = 0
}
$c_jl_Character$.prototype = new $h_O();
$c_jl_Character$.prototype.constructor = $c_jl_Character$;
/** @constructor */
function $h_jl_Character$() {
  /*<skip>*/
}
$h_jl_Character$.prototype = $c_jl_Character$.prototype;
$c_jl_Character$.prototype.toString__I__T = (function(codePoint) {
  if (((codePoint >= 0) && (codePoint < 65536))) {
    return $as_T(String.fromCharCode(codePoint))
  } else if (((codePoint >= 0) && (codePoint <= 1114111))) {
    return $as_T(String.fromCharCode((65535 & (55296 | (((-64) + (codePoint >> 10)) | 0))), (65535 & (56320 | (1023 & codePoint)))))
  } else {
    throw $ct_jl_IllegalArgumentException__(new $c_jl_IllegalArgumentException())
  }
});
$c_jl_Character$.prototype.digitWithValidRadix__I__I__I = (function(codePoint, radix) {
  if ((codePoint < 256)) {
    var value = (((codePoint >= 48) && (codePoint <= 57)) ? (((-48) + codePoint) | 0) : (((codePoint >= 65) && (codePoint <= 90)) ? (((-55) + codePoint) | 0) : (((codePoint >= 97) && (codePoint <= 122)) ? (((-87) + codePoint) | 0) : (-1))))
  } else if (((codePoint >= 65313) && (codePoint <= 65338))) {
    var value = (((-65303) + codePoint) | 0)
  } else if (((codePoint >= 65345) && (codePoint <= 65370))) {
    var value = (((-65335) + codePoint) | 0)
  } else {
    var a = $p_jl_Character$__nonASCIIZeroDigitCodePoints__AI(this);
    var p = $m_ju_Arrays$().binarySearch__AI__I__I(a, codePoint);
    var zeroCodePointIndex = ((p < 0) ? (((-2) - p) | 0) : p);
    if ((zeroCodePointIndex < 0)) {
      var value = (-1)
    } else {
      var v = ((codePoint - $p_jl_Character$__nonASCIIZeroDigitCodePoints__AI(this).get(zeroCodePointIndex)) | 0);
      var value = ((v > 9) ? (-1) : v)
    }
  };
  return ((value < radix) ? value : (-1))
});
$c_jl_Character$.prototype.isZeroDigit__C__Z = (function(ch) {
  if ((ch < 256)) {
    return (ch === 48)
  } else {
    var a = $p_jl_Character$__nonASCIIZeroDigitCodePoints__AI(this);
    var key = ch;
    return ($m_ju_Arrays$().binarySearch__AI__I__I(a, key) >= 0)
  }
});
$c_jl_Character$.prototype.forDigit__I__I__C = (function(digit, radix) {
  if (((((radix < 2) || (radix > 36)) || (digit < 0)) || (digit >= radix))) {
    return 0
  } else {
    var overBaseTen = (((-10) + digit) | 0);
    var result = ((overBaseTen < 0) ? ((48 + digit) | 0) : ((97 + overBaseTen) | 0));
    return (65535 & result)
  }
});
$c_jl_Character$.prototype.toUpperCase__C__C = (function(ch) {
  return (65535 & this.toUpperCase__I__I(ch))
});
$c_jl_Character$.prototype.toUpperCase__I__I = (function(codePoint) {
  switch (codePoint) {
    case 8115:
    case 8131:
    case 8179: {
      return ((9 + codePoint) | 0);
      break
    }
    default: {
      if (((codePoint >= 8064) && (codePoint <= 8111))) {
        return (8 | codePoint)
      } else {
        var this$1 = this.toString__I__T(codePoint);
        var upperChars = $as_T(this$1.toUpperCase());
        var x1$2 = $uI(upperChars.length);
        switch (x1$2) {
          case 1: {
            return (65535 & $uI(upperChars.charCodeAt(0)));
            break
          }
          case 2: {
            var high = (65535 & $uI(upperChars.charCodeAt(0)));
            var low = (65535 & $uI(upperChars.charCodeAt(1)));
            return ((((-67044352) & ((high << 16) | low)) === (-671032320)) ? ((((64 + (1023 & high)) | 0) << 10) | (1023 & low)) : codePoint);
            break
          }
          default: {
            return codePoint
          }
        }
      }
    }
  }
});
$c_jl_Character$.prototype.toLowerCase__C__C = (function(ch) {
  return (65535 & this.toLowerCase__I__I(ch))
});
$c_jl_Character$.prototype.toLowerCase__I__I = (function(codePoint) {
  if ((codePoint === 304)) {
    return 105
  } else {
    var this$1 = this.toString__I__T(codePoint);
    var lowerChars = $as_T(this$1.toLowerCase());
    var x1$2 = $uI(lowerChars.length);
    switch (x1$2) {
      case 1: {
        return (65535 & $uI(lowerChars.charCodeAt(0)));
        break
      }
      case 2: {
        var high = (65535 & $uI(lowerChars.charCodeAt(0)));
        var low = (65535 & $uI(lowerChars.charCodeAt(1)));
        return ((((-67044352) & ((high << 16) | low)) === (-671032320)) ? ((((64 + (1023 & high)) | 0) << 10) | (1023 & low)) : codePoint);
        break
      }
      default: {
        return codePoint
      }
    }
  }
});
var $d_jl_Character$ = new $TypeData().initClass({
  jl_Character$: 0
}, false, "java.lang.Character$", {
  jl_Character$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_Character$.prototype.$classData = $d_jl_Character$;
var $n_jl_Character$;
function $m_jl_Character$() {
  if ((!$n_jl_Character$)) {
    $n_jl_Character$ = new $c_jl_Character$()
  };
  return $n_jl_Character$
}
function $p_jl_Double$__doubleStrPat$lzycompute__O($thiz) {
  if (((((1 & $thiz.jl_Double$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.jl_Double$__f_doubleStrPat = new RegExp("^[\\x00-\\x20]*([+-]?(?:NaN|Infinity|(?:\\d+\\.?\\d*|\\.\\d+)(?:[eE][+-]?\\d+)?)[fFdD]?)[\\x00-\\x20]*$");
    $thiz.jl_Double$__f_bitmap$0 = (((1 | $thiz.jl_Double$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.jl_Double$__f_doubleStrPat
}
function $p_jl_Double$__doubleStrPat__O($thiz) {
  return (((((1 & $thiz.jl_Double$__f_bitmap$0) << 24) >> 24) === 0) ? $p_jl_Double$__doubleStrPat$lzycompute__O($thiz) : $thiz.jl_Double$__f_doubleStrPat)
}
function $p_jl_Double$__doubleStrHexPat$lzycompute__O($thiz) {
  if (((((2 & $thiz.jl_Double$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.jl_Double$__f_doubleStrHexPat = new RegExp("^[\\x00-\\x20]*([+-]?)0[xX]([0-9A-Fa-f]*)\\.?([0-9A-Fa-f]*)[pP]([+-]?\\d+)[fFdD]?[\\x00-\\x20]*$");
    $thiz.jl_Double$__f_bitmap$0 = (((2 | $thiz.jl_Double$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.jl_Double$__f_doubleStrHexPat
}
function $p_jl_Double$__doubleStrHexPat__O($thiz) {
  return (((((2 & $thiz.jl_Double$__f_bitmap$0) << 24) >> 24) === 0) ? $p_jl_Double$__doubleStrHexPat$lzycompute__O($thiz) : $thiz.jl_Double$__f_doubleStrHexPat)
}
function $p_jl_Double$__parseDoubleSlowPath__T__D($thiz, s) {
  var groups = $p_jl_Double$__doubleStrHexPat__O($thiz).exec(s);
  if ((groups === null)) {
    $p_jl_Double$__fail$1__T__E($thiz, s)
  };
  var signStr = $as_T(groups[1]);
  var integralPartStr = $as_T(groups[2]);
  var fractionalPartStr = $as_T(groups[3]);
  var binaryExpStr = $as_T(groups[4]);
  if (((integralPartStr === "") && (fractionalPartStr === ""))) {
    $p_jl_Double$__fail$1__T__E($thiz, s)
  };
  var absResult = $thiz.parseHexDoubleImpl__T__T__T__I__D(integralPartStr, fractionalPartStr, binaryExpStr, 15);
  return ((signStr === "-") ? (-absResult) : absResult)
}
function $p_jl_Double$__fail$1__T__E($thiz, s$1) {
  throw new $c_jl_NumberFormatException((("For input string: \"" + s$1) + "\""))
}
/** @constructor */
function $c_jl_Double$() {
  this.jl_Double$__f_doubleStrPat = null;
  this.jl_Double$__f_doubleStrHexPat = null;
  this.jl_Double$__f_bitmap$0 = 0
}
$c_jl_Double$.prototype = new $h_O();
$c_jl_Double$.prototype.constructor = $c_jl_Double$;
/** @constructor */
function $h_jl_Double$() {
  /*<skip>*/
}
$h_jl_Double$.prototype = $c_jl_Double$.prototype;
$c_jl_Double$.prototype.parseDouble__T__D = (function(s) {
  var groups = $p_jl_Double$__doubleStrPat__O(this).exec(s);
  return ((groups !== null) ? $uD(parseFloat(groups[1])) : $p_jl_Double$__parseDoubleSlowPath__T__D(this, s))
});
$c_jl_Double$.prototype.parseHexDoubleImpl__T__T__T__I__D = (function(integralPartStr, fractionalPartStr, binaryExpStr, maxPrecisionChars) {
  var mantissaStr0 = (("" + integralPartStr) + fractionalPartStr);
  var correction1 = ((-($uI(fractionalPartStr.length) << 2)) | 0);
  var i = 0;
  while (true) {
    if ((i !== $uI(mantissaStr0.length))) {
      var index = i;
      var $$x1 = ((65535 & $uI(mantissaStr0.charCodeAt(index))) === 48)
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      i = ((1 + i) | 0)
    } else {
      break
    }
  };
  var beginIndex = i;
  var mantissaStr = $as_T(mantissaStr0.substring(beginIndex));
  if ((mantissaStr === "")) {
    return 0.0
  };
  var mantissaStrLen = $uI(mantissaStr.length);
  var needsCorrection2 = (mantissaStrLen > maxPrecisionChars);
  if (needsCorrection2) {
    var hasNonZeroChar = false;
    var j = maxPrecisionChars;
    while (((!hasNonZeroChar) && (j !== mantissaStrLen))) {
      var index$1 = j;
      if (((65535 & $uI(mantissaStr.charCodeAt(index$1))) !== 48)) {
        hasNonZeroChar = true
      };
      j = ((1 + j) | 0)
    };
    var compressedTail = (hasNonZeroChar ? "1" : "0");
    var truncatedMantissaStr = ($as_T(mantissaStr.substring(0, maxPrecisionChars)) + compressedTail)
  } else {
    var truncatedMantissaStr = mantissaStr
  };
  var correction2 = (needsCorrection2 ? ((($uI(mantissaStr.length) - ((1 + maxPrecisionChars) | 0)) | 0) << 2) : 0);
  var fullCorrection = ((correction1 + correction2) | 0);
  var mantissa = $uD(parseInt(truncatedMantissaStr, 16));
  var binaryExpDouble = $uD(parseInt(binaryExpStr, 10));
  var binaryExp = $doubleToInt(binaryExpDouble);
  var binExpAndCorrection = ((binaryExp + fullCorrection) | 0);
  var binExpAndCorrection_div_3 = ((binExpAndCorrection / 3) | 0);
  var b = binExpAndCorrection_div_3;
  var correctingPow = $uD(Math.pow(2.0, b));
  var b$1 = ((binExpAndCorrection - (binExpAndCorrection_div_3 << 1)) | 0);
  var correctingPow3 = $uD(Math.pow(2.0, b$1));
  return (((mantissa * correctingPow) * correctingPow) * correctingPow3)
});
var $d_jl_Double$ = new $TypeData().initClass({
  jl_Double$: 0
}, false, "java.lang.Double$", {
  jl_Double$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_Double$.prototype.$classData = $d_jl_Double$;
var $n_jl_Double$;
function $m_jl_Double$() {
  if ((!$n_jl_Double$)) {
    $n_jl_Double$ = new $c_jl_Double$()
  };
  return $n_jl_Double$
}
function $p_jl_Float$__parseFloatRegExp$lzycompute__O($thiz) {
  if ((!$thiz.jl_Float$__f_bitmap$0)) {
    $thiz.jl_Float$__f_parseFloatRegExp = new RegExp("^[\\x00-\\x20]*([+-]?)(?:(NaN)|(Infinity)|(?:((?:(\\d+)(?:\\.(\\d*))?|\\.(\\d+))(?:[eE]([+-]?\\d+))?)|(0[xX](?:([0-9A-Fa-f]+)(?:\\.([0-9A-Fa-f]*))?|\\.([0-9A-Fa-f]+))[pP]([+-]?\\d+)))[fFdD]?)[\\x00-\\x20]*$");
    $thiz.jl_Float$__f_bitmap$0 = true
  };
  return $thiz.jl_Float$__f_parseFloatRegExp
}
function $p_jl_Float$__parseFloatRegExp__O($thiz) {
  return ((!$thiz.jl_Float$__f_bitmap$0) ? $p_jl_Float$__parseFloatRegExp$lzycompute__O($thiz) : $thiz.jl_Float$__f_parseFloatRegExp)
}
function $p_jl_Float$__parseFloatDecimal__T__T__T__T__F($thiz, fullNumberStr, integralPartStr, fractionalPartStr, exponentStr) {
  var z0 = $uD(parseFloat(fullNumberStr));
  var z = $fround(z0);
  var zDouble = z;
  if ((zDouble === z0)) {
    return z
  } else if ((zDouble === Infinity)) {
    return ((z0 === 3.4028235677973366E38) ? $p_jl_Float$__parseFloatDecimalCorrection__T__T__T__F__F__D__F($thiz, integralPartStr, fractionalPartStr, exponentStr, 3.4028234663852886E38, z, 3.4028235677973366E38) : z)
  } else if ((zDouble < z0)) {
    var zUp = $m_jl_Math$().nextUp__F__F(z);
    var mid$2 = ((zDouble + zUp) / 2.0);
    return ((z0 === mid$2) ? $p_jl_Float$__parseFloatDecimalCorrection__T__T__T__F__F__D__F($thiz, integralPartStr, fractionalPartStr, exponentStr, z, zUp, mid$2) : z)
  } else {
    var zDown = $m_jl_Math$().nextDown__F__F(z);
    var mid$3 = ((zDouble + zDown) / 2.0);
    return ((z0 === mid$3) ? $p_jl_Float$__parseFloatDecimalCorrection__T__T__T__F__F__D__F($thiz, integralPartStr, fractionalPartStr, exponentStr, zDown, z, mid$3) : z)
  }
}
function $p_jl_Float$__parseFloatDecimalCorrection__T__T__T__F__F__D__F($thiz, integralPartStr, fractionalPartStr, exponentStr, zDown, zUp, mid) {
  var f = $ct_Ljava_math_BigInteger__T__(new $c_Ljava_math_BigInteger(), (("" + integralPartStr) + fractionalPartStr));
  var this$1 = $m_jl_Integer$();
  var e = ((this$1.parseInt__T__I__I(exponentStr, 10) - $uI(fractionalPartStr.length)) | 0);
  var t = $m_jl_FloatingPointBits$().doubleToLongBits__D__J(mid);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var lo$1 = (hi >> 20);
  if ((lo$1 === 0)) {
    throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), ("parseFloatCorrection was given a subnormal mid: " + mid))
  };
  var hi$2 = (1048575 & hi);
  var hi$3 = (1048576 | hi$2);
  var m = $m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(new $c_RTLong(lo, hi$3));
  var k = (((-1075) + lo$1) | 0);
  if ((e >= 0)) {
    if ((k >= 0)) {
      var x = f.multiply__Ljava_math_BigInteger__Ljava_math_BigInteger($m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_TEN.pow__I__Ljava_math_BigInteger(e));
      var y = m.shiftLeft__I__Ljava_math_BigInteger(k);
      var cmp = x.compareTo__Ljava_math_BigInteger__I(y)
    } else {
      var v = f.multiply__Ljava_math_BigInteger__Ljava_math_BigInteger($m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_TEN.pow__I__Ljava_math_BigInteger(e));
      var e$1 = ((-k) | 0);
      var x$1 = v.shiftLeft__I__Ljava_math_BigInteger(e$1);
      var cmp = x$1.compareTo__Ljava_math_BigInteger__I(m)
    }
  } else if ((k >= 0)) {
    var e$2 = ((-e) | 0);
    var v$1 = m.multiply__Ljava_math_BigInteger__Ljava_math_BigInteger($m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_TEN.pow__I__Ljava_math_BigInteger(e$2));
    var y$1 = v$1.shiftLeft__I__Ljava_math_BigInteger(k);
    var cmp = f.compareTo__Ljava_math_BigInteger__I(y$1)
  } else {
    var e$3 = ((-k) | 0);
    var x$2 = f.shiftLeft__I__Ljava_math_BigInteger(e$3);
    var e$4 = ((-e) | 0);
    var y$2 = m.multiply__Ljava_math_BigInteger__Ljava_math_BigInteger($m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_TEN.pow__I__Ljava_math_BigInteger(e$4));
    var cmp = x$2.compareTo__Ljava_math_BigInteger__I(y$2)
  };
  return ((cmp < 0) ? zDown : ((cmp > 0) ? zUp : (((1 & $m_jl_FloatingPointBits$().floatToIntBits__F__I(zDown)) === 0) ? zDown : zUp)))
}
function $p_jl_Float$__parseFloatHexadecimal__T__T__T__F($thiz, integralPartStr, fractionalPartStr, binaryExpStr) {
  var doubleValue = $m_jl_Double$().parseHexDoubleImpl__T__T__T__I__D(integralPartStr, fractionalPartStr, binaryExpStr, 7);
  return $fround(doubleValue)
}
/** @constructor */
function $c_jl_Float$() {
  this.jl_Float$__f_parseFloatRegExp = null;
  this.jl_Float$__f_bitmap$0 = false
}
$c_jl_Float$.prototype = new $h_O();
$c_jl_Float$.prototype.constructor = $c_jl_Float$;
/** @constructor */
function $h_jl_Float$() {
  /*<skip>*/
}
$h_jl_Float$.prototype = $c_jl_Float$.prototype;
$c_jl_Float$.prototype.parseFloat__T__F = (function(s) {
  var groups = $p_jl_Float$__parseFloatRegExp__O(this).exec(s);
  if ((groups === null)) {
    throw new $c_jl_NumberFormatException((("For input string: \"" + s) + "\""))
  };
  var x = groups[2];
  if ((x !== (void 0))) {
    var absResult = (NaN)
  } else {
    var x$1 = groups[3];
    if ((x$1 !== (void 0))) {
      var absResult = Infinity
    } else {
      var x$2 = groups[4];
      if ((x$2 !== (void 0))) {
        var x$3 = groups[4];
        var fullNumberStr = $as_T(x$3);
        var x$4 = groups[5];
        var integralPartStr = $as_T(((x$4 !== (void 0)) ? x$4 : ""));
        var x$5 = groups[6];
        var $$x1 = $as_T(((x$5 !== (void 0)) ? x$5 : ""));
        var x$6 = groups[7];
        var fractionalPartStr = (("" + $$x1) + ((x$6 !== (void 0)) ? x$6 : ""));
        var x$7 = groups[8];
        var exponentStr = $as_T(((x$7 !== (void 0)) ? x$7 : "0"));
        var absResult = $p_jl_Float$__parseFloatDecimal__T__T__T__T__F(this, fullNumberStr, integralPartStr, fractionalPartStr, exponentStr)
      } else {
        var x$8 = groups[10];
        var integralPartStr$2 = $as_T(((x$8 !== (void 0)) ? x$8 : ""));
        var x$9 = groups[11];
        var $$x2 = $as_T(((x$9 !== (void 0)) ? x$9 : ""));
        var x$10 = groups[12];
        var fractionalPartStr$2 = (("" + $$x2) + ((x$10 !== (void 0)) ? x$10 : ""));
        var x$11 = groups[13];
        var binaryExpStr = $as_T(x$11);
        var absResult = $p_jl_Float$__parseFloatHexadecimal__T__T__T__F(this, integralPartStr$2, fractionalPartStr$2, binaryExpStr)
      }
    }
  };
  var x$12 = groups[1];
  var signStr = $as_T(x$12);
  return ((signStr === "-") ? $fround((-absResult)) : absResult)
});
var $d_jl_Float$ = new $TypeData().initClass({
  jl_Float$: 0
}, false, "java.lang.Float$", {
  jl_Float$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_Float$.prototype.$classData = $d_jl_Float$;
var $n_jl_Float$;
function $m_jl_Float$() {
  if ((!$n_jl_Float$)) {
    $n_jl_Float$ = new $c_jl_Float$()
  };
  return $n_jl_Float$
}
function $p_jl_Integer$__fail$1__T__E($thiz, s$1) {
  throw new $c_jl_NumberFormatException((("For input string: \"" + s$1) + "\""))
}
/** @constructor */
function $c_jl_Integer$() {
  /*<skip>*/
}
$c_jl_Integer$.prototype = new $h_O();
$c_jl_Integer$.prototype.constructor = $c_jl_Integer$;
/** @constructor */
function $h_jl_Integer$() {
  /*<skip>*/
}
$h_jl_Integer$.prototype = $c_jl_Integer$.prototype;
$c_jl_Integer$.prototype.parseInt__T__I__I = (function(s, radix) {
  var len = ((s === null) ? 0 : $uI(s.length));
  if ((((len === 0) || (radix < 2)) || (radix > 36))) {
    $p_jl_Integer$__fail$1__T__E(this, s)
  };
  var firstChar = (65535 & $uI(s.charCodeAt(0)));
  var negative = (firstChar === 45);
  var maxAbsValue = (negative ? 2.147483648E9 : 2.147483647E9);
  var i = ((negative || (firstChar === 43)) ? 1 : 0);
  if ((i >= $uI(s.length))) {
    $p_jl_Integer$__fail$1__T__E(this, s)
  };
  var result = 0.0;
  while ((i !== len)) {
    var $$x1 = $m_jl_Character$();
    var index = i;
    var digit = $$x1.digitWithValidRadix__I__I__I((65535 & $uI(s.charCodeAt(index))), radix);
    result = ((result * radix) + digit);
    if (((digit === (-1)) || (result > maxAbsValue))) {
      $p_jl_Integer$__fail$1__T__E(this, s)
    };
    i = ((1 + i) | 0)
  };
  if (negative) {
    var n = (-result);
    return $uI((n | 0))
  } else {
    var n$1 = result;
    return $uI((n$1 | 0))
  }
});
$c_jl_Integer$.prototype.bitCount__I__I = (function(i) {
  var t1 = ((i - (1431655765 & (i >> 1))) | 0);
  var t2 = (((858993459 & t1) + (858993459 & (t1 >> 2))) | 0);
  return ($imul(16843009, (252645135 & ((t2 + (t2 >> 4)) | 0))) >> 24)
});
var $d_jl_Integer$ = new $TypeData().initClass({
  jl_Integer$: 0
}, false, "java.lang.Integer$", {
  jl_Integer$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_Integer$.prototype.$classData = $d_jl_Integer$;
var $n_jl_Integer$;
function $m_jl_Integer$() {
  if ((!$n_jl_Integer$)) {
    $n_jl_Integer$ = new $c_jl_Integer$()
  };
  return $n_jl_Integer$
}
function $p_jl_Long$__StringRadixInfos$lzycompute__O($thiz) {
  if ((!$thiz.jl_Long$__f_bitmap$0)) {
    var r = [];
    var radix = 0;
    while ((radix < 2)) {
      r.push(null);
      radix = ((1 + radix) | 0)
    };
    while ((radix <= 36)) {
      var barrier = $intDiv(2147483647, radix);
      var radixPowLength = radix;
      var chunkLength = 1;
      var paddingZeros = "0";
      while ((radixPowLength <= barrier)) {
        radixPowLength = $imul(radixPowLength, radix);
        chunkLength = ((1 + chunkLength) | 0);
        paddingZeros = (paddingZeros + "0")
      };
      var value = radixPowLength;
      var hi = (value >> 31);
      var this$2 = $m_RTLong$();
      var lo = this$2.divideUnsignedImpl__I__I__I__I__I((-1), (-1), value, hi);
      var hi$1 = this$2.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      r.push(new $c_jl_Long$StringRadixInfo(chunkLength, new $c_RTLong(value, hi), paddingZeros, new $c_RTLong(lo, hi$1)));
      radix = ((1 + radix) | 0)
    };
    $thiz.jl_Long$__f_StringRadixInfos = r;
    $thiz.jl_Long$__f_bitmap$0 = true
  };
  return $thiz.jl_Long$__f_StringRadixInfos
}
function $p_jl_Long$__StringRadixInfos__O($thiz) {
  return ((!$thiz.jl_Long$__f_bitmap$0) ? $p_jl_Long$__StringRadixInfos$lzycompute__O($thiz) : $thiz.jl_Long$__f_StringRadixInfos)
}
function $p_jl_Long$__toUnsignedStringInternalLarge__J__I__T($thiz, i, radix) {
  var radixInfo = $as_jl_Long$StringRadixInfo($p_jl_Long$__StringRadixInfos__O($thiz)[radix]);
  var t = radixInfo.jl_Long$StringRadixInfo__f_radixPowLength;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var paddingZeros = radixInfo.jl_Long$StringRadixInfo__f_paddingZeros;
  var hi$1 = ((-2147483648) ^ hi);
  var res = "";
  var lo$1 = i.RTLong__f_lo;
  var hi$2 = i.RTLong__f_hi;
  var value__lo = lo$1;
  var value__hi = hi$2;
  while (true) {
    var b__lo = value__lo;
    var b__hi = value__hi;
    var lo$2 = b__lo;
    var hi$3 = ((-2147483648) ^ b__hi);
    if (((hi$3 === hi$1) ? (((-2147483648) ^ lo$2) >= ((-2147483648) ^ lo)) : (hi$3 > hi$1))) {
      var this$1__lo = value__lo;
      var this$1__hi = value__hi;
      var this$2 = $m_RTLong$();
      var lo$3 = this$2.divideUnsignedImpl__I__I__I__I__I(this$1__lo, this$1__hi, lo, hi);
      var hi$4 = this$2.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      var this$3__lo = value__lo;
      var this$3__hi = value__hi;
      var a0 = (65535 & lo$3);
      var a1 = ((lo$3 >>> 16) | 0);
      var b0 = (65535 & lo);
      var b1 = ((lo >>> 16) | 0);
      var a0b0 = $imul(a0, b0);
      var a1b0 = $imul(a1, b0);
      var a0b1 = $imul(a0, b1);
      var lo$4 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi$5 = (((((((($imul(lo$3, hi) + $imul(hi$4, lo)) | 0) + $imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
      var alo = this$3__lo;
      var ahi = this$3__hi;
      var lo$5 = ((alo - lo$4) | 0);
      var remStr = $as_T(lo$5.toString(radix));
      res = ((("" + $as_T(paddingZeros.substring($uI(remStr.length)))) + remStr) + res);
      var $$x1__lo = lo$3;
      var $$x1__hi = hi$4;
      value__lo = $$x1__lo;
      value__hi = $$x1__hi
    } else {
      break
    }
  };
  var this$7__lo = value__lo;
  var this$7__hi = value__hi;
  var x = this$7__lo;
  var $$x2 = x.toString(radix);
  return (("" + $as_T($$x2)) + res)
}
function $p_jl_Long$__parseLongError__T__E($thiz, s) {
  throw new $c_jl_NumberFormatException((("For input string: \"" + s) + "\""))
}
function $p_jl_Long$__parseChunkAsUInt$1__I__I__T__I__I($thiz, chunkStart, chunkEnd, s$1, radix$1) {
  var result = 0;
  var i = chunkStart;
  while ((i !== chunkEnd)) {
    var $$x1 = $m_jl_Character$();
    var index = i;
    var digit = $$x1.digitWithValidRadix__I__I__I((65535 & $uI(s$1.charCodeAt(index))), radix$1);
    if ((digit === (-1))) {
      $p_jl_Long$__parseLongError__T__E($thiz, s$1)
    };
    result = (($imul(result, radix$1) + digit) | 0);
    i = ((1 + i) | 0)
  };
  return result
}
/** @constructor */
function $c_jl_Long$() {
  this.jl_Long$__f_StringRadixInfos = null;
  this.jl_Long$__f_bitmap$0 = false
}
$c_jl_Long$.prototype = new $h_O();
$c_jl_Long$.prototype.constructor = $c_jl_Long$;
/** @constructor */
function $h_jl_Long$() {
  /*<skip>*/
}
$h_jl_Long$.prototype = $c_jl_Long$.prototype;
$c_jl_Long$.prototype.java$lang$Long$$toStringImpl__J__I__T = (function(i, radix) {
  var lo = i.RTLong__f_lo;
  var hi = i.RTLong__f_hi;
  if (((lo >> 31) === hi)) {
    return $as_T(lo.toString(radix))
  } else if ((hi < 0)) {
    var lo$1 = i.RTLong__f_lo;
    var hi$1 = i.RTLong__f_hi;
    var lo$2 = ((-lo$1) | 0);
    var hi$2 = ((lo$1 !== 0) ? (~hi$1) : ((-hi$1) | 0));
    return ("-" + $p_jl_Long$__toUnsignedStringInternalLarge__J__I__T(this, new $c_RTLong(lo$2, hi$2), radix))
  } else {
    return $p_jl_Long$__toUnsignedStringInternalLarge__J__I__T(this, i, radix)
  }
});
$c_jl_Long$.prototype.parseLong__T__I__J = (function(s, radix) {
  if ((s === "")) {
    $p_jl_Long$__parseLongError__T__E(this, s)
  };
  var start = 0;
  var neg = false;
  var x1 = (65535 & $uI(s.charCodeAt(0)));
  switch (x1) {
    case 43: {
      start = 1;
      break
    }
    case 45: {
      start = 1;
      neg = true;
      break
    }
  };
  var t = this.parseUnsignedLongInternal__T__I__I__J(s, radix, start);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  if (neg) {
    var lo$1 = ((-lo) | 0);
    var hi$1 = ((lo !== 0) ? (~hi) : ((-hi) | 0));
    if (((hi$1 === 0) ? (lo$1 !== 0) : (hi$1 > 0))) {
      $p_jl_Long$__parseLongError__T__E(this, s)
    };
    return new $c_RTLong(lo$1, hi$1)
  } else {
    if ((hi < 0)) {
      $p_jl_Long$__parseLongError__T__E(this, s)
    };
    return new $c_RTLong(lo, hi)
  }
});
$c_jl_Long$.prototype.parseUnsignedLongInternal__T__I__I__J = (function(s, radix, start) {
  var length = $uI(s.length);
  if ((((start >= length) || (radix < 2)) || (radix > 36))) {
    $p_jl_Long$__parseLongError__T__E(this, s)
  } else {
    var radixInfo = $as_jl_Long$StringRadixInfo($p_jl_Long$__StringRadixInfos__O(this)[radix]);
    var chunkLen = radixInfo.jl_Long$StringRadixInfo__f_chunkLength;
    var firstChunkStart = start;
    while (true) {
      if ((firstChunkStart < length)) {
        var $$x2 = $m_jl_Character$();
        var index = firstChunkStart;
        var $$x1 = $$x2.isZeroDigit__C__Z((65535 & $uI(s.charCodeAt(index))))
      } else {
        var $$x1 = false
      };
      if ($$x1) {
        firstChunkStart = ((1 + firstChunkStart) | 0)
      } else {
        break
      }
    };
    if ((((length - firstChunkStart) | 0) > $imul(3, chunkLen))) {
      $p_jl_Long$__parseLongError__T__E(this, s)
    };
    var firstChunkLength = ((1 + $intMod((((-1) + ((length - firstChunkStart) | 0)) | 0), chunkLen)) | 0);
    var firstChunkEnd = ((firstChunkStart + firstChunkLength) | 0);
    var chunkStart = firstChunkStart;
    var x = $p_jl_Long$__parseChunkAsUInt$1__I__I__T__I__I(this, chunkStart, firstChunkEnd, s, radix);
    if ((firstChunkEnd === length)) {
      return new $c_RTLong(x, 0)
    } else {
      var t = radixInfo.jl_Long$StringRadixInfo__f_radixPowLength;
      var lo = t.RTLong__f_lo;
      var hi$1 = t.RTLong__f_hi;
      var secondChunkEnd = ((firstChunkEnd + chunkLen) | 0);
      var a0 = (65535 & x);
      var a1 = ((x >>> 16) | 0);
      var b0 = (65535 & lo);
      var b1 = ((lo >>> 16) | 0);
      var a0b0 = $imul(a0, b0);
      var a1b0 = $imul(a1, b0);
      var a0b1 = $imul(a0, b1);
      var lo$1 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi$2 = (((((($imul(x, hi$1) + $imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
      var x$1 = $p_jl_Long$__parseChunkAsUInt$1__I__I__T__I__I(this, firstChunkEnd, secondChunkEnd, s, radix);
      var lo$2 = ((lo$1 + x$1) | 0);
      var hi$4 = ((((-2147483648) ^ lo$2) < ((-2147483648) ^ lo$1)) ? ((1 + hi$2) | 0) : hi$2);
      if ((secondChunkEnd === length)) {
        return new $c_RTLong(lo$2, hi$4)
      } else {
        var t$1 = radixInfo.jl_Long$StringRadixInfo__f_overflowBarrier;
        var lo$3 = t$1.RTLong__f_lo;
        var hi$5 = t$1.RTLong__f_hi;
        var x$2 = $p_jl_Long$__parseChunkAsUInt$1__I__I__T__I__I(this, secondChunkEnd, length, s, radix);
        if (((hi$4 === hi$5) ? (((-2147483648) ^ lo$2) > ((-2147483648) ^ lo$3)) : (hi$4 > hi$5))) {
          $p_jl_Long$__parseLongError__T__E(this, s)
        };
        var a0$1 = (65535 & lo$2);
        var a1$1 = ((lo$2 >>> 16) | 0);
        var b0$1 = (65535 & lo);
        var b1$1 = ((lo >>> 16) | 0);
        var a0b0$1 = $imul(a0$1, b0$1);
        var a1b0$1 = $imul(a1$1, b0$1);
        var a0b1$1 = $imul(a0$1, b1$1);
        var lo$4 = ((a0b0$1 + (((a1b0$1 + a0b1$1) | 0) << 16)) | 0);
        var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
        var hi$7 = (((((((($imul(lo$2, hi$1) + $imul(hi$4, lo)) | 0) + $imul(a1$1, b1$1)) | 0) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
        var lo$5 = ((lo$4 + x$2) | 0);
        var hi$8 = ((((-2147483648) ^ lo$5) < ((-2147483648) ^ lo$4)) ? ((1 + hi$7) | 0) : hi$7);
        var hi$9 = ((-2147483648) ^ hi$8);
        if (((hi$9 === (-2147483648)) && (((-2147483648) ^ lo$5) < ((-2147483648) ^ x$2)))) {
          $p_jl_Long$__parseLongError__T__E(this, s)
        };
        return new $c_RTLong(lo$5, hi$8)
      }
    }
  }
});
$c_jl_Long$.prototype.java$lang$Long$$toHexString__I__I__T = (function(lo, hi) {
  if ((hi !== 0)) {
    var $$x1 = $as_T($uD((hi >>> 0)).toString(16));
    var s = $as_T($uD((lo >>> 0)).toString(16));
    var beginIndex = $uI(s.length);
    return ($$x1 + (("" + $as_T("00000000".substring(beginIndex))) + s))
  } else {
    return $as_T($uD((lo >>> 0)).toString(16))
  }
});
$c_jl_Long$.prototype.java$lang$Long$$toOctalString__I__I__T = (function(lo, hi) {
  var lp = (1073741823 & lo);
  var mp = (1073741823 & ((((lo >>> 30) | 0) + (hi << 2)) | 0));
  var hp = ((hi >>> 28) | 0);
  if ((hp !== 0)) {
    var $$x2 = $as_T($uD((hp >>> 0)).toString(8));
    var s = $as_T($uD((mp >>> 0)).toString(8));
    var beginIndex = $uI(s.length);
    var $$x1 = $as_T("0000000000".substring(beginIndex));
    var s$1 = $as_T($uD((lp >>> 0)).toString(8));
    var beginIndex$1 = $uI(s$1.length);
    return (($$x2 + (("" + $$x1) + s)) + (("" + $as_T("0000000000".substring(beginIndex$1))) + s$1))
  } else if ((mp !== 0)) {
    var $$x3 = $as_T($uD((mp >>> 0)).toString(8));
    var s$2 = $as_T($uD((lp >>> 0)).toString(8));
    var beginIndex$2 = $uI(s$2.length);
    return ($$x3 + (("" + $as_T("0000000000".substring(beginIndex$2))) + s$2))
  } else {
    return $as_T($uD((lp >>> 0)).toString(8))
  }
});
var $d_jl_Long$ = new $TypeData().initClass({
  jl_Long$: 0
}, false, "java.lang.Long$", {
  jl_Long$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_Long$.prototype.$classData = $d_jl_Long$;
var $n_jl_Long$;
function $m_jl_Long$() {
  if ((!$n_jl_Long$)) {
    $n_jl_Long$ = new $c_jl_Long$()
  };
  return $n_jl_Long$
}
/** @constructor */
function $c_jl_Number() {
  /*<skip>*/
}
$c_jl_Number.prototype = new $h_O();
$c_jl_Number.prototype.constructor = $c_jl_Number;
/** @constructor */
function $h_jl_Number() {
  /*<skip>*/
}
$h_jl_Number.prototype = $c_jl_Number.prototype;
function $is_jl_Number(obj) {
  return ((obj instanceof $c_jl_Number) || ((typeof obj) === "number"))
}
function $as_jl_Number(obj) {
  return (($is_jl_Number(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Number"))
}
function $isArrayOf_jl_Number(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Number)))
}
function $asArrayOf_jl_Number(obj, depth) {
  return (($isArrayOf_jl_Number(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Number;", depth))
}
/** @constructor */
function $c_jl_StackTraceElement(declaringClass, methodName, fileName, lineNumber) {
  this.jl_StackTraceElement__f_declaringClass = null;
  this.jl_StackTraceElement__f_methodName = null;
  this.jl_StackTraceElement__f_fileName = null;
  this.jl_StackTraceElement__f_lineNumber = 0;
  this.jl_StackTraceElement__f_columnNumber = 0;
  this.jl_StackTraceElement__f_declaringClass = declaringClass;
  this.jl_StackTraceElement__f_methodName = methodName;
  this.jl_StackTraceElement__f_fileName = fileName;
  this.jl_StackTraceElement__f_lineNumber = lineNumber;
  this.jl_StackTraceElement__f_columnNumber = (-1)
}
$c_jl_StackTraceElement.prototype = new $h_O();
$c_jl_StackTraceElement.prototype.constructor = $c_jl_StackTraceElement;
/** @constructor */
function $h_jl_StackTraceElement() {
  /*<skip>*/
}
$h_jl_StackTraceElement.prototype = $c_jl_StackTraceElement.prototype;
$c_jl_StackTraceElement.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_jl_StackTraceElement)) {
    var x2 = $as_jl_StackTraceElement(that);
    return ((((this.jl_StackTraceElement__f_fileName === x2.jl_StackTraceElement__f_fileName) && (this.jl_StackTraceElement__f_lineNumber === x2.jl_StackTraceElement__f_lineNumber)) && (this.jl_StackTraceElement__f_declaringClass === x2.jl_StackTraceElement__f_declaringClass)) && (this.jl_StackTraceElement__f_methodName === x2.jl_StackTraceElement__f_methodName))
  } else {
    return false
  }
});
$c_jl_StackTraceElement.prototype.toString__T = (function() {
  var result = "";
  if ((this.jl_StackTraceElement__f_declaringClass !== "<jscode>")) {
    result = ((("" + result) + this.jl_StackTraceElement__f_declaringClass) + ".")
  };
  result = (("" + result) + this.jl_StackTraceElement__f_methodName);
  if ((this.jl_StackTraceElement__f_fileName === null)) {
    result = (result + "(Unknown Source)")
  } else {
    result = ((result + "(") + this.jl_StackTraceElement__f_fileName);
    if ((this.jl_StackTraceElement__f_lineNumber >= 0)) {
      result = ((result + ":") + this.jl_StackTraceElement__f_lineNumber);
      if ((this.jl_StackTraceElement__f_columnNumber >= 0)) {
        result = ((result + ":") + this.jl_StackTraceElement__f_columnNumber)
      }
    };
    result = (result + ")")
  };
  return result
});
$c_jl_StackTraceElement.prototype.hashCode__I = (function() {
  return ($f_T__hashCode__I(this.jl_StackTraceElement__f_declaringClass) ^ $f_T__hashCode__I(this.jl_StackTraceElement__f_methodName))
});
function $as_jl_StackTraceElement(obj) {
  return (((obj instanceof $c_jl_StackTraceElement) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.StackTraceElement"))
}
function $isArrayOf_jl_StackTraceElement(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_StackTraceElement)))
}
function $asArrayOf_jl_StackTraceElement(obj, depth) {
  return (($isArrayOf_jl_StackTraceElement(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.StackTraceElement;", depth))
}
var $d_jl_StackTraceElement = new $TypeData().initClass({
  jl_StackTraceElement: 0
}, false, "java.lang.StackTraceElement", {
  jl_StackTraceElement: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_StackTraceElement.prototype.$classData = $d_jl_StackTraceElement;
/** @constructor */
function $c_jl_String$() {
  this.jl_String$__f_CASE_INSENSITIVE_ORDER = null;
  this.jl_String$__f_bitmap$0 = false
}
$c_jl_String$.prototype = new $h_O();
$c_jl_String$.prototype.constructor = $c_jl_String$;
/** @constructor */
function $h_jl_String$() {
  /*<skip>*/
}
$h_jl_String$.prototype = $c_jl_String$.prototype;
$c_jl_String$.prototype.new__AC__I__I__T = (function(value, offset, count) {
  var end = ((offset + count) | 0);
  if ((((offset < 0) || (end < offset)) || (end > value.u.length))) {
    throw $ct_jl_StringIndexOutOfBoundsException__(new $c_jl_StringIndexOutOfBoundsException())
  };
  var result = "";
  var i = offset;
  while ((i !== end)) {
    var $$x1 = result;
    var this$1 = value.get(i);
    result = (("" + $$x1) + $as_T(String.fromCharCode(this$1)));
    i = ((1 + i) | 0)
  };
  return result
});
$c_jl_String$.prototype.format__T__AO__T = (function(format, args) {
  return $ct_ju_Formatter__(new $c_ju_Formatter()).format__T__AO__ju_Formatter(format, args).toString__T()
});
var $d_jl_String$ = new $TypeData().initClass({
  jl_String$: 0
}, false, "java.lang.String$", {
  jl_String$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_String$.prototype.$classData = $d_jl_String$;
var $n_jl_String$;
function $m_jl_String$() {
  if ((!$n_jl_String$)) {
    $n_jl_String$ = new $c_jl_String$()
  };
  return $n_jl_String$
}
/** @constructor */
function $c_jl_Thread(dummy) {
  this.jl_Thread__f_java$lang$Thread$$interruptedState = false;
  this.jl_Thread__f_name = null;
  this.jl_Thread__f_java$lang$Thread$$interruptedState = false;
  this.jl_Thread__f_name = "main"
}
$c_jl_Thread.prototype = new $h_O();
$c_jl_Thread.prototype.constructor = $c_jl_Thread;
/** @constructor */
function $h_jl_Thread() {
  /*<skip>*/
}
$h_jl_Thread.prototype = $c_jl_Thread.prototype;
$c_jl_Thread.prototype.run__V = (function() {
  /*<skip>*/
});
var $d_jl_Thread = new $TypeData().initClass({
  jl_Thread: 0
}, false, "java.lang.Thread", {
  jl_Thread: 1,
  O: 1,
  jl_Runnable: 1
});
$c_jl_Thread.prototype.$classData = $d_jl_Thread;
function $p_jl_Throwable__printStackTraceImpl__O__V($thiz, sprintln) {
  $thiz.getStackTrace__Ajl_StackTraceElement();
  sprintln($thiz.toString__T());
  if (($thiz.jl_Throwable__f_stackTrace.u.length !== 0)) {
    var i = 0;
    while ((i < $thiz.jl_Throwable__f_stackTrace.u.length)) {
      sprintln(("  at " + $thiz.jl_Throwable__f_stackTrace.get(i)));
      i = ((1 + i) | 0)
    }
  } else {
    sprintln("  <no stack trace available>")
  };
  var wCause = $thiz;
  while (true) {
    var $$x3 = wCause;
    var this$1 = wCause;
    if (($$x3 !== this$1.jl_Throwable__f_e)) {
      var this$2 = wCause;
      var $$x2 = (this$2.jl_Throwable__f_e !== null)
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      var parentTrace = wCause.getStackTrace__Ajl_StackTraceElement();
      var this$3 = wCause;
      wCause = this$3.jl_Throwable__f_e;
      var thisTrace = wCause.getStackTrace__Ajl_StackTraceElement();
      var thisLength = thisTrace.u.length;
      var parentLength = parentTrace.u.length;
      sprintln(("Caused by: " + wCause.toString__T()));
      if ((thisLength !== 0)) {
        var sameFrameCount = 0;
        while (true) {
          if (((sameFrameCount < thisLength) && (sameFrameCount < parentLength))) {
            var x = thisTrace.get((((-1) + ((thisLength - sameFrameCount) | 0)) | 0));
            var x$2 = parentTrace.get((((-1) + ((parentLength - sameFrameCount) | 0)) | 0));
            var $$x1 = ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
          } else {
            var $$x1 = false
          };
          if ($$x1) {
            sameFrameCount = ((1 + sameFrameCount) | 0)
          } else {
            break
          }
        };
        if ((sameFrameCount > 0)) {
          sameFrameCount = (((-1) + sameFrameCount) | 0)
        };
        var lengthToPrint = ((thisLength - sameFrameCount) | 0);
        var i$2 = 0;
        while ((i$2 < lengthToPrint)) {
          sprintln(("  at " + thisTrace.get(i$2)));
          i$2 = ((1 + i$2) | 0)
        };
        if ((sameFrameCount > 0)) {
          sprintln((("  ... " + sameFrameCount) + " more"))
        }
      } else {
        sprintln("  <no stack trace available>")
      }
    } else {
      break
    }
  }
}
function $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, e, enableSuppression, writableStackTrace) {
  $thiz.jl_Throwable__f_s = s;
  $thiz.jl_Throwable__f_e = e;
  $thiz.jl_Throwable__f_enableSuppression = enableSuppression;
  $thiz.jl_Throwable__f_writableStackTrace = writableStackTrace;
  if (writableStackTrace) {
    $thiz.fillInStackTrace__jl_Throwable()
  };
  return $thiz
}
/** @constructor */
function $c_jl_Throwable() {
  this.jl_Throwable__f_s = null;
  this.jl_Throwable__f_e = null;
  this.jl_Throwable__f_enableSuppression = false;
  this.jl_Throwable__f_writableStackTrace = false;
  this.jl_Throwable__f_stackTraceStateInternal = null;
  this.jl_Throwable__f_stackTrace = null;
  this.jl_Throwable__f_suppressed = null
}
/** @constructor */
var $hh_jl_Throwable = (function() {
  /*<skip>*/
});
$hh_jl_Throwable.prototype = Error.prototype;
$c_jl_Throwable.prototype = new $hh_jl_Throwable();
$c_jl_Throwable.prototype.constructor = $c_jl_Throwable;
/** @constructor */
function $h_jl_Throwable() {
  /*<skip>*/
}
$h_jl_Throwable.prototype = $c_jl_Throwable.prototype;
$c_jl_Throwable.prototype.getMessage__T = (function() {
  return this.jl_Throwable__f_s
});
$c_jl_Throwable.prototype.fillInStackTrace__jl_Throwable = (function() {
  var identifyingString = Object.prototype.toString.call(this);
  if ((identifyingString === "[object Error]")) {
    this.jl_Throwable__f_stackTraceStateInternal = this
  } else if ((Error.captureStackTrace === (void 0))) {
    var e = new Error();
    this.jl_Throwable__f_stackTraceStateInternal = e
  } else {
    Error.captureStackTrace(this);
    this.jl_Throwable__f_stackTraceStateInternal = this
  };
  return this
});
$c_jl_Throwable.prototype.getStackTrace__Ajl_StackTraceElement = (function() {
  if ((this.jl_Throwable__f_stackTrace === null)) {
    if (this.jl_Throwable__f_writableStackTrace) {
      var this$1 = $m_jl_StackTrace$();
      this.jl_Throwable__f_stackTrace = $p_jl_StackTrace$__extract__O__Ajl_StackTraceElement(this$1, this.jl_Throwable__f_stackTraceStateInternal)
    } else {
      this.jl_Throwable__f_stackTrace = new ($d_jl_StackTraceElement.getArrayOf().constr)(0)
    }
  };
  return this.jl_Throwable__f_stackTrace
});
$c_jl_Throwable.prototype.printStackTrace__Ljava_io_PrintStream__V = (function(s) {
  $p_jl_Throwable__printStackTraceImpl__O__V(this, (function(arg$outer, s$1) {
    return (function(arg1$2) {
      var arg1 = $as_T(arg1$2);
      s$1.println__T__V(arg1)
    })
  })(this, s))
});
$c_jl_Throwable.prototype.toString__T = (function() {
  var className = $objectClassName(this);
  var message = this.getMessage__T();
  return ((message === null) ? className : ((className + ": ") + message))
});
$c_jl_Throwable.prototype.$js$exported$meth$toString__O = (function() {
  return this.toString__T()
});
$c_jl_Throwable.prototype.$js$exported$prop$name__O = (function() {
  return $objectClassName(this)
});
$c_jl_Throwable.prototype.$js$exported$prop$message__O = (function() {
  var m = this.getMessage__T();
  return ((m === null) ? "" : m)
});
$c_jl_Throwable.prototype.hashCode__I = (function() {
  return $c_O.prototype.hashCode__I.call(this)
});
$c_jl_Throwable.prototype.equals__O__Z = (function(that) {
  return $c_O.prototype.equals__O__Z.call(this, that)
});
Object.defineProperty($c_jl_Throwable.prototype, "message", {
  "get": (function() {
    return this.$js$exported$prop$message__O()
  }),
  "configurable": true
});
Object.defineProperty($c_jl_Throwable.prototype, "name", {
  "get": (function() {
    return this.$js$exported$prop$name__O()
  }),
  "configurable": true
});
$c_jl_Throwable.prototype.toString = (function() {
  return this.$js$exported$meth$toString__O()
});
function $as_jl_Throwable(obj) {
  return (((obj instanceof $c_jl_Throwable) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Throwable"))
}
function $isArrayOf_jl_Throwable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Throwable)))
}
function $asArrayOf_jl_Throwable(obj, depth) {
  return (($isArrayOf_jl_Throwable(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Throwable;", depth))
}
var $d_jl_Throwable = new $TypeData().initClass({
  jl_Throwable: 0
}, false, "java.lang.Throwable", {
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_Throwable.prototype.$classData = $d_jl_Throwable;
/** @constructor */
function $c_Ljava_math_BigDecimal$() {
  this.Ljava_math_BigDecimal$__f_ZERO = null;
  this.Ljava_math_BigDecimal$__f_ONE = null;
  this.Ljava_math_BigDecimal$__f_TEN = null;
  this.Ljava_math_BigDecimal$__f_java$math$BigDecimal$$LongFivePows = null;
  this.Ljava_math_BigDecimal$__f_java$math$BigDecimal$$LongFivePowsBitLength = null;
  this.Ljava_math_BigDecimal$__f_LongTenPows = null;
  this.Ljava_math_BigDecimal$__f_java$math$BigDecimal$$LongTenPowsBitLength = null;
  this.Ljava_math_BigDecimal$__f_BigIntScaledByZero = null;
  this.Ljava_math_BigDecimal$__f_ZeroScaledBy = null;
  this.Ljava_math_BigDecimal$__f_java$math$BigDecimal$$CharZeros = null;
  $n_Ljava_math_BigDecimal$ = this;
  this.Ljava_math_BigDecimal$__f_ZERO = $ct_Ljava_math_BigDecimal__I__I__(new $c_Ljava_math_BigDecimal(), 0, 0);
  this.Ljava_math_BigDecimal$__f_ONE = $ct_Ljava_math_BigDecimal__I__I__(new $c_Ljava_math_BigDecimal(), 1, 0);
  this.Ljava_math_BigDecimal$__f_TEN = $ct_Ljava_math_BigDecimal__I__I__(new $c_Ljava_math_BigDecimal(), 10, 0);
  this.Ljava_math_BigDecimal$__f_java$math$BigDecimal$$LongFivePows = this.newArrayOfPows__I__I__AJ(28, 5);
  var n = this.Ljava_math_BigDecimal$__f_java$math$BigDecimal$$LongFivePows.u.length;
  $m_s_reflect_ManifestFactory$IntManifest$();
  if ((n <= 0)) {
    var $$x1 = new $ac_I(0)
  } else {
    var array = new $ac_I(n);
    var i = 0;
    while ((i < n)) {
      var $$x2 = i;
      var arg1 = i;
      array.set($$x2, $m_Ljava_math_BigDecimal$().bitLength__J__I($m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_java$math$BigDecimal$$LongFivePows.get(arg1)));
      i = ((1 + i) | 0)
    };
    var $$x1 = array
  };
  this.Ljava_math_BigDecimal$__f_java$math$BigDecimal$$LongFivePowsBitLength = $$x1;
  this.Ljava_math_BigDecimal$__f_LongTenPows = this.newArrayOfPows__I__I__AJ(19, 10);
  var n$1 = this.Ljava_math_BigDecimal$__f_LongTenPows.u.length;
  $m_s_reflect_ManifestFactory$IntManifest$();
  if ((n$1 <= 0)) {
    var $$x3 = new $ac_I(0)
  } else {
    var array$1 = new $ac_I(n$1);
    var i$1 = 0;
    while ((i$1 < n$1)) {
      var $$x4 = i$1;
      var arg1$1 = i$1;
      array$1.set($$x4, $m_Ljava_math_BigDecimal$().bitLength__J__I($m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_LongTenPows.get(arg1$1)));
      i$1 = ((1 + i$1) | 0)
    };
    var $$x3 = array$1
  };
  this.Ljava_math_BigDecimal$__f_java$math$BigDecimal$$LongTenPowsBitLength = $$x3;
  var array$2 = new ($d_Ljava_math_BigDecimal.getArrayOf().constr)(11);
  var i$2 = 0;
  while ((i$2 < 11)) {
    var $$x5 = i$2;
    var arg1$2 = i$2;
    array$2.set($$x5, $ct_Ljava_math_BigDecimal__I__I__(new $c_Ljava_math_BigDecimal(), arg1$2, 0));
    i$2 = ((1 + i$2) | 0)
  };
  this.Ljava_math_BigDecimal$__f_BigIntScaledByZero = array$2;
  var array$3 = new ($d_Ljava_math_BigDecimal.getArrayOf().constr)(11);
  var i$3 = 0;
  while ((i$3 < 11)) {
    var $$x6 = i$3;
    var arg1$3 = i$3;
    array$3.set($$x6, $ct_Ljava_math_BigDecimal__I__I__(new $c_Ljava_math_BigDecimal(), 0, arg1$3));
    i$3 = ((1 + i$3) | 0)
  };
  this.Ljava_math_BigDecimal$__f_ZeroScaledBy = array$3;
  this.Ljava_math_BigDecimal$__f_java$math$BigDecimal$$CharZeros = "0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000"
}
$c_Ljava_math_BigDecimal$.prototype = new $h_O();
$c_Ljava_math_BigDecimal$.prototype.constructor = $c_Ljava_math_BigDecimal$;
/** @constructor */
function $h_Ljava_math_BigDecimal$() {
  /*<skip>*/
}
$h_Ljava_math_BigDecimal$.prototype = $c_Ljava_math_BigDecimal$.prototype;
$c_Ljava_math_BigDecimal$.prototype.valueOf__J__I__Ljava_math_BigDecimal = (function(unscaledVal, scale) {
  return ((scale === 0) ? this.valueOf__J__Ljava_math_BigDecimal(unscaledVal) : (((((unscaledVal.RTLong__f_lo === 0) && (unscaledVal.RTLong__f_hi === 0)) && (scale >= 0)) && (scale < this.Ljava_math_BigDecimal$__f_ZeroScaledBy.u.length)) ? this.Ljava_math_BigDecimal$__f_ZeroScaledBy.get(scale) : $ct_Ljava_math_BigDecimal__J__I__(new $c_Ljava_math_BigDecimal(), unscaledVal, scale)))
});
$c_Ljava_math_BigDecimal$.prototype.valueOf__J__Ljava_math_BigDecimal = (function(unscaledVal) {
  var ahi = unscaledVal.RTLong__f_hi;
  if ((ahi >= 0)) {
    var ahi$1 = unscaledVal.RTLong__f_hi;
    var $$x1 = ((ahi$1 === 0) ? (((-2147483648) ^ unscaledVal.RTLong__f_lo) < (-2147483637)) : (ahi$1 < 0))
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    return this.Ljava_math_BigDecimal$__f_BigIntScaledByZero.get(unscaledVal.RTLong__f_lo)
  } else {
    return $ct_Ljava_math_BigDecimal__J__I__(new $c_Ljava_math_BigDecimal(), unscaledVal, 0)
  }
});
$c_Ljava_math_BigDecimal$.prototype.java$math$BigDecimal$$longCompareTo__J__J__I = (function(value1, value2) {
  var ahi = value1.RTLong__f_hi;
  var bhi = value2.RTLong__f_hi;
  if (((ahi === bhi) ? (((-2147483648) ^ value1.RTLong__f_lo) > ((-2147483648) ^ value2.RTLong__f_lo)) : (ahi > bhi))) {
    return 1
  } else {
    var ahi$1 = value1.RTLong__f_hi;
    var bhi$1 = value2.RTLong__f_hi;
    if (((ahi$1 === bhi$1) ? (((-2147483648) ^ value1.RTLong__f_lo) < ((-2147483648) ^ value2.RTLong__f_lo)) : (ahi$1 < bhi$1))) {
      return (-1)
    } else {
      return 0
    }
  }
});
$c_Ljava_math_BigDecimal$.prototype.newArrayOfPows__I__I__AJ = (function(len, pow) {
  $m_s_reflect_ManifestFactory$LongManifest$();
  if ((len > 0)) {
    var array = new $ac_J(len);
    var acc = new $c_RTLong(1, 0);
    var i = 1;
    array.set(0, $uJ(acc));
    while ((i < len)) {
      var arg1 = acc;
      var t = $uJ(arg1);
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      var hi$1 = (pow >> 31);
      var a0 = (65535 & lo);
      var a1 = ((lo >>> 16) | 0);
      var b0 = (65535 & pow);
      var b1 = ((pow >>> 16) | 0);
      var a0b0 = $imul(a0, b0);
      var a1b0 = $imul(a1, b0);
      var a0b1 = $imul(a0, b1);
      var lo$1 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi$2 = (((((((($imul(lo, hi$1) + $imul(hi, pow)) | 0) + $imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
      acc = new $c_RTLong(lo$1, hi$2);
      array.set(i, $uJ(acc));
      i = ((1 + i) | 0)
    };
    return array
  } else {
    return new $ac_J(0)
  }
});
$c_Ljava_math_BigDecimal$.prototype.java$math$BigDecimal$$roundingBehavior__I__I__Ljava_math_RoundingMode__I = (function(parityBit, fraction, roundingMode) {
  var absFraction = ((fraction < 0) ? ((-fraction) | 0) : fraction);
  var sigFraction = ((fraction === 0) ? 0 : ((fraction < 0) ? (-1) : 1));
  var x = $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_UP;
  if ((x === roundingMode)) {
    return sigFraction
  } else {
    var x$3 = $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_DOWN;
    if ((x$3 === roundingMode)) {
      return 0
    } else {
      var x$5 = $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_CEILING;
      if ((x$5 === roundingMode)) {
        return ((sigFraction > 0) ? sigFraction : 0)
      } else {
        var x$7 = $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_FLOOR;
        if ((x$7 === roundingMode)) {
          return ((sigFraction < 0) ? sigFraction : 0)
        } else {
          var x$9 = $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_HALF_UP;
          if ((x$9 === roundingMode)) {
            return ((absFraction >= 5) ? sigFraction : 0)
          } else {
            var x$11 = $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_HALF_DOWN;
            if ((x$11 === roundingMode)) {
              return ((absFraction > 5) ? sigFraction : 0)
            } else {
              var x$13 = $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_HALF_EVEN;
              if ((x$13 === roundingMode)) {
                return ((((absFraction + parityBit) | 0) > 5) ? sigFraction : 0)
              } else {
                var x$15 = $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_UNNECESSARY;
                if ((x$15 === roundingMode)) {
                  if ((fraction === 0)) {
                    return 0
                  } else {
                    throw new $c_jl_ArithmeticException("Rounding necessary")
                  }
                } else {
                  throw new $c_s_MatchError(roundingMode)
                }
              }
            }
          }
        }
      }
    }
  }
});
$c_Ljava_math_BigDecimal$.prototype.java$math$BigDecimal$$safeLongToInt__J__I = (function(longValue) {
  var ahi = longValue.RTLong__f_hi;
  if (((ahi === (-1)) ? (((-2147483648) ^ longValue.RTLong__f_lo) < 0) : (ahi < (-1)))) {
    var $$x1 = true
  } else {
    var ahi$1 = longValue.RTLong__f_hi;
    var $$x1 = ((ahi$1 === 0) ? (((-2147483648) ^ longValue.RTLong__f_lo) > (-1)) : (ahi$1 > 0))
  };
  if ($$x1) {
    throw new $c_jl_ArithmeticException(("Out of int range: " + longValue))
  };
  return longValue.RTLong__f_lo
});
$c_Ljava_math_BigDecimal$.prototype.java$math$BigDecimal$$zeroScaledBy__J__Ljava_math_BigDecimal = (function(longScale) {
  var value = longScale.RTLong__f_lo;
  var hi = (value >> 31);
  if (((longScale.RTLong__f_lo === value) && (longScale.RTLong__f_hi === hi))) {
    return this.valueOf__J__I__Ljava_math_BigDecimal($L0, longScale.RTLong__f_lo)
  } else {
    var ahi = longScale.RTLong__f_hi;
    if ((ahi >= 0)) {
      return $ct_Ljava_math_BigDecimal__I__I__(new $c_Ljava_math_BigDecimal(), 0, 2147483647)
    } else {
      return $ct_Ljava_math_BigDecimal__I__I__(new $c_Ljava_math_BigDecimal(), 0, (-2147483648))
    }
  }
});
$c_Ljava_math_BigDecimal$.prototype.bitLength__J__I = (function(sValue) {
  var ahi = sValue.RTLong__f_hi;
  if ((ahi < 0)) {
    var lo = (~sValue.RTLong__f_lo);
    var hi = (~sValue.RTLong__f_hi);
    var x__lo = lo;
    var x__hi = hi;
    var t = new $c_RTLong(x__lo, x__hi)
  } else {
    var t = sValue
  };
  var lo$1 = t.RTLong__f_lo;
  var hi$1 = t.RTLong__f_hi;
  return ((64 - ((hi$1 !== 0) ? $clz32(hi$1) : ((32 + $clz32(lo$1)) | 0))) | 0)
});
$c_Ljava_math_BigDecimal$.prototype.java$math$BigDecimal$$bitLength__I__I = (function(sValue) {
  var smallValue = ((sValue < 0) ? (~sValue) : sValue);
  return ((32 - $clz32(smallValue)) | 0)
});
var $d_Ljava_math_BigDecimal$ = new $TypeData().initClass({
  Ljava_math_BigDecimal$: 0
}, false, "java.math.BigDecimal$", {
  Ljava_math_BigDecimal$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_math_BigDecimal$.prototype.$classData = $d_Ljava_math_BigDecimal$;
var $n_Ljava_math_BigDecimal$;
function $m_Ljava_math_BigDecimal$() {
  if ((!$n_Ljava_math_BigDecimal$)) {
    $n_Ljava_math_BigDecimal$ = new $c_Ljava_math_BigDecimal$()
  };
  return $n_Ljava_math_BigDecimal$
}
/** @constructor */
function $c_Ljava_math_BigInteger$() {
  this.Ljava_math_BigInteger$__f_ONE = null;
  this.Ljava_math_BigInteger$__f_TEN = null;
  this.Ljava_math_BigInteger$__f_ZERO = null;
  this.Ljava_math_BigInteger$__f_MINUS_ONE = null;
  this.Ljava_math_BigInteger$__f_SMALL_VALUES = null;
  this.Ljava_math_BigInteger$__f_TWO_POWS = null;
  $n_Ljava_math_BigInteger$ = this;
  this.Ljava_math_BigInteger$__f_ONE = $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 1);
  this.Ljava_math_BigInteger$__f_TEN = $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 10);
  this.Ljava_math_BigInteger$__f_ZERO = $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 0, 0);
  this.Ljava_math_BigInteger$__f_MINUS_ONE = $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), (-1), 1);
  this.Ljava_math_BigInteger$__f_SMALL_VALUES = new ($d_Ljava_math_BigInteger.getArrayOf().constr)([this.Ljava_math_BigInteger$__f_ZERO, this.Ljava_math_BigInteger$__f_ONE, $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 2), $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 3), $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 4), $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 5), $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 6), $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 7), $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 8), $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 9), this.Ljava_math_BigInteger$__f_TEN]);
  var array = new ($d_Ljava_math_BigInteger.getArrayOf().constr)(32);
  var i = 0;
  while ((i < 32)) {
    var $$x2 = i;
    var arg1 = i;
    var $$x1 = $m_Ljava_math_BigInteger$();
    var lo = (((32 & arg1) === 0) ? (1 << arg1) : 0);
    var hi = (((32 & arg1) === 0) ? 0 : (1 << arg1));
    array.set($$x2, $$x1.valueOf__J__Ljava_math_BigInteger(new $c_RTLong(lo, hi)));
    i = ((1 + i) | 0)
  };
  this.Ljava_math_BigInteger$__f_TWO_POWS = array
}
$c_Ljava_math_BigInteger$.prototype = new $h_O();
$c_Ljava_math_BigInteger$.prototype.constructor = $c_Ljava_math_BigInteger$;
/** @constructor */
function $h_Ljava_math_BigInteger$() {
  /*<skip>*/
}
$h_Ljava_math_BigInteger$.prototype = $c_Ljava_math_BigInteger$.prototype;
$c_Ljava_math_BigInteger$.prototype.valueOf__J__Ljava_math_BigInteger = (function(lVal) {
  var ahi = lVal.RTLong__f_hi;
  if ((ahi < 0)) {
    if ((!((lVal.RTLong__f_lo === (-1)) && (lVal.RTLong__f_hi === (-1))))) {
      var lo = lVal.RTLong__f_lo;
      var hi = lVal.RTLong__f_hi;
      var lo$1 = ((-lo) | 0);
      var hi$1 = ((lo !== 0) ? (~hi) : ((-hi) | 0));
      return $ct_Ljava_math_BigInteger__I__J__(new $c_Ljava_math_BigInteger(), (-1), new $c_RTLong(lo$1, hi$1))
    } else {
      return this.Ljava_math_BigInteger$__f_MINUS_ONE
    }
  } else {
    var ahi$1 = lVal.RTLong__f_hi;
    if (((ahi$1 === 0) ? (((-2147483648) ^ lVal.RTLong__f_lo) <= (-2147483638)) : (ahi$1 < 0))) {
      return this.Ljava_math_BigInteger$__f_SMALL_VALUES.get(lVal.RTLong__f_lo)
    } else {
      return $ct_Ljava_math_BigInteger__I__J__(new $c_Ljava_math_BigInteger(), 1, lVal)
    }
  }
});
$c_Ljava_math_BigInteger$.prototype.getPowerOfTwo__I__Ljava_math_BigInteger = (function(exp) {
  if ((exp < this.Ljava_math_BigInteger$__f_TWO_POWS.u.length)) {
    return this.Ljava_math_BigInteger$__f_TWO_POWS.get(exp)
  } else {
    var intCount = (exp >> 5);
    var bitN = (31 & exp);
    var resDigits = new $ac_I(((1 + intCount) | 0));
    resDigits.set(intCount, (1 << bitN));
    return $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), 1, ((1 + intCount) | 0), resDigits)
  }
});
var $d_Ljava_math_BigInteger$ = new $TypeData().initClass({
  Ljava_math_BigInteger$: 0
}, false, "java.math.BigInteger$", {
  Ljava_math_BigInteger$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_math_BigInteger$.prototype.$classData = $d_Ljava_math_BigInteger$;
var $n_Ljava_math_BigInteger$;
function $m_Ljava_math_BigInteger$() {
  if ((!$n_Ljava_math_BigInteger$)) {
    $n_Ljava_math_BigInteger$ = new $c_Ljava_math_BigInteger$()
  };
  return $n_Ljava_math_BigInteger$
}
/** @constructor */
function $c_Ljava_math_RoundingMode$() {
  this.Ljava_math_RoundingMode$__f_UP = null;
  this.Ljava_math_RoundingMode$__f_DOWN = null;
  this.Ljava_math_RoundingMode$__f_CEILING = null;
  this.Ljava_math_RoundingMode$__f_FLOOR = null;
  this.Ljava_math_RoundingMode$__f_HALF_UP = null;
  this.Ljava_math_RoundingMode$__f_HALF_DOWN = null;
  this.Ljava_math_RoundingMode$__f_HALF_EVEN = null;
  this.Ljava_math_RoundingMode$__f_UNNECESSARY = null;
  this.Ljava_math_RoundingMode$__f__values = null;
  $n_Ljava_math_RoundingMode$ = this;
  this.Ljava_math_RoundingMode$__f_UP = new $c_Ljava_math_RoundingMode("UP", 0);
  this.Ljava_math_RoundingMode$__f_DOWN = new $c_Ljava_math_RoundingMode("DOWN", 1);
  this.Ljava_math_RoundingMode$__f_CEILING = new $c_Ljava_math_RoundingMode("CEILING", 2);
  this.Ljava_math_RoundingMode$__f_FLOOR = new $c_Ljava_math_RoundingMode("FLOOR", 3);
  this.Ljava_math_RoundingMode$__f_HALF_UP = new $c_Ljava_math_RoundingMode("HALF_UP", 4);
  this.Ljava_math_RoundingMode$__f_HALF_DOWN = new $c_Ljava_math_RoundingMode("HALF_DOWN", 5);
  this.Ljava_math_RoundingMode$__f_HALF_EVEN = new $c_Ljava_math_RoundingMode("HALF_EVEN", 6);
  this.Ljava_math_RoundingMode$__f_UNNECESSARY = new $c_Ljava_math_RoundingMode("UNNECESSARY", 7);
  this.Ljava_math_RoundingMode$__f__values = new ($d_Ljava_math_RoundingMode.getArrayOf().constr)([this.Ljava_math_RoundingMode$__f_UP, this.Ljava_math_RoundingMode$__f_DOWN, this.Ljava_math_RoundingMode$__f_CEILING, this.Ljava_math_RoundingMode$__f_FLOOR, this.Ljava_math_RoundingMode$__f_HALF_UP, this.Ljava_math_RoundingMode$__f_HALF_DOWN, this.Ljava_math_RoundingMode$__f_HALF_EVEN, this.Ljava_math_RoundingMode$__f_UNNECESSARY])
}
$c_Ljava_math_RoundingMode$.prototype = new $h_O();
$c_Ljava_math_RoundingMode$.prototype.constructor = $c_Ljava_math_RoundingMode$;
/** @constructor */
function $h_Ljava_math_RoundingMode$() {
  /*<skip>*/
}
$h_Ljava_math_RoundingMode$.prototype = $c_Ljava_math_RoundingMode$.prototype;
var $d_Ljava_math_RoundingMode$ = new $TypeData().initClass({
  Ljava_math_RoundingMode$: 0
}, false, "java.math.RoundingMode$", {
  Ljava_math_RoundingMode$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_math_RoundingMode$.prototype.$classData = $d_Ljava_math_RoundingMode$;
var $n_Ljava_math_RoundingMode$;
function $m_Ljava_math_RoundingMode$() {
  if ((!$n_Ljava_math_RoundingMode$)) {
    $n_Ljava_math_RoundingMode$ = new $c_Ljava_math_RoundingMode$()
  };
  return $n_Ljava_math_RoundingMode$
}
function $p_Ljava_net_URI$__loop$1__I__T__T__I($thiz, i, x$13, y$2) {
  while (true) {
    if (((i >= $uI(x$13.length)) || (i >= $uI(y$2.length)))) {
      return (($uI(x$13.length) - $uI(y$2.length)) | 0)
    } else {
      var index = i;
      var $$x1 = $uI(x$13.charCodeAt(index));
      var index$1 = i;
      var diff = (((65535 & $$x1) - (65535 & $uI(y$2.charCodeAt(index$1)))) | 0);
      if ((diff !== 0)) {
        return diff
      } else {
        var index$2 = i;
        if (((65535 & $uI(x$13.charCodeAt(index$2))) === 37)) {
          if (((((2 + i) | 0) >= $uI(x$13.length)) || (((2 + i) | 0) >= $uI(y$2.length)))) {
            throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), "Invalid escape in URI")
          };
          var beginIndex = ((1 + i) | 0);
          var endIndex = ((3 + i) | 0);
          var $$x2 = $as_T(x$13.substring(beginIndex, endIndex));
          var beginIndex$1 = ((1 + i) | 0);
          var endIndex$1 = ((3 + i) | 0);
          var cmp = $f_T__compareToIgnoreCase__T__I($$x2, $as_T(y$2.substring(beginIndex$1, endIndex$1)));
          if ((cmp !== 0)) {
            return cmp
          } else {
            i = ((3 + i) | 0)
          }
        } else {
          i = ((1 + i) | 0)
        }
      }
    }
  }
}
/** @constructor */
function $c_Ljava_net_URI$() {
  this.Ljava_net_URI$__f_ipv4address = null;
  this.Ljava_net_URI$__f_ipv6address = null;
  this.Ljava_net_URI$__f_ipv6Re = null;
  this.Ljava_net_URI$__f_java$net$URI$$uriRe = null;
  this.Ljava_net_URI$__f_quoteStr = null;
  this.Ljava_net_URI$__f_userInfoQuoteRe = null;
  this.Ljava_net_URI$__f_pathQuoteRe = null;
  this.Ljava_net_URI$__f_authorityQuoteRe = null;
  this.Ljava_net_URI$__f_illegalQuoteRe = null;
  this.Ljava_net_URI$__f_nonASCIIQuoteRe = null;
  $n_Ljava_net_URI$ = this;
  this.Ljava_net_URI$__f_ipv4address = "(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)";
  var ipv4 = this.Ljava_net_URI$__f_ipv4address;
  this.Ljava_net_URI$__f_ipv6address = (((((((((((((("(?:(?:[0-9a-f]{1,4}:){7}[0-9a-f]{1,4}|(?:[0-9a-f]{1,4}:){1,7}:|(?:[0-9a-f]{1,4}:){1,6}(?::[0-9a-f]{1,4})|(?:[0-9a-f]{1,4}:){1,5}(?::[0-9a-f]{1,4}){1,2}|(?:[0-9a-f]{1,4}:){1,4}(?::[0-9a-f]{1,4}){1,3}|(?:[0-9a-f]{1,4}:){1,3}(?::[0-9a-f]{1,4}){1,4}|(?:[0-9a-f]{1,4}:){1,2}(?::[0-9a-f]{1,4}){1,5}|(?:[0-9a-f]{1,4}:)(?::[0-9a-f]{1,4}){1,6}|:(?:(?::[0-9a-f]{1,4}){1,7}|:)|(?:[0-9a-f]{1,4}:){6}" + ipv4) + "|(?:[0-9a-f]{1,4}:){1,5}:") + ipv4) + "|(?:[0-9a-f]{1,4}:){1,4}(?::[0-9a-f]{1,4}):") + ipv4) + "|(?:[0-9a-f]{1,4}:){1,3}(?::[0-9a-f]{1,4}){1,2}:") + ipv4) + "|(?:[0-9a-f]{1,4}:){1,2}(?::[0-9a-f]{1,4}){1,3}:") + ipv4) + "|(?:[0-9a-f]{1,4}:)(?::[0-9a-f]{1,4}){1,4}:") + ipv4) + "|::(?:[0-9a-f]{1,4}:){1,5}") + ipv4) + ")(?:%[0-9a-z]+)?");
  this.Ljava_net_URI$__f_ipv6Re = new RegExp((("^" + this.Ljava_net_URI$__f_ipv6address) + "$"), "i");
  var ipv6reference = (("\\[(?:" + this.Ljava_net_URI$__f_ipv6address) + ")\\]");
  var host = (((("((?:(?:[a-z0-9]|[a-z0-9][a-z0-9-]*[a-z0-9])\\.)*(?:[a-z]|[a-z][a-z0-9-]*[a-z0-9])\\.?|" + this.Ljava_net_URI$__f_ipv4address) + "|") + ipv6reference) + ")");
  var hostport = (host + "(?::([0-9]*))?");
  var server = (("(?:(?:((?:[a-z0-9-_.!~*'();:&=+$,]|%[a-f0-9]{2}|[^\u0000-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])*)@)?" + hostport) + ")?");
  var authority = (server + "|(?:[a-z0-9-_.!~*'()$,;:@&=+]|%[a-f0-9]{2}|[^\u0000-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])+");
  var net_path = (("//(" + authority) + ")(/(?:[a-z0-9-_.!~*'():@&=+$,]|%[a-f0-9]{2}|[^\u0000-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])*(?:;(?:[a-z0-9-_.!~*'():@&=+$,]|%[a-f0-9]{2}|[^\u0000-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])*)*(?:/(?:[a-z0-9-_.!~*'():@&=+$,]|%[a-f0-9]{2}|[^\u0000-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])*(?:;(?:[a-z0-9-_.!~*'():@&=+$,]|%[a-f0-9]{2}|[^\u0000-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])*)*)*)?");
  var hier_part = (("(?:" + net_path) + "|(/(?:[a-z0-9-_.!~*'():@&=+$,]|%[a-f0-9]{2}|[^\u0000-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])*(?:;(?:[a-z0-9-_.!~*'():@&=+$,]|%[a-f0-9]{2}|[^\u0000-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])*)*(?:/(?:[a-z0-9-_.!~*'():@&=+$,]|%[a-f0-9]{2}|[^\u0000-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])*(?:;(?:[a-z0-9-_.!~*'():@&=+$,]|%[a-f0-9]{2}|[^\u0000-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])*)*)*))(?:\\?((?:[;/?:@&=+$,\\[\\]a-z0-9-_.!~*'()]|%[a-f0-9]{2}|[^\u0000-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])*))?");
  var absoluteURI = (("([a-z][a-z0-9+-.]*):(?:(" + hier_part) + ")|((?:[a-z0-9-_.!~*'();?:@&=+$,]|%[a-f0-9]{2})(?:[;/?:@&=+$,\\[\\]a-z0-9-_.!~*'()]|%[a-f0-9]{2}|[^\u0000-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])*))");
  var relativeURI = (("((?:" + net_path) + "|(/(?:[a-z0-9-_.!~*'():@&=+$,]|%[a-f0-9]{2}|[^\u0000-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])*(?:;(?:[a-z0-9-_.!~*'():@&=+$,]|%[a-f0-9]{2}|[^\u0000-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])*)*(?:/(?:[a-z0-9-_.!~*'():@&=+$,]|%[a-f0-9]{2}|[^\u0000-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])*(?:;(?:[a-z0-9-_.!~*'():@&=+$,]|%[a-f0-9]{2}|[^\u0000-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])*)*)*)|((?:[a-z0-9-_.!~*'();@&=+$,]|%[a-f0-9]{2})*(?:/(?:[a-z0-9-_.!~*'():@&=+$,]|%[a-f0-9]{2}|[^\u0000-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])*(?:;(?:[a-z0-9-_.!~*'():@&=+$,]|%[a-f0-9]{2}|[^\u0000-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])*)*(?:/(?:[a-z0-9-_.!~*'():@&=+$,]|%[a-f0-9]{2}|[^\u0000-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])*(?:;(?:[a-z0-9-_.!~*'():@&=+$,]|%[a-f0-9]{2}|[^\u0000-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])*)*)*)?))(?:\\?((?:[;/?:@&=+$,\\[\\]a-z0-9-_.!~*'()]|%[a-f0-9]{2}|[^\u0000-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])*))?)");
  var uriRef = (((("^(?:" + absoluteURI) + "|") + relativeURI) + ")(?:#((?:[;/?:@&=+$,\\[\\]a-z0-9-_.!~*'()]|%[a-f0-9]{2}|[^\u0000-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])*))?$");
  this.Ljava_net_URI$__f_java$net$URI$$uriRe = new RegExp(uriRef, "i");
  this.Ljava_net_URI$__f_quoteStr = (function(arg1$2) {
    var arg1 = $as_T(arg1$2);
    return $m_Ljava_net_URI$().java$net$URI$$$anonfun$quoteStr$1__T__T(arg1)
  });
  this.Ljava_net_URI$__f_userInfoQuoteRe = new RegExp("[\u0000- \"#/<>?@\\[-\\^`{-}\u007f-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029]|%(?![0-9a-f]{2})", "ig");
  this.Ljava_net_URI$__f_pathQuoteRe = new RegExp("[\u0000- \"#<>?\\[-\\^`{-}\u007f-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029]|%(?![0-9a-f]{2})", "ig");
  this.Ljava_net_URI$__f_authorityQuoteRe = new RegExp("[\u0000- \"#/<>?\\^`{-}\u007f-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029]|%(?![0-9a-f]{2})", "ig");
  this.Ljava_net_URI$__f_illegalQuoteRe = new RegExp("[\u0000- \"#<>@\\^`{-}\u007f-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029]|%(?![0-9a-f]{2})", "ig");
  this.Ljava_net_URI$__f_nonASCIIQuoteRe = new RegExp("[^\u0000-\u007f]+", "g")
}
$c_Ljava_net_URI$.prototype = new $h_O();
$c_Ljava_net_URI$.prototype.constructor = $c_Ljava_net_URI$;
/** @constructor */
function $h_Ljava_net_URI$() {
  /*<skip>*/
}
$h_Ljava_net_URI$.prototype = $c_Ljava_net_URI$.prototype;
$c_Ljava_net_URI$.prototype.java$net$URI$$normalizeEscapes__sjs_js_$bar__sjs_js_$bar = (function(maybeStr) {
  if ((maybeStr === (void 0))) {
    return (void 0)
  } else {
    var str = $as_T(maybeStr);
    var i = 0;
    var res = "";
    while ((i < $uI(str.length))) {
      var index = i;
      if (((65535 & $uI(str.charCodeAt(index))) === 37)) {
        if ((((2 + i) | 0) >= $uI(str.length))) {
          throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), "Invalid escape in URI")
        };
        var $$x1 = res;
        var beginIndex = i;
        var endIndex = ((3 + i) | 0);
        var this$6 = $as_T(str.substring(beginIndex, endIndex));
        res = (("" + $$x1) + $as_T(this$6.toUpperCase()));
        i = ((3 + i) | 0)
      } else {
        var $$x2 = res;
        var beginIndex$1 = i;
        var endIndex$1 = ((1 + i) | 0);
        res = (("" + $$x2) + $as_T(str.substring(beginIndex$1, endIndex$1)));
        i = ((1 + i) | 0)
      }
    };
    var a = res;
    return a
  }
});
$c_Ljava_net_URI$.prototype.java$net$URI$$$anonfun$quoteStr$1__T__T = (function(str) {
  var buf = $m_Ljava_nio_charset_UTF\uff3f8$().encode__T__Ljava_nio_ByteBuffer(str);
  var res = "";
  while ((buf.Ljava_nio_Buffer__f_java$nio$Buffer$$_position !== buf.Ljava_nio_Buffer__f__limit)) {
    var c = (255 & buf.get__B());
    var $$x1 = res;
    var this$3 = $as_T($uD((c >>> 0)).toString(16));
    res = (($$x1 + ((c <= 15) ? "%0" : "%")) + $as_T(this$3.toUpperCase()))
  };
  return res
});
var $d_Ljava_net_URI$ = new $TypeData().initClass({
  Ljava_net_URI$: 0
}, false, "java.net.URI$", {
  Ljava_net_URI$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_net_URI$.prototype.$classData = $d_Ljava_net_URI$;
var $n_Ljava_net_URI$;
function $m_Ljava_net_URI$() {
  if ((!$n_Ljava_net_URI$)) {
    $n_Ljava_net_URI$ = new $c_Ljava_net_URI$()
  };
  return $n_Ljava_net_URI$
}
function $p_Ljava_nio_charset_Charset__cachedEncoder$lzycompute__Ljava_nio_charset_CharsetEncoder($thiz) {
  if (((((4 & $thiz.Ljava_nio_charset_Charset__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Ljava_nio_charset_Charset__f_cachedEncoder = new $c_Ljava_nio_charset_UTF\uff3f8$Encoder().onMalformedInput__Ljava_nio_charset_CodingErrorAction__Ljava_nio_charset_CharsetEncoder($m_Ljava_nio_charset_CodingErrorAction$().Ljava_nio_charset_CodingErrorAction$__f_REPLACE).onUnmappableCharacter__Ljava_nio_charset_CodingErrorAction__Ljava_nio_charset_CharsetEncoder($m_Ljava_nio_charset_CodingErrorAction$().Ljava_nio_charset_CodingErrorAction$__f_REPLACE);
    $thiz.Ljava_nio_charset_Charset__f_bitmap$0 = (((4 | $thiz.Ljava_nio_charset_Charset__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Ljava_nio_charset_Charset__f_cachedEncoder
}
function $p_Ljava_nio_charset_Charset__cachedEncoder__Ljava_nio_charset_CharsetEncoder($thiz) {
  return (((((4 & $thiz.Ljava_nio_charset_Charset__f_bitmap$0) << 24) >> 24) === 0) ? $p_Ljava_nio_charset_Charset__cachedEncoder$lzycompute__Ljava_nio_charset_CharsetEncoder($thiz) : $thiz.Ljava_nio_charset_Charset__f_cachedEncoder)
}
function $ct_Ljava_nio_charset_Charset__T__AT__($thiz, canonicalName, _aliases) {
  $thiz.Ljava_nio_charset_Charset__f_canonicalName = canonicalName;
  $thiz.Ljava_nio_charset_Charset__f_java$nio$charset$Charset$$_aliases = _aliases;
  return $thiz
}
/** @constructor */
function $c_Ljava_nio_charset_Charset() {
  this.Ljava_nio_charset_Charset__f_aliasesSet = null;
  this.Ljava_nio_charset_Charset__f_cachedDecoder = null;
  this.Ljava_nio_charset_Charset__f_cachedEncoder = null;
  this.Ljava_nio_charset_Charset__f_canonicalName = null;
  this.Ljava_nio_charset_Charset__f_java$nio$charset$Charset$$_aliases = null;
  this.Ljava_nio_charset_Charset__f_bitmap$0 = 0
}
$c_Ljava_nio_charset_Charset.prototype = new $h_O();
$c_Ljava_nio_charset_Charset.prototype.constructor = $c_Ljava_nio_charset_Charset;
/** @constructor */
function $h_Ljava_nio_charset_Charset() {
  /*<skip>*/
}
$h_Ljava_nio_charset_Charset.prototype = $c_Ljava_nio_charset_Charset.prototype;
$c_Ljava_nio_charset_Charset.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_Ljava_nio_charset_Charset)) {
    var x2 = $as_Ljava_nio_charset_Charset(that);
    return (this.Ljava_nio_charset_Charset__f_canonicalName === x2.Ljava_nio_charset_Charset__f_canonicalName)
  } else {
    return false
  }
});
$c_Ljava_nio_charset_Charset.prototype.toString__T = (function() {
  return this.Ljava_nio_charset_Charset__f_canonicalName
});
$c_Ljava_nio_charset_Charset.prototype.hashCode__I = (function() {
  var x = this.Ljava_nio_charset_Charset__f_canonicalName;
  return $m_sr_Statics$().anyHash__O__I(x)
});
$c_Ljava_nio_charset_Charset.prototype.encode__T__Ljava_nio_ByteBuffer = (function(str) {
  var this$1 = $m_Ljava_nio_CharBuffer$();
  var cb = this$1.wrap__jl_CharSequence__I__I__Ljava_nio_CharBuffer(str, 0, $uI(str.length));
  return $p_Ljava_nio_charset_Charset__cachedEncoder__Ljava_nio_charset_CharsetEncoder(this).encode__Ljava_nio_CharBuffer__Ljava_nio_ByteBuffer(cb)
});
function $as_Ljava_nio_charset_Charset(obj) {
  return (((obj instanceof $c_Ljava_nio_charset_Charset) || (obj === null)) ? obj : $throwClassCastException(obj, "java.nio.charset.Charset"))
}
function $isArrayOf_Ljava_nio_charset_Charset(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_nio_charset_Charset)))
}
function $asArrayOf_Ljava_nio_charset_Charset(obj, depth) {
  return (($isArrayOf_Ljava_nio_charset_Charset(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.nio.charset.Charset;", depth))
}
function $p_Ljava_nio_charset_UTF\uff3f8$Encoder__encodeLoopArray__Ljava_nio_CharBuffer__Ljava_nio_ByteBuffer__Ljava_nio_charset_CoderResult($thiz, in$1, out) {
  var a = in$1.Ljava_nio_CharBuffer__f__array;
  if ((a === null)) {
    throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException())
  };
  throw new $c_Ljava_nio_ReadOnlyBufferException()
}
/** @constructor */
function $c_Ljava_nio_charset_UTF\uff3f8$Encoder() {
  this.Ljava_nio_charset_CharsetEncoder__f_cs = null;
  this.Ljava_nio_charset_CharsetEncoder__f__averageBytesPerChar = 0.0;
  this.Ljava_nio_charset_CharsetEncoder__f__maxBytesPerChar = 0.0;
  this.Ljava_nio_charset_CharsetEncoder__f__replacement = null;
  this.Ljava_nio_charset_CharsetEncoder__f__malformedInputAction = null;
  this.Ljava_nio_charset_CharsetEncoder__f__unmappableCharacterAction = null;
  this.Ljava_nio_charset_CharsetEncoder__f_status = 0;
  $ct_Ljava_nio_charset_CharsetEncoder__Ljava_nio_charset_Charset__F__F__(this, $m_Ljava_nio_charset_UTF\uff3f8$(), 1.100000023841858, 3.0)
}
$c_Ljava_nio_charset_UTF\uff3f8$Encoder.prototype = new $h_Ljava_nio_charset_CharsetEncoder();
$c_Ljava_nio_charset_UTF\uff3f8$Encoder.prototype.constructor = $c_Ljava_nio_charset_UTF\uff3f8$Encoder;
/** @constructor */
function $h_Ljava_nio_charset_UTF\uff3f8$Encoder() {
  /*<skip>*/
}
$h_Ljava_nio_charset_UTF\uff3f8$Encoder.prototype = $c_Ljava_nio_charset_UTF\uff3f8$Encoder.prototype;
$c_Ljava_nio_charset_UTF\uff3f8$Encoder.prototype.encodeLoop__Ljava_nio_CharBuffer__Ljava_nio_ByteBuffer__Ljava_nio_charset_CoderResult = (function(in$1, out) {
  if ((false && ((out.Ljava_nio_ByteBuffer__f__array !== null) && (!out.Ljava_nio_HeapByteBuffer__f__readOnly)))) {
    return $p_Ljava_nio_charset_UTF\uff3f8$Encoder__encodeLoopArray__Ljava_nio_CharBuffer__Ljava_nio_ByteBuffer__Ljava_nio_charset_CoderResult(this, in$1, out)
  } else {
    while (true) {
      if ((in$1.Ljava_nio_Buffer__f_java$nio$Buffer$$_position === in$1.Ljava_nio_Buffer__f__limit)) {
        return $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_UNDERFLOW
      } else {
        var c1 = in$1.get__C();
        if ((c1 < 128)) {
          if ((out.Ljava_nio_Buffer__f_java$nio$Buffer$$_position === out.Ljava_nio_Buffer__f__limit)) {
            var result = $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_OVERFLOW;
            var newPosition = (((-1) + in$1.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0);
            $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(in$1, newPosition);
            return result
          } else {
            out.put__B__Ljava_nio_ByteBuffer(((c1 << 24) >> 24))
          }
        } else if ((c1 < 2048)) {
          if ((((out.Ljava_nio_Buffer__f__limit - out.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0) < 2)) {
            var result$1 = $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_OVERFLOW;
            var newPosition$1 = (((-1) + in$1.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0);
            $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(in$1, newPosition$1);
            return result$1
          } else {
            out.put__B__Ljava_nio_ByteBuffer((((192 | (c1 >> 6)) << 24) >> 24));
            out.put__B__Ljava_nio_ByteBuffer((((128 | (63 & c1)) << 24) >> 24))
          }
        } else if ((!($m_Ljava_nio_charset_UTF\uff3f8$(), ((63488 & c1) === 55296)))) {
          if ((((out.Ljava_nio_Buffer__f__limit - out.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0) < 3)) {
            var result$2 = $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_OVERFLOW;
            var newPosition$2 = (((-1) + in$1.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0);
            $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(in$1, newPosition$2);
            return result$2
          } else {
            out.put__B__Ljava_nio_ByteBuffer((((224 | (c1 >> 12)) << 24) >> 24));
            out.put__B__Ljava_nio_ByteBuffer((((128 | (63 & (c1 >> 6))) << 24) >> 24));
            out.put__B__Ljava_nio_ByteBuffer((((128 | (63 & c1)) << 24) >> 24))
          }
        } else if (((64512 & c1) === 55296)) {
          if ((in$1.Ljava_nio_Buffer__f_java$nio$Buffer$$_position === in$1.Ljava_nio_Buffer__f__limit)) {
            var result$3 = $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_UNDERFLOW;
            var newPosition$3 = (((-1) + in$1.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0);
            $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(in$1, newPosition$3);
            return result$3
          } else {
            var c2 = in$1.get__C();
            if (((64512 & c2) !== 56320)) {
              var this$8 = $m_Ljava_nio_charset_CoderResult$();
              var result$4 = this$8.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed1;
              var newPosition$4 = (((-2) + in$1.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0);
              $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(in$1, newPosition$4);
              return result$4
            } else if ((((out.Ljava_nio_Buffer__f__limit - out.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0) < 4)) {
              var result$5 = $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_OVERFLOW;
              var newPosition$5 = (((-2) + in$1.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0);
              $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(in$1, newPosition$5);
              return result$5
            } else {
              var cp = ((((64 + (1023 & c1)) | 0) << 10) | (1023 & c2));
              out.put__B__Ljava_nio_ByteBuffer((((240 | (cp >> 18)) << 24) >> 24));
              out.put__B__Ljava_nio_ByteBuffer((((128 | (63 & (cp >> 12))) << 24) >> 24));
              out.put__B__Ljava_nio_ByteBuffer((((128 | (63 & (cp >> 6))) << 24) >> 24));
              out.put__B__Ljava_nio_ByteBuffer((((128 | (63 & cp)) << 24) >> 24))
            }
          }
        } else {
          var this$10 = $m_Ljava_nio_charset_CoderResult$();
          var result$6 = this$10.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed1;
          var newPosition$6 = (((-1) + in$1.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0);
          $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(in$1, newPosition$6);
          return result$6
        }
      }
    }
  }
});
var $d_Ljava_nio_charset_UTF\uff3f8$Encoder = new $TypeData().initClass({
  Ljava_nio_charset_UTF\uff3f8$Encoder: 0
}, false, "java.nio.charset.UTF_8$Encoder", {
  Ljava_nio_charset_UTF\uff3f8$Encoder: 1,
  Ljava_nio_charset_CharsetEncoder: 1,
  O: 1
});
$c_Ljava_nio_charset_UTF\uff3f8$Encoder.prototype.$classData = $d_Ljava_nio_charset_UTF\uff3f8$Encoder;
/** @constructor */
function $c_ju_AbstractMap() {
  /*<skip>*/
}
$c_ju_AbstractMap.prototype = new $h_O();
$c_ju_AbstractMap.prototype.constructor = $c_ju_AbstractMap;
/** @constructor */
function $h_ju_AbstractMap() {
  /*<skip>*/
}
$h_ju_AbstractMap.prototype = $c_ju_AbstractMap.prototype;
$c_ju_AbstractMap.prototype.equals__O__Z = (function(o) {
  if ((o === this)) {
    return true
  } else if ($is_ju_Map(o)) {
    var x2 = $as_ju_Map(o);
    if ((this.ju_HashMap__f_contentSize === x2.ju_HashMap__f_contentSize)) {
      var _\uff3fself = new $c_ju_HashMap$EntrySet(this);
      var _\uff3fself$1 = _\uff3fself.iterator__ju_Iterator();
      _return: {
        while (_\uff3fself$1.hasNext__Z()) {
          var arg1 = _\uff3fself$1.next__O();
          var item = $as_ju_Map$Entry(arg1);
          var key = item.ju_HashMap$Node__f_key;
          var a = $p_ju_HashMap__getOrDefaultImpl__O__O__O(x2, key, null);
          var b = item.ju_HashMap$Node__f_value;
          if ((!((a === null) ? (b === null) : $dp_equals__O__Z(a, b)))) {
            var $$x1 = true;
            break _return
          }
        };
        var $$x1 = false
      };
      return (!$$x1)
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_ju_AbstractMap.prototype.hashCode__I = (function() {
  var _\uff3fself = new $c_ju_HashMap$EntrySet(this);
  var _\uff3fself$1 = _\uff3fself.iterator__ju_Iterator();
  var result = 0;
  while (_\uff3fself$1.hasNext__Z()) {
    var arg1 = result;
    var arg2 = _\uff3fself$1.next__O();
    var prev = $uI(arg1);
    var item = $as_ju_Map$Entry(arg2);
    result = ((item.hashCode__I() + prev) | 0)
  };
  return $uI(result)
});
$c_ju_AbstractMap.prototype.toString__T = (function() {
  var result = "{";
  var first = true;
  var iter = new $c_ju_HashMap$EntrySet(this).iterator__ju_Iterator();
  while (iter.hasNext__Z()) {
    var entry = $as_ju_Map$Entry(iter.next__O());
    if (first) {
      first = false
    } else {
      result = (result + ", ")
    };
    result = (((("" + result) + entry.ju_HashMap$Node__f_key) + "=") + entry.ju_HashMap$Node__f_value)
  };
  return (result + "}")
});
function $is_ju_Collection(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.ju_Collection)))
}
function $as_ju_Collection(obj) {
  return (($is_ju_Collection(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.util.Collection"))
}
function $isArrayOf_ju_Collection(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_Collection)))
}
function $asArrayOf_ju_Collection(obj, depth) {
  return (($isArrayOf_ju_Collection(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.util.Collection;", depth))
}
/** @constructor */
function $c_ju_Formatter$RootLocaleInfo$() {
  /*<skip>*/
}
$c_ju_Formatter$RootLocaleInfo$.prototype = new $h_ju_Formatter$LocaleInfo();
$c_ju_Formatter$RootLocaleInfo$.prototype.constructor = $c_ju_Formatter$RootLocaleInfo$;
/** @constructor */
function $h_ju_Formatter$RootLocaleInfo$() {
  /*<skip>*/
}
$h_ju_Formatter$RootLocaleInfo$.prototype = $c_ju_Formatter$RootLocaleInfo$.prototype;
var $d_ju_Formatter$RootLocaleInfo$ = new $TypeData().initClass({
  ju_Formatter$RootLocaleInfo$: 0
}, false, "java.util.Formatter$RootLocaleInfo$", {
  ju_Formatter$RootLocaleInfo$: 1,
  ju_Formatter$LocaleInfo: 1,
  O: 1
});
$c_ju_Formatter$RootLocaleInfo$.prototype.$classData = $d_ju_Formatter$RootLocaleInfo$;
var $n_ju_Formatter$RootLocaleInfo$;
function $m_ju_Formatter$RootLocaleInfo$() {
  if ((!$n_ju_Formatter$RootLocaleInfo$)) {
    $n_ju_Formatter$RootLocaleInfo$ = new $c_ju_Formatter$RootLocaleInfo$()
  };
  return $n_ju_Formatter$RootLocaleInfo$
}
function $ct_ju_HashMap$Node__O__I__O__ju_HashMap$Node__ju_HashMap$Node__($thiz, key, hash, value, previous, next) {
  $thiz.ju_HashMap$Node__f_key = key;
  $thiz.ju_HashMap$Node__f_hash = hash;
  $thiz.ju_HashMap$Node__f_value = value;
  $thiz.ju_HashMap$Node__f_previous = previous;
  $thiz.ju_HashMap$Node__f_next = next;
  return $thiz
}
/** @constructor */
function $c_ju_HashMap$Node() {
  this.ju_HashMap$Node__f_key = null;
  this.ju_HashMap$Node__f_hash = 0;
  this.ju_HashMap$Node__f_value = null;
  this.ju_HashMap$Node__f_previous = null;
  this.ju_HashMap$Node__f_next = null
}
$c_ju_HashMap$Node.prototype = new $h_O();
$c_ju_HashMap$Node.prototype.constructor = $c_ju_HashMap$Node;
/** @constructor */
function $h_ju_HashMap$Node() {
  /*<skip>*/
}
$h_ju_HashMap$Node.prototype = $c_ju_HashMap$Node.prototype;
$c_ju_HashMap$Node.prototype.equals__O__Z = (function(that) {
  if ($is_ju_Map$Entry(that)) {
    var x2 = $as_ju_Map$Entry(that);
    var a = this.ju_HashMap$Node__f_key;
    var b = x2.ju_HashMap$Node__f_key;
    if (((a === null) ? (b === null) : $dp_equals__O__Z(a, b))) {
      var a$1 = this.ju_HashMap$Node__f_value;
      var b$1 = x2.ju_HashMap$Node__f_value;
      return ((a$1 === null) ? (b$1 === null) : $dp_equals__O__Z(a$1, b$1))
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_ju_HashMap$Node.prototype.hashCode__I = (function() {
  var improvedHash = this.ju_HashMap$Node__f_hash;
  var o = this.ju_HashMap$Node__f_value;
  return ((improvedHash ^ ((improvedHash >>> 16) | 0)) ^ ((o === null) ? 0 : $dp_hashCode__I(o)))
});
$c_ju_HashMap$Node.prototype.toString__T = (function() {
  return ((this.ju_HashMap$Node__f_key + "=") + this.ju_HashMap$Node__f_value)
});
var $d_ju_HashMap$Node = new $TypeData().initClass({
  ju_HashMap$Node: 0
}, false, "java.util.HashMap$Node", {
  ju_HashMap$Node: 1,
  O: 1,
  ju_Map$Entry: 1
});
$c_ju_HashMap$Node.prototype.$classData = $d_ju_HashMap$Node;
function $ct_ju_LinkedHashMap$AbstractLinkedHashMapIterator__ju_LinkedHashMap__($thiz, outer) {
  if ((outer === null)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(null)
  } else {
    $thiz.ju_LinkedHashMap$AbstractLinkedHashMapIterator__f_$outer = outer
  };
  $thiz.ju_LinkedHashMap$AbstractLinkedHashMapIterator__f_nextNode = outer.ju_LinkedHashMap__f_java$util$LinkedHashMap$$eldest;
  return $thiz
}
/** @constructor */
function $c_ju_LinkedHashMap$AbstractLinkedHashMapIterator() {
  this.ju_LinkedHashMap$AbstractLinkedHashMapIterator__f_nextNode = null;
  this.ju_LinkedHashMap$AbstractLinkedHashMapIterator__f_lastNode = null;
  this.ju_LinkedHashMap$AbstractLinkedHashMapIterator__f_$outer = null
}
$c_ju_LinkedHashMap$AbstractLinkedHashMapIterator.prototype = new $h_O();
$c_ju_LinkedHashMap$AbstractLinkedHashMapIterator.prototype.constructor = $c_ju_LinkedHashMap$AbstractLinkedHashMapIterator;
/** @constructor */
function $h_ju_LinkedHashMap$AbstractLinkedHashMapIterator() {
  /*<skip>*/
}
$h_ju_LinkedHashMap$AbstractLinkedHashMapIterator.prototype = $c_ju_LinkedHashMap$AbstractLinkedHashMapIterator.prototype;
$c_ju_LinkedHashMap$AbstractLinkedHashMapIterator.prototype.hasNext__Z = (function() {
  return (this.ju_LinkedHashMap$AbstractLinkedHashMapIterator__f_nextNode !== null)
});
$c_ju_LinkedHashMap$AbstractLinkedHashMapIterator.prototype.next__O = (function() {
  if ((!this.hasNext__Z())) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "next on empty iterator")
  };
  var node = this.ju_LinkedHashMap$AbstractLinkedHashMapIterator__f_nextNode;
  this.ju_LinkedHashMap$AbstractLinkedHashMapIterator__f_lastNode = node;
  this.ju_LinkedHashMap$AbstractLinkedHashMapIterator__f_nextNode = node.ju_LinkedHashMap$Node__f_younger;
  return node
});
function $p_ju_UUID$__fail$1__T__E($thiz, name$1) {
  throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("Invalid UUID string: " + name$1))
}
/** @constructor */
function $c_ju_UUID$() {
  this.ju_UUID$__f_rng = null;
  this.ju_UUID$__f_bitmap$0 = false
}
$c_ju_UUID$.prototype = new $h_O();
$c_ju_UUID$.prototype.constructor = $c_ju_UUID$;
/** @constructor */
function $h_ju_UUID$() {
  /*<skip>*/
}
$h_ju_UUID$.prototype = $c_ju_UUID$.prototype;
$c_ju_UUID$.prototype.fromString__T__ju_UUID = (function(name) {
  if (((((($uI(name.length) !== 36) || ((65535 & $uI(name.charCodeAt(8))) !== 45)) || ((65535 & $uI(name.charCodeAt(13))) !== 45)) || ((65535 & $uI(name.charCodeAt(18))) !== 45)) || ((65535 & $uI(name.charCodeAt(23))) !== 45))) {
    $p_ju_UUID$__fail$1__T__E(this, name)
  };
  try {
    var his = $as_T(name.substring(0, 4));
    var los = $as_T(name.substring(4, 8));
    var i1 = (($m_jl_Integer$().parseInt__T__I__I(his, 16) << 16) | $m_jl_Integer$().parseInt__T__I__I(los, 16));
    var his$1 = $as_T(name.substring(9, 13));
    var los$1 = $as_T(name.substring(14, 18));
    var i2 = (($m_jl_Integer$().parseInt__T__I__I(his$1, 16) << 16) | $m_jl_Integer$().parseInt__T__I__I(los$1, 16));
    var his$2 = $as_T(name.substring(19, 23));
    var los$2 = $as_T(name.substring(24, 28));
    var i3 = (($m_jl_Integer$().parseInt__T__I__I(his$2, 16) << 16) | $m_jl_Integer$().parseInt__T__I__I(los$2, 16));
    var his$3 = $as_T(name.substring(28, 32));
    var los$3 = $as_T(name.substring(32, 36));
    var i4 = (($m_jl_Integer$().parseInt__T__I__I(his$3, 16) << 16) | $m_jl_Integer$().parseInt__T__I__I(los$3, 16));
    return new $c_ju_UUID(i1, i2, i3, i4, null, null)
  } catch (e) {
    if ((e instanceof $c_jl_NumberFormatException)) {
      $p_ju_UUID$__fail$1__T__E(this, name)
    } else {
      throw e
    }
  }
});
var $d_ju_UUID$ = new $TypeData().initClass({
  ju_UUID$: 0
}, false, "java.util.UUID$", {
  ju_UUID$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_ju_UUID$.prototype.$classData = $d_ju_UUID$;
var $n_ju_UUID$;
function $m_ju_UUID$() {
  if ((!$n_ju_UUID$)) {
    $n_ju_UUID$ = new $c_ju_UUID$()
  };
  return $n_ju_UUID$
}
/** @constructor */
function $c_ju_concurrent_TimeUnit$() {
  this.ju_concurrent_TimeUnit$__f_NANOSECONDS = null;
  this.ju_concurrent_TimeUnit$__f_MICROSECONDS = null;
  this.ju_concurrent_TimeUnit$__f_MILLISECONDS = null;
  this.ju_concurrent_TimeUnit$__f_SECONDS = null;
  this.ju_concurrent_TimeUnit$__f_MINUTES = null;
  this.ju_concurrent_TimeUnit$__f_HOURS = null;
  this.ju_concurrent_TimeUnit$__f_DAYS = null;
  this.ju_concurrent_TimeUnit$__f__values = null;
  $n_ju_concurrent_TimeUnit$ = this;
  this.ju_concurrent_TimeUnit$__f_NANOSECONDS = new $c_ju_concurrent_TimeUnit$$anon$1();
  this.ju_concurrent_TimeUnit$__f_MICROSECONDS = new $c_ju_concurrent_TimeUnit$$anon$2();
  this.ju_concurrent_TimeUnit$__f_MILLISECONDS = new $c_ju_concurrent_TimeUnit$$anon$3();
  this.ju_concurrent_TimeUnit$__f_SECONDS = new $c_ju_concurrent_TimeUnit$$anon$4();
  this.ju_concurrent_TimeUnit$__f_MINUTES = new $c_ju_concurrent_TimeUnit$$anon$5();
  this.ju_concurrent_TimeUnit$__f_HOURS = new $c_ju_concurrent_TimeUnit$$anon$6();
  this.ju_concurrent_TimeUnit$__f_DAYS = new $c_ju_concurrent_TimeUnit$$anon$7();
  this.ju_concurrent_TimeUnit$__f__values = new ($d_ju_concurrent_TimeUnit.getArrayOf().constr)([this.ju_concurrent_TimeUnit$__f_NANOSECONDS, this.ju_concurrent_TimeUnit$__f_MICROSECONDS, this.ju_concurrent_TimeUnit$__f_MILLISECONDS, this.ju_concurrent_TimeUnit$__f_SECONDS, this.ju_concurrent_TimeUnit$__f_MINUTES, this.ju_concurrent_TimeUnit$__f_HOURS, this.ju_concurrent_TimeUnit$__f_DAYS])
}
$c_ju_concurrent_TimeUnit$.prototype = new $h_O();
$c_ju_concurrent_TimeUnit$.prototype.constructor = $c_ju_concurrent_TimeUnit$;
/** @constructor */
function $h_ju_concurrent_TimeUnit$() {
  /*<skip>*/
}
$h_ju_concurrent_TimeUnit$.prototype = $c_ju_concurrent_TimeUnit$.prototype;
$c_ju_concurrent_TimeUnit$.prototype.java$util$concurrent$TimeUnit$$x__J__J__J__J = (function(a, b, max) {
  var ahi = a.RTLong__f_hi;
  var bhi = max.RTLong__f_hi;
  if (((ahi === bhi) ? (((-2147483648) ^ a.RTLong__f_lo) > ((-2147483648) ^ max.RTLong__f_lo)) : (ahi > bhi))) {
    return new $c_RTLong((-1), 2147483647)
  } else {
    var lo = max.RTLong__f_lo;
    var hi = max.RTLong__f_hi;
    var lo$1 = ((-lo) | 0);
    var hi$1 = ((lo !== 0) ? (~hi) : ((-hi) | 0));
    var ahi$1 = a.RTLong__f_hi;
    if (((ahi$1 === hi$1) ? (((-2147483648) ^ a.RTLong__f_lo) < ((-2147483648) ^ lo$1)) : (ahi$1 < hi$1))) {
      return new $c_RTLong(1, (-2147483648))
    } else {
      var alo = a.RTLong__f_lo;
      var blo = b.RTLong__f_lo;
      var a0 = (65535 & alo);
      var a1 = ((alo >>> 16) | 0);
      var b0 = (65535 & blo);
      var b1 = ((blo >>> 16) | 0);
      var a0b0 = $imul(a0, b0);
      var a1b0 = $imul(a1, b0);
      var a0b1 = $imul(a0, b1);
      var lo$2 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi$2 = (((((((($imul(alo, b.RTLong__f_hi) + $imul(a.RTLong__f_hi, blo)) | 0) + $imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
      return new $c_RTLong(lo$2, hi$2)
    }
  }
});
var $d_ju_concurrent_TimeUnit$ = new $TypeData().initClass({
  ju_concurrent_TimeUnit$: 0
}, false, "java.util.concurrent.TimeUnit$", {
  ju_concurrent_TimeUnit$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_ju_concurrent_TimeUnit$.prototype.$classData = $d_ju_concurrent_TimeUnit$;
var $n_ju_concurrent_TimeUnit$;
function $m_ju_concurrent_TimeUnit$() {
  if ((!$n_ju_concurrent_TimeUnit$)) {
    $n_ju_concurrent_TimeUnit$ = new $c_ju_concurrent_TimeUnit$()
  };
  return $n_ju_concurrent_TimeUnit$
}
function $ct_ju_concurrent_atomic_AtomicReference__O__($thiz, value) {
  $thiz.ju_concurrent_atomic_AtomicReference__f_value = value;
  return $thiz
}
/** @constructor */
function $c_ju_concurrent_atomic_AtomicReference() {
  this.ju_concurrent_atomic_AtomicReference__f_value = null
}
$c_ju_concurrent_atomic_AtomicReference.prototype = new $h_O();
$c_ju_concurrent_atomic_AtomicReference.prototype.constructor = $c_ju_concurrent_atomic_AtomicReference;
/** @constructor */
function $h_ju_concurrent_atomic_AtomicReference() {
  /*<skip>*/
}
$h_ju_concurrent_atomic_AtomicReference.prototype = $c_ju_concurrent_atomic_AtomicReference.prototype;
$c_ju_concurrent_atomic_AtomicReference.prototype.compareAndSet__O__O__Z = (function(expect, update) {
  if ($is(expect, this.ju_concurrent_atomic_AtomicReference__f_value)) {
    this.ju_concurrent_atomic_AtomicReference__f_value = update;
    return true
  } else {
    return false
  }
});
$c_ju_concurrent_atomic_AtomicReference.prototype.toString__T = (function() {
  var obj = this.ju_concurrent_atomic_AtomicReference__f_value;
  return ("" + obj)
});
function $p_ju_regex_Matcher__ensureLastMatch__sjs_js_RegExp$ExecResult($thiz) {
  if (($thiz.ju_regex_Matcher__f_lastMatch === null)) {
    throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "No match available")
  };
  return $thiz.ju_regex_Matcher__f_lastMatch
}
/** @constructor */
function $c_ju_regex_Matcher(pattern0, input0, regionStart0, regionEnd0) {
  this.ju_regex_Matcher__f_pattern0 = null;
  this.ju_regex_Matcher__f_input0 = null;
  this.ju_regex_Matcher__f_regionStart0 = 0;
  this.ju_regex_Matcher__f_regionEnd0 = 0;
  this.ju_regex_Matcher__f_regexp = null;
  this.ju_regex_Matcher__f_inputstr = null;
  this.ju_regex_Matcher__f_lastMatch = null;
  this.ju_regex_Matcher__f_lastMatchIsValid = false;
  this.ju_regex_Matcher__f_canStillFind = false;
  this.ju_regex_Matcher__f_appendPos = 0;
  this.ju_regex_Matcher__f_startOfGroupCache = null;
  this.ju_regex_Matcher__f_pattern0 = pattern0;
  this.ju_regex_Matcher__f_input0 = input0;
  this.ju_regex_Matcher__f_regionStart0 = regionStart0;
  this.ju_regex_Matcher__f_regionEnd0 = regionEnd0;
  this.ju_regex_Matcher__f_regexp = this.ju_regex_Matcher__f_pattern0.newJSRegExp__sjs_js_RegExp();
  this.ju_regex_Matcher__f_inputstr = $dp_toString__T($dp_subSequence__I__I__jl_CharSequence(this.ju_regex_Matcher__f_input0, this.ju_regex_Matcher__f_regionStart0, this.ju_regex_Matcher__f_regionEnd0));
  this.ju_regex_Matcher__f_lastMatch = null;
  this.ju_regex_Matcher__f_lastMatchIsValid = false;
  this.ju_regex_Matcher__f_canStillFind = true;
  this.ju_regex_Matcher__f_appendPos = 0
}
$c_ju_regex_Matcher.prototype = new $h_O();
$c_ju_regex_Matcher.prototype.constructor = $c_ju_regex_Matcher;
/** @constructor */
function $h_ju_regex_Matcher() {
  /*<skip>*/
}
$h_ju_regex_Matcher.prototype = $c_ju_regex_Matcher.prototype;
$c_ju_regex_Matcher.prototype.find__Z = (function() {
  if (this.ju_regex_Matcher__f_canStillFind) {
    this.ju_regex_Matcher__f_lastMatchIsValid = true;
    this.ju_regex_Matcher__f_lastMatch = this.ju_regex_Matcher__f_regexp.exec(this.ju_regex_Matcher__f_inputstr);
    if ((this.ju_regex_Matcher__f_lastMatch !== null)) {
      var value = this.ju_regex_Matcher__f_lastMatch[0];
      if ((value === (void 0))) {
        throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "undefined.get")
      };
      var this$5 = $as_T(value);
      if ((this$5 === "")) {
        var ev$1 = this.ju_regex_Matcher__f_regexp;
        ev$1.lastIndex = ((1 + $uI(ev$1.lastIndex)) | 0)
      }
    } else {
      this.ju_regex_Matcher__f_canStillFind = false
    };
    this.ju_regex_Matcher__f_startOfGroupCache = null;
    return (this.ju_regex_Matcher__f_lastMatch !== null)
  } else {
    return false
  }
});
$c_ju_regex_Matcher.prototype.start__I = (function() {
  return (($uI($p_ju_regex_Matcher__ensureLastMatch__sjs_js_RegExp$ExecResult(this).index) + this.ju_regex_Matcher__f_regionStart0) | 0)
});
$c_ju_regex_Matcher.prototype.end__I = (function() {
  var $$x1 = this.start__I();
  var this$1 = this.group__T();
  return (($$x1 + $uI(this$1.length)) | 0)
});
$c_ju_regex_Matcher.prototype.group__T = (function() {
  var value = $p_ju_regex_Matcher__ensureLastMatch__sjs_js_RegExp$ExecResult(this)[0];
  if ((value === (void 0))) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "undefined.get")
  };
  return $as_T(value)
});
var $d_ju_regex_Matcher = new $TypeData().initClass({
  ju_regex_Matcher: 0
}, false, "java.util.regex.Matcher", {
  ju_regex_Matcher: 1,
  O: 1,
  ju_regex_MatchResult: 1
});
$c_ju_regex_Matcher.prototype.$classData = $d_ju_regex_Matcher;
function $p_ju_regex_Pattern__jsPattern__T($thiz) {
  return $as_T($thiz.ju_regex_Pattern__f_jsRegExp.source)
}
function $p_ju_regex_Pattern__jsFlags__T($thiz) {
  return ((($uZ($thiz.ju_regex_Pattern__f_jsRegExp.global) ? "g" : "") + ($uZ($thiz.ju_regex_Pattern__f_jsRegExp.ignoreCase) ? "i" : "")) + ($uZ($thiz.ju_regex_Pattern__f_jsRegExp.multiline) ? "m" : ""))
}
/** @constructor */
function $c_ju_regex_Pattern(jsRegExp, _pattern, _flags) {
  this.ju_regex_Pattern__f_groupCount = 0;
  this.ju_regex_Pattern__f_groupStartMapper = null;
  this.ju_regex_Pattern__f_jsRegExp = null;
  this.ju_regex_Pattern__f__pattern = null;
  this.ju_regex_Pattern__f__flags = 0;
  this.ju_regex_Pattern__f_bitmap$0 = 0;
  this.ju_regex_Pattern__f_jsRegExp = jsRegExp;
  this.ju_regex_Pattern__f__pattern = _pattern;
  this.ju_regex_Pattern__f__flags = _flags
}
$c_ju_regex_Pattern.prototype = new $h_O();
$c_ju_regex_Pattern.prototype.constructor = $c_ju_regex_Pattern;
/** @constructor */
function $h_ju_regex_Pattern() {
  /*<skip>*/
}
$h_ju_regex_Pattern.prototype = $c_ju_regex_Pattern.prototype;
$c_ju_regex_Pattern.prototype.toString__T = (function() {
  return this.ju_regex_Pattern__f__pattern
});
$c_ju_regex_Pattern.prototype.newJSRegExp__sjs_js_RegExp = (function() {
  var r = new RegExp(this.ju_regex_Pattern__f_jsRegExp);
  return ((!$is(r, this.ju_regex_Pattern__f_jsRegExp)) ? r : new RegExp($p_ju_regex_Pattern__jsPattern__T(this), $p_ju_regex_Pattern__jsFlags__T(this)))
});
$c_ju_regex_Pattern.prototype.split__jl_CharSequence__I__AT = (function(input, limit) {
  var inputStr = $dp_toString__T(input);
  if ((inputStr === "")) {
    return new ($d_T.getArrayOf().constr)([""])
  } else {
    var lim = ((limit > 0) ? limit : 2147483647);
    var matcher = new $c_ju_regex_Matcher(this, inputStr, 0, $uI(inputStr.length));
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    capacity = 0;
    size = 0;
    jsElems = [];
    var prevEnd = 0;
    var size$1 = 0;
    while (((size$1 < (((-1) + lim) | 0)) && matcher.find__Z())) {
      if ((matcher.end__I() !== 0)) {
        var beginIndex = prevEnd;
        var endIndex = matcher.start__I();
        var elem = $as_T(inputStr.substring(beginIndex, endIndex));
        var unboxedElem = ((elem === null) ? null : elem);
        jsElems.push(unboxedElem);
        size$1 = ((1 + size$1) | 0)
      };
      prevEnd = matcher.end__I()
    };
    var beginIndex$1 = prevEnd;
    var elem$1 = $as_T(inputStr.substring(beginIndex$1));
    var unboxedElem$1 = ((elem$1 === null) ? null : elem$1);
    jsElems.push(unboxedElem$1);
    var result = new ($d_T.getArrayOf().constr)(jsElems);
    if ((limit !== 0)) {
      return result
    } else {
      var actualLength = result.u.length;
      while (((actualLength !== 0) && (result.get((((-1) + actualLength) | 0)) === ""))) {
        actualLength = (((-1) + actualLength) | 0)
      };
      if ((actualLength === result.u.length)) {
        return result
      } else {
        var actualResult = new ($d_T.getArrayOf().constr)(actualLength);
        var length = actualLength;
        $systemArraycopy(result, 0, actualResult, 0, length);
        return actualResult
      }
    }
  }
});
var $d_ju_regex_Pattern = new $TypeData().initClass({
  ju_regex_Pattern: 0
}, false, "java.util.regex.Pattern", {
  ju_regex_Pattern: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_ju_regex_Pattern.prototype.$classData = $d_ju_regex_Pattern;
/** @constructor */
function $c_ju_regex_Pattern$() {
  this.ju_regex_Pattern$__f_java$util$regex$Pattern$$splitHackPat = null;
  this.ju_regex_Pattern$__f_java$util$regex$Pattern$$flagHackPat = null;
  $n_ju_regex_Pattern$ = this;
  this.ju_regex_Pattern$__f_java$util$regex$Pattern$$splitHackPat = new RegExp("^\\\\Q(.|\\n|\\r)\\\\E$");
  this.ju_regex_Pattern$__f_java$util$regex$Pattern$$flagHackPat = new RegExp("^\\(\\?([idmsuxU]*)(?:-([idmsuxU]*))?\\)")
}
$c_ju_regex_Pattern$.prototype = new $h_O();
$c_ju_regex_Pattern$.prototype.constructor = $c_ju_regex_Pattern$;
/** @constructor */
function $h_ju_regex_Pattern$() {
  /*<skip>*/
}
$h_ju_regex_Pattern$.prototype = $c_ju_regex_Pattern$.prototype;
$c_ju_regex_Pattern$.prototype.compile__T__I__ju_regex_Pattern = (function(regex, flags) {
  if (((16 & flags) !== 0)) {
    var x1 = new $c_T2(this.quote__T__T(regex), flags)
  } else {
    var m = this.ju_regex_Pattern$__f_java$util$regex$Pattern$$splitHackPat.exec(regex);
    if ((m !== null)) {
      var value = m[1];
      if ((value === (void 0))) {
        throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "undefined.get")
      };
      var this$5 = new $c_s_Some(new $c_T2(this.quote__T__T($as_T(value)), flags))
    } else {
      var this$5 = $m_s_None$()
    };
    if (this$5.isEmpty__Z()) {
      var this$6 = $m_ju_regex_Pattern$();
      var m$1 = this$6.ju_regex_Pattern$__f_java$util$regex$Pattern$$flagHackPat.exec(regex);
      if ((m$1 !== null)) {
        var value$1 = m$1[0];
        if ((value$1 === (void 0))) {
          throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "undefined.get")
        };
        var this$11 = $as_T(value$1);
        var beginIndex = $uI(this$11.length);
        var newPat = $as_T(regex.substring(beginIndex));
        var elem = 0;
        elem = flags;
        var value$2 = m$1[1];
        if ((value$2 !== (void 0))) {
          var chars = $as_T(value$2);
          var end = $uI(chars.length);
          var i = 0;
          while ((i < end)) {
            var arg1 = i;
            elem = (elem | $m_ju_regex_Pattern$().java$util$regex$Pattern$$charToFlag__C__I((65535 & $uI(chars.charCodeAt(arg1)))));
            i = ((1 + i) | 0)
          }
        };
        var value$3 = m$1[2];
        if ((value$3 !== (void 0))) {
          var chars$3 = $as_T(value$3);
          var end$1 = $uI(chars$3.length);
          var i$1 = 0;
          while ((i$1 < end$1)) {
            var arg1$1 = i$1;
            elem = (elem & (~$m_ju_regex_Pattern$().java$util$regex$Pattern$$charToFlag__C__I((65535 & $uI(chars$3.charCodeAt(arg1$1))))));
            i$1 = ((1 + i$1) | 0)
          }
        };
        var this$28 = new $c_s_Some(new $c_T2(newPat, elem))
      } else {
        var this$28 = $m_s_None$()
      }
    } else {
      var this$28 = this$5
    };
    var x1 = $as_T2((this$28.isEmpty__Z() ? new $c_T2(regex, flags) : this$28.get__O()))
  };
  if ((x1 === null)) {
    throw new $c_s_MatchError(x1)
  };
  var jsPattern = $as_T(x1._1__O());
  var flags1 = $uI(x1._2__O());
  var jsFlags = (("g" + (((2 & flags1) !== 0) ? "i" : "")) + (((8 & flags1) !== 0) ? "m" : ""));
  var jsRegExp = new RegExp(jsPattern, jsFlags);
  return new $c_ju_regex_Pattern(jsRegExp, regex, flags1)
});
$c_ju_regex_Pattern$.prototype.quote__T__T = (function(s) {
  var result = "";
  var i = 0;
  while ((i < $uI(s.length))) {
    var index = i;
    var c = (65535 & $uI(s.charCodeAt(index)));
    var $$x2 = result;
    switch (c) {
      case 92:
      case 46:
      case 40:
      case 41:
      case 91:
      case 93:
      case 123:
      case 125:
      case 124:
      case 63:
      case 42:
      case 43:
      case 94:
      case 36: {
        var $$x1 = ("\\" + $bC(c));
        break
      }
      default: {
        var $$x1 = $bC(c)
      }
    };
    result = (("" + $$x2) + $$x1);
    i = ((1 + i) | 0)
  };
  return result
});
$c_ju_regex_Pattern$.prototype.java$util$regex$Pattern$$charToFlag__C__I = (function(c) {
  switch (c) {
    case 105: {
      return 2;
      break
    }
    case 100: {
      return 1;
      break
    }
    case 109: {
      return 8;
      break
    }
    case 115: {
      return 32;
      break
    }
    case 117: {
      return 64;
      break
    }
    case 120: {
      return 4;
      break
    }
    case 85: {
      return 256;
      break
    }
    default: {
      throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "bad in-pattern flag")
    }
  }
});
var $d_ju_regex_Pattern$ = new $TypeData().initClass({
  ju_regex_Pattern$: 0
}, false, "java.util.regex.Pattern$", {
  ju_regex_Pattern$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_ju_regex_Pattern$.prototype.$classData = $d_ju_regex_Pattern$;
var $n_ju_regex_Pattern$;
function $m_ju_regex_Pattern$() {
  if ((!$n_ju_regex_Pattern$)) {
    $n_ju_regex_Pattern$ = new $c_ju_regex_Pattern$()
  };
  return $n_ju_regex_Pattern$
}
function $p_RTLong$__toUnsignedString__I__I__T($thiz, lo, hi) {
  if ((((-2097152) & hi) === 0)) {
    var this$1 = ((4.294967296E9 * hi) + $uD((lo >>> 0)));
    return ("" + this$1)
  } else {
    return $as_T($p_RTLong$__unsignedDivModHelper__I__I__I__I__I__O($thiz, lo, hi, 1000000000, 0, 2))
  }
}
function $p_RTLong$__unsigned_$div__I__I__I__I__I($thiz, alo, ahi, blo, bhi) {
  if ((((-2097152) & ahi) === 0)) {
    if ((((-2097152) & bhi) === 0)) {
      var aDouble = ((4.294967296E9 * ahi) + $uD((alo >>> 0)));
      var bDouble = ((4.294967296E9 * bhi) + $uD((blo >>> 0)));
      var rDouble = (aDouble / bDouble);
      var x = (rDouble / 4.294967296E9);
      $thiz.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = $uI((x | 0));
      return $uI((rDouble | 0))
    } else {
      $thiz.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = 0;
      return 0
    }
  } else if (((bhi === 0) && ((blo & (((-1) + blo) | 0)) === 0))) {
    var pow = ((31 - $clz32(blo)) | 0);
    $thiz.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = ((ahi >>> pow) | 0);
    return (((alo >>> pow) | 0) | ((ahi << 1) << ((31 - pow) | 0)))
  } else if (((blo === 0) && ((bhi & (((-1) + bhi) | 0)) === 0))) {
    var pow$2 = ((31 - $clz32(bhi)) | 0);
    $thiz.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = 0;
    return ((ahi >>> pow$2) | 0)
  } else {
    return $uI($p_RTLong$__unsignedDivModHelper__I__I__I__I__I__O($thiz, alo, ahi, blo, bhi, 0))
  }
}
function $p_RTLong$__unsigned_$percent__I__I__I__I__I($thiz, alo, ahi, blo, bhi) {
  if ((((-2097152) & ahi) === 0)) {
    if ((((-2097152) & bhi) === 0)) {
      var aDouble = ((4.294967296E9 * ahi) + $uD((alo >>> 0)));
      var bDouble = ((4.294967296E9 * bhi) + $uD((blo >>> 0)));
      var rDouble = (aDouble % bDouble);
      var x = (rDouble / 4.294967296E9);
      $thiz.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = $uI((x | 0));
      return $uI((rDouble | 0))
    } else {
      $thiz.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = ahi;
      return alo
    }
  } else if (((bhi === 0) && ((blo & (((-1) + blo) | 0)) === 0))) {
    $thiz.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = 0;
    return (alo & (((-1) + blo) | 0))
  } else if (((blo === 0) && ((bhi & (((-1) + bhi) | 0)) === 0))) {
    $thiz.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = (ahi & (((-1) + bhi) | 0));
    return alo
  } else {
    return $uI($p_RTLong$__unsignedDivModHelper__I__I__I__I__I__O($thiz, alo, ahi, blo, bhi, 1))
  }
}
function $p_RTLong$__unsignedDivModHelper__I__I__I__I__I__O($thiz, alo, ahi, blo, bhi, ask) {
  var shift = ((((bhi !== 0) ? $clz32(bhi) : ((32 + $clz32(blo)) | 0)) - ((ahi !== 0) ? $clz32(ahi) : ((32 + $clz32(alo)) | 0))) | 0);
  var n = shift;
  var lo = (((32 & n) === 0) ? (blo << n) : 0);
  var hi = (((32 & n) === 0) ? (((((blo >>> 1) | 0) >>> ((31 - n) | 0)) | 0) | (bhi << n)) : (blo << n));
  var bShiftLo = lo;
  var bShiftHi = hi;
  var remLo = alo;
  var remHi = ahi;
  var quotLo = 0;
  var quotHi = 0;
  while (((shift >= 0) && (((-2097152) & remHi) !== 0))) {
    var alo$1 = remLo;
    var ahi$1 = remHi;
    var blo$1 = bShiftLo;
    var bhi$1 = bShiftHi;
    if (((ahi$1 === bhi$1) ? (((-2147483648) ^ alo$1) >= ((-2147483648) ^ blo$1)) : (((-2147483648) ^ ahi$1) >= ((-2147483648) ^ bhi$1)))) {
      var lo$1 = remLo;
      var hi$1 = remHi;
      var lo$2 = bShiftLo;
      var hi$2 = bShiftHi;
      var lo$3 = ((lo$1 - lo$2) | 0);
      var hi$3 = ((((-2147483648) ^ lo$3) > ((-2147483648) ^ lo$1)) ? (((-1) + ((hi$1 - hi$2) | 0)) | 0) : ((hi$1 - hi$2) | 0));
      remLo = lo$3;
      remHi = hi$3;
      if ((shift < 32)) {
        quotLo = (quotLo | (1 << shift))
      } else {
        quotHi = (quotHi | (1 << shift))
      }
    };
    shift = (((-1) + shift) | 0);
    var lo$4 = bShiftLo;
    var hi$4 = bShiftHi;
    var lo$5 = (((lo$4 >>> 1) | 0) | (hi$4 << 31));
    var hi$5 = ((hi$4 >>> 1) | 0);
    bShiftLo = lo$5;
    bShiftHi = hi$5
  };
  var alo$2 = remLo;
  var ahi$2 = remHi;
  if (((ahi$2 === bhi) ? (((-2147483648) ^ alo$2) >= ((-2147483648) ^ blo)) : (((-2147483648) ^ ahi$2) >= ((-2147483648) ^ bhi)))) {
    var lo$6 = remLo;
    var hi$6 = remHi;
    var remDouble = ((4.294967296E9 * hi$6) + $uD((lo$6 >>> 0)));
    var bDouble = ((4.294967296E9 * bhi) + $uD((blo >>> 0)));
    if ((ask !== 1)) {
      var x = (remDouble / bDouble);
      var lo$7 = $uI((x | 0));
      var x$1 = (x / 4.294967296E9);
      var hi$7 = $uI((x$1 | 0));
      var lo$8 = quotLo;
      var hi$8 = quotHi;
      var lo$9 = ((lo$8 + lo$7) | 0);
      var hi$9 = ((((-2147483648) ^ lo$9) < ((-2147483648) ^ lo$8)) ? ((1 + ((hi$8 + hi$7) | 0)) | 0) : ((hi$8 + hi$7) | 0));
      quotLo = lo$9;
      quotHi = hi$9
    };
    if ((ask !== 0)) {
      var rem_mod_bDouble = (remDouble % bDouble);
      remLo = $uI((rem_mod_bDouble | 0));
      var x$2 = (rem_mod_bDouble / 4.294967296E9);
      remHi = $uI((x$2 | 0))
    }
  };
  if ((ask === 0)) {
    $thiz.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = quotHi;
    return quotLo
  } else if ((ask === 1)) {
    $thiz.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = remHi;
    return remLo
  } else {
    var lo$10 = quotLo;
    var hi$10 = quotHi;
    var quot = ((4.294967296E9 * hi$10) + $uD((lo$10 >>> 0)));
    var this$3 = remLo;
    var remStr = ("" + this$3);
    var start = $uI(remStr.length);
    return ((("" + quot) + $as_T("000000000".substring(start))) + remStr)
  }
}
/** @constructor */
function $c_RTLong$() {
  this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = 0
}
$c_RTLong$.prototype = new $h_O();
$c_RTLong$.prototype.constructor = $c_RTLong$;
/** @constructor */
function $h_RTLong$() {
  /*<skip>*/
}
$h_RTLong$.prototype = $c_RTLong$.prototype;
$c_RTLong$.prototype.org$scalajs$linker$runtime$RuntimeLong$$toString__I__I__T = (function(lo, hi) {
  return ((hi === (lo >> 31)) ? ("" + lo) : ((hi < 0) ? ("-" + $p_RTLong$__toUnsignedString__I__I__T(this, ((-lo) | 0), ((lo !== 0) ? (~hi) : ((-hi) | 0)))) : $p_RTLong$__toUnsignedString__I__I__T(this, lo, hi)))
});
$c_RTLong$.prototype.org$scalajs$linker$runtime$RuntimeLong$$toDouble__I__I__D = (function(lo, hi) {
  if ((hi < 0)) {
    var x = ((lo !== 0) ? (~hi) : ((-hi) | 0));
    var $$x1 = $uD((x >>> 0));
    var x$1 = ((-lo) | 0);
    return (-((4.294967296E9 * $$x1) + $uD((x$1 >>> 0))))
  } else {
    return ((4.294967296E9 * hi) + $uD((lo >>> 0)))
  }
});
$c_RTLong$.prototype.fromInt__I__RTLong = (function(value) {
  return new $c_RTLong(value, (value >> 31))
});
$c_RTLong$.prototype.fromDouble__D__RTLong = (function(value) {
  var lo = this.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value);
  return new $c_RTLong(lo, this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn)
});
$c_RTLong$.prototype.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I = (function(value) {
  if ((value < (-9.223372036854776E18))) {
    this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = (-2147483648);
    return 0
  } else if ((value >= 9.223372036854776E18)) {
    this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = 2147483647;
    return (-1)
  } else {
    var rawLo = $uI((value | 0));
    var x = (value / 4.294967296E9);
    var rawHi = $uI((x | 0));
    this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = (((value < 0.0) && (rawLo !== 0)) ? (((-1) + rawHi) | 0) : rawHi);
    return rawLo
  }
});
$c_RTLong$.prototype.org$scalajs$linker$runtime$RuntimeLong$$compare__I__I__I__I__I = (function(alo, ahi, blo, bhi) {
  return ((ahi === bhi) ? ((alo === blo) ? 0 : ((((-2147483648) ^ alo) < ((-2147483648) ^ blo)) ? (-1) : 1)) : ((ahi < bhi) ? (-1) : 1))
});
$c_RTLong$.prototype.divideImpl__I__I__I__I__I = (function(alo, ahi, blo, bhi) {
  if (((blo | bhi) === 0)) {
    throw new $c_jl_ArithmeticException("/ by zero")
  };
  if ((ahi === (alo >> 31))) {
    if ((bhi === (blo >> 31))) {
      if (((alo === (-2147483648)) && (blo === (-1)))) {
        this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = 0;
        return (-2147483648)
      } else {
        var lo = $intDiv(alo, blo);
        this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = (lo >> 31);
        return lo
      }
    } else if (((alo === (-2147483648)) && ((blo === (-2147483648)) && (bhi === 0)))) {
      this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = (-1);
      return (-1)
    } else {
      this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = 0;
      return 0
    }
  } else {
    if ((ahi < 0)) {
      var lo$1 = ((-alo) | 0);
      var hi = ((alo !== 0) ? (~ahi) : ((-ahi) | 0));
      var aAbs__lo = lo$1;
      var aAbs__hi = hi
    } else {
      var aAbs__lo = alo;
      var aAbs__hi = ahi
    };
    if ((bhi < 0)) {
      var lo$2 = ((-blo) | 0);
      var hi$1 = ((blo !== 0) ? (~bhi) : ((-bhi) | 0));
      var bAbs__lo = lo$2;
      var bAbs__hi = hi$1
    } else {
      var bAbs__lo = blo;
      var bAbs__hi = bhi
    };
    var absRLo = $p_RTLong$__unsigned_$div__I__I__I__I__I(this, aAbs__lo, aAbs__hi, bAbs__lo, bAbs__hi);
    if (((ahi ^ bhi) >= 0)) {
      return absRLo
    } else {
      var hi$2 = this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = ((absRLo !== 0) ? (~hi$2) : ((-hi$2) | 0));
      return ((-absRLo) | 0)
    }
  }
});
$c_RTLong$.prototype.divideUnsignedImpl__I__I__I__I__I = (function(alo, ahi, blo, bhi) {
  if (((blo | bhi) === 0)) {
    throw new $c_jl_ArithmeticException("/ by zero")
  };
  if ((ahi === 0)) {
    if ((bhi === 0)) {
      this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = 0;
      if ((blo === 0)) {
        return $intDiv(0, 0)
      } else {
        var n = ($uD((alo >>> 0)) / $uD((blo >>> 0)));
        return $uI((n | 0))
      }
    } else {
      this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = 0;
      return 0
    }
  } else {
    return $p_RTLong$__unsigned_$div__I__I__I__I__I(this, alo, ahi, blo, bhi)
  }
});
$c_RTLong$.prototype.remainderImpl__I__I__I__I__I = (function(alo, ahi, blo, bhi) {
  if (((blo | bhi) === 0)) {
    throw new $c_jl_ArithmeticException("/ by zero")
  };
  if ((ahi === (alo >> 31))) {
    if ((bhi === (blo >> 31))) {
      if ((blo !== (-1))) {
        var lo = $intMod(alo, blo);
        this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = (lo >> 31);
        return lo
      } else {
        this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = 0;
        return 0
      }
    } else if (((alo === (-2147483648)) && ((blo === (-2147483648)) && (bhi === 0)))) {
      this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = 0;
      return 0
    } else {
      this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = ahi;
      return alo
    }
  } else {
    if ((ahi < 0)) {
      var lo$1 = ((-alo) | 0);
      var hi = ((alo !== 0) ? (~ahi) : ((-ahi) | 0));
      var aAbs__lo = lo$1;
      var aAbs__hi = hi
    } else {
      var aAbs__lo = alo;
      var aAbs__hi = ahi
    };
    if ((bhi < 0)) {
      var lo$2 = ((-blo) | 0);
      var hi$1 = ((blo !== 0) ? (~bhi) : ((-bhi) | 0));
      var bAbs__lo = lo$2;
      var bAbs__hi = hi$1
    } else {
      var bAbs__lo = blo;
      var bAbs__hi = bhi
    };
    var absRLo = $p_RTLong$__unsigned_$percent__I__I__I__I__I(this, aAbs__lo, aAbs__hi, bAbs__lo, bAbs__hi);
    if ((ahi < 0)) {
      var hi$2 = this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = ((absRLo !== 0) ? (~hi$2) : ((-hi$2) | 0));
      return ((-absRLo) | 0)
    } else {
      return absRLo
    }
  }
});
var $d_RTLong$ = new $TypeData().initClass({
  RTLong$: 0
}, false, "org.scalajs.linker.runtime.RuntimeLong$", {
  RTLong$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_RTLong$.prototype.$classData = $d_RTLong$;
var $n_RTLong$;
function $m_RTLong$() {
  if ((!$n_RTLong$)) {
    $n_RTLong$ = new $c_RTLong$()
  };
  return $n_RTLong$
}
/** @constructor */
function $c_Lplay_api_libs_functional_FunctionalCanBuild$$anon$1(app$1) {
  this.Lplay_api_libs_functional_FunctionalCanBuild$$anon$1__f_app$1 = null;
  this.Lplay_api_libs_functional_FunctionalCanBuild$$anon$1__f_app$1 = app$1
}
$c_Lplay_api_libs_functional_FunctionalCanBuild$$anon$1.prototype = new $h_O();
$c_Lplay_api_libs_functional_FunctionalCanBuild$$anon$1.prototype.constructor = $c_Lplay_api_libs_functional_FunctionalCanBuild$$anon$1;
/** @constructor */
function $h_Lplay_api_libs_functional_FunctionalCanBuild$$anon$1() {
  /*<skip>*/
}
$h_Lplay_api_libs_functional_FunctionalCanBuild$$anon$1.prototype = $c_Lplay_api_libs_functional_FunctionalCanBuild$$anon$1.prototype;
$c_Lplay_api_libs_functional_FunctionalCanBuild$$anon$1.prototype.apply__O__O__O = (function(a, b) {
  return this.Lplay_api_libs_functional_FunctionalCanBuild$$anon$1__f_app$1.apply__O__O__O(this.Lplay_api_libs_functional_FunctionalCanBuild$$anon$1__f_app$1.map__O__F1__O(a, new $c_sjsr_AnonFunction1((function(this$1) {
    return (function(a$2$2) {
      return new $c_sjsr_AnonFunction1((function(this$2, a$1) {
        return (function(b$2) {
          return new $c_Lplay_api_libs_functional_$tilde(a$1, b$2)
        })
      })(this$1, a$2$2))
    })
  })(this))), b)
});
var $d_Lplay_api_libs_functional_FunctionalCanBuild$$anon$1 = new $TypeData().initClass({
  Lplay_api_libs_functional_FunctionalCanBuild$$anon$1: 0
}, false, "play.api.libs.functional.FunctionalCanBuild$$anon$1", {
  Lplay_api_libs_functional_FunctionalCanBuild$$anon$1: 1,
  O: 1,
  Lplay_api_libs_functional_FunctionalCanBuild: 1
});
$c_Lplay_api_libs_functional_FunctionalCanBuild$$anon$1.prototype.$classData = $d_Lplay_api_libs_functional_FunctionalCanBuild$$anon$1;
/** @constructor */
function $c_Lplay_api_libs_functional_Reducer$$anon$2(f$1, m$1) {
  this.Lplay_api_libs_functional_Reducer$$anon$2__f_f$1 = null;
  this.Lplay_api_libs_functional_Reducer$$anon$2__f_m$1 = null;
  this.Lplay_api_libs_functional_Reducer$$anon$2__f_f$1 = f$1;
  this.Lplay_api_libs_functional_Reducer$$anon$2__f_m$1 = m$1
}
$c_Lplay_api_libs_functional_Reducer$$anon$2.prototype = new $h_O();
$c_Lplay_api_libs_functional_Reducer$$anon$2.prototype.constructor = $c_Lplay_api_libs_functional_Reducer$$anon$2;
/** @constructor */
function $h_Lplay_api_libs_functional_Reducer$$anon$2() {
  /*<skip>*/
}
$h_Lplay_api_libs_functional_Reducer$$anon$2.prototype = $c_Lplay_api_libs_functional_Reducer$$anon$2.prototype;
var $d_Lplay_api_libs_functional_Reducer$$anon$2 = new $TypeData().initClass({
  Lplay_api_libs_functional_Reducer$$anon$2: 0
}, false, "play.api.libs.functional.Reducer$$anon$2", {
  Lplay_api_libs_functional_Reducer$$anon$2: 1,
  O: 1,
  Lplay_api_libs_functional_Reducer: 1
});
$c_Lplay_api_libs_functional_Reducer$$anon$2.prototype.$classData = $d_Lplay_api_libs_functional_Reducer$$anon$2;
/** @constructor */
function $c_Lplay_api_libs_json_DefaultReads$IntReads$(outer) {
  /*<skip>*/
}
$c_Lplay_api_libs_json_DefaultReads$IntReads$.prototype = new $h_O();
$c_Lplay_api_libs_json_DefaultReads$IntReads$.prototype.constructor = $c_Lplay_api_libs_json_DefaultReads$IntReads$;
/** @constructor */
function $h_Lplay_api_libs_json_DefaultReads$IntReads$() {
  /*<skip>*/
}
$h_Lplay_api_libs_json_DefaultReads$IntReads$.prototype = $c_Lplay_api_libs_json_DefaultReads$IntReads$.prototype;
$c_Lplay_api_libs_json_DefaultReads$IntReads$.prototype.reads__Lplay_api_libs_json_JsValue__Lplay_api_libs_json_JsResult = (function(json) {
  var rc5 = false;
  var x2 = null;
  if ((json instanceof $c_Lplay_api_libs_json_JsNumber)) {
    rc5 = true;
    x2 = $as_Lplay_api_libs_json_JsNumber(json);
    var n = x2.Lplay_api_libs_json_JsNumber__f_value;
    if (n.isValidInt__Z()) {
      return new $c_Lplay_api_libs_json_JsSuccess(n.s_math_BigDecimal__f_bigDecimal.intValue__I(), $ct_Lplay_api_libs_json_JsPath__sci_List__(new $c_Lplay_api_libs_json_JsPath(), ($m_Lplay_api_libs_json_JsPath$(), $m_sci_Nil$())))
    }
  };
  if (rc5) {
    return $m_Lplay_api_libs_json_JsError$().apply__T__Lplay_api_libs_json_JsError("error.expected.int")
  };
  return $m_Lplay_api_libs_json_JsError$().apply__T__Lplay_api_libs_json_JsError("error.expected.jsnumber")
});
var $d_Lplay_api_libs_json_DefaultReads$IntReads$ = new $TypeData().initClass({
  Lplay_api_libs_json_DefaultReads$IntReads$: 0
}, false, "play.api.libs.json.DefaultReads$IntReads$", {
  Lplay_api_libs_json_DefaultReads$IntReads$: 1,
  O: 1,
  Lplay_api_libs_json_Reads: 1
});
$c_Lplay_api_libs_json_DefaultReads$IntReads$.prototype.$classData = $d_Lplay_api_libs_json_DefaultReads$IntReads$;
/** @constructor */
function $c_Lplay_api_libs_json_DefaultReads$StringReads$(outer) {
  /*<skip>*/
}
$c_Lplay_api_libs_json_DefaultReads$StringReads$.prototype = new $h_O();
$c_Lplay_api_libs_json_DefaultReads$StringReads$.prototype.constructor = $c_Lplay_api_libs_json_DefaultReads$StringReads$;
/** @constructor */
function $h_Lplay_api_libs_json_DefaultReads$StringReads$() {
  /*<skip>*/
}
$h_Lplay_api_libs_json_DefaultReads$StringReads$.prototype = $c_Lplay_api_libs_json_DefaultReads$StringReads$.prototype;
$c_Lplay_api_libs_json_DefaultReads$StringReads$.prototype.reads__Lplay_api_libs_json_JsValue__Lplay_api_libs_json_JsResult = (function(json) {
  if ((json instanceof $c_Lplay_api_libs_json_JsString)) {
    var x2 = $as_Lplay_api_libs_json_JsString(json);
    var s = x2.Lplay_api_libs_json_JsString__f_value;
    return new $c_Lplay_api_libs_json_JsSuccess(s, $ct_Lplay_api_libs_json_JsPath__sci_List__(new $c_Lplay_api_libs_json_JsPath(), ($m_Lplay_api_libs_json_JsPath$(), $m_sci_Nil$())))
  } else {
    var $$x3 = $m_sc_Seq$();
    var self = $m_Lplay_api_libs_json_JsPath$();
    var $$x2 = $m_sc_Seq$();
    var $$x1 = $m_Lplay_api_libs_json_JsonValidationError$();
    var array = [];
    var array$1 = [$$x1.apply__T__sci_Seq__Lplay_api_libs_json_JsonValidationError("error.expected.jsstring", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))];
    var y = $$x2.apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1));
    var array$2 = [new $c_T2(self, y)];
    return new $c_Lplay_api_libs_json_JsError($as_sc_Seq($$x3.apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))))
  }
});
var $d_Lplay_api_libs_json_DefaultReads$StringReads$ = new $TypeData().initClass({
  Lplay_api_libs_json_DefaultReads$StringReads$: 0
}, false, "play.api.libs.json.DefaultReads$StringReads$", {
  Lplay_api_libs_json_DefaultReads$StringReads$: 1,
  O: 1,
  Lplay_api_libs_json_Reads: 1
});
$c_Lplay_api_libs_json_DefaultReads$StringReads$.prototype.$classData = $d_Lplay_api_libs_json_DefaultReads$StringReads$;
/** @constructor */
function $c_Lplay_api_libs_json_DefaultReads$UUIDReader(outer, checkValidity) {
  this.Lplay_api_libs_json_DefaultReads$UUIDReader__f_checkValidity = false;
  this.Lplay_api_libs_json_DefaultReads$UUIDReader__f_$outer = null;
  this.Lplay_api_libs_json_DefaultReads$UUIDReader__f_checkValidity = checkValidity;
  if ((outer === null)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(null)
  } else {
    this.Lplay_api_libs_json_DefaultReads$UUIDReader__f_$outer = outer
  }
}
$c_Lplay_api_libs_json_DefaultReads$UUIDReader.prototype = new $h_O();
$c_Lplay_api_libs_json_DefaultReads$UUIDReader.prototype.constructor = $c_Lplay_api_libs_json_DefaultReads$UUIDReader;
/** @constructor */
function $h_Lplay_api_libs_json_DefaultReads$UUIDReader() {
  /*<skip>*/
}
$h_Lplay_api_libs_json_DefaultReads$UUIDReader.prototype = $c_Lplay_api_libs_json_DefaultReads$UUIDReader.prototype;
$c_Lplay_api_libs_json_DefaultReads$UUIDReader.prototype.check__T__ju_UUID__Z = (function(s, u) {
  return ((u !== null) && (s === u.toString__T()))
});
$c_Lplay_api_libs_json_DefaultReads$UUIDReader.prototype.parseUuid__T__s_Option = (function(s) {
  try {
    var $$x1 = new $c_s_util_Success($m_ju_UUID$().fromString__T__ju_UUID(s))
  } catch (e) {
    var e$2 = $m_sjsr_package$().wrapJavaScriptException__O__jl_Throwable(e);
    if ((e$2 !== null)) {
      matchEnd8: {
        var $$x1;
        if ((e$2 !== null)) {
          var o11 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
          if ((!o11.isEmpty__Z())) {
            var e$3 = $as_jl_Throwable(o11.get__O());
            var $$x1 = new $c_s_util_Failure(e$3);
            break matchEnd8
          }
        };
        throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(e$2)
      }
    } else {
      var $$x1;
      throw e
    }
  };
  var uncheckedUuid = $$x1.toOption__s_Option();
  if (this.Lplay_api_libs_json_DefaultReads$UUIDReader__f_checkValidity) {
    if (uncheckedUuid.isEmpty__Z()) {
      var $$x2 = true
    } else {
      var arg1 = uncheckedUuid.get__O();
      var u = $as_ju_UUID(arg1);
      var $$x2 = this.check__T__ju_UUID__Z(s, u)
    };
    if ($$x2) {
      return uncheckedUuid
    } else {
      return $m_s_None$()
    }
  } else {
    return uncheckedUuid
  }
});
$c_Lplay_api_libs_json_DefaultReads$UUIDReader.prototype.reads__Lplay_api_libs_json_JsValue__Lplay_api_libs_json_JsResult = (function(json) {
  if ((json instanceof $c_Lplay_api_libs_json_JsString)) {
    var x2 = $as_Lplay_api_libs_json_JsString(json);
    var s = x2.Lplay_api_libs_json_JsString__f_value;
    var this$1 = this.parseUuid__T__s_Option(s);
    if (this$1.isEmpty__Z()) {
      var this$4 = $m_s_None$()
    } else {
      var arg1 = this$1.get__O();
      var x$15 = $as_ju_UUID(arg1);
      var this$4 = new $c_s_Some(new $c_Lplay_api_libs_json_JsSuccess(x$15, $ct_Lplay_api_libs_json_JsPath__sci_List__(new $c_Lplay_api_libs_json_JsPath(), ($m_Lplay_api_libs_json_JsPath$(), $m_sci_Nil$()))))
    };
    if (this$4.isEmpty__Z()) {
      var $$x4 = $m_sc_Seq$();
      var self = $m_Lplay_api_libs_json_JsPath$();
      var $$x3 = $m_sc_Seq$();
      var $$x2 = $m_Lplay_api_libs_json_JsonValidationError$();
      var array = [];
      var array$1 = [$$x2.apply__T__sci_Seq__Lplay_api_libs_json_JsonValidationError("error.expected.uuid", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))];
      var y = $$x3.apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1));
      var array$2 = [new $c_T2(self, y)];
      var $$x1 = new $c_Lplay_api_libs_json_JsError($as_sc_Seq($$x4.apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))))
    } else {
      var $$x1 = this$4.get__O()
    };
    return $as_Lplay_api_libs_json_JsResult($$x1)
  } else {
    var $$x7 = $m_sc_Seq$();
    var self$1 = $m_Lplay_api_libs_json_JsPath$();
    var $$x6 = $m_sc_Seq$();
    var $$x5 = $m_Lplay_api_libs_json_JsonValidationError$();
    var array$3 = [];
    var array$4 = [$$x5.apply__T__sci_Seq__Lplay_api_libs_json_JsonValidationError("error.expected.uuid", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))];
    var y$1 = $$x6.apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4));
    var array$5 = [new $c_T2(self$1, y$1)];
    return new $c_Lplay_api_libs_json_JsError($as_sc_Seq($$x7.apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5))))
  }
});
var $d_Lplay_api_libs_json_DefaultReads$UUIDReader = new $TypeData().initClass({
  Lplay_api_libs_json_DefaultReads$UUIDReader: 0
}, false, "play.api.libs.json.DefaultReads$UUIDReader", {
  Lplay_api_libs_json_DefaultReads$UUIDReader: 1,
  O: 1,
  Lplay_api_libs_json_Reads: 1
});
$c_Lplay_api_libs_json_DefaultReads$UUIDReader.prototype.$classData = $d_Lplay_api_libs_json_DefaultReads$UUIDReader;
/** @constructor */
function $c_Lplay_api_libs_json_DefaultWrites$IntWrites$(outer) {
  /*<skip>*/
}
$c_Lplay_api_libs_json_DefaultWrites$IntWrites$.prototype = new $h_O();
$c_Lplay_api_libs_json_DefaultWrites$IntWrites$.prototype.constructor = $c_Lplay_api_libs_json_DefaultWrites$IntWrites$;
/** @constructor */
function $h_Lplay_api_libs_json_DefaultWrites$IntWrites$() {
  /*<skip>*/
}
$h_Lplay_api_libs_json_DefaultWrites$IntWrites$.prototype = $c_Lplay_api_libs_json_DefaultWrites$IntWrites$.prototype;
$c_Lplay_api_libs_json_DefaultWrites$IntWrites$.prototype.contramap__F1__Lplay_api_libs_json_Writes = (function(f) {
  return $f_Lplay_api_libs_json_Writes__contramap__F1__Lplay_api_libs_json_Writes(this, f)
});
$c_Lplay_api_libs_json_DefaultWrites$IntWrites$.prototype.writes__I__Lplay_api_libs_json_JsNumber = (function(o) {
  var this$1 = $m_s_math_BigDecimal$();
  return new $c_Lplay_api_libs_json_JsNumber(this$1.apply__I__Ljava_math_MathContext__s_math_BigDecimal(o, this$1.s_math_BigDecimal$__f_defaultMathContext))
});
$c_Lplay_api_libs_json_DefaultWrites$IntWrites$.prototype.writes__O__Lplay_api_libs_json_JsValue = (function(o) {
  return this.writes__I__Lplay_api_libs_json_JsNumber($uI(o))
});
var $d_Lplay_api_libs_json_DefaultWrites$IntWrites$ = new $TypeData().initClass({
  Lplay_api_libs_json_DefaultWrites$IntWrites$: 0
}, false, "play.api.libs.json.DefaultWrites$IntWrites$", {
  Lplay_api_libs_json_DefaultWrites$IntWrites$: 1,
  O: 1,
  Lplay_api_libs_json_Writes: 1
});
$c_Lplay_api_libs_json_DefaultWrites$IntWrites$.prototype.$classData = $d_Lplay_api_libs_json_DefaultWrites$IntWrites$;
/** @constructor */
function $c_Lplay_api_libs_json_DefaultWrites$StringWrites$(outer) {
  /*<skip>*/
}
$c_Lplay_api_libs_json_DefaultWrites$StringWrites$.prototype = new $h_O();
$c_Lplay_api_libs_json_DefaultWrites$StringWrites$.prototype.constructor = $c_Lplay_api_libs_json_DefaultWrites$StringWrites$;
/** @constructor */
function $h_Lplay_api_libs_json_DefaultWrites$StringWrites$() {
  /*<skip>*/
}
$h_Lplay_api_libs_json_DefaultWrites$StringWrites$.prototype = $c_Lplay_api_libs_json_DefaultWrites$StringWrites$.prototype;
$c_Lplay_api_libs_json_DefaultWrites$StringWrites$.prototype.contramap__F1__Lplay_api_libs_json_Writes = (function(f) {
  return $f_Lplay_api_libs_json_Writes__contramap__F1__Lplay_api_libs_json_Writes(this, f)
});
$c_Lplay_api_libs_json_DefaultWrites$StringWrites$.prototype.writes__O__Lplay_api_libs_json_JsValue = (function(o) {
  var o$1 = $as_T(o);
  return new $c_Lplay_api_libs_json_JsString(o$1)
});
var $d_Lplay_api_libs_json_DefaultWrites$StringWrites$ = new $TypeData().initClass({
  Lplay_api_libs_json_DefaultWrites$StringWrites$: 0
}, false, "play.api.libs.json.DefaultWrites$StringWrites$", {
  Lplay_api_libs_json_DefaultWrites$StringWrites$: 1,
  O: 1,
  Lplay_api_libs_json_Writes: 1
});
$c_Lplay_api_libs_json_DefaultWrites$StringWrites$.prototype.$classData = $d_Lplay_api_libs_json_DefaultWrites$StringWrites$;
/** @constructor */
function $c_Lplay_api_libs_json_JsError$() {
  /*<skip>*/
}
$c_Lplay_api_libs_json_JsError$.prototype = new $h_O();
$c_Lplay_api_libs_json_JsError$.prototype.constructor = $c_Lplay_api_libs_json_JsError$;
/** @constructor */
function $h_Lplay_api_libs_json_JsError$() {
  /*<skip>*/
}
$h_Lplay_api_libs_json_JsError$.prototype = $c_Lplay_api_libs_json_JsError$.prototype;
$c_Lplay_api_libs_json_JsError$.prototype.apply__Lplay_api_libs_json_JsonValidationError__Lplay_api_libs_json_JsError = (function(error) {
  var $$x2 = $m_sc_Seq$();
  var self = $m_Lplay_api_libs_json_JsPath$();
  var $$x1 = $m_sc_Seq$();
  var array = [error];
  var y = $$x1.apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
  var array$1 = [new $c_T2(self, y)];
  return new $c_Lplay_api_libs_json_JsError($as_sc_Seq($$x2.apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))))
});
$c_Lplay_api_libs_json_JsError$.prototype.apply__T__Lplay_api_libs_json_JsError = (function(error) {
  var $$x2 = $m_Lplay_api_libs_json_JsError$();
  var $$x1 = $m_Lplay_api_libs_json_JsonValidationError$();
  var array = [];
  return $$x2.apply__Lplay_api_libs_json_JsonValidationError__Lplay_api_libs_json_JsError($$x1.apply__T__sci_Seq__Lplay_api_libs_json_JsonValidationError(error, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)))
});
$c_Lplay_api_libs_json_JsError$.prototype.merge__sc_Seq__sc_Seq__sc_Seq = (function(e1, e2) {
  var this$1 = $as_sc_IterableOps(e1.appendedAll__sc_IterableOnce__O(e2));
  var m = $as_scm_Map($m_scm_Map$().empty__O());
  var it = this$1.iterator__sc_Iterator();
  while (it.hasNext__Z()) {
    var elem = it.next__O();
    var x$1 = $as_T2(elem);
    var key = $as_Lplay_api_libs_json_JsPath(x$1._1__O());
    var bldr = $as_scm_Builder(m.getOrElseUpdate__O__F0__O(key, new $c_sjsr_AnonFunction0((function(this$2) {
      return (function() {
        return this$2.newSpecificBuilder__scm_Builder()
      })
    })(this$1))));
    bldr.addOne__O__scm_Growable(elem)
  };
  var this$3 = $m_sci_HashMap$();
  var result = this$3.sci_HashMap$__f_EmptyMap;
  var mapIt = m.iterator__sc_Iterator();
  while (mapIt.hasNext__Z()) {
    var x1 = $as_T2(mapIt.next__O());
    if ((x1 === null)) {
      throw new $c_s_MatchError(x1)
    };
    var k = x1._1__O();
    var v = $as_scm_Builder(x1._2__O());
    result = result.updated__O__O__sci_HashMap(k, v.result__O())
  };
  var this$5 = result;
  var f = new $c_sjsr_AnonFunction1((function(this$2$1) {
    return (function(x$2$2) {
      var x$2 = $as_sc_Seq(x$2$2);
      return $as_sc_Seq(x$2.flatMap__F1__O(new $c_sjsr_AnonFunction1((function(this$4) {
        return (function(x$3$2) {
          var x$3 = $as_T2(x$3$2);
          return $as_sc_Seq(x$3._2__O())
        })
      })(this$2$1))))
    })
  })(this));
  var this$6 = new $c_sc_MapView$MapValues(this$5, f);
  $m_sci_List$();
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$6)
});
var $d_Lplay_api_libs_json_JsError$ = new $TypeData().initClass({
  Lplay_api_libs_json_JsError$: 0
}, false, "play.api.libs.json.JsError$", {
  Lplay_api_libs_json_JsError$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lplay_api_libs_json_JsError$.prototype.$classData = $d_Lplay_api_libs_json_JsError$;
var $n_Lplay_api_libs_json_JsError$;
function $m_Lplay_api_libs_json_JsError$() {
  if ((!$n_Lplay_api_libs_json_JsError$)) {
    $n_Lplay_api_libs_json_JsError$ = new $c_Lplay_api_libs_json_JsError$()
  };
  return $n_Lplay_api_libs_json_JsError$
}
function $is_Lplay_api_libs_json_JsValue(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lplay_api_libs_json_JsValue)))
}
function $as_Lplay_api_libs_json_JsValue(obj) {
  return (($is_Lplay_api_libs_json_JsValue(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "play.api.libs.json.JsValue"))
}
function $isArrayOf_Lplay_api_libs_json_JsValue(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lplay_api_libs_json_JsValue)))
}
function $asArrayOf_Lplay_api_libs_json_JsValue(obj, depth) {
  return (($isArrayOf_Lplay_api_libs_json_JsValue(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lplay.api.libs.json.JsValue;", depth))
}
var $d_Lplay_api_libs_json_JsValue = new $TypeData().initClass({
  Lplay_api_libs_json_JsValue: 0
}, true, "play.api.libs.json.JsValue", {
  Lplay_api_libs_json_JsValue: 1,
  O: 1,
  Lplay_api_libs_json_JsReadable: 1
});
/** @constructor */
function $c_Lplay_api_libs_json_JsonConfiguration$Impl(naming, optionHandlers, discriminator, typeNaming) {
  this.Lplay_api_libs_json_JsonConfiguration$Impl__f_naming = null;
  this.Lplay_api_libs_json_JsonConfiguration$Impl__f_optionHandlers = null;
  this.Lplay_api_libs_json_JsonConfiguration$Impl__f_discriminator = null;
  this.Lplay_api_libs_json_JsonConfiguration$Impl__f_typeNaming = null;
  this.Lplay_api_libs_json_JsonConfiguration$Impl__f_naming = naming;
  this.Lplay_api_libs_json_JsonConfiguration$Impl__f_optionHandlers = optionHandlers;
  this.Lplay_api_libs_json_JsonConfiguration$Impl__f_discriminator = discriminator;
  this.Lplay_api_libs_json_JsonConfiguration$Impl__f_typeNaming = typeNaming
}
$c_Lplay_api_libs_json_JsonConfiguration$Impl.prototype = new $h_O();
$c_Lplay_api_libs_json_JsonConfiguration$Impl.prototype.constructor = $c_Lplay_api_libs_json_JsonConfiguration$Impl;
/** @constructor */
function $h_Lplay_api_libs_json_JsonConfiguration$Impl() {
  /*<skip>*/
}
$h_Lplay_api_libs_json_JsonConfiguration$Impl.prototype = $c_Lplay_api_libs_json_JsonConfiguration$Impl.prototype;
var $d_Lplay_api_libs_json_JsonConfiguration$Impl = new $TypeData().initClass({
  Lplay_api_libs_json_JsonConfiguration$Impl: 0
}, false, "play.api.libs.json.JsonConfiguration$Impl", {
  Lplay_api_libs_json_JsonConfiguration$Impl: 1,
  O: 1,
  Lplay_api_libs_json_JsonConfiguration: 1
});
$c_Lplay_api_libs_json_JsonConfiguration$Impl.prototype.$classData = $d_Lplay_api_libs_json_JsonConfiguration$Impl;
/** @constructor */
function $c_Lplay_api_libs_json_JsonValidationError$() {
  this.Lplay_api_libs_json_JsonValidationError$__f_PathMissing = null;
  $n_Lplay_api_libs_json_JsonValidationError$ = this;
  var $$x2 = $m_sci_Seq$();
  var $$x1 = $m_Lplay_api_libs_json_JsonValidationError$();
  var array = [];
  var array$1 = [$$x1.apply__T__sci_Seq__Lplay_api_libs_json_JsonValidationError("error.path.missing", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))];
  this.Lplay_api_libs_json_JsonValidationError$__f_PathMissing = $as_sci_Seq($$x2.apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1)))
}
$c_Lplay_api_libs_json_JsonValidationError$.prototype = new $h_O();
$c_Lplay_api_libs_json_JsonValidationError$.prototype.constructor = $c_Lplay_api_libs_json_JsonValidationError$;
/** @constructor */
function $h_Lplay_api_libs_json_JsonValidationError$() {
  /*<skip>*/
}
$h_Lplay_api_libs_json_JsonValidationError$.prototype = $c_Lplay_api_libs_json_JsonValidationError$.prototype;
$c_Lplay_api_libs_json_JsonValidationError$.prototype.apply__T__sci_Seq__Lplay_api_libs_json_JsonValidationError = (function(message, args) {
  var $$x1 = $m_sci_Seq$();
  var array = [message];
  return new $c_Lplay_api_libs_json_JsonValidationError($as_sci_Seq($$x1.apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))), args)
});
var $d_Lplay_api_libs_json_JsonValidationError$ = new $TypeData().initClass({
  Lplay_api_libs_json_JsonValidationError$: 0
}, false, "play.api.libs.json.JsonValidationError$", {
  Lplay_api_libs_json_JsonValidationError$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lplay_api_libs_json_JsonValidationError$.prototype.$classData = $d_Lplay_api_libs_json_JsonValidationError$;
var $n_Lplay_api_libs_json_JsonValidationError$;
function $m_Lplay_api_libs_json_JsonValidationError$() {
  if ((!$n_Lplay_api_libs_json_JsonValidationError$)) {
    $n_Lplay_api_libs_json_JsonValidationError$ = new $c_Lplay_api_libs_json_JsonValidationError$()
  };
  return $n_Lplay_api_libs_json_JsonValidationError$
}
function $f_Lplay_api_libs_json_LowPriorityWrites__$init$__V($thiz) {
  var this$2 = $m_s_$less$colon$less$();
  var conv = this$2.s_$less$colon$less$__f_singleton;
  var this$3 = $m_Lplay_api_libs_json_Writes$().StringWrites__Lplay_api_libs_json_DefaultWrites$StringWrites$();
  var e = $f_Lplay_api_libs_json_Writes__contramap__F1__Lplay_api_libs_json_Writes(this$3, conv);
  $thiz.Lplay_api_libs_json_Writes$__f_uriWrites = e.contramap__F1__Lplay_api_libs_json_Writes(new $c_sjsr_AnonFunction1((function(this$5) {
    return (function(x$6$2) {
      var x$6 = $as_Ljava_net_URI(x$6$2);
      return x$6.Ljava_net_URI__f_origStr
    })
  })($thiz)))
}
/** @constructor */
function $c_Lplay_api_libs_json_OFormat$$anon$1(rcb$1, wcb$1) {
  this.Lplay_api_libs_json_OFormat$$anon$1__f_rcb$1 = null;
  this.Lplay_api_libs_json_OFormat$$anon$1__f_wcb$1 = null;
  this.Lplay_api_libs_json_OFormat$$anon$1__f_rcb$1 = rcb$1;
  this.Lplay_api_libs_json_OFormat$$anon$1__f_wcb$1 = wcb$1
}
$c_Lplay_api_libs_json_OFormat$$anon$1.prototype = new $h_O();
$c_Lplay_api_libs_json_OFormat$$anon$1.prototype.constructor = $c_Lplay_api_libs_json_OFormat$$anon$1;
/** @constructor */
function $h_Lplay_api_libs_json_OFormat$$anon$1() {
  /*<skip>*/
}
$h_Lplay_api_libs_json_OFormat$$anon$1.prototype = $c_Lplay_api_libs_json_OFormat$$anon$1.prototype;
$c_Lplay_api_libs_json_OFormat$$anon$1.prototype.apply__Lplay_api_libs_json_OFormat__Lplay_api_libs_json_OFormat__Lplay_api_libs_json_OFormat = (function(fa, fb) {
  $m_Lplay_api_libs_json_OFormat$();
  var r = $as_Lplay_api_libs_json_Reads(this.Lplay_api_libs_json_OFormat$$anon$1__f_rcb$1.apply__O__O__O(fa, fb));
  var w = $as_Lplay_api_libs_json_OWrites(this.Lplay_api_libs_json_OFormat$$anon$1__f_wcb$1.apply__O__O__O(fa, fb));
  return new $c_Lplay_api_libs_json_OFormat$$anon$4(r, w)
});
$c_Lplay_api_libs_json_OFormat$$anon$1.prototype.apply__O__O__O = (function(ma, mb) {
  return this.apply__Lplay_api_libs_json_OFormat__Lplay_api_libs_json_OFormat__Lplay_api_libs_json_OFormat($as_Lplay_api_libs_json_OFormat(ma), $as_Lplay_api_libs_json_OFormat(mb))
});
var $d_Lplay_api_libs_json_OFormat$$anon$1 = new $TypeData().initClass({
  Lplay_api_libs_json_OFormat$$anon$1: 0
}, false, "play.api.libs.json.OFormat$$anon$1", {
  Lplay_api_libs_json_OFormat$$anon$1: 1,
  O: 1,
  Lplay_api_libs_functional_FunctionalCanBuild: 1
});
$c_Lplay_api_libs_json_OFormat$$anon$1.prototype.$classData = $d_Lplay_api_libs_json_OFormat$$anon$1;
function $f_Lplay_api_libs_json_OWrites__contramap__F1__Lplay_api_libs_json_OWrites($thiz, f) {
  $m_Lplay_api_libs_json_OWrites$();
  var f$2 = new $c_sjsr_AnonFunction1((function(this$1, f$1) {
    return (function(b$2) {
      return this$1.writes__O__Lplay_api_libs_json_JsObject(f$1.apply__O__O(b$2))
    })
  })($thiz, f));
  return new $c_Lplay_api_libs_json_OWrites$$anon$4(f$2)
}
function $is_Lplay_api_libs_json_OWrites(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lplay_api_libs_json_OWrites)))
}
function $as_Lplay_api_libs_json_OWrites(obj) {
  return (($is_Lplay_api_libs_json_OWrites(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "play.api.libs.json.OWrites"))
}
function $isArrayOf_Lplay_api_libs_json_OWrites(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lplay_api_libs_json_OWrites)))
}
function $asArrayOf_Lplay_api_libs_json_OWrites(obj, depth) {
  return (($isArrayOf_Lplay_api_libs_json_OWrites(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lplay.api.libs.json.OWrites;", depth))
}
/** @constructor */
function $c_Lplay_api_libs_json_OWrites$$anon$2() {
  /*<skip>*/
}
$c_Lplay_api_libs_json_OWrites$$anon$2.prototype = new $h_O();
$c_Lplay_api_libs_json_OWrites$$anon$2.prototype.constructor = $c_Lplay_api_libs_json_OWrites$$anon$2;
/** @constructor */
function $h_Lplay_api_libs_json_OWrites$$anon$2() {
  /*<skip>*/
}
$h_Lplay_api_libs_json_OWrites$$anon$2.prototype = $c_Lplay_api_libs_json_OWrites$$anon$2.prototype;
$c_Lplay_api_libs_json_OWrites$$anon$2.prototype.apply__O__O__O = (function(ma, mb) {
  var wa = $as_Lplay_api_libs_json_OWrites(ma);
  var wb = $as_Lplay_api_libs_json_OWrites(mb);
  return new $c_Lplay_api_libs_json_OWrites$MergedOWrites$$anon$1(wa, wb)
});
var $d_Lplay_api_libs_json_OWrites$$anon$2 = new $TypeData().initClass({
  Lplay_api_libs_json_OWrites$$anon$2: 0
}, false, "play.api.libs.json.OWrites$$anon$2", {
  Lplay_api_libs_json_OWrites$$anon$2: 1,
  O: 1,
  Lplay_api_libs_functional_FunctionalCanBuild: 1
});
$c_Lplay_api_libs_json_OWrites$$anon$2.prototype.$classData = $d_Lplay_api_libs_json_OWrites$$anon$2;
/** @constructor */
function $c_Lplay_api_libs_json_OptionHandlers$Default$() {
  /*<skip>*/
}
$c_Lplay_api_libs_json_OptionHandlers$Default$.prototype = new $h_O();
$c_Lplay_api_libs_json_OptionHandlers$Default$.prototype.constructor = $c_Lplay_api_libs_json_OptionHandlers$Default$;
/** @constructor */
function $h_Lplay_api_libs_json_OptionHandlers$Default$() {
  /*<skip>*/
}
$h_Lplay_api_libs_json_OptionHandlers$Default$.prototype = $c_Lplay_api_libs_json_OptionHandlers$Default$.prototype;
var $d_Lplay_api_libs_json_OptionHandlers$Default$ = new $TypeData().initClass({
  Lplay_api_libs_json_OptionHandlers$Default$: 0
}, false, "play.api.libs.json.OptionHandlers$Default$", {
  Lplay_api_libs_json_OptionHandlers$Default$: 1,
  O: 1,
  Lplay_api_libs_json_OptionHandlers: 1
});
$c_Lplay_api_libs_json_OptionHandlers$Default$.prototype.$classData = $d_Lplay_api_libs_json_OptionHandlers$Default$;
var $n_Lplay_api_libs_json_OptionHandlers$Default$;
function $m_Lplay_api_libs_json_OptionHandlers$Default$() {
  if ((!$n_Lplay_api_libs_json_OptionHandlers$Default$)) {
    $n_Lplay_api_libs_json_OptionHandlers$Default$ = new $c_Lplay_api_libs_json_OptionHandlers$Default$()
  };
  return $n_Lplay_api_libs_json_OptionHandlers$Default$
}
/** @constructor */
function $c_Lplay_api_libs_json_Reads$$anon$1$$anon$2(outer, mf$1, ma$1) {
  this.Lplay_api_libs_json_Reads$$anon$1$$anon$2__f_$outer = null;
  this.Lplay_api_libs_json_Reads$$anon$1$$anon$2__f_mf$1 = null;
  this.Lplay_api_libs_json_Reads$$anon$1$$anon$2__f_ma$1 = null;
  if ((outer === null)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(null)
  } else {
    this.Lplay_api_libs_json_Reads$$anon$1$$anon$2__f_$outer = outer
  };
  this.Lplay_api_libs_json_Reads$$anon$1$$anon$2__f_mf$1 = mf$1;
  this.Lplay_api_libs_json_Reads$$anon$1$$anon$2__f_ma$1 = ma$1
}
$c_Lplay_api_libs_json_Reads$$anon$1$$anon$2.prototype = new $h_O();
$c_Lplay_api_libs_json_Reads$$anon$1$$anon$2.prototype.constructor = $c_Lplay_api_libs_json_Reads$$anon$1$$anon$2;
/** @constructor */
function $h_Lplay_api_libs_json_Reads$$anon$1$$anon$2() {
  /*<skip>*/
}
$h_Lplay_api_libs_json_Reads$$anon$1$$anon$2.prototype = $c_Lplay_api_libs_json_Reads$$anon$1$$anon$2.prototype;
$c_Lplay_api_libs_json_Reads$$anon$1$$anon$2.prototype.reads__Lplay_api_libs_json_JsValue__Lplay_api_libs_json_JsResult = (function(js) {
  return $as_Lplay_api_libs_json_JsResult(this.Lplay_api_libs_json_Reads$$anon$1$$anon$2__f_$outer.Lplay_api_libs_json_Reads$$anon$1__f_applicativeJsResult$1.apply__O__O__O(this.Lplay_api_libs_json_Reads$$anon$1$$anon$2__f_mf$1.reads__Lplay_api_libs_json_JsValue__Lplay_api_libs_json_JsResult(js), this.Lplay_api_libs_json_Reads$$anon$1$$anon$2__f_ma$1.reads__Lplay_api_libs_json_JsValue__Lplay_api_libs_json_JsResult(js)))
});
var $d_Lplay_api_libs_json_Reads$$anon$1$$anon$2 = new $TypeData().initClass({
  Lplay_api_libs_json_Reads$$anon$1$$anon$2: 0
}, false, "play.api.libs.json.Reads$$anon$1$$anon$2", {
  Lplay_api_libs_json_Reads$$anon$1$$anon$2: 1,
  O: 1,
  Lplay_api_libs_json_Reads: 1
});
$c_Lplay_api_libs_json_Reads$$anon$1$$anon$2.prototype.$classData = $d_Lplay_api_libs_json_Reads$$anon$1$$anon$2;
/** @constructor */
function $c_Lplay_api_libs_json_Reads$$anon$6(f$10) {
  this.Lplay_api_libs_json_Reads$$anon$6__f_f$10 = null;
  this.Lplay_api_libs_json_Reads$$anon$6__f_f$10 = f$10
}
$c_Lplay_api_libs_json_Reads$$anon$6.prototype = new $h_O();
$c_Lplay_api_libs_json_Reads$$anon$6.prototype.constructor = $c_Lplay_api_libs_json_Reads$$anon$6;
/** @constructor */
function $h_Lplay_api_libs_json_Reads$$anon$6() {
  /*<skip>*/
}
$h_Lplay_api_libs_json_Reads$$anon$6.prototype = $c_Lplay_api_libs_json_Reads$$anon$6.prototype;
$c_Lplay_api_libs_json_Reads$$anon$6.prototype.reads__Lplay_api_libs_json_JsValue__Lplay_api_libs_json_JsResult = (function(json) {
  return $as_Lplay_api_libs_json_JsResult(this.Lplay_api_libs_json_Reads$$anon$6__f_f$10.apply__O__O(json))
});
var $d_Lplay_api_libs_json_Reads$$anon$6 = new $TypeData().initClass({
  Lplay_api_libs_json_Reads$$anon$6: 0
}, false, "play.api.libs.json.Reads$$anon$6", {
  Lplay_api_libs_json_Reads$$anon$6: 1,
  O: 1,
  Lplay_api_libs_json_Reads: 1
});
$c_Lplay_api_libs_json_Reads$$anon$6.prototype.$classData = $d_Lplay_api_libs_json_Reads$$anon$6;
/** @constructor */
function $c_Lplay_api_libs_json_Reads$JsArrayMonoid$() {
  /*<skip>*/
}
$c_Lplay_api_libs_json_Reads$JsArrayMonoid$.prototype = new $h_O();
$c_Lplay_api_libs_json_Reads$JsArrayMonoid$.prototype.constructor = $c_Lplay_api_libs_json_Reads$JsArrayMonoid$;
/** @constructor */
function $h_Lplay_api_libs_json_Reads$JsArrayMonoid$() {
  /*<skip>*/
}
$h_Lplay_api_libs_json_Reads$JsArrayMonoid$.prototype = $c_Lplay_api_libs_json_Reads$JsArrayMonoid$.prototype;
var $d_Lplay_api_libs_json_Reads$JsArrayMonoid$ = new $TypeData().initClass({
  Lplay_api_libs_json_Reads$JsArrayMonoid$: 0
}, false, "play.api.libs.json.Reads$JsArrayMonoid$", {
  Lplay_api_libs_json_Reads$JsArrayMonoid$: 1,
  O: 1,
  Lplay_api_libs_functional_Monoid: 1
});
$c_Lplay_api_libs_json_Reads$JsArrayMonoid$.prototype.$classData = $d_Lplay_api_libs_json_Reads$JsArrayMonoid$;
var $n_Lplay_api_libs_json_Reads$JsArrayMonoid$;
function $m_Lplay_api_libs_json_Reads$JsArrayMonoid$() {
  if ((!$n_Lplay_api_libs_json_Reads$JsArrayMonoid$)) {
    $n_Lplay_api_libs_json_Reads$JsArrayMonoid$ = new $c_Lplay_api_libs_json_Reads$JsArrayMonoid$()
  };
  return $n_Lplay_api_libs_json_Reads$JsArrayMonoid$
}
/** @constructor */
function $c_Lplay_api_libs_json_Reads$JsObjectMonoid$() {
  /*<skip>*/
}
$c_Lplay_api_libs_json_Reads$JsObjectMonoid$.prototype = new $h_O();
$c_Lplay_api_libs_json_Reads$JsObjectMonoid$.prototype.constructor = $c_Lplay_api_libs_json_Reads$JsObjectMonoid$;
/** @constructor */
function $h_Lplay_api_libs_json_Reads$JsObjectMonoid$() {
  /*<skip>*/
}
$h_Lplay_api_libs_json_Reads$JsObjectMonoid$.prototype = $c_Lplay_api_libs_json_Reads$JsObjectMonoid$.prototype;
var $d_Lplay_api_libs_json_Reads$JsObjectMonoid$ = new $TypeData().initClass({
  Lplay_api_libs_json_Reads$JsObjectMonoid$: 0
}, false, "play.api.libs.json.Reads$JsObjectMonoid$", {
  Lplay_api_libs_json_Reads$JsObjectMonoid$: 1,
  O: 1,
  Lplay_api_libs_functional_Monoid: 1
});
$c_Lplay_api_libs_json_Reads$JsObjectMonoid$.prototype.$classData = $d_Lplay_api_libs_json_Reads$JsObjectMonoid$;
var $n_Lplay_api_libs_json_Reads$JsObjectMonoid$;
function $m_Lplay_api_libs_json_Reads$JsObjectMonoid$() {
  if ((!$n_Lplay_api_libs_json_Reads$JsObjectMonoid$)) {
    $n_Lplay_api_libs_json_Reads$JsObjectMonoid$ = new $c_Lplay_api_libs_json_Reads$JsObjectMonoid$()
  };
  return $n_Lplay_api_libs_json_Reads$JsObjectMonoid$
}
/** @constructor */
function $c_Lplay_api_libs_json_Writes$$anon$6(f$5) {
  this.Lplay_api_libs_json_Writes$$anon$6__f_f$5 = null;
  this.Lplay_api_libs_json_Writes$$anon$6__f_f$5 = f$5
}
$c_Lplay_api_libs_json_Writes$$anon$6.prototype = new $h_O();
$c_Lplay_api_libs_json_Writes$$anon$6.prototype.constructor = $c_Lplay_api_libs_json_Writes$$anon$6;
/** @constructor */
function $h_Lplay_api_libs_json_Writes$$anon$6() {
  /*<skip>*/
}
$h_Lplay_api_libs_json_Writes$$anon$6.prototype = $c_Lplay_api_libs_json_Writes$$anon$6.prototype;
$c_Lplay_api_libs_json_Writes$$anon$6.prototype.contramap__F1__Lplay_api_libs_json_Writes = (function(f) {
  return $f_Lplay_api_libs_json_Writes__contramap__F1__Lplay_api_libs_json_Writes(this, f)
});
$c_Lplay_api_libs_json_Writes$$anon$6.prototype.writes__O__Lplay_api_libs_json_JsValue = (function(a) {
  return $as_Lplay_api_libs_json_JsValue(this.Lplay_api_libs_json_Writes$$anon$6__f_f$5.apply__O__O(a))
});
var $d_Lplay_api_libs_json_Writes$$anon$6 = new $TypeData().initClass({
  Lplay_api_libs_json_Writes$$anon$6: 0
}, false, "play.api.libs.json.Writes$$anon$6", {
  Lplay_api_libs_json_Writes$$anon$6: 1,
  O: 1,
  Lplay_api_libs_json_Writes: 1
});
$c_Lplay_api_libs_json_Writes$$anon$6.prototype.$classData = $d_Lplay_api_libs_json_Writes$$anon$6;
/** @constructor */
function $c_s_$less$colon$less$() {
  this.s_$less$colon$less$__f_singleton = null;
  $n_s_$less$colon$less$ = this;
  this.s_$less$colon$less$__f_singleton = new $c_s_$less$colon$less$$anon$1()
}
$c_s_$less$colon$less$.prototype = new $h_O();
$c_s_$less$colon$less$.prototype.constructor = $c_s_$less$colon$less$;
/** @constructor */
function $h_s_$less$colon$less$() {
  /*<skip>*/
}
$h_s_$less$colon$less$.prototype = $c_s_$less$colon$less$.prototype;
var $d_s_$less$colon$less$ = new $TypeData().initClass({
  s_$less$colon$less$: 0
}, false, "scala.$less$colon$less$", {
  s_$less$colon$less$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_s_$less$colon$less$.prototype.$classData = $d_s_$less$colon$less$;
var $n_s_$less$colon$less$;
function $m_s_$less$colon$less$() {
  if ((!$n_s_$less$colon$less$)) {
    $n_s_$less$colon$less$ = new $c_s_$less$colon$less$()
  };
  return $n_s_$less$colon$less$
}
function $p_s_Array$__slowcopy__O__I__O__I__I__V($thiz, src, srcPos, dest, destPos, length) {
  var i = srcPos;
  var j = destPos;
  var srcUntil = ((srcPos + length) | 0);
  while ((i < srcUntil)) {
    $m_sr_ScalaRunTime$().array_update__O__I__O__V(dest, j, $m_sr_ScalaRunTime$().array_apply__O__I__O(src, i));
    i = ((1 + i) | 0);
    j = ((1 + j) | 0)
  }
}
/** @constructor */
function $c_s_Array$() {
  /*<skip>*/
}
$c_s_Array$.prototype = new $h_O();
$c_s_Array$.prototype.constructor = $c_s_Array$;
/** @constructor */
function $h_s_Array$() {
  /*<skip>*/
}
$h_s_Array$.prototype = $c_s_Array$.prototype;
$c_s_Array$.prototype.copy__O__I__O__I__I__V = (function(src, srcPos, dest, destPos, length) {
  var srcClass = $objectGetClass(src);
  if ((srcClass.isArray__Z() && $objectGetClass(dest).isAssignableFrom__jl_Class__Z(srcClass))) {
    $systemArraycopy(src, srcPos, dest, destPos, length)
  } else {
    $p_s_Array$__slowcopy__O__I__O__I__I__V(this, src, srcPos, dest, destPos, length)
  }
});
$c_s_Array$.prototype.equals__AO__AO__Z = (function(xs, ys) {
  if ((xs === ys)) {
    return true
  };
  if ((xs.u.length !== ys.u.length)) {
    return false
  };
  var len = xs.u.length;
  var i = 0;
  while ((i < len)) {
    if ((!$m_sr_BoxesRunTime$().equals__O__O__Z(xs.get(i), ys.get(i)))) {
      return false
    };
    i = ((1 + i) | 0)
  };
  return true
});
var $d_s_Array$ = new $TypeData().initClass({
  s_Array$: 0
}, false, "scala.Array$", {
  s_Array$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_s_Array$.prototype.$classData = $d_s_Array$;
var $n_s_Array$;
function $m_s_Array$() {
  if ((!$n_s_Array$)) {
    $n_s_Array$ = new $c_s_Array$()
  };
  return $n_s_Array$
}
/** @constructor */
function $c_s_Console$() {
  this.s_Console$__f_outVar = null;
  this.s_Console$__f_errVar = null;
  this.s_Console$__f_inVar = null;
  $n_s_Console$ = this;
  this.s_Console$__f_outVar = new $c_s_util_DynamicVariable($m_jl_System$Streams$().jl_System$Streams$__f_out);
  this.s_Console$__f_errVar = new $c_s_util_DynamicVariable($m_jl_System$Streams$().jl_System$Streams$__f_err);
  this.s_Console$__f_inVar = new $c_s_util_DynamicVariable(null)
}
$c_s_Console$.prototype = new $h_O();
$c_s_Console$.prototype.constructor = $c_s_Console$;
/** @constructor */
function $h_s_Console$() {
  /*<skip>*/
}
$h_s_Console$.prototype = $c_s_Console$.prototype;
$c_s_Console$.prototype.out__Ljava_io_PrintStream = (function() {
  return $as_Ljava_io_PrintStream(this.s_Console$__f_outVar.s_util_DynamicVariable__f_v)
});
$c_s_Console$.prototype.err__Ljava_io_PrintStream = (function() {
  return $as_Ljava_io_PrintStream(this.s_Console$__f_errVar.s_util_DynamicVariable__f_v)
});
var $d_s_Console$ = new $TypeData().initClass({
  s_Console$: 0
}, false, "scala.Console$", {
  s_Console$: 1,
  O: 1,
  s_io_AnsiColor: 1
});
$c_s_Console$.prototype.$classData = $d_s_Console$;
var $n_s_Console$;
function $m_s_Console$() {
  if ((!$n_s_Console$)) {
    $n_s_Console$ = new $c_s_Console$()
  };
  return $n_s_Console$
}
/** @constructor */
function $c_s_LowPriorityImplicits() {
  /*<skip>*/
}
$c_s_LowPriorityImplicits.prototype = new $h_s_LowPriorityImplicits2();
$c_s_LowPriorityImplicits.prototype.constructor = $c_s_LowPriorityImplicits;
/** @constructor */
function $h_s_LowPriorityImplicits() {
  /*<skip>*/
}
$h_s_LowPriorityImplicits.prototype = $c_s_LowPriorityImplicits.prototype;
$c_s_LowPriorityImplicits.prototype.wrapRefArray__AO__scm_ArraySeq$ofRef = (function(xs) {
  if ((xs === null)) {
    return null
  } else if ((xs.u.length === 0)) {
    var this$3 = $m_scm_ArraySeq$();
    $m_s_reflect_ManifestFactory$ObjectManifest$();
    return this$3.scm_ArraySeq$__f_EmptyArraySeq
  } else {
    return new $c_scm_ArraySeq$ofRef(xs)
  }
});
/** @constructor */
function $c_s_Option$() {
  /*<skip>*/
}
$c_s_Option$.prototype = new $h_O();
$c_s_Option$.prototype.constructor = $c_s_Option$;
/** @constructor */
function $h_s_Option$() {
  /*<skip>*/
}
$h_s_Option$.prototype = $c_s_Option$.prototype;
$c_s_Option$.prototype.apply__O__s_Option = (function(x) {
  return ((x === null) ? $m_s_None$() : new $c_s_Some(x))
});
var $d_s_Option$ = new $TypeData().initClass({
  s_Option$: 0
}, false, "scala.Option$", {
  s_Option$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_s_Option$.prototype.$classData = $d_s_Option$;
var $n_s_Option$;
function $m_s_Option$() {
  if ((!$n_s_Option$)) {
    $n_s_Option$ = new $c_s_Option$()
  };
  return $n_s_Option$
}
function $f_s_PartialFunction__applyOrElse__O__F1__O($thiz, x, default$1) {
  return ($thiz.isDefinedAt__O__Z(x) ? $thiz.apply__O__O(x) : default$1.apply__O__O(x))
}
function $is_s_PartialFunction(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.s_PartialFunction)))
}
function $as_s_PartialFunction(obj) {
  return (($is_s_PartialFunction(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.PartialFunction"))
}
function $isArrayOf_s_PartialFunction(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_PartialFunction)))
}
function $asArrayOf_s_PartialFunction(obj, depth) {
  return (($isArrayOf_s_PartialFunction(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.PartialFunction;", depth))
}
/** @constructor */
function $c_T2$() {
  /*<skip>*/
}
$c_T2$.prototype = new $h_O();
$c_T2$.prototype.constructor = $c_T2$;
/** @constructor */
function $h_T2$() {
  /*<skip>*/
}
$h_T2$.prototype = $c_T2$.prototype;
$c_T2$.prototype.toString__T = (function() {
  return "Tuple2"
});
var $d_T2$ = new $TypeData().initClass({
  T2$: 0
}, false, "scala.Tuple2$", {
  T2$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_T2$.prototype.$classData = $d_T2$;
var $n_T2$;
function $m_T2$() {
  if ((!$n_T2$)) {
    $n_T2$ = new $c_T2$()
  };
  return $n_T2$
}
/** @constructor */
function $c_sc_BuildFrom$$anon$5() {
  /*<skip>*/
}
$c_sc_BuildFrom$$anon$5.prototype = new $h_O();
$c_sc_BuildFrom$$anon$5.prototype.constructor = $c_sc_BuildFrom$$anon$5;
/** @constructor */
function $h_sc_BuildFrom$$anon$5() {
  /*<skip>*/
}
$h_sc_BuildFrom$$anon$5.prototype = $c_sc_BuildFrom$$anon$5.prototype;
$c_sc_BuildFrom$$anon$5.prototype.newBuilder__O__scm_Builder = (function(from) {
  $as_T(from);
  return $m_sc_Factory$().sc_Factory$__f_stringFactory.newBuilder__scm_Builder()
});
var $d_sc_BuildFrom$$anon$5 = new $TypeData().initClass({
  sc_BuildFrom$$anon$5: 0
}, false, "scala.collection.BuildFrom$$anon$5", {
  sc_BuildFrom$$anon$5: 1,
  O: 1,
  sc_BuildFrom: 1
});
$c_sc_BuildFrom$$anon$5.prototype.$classData = $d_sc_BuildFrom$$anon$5;
/** @constructor */
function $c_sc_BuildFrom$$anon$6() {
  /*<skip>*/
}
$c_sc_BuildFrom$$anon$6.prototype = new $h_O();
$c_sc_BuildFrom$$anon$6.prototype.constructor = $c_sc_BuildFrom$$anon$6;
/** @constructor */
function $h_sc_BuildFrom$$anon$6() {
  /*<skip>*/
}
$h_sc_BuildFrom$$anon$6.prototype = $c_sc_BuildFrom$$anon$6.prototype;
$c_sc_BuildFrom$$anon$6.prototype.newBuilder__O__scm_Builder = (function(from) {
  $as_sci_WrappedString(from);
  return $m_sci_WrappedString$().newBuilder__scm_Builder()
});
var $d_sc_BuildFrom$$anon$6 = new $TypeData().initClass({
  sc_BuildFrom$$anon$6: 0
}, false, "scala.collection.BuildFrom$$anon$6", {
  sc_BuildFrom$$anon$6: 1,
  O: 1,
  sc_BuildFrom: 1
});
$c_sc_BuildFrom$$anon$6.prototype.$classData = $d_sc_BuildFrom$$anon$6;
/** @constructor */
function $c_sc_BuildFromLowPriority2$$anon$11(outer) {
  /*<skip>*/
}
$c_sc_BuildFromLowPriority2$$anon$11.prototype = new $h_O();
$c_sc_BuildFromLowPriority2$$anon$11.prototype.constructor = $c_sc_BuildFromLowPriority2$$anon$11;
/** @constructor */
function $h_sc_BuildFromLowPriority2$$anon$11() {
  /*<skip>*/
}
$h_sc_BuildFromLowPriority2$$anon$11.prototype = $c_sc_BuildFromLowPriority2$$anon$11.prototype;
$c_sc_BuildFromLowPriority2$$anon$11.prototype.newBuilder__O__scm_Builder = (function(from) {
  var from$1 = $as_sc_Iterable(from);
  return from$1.iterableFactory__sc_IterableFactory().newBuilder__scm_Builder()
});
var $d_sc_BuildFromLowPriority2$$anon$11 = new $TypeData().initClass({
  sc_BuildFromLowPriority2$$anon$11: 0
}, false, "scala.collection.BuildFromLowPriority2$$anon$11", {
  sc_BuildFromLowPriority2$$anon$11: 1,
  O: 1,
  sc_BuildFrom: 1
});
$c_sc_BuildFromLowPriority2$$anon$11.prototype.$classData = $d_sc_BuildFromLowPriority2$$anon$11;
/** @constructor */
function $c_sci_$colon$colon$() {
  /*<skip>*/
}
$c_sci_$colon$colon$.prototype = new $h_O();
$c_sci_$colon$colon$.prototype.constructor = $c_sci_$colon$colon$;
/** @constructor */
function $h_sci_$colon$colon$() {
  /*<skip>*/
}
$h_sci_$colon$colon$.prototype = $c_sci_$colon$colon$.prototype;
$c_sci_$colon$colon$.prototype.toString__T = (function() {
  return "::"
});
var $d_sci_$colon$colon$ = new $TypeData().initClass({
  sci_$colon$colon$: 0
}, false, "scala.collection.immutable.$colon$colon$", {
  sci_$colon$colon$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_sci_$colon$colon$.prototype.$classData = $d_sci_$colon$colon$;
var $n_sci_$colon$colon$;
function $m_sci_$colon$colon$() {
  if ((!$n_sci_$colon$colon$)) {
    $n_sci_$colon$colon$ = new $c_sci_$colon$colon$()
  };
  return $n_sci_$colon$colon$
}
/** @constructor */
function $c_sci_HashMapBuilder$$anon$1(outer, x2$1) {
  this.sci_ChampBaseIterator__f_currentValueCursor = 0;
  this.sci_ChampBaseIterator__f_currentValueLength = 0;
  this.sci_ChampBaseIterator__f_currentValueNode = null;
  this.sci_ChampBaseIterator__f_currentStackLevel = 0;
  this.sci_ChampBaseIterator__f_nodeCursorsAndLengths = null;
  this.sci_ChampBaseIterator__f_nodes = null;
  $ct_sci_ChampBaseIterator__sci_Node__(this, x2$1.sci_HashMap__f_rootNode);
  while (this.hasNext__Z()) {
    var originalHash = this.sci_ChampBaseIterator__f_currentValueNode.getHash__I__I(this.sci_ChampBaseIterator__f_currentValueCursor);
    outer.update__sci_MapNode__O__O__I__I__I__V(outer.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode, $as_sci_MapNode(this.sci_ChampBaseIterator__f_currentValueNode).getKey__I__O(this.sci_ChampBaseIterator__f_currentValueCursor), $as_sci_MapNode(this.sci_ChampBaseIterator__f_currentValueNode).getValue__I__O(this.sci_ChampBaseIterator__f_currentValueCursor), originalHash, $m_sc_Hashing$().improve__I__I(originalHash), 0);
    this.sci_ChampBaseIterator__f_currentValueCursor = ((1 + this.sci_ChampBaseIterator__f_currentValueCursor) | 0)
  }
}
$c_sci_HashMapBuilder$$anon$1.prototype = new $h_sci_ChampBaseIterator();
$c_sci_HashMapBuilder$$anon$1.prototype.constructor = $c_sci_HashMapBuilder$$anon$1;
/** @constructor */
function $h_sci_HashMapBuilder$$anon$1() {
  /*<skip>*/
}
$h_sci_HashMapBuilder$$anon$1.prototype = $c_sci_HashMapBuilder$$anon$1.prototype;
var $d_sci_HashMapBuilder$$anon$1 = new $TypeData().initClass({
  sci_HashMapBuilder$$anon$1: 0
}, false, "scala.collection.immutable.HashMapBuilder$$anon$1", {
  sci_HashMapBuilder$$anon$1: 1,
  sci_ChampBaseIterator: 1,
  O: 1
});
$c_sci_HashMapBuilder$$anon$1.prototype.$classData = $d_sci_HashMapBuilder$$anon$1;
/** @constructor */
function $c_sci_HashSetBuilder$$anon$1(outer, x2$1) {
  this.sci_ChampBaseIterator__f_currentValueCursor = 0;
  this.sci_ChampBaseIterator__f_currentValueLength = 0;
  this.sci_ChampBaseIterator__f_currentValueNode = null;
  this.sci_ChampBaseIterator__f_currentStackLevel = 0;
  this.sci_ChampBaseIterator__f_nodeCursorsAndLengths = null;
  this.sci_ChampBaseIterator__f_nodes = null;
  $ct_sci_ChampBaseIterator__sci_Node__(this, x2$1.sci_HashSet__f_rootNode);
  while (this.hasNext__Z()) {
    var originalHash = this.sci_ChampBaseIterator__f_currentValueNode.getHash__I__I(this.sci_ChampBaseIterator__f_currentValueCursor);
    outer.update__sci_SetNode__O__I__I__I__V(outer.sci_HashSetBuilder__f_scala$collection$immutable$HashSetBuilder$$rootNode, $as_sci_SetNode(this.sci_ChampBaseIterator__f_currentValueNode).getPayload__I__O(this.sci_ChampBaseIterator__f_currentValueCursor), originalHash, $m_sc_Hashing$().improve__I__I(originalHash), 0);
    this.sci_ChampBaseIterator__f_currentValueCursor = ((1 + this.sci_ChampBaseIterator__f_currentValueCursor) | 0)
  }
}
$c_sci_HashSetBuilder$$anon$1.prototype = new $h_sci_ChampBaseIterator();
$c_sci_HashSetBuilder$$anon$1.prototype.constructor = $c_sci_HashSetBuilder$$anon$1;
/** @constructor */
function $h_sci_HashSetBuilder$$anon$1() {
  /*<skip>*/
}
$h_sci_HashSetBuilder$$anon$1.prototype = $c_sci_HashSetBuilder$$anon$1.prototype;
var $d_sci_HashSetBuilder$$anon$1 = new $TypeData().initClass({
  sci_HashSetBuilder$$anon$1: 0
}, false, "scala.collection.immutable.HashSetBuilder$$anon$1", {
  sci_HashSetBuilder$$anon$1: 1,
  sci_ChampBaseIterator: 1,
  O: 1
});
$c_sci_HashSetBuilder$$anon$1.prototype.$classData = $d_sci_HashSetBuilder$$anon$1;
function $is_sci_LazyList$State(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sci_LazyList$State)))
}
function $as_sci_LazyList$State(obj) {
  return (($is_sci_LazyList$State(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.LazyList$State"))
}
function $isArrayOf_sci_LazyList$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_LazyList$State)))
}
function $asArrayOf_sci_LazyList$State(obj, depth) {
  return (($isArrayOf_sci_LazyList$State(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.LazyList$State;", depth))
}
/** @constructor */
function $c_sci_List$$anon$1() {
  /*<skip>*/
}
$c_sci_List$$anon$1.prototype = new $h_O();
$c_sci_List$$anon$1.prototype.constructor = $c_sci_List$$anon$1;
/** @constructor */
function $h_sci_List$$anon$1() {
  /*<skip>*/
}
$h_sci_List$$anon$1.prototype = $c_sci_List$$anon$1.prototype;
$c_sci_List$$anon$1.prototype.toString__T = (function() {
  return "<function1>"
});
$c_sci_List$$anon$1.prototype.apply__O__O = (function(x) {
  return this
});
var $d_sci_List$$anon$1 = new $TypeData().initClass({
  sci_List$$anon$1: 0
}, false, "scala.collection.immutable.List$$anon$1", {
  sci_List$$anon$1: 1,
  O: 1,
  F1: 1
});
$c_sci_List$$anon$1.prototype.$classData = $d_sci_List$$anon$1;
/** @constructor */
function $c_sci_MapNode() {
  /*<skip>*/
}
$c_sci_MapNode.prototype = new $h_sci_Node();
$c_sci_MapNode.prototype.constructor = $c_sci_MapNode;
/** @constructor */
function $h_sci_MapNode() {
  /*<skip>*/
}
$h_sci_MapNode.prototype = $c_sci_MapNode.prototype;
function $as_sci_MapNode(obj) {
  return (((obj instanceof $c_sci_MapNode) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.MapNode"))
}
function $isArrayOf_sci_MapNode(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_MapNode)))
}
function $asArrayOf_sci_MapNode(obj, depth) {
  return (($isArrayOf_sci_MapNode(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.MapNode;", depth))
}
/** @constructor */
function $c_sci_Range$() {
  /*<skip>*/
}
$c_sci_Range$.prototype = new $h_O();
$c_sci_Range$.prototype.constructor = $c_sci_Range$;
/** @constructor */
function $h_sci_Range$() {
  /*<skip>*/
}
$h_sci_Range$.prototype = $c_sci_Range$.prototype;
var $d_sci_Range$ = new $TypeData().initClass({
  sci_Range$: 0
}, false, "scala.collection.immutable.Range$", {
  sci_Range$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Range$.prototype.$classData = $d_sci_Range$;
var $n_sci_Range$;
function $m_sci_Range$() {
  if ((!$n_sci_Range$)) {
    $n_sci_Range$ = new $c_sci_Range$()
  };
  return $n_sci_Range$
}
/** @constructor */
function $c_sci_SetNode() {
  /*<skip>*/
}
$c_sci_SetNode.prototype = new $h_sci_Node();
$c_sci_SetNode.prototype.constructor = $c_sci_SetNode;
/** @constructor */
function $h_sci_SetNode() {
  /*<skip>*/
}
$h_sci_SetNode.prototype = $c_sci_SetNode.prototype;
function $as_sci_SetNode(obj) {
  return (((obj instanceof $c_sci_SetNode) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.SetNode"))
}
function $isArrayOf_sci_SetNode(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_SetNode)))
}
function $asArrayOf_sci_SetNode(obj, depth) {
  return (($isArrayOf_sci_SetNode(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.SetNode;", depth))
}
function $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable($thiz, xs) {
  if ((xs === $thiz)) {
    $thiz.addAll__sc_IterableOnce__scm_Growable($m_scm_Buffer$().from__sc_IterableOnce__sc_SeqOps(xs))
  } else {
    var it = xs.iterator__sc_Iterator();
    while (it.hasNext__Z()) {
      $thiz.addOne__O__scm_Growable(it.next__O())
    }
  };
  return $thiz
}
function $is_scm_Growable(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.scm_Growable)))
}
function $as_scm_Growable(obj) {
  return (($is_scm_Growable(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.Growable"))
}
function $isArrayOf_scm_Growable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_Growable)))
}
function $asArrayOf_scm_Growable(obj, depth) {
  return (($isArrayOf_scm_Growable(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.Growable;", depth))
}
/** @constructor */
function $c_scm_StringBuilder$() {
  /*<skip>*/
}
$c_scm_StringBuilder$.prototype = new $h_O();
$c_scm_StringBuilder$.prototype.constructor = $c_scm_StringBuilder$;
/** @constructor */
function $h_scm_StringBuilder$() {
  /*<skip>*/
}
$h_scm_StringBuilder$.prototype = $c_scm_StringBuilder$.prototype;
var $d_scm_StringBuilder$ = new $TypeData().initClass({
  scm_StringBuilder$: 0
}, false, "scala.collection.mutable.StringBuilder$", {
  scm_StringBuilder$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_scm_StringBuilder$.prototype.$classData = $d_scm_StringBuilder$;
var $n_scm_StringBuilder$;
function $m_scm_StringBuilder$() {
  if ((!$n_scm_StringBuilder$)) {
    $n_scm_StringBuilder$ = new $c_scm_StringBuilder$()
  };
  return $n_scm_StringBuilder$
}
function $f_s_concurrent_BatchingExecutor__submitSyncBatched__jl_Runnable__V($thiz, runnable) {
  if ((runnable === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "runnable is null")
  };
  var tl = $thiz.s_concurrent_ExecutionContext$parasitic$__f_scala$concurrent$BatchingExecutor$$_tasksLocal;
  var b = tl.get__O();
  if ((b instanceof $c_s_concurrent_BatchingExecutor$SyncBatch)) {
    $as_s_concurrent_BatchingExecutor$SyncBatch(b).push__jl_Runnable__V(runnable)
  } else {
    if ((b !== null)) {
      var this$2 = $as_jl_Integer(b);
      var i = $uI(this$2)
    } else {
      var i = 0
    };
    if ((i < 16)) {
      var i$1 = ((1 + i) | 0);
      tl.set__O__V(i$1);
      try {
        runnable.run__V()
      } catch (e) {
        var e$2 = $m_sjsr_package$().wrapJavaScriptException__O__jl_Throwable(e);
        if (false) {
          var x2 = $as_jl_InterruptedException(e$2);
          $m_s_concurrent_ExecutionContext$().s_concurrent_ExecutionContext$__f_defaultReporter.apply__O__O(x2)
        } else if ((e$2 !== null)) {
          if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
            $m_s_concurrent_ExecutionContext$().s_concurrent_ExecutionContext$__f_defaultReporter.apply__O__O(e$2)
          } else {
            throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(e$2)
          }
        } else {
          throw e
        }
      } finally {
        tl.set__O__V(b)
      }
    } else {
      var batch = new $c_s_concurrent_BatchingExecutor$SyncBatch($thiz, runnable);
      tl.set__O__V(batch);
      batch.run__V();
      tl.set__O__V(b)
    }
  }
}
function $is_s_concurrent_BatchingExecutor(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.s_concurrent_BatchingExecutor)))
}
function $as_s_concurrent_BatchingExecutor(obj) {
  return (($is_s_concurrent_BatchingExecutor(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.concurrent.BatchingExecutor"))
}
function $isArrayOf_s_concurrent_BatchingExecutor(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_concurrent_BatchingExecutor)))
}
function $asArrayOf_s_concurrent_BatchingExecutor(obj, depth) {
  return (($isArrayOf_s_concurrent_BatchingExecutor(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.concurrent.BatchingExecutor;", depth))
}
function $f_s_concurrent_Future__zipWith__s_concurrent_Future__F2__s_concurrent_ExecutionContext__s_concurrent_Future($thiz, that, f, executor) {
  return $thiz.flatMap__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1((function(this$1, that$1, f$1, executor$1) {
    return (function(r1$2) {
      return that$1.map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1((function(this$2, f$5, r1) {
        return (function(r2$2) {
          return f$5.apply__O__O__O(r1, r2$2)
        })
      })(this$1, f$1, r1$2)), executor$1)
    })
  })($thiz, that, f, executor)), ($is_s_concurrent_BatchingExecutor(executor) ? executor : $m_s_concurrent_ExecutionContext$parasitic$()))
}
function $f_s_concurrent_Future__andThen__s_PartialFunction__s_concurrent_ExecutionContext__s_concurrent_Future($thiz, pf, executor) {
  return $thiz.transform__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1((function(this$1, pf$1, executor$1) {
    return (function(result$2) {
      var result = $as_s_util_Try(result$2);
      try {
        pf$1.applyOrElse__O__F1__O(result, $m_s_concurrent_Future$().s_concurrent_Future$__f__cachedId)
      } catch (e) {
        var e$2 = $m_sjsr_package$().wrapJavaScriptException__O__jl_Throwable(e);
        if ((e$2 !== null)) {
          if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
            executor$1.reportFailure__jl_Throwable__V(e$2)
          } else {
            throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(e$2)
          }
        } else {
          throw e
        }
      };
      return result
    })
  })($thiz, pf, executor)), executor)
}
function $is_s_concurrent_Future(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.s_concurrent_Future)))
}
function $as_s_concurrent_Future(obj) {
  return (($is_s_concurrent_Future(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.concurrent.Future"))
}
function $isArrayOf_s_concurrent_Future(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_concurrent_Future)))
}
function $asArrayOf_s_concurrent_Future(obj, depth) {
  return (($isArrayOf_s_concurrent_Future(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.concurrent.Future;", depth))
}
function $p_s_concurrent_duration_Duration$__words__T__sci_List($thiz, s) {
  var $$x1 = $m_s_Predef$();
  var this$1 = $f_T__trim__T(s);
  var this$2 = $$x1.wrapRefArray__AO__scm_ArraySeq$ofRef($f_T__split__T__I__AT(this$1, "\\s+", 0));
  $m_sci_List$();
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$2)
}
function $p_s_concurrent_duration_Duration$__expandLabels__T__sci_List($thiz, labels) {
  var x1 = $p_s_concurrent_duration_Duration$__words__T__sci_List($thiz, labels);
  if ((!(x1 instanceof $c_sci_$colon$colon))) {
    throw new $c_s_MatchError(x1)
  };
  var x2 = $as_sci_$colon$colon(x1);
  var hd = $as_T(x2.sci_$colon$colon__f_head);
  var rest = x2.sci_$colon$colon__f_next;
  var rest$1 = rest;
  var h = null;
  var t = null;
  while ((rest$1 !== $m_sci_Nil$())) {
    var arg1 = rest$1.head__O();
    var s = $as_T(arg1);
    $m_s_package$();
    var array = [s, (s + "s")];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    var it = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems).iterator__sc_Iterator();
    while (it.hasNext__Z()) {
      var nx = new $c_sci_$colon$colon(it.next__O(), $m_sci_Nil$());
      if ((t === null)) {
        h = nx
      } else {
        t.sci_$colon$colon__f_next = nx
      };
      t = nx
    };
    rest$1 = $as_sci_List(rest$1.tail__O())
  };
  var this$5 = ((h === null) ? $m_sci_Nil$() : h);
  return new $c_sci_$colon$colon(hd, this$5)
}
/** @constructor */
function $c_s_concurrent_duration_Duration$() {
  this.s_concurrent_duration_Duration$__f_timeUnitLabels = null;
  this.s_concurrent_duration_Duration$__f_timeUnitName = null;
  this.s_concurrent_duration_Duration$__f_timeUnit = null;
  this.s_concurrent_duration_Duration$__f_Zero = null;
  this.s_concurrent_duration_Duration$__f_Undefined = null;
  this.s_concurrent_duration_Duration$__f_Inf = null;
  this.s_concurrent_duration_Duration$__f_MinusInf = null;
  $n_s_concurrent_duration_Duration$ = this;
  $m_s_package$();
  var self = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_DAYS;
  var $$x6 = new $c_T2(self, "d day");
  var self$1 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_HOURS;
  var $$x5 = new $c_T2(self$1, "h hr hour");
  var self$2 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MINUTES;
  var $$x4 = new $c_T2(self$2, "m min minute");
  var self$3 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_SECONDS;
  var $$x3 = new $c_T2(self$3, "s sec second");
  var self$4 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MILLISECONDS;
  var $$x2 = new $c_T2(self$4, "ms milli millisecond");
  var self$5 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MICROSECONDS;
  var $$x1 = new $c_T2(self$5, "\u00b5s micro microsecond");
  var self$6 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_NANOSECONDS;
  var array = [$$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_T2(self$6, "ns nano nanosecond")];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.s_concurrent_duration_Duration$__f_timeUnitLabels = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
  var this$20 = this.s_concurrent_duration_Duration$__f_timeUnitLabels;
  $m_s_$less$colon$less$();
  var this$21 = $m_sci_Map$().from__sc_IterableOnce__sci_Map(this$20);
  var this$23 = new $c_sc_MapView$Id(this$21);
  var f = new $c_sjsr_AnonFunction1((function(this$22) {
    return (function(s$2) {
      var s = $as_T(s$2);
      return $as_T($p_s_concurrent_duration_Duration$__words__T__sci_List($m_s_concurrent_duration_Duration$(), s).last__O())
    })
  })(this));
  var this$25 = new $c_sc_MapView$MapValues(this$23, f);
  $m_s_$less$colon$less$();
  this.s_concurrent_duration_Duration$__f_timeUnitName = $m_sci_Map$().from__sc_IterableOnce__sci_Map(this$25);
  var this$26 = this.s_concurrent_duration_Duration$__f_timeUnitLabels;
  var rest = this$26;
  var h = null;
  var t = null;
  while ((rest !== $m_sci_Nil$())) {
    var arg1 = rest.head__O();
    var x0$1 = $as_T2(arg1);
    if ((x0$1 === null)) {
      throw new $c_s_MatchError(x0$1)
    };
    var unit = $as_ju_concurrent_TimeUnit(x0$1._1__O());
    var names = $as_T(x0$1._2__O());
    var this$30 = $p_s_concurrent_duration_Duration$__expandLabels__T__sci_List($m_s_concurrent_duration_Duration$(), names);
    var f$1 = (function(this$27, unit$1) {
      return (function(x$5$2) {
        var x$5 = $as_T(x$5$2);
        return new $c_T2(x$5, unit$1)
      })
    })(this, unit);
    if ((this$30 === $m_sci_Nil$())) {
      var $$x7 = $m_sci_Nil$()
    } else {
      var arg1$1 = this$30.head__O();
      var h$1 = new $c_sci_$colon$colon(f$1(arg1$1), $m_sci_Nil$());
      var t$1 = h$1;
      var rest$1 = $as_sci_List(this$30.tail__O());
      while ((rest$1 !== $m_sci_Nil$())) {
        var arg1$2 = rest$1.head__O();
        var nx = new $c_sci_$colon$colon(f$1(arg1$2), $m_sci_Nil$());
        t$1.sci_$colon$colon__f_next = nx;
        t$1 = nx;
        rest$1 = $as_sci_List(rest$1.tail__O())
      };
      var $$x7 = h$1
    };
    var it = $$x7.iterator__sc_Iterator();
    while (it.hasNext__Z()) {
      var nx$1 = new $c_sci_$colon$colon(it.next__O(), $m_sci_Nil$());
      if ((t === null)) {
        h = nx$1
      } else {
        t.sci_$colon$colon__f_next = nx$1
      };
      t = nx$1
    };
    rest = $as_sci_List(rest.tail__O())
  };
  var this$32 = ((h === null) ? $m_sci_Nil$() : h);
  $m_s_$less$colon$less$();
  this.s_concurrent_duration_Duration$__f_timeUnit = $m_sci_Map$().from__sc_IterableOnce__sci_Map(this$32);
  this.s_concurrent_duration_Duration$__f_Zero = new $c_s_concurrent_duration_FiniteDuration($L0, $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_DAYS);
  this.s_concurrent_duration_Duration$__f_Undefined = new $c_s_concurrent_duration_Duration$$anon$1();
  this.s_concurrent_duration_Duration$__f_Inf = new $c_s_concurrent_duration_Duration$$anon$2();
  this.s_concurrent_duration_Duration$__f_MinusInf = new $c_s_concurrent_duration_Duration$$anon$3()
}
$c_s_concurrent_duration_Duration$.prototype = new $h_O();
$c_s_concurrent_duration_Duration$.prototype.constructor = $c_s_concurrent_duration_Duration$;
/** @constructor */
function $h_s_concurrent_duration_Duration$() {
  /*<skip>*/
}
$h_s_concurrent_duration_Duration$.prototype = $c_s_concurrent_duration_Duration$.prototype;
var $d_s_concurrent_duration_Duration$ = new $TypeData().initClass({
  s_concurrent_duration_Duration$: 0
}, false, "scala.concurrent.duration.Duration$", {
  s_concurrent_duration_Duration$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_s_concurrent_duration_Duration$.prototype.$classData = $d_s_concurrent_duration_Duration$;
var $n_s_concurrent_duration_Duration$;
function $m_s_concurrent_duration_Duration$() {
  if ((!$n_s_concurrent_duration_Duration$)) {
    $n_s_concurrent_duration_Duration$ = new $c_s_concurrent_duration_Duration$()
  };
  return $n_s_concurrent_duration_Duration$
}
/** @constructor */
function $c_s_concurrent_duration_package$DurationInt(n) {
  this.s_concurrent_duration_package$DurationInt__f_scala$concurrent$duration$DurationInt$$n = 0;
  this.s_concurrent_duration_package$DurationInt__f_scala$concurrent$duration$DurationInt$$n = n
}
$c_s_concurrent_duration_package$DurationInt.prototype = new $h_O();
$c_s_concurrent_duration_package$DurationInt.prototype.constructor = $c_s_concurrent_duration_package$DurationInt;
/** @constructor */
function $h_s_concurrent_duration_package$DurationInt() {
  /*<skip>*/
}
$h_s_concurrent_duration_package$DurationInt.prototype = $c_s_concurrent_duration_package$DurationInt.prototype;
$c_s_concurrent_duration_package$DurationInt.prototype.hashCode__I = (function() {
  var this$ = this.s_concurrent_duration_package$DurationInt__f_scala$concurrent$duration$DurationInt$$n;
  return this$
});
$c_s_concurrent_duration_package$DurationInt.prototype.equals__O__Z = (function(x$1) {
  return $m_s_concurrent_duration_package$DurationInt$().equals$extension__I__O__Z(this.s_concurrent_duration_package$DurationInt__f_scala$concurrent$duration$DurationInt$$n, x$1)
});
function $as_s_concurrent_duration_package$DurationInt(obj) {
  return (((obj instanceof $c_s_concurrent_duration_package$DurationInt) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.concurrent.duration.package$DurationInt"))
}
function $isArrayOf_s_concurrent_duration_package$DurationInt(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_concurrent_duration_package$DurationInt)))
}
function $asArrayOf_s_concurrent_duration_package$DurationInt(obj, depth) {
  return (($isArrayOf_s_concurrent_duration_package$DurationInt(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.concurrent.duration.package$DurationInt;", depth))
}
var $d_s_concurrent_duration_package$DurationInt = new $TypeData().initClass({
  s_concurrent_duration_package$DurationInt: 0
}, false, "scala.concurrent.duration.package$DurationInt", {
  s_concurrent_duration_package$DurationInt: 1,
  O: 1,
  s_concurrent_duration_DurationConversions: 1
});
$c_s_concurrent_duration_package$DurationInt.prototype.$classData = $d_s_concurrent_duration_package$DurationInt;
/** @constructor */
function $c_s_concurrent_impl_Promise$ManyCallbacks(first, rest) {
  this.s_concurrent_impl_Promise$ManyCallbacks__f_first = null;
  this.s_concurrent_impl_Promise$ManyCallbacks__f_rest = null;
  this.s_concurrent_impl_Promise$ManyCallbacks__f_first = first;
  this.s_concurrent_impl_Promise$ManyCallbacks__f_rest = rest
}
$c_s_concurrent_impl_Promise$ManyCallbacks.prototype = new $h_O();
$c_s_concurrent_impl_Promise$ManyCallbacks.prototype.constructor = $c_s_concurrent_impl_Promise$ManyCallbacks;
/** @constructor */
function $h_s_concurrent_impl_Promise$ManyCallbacks() {
  /*<skip>*/
}
$h_s_concurrent_impl_Promise$ManyCallbacks.prototype = $c_s_concurrent_impl_Promise$ManyCallbacks.prototype;
$c_s_concurrent_impl_Promise$ManyCallbacks.prototype.toString__T = (function() {
  return "ManyCallbacks"
});
function $as_s_concurrent_impl_Promise$ManyCallbacks(obj) {
  return (((obj instanceof $c_s_concurrent_impl_Promise$ManyCallbacks) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.concurrent.impl.Promise$ManyCallbacks"))
}
function $isArrayOf_s_concurrent_impl_Promise$ManyCallbacks(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_concurrent_impl_Promise$ManyCallbacks)))
}
function $asArrayOf_s_concurrent_impl_Promise$ManyCallbacks(obj, depth) {
  return (($isArrayOf_s_concurrent_impl_Promise$ManyCallbacks(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.concurrent.impl.Promise$ManyCallbacks;", depth))
}
var $d_s_concurrent_impl_Promise$ManyCallbacks = new $TypeData().initClass({
  s_concurrent_impl_Promise$ManyCallbacks: 0
}, false, "scala.concurrent.impl.Promise$ManyCallbacks", {
  s_concurrent_impl_Promise$ManyCallbacks: 1,
  O: 1,
  s_concurrent_impl_Promise$Callbacks: 1
});
$c_s_concurrent_impl_Promise$ManyCallbacks.prototype.$classData = $d_s_concurrent_impl_Promise$ManyCallbacks;
function $p_s_math_BigDecimal$__cache$lzycompute__As_math_BigDecimal($thiz) {
  if ((!$thiz.s_math_BigDecimal$__f_bitmap$0)) {
    $thiz.s_math_BigDecimal$__f_cache = new ($d_s_math_BigDecimal.getArrayOf().constr)(((1 + (($thiz.s_math_BigDecimal$__f_maxCached - $thiz.s_math_BigDecimal$__f_minCached) | 0)) | 0));
    $thiz.s_math_BigDecimal$__f_bitmap$0 = true
  };
  return $thiz.s_math_BigDecimal$__f_cache
}
function $p_s_math_BigDecimal$__cache__As_math_BigDecimal($thiz) {
  return ((!$thiz.s_math_BigDecimal$__f_bitmap$0) ? $p_s_math_BigDecimal$__cache$lzycompute__As_math_BigDecimal($thiz) : $thiz.s_math_BigDecimal$__f_cache)
}
/** @constructor */
function $c_s_math_BigDecimal$() {
  this.s_math_BigDecimal$__f_cache = null;
  this.s_math_BigDecimal$__f_minCached = 0;
  this.s_math_BigDecimal$__f_maxCached = 0;
  this.s_math_BigDecimal$__f_defaultMathContext = null;
  this.s_math_BigDecimal$__f_bitmap$0 = false;
  $n_s_math_BigDecimal$ = this;
  this.s_math_BigDecimal$__f_minCached = (-512);
  this.s_math_BigDecimal$__f_maxCached = 512;
  this.s_math_BigDecimal$__f_defaultMathContext = $m_Ljava_math_MathContext$().Ljava_math_MathContext$__f_DECIMAL128
}
$c_s_math_BigDecimal$.prototype = new $h_O();
$c_s_math_BigDecimal$.prototype.constructor = $c_s_math_BigDecimal$;
/** @constructor */
function $h_s_math_BigDecimal$() {
  /*<skip>*/
}
$h_s_math_BigDecimal$.prototype = $c_s_math_BigDecimal$.prototype;
$c_s_math_BigDecimal$.prototype.decimal__D__Ljava_math_MathContext__s_math_BigDecimal = (function(d, mc) {
  return new $c_s_math_BigDecimal($ct_Ljava_math_BigDecimal__T__Ljava_math_MathContext__(new $c_Ljava_math_BigDecimal(), ("" + d), mc), mc)
});
$c_s_math_BigDecimal$.prototype.apply__I__Ljava_math_MathContext__s_math_BigDecimal = (function(i, mc) {
  var x$2 = this.s_math_BigDecimal$__f_defaultMathContext;
  if (((((mc === null) ? (x$2 === null) : mc.equals__O__Z(x$2)) && (this.s_math_BigDecimal$__f_minCached <= i)) && (i <= this.s_math_BigDecimal$__f_maxCached))) {
    var offset = ((i - this.s_math_BigDecimal$__f_minCached) | 0);
    var n = $p_s_math_BigDecimal$__cache__As_math_BigDecimal(this).get(offset);
    if ((n === null)) {
      var hi = (i >> 31);
      n = new $c_s_math_BigDecimal($m_Ljava_math_BigDecimal$().valueOf__J__Ljava_math_BigDecimal(new $c_RTLong(i, hi)), mc);
      $p_s_math_BigDecimal$__cache__As_math_BigDecimal(this).set(offset, n)
    };
    return n
  } else {
    var hi$1 = (i >> 31);
    return this.apply__J__Ljava_math_MathContext__s_math_BigDecimal(new $c_RTLong(i, hi$1), mc)
  }
});
$c_s_math_BigDecimal$.prototype.apply__J__Ljava_math_MathContext__s_math_BigDecimal = (function(l, mc) {
  return new $c_s_math_BigDecimal($ct_Ljava_math_BigDecimal__J__Ljava_math_MathContext__(new $c_Ljava_math_BigDecimal(), l, mc), mc)
});
$c_s_math_BigDecimal$.prototype.javaBigDecimal2bigDecimal__Ljava_math_BigDecimal__s_math_BigDecimal = (function(x) {
  return ((x === null) ? null : new $c_s_math_BigDecimal(x, this.s_math_BigDecimal$__f_defaultMathContext))
});
var $d_s_math_BigDecimal$ = new $TypeData().initClass({
  s_math_BigDecimal$: 0
}, false, "scala.math.BigDecimal$", {
  s_math_BigDecimal$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_s_math_BigDecimal$.prototype.$classData = $d_s_math_BigDecimal$;
var $n_s_math_BigDecimal$;
function $m_s_math_BigDecimal$() {
  if ((!$n_s_math_BigDecimal$)) {
    $n_s_math_BigDecimal$ = new $c_s_math_BigDecimal$()
  };
  return $n_s_math_BigDecimal$
}
/** @constructor */
function $c_s_math_BigInt$() {
  this.s_math_BigInt$__f_minCached = 0;
  this.s_math_BigInt$__f_maxCached = 0;
  this.s_math_BigInt$__f_cache = null;
  this.s_math_BigInt$__f_scala$math$BigInt$$minusOne = null;
  $n_s_math_BigInt$ = this;
  this.s_math_BigInt$__f_minCached = (-1024);
  this.s_math_BigInt$__f_maxCached = 1024;
  this.s_math_BigInt$__f_cache = new ($d_s_math_BigInt.getArrayOf().constr)(((1 + ((this.s_math_BigInt$__f_maxCached - this.s_math_BigInt$__f_minCached) | 0)) | 0));
  this.s_math_BigInt$__f_scala$math$BigInt$$minusOne = $m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(new $c_RTLong((-1), (-1)))
}
$c_s_math_BigInt$.prototype = new $h_O();
$c_s_math_BigInt$.prototype.constructor = $c_s_math_BigInt$;
/** @constructor */
function $h_s_math_BigInt$() {
  /*<skip>*/
}
$h_s_math_BigInt$.prototype = $c_s_math_BigInt$.prototype;
$c_s_math_BigInt$.prototype.apply__I__s_math_BigInt = (function(i) {
  if (((this.s_math_BigInt$__f_minCached <= i) && (i <= this.s_math_BigInt$__f_maxCached))) {
    var offset = ((i - this.s_math_BigInt$__f_minCached) | 0);
    var n = this.s_math_BigInt$__f_cache.get(offset);
    if ((n === null)) {
      var hi = (i >> 31);
      n = new $c_s_math_BigInt($m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(new $c_RTLong(i, hi)));
      this.s_math_BigInt$__f_cache.set(offset, n)
    };
    return n
  } else {
    var hi$1 = (i >> 31);
    return new $c_s_math_BigInt($m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(new $c_RTLong(i, hi$1)))
  }
});
$c_s_math_BigInt$.prototype.apply__J__s_math_BigInt = (function(l) {
  var value = this.s_math_BigInt$__f_minCached;
  var hi = (value >> 31);
  var bhi = l.RTLong__f_hi;
  if (((hi === bhi) ? (((-2147483648) ^ value) <= ((-2147483648) ^ l.RTLong__f_lo)) : (hi < bhi))) {
    var value$1 = this.s_math_BigInt$__f_maxCached;
    var hi$1 = (value$1 >> 31);
    var ahi = l.RTLong__f_hi;
    var $$x1 = ((ahi === hi$1) ? (((-2147483648) ^ l.RTLong__f_lo) <= ((-2147483648) ^ value$1)) : (ahi < hi$1))
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    return this.apply__I__s_math_BigInt(l.RTLong__f_lo)
  } else {
    return new $c_s_math_BigInt($m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(l))
  }
});
var $d_s_math_BigInt$ = new $TypeData().initClass({
  s_math_BigInt$: 0
}, false, "scala.math.BigInt$", {
  s_math_BigInt$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_s_math_BigInt$.prototype.$classData = $d_s_math_BigInt$;
var $n_s_math_BigInt$;
function $m_s_math_BigInt$() {
  if ((!$n_s_math_BigInt$)) {
    $n_s_math_BigInt$ = new $c_s_math_BigInt$()
  };
  return $n_s_math_BigInt$
}
/** @constructor */
function $c_s_math_Fractional$() {
  /*<skip>*/
}
$c_s_math_Fractional$.prototype = new $h_O();
$c_s_math_Fractional$.prototype.constructor = $c_s_math_Fractional$;
/** @constructor */
function $h_s_math_Fractional$() {
  /*<skip>*/
}
$h_s_math_Fractional$.prototype = $c_s_math_Fractional$.prototype;
var $d_s_math_Fractional$ = new $TypeData().initClass({
  s_math_Fractional$: 0
}, false, "scala.math.Fractional$", {
  s_math_Fractional$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_s_math_Fractional$.prototype.$classData = $d_s_math_Fractional$;
var $n_s_math_Fractional$;
function $m_s_math_Fractional$() {
  if ((!$n_s_math_Fractional$)) {
    $n_s_math_Fractional$ = new $c_s_math_Fractional$()
  };
  return $n_s_math_Fractional$
}
/** @constructor */
function $c_s_math_Integral$() {
  /*<skip>*/
}
$c_s_math_Integral$.prototype = new $h_O();
$c_s_math_Integral$.prototype.constructor = $c_s_math_Integral$;
/** @constructor */
function $h_s_math_Integral$() {
  /*<skip>*/
}
$h_s_math_Integral$.prototype = $c_s_math_Integral$.prototype;
var $d_s_math_Integral$ = new $TypeData().initClass({
  s_math_Integral$: 0
}, false, "scala.math.Integral$", {
  s_math_Integral$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_s_math_Integral$.prototype.$classData = $d_s_math_Integral$;
var $n_s_math_Integral$;
function $m_s_math_Integral$() {
  if ((!$n_s_math_Integral$)) {
    $n_s_math_Integral$ = new $c_s_math_Integral$()
  };
  return $n_s_math_Integral$
}
/** @constructor */
function $c_s_math_Numeric$() {
  /*<skip>*/
}
$c_s_math_Numeric$.prototype = new $h_O();
$c_s_math_Numeric$.prototype.constructor = $c_s_math_Numeric$;
/** @constructor */
function $h_s_math_Numeric$() {
  /*<skip>*/
}
$h_s_math_Numeric$.prototype = $c_s_math_Numeric$.prototype;
var $d_s_math_Numeric$ = new $TypeData().initClass({
  s_math_Numeric$: 0
}, false, "scala.math.Numeric$", {
  s_math_Numeric$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_s_math_Numeric$.prototype.$classData = $d_s_math_Numeric$;
var $n_s_math_Numeric$;
function $m_s_math_Numeric$() {
  if ((!$n_s_math_Numeric$)) {
    $n_s_math_Numeric$ = new $c_s_math_Numeric$()
  };
  return $n_s_math_Numeric$
}
function $f_s_math_Ordered__$less$eq__O__Z($thiz, that) {
  return ($thiz.compare__O__I(that) <= 0)
}
function $f_s_math_Ordered__$greater$eq__O__Z($thiz, that) {
  return ($thiz.compare__O__I(that) >= 0)
}
/** @constructor */
function $c_s_package$$anon$1() {
  /*<skip>*/
}
$c_s_package$$anon$1.prototype = new $h_O();
$c_s_package$$anon$1.prototype.constructor = $c_s_package$$anon$1;
/** @constructor */
function $h_s_package$$anon$1() {
  /*<skip>*/
}
$h_s_package$$anon$1.prototype = $c_s_package$$anon$1.prototype;
$c_s_package$$anon$1.prototype.toString__T = (function() {
  return "object AnyRef"
});
var $d_s_package$$anon$1 = new $TypeData().initClass({
  s_package$$anon$1: 0
}, false, "scala.package$$anon$1", {
  s_package$$anon$1: 1,
  O: 1,
  s_Specializable: 1
});
$c_s_package$$anon$1.prototype.$classData = $d_s_package$$anon$1;
/** @constructor */
function $c_s_reflect_ClassTag$() {
  /*<skip>*/
}
$c_s_reflect_ClassTag$.prototype = new $h_O();
$c_s_reflect_ClassTag$.prototype.constructor = $c_s_reflect_ClassTag$;
/** @constructor */
function $h_s_reflect_ClassTag$() {
  /*<skip>*/
}
$h_s_reflect_ClassTag$.prototype = $c_s_reflect_ClassTag$.prototype;
$c_s_reflect_ClassTag$.prototype.apply__jl_Class__s_reflect_ClassTag = (function(runtimeClass1) {
  return ((runtimeClass1 === $d_B.getClassOf()) ? $m_s_reflect_ManifestFactory$ByteManifest$() : ((runtimeClass1 === $d_S.getClassOf()) ? $m_s_reflect_ManifestFactory$ShortManifest$() : ((runtimeClass1 === $d_C.getClassOf()) ? $m_s_reflect_ManifestFactory$CharManifest$() : ((runtimeClass1 === $d_I.getClassOf()) ? $m_s_reflect_ManifestFactory$IntManifest$() : ((runtimeClass1 === $d_J.getClassOf()) ? $m_s_reflect_ManifestFactory$LongManifest$() : ((runtimeClass1 === $d_F.getClassOf()) ? $m_s_reflect_ManifestFactory$FloatManifest$() : ((runtimeClass1 === $d_D.getClassOf()) ? $m_s_reflect_ManifestFactory$DoubleManifest$() : ((runtimeClass1 === $d_Z.getClassOf()) ? $m_s_reflect_ManifestFactory$BooleanManifest$() : ((runtimeClass1 === $d_V.getClassOf()) ? $m_s_reflect_ManifestFactory$UnitManifest$() : ((runtimeClass1 === $d_O.getClassOf()) ? $m_s_reflect_ManifestFactory$ObjectManifest$() : ((runtimeClass1 === $d_sr_Nothing$.getClassOf()) ? $m_s_reflect_ManifestFactory$NothingManifest$() : ((runtimeClass1 === $d_sr_Null$.getClassOf()) ? $m_s_reflect_ManifestFactory$NullManifest$() : new $c_s_reflect_ClassTag$GenericClassTag(runtimeClass1)))))))))))))
});
var $d_s_reflect_ClassTag$ = new $TypeData().initClass({
  s_reflect_ClassTag$: 0
}, false, "scala.reflect.ClassTag$", {
  s_reflect_ClassTag$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_s_reflect_ClassTag$.prototype.$classData = $d_s_reflect_ClassTag$;
var $n_s_reflect_ClassTag$;
function $m_s_reflect_ClassTag$() {
  if ((!$n_s_reflect_ClassTag$)) {
    $n_s_reflect_ClassTag$ = new $c_s_reflect_ClassTag$()
  };
  return $n_s_reflect_ClassTag$
}
/** @constructor */
function $c_s_reflect_Manifest$() {
  /*<skip>*/
}
$c_s_reflect_Manifest$.prototype = new $h_O();
$c_s_reflect_Manifest$.prototype.constructor = $c_s_reflect_Manifest$;
/** @constructor */
function $h_s_reflect_Manifest$() {
  /*<skip>*/
}
$h_s_reflect_Manifest$.prototype = $c_s_reflect_Manifest$.prototype;
var $d_s_reflect_Manifest$ = new $TypeData().initClass({
  s_reflect_Manifest$: 0
}, false, "scala.reflect.Manifest$", {
  s_reflect_Manifest$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_s_reflect_Manifest$.prototype.$classData = $d_s_reflect_Manifest$;
var $n_s_reflect_Manifest$;
function $m_s_reflect_Manifest$() {
  if ((!$n_s_reflect_Manifest$)) {
    $n_s_reflect_Manifest$ = new $c_s_reflect_Manifest$()
  };
  return $n_s_reflect_Manifest$
}
/** @constructor */
function $c_sr_AbstractFunction0() {
  /*<skip>*/
}
$c_sr_AbstractFunction0.prototype = new $h_O();
$c_sr_AbstractFunction0.prototype.constructor = $c_sr_AbstractFunction0;
/** @constructor */
function $h_sr_AbstractFunction0() {
  /*<skip>*/
}
$h_sr_AbstractFunction0.prototype = $c_sr_AbstractFunction0.prototype;
$c_sr_AbstractFunction0.prototype.toString__T = (function() {
  return "<function0>"
});
/** @constructor */
function $c_sr_AbstractFunction1() {
  /*<skip>*/
}
$c_sr_AbstractFunction1.prototype = new $h_O();
$c_sr_AbstractFunction1.prototype.constructor = $c_sr_AbstractFunction1;
/** @constructor */
function $h_sr_AbstractFunction1() {
  /*<skip>*/
}
$h_sr_AbstractFunction1.prototype = $c_sr_AbstractFunction1.prototype;
$c_sr_AbstractFunction1.prototype.toString__T = (function() {
  return "<function1>"
});
/** @constructor */
function $c_sr_AbstractFunction2() {
  /*<skip>*/
}
$c_sr_AbstractFunction2.prototype = new $h_O();
$c_sr_AbstractFunction2.prototype.constructor = $c_sr_AbstractFunction2;
/** @constructor */
function $h_sr_AbstractFunction2() {
  /*<skip>*/
}
$h_sr_AbstractFunction2.prototype = $c_sr_AbstractFunction2.prototype;
$c_sr_AbstractFunction2.prototype.toString__T = (function() {
  return "<function2>"
});
/** @constructor */
function $c_sr_AbstractFunction3() {
  /*<skip>*/
}
$c_sr_AbstractFunction3.prototype = new $h_O();
$c_sr_AbstractFunction3.prototype.constructor = $c_sr_AbstractFunction3;
/** @constructor */
function $h_sr_AbstractFunction3() {
  /*<skip>*/
}
$h_sr_AbstractFunction3.prototype = $c_sr_AbstractFunction3.prototype;
$c_sr_AbstractFunction3.prototype.toString__T = (function() {
  return "<function3>"
});
/** @constructor */
function $c_sr_IntRef(elem) {
  this.sr_IntRef__f_elem = 0;
  this.sr_IntRef__f_elem = elem
}
$c_sr_IntRef.prototype = new $h_O();
$c_sr_IntRef.prototype.constructor = $c_sr_IntRef;
/** @constructor */
function $h_sr_IntRef() {
  /*<skip>*/
}
$h_sr_IntRef.prototype = $c_sr_IntRef.prototype;
$c_sr_IntRef.prototype.toString__T = (function() {
  var i = this.sr_IntRef__f_elem;
  return ("" + i)
});
var $d_sr_IntRef = new $TypeData().initClass({
  sr_IntRef: 0
}, false, "scala.runtime.IntRef", {
  sr_IntRef: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_sr_IntRef.prototype.$classData = $d_sr_IntRef;
/** @constructor */
function $c_sr_ObjectRef(elem) {
  this.sr_ObjectRef__f_elem = null;
  this.sr_ObjectRef__f_elem = elem
}
$c_sr_ObjectRef.prototype = new $h_O();
$c_sr_ObjectRef.prototype.constructor = $c_sr_ObjectRef;
/** @constructor */
function $h_sr_ObjectRef() {
  /*<skip>*/
}
$h_sr_ObjectRef.prototype = $c_sr_ObjectRef.prototype;
$c_sr_ObjectRef.prototype.toString__T = (function() {
  var obj = this.sr_ObjectRef__f_elem;
  return ("" + obj)
});
var $d_sr_ObjectRef = new $TypeData().initClass({
  sr_ObjectRef: 0
}, false, "scala.runtime.ObjectRef", {
  sr_ObjectRef: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_sr_ObjectRef.prototype.$classData = $d_sr_ObjectRef;
/** @constructor */
function $c_sjs_js_$bar$EvidenceLowPrioImplicits() {
  /*<skip>*/
}
$c_sjs_js_$bar$EvidenceLowPrioImplicits.prototype = new $h_sjs_js_$bar$EvidenceLowestPrioImplicits();
$c_sjs_js_$bar$EvidenceLowPrioImplicits.prototype.constructor = $c_sjs_js_$bar$EvidenceLowPrioImplicits;
/** @constructor */
function $h_sjs_js_$bar$EvidenceLowPrioImplicits() {
  /*<skip>*/
}
$h_sjs_js_$bar$EvidenceLowPrioImplicits.prototype = $c_sjs_js_$bar$EvidenceLowPrioImplicits.prototype;
$c_sjs_js_$bar$EvidenceLowPrioImplicits.prototype.left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence = (function(ev) {
  return $m_sjs_js_$bar$ReusableEvidence$()
});
/** @constructor */
function $c_sjs_js_$bar$ReusableEvidence$() {
  /*<skip>*/
}
$c_sjs_js_$bar$ReusableEvidence$.prototype = new $h_O();
$c_sjs_js_$bar$ReusableEvidence$.prototype.constructor = $c_sjs_js_$bar$ReusableEvidence$;
/** @constructor */
function $h_sjs_js_$bar$ReusableEvidence$() {
  /*<skip>*/
}
$h_sjs_js_$bar$ReusableEvidence$.prototype = $c_sjs_js_$bar$ReusableEvidence$.prototype;
var $d_sjs_js_$bar$ReusableEvidence$ = new $TypeData().initClass({
  sjs_js_$bar$ReusableEvidence$: 0
}, false, "scala.scalajs.js.$bar$ReusableEvidence$", {
  sjs_js_$bar$ReusableEvidence$: 1,
  O: 1,
  sjs_js_$bar$Evidence: 1
});
$c_sjs_js_$bar$ReusableEvidence$.prototype.$classData = $d_sjs_js_$bar$ReusableEvidence$;
var $n_sjs_js_$bar$ReusableEvidence$;
function $m_sjs_js_$bar$ReusableEvidence$() {
  if ((!$n_sjs_js_$bar$ReusableEvidence$)) {
    $n_sjs_js_$bar$ReusableEvidence$ = new $c_sjs_js_$bar$ReusableEvidence$()
  };
  return $n_sjs_js_$bar$ReusableEvidence$
}
/** @constructor */
function $c_s_util_Either$() {
  /*<skip>*/
}
$c_s_util_Either$.prototype = new $h_O();
$c_s_util_Either$.prototype.constructor = $c_s_util_Either$;
/** @constructor */
function $h_s_util_Either$() {
  /*<skip>*/
}
$h_s_util_Either$.prototype = $c_s_util_Either$.prototype;
var $d_s_util_Either$ = new $TypeData().initClass({
  s_util_Either$: 0
}, false, "scala.util.Either$", {
  s_util_Either$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_s_util_Either$.prototype.$classData = $d_s_util_Either$;
var $n_s_util_Either$;
function $m_s_util_Either$() {
  if ((!$n_s_util_Either$)) {
    $n_s_util_Either$ = new $c_s_util_Either$()
  };
  return $n_s_util_Either$
}
/** @constructor */
function $c_s_util_Left$() {
  /*<skip>*/
}
$c_s_util_Left$.prototype = new $h_O();
$c_s_util_Left$.prototype.constructor = $c_s_util_Left$;
/** @constructor */
function $h_s_util_Left$() {
  /*<skip>*/
}
$h_s_util_Left$.prototype = $c_s_util_Left$.prototype;
$c_s_util_Left$.prototype.toString__T = (function() {
  return "Left"
});
var $d_s_util_Left$ = new $TypeData().initClass({
  s_util_Left$: 0
}, false, "scala.util.Left$", {
  s_util_Left$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_s_util_Left$.prototype.$classData = $d_s_util_Left$;
var $n_s_util_Left$;
function $m_s_util_Left$() {
  if ((!$n_s_util_Left$)) {
    $n_s_util_Left$ = new $c_s_util_Left$()
  };
  return $n_s_util_Left$
}
/** @constructor */
function $c_s_util_Right$() {
  /*<skip>*/
}
$c_s_util_Right$.prototype = new $h_O();
$c_s_util_Right$.prototype.constructor = $c_s_util_Right$;
/** @constructor */
function $h_s_util_Right$() {
  /*<skip>*/
}
$h_s_util_Right$.prototype = $c_s_util_Right$.prototype;
$c_s_util_Right$.prototype.toString__T = (function() {
  return "Right"
});
var $d_s_util_Right$ = new $TypeData().initClass({
  s_util_Right$: 0
}, false, "scala.util.Right$", {
  s_util_Right$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_s_util_Right$.prototype.$classData = $d_s_util_Right$;
var $n_s_util_Right$;
function $m_s_util_Right$() {
  if ((!$n_s_util_Right$)) {
    $n_s_util_Right$ = new $c_s_util_Right$()
  };
  return $n_s_util_Right$
}
/** @constructor */
function $c_s_util_control_Exception$Catch(pf, fin, rethrow) {
  this.s_util_control_Exception$Catch__f_pf = null;
  this.s_util_control_Exception$Catch__f_fin = null;
  this.s_util_control_Exception$Catch__f_rethrow = null;
  this.s_util_control_Exception$Catch__f_name = null;
  this.s_util_control_Exception$Catch__f_scala$util$control$Exception$Described$$_desc = null;
  this.s_util_control_Exception$Catch__f_pf = pf;
  this.s_util_control_Exception$Catch__f_fin = fin;
  this.s_util_control_Exception$Catch__f_rethrow = rethrow;
  this.s_util_control_Exception$Catch__f_scala$util$control$Exception$Described$$_desc = "";
  this.s_util_control_Exception$Catch__f_name = "Catch"
}
$c_s_util_control_Exception$Catch.prototype = new $h_O();
$c_s_util_control_Exception$Catch.prototype.constructor = $c_s_util_control_Exception$Catch;
/** @constructor */
function $h_s_util_control_Exception$Catch() {
  /*<skip>*/
}
$h_s_util_control_Exception$Catch.prototype = $c_s_util_control_Exception$Catch.prototype;
$c_s_util_control_Exception$Catch.prototype.toString__T = (function() {
  return $f_s_util_control_Exception$Described__toString__T(this)
});
$c_s_util_control_Exception$Catch.prototype.withApply__F1__s_util_control_Exception$Catch = (function(f) {
  var pf2 = new $c_s_util_control_Exception$Catch$$anon$2(this, f);
  return new $c_s_util_control_Exception$Catch(pf2, this.s_util_control_Exception$Catch__f_fin, this.s_util_control_Exception$Catch__f_rethrow)
});
$c_s_util_control_Exception$Catch.prototype.toOption__s_util_control_Exception$Catch = (function() {
  return this.withApply__F1__s_util_control_Exception$Catch(new $c_sjsr_AnonFunction1((function(this$1) {
    return (function(x$3$2) {
      $as_jl_Throwable(x$3$2);
      return $m_s_None$()
    })
  })(this)))
});
function $as_s_util_control_Exception$Catch(obj) {
  return (((obj instanceof $c_s_util_control_Exception$Catch) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.util.control.Exception$Catch"))
}
function $isArrayOf_s_util_control_Exception$Catch(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_util_control_Exception$Catch)))
}
function $asArrayOf_s_util_control_Exception$Catch(obj, depth) {
  return (($isArrayOf_s_util_control_Exception$Catch(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.util.control.Exception$Catch;", depth))
}
var $d_s_util_control_Exception$Catch = new $TypeData().initClass({
  s_util_control_Exception$Catch: 0
}, false, "scala.util.control.Exception$Catch", {
  s_util_control_Exception$Catch: 1,
  O: 1,
  s_util_control_Exception$Described: 1
});
$c_s_util_control_Exception$Catch.prototype.$classData = $d_s_util_control_Exception$Catch;
function $as_s_util_control_Exception$Finally(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "scala.util.control.Exception$Finally"))
}
function $isArrayOf_s_util_control_Exception$Finally(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_util_control_Exception$Finally)))
}
function $asArrayOf_s_util_control_Exception$Finally(obj, depth) {
  return (($isArrayOf_s_util_control_Exception$Finally(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.util.control.Exception$Finally;", depth))
}
/** @constructor */
function $c_s_util_control_NoStackTrace$() {
  this.s_util_control_NoStackTrace$__f__noSuppression = false;
  this.s_util_control_NoStackTrace$__f__noSuppression = false
}
$c_s_util_control_NoStackTrace$.prototype = new $h_O();
$c_s_util_control_NoStackTrace$.prototype.constructor = $c_s_util_control_NoStackTrace$;
/** @constructor */
function $h_s_util_control_NoStackTrace$() {
  /*<skip>*/
}
$h_s_util_control_NoStackTrace$.prototype = $c_s_util_control_NoStackTrace$.prototype;
var $d_s_util_control_NoStackTrace$ = new $TypeData().initClass({
  s_util_control_NoStackTrace$: 0
}, false, "scala.util.control.NoStackTrace$", {
  s_util_control_NoStackTrace$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_s_util_control_NoStackTrace$.prototype.$classData = $d_s_util_control_NoStackTrace$;
var $n_s_util_control_NoStackTrace$;
function $m_s_util_control_NoStackTrace$() {
  if ((!$n_s_util_control_NoStackTrace$)) {
    $n_s_util_control_NoStackTrace$ = new $c_s_util_control_NoStackTrace$()
  };
  return $n_s_util_control_NoStackTrace$
}
/** @constructor */
function $c_s_util_hashing_MurmurHash3$() {
  this.s_util_hashing_MurmurHash3$__f_seqSeed = 0;
  this.s_util_hashing_MurmurHash3$__f_mapSeed = 0;
  this.s_util_hashing_MurmurHash3$__f_setSeed = 0;
  this.s_util_hashing_MurmurHash3$__f_emptyMapHash = 0;
  $n_s_util_hashing_MurmurHash3$ = this;
  this.s_util_hashing_MurmurHash3$__f_seqSeed = $f_T__hashCode__I("Seq");
  this.s_util_hashing_MurmurHash3$__f_mapSeed = $f_T__hashCode__I("Map");
  this.s_util_hashing_MurmurHash3$__f_setSeed = $f_T__hashCode__I("Set");
  this.s_util_hashing_MurmurHash3$__f_emptyMapHash = this.unorderedHash__sc_IterableOnce__I__I($m_s_package$().s_package$__f_Nil, this.s_util_hashing_MurmurHash3$__f_mapSeed)
}
$c_s_util_hashing_MurmurHash3$.prototype = new $h_s_util_hashing_MurmurHash3();
$c_s_util_hashing_MurmurHash3$.prototype.constructor = $c_s_util_hashing_MurmurHash3$;
/** @constructor */
function $h_s_util_hashing_MurmurHash3$() {
  /*<skip>*/
}
$h_s_util_hashing_MurmurHash3$.prototype = $c_s_util_hashing_MurmurHash3$.prototype;
$c_s_util_hashing_MurmurHash3$.prototype.tuple2Hash__O__O__I = (function(x, y) {
  return this.tuple2Hash__I__I__I__I($m_sr_Statics$().anyHash__O__I(x), $m_sr_Statics$().anyHash__O__I(y), (-889275714))
});
$c_s_util_hashing_MurmurHash3$.prototype.seqHash__sc_Seq__I = (function(xs) {
  if ($is_sc_IndexedSeq(xs)) {
    var x2 = $as_sc_IndexedSeq(xs);
    return this.indexedSeqHash__sc_IndexedSeq__I__I(x2, this.s_util_hashing_MurmurHash3$__f_seqSeed)
  } else if ((xs instanceof $c_sci_List)) {
    var x3 = $as_sci_List(xs);
    return this.listHash__sci_List__I__I(x3, this.s_util_hashing_MurmurHash3$__f_seqSeed)
  } else {
    return this.orderedHash__sc_IterableOnce__I__I(xs, this.s_util_hashing_MurmurHash3$__f_seqSeed)
  }
});
$c_s_util_hashing_MurmurHash3$.prototype.mapHash__sc_Map__I = (function(xs) {
  if (xs.isEmpty__Z()) {
    return this.s_util_hashing_MurmurHash3$__f_emptyMapHash
  } else {
    var accum = new $c_s_util_hashing_MurmurHash3$accum$1();
    var h = this.s_util_hashing_MurmurHash3$__f_mapSeed;
    xs.foreachEntry__F2__V(accum);
    h = this.mix__I__I__I(h, accum.s_util_hashing_MurmurHash3$accum$1__f_a);
    h = this.mix__I__I__I(h, accum.s_util_hashing_MurmurHash3$accum$1__f_b);
    h = this.mixLast__I__I__I(h, accum.s_util_hashing_MurmurHash3$accum$1__f_c);
    return this.finalizeHash__I__I__I(h, accum.s_util_hashing_MurmurHash3$accum$1__f_n)
  }
});
var $d_s_util_hashing_MurmurHash3$ = new $TypeData().initClass({
  s_util_hashing_MurmurHash3$: 0
}, false, "scala.util.hashing.MurmurHash3$", {
  s_util_hashing_MurmurHash3$: 1,
  s_util_hashing_MurmurHash3: 1,
  O: 1
});
$c_s_util_hashing_MurmurHash3$.prototype.$classData = $d_s_util_hashing_MurmurHash3$;
var $n_s_util_hashing_MurmurHash3$;
function $m_s_util_hashing_MurmurHash3$() {
  if ((!$n_s_util_hashing_MurmurHash3$)) {
    $n_s_util_hashing_MurmurHash3$ = new $c_s_util_hashing_MurmurHash3$()
  };
  return $n_s_util_hashing_MurmurHash3$
}
/** @constructor */
function $c_s_util_hashing_MurmurHash3$accum$1() {
  this.s_util_hashing_MurmurHash3$accum$1__f_a = 0;
  this.s_util_hashing_MurmurHash3$accum$1__f_b = 0;
  this.s_util_hashing_MurmurHash3$accum$1__f_n = 0;
  this.s_util_hashing_MurmurHash3$accum$1__f_c = 0;
  this.s_util_hashing_MurmurHash3$accum$1__f_a = 0;
  this.s_util_hashing_MurmurHash3$accum$1__f_b = 0;
  this.s_util_hashing_MurmurHash3$accum$1__f_n = 0;
  this.s_util_hashing_MurmurHash3$accum$1__f_c = 1
}
$c_s_util_hashing_MurmurHash3$accum$1.prototype = new $h_O();
$c_s_util_hashing_MurmurHash3$accum$1.prototype.constructor = $c_s_util_hashing_MurmurHash3$accum$1;
/** @constructor */
function $h_s_util_hashing_MurmurHash3$accum$1() {
  /*<skip>*/
}
$h_s_util_hashing_MurmurHash3$accum$1.prototype = $c_s_util_hashing_MurmurHash3$accum$1.prototype;
$c_s_util_hashing_MurmurHash3$accum$1.prototype.toString__T = (function() {
  return "<function2>"
});
$c_s_util_hashing_MurmurHash3$accum$1.prototype.apply__O__O__V = (function(k, v) {
  var h = $m_s_util_hashing_MurmurHash3$().tuple2Hash__O__O__I(k, v);
  this.s_util_hashing_MurmurHash3$accum$1__f_a = ((this.s_util_hashing_MurmurHash3$accum$1__f_a + h) | 0);
  this.s_util_hashing_MurmurHash3$accum$1__f_b = (this.s_util_hashing_MurmurHash3$accum$1__f_b ^ h);
  this.s_util_hashing_MurmurHash3$accum$1__f_c = $imul(this.s_util_hashing_MurmurHash3$accum$1__f_c, (1 | h));
  this.s_util_hashing_MurmurHash3$accum$1__f_n = ((1 + this.s_util_hashing_MurmurHash3$accum$1__f_n) | 0)
});
$c_s_util_hashing_MurmurHash3$accum$1.prototype.apply__O__O__O = (function(v1, v2) {
  this.apply__O__O__V(v1, v2)
});
var $d_s_util_hashing_MurmurHash3$accum$1 = new $TypeData().initClass({
  s_util_hashing_MurmurHash3$accum$1: 0
}, false, "scala.util.hashing.MurmurHash3$accum$1", {
  s_util_hashing_MurmurHash3$accum$1: 1,
  O: 1,
  F2: 1
});
$c_s_util_hashing_MurmurHash3$accum$1.prototype.$classData = $d_s_util_hashing_MurmurHash3$accum$1;
/** @constructor */
function $c_Lscommons_api_ApiStatus$() {
  this.Lscommons_api_ApiStatus$__f_Ok = null;
  this.Lscommons_api_ApiStatus$__f_jsonFormat = null;
  $n_Lscommons_api_ApiStatus$ = this;
  $m_Lscommons_api_ApiStatus$();
  var error = $m_s_None$();
  var details = $m_s_None$();
  this.Lscommons_api_ApiStatus$__f_Ok = new $c_Lscommons_api_ApiStatus(0, error, details);
  var $$x2 = $m_Lplay_api_libs_json_JsPath$();
  var this$2 = $m_Lplay_api_libs_json_JsonConfiguration$();
  var naming = $m_Lplay_api_libs_json_JsonNaming$Identity$();
  var optionHandlers = $m_Lplay_api_libs_json_OptionHandlers$Default$();
  var discriminator = this$2.Lplay_api_libs_json_JsonConfiguration$__f_defaultDiscriminator;
  var typeNaming = $m_Lplay_api_libs_json_JsonNaming$Identity$();
  new $c_Lplay_api_libs_json_JsonConfiguration$Impl(naming, optionHandlers, discriminator, typeNaming);
  var this$5 = $$x2.$bslash__T__Lplay_api_libs_json_JsPath("code");
  var this$4 = $m_Lplay_api_libs_json_Format$();
  var fjs = $m_Lplay_api_libs_json_Reads$().IntReads__Lplay_api_libs_json_DefaultReads$IntReads$();
  var tjs = $m_Lplay_api_libs_json_Writes$().IntWrites__Lplay_api_libs_json_DefaultWrites$IntWrites$();
  var f = new $c_Lplay_api_libs_json_DefaultFormat$$anon$7(this$4, fjs, tjs);
  var this$6 = $m_Lplay_api_libs_json_Format$();
  var a = $f_Lplay_api_libs_json_PathFormat__at__Lplay_api_libs_json_JsPath__Lplay_api_libs_json_Format__Lplay_api_libs_json_OFormat(this$6, this$5, f);
  $m_Lplay_api_libs_json_OFormat$();
  $m_Lplay_api_libs_json_Reads$();
  var applicativeJsResult = $m_Lplay_api_libs_json_JsResult$().Lplay_api_libs_json_JsResult$__f_applicativeJsResult;
  var app = new $c_Lplay_api_libs_json_Reads$$anon$1(applicativeJsResult);
  var rcb = new $c_Lplay_api_libs_functional_FunctionalCanBuild$$anon$1(app);
  var wcb = $m_Lplay_api_libs_json_OWrites$().Lplay_api_libs_json_OWrites$__f_functionalCanBuildOWrites;
  var fcb = new $c_Lplay_api_libs_json_OFormat$$anon$1(rcb, wcb);
  var this$16 = new $c_Lplay_api_libs_functional_FunctionalBuilderOps(a, fcb);
  var this$11 = $m_Lplay_api_libs_json_JsonConfiguration$();
  var naming$1 = $m_Lplay_api_libs_json_JsonNaming$Identity$();
  var optionHandlers$1 = $m_Lplay_api_libs_json_OptionHandlers$Default$();
  var discriminator$1 = this$11.Lplay_api_libs_json_JsonConfiguration$__f_defaultDiscriminator;
  var typeNaming$1 = $m_Lplay_api_libs_json_JsonNaming$Identity$();
  var this$15 = new $c_Lplay_api_libs_json_JsonConfiguration$Impl(naming$1, optionHandlers$1, discriminator$1, typeNaming$1).Lplay_api_libs_json_JsonConfiguration$Impl__f_optionHandlers;
  var $$x3 = $m_Lplay_api_libs_json_JsPath$();
  var this$12 = $m_Lplay_api_libs_json_JsonConfiguration$();
  var naming$2 = $m_Lplay_api_libs_json_JsonNaming$Identity$();
  var optionHandlers$2 = $m_Lplay_api_libs_json_OptionHandlers$Default$();
  var discriminator$2 = this$12.Lplay_api_libs_json_JsonConfiguration$__f_defaultDiscriminator;
  var typeNaming$2 = $m_Lplay_api_libs_json_JsonNaming$Identity$();
  new $c_Lplay_api_libs_json_JsonConfiguration$Impl(naming$2, optionHandlers$2, discriminator$2, typeNaming$2);
  var jsPath = $$x3.$bslash__T__Lplay_api_libs_json_JsPath("error");
  var this$14 = $m_Lplay_api_libs_json_Format$();
  var fjs$1 = $m_Lplay_api_libs_json_Reads$().StringReads__Lplay_api_libs_json_DefaultReads$StringReads$();
  var tjs$1 = $m_Lplay_api_libs_json_Writes$().StringWrites__Lplay_api_libs_json_DefaultWrites$StringWrites$();
  var format = new $c_Lplay_api_libs_json_DefaultFormat$$anon$7(this$14, fjs$1, tjs$1);
  var mb = $f_Lplay_api_libs_json_OptionHandlers__formatHandler__Lplay_api_libs_json_JsPath__Lplay_api_libs_json_Format__Lplay_api_libs_json_OFormat(this$15, jsPath, format);
  var this$22 = this$16.$tilde__O__Lplay_api_libs_functional_FunctionalBuilder$CanBuild2(mb);
  var this$17 = $m_Lplay_api_libs_json_JsonConfiguration$();
  var naming$3 = $m_Lplay_api_libs_json_JsonNaming$Identity$();
  var optionHandlers$3 = $m_Lplay_api_libs_json_OptionHandlers$Default$();
  var discriminator$3 = this$17.Lplay_api_libs_json_JsonConfiguration$__f_defaultDiscriminator;
  var typeNaming$3 = $m_Lplay_api_libs_json_JsonNaming$Identity$();
  var this$21 = new $c_Lplay_api_libs_json_JsonConfiguration$Impl(naming$3, optionHandlers$3, discriminator$3, typeNaming$3).Lplay_api_libs_json_JsonConfiguration$Impl__f_optionHandlers;
  var $$x4 = $m_Lplay_api_libs_json_JsPath$();
  var this$18 = $m_Lplay_api_libs_json_JsonConfiguration$();
  var naming$4 = $m_Lplay_api_libs_json_JsonNaming$Identity$();
  var optionHandlers$4 = $m_Lplay_api_libs_json_OptionHandlers$Default$();
  var discriminator$4 = this$18.Lplay_api_libs_json_JsonConfiguration$__f_defaultDiscriminator;
  var typeNaming$4 = $m_Lplay_api_libs_json_JsonNaming$Identity$();
  new $c_Lplay_api_libs_json_JsonConfiguration$Impl(naming$4, optionHandlers$4, discriminator$4, typeNaming$4);
  var jsPath$1 = $$x4.$bslash__T__Lplay_api_libs_json_JsPath("details");
  var this$20 = $m_Lplay_api_libs_json_Format$();
  var fjs$2 = $m_Lplay_api_libs_json_Reads$().StringReads__Lplay_api_libs_json_DefaultReads$StringReads$();
  var tjs$2 = $m_Lplay_api_libs_json_Writes$().StringWrites__Lplay_api_libs_json_DefaultWrites$StringWrites$();
  var format$1 = new $c_Lplay_api_libs_json_DefaultFormat$$anon$7(this$20, fjs$2, tjs$2);
  var m3 = $f_Lplay_api_libs_json_OptionHandlers__formatHandler__Lplay_api_libs_json_JsPath__Lplay_api_libs_json_Format__Lplay_api_libs_json_OFormat(this$21, jsPath$1, format$1);
  var $$x5 = this$22.$tilde__O__Lplay_api_libs_functional_FunctionalBuilder$CanBuild3(m3);
  var $$x1 = new $c_sjsr_AnonFunction3((function(this$23) {
    return (function(code$2, error$2, details$2) {
      var code = $uI(code$2);
      var error$1 = $as_s_Option(error$2);
      var details$1 = $as_s_Option(details$2);
      $m_Lscommons_api_ApiStatus$();
      return new $c_Lscommons_api_ApiStatus(code, error$1, details$1)
    })
  })(this));
  var f$1 = new $c_sjsr_AnonFunction1((function(this$2$1) {
    return (function(x$0$2) {
      var x$0 = $as_Lscommons_api_ApiStatus(x$0$2);
      return $m_Lscommons_api_ApiStatus$().unapply__Lscommons_api_ApiStatus__s_Option(x$0)
    })
  })(this));
  var underlying = $as_Lplay_api_libs_json_OFormat($$x5.apply__F3__F1__Lplay_api_libs_functional_InvariantFunctor__O($$x1, $m_s_PartialFunction$().unlifted__F1__s_PartialFunction(f$1), $m_Lplay_api_libs_json_OFormat$().Lplay_api_libs_json_OFormat$__f_invariantFunctorOFormat));
  var rfn = new $c_sjsr_AnonFunction1((function(this$3$1, underlying$1) {
    return (function(x0$1$2) {
      var x0$1 = $as_Lplay_api_libs_json_JsValue(x0$1$2);
      if ((x0$1 instanceof $c_Lplay_api_libs_json_JsObject)) {
        var x2 = $as_Lplay_api_libs_json_JsObject(x0$1);
        return underlying$1.reads__Lplay_api_libs_json_JsValue__Lplay_api_libs_json_JsResult(x2)
      } else {
        return $m_Lplay_api_libs_json_JsError$().apply__T__Lplay_api_libs_json_JsError("error.expected.jsobject")
      }
    })
  })(this, underlying));
  $m_Lplay_api_libs_json_OFormat$();
  var write = new $c_sjsr_AnonFunction1((function(this$4$1, underlying$2) {
    return (function(o$2) {
      var o = $as_Lscommons_api_ApiStatus(o$2);
      return underlying$2.writes__O__Lplay_api_libs_json_JsObject(o)
    })
  })(this, underlying));
  this.Lscommons_api_ApiStatus$__f_jsonFormat = new $c_Lplay_api_libs_json_OFormat$$anon$3(rfn, write)
}
$c_Lscommons_api_ApiStatus$.prototype = new $h_O();
$c_Lscommons_api_ApiStatus$.prototype.constructor = $c_Lscommons_api_ApiStatus$;
/** @constructor */
function $h_Lscommons_api_ApiStatus$() {
  /*<skip>*/
}
$h_Lscommons_api_ApiStatus$.prototype = $c_Lscommons_api_ApiStatus$.prototype;
$c_Lscommons_api_ApiStatus$.prototype.apply__I__T__T__Lscommons_api_ApiStatus = (function(code, error, details) {
  $m_Lscommons_api_ApiStatus$();
  var error$1 = new $c_s_Some(error);
  var details$1 = new $c_s_Some(details);
  return new $c_Lscommons_api_ApiStatus(code, error$1, details$1)
});
$c_Lscommons_api_ApiStatus$.prototype.unapply__Lscommons_api_ApiStatus__s_Option = (function(x$0) {
  return ((x$0 === null) ? $m_s_None$() : new $c_s_Some(new $c_T3(x$0.Lscommons_api_ApiStatus__f_code, x$0.Lscommons_api_ApiStatus__f_error, x$0.Lscommons_api_ApiStatus__f_details)))
});
var $d_Lscommons_api_ApiStatus$ = new $TypeData().initClass({
  Lscommons_api_ApiStatus$: 0
}, false, "scommons.api.ApiStatus$", {
  Lscommons_api_ApiStatus$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lscommons_api_ApiStatus$.prototype.$classData = $d_Lscommons_api_ApiStatus$;
var $n_Lscommons_api_ApiStatus$;
function $m_Lscommons_api_ApiStatus$() {
  if ((!$n_Lscommons_api_ApiStatus$)) {
    $n_Lscommons_api_ApiStatus$ = new $c_Lscommons_api_ApiStatus$()
  };
  return $n_Lscommons_api_ApiStatus$
}
/** @constructor */
function $c_Lscommons_expo_sqlite_SQLite$() {
  /*<skip>*/
}
$c_Lscommons_expo_sqlite_SQLite$.prototype = new $h_O();
$c_Lscommons_expo_sqlite_SQLite$.prototype.constructor = $c_Lscommons_expo_sqlite_SQLite$;
/** @constructor */
function $h_Lscommons_expo_sqlite_SQLite$() {
  /*<skip>*/
}
$h_Lscommons_expo_sqlite_SQLite$.prototype = $c_Lscommons_expo_sqlite_SQLite$.prototype;
var $d_Lscommons_expo_sqlite_SQLite$ = new $TypeData().initClass({
  Lscommons_expo_sqlite_SQLite$: 0
}, false, "scommons.expo.sqlite.SQLite$", {
  Lscommons_expo_sqlite_SQLite$: 1,
  O: 1,
  Lscommons_expo_sqlite_SQLite: 1
});
$c_Lscommons_expo_sqlite_SQLite$.prototype.$classData = $d_Lscommons_expo_sqlite_SQLite$;
var $n_Lscommons_expo_sqlite_SQLite$;
function $m_Lscommons_expo_sqlite_SQLite$() {
  if ((!$n_Lscommons_expo_sqlite_SQLite$)) {
    $n_Lscommons_expo_sqlite_SQLite$ = new $c_Lscommons_expo_sqlite_SQLite$()
  };
  return $n_Lscommons_expo_sqlite_SQLite$
}
function $f_Lscommons_react_FunctionComponent__create__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz) {
  var render0 = (function(arg$outer) {
    return (function(arg1$2) {
      return $f_Lscommons_react_FunctionComponent__scommons$react$FunctionComponent$$$anonfun$create$1__sjs_js_Dynamic__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement(arg$outer, arg1$2)
    })
  })($thiz);
  var fn = new Function("render", (("return function " + $f_Lscommons_react_UiComponent__displayName__T($thiz)) + "(props){ return render(props) };")).call(null, render0);
  var s = $f_Lscommons_react_UiComponent__displayName__T($thiz);
  fn.displayName = s;
  return fn
}
function $f_Lscommons_react_FunctionComponent__scommons$react$FunctionComponent$$$anonfun$create$1__sjs_js_Dynamic__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($thiz, props) {
  return $thiz.render__Lio_github_shogowada_scalajs_reactjs_React$Props__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement(new $c_Lio_github_shogowada_scalajs_reactjs_React$Props(props))
}
function $p_Lscommons_react_navigation_package$__native$lzycompute__Lscommons_react_navigation_raw_ReactNavigation($thiz) {
  if (((((1 & $thiz.Lscommons_react_navigation_package$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lscommons_react_navigation_package$__f_native = $i_$0040react$002dnavigation$002fnative;
    $thiz.Lscommons_react_navigation_package$__f_bitmap$0 = (((1 | $thiz.Lscommons_react_navigation_package$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lscommons_react_navigation_package$__f_native
}
function $p_Lscommons_react_navigation_package$__DefaultTheme$lzycompute__Lscommons_react_navigation_raw_Theme($thiz) {
  if (((((2 & $thiz.Lscommons_react_navigation_package$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lscommons_react_navigation_package$__f_DefaultTheme = $thiz.native__Lscommons_react_navigation_raw_ReactNavigation().DefaultTheme;
    $thiz.Lscommons_react_navigation_package$__f_bitmap$0 = (((2 | $thiz.Lscommons_react_navigation_package$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lscommons_react_navigation_package$__f_DefaultTheme
}
function $p_Lscommons_react_navigation_package$__DarkTheme$lzycompute__Lscommons_react_navigation_raw_Theme($thiz) {
  if (((((4 & $thiz.Lscommons_react_navigation_package$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lscommons_react_navigation_package$__f_DarkTheme = $thiz.native__Lscommons_react_navigation_raw_ReactNavigation().DarkTheme;
    $thiz.Lscommons_react_navigation_package$__f_bitmap$0 = (((4 | $thiz.Lscommons_react_navigation_package$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lscommons_react_navigation_package$__f_DarkTheme
}
/** @constructor */
function $c_Lscommons_react_navigation_package$() {
  this.Lscommons_react_navigation_package$__f_native = null;
  this.Lscommons_react_navigation_package$__f_DefaultTheme = null;
  this.Lscommons_react_navigation_package$__f_DarkTheme = null;
  this.Lscommons_react_navigation_package$__f_scommons$react$navigation$ReactNavigation$$themeStyles = null;
  this.Lscommons_react_navigation_package$__f_bitmap$0 = 0;
  $n_Lscommons_react_navigation_package$ = this;
  $f_Lscommons_react_navigation_ReactNavigation__$init$__V(this)
}
$c_Lscommons_react_navigation_package$.prototype = new $h_O();
$c_Lscommons_react_navigation_package$.prototype.constructor = $c_Lscommons_react_navigation_package$;
/** @constructor */
function $h_Lscommons_react_navigation_package$() {
  /*<skip>*/
}
$h_Lscommons_react_navigation_package$.prototype = $c_Lscommons_react_navigation_package$.prototype;
$c_Lscommons_react_navigation_package$.prototype.native__Lscommons_react_navigation_raw_ReactNavigation = (function() {
  return (((((1 & this.Lscommons_react_navigation_package$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lscommons_react_navigation_package$__native$lzycompute__Lscommons_react_navigation_raw_ReactNavigation(this) : this.Lscommons_react_navigation_package$__f_native)
});
$c_Lscommons_react_navigation_package$.prototype.DefaultTheme__Lscommons_react_navigation_raw_Theme = (function() {
  return (((((2 & this.Lscommons_react_navigation_package$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lscommons_react_navigation_package$__DefaultTheme$lzycompute__Lscommons_react_navigation_raw_Theme(this) : this.Lscommons_react_navigation_package$__f_DefaultTheme)
});
$c_Lscommons_react_navigation_package$.prototype.DarkTheme__Lscommons_react_navigation_raw_Theme = (function() {
  return (((((4 & this.Lscommons_react_navigation_package$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lscommons_react_navigation_package$__DarkTheme$lzycompute__Lscommons_react_navigation_raw_Theme(this) : this.Lscommons_react_navigation_package$__f_DarkTheme)
});
var $d_Lscommons_react_navigation_package$ = new $TypeData().initClass({
  Lscommons_react_navigation_package$: 0
}, false, "scommons.react.navigation.package$", {
  Lscommons_react_navigation_package$: 1,
  O: 1,
  Lscommons_react_navigation_ReactNavigation: 1
});
$c_Lscommons_react_navigation_package$.prototype.$classData = $d_Lscommons_react_navigation_package$;
var $n_Lscommons_react_navigation_package$;
function $m_Lscommons_react_navigation_package$() {
  if ((!$n_Lscommons_react_navigation_package$)) {
    $n_Lscommons_react_navigation_package$ = new $c_Lscommons_react_navigation_package$()
  };
  return $n_Lscommons_react_navigation_package$
}
function $is_Lscommons_react_redux_task_TaskAction(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lscommons_react_redux_task_TaskAction)))
}
function $as_Lscommons_react_redux_task_TaskAction(obj) {
  return (($is_Lscommons_react_redux_task_TaskAction(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scommons.react.redux.task.TaskAction"))
}
function $isArrayOf_Lscommons_react_redux_task_TaskAction(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscommons_react_redux_task_TaskAction)))
}
function $asArrayOf_Lscommons_react_redux_task_TaskAction(obj, depth) {
  return (($isArrayOf_Lscommons_react_redux_task_TaskAction(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscommons.react.redux.task.TaskAction;", depth))
}
/** @constructor */
function $c_Lscommons_reactnative_Image$() {
  /*<skip>*/
}
$c_Lscommons_reactnative_Image$.prototype = new $h_O();
$c_Lscommons_reactnative_Image$.prototype.constructor = $c_Lscommons_reactnative_Image$;
/** @constructor */
function $h_Lscommons_reactnative_Image$() {
  /*<skip>*/
}
$h_Lscommons_reactnative_Image$.prototype = $c_Lscommons_reactnative_Image$.prototype;
$c_Lscommons_reactnative_Image$.prototype.prefetch__T__s_concurrent_Future = (function(url) {
  var $$x1 = $m_sjs_js_Thenable$ThenableOps$();
  var p = $i_react$002dnative.Image.prefetch(url);
  return $$x1.toFuture$extension__sjs_js_Thenable__s_concurrent_Future(p)
});
var $d_Lscommons_reactnative_Image$ = new $TypeData().initClass({
  Lscommons_reactnative_Image$: 0
}, false, "scommons.reactnative.Image$", {
  Lscommons_reactnative_Image$: 1,
  O: 1,
  Lscommons_reactnative_Image: 1
});
$c_Lscommons_reactnative_Image$.prototype.$classData = $d_Lscommons_reactnative_Image$;
var $n_Lscommons_reactnative_Image$;
function $m_Lscommons_reactnative_Image$() {
  if ((!$n_Lscommons_reactnative_Image$)) {
    $n_Lscommons_reactnative_Image$ = new $c_Lscommons_reactnative_Image$()
  };
  return $n_Lscommons_reactnative_Image$
}
function $f_Lscommons_reactnative_app_BaseStateAndRouteController__mapStateToProps__F1__O__Lio_github_shogowada_scalajs_reactjs_React$Props__O($thiz, dispatch, state, props) {
  return $thiz.mapStateAndRouteToProps__F1__O__Lscommons_react_navigation_Navigation__O(dispatch, state, $m_Lscommons_react_navigation_Navigation$().apply__Lio_github_shogowada_scalajs_reactjs_React$Props__Lscommons_react_navigation_Navigation(props))
}
function $p_Lscommons_reactnative_safearea_package$__native$lzycompute__Lscommons_reactnative_safearea_raw_SafeArea($thiz) {
  if ((!$thiz.Lscommons_reactnative_safearea_package$__f_bitmap$0)) {
    $thiz.Lscommons_reactnative_safearea_package$__f_native = $i_react$002dnative$002dsafe$002darea$002dcontext;
    $thiz.Lscommons_reactnative_safearea_package$__f_bitmap$0 = true
  };
  return $thiz.Lscommons_reactnative_safearea_package$__f_native
}
/** @constructor */
function $c_Lscommons_reactnative_safearea_package$() {
  this.Lscommons_reactnative_safearea_package$__f_native = null;
  this.Lscommons_reactnative_safearea_package$__f_bitmap$0 = false
}
$c_Lscommons_reactnative_safearea_package$.prototype = new $h_O();
$c_Lscommons_reactnative_safearea_package$.prototype.constructor = $c_Lscommons_reactnative_safearea_package$;
/** @constructor */
function $h_Lscommons_reactnative_safearea_package$() {
  /*<skip>*/
}
$h_Lscommons_reactnative_safearea_package$.prototype = $c_Lscommons_reactnative_safearea_package$.prototype;
$c_Lscommons_reactnative_safearea_package$.prototype.native__Lscommons_reactnative_safearea_raw_SafeArea = (function() {
  return ((!this.Lscommons_reactnative_safearea_package$__f_bitmap$0) ? $p_Lscommons_reactnative_safearea_package$__native$lzycompute__Lscommons_reactnative_safearea_raw_SafeArea(this) : this.Lscommons_reactnative_safearea_package$__f_native)
});
var $d_Lscommons_reactnative_safearea_package$ = new $TypeData().initClass({
  Lscommons_reactnative_safearea_package$: 0
}, false, "scommons.reactnative.safearea.package$", {
  Lscommons_reactnative_safearea_package$: 1,
  O: 1,
  Lscommons_reactnative_safearea_SafeArea: 1
});
$c_Lscommons_reactnative_safearea_package$.prototype.$classData = $d_Lscommons_reactnative_safearea_package$;
var $n_Lscommons_reactnative_safearea_package$;
function $m_Lscommons_reactnative_safearea_package$() {
  if ((!$n_Lscommons_reactnative_safearea_package$)) {
    $n_Lscommons_reactnative_safearea_package$ = new $c_Lscommons_reactnative_safearea_package$()
  };
  return $n_Lscommons_reactnative_safearea_package$
}
/** @constructor */
function $c_Lscommons_reactnative_ui_ChoiceGroupProps$() {
  /*<skip>*/
}
$c_Lscommons_reactnative_ui_ChoiceGroupProps$.prototype = new $h_O();
$c_Lscommons_reactnative_ui_ChoiceGroupProps$.prototype.constructor = $c_Lscommons_reactnative_ui_ChoiceGroupProps$;
/** @constructor */
function $h_Lscommons_reactnative_ui_ChoiceGroupProps$() {
  /*<skip>*/
}
$h_Lscommons_reactnative_ui_ChoiceGroupProps$.prototype = $c_Lscommons_reactnative_ui_ChoiceGroupProps$.prototype;
$c_Lscommons_reactnative_ui_ChoiceGroupProps$.prototype.defaultIconRenderer__Z__I__s_Option__F2 = (function(multiSelect, size, color) {
  return new $c_sjsr_AnonFunction2((function(this$1, multiSelect$1, size$1, color$1) {
    return (function(isSelected$2, theme$2) {
      var isSelected = $uZ(isSelected$2);
      $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
      var reactClass = $m_Lscommons_expo_package$().VectorIcons__Lscommons_expo_raw_VectorIcons$().Ionicons;
      var $$x3 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass);
      var this$3 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes().name__Lio_github_shogowada_statictags_StringAttributeSpec();
      var value = (multiSelect$1 ? (isSelected ? "md-checkbox-outline" : "md-square-outline") : (isSelected ? "md-radio-button-on" : "md-radio-button-off"));
      var $$x2 = new $c_Lio_github_shogowada_statictags_Attribute(this$3.Lio_github_shogowada_statictags_StringAttributeSpec__f_name, value, $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$());
      var attributes = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
      var $$x1 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes).rnSize__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeSizeAttributeSpec().$colon$eq__I__Lio_github_shogowada_statictags_Attribute(size$1);
      var attributes$1 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
      var this$7 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$1).color__Lio_github_shogowada_statictags_StringAttributeSpec();
      var value$1 = $as_T((color$1.isEmpty__Z() ? $as_T(theme$2.colors.primary) : color$1.get__O()));
      var array = [$$x2, $$x1, new $c_Lio_github_shogowada_statictags_Attribute(this$7.Lio_github_shogowada_statictags_StringAttributeSpec__f_name, value$1, $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$())];
      return $$x3.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array), $m_sci_Nil$())
    })
  })(this, multiSelect, size, color))
});
$c_Lscommons_reactnative_ui_ChoiceGroupProps$.prototype.apply__sci_List__sci_Set__F1__Z__s_Option__Lscommons_reactnative_ui_ChoiceGroupProps = (function(items, selectedIds, onSelectChange, multiSelect, style) {
  return new $c_Lscommons_reactnative_ui_ChoiceGroupProps(items, new $c_sjsr_AnonFunction1((function(this$1) {
    return (function(x$2$2) {
      var x$2 = $as_Lscommons_reactnative_ui_ChoiceItemData(x$2$2);
      return x$2.Lscommons_reactnative_ui_ChoiceItemData__f_id
    })
  })(this)), this.defaultIconRenderer__Z__I__s_Option__F2(multiSelect, 24, $m_s_None$()), new $c_sjsr_AnonFunction2((function(this$2) {
    return (function(data$2, theme$2) {
      var data = $as_Lscommons_reactnative_ui_ChoiceItemData(data$2);
      var elements = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
      var $$x2 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements).Text__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
      var this$5 = $m_Lscommons_react_navigation_package$();
      var light = $m_Lscommons_reactnative_ui_ChoiceGroup$().styles__Lscommons_reactnative_ui_ChoiceGroup$Styles().label;
      var this$4 = $m_Lscommons_react_navigation_package$();
      var dark = $f_Lscommons_react_navigation_ReactNavigation__themeTextStyle__Lscommons_react_navigation_raw_Theme__Lscommons_reactnative_TextStyle(this$4, theme$2);
      var array = [$f_Lscommons_react_navigation_ReactNavigation__themeStyle__Lscommons_reactnative_Style__Lscommons_reactnative_Style__Lscommons_react_navigation_raw_Theme__Lio_github_shogowada_statictags_Attribute(this$5, light, dark, theme$2)];
      var $$x1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
      var array$1 = [data.Lscommons_reactnative_ui_ChoiceItemData__f_text];
      return $$x2.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x1, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
    })
  })(this)), selectedIds, onSelectChange, multiSelect, style)
});
var $d_Lscommons_reactnative_ui_ChoiceGroupProps$ = new $TypeData().initClass({
  Lscommons_reactnative_ui_ChoiceGroupProps$: 0
}, false, "scommons.reactnative.ui.ChoiceGroupProps$", {
  Lscommons_reactnative_ui_ChoiceGroupProps$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lscommons_reactnative_ui_ChoiceGroupProps$.prototype.$classData = $d_Lscommons_reactnative_ui_ChoiceGroupProps$;
var $n_Lscommons_reactnative_ui_ChoiceGroupProps$;
function $m_Lscommons_reactnative_ui_ChoiceGroupProps$() {
  if ((!$n_Lscommons_reactnative_ui_ChoiceGroupProps$)) {
    $n_Lscommons_reactnative_ui_ChoiceGroupProps$ = new $c_Lscommons_reactnative_ui_ChoiceGroupProps$()
  };
  return $n_Lscommons_reactnative_ui_ChoiceGroupProps$
}
function $p_Lshowcase_SwitchController__scommons$react$redux$BaseStateController$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz) {
  if (((((2 & $thiz.Lshowcase_SwitchController__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lshowcase_SwitchController__f_scommons$react$redux$BaseStateController$$reactClass = $f_Lscommons_react_redux_BaseStateController__scommons$react$redux$BaseStateController$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz);
    $thiz.Lshowcase_SwitchController__f_bitmap$0 = (((2 | $thiz.Lshowcase_SwitchController__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lshowcase_SwitchController__f_scommons$react$redux$BaseStateController$$reactClass
}
function $p_Lshowcase_SwitchController__uiComponent$lzycompute__Lscommons_react_UiComponent($thiz) {
  if (((((1 & $thiz.Lshowcase_SwitchController__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lshowcase_SwitchController__f_uiComponent = $m_Lshowcase_SwitchDemo$();
    $thiz.Lshowcase_SwitchController__f_bitmap$0 = (((1 | $thiz.Lshowcase_SwitchController__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lshowcase_SwitchController__f_uiComponent
}
/** @constructor */
function $c_Lshowcase_SwitchController(actions) {
  this.Lshowcase_SwitchController__f_uiComponent = null;
  this.Lshowcase_SwitchController__f_actions = null;
  this.Lshowcase_SwitchController__f_scommons$react$redux$BaseStateController$$reactClass = null;
  this.Lshowcase_SwitchController__f_bitmap$0 = 0;
  this.Lshowcase_SwitchController__f_actions = actions
}
$c_Lshowcase_SwitchController.prototype = new $h_O();
$c_Lshowcase_SwitchController.prototype.constructor = $c_Lshowcase_SwitchController;
/** @constructor */
function $h_Lshowcase_SwitchController() {
  /*<skip>*/
}
$h_Lshowcase_SwitchController.prototype = $c_Lshowcase_SwitchController.prototype;
$c_Lshowcase_SwitchController.prototype.scommons$react$redux$BaseStateController$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass = (function() {
  return (((((2 & this.Lshowcase_SwitchController__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lshowcase_SwitchController__scommons$react$redux$BaseStateController$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass(this) : this.Lshowcase_SwitchController__f_scommons$react$redux$BaseStateController$$reactClass)
});
$c_Lshowcase_SwitchController.prototype.uiComponent__Lscommons_react_UiComponent = (function() {
  return (((((1 & this.Lshowcase_SwitchController__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lshowcase_SwitchController__uiComponent$lzycompute__Lscommons_react_UiComponent(this) : this.Lshowcase_SwitchController__f_uiComponent)
});
$c_Lshowcase_SwitchController.prototype.mapStateToProps__F1__Lshowcase_app_ShowcaseStateDef__Lio_github_shogowada_scalajs_reactjs_React$Props__Lshowcase_SwitchDemoProps = (function(dispatch, state, props) {
  return new $c_Lshowcase_SwitchDemoProps(dispatch, this.Lshowcase_SwitchController__f_actions, state.Lshowcase_app_ShowcaseState__f_config.Lshowcase_app_config_ShowcaseConfig__f_darkTheme)
});
$c_Lshowcase_SwitchController.prototype.mapStateToProps__F1__O__Lio_github_shogowada_scalajs_reactjs_React$Props__O = (function(dispatch, state, props) {
  return this.mapStateToProps__F1__Lshowcase_app_ShowcaseStateDef__Lio_github_shogowada_scalajs_reactjs_React$Props__Lshowcase_SwitchDemoProps(dispatch, $as_Lshowcase_app_ShowcaseStateDef(state), props)
});
var $d_Lshowcase_SwitchController = new $TypeData().initClass({
  Lshowcase_SwitchController: 0
}, false, "showcase.SwitchController", {
  Lshowcase_SwitchController: 1,
  O: 1,
  Lscommons_react_redux_BaseStateController: 1
});
$c_Lshowcase_SwitchController.prototype.$classData = $d_Lshowcase_SwitchController;
/** @constructor */
function $c_Lshowcase_app_ShowcaseActions$$anon$1() {
  /*<skip>*/
}
$c_Lshowcase_app_ShowcaseActions$$anon$1.prototype = new $h_O();
$c_Lshowcase_app_ShowcaseActions$$anon$1.prototype.constructor = $c_Lshowcase_app_ShowcaseActions$$anon$1;
/** @constructor */
function $h_Lshowcase_app_ShowcaseActions$$anon$1() {
  /*<skip>*/
}
$h_Lshowcase_app_ShowcaseActions$$anon$1.prototype = $c_Lshowcase_app_ShowcaseActions$$anon$1.prototype;
var $d_Lshowcase_app_ShowcaseActions$$anon$1 = new $TypeData().initClass({
  Lshowcase_app_ShowcaseActions$$anon$1: 0
}, false, "showcase.app.ShowcaseActions$$anon$1", {
  Lshowcase_app_ShowcaseActions$$anon$1: 1,
  O: 1,
  Lshowcase_api_task_DemoTaskApi: 1
});
$c_Lshowcase_app_ShowcaseActions$$anon$1.prototype.$classData = $d_Lshowcase_app_ShowcaseActions$$anon$1;
function $p_Lshowcase_app_ShowcaseRootController$__scommons$react$redux$BaseStateController$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz) {
  if (((((2 & $thiz.Lshowcase_app_ShowcaseRootController$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lshowcase_app_ShowcaseRootController$__f_scommons$react$redux$BaseStateController$$reactClass = $f_Lscommons_react_redux_BaseStateController__scommons$react$redux$BaseStateController$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz);
    $thiz.Lshowcase_app_ShowcaseRootController$__f_bitmap$0 = (((2 | $thiz.Lshowcase_app_ShowcaseRootController$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lshowcase_app_ShowcaseRootController$__f_scommons$react$redux$BaseStateController$$reactClass
}
function $p_Lshowcase_app_ShowcaseRootController$__uiComponent$lzycompute__Lscommons_react_UiComponent($thiz) {
  if (((((1 & $thiz.Lshowcase_app_ShowcaseRootController$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lshowcase_app_ShowcaseRootController$__f_uiComponent = $m_Lshowcase_app_ShowcaseRoot$();
    $thiz.Lshowcase_app_ShowcaseRootController$__f_bitmap$0 = (((1 | $thiz.Lshowcase_app_ShowcaseRootController$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lshowcase_app_ShowcaseRootController$__f_uiComponent
}
/** @constructor */
function $c_Lshowcase_app_ShowcaseRootController$() {
  this.Lshowcase_app_ShowcaseRootController$__f_uiComponent = null;
  this.Lshowcase_app_ShowcaseRootController$__f_scommons$react$redux$BaseStateController$$reactClass = null;
  this.Lshowcase_app_ShowcaseRootController$__f_bitmap$0 = 0
}
$c_Lshowcase_app_ShowcaseRootController$.prototype = new $h_O();
$c_Lshowcase_app_ShowcaseRootController$.prototype.constructor = $c_Lshowcase_app_ShowcaseRootController$;
/** @constructor */
function $h_Lshowcase_app_ShowcaseRootController$() {
  /*<skip>*/
}
$h_Lshowcase_app_ShowcaseRootController$.prototype = $c_Lshowcase_app_ShowcaseRootController$.prototype;
$c_Lshowcase_app_ShowcaseRootController$.prototype.scommons$react$redux$BaseStateController$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass = (function() {
  return (((((2 & this.Lshowcase_app_ShowcaseRootController$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lshowcase_app_ShowcaseRootController$__scommons$react$redux$BaseStateController$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass(this) : this.Lshowcase_app_ShowcaseRootController$__f_scommons$react$redux$BaseStateController$$reactClass)
});
$c_Lshowcase_app_ShowcaseRootController$.prototype.uiComponent__Lscommons_react_UiComponent = (function() {
  return (((((1 & this.Lshowcase_app_ShowcaseRootController$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lshowcase_app_ShowcaseRootController$__uiComponent$lzycompute__Lscommons_react_UiComponent(this) : this.Lshowcase_app_ShowcaseRootController$__f_uiComponent)
});
$c_Lshowcase_app_ShowcaseRootController$.prototype.mapStateToProps__F1__Lshowcase_app_ShowcaseStateDef__Lio_github_shogowada_scalajs_reactjs_React$Props__Lshowcase_app_ShowcaseRootProps = (function(dispatch, state, props) {
  return new $c_Lshowcase_app_ShowcaseRootProps(state.Lshowcase_app_ShowcaseState__f_config.Lshowcase_app_config_ShowcaseConfig__f_darkTheme)
});
$c_Lshowcase_app_ShowcaseRootController$.prototype.mapStateToProps__F1__O__Lio_github_shogowada_scalajs_reactjs_React$Props__O = (function(dispatch, state, props) {
  return this.mapStateToProps__F1__Lshowcase_app_ShowcaseStateDef__Lio_github_shogowada_scalajs_reactjs_React$Props__Lshowcase_app_ShowcaseRootProps(dispatch, $as_Lshowcase_app_ShowcaseStateDef(state), props)
});
var $d_Lshowcase_app_ShowcaseRootController$ = new $TypeData().initClass({
  Lshowcase_app_ShowcaseRootController$: 0
}, false, "showcase.app.ShowcaseRootController$", {
  Lshowcase_app_ShowcaseRootController$: 1,
  O: 1,
  Lscommons_react_redux_BaseStateController: 1
});
$c_Lshowcase_app_ShowcaseRootController$.prototype.$classData = $d_Lshowcase_app_ShowcaseRootController$;
var $n_Lshowcase_app_ShowcaseRootController$;
function $m_Lshowcase_app_ShowcaseRootController$() {
  if ((!$n_Lshowcase_app_ShowcaseRootController$)) {
    $n_Lshowcase_app_ShowcaseRootController$ = new $c_Lshowcase_app_ShowcaseRootController$()
  };
  return $n_Lshowcase_app_ShowcaseRootController$
}
function $p_Lshowcase_app_ShowcaseTaskController$__scommons$react$redux$BaseStateController$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz) {
  if (((((2 & $thiz.Lshowcase_app_ShowcaseTaskController$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lshowcase_app_ShowcaseTaskController$__f_scommons$react$redux$BaseStateController$$reactClass = $f_Lscommons_react_redux_BaseStateController__scommons$react$redux$BaseStateController$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz);
    $thiz.Lshowcase_app_ShowcaseTaskController$__f_bitmap$0 = (((2 | $thiz.Lshowcase_app_ShowcaseTaskController$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lshowcase_app_ShowcaseTaskController$__f_scommons$react$redux$BaseStateController$$reactClass
}
function $p_Lshowcase_app_ShowcaseTaskController$__uiComponent$lzycompute__Lscommons_react_UiComponent($thiz) {
  if (((((1 & $thiz.Lshowcase_app_ShowcaseTaskController$__f_bitmap$0) << 24) >> 24) === 0)) {
    $m_Lscommons_react_redux_task_TaskManager$().Lscommons_react_redux_task_TaskManager$__f_uiComponent = new $c_Lscommons_reactnative_app_AppTaskManagerUi(($m_Lscommons_reactnative_app_AppTaskManagerUi$(), new $c_Lscommons_reactnative_ui_popup_LoadingPopupProps($m_Lscommons_reactnative_ActivityIndicator$ActivityIndicatorSize$().Lscommons_reactnative_ActivityIndicator$ActivityIndicatorSize$__f_small, $m_Lscommons_reactnative_Style$Color$().Lscommons_reactnative_Style$Color$__f_gray)));
    $m_Lscommons_react_redux_task_TaskManager$().Lscommons_react_redux_task_TaskManager$__f_errorHandler = $m_Lscommons_reactnative_app_AppTaskManagerUi$().Lscommons_reactnative_app_AppTaskManagerUi$__f_errorHandler;
    $thiz.Lshowcase_app_ShowcaseTaskController$__f_uiComponent = $m_Lscommons_react_redux_task_TaskManager$();
    $thiz.Lshowcase_app_ShowcaseTaskController$__f_bitmap$0 = (((1 | $thiz.Lshowcase_app_ShowcaseTaskController$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lshowcase_app_ShowcaseTaskController$__f_uiComponent
}
/** @constructor */
function $c_Lshowcase_app_ShowcaseTaskController$() {
  this.Lshowcase_app_ShowcaseTaskController$__f_uiComponent = null;
  this.Lshowcase_app_ShowcaseTaskController$__f_scommons$react$redux$BaseStateController$$reactClass = null;
  this.Lshowcase_app_ShowcaseTaskController$__f_bitmap$0 = 0
}
$c_Lshowcase_app_ShowcaseTaskController$.prototype = new $h_O();
$c_Lshowcase_app_ShowcaseTaskController$.prototype.constructor = $c_Lshowcase_app_ShowcaseTaskController$;
/** @constructor */
function $h_Lshowcase_app_ShowcaseTaskController$() {
  /*<skip>*/
}
$h_Lshowcase_app_ShowcaseTaskController$.prototype = $c_Lshowcase_app_ShowcaseTaskController$.prototype;
$c_Lshowcase_app_ShowcaseTaskController$.prototype.scommons$react$redux$BaseStateController$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass = (function() {
  return (((((2 & this.Lshowcase_app_ShowcaseTaskController$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lshowcase_app_ShowcaseTaskController$__scommons$react$redux$BaseStateController$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass(this) : this.Lshowcase_app_ShowcaseTaskController$__f_scommons$react$redux$BaseStateController$$reactClass)
});
$c_Lshowcase_app_ShowcaseTaskController$.prototype.uiComponent__Lscommons_react_UiComponent = (function() {
  return (((((1 & this.Lshowcase_app_ShowcaseTaskController$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lshowcase_app_ShowcaseTaskController$__uiComponent$lzycompute__Lscommons_react_UiComponent(this) : this.Lshowcase_app_ShowcaseTaskController$__f_uiComponent)
});
$c_Lshowcase_app_ShowcaseTaskController$.prototype.mapStateToProps__F1__O__Lio_github_shogowada_scalajs_reactjs_React$Props__O = (function(dispatch, state, props) {
  var state$1 = $as_Lshowcase_app_ShowcaseStateDef(state);
  return new $c_Lscommons_react_redux_task_TaskManagerProps(state$1.Lshowcase_app_ShowcaseState__f_currentTask)
});
var $d_Lshowcase_app_ShowcaseTaskController$ = new $TypeData().initClass({
  Lshowcase_app_ShowcaseTaskController$: 0
}, false, "showcase.app.ShowcaseTaskController$", {
  Lshowcase_app_ShowcaseTaskController$: 1,
  O: 1,
  Lscommons_react_redux_BaseStateController: 1
});
$c_Lshowcase_app_ShowcaseTaskController$.prototype.$classData = $d_Lshowcase_app_ShowcaseTaskController$;
var $n_Lshowcase_app_ShowcaseTaskController$;
function $m_Lshowcase_app_ShowcaseTaskController$() {
  if ((!$n_Lshowcase_app_ShowcaseTaskController$)) {
    $n_Lshowcase_app_ShowcaseTaskController$ = new $c_Lshowcase_app_ShowcaseTaskController$()
  };
  return $n_Lshowcase_app_ShowcaseTaskController$
}
function $p_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$__VirtualDOMElements$lzycompute$1__V($thiz) {
  if (($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().Lio_github_shogowada_scalajs_reactjs_VirtualDOM$__f_VirtualDOMElements$module === null)) {
    $m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().Lio_github_shogowada_scalajs_reactjs_VirtualDOM$__f_VirtualDOMElements$module = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$($thiz)
  }
}
function $p_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$__VirtualDOMAttributes$lzycompute$1__V($thiz) {
  if (($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().Lio_github_shogowada_scalajs_reactjs_VirtualDOM$__f_VirtualDOMAttributes$module === null)) {
    $m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().Lio_github_shogowada_scalajs_reactjs_VirtualDOM$__f_VirtualDOMAttributes$module = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$($thiz)
  }
}
/** @constructor */
function $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$() {
  this.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$__f_VirtualDOMElements$module = null;
  this.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$__f_VirtualDOMAttributes$module = null;
  this.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$__f_$less = null;
  this.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$__f_$up = null;
  this.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$__f_bitmap$init$0 = 0;
  $n_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$ = this;
  $f_Lio_github_shogowada_statictags_StaticTags__$init$__V(this);
  $f_Lio_github_shogowada_scalajs_reactjs_VirtualDOM__$init$__V(this)
}
$c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$.prototype = new $h_O();
$c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$.prototype.constructor = $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$;
/** @constructor */
function $h_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$() {
  /*<skip>*/
}
$h_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$.prototype = $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$.prototype;
$c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$.prototype.VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ = (function() {
  if (($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().Lio_github_shogowada_scalajs_reactjs_VirtualDOM$__f_VirtualDOMElements$module === null)) {
    $p_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$__VirtualDOMElements$lzycompute$1__V(this)
  };
  return $m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().Lio_github_shogowada_scalajs_reactjs_VirtualDOM$__f_VirtualDOMElements$module
});
$c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$.prototype.VirtualDOMAttributes__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$ = (function() {
  if (($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().Lio_github_shogowada_scalajs_reactjs_VirtualDOM$__f_VirtualDOMAttributes$module === null)) {
    $p_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$__VirtualDOMAttributes$lzycompute$1__V(this)
  };
  return $m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().Lio_github_shogowada_scalajs_reactjs_VirtualDOM$__f_VirtualDOMAttributes$module
});
$c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$.prototype.$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements = (function() {
  if (((((4 & this.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scalajs-reactjs/scalajs-reactjs/core/src/main/scala/io/github/shogowada/scalajs/reactjs/VirtualDOM.scala: 15")
  };
  return this.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$__f_$less
});
$c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$.prototype.$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes = (function() {
  if (((((8 & this.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$__f_bitmap$init$0) << 24) >> 24) === 0)) {
    throw new $c_s_UninitializedFieldError("Uninitialized field: /home/runner/work/scalajs-reactjs/scalajs-reactjs/core/src/main/scala/io/github/shogowada/scalajs/reactjs/VirtualDOM.scala: 15")
  };
  return this.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$__f_$up
});
$c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$.prototype.io$github$shogowada$scalajs$reactjs$VirtualDOM$_setter_$$less_$eq__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements__V = (function(x$1) {
  this.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$__f_$less = x$1;
  this.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$__f_bitmap$init$0 = (((4 | this.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$__f_bitmap$init$0) << 24) >> 24)
});
$c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$.prototype.io$github$shogowada$scalajs$reactjs$VirtualDOM$_setter_$$up_$eq__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes__V = (function(x$1) {
  this.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$__f_$up = x$1;
  this.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$__f_bitmap$init$0 = (((8 | this.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$__f_bitmap$init$0) << 24) >> 24)
});
$c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$.prototype.io$github$shogowada$statictags$StaticTags$_setter_$$less_$eq__Lio_github_shogowada_statictags_StaticTags$Elements__V = (function(x$1) {
  this.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$__f_bitmap$init$0 = (((4 | this.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$__f_bitmap$init$0) << 24) >> 24)
});
$c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$.prototype.io$github$shogowada$statictags$StaticTags$_setter_$$up_$eq__Lio_github_shogowada_statictags_StaticTags$Attributes__V = (function(x$1) {
  this.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$__f_bitmap$init$0 = (((8 | this.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$__f_bitmap$init$0) << 24) >> 24)
});
var $d_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$ = new $TypeData().initClass({
  Lio_github_shogowada_scalajs_reactjs_VirtualDOM$: 0
}, false, "io.github.shogowada.scalajs.reactjs.VirtualDOM$", {
  Lio_github_shogowada_scalajs_reactjs_VirtualDOM$: 1,
  O: 1,
  Lio_github_shogowada_scalajs_reactjs_VirtualDOM: 1,
  Lio_github_shogowada_statictags_StaticTags: 1
});
$c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$.prototype.$classData = $d_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$;
var $n_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$;
function $m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$() {
  if ((!$n_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$)) {
    $n_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$ = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$()
  };
  return $n_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$
}
function $f_jl_Boolean__equals__O__Z($thiz, that) {
  return ($thiz === that)
}
function $f_jl_Boolean__hashCode__I($thiz) {
  return ($uZ($thiz) ? 1231 : 1237)
}
function $f_jl_Boolean__toString__T($thiz) {
  var b = $uZ($thiz);
  return ("" + b)
}
function $as_jl_Boolean(obj) {
  return ((((typeof obj) === "boolean") || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Boolean"))
}
function $isArrayOf_jl_Boolean(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Boolean)))
}
function $asArrayOf_jl_Boolean(obj, depth) {
  return (($isArrayOf_jl_Boolean(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Boolean;", depth))
}
var $d_jl_Boolean = new $TypeData().initClass({
  jl_Boolean: 0
}, false, "java.lang.Boolean", {
  jl_Boolean: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1
}, (void 0), (void 0), (function(x) {
  return ((typeof x) === "boolean")
}));
function $f_jl_Character__hashCode__I($thiz) {
  var value = $uC($thiz);
  return value
}
function $f_jl_Character__equals__O__Z($thiz, that) {
  if ((that instanceof $Char)) {
    var $$x1 = $uC($thiz);
    var this$1 = $as_jl_Character(that);
    return ($$x1 === $uC(this$1))
  } else {
    return false
  }
}
function $f_jl_Character__toString__T($thiz) {
  var c = $uC($thiz);
  return $as_T(String.fromCharCode(c))
}
function $as_jl_Character(obj) {
  return (((obj instanceof $Char) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Character"))
}
function $isArrayOf_jl_Character(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Character)))
}
function $asArrayOf_jl_Character(obj, depth) {
  return (($isArrayOf_jl_Character(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Character;", depth))
}
var $d_jl_Character = new $TypeData().initClass({
  jl_Character: 0
}, false, "java.lang.Character", {
  jl_Character: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1
}, (void 0), (void 0), (function(x) {
  return (x instanceof $Char)
}));
function $ct_jl_Enum__T__I__($thiz, _name, _ordinal) {
  $thiz.jl_Enum__f__name = _name;
  $thiz.jl_Enum__f__ordinal = _ordinal;
  return $thiz
}
/** @constructor */
function $c_jl_Enum() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0
}
$c_jl_Enum.prototype = new $h_O();
$c_jl_Enum.prototype.constructor = $c_jl_Enum;
/** @constructor */
function $h_jl_Enum() {
  /*<skip>*/
}
$h_jl_Enum.prototype = $c_jl_Enum.prototype;
$c_jl_Enum.prototype.toString__T = (function() {
  return this.jl_Enum__f__name
});
$c_jl_Enum.prototype.equals__O__Z = (function(that) {
  return (this === that)
});
$c_jl_Enum.prototype.hashCode__I = (function() {
  return $systemIdentityHashCode(this)
});
function $ct_jl_Error__jl_Throwable__($thiz, e) {
  var message = ((e === null) ? null : e.toString__T());
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, message, e, true, true);
  return $thiz
}
/** @constructor */
function $c_jl_Error() {
  this.jl_Throwable__f_s = null;
  this.jl_Throwable__f_e = null;
  this.jl_Throwable__f_enableSuppression = false;
  this.jl_Throwable__f_writableStackTrace = false;
  this.jl_Throwable__f_stackTraceStateInternal = null;
  this.jl_Throwable__f_stackTrace = null;
  this.jl_Throwable__f_suppressed = null
}
$c_jl_Error.prototype = new $h_jl_Throwable();
$c_jl_Error.prototype.constructor = $c_jl_Error;
/** @constructor */
function $h_jl_Error() {
  /*<skip>*/
}
$h_jl_Error.prototype = $c_jl_Error.prototype;
function $as_jl_Error(obj) {
  return (((obj instanceof $c_jl_Error) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Error"))
}
function $isArrayOf_jl_Error(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Error)))
}
function $asArrayOf_jl_Error(obj, depth) {
  return (($isArrayOf_jl_Error(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Error;", depth))
}
function $ct_jl_Exception__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz
}
/** @constructor */
function $c_jl_Exception() {
  this.jl_Throwable__f_s = null;
  this.jl_Throwable__f_e = null;
  this.jl_Throwable__f_enableSuppression = false;
  this.jl_Throwable__f_writableStackTrace = false;
  this.jl_Throwable__f_stackTraceStateInternal = null;
  this.jl_Throwable__f_stackTrace = null;
  this.jl_Throwable__f_suppressed = null
}
$c_jl_Exception.prototype = new $h_jl_Throwable();
$c_jl_Exception.prototype.constructor = $c_jl_Exception;
/** @constructor */
function $h_jl_Exception() {
  /*<skip>*/
}
$h_jl_Exception.prototype = $c_jl_Exception.prototype;
var $d_jl_Exception = new $TypeData().initClass({
  jl_Exception: 0
}, false, "java.lang.Exception", {
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_Exception.prototype.$classData = $d_jl_Exception;
/** @constructor */
function $c_Ljava_net_URI(origStr) {
  this.Ljava_net_URI__f_origStr = null;
  this.Ljava_net_URI__f_java$net$URI$$_fld = null;
  this.Ljava_net_URI__f_java$net$URI$$_isAbsolute = false;
  this.Ljava_net_URI__f__isOpaque = false;
  this.Ljava_net_URI__f_java$net$URI$$_scheme = null;
  this.Ljava_net_URI__f_java$net$URI$$_schemeSpecificPart = null;
  this.Ljava_net_URI__f_java$net$URI$$_authority = null;
  this.Ljava_net_URI__f_java$net$URI$$_userInfo = null;
  this.Ljava_net_URI__f_java$net$URI$$_host = null;
  this.Ljava_net_URI__f_java$net$URI$$_port = null;
  this.Ljava_net_URI__f__path = null;
  this.Ljava_net_URI__f__query = null;
  this.Ljava_net_URI__f__fragment = null;
  this.Ljava_net_URI__f_origStr = origStr;
  var this$1 = $m_s_Option$().apply__O__s_Option($m_Ljava_net_URI$().Ljava_net_URI$__f_java$net$URI$$uriRe.exec(origStr));
  if (this$1.isEmpty__Z()) {
    var $$x1;
    throw $ct_Ljava_net_URISyntaxException__T__T__(new $c_Ljava_net_URISyntaxException(), this.Ljava_net_URI__f_origStr, "Malformed URI")
  } else {
    var $$x1 = this$1.get__O()
  };
  this.Ljava_net_URI__f_java$net$URI$$_fld = $$x1;
  var value = this.Ljava_net_URI__f_java$net$URI$$_fld[1];
  this.Ljava_net_URI__f_java$net$URI$$_isAbsolute = (value !== (void 0));
  var value$1 = this.Ljava_net_URI__f_java$net$URI$$_fld[10];
  this.Ljava_net_URI__f__isOpaque = (value$1 !== (void 0));
  this.Ljava_net_URI__f_java$net$URI$$_scheme = this.Ljava_net_URI__f_java$net$URI$$_fld[1];
  var value$2 = ((!this.Ljava_net_URI__f_java$net$URI$$_isAbsolute) ? this.Ljava_net_URI__f_java$net$URI$$_fld[11] : (this.Ljava_net_URI__f__isOpaque ? this.Ljava_net_URI__f_java$net$URI$$_fld[10] : this.Ljava_net_URI__f_java$net$URI$$_fld[2]));
  if ((value$2 === (void 0))) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "undefined.get")
  };
  this.Ljava_net_URI__f_java$net$URI$$_schemeSpecificPart = $as_T(value$2);
  var value$3 = (this.Ljava_net_URI__f_java$net$URI$$_isAbsolute ? this.Ljava_net_URI__f_java$net$URI$$_fld[3] : this.Ljava_net_URI__f_java$net$URI$$_fld[12]);
  if ((value$3 === (void 0))) {
    var $$x2 = true
  } else {
    var x$1 = $as_T(value$3);
    var $$x2 = (x$1 !== "")
  };
  this.Ljava_net_URI__f_java$net$URI$$_authority = ($$x2 ? value$3 : (void 0));
  this.Ljava_net_URI__f_java$net$URI$$_userInfo = (this.Ljava_net_URI__f_java$net$URI$$_isAbsolute ? this.Ljava_net_URI__f_java$net$URI$$_fld[4] : this.Ljava_net_URI__f_java$net$URI$$_fld[13]);
  this.Ljava_net_URI__f_java$net$URI$$_host = (this.Ljava_net_URI__f_java$net$URI$$_isAbsolute ? this.Ljava_net_URI__f_java$net$URI$$_fld[5] : this.Ljava_net_URI__f_java$net$URI$$_fld[14]);
  var value$4 = (this.Ljava_net_URI__f_java$net$URI$$_isAbsolute ? this.Ljava_net_URI__f_java$net$URI$$_fld[6] : this.Ljava_net_URI__f_java$net$URI$$_fld[15]);
  if ((value$4 === (void 0))) {
    var $$x3 = (void 0)
  } else {
    var x$2 = $as_T(value$4);
    var this$24 = $m_jl_Integer$();
    var a = this$24.parseInt__T__I__I(x$2, 10);
    var $$x3 = a
  };
  this.Ljava_net_URI__f_java$net$URI$$_port = $$x3;
  var value$5 = (this.Ljava_net_URI__f_java$net$URI$$_isAbsolute ? this.Ljava_net_URI__f_java$net$URI$$_fld[3] : this.Ljava_net_URI__f_java$net$URI$$_fld[12]);
  var useNetPath = (value$5 !== (void 0));
  if (useNetPath) {
    var value$6 = (this.Ljava_net_URI__f_java$net$URI$$_isAbsolute ? this.Ljava_net_URI__f_java$net$URI$$_fld[7] : this.Ljava_net_URI__f_java$net$URI$$_fld[16]);
    var $$x4 = ((value$6 === (void 0)) ? "" : value$6)
  } else if (this.Ljava_net_URI__f_java$net$URI$$_isAbsolute) {
    var $$x4 = this.Ljava_net_URI__f_java$net$URI$$_fld[8]
  } else {
    var value$7 = this.Ljava_net_URI__f_java$net$URI$$_fld[17];
    var $$x4 = ((value$7 === (void 0)) ? this.Ljava_net_URI__f_java$net$URI$$_fld[18] : value$7)
  };
  this.Ljava_net_URI__f__path = $$x4;
  this.Ljava_net_URI__f__query = (this.Ljava_net_URI__f_java$net$URI$$_isAbsolute ? this.Ljava_net_URI__f_java$net$URI$$_fld[9] : this.Ljava_net_URI__f_java$net$URI$$_fld[19]);
  this.Ljava_net_URI__f__fragment = this.Ljava_net_URI__f_java$net$URI$$_fld[20];
  this.Ljava_net_URI__f_java$net$URI$$_fld = null
}
$c_Ljava_net_URI.prototype = new $h_O();
$c_Ljava_net_URI.prototype.constructor = $c_Ljava_net_URI;
/** @constructor */
function $h_Ljava_net_URI() {
  /*<skip>*/
}
$h_Ljava_net_URI.prototype = $c_Ljava_net_URI.prototype;
$c_Ljava_net_URI.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_Ljava_net_URI)) {
    var x2 = $as_Ljava_net_URI(that);
    var f = (function(this$1) {
      return (function(x$2, y$2) {
        var x = $as_T(x$2);
        var y = $as_T(y$2);
        var this$2 = $m_Ljava_net_URI$();
        return $p_Ljava_net_URI$__loop$1__I__T__T__I(this$2, 0, x, y)
      })
    })(this);
    var x$1 = this.Ljava_net_URI__f_java$net$URI$$_scheme;
    var y$1 = x2.Ljava_net_URI__f_java$net$URI$$_scheme;
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(x$1, y$1)) {
      var cmpScheme = 0
    } else if ((x$1 === (void 0))) {
      var cmpScheme = (-1)
    } else if ((y$1 === (void 0))) {
      var cmpScheme = 1
    } else {
      var x$3 = $as_T(x$1);
      var x$4 = $as_T(y$1);
      var cmpScheme = $f_T__compareToIgnoreCase__T__I(x$3, x$4)
    };
    if ((cmpScheme !== 0)) {
      var $$x1 = cmpScheme
    } else {
      var x$5 = this.Ljava_net_URI__f__isOpaque;
      var y$3 = x2.Ljava_net_URI__f__isOpaque;
      var cmpIsOpaque = ((x$5 === y$3) ? 0 : (x$5 ? 1 : (-1)));
      if ((cmpIsOpaque !== 0)) {
        var $$x1 = cmpIsOpaque
      } else if (this.Ljava_net_URI__f__isOpaque) {
        var arg1 = this.Ljava_net_URI__f_java$net$URI$$_schemeSpecificPart;
        var arg2 = x2.Ljava_net_URI__f_java$net$URI$$_schemeSpecificPart;
        var cmpSchemeSpecificPart = $uI(f(arg1, arg2));
        if ((cmpSchemeSpecificPart !== 0)) {
          var $$x1 = cmpSchemeSpecificPart
        } else {
          var x$6 = this.Ljava_net_URI__f__path;
          var y$4 = x2.Ljava_net_URI__f__path;
          var cmpPath = ($m_sr_BoxesRunTime$().equals__O__O__Z(x$6, y$4) ? 0 : ((x$6 === (void 0)) ? (-1) : ((y$4 === (void 0)) ? 1 : $uI(f(x$6, y$4)))));
          if ((cmpPath !== 0)) {
            var $$x1 = cmpPath
          } else {
            var x$7 = this.Ljava_net_URI__f__query;
            var y$5 = x2.Ljava_net_URI__f__query;
            var cmpQuery = ($m_sr_BoxesRunTime$().equals__O__O__Z(x$7, y$5) ? 0 : ((x$7 === (void 0)) ? (-1) : ((y$5 === (void 0)) ? 1 : $uI(f(x$7, y$5)))));
            if ((cmpQuery !== 0)) {
              var $$x1 = cmpQuery
            } else {
              var x$8 = this.Ljava_net_URI__f__fragment;
              var y$6 = x2.Ljava_net_URI__f__fragment;
              var $$x1 = ($m_sr_BoxesRunTime$().equals__O__O__Z(x$8, y$6) ? 0 : ((x$8 === (void 0)) ? (-1) : ((y$6 === (void 0)) ? 1 : $uI(f(x$8, y$6)))))
            }
          }
        }
      } else {
        var value = this.Ljava_net_URI__f_java$net$URI$$_host;
        if ((value !== (void 0))) {
          var value$1 = x2.Ljava_net_URI__f_java$net$URI$$_host;
          var $$x2 = (value$1 !== (void 0))
        } else {
          var $$x2 = false
        };
        if ($$x2) {
          var x$9 = this.Ljava_net_URI__f_java$net$URI$$_userInfo;
          var y$7 = x2.Ljava_net_URI__f_java$net$URI$$_userInfo;
          var cmpUserInfo = ($m_sr_BoxesRunTime$().equals__O__O__Z(x$9, y$7) ? 0 : ((x$9 === (void 0)) ? (-1) : ((y$7 === (void 0)) ? 1 : $uI(f(x$9, y$7)))));
          if ((cmpUserInfo !== 0)) {
            var $$x1 = cmpUserInfo
          } else {
            var x$10 = this.Ljava_net_URI__f_java$net$URI$$_host;
            var y$8 = x2.Ljava_net_URI__f_java$net$URI$$_host;
            if ($m_sr_BoxesRunTime$().equals__O__O__Z(x$10, y$8)) {
              var cmpHost = 0
            } else if ((x$10 === (void 0))) {
              var cmpHost = (-1)
            } else if ((y$8 === (void 0))) {
              var cmpHost = 1
            } else {
              var x$5$1 = $as_T(x$10);
              var x$6$1 = $as_T(y$8);
              var cmpHost = $f_T__compareToIgnoreCase__T__I(x$5$1, x$6$1)
            };
            if ((cmpHost !== 0)) {
              var $$x1 = cmpHost
            } else {
              var x$11 = this.Ljava_net_URI__f_java$net$URI$$_port;
              var y$9 = x2.Ljava_net_URI__f_java$net$URI$$_port;
              if ($m_sr_BoxesRunTime$().equals__O__O__Z(x$11, y$9)) {
                var cmpPort = 0
              } else if ((x$11 === (void 0))) {
                var cmpPort = (-1)
              } else if ((y$9 === (void 0))) {
                var cmpPort = 1
              } else {
                var x$7$1 = $uI(x$11);
                var x$8$1 = $uI(y$9);
                var cmpPort = ((x$7$1 - x$8$1) | 0)
              };
              if ((cmpPort !== 0)) {
                var $$x1 = cmpPort
              } else {
                var x$12 = this.Ljava_net_URI__f__path;
                var y$10 = x2.Ljava_net_URI__f__path;
                var cmpPath$1 = ($m_sr_BoxesRunTime$().equals__O__O__Z(x$12, y$10) ? 0 : ((x$12 === (void 0)) ? (-1) : ((y$10 === (void 0)) ? 1 : $uI(f(x$12, y$10)))));
                if ((cmpPath$1 !== 0)) {
                  var $$x1 = cmpPath$1
                } else {
                  var x$13 = this.Ljava_net_URI__f__query;
                  var y$11 = x2.Ljava_net_URI__f__query;
                  var cmpQuery$1 = ($m_sr_BoxesRunTime$().equals__O__O__Z(x$13, y$11) ? 0 : ((x$13 === (void 0)) ? (-1) : ((y$11 === (void 0)) ? 1 : $uI(f(x$13, y$11)))));
                  if ((cmpQuery$1 !== 0)) {
                    var $$x1 = cmpQuery$1
                  } else {
                    var x$14 = this.Ljava_net_URI__f__fragment;
                    var y$12 = x2.Ljava_net_URI__f__fragment;
                    var $$x1 = ($m_sr_BoxesRunTime$().equals__O__O__Z(x$14, y$12) ? 0 : ((x$14 === (void 0)) ? (-1) : ((y$12 === (void 0)) ? 1 : $uI(f(x$14, y$12)))))
                  }
                }
              }
            }
          }
        } else {
          var x$15 = this.Ljava_net_URI__f_java$net$URI$$_authority;
          var y$13 = x2.Ljava_net_URI__f_java$net$URI$$_authority;
          var cmpAuthority = ($m_sr_BoxesRunTime$().equals__O__O__Z(x$15, y$13) ? 0 : ((x$15 === (void 0)) ? (-1) : ((y$13 === (void 0)) ? 1 : $uI(f(x$15, y$13)))));
          if ((cmpAuthority !== 0)) {
            var $$x1 = cmpAuthority
          } else {
            var x$16 = this.Ljava_net_URI__f__path;
            var y$14 = x2.Ljava_net_URI__f__path;
            var cmpPath$2 = ($m_sr_BoxesRunTime$().equals__O__O__Z(x$16, y$14) ? 0 : ((x$16 === (void 0)) ? (-1) : ((y$14 === (void 0)) ? 1 : $uI(f(x$16, y$14)))));
            if ((cmpPath$2 !== 0)) {
              var $$x1 = cmpPath$2
            } else {
              var x$17 = this.Ljava_net_URI__f__query;
              var y$15 = x2.Ljava_net_URI__f__query;
              var cmpQuery$2 = ($m_sr_BoxesRunTime$().equals__O__O__Z(x$17, y$15) ? 0 : ((x$17 === (void 0)) ? (-1) : ((y$15 === (void 0)) ? 1 : $uI(f(x$17, y$15)))));
              if ((cmpQuery$2 !== 0)) {
                var $$x1 = cmpQuery$2
              } else {
                var x$18 = this.Ljava_net_URI__f__fragment;
                var y$16 = x2.Ljava_net_URI__f__fragment;
                var $$x1 = ($m_sr_BoxesRunTime$().equals__O__O__Z(x$18, y$16) ? 0 : ((x$18 === (void 0)) ? (-1) : ((y$16 === (void 0)) ? 1 : $uI(f(x$18, y$16)))))
              }
            }
          }
        }
      }
    };
    return ($$x1 === 0)
  } else {
    return false
  }
});
$c_Ljava_net_URI.prototype.hashCode__I = (function() {
  var acc = 53722356;
  var $$x2 = $m_s_util_hashing_MurmurHash3$();
  var $$x1 = acc;
  var value = this.Ljava_net_URI__f_java$net$URI$$_scheme;
  if ((value === (void 0))) {
    var x = (void 0)
  } else {
    var x$11 = $as_T(value);
    var a = $as_T(x$11.toLowerCase());
    var x = a
  };
  acc = $$x2.mix__I__I__I($$x1, $m_sr_Statics$().anyHash__O__I(x));
  if (this.Ljava_net_URI__f__isOpaque) {
    var $$x5 = $m_s_util_hashing_MurmurHash3$();
    var $$x4 = acc;
    var $$x3 = $m_Ljava_net_URI$();
    var a$1 = this.Ljava_net_URI__f_java$net$URI$$_schemeSpecificPart;
    var x$1 = $$x3.java$net$URI$$normalizeEscapes__sjs_js_$bar__sjs_js_$bar(a$1);
    acc = $$x5.mix__I__I__I($$x4, $m_sr_Statics$().anyHash__O__I(x$1))
  } else {
    var value$1 = this.Ljava_net_URI__f_java$net$URI$$_host;
    if ((value$1 !== (void 0))) {
      var $$x7 = $m_s_util_hashing_MurmurHash3$();
      var $$x6 = acc;
      var x$2 = $m_Ljava_net_URI$().java$net$URI$$normalizeEscapes__sjs_js_$bar__sjs_js_$bar(this.Ljava_net_URI__f_java$net$URI$$_userInfo);
      acc = $$x7.mix__I__I__I($$x6, $m_sr_Statics$().anyHash__O__I(x$2));
      var $$x9 = $m_s_util_hashing_MurmurHash3$();
      var $$x8 = acc;
      var value$2 = this.Ljava_net_URI__f_java$net$URI$$_host;
      if ((value$2 === (void 0))) {
        var x$3 = (void 0)
      } else {
        var x$12 = $as_T(value$2);
        var a$2 = $as_T(x$12.toLowerCase());
        var x$3 = a$2
      };
      acc = $$x9.mix__I__I__I($$x8, $m_sr_Statics$().anyHash__O__I(x$3));
      var $$x11 = $m_s_util_hashing_MurmurHash3$();
      var $$x10 = acc;
      var x$4 = this.Ljava_net_URI__f_java$net$URI$$_port;
      acc = $$x11.mix__I__I__I($$x10, $m_sr_Statics$().anyHash__O__I(x$4))
    } else {
      var $$x13 = $m_s_util_hashing_MurmurHash3$();
      var $$x12 = acc;
      var x$5 = $m_Ljava_net_URI$().java$net$URI$$normalizeEscapes__sjs_js_$bar__sjs_js_$bar(this.Ljava_net_URI__f_java$net$URI$$_authority);
      acc = $$x13.mix__I__I__I($$x12, $m_sr_Statics$().anyHash__O__I(x$5))
    }
  };
  var $$x15 = $m_s_util_hashing_MurmurHash3$();
  var $$x14 = acc;
  var x$6 = $m_Ljava_net_URI$().java$net$URI$$normalizeEscapes__sjs_js_$bar__sjs_js_$bar(this.Ljava_net_URI__f__path);
  acc = $$x15.mix__I__I__I($$x14, $m_sr_Statics$().anyHash__O__I(x$6));
  var $$x17 = $m_s_util_hashing_MurmurHash3$();
  var $$x16 = acc;
  var x$7 = $m_Ljava_net_URI$().java$net$URI$$normalizeEscapes__sjs_js_$bar__sjs_js_$bar(this.Ljava_net_URI__f__query);
  acc = $$x17.mix__I__I__I($$x16, $m_sr_Statics$().anyHash__O__I(x$7));
  var $$x19 = $m_s_util_hashing_MurmurHash3$();
  var $$x18 = acc;
  var x$8 = $m_Ljava_net_URI$().java$net$URI$$normalizeEscapes__sjs_js_$bar__sjs_js_$bar(this.Ljava_net_URI__f__fragment);
  acc = $$x19.mixLast__I__I__I($$x18, $m_sr_Statics$().anyHash__O__I(x$8));
  return $m_s_util_hashing_MurmurHash3$().finalizeHash__I__I__I(acc, 3)
});
$c_Ljava_net_URI.prototype.toString__T = (function() {
  return this.Ljava_net_URI__f_origStr
});
function $as_Ljava_net_URI(obj) {
  return (((obj instanceof $c_Ljava_net_URI) || (obj === null)) ? obj : $throwClassCastException(obj, "java.net.URI"))
}
function $isArrayOf_Ljava_net_URI(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_net_URI)))
}
function $asArrayOf_Ljava_net_URI(obj, depth) {
  return (($isArrayOf_Ljava_net_URI(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.net.URI;", depth))
}
var $d_Ljava_net_URI = new $TypeData().initClass({
  Ljava_net_URI: 0
}, false, "java.net.URI", {
  Ljava_net_URI: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1
});
$c_Ljava_net_URI.prototype.$classData = $d_Ljava_net_URI;
function $ct_Ljava_nio_ByteBuffer__I__AB__I__($thiz, _capacity, _array, _arrayOffset) {
  $thiz.Ljava_nio_ByteBuffer__f__array = _array;
  $thiz.Ljava_nio_ByteBuffer__f__arrayOffset = _arrayOffset;
  $ct_Ljava_nio_Buffer__I__($thiz, _capacity);
  $thiz.Ljava_nio_ByteBuffer__f__isBigEndian = true;
  return $thiz
}
/** @constructor */
function $c_Ljava_nio_ByteBuffer() {
  this.Ljava_nio_Buffer__f__capacity = 0;
  this.Ljava_nio_Buffer__f__limit = 0;
  this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position = 0;
  this.Ljava_nio_Buffer__f__mark = 0;
  this.Ljava_nio_ByteBuffer__f__array = null;
  this.Ljava_nio_ByteBuffer__f__arrayOffset = 0;
  this.Ljava_nio_ByteBuffer__f__isBigEndian = false
}
$c_Ljava_nio_ByteBuffer.prototype = new $h_Ljava_nio_Buffer();
$c_Ljava_nio_ByteBuffer.prototype.constructor = $c_Ljava_nio_ByteBuffer;
/** @constructor */
function $h_Ljava_nio_ByteBuffer() {
  /*<skip>*/
}
$h_Ljava_nio_ByteBuffer.prototype = $c_Ljava_nio_ByteBuffer.prototype;
$c_Ljava_nio_ByteBuffer.prototype.put__Ljava_nio_ByteBuffer__Ljava_nio_ByteBuffer = (function(src) {
  if ((src === this)) {
    throw $ct_jl_IllegalArgumentException__(new $c_jl_IllegalArgumentException())
  };
  if (this.Ljava_nio_HeapByteBuffer__f__readOnly) {
    throw new $c_Ljava_nio_ReadOnlyBufferException()
  };
  var srcLimit = src.Ljava_nio_Buffer__f__limit;
  var srcPos = src.Ljava_nio_Buffer__f_java$nio$Buffer$$_position;
  var length = ((srcLimit - srcPos) | 0);
  var p = this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position;
  var newPos = ((p + length) | 0);
  if ((newPos > this.Ljava_nio_Buffer__f__limit)) {
    throw new $c_Ljava_nio_BufferOverflowException()
  };
  this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position = newPos;
  var selfPos = p;
  $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(src, srcLimit);
  var srcArray = src.Ljava_nio_ByteBuffer__f__array;
  if ((srcArray !== null)) {
    var startIndex = selfPos;
    var offset = ((src.Ljava_nio_ByteBuffer__f__arrayOffset + srcPos) | 0);
    var dest = this.Ljava_nio_ByteBuffer__f__array;
    var destPos = ((this.Ljava_nio_ByteBuffer__f__arrayOffset + startIndex) | 0);
    $systemArraycopy(srcArray, offset, dest, destPos, length)
  } else {
    while ((srcPos !== srcLimit)) {
      var index$1 = selfPos;
      var index = srcPos;
      var elem = src.Ljava_nio_ByteBuffer__f__array.get(((src.Ljava_nio_ByteBuffer__f__arrayOffset + index) | 0));
      this.Ljava_nio_ByteBuffer__f__array.set(((this.Ljava_nio_ByteBuffer__f__arrayOffset + index$1) | 0), elem);
      srcPos = ((1 + srcPos) | 0);
      selfPos = ((1 + selfPos) | 0)
    }
  };
  return this
});
$c_Ljava_nio_ByteBuffer.prototype.hashCode__I = (function() {
  var start = this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position;
  var end = this.Ljava_nio_Buffer__f__limit;
  var h = (-547316498);
  var i = start;
  while ((i !== end)) {
    var $$x2 = $m_s_util_hashing_MurmurHash3$();
    var $$x1 = h;
    var index = i;
    var x = this.Ljava_nio_ByteBuffer__f__array.get(((this.Ljava_nio_ByteBuffer__f__arrayOffset + index) | 0));
    h = $$x2.mix__I__I__I($$x1, $m_sr_Statics$().anyHash__O__I(x));
    i = ((1 + i) | 0)
  };
  return $m_s_util_hashing_MurmurHash3$().finalizeHash__I__I__I(h, ((end - start) | 0))
});
$c_Ljava_nio_ByteBuffer.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_Ljava_nio_ByteBuffer)) {
    var x2 = $as_Ljava_nio_ByteBuffer(that);
    return (this.compareTo__Ljava_nio_ByteBuffer__I(x2) === 0)
  } else {
    return false
  }
});
$c_Ljava_nio_ByteBuffer.prototype.compareTo__Ljava_nio_ByteBuffer__I = (function(that) {
  if ((this === that)) {
    return 0
  } else {
    var thisStart = this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position;
    var thisRemaining = ((this.Ljava_nio_Buffer__f__limit - thisStart) | 0);
    var thatStart = that.Ljava_nio_Buffer__f_java$nio$Buffer$$_position;
    var thatRemaining = ((that.Ljava_nio_Buffer__f__limit - thatStart) | 0);
    var shortestLength = ((thisRemaining < thatRemaining) ? thisRemaining : thatRemaining);
    var i = 0;
    while ((i !== shortestLength)) {
      var index = ((thisStart + i) | 0);
      var arg1 = this.Ljava_nio_ByteBuffer__f__array.get(((this.Ljava_nio_ByteBuffer__f__arrayOffset + index) | 0));
      var index$1 = ((thatStart + i) | 0);
      var arg2 = that.Ljava_nio_ByteBuffer__f__array.get(((that.Ljava_nio_ByteBuffer__f__arrayOffset + index$1) | 0));
      var cmp = ((arg1 - arg2) | 0);
      if ((cmp !== 0)) {
        return cmp
      };
      i = ((1 + i) | 0)
    };
    return ((thisRemaining === thatRemaining) ? 0 : ((thisRemaining < thatRemaining) ? (-1) : 1))
  }
});
function $as_Ljava_nio_ByteBuffer(obj) {
  return (((obj instanceof $c_Ljava_nio_ByteBuffer) || (obj === null)) ? obj : $throwClassCastException(obj, "java.nio.ByteBuffer"))
}
function $isArrayOf_Ljava_nio_ByteBuffer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_nio_ByteBuffer)))
}
function $asArrayOf_Ljava_nio_ByteBuffer(obj, depth) {
  return (($isArrayOf_Ljava_nio_ByteBuffer(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.nio.ByteBuffer;", depth))
}
/** @constructor */
function $c_Ljava_nio_charset_UTF\uff3f8$() {
  this.Ljava_nio_charset_Charset__f_aliasesSet = null;
  this.Ljava_nio_charset_Charset__f_cachedDecoder = null;
  this.Ljava_nio_charset_Charset__f_cachedEncoder = null;
  this.Ljava_nio_charset_Charset__f_canonicalName = null;
  this.Ljava_nio_charset_Charset__f_java$nio$charset$Charset$$_aliases = null;
  this.Ljava_nio_charset_Charset__f_bitmap$0 = 0;
  this.Ljava_nio_charset_UTF\uff3f8$__f_java$nio$charset$UTF_8$$lengthByLeading = null;
  $ct_Ljava_nio_charset_Charset__T__AT__(this, "UTF-8", new ($d_T.getArrayOf().constr)(["UTF8", "unicode-1-1-utf-8"]));
  $n_Ljava_nio_charset_UTF\uff3f8$ = this;
  this.Ljava_nio_charset_UTF\uff3f8$__f_java$nio$charset$UTF_8$$lengthByLeading = new $ac_I([(-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 4, 4, 4, 4, 4, 4, 4, 4, (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1)])
}
$c_Ljava_nio_charset_UTF\uff3f8$.prototype = new $h_Ljava_nio_charset_Charset();
$c_Ljava_nio_charset_UTF\uff3f8$.prototype.constructor = $c_Ljava_nio_charset_UTF\uff3f8$;
/** @constructor */
function $h_Ljava_nio_charset_UTF\uff3f8$() {
  /*<skip>*/
}
$h_Ljava_nio_charset_UTF\uff3f8$.prototype = $c_Ljava_nio_charset_UTF\uff3f8$.prototype;
var $d_Ljava_nio_charset_UTF\uff3f8$ = new $TypeData().initClass({
  Ljava_nio_charset_UTF\uff3f8$: 0
}, false, "java.nio.charset.UTF_8$", {
  Ljava_nio_charset_UTF\uff3f8$: 1,
  Ljava_nio_charset_Charset: 1,
  O: 1,
  jl_Comparable: 1
});
$c_Ljava_nio_charset_UTF\uff3f8$.prototype.$classData = $d_Ljava_nio_charset_UTF\uff3f8$;
var $n_Ljava_nio_charset_UTF\uff3f8$;
function $m_Ljava_nio_charset_UTF\uff3f8$() {
  if ((!$n_Ljava_nio_charset_UTF\uff3f8$)) {
    $n_Ljava_nio_charset_UTF\uff3f8$ = new $c_Ljava_nio_charset_UTF\uff3f8$()
  };
  return $n_Ljava_nio_charset_UTF\uff3f8$
}
/** @constructor */
function $c_ju_AbstractCollection() {
  /*<skip>*/
}
$c_ju_AbstractCollection.prototype = new $h_O();
$c_ju_AbstractCollection.prototype.constructor = $c_ju_AbstractCollection;
/** @constructor */
function $h_ju_AbstractCollection() {
  /*<skip>*/
}
$h_ju_AbstractCollection.prototype = $c_ju_AbstractCollection.prototype;
$c_ju_AbstractCollection.prototype.containsAll__ju_Collection__Z = (function(c) {
  var _\uff3fself = c.iterator__ju_Iterator();
  _return: {
    while (_\uff3fself.hasNext__Z()) {
      var arg1 = _\uff3fself.next__O();
      if ((!this.contains__O__Z(arg1))) {
        var $$x1 = true;
        break _return
      }
    };
    var $$x1 = false
  };
  return (!$$x1)
});
$c_ju_AbstractCollection.prototype.toString__T = (function() {
  var _\uff3fself = this.iterator__ju_Iterator();
  var result = "[";
  var first = true;
  while (_\uff3fself.hasNext__Z()) {
    if (first) {
      first = false
    } else {
      result = (result + ", ")
    };
    result = (("" + result) + _\uff3fself.next__O())
  };
  return (result + "]")
});
/** @constructor */
function $c_ju_LinkedHashMap$Node(key, hash, value, previous, next, older, younger) {
  this.ju_HashMap$Node__f_key = null;
  this.ju_HashMap$Node__f_hash = 0;
  this.ju_HashMap$Node__f_value = null;
  this.ju_HashMap$Node__f_previous = null;
  this.ju_HashMap$Node__f_next = null;
  this.ju_LinkedHashMap$Node__f_older = null;
  this.ju_LinkedHashMap$Node__f_younger = null;
  this.ju_LinkedHashMap$Node__f_older = older;
  this.ju_LinkedHashMap$Node__f_younger = younger;
  $ct_ju_HashMap$Node__O__I__O__ju_HashMap$Node__ju_HashMap$Node__(this, key, hash, value, previous, next)
}
$c_ju_LinkedHashMap$Node.prototype = new $h_ju_HashMap$Node();
$c_ju_LinkedHashMap$Node.prototype.constructor = $c_ju_LinkedHashMap$Node;
/** @constructor */
function $h_ju_LinkedHashMap$Node() {
  /*<skip>*/
}
$h_ju_LinkedHashMap$Node.prototype = $c_ju_LinkedHashMap$Node.prototype;
function $as_ju_LinkedHashMap$Node(obj) {
  return (((obj instanceof $c_ju_LinkedHashMap$Node) || (obj === null)) ? obj : $throwClassCastException(obj, "java.util.LinkedHashMap$Node"))
}
function $isArrayOf_ju_LinkedHashMap$Node(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_LinkedHashMap$Node)))
}
function $asArrayOf_ju_LinkedHashMap$Node(obj, depth) {
  return (($isArrayOf_ju_LinkedHashMap$Node(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.util.LinkedHashMap$Node;", depth))
}
var $d_ju_LinkedHashMap$Node = new $TypeData().initClass({
  ju_LinkedHashMap$Node: 0
}, false, "java.util.LinkedHashMap$Node", {
  ju_LinkedHashMap$Node: 1,
  ju_HashMap$Node: 1,
  O: 1,
  ju_Map$Entry: 1
});
$c_ju_LinkedHashMap$Node.prototype.$classData = $d_ju_LinkedHashMap$Node;
/** @constructor */
function $c_ju_LinkedHashMap$NodeIterator(outer) {
  this.ju_LinkedHashMap$AbstractLinkedHashMapIterator__f_nextNode = null;
  this.ju_LinkedHashMap$AbstractLinkedHashMapIterator__f_lastNode = null;
  this.ju_LinkedHashMap$AbstractLinkedHashMapIterator__f_$outer = null;
  $ct_ju_LinkedHashMap$AbstractLinkedHashMapIterator__ju_LinkedHashMap__(this, outer)
}
$c_ju_LinkedHashMap$NodeIterator.prototype = new $h_ju_LinkedHashMap$AbstractLinkedHashMapIterator();
$c_ju_LinkedHashMap$NodeIterator.prototype.constructor = $c_ju_LinkedHashMap$NodeIterator;
/** @constructor */
function $h_ju_LinkedHashMap$NodeIterator() {
  /*<skip>*/
}
$h_ju_LinkedHashMap$NodeIterator.prototype = $c_ju_LinkedHashMap$NodeIterator.prototype;
var $d_ju_LinkedHashMap$NodeIterator = new $TypeData().initClass({
  ju_LinkedHashMap$NodeIterator: 0
}, false, "java.util.LinkedHashMap$NodeIterator", {
  ju_LinkedHashMap$NodeIterator: 1,
  ju_LinkedHashMap$AbstractLinkedHashMapIterator: 1,
  O: 1,
  ju_Iterator: 1
});
$c_ju_LinkedHashMap$NodeIterator.prototype.$classData = $d_ju_LinkedHashMap$NodeIterator;
/** @constructor */
function $c_ju_UUID(i1, i2, i3, i4, l1, l2) {
  this.ju_UUID__f_i1 = 0;
  this.ju_UUID__f_i2 = 0;
  this.ju_UUID__f_i3 = 0;
  this.ju_UUID__f_i4 = 0;
  this.ju_UUID__f_l1 = null;
  this.ju_UUID__f_l2 = null;
  this.ju_UUID__f_i1 = i1;
  this.ju_UUID__f_i2 = i2;
  this.ju_UUID__f_i3 = i3;
  this.ju_UUID__f_i4 = i4;
  this.ju_UUID__f_l1 = l1;
  this.ju_UUID__f_l2 = l2
}
$c_ju_UUID.prototype = new $h_O();
$c_ju_UUID.prototype.constructor = $c_ju_UUID;
/** @constructor */
function $h_ju_UUID() {
  /*<skip>*/
}
$h_ju_UUID.prototype = $c_ju_UUID.prototype;
$c_ju_UUID.prototype.toString__T = (function() {
  var i = this.ju_UUID__f_i1;
  var s = $as_T($uD((i >>> 0)).toString(16));
  var beginIndex = $uI(s.length);
  var $$x5 = $as_T("00000000".substring(beginIndex));
  var i$1 = ((this.ju_UUID__f_i2 >>> 16) | 0);
  var s$1 = $as_T($uD((i$1 >>> 0)).toString(16));
  var beginIndex$1 = $uI(s$1.length);
  var $$x4 = $as_T("0000".substring(beginIndex$1));
  var i$2 = (65535 & this.ju_UUID__f_i2);
  var s$2 = $as_T($uD((i$2 >>> 0)).toString(16));
  var beginIndex$2 = $uI(s$2.length);
  var $$x3 = $as_T("0000".substring(beginIndex$2));
  var i$3 = ((this.ju_UUID__f_i3 >>> 16) | 0);
  var s$3 = $as_T($uD((i$3 >>> 0)).toString(16));
  var beginIndex$3 = $uI(s$3.length);
  var $$x2 = $as_T("0000".substring(beginIndex$3));
  var i$4 = (65535 & this.ju_UUID__f_i3);
  var s$4 = $as_T($uD((i$4 >>> 0)).toString(16));
  var beginIndex$4 = $uI(s$4.length);
  var $$x1 = $as_T("0000".substring(beginIndex$4));
  var i$5 = this.ju_UUID__f_i4;
  var s$5 = $as_T($uD((i$5 >>> 0)).toString(16));
  var beginIndex$5 = $uI(s$5.length);
  return ((((((((((("" + $$x5) + s) + "-") + (("" + $$x4) + s$1)) + "-") + (("" + $$x3) + s$2)) + "-") + (("" + $$x2) + s$3)) + "-") + (("" + $$x1) + s$4)) + (("" + $as_T("00000000".substring(beginIndex$5))) + s$5))
});
$c_ju_UUID.prototype.hashCode__I = (function() {
  return (((this.ju_UUID__f_i1 ^ this.ju_UUID__f_i2) ^ this.ju_UUID__f_i3) ^ this.ju_UUID__f_i4)
});
$c_ju_UUID.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_ju_UUID)) {
    var x2 = $as_ju_UUID(that);
    return ((((this.ju_UUID__f_i1 === x2.ju_UUID__f_i1) && (this.ju_UUID__f_i2 === x2.ju_UUID__f_i2)) && (this.ju_UUID__f_i3 === x2.ju_UUID__f_i3)) && (this.ju_UUID__f_i4 === x2.ju_UUID__f_i4))
  } else {
    return false
  }
});
function $as_ju_UUID(obj) {
  return (((obj instanceof $c_ju_UUID) || (obj === null)) ? obj : $throwClassCastException(obj, "java.util.UUID"))
}
function $isArrayOf_ju_UUID(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_UUID)))
}
function $asArrayOf_ju_UUID(obj, depth) {
  return (($isArrayOf_ju_UUID(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.util.UUID;", depth))
}
var $d_ju_UUID = new $TypeData().initClass({
  ju_UUID: 0
}, false, "java.util.UUID", {
  ju_UUID: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1
});
$c_ju_UUID.prototype.$classData = $d_ju_UUID;
function $f_Lplay_api_libs_json_DefaultReads__$init$__V($thiz) {
  $m_Lplay_api_libs_json_Reads$();
  var f = new $c_sjsr_AnonFunction1((function(this$1) {
    return (function(js$2) {
      var js = $as_Lplay_api_libs_json_JsValue(js$2);
      if ((js instanceof $c_Lplay_api_libs_json_JsString)) {
        var x2 = $as_Lplay_api_libs_json_JsString(js);
        var s = x2.Lplay_api_libs_json_JsString__f_value;
        var $$x1 = $m_s_util_control_Exception$();
        var array = [$d_jl_NumberFormatException.getClassOf()];
        var this$5 = $$x1.catching__sci_Seq__s_util_control_Exception$Catch($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
        var this$6 = this$5.toOption__s_util_control_Exception$Catch();
        try {
          var this$7 = $m_s_package$().BigDecimal__s_math_BigDecimal$();
          var bd = $ct_Ljava_math_BigDecimal__T__(new $c_Ljava_math_BigDecimal(), s);
          var $$x2 = new $c_s_Some(new $c_Lplay_api_libs_json_JsSuccess(new $c_s_math_BigDecimal(bd, this$7.s_math_BigDecimal$__f_defaultMathContext), $ct_Lplay_api_libs_json_JsPath__sci_List__(new $c_Lplay_api_libs_json_JsPath(), ($m_Lplay_api_libs_json_JsPath$(), $m_sci_Nil$()))))
        } catch (e) {
          var e$2 = $m_sjsr_package$().wrapJavaScriptException__O__jl_Throwable(e);
          if ((e$2 !== null)) {
            if ($uZ(this$6.s_util_control_Exception$Catch__f_rethrow.apply__O__O(e$2))) {
              var $$x2;
              throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(e$2)
            } else if (this$6.s_util_control_Exception$Catch__f_pf.isDefinedAt__O__Z(e$2)) {
              var $$x2 = this$6.s_util_control_Exception$Catch__f_pf.apply__O__O(e$2)
            } else {
              var $$x2;
              throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(e$2)
            }
          } else {
            var $$x2;
            throw e
          }
        } finally {
          var this$10 = this$6.s_util_control_Exception$Catch__f_fin;
          if ((!this$10.isEmpty__Z())) {
            var arg1 = this$10.get__O();
            var x$1 = $as_s_util_control_Exception$Finally(arg1);
            x$1.invoke__V()
          }
        };
        var this$11 = $as_s_Option($$x2);
        if (this$11.isEmpty__Z()) {
          var $$x5 = $m_Lplay_api_libs_json_JsError$();
          var $$x4 = $m_Lplay_api_libs_json_JsonValidationError$();
          var array$1 = [];
          var $$x3 = $$x5.apply__Lplay_api_libs_json_JsonValidationError__Lplay_api_libs_json_JsError($$x4.apply__T__sci_Seq__Lplay_api_libs_json_JsonValidationError("error.expected.numberformatexception", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1)))
        } else {
          var $$x3 = this$11.get__O()
        };
        return $as_Lplay_api_libs_json_JsResult($$x3)
      } else if ((js instanceof $c_Lplay_api_libs_json_JsNumber)) {
        var x3 = $as_Lplay_api_libs_json_JsNumber(js);
        var d = x3.Lplay_api_libs_json_JsNumber__f_value;
        return new $c_Lplay_api_libs_json_JsSuccess($m_s_math_BigDecimal$().javaBigDecimal2bigDecimal__Ljava_math_BigDecimal__s_math_BigDecimal(d.s_math_BigDecimal__f_bigDecimal), $ct_Lplay_api_libs_json_JsPath__sci_List__(new $c_Lplay_api_libs_json_JsPath(), ($m_Lplay_api_libs_json_JsPath$(), $m_sci_Nil$())))
      } else {
        var $$x7 = $m_Lplay_api_libs_json_JsError$();
        var $$x6 = $m_Lplay_api_libs_json_JsonValidationError$();
        var array$2 = [];
        return $$x7.apply__Lplay_api_libs_json_JsonValidationError__Lplay_api_libs_json_JsError($$x6.apply__T__sci_Seq__Lplay_api_libs_json_JsonValidationError("error.expected.jsnumberorjsstring", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2)))
      }
    })
  })($thiz));
  $thiz.Lplay_api_libs_json_Reads$__f_bigDecReads = new $c_Lplay_api_libs_json_Reads$$anon$6(f);
  $m_Lplay_api_libs_json_Reads$();
  var f$1 = new $c_sjsr_AnonFunction1((function(this$2$1) {
    return (function(js$3$2) {
      var js$3 = $as_Lplay_api_libs_json_JsValue(js$3$2);
      if ((js$3 instanceof $c_Lplay_api_libs_json_JsString)) {
        var x2$1 = $as_Lplay_api_libs_json_JsString(js$3);
        var s$1 = x2$1.Lplay_api_libs_json_JsString__f_value;
        var $$x8 = $m_s_util_control_Exception$();
        var array$3 = [$d_jl_NumberFormatException.getClassOf()];
        var this$24 = $$x8.catching__sci_Seq__s_util_control_Exception$Catch($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3));
        var this$25 = this$24.toOption__s_util_control_Exception$Catch();
        try {
          var $$x9 = new $c_s_Some(new $c_Lplay_api_libs_json_JsSuccess($ct_Ljava_math_BigDecimal__T__(new $c_Ljava_math_BigDecimal(), s$1), $ct_Lplay_api_libs_json_JsPath__sci_List__(new $c_Lplay_api_libs_json_JsPath(), ($m_Lplay_api_libs_json_JsPath$(), $m_sci_Nil$()))))
        } catch (e$1) {
          var e$2$1 = $m_sjsr_package$().wrapJavaScriptException__O__jl_Throwable(e$1);
          if ((e$2$1 !== null)) {
            if ($uZ(this$25.s_util_control_Exception$Catch__f_rethrow.apply__O__O(e$2$1))) {
              var $$x9;
              throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(e$2$1)
            } else if (this$25.s_util_control_Exception$Catch__f_pf.isDefinedAt__O__Z(e$2$1)) {
              var $$x9 = this$25.s_util_control_Exception$Catch__f_pf.apply__O__O(e$2$1)
            } else {
              var $$x9;
              throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(e$2$1)
            }
          } else {
            var $$x9;
            throw e$1
          }
        } finally {
          var this$28 = this$25.s_util_control_Exception$Catch__f_fin;
          if ((!this$28.isEmpty__Z())) {
            var arg1$1 = this$28.get__O();
            var x$1$1 = $as_s_util_control_Exception$Finally(arg1$1);
            x$1$1.invoke__V()
          }
        };
        var this$29 = $as_s_Option($$x9);
        if (this$29.isEmpty__Z()) {
          var $$x12 = $m_Lplay_api_libs_json_JsError$();
          var $$x11 = $m_Lplay_api_libs_json_JsonValidationError$();
          var array$4 = [];
          var $$x10 = $$x12.apply__Lplay_api_libs_json_JsonValidationError__Lplay_api_libs_json_JsError($$x11.apply__T__sci_Seq__Lplay_api_libs_json_JsonValidationError("error.expected.numberformatexception", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4)))
        } else {
          var $$x10 = this$29.get__O()
        };
        return $as_Lplay_api_libs_json_JsResult($$x10)
      } else if ((js$3 instanceof $c_Lplay_api_libs_json_JsNumber)) {
        var x3$1 = $as_Lplay_api_libs_json_JsNumber(js$3);
        var d$1 = x3$1.Lplay_api_libs_json_JsNumber__f_value;
        return new $c_Lplay_api_libs_json_JsSuccess(d$1.s_math_BigDecimal__f_bigDecimal, $ct_Lplay_api_libs_json_JsPath__sci_List__(new $c_Lplay_api_libs_json_JsPath(), ($m_Lplay_api_libs_json_JsPath$(), $m_sci_Nil$())))
      } else {
        var $$x14 = $m_Lplay_api_libs_json_JsError$();
        var $$x13 = $m_Lplay_api_libs_json_JsonValidationError$();
        var array$5 = [];
        return $$x14.apply__Lplay_api_libs_json_JsonValidationError__Lplay_api_libs_json_JsError($$x13.apply__T__sci_Seq__Lplay_api_libs_json_JsonValidationError("error.expected.jsnumberorjsstring", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5)))
      }
    })
  })($thiz));
  $thiz.Lplay_api_libs_json_Reads$__f_javaBigDecReads = new $c_Lplay_api_libs_json_Reads$$anon$6(f$1);
  $m_Lplay_api_libs_json_Reads$();
  var f$2 = new $c_sjsr_AnonFunction1((function(this$3$1) {
    return (function(x$14$2) {
      var x$14 = $as_Lplay_api_libs_json_JsValue(x$14$2);
      var rds = this$3$1.StringReads__Lplay_api_libs_json_DefaultReads$StringReads$();
      return rds.reads__Lplay_api_libs_json_JsValue__Lplay_api_libs_json_JsResult(x$14).flatMap__F1__Lplay_api_libs_json_JsResult(new $c_sjsr_AnonFunction1((function(this$39) {
        return (function(repr$2) {
          var repr = $as_T(repr$2);
          var $$x16 = $m_Lplay_api_libs_json_JsResult$();
          try {
            var $$x15 = new $c_s_util_Success(new $c_Ljava_net_URI(repr))
          } catch (e$3) {
            var e$2$2 = $m_sjsr_package$().wrapJavaScriptException__O__jl_Throwable(e$3);
            if ((e$2$2 !== null)) {
              matchEnd8: {
                var $$x15;
                if ((e$2$2 !== null)) {
                  var o11 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2$2);
                  if ((!o11.isEmpty__Z())) {
                    var e$3$1 = $as_jl_Throwable(o11.get__O());
                    var $$x15 = new $c_s_util_Failure(e$3$1);
                    break matchEnd8
                  }
                };
                throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(e$2$2)
              }
            } else {
              var $$x15;
              throw e$3
            }
          };
          return $$x16.fromTry__s_util_Try__F1__Lplay_api_libs_json_JsResult($$x15, $m_Lplay_api_libs_json_JsResult$().fromTry$default$2__F1())
        })
      })(this$3$1)))
    })
  })($thiz));
  $thiz.Lplay_api_libs_json_Reads$__f_uriReads = new $c_Lplay_api_libs_json_Reads$$anon$6(f$2);
  $thiz.Lplay_api_libs_json_Reads$__f_uuidReads = new $c_Lplay_api_libs_json_DefaultReads$UUIDReader($thiz, false)
}
function $f_Lplay_api_libs_json_DefaultWrites__$init$__V($thiz) {
  $m_Lplay_api_libs_json_Writes$();
  var f = new $c_sjsr_AnonFunction1((function(this$1) {
    return (function(x$4$2) {
      $as_s_None$(x$4$2);
      return $m_Lplay_api_libs_json_JsNull$()
    })
  })($thiz));
  $thiz.Lplay_api_libs_json_Writes$__f_NoneWrites = new $c_Lplay_api_libs_json_Writes$$anon$6(f)
}
function $is_Lplay_api_libs_json_Format(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lplay_api_libs_json_Format)))
}
function $as_Lplay_api_libs_json_Format(obj) {
  return (($is_Lplay_api_libs_json_Format(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "play.api.libs.json.Format"))
}
function $isArrayOf_Lplay_api_libs_json_Format(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lplay_api_libs_json_Format)))
}
function $asArrayOf_Lplay_api_libs_json_Format(obj, depth) {
  return (($isArrayOf_Lplay_api_libs_json_Format(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lplay.api.libs.json.Format;", depth))
}
/** @constructor */
function $c_Lplay_api_libs_json_Format$$anon$5() {
  /*<skip>*/
}
$c_Lplay_api_libs_json_Format$$anon$5.prototype = new $h_O();
$c_Lplay_api_libs_json_Format$$anon$5.prototype.constructor = $c_Lplay_api_libs_json_Format$$anon$5;
/** @constructor */
function $h_Lplay_api_libs_json_Format$$anon$5() {
  /*<skip>*/
}
$h_Lplay_api_libs_json_Format$$anon$5.prototype = $c_Lplay_api_libs_json_Format$$anon$5.prototype;
$c_Lplay_api_libs_json_Format$$anon$5.prototype.inmap__Lplay_api_libs_json_Format__F1__F1__Lplay_api_libs_json_Format = (function(fa, f1, f2) {
  $m_Lplay_api_libs_json_Format$();
  var fjs = $f_Lplay_api_libs_json_Reads__map__F1__Lplay_api_libs_json_Reads(fa, f1);
  $m_Lplay_api_libs_json_Writes$();
  var f = new $c_sjsr_AnonFunction1((function(this$1, fa$1, f2$1) {
    return (function(b$2) {
      return fa$1.writes__O__Lplay_api_libs_json_JsValue(f2$1.apply__O__O(b$2))
    })
  })(this, fa, f2));
  var tjs = new $c_Lplay_api_libs_json_Writes$$anon$6(f);
  return new $c_Lplay_api_libs_json_Format$$anon$6(fjs, tjs)
});
$c_Lplay_api_libs_json_Format$$anon$5.prototype.inmap__O__F1__F1__O = (function(m, f1, f2) {
  return this.inmap__Lplay_api_libs_json_Format__F1__F1__Lplay_api_libs_json_Format($as_Lplay_api_libs_json_Format(m), f1, f2)
});
var $d_Lplay_api_libs_json_Format$$anon$5 = new $TypeData().initClass({
  Lplay_api_libs_json_Format$$anon$5: 0
}, false, "play.api.libs.json.Format$$anon$5", {
  Lplay_api_libs_json_Format$$anon$5: 1,
  O: 1,
  Lplay_api_libs_functional_InvariantFunctor: 1,
  Lplay_api_libs_functional_Variant: 1
});
$c_Lplay_api_libs_json_Format$$anon$5.prototype.$classData = $d_Lplay_api_libs_json_Format$$anon$5;
/** @constructor */
function $c_Lplay_api_libs_json_JsObject$() {
  /*<skip>*/
}
$c_Lplay_api_libs_json_JsObject$.prototype = new $h_O();
$c_Lplay_api_libs_json_JsObject$.prototype.constructor = $c_Lplay_api_libs_json_JsObject$;
/** @constructor */
function $h_Lplay_api_libs_json_JsObject$() {
  /*<skip>*/
}
$h_Lplay_api_libs_json_JsObject$.prototype = $c_Lplay_api_libs_json_JsObject$.prototype;
$c_Lplay_api_libs_json_JsObject$.prototype.toString__T = (function() {
  return "<function1>"
});
$c_Lplay_api_libs_json_JsObject$.prototype.createFieldsMap__sc_Iterable__scm_Map = (function(fields) {
  var this$1 = $as_scm_Growable($m_sc_JavaConverters$().mapAsScalaMapConverter__ju_Map__sc_JavaConverters$AsScala($ct_ju_LinkedHashMap__(new $c_ju_LinkedHashMap())).asScala__O());
  return $as_scm_Map(this$1.addAll__sc_IterableOnce__scm_Growable(fields))
});
$c_Lplay_api_libs_json_JsObject$.prototype.apply__sc_Seq__Lplay_api_libs_json_JsObject = (function(fields) {
  return new $c_Lplay_api_libs_json_JsObject(this.createFieldsMap__sc_Iterable__scm_Map(fields))
});
$c_Lplay_api_libs_json_JsObject$.prototype.apply__O__O = (function(v1) {
  return this.apply__sc_Seq__Lplay_api_libs_json_JsObject($as_sc_Seq(v1))
});
var $d_Lplay_api_libs_json_JsObject$ = new $TypeData().initClass({
  Lplay_api_libs_json_JsObject$: 0
}, false, "play.api.libs.json.JsObject$", {
  Lplay_api_libs_json_JsObject$: 1,
  O: 1,
  F1: 1,
  Ljava_io_Serializable: 1
});
$c_Lplay_api_libs_json_JsObject$.prototype.$classData = $d_Lplay_api_libs_json_JsObject$;
var $n_Lplay_api_libs_json_JsObject$;
function $m_Lplay_api_libs_json_JsObject$() {
  if ((!$n_Lplay_api_libs_json_JsObject$)) {
    $n_Lplay_api_libs_json_JsObject$ = new $c_Lplay_api_libs_json_JsObject$()
  };
  return $n_Lplay_api_libs_json_JsObject$
}
/** @constructor */
function $c_Lplay_api_libs_json_JsResult$$anon$2() {
  /*<skip>*/
}
$c_Lplay_api_libs_json_JsResult$$anon$2.prototype = new $h_O();
$c_Lplay_api_libs_json_JsResult$$anon$2.prototype.constructor = $c_Lplay_api_libs_json_JsResult$$anon$2;
/** @constructor */
function $h_Lplay_api_libs_json_JsResult$$anon$2() {
  /*<skip>*/
}
$h_Lplay_api_libs_json_JsResult$$anon$2.prototype = $c_Lplay_api_libs_json_JsResult$$anon$2.prototype;
$c_Lplay_api_libs_json_JsResult$$anon$2.prototype.apply__Lplay_api_libs_json_JsResult__Lplay_api_libs_json_JsResult__Lplay_api_libs_json_JsResult = (function(mf, ma) {
  var x1 = new $c_T2(mf, ma);
  var p2 = $as_Lplay_api_libs_json_JsResult(x1.T2__f__1);
  var p3 = $as_Lplay_api_libs_json_JsResult(x1.T2__f__2);
  if ((p2 instanceof $c_Lplay_api_libs_json_JsSuccess)) {
    var x4 = $as_Lplay_api_libs_json_JsSuccess(p2);
    var f = $as_F1(x4.Lplay_api_libs_json_JsSuccess__f_value);
    if ((p3 instanceof $c_Lplay_api_libs_json_JsSuccess)) {
      var x6 = $as_Lplay_api_libs_json_JsSuccess(p3);
      var a = x6.Lplay_api_libs_json_JsSuccess__f_value;
      return new $c_Lplay_api_libs_json_JsSuccess(f.apply__O__O(a), $ct_Lplay_api_libs_json_JsPath__sci_List__(new $c_Lplay_api_libs_json_JsPath(), ($m_Lplay_api_libs_json_JsPath$(), $m_sci_Nil$())))
    }
  };
  var p8 = $as_Lplay_api_libs_json_JsResult(x1.T2__f__1);
  var p9 = $as_Lplay_api_libs_json_JsResult(x1.T2__f__2);
  if ((p8 instanceof $c_Lplay_api_libs_json_JsError)) {
    var x10 = $as_Lplay_api_libs_json_JsError(p8);
    var e1 = x10.Lplay_api_libs_json_JsError__f_errors;
    if ((p9 instanceof $c_Lplay_api_libs_json_JsError)) {
      var x11 = $as_Lplay_api_libs_json_JsError(p9);
      var e2 = x11.Lplay_api_libs_json_JsError__f_errors;
      return new $c_Lplay_api_libs_json_JsError($m_Lplay_api_libs_json_JsError$().merge__sc_Seq__sc_Seq__sc_Seq(e1, e2))
    }
  };
  var p12 = $as_Lplay_api_libs_json_JsResult(x1.T2__f__1);
  if ((p12 instanceof $c_Lplay_api_libs_json_JsError)) {
    var x14 = $as_Lplay_api_libs_json_JsError(p12);
    var e = x14.Lplay_api_libs_json_JsError__f_errors;
    return new $c_Lplay_api_libs_json_JsError(e)
  };
  var p16 = $as_Lplay_api_libs_json_JsResult(x1.T2__f__2);
  if ((p16 instanceof $c_Lplay_api_libs_json_JsError)) {
    var x17 = $as_Lplay_api_libs_json_JsError(p16);
    var e$2 = x17.Lplay_api_libs_json_JsError__f_errors;
    return new $c_Lplay_api_libs_json_JsError(e$2)
  };
  throw new $c_s_MatchError(x1)
});
$c_Lplay_api_libs_json_JsResult$$anon$2.prototype.apply__O__O__O = (function(mf, ma) {
  return this.apply__Lplay_api_libs_json_JsResult__Lplay_api_libs_json_JsResult__Lplay_api_libs_json_JsResult($as_Lplay_api_libs_json_JsResult(mf), $as_Lplay_api_libs_json_JsResult(ma))
});
$c_Lplay_api_libs_json_JsResult$$anon$2.prototype.map__O__F1__O = (function(m, f) {
  var m$1 = $as_Lplay_api_libs_json_JsResult(m);
  return m$1.map__F1__Lplay_api_libs_json_JsResult(f)
});
var $d_Lplay_api_libs_json_JsResult$$anon$2 = new $TypeData().initClass({
  Lplay_api_libs_json_JsResult$$anon$2: 0
}, false, "play.api.libs.json.JsResult$$anon$2", {
  Lplay_api_libs_json_JsResult$$anon$2: 1,
  O: 1,
  Lplay_api_libs_functional_Applicative: 1,
  Lplay_api_libs_functional_DeprecatedApplicative: 1
});
$c_Lplay_api_libs_json_JsResult$$anon$2.prototype.$classData = $d_Lplay_api_libs_json_JsResult$$anon$2;
/** @constructor */
function $c_Lplay_api_libs_json_JsResult$$anon$3() {
  /*<skip>*/
}
$c_Lplay_api_libs_json_JsResult$$anon$3.prototype = new $h_O();
$c_Lplay_api_libs_json_JsResult$$anon$3.prototype.constructor = $c_Lplay_api_libs_json_JsResult$$anon$3;
/** @constructor */
function $h_Lplay_api_libs_json_JsResult$$anon$3() {
  /*<skip>*/
}
$h_Lplay_api_libs_json_JsResult$$anon$3.prototype = $c_Lplay_api_libs_json_JsResult$$anon$3.prototype;
var $d_Lplay_api_libs_json_JsResult$$anon$3 = new $TypeData().initClass({
  Lplay_api_libs_json_JsResult$$anon$3: 0
}, false, "play.api.libs.json.JsResult$$anon$3", {
  Lplay_api_libs_json_JsResult$$anon$3: 1,
  O: 1,
  Lplay_api_libs_functional_Functor: 1,
  Lplay_api_libs_functional_Variant: 1
});
$c_Lplay_api_libs_json_JsResult$$anon$3.prototype.$classData = $d_Lplay_api_libs_json_JsResult$$anon$3;
/** @constructor */
function $c_Lplay_api_libs_json_JsUndefined(err) {
  this.Lplay_api_libs_json_JsUndefined__f_err = null;
  this.Lplay_api_libs_json_JsUndefined__f_err = err
}
$c_Lplay_api_libs_json_JsUndefined.prototype = new $h_O();
$c_Lplay_api_libs_json_JsUndefined.prototype.constructor = $c_Lplay_api_libs_json_JsUndefined;
/** @constructor */
function $h_Lplay_api_libs_json_JsUndefined() {
  /*<skip>*/
}
$h_Lplay_api_libs_json_JsUndefined.prototype = $c_Lplay_api_libs_json_JsUndefined.prototype;
$c_Lplay_api_libs_json_JsUndefined.prototype.toString__T = (function() {
  return (("JsUndefined(" + this.Lplay_api_libs_json_JsUndefined__f_err.apply__O()) + ")")
});
function $as_Lplay_api_libs_json_JsUndefined(obj) {
  return (((obj instanceof $c_Lplay_api_libs_json_JsUndefined) || (obj === null)) ? obj : $throwClassCastException(obj, "play.api.libs.json.JsUndefined"))
}
function $isArrayOf_Lplay_api_libs_json_JsUndefined(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lplay_api_libs_json_JsUndefined)))
}
function $asArrayOf_Lplay_api_libs_json_JsUndefined(obj, depth) {
  return (($isArrayOf_Lplay_api_libs_json_JsUndefined(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lplay.api.libs.json.JsUndefined;", depth))
}
var $d_Lplay_api_libs_json_JsUndefined = new $TypeData().initClass({
  Lplay_api_libs_json_JsUndefined: 0
}, false, "play.api.libs.json.JsUndefined", {
  Lplay_api_libs_json_JsUndefined: 1,
  O: 1,
  Lplay_api_libs_json_JsLookupResult: 1,
  Lplay_api_libs_json_JsReadable: 1
});
$c_Lplay_api_libs_json_JsUndefined.prototype.$classData = $d_Lplay_api_libs_json_JsUndefined;
/** @constructor */
function $c_Lplay_api_libs_json_JsonNaming$Identity$() {
  this.Lplay_api_libs_json_JsonNaming$Identity$__f_toString = null;
  this.Lplay_api_libs_json_JsonNaming$Identity$__f_toString = "Identity"
}
$c_Lplay_api_libs_json_JsonNaming$Identity$.prototype = new $h_O();
$c_Lplay_api_libs_json_JsonNaming$Identity$.prototype.constructor = $c_Lplay_api_libs_json_JsonNaming$Identity$;
/** @constructor */
function $h_Lplay_api_libs_json_JsonNaming$Identity$() {
  /*<skip>*/
}
$h_Lplay_api_libs_json_JsonNaming$Identity$.prototype = $c_Lplay_api_libs_json_JsonNaming$Identity$.prototype;
$c_Lplay_api_libs_json_JsonNaming$Identity$.prototype.toString__T = (function() {
  return this.Lplay_api_libs_json_JsonNaming$Identity$__f_toString
});
$c_Lplay_api_libs_json_JsonNaming$Identity$.prototype.apply__O__O = (function(v1) {
  var property = $as_T(v1);
  return property
});
var $d_Lplay_api_libs_json_JsonNaming$Identity$ = new $TypeData().initClass({
  Lplay_api_libs_json_JsonNaming$Identity$: 0
}, false, "play.api.libs.json.JsonNaming$Identity$", {
  Lplay_api_libs_json_JsonNaming$Identity$: 1,
  O: 1,
  Lplay_api_libs_json_JsonNaming: 1,
  F1: 1
});
$c_Lplay_api_libs_json_JsonNaming$Identity$.prototype.$classData = $d_Lplay_api_libs_json_JsonNaming$Identity$;
var $n_Lplay_api_libs_json_JsonNaming$Identity$;
function $m_Lplay_api_libs_json_JsonNaming$Identity$() {
  if ((!$n_Lplay_api_libs_json_JsonNaming$Identity$)) {
    $n_Lplay_api_libs_json_JsonNaming$Identity$ = new $c_Lplay_api_libs_json_JsonNaming$Identity$()
  };
  return $n_Lplay_api_libs_json_JsonNaming$Identity$
}
/** @constructor */
function $c_Lplay_api_libs_json_OFormat$$anon$2() {
  /*<skip>*/
}
$c_Lplay_api_libs_json_OFormat$$anon$2.prototype = new $h_O();
$c_Lplay_api_libs_json_OFormat$$anon$2.prototype.constructor = $c_Lplay_api_libs_json_OFormat$$anon$2;
/** @constructor */
function $h_Lplay_api_libs_json_OFormat$$anon$2() {
  /*<skip>*/
}
$h_Lplay_api_libs_json_OFormat$$anon$2.prototype = $c_Lplay_api_libs_json_OFormat$$anon$2.prototype;
$c_Lplay_api_libs_json_OFormat$$anon$2.prototype.inmap__Lplay_api_libs_json_OFormat__F1__F1__Lplay_api_libs_json_OFormat = (function(fa, f1, f2) {
  $m_Lplay_api_libs_json_OFormat$();
  var read = new $c_sjsr_AnonFunction1((function(this$1, fa$1, f1$1) {
    return (function(js$2) {
      var js = $as_Lplay_api_libs_json_JsValue(js$2);
      return fa$1.reads__Lplay_api_libs_json_JsValue__Lplay_api_libs_json_JsResult(js).map__F1__Lplay_api_libs_json_JsResult(f1$1)
    })
  })(this, fa, f1));
  var write = new $c_sjsr_AnonFunction1((function(this$2, fa$2, f2$1) {
    return (function(b$2) {
      return fa$2.writes__O__Lplay_api_libs_json_JsObject(f2$1.apply__O__O(b$2))
    })
  })(this, fa, f2));
  return new $c_Lplay_api_libs_json_OFormat$$anon$3(read, write)
});
$c_Lplay_api_libs_json_OFormat$$anon$2.prototype.inmap__O__F1__F1__O = (function(m, f1, f2) {
  return this.inmap__Lplay_api_libs_json_OFormat__F1__F1__Lplay_api_libs_json_OFormat($as_Lplay_api_libs_json_OFormat(m), f1, f2)
});
var $d_Lplay_api_libs_json_OFormat$$anon$2 = new $TypeData().initClass({
  Lplay_api_libs_json_OFormat$$anon$2: 0
}, false, "play.api.libs.json.OFormat$$anon$2", {
  Lplay_api_libs_json_OFormat$$anon$2: 1,
  O: 1,
  Lplay_api_libs_functional_InvariantFunctor: 1,
  Lplay_api_libs_functional_Variant: 1
});
$c_Lplay_api_libs_json_OFormat$$anon$2.prototype.$classData = $d_Lplay_api_libs_json_OFormat$$anon$2;
/** @constructor */
function $c_Lplay_api_libs_json_OWrites$() {
  this.Lplay_api_libs_json_OWrites$__f_functionalCanBuildOWrites = null;
  this.Lplay_api_libs_json_OWrites$__f_contravariantfunctorOWrites = null;
  $n_Lplay_api_libs_json_OWrites$ = this;
  this.Lplay_api_libs_json_OWrites$__f_functionalCanBuildOWrites = new $c_Lplay_api_libs_json_OWrites$$anon$2();
  this.Lplay_api_libs_json_OWrites$__f_contravariantfunctorOWrites = new $c_Lplay_api_libs_json_OWrites$$anon$3()
}
$c_Lplay_api_libs_json_OWrites$.prototype = new $h_O();
$c_Lplay_api_libs_json_OWrites$.prototype.constructor = $c_Lplay_api_libs_json_OWrites$;
/** @constructor */
function $h_Lplay_api_libs_json_OWrites$() {
  /*<skip>*/
}
$h_Lplay_api_libs_json_OWrites$.prototype = $c_Lplay_api_libs_json_OWrites$.prototype;
var $d_Lplay_api_libs_json_OWrites$ = new $TypeData().initClass({
  Lplay_api_libs_json_OWrites$: 0
}, false, "play.api.libs.json.OWrites$", {
  Lplay_api_libs_json_OWrites$: 1,
  O: 1,
  Lplay_api_libs_json_PathWrites: 1,
  Lplay_api_libs_json_ConstraintWrites: 1
});
$c_Lplay_api_libs_json_OWrites$.prototype.$classData = $d_Lplay_api_libs_json_OWrites$;
var $n_Lplay_api_libs_json_OWrites$;
function $m_Lplay_api_libs_json_OWrites$() {
  if ((!$n_Lplay_api_libs_json_OWrites$)) {
    $n_Lplay_api_libs_json_OWrites$ = new $c_Lplay_api_libs_json_OWrites$()
  };
  return $n_Lplay_api_libs_json_OWrites$
}
/** @constructor */
function $c_Lplay_api_libs_json_OWrites$$anon$3() {
  /*<skip>*/
}
$c_Lplay_api_libs_json_OWrites$$anon$3.prototype = new $h_O();
$c_Lplay_api_libs_json_OWrites$$anon$3.prototype.constructor = $c_Lplay_api_libs_json_OWrites$$anon$3;
/** @constructor */
function $h_Lplay_api_libs_json_OWrites$$anon$3() {
  /*<skip>*/
}
$h_Lplay_api_libs_json_OWrites$$anon$3.prototype = $c_Lplay_api_libs_json_OWrites$$anon$3.prototype;
var $d_Lplay_api_libs_json_OWrites$$anon$3 = new $TypeData().initClass({
  Lplay_api_libs_json_OWrites$$anon$3: 0
}, false, "play.api.libs.json.OWrites$$anon$3", {
  Lplay_api_libs_json_OWrites$$anon$3: 1,
  O: 1,
  Lplay_api_libs_functional_ContravariantFunctor: 1,
  Lplay_api_libs_functional_Variant: 1
});
$c_Lplay_api_libs_json_OWrites$$anon$3.prototype.$classData = $d_Lplay_api_libs_json_OWrites$$anon$3;
/** @constructor */
function $c_Lplay_api_libs_json_OWrites$$anon$4(f$3) {
  this.Lplay_api_libs_json_OWrites$$anon$4__f_f$3 = null;
  this.Lplay_api_libs_json_OWrites$$anon$4__f_f$3 = f$3
}
$c_Lplay_api_libs_json_OWrites$$anon$4.prototype = new $h_O();
$c_Lplay_api_libs_json_OWrites$$anon$4.prototype.constructor = $c_Lplay_api_libs_json_OWrites$$anon$4;
/** @constructor */
function $h_Lplay_api_libs_json_OWrites$$anon$4() {
  /*<skip>*/
}
$h_Lplay_api_libs_json_OWrites$$anon$4.prototype = $c_Lplay_api_libs_json_OWrites$$anon$4.prototype;
$c_Lplay_api_libs_json_OWrites$$anon$4.prototype.writes__O__Lplay_api_libs_json_JsObject = (function(a) {
  return $as_Lplay_api_libs_json_JsObject(this.Lplay_api_libs_json_OWrites$$anon$4__f_f$3.apply__O__O(a))
});
$c_Lplay_api_libs_json_OWrites$$anon$4.prototype.contramap__F1__Lplay_api_libs_json_Writes = (function(f) {
  return $f_Lplay_api_libs_json_OWrites__contramap__F1__Lplay_api_libs_json_OWrites(this, f)
});
$c_Lplay_api_libs_json_OWrites$$anon$4.prototype.writes__O__Lplay_api_libs_json_JsValue = (function(o) {
  return this.writes__O__Lplay_api_libs_json_JsObject(o)
});
var $d_Lplay_api_libs_json_OWrites$$anon$4 = new $TypeData().initClass({
  Lplay_api_libs_json_OWrites$$anon$4: 0
}, false, "play.api.libs.json.OWrites$$anon$4", {
  Lplay_api_libs_json_OWrites$$anon$4: 1,
  O: 1,
  Lplay_api_libs_json_OWrites: 1,
  Lplay_api_libs_json_Writes: 1
});
$c_Lplay_api_libs_json_OWrites$$anon$4.prototype.$classData = $d_Lplay_api_libs_json_OWrites$$anon$4;
function $f_Lplay_api_libs_json_OWrites$OWritesFromFields__writes__O__Lplay_api_libs_json_JsObject($thiz, a) {
  var fieldsMap = $m_Lplay_api_libs_json_JsObject$().createFieldsMap__sc_Iterable__scm_Map($as_sc_Iterable($m_sc_Seq$().empty__sc_SeqOps()));
  $thiz.writeFields__scm_Map__Lplay_api_libs_functional_$tilde__V(fieldsMap, $as_Lplay_api_libs_functional_$tilde(a));
  return new $c_Lplay_api_libs_json_JsObject(fieldsMap)
}
function $is_Lplay_api_libs_json_OWrites$OWritesFromFields(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lplay_api_libs_json_OWrites$OWritesFromFields)))
}
function $as_Lplay_api_libs_json_OWrites$OWritesFromFields(obj) {
  return (($is_Lplay_api_libs_json_OWrites$OWritesFromFields(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "play.api.libs.json.OWrites$OWritesFromFields"))
}
function $isArrayOf_Lplay_api_libs_json_OWrites$OWritesFromFields(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lplay_api_libs_json_OWrites$OWritesFromFields)))
}
function $asArrayOf_Lplay_api_libs_json_OWrites$OWritesFromFields(obj, depth) {
  return (($isArrayOf_Lplay_api_libs_json_OWrites$OWritesFromFields(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lplay.api.libs.json.OWrites$OWritesFromFields;", depth))
}
/** @constructor */
function $c_Lplay_api_libs_json_Reads$$anon$1(applicativeJsResult$1) {
  this.Lplay_api_libs_json_Reads$$anon$1__f_applicativeJsResult$1 = null;
  this.Lplay_api_libs_json_Reads$$anon$1__f_applicativeJsResult$1 = applicativeJsResult$1
}
$c_Lplay_api_libs_json_Reads$$anon$1.prototype = new $h_O();
$c_Lplay_api_libs_json_Reads$$anon$1.prototype.constructor = $c_Lplay_api_libs_json_Reads$$anon$1;
/** @constructor */
function $h_Lplay_api_libs_json_Reads$$anon$1() {
  /*<skip>*/
}
$h_Lplay_api_libs_json_Reads$$anon$1.prototype = $c_Lplay_api_libs_json_Reads$$anon$1.prototype;
$c_Lplay_api_libs_json_Reads$$anon$1.prototype.apply__O__O__O = (function(mf, ma) {
  var mf$1 = $as_Lplay_api_libs_json_Reads(mf);
  var ma$1 = $as_Lplay_api_libs_json_Reads(ma);
  return new $c_Lplay_api_libs_json_Reads$$anon$1$$anon$2(this, mf$1, ma$1)
});
$c_Lplay_api_libs_json_Reads$$anon$1.prototype.map__O__F1__O = (function(m, f) {
  var m$1 = $as_Lplay_api_libs_json_Reads(m);
  return $f_Lplay_api_libs_json_Reads__map__F1__Lplay_api_libs_json_Reads(m$1, f)
});
var $d_Lplay_api_libs_json_Reads$$anon$1 = new $TypeData().initClass({
  Lplay_api_libs_json_Reads$$anon$1: 0
}, false, "play.api.libs.json.Reads$$anon$1", {
  Lplay_api_libs_json_Reads$$anon$1: 1,
  O: 1,
  Lplay_api_libs_functional_Applicative: 1,
  Lplay_api_libs_functional_DeprecatedApplicative: 1
});
$c_Lplay_api_libs_json_Reads$$anon$1.prototype.$classData = $d_Lplay_api_libs_json_Reads$$anon$1;
/** @constructor */
function $c_Lplay_api_libs_json_Writes$$anon$5() {
  /*<skip>*/
}
$c_Lplay_api_libs_json_Writes$$anon$5.prototype = new $h_O();
$c_Lplay_api_libs_json_Writes$$anon$5.prototype.constructor = $c_Lplay_api_libs_json_Writes$$anon$5;
/** @constructor */
function $h_Lplay_api_libs_json_Writes$$anon$5() {
  /*<skip>*/
}
$h_Lplay_api_libs_json_Writes$$anon$5.prototype = $c_Lplay_api_libs_json_Writes$$anon$5.prototype;
var $d_Lplay_api_libs_json_Writes$$anon$5 = new $TypeData().initClass({
  Lplay_api_libs_json_Writes$$anon$5: 0
}, false, "play.api.libs.json.Writes$$anon$5", {
  Lplay_api_libs_json_Writes$$anon$5: 1,
  O: 1,
  Lplay_api_libs_functional_ContravariantFunctor: 1,
  Lplay_api_libs_functional_Variant: 1
});
$c_Lplay_api_libs_json_Writes$$anon$5.prototype.$classData = $d_Lplay_api_libs_json_Writes$$anon$5;
/** @constructor */
function $c_s_$less$colon$less() {
  /*<skip>*/
}
$c_s_$less$colon$less.prototype = new $h_O();
$c_s_$less$colon$less.prototype.constructor = $c_s_$less$colon$less;
/** @constructor */
function $h_s_$less$colon$less() {
  /*<skip>*/
}
$h_s_$less$colon$less.prototype = $c_s_$less$colon$less.prototype;
/** @constructor */
function $c_s_Predef$() {
  this.s_Predef$__f_Map = null;
  this.s_Predef$__f_Set = null;
  this.s_Predef$__f_$minus$greater = null;
  this.s_Predef$__f_Manifest = null;
  this.s_Predef$__f_NoManifest = null;
  $n_s_Predef$ = this;
  $m_s_package$();
  $m_sci_List$();
  this.s_Predef$__f_Map = $m_sci_Map$();
  this.s_Predef$__f_Set = $m_sci_Set$();
  this.s_Predef$__f_$minus$greater = $m_T2$();
  this.s_Predef$__f_Manifest = $m_s_reflect_Manifest$();
  this.s_Predef$__f_NoManifest = $m_s_reflect_NoManifest$()
}
$c_s_Predef$.prototype = new $h_s_LowPriorityImplicits();
$c_s_Predef$.prototype.constructor = $c_s_Predef$;
/** @constructor */
function $h_s_Predef$() {
  /*<skip>*/
}
$h_s_Predef$.prototype = $c_s_Predef$.prototype;
$c_s_Predef$.prototype.require__Z__V = (function(requirement) {
  if ((!requirement)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "requirement failed")
  }
});
var $d_s_Predef$ = new $TypeData().initClass({
  s_Predef$: 0
}, false, "scala.Predef$", {
  s_Predef$: 1,
  s_LowPriorityImplicits: 1,
  s_LowPriorityImplicits2: 1,
  O: 1
});
$c_s_Predef$.prototype.$classData = $d_s_Predef$;
var $n_s_Predef$;
function $m_s_Predef$() {
  if ((!$n_s_Predef$)) {
    $n_s_Predef$ = new $c_s_Predef$()
  };
  return $n_s_Predef$
}
function $f_s_Product2__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz._1__O();
      break
    }
    case 1: {
      return $thiz._2__O();
      break
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 1)"))
    }
  }
}
function $f_s_Product3__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.T3__f__1;
      break
    }
    case 1: {
      return $thiz.T3__f__2;
      break
    }
    case 2: {
      return $thiz.T3__f__3;
      break
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 2)"))
    }
  }
}
/** @constructor */
function $c_sc_BuildFrom$() {
  this.sc_BuildFrom$__f_buildFromString = null;
  this.sc_BuildFrom$__f_buildFromWrappedString = null;
  $n_sc_BuildFrom$ = this;
  this.sc_BuildFrom$__f_buildFromString = new $c_sc_BuildFrom$$anon$5();
  this.sc_BuildFrom$__f_buildFromWrappedString = new $c_sc_BuildFrom$$anon$6()
}
$c_sc_BuildFrom$.prototype = new $h_O();
$c_sc_BuildFrom$.prototype.constructor = $c_sc_BuildFrom$;
/** @constructor */
function $h_sc_BuildFrom$() {
  /*<skip>*/
}
$h_sc_BuildFrom$.prototype = $c_sc_BuildFrom$.prototype;
var $d_sc_BuildFrom$ = new $TypeData().initClass({
  sc_BuildFrom$: 0
}, false, "scala.collection.BuildFrom$", {
  sc_BuildFrom$: 1,
  O: 1,
  sc_BuildFromLowPriority1: 1,
  sc_BuildFromLowPriority2: 1
});
$c_sc_BuildFrom$.prototype.$classData = $d_sc_BuildFrom$;
var $n_sc_BuildFrom$;
function $m_sc_BuildFrom$() {
  if ((!$n_sc_BuildFrom$)) {
    $n_sc_BuildFrom$ = new $c_sc_BuildFrom$()
  };
  return $n_sc_BuildFrom$
}
function $ct_sc_ClassTagIterableFactory$AnyIterableDelegate__sc_ClassTagIterableFactory__($thiz, delegate) {
  $thiz.sc_ClassTagIterableFactory$AnyIterableDelegate__f_delegate = delegate;
  return $thiz
}
/** @constructor */
function $c_sc_ClassTagIterableFactory$AnyIterableDelegate() {
  this.sc_ClassTagIterableFactory$AnyIterableDelegate__f_delegate = null
}
$c_sc_ClassTagIterableFactory$AnyIterableDelegate.prototype = new $h_O();
$c_sc_ClassTagIterableFactory$AnyIterableDelegate.prototype.constructor = $c_sc_ClassTagIterableFactory$AnyIterableDelegate;
/** @constructor */
function $h_sc_ClassTagIterableFactory$AnyIterableDelegate() {
  /*<skip>*/
}
$h_sc_ClassTagIterableFactory$AnyIterableDelegate.prototype = $c_sc_ClassTagIterableFactory$AnyIterableDelegate.prototype;
$c_sc_ClassTagIterableFactory$AnyIterableDelegate.prototype.empty__O = (function() {
  var this$3 = this.sc_ClassTagIterableFactory$AnyIterableDelegate__f_delegate;
  $m_s_reflect_ManifestFactory$AnyManifest$();
  return this$3.scm_ArraySeq$__f_EmptyArraySeq
});
$c_sc_ClassTagIterableFactory$AnyIterableDelegate.prototype.from__sc_IterableOnce__O = (function(it) {
  var this$3 = this.sc_ClassTagIterableFactory$AnyIterableDelegate__f_delegate;
  $m_s_reflect_ManifestFactory$AnyManifest$();
  var n = it.knownSize__I();
  if ((n > (-1))) {
    var elements = new $ac_O(n);
    var iterator = it.iterator__sc_Iterator();
    var i = 0;
    while ((i < n)) {
      elements.set(i, iterator.next__O());
      i = ((1 + i) | 0)
    };
    var $$x1 = elements
  } else {
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    capacity = 0;
    size = 0;
    jsElems = [];
    var iterator$2 = it.iterator__sc_Iterator();
    while (iterator$2.hasNext__Z()) {
      var elem = iterator$2.next__O();
      var unboxedElem = ((elem === null) ? null : elem);
      jsElems.push(unboxedElem)
    };
    var $$x1 = new $ac_O(jsElems)
  };
  return this$3.make__O__scm_ArraySeq($$x1)
});
$c_sc_ClassTagIterableFactory$AnyIterableDelegate.prototype.newBuilder__scm_Builder = (function() {
  var this$3 = this.sc_ClassTagIterableFactory$AnyIterableDelegate__f_delegate;
  $m_s_reflect_ManifestFactory$AnyManifest$();
  var this$7 = new $c_scm_ArrayBuilder$generic($d_O.getClassOf());
  var f = new $c_sjsr_AnonFunction1((function(this$6) {
    return (function(x$2) {
      return $m_scm_ArraySeq$().make__O__scm_ArraySeq(x$2)
    })
  })(this$3));
  return new $c_scm_Builder$$anon$1(this$7, f)
});
$c_sc_ClassTagIterableFactory$AnyIterableDelegate.prototype.apply__sci_Seq__O = (function(elems) {
  var this$3 = this.sc_ClassTagIterableFactory$AnyIterableDelegate__f_delegate;
  $m_s_reflect_ManifestFactory$AnyManifest$();
  var n = elems.knownSize__I();
  if ((n > (-1))) {
    var elements = new $ac_O(n);
    var iterator = elems.iterator__sc_Iterator();
    var i = 0;
    while ((i < n)) {
      elements.set(i, iterator.next__O());
      i = ((1 + i) | 0)
    };
    var $$x1 = elements
  } else {
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    capacity = 0;
    size = 0;
    jsElems = [];
    var iterator$2 = elems.iterator__sc_Iterator();
    while (iterator$2.hasNext__Z()) {
      var elem = iterator$2.next__O();
      var unboxedElem = ((elem === null) ? null : elem);
      jsElems.push(unboxedElem)
    };
    var $$x1 = new $ac_O(jsElems)
  };
  return this$3.make__O__scm_ArraySeq($$x1)
});
/** @constructor */
function $c_sc_Factory$StringFactory() {
  /*<skip>*/
}
$c_sc_Factory$StringFactory.prototype = new $h_O();
$c_sc_Factory$StringFactory.prototype.constructor = $c_sc_Factory$StringFactory;
/** @constructor */
function $h_sc_Factory$StringFactory() {
  /*<skip>*/
}
$h_sc_Factory$StringFactory.prototype = $c_sc_Factory$StringFactory.prototype;
$c_sc_Factory$StringFactory.prototype.newBuilder__scm_Builder = (function() {
  return $ct_scm_StringBuilder__(new $c_scm_StringBuilder())
});
var $d_sc_Factory$StringFactory = new $TypeData().initClass({
  sc_Factory$StringFactory: 0
}, false, "scala.collection.Factory$StringFactory", {
  sc_Factory$StringFactory: 1,
  O: 1,
  sc_Factory: 1,
  Ljava_io_Serializable: 1
});
$c_sc_Factory$StringFactory.prototype.$classData = $d_sc_Factory$StringFactory;
function $ct_sc_IterableFactory$Delegate__sc_IterableFactory__($thiz, delegate) {
  $thiz.sc_IterableFactory$Delegate__f_delegate = delegate;
  return $thiz
}
/** @constructor */
function $c_sc_IterableFactory$Delegate() {
  this.sc_IterableFactory$Delegate__f_delegate = null
}
$c_sc_IterableFactory$Delegate.prototype = new $h_O();
$c_sc_IterableFactory$Delegate.prototype.constructor = $c_sc_IterableFactory$Delegate;
/** @constructor */
function $h_sc_IterableFactory$Delegate() {
  /*<skip>*/
}
$h_sc_IterableFactory$Delegate.prototype = $c_sc_IterableFactory$Delegate.prototype;
$c_sc_IterableFactory$Delegate.prototype.from__sc_IterableOnce__O = (function(it) {
  return this.sc_IterableFactory$Delegate__f_delegate.from__sc_IterableOnce__O(it)
});
$c_sc_IterableFactory$Delegate.prototype.newBuilder__scm_Builder = (function() {
  return this.sc_IterableFactory$Delegate__f_delegate.newBuilder__scm_Builder()
});
function $f_sc_IterableOps__sizeCompare__I__I($thiz, otherSize) {
  if ((otherSize < 0)) {
    return 1
  } else {
    var known = $thiz.knownSize__I();
    if ((known >= 0)) {
      return ((known === otherSize) ? 0 : ((known < otherSize) ? (-1) : 1))
    } else {
      var i = 0;
      var it = $thiz.iterator__sc_Iterator();
      while (it.hasNext__Z()) {
        if ((i === otherSize)) {
          return 1
        };
        it.next__O();
        i = ((1 + i) | 0)
      };
      return ((i - otherSize) | 0)
    }
  }
}
function $f_sc_IterableOps__drop__I__O($thiz, n) {
  return $thiz.fromSpecific__sc_IterableOnce__O($ct_sc_View$Drop__sc_IterableOps__I__(new $c_sc_View$Drop(), $thiz, n))
}
function $f_sc_IterableOps__tail__O($thiz) {
  if ($thiz.isEmpty__Z()) {
    throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException())
  };
  return $thiz.drop__I__O(1)
}
function $f_sc_IterableOps__map__F1__O($thiz, f) {
  return $thiz.iterableFactory__sc_IterableFactory().from__sc_IterableOnce__O($ct_sc_View$Map__sc_IterableOps__F1__(new $c_sc_View$Map(), $thiz, f))
}
function $f_sc_IterableOps__flatMap__F1__O($thiz, f) {
  return $thiz.iterableFactory__sc_IterableFactory().from__sc_IterableOnce__O(new $c_sc_View$FlatMap($thiz, f))
}
function $f_sc_IterableOps__concat__sc_IterableOnce__O($thiz, suffix) {
  var $$x2 = $thiz.iterableFactory__sc_IterableFactory();
  if ($is_sc_Iterable(suffix)) {
    var x2 = $as_sc_Iterable(suffix);
    var $$x1 = new $c_sc_View$Concat($thiz, x2)
  } else {
    var this$2 = $thiz.iterator__sc_Iterator();
    var xs = new $c_sjsr_AnonFunction0((function(this$1, suffix$1) {
      return (function() {
        return suffix$1.iterator__sc_Iterator()
      })
    })($thiz, suffix));
    var $$x1 = this$2.concat__F0__sc_Iterator(xs)
  };
  return $$x2.from__sc_IterableOnce__O($$x1)
}
function $f_sc_IterableOps__zipWithIndex__O($thiz) {
  return $thiz.iterableFactory__sc_IterableFactory().from__sc_IterableOnce__O(new $c_sc_View$ZipWithIndex($thiz))
}
function $is_sc_IterableOps(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_IterableOps)))
}
function $as_sc_IterableOps(obj) {
  return (($is_sc_IterableOps(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.IterableOps"))
}
function $isArrayOf_sc_IterableOps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_IterableOps)))
}
function $asArrayOf_sc_IterableOps(obj, depth) {
  return (($isArrayOf_sc_IterableOps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.IterableOps;", depth))
}
function $f_sc_Iterator__indexWhere__F1__I__I($thiz, p, from) {
  var i = ((from > 0) ? from : 0);
  $thiz.drop__I__sc_Iterator(from);
  while ($thiz.hasNext__Z()) {
    if ($uZ(p.apply__O__O($thiz.next__O()))) {
      return i
    };
    i = ((1 + i) | 0)
  };
  return (-1)
}
function $f_sc_Iterator__concat__F0__sc_Iterator($thiz, xs) {
  return new $c_sc_Iterator$ConcatIterator($thiz).concat__F0__sc_Iterator(xs)
}
function $f_sc_Iterator__drop__I__sc_Iterator($thiz, n) {
  var i = 0;
  while (((i < n) && $thiz.hasNext__Z())) {
    $thiz.next__O();
    i = ((1 + i) | 0)
  };
  return $thiz
}
function $f_sc_Iterator__sameElements__sc_IterableOnce__Z($thiz, that) {
  var those = that.iterator__sc_Iterator();
  while (($thiz.hasNext__Z() && those.hasNext__Z())) {
    if ((!$m_sr_BoxesRunTime$().equals__O__O__Z($thiz.next__O(), those.next__O()))) {
      return false
    }
  };
  return ($thiz.hasNext__Z() === those.hasNext__Z())
}
function $is_sc_Iterator(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_Iterator)))
}
function $as_sc_Iterator(obj) {
  return (($is_sc_Iterator(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.Iterator"))
}
function $isArrayOf_sc_Iterator(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_Iterator)))
}
function $asArrayOf_sc_Iterator(obj, depth) {
  return (($isArrayOf_sc_Iterator(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.Iterator;", depth))
}
/** @constructor */
function $c_sc_Iterator$() {
  this.sc_Iterator$__f_scala$collection$Iterator$$_empty = null;
  $n_sc_Iterator$ = this;
  this.sc_Iterator$__f_scala$collection$Iterator$$_empty = new $c_sc_Iterator$$anon$19()
}
$c_sc_Iterator$.prototype = new $h_O();
$c_sc_Iterator$.prototype.constructor = $c_sc_Iterator$;
/** @constructor */
function $h_sc_Iterator$() {
  /*<skip>*/
}
$h_sc_Iterator$.prototype = $c_sc_Iterator$.prototype;
$c_sc_Iterator$.prototype.newBuilder__scm_Builder = (function() {
  return new $c_sc_Iterator$$anon$21()
});
$c_sc_Iterator$.prototype.from__sc_IterableOnce__O = (function(source) {
  return source.iterator__sc_Iterator()
});
var $d_sc_Iterator$ = new $TypeData().initClass({
  sc_Iterator$: 0
}, false, "scala.collection.Iterator$", {
  sc_Iterator$: 1,
  O: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sc_Iterator$.prototype.$classData = $d_sc_Iterator$;
var $n_sc_Iterator$;
function $m_sc_Iterator$() {
  if ((!$n_sc_Iterator$)) {
    $n_sc_Iterator$ = new $c_sc_Iterator$()
  };
  return $n_sc_Iterator$
}
/** @constructor */
function $c_sc_JavaConverters$() {
  /*<skip>*/
}
$c_sc_JavaConverters$.prototype = new $h_O();
$c_sc_JavaConverters$.prototype.constructor = $c_sc_JavaConverters$;
/** @constructor */
function $h_sc_JavaConverters$() {
  /*<skip>*/
}
$h_sc_JavaConverters$.prototype = $c_sc_JavaConverters$.prototype;
$c_sc_JavaConverters$.prototype.mapAsScalaMapConverter__ju_Map__sc_JavaConverters$AsScala = (function(m) {
  return new $c_sc_JavaConverters$AsScala(new $c_sjsr_AnonFunction0((function(this$1, m$1) {
    return (function() {
      var this$2 = $m_sc_JavaConverters$();
      return $f_sc_convert_AsScalaConverters__asScala__ju_Map__scm_Map(this$2, m$1)
    })
  })(this, m)))
});
var $d_sc_JavaConverters$ = new $TypeData().initClass({
  sc_JavaConverters$: 0
}, false, "scala.collection.JavaConverters$", {
  sc_JavaConverters$: 1,
  O: 1,
  sc_convert_AsJavaConverters: 1,
  sc_convert_AsScalaConverters: 1
});
$c_sc_JavaConverters$.prototype.$classData = $d_sc_JavaConverters$;
var $n_sc_JavaConverters$;
function $m_sc_JavaConverters$() {
  if ((!$n_sc_JavaConverters$)) {
    $n_sc_JavaConverters$ = new $c_sc_JavaConverters$()
  };
  return $n_sc_JavaConverters$
}
function $ct_sc_MapFactory$Delegate__sc_MapFactory__($thiz, delegate) {
  $thiz.sc_MapFactory$Delegate__f_delegate = delegate;
  return $thiz
}
/** @constructor */
function $c_sc_MapFactory$Delegate() {
  this.sc_MapFactory$Delegate__f_delegate = null
}
$c_sc_MapFactory$Delegate.prototype = new $h_O();
$c_sc_MapFactory$Delegate.prototype.constructor = $c_sc_MapFactory$Delegate;
/** @constructor */
function $h_sc_MapFactory$Delegate() {
  /*<skip>*/
}
$h_sc_MapFactory$Delegate.prototype = $c_sc_MapFactory$Delegate.prototype;
$c_sc_MapFactory$Delegate.prototype.from__sc_IterableOnce__O = (function(it) {
  return this.sc_MapFactory$Delegate__f_delegate.from__sc_IterableOnce__O(it)
});
$c_sc_MapFactory$Delegate.prototype.empty__O = (function() {
  return this.sc_MapFactory$Delegate__f_delegate.empty__O()
});
$c_sc_MapFactory$Delegate.prototype.newBuilder__scm_Builder = (function() {
  return this.sc_MapFactory$Delegate__f_delegate.newBuilder__scm_Builder()
});
/** @constructor */
function $c_sc_View$() {
  /*<skip>*/
}
$c_sc_View$.prototype = new $h_O();
$c_sc_View$.prototype.constructor = $c_sc_View$;
/** @constructor */
function $h_sc_View$() {
  /*<skip>*/
}
$h_sc_View$.prototype = $c_sc_View$.prototype;
$c_sc_View$.prototype.from__sc_IterableOnce__sc_View = (function(it) {
  if ($is_sc_View(it)) {
    var x2 = $as_sc_View(it);
    return x2
  } else if ($is_sc_Iterable(it)) {
    var x3 = $as_sc_Iterable(it);
    var it$1 = new $c_sjsr_AnonFunction0((function(this$1, x3$1) {
      return (function() {
        return x3$1.iterator__sc_Iterator()
      })
    })(this, x3));
    return new $c_sc_View$$anon$1(it$1)
  } else {
    var this$3 = $m_sci_LazyList$().from__sc_IterableOnce__sci_LazyList(it);
    return $ct_sc_SeqView$Id__sc_SeqOps__(new $c_sc_SeqView$Id(), this$3)
  }
});
$c_sc_View$.prototype.newBuilder__scm_Builder = (function() {
  var this$3 = new $c_scm_ArrayBuffer$$anon$1();
  var f = new $c_sjsr_AnonFunction1((function(this$2) {
    return (function(it$2) {
      var it = $as_sc_IterableOnce(it$2);
      return $m_sc_View$().from__sc_IterableOnce__sc_View(it)
    })
  })(this));
  return new $c_scm_Builder$$anon$1(this$3, f)
});
$c_sc_View$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__sc_View(source)
});
var $d_sc_View$ = new $TypeData().initClass({
  sc_View$: 0
}, false, "scala.collection.View$", {
  sc_View$: 1,
  O: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sc_View$.prototype.$classData = $d_sc_View$;
var $n_sc_View$;
function $m_sc_View$() {
  if ((!$n_sc_View$)) {
    $n_sc_View$ = new $c_sc_View$()
  };
  return $n_sc_View$
}
/** @constructor */
function $c_sci_BitmapIndexedMapNode(dataMap, nodeMap, content, originalHashes, size, cachedJavaKeySetHashCode) {
  this.sci_BitmapIndexedMapNode__f_dataMap = 0;
  this.sci_BitmapIndexedMapNode__f_nodeMap = 0;
  this.sci_BitmapIndexedMapNode__f_content = null;
  this.sci_BitmapIndexedMapNode__f_originalHashes = null;
  this.sci_BitmapIndexedMapNode__f_size = 0;
  this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode = 0;
  this.sci_BitmapIndexedMapNode__f_dataMap = dataMap;
  this.sci_BitmapIndexedMapNode__f_nodeMap = nodeMap;
  this.sci_BitmapIndexedMapNode__f_content = content;
  this.sci_BitmapIndexedMapNode__f_originalHashes = originalHashes;
  this.sci_BitmapIndexedMapNode__f_size = size;
  this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode = cachedJavaKeySetHashCode
}
$c_sci_BitmapIndexedMapNode.prototype = new $h_sci_MapNode();
$c_sci_BitmapIndexedMapNode.prototype.constructor = $c_sci_BitmapIndexedMapNode;
/** @constructor */
function $h_sci_BitmapIndexedMapNode() {
  /*<skip>*/
}
$h_sci_BitmapIndexedMapNode.prototype = $c_sci_BitmapIndexedMapNode.prototype;
$c_sci_BitmapIndexedMapNode.prototype.size__I = (function() {
  return this.sci_BitmapIndexedMapNode__f_size
});
$c_sci_BitmapIndexedMapNode.prototype.cachedJavaKeySetHashCode__I = (function() {
  return this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode
});
$c_sci_BitmapIndexedMapNode.prototype.getKey__I__O = (function(index) {
  return this.sci_BitmapIndexedMapNode__f_content.get((index << 1))
});
$c_sci_BitmapIndexedMapNode.prototype.getValue__I__O = (function(index) {
  return this.sci_BitmapIndexedMapNode__f_content.get(((1 + (index << 1)) | 0))
});
$c_sci_BitmapIndexedMapNode.prototype.getPayload__I__T2 = (function(index) {
  return new $c_T2(this.sci_BitmapIndexedMapNode__f_content.get((index << 1)), this.sci_BitmapIndexedMapNode__f_content.get(((1 + (index << 1)) | 0)))
});
$c_sci_BitmapIndexedMapNode.prototype.getHash__I__I = (function(index) {
  return this.sci_BitmapIndexedMapNode__f_originalHashes.get(index)
});
$c_sci_BitmapIndexedMapNode.prototype.getNode__I__sci_MapNode = (function(index) {
  return $as_sci_MapNode(this.sci_BitmapIndexedMapNode__f_content.get((((((-1) + this.sci_BitmapIndexedMapNode__f_content.u.length) | 0) - index) | 0)))
});
$c_sci_BitmapIndexedMapNode.prototype.apply__O__I__I__I__O = (function(key, originalHash, keyHash, shift) {
  var mask = $m_sci_Node$().maskFrom__I__I__I(keyHash, shift);
  var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
  if (((this.sci_BitmapIndexedMapNode__f_dataMap & bitpos) !== 0)) {
    var index = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_dataMap, mask, bitpos);
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.getKey__I__O(index))) {
      return this.getValue__I__O(index)
    } else {
      throw $ct_ju_NoSuchElementException__(new $c_ju_NoSuchElementException())
    }
  } else if (((this.sci_BitmapIndexedMapNode__f_nodeMap & bitpos) !== 0)) {
    return this.getNode__I__sci_MapNode($m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_nodeMap, mask, bitpos)).apply__O__I__I__I__O(key, originalHash, keyHash, ((5 + shift) | 0))
  } else {
    throw $ct_ju_NoSuchElementException__(new $c_ju_NoSuchElementException())
  }
});
$c_sci_BitmapIndexedMapNode.prototype.get__O__I__I__I__s_Option = (function(key, originalHash, keyHash, shift) {
  var mask = $m_sci_Node$().maskFrom__I__I__I(keyHash, shift);
  var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
  if (((this.sci_BitmapIndexedMapNode__f_dataMap & bitpos) !== 0)) {
    var index = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_dataMap, mask, bitpos);
    var key0 = this.getKey__I__O(index);
    return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, key0) ? new $c_s_Some(this.getValue__I__O(index)) : $m_s_None$())
  } else if (((this.sci_BitmapIndexedMapNode__f_nodeMap & bitpos) !== 0)) {
    var index$2 = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_nodeMap, mask, bitpos);
    return this.getNode__I__sci_MapNode(index$2).get__O__I__I__I__s_Option(key, originalHash, keyHash, ((5 + shift) | 0))
  } else {
    return $m_s_None$()
  }
});
$c_sci_BitmapIndexedMapNode.prototype.getOrElse__O__I__I__I__F0__O = (function(key, originalHash, keyHash, shift, f) {
  var mask = $m_sci_Node$().maskFrom__I__I__I(keyHash, shift);
  var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
  if (((this.sci_BitmapIndexedMapNode__f_dataMap & bitpos) !== 0)) {
    var index = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_dataMap, mask, bitpos);
    var key0 = this.getKey__I__O(index);
    return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, key0) ? this.getValue__I__O(index) : f.apply__O())
  } else if (((this.sci_BitmapIndexedMapNode__f_nodeMap & bitpos) !== 0)) {
    var index$2 = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_nodeMap, mask, bitpos);
    return this.getNode__I__sci_MapNode(index$2).getOrElse__O__I__I__I__F0__O(key, originalHash, keyHash, ((5 + shift) | 0), f)
  } else {
    return f.apply__O()
  }
});
$c_sci_BitmapIndexedMapNode.prototype.containsKey__O__I__I__I__Z = (function(key, originalHash, keyHash, shift) {
  var mask = $m_sci_Node$().maskFrom__I__I__I(keyHash, shift);
  var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
  if (((this.sci_BitmapIndexedMapNode__f_dataMap & bitpos) !== 0)) {
    var index = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_dataMap, mask, bitpos);
    return ((this.sci_BitmapIndexedMapNode__f_originalHashes.get(index) === originalHash) && $m_sr_BoxesRunTime$().equals__O__O__Z(key, this.getKey__I__O(index)))
  } else {
    return (((this.sci_BitmapIndexedMapNode__f_nodeMap & bitpos) !== 0) && this.getNode__I__sci_MapNode($m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_nodeMap, mask, bitpos)).containsKey__O__I__I__I__Z(key, originalHash, keyHash, ((5 + shift) | 0)))
  }
});
$c_sci_BitmapIndexedMapNode.prototype.updated__O__O__I__I__I__Z__sci_BitmapIndexedMapNode = (function(key, value, originalHash, keyHash, shift, replaceValue) {
  var mask = $m_sci_Node$().maskFrom__I__I__I(keyHash, shift);
  var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
  if (((this.sci_BitmapIndexedMapNode__f_dataMap & bitpos) !== 0)) {
    var index = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_dataMap, mask, bitpos);
    var key0 = this.getKey__I__O(index);
    var key0UnimprovedHash = this.getHash__I__I(index);
    if (((key0UnimprovedHash === originalHash) && $m_sr_BoxesRunTime$().equals__O__O__Z(key0, key))) {
      if (replaceValue) {
        var value0 = this.getValue__I__O(index);
        return (($is(key0, key) && $is(value0, value)) ? this : this.copyAndSetValue__I__O__O__sci_BitmapIndexedMapNode(bitpos, key, value))
      } else {
        return this
      }
    } else {
      var value0$2 = this.getValue__I__O(index);
      var key0Hash = $m_sc_Hashing$().improve__I__I(key0UnimprovedHash);
      var subNodeNew = this.mergeTwoKeyValPairs__O__O__I__I__O__O__I__I__I__sci_MapNode(key0, value0$2, key0UnimprovedHash, key0Hash, key, value, originalHash, keyHash, ((5 + shift) | 0));
      return this.copyAndMigrateFromInlineToNode__I__I__sci_MapNode__sci_BitmapIndexedMapNode(bitpos, key0Hash, subNodeNew)
    }
  } else if (((this.sci_BitmapIndexedMapNode__f_nodeMap & bitpos) !== 0)) {
    var index$2 = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_nodeMap, mask, bitpos);
    var subNode = this.getNode__I__sci_MapNode(index$2);
    var subNodeNew$2 = subNode.updated__O__O__I__I__I__Z__sci_MapNode(key, value, originalHash, keyHash, ((5 + shift) | 0), replaceValue);
    return ((subNodeNew$2 === subNode) ? this : this.copyAndSetNode__I__sci_MapNode__sci_MapNode__sci_BitmapIndexedMapNode(bitpos, subNode, subNodeNew$2))
  } else {
    return this.copyAndInsertValue__I__O__I__I__O__sci_BitmapIndexedMapNode(bitpos, key, originalHash, keyHash, value)
  }
});
$c_sci_BitmapIndexedMapNode.prototype.updateWithShallowMutations__O__O__I__I__I__I__I = (function(key, value, originalHash, keyHash, shift, shallowlyMutableNodeMap) {
  var mask = $m_sci_Node$().maskFrom__I__I__I(keyHash, shift);
  var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
  if (((this.sci_BitmapIndexedMapNode__f_dataMap & bitpos) !== 0)) {
    var index = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_dataMap, mask, bitpos);
    var key0 = this.getKey__I__O(index);
    var key0UnimprovedHash = this.getHash__I__I(index);
    if (((key0UnimprovedHash === originalHash) && $m_sr_BoxesRunTime$().equals__O__O__Z(key0, key))) {
      var value0 = this.getValue__I__O(index);
      if ((!($is(key0, key) && $is(value0, value)))) {
        var dataIx = this.dataIndex__I__I(bitpos);
        var idx = (dataIx << 1);
        this.sci_BitmapIndexedMapNode__f_content.set(((1 + idx) | 0), value)
      };
      return shallowlyMutableNodeMap
    } else {
      var value0$2 = this.getValue__I__O(index);
      var key0Hash = $m_sc_Hashing$().improve__I__I(key0UnimprovedHash);
      var subNodeNew = this.mergeTwoKeyValPairs__O__O__I__I__O__O__I__I__I__sci_MapNode(key0, value0$2, key0UnimprovedHash, key0Hash, key, value, originalHash, keyHash, ((5 + shift) | 0));
      this.migrateFromInlineToNodeInPlace__I__I__sci_MapNode__sci_BitmapIndexedMapNode(bitpos, key0Hash, subNodeNew);
      return (shallowlyMutableNodeMap | bitpos)
    }
  } else if (((this.sci_BitmapIndexedMapNode__f_nodeMap & bitpos) !== 0)) {
    var index$2 = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_nodeMap, mask, bitpos);
    var subNode = this.getNode__I__sci_MapNode(index$2);
    var subNodeSize = subNode.size__I();
    var subNodeHashCode = subNode.cachedJavaKeySetHashCode__I();
    var returnMutableNodeMap = shallowlyMutableNodeMap;
    matchEnd4: {
      var subNodeNew$2;
      if ((subNode instanceof $c_sci_BitmapIndexedMapNode)) {
        var x2 = $as_sci_BitmapIndexedMapNode(subNode);
        if (((bitpos & shallowlyMutableNodeMap) !== 0)) {
          x2.updateWithShallowMutations__O__O__I__I__I__I__I(key, value, originalHash, keyHash, ((5 + shift) | 0), 0);
          var subNodeNew$2 = x2;
          break matchEnd4
        }
      };
      var result = subNode.updated__O__O__I__I__I__Z__sci_MapNode(key, value, originalHash, keyHash, ((5 + shift) | 0), true);
      if ((result !== subNode)) {
        returnMutableNodeMap = (returnMutableNodeMap | bitpos)
      };
      var subNodeNew$2 = result
    };
    this.sci_BitmapIndexedMapNode__f_content.set((((((-1) + this.sci_BitmapIndexedMapNode__f_content.u.length) | 0) - this.nodeIndex__I__I(bitpos)) | 0), subNodeNew$2);
    this.sci_BitmapIndexedMapNode__f_size = ((((this.sci_BitmapIndexedMapNode__f_size - subNodeSize) | 0) + subNodeNew$2.size__I()) | 0);
    this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode = ((((this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode - subNodeHashCode) | 0) + subNodeNew$2.cachedJavaKeySetHashCode__I()) | 0);
    return returnMutableNodeMap
  } else {
    var dataIx$2 = this.dataIndex__I__I(bitpos);
    var idx$2 = (dataIx$2 << 1);
    var src = this.sci_BitmapIndexedMapNode__f_content;
    var dst = new $ac_O(((2 + src.u.length) | 0));
    $systemArraycopy(src, 0, dst, 0, idx$2);
    dst.set(idx$2, key);
    dst.set(((1 + idx$2) | 0), value);
    var destPos = ((2 + idx$2) | 0);
    var length = ((src.u.length - idx$2) | 0);
    $systemArraycopy(src, idx$2, dst, destPos, length);
    this.sci_BitmapIndexedMapNode__f_dataMap = (this.sci_BitmapIndexedMapNode__f_dataMap | bitpos);
    this.sci_BitmapIndexedMapNode__f_content = dst;
    this.sci_BitmapIndexedMapNode__f_originalHashes = this.insertElement__AI__I__I__AI(this.sci_BitmapIndexedMapNode__f_originalHashes, dataIx$2, originalHash);
    this.sci_BitmapIndexedMapNode__f_size = ((1 + this.sci_BitmapIndexedMapNode__f_size) | 0);
    this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode = ((this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode + keyHash) | 0);
    return shallowlyMutableNodeMap
  }
});
$c_sci_BitmapIndexedMapNode.prototype.removed__O__I__I__I__sci_BitmapIndexedMapNode = (function(key, originalHash, keyHash, shift) {
  var mask = $m_sci_Node$().maskFrom__I__I__I(keyHash, shift);
  var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
  if (((this.sci_BitmapIndexedMapNode__f_dataMap & bitpos) !== 0)) {
    var index = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_dataMap, mask, bitpos);
    var key0 = this.getKey__I__O(index);
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(key0, key)) {
      var i = this.sci_BitmapIndexedMapNode__f_dataMap;
      if (($m_jl_Integer$().bitCount__I__I(i) === 2)) {
        var i$1 = this.sci_BitmapIndexedMapNode__f_nodeMap;
        var $$x1 = ($m_jl_Integer$().bitCount__I__I(i$1) === 0)
      } else {
        var $$x1 = false
      };
      if ($$x1) {
        var newDataMap = ((shift === 0) ? (this.sci_BitmapIndexedMapNode__f_dataMap ^ bitpos) : $m_sci_Node$().bitposFrom__I__I($m_sci_Node$().maskFrom__I__I__I(keyHash, 0)));
        if ((index === 0)) {
          var array = [this.getKey__I__O(1), this.getValue__I__O(1)];
          var xs = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
          $m_s_reflect_ManifestFactory$AnyManifest$();
          var len = xs.length__I();
          var array$1 = new $ac_O(len);
          var this$7 = new $c_sc_IndexedSeqView$Id(xs);
          var iterator = new $c_sc_IndexedSeqView$IndexedSeqViewIterator(this$7);
          var i$2 = 0;
          while (iterator.hasNext__Z()) {
            array$1.set(i$2, iterator.next__O());
            i$2 = ((1 + i$2) | 0)
          };
          return new $c_sci_BitmapIndexedMapNode(newDataMap, 0, array$1, new $ac_I([this.sci_BitmapIndexedMapNode__f_originalHashes.get(1)]), 1, $m_sc_Hashing$().improve__I__I(this.getHash__I__I(1)))
        } else {
          var array$2 = [this.getKey__I__O(0), this.getValue__I__O(0)];
          var xs$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
          $m_s_reflect_ManifestFactory$AnyManifest$();
          var len$1 = xs$1.length__I();
          var array$3 = new $ac_O(len$1);
          var this$14 = new $c_sc_IndexedSeqView$Id(xs$1);
          var iterator$1 = new $c_sc_IndexedSeqView$IndexedSeqViewIterator(this$14);
          var i$3 = 0;
          while (iterator$1.hasNext__Z()) {
            array$3.set(i$3, iterator$1.next__O());
            i$3 = ((1 + i$3) | 0)
          };
          return new $c_sci_BitmapIndexedMapNode(newDataMap, 0, array$3, new $ac_I([this.sci_BitmapIndexedMapNode__f_originalHashes.get(0)]), 1, $m_sc_Hashing$().improve__I__I(this.getHash__I__I(0)))
        }
      } else {
        return this.copyAndRemoveValue__I__I__sci_BitmapIndexedMapNode(bitpos, keyHash)
      }
    } else {
      return this
    }
  } else if (((this.sci_BitmapIndexedMapNode__f_nodeMap & bitpos) !== 0)) {
    var index$2 = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_nodeMap, mask, bitpos);
    var subNode = this.getNode__I__sci_MapNode(index$2);
    var subNodeNew = subNode.removed__O__I__I__I__sci_MapNode(key, originalHash, keyHash, ((5 + shift) | 0));
    if ((subNodeNew === subNode)) {
      return this
    };
    var subNodeNewSize = subNodeNew.size__I();
    return ((subNodeNewSize === 1) ? ((this.sci_BitmapIndexedMapNode__f_size === subNode.size__I()) ? $as_sci_BitmapIndexedMapNode(subNodeNew) : this.copyAndMigrateFromNodeToInline__I__sci_MapNode__sci_MapNode__sci_BitmapIndexedMapNode(bitpos, subNode, subNodeNew)) : ((subNodeNewSize > 1) ? this.copyAndSetNode__I__sci_MapNode__sci_MapNode__sci_BitmapIndexedMapNode(bitpos, subNode, subNodeNew) : this))
  } else {
    return this
  }
});
$c_sci_BitmapIndexedMapNode.prototype.mergeTwoKeyValPairs__O__O__I__I__O__O__I__I__I__sci_MapNode = (function(key0, value0, originalHash0, keyHash0, key1, value1, originalHash1, keyHash1, shift) {
  if ((shift >= 32)) {
    var this$4 = $m_sci_Vector$();
    var array = [new $c_T2(key0, value0), new $c_T2(key1, value1)];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    return new $c_sci_HashCollisionMapNode(originalHash0, keyHash0, this$4.from__sc_IterableOnce__sci_Vector(elems))
  } else {
    var mask0 = $m_sci_Node$().maskFrom__I__I__I(keyHash0, shift);
    var mask1 = $m_sci_Node$().maskFrom__I__I__I(keyHash1, shift);
    var newCachedHash = ((keyHash0 + keyHash1) | 0);
    if ((mask0 !== mask1)) {
      var dataMap = ($m_sci_Node$().bitposFrom__I__I(mask0) | $m_sci_Node$().bitposFrom__I__I(mask1));
      if ((mask0 < mask1)) {
        var array$1 = [key0, value0, key1, value1];
        var xs = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
        $m_s_reflect_ManifestFactory$AnyManifest$();
        var len = xs.length__I();
        var array$2 = new $ac_O(len);
        var this$11 = new $c_sc_IndexedSeqView$Id(xs);
        var iterator = new $c_sc_IndexedSeqView$IndexedSeqViewIterator(this$11);
        var i = 0;
        while (iterator.hasNext__Z()) {
          array$2.set(i, iterator.next__O());
          i = ((1 + i) | 0)
        };
        return new $c_sci_BitmapIndexedMapNode(dataMap, 0, array$2, new $ac_I([originalHash0, originalHash1]), 2, newCachedHash)
      } else {
        var array$3 = [key1, value1, key0, value0];
        var xs$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3);
        $m_s_reflect_ManifestFactory$AnyManifest$();
        var len$1 = xs$1.length__I();
        var array$4 = new $ac_O(len$1);
        var this$18 = new $c_sc_IndexedSeqView$Id(xs$1);
        var iterator$1 = new $c_sc_IndexedSeqView$IndexedSeqViewIterator(this$18);
        var i$1 = 0;
        while (iterator$1.hasNext__Z()) {
          array$4.set(i$1, iterator$1.next__O());
          i$1 = ((1 + i$1) | 0)
        };
        return new $c_sci_BitmapIndexedMapNode(dataMap, 0, array$4, new $ac_I([originalHash1, originalHash0]), 2, newCachedHash)
      }
    } else {
      var nodeMap = $m_sci_Node$().bitposFrom__I__I(mask0);
      var node = this.mergeTwoKeyValPairs__O__O__I__I__O__O__I__I__I__sci_MapNode(key0, value0, originalHash0, keyHash0, key1, value1, originalHash1, keyHash1, ((5 + shift) | 0));
      var array$5 = [node];
      var xs$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5);
      $m_s_reflect_ManifestFactory$AnyManifest$();
      var len$2 = xs$2.length__I();
      var array$6 = new $ac_O(len$2);
      var this$25 = new $c_sc_IndexedSeqView$Id(xs$2);
      var iterator$2 = new $c_sc_IndexedSeqView$IndexedSeqViewIterator(this$25);
      var i$2 = 0;
      while (iterator$2.hasNext__Z()) {
        array$6.set(i$2, iterator$2.next__O());
        i$2 = ((1 + i$2) | 0)
      };
      return new $c_sci_BitmapIndexedMapNode(0, nodeMap, array$6, $m_s_Array$EmptyArrays$().s_Array$EmptyArrays$__f_emptyIntArray, node.size__I(), node.cachedJavaKeySetHashCode__I())
    }
  }
});
$c_sci_BitmapIndexedMapNode.prototype.hasNodes__Z = (function() {
  return (this.sci_BitmapIndexedMapNode__f_nodeMap !== 0)
});
$c_sci_BitmapIndexedMapNode.prototype.nodeArity__I = (function() {
  var i = this.sci_BitmapIndexedMapNode__f_nodeMap;
  return $m_jl_Integer$().bitCount__I__I(i)
});
$c_sci_BitmapIndexedMapNode.prototype.hasPayload__Z = (function() {
  return (this.sci_BitmapIndexedMapNode__f_dataMap !== 0)
});
$c_sci_BitmapIndexedMapNode.prototype.payloadArity__I = (function() {
  var i = this.sci_BitmapIndexedMapNode__f_dataMap;
  return $m_jl_Integer$().bitCount__I__I(i)
});
$c_sci_BitmapIndexedMapNode.prototype.dataIndex__I__I = (function(bitpos) {
  var i = (this.sci_BitmapIndexedMapNode__f_dataMap & (((-1) + bitpos) | 0));
  return $m_jl_Integer$().bitCount__I__I(i)
});
$c_sci_BitmapIndexedMapNode.prototype.nodeIndex__I__I = (function(bitpos) {
  var i = (this.sci_BitmapIndexedMapNode__f_nodeMap & (((-1) + bitpos) | 0));
  return $m_jl_Integer$().bitCount__I__I(i)
});
$c_sci_BitmapIndexedMapNode.prototype.copyAndSetValue__I__O__O__sci_BitmapIndexedMapNode = (function(bitpos, newKey, newValue) {
  var dataIx = this.dataIndex__I__I(bitpos);
  var idx = (dataIx << 1);
  var src = this.sci_BitmapIndexedMapNode__f_content;
  var dst = new $ac_O(src.u.length);
  var length = src.u.length;
  $systemArraycopy(src, 0, dst, 0, length);
  dst.set(((1 + idx) | 0), newValue);
  return new $c_sci_BitmapIndexedMapNode(this.sci_BitmapIndexedMapNode__f_dataMap, this.sci_BitmapIndexedMapNode__f_nodeMap, dst, this.sci_BitmapIndexedMapNode__f_originalHashes, this.sci_BitmapIndexedMapNode__f_size, this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode)
});
$c_sci_BitmapIndexedMapNode.prototype.copyAndSetNode__I__sci_MapNode__sci_MapNode__sci_BitmapIndexedMapNode = (function(bitpos, oldNode, newNode) {
  var idx = (((((-1) + this.sci_BitmapIndexedMapNode__f_content.u.length) | 0) - this.nodeIndex__I__I(bitpos)) | 0);
  var src = this.sci_BitmapIndexedMapNode__f_content;
  var dst = new $ac_O(src.u.length);
  var length = src.u.length;
  $systemArraycopy(src, 0, dst, 0, length);
  dst.set(idx, newNode);
  return new $c_sci_BitmapIndexedMapNode(this.sci_BitmapIndexedMapNode__f_dataMap, this.sci_BitmapIndexedMapNode__f_nodeMap, dst, this.sci_BitmapIndexedMapNode__f_originalHashes, ((((this.sci_BitmapIndexedMapNode__f_size - oldNode.size__I()) | 0) + newNode.size__I()) | 0), ((((this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode - oldNode.cachedJavaKeySetHashCode__I()) | 0) + newNode.cachedJavaKeySetHashCode__I()) | 0))
});
$c_sci_BitmapIndexedMapNode.prototype.copyAndInsertValue__I__O__I__I__O__sci_BitmapIndexedMapNode = (function(bitpos, key, originalHash, keyHash, value) {
  var dataIx = this.dataIndex__I__I(bitpos);
  var idx = (dataIx << 1);
  var src = this.sci_BitmapIndexedMapNode__f_content;
  var dst = new $ac_O(((2 + src.u.length) | 0));
  $systemArraycopy(src, 0, dst, 0, idx);
  dst.set(idx, key);
  dst.set(((1 + idx) | 0), value);
  var destPos = ((2 + idx) | 0);
  var length = ((src.u.length - idx) | 0);
  $systemArraycopy(src, idx, dst, destPos, length);
  var dstHashes = this.insertElement__AI__I__I__AI(this.sci_BitmapIndexedMapNode__f_originalHashes, dataIx, originalHash);
  return new $c_sci_BitmapIndexedMapNode((this.sci_BitmapIndexedMapNode__f_dataMap | bitpos), this.sci_BitmapIndexedMapNode__f_nodeMap, dst, dstHashes, ((1 + this.sci_BitmapIndexedMapNode__f_size) | 0), ((this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode + keyHash) | 0))
});
$c_sci_BitmapIndexedMapNode.prototype.copyAndRemoveValue__I__I__sci_BitmapIndexedMapNode = (function(bitpos, keyHash) {
  var dataIx = this.dataIndex__I__I(bitpos);
  var idx = (dataIx << 1);
  var src = this.sci_BitmapIndexedMapNode__f_content;
  var dst = new $ac_O((((-2) + src.u.length) | 0));
  $systemArraycopy(src, 0, dst, 0, idx);
  var srcPos = ((2 + idx) | 0);
  var length = (((-2) + ((src.u.length - idx) | 0)) | 0);
  $systemArraycopy(src, srcPos, dst, idx, length);
  var dstHashes = this.removeElement__AI__I__AI(this.sci_BitmapIndexedMapNode__f_originalHashes, dataIx);
  return new $c_sci_BitmapIndexedMapNode((this.sci_BitmapIndexedMapNode__f_dataMap ^ bitpos), this.sci_BitmapIndexedMapNode__f_nodeMap, dst, dstHashes, (((-1) + this.sci_BitmapIndexedMapNode__f_size) | 0), ((this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode - keyHash) | 0))
});
$c_sci_BitmapIndexedMapNode.prototype.migrateFromInlineToNodeInPlace__I__I__sci_MapNode__sci_BitmapIndexedMapNode = (function(bitpos, keyHash, node) {
  var dataIx = this.dataIndex__I__I(bitpos);
  var idxOld = (dataIx << 1);
  var idxNew = (((((-2) + this.sci_BitmapIndexedMapNode__f_content.u.length) | 0) - this.nodeIndex__I__I(bitpos)) | 0);
  var src = this.sci_BitmapIndexedMapNode__f_content;
  var dst = new $ac_O((((-1) + src.u.length) | 0));
  $systemArraycopy(src, 0, dst, 0, idxOld);
  var srcPos = ((2 + idxOld) | 0);
  var length = ((idxNew - idxOld) | 0);
  $systemArraycopy(src, srcPos, dst, idxOld, length);
  dst.set(idxNew, node);
  var srcPos$1 = ((2 + idxNew) | 0);
  var destPos = ((1 + idxNew) | 0);
  var length$1 = (((-2) + ((src.u.length - idxNew) | 0)) | 0);
  $systemArraycopy(src, srcPos$1, dst, destPos, length$1);
  var dstHashes = this.removeElement__AI__I__AI(this.sci_BitmapIndexedMapNode__f_originalHashes, dataIx);
  this.sci_BitmapIndexedMapNode__f_dataMap = (this.sci_BitmapIndexedMapNode__f_dataMap ^ bitpos);
  this.sci_BitmapIndexedMapNode__f_nodeMap = (this.sci_BitmapIndexedMapNode__f_nodeMap | bitpos);
  this.sci_BitmapIndexedMapNode__f_content = dst;
  this.sci_BitmapIndexedMapNode__f_originalHashes = dstHashes;
  this.sci_BitmapIndexedMapNode__f_size = (((((-1) + this.sci_BitmapIndexedMapNode__f_size) | 0) + node.size__I()) | 0);
  this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode = ((((this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode - keyHash) | 0) + node.cachedJavaKeySetHashCode__I()) | 0);
  return this
});
$c_sci_BitmapIndexedMapNode.prototype.copyAndMigrateFromInlineToNode__I__I__sci_MapNode__sci_BitmapIndexedMapNode = (function(bitpos, keyHash, node) {
  var dataIx = this.dataIndex__I__I(bitpos);
  var idxOld = (dataIx << 1);
  var idxNew = (((((-2) + this.sci_BitmapIndexedMapNode__f_content.u.length) | 0) - this.nodeIndex__I__I(bitpos)) | 0);
  var src = this.sci_BitmapIndexedMapNode__f_content;
  var dst = new $ac_O((((-1) + src.u.length) | 0));
  $systemArraycopy(src, 0, dst, 0, idxOld);
  var srcPos = ((2 + idxOld) | 0);
  var length = ((idxNew - idxOld) | 0);
  $systemArraycopy(src, srcPos, dst, idxOld, length);
  dst.set(idxNew, node);
  var srcPos$1 = ((2 + idxNew) | 0);
  var destPos = ((1 + idxNew) | 0);
  var length$1 = (((-2) + ((src.u.length - idxNew) | 0)) | 0);
  $systemArraycopy(src, srcPos$1, dst, destPos, length$1);
  var dstHashes = this.removeElement__AI__I__AI(this.sci_BitmapIndexedMapNode__f_originalHashes, dataIx);
  return new $c_sci_BitmapIndexedMapNode((this.sci_BitmapIndexedMapNode__f_dataMap ^ bitpos), (this.sci_BitmapIndexedMapNode__f_nodeMap | bitpos), dst, dstHashes, (((((-1) + this.sci_BitmapIndexedMapNode__f_size) | 0) + node.size__I()) | 0), ((((this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode - keyHash) | 0) + node.cachedJavaKeySetHashCode__I()) | 0))
});
$c_sci_BitmapIndexedMapNode.prototype.copyAndMigrateFromNodeToInline__I__sci_MapNode__sci_MapNode__sci_BitmapIndexedMapNode = (function(bitpos, oldNode, node) {
  var idxOld = (((((-1) + this.sci_BitmapIndexedMapNode__f_content.u.length) | 0) - this.nodeIndex__I__I(bitpos)) | 0);
  var dataIxNew = this.dataIndex__I__I(bitpos);
  var idxNew = (dataIxNew << 1);
  var key = node.getKey__I__O(0);
  var value = node.getValue__I__O(0);
  var src = this.sci_BitmapIndexedMapNode__f_content;
  var dst = new $ac_O(((1 + src.u.length) | 0));
  $systemArraycopy(src, 0, dst, 0, idxNew);
  dst.set(idxNew, key);
  dst.set(((1 + idxNew) | 0), value);
  var destPos = ((2 + idxNew) | 0);
  var length = ((idxOld - idxNew) | 0);
  $systemArraycopy(src, idxNew, dst, destPos, length);
  var srcPos = ((1 + idxOld) | 0);
  var destPos$1 = ((2 + idxOld) | 0);
  var length$1 = (((-1) + ((src.u.length - idxOld) | 0)) | 0);
  $systemArraycopy(src, srcPos, dst, destPos$1, length$1);
  var hash = node.getHash__I__I(0);
  var dstHashes = this.insertElement__AI__I__I__AI(this.sci_BitmapIndexedMapNode__f_originalHashes, dataIxNew, hash);
  return new $c_sci_BitmapIndexedMapNode((this.sci_BitmapIndexedMapNode__f_dataMap | bitpos), (this.sci_BitmapIndexedMapNode__f_nodeMap ^ bitpos), dst, dstHashes, ((1 + ((this.sci_BitmapIndexedMapNode__f_size - oldNode.size__I()) | 0)) | 0), ((((this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode - oldNode.cachedJavaKeySetHashCode__I()) | 0) + node.cachedJavaKeySetHashCode__I()) | 0))
});
$c_sci_BitmapIndexedMapNode.prototype.foreach__F1__V = (function(f) {
  var i = this.sci_BitmapIndexedMapNode__f_dataMap;
  var iN = $m_jl_Integer$().bitCount__I__I(i);
  var i$1 = 0;
  while ((i$1 < iN)) {
    f.apply__O__O(this.getPayload__I__T2(i$1));
    i$1 = ((1 + i$1) | 0)
  };
  var i$2 = this.sci_BitmapIndexedMapNode__f_nodeMap;
  var jN = $m_jl_Integer$().bitCount__I__I(i$2);
  var j = 0;
  while ((j < jN)) {
    this.getNode__I__sci_MapNode(j).foreach__F1__V(f);
    j = ((1 + j) | 0)
  }
});
$c_sci_BitmapIndexedMapNode.prototype.foreachEntry__F2__V = (function(f) {
  var i = this.sci_BitmapIndexedMapNode__f_dataMap;
  var iN = $m_jl_Integer$().bitCount__I__I(i);
  var i$1 = 0;
  while ((i$1 < iN)) {
    f.apply__O__O__O(this.getKey__I__O(i$1), this.getValue__I__O(i$1));
    i$1 = ((1 + i$1) | 0)
  };
  var i$2 = this.sci_BitmapIndexedMapNode__f_nodeMap;
  var jN = $m_jl_Integer$().bitCount__I__I(i$2);
  var j = 0;
  while ((j < jN)) {
    this.getNode__I__sci_MapNode(j).foreachEntry__F2__V(f);
    j = ((1 + j) | 0)
  }
});
$c_sci_BitmapIndexedMapNode.prototype.foreachWithHash__F3__V = (function(f) {
  var i = 0;
  var i$1 = this.sci_BitmapIndexedMapNode__f_dataMap;
  var iN = $m_jl_Integer$().bitCount__I__I(i$1);
  while ((i < iN)) {
    f.apply__O__O__O__O(this.getKey__I__O(i), this.getValue__I__O(i), this.getHash__I__I(i));
    i = ((1 + i) | 0)
  };
  var i$2 = this.sci_BitmapIndexedMapNode__f_nodeMap;
  var jN = $m_jl_Integer$().bitCount__I__I(i$2);
  var j = 0;
  while ((j < jN)) {
    this.getNode__I__sci_MapNode(j).foreachWithHash__F3__V(f);
    j = ((1 + j) | 0)
  }
});
$c_sci_BitmapIndexedMapNode.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_BitmapIndexedMapNode)) {
    var x2 = $as_sci_BitmapIndexedMapNode(that);
    if ((this === x2)) {
      return true
    } else {
      if (((((this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode === x2.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode) && (this.sci_BitmapIndexedMapNode__f_nodeMap === x2.sci_BitmapIndexedMapNode__f_nodeMap)) && (this.sci_BitmapIndexedMapNode__f_dataMap === x2.sci_BitmapIndexedMapNode__f_dataMap)) && (this.sci_BitmapIndexedMapNode__f_size === x2.sci_BitmapIndexedMapNode__f_size))) {
        var a = this.sci_BitmapIndexedMapNode__f_originalHashes;
        var b = x2.sci_BitmapIndexedMapNode__f_originalHashes;
        var $$x1 = $m_ju_Arrays$().equals__AI__AI__Z(a, b)
      } else {
        var $$x1 = false
      };
      if ($$x1) {
        var a1 = this.sci_BitmapIndexedMapNode__f_content;
        var a2 = x2.sci_BitmapIndexedMapNode__f_content;
        var length = this.sci_BitmapIndexedMapNode__f_content.u.length;
        if ((a1 === a2)) {
          return true
        } else {
          var isEqual = true;
          var i = 0;
          while ((isEqual && (i < length))) {
            isEqual = $m_sr_BoxesRunTime$().equals__O__O__Z(a1.get(i), a2.get(i));
            i = ((1 + i) | 0)
          };
          return isEqual
        }
      } else {
        return false
      }
    }
  } else {
    return false
  }
});
$c_sci_BitmapIndexedMapNode.prototype.hashCode__I = (function() {
  throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "Trie nodes do not support hashing.")
});
$c_sci_BitmapIndexedMapNode.prototype.concat__sci_MapNode__I__sci_BitmapIndexedMapNode = (function(that, shift) {
  if ((that instanceof $c_sci_BitmapIndexedMapNode)) {
    var x2 = $as_sci_BitmapIndexedMapNode(that);
    if ((this.sci_BitmapIndexedMapNode__f_size === 0)) {
      return x2
    } else if (((x2.sci_BitmapIndexedMapNode__f_size === 0) || (x2 === this))) {
      return this
    } else if ((x2.sci_BitmapIndexedMapNode__f_size === 1)) {
      var originalHash = x2.getHash__I__I(0);
      return this.updated__O__O__I__I__I__Z__sci_BitmapIndexedMapNode(x2.getKey__I__O(0), x2.getValue__I__O(0), originalHash, $m_sc_Hashing$().improve__I__I(originalHash), shift, true)
    };
    var anyChangesMadeSoFar = false;
    var allMap = (((this.sci_BitmapIndexedMapNode__f_dataMap | x2.sci_BitmapIndexedMapNode__f_dataMap) | this.sci_BitmapIndexedMapNode__f_nodeMap) | x2.sci_BitmapIndexedMapNode__f_nodeMap);
    var minimumBitPos = $m_sci_Node$().bitposFrom__I__I(((allMap === 0) ? 32 : ((31 - $clz32((allMap & ((-allMap) | 0)))) | 0)));
    var maximumBitPos = $m_sci_Node$().bitposFrom__I__I(((31 - $clz32(allMap)) | 0));
    var leftNodeRightNode = 0;
    var leftDataRightNode = 0;
    var leftNodeRightData = 0;
    var leftDataOnly = 0;
    var rightDataOnly = 0;
    var leftNodeOnly = 0;
    var rightNodeOnly = 0;
    var leftDataRightDataMigrateToNode = 0;
    var leftDataRightDataRightOverwrites = 0;
    var dataToNodeMigrationTargets = 0;
    var bitpos = minimumBitPos;
    var leftIdx = 0;
    var rightIdx = 0;
    var finished = false;
    while ((!finished)) {
      if (((bitpos & this.sci_BitmapIndexedMapNode__f_dataMap) !== 0)) {
        if (((bitpos & x2.sci_BitmapIndexedMapNode__f_dataMap) !== 0)) {
          var leftOriginalHash = this.getHash__I__I(leftIdx);
          if (((leftOriginalHash === x2.getHash__I__I(rightIdx)) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.getKey__I__O(leftIdx), x2.getKey__I__O(rightIdx)))) {
            leftDataRightDataRightOverwrites = (leftDataRightDataRightOverwrites | bitpos)
          } else {
            leftDataRightDataMigrateToNode = (leftDataRightDataMigrateToNode | bitpos);
            dataToNodeMigrationTargets = (dataToNodeMigrationTargets | $m_sci_Node$().bitposFrom__I__I($m_sci_Node$().maskFrom__I__I__I($m_sc_Hashing$().improve__I__I(leftOriginalHash), shift)))
          };
          rightIdx = ((1 + rightIdx) | 0)
        } else if (((bitpos & x2.sci_BitmapIndexedMapNode__f_nodeMap) !== 0)) {
          leftDataRightNode = (leftDataRightNode | bitpos)
        } else {
          leftDataOnly = (leftDataOnly | bitpos)
        };
        leftIdx = ((1 + leftIdx) | 0)
      } else if (((bitpos & this.sci_BitmapIndexedMapNode__f_nodeMap) !== 0)) {
        if (((bitpos & x2.sci_BitmapIndexedMapNode__f_dataMap) !== 0)) {
          leftNodeRightData = (leftNodeRightData | bitpos);
          rightIdx = ((1 + rightIdx) | 0)
        } else if (((bitpos & x2.sci_BitmapIndexedMapNode__f_nodeMap) !== 0)) {
          leftNodeRightNode = (leftNodeRightNode | bitpos)
        } else {
          leftNodeOnly = (leftNodeOnly | bitpos)
        }
      } else if (((bitpos & x2.sci_BitmapIndexedMapNode__f_dataMap) !== 0)) {
        rightDataOnly = (rightDataOnly | bitpos);
        rightIdx = ((1 + rightIdx) | 0)
      } else if (((bitpos & x2.sci_BitmapIndexedMapNode__f_nodeMap) !== 0)) {
        rightNodeOnly = (rightNodeOnly | bitpos)
      };
      if ((bitpos === maximumBitPos)) {
        finished = true
      } else {
        bitpos = (bitpos << 1)
      }
    };
    var newDataMap = ((leftDataOnly | rightDataOnly) | leftDataRightDataRightOverwrites);
    var newNodeMap = (((((leftNodeRightNode | leftDataRightNode) | leftNodeRightData) | leftNodeOnly) | rightNodeOnly) | dataToNodeMigrationTargets);
    if (((newDataMap === (rightDataOnly | leftDataRightDataRightOverwrites)) && (newNodeMap === rightNodeOnly))) {
      return x2
    };
    var newDataSize = $m_jl_Integer$().bitCount__I__I(newDataMap);
    var newContentSize = (((newDataSize << 1) + $m_jl_Integer$().bitCount__I__I(newNodeMap)) | 0);
    var newContent = new $ac_O(newContentSize);
    var newOriginalHashes = new $ac_I(newDataSize);
    var newSize = 0;
    var newCachedHashCode = 0;
    var leftDataIdx = 0;
    var rightDataIdx = 0;
    var leftNodeIdx = 0;
    var rightNodeIdx = 0;
    var nextShift = ((5 + shift) | 0);
    var compressedDataIdx = 0;
    var compressedNodeIdx = 0;
    var bitpos$2 = minimumBitPos;
    var finished$2 = false;
    while ((!finished$2)) {
      if (((bitpos$2 & leftNodeRightNode) !== 0)) {
        var rightNode = x2.getNode__I__sci_MapNode(rightNodeIdx);
        var newNode = this.getNode__I__sci_MapNode(leftNodeIdx).concat__sci_MapNode__I__sci_MapNode(rightNode, nextShift);
        if ((rightNode !== newNode)) {
          anyChangesMadeSoFar = true
        };
        newContent.set((((-1) + ((newContentSize - compressedNodeIdx) | 0)) | 0), newNode);
        compressedNodeIdx = ((1 + compressedNodeIdx) | 0);
        rightNodeIdx = ((1 + rightNodeIdx) | 0);
        leftNodeIdx = ((1 + leftNodeIdx) | 0);
        newSize = ((newSize + newNode.size__I()) | 0);
        newCachedHashCode = ((newCachedHashCode + newNode.cachedJavaKeySetHashCode__I()) | 0)
      } else if (((bitpos$2 & leftDataRightNode) !== 0)) {
        var n = x2.getNode__I__sci_MapNode(rightNodeIdx);
        var leftKey = this.getKey__I__O(leftDataIdx);
        var leftValue = this.getValue__I__O(leftDataIdx);
        var leftOriginalHash$2 = this.getHash__I__I(leftDataIdx);
        var leftImproved = $m_sc_Hashing$().improve__I__I(leftOriginalHash$2);
        var updated = n.updated__O__O__I__I__I__Z__sci_MapNode(leftKey, leftValue, leftOriginalHash$2, leftImproved, nextShift, false);
        if ((updated !== n)) {
          anyChangesMadeSoFar = true
        };
        newContent.set((((-1) + ((newContentSize - compressedNodeIdx) | 0)) | 0), updated);
        compressedNodeIdx = ((1 + compressedNodeIdx) | 0);
        rightNodeIdx = ((1 + rightNodeIdx) | 0);
        leftDataIdx = ((1 + leftDataIdx) | 0);
        newSize = ((newSize + updated.size__I()) | 0);
        newCachedHashCode = ((newCachedHashCode + updated.cachedJavaKeySetHashCode__I()) | 0)
      } else if (((bitpos$2 & leftNodeRightData) !== 0)) {
        anyChangesMadeSoFar = true;
        var rightOriginalHash = x2.getHash__I__I(rightDataIdx);
        var newNode$3 = this.getNode__I__sci_MapNode(leftNodeIdx).updated__O__O__I__I__I__Z__sci_MapNode(x2.getKey__I__O(rightDataIdx), x2.getValue__I__O(rightDataIdx), x2.getHash__I__I(rightDataIdx), $m_sc_Hashing$().improve__I__I(rightOriginalHash), nextShift, true);
        newContent.set((((-1) + ((newContentSize - compressedNodeIdx) | 0)) | 0), newNode$3);
        compressedNodeIdx = ((1 + compressedNodeIdx) | 0);
        leftNodeIdx = ((1 + leftNodeIdx) | 0);
        rightDataIdx = ((1 + rightDataIdx) | 0);
        newSize = ((newSize + newNode$3.size__I()) | 0);
        newCachedHashCode = ((newCachedHashCode + newNode$3.cachedJavaKeySetHashCode__I()) | 0)
      } else if (((bitpos$2 & leftDataOnly) !== 0)) {
        anyChangesMadeSoFar = true;
        var originalHash$2 = this.sci_BitmapIndexedMapNode__f_originalHashes.get(leftDataIdx);
        newContent.set((compressedDataIdx << 1), this.getKey__I__O(leftDataIdx));
        newContent.set(((1 + (compressedDataIdx << 1)) | 0), this.getValue__I__O(leftDataIdx));
        newOriginalHashes.set(compressedDataIdx, originalHash$2);
        compressedDataIdx = ((1 + compressedDataIdx) | 0);
        leftDataIdx = ((1 + leftDataIdx) | 0);
        newSize = ((1 + newSize) | 0);
        newCachedHashCode = ((newCachedHashCode + $m_sc_Hashing$().improve__I__I(originalHash$2)) | 0)
      } else if (((bitpos$2 & rightDataOnly) !== 0)) {
        var originalHash$3 = x2.sci_BitmapIndexedMapNode__f_originalHashes.get(rightDataIdx);
        newContent.set((compressedDataIdx << 1), x2.getKey__I__O(rightDataIdx));
        newContent.set(((1 + (compressedDataIdx << 1)) | 0), x2.getValue__I__O(rightDataIdx));
        newOriginalHashes.set(compressedDataIdx, originalHash$3);
        compressedDataIdx = ((1 + compressedDataIdx) | 0);
        rightDataIdx = ((1 + rightDataIdx) | 0);
        newSize = ((1 + newSize) | 0);
        newCachedHashCode = ((newCachedHashCode + $m_sc_Hashing$().improve__I__I(originalHash$3)) | 0)
      } else if (((bitpos$2 & leftNodeOnly) !== 0)) {
        anyChangesMadeSoFar = true;
        var newNode$4 = this.getNode__I__sci_MapNode(leftNodeIdx);
        newContent.set((((-1) + ((newContentSize - compressedNodeIdx) | 0)) | 0), newNode$4);
        compressedNodeIdx = ((1 + compressedNodeIdx) | 0);
        leftNodeIdx = ((1 + leftNodeIdx) | 0);
        newSize = ((newSize + newNode$4.size__I()) | 0);
        newCachedHashCode = ((newCachedHashCode + newNode$4.cachedJavaKeySetHashCode__I()) | 0)
      } else if (((bitpos$2 & rightNodeOnly) !== 0)) {
        var newNode$5 = x2.getNode__I__sci_MapNode(rightNodeIdx);
        newContent.set((((-1) + ((newContentSize - compressedNodeIdx) | 0)) | 0), newNode$5);
        compressedNodeIdx = ((1 + compressedNodeIdx) | 0);
        rightNodeIdx = ((1 + rightNodeIdx) | 0);
        newSize = ((newSize + newNode$5.size__I()) | 0);
        newCachedHashCode = ((newCachedHashCode + newNode$5.cachedJavaKeySetHashCode__I()) | 0)
      } else if (((bitpos$2 & leftDataRightDataMigrateToNode) !== 0)) {
        anyChangesMadeSoFar = true;
        var leftOriginalHash$3 = this.getHash__I__I(leftDataIdx);
        var rightOriginalHash$2 = x2.getHash__I__I(rightDataIdx);
        var newNode$6 = x2.mergeTwoKeyValPairs__O__O__I__I__O__O__I__I__I__sci_MapNode(this.getKey__I__O(leftDataIdx), this.getValue__I__O(leftDataIdx), leftOriginalHash$3, $m_sc_Hashing$().improve__I__I(leftOriginalHash$3), x2.getKey__I__O(rightDataIdx), x2.getValue__I__O(rightDataIdx), rightOriginalHash$2, $m_sc_Hashing$().improve__I__I(rightOriginalHash$2), nextShift);
        newContent.set((((-1) + ((newContentSize - compressedNodeIdx) | 0)) | 0), newNode$6);
        compressedNodeIdx = ((1 + compressedNodeIdx) | 0);
        leftDataIdx = ((1 + leftDataIdx) | 0);
        rightDataIdx = ((1 + rightDataIdx) | 0);
        newSize = ((newSize + newNode$6.size__I()) | 0);
        newCachedHashCode = ((newCachedHashCode + newNode$6.cachedJavaKeySetHashCode__I()) | 0)
      } else if (((bitpos$2 & leftDataRightDataRightOverwrites) !== 0)) {
        var originalHash$4 = x2.sci_BitmapIndexedMapNode__f_originalHashes.get(rightDataIdx);
        newContent.set((compressedDataIdx << 1), x2.getKey__I__O(rightDataIdx));
        newContent.set(((1 + (compressedDataIdx << 1)) | 0), x2.getValue__I__O(rightDataIdx));
        newOriginalHashes.set(compressedDataIdx, originalHash$4);
        compressedDataIdx = ((1 + compressedDataIdx) | 0);
        rightDataIdx = ((1 + rightDataIdx) | 0);
        newSize = ((1 + newSize) | 0);
        newCachedHashCode = ((newCachedHashCode + $m_sc_Hashing$().improve__I__I(originalHash$4)) | 0);
        leftDataIdx = ((1 + leftDataIdx) | 0)
      };
      if ((bitpos$2 === maximumBitPos)) {
        finished$2 = true
      } else {
        bitpos$2 = (bitpos$2 << 1)
      }
    };
    return (anyChangesMadeSoFar ? new $c_sci_BitmapIndexedMapNode(newDataMap, newNodeMap, newContent, newOriginalHashes, newSize, newCachedHashCode) : x2)
  } else {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "Cannot concatenate a HashCollisionMapNode with a BitmapIndexedMapNode")
  }
});
$c_sci_BitmapIndexedMapNode.prototype.copy__sci_BitmapIndexedMapNode = (function() {
  var this$1 = this.sci_BitmapIndexedMapNode__f_content;
  var contentClone = this$1.clone__O();
  var contentLength = contentClone.u.length;
  var i = this.sci_BitmapIndexedMapNode__f_dataMap;
  var i$1 = ($m_jl_Integer$().bitCount__I__I(i) << 1);
  while ((i$1 < contentLength)) {
    contentClone.set(i$1, $as_sci_MapNode(contentClone.get(i$1)).copy__sci_MapNode());
    i$1 = ((1 + i$1) | 0)
  };
  var $$x2 = this.sci_BitmapIndexedMapNode__f_dataMap;
  var $$x1 = this.sci_BitmapIndexedMapNode__f_nodeMap;
  var this$2 = this.sci_BitmapIndexedMapNode__f_originalHashes;
  return new $c_sci_BitmapIndexedMapNode($$x2, $$x1, contentClone, this$2.clone__O(), this.sci_BitmapIndexedMapNode__f_size, this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode)
});
$c_sci_BitmapIndexedMapNode.prototype.copy__sci_MapNode = (function() {
  return this.copy__sci_BitmapIndexedMapNode()
});
$c_sci_BitmapIndexedMapNode.prototype.concat__sci_MapNode__I__sci_MapNode = (function(that, shift) {
  return this.concat__sci_MapNode__I__sci_BitmapIndexedMapNode(that, shift)
});
$c_sci_BitmapIndexedMapNode.prototype.removed__O__I__I__I__sci_MapNode = (function(key, originalHash, hash, shift) {
  return this.removed__O__I__I__I__sci_BitmapIndexedMapNode(key, originalHash, hash, shift)
});
$c_sci_BitmapIndexedMapNode.prototype.updated__O__O__I__I__I__Z__sci_MapNode = (function(key, value, originalHash, hash, shift, replaceValue) {
  return this.updated__O__O__I__I__I__Z__sci_BitmapIndexedMapNode(key, value, originalHash, hash, shift, replaceValue)
});
$c_sci_BitmapIndexedMapNode.prototype.getNode__I__sci_Node = (function(index) {
  return this.getNode__I__sci_MapNode(index)
});
function $as_sci_BitmapIndexedMapNode(obj) {
  return (((obj instanceof $c_sci_BitmapIndexedMapNode) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.BitmapIndexedMapNode"))
}
function $isArrayOf_sci_BitmapIndexedMapNode(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_BitmapIndexedMapNode)))
}
function $asArrayOf_sci_BitmapIndexedMapNode(obj, depth) {
  return (($isArrayOf_sci_BitmapIndexedMapNode(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.BitmapIndexedMapNode;", depth))
}
var $d_sci_BitmapIndexedMapNode = new $TypeData().initClass({
  sci_BitmapIndexedMapNode: 0
}, false, "scala.collection.immutable.BitmapIndexedMapNode", {
  sci_BitmapIndexedMapNode: 1,
  sci_MapNode: 1,
  sci_Node: 1,
  O: 1
});
$c_sci_BitmapIndexedMapNode.prototype.$classData = $d_sci_BitmapIndexedMapNode;
/** @constructor */
function $c_sci_BitmapIndexedSetNode(dataMap, nodeMap, content, originalHashes, size, cachedJavaKeySetHashCode) {
  this.sci_BitmapIndexedSetNode__f_dataMap = 0;
  this.sci_BitmapIndexedSetNode__f_nodeMap = 0;
  this.sci_BitmapIndexedSetNode__f_content = null;
  this.sci_BitmapIndexedSetNode__f_originalHashes = null;
  this.sci_BitmapIndexedSetNode__f_size = 0;
  this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode = 0;
  this.sci_BitmapIndexedSetNode__f_dataMap = dataMap;
  this.sci_BitmapIndexedSetNode__f_nodeMap = nodeMap;
  this.sci_BitmapIndexedSetNode__f_content = content;
  this.sci_BitmapIndexedSetNode__f_originalHashes = originalHashes;
  this.sci_BitmapIndexedSetNode__f_size = size;
  this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode = cachedJavaKeySetHashCode
}
$c_sci_BitmapIndexedSetNode.prototype = new $h_sci_SetNode();
$c_sci_BitmapIndexedSetNode.prototype.constructor = $c_sci_BitmapIndexedSetNode;
/** @constructor */
function $h_sci_BitmapIndexedSetNode() {
  /*<skip>*/
}
$h_sci_BitmapIndexedSetNode.prototype = $c_sci_BitmapIndexedSetNode.prototype;
$c_sci_BitmapIndexedSetNode.prototype.size__I = (function() {
  return this.sci_BitmapIndexedSetNode__f_size
});
$c_sci_BitmapIndexedSetNode.prototype.cachedJavaKeySetHashCode__I = (function() {
  return this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode
});
$c_sci_BitmapIndexedSetNode.prototype.getPayload__I__O = (function(index) {
  return this.sci_BitmapIndexedSetNode__f_content.get(index)
});
$c_sci_BitmapIndexedSetNode.prototype.getHash__I__I = (function(index) {
  return this.sci_BitmapIndexedSetNode__f_originalHashes.get(index)
});
$c_sci_BitmapIndexedSetNode.prototype.getNode__I__sci_SetNode = (function(index) {
  return $as_sci_SetNode(this.sci_BitmapIndexedSetNode__f_content.get((((((-1) + this.sci_BitmapIndexedSetNode__f_content.u.length) | 0) - index) | 0)))
});
$c_sci_BitmapIndexedSetNode.prototype.contains__O__I__I__I__Z = (function(element, originalHash, elementHash, shift) {
  var mask = $m_sci_Node$().maskFrom__I__I__I(elementHash, shift);
  var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
  if (((this.sci_BitmapIndexedSetNode__f_dataMap & bitpos) !== 0)) {
    var index = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedSetNode__f_dataMap, mask, bitpos);
    return ((this.sci_BitmapIndexedSetNode__f_originalHashes.get(index) === originalHash) && $m_sr_BoxesRunTime$().equals__O__O__Z(element, this.getPayload__I__O(index)))
  };
  if (((this.sci_BitmapIndexedSetNode__f_nodeMap & bitpos) !== 0)) {
    var index$2 = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedSetNode__f_nodeMap, mask, bitpos);
    return this.getNode__I__sci_SetNode(index$2).contains__O__I__I__I__Z(element, originalHash, elementHash, ((5 + shift) | 0))
  };
  return false
});
$c_sci_BitmapIndexedSetNode.prototype.updated__O__I__I__I__sci_BitmapIndexedSetNode = (function(element, originalHash, elementHash, shift) {
  var mask = $m_sci_Node$().maskFrom__I__I__I(elementHash, shift);
  var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
  if (((this.sci_BitmapIndexedSetNode__f_dataMap & bitpos) !== 0)) {
    var index = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedSetNode__f_dataMap, mask, bitpos);
    var element0 = this.getPayload__I__O(index);
    if ($is(element0, element)) {
      return this
    } else {
      var element0UnimprovedHash = this.getHash__I__I(index);
      var element0Hash = $m_sc_Hashing$().improve__I__I(element0UnimprovedHash);
      if (((originalHash === element0UnimprovedHash) && $m_sr_BoxesRunTime$().equals__O__O__Z(element0, element))) {
        return this
      } else {
        var subNodeNew = this.mergeTwoKeyValPairs__O__I__I__O__I__I__I__sci_SetNode(element0, element0UnimprovedHash, element0Hash, element, originalHash, elementHash, ((5 + shift) | 0));
        return this.copyAndMigrateFromInlineToNode__I__I__sci_SetNode__sci_BitmapIndexedSetNode(bitpos, element0Hash, subNodeNew)
      }
    }
  };
  if (((this.sci_BitmapIndexedSetNode__f_nodeMap & bitpos) !== 0)) {
    var index$2 = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedSetNode__f_nodeMap, mask, bitpos);
    var subNode = this.getNode__I__sci_SetNode(index$2);
    var subNodeNew$2 = subNode.updated__O__I__I__I__sci_SetNode(element, originalHash, elementHash, ((5 + shift) | 0));
    if ((subNode === subNodeNew$2)) {
      return this
    } else {
      return this.copyAndSetNode__I__sci_SetNode__sci_SetNode__sci_BitmapIndexedSetNode(bitpos, subNode, subNodeNew$2)
    }
  };
  return this.copyAndInsertValue__I__O__I__I__sci_BitmapIndexedSetNode(bitpos, element, originalHash, elementHash)
});
$c_sci_BitmapIndexedSetNode.prototype.removed__O__I__I__I__sci_BitmapIndexedSetNode = (function(element, originalHash, elementHash, shift) {
  var mask = $m_sci_Node$().maskFrom__I__I__I(elementHash, shift);
  var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
  if (((this.sci_BitmapIndexedSetNode__f_dataMap & bitpos) !== 0)) {
    var index = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedSetNode__f_dataMap, mask, bitpos);
    var element0 = this.getPayload__I__O(index);
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(element0, element)) {
      var i = this.sci_BitmapIndexedSetNode__f_dataMap;
      if (($m_jl_Integer$().bitCount__I__I(i) === 2)) {
        var i$1 = this.sci_BitmapIndexedSetNode__f_nodeMap;
        var $$x1 = ($m_jl_Integer$().bitCount__I__I(i$1) === 0)
      } else {
        var $$x1 = false
      };
      if ($$x1) {
        var newDataMap = ((shift === 0) ? (this.sci_BitmapIndexedSetNode__f_dataMap ^ bitpos) : $m_sci_Node$().bitposFrom__I__I($m_sci_Node$().maskFrom__I__I__I(elementHash, 0)));
        if ((index === 0)) {
          var array = [this.getPayload__I__O(1)];
          var xs = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
          $m_s_reflect_ManifestFactory$AnyManifest$();
          var len = xs.length__I();
          var array$1 = new $ac_O(len);
          var this$7 = new $c_sc_IndexedSeqView$Id(xs);
          var iterator = new $c_sc_IndexedSeqView$IndexedSeqViewIterator(this$7);
          var i$2 = 0;
          while (iterator.hasNext__Z()) {
            array$1.set(i$2, iterator.next__O());
            i$2 = ((1 + i$2) | 0)
          };
          return new $c_sci_BitmapIndexedSetNode(newDataMap, 0, array$1, new $ac_I([this.sci_BitmapIndexedSetNode__f_originalHashes.get(1)]), (((-1) + this.sci_BitmapIndexedSetNode__f_size) | 0), $m_sc_Hashing$().improve__I__I(this.sci_BitmapIndexedSetNode__f_originalHashes.get(1)))
        } else {
          var array$2 = [this.getPayload__I__O(0)];
          var xs$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
          $m_s_reflect_ManifestFactory$AnyManifest$();
          var len$1 = xs$1.length__I();
          var array$3 = new $ac_O(len$1);
          var this$14 = new $c_sc_IndexedSeqView$Id(xs$1);
          var iterator$1 = new $c_sc_IndexedSeqView$IndexedSeqViewIterator(this$14);
          var i$3 = 0;
          while (iterator$1.hasNext__Z()) {
            array$3.set(i$3, iterator$1.next__O());
            i$3 = ((1 + i$3) | 0)
          };
          return new $c_sci_BitmapIndexedSetNode(newDataMap, 0, array$3, new $ac_I([this.sci_BitmapIndexedSetNode__f_originalHashes.get(0)]), (((-1) + this.sci_BitmapIndexedSetNode__f_size) | 0), $m_sc_Hashing$().improve__I__I(this.sci_BitmapIndexedSetNode__f_originalHashes.get(0)))
        }
      } else {
        return this.copyAndRemoveValue__I__I__sci_BitmapIndexedSetNode(bitpos, elementHash)
      }
    } else {
      return this
    }
  };
  if (((this.sci_BitmapIndexedSetNode__f_nodeMap & bitpos) !== 0)) {
    var index$2 = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedSetNode__f_nodeMap, mask, bitpos);
    var subNode = this.getNode__I__sci_SetNode(index$2);
    var subNodeNew = subNode.removed__O__I__I__I__sci_SetNode(element, originalHash, elementHash, ((5 + shift) | 0));
    if ((subNodeNew === subNode)) {
      return this
    };
    var subNodeNewSize = subNodeNew.size__I();
    if ((subNodeNewSize === 1)) {
      if ((this.sci_BitmapIndexedSetNode__f_size === subNode.size__I())) {
        return $as_sci_BitmapIndexedSetNode(subNodeNew)
      } else {
        return this.copyAndMigrateFromNodeToInline__I__I__sci_SetNode__sci_SetNode__sci_BitmapIndexedSetNode(bitpos, elementHash, subNode, subNodeNew)
      }
    } else if ((subNodeNewSize > 1)) {
      return this.copyAndSetNode__I__sci_SetNode__sci_SetNode__sci_BitmapIndexedSetNode(bitpos, subNode, subNodeNew)
    }
  };
  return this
});
$c_sci_BitmapIndexedSetNode.prototype.mergeTwoKeyValPairs__O__I__I__O__I__I__I__sci_SetNode = (function(key0, originalKeyHash0, keyHash0, key1, originalKeyHash1, keyHash1, shift) {
  if ((shift >= 32)) {
    var this$4 = $m_sci_Vector$();
    var array = [key0, key1];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    return new $c_sci_HashCollisionSetNode(originalKeyHash0, keyHash0, this$4.from__sc_IterableOnce__sci_Vector(elems))
  } else {
    var mask0 = $m_sci_Node$().maskFrom__I__I__I(keyHash0, shift);
    var mask1 = $m_sci_Node$().maskFrom__I__I__I(keyHash1, shift);
    if ((mask0 !== mask1)) {
      var dataMap = ($m_sci_Node$().bitposFrom__I__I(mask0) | $m_sci_Node$().bitposFrom__I__I(mask1));
      var newCachedHashCode = ((keyHash0 + keyHash1) | 0);
      if ((mask0 < mask1)) {
        var array$1 = [key0, key1];
        var xs = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
        $m_s_reflect_ManifestFactory$AnyManifest$();
        var len = xs.length__I();
        var array$2 = new $ac_O(len);
        var this$11 = new $c_sc_IndexedSeqView$Id(xs);
        var iterator = new $c_sc_IndexedSeqView$IndexedSeqViewIterator(this$11);
        var i = 0;
        while (iterator.hasNext__Z()) {
          array$2.set(i, iterator.next__O());
          i = ((1 + i) | 0)
        };
        return new $c_sci_BitmapIndexedSetNode(dataMap, 0, array$2, new $ac_I([originalKeyHash0, originalKeyHash1]), 2, newCachedHashCode)
      } else {
        var array$3 = [key1, key0];
        var xs$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3);
        $m_s_reflect_ManifestFactory$AnyManifest$();
        var len$1 = xs$1.length__I();
        var array$4 = new $ac_O(len$1);
        var this$18 = new $c_sc_IndexedSeqView$Id(xs$1);
        var iterator$1 = new $c_sc_IndexedSeqView$IndexedSeqViewIterator(this$18);
        var i$1 = 0;
        while (iterator$1.hasNext__Z()) {
          array$4.set(i$1, iterator$1.next__O());
          i$1 = ((1 + i$1) | 0)
        };
        return new $c_sci_BitmapIndexedSetNode(dataMap, 0, array$4, new $ac_I([originalKeyHash1, originalKeyHash0]), 2, newCachedHashCode)
      }
    } else {
      var nodeMap = $m_sci_Node$().bitposFrom__I__I(mask0);
      var node = this.mergeTwoKeyValPairs__O__I__I__O__I__I__I__sci_SetNode(key0, originalKeyHash0, keyHash0, key1, originalKeyHash1, keyHash1, ((5 + shift) | 0));
      var array$5 = [node];
      var xs$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5);
      $m_s_reflect_ManifestFactory$AnyManifest$();
      var len$2 = xs$2.length__I();
      var array$6 = new $ac_O(len$2);
      var this$25 = new $c_sc_IndexedSeqView$Id(xs$2);
      var iterator$2 = new $c_sc_IndexedSeqView$IndexedSeqViewIterator(this$25);
      var i$2 = 0;
      while (iterator$2.hasNext__Z()) {
        array$6.set(i$2, iterator$2.next__O());
        i$2 = ((1 + i$2) | 0)
      };
      return new $c_sci_BitmapIndexedSetNode(0, nodeMap, array$6, $m_s_Array$EmptyArrays$().s_Array$EmptyArrays$__f_emptyIntArray, node.size__I(), node.cachedJavaKeySetHashCode__I())
    }
  }
});
$c_sci_BitmapIndexedSetNode.prototype.hasPayload__Z = (function() {
  return (this.sci_BitmapIndexedSetNode__f_dataMap !== 0)
});
$c_sci_BitmapIndexedSetNode.prototype.payloadArity__I = (function() {
  var i = this.sci_BitmapIndexedSetNode__f_dataMap;
  return $m_jl_Integer$().bitCount__I__I(i)
});
$c_sci_BitmapIndexedSetNode.prototype.hasNodes__Z = (function() {
  return (this.sci_BitmapIndexedSetNode__f_nodeMap !== 0)
});
$c_sci_BitmapIndexedSetNode.prototype.nodeArity__I = (function() {
  var i = this.sci_BitmapIndexedSetNode__f_nodeMap;
  return $m_jl_Integer$().bitCount__I__I(i)
});
$c_sci_BitmapIndexedSetNode.prototype.dataIndex__I__I = (function(bitpos) {
  var i = (this.sci_BitmapIndexedSetNode__f_dataMap & (((-1) + bitpos) | 0));
  return $m_jl_Integer$().bitCount__I__I(i)
});
$c_sci_BitmapIndexedSetNode.prototype.nodeIndex__I__I = (function(bitpos) {
  var i = (this.sci_BitmapIndexedSetNode__f_nodeMap & (((-1) + bitpos) | 0));
  return $m_jl_Integer$().bitCount__I__I(i)
});
$c_sci_BitmapIndexedSetNode.prototype.copyAndSetNode__I__sci_SetNode__sci_SetNode__sci_BitmapIndexedSetNode = (function(bitpos, oldNode, newNode) {
  var idx = (((((-1) + this.sci_BitmapIndexedSetNode__f_content.u.length) | 0) - this.nodeIndex__I__I(bitpos)) | 0);
  var src = this.sci_BitmapIndexedSetNode__f_content;
  var dst = new $ac_O(src.u.length);
  var length = src.u.length;
  $systemArraycopy(src, 0, dst, 0, length);
  dst.set(idx, newNode);
  return new $c_sci_BitmapIndexedSetNode(this.sci_BitmapIndexedSetNode__f_dataMap, this.sci_BitmapIndexedSetNode__f_nodeMap, dst, this.sci_BitmapIndexedSetNode__f_originalHashes, ((((this.sci_BitmapIndexedSetNode__f_size - oldNode.size__I()) | 0) + newNode.size__I()) | 0), ((((this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode - oldNode.cachedJavaKeySetHashCode__I()) | 0) + newNode.cachedJavaKeySetHashCode__I()) | 0))
});
$c_sci_BitmapIndexedSetNode.prototype.copyAndInsertValue__I__O__I__I__sci_BitmapIndexedSetNode = (function(bitpos, key, originalHash, elementHash) {
  var dataIx = this.dataIndex__I__I(bitpos);
  var src = this.sci_BitmapIndexedSetNode__f_content;
  var dst = new $ac_O(((1 + src.u.length) | 0));
  $systemArraycopy(src, 0, dst, 0, dataIx);
  dst.set(dataIx, key);
  var destPos = ((1 + dataIx) | 0);
  var length = ((src.u.length - dataIx) | 0);
  $systemArraycopy(src, dataIx, dst, destPos, length);
  var dstHashes = this.insertElement__AI__I__I__AI(this.sci_BitmapIndexedSetNode__f_originalHashes, dataIx, originalHash);
  return new $c_sci_BitmapIndexedSetNode((this.sci_BitmapIndexedSetNode__f_dataMap | bitpos), this.sci_BitmapIndexedSetNode__f_nodeMap, dst, dstHashes, ((1 + this.sci_BitmapIndexedSetNode__f_size) | 0), ((this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode + elementHash) | 0))
});
$c_sci_BitmapIndexedSetNode.prototype.copyAndRemoveValue__I__I__sci_BitmapIndexedSetNode = (function(bitpos, elementHash) {
  var dataIx = this.dataIndex__I__I(bitpos);
  var src = this.sci_BitmapIndexedSetNode__f_content;
  var dst = new $ac_O((((-1) + src.u.length) | 0));
  $systemArraycopy(src, 0, dst, 0, dataIx);
  var srcPos = ((1 + dataIx) | 0);
  var length = (((-1) + ((src.u.length - dataIx) | 0)) | 0);
  $systemArraycopy(src, srcPos, dst, dataIx, length);
  var dstHashes = this.removeElement__AI__I__AI(this.sci_BitmapIndexedSetNode__f_originalHashes, dataIx);
  return new $c_sci_BitmapIndexedSetNode((this.sci_BitmapIndexedSetNode__f_dataMap ^ bitpos), this.sci_BitmapIndexedSetNode__f_nodeMap, dst, dstHashes, (((-1) + this.sci_BitmapIndexedSetNode__f_size) | 0), ((this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode - elementHash) | 0))
});
$c_sci_BitmapIndexedSetNode.prototype.copyAndMigrateFromInlineToNode__I__I__sci_SetNode__sci_BitmapIndexedSetNode = (function(bitpos, elementHash, node) {
  var dataIx = this.dataIndex__I__I(bitpos);
  var idxNew = (((((-1) + this.sci_BitmapIndexedSetNode__f_content.u.length) | 0) - this.nodeIndex__I__I(bitpos)) | 0);
  var src = this.sci_BitmapIndexedSetNode__f_content;
  var dst = new $ac_O(src.u.length);
  $systemArraycopy(src, 0, dst, 0, dataIx);
  var srcPos = ((1 + dataIx) | 0);
  var length = ((idxNew - dataIx) | 0);
  $systemArraycopy(src, srcPos, dst, dataIx, length);
  dst.set(idxNew, node);
  var srcPos$1 = ((1 + idxNew) | 0);
  var destPos = ((1 + idxNew) | 0);
  var length$1 = (((-1) + ((src.u.length - idxNew) | 0)) | 0);
  $systemArraycopy(src, srcPos$1, dst, destPos, length$1);
  var dstHashes = this.removeElement__AI__I__AI(this.sci_BitmapIndexedSetNode__f_originalHashes, dataIx);
  return new $c_sci_BitmapIndexedSetNode((this.sci_BitmapIndexedSetNode__f_dataMap ^ bitpos), (this.sci_BitmapIndexedSetNode__f_nodeMap | bitpos), dst, dstHashes, (((((-1) + this.sci_BitmapIndexedSetNode__f_size) | 0) + node.size__I()) | 0), ((((this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode - elementHash) | 0) + node.cachedJavaKeySetHashCode__I()) | 0))
});
$c_sci_BitmapIndexedSetNode.prototype.migrateFromInlineToNodeInPlace__I__I__sci_SetNode__sci_BitmapIndexedSetNode = (function(bitpos, keyHash, node) {
  var dataIx = this.dataIndex__I__I(bitpos);
  var idxNew = (((((-1) + this.sci_BitmapIndexedSetNode__f_content.u.length) | 0) - this.nodeIndex__I__I(bitpos)) | 0);
  var src = this.sci_BitmapIndexedSetNode__f_content;
  var srcPos = ((1 + dataIx) | 0);
  var dest = this.sci_BitmapIndexedSetNode__f_content;
  var length = ((idxNew - dataIx) | 0);
  $systemArraycopy(src, srcPos, dest, dataIx, length);
  this.sci_BitmapIndexedSetNode__f_content.set(idxNew, node);
  this.sci_BitmapIndexedSetNode__f_dataMap = (this.sci_BitmapIndexedSetNode__f_dataMap ^ bitpos);
  this.sci_BitmapIndexedSetNode__f_nodeMap = (this.sci_BitmapIndexedSetNode__f_nodeMap | bitpos);
  this.sci_BitmapIndexedSetNode__f_originalHashes = this.removeElement__AI__I__AI(this.sci_BitmapIndexedSetNode__f_originalHashes, dataIx);
  this.sci_BitmapIndexedSetNode__f_size = (((((-1) + this.sci_BitmapIndexedSetNode__f_size) | 0) + node.size__I()) | 0);
  this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode = ((((this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode - keyHash) | 0) + node.cachedJavaKeySetHashCode__I()) | 0);
  return this
});
$c_sci_BitmapIndexedSetNode.prototype.copyAndMigrateFromNodeToInline__I__I__sci_SetNode__sci_SetNode__sci_BitmapIndexedSetNode = (function(bitpos, elementHash, oldNode, node) {
  var idxOld = (((((-1) + this.sci_BitmapIndexedSetNode__f_content.u.length) | 0) - this.nodeIndex__I__I(bitpos)) | 0);
  var dataIxNew = this.dataIndex__I__I(bitpos);
  var src = this.sci_BitmapIndexedSetNode__f_content;
  var dst = new $ac_O(src.u.length);
  $systemArraycopy(src, 0, dst, 0, dataIxNew);
  dst.set(dataIxNew, node.getPayload__I__O(0));
  var destPos = ((1 + dataIxNew) | 0);
  var length = ((idxOld - dataIxNew) | 0);
  $systemArraycopy(src, dataIxNew, dst, destPos, length);
  var srcPos = ((1 + idxOld) | 0);
  var destPos$1 = ((1 + idxOld) | 0);
  var length$1 = (((-1) + ((src.u.length - idxOld) | 0)) | 0);
  $systemArraycopy(src, srcPos, dst, destPos$1, length$1);
  var hash = node.getHash__I__I(0);
  var dstHashes = this.insertElement__AI__I__I__AI(this.sci_BitmapIndexedSetNode__f_originalHashes, dataIxNew, hash);
  return new $c_sci_BitmapIndexedSetNode((this.sci_BitmapIndexedSetNode__f_dataMap | bitpos), (this.sci_BitmapIndexedSetNode__f_nodeMap ^ bitpos), dst, dstHashes, ((1 + ((this.sci_BitmapIndexedSetNode__f_size - oldNode.size__I()) | 0)) | 0), ((((this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode - oldNode.cachedJavaKeySetHashCode__I()) | 0) + node.cachedJavaKeySetHashCode__I()) | 0))
});
$c_sci_BitmapIndexedSetNode.prototype.foreach__F1__V = (function(f) {
  var i = this.sci_BitmapIndexedSetNode__f_dataMap;
  var thisPayloadArity = $m_jl_Integer$().bitCount__I__I(i);
  var i$1 = 0;
  while ((i$1 < thisPayloadArity)) {
    f.apply__O__O(this.getPayload__I__O(i$1));
    i$1 = ((1 + i$1) | 0)
  };
  var i$2 = this.sci_BitmapIndexedSetNode__f_nodeMap;
  var thisNodeArity = $m_jl_Integer$().bitCount__I__I(i$2);
  var j = 0;
  while ((j < thisNodeArity)) {
    this.getNode__I__sci_SetNode(j).foreach__F1__V(f);
    j = ((1 + j) | 0)
  }
});
$c_sci_BitmapIndexedSetNode.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_BitmapIndexedSetNode)) {
    var x2 = $as_sci_BitmapIndexedSetNode(that);
    if ((this === x2)) {
      return true
    } else {
      if (((((this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode === x2.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode) && (this.sci_BitmapIndexedSetNode__f_nodeMap === x2.sci_BitmapIndexedSetNode__f_nodeMap)) && (this.sci_BitmapIndexedSetNode__f_dataMap === x2.sci_BitmapIndexedSetNode__f_dataMap)) && (this.sci_BitmapIndexedSetNode__f_size === x2.sci_BitmapIndexedSetNode__f_size))) {
        var a = this.sci_BitmapIndexedSetNode__f_originalHashes;
        var b = x2.sci_BitmapIndexedSetNode__f_originalHashes;
        var $$x1 = $m_ju_Arrays$().equals__AI__AI__Z(a, b)
      } else {
        var $$x1 = false
      };
      if ($$x1) {
        var a1 = this.sci_BitmapIndexedSetNode__f_content;
        var a2 = x2.sci_BitmapIndexedSetNode__f_content;
        var length = this.sci_BitmapIndexedSetNode__f_content.u.length;
        if ((a1 === a2)) {
          return true
        } else {
          var isEqual = true;
          var i = 0;
          while ((isEqual && (i < length))) {
            isEqual = $m_sr_BoxesRunTime$().equals__O__O__Z(a1.get(i), a2.get(i));
            i = ((1 + i) | 0)
          };
          return isEqual
        }
      } else {
        return false
      }
    }
  } else {
    return false
  }
});
$c_sci_BitmapIndexedSetNode.prototype.hashCode__I = (function() {
  throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "Trie nodes do not support hashing.")
});
$c_sci_BitmapIndexedSetNode.prototype.copy__sci_BitmapIndexedSetNode = (function() {
  var this$1 = this.sci_BitmapIndexedSetNode__f_content;
  var contentClone = this$1.clone__O();
  var contentLength = contentClone.u.length;
  var i = this.sci_BitmapIndexedSetNode__f_dataMap;
  var i$1 = $m_jl_Integer$().bitCount__I__I(i);
  while ((i$1 < contentLength)) {
    contentClone.set(i$1, $as_sci_SetNode(contentClone.get(i$1)).copy__sci_SetNode());
    i$1 = ((1 + i$1) | 0)
  };
  var $$x2 = this.sci_BitmapIndexedSetNode__f_dataMap;
  var $$x1 = this.sci_BitmapIndexedSetNode__f_nodeMap;
  var this$2 = this.sci_BitmapIndexedSetNode__f_originalHashes;
  return new $c_sci_BitmapIndexedSetNode($$x2, $$x1, contentClone, this$2.clone__O(), this.sci_BitmapIndexedSetNode__f_size, this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode)
});
$c_sci_BitmapIndexedSetNode.prototype.copy__sci_SetNode = (function() {
  return this.copy__sci_BitmapIndexedSetNode()
});
$c_sci_BitmapIndexedSetNode.prototype.removed__O__I__I__I__sci_SetNode = (function(element, originalHash, hash, shift) {
  return this.removed__O__I__I__I__sci_BitmapIndexedSetNode(element, originalHash, hash, shift)
});
$c_sci_BitmapIndexedSetNode.prototype.updated__O__I__I__I__sci_SetNode = (function(element, originalHash, hash, shift) {
  return this.updated__O__I__I__I__sci_BitmapIndexedSetNode(element, originalHash, hash, shift)
});
$c_sci_BitmapIndexedSetNode.prototype.getNode__I__sci_Node = (function(index) {
  return this.getNode__I__sci_SetNode(index)
});
function $as_sci_BitmapIndexedSetNode(obj) {
  return (((obj instanceof $c_sci_BitmapIndexedSetNode) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.BitmapIndexedSetNode"))
}
function $isArrayOf_sci_BitmapIndexedSetNode(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_BitmapIndexedSetNode)))
}
function $asArrayOf_sci_BitmapIndexedSetNode(obj, depth) {
  return (($isArrayOf_sci_BitmapIndexedSetNode(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.BitmapIndexedSetNode;", depth))
}
var $d_sci_BitmapIndexedSetNode = new $TypeData().initClass({
  sci_BitmapIndexedSetNode: 0
}, false, "scala.collection.immutable.BitmapIndexedSetNode", {
  sci_BitmapIndexedSetNode: 1,
  sci_SetNode: 1,
  sci_Node: 1,
  O: 1
});
$c_sci_BitmapIndexedSetNode.prototype.$classData = $d_sci_BitmapIndexedSetNode;
/** @constructor */
function $c_sci_HashCollisionMapNode(originalHash, hash, content) {
  this.sci_HashCollisionMapNode__f_originalHash = 0;
  this.sci_HashCollisionMapNode__f_hash = 0;
  this.sci_HashCollisionMapNode__f_content = null;
  this.sci_HashCollisionMapNode__f_originalHash = originalHash;
  this.sci_HashCollisionMapNode__f_hash = hash;
  this.sci_HashCollisionMapNode__f_content = content;
  $m_s_Predef$().require__Z__V((this.sci_HashCollisionMapNode__f_content.length__I() >= 2))
}
$c_sci_HashCollisionMapNode.prototype = new $h_sci_MapNode();
$c_sci_HashCollisionMapNode.prototype.constructor = $c_sci_HashCollisionMapNode;
/** @constructor */
function $h_sci_HashCollisionMapNode() {
  /*<skip>*/
}
$h_sci_HashCollisionMapNode.prototype = $c_sci_HashCollisionMapNode.prototype;
$c_sci_HashCollisionMapNode.prototype.indexOf__O__I = (function(key) {
  var iter = this.sci_HashCollisionMapNode__f_content.iterator__sc_Iterator();
  var i = 0;
  while (iter.hasNext__Z()) {
    if ($m_sr_BoxesRunTime$().equals__O__O__Z($as_T2(iter.next__O())._1__O(), key)) {
      return i
    };
    i = ((1 + i) | 0)
  };
  return (-1)
});
$c_sci_HashCollisionMapNode.prototype.size__I = (function() {
  return this.sci_HashCollisionMapNode__f_content.length__I()
});
$c_sci_HashCollisionMapNode.prototype.apply__O__I__I__I__O = (function(key, originalHash, hash, shift) {
  var this$1 = this.get__O__I__I__I__s_Option(key, originalHash, hash, shift);
  if (this$1.isEmpty__Z()) {
    throw $ct_ju_NoSuchElementException__(new $c_ju_NoSuchElementException())
  } else {
    return this$1.get__O()
  }
});
$c_sci_HashCollisionMapNode.prototype.get__O__I__I__I__s_Option = (function(key, originalHash, hash, shift) {
  if ((this.sci_HashCollisionMapNode__f_hash === hash)) {
    var index = this.indexOf__O__I(key);
    return ((index >= 0) ? new $c_s_Some($as_T2(this.sci_HashCollisionMapNode__f_content.apply__I__O(index))._2__O()) : $m_s_None$())
  } else {
    return $m_s_None$()
  }
});
$c_sci_HashCollisionMapNode.prototype.getOrElse__O__I__I__I__F0__O = (function(key, originalHash, hash, shift, f) {
  if ((this.sci_HashCollisionMapNode__f_hash === hash)) {
    var x1 = this.indexOf__O__I(key);
    return ((x1 === (-1)) ? f.apply__O() : $as_T2(this.sci_HashCollisionMapNode__f_content.apply__I__O(x1))._2__O())
  } else {
    return f.apply__O()
  }
});
$c_sci_HashCollisionMapNode.prototype.containsKey__O__I__I__I__Z = (function(key, originalHash, hash, shift) {
  return ((this.sci_HashCollisionMapNode__f_hash === hash) && (this.indexOf__O__I(key) >= 0))
});
$c_sci_HashCollisionMapNode.prototype.updated__O__O__I__I__I__Z__sci_MapNode = (function(key, value, originalHash, hash, shift, replaceValue) {
  var index = this.indexOf__O__I(key);
  return ((index >= 0) ? (replaceValue ? ($is($as_T2(this.sci_HashCollisionMapNode__f_content.apply__I__O(index))._2__O(), value) ? this : new $c_sci_HashCollisionMapNode(originalHash, hash, this.sci_HashCollisionMapNode__f_content.updated__I__O__sci_Vector(index, new $c_T2(key, value)))) : this) : new $c_sci_HashCollisionMapNode(originalHash, hash, this.sci_HashCollisionMapNode__f_content.appended__O__sci_Vector(new $c_T2(key, value))))
});
$c_sci_HashCollisionMapNode.prototype.removed__O__I__I__I__sci_MapNode = (function(key, originalHash, hash, shift) {
  if ((!this.containsKey__O__I__I__I__Z(key, originalHash, hash, shift))) {
    return this
  } else {
    var this$2 = this.sci_HashCollisionMapNode__f_content;
    var pred = new $c_sjsr_AnonFunction1((function(this$1, key$1) {
      return (function(keyValuePair$2) {
        var keyValuePair = $as_T2(keyValuePair$2);
        return $m_sr_BoxesRunTime$().equals__O__O__Z(keyValuePair._1__O(), key$1)
      })
    })(this, key));
    var updatedContent = this$2.filterImpl__F1__Z__sci_Vector(pred, true);
    var x1 = updatedContent.length__I();
    if ((x1 === 1)) {
      var x1$2 = $as_T2(updatedContent.apply__I__O(0));
      if ((x1$2 === null)) {
        throw new $c_s_MatchError(x1$2)
      };
      var k = x1$2._1__O();
      var v = x1$2._2__O();
      var $$x1 = $m_sci_Node$().bitposFrom__I__I($m_sci_Node$().maskFrom__I__I__I(hash, 0));
      var array = [k, v];
      var xs = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
      $m_s_reflect_ManifestFactory$AnyManifest$();
      var len = xs.length__I();
      var array$1 = new $ac_O(len);
      var this$9 = new $c_sc_IndexedSeqView$Id(xs);
      var iterator = new $c_sc_IndexedSeqView$IndexedSeqViewIterator(this$9);
      var i = 0;
      while (iterator.hasNext__Z()) {
        array$1.set(i, iterator.next__O());
        i = ((1 + i) | 0)
      };
      return new $c_sci_BitmapIndexedMapNode($$x1, 0, array$1, new $ac_I([originalHash]), 1, hash)
    } else {
      return new $c_sci_HashCollisionMapNode(originalHash, hash, updatedContent)
    }
  }
});
$c_sci_HashCollisionMapNode.prototype.hasNodes__Z = (function() {
  return false
});
$c_sci_HashCollisionMapNode.prototype.nodeArity__I = (function() {
  return 0
});
$c_sci_HashCollisionMapNode.prototype.getNode__I__sci_MapNode = (function(index) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), "No sub-nodes present in hash-collision leaf node.")
});
$c_sci_HashCollisionMapNode.prototype.hasPayload__Z = (function() {
  return true
});
$c_sci_HashCollisionMapNode.prototype.payloadArity__I = (function() {
  return this.sci_HashCollisionMapNode__f_content.length__I()
});
$c_sci_HashCollisionMapNode.prototype.getKey__I__O = (function(index) {
  return $as_T2(this.sci_HashCollisionMapNode__f_content.apply__I__O(index))._1__O()
});
$c_sci_HashCollisionMapNode.prototype.getValue__I__O = (function(index) {
  return $as_T2(this.sci_HashCollisionMapNode__f_content.apply__I__O(index))._2__O()
});
$c_sci_HashCollisionMapNode.prototype.getPayload__I__T2 = (function(index) {
  return $as_T2(this.sci_HashCollisionMapNode__f_content.apply__I__O(index))
});
$c_sci_HashCollisionMapNode.prototype.getHash__I__I = (function(index) {
  return this.sci_HashCollisionMapNode__f_originalHash
});
$c_sci_HashCollisionMapNode.prototype.foreach__F1__V = (function(f) {
  this.sci_HashCollisionMapNode__f_content.foreach__F1__V(f)
});
$c_sci_HashCollisionMapNode.prototype.foreachEntry__F2__V = (function(f) {
  this.sci_HashCollisionMapNode__f_content.foreach__F1__V(new $c_sjsr_AnonFunction1((function(this$1, f$1) {
    return (function(x0$1$2) {
      var x0$1 = $as_T2(x0$1$2);
      if ((x0$1 !== null)) {
        var k = x0$1._1__O();
        var v = x0$1._2__O();
        return f$1.apply__O__O__O(k, v)
      } else {
        throw new $c_s_MatchError(x0$1)
      }
    })
  })(this, f)))
});
$c_sci_HashCollisionMapNode.prototype.foreachWithHash__F3__V = (function(f) {
  var iter = this.sci_HashCollisionMapNode__f_content.iterator__sc_Iterator();
  while (iter.hasNext__Z()) {
    var next = $as_T2(iter.next__O());
    f.apply__O__O__O__O(next._1__O(), next._2__O(), this.sci_HashCollisionMapNode__f_originalHash)
  }
});
$c_sci_HashCollisionMapNode.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_HashCollisionMapNode)) {
    var x2 = $as_sci_HashCollisionMapNode(that);
    if ((this === x2)) {
      return true
    } else if (((this.sci_HashCollisionMapNode__f_hash === x2.sci_HashCollisionMapNode__f_hash) && (this.sci_HashCollisionMapNode__f_content.length__I() === x2.sci_HashCollisionMapNode__f_content.length__I()))) {
      var iter = this.sci_HashCollisionMapNode__f_content.iterator__sc_Iterator();
      while (iter.hasNext__Z()) {
        var x1$2 = $as_T2(iter.next__O());
        if ((x1$2 === null)) {
          throw new $c_s_MatchError(x1$2)
        };
        var key = x1$2._1__O();
        var value = x1$2._2__O();
        var index = x2.indexOf__O__I(key);
        if (((index < 0) || (!$m_sr_BoxesRunTime$().equals__O__O__Z(value, $as_T2(x2.sci_HashCollisionMapNode__f_content.apply__I__O(index))._2__O())))) {
          return false
        }
      };
      return true
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_sci_HashCollisionMapNode.prototype.concat__sci_MapNode__I__sci_HashCollisionMapNode = (function(that, shift) {
  if ((that instanceof $c_sci_HashCollisionMapNode)) {
    var x2 = $as_sci_HashCollisionMapNode(that);
    if ((x2 === this)) {
      return this
    } else {
      var newContent = null;
      var iter = this.sci_HashCollisionMapNode__f_content.iterator__sc_Iterator();
      while (iter.hasNext__Z()) {
        var nextPayload = $as_T2(iter.next__O());
        if ((x2.indexOf__O__I(nextPayload._1__O()) < 0)) {
          if ((newContent === null)) {
            newContent = new $c_sci_VectorBuilder();
            newContent.addAll__sc_IterableOnce__sci_VectorBuilder(x2.sci_HashCollisionMapNode__f_content)
          };
          newContent.addOne__O__sci_VectorBuilder(nextPayload)
        }
      };
      return ((newContent === null) ? x2 : new $c_sci_HashCollisionMapNode(this.sci_HashCollisionMapNode__f_originalHash, this.sci_HashCollisionMapNode__f_hash, newContent.result__sci_Vector()))
    }
  } else if ((that instanceof $c_sci_BitmapIndexedMapNode)) {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "Cannot concatenate a HashCollisionMapNode with a BitmapIndexedMapNode")
  } else {
    throw new $c_s_MatchError(that)
  }
});
$c_sci_HashCollisionMapNode.prototype.hashCode__I = (function() {
  throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "Trie nodes do not support hashing.")
});
$c_sci_HashCollisionMapNode.prototype.cachedJavaKeySetHashCode__I = (function() {
  return $imul(this.sci_HashCollisionMapNode__f_content.length__I(), this.sci_HashCollisionMapNode__f_hash)
});
$c_sci_HashCollisionMapNode.prototype.copy__sci_MapNode = (function() {
  return new $c_sci_HashCollisionMapNode(this.sci_HashCollisionMapNode__f_originalHash, this.sci_HashCollisionMapNode__f_hash, this.sci_HashCollisionMapNode__f_content)
});
$c_sci_HashCollisionMapNode.prototype.concat__sci_MapNode__I__sci_MapNode = (function(that, shift) {
  return this.concat__sci_MapNode__I__sci_HashCollisionMapNode(that, shift)
});
$c_sci_HashCollisionMapNode.prototype.getNode__I__sci_Node = (function(index) {
  return this.getNode__I__sci_MapNode(index)
});
function $as_sci_HashCollisionMapNode(obj) {
  return (((obj instanceof $c_sci_HashCollisionMapNode) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.HashCollisionMapNode"))
}
function $isArrayOf_sci_HashCollisionMapNode(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_HashCollisionMapNode)))
}
function $asArrayOf_sci_HashCollisionMapNode(obj, depth) {
  return (($isArrayOf_sci_HashCollisionMapNode(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.HashCollisionMapNode;", depth))
}
var $d_sci_HashCollisionMapNode = new $TypeData().initClass({
  sci_HashCollisionMapNode: 0
}, false, "scala.collection.immutable.HashCollisionMapNode", {
  sci_HashCollisionMapNode: 1,
  sci_MapNode: 1,
  sci_Node: 1,
  O: 1
});
$c_sci_HashCollisionMapNode.prototype.$classData = $d_sci_HashCollisionMapNode;
/** @constructor */
function $c_sci_HashCollisionSetNode(originalHash, hash, content) {
  this.sci_HashCollisionSetNode__f_originalHash = 0;
  this.sci_HashCollisionSetNode__f_hash = 0;
  this.sci_HashCollisionSetNode__f_content = null;
  this.sci_HashCollisionSetNode__f_originalHash = originalHash;
  this.sci_HashCollisionSetNode__f_hash = hash;
  this.sci_HashCollisionSetNode__f_content = content;
  $m_s_Predef$().require__Z__V((this.sci_HashCollisionSetNode__f_content.length__I() >= 2))
}
$c_sci_HashCollisionSetNode.prototype = new $h_sci_SetNode();
$c_sci_HashCollisionSetNode.prototype.constructor = $c_sci_HashCollisionSetNode;
/** @constructor */
function $h_sci_HashCollisionSetNode() {
  /*<skip>*/
}
$h_sci_HashCollisionSetNode.prototype = $c_sci_HashCollisionSetNode.prototype;
$c_sci_HashCollisionSetNode.prototype.contains__O__I__I__I__Z = (function(element, originalHash, hash, shift) {
  if ((this.sci_HashCollisionSetNode__f_hash === hash)) {
    var this$1 = this.sci_HashCollisionSetNode__f_content;
    return $f_sc_SeqOps__contains__O__Z(this$1, element)
  } else {
    return false
  }
});
$c_sci_HashCollisionSetNode.prototype.updated__O__I__I__I__sci_SetNode = (function(element, originalHash, hash, shift) {
  return (this.contains__O__I__I__I__Z(element, originalHash, hash, shift) ? this : new $c_sci_HashCollisionSetNode(originalHash, hash, this.sci_HashCollisionSetNode__f_content.appended__O__sci_Vector(element)))
});
$c_sci_HashCollisionSetNode.prototype.removed__O__I__I__I__sci_SetNode = (function(element, originalHash, hash, shift) {
  if ((!this.contains__O__I__I__I__Z(element, originalHash, hash, shift))) {
    return this
  } else {
    var this$2 = this.sci_HashCollisionSetNode__f_content;
    var pred = new $c_sjsr_AnonFunction1((function(this$1, element$1) {
      return (function(element0$2) {
        return $m_sr_BoxesRunTime$().equals__O__O__Z(element0$2, element$1)
      })
    })(this, element));
    var updatedContent = this$2.filterImpl__F1__Z__sci_Vector(pred, true);
    var x1 = updatedContent.length__I();
    if ((x1 === 1)) {
      var $$x1 = $m_sci_Node$().bitposFrom__I__I($m_sci_Node$().maskFrom__I__I__I(hash, 0));
      var array = [updatedContent.apply__I__O(0)];
      var xs = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
      $m_s_reflect_ManifestFactory$AnyManifest$();
      var len = xs.length__I();
      var array$1 = new $ac_O(len);
      var this$9 = new $c_sc_IndexedSeqView$Id(xs);
      var iterator = new $c_sc_IndexedSeqView$IndexedSeqViewIterator(this$9);
      var i = 0;
      while (iterator.hasNext__Z()) {
        array$1.set(i, iterator.next__O());
        i = ((1 + i) | 0)
      };
      return new $c_sci_BitmapIndexedSetNode($$x1, 0, array$1, new $ac_I([originalHash]), 1, hash)
    } else {
      return new $c_sci_HashCollisionSetNode(originalHash, hash, updatedContent)
    }
  }
});
$c_sci_HashCollisionSetNode.prototype.hasNodes__Z = (function() {
  return false
});
$c_sci_HashCollisionSetNode.prototype.nodeArity__I = (function() {
  return 0
});
$c_sci_HashCollisionSetNode.prototype.getNode__I__sci_SetNode = (function(index) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), "No sub-nodes present in hash-collision leaf node.")
});
$c_sci_HashCollisionSetNode.prototype.hasPayload__Z = (function() {
  return true
});
$c_sci_HashCollisionSetNode.prototype.payloadArity__I = (function() {
  return this.sci_HashCollisionSetNode__f_content.length__I()
});
$c_sci_HashCollisionSetNode.prototype.getPayload__I__O = (function(index) {
  return this.sci_HashCollisionSetNode__f_content.apply__I__O(index)
});
$c_sci_HashCollisionSetNode.prototype.getHash__I__I = (function(index) {
  return this.sci_HashCollisionSetNode__f_originalHash
});
$c_sci_HashCollisionSetNode.prototype.size__I = (function() {
  return this.sci_HashCollisionSetNode__f_content.length__I()
});
$c_sci_HashCollisionSetNode.prototype.foreach__F1__V = (function(f) {
  var iter = this.sci_HashCollisionSetNode__f_content.iterator__sc_Iterator();
  while (iter.hasNext__Z()) {
    f.apply__O__O(iter.next__O())
  }
});
$c_sci_HashCollisionSetNode.prototype.cachedJavaKeySetHashCode__I = (function() {
  return $imul(this.sci_HashCollisionSetNode__f_content.length__I(), this.sci_HashCollisionSetNode__f_hash)
});
$c_sci_HashCollisionSetNode.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_HashCollisionSetNode)) {
    var x2 = $as_sci_HashCollisionSetNode(that);
    if ((this === x2)) {
      return true
    } else {
      if ((this.sci_HashCollisionSetNode__f_hash === x2.sci_HashCollisionSetNode__f_hash)) {
        var this$1 = this.sci_HashCollisionSetNode__f_content;
        var $$x2 = this$1.length__I();
        var this$2 = x2.sci_HashCollisionSetNode__f_content;
        var $$x1 = ($$x2 === this$2.length__I())
      } else {
        var $$x1 = false
      };
      if ($$x1) {
        var this$3 = this.sci_HashCollisionSetNode__f_content;
        var eta$0$1 = x2.sci_HashCollisionSetNode__f_content;
        var res = true;
        var it = this$3.iterator__sc_Iterator();
        while ((res && it.hasNext__Z())) {
          var arg1 = it.next__O();
          res = $f_sc_SeqOps__contains__O__Z(eta$0$1, arg1)
        };
        return res
      } else {
        return false
      }
    }
  } else {
    return false
  }
});
$c_sci_HashCollisionSetNode.prototype.hashCode__I = (function() {
  throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "Trie nodes do not support hashing.")
});
$c_sci_HashCollisionSetNode.prototype.copy__sci_SetNode = (function() {
  return new $c_sci_HashCollisionSetNode(this.sci_HashCollisionSetNode__f_originalHash, this.sci_HashCollisionSetNode__f_hash, this.sci_HashCollisionSetNode__f_content)
});
$c_sci_HashCollisionSetNode.prototype.getNode__I__sci_Node = (function(index) {
  return this.getNode__I__sci_SetNode(index)
});
function $as_sci_HashCollisionSetNode(obj) {
  return (((obj instanceof $c_sci_HashCollisionSetNode) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.HashCollisionSetNode"))
}
function $isArrayOf_sci_HashCollisionSetNode(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_HashCollisionSetNode)))
}
function $asArrayOf_sci_HashCollisionSetNode(obj, depth) {
  return (($isArrayOf_sci_HashCollisionSetNode(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.HashCollisionSetNode;", depth))
}
var $d_sci_HashCollisionSetNode = new $TypeData().initClass({
  sci_HashCollisionSetNode: 0
}, false, "scala.collection.immutable.HashCollisionSetNode", {
  sci_HashCollisionSetNode: 1,
  sci_SetNode: 1,
  sci_Node: 1,
  O: 1
});
$c_sci_HashCollisionSetNode.prototype.$classData = $d_sci_HashCollisionSetNode;
/** @constructor */
function $c_sci_HashMap$() {
  this.sci_HashMap$__f_EmptyMap = null;
  $n_sci_HashMap$ = this;
  var this$1 = $m_sci_MapNode$();
  this.sci_HashMap$__f_EmptyMap = new $c_sci_HashMap(this$1.sci_MapNode$__f_EmptyMapNode)
}
$c_sci_HashMap$.prototype = new $h_O();
$c_sci_HashMap$.prototype.constructor = $c_sci_HashMap$;
/** @constructor */
function $h_sci_HashMap$() {
  /*<skip>*/
}
$h_sci_HashMap$.prototype = $c_sci_HashMap$.prototype;
$c_sci_HashMap$.prototype.from__sc_IterableOnce__sci_HashMap = (function(source) {
  if ((source instanceof $c_sci_HashMap)) {
    var x2 = $as_sci_HashMap(source);
    return x2
  } else {
    var this$1 = new $c_sci_HashMapBuilder();
    var this$2 = this$1.addAll__sc_IterableOnce__sci_HashMapBuilder(source);
    return this$2.result__sci_HashMap()
  }
});
$c_sci_HashMap$.prototype.newBuilder__scm_Builder = (function() {
  return new $c_sci_HashMapBuilder()
});
$c_sci_HashMap$.prototype.from__sc_IterableOnce__O = (function(it) {
  return this.from__sc_IterableOnce__sci_HashMap(it)
});
$c_sci_HashMap$.prototype.empty__O = (function() {
  return this.sci_HashMap$__f_EmptyMap
});
var $d_sci_HashMap$ = new $TypeData().initClass({
  sci_HashMap$: 0
}, false, "scala.collection.immutable.HashMap$", {
  sci_HashMap$: 1,
  O: 1,
  sc_MapFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sci_HashMap$.prototype.$classData = $d_sci_HashMap$;
var $n_sci_HashMap$;
function $m_sci_HashMap$() {
  if ((!$n_sci_HashMap$)) {
    $n_sci_HashMap$ = new $c_sci_HashMap$()
  };
  return $n_sci_HashMap$
}
/** @constructor */
function $c_sci_HashSet$() {
  this.sci_HashSet$__f_EmptySet = null;
  $n_sci_HashSet$ = this;
  var this$1 = $m_sci_SetNode$();
  this.sci_HashSet$__f_EmptySet = new $c_sci_HashSet(this$1.sci_SetNode$__f_EmptySetNode)
}
$c_sci_HashSet$.prototype = new $h_O();
$c_sci_HashSet$.prototype.constructor = $c_sci_HashSet$;
/** @constructor */
function $h_sci_HashSet$() {
  /*<skip>*/
}
$h_sci_HashSet$.prototype = $c_sci_HashSet$.prototype;
$c_sci_HashSet$.prototype.from__sc_IterableOnce__sci_HashSet = (function(source) {
  if ((source instanceof $c_sci_HashSet)) {
    var x2 = $as_sci_HashSet(source);
    return x2
  } else if ((source.knownSize__I() === 0)) {
    return this.sci_HashSet$__f_EmptySet
  } else {
    var this$1 = new $c_sci_HashSetBuilder();
    var this$2 = this$1.addAll__sc_IterableOnce__sci_HashSetBuilder(source);
    return this$2.result__sci_HashSet()
  }
});
$c_sci_HashSet$.prototype.newBuilder__scm_Builder = (function() {
  return new $c_sci_HashSetBuilder()
});
$c_sci_HashSet$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__sci_HashSet(source)
});
var $d_sci_HashSet$ = new $TypeData().initClass({
  sci_HashSet$: 0
}, false, "scala.collection.immutable.HashSet$", {
  sci_HashSet$: 1,
  O: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sci_HashSet$.prototype.$classData = $d_sci_HashSet$;
var $n_sci_HashSet$;
function $m_sci_HashSet$() {
  if ((!$n_sci_HashSet$)) {
    $n_sci_HashSet$ = new $c_sci_HashSet$()
  };
  return $n_sci_HashSet$
}
/** @constructor */
function $c_sci_LazyList$State$Cons(head, tail) {
  this.sci_LazyList$State$Cons__f_head = null;
  this.sci_LazyList$State$Cons__f_tail = null;
  this.sci_LazyList$State$Cons__f_head = head;
  this.sci_LazyList$State$Cons__f_tail = tail
}
$c_sci_LazyList$State$Cons.prototype = new $h_O();
$c_sci_LazyList$State$Cons.prototype.constructor = $c_sci_LazyList$State$Cons;
/** @constructor */
function $h_sci_LazyList$State$Cons() {
  /*<skip>*/
}
$h_sci_LazyList$State$Cons.prototype = $c_sci_LazyList$State$Cons.prototype;
$c_sci_LazyList$State$Cons.prototype.head__O = (function() {
  return this.sci_LazyList$State$Cons__f_head
});
$c_sci_LazyList$State$Cons.prototype.tail__sci_LazyList = (function() {
  return this.sci_LazyList$State$Cons__f_tail
});
var $d_sci_LazyList$State$Cons = new $TypeData().initClass({
  sci_LazyList$State$Cons: 0
}, false, "scala.collection.immutable.LazyList$State$Cons", {
  sci_LazyList$State$Cons: 1,
  O: 1,
  sci_LazyList$State: 1,
  Ljava_io_Serializable: 1
});
$c_sci_LazyList$State$Cons.prototype.$classData = $d_sci_LazyList$State$Cons;
/** @constructor */
function $c_sci_LazyList$State$Empty$() {
  /*<skip>*/
}
$c_sci_LazyList$State$Empty$.prototype = new $h_O();
$c_sci_LazyList$State$Empty$.prototype.constructor = $c_sci_LazyList$State$Empty$;
/** @constructor */
function $h_sci_LazyList$State$Empty$() {
  /*<skip>*/
}
$h_sci_LazyList$State$Empty$.prototype = $c_sci_LazyList$State$Empty$.prototype;
$c_sci_LazyList$State$Empty$.prototype.head__E = (function() {
  throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "head of empty lazy list")
});
$c_sci_LazyList$State$Empty$.prototype.tail__sci_LazyList = (function() {
  throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "tail of empty lazy list")
});
$c_sci_LazyList$State$Empty$.prototype.head__O = (function() {
  this.head__E()
});
var $d_sci_LazyList$State$Empty$ = new $TypeData().initClass({
  sci_LazyList$State$Empty$: 0
}, false, "scala.collection.immutable.LazyList$State$Empty$", {
  sci_LazyList$State$Empty$: 1,
  O: 1,
  sci_LazyList$State: 1,
  Ljava_io_Serializable: 1
});
$c_sci_LazyList$State$Empty$.prototype.$classData = $d_sci_LazyList$State$Empty$;
var $n_sci_LazyList$State$Empty$;
function $m_sci_LazyList$State$Empty$() {
  if ((!$n_sci_LazyList$State$Empty$)) {
    $n_sci_LazyList$State$Empty$ = new $c_sci_LazyList$State$Empty$()
  };
  return $n_sci_LazyList$State$Empty$
}
/** @constructor */
function $c_sci_Map$() {
  /*<skip>*/
}
$c_sci_Map$.prototype = new $h_O();
$c_sci_Map$.prototype.constructor = $c_sci_Map$;
/** @constructor */
function $h_sci_Map$() {
  /*<skip>*/
}
$h_sci_Map$.prototype = $c_sci_Map$.prototype;
$c_sci_Map$.prototype.from__sc_IterableOnce__sci_Map = (function(it) {
  if ($is_sci_Iterable(it)) {
    var x2 = $as_sci_Iterable(it);
    if (x2.isEmpty__Z()) {
      return $m_sci_Map$EmptyMap$()
    }
  };
  if ($is_sci_Map(it)) {
    var x3 = $as_sci_Map(it);
    return x3
  };
  var this$1 = new $c_sci_MapBuilderImpl();
  var this$2 = this$1.addAll__sc_IterableOnce__sci_MapBuilderImpl(it);
  return this$2.result__sci_Map()
});
$c_sci_Map$.prototype.newBuilder__scm_Builder = (function() {
  return new $c_sci_MapBuilderImpl()
});
$c_sci_Map$.prototype.from__sc_IterableOnce__O = (function(it) {
  return this.from__sc_IterableOnce__sci_Map(it)
});
$c_sci_Map$.prototype.empty__O = (function() {
  return $m_sci_Map$EmptyMap$()
});
var $d_sci_Map$ = new $TypeData().initClass({
  sci_Map$: 0
}, false, "scala.collection.immutable.Map$", {
  sci_Map$: 1,
  O: 1,
  sc_MapFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Map$.prototype.$classData = $d_sci_Map$;
var $n_sci_Map$;
function $m_sci_Map$() {
  if ((!$n_sci_Map$)) {
    $n_sci_Map$ = new $c_sci_Map$()
  };
  return $n_sci_Map$
}
/** @constructor */
function $c_sci_Set$() {
  /*<skip>*/
}
$c_sci_Set$.prototype = new $h_O();
$c_sci_Set$.prototype.constructor = $c_sci_Set$;
/** @constructor */
function $h_sci_Set$() {
  /*<skip>*/
}
$h_sci_Set$.prototype = $c_sci_Set$.prototype;
$c_sci_Set$.prototype.from__sc_IterableOnce__sci_Set = (function(it) {
  if ($is_sci_SortedSet(it)) {
    var this$1 = new $c_sci_SetBuilderImpl();
    var this$2 = this$1.addAll__sc_IterableOnce__sci_SetBuilderImpl(it);
    return this$2.result__sci_Set()
  } else if ((it.knownSize__I() === 0)) {
    return $m_sci_Set$EmptySet$()
  } else if ($is_sci_Set(it)) {
    var x3 = $as_sci_Set(it);
    return x3
  } else {
    var this$3 = new $c_sci_SetBuilderImpl();
    var this$4 = this$3.addAll__sc_IterableOnce__sci_SetBuilderImpl(it);
    return this$4.result__sci_Set()
  }
});
$c_sci_Set$.prototype.newBuilder__scm_Builder = (function() {
  return new $c_sci_SetBuilderImpl()
});
$c_sci_Set$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__sci_Set(source)
});
var $d_sci_Set$ = new $TypeData().initClass({
  sci_Set$: 0
}, false, "scala.collection.immutable.Set$", {
  sci_Set$: 1,
  O: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Set$.prototype.$classData = $d_sci_Set$;
var $n_sci_Set$;
function $m_sci_Set$() {
  if ((!$n_sci_Set$)) {
    $n_sci_Set$ = new $c_sci_Set$()
  };
  return $n_sci_Set$
}
function $is_scm_Builder(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.scm_Builder)))
}
function $as_scm_Builder(obj) {
  return (($is_scm_Builder(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.Builder"))
}
function $isArrayOf_scm_Builder(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_Builder)))
}
function $asArrayOf_scm_Builder(obj, depth) {
  return (($isArrayOf_scm_Builder(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.Builder;", depth))
}
/** @constructor */
function $c_scm_HashMap$() {
  /*<skip>*/
}
$c_scm_HashMap$.prototype = new $h_O();
$c_scm_HashMap$.prototype.constructor = $c_scm_HashMap$;
/** @constructor */
function $h_scm_HashMap$() {
  /*<skip>*/
}
$h_scm_HashMap$.prototype = $c_scm_HashMap$.prototype;
$c_scm_HashMap$.prototype.from__sc_IterableOnce__scm_HashMap = (function(it) {
  var k = it.knownSize__I();
  var cap = ((k > 0) ? $doubleToInt((((1 + k) | 0) / 0.75)) : 16);
  return $ct_scm_HashMap__I__D__(new $c_scm_HashMap(), cap, 0.75).addAll__sc_IterableOnce__scm_HashMap(it)
});
$c_scm_HashMap$.prototype.newBuilder__scm_Builder = (function() {
  return new $c_scm_HashMap$$anon$6(16, 0.75)
});
$c_scm_HashMap$.prototype.from__sc_IterableOnce__O = (function(it) {
  return this.from__sc_IterableOnce__scm_HashMap(it)
});
$c_scm_HashMap$.prototype.empty__O = (function() {
  return $ct_scm_HashMap__(new $c_scm_HashMap())
});
var $d_scm_HashMap$ = new $TypeData().initClass({
  scm_HashMap$: 0
}, false, "scala.collection.mutable.HashMap$", {
  scm_HashMap$: 1,
  O: 1,
  sc_MapFactory: 1,
  Ljava_io_Serializable: 1
});
$c_scm_HashMap$.prototype.$classData = $d_scm_HashMap$;
var $n_scm_HashMap$;
function $m_scm_HashMap$() {
  if ((!$n_scm_HashMap$)) {
    $n_scm_HashMap$ = new $c_scm_HashMap$()
  };
  return $n_scm_HashMap$
}
/** @constructor */
function $c_s_concurrent_BatchingExecutor$SyncBatch(outer, runnable) {
  this.s_concurrent_BatchingExecutor$AbstractBatch__f_first = null;
  this.s_concurrent_BatchingExecutor$AbstractBatch__f_other = null;
  this.s_concurrent_BatchingExecutor$AbstractBatch__f_size = 0;
  this.s_concurrent_BatchingExecutor$AbstractBatch__f_$outer = null;
  $ct_s_concurrent_BatchingExecutor$AbstractBatch__s_concurrent_BatchingExecutor__jl_Runnable__Ajl_Runnable__I__(this, outer, runnable, $m_s_concurrent_BatchingExecutorStatics$().s_concurrent_BatchingExecutorStatics$__f_emptyBatchArray, 1)
}
$c_s_concurrent_BatchingExecutor$SyncBatch.prototype = new $h_s_concurrent_BatchingExecutor$AbstractBatch();
$c_s_concurrent_BatchingExecutor$SyncBatch.prototype.constructor = $c_s_concurrent_BatchingExecutor$SyncBatch;
/** @constructor */
function $h_s_concurrent_BatchingExecutor$SyncBatch() {
  /*<skip>*/
}
$h_s_concurrent_BatchingExecutor$SyncBatch.prototype = $c_s_concurrent_BatchingExecutor$SyncBatch.prototype;
$c_s_concurrent_BatchingExecutor$SyncBatch.prototype.run__V = (function() {
  while (true) {
    try {
      this.runN__I__V(1024)
    } catch (e) {
      var e$2 = $m_sjsr_package$().wrapJavaScriptException__O__jl_Throwable(e);
      if (false) {
        var x2 = $as_jl_InterruptedException(e$2);
        $m_s_concurrent_ExecutionContext$().s_concurrent_ExecutionContext$__f_defaultReporter.apply__O__O(x2)
      } else if ((e$2 !== null)) {
        if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
          $m_s_concurrent_ExecutionContext$().s_concurrent_ExecutionContext$__f_defaultReporter.apply__O__O(e$2)
        } else {
          throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(e$2)
        }
      } else {
        throw e
      }
    };
    if ((this.s_concurrent_BatchingExecutor$AbstractBatch__f_size > 0)) {
      continue
    };
    return (void 0)
  }
});
function $as_s_concurrent_BatchingExecutor$SyncBatch(obj) {
  return (((obj instanceof $c_s_concurrent_BatchingExecutor$SyncBatch) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.concurrent.BatchingExecutor$SyncBatch"))
}
function $isArrayOf_s_concurrent_BatchingExecutor$SyncBatch(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_concurrent_BatchingExecutor$SyncBatch)))
}
function $asArrayOf_s_concurrent_BatchingExecutor$SyncBatch(obj, depth) {
  return (($isArrayOf_s_concurrent_BatchingExecutor$SyncBatch(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.concurrent.BatchingExecutor$SyncBatch;", depth))
}
var $d_s_concurrent_BatchingExecutor$SyncBatch = new $TypeData().initClass({
  s_concurrent_BatchingExecutor$SyncBatch: 0
}, false, "scala.concurrent.BatchingExecutor$SyncBatch", {
  s_concurrent_BatchingExecutor$SyncBatch: 1,
  s_concurrent_BatchingExecutor$AbstractBatch: 1,
  O: 1,
  jl_Runnable: 1
});
$c_s_concurrent_BatchingExecutor$SyncBatch.prototype.$classData = $d_s_concurrent_BatchingExecutor$SyncBatch;
/** @constructor */
function $c_s_concurrent_impl_Promise$Link(to) {
  this.ju_concurrent_atomic_AtomicReference__f_value = null;
  $ct_ju_concurrent_atomic_AtomicReference__O__(this, to)
}
$c_s_concurrent_impl_Promise$Link.prototype = new $h_ju_concurrent_atomic_AtomicReference();
$c_s_concurrent_impl_Promise$Link.prototype.constructor = $c_s_concurrent_impl_Promise$Link;
/** @constructor */
function $h_s_concurrent_impl_Promise$Link() {
  /*<skip>*/
}
$h_s_concurrent_impl_Promise$Link.prototype = $c_s_concurrent_impl_Promise$Link.prototype;
$c_s_concurrent_impl_Promise$Link.prototype.promise__s_concurrent_impl_Promise$DefaultPromise__s_concurrent_impl_Promise$DefaultPromise = (function(owner) {
  var c = $as_s_concurrent_impl_Promise$DefaultPromise(this.ju_concurrent_atomic_AtomicReference__f_value);
  var current = c;
  var target = c;
  while (true) {
    var value = target.ju_concurrent_atomic_AtomicReference__f_value;
    if ($is_s_concurrent_impl_Promise$Callbacks(value)) {
      if (this.compareAndSet__O__O__Z(current, target)) {
        return target
      } else {
        current = $as_s_concurrent_impl_Promise$DefaultPromise(this.ju_concurrent_atomic_AtomicReference__f_value)
      }
    } else if ((value instanceof $c_s_concurrent_impl_Promise$Link)) {
      target = $as_s_concurrent_impl_Promise$DefaultPromise($as_s_concurrent_impl_Promise$Link(value).ju_concurrent_atomic_AtomicReference__f_value)
    } else {
      owner.unlink__s_util_Try__V($as_s_util_Try(value));
      return owner
    }
  }
});
function $as_s_concurrent_impl_Promise$Link(obj) {
  return (((obj instanceof $c_s_concurrent_impl_Promise$Link) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.concurrent.impl.Promise$Link"))
}
function $isArrayOf_s_concurrent_impl_Promise$Link(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_concurrent_impl_Promise$Link)))
}
function $asArrayOf_s_concurrent_impl_Promise$Link(obj, depth) {
  return (($isArrayOf_s_concurrent_impl_Promise$Link(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.concurrent.impl.Promise$Link;", depth))
}
var $d_s_concurrent_impl_Promise$Link = new $TypeData().initClass({
  s_concurrent_impl_Promise$Link: 0
}, false, "scala.concurrent.impl.Promise$Link", {
  s_concurrent_impl_Promise$Link: 1,
  ju_concurrent_atomic_AtomicReference: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_s_concurrent_impl_Promise$Link.prototype.$classData = $d_s_concurrent_impl_Promise$Link;
/** @constructor */
function $c_s_math_Equiv$() {
  /*<skip>*/
}
$c_s_math_Equiv$.prototype = new $h_O();
$c_s_math_Equiv$.prototype.constructor = $c_s_math_Equiv$;
/** @constructor */
function $h_s_math_Equiv$() {
  /*<skip>*/
}
$h_s_math_Equiv$.prototype = $c_s_math_Equiv$.prototype;
var $d_s_math_Equiv$ = new $TypeData().initClass({
  s_math_Equiv$: 0
}, false, "scala.math.Equiv$", {
  s_math_Equiv$: 1,
  O: 1,
  s_math_LowPriorityEquiv: 1,
  Ljava_io_Serializable: 1
});
$c_s_math_Equiv$.prototype.$classData = $d_s_math_Equiv$;
var $n_s_math_Equiv$;
function $m_s_math_Equiv$() {
  if ((!$n_s_math_Equiv$)) {
    $n_s_math_Equiv$ = new $c_s_math_Equiv$()
  };
  return $n_s_math_Equiv$
}
/** @constructor */
function $c_s_math_Ordering$() {
  /*<skip>*/
}
$c_s_math_Ordering$.prototype = new $h_O();
$c_s_math_Ordering$.prototype.constructor = $c_s_math_Ordering$;
/** @constructor */
function $h_s_math_Ordering$() {
  /*<skip>*/
}
$h_s_math_Ordering$.prototype = $c_s_math_Ordering$.prototype;
var $d_s_math_Ordering$ = new $TypeData().initClass({
  s_math_Ordering$: 0
}, false, "scala.math.Ordering$", {
  s_math_Ordering$: 1,
  O: 1,
  s_math_LowPriorityOrderingImplicits: 1,
  Ljava_io_Serializable: 1
});
$c_s_math_Ordering$.prototype.$classData = $d_s_math_Ordering$;
var $n_s_math_Ordering$;
function $m_s_math_Ordering$() {
  if ((!$n_s_math_Ordering$)) {
    $n_s_math_Ordering$ = new $c_s_math_Ordering$()
  };
  return $n_s_math_Ordering$
}
/** @constructor */
function $c_s_math_ScalaNumber() {
  /*<skip>*/
}
$c_s_math_ScalaNumber.prototype = new $h_jl_Number();
$c_s_math_ScalaNumber.prototype.constructor = $c_s_math_ScalaNumber;
/** @constructor */
function $h_s_math_ScalaNumber() {
  /*<skip>*/
}
$h_s_math_ScalaNumber.prototype = $c_s_math_ScalaNumber.prototype;
function $as_s_math_ScalaNumber(obj) {
  return (((obj instanceof $c_s_math_ScalaNumber) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.math.ScalaNumber"))
}
function $isArrayOf_s_math_ScalaNumber(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_math_ScalaNumber)))
}
function $asArrayOf_s_math_ScalaNumber(obj, depth) {
  return (($isArrayOf_s_math_ScalaNumber(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.math.ScalaNumber;", depth))
}
/** @constructor */
function $c_s_reflect_NoManifest$() {
  /*<skip>*/
}
$c_s_reflect_NoManifest$.prototype = new $h_O();
$c_s_reflect_NoManifest$.prototype.constructor = $c_s_reflect_NoManifest$;
/** @constructor */
function $h_s_reflect_NoManifest$() {
  /*<skip>*/
}
$h_s_reflect_NoManifest$.prototype = $c_s_reflect_NoManifest$.prototype;
$c_s_reflect_NoManifest$.prototype.toString__T = (function() {
  return "<?>"
});
var $d_s_reflect_NoManifest$ = new $TypeData().initClass({
  s_reflect_NoManifest$: 0
}, false, "scala.reflect.NoManifest$", {
  s_reflect_NoManifest$: 1,
  O: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1
});
$c_s_reflect_NoManifest$.prototype.$classData = $d_s_reflect_NoManifest$;
var $n_s_reflect_NoManifest$;
function $m_s_reflect_NoManifest$() {
  if ((!$n_s_reflect_NoManifest$)) {
    $n_s_reflect_NoManifest$ = new $c_s_reflect_NoManifest$()
  };
  return $n_s_reflect_NoManifest$
}
/** @constructor */
function $c_sr_AbstractPartialFunction() {
  /*<skip>*/
}
$c_sr_AbstractPartialFunction.prototype = new $h_O();
$c_sr_AbstractPartialFunction.prototype.constructor = $c_sr_AbstractPartialFunction;
/** @constructor */
function $h_sr_AbstractPartialFunction() {
  /*<skip>*/
}
$h_sr_AbstractPartialFunction.prototype = $c_sr_AbstractPartialFunction.prototype;
$c_sr_AbstractPartialFunction.prototype.toString__T = (function() {
  return "<function1>"
});
$c_sr_AbstractPartialFunction.prototype.apply__O__O = (function(x) {
  return this.applyOrElse__O__F1__O(x, $m_s_PartialFunction$().s_PartialFunction$__f_empty_pf)
});
var $d_sr_Nothing$ = new $TypeData().initClass({
  sr_Nothing$: 0
}, false, "scala.runtime.Nothing$", {
  sr_Nothing$: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
/** @constructor */
function $c_sjs_js_$bar$Evidence$() {
  /*<skip>*/
}
$c_sjs_js_$bar$Evidence$.prototype = new $h_sjs_js_$bar$EvidenceLowPrioImplicits();
$c_sjs_js_$bar$Evidence$.prototype.constructor = $c_sjs_js_$bar$Evidence$;
/** @constructor */
function $h_sjs_js_$bar$Evidence$() {
  /*<skip>*/
}
$h_sjs_js_$bar$Evidence$.prototype = $c_sjs_js_$bar$Evidence$.prototype;
$c_sjs_js_$bar$Evidence$.prototype.base__sjs_js_$bar$Evidence = (function() {
  return $m_sjs_js_$bar$ReusableEvidence$()
});
var $d_sjs_js_$bar$Evidence$ = new $TypeData().initClass({
  sjs_js_$bar$Evidence$: 0
}, false, "scala.scalajs.js.$bar$Evidence$", {
  sjs_js_$bar$Evidence$: 1,
  sjs_js_$bar$EvidenceLowPrioImplicits: 1,
  sjs_js_$bar$EvidenceLowestPrioImplicits: 1,
  O: 1
});
$c_sjs_js_$bar$Evidence$.prototype.$classData = $d_sjs_js_$bar$Evidence$;
var $n_sjs_js_$bar$Evidence$;
function $m_sjs_js_$bar$Evidence$() {
  if ((!$n_sjs_js_$bar$Evidence$)) {
    $n_sjs_js_$bar$Evidence$ = new $c_sjs_js_$bar$Evidence$()
  };
  return $n_sjs_js_$bar$Evidence$
}
/** @constructor */
function $c_sjs_js_Any$() {
  /*<skip>*/
}
$c_sjs_js_Any$.prototype = new $h_O();
$c_sjs_js_Any$.prototype.constructor = $c_sjs_js_Any$;
/** @constructor */
function $h_sjs_js_Any$() {
  /*<skip>*/
}
$h_sjs_js_Any$.prototype = $c_sjs_js_Any$.prototype;
$c_sjs_js_Any$.prototype.fromFunction0__F0__sjs_js_Function0 = (function(f) {
  return (function(f$1) {
    return (function() {
      return f$1.apply__O()
    })
  })(f)
});
$c_sjs_js_Any$.prototype.toFunction1__sjs_js_Function1__F1 = (function(f) {
  return new $c_sjsr_AnonFunction1((function(this$1, f$1) {
    return (function(x1$2) {
      return f$1(x1$2)
    })
  })(this, f))
});
var $d_sjs_js_Any$ = new $TypeData().initClass({
  sjs_js_Any$: 0
}, false, "scala.scalajs.js.Any$", {
  sjs_js_Any$: 1,
  O: 1,
  sjs_js_LowPrioAnyImplicits: 1,
  sjs_js_LowestPrioAnyImplicits: 1
});
$c_sjs_js_Any$.prototype.$classData = $d_sjs_js_Any$;
var $n_sjs_js_Any$;
function $m_sjs_js_Any$() {
  if ((!$n_sjs_js_Any$)) {
    $n_sjs_js_Any$ = new $c_sjs_js_Any$()
  };
  return $n_sjs_js_Any$
}
/** @constructor */
function $c_sjsr_AnonFunction0(f) {
  this.sjsr_AnonFunction0__f_f = null;
  this.sjsr_AnonFunction0__f_f = f
}
$c_sjsr_AnonFunction0.prototype = new $h_sr_AbstractFunction0();
$c_sjsr_AnonFunction0.prototype.constructor = $c_sjsr_AnonFunction0;
/** @constructor */
function $h_sjsr_AnonFunction0() {
  /*<skip>*/
}
$h_sjsr_AnonFunction0.prototype = $c_sjsr_AnonFunction0.prototype;
$c_sjsr_AnonFunction0.prototype.apply__O = (function() {
  return (0, this.sjsr_AnonFunction0__f_f)()
});
var $d_sjsr_AnonFunction0 = new $TypeData().initClass({
  sjsr_AnonFunction0: 0
}, false, "scala.scalajs.runtime.AnonFunction0", {
  sjsr_AnonFunction0: 1,
  sr_AbstractFunction0: 1,
  O: 1,
  F0: 1
});
$c_sjsr_AnonFunction0.prototype.$classData = $d_sjsr_AnonFunction0;
/** @constructor */
function $c_sjsr_AnonFunction1(f) {
  this.sjsr_AnonFunction1__f_f = null;
  this.sjsr_AnonFunction1__f_f = f
}
$c_sjsr_AnonFunction1.prototype = new $h_sr_AbstractFunction1();
$c_sjsr_AnonFunction1.prototype.constructor = $c_sjsr_AnonFunction1;
/** @constructor */
function $h_sjsr_AnonFunction1() {
  /*<skip>*/
}
$h_sjsr_AnonFunction1.prototype = $c_sjsr_AnonFunction1.prototype;
$c_sjsr_AnonFunction1.prototype.apply__O__O = (function(arg1) {
  return (0, this.sjsr_AnonFunction1__f_f)(arg1)
});
var $d_sjsr_AnonFunction1 = new $TypeData().initClass({
  sjsr_AnonFunction1: 0
}, false, "scala.scalajs.runtime.AnonFunction1", {
  sjsr_AnonFunction1: 1,
  sr_AbstractFunction1: 1,
  O: 1,
  F1: 1
});
$c_sjsr_AnonFunction1.prototype.$classData = $d_sjsr_AnonFunction1;
/** @constructor */
function $c_sjsr_AnonFunction2(f) {
  this.sjsr_AnonFunction2__f_f = null;
  this.sjsr_AnonFunction2__f_f = f
}
$c_sjsr_AnonFunction2.prototype = new $h_sr_AbstractFunction2();
$c_sjsr_AnonFunction2.prototype.constructor = $c_sjsr_AnonFunction2;
/** @constructor */
function $h_sjsr_AnonFunction2() {
  /*<skip>*/
}
$h_sjsr_AnonFunction2.prototype = $c_sjsr_AnonFunction2.prototype;
$c_sjsr_AnonFunction2.prototype.apply__O__O__O = (function(arg1, arg2) {
  return (0, this.sjsr_AnonFunction2__f_f)(arg1, arg2)
});
var $d_sjsr_AnonFunction2 = new $TypeData().initClass({
  sjsr_AnonFunction2: 0
}, false, "scala.scalajs.runtime.AnonFunction2", {
  sjsr_AnonFunction2: 1,
  sr_AbstractFunction2: 1,
  O: 1,
  F2: 1
});
$c_sjsr_AnonFunction2.prototype.$classData = $d_sjsr_AnonFunction2;
/** @constructor */
function $c_sjsr_AnonFunction3(f) {
  this.sjsr_AnonFunction3__f_f = null;
  this.sjsr_AnonFunction3__f_f = f
}
$c_sjsr_AnonFunction3.prototype = new $h_sr_AbstractFunction3();
$c_sjsr_AnonFunction3.prototype.constructor = $c_sjsr_AnonFunction3;
/** @constructor */
function $h_sjsr_AnonFunction3() {
  /*<skip>*/
}
$h_sjsr_AnonFunction3.prototype = $c_sjsr_AnonFunction3.prototype;
$c_sjsr_AnonFunction3.prototype.apply__O__O__O__O = (function(arg1, arg2, arg3) {
  return (0, this.sjsr_AnonFunction3__f_f)(arg1, arg2, arg3)
});
var $d_sjsr_AnonFunction3 = new $TypeData().initClass({
  sjsr_AnonFunction3: 0
}, false, "scala.scalajs.runtime.AnonFunction3", {
  sjsr_AnonFunction3: 1,
  sr_AbstractFunction3: 1,
  O: 1,
  F3: 1
});
$c_sjsr_AnonFunction3.prototype.$classData = $d_sjsr_AnonFunction3;
function $as_s_util_control_ControlThrowable(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "scala.util.control.ControlThrowable"))
}
function $isArrayOf_s_util_control_ControlThrowable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_util_control_ControlThrowable)))
}
function $asArrayOf_s_util_control_ControlThrowable(obj, depth) {
  return (($isArrayOf_s_util_control_ControlThrowable(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.util.control.ControlThrowable;", depth))
}
function $p_s_util_control_Exception$$anon$1__downcast__jl_Throwable__s_Option($thiz, x) {
  $m_s_reflect_package$();
  var ctag = $thiz.s_util_control_Exception$$anon$1__f_evidence$1$1;
  if (ctag.runtimeClass__jl_Class().isAssignableFrom__jl_Class__Z($objectGetClass(x))) {
    return new $c_s_Some(x)
  } else {
    return $m_s_None$()
  }
}
/** @constructor */
function $c_s_util_control_Exception$$anon$1(evidence$1$1, isDef$1, f$1) {
  this.s_util_control_Exception$$anon$1__f_evidence$1$1 = null;
  this.s_util_control_Exception$$anon$1__f_isDef$1 = null;
  this.s_util_control_Exception$$anon$1__f_f$1 = null;
  this.s_util_control_Exception$$anon$1__f_evidence$1$1 = evidence$1$1;
  this.s_util_control_Exception$$anon$1__f_isDef$1 = isDef$1;
  this.s_util_control_Exception$$anon$1__f_f$1 = f$1
}
$c_s_util_control_Exception$$anon$1.prototype = new $h_O();
$c_s_util_control_Exception$$anon$1.prototype.constructor = $c_s_util_control_Exception$$anon$1;
/** @constructor */
function $h_s_util_control_Exception$$anon$1() {
  /*<skip>*/
}
$h_s_util_control_Exception$$anon$1.prototype = $c_s_util_control_Exception$$anon$1.prototype;
$c_s_util_control_Exception$$anon$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return $f_s_PartialFunction__applyOrElse__O__F1__O(this, x, default$1)
});
$c_s_util_control_Exception$$anon$1.prototype.toString__T = (function() {
  return "<function1>"
});
$c_s_util_control_Exception$$anon$1.prototype.isDefinedAt__jl_Throwable__Z = (function(x) {
  var this$1 = $p_s_util_control_Exception$$anon$1__downcast__jl_Throwable__s_Option(this, x);
  var p = this.s_util_control_Exception$$anon$1__f_isDef$1;
  return ((!this$1.isEmpty__Z()) && $uZ(p.apply__O__O(this$1.get__O())))
});
$c_s_util_control_Exception$$anon$1.prototype.apply__jl_Throwable__O = (function(x) {
  return this.s_util_control_Exception$$anon$1__f_f$1.apply__O__O($p_s_util_control_Exception$$anon$1__downcast__jl_Throwable__s_Option(this, x).get__O())
});
$c_s_util_control_Exception$$anon$1.prototype.apply__O__O = (function(v1) {
  return this.apply__jl_Throwable__O($as_jl_Throwable(v1))
});
$c_s_util_control_Exception$$anon$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__jl_Throwable__Z($as_jl_Throwable(x))
});
var $d_s_util_control_Exception$$anon$1 = new $TypeData().initClass({
  s_util_control_Exception$$anon$1: 0
}, false, "scala.util.control.Exception$$anon$1", {
  s_util_control_Exception$$anon$1: 1,
  O: 1,
  s_PartialFunction: 1,
  F1: 1
});
$c_s_util_control_Exception$$anon$1.prototype.$classData = $d_s_util_control_Exception$$anon$1;
/** @constructor */
function $c_s_util_control_Exception$Catch$$anon$2(outer, f$2) {
  this.s_util_control_Exception$Catch$$anon$2__f_$outer = null;
  this.s_util_control_Exception$Catch$$anon$2__f_f$2 = null;
  if ((outer === null)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(null)
  } else {
    this.s_util_control_Exception$Catch$$anon$2__f_$outer = outer
  };
  this.s_util_control_Exception$Catch$$anon$2__f_f$2 = f$2
}
$c_s_util_control_Exception$Catch$$anon$2.prototype = new $h_O();
$c_s_util_control_Exception$Catch$$anon$2.prototype.constructor = $c_s_util_control_Exception$Catch$$anon$2;
/** @constructor */
function $h_s_util_control_Exception$Catch$$anon$2() {
  /*<skip>*/
}
$h_s_util_control_Exception$Catch$$anon$2.prototype = $c_s_util_control_Exception$Catch$$anon$2.prototype;
$c_s_util_control_Exception$Catch$$anon$2.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return $f_s_PartialFunction__applyOrElse__O__F1__O(this, x, default$1)
});
$c_s_util_control_Exception$Catch$$anon$2.prototype.toString__T = (function() {
  return "<function1>"
});
$c_s_util_control_Exception$Catch$$anon$2.prototype.isDefinedAt__jl_Throwable__Z = (function(x) {
  return this.s_util_control_Exception$Catch$$anon$2__f_$outer.s_util_control_Exception$Catch__f_pf.isDefinedAt__O__Z(x)
});
$c_s_util_control_Exception$Catch$$anon$2.prototype.apply__jl_Throwable__O = (function(x) {
  return this.s_util_control_Exception$Catch$$anon$2__f_f$2.apply__O__O(x)
});
$c_s_util_control_Exception$Catch$$anon$2.prototype.apply__O__O = (function(v1) {
  return this.apply__jl_Throwable__O($as_jl_Throwable(v1))
});
$c_s_util_control_Exception$Catch$$anon$2.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__jl_Throwable__Z($as_jl_Throwable(x))
});
var $d_s_util_control_Exception$Catch$$anon$2 = new $TypeData().initClass({
  s_util_control_Exception$Catch$$anon$2: 0
}, false, "scala.util.control.Exception$Catch$$anon$2", {
  s_util_control_Exception$Catch$$anon$2: 1,
  O: 1,
  s_PartialFunction: 1,
  F1: 1
});
$c_s_util_control_Exception$Catch$$anon$2.prototype.$classData = $d_s_util_control_Exception$Catch$$anon$2;
function $p_Lscommons_react_redux_task_TaskManager$__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz) {
  if ((!$thiz.Lscommons_react_redux_task_TaskManager$__f_bitmap$0)) {
    $thiz.Lscommons_react_redux_task_TaskManager$__f_scommons$react$UiComponent$$reactClass = $f_Lscommons_react_FunctionComponent__create__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz);
    $thiz.Lscommons_react_redux_task_TaskManager$__f_bitmap$0 = true
  };
  return $thiz.Lscommons_react_redux_task_TaskManager$__f_scommons$react$UiComponent$$reactClass
}
function $p_Lscommons_react_redux_task_TaskManager$__onTaskStart__sjs_js_Function1__Lscommons_react_redux_task_AbstractTask__V($thiz, setState, task) {
  var f = new $c_sjsr_AnonFunction1((function(this$1, setState$1, task$1) {
    return (function(value$2) {
      var value = $as_s_util_Try(value$2);
      $p_Lscommons_react_redux_task_TaskManager$__onTaskFinish__sjs_js_Function1__Lscommons_react_redux_task_AbstractTask__s_util_Try__V($m_Lscommons_react_redux_task_TaskManager$(), setState$1, task$1, value)
    })
  })($thiz, setState, task));
  task.Lscommons_react_redux_task_FutureTask__f_future.onComplete__F1__s_concurrent_ExecutionContext__V(f, $m_sjs_concurrent_JSExecutionContext$Implicits$().sjs_concurrent_JSExecutionContext$Implicits$__f_queue);
  setState((function(task$1$1) {
    return (function(arg1$2) {
      var arg1 = $as_Lscommons_react_redux_task_TaskManager$TaskManagerState(arg1$2);
      return $m_Lscommons_react_redux_task_TaskManager$().scommons$react$redux$task$TaskManager$$$anonfun$onTaskStart$2__Lscommons_react_redux_task_TaskManager$TaskManagerState__Lscommons_react_redux_task_AbstractTask__Lscommons_react_redux_task_TaskManager$TaskManagerState(arg1, task$1$1)
    })
  })(task))
}
function $p_Lscommons_react_redux_task_TaskManager$__onTaskFinish__sjs_js_Function1__Lscommons_react_redux_task_AbstractTask__s_util_Try__V($thiz, setState, task, value) {
  var this$2 = $m_RTLong$();
  var value$1 = $uD(new Date().getTime());
  var lo = this$2.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value$1);
  var hi = this$2.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var b = task.Lscommons_react_redux_task_FutureTask__f_startTime;
  var bhi = b.RTLong__f_hi;
  var lo$1 = ((lo - b.RTLong__f_lo) | 0);
  var hi$1 = ((((-2147483648) ^ lo$1) > ((-2147483648) ^ lo)) ? (((-1) + ((hi - bhi) | 0)) | 0) : ((hi - bhi) | 0));
  var statusMessage = (((task.Lscommons_react_redux_task_FutureTask__f_message + "...Done ") + $thiz.formatDuration__J__T(new $c_RTLong(lo$1, hi$1))) + " sec.");
  var x1 = $as_T2($thiz.Lscommons_react_redux_task_TaskManager$__f_errorHandler.applyOrElse__O__F1__O(value, new $c_sjsr_AnonFunction1((function(this$4) {
    return (function(value$2$2) {
      var value$2 = $as_s_util_Try(value$2$2);
      return $p_Lscommons_react_redux_task_TaskManager$__defaultErrorHandler$1__s_util_Try__T2(this$4, value$2)
    })
  })($thiz))));
  if ((x1 === null)) {
    throw new $c_s_MatchError(x1)
  };
  var error = $as_s_Option(x1._1__O());
  var errorDetails = $as_s_Option(x1._2__O());
  setState((function(statusMessage$1, error$1, errorDetails$1) {
    return (function(arg1$2) {
      var arg1 = $as_Lscommons_react_redux_task_TaskManager$TaskManagerState(arg1$2);
      return $m_Lscommons_react_redux_task_TaskManager$().scommons$react$redux$task$TaskManager$$$anonfun$onTaskFinish$2__Lscommons_react_redux_task_TaskManager$TaskManagerState__T__s_Option__s_Option__Lscommons_react_redux_task_TaskManager$TaskManagerState(arg1, statusMessage$1, error$1, errorDetails$1)
    })
  })(statusMessage, error, errorDetails))
}
function $p_Lscommons_react_redux_task_TaskManager$__printStackTraceAsCause__scm_StringBuilder__jl_Throwable__Ajl_StackTraceElement__T__V($thiz, sb, cause, causedTrace, sep) {
  while (true) {
    var trace = cause.getStackTrace__Ajl_StackTraceElement();
    var m = (((-1) + trace.u.length) | 0);
    var n = (((-1) + causedTrace.u.length) | 0);
    while (true) {
      if (((m >= 0) && (n >= 0))) {
        var x = trace.get(m);
        var x$2 = causedTrace.get(n);
        var $$x1 = ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
      } else {
        var $$x1 = false
      };
      if ($$x1) {
        m = (((-1) + m) | 0);
        n = (((-1) + n) | 0)
      } else {
        break
      }
    };
    var framesInCommon = (((((-1) + trace.u.length) | 0) - m) | 0);
    sb.append__T__scm_StringBuilder(("\nCaused by: " + cause));
    var end = m;
    var isEmpty = (end < 0);
    if ((!isEmpty)) {
      var i = 0;
      while (true) {
        var arg1 = i;
        sb.append__T__scm_StringBuilder(("\n\tat" + sep)).append__O__scm_StringBuilder(trace.get(arg1));
        if ((i === end)) {
          break
        };
        i = ((1 + i) | 0)
      }
    };
    if ((framesInCommon !== 0)) {
      sb.append__T__scm_StringBuilder(("\n\t..." + sep)).append__I__scm_StringBuilder(framesInCommon).append__T__scm_StringBuilder((sep + "more"))
    };
    var this$6 = cause;
    var ourCause = this$6.jl_Throwable__f_e;
    if ((ourCause !== null)) {
      cause = ourCause;
      causedTrace = trace;
      continue
    };
    return (void 0)
  }
}
function $p_Lscommons_react_redux_task_TaskManager$__defaultErrorHandler$1__s_util_Try__T2($thiz, value) {
  if ((value instanceof $c_s_util_Success)) {
    return new $c_T2($m_s_None$(), $m_s_None$())
  } else if ((value instanceof $c_s_util_Failure)) {
    var x4 = $as_s_util_Failure(value);
    var e = x4.s_util_Failure__f_exception;
    return new $c_T2(new $c_s_Some(e.toString__T()), new $c_s_Some($thiz.printStackTrace__jl_Throwable__T__T(e, "&nbsp")))
  } else {
    throw new $c_s_MatchError(value)
  }
}
/** @constructor */
function $c_Lscommons_react_redux_task_TaskManager$() {
  this.Lscommons_react_redux_task_TaskManager$__f_uiComponent = null;
  this.Lscommons_react_redux_task_TaskManager$__f_errorHandler = null;
  this.Lscommons_react_redux_task_TaskManager$__f_scommons$react$UiComponent$$reactClass = null;
  this.Lscommons_react_redux_task_TaskManager$__f_bitmap$0 = false;
  $n_Lscommons_react_redux_task_TaskManager$ = this;
  this.Lscommons_react_redux_task_TaskManager$__f_errorHandler = $m_s_PartialFunction$().s_PartialFunction$__f_empty_pf
}
$c_Lscommons_react_redux_task_TaskManager$.prototype = new $h_O();
$c_Lscommons_react_redux_task_TaskManager$.prototype.constructor = $c_Lscommons_react_redux_task_TaskManager$;
/** @constructor */
function $h_Lscommons_react_redux_task_TaskManager$() {
  /*<skip>*/
}
$h_Lscommons_react_redux_task_TaskManager$.prototype = $c_Lscommons_react_redux_task_TaskManager$.prototype;
$c_Lscommons_react_redux_task_TaskManager$.prototype.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass = (function() {
  return ((!this.Lscommons_react_redux_task_TaskManager$__f_bitmap$0) ? $p_Lscommons_react_redux_task_TaskManager$__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass(this) : this.Lscommons_react_redux_task_TaskManager$__f_scommons$react$UiComponent$$reactClass)
});
$c_Lscommons_react_redux_task_TaskManager$.prototype.render__Lio_github_shogowada_scalajs_reactjs_React$Props__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement = (function(compProps) {
  var props = $as_Lscommons_react_redux_task_TaskManagerProps(compProps.wrapped__O());
  var this$5 = $m_Lscommons_react_hooks_package$();
  var initialState = new $c_sjsr_AnonFunction0((function(this$1) {
    return (function() {
      return new $c_Lscommons_react_redux_task_TaskManager$TaskManagerState(0, $m_s_None$(), $m_s_None$(), $m_s_None$())
    })
  })(this));
  var x1 = $f_Lscommons_react_hooks_UseState__useStateUpdater__F0__T2(this$5, initialState);
  if ((x1 === null)) {
    throw new $c_s_MatchError(x1)
  };
  var state = $as_Lscommons_react_redux_task_TaskManager$TaskManagerState(x1._1__O());
  var setState = x1._2__O();
  if ((this.Lscommons_react_redux_task_TaskManager$__f_uiComponent === null)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(new $c_sjs_js_JavaScriptException(Error("TaskManager.uiComponent is not specified")))
  };
  var this$14 = $m_Lscommons_react_hooks_package$();
  var didUpdate = new $c_sjsr_AnonFunction0((function(this$2$1, props$1, setState$2) {
    return (function() {
      var this$6 = props$1.Lscommons_react_redux_task_TaskManagerProps__f_startTask;
      if ((!this$6.isEmpty__Z())) {
        var arg1 = this$6.get__O();
        var task = $as_Lscommons_react_redux_task_AbstractTask(arg1);
        $p_Lscommons_react_redux_task_TaskManager$__onTaskStart__sjs_js_Function1__Lscommons_react_redux_task_AbstractTask__V($m_Lscommons_react_redux_task_TaskManager$(), setState$2, task)
      };
      var value = (void 0);
      return value
    })
  })(this, props, setState));
  $m_s_package$();
  var x1$2 = props.Lscommons_react_redux_task_TaskManagerProps__f_startTask;
  var x = $m_s_None$();
  if ((x === x1$2)) {
    var $$x2 = $m_sjs_js_$bar$();
    var this$9 = $m_s_$less$colon$less$();
    var $$x1 = $$x2.undefOr2jsAny__sjs_js_$bar__F1__sjs_js_Any((void 0), this$9.s_$less$colon$less$__f_singleton)
  } else {
    if ((!(x1$2 instanceof $c_s_Some))) {
      throw new $c_s_MatchError(x1$2)
    };
    var x2 = $as_s_Some(x1$2);
    var task$1 = $as_Lscommons_react_redux_task_AbstractTask(x2.s_Some__f_value);
    var $$x1 = task$1
  };
  var array = [$$x1];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var dependencies = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
  $f_Lscommons_react_hooks_UseLayoutEffect__useLayoutEffect__F0__sci_List__V(this$14, didUpdate, dependencies);
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var this$15 = this.Lscommons_react_redux_task_TaskManager$__f_uiComponent;
  var reactClass = this$15.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass();
  var $$x3 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass);
  var array$1 = [$m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes().wrapped__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$WrappedPropsAttributeSpec().$colon$eq__O__Lio_github_shogowada_statictags_Attribute(new $c_Lscommons_react_redux_task_TaskManagerUiProps((state.Lscommons_react_redux_task_TaskManager$TaskManagerState__f_taskCount > 0), state.Lscommons_react_redux_task_TaskManager$TaskManagerState__f_status, new $c_sjsr_AnonFunction0((function(this$3$1, setState$2$1) {
    return (function() {
      setState$2$1((function(arg1$2) {
        var arg1$1 = $as_Lscommons_react_redux_task_TaskManager$TaskManagerState(arg1$2);
        return $m_Lscommons_react_redux_task_TaskManager$().scommons$react$redux$task$TaskManager$$$anonfun$render$5__Lscommons_react_redux_task_TaskManager$TaskManagerState__Lscommons_react_redux_task_TaskManager$TaskManagerState(arg1$1)
      }))
    })
  })(this, setState)), state.Lscommons_react_redux_task_TaskManager$TaskManagerState__f_error, state.Lscommons_react_redux_task_TaskManager$TaskManagerState__f_errorDetails, new $c_sjsr_AnonFunction0((function(this$4$1, setState$2$2) {
    return (function() {
      setState$2$2((function(arg1$2$1) {
        var arg1$3 = $as_Lscommons_react_redux_task_TaskManager$TaskManagerState(arg1$2$1);
        return $m_Lscommons_react_redux_task_TaskManager$().scommons$react$redux$task$TaskManager$$$anonfun$render$7__Lscommons_react_redux_task_TaskManager$TaskManagerState__Lscommons_react_redux_task_TaskManager$TaskManagerState(arg1$3)
      }))
    })
  })(this, setState))))];
  return $$x3.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1), $m_sci_Nil$())
});
$c_Lscommons_react_redux_task_TaskManager$.prototype.formatDuration__J__T = (function(durationMillis) {
  var $$x1 = $m_sc_StringOps$();
  var array = [($m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toDouble__I__I__D(durationMillis.RTLong__f_lo, durationMillis.RTLong__f_hi) / 1000.0)];
  return $$x1.format$extension__T__sci_Seq__T("%.3f", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))
});
$c_Lscommons_react_redux_task_TaskManager$.prototype.printStackTrace__jl_Throwable__T__T = (function(x, sep) {
  var sb = $ct_scm_StringBuilder__T__(new $c_scm_StringBuilder(), x.toString__T());
  var trace = x.getStackTrace__Ajl_StackTraceElement();
  var f = (function(this$2, sb$1, sep$1) {
    return (function(t$2) {
      var t = $as_jl_StackTraceElement(t$2);
      return sb$1.append__T__scm_StringBuilder(("\n\tat" + sep$1)).append__O__scm_StringBuilder(t)
    })
  })(this, sb, sep);
  var len = trace.u.length;
  var i = 0;
  if ((trace !== null)) {
    while ((i < len)) {
      var arg1 = trace.get(i);
      f(arg1);
      i = ((1 + i) | 0)
    }
  } else if ((trace instanceof $ac_I)) {
    var x3 = $asArrayOf_I(trace, 1);
    while ((i < len)) {
      var arg1$1 = x3.get(i);
      f(arg1$1);
      i = ((1 + i) | 0)
    }
  } else if ((trace instanceof $ac_D)) {
    var x4 = $asArrayOf_D(trace, 1);
    while ((i < len)) {
      var arg1$2 = x4.get(i);
      f(arg1$2);
      i = ((1 + i) | 0)
    }
  } else if ((trace instanceof $ac_J)) {
    var x5 = $asArrayOf_J(trace, 1);
    while ((i < len)) {
      var t$1 = x5.get(i);
      var lo = t$1.RTLong__f_lo;
      var hi = t$1.RTLong__f_hi;
      f(new $c_RTLong(lo, hi));
      i = ((1 + i) | 0)
    }
  } else if ((trace instanceof $ac_F)) {
    var x6 = $asArrayOf_F(trace, 1);
    while ((i < len)) {
      var arg1$3 = x6.get(i);
      f(arg1$3);
      i = ((1 + i) | 0)
    }
  } else if ((trace instanceof $ac_C)) {
    var x7 = $asArrayOf_C(trace, 1);
    while ((i < len)) {
      var arg1$4 = x7.get(i);
      f($bC(arg1$4));
      i = ((1 + i) | 0)
    }
  } else if ((trace instanceof $ac_B)) {
    var x8 = $asArrayOf_B(trace, 1);
    while ((i < len)) {
      var arg1$5 = x8.get(i);
      f(arg1$5);
      i = ((1 + i) | 0)
    }
  } else if ((trace instanceof $ac_S)) {
    var x9 = $asArrayOf_S(trace, 1);
    while ((i < len)) {
      var arg1$6 = x9.get(i);
      f(arg1$6);
      i = ((1 + i) | 0)
    }
  } else if ((trace instanceof $ac_Z)) {
    var x10 = $asArrayOf_Z(trace, 1);
    while ((i < len)) {
      var arg1$7 = x10.get(i);
      f(arg1$7);
      i = ((1 + i) | 0)
    }
  } else {
    throw new $c_s_MatchError(trace)
  };
  var cause = x.jl_Throwable__f_e;
  if ((cause !== null)) {
    $p_Lscommons_react_redux_task_TaskManager$__printStackTraceAsCause__scm_StringBuilder__jl_Throwable__Ajl_StackTraceElement__T__V(this, sb, cause, trace, sep)
  };
  return sb.scm_StringBuilder__f_underlying.jl_StringBuilder__f_java$lang$StringBuilder$$content
});
$c_Lscommons_react_redux_task_TaskManager$.prototype.scommons$react$redux$task$TaskManager$$$anonfun$render$5__Lscommons_react_redux_task_TaskManager$TaskManagerState__Lscommons_react_redux_task_TaskManager$TaskManagerState = (function(x$3) {
  var x$1 = $m_s_None$();
  var x$2 = x$3.Lscommons_react_redux_task_TaskManager$TaskManagerState__f_taskCount;
  var x$3$2 = x$3.Lscommons_react_redux_task_TaskManager$TaskManagerState__f_error;
  var x$4 = x$3.Lscommons_react_redux_task_TaskManager$TaskManagerState__f_errorDetails;
  return new $c_Lscommons_react_redux_task_TaskManager$TaskManagerState(x$2, x$1, x$3$2, x$4)
});
$c_Lscommons_react_redux_task_TaskManager$.prototype.scommons$react$redux$task$TaskManager$$$anonfun$render$7__Lscommons_react_redux_task_TaskManager$TaskManagerState__Lscommons_react_redux_task_TaskManager$TaskManagerState = (function(x$4) {
  var x$5 = $m_s_None$();
  var x$6 = $m_s_None$();
  var x$7 = x$4.Lscommons_react_redux_task_TaskManager$TaskManagerState__f_taskCount;
  var x$8 = x$4.Lscommons_react_redux_task_TaskManager$TaskManagerState__f_status;
  return new $c_Lscommons_react_redux_task_TaskManager$TaskManagerState(x$7, x$8, x$5, x$6)
});
$c_Lscommons_react_redux_task_TaskManager$.prototype.scommons$react$redux$task$TaskManager$$$anonfun$onTaskStart$2__Lscommons_react_redux_task_TaskManager$TaskManagerState__Lscommons_react_redux_task_AbstractTask__Lscommons_react_redux_task_TaskManager$TaskManagerState = (function(s, task$1) {
  var taskCount = ((1 + s.Lscommons_react_redux_task_TaskManager$TaskManagerState__f_taskCount) | 0);
  var status = new $c_s_Some((task$1.Lscommons_react_redux_task_FutureTask__f_message + "..."));
  var error = s.Lscommons_react_redux_task_TaskManager$TaskManagerState__f_error;
  var errorDetails = s.Lscommons_react_redux_task_TaskManager$TaskManagerState__f_errorDetails;
  return new $c_Lscommons_react_redux_task_TaskManager$TaskManagerState(taskCount, status, error, errorDetails)
});
$c_Lscommons_react_redux_task_TaskManager$.prototype.scommons$react$redux$task$TaskManager$$$anonfun$onTaskFinish$2__Lscommons_react_redux_task_TaskManager$TaskManagerState__T__s_Option__s_Option__Lscommons_react_redux_task_TaskManager$TaskManagerState = (function(s, statusMessage$1, error$1, errorDetails$1) {
  var taskCount = (((-1) + s.Lscommons_react_redux_task_TaskManager$TaskManagerState__f_taskCount) | 0);
  var status = new $c_s_Some(statusMessage$1);
  return new $c_Lscommons_react_redux_task_TaskManager$TaskManagerState(taskCount, status, error$1, errorDetails$1)
});
var $d_Lscommons_react_redux_task_TaskManager$ = new $TypeData().initClass({
  Lscommons_react_redux_task_TaskManager$: 0
}, false, "scommons.react.redux.task.TaskManager$", {
  Lscommons_react_redux_task_TaskManager$: 1,
  O: 1,
  Lscommons_react_FunctionComponent: 1,
  Lscommons_react_UiComponent: 1
});
$c_Lscommons_react_redux_task_TaskManager$.prototype.$classData = $d_Lscommons_react_redux_task_TaskManager$;
var $n_Lscommons_react_redux_task_TaskManager$;
function $m_Lscommons_react_redux_task_TaskManager$() {
  if ((!$n_Lscommons_react_redux_task_TaskManager$)) {
    $n_Lscommons_react_redux_task_TaskManager$ = new $c_Lscommons_react_redux_task_TaskManager$()
  };
  return $n_Lscommons_react_redux_task_TaskManager$
}
function $p_Lscommons_reactnative_app_AppTaskManagerUi__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz) {
  if ((!$thiz.Lscommons_reactnative_app_AppTaskManagerUi__f_bitmap$0)) {
    $thiz.Lscommons_reactnative_app_AppTaskManagerUi__f_scommons$react$UiComponent$$reactClass = $f_Lscommons_react_FunctionComponent__create__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz);
    $thiz.Lscommons_reactnative_app_AppTaskManagerUi__f_bitmap$0 = true
  };
  return $thiz.Lscommons_reactnative_app_AppTaskManagerUi__f_scommons$react$UiComponent$$reactClass
}
/** @constructor */
function $c_Lscommons_reactnative_app_AppTaskManagerUi(loadingProps) {
  this.Lscommons_reactnative_app_AppTaskManagerUi__f_loadingProps = null;
  this.Lscommons_reactnative_app_AppTaskManagerUi__f_scommons$react$UiComponent$$reactClass = null;
  this.Lscommons_reactnative_app_AppTaskManagerUi__f_bitmap$0 = false;
  this.Lscommons_reactnative_app_AppTaskManagerUi__f_loadingProps = loadingProps
}
$c_Lscommons_reactnative_app_AppTaskManagerUi.prototype = new $h_O();
$c_Lscommons_reactnative_app_AppTaskManagerUi.prototype.constructor = $c_Lscommons_reactnative_app_AppTaskManagerUi;
/** @constructor */
function $h_Lscommons_reactnative_app_AppTaskManagerUi() {
  /*<skip>*/
}
$h_Lscommons_reactnative_app_AppTaskManagerUi.prototype = $c_Lscommons_reactnative_app_AppTaskManagerUi.prototype;
$c_Lscommons_reactnative_app_AppTaskManagerUi.prototype.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass = (function() {
  return ((!this.Lscommons_reactnative_app_AppTaskManagerUi__f_bitmap$0) ? $p_Lscommons_reactnative_app_AppTaskManagerUi__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass(this) : this.Lscommons_reactnative_app_AppTaskManagerUi__f_scommons$react$UiComponent$$reactClass)
});
$c_Lscommons_reactnative_app_AppTaskManagerUi.prototype.render__Lio_github_shogowada_scalajs_reactjs_React$Props__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement = (function(compProps) {
  var props = $as_Lscommons_react_redux_task_TaskManagerUiProps(compProps.wrapped__O());
  var this$1 = props.Lscommons_react_redux_task_TaskManagerUiProps__f_status;
  var statusMessage = $as_T((this$1.isEmpty__Z() ? "" : this$1.get__O()));
  var this$2 = props.Lscommons_react_redux_task_TaskManagerUiProps__f_error;
  var showError = (!this$2.isEmpty__Z());
  var this$3 = props.Lscommons_react_redux_task_TaskManagerUiProps__f_error;
  var errorMessage = $as_T((this$3.isEmpty__Z() ? "" : this$3.get__O()));
  var elements = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x8 = new $c_Lscommons_react_package$ReactVirtualDOMElements(elements).$greater__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var $$x7 = $m_sci_Nil$();
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var this$5 = $m_Lscommons_reactnative_app_AppTaskManagerUi$().Lscommons_reactnative_app_AppTaskManagerUi$__f_taskLoggerComp;
  var reactClass = this$5.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass();
  var $$x6 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass);
  var array = [$m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes().wrapped__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$WrappedPropsAttributeSpec().$colon$eq__O__Lio_github_shogowada_statictags_Attribute(new $c_Lscommons_reactnative_app_TaskLoggerProps(statusMessage))];
  var $$x5 = $$x6.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array), $m_sci_Nil$());
  if (props.Lscommons_react_redux_task_TaskManagerUiProps__f_showLoading) {
    $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
    var this$10 = $m_Lscommons_reactnative_app_AppTaskManagerUi$().Lscommons_reactnative_app_AppTaskManagerUi$__f_loadingPopup;
    var reactClass$1 = this$10.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass();
    var $$x4 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass$1);
    var array$1 = [$m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes().wrapped__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$WrappedPropsAttributeSpec().$colon$eq__O__Lio_github_shogowada_statictags_Attribute(this.Lscommons_reactnative_app_AppTaskManagerUi__f_loadingProps)];
    var $$x3 = new $c_s_Some($$x4.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1), $m_sci_Nil$()))
  } else {
    var $$x3 = $m_s_None$()
  };
  if (showError) {
    $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
    var this$15 = $m_Lscommons_reactnative_app_AppTaskManagerUi$().Lscommons_reactnative_app_AppTaskManagerUi$__f_errorPopup;
    var reactClass$2 = this$15.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass();
    var $$x2 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass$2);
    var array$2 = [$m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes().wrapped__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$WrappedPropsAttributeSpec().$colon$eq__O__Lio_github_shogowada_statictags_Attribute(new $c_Lscommons_reactnative_ui_popup_ErrorPopupProps(errorMessage, props.Lscommons_react_redux_task_TaskManagerUiProps__f_onCloseErrorPopup, props.Lscommons_react_redux_task_TaskManagerUiProps__f_errorDetails))];
    var $$x1 = new $c_s_Some($$x2.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2), $m_sci_Nil$()))
  } else {
    var $$x1 = $m_s_None$()
  };
  var array$3 = [$$x5, $$x3, $$x1];
  return $$x8.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x7, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))
});
var $d_Lscommons_reactnative_app_AppTaskManagerUi = new $TypeData().initClass({
  Lscommons_reactnative_app_AppTaskManagerUi: 0
}, false, "scommons.reactnative.app.AppTaskManagerUi", {
  Lscommons_reactnative_app_AppTaskManagerUi: 1,
  O: 1,
  Lscommons_react_FunctionComponent: 1,
  Lscommons_react_UiComponent: 1
});
$c_Lscommons_reactnative_app_AppTaskManagerUi.prototype.$classData = $d_Lscommons_reactnative_app_AppTaskManagerUi;
function $p_Lscommons_reactnative_app_TaskLogger$__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz) {
  if ((!$thiz.Lscommons_reactnative_app_TaskLogger$__f_bitmap$0)) {
    $thiz.Lscommons_reactnative_app_TaskLogger$__f_scommons$react$UiComponent$$reactClass = $f_Lscommons_react_FunctionComponent__create__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz);
    $thiz.Lscommons_reactnative_app_TaskLogger$__f_bitmap$0 = true
  };
  return $thiz.Lscommons_reactnative_app_TaskLogger$__f_scommons$react$UiComponent$$reactClass
}
/** @constructor */
function $c_Lscommons_reactnative_app_TaskLogger$() {
  this.Lscommons_reactnative_app_TaskLogger$__f_logger = null;
  this.Lscommons_reactnative_app_TaskLogger$__f_scommons$react$UiComponent$$reactClass = null;
  this.Lscommons_reactnative_app_TaskLogger$__f_bitmap$0 = false;
  $n_Lscommons_reactnative_app_TaskLogger$ = this;
  this.Lscommons_reactnative_app_TaskLogger$__f_logger = new $c_sjsr_AnonFunction1((function(this$1) {
    return (function(x$2) {
      var this$3 = $m_s_Console$();
      var this$4 = this$3.out__Ljava_io_PrintStream();
      this$4.java$lang$JSConsoleBasedPrintStream$$printString__T__V((x$2 + "\n"))
    })
  })(this))
}
$c_Lscommons_reactnative_app_TaskLogger$.prototype = new $h_O();
$c_Lscommons_reactnative_app_TaskLogger$.prototype.constructor = $c_Lscommons_reactnative_app_TaskLogger$;
/** @constructor */
function $h_Lscommons_reactnative_app_TaskLogger$() {
  /*<skip>*/
}
$h_Lscommons_reactnative_app_TaskLogger$.prototype = $c_Lscommons_reactnative_app_TaskLogger$.prototype;
$c_Lscommons_reactnative_app_TaskLogger$.prototype.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass = (function() {
  return ((!this.Lscommons_reactnative_app_TaskLogger$__f_bitmap$0) ? $p_Lscommons_reactnative_app_TaskLogger$__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass(this) : this.Lscommons_reactnative_app_TaskLogger$__f_scommons$react$UiComponent$$reactClass)
});
$c_Lscommons_reactnative_app_TaskLogger$.prototype.render__Lio_github_shogowada_scalajs_reactjs_React$Props__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement = (function(compProps) {
  var props = $as_Lscommons_reactnative_app_TaskLoggerProps(compProps.wrapped__O());
  var this$11 = $m_Lscommons_react_hooks_package$();
  var didUpdate = new $c_sjsr_AnonFunction0((function(this$1, props$1) {
    return (function() {
      var x = props$1.Lscommons_reactnative_app_TaskLoggerProps__f_text;
      if ((x !== "")) {
        var value = $as_jl_Void($m_Lscommons_reactnative_app_TaskLogger$().Lscommons_reactnative_app_TaskLogger$__f_logger.apply__O__O(props$1.Lscommons_reactnative_app_TaskLoggerProps__f_text));
        return value
      } else {
        return (void 0)
      }
    })
  })(this, props));
  $m_s_package$();
  var s = props.Lscommons_reactnative_app_TaskLoggerProps__f_text;
  var array = [s];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var dependencies = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
  $f_Lscommons_react_hooks_UseEffect__useEffect__F0__sci_List__V(this$11, didUpdate, dependencies);
  var elements = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  return new $c_Lscommons_react_package$ReactVirtualDOMElements(elements).$greater__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec().apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($m_sci_Nil$(), $m_sci_Nil$())
});
var $d_Lscommons_reactnative_app_TaskLogger$ = new $TypeData().initClass({
  Lscommons_reactnative_app_TaskLogger$: 0
}, false, "scommons.reactnative.app.TaskLogger$", {
  Lscommons_reactnative_app_TaskLogger$: 1,
  O: 1,
  Lscommons_react_FunctionComponent: 1,
  Lscommons_react_UiComponent: 1
});
$c_Lscommons_reactnative_app_TaskLogger$.prototype.$classData = $d_Lscommons_reactnative_app_TaskLogger$;
var $n_Lscommons_reactnative_app_TaskLogger$;
function $m_Lscommons_reactnative_app_TaskLogger$() {
  if ((!$n_Lscommons_reactnative_app_TaskLogger$)) {
    $n_Lscommons_reactnative_app_TaskLogger$ = new $c_Lscommons_reactnative_app_TaskLogger$()
  };
  return $n_Lscommons_reactnative_app_TaskLogger$
}
function $p_Lscommons_reactnative_ui_ChoiceGroup__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz) {
  if ((!$thiz.Lscommons_reactnative_ui_ChoiceGroup__f_bitmap$0)) {
    $thiz.Lscommons_reactnative_ui_ChoiceGroup__f_scommons$react$UiComponent$$reactClass = $f_Lscommons_react_FunctionComponent__create__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz);
    $thiz.Lscommons_reactnative_ui_ChoiceGroup__f_bitmap$0 = true
  };
  return $thiz.Lscommons_reactnative_ui_ChoiceGroup__f_scommons$react$UiComponent$$reactClass
}
function $p_Lscommons_reactnative_ui_ChoiceGroup__onPress__Lscommons_reactnative_ui_ChoiceGroupProps__O__O__F0($thiz, props, key, row) {
  return new $c_sjsr_AnonFunction0((function(this$1, props$1, key$1) {
    return (function() {
      var isSelected = props$1.Lscommons_reactnative_ui_ChoiceGroupProps__f_selectedIds.contains__O__Z(key$1);
      if (props$1.Lscommons_reactnative_ui_ChoiceGroupProps__f_multiSelect) {
        if (isSelected) {
          var this$2 = props$1.Lscommons_reactnative_ui_ChoiceGroupProps__f_selectedIds;
          var newIds = $as_sci_Set(this$2.excl__O__sci_SetOps(key$1))
        } else {
          var this$3 = props$1.Lscommons_reactnative_ui_ChoiceGroupProps__f_selectedIds;
          var newIds = $as_sci_Set(this$3.incl__O__sci_SetOps(key$1))
        };
        props$1.Lscommons_reactnative_ui_ChoiceGroupProps__f_onSelectChange.apply__O__O(newIds)
      } else if ((!isSelected)) {
        var $$x1 = props$1.Lscommons_reactnative_ui_ChoiceGroupProps__f_onSelectChange;
        var this$7 = $m_s_Predef$().s_Predef$__f_Set;
        var array = [key$1];
        var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
        $$x1.apply__O__O(this$7.from__sc_IterableOnce__sci_Set(elems))
      }
    })
  })($thiz, props, key))
}
function $p_Lscommons_reactnative_ui_ChoiceGroup__renderItem$1__O__I__Lscommons_reactnative_ui_ChoiceGroupProps__Lscommons_react_navigation_raw_Theme__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($thiz, data, index, props$1, theme$2) {
  var key = props$1.Lscommons_reactnative_ui_ChoiceGroupProps__f_keyExtractor.apply__O__O(data);
  var isSelected = props$1.Lscommons_reactnative_ui_ChoiceGroupProps__f_selectedIds.contains__O__Z(key);
  var elements = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x4 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements).TouchableOpacity__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var this$2 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes().key__Lio_github_shogowada_statictags_StringAttributeSpec();
  var value = ("" + key);
  var $$x2 = new $c_Lio_github_shogowada_statictags_Attribute(this$2.Lio_github_shogowada_statictags_StringAttributeSpec__f_name, value, $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$());
  if ((index > 0)) {
    var attributes = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
    var $$x1 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__sjs_js_Array__Lio_github_shogowada_statictags_Attribute([$m_Lscommons_reactnative_ui_ChoiceGroup$().styles__Lscommons_reactnative_ui_ChoiceGroup$Styles().item, $m_Lscommons_reactnative_ui_ChoiceGroup$().styles__Lscommons_reactnative_ui_ChoiceGroup$Styles().nonTopItem])
  } else {
    var attributes$1 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
    var $$x1 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$1).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__Lscommons_reactnative_Style__Lio_github_shogowada_statictags_Attribute($m_Lscommons_reactnative_ui_ChoiceGroup$().styles__Lscommons_reactnative_ui_ChoiceGroup$Styles().item)
  };
  var attributes$2 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array = [$$x2, $$x1, new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$2).onPress__Lscommons_reactnative_Touchable$TouchableAttributes$OnPressEventAttribute().$colon$eq__sjs_js_Function0__Lio_github_shogowada_statictags_Attribute($m_sjs_js_Any$().fromFunction0__F0__sjs_js_Function0($p_Lscommons_reactnative_ui_ChoiceGroup__onPress__Lscommons_reactnative_ui_ChoiceGroupProps__O__O__F0($thiz, props$1, key, data)))];
  var $$x3 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var array$1 = [props$1.Lscommons_reactnative_ui_ChoiceGroupProps__f_iconRenderer.apply__O__O__O(isSelected, theme$2), props$1.Lscommons_reactnative_ui_ChoiceGroupProps__f_labelRenderer.apply__O__O__O(data, theme$2)];
  return $$x4.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x3, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
}
function $ct_Lscommons_reactnative_ui_ChoiceGroup__($thiz) {
  return $thiz
}
/** @constructor */
function $c_Lscommons_reactnative_ui_ChoiceGroup() {
  this.Lscommons_reactnative_ui_ChoiceGroup__f_scommons$react$UiComponent$$reactClass = null;
  this.Lscommons_reactnative_ui_ChoiceGroup__f_bitmap$0 = false
}
$c_Lscommons_reactnative_ui_ChoiceGroup.prototype = new $h_O();
$c_Lscommons_reactnative_ui_ChoiceGroup.prototype.constructor = $c_Lscommons_reactnative_ui_ChoiceGroup;
/** @constructor */
function $h_Lscommons_reactnative_ui_ChoiceGroup() {
  /*<skip>*/
}
$h_Lscommons_reactnative_ui_ChoiceGroup.prototype = $c_Lscommons_reactnative_ui_ChoiceGroup.prototype;
$c_Lscommons_reactnative_ui_ChoiceGroup.prototype.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass = (function() {
  return ((!this.Lscommons_reactnative_ui_ChoiceGroup__f_bitmap$0) ? $p_Lscommons_reactnative_ui_ChoiceGroup__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass(this) : this.Lscommons_reactnative_ui_ChoiceGroup__f_scommons$react$UiComponent$$reactClass)
});
$c_Lscommons_reactnative_ui_ChoiceGroup.prototype.render__Lio_github_shogowada_scalajs_reactjs_React$Props__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement = (function(compProps) {
  var this$1 = $m_Lscommons_react_navigation_package$();
  var theme = this$1.native__Lscommons_react_navigation_raw_ReactNavigation().useTheme();
  var props = $as_Lscommons_reactnative_ui_ChoiceGroupProps(compProps.wrapped__O());
  var elements = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x3 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements).View__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var this$3 = props.Lscommons_reactnative_ui_ChoiceGroupProps__f_style;
  if (this$3.isEmpty__Z()) {
    var $$x1 = $m_s_None$()
  } else {
    var arg1 = this$3.get__O();
    var attributes = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
    var $$x1 = new $c_s_Some(new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__Lscommons_reactnative_Style__Lio_github_shogowada_statictags_Attribute(arg1))
  };
  var array = [$$x1];
  var $$x2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var array$1 = [$as_sc_IterableOps(props.Lscommons_reactnative_ui_ChoiceGroupProps__f_items.zipWithIndex__O()).map__F1__O(new $c_sjsr_AnonFunction1((function(this$2$1, props$1, theme$1) {
    return (function(x0$1$2) {
      var x0$1 = $as_T2(x0$1$2);
      if ((x0$1 !== null)) {
        var data = x0$1._1__O();
        var index = $uI(x0$1._2__O());
        return $p_Lscommons_reactnative_ui_ChoiceGroup__renderItem$1__O__I__Lscommons_reactnative_ui_ChoiceGroupProps__Lscommons_react_navigation_raw_Theme__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement(this$2$1, data, index, props$1, theme$1)
      } else {
        throw new $c_s_MatchError(x0$1)
      }
    })
  })(this, props, theme)))];
  return $$x3.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x2, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
});
var $d_Lscommons_reactnative_ui_ChoiceGroup = new $TypeData().initClass({
  Lscommons_reactnative_ui_ChoiceGroup: 0
}, false, "scommons.reactnative.ui.ChoiceGroup", {
  Lscommons_reactnative_ui_ChoiceGroup: 1,
  O: 1,
  Lscommons_react_FunctionComponent: 1,
  Lscommons_react_UiComponent: 1
});
$c_Lscommons_reactnative_ui_ChoiceGroup.prototype.$classData = $d_Lscommons_reactnative_ui_ChoiceGroup;
var $b_Lscommons_reactnative_ui_ChoiceGroup$Styles;
function $a_Lscommons_reactnative_ui_ChoiceGroup$Styles() {
  if ((!$b_Lscommons_reactnative_ui_ChoiceGroup$Styles)) {
    /** @constructor */
    $b_Lscommons_reactnative_ui_ChoiceGroup$Styles = (function() {
      Object.call(this);
      Object.defineProperty(this, "item", {
        "configurable": true,
        "enumerable": true,
        "writable": true,
        "value": null
      });
      Object.defineProperty(this, "nonTopItem", {
        "configurable": true,
        "enumerable": true,
        "writable": true,
        "value": null
      });
      Object.defineProperty(this, "label", {
        "configurable": true,
        "enumerable": true,
        "writable": true,
        "value": null
      });
      this.item = (function(superClass$, arg$outer) {
        return (function() {
          var outer = arg$outer;
          var this\u00f8 = {};
          this\u00f8.flexDirection = null;
          this\u00f8.alignItems = null;
          this\u00f8.flexDirection = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($m_Lscommons_reactnative_ViewStyle$FlexDirection$().row__Lscommons_reactnative_ViewStyle$FlexDirection(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this\u00f8.alignItems = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($m_Lscommons_reactnative_ViewStyle$AlignItems$().center__Lscommons_reactnative_ViewStyle$AlignItems(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          $s_sr_Statics__releaseFence__V();
          return this\u00f8
        })
      })(Object, this)();
      this.nonTopItem = (function(superClass$, arg$outer) {
        return (function() {
          var outer = arg$outer;
          var this$2 = {};
          this$2.marginTop = null;
          this$2.marginTop = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(10, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().right__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          $s_sr_Statics__releaseFence__V();
          return this$2
        })
      })(Object, this)();
      this.label = (function(superClass$, arg$outer) {
        return (function() {
          var outer = arg$outer;
          var this$3 = {};
          this$3.marginHorizontal = null;
          this$3.paddingHorizontal = null;
          this$3.marginHorizontal = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(5, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().right__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          this$3.paddingHorizontal = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(5, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().right__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          $s_sr_Statics__releaseFence__V();
          return this$3
        })
      })(Object, this)()
    });
    /** @constructor */
    var $hh_Lscommons_reactnative_ui_ChoiceGroup$Styles = (function() {
      /*<skip>*/
    });
    $hh_Lscommons_reactnative_ui_ChoiceGroup$Styles.prototype = Object.prototype;
    $b_Lscommons_reactnative_ui_ChoiceGroup$Styles.prototype = new $hh_Lscommons_reactnative_ui_ChoiceGroup$Styles();
    $b_Lscommons_reactnative_ui_ChoiceGroup$Styles.prototype.constructor = $b_Lscommons_reactnative_ui_ChoiceGroup$Styles
  };
  return $b_Lscommons_reactnative_ui_ChoiceGroup$Styles
}
function $p_Lscommons_reactnative_ui_popup_ErrorPopup$__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz) {
  if ((!$thiz.Lscommons_reactnative_ui_popup_ErrorPopup$__f_bitmap$0)) {
    $thiz.Lscommons_reactnative_ui_popup_ErrorPopup$__f_scommons$react$UiComponent$$reactClass = $f_Lscommons_react_FunctionComponent__create__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz);
    $thiz.Lscommons_reactnative_ui_popup_ErrorPopup$__f_bitmap$0 = true
  };
  return $thiz.Lscommons_reactnative_ui_popup_ErrorPopup$__f_scommons$react$UiComponent$$reactClass
}
function $p_Lscommons_reactnative_ui_popup_ErrorPopup$__getFullText__Lscommons_reactnative_ui_popup_ErrorPopupProps__T($thiz, props) {
  var $$x1 = props.Lscommons_reactnative_ui_popup_ErrorPopupProps__f_error;
  var this$1 = props.Lscommons_reactnative_ui_popup_ErrorPopupProps__f_details;
  return (($$x1 + "\n\n") + (this$1.isEmpty__Z() ? "" : this$1.get__O()))
}
function $p_Lscommons_reactnative_ui_popup_ErrorPopup$__showAlert$1__Z__Lscommons_reactnative_ui_popup_ErrorPopupProps__sjs_js_Function1__Lscommons_reactnative_Alert$AlertButton__V($thiz, showDetails$1, props$1, setShowDetails$1, closeBtn$1) {
  var $$x3 = $m_Lscommons_reactnative_Alert$();
  var $$x2 = (showDetails$1 ? $p_Lscommons_reactnative_ui_popup_ErrorPopup$__getFullText__Lscommons_reactnative_ui_popup_ErrorPopupProps__T($thiz, props$1) : props$1.Lscommons_reactnative_ui_popup_ErrorPopupProps__f_error);
  var this$1 = props$1.Lscommons_reactnative_ui_popup_ErrorPopupProps__f_details;
  if (((!this$1.isEmpty__Z()) && (!showDetails$1))) {
    var detailsBtn = new $c_Lscommons_reactnative_Alert$AlertButton("Details", new $c_sjsr_AnonFunction0((function(this$2, setShowDetails$1$1, showDetails$1$1) {
      return (function() {
        setShowDetails$1$1((!showDetails$1$1))
      })
    })($thiz, setShowDetails$1, showDetails$1)), $m_s_None$());
    $m_s_package$();
    var array = [detailsBtn, closeBtn$1];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    var $$x1 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)
  } else {
    $m_s_package$();
    var array$1 = [closeBtn$1];
    var elems$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
    var $$x1 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$1)
  };
  var this$12 = $m_Lscommons_reactnative_Alert$();
  $$x3.alert__T__T__sci_List__Lscommons_reactnative_raw_AlertOptions__V("Error", $$x2, $$x1, $p_Lscommons_reactnative_Alert$__defaultOptions__Lscommons_reactnative_raw_AlertOptions(this$12))
}
/** @constructor */
function $c_Lscommons_reactnative_ui_popup_ErrorPopup$() {
  this.Lscommons_reactnative_ui_popup_ErrorPopup$__f_scommons$react$UiComponent$$reactClass = null;
  this.Lscommons_reactnative_ui_popup_ErrorPopup$__f_bitmap$0 = false
}
$c_Lscommons_reactnative_ui_popup_ErrorPopup$.prototype = new $h_O();
$c_Lscommons_reactnative_ui_popup_ErrorPopup$.prototype.constructor = $c_Lscommons_reactnative_ui_popup_ErrorPopup$;
/** @constructor */
function $h_Lscommons_reactnative_ui_popup_ErrorPopup$() {
  /*<skip>*/
}
$h_Lscommons_reactnative_ui_popup_ErrorPopup$.prototype = $c_Lscommons_reactnative_ui_popup_ErrorPopup$.prototype;
$c_Lscommons_reactnative_ui_popup_ErrorPopup$.prototype.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass = (function() {
  return ((!this.Lscommons_reactnative_ui_popup_ErrorPopup$__f_bitmap$0) ? $p_Lscommons_reactnative_ui_popup_ErrorPopup$__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass(this) : this.Lscommons_reactnative_ui_popup_ErrorPopup$__f_scommons$react$UiComponent$$reactClass)
});
$c_Lscommons_reactnative_ui_popup_ErrorPopup$.prototype.render__Lio_github_shogowada_scalajs_reactjs_React$Props__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement = (function(compProps) {
  var this$1 = $m_Lscommons_react_hooks_package$();
  var x1 = $f_Lscommons_react_hooks_UseState__useState__O__T2(this$1, false);
  if ((x1 === null)) {
    throw new $c_s_MatchError(x1)
  };
  var showDetails = $uZ(x1._1__O());
  var setShowDetails = x1._2__O();
  var props = $as_Lscommons_reactnative_ui_popup_ErrorPopupProps(compProps.wrapped__O());
  var closeBtn = new $c_Lscommons_reactnative_Alert$AlertButton("Close", props.Lscommons_reactnative_ui_popup_ErrorPopupProps__f_onClose, new $c_s_Some($m_Lscommons_reactnative_Alert$AlertButtonStyle$().Lscommons_reactnative_Alert$AlertButtonStyle$__f_cancel));
  var this$10 = $m_Lscommons_react_hooks_package$();
  var didUpdate = new $c_sjsr_AnonFunction0((function(this$2, showDetails$2, props$1, setShowDetails$2, closeBtn$1) {
    return (function() {
      if ((!showDetails$2)) {
        $m_Lscommons_reactnative_package$().setTimeout__sjs_js_Function0__D__Lscommons_reactnative_raw_Timeout((function(showDetails$1, props$1$1, setShowDetails$1, closeBtn$1$1) {
          return (function() {
            var this$3 = $m_Lscommons_reactnative_ui_popup_ErrorPopup$();
            $p_Lscommons_reactnative_ui_popup_ErrorPopup$__showAlert$1__Z__Lscommons_reactnative_ui_popup_ErrorPopupProps__sjs_js_Function1__Lscommons_reactnative_Alert$AlertButton__V(this$3, showDetails$1, props$1$1, setShowDetails$1, closeBtn$1$1)
          })
        })(showDetails$2, props$1, setShowDetails$2, closeBtn$1), 100.0)
      } else {
        $p_Lscommons_reactnative_ui_popup_ErrorPopup$__showAlert$1__Z__Lscommons_reactnative_ui_popup_ErrorPopupProps__sjs_js_Function1__Lscommons_reactnative_Alert$AlertButton__V(this$2, showDetails$2, props$1, setShowDetails$2, closeBtn$1)
      }
    })
  })(this, showDetails, props, setShowDetails, closeBtn));
  $m_s_package$();
  var array = [showDetails];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var dependencies = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
  $f_Lscommons_react_hooks_UseEffect__useEffect__F0__sci_List__V(this$10, didUpdate, dependencies);
  var elements = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  return new $c_Lscommons_react_package$ReactVirtualDOMElements(elements).$greater__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec().apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($m_sci_Nil$(), $m_sci_Nil$())
});
var $d_Lscommons_reactnative_ui_popup_ErrorPopup$ = new $TypeData().initClass({
  Lscommons_reactnative_ui_popup_ErrorPopup$: 0
}, false, "scommons.reactnative.ui.popup.ErrorPopup$", {
  Lscommons_reactnative_ui_popup_ErrorPopup$: 1,
  O: 1,
  Lscommons_react_FunctionComponent: 1,
  Lscommons_react_UiComponent: 1
});
$c_Lscommons_reactnative_ui_popup_ErrorPopup$.prototype.$classData = $d_Lscommons_reactnative_ui_popup_ErrorPopup$;
var $n_Lscommons_reactnative_ui_popup_ErrorPopup$;
function $m_Lscommons_reactnative_ui_popup_ErrorPopup$() {
  if ((!$n_Lscommons_reactnative_ui_popup_ErrorPopup$)) {
    $n_Lscommons_reactnative_ui_popup_ErrorPopup$ = new $c_Lscommons_reactnative_ui_popup_ErrorPopup$()
  };
  return $n_Lscommons_reactnative_ui_popup_ErrorPopup$
}
function $p_Lscommons_reactnative_ui_popup_LoadingPopup$__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz) {
  if (((((2 & $thiz.Lscommons_reactnative_ui_popup_LoadingPopup$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lscommons_reactnative_ui_popup_LoadingPopup$__f_scommons$react$UiComponent$$reactClass = $f_Lscommons_react_FunctionComponent__create__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz);
    $thiz.Lscommons_reactnative_ui_popup_LoadingPopup$__f_bitmap$0 = (((2 | $thiz.Lscommons_reactnative_ui_popup_LoadingPopup$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lscommons_reactnative_ui_popup_LoadingPopup$__f_scommons$react$UiComponent$$reactClass
}
function $p_Lscommons_reactnative_ui_popup_LoadingPopup$__styles$lzycompute__Lscommons_reactnative_ui_popup_LoadingPopup$Styles($thiz) {
  if (((((1 & $thiz.Lscommons_reactnative_ui_popup_LoadingPopup$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lscommons_reactnative_ui_popup_LoadingPopup$__f_styles = $m_Lscommons_reactnative_StyleSheet$().create__sjs_js_Object__sjs_js_Object(new ($a_Lscommons_reactnative_ui_popup_LoadingPopup$Styles())());
    $thiz.Lscommons_reactnative_ui_popup_LoadingPopup$__f_bitmap$0 = (((1 | $thiz.Lscommons_reactnative_ui_popup_LoadingPopup$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lscommons_reactnative_ui_popup_LoadingPopup$__f_styles
}
/** @constructor */
function $c_Lscommons_reactnative_ui_popup_LoadingPopup$() {
  this.Lscommons_reactnative_ui_popup_LoadingPopup$__f_styles = null;
  this.Lscommons_reactnative_ui_popup_LoadingPopup$__f_scommons$react$UiComponent$$reactClass = null;
  this.Lscommons_reactnative_ui_popup_LoadingPopup$__f_bitmap$0 = 0
}
$c_Lscommons_reactnative_ui_popup_LoadingPopup$.prototype = new $h_O();
$c_Lscommons_reactnative_ui_popup_LoadingPopup$.prototype.constructor = $c_Lscommons_reactnative_ui_popup_LoadingPopup$;
/** @constructor */
function $h_Lscommons_reactnative_ui_popup_LoadingPopup$() {
  /*<skip>*/
}
$h_Lscommons_reactnative_ui_popup_LoadingPopup$.prototype = $c_Lscommons_reactnative_ui_popup_LoadingPopup$.prototype;
$c_Lscommons_reactnative_ui_popup_LoadingPopup$.prototype.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass = (function() {
  return (((((2 & this.Lscommons_reactnative_ui_popup_LoadingPopup$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lscommons_reactnative_ui_popup_LoadingPopup$__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass(this) : this.Lscommons_reactnative_ui_popup_LoadingPopup$__f_scommons$react$UiComponent$$reactClass)
});
$c_Lscommons_reactnative_ui_popup_LoadingPopup$.prototype.render__Lio_github_shogowada_scalajs_reactjs_React$Props__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement = (function(compProps) {
  var props = $as_Lscommons_reactnative_ui_popup_LoadingPopupProps(compProps.wrapped__O());
  var elements = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x8 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements).Modal__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var attributes = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var $$x6 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes).animationType__Lscommons_reactnative_Modal$ModalAttributes$AnimationTypeAttributeSpec().$colon$eq__Lscommons_reactnative_Modal$AnimationType__Lio_github_shogowada_statictags_Attribute($m_Lscommons_reactnative_Modal$AnimationType$().Lscommons_reactnative_Modal$AnimationType$__f_none);
  var attributes$1 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var this$4 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$1).transparent__Lio_github_shogowada_statictags_BooleanAttributeSpec();
  var $$x5 = new $c_Lio_github_shogowada_statictags_Attribute(this$4.Lio_github_shogowada_statictags_BooleanAttributeSpec__f_name, true, $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$());
  var attributes$2 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var this$7 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$2).visible__Lio_github_shogowada_statictags_BooleanAttributeSpec();
  var array = [$$x6, $$x5, new $c_Lio_github_shogowada_statictags_Attribute(this$7.Lio_github_shogowada_statictags_BooleanAttributeSpec__f_name, true, $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$())];
  var $$x7 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var elements$1 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x4 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements$1).View__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var attributes$3 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array$1 = [new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$3).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__Lscommons_reactnative_Style__Lio_github_shogowada_statictags_Attribute(this.styles__Lscommons_reactnative_ui_popup_LoadingPopup$Styles().container)];
  var $$x3 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  var elements$2 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x2 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements$2).ActivityIndicator__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var attributes$4 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var $$x1 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$4).aiSize__Lscommons_reactnative_ActivityIndicator$ActivityIndicatorAttributes$ActivityIndicatorSizeAttributeSpec().$colon$eq__Lscommons_reactnative_ActivityIndicator$ActivityIndicatorSize__Lio_github_shogowada_statictags_Attribute(props.Lscommons_reactnative_ui_popup_LoadingPopupProps__f_size);
  var attributes$5 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var this$20 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$5).color__Lio_github_shogowada_statictags_StringAttributeSpec();
  var value = props.Lscommons_reactnative_ui_popup_LoadingPopupProps__f_color;
  var array$2 = [$$x1, new $c_Lio_github_shogowada_statictags_Attribute(this$20.Lio_github_shogowada_statictags_StringAttributeSpec__f_name, value, $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$())];
  var array$3 = [$$x2.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2), $m_sci_Nil$())];
  var array$4 = [$$x4.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x3, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))];
  return $$x8.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x7, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4))
});
$c_Lscommons_reactnative_ui_popup_LoadingPopup$.prototype.styles__Lscommons_reactnative_ui_popup_LoadingPopup$Styles = (function() {
  return (((((1 & this.Lscommons_reactnative_ui_popup_LoadingPopup$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lscommons_reactnative_ui_popup_LoadingPopup$__styles$lzycompute__Lscommons_reactnative_ui_popup_LoadingPopup$Styles(this) : this.Lscommons_reactnative_ui_popup_LoadingPopup$__f_styles)
});
var $d_Lscommons_reactnative_ui_popup_LoadingPopup$ = new $TypeData().initClass({
  Lscommons_reactnative_ui_popup_LoadingPopup$: 0
}, false, "scommons.reactnative.ui.popup.LoadingPopup$", {
  Lscommons_reactnative_ui_popup_LoadingPopup$: 1,
  O: 1,
  Lscommons_react_FunctionComponent: 1,
  Lscommons_react_UiComponent: 1
});
$c_Lscommons_reactnative_ui_popup_LoadingPopup$.prototype.$classData = $d_Lscommons_reactnative_ui_popup_LoadingPopup$;
var $n_Lscommons_reactnative_ui_popup_LoadingPopup$;
function $m_Lscommons_reactnative_ui_popup_LoadingPopup$() {
  if ((!$n_Lscommons_reactnative_ui_popup_LoadingPopup$)) {
    $n_Lscommons_reactnative_ui_popup_LoadingPopup$ = new $c_Lscommons_reactnative_ui_popup_LoadingPopup$()
  };
  return $n_Lscommons_reactnative_ui_popup_LoadingPopup$
}
var $b_Lscommons_reactnative_ui_popup_LoadingPopup$Styles;
function $a_Lscommons_reactnative_ui_popup_LoadingPopup$Styles() {
  if ((!$b_Lscommons_reactnative_ui_popup_LoadingPopup$Styles)) {
    /** @constructor */
    $b_Lscommons_reactnative_ui_popup_LoadingPopup$Styles = (function() {
      Object.call(this);
      Object.defineProperty(this, "container", {
        "configurable": true,
        "enumerable": true,
        "writable": true,
        "value": null
      });
      this.container = (function(superClass$, arg$outer) {
        return (function() {
          var outer = arg$outer;
          var this\u00f8 = {};
          this\u00f8.flex = null;
          this\u00f8.justifyContent = null;
          this\u00f8.alignContent = null;
          this\u00f8.flex = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(1, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this\u00f8.justifyContent = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($m_Lscommons_reactnative_ViewStyle$JustifyContent$().center__Lscommons_reactnative_ViewStyle$JustifyContent(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this\u00f8.alignContent = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($m_Lscommons_reactnative_ViewStyle$AlignContent$().center__Lscommons_reactnative_ViewStyle$AlignContent(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          $s_sr_Statics__releaseFence__V();
          return this\u00f8
        })
      })(Object, this)()
    });
    /** @constructor */
    var $hh_Lscommons_reactnative_ui_popup_LoadingPopup$Styles = (function() {
      /*<skip>*/
    });
    $hh_Lscommons_reactnative_ui_popup_LoadingPopup$Styles.prototype = Object.prototype;
    $b_Lscommons_reactnative_ui_popup_LoadingPopup$Styles.prototype = new $hh_Lscommons_reactnative_ui_popup_LoadingPopup$Styles();
    $b_Lscommons_reactnative_ui_popup_LoadingPopup$Styles.prototype.constructor = $b_Lscommons_reactnative_ui_popup_LoadingPopup$Styles
  };
  return $b_Lscommons_reactnative_ui_popup_LoadingPopup$Styles
}
function $p_Lshowcase_ActivityIndicatorDemo$__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz) {
  if (((((2 & $thiz.Lshowcase_ActivityIndicatorDemo$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lshowcase_ActivityIndicatorDemo$__f_scommons$react$UiComponent$$reactClass = $f_Lscommons_react_FunctionComponent__create__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz);
    $thiz.Lshowcase_ActivityIndicatorDemo$__f_bitmap$0 = (((2 | $thiz.Lshowcase_ActivityIndicatorDemo$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lshowcase_ActivityIndicatorDemo$__f_scommons$react$UiComponent$$reactClass
}
function $p_Lshowcase_ActivityIndicatorDemo$__styles$lzycompute__Lshowcase_ActivityIndicatorDemo$Styles($thiz) {
  if (((((1 & $thiz.Lshowcase_ActivityIndicatorDemo$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lshowcase_ActivityIndicatorDemo$__f_styles = $m_Lscommons_reactnative_StyleSheet$().create__sjs_js_Object__sjs_js_Object(new ($a_Lshowcase_ActivityIndicatorDemo$Styles())());
    $thiz.Lshowcase_ActivityIndicatorDemo$__f_bitmap$0 = (((1 | $thiz.Lshowcase_ActivityIndicatorDemo$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lshowcase_ActivityIndicatorDemo$__f_styles
}
/** @constructor */
function $c_Lshowcase_ActivityIndicatorDemo$() {
  this.Lshowcase_ActivityIndicatorDemo$__f_styles = null;
  this.Lshowcase_ActivityIndicatorDemo$__f_scommons$react$UiComponent$$reactClass = null;
  this.Lshowcase_ActivityIndicatorDemo$__f_bitmap$0 = 0
}
$c_Lshowcase_ActivityIndicatorDemo$.prototype = new $h_O();
$c_Lshowcase_ActivityIndicatorDemo$.prototype.constructor = $c_Lshowcase_ActivityIndicatorDemo$;
/** @constructor */
function $h_Lshowcase_ActivityIndicatorDemo$() {
  /*<skip>*/
}
$h_Lshowcase_ActivityIndicatorDemo$.prototype = $c_Lshowcase_ActivityIndicatorDemo$.prototype;
$c_Lshowcase_ActivityIndicatorDemo$.prototype.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass = (function() {
  return (((((2 & this.Lshowcase_ActivityIndicatorDemo$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lshowcase_ActivityIndicatorDemo$__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass(this) : this.Lshowcase_ActivityIndicatorDemo$__f_scommons$react$UiComponent$$reactClass)
});
$c_Lshowcase_ActivityIndicatorDemo$.prototype.render__Lio_github_shogowada_scalajs_reactjs_React$Props__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement = (function(props) {
  var elements = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x13 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements).View__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var attributes = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array = [new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__sjs_js_Array__Lio_github_shogowada_statictags_Attribute([this.styles__Lshowcase_ActivityIndicatorDemo$Styles().container, this.styles__Lshowcase_ActivityIndicatorDemo$Styles().horizontal])];
  var $$x12 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var elements$1 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x11 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements$1).ActivityIndicator__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var attributes$1 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var $$x10 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$1).aiSize__Lscommons_reactnative_ActivityIndicator$ActivityIndicatorAttributes$ActivityIndicatorSizeAttributeSpec().$colon$eq__Lscommons_reactnative_ActivityIndicator$ActivityIndicatorSize__Lio_github_shogowada_statictags_Attribute($m_Lscommons_reactnative_ActivityIndicator$ActivityIndicatorSize$().Lscommons_reactnative_ActivityIndicator$ActivityIndicatorSize$__f_large);
  var attributes$2 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var this$9 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$2).color__Lio_github_shogowada_statictags_StringAttributeSpec();
  var array$1 = [$$x10, new $c_Lio_github_shogowada_statictags_Attribute(this$9.Lio_github_shogowada_statictags_StringAttributeSpec__f_name, "#0000ff", $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$())];
  var $$x9 = $$x11.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1), $m_sci_Nil$());
  var elements$2 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x8 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements$2).ActivityIndicator__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var attributes$3 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var $$x7 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$3).aiSize__Lscommons_reactnative_ActivityIndicator$ActivityIndicatorAttributes$ActivityIndicatorSizeAttributeSpec().$colon$eq__Lscommons_reactnative_ActivityIndicator$ActivityIndicatorSize__Lio_github_shogowada_statictags_Attribute($m_Lscommons_reactnative_ActivityIndicator$ActivityIndicatorSize$().Lscommons_reactnative_ActivityIndicator$ActivityIndicatorSize$__f_small);
  var attributes$4 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var this$17 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$4).color__Lio_github_shogowada_statictags_StringAttributeSpec();
  var array$2 = [$$x7, new $c_Lio_github_shogowada_statictags_Attribute(this$17.Lio_github_shogowada_statictags_StringAttributeSpec__f_name, "#00ff00", $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$())];
  var $$x6 = $$x8.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2), $m_sci_Nil$());
  var elements$3 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x5 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements$3).ActivityIndicator__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var attributes$5 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var $$x4 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$5).aiSize__Lscommons_reactnative_ActivityIndicator$ActivityIndicatorAttributes$ActivityIndicatorSizeAttributeSpec().$colon$eq__Lscommons_reactnative_ActivityIndicator$ActivityIndicatorSize__Lio_github_shogowada_statictags_Attribute($m_Lscommons_reactnative_ActivityIndicator$ActivityIndicatorSize$().Lscommons_reactnative_ActivityIndicator$ActivityIndicatorSize$__f_large);
  var attributes$6 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var this$25 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$6).color__Lio_github_shogowada_statictags_StringAttributeSpec();
  var array$3 = [$$x4, new $c_Lio_github_shogowada_statictags_Attribute(this$25.Lio_github_shogowada_statictags_StringAttributeSpec__f_name, "#0000ff", $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$())];
  var $$x3 = $$x5.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3), $m_sci_Nil$());
  var elements$4 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x2 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements$4).ActivityIndicator__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var attributes$7 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var $$x1 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$7).aiSize__Lscommons_reactnative_ActivityIndicator$ActivityIndicatorAttributes$ActivityIndicatorSizeAttributeSpec().$colon$eq__Lscommons_reactnative_ActivityIndicator$ActivityIndicatorSize__Lio_github_shogowada_statictags_Attribute($m_Lscommons_reactnative_ActivityIndicator$ActivityIndicatorSize$().Lscommons_reactnative_ActivityIndicator$ActivityIndicatorSize$__f_small);
  var attributes$8 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var this$33 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$8).color__Lio_github_shogowada_statictags_StringAttributeSpec();
  var array$4 = [$$x1, new $c_Lio_github_shogowada_statictags_Attribute(this$33.Lio_github_shogowada_statictags_StringAttributeSpec__f_name, "#00ff00", $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$())];
  var array$5 = [$$x9, $$x6, $$x3, $$x2.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4), $m_sci_Nil$())];
  return $$x13.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x12, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5))
});
$c_Lshowcase_ActivityIndicatorDemo$.prototype.styles__Lshowcase_ActivityIndicatorDemo$Styles = (function() {
  return (((((1 & this.Lshowcase_ActivityIndicatorDemo$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lshowcase_ActivityIndicatorDemo$__styles$lzycompute__Lshowcase_ActivityIndicatorDemo$Styles(this) : this.Lshowcase_ActivityIndicatorDemo$__f_styles)
});
var $d_Lshowcase_ActivityIndicatorDemo$ = new $TypeData().initClass({
  Lshowcase_ActivityIndicatorDemo$: 0
}, false, "showcase.ActivityIndicatorDemo$", {
  Lshowcase_ActivityIndicatorDemo$: 1,
  O: 1,
  Lscommons_react_FunctionComponent: 1,
  Lscommons_react_UiComponent: 1
});
$c_Lshowcase_ActivityIndicatorDemo$.prototype.$classData = $d_Lshowcase_ActivityIndicatorDemo$;
var $n_Lshowcase_ActivityIndicatorDemo$;
function $m_Lshowcase_ActivityIndicatorDemo$() {
  if ((!$n_Lshowcase_ActivityIndicatorDemo$)) {
    $n_Lshowcase_ActivityIndicatorDemo$ = new $c_Lshowcase_ActivityIndicatorDemo$()
  };
  return $n_Lshowcase_ActivityIndicatorDemo$
}
var $b_Lshowcase_ActivityIndicatorDemo$Styles;
function $a_Lshowcase_ActivityIndicatorDemo$Styles() {
  if ((!$b_Lshowcase_ActivityIndicatorDemo$Styles)) {
    /** @constructor */
    $b_Lshowcase_ActivityIndicatorDemo$Styles = (function() {
      Object.call(this);
      Object.defineProperty(this, "container", {
        "configurable": true,
        "enumerable": true,
        "writable": true,
        "value": null
      });
      Object.defineProperty(this, "horizontal", {
        "configurable": true,
        "enumerable": true,
        "writable": true,
        "value": null
      });
      this.container = (function(superClass$, arg$outer) {
        return (function() {
          var outer = arg$outer;
          var this\u00f8 = {};
          this\u00f8.flex = null;
          this\u00f8.justifyContent = null;
          this\u00f8.flex = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(1, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this\u00f8.justifyContent = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($m_Lscommons_reactnative_ViewStyle$JustifyContent$().center__Lscommons_reactnative_ViewStyle$JustifyContent(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          $s_sr_Statics__releaseFence__V();
          return this\u00f8
        })
      })(Object, this)();
      this.horizontal = (function(superClass$, arg$outer) {
        return (function() {
          var outer = arg$outer;
          var this$2 = {};
          this$2.flexDirection = null;
          this$2.justifyContent = null;
          this$2.padding = null;
          this$2.flexDirection = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($m_Lscommons_reactnative_ViewStyle$FlexDirection$().row__Lscommons_reactnative_ViewStyle$FlexDirection(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this$2.justifyContent = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($m_Lscommons_reactnative_ViewStyle$JustifyContent$().space$minusaround__Lscommons_reactnative_ViewStyle$JustifyContent(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this$2.padding = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(10, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().right__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          $s_sr_Statics__releaseFence__V();
          return this$2
        })
      })(Object, this)()
    });
    /** @constructor */
    var $hh_Lshowcase_ActivityIndicatorDemo$Styles = (function() {
      /*<skip>*/
    });
    $hh_Lshowcase_ActivityIndicatorDemo$Styles.prototype = Object.prototype;
    $b_Lshowcase_ActivityIndicatorDemo$Styles.prototype = new $hh_Lshowcase_ActivityIndicatorDemo$Styles();
    $b_Lshowcase_ActivityIndicatorDemo$Styles.prototype.constructor = $b_Lshowcase_ActivityIndicatorDemo$Styles
  };
  return $b_Lshowcase_ActivityIndicatorDemo$Styles
}
function $p_Lshowcase_AlertDemo$__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz) {
  if (((((2 & $thiz.Lshowcase_AlertDemo$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lshowcase_AlertDemo$__f_scommons$react$UiComponent$$reactClass = $f_Lscommons_react_FunctionComponent__create__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz);
    $thiz.Lshowcase_AlertDemo$__f_bitmap$0 = (((2 | $thiz.Lshowcase_AlertDemo$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lshowcase_AlertDemo$__f_scommons$react$UiComponent$$reactClass
}
function $p_Lshowcase_AlertDemo$__styles$lzycompute__Lshowcase_AlertDemo$Styles($thiz) {
  if (((((1 & $thiz.Lshowcase_AlertDemo$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lshowcase_AlertDemo$__f_styles = $m_Lscommons_reactnative_StyleSheet$().create__sjs_js_Object__sjs_js_Object(new ($a_Lshowcase_AlertDemo$Styles())());
    $thiz.Lshowcase_AlertDemo$__f_bitmap$0 = (((1 | $thiz.Lshowcase_AlertDemo$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lshowcase_AlertDemo$__f_styles
}
/** @constructor */
function $c_Lshowcase_AlertDemo$() {
  this.Lshowcase_AlertDemo$__f_styles = null;
  this.Lshowcase_AlertDemo$__f_okHandler = null;
  this.Lshowcase_AlertDemo$__f_scommons$react$UiComponent$$reactClass = null;
  this.Lshowcase_AlertDemo$__f_bitmap$0 = 0;
  $n_Lshowcase_AlertDemo$ = this;
  this.Lshowcase_AlertDemo$__f_okHandler = new $c_sjsr_AnonFunction0((function(this$1) {
    return (function() {
      var this$3 = $m_s_Console$();
      var this$4 = this$3.out__Ljava_io_PrintStream();
      this$4.java$lang$JSConsoleBasedPrintStream$$printString__T__V("OK pressed\n")
    })
  })(this))
}
$c_Lshowcase_AlertDemo$.prototype = new $h_O();
$c_Lshowcase_AlertDemo$.prototype.constructor = $c_Lshowcase_AlertDemo$;
/** @constructor */
function $h_Lshowcase_AlertDemo$() {
  /*<skip>*/
}
$h_Lshowcase_AlertDemo$.prototype = $c_Lshowcase_AlertDemo$.prototype;
$c_Lshowcase_AlertDemo$.prototype.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass = (function() {
  return (((((2 & this.Lshowcase_AlertDemo$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lshowcase_AlertDemo$__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass(this) : this.Lshowcase_AlertDemo$__f_scommons$react$UiComponent$$reactClass)
});
$c_Lshowcase_AlertDemo$.prototype.render__Lio_github_shogowada_scalajs_reactjs_React$Props__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement = (function(props) {
  var okButton = new $c_Lscommons_reactnative_Alert$AlertButton("OK", this.Lshowcase_AlertDemo$__f_okHandler, $m_s_None$());
  var cancelButton = new $c_Lscommons_reactnative_Alert$AlertButton("Cancel", new $c_sjsr_AnonFunction0((function(this$2) {
    return (function() {
      var this$4 = $m_s_Console$();
      var this$5 = this$4.out__Ljava_io_PrintStream();
      this$5.java$lang$JSConsoleBasedPrintStream$$printString__T__V("Cancel pressed\n")
    })
  })(this)), new $c_s_Some($m_Lscommons_reactnative_Alert$AlertButtonStyle$().Lscommons_reactnative_Alert$AlertButtonStyle$__f_cancel));
  var elements = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x9 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements).View__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var attributes = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array = [new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__Lscommons_reactnative_Style__Lio_github_shogowada_statictags_Attribute(this.styles__Lshowcase_AlertDemo$Styles().container)];
  var $$x8 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var elements$1 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x7 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements$1).Button__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var this$12 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes().title__Lio_github_shogowada_statictags_StringAttributeSpec();
  var $$x6 = new $c_Lio_github_shogowada_statictags_Attribute(this$12.Lio_github_shogowada_statictags_StringAttributeSpec__f_name, "2-Button Alert", $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$());
  var attributes$1 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var this$15 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$1).color__Lio_github_shogowada_statictags_StringAttributeSpec();
  var $$x5 = new $c_Lio_github_shogowada_statictags_Attribute(this$15.Lio_github_shogowada_statictags_StringAttributeSpec__f_name, "#0000ff", $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$());
  var attributes$2 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array$1 = [$$x6, $$x5, new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$2).onPress__Lscommons_reactnative_Touchable$TouchableAttributes$OnPressEventAttribute().$colon$eq__sjs_js_Function0__Lio_github_shogowada_statictags_Attribute((function(cancelButton$1, okButton$1) {
    return (function() {
      $m_Lshowcase_AlertDemo$().showcase$AlertDemo$$$anonfun$render$2__Lscommons_reactnative_Alert$AlertButton__Lscommons_reactnative_Alert$AlertButton__V(cancelButton$1, okButton$1)
    })
  })(cancelButton, okButton))];
  var $$x4 = $$x7.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1), $m_sci_Nil$());
  var elements$2 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x3 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements$2).Button__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var this$22 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes().title__Lio_github_shogowada_statictags_StringAttributeSpec();
  var $$x2 = new $c_Lio_github_shogowada_statictags_Attribute(this$22.Lio_github_shogowada_statictags_StringAttributeSpec__f_name, "3-Button Alert", $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$());
  var attributes$3 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var this$25 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$3).color__Lio_github_shogowada_statictags_StringAttributeSpec();
  var $$x1 = new $c_Lio_github_shogowada_statictags_Attribute(this$25.Lio_github_shogowada_statictags_StringAttributeSpec__f_name, "#0000ff", $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$());
  var attributes$4 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array$2 = [$$x2, $$x1, new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$4).onPress__Lscommons_reactnative_Touchable$TouchableAttributes$OnPressEventAttribute().$colon$eq__sjs_js_Function0__Lio_github_shogowada_statictags_Attribute((function(cancelButton$1$1, okButton$1$1) {
    return (function() {
      $m_Lshowcase_AlertDemo$().showcase$AlertDemo$$$anonfun$render$4__Lscommons_reactnative_Alert$AlertButton__Lscommons_reactnative_Alert$AlertButton__V(cancelButton$1$1, okButton$1$1)
    })
  })(cancelButton, okButton))];
  var array$3 = [$$x4, $$x3.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2), $m_sci_Nil$())];
  return $$x9.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x8, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))
});
$c_Lshowcase_AlertDemo$.prototype.styles__Lshowcase_AlertDemo$Styles = (function() {
  return (((((1 & this.Lshowcase_AlertDemo$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lshowcase_AlertDemo$__styles$lzycompute__Lshowcase_AlertDemo$Styles(this) : this.Lshowcase_AlertDemo$__f_styles)
});
$c_Lshowcase_AlertDemo$.prototype.showcase$AlertDemo$$$anonfun$render$2__Lscommons_reactnative_Alert$AlertButton__Lscommons_reactnative_Alert$AlertButton__V = (function(cancelButton$1, okButton$1) {
  var $$x2 = $m_Lscommons_reactnative_Alert$();
  $m_s_package$();
  var array = [cancelButton$1, okButton$1];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var $$x1 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
  var this$5 = $m_Lscommons_reactnative_Alert$();
  $$x2.alert__T__T__sci_List__Lscommons_reactnative_raw_AlertOptions__V("Alert Title", "My Alert Msg", $$x1, $p_Lscommons_reactnative_Alert$__defaultOptions__Lscommons_reactnative_raw_AlertOptions(this$5))
});
$c_Lshowcase_AlertDemo$.prototype.showcase$AlertDemo$$$anonfun$render$4__Lscommons_reactnative_Alert$AlertButton__Lscommons_reactnative_Alert$AlertButton__V = (function(cancelButton$1, okButton$1) {
  var $$x2 = $m_Lscommons_reactnative_Alert$();
  $m_s_package$();
  var array = [new $c_Lscommons_reactnative_Alert$AlertButton("Ask me later", new $c_sjsr_AnonFunction0((function(this$1) {
    return (function() {
      var this$3 = $m_s_Console$();
      var this$4 = this$3.out__Ljava_io_PrintStream();
      this$4.java$lang$JSConsoleBasedPrintStream$$printString__T__V("Ask me later pressed\n")
    })
  })(this)), $m_s_None$()), cancelButton$1, okButton$1];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var $$x1 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
  var this$10 = $m_Lscommons_reactnative_Alert$();
  $$x2.alert__T__T__sci_List__Lscommons_reactnative_raw_AlertOptions__V("Alert Title", "", $$x1, $p_Lscommons_reactnative_Alert$__defaultOptions__Lscommons_reactnative_raw_AlertOptions(this$10))
});
var $d_Lshowcase_AlertDemo$ = new $TypeData().initClass({
  Lshowcase_AlertDemo$: 0
}, false, "showcase.AlertDemo$", {
  Lshowcase_AlertDemo$: 1,
  O: 1,
  Lscommons_react_FunctionComponent: 1,
  Lscommons_react_UiComponent: 1
});
$c_Lshowcase_AlertDemo$.prototype.$classData = $d_Lshowcase_AlertDemo$;
var $n_Lshowcase_AlertDemo$;
function $m_Lshowcase_AlertDemo$() {
  if ((!$n_Lshowcase_AlertDemo$)) {
    $n_Lshowcase_AlertDemo$ = new $c_Lshowcase_AlertDemo$()
  };
  return $n_Lshowcase_AlertDemo$
}
var $b_Lshowcase_AlertDemo$Styles;
function $a_Lshowcase_AlertDemo$Styles() {
  if ((!$b_Lshowcase_AlertDemo$Styles)) {
    /** @constructor */
    $b_Lshowcase_AlertDemo$Styles = (function() {
      Object.call(this);
      Object.defineProperty(this, "container", {
        "configurable": true,
        "enumerable": true,
        "writable": true,
        "value": null
      });
      this.container = (function(superClass$, arg$outer) {
        return (function() {
          var outer = arg$outer;
          var this\u00f8 = {};
          this\u00f8.marginTop = null;
          this\u00f8.marginTop = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(22, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().right__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          $s_sr_Statics__releaseFence__V();
          return this\u00f8
        })
      })(Object, this)()
    });
    /** @constructor */
    var $hh_Lshowcase_AlertDemo$Styles = (function() {
      /*<skip>*/
    });
    $hh_Lshowcase_AlertDemo$Styles.prototype = Object.prototype;
    $b_Lshowcase_AlertDemo$Styles.prototype = new $hh_Lshowcase_AlertDemo$Styles();
    $b_Lshowcase_AlertDemo$Styles.prototype.constructor = $b_Lshowcase_AlertDemo$Styles
  };
  return $b_Lshowcase_AlertDemo$Styles
}
function $p_Lshowcase_ButtonDemo$__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz) {
  if (((((2 & $thiz.Lshowcase_ButtonDemo$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lshowcase_ButtonDemo$__f_scommons$react$UiComponent$$reactClass = $f_Lscommons_react_FunctionComponent__create__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz);
    $thiz.Lshowcase_ButtonDemo$__f_bitmap$0 = (((2 | $thiz.Lshowcase_ButtonDemo$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lshowcase_ButtonDemo$__f_scommons$react$UiComponent$$reactClass
}
function $p_Lshowcase_ButtonDemo$__styles$lzycompute__Lshowcase_ButtonDemo$Styles($thiz) {
  if (((((1 & $thiz.Lshowcase_ButtonDemo$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lshowcase_ButtonDemo$__f_styles = $m_Lscommons_reactnative_StyleSheet$().create__sjs_js_Object__sjs_js_Object(new ($a_Lshowcase_ButtonDemo$Styles())());
    $thiz.Lshowcase_ButtonDemo$__f_bitmap$0 = (((1 | $thiz.Lshowcase_ButtonDemo$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lshowcase_ButtonDemo$__f_styles
}
/** @constructor */
function $c_Lshowcase_ButtonDemo$() {
  this.Lshowcase_ButtonDemo$__f_styles = null;
  this.Lshowcase_ButtonDemo$__f_scommons$react$UiComponent$$reactClass = null;
  this.Lshowcase_ButtonDemo$__f_bitmap$0 = 0
}
$c_Lshowcase_ButtonDemo$.prototype = new $h_O();
$c_Lshowcase_ButtonDemo$.prototype.constructor = $c_Lshowcase_ButtonDemo$;
/** @constructor */
function $h_Lshowcase_ButtonDemo$() {
  /*<skip>*/
}
$h_Lshowcase_ButtonDemo$.prototype = $c_Lshowcase_ButtonDemo$.prototype;
$c_Lshowcase_ButtonDemo$.prototype.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass = (function() {
  return (((((2 & this.Lshowcase_ButtonDemo$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lshowcase_ButtonDemo$__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass(this) : this.Lshowcase_ButtonDemo$__f_scommons$react$UiComponent$$reactClass)
});
$c_Lshowcase_ButtonDemo$.prototype.render__Lio_github_shogowada_scalajs_reactjs_React$Props__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement = (function(props) {
  var elements = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x9 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements).View__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var attributes = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array = [new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__sjs_js_Array__Lio_github_shogowada_statictags_Attribute([this.styles__Lshowcase_ButtonDemo$Styles().container, this.styles__Lshowcase_ButtonDemo$Styles().horizontal])];
  var $$x8 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var elements$1 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x7 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements$1).Button__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var this$7 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes().title__Lio_github_shogowada_statictags_StringAttributeSpec();
  var $$x6 = new $c_Lio_github_shogowada_statictags_Attribute(this$7.Lio_github_shogowada_statictags_StringAttributeSpec__f_name, "Press me", $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$());
  var attributes$1 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var this$10 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$1).color__Lio_github_shogowada_statictags_StringAttributeSpec();
  var $$x5 = new $c_Lio_github_shogowada_statictags_Attribute(this$10.Lio_github_shogowada_statictags_StringAttributeSpec__f_name, "#0000ff", $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$());
  var attributes$2 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array$1 = [$$x6, $$x5, new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$2).onPress__Lscommons_reactnative_Touchable$TouchableAttributes$OnPressEventAttribute().$colon$eq__sjs_js_Function0__Lio_github_shogowada_statictags_Attribute((function() {
    return (void 0)
  }))];
  var $$x4 = $$x7.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1), $m_sci_Nil$());
  var elements$2 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x3 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements$2).Button__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var this$17 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes().title__Lio_github_shogowada_statictags_StringAttributeSpec();
  var $$x2 = new $c_Lio_github_shogowada_statictags_Attribute(this$17.Lio_github_shogowada_statictags_StringAttributeSpec__f_name, "Press me", $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$());
  var attributes$3 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var this$20 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$3).color__Lio_github_shogowada_statictags_StringAttributeSpec();
  var $$x1 = new $c_Lio_github_shogowada_statictags_Attribute(this$20.Lio_github_shogowada_statictags_StringAttributeSpec__f_name, "#00ff00", $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$());
  var attributes$4 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array$2 = [$$x2, $$x1, new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$4).onPress__Lscommons_reactnative_Touchable$TouchableAttributes$OnPressEventAttribute().$colon$eq__sjs_js_Function0__Lio_github_shogowada_statictags_Attribute((function() {
    return (void 0)
  }))];
  var array$3 = [$$x4, $$x3.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2), $m_sci_Nil$())];
  return $$x9.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x8, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))
});
$c_Lshowcase_ButtonDemo$.prototype.styles__Lshowcase_ButtonDemo$Styles = (function() {
  return (((((1 & this.Lshowcase_ButtonDemo$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lshowcase_ButtonDemo$__styles$lzycompute__Lshowcase_ButtonDemo$Styles(this) : this.Lshowcase_ButtonDemo$__f_styles)
});
var $d_Lshowcase_ButtonDemo$ = new $TypeData().initClass({
  Lshowcase_ButtonDemo$: 0
}, false, "showcase.ButtonDemo$", {
  Lshowcase_ButtonDemo$: 1,
  O: 1,
  Lscommons_react_FunctionComponent: 1,
  Lscommons_react_UiComponent: 1
});
$c_Lshowcase_ButtonDemo$.prototype.$classData = $d_Lshowcase_ButtonDemo$;
var $n_Lshowcase_ButtonDemo$;
function $m_Lshowcase_ButtonDemo$() {
  if ((!$n_Lshowcase_ButtonDemo$)) {
    $n_Lshowcase_ButtonDemo$ = new $c_Lshowcase_ButtonDemo$()
  };
  return $n_Lshowcase_ButtonDemo$
}
var $b_Lshowcase_ButtonDemo$Styles;
function $a_Lshowcase_ButtonDemo$Styles() {
  if ((!$b_Lshowcase_ButtonDemo$Styles)) {
    /** @constructor */
    $b_Lshowcase_ButtonDemo$Styles = (function() {
      Object.call(this);
      Object.defineProperty(this, "container", {
        "configurable": true,
        "enumerable": true,
        "writable": true,
        "value": null
      });
      Object.defineProperty(this, "horizontal", {
        "configurable": true,
        "enumerable": true,
        "writable": true,
        "value": null
      });
      this.container = (function(superClass$, arg$outer) {
        return (function() {
          var outer = arg$outer;
          var this\u00f8 = {};
          this\u00f8.flex = null;
          this\u00f8.justifyContent = null;
          this\u00f8.flex = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(1, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this\u00f8.justifyContent = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($m_Lscommons_reactnative_ViewStyle$JustifyContent$().center__Lscommons_reactnative_ViewStyle$JustifyContent(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          $s_sr_Statics__releaseFence__V();
          return this\u00f8
        })
      })(Object, this)();
      this.horizontal = (function(superClass$, arg$outer) {
        return (function() {
          var outer = arg$outer;
          var this$2 = {};
          this$2.flexDirection = null;
          this$2.justifyContent = null;
          this$2.padding = null;
          this$2.flexDirection = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($m_Lscommons_reactnative_ViewStyle$FlexDirection$().row__Lscommons_reactnative_ViewStyle$FlexDirection(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this$2.justifyContent = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($m_Lscommons_reactnative_ViewStyle$JustifyContent$().space$minusaround__Lscommons_reactnative_ViewStyle$JustifyContent(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this$2.padding = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(10, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().right__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          $s_sr_Statics__releaseFence__V();
          return this$2
        })
      })(Object, this)()
    });
    /** @constructor */
    var $hh_Lshowcase_ButtonDemo$Styles = (function() {
      /*<skip>*/
    });
    $hh_Lshowcase_ButtonDemo$Styles.prototype = Object.prototype;
    $b_Lshowcase_ButtonDemo$Styles.prototype = new $hh_Lshowcase_ButtonDemo$Styles();
    $b_Lshowcase_ButtonDemo$Styles.prototype.constructor = $b_Lshowcase_ButtonDemo$Styles
  };
  return $b_Lshowcase_ButtonDemo$Styles
}
function $p_Lshowcase_FlatListDemo$__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz) {
  if (((((4 & $thiz.Lshowcase_FlatListDemo$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lshowcase_FlatListDemo$__f_scommons$react$UiComponent$$reactClass = $f_Lscommons_react_FunctionComponent__create__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz);
    $thiz.Lshowcase_FlatListDemo$__f_bitmap$0 = (((4 | $thiz.Lshowcase_FlatListDemo$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lshowcase_FlatListDemo$__f_scommons$react$UiComponent$$reactClass
}
function $p_Lshowcase_FlatListDemo$__dataList$lzycompute__sci_List($thiz) {
  if (((((1 & $thiz.Lshowcase_FlatListDemo$__f_bitmap$0) << 24) >> 24) === 0)) {
    $m_s_package$();
    var array = [new $c_Lshowcase_FlatListDemo$Data("bd7acbea-c1b1-46c2-aed5-3ad53abb28ba", "First Item"), new $c_Lshowcase_FlatListDemo$Data("3ac68afc-c605-48d3-a4f8-fbd91aa97f63", "Second Item"), new $c_Lshowcase_FlatListDemo$Data("58694a0f-3da1-471f-bd96-145571e29d72", "Third Item")];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    $thiz.Lshowcase_FlatListDemo$__f_dataList = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
    $thiz.Lshowcase_FlatListDemo$__f_bitmap$0 = (((1 | $thiz.Lshowcase_FlatListDemo$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lshowcase_FlatListDemo$__f_dataList
}
function $p_Lshowcase_FlatListDemo$__styles$lzycompute__Lshowcase_FlatListDemo$Styles($thiz) {
  if (((((2 & $thiz.Lshowcase_FlatListDemo$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lshowcase_FlatListDemo$__f_styles = $m_Lscommons_reactnative_StyleSheet$().create__sjs_js_Object__sjs_js_Object(new ($a_Lshowcase_FlatListDemo$Styles())());
    $thiz.Lshowcase_FlatListDemo$__f_bitmap$0 = (((2 | $thiz.Lshowcase_FlatListDemo$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lshowcase_FlatListDemo$__f_styles
}
function $p_Lshowcase_FlatListDemo$__onInvertSelection$1__T__sci_Set__sjs_js_Function1__V($thiz, id, selected$1, setSelected$1) {
  if (selected$1.contains__O__Z(id)) {
    setSelected$1(selected$1.excl__O__sci_SetOps(id))
  } else {
    setSelected$1(selected$1.incl__O__sci_SetOps(id))
  }
}
/** @constructor */
function $c_Lshowcase_FlatListDemo$() {
  this.Lshowcase_FlatListDemo$__f_dataList = null;
  this.Lshowcase_FlatListDemo$__f_styles = null;
  this.Lshowcase_FlatListDemo$__f_scommons$react$UiComponent$$reactClass = null;
  this.Lshowcase_FlatListDemo$__f_bitmap$0 = 0
}
$c_Lshowcase_FlatListDemo$.prototype = new $h_O();
$c_Lshowcase_FlatListDemo$.prototype.constructor = $c_Lshowcase_FlatListDemo$;
/** @constructor */
function $h_Lshowcase_FlatListDemo$() {
  /*<skip>*/
}
$h_Lshowcase_FlatListDemo$.prototype = $c_Lshowcase_FlatListDemo$.prototype;
$c_Lshowcase_FlatListDemo$.prototype.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass = (function() {
  return (((((4 & this.Lshowcase_FlatListDemo$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lshowcase_FlatListDemo$__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass(this) : this.Lshowcase_FlatListDemo$__f_scommons$react$UiComponent$$reactClass)
});
$c_Lshowcase_FlatListDemo$.prototype.dataList__sci_List = (function() {
  return (((((1 & this.Lshowcase_FlatListDemo$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lshowcase_FlatListDemo$__dataList$lzycompute__sci_List(this) : this.Lshowcase_FlatListDemo$__f_dataList)
});
$c_Lshowcase_FlatListDemo$.prototype.render__Lio_github_shogowada_scalajs_reactjs_React$Props__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement = (function(props) {
  var this$1 = $m_Lscommons_react_hooks_package$();
  var x1 = $f_Lscommons_react_hooks_UseState__useState__O__T2(this$1, false);
  if ((x1 === null)) {
    throw new $c_s_MatchError(x1)
  };
  var refreshing = $uZ(x1._1__O());
  var setRefreshing = x1._2__O();
  var this$3 = $m_Lscommons_react_hooks_package$();
  var initialState = $m_sci_Set$EmptySet$();
  var x1$2 = $f_Lscommons_react_hooks_UseState__useState__O__T2(this$3, initialState);
  if ((x1$2 === null)) {
    throw new $c_s_MatchError(x1$2)
  };
  var selected = $as_sci_Set(x1$2._1__O());
  var setSelected = x1$2._2__O();
  var this$10 = $m_Lscommons_react_hooks_package$();
  var calculate = new $c_sjsr_AnonFunction0((function(this$4, setRefreshing$2) {
    return (function() {
      return (function(setRefreshing$1) {
        return (function() {
          $m_Lshowcase_FlatListDemo$().showcase$FlatListDemo$$$anonfun$render$2__sjs_js_Function1__V(setRefreshing$1)
        })
      })(setRefreshing$2)
    })
  })(this, setRefreshing));
  $m_s_package$();
  var array = [refreshing];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var dependencies = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
  var onRefresh = $f_Lscommons_react_hooks_UseMemo__useMemo__F0__sci_List__O(this$10, calculate, dependencies);
  var elements = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x10 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements).View__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var attributes = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array$1 = [new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__Lscommons_reactnative_Style__Lio_github_shogowada_statictags_Attribute(this.styles__Lshowcase_FlatListDemo$Styles().container)];
  var $$x9 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  var elements$1 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x8 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements$1).FlatList__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var attributes$1 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var this$18 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$1).refreshing__Lio_github_shogowada_statictags_BooleanAttributeSpec();
  var $$x7 = new $c_Lio_github_shogowada_statictags_Attribute(this$18.Lio_github_shogowada_statictags_BooleanAttributeSpec__f_name, refreshing, $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$());
  var attributes$2 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var $$x6 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$2).onRefresh__Lscommons_reactnative_FlatList$FlatListAttributes$OnRefreshAttributeSpec().$colon$eq__sjs_js_Function0__Lio_github_shogowada_statictags_Attribute(onRefresh);
  var attributes$3 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var $$x5 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$3).flatListData__Lscommons_reactnative_FlatList$FlatListAttributes$DataAttributeSpec();
  var seq = this.dataList__sci_List();
  var $$x4 = $m_sjsr_Compat$().toJSVarArgsImpl__sci_Seq__sjs_js_Array(seq);
  var $$x3 = $$x5.$colon$eq__sjs_js_Array__Lio_github_shogowada_statictags_Attribute($$x4);
  var attributes$4 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var $$x2 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$4).renderItem__Lscommons_reactnative_FlatList$FlatListAttributes$RenderItemAttributeSpec().$colon$eq__sjs_js_Function1__Lio_github_shogowada_statictags_Attribute((function(selected$1, setSelected$1) {
    return (function(arg1$2) {
      return $m_Lshowcase_FlatListDemo$().showcase$FlatListDemo$$$anonfun$render$4__Lscommons_reactnative_FlatList$FlatListData__sci_Set__sjs_js_Function1__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement(arg1$2, selected$1, setSelected$1)
    })
  })(selected, setSelected));
  var attributes$5 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var $$x1 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$5).keyExtractor__Lscommons_reactnative_FlatList$FlatListAttributes$KeyExtractorAttributeSpec().$colon$eq__sjs_js_Function1__Lio_github_shogowada_statictags_Attribute((function(arg1$2$1) {
    var arg1 = $as_Lshowcase_FlatListDemo$Data(arg1$2$1);
    return arg1.Lshowcase_FlatListDemo$Data__f_id
  }));
  var attributes$6 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array$2 = [$$x7, $$x6, $$x3, $$x2, $$x1, new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$6).extraData__Lscommons_reactnative_FlatList$FlatListAttributes$ExtraDataAttributeSpec().$colon$eq__O__Lio_github_shogowada_statictags_Attribute(selected)];
  var array$3 = [$$x8.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2), $m_sci_Nil$())];
  return $$x10.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x9, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))
});
$c_Lshowcase_FlatListDemo$.prototype.styles__Lshowcase_FlatListDemo$Styles = (function() {
  return (((((2 & this.Lshowcase_FlatListDemo$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lshowcase_FlatListDemo$__styles$lzycompute__Lshowcase_FlatListDemo$Styles(this) : this.Lshowcase_FlatListDemo$__f_styles)
});
$c_Lshowcase_FlatListDemo$.prototype.showcase$FlatListDemo$$$anonfun$render$3__sr_ObjectRef__sjs_js_Function1__O = (function(handleId$1, setRefreshing$1) {
  clearTimeout(handleId$1.sr_ObjectRef__f_elem);
  return setRefreshing$1(false)
});
$c_Lshowcase_FlatListDemo$.prototype.showcase$FlatListDemo$$$anonfun$render$2__sjs_js_Function1__V = (function(setRefreshing$1) {
  setRefreshing$1(true);
  var handleId = new $c_sr_ObjectRef(null);
  var $$x2 = setTimeout;
  var this$3 = new $c_s_concurrent_duration_package$DurationInt(2);
  var unit = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_SECONDS;
  var this$ = this$3.s_concurrent_duration_package$DurationInt__f_scala$concurrent$duration$DurationInt$$n;
  $m_s_concurrent_duration_Duration$();
  var hi = (this$ >> 31);
  var this$7 = new $c_s_concurrent_duration_FiniteDuration(new $c_RTLong(this$, hi), unit);
  var this$8 = this$7.s_concurrent_duration_FiniteDuration__f_unit.toMillis__J__J(this$7.s_concurrent_duration_FiniteDuration__f_length);
  var $$x1 = $$x2((function(handleId$1, setRefreshing$1$1) {
    return (function() {
      return $m_Lshowcase_FlatListDemo$().showcase$FlatListDemo$$$anonfun$render$3__sr_ObjectRef__sjs_js_Function1__O(handleId$1, setRefreshing$1$1)
    })
  })(handleId, setRefreshing$1), $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toDouble__I__I__D(this$8.RTLong__f_lo, this$8.RTLong__f_hi));
  handleId.sr_ObjectRef__f_elem = $$x1
});
$c_Lshowcase_FlatListDemo$.prototype.showcase$FlatListDemo$$$anonfun$render$4__Lscommons_reactnative_FlatList$FlatListData__sci_Set__sjs_js_Function1__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement = (function(data, selected$1, setSelected$1) {
  var item = $as_Lshowcase_FlatListDemo$Data(data.item);
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var this$1 = $m_Lshowcase_FlatListDemo$Item$();
  var reactClass = this$1.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass();
  var $$x1 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass);
  var array = [$m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes().wrapped__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$WrappedPropsAttributeSpec().$colon$eq__O__Lio_github_shogowada_statictags_Attribute(new $c_Lshowcase_FlatListDemo$ItemProps(item.Lshowcase_FlatListDemo$Data__f_title, selected$1.contains__O__Z(item.Lshowcase_FlatListDemo$Data__f_id), new $c_sjsr_AnonFunction0((function(this$3, item$1, selected$1$1, setSelected$1$1) {
    return (function() {
      $p_Lshowcase_FlatListDemo$__onInvertSelection$1__T__sci_Set__sjs_js_Function1__V(this$3, item$1.Lshowcase_FlatListDemo$Data__f_id, selected$1$1, setSelected$1$1)
    })
  })(this, item, selected$1, setSelected$1))))];
  return $$x1.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array), $m_sci_Nil$())
});
var $d_Lshowcase_FlatListDemo$ = new $TypeData().initClass({
  Lshowcase_FlatListDemo$: 0
}, false, "showcase.FlatListDemo$", {
  Lshowcase_FlatListDemo$: 1,
  O: 1,
  Lscommons_react_FunctionComponent: 1,
  Lscommons_react_UiComponent: 1
});
$c_Lshowcase_FlatListDemo$.prototype.$classData = $d_Lshowcase_FlatListDemo$;
var $n_Lshowcase_FlatListDemo$;
function $m_Lshowcase_FlatListDemo$() {
  if ((!$n_Lshowcase_FlatListDemo$)) {
    $n_Lshowcase_FlatListDemo$ = new $c_Lshowcase_FlatListDemo$()
  };
  return $n_Lshowcase_FlatListDemo$
}
function $p_Lshowcase_FlatListDemo$Item$__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz) {
  if ((!$thiz.Lshowcase_FlatListDemo$Item$__f_bitmap$0)) {
    $thiz.Lshowcase_FlatListDemo$Item$__f_scommons$react$UiComponent$$reactClass = $f_Lscommons_react_FunctionComponent__create__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz);
    $thiz.Lshowcase_FlatListDemo$Item$__f_bitmap$0 = true
  };
  return $thiz.Lshowcase_FlatListDemo$Item$__f_scommons$react$UiComponent$$reactClass
}
/** @constructor */
function $c_Lshowcase_FlatListDemo$Item$() {
  this.Lshowcase_FlatListDemo$Item$__f_scommons$react$UiComponent$$reactClass = null;
  this.Lshowcase_FlatListDemo$Item$__f_bitmap$0 = false
}
$c_Lshowcase_FlatListDemo$Item$.prototype = new $h_O();
$c_Lshowcase_FlatListDemo$Item$.prototype.constructor = $c_Lshowcase_FlatListDemo$Item$;
/** @constructor */
function $h_Lshowcase_FlatListDemo$Item$() {
  /*<skip>*/
}
$h_Lshowcase_FlatListDemo$Item$.prototype = $c_Lshowcase_FlatListDemo$Item$.prototype;
$c_Lshowcase_FlatListDemo$Item$.prototype.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass = (function() {
  return ((!this.Lshowcase_FlatListDemo$Item$__f_bitmap$0) ? $p_Lshowcase_FlatListDemo$Item$__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass(this) : this.Lshowcase_FlatListDemo$Item$__f_scommons$react$UiComponent$$reactClass)
});
$c_Lshowcase_FlatListDemo$Item$.prototype.render__Lio_github_shogowada_scalajs_reactjs_React$Props__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement = (function(compProps) {
  var props = $as_Lshowcase_FlatListDemo$ItemProps(compProps.wrapped__O());
  if (props.Lshowcase_FlatListDemo$ItemProps__f_selected) {
    var attributes = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
    var styleAttr = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__sjs_js_Array__Lio_github_shogowada_statictags_Attribute([$m_Lshowcase_FlatListDemo$().styles__Lshowcase_FlatListDemo$Styles().item, $m_Lshowcase_FlatListDemo$().styles__Lshowcase_FlatListDemo$Styles().selectedItem])
  } else {
    var attributes$1 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
    var styleAttr = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$1).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__Lscommons_reactnative_Style__Lio_github_shogowada_statictags_Attribute($m_Lshowcase_FlatListDemo$().styles__Lshowcase_FlatListDemo$Styles().item)
  };
  var elements = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x4 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements).TouchableOpacity__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var attributes$2 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array = [styleAttr, new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$2).onPress__Lscommons_reactnative_Touchable$TouchableAttributes$OnPressEventAttribute().$colon$eq__sjs_js_Function0__Lio_github_shogowada_statictags_Attribute($m_sjs_js_Any$().fromFunction0__F0__sjs_js_Function0(props.Lshowcase_FlatListDemo$ItemProps__f_onPress))];
  var $$x3 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var elements$1 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x2 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements$1).Text__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var attributes$3 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array$1 = [new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$3).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__Lscommons_reactnative_Style__Lio_github_shogowada_statictags_Attribute($m_Lshowcase_FlatListDemo$().styles__Lshowcase_FlatListDemo$Styles().title)];
  var $$x1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  var array$2 = [props.Lshowcase_FlatListDemo$ItemProps__f_title];
  var array$3 = [$$x2.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x1, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))];
  return $$x4.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x3, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))
});
var $d_Lshowcase_FlatListDemo$Item$ = new $TypeData().initClass({
  Lshowcase_FlatListDemo$Item$: 0
}, false, "showcase.FlatListDemo$Item$", {
  Lshowcase_FlatListDemo$Item$: 1,
  O: 1,
  Lscommons_react_FunctionComponent: 1,
  Lscommons_react_UiComponent: 1
});
$c_Lshowcase_FlatListDemo$Item$.prototype.$classData = $d_Lshowcase_FlatListDemo$Item$;
var $n_Lshowcase_FlatListDemo$Item$;
function $m_Lshowcase_FlatListDemo$Item$() {
  if ((!$n_Lshowcase_FlatListDemo$Item$)) {
    $n_Lshowcase_FlatListDemo$Item$ = new $c_Lshowcase_FlatListDemo$Item$()
  };
  return $n_Lshowcase_FlatListDemo$Item$
}
var $b_Lshowcase_FlatListDemo$Styles;
function $a_Lshowcase_FlatListDemo$Styles() {
  if ((!$b_Lshowcase_FlatListDemo$Styles)) {
    /** @constructor */
    $b_Lshowcase_FlatListDemo$Styles = (function() {
      Object.call(this);
      Object.defineProperty(this, "container", {
        "configurable": true,
        "enumerable": true,
        "writable": true,
        "value": null
      });
      Object.defineProperty(this, "item", {
        "configurable": true,
        "enumerable": true,
        "writable": true,
        "value": null
      });
      Object.defineProperty(this, "selectedItem", {
        "configurable": true,
        "enumerable": true,
        "writable": true,
        "value": null
      });
      Object.defineProperty(this, "title", {
        "configurable": true,
        "enumerable": true,
        "writable": true,
        "value": null
      });
      this.container = (function(superClass$, arg$outer) {
        return (function() {
          var outer = arg$outer;
          var this\u00f8 = {};
          this\u00f8.flex = null;
          this\u00f8.marginTop = null;
          this\u00f8.flex = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(1, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this\u00f8.marginTop = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(20, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().right__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          $s_sr_Statics__releaseFence__V();
          return this\u00f8
        })
      })(Object, this)();
      this.item = (function(superClass$, arg$outer) {
        return (function() {
          var outer = arg$outer;
          var this$2 = {};
          this$2.backgroundColor = null;
          this$2.padding = null;
          this$2.marginVertical = null;
          this$2.marginHorizontal = null;
          this$2.backgroundColor = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar("#f9c2ff", $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this$2.padding = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(20, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().right__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          this$2.marginVertical = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(8, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().right__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          this$2.marginHorizontal = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(16, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().right__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          $s_sr_Statics__releaseFence__V();
          return this$2
        })
      })(Object, this)();
      this.selectedItem = (function(superClass$, arg$outer) {
        return (function() {
          var outer = arg$outer;
          var this$3 = {};
          this$3.backgroundColor = null;
          this$3.backgroundColor = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar("#6e3b6e", $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          $s_sr_Statics__releaseFence__V();
          return this$3
        })
      })(Object, this)();
      this.title = (function(superClass$, arg$outer) {
        return (function() {
          var outer = arg$outer;
          var this$4 = {};
          this$4.fontSize = null;
          this$4.fontSize = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(32, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          $s_sr_Statics__releaseFence__V();
          return this$4
        })
      })(Object, this)()
    });
    /** @constructor */
    var $hh_Lshowcase_FlatListDemo$Styles = (function() {
      /*<skip>*/
    });
    $hh_Lshowcase_FlatListDemo$Styles.prototype = Object.prototype;
    $b_Lshowcase_FlatListDemo$Styles.prototype = new $hh_Lshowcase_FlatListDemo$Styles();
    $b_Lshowcase_FlatListDemo$Styles.prototype.constructor = $b_Lshowcase_FlatListDemo$Styles
  };
  return $b_Lshowcase_FlatListDemo$Styles
}
function $p_Lshowcase_ImageDemo$__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz) {
  if (((((2 & $thiz.Lshowcase_ImageDemo$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lshowcase_ImageDemo$__f_scommons$react$UiComponent$$reactClass = $f_Lscommons_react_FunctionComponent__create__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz);
    $thiz.Lshowcase_ImageDemo$__f_bitmap$0 = (((2 | $thiz.Lshowcase_ImageDemo$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lshowcase_ImageDemo$__f_scommons$react$UiComponent$$reactClass
}
function $p_Lshowcase_ImageDemo$__styles$lzycompute__Lshowcase_ImageDemo$Styles($thiz) {
  if (((((1 & $thiz.Lshowcase_ImageDemo$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lshowcase_ImageDemo$__f_styles = $m_Lscommons_reactnative_StyleSheet$().create__sjs_js_Object__sjs_js_Object(new ($a_Lshowcase_ImageDemo$Styles())());
    $thiz.Lshowcase_ImageDemo$__f_bitmap$0 = (((1 | $thiz.Lshowcase_ImageDemo$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lshowcase_ImageDemo$__f_styles
}
/** @constructor */
function $c_Lshowcase_ImageDemo$() {
  this.Lshowcase_ImageDemo$__f_styles = null;
  this.Lshowcase_ImageDemo$__f_scommons$react$UiComponent$$reactClass = null;
  this.Lshowcase_ImageDemo$__f_bitmap$0 = 0
}
$c_Lshowcase_ImageDemo$.prototype = new $h_O();
$c_Lshowcase_ImageDemo$.prototype.constructor = $c_Lshowcase_ImageDemo$;
/** @constructor */
function $h_Lshowcase_ImageDemo$() {
  /*<skip>*/
}
$h_Lshowcase_ImageDemo$.prototype = $c_Lshowcase_ImageDemo$.prototype;
$c_Lshowcase_ImageDemo$.prototype.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass = (function() {
  return (((((2 & this.Lshowcase_ImageDemo$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lshowcase_ImageDemo$__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass(this) : this.Lshowcase_ImageDemo$__f_scommons$react$UiComponent$$reactClass)
});
$c_Lshowcase_ImageDemo$.prototype.render__Lio_github_shogowada_scalajs_reactjs_React$Props__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement = (function(compProps) {
  var this$1 = $m_Lscommons_react_hooks_package$();
  var x1 = $f_Lscommons_react_hooks_UseState__useState__O__T2(this$1, false);
  if ((x1 === null)) {
    throw new $c_s_MatchError(x1)
  };
  var imagesReady = $uZ(x1._1__O());
  var setImagesReady = x1._2__O();
  var this$12 = $m_Lscommons_react_hooks_package$();
  var didUpdate = new $c_sjsr_AnonFunction0((function(this$2, networkImageUrl, setImagesReady$2) {
    return (function() {
      var $$x2 = $m_s_concurrent_Future$();
      $m_s_package$();
      var array = [$m_Lscommons_expo_Asset$().loadAsync__Lscommons_reactnative_raw_StaticResource__s_concurrent_Future($i_$002e$002fshowcase$002fapp$002fexpo$002epng), $m_Lscommons_reactnative_Image$().prefetch__T__s_concurrent_Future(networkImageUrl)];
      var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
      var $$x1 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
      var this$7 = $m_sc_BuildFrom$();
      $$x2.sequence__sc_IterableOnce__sc_BuildFrom__s_concurrent_ExecutionContext__s_concurrent_Future($$x1, new $c_sc_BuildFromLowPriority2$$anon$11(this$7), $m_s_concurrent_ExecutionContext$().global__s_concurrent_ExecutionContextExecutor()).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1((function(this$9, setImagesReady$1) {
        return (function(x$2$2) {
          $as_sci_List(x$2$2);
          setImagesReady$1(true)
        })
      })(this$2, setImagesReady$2)), $m_s_concurrent_ExecutionContext$().global__s_concurrent_ExecutionContextExecutor())
    })
  })(this, "https://reactjs.org/logo-og.png", setImagesReady));
  var dependencies = $m_s_package$().s_package$__f_Nil;
  $f_Lscommons_react_hooks_UseEffect__useEffect__F0__sci_List__V(this$12, didUpdate, dependencies);
  var elements = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x12 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements).View__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var attributes = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array$1 = [new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__Lscommons_reactnative_Style__Lio_github_shogowada_statictags_Attribute(this.styles__Lshowcase_ImageDemo$Styles().container)];
  var $$x11 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  if (imagesReady) {
    var elements$1 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
    var $$x10 = new $c_Lscommons_react_package$ReactVirtualDOMElements(elements$1).$greater__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
    var $$x9 = $m_sci_Nil$();
    var elements$2 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
    var $$x8 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements$2).Image__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
    var attributes$1 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
    var $$x7 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$1).source__Lscommons_reactnative_Image$ImageAttributes$ImageSourceAttributeSpec().$colon$eq__Lscommons_reactnative_raw_StaticResource__Lio_github_shogowada_statictags_Attribute($i_$002e$002fshowcase$002fapp$002fexpo$002epng);
    var attributes$2 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
    var array$2 = [$$x7, new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$2).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__Lscommons_reactnative_Style__Lio_github_shogowada_statictags_Attribute((function(superClass$) {
      return (function() {
        var this$2$1 = {};
        this$2$1.width = null;
        this$2$1.height = null;
        var a = $m_Lshowcase_app_ShowcaseImages$Expo$().Lshowcase_app_ShowcaseImages$Expo$__f_asset.width;
        this$2$1.width = a;
        var a$1 = $m_Lshowcase_app_ShowcaseImages$Expo$().Lshowcase_app_ShowcaseImages$Expo$__f_asset.height;
        this$2$1.height = a$1;
        return this$2$1
      })
    })(Object)())];
    var $$x6 = $$x8.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2), $m_sci_Nil$());
    var elements$3 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
    var $$x5 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements$3).Image__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
    var attributes$3 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
    var $$x4 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$3).source__Lscommons_reactnative_Image$ImageAttributes$ImageSourceAttributeSpec().$colon$eq__Lscommons_reactnative_raw_UriResource__Lio_github_shogowada_statictags_Attribute((function(superClass$$1, networkImageUrl$1$2) {
      return (function() {
        var this$3$1 = {};
        this$3$1.uri = null;
        this$3$1.uri = networkImageUrl$1$2;
        return this$3$1
      })
    })(Object, "https://reactjs.org/logo-og.png")());
    var attributes$4 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
    var array$3 = [$$x4, new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$4).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__Lscommons_reactnative_Style__Lio_github_shogowada_statictags_Attribute((function(superClass$$2) {
      return (function() {
        var this$4$1 = {};
        this$4$1.width = null;
        this$4$1.height = null;
        this$4$1.width = 400;
        this$4$1.height = 400;
        return this$4$1
      })
    })(Object)())];
    var array$4 = [$$x6, $$x5.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3), $m_sci_Nil$())];
    var $$x3 = new $c_s_Some($$x10.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x9, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4)))
  } else {
    var $$x3 = $m_s_None$()
  };
  var array$5 = [$$x3];
  return $$x12.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x11, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5))
});
$c_Lshowcase_ImageDemo$.prototype.styles__Lshowcase_ImageDemo$Styles = (function() {
  return (((((1 & this.Lshowcase_ImageDemo$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lshowcase_ImageDemo$__styles$lzycompute__Lshowcase_ImageDemo$Styles(this) : this.Lshowcase_ImageDemo$__f_styles)
});
var $d_Lshowcase_ImageDemo$ = new $TypeData().initClass({
  Lshowcase_ImageDemo$: 0
}, false, "showcase.ImageDemo$", {
  Lshowcase_ImageDemo$: 1,
  O: 1,
  Lscommons_react_FunctionComponent: 1,
  Lscommons_react_UiComponent: 1
});
$c_Lshowcase_ImageDemo$.prototype.$classData = $d_Lshowcase_ImageDemo$;
var $n_Lshowcase_ImageDemo$;
function $m_Lshowcase_ImageDemo$() {
  if ((!$n_Lshowcase_ImageDemo$)) {
    $n_Lshowcase_ImageDemo$ = new $c_Lshowcase_ImageDemo$()
  };
  return $n_Lshowcase_ImageDemo$
}
var $b_Lshowcase_ImageDemo$Styles;
function $a_Lshowcase_ImageDemo$Styles() {
  if ((!$b_Lshowcase_ImageDemo$Styles)) {
    /** @constructor */
    $b_Lshowcase_ImageDemo$Styles = (function() {
      Object.call(this);
      Object.defineProperty(this, "container", {
        "configurable": true,
        "enumerable": true,
        "writable": true,
        "value": null
      });
      this.container = (function(superClass$, arg$outer) {
        return (function() {
          var outer = arg$outer;
          var this\u00f8 = {};
          this\u00f8.flex = null;
          this\u00f8.justifyContent = null;
          this\u00f8.alignItems = null;
          this\u00f8.alignContent = null;
          this\u00f8.flex = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(1, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this\u00f8.justifyContent = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($m_Lscommons_reactnative_ViewStyle$JustifyContent$().center__Lscommons_reactnative_ViewStyle$JustifyContent(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this\u00f8.alignItems = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($m_Lscommons_reactnative_ViewStyle$AlignItems$().center__Lscommons_reactnative_ViewStyle$AlignItems(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this\u00f8.alignContent = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($m_Lscommons_reactnative_ViewStyle$AlignContent$().space$minusbetween__Lscommons_reactnative_ViewStyle$AlignContent(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          $s_sr_Statics__releaseFence__V();
          return this\u00f8
        })
      })(Object, this)()
    });
    /** @constructor */
    var $hh_Lshowcase_ImageDemo$Styles = (function() {
      /*<skip>*/
    });
    $hh_Lshowcase_ImageDemo$Styles.prototype = Object.prototype;
    $b_Lshowcase_ImageDemo$Styles.prototype = new $hh_Lshowcase_ImageDemo$Styles();
    $b_Lshowcase_ImageDemo$Styles.prototype.constructor = $b_Lshowcase_ImageDemo$Styles
  };
  return $b_Lshowcase_ImageDemo$Styles
}
function $p_Lshowcase_ModalDemo$__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz) {
  if (((((2 & $thiz.Lshowcase_ModalDemo$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lshowcase_ModalDemo$__f_scommons$react$UiComponent$$reactClass = $f_Lscommons_react_FunctionComponent__create__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz);
    $thiz.Lshowcase_ModalDemo$__f_bitmap$0 = (((2 | $thiz.Lshowcase_ModalDemo$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lshowcase_ModalDemo$__f_scommons$react$UiComponent$$reactClass
}
function $p_Lshowcase_ModalDemo$__styles$lzycompute__Lshowcase_ModalDemo$Styles($thiz) {
  if (((((1 & $thiz.Lshowcase_ModalDemo$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lshowcase_ModalDemo$__f_styles = $m_Lscommons_reactnative_StyleSheet$().create__sjs_js_Object__sjs_js_Object(new ($a_Lshowcase_ModalDemo$Styles())());
    $thiz.Lshowcase_ModalDemo$__f_bitmap$0 = (((1 | $thiz.Lshowcase_ModalDemo$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lshowcase_ModalDemo$__f_styles
}
/** @constructor */
function $c_Lshowcase_ModalDemo$() {
  this.Lshowcase_ModalDemo$__f_styles = null;
  this.Lshowcase_ModalDemo$__f_scommons$react$UiComponent$$reactClass = null;
  this.Lshowcase_ModalDemo$__f_bitmap$0 = 0
}
$c_Lshowcase_ModalDemo$.prototype = new $h_O();
$c_Lshowcase_ModalDemo$.prototype.constructor = $c_Lshowcase_ModalDemo$;
/** @constructor */
function $h_Lshowcase_ModalDemo$() {
  /*<skip>*/
}
$h_Lshowcase_ModalDemo$.prototype = $c_Lshowcase_ModalDemo$.prototype;
$c_Lshowcase_ModalDemo$.prototype.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass = (function() {
  return (((((2 & this.Lshowcase_ModalDemo$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lshowcase_ModalDemo$__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass(this) : this.Lshowcase_ModalDemo$__f_scommons$react$UiComponent$$reactClass)
});
$c_Lshowcase_ModalDemo$.prototype.render__Lio_github_shogowada_scalajs_reactjs_React$Props__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement = (function(props) {
  var this$1 = $m_Lscommons_react_hooks_package$();
  var x1 = $f_Lscommons_react_hooks_UseState__useState__O__T2(this$1, false);
  if ((x1 !== null)) {
    var modalVisible = $uZ(x1._1__O());
    var setModalVisible = x1._2__O();
    var x$1 = new $c_T2(modalVisible, setModalVisible)
  } else {
    var x$1;
    throw new $c_s_MatchError(x1)
  };
  var modalVisible$2 = $uZ(x$1._1__O());
  var setModalVisible$2 = x$1._2__O();
  var elements = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x22 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements).View__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var attributes = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array = [new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__Lscommons_reactnative_Style__Lio_github_shogowada_statictags_Attribute(this.styles__Lshowcase_ModalDemo$Styles().container)];
  var $$x21 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  if (modalVisible$2) {
    var elements$1 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
    var $$x20 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements$1).Modal__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
    var attributes$1 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
    var $$x18 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$1).animationType__Lscommons_reactnative_Modal$ModalAttributes$AnimationTypeAttributeSpec().$colon$eq__Lscommons_reactnative_Modal$AnimationType__Lio_github_shogowada_statictags_Attribute($m_Lscommons_reactnative_Modal$AnimationType$().Lscommons_reactnative_Modal$AnimationType$__f_slide);
    var attributes$2 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
    var this$10 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$2).transparent__Lio_github_shogowada_statictags_BooleanAttributeSpec();
    var $$x17 = new $c_Lio_github_shogowada_statictags_Attribute(this$10.Lio_github_shogowada_statictags_BooleanAttributeSpec__f_name, false, $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$());
    var attributes$3 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
    var this$13 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$3).visible__Lio_github_shogowada_statictags_BooleanAttributeSpec();
    var $$x16 = new $c_Lio_github_shogowada_statictags_Attribute(this$13.Lio_github_shogowada_statictags_BooleanAttributeSpec__f_name, true, $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$());
    var attributes$4 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
    var $$x15 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$4).onShow__Lscommons_reactnative_Modal$ModalAttributes$Function0AttributeSpec().$colon$eq__sjs_js_Function0__Lio_github_shogowada_statictags_Attribute((function() {
      var this$18 = $m_s_Console$();
      var this$19 = this$18.out__Ljava_io_PrintStream();
      this$19.java$lang$JSConsoleBasedPrintStream$$printString__T__V("modal is visible\n")
    }));
    var attributes$5 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
    var array$1 = [$$x18, $$x17, $$x16, $$x15, new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$5).onRequestClose__Lscommons_reactnative_Modal$ModalAttributes$Function0AttributeSpec().$colon$eq__sjs_js_Function0__Lio_github_shogowada_statictags_Attribute((function() {
      var this$23 = $m_s_Console$();
      var this$24 = this$23.out__Ljava_io_PrintStream();
      this$24.java$lang$JSConsoleBasedPrintStream$$printString__T__V("modal will be closed\n")
    }))];
    var $$x19 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
    var elements$2 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
    var $$x14 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements$2).View__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
    var attributes$6 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
    var array$2 = [new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$6).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__Lscommons_reactnative_Style__Lio_github_shogowada_statictags_Attribute(this.styles__Lshowcase_ModalDemo$Styles().container)];
    var $$x13 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
    var elements$3 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
    var $$x12 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements$3).View__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
    var $$x11 = $m_sci_Nil$();
    var elements$4 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
    var $$x10 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements$4).Text__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
    var $$x9 = $m_sci_Nil$();
    var array$3 = ["Hello World!"];
    var $$x8 = $$x10.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x9, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3));
    var elements$5 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
    var $$x7 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements$5).Button__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
    var this$39 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes().title__Lio_github_shogowada_statictags_StringAttributeSpec();
    var $$x6 = new $c_Lio_github_shogowada_statictags_Attribute(this$39.Lio_github_shogowada_statictags_StringAttributeSpec__f_name, "Hide Modal", $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$());
    var attributes$7 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
    var this$42 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$7).color__Lio_github_shogowada_statictags_StringAttributeSpec();
    var $$x5 = new $c_Lio_github_shogowada_statictags_Attribute(this$42.Lio_github_shogowada_statictags_StringAttributeSpec__f_name, "#0000ff", $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$());
    var attributes$8 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
    var array$4 = [$$x6, $$x5, new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$8).onPress__Lscommons_reactnative_Touchable$TouchableAttributes$OnPressEventAttribute().$colon$eq__sjs_js_Function0__Lio_github_shogowada_statictags_Attribute((function(setModalVisible$1) {
      return (function() {
        $m_Lshowcase_ModalDemo$().showcase$ModalDemo$$$anonfun$render$5__sjs_js_Function1__V(setModalVisible$1)
      })
    })(setModalVisible$2))];
    var array$5 = [$$x8, $$x7.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4), $m_sci_Nil$())];
    var array$6 = [$$x12.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x11, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5))];
    var array$7 = [$$x14.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x13, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6))];
    var $$x4 = new $c_s_Some($$x20.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x19, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7)))
  } else {
    var $$x4 = $m_s_None$()
  };
  var elements$6 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x3 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements$6).Button__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var this$58 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes().title__Lio_github_shogowada_statictags_StringAttributeSpec();
  var $$x2 = new $c_Lio_github_shogowada_statictags_Attribute(this$58.Lio_github_shogowada_statictags_StringAttributeSpec__f_name, "Show Modal", $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$());
  var attributes$9 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var this$61 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$9).color__Lio_github_shogowada_statictags_StringAttributeSpec();
  var $$x1 = new $c_Lio_github_shogowada_statictags_Attribute(this$61.Lio_github_shogowada_statictags_StringAttributeSpec__f_name, "#0000ff", $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$());
  var attributes$10 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array$8 = [$$x2, $$x1, new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$10).onPress__Lscommons_reactnative_Touchable$TouchableAttributes$OnPressEventAttribute().$colon$eq__sjs_js_Function0__Lio_github_shogowada_statictags_Attribute((function(setModalVisible$1$1) {
    return (function() {
      $m_Lshowcase_ModalDemo$().showcase$ModalDemo$$$anonfun$render$7__sjs_js_Function1__V(setModalVisible$1$1)
    })
  })(setModalVisible$2))];
  var array$9 = [$$x4, $$x3.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8), $m_sci_Nil$())];
  return $$x22.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x21, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9))
});
$c_Lshowcase_ModalDemo$.prototype.styles__Lshowcase_ModalDemo$Styles = (function() {
  return (((((1 & this.Lshowcase_ModalDemo$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lshowcase_ModalDemo$__styles$lzycompute__Lshowcase_ModalDemo$Styles(this) : this.Lshowcase_ModalDemo$__f_styles)
});
$c_Lshowcase_ModalDemo$.prototype.showcase$ModalDemo$$$anonfun$render$5__sjs_js_Function1__V = (function(setModalVisible$1) {
  setModalVisible$1(false)
});
$c_Lshowcase_ModalDemo$.prototype.showcase$ModalDemo$$$anonfun$render$7__sjs_js_Function1__V = (function(setModalVisible$1) {
  setModalVisible$1(true)
});
var $d_Lshowcase_ModalDemo$ = new $TypeData().initClass({
  Lshowcase_ModalDemo$: 0
}, false, "showcase.ModalDemo$", {
  Lshowcase_ModalDemo$: 1,
  O: 1,
  Lscommons_react_FunctionComponent: 1,
  Lscommons_react_UiComponent: 1
});
$c_Lshowcase_ModalDemo$.prototype.$classData = $d_Lshowcase_ModalDemo$;
var $n_Lshowcase_ModalDemo$;
function $m_Lshowcase_ModalDemo$() {
  if ((!$n_Lshowcase_ModalDemo$)) {
    $n_Lshowcase_ModalDemo$ = new $c_Lshowcase_ModalDemo$()
  };
  return $n_Lshowcase_ModalDemo$
}
var $b_Lshowcase_ModalDemo$Styles;
function $a_Lshowcase_ModalDemo$Styles() {
  if ((!$b_Lshowcase_ModalDemo$Styles)) {
    /** @constructor */
    $b_Lshowcase_ModalDemo$Styles = (function() {
      Object.call(this);
      Object.defineProperty(this, "container", {
        "configurable": true,
        "enumerable": true,
        "writable": true,
        "value": null
      });
      this.container = (function(superClass$, arg$outer) {
        return (function() {
          var outer = arg$outer;
          var this\u00f8 = {};
          this\u00f8.marginTop = null;
          this\u00f8.marginTop = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(22, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().right__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          $s_sr_Statics__releaseFence__V();
          return this\u00f8
        })
      })(Object, this)()
    });
    /** @constructor */
    var $hh_Lshowcase_ModalDemo$Styles = (function() {
      /*<skip>*/
    });
    $hh_Lshowcase_ModalDemo$Styles.prototype = Object.prototype;
    $b_Lshowcase_ModalDemo$Styles.prototype = new $hh_Lshowcase_ModalDemo$Styles();
    $b_Lshowcase_ModalDemo$Styles.prototype.constructor = $b_Lshowcase_ModalDemo$Styles
  };
  return $b_Lshowcase_ModalDemo$Styles
}
function $p_Lshowcase_PlatformDemo$__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz) {
  if (((((2 & $thiz.Lshowcase_PlatformDemo$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lshowcase_PlatformDemo$__f_scommons$react$UiComponent$$reactClass = $f_Lscommons_react_FunctionComponent__create__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz);
    $thiz.Lshowcase_PlatformDemo$__f_bitmap$0 = (((2 | $thiz.Lshowcase_PlatformDemo$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lshowcase_PlatformDemo$__f_scommons$react$UiComponent$$reactClass
}
function $p_Lshowcase_PlatformDemo$__styles$lzycompute__Lshowcase_PlatformDemo$Styles($thiz) {
  if (((((1 & $thiz.Lshowcase_PlatformDemo$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lshowcase_PlatformDemo$__f_styles = $m_Lscommons_reactnative_StyleSheet$().create__sjs_js_Object__sjs_js_Object(new ($a_Lshowcase_PlatformDemo$Styles())());
    $thiz.Lshowcase_PlatformDemo$__f_bitmap$0 = (((1 | $thiz.Lshowcase_PlatformDemo$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lshowcase_PlatformDemo$__f_styles
}
/** @constructor */
function $c_Lshowcase_PlatformDemo$() {
  this.Lshowcase_PlatformDemo$__f_styles = null;
  this.Lshowcase_PlatformDemo$__f_scommons$react$UiComponent$$reactClass = null;
  this.Lshowcase_PlatformDemo$__f_bitmap$0 = 0
}
$c_Lshowcase_PlatformDemo$.prototype = new $h_O();
$c_Lshowcase_PlatformDemo$.prototype.constructor = $c_Lshowcase_PlatformDemo$;
/** @constructor */
function $h_Lshowcase_PlatformDemo$() {
  /*<skip>*/
}
$h_Lshowcase_PlatformDemo$.prototype = $c_Lshowcase_PlatformDemo$.prototype;
$c_Lshowcase_PlatformDemo$.prototype.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass = (function() {
  return (((((2 & this.Lshowcase_PlatformDemo$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lshowcase_PlatformDemo$__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass(this) : this.Lshowcase_PlatformDemo$__f_scommons$react$UiComponent$$reactClass)
});
$c_Lshowcase_PlatformDemo$.prototype.render__Lio_github_shogowada_scalajs_reactjs_React$Props__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement = (function(props) {
  var this$1 = $m_Lscommons_react_navigation_package$();
  var theme = this$1.native__Lscommons_react_navigation_raw_ReactNavigation().useTheme();
  var elements = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x4 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements).View__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var attributes = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array = [new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__Lscommons_reactnative_Style__Lio_github_shogowada_statictags_Attribute(this.styles__Lshowcase_PlatformDemo$Styles().container)];
  var $$x3 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var elements$1 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x2 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements$1).Text__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var this$9 = $m_Lscommons_react_navigation_package$();
  var light = this.styles__Lshowcase_PlatformDemo$Styles().info;
  var this$8 = $m_Lscommons_react_navigation_package$();
  var dark = $f_Lscommons_react_navigation_ReactNavigation__themeTextStyle__Lscommons_react_navigation_raw_Theme__Lscommons_reactnative_TextStyle(this$8, theme);
  var array$1 = [$f_Lscommons_react_navigation_ReactNavigation__themeStyle__Lscommons_reactnative_Style__Lscommons_reactnative_Style__Lscommons_react_navigation_raw_Theme__Lio_github_shogowada_statictags_Attribute(this$9, light, dark, theme)];
  var $$x1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  var array$2 = [(("You are using " + $m_Lscommons_reactnative_Platform$().OS__Lscommons_reactnative_Platform()) + " platform")];
  var array$3 = [$$x2.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x1, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))];
  return $$x4.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x3, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))
});
$c_Lshowcase_PlatformDemo$.prototype.styles__Lshowcase_PlatformDemo$Styles = (function() {
  return (((((1 & this.Lshowcase_PlatformDemo$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lshowcase_PlatformDemo$__styles$lzycompute__Lshowcase_PlatformDemo$Styles(this) : this.Lshowcase_PlatformDemo$__f_styles)
});
var $d_Lshowcase_PlatformDemo$ = new $TypeData().initClass({
  Lshowcase_PlatformDemo$: 0
}, false, "showcase.PlatformDemo$", {
  Lshowcase_PlatformDemo$: 1,
  O: 1,
  Lscommons_react_FunctionComponent: 1,
  Lscommons_react_UiComponent: 1
});
$c_Lshowcase_PlatformDemo$.prototype.$classData = $d_Lshowcase_PlatformDemo$;
var $n_Lshowcase_PlatformDemo$;
function $m_Lshowcase_PlatformDemo$() {
  if ((!$n_Lshowcase_PlatformDemo$)) {
    $n_Lshowcase_PlatformDemo$ = new $c_Lshowcase_PlatformDemo$()
  };
  return $n_Lshowcase_PlatformDemo$
}
var $b_Lshowcase_PlatformDemo$Styles;
function $a_Lshowcase_PlatformDemo$Styles() {
  if ((!$b_Lshowcase_PlatformDemo$Styles)) {
    /** @constructor */
    $b_Lshowcase_PlatformDemo$Styles = (function() {
      Object.call(this);
      Object.defineProperty(this, "container", {
        "configurable": true,
        "enumerable": true,
        "writable": true,
        "value": null
      });
      Object.defineProperty(this, "info", {
        "configurable": true,
        "enumerable": true,
        "writable": true,
        "value": null
      });
      this.container = (function(superClass$, arg$outer) {
        return (function() {
          var outer = arg$outer;
          var this\u00f8 = {};
          this\u00f8.flex = null;
          this\u00f8.justifyContent = null;
          this\u00f8.alignItems = null;
          this\u00f8.flex = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(1, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this\u00f8.justifyContent = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($m_Lscommons_reactnative_ViewStyle$JustifyContent$().center__Lscommons_reactnative_ViewStyle$JustifyContent(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this\u00f8.alignItems = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($m_Lscommons_reactnative_ViewStyle$AlignItems$().center__Lscommons_reactnative_ViewStyle$AlignItems(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          $s_sr_Statics__releaseFence__V();
          return this\u00f8
        })
      })(Object, this)();
      this.info = (function(superClass$, arg$outer) {
        return (function() {
          var outer = arg$outer;
          var this$2 = {};
          this$2.fontFamily = null;
          this$2.color = null;
          this$2.fontFamily = $m_Lscommons_reactnative_Platform$().select__F1__O(new $c_sjsr_AnonFunction1((function(this\u00f8) {
            return (function(x0$1$2) {
              var x0$1 = $as_Lscommons_reactnative_Platform(x0$1$2);
              return $ps_Lshowcase_PlatformDemo$Styles$$anon$2__$anonfun$fontFamily$1__Lshowcase_PlatformDemo$Styles$$anon$2__Lscommons_reactnative_Platform__sjs_js_$bar(this\u00f8, x0$1)
            })
          })(this$2)));
          this$2.color = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($as_T($m_Lscommons_react_navigation_package$().DefaultTheme__Lscommons_react_navigation_raw_Theme().colors.text), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          $s_sr_Statics__releaseFence__V();
          return this$2
        })
      })(Object, this)()
    });
    /** @constructor */
    var $hh_Lshowcase_PlatformDemo$Styles = (function() {
      /*<skip>*/
    });
    $hh_Lshowcase_PlatformDemo$Styles.prototype = Object.prototype;
    $b_Lshowcase_PlatformDemo$Styles.prototype = new $hh_Lshowcase_PlatformDemo$Styles();
    $b_Lshowcase_PlatformDemo$Styles.prototype.constructor = $b_Lshowcase_PlatformDemo$Styles
  };
  return $b_Lshowcase_PlatformDemo$Styles
}
function $p_Lshowcase_SwitchDemo$__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz) {
  if (((((2 & $thiz.Lshowcase_SwitchDemo$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lshowcase_SwitchDemo$__f_scommons$react$UiComponent$$reactClass = $f_Lscommons_react_FunctionComponent__create__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz);
    $thiz.Lshowcase_SwitchDemo$__f_bitmap$0 = (((2 | $thiz.Lshowcase_SwitchDemo$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lshowcase_SwitchDemo$__f_scommons$react$UiComponent$$reactClass
}
function $p_Lshowcase_SwitchDemo$__styles$lzycompute__Lshowcase_SwitchDemo$Styles($thiz) {
  if (((((1 & $thiz.Lshowcase_SwitchDemo$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lshowcase_SwitchDemo$__f_styles = $m_Lscommons_reactnative_StyleSheet$().create__sjs_js_Object__sjs_js_Object(new ($a_Lshowcase_SwitchDemo$Styles())());
    $thiz.Lshowcase_SwitchDemo$__f_bitmap$0 = (((1 | $thiz.Lshowcase_SwitchDemo$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lshowcase_SwitchDemo$__f_styles
}
/** @constructor */
function $c_Lshowcase_SwitchDemo$() {
  this.Lshowcase_SwitchDemo$__f_styles = null;
  this.Lshowcase_SwitchDemo$__f_scommons$react$UiComponent$$reactClass = null;
  this.Lshowcase_SwitchDemo$__f_bitmap$0 = 0
}
$c_Lshowcase_SwitchDemo$.prototype = new $h_O();
$c_Lshowcase_SwitchDemo$.prototype.constructor = $c_Lshowcase_SwitchDemo$;
/** @constructor */
function $h_Lshowcase_SwitchDemo$() {
  /*<skip>*/
}
$h_Lshowcase_SwitchDemo$.prototype = $c_Lshowcase_SwitchDemo$.prototype;
$c_Lshowcase_SwitchDemo$.prototype.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass = (function() {
  return (((((2 & this.Lshowcase_SwitchDemo$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lshowcase_SwitchDemo$__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass(this) : this.Lshowcase_SwitchDemo$__f_scommons$react$UiComponent$$reactClass)
});
$c_Lshowcase_SwitchDemo$.prototype.render__Lio_github_shogowada_scalajs_reactjs_React$Props__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement = (function(compProps) {
  var props = $as_Lshowcase_SwitchDemoProps(compProps.wrapped__O());
  var this$1 = $m_Lscommons_react_navigation_package$();
  var theme = this$1.native__Lscommons_react_navigation_raw_ReactNavigation().useTheme();
  var elements = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x11 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements).View__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var attributes = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array = [new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__Lscommons_reactnative_Style__Lio_github_shogowada_statictags_Attribute(this.styles__Lshowcase_SwitchDemo$Styles().container)];
  var $$x10 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var elements$1 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x9 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements$1).Text__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var attributes$1 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var $$x7 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$1).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec();
  var this$9 = $m_Lscommons_react_navigation_package$();
  var array$1 = [$$x7.$colon$eq__Lscommons_reactnative_Style__Lio_github_shogowada_statictags_Attribute($f_Lscommons_react_navigation_ReactNavigation__themeTextStyle__Lscommons_react_navigation_raw_Theme__Lscommons_reactnative_TextStyle(this$9, theme))];
  var $$x8 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  var array$2 = ["Dark Theme"];
  var $$x6 = $$x9.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x8, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2));
  var elements$2 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x5 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements$2).Switch__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var attributes$2 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var $$x4 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$2).trackColor__Lscommons_reactnative_Switch$SwitchAttributes$TrackColorAttributeSpec().$colon$eq__Lscommons_reactnative_Switch$TrackColor__Lio_github_shogowada_statictags_Attribute((function(superClass$) {
    return (function() {
      var this$18 = {};
      this$18.false = null;
      this$18.true = null;
      this$18.false = "#767577";
      this$18.true = "#81b0ff";
      return this$18
    })
  })(Object)());
  var attributes$3 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var this$20 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$3).thumbColor__Lio_github_shogowada_statictags_StringAttributeSpec();
  var value = (props.Lshowcase_SwitchDemoProps__f_darkTheme ? "#f5dd4b" : "#f4f3f4");
  var $$x3 = new $c_Lio_github_shogowada_statictags_Attribute(this$20.Lio_github_shogowada_statictags_StringAttributeSpec__f_name, value, $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$());
  $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var this$23 = new $c_Lio_github_shogowada_statictags_DynamicAttributeSpec("ios_backgroundColor");
  var $$x2 = new $c_Lio_github_shogowada_statictags_Attribute(this$23.Lio_github_shogowada_statictags_DynamicAttributeSpec__f_name, "#3e3e3e", $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$());
  var attributes$4 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var $$x1 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$4).switchOnValueChange__Lscommons_reactnative_Switch$SwitchAttributes$OnValueChangeAttributeSpec().$colon$eq__sjs_js_Function1__Lio_github_shogowada_statictags_Attribute((function(props$1) {
    return (function(arg1$2) {
      var arg1 = $uZ(arg1$2);
      var this$27 = props$1.Lshowcase_SwitchDemoProps__f_actions;
      var dispatch = props$1.Lshowcase_SwitchDemoProps__f_dispatch;
      $f_Lshowcase_app_config_ShowcaseConfigActions__updateTheme__F1__Z__V(this$27, dispatch, arg1)
    })
  })(props));
  var attributes$5 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var this$29 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$5).switchValue__Lio_github_shogowada_statictags_BooleanAttributeSpec();
  var value$1 = props.Lshowcase_SwitchDemoProps__f_darkTheme;
  var array$3 = [$$x4, $$x3, $$x2, $$x1, new $c_Lio_github_shogowada_statictags_Attribute(this$29.Lio_github_shogowada_statictags_BooleanAttributeSpec__f_name, value$1, $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$())];
  var array$4 = [$$x6, $$x5.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3), $m_sci_Nil$())];
  return $$x11.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x10, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4))
});
$c_Lshowcase_SwitchDemo$.prototype.styles__Lshowcase_SwitchDemo$Styles = (function() {
  return (((((1 & this.Lshowcase_SwitchDemo$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lshowcase_SwitchDemo$__styles$lzycompute__Lshowcase_SwitchDemo$Styles(this) : this.Lshowcase_SwitchDemo$__f_styles)
});
var $d_Lshowcase_SwitchDemo$ = new $TypeData().initClass({
  Lshowcase_SwitchDemo$: 0
}, false, "showcase.SwitchDemo$", {
  Lshowcase_SwitchDemo$: 1,
  O: 1,
  Lscommons_react_FunctionComponent: 1,
  Lscommons_react_UiComponent: 1
});
$c_Lshowcase_SwitchDemo$.prototype.$classData = $d_Lshowcase_SwitchDemo$;
var $n_Lshowcase_SwitchDemo$;
function $m_Lshowcase_SwitchDemo$() {
  if ((!$n_Lshowcase_SwitchDemo$)) {
    $n_Lshowcase_SwitchDemo$ = new $c_Lshowcase_SwitchDemo$()
  };
  return $n_Lshowcase_SwitchDemo$
}
var $b_Lshowcase_SwitchDemo$Styles;
function $a_Lshowcase_SwitchDemo$Styles() {
  if ((!$b_Lshowcase_SwitchDemo$Styles)) {
    /** @constructor */
    $b_Lshowcase_SwitchDemo$Styles = (function() {
      Object.call(this);
      Object.defineProperty(this, "container", {
        "configurable": true,
        "enumerable": true,
        "writable": true,
        "value": null
      });
      this.container = (function(superClass$, arg$outer) {
        return (function() {
          var outer = arg$outer;
          var this\u00f8 = {};
          this\u00f8.flex = null;
          this\u00f8.alignItems = null;
          this\u00f8.justifyContent = null;
          this\u00f8.flex = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(1, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this\u00f8.alignItems = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($m_Lscommons_reactnative_ViewStyle$AlignItems$().center__Lscommons_reactnative_ViewStyle$AlignItems(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this\u00f8.justifyContent = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($m_Lscommons_reactnative_ViewStyle$JustifyContent$().center__Lscommons_reactnative_ViewStyle$JustifyContent(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          $s_sr_Statics__releaseFence__V();
          return this\u00f8
        })
      })(Object, this)()
    });
    /** @constructor */
    var $hh_Lshowcase_SwitchDemo$Styles = (function() {
      /*<skip>*/
    });
    $hh_Lshowcase_SwitchDemo$Styles.prototype = Object.prototype;
    $b_Lshowcase_SwitchDemo$Styles.prototype = new $hh_Lshowcase_SwitchDemo$Styles();
    $b_Lshowcase_SwitchDemo$Styles.prototype.constructor = $b_Lshowcase_SwitchDemo$Styles
  };
  return $b_Lshowcase_SwitchDemo$Styles
}
function $p_Lshowcase_app_ReactNativeDemoController$__scommons$react$redux$BaseStateController$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz) {
  if (((((2 & $thiz.Lshowcase_app_ReactNativeDemoController$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lshowcase_app_ReactNativeDemoController$__f_scommons$react$redux$BaseStateController$$reactClass = $f_Lscommons_react_redux_BaseStateController__scommons$react$redux$BaseStateController$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz);
    $thiz.Lshowcase_app_ReactNativeDemoController$__f_bitmap$0 = (((2 | $thiz.Lshowcase_app_ReactNativeDemoController$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lshowcase_app_ReactNativeDemoController$__f_scommons$react$redux$BaseStateController$$reactClass
}
function $p_Lshowcase_app_ReactNativeDemoController$__uiComponent$lzycompute__Lscommons_react_UiComponent($thiz) {
  if (((((1 & $thiz.Lshowcase_app_ReactNativeDemoController$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lshowcase_app_ReactNativeDemoController$__f_uiComponent = $m_Lshowcase_app_ReactNativeDemoScreen$();
    $thiz.Lshowcase_app_ReactNativeDemoController$__f_bitmap$0 = (((1 | $thiz.Lshowcase_app_ReactNativeDemoController$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lshowcase_app_ReactNativeDemoController$__f_uiComponent
}
/** @constructor */
function $c_Lshowcase_app_ReactNativeDemoController$() {
  this.Lshowcase_app_ReactNativeDemoController$__f_uiComponent = null;
  this.Lshowcase_app_ReactNativeDemoController$__f_scommons$react$redux$BaseStateController$$reactClass = null;
  this.Lshowcase_app_ReactNativeDemoController$__f_bitmap$0 = 0
}
$c_Lshowcase_app_ReactNativeDemoController$.prototype = new $h_O();
$c_Lshowcase_app_ReactNativeDemoController$.prototype.constructor = $c_Lshowcase_app_ReactNativeDemoController$;
/** @constructor */
function $h_Lshowcase_app_ReactNativeDemoController$() {
  /*<skip>*/
}
$h_Lshowcase_app_ReactNativeDemoController$.prototype = $c_Lshowcase_app_ReactNativeDemoController$.prototype;
$c_Lshowcase_app_ReactNativeDemoController$.prototype.mapStateToProps__F1__O__Lio_github_shogowada_scalajs_reactjs_React$Props__O = (function(dispatch, state, props) {
  return $f_Lscommons_reactnative_app_BaseStateAndRouteController__mapStateToProps__F1__O__Lio_github_shogowada_scalajs_reactjs_React$Props__O(this, dispatch, state, props)
});
$c_Lshowcase_app_ReactNativeDemoController$.prototype.scommons$react$redux$BaseStateController$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass = (function() {
  return (((((2 & this.Lshowcase_app_ReactNativeDemoController$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lshowcase_app_ReactNativeDemoController$__scommons$react$redux$BaseStateController$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass(this) : this.Lshowcase_app_ReactNativeDemoController$__f_scommons$react$redux$BaseStateController$$reactClass)
});
$c_Lshowcase_app_ReactNativeDemoController$.prototype.uiComponent__Lscommons_react_UiComponent = (function() {
  return (((((1 & this.Lshowcase_app_ReactNativeDemoController$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lshowcase_app_ReactNativeDemoController$__uiComponent$lzycompute__Lscommons_react_UiComponent(this) : this.Lshowcase_app_ReactNativeDemoController$__f_uiComponent)
});
$c_Lshowcase_app_ReactNativeDemoController$.prototype.mapStateAndRouteToProps__F1__Lshowcase_app_ShowcaseStateDef__Lscommons_react_navigation_Navigation__Lshowcase_app_ReactNativeDemoScreenProps = (function(dispatch, state, nav) {
  return new $c_Lshowcase_app_ReactNativeDemoScreenProps(new $c_sjsr_AnonFunction1((function(this$1, nav$1) {
    return (function(screen$2) {
      var screen = $as_T(screen$2);
      nav$1.navigate__T__V(screen)
    })
  })(this, nav)))
});
$c_Lshowcase_app_ReactNativeDemoController$.prototype.mapStateAndRouteToProps__F1__O__Lscommons_react_navigation_Navigation__O = (function(dispatch, state, nav) {
  return this.mapStateAndRouteToProps__F1__Lshowcase_app_ShowcaseStateDef__Lscommons_react_navigation_Navigation__Lshowcase_app_ReactNativeDemoScreenProps(dispatch, $as_Lshowcase_app_ShowcaseStateDef(state), nav)
});
var $d_Lshowcase_app_ReactNativeDemoController$ = new $TypeData().initClass({
  Lshowcase_app_ReactNativeDemoController$: 0
}, false, "showcase.app.ReactNativeDemoController$", {
  Lshowcase_app_ReactNativeDemoController$: 1,
  O: 1,
  Lscommons_reactnative_app_BaseStateAndRouteController: 1,
  Lscommons_react_redux_BaseStateController: 1
});
$c_Lshowcase_app_ReactNativeDemoController$.prototype.$classData = $d_Lshowcase_app_ReactNativeDemoController$;
var $n_Lshowcase_app_ReactNativeDemoController$;
function $m_Lshowcase_app_ReactNativeDemoController$() {
  if ((!$n_Lshowcase_app_ReactNativeDemoController$)) {
    $n_Lshowcase_app_ReactNativeDemoController$ = new $c_Lshowcase_app_ReactNativeDemoController$()
  };
  return $n_Lshowcase_app_ReactNativeDemoController$
}
function $p_Lshowcase_app_ReactNativeDemoScreen$__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz) {
  if (((((2 & $thiz.Lshowcase_app_ReactNativeDemoScreen$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lshowcase_app_ReactNativeDemoScreen$__f_scommons$react$UiComponent$$reactClass = $f_Lscommons_react_FunctionComponent__create__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz);
    $thiz.Lshowcase_app_ReactNativeDemoScreen$__f_bitmap$0 = (((2 | $thiz.Lshowcase_app_ReactNativeDemoScreen$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lshowcase_app_ReactNativeDemoScreen$__f_scommons$react$UiComponent$$reactClass
}
function $p_Lshowcase_app_ReactNativeDemoScreen$__switchComp$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz) {
  if (((((1 & $thiz.Lshowcase_app_ReactNativeDemoScreen$__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = new $c_Lshowcase_SwitchController($m_Lshowcase_app_ShowcaseActions$());
    $thiz.Lshowcase_app_ReactNativeDemoScreen$__f_switchComp = this$1.scommons$react$redux$BaseStateController$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass();
    $thiz.Lshowcase_app_ReactNativeDemoScreen$__f_bitmap$0 = (((1 | $thiz.Lshowcase_app_ReactNativeDemoScreen$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lshowcase_app_ReactNativeDemoScreen$__f_switchComp
}
/** @constructor */
function $c_Lshowcase_app_ReactNativeDemoScreen$() {
  this.Lshowcase_app_ReactNativeDemoScreen$__f_switchComp = null;
  this.Lshowcase_app_ReactNativeDemoScreen$__f_scommons$react$UiComponent$$reactClass = null;
  this.Lshowcase_app_ReactNativeDemoScreen$__f_bitmap$0 = 0
}
$c_Lshowcase_app_ReactNativeDemoScreen$.prototype = new $h_O();
$c_Lshowcase_app_ReactNativeDemoScreen$.prototype.constructor = $c_Lshowcase_app_ReactNativeDemoScreen$;
/** @constructor */
function $h_Lshowcase_app_ReactNativeDemoScreen$() {
  /*<skip>*/
}
$h_Lshowcase_app_ReactNativeDemoScreen$.prototype = $c_Lshowcase_app_ReactNativeDemoScreen$.prototype;
$c_Lshowcase_app_ReactNativeDemoScreen$.prototype.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass = (function() {
  return (((((2 & this.Lshowcase_app_ReactNativeDemoScreen$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lshowcase_app_ReactNativeDemoScreen$__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass(this) : this.Lshowcase_app_ReactNativeDemoScreen$__f_scommons$react$UiComponent$$reactClass)
});
$c_Lshowcase_app_ReactNativeDemoScreen$.prototype.render__Lio_github_shogowada_scalajs_reactjs_React$Props__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement = (function(compProps) {
  var props = $as_Lshowcase_app_ReactNativeDemoScreenProps(compProps.wrapped__O());
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var this$1 = $m_Lshowcase_app_ShowcaseListView$();
  var reactClass = this$1.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass();
  var $$x2 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass);
  var $$x1 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes().wrapped__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$WrappedPropsAttributeSpec();
  $m_s_package$();
  var array = [new $c_T2("ActivityIndicator", "Demo ActivityIndicator component"), new $c_T2("Button", "Demo Button component"), new $c_T2("FlatList", "Demo FlatList component"), new $c_T2("Image", "Demo Image component"), new $c_T2("Modal", "Demo Modal component"), new $c_T2("Alert", "Demo Alert component"), new $c_T2("Switch", "Demo Switch component"), new $c_T2("Platform", "Demo Platform API")];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var array$1 = [$$x1.$colon$eq__O__Lio_github_shogowada_statictags_Attribute(new $c_Lshowcase_app_ShowcaseListViewProps($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems), props.Lshowcase_app_ReactNativeDemoScreenProps__f_navigate))];
  return $$x2.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1), $m_sci_Nil$())
});
$c_Lshowcase_app_ReactNativeDemoScreen$.prototype.switchComp__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass = (function() {
  return (((((1 & this.Lshowcase_app_ReactNativeDemoScreen$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lshowcase_app_ReactNativeDemoScreen$__switchComp$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass(this) : this.Lshowcase_app_ReactNativeDemoScreen$__f_switchComp)
});
$c_Lshowcase_app_ReactNativeDemoScreen$.prototype.getReactNativeScreens__Lscommons_react_navigation_stack_raw_StackNavigator__sci_Seq = (function(stack) {
  var $$x31 = $m_s_package$().s_package$__f_Seq;
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var reactClass = stack.Screen;
  var $$x30 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass);
  var this$2 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes().name__Lio_github_shogowada_statictags_StringAttributeSpec();
  var $$x29 = new $c_Lio_github_shogowada_statictags_Attribute(this$2.Lio_github_shogowada_statictags_StringAttributeSpec__f_name, "ActivityIndicator", $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$());
  $m_Lscommons_react_navigation_package$();
  var attributes = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var $$x28 = new $c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes(attributes).component__Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenComponentAttributeSpec();
  var this$5 = $m_Lshowcase_ActivityIndicatorDemo$();
  var array = [$$x29, $$x28.$colon$eq__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass__Lio_github_shogowada_statictags_Attribute(this$5.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass())];
  var $$x27 = $$x30.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array), $m_sci_Nil$());
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var reactClass$1 = stack.Screen;
  var $$x26 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass$1);
  var this$10 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes().name__Lio_github_shogowada_statictags_StringAttributeSpec();
  var $$x25 = new $c_Lio_github_shogowada_statictags_Attribute(this$10.Lio_github_shogowada_statictags_StringAttributeSpec__f_name, "Button", $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$());
  $m_Lscommons_react_navigation_package$();
  var attributes$1 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var $$x24 = new $c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes(attributes$1).component__Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenComponentAttributeSpec();
  var this$13 = $m_Lshowcase_ButtonDemo$();
  var array$1 = [$$x25, $$x24.$colon$eq__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass__Lio_github_shogowada_statictags_Attribute(this$13.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass())];
  var $$x23 = $$x26.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1), $m_sci_Nil$());
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var reactClass$2 = stack.Screen;
  var $$x22 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass$2);
  var this$18 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes().name__Lio_github_shogowada_statictags_StringAttributeSpec();
  var $$x21 = new $c_Lio_github_shogowada_statictags_Attribute(this$18.Lio_github_shogowada_statictags_StringAttributeSpec__f_name, "FlatList", $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$());
  $m_Lscommons_react_navigation_package$();
  var attributes$2 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var $$x20 = new $c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes(attributes$2).component__Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenComponentAttributeSpec();
  var this$21 = $m_Lshowcase_FlatListDemo$();
  var array$2 = [$$x21, $$x20.$colon$eq__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass__Lio_github_shogowada_statictags_Attribute(this$21.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass())];
  var $$x19 = $$x22.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2), $m_sci_Nil$());
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var reactClass$3 = stack.Screen;
  var $$x18 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass$3);
  var this$26 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes().name__Lio_github_shogowada_statictags_StringAttributeSpec();
  var $$x17 = new $c_Lio_github_shogowada_statictags_Attribute(this$26.Lio_github_shogowada_statictags_StringAttributeSpec__f_name, "Image", $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$());
  $m_Lscommons_react_navigation_package$();
  var attributes$3 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var $$x16 = new $c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes(attributes$3).component__Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenComponentAttributeSpec();
  var this$29 = $m_Lshowcase_ImageDemo$();
  var array$3 = [$$x17, $$x16.$colon$eq__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass__Lio_github_shogowada_statictags_Attribute(this$29.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass())];
  var $$x15 = $$x18.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3), $m_sci_Nil$());
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var reactClass$4 = stack.Screen;
  var $$x14 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass$4);
  var this$34 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes().name__Lio_github_shogowada_statictags_StringAttributeSpec();
  var $$x13 = new $c_Lio_github_shogowada_statictags_Attribute(this$34.Lio_github_shogowada_statictags_StringAttributeSpec__f_name, "Modal", $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$());
  $m_Lscommons_react_navigation_package$();
  var attributes$4 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var $$x12 = new $c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes(attributes$4).component__Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenComponentAttributeSpec();
  var this$37 = $m_Lshowcase_ModalDemo$();
  var array$4 = [$$x13, $$x12.$colon$eq__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass__Lio_github_shogowada_statictags_Attribute(this$37.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass())];
  var $$x11 = $$x14.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4), $m_sci_Nil$());
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var reactClass$5 = stack.Screen;
  var $$x10 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass$5);
  var this$42 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes().name__Lio_github_shogowada_statictags_StringAttributeSpec();
  var $$x9 = new $c_Lio_github_shogowada_statictags_Attribute(this$42.Lio_github_shogowada_statictags_StringAttributeSpec__f_name, "Alert", $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$());
  $m_Lscommons_react_navigation_package$();
  var attributes$5 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var $$x8 = new $c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes(attributes$5).component__Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenComponentAttributeSpec();
  var this$45 = $m_Lshowcase_AlertDemo$();
  var array$5 = [$$x9, $$x8.$colon$eq__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass__Lio_github_shogowada_statictags_Attribute(this$45.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass())];
  var $$x7 = $$x10.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5), $m_sci_Nil$());
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var reactClass$6 = stack.Screen;
  var $$x6 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass$6);
  var this$50 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes().name__Lio_github_shogowada_statictags_StringAttributeSpec();
  var $$x5 = new $c_Lio_github_shogowada_statictags_Attribute(this$50.Lio_github_shogowada_statictags_StringAttributeSpec__f_name, "Switch", $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$());
  $m_Lscommons_react_navigation_package$();
  var attributes$6 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array$6 = [$$x5, new $c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes(attributes$6).component__Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenComponentAttributeSpec().$colon$eq__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass__Lio_github_shogowada_statictags_Attribute(this.switchComp__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass())];
  var $$x4 = $$x6.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6), $m_sci_Nil$());
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var reactClass$7 = stack.Screen;
  var $$x3 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass$7);
  var this$57 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes().name__Lio_github_shogowada_statictags_StringAttributeSpec();
  var $$x2 = new $c_Lio_github_shogowada_statictags_Attribute(this$57.Lio_github_shogowada_statictags_StringAttributeSpec__f_name, "Platform", $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$());
  $m_Lscommons_react_navigation_package$();
  var attributes$7 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var $$x1 = new $c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes(attributes$7).component__Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenComponentAttributeSpec();
  var this$60 = $m_Lshowcase_PlatformDemo$();
  var array$7 = [$$x2, $$x1.$colon$eq__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass__Lio_github_shogowada_statictags_Attribute(this$60.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass())];
  var array$8 = [$$x27, $$x23, $$x19, $$x15, $$x11, $$x7, $$x4, $$x3.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7), $m_sci_Nil$())];
  return $as_sci_Seq($$x31.apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8)))
});
var $d_Lshowcase_app_ReactNativeDemoScreen$ = new $TypeData().initClass({
  Lshowcase_app_ReactNativeDemoScreen$: 0
}, false, "showcase.app.ReactNativeDemoScreen$", {
  Lshowcase_app_ReactNativeDemoScreen$: 1,
  O: 1,
  Lscommons_react_FunctionComponent: 1,
  Lscommons_react_UiComponent: 1
});
$c_Lshowcase_app_ReactNativeDemoScreen$.prototype.$classData = $d_Lshowcase_app_ReactNativeDemoScreen$;
var $n_Lshowcase_app_ReactNativeDemoScreen$;
function $m_Lshowcase_app_ReactNativeDemoScreen$() {
  if ((!$n_Lshowcase_app_ReactNativeDemoScreen$)) {
    $n_Lshowcase_app_ReactNativeDemoScreen$ = new $c_Lshowcase_app_ReactNativeDemoScreen$()
  };
  return $n_Lshowcase_app_ReactNativeDemoScreen$
}
/** @constructor */
function $c_Lshowcase_app_ShowcaseActions$() {
  this.Lshowcase_app_ShowcaseActions$__f_client = null;
  $n_Lshowcase_app_ShowcaseActions$ = this;
  this.Lshowcase_app_ShowcaseActions$__f_client = new $c_Lshowcase_app_ShowcaseActions$$anon$1()
}
$c_Lshowcase_app_ShowcaseActions$.prototype = new $h_O();
$c_Lshowcase_app_ShowcaseActions$.prototype.constructor = $c_Lshowcase_app_ShowcaseActions$;
/** @constructor */
function $h_Lshowcase_app_ShowcaseActions$() {
  /*<skip>*/
}
$h_Lshowcase_app_ShowcaseActions$.prototype = $c_Lshowcase_app_ShowcaseActions$.prototype;
var $d_Lshowcase_app_ShowcaseActions$ = new $TypeData().initClass({
  Lshowcase_app_ShowcaseActions$: 0
}, false, "showcase.app.ShowcaseActions$", {
  Lshowcase_app_ShowcaseActions$: 1,
  O: 1,
  Lshowcase_app_task_DemoTaskActions: 1,
  Lshowcase_app_config_ShowcaseConfigActions: 1
});
$c_Lshowcase_app_ShowcaseActions$.prototype.$classData = $d_Lshowcase_app_ShowcaseActions$;
var $n_Lshowcase_app_ShowcaseActions$;
function $m_Lshowcase_app_ShowcaseActions$() {
  if ((!$n_Lshowcase_app_ShowcaseActions$)) {
    $n_Lshowcase_app_ShowcaseActions$ = new $c_Lshowcase_app_ShowcaseActions$()
  };
  return $n_Lshowcase_app_ShowcaseActions$
}
function $p_Lshowcase_app_ShowcaseApp__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz) {
  if ((!$thiz.Lshowcase_app_ShowcaseApp__f_bitmap$0)) {
    $thiz.Lshowcase_app_ShowcaseApp__f_scommons$react$UiComponent$$reactClass = $f_Lscommons_react_FunctionComponent__create__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz);
    $thiz.Lshowcase_app_ShowcaseApp__f_bitmap$0 = true
  };
  return $thiz.Lshowcase_app_ShowcaseApp__f_scommons$react$UiComponent$$reactClass
}
function $p_Lshowcase_app_ShowcaseApp__preloadAssets__F0__V($thiz, onFinish) {
  var $$x3 = $m_s_concurrent_Future$();
  var $$x2 = $m_s_package$().s_package$__f_Seq;
  var array = [$p_Lshowcase_app_ShowcaseApp__cacheImages$1__s_concurrent_Future($thiz), $p_Lshowcase_app_ShowcaseApp__cacheFonts$1__s_concurrent_Future($thiz), $p_Lshowcase_app_ShowcaseApp__cacheIcons$1__s_concurrent_Future($thiz)];
  var $$x1 = $$x2.apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
  var this$4 = $m_sc_BuildFrom$();
  var this$7 = $$x3.sequence__sc_IterableOnce__sc_BuildFrom__s_concurrent_ExecutionContext__s_concurrent_Future($$x1, new $c_sc_BuildFromLowPriority2$$anon$11(this$4), $m_s_concurrent_ExecutionContext$().global__s_concurrent_ExecutionContextExecutor());
  var pf = new $c_Lshowcase_app_ShowcaseApp$$anonfun$preloadAssets$1($thiz, onFinish);
  var executor = $m_s_concurrent_ExecutionContext$().global__s_concurrent_ExecutionContextExecutor();
  $f_s_concurrent_Future__andThen__s_PartialFunction__s_concurrent_ExecutionContext__s_concurrent_Future(this$7, pf, executor)
}
function $p_Lshowcase_app_ShowcaseApp__cacheImages$1__s_concurrent_Future($thiz) {
  return $m_Lscommons_expo_Asset$().loadAsync__sci_Seq__s_concurrent_Future($m_Lshowcase_app_ShowcaseImages$().imagesToPreload__sci_Seq()).recover__s_PartialFunction__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_Lshowcase_app_ShowcaseApp$$anonfun$cacheImages$1$1($thiz), $m_s_concurrent_ExecutionContext$().global__s_concurrent_ExecutionContextExecutor())
}
function $p_Lshowcase_app_ShowcaseApp__cacheFonts$1__s_concurrent_Future($thiz) {
  return $m_Lscommons_expo_Font$().loadAsync__sci_Seq__s_concurrent_Future($m_Lshowcase_app_ShowcaseFonts$().fontsToPreload__sci_Seq()).recover__s_PartialFunction__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_Lshowcase_app_ShowcaseApp$$anonfun$cacheFonts$1$1($thiz), $m_s_concurrent_ExecutionContext$().global__s_concurrent_ExecutionContextExecutor())
}
function $p_Lshowcase_app_ShowcaseApp__cacheIcons$1__s_concurrent_Future($thiz) {
  return $m_Lscommons_expo_Font$().loadAsync__sci_Seq__s_concurrent_Future($m_Lshowcase_app_ShowcaseIcons$().iconsToPreload__sci_Seq()).recover__s_PartialFunction__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_Lshowcase_app_ShowcaseApp$$anonfun$cacheIcons$1$1($thiz), $m_s_concurrent_ExecutionContext$().global__s_concurrent_ExecutionContextExecutor())
}
/** @constructor */
function $c_Lshowcase_app_ShowcaseApp(onReady) {
  this.Lshowcase_app_ShowcaseApp__f_onReady = null;
  this.Lshowcase_app_ShowcaseApp__f_store = null;
  this.Lshowcase_app_ShowcaseApp__f_scommons$react$UiComponent$$reactClass = null;
  this.Lshowcase_app_ShowcaseApp__f_bitmap$0 = false;
  this.Lshowcase_app_ShowcaseApp__f_onReady = onReady;
  var this$2 = $m_Lio_github_shogowada_scalajs_reactjs_redux_Redux$();
  var reducer = new $c_sjsr_AnonFunction2((function(this$1) {
    return (function(state$2, action$2) {
      var state = $as_s_Option(state$2);
      return $m_Lshowcase_app_ShowcaseStateReducer$().reduce__s_Option__O__Lshowcase_app_ShowcaseState(state, action$2)
    })
  })(this));
  this.Lshowcase_app_ShowcaseApp__f_store = this$2.createStore__F2__sjs_js_Any__Lio_github_shogowada_scalajs_reactjs_redux_Store(reducer, null)
}
$c_Lshowcase_app_ShowcaseApp.prototype = new $h_O();
$c_Lshowcase_app_ShowcaseApp.prototype.constructor = $c_Lshowcase_app_ShowcaseApp;
/** @constructor */
function $h_Lshowcase_app_ShowcaseApp() {
  /*<skip>*/
}
$h_Lshowcase_app_ShowcaseApp.prototype = $c_Lshowcase_app_ShowcaseApp.prototype;
$c_Lshowcase_app_ShowcaseApp.prototype.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass = (function() {
  return ((!this.Lshowcase_app_ShowcaseApp__f_bitmap$0) ? $p_Lshowcase_app_ShowcaseApp__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass(this) : this.Lshowcase_app_ShowcaseApp__f_scommons$react$UiComponent$$reactClass)
});
$c_Lshowcase_app_ShowcaseApp.prototype.render__Lio_github_shogowada_scalajs_reactjs_React$Props__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement = (function(props) {
  var this$1 = $m_Lscommons_react_hooks_package$();
  var x1 = $f_Lscommons_react_hooks_UseState__useState__O__T2(this$1, false);
  if ((x1 === null)) {
    throw new $c_s_MatchError(x1)
  };
  var isReady = $uZ(x1._1__O());
  var setIsReady = x1._2__O();
  var this$5 = $m_Lscommons_react_hooks_package$();
  var didUpdate = new $c_sjsr_AnonFunction0((function(this$2, setIsReady$2) {
    return (function() {
      $p_Lshowcase_app_ShowcaseApp__preloadAssets__F0__V(this$2, new $c_sjsr_AnonFunction0((function(this$3, setIsReady$1) {
        return (function() {
          setIsReady$1(true);
          (0, this$3.Lshowcase_app_ShowcaseApp__f_onReady)()
        })
      })(this$2, setIsReady$2)));
      var value = (void 0);
      return value
    })
  })(this, setIsReady));
  var dependencies = $m_s_package$().s_package$__f_Nil;
  $f_Lscommons_react_hooks_UseEffect__useEffect__F0__sci_List__V(this$5, didUpdate, dependencies);
  if ((!isReady)) {
    var elements = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
    return new $c_Lscommons_react_package$ReactVirtualDOMElements(elements).$greater__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec().apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($m_sci_Nil$(), $m_sci_Nil$())
  } else {
    var elements$1 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
    var $$x5 = new $c_Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMElements(elements$1).Provider__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
    var attributes = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
    var array = [new $c_Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMAttributes(attributes).store__Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMAttributes$StoreAttributeSpec().$colon$eq__Lio_github_shogowada_scalajs_reactjs_redux_Store__Lio_github_shogowada_statictags_Attribute(this.Lshowcase_app_ShowcaseApp__f_store)];
    var $$x4 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    var elements$2 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
    var $$x3 = new $c_Lscommons_react_package$ReactVirtualDOMElements(elements$2).$greater__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
    var $$x2 = $m_sci_Nil$();
    $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
    var this$13 = $m_Lshowcase_app_ShowcaseRootController$();
    var reactClass = this$13.scommons$react$redux$BaseStateController$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass();
    var this$15 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass);
    var $$x1 = this$15.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($m_sci_Nil$(), $m_sci_Nil$());
    $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
    var this$16 = $m_Lshowcase_app_ShowcaseTaskController$();
    var reactClass$1 = this$16.scommons$react$redux$BaseStateController$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass();
    var this$18 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass$1);
    var array$1 = [$$x1, this$18.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($m_sci_Nil$(), $m_sci_Nil$())];
    var array$2 = [$$x3.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x2, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))];
    return $$x5.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x4, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))
  }
});
$c_Lshowcase_app_ShowcaseApp.prototype.$js$exported$meth$apply__O = (function() {
  return this.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass()
});
$c_Lshowcase_app_ShowcaseApp.prototype.apply = (function() {
  return this.$js$exported$meth$apply__O()
});
var $d_Lshowcase_app_ShowcaseApp = new $TypeData().initClass({
  Lshowcase_app_ShowcaseApp: 0
}, false, "showcase.app.ShowcaseApp", {
  Lshowcase_app_ShowcaseApp: 1,
  O: 1,
  Lscommons_react_FunctionComponent: 1,
  Lscommons_react_UiComponent: 1
});
$c_Lshowcase_app_ShowcaseApp.prototype.$classData = $d_Lshowcase_app_ShowcaseApp;
function $p_Lshowcase_app_ShowcaseController$__scommons$react$redux$BaseStateController$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz) {
  if (((((2 & $thiz.Lshowcase_app_ShowcaseController$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lshowcase_app_ShowcaseController$__f_scommons$react$redux$BaseStateController$$reactClass = $f_Lscommons_react_redux_BaseStateController__scommons$react$redux$BaseStateController$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz);
    $thiz.Lshowcase_app_ShowcaseController$__f_bitmap$0 = (((2 | $thiz.Lshowcase_app_ShowcaseController$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lshowcase_app_ShowcaseController$__f_scommons$react$redux$BaseStateController$$reactClass
}
function $p_Lshowcase_app_ShowcaseController$__uiComponent$lzycompute__Lscommons_react_UiComponent($thiz) {
  if (((((1 & $thiz.Lshowcase_app_ShowcaseController$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lshowcase_app_ShowcaseController$__f_uiComponent = $m_Lshowcase_app_ShowcaseScreen$();
    $thiz.Lshowcase_app_ShowcaseController$__f_bitmap$0 = (((1 | $thiz.Lshowcase_app_ShowcaseController$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lshowcase_app_ShowcaseController$__f_uiComponent
}
/** @constructor */
function $c_Lshowcase_app_ShowcaseController$() {
  this.Lshowcase_app_ShowcaseController$__f_uiComponent = null;
  this.Lshowcase_app_ShowcaseController$__f_scommons$react$redux$BaseStateController$$reactClass = null;
  this.Lshowcase_app_ShowcaseController$__f_bitmap$0 = 0
}
$c_Lshowcase_app_ShowcaseController$.prototype = new $h_O();
$c_Lshowcase_app_ShowcaseController$.prototype.constructor = $c_Lshowcase_app_ShowcaseController$;
/** @constructor */
function $h_Lshowcase_app_ShowcaseController$() {
  /*<skip>*/
}
$h_Lshowcase_app_ShowcaseController$.prototype = $c_Lshowcase_app_ShowcaseController$.prototype;
$c_Lshowcase_app_ShowcaseController$.prototype.mapStateToProps__F1__O__Lio_github_shogowada_scalajs_reactjs_React$Props__O = (function(dispatch, state, props) {
  return $f_Lscommons_reactnative_app_BaseStateAndRouteController__mapStateToProps__F1__O__Lio_github_shogowada_scalajs_reactjs_React$Props__O(this, dispatch, state, props)
});
$c_Lshowcase_app_ShowcaseController$.prototype.scommons$react$redux$BaseStateController$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass = (function() {
  return (((((2 & this.Lshowcase_app_ShowcaseController$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lshowcase_app_ShowcaseController$__scommons$react$redux$BaseStateController$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass(this) : this.Lshowcase_app_ShowcaseController$__f_scommons$react$redux$BaseStateController$$reactClass)
});
$c_Lshowcase_app_ShowcaseController$.prototype.uiComponent__Lscommons_react_UiComponent = (function() {
  return (((((1 & this.Lshowcase_app_ShowcaseController$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lshowcase_app_ShowcaseController$__uiComponent$lzycompute__Lscommons_react_UiComponent(this) : this.Lshowcase_app_ShowcaseController$__f_uiComponent)
});
$c_Lshowcase_app_ShowcaseController$.prototype.mapStateAndRouteToProps__F1__Lshowcase_app_ShowcaseStateDef__Lscommons_react_navigation_Navigation__Lshowcase_app_ShowcaseScreenProps = (function(dispatch, state, nav) {
  return new $c_Lshowcase_app_ShowcaseScreenProps(new $c_sjsr_AnonFunction1((function(this$1, nav$1) {
    return (function(screen$2) {
      var screen = $as_T(screen$2);
      nav$1.navigate__T__V(screen)
    })
  })(this, nav)))
});
$c_Lshowcase_app_ShowcaseController$.prototype.mapStateAndRouteToProps__F1__O__Lscommons_react_navigation_Navigation__O = (function(dispatch, state, nav) {
  return this.mapStateAndRouteToProps__F1__Lshowcase_app_ShowcaseStateDef__Lscommons_react_navigation_Navigation__Lshowcase_app_ShowcaseScreenProps(dispatch, $as_Lshowcase_app_ShowcaseStateDef(state), nav)
});
var $d_Lshowcase_app_ShowcaseController$ = new $TypeData().initClass({
  Lshowcase_app_ShowcaseController$: 0
}, false, "showcase.app.ShowcaseController$", {
  Lshowcase_app_ShowcaseController$: 1,
  O: 1,
  Lscommons_reactnative_app_BaseStateAndRouteController: 1,
  Lscommons_react_redux_BaseStateController: 1
});
$c_Lshowcase_app_ShowcaseController$.prototype.$classData = $d_Lshowcase_app_ShowcaseController$;
var $n_Lshowcase_app_ShowcaseController$;
function $m_Lshowcase_app_ShowcaseController$() {
  if ((!$n_Lshowcase_app_ShowcaseController$)) {
    $n_Lshowcase_app_ShowcaseController$ = new $c_Lshowcase_app_ShowcaseController$()
  };
  return $n_Lshowcase_app_ShowcaseController$
}
function $p_Lshowcase_app_ShowcaseListView$__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz) {
  if (((((2 & $thiz.Lshowcase_app_ShowcaseListView$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lshowcase_app_ShowcaseListView$__f_scommons$react$UiComponent$$reactClass = $f_Lscommons_react_FunctionComponent__create__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz);
    $thiz.Lshowcase_app_ShowcaseListView$__f_bitmap$0 = (((2 | $thiz.Lshowcase_app_ShowcaseListView$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lshowcase_app_ShowcaseListView$__f_scommons$react$UiComponent$$reactClass
}
function $p_Lshowcase_app_ShowcaseListView$__styles$lzycompute__Lshowcase_app_ShowcaseListView$Styles($thiz) {
  if (((((1 & $thiz.Lshowcase_app_ShowcaseListView$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lshowcase_app_ShowcaseListView$__f_styles = $m_Lscommons_reactnative_StyleSheet$().create__sjs_js_Object__sjs_js_Object(new ($a_Lshowcase_app_ShowcaseListView$Styles())());
    $thiz.Lshowcase_app_ShowcaseListView$__f_bitmap$0 = (((1 | $thiz.Lshowcase_app_ShowcaseListView$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lshowcase_app_ShowcaseListView$__f_styles
}
/** @constructor */
function $c_Lshowcase_app_ShowcaseListView$() {
  this.Lshowcase_app_ShowcaseListView$__f_styles = null;
  this.Lshowcase_app_ShowcaseListView$__f_scommons$react$UiComponent$$reactClass = null;
  this.Lshowcase_app_ShowcaseListView$__f_bitmap$0 = 0
}
$c_Lshowcase_app_ShowcaseListView$.prototype = new $h_O();
$c_Lshowcase_app_ShowcaseListView$.prototype.constructor = $c_Lshowcase_app_ShowcaseListView$;
/** @constructor */
function $h_Lshowcase_app_ShowcaseListView$() {
  /*<skip>*/
}
$h_Lshowcase_app_ShowcaseListView$.prototype = $c_Lshowcase_app_ShowcaseListView$.prototype;
$c_Lshowcase_app_ShowcaseListView$.prototype.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass = (function() {
  return (((((2 & this.Lshowcase_app_ShowcaseListView$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lshowcase_app_ShowcaseListView$__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass(this) : this.Lshowcase_app_ShowcaseListView$__f_scommons$react$UiComponent$$reactClass)
});
$c_Lshowcase_app_ShowcaseListView$.prototype.render__Lio_github_shogowada_scalajs_reactjs_React$Props__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement = (function(compProps) {
  var this$1 = $m_Lscommons_react_navigation_package$();
  var theme = this$1.native__Lscommons_react_navigation_raw_ReactNavigation().useTheme();
  var props = $as_Lshowcase_app_ShowcaseListViewProps(compProps.wrapped__O());
  var elements = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x12 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements).ScrollView__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var attributes = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array = [new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes).keyboardShouldPersistTaps__Lscommons_reactnative_ScrollView$ScrollViewAttributes$KeyboardShouldPersistTapsAttribute().$colon$eq__Lscommons_reactnative_ScrollView$KeyboardShouldPersistTaps__Lio_github_shogowada_statictags_Attribute($m_Lscommons_reactnative_ScrollView$KeyboardShouldPersistTaps$().Lscommons_reactnative_ScrollView$KeyboardShouldPersistTaps$__f_always)];
  var $$x11 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var array$9 = [props.Lshowcase_app_ShowcaseListViewProps__f_items.map__F1__sci_List(new $c_sjsr_AnonFunction1((function(this$7, props$1, theme$1) {
    return (function(x0$1$2) {
      var x0$1 = $as_T2(x0$1$2);
      if ((x0$1 !== null)) {
        var item = $as_T(x0$1._1__O());
        var description = $as_T(x0$1._2__O());
        var elements$1 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
        var $$x10 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements$1).TouchableWithoutFeedback__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
        var this$9 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes().key__Lio_github_shogowada_statictags_StringAttributeSpec();
        var $$x8 = new $c_Lio_github_shogowada_statictags_Attribute(this$9.Lio_github_shogowada_statictags_StringAttributeSpec__f_name, item, $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$());
        var attributes$1 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
        var array$1 = [$$x8, new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$1).onPress__Lscommons_reactnative_Touchable$TouchableAttributes$OnPressEventAttribute().$colon$eq__sjs_js_Function0__Lio_github_shogowada_statictags_Attribute((function(props$1$1, item$1) {
          return (function() {
            props$1$1.Lshowcase_app_ShowcaseListViewProps__f_navigate.apply__O__O(item$1)
          })
        })(props$1, item))];
        var $$x9 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
        var elements$2 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
        var $$x7 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements$2).View__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
        var this$17 = $m_Lscommons_react_navigation_package$();
        var light = $m_Lshowcase_app_ShowcaseListView$().styles__Lshowcase_app_ShowcaseListView$Styles().itemContainer;
        var dark = $m_Lshowcase_app_ShowcaseListView$().styles__Lshowcase_app_ShowcaseListView$Styles().itemContainerDark;
        var array$2 = [$f_Lscommons_react_navigation_ReactNavigation__themeStyle__Lscommons_reactnative_Style__Lscommons_reactnative_Style__Lscommons_react_navigation_raw_Theme__Lio_github_shogowada_statictags_Attribute(this$17, light, dark, theme$1)];
        var $$x6 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
        var elements$3 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
        var $$x5 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements$3).Text__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
        var this$23 = $m_Lscommons_react_navigation_package$();
        var light$1 = $m_Lshowcase_app_ShowcaseListView$().styles__Lshowcase_app_ShowcaseListView$Styles().itemTitle;
        var this$22 = $m_Lscommons_react_navigation_package$();
        var dark$1 = $f_Lscommons_react_navigation_ReactNavigation__themeTextStyle__Lscommons_react_navigation_raw_Theme__Lscommons_reactnative_TextStyle(this$22, theme$1);
        var array$3 = [$f_Lscommons_react_navigation_ReactNavigation__themeStyle__Lscommons_reactnative_Style__Lscommons_reactnative_Style__Lscommons_react_navigation_raw_Theme__Lio_github_shogowada_statictags_Attribute(this$23, light$1, dark$1, theme$1)];
        var $$x4 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3);
        var array$4 = [item];
        var $$x3 = $$x5.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x4, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4));
        var elements$4 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
        var $$x2 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements$4).Text__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
        var this$31 = $m_Lscommons_react_navigation_package$();
        var light$2 = $m_Lshowcase_app_ShowcaseListView$().styles__Lshowcase_app_ShowcaseListView$Styles().itemDescription;
        var dark$2 = $m_Lshowcase_app_ShowcaseListView$().styles__Lshowcase_app_ShowcaseListView$Styles().itemDescriptionDark;
        var array$5 = [$f_Lscommons_react_navigation_ReactNavigation__themeStyle__Lscommons_reactnative_Style__Lscommons_reactnative_Style__Lscommons_react_navigation_raw_Theme__Lio_github_shogowada_statictags_Attribute(this$31, light$2, dark$2, theme$1)];
        var $$x1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5);
        var array$6 = [description];
        var array$7 = [$$x3, $$x2.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x1, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6))];
        var array$8 = [$$x7.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x6, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7))];
        return $$x10.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x9, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8))
      } else {
        throw new $c_s_MatchError(x0$1)
      }
    })
  })(this, props, theme)))];
  return $$x12.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x11, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9))
});
$c_Lshowcase_app_ShowcaseListView$.prototype.styles__Lshowcase_app_ShowcaseListView$Styles = (function() {
  return (((((1 & this.Lshowcase_app_ShowcaseListView$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lshowcase_app_ShowcaseListView$__styles$lzycompute__Lshowcase_app_ShowcaseListView$Styles(this) : this.Lshowcase_app_ShowcaseListView$__f_styles)
});
var $d_Lshowcase_app_ShowcaseListView$ = new $TypeData().initClass({
  Lshowcase_app_ShowcaseListView$: 0
}, false, "showcase.app.ShowcaseListView$", {
  Lshowcase_app_ShowcaseListView$: 1,
  O: 1,
  Lscommons_react_FunctionComponent: 1,
  Lscommons_react_UiComponent: 1
});
$c_Lshowcase_app_ShowcaseListView$.prototype.$classData = $d_Lshowcase_app_ShowcaseListView$;
var $n_Lshowcase_app_ShowcaseListView$;
function $m_Lshowcase_app_ShowcaseListView$() {
  if ((!$n_Lshowcase_app_ShowcaseListView$)) {
    $n_Lshowcase_app_ShowcaseListView$ = new $c_Lshowcase_app_ShowcaseListView$()
  };
  return $n_Lshowcase_app_ShowcaseListView$
}
var $b_Lshowcase_app_ShowcaseListView$Styles;
function $a_Lshowcase_app_ShowcaseListView$Styles() {
  if ((!$b_Lshowcase_app_ShowcaseListView$Styles)) {
    /** @constructor */
    $b_Lshowcase_app_ShowcaseListView$Styles = (function() {
      Object.call(this);
      Object.defineProperty(this, "itemContainer", {
        "configurable": true,
        "enumerable": true,
        "writable": true,
        "value": null
      });
      Object.defineProperty(this, "itemContainerDark", {
        "configurable": true,
        "enumerable": true,
        "writable": true,
        "value": null
      });
      Object.defineProperty(this, "itemTitle", {
        "configurable": true,
        "enumerable": true,
        "writable": true,
        "value": null
      });
      Object.defineProperty(this, "itemDescription", {
        "configurable": true,
        "enumerable": true,
        "writable": true,
        "value": null
      });
      Object.defineProperty(this, "itemDescriptionDark", {
        "configurable": true,
        "enumerable": true,
        "writable": true,
        "value": null
      });
      this.itemContainer = (function(superClass$, arg$outer) {
        return (function() {
          var outer = arg$outer;
          var this\u00f8 = {};
          this\u00f8.padding = null;
          this\u00f8.borderBottomWidth = null;
          this\u00f8.borderBottomColor = null;
          this\u00f8.padding = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(10, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().right__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          this\u00f8.borderBottomWidth = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(2, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this\u00f8.borderBottomColor = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($m_Lscommons_reactnative_Style$Color$().darkgray__T(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          $s_sr_Statics__releaseFence__V();
          return this\u00f8
        })
      })(Object, this)();
      this.itemContainerDark = (function(superClass$, arg$outer) {
        return (function() {
          var outer = arg$outer;
          var this$2 = {};
          this$2.borderBottomColor = null;
          this$2.borderBottomColor = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($m_Lscommons_reactnative_Style$Color$().gray__T(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          $s_sr_Statics__releaseFence__V();
          return this$2
        })
      })(Object, this)();
      this.itemTitle = (function(superClass$, arg$outer) {
        return (function() {
          var outer = arg$outer;
          var this$3 = {};
          this$3.fontSize = null;
          this$3.color = null;
          this$3.fontSize = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(20, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this$3.color = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($as_T($m_Lscommons_react_navigation_package$().DefaultTheme__Lscommons_react_navigation_raw_Theme().colors.text), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          $s_sr_Statics__releaseFence__V();
          return this$3
        })
      })(Object, this)();
      this.itemDescription = (function(superClass$, arg$outer) {
        return (function() {
          var outer = arg$outer;
          var this$4 = {};
          this$4.color = null;
          this$4.color = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar("rgba(0, 0, 0, .5)", $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          $s_sr_Statics__releaseFence__V();
          return this$4
        })
      })(Object, this)();
      this.itemDescriptionDark = (function(superClass$, arg$outer) {
        return (function() {
          var outer = arg$outer;
          var this$5 = {};
          this$5.color = null;
          this$5.color = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar("rgba(255, 255, 255, .5)", $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          $s_sr_Statics__releaseFence__V();
          return this$5
        })
      })(Object, this)()
    });
    /** @constructor */
    var $hh_Lshowcase_app_ShowcaseListView$Styles = (function() {
      /*<skip>*/
    });
    $hh_Lshowcase_app_ShowcaseListView$Styles.prototype = Object.prototype;
    $b_Lshowcase_app_ShowcaseListView$Styles.prototype = new $hh_Lshowcase_app_ShowcaseListView$Styles();
    $b_Lshowcase_app_ShowcaseListView$Styles.prototype.constructor = $b_Lshowcase_app_ShowcaseListView$Styles
  };
  return $b_Lshowcase_app_ShowcaseListView$Styles
}
function $p_Lshowcase_app_ShowcaseRoot$__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz) {
  if (((((8 & $thiz.Lshowcase_app_ShowcaseRoot$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lshowcase_app_ShowcaseRoot$__f_scommons$react$UiComponent$$reactClass = $f_Lscommons_react_FunctionComponent__create__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz);
    $thiz.Lshowcase_app_ShowcaseRoot$__f_bitmap$0 = (((8 | $thiz.Lshowcase_app_ShowcaseRoot$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lshowcase_app_ShowcaseRoot$__f_scommons$react$UiComponent$$reactClass
}
function $p_Lshowcase_app_ShowcaseRoot$__AppStack$lzycompute__Lscommons_react_navigation_stack_raw_StackNavigator($thiz) {
  if (((((1 & $thiz.Lshowcase_app_ShowcaseRoot$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lshowcase_app_ShowcaseRoot$__f_AppStack = $m_Lscommons_react_navigation_stack_package$().createStackNavigator__Lscommons_react_navigation_stack_raw_StackNavigator();
    $thiz.Lshowcase_app_ShowcaseRoot$__f_bitmap$0 = (((1 | $thiz.Lshowcase_app_ShowcaseRoot$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lshowcase_app_ShowcaseRoot$__f_AppStack
}
function $p_Lshowcase_app_ShowcaseRoot$__HomeTab$lzycompute__Lscommons_react_navigation_tab_raw_TabNavigator($thiz) {
  if (((((2 & $thiz.Lshowcase_app_ShowcaseRoot$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lshowcase_app_ShowcaseRoot$__f_HomeTab = $m_Lscommons_react_navigation_tab_package$().createBottomTabNavigator__Lscommons_react_navigation_tab_raw_TabNavigator();
    $thiz.Lshowcase_app_ShowcaseRoot$__f_bitmap$0 = (((2 | $thiz.Lshowcase_app_ShowcaseRoot$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lshowcase_app_ShowcaseRoot$__f_HomeTab
}
function $p_Lshowcase_app_ShowcaseRoot$__homeTabComp$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz) {
  if (((((4 & $thiz.Lshowcase_app_ShowcaseRoot$__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = new $c_Lshowcase_app_ShowcaseRoot$$anon$2();
    $thiz.Lshowcase_app_ShowcaseRoot$__f_homeTabComp = this$1.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass();
    $thiz.Lshowcase_app_ShowcaseRoot$__f_bitmap$0 = (((4 | $thiz.Lshowcase_app_ShowcaseRoot$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lshowcase_app_ShowcaseRoot$__f_homeTabComp
}
function $p_Lshowcase_app_ShowcaseRoot$__getScreenTitle$1__Lscommons_react_navigation_raw_NavigationProps__T($thiz, navProps) {
  var this$1 = $m_Lscommons_react_navigation_package$();
  var route = navProps.route;
  var this$2 = $f_Lscommons_react_navigation_ReactNavigation__getFocusedRouteNameFromRoute__Lscommons_react_navigation_raw_Route__s_Option(this$1, route);
  var routeName = $as_T((this$2.isEmpty__Z() ? $as_T(navProps.route.name) : this$2.get__O()));
  return ((routeName === "App") ? "Showcase" : ((routeName === "Home") ? "Showcase" : routeName))
}
/** @constructor */
function $c_Lshowcase_app_ShowcaseRoot$() {
  this.Lshowcase_app_ShowcaseRoot$__f_AppStack = null;
  this.Lshowcase_app_ShowcaseRoot$__f_HomeTab = null;
  this.Lshowcase_app_ShowcaseRoot$__f_homeTabComp = null;
  this.Lshowcase_app_ShowcaseRoot$__f_scommons$react$UiComponent$$reactClass = null;
  this.Lshowcase_app_ShowcaseRoot$__f_bitmap$0 = 0
}
$c_Lshowcase_app_ShowcaseRoot$.prototype = new $h_O();
$c_Lshowcase_app_ShowcaseRoot$.prototype.constructor = $c_Lshowcase_app_ShowcaseRoot$;
/** @constructor */
function $h_Lshowcase_app_ShowcaseRoot$() {
  /*<skip>*/
}
$h_Lshowcase_app_ShowcaseRoot$.prototype = $c_Lshowcase_app_ShowcaseRoot$.prototype;
$c_Lshowcase_app_ShowcaseRoot$.prototype.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass = (function() {
  return (((((8 & this.Lshowcase_app_ShowcaseRoot$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lshowcase_app_ShowcaseRoot$__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass(this) : this.Lshowcase_app_ShowcaseRoot$__f_scommons$react$UiComponent$$reactClass)
});
$c_Lshowcase_app_ShowcaseRoot$.prototype.render__Lio_github_shogowada_scalajs_reactjs_React$Props__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement = (function(compProps) {
  var props = $as_Lshowcase_app_ShowcaseRootProps(compProps.wrapped__O());
  var elements = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x12 = new $c_Lscommons_react_package$ReactVirtualDOMElements(elements).$greater__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var $$x11 = $m_sci_Nil$();
  var elements$1 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x10 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements$1).StatusBar__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var attributes = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array = [new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes).barStyle__Lscommons_reactnative_StatusBar$StatusBarAttributes$BarStyleAttributeSpec().$colon$eq__Lscommons_reactnative_StatusBar$BarStyle__Lio_github_shogowada_statictags_Attribute((props.Lshowcase_app_ShowcaseRootProps__f_darkTheme ? $m_Lscommons_reactnative_StatusBar$BarStyle$().Lscommons_reactnative_StatusBar$BarStyle$__f_light$minuscontent : $m_Lscommons_reactnative_StatusBar$BarStyle$().Lscommons_reactnative_StatusBar$BarStyle$__f_dark$minuscontent))];
  var $$x9 = $$x10.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array), $m_sci_Nil$());
  var elements$2 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x8 = new $c_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMElements(elements$2).SafeAreaProvider__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var $$x7 = $m_sci_Nil$();
  $m_Lscommons_react_navigation_package$();
  var elements$3 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x6 = new $c_Lscommons_react_navigation_package$ReactNavigationVirtualDOMElements(elements$3).NavigationContainer__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  $m_Lscommons_react_navigation_package$();
  var attributes$1 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array$1 = [new $c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes(attributes$1).theme__Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ThemeAttributeSpec().$colon$eq__Lscommons_react_navigation_raw_Theme__Lio_github_shogowada_statictags_Attribute((props.Lshowcase_app_ShowcaseRootProps__f_darkTheme ? $m_Lscommons_react_navigation_package$().DarkTheme__Lscommons_react_navigation_raw_Theme() : $m_Lscommons_react_navigation_package$().DefaultTheme__Lscommons_react_navigation_raw_Theme()))];
  var $$x5 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var reactClass = this.AppStack__Lscommons_react_navigation_stack_raw_StackNavigator().Navigator;
  var $$x4 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass);
  $m_Lscommons_react_navigation_package$();
  var attributes$2 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array$2 = [new $c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes(attributes$2).screenOptions__Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenOptionsAttributeSpec().$colon$eq__sjs_js_Function1__Lio_github_shogowada_statictags_Attribute((function(arg1$2) {
    return $m_Lshowcase_app_ShowcaseRoot$().showcase$app$ShowcaseRoot$$$anonfun$render$2__Lscommons_react_navigation_raw_NavigationProps__Lscommons_react_navigation_raw_NavigatorScreenOptions(arg1$2)
  }))];
  var $$x3 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var reactClass$1 = this.AppStack__Lscommons_react_navigation_stack_raw_StackNavigator().Screen;
  var $$x2 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass$1);
  var this$19 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes().name__Lio_github_shogowada_statictags_StringAttributeSpec();
  var $$x1 = new $c_Lio_github_shogowada_statictags_Attribute(this$19.Lio_github_shogowada_statictags_StringAttributeSpec__f_name, "App", $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$());
  $m_Lscommons_react_navigation_package$();
  var attributes$3 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array$3 = [$$x1, new $c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes(attributes$3).component__Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenComponentAttributeSpec().$colon$eq__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass__Lio_github_shogowada_statictags_Attribute(this.homeTabComp__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass())];
  var array$4 = [$$x2.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3), $m_sci_Nil$()), $m_Lshowcase_app_ShowcaseScreen$().getHomeScreens__Lscommons_react_navigation_stack_raw_StackNavigator__sci_Seq(this.AppStack__Lscommons_react_navigation_stack_raw_StackNavigator()), $m_Lshowcase_app_ReactNativeDemoScreen$().getReactNativeScreens__Lscommons_react_navigation_stack_raw_StackNavigator__sci_Seq(this.AppStack__Lscommons_react_navigation_stack_raw_StackNavigator()), $m_Lshowcase_app_community_CommunityDemoScreen$().getCommunityScreens__Lscommons_react_navigation_stack_raw_StackNavigator__sci_Seq(this.AppStack__Lscommons_react_navigation_stack_raw_StackNavigator()), $m_Lshowcase_app_expo_ExpoDemoScreen$().getExpoScreens__Lscommons_react_navigation_stack_raw_StackNavigator__sci_Seq(this.AppStack__Lscommons_react_navigation_stack_raw_StackNavigator())];
  var array$5 = [$$x4.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x3, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4))];
  var array$6 = [$$x6.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x5, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5))];
  var array$7 = [$$x9, $$x8.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x7, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6))];
  return $$x12.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x11, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7))
});
$c_Lshowcase_app_ShowcaseRoot$.prototype.AppStack__Lscommons_react_navigation_stack_raw_StackNavigator = (function() {
  return (((((1 & this.Lshowcase_app_ShowcaseRoot$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lshowcase_app_ShowcaseRoot$__AppStack$lzycompute__Lscommons_react_navigation_stack_raw_StackNavigator(this) : this.Lshowcase_app_ShowcaseRoot$__f_AppStack)
});
$c_Lshowcase_app_ShowcaseRoot$.prototype.HomeTab__Lscommons_react_navigation_tab_raw_TabNavigator = (function() {
  return (((((2 & this.Lshowcase_app_ShowcaseRoot$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lshowcase_app_ShowcaseRoot$__HomeTab$lzycompute__Lscommons_react_navigation_tab_raw_TabNavigator(this) : this.Lshowcase_app_ShowcaseRoot$__f_HomeTab)
});
$c_Lshowcase_app_ShowcaseRoot$.prototype.homeTabComp__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass = (function() {
  return (((((4 & this.Lshowcase_app_ShowcaseRoot$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lshowcase_app_ShowcaseRoot$__homeTabComp$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass(this) : this.Lshowcase_app_ShowcaseRoot$__f_homeTabComp)
});
$c_Lshowcase_app_ShowcaseRoot$.prototype.showcase$app$ShowcaseRoot$$$anonfun$render$2__Lscommons_react_navigation_raw_NavigationProps__Lscommons_react_navigation_raw_NavigatorScreenOptions = (function(navProps) {
  var screenTitle = $p_Lshowcase_app_ShowcaseRoot$__getScreenTitle$1__Lscommons_react_navigation_raw_NavigationProps__T(this, navProps);
  var options = (function(superClass$, screenTitle$1$2) {
    return (function() {
      var this$1 = {};
      this$1.headerBackTitleVisible = false;
      this$1.title = null;
      this$1.headerBackTitleVisible = false;
      this$1.title = screenTitle$1$2;
      return this$1
    })
  })(Object, screenTitle)();
  return options
});
var $d_Lshowcase_app_ShowcaseRoot$ = new $TypeData().initClass({
  Lshowcase_app_ShowcaseRoot$: 0
}, false, "showcase.app.ShowcaseRoot$", {
  Lshowcase_app_ShowcaseRoot$: 1,
  O: 1,
  Lscommons_react_FunctionComponent: 1,
  Lscommons_react_UiComponent: 1
});
$c_Lshowcase_app_ShowcaseRoot$.prototype.$classData = $d_Lshowcase_app_ShowcaseRoot$;
var $n_Lshowcase_app_ShowcaseRoot$;
function $m_Lshowcase_app_ShowcaseRoot$() {
  if ((!$n_Lshowcase_app_ShowcaseRoot$)) {
    $n_Lshowcase_app_ShowcaseRoot$ = new $c_Lshowcase_app_ShowcaseRoot$()
  };
  return $n_Lshowcase_app_ShowcaseRoot$
}
function $p_Lshowcase_app_ShowcaseRoot$$anon$2__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz) {
  if ((!$thiz.Lshowcase_app_ShowcaseRoot$$anon$2__f_bitmap$0)) {
    $thiz.Lshowcase_app_ShowcaseRoot$$anon$2__f_scommons$react$UiComponent$$reactClass = $f_Lscommons_react_FunctionComponent__create__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz);
    $thiz.Lshowcase_app_ShowcaseRoot$$anon$2__f_bitmap$0 = true
  };
  return $thiz.Lshowcase_app_ShowcaseRoot$$anon$2__f_scommons$react$UiComponent$$reactClass
}
/** @constructor */
function $c_Lshowcase_app_ShowcaseRoot$$anon$2() {
  this.Lshowcase_app_ShowcaseRoot$$anon$2__f_scommons$react$UiComponent$$reactClass = null;
  this.Lshowcase_app_ShowcaseRoot$$anon$2__f_bitmap$0 = false
}
$c_Lshowcase_app_ShowcaseRoot$$anon$2.prototype = new $h_O();
$c_Lshowcase_app_ShowcaseRoot$$anon$2.prototype.constructor = $c_Lshowcase_app_ShowcaseRoot$$anon$2;
/** @constructor */
function $h_Lshowcase_app_ShowcaseRoot$$anon$2() {
  /*<skip>*/
}
$h_Lshowcase_app_ShowcaseRoot$$anon$2.prototype = $c_Lshowcase_app_ShowcaseRoot$$anon$2.prototype;
$c_Lshowcase_app_ShowcaseRoot$$anon$2.prototype.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass = (function() {
  return ((!this.Lshowcase_app_ShowcaseRoot$$anon$2__f_bitmap$0) ? $p_Lshowcase_app_ShowcaseRoot$$anon$2__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass(this) : this.Lshowcase_app_ShowcaseRoot$$anon$2__f_scommons$react$UiComponent$$reactClass)
});
$c_Lshowcase_app_ShowcaseRoot$$anon$2.prototype.render__Lio_github_shogowada_scalajs_reactjs_React$Props__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement = (function(props) {
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var reactClass = $m_Lshowcase_app_ShowcaseRoot$().HomeTab__Lscommons_react_navigation_tab_raw_TabNavigator().Navigator;
  var $$x22 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass);
  $m_Lscommons_react_navigation_package$();
  var attributes = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var this$3 = new $c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes(attributes).initialRouteName__Lio_github_shogowada_statictags_StringAttributeSpec();
  var $$x20 = new $c_Lio_github_shogowada_statictags_Attribute(this$3.Lio_github_shogowada_statictags_StringAttributeSpec__f_name, "Home", $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$());
  $m_Lscommons_react_navigation_package$();
  var attributes$1 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array = [$$x20, new $c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes(attributes$1).screenOptions__Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenOptionsAttributeSpec().$colon$eq__Lscommons_react_navigation_raw_NavigatorScreenOptions__Lio_github_shogowada_statictags_Attribute((function(superClass$, arg$outer) {
    return (function() {
      var this$6 = {};
      this$6.headerShown = null;
      this$6.lazy = null;
      this$6.tabBarLabelPosition = null;
      this$6.headerShown = false;
      this$6.lazy = false;
      var a = $m_Lscommons_react_navigation_tab_TabBarOptions$LabelPosition$().Lscommons_react_navigation_tab_TabBarOptions$LabelPosition$__f_below$minusicon;
      this$6.tabBarLabelPosition = a;
      return this$6
    })
  })(Object, this)())];
  var $$x21 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var reactClass$1 = $m_Lshowcase_app_ShowcaseRoot$().HomeTab__Lscommons_react_navigation_tab_raw_TabNavigator().Screen;
  var $$x19 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass$1);
  var this$20 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes().name__Lio_github_shogowada_statictags_StringAttributeSpec();
  var $$x18 = new $c_Lio_github_shogowada_statictags_Attribute(this$20.Lio_github_shogowada_statictags_StringAttributeSpec__f_name, "Home", $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$());
  $m_Lscommons_react_navigation_package$();
  var attributes$2 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var $$x17 = new $c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes(attributes$2).component__Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenComponentAttributeSpec();
  var this$23 = $m_Lshowcase_app_ShowcaseController$();
  var $$x16 = $$x17.$colon$eq__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass__Lio_github_shogowada_statictags_Attribute(this$23.scommons$react$redux$BaseStateController$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass());
  $m_Lscommons_react_navigation_package$();
  var attributes$3 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array$1 = [$$x18, $$x16, new $c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes(attributes$3).options__Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenOptionsAttributeSpec().$colon$eq__Lscommons_react_navigation_raw_NavigatorScreenOptions__Lio_github_shogowada_statictags_Attribute((function(superClass$$1, arg$outer$1) {
    return (function() {
      var this$2$1 = {};
      this$2$1.tabBarIcon = null;
      var a$1 = (function(arg$outer$2) {
        return (function(arg1$2) {
          return $s_Lshowcase_app_ShowcaseRoot$$anon$2$$anon$4__showcase$app$ShowcaseRoot$$nestedInanon$2$$nestedInanon$4$$$anonfun$tabBarIcon$1__Lshowcase_app_ShowcaseRoot$$anon$2$$anon$4__Lscommons_react_navigation_tab_raw_TabBarIconParams__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement(arg$outer$2, arg1$2)
        })
      })(this$2$1);
      this$2$1.tabBarIcon = a$1;
      return this$2$1
    })
  })(Object, this)())];
  var $$x15 = $$x19.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1), $m_sci_Nil$());
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var reactClass$2 = $m_Lshowcase_app_ShowcaseRoot$().HomeTab__Lscommons_react_navigation_tab_raw_TabNavigator().Screen;
  var $$x14 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass$2);
  var this$32 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes().name__Lio_github_shogowada_statictags_StringAttributeSpec();
  var $$x13 = new $c_Lio_github_shogowada_statictags_Attribute(this$32.Lio_github_shogowada_statictags_StringAttributeSpec__f_name, "react-native", $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$());
  $m_Lscommons_react_navigation_package$();
  var attributes$4 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var $$x12 = new $c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes(attributes$4).component__Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenComponentAttributeSpec();
  var this$35 = $m_Lshowcase_app_ReactNativeDemoController$();
  var $$x11 = $$x12.$colon$eq__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass__Lio_github_shogowada_statictags_Attribute(this$35.scommons$react$redux$BaseStateController$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass());
  $m_Lscommons_react_navigation_package$();
  var attributes$5 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array$2 = [$$x13, $$x11, new $c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes(attributes$5).options__Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenOptionsAttributeSpec().$colon$eq__Lscommons_react_navigation_raw_NavigatorScreenOptions__Lio_github_shogowada_statictags_Attribute((function(superClass$$2, arg$outer$3) {
    return (function() {
      var this$3$1 = {};
      this$3$1.tabBarIcon = null;
      var a$2 = (function(arg$outer$4) {
        return (function(arg1$2$1) {
          return $s_Lshowcase_app_ShowcaseRoot$$anon$2$$anon$5__showcase$app$ShowcaseRoot$$nestedInanon$2$$nestedInanon$5$$$anonfun$tabBarIcon$2__Lshowcase_app_ShowcaseRoot$$anon$2$$anon$5__Lscommons_react_navigation_tab_raw_TabBarIconParams__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement(arg$outer$4, arg1$2$1)
        })
      })(this$3$1);
      this$3$1.tabBarIcon = a$2;
      return this$3$1
    })
  })(Object, this)())];
  var $$x10 = $$x14.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2), $m_sci_Nil$());
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var reactClass$3 = $m_Lshowcase_app_ShowcaseRoot$().HomeTab__Lscommons_react_navigation_tab_raw_TabNavigator().Screen;
  var $$x9 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass$3);
  var this$44 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes().name__Lio_github_shogowada_statictags_StringAttributeSpec();
  var $$x8 = new $c_Lio_github_shogowada_statictags_Attribute(this$44.Lio_github_shogowada_statictags_StringAttributeSpec__f_name, "community", $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$());
  $m_Lscommons_react_navigation_package$();
  var attributes$6 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var $$x7 = new $c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes(attributes$6).component__Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenComponentAttributeSpec();
  var this$47 = $m_Lshowcase_app_community_CommunityDemoController$();
  var $$x6 = $$x7.$colon$eq__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass__Lio_github_shogowada_statictags_Attribute(this$47.scommons$react$redux$BaseStateController$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass());
  $m_Lscommons_react_navigation_package$();
  var attributes$7 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array$3 = [$$x8, $$x6, new $c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes(attributes$7).options__Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenOptionsAttributeSpec().$colon$eq__Lscommons_react_navigation_raw_NavigatorScreenOptions__Lio_github_shogowada_statictags_Attribute((function(superClass$$3, arg$outer$5) {
    return (function() {
      var this$4$1 = {};
      this$4$1.tabBarIcon = null;
      var a$3 = (function(arg$outer$6) {
        return (function(arg1$2$2) {
          return $s_Lshowcase_app_ShowcaseRoot$$anon$2$$anon$6__showcase$app$ShowcaseRoot$$nestedInanon$2$$nestedInanon$6$$$anonfun$tabBarIcon$3__Lshowcase_app_ShowcaseRoot$$anon$2$$anon$6__Lscommons_react_navigation_tab_raw_TabBarIconParams__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement(arg$outer$6, arg1$2$2)
        })
      })(this$4$1);
      this$4$1.tabBarIcon = a$3;
      return this$4$1
    })
  })(Object, this)())];
  var $$x5 = $$x9.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3), $m_sci_Nil$());
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var reactClass$4 = $m_Lshowcase_app_ShowcaseRoot$().HomeTab__Lscommons_react_navigation_tab_raw_TabNavigator().Screen;
  var $$x4 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass$4);
  var this$56 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes().name__Lio_github_shogowada_statictags_StringAttributeSpec();
  var $$x3 = new $c_Lio_github_shogowada_statictags_Attribute(this$56.Lio_github_shogowada_statictags_StringAttributeSpec__f_name, "expo", $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$());
  $m_Lscommons_react_navigation_package$();
  var attributes$8 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var $$x2 = new $c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes(attributes$8).component__Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenComponentAttributeSpec();
  var this$59 = $m_Lshowcase_app_expo_ExpoDemoController$();
  var $$x1 = $$x2.$colon$eq__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass__Lio_github_shogowada_statictags_Attribute(this$59.scommons$react$redux$BaseStateController$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass());
  $m_Lscommons_react_navigation_package$();
  var attributes$9 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array$4 = [$$x3, $$x1, new $c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes(attributes$9).options__Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenOptionsAttributeSpec().$colon$eq__Lscommons_react_navigation_raw_NavigatorScreenOptions__Lio_github_shogowada_statictags_Attribute((function(superClass$$4, arg$outer$7) {
    return (function() {
      var this$5$1 = {};
      this$5$1.tabBarIcon = null;
      var a$4 = (function(arg$outer$8) {
        return (function(arg1$2$3) {
          return $s_Lshowcase_app_ShowcaseRoot$$anon$2$$anon$7__showcase$app$ShowcaseRoot$$nestedInanon$2$$nestedInanon$7$$$anonfun$tabBarIcon$4__Lshowcase_app_ShowcaseRoot$$anon$2$$anon$7__Lscommons_react_navigation_tab_raw_TabBarIconParams__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement(arg$outer$8, arg1$2$3)
        })
      })(this$5$1);
      this$5$1.tabBarIcon = a$4;
      return this$5$1
    })
  })(Object, this)())];
  var array$5 = [$$x15, $$x10, $$x5, $$x4.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4), $m_sci_Nil$())];
  return $$x22.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x21, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5))
});
var $d_Lshowcase_app_ShowcaseRoot$$anon$2 = new $TypeData().initClass({
  Lshowcase_app_ShowcaseRoot$$anon$2: 0
}, false, "showcase.app.ShowcaseRoot$$anon$2", {
  Lshowcase_app_ShowcaseRoot$$anon$2: 1,
  O: 1,
  Lscommons_react_FunctionComponent: 1,
  Lscommons_react_UiComponent: 1
});
$c_Lshowcase_app_ShowcaseRoot$$anon$2.prototype.$classData = $d_Lshowcase_app_ShowcaseRoot$$anon$2;
function $p_Lshowcase_app_ShowcaseScreen$__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz) {
  if (((((2 & $thiz.Lshowcase_app_ShowcaseScreen$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lshowcase_app_ShowcaseScreen$__f_scommons$react$UiComponent$$reactClass = $f_Lscommons_react_FunctionComponent__create__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz);
    $thiz.Lshowcase_app_ShowcaseScreen$__f_bitmap$0 = (((2 | $thiz.Lshowcase_app_ShowcaseScreen$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lshowcase_app_ShowcaseScreen$__f_scommons$react$UiComponent$$reactClass
}
function $p_Lshowcase_app_ShowcaseScreen$__demoTaskComp$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz) {
  if (((((1 & $thiz.Lshowcase_app_ShowcaseScreen$__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = new $c_Lshowcase_app_task_DemoTaskController($m_Lshowcase_app_ShowcaseActions$());
    $thiz.Lshowcase_app_ShowcaseScreen$__f_demoTaskComp = this$1.scommons$react$redux$BaseStateController$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass();
    $thiz.Lshowcase_app_ShowcaseScreen$__f_bitmap$0 = (((1 | $thiz.Lshowcase_app_ShowcaseScreen$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lshowcase_app_ShowcaseScreen$__f_demoTaskComp
}
/** @constructor */
function $c_Lshowcase_app_ShowcaseScreen$() {
  this.Lshowcase_app_ShowcaseScreen$__f_demoTaskComp = null;
  this.Lshowcase_app_ShowcaseScreen$__f_scommons$react$UiComponent$$reactClass = null;
  this.Lshowcase_app_ShowcaseScreen$__f_bitmap$0 = 0
}
$c_Lshowcase_app_ShowcaseScreen$.prototype = new $h_O();
$c_Lshowcase_app_ShowcaseScreen$.prototype.constructor = $c_Lshowcase_app_ShowcaseScreen$;
/** @constructor */
function $h_Lshowcase_app_ShowcaseScreen$() {
  /*<skip>*/
}
$h_Lshowcase_app_ShowcaseScreen$.prototype = $c_Lshowcase_app_ShowcaseScreen$.prototype;
$c_Lshowcase_app_ShowcaseScreen$.prototype.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass = (function() {
  return (((((2 & this.Lshowcase_app_ShowcaseScreen$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lshowcase_app_ShowcaseScreen$__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass(this) : this.Lshowcase_app_ShowcaseScreen$__f_scommons$react$UiComponent$$reactClass)
});
$c_Lshowcase_app_ShowcaseScreen$.prototype.render__Lio_github_shogowada_scalajs_reactjs_React$Props__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement = (function(compProps) {
  var props = $as_Lshowcase_app_ShowcaseScreenProps(compProps.wrapped__O());
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var this$1 = $m_Lshowcase_app_ShowcaseListView$();
  var reactClass = this$1.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass();
  var $$x2 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass);
  var $$x1 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes().wrapped__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$WrappedPropsAttributeSpec();
  $m_s_package$();
  var array = [new $c_T2("Styles", "Demo different styles"), new $c_T2("DemoTask", "Demo API tasks"), new $c_T2("UI", "Demo common UI components")];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var array$1 = [$$x1.$colon$eq__O__Lio_github_shogowada_statictags_Attribute(new $c_Lshowcase_app_ShowcaseListViewProps($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems), props.Lshowcase_app_ShowcaseScreenProps__f_navigate))];
  return $$x2.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1), $m_sci_Nil$())
});
$c_Lshowcase_app_ShowcaseScreen$.prototype.demoTaskComp__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass = (function() {
  return (((((1 & this.Lshowcase_app_ShowcaseScreen$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lshowcase_app_ShowcaseScreen$__demoTaskComp$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass(this) : this.Lshowcase_app_ShowcaseScreen$__f_demoTaskComp)
});
$c_Lshowcase_app_ShowcaseScreen$.prototype.getHomeScreens__Lscommons_react_navigation_stack_raw_StackNavigator__sci_Seq = (function(stack) {
  var this$12 = $m_Lshowcase_app_style_StylesScreen$().getStylesStack__Lscommons_react_navigation_stack_raw_StackNavigator__sci_Seq(stack);
  $m_s_package$();
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var reactClass = stack.Screen;
  var $$x2 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass);
  var this$2 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes().name__Lio_github_shogowada_statictags_StringAttributeSpec();
  var $$x1 = new $c_Lio_github_shogowada_statictags_Attribute(this$2.Lio_github_shogowada_statictags_StringAttributeSpec__f_name, "DemoTask", $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$());
  $m_Lscommons_react_navigation_package$();
  var attributes = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array = [$$x1, new $c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes(attributes).component__Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenComponentAttributeSpec().$colon$eq__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass__Lio_github_shogowada_statictags_Attribute(this.demoTaskComp__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass())];
  var array$1 = [$$x2.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array), $m_sci_Nil$())];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  var suffix = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
  var this$13 = $as_sc_IterableOps(this$12.appendedAll__sc_IterableOnce__O(suffix));
  var suffix$1 = $m_Lshowcase_app_ui_UiDemoScreen$().getUiStack__Lscommons_react_navigation_stack_raw_StackNavigator__sci_Seq(stack);
  return $as_sci_Seq(this$13.concat__sc_IterableOnce__O(suffix$1))
});
var $d_Lshowcase_app_ShowcaseScreen$ = new $TypeData().initClass({
  Lshowcase_app_ShowcaseScreen$: 0
}, false, "showcase.app.ShowcaseScreen$", {
  Lshowcase_app_ShowcaseScreen$: 1,
  O: 1,
  Lscommons_react_FunctionComponent: 1,
  Lscommons_react_UiComponent: 1
});
$c_Lshowcase_app_ShowcaseScreen$.prototype.$classData = $d_Lshowcase_app_ShowcaseScreen$;
var $n_Lshowcase_app_ShowcaseScreen$;
function $m_Lshowcase_app_ShowcaseScreen$() {
  if ((!$n_Lshowcase_app_ShowcaseScreen$)) {
    $n_Lshowcase_app_ShowcaseScreen$ = new $c_Lshowcase_app_ShowcaseScreen$()
  };
  return $n_Lshowcase_app_ShowcaseScreen$
}
function $p_Lshowcase_app_community_CommunityDemoController$__scommons$react$redux$BaseStateController$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz) {
  if (((((2 & $thiz.Lshowcase_app_community_CommunityDemoController$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lshowcase_app_community_CommunityDemoController$__f_scommons$react$redux$BaseStateController$$reactClass = $f_Lscommons_react_redux_BaseStateController__scommons$react$redux$BaseStateController$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz);
    $thiz.Lshowcase_app_community_CommunityDemoController$__f_bitmap$0 = (((2 | $thiz.Lshowcase_app_community_CommunityDemoController$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lshowcase_app_community_CommunityDemoController$__f_scommons$react$redux$BaseStateController$$reactClass
}
function $p_Lshowcase_app_community_CommunityDemoController$__uiComponent$lzycompute__Lscommons_react_UiComponent($thiz) {
  if (((((1 & $thiz.Lshowcase_app_community_CommunityDemoController$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lshowcase_app_community_CommunityDemoController$__f_uiComponent = $m_Lshowcase_app_community_CommunityDemoScreen$();
    $thiz.Lshowcase_app_community_CommunityDemoController$__f_bitmap$0 = (((1 | $thiz.Lshowcase_app_community_CommunityDemoController$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lshowcase_app_community_CommunityDemoController$__f_uiComponent
}
/** @constructor */
function $c_Lshowcase_app_community_CommunityDemoController$() {
  this.Lshowcase_app_community_CommunityDemoController$__f_uiComponent = null;
  this.Lshowcase_app_community_CommunityDemoController$__f_scommons$react$redux$BaseStateController$$reactClass = null;
  this.Lshowcase_app_community_CommunityDemoController$__f_bitmap$0 = 0
}
$c_Lshowcase_app_community_CommunityDemoController$.prototype = new $h_O();
$c_Lshowcase_app_community_CommunityDemoController$.prototype.constructor = $c_Lshowcase_app_community_CommunityDemoController$;
/** @constructor */
function $h_Lshowcase_app_community_CommunityDemoController$() {
  /*<skip>*/
}
$h_Lshowcase_app_community_CommunityDemoController$.prototype = $c_Lshowcase_app_community_CommunityDemoController$.prototype;
$c_Lshowcase_app_community_CommunityDemoController$.prototype.mapStateToProps__F1__O__Lio_github_shogowada_scalajs_reactjs_React$Props__O = (function(dispatch, state, props) {
  return $f_Lscommons_reactnative_app_BaseStateAndRouteController__mapStateToProps__F1__O__Lio_github_shogowada_scalajs_reactjs_React$Props__O(this, dispatch, state, props)
});
$c_Lshowcase_app_community_CommunityDemoController$.prototype.scommons$react$redux$BaseStateController$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass = (function() {
  return (((((2 & this.Lshowcase_app_community_CommunityDemoController$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lshowcase_app_community_CommunityDemoController$__scommons$react$redux$BaseStateController$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass(this) : this.Lshowcase_app_community_CommunityDemoController$__f_scommons$react$redux$BaseStateController$$reactClass)
});
$c_Lshowcase_app_community_CommunityDemoController$.prototype.uiComponent__Lscommons_react_UiComponent = (function() {
  return (((((1 & this.Lshowcase_app_community_CommunityDemoController$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lshowcase_app_community_CommunityDemoController$__uiComponent$lzycompute__Lscommons_react_UiComponent(this) : this.Lshowcase_app_community_CommunityDemoController$__f_uiComponent)
});
$c_Lshowcase_app_community_CommunityDemoController$.prototype.mapStateAndRouteToProps__F1__Lshowcase_app_ShowcaseStateDef__Lscommons_react_navigation_Navigation__Lshowcase_app_community_CommunityDemoScreenProps = (function(dispatch, state, nav) {
  return new $c_Lshowcase_app_community_CommunityDemoScreenProps(new $c_sjsr_AnonFunction1((function(this$1, nav$1) {
    return (function(screen$2) {
      var screen = $as_T(screen$2);
      nav$1.navigate__T__V(screen)
    })
  })(this, nav)))
});
$c_Lshowcase_app_community_CommunityDemoController$.prototype.mapStateAndRouteToProps__F1__O__Lscommons_react_navigation_Navigation__O = (function(dispatch, state, nav) {
  return this.mapStateAndRouteToProps__F1__Lshowcase_app_ShowcaseStateDef__Lscommons_react_navigation_Navigation__Lshowcase_app_community_CommunityDemoScreenProps(dispatch, $as_Lshowcase_app_ShowcaseStateDef(state), nav)
});
var $d_Lshowcase_app_community_CommunityDemoController$ = new $TypeData().initClass({
  Lshowcase_app_community_CommunityDemoController$: 0
}, false, "showcase.app.community.CommunityDemoController$", {
  Lshowcase_app_community_CommunityDemoController$: 1,
  O: 1,
  Lscommons_reactnative_app_BaseStateAndRouteController: 1,
  Lscommons_react_redux_BaseStateController: 1
});
$c_Lshowcase_app_community_CommunityDemoController$.prototype.$classData = $d_Lshowcase_app_community_CommunityDemoController$;
var $n_Lshowcase_app_community_CommunityDemoController$;
function $m_Lshowcase_app_community_CommunityDemoController$() {
  if ((!$n_Lshowcase_app_community_CommunityDemoController$)) {
    $n_Lshowcase_app_community_CommunityDemoController$ = new $c_Lshowcase_app_community_CommunityDemoController$()
  };
  return $n_Lshowcase_app_community_CommunityDemoController$
}
function $p_Lshowcase_app_community_CommunityDemoScreen$__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz) {
  if ((!$thiz.Lshowcase_app_community_CommunityDemoScreen$__f_bitmap$0)) {
    $thiz.Lshowcase_app_community_CommunityDemoScreen$__f_scommons$react$UiComponent$$reactClass = $f_Lscommons_react_FunctionComponent__create__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz);
    $thiz.Lshowcase_app_community_CommunityDemoScreen$__f_bitmap$0 = true
  };
  return $thiz.Lshowcase_app_community_CommunityDemoScreen$__f_scommons$react$UiComponent$$reactClass
}
/** @constructor */
function $c_Lshowcase_app_community_CommunityDemoScreen$() {
  this.Lshowcase_app_community_CommunityDemoScreen$__f_scommons$react$UiComponent$$reactClass = null;
  this.Lshowcase_app_community_CommunityDemoScreen$__f_bitmap$0 = false
}
$c_Lshowcase_app_community_CommunityDemoScreen$.prototype = new $h_O();
$c_Lshowcase_app_community_CommunityDemoScreen$.prototype.constructor = $c_Lshowcase_app_community_CommunityDemoScreen$;
/** @constructor */
function $h_Lshowcase_app_community_CommunityDemoScreen$() {
  /*<skip>*/
}
$h_Lshowcase_app_community_CommunityDemoScreen$.prototype = $c_Lshowcase_app_community_CommunityDemoScreen$.prototype;
$c_Lshowcase_app_community_CommunityDemoScreen$.prototype.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass = (function() {
  return ((!this.Lshowcase_app_community_CommunityDemoScreen$__f_bitmap$0) ? $p_Lshowcase_app_community_CommunityDemoScreen$__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass(this) : this.Lshowcase_app_community_CommunityDemoScreen$__f_scommons$react$UiComponent$$reactClass)
});
$c_Lshowcase_app_community_CommunityDemoScreen$.prototype.render__Lio_github_shogowada_scalajs_reactjs_React$Props__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement = (function(compProps) {
  var props = $as_Lshowcase_app_community_CommunityDemoScreenProps(compProps.wrapped__O());
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var this$1 = $m_Lshowcase_app_ShowcaseListView$();
  var reactClass = this$1.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass();
  var $$x2 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass);
  var $$x1 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes().wrapped__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$WrappedPropsAttributeSpec();
  $m_s_package$();
  var array = [new $c_T2("Picker", "Demo Picker component"), new $c_T2("Svg", "Demo Svg components"), new $c_T2("WebView", "Demo WebView components"), new $c_T2("HTMLView", "Demo HTMLView components"), new $c_T2("SyntaxHighlighter", "Demo SyntaxHighlighter components")];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var array$1 = [$$x1.$colon$eq__O__Lio_github_shogowada_statictags_Attribute(new $c_Lshowcase_app_ShowcaseListViewProps($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems), props.Lshowcase_app_community_CommunityDemoScreenProps__f_navigate))];
  return $$x2.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1), $m_sci_Nil$())
});
$c_Lshowcase_app_community_CommunityDemoScreen$.prototype.getCommunityScreens__Lscommons_react_navigation_stack_raw_StackNavigator__sci_Seq = (function(stack) {
  var $$x20 = $m_s_package$().s_package$__f_Seq;
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var reactClass = stack.Screen;
  var $$x19 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass);
  var this$2 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes().name__Lio_github_shogowada_statictags_StringAttributeSpec();
  var $$x18 = new $c_Lio_github_shogowada_statictags_Attribute(this$2.Lio_github_shogowada_statictags_StringAttributeSpec__f_name, "Picker", $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$());
  $m_Lscommons_react_navigation_package$();
  var attributes = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var $$x17 = new $c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes(attributes).component__Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenComponentAttributeSpec();
  var this$5 = $m_Lshowcase_app_community_PickerDemo$();
  var array = [$$x18, $$x17.$colon$eq__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass__Lio_github_shogowada_statictags_Attribute(this$5.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass())];
  var $$x16 = $$x19.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array), $m_sci_Nil$());
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var reactClass$1 = stack.Screen;
  var $$x15 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass$1);
  var this$10 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes().name__Lio_github_shogowada_statictags_StringAttributeSpec();
  var $$x14 = new $c_Lio_github_shogowada_statictags_Attribute(this$10.Lio_github_shogowada_statictags_StringAttributeSpec__f_name, "Svg", $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$());
  $m_Lscommons_react_navigation_package$();
  var attributes$1 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var $$x13 = new $c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes(attributes$1).component__Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenComponentAttributeSpec();
  var this$13 = $m_Lshowcase_app_community_SvgDemo$();
  var array$1 = [$$x14, $$x13.$colon$eq__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass__Lio_github_shogowada_statictags_Attribute(this$13.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass())];
  var $$x12 = $$x15.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1), $m_sci_Nil$());
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var reactClass$2 = stack.Screen;
  var $$x11 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass$2);
  var this$18 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes().name__Lio_github_shogowada_statictags_StringAttributeSpec();
  var $$x10 = new $c_Lio_github_shogowada_statictags_Attribute(this$18.Lio_github_shogowada_statictags_StringAttributeSpec__f_name, "WebView", $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$());
  $m_Lscommons_react_navigation_package$();
  var attributes$2 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var $$x9 = new $c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes(attributes$2).component__Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenComponentAttributeSpec();
  var this$21 = $m_Lshowcase_app_community_WebViewDemo$();
  var array$2 = [$$x10, $$x9.$colon$eq__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass__Lio_github_shogowada_statictags_Attribute(this$21.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass())];
  var $$x8 = $$x11.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2), $m_sci_Nil$());
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var reactClass$3 = stack.Screen;
  var $$x7 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass$3);
  var this$26 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes().name__Lio_github_shogowada_statictags_StringAttributeSpec();
  var $$x6 = new $c_Lio_github_shogowada_statictags_Attribute(this$26.Lio_github_shogowada_statictags_StringAttributeSpec__f_name, "HTMLView", $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$());
  $m_Lscommons_react_navigation_package$();
  var attributes$3 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var $$x5 = new $c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes(attributes$3).component__Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenComponentAttributeSpec();
  var this$29 = $m_Lshowcase_app_community_HTMLViewDemo$();
  var array$3 = [$$x6, $$x5.$colon$eq__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass__Lio_github_shogowada_statictags_Attribute(this$29.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass())];
  var $$x4 = $$x7.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3), $m_sci_Nil$());
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var reactClass$4 = stack.Screen;
  var $$x3 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass$4);
  var this$34 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes().name__Lio_github_shogowada_statictags_StringAttributeSpec();
  var $$x2 = new $c_Lio_github_shogowada_statictags_Attribute(this$34.Lio_github_shogowada_statictags_StringAttributeSpec__f_name, "SyntaxHighlighter", $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$());
  $m_Lscommons_react_navigation_package$();
  var attributes$4 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var $$x1 = new $c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes(attributes$4).component__Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenComponentAttributeSpec();
  var this$37 = $m_Lshowcase_app_community_SyntaxHighlighterDemo$();
  var array$4 = [$$x2, $$x1.$colon$eq__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass__Lio_github_shogowada_statictags_Attribute(this$37.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass())];
  var array$5 = [$$x16, $$x12, $$x8, $$x4, $$x3.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4), $m_sci_Nil$())];
  return $as_sci_Seq($$x20.apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5)))
});
var $d_Lshowcase_app_community_CommunityDemoScreen$ = new $TypeData().initClass({
  Lshowcase_app_community_CommunityDemoScreen$: 0
}, false, "showcase.app.community.CommunityDemoScreen$", {
  Lshowcase_app_community_CommunityDemoScreen$: 1,
  O: 1,
  Lscommons_react_FunctionComponent: 1,
  Lscommons_react_UiComponent: 1
});
$c_Lshowcase_app_community_CommunityDemoScreen$.prototype.$classData = $d_Lshowcase_app_community_CommunityDemoScreen$;
var $n_Lshowcase_app_community_CommunityDemoScreen$;
function $m_Lshowcase_app_community_CommunityDemoScreen$() {
  if ((!$n_Lshowcase_app_community_CommunityDemoScreen$)) {
    $n_Lshowcase_app_community_CommunityDemoScreen$ = new $c_Lshowcase_app_community_CommunityDemoScreen$()
  };
  return $n_Lshowcase_app_community_CommunityDemoScreen$
}
function $p_Lshowcase_app_community_HTMLViewDemo$__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz) {
  if (((((4 & $thiz.Lshowcase_app_community_HTMLViewDemo$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lshowcase_app_community_HTMLViewDemo$__f_scommons$react$UiComponent$$reactClass = $f_Lscommons_react_FunctionComponent__create__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz);
    $thiz.Lshowcase_app_community_HTMLViewDemo$__f_bitmap$0 = (((4 | $thiz.Lshowcase_app_community_HTMLViewDemo$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lshowcase_app_community_HTMLViewDemo$__f_scommons$react$UiComponent$$reactClass
}
function $p_Lshowcase_app_community_HTMLViewDemo$__htmlStyles$lzycompute__sjs_js_Object($thiz) {
  if (((((1 & $thiz.Lshowcase_app_community_HTMLViewDemo$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lshowcase_app_community_HTMLViewDemo$__f_htmlStyles = $m_Lscommons_reactnative_StyleSheet$().create__sjs_js_Object__sjs_js_Object((function(superClass$) {
      return (function() {
        var this$1 = {};
        this$1.h1 = null;
        this$1.h1 = (function(superClass$$1, arg$outer) {
          return (function() {
            var this$2 = {};
            this$2.fontSize = null;
            this$2.color = null;
            this$2.fontSize = 24;
            var a = $m_Lscommons_reactnative_Style$Color$().Lscommons_reactnative_Style$Color$__f_blue;
            this$2.color = a;
            return this$2
          })
        })(Object, this$1)();
        return this$1
      })
    })(Object)());
    $thiz.Lshowcase_app_community_HTMLViewDemo$__f_bitmap$0 = (((1 | $thiz.Lshowcase_app_community_HTMLViewDemo$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lshowcase_app_community_HTMLViewDemo$__f_htmlStyles
}
function $p_Lshowcase_app_community_HTMLViewDemo$__styles$lzycompute__Lshowcase_app_community_HTMLViewDemo$Styles($thiz) {
  if (((((2 & $thiz.Lshowcase_app_community_HTMLViewDemo$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lshowcase_app_community_HTMLViewDemo$__f_styles = $m_Lscommons_reactnative_StyleSheet$().create__sjs_js_Object__sjs_js_Object(new ($a_Lshowcase_app_community_HTMLViewDemo$Styles())());
    $thiz.Lshowcase_app_community_HTMLViewDemo$__f_bitmap$0 = (((2 | $thiz.Lshowcase_app_community_HTMLViewDemo$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lshowcase_app_community_HTMLViewDemo$__f_styles
}
function $p_Lshowcase_app_community_HTMLViewDemo$__getNodeText$1__Lscommons_reactnative_htmlview_raw_HTMLViewNode__s_Option($thiz, node) {
  var $$x1 = $m_sjs_js_ArrayOps$();
  var array = node.children;
  var this$2 = $$x1.headOption$extension__sjs_js_Array__s_Option(array);
  if (this$2.isEmpty__Z()) {
    return $m_s_None$()
  } else {
    var arg1 = this$2.get__O();
    var value = arg1.data;
    return ((value === (void 0)) ? $m_s_None$() : new $c_s_Some(value))
  }
}
/** @constructor */
function $c_Lshowcase_app_community_HTMLViewDemo$() {
  this.Lshowcase_app_community_HTMLViewDemo$__f_htmlStyles = null;
  this.Lshowcase_app_community_HTMLViewDemo$__f_styles = null;
  this.Lshowcase_app_community_HTMLViewDemo$__f_scommons$react$UiComponent$$reactClass = null;
  this.Lshowcase_app_community_HTMLViewDemo$__f_bitmap$0 = 0
}
$c_Lshowcase_app_community_HTMLViewDemo$.prototype = new $h_O();
$c_Lshowcase_app_community_HTMLViewDemo$.prototype.constructor = $c_Lshowcase_app_community_HTMLViewDemo$;
/** @constructor */
function $h_Lshowcase_app_community_HTMLViewDemo$() {
  /*<skip>*/
}
$h_Lshowcase_app_community_HTMLViewDemo$.prototype = $c_Lshowcase_app_community_HTMLViewDemo$.prototype;
$c_Lshowcase_app_community_HTMLViewDemo$.prototype.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass = (function() {
  return (((((4 & this.Lshowcase_app_community_HTMLViewDemo$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lshowcase_app_community_HTMLViewDemo$__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass(this) : this.Lshowcase_app_community_HTMLViewDemo$__f_scommons$react$UiComponent$$reactClass)
});
$c_Lshowcase_app_community_HTMLViewDemo$.prototype.renderNode__Lscommons_reactnative_htmlview_raw_HTMLViewNode__I__sjs_js_Array__sjs_js_$bar__sjs_js_Function2__sjs_js_Any = (function(node, index, siblings, parent, defaultRenderer) {
  var value = node.name;
  var tagName = $as_T(((value === (void 0)) ? "" : value));
  if ((tagName === "custom")) {
    var specialStyle = node.attribs.style;
    var elements = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
    var $$x3 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements).Text__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
    var this$7 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes().key__Lio_github_shogowada_statictags_StringAttributeSpec();
    var value$1 = ("" + index);
    var $$x1 = new $c_Lio_github_shogowada_statictags_Attribute(this$7.Lio_github_shogowada_statictags_StringAttributeSpec__f_name, value$1, $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$());
    var attributes = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
    var array = [$$x1, new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__sjs_js_Array__Lio_github_shogowada_statictags_Attribute([specialStyle, this.styles__Lshowcase_app_community_HTMLViewDemo$Styles().customText])];
    var $$x2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    var this$13 = $p_Lshowcase_app_community_HTMLViewDemo$__getNodeText$1__Lscommons_reactnative_htmlview_raw_HTMLViewNode__s_Option(this, node);
    var str = $as_T((this$13.isEmpty__Z() ? "" : this$13.get__O()));
    var array$1 = [$as_T($moduleDefault($i_entities).decodeHTML(str))];
    return $$x3.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x2, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
  } else {
    return (void 0)
  }
});
$c_Lshowcase_app_community_HTMLViewDemo$.prototype.render__Lio_github_shogowada_scalajs_reactjs_React$Props__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement = (function(props) {
  var this$1 = $m_Lscommons_react_navigation_package$();
  var theme = this$1.native__Lscommons_react_navigation_raw_ReactNavigation().useTheme();
  var attributes = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var $$x1 = new $c_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes(attributes).textComponentProps__Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes$JsObjectAttribute();
  var attrs = (function(superClass$, theme$1$2) {
    return (function() {
      var this$3 = {};
      this$3.style = null;
      var this$4 = $m_Lscommons_react_navigation_package$();
      this$3.style = $f_Lscommons_react_navigation_ReactNavigation__themeTextStyle__Lscommons_react_navigation_raw_Theme__Lscommons_reactnative_TextStyle(this$4, theme$1$2);
      return this$3
    })
  })(Object, theme)();
  var textProps = $$x1.$colon$eq__sjs_js_Object__Lio_github_shogowada_statictags_Attribute(attrs);
  var elements = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x14 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements).View__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var attributes$1 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array = [new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$1).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__Lscommons_reactnative_Style__Lio_github_shogowada_statictags_Attribute(this.styles__Lshowcase_app_community_HTMLViewDemo$Styles().container)];
  var $$x13 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var elements$1 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x12 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements$1).Text__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var this$12 = $m_Lscommons_react_navigation_package$();
  var light = this.styles__Lshowcase_app_community_HTMLViewDemo$Styles().title;
  var this$11 = $m_Lscommons_react_navigation_package$();
  var dark = $f_Lscommons_react_navigation_ReactNavigation__themeTextStyle__Lscommons_react_navigation_raw_Theme__Lscommons_reactnative_TextStyle(this$11, theme);
  var array$1 = [$f_Lscommons_react_navigation_ReactNavigation__themeStyle__Lscommons_reactnative_Style__Lscommons_reactnative_Style__Lscommons_react_navigation_raw_Theme__Lio_github_shogowada_statictags_Attribute(this$12, light, dark, theme)];
  var $$x11 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  var array$2 = ["Simple Html:"];
  var $$x10 = $$x12.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x11, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2));
  var elements$2 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x9 = new $c_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMElements(elements$2).HTMLView__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var this$20 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes().value__Lio_github_shogowada_statictags_ValueAttributeSpec();
  var array$3 = [textProps, new $c_Lio_github_shogowada_statictags_Attribute(this$20.Lio_github_shogowada_statictags_ValueAttributeSpec__f_name, "<h1>Rendered from html!</h1>", $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$())];
  var $$x8 = $$x9.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3), $m_sci_Nil$());
  var elements$3 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x7 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements$3).Text__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var this$27 = $m_Lscommons_react_navigation_package$();
  var light$1 = this.styles__Lshowcase_app_community_HTMLViewDemo$Styles().title;
  var this$26 = $m_Lscommons_react_navigation_package$();
  var dark$1 = $f_Lscommons_react_navigation_ReactNavigation__themeTextStyle__Lscommons_react_navigation_raw_Theme__Lscommons_reactnative_TextStyle(this$26, theme);
  var array$4 = [$f_Lscommons_react_navigation_ReactNavigation__themeStyle__Lscommons_reactnative_Style__Lscommons_reactnative_Style__Lscommons_react_navigation_raw_Theme__Lio_github_shogowada_statictags_Attribute(this$27, light$1, dark$1, theme)];
  var $$x6 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4);
  var array$5 = ["Html with custom styles/tags:"];
  var $$x5 = $$x7.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x6, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5));
  var elements$4 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x4 = new $c_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMElements(elements$4).HTMLView__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var attributes$2 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var $$x3 = new $c_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes(attributes$2).stylesheet__Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes$JsObjectAttribute().$colon$eq__sjs_js_Object__Lio_github_shogowada_statictags_Attribute(this.htmlStyles__sjs_js_Object());
  var attributes$3 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var $$x2 = new $c_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes(attributes$3).renderNode__Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes$RenderNodeAttribute().$colon$eq__sjs_js_Function5__Lio_github_shogowada_statictags_Attribute((function(arg1$2, arg2$2, arg3$2, arg4$2, arg5$2) {
    var arg2 = $uI(arg2$2);
    return $m_Lshowcase_app_community_HTMLViewDemo$().renderNode__Lscommons_reactnative_htmlview_raw_HTMLViewNode__I__sjs_js_Array__sjs_js_$bar__sjs_js_Function2__sjs_js_Any(arg1$2, arg2, arg3$2, arg4$2, arg5$2)
  }));
  var this$40 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes().value__Lio_github_shogowada_statictags_ValueAttributeSpec();
  var value = $m_sc_StringOps$().stripMargin$extension__T__C__T("<h1>Custom style example</h1>\n            |Some custom <b>&lt;tag&gt;</b> style:\n            |<div>\n            |  <custom>Rendered with &lt;custom&gt; tag/style</custom>\n            |</div>\n            |", 124);
  var array$6 = [textProps, $$x3, $$x2, new $c_Lio_github_shogowada_statictags_Attribute(this$40.Lio_github_shogowada_statictags_ValueAttributeSpec__f_name, value, $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$())];
  var array$7 = [$$x10, $$x8, $$x5, $$x4.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6), $m_sci_Nil$())];
  return $$x14.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x13, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7))
});
$c_Lshowcase_app_community_HTMLViewDemo$.prototype.htmlStyles__sjs_js_Object = (function() {
  return (((((1 & this.Lshowcase_app_community_HTMLViewDemo$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lshowcase_app_community_HTMLViewDemo$__htmlStyles$lzycompute__sjs_js_Object(this) : this.Lshowcase_app_community_HTMLViewDemo$__f_htmlStyles)
});
$c_Lshowcase_app_community_HTMLViewDemo$.prototype.styles__Lshowcase_app_community_HTMLViewDemo$Styles = (function() {
  return (((((2 & this.Lshowcase_app_community_HTMLViewDemo$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lshowcase_app_community_HTMLViewDemo$__styles$lzycompute__Lshowcase_app_community_HTMLViewDemo$Styles(this) : this.Lshowcase_app_community_HTMLViewDemo$__f_styles)
});
var $d_Lshowcase_app_community_HTMLViewDemo$ = new $TypeData().initClass({
  Lshowcase_app_community_HTMLViewDemo$: 0
}, false, "showcase.app.community.HTMLViewDemo$", {
  Lshowcase_app_community_HTMLViewDemo$: 1,
  O: 1,
  Lscommons_react_FunctionComponent: 1,
  Lscommons_react_UiComponent: 1
});
$c_Lshowcase_app_community_HTMLViewDemo$.prototype.$classData = $d_Lshowcase_app_community_HTMLViewDemo$;
var $n_Lshowcase_app_community_HTMLViewDemo$;
function $m_Lshowcase_app_community_HTMLViewDemo$() {
  if ((!$n_Lshowcase_app_community_HTMLViewDemo$)) {
    $n_Lshowcase_app_community_HTMLViewDemo$ = new $c_Lshowcase_app_community_HTMLViewDemo$()
  };
  return $n_Lshowcase_app_community_HTMLViewDemo$
}
var $b_Lshowcase_app_community_HTMLViewDemo$Styles;
function $a_Lshowcase_app_community_HTMLViewDemo$Styles() {
  if ((!$b_Lshowcase_app_community_HTMLViewDemo$Styles)) {
    /** @constructor */
    $b_Lshowcase_app_community_HTMLViewDemo$Styles = (function() {
      Object.call(this);
      Object.defineProperty(this, "container", {
        "configurable": true,
        "enumerable": true,
        "writable": true,
        "value": null
      });
      Object.defineProperty(this, "title", {
        "configurable": true,
        "enumerable": true,
        "writable": true,
        "value": null
      });
      Object.defineProperty(this, "customText", {
        "configurable": true,
        "enumerable": true,
        "writable": true,
        "value": null
      });
      this.container = (function(superClass$, arg$outer) {
        return (function() {
          var outer = arg$outer;
          var this\u00f8 = {};
          this\u00f8.flex = null;
          this\u00f8.flex = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(1, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          $s_sr_Statics__releaseFence__V();
          return this\u00f8
        })
      })(Object, this)();
      this.title = (function(superClass$, arg$outer) {
        return (function() {
          var outer = arg$outer;
          var this$2 = {};
          this$2.marginTop = null;
          this$2.marginBottom = null;
          this$2.color = null;
          this$2.marginTop = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(15, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().right__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          this$2.marginBottom = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(5, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().right__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          this$2.color = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($as_T($m_Lscommons_react_navigation_package$().DefaultTheme__Lscommons_react_navigation_raw_Theme().colors.text), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          $s_sr_Statics__releaseFence__V();
          return this$2
        })
      })(Object, this)();
      this.customText = (function(superClass$, arg$outer) {
        return (function() {
          var outer = arg$outer;
          var this$3 = {};
          this$3.backgroundColor = null;
          this$3.color = null;
          this$3.backgroundColor = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($m_Lscommons_reactnative_Style$Color$().yellow__T(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this$3.color = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($m_Lscommons_reactnative_Style$Color$().red__T(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          $s_sr_Statics__releaseFence__V();
          return this$3
        })
      })(Object, this)()
    });
    /** @constructor */
    var $hh_Lshowcase_app_community_HTMLViewDemo$Styles = (function() {
      /*<skip>*/
    });
    $hh_Lshowcase_app_community_HTMLViewDemo$Styles.prototype = Object.prototype;
    $b_Lshowcase_app_community_HTMLViewDemo$Styles.prototype = new $hh_Lshowcase_app_community_HTMLViewDemo$Styles();
    $b_Lshowcase_app_community_HTMLViewDemo$Styles.prototype.constructor = $b_Lshowcase_app_community_HTMLViewDemo$Styles
  };
  return $b_Lshowcase_app_community_HTMLViewDemo$Styles
}
function $p_Lshowcase_app_community_PickerDemo$__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz) {
  if (((((2 & $thiz.Lshowcase_app_community_PickerDemo$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lshowcase_app_community_PickerDemo$__f_scommons$react$UiComponent$$reactClass = $f_Lscommons_react_FunctionComponent__create__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz);
    $thiz.Lshowcase_app_community_PickerDemo$__f_bitmap$0 = (((2 | $thiz.Lshowcase_app_community_PickerDemo$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lshowcase_app_community_PickerDemo$__f_scommons$react$UiComponent$$reactClass
}
function $p_Lshowcase_app_community_PickerDemo$__styles$lzycompute__Lshowcase_app_community_PickerDemo$Styles($thiz) {
  if (((((1 & $thiz.Lshowcase_app_community_PickerDemo$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lshowcase_app_community_PickerDemo$__f_styles = $m_Lscommons_reactnative_StyleSheet$().create__sjs_js_Object__sjs_js_Object(new ($a_Lshowcase_app_community_PickerDemo$Styles())());
    $thiz.Lshowcase_app_community_PickerDemo$__f_bitmap$0 = (((1 | $thiz.Lshowcase_app_community_PickerDemo$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lshowcase_app_community_PickerDemo$__f_styles
}
/** @constructor */
function $c_Lshowcase_app_community_PickerDemo$() {
  this.Lshowcase_app_community_PickerDemo$__f_styles = null;
  this.Lshowcase_app_community_PickerDemo$__f_scommons$react$UiComponent$$reactClass = null;
  this.Lshowcase_app_community_PickerDemo$__f_bitmap$0 = 0
}
$c_Lshowcase_app_community_PickerDemo$.prototype = new $h_O();
$c_Lshowcase_app_community_PickerDemo$.prototype.constructor = $c_Lshowcase_app_community_PickerDemo$;
/** @constructor */
function $h_Lshowcase_app_community_PickerDemo$() {
  /*<skip>*/
}
$h_Lshowcase_app_community_PickerDemo$.prototype = $c_Lshowcase_app_community_PickerDemo$.prototype;
$c_Lshowcase_app_community_PickerDemo$.prototype.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass = (function() {
  return (((((2 & this.Lshowcase_app_community_PickerDemo$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lshowcase_app_community_PickerDemo$__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass(this) : this.Lshowcase_app_community_PickerDemo$__f_scommons$react$UiComponent$$reactClass)
});
$c_Lshowcase_app_community_PickerDemo$.prototype.render__Lio_github_shogowada_scalajs_reactjs_React$Props__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement = (function(props) {
  var this$1 = $m_Lscommons_react_navigation_package$();
  var theme = this$1.native__Lscommons_react_navigation_raw_ReactNavigation().useTheme();
  var this$2 = $m_Lscommons_react_hooks_package$();
  var x1 = $f_Lscommons_react_hooks_UseState__useState__O__T2(this$2, "1");
  if ((x1 === null)) {
    throw new $c_s_MatchError(x1)
  };
  var language = $as_T(x1._1__O());
  var setLanguage = x1._2__O();
  var elements = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x11 = new $c_Lscommons_reactnative_picker_package$PickerVirtualDOMElements(elements).Picker__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var attributes = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var $$x9 = new $c_Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes(attributes).selectedValue__Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes$SelectedValueAttributeSpec().$colon$eq__sjs_js_$bar__Lio_github_shogowada_statictags_Attribute(language);
  var attributes$1 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var $$x8 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$1).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__Lscommons_reactnative_Style__Lio_github_shogowada_statictags_Attribute(this.styles__Lshowcase_app_community_PickerDemo$Styles().picker);
  var attributes$2 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array = [$$x9, $$x8, new $c_Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes(attributes$2).onValueChange__Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes$OnValueChangeAttributeSpec().$colon$eq__sjs_js_Function2__Lio_github_shogowada_statictags_Attribute((function(setLanguage$1) {
    return (function(arg1$2, arg2$2) {
      var arg1 = $as_T(arg1$2);
      var arg2 = $uI(arg2$2);
      $m_Lshowcase_app_community_PickerDemo$().showcase$app$community$PickerDemo$$$anonfun$render$1__T__I__sjs_js_Function1__V(arg1, arg2, setLanguage$1)
    })
  })(setLanguage))];
  var $$x10 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var elements$1 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x7 = new $c_Lscommons_reactnative_picker_package$PickerVirtualDOMElements(elements$1).PickerItem__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var attributes$3 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var this$15 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$3).color__Lio_github_shogowada_statictags_StringAttributeSpec();
  var value = $as_T(theme.colors.primary);
  var $$x6 = new $c_Lio_github_shogowada_statictags_Attribute(this$15.Lio_github_shogowada_statictags_StringAttributeSpec__f_name, value, $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$());
  var this$17 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes().label__Lio_github_shogowada_statictags_StringAttributeSpec();
  var $$x5 = new $c_Lio_github_shogowada_statictags_Attribute(this$17.Lio_github_shogowada_statictags_StringAttributeSpec__f_name, "Java", $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$());
  var this$19 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes().value__Lio_github_shogowada_statictags_ValueAttributeSpec();
  var array$1 = [$$x6, $$x5, new $c_Lio_github_shogowada_statictags_Attribute(this$19.Lio_github_shogowada_statictags_ValueAttributeSpec__f_name, 1, $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$())];
  var $$x4 = $$x7.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1), $m_sci_Nil$());
  var elements$2 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x3 = new $c_Lscommons_reactnative_picker_package$PickerVirtualDOMElements(elements$2).PickerItem__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var attributes$4 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var this$26 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$4).color__Lio_github_shogowada_statictags_StringAttributeSpec();
  var value$1 = $as_T(theme.colors.primary);
  var $$x2 = new $c_Lio_github_shogowada_statictags_Attribute(this$26.Lio_github_shogowada_statictags_StringAttributeSpec__f_name, value$1, $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$());
  var this$28 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes().label__Lio_github_shogowada_statictags_StringAttributeSpec();
  var $$x1 = new $c_Lio_github_shogowada_statictags_Attribute(this$28.Lio_github_shogowada_statictags_StringAttributeSpec__f_name, "JavaScript", $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$());
  var this$30 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes().value__Lio_github_shogowada_statictags_ValueAttributeSpec();
  var array$2 = [$$x2, $$x1, new $c_Lio_github_shogowada_statictags_Attribute(this$30.Lio_github_shogowada_statictags_ValueAttributeSpec__f_name, 2, $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$())];
  var array$3 = [$$x4, $$x3.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2), $m_sci_Nil$())];
  return $$x11.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x10, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))
});
$c_Lshowcase_app_community_PickerDemo$.prototype.styles__Lshowcase_app_community_PickerDemo$Styles = (function() {
  return (((((1 & this.Lshowcase_app_community_PickerDemo$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lshowcase_app_community_PickerDemo$__styles$lzycompute__Lshowcase_app_community_PickerDemo$Styles(this) : this.Lshowcase_app_community_PickerDemo$__f_styles)
});
$c_Lshowcase_app_community_PickerDemo$.prototype.showcase$app$community$PickerDemo$$$anonfun$render$1__T__I__sjs_js_Function1__V = (function(itemValue, itemIndex, setLanguage$1) {
  setLanguage$1(itemValue)
});
var $d_Lshowcase_app_community_PickerDemo$ = new $TypeData().initClass({
  Lshowcase_app_community_PickerDemo$: 0
}, false, "showcase.app.community.PickerDemo$", {
  Lshowcase_app_community_PickerDemo$: 1,
  O: 1,
  Lscommons_react_FunctionComponent: 1,
  Lscommons_react_UiComponent: 1
});
$c_Lshowcase_app_community_PickerDemo$.prototype.$classData = $d_Lshowcase_app_community_PickerDemo$;
var $n_Lshowcase_app_community_PickerDemo$;
function $m_Lshowcase_app_community_PickerDemo$() {
  if ((!$n_Lshowcase_app_community_PickerDemo$)) {
    $n_Lshowcase_app_community_PickerDemo$ = new $c_Lshowcase_app_community_PickerDemo$()
  };
  return $n_Lshowcase_app_community_PickerDemo$
}
var $b_Lshowcase_app_community_PickerDemo$Styles;
function $a_Lshowcase_app_community_PickerDemo$Styles() {
  if ((!$b_Lshowcase_app_community_PickerDemo$Styles)) {
    /** @constructor */
    $b_Lshowcase_app_community_PickerDemo$Styles = (function() {
      Object.call(this);
      Object.defineProperty(this, "picker", {
        "configurable": true,
        "enumerable": true,
        "writable": true,
        "value": null
      });
      this.picker = (function(superClass$, arg$outer) {
        return (function() {
          var outer = arg$outer;
          var this\u00f8 = {};
          this\u00f8.height = null;
          this\u00f8.width = null;
          this\u00f8.height = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(50, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().right__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          this\u00f8.width = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar("100%", $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          $s_sr_Statics__releaseFence__V();
          return this\u00f8
        })
      })(Object, this)()
    });
    /** @constructor */
    var $hh_Lshowcase_app_community_PickerDemo$Styles = (function() {
      /*<skip>*/
    });
    $hh_Lshowcase_app_community_PickerDemo$Styles.prototype = Object.prototype;
    $b_Lshowcase_app_community_PickerDemo$Styles.prototype = new $hh_Lshowcase_app_community_PickerDemo$Styles();
    $b_Lshowcase_app_community_PickerDemo$Styles.prototype.constructor = $b_Lshowcase_app_community_PickerDemo$Styles
  };
  return $b_Lshowcase_app_community_PickerDemo$Styles
}
function $p_Lshowcase_app_community_SvgCssDemo$__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz) {
  if ((!$thiz.Lshowcase_app_community_SvgCssDemo$__f_bitmap$0)) {
    $thiz.Lshowcase_app_community_SvgCssDemo$__f_scommons$react$UiComponent$$reactClass = $f_Lscommons_react_FunctionComponent__create__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz);
    $thiz.Lshowcase_app_community_SvgCssDemo$__f_bitmap$0 = true
  };
  return $thiz.Lshowcase_app_community_SvgCssDemo$__f_scommons$react$UiComponent$$reactClass
}
/** @constructor */
function $c_Lshowcase_app_community_SvgCssDemo$() {
  this.Lshowcase_app_community_SvgCssDemo$__f_xml = null;
  this.Lshowcase_app_community_SvgCssDemo$__f_scommons$react$UiComponent$$reactClass = null;
  this.Lshowcase_app_community_SvgCssDemo$__f_bitmap$0 = false;
  $n_Lshowcase_app_community_SvgCssDemo$ = this;
  this.Lshowcase_app_community_SvgCssDemo$__f_xml = $m_sc_StringOps$().stripMargin$extension__T__C__T("<svg viewBox=\"0 0 32 32\">\n      |  <style>\n      |    .red {\n      |      fill: #ff0000;\n      |    }\n      |  </style>\n      |  <rect class=\"red\" x=\"0\" y=\"0\" width=\"32\" height=\"32\" />\n      |</svg>\n      |", 124)
}
$c_Lshowcase_app_community_SvgCssDemo$.prototype = new $h_O();
$c_Lshowcase_app_community_SvgCssDemo$.prototype.constructor = $c_Lshowcase_app_community_SvgCssDemo$;
/** @constructor */
function $h_Lshowcase_app_community_SvgCssDemo$() {
  /*<skip>*/
}
$h_Lshowcase_app_community_SvgCssDemo$.prototype = $c_Lshowcase_app_community_SvgCssDemo$.prototype;
$c_Lshowcase_app_community_SvgCssDemo$.prototype.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass = (function() {
  return ((!this.Lshowcase_app_community_SvgCssDemo$__f_bitmap$0) ? $p_Lshowcase_app_community_SvgCssDemo$__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass(this) : this.Lshowcase_app_community_SvgCssDemo$__f_scommons$react$UiComponent$$reactClass)
});
$c_Lshowcase_app_community_SvgCssDemo$.prototype.render__Lio_github_shogowada_scalajs_reactjs_React$Props__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement = (function(props) {
  var elements = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x5 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements).View__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var $$x4 = $m_sci_Nil$();
  var elements$1 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x3 = new $c_Lscommons_reactnative_svg_package$SvgVirtualDOMElements(elements$1).SvgCss__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var attributes = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var this$4 = new $c_Lscommons_reactnative_svg_package$SvgVirtualDOMAttributes(attributes).xml__Lio_github_shogowada_statictags_StringAttributeSpec();
  var value = this.Lshowcase_app_community_SvgCssDemo$__f_xml;
  var $$x2 = new $c_Lio_github_shogowada_statictags_Attribute(this$4.Lio_github_shogowada_statictags_StringAttributeSpec__f_name, value, $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$());
  var this$6 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes().width__Lio_github_shogowada_statictags_IntegerAttributeSpec();
  var $$x1 = new $c_Lio_github_shogowada_statictags_Attribute(this$6.Lio_github_shogowada_statictags_IntegerAttributeSpec__f_name, 32, $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$());
  var this$8 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes().height__Lio_github_shogowada_statictags_IntegerAttributeSpec();
  var array = [$$x2, $$x1, new $c_Lio_github_shogowada_statictags_Attribute(this$8.Lio_github_shogowada_statictags_IntegerAttributeSpec__f_name, 32, $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$())];
  var array$1 = [$$x3.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array), $m_sci_Nil$())];
  return $$x5.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x4, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
});
var $d_Lshowcase_app_community_SvgCssDemo$ = new $TypeData().initClass({
  Lshowcase_app_community_SvgCssDemo$: 0
}, false, "showcase.app.community.SvgCssDemo$", {
  Lshowcase_app_community_SvgCssDemo$: 1,
  O: 1,
  Lscommons_react_FunctionComponent: 1,
  Lscommons_react_UiComponent: 1
});
$c_Lshowcase_app_community_SvgCssDemo$.prototype.$classData = $d_Lshowcase_app_community_SvgCssDemo$;
var $n_Lshowcase_app_community_SvgCssDemo$;
function $m_Lshowcase_app_community_SvgCssDemo$() {
  if ((!$n_Lshowcase_app_community_SvgCssDemo$)) {
    $n_Lshowcase_app_community_SvgCssDemo$ = new $c_Lshowcase_app_community_SvgCssDemo$()
  };
  return $n_Lshowcase_app_community_SvgCssDemo$
}
function $p_Lshowcase_app_community_SvgDemo$__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz) {
  if (((((2 & $thiz.Lshowcase_app_community_SvgDemo$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lshowcase_app_community_SvgDemo$__f_scommons$react$UiComponent$$reactClass = $f_Lscommons_react_FunctionComponent__create__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz);
    $thiz.Lshowcase_app_community_SvgDemo$__f_bitmap$0 = (((2 | $thiz.Lshowcase_app_community_SvgDemo$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lshowcase_app_community_SvgDemo$__f_scommons$react$UiComponent$$reactClass
}
function $p_Lshowcase_app_community_SvgDemo$__styles$lzycompute__Lshowcase_app_community_SvgDemo$Styles($thiz) {
  if (((((1 & $thiz.Lshowcase_app_community_SvgDemo$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lshowcase_app_community_SvgDemo$__f_styles = $m_Lscommons_reactnative_StyleSheet$().create__sjs_js_Object__sjs_js_Object(new ($a_Lshowcase_app_community_SvgDemo$Styles())());
    $thiz.Lshowcase_app_community_SvgDemo$__f_bitmap$0 = (((1 | $thiz.Lshowcase_app_community_SvgDemo$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lshowcase_app_community_SvgDemo$__f_styles
}
/** @constructor */
function $c_Lshowcase_app_community_SvgDemo$() {
  this.Lshowcase_app_community_SvgDemo$__f_styles = null;
  this.Lshowcase_app_community_SvgDemo$__f_svgXmlDemoComp = null;
  this.Lshowcase_app_community_SvgDemo$__f_svgCssDemoComp = null;
  this.Lshowcase_app_community_SvgDemo$__f_scommons$react$UiComponent$$reactClass = null;
  this.Lshowcase_app_community_SvgDemo$__f_bitmap$0 = 0;
  $n_Lshowcase_app_community_SvgDemo$ = this;
  this.Lshowcase_app_community_SvgDemo$__f_svgXmlDemoComp = $m_Lshowcase_app_community_SvgXmlDemo$();
  this.Lshowcase_app_community_SvgDemo$__f_svgCssDemoComp = $m_Lshowcase_app_community_SvgCssDemo$()
}
$c_Lshowcase_app_community_SvgDemo$.prototype = new $h_O();
$c_Lshowcase_app_community_SvgDemo$.prototype.constructor = $c_Lshowcase_app_community_SvgDemo$;
/** @constructor */
function $h_Lshowcase_app_community_SvgDemo$() {
  /*<skip>*/
}
$h_Lshowcase_app_community_SvgDemo$.prototype = $c_Lshowcase_app_community_SvgDemo$.prototype;
$c_Lshowcase_app_community_SvgDemo$.prototype.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass = (function() {
  return (((((2 & this.Lshowcase_app_community_SvgDemo$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lshowcase_app_community_SvgDemo$__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass(this) : this.Lshowcase_app_community_SvgDemo$__f_scommons$react$UiComponent$$reactClass)
});
$c_Lshowcase_app_community_SvgDemo$.prototype.render__Lio_github_shogowada_scalajs_reactjs_React$Props__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement = (function(props) {
  var this$1 = $m_Lscommons_react_navigation_package$();
  var theme = this$1.native__Lscommons_react_navigation_raw_ReactNavigation().useTheme();
  var elements = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x9 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements).View__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var attributes = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array = [new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__Lscommons_reactnative_Style__Lio_github_shogowada_statictags_Attribute(this.styles__Lshowcase_app_community_SvgDemo$Styles().container)];
  var $$x8 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var elements$1 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x7 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements$1).Text__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var this$9 = $m_Lscommons_react_navigation_package$();
  var light = this.styles__Lshowcase_app_community_SvgDemo$Styles().title;
  var this$8 = $m_Lscommons_react_navigation_package$();
  var dark = $f_Lscommons_react_navigation_ReactNavigation__themeTextStyle__Lscommons_react_navigation_raw_Theme__Lscommons_reactnative_TextStyle(this$8, theme);
  var array$1 = [$f_Lscommons_react_navigation_ReactNavigation__themeStyle__Lscommons_reactnative_Style__Lscommons_reactnative_Style__Lscommons_react_navigation_raw_Theme__Lio_github_shogowada_statictags_Attribute(this$9, light, dark, theme)];
  var $$x6 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  var array$2 = ["SvgXml:"];
  var $$x5 = $$x7.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x6, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2));
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var this$16 = this.Lshowcase_app_community_SvgDemo$__f_svgXmlDemoComp;
  var reactClass = this$16.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass();
  var $$x4 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass).apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($m_sci_Nil$(), $m_sci_Nil$());
  var elements$2 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x3 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements$2).Text__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var this$20 = $m_Lscommons_react_navigation_package$();
  var light$1 = this.styles__Lshowcase_app_community_SvgDemo$Styles().title;
  var this$19 = $m_Lscommons_react_navigation_package$();
  var dark$1 = $f_Lscommons_react_navigation_ReactNavigation__themeTextStyle__Lscommons_react_navigation_raw_Theme__Lscommons_reactnative_TextStyle(this$19, theme);
  var array$3 = [$f_Lscommons_react_navigation_ReactNavigation__themeStyle__Lscommons_reactnative_Style__Lscommons_reactnative_Style__Lscommons_react_navigation_raw_Theme__Lio_github_shogowada_statictags_Attribute(this$20, light$1, dark$1, theme)];
  var $$x2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3);
  var array$4 = ["SvgCss:"];
  var $$x1 = $$x3.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x2, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4));
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var this$27 = this.Lshowcase_app_community_SvgDemo$__f_svgCssDemoComp;
  var reactClass$1 = this$27.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass();
  var array$5 = [$$x5, $$x4, $$x1, new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass$1).apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($m_sci_Nil$(), $m_sci_Nil$())];
  return $$x9.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x8, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5))
});
$c_Lshowcase_app_community_SvgDemo$.prototype.styles__Lshowcase_app_community_SvgDemo$Styles = (function() {
  return (((((1 & this.Lshowcase_app_community_SvgDemo$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lshowcase_app_community_SvgDemo$__styles$lzycompute__Lshowcase_app_community_SvgDemo$Styles(this) : this.Lshowcase_app_community_SvgDemo$__f_styles)
});
var $d_Lshowcase_app_community_SvgDemo$ = new $TypeData().initClass({
  Lshowcase_app_community_SvgDemo$: 0
}, false, "showcase.app.community.SvgDemo$", {
  Lshowcase_app_community_SvgDemo$: 1,
  O: 1,
  Lscommons_react_FunctionComponent: 1,
  Lscommons_react_UiComponent: 1
});
$c_Lshowcase_app_community_SvgDemo$.prototype.$classData = $d_Lshowcase_app_community_SvgDemo$;
var $n_Lshowcase_app_community_SvgDemo$;
function $m_Lshowcase_app_community_SvgDemo$() {
  if ((!$n_Lshowcase_app_community_SvgDemo$)) {
    $n_Lshowcase_app_community_SvgDemo$ = new $c_Lshowcase_app_community_SvgDemo$()
  };
  return $n_Lshowcase_app_community_SvgDemo$
}
var $b_Lshowcase_app_community_SvgDemo$Styles;
function $a_Lshowcase_app_community_SvgDemo$Styles() {
  if ((!$b_Lshowcase_app_community_SvgDemo$Styles)) {
    /** @constructor */
    $b_Lshowcase_app_community_SvgDemo$Styles = (function() {
      Object.call(this);
      Object.defineProperty(this, "container", {
        "configurable": true,
        "enumerable": true,
        "writable": true,
        "value": null
      });
      Object.defineProperty(this, "title", {
        "configurable": true,
        "enumerable": true,
        "writable": true,
        "value": null
      });
      this.container = (function(superClass$, arg$outer) {
        return (function() {
          var outer = arg$outer;
          var this\u00f8 = {};
          this\u00f8.flex = null;
          this\u00f8.alignItems = null;
          this\u00f8.flex = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(1, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this\u00f8.alignItems = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($m_Lscommons_reactnative_ViewStyle$AlignItems$().center__Lscommons_reactnative_ViewStyle$AlignItems(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          $s_sr_Statics__releaseFence__V();
          return this\u00f8
        })
      })(Object, this)();
      this.title = (function(superClass$, arg$outer) {
        return (function() {
          var outer = arg$outer;
          var this$2 = {};
          this$2.marginTop = null;
          this$2.marginBottom = null;
          this$2.marginTop = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(15, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().right__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          this$2.marginBottom = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(5, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().right__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          $s_sr_Statics__releaseFence__V();
          return this$2
        })
      })(Object, this)()
    });
    /** @constructor */
    var $hh_Lshowcase_app_community_SvgDemo$Styles = (function() {
      /*<skip>*/
    });
    $hh_Lshowcase_app_community_SvgDemo$Styles.prototype = Object.prototype;
    $b_Lshowcase_app_community_SvgDemo$Styles.prototype = new $hh_Lshowcase_app_community_SvgDemo$Styles();
    $b_Lshowcase_app_community_SvgDemo$Styles.prototype.constructor = $b_Lshowcase_app_community_SvgDemo$Styles
  };
  return $b_Lshowcase_app_community_SvgDemo$Styles
}
function $p_Lshowcase_app_community_SvgXmlDemo$__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz) {
  if (((((2 & $thiz.Lshowcase_app_community_SvgXmlDemo$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lshowcase_app_community_SvgXmlDemo$__f_scommons$react$UiComponent$$reactClass = $f_Lscommons_react_FunctionComponent__create__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz);
    $thiz.Lshowcase_app_community_SvgXmlDemo$__f_bitmap$0 = (((2 | $thiz.Lshowcase_app_community_SvgXmlDemo$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lshowcase_app_community_SvgXmlDemo$__f_scommons$react$UiComponent$$reactClass
}
function $p_Lshowcase_app_community_SvgXmlDemo$__styles$lzycompute__Lshowcase_app_community_SvgXmlDemo$Styles($thiz) {
  if (((((1 & $thiz.Lshowcase_app_community_SvgXmlDemo$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lshowcase_app_community_SvgXmlDemo$__f_styles = $m_Lscommons_reactnative_StyleSheet$().create__sjs_js_Object__sjs_js_Object(new ($a_Lshowcase_app_community_SvgXmlDemo$Styles())());
    $thiz.Lshowcase_app_community_SvgXmlDemo$__f_bitmap$0 = (((1 | $thiz.Lshowcase_app_community_SvgXmlDemo$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lshowcase_app_community_SvgXmlDemo$__f_styles
}
/** @constructor */
function $c_Lshowcase_app_community_SvgXmlDemo$() {
  this.Lshowcase_app_community_SvgXmlDemo$__f_styles = null;
  this.Lshowcase_app_community_SvgXmlDemo$__f_xml = null;
  this.Lshowcase_app_community_SvgXmlDemo$__f_scommons$react$UiComponent$$reactClass = null;
  this.Lshowcase_app_community_SvgXmlDemo$__f_bitmap$0 = 0;
  $n_Lshowcase_app_community_SvgXmlDemo$ = this;
  this.Lshowcase_app_community_SvgXmlDemo$__f_xml = $m_sc_StringOps$().stripMargin$extension__T__C__T("<svg width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n      |  <path\n      |    fill-rule=\"evenodd\"\n      |    clip-rule=\"evenodd\"\n      |    fill=\"url(#gradient)\"\n      |    d=\"M4 0C1.79086 0 0 1.79086 0 4V28C0 30.2091 1.79086 32 4 32H28C30.2091 32 32 30.2091 32 28V4C32 1.79086 30.2091 0 28 0H4ZM17 6C17 5.44772 17.4477 5 18 5H20C20.5523 5 21 5.44772 21 6V25C21 25.5523 20.5523 26 20 26H18C17.4477 26 17 25.5523 17 25V6ZM12 11C11.4477 11 11 11.4477 11 12V25C11 25.5523 11.4477 26 12 26H14C14.5523 26 15 25.5523 15 25V12C15 11.4477 14.5523 11 14 11H12ZM6 18C5.44772 18 5 18.4477 5 19V25C5 25.5523 5.44772 26 6 26H8C8.55228 26 9 25.5523 9 25V19C9 18.4477 8.55228 18 8 18H6ZM24 14C23.4477 14 23 14.4477 23 15V25C23 25.5523 23.4477 26 24 26H26C26.5523 26 27 25.5523 27 25V15C27 14.4477 26.5523 14 26 14H24Z\"\n      |  />\n      |  <defs>\n      |    <linearGradient\n      |      id=\"gradient\"\n      |      x1=\"0\"\n      |      y1=\"0\"\n      |      x2=\"8.46631\"\n      |      y2=\"37.3364\"\n      |      gradient-units=\"userSpaceOnUse\">\n      |      <stop offset=\"0\" stop-color=\"#FEA267\" />\n      |      <stop offset=\"1\" stop-color=\"#E75A4C\" />\n      |    </linearGradient>\n      |  </defs>\n      |</svg>\n      |", 124)
}
$c_Lshowcase_app_community_SvgXmlDemo$.prototype = new $h_O();
$c_Lshowcase_app_community_SvgXmlDemo$.prototype.constructor = $c_Lshowcase_app_community_SvgXmlDemo$;
/** @constructor */
function $h_Lshowcase_app_community_SvgXmlDemo$() {
  /*<skip>*/
}
$h_Lshowcase_app_community_SvgXmlDemo$.prototype = $c_Lshowcase_app_community_SvgXmlDemo$.prototype;
$c_Lshowcase_app_community_SvgXmlDemo$.prototype.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass = (function() {
  return (((((2 & this.Lshowcase_app_community_SvgXmlDemo$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lshowcase_app_community_SvgXmlDemo$__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass(this) : this.Lshowcase_app_community_SvgXmlDemo$__f_scommons$react$UiComponent$$reactClass)
});
$c_Lshowcase_app_community_SvgXmlDemo$.prototype.render__Lio_github_shogowada_scalajs_reactjs_React$Props__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement = (function(props) {
  var elements = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x4 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements).View__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var $$x3 = $m_sci_Nil$();
  var elements$1 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x2 = new $c_Lscommons_reactnative_svg_package$SvgVirtualDOMElements(elements$1).SvgXml__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var attributes = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var $$x1 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__Lscommons_reactnative_Style__Lio_github_shogowada_statictags_Attribute(this.styles__Lshowcase_app_community_SvgXmlDemo$Styles().svg);
  var attributes$1 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var this$5 = new $c_Lscommons_reactnative_svg_package$SvgVirtualDOMAttributes(attributes$1).xml__Lio_github_shogowada_statictags_StringAttributeSpec();
  var value = this.Lshowcase_app_community_SvgXmlDemo$__f_xml;
  var array = [$$x1, new $c_Lio_github_shogowada_statictags_Attribute(this$5.Lio_github_shogowada_statictags_StringAttributeSpec__f_name, value, $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$())];
  var array$1 = [$$x2.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array), $m_sci_Nil$())];
  return $$x4.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x3, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
});
$c_Lshowcase_app_community_SvgXmlDemo$.prototype.styles__Lshowcase_app_community_SvgXmlDemo$Styles = (function() {
  return (((((1 & this.Lshowcase_app_community_SvgXmlDemo$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lshowcase_app_community_SvgXmlDemo$__styles$lzycompute__Lshowcase_app_community_SvgXmlDemo$Styles(this) : this.Lshowcase_app_community_SvgXmlDemo$__f_styles)
});
var $d_Lshowcase_app_community_SvgXmlDemo$ = new $TypeData().initClass({
  Lshowcase_app_community_SvgXmlDemo$: 0
}, false, "showcase.app.community.SvgXmlDemo$", {
  Lshowcase_app_community_SvgXmlDemo$: 1,
  O: 1,
  Lscommons_react_FunctionComponent: 1,
  Lscommons_react_UiComponent: 1
});
$c_Lshowcase_app_community_SvgXmlDemo$.prototype.$classData = $d_Lshowcase_app_community_SvgXmlDemo$;
var $n_Lshowcase_app_community_SvgXmlDemo$;
function $m_Lshowcase_app_community_SvgXmlDemo$() {
  if ((!$n_Lshowcase_app_community_SvgXmlDemo$)) {
    $n_Lshowcase_app_community_SvgXmlDemo$ = new $c_Lshowcase_app_community_SvgXmlDemo$()
  };
  return $n_Lshowcase_app_community_SvgXmlDemo$
}
var $b_Lshowcase_app_community_SvgXmlDemo$Styles;
function $a_Lshowcase_app_community_SvgXmlDemo$Styles() {
  if ((!$b_Lshowcase_app_community_SvgXmlDemo$Styles)) {
    /** @constructor */
    $b_Lshowcase_app_community_SvgXmlDemo$Styles = (function() {
      Object.call(this);
      Object.defineProperty(this, "svg", {
        "configurable": true,
        "enumerable": true,
        "writable": true,
        "value": null
      });
      this.svg = (function(superClass$, arg$outer) {
        return (function() {
          var outer = arg$outer;
          var this\u00f8 = {};
          this\u00f8.width = null;
          this\u00f8.height = null;
          this\u00f8.width = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar("100%", $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          this\u00f8.height = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar("100%", $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          $s_sr_Statics__releaseFence__V();
          return this\u00f8
        })
      })(Object, this)()
    });
    /** @constructor */
    var $hh_Lshowcase_app_community_SvgXmlDemo$Styles = (function() {
      /*<skip>*/
    });
    $hh_Lshowcase_app_community_SvgXmlDemo$Styles.prototype = Object.prototype;
    $b_Lshowcase_app_community_SvgXmlDemo$Styles.prototype = new $hh_Lshowcase_app_community_SvgXmlDemo$Styles();
    $b_Lshowcase_app_community_SvgXmlDemo$Styles.prototype.constructor = $b_Lshowcase_app_community_SvgXmlDemo$Styles
  };
  return $b_Lshowcase_app_community_SvgXmlDemo$Styles
}
function $p_Lshowcase_app_community_SyntaxHighlighterDemo$__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz) {
  if (((((2 & $thiz.Lshowcase_app_community_SyntaxHighlighterDemo$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lshowcase_app_community_SyntaxHighlighterDemo$__f_scommons$react$UiComponent$$reactClass = $f_Lscommons_react_FunctionComponent__create__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz);
    $thiz.Lshowcase_app_community_SyntaxHighlighterDemo$__f_bitmap$0 = (((2 | $thiz.Lshowcase_app_community_SyntaxHighlighterDemo$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lshowcase_app_community_SyntaxHighlighterDemo$__f_scommons$react$UiComponent$$reactClass
}
function $p_Lshowcase_app_community_SyntaxHighlighterDemo$__styles$lzycompute__Lshowcase_app_community_SyntaxHighlighterDemo$Styles($thiz) {
  if (((((1 & $thiz.Lshowcase_app_community_SyntaxHighlighterDemo$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lshowcase_app_community_SyntaxHighlighterDemo$__f_styles = $m_Lscommons_reactnative_StyleSheet$().create__sjs_js_Object__sjs_js_Object(new ($a_Lshowcase_app_community_SyntaxHighlighterDemo$Styles())());
    $thiz.Lshowcase_app_community_SyntaxHighlighterDemo$__f_bitmap$0 = (((1 | $thiz.Lshowcase_app_community_SyntaxHighlighterDemo$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lshowcase_app_community_SyntaxHighlighterDemo$__f_styles
}
/** @constructor */
function $c_Lshowcase_app_community_SyntaxHighlighterDemo$() {
  this.Lshowcase_app_community_SyntaxHighlighterDemo$__f_styles = null;
  this.Lshowcase_app_community_SyntaxHighlighterDemo$__f_customStyle = null;
  this.Lshowcase_app_community_SyntaxHighlighterDemo$__f_scommons$react$UiComponent$$reactClass = null;
  this.Lshowcase_app_community_SyntaxHighlighterDemo$__f_bitmap$0 = 0;
  $n_Lshowcase_app_community_SyntaxHighlighterDemo$ = this;
  this.Lshowcase_app_community_SyntaxHighlighterDemo$__f_customStyle = (function(superClass$) {
    return (function() {
      var this$1 = {};
      this$1.padding = 0;
      this$1.margin = 0;
      this$1.padding = 0;
      this$1.margin = 0;
      return this$1
    })
  })(Object)()
}
$c_Lshowcase_app_community_SyntaxHighlighterDemo$.prototype = new $h_O();
$c_Lshowcase_app_community_SyntaxHighlighterDemo$.prototype.constructor = $c_Lshowcase_app_community_SyntaxHighlighterDemo$;
/** @constructor */
function $h_Lshowcase_app_community_SyntaxHighlighterDemo$() {
  /*<skip>*/
}
$h_Lshowcase_app_community_SyntaxHighlighterDemo$.prototype = $c_Lshowcase_app_community_SyntaxHighlighterDemo$.prototype;
$c_Lshowcase_app_community_SyntaxHighlighterDemo$.prototype.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass = (function() {
  return (((((2 & this.Lshowcase_app_community_SyntaxHighlighterDemo$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lshowcase_app_community_SyntaxHighlighterDemo$__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass(this) : this.Lshowcase_app_community_SyntaxHighlighterDemo$__f_scommons$react$UiComponent$$reactClass)
});
$c_Lshowcase_app_community_SyntaxHighlighterDemo$.prototype.renderNode__Lscommons_reactnative_htmlview_raw_HTMLViewNode__I__sjs_js_Array__sjs_js_$bar__sjs_js_Function2__sjs_js_Any = (function(node, index, siblings, parent, defaultRenderer) {
  var value = node.name;
  var tagName = $as_T(((value === (void 0)) ? "" : value));
  if ((tagName === "pre")) {
    var array = node.children;
    _return: {
      var len = $uI(array.length);
      var i = 0;
      while ((i < len)) {
        var arg1 = array[i];
        var value$1 = arg1.name;
        if (((value$1 !== (void 0)) && $m_sr_BoxesRunTime$().equals__O__O__Z("code", value$1))) {
          var idx = i;
          break _return
        };
        i = ((1 + i) | 0)
      };
      var idx = (-1)
    };
    var this$14 = ((idx === (-1)) ? $m_s_None$() : new $c_s_Some(array[idx]));
    if (this$14.isEmpty__Z()) {
      var codeBlock = $m_s_None$()
    } else {
      var arg1$1 = this$14.get__O();
      var $$x1 = $m_sjs_js_ArrayOps$();
      var array$1 = arg1$1.children;
      var this$16 = $$x1.headOption$extension__sjs_js_Array__s_Option(array$1);
      if (this$16.isEmpty__Z()) {
        var codeBlock = $m_s_None$()
      } else {
        var arg1$2 = this$16.get__O();
        var value$2 = arg1$2.data;
        var codeBlock = ((value$2 === (void 0)) ? $m_s_None$() : new $c_s_Some(value$2))
      }
    }
  } else {
    var codeBlock = $m_s_None$()
  };
  if ((codeBlock instanceof $c_s_Some)) {
    var x2 = $as_s_Some(codeBlock);
    var code = $as_T(x2.s_Some__f_value);
    $m_Lscommons_reactnative_highlighter_package$();
    var elements = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
    var $$x11 = new $c_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMElements(elements).SyntaxHighlighter__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
    var this$23 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes().key__Lio_github_shogowada_statictags_StringAttributeSpec();
    var value$3 = ("" + index);
    var $$x9 = new $c_Lio_github_shogowada_statictags_Attribute(this$23.Lio_github_shogowada_statictags_StringAttributeSpec__f_name, value$3, $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$());
    $m_Lscommons_reactnative_highlighter_package$();
    var attributes = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
    var $$x8 = new $c_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes(attributes).PreTag__Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$ReactClassAttribute();
    var elements$1 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
    var $$x7 = $$x8.$colon$eq__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass__Lio_github_shogowada_statictags_Attribute(new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements$1).Text__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec().Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec__f_reactClass);
    $m_Lscommons_reactnative_highlighter_package$();
    var attributes$1 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
    var $$x6 = new $c_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes(attributes$1).CodeTag__Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$ReactClassAttribute();
    var elements$2 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
    var $$x5 = $$x6.$colon$eq__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass__Lio_github_shogowada_statictags_Attribute(new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements$2).Text__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec().Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec__f_reactClass);
    $m_Lscommons_reactnative_highlighter_package$();
    var attributes$2 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
    var $$x4 = new $c_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes(attributes$2).customStyle__Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$CustomStyleAttributeSpec().$colon$eq__sjs_js_Object__Lio_github_shogowada_statictags_Attribute(this.Lshowcase_app_community_SyntaxHighlighterDemo$__f_customStyle);
    $m_Lscommons_reactnative_highlighter_package$();
    var attributes$3 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
    var this$31 = new $c_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes(attributes$3).highlighter__Lio_github_shogowada_statictags_StringAttributeSpec();
    var $$x3 = new $c_Lio_github_shogowada_statictags_Attribute(this$31.Lio_github_shogowada_statictags_StringAttributeSpec__f_name, "hljs", $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$());
    $m_Lscommons_reactnative_highlighter_package$();
    var attributes$4 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
    var $$x2 = new $c_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes(attributes$4).highlighterStyle__Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$HighlighterStyleAttribute();
    var this$34 = $m_Lscommons_reactnative_highlighter_package$().getHighlightJsStyle__T__s_Option("dark");
    var array$2 = [$$x9, $$x7, $$x5, $$x4, $$x3, $$x2.$colon$eq__Lscommons_reactnative_highlighter_raw_HighlighterStyle__Lio_github_shogowada_statictags_Attribute((this$34.isEmpty__Z() ? $m_Lscommons_reactnative_highlighter_package$().Lscommons_reactnative_highlighter_package$__f_HighlightJsStyles.defaultStyle : this$34.get__O()))];
    var $$x10 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
    var str = $f_T__trim__T(code);
    var array$3 = [$as_T($moduleDefault($i_entities).decodeHTML(str))];
    return $$x11.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x10, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))
  } else {
    var x = $m_s_None$();
    if ((x === codeBlock)) {
      return (void 0)
    } else {
      throw new $c_s_MatchError(codeBlock)
    }
  }
});
$c_Lshowcase_app_community_SyntaxHighlighterDemo$.prototype.render__Lio_github_shogowada_scalajs_reactjs_React$Props__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement = (function(props) {
  var this$1 = $m_Lscommons_react_navigation_package$();
  var theme = this$1.native__Lscommons_react_navigation_raw_ReactNavigation().useTheme();
  var elements = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x16 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements).View__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var attributes = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array = [new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__Lscommons_reactnative_Style__Lio_github_shogowada_statictags_Attribute(this.styles__Lshowcase_app_community_SyntaxHighlighterDemo$Styles().container)];
  var $$x15 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var elements$1 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x14 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements$1).Text__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var this$9 = $m_Lscommons_react_navigation_package$();
  var light = this.styles__Lshowcase_app_community_SyntaxHighlighterDemo$Styles().title;
  var this$8 = $m_Lscommons_react_navigation_package$();
  var dark = $f_Lscommons_react_navigation_ReactNavigation__themeTextStyle__Lscommons_react_navigation_raw_Theme__Lscommons_reactnative_TextStyle(this$8, theme);
  var array$1 = [$f_Lscommons_react_navigation_ReactNavigation__themeStyle__Lscommons_reactnative_Style__Lscommons_reactnative_Style__Lscommons_react_navigation_raw_Theme__Lio_github_shogowada_statictags_Attribute(this$9, light, dark, theme)];
  var $$x13 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  var array$2 = ["SyntaxHighlighter:"];
  var $$x12 = $$x14.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x13, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2));
  $m_Lscommons_reactnative_highlighter_package$();
  var elements$2 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x11 = new $c_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMElements(elements$2).SyntaxHighlighter__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  $m_Lscommons_reactnative_highlighter_package$();
  var attributes$1 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var this$18 = new $c_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes(attributes$1).language__Lio_github_shogowada_statictags_StringAttributeSpec();
  var $$x9 = new $c_Lio_github_shogowada_statictags_Attribute(this$18.Lio_github_shogowada_statictags_StringAttributeSpec__f_name, "javascript", $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$());
  $m_Lscommons_reactnative_highlighter_package$();
  var attributes$2 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var this$21 = new $c_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes(attributes$2).highlighter__Lio_github_shogowada_statictags_StringAttributeSpec();
  var $$x8 = new $c_Lio_github_shogowada_statictags_Attribute(this$21.Lio_github_shogowada_statictags_StringAttributeSpec__f_name, "hljs", $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$());
  $m_Lscommons_reactnative_highlighter_package$();
  var attributes$3 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var $$x7 = new $c_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes(attributes$3).highlighterStyle__Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$HighlighterStyleAttribute();
  var this$24 = $m_Lscommons_reactnative_highlighter_package$().getHighlightJsStyle__T__s_Option("github");
  var array$3 = [$$x9, $$x8, $$x7.$colon$eq__Lscommons_reactnative_highlighter_raw_HighlighterStyle__Lio_github_shogowada_statictags_Attribute((this$24.isEmpty__Z() ? $m_Lscommons_reactnative_highlighter_package$().Lscommons_reactnative_highlighter_package$__f_HighlightJsStyles.defaultStyle : this$24.get__O()))];
  var $$x10 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3);
  var array$4 = ["(num) => num + 1"];
  var $$x6 = $$x11.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x10, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4));
  var elements$3 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x5 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements$3).Text__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var this$33 = $m_Lscommons_react_navigation_package$();
  var light$1 = this.styles__Lshowcase_app_community_SyntaxHighlighterDemo$Styles().title;
  var this$32 = $m_Lscommons_react_navigation_package$();
  var dark$1 = $f_Lscommons_react_navigation_ReactNavigation__themeTextStyle__Lscommons_react_navigation_raw_Theme__Lscommons_reactnative_TextStyle(this$32, theme);
  var array$5 = [$f_Lscommons_react_navigation_ReactNavigation__themeStyle__Lscommons_reactnative_Style__Lscommons_reactnative_Style__Lscommons_react_navigation_raw_Theme__Lio_github_shogowada_statictags_Attribute(this$33, light$1, dark$1, theme)];
  var $$x4 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5);
  var array$6 = ["HtmlView with SyntaxHighlighter:"];
  var $$x3 = $$x5.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x4, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6));
  var elements$4 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x2 = new $c_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMElements(elements$4).HTMLView__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var attributes$4 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var $$x1 = new $c_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes(attributes$4).renderNode__Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes$RenderNodeAttribute().$colon$eq__sjs_js_Function5__Lio_github_shogowada_statictags_Attribute((function(arg1$2, arg2$2, arg3$2, arg4$2, arg5$2) {
    var arg2 = $uI(arg2$2);
    $m_Lshowcase_app_community_SyntaxHighlighterDemo$();
    return $m_Lshowcase_app_community_SyntaxHighlighterDemo$().renderNode__Lscommons_reactnative_htmlview_raw_HTMLViewNode__I__sjs_js_Array__sjs_js_$bar__sjs_js_Function2__sjs_js_Any(arg1$2, arg2, arg3$2, arg4$2, arg5$2)
  }));
  var this$45 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes().value__Lio_github_shogowada_statictags_ValueAttributeSpec();
  var value = $m_sc_StringOps$().stripMargin$extension__T__C__T("<pre>\n            |  <code>val test = 1 + 2;</code>\n            |</pre>\n            |", 124);
  var array$7 = [$$x1, new $c_Lio_github_shogowada_statictags_Attribute(this$45.Lio_github_shogowada_statictags_ValueAttributeSpec__f_name, value, $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$())];
  var array$8 = [$$x12, $$x6, $$x3, $$x2.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7), $m_sci_Nil$())];
  return $$x16.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x15, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8))
});
$c_Lshowcase_app_community_SyntaxHighlighterDemo$.prototype.styles__Lshowcase_app_community_SyntaxHighlighterDemo$Styles = (function() {
  return (((((1 & this.Lshowcase_app_community_SyntaxHighlighterDemo$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lshowcase_app_community_SyntaxHighlighterDemo$__styles$lzycompute__Lshowcase_app_community_SyntaxHighlighterDemo$Styles(this) : this.Lshowcase_app_community_SyntaxHighlighterDemo$__f_styles)
});
var $d_Lshowcase_app_community_SyntaxHighlighterDemo$ = new $TypeData().initClass({
  Lshowcase_app_community_SyntaxHighlighterDemo$: 0
}, false, "showcase.app.community.SyntaxHighlighterDemo$", {
  Lshowcase_app_community_SyntaxHighlighterDemo$: 1,
  O: 1,
  Lscommons_react_FunctionComponent: 1,
  Lscommons_react_UiComponent: 1
});
$c_Lshowcase_app_community_SyntaxHighlighterDemo$.prototype.$classData = $d_Lshowcase_app_community_SyntaxHighlighterDemo$;
var $n_Lshowcase_app_community_SyntaxHighlighterDemo$;
function $m_Lshowcase_app_community_SyntaxHighlighterDemo$() {
  if ((!$n_Lshowcase_app_community_SyntaxHighlighterDemo$)) {
    $n_Lshowcase_app_community_SyntaxHighlighterDemo$ = new $c_Lshowcase_app_community_SyntaxHighlighterDemo$()
  };
  return $n_Lshowcase_app_community_SyntaxHighlighterDemo$
}
var $b_Lshowcase_app_community_SyntaxHighlighterDemo$Styles;
function $a_Lshowcase_app_community_SyntaxHighlighterDemo$Styles() {
  if ((!$b_Lshowcase_app_community_SyntaxHighlighterDemo$Styles)) {
    /** @constructor */
    $b_Lshowcase_app_community_SyntaxHighlighterDemo$Styles = (function() {
      Object.call(this);
      Object.defineProperty(this, "container", {
        "configurable": true,
        "enumerable": true,
        "writable": true,
        "value": null
      });
      Object.defineProperty(this, "title", {
        "configurable": true,
        "enumerable": true,
        "writable": true,
        "value": null
      });
      this.container = (function(superClass$, arg$outer) {
        return (function() {
          var outer = arg$outer;
          var this\u00f8 = {};
          $s_sr_Statics__releaseFence__V();
          return this\u00f8
        })
      })(Object, this)();
      this.title = (function(superClass$, arg$outer) {
        return (function() {
          var outer = arg$outer;
          var this$2 = {};
          this$2.marginTop = null;
          this$2.marginBottom = null;
          this$2.marginTop = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(15, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().right__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          this$2.marginBottom = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(5, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().right__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          $s_sr_Statics__releaseFence__V();
          return this$2
        })
      })(Object, this)()
    });
    /** @constructor */
    var $hh_Lshowcase_app_community_SyntaxHighlighterDemo$Styles = (function() {
      /*<skip>*/
    });
    $hh_Lshowcase_app_community_SyntaxHighlighterDemo$Styles.prototype = Object.prototype;
    $b_Lshowcase_app_community_SyntaxHighlighterDemo$Styles.prototype = new $hh_Lshowcase_app_community_SyntaxHighlighterDemo$Styles();
    $b_Lshowcase_app_community_SyntaxHighlighterDemo$Styles.prototype.constructor = $b_Lshowcase_app_community_SyntaxHighlighterDemo$Styles
  };
  return $b_Lshowcase_app_community_SyntaxHighlighterDemo$Styles
}
function $p_Lshowcase_app_community_WebViewDemo$__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz) {
  if (((((2 & $thiz.Lshowcase_app_community_WebViewDemo$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lshowcase_app_community_WebViewDemo$__f_scommons$react$UiComponent$$reactClass = $f_Lscommons_react_FunctionComponent__create__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz);
    $thiz.Lshowcase_app_community_WebViewDemo$__f_bitmap$0 = (((2 | $thiz.Lshowcase_app_community_WebViewDemo$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lshowcase_app_community_WebViewDemo$__f_scommons$react$UiComponent$$reactClass
}
function $p_Lshowcase_app_community_WebViewDemo$__styles$lzycompute__Lshowcase_app_community_WebViewDemo$Styles($thiz) {
  if (((((1 & $thiz.Lshowcase_app_community_WebViewDemo$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lshowcase_app_community_WebViewDemo$__f_styles = $m_Lscommons_reactnative_StyleSheet$().create__sjs_js_Object__sjs_js_Object(new ($a_Lshowcase_app_community_WebViewDemo$Styles())());
    $thiz.Lshowcase_app_community_WebViewDemo$__f_bitmap$0 = (((1 | $thiz.Lshowcase_app_community_WebViewDemo$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lshowcase_app_community_WebViewDemo$__f_styles
}
/** @constructor */
function $c_Lshowcase_app_community_WebViewDemo$() {
  this.Lshowcase_app_community_WebViewDemo$__f_styles = null;
  this.Lshowcase_app_community_WebViewDemo$__f_scommons$react$UiComponent$$reactClass = null;
  this.Lshowcase_app_community_WebViewDemo$__f_bitmap$0 = 0
}
$c_Lshowcase_app_community_WebViewDemo$.prototype = new $h_O();
$c_Lshowcase_app_community_WebViewDemo$.prototype.constructor = $c_Lshowcase_app_community_WebViewDemo$;
/** @constructor */
function $h_Lshowcase_app_community_WebViewDemo$() {
  /*<skip>*/
}
$h_Lshowcase_app_community_WebViewDemo$.prototype = $c_Lshowcase_app_community_WebViewDemo$.prototype;
$c_Lshowcase_app_community_WebViewDemo$.prototype.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass = (function() {
  return (((((2 & this.Lshowcase_app_community_WebViewDemo$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lshowcase_app_community_WebViewDemo$__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass(this) : this.Lshowcase_app_community_WebViewDemo$__f_scommons$react$UiComponent$$reactClass)
});
$c_Lshowcase_app_community_WebViewDemo$.prototype.render__Lio_github_shogowada_scalajs_reactjs_React$Props__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement = (function(props) {
  var this$1 = $m_Lscommons_react_navigation_package$();
  var theme = this$1.native__Lscommons_react_navigation_raw_ReactNavigation().useTheme();
  var elements = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x17 = new $c_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMElements(elements).SafeAreaView__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var attributes = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var $$x15 = new $c_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes(attributes).mode__Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes$ModeAttributeSpec().$colon$eq__Lscommons_reactnative_safearea_SafeArea$SafeAreaMode__Lio_github_shogowada_statictags_Attribute($m_Lscommons_reactnative_safearea_SafeArea$SafeAreaMode$().Lscommons_reactnative_safearea_SafeArea$SafeAreaMode$__f_padding);
  var attributes$1 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var $$x14 = new $c_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes(attributes$1).edges__Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes$EdgesAttributeSpec();
  $m_s_package$();
  var array = [$m_Lscommons_reactnative_safearea_SafeArea$SafeAreaEdge$().Lscommons_reactnative_safearea_SafeArea$SafeAreaEdge$__f_left, $m_Lscommons_reactnative_safearea_SafeArea$SafeAreaEdge$().Lscommons_reactnative_safearea_SafeArea$SafeAreaEdge$__f_bottom, $m_Lscommons_reactnative_safearea_SafeArea$SafeAreaEdge$().Lscommons_reactnative_safearea_SafeArea$SafeAreaEdge$__f_right];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var $$x13 = $$x14.$colon$eq__sci_Seq__Lio_github_shogowada_statictags_Attribute($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems));
  var attributes$2 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array$1 = [$$x15, $$x13, new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$2).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__Lscommons_reactnative_Style__Lio_github_shogowada_statictags_Attribute(this.styles__Lshowcase_app_community_WebViewDemo$Styles().container)];
  var $$x16 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  var elements$1 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x12 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements$1).Text__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var this$15 = $m_Lscommons_react_navigation_package$();
  var light = this.styles__Lshowcase_app_community_WebViewDemo$Styles().title;
  var this$14 = $m_Lscommons_react_navigation_package$();
  var dark = $f_Lscommons_react_navigation_ReactNavigation__themeTextStyle__Lscommons_react_navigation_raw_Theme__Lscommons_reactnative_TextStyle(this$14, theme);
  var array$2 = [$f_Lscommons_react_navigation_ReactNavigation__themeStyle__Lscommons_reactnative_Style__Lscommons_reactnative_Style__Lscommons_react_navigation_raw_Theme__Lio_github_shogowada_statictags_Attribute(this$15, light, dark, theme)];
  var $$x11 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
  var array$3 = ["InlineWeb:"];
  var $$x10 = $$x12.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x11, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3));
  var elements$2 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x9 = new $c_Lscommons_reactnative_webview_package$WebViewVirtualDOMElements(elements$2).WebView__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var attributes$3 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var $$x8 = new $c_Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes(attributes$3).originWhiteList__Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes$OriginWhiteListAttribute();
  var $$x7 = $m_s_package$().s_package$__f_Seq;
  var array$4 = ["*"];
  var $$x6 = $$x8.$colon$eq__sci_Seq__Lio_github_shogowada_statictags_Attribute($as_sci_Seq($$x7.apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4))));
  var attributes$4 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array$5 = [$$x6, new $c_Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes(attributes$4).htmlSource__Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes$HtmlSourceAttribute().$colon$eq__Lscommons_reactnative_webview_raw_HtmlResource__Lio_github_shogowada_statictags_Attribute((function(superClass$) {
    return (function() {
      var this$28 = {};
      this$28.html = null;
      this$28.html = "<h1>Hello world</h1>";
      return this$28
    })
  })(Object)())];
  var $$x5 = $$x9.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5), $m_sci_Nil$());
  var elements$3 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x4 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements$3).Text__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var this$34 = $m_Lscommons_react_navigation_package$();
  var light$1 = this.styles__Lshowcase_app_community_WebViewDemo$Styles().title;
  var this$33 = $m_Lscommons_react_navigation_package$();
  var dark$1 = $f_Lscommons_react_navigation_ReactNavigation__themeTextStyle__Lscommons_react_navigation_raw_Theme__Lscommons_reactnative_TextStyle(this$33, theme);
  var array$6 = [$f_Lscommons_react_navigation_ReactNavigation__themeStyle__Lscommons_reactnative_Style__Lscommons_reactnative_Style__Lscommons_react_navigation_raw_Theme__Lio_github_shogowada_statictags_Attribute(this$34, light$1, dark$1, theme)];
  var $$x3 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6);
  var array$7 = ["WebView:"];
  var $$x2 = $$x4.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x3, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7));
  var elements$4 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x1 = new $c_Lscommons_reactnative_webview_package$WebViewVirtualDOMElements(elements$4).WebView__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var attributes$5 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array$8 = [new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$5).source__Lscommons_reactnative_Image$ImageAttributes$ImageSourceAttributeSpec().$colon$eq__Lscommons_reactnative_raw_UriResource__Lio_github_shogowada_statictags_Attribute((function(superClass$$1) {
    return (function() {
      var this$2$1 = {};
      this$2$1.uri = null;
      this$2$1.uri = "https://scommons.github.io/";
      return this$2$1
    })
  })(Object)())];
  var array$9 = [$$x10, $$x5, $$x2, $$x1.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8), $m_sci_Nil$())];
  return $$x17.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x16, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9))
});
$c_Lshowcase_app_community_WebViewDemo$.prototype.styles__Lshowcase_app_community_WebViewDemo$Styles = (function() {
  return (((((1 & this.Lshowcase_app_community_WebViewDemo$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lshowcase_app_community_WebViewDemo$__styles$lzycompute__Lshowcase_app_community_WebViewDemo$Styles(this) : this.Lshowcase_app_community_WebViewDemo$__f_styles)
});
var $d_Lshowcase_app_community_WebViewDemo$ = new $TypeData().initClass({
  Lshowcase_app_community_WebViewDemo$: 0
}, false, "showcase.app.community.WebViewDemo$", {
  Lshowcase_app_community_WebViewDemo$: 1,
  O: 1,
  Lscommons_react_FunctionComponent: 1,
  Lscommons_react_UiComponent: 1
});
$c_Lshowcase_app_community_WebViewDemo$.prototype.$classData = $d_Lshowcase_app_community_WebViewDemo$;
var $n_Lshowcase_app_community_WebViewDemo$;
function $m_Lshowcase_app_community_WebViewDemo$() {
  if ((!$n_Lshowcase_app_community_WebViewDemo$)) {
    $n_Lshowcase_app_community_WebViewDemo$ = new $c_Lshowcase_app_community_WebViewDemo$()
  };
  return $n_Lshowcase_app_community_WebViewDemo$
}
var $b_Lshowcase_app_community_WebViewDemo$Styles;
function $a_Lshowcase_app_community_WebViewDemo$Styles() {
  if ((!$b_Lshowcase_app_community_WebViewDemo$Styles)) {
    /** @constructor */
    $b_Lshowcase_app_community_WebViewDemo$Styles = (function() {
      Object.call(this);
      Object.defineProperty(this, "container", {
        "configurable": true,
        "enumerable": true,
        "writable": true,
        "value": null
      });
      Object.defineProperty(this, "title", {
        "configurable": true,
        "enumerable": true,
        "writable": true,
        "value": null
      });
      this.container = (function(superClass$, arg$outer) {
        return (function() {
          var outer = arg$outer;
          var this\u00f8 = {};
          this\u00f8.flex = null;
          this\u00f8.flex = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(1, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          $s_sr_Statics__releaseFence__V();
          return this\u00f8
        })
      })(Object, this)();
      this.title = (function(superClass$, arg$outer) {
        return (function() {
          var outer = arg$outer;
          var this$2 = {};
          this$2.marginTop = null;
          this$2.marginBottom = null;
          this$2.marginTop = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(15, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().right__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          this$2.marginBottom = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(5, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().right__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          $s_sr_Statics__releaseFence__V();
          return this$2
        })
      })(Object, this)()
    });
    /** @constructor */
    var $hh_Lshowcase_app_community_WebViewDemo$Styles = (function() {
      /*<skip>*/
    });
    $hh_Lshowcase_app_community_WebViewDemo$Styles.prototype = Object.prototype;
    $b_Lshowcase_app_community_WebViewDemo$Styles.prototype = new $hh_Lshowcase_app_community_WebViewDemo$Styles();
    $b_Lshowcase_app_community_WebViewDemo$Styles.prototype.constructor = $b_Lshowcase_app_community_WebViewDemo$Styles
  };
  return $b_Lshowcase_app_community_WebViewDemo$Styles
}
function $p_Lshowcase_app_expo_AssetDemo$__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz) {
  if (((((2 & $thiz.Lshowcase_app_expo_AssetDemo$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lshowcase_app_expo_AssetDemo$__f_scommons$react$UiComponent$$reactClass = $f_Lscommons_react_FunctionComponent__create__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz);
    $thiz.Lshowcase_app_expo_AssetDemo$__f_bitmap$0 = (((2 | $thiz.Lshowcase_app_expo_AssetDemo$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lshowcase_app_expo_AssetDemo$__f_scommons$react$UiComponent$$reactClass
}
function $p_Lshowcase_app_expo_AssetDemo$__styles$lzycompute__Lshowcase_app_expo_AssetDemo$Styles($thiz) {
  if (((((1 & $thiz.Lshowcase_app_expo_AssetDemo$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lshowcase_app_expo_AssetDemo$__f_styles = $m_Lscommons_reactnative_StyleSheet$().create__sjs_js_Object__sjs_js_Object(new ($a_Lshowcase_app_expo_AssetDemo$Styles())());
    $thiz.Lshowcase_app_expo_AssetDemo$__f_bitmap$0 = (((1 | $thiz.Lshowcase_app_expo_AssetDemo$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lshowcase_app_expo_AssetDemo$__f_styles
}
/** @constructor */
function $c_Lshowcase_app_expo_AssetDemo$() {
  this.Lshowcase_app_expo_AssetDemo$__f_styles = null;
  this.Lshowcase_app_expo_AssetDemo$__f_scommons$react$UiComponent$$reactClass = null;
  this.Lshowcase_app_expo_AssetDemo$__f_bitmap$0 = 0
}
$c_Lshowcase_app_expo_AssetDemo$.prototype = new $h_O();
$c_Lshowcase_app_expo_AssetDemo$.prototype.constructor = $c_Lshowcase_app_expo_AssetDemo$;
/** @constructor */
function $h_Lshowcase_app_expo_AssetDemo$() {
  /*<skip>*/
}
$h_Lshowcase_app_expo_AssetDemo$.prototype = $c_Lshowcase_app_expo_AssetDemo$.prototype;
$c_Lshowcase_app_expo_AssetDemo$.prototype.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass = (function() {
  return (((((2 & this.Lshowcase_app_expo_AssetDemo$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lshowcase_app_expo_AssetDemo$__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass(this) : this.Lshowcase_app_expo_AssetDemo$__f_scommons$react$UiComponent$$reactClass)
});
$c_Lshowcase_app_expo_AssetDemo$.prototype.render__Lio_github_shogowada_scalajs_reactjs_React$Props__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement = (function(props) {
  var this$1 = $m_Lscommons_react_navigation_package$();
  var theme = this$1.native__Lscommons_react_navigation_raw_ReactNavigation().useTheme();
  var this$3 = $m_Lscommons_react_hooks_package$();
  var initialState = $m_s_None$();
  var x1 = $f_Lscommons_react_hooks_UseState__useState__O__T2(this$3, initialState);
  if ((x1 === null)) {
    throw new $c_s_MatchError(x1)
  };
  var maybeAsset = $as_s_Option(x1._1__O());
  var setAsset = x1._2__O();
  var this$11 = $m_Lscommons_react_hooks_package$();
  var didUpdate = new $c_sjsr_AnonFunction0((function(this$4, setAsset$2) {
    return (function() {
      var $$x2 = $m_Lscommons_expo_Asset$();
      var $$x1 = $m_s_package$().s_package$__f_Seq;
      var array = [$i_$002e$002fshowcase$002fapp$002fexpo$002epng];
      $$x2.loadAsync__sci_Seq__s_concurrent_Future($as_sci_Seq($$x1.apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)))).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1((function(this$8, setAsset$1) {
        return (function(x$2$2) {
          var asset = $m_Lscommons_expo_Asset$().fromModule__Lscommons_reactnative_raw_StaticResource__Lscommons_expo_raw_Asset($i_$002e$002fshowcase$002fapp$002fexpo$002epng);
          setAsset$1(new $c_s_Some(asset))
        })
      })(this$4, setAsset$2)), $m_s_concurrent_ExecutionContext$().global__s_concurrent_ExecutionContextExecutor())
    })
  })(this, setAsset));
  var dependencies = $m_s_package$().s_package$__f_Nil;
  $f_Lscommons_react_hooks_UseEffect__useEffect__F0__sci_List__V(this$11, didUpdate, dependencies);
  var elements = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x13 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements).View__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var attributes = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array$1 = [new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__Lscommons_reactnative_Style__Lio_github_shogowada_statictags_Attribute(this.styles__Lshowcase_app_expo_AssetDemo$Styles().container)];
  var $$x12 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  if (maybeAsset.isEmpty__Z()) {
    var $$x3 = $m_s_None$()
  } else {
    var arg1 = maybeAsset.get__O();
    var elements$1 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
    var $$x11 = new $c_Lscommons_react_package$ReactVirtualDOMElements(elements$1).$greater__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
    var $$x10 = $m_sci_Nil$();
    var elements$2 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
    var $$x9 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements$2).Image__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
    var attributes$1 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
    var $$x8 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$1).source__Lscommons_reactnative_Image$ImageAttributes$ImageSourceAttributeSpec().$colon$eq__Lscommons_reactnative_raw_StaticResource__Lio_github_shogowada_statictags_Attribute($i_$002e$002fshowcase$002fapp$002fexpo$002epng);
    var attributes$2 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
    var array$2 = [$$x8, new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$2).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__Lscommons_reactnative_Style__Lio_github_shogowada_statictags_Attribute((function(superClass$, asset$1$2) {
      return (function() {
        var this$21 = {};
        this$21.width = null;
        this$21.height = null;
        var a = asset$1$2.width;
        this$21.width = a;
        var a$1 = asset$1$2.height;
        this$21.height = a$1;
        return this$21
      })
    })(Object, arg1)())];
    var $$x7 = $$x9.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2), $m_sci_Nil$());
    var elements$3 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
    var $$x6 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements$3).Text__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
    var attributes$3 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
    var $$x4 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$3).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec();
    var this$41 = $m_Lscommons_react_navigation_package$();
    var array$3 = [$$x4.$colon$eq__Lscommons_reactnative_Style__Lio_github_shogowada_statictags_Attribute($f_Lscommons_react_navigation_ReactNavigation__themeTextStyle__Lscommons_react_navigation_raw_Theme__Lscommons_reactnative_TextStyle(this$41, theme))];
    var $$x5 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3);
    var x = (((((((("Asset props:\n               |name: " + $as_T(arg1.name)) + "\n               |type: ") + $as_T(arg1.type)) + "\n               |width: ") + arg1.width) + "\n               |height: ") + arg1.height) + "\n               |");
    var array$4 = [$m_sc_StringOps$().stripMargin$extension__T__C__T(x, 124)];
    var array$5 = [$$x7, $$x6.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x5, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4))];
    var $$x3 = new $c_s_Some($$x11.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x10, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5)))
  };
  var array$6 = [$$x3];
  return $$x13.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x12, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6))
});
$c_Lshowcase_app_expo_AssetDemo$.prototype.styles__Lshowcase_app_expo_AssetDemo$Styles = (function() {
  return (((((1 & this.Lshowcase_app_expo_AssetDemo$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lshowcase_app_expo_AssetDemo$__styles$lzycompute__Lshowcase_app_expo_AssetDemo$Styles(this) : this.Lshowcase_app_expo_AssetDemo$__f_styles)
});
var $d_Lshowcase_app_expo_AssetDemo$ = new $TypeData().initClass({
  Lshowcase_app_expo_AssetDemo$: 0
}, false, "showcase.app.expo.AssetDemo$", {
  Lshowcase_app_expo_AssetDemo$: 1,
  O: 1,
  Lscommons_react_FunctionComponent: 1,
  Lscommons_react_UiComponent: 1
});
$c_Lshowcase_app_expo_AssetDemo$.prototype.$classData = $d_Lshowcase_app_expo_AssetDemo$;
var $n_Lshowcase_app_expo_AssetDemo$;
function $m_Lshowcase_app_expo_AssetDemo$() {
  if ((!$n_Lshowcase_app_expo_AssetDemo$)) {
    $n_Lshowcase_app_expo_AssetDemo$ = new $c_Lshowcase_app_expo_AssetDemo$()
  };
  return $n_Lshowcase_app_expo_AssetDemo$
}
var $b_Lshowcase_app_expo_AssetDemo$Styles;
function $a_Lshowcase_app_expo_AssetDemo$Styles() {
  if ((!$b_Lshowcase_app_expo_AssetDemo$Styles)) {
    /** @constructor */
    $b_Lshowcase_app_expo_AssetDemo$Styles = (function() {
      Object.call(this);
      Object.defineProperty(this, "container", {
        "configurable": true,
        "enumerable": true,
        "writable": true,
        "value": null
      });
      this.container = (function(superClass$, arg$outer) {
        return (function() {
          var outer = arg$outer;
          var this\u00f8 = {};
          this\u00f8.flex = null;
          this\u00f8.justifyContent = null;
          this\u00f8.alignItems = null;
          this\u00f8.flex = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(1, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this\u00f8.justifyContent = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($m_Lscommons_reactnative_ViewStyle$JustifyContent$().center__Lscommons_reactnative_ViewStyle$JustifyContent(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this\u00f8.alignItems = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($m_Lscommons_reactnative_ViewStyle$AlignItems$().center__Lscommons_reactnative_ViewStyle$AlignItems(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          $s_sr_Statics__releaseFence__V();
          return this\u00f8
        })
      })(Object, this)()
    });
    /** @constructor */
    var $hh_Lshowcase_app_expo_AssetDemo$Styles = (function() {
      /*<skip>*/
    });
    $hh_Lshowcase_app_expo_AssetDemo$Styles.prototype = Object.prototype;
    $b_Lshowcase_app_expo_AssetDemo$Styles.prototype = new $hh_Lshowcase_app_expo_AssetDemo$Styles();
    $b_Lshowcase_app_expo_AssetDemo$Styles.prototype.constructor = $b_Lshowcase_app_expo_AssetDemo$Styles
  };
  return $b_Lshowcase_app_expo_AssetDemo$Styles
}
function $p_Lshowcase_app_expo_ExpoDemoController$__scommons$react$redux$BaseStateController$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz) {
  if (((((2 & $thiz.Lshowcase_app_expo_ExpoDemoController$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lshowcase_app_expo_ExpoDemoController$__f_scommons$react$redux$BaseStateController$$reactClass = $f_Lscommons_react_redux_BaseStateController__scommons$react$redux$BaseStateController$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz);
    $thiz.Lshowcase_app_expo_ExpoDemoController$__f_bitmap$0 = (((2 | $thiz.Lshowcase_app_expo_ExpoDemoController$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lshowcase_app_expo_ExpoDemoController$__f_scommons$react$redux$BaseStateController$$reactClass
}
function $p_Lshowcase_app_expo_ExpoDemoController$__uiComponent$lzycompute__Lscommons_react_UiComponent($thiz) {
  if (((((1 & $thiz.Lshowcase_app_expo_ExpoDemoController$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lshowcase_app_expo_ExpoDemoController$__f_uiComponent = $m_Lshowcase_app_expo_ExpoDemoScreen$();
    $thiz.Lshowcase_app_expo_ExpoDemoController$__f_bitmap$0 = (((1 | $thiz.Lshowcase_app_expo_ExpoDemoController$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lshowcase_app_expo_ExpoDemoController$__f_uiComponent
}
/** @constructor */
function $c_Lshowcase_app_expo_ExpoDemoController$() {
  this.Lshowcase_app_expo_ExpoDemoController$__f_uiComponent = null;
  this.Lshowcase_app_expo_ExpoDemoController$__f_scommons$react$redux$BaseStateController$$reactClass = null;
  this.Lshowcase_app_expo_ExpoDemoController$__f_bitmap$0 = 0
}
$c_Lshowcase_app_expo_ExpoDemoController$.prototype = new $h_O();
$c_Lshowcase_app_expo_ExpoDemoController$.prototype.constructor = $c_Lshowcase_app_expo_ExpoDemoController$;
/** @constructor */
function $h_Lshowcase_app_expo_ExpoDemoController$() {
  /*<skip>*/
}
$h_Lshowcase_app_expo_ExpoDemoController$.prototype = $c_Lshowcase_app_expo_ExpoDemoController$.prototype;
$c_Lshowcase_app_expo_ExpoDemoController$.prototype.mapStateToProps__F1__O__Lio_github_shogowada_scalajs_reactjs_React$Props__O = (function(dispatch, state, props) {
  return $f_Lscommons_reactnative_app_BaseStateAndRouteController__mapStateToProps__F1__O__Lio_github_shogowada_scalajs_reactjs_React$Props__O(this, dispatch, state, props)
});
$c_Lshowcase_app_expo_ExpoDemoController$.prototype.scommons$react$redux$BaseStateController$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass = (function() {
  return (((((2 & this.Lshowcase_app_expo_ExpoDemoController$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lshowcase_app_expo_ExpoDemoController$__scommons$react$redux$BaseStateController$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass(this) : this.Lshowcase_app_expo_ExpoDemoController$__f_scommons$react$redux$BaseStateController$$reactClass)
});
$c_Lshowcase_app_expo_ExpoDemoController$.prototype.uiComponent__Lscommons_react_UiComponent = (function() {
  return (((((1 & this.Lshowcase_app_expo_ExpoDemoController$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lshowcase_app_expo_ExpoDemoController$__uiComponent$lzycompute__Lscommons_react_UiComponent(this) : this.Lshowcase_app_expo_ExpoDemoController$__f_uiComponent)
});
$c_Lshowcase_app_expo_ExpoDemoController$.prototype.mapStateAndRouteToProps__F1__Lshowcase_app_ShowcaseStateDef__Lscommons_react_navigation_Navigation__Lshowcase_app_expo_ExpoDemoScreenProps = (function(dispatch, state, nav) {
  return new $c_Lshowcase_app_expo_ExpoDemoScreenProps(new $c_sjsr_AnonFunction1((function(this$1, nav$1) {
    return (function(screen$2) {
      var screen = $as_T(screen$2);
      nav$1.navigate__T__V(screen)
    })
  })(this, nav)))
});
$c_Lshowcase_app_expo_ExpoDemoController$.prototype.mapStateAndRouteToProps__F1__O__Lscommons_react_navigation_Navigation__O = (function(dispatch, state, nav) {
  return this.mapStateAndRouteToProps__F1__Lshowcase_app_ShowcaseStateDef__Lscommons_react_navigation_Navigation__Lshowcase_app_expo_ExpoDemoScreenProps(dispatch, $as_Lshowcase_app_ShowcaseStateDef(state), nav)
});
var $d_Lshowcase_app_expo_ExpoDemoController$ = new $TypeData().initClass({
  Lshowcase_app_expo_ExpoDemoController$: 0
}, false, "showcase.app.expo.ExpoDemoController$", {
  Lshowcase_app_expo_ExpoDemoController$: 1,
  O: 1,
  Lscommons_reactnative_app_BaseStateAndRouteController: 1,
  Lscommons_react_redux_BaseStateController: 1
});
$c_Lshowcase_app_expo_ExpoDemoController$.prototype.$classData = $d_Lshowcase_app_expo_ExpoDemoController$;
var $n_Lshowcase_app_expo_ExpoDemoController$;
function $m_Lshowcase_app_expo_ExpoDemoController$() {
  if ((!$n_Lshowcase_app_expo_ExpoDemoController$)) {
    $n_Lshowcase_app_expo_ExpoDemoController$ = new $c_Lshowcase_app_expo_ExpoDemoController$()
  };
  return $n_Lshowcase_app_expo_ExpoDemoController$
}
function $p_Lshowcase_app_expo_ExpoDemoScreen$__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz) {
  if ((!$thiz.Lshowcase_app_expo_ExpoDemoScreen$__f_bitmap$0)) {
    $thiz.Lshowcase_app_expo_ExpoDemoScreen$__f_scommons$react$UiComponent$$reactClass = $f_Lscommons_react_FunctionComponent__create__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz);
    $thiz.Lshowcase_app_expo_ExpoDemoScreen$__f_bitmap$0 = true
  };
  return $thiz.Lshowcase_app_expo_ExpoDemoScreen$__f_scommons$react$UiComponent$$reactClass
}
/** @constructor */
function $c_Lshowcase_app_expo_ExpoDemoScreen$() {
  this.Lshowcase_app_expo_ExpoDemoScreen$__f_scommons$react$UiComponent$$reactClass = null;
  this.Lshowcase_app_expo_ExpoDemoScreen$__f_bitmap$0 = false
}
$c_Lshowcase_app_expo_ExpoDemoScreen$.prototype = new $h_O();
$c_Lshowcase_app_expo_ExpoDemoScreen$.prototype.constructor = $c_Lshowcase_app_expo_ExpoDemoScreen$;
/** @constructor */
function $h_Lshowcase_app_expo_ExpoDemoScreen$() {
  /*<skip>*/
}
$h_Lshowcase_app_expo_ExpoDemoScreen$.prototype = $c_Lshowcase_app_expo_ExpoDemoScreen$.prototype;
$c_Lshowcase_app_expo_ExpoDemoScreen$.prototype.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass = (function() {
  return ((!this.Lshowcase_app_expo_ExpoDemoScreen$__f_bitmap$0) ? $p_Lshowcase_app_expo_ExpoDemoScreen$__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass(this) : this.Lshowcase_app_expo_ExpoDemoScreen$__f_scommons$react$UiComponent$$reactClass)
});
$c_Lshowcase_app_expo_ExpoDemoScreen$.prototype.render__Lio_github_shogowada_scalajs_reactjs_React$Props__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement = (function(compProps) {
  var props = $as_Lshowcase_app_expo_ExpoDemoScreenProps(compProps.wrapped__O());
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var this$1 = $m_Lshowcase_app_ShowcaseListView$();
  var reactClass = this$1.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass();
  var $$x2 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass);
  var $$x1 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes().wrapped__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$WrappedPropsAttributeSpec();
  $m_s_package$();
  var array = [new $c_T2("Asset", "Demo Asset API"), new $c_T2("Font", "Demo Font API"), new $c_T2("Video", "Demo video components"), new $c_T2("SQLite", "Demo SQLite API")];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var array$1 = [$$x1.$colon$eq__O__Lio_github_shogowada_statictags_Attribute(new $c_Lshowcase_app_ShowcaseListViewProps($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems), props.Lshowcase_app_expo_ExpoDemoScreenProps__f_navigate))];
  return $$x2.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1), $m_sci_Nil$())
});
$c_Lshowcase_app_expo_ExpoDemoScreen$.prototype.getExpoScreens__Lscommons_react_navigation_stack_raw_StackNavigator__sci_Seq = (function(stack) {
  var $$x16 = $m_s_package$().s_package$__f_Seq;
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var reactClass = stack.Screen;
  var $$x15 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass);
  var this$2 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes().name__Lio_github_shogowada_statictags_StringAttributeSpec();
  var $$x14 = new $c_Lio_github_shogowada_statictags_Attribute(this$2.Lio_github_shogowada_statictags_StringAttributeSpec__f_name, "Asset", $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$());
  $m_Lscommons_react_navigation_package$();
  var attributes = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var $$x13 = new $c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes(attributes).component__Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenComponentAttributeSpec();
  var this$5 = $m_Lshowcase_app_expo_AssetDemo$();
  var array = [$$x14, $$x13.$colon$eq__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass__Lio_github_shogowada_statictags_Attribute(this$5.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass())];
  var $$x12 = $$x15.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array), $m_sci_Nil$());
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var reactClass$1 = stack.Screen;
  var $$x11 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass$1);
  var this$10 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes().name__Lio_github_shogowada_statictags_StringAttributeSpec();
  var $$x10 = new $c_Lio_github_shogowada_statictags_Attribute(this$10.Lio_github_shogowada_statictags_StringAttributeSpec__f_name, "Font", $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$());
  $m_Lscommons_react_navigation_package$();
  var attributes$1 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var $$x9 = new $c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes(attributes$1).component__Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenComponentAttributeSpec();
  var this$13 = $m_Lshowcase_app_expo_FontDemo$();
  var array$1 = [$$x10, $$x9.$colon$eq__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass__Lio_github_shogowada_statictags_Attribute(this$13.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass())];
  var $$x8 = $$x11.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1), $m_sci_Nil$());
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var reactClass$2 = stack.Screen;
  var $$x7 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass$2);
  var this$18 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes().name__Lio_github_shogowada_statictags_StringAttributeSpec();
  var $$x6 = new $c_Lio_github_shogowada_statictags_Attribute(this$18.Lio_github_shogowada_statictags_StringAttributeSpec__f_name, "Video", $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$());
  $m_Lscommons_react_navigation_package$();
  var attributes$2 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var $$x5 = new $c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes(attributes$2).component__Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenComponentAttributeSpec();
  var this$21 = $m_Lshowcase_app_expo_av_VideoDemo$();
  var array$2 = [$$x6, $$x5.$colon$eq__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass__Lio_github_shogowada_statictags_Attribute(this$21.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass())];
  var $$x4 = $$x7.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2), $m_sci_Nil$());
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var reactClass$3 = stack.Screen;
  var $$x3 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass$3);
  var this$26 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes().name__Lio_github_shogowada_statictags_StringAttributeSpec();
  var $$x2 = new $c_Lio_github_shogowada_statictags_Attribute(this$26.Lio_github_shogowada_statictags_StringAttributeSpec__f_name, "SQLite", $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$());
  $m_Lscommons_react_navigation_package$();
  var attributes$3 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var $$x1 = new $c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes(attributes$3).component__Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenComponentAttributeSpec();
  var this$29 = $m_Lshowcase_app_expo_sqlite_SQLiteDemo$();
  var array$3 = [$$x2, $$x1.$colon$eq__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass__Lio_github_shogowada_statictags_Attribute(this$29.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass())];
  var array$4 = [$$x12, $$x8, $$x4, $$x3.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3), $m_sci_Nil$())];
  return $as_sci_Seq($$x16.apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4)))
});
var $d_Lshowcase_app_expo_ExpoDemoScreen$ = new $TypeData().initClass({
  Lshowcase_app_expo_ExpoDemoScreen$: 0
}, false, "showcase.app.expo.ExpoDemoScreen$", {
  Lshowcase_app_expo_ExpoDemoScreen$: 1,
  O: 1,
  Lscommons_react_FunctionComponent: 1,
  Lscommons_react_UiComponent: 1
});
$c_Lshowcase_app_expo_ExpoDemoScreen$.prototype.$classData = $d_Lshowcase_app_expo_ExpoDemoScreen$;
var $n_Lshowcase_app_expo_ExpoDemoScreen$;
function $m_Lshowcase_app_expo_ExpoDemoScreen$() {
  if ((!$n_Lshowcase_app_expo_ExpoDemoScreen$)) {
    $n_Lshowcase_app_expo_ExpoDemoScreen$ = new $c_Lshowcase_app_expo_ExpoDemoScreen$()
  };
  return $n_Lshowcase_app_expo_ExpoDemoScreen$
}
function $p_Lshowcase_app_expo_FontDemo$__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz) {
  if (((((2 & $thiz.Lshowcase_app_expo_FontDemo$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lshowcase_app_expo_FontDemo$__f_scommons$react$UiComponent$$reactClass = $f_Lscommons_react_FunctionComponent__create__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz);
    $thiz.Lshowcase_app_expo_FontDemo$__f_bitmap$0 = (((2 | $thiz.Lshowcase_app_expo_FontDemo$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lshowcase_app_expo_FontDemo$__f_scommons$react$UiComponent$$reactClass
}
function $p_Lshowcase_app_expo_FontDemo$__styles$lzycompute__Lshowcase_app_expo_FontDemo$Styles($thiz) {
  if (((((1 & $thiz.Lshowcase_app_expo_FontDemo$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lshowcase_app_expo_FontDemo$__f_styles = $m_Lscommons_reactnative_StyleSheet$().create__sjs_js_Object__sjs_js_Object(new ($a_Lshowcase_app_expo_FontDemo$Styles())());
    $thiz.Lshowcase_app_expo_FontDemo$__f_bitmap$0 = (((1 | $thiz.Lshowcase_app_expo_FontDemo$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lshowcase_app_expo_FontDemo$__f_styles
}
/** @constructor */
function $c_Lshowcase_app_expo_FontDemo$() {
  this.Lshowcase_app_expo_FontDemo$__f_styles = null;
  this.Lshowcase_app_expo_FontDemo$__f_scommons$react$UiComponent$$reactClass = null;
  this.Lshowcase_app_expo_FontDemo$__f_bitmap$0 = 0
}
$c_Lshowcase_app_expo_FontDemo$.prototype = new $h_O();
$c_Lshowcase_app_expo_FontDemo$.prototype.constructor = $c_Lshowcase_app_expo_FontDemo$;
/** @constructor */
function $h_Lshowcase_app_expo_FontDemo$() {
  /*<skip>*/
}
$h_Lshowcase_app_expo_FontDemo$.prototype = $c_Lshowcase_app_expo_FontDemo$.prototype;
$c_Lshowcase_app_expo_FontDemo$.prototype.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass = (function() {
  return (((((2 & this.Lshowcase_app_expo_FontDemo$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lshowcase_app_expo_FontDemo$__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass(this) : this.Lshowcase_app_expo_FontDemo$__f_scommons$react$UiComponent$$reactClass)
});
$c_Lshowcase_app_expo_FontDemo$.prototype.render__Lio_github_shogowada_scalajs_reactjs_React$Props__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement = (function(props) {
  var this$1 = $m_Lscommons_react_navigation_package$();
  var theme = this$1.native__Lscommons_react_navigation_raw_ReactNavigation().useTheme();
  var this$3 = $m_Lscommons_react_hooks_package$();
  var initialState = $m_s_None$();
  var x1 = $f_Lscommons_react_hooks_UseState__useState__O__T2(this$3, initialState);
  if ((x1 === null)) {
    throw new $c_s_MatchError(x1)
  };
  var maybeFont = $as_s_Option(x1._1__O());
  var setFont = x1._2__O();
  var this$13 = $m_Lscommons_react_hooks_package$();
  var didUpdate = new $c_sjsr_AnonFunction0((function(this$4, setFont$2) {
    return (function() {
      var $$x2 = $m_Lscommons_expo_Font$();
      var $$x1 = $m_s_package$().s_package$__f_Seq;
      var self = $m_Lshowcase_app_ShowcaseFonts$MontserratBlack$().Lshowcase_app_ShowcaseFonts$MontserratBlack$__f_name;
      var y = $i_$002e$002fshowcase$002fapp$002fMontserrat$002dBlack$002ettf;
      var array = [new $c_T2(self, y)];
      $$x2.loadAsync__sci_Seq__s_concurrent_Future($as_sci_Seq($$x1.apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array)))).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1((function(this$10, setFont$1) {
        return (function(x$2$2) {
          setFont$1(new $c_s_Some($m_Lshowcase_app_ShowcaseFonts$MontserratBlack$().Lshowcase_app_ShowcaseFonts$MontserratBlack$__f_name))
        })
      })(this$4, setFont$2)), $m_s_concurrent_ExecutionContext$().global__s_concurrent_ExecutionContextExecutor())
    })
  })(this, setFont));
  var dependencies = $m_s_package$().s_package$__f_Nil;
  $f_Lscommons_react_hooks_UseEffect__useEffect__F0__sci_List__V(this$13, didUpdate, dependencies);
  var elements = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x7 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements).View__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var attributes = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array$1 = [new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__Lscommons_reactnative_Style__Lio_github_shogowada_statictags_Attribute(this.styles__Lshowcase_app_expo_FontDemo$Styles().container)];
  var $$x6 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  if (maybeFont.isEmpty__Z()) {
    var $$x3 = $m_s_None$()
  } else {
    var arg1 = maybeFont.get__O();
    var font = $as_T(arg1);
    var elements$1 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
    var $$x5 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements$1).Text__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
    var attributes$1 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
    var array$2 = [new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$1).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__Lscommons_reactnative_Style__Lio_github_shogowada_statictags_Attribute((function(superClass$, font$1$2, theme$1$2) {
      return (function() {
        var this$21 = {};
        this$21.fontFamily = null;
        this$21.color = null;
        this$21.fontFamily = font$1$2;
        var a = $as_T(theme$1$2.colors.text);
        this$21.color = a;
        return this$21
      })
    })(Object, font, theme)())];
    var $$x4 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
    var array$3 = [("Font: " + font)];
    var $$x3 = new $c_s_Some($$x5.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x4, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3)))
  };
  var array$4 = [$$x3];
  return $$x7.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x6, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4))
});
$c_Lshowcase_app_expo_FontDemo$.prototype.styles__Lshowcase_app_expo_FontDemo$Styles = (function() {
  return (((((1 & this.Lshowcase_app_expo_FontDemo$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lshowcase_app_expo_FontDemo$__styles$lzycompute__Lshowcase_app_expo_FontDemo$Styles(this) : this.Lshowcase_app_expo_FontDemo$__f_styles)
});
var $d_Lshowcase_app_expo_FontDemo$ = new $TypeData().initClass({
  Lshowcase_app_expo_FontDemo$: 0
}, false, "showcase.app.expo.FontDemo$", {
  Lshowcase_app_expo_FontDemo$: 1,
  O: 1,
  Lscommons_react_FunctionComponent: 1,
  Lscommons_react_UiComponent: 1
});
$c_Lshowcase_app_expo_FontDemo$.prototype.$classData = $d_Lshowcase_app_expo_FontDemo$;
var $n_Lshowcase_app_expo_FontDemo$;
function $m_Lshowcase_app_expo_FontDemo$() {
  if ((!$n_Lshowcase_app_expo_FontDemo$)) {
    $n_Lshowcase_app_expo_FontDemo$ = new $c_Lshowcase_app_expo_FontDemo$()
  };
  return $n_Lshowcase_app_expo_FontDemo$
}
var $b_Lshowcase_app_expo_FontDemo$Styles;
function $a_Lshowcase_app_expo_FontDemo$Styles() {
  if ((!$b_Lshowcase_app_expo_FontDemo$Styles)) {
    /** @constructor */
    $b_Lshowcase_app_expo_FontDemo$Styles = (function() {
      Object.call(this);
      Object.defineProperty(this, "container", {
        "configurable": true,
        "enumerable": true,
        "writable": true,
        "value": null
      });
      this.container = (function(superClass$, arg$outer) {
        return (function() {
          var outer = arg$outer;
          var this\u00f8 = {};
          this\u00f8.flex = null;
          this\u00f8.justifyContent = null;
          this\u00f8.alignItems = null;
          this\u00f8.flex = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(1, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this\u00f8.justifyContent = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($m_Lscommons_reactnative_ViewStyle$JustifyContent$().center__Lscommons_reactnative_ViewStyle$JustifyContent(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this\u00f8.alignItems = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($m_Lscommons_reactnative_ViewStyle$AlignItems$().center__Lscommons_reactnative_ViewStyle$AlignItems(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          $s_sr_Statics__releaseFence__V();
          return this\u00f8
        })
      })(Object, this)()
    });
    /** @constructor */
    var $hh_Lshowcase_app_expo_FontDemo$Styles = (function() {
      /*<skip>*/
    });
    $hh_Lshowcase_app_expo_FontDemo$Styles.prototype = Object.prototype;
    $b_Lshowcase_app_expo_FontDemo$Styles.prototype = new $hh_Lshowcase_app_expo_FontDemo$Styles();
    $b_Lshowcase_app_expo_FontDemo$Styles.prototype.constructor = $b_Lshowcase_app_expo_FontDemo$Styles
  };
  return $b_Lshowcase_app_expo_FontDemo$Styles
}
function $p_Lshowcase_app_expo_av_VideoDemo$__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz) {
  if (((((2 & $thiz.Lshowcase_app_expo_av_VideoDemo$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lshowcase_app_expo_av_VideoDemo$__f_scommons$react$UiComponent$$reactClass = $f_Lscommons_react_FunctionComponent__create__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz);
    $thiz.Lshowcase_app_expo_av_VideoDemo$__f_bitmap$0 = (((2 | $thiz.Lshowcase_app_expo_av_VideoDemo$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lshowcase_app_expo_av_VideoDemo$__f_scommons$react$UiComponent$$reactClass
}
function $p_Lshowcase_app_expo_av_VideoDemo$__styles$lzycompute__Lshowcase_app_expo_av_VideoDemo$Styles($thiz) {
  if (((((1 & $thiz.Lshowcase_app_expo_av_VideoDemo$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lshowcase_app_expo_av_VideoDemo$__f_styles = $m_Lscommons_reactnative_StyleSheet$().create__sjs_js_Object__sjs_js_Object(new ($a_Lshowcase_app_expo_av_VideoDemo$Styles())());
    $thiz.Lshowcase_app_expo_av_VideoDemo$__f_bitmap$0 = (((1 | $thiz.Lshowcase_app_expo_av_VideoDemo$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lshowcase_app_expo_av_VideoDemo$__f_styles
}
/** @constructor */
function $c_Lshowcase_app_expo_av_VideoDemo$() {
  this.Lshowcase_app_expo_av_VideoDemo$__f_styles = null;
  this.Lshowcase_app_expo_av_VideoDemo$__f_scommons$react$UiComponent$$reactClass = null;
  this.Lshowcase_app_expo_av_VideoDemo$__f_bitmap$0 = 0
}
$c_Lshowcase_app_expo_av_VideoDemo$.prototype = new $h_O();
$c_Lshowcase_app_expo_av_VideoDemo$.prototype.constructor = $c_Lshowcase_app_expo_av_VideoDemo$;
/** @constructor */
function $h_Lshowcase_app_expo_av_VideoDemo$() {
  /*<skip>*/
}
$h_Lshowcase_app_expo_av_VideoDemo$.prototype = $c_Lshowcase_app_expo_av_VideoDemo$.prototype;
$c_Lshowcase_app_expo_av_VideoDemo$.prototype.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass = (function() {
  return (((((2 & this.Lshowcase_app_expo_av_VideoDemo$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lshowcase_app_expo_av_VideoDemo$__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass(this) : this.Lshowcase_app_expo_av_VideoDemo$__f_scommons$react$UiComponent$$reactClass)
});
$c_Lshowcase_app_expo_av_VideoDemo$.prototype.render__Lio_github_shogowada_scalajs_reactjs_React$Props__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement = (function(props) {
  var elements = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x6 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements).View__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var attributes = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array = [new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__Lscommons_reactnative_Style__Lio_github_shogowada_statictags_Attribute(this.styles__Lshowcase_app_expo_av_VideoDemo$Styles().container)];
  var $$x5 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var elements$1 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x4 = new $c_Lscommons_expo_av_package$ExpoAVElements(elements$1).Video__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var attributes$1 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var $$x3 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$1).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__Lscommons_reactnative_Style__Lio_github_shogowada_statictags_Attribute(this.styles__Lshowcase_app_expo_av_VideoDemo$Styles().mediaPlayer);
  var attributes$2 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var $$x2 = new $c_Lscommons_expo_av_package$ExpoAVAttributes(attributes$2).expoAVSource__Lscommons_expo_av_package$ExpoAVAttributes$ExpoAVSourceAttributeSpec().$colon$eq__Lscommons_expo_av_raw_ExpoAVSource__Lio_github_shogowada_statictags_Attribute((function(superClass$) {
    return (function() {
      var this$9 = {};
      this$9.uri = null;
      this$9.uri = "http://d23dyxeqlo5psv.cloudfront.net/big_buck_bunny.mp4";
      return this$9
    })
  })(Object)());
  var attributes$3 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var this$14 = new $c_Lscommons_expo_av_package$ExpoAVAttributes(attributes$3).shouldPlay__Lio_github_shogowada_statictags_BooleanAttributeSpec();
  var $$x1 = new $c_Lio_github_shogowada_statictags_Attribute(this$14.Lio_github_shogowada_statictags_BooleanAttributeSpec__f_name, true, $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$());
  var attributes$4 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var this$17 = new $c_Lscommons_expo_av_package$ExpoAVAttributes(attributes$4).useNativeControls__Lio_github_shogowada_statictags_BooleanAttributeSpec();
  var array$1 = [$$x3, $$x2, $$x1, new $c_Lio_github_shogowada_statictags_Attribute(this$17.Lio_github_shogowada_statictags_BooleanAttributeSpec__f_name, true, $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$())];
  var array$2 = [$$x4.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1), $m_sci_Nil$())];
  return $$x6.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x5, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))
});
$c_Lshowcase_app_expo_av_VideoDemo$.prototype.styles__Lshowcase_app_expo_av_VideoDemo$Styles = (function() {
  return (((((1 & this.Lshowcase_app_expo_av_VideoDemo$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lshowcase_app_expo_av_VideoDemo$__styles$lzycompute__Lshowcase_app_expo_av_VideoDemo$Styles(this) : this.Lshowcase_app_expo_av_VideoDemo$__f_styles)
});
var $d_Lshowcase_app_expo_av_VideoDemo$ = new $TypeData().initClass({
  Lshowcase_app_expo_av_VideoDemo$: 0
}, false, "showcase.app.expo.av.VideoDemo$", {
  Lshowcase_app_expo_av_VideoDemo$: 1,
  O: 1,
  Lscommons_react_FunctionComponent: 1,
  Lscommons_react_UiComponent: 1
});
$c_Lshowcase_app_expo_av_VideoDemo$.prototype.$classData = $d_Lshowcase_app_expo_av_VideoDemo$;
var $n_Lshowcase_app_expo_av_VideoDemo$;
function $m_Lshowcase_app_expo_av_VideoDemo$() {
  if ((!$n_Lshowcase_app_expo_av_VideoDemo$)) {
    $n_Lshowcase_app_expo_av_VideoDemo$ = new $c_Lshowcase_app_expo_av_VideoDemo$()
  };
  return $n_Lshowcase_app_expo_av_VideoDemo$
}
var $b_Lshowcase_app_expo_av_VideoDemo$Styles;
function $a_Lshowcase_app_expo_av_VideoDemo$Styles() {
  if ((!$b_Lshowcase_app_expo_av_VideoDemo$Styles)) {
    /** @constructor */
    $b_Lshowcase_app_expo_av_VideoDemo$Styles = (function() {
      Object.call(this);
      Object.defineProperty(this, "container", {
        "configurable": true,
        "enumerable": true,
        "writable": true,
        "value": null
      });
      Object.defineProperty(this, "mediaPlayer", {
        "configurable": true,
        "enumerable": true,
        "writable": true,
        "value": null
      });
      this.container = (function(superClass$, arg$outer) {
        return (function() {
          var outer = arg$outer;
          var this\u00f8 = {};
          this\u00f8.flex = null;
          this\u00f8.flex = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(1, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          $s_sr_Statics__releaseFence__V();
          return this\u00f8
        })
      })(Object, this)();
      this.mediaPlayer = (function(superClass$, arg$outer) {
        return (function() {
          var outer = arg$outer;
          var this$2 = {};
          this$2.position = null;
          this$2.top = null;
          this$2.left = null;
          this$2.bottom = null;
          this$2.right = null;
          this$2.backgroundColor = null;
          this$2.position = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($m_Lscommons_reactnative_Style$Position$().absolute__Lscommons_reactnative_Style$Position(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this$2.top = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(0, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().right__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          this$2.left = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(0, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().right__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          this$2.bottom = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(0, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().right__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          this$2.right = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(0, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().right__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          this$2.backgroundColor = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($m_Lscommons_reactnative_Style$Color$().black__T(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          $s_sr_Statics__releaseFence__V();
          return this$2
        })
      })(Object, this)()
    });
    /** @constructor */
    var $hh_Lshowcase_app_expo_av_VideoDemo$Styles = (function() {
      /*<skip>*/
    });
    $hh_Lshowcase_app_expo_av_VideoDemo$Styles.prototype = Object.prototype;
    $b_Lshowcase_app_expo_av_VideoDemo$Styles.prototype = new $hh_Lshowcase_app_expo_av_VideoDemo$Styles();
    $b_Lshowcase_app_expo_av_VideoDemo$Styles.prototype.constructor = $b_Lshowcase_app_expo_av_VideoDemo$Styles
  };
  return $b_Lshowcase_app_expo_av_VideoDemo$Styles
}
function $p_Lshowcase_app_expo_sqlite_SQLiteDemo$__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz) {
  if ((!$thiz.Lshowcase_app_expo_sqlite_SQLiteDemo$__f_bitmap$0)) {
    $thiz.Lshowcase_app_expo_sqlite_SQLiteDemo$__f_scommons$react$UiComponent$$reactClass = $f_Lscommons_react_FunctionComponent__create__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz);
    $thiz.Lshowcase_app_expo_sqlite_SQLiteDemo$__f_bitmap$0 = true
  };
  return $thiz.Lshowcase_app_expo_sqlite_SQLiteDemo$__f_scommons$react$UiComponent$$reactClass
}
function $p_Lshowcase_app_expo_sqlite_SQLiteDemo$__onSuccess$1__Lscommons_websql_Transaction__scm_ListBuffer__V($thiz, tx, msgLog$1) {
  tx.executeSql__T__sci_Seq__F2__F2__V("select * from emails", $m_s_package$().s_package$__f_Nil, new $c_sjsr_AnonFunction2((function(this$1, msgLog$1$1) {
    return (function(x$2$2, res$2) {
      $as_Lscommons_websql_Transaction(x$2$2);
      var res = $as_Lscommons_websql_ResultSet(res$2);
      var this$2 = res.rows__sci_Seq();
      var msg = ("select: rows: " + this$2.length__I());
      msgLog$1$1.addOne__O__scm_ListBuffer(msg)
    })
  })($thiz, msgLog$1)), new $c_sjsr_AnonFunction2((function(this$2$1, msgLog$1$2) {
    return (function(x$3$2, error$2) {
      $as_Lscommons_websql_Transaction(x$3$2);
      var msg$1 = ("select error: " + error$2);
      msgLog$1$2.addOne__O__scm_ListBuffer(msg$1);
      return true
    })
  })($thiz, msgLog$1)))
}
/** @constructor */
function $c_Lshowcase_app_expo_sqlite_SQLiteDemo$() {
  this.Lshowcase_app_expo_sqlite_SQLiteDemo$__f_scommons$react$UiComponent$$reactClass = null;
  this.Lshowcase_app_expo_sqlite_SQLiteDemo$__f_bitmap$0 = false
}
$c_Lshowcase_app_expo_sqlite_SQLiteDemo$.prototype = new $h_O();
$c_Lshowcase_app_expo_sqlite_SQLiteDemo$.prototype.constructor = $c_Lshowcase_app_expo_sqlite_SQLiteDemo$;
/** @constructor */
function $h_Lshowcase_app_expo_sqlite_SQLiteDemo$() {
  /*<skip>*/
}
$h_Lshowcase_app_expo_sqlite_SQLiteDemo$.prototype = $c_Lshowcase_app_expo_sqlite_SQLiteDemo$.prototype;
$c_Lshowcase_app_expo_sqlite_SQLiteDemo$.prototype.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass = (function() {
  return ((!this.Lshowcase_app_expo_sqlite_SQLiteDemo$__f_bitmap$0) ? $p_Lshowcase_app_expo_sqlite_SQLiteDemo$__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass(this) : this.Lshowcase_app_expo_sqlite_SQLiteDemo$__f_scommons$react$UiComponent$$reactClass)
});
$c_Lshowcase_app_expo_sqlite_SQLiteDemo$.prototype.render__Lio_github_shogowada_scalajs_reactjs_React$Props__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement = (function(props) {
  var this$1 = $m_Lscommons_react_navigation_package$();
  var theme = this$1.native__Lscommons_react_navigation_raw_ReactNavigation().useTheme();
  var this$2 = $m_Lscommons_react_hooks_package$();
  var initialState = $m_s_package$().s_package$__f_Seq.empty__sc_SeqOps();
  var x1 = $f_Lscommons_react_hooks_UseState__useState__O__T2(this$2, initialState);
  if ((x1 === null)) {
    throw new $c_s_MatchError(x1)
  };
  var messages = $as_sci_Seq(x1._1__O());
  var setMessages = x1._2__O();
  var this$19 = $m_Lscommons_react_hooks_package$();
  var didUpdate = new $c_sjsr_AnonFunction0((function(this$3, setMessages$2) {
    return (function() {
      var this$4 = $m_Lscommons_expo_sqlite_SQLite$();
      $f_Lscommons_expo_sqlite_SQLite__openDatabase__T__s_concurrent_Future(this$4, "scommons_showcase.db").foreach__F1__s_concurrent_ExecutionContext__V(new $c_sjsr_AnonFunction1((function(this$5, setMessages$1) {
        return (function(db$2) {
          var db = $as_Lscommons_websql_Database(db$2);
          var msgLog = new $c_scm_ListBuffer();
          msgLog.addOne__O__scm_ListBuffer("DB is opened");
          db.transaction__F1__s_concurrent_Future(new $c_sjsr_AnonFunction1((function(this$6, msgLog$1) {
            return (function(tx$2) {
              var tx = $as_Lscommons_websql_Transaction(tx$2);
              tx.executeSql__T__sci_Seq__F2__F2__V($m_sc_StringOps$().stripMargin$extension__T__C__T("create table if not exists emails (\n              |  id              integer primary key,\n              |  email           text not null,\n              |  created_at      timestamp without time zone default current_timestamp,\n              |  UNIQUE (email)\n              |)\n              |", 124), $m_s_package$().s_package$__f_Nil, null, null);
              var $$x1 = $m_s_package$().s_package$__f_Seq;
              var array = ["email1@test.com"];
              tx.executeSql__T__sci_Seq__F2__F2__V("insert into emails (email) values (?)", $as_sci_Seq($$x1.apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))), new $c_sjsr_AnonFunction2((function(this$13, msgLog$1$1) {
                return (function(tx$2$2, x$4$2) {
                  var tx$2$1 = $as_Lscommons_websql_Transaction(tx$2$2);
                  $as_Lscommons_websql_ResultSet(x$4$2);
                  $p_Lshowcase_app_expo_sqlite_SQLiteDemo$__onSuccess$1__Lscommons_websql_Transaction__scm_ListBuffer__V(this$13, tx$2$1, msgLog$1$1)
                })
              })(this$6, msgLog$1)), new $c_sjsr_AnonFunction2((function(this$2$1, msgLog$1$2) {
                return (function(tx$3$2, error$2) {
                  var tx$3 = $as_Lscommons_websql_Transaction(tx$3$2);
                  var msg = ("insert error: " + error$2);
                  msgLog$1$2.addOne__O__scm_ListBuffer(msg);
                  $p_Lshowcase_app_expo_sqlite_SQLiteDemo$__onSuccess$1__Lscommons_websql_Transaction__scm_ListBuffer__V(this$2$1, tx$3, msgLog$1$2);
                  return false
                })
              })(this$6, msgLog$1)))
            })
          })(this$5, msgLog))).map__F1__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_sjsr_AnonFunction1((function(this$2$2, msgLog$2) {
            return (function(x$5$2) {
              $as_jl_Void(x$5$2);
              msgLog$2.addOne__O__scm_ListBuffer("tx is completed")
            })
          })(this$5, msgLog)), $m_s_concurrent_ExecutionContext$().global__s_concurrent_ExecutionContextExecutor()).recover__s_PartialFunction__s_concurrent_ExecutionContext__s_concurrent_Future(new $c_Lshowcase_app_expo_sqlite_SQLiteDemo$$anonfun$$nestedInanonfun$render$2$1(msgLog), $m_s_concurrent_ExecutionContext$().global__s_concurrent_ExecutionContextExecutor()).foreach__F1__s_concurrent_ExecutionContext__V(new $c_sjsr_AnonFunction1((function(this$3$1, setMessages$1$1, msgLog$3) {
            return (function(x$6$2) {
              $as_jl_Void(x$6$2);
              setMessages$1$1(msgLog$3.toList__sci_List())
            })
          })(this$5, setMessages$1, msgLog)), $m_s_concurrent_ExecutionContext$().global__s_concurrent_ExecutionContextExecutor())
        })
      })(this$3, setMessages$2)), $m_s_concurrent_ExecutionContext$().global__s_concurrent_ExecutionContextExecutor())
    })
  })(this, setMessages));
  var dependencies = $m_s_package$().s_package$__f_Nil;
  $f_Lscommons_react_hooks_UseEffect__useEffect__F0__sci_List__V(this$19, didUpdate, dependencies);
  var elements = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x6 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements).View__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var $$x5 = $m_sci_Nil$();
  var elements$1 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x4 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements$1).Text__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var attributes = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var $$x2 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec();
  var this$23 = $m_Lscommons_react_navigation_package$();
  var array$1 = [$$x2.$colon$eq__Lscommons_reactnative_Style__Lio_github_shogowada_statictags_Attribute($f_Lscommons_react_navigation_ReactNavigation__themeTextStyle__Lscommons_react_navigation_raw_Theme__Lscommons_reactnative_TextStyle(this$23, theme))];
  var $$x3 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  var x = (("DB log:\n           |\n           |" + $f_sc_IterableOnceOps__mkString__T__T__T__T(messages, "", "\n", "")) + "\n           |");
  var array$2 = [$m_sc_StringOps$().stripMargin$extension__T__C__T(x, 124)];
  var array$3 = [$$x4.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x3, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))];
  return $$x6.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x5, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))
});
var $d_Lshowcase_app_expo_sqlite_SQLiteDemo$ = new $TypeData().initClass({
  Lshowcase_app_expo_sqlite_SQLiteDemo$: 0
}, false, "showcase.app.expo.sqlite.SQLiteDemo$", {
  Lshowcase_app_expo_sqlite_SQLiteDemo$: 1,
  O: 1,
  Lscommons_react_FunctionComponent: 1,
  Lscommons_react_UiComponent: 1
});
$c_Lshowcase_app_expo_sqlite_SQLiteDemo$.prototype.$classData = $d_Lshowcase_app_expo_sqlite_SQLiteDemo$;
var $n_Lshowcase_app_expo_sqlite_SQLiteDemo$;
function $m_Lshowcase_app_expo_sqlite_SQLiteDemo$() {
  if ((!$n_Lshowcase_app_expo_sqlite_SQLiteDemo$)) {
    $n_Lshowcase_app_expo_sqlite_SQLiteDemo$ = new $c_Lshowcase_app_expo_sqlite_SQLiteDemo$()
  };
  return $n_Lshowcase_app_expo_sqlite_SQLiteDemo$
}
function $p_Lshowcase_app_style_BorderRadiusDemo$__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz) {
  if (((((2 & $thiz.Lshowcase_app_style_BorderRadiusDemo$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lshowcase_app_style_BorderRadiusDemo$__f_scommons$react$UiComponent$$reactClass = $f_Lscommons_react_FunctionComponent__create__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz);
    $thiz.Lshowcase_app_style_BorderRadiusDemo$__f_bitmap$0 = (((2 | $thiz.Lshowcase_app_style_BorderRadiusDemo$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lshowcase_app_style_BorderRadiusDemo$__f_scommons$react$UiComponent$$reactClass
}
function $p_Lshowcase_app_style_BorderRadiusDemo$__styles$lzycompute__Lshowcase_app_style_BorderRadiusDemo$Styles($thiz) {
  if (((((1 & $thiz.Lshowcase_app_style_BorderRadiusDemo$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lshowcase_app_style_BorderRadiusDemo$__f_styles = $m_Lscommons_reactnative_StyleSheet$().create__sjs_js_Object__sjs_js_Object(new ($a_Lshowcase_app_style_BorderRadiusDemo$Styles())());
    $thiz.Lshowcase_app_style_BorderRadiusDemo$__f_bitmap$0 = (((1 | $thiz.Lshowcase_app_style_BorderRadiusDemo$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lshowcase_app_style_BorderRadiusDemo$__f_styles
}
/** @constructor */
function $c_Lshowcase_app_style_BorderRadiusDemo$() {
  this.Lshowcase_app_style_BorderRadiusDemo$__f_styles = null;
  this.Lshowcase_app_style_BorderRadiusDemo$__f_Example = null;
  this.Lshowcase_app_style_BorderRadiusDemo$__f_CenteredText = null;
  this.Lshowcase_app_style_BorderRadiusDemo$__f_exampleComp = null;
  this.Lshowcase_app_style_BorderRadiusDemo$__f_centeredTextComp = null;
  this.Lshowcase_app_style_BorderRadiusDemo$__f_scommons$react$UiComponent$$reactClass = null;
  this.Lshowcase_app_style_BorderRadiusDemo$__f_bitmap$0 = 0;
  $n_Lshowcase_app_style_BorderRadiusDemo$ = this;
  this.Lshowcase_app_style_BorderRadiusDemo$__f_Example = new $c_Lshowcase_app_style_BorderRadiusDemo$$anon$1();
  this.Lshowcase_app_style_BorderRadiusDemo$__f_CenteredText = new $c_Lshowcase_app_style_BorderRadiusDemo$$anon$2();
  this.Lshowcase_app_style_BorderRadiusDemo$__f_exampleComp = this.Lshowcase_app_style_BorderRadiusDemo$__f_Example;
  this.Lshowcase_app_style_BorderRadiusDemo$__f_centeredTextComp = this.Lshowcase_app_style_BorderRadiusDemo$__f_CenteredText
}
$c_Lshowcase_app_style_BorderRadiusDemo$.prototype = new $h_O();
$c_Lshowcase_app_style_BorderRadiusDemo$.prototype.constructor = $c_Lshowcase_app_style_BorderRadiusDemo$;
/** @constructor */
function $h_Lshowcase_app_style_BorderRadiusDemo$() {
  /*<skip>*/
}
$h_Lshowcase_app_style_BorderRadiusDemo$.prototype = $c_Lshowcase_app_style_BorderRadiusDemo$.prototype;
$c_Lshowcase_app_style_BorderRadiusDemo$.prototype.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass = (function() {
  return (((((2 & this.Lshowcase_app_style_BorderRadiusDemo$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lshowcase_app_style_BorderRadiusDemo$__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass(this) : this.Lshowcase_app_style_BorderRadiusDemo$__f_scommons$react$UiComponent$$reactClass)
});
$c_Lshowcase_app_style_BorderRadiusDemo$.prototype.render__Lio_github_shogowada_scalajs_reactjs_React$Props__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement = (function(props) {
  var elements = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x21 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements).View__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var attributes = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array = [new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__Lscommons_reactnative_Style__Lio_github_shogowada_statictags_Attribute(this.styles__Lshowcase_app_style_BorderRadiusDemo$Styles().container)];
  var $$x20 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var this$6 = this.Lshowcase_app_style_BorderRadiusDemo$__f_exampleComp;
  var reactClass = this$6.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass();
  var $$x19 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass);
  var attributes$1 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array$1 = [new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$1).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__Lscommons_reactnative_Style__Lio_github_shogowada_statictags_Attribute((function(superClass$) {
    return (function() {
      var this$9 = {};
      this$9.borderRadius = null;
      this$9.borderRadius = 20;
      return this$9
    })
  })(Object)())];
  var $$x18 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var this$16 = this.Lshowcase_app_style_BorderRadiusDemo$__f_centeredTextComp;
  var reactClass$1 = this$16.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass();
  var $$x17 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass$1);
  var $$x16 = $m_sci_Nil$();
  var array$2 = ["Example 1:\n4 Rounded Corners"];
  var array$3 = [$$x17.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x16, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))];
  var $$x15 = $$x19.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x18, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3));
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var this$24 = this.Lshowcase_app_style_BorderRadiusDemo$__f_exampleComp;
  var reactClass$2 = this$24.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass();
  var $$x14 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass$2);
  var attributes$2 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array$4 = [new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$2).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__Lscommons_reactnative_Style__Lio_github_shogowada_statictags_Attribute((function(superClass$$1) {
    return (function() {
      var this$2$1 = {};
      this$2$1.borderTopRightRadius = null;
      this$2$1.borderBottomRightRadius = null;
      this$2$1.borderTopRightRadius = 60;
      this$2$1.borderBottomRightRadius = 60;
      return this$2$1
    })
  })(Object)())];
  var $$x13 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4);
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var this$36 = this.Lshowcase_app_style_BorderRadiusDemo$__f_centeredTextComp;
  var reactClass$3 = this$36.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass();
  var $$x12 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass$3);
  var $$x11 = $m_sci_Nil$();
  var array$5 = ["Example 2:\nD Shape"];
  var array$6 = [$$x12.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x11, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5))];
  var $$x10 = $$x14.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x13, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6));
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var this$44 = this.Lshowcase_app_style_BorderRadiusDemo$__f_exampleComp;
  var reactClass$4 = this$44.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass();
  var $$x9 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass$4);
  var attributes$3 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array$7 = [new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$3).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__Lscommons_reactnative_Style__Lio_github_shogowada_statictags_Attribute((function(superClass$$2) {
    return (function() {
      var this$3$1 = {};
      this$3$1.borderTopLeftRadius = null;
      this$3$1.borderBottomRightRadius = null;
      this$3$1.borderTopLeftRadius = 30;
      this$3$1.borderBottomRightRadius = 30;
      return this$3$1
    })
  })(Object)())];
  var $$x8 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7);
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var this$56 = this.Lshowcase_app_style_BorderRadiusDemo$__f_centeredTextComp;
  var reactClass$5 = this$56.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass();
  var $$x7 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass$5);
  var $$x6 = $m_sci_Nil$();
  var array$8 = ["Example 3:\nLeaf Shape"];
  var array$9 = [$$x7.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x6, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8))];
  var $$x5 = $$x9.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x8, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9));
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var this$64 = this.Lshowcase_app_style_BorderRadiusDemo$__f_exampleComp;
  var reactClass$6 = this$64.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass();
  var $$x4 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass$6);
  var attributes$4 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array$10 = [new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$4).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__Lscommons_reactnative_Style__Lio_github_shogowada_statictags_Attribute((function(superClass$$3) {
    return (function() {
      var this$4$1 = {};
      this$4$1.borderRadius = null;
      this$4$1.borderRadius = 60;
      return this$4$1
    })
  })(Object)())];
  var $$x3 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$10);
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var this$73 = this.Lshowcase_app_style_BorderRadiusDemo$__f_centeredTextComp;
  var reactClass$7 = this$73.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass();
  var $$x2 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass$7);
  var $$x1 = $m_sci_Nil$();
  var array$11 = ["Example 4:\nCircle"];
  var array$12 = [$$x2.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x1, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$11))];
  var array$13 = [$$x15, $$x10, $$x5, $$x4.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x3, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$12))];
  return $$x21.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x20, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$13))
});
$c_Lshowcase_app_style_BorderRadiusDemo$.prototype.styles__Lshowcase_app_style_BorderRadiusDemo$Styles = (function() {
  return (((((1 & this.Lshowcase_app_style_BorderRadiusDemo$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lshowcase_app_style_BorderRadiusDemo$__styles$lzycompute__Lshowcase_app_style_BorderRadiusDemo$Styles(this) : this.Lshowcase_app_style_BorderRadiusDemo$__f_styles)
});
var $d_Lshowcase_app_style_BorderRadiusDemo$ = new $TypeData().initClass({
  Lshowcase_app_style_BorderRadiusDemo$: 0
}, false, "showcase.app.style.BorderRadiusDemo$", {
  Lshowcase_app_style_BorderRadiusDemo$: 1,
  O: 1,
  Lscommons_react_FunctionComponent: 1,
  Lscommons_react_UiComponent: 1
});
$c_Lshowcase_app_style_BorderRadiusDemo$.prototype.$classData = $d_Lshowcase_app_style_BorderRadiusDemo$;
var $n_Lshowcase_app_style_BorderRadiusDemo$;
function $m_Lshowcase_app_style_BorderRadiusDemo$() {
  if ((!$n_Lshowcase_app_style_BorderRadiusDemo$)) {
    $n_Lshowcase_app_style_BorderRadiusDemo$ = new $c_Lshowcase_app_style_BorderRadiusDemo$()
  };
  return $n_Lshowcase_app_style_BorderRadiusDemo$
}
function $p_Lshowcase_app_style_BorderRadiusDemo$$anon$1__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz) {
  if ((!$thiz.Lshowcase_app_style_BorderRadiusDemo$$anon$1__f_bitmap$0)) {
    $thiz.Lshowcase_app_style_BorderRadiusDemo$$anon$1__f_scommons$react$UiComponent$$reactClass = $f_Lscommons_react_FunctionComponent__create__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz);
    $thiz.Lshowcase_app_style_BorderRadiusDemo$$anon$1__f_bitmap$0 = true
  };
  return $thiz.Lshowcase_app_style_BorderRadiusDemo$$anon$1__f_scommons$react$UiComponent$$reactClass
}
/** @constructor */
function $c_Lshowcase_app_style_BorderRadiusDemo$$anon$1() {
  this.Lshowcase_app_style_BorderRadiusDemo$$anon$1__f_scommons$react$UiComponent$$reactClass = null;
  this.Lshowcase_app_style_BorderRadiusDemo$$anon$1__f_bitmap$0 = false
}
$c_Lshowcase_app_style_BorderRadiusDemo$$anon$1.prototype = new $h_O();
$c_Lshowcase_app_style_BorderRadiusDemo$$anon$1.prototype.constructor = $c_Lshowcase_app_style_BorderRadiusDemo$$anon$1;
/** @constructor */
function $h_Lshowcase_app_style_BorderRadiusDemo$$anon$1() {
  /*<skip>*/
}
$h_Lshowcase_app_style_BorderRadiusDemo$$anon$1.prototype = $c_Lshowcase_app_style_BorderRadiusDemo$$anon$1.prototype;
$c_Lshowcase_app_style_BorderRadiusDemo$$anon$1.prototype.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass = (function() {
  return ((!this.Lshowcase_app_style_BorderRadiusDemo$$anon$1__f_bitmap$0) ? $p_Lshowcase_app_style_BorderRadiusDemo$$anon$1__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass(this) : this.Lshowcase_app_style_BorderRadiusDemo$$anon$1__f_scommons$react$UiComponent$$reactClass)
});
$c_Lshowcase_app_style_BorderRadiusDemo$$anon$1.prototype.render__Lio_github_shogowada_scalajs_reactjs_React$Props__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement = (function(props) {
  var elements = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x2 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements).View__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var attributes = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array = [new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__sjs_js_Array__Lio_github_shogowada_statictags_Attribute([$m_Lshowcase_app_style_BorderRadiusDemo$().styles__Lshowcase_app_style_BorderRadiusDemo$Styles().example, props.Lio_github_shogowada_scalajs_reactjs_React$Props__f_native.style])];
  var $$x1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var array$1 = [props.children__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement()];
  return $$x2.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x1, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
});
var $d_Lshowcase_app_style_BorderRadiusDemo$$anon$1 = new $TypeData().initClass({
  Lshowcase_app_style_BorderRadiusDemo$$anon$1: 0
}, false, "showcase.app.style.BorderRadiusDemo$$anon$1", {
  Lshowcase_app_style_BorderRadiusDemo$$anon$1: 1,
  O: 1,
  Lscommons_react_FunctionComponent: 1,
  Lscommons_react_UiComponent: 1
});
$c_Lshowcase_app_style_BorderRadiusDemo$$anon$1.prototype.$classData = $d_Lshowcase_app_style_BorderRadiusDemo$$anon$1;
function $p_Lshowcase_app_style_BorderRadiusDemo$$anon$2__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz) {
  if ((!$thiz.Lshowcase_app_style_BorderRadiusDemo$$anon$2__f_bitmap$0)) {
    $thiz.Lshowcase_app_style_BorderRadiusDemo$$anon$2__f_scommons$react$UiComponent$$reactClass = $f_Lscommons_react_FunctionComponent__create__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz);
    $thiz.Lshowcase_app_style_BorderRadiusDemo$$anon$2__f_bitmap$0 = true
  };
  return $thiz.Lshowcase_app_style_BorderRadiusDemo$$anon$2__f_scommons$react$UiComponent$$reactClass
}
/** @constructor */
function $c_Lshowcase_app_style_BorderRadiusDemo$$anon$2() {
  this.Lshowcase_app_style_BorderRadiusDemo$$anon$2__f_scommons$react$UiComponent$$reactClass = null;
  this.Lshowcase_app_style_BorderRadiusDemo$$anon$2__f_bitmap$0 = false
}
$c_Lshowcase_app_style_BorderRadiusDemo$$anon$2.prototype = new $h_O();
$c_Lshowcase_app_style_BorderRadiusDemo$$anon$2.prototype.constructor = $c_Lshowcase_app_style_BorderRadiusDemo$$anon$2;
/** @constructor */
function $h_Lshowcase_app_style_BorderRadiusDemo$$anon$2() {
  /*<skip>*/
}
$h_Lshowcase_app_style_BorderRadiusDemo$$anon$2.prototype = $c_Lshowcase_app_style_BorderRadiusDemo$$anon$2.prototype;
$c_Lshowcase_app_style_BorderRadiusDemo$$anon$2.prototype.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass = (function() {
  return ((!this.Lshowcase_app_style_BorderRadiusDemo$$anon$2__f_bitmap$0) ? $p_Lshowcase_app_style_BorderRadiusDemo$$anon$2__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass(this) : this.Lshowcase_app_style_BorderRadiusDemo$$anon$2__f_scommons$react$UiComponent$$reactClass)
});
$c_Lshowcase_app_style_BorderRadiusDemo$$anon$2.prototype.render__Lio_github_shogowada_scalajs_reactjs_React$Props__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement = (function(props) {
  var elements = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x2 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements).Text__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var attributes = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array = [new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__sjs_js_Array__Lio_github_shogowada_statictags_Attribute([$m_Lshowcase_app_style_BorderRadiusDemo$().styles__Lshowcase_app_style_BorderRadiusDemo$Styles().centeredText, props.Lio_github_shogowada_scalajs_reactjs_React$Props__f_native.style])];
  var $$x1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var array$1 = [props.children__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement()];
  return $$x2.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x1, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
});
var $d_Lshowcase_app_style_BorderRadiusDemo$$anon$2 = new $TypeData().initClass({
  Lshowcase_app_style_BorderRadiusDemo$$anon$2: 0
}, false, "showcase.app.style.BorderRadiusDemo$$anon$2", {
  Lshowcase_app_style_BorderRadiusDemo$$anon$2: 1,
  O: 1,
  Lscommons_react_FunctionComponent: 1,
  Lscommons_react_UiComponent: 1
});
$c_Lshowcase_app_style_BorderRadiusDemo$$anon$2.prototype.$classData = $d_Lshowcase_app_style_BorderRadiusDemo$$anon$2;
var $b_Lshowcase_app_style_BorderRadiusDemo$Styles;
function $a_Lshowcase_app_style_BorderRadiusDemo$Styles() {
  if ((!$b_Lshowcase_app_style_BorderRadiusDemo$Styles)) {
    /** @constructor */
    $b_Lshowcase_app_style_BorderRadiusDemo$Styles = (function() {
      Object.call(this);
      Object.defineProperty(this, "container", {
        "configurable": true,
        "enumerable": true,
        "writable": true,
        "value": null
      });
      Object.defineProperty(this, "example", {
        "configurable": true,
        "enumerable": true,
        "writable": true,
        "value": null
      });
      Object.defineProperty(this, "centeredText", {
        "configurable": true,
        "enumerable": true,
        "writable": true,
        "value": null
      });
      this.container = (function(superClass$, arg$outer) {
        return (function() {
          var outer = arg$outer;
          var this\u00f8 = {};
          this\u00f8.flex = null;
          this\u00f8.justifyContent = null;
          this\u00f8.alignItems = null;
          this\u00f8.flexDirection = null;
          this\u00f8.flexWrap = null;
          this\u00f8.backgroundColor = null;
          this\u00f8.flex = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(1, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this\u00f8.justifyContent = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($m_Lscommons_reactnative_ViewStyle$JustifyContent$().center__Lscommons_reactnative_ViewStyle$JustifyContent(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this\u00f8.alignItems = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($m_Lscommons_reactnative_ViewStyle$AlignItems$().center__Lscommons_reactnative_ViewStyle$AlignItems(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this\u00f8.flexDirection = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($m_Lscommons_reactnative_ViewStyle$FlexDirection$().row__Lscommons_reactnative_ViewStyle$FlexDirection(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this\u00f8.flexWrap = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($m_Lscommons_reactnative_ViewStyle$FlexWrap$().wrap__Lscommons_reactnative_ViewStyle$FlexWrap(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this\u00f8.backgroundColor = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($m_Lscommons_reactnative_Style$Color$().white__T(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          $s_sr_Statics__releaseFence__V();
          return this\u00f8
        })
      })(Object, this)();
      this.example = (function(superClass$, arg$outer) {
        return (function() {
          var outer = arg$outer;
          var this$2 = {};
          this$2.width = null;
          this$2.height = null;
          this$2.marginLeft = null;
          this$2.marginBottom = null;
          this$2.backgroundColor = null;
          this$2.borderWidth = null;
          this$2.justifyContent = null;
          this$2.width = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(120, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().right__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          this$2.height = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(120, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().right__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          this$2.marginLeft = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(20, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().right__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          this$2.marginBottom = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(20, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().right__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          this$2.backgroundColor = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($m_Lscommons_reactnative_Style$Color$().grey__T(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this$2.borderWidth = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(2, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this$2.justifyContent = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($m_Lscommons_reactnative_ViewStyle$JustifyContent$().center__Lscommons_reactnative_ViewStyle$JustifyContent(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          $s_sr_Statics__releaseFence__V();
          return this$2
        })
      })(Object, this)();
      this.centeredText = (function(superClass$, arg$outer) {
        return (function() {
          var outer = arg$outer;
          var this$3 = {};
          this$3.textAlign = null;
          this$3.margin = null;
          this$3.textAlign = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($m_Lscommons_reactnative_TextStyle$TextAlign$().center__Lscommons_reactnative_TextStyle$TextAlign(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this$3.margin = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(10, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().right__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          $s_sr_Statics__releaseFence__V();
          return this$3
        })
      })(Object, this)()
    });
    /** @constructor */
    var $hh_Lshowcase_app_style_BorderRadiusDemo$Styles = (function() {
      /*<skip>*/
    });
    $hh_Lshowcase_app_style_BorderRadiusDemo$Styles.prototype = Object.prototype;
    $b_Lshowcase_app_style_BorderRadiusDemo$Styles.prototype = new $hh_Lshowcase_app_style_BorderRadiusDemo$Styles();
    $b_Lshowcase_app_style_BorderRadiusDemo$Styles.prototype.constructor = $b_Lshowcase_app_style_BorderRadiusDemo$Styles
  };
  return $b_Lshowcase_app_style_BorderRadiusDemo$Styles
}
function $p_Lshowcase_app_style_BorderStyleDemo$__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz) {
  if (((((2 & $thiz.Lshowcase_app_style_BorderStyleDemo$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lshowcase_app_style_BorderStyleDemo$__f_scommons$react$UiComponent$$reactClass = $f_Lscommons_react_FunctionComponent__create__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz);
    $thiz.Lshowcase_app_style_BorderStyleDemo$__f_bitmap$0 = (((2 | $thiz.Lshowcase_app_style_BorderStyleDemo$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lshowcase_app_style_BorderStyleDemo$__f_scommons$react$UiComponent$$reactClass
}
function $p_Lshowcase_app_style_BorderStyleDemo$__styles$lzycompute__Lshowcase_app_style_BorderStyleDemo$Styles($thiz) {
  if (((((1 & $thiz.Lshowcase_app_style_BorderStyleDemo$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lshowcase_app_style_BorderStyleDemo$__f_styles = $m_Lscommons_reactnative_StyleSheet$().create__sjs_js_Object__sjs_js_Object(new ($a_Lshowcase_app_style_BorderStyleDemo$Styles())());
    $thiz.Lshowcase_app_style_BorderStyleDemo$__f_bitmap$0 = (((1 | $thiz.Lshowcase_app_style_BorderStyleDemo$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lshowcase_app_style_BorderStyleDemo$__f_styles
}
/** @constructor */
function $c_Lshowcase_app_style_BorderStyleDemo$() {
  this.Lshowcase_app_style_BorderStyleDemo$__f_styles = null;
  this.Lshowcase_app_style_BorderStyleDemo$__f_Example = null;
  this.Lshowcase_app_style_BorderStyleDemo$__f_exampleComp = null;
  this.Lshowcase_app_style_BorderStyleDemo$__f_scommons$react$UiComponent$$reactClass = null;
  this.Lshowcase_app_style_BorderStyleDemo$__f_bitmap$0 = 0;
  $n_Lshowcase_app_style_BorderStyleDemo$ = this;
  this.Lshowcase_app_style_BorderStyleDemo$__f_Example = new $c_Lshowcase_app_style_BorderStyleDemo$$anon$1();
  this.Lshowcase_app_style_BorderStyleDemo$__f_exampleComp = this.Lshowcase_app_style_BorderStyleDemo$__f_Example
}
$c_Lshowcase_app_style_BorderStyleDemo$.prototype = new $h_O();
$c_Lshowcase_app_style_BorderStyleDemo$.prototype.constructor = $c_Lshowcase_app_style_BorderStyleDemo$;
/** @constructor */
function $h_Lshowcase_app_style_BorderStyleDemo$() {
  /*<skip>*/
}
$h_Lshowcase_app_style_BorderStyleDemo$.prototype = $c_Lshowcase_app_style_BorderStyleDemo$.prototype;
$c_Lshowcase_app_style_BorderStyleDemo$.prototype.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass = (function() {
  return (((((2 & this.Lshowcase_app_style_BorderStyleDemo$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lshowcase_app_style_BorderStyleDemo$__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass(this) : this.Lshowcase_app_style_BorderStyleDemo$__f_scommons$react$UiComponent$$reactClass)
});
$c_Lshowcase_app_style_BorderStyleDemo$.prototype.render__Lio_github_shogowada_scalajs_reactjs_React$Props__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement = (function(props) {
  var elements = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x26 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements).View__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var attributes = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array = [new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__Lscommons_reactnative_Style__Lio_github_shogowada_statictags_Attribute(this.styles__Lshowcase_app_style_BorderStyleDemo$Styles().container)];
  var $$x25 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var this$6 = this.Lshowcase_app_style_BorderStyleDemo$__f_exampleComp;
  var reactClass = this$6.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass();
  var $$x24 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass);
  var attributes$1 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array$1 = [new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$1).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__Lscommons_reactnative_Style__Lio_github_shogowada_statictags_Attribute((function(superClass$) {
    return (function() {
      var this$9 = {};
      this$9.borderWidth = null;
      this$9.borderWidth = 1;
      return this$9
    })
  })(Object)())];
  var $$x23 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  var elements$1 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x22 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements$1).Text__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var $$x21 = $m_sci_Nil$();
  var array$2 = ["borderWidth: 1"];
  var array$3 = [$$x22.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x21, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))];
  var $$x20 = $$x24.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x23, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3));
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var this$23 = this.Lshowcase_app_style_BorderStyleDemo$__f_exampleComp;
  var reactClass$1 = this$23.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass();
  var $$x19 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass$1);
  var attributes$2 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array$4 = [new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$2).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__Lscommons_reactnative_Style__Lio_github_shogowada_statictags_Attribute((function(superClass$$1) {
    return (function() {
      var this$2$1 = {};
      this$2$1.borderWidth = null;
      this$2$1.borderLeftWidth = null;
      this$2$1.borderWidth = 3;
      this$2$1.borderLeftWidth = 0;
      return this$2$1
    })
  })(Object)())];
  var $$x18 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4);
  var elements$2 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x17 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements$2).Text__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var $$x16 = $m_sci_Nil$();
  var array$5 = ["borderWidth: 3, borderLeftWidth: 0"];
  var array$6 = [$$x17.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x16, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5))];
  var $$x15 = $$x19.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x18, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6));
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var this$42 = this.Lshowcase_app_style_BorderStyleDemo$__f_exampleComp;
  var reactClass$2 = this$42.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass();
  var $$x14 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass$2);
  var attributes$3 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array$7 = [new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$3).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__Lscommons_reactnative_Style__Lio_github_shogowada_statictags_Attribute((function(superClass$$2) {
    return (function() {
      var this$3$1 = {};
      this$3$1.borderWidth = null;
      this$3$1.borderLeftColor = null;
      this$3$1.borderWidth = 3;
      var a = $m_Lscommons_reactnative_Style$Color$().Lscommons_reactnative_Style$Color$__f_red;
      this$3$1.borderLeftColor = a;
      return this$3$1
    })
  })(Object)())];
  var $$x13 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7);
  var elements$3 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x12 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements$3).Text__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var $$x11 = $m_sci_Nil$();
  var array$8 = ["borderWidth: 3, borderLeftColor: 'red'"];
  var array$9 = [$$x12.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x11, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8))];
  var $$x10 = $$x14.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x13, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9));
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var this$61 = this.Lshowcase_app_style_BorderStyleDemo$__f_exampleComp;
  var reactClass$3 = this$61.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass();
  var $$x9 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass$3);
  var attributes$4 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array$10 = [new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$4).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__Lscommons_reactnative_Style__Lio_github_shogowada_statictags_Attribute((function(superClass$$3) {
    return (function() {
      var this$4$1 = {};
      this$4$1.borderLeftWidth = null;
      this$4$1.borderLeftWidth = 3;
      return this$4$1
    })
  })(Object)())];
  var $$x8 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$10);
  var elements$4 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x7 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements$4).Text__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var $$x6 = $m_sci_Nil$();
  var array$11 = ["borderLeftWidth: 3"];
  var array$12 = [$$x7.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x6, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$11))];
  var $$x5 = $$x9.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x8, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$12));
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var this$77 = this.Lshowcase_app_style_BorderStyleDemo$__f_exampleComp;
  var reactClass$4 = this$77.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass();
  var $$x4 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass$4);
  var attributes$5 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array$13 = [new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$5).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__Lscommons_reactnative_Style__Lio_github_shogowada_statictags_Attribute((function(superClass$$4) {
    return (function() {
      var this$5$1 = {};
      this$5$1.borderWidth = null;
      this$5$1.borderStyle = null;
      this$5$1.borderWidth = 1;
      var a$1 = $m_Lscommons_reactnative_Style$BorderStyle$().Lscommons_reactnative_Style$BorderStyle$__f_dashed;
      this$5$1.borderStyle = a$1;
      return this$5$1
    })
  })(Object)())];
  var $$x3 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$13);
  var elements$5 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x2 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements$5).Text__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var $$x1 = $m_sci_Nil$();
  var array$14 = ["borderWidth: 1, borderStyle: 'dashed'"];
  var array$15 = [$$x2.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x1, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$14))];
  var array$16 = [$$x20, $$x15, $$x10, $$x5, $$x4.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x3, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$15))];
  return $$x26.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x25, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$16))
});
$c_Lshowcase_app_style_BorderStyleDemo$.prototype.styles__Lshowcase_app_style_BorderStyleDemo$Styles = (function() {
  return (((((1 & this.Lshowcase_app_style_BorderStyleDemo$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lshowcase_app_style_BorderStyleDemo$__styles$lzycompute__Lshowcase_app_style_BorderStyleDemo$Styles(this) : this.Lshowcase_app_style_BorderStyleDemo$__f_styles)
});
var $d_Lshowcase_app_style_BorderStyleDemo$ = new $TypeData().initClass({
  Lshowcase_app_style_BorderStyleDemo$: 0
}, false, "showcase.app.style.BorderStyleDemo$", {
  Lshowcase_app_style_BorderStyleDemo$: 1,
  O: 1,
  Lscommons_react_FunctionComponent: 1,
  Lscommons_react_UiComponent: 1
});
$c_Lshowcase_app_style_BorderStyleDemo$.prototype.$classData = $d_Lshowcase_app_style_BorderStyleDemo$;
var $n_Lshowcase_app_style_BorderStyleDemo$;
function $m_Lshowcase_app_style_BorderStyleDemo$() {
  if ((!$n_Lshowcase_app_style_BorderStyleDemo$)) {
    $n_Lshowcase_app_style_BorderStyleDemo$ = new $c_Lshowcase_app_style_BorderStyleDemo$()
  };
  return $n_Lshowcase_app_style_BorderStyleDemo$
}
function $p_Lshowcase_app_style_BorderStyleDemo$$anon$1__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz) {
  if ((!$thiz.Lshowcase_app_style_BorderStyleDemo$$anon$1__f_bitmap$0)) {
    $thiz.Lshowcase_app_style_BorderStyleDemo$$anon$1__f_scommons$react$UiComponent$$reactClass = $f_Lscommons_react_FunctionComponent__create__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz);
    $thiz.Lshowcase_app_style_BorderStyleDemo$$anon$1__f_bitmap$0 = true
  };
  return $thiz.Lshowcase_app_style_BorderStyleDemo$$anon$1__f_scommons$react$UiComponent$$reactClass
}
/** @constructor */
function $c_Lshowcase_app_style_BorderStyleDemo$$anon$1() {
  this.Lshowcase_app_style_BorderStyleDemo$$anon$1__f_scommons$react$UiComponent$$reactClass = null;
  this.Lshowcase_app_style_BorderStyleDemo$$anon$1__f_bitmap$0 = false
}
$c_Lshowcase_app_style_BorderStyleDemo$$anon$1.prototype = new $h_O();
$c_Lshowcase_app_style_BorderStyleDemo$$anon$1.prototype.constructor = $c_Lshowcase_app_style_BorderStyleDemo$$anon$1;
/** @constructor */
function $h_Lshowcase_app_style_BorderStyleDemo$$anon$1() {
  /*<skip>*/
}
$h_Lshowcase_app_style_BorderStyleDemo$$anon$1.prototype = $c_Lshowcase_app_style_BorderStyleDemo$$anon$1.prototype;
$c_Lshowcase_app_style_BorderStyleDemo$$anon$1.prototype.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass = (function() {
  return ((!this.Lshowcase_app_style_BorderStyleDemo$$anon$1__f_bitmap$0) ? $p_Lshowcase_app_style_BorderStyleDemo$$anon$1__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass(this) : this.Lshowcase_app_style_BorderStyleDemo$$anon$1__f_scommons$react$UiComponent$$reactClass)
});
$c_Lshowcase_app_style_BorderStyleDemo$$anon$1.prototype.render__Lio_github_shogowada_scalajs_reactjs_React$Props__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement = (function(props) {
  var elements = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x2 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements).View__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var attributes = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array = [new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__sjs_js_Array__Lio_github_shogowada_statictags_Attribute([$m_Lshowcase_app_style_BorderStyleDemo$().styles__Lshowcase_app_style_BorderStyleDemo$Styles().example, props.Lio_github_shogowada_scalajs_reactjs_React$Props__f_native.style])];
  var $$x1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var array$1 = [props.children__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement()];
  return $$x2.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x1, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
});
var $d_Lshowcase_app_style_BorderStyleDemo$$anon$1 = new $TypeData().initClass({
  Lshowcase_app_style_BorderStyleDemo$$anon$1: 0
}, false, "showcase.app.style.BorderStyleDemo$$anon$1", {
  Lshowcase_app_style_BorderStyleDemo$$anon$1: 1,
  O: 1,
  Lscommons_react_FunctionComponent: 1,
  Lscommons_react_UiComponent: 1
});
$c_Lshowcase_app_style_BorderStyleDemo$$anon$1.prototype.$classData = $d_Lshowcase_app_style_BorderStyleDemo$$anon$1;
var $b_Lshowcase_app_style_BorderStyleDemo$Styles;
function $a_Lshowcase_app_style_BorderStyleDemo$Styles() {
  if ((!$b_Lshowcase_app_style_BorderStyleDemo$Styles)) {
    /** @constructor */
    $b_Lshowcase_app_style_BorderStyleDemo$Styles = (function() {
      Object.call(this);
      Object.defineProperty(this, "container", {
        "configurable": true,
        "enumerable": true,
        "writable": true,
        "value": null
      });
      Object.defineProperty(this, "example", {
        "configurable": true,
        "enumerable": true,
        "writable": true,
        "value": null
      });
      this.container = (function(superClass$, arg$outer) {
        return (function() {
          var outer = arg$outer;
          var this\u00f8 = {};
          this\u00f8.flex = null;
          this\u00f8.justifyContent = null;
          this\u00f8.alignItems = null;
          this\u00f8.backgroundColor = null;
          this\u00f8.flex = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(1, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this\u00f8.justifyContent = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($m_Lscommons_reactnative_ViewStyle$JustifyContent$().center__Lscommons_reactnative_ViewStyle$JustifyContent(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this\u00f8.alignItems = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($m_Lscommons_reactnative_ViewStyle$AlignItems$().center__Lscommons_reactnative_ViewStyle$AlignItems(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this\u00f8.backgroundColor = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($m_Lscommons_reactnative_Style$Color$().white__T(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          $s_sr_Statics__releaseFence__V();
          return this\u00f8
        })
      })(Object, this)();
      this.example = (function(superClass$, arg$outer) {
        return (function() {
          var outer = arg$outer;
          var this$2 = {};
          this$2.marginBottom = null;
          this$2.marginBottom = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(15, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().right__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          $s_sr_Statics__releaseFence__V();
          return this$2
        })
      })(Object, this)()
    });
    /** @constructor */
    var $hh_Lshowcase_app_style_BorderStyleDemo$Styles = (function() {
      /*<skip>*/
    });
    $hh_Lshowcase_app_style_BorderStyleDemo$Styles.prototype = Object.prototype;
    $b_Lshowcase_app_style_BorderStyleDemo$Styles.prototype = new $hh_Lshowcase_app_style_BorderStyleDemo$Styles();
    $b_Lshowcase_app_style_BorderStyleDemo$Styles.prototype.constructor = $b_Lshowcase_app_style_BorderStyleDemo$Styles
  };
  return $b_Lshowcase_app_style_BorderStyleDemo$Styles
}
function $p_Lshowcase_app_style_MarginStyleDemo$__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz) {
  if (((((2 & $thiz.Lshowcase_app_style_MarginStyleDemo$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lshowcase_app_style_MarginStyleDemo$__f_scommons$react$UiComponent$$reactClass = $f_Lscommons_react_FunctionComponent__create__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz);
    $thiz.Lshowcase_app_style_MarginStyleDemo$__f_bitmap$0 = (((2 | $thiz.Lshowcase_app_style_MarginStyleDemo$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lshowcase_app_style_MarginStyleDemo$__f_scommons$react$UiComponent$$reactClass
}
function $p_Lshowcase_app_style_MarginStyleDemo$__styles$lzycompute__Lshowcase_app_style_MarginStyleDemo$Styles($thiz) {
  if (((((1 & $thiz.Lshowcase_app_style_MarginStyleDemo$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lshowcase_app_style_MarginStyleDemo$__f_styles = $m_Lscommons_reactnative_StyleSheet$().create__sjs_js_Object__sjs_js_Object(new ($a_Lshowcase_app_style_MarginStyleDemo$Styles())());
    $thiz.Lshowcase_app_style_MarginStyleDemo$__f_bitmap$0 = (((1 | $thiz.Lshowcase_app_style_MarginStyleDemo$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lshowcase_app_style_MarginStyleDemo$__f_styles
}
/** @constructor */
function $c_Lshowcase_app_style_MarginStyleDemo$() {
  this.Lshowcase_app_style_MarginStyleDemo$__f_styles = null;
  this.Lshowcase_app_style_MarginStyleDemo$__f_Example = null;
  this.Lshowcase_app_style_MarginStyleDemo$__f_CenteredText = null;
  this.Lshowcase_app_style_MarginStyleDemo$__f_exampleComp = null;
  this.Lshowcase_app_style_MarginStyleDemo$__f_centeredTextComp = null;
  this.Lshowcase_app_style_MarginStyleDemo$__f_scommons$react$UiComponent$$reactClass = null;
  this.Lshowcase_app_style_MarginStyleDemo$__f_bitmap$0 = 0;
  $n_Lshowcase_app_style_MarginStyleDemo$ = this;
  this.Lshowcase_app_style_MarginStyleDemo$__f_Example = new $c_Lshowcase_app_style_MarginStyleDemo$$anon$1();
  this.Lshowcase_app_style_MarginStyleDemo$__f_CenteredText = new $c_Lshowcase_app_style_MarginStyleDemo$$anon$2();
  this.Lshowcase_app_style_MarginStyleDemo$__f_exampleComp = this.Lshowcase_app_style_MarginStyleDemo$__f_Example;
  this.Lshowcase_app_style_MarginStyleDemo$__f_centeredTextComp = this.Lshowcase_app_style_MarginStyleDemo$__f_CenteredText
}
$c_Lshowcase_app_style_MarginStyleDemo$.prototype = new $h_O();
$c_Lshowcase_app_style_MarginStyleDemo$.prototype.constructor = $c_Lshowcase_app_style_MarginStyleDemo$;
/** @constructor */
function $h_Lshowcase_app_style_MarginStyleDemo$() {
  /*<skip>*/
}
$h_Lshowcase_app_style_MarginStyleDemo$.prototype = $c_Lshowcase_app_style_MarginStyleDemo$.prototype;
$c_Lshowcase_app_style_MarginStyleDemo$.prototype.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass = (function() {
  return (((((2 & this.Lshowcase_app_style_MarginStyleDemo$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lshowcase_app_style_MarginStyleDemo$__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass(this) : this.Lshowcase_app_style_MarginStyleDemo$__f_scommons$react$UiComponent$$reactClass)
});
$c_Lshowcase_app_style_MarginStyleDemo$.prototype.render__Lio_github_shogowada_scalajs_reactjs_React$Props__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement = (function(props) {
  var elements = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x29 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements).View__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var attributes = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array = [new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__Lscommons_reactnative_Style__Lio_github_shogowada_statictags_Attribute(this.styles__Lshowcase_app_style_MarginStyleDemo$Styles().container)];
  var $$x28 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var elements$1 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x27 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements$1).View__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var attributes$1 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array$1 = [new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$1).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__Lscommons_reactnative_Style__Lio_github_shogowada_statictags_Attribute(this.styles__Lshowcase_app_style_MarginStyleDemo$Styles().exampleContainer)];
  var $$x26 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var this$11 = this.Lshowcase_app_style_MarginStyleDemo$__f_exampleComp;
  var reactClass = this$11.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass();
  var $$x25 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass);
  var $$x24 = $m_sci_Nil$();
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var this$13 = this.Lshowcase_app_style_MarginStyleDemo$__f_centeredTextComp;
  var reactClass$1 = this$13.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass();
  var $$x23 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass$1);
  var $$x22 = $m_sci_Nil$();
  var array$2 = ["A"];
  var array$3 = [$$x23.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x22, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))];
  var array$4 = [$$x25.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x24, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))];
  var $$x21 = $$x27.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x26, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4));
  var elements$2 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x20 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements$2).View__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var attributes$2 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array$5 = [new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$2).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__Lscommons_reactnative_Style__Lio_github_shogowada_statictags_Attribute(this.styles__Lshowcase_app_style_MarginStyleDemo$Styles().exampleContainer)];
  var $$x19 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5);
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var this$29 = this.Lshowcase_app_style_MarginStyleDemo$__f_exampleComp;
  var reactClass$2 = this$29.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass();
  var $$x18 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass$2);
  var attributes$3 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array$6 = [new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$3).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__Lscommons_reactnative_Style__Lio_github_shogowada_statictags_Attribute((function(superClass$) {
    return (function() {
      var this$32 = {};
      this$32.marginTop = null;
      this$32.marginTop = 50;
      return this$32
    })
  })(Object)())];
  var $$x17 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6);
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var this$40 = this.Lshowcase_app_style_MarginStyleDemo$__f_centeredTextComp;
  var reactClass$3 = this$40.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass();
  var $$x16 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass$3);
  var $$x15 = $m_sci_Nil$();
  var array$7 = ["B"];
  var array$8 = [$$x16.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x15, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7))];
  var array$9 = [$$x18.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x17, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8))];
  var $$x14 = $$x20.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x19, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9));
  var elements$3 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x13 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements$3).View__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var attributes$4 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array$10 = [new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$4).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__Lscommons_reactnative_Style__Lio_github_shogowada_statictags_Attribute(this.styles__Lshowcase_app_style_MarginStyleDemo$Styles().exampleContainer)];
  var $$x12 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$10);
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var this$56 = this.Lshowcase_app_style_MarginStyleDemo$__f_exampleComp;
  var reactClass$4 = this$56.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass();
  var $$x11 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass$4);
  var attributes$5 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array$11 = [new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$5).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__Lscommons_reactnative_Style__Lio_github_shogowada_statictags_Attribute((function(superClass$$1) {
    return (function() {
      var this$2$1 = {};
      this$2$1.marginTop = null;
      this$2$1.marginLeft = null;
      this$2$1.marginTop = 50;
      this$2$1.marginLeft = 10;
      return this$2$1
    })
  })(Object)())];
  var $$x10 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$11);
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var this$70 = this.Lshowcase_app_style_MarginStyleDemo$__f_centeredTextComp;
  var reactClass$5 = this$70.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass();
  var $$x9 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass$5);
  var $$x8 = $m_sci_Nil$();
  var array$12 = ["C"];
  var array$13 = [$$x9.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x8, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$12))];
  var array$14 = [$$x11.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x10, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$13))];
  var $$x7 = $$x13.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x12, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$14));
  var elements$4 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x6 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements$4).View__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var attributes$6 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array$15 = [new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$6).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__Lscommons_reactnative_Style__Lio_github_shogowada_statictags_Attribute(this.styles__Lshowcase_app_style_MarginStyleDemo$Styles().exampleContainer)];
  var $$x5 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$15);
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var this$86 = this.Lshowcase_app_style_MarginStyleDemo$__f_exampleComp;
  var reactClass$6 = this$86.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass();
  var $$x4 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass$6);
  var attributes$7 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array$16 = [new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$7).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__Lscommons_reactnative_Style__Lio_github_shogowada_statictags_Attribute((function(superClass$$2) {
    return (function() {
      var this$3$1 = {};
      this$3$1.marginLeft = null;
      this$3$1.marginTop = null;
      this$3$1.marginLeft = (-10);
      this$3$1.marginTop = (-10);
      return this$3$1
    })
  })(Object)())];
  var $$x3 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$16);
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var this$100 = this.Lshowcase_app_style_MarginStyleDemo$__f_centeredTextComp;
  var reactClass$7 = this$100.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass();
  var $$x2 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass$7);
  var $$x1 = $m_sci_Nil$();
  var array$17 = ["D"];
  var array$18 = [$$x2.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x1, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$17))];
  var array$19 = [$$x4.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x3, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$18))];
  var array$20 = [$$x21, $$x14, $$x7, $$x6.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x5, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$19))];
  return $$x29.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x28, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$20))
});
$c_Lshowcase_app_style_MarginStyleDemo$.prototype.styles__Lshowcase_app_style_MarginStyleDemo$Styles = (function() {
  return (((((1 & this.Lshowcase_app_style_MarginStyleDemo$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lshowcase_app_style_MarginStyleDemo$__styles$lzycompute__Lshowcase_app_style_MarginStyleDemo$Styles(this) : this.Lshowcase_app_style_MarginStyleDemo$__f_styles)
});
var $d_Lshowcase_app_style_MarginStyleDemo$ = new $TypeData().initClass({
  Lshowcase_app_style_MarginStyleDemo$: 0
}, false, "showcase.app.style.MarginStyleDemo$", {
  Lshowcase_app_style_MarginStyleDemo$: 1,
  O: 1,
  Lscommons_react_FunctionComponent: 1,
  Lscommons_react_UiComponent: 1
});
$c_Lshowcase_app_style_MarginStyleDemo$.prototype.$classData = $d_Lshowcase_app_style_MarginStyleDemo$;
var $n_Lshowcase_app_style_MarginStyleDemo$;
function $m_Lshowcase_app_style_MarginStyleDemo$() {
  if ((!$n_Lshowcase_app_style_MarginStyleDemo$)) {
    $n_Lshowcase_app_style_MarginStyleDemo$ = new $c_Lshowcase_app_style_MarginStyleDemo$()
  };
  return $n_Lshowcase_app_style_MarginStyleDemo$
}
function $p_Lshowcase_app_style_MarginStyleDemo$$anon$1__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz) {
  if ((!$thiz.Lshowcase_app_style_MarginStyleDemo$$anon$1__f_bitmap$0)) {
    $thiz.Lshowcase_app_style_MarginStyleDemo$$anon$1__f_scommons$react$UiComponent$$reactClass = $f_Lscommons_react_FunctionComponent__create__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz);
    $thiz.Lshowcase_app_style_MarginStyleDemo$$anon$1__f_bitmap$0 = true
  };
  return $thiz.Lshowcase_app_style_MarginStyleDemo$$anon$1__f_scommons$react$UiComponent$$reactClass
}
/** @constructor */
function $c_Lshowcase_app_style_MarginStyleDemo$$anon$1() {
  this.Lshowcase_app_style_MarginStyleDemo$$anon$1__f_scommons$react$UiComponent$$reactClass = null;
  this.Lshowcase_app_style_MarginStyleDemo$$anon$1__f_bitmap$0 = false
}
$c_Lshowcase_app_style_MarginStyleDemo$$anon$1.prototype = new $h_O();
$c_Lshowcase_app_style_MarginStyleDemo$$anon$1.prototype.constructor = $c_Lshowcase_app_style_MarginStyleDemo$$anon$1;
/** @constructor */
function $h_Lshowcase_app_style_MarginStyleDemo$$anon$1() {
  /*<skip>*/
}
$h_Lshowcase_app_style_MarginStyleDemo$$anon$1.prototype = $c_Lshowcase_app_style_MarginStyleDemo$$anon$1.prototype;
$c_Lshowcase_app_style_MarginStyleDemo$$anon$1.prototype.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass = (function() {
  return ((!this.Lshowcase_app_style_MarginStyleDemo$$anon$1__f_bitmap$0) ? $p_Lshowcase_app_style_MarginStyleDemo$$anon$1__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass(this) : this.Lshowcase_app_style_MarginStyleDemo$$anon$1__f_scommons$react$UiComponent$$reactClass)
});
$c_Lshowcase_app_style_MarginStyleDemo$$anon$1.prototype.render__Lio_github_shogowada_scalajs_reactjs_React$Props__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement = (function(props) {
  var elements = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x2 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements).View__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var attributes = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array = [new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__sjs_js_Array__Lio_github_shogowada_statictags_Attribute([$m_Lshowcase_app_style_MarginStyleDemo$().styles__Lshowcase_app_style_MarginStyleDemo$Styles().example, props.Lio_github_shogowada_scalajs_reactjs_React$Props__f_native.style])];
  var $$x1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var array$1 = [props.children__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement()];
  return $$x2.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x1, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
});
var $d_Lshowcase_app_style_MarginStyleDemo$$anon$1 = new $TypeData().initClass({
  Lshowcase_app_style_MarginStyleDemo$$anon$1: 0
}, false, "showcase.app.style.MarginStyleDemo$$anon$1", {
  Lshowcase_app_style_MarginStyleDemo$$anon$1: 1,
  O: 1,
  Lscommons_react_FunctionComponent: 1,
  Lscommons_react_UiComponent: 1
});
$c_Lshowcase_app_style_MarginStyleDemo$$anon$1.prototype.$classData = $d_Lshowcase_app_style_MarginStyleDemo$$anon$1;
function $p_Lshowcase_app_style_MarginStyleDemo$$anon$2__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz) {
  if ((!$thiz.Lshowcase_app_style_MarginStyleDemo$$anon$2__f_bitmap$0)) {
    $thiz.Lshowcase_app_style_MarginStyleDemo$$anon$2__f_scommons$react$UiComponent$$reactClass = $f_Lscommons_react_FunctionComponent__create__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz);
    $thiz.Lshowcase_app_style_MarginStyleDemo$$anon$2__f_bitmap$0 = true
  };
  return $thiz.Lshowcase_app_style_MarginStyleDemo$$anon$2__f_scommons$react$UiComponent$$reactClass
}
/** @constructor */
function $c_Lshowcase_app_style_MarginStyleDemo$$anon$2() {
  this.Lshowcase_app_style_MarginStyleDemo$$anon$2__f_scommons$react$UiComponent$$reactClass = null;
  this.Lshowcase_app_style_MarginStyleDemo$$anon$2__f_bitmap$0 = false
}
$c_Lshowcase_app_style_MarginStyleDemo$$anon$2.prototype = new $h_O();
$c_Lshowcase_app_style_MarginStyleDemo$$anon$2.prototype.constructor = $c_Lshowcase_app_style_MarginStyleDemo$$anon$2;
/** @constructor */
function $h_Lshowcase_app_style_MarginStyleDemo$$anon$2() {
  /*<skip>*/
}
$h_Lshowcase_app_style_MarginStyleDemo$$anon$2.prototype = $c_Lshowcase_app_style_MarginStyleDemo$$anon$2.prototype;
$c_Lshowcase_app_style_MarginStyleDemo$$anon$2.prototype.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass = (function() {
  return ((!this.Lshowcase_app_style_MarginStyleDemo$$anon$2__f_bitmap$0) ? $p_Lshowcase_app_style_MarginStyleDemo$$anon$2__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass(this) : this.Lshowcase_app_style_MarginStyleDemo$$anon$2__f_scommons$react$UiComponent$$reactClass)
});
$c_Lshowcase_app_style_MarginStyleDemo$$anon$2.prototype.render__Lio_github_shogowada_scalajs_reactjs_React$Props__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement = (function(props) {
  var elements = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x2 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements).Text__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var attributes = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array = [new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__sjs_js_Array__Lio_github_shogowada_statictags_Attribute([$m_Lshowcase_app_style_MarginStyleDemo$().styles__Lshowcase_app_style_MarginStyleDemo$Styles().centeredText, props.Lio_github_shogowada_scalajs_reactjs_React$Props__f_native.style])];
  var $$x1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var array$1 = [props.children__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement()];
  return $$x2.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x1, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
});
var $d_Lshowcase_app_style_MarginStyleDemo$$anon$2 = new $TypeData().initClass({
  Lshowcase_app_style_MarginStyleDemo$$anon$2: 0
}, false, "showcase.app.style.MarginStyleDemo$$anon$2", {
  Lshowcase_app_style_MarginStyleDemo$$anon$2: 1,
  O: 1,
  Lscommons_react_FunctionComponent: 1,
  Lscommons_react_UiComponent: 1
});
$c_Lshowcase_app_style_MarginStyleDemo$$anon$2.prototype.$classData = $d_Lshowcase_app_style_MarginStyleDemo$$anon$2;
var $b_Lshowcase_app_style_MarginStyleDemo$Styles;
function $a_Lshowcase_app_style_MarginStyleDemo$Styles() {
  if ((!$b_Lshowcase_app_style_MarginStyleDemo$Styles)) {
    /** @constructor */
    $b_Lshowcase_app_style_MarginStyleDemo$Styles = (function() {
      Object.call(this);
      Object.defineProperty(this, "container", {
        "configurable": true,
        "enumerable": true,
        "writable": true,
        "value": null
      });
      Object.defineProperty(this, "exampleContainer", {
        "configurable": true,
        "enumerable": true,
        "writable": true,
        "value": null
      });
      Object.defineProperty(this, "example", {
        "configurable": true,
        "enumerable": true,
        "writable": true,
        "value": null
      });
      Object.defineProperty(this, "centeredText", {
        "configurable": true,
        "enumerable": true,
        "writable": true,
        "value": null
      });
      this.container = (function(superClass$, arg$outer) {
        return (function() {
          var outer = arg$outer;
          var this\u00f8 = {};
          this\u00f8.alignItems = null;
          this\u00f8.flex = null;
          this\u00f8.flexDirection = null;
          this\u00f8.flexWrap = null;
          this\u00f8.justifyContent = null;
          this\u00f8.backgroundColor = null;
          this\u00f8.alignItems = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($m_Lscommons_reactnative_ViewStyle$AlignItems$().center__Lscommons_reactnative_ViewStyle$AlignItems(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this\u00f8.flex = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(1, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this\u00f8.flexDirection = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($m_Lscommons_reactnative_ViewStyle$FlexDirection$().row__Lscommons_reactnative_ViewStyle$FlexDirection(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this\u00f8.flexWrap = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($m_Lscommons_reactnative_ViewStyle$FlexWrap$().wrap__Lscommons_reactnative_ViewStyle$FlexWrap(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this\u00f8.justifyContent = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($m_Lscommons_reactnative_ViewStyle$JustifyContent$().center__Lscommons_reactnative_ViewStyle$JustifyContent(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this\u00f8.backgroundColor = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($m_Lscommons_reactnative_Style$Color$().white__T(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          $s_sr_Statics__releaseFence__V();
          return this\u00f8
        })
      })(Object, this)();
      this.exampleContainer = (function(superClass$, arg$outer) {
        return (function() {
          var outer = arg$outer;
          var this$2 = {};
          this$2.borderWidth = null;
          this$2.width = null;
          this$2.height = null;
          this$2.marginLeft = null;
          this$2.marginBottom = null;
          this$2.borderWidth = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(1, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this$2.width = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(120, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().right__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          this$2.height = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(120, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().right__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          this$2.marginLeft = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(20, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().right__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          this$2.marginBottom = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(20, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().right__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          $s_sr_Statics__releaseFence__V();
          return this$2
        })
      })(Object, this)();
      this.example = (function(superClass$, arg$outer) {
        return (function() {
          var outer = arg$outer;
          var this$3 = {};
          this$3.width = null;
          this$3.height = null;
          this$3.backgroundColor = null;
          this$3.borderWidth = null;
          this$3.justifyContent = null;
          this$3.width = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(50, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().right__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          this$3.height = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(50, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().right__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          this$3.backgroundColor = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($m_Lscommons_reactnative_Style$Color$().grey__T(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this$3.borderWidth = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(1, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this$3.justifyContent = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($m_Lscommons_reactnative_ViewStyle$JustifyContent$().center__Lscommons_reactnative_ViewStyle$JustifyContent(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          $s_sr_Statics__releaseFence__V();
          return this$3
        })
      })(Object, this)();
      this.centeredText = (function(superClass$, arg$outer) {
        return (function() {
          var outer = arg$outer;
          var this$4 = {};
          this$4.textAlign = null;
          this$4.margin = null;
          this$4.textAlign = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($m_Lscommons_reactnative_TextStyle$TextAlign$().center__Lscommons_reactnative_TextStyle$TextAlign(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this$4.margin = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(10, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().right__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          $s_sr_Statics__releaseFence__V();
          return this$4
        })
      })(Object, this)()
    });
    /** @constructor */
    var $hh_Lshowcase_app_style_MarginStyleDemo$Styles = (function() {
      /*<skip>*/
    });
    $hh_Lshowcase_app_style_MarginStyleDemo$Styles.prototype = Object.prototype;
    $b_Lshowcase_app_style_MarginStyleDemo$Styles.prototype = new $hh_Lshowcase_app_style_MarginStyleDemo$Styles();
    $b_Lshowcase_app_style_MarginStyleDemo$Styles.prototype.constructor = $b_Lshowcase_app_style_MarginStyleDemo$Styles
  };
  return $b_Lshowcase_app_style_MarginStyleDemo$Styles
}
function $p_Lshowcase_app_style_PaddingStyleDemo$__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz) {
  if (((((2 & $thiz.Lshowcase_app_style_PaddingStyleDemo$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lshowcase_app_style_PaddingStyleDemo$__f_scommons$react$UiComponent$$reactClass = $f_Lscommons_react_FunctionComponent__create__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz);
    $thiz.Lshowcase_app_style_PaddingStyleDemo$__f_bitmap$0 = (((2 | $thiz.Lshowcase_app_style_PaddingStyleDemo$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lshowcase_app_style_PaddingStyleDemo$__f_scommons$react$UiComponent$$reactClass
}
function $p_Lshowcase_app_style_PaddingStyleDemo$__styles$lzycompute__Lshowcase_app_style_PaddingStyleDemo$Styles($thiz) {
  if (((((1 & $thiz.Lshowcase_app_style_PaddingStyleDemo$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lshowcase_app_style_PaddingStyleDemo$__f_styles = $m_Lscommons_reactnative_StyleSheet$().create__sjs_js_Object__sjs_js_Object(new ($a_Lshowcase_app_style_PaddingStyleDemo$Styles())());
    $thiz.Lshowcase_app_style_PaddingStyleDemo$__f_bitmap$0 = (((1 | $thiz.Lshowcase_app_style_PaddingStyleDemo$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lshowcase_app_style_PaddingStyleDemo$__f_styles
}
/** @constructor */
function $c_Lshowcase_app_style_PaddingStyleDemo$() {
  this.Lshowcase_app_style_PaddingStyleDemo$__f_styles = null;
  this.Lshowcase_app_style_PaddingStyleDemo$__f_Example = null;
  this.Lshowcase_app_style_PaddingStyleDemo$__f_CenteredText = null;
  this.Lshowcase_app_style_PaddingStyleDemo$__f_exampleComp = null;
  this.Lshowcase_app_style_PaddingStyleDemo$__f_centeredTextComp = null;
  this.Lshowcase_app_style_PaddingStyleDemo$__f_scommons$react$UiComponent$$reactClass = null;
  this.Lshowcase_app_style_PaddingStyleDemo$__f_bitmap$0 = 0;
  $n_Lshowcase_app_style_PaddingStyleDemo$ = this;
  this.Lshowcase_app_style_PaddingStyleDemo$__f_Example = new $c_Lshowcase_app_style_PaddingStyleDemo$$anon$1();
  this.Lshowcase_app_style_PaddingStyleDemo$__f_CenteredText = new $c_Lshowcase_app_style_PaddingStyleDemo$$anon$2();
  this.Lshowcase_app_style_PaddingStyleDemo$__f_exampleComp = this.Lshowcase_app_style_PaddingStyleDemo$__f_Example;
  this.Lshowcase_app_style_PaddingStyleDemo$__f_centeredTextComp = this.Lshowcase_app_style_PaddingStyleDemo$__f_CenteredText
}
$c_Lshowcase_app_style_PaddingStyleDemo$.prototype = new $h_O();
$c_Lshowcase_app_style_PaddingStyleDemo$.prototype.constructor = $c_Lshowcase_app_style_PaddingStyleDemo$;
/** @constructor */
function $h_Lshowcase_app_style_PaddingStyleDemo$() {
  /*<skip>*/
}
$h_Lshowcase_app_style_PaddingStyleDemo$.prototype = $c_Lshowcase_app_style_PaddingStyleDemo$.prototype;
$c_Lshowcase_app_style_PaddingStyleDemo$.prototype.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass = (function() {
  return (((((2 & this.Lshowcase_app_style_PaddingStyleDemo$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lshowcase_app_style_PaddingStyleDemo$__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass(this) : this.Lshowcase_app_style_PaddingStyleDemo$__f_scommons$react$UiComponent$$reactClass)
});
$c_Lshowcase_app_style_PaddingStyleDemo$.prototype.render__Lio_github_shogowada_scalajs_reactjs_React$Props__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement = (function(props) {
  var elements = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x29 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements).View__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var attributes = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array = [new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__Lscommons_reactnative_Style__Lio_github_shogowada_statictags_Attribute(this.styles__Lshowcase_app_style_PaddingStyleDemo$Styles().container)];
  var $$x28 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var elements$1 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x27 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements$1).View__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var attributes$1 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array$1 = [new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$1).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__Lscommons_reactnative_Style__Lio_github_shogowada_statictags_Attribute(this.styles__Lshowcase_app_style_PaddingStyleDemo$Styles().exampleContainer)];
  var $$x26 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var this$11 = this.Lshowcase_app_style_PaddingStyleDemo$__f_exampleComp;
  var reactClass = this$11.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass();
  var $$x25 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass);
  var $$x24 = $m_sci_Nil$();
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var this$13 = this.Lshowcase_app_style_PaddingStyleDemo$__f_centeredTextComp;
  var reactClass$1 = this$13.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass();
  var $$x23 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass$1);
  var $$x22 = $m_sci_Nil$();
  var array$2 = ["A"];
  var array$3 = [$$x23.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x22, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))];
  var array$4 = [$$x25.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x24, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))];
  var $$x21 = $$x27.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x26, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4));
  var elements$2 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x20 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements$2).View__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var attributes$2 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array$5 = [new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$2).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__Lscommons_reactnative_Style__Lio_github_shogowada_statictags_Attribute(this.styles__Lshowcase_app_style_PaddingStyleDemo$Styles().exampleContainer)];
  var $$x19 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5);
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var this$29 = this.Lshowcase_app_style_PaddingStyleDemo$__f_exampleComp;
  var reactClass$2 = this$29.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass();
  var $$x18 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass$2);
  var attributes$3 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array$6 = [new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$3).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__Lscommons_reactnative_Style__Lio_github_shogowada_statictags_Attribute((function(superClass$) {
    return (function() {
      var this$32 = {};
      this$32.paddingTop = null;
      this$32.paddingTop = 50;
      return this$32
    })
  })(Object)())];
  var $$x17 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6);
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var this$40 = this.Lshowcase_app_style_PaddingStyleDemo$__f_centeredTextComp;
  var reactClass$3 = this$40.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass();
  var $$x16 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass$3);
  var $$x15 = $m_sci_Nil$();
  var array$7 = ["B"];
  var array$8 = [$$x16.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x15, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7))];
  var array$9 = [$$x18.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x17, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8))];
  var $$x14 = $$x20.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x19, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9));
  var elements$3 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x13 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements$3).View__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var attributes$4 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array$10 = [new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$4).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__Lscommons_reactnative_Style__Lio_github_shogowada_statictags_Attribute(this.styles__Lshowcase_app_style_PaddingStyleDemo$Styles().exampleContainer)];
  var $$x12 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$10);
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var this$56 = this.Lshowcase_app_style_PaddingStyleDemo$__f_exampleComp;
  var reactClass$4 = this$56.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass();
  var $$x11 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass$4);
  var attributes$5 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array$11 = [new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$5).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__Lscommons_reactnative_Style__Lio_github_shogowada_statictags_Attribute((function(superClass$$1) {
    return (function() {
      var this$2$1 = {};
      this$2$1.paddingTop = null;
      this$2$1.paddingLeft = null;
      this$2$1.paddingTop = 50;
      this$2$1.paddingLeft = 10;
      return this$2$1
    })
  })(Object)())];
  var $$x10 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$11);
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var this$70 = this.Lshowcase_app_style_PaddingStyleDemo$__f_centeredTextComp;
  var reactClass$5 = this$70.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass();
  var $$x9 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass$5);
  var $$x8 = $m_sci_Nil$();
  var array$12 = ["C"];
  var array$13 = [$$x9.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x8, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$12))];
  var array$14 = [$$x11.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x10, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$13))];
  var $$x7 = $$x13.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x12, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$14));
  var elements$4 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x6 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements$4).View__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var attributes$6 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array$15 = [new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$6).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__Lscommons_reactnative_Style__Lio_github_shogowada_statictags_Attribute(this.styles__Lshowcase_app_style_PaddingStyleDemo$Styles().exampleContainer)];
  var $$x5 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$15);
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var this$86 = this.Lshowcase_app_style_PaddingStyleDemo$__f_exampleComp;
  var reactClass$6 = this$86.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass();
  var $$x4 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass$6);
  var attributes$7 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array$16 = [new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$7).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__Lscommons_reactnative_Style__Lio_github_shogowada_statictags_Attribute((function(superClass$$2) {
    return (function() {
      var this$3$1 = {};
      this$3$1.paddingLeft = null;
      this$3$1.paddingTop = null;
      this$3$1.paddingLeft = (-10);
      this$3$1.paddingTop = (-10);
      return this$3$1
    })
  })(Object)())];
  var $$x3 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$16);
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var this$100 = this.Lshowcase_app_style_PaddingStyleDemo$__f_centeredTextComp;
  var reactClass$7 = this$100.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass();
  var $$x2 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass$7);
  var $$x1 = $m_sci_Nil$();
  var array$17 = ["D"];
  var array$18 = [$$x2.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x1, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$17))];
  var array$19 = [$$x4.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x3, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$18))];
  var array$20 = [$$x21, $$x14, $$x7, $$x6.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x5, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$19))];
  return $$x29.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x28, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$20))
});
$c_Lshowcase_app_style_PaddingStyleDemo$.prototype.styles__Lshowcase_app_style_PaddingStyleDemo$Styles = (function() {
  return (((((1 & this.Lshowcase_app_style_PaddingStyleDemo$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lshowcase_app_style_PaddingStyleDemo$__styles$lzycompute__Lshowcase_app_style_PaddingStyleDemo$Styles(this) : this.Lshowcase_app_style_PaddingStyleDemo$__f_styles)
});
var $d_Lshowcase_app_style_PaddingStyleDemo$ = new $TypeData().initClass({
  Lshowcase_app_style_PaddingStyleDemo$: 0
}, false, "showcase.app.style.PaddingStyleDemo$", {
  Lshowcase_app_style_PaddingStyleDemo$: 1,
  O: 1,
  Lscommons_react_FunctionComponent: 1,
  Lscommons_react_UiComponent: 1
});
$c_Lshowcase_app_style_PaddingStyleDemo$.prototype.$classData = $d_Lshowcase_app_style_PaddingStyleDemo$;
var $n_Lshowcase_app_style_PaddingStyleDemo$;
function $m_Lshowcase_app_style_PaddingStyleDemo$() {
  if ((!$n_Lshowcase_app_style_PaddingStyleDemo$)) {
    $n_Lshowcase_app_style_PaddingStyleDemo$ = new $c_Lshowcase_app_style_PaddingStyleDemo$()
  };
  return $n_Lshowcase_app_style_PaddingStyleDemo$
}
function $p_Lshowcase_app_style_PaddingStyleDemo$$anon$1__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz) {
  if ((!$thiz.Lshowcase_app_style_PaddingStyleDemo$$anon$1__f_bitmap$0)) {
    $thiz.Lshowcase_app_style_PaddingStyleDemo$$anon$1__f_scommons$react$UiComponent$$reactClass = $f_Lscommons_react_FunctionComponent__create__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz);
    $thiz.Lshowcase_app_style_PaddingStyleDemo$$anon$1__f_bitmap$0 = true
  };
  return $thiz.Lshowcase_app_style_PaddingStyleDemo$$anon$1__f_scommons$react$UiComponent$$reactClass
}
/** @constructor */
function $c_Lshowcase_app_style_PaddingStyleDemo$$anon$1() {
  this.Lshowcase_app_style_PaddingStyleDemo$$anon$1__f_scommons$react$UiComponent$$reactClass = null;
  this.Lshowcase_app_style_PaddingStyleDemo$$anon$1__f_bitmap$0 = false
}
$c_Lshowcase_app_style_PaddingStyleDemo$$anon$1.prototype = new $h_O();
$c_Lshowcase_app_style_PaddingStyleDemo$$anon$1.prototype.constructor = $c_Lshowcase_app_style_PaddingStyleDemo$$anon$1;
/** @constructor */
function $h_Lshowcase_app_style_PaddingStyleDemo$$anon$1() {
  /*<skip>*/
}
$h_Lshowcase_app_style_PaddingStyleDemo$$anon$1.prototype = $c_Lshowcase_app_style_PaddingStyleDemo$$anon$1.prototype;
$c_Lshowcase_app_style_PaddingStyleDemo$$anon$1.prototype.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass = (function() {
  return ((!this.Lshowcase_app_style_PaddingStyleDemo$$anon$1__f_bitmap$0) ? $p_Lshowcase_app_style_PaddingStyleDemo$$anon$1__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass(this) : this.Lshowcase_app_style_PaddingStyleDemo$$anon$1__f_scommons$react$UiComponent$$reactClass)
});
$c_Lshowcase_app_style_PaddingStyleDemo$$anon$1.prototype.render__Lio_github_shogowada_scalajs_reactjs_React$Props__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement = (function(props) {
  var elements = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x2 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements).View__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var attributes = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array = [new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__sjs_js_Array__Lio_github_shogowada_statictags_Attribute([$m_Lshowcase_app_style_PaddingStyleDemo$().styles__Lshowcase_app_style_PaddingStyleDemo$Styles().example, props.Lio_github_shogowada_scalajs_reactjs_React$Props__f_native.style])];
  var $$x1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var array$1 = [props.children__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement()];
  return $$x2.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x1, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
});
var $d_Lshowcase_app_style_PaddingStyleDemo$$anon$1 = new $TypeData().initClass({
  Lshowcase_app_style_PaddingStyleDemo$$anon$1: 0
}, false, "showcase.app.style.PaddingStyleDemo$$anon$1", {
  Lshowcase_app_style_PaddingStyleDemo$$anon$1: 1,
  O: 1,
  Lscommons_react_FunctionComponent: 1,
  Lscommons_react_UiComponent: 1
});
$c_Lshowcase_app_style_PaddingStyleDemo$$anon$1.prototype.$classData = $d_Lshowcase_app_style_PaddingStyleDemo$$anon$1;
function $p_Lshowcase_app_style_PaddingStyleDemo$$anon$2__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz) {
  if ((!$thiz.Lshowcase_app_style_PaddingStyleDemo$$anon$2__f_bitmap$0)) {
    $thiz.Lshowcase_app_style_PaddingStyleDemo$$anon$2__f_scommons$react$UiComponent$$reactClass = $f_Lscommons_react_FunctionComponent__create__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz);
    $thiz.Lshowcase_app_style_PaddingStyleDemo$$anon$2__f_bitmap$0 = true
  };
  return $thiz.Lshowcase_app_style_PaddingStyleDemo$$anon$2__f_scommons$react$UiComponent$$reactClass
}
/** @constructor */
function $c_Lshowcase_app_style_PaddingStyleDemo$$anon$2() {
  this.Lshowcase_app_style_PaddingStyleDemo$$anon$2__f_scommons$react$UiComponent$$reactClass = null;
  this.Lshowcase_app_style_PaddingStyleDemo$$anon$2__f_bitmap$0 = false
}
$c_Lshowcase_app_style_PaddingStyleDemo$$anon$2.prototype = new $h_O();
$c_Lshowcase_app_style_PaddingStyleDemo$$anon$2.prototype.constructor = $c_Lshowcase_app_style_PaddingStyleDemo$$anon$2;
/** @constructor */
function $h_Lshowcase_app_style_PaddingStyleDemo$$anon$2() {
  /*<skip>*/
}
$h_Lshowcase_app_style_PaddingStyleDemo$$anon$2.prototype = $c_Lshowcase_app_style_PaddingStyleDemo$$anon$2.prototype;
$c_Lshowcase_app_style_PaddingStyleDemo$$anon$2.prototype.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass = (function() {
  return ((!this.Lshowcase_app_style_PaddingStyleDemo$$anon$2__f_bitmap$0) ? $p_Lshowcase_app_style_PaddingStyleDemo$$anon$2__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass(this) : this.Lshowcase_app_style_PaddingStyleDemo$$anon$2__f_scommons$react$UiComponent$$reactClass)
});
$c_Lshowcase_app_style_PaddingStyleDemo$$anon$2.prototype.render__Lio_github_shogowada_scalajs_reactjs_React$Props__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement = (function(props) {
  var elements = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x2 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements).Text__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var attributes = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array = [new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__sjs_js_Array__Lio_github_shogowada_statictags_Attribute([$m_Lshowcase_app_style_PaddingStyleDemo$().styles__Lshowcase_app_style_PaddingStyleDemo$Styles().centeredText, props.Lio_github_shogowada_scalajs_reactjs_React$Props__f_native.style])];
  var $$x1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var array$1 = [props.children__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement()];
  return $$x2.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x1, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
});
var $d_Lshowcase_app_style_PaddingStyleDemo$$anon$2 = new $TypeData().initClass({
  Lshowcase_app_style_PaddingStyleDemo$$anon$2: 0
}, false, "showcase.app.style.PaddingStyleDemo$$anon$2", {
  Lshowcase_app_style_PaddingStyleDemo$$anon$2: 1,
  O: 1,
  Lscommons_react_FunctionComponent: 1,
  Lscommons_react_UiComponent: 1
});
$c_Lshowcase_app_style_PaddingStyleDemo$$anon$2.prototype.$classData = $d_Lshowcase_app_style_PaddingStyleDemo$$anon$2;
var $b_Lshowcase_app_style_PaddingStyleDemo$Styles;
function $a_Lshowcase_app_style_PaddingStyleDemo$Styles() {
  if ((!$b_Lshowcase_app_style_PaddingStyleDemo$Styles)) {
    /** @constructor */
    $b_Lshowcase_app_style_PaddingStyleDemo$Styles = (function() {
      Object.call(this);
      Object.defineProperty(this, "container", {
        "configurable": true,
        "enumerable": true,
        "writable": true,
        "value": null
      });
      Object.defineProperty(this, "exampleContainer", {
        "configurable": true,
        "enumerable": true,
        "writable": true,
        "value": null
      });
      Object.defineProperty(this, "example", {
        "configurable": true,
        "enumerable": true,
        "writable": true,
        "value": null
      });
      Object.defineProperty(this, "centeredText", {
        "configurable": true,
        "enumerable": true,
        "writable": true,
        "value": null
      });
      this.container = (function(superClass$, arg$outer) {
        return (function() {
          var outer = arg$outer;
          var this\u00f8 = {};
          this\u00f8.alignItems = null;
          this\u00f8.flex = null;
          this\u00f8.flexDirection = null;
          this\u00f8.flexWrap = null;
          this\u00f8.justifyContent = null;
          this\u00f8.backgroundColor = null;
          this\u00f8.alignItems = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($m_Lscommons_reactnative_ViewStyle$AlignItems$().center__Lscommons_reactnative_ViewStyle$AlignItems(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this\u00f8.flex = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(1, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this\u00f8.flexDirection = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($m_Lscommons_reactnative_ViewStyle$FlexDirection$().row__Lscommons_reactnative_ViewStyle$FlexDirection(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this\u00f8.flexWrap = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($m_Lscommons_reactnative_ViewStyle$FlexWrap$().wrap__Lscommons_reactnative_ViewStyle$FlexWrap(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this\u00f8.justifyContent = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($m_Lscommons_reactnative_ViewStyle$JustifyContent$().center__Lscommons_reactnative_ViewStyle$JustifyContent(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this\u00f8.backgroundColor = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($m_Lscommons_reactnative_Style$Color$().white__T(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          $s_sr_Statics__releaseFence__V();
          return this\u00f8
        })
      })(Object, this)();
      this.exampleContainer = (function(superClass$, arg$outer) {
        return (function() {
          var outer = arg$outer;
          var this$2 = {};
          this$2.borderWidth = null;
          this$2.width = null;
          this$2.height = null;
          this$2.marginLeft = null;
          this$2.marginBottom = null;
          this$2.borderWidth = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(1, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this$2.width = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(120, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().right__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          this$2.height = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(120, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().right__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          this$2.marginLeft = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(20, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().right__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          this$2.marginBottom = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(20, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().right__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          $s_sr_Statics__releaseFence__V();
          return this$2
        })
      })(Object, this)();
      this.example = (function(superClass$, arg$outer) {
        return (function() {
          var outer = arg$outer;
          var this$3 = {};
          this$3.width = null;
          this$3.height = null;
          this$3.backgroundColor = null;
          this$3.borderWidth = null;
          this$3.justifyContent = null;
          this$3.width = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(50, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().right__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          this$3.height = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(50, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().right__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          this$3.backgroundColor = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($m_Lscommons_reactnative_Style$Color$().grey__T(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this$3.borderWidth = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(1, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this$3.justifyContent = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($m_Lscommons_reactnative_ViewStyle$JustifyContent$().center__Lscommons_reactnative_ViewStyle$JustifyContent(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          $s_sr_Statics__releaseFence__V();
          return this$3
        })
      })(Object, this)();
      this.centeredText = (function(superClass$, arg$outer) {
        return (function() {
          var outer = arg$outer;
          var this$4 = {};
          this$4.textAlign = null;
          this$4.margin = null;
          this$4.borderWidth = null;
          this$4.backgroundColor = null;
          this$4.textAlign = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($m_Lscommons_reactnative_TextStyle$TextAlign$().center__Lscommons_reactnative_TextStyle$TextAlign(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this$4.margin = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(10, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().right__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          this$4.borderWidth = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(1, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this$4.backgroundColor = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($m_Lscommons_reactnative_Style$Color$().lightgrey__T(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          $s_sr_Statics__releaseFence__V();
          return this$4
        })
      })(Object, this)()
    });
    /** @constructor */
    var $hh_Lshowcase_app_style_PaddingStyleDemo$Styles = (function() {
      /*<skip>*/
    });
    $hh_Lshowcase_app_style_PaddingStyleDemo$Styles.prototype = Object.prototype;
    $b_Lshowcase_app_style_PaddingStyleDemo$Styles.prototype = new $hh_Lshowcase_app_style_PaddingStyleDemo$Styles();
    $b_Lshowcase_app_style_PaddingStyleDemo$Styles.prototype.constructor = $b_Lshowcase_app_style_PaddingStyleDemo$Styles
  };
  return $b_Lshowcase_app_style_PaddingStyleDemo$Styles
}
function $p_Lshowcase_app_style_PositionStyleDemo$__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz) {
  if (((((2 & $thiz.Lshowcase_app_style_PositionStyleDemo$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lshowcase_app_style_PositionStyleDemo$__f_scommons$react$UiComponent$$reactClass = $f_Lscommons_react_FunctionComponent__create__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz);
    $thiz.Lshowcase_app_style_PositionStyleDemo$__f_bitmap$0 = (((2 | $thiz.Lshowcase_app_style_PositionStyleDemo$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lshowcase_app_style_PositionStyleDemo$__f_scommons$react$UiComponent$$reactClass
}
function $p_Lshowcase_app_style_PositionStyleDemo$__styles$lzycompute__Lshowcase_app_style_PositionStyleDemo$Styles($thiz) {
  if (((((1 & $thiz.Lshowcase_app_style_PositionStyleDemo$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lshowcase_app_style_PositionStyleDemo$__f_styles = $m_Lscommons_reactnative_StyleSheet$().create__sjs_js_Object__sjs_js_Object(new ($a_Lshowcase_app_style_PositionStyleDemo$Styles())());
    $thiz.Lshowcase_app_style_PositionStyleDemo$__f_bitmap$0 = (((1 | $thiz.Lshowcase_app_style_PositionStyleDemo$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lshowcase_app_style_PositionStyleDemo$__f_styles
}
/** @constructor */
function $c_Lshowcase_app_style_PositionStyleDemo$() {
  this.Lshowcase_app_style_PositionStyleDemo$__f_styles = null;
  this.Lshowcase_app_style_PositionStyleDemo$__f_Example = null;
  this.Lshowcase_app_style_PositionStyleDemo$__f_CenteredText = null;
  this.Lshowcase_app_style_PositionStyleDemo$__f_exampleComp = null;
  this.Lshowcase_app_style_PositionStyleDemo$__f_centeredTextComp = null;
  this.Lshowcase_app_style_PositionStyleDemo$__f_scommons$react$UiComponent$$reactClass = null;
  this.Lshowcase_app_style_PositionStyleDemo$__f_bitmap$0 = 0;
  $n_Lshowcase_app_style_PositionStyleDemo$ = this;
  this.Lshowcase_app_style_PositionStyleDemo$__f_Example = new $c_Lshowcase_app_style_PositionStyleDemo$$anon$1();
  this.Lshowcase_app_style_PositionStyleDemo$__f_CenteredText = new $c_Lshowcase_app_style_PositionStyleDemo$$anon$2();
  this.Lshowcase_app_style_PositionStyleDemo$__f_exampleComp = this.Lshowcase_app_style_PositionStyleDemo$__f_Example;
  this.Lshowcase_app_style_PositionStyleDemo$__f_centeredTextComp = this.Lshowcase_app_style_PositionStyleDemo$__f_CenteredText
}
$c_Lshowcase_app_style_PositionStyleDemo$.prototype = new $h_O();
$c_Lshowcase_app_style_PositionStyleDemo$.prototype.constructor = $c_Lshowcase_app_style_PositionStyleDemo$;
/** @constructor */
function $h_Lshowcase_app_style_PositionStyleDemo$() {
  /*<skip>*/
}
$h_Lshowcase_app_style_PositionStyleDemo$.prototype = $c_Lshowcase_app_style_PositionStyleDemo$.prototype;
$c_Lshowcase_app_style_PositionStyleDemo$.prototype.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass = (function() {
  return (((((2 & this.Lshowcase_app_style_PositionStyleDemo$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lshowcase_app_style_PositionStyleDemo$__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass(this) : this.Lshowcase_app_style_PositionStyleDemo$__f_scommons$react$UiComponent$$reactClass)
});
$c_Lshowcase_app_style_PositionStyleDemo$.prototype.render__Lio_github_shogowada_scalajs_reactjs_React$Props__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement = (function(props) {
  var elements = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x30 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements).View__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var attributes = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array = [new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__Lscommons_reactnative_Style__Lio_github_shogowada_statictags_Attribute(this.styles__Lshowcase_app_style_PositionStyleDemo$Styles().screen)];
  var $$x29 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var elements$1 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x28 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements$1).View__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var attributes$1 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array$1 = [new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$1).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__Lscommons_reactnative_Style__Lio_github_shogowada_statictags_Attribute(this.styles__Lshowcase_app_style_PositionStyleDemo$Styles().container)];
  var $$x27 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  var elements$2 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x26 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements$2).View__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var attributes$2 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array$2 = [new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$2).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__Lscommons_reactnative_Style__Lio_github_shogowada_statictags_Attribute(this.styles__Lshowcase_app_style_PositionStyleDemo$Styles().row)];
  var $$x25 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var this$16 = this.Lshowcase_app_style_PositionStyleDemo$__f_exampleComp;
  var reactClass = this$16.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass();
  var $$x24 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass);
  var $$x23 = $m_sci_Nil$();
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var this$18 = this.Lshowcase_app_style_PositionStyleDemo$__f_centeredTextComp;
  var reactClass$1 = this$18.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass();
  var $$x22 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass$1);
  var $$x21 = $m_sci_Nil$();
  var array$3 = ["A"];
  var array$4 = [$$x22.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x21, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3))];
  var $$x20 = $$x24.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x23, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4));
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var this$26 = this.Lshowcase_app_style_PositionStyleDemo$__f_exampleComp;
  var reactClass$2 = this$26.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass();
  var $$x19 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass$2);
  var $$x18 = $m_sci_Nil$();
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var this$28 = this.Lshowcase_app_style_PositionStyleDemo$__f_centeredTextComp;
  var reactClass$3 = this$28.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass();
  var $$x17 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass$3);
  var $$x16 = $m_sci_Nil$();
  var array$5 = ["B"];
  var $$x15 = $$x17.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x16, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5));
  var elements$3 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x14 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements$3).View__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var attributes$3 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array$6 = [new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$3).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__sjs_js_Array__Lio_github_shogowada_statictags_Attribute([this.styles__Lshowcase_app_style_PositionStyleDemo$Styles().tinyExample, this.styles__Lshowcase_app_style_PositionStyleDemo$Styles().positionAbsolute])];
  var $$x13 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6);
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var this$38 = this.Lshowcase_app_style_PositionStyleDemo$__f_centeredTextComp;
  var reactClass$4 = this$38.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass();
  var $$x12 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass$4);
  var $$x11 = $m_sci_Nil$();
  var array$7 = ["E"];
  var array$8 = [$$x12.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x11, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7))];
  var array$9 = [$$x15, $$x14.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x13, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8))];
  var $$x10 = $$x19.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x18, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9));
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var this$49 = this.Lshowcase_app_style_PositionStyleDemo$__f_exampleComp;
  var reactClass$5 = this$49.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass();
  var $$x9 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass$5);
  var $$x8 = $m_sci_Nil$();
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var this$51 = this.Lshowcase_app_style_PositionStyleDemo$__f_centeredTextComp;
  var reactClass$6 = this$51.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass();
  var $$x7 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass$6);
  var $$x6 = $m_sci_Nil$();
  var array$10 = ["C"];
  var array$11 = [$$x7.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x6, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$10))];
  var array$12 = [$$x20, $$x10, $$x9.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x8, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$11))];
  var $$x5 = $$x26.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x25, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$12));
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var this$62 = this.Lshowcase_app_style_PositionStyleDemo$__f_exampleComp;
  var reactClass$7 = this$62.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass();
  var $$x4 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass$7);
  var attributes$4 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array$13 = [new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$4).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__Lscommons_reactnative_Style__Lio_github_shogowada_statictags_Attribute(this.styles__Lshowcase_app_style_PositionStyleDemo$Styles().positionAbsolute)];
  var $$x3 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$13);
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var this$68 = this.Lshowcase_app_style_PositionStyleDemo$__f_centeredTextComp;
  var reactClass$8 = this$68.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass();
  var $$x2 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass$8);
  var $$x1 = $m_sci_Nil$();
  var array$14 = ["D"];
  var array$15 = [$$x2.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x1, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$14))];
  var array$16 = [$$x5, $$x4.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x3, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$15))];
  var array$17 = [$$x28.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x27, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$16))];
  return $$x30.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x29, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$17))
});
$c_Lshowcase_app_style_PositionStyleDemo$.prototype.styles__Lshowcase_app_style_PositionStyleDemo$Styles = (function() {
  return (((((1 & this.Lshowcase_app_style_PositionStyleDemo$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lshowcase_app_style_PositionStyleDemo$__styles$lzycompute__Lshowcase_app_style_PositionStyleDemo$Styles(this) : this.Lshowcase_app_style_PositionStyleDemo$__f_styles)
});
var $d_Lshowcase_app_style_PositionStyleDemo$ = new $TypeData().initClass({
  Lshowcase_app_style_PositionStyleDemo$: 0
}, false, "showcase.app.style.PositionStyleDemo$", {
  Lshowcase_app_style_PositionStyleDemo$: 1,
  O: 1,
  Lscommons_react_FunctionComponent: 1,
  Lscommons_react_UiComponent: 1
});
$c_Lshowcase_app_style_PositionStyleDemo$.prototype.$classData = $d_Lshowcase_app_style_PositionStyleDemo$;
var $n_Lshowcase_app_style_PositionStyleDemo$;
function $m_Lshowcase_app_style_PositionStyleDemo$() {
  if ((!$n_Lshowcase_app_style_PositionStyleDemo$)) {
    $n_Lshowcase_app_style_PositionStyleDemo$ = new $c_Lshowcase_app_style_PositionStyleDemo$()
  };
  return $n_Lshowcase_app_style_PositionStyleDemo$
}
function $p_Lshowcase_app_style_PositionStyleDemo$$anon$1__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz) {
  if ((!$thiz.Lshowcase_app_style_PositionStyleDemo$$anon$1__f_bitmap$0)) {
    $thiz.Lshowcase_app_style_PositionStyleDemo$$anon$1__f_scommons$react$UiComponent$$reactClass = $f_Lscommons_react_FunctionComponent__create__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz);
    $thiz.Lshowcase_app_style_PositionStyleDemo$$anon$1__f_bitmap$0 = true
  };
  return $thiz.Lshowcase_app_style_PositionStyleDemo$$anon$1__f_scommons$react$UiComponent$$reactClass
}
/** @constructor */
function $c_Lshowcase_app_style_PositionStyleDemo$$anon$1() {
  this.Lshowcase_app_style_PositionStyleDemo$$anon$1__f_scommons$react$UiComponent$$reactClass = null;
  this.Lshowcase_app_style_PositionStyleDemo$$anon$1__f_bitmap$0 = false
}
$c_Lshowcase_app_style_PositionStyleDemo$$anon$1.prototype = new $h_O();
$c_Lshowcase_app_style_PositionStyleDemo$$anon$1.prototype.constructor = $c_Lshowcase_app_style_PositionStyleDemo$$anon$1;
/** @constructor */
function $h_Lshowcase_app_style_PositionStyleDemo$$anon$1() {
  /*<skip>*/
}
$h_Lshowcase_app_style_PositionStyleDemo$$anon$1.prototype = $c_Lshowcase_app_style_PositionStyleDemo$$anon$1.prototype;
$c_Lshowcase_app_style_PositionStyleDemo$$anon$1.prototype.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass = (function() {
  return ((!this.Lshowcase_app_style_PositionStyleDemo$$anon$1__f_bitmap$0) ? $p_Lshowcase_app_style_PositionStyleDemo$$anon$1__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass(this) : this.Lshowcase_app_style_PositionStyleDemo$$anon$1__f_scommons$react$UiComponent$$reactClass)
});
$c_Lshowcase_app_style_PositionStyleDemo$$anon$1.prototype.render__Lio_github_shogowada_scalajs_reactjs_React$Props__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement = (function(props) {
  var elements = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x2 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements).View__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var attributes = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array = [new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__sjs_js_Array__Lio_github_shogowada_statictags_Attribute([$m_Lshowcase_app_style_PositionStyleDemo$().styles__Lshowcase_app_style_PositionStyleDemo$Styles().example, props.Lio_github_shogowada_scalajs_reactjs_React$Props__f_native.style])];
  var $$x1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var array$1 = [props.children__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement()];
  return $$x2.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x1, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
});
var $d_Lshowcase_app_style_PositionStyleDemo$$anon$1 = new $TypeData().initClass({
  Lshowcase_app_style_PositionStyleDemo$$anon$1: 0
}, false, "showcase.app.style.PositionStyleDemo$$anon$1", {
  Lshowcase_app_style_PositionStyleDemo$$anon$1: 1,
  O: 1,
  Lscommons_react_FunctionComponent: 1,
  Lscommons_react_UiComponent: 1
});
$c_Lshowcase_app_style_PositionStyleDemo$$anon$1.prototype.$classData = $d_Lshowcase_app_style_PositionStyleDemo$$anon$1;
function $p_Lshowcase_app_style_PositionStyleDemo$$anon$2__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz) {
  if ((!$thiz.Lshowcase_app_style_PositionStyleDemo$$anon$2__f_bitmap$0)) {
    $thiz.Lshowcase_app_style_PositionStyleDemo$$anon$2__f_scommons$react$UiComponent$$reactClass = $f_Lscommons_react_FunctionComponent__create__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz);
    $thiz.Lshowcase_app_style_PositionStyleDemo$$anon$2__f_bitmap$0 = true
  };
  return $thiz.Lshowcase_app_style_PositionStyleDemo$$anon$2__f_scommons$react$UiComponent$$reactClass
}
/** @constructor */
function $c_Lshowcase_app_style_PositionStyleDemo$$anon$2() {
  this.Lshowcase_app_style_PositionStyleDemo$$anon$2__f_scommons$react$UiComponent$$reactClass = null;
  this.Lshowcase_app_style_PositionStyleDemo$$anon$2__f_bitmap$0 = false
}
$c_Lshowcase_app_style_PositionStyleDemo$$anon$2.prototype = new $h_O();
$c_Lshowcase_app_style_PositionStyleDemo$$anon$2.prototype.constructor = $c_Lshowcase_app_style_PositionStyleDemo$$anon$2;
/** @constructor */
function $h_Lshowcase_app_style_PositionStyleDemo$$anon$2() {
  /*<skip>*/
}
$h_Lshowcase_app_style_PositionStyleDemo$$anon$2.prototype = $c_Lshowcase_app_style_PositionStyleDemo$$anon$2.prototype;
$c_Lshowcase_app_style_PositionStyleDemo$$anon$2.prototype.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass = (function() {
  return ((!this.Lshowcase_app_style_PositionStyleDemo$$anon$2__f_bitmap$0) ? $p_Lshowcase_app_style_PositionStyleDemo$$anon$2__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass(this) : this.Lshowcase_app_style_PositionStyleDemo$$anon$2__f_scommons$react$UiComponent$$reactClass)
});
$c_Lshowcase_app_style_PositionStyleDemo$$anon$2.prototype.render__Lio_github_shogowada_scalajs_reactjs_React$Props__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement = (function(props) {
  var elements = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x2 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements).Text__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var attributes = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array = [new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__sjs_js_Array__Lio_github_shogowada_statictags_Attribute([$m_Lshowcase_app_style_PositionStyleDemo$().styles__Lshowcase_app_style_PositionStyleDemo$Styles().centeredText, props.Lio_github_shogowada_scalajs_reactjs_React$Props__f_native.style])];
  var $$x1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var array$1 = [props.children__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement()];
  return $$x2.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x1, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
});
var $d_Lshowcase_app_style_PositionStyleDemo$$anon$2 = new $TypeData().initClass({
  Lshowcase_app_style_PositionStyleDemo$$anon$2: 0
}, false, "showcase.app.style.PositionStyleDemo$$anon$2", {
  Lshowcase_app_style_PositionStyleDemo$$anon$2: 1,
  O: 1,
  Lscommons_react_FunctionComponent: 1,
  Lscommons_react_UiComponent: 1
});
$c_Lshowcase_app_style_PositionStyleDemo$$anon$2.prototype.$classData = $d_Lshowcase_app_style_PositionStyleDemo$$anon$2;
var $b_Lshowcase_app_style_PositionStyleDemo$Styles;
function $a_Lshowcase_app_style_PositionStyleDemo$Styles() {
  if ((!$b_Lshowcase_app_style_PositionStyleDemo$Styles)) {
    /** @constructor */
    $b_Lshowcase_app_style_PositionStyleDemo$Styles = (function() {
      Object.call(this);
      Object.defineProperty(this, "screen", {
        "configurable": true,
        "enumerable": true,
        "writable": true,
        "value": null
      });
      Object.defineProperty(this, "container", {
        "configurable": true,
        "enumerable": true,
        "writable": true,
        "value": null
      });
      Object.defineProperty(this, "row", {
        "configurable": true,
        "enumerable": true,
        "writable": true,
        "value": null
      });
      Object.defineProperty(this, "example", {
        "configurable": true,
        "enumerable": true,
        "writable": true,
        "value": null
      });
      Object.defineProperty(this, "tinyExample", {
        "configurable": true,
        "enumerable": true,
        "writable": true,
        "value": null
      });
      Object.defineProperty(this, "centeredText", {
        "configurable": true,
        "enumerable": true,
        "writable": true,
        "value": null
      });
      Object.defineProperty(this, "positionAbsolute", {
        "configurable": true,
        "enumerable": true,
        "writable": true,
        "value": null
      });
      this.screen = (function(superClass$, arg$outer) {
        return (function() {
          var outer = arg$outer;
          var this\u00f8 = {};
          this\u00f8.flex = null;
          this\u00f8.justifyContent = null;
          this\u00f8.alignItems = null;
          this\u00f8.backgroundColor = null;
          this\u00f8.flex = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(1, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this\u00f8.justifyContent = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($m_Lscommons_reactnative_ViewStyle$JustifyContent$().center__Lscommons_reactnative_ViewStyle$JustifyContent(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this\u00f8.alignItems = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($m_Lscommons_reactnative_ViewStyle$AlignItems$().center__Lscommons_reactnative_ViewStyle$AlignItems(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this\u00f8.backgroundColor = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($m_Lscommons_reactnative_Style$Color$().white__T(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          $s_sr_Statics__releaseFence__V();
          return this\u00f8
        })
      })(Object, this)();
      this.container = (function(superClass$, arg$outer) {
        return (function() {
          var outer = arg$outer;
          var this$2 = {};
          this$2.width = null;
          this$2.height = null;
          this$2.marginLeft = null;
          this$2.marginBottom = null;
          this$2.borderWidth = null;
          this$2.width = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(300, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().right__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          this$2.height = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(300, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().right__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          this$2.marginLeft = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(40, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().right__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          this$2.marginBottom = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(20, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().right__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          this$2.borderWidth = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(1, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          $s_sr_Statics__releaseFence__V();
          return this$2
        })
      })(Object, this)();
      this.row = (function(superClass$, arg$outer) {
        return (function() {
          var outer = arg$outer;
          var this$3 = {};
          this$3.flex = null;
          this$3.flexDirection = null;
          this$3.flex = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(1, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this$3.flexDirection = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($m_Lscommons_reactnative_ViewStyle$FlexDirection$().row__Lscommons_reactnative_ViewStyle$FlexDirection(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          $s_sr_Statics__releaseFence__V();
          return this$3
        })
      })(Object, this)();
      this.example = (function(superClass$, arg$outer) {
        return (function() {
          var outer = arg$outer;
          var this$4 = {};
          this$4.width = null;
          this$4.height = null;
          this$4.backgroundColor = null;
          this$4.borderWidth = null;
          this$4.justifyContent = null;
          this$4.width = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(100, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().right__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          this$4.height = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(100, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().right__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          this$4.backgroundColor = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($m_Lscommons_reactnative_Style$Color$().grey__T(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this$4.borderWidth = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(1, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this$4.justifyContent = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($m_Lscommons_reactnative_ViewStyle$JustifyContent$().center__Lscommons_reactnative_ViewStyle$JustifyContent(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          $s_sr_Statics__releaseFence__V();
          return this$4
        })
      })(Object, this)();
      this.tinyExample = (function(superClass$, arg$outer) {
        return (function() {
          var outer = arg$outer;
          var this$5 = {};
          this$5.width = null;
          this$5.height = null;
          this$5.borderWidth = null;
          this$5.justifyContent = null;
          this$5.backgroundColor = null;
          this$5.width = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(30, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().right__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          this$5.height = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(30, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().right__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          this$5.borderWidth = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(1, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this$5.justifyContent = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($m_Lscommons_reactnative_ViewStyle$JustifyContent$().center__Lscommons_reactnative_ViewStyle$JustifyContent(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this$5.backgroundColor = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($m_Lscommons_reactnative_Style$Color$().lightgrey__T(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          $s_sr_Statics__releaseFence__V();
          return this$5
        })
      })(Object, this)();
      this.centeredText = (function(superClass$, arg$outer) {
        return (function() {
          var outer = arg$outer;
          var this$6 = {};
          this$6.textAlign = null;
          this$6.margin = null;
          this$6.textAlign = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($m_Lscommons_reactnative_TextStyle$TextAlign$().center__Lscommons_reactnative_TextStyle$TextAlign(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this$6.margin = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(10, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().right__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          $s_sr_Statics__releaseFence__V();
          return this$6
        })
      })(Object, this)();
      this.positionAbsolute = (function(superClass$, arg$outer) {
        return (function() {
          var outer = arg$outer;
          var this$7 = {};
          this$7.position = null;
          this$7.right = null;
          this$7.bottom = null;
          this$7.position = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($m_Lscommons_reactnative_Style$Position$().absolute__Lscommons_reactnative_Style$Position(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this$7.right = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(0, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().right__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          this$7.bottom = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(0, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().right__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          $s_sr_Statics__releaseFence__V();
          return this$7
        })
      })(Object, this)()
    });
    /** @constructor */
    var $hh_Lshowcase_app_style_PositionStyleDemo$Styles = (function() {
      /*<skip>*/
    });
    $hh_Lshowcase_app_style_PositionStyleDemo$Styles.prototype = Object.prototype;
    $b_Lshowcase_app_style_PositionStyleDemo$Styles.prototype = new $hh_Lshowcase_app_style_PositionStyleDemo$Styles();
    $b_Lshowcase_app_style_PositionStyleDemo$Styles.prototype.constructor = $b_Lshowcase_app_style_PositionStyleDemo$Styles
  };
  return $b_Lshowcase_app_style_PositionStyleDemo$Styles
}
function $p_Lshowcase_app_style_ProfileCard$__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz) {
  if (((((2 & $thiz.Lshowcase_app_style_ProfileCard$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lshowcase_app_style_ProfileCard$__f_scommons$react$UiComponent$$reactClass = $f_Lscommons_react_FunctionComponent__create__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz);
    $thiz.Lshowcase_app_style_ProfileCard$__f_bitmap$0 = (((2 | $thiz.Lshowcase_app_style_ProfileCard$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lshowcase_app_style_ProfileCard$__f_scommons$react$UiComponent$$reactClass
}
function $p_Lshowcase_app_style_ProfileCard$__styles$lzycompute__Lshowcase_app_style_ProfileCard$Styles($thiz) {
  if (((((1 & $thiz.Lshowcase_app_style_ProfileCard$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lshowcase_app_style_ProfileCard$__f_styles = $m_Lscommons_reactnative_StyleSheet$().create__sjs_js_Object__sjs_js_Object(new ($a_Lshowcase_app_style_ProfileCard$Styles())());
    $thiz.Lshowcase_app_style_ProfileCard$__f_bitmap$0 = (((1 | $thiz.Lshowcase_app_style_ProfileCard$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lshowcase_app_style_ProfileCard$__f_styles
}
/** @constructor */
function $c_Lshowcase_app_style_ProfileCard$() {
  this.Lshowcase_app_style_ProfileCard$__f_styles = null;
  this.Lshowcase_app_style_ProfileCard$__f_showcase$app$style$ProfileCard$$profileCardColor = null;
  this.Lshowcase_app_style_ProfileCard$__f_scommons$react$UiComponent$$reactClass = null;
  this.Lshowcase_app_style_ProfileCard$__f_bitmap$0 = 0;
  $n_Lshowcase_app_style_ProfileCard$ = this;
  this.Lshowcase_app_style_ProfileCard$__f_showcase$app$style$ProfileCard$$profileCardColor = $m_Lscommons_reactnative_Style$Color$().Lscommons_reactnative_Style$Color$__f_dodgerblue
}
$c_Lshowcase_app_style_ProfileCard$.prototype = new $h_O();
$c_Lshowcase_app_style_ProfileCard$.prototype.constructor = $c_Lshowcase_app_style_ProfileCard$;
/** @constructor */
function $h_Lshowcase_app_style_ProfileCard$() {
  /*<skip>*/
}
$h_Lshowcase_app_style_ProfileCard$.prototype = $c_Lshowcase_app_style_ProfileCard$.prototype;
$c_Lshowcase_app_style_ProfileCard$.prototype.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass = (function() {
  return (((((2 & this.Lshowcase_app_style_ProfileCard$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lshowcase_app_style_ProfileCard$__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass(this) : this.Lshowcase_app_style_ProfileCard$__f_scommons$react$UiComponent$$reactClass)
});
$c_Lshowcase_app_style_ProfileCard$.prototype.render__Lio_github_shogowada_scalajs_reactjs_React$Props__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement = (function(props) {
  var elements = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x23 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements).View__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var attributes = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array = [new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__Lscommons_reactnative_Style__Lio_github_shogowada_statictags_Attribute(this.styles__Lshowcase_app_style_ProfileCard$Styles().container)];
  var $$x22 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var elements$1 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x21 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements$1).View__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var attributes$1 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array$1 = [new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$1).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__sjs_js_Array__Lio_github_shogowada_statictags_Attribute([this.styles__Lshowcase_app_style_ProfileCard$Styles().cardContainer, this.styles__Lshowcase_app_style_ProfileCard$Styles().cardContainerShadow])];
  var $$x20 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  var elements$2 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x19 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements$2).View__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var attributes$2 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array$2 = [new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$2).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__sjs_js_Array__Lio_github_shogowada_statictags_Attribute([this.styles__Lshowcase_app_style_ProfileCard$Styles().cardImageContainer, this.styles__Lshowcase_app_style_ProfileCard$Styles().cardImageContainerShadow])];
  var $$x18 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
  var elements$3 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x17 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements$3).Image__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var attributes$3 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var $$x16 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$3).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__Lscommons_reactnative_Style__Lio_github_shogowada_statictags_Attribute(this.styles__Lshowcase_app_style_ProfileCard$Styles().cardImage);
  var attributes$4 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array$3 = [$$x16, new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$4).source__Lscommons_reactnative_Image$ImageAttributes$ImageSourceAttributeSpec().$colon$eq__Lscommons_reactnative_raw_StaticResource__Lio_github_shogowada_statictags_Attribute($i_$002e$002fshowcase$002fapp$002fuser$002epng)];
  var array$4 = [$$x17.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3), $m_sci_Nil$())];
  var $$x15 = $$x19.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x18, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4));
  var elements$4 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x14 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements$4).View__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var $$x13 = $m_sci_Nil$();
  var elements$5 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x12 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements$5).Text__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var attributes$5 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array$5 = [new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$5).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__Lscommons_reactnative_Style__Lio_github_shogowada_statictags_Attribute(this.styles__Lshowcase_app_style_ProfileCard$Styles().cardName)];
  var $$x11 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5);
  var array$6 = ["John Doe"];
  var array$7 = [$$x12.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x11, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6))];
  var $$x10 = $$x14.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x13, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7));
  var elements$6 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x9 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements$6).View__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var attributes$6 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array$8 = [new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$6).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__Lscommons_reactnative_Style__Lio_github_shogowada_statictags_Attribute(this.styles__Lshowcase_app_style_ProfileCard$Styles().cardOccupationContainer)];
  var $$x8 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8);
  var elements$7 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x7 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements$7).Text__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var attributes$7 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array$9 = [new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$7).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__Lscommons_reactnative_Style__Lio_github_shogowada_statictags_Attribute(this.styles__Lshowcase_app_style_ProfileCard$Styles().cardOccupation)];
  var $$x6 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9);
  var array$10 = ["React Native Developer"];
  var array$11 = [$$x7.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x6, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$10))];
  var $$x5 = $$x9.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x8, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$11));
  var elements$8 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x4 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements$8).View__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var $$x3 = $m_sci_Nil$();
  var elements$9 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x2 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements$9).Text__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var attributes$8 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array$12 = [new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$8).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__Lscommons_reactnative_Style__Lio_github_shogowada_statictags_Attribute(this.styles__Lshowcase_app_style_ProfileCard$Styles().cardDescription)];
  var $$x1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$12);
  var array$13 = ["John is a really great JavaScript developer. He loves using JS to build React Native applications for iOS and Android."];
  var array$14 = [$$x2.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x1, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$13))];
  var array$15 = [$$x15, $$x10, $$x5, $$x4.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x3, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$14))];
  var array$16 = [$$x21.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x20, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$15))];
  return $$x23.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x22, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$16))
});
$c_Lshowcase_app_style_ProfileCard$.prototype.showcase$app$style$ProfileCard$$profileCardColor__T = (function() {
  return this.Lshowcase_app_style_ProfileCard$__f_showcase$app$style$ProfileCard$$profileCardColor
});
$c_Lshowcase_app_style_ProfileCard$.prototype.styles__Lshowcase_app_style_ProfileCard$Styles = (function() {
  return (((((1 & this.Lshowcase_app_style_ProfileCard$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lshowcase_app_style_ProfileCard$__styles$lzycompute__Lshowcase_app_style_ProfileCard$Styles(this) : this.Lshowcase_app_style_ProfileCard$__f_styles)
});
var $d_Lshowcase_app_style_ProfileCard$ = new $TypeData().initClass({
  Lshowcase_app_style_ProfileCard$: 0
}, false, "showcase.app.style.ProfileCard$", {
  Lshowcase_app_style_ProfileCard$: 1,
  O: 1,
  Lscommons_react_FunctionComponent: 1,
  Lscommons_react_UiComponent: 1
});
$c_Lshowcase_app_style_ProfileCard$.prototype.$classData = $d_Lshowcase_app_style_ProfileCard$;
var $n_Lshowcase_app_style_ProfileCard$;
function $m_Lshowcase_app_style_ProfileCard$() {
  if ((!$n_Lshowcase_app_style_ProfileCard$)) {
    $n_Lshowcase_app_style_ProfileCard$ = new $c_Lshowcase_app_style_ProfileCard$()
  };
  return $n_Lshowcase_app_style_ProfileCard$
}
function $ps_Lshowcase_app_style_ProfileCard$Styles__$anonfun$cardContainerShadow$1__Lshowcase_app_style_ProfileCard$Styles__Lscommons_reactnative_Platform__Lscommons_reactnative_Style(this$1, x0$1) {
  var x = $m_Lscommons_reactnative_Platform$ios$();
  if ((x === x0$1)) {
    var $$x1 = true
  } else {
    var x$3 = $m_Lscommons_reactnative_Platform$web$();
    var $$x1 = (x$3 === x0$1)
  };
  if ($$x1) {
    return (function(superClass$, arg$outer) {
      return (function() {
        var this$2 = {};
        this$2.shadowColor = null;
        this$2.shadowOffset = null;
        this$2.shadowOpacity = null;
        var a = $m_Lscommons_reactnative_Style$Color$().Lscommons_reactnative_Style$Color$__f_black;
        this$2.shadowColor = a;
        var a$1 = (function(superClass$$1, arg$outer$1) {
          return (function() {
            var this$6 = {};
            this$6.height = null;
            this$6.height = 10;
            return this$6
          })
        })(Object, this$2)();
        this$2.shadowOffset = a$1;
        this$2.shadowOpacity = 1;
        return this$2
      })
    })(Object, this$1)()
  } else {
    var x$5 = $m_Lscommons_reactnative_Platform$android$();
    if ((x$5 === x0$1)) {
      return (function(superClass$$2, arg$outer$2) {
        return (function() {
          var this$3$1 = {};
          this$3$1.elevation = null;
          this$3$1.elevation = 15;
          return this$3$1
        })
      })(Object, this$1)()
    } else {
      throw new $c_s_MatchError(x0$1)
    }
  }
}
function $ps_Lshowcase_app_style_ProfileCard$Styles__$anonfun$cardImageContainerShadow$1__Lshowcase_app_style_ProfileCard$Styles__Lscommons_reactnative_Platform__Lscommons_reactnative_Style(this$1, x0$2) {
  var x = $m_Lscommons_reactnative_Platform$ios$();
  if ((x === x0$2)) {
    var $$x1 = true
  } else {
    var x$3 = $m_Lscommons_reactnative_Platform$web$();
    var $$x1 = (x$3 === x0$2)
  };
  if ($$x1) {
    return (function(superClass$, arg$outer) {
      return (function() {
        var this$2 = {};
        this$2.shadowColor = null;
        this$2.shadowOffset = null;
        this$2.shadowOpacity = null;
        var a = $m_Lscommons_reactnative_Style$Color$().Lscommons_reactnative_Style$Color$__f_black;
        this$2.shadowColor = a;
        var a$1 = (function(superClass$$1, arg$outer$1) {
          return (function() {
            var this$6 = {};
            this$6.height = null;
            this$6.height = 10;
            return this$6
          })
        })(Object, this$2)();
        this$2.shadowOffset = a$1;
        this$2.shadowOpacity = 1;
        return this$2
      })
    })(Object, this$1)()
  } else {
    var x$5 = $m_Lscommons_reactnative_Platform$android$();
    if ((x$5 === x0$2)) {
      return (function(superClass$$2, arg$outer$2) {
        return (function() {
          var this$3$1 = {};
          this$3$1.borderWidth = null;
          this$3$1.borderColor = null;
          this$3$1.elevation = null;
          this$3$1.borderWidth = 3;
          var a$2 = $m_Lscommons_reactnative_Style$Color$().Lscommons_reactnative_Style$Color$__f_black;
          this$3$1.borderColor = a$2;
          this$3$1.elevation = 15;
          return this$3$1
        })
      })(Object, this$1)()
    } else {
      throw new $c_s_MatchError(x0$2)
    }
  }
}
var $b_Lshowcase_app_style_ProfileCard$Styles;
function $a_Lshowcase_app_style_ProfileCard$Styles() {
  if ((!$b_Lshowcase_app_style_ProfileCard$Styles)) {
    /** @constructor */
    $b_Lshowcase_app_style_ProfileCard$Styles = (function() {
      Object.call(this);
      Object.defineProperty(this, "container", {
        "configurable": true,
        "enumerable": true,
        "writable": true,
        "value": null
      });
      Object.defineProperty(this, "cardContainer", {
        "configurable": true,
        "enumerable": true,
        "writable": true,
        "value": null
      });
      Object.defineProperty(this, "cardContainerShadow", {
        "configurable": true,
        "enumerable": true,
        "writable": true,
        "value": null
      });
      Object.defineProperty(this, "cardImageContainer", {
        "configurable": true,
        "enumerable": true,
        "writable": true,
        "value": null
      });
      Object.defineProperty(this, "cardImageContainerShadow", {
        "configurable": true,
        "enumerable": true,
        "writable": true,
        "value": null
      });
      Object.defineProperty(this, "cardImage", {
        "configurable": true,
        "enumerable": true,
        "writable": true,
        "value": null
      });
      Object.defineProperty(this, "cardName", {
        "configurable": true,
        "enumerable": true,
        "writable": true,
        "value": null
      });
      Object.defineProperty(this, "cardOccupationContainer", {
        "configurable": true,
        "enumerable": true,
        "writable": true,
        "value": null
      });
      Object.defineProperty(this, "cardOccupation", {
        "configurable": true,
        "enumerable": true,
        "writable": true,
        "value": null
      });
      Object.defineProperty(this, "cardDescription", {
        "configurable": true,
        "enumerable": true,
        "writable": true,
        "value": null
      });
      this.container = (function(superClass$, arg$outer) {
        return (function() {
          var outer = arg$outer;
          var this\u00f8 = {};
          this\u00f8.flex = null;
          this\u00f8.justifyContent = null;
          this\u00f8.alignItems = null;
          this\u00f8.flex = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(1, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this\u00f8.justifyContent = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($m_Lscommons_reactnative_ViewStyle$JustifyContent$().center__Lscommons_reactnative_ViewStyle$JustifyContent(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this\u00f8.alignItems = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($m_Lscommons_reactnative_ViewStyle$AlignItems$().center__Lscommons_reactnative_ViewStyle$AlignItems(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          $s_sr_Statics__releaseFence__V();
          return this\u00f8
        })
      })(Object, this)();
      this.cardContainer = (function(superClass$, arg$outer) {
        return (function() {
          var outer = arg$outer;
          var this$2 = {};
          this$2.alignItems = null;
          this$2.borderColor = null;
          this$2.borderWidth = null;
          this$2.borderStyle = null;
          this$2.borderRadius = null;
          this$2.backgroundColor = null;
          this$2.width = null;
          this$2.height = null;
          this$2.alignItems = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($m_Lscommons_reactnative_ViewStyle$AlignItems$().center__Lscommons_reactnative_ViewStyle$AlignItems(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this$2.borderColor = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($m_Lscommons_reactnative_Style$Color$().black__T(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this$2.borderWidth = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(3, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this$2.borderStyle = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($m_Lscommons_reactnative_Style$BorderStyle$().solid__Lscommons_reactnative_Style$BorderStyle(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this$2.borderRadius = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(20, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this$2.backgroundColor = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($m_Lshowcase_app_style_ProfileCard$().showcase$app$style$ProfileCard$$profileCardColor__T(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this$2.width = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(300, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().right__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          this$2.height = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(400, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().right__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          $s_sr_Statics__releaseFence__V();
          return this$2
        })
      })(Object, this)();
      this.cardContainerShadow = $m_Lscommons_reactnative_Platform$().select__F1__O(new $c_sjsr_AnonFunction1((function(this$3) {
        return (function(x0$1$2) {
          var x0$1 = $as_Lscommons_reactnative_Platform(x0$1$2);
          return $ps_Lshowcase_app_style_ProfileCard$Styles__$anonfun$cardContainerShadow$1__Lshowcase_app_style_ProfileCard$Styles__Lscommons_reactnative_Platform__Lscommons_reactnative_Style(this$3, x0$1)
        })
      })(this)));
      this.cardImageContainer = (function(superClass$, arg$outer) {
        return (function() {
          var outer = arg$outer;
          var this$4 = {};
          this$4.alignItems = null;
          this$4.backgroundColor = null;
          this$4.borderWidth = null;
          this$4.borderColor = null;
          this$4.width = null;
          this$4.height = null;
          this$4.borderRadius = null;
          this$4.marginTop = null;
          this$4.paddingTop = null;
          this$4.alignItems = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($m_Lscommons_reactnative_ViewStyle$AlignItems$().center__Lscommons_reactnative_ViewStyle$AlignItems(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this$4.backgroundColor = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($m_Lscommons_reactnative_Style$Color$().white__T(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this$4.borderWidth = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(3, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this$4.borderColor = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($m_Lscommons_reactnative_Style$Color$().black__T(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this$4.width = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(120, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().right__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          this$4.height = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(120, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().right__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          this$4.borderRadius = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(60, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this$4.marginTop = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(30, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().right__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          this$4.paddingTop = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(15, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().right__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          $s_sr_Statics__releaseFence__V();
          return this$4
        })
      })(Object, this)();
      this.cardImageContainerShadow = $m_Lscommons_reactnative_Platform$().select__F1__O(new $c_sjsr_AnonFunction1((function(this$5) {
        return (function(x0$2$2) {
          var x0$2 = $as_Lscommons_reactnative_Platform(x0$2$2);
          return $ps_Lshowcase_app_style_ProfileCard$Styles__$anonfun$cardImageContainerShadow$1__Lshowcase_app_style_ProfileCard$Styles__Lscommons_reactnative_Platform__Lscommons_reactnative_Style(this$5, x0$2)
        })
      })(this)));
      this.cardImage = (function(superClass$, arg$outer) {
        return (function() {
          var outer = arg$outer;
          var this$6 = {};
          this$6.width = null;
          this$6.height = null;
          this$6.width = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(80, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().right__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          this$6.height = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(80, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().right__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          $s_sr_Statics__releaseFence__V();
          return this$6
        })
      })(Object, this)();
      this.cardName = (function(superClass$, arg$outer) {
        return (function() {
          var outer = arg$outer;
          var this$7 = {};
          this$7.color = null;
          this$7.fontWeight = null;
          this$7.fontSize = null;
          this$7.marginTop = null;
          this$7.textShadowColor = null;
          this$7.textShadowOffset = null;
          this$7.textShadowRadius = null;
          this$7.color = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($m_Lscommons_reactnative_Style$Color$().white__T(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this$7.fontWeight = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($m_Lscommons_reactnative_TextStyle$FontWeight$().bold__Lscommons_reactnative_TextStyle$FontWeight(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this$7.fontSize = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(24, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this$7.marginTop = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(30, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().right__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          this$7.textShadowColor = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($m_Lscommons_reactnative_Style$Color$().black__T(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this$7.textShadowOffset = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar((function(superClass$, arg$outer) {
            return (function() {
              var outer = arg$outer;
              var this\u00f8 = {};
              this\u00f8.height = null;
              this\u00f8.width = null;
              this\u00f8.height = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(2, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
              this\u00f8.width = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(2, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
              return this\u00f8
            })
          })(Object, this$7)(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this$7.textShadowRadius = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(3, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          $s_sr_Statics__releaseFence__V();
          return this$7
        })
      })(Object, this)();
      this.cardOccupationContainer = (function(superClass$, arg$outer) {
        return (function() {
          var outer = arg$outer;
          var this$8 = {};
          this$8.borderColor = null;
          this$8.borderBottomWidth = null;
          this$8.borderColor = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($m_Lscommons_reactnative_Style$Color$().black__T(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this$8.borderBottomWidth = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(3, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          $s_sr_Statics__releaseFence__V();
          return this$8
        })
      })(Object, this)();
      this.cardOccupation = (function(superClass$, arg$outer) {
        return (function() {
          var outer = arg$outer;
          var this$9 = {};
          this$9.fontWeight = null;
          this$9.marginTop = null;
          this$9.marginBottom = null;
          this$9.fontWeight = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($m_Lscommons_reactnative_TextStyle$FontWeight$().bold__Lscommons_reactnative_TextStyle$FontWeight(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this$9.marginTop = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(10, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().right__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          this$9.marginBottom = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(10, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().right__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          $s_sr_Statics__releaseFence__V();
          return this$9
        })
      })(Object, this)();
      this.cardDescription = (function(superClass$, arg$outer) {
        return (function() {
          var outer = arg$outer;
          var this$10 = {};
          this$10.fontStyle = null;
          this$10.marginTop = null;
          this$10.marginRight = null;
          this$10.marginLeft = null;
          this$10.marginBottom = null;
          this$10.fontStyle = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($m_Lscommons_reactnative_TextStyle$FontStyle$().italic__Lscommons_reactnative_TextStyle$FontStyle(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this$10.marginTop = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(10, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().right__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          this$10.marginRight = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(40, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().right__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          this$10.marginLeft = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(40, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().right__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          this$10.marginBottom = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(10, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().right__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          $s_sr_Statics__releaseFence__V();
          return this$10
        })
      })(Object, this)()
    });
    /** @constructor */
    var $hh_Lshowcase_app_style_ProfileCard$Styles = (function() {
      /*<skip>*/
    });
    $hh_Lshowcase_app_style_ProfileCard$Styles.prototype = Object.prototype;
    $b_Lshowcase_app_style_ProfileCard$Styles.prototype = new $hh_Lshowcase_app_style_ProfileCard$Styles();
    $b_Lshowcase_app_style_ProfileCard$Styles.prototype.constructor = $b_Lshowcase_app_style_ProfileCard$Styles
  };
  return $b_Lshowcase_app_style_ProfileCard$Styles
}
function $p_Lshowcase_app_style_StylesScreen$__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz) {
  if ((!$thiz.Lshowcase_app_style_StylesScreen$__f_bitmap$0)) {
    $thiz.Lshowcase_app_style_StylesScreen$__f_scommons$react$UiComponent$$reactClass = $f_Lscommons_react_FunctionComponent__create__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz);
    $thiz.Lshowcase_app_style_StylesScreen$__f_bitmap$0 = true
  };
  return $thiz.Lshowcase_app_style_StylesScreen$__f_scommons$react$UiComponent$$reactClass
}
/** @constructor */
function $c_Lshowcase_app_style_StylesScreen$() {
  this.Lshowcase_app_style_StylesScreen$__f_scommons$react$UiComponent$$reactClass = null;
  this.Lshowcase_app_style_StylesScreen$__f_bitmap$0 = false
}
$c_Lshowcase_app_style_StylesScreen$.prototype = new $h_O();
$c_Lshowcase_app_style_StylesScreen$.prototype.constructor = $c_Lshowcase_app_style_StylesScreen$;
/** @constructor */
function $h_Lshowcase_app_style_StylesScreen$() {
  /*<skip>*/
}
$h_Lshowcase_app_style_StylesScreen$.prototype = $c_Lshowcase_app_style_StylesScreen$.prototype;
$c_Lshowcase_app_style_StylesScreen$.prototype.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass = (function() {
  return ((!this.Lshowcase_app_style_StylesScreen$__f_bitmap$0) ? $p_Lshowcase_app_style_StylesScreen$__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass(this) : this.Lshowcase_app_style_StylesScreen$__f_scommons$react$UiComponent$$reactClass)
});
$c_Lshowcase_app_style_StylesScreen$.prototype.render__Lio_github_shogowada_scalajs_reactjs_React$Props__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement = (function(compProps) {
  var props = $as_Lshowcase_app_style_StylesScreenProps(compProps.wrapped__O());
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var this$1 = $m_Lshowcase_app_ShowcaseListView$();
  var reactClass = this$1.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass();
  var $$x2 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass);
  var $$x1 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes().wrapped__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$WrappedPropsAttributeSpec();
  $m_s_package$();
  var array = [new $c_T2("BorderStyle", "Demo border styles"), new $c_T2("BorderRadius", "Demo border radius styles"), new $c_T2("MarginStyle", "Demo margin styles"), new $c_T2("PaddingStyle", "Demo padding styles"), new $c_T2("PositionStyle", "Demo position styles"), new $c_T2("TextStyle", "Demo text styles"), new $c_T2("ProfileCard", "Demo ProfileCard component")];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var array$1 = [$$x1.$colon$eq__O__Lio_github_shogowada_statictags_Attribute(new $c_Lshowcase_app_ShowcaseListViewProps($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems), props.Lshowcase_app_style_StylesScreenProps__f_navigate))];
  return $$x2.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1), $m_sci_Nil$())
});
$c_Lshowcase_app_style_StylesScreen$.prototype.getStylesStack__Lscommons_react_navigation_stack_raw_StackNavigator__sci_Seq = (function(stack) {
  $m_s_package$();
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var reactClass = stack.Screen;
  var $$x31 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass);
  var this$2 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes().name__Lio_github_shogowada_statictags_StringAttributeSpec();
  var $$x30 = new $c_Lio_github_shogowada_statictags_Attribute(this$2.Lio_github_shogowada_statictags_StringAttributeSpec__f_name, "Styles", $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$());
  $m_Lscommons_react_navigation_package$();
  var attributes = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var $$x29 = new $c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes(attributes).component__Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenComponentAttributeSpec();
  var this$5 = $m_Lshowcase_app_style_StylesScreenController$();
  var array = [$$x30, $$x29.$colon$eq__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass__Lio_github_shogowada_statictags_Attribute(this$5.scommons$react$redux$BaseStateController$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass())];
  var $$x28 = $$x31.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array), $m_sci_Nil$());
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var reactClass$1 = stack.Screen;
  var $$x27 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass$1);
  var this$10 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes().name__Lio_github_shogowada_statictags_StringAttributeSpec();
  var $$x26 = new $c_Lio_github_shogowada_statictags_Attribute(this$10.Lio_github_shogowada_statictags_StringAttributeSpec__f_name, "BorderStyle", $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$());
  $m_Lscommons_react_navigation_package$();
  var attributes$1 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var $$x25 = new $c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes(attributes$1).component__Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenComponentAttributeSpec();
  var this$13 = $m_Lshowcase_app_style_BorderStyleDemo$();
  var array$1 = [$$x26, $$x25.$colon$eq__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass__Lio_github_shogowada_statictags_Attribute(this$13.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass())];
  var $$x24 = $$x27.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1), $m_sci_Nil$());
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var reactClass$2 = stack.Screen;
  var $$x23 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass$2);
  var this$18 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes().name__Lio_github_shogowada_statictags_StringAttributeSpec();
  var $$x22 = new $c_Lio_github_shogowada_statictags_Attribute(this$18.Lio_github_shogowada_statictags_StringAttributeSpec__f_name, "BorderRadius", $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$());
  $m_Lscommons_react_navigation_package$();
  var attributes$2 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var $$x21 = new $c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes(attributes$2).component__Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenComponentAttributeSpec();
  var this$21 = $m_Lshowcase_app_style_BorderRadiusDemo$();
  var array$2 = [$$x22, $$x21.$colon$eq__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass__Lio_github_shogowada_statictags_Attribute(this$21.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass())];
  var $$x20 = $$x23.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2), $m_sci_Nil$());
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var reactClass$3 = stack.Screen;
  var $$x19 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass$3);
  var this$26 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes().name__Lio_github_shogowada_statictags_StringAttributeSpec();
  var $$x18 = new $c_Lio_github_shogowada_statictags_Attribute(this$26.Lio_github_shogowada_statictags_StringAttributeSpec__f_name, "MarginStyle", $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$());
  $m_Lscommons_react_navigation_package$();
  var attributes$3 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var $$x17 = new $c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes(attributes$3).component__Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenComponentAttributeSpec();
  var this$29 = $m_Lshowcase_app_style_MarginStyleDemo$();
  var array$3 = [$$x18, $$x17.$colon$eq__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass__Lio_github_shogowada_statictags_Attribute(this$29.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass())];
  var $$x16 = $$x19.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3), $m_sci_Nil$());
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var reactClass$4 = stack.Screen;
  var $$x15 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass$4);
  var this$34 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes().name__Lio_github_shogowada_statictags_StringAttributeSpec();
  var $$x14 = new $c_Lio_github_shogowada_statictags_Attribute(this$34.Lio_github_shogowada_statictags_StringAttributeSpec__f_name, "PaddingStyle", $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$());
  $m_Lscommons_react_navigation_package$();
  var attributes$4 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var $$x13 = new $c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes(attributes$4).component__Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenComponentAttributeSpec();
  var this$37 = $m_Lshowcase_app_style_PaddingStyleDemo$();
  var array$4 = [$$x14, $$x13.$colon$eq__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass__Lio_github_shogowada_statictags_Attribute(this$37.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass())];
  var $$x12 = $$x15.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4), $m_sci_Nil$());
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var reactClass$5 = stack.Screen;
  var $$x11 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass$5);
  var this$42 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes().name__Lio_github_shogowada_statictags_StringAttributeSpec();
  var $$x10 = new $c_Lio_github_shogowada_statictags_Attribute(this$42.Lio_github_shogowada_statictags_StringAttributeSpec__f_name, "PositionStyle", $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$());
  $m_Lscommons_react_navigation_package$();
  var attributes$5 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var $$x9 = new $c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes(attributes$5).component__Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenComponentAttributeSpec();
  var this$45 = $m_Lshowcase_app_style_PositionStyleDemo$();
  var array$5 = [$$x10, $$x9.$colon$eq__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass__Lio_github_shogowada_statictags_Attribute(this$45.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass())];
  var $$x8 = $$x11.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5), $m_sci_Nil$());
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var reactClass$6 = stack.Screen;
  var $$x7 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass$6);
  var this$50 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes().name__Lio_github_shogowada_statictags_StringAttributeSpec();
  var $$x6 = new $c_Lio_github_shogowada_statictags_Attribute(this$50.Lio_github_shogowada_statictags_StringAttributeSpec__f_name, "TextStyle", $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$());
  $m_Lscommons_react_navigation_package$();
  var attributes$6 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var $$x5 = new $c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes(attributes$6).component__Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenComponentAttributeSpec();
  var this$53 = $m_Lshowcase_app_style_TextStyleDemo$();
  var array$6 = [$$x6, $$x5.$colon$eq__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass__Lio_github_shogowada_statictags_Attribute(this$53.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass())];
  var $$x4 = $$x7.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6), $m_sci_Nil$());
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var reactClass$7 = stack.Screen;
  var $$x3 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass$7);
  var this$58 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes().name__Lio_github_shogowada_statictags_StringAttributeSpec();
  var $$x2 = new $c_Lio_github_shogowada_statictags_Attribute(this$58.Lio_github_shogowada_statictags_StringAttributeSpec__f_name, "ProfileCard", $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$());
  $m_Lscommons_react_navigation_package$();
  var attributes$7 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var $$x1 = new $c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes(attributes$7).component__Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenComponentAttributeSpec();
  var this$61 = $m_Lshowcase_app_style_ProfileCard$();
  var array$7 = [$$x2, $$x1.$colon$eq__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass__Lio_github_shogowada_statictags_Attribute(this$61.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass())];
  var array$8 = [$$x28, $$x24, $$x20, $$x16, $$x12, $$x8, $$x4, $$x3.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7), $m_sci_Nil$())];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8);
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)
});
var $d_Lshowcase_app_style_StylesScreen$ = new $TypeData().initClass({
  Lshowcase_app_style_StylesScreen$: 0
}, false, "showcase.app.style.StylesScreen$", {
  Lshowcase_app_style_StylesScreen$: 1,
  O: 1,
  Lscommons_react_FunctionComponent: 1,
  Lscommons_react_UiComponent: 1
});
$c_Lshowcase_app_style_StylesScreen$.prototype.$classData = $d_Lshowcase_app_style_StylesScreen$;
var $n_Lshowcase_app_style_StylesScreen$;
function $m_Lshowcase_app_style_StylesScreen$() {
  if ((!$n_Lshowcase_app_style_StylesScreen$)) {
    $n_Lshowcase_app_style_StylesScreen$ = new $c_Lshowcase_app_style_StylesScreen$()
  };
  return $n_Lshowcase_app_style_StylesScreen$
}
function $p_Lshowcase_app_style_StylesScreenController$__scommons$react$redux$BaseStateController$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz) {
  if (((((2 & $thiz.Lshowcase_app_style_StylesScreenController$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lshowcase_app_style_StylesScreenController$__f_scommons$react$redux$BaseStateController$$reactClass = $f_Lscommons_react_redux_BaseStateController__scommons$react$redux$BaseStateController$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz);
    $thiz.Lshowcase_app_style_StylesScreenController$__f_bitmap$0 = (((2 | $thiz.Lshowcase_app_style_StylesScreenController$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lshowcase_app_style_StylesScreenController$__f_scommons$react$redux$BaseStateController$$reactClass
}
function $p_Lshowcase_app_style_StylesScreenController$__uiComponent$lzycompute__Lscommons_react_UiComponent($thiz) {
  if (((((1 & $thiz.Lshowcase_app_style_StylesScreenController$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lshowcase_app_style_StylesScreenController$__f_uiComponent = $m_Lshowcase_app_style_StylesScreen$();
    $thiz.Lshowcase_app_style_StylesScreenController$__f_bitmap$0 = (((1 | $thiz.Lshowcase_app_style_StylesScreenController$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lshowcase_app_style_StylesScreenController$__f_uiComponent
}
/** @constructor */
function $c_Lshowcase_app_style_StylesScreenController$() {
  this.Lshowcase_app_style_StylesScreenController$__f_uiComponent = null;
  this.Lshowcase_app_style_StylesScreenController$__f_scommons$react$redux$BaseStateController$$reactClass = null;
  this.Lshowcase_app_style_StylesScreenController$__f_bitmap$0 = 0
}
$c_Lshowcase_app_style_StylesScreenController$.prototype = new $h_O();
$c_Lshowcase_app_style_StylesScreenController$.prototype.constructor = $c_Lshowcase_app_style_StylesScreenController$;
/** @constructor */
function $h_Lshowcase_app_style_StylesScreenController$() {
  /*<skip>*/
}
$h_Lshowcase_app_style_StylesScreenController$.prototype = $c_Lshowcase_app_style_StylesScreenController$.prototype;
$c_Lshowcase_app_style_StylesScreenController$.prototype.mapStateToProps__F1__O__Lio_github_shogowada_scalajs_reactjs_React$Props__O = (function(dispatch, state, props) {
  return $f_Lscommons_reactnative_app_BaseStateAndRouteController__mapStateToProps__F1__O__Lio_github_shogowada_scalajs_reactjs_React$Props__O(this, dispatch, state, props)
});
$c_Lshowcase_app_style_StylesScreenController$.prototype.scommons$react$redux$BaseStateController$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass = (function() {
  return (((((2 & this.Lshowcase_app_style_StylesScreenController$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lshowcase_app_style_StylesScreenController$__scommons$react$redux$BaseStateController$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass(this) : this.Lshowcase_app_style_StylesScreenController$__f_scommons$react$redux$BaseStateController$$reactClass)
});
$c_Lshowcase_app_style_StylesScreenController$.prototype.uiComponent__Lscommons_react_UiComponent = (function() {
  return (((((1 & this.Lshowcase_app_style_StylesScreenController$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lshowcase_app_style_StylesScreenController$__uiComponent$lzycompute__Lscommons_react_UiComponent(this) : this.Lshowcase_app_style_StylesScreenController$__f_uiComponent)
});
$c_Lshowcase_app_style_StylesScreenController$.prototype.mapStateAndRouteToProps__F1__Lshowcase_app_ShowcaseStateDef__Lscommons_react_navigation_Navigation__Lshowcase_app_style_StylesScreenProps = (function(dispatch, state, nav) {
  return new $c_Lshowcase_app_style_StylesScreenProps(new $c_sjsr_AnonFunction1((function(this$1, nav$1) {
    return (function(screen$2) {
      var screen = $as_T(screen$2);
      nav$1.navigate__T__V(screen)
    })
  })(this, nav)))
});
$c_Lshowcase_app_style_StylesScreenController$.prototype.mapStateAndRouteToProps__F1__O__Lscommons_react_navigation_Navigation__O = (function(dispatch, state, nav) {
  return this.mapStateAndRouteToProps__F1__Lshowcase_app_ShowcaseStateDef__Lscommons_react_navigation_Navigation__Lshowcase_app_style_StylesScreenProps(dispatch, $as_Lshowcase_app_ShowcaseStateDef(state), nav)
});
var $d_Lshowcase_app_style_StylesScreenController$ = new $TypeData().initClass({
  Lshowcase_app_style_StylesScreenController$: 0
}, false, "showcase.app.style.StylesScreenController$", {
  Lshowcase_app_style_StylesScreenController$: 1,
  O: 1,
  Lscommons_reactnative_app_BaseStateAndRouteController: 1,
  Lscommons_react_redux_BaseStateController: 1
});
$c_Lshowcase_app_style_StylesScreenController$.prototype.$classData = $d_Lshowcase_app_style_StylesScreenController$;
var $n_Lshowcase_app_style_StylesScreenController$;
function $m_Lshowcase_app_style_StylesScreenController$() {
  if ((!$n_Lshowcase_app_style_StylesScreenController$)) {
    $n_Lshowcase_app_style_StylesScreenController$ = new $c_Lshowcase_app_style_StylesScreenController$()
  };
  return $n_Lshowcase_app_style_StylesScreenController$
}
function $p_Lshowcase_app_style_TextStyleDemo$__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz) {
  if (((((2 & $thiz.Lshowcase_app_style_TextStyleDemo$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lshowcase_app_style_TextStyleDemo$__f_scommons$react$UiComponent$$reactClass = $f_Lscommons_react_FunctionComponent__create__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz);
    $thiz.Lshowcase_app_style_TextStyleDemo$__f_bitmap$0 = (((2 | $thiz.Lshowcase_app_style_TextStyleDemo$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lshowcase_app_style_TextStyleDemo$__f_scommons$react$UiComponent$$reactClass
}
function $p_Lshowcase_app_style_TextStyleDemo$__styles$lzycompute__Lshowcase_app_style_TextStyleDemo$Styles($thiz) {
  if (((((1 & $thiz.Lshowcase_app_style_TextStyleDemo$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lshowcase_app_style_TextStyleDemo$__f_styles = $m_Lscommons_reactnative_StyleSheet$().create__sjs_js_Object__sjs_js_Object(new ($a_Lshowcase_app_style_TextStyleDemo$Styles())());
    $thiz.Lshowcase_app_style_TextStyleDemo$__f_bitmap$0 = (((1 | $thiz.Lshowcase_app_style_TextStyleDemo$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lshowcase_app_style_TextStyleDemo$__f_styles
}
/** @constructor */
function $c_Lshowcase_app_style_TextStyleDemo$() {
  this.Lshowcase_app_style_TextStyleDemo$__f_styles = null;
  this.Lshowcase_app_style_TextStyleDemo$__f_LeftText = null;
  this.Lshowcase_app_style_TextStyleDemo$__f_leftTextComp = null;
  this.Lshowcase_app_style_TextStyleDemo$__f_scommons$react$UiComponent$$reactClass = null;
  this.Lshowcase_app_style_TextStyleDemo$__f_bitmap$0 = 0;
  $n_Lshowcase_app_style_TextStyleDemo$ = this;
  this.Lshowcase_app_style_TextStyleDemo$__f_LeftText = new $c_Lshowcase_app_style_TextStyleDemo$$anon$1();
  this.Lshowcase_app_style_TextStyleDemo$__f_leftTextComp = this.Lshowcase_app_style_TextStyleDemo$__f_LeftText
}
$c_Lshowcase_app_style_TextStyleDemo$.prototype = new $h_O();
$c_Lshowcase_app_style_TextStyleDemo$.prototype.constructor = $c_Lshowcase_app_style_TextStyleDemo$;
/** @constructor */
function $h_Lshowcase_app_style_TextStyleDemo$() {
  /*<skip>*/
}
$h_Lshowcase_app_style_TextStyleDemo$.prototype = $c_Lshowcase_app_style_TextStyleDemo$.prototype;
$c_Lshowcase_app_style_TextStyleDemo$.prototype.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass = (function() {
  return (((((2 & this.Lshowcase_app_style_TextStyleDemo$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lshowcase_app_style_TextStyleDemo$__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass(this) : this.Lshowcase_app_style_TextStyleDemo$__f_scommons$react$UiComponent$$reactClass)
});
$c_Lshowcase_app_style_TextStyleDemo$.prototype.render__Lio_github_shogowada_scalajs_reactjs_React$Props__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement = (function(props) {
  var elements = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x21 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements).View__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var attributes = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array = [new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__Lscommons_reactnative_Style__Lio_github_shogowada_statictags_Attribute(this.styles__Lshowcase_app_style_TextStyleDemo$Styles().screen)];
  var $$x20 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var elements$1 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x19 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements$1).View__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var attributes$1 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array$1 = [new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$1).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__Lscommons_reactnative_Style__Lio_github_shogowada_statictags_Attribute(this.styles__Lshowcase_app_style_TextStyleDemo$Styles().container)];
  var $$x18 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var this$11 = this.Lshowcase_app_style_TextStyleDemo$__f_leftTextComp;
  var reactClass = this$11.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass();
  var $$x17 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass);
  var attributes$2 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array$2 = [new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$2).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__Lscommons_reactnative_Style__Lio_github_shogowada_statictags_Attribute((function(superClass$) {
    return (function() {
      var this$14 = {};
      this$14.fontStyle = null;
      var a = $m_Lscommons_reactnative_TextStyle$FontStyle$().Lscommons_reactnative_TextStyle$FontStyle$__f_italic;
      this$14.fontStyle = a;
      return this$14
    })
  })(Object)())];
  var $$x16 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
  var array$3 = ["A) Italic"];
  var $$x15 = $$x17.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x16, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3));
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var this$24 = this.Lshowcase_app_style_TextStyleDemo$__f_leftTextComp;
  var reactClass$1 = this$24.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass();
  var $$x14 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass$1);
  var attributes$3 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array$4 = [new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$3).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__Lscommons_reactnative_Style__Lio_github_shogowada_statictags_Attribute((function(superClass$$1) {
    return (function() {
      var this$2$1 = {};
      this$2$1.textDecorationLine = null;
      var a$1 = $m_Lscommons_reactnative_TextStyle$TextDecorationLine$().Lscommons_reactnative_TextStyle$TextDecorationLine$__f_underline$u0020line$minusthrough;
      this$2$1.textDecorationLine = a$1;
      return this$2$1
    })
  })(Object)())];
  var $$x13 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4);
  var array$5 = ["B) Underline and Line Through"];
  var $$x12 = $$x14.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x13, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5));
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var this$36 = this.Lshowcase_app_style_TextStyleDemo$__f_leftTextComp;
  var reactClass$2 = this$36.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass();
  var $$x11 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass$2);
  var attributes$4 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array$6 = [new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$4).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__Lscommons_reactnative_Style__Lio_github_shogowada_statictags_Attribute((function(superClass$$2) {
    return (function() {
      var this$3$1 = {};
      this$3$1.textDecorationLine = null;
      this$3$1.textDecorationColor = null;
      this$3$1.textDecorationStyle = null;
      var a$2 = $m_Lscommons_reactnative_TextStyle$TextDecorationLine$().Lscommons_reactnative_TextStyle$TextDecorationLine$__f_underline$u0020line$minusthrough;
      this$3$1.textDecorationLine = a$2;
      var a$3 = $m_Lscommons_reactnative_Style$Color$().Lscommons_reactnative_Style$Color$__f_red;
      this$3$1.textDecorationColor = a$3;
      var a$4 = $m_Lscommons_reactnative_IOSTextStyle$TextDecorationStyle$().Lscommons_reactnative_IOSTextStyle$TextDecorationStyle$__f_dotted;
      this$3$1.textDecorationStyle = a$4;
      return this$3$1
    })
  })(Object)())];
  var $$x10 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6);
  var array$7 = ["C) Underline and Line Through"];
  var $$x9 = $$x11.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x10, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7));
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var this$54 = this.Lshowcase_app_style_TextStyleDemo$__f_leftTextComp;
  var reactClass$3 = this$54.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass();
  var $$x8 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass$3);
  var attributes$5 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array$8 = [new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$5).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__Lscommons_reactnative_Style__Lio_github_shogowada_statictags_Attribute((function(superClass$$3) {
    return (function() {
      var this$4$1 = {};
      this$4$1.textShadowColor = null;
      this$4$1.textShadowOffset = null;
      this$4$1.textShadowRadius = null;
      var a$5 = $m_Lscommons_reactnative_Style$Color$().Lscommons_reactnative_Style$Color$__f_red;
      this$4$1.textShadowColor = a$5;
      var a$6 = (function(superClass$$4, arg$outer) {
        return (function() {
          var this$60 = {};
          this$60.width = null;
          this$60.height = null;
          this$60.width = (-2);
          this$60.height = (-2);
          return this$60
        })
      })(Object, this$4$1)();
      this$4$1.textShadowOffset = a$6;
      this$4$1.textShadowRadius = 4;
      return this$4$1
    })
  })(Object)())];
  var $$x7 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8);
  var array$9 = ["D) Text Shadow"];
  var $$x6 = $$x8.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x7, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9));
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var this$79 = this.Lshowcase_app_style_TextStyleDemo$__f_leftTextComp;
  var reactClass$4 = this$79.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass();
  var $$x5 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass$4);
  var attributes$6 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array$10 = [new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$6).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__Lscommons_reactnative_Style__Lio_github_shogowada_statictags_Attribute((function(superClass$$5) {
    return (function() {
      var this$5$1 = {};
      this$5$1.letterSpacing = null;
      this$5$1.letterSpacing = 5;
      return this$5$1
    })
  })(Object)())];
  var $$x4 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$10);
  var array$11 = ["E) Letter Spacing"];
  var $$x3 = $$x5.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x4, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$11));
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var this$91 = this.Lshowcase_app_style_TextStyleDemo$__f_leftTextComp;
  var reactClass$5 = this$91.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass();
  var $$x2 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass$5);
  var attributes$7 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array$12 = [new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$7).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__Lscommons_reactnative_Style__Lio_github_shogowada_statictags_Attribute((function(superClass$$6) {
    return (function() {
      var this$6$1 = {};
      this$6$1.textAlign = null;
      this$6$1.fontWeight = null;
      var a$7 = $m_Lscommons_reactnative_TextStyle$TextAlign$().Lscommons_reactnative_TextStyle$TextAlign$__f_center;
      this$6$1.textAlign = a$7;
      var a$8 = $m_Lscommons_reactnative_TextStyle$FontWeight$().Lscommons_reactnative_TextStyle$FontWeight$__f_bold;
      this$6$1.fontWeight = a$8;
      return this$6$1
    })
  })(Object)())];
  var $$x1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$12);
  var array$13 = [("" + $m_Lscommons_reactnative_Platform$().OS__Lscommons_reactnative_Platform())];
  var array$14 = [$$x15, $$x12, $$x9, $$x6, $$x3, $$x2.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x1, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$13))];
  var array$15 = [$$x19.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x18, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$14))];
  return $$x21.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x20, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$15))
});
$c_Lshowcase_app_style_TextStyleDemo$.prototype.styles__Lshowcase_app_style_TextStyleDemo$Styles = (function() {
  return (((((1 & this.Lshowcase_app_style_TextStyleDemo$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lshowcase_app_style_TextStyleDemo$__styles$lzycompute__Lshowcase_app_style_TextStyleDemo$Styles(this) : this.Lshowcase_app_style_TextStyleDemo$__f_styles)
});
var $d_Lshowcase_app_style_TextStyleDemo$ = new $TypeData().initClass({
  Lshowcase_app_style_TextStyleDemo$: 0
}, false, "showcase.app.style.TextStyleDemo$", {
  Lshowcase_app_style_TextStyleDemo$: 1,
  O: 1,
  Lscommons_react_FunctionComponent: 1,
  Lscommons_react_UiComponent: 1
});
$c_Lshowcase_app_style_TextStyleDemo$.prototype.$classData = $d_Lshowcase_app_style_TextStyleDemo$;
var $n_Lshowcase_app_style_TextStyleDemo$;
function $m_Lshowcase_app_style_TextStyleDemo$() {
  if ((!$n_Lshowcase_app_style_TextStyleDemo$)) {
    $n_Lshowcase_app_style_TextStyleDemo$ = new $c_Lshowcase_app_style_TextStyleDemo$()
  };
  return $n_Lshowcase_app_style_TextStyleDemo$
}
function $p_Lshowcase_app_style_TextStyleDemo$$anon$1__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz) {
  if ((!$thiz.Lshowcase_app_style_TextStyleDemo$$anon$1__f_bitmap$0)) {
    $thiz.Lshowcase_app_style_TextStyleDemo$$anon$1__f_scommons$react$UiComponent$$reactClass = $f_Lscommons_react_FunctionComponent__create__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz);
    $thiz.Lshowcase_app_style_TextStyleDemo$$anon$1__f_bitmap$0 = true
  };
  return $thiz.Lshowcase_app_style_TextStyleDemo$$anon$1__f_scommons$react$UiComponent$$reactClass
}
/** @constructor */
function $c_Lshowcase_app_style_TextStyleDemo$$anon$1() {
  this.Lshowcase_app_style_TextStyleDemo$$anon$1__f_scommons$react$UiComponent$$reactClass = null;
  this.Lshowcase_app_style_TextStyleDemo$$anon$1__f_bitmap$0 = false
}
$c_Lshowcase_app_style_TextStyleDemo$$anon$1.prototype = new $h_O();
$c_Lshowcase_app_style_TextStyleDemo$$anon$1.prototype.constructor = $c_Lshowcase_app_style_TextStyleDemo$$anon$1;
/** @constructor */
function $h_Lshowcase_app_style_TextStyleDemo$$anon$1() {
  /*<skip>*/
}
$h_Lshowcase_app_style_TextStyleDemo$$anon$1.prototype = $c_Lshowcase_app_style_TextStyleDemo$$anon$1.prototype;
$c_Lshowcase_app_style_TextStyleDemo$$anon$1.prototype.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass = (function() {
  return ((!this.Lshowcase_app_style_TextStyleDemo$$anon$1__f_bitmap$0) ? $p_Lshowcase_app_style_TextStyleDemo$$anon$1__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass(this) : this.Lshowcase_app_style_TextStyleDemo$$anon$1__f_scommons$react$UiComponent$$reactClass)
});
$c_Lshowcase_app_style_TextStyleDemo$$anon$1.prototype.render__Lio_github_shogowada_scalajs_reactjs_React$Props__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement = (function(props) {
  var elements = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x2 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements).Text__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var attributes = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array = [new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__sjs_js_Array__Lio_github_shogowada_statictags_Attribute([$m_Lshowcase_app_style_TextStyleDemo$().styles__Lshowcase_app_style_TextStyleDemo$Styles().leftText, props.Lio_github_shogowada_scalajs_reactjs_React$Props__f_native.style])];
  var $$x1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var array$1 = [props.children__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement()];
  return $$x2.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x1, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))
});
var $d_Lshowcase_app_style_TextStyleDemo$$anon$1 = new $TypeData().initClass({
  Lshowcase_app_style_TextStyleDemo$$anon$1: 0
}, false, "showcase.app.style.TextStyleDemo$$anon$1", {
  Lshowcase_app_style_TextStyleDemo$$anon$1: 1,
  O: 1,
  Lscommons_react_FunctionComponent: 1,
  Lscommons_react_UiComponent: 1
});
$c_Lshowcase_app_style_TextStyleDemo$$anon$1.prototype.$classData = $d_Lshowcase_app_style_TextStyleDemo$$anon$1;
var $b_Lshowcase_app_style_TextStyleDemo$Styles;
function $a_Lshowcase_app_style_TextStyleDemo$Styles() {
  if ((!$b_Lshowcase_app_style_TextStyleDemo$Styles)) {
    /** @constructor */
    $b_Lshowcase_app_style_TextStyleDemo$Styles = (function() {
      Object.call(this);
      Object.defineProperty(this, "screen", {
        "configurable": true,
        "enumerable": true,
        "writable": true,
        "value": null
      });
      Object.defineProperty(this, "container", {
        "configurable": true,
        "enumerable": true,
        "writable": true,
        "value": null
      });
      Object.defineProperty(this, "leftText", {
        "configurable": true,
        "enumerable": true,
        "writable": true,
        "value": null
      });
      this.screen = (function(superClass$, arg$outer) {
        return (function() {
          var outer = arg$outer;
          var this\u00f8 = {};
          this\u00f8.flex = null;
          this\u00f8.justifyContent = null;
          this\u00f8.alignItems = null;
          this\u00f8.backgroundColor = null;
          this\u00f8.flex = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(1, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this\u00f8.justifyContent = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($m_Lscommons_reactnative_ViewStyle$JustifyContent$().center__Lscommons_reactnative_ViewStyle$JustifyContent(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this\u00f8.alignItems = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($m_Lscommons_reactnative_ViewStyle$AlignItems$().center__Lscommons_reactnative_ViewStyle$AlignItems(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this\u00f8.backgroundColor = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($m_Lscommons_reactnative_Style$Color$().white__T(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          $s_sr_Statics__releaseFence__V();
          return this\u00f8
        })
      })(Object, this)();
      this.container = (function(superClass$, arg$outer) {
        return (function() {
          var outer = arg$outer;
          var this$2 = {};
          this$2.width = null;
          this$2.marginLeft = null;
          this$2.marginBottom = null;
          this$2.width = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(300, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().right__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          this$2.marginLeft = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(40, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().right__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          this$2.marginBottom = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(20, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().right__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          $s_sr_Statics__releaseFence__V();
          return this$2
        })
      })(Object, this)();
      this.leftText = (function(superClass$, arg$outer) {
        return (function() {
          var outer = arg$outer;
          var this$3 = {};
          this$3.fontSize = null;
          this$3.paddingBottom = null;
          this$3.fontSize = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(20, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this$3.paddingBottom = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(10, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().right__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          $s_sr_Statics__releaseFence__V();
          return this$3
        })
      })(Object, this)()
    });
    /** @constructor */
    var $hh_Lshowcase_app_style_TextStyleDemo$Styles = (function() {
      /*<skip>*/
    });
    $hh_Lshowcase_app_style_TextStyleDemo$Styles.prototype = Object.prototype;
    $b_Lshowcase_app_style_TextStyleDemo$Styles.prototype = new $hh_Lshowcase_app_style_TextStyleDemo$Styles();
    $b_Lshowcase_app_style_TextStyleDemo$Styles.prototype.constructor = $b_Lshowcase_app_style_TextStyleDemo$Styles
  };
  return $b_Lshowcase_app_style_TextStyleDemo$Styles
}
function $p_Lshowcase_app_task_DemoTaskController__scommons$react$redux$BaseStateController$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz) {
  if (((((2 & $thiz.Lshowcase_app_task_DemoTaskController__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lshowcase_app_task_DemoTaskController__f_scommons$react$redux$BaseStateController$$reactClass = $f_Lscommons_react_redux_BaseStateController__scommons$react$redux$BaseStateController$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz);
    $thiz.Lshowcase_app_task_DemoTaskController__f_bitmap$0 = (((2 | $thiz.Lshowcase_app_task_DemoTaskController__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lshowcase_app_task_DemoTaskController__f_scommons$react$redux$BaseStateController$$reactClass
}
function $p_Lshowcase_app_task_DemoTaskController__uiComponent$lzycompute__Lscommons_react_UiComponent($thiz) {
  if (((((1 & $thiz.Lshowcase_app_task_DemoTaskController__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lshowcase_app_task_DemoTaskController__f_uiComponent = $m_Lshowcase_app_task_DemoTaskScreen$();
    $thiz.Lshowcase_app_task_DemoTaskController__f_bitmap$0 = (((1 | $thiz.Lshowcase_app_task_DemoTaskController__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lshowcase_app_task_DemoTaskController__f_uiComponent
}
/** @constructor */
function $c_Lshowcase_app_task_DemoTaskController(actions) {
  this.Lshowcase_app_task_DemoTaskController__f_uiComponent = null;
  this.Lshowcase_app_task_DemoTaskController__f_actions = null;
  this.Lshowcase_app_task_DemoTaskController__f_scommons$react$redux$BaseStateController$$reactClass = null;
  this.Lshowcase_app_task_DemoTaskController__f_bitmap$0 = 0;
  this.Lshowcase_app_task_DemoTaskController__f_actions = actions
}
$c_Lshowcase_app_task_DemoTaskController.prototype = new $h_O();
$c_Lshowcase_app_task_DemoTaskController.prototype.constructor = $c_Lshowcase_app_task_DemoTaskController;
/** @constructor */
function $h_Lshowcase_app_task_DemoTaskController() {
  /*<skip>*/
}
$h_Lshowcase_app_task_DemoTaskController.prototype = $c_Lshowcase_app_task_DemoTaskController.prototype;
$c_Lshowcase_app_task_DemoTaskController.prototype.mapStateToProps__F1__O__Lio_github_shogowada_scalajs_reactjs_React$Props__O = (function(dispatch, state, props) {
  return $f_Lscommons_reactnative_app_BaseStateAndRouteController__mapStateToProps__F1__O__Lio_github_shogowada_scalajs_reactjs_React$Props__O(this, dispatch, state, props)
});
$c_Lshowcase_app_task_DemoTaskController.prototype.scommons$react$redux$BaseStateController$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass = (function() {
  return (((((2 & this.Lshowcase_app_task_DemoTaskController__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lshowcase_app_task_DemoTaskController__scommons$react$redux$BaseStateController$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass(this) : this.Lshowcase_app_task_DemoTaskController__f_scommons$react$redux$BaseStateController$$reactClass)
});
$c_Lshowcase_app_task_DemoTaskController.prototype.uiComponent__Lscommons_react_UiComponent = (function() {
  return (((((1 & this.Lshowcase_app_task_DemoTaskController__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lshowcase_app_task_DemoTaskController__uiComponent$lzycompute__Lscommons_react_UiComponent(this) : this.Lshowcase_app_task_DemoTaskController__f_uiComponent)
});
$c_Lshowcase_app_task_DemoTaskController.prototype.mapStateAndRouteToProps__F1__Lshowcase_app_ShowcaseStateDef__Lscommons_react_navigation_Navigation__Lshowcase_app_task_DemoTaskScreenProps = (function(dispatch, state, nav) {
  return new $c_Lshowcase_app_task_DemoTaskScreenProps(dispatch, this.Lshowcase_app_task_DemoTaskController__f_actions)
});
$c_Lshowcase_app_task_DemoTaskController.prototype.mapStateAndRouteToProps__F1__O__Lscommons_react_navigation_Navigation__O = (function(dispatch, state, nav) {
  return this.mapStateAndRouteToProps__F1__Lshowcase_app_ShowcaseStateDef__Lscommons_react_navigation_Navigation__Lshowcase_app_task_DemoTaskScreenProps(dispatch, $as_Lshowcase_app_ShowcaseStateDef(state), nav)
});
var $d_Lshowcase_app_task_DemoTaskController = new $TypeData().initClass({
  Lshowcase_app_task_DemoTaskController: 0
}, false, "showcase.app.task.DemoTaskController", {
  Lshowcase_app_task_DemoTaskController: 1,
  O: 1,
  Lscommons_reactnative_app_BaseStateAndRouteController: 1,
  Lscommons_react_redux_BaseStateController: 1
});
$c_Lshowcase_app_task_DemoTaskController.prototype.$classData = $d_Lshowcase_app_task_DemoTaskController;
function $p_Lshowcase_app_task_DemoTaskScreen$__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz) {
  if (((((2 & $thiz.Lshowcase_app_task_DemoTaskScreen$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lshowcase_app_task_DemoTaskScreen$__f_scommons$react$UiComponent$$reactClass = $f_Lscommons_react_FunctionComponent__create__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz);
    $thiz.Lshowcase_app_task_DemoTaskScreen$__f_bitmap$0 = (((2 | $thiz.Lshowcase_app_task_DemoTaskScreen$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lshowcase_app_task_DemoTaskScreen$__f_scommons$react$UiComponent$$reactClass
}
function $p_Lshowcase_app_task_DemoTaskScreen$__styles$lzycompute__Lshowcase_app_task_DemoTaskScreen$Styles($thiz) {
  if (((((1 & $thiz.Lshowcase_app_task_DemoTaskScreen$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lshowcase_app_task_DemoTaskScreen$__f_styles = $m_Lscommons_reactnative_StyleSheet$().create__sjs_js_Object__sjs_js_Object(new ($a_Lshowcase_app_task_DemoTaskScreen$Styles())());
    $thiz.Lshowcase_app_task_DemoTaskScreen$__f_bitmap$0 = (((1 | $thiz.Lshowcase_app_task_DemoTaskScreen$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lshowcase_app_task_DemoTaskScreen$__f_styles
}
/** @constructor */
function $c_Lshowcase_app_task_DemoTaskScreen$() {
  this.Lshowcase_app_task_DemoTaskScreen$__f_styles = null;
  this.Lshowcase_app_task_DemoTaskScreen$__f_scommons$react$UiComponent$$reactClass = null;
  this.Lshowcase_app_task_DemoTaskScreen$__f_bitmap$0 = 0
}
$c_Lshowcase_app_task_DemoTaskScreen$.prototype = new $h_O();
$c_Lshowcase_app_task_DemoTaskScreen$.prototype.constructor = $c_Lshowcase_app_task_DemoTaskScreen$;
/** @constructor */
function $h_Lshowcase_app_task_DemoTaskScreen$() {
  /*<skip>*/
}
$h_Lshowcase_app_task_DemoTaskScreen$.prototype = $c_Lshowcase_app_task_DemoTaskScreen$.prototype;
$c_Lshowcase_app_task_DemoTaskScreen$.prototype.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass = (function() {
  return (((((2 & this.Lshowcase_app_task_DemoTaskScreen$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lshowcase_app_task_DemoTaskScreen$__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass(this) : this.Lshowcase_app_task_DemoTaskScreen$__f_scommons$react$UiComponent$$reactClass)
});
$c_Lshowcase_app_task_DemoTaskScreen$.prototype.render__Lio_github_shogowada_scalajs_reactjs_React$Props__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement = (function(compProps) {
  var props = $as_Lshowcase_app_task_DemoTaskScreenProps(compProps.wrapped__O());
  var elements = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x13 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements).View__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var attributes = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array = [new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__Lscommons_reactnative_Style__Lio_github_shogowada_statictags_Attribute(this.styles__Lshowcase_app_task_DemoTaskScreen$Styles().container)];
  var $$x12 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var elements$1 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x11 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements$1).Button__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var this$7 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes().title__Lio_github_shogowada_statictags_StringAttributeSpec();
  var $$x10 = new $c_Lio_github_shogowada_statictags_Attribute(this$7.Lio_github_shogowada_statictags_StringAttributeSpec__f_name, "Successful Request", $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$());
  var attributes$1 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var this$10 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$1).color__Lio_github_shogowada_statictags_StringAttributeSpec();
  var $$x9 = new $c_Lio_github_shogowada_statictags_Attribute(this$10.Lio_github_shogowada_statictags_StringAttributeSpec__f_name, "#00ff00", $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$());
  var attributes$2 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array$1 = [$$x10, $$x9, new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$2).onPress__Lscommons_reactnative_Touchable$TouchableAttributes$OnPressEventAttribute().$colon$eq__sjs_js_Function0__Lio_github_shogowada_statictags_Attribute((function(props$1) {
    return (function() {
      $m_Lshowcase_app_task_DemoTaskScreen$().showcase$app$task$DemoTaskScreen$$$anonfun$render$1__Lshowcase_app_task_DemoTaskScreenProps__V(props$1)
    })
  })(props))];
  var $$x8 = $$x11.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1), $m_sci_Nil$());
  var elements$2 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x7 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements$2).Button__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var this$17 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes().title__Lio_github_shogowada_statictags_StringAttributeSpec();
  var $$x6 = new $c_Lio_github_shogowada_statictags_Attribute(this$17.Lio_github_shogowada_statictags_StringAttributeSpec__f_name, "Timed-out Request", $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$());
  var attributes$3 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var this$20 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$3).color__Lio_github_shogowada_statictags_StringAttributeSpec();
  var $$x5 = new $c_Lio_github_shogowada_statictags_Attribute(this$20.Lio_github_shogowada_statictags_StringAttributeSpec__f_name, "#0000ff", $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$());
  var attributes$4 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array$2 = [$$x6, $$x5, new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$4).onPress__Lscommons_reactnative_Touchable$TouchableAttributes$OnPressEventAttribute().$colon$eq__sjs_js_Function0__Lio_github_shogowada_statictags_Attribute((function(props$1$1) {
    return (function() {
      $m_Lshowcase_app_task_DemoTaskScreen$().showcase$app$task$DemoTaskScreen$$$anonfun$render$3__Lshowcase_app_task_DemoTaskScreenProps__V(props$1$1)
    })
  })(props))];
  var $$x4 = $$x7.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2), $m_sci_Nil$());
  var elements$3 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x3 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements$3).Button__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var this$27 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes().title__Lio_github_shogowada_statictags_StringAttributeSpec();
  var $$x2 = new $c_Lio_github_shogowada_statictags_Attribute(this$27.Lio_github_shogowada_statictags_StringAttributeSpec__f_name, "Failed Request", $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$());
  var attributes$5 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var this$30 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$5).color__Lio_github_shogowada_statictags_StringAttributeSpec();
  var $$x1 = new $c_Lio_github_shogowada_statictags_Attribute(this$30.Lio_github_shogowada_statictags_StringAttributeSpec__f_name, "#ff0000", $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$());
  var attributes$6 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array$3 = [$$x2, $$x1, new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes$6).onPress__Lscommons_reactnative_Touchable$TouchableAttributes$OnPressEventAttribute().$colon$eq__sjs_js_Function0__Lio_github_shogowada_statictags_Attribute((function(props$1$2) {
    return (function() {
      $m_Lshowcase_app_task_DemoTaskScreen$().showcase$app$task$DemoTaskScreen$$$anonfun$render$5__Lshowcase_app_task_DemoTaskScreenProps__V(props$1$2)
    })
  })(props))];
  var array$4 = [$$x8, $$x4, $$x3.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3), $m_sci_Nil$())];
  return $$x13.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x12, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4))
});
$c_Lshowcase_app_task_DemoTaskScreen$.prototype.styles__Lshowcase_app_task_DemoTaskScreen$Styles = (function() {
  return (((((1 & this.Lshowcase_app_task_DemoTaskScreen$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lshowcase_app_task_DemoTaskScreen$__styles$lzycompute__Lshowcase_app_task_DemoTaskScreen$Styles(this) : this.Lshowcase_app_task_DemoTaskScreen$__f_styles)
});
$c_Lshowcase_app_task_DemoTaskScreen$.prototype.showcase$app$task$DemoTaskScreen$$$anonfun$render$1__Lshowcase_app_task_DemoTaskScreenProps__V = (function(props$1) {
  var this$1 = props$1.Lshowcase_app_task_DemoTaskScreenProps__f_actions;
  var dispatch = props$1.Lshowcase_app_task_DemoTaskScreenProps__f_dispatch;
  var action = $f_Lshowcase_app_task_DemoTaskActions__successfulAction__F1__Lshowcase_app_task_DemoTaskActions$SuccessfulFetchAction(this$1, dispatch);
  props$1.Lshowcase_app_task_DemoTaskScreenProps__f_dispatch.apply__O__O(action);
  var this$3 = action.Lshowcase_app_task_DemoTaskActions$SuccessfulFetchAction__f_task.Lscommons_react_redux_task_FutureTask__f_future;
  var pf = new $c_Lshowcase_app_task_DemoTaskScreen$$anonfun$showcase$app$task$DemoTaskScreen$$$nestedInanonfun$render$1$1();
  var executor = $m_s_concurrent_ExecutionContext$().global__s_concurrent_ExecutionContextExecutor();
  $f_s_concurrent_Future__andThen__s_PartialFunction__s_concurrent_ExecutionContext__s_concurrent_Future(this$3, pf, executor)
});
$c_Lshowcase_app_task_DemoTaskScreen$.prototype.showcase$app$task$DemoTaskScreen$$$anonfun$render$3__Lshowcase_app_task_DemoTaskScreenProps__V = (function(props$1) {
  var $$x1 = props$1.Lshowcase_app_task_DemoTaskScreenProps__f_dispatch;
  var this$1 = props$1.Lshowcase_app_task_DemoTaskScreenProps__f_actions;
  $$x1.apply__O__O($f_Lshowcase_app_task_DemoTaskActions__timedoutAction__Lshowcase_app_task_DemoTaskActions$FailingApiAction(this$1))
});
$c_Lshowcase_app_task_DemoTaskScreen$.prototype.showcase$app$task$DemoTaskScreen$$$anonfun$render$5__Lshowcase_app_task_DemoTaskScreenProps__V = (function(props$1) {
  var $$x1 = props$1.Lshowcase_app_task_DemoTaskScreenProps__f_dispatch;
  var this$1 = props$1.Lshowcase_app_task_DemoTaskScreenProps__f_actions;
  $$x1.apply__O__O($f_Lshowcase_app_task_DemoTaskActions__failedAction__Lshowcase_app_task_DemoTaskActions$FailingApiAction(this$1))
});
var $d_Lshowcase_app_task_DemoTaskScreen$ = new $TypeData().initClass({
  Lshowcase_app_task_DemoTaskScreen$: 0
}, false, "showcase.app.task.DemoTaskScreen$", {
  Lshowcase_app_task_DemoTaskScreen$: 1,
  O: 1,
  Lscommons_react_FunctionComponent: 1,
  Lscommons_react_UiComponent: 1
});
$c_Lshowcase_app_task_DemoTaskScreen$.prototype.$classData = $d_Lshowcase_app_task_DemoTaskScreen$;
var $n_Lshowcase_app_task_DemoTaskScreen$;
function $m_Lshowcase_app_task_DemoTaskScreen$() {
  if ((!$n_Lshowcase_app_task_DemoTaskScreen$)) {
    $n_Lshowcase_app_task_DemoTaskScreen$ = new $c_Lshowcase_app_task_DemoTaskScreen$()
  };
  return $n_Lshowcase_app_task_DemoTaskScreen$
}
var $b_Lshowcase_app_task_DemoTaskScreen$Styles;
function $a_Lshowcase_app_task_DemoTaskScreen$Styles() {
  if ((!$b_Lshowcase_app_task_DemoTaskScreen$Styles)) {
    /** @constructor */
    $b_Lshowcase_app_task_DemoTaskScreen$Styles = (function() {
      Object.call(this);
      Object.defineProperty(this, "container", {
        "configurable": true,
        "enumerable": true,
        "writable": true,
        "value": null
      });
      this.container = (function(superClass$, arg$outer) {
        return (function() {
          var outer = arg$outer;
          var this\u00f8 = {};
          this\u00f8.marginTop = null;
          this\u00f8.flex = null;
          this\u00f8.marginTop = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(22, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().right__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          this\u00f8.flex = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(1, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          $s_sr_Statics__releaseFence__V();
          return this\u00f8
        })
      })(Object, this)()
    });
    /** @constructor */
    var $hh_Lshowcase_app_task_DemoTaskScreen$Styles = (function() {
      /*<skip>*/
    });
    $hh_Lshowcase_app_task_DemoTaskScreen$Styles.prototype = Object.prototype;
    $b_Lshowcase_app_task_DemoTaskScreen$Styles.prototype = new $hh_Lshowcase_app_task_DemoTaskScreen$Styles();
    $b_Lshowcase_app_task_DemoTaskScreen$Styles.prototype.constructor = $b_Lshowcase_app_task_DemoTaskScreen$Styles
  };
  return $b_Lshowcase_app_task_DemoTaskScreen$Styles
}
function $p_Lshowcase_app_ui_ChoiceGroupDemo$__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz) {
  if (((((2 & $thiz.Lshowcase_app_ui_ChoiceGroupDemo$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lshowcase_app_ui_ChoiceGroupDemo$__f_scommons$react$UiComponent$$reactClass = $f_Lscommons_react_FunctionComponent__create__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz);
    $thiz.Lshowcase_app_ui_ChoiceGroupDemo$__f_bitmap$0 = (((2 | $thiz.Lshowcase_app_ui_ChoiceGroupDemo$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lshowcase_app_ui_ChoiceGroupDemo$__f_scommons$react$UiComponent$$reactClass
}
function $p_Lshowcase_app_ui_ChoiceGroupDemo$__styles$lzycompute__Lshowcase_app_ui_ChoiceGroupDemo$Styles($thiz) {
  if (((((1 & $thiz.Lshowcase_app_ui_ChoiceGroupDemo$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lshowcase_app_ui_ChoiceGroupDemo$__f_styles = $m_Lscommons_reactnative_StyleSheet$().create__sjs_js_Object__sjs_js_Object(new ($a_Lshowcase_app_ui_ChoiceGroupDemo$Styles())());
    $thiz.Lshowcase_app_ui_ChoiceGroupDemo$__f_bitmap$0 = (((1 | $thiz.Lshowcase_app_ui_ChoiceGroupDemo$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lshowcase_app_ui_ChoiceGroupDemo$__f_styles
}
/** @constructor */
function $c_Lshowcase_app_ui_ChoiceGroupDemo$() {
  this.Lshowcase_app_ui_ChoiceGroupDemo$__f_styles = null;
  this.Lshowcase_app_ui_ChoiceGroupDemo$__f_customChoiceGroupComp = null;
  this.Lshowcase_app_ui_ChoiceGroupDemo$__f_choiceGroupComp = null;
  this.Lshowcase_app_ui_ChoiceGroupDemo$__f_scommons$react$UiComponent$$reactClass = null;
  this.Lshowcase_app_ui_ChoiceGroupDemo$__f_bitmap$0 = 0;
  $n_Lshowcase_app_ui_ChoiceGroupDemo$ = this;
  this.Lshowcase_app_ui_ChoiceGroupDemo$__f_customChoiceGroupComp = $ct_Lscommons_reactnative_ui_ChoiceGroup__(new $c_Lscommons_reactnative_ui_ChoiceGroup());
  this.Lshowcase_app_ui_ChoiceGroupDemo$__f_choiceGroupComp = $m_Lscommons_reactnative_ui_ChoiceGroup$()
}
$c_Lshowcase_app_ui_ChoiceGroupDemo$.prototype = new $h_O();
$c_Lshowcase_app_ui_ChoiceGroupDemo$.prototype.constructor = $c_Lshowcase_app_ui_ChoiceGroupDemo$;
/** @constructor */
function $h_Lshowcase_app_ui_ChoiceGroupDemo$() {
  /*<skip>*/
}
$h_Lshowcase_app_ui_ChoiceGroupDemo$.prototype = $c_Lshowcase_app_ui_ChoiceGroupDemo$.prototype;
$c_Lshowcase_app_ui_ChoiceGroupDemo$.prototype.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass = (function() {
  return (((((2 & this.Lshowcase_app_ui_ChoiceGroupDemo$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lshowcase_app_ui_ChoiceGroupDemo$__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass(this) : this.Lshowcase_app_ui_ChoiceGroupDemo$__f_scommons$react$UiComponent$$reactClass)
});
$c_Lshowcase_app_ui_ChoiceGroupDemo$.prototype.render__Lio_github_shogowada_scalajs_reactjs_React$Props__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement = (function(props) {
  var this$1 = $m_Lscommons_react_navigation_package$();
  var theme = this$1.native__Lscommons_react_navigation_raw_ReactNavigation().useTheme();
  var this$3 = $m_Lscommons_react_hooks_package$();
  var initialState = $m_sci_Set$EmptySet$();
  var x1 = $f_Lscommons_react_hooks_UseState__useState__O__T2(this$3, initialState);
  if ((x1 === null)) {
    throw new $c_s_MatchError(x1)
  };
  var singleSelectIds = $as_sci_Set(x1._1__O());
  var setSingleSelectIds = x1._2__O();
  var this$5 = $m_Lscommons_react_hooks_package$();
  var initialState$1 = $m_sci_Set$EmptySet$();
  var x1$2 = $f_Lscommons_react_hooks_UseState__useState__O__T2(this$5, initialState$1);
  if ((x1$2 === null)) {
    throw new $c_s_MatchError(x1$2)
  };
  var multiSelectIds = $as_sci_Set(x1$2._1__O());
  var setMultiSelectIds = x1$2._2__O();
  var elements = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x15 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements).View__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var attributes = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var array = [new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes).rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec().$colon$eq__Lscommons_reactnative_Style__Lio_github_shogowada_statictags_Attribute(this.styles__Lshowcase_app_ui_ChoiceGroupDemo$Styles().container)];
  var $$x14 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var elements$1 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x13 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements$1).Text__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var this$13 = $m_Lscommons_react_navigation_package$();
  var light = this.styles__Lshowcase_app_ui_ChoiceGroupDemo$Styles().title;
  var this$12 = $m_Lscommons_react_navigation_package$();
  var dark = $f_Lscommons_react_navigation_ReactNavigation__themeTextStyle__Lscommons_react_navigation_raw_Theme__Lscommons_reactnative_TextStyle(this$12, theme);
  var array$1 = [$f_Lscommons_react_navigation_ReactNavigation__themeStyle__Lscommons_reactnative_Style__Lscommons_reactnative_Style__Lscommons_react_navigation_raw_Theme__Lio_github_shogowada_statictags_Attribute(this$13, light, dark, theme)];
  var $$x12 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
  var array$2 = ["Single-select (simple):"];
  var $$x11 = $$x13.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x12, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2));
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var this$20 = this.Lshowcase_app_ui_ChoiceGroupDemo$__f_choiceGroupComp;
  var reactClass = this$20.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass();
  var $$x10 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass);
  var $$x9 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes().wrapped__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$WrappedPropsAttributeSpec();
  $m_s_package$();
  var array$3 = [new $c_Lscommons_reactnative_ui_ChoiceItemData("1", "item1"), new $c_Lscommons_reactnative_ui_ChoiceItemData("2", "item2")];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3);
  var x$1$2 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
  var x$3 = $m_sjs_js_Any$().toFunction1__sjs_js_Function1__F1(setSingleSelectIds);
  var x$4 = new $c_s_Some(this.styles__Lshowcase_app_ui_ChoiceGroupDemo$Styles().choiceGroup);
  var array$4 = [$$x9.$colon$eq__O__Lio_github_shogowada_statictags_Attribute($m_Lscommons_reactnative_ui_ChoiceGroupProps$().apply__sci_List__sci_Set__F1__Z__s_Option__Lscommons_reactnative_ui_ChoiceGroupProps(x$1$2, singleSelectIds, x$3, false, x$4))];
  var $$x8 = $$x10.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4), $m_sci_Nil$());
  var elements$2 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var $$x7 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements$2).Text__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
  var this$31 = $m_Lscommons_react_navigation_package$();
  var light$1 = this.styles__Lshowcase_app_ui_ChoiceGroupDemo$Styles().title;
  var this$30 = $m_Lscommons_react_navigation_package$();
  var dark$1 = $f_Lscommons_react_navigation_ReactNavigation__themeTextStyle__Lscommons_react_navigation_raw_Theme__Lscommons_reactnative_TextStyle(this$30, theme);
  var array$5 = [$f_Lscommons_react_navigation_ReactNavigation__themeStyle__Lscommons_reactnative_Style__Lscommons_reactnative_Style__Lscommons_react_navigation_raw_Theme__Lio_github_shogowada_statictags_Attribute(this$31, light$1, dark$1, theme)];
  var $$x6 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$5);
  var array$6 = ["Multi-select (with custom data):"];
  var $$x5 = $$x7.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x6, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$6));
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var this$38 = this.Lshowcase_app_ui_ChoiceGroupDemo$__f_customChoiceGroupComp;
  var reactClass$1 = this$38.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass();
  var $$x4 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass$1);
  var $$x1 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes().wrapped__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$WrappedPropsAttributeSpec();
  $m_s_package$();
  var array$7 = [new $c_Lshowcase_app_ui_ChoiceGroupDemo$ChoiceData(1, "option 1", 0.1), new $c_Lshowcase_app_ui_ChoiceGroupDemo$ChoiceData(2, "option 2", 0.2)];
  var elems$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$7);
  var array$10 = [$$x1.$colon$eq__O__Lio_github_shogowada_statictags_Attribute(new $c_Lscommons_reactnative_ui_ChoiceGroupProps($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$1), new $c_sjsr_AnonFunction1((function(this$44) {
    return (function(x$3$2$2) {
      var x$3$2 = $as_Lshowcase_app_ui_ChoiceGroupDemo$ChoiceData(x$3$2$2);
      return x$3$2.Lshowcase_app_ui_ChoiceGroupDemo$ChoiceData__f_id
    })
  })(this)), $m_Lscommons_reactnative_ui_ChoiceGroupProps$().defaultIconRenderer__Z__I__s_Option__F2(true, 24, $m_s_None$()), new $c_sjsr_AnonFunction2((function(this$2$1) {
    return (function(data$2, t$2) {
      var data = $as_Lshowcase_app_ui_ChoiceGroupDemo$ChoiceData(data$2);
      var elements$3 = $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
      var $$x3 = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMElements(elements$3).Text__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec();
      var this$48 = $m_Lscommons_react_navigation_package$();
      var light$2 = $m_Lshowcase_app_ui_ChoiceGroupDemo$().styles__Lshowcase_app_ui_ChoiceGroupDemo$Styles().label;
      var this$47 = $m_Lscommons_react_navigation_package$();
      var dark$2 = $f_Lscommons_react_navigation_ReactNavigation__themeTextStyle__Lscommons_react_navigation_raw_Theme__Lscommons_reactnative_TextStyle(this$47, t$2);
      var array$8 = [$f_Lscommons_react_navigation_ReactNavigation__themeStyle__Lscommons_reactnative_Style__Lscommons_reactnative_Style__Lscommons_react_navigation_raw_Theme__Lio_github_shogowada_statictags_Attribute(this$48, light$2, dark$2, t$2)];
      var $$x2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$8);
      var array$9 = [data.Lshowcase_app_ui_ChoiceGroupDemo$ChoiceData__f_name];
      return $$x3.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x2, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$9))
    })
  })(this)), multiSelectIds, $m_sjs_js_Any$().toFunction1__sjs_js_Function1__F1(setMultiSelectIds), true, new $c_s_Some(this.styles__Lshowcase_app_ui_ChoiceGroupDemo$Styles().choiceGroup)))];
  var array$11 = [$$x11, $$x8, $$x5, $$x4.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$10), $m_sci_Nil$())];
  return $$x15.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($$x14, $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$11))
});
$c_Lshowcase_app_ui_ChoiceGroupDemo$.prototype.styles__Lshowcase_app_ui_ChoiceGroupDemo$Styles = (function() {
  return (((((1 & this.Lshowcase_app_ui_ChoiceGroupDemo$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lshowcase_app_ui_ChoiceGroupDemo$__styles$lzycompute__Lshowcase_app_ui_ChoiceGroupDemo$Styles(this) : this.Lshowcase_app_ui_ChoiceGroupDemo$__f_styles)
});
var $d_Lshowcase_app_ui_ChoiceGroupDemo$ = new $TypeData().initClass({
  Lshowcase_app_ui_ChoiceGroupDemo$: 0
}, false, "showcase.app.ui.ChoiceGroupDemo$", {
  Lshowcase_app_ui_ChoiceGroupDemo$: 1,
  O: 1,
  Lscommons_react_FunctionComponent: 1,
  Lscommons_react_UiComponent: 1
});
$c_Lshowcase_app_ui_ChoiceGroupDemo$.prototype.$classData = $d_Lshowcase_app_ui_ChoiceGroupDemo$;
var $n_Lshowcase_app_ui_ChoiceGroupDemo$;
function $m_Lshowcase_app_ui_ChoiceGroupDemo$() {
  if ((!$n_Lshowcase_app_ui_ChoiceGroupDemo$)) {
    $n_Lshowcase_app_ui_ChoiceGroupDemo$ = new $c_Lshowcase_app_ui_ChoiceGroupDemo$()
  };
  return $n_Lshowcase_app_ui_ChoiceGroupDemo$
}
var $b_Lshowcase_app_ui_ChoiceGroupDemo$Styles;
function $a_Lshowcase_app_ui_ChoiceGroupDemo$Styles() {
  if ((!$b_Lshowcase_app_ui_ChoiceGroupDemo$Styles)) {
    /** @constructor */
    $b_Lshowcase_app_ui_ChoiceGroupDemo$Styles = (function() {
      Object.call(this);
      Object.defineProperty(this, "container", {
        "configurable": true,
        "enumerable": true,
        "writable": true,
        "value": null
      });
      Object.defineProperty(this, "title", {
        "configurable": true,
        "enumerable": true,
        "writable": true,
        "value": null
      });
      Object.defineProperty(this, "choiceGroup", {
        "configurable": true,
        "enumerable": true,
        "writable": true,
        "value": null
      });
      Object.defineProperty(this, "label", {
        "configurable": true,
        "enumerable": true,
        "writable": true,
        "value": null
      });
      this.container = (function(superClass$, arg$outer) {
        return (function() {
          var outer = arg$outer;
          var this\u00f8 = {};
          this\u00f8.flex = null;
          this\u00f8.margin = null;
          this\u00f8.flex = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(1, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this\u00f8.margin = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(5, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().right__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          $s_sr_Statics__releaseFence__V();
          return this\u00f8
        })
      })(Object, this)();
      this.title = (function(superClass$, arg$outer) {
        return (function() {
          var outer = arg$outer;
          var this$2 = {};
          this$2.marginTop = null;
          this$2.marginBottom = null;
          this$2.marginTop = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(15, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().right__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          this$2.marginBottom = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(5, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().right__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          $s_sr_Statics__releaseFence__V();
          return this$2
        })
      })(Object, this)();
      this.choiceGroup = (function(superClass$, arg$outer) {
        return (function() {
          var outer = arg$outer;
          var this$3 = {};
          this$3.alignSelf = null;
          this$3.margin = null;
          this$3.padding = null;
          this$3.alignSelf = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar($m_Lscommons_reactnative_ViewStyle$AlignSelf$().center__Lscommons_reactnative_ViewStyle$AlignSelf(), $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence()));
          this$3.margin = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(5, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().right__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          this$3.padding = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(5, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().right__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          $s_sr_Statics__releaseFence__V();
          return this$3
        })
      })(Object, this)();
      this.label = (function(superClass$, arg$outer) {
        return (function() {
          var outer = arg$outer;
          var this$4 = {};
          this$4.marginHorizontal = null;
          this$4.paddingHorizontal = null;
          this$4.marginHorizontal = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(5, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().right__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          this$4.paddingHorizontal = $m_sjs_js_$bar$().from__O__sjs_js_$bar$Evidence__sjs_js_$bar(5, $m_sjs_js_$bar$Evidence$().left__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().right__sjs_js_$bar$Evidence__sjs_js_$bar$Evidence($m_sjs_js_$bar$Evidence$().base__sjs_js_$bar$Evidence())));
          $s_sr_Statics__releaseFence__V();
          return this$4
        })
      })(Object, this)()
    });
    /** @constructor */
    var $hh_Lshowcase_app_ui_ChoiceGroupDemo$Styles = (function() {
      /*<skip>*/
    });
    $hh_Lshowcase_app_ui_ChoiceGroupDemo$Styles.prototype = Object.prototype;
    $b_Lshowcase_app_ui_ChoiceGroupDemo$Styles.prototype = new $hh_Lshowcase_app_ui_ChoiceGroupDemo$Styles();
    $b_Lshowcase_app_ui_ChoiceGroupDemo$Styles.prototype.constructor = $b_Lshowcase_app_ui_ChoiceGroupDemo$Styles
  };
  return $b_Lshowcase_app_ui_ChoiceGroupDemo$Styles
}
function $p_Lshowcase_app_ui_UiDemoController$__scommons$react$redux$BaseStateController$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz) {
  if (((((2 & $thiz.Lshowcase_app_ui_UiDemoController$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lshowcase_app_ui_UiDemoController$__f_scommons$react$redux$BaseStateController$$reactClass = $f_Lscommons_react_redux_BaseStateController__scommons$react$redux$BaseStateController$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz);
    $thiz.Lshowcase_app_ui_UiDemoController$__f_bitmap$0 = (((2 | $thiz.Lshowcase_app_ui_UiDemoController$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lshowcase_app_ui_UiDemoController$__f_scommons$react$redux$BaseStateController$$reactClass
}
function $p_Lshowcase_app_ui_UiDemoController$__uiComponent$lzycompute__Lscommons_react_UiComponent($thiz) {
  if (((((1 & $thiz.Lshowcase_app_ui_UiDemoController$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Lshowcase_app_ui_UiDemoController$__f_uiComponent = $m_Lshowcase_app_ui_UiDemoScreen$();
    $thiz.Lshowcase_app_ui_UiDemoController$__f_bitmap$0 = (((1 | $thiz.Lshowcase_app_ui_UiDemoController$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lshowcase_app_ui_UiDemoController$__f_uiComponent
}
/** @constructor */
function $c_Lshowcase_app_ui_UiDemoController$() {
  this.Lshowcase_app_ui_UiDemoController$__f_uiComponent = null;
  this.Lshowcase_app_ui_UiDemoController$__f_scommons$react$redux$BaseStateController$$reactClass = null;
  this.Lshowcase_app_ui_UiDemoController$__f_bitmap$0 = 0
}
$c_Lshowcase_app_ui_UiDemoController$.prototype = new $h_O();
$c_Lshowcase_app_ui_UiDemoController$.prototype.constructor = $c_Lshowcase_app_ui_UiDemoController$;
/** @constructor */
function $h_Lshowcase_app_ui_UiDemoController$() {
  /*<skip>*/
}
$h_Lshowcase_app_ui_UiDemoController$.prototype = $c_Lshowcase_app_ui_UiDemoController$.prototype;
$c_Lshowcase_app_ui_UiDemoController$.prototype.mapStateToProps__F1__O__Lio_github_shogowada_scalajs_reactjs_React$Props__O = (function(dispatch, state, props) {
  return $f_Lscommons_reactnative_app_BaseStateAndRouteController__mapStateToProps__F1__O__Lio_github_shogowada_scalajs_reactjs_React$Props__O(this, dispatch, state, props)
});
$c_Lshowcase_app_ui_UiDemoController$.prototype.scommons$react$redux$BaseStateController$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass = (function() {
  return (((((2 & this.Lshowcase_app_ui_UiDemoController$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lshowcase_app_ui_UiDemoController$__scommons$react$redux$BaseStateController$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass(this) : this.Lshowcase_app_ui_UiDemoController$__f_scommons$react$redux$BaseStateController$$reactClass)
});
$c_Lshowcase_app_ui_UiDemoController$.prototype.uiComponent__Lscommons_react_UiComponent = (function() {
  return (((((1 & this.Lshowcase_app_ui_UiDemoController$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lshowcase_app_ui_UiDemoController$__uiComponent$lzycompute__Lscommons_react_UiComponent(this) : this.Lshowcase_app_ui_UiDemoController$__f_uiComponent)
});
$c_Lshowcase_app_ui_UiDemoController$.prototype.mapStateAndRouteToProps__F1__Lshowcase_app_ShowcaseStateDef__Lscommons_react_navigation_Navigation__Lshowcase_app_ui_UiDemoScreenProps = (function(dispatch, state, nav) {
  return new $c_Lshowcase_app_ui_UiDemoScreenProps(new $c_sjsr_AnonFunction1((function(this$1, nav$1) {
    return (function(screen$2) {
      var screen = $as_T(screen$2);
      nav$1.navigate__T__V(screen)
    })
  })(this, nav)))
});
$c_Lshowcase_app_ui_UiDemoController$.prototype.mapStateAndRouteToProps__F1__O__Lscommons_react_navigation_Navigation__O = (function(dispatch, state, nav) {
  return this.mapStateAndRouteToProps__F1__Lshowcase_app_ShowcaseStateDef__Lscommons_react_navigation_Navigation__Lshowcase_app_ui_UiDemoScreenProps(dispatch, $as_Lshowcase_app_ShowcaseStateDef(state), nav)
});
var $d_Lshowcase_app_ui_UiDemoController$ = new $TypeData().initClass({
  Lshowcase_app_ui_UiDemoController$: 0
}, false, "showcase.app.ui.UiDemoController$", {
  Lshowcase_app_ui_UiDemoController$: 1,
  O: 1,
  Lscommons_reactnative_app_BaseStateAndRouteController: 1,
  Lscommons_react_redux_BaseStateController: 1
});
$c_Lshowcase_app_ui_UiDemoController$.prototype.$classData = $d_Lshowcase_app_ui_UiDemoController$;
var $n_Lshowcase_app_ui_UiDemoController$;
function $m_Lshowcase_app_ui_UiDemoController$() {
  if ((!$n_Lshowcase_app_ui_UiDemoController$)) {
    $n_Lshowcase_app_ui_UiDemoController$ = new $c_Lshowcase_app_ui_UiDemoController$()
  };
  return $n_Lshowcase_app_ui_UiDemoController$
}
function $p_Lshowcase_app_ui_UiDemoScreen$__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz) {
  if ((!$thiz.Lshowcase_app_ui_UiDemoScreen$__f_bitmap$0)) {
    $thiz.Lshowcase_app_ui_UiDemoScreen$__f_scommons$react$UiComponent$$reactClass = $f_Lscommons_react_FunctionComponent__create__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass($thiz);
    $thiz.Lshowcase_app_ui_UiDemoScreen$__f_bitmap$0 = true
  };
  return $thiz.Lshowcase_app_ui_UiDemoScreen$__f_scommons$react$UiComponent$$reactClass
}
/** @constructor */
function $c_Lshowcase_app_ui_UiDemoScreen$() {
  this.Lshowcase_app_ui_UiDemoScreen$__f_scommons$react$UiComponent$$reactClass = null;
  this.Lshowcase_app_ui_UiDemoScreen$__f_bitmap$0 = false
}
$c_Lshowcase_app_ui_UiDemoScreen$.prototype = new $h_O();
$c_Lshowcase_app_ui_UiDemoScreen$.prototype.constructor = $c_Lshowcase_app_ui_UiDemoScreen$;
/** @constructor */
function $h_Lshowcase_app_ui_UiDemoScreen$() {
  /*<skip>*/
}
$h_Lshowcase_app_ui_UiDemoScreen$.prototype = $c_Lshowcase_app_ui_UiDemoScreen$.prototype;
$c_Lshowcase_app_ui_UiDemoScreen$.prototype.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass = (function() {
  return ((!this.Lshowcase_app_ui_UiDemoScreen$__f_bitmap$0) ? $p_Lshowcase_app_ui_UiDemoScreen$__scommons$react$UiComponent$$reactClass$lzycompute__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass(this) : this.Lshowcase_app_ui_UiDemoScreen$__f_scommons$react$UiComponent$$reactClass)
});
$c_Lshowcase_app_ui_UiDemoScreen$.prototype.render__Lio_github_shogowada_scalajs_reactjs_React$Props__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement = (function(compProps) {
  var props = $as_Lshowcase_app_ui_UiDemoScreenProps(compProps.wrapped__O());
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var this$1 = $m_Lshowcase_app_ShowcaseListView$();
  var reactClass = this$1.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass();
  var $$x2 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass);
  var $$x1 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes().wrapped__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$WrappedPropsAttributeSpec();
  $m_s_package$();
  var array = [new $c_T2("ChoiceGroup", "Demo ChoiceGroup component")];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var array$1 = [$$x1.$colon$eq__O__Lio_github_shogowada_statictags_Attribute(new $c_Lshowcase_app_ShowcaseListViewProps($m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems), props.Lshowcase_app_ui_UiDemoScreenProps__f_navigate))];
  return $$x2.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1), $m_sci_Nil$())
});
$c_Lshowcase_app_ui_UiDemoScreen$.prototype.getUiStack__Lscommons_react_navigation_stack_raw_StackNavigator__sci_Seq = (function(stack) {
  $m_s_package$();
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var reactClass = stack.Screen;
  var $$x7 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass);
  var this$2 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes().name__Lio_github_shogowada_statictags_StringAttributeSpec();
  var $$x6 = new $c_Lio_github_shogowada_statictags_Attribute(this$2.Lio_github_shogowada_statictags_StringAttributeSpec__f_name, "UI", $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$());
  $m_Lscommons_react_navigation_package$();
  var attributes = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var $$x5 = new $c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes(attributes).component__Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenComponentAttributeSpec();
  var this$5 = $m_Lshowcase_app_ui_UiDemoController$();
  var array = [$$x6, $$x5.$colon$eq__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass__Lio_github_shogowada_statictags_Attribute(this$5.scommons$react$redux$BaseStateController$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass())];
  var $$x4 = $$x7.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array), $m_sci_Nil$());
  $m_Lscommons_react_package$().$less__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements();
  var reactClass$1 = stack.Screen;
  var $$x3 = new $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec($m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMElements__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$(), reactClass$1);
  var this$10 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes().name__Lio_github_shogowada_statictags_StringAttributeSpec();
  var $$x2 = new $c_Lio_github_shogowada_statictags_Attribute(this$10.Lio_github_shogowada_statictags_StringAttributeSpec__f_name, "ChoiceGroup", $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$());
  $m_Lscommons_react_navigation_package$();
  var attributes$1 = $m_Lscommons_react_package$().$up__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes();
  var $$x1 = new $c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes(attributes$1).component__Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenComponentAttributeSpec();
  var this$13 = $m_Lshowcase_app_ui_ChoiceGroupDemo$();
  var array$1 = [$$x2, $$x1.$colon$eq__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass__Lio_github_shogowada_statictags_Attribute(this$13.scommons$react$UiComponent$$reactClass__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass())];
  var array$2 = [$$x4, $$x3.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1), $m_sci_Nil$())];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)
});
var $d_Lshowcase_app_ui_UiDemoScreen$ = new $TypeData().initClass({
  Lshowcase_app_ui_UiDemoScreen$: 0
}, false, "showcase.app.ui.UiDemoScreen$", {
  Lshowcase_app_ui_UiDemoScreen$: 1,
  O: 1,
  Lscommons_react_FunctionComponent: 1,
  Lscommons_react_UiComponent: 1
});
$c_Lshowcase_app_ui_UiDemoScreen$.prototype.$classData = $d_Lshowcase_app_ui_UiDemoScreen$;
var $n_Lshowcase_app_ui_UiDemoScreen$;
function $m_Lshowcase_app_ui_UiDemoScreen$() {
  if ((!$n_Lshowcase_app_ui_UiDemoScreen$)) {
    $n_Lshowcase_app_ui_UiDemoScreen$ = new $c_Lshowcase_app_ui_UiDemoScreen$()
  };
  return $n_Lshowcase_app_ui_UiDemoScreen$
}
/** @constructor */
function $c_Lio_github_shogowada_scalajs_reactjs_React$Props(native) {
  this.Lio_github_shogowada_scalajs_reactjs_React$Props__f_native = null;
  this.Lio_github_shogowada_scalajs_reactjs_React$Props__f_native = native
}
$c_Lio_github_shogowada_scalajs_reactjs_React$Props.prototype = new $h_O();
$c_Lio_github_shogowada_scalajs_reactjs_React$Props.prototype.constructor = $c_Lio_github_shogowada_scalajs_reactjs_React$Props;
/** @constructor */
function $h_Lio_github_shogowada_scalajs_reactjs_React$Props() {
  /*<skip>*/
}
$h_Lio_github_shogowada_scalajs_reactjs_React$Props.prototype = $c_Lio_github_shogowada_scalajs_reactjs_React$Props.prototype;
$c_Lio_github_shogowada_scalajs_reactjs_React$Props.prototype.wrapped__O = (function() {
  return this.Lio_github_shogowada_scalajs_reactjs_React$Props__f_native.wrapped
});
$c_Lio_github_shogowada_scalajs_reactjs_React$Props.prototype.children__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement = (function() {
  return this.Lio_github_shogowada_scalajs_reactjs_React$Props__f_native.children
});
$c_Lio_github_shogowada_scalajs_reactjs_React$Props.prototype.productPrefix__T = (function() {
  return "Props"
});
$c_Lio_github_shogowada_scalajs_reactjs_React$Props.prototype.productArity__I = (function() {
  return 1
});
$c_Lio_github_shogowada_scalajs_reactjs_React$Props.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lio_github_shogowada_scalajs_reactjs_React$Props__f_native : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lio_github_shogowada_scalajs_reactjs_React$Props.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lio_github_shogowada_scalajs_reactjs_React$Props.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lio_github_shogowada_scalajs_reactjs_React$Props.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lio_github_shogowada_scalajs_reactjs_React$Props.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lio_github_shogowada_scalajs_reactjs_React$Props)) {
    var Props$1 = $as_Lio_github_shogowada_scalajs_reactjs_React$Props(x$1);
    var x = this.Lio_github_shogowada_scalajs_reactjs_React$Props__f_native;
    var y = Props$1.Lio_github_shogowada_scalajs_reactjs_React$Props__f_native;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y)
  } else {
    return false
  }
});
function $as_Lio_github_shogowada_scalajs_reactjs_React$Props(obj) {
  return (((obj instanceof $c_Lio_github_shogowada_scalajs_reactjs_React$Props) || (obj === null)) ? obj : $throwClassCastException(obj, "io.github.shogowada.scalajs.reactjs.React$Props"))
}
function $isArrayOf_Lio_github_shogowada_scalajs_reactjs_React$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_github_shogowada_scalajs_reactjs_React$Props)))
}
function $asArrayOf_Lio_github_shogowada_scalajs_reactjs_React$Props(obj, depth) {
  return (($isArrayOf_Lio_github_shogowada_scalajs_reactjs_React$Props(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.github.shogowada.scalajs.reactjs.React$Props;", depth))
}
var $d_Lio_github_shogowada_scalajs_reactjs_React$Props = new $TypeData().initClass({
  Lio_github_shogowada_scalajs_reactjs_React$Props: 0
}, false, "io.github.shogowada.scalajs.reactjs.React$Props", {
  Lio_github_shogowada_scalajs_reactjs_React$Props: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_github_shogowada_scalajs_reactjs_React$Props.prototype.$classData = $d_Lio_github_shogowada_scalajs_reactjs_React$Props;
/** @constructor */
function $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec(outer, reactClass) {
  this.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec__f_reactClass = null;
  this.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec__f_$outer = null;
  this.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec__f_reactClass = reactClass;
  if ((outer === null)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(null)
  } else {
    this.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec__f_$outer = outer
  }
}
$c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec.prototype = new $h_O();
$c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec.prototype.constructor = $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec;
/** @constructor */
function $h_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec() {
  /*<skip>*/
}
$h_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec.prototype = $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec.prototype;
$c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec.prototype.apply__sci_Seq__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement = (function(attributes, contents) {
  return $m_Lio_github_shogowada_scalajs_reactjs_React$().createElement__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass__sjs_js_Any__sci_Seq__Lio_github_shogowada_scalajs_reactjs_elements_ReactElement(this.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec__f_reactClass, this.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec__f_$outer.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$__f_$outer.VirtualDOMAttributes__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$().toReactAttributes__sc_Iterable__sjs_js_Dictionary($m_Lio_github_shogowada_statictags_Element$().flattenAttributes__sc_Iterable__sc_Iterable(attributes)), this.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec__f_$outer.toReactElements__sci_Seq__sci_Seq($m_Lio_github_shogowada_statictags_Element$().flattenContents__sci_Seq__sci_Seq(contents)))
});
$c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec.prototype.productPrefix__T = (function() {
  return "ReactClassElementSpec"
});
$c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec.prototype.productArity__I = (function() {
  return 1
});
$c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec__f_reactClass : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if (((x$1 instanceof $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec) && ($as_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec(x$1).Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec__f_$outer === this.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec__f_$outer))) {
    var ReactClassElementSpec$1 = $as_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec(x$1);
    var x = this.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec__f_reactClass;
    var y = ReactClassElementSpec$1.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec__f_reactClass;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y)
  } else {
    return false
  }
});
function $as_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec(obj) {
  return (((obj instanceof $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec) || (obj === null)) ? obj : $throwClassCastException(obj, "io.github.shogowada.scalajs.reactjs.VirtualDOM$VirtualDOMElements$ReactClassElementSpec"))
}
function $isArrayOf_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec)))
}
function $asArrayOf_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec(obj, depth) {
  return (($isArrayOf_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.github.shogowada.scalajs.reactjs.VirtualDOM$VirtualDOMElements$ReactClassElementSpec;", depth))
}
var $d_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec = new $TypeData().initClass({
  Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec: 0
}, false, "io.github.shogowada.scalajs.reactjs.VirtualDOM$VirtualDOMElements$ReactClassElementSpec", {
  Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec.prototype.$classData = $d_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMElements$ReactClassElementSpec;
/** @constructor */
function $c_Lio_github_shogowada_scalajs_reactjs_redux_Store(native) {
  this.Lio_github_shogowada_scalajs_reactjs_redux_Store__f_native = null;
  this.Lio_github_shogowada_scalajs_reactjs_redux_Store__f_native = native
}
$c_Lio_github_shogowada_scalajs_reactjs_redux_Store.prototype = new $h_O();
$c_Lio_github_shogowada_scalajs_reactjs_redux_Store.prototype.constructor = $c_Lio_github_shogowada_scalajs_reactjs_redux_Store;
/** @constructor */
function $h_Lio_github_shogowada_scalajs_reactjs_redux_Store() {
  /*<skip>*/
}
$h_Lio_github_shogowada_scalajs_reactjs_redux_Store.prototype = $c_Lio_github_shogowada_scalajs_reactjs_redux_Store.prototype;
$c_Lio_github_shogowada_scalajs_reactjs_redux_Store.prototype.productPrefix__T = (function() {
  return "Store"
});
$c_Lio_github_shogowada_scalajs_reactjs_redux_Store.prototype.productArity__I = (function() {
  return 1
});
$c_Lio_github_shogowada_scalajs_reactjs_redux_Store.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lio_github_shogowada_scalajs_reactjs_redux_Store__f_native : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lio_github_shogowada_scalajs_reactjs_redux_Store.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lio_github_shogowada_scalajs_reactjs_redux_Store.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lio_github_shogowada_scalajs_reactjs_redux_Store.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lio_github_shogowada_scalajs_reactjs_redux_Store.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lio_github_shogowada_scalajs_reactjs_redux_Store)) {
    var Store$1 = $as_Lio_github_shogowada_scalajs_reactjs_redux_Store(x$1);
    var x = this.Lio_github_shogowada_scalajs_reactjs_redux_Store__f_native;
    var y = Store$1.Lio_github_shogowada_scalajs_reactjs_redux_Store__f_native;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y)
  } else {
    return false
  }
});
function $as_Lio_github_shogowada_scalajs_reactjs_redux_Store(obj) {
  return (((obj instanceof $c_Lio_github_shogowada_scalajs_reactjs_redux_Store) || (obj === null)) ? obj : $throwClassCastException(obj, "io.github.shogowada.scalajs.reactjs.redux.Store"))
}
function $isArrayOf_Lio_github_shogowada_scalajs_reactjs_redux_Store(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_github_shogowada_scalajs_reactjs_redux_Store)))
}
function $asArrayOf_Lio_github_shogowada_scalajs_reactjs_redux_Store(obj, depth) {
  return (($isArrayOf_Lio_github_shogowada_scalajs_reactjs_redux_Store(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.github.shogowada.scalajs.reactjs.redux.Store;", depth))
}
var $d_Lio_github_shogowada_scalajs_reactjs_redux_Store = new $TypeData().initClass({
  Lio_github_shogowada_scalajs_reactjs_redux_Store: 0
}, false, "io.github.shogowada.scalajs.reactjs.redux.Store", {
  Lio_github_shogowada_scalajs_reactjs_redux_Store: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_github_shogowada_scalajs_reactjs_redux_Store.prototype.$classData = $d_Lio_github_shogowada_scalajs_reactjs_redux_Store;
function $p_Lio_github_shogowada_statictags_Attribute__delimitValues__sc_Iterable__T__T($thiz, values, delimiter) {
  var this$2 = $as_sc_IterableOnceOps(values.map__F1__O(new $c_sjsr_AnonFunction1((function(this$1) {
    return (function(x$1$2) {
      return $dp_toString__T(x$1$2)
    })
  })($thiz))));
  return $f_sc_IterableOnceOps__mkString__T__T__T__T(this$2, "", delimiter, "")
}
function $p_Lio_github_shogowada_statictags_Attribute__formatCss__sci_Map__T($thiz, valueMap) {
  var this$2 = $as_sc_IterableOnceOps(valueMap.map__F1__O(new $c_sjsr_AnonFunction1((function(this$1) {
    return (function(kv$2) {
      var kv = $as_T2(kv$2);
      return (((kv._1__O() + ":") + kv._2__O()) + ";")
    })
  })($thiz))));
  return $f_sc_IterableOnceOps__mkString__T__T__T__T(this$2, "", "", "")
}
function $p_Lio_github_shogowada_statictags_Attribute__quoteAndAddEqual__T__T($thiz, value) {
  return (("=\"" + value) + "\"")
}
/** @constructor */
function $c_Lio_github_shogowada_statictags_Attribute(name, value, valueType) {
  this.Lio_github_shogowada_statictags_Attribute__f_name = null;
  this.Lio_github_shogowada_statictags_Attribute__f_value = null;
  this.Lio_github_shogowada_statictags_Attribute__f_valueType = null;
  this.Lio_github_shogowada_statictags_Attribute__f_name = name;
  this.Lio_github_shogowada_statictags_Attribute__f_value = value;
  this.Lio_github_shogowada_statictags_Attribute__f_valueType = valueType
}
$c_Lio_github_shogowada_statictags_Attribute.prototype = new $h_O();
$c_Lio_github_shogowada_statictags_Attribute.prototype.constructor = $c_Lio_github_shogowada_statictags_Attribute;
/** @constructor */
function $h_Lio_github_shogowada_statictags_Attribute() {
  /*<skip>*/
}
$h_Lio_github_shogowada_statictags_Attribute.prototype = $c_Lio_github_shogowada_statictags_Attribute.prototype;
$c_Lio_github_shogowada_statictags_Attribute.prototype.toString__T = (function() {
  var p4 = this.Lio_github_shogowada_statictags_Attribute__f_valueType;
  if (((typeof this.Lio_github_shogowada_statictags_Attribute__f_value) === "boolean")) {
    var x = $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$();
    var $$x1 = (x === p4)
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    return this.valueToString__T()
  };
  return (("" + this.Lio_github_shogowada_statictags_Attribute__f_name) + $p_Lio_github_shogowada_statictags_Attribute__quoteAndAddEqual__T__T(this, this.valueToString__T()))
});
$c_Lio_github_shogowada_statictags_Attribute.prototype.valueToString__T = (function() {
  var values = this.Lio_github_shogowada_statictags_Attribute__f_value;
  var p3 = this.Lio_github_shogowada_statictags_Attribute__f_valueType;
  if ($is_sc_Iterable(values)) {
    var x = $m_Lio_github_shogowada_statictags_AttributeValueType$COMMA\uff3fSEPARATED$();
    if ((x === p3)) {
      return $p_Lio_github_shogowada_statictags_Attribute__delimitValues__sc_Iterable__T__T(this, $as_sc_Iterable(values), ",")
    }
  };
  var values$2 = this.Lio_github_shogowada_statictags_Attribute__f_value;
  var p5 = this.Lio_github_shogowada_statictags_Attribute__f_valueType;
  if ($is_sc_Iterable(values$2)) {
    var x$3 = $m_Lio_github_shogowada_statictags_AttributeValueType$SPACE\uff3fSEPARATED$();
    if ((x$3 === p5)) {
      return $p_Lio_github_shogowada_statictags_Attribute__delimitValues__sc_Iterable__T__T(this, $as_sc_Iterable(values$2), " ")
    }
  };
  var valueMap = this.Lio_github_shogowada_statictags_Attribute__f_value;
  var p7 = this.Lio_github_shogowada_statictags_Attribute__f_valueType;
  if ($is_sci_Map(valueMap)) {
    var x$5 = $m_Lio_github_shogowada_statictags_AttributeValueType$CSS$();
    if ((x$5 === p7)) {
      return $p_Lio_github_shogowada_statictags_Attribute__formatCss__sci_Map__T(this, $as_sci_Map(valueMap))
    }
  };
  var theValue = this.Lio_github_shogowada_statictags_Attribute__f_value;
  var p9 = this.Lio_github_shogowada_statictags_Attribute__f_valueType;
  if (((typeof theValue) === "boolean")) {
    var x25 = $uZ(theValue);
    var x$7 = $m_Lio_github_shogowada_statictags_AttributeValueType$ON\uff3fOR\uff3fOFF$();
    if ((x$7 === p9)) {
      return $as_T(new $c_Lio_github_shogowada_statictags_Attribute$RichBoolean(this, x25).fold__O__O__O("on", "off"))
    }
  };
  var theValue$2 = this.Lio_github_shogowada_statictags_Attribute__f_value;
  var p11 = this.Lio_github_shogowada_statictags_Attribute__f_valueType;
  if (((typeof theValue$2) === "boolean")) {
    var x27 = $uZ(theValue$2);
    var x$9 = $m_Lio_github_shogowada_statictags_AttributeValueType$TRUE\uff3fOR\uff3fFALSE$();
    if ((x$9 === p11)) {
      return $as_T(new $c_Lio_github_shogowada_statictags_Attribute$RichBoolean(this, x27).fold__O__O__O("true", "false"))
    }
  };
  var theValue$3 = this.Lio_github_shogowada_statictags_Attribute__f_value;
  var p13 = this.Lio_github_shogowada_statictags_Attribute__f_valueType;
  if (((typeof theValue$3) === "boolean")) {
    var x29 = $uZ(theValue$3);
    var x$11 = $m_Lio_github_shogowada_statictags_AttributeValueType$YES\uff3fOR\uff3fNO$();
    if ((x$11 === p13)) {
      return $as_T(new $c_Lio_github_shogowada_statictags_Attribute$RichBoolean(this, x29).fold__O__O__O("yes", "no"))
    }
  };
  var theValue$4 = this.Lio_github_shogowada_statictags_Attribute__f_value;
  var p15 = this.Lio_github_shogowada_statictags_Attribute__f_valueType;
  if (((typeof theValue$4) === "boolean")) {
    var x31 = $uZ(theValue$4);
    var x$13 = $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$();
    if ((x$13 === p15)) {
      return $as_T(new $c_Lio_github_shogowada_statictags_Attribute$RichBoolean(this, x31).fold__O__O__O(this.Lio_github_shogowada_statictags_Attribute__f_name, ""))
    }
  };
  return $dp_toString__T(this.Lio_github_shogowada_statictags_Attribute__f_value)
});
$c_Lio_github_shogowada_statictags_Attribute.prototype.productPrefix__T = (function() {
  return "Attribute"
});
$c_Lio_github_shogowada_statictags_Attribute.prototype.productArity__I = (function() {
  return 3
});
$c_Lio_github_shogowada_statictags_Attribute.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lio_github_shogowada_statictags_Attribute__f_name;
      break
    }
    case 1: {
      return this.Lio_github_shogowada_statictags_Attribute__f_value;
      break
    }
    case 2: {
      return this.Lio_github_shogowada_statictags_Attribute__f_valueType;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lio_github_shogowada_statictags_Attribute.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lio_github_shogowada_statictags_Attribute.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lio_github_shogowada_statictags_Attribute.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lio_github_shogowada_statictags_Attribute)) {
    var Attribute$1 = $as_Lio_github_shogowada_statictags_Attribute(x$1);
    if ((this.Lio_github_shogowada_statictags_Attribute__f_name === Attribute$1.Lio_github_shogowada_statictags_Attribute__f_name)) {
      var x = this.Lio_github_shogowada_statictags_Attribute__f_value;
      var y = Attribute$1.Lio_github_shogowada_statictags_Attribute__f_value;
      var $$x1 = $m_sr_BoxesRunTime$().equals__O__O__Z(x, y)
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$2 = this.Lio_github_shogowada_statictags_Attribute__f_valueType;
      var x$2$1 = Attribute$1.Lio_github_shogowada_statictags_Attribute__f_valueType;
      return (x$2 === x$2$1)
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lio_github_shogowada_statictags_Attribute(obj) {
  return (((obj instanceof $c_Lio_github_shogowada_statictags_Attribute) || (obj === null)) ? obj : $throwClassCastException(obj, "io.github.shogowada.statictags.Attribute"))
}
function $isArrayOf_Lio_github_shogowada_statictags_Attribute(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_github_shogowada_statictags_Attribute)))
}
function $asArrayOf_Lio_github_shogowada_statictags_Attribute(obj, depth) {
  return (($isArrayOf_Lio_github_shogowada_statictags_Attribute(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.github.shogowada.statictags.Attribute;", depth))
}
var $d_Lio_github_shogowada_statictags_Attribute = new $TypeData().initClass({
  Lio_github_shogowada_statictags_Attribute: 0
}, false, "io.github.shogowada.statictags.Attribute", {
  Lio_github_shogowada_statictags_Attribute: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_github_shogowada_statictags_Attribute.prototype.$classData = $d_Lio_github_shogowada_statictags_Attribute;
function $as_Lio_github_shogowada_statictags_Element(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "io.github.shogowada.statictags.Element"))
}
function $isArrayOf_Lio_github_shogowada_statictags_Element(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_github_shogowada_statictags_Element)))
}
function $asArrayOf_Lio_github_shogowada_statictags_Element(obj, depth) {
  return (($isArrayOf_Lio_github_shogowada_statictags_Element(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.github.shogowada.statictags.Element;", depth))
}
/** @constructor */
function $c_Ljava_io_IOException() {
  this.jl_Throwable__f_s = null;
  this.jl_Throwable__f_e = null;
  this.jl_Throwable__f_enableSuppression = false;
  this.jl_Throwable__f_writableStackTrace = false;
  this.jl_Throwable__f_stackTraceStateInternal = null;
  this.jl_Throwable__f_stackTrace = null;
  this.jl_Throwable__f_suppressed = null
}
$c_Ljava_io_IOException.prototype = new $h_jl_Exception();
$c_Ljava_io_IOException.prototype.constructor = $c_Ljava_io_IOException;
/** @constructor */
function $h_Ljava_io_IOException() {
  /*<skip>*/
}
$h_Ljava_io_IOException.prototype = $c_Ljava_io_IOException.prototype;
function $as_Ljava_io_IOException(obj) {
  return (((obj instanceof $c_Ljava_io_IOException) || (obj === null)) ? obj : $throwClassCastException(obj, "java.io.IOException"))
}
function $isArrayOf_Ljava_io_IOException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_io_IOException)))
}
function $asArrayOf_Ljava_io_IOException(obj, depth) {
  return (($isArrayOf_Ljava_io_IOException(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.io.IOException;", depth))
}
/** @constructor */
function $c_Ljava_io_OutputStream() {
  /*<skip>*/
}
$c_Ljava_io_OutputStream.prototype = new $h_O();
$c_Ljava_io_OutputStream.prototype.constructor = $c_Ljava_io_OutputStream;
/** @constructor */
function $h_Ljava_io_OutputStream() {
  /*<skip>*/
}
$h_Ljava_io_OutputStream.prototype = $c_Ljava_io_OutputStream.prototype;
function $ct_jl_AssertionError__($thiz) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, null, null, true, true);
  return $thiz
}
function $ct_jl_AssertionError__O__($thiz, detailMessage) {
  var message = ("" + detailMessage);
  if ((detailMessage instanceof $c_jl_Throwable)) {
    var x2 = $as_jl_Throwable(detailMessage);
    var cause = x2
  } else {
    var cause = null
  };
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, message, cause, true, true);
  return $thiz
}
/** @constructor */
function $c_jl_AssertionError() {
  this.jl_Throwable__f_s = null;
  this.jl_Throwable__f_e = null;
  this.jl_Throwable__f_enableSuppression = false;
  this.jl_Throwable__f_writableStackTrace = false;
  this.jl_Throwable__f_stackTraceStateInternal = null;
  this.jl_Throwable__f_stackTrace = null;
  this.jl_Throwable__f_suppressed = null
}
$c_jl_AssertionError.prototype = new $h_jl_Error();
$c_jl_AssertionError.prototype.constructor = $c_jl_AssertionError;
/** @constructor */
function $h_jl_AssertionError() {
  /*<skip>*/
}
$h_jl_AssertionError.prototype = $c_jl_AssertionError.prototype;
var $d_jl_AssertionError = new $TypeData().initClass({
  jl_AssertionError: 0
}, false, "java.lang.AssertionError", {
  jl_AssertionError: 1,
  jl_Error: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_AssertionError.prototype.$classData = $d_jl_AssertionError;
function $f_jl_Byte__equals__O__Z($thiz, that) {
  return $is($thiz, that)
}
function $f_jl_Byte__hashCode__I($thiz) {
  return $uB($thiz)
}
function $f_jl_Byte__toString__T($thiz) {
  var b = $uB($thiz);
  return ("" + b)
}
function $as_jl_Byte(obj) {
  return (($isByte(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Byte"))
}
function $isArrayOf_jl_Byte(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Byte)))
}
function $asArrayOf_jl_Byte(obj, depth) {
  return (($isArrayOf_jl_Byte(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Byte;", depth))
}
var $d_jl_Byte = new $TypeData().initClass({
  jl_Byte: 0
}, false, "java.lang.Byte", {
  jl_Byte: 1,
  jl_Number: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1
}, (void 0), (void 0), (function(x) {
  return $isByte(x)
}));
function $f_jl_Double__equals__O__Z($thiz, that) {
  return $is($thiz, that)
}
function $f_jl_Double__hashCode__I($thiz) {
  var value = $uD($thiz);
  return $m_jl_FloatingPointBits$().numberHashCode__D__I(value)
}
function $f_jl_Double__toString__T($thiz) {
  var d = $uD($thiz);
  return ("" + d)
}
function $as_jl_Double(obj) {
  return ((((typeof obj) === "number") || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Double"))
}
function $isArrayOf_jl_Double(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Double)))
}
function $asArrayOf_jl_Double(obj, depth) {
  return (($isArrayOf_jl_Double(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Double;", depth))
}
var $d_jl_Double = new $TypeData().initClass({
  jl_Double: 0
}, false, "java.lang.Double", {
  jl_Double: 1,
  jl_Number: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1
}, (void 0), (void 0), (function(x) {
  return ((typeof x) === "number")
}));
function $f_jl_Float__equals__O__Z($thiz, that) {
  return $is($thiz, that)
}
function $f_jl_Float__hashCode__I($thiz) {
  var value = $uF($thiz);
  return $m_jl_FloatingPointBits$().numberHashCode__D__I(value)
}
function $f_jl_Float__toString__T($thiz) {
  var f = $uF($thiz);
  return ("" + f)
}
function $as_jl_Float(obj) {
  return ((((typeof obj) === "number") || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Float"))
}
function $isArrayOf_jl_Float(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Float)))
}
function $asArrayOf_jl_Float(obj, depth) {
  return (($isArrayOf_jl_Float(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Float;", depth))
}
var $d_jl_Float = new $TypeData().initClass({
  jl_Float: 0
}, false, "java.lang.Float", {
  jl_Float: 1,
  jl_Number: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1
}, (void 0), (void 0), (function(x) {
  return ((typeof x) === "number")
}));
function $f_jl_Integer__equals__O__Z($thiz, that) {
  return $is($thiz, that)
}
function $f_jl_Integer__hashCode__I($thiz) {
  return $uI($thiz)
}
function $f_jl_Integer__toString__T($thiz) {
  var i = $uI($thiz);
  return ("" + i)
}
function $as_jl_Integer(obj) {
  return (($isInt(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Integer"))
}
function $isArrayOf_jl_Integer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Integer)))
}
function $asArrayOf_jl_Integer(obj, depth) {
  return (($isArrayOf_jl_Integer(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Integer;", depth))
}
var $d_jl_Integer = new $TypeData().initClass({
  jl_Integer: 0
}, false, "java.lang.Integer", {
  jl_Integer: 1,
  jl_Number: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1
}, (void 0), (void 0), (function(x) {
  return $isInt(x)
}));
function $as_jl_InterruptedException(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.InterruptedException"))
}
function $isArrayOf_jl_InterruptedException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_InterruptedException)))
}
function $asArrayOf_jl_InterruptedException(obj, depth) {
  return (($isArrayOf_jl_InterruptedException(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.InterruptedException;", depth))
}
function $as_jl_LinkageError(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.LinkageError"))
}
function $isArrayOf_jl_LinkageError(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_LinkageError)))
}
function $asArrayOf_jl_LinkageError(obj, depth) {
  return (($isArrayOf_jl_LinkageError(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.LinkageError;", depth))
}
function $f_jl_Long__equals__O__Z($thiz, that) {
  if ((that instanceof $c_RTLong)) {
    var x2 = $as_jl_Long(that);
    var this$1 = $uJ($thiz);
    var b = $uJ(x2);
    return ((this$1.RTLong__f_lo === b.RTLong__f_lo) && (this$1.RTLong__f_hi === b.RTLong__f_hi))
  } else {
    return false
  }
}
function $f_jl_Long__hashCode__I($thiz) {
  var t = $uJ($thiz);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  return (lo ^ hi)
}
function $f_jl_Long__toString__T($thiz) {
  var this$1 = $uJ($thiz);
  return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toString__I__I__T(this$1.RTLong__f_lo, this$1.RTLong__f_hi)
}
function $as_jl_Long(obj) {
  return (((obj instanceof $c_RTLong) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Long"))
}
function $isArrayOf_jl_Long(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Long)))
}
function $asArrayOf_jl_Long(obj, depth) {
  return (($isArrayOf_jl_Long(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Long;", depth))
}
var $d_jl_Long = new $TypeData().initClass({
  jl_Long: 0
}, false, "java.lang.Long", {
  jl_Long: 1,
  jl_Number: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1
}, (void 0), (void 0), (function(x) {
  return (x instanceof $c_RTLong)
}));
function $ct_jl_RuntimeException__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz
}
/** @constructor */
function $c_jl_RuntimeException() {
  this.jl_Throwable__f_s = null;
  this.jl_Throwable__f_e = null;
  this.jl_Throwable__f_enableSuppression = false;
  this.jl_Throwable__f_writableStackTrace = false;
  this.jl_Throwable__f_stackTraceStateInternal = null;
  this.jl_Throwable__f_stackTrace = null;
  this.jl_Throwable__f_suppressed = null
}
$c_jl_RuntimeException.prototype = new $h_jl_Exception();
$c_jl_RuntimeException.prototype.constructor = $c_jl_RuntimeException;
/** @constructor */
function $h_jl_RuntimeException() {
  /*<skip>*/
}
$h_jl_RuntimeException.prototype = $c_jl_RuntimeException.prototype;
var $d_jl_RuntimeException = new $TypeData().initClass({
  jl_RuntimeException: 0
}, false, "java.lang.RuntimeException", {
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_RuntimeException.prototype.$classData = $d_jl_RuntimeException;
function $f_jl_Short__equals__O__Z($thiz, that) {
  return $is($thiz, that)
}
function $f_jl_Short__hashCode__I($thiz) {
  return $uS($thiz)
}
function $f_jl_Short__toString__T($thiz) {
  var s = $uS($thiz);
  return ("" + s)
}
function $as_jl_Short(obj) {
  return (($isShort(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Short"))
}
function $isArrayOf_jl_Short(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Short)))
}
function $asArrayOf_jl_Short(obj, depth) {
  return (($isArrayOf_jl_Short(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Short;", depth))
}
var $d_jl_Short = new $TypeData().initClass({
  jl_Short: 0
}, false, "java.lang.Short", {
  jl_Short: 1,
  jl_Number: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1
}, (void 0), (void 0), (function(x) {
  return $isShort(x)
}));
function $f_T__charAt__I__C($thiz, index) {
  return (65535 & $uI($thiz.charCodeAt(index)))
}
function $f_T__hashCode__I($thiz) {
  var res = 0;
  var mul = 1;
  var i = (((-1) + $uI($thiz.length)) | 0);
  while ((i >= 0)) {
    var $$x1 = res;
    var index = i;
    res = (($$x1 + $imul((65535 & $uI($thiz.charCodeAt(index))), mul)) | 0);
    mul = $imul(31, mul);
    i = (((-1) + i) | 0)
  };
  return res
}
function $f_T__equals__O__Z($thiz, that) {
  return ($thiz === that)
}
function $f_T__compareToIgnoreCase__T__I($thiz, str) {
  var thisLength = $uI($thiz.length);
  var strLength = $uI(str.length);
  var minLength = ((thisLength < strLength) ? thisLength : strLength);
  var i = 0;
  while ((i !== minLength)) {
    var index = i;
    var c = (65535 & $uI($thiz.charCodeAt(index)));
    var $$x1 = $m_jl_Character$().toLowerCase__C__C($m_jl_Character$().toUpperCase__C__C(c));
    var index$1 = i;
    var c$1 = (65535 & $uI(str.charCodeAt(index$1)));
    var cmp = (($$x1 - $m_jl_Character$().toLowerCase__C__C($m_jl_Character$().toUpperCase__C__C(c$1))) | 0);
    if ((cmp !== 0)) {
      return cmp
    };
    i = ((1 + i) | 0)
  };
  return ((thisLength - strLength) | 0)
}
function $f_T__endsWith__T__Z($thiz, suffix) {
  return ($as_T($thiz.substring((($uI($thiz.length) - $uI(suffix.length)) | 0))) === suffix)
}
function $f_T__getChars__I__I__AC__I__V($thiz, srcBegin, srcEnd, dst, dstBegin) {
  if (((((srcEnd > $uI($thiz.length)) || (srcBegin < 0)) || (srcEnd < 0)) || (srcBegin > srcEnd))) {
    throw $ct_jl_StringIndexOutOfBoundsException__T__(new $c_jl_StringIndexOutOfBoundsException(), "Index out of Bound")
  };
  var offset = ((dstBegin - srcBegin) | 0);
  var i = srcBegin;
  while ((i < srcEnd)) {
    var $$x1 = i;
    var index = i;
    dst.set((($$x1 + offset) | 0), (65535 & $uI($thiz.charCodeAt(index))));
    i = ((1 + i) | 0)
  }
}
function $f_T__indexOf__I__I($thiz, ch) {
  var str = $m_jl_Character$().toString__I__T(ch);
  return $uI($thiz.indexOf(str))
}
function $f_T__lastIndexOf__I__I($thiz, ch) {
  var str = $m_jl_Character$().toString__I__T(ch);
  return $uI($thiz.lastIndexOf(str))
}
function $f_T__length__I($thiz) {
  return $uI($thiz.length)
}
function $f_T__split__T__I__AT($thiz, regex, limit) {
  var this$1 = $m_ju_regex_Pattern$();
  return this$1.compile__T__I__ju_regex_Pattern(regex, 0).split__jl_CharSequence__I__AT($thiz, limit)
}
function $f_T__subSequence__I__I__jl_CharSequence($thiz, beginIndex, endIndex) {
  return $as_T($thiz.substring(beginIndex, endIndex))
}
function $f_T__toCharArray__AC($thiz) {
  var len = $uI($thiz.length);
  var result = new $ac_C(len);
  var i = 0;
  while ((i < len)) {
    var $$x1 = i;
    var index = i;
    result.set($$x1, (65535 & $uI($thiz.charCodeAt(index))));
    i = ((1 + i) | 0)
  };
  return result
}
function $f_T__trim__T($thiz) {
  var len = $uI($thiz.length);
  var start = 0;
  while (true) {
    if ((start !== len)) {
      var index = start;
      var $$x1 = ((65535 & $uI($thiz.charCodeAt(index))) <= 32)
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      start = ((1 + start) | 0)
    } else {
      break
    }
  };
  if ((start === len)) {
    return ""
  } else {
    var end = len;
    while (true) {
      var index$1 = (((-1) + end) | 0);
      if (((65535 & $uI($thiz.charCodeAt(index$1))) <= 32)) {
        end = (((-1) + end) | 0)
      } else {
        break
      }
    };
    if (((start === 0) && (end === len))) {
      return $thiz
    } else {
      var beginIndex = start;
      var endIndex = end;
      return $as_T($thiz.substring(beginIndex, endIndex))
    }
  }
}
function $f_T__toString__T($thiz) {
  return $thiz
}
function $as_T(obj) {
  return ((((typeof obj) === "string") || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.String"))
}
function $isArrayOf_T(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T)))
}
function $asArrayOf_T(obj, depth) {
  return (($isArrayOf_T(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.String;", depth))
}
var $d_T = new $TypeData().initClass({
  T: 0
}, false, "java.lang.String", {
  T: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1,
  jl_CharSequence: 1
}, (void 0), (void 0), (function(x) {
  return ((typeof x) === "string")
}));
function $ct_jl_StringBuilder__($thiz) {
  $thiz.jl_StringBuilder__f_java$lang$StringBuilder$$content = "";
  return $thiz
}
function $ct_jl_StringBuilder__T__($thiz, str) {
  $ct_jl_StringBuilder__($thiz);
  if ((str === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  $thiz.jl_StringBuilder__f_java$lang$StringBuilder$$content = str;
  return $thiz
}
function $ct_jl_StringBuilder__I__($thiz, initialCapacity) {
  $ct_jl_StringBuilder__($thiz);
  if ((initialCapacity < 0)) {
    throw new $c_jl_NegativeArraySizeException()
  };
  return $thiz
}
/** @constructor */
function $c_jl_StringBuilder() {
  this.jl_StringBuilder__f_java$lang$StringBuilder$$content = null
}
$c_jl_StringBuilder.prototype = new $h_O();
$c_jl_StringBuilder.prototype.constructor = $c_jl_StringBuilder;
/** @constructor */
function $h_jl_StringBuilder() {
  /*<skip>*/
}
$h_jl_StringBuilder.prototype = $c_jl_StringBuilder.prototype;
$c_jl_StringBuilder.prototype.append__AC__jl_StringBuilder = (function(str) {
  var this$1 = $m_jl_String$();
  var count = str.u.length;
  var str$1 = this$1.new__AC__I__I__T(str, 0, count);
  this.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str$1);
  return this
});
$c_jl_StringBuilder.prototype.reverse__jl_StringBuilder = (function() {
  var original = this.jl_StringBuilder__f_java$lang$StringBuilder$$content;
  var result = "";
  var i = (((-1) + $uI(original.length)) | 0);
  while ((i > 0)) {
    var index = i;
    var c = (65535 & $uI(original.charCodeAt(index)));
    if (((64512 & c) === 56320)) {
      var index$1 = (((-1) + i) | 0);
      var c2 = (65535 & $uI(original.charCodeAt(index$1)));
      if (((64512 & c2) === 55296)) {
        result = ((("" + result) + $as_T(String.fromCharCode(c2))) + $as_T(String.fromCharCode(c)));
        i = (((-2) + i) | 0)
      } else {
        result = (("" + result) + $as_T(String.fromCharCode(c)));
        i = (((-1) + i) | 0)
      }
    } else {
      result = (("" + result) + $as_T(String.fromCharCode(c)));
      i = (((-1) + i) | 0)
    }
  };
  if ((i === 0)) {
    var $$x1 = result;
    var this$7 = (65535 & $uI(original.charCodeAt(0)));
    result = (("" + $$x1) + $as_T(String.fromCharCode(this$7)))
  };
  this.jl_StringBuilder__f_java$lang$StringBuilder$$content = result;
  return this
});
$c_jl_StringBuilder.prototype.toString__T = (function() {
  return this.jl_StringBuilder__f_java$lang$StringBuilder$$content
});
$c_jl_StringBuilder.prototype.length__I = (function() {
  var this$1 = this.jl_StringBuilder__f_java$lang$StringBuilder$$content;
  return $uI(this$1.length)
});
$c_jl_StringBuilder.prototype.charAt__I__C = (function(index) {
  var this$1 = this.jl_StringBuilder__f_java$lang$StringBuilder$$content;
  return (65535 & $uI(this$1.charCodeAt(index)))
});
$c_jl_StringBuilder.prototype.getChars__I__I__AC__I__V = (function(srcBegin, srcEnd, dst, dstBegin) {
  $f_T__getChars__I__I__AC__I__V(this.jl_StringBuilder__f_java$lang$StringBuilder$$content, srcBegin, srcEnd, dst, dstBegin)
});
$c_jl_StringBuilder.prototype.subSequence__I__I__jl_CharSequence = (function(start, end) {
  return this.substring__I__I__T(start, end)
});
$c_jl_StringBuilder.prototype.substring__I__I__T = (function(start, end) {
  var this$1 = this.jl_StringBuilder__f_java$lang$StringBuilder$$content;
  return $as_T(this$1.substring(start, end))
});
$c_jl_StringBuilder.prototype.append__jl_CharSequence__jl_Appendable = (function(csq) {
  this.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this.jl_StringBuilder__f_java$lang$StringBuilder$$content) + csq);
  return this
});
var $d_jl_StringBuilder = new $TypeData().initClass({
  jl_StringBuilder: 0
}, false, "java.lang.StringBuilder", {
  jl_StringBuilder: 1,
  O: 1,
  jl_CharSequence: 1,
  jl_Appendable: 1,
  Ljava_io_Serializable: 1
});
$c_jl_StringBuilder.prototype.$classData = $d_jl_StringBuilder;
function $as_jl_ThreadDeath(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.ThreadDeath"))
}
function $isArrayOf_jl_ThreadDeath(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_ThreadDeath)))
}
function $asArrayOf_jl_ThreadDeath(obj, depth) {
  return (($isArrayOf_jl_ThreadDeath(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.ThreadDeath;", depth))
}
/** @constructor */
function $c_jl_VirtualMachineError() {
  this.jl_Throwable__f_s = null;
  this.jl_Throwable__f_e = null;
  this.jl_Throwable__f_enableSuppression = false;
  this.jl_Throwable__f_writableStackTrace = false;
  this.jl_Throwable__f_stackTraceStateInternal = null;
  this.jl_Throwable__f_stackTrace = null;
  this.jl_Throwable__f_suppressed = null
}
$c_jl_VirtualMachineError.prototype = new $h_jl_Error();
$c_jl_VirtualMachineError.prototype.constructor = $c_jl_VirtualMachineError;
/** @constructor */
function $h_jl_VirtualMachineError() {
  /*<skip>*/
}
$h_jl_VirtualMachineError.prototype = $c_jl_VirtualMachineError.prototype;
function $as_jl_VirtualMachineError(obj) {
  return (((obj instanceof $c_jl_VirtualMachineError) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.VirtualMachineError"))
}
function $isArrayOf_jl_VirtualMachineError(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_VirtualMachineError)))
}
function $asArrayOf_jl_VirtualMachineError(obj, depth) {
  return (($isArrayOf_jl_VirtualMachineError(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.VirtualMachineError;", depth))
}
function $p_Ljava_math_BigDecimal__decimalDigitsInLong__J__I($thiz, value) {
  if (((value.RTLong__f_lo === 0) && (value.RTLong__f_hi === (-2147483648)))) {
    return 19
  } else {
    var $$x3 = $m_ju_Arrays$();
    var $$x2 = $m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_LongTenPows;
    var ahi = value.RTLong__f_hi;
    if ((ahi < 0)) {
      var lo = value.RTLong__f_lo;
      var hi = value.RTLong__f_hi;
      var lo$1 = ((-lo) | 0);
      var hi$1 = ((lo !== 0) ? (~hi) : ((-hi) | 0));
      var x__lo = lo$1;
      var x__hi = hi$1;
      var $$x1 = new $c_RTLong(x__lo, x__hi)
    } else {
      var $$x1 = value
    };
    var index = $$x3.binarySearch__AJ__J__I($$x2, $$x1);
    return ((index < 0) ? (((-1) - index) | 0) : ((1 + index) | 0))
  }
}
function $p_Ljava_math_BigDecimal__inplaceRound__Ljava_math_MathContext__V($thiz, mc) {
  var mcPrecision = mc.Ljava_math_MathContext__f_precision;
  var discardedPrecision = (($thiz.precision__I() - mcPrecision) | 0);
  var mcPrecGood = (($p_Ljava_math_BigDecimal__approxPrecision__I($thiz) < mcPrecision) || (mcPrecision === 0));
  if ((!(mcPrecGood || (discardedPrecision <= 0)))) {
    if (($thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength < 64)) {
      $p_Ljava_math_BigDecimal__smallRound__Ljava_math_MathContext__I__V($thiz, mc, discardedPrecision)
    } else {
      var $$x1 = $m_Ljava_math_Multiplication$();
      var hi = (discardedPrecision >> 31);
      var sizeOfFraction = $$x1.powerOf10__J__Ljava_math_BigInteger(new $c_RTLong(discardedPrecision, hi));
      var integerAndFraction = $thiz.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger().divideAndRemainder__Ljava_math_BigInteger__ALjava_math_BigInteger(sizeOfFraction);
      var value = $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
      var hi$1 = (value >> 31);
      var hi$2 = (discardedPrecision >> 31);
      var lo = ((value - discardedPrecision) | 0);
      var hi$3 = ((((-2147483648) ^ lo) > ((-2147483648) ^ value)) ? (((-1) + ((hi$1 - hi$2) | 0)) | 0) : ((hi$1 - hi$2) | 0));
      var this$5 = integerAndFraction.get(1);
      if ((this$5.Ljava_math_BigInteger__f_sign !== 0)) {
        var absBi = integerAndFraction.get(1).abs__Ljava_math_BigInteger();
        var compRem = absBi.shiftLeftOneBit__Ljava_math_BigInteger().compareTo__Ljava_math_BigInteger__I(sizeOfFraction);
        var parityBit = (integerAndFraction.get(0).testBit__I__Z(0) ? 1 : 0);
        var this$6 = integerAndFraction.get(1);
        var frac = $imul(this$6.Ljava_math_BigInteger__f_sign, ((5 + compRem) | 0));
        var carry = $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$roundingBehavior__I__I__Ljava_math_RoundingMode__I(parityBit, frac, mc.Ljava_math_MathContext__f_roundingMode);
        if ((carry !== 0)) {
          var $$x2 = $m_Ljava_math_BigInteger$();
          var hi$4 = (carry >> 31);
          var bi = $$x2.valueOf__J__Ljava_math_BigInteger(new $c_RTLong(carry, hi$4));
          var this$8 = integerAndFraction.get(0);
          integerAndFraction.set(0, $m_Ljava_math_Elementary$().add__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$8, bi))
        };
        var tempBD = $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__(new $c_Ljava_math_BigDecimal(), integerAndFraction.get(0));
        if ((tempBD.precision__I() > mcPrecision)) {
          integerAndFraction.set(0, integerAndFraction.get(0).divide__Ljava_math_BigInteger__Ljava_math_BigInteger($m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_TEN));
          var lo$1 = (((-1) + lo) | 0);
          var hi$5 = ((lo$1 !== (-1)) ? hi$3 : (((-1) + hi$3) | 0));
          var newScale__lo = lo$1;
          var newScale__hi = hi$5
        } else {
          var newScale__lo = lo;
          var newScale__hi = hi$3
        }
      } else {
        var newScale__lo = lo;
        var newScale__hi = hi$3
      };
      $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale = $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$safeLongToInt__J__I(new $c_RTLong(newScale__lo, newScale__hi));
      $thiz.Ljava_math_BigDecimal__f__precision = mcPrecision;
      $p_Ljava_math_BigDecimal__setUnscaledValue__Ljava_math_BigInteger__V($thiz, integerAndFraction.get(0))
    }
  }
}
function $p_Ljava_math_BigDecimal__isZero__Z($thiz) {
  if (($thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength === 0)) {
    var this$1 = $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
    return (!((this$1.RTLong__f_lo === (-1)) && (this$1.RTLong__f_hi === (-1))))
  } else {
    return false
  }
}
function $p_Ljava_math_BigDecimal__smallRound__Ljava_math_MathContext__I__V($thiz, mc, discardedPrecision) {
  var t = $m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_LongTenPows.get(discardedPrecision);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var value = $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
  var hi$1 = (value >> 31);
  var hi$2 = (discardedPrecision >> 31);
  var lo$1 = ((value - discardedPrecision) | 0);
  var hi$3 = ((((-2147483648) ^ lo$1) > ((-2147483648) ^ value)) ? (((-1) + ((hi$1 - hi$2) | 0)) | 0) : ((hi$1 - hi$2) | 0));
  var t$1 = $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
  var lo$2 = t$1.RTLong__f_lo;
  var hi$4 = t$1.RTLong__f_hi;
  var this$4 = $m_RTLong$();
  var lo$3 = this$4.divideImpl__I__I__I__I__I(lo$2, hi$4, lo, hi);
  var hi$5 = this$4.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var this$5 = $m_RTLong$();
  var lo$4 = this$5.remainderImpl__I__I__I__I__I(lo$2, hi$4, lo, hi);
  var hi$6 = this$5.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  if ((!((lo$4 === 0) && (hi$6 === 0)))) {
    var $$x1 = $m_Ljava_math_BigDecimal$();
    if ((hi$6 < 0)) {
      var lo$5 = ((-lo$4) | 0);
      var hi$7 = ((lo$4 !== 0) ? (~hi$6) : ((-hi$6) | 0));
      var this$9__lo = lo$5;
      var this$9__hi = hi$7
    } else {
      var this$9__lo = lo$4;
      var this$9__hi = hi$6
    };
    var lo$6 = this$9__lo;
    var lo$7 = (lo$6 << 1);
    var hi$8 = (((lo$6 >>> 31) | 0) | (this$9__hi << 1));
    var compRem = $$x1.java$math$BigDecimal$$longCompareTo__J__J__I(new $c_RTLong(lo$7, hi$8), new $c_RTLong(lo, hi));
    var frac = $imul(((hi$6 < 0) ? (-1) : (((hi$6 === 0) && (lo$4 === 0)) ? 0 : 1)), ((5 + compRem) | 0));
    var value$1 = $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$roundingBehavior__I__I__Ljava_math_RoundingMode__I((1 & lo$3), frac, mc.Ljava_math_MathContext__f_roundingMode);
    var hi$9 = (value$1 >> 31);
    var lo$8 = ((lo$3 + value$1) | 0);
    var hi$10 = ((((-2147483648) ^ lo$8) < ((-2147483648) ^ lo$3)) ? ((1 + ((hi$5 + hi$9) | 0)) | 0) : ((hi$5 + hi$9) | 0));
    if ((hi$10 < 0)) {
      var lo$9 = ((-lo$8) | 0);
      var hi$11 = ((lo$8 !== 0) ? (~hi$10) : ((-hi$10) | 0));
      var this$16__lo = lo$9;
      var this$16__hi = hi$11
    } else {
      var this$16__lo = lo$8;
      var this$16__hi = hi$10
    };
    var a = $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toDouble__I__I__D(this$16__lo, this$16__hi);
    var x = Math.log10;
    if ((((!(x === (void 0))) ? $uD(Math.log10(a)) : ($uD(Math.log(a)) / 2.302585092994046)) >= mc.Ljava_math_MathContext__f_precision)) {
      var lo$10 = (((-1) + lo$1) | 0);
      var hi$12 = ((lo$10 !== (-1)) ? hi$3 : (((-1) + hi$3) | 0));
      var this$20 = $m_RTLong$();
      var lo$11 = this$20.divideImpl__I__I__I__I__I(lo$8, hi$10, 10, 0);
      var hi$13 = this$20.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      var x1___1 = null;
      var x1___2 = null;
      var x1___1$mcJ$sp = new $c_RTLong(lo$10, hi$12);
      var x1___2$mcJ$sp = new $c_RTLong(lo$11, hi$13)
    } else {
      var x1___1 = null;
      var x1___2 = null;
      var x1___1$mcJ$sp = new $c_RTLong(lo$1, hi$3);
      var x1___2$mcJ$sp = new $c_RTLong(lo$8, hi$10)
    }
  } else {
    var x1___1 = null;
    var x1___2 = null;
    var x1___1$mcJ$sp = new $c_RTLong(lo$1, hi$3);
    var x1___2$mcJ$sp = new $c_RTLong(lo$3, hi$5)
  };
  var t$2 = x1___1$mcJ$sp;
  var lo$12 = t$2.RTLong__f_lo;
  var hi$14 = t$2.RTLong__f_hi;
  var t$3 = x1___2$mcJ$sp;
  var lo$13 = t$3.RTLong__f_lo;
  var hi$15 = t$3.RTLong__f_hi;
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale = $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$safeLongToInt__J__I(new $c_RTLong(lo$12, hi$14));
  $thiz.Ljava_math_BigDecimal__f__precision = mc.Ljava_math_MathContext__f_precision;
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue = new $c_RTLong(lo$13, hi$15);
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength = $m_Ljava_math_BigDecimal$().bitLength__J__I(new $c_RTLong(lo$13, hi$15));
  $thiz.Ljava_math_BigDecimal__f__intVal = null
}
function $p_Ljava_math_BigDecimal__valueExact__I__J($thiz, bitLengthOfType) {
  var value = $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
  var hi = (value >> 31);
  var lo = ((-value) | 0);
  var hi$1 = ((value !== 0) ? (~hi) : ((-hi) | 0));
  var value$1 = $p_Ljava_math_BigDecimal__approxPrecision__I($thiz);
  var hi$2 = (value$1 >> 31);
  var lo$1 = ((lo + value$1) | 0);
  var hi$3 = ((((-2147483648) ^ lo$1) < ((-2147483648) ^ lo)) ? ((1 + ((hi$1 + hi$2) | 0)) | 0) : ((hi$1 + hi$2) | 0));
  if (((hi$3 === 0) ? (((-2147483648) ^ lo$1) > (-2147483629)) : (hi$3 > 0))) {
    throw new $c_jl_ArithmeticException("Rounding necessary")
  };
  var bigInteger = $thiz.toBigIntegerExact__Ljava_math_BigInteger();
  if (($m_Ljava_math_BitLevel$().bitLength__Ljava_math_BigInteger__I(bigInteger) < bitLengthOfType)) {
    return bigInteger.longValue__J()
  } else {
    throw new $c_jl_ArithmeticException("Rounding necessary")
  }
}
function $p_Ljava_math_BigDecimal__approxPrecision__I($thiz) {
  return (($thiz.Ljava_math_BigDecimal__f__precision > 0) ? $thiz.Ljava_math_BigDecimal__f__precision : ((1 + $doubleToInt((0.3010299956639812 * (((-1) + $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength) | 0)))) | 0))
}
function $p_Ljava_math_BigDecimal__setUnscaledValue__Ljava_math_BigInteger__V($thiz, unscaledVal) {
  $thiz.Ljava_math_BigDecimal__f__intVal = unscaledVal;
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength = $m_Ljava_math_BitLevel$().bitLength__Ljava_math_BigInteger__I(unscaledVal);
  if (($thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength < 64)) {
    $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue = unscaledVal.longValue__J()
  }
}
function $ct_Ljava_math_BigDecimal__($thiz) {
  $thiz.Ljava_math_BigDecimal__f__toStringImage = null;
  $thiz.Ljava_math_BigDecimal__f__hashCode = 0;
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength = 0;
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue = $L0;
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale = 0;
  $thiz.Ljava_math_BigDecimal__f__precision = 0;
  return $thiz
}
function $ct_Ljava_math_BigDecimal__J__I__($thiz, smallValue, scale) {
  $ct_Ljava_math_BigDecimal__($thiz);
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue = smallValue;
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale = scale;
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength = $m_Ljava_math_BigDecimal$().bitLength__J__I(smallValue);
  return $thiz
}
function $ct_Ljava_math_BigDecimal__I__I__($thiz, smallValue, scale) {
  $ct_Ljava_math_BigDecimal__($thiz);
  var hi = (smallValue >> 31);
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue = new $c_RTLong(smallValue, hi);
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale = scale;
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength = $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$bitLength__I__I(smallValue);
  return $thiz
}
function $ct_Ljava_math_BigDecimal__AC__I__I__($thiz, in$1, offset, len) {
  $ct_Ljava_math_BigDecimal__($thiz);
  var last = (((-1) + ((offset + len) | 0)) | 0);
  if ((in$1 === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "in == null")
  };
  if (((((last >= in$1.u.length) || (offset < 0)) || (len <= 0)) || (last < 0))) {
    throw new $c_jl_NumberFormatException(((((("Bad offset/length: offset=" + offset) + " len=") + len) + " in.length=") + in$1.u.length))
  };
  var index = offset;
  if (((offset <= last) && (in$1.get(offset) === 43))) {
    index = ((1 + index) | 0);
    if ((index < last)) {
      $m_Ljava_math_BigDecimal$();
      var c = in$1.get(index);
      var array = [$bC(43), $bC(45)];
      var cs = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
      var $$x1 = $f_sc_SeqOps__contains__O__Z(cs, $bC(c))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      throw new $c_jl_NumberFormatException(("For input string: " + in$1.toString__T()))
    }
  } else {
    var isMinus = ((index <= last) && (in$1.get(index) === 45));
    if ((((1 + index) | 0) < last)) {
      $m_Ljava_math_BigDecimal$();
      var c$1 = in$1.get(((1 + index) | 0));
      var array$1 = [$bC(43), $bC(45)];
      var cs$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
      var nextIsSign = $f_sc_SeqOps__contains__O__Z(cs$1, $bC(c$1))
    } else {
      var nextIsSign = false
    };
    if ((isMinus && nextIsSign)) {
      throw new $c_jl_NumberFormatException(("For input string: " + in$1.toString__T()))
    }
  };
  var begin = index;
  var counter = 0;
  var wasNonZero = false;
  while (true) {
    if ((index <= last)) {
      $m_Ljava_math_BigDecimal$();
      var c$2 = in$1.get(index);
      var array$2 = [$bC(46), $bC(101), $bC(69)];
      var cs$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
      var $$x2 = (!$f_sc_SeqOps__contains__O__Z(cs$2, $bC(c$2)))
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      if ((!wasNonZero)) {
        if ((in$1.get(index) === 48)) {
          counter = ((1 + counter) | 0)
        } else {
          wasNonZero = true
        }
      };
      index = ((1 + index) | 0)
    } else {
      break
    }
  };
  var count = ((index - begin) | 0);
  var this$13 = $m_jl_String$();
  var u = this$13.new__AC__I__I__T(in$1, begin, count);
  var b = ((index - begin) | 0);
  if (((index <= last) && (in$1.get(index) === 46))) {
    index = ((1 + index) | 0);
    var begin$2 = index;
    while (true) {
      if ((index <= last)) {
        $m_Ljava_math_BigDecimal$();
        var c$3 = in$1.get(index);
        var array$3 = [$bC(101), $bC(69)];
        var cs$3 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3);
        var $$x3 = (!$f_sc_SeqOps__contains__O__Z(cs$3, $bC(c$3)))
      } else {
        var $$x3 = false
      };
      if ($$x3) {
        if ((!wasNonZero)) {
          if ((in$1.get(index) === 48)) {
            counter = ((1 + counter) | 0)
          } else {
            wasNonZero = true
          }
        };
        index = ((1 + index) | 0)
      } else {
        break
      }
    };
    $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale = ((index - begin$2) | 0);
    var count$1 = $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
    var this$18 = $m_jl_String$();
    var _1 = (("" + u) + this$18.new__AC__I__I__T(in$1, begin$2, count$1));
    var _2 = ((b + $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale) | 0);
    var x1___1 = _1;
    var x1___2 = _2
  } else {
    $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale = 0;
    var x1___1 = u;
    var x1___2 = b
  };
  var unscaled = $as_T(x1___1);
  var bufLength = $uI(x1___2);
  if ((index <= last)) {
    $m_Ljava_math_BigDecimal$();
    var c$4 = in$1.get(index);
    var array$4 = [$bC(101), $bC(69)];
    var cs$4 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4);
    var $$x4 = $f_sc_SeqOps__contains__O__Z(cs$4, $bC(c$4))
  } else {
    var $$x4 = false
  };
  if ($$x4) {
    index = ((1 + index) | 0);
    var indexIsPlus = ((index <= last) && (in$1.get(index) === 43));
    var nextIsNotMinus = ((((1 + index) | 0) <= last) && (in$1.get(((1 + index) | 0)) !== 45));
    var begin$3 = ((indexIsPlus && nextIsNotMinus) ? ((1 + index) | 0) : index);
    var count$2 = ((((1 + last) | 0) - begin$3) | 0);
    var this$23 = $m_jl_String$();
    var scaleString = this$23.new__AC__I__I__T(in$1, begin$3, count$2);
    var value = $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
    var hi = (value >> 31);
    var this$25 = $m_jl_Integer$();
    var value$1 = this$25.parseInt__T__I__I(scaleString, 10);
    var hi$1 = (value$1 >> 31);
    var lo = ((value - value$1) | 0);
    var hi$2 = ((((-2147483648) ^ lo) > ((-2147483648) ^ value)) ? (((-1) + ((hi - hi$1) | 0)) | 0) : ((hi - hi$1) | 0));
    $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale = lo;
    var value$2 = $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
    var hi$3 = (value$2 >> 31);
    if ((!((lo === value$2) && (hi$2 === hi$3)))) {
      throw new $c_jl_NumberFormatException("Scale out of range")
    }
  };
  if ((bufLength < 19)) {
    var this$29 = $m_jl_Long$();
    $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue = this$29.parseLong__T__I__J(unscaled, 10);
    $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength = $m_Ljava_math_BigDecimal$().bitLength__J__I($thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue)
  } else {
    $p_Ljava_math_BigDecimal__setUnscaledValue__Ljava_math_BigInteger__V($thiz, $ct_Ljava_math_BigInteger__T__(new $c_Ljava_math_BigInteger(), unscaled))
  };
  return $thiz
}
function $ct_Ljava_math_BigDecimal__T__($thiz, sVal) {
  $ct_Ljava_math_BigDecimal__AC__I__I__($thiz, $f_T__toCharArray__AC(sVal), 0, $uI(sVal.length));
  return $thiz
}
function $ct_Ljava_math_BigDecimal__T__Ljava_math_MathContext__($thiz, sVal, mc) {
  $ct_Ljava_math_BigDecimal__AC__I__I__($thiz, $f_T__toCharArray__AC(sVal), 0, $uI(sVal.length));
  $p_Ljava_math_BigDecimal__inplaceRound__Ljava_math_MathContext__V($thiz, mc);
  return $thiz
}
function $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__($thiz, unscaledVal, scale) {
  $ct_Ljava_math_BigDecimal__($thiz);
  if ((unscaledVal === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "unscaledVal == null")
  };
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale = scale;
  $p_Ljava_math_BigDecimal__setUnscaledValue__Ljava_math_BigInteger__V($thiz, unscaledVal);
  return $thiz
}
function $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__($thiz, bi) {
  $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__($thiz, bi, 0);
  return $thiz
}
function $ct_Ljava_math_BigDecimal__J__Ljava_math_MathContext__($thiz, lVal, mc) {
  $ct_Ljava_math_BigDecimal__J__I__($thiz, lVal, 0);
  $p_Ljava_math_BigDecimal__inplaceRound__Ljava_math_MathContext__V($thiz, mc);
  return $thiz
}
/** @constructor */
function $c_Ljava_math_BigDecimal() {
  this.Ljava_math_BigDecimal__f__toStringImage = null;
  this.Ljava_math_BigDecimal__f__hashCode = 0;
  this.Ljava_math_BigDecimal__f__intVal = null;
  this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength = 0;
  this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue = $L0;
  this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale = 0;
  this.Ljava_math_BigDecimal__f__precision = 0
}
$c_Ljava_math_BigDecimal.prototype = new $h_jl_Number();
$c_Ljava_math_BigDecimal.prototype.constructor = $c_Ljava_math_BigDecimal;
/** @constructor */
function $h_Ljava_math_BigDecimal() {
  /*<skip>*/
}
$h_Ljava_math_BigDecimal.prototype = $c_Ljava_math_BigDecimal.prototype;
$c_Ljava_math_BigDecimal.prototype.signum__I = (function() {
  if ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength < 64)) {
    var this$1 = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
    var ahi = this$1.RTLong__f_hi;
    if ((ahi < 0)) {
      return (-1)
    } else {
      var this$2 = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
      var ahi$1 = this$2.RTLong__f_hi;
      if (((ahi$1 === 0) ? (this$2.RTLong__f_lo !== 0) : (ahi$1 > 0))) {
        return 1
      } else {
        return 0
      }
    }
  } else {
    var this$3 = this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
    return this$3.Ljava_math_BigInteger__f_sign
  }
});
$c_Ljava_math_BigDecimal.prototype.precision__I = (function() {
  if ((this.Ljava_math_BigDecimal__f__precision === 0)) {
    if ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength === 0)) {
      var $$x1 = 1
    } else if ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength < 64)) {
      var $$x1 = $p_Ljava_math_BigDecimal__decimalDigitsInLong__J__I(this, this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue)
    } else {
      var decimalDigits = ((1 + $doubleToInt((0.3010299956639812 * (((-1) + this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength) | 0)))) | 0);
      var $$x3 = this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
      var $$x2 = $m_Ljava_math_Multiplication$();
      var hi = (decimalDigits >> 31);
      var this$2 = $$x3.divide__Ljava_math_BigInteger__Ljava_math_BigInteger($$x2.powerOf10__J__Ljava_math_BigInteger(new $c_RTLong(decimalDigits, hi)));
      if ((this$2.Ljava_math_BigInteger__f_sign !== 0)) {
        var $$x1 = ((1 + decimalDigits) | 0)
      } else {
        var $$x1 = decimalDigits
      }
    };
    this.Ljava_math_BigDecimal__f__precision = $$x1
  };
  return this.Ljava_math_BigDecimal__f__precision
});
$c_Ljava_math_BigDecimal.prototype.scaleByPowerOfTen__I__Ljava_math_BigDecimal = (function(n) {
  var value = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
  var hi = (value >> 31);
  var hi$1 = (n >> 31);
  var lo = ((value - n) | 0);
  var hi$2 = ((((-2147483648) ^ lo) > ((-2147483648) ^ value)) ? (((-1) + ((hi - hi$1) | 0)) | 0) : ((hi - hi$1) | 0));
  if ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength < 64)) {
    var this$4 = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
    if (((this$4.RTLong__f_lo === 0) && (this$4.RTLong__f_hi === 0))) {
      return $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$zeroScaledBy__J__Ljava_math_BigDecimal(new $c_RTLong(lo, hi$2))
    } else {
      return $m_Ljava_math_BigDecimal$().valueOf__J__I__Ljava_math_BigDecimal(this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue, $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$safeLongToInt__J__I(new $c_RTLong(lo, hi$2)))
    }
  } else {
    return $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger(), $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$safeLongToInt__J__I(new $c_RTLong(lo, hi$2)))
  }
});
$c_Ljava_math_BigDecimal.prototype.stripTrailingZeros__Ljava_math_BigDecimal = (function() {
  if ($p_Ljava_math_BigDecimal__isZero__Z(this)) {
    return this
  } else {
    var lastPow = (((-1) + $m_Ljava_math_Multiplication$().Ljava_math_Multiplication$__f_BigTenPows.u.length) | 0);
    var i = 1;
    var strippedBI = this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
    var value = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
    var hi = (value >> 31);
    var scale__lo = value;
    var scale__hi = hi;
    var x1___1;
    var x1___2;
    while (true) {
      if ((!strippedBI.testBit__I__Z(0))) {
        var qr = strippedBI.divideAndRemainderImpl__Ljava_math_BigInteger__Ljava_math_BigInteger$QuotAndRem($m_Ljava_math_Multiplication$().Ljava_math_Multiplication$__f_BigTenPows.get(i));
        var this$2 = qr.Ljava_math_BigInteger$QuotAndRem__f_rem;
        if ((this$2.Ljava_math_BigInteger__f_sign === 0)) {
          var temp$i = ((i < lastPow) ? ((1 + i) | 0) : i);
          var temp$strippedBI = qr.Ljava_math_BigInteger$QuotAndRem__f_quot;
          var this$4__lo = scale__lo;
          var this$4__hi = scale__hi;
          var value$1 = i;
          var hi$1 = (value$1 >> 31);
          var alo = this$4__lo;
          var ahi = this$4__hi;
          var lo = ((alo - value$1) | 0);
          var hi$2 = ((((-2147483648) ^ lo) > ((-2147483648) ^ alo)) ? (((-1) + ((ahi - hi$1) | 0)) | 0) : ((ahi - hi$1) | 0));
          i = temp$i;
          strippedBI = temp$strippedBI;
          var $$x1__lo = lo;
          var $$x1__hi = hi$2;
          scale__lo = $$x1__lo;
          scale__hi = $$x1__hi;
          continue
        };
        if ((i !== 1)) {
          i = 1;
          continue
        };
        var _1 = strippedBI;
        var _2__lo = scale__lo;
        var _2__hi = scale__hi;
        var x1___1 = _1;
        var x1___2 = new $c_RTLong(_2__lo, _2__hi);
        break
      } else {
        var _1$1 = strippedBI;
        var _2$1__lo = scale__lo;
        var _2$1__hi = scale__hi;
        var x1___1 = _1$1;
        var x1___2 = new $c_RTLong(_2$1__lo, _2$1__hi);
        break
      }
    };
    var strippedBI$1 = $as_Ljava_math_BigInteger(x1___1);
    var t = $uJ(x1___2);
    var lo$1 = t.RTLong__f_lo;
    var hi$3 = t.RTLong__f_hi;
    var t$1 = $uJ(new $c_RTLong(lo$1, hi$3));
    var lo$2 = t$1.RTLong__f_lo;
    var hi$4 = t$1.RTLong__f_hi;
    return $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), strippedBI$1, $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$safeLongToInt__J__I(new $c_RTLong(lo$2, hi$4)))
  }
});
$c_Ljava_math_BigDecimal.prototype.compareTo__Ljava_math_BigDecimal__I = (function(bi) {
  var thisSign = this.signum__I();
  var valueSign = bi.signum__I();
  if ((thisSign === valueSign)) {
    if ((((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale === bi.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale) && (this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength < 64)) && (bi.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength < 64))) {
      var this$1 = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
      var b = bi.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
      var ahi = this$1.RTLong__f_hi;
      var bhi = b.RTLong__f_hi;
      if (((ahi === bhi) ? (((-2147483648) ^ this$1.RTLong__f_lo) < ((-2147483648) ^ b.RTLong__f_lo)) : (ahi < bhi))) {
        return (-1)
      } else {
        var this$2 = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
        var b$1 = bi.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
        var ahi$1 = this$2.RTLong__f_hi;
        var bhi$1 = b$1.RTLong__f_hi;
        if (((ahi$1 === bhi$1) ? (((-2147483648) ^ this$2.RTLong__f_lo) > ((-2147483648) ^ b$1.RTLong__f_lo)) : (ahi$1 > bhi$1))) {
          return 1
        } else {
          return 0
        }
      }
    } else {
      var value = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
      var hi = (value >> 31);
      var value$1 = bi.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
      var hi$1 = (value$1 >> 31);
      var lo = ((value - value$1) | 0);
      var hi$2 = ((((-2147483648) ^ lo) > ((-2147483648) ^ value)) ? (((-1) + ((hi - hi$1) | 0)) | 0) : ((hi - hi$1) | 0));
      var diffPrecision = (($p_Ljava_math_BigDecimal__approxPrecision__I(this) - $p_Ljava_math_BigDecimal__approxPrecision__I(bi)) | 0);
      var hi$3 = (diffPrecision >> 31);
      var lo$1 = ((1 + lo) | 0);
      var hi$4 = ((lo$1 === 0) ? ((1 + hi$2) | 0) : hi$2);
      if (((hi$3 === hi$4) ? (((-2147483648) ^ diffPrecision) > ((-2147483648) ^ lo$1)) : (hi$3 > hi$4))) {
        return thisSign
      } else {
        var hi$5 = (diffPrecision >> 31);
        var lo$2 = (((-1) + lo) | 0);
        var hi$6 = ((lo$2 !== (-1)) ? hi$2 : (((-1) + hi$2) | 0));
        if (((hi$5 === hi$6) ? (((-2147483648) ^ diffPrecision) < ((-2147483648) ^ lo$2)) : (hi$5 < hi$6))) {
          return ((-thisSign) | 0)
        } else {
          var t = this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
          var v = bi.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
          if ((hi$2 < 0)) {
            var $$x1 = $m_Ljava_math_Multiplication$();
            var lo$3 = ((-lo) | 0);
            var hi$7 = ((lo !== 0) ? (~hi$2) : ((-hi$2) | 0));
            var _1 = t.multiply__Ljava_math_BigInteger__Ljava_math_BigInteger($$x1.powerOf10__J__Ljava_math_BigInteger(new $c_RTLong(lo$3, hi$7)));
            var x1___1 = _1;
            var x1___2 = v
          } else if (((hi$2 === 0) ? (lo !== 0) : (hi$2 > 0))) {
            var _2 = v.multiply__Ljava_math_BigInteger__Ljava_math_BigInteger($m_Ljava_math_Multiplication$().powerOf10__J__Ljava_math_BigInteger(new $c_RTLong(lo, hi$2)));
            var x1___1 = t;
            var x1___2 = _2
          } else {
            var x1___1 = t;
            var x1___2 = v
          };
          var thisUnscaled = $as_Ljava_math_BigInteger(x1___1);
          var valUnscaled = $as_Ljava_math_BigInteger(x1___2);
          return thisUnscaled.compareTo__Ljava_math_BigInteger__I(valUnscaled)
        }
      }
    }
  } else {
    return ((thisSign < valueSign) ? (-1) : 1)
  }
});
$c_Ljava_math_BigDecimal.prototype.equals__O__Z = (function(x) {
  if ((x instanceof $c_Ljava_math_BigDecimal)) {
    var x2 = $as_Ljava_math_BigDecimal(x);
    if ((x2.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale === this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale)) {
      if ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength < 64)) {
        var this$1 = x2.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
        var b = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
        return ((this$1.RTLong__f_lo === b.RTLong__f_lo) && (this$1.RTLong__f_hi === b.RTLong__f_hi))
      } else {
        var xn = this.Ljava_math_BigDecimal__f__intVal;
        var yn = x2.Ljava_math_BigDecimal__f__intVal;
        return $m_sr_BoxesRunTime$().equalsNumNum__jl_Number__jl_Number__Z(xn, yn)
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Ljava_math_BigDecimal.prototype.hashCode__I = (function() {
  if ((this.Ljava_math_BigDecimal__f__hashCode !== 0)) {
    return this.Ljava_math_BigDecimal__f__hashCode
  } else if ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength < 64)) {
    var this$1 = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
    this.Ljava_math_BigDecimal__f__hashCode = this$1.RTLong__f_lo;
    var $$x1 = this.Ljava_math_BigDecimal__f__hashCode;
    var this$2 = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
    var hi = this$2.RTLong__f_hi;
    this.Ljava_math_BigDecimal__f__hashCode = (($imul(33, $$x1) + hi) | 0);
    this.Ljava_math_BigDecimal__f__hashCode = (($imul(17, this.Ljava_math_BigDecimal__f__hashCode) + this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale) | 0);
    return this.Ljava_math_BigDecimal__f__hashCode
  } else {
    this.Ljava_math_BigDecimal__f__hashCode = (($imul(17, this.Ljava_math_BigDecimal__f__intVal.hashCode__I()) + this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale) | 0);
    return this.Ljava_math_BigDecimal__f__hashCode
  }
});
$c_Ljava_math_BigDecimal.prototype.toString__T = (function() {
  if ((this.Ljava_math_BigDecimal__f__toStringImage !== null)) {
    return this.Ljava_math_BigDecimal__f__toStringImage
  } else if ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength < 32)) {
    this.Ljava_math_BigDecimal__f__toStringImage = $m_Ljava_math_Conversion$().toDecimalScaledString__J__I__T(this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue, this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale);
    return this.Ljava_math_BigDecimal__f__toStringImage
  } else {
    var this$1 = this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
    var intString = $m_Ljava_math_Conversion$().toDecimalScaledString__Ljava_math_BigInteger__T(this$1);
    if ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale === 0)) {
      return intString
    } else {
      var this$2 = this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
      if ((this$2.Ljava_math_BigInteger__f_sign < 0)) {
        var begin = 2
      } else {
        var begin = 1
      };
      var end = $uI(intString.length);
      var value = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
      var hi = (value >> 31);
      var lo = ((-value) | 0);
      var hi$1 = ((value !== 0) ? (~hi) : ((-hi) | 0));
      var hi$2 = (end >> 31);
      var lo$1 = ((lo + end) | 0);
      var hi$3 = ((((-2147483648) ^ lo$1) < ((-2147483648) ^ lo)) ? ((1 + ((hi$1 + hi$2) | 0)) | 0) : ((hi$1 + hi$2) | 0));
      var hi$4 = (begin >> 31);
      var lo$2 = ((lo$1 - begin) | 0);
      var hi$5 = ((((-2147483648) ^ lo$2) > ((-2147483648) ^ lo$1)) ? (((-1) + ((hi$3 - hi$4) | 0)) | 0) : ((hi$3 - hi$4) | 0));
      if (((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale > 0) && ((hi$5 === (-1)) ? (((-2147483648) ^ lo$2) >= 2147483642) : (hi$5 > (-1))))) {
        if ((hi$5 >= 0)) {
          $m_Ljava_math_BigDecimal$();
          var pos = ((end - this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale) | 0);
          $m_Ljava_math_BigDecimal$();
          var result = (($as_T(intString.substring(0, pos)) + ".") + $as_T(intString.substring(pos)))
        } else {
          $m_Ljava_math_BigDecimal$();
          $m_Ljava_math_BigDecimal$();
          var pos$1 = (((-1) + begin) | 0);
          $m_Ljava_math_BigDecimal$();
          var s = (($as_T(intString.substring(0, pos$1)) + "0.") + $as_T(intString.substring(pos$1)));
          var pos$2 = ((1 + begin) | 0);
          var s2 = $m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_java$math$BigDecimal$$CharZeros;
          var s2Len = (((-1) - lo$2) | 0);
          $m_Ljava_math_BigDecimal$();
          var s2$1 = $as_T(s2.substring(0, s2Len));
          var result = ((("" + $as_T(s.substring(0, pos$2))) + s2$1) + $as_T(s.substring(pos$2)))
        }
      } else {
        var r0 = ((((end - begin) | 0) >= 1) ? ($m_Ljava_math_BigDecimal$(), $m_Ljava_math_BigDecimal$(), (($as_T(intString.substring(0, begin)) + ".") + $as_T(intString.substring(begin)))) : intString);
        var r1 = (r0 + "E");
        var r2 = (((hi$5 === 0) ? (lo$2 !== 0) : (hi$5 > 0)) ? (r1 + "+") : r1);
        var result = (r2 + $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toString__I__I__T(lo$2, hi$5))
      };
      this.Ljava_math_BigDecimal__f__toStringImage = result;
      return this.Ljava_math_BigDecimal__f__toStringImage
    }
  }
});
$c_Ljava_math_BigDecimal.prototype.toBigInteger__Ljava_math_BigInteger = (function() {
  if (((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale === 0) || $p_Ljava_math_BigDecimal__isZero__Z(this))) {
    return this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger()
  } else if ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale < 0)) {
    var $$x2 = this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
    var $$x1 = $m_Ljava_math_Multiplication$();
    var value = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
    var hi = (value >> 31);
    var lo = ((-value) | 0);
    var hi$1 = ((value !== 0) ? (~hi) : ((-hi) | 0));
    return $$x2.multiply__Ljava_math_BigInteger__Ljava_math_BigInteger($$x1.powerOf10__J__Ljava_math_BigInteger(new $c_RTLong(lo, hi$1)))
  } else {
    var $$x4 = this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
    var $$x3 = $m_Ljava_math_Multiplication$();
    var value$1 = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
    var hi$2 = (value$1 >> 31);
    return $$x4.divide__Ljava_math_BigInteger__Ljava_math_BigInteger($$x3.powerOf10__J__Ljava_math_BigInteger(new $c_RTLong(value$1, hi$2)))
  }
});
$c_Ljava_math_BigDecimal.prototype.toBigIntegerExact__Ljava_math_BigInteger = (function() {
  if (((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale === 0) || $p_Ljava_math_BigDecimal__isZero__Z(this))) {
    return this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger()
  } else if ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale < 0)) {
    var $$x2 = this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
    var $$x1 = $m_Ljava_math_Multiplication$();
    var value = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
    var hi = (value >> 31);
    var lo = ((-value) | 0);
    var hi$1 = ((value !== 0) ? (~hi) : ((-hi) | 0));
    return $$x2.multiply__Ljava_math_BigInteger__Ljava_math_BigInteger($$x1.powerOf10__J__Ljava_math_BigInteger(new $c_RTLong(lo, hi$1)))
  } else {
    if (((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale > $p_Ljava_math_BigDecimal__approxPrecision__I(this)) || (this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale > this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger().getLowestSetBit__I()))) {
      throw new $c_jl_ArithmeticException("Rounding necessary")
    };
    var $$x4 = this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
    var $$x3 = $m_Ljava_math_Multiplication$();
    var value$1 = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
    var hi$2 = (value$1 >> 31);
    var integerAndFraction = $$x4.divideAndRemainder__Ljava_math_BigInteger__ALjava_math_BigInteger($$x3.powerOf10__J__Ljava_math_BigInteger(new $c_RTLong(value$1, hi$2)));
    var this$5 = integerAndFraction.get(1);
    if ((this$5.Ljava_math_BigInteger__f_sign !== 0)) {
      throw new $c_jl_ArithmeticException("Rounding necessary")
    };
    return integerAndFraction.get(0)
  }
});
$c_Ljava_math_BigDecimal.prototype.longValue__J = (function() {
  return (((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale <= (-64)) || (this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale > $p_Ljava_math_BigDecimal__approxPrecision__I(this))) ? $L0 : this.toBigInteger__Ljava_math_BigInteger().longValue__J())
});
$c_Ljava_math_BigDecimal.prototype.intValue__I = (function() {
  return (((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale <= (-32)) || (this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale > $p_Ljava_math_BigDecimal__approxPrecision__I(this))) ? 0 : this.toBigInteger__Ljava_math_BigInteger().intValue__I())
});
$c_Ljava_math_BigDecimal.prototype.intValueExact__I = (function() {
  var this$1 = $p_Ljava_math_BigDecimal__valueExact__I__J(this, 32);
  return this$1.RTLong__f_lo
});
$c_Ljava_math_BigDecimal.prototype.shortValueExact__S = (function() {
  var this$1 = $p_Ljava_math_BigDecimal__valueExact__I__J(this, 16);
  return ((this$1.RTLong__f_lo << 16) >> 16)
});
$c_Ljava_math_BigDecimal.prototype.byteValueExact__B = (function() {
  var this$1 = $p_Ljava_math_BigDecimal__valueExact__I__J(this, 8);
  return ((this$1.RTLong__f_lo << 24) >> 24)
});
$c_Ljava_math_BigDecimal.prototype.floatValue__F = (function() {
  var value = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength;
  var hi = (value >> 31);
  var this$2 = $m_RTLong$();
  var value$1 = (this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale / 0.3010299956639812);
  var lo = this$2.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value$1);
  var hi$1 = this$2.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var lo$1 = ((value - lo) | 0);
  var hi$2 = ((((-2147483648) ^ lo$1) > ((-2147483648) ^ value)) ? (((-1) + ((hi - hi$1) | 0)) | 0) : ((hi - hi$1) | 0));
  var floatResult0 = $fround(this.signum__I());
  var floatResult = ((((hi$2 === (-1)) ? (((-2147483648) ^ lo$1) < 2147483499) : (hi$2 < (-1))) || (floatResult0 === 0.0)) ? $fround((0.0 * floatResult0)) : (((hi$2 === 0) ? (((-2147483648) ^ lo$1) > (-2147483519)) : (hi$2 > 0)) ? $fround((Infinity * floatResult0)) : $fround(this.doubleValue__D())));
  return floatResult
});
$c_Ljava_math_BigDecimal.prototype.doubleValue__D = (function() {
  var sign = this.signum__I();
  var value = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength;
  var hi = (value >> 31);
  var this$2 = $m_RTLong$();
  var value$1 = (this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale / 0.3010299956639812);
  var lo = this$2.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value$1);
  var hi$1 = this$2.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var lo$1 = ((value - lo) | 0);
  var hi$2 = ((((-2147483648) ^ lo$1) > ((-2147483648) ^ value)) ? (((-1) + ((hi - hi$1) | 0)) | 0) : ((hi - hi$1) | 0));
  if ((((hi$2 === (-1)) ? (((-2147483648) ^ lo$1) < 2147482574) : (hi$2 < (-1))) || (sign === 0))) {
    return (0.0 * sign)
  } else if (((hi$2 === 0) ? (((-2147483648) ^ lo$1) > (-2147482623)) : (hi$2 > 0))) {
    return (Infinity * sign)
  } else {
    var mantissa0 = this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger().abs__Ljava_math_BigInteger();
    var exponent = 1076;
    if ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale <= 0)) {
      var $$x1 = $m_Ljava_math_Multiplication$();
      var value$2 = ((-this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale) | 0);
      var hi$3 = (value$2 >> 31);
      var mantissa = mantissa0.multiply__Ljava_math_BigInteger__Ljava_math_BigInteger($$x1.powerOf10__J__Ljava_math_BigInteger(new $c_RTLong(value$2, hi$3)))
    } else {
      var $$x2 = $m_Ljava_math_Multiplication$();
      var value$3 = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
      var hi$4 = (value$3 >> 31);
      var powerOfTen = $$x2.powerOf10__J__Ljava_math_BigInteger(new $c_RTLong(value$3, hi$4));
      var k = ((100 - lo$1) | 0);
      if ((k > 0)) {
        exponent = ((exponent - k) | 0);
        var m = mantissa0.shiftLeft__I__Ljava_math_BigInteger(k)
      } else {
        var m = mantissa0
      };
      var qr = m.divideAndRemainderImpl__Ljava_math_BigInteger__Ljava_math_BigInteger$QuotAndRem(powerOfTen);
      var compRem = qr.Ljava_math_BigInteger$QuotAndRem__f_rem.shiftLeftOneBit__Ljava_math_BigInteger().compareTo__Ljava_math_BigInteger__I(powerOfTen);
      exponent = (((-2) + exponent) | 0);
      var this$7 = qr.Ljava_math_BigInteger$QuotAndRem__f_quot.shiftLeft__I__Ljava_math_BigInteger(2);
      var $$x3 = $m_Ljava_math_BigInteger$();
      var value$4 = ((1 + (($imul(compRem, ((3 + compRem) | 0)) / 2) | 0)) | 0);
      var hi$5 = (value$4 >> 31);
      var bi = $$x3.valueOf__J__Ljava_math_BigInteger(new $c_RTLong(value$4, hi$5));
      var mantissa = $m_Ljava_math_Elementary$().add__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$7, bi)
    };
    var lowestSetBit = mantissa.getLowestSetBit__I();
    var discardedSize = (((-54) + $m_Ljava_math_BitLevel$().bitLength__Ljava_math_BigInteger__I(mantissa)) | 0);
    var bits__lo = 0;
    var bits__hi = 0;
    var tempBits__lo = 0;
    var tempBits__hi = 0;
    if ((discardedSize > 0)) {
      var t = mantissa.shiftRight__I__Ljava_math_BigInteger(discardedSize).longValue__J();
      var lo$2 = t.RTLong__f_lo;
      var hi$6 = t.RTLong__f_hi;
      var $$x4__lo = lo$2;
      var $$x4__hi = hi$6;
      bits__lo = $$x4__lo;
      bits__hi = $$x4__hi;
      tempBits__lo = bits__lo;
      tempBits__hi = bits__hi;
      var b__lo = bits__lo;
      var b__hi = bits__hi;
      var lo$3 = (1 & b__lo);
      if (((lo$3 === 1) && (lowestSetBit < discardedSize))) {
        var $$x5 = true
      } else {
        var b$1__lo = bits__lo;
        var b$1__hi = bits__hi;
        var lo$4 = (3 & b$1__lo);
        var $$x5 = (lo$4 === 3)
      };
      if ($$x5) {
        var b$2__lo = bits__lo;
        var b$2__hi = bits__hi;
        var bhi = b$2__hi;
        var lo$5 = ((2 + b$2__lo) | 0);
        var hi$7 = ((((-2147483648) ^ lo$5) < (-2147483646)) ? ((1 + bhi) | 0) : bhi);
        var $$x6__lo = lo$5;
        var $$x6__hi = hi$7;
        bits__lo = $$x6__lo;
        bits__hi = $$x6__hi
      }
    } else {
      var this$9 = mantissa.longValue__J();
      var n = ((-discardedSize) | 0);
      var lo$6 = this$9.RTLong__f_lo;
      var lo$7 = (((32 & n) === 0) ? (lo$6 << n) : 0);
      var hi$8 = (((32 & n) === 0) ? (((((lo$6 >>> 1) | 0) >>> ((31 - n) | 0)) | 0) | (this$9.RTLong__f_hi << n)) : (lo$6 << n));
      var $$x7__lo = lo$7;
      var $$x7__hi = hi$8;
      bits__lo = $$x7__lo;
      bits__hi = $$x7__hi;
      tempBits__lo = bits__lo;
      tempBits__hi = bits__hi;
      var b$3__lo = bits__lo;
      var b$3__hi = bits__hi;
      var lo$8 = (3 & b$3__lo);
      if ((lo$8 === 3)) {
        var b$4__lo = bits__lo;
        var b$4__hi = bits__hi;
        var bhi$1 = b$4__hi;
        var lo$9 = ((2 + b$4__lo) | 0);
        var hi$9 = ((((-2147483648) ^ lo$9) < (-2147483646)) ? ((1 + bhi$1) | 0) : bhi$1);
        var $$x8__lo = lo$9;
        var $$x8__hi = hi$9;
        bits__lo = $$x8__lo;
        bits__hi = $$x8__hi
      }
    };
    var b$5__lo = bits__lo;
    var b$5__hi = bits__hi;
    var hi$10 = (4194304 & b$5__hi);
    if ((hi$10 === 0)) {
      var this$11__lo = bits__lo;
      var this$11__hi = bits__hi;
      var hi$11 = this$11__hi;
      var lo$10 = (((this$11__lo >>> 1) | 0) | (hi$11 << 31));
      var hi$12 = (hi$11 >> 1);
      var $$x9__lo = lo$10;
      var $$x9__hi = hi$12;
      bits__lo = $$x9__lo;
      bits__hi = $$x9__hi;
      exponent = ((exponent + discardedSize) | 0)
    } else {
      var this$12__lo = bits__lo;
      var this$12__hi = bits__hi;
      var hi$13 = this$12__hi;
      var lo$11 = (((this$12__lo >>> 2) | 0) | (hi$13 << 30));
      var hi$14 = (hi$13 >> 2);
      var $$x10__lo = lo$11;
      var $$x10__hi = hi$14;
      bits__lo = $$x10__lo;
      bits__hi = $$x10__hi;
      exponent = ((exponent + ((1 + discardedSize) | 0)) | 0)
    };
    if ((exponent > 2046)) {
      return (Infinity * sign)
    } else if ((exponent < (-53))) {
      return (0.0 * sign)
    } else {
      if ((exponent <= 0)) {
        var this$13__lo = tempBits__lo;
        var this$13__hi = tempBits__hi;
        var hi$15 = this$13__hi;
        var lo$12 = (((this$13__lo >>> 1) | 0) | (hi$15 << 31));
        var hi$16 = (hi$15 >> 1);
        var $$x11__lo = lo$12;
        var $$x11__hi = hi$16;
        bits__lo = $$x11__lo;
        bits__hi = $$x11__hi;
        var this$14__lo = bits__lo;
        var this$14__hi = bits__hi;
        var n$1 = ((63 + exponent) | 0);
        var lo$13 = (((32 & n$1) === 0) ? ((((-1) >>> n$1) | 0) | ((-2) << ((31 - n$1) | 0))) : (((-1) >>> n$1) | 0));
        var hi$17 = (((32 & n$1) === 0) ? (((-1) >>> n$1) | 0) : 0);
        var lo$14 = (this$14__lo & lo$13);
        var hi$18 = (this$14__hi & hi$17);
        var $$x12__lo = lo$14;
        var $$x12__hi = hi$18;
        tempBits__lo = $$x12__lo;
        tempBits__hi = $$x12__hi;
        var this$15__lo = bits__lo;
        var this$15__hi = bits__hi;
        var n$2 = ((-exponent) | 0);
        var hi$19 = this$15__hi;
        var lo$15 = (((32 & n$2) === 0) ? (((this$15__lo >>> n$2) | 0) | ((hi$19 << 1) << ((31 - n$2) | 0))) : (hi$19 >> n$2));
        var hi$20 = (((32 & n$2) === 0) ? (hi$19 >> n$2) : (hi$19 >> 31));
        var $$x13__lo = lo$15;
        var $$x13__hi = hi$20;
        bits__lo = $$x13__lo;
        bits__hi = $$x13__hi;
        var b$6__lo = bits__lo;
        var b$6__hi = bits__hi;
        var lo$16 = (3 & b$6__lo);
        if ((lo$16 === 3)) {
          var $$x14 = true
        } else {
          var b$7__lo = bits__lo;
          var b$7__hi = bits__hi;
          var lo$17 = (1 & b$7__lo);
          if ((lo$17 === 1)) {
            var this$16__lo = tempBits__lo;
            var this$16__hi = tempBits__hi;
            var $$x15 = (!((this$16__lo === 0) && (this$16__hi === 0)))
          } else {
            var $$x15 = false
          };
          if ($$x15) {
            var $$x14 = (lowestSetBit < discardedSize)
          } else {
            var $$x14 = false
          }
        };
        if ($$x14) {
          var b$8__lo = bits__lo;
          var b$8__hi = bits__hi;
          var bhi$2 = b$8__hi;
          var lo$18 = ((1 + b$8__lo) | 0);
          var hi$21 = ((lo$18 === 0) ? ((1 + bhi$2) | 0) : bhi$2);
          var $$x16__lo = lo$18;
          var $$x16__hi = hi$21;
          bits__lo = $$x16__lo;
          bits__hi = $$x16__hi
        };
        exponent = 0;
        var this$18__lo = bits__lo;
        var this$18__hi = bits__hi;
        var hi$22 = this$18__hi;
        var lo$19 = (((this$18__lo >>> 1) | 0) | (hi$22 << 31));
        var hi$23 = (hi$22 >> 1);
        var $$x17__lo = lo$19;
        var $$x17__hi = hi$23;
        bits__lo = $$x17__lo;
        bits__hi = $$x17__hi
      };
      var hi$24 = (sign >> 31);
      var hi$25 = ((-2147483648) & hi$24);
      var value$5 = exponent;
      var hi$27 = (value$5 << 20);
      var hi$28 = (hi$25 | hi$27);
      var b$9__lo = bits__lo;
      var b$9__hi = bits__hi;
      var lo$20 = b$9__lo;
      var hi$29 = (1048575 & b$9__hi);
      var hi$30 = (hi$28 | hi$29);
      return $m_jl_FloatingPointBits$().longBitsToDouble__J__D(new $c_RTLong(lo$20, hi$30))
    }
  }
});
$c_Ljava_math_BigDecimal.prototype.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger = (function() {
  if ((this.Ljava_math_BigDecimal__f__intVal === null)) {
    this.Ljava_math_BigDecimal__f__intVal = $m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue)
  };
  return this.Ljava_math_BigDecimal__f__intVal
});
function $as_Ljava_math_BigDecimal(obj) {
  return (((obj instanceof $c_Ljava_math_BigDecimal) || (obj === null)) ? obj : $throwClassCastException(obj, "java.math.BigDecimal"))
}
function $isArrayOf_Ljava_math_BigDecimal(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_math_BigDecimal)))
}
function $asArrayOf_Ljava_math_BigDecimal(obj, depth) {
  return (($isArrayOf_Ljava_math_BigDecimal(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.math.BigDecimal;", depth))
}
var $d_Ljava_math_BigDecimal = new $TypeData().initClass({
  Ljava_math_BigDecimal: 0
}, false, "java.math.BigDecimal", {
  Ljava_math_BigDecimal: 1,
  jl_Number: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1
});
$c_Ljava_math_BigDecimal.prototype.$classData = $d_Ljava_math_BigDecimal;
function $p_Ljava_math_BigInteger__setFromString__T__I__V($thiz, s, radix) {
  if ((((s === "") || (s === "+")) || (s === "-"))) {
    throw new $c_jl_NumberFormatException("Zero length BigInteger")
  };
  var stringLength0 = $uI(s.length);
  if (((65535 & $uI(s.charCodeAt(0))) === 45)) {
    var _3 = (((-1) + stringLength0) | 0);
    var x1___1 = (-1);
    var x1___2 = 1;
    var x1___3 = _3
  } else if (((65535 & $uI(s.charCodeAt(0))) === 43)) {
    var _3$1 = (((-1) + stringLength0) | 0);
    var x1___1 = 1;
    var x1___2 = 1;
    var x1___3 = _3$1
  } else {
    var x1___1 = 1;
    var x1___2 = 0;
    var x1___3 = stringLength0
  };
  var _sign = $uI(x1___1);
  var startChar = $uI(x1___2);
  var stringLength = $uI(x1___3);
  var i = startChar;
  while ((i < stringLength0)) {
    var arg1 = i;
    var c = (65535 & $uI(s.charCodeAt(arg1)));
    if (((c === 43) || (c === 45))) {
      throw new $c_jl_NumberFormatException("Illegal embedded sign character")
    };
    i = ((1 + i) | 0)
  };
  var charsPerInt = $m_Ljava_math_Conversion$().Ljava_math_Conversion$__f_DigitFitInInt.get(radix);
  var bigRadixDigitsLength = $intDiv(stringLength, charsPerInt);
  var topChars = $intMod(stringLength, charsPerInt);
  if ((topChars !== 0)) {
    bigRadixDigitsLength = ((1 + bigRadixDigitsLength) | 0)
  };
  var _digits = new $ac_I(bigRadixDigitsLength);
  var bigRadix = $m_Ljava_math_Conversion$().Ljava_math_Conversion$__f_BigRadices.get((((-2) + radix) | 0));
  var digitIndex = 0;
  var substrEnd = ((startChar + ((topChars === 0) ? charsPerInt : topChars)) | 0);
  var newDigit = 0;
  var substrStart = startChar;
  while ((substrStart < stringLength0)) {
    var beginIndex = substrStart;
    var endIndex = substrEnd;
    var s$1 = $as_T(s.substring(beginIndex, endIndex));
    var bigRadixDigit = $m_jl_Integer$().parseInt__T__I__I(s$1, radix);
    var this$3 = $m_Ljava_math_Multiplication$();
    var aSize = digitIndex;
    newDigit = $p_Ljava_math_Multiplication$__multiplyByInt__AI__AI__I__I__I(this$3, _digits, _digits, aSize, bigRadix);
    newDigit = ((newDigit + $m_Ljava_math_Elementary$().inplaceAdd__AI__I__I__I(_digits, digitIndex, bigRadixDigit)) | 0);
    _digits.set(digitIndex, newDigit);
    digitIndex = ((1 + digitIndex) | 0);
    substrStart = substrEnd;
    substrEnd = ((substrStart + charsPerInt) | 0)
  };
  $thiz.Ljava_math_BigInteger__f_sign = _sign;
  $thiz.Ljava_math_BigInteger__f_numberLength = digitIndex;
  $thiz.Ljava_math_BigInteger__f_digits = _digits;
  $thiz.cutOffLeadingZeroes__V()
}
function $ct_Ljava_math_BigInteger__($thiz) {
  $thiz.Ljava_math_BigInteger__f_java$math$BigInteger$$firstNonzeroDigit = (-2);
  $thiz.Ljava_math_BigInteger__f__hashCode = 0;
  return $thiz
}
function $ct_Ljava_math_BigInteger__T__I__($thiz, s, radix) {
  $ct_Ljava_math_BigInteger__($thiz);
  $m_Ljava_math_BigInteger$();
  if ((s === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  if (((radix < 2) || (radix > 36))) {
    throw new $c_jl_NumberFormatException("Radix out of range")
  };
  if ((s === "")) {
    throw new $c_jl_NumberFormatException("Zero length BigInteger")
  };
  $p_Ljava_math_BigInteger__setFromString__T__I__V($thiz, s, radix);
  return $thiz
}
function $ct_Ljava_math_BigInteger__T__($thiz, s) {
  $ct_Ljava_math_BigInteger__T__I__($thiz, s, 10);
  return $thiz
}
function $ct_Ljava_math_BigInteger__I__I__($thiz, sign, value) {
  $ct_Ljava_math_BigInteger__($thiz);
  $thiz.Ljava_math_BigInteger__f_sign = sign;
  $thiz.Ljava_math_BigInteger__f_numberLength = 1;
  $thiz.Ljava_math_BigInteger__f_digits = new $ac_I([value]);
  return $thiz
}
function $ct_Ljava_math_BigInteger__I__AI__($thiz, signum, digits) {
  $ct_Ljava_math_BigInteger__($thiz);
  if ((digits.u.length === 0)) {
    $thiz.Ljava_math_BigInteger__f_sign = 0;
    $thiz.Ljava_math_BigInteger__f_numberLength = 1;
    $thiz.Ljava_math_BigInteger__f_digits = new $ac_I([0])
  } else {
    $thiz.Ljava_math_BigInteger__f_sign = signum;
    $thiz.Ljava_math_BigInteger__f_numberLength = digits.u.length;
    $thiz.Ljava_math_BigInteger__f_digits = digits;
    $thiz.cutOffLeadingZeroes__V()
  };
  return $thiz
}
function $ct_Ljava_math_BigInteger__I__I__AI__($thiz, sign, numberLength, digits) {
  $ct_Ljava_math_BigInteger__($thiz);
  $thiz.Ljava_math_BigInteger__f_sign = sign;
  $thiz.Ljava_math_BigInteger__f_numberLength = numberLength;
  $thiz.Ljava_math_BigInteger__f_digits = digits;
  return $thiz
}
function $ct_Ljava_math_BigInteger__I__J__($thiz, sign, lVal) {
  $ct_Ljava_math_BigInteger__($thiz);
  $thiz.Ljava_math_BigInteger__f_sign = sign;
  var hi = lVal.RTLong__f_hi;
  if ((hi === 0)) {
    $thiz.Ljava_math_BigInteger__f_numberLength = 1;
    $thiz.Ljava_math_BigInteger__f_digits = new $ac_I([lVal.RTLong__f_lo])
  } else {
    $thiz.Ljava_math_BigInteger__f_numberLength = 2;
    $thiz.Ljava_math_BigInteger__f_digits = new $ac_I([lVal.RTLong__f_lo, hi])
  };
  return $thiz
}
/** @constructor */
function $c_Ljava_math_BigInteger() {
  this.Ljava_math_BigInteger__f_digits = null;
  this.Ljava_math_BigInteger__f_numberLength = 0;
  this.Ljava_math_BigInteger__f_sign = 0;
  this.Ljava_math_BigInteger__f_java$math$BigInteger$$firstNonzeroDigit = 0;
  this.Ljava_math_BigInteger__f__hashCode = 0
}
$c_Ljava_math_BigInteger.prototype = new $h_jl_Number();
$c_Ljava_math_BigInteger.prototype.constructor = $c_Ljava_math_BigInteger;
/** @constructor */
function $h_Ljava_math_BigInteger() {
  /*<skip>*/
}
$h_Ljava_math_BigInteger.prototype = $c_Ljava_math_BigInteger.prototype;
$c_Ljava_math_BigInteger.prototype.abs__Ljava_math_BigInteger = (function() {
  return ((this.Ljava_math_BigInteger__f_sign < 0) ? $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), 1, this.Ljava_math_BigInteger__f_numberLength, this.Ljava_math_BigInteger__f_digits) : this)
});
$c_Ljava_math_BigInteger.prototype.compareTo__Ljava_math_BigInteger__I = (function(bi) {
  return ((this.Ljava_math_BigInteger__f_sign > bi.Ljava_math_BigInteger__f_sign) ? 1 : ((this.Ljava_math_BigInteger__f_sign < bi.Ljava_math_BigInteger__f_sign) ? (-1) : ((this.Ljava_math_BigInteger__f_numberLength > bi.Ljava_math_BigInteger__f_numberLength) ? this.Ljava_math_BigInteger__f_sign : ((this.Ljava_math_BigInteger__f_numberLength < bi.Ljava_math_BigInteger__f_numberLength) ? ((-bi.Ljava_math_BigInteger__f_sign) | 0) : $imul(this.Ljava_math_BigInteger__f_sign, $m_Ljava_math_Elementary$().compareArrays__AI__AI__I__I(this.Ljava_math_BigInteger__f_digits, bi.Ljava_math_BigInteger__f_digits, this.Ljava_math_BigInteger__f_numberLength))))))
});
$c_Ljava_math_BigInteger.prototype.divide__Ljava_math_BigInteger__Ljava_math_BigInteger = (function(divisor) {
  if ((divisor.Ljava_math_BigInteger__f_sign === 0)) {
    throw new $c_jl_ArithmeticException("BigInteger divide by zero")
  };
  var divisorSign = divisor.Ljava_math_BigInteger__f_sign;
  if (divisor.isOne__Z()) {
    return ((divisor.Ljava_math_BigInteger__f_sign > 0) ? this : this.negate__Ljava_math_BigInteger())
  } else {
    var thisSign = this.Ljava_math_BigInteger__f_sign;
    var thisLen = this.Ljava_math_BigInteger__f_numberLength;
    var divisorLen = divisor.Ljava_math_BigInteger__f_numberLength;
    if ((((thisLen + divisorLen) | 0) === 2)) {
      var value = this.Ljava_math_BigInteger__f_digits.get(0);
      var value$1 = divisor.Ljava_math_BigInteger__f_digits.get(0);
      var this$3 = $m_RTLong$();
      var lo = this$3.divideImpl__I__I__I__I__I(value, 0, value$1, 0);
      var hi$2 = this$3.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      var bi__lo = lo;
      var bi__hi = hi$2;
      if ((thisSign !== divisorSign)) {
        var this$4__lo = bi__lo;
        var this$4__hi = bi__hi;
        var lo$1 = this$4__lo;
        var hi$3 = this$4__hi;
        var lo$2 = ((-lo$1) | 0);
        var hi$4 = ((lo$1 !== 0) ? (~hi$3) : ((-hi$3) | 0));
        var $$x1__lo = lo$2;
        var $$x1__hi = hi$4;
        bi__lo = $$x1__lo;
        bi__hi = $$x1__hi
      };
      return $m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(new $c_RTLong(bi__lo, bi__hi))
    } else {
      var cmp = ((thisLen !== divisorLen) ? ((thisLen > divisorLen) ? 1 : (-1)) : $m_Ljava_math_Elementary$().compareArrays__AI__AI__I__I(this.Ljava_math_BigInteger__f_digits, divisor.Ljava_math_BigInteger__f_digits, thisLen));
      if ((cmp === 0)) {
        return ((thisSign === divisorSign) ? $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ONE : $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_MINUS_ONE)
      } else if ((cmp === (-1))) {
        return $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ZERO
      } else {
        var resLength = ((1 + ((thisLen - divisorLen) | 0)) | 0);
        var resDigits = new $ac_I(resLength);
        var resSign = ((thisSign === divisorSign) ? 1 : (-1));
        if ((divisorLen === 1)) {
          $m_Ljava_math_Division$().divideArrayByInt__AI__AI__I__I__I(resDigits, this.Ljava_math_BigInteger__f_digits, thisLen, divisor.Ljava_math_BigInteger__f_digits.get(0))
        } else {
          $m_Ljava_math_Division$().divide__AI__I__AI__I__AI__I__AI(resDigits, resLength, this.Ljava_math_BigInteger__f_digits, thisLen, divisor.Ljava_math_BigInteger__f_digits, divisorLen)
        };
        var result = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), resSign, resLength, resDigits);
        result.cutOffLeadingZeroes__V();
        return result
      }
    }
  }
});
$c_Ljava_math_BigInteger.prototype.divideAndRemainder__Ljava_math_BigInteger__ALjava_math_BigInteger = (function(divisor) {
  return this.divideAndRemainderImpl__Ljava_math_BigInteger__Ljava_math_BigInteger$QuotAndRem(divisor).toArray__ALjava_math_BigInteger()
});
$c_Ljava_math_BigInteger.prototype.divideAndRemainderImpl__Ljava_math_BigInteger__Ljava_math_BigInteger$QuotAndRem = (function(divisor) {
  var divisorSign = divisor.Ljava_math_BigInteger__f_sign;
  if ((divisorSign === 0)) {
    throw new $c_jl_ArithmeticException("BigInteger divide by zero")
  };
  var divisorLen = divisor.Ljava_math_BigInteger__f_numberLength;
  var divisorDigits = divisor.Ljava_math_BigInteger__f_digits;
  if ((divisorLen === 1)) {
    return $m_Ljava_math_Division$().divideAndRemainderByInteger__Ljava_math_BigInteger__I__I__Ljava_math_BigInteger$QuotAndRem(this, divisorDigits.get(0), divisorSign)
  } else {
    var thisDigits = this.Ljava_math_BigInteger__f_digits;
    var thisLen = this.Ljava_math_BigInteger__f_numberLength;
    var cmp = ((thisLen !== divisorLen) ? ((thisLen > divisorLen) ? 1 : (-1)) : $m_Ljava_math_Elementary$().compareArrays__AI__AI__I__I(thisDigits, divisorDigits, thisLen));
    if ((cmp < 0)) {
      return new $c_Ljava_math_BigInteger$QuotAndRem($m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ZERO, this)
    } else {
      var thisSign = this.Ljava_math_BigInteger__f_sign;
      var quotientLength = ((1 + ((thisLen - divisorLen) | 0)) | 0);
      var quotientSign = ((thisSign === divisorSign) ? 1 : (-1));
      var quotientDigits = new $ac_I(quotientLength);
      var remainderDigits = $m_Ljava_math_Division$().divide__AI__I__AI__I__AI__I__AI(quotientDigits, quotientLength, thisDigits, thisLen, divisorDigits, divisorLen);
      var result0 = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), quotientSign, quotientLength, quotientDigits);
      var result1 = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), thisSign, divisorLen, remainderDigits);
      result0.cutOffLeadingZeroes__V();
      result1.cutOffLeadingZeroes__V();
      return new $c_Ljava_math_BigInteger$QuotAndRem(result0, result1)
    }
  }
});
$c_Ljava_math_BigInteger.prototype.equals__O__Z = (function(x) {
  if ((x instanceof $c_Ljava_math_BigInteger)) {
    var x2 = $as_Ljava_math_BigInteger(x);
    return (((this.Ljava_math_BigInteger__f_sign === x2.Ljava_math_BigInteger__f_sign) && (this.Ljava_math_BigInteger__f_numberLength === x2.Ljava_math_BigInteger__f_numberLength)) && this.equalsArrays__AI__Z(x2.Ljava_math_BigInteger__f_digits))
  } else {
    return false
  }
});
$c_Ljava_math_BigInteger.prototype.getLowestSetBit__I = (function() {
  if ((this.Ljava_math_BigInteger__f_sign === 0)) {
    return (-1)
  } else {
    var i = this.getFirstNonzeroDigit__I();
    var i$1 = this.Ljava_math_BigInteger__f_digits.get(i);
    return (((i << 5) + ((i$1 === 0) ? 32 : ((31 - $clz32((i$1 & ((-i$1) | 0)))) | 0))) | 0)
  }
});
$c_Ljava_math_BigInteger.prototype.hashCode__I = (function() {
  if ((this.Ljava_math_BigInteger__f__hashCode !== 0)) {
    return this.Ljava_math_BigInteger__f__hashCode
  } else {
    var end = this.Ljava_math_BigInteger__f_numberLength;
    var i = 0;
    while ((i < end)) {
      var arg1 = i;
      this.Ljava_math_BigInteger__f__hashCode = (($imul(33, this.Ljava_math_BigInteger__f__hashCode) + this.Ljava_math_BigInteger__f_digits.get(arg1)) | 0);
      i = ((1 + i) | 0)
    };
    this.Ljava_math_BigInteger__f__hashCode = $imul(this.Ljava_math_BigInteger__f__hashCode, this.Ljava_math_BigInteger__f_sign);
    return this.Ljava_math_BigInteger__f__hashCode
  }
});
$c_Ljava_math_BigInteger.prototype.intValue__I = (function() {
  return $imul(this.Ljava_math_BigInteger__f_sign, this.Ljava_math_BigInteger__f_digits.get(0))
});
$c_Ljava_math_BigInteger.prototype.longValue__J = (function() {
  if ((this.Ljava_math_BigInteger__f_numberLength > 1)) {
    var value = this.Ljava_math_BigInteger__f_digits.get(1);
    var value$1 = this.Ljava_math_BigInteger__f_digits.get(0);
    var value$3__lo = value$1;
    var value$3__hi = value
  } else {
    var value$2 = this.Ljava_math_BigInteger__f_digits.get(0);
    var value$3__lo = value$2;
    var value$3__hi = 0
  };
  var value$4 = this.Ljava_math_BigInteger__f_sign;
  var hi$3 = (value$4 >> 31);
  var blo = value$3__lo;
  var a0 = (65535 & value$4);
  var a1 = ((value$4 >>> 16) | 0);
  var b0 = (65535 & blo);
  var b1 = ((blo >>> 16) | 0);
  var a0b0 = $imul(a0, b0);
  var a1b0 = $imul(a1, b0);
  var a0b1 = $imul(a0, b1);
  var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$4 = (((((((($imul(value$4, value$3__hi) + $imul(hi$3, blo)) | 0) + $imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  return new $c_RTLong(lo, hi$4)
});
$c_Ljava_math_BigInteger.prototype.multiply__Ljava_math_BigInteger__Ljava_math_BigInteger = (function(bi) {
  if (((bi.Ljava_math_BigInteger__f_sign === 0) || (this.Ljava_math_BigInteger__f_sign === 0))) {
    return $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ZERO
  } else {
    var this$1 = $m_Ljava_math_Multiplication$();
    return this$1.karatsuba__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this, bi)
  }
});
$c_Ljava_math_BigInteger.prototype.negate__Ljava_math_BigInteger = (function() {
  return ((this.Ljava_math_BigInteger__f_sign === 0) ? this : $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), ((-this.Ljava_math_BigInteger__f_sign) | 0), this.Ljava_math_BigInteger__f_numberLength, this.Ljava_math_BigInteger__f_digits))
});
$c_Ljava_math_BigInteger.prototype.pow__I__Ljava_math_BigInteger = (function(exp) {
  if ((exp < 0)) {
    throw new $c_jl_ArithmeticException("Negative exponent")
  } else if ((exp === 0)) {
    return $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ONE
  } else if ((((exp === 1) || this.equals__O__Z($m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ONE)) || this.equals__O__Z($m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ZERO))) {
    return this
  } else if ((!this.testBit__I__Z(0))) {
    var x = 1;
    while ((!this.testBit__I__Z(x))) {
      x = ((1 + x) | 0)
    };
    return $m_Ljava_math_BigInteger$().getPowerOfTwo__I__Ljava_math_BigInteger($imul(x, exp)).multiply__Ljava_math_BigInteger__Ljava_math_BigInteger(this.shiftRight__I__Ljava_math_BigInteger(x).pow__I__Ljava_math_BigInteger(exp))
  } else {
    return $m_Ljava_math_Multiplication$().pow__Ljava_math_BigInteger__I__Ljava_math_BigInteger(this, exp)
  }
});
$c_Ljava_math_BigInteger.prototype.shiftLeft__I__Ljava_math_BigInteger = (function(n) {
  return (((n === 0) || (this.Ljava_math_BigInteger__f_sign === 0)) ? this : ((n > 0) ? $m_Ljava_math_BitLevel$().shiftLeft__Ljava_math_BigInteger__I__Ljava_math_BigInteger(this, n) : $m_Ljava_math_BitLevel$().shiftRight__Ljava_math_BigInteger__I__Ljava_math_BigInteger(this, ((-n) | 0))))
});
$c_Ljava_math_BigInteger.prototype.shiftRight__I__Ljava_math_BigInteger = (function(n) {
  return (((n === 0) || (this.Ljava_math_BigInteger__f_sign === 0)) ? this : ((n > 0) ? $m_Ljava_math_BitLevel$().shiftRight__Ljava_math_BigInteger__I__Ljava_math_BigInteger(this, n) : $m_Ljava_math_BitLevel$().shiftLeft__Ljava_math_BigInteger__I__Ljava_math_BigInteger(this, ((-n) | 0))))
});
$c_Ljava_math_BigInteger.prototype.testBit__I__Z = (function(n) {
  var intCount = (n >> 5);
  if ((n === 0)) {
    return ((1 & this.Ljava_math_BigInteger__f_digits.get(0)) !== 0)
  } else if ((n < 0)) {
    throw new $c_jl_ArithmeticException("Negative bit address")
  } else if ((intCount >= this.Ljava_math_BigInteger__f_numberLength)) {
    return (this.Ljava_math_BigInteger__f_sign < 0)
  } else if ((!((this.Ljava_math_BigInteger__f_sign < 0) && (intCount < this.getFirstNonzeroDigit__I())))) {
    var digit = this.Ljava_math_BigInteger__f_digits.get(intCount);
    if ((this.Ljava_math_BigInteger__f_sign < 0)) {
      digit = ((this.getFirstNonzeroDigit__I() === intCount) ? ((-digit) | 0) : (~digit))
    };
    var i = (1 << (31 & n));
    return ((digit & i) !== 0)
  } else {
    return false
  }
});
$c_Ljava_math_BigInteger.prototype.toString__T = (function() {
  return $m_Ljava_math_Conversion$().toDecimalScaledString__Ljava_math_BigInteger__T(this)
});
$c_Ljava_math_BigInteger.prototype.cutOffLeadingZeroes__V = (function() {
  while (true) {
    if ((this.Ljava_math_BigInteger__f_numberLength > 0)) {
      this.Ljava_math_BigInteger__f_numberLength = (((-1) + this.Ljava_math_BigInteger__f_numberLength) | 0);
      if ((this.Ljava_math_BigInteger__f_digits.get(this.Ljava_math_BigInteger__f_numberLength) === 0)) {
        continue
      }
    };
    break
  };
  if ((this.Ljava_math_BigInteger__f_digits.get(this.Ljava_math_BigInteger__f_numberLength) === 0)) {
    this.Ljava_math_BigInteger__f_sign = 0
  };
  this.Ljava_math_BigInteger__f_numberLength = ((1 + this.Ljava_math_BigInteger__f_numberLength) | 0)
});
$c_Ljava_math_BigInteger.prototype.equalsArrays__AI__Z = (function(b) {
  var i = 0;
  while ((i !== this.Ljava_math_BigInteger__f_numberLength)) {
    if ((this.Ljava_math_BigInteger__f_digits.get(i) !== b.get(i))) {
      return false
    };
    i = ((1 + i) | 0)
  };
  return true
});
$c_Ljava_math_BigInteger.prototype.getFirstNonzeroDigit__I = (function() {
  if ((this.Ljava_math_BigInteger__f_java$math$BigInteger$$firstNonzeroDigit === (-2))) {
    if ((this.Ljava_math_BigInteger__f_sign === 0)) {
      var $$x1 = (-1)
    } else {
      var i = 0;
      while ((this.Ljava_math_BigInteger__f_digits.get(i) === 0)) {
        i = ((1 + i) | 0)
      };
      var $$x1 = i
    };
    this.Ljava_math_BigInteger__f_java$math$BigInteger$$firstNonzeroDigit = $$x1
  };
  return this.Ljava_math_BigInteger__f_java$math$BigInteger$$firstNonzeroDigit
});
$c_Ljava_math_BigInteger.prototype.isOne__Z = (function() {
  return ((this.Ljava_math_BigInteger__f_numberLength === 1) && (this.Ljava_math_BigInteger__f_digits.get(0) === 1))
});
$c_Ljava_math_BigInteger.prototype.shiftLeftOneBit__Ljava_math_BigInteger = (function() {
  return ((this.Ljava_math_BigInteger__f_sign === 0) ? this : $m_Ljava_math_BitLevel$().shiftLeftOneBit__Ljava_math_BigInteger__Ljava_math_BigInteger(this))
});
function $as_Ljava_math_BigInteger(obj) {
  return (((obj instanceof $c_Ljava_math_BigInteger) || (obj === null)) ? obj : $throwClassCastException(obj, "java.math.BigInteger"))
}
function $isArrayOf_Ljava_math_BigInteger(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_math_BigInteger)))
}
function $asArrayOf_Ljava_math_BigInteger(obj, depth) {
  return (($isArrayOf_Ljava_math_BigInteger(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.math.BigInteger;", depth))
}
var $d_Ljava_math_BigInteger = new $TypeData().initClass({
  Ljava_math_BigInteger: 0
}, false, "java.math.BigInteger", {
  Ljava_math_BigInteger: 1,
  jl_Number: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1
});
$c_Ljava_math_BigInteger.prototype.$classData = $d_Ljava_math_BigInteger;
/** @constructor */
function $c_Ljava_math_RoundingMode(name, ordinal) {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  $ct_jl_Enum__T__I__(this, name, ordinal)
}
$c_Ljava_math_RoundingMode.prototype = new $h_jl_Enum();
$c_Ljava_math_RoundingMode.prototype.constructor = $c_Ljava_math_RoundingMode;
/** @constructor */
function $h_Ljava_math_RoundingMode() {
  /*<skip>*/
}
$h_Ljava_math_RoundingMode.prototype = $c_Ljava_math_RoundingMode.prototype;
var $d_Ljava_math_RoundingMode = new $TypeData().initClass({
  Ljava_math_RoundingMode: 0
}, false, "java.math.RoundingMode", {
  Ljava_math_RoundingMode: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_math_RoundingMode.prototype.$classData = $d_Ljava_math_RoundingMode;
function $ct_Ljava_net_URISyntaxException__T__T__I__($thiz, input, reason, index) {
  $thiz.Ljava_net_URISyntaxException__f_input = input;
  $thiz.Ljava_net_URISyntaxException__f_reason = reason;
  $thiz.Ljava_net_URISyntaxException__f_index = index;
  var s = ((((reason + " in ") + input) + " at ") + index);
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz
}
function $ct_Ljava_net_URISyntaxException__T__T__($thiz, input, reason) {
  $ct_Ljava_net_URISyntaxException__T__T__I__($thiz, input, reason, (-1));
  return $thiz
}
/** @constructor */
function $c_Ljava_net_URISyntaxException() {
  this.jl_Throwable__f_s = null;
  this.jl_Throwable__f_e = null;
  this.jl_Throwable__f_enableSuppression = false;
  this.jl_Throwable__f_writableStackTrace = false;
  this.jl_Throwable__f_stackTraceStateInternal = null;
  this.jl_Throwable__f_stackTrace = null;
  this.jl_Throwable__f_suppressed = null;
  this.Ljava_net_URISyntaxException__f_input = null;
  this.Ljava_net_URISyntaxException__f_reason = null;
  this.Ljava_net_URISyntaxException__f_index = 0
}
$c_Ljava_net_URISyntaxException.prototype = new $h_jl_Exception();
$c_Ljava_net_URISyntaxException.prototype.constructor = $c_Ljava_net_URISyntaxException;
/** @constructor */
function $h_Ljava_net_URISyntaxException() {
  /*<skip>*/
}
$h_Ljava_net_URISyntaxException.prototype = $c_Ljava_net_URISyntaxException.prototype;
var $d_Ljava_net_URISyntaxException = new $TypeData().initClass({
  Ljava_net_URISyntaxException: 0
}, false, "java.net.URISyntaxException", {
  Ljava_net_URISyntaxException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_net_URISyntaxException.prototype.$classData = $d_Ljava_net_URISyntaxException;
/** @constructor */
function $c_Ljava_nio_HeapByteBuffer(_capacity, _array0, _arrayOffset0, _initialPosition, _initialLimit, _readOnly) {
  this.Ljava_nio_Buffer__f__capacity = 0;
  this.Ljava_nio_Buffer__f__limit = 0;
  this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position = 0;
  this.Ljava_nio_Buffer__f__mark = 0;
  this.Ljava_nio_ByteBuffer__f__array = null;
  this.Ljava_nio_ByteBuffer__f__arrayOffset = 0;
  this.Ljava_nio_ByteBuffer__f__isBigEndian = false;
  this.Ljava_nio_HeapByteBuffer__f__readOnly = false;
  this.Ljava_nio_HeapByteBuffer__f__readOnly = _readOnly;
  $ct_Ljava_nio_ByteBuffer__I__AB__I__(this, _capacity, _array0, _arrayOffset0);
  $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(this, _initialPosition);
  $c_Ljava_nio_Buffer.prototype.limit__I__Ljava_nio_Buffer.call(this, _initialLimit)
}
$c_Ljava_nio_HeapByteBuffer.prototype = new $h_Ljava_nio_ByteBuffer();
$c_Ljava_nio_HeapByteBuffer.prototype.constructor = $c_Ljava_nio_HeapByteBuffer;
/** @constructor */
function $h_Ljava_nio_HeapByteBuffer() {
  /*<skip>*/
}
$h_Ljava_nio_HeapByteBuffer.prototype = $c_Ljava_nio_HeapByteBuffer.prototype;
$c_Ljava_nio_HeapByteBuffer.prototype.get__B = (function() {
  var p = this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position;
  if ((p === this.Ljava_nio_Buffer__f__limit)) {
    throw new $c_Ljava_nio_BufferUnderflowException()
  };
  this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position = ((1 + p) | 0);
  return this.Ljava_nio_ByteBuffer__f__array.get(((this.Ljava_nio_ByteBuffer__f__arrayOffset + p) | 0))
});
$c_Ljava_nio_HeapByteBuffer.prototype.put__B__Ljava_nio_ByteBuffer = (function(b) {
  if (this.Ljava_nio_HeapByteBuffer__f__readOnly) {
    throw new $c_Ljava_nio_ReadOnlyBufferException()
  };
  var p = this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position;
  if ((p === this.Ljava_nio_Buffer__f__limit)) {
    throw new $c_Ljava_nio_BufferOverflowException()
  };
  this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position = ((1 + p) | 0);
  this.Ljava_nio_ByteBuffer__f__array.set(((this.Ljava_nio_ByteBuffer__f__arrayOffset + p) | 0), b);
  return this
});
$c_Ljava_nio_HeapByteBuffer.prototype.put__AB__I__I__Ljava_nio_ByteBuffer = (function(src, offset, length) {
  if (this.Ljava_nio_HeapByteBuffer__f__readOnly) {
    throw new $c_Ljava_nio_ReadOnlyBufferException()
  };
  if ((((offset < 0) || (length < 0)) || (offset > ((src.u.length - length) | 0)))) {
    throw $ct_jl_IndexOutOfBoundsException__(new $c_jl_IndexOutOfBoundsException())
  };
  var p = this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position;
  var newPos = ((p + length) | 0);
  if ((newPos > this.Ljava_nio_Buffer__f__limit)) {
    throw new $c_Ljava_nio_BufferOverflowException()
  };
  this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position = newPos;
  var dest = this.Ljava_nio_ByteBuffer__f__array;
  var destPos = ((this.Ljava_nio_ByteBuffer__f__arrayOffset + p) | 0);
  $systemArraycopy(src, offset, dest, destPos, length);
  return this
});
var $d_Ljava_nio_HeapByteBuffer = new $TypeData().initClass({
  Ljava_nio_HeapByteBuffer: 0
}, false, "java.nio.HeapByteBuffer", {
  Ljava_nio_HeapByteBuffer: 1,
  Ljava_nio_ByteBuffer: 1,
  Ljava_nio_Buffer: 1,
  O: 1,
  jl_Comparable: 1
});
$c_Ljava_nio_HeapByteBuffer.prototype.$classData = $d_Ljava_nio_HeapByteBuffer;
/** @constructor */
function $c_Ljava_nio_charset_CoderMalfunctionError(cause) {
  this.jl_Throwable__f_s = null;
  this.jl_Throwable__f_e = null;
  this.jl_Throwable__f_enableSuppression = false;
  this.jl_Throwable__f_writableStackTrace = false;
  this.jl_Throwable__f_stackTraceStateInternal = null;
  this.jl_Throwable__f_stackTrace = null;
  this.jl_Throwable__f_suppressed = null;
  $ct_jl_Error__jl_Throwable__(this, cause)
}
$c_Ljava_nio_charset_CoderMalfunctionError.prototype = new $h_jl_Error();
$c_Ljava_nio_charset_CoderMalfunctionError.prototype.constructor = $c_Ljava_nio_charset_CoderMalfunctionError;
/** @constructor */
function $h_Ljava_nio_charset_CoderMalfunctionError() {
  /*<skip>*/
}
$h_Ljava_nio_charset_CoderMalfunctionError.prototype = $c_Ljava_nio_charset_CoderMalfunctionError.prototype;
var $d_Ljava_nio_charset_CoderMalfunctionError = new $TypeData().initClass({
  Ljava_nio_charset_CoderMalfunctionError: 0
}, false, "java.nio.charset.CoderMalfunctionError", {
  Ljava_nio_charset_CoderMalfunctionError: 1,
  jl_Error: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_nio_charset_CoderMalfunctionError.prototype.$classData = $d_Ljava_nio_charset_CoderMalfunctionError;
function $p_ju_Formatter__sendToDest__T__V($thiz, s) {
  if (($thiz.ju_Formatter__f_dest === null)) {
    $thiz.ju_Formatter__f_stringOutput = (("" + $thiz.ju_Formatter__f_stringOutput) + s)
  } else {
    $p_ju_Formatter__sendToDestSlowPath__sjs_js_Array__V($thiz, [s])
  }
}
function $p_ju_Formatter__sendToDest__T__T__V($thiz, s1, s2) {
  if (($thiz.ju_Formatter__f_dest === null)) {
    $thiz.ju_Formatter__f_stringOutput = ((("" + $thiz.ju_Formatter__f_stringOutput) + s1) + s2)
  } else {
    $p_ju_Formatter__sendToDestSlowPath__sjs_js_Array__V($thiz, [s1, s2])
  }
}
function $p_ju_Formatter__sendToDest__T__T__T__V($thiz, s1, s2, s3) {
  if (($thiz.ju_Formatter__f_dest === null)) {
    $thiz.ju_Formatter__f_stringOutput = (($thiz.ju_Formatter__f_stringOutput + (("" + s1) + s2)) + s3)
  } else {
    $p_ju_Formatter__sendToDestSlowPath__sjs_js_Array__V($thiz, [s1, s2, s3])
  }
}
function $p_ju_Formatter__sendToDestSlowPath__sjs_js_Array__V($thiz, ss) {
  try {
    var len = $uI(ss.length);
    var i = 0;
    while ((i < len)) {
      var arg1 = ss[i];
      var x$1 = $as_T(arg1);
      $thiz.ju_Formatter__f_dest.append__jl_CharSequence__jl_Appendable(x$1);
      i = ((1 + i) | 0)
    }
  } catch (e) {
    if ((e instanceof $c_Ljava_io_IOException)) {
      var th = $as_Ljava_io_IOException(e);
      $thiz.ju_Formatter__f_java$util$Formatter$$lastIOException = th
    } else {
      throw e
    }
  }
}
function $p_ju_Formatter__format__ju_Formatter$LocaleInfo__T__AO__ju_Formatter($thiz, localeInfo, format, args) {
  if ($thiz.ju_Formatter__f_java$util$Formatter$$closed) {
    throw new $c_ju_FormatterClosedException()
  };
  var lastImplicitArgIndex = 0;
  var lastArgIndex = 0;
  var fmtLength = $uI(format.length);
  var fmtIndex = 0;
  while ((fmtIndex !== fmtLength)) {
    var fromIndex = fmtIndex;
    var nextPercentIndex = $uI(format.indexOf("%", fromIndex));
    if ((nextPercentIndex < 0)) {
      var beginIndex = fmtIndex;
      $p_ju_Formatter__sendToDest__T__V($thiz, $as_T(format.substring(beginIndex)));
      return $thiz
    };
    var beginIndex$1 = fmtIndex;
    $p_ju_Formatter__sendToDest__T__V($thiz, $as_T(format.substring(beginIndex$1, nextPercentIndex)));
    var formatSpecifierIndex = ((1 + nextPercentIndex) | 0);
    var re = $m_ju_Formatter$().ju_Formatter$__f_java$util$Formatter$$FormatSpecifier;
    re.lastIndex = formatSpecifierIndex;
    var execResult = re.exec(format);
    if (((execResult === null) || ($uI(execResult.index) !== formatSpecifierIndex))) {
      var conversion = ((formatSpecifierIndex === fmtLength) ? 37 : (65535 & $uI(format.charCodeAt(formatSpecifierIndex))));
      $p_ju_Formatter__throwUnknownFormatConversionException__C__E($thiz, conversion)
    };
    fmtIndex = $uI(re.lastIndex);
    var index = (((-1) + fmtIndex) | 0);
    var conversion$2 = (65535 & $uI(format.charCodeAt(index)));
    var flags = $p_ju_Formatter__parseFlags__T__C__I($thiz, $as_T(execResult[2]), conversion$2);
    var width = $p_ju_Formatter__parsePositiveIntSilent__sjs_js_$bar__I__I($thiz, execResult[3], (-1));
    var precision = $p_ju_Formatter__parsePositiveIntSilent__sjs_js_$bar__I__I($thiz, execResult[4], (-1));
    if ((conversion$2 === 110)) {
      if ((precision !== (-1))) {
        $p_ju_Formatter__throwIllegalFormatPrecisionException__I__E($thiz, precision)
      };
      if ((width !== (-1))) {
        $p_ju_Formatter__throwIllegalFormatWidthException__I__E($thiz, width)
      };
      if ((flags !== 0)) {
        $thiz.java$util$Formatter$$throwIllegalFormatFlagsException__I__E(flags)
      };
      $p_ju_Formatter__sendToDest__T__V($thiz, "\n")
    } else if ((conversion$2 === 37)) {
      if ((precision !== (-1))) {
        $p_ju_Formatter__throwIllegalFormatPrecisionException__I__E($thiz, precision)
      };
      if ((((17 & flags) === 17) || ((12 & flags) === 12))) {
        $thiz.java$util$Formatter$$throwIllegalFormatFlagsException__I__E(flags)
      };
      if ((((1 & flags) !== 0) && (width === (-1)))) {
        $p_ju_Formatter__throwMissingFormatWidthException__T__E($thiz, $p_ju_Formatter__fullFormatSpecifier$1__sjs_js_RegExp$ExecResult__T($thiz, execResult))
      };
      if ((((-2) & flags) !== 0)) {
        $thiz.java$util$Formatter$$throwFormatFlagsConversionMismatchException__C__I__I__E(37, flags, (-2))
      };
      $p_ju_Formatter__padAndSendToDestNoZeroPad__I__I__T__V($thiz, flags, width, "%")
    } else {
      var conversionLower = (((256 & flags) !== 0) ? (65535 & ((32 + conversion$2) | 0)) : conversion$2);
      var illegalFlags = $m_ju_Formatter$().ju_Formatter$__f_java$util$Formatter$$ConversionsIllegalFlags.get((((-97) + conversionLower) | 0));
      if (((illegalFlags === (-1)) || (((256 & flags) & illegalFlags) !== 0))) {
        $p_ju_Formatter__throwUnknownFormatConversionException__C__E($thiz, conversion$2)
      };
      if ((((17 & flags) !== 0) && (width === (-1)))) {
        $p_ju_Formatter__throwMissingFormatWidthException__T__E($thiz, $p_ju_Formatter__fullFormatSpecifier$1__sjs_js_RegExp$ExecResult__T($thiz, execResult))
      };
      if ((((17 & flags) === 17) || ((12 & flags) === 12))) {
        $thiz.java$util$Formatter$$throwIllegalFormatFlagsException__I__E(flags)
      };
      if (((precision !== (-1)) && ((512 & illegalFlags) !== 0))) {
        $p_ju_Formatter__throwIllegalFormatPrecisionException__I__E($thiz, precision)
      };
      if (((flags & illegalFlags) !== 0)) {
        $thiz.java$util$Formatter$$throwFormatFlagsConversionMismatchException__C__I__I__E(conversionLower, flags, illegalFlags)
      };
      if (((128 & flags) !== 0)) {
        var argIndex = lastArgIndex
      } else {
        var i = $p_ju_Formatter__parsePositiveIntSilent__sjs_js_$bar__I__I($thiz, execResult[1], 0);
        if ((i === 0)) {
          lastImplicitArgIndex = ((1 + lastImplicitArgIndex) | 0);
          var argIndex = lastImplicitArgIndex
        } else {
          var argIndex = ((i < 0) ? lastArgIndex : i)
        }
      };
      if (((argIndex <= 0) || (argIndex > args.u.length))) {
        $p_ju_Formatter__throwMissingFormatArgumentException__T__E($thiz, $p_ju_Formatter__fullFormatSpecifier$1__sjs_js_RegExp$ExecResult__T($thiz, execResult))
      };
      lastArgIndex = argIndex;
      var arg = args.get((((-1) + argIndex) | 0));
      if ((((arg === null) && (conversionLower !== 98)) && (conversionLower !== 115))) {
        $p_ju_Formatter__formatNonNumericString__ju_Formatter$LocaleInfo__I__I__I__T__V($thiz, $m_ju_Formatter$RootLocaleInfo$(), flags, width, precision, "null")
      } else {
        $p_ju_Formatter__formatArg__ju_Formatter$LocaleInfo__O__C__I__I__I__V($thiz, localeInfo, arg, conversionLower, flags, width, precision)
      }
    }
  };
  return $thiz
}
function $p_ju_Formatter__parseFlags__T__C__I($thiz, flags, conversion) {
  var bits = (((conversion >= 65) && (conversion <= 90)) ? 256 : 0);
  var len = $uI(flags.length);
  var i = 0;
  while ((i !== len)) {
    var index = i;
    var f = (65535 & $uI(flags.charCodeAt(index)));
    switch (f) {
      case 45: {
        var bit = 1;
        break
      }
      case 35: {
        var bit = 2;
        break
      }
      case 43: {
        var bit = 4;
        break
      }
      case 32: {
        var bit = 8;
        break
      }
      case 48: {
        var bit = 16;
        break
      }
      case 44: {
        var bit = 32;
        break
      }
      case 40: {
        var bit = 64;
        break
      }
      case 60: {
        var bit = 128;
        break
      }
      default: {
        var bit;
        throw new $c_s_MatchError($bC(f))
      }
    };
    if (((bits & bit) !== 0)) {
      $p_ju_Formatter__throwDuplicateFormatFlagsException__C__E($thiz, f)
    };
    bits = (bits | bit);
    i = ((1 + i) | 0)
  };
  return bits
}
function $p_ju_Formatter__parsePositiveIntSilent__sjs_js_$bar__I__I($thiz, capture, default$1) {
  if ((capture === (void 0))) {
    return default$1
  } else {
    var s = $as_T(capture);
    var x = $uD(parseInt(s, 10));
    return ((x <= 2.147483647E9) ? $doubleToInt(x) : (-1))
  }
}
function $p_ju_Formatter__formatArg__ju_Formatter$LocaleInfo__O__C__I__I__I__V($thiz, localeInfo, arg, conversionLower, flags, width, precision) {
  switch (conversionLower) {
    case 98: {
      var str = (((arg === false) || (arg === null)) ? "false" : "true");
      $p_ju_Formatter__formatNonNumericString__ju_Formatter$LocaleInfo__I__I__I__T__V($thiz, $m_ju_Formatter$RootLocaleInfo$(), flags, width, precision, str);
      break
    }
    case 104: {
      var i = $dp_hashCode__I(arg);
      var str$2 = $as_T($uD((i >>> 0)).toString(16));
      $p_ju_Formatter__formatNonNumericString__ju_Formatter$LocaleInfo__I__I__I__T__V($thiz, $m_ju_Formatter$RootLocaleInfo$(), flags, width, precision, str$2);
      break
    }
    case 115: {
      if ($is_ju_Formattable(arg)) {
        var x2 = $as_ju_Formattable(arg);
        var formattableFlags = (((((1 & flags) !== 0) ? 1 : 0) | (((2 & flags) !== 0) ? 4 : 0)) | (((256 & flags) !== 0) ? 2 : 0));
        x2.formatTo__ju_Formatter__I__I__I__V($thiz, formattableFlags, width, precision)
      } else {
        if (((2 & flags) !== 0)) {
          $thiz.java$util$Formatter$$throwFormatFlagsConversionMismatchException__C__I__I__E(conversionLower, flags, 2)
        };
        var str$3 = ("" + arg);
        $p_ju_Formatter__formatNonNumericString__ju_Formatter$LocaleInfo__I__I__I__T__V($thiz, localeInfo, flags, width, precision, str$3)
      };
      break
    }
    case 99: {
      if ((arg instanceof $Char)) {
        var x2$2 = $uC(arg);
        var str$4 = $as_T(String.fromCharCode(x2$2))
      } else {
        if ((!$isInt(arg))) {
          $thiz.java$util$Formatter$$throwIllegalFormatConversionException__C__O__E(conversionLower, arg)
        };
        var x3 = $uI(arg);
        if ((!((x3 >= 0) && (x3 <= 1114111)))) {
          $p_ju_Formatter__throwIllegalFormatCodePointException__I__E($thiz, x3)
        };
        if ((x3 < 65536)) {
          var str$4 = $as_T(String.fromCharCode(x3))
        } else {
          var $$x2 = String;
          var value = (55296 | (((-64) + (x3 >> 10)) | 0));
          var value$1 = (56320 | (1023 & x3));
          var $$x1 = $$x2.fromCharCode(value, value$1);
          var str$4 = $as_T($$x1)
        }
      };
      $p_ju_Formatter__formatNonNumericString__ju_Formatter$LocaleInfo__I__I__I__T__V($thiz, localeInfo, flags, width, (-1), str$4);
      break
    }
    case 100: {
      if ($isInt(arg)) {
        var x2$3 = $uI(arg);
        var str$5 = ("" + x2$3)
      } else if ((arg instanceof $c_RTLong)) {
        var t = $uJ(arg);
        var lo = t.RTLong__f_lo;
        var hi = t.RTLong__f_hi;
        var str$5 = $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toString__I__I__T(lo, hi)
      } else {
        if ((!(arg instanceof $c_Ljava_math_BigInteger))) {
          $thiz.java$util$Formatter$$throwIllegalFormatConversionException__C__O__E(conversionLower, arg)
        };
        var x4 = $as_Ljava_math_BigInteger(arg);
        var str$5 = $m_Ljava_math_Conversion$().toDecimalScaledString__Ljava_math_BigInteger__T(x4)
      };
      $p_ju_Formatter__formatNumericString__ju_Formatter$LocaleInfo__I__I__T__T__V($thiz, localeInfo, flags, width, str$5, "");
      break
    }
    case 111:
    case 120: {
      var isOctal = (conversionLower === 111);
      var prefix = (((2 & flags) === 0) ? "" : (isOctal ? "0" : (((256 & flags) !== 0) ? "0X" : "0x")));
      if ((arg instanceof $c_Ljava_math_BigInteger)) {
        var x2$4 = $as_Ljava_math_BigInteger(arg);
        var radix = (isOctal ? 8 : 16);
        $p_ju_Formatter__formatNumericString__ju_Formatter$LocaleInfo__I__I__T__T__V($thiz, $m_ju_Formatter$RootLocaleInfo$(), flags, width, $m_Ljava_math_Conversion$().bigInteger2String__Ljava_math_BigInteger__I__T(x2$4, radix), prefix)
      } else {
        if ($isInt(arg)) {
          var x2$5 = $uI(arg);
          var str$6 = (isOctal ? $as_T($uD((x2$5 >>> 0)).toString(8)) : $as_T($uD((x2$5 >>> 0)).toString(16)))
        } else {
          if ((!(arg instanceof $c_RTLong))) {
            $thiz.java$util$Formatter$$throwIllegalFormatConversionException__C__O__E(conversionLower, arg)
          };
          var t$1 = $uJ(arg);
          var lo$1 = t$1.RTLong__f_lo;
          var hi$1 = t$1.RTLong__f_hi;
          if (isOctal) {
            var this$17 = $m_jl_Long$();
            var str$6 = this$17.java$lang$Long$$toOctalString__I__I__T(lo$1, hi$1)
          } else {
            var this$18 = $m_jl_Long$();
            var str$6 = this$18.java$lang$Long$$toHexString__I__I__T(lo$1, hi$1)
          }
        };
        if (((76 & flags) !== 0)) {
          $thiz.java$util$Formatter$$throwFormatFlagsConversionMismatchException__C__I__I__E(conversionLower, flags, 76)
        };
        $p_ju_Formatter__padAndSendToDest__ju_Formatter$LocaleInfo__I__I__T__T__V($thiz, $m_ju_Formatter$RootLocaleInfo$(), flags, width, prefix, $p_ju_Formatter__applyNumberUpperCase__I__T__T($thiz, flags, str$6))
      };
      break
    }
    case 101:
    case 102:
    case 103: {
      if (((typeof arg) === "number")) {
        var x2$6 = $uD(arg);
        if (((x2$6 !== x2$6) || ((x2$6 === Infinity) || (x2$6 === (-Infinity))))) {
          $p_ju_Formatter__formatNaNOrInfinite__I__I__D__V($thiz, flags, width, x2$6)
        } else {
          $p_ju_Formatter__formatDecimal$1__ju_Formatter$Decimal__I__I__C__ju_Formatter$LocaleInfo__I__V($thiz, $m_ju_Formatter$().java$util$Formatter$$numberToDecimal__D__ju_Formatter$Decimal(x2$6), flags, precision, conversionLower, localeInfo, width)
        }
      } else if ((arg instanceof $c_Ljava_math_BigDecimal)) {
        var x3$4 = $as_Ljava_math_BigDecimal(arg);
        $p_ju_Formatter__formatDecimal$1__ju_Formatter$Decimal__I__I__C__ju_Formatter$LocaleInfo__I__V($thiz, $m_ju_Formatter$().java$util$Formatter$$bigDecimalToDecimal__Ljava_math_BigDecimal__ju_Formatter$Decimal(x3$4), flags, precision, conversionLower, localeInfo, width)
      } else {
        $thiz.java$util$Formatter$$throwIllegalFormatConversionException__C__O__E(conversionLower, arg)
      };
      break
    }
    case 97: {
      if (((typeof arg) === "number")) {
        var x2$7 = $uD(arg);
        $p_ju_Formatter__formatHexFloatingPoint__I__I__I__D__V($thiz, flags, width, precision, x2$7)
      } else {
        $thiz.java$util$Formatter$$throwIllegalFormatConversionException__C__O__E(conversionLower, arg)
      };
      break
    }
    default: {
      throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), (("Unknown conversion '" + $bC(conversionLower)) + "' was not rejected earlier"))
    }
  }
}
function $p_ju_Formatter__flagsToString__I__T($thiz, flags) {
  return ((((((((((1 & flags) !== 0) ? "-" : "") + (((2 & flags) !== 0) ? "#" : "")) + (((4 & flags) !== 0) ? "+" : "")) + (((8 & flags) !== 0) ? " " : "")) + (((16 & flags) !== 0) ? "0" : "")) + (((32 & flags) !== 0) ? "," : "")) + (((64 & flags) !== 0) ? "(" : "")) + (((128 & flags) !== 0) ? "<" : ""))
}
function $p_ju_Formatter__computerizedScientificNotation__ju_Formatter$Decimal__I__Z__T($thiz, x, digitsAfterDot, forceDecimalSep) {
  var rounded = x.round__I__ju_Formatter$Decimal(((1 + digitsAfterDot) | 0));
  var signStr = (rounded.ju_Formatter$Decimal__f_negative ? "-" : "");
  var intStr = rounded.ju_Formatter$Decimal__f_unscaledValue;
  var fractionalDigitCount = (((-1) + $uI(intStr.length)) | 0);
  var missingZeros = ((digitsAfterDot - fractionalDigitCount) | 0);
  var integerPart = $as_T(intStr.substring(0, 1));
  var fractionalPart = (("" + $as_T(intStr.substring(1))) + $m_ju_Formatter$().java$util$Formatter$$strOfZeros__I__T(missingZeros));
  var significandStr = (((fractionalPart === "") && (!forceDecimalSep)) ? integerPart : ((integerPart + ".") + fractionalPart));
  var exponent = ((fractionalDigitCount - rounded.ju_Formatter$Decimal__f_scale) | 0);
  var exponentSign = ((exponent < 0) ? "-" : "+");
  var this$3 = ((exponent < 0) ? ((-exponent) | 0) : exponent);
  var exponentAbsStr0 = ("" + this$3);
  var exponentAbsStr = (($uI(exponentAbsStr0.length) === 1) ? ("0" + exponentAbsStr0) : exponentAbsStr0);
  return ((((signStr + significandStr) + "e") + exponentSign) + exponentAbsStr)
}
function $p_ju_Formatter__decimalNotation__ju_Formatter$Decimal__I__Z__T($thiz, x, scale, forceDecimalSep) {
  var rounded = x.setScale__I__ju_Formatter$Decimal(scale);
  var signStr = (rounded.ju_Formatter$Decimal__f_negative ? "-" : "");
  var intStr = rounded.ju_Formatter$Decimal__f_unscaledValue;
  var intStrLen = $uI(intStr.length);
  var minDigits = ((1 + scale) | 0);
  var expandedIntStr = ((intStrLen >= minDigits) ? intStr : (("" + $m_ju_Formatter$().java$util$Formatter$$strOfZeros__I__T(((minDigits - intStrLen) | 0))) + intStr));
  var dotPos = (($uI(expandedIntStr.length) - scale) | 0);
  var integerPart = (signStr + $as_T(expandedIntStr.substring(0, dotPos)));
  return (((scale === 0) && (!forceDecimalSep)) ? integerPart : ((integerPart + ".") + $as_T(expandedIntStr.substring(dotPos))))
}
function $p_ju_Formatter__generalScientificNotation__ju_Formatter$Decimal__I__Z__T($thiz, x, precision, forceDecimalSep) {
  var p = ((precision === 0) ? 1 : precision);
  var rounded = x.round__I__ju_Formatter$Decimal(p);
  var this$1 = rounded.ju_Formatter$Decimal__f_unscaledValue;
  var orderOfMagnitude = (((((-1) + $uI(this$1.length)) | 0) - rounded.ju_Formatter$Decimal__f_scale) | 0);
  if (((orderOfMagnitude >= (-4)) && (orderOfMagnitude < p))) {
    var b = (((-1) + ((p - orderOfMagnitude) | 0)) | 0);
    return $p_ju_Formatter__decimalNotation__ju_Formatter$Decimal__I__Z__T($thiz, rounded, ((b < 0) ? 0 : b), forceDecimalSep)
  } else {
    return $p_ju_Formatter__computerizedScientificNotation__ju_Formatter$Decimal__I__Z__T($thiz, rounded, (((-1) + p) | 0), forceDecimalSep)
  }
}
function $p_ju_Formatter__formatHexFloatingPoint__I__I__I__D__V($thiz, flags, width, precision, arg) {
  if (((arg !== arg) || ((arg === Infinity) || (arg === (-Infinity))))) {
    $p_ju_Formatter__formatNaNOrInfinite__I__I__D__V($thiz, flags, width, arg)
  } else {
    var t = $m_jl_FloatingPointBits$().doubleToLongBits__D__J(arg);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var negative = (hi < 0);
    var hi$1 = (1048575 & hi);
    var lo$1 = ((hi >>> 20) | 0);
    var biasedExponent = (2047 & lo$1);
    var actualPrecision = ((precision === 0) ? 1 : ((precision > 12) ? (-1) : precision));
    var signStr = (negative ? "-" : (((4 & flags) !== 0) ? "+" : (((8 & flags) !== 0) ? " " : "")));
    if ((biasedExponent === 0)) {
      if (((lo === 0) && (hi$1 === 0))) {
        var x1___1 = "0";
        var x1___2 = $L0;
        var x1___3 = 0
      } else if ((actualPrecision === (-1))) {
        var x1___1 = "0";
        var x1___2 = new $c_RTLong(lo, hi$1);
        var x1___3 = (-1022)
      } else {
        var leadingZeros = ((hi$1 !== 0) ? $clz32(hi$1) : ((32 + $clz32(lo)) | 0));
        var shift = (((-11) + leadingZeros) | 0);
        var lo$2 = (((32 & shift) === 0) ? (lo << shift) : 0);
        var hi$2 = (((32 & shift) === 0) ? (((((lo >>> 1) | 0) >>> ((31 - shift) | 0)) | 0) | (hi$1 << shift)) : (lo << shift));
        var hi$3 = (1048575 & hi$2);
        var normalizedExponent = (((-1022) - shift) | 0);
        var x1___1 = "1";
        var x1___2 = new $c_RTLong(lo$2, hi$3);
        var x1___3 = normalizedExponent
      }
    } else {
      var _3 = (((-1023) + biasedExponent) | 0);
      var x1___1 = "1";
      var x1___2 = new $c_RTLong(lo, hi$1);
      var x1___3 = _3
    };
    var implicitBitStr = $as_T(x1___1);
    var t$1 = $uJ(x1___2);
    var lo$3 = t$1.RTLong__f_lo;
    var hi$4 = t$1.RTLong__f_hi;
    var exponent = $uI(x1___3);
    var t$2 = $uJ(new $c_RTLong(lo$3, hi$4));
    var lo$4 = t$2.RTLong__f_lo;
    var hi$5 = t$2.RTLong__f_hi;
    if ((actualPrecision === (-1))) {
      var roundedMantissa__lo = lo$4;
      var roundedMantissa__hi = hi$5
    } else {
      var n = ((52 - (actualPrecision << 2)) | 0);
      var lo$5 = (((32 & n) === 0) ? (1 << n) : 0);
      var hi$6 = (((32 & n) === 0) ? 0 : (1 << n));
      var lo$6 = (((-1) + lo$5) | 0);
      var hi$7 = ((lo$6 !== (-1)) ? hi$6 : (((-1) + hi$6) | 0));
      var lo$7 = (((lo$5 >>> 1) | 0) | (hi$6 << 31));
      var hi$8 = (hi$6 >> 1);
      var lo$8 = (~lo$6);
      var hi$9 = (~hi$7);
      var lo$9 = (lo$4 & lo$8);
      var hi$10 = (hi$5 & hi$9);
      var lo$10 = (lo$4 & lo$6);
      var hi$11 = (hi$5 & hi$7);
      if (((hi$11 === hi$8) ? (((-2147483648) ^ lo$10) < ((-2147483648) ^ lo$7)) : (hi$11 < hi$8))) {
        var roundedMantissa__lo = lo$9;
        var roundedMantissa__hi = hi$10
      } else if (((hi$11 === hi$8) ? (((-2147483648) ^ lo$10) > ((-2147483648) ^ lo$7)) : (hi$11 > hi$8))) {
        var lo$11 = ((lo$9 + lo$5) | 0);
        var hi$12 = ((((-2147483648) ^ lo$11) < ((-2147483648) ^ lo$9)) ? ((1 + ((hi$10 + hi$6) | 0)) | 0) : ((hi$10 + hi$6) | 0));
        var roundedMantissa__lo = lo$11;
        var roundedMantissa__hi = hi$12
      } else {
        var lo$12 = (lo$9 & lo$5);
        var hi$13 = (hi$10 & hi$6);
        if (((lo$12 === 0) && (hi$13 === 0))) {
          var roundedMantissa__lo = lo$9;
          var roundedMantissa__hi = hi$10
        } else {
          var lo$13 = ((lo$9 + lo$5) | 0);
          var hi$14 = ((((-2147483648) ^ lo$13) < ((-2147483648) ^ lo$9)) ? ((1 + ((hi$10 + hi$6) | 0)) | 0) : ((hi$10 + hi$6) | 0));
          var roundedMantissa__lo = lo$13;
          var roundedMantissa__hi = hi$14
        }
      }
    };
    var this$10 = $m_jl_Long$();
    var hi$15 = roundedMantissa__hi;
    var baseStr = this$10.java$lang$Long$$toHexString__I__I__T(roundedMantissa__lo, hi$15);
    var beginIndex = $uI(baseStr.length);
    var padded = (("" + $as_T("0000000000000".substring(beginIndex))) + baseStr);
    $m_ju_Formatter$();
    var condition = ($uI(padded.length) === 13);
    if ((!condition)) {
      throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), "padded mantissa does not have the right number of bits")
    };
    var minLength = ((actualPrecision < 1) ? 1 : actualPrecision);
    var len = $uI(padded.length);
    while (true) {
      if ((len > minLength)) {
        var index = (((-1) + len) | 0);
        var $$x1 = ((65535 & $uI(padded.charCodeAt(index))) === 48)
      } else {
        var $$x1 = false
      };
      if ($$x1) {
        len = (((-1) + len) | 0)
      } else {
        break
      }
    };
    var endIndex = len;
    var mantissaStr = $as_T(padded.substring(0, endIndex));
    var exponentStr = ("" + exponent);
    var prefix = (signStr + (((256 & flags) !== 0) ? "0X" : "0x"));
    var rest = ((((implicitBitStr + ".") + mantissaStr) + "p") + exponentStr);
    $p_ju_Formatter__padAndSendToDest__ju_Formatter$LocaleInfo__I__I__T__T__V($thiz, $m_ju_Formatter$RootLocaleInfo$(), flags, width, prefix, $p_ju_Formatter__applyNumberUpperCase__I__T__T($thiz, flags, rest))
  }
}
function $p_ju_Formatter__formatNonNumericString__ju_Formatter$LocaleInfo__I__I__I__T__V($thiz, localeInfo, flags, width, precision, str) {
  var truncatedStr = ((precision < 0) ? str : $as_T(str.substring(0, precision)));
  $p_ju_Formatter__padAndSendToDestNoZeroPad__I__I__T__V($thiz, flags, width, $p_ju_Formatter__applyUpperCase__ju_Formatter$LocaleInfo__I__T__T($thiz, localeInfo, flags, truncatedStr))
}
function $p_ju_Formatter__formatNaNOrInfinite__I__I__D__V($thiz, flags, width, x) {
  var str = ((x !== x) ? "NaN" : ((x > 0.0) ? (((4 & flags) !== 0) ? "+Infinity" : (((8 & flags) !== 0) ? " Infinity" : "Infinity")) : (((64 & flags) !== 0) ? "(Infinity)" : "-Infinity")));
  $p_ju_Formatter__padAndSendToDestNoZeroPad__I__I__T__V($thiz, flags, width, $p_ju_Formatter__applyNumberUpperCase__I__T__T($thiz, flags, str))
}
function $p_ju_Formatter__formatNumericString__ju_Formatter$LocaleInfo__I__I__T__T__V($thiz, localeInfo, flags, width, str, basePrefix) {
  if ((($uI(str.length) >= width) && ((110 & flags) === 0))) {
    var str$1 = $p_ju_Formatter__applyNumberUpperCase__I__T__T($thiz, flags, str);
    $p_ju_Formatter__sendToDest__T__V($thiz, str$1)
  } else if (((126 & flags) === 0)) {
    $p_ju_Formatter__padAndSendToDestNoZeroPad__I__I__T__V($thiz, flags, width, $p_ju_Formatter__applyNumberUpperCase__I__T__T($thiz, flags, str))
  } else {
    if (((65535 & $uI(str.charCodeAt(0))) !== 45)) {
      if (((4 & flags) !== 0)) {
        var x1___1 = "+";
        var x1___2 = str
      } else if (((8 & flags) !== 0)) {
        var x1___1 = " ";
        var x1___2 = str
      } else {
        var x1___1 = "";
        var x1___2 = str
      }
    } else if (((64 & flags) !== 0)) {
      var _2 = ($as_T(str.substring(1)) + ")");
      var x1___1 = "(";
      var x1___2 = _2
    } else {
      var _2$1 = $as_T(str.substring(1));
      var x1___1 = "-";
      var x1___2 = _2$1
    };
    var numberPrefix = $as_T(x1___1);
    var rest0 = $as_T(x1___2);
    var prefix = (("" + numberPrefix) + basePrefix);
    var rest = (((32 & flags) !== 0) ? $p_ju_Formatter__insertGroupingCommas__ju_Formatter$LocaleInfo__T__T($thiz, localeInfo, rest0) : rest0);
    var str$2 = $p_ju_Formatter__applyNumberUpperCase__I__T__T($thiz, flags, rest);
    $p_ju_Formatter__padAndSendToDest__ju_Formatter$LocaleInfo__I__I__T__T__V($thiz, localeInfo, flags, width, prefix, str$2)
  }
}
function $p_ju_Formatter__insertGroupingCommas__ju_Formatter$LocaleInfo__T__T($thiz, localeInfo, s) {
  var len = $uI(s.length);
  var index = 0;
  while (true) {
    if ((index !== len)) {
      var index$1 = index;
      var c = (65535 & $uI(s.charCodeAt(index$1)));
      var $$x1 = ((c >= 48) && (c <= 57))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      index = ((1 + index) | 0)
    } else {
      break
    }
  };
  index = (((-3) + index) | 0);
  if ((index <= 0)) {
    return s
  } else {
    var beginIndex = index;
    var result = $as_T(s.substring(beginIndex));
    while ((index > 3)) {
      var next = (((-3) + index) | 0);
      var endIndex = index;
      result = (($as_T(s.substring(next, endIndex)) + ",") + result);
      index = next
    };
    var endIndex$1 = index;
    return (($as_T(s.substring(0, endIndex$1)) + ",") + result)
  }
}
function $p_ju_Formatter__applyNumberUpperCase__I__T__T($thiz, flags, str) {
  return (((256 & flags) !== 0) ? $as_T(str.toUpperCase()) : str)
}
function $p_ju_Formatter__applyUpperCase__ju_Formatter$LocaleInfo__I__T__T($thiz, localeInfo, flags, str) {
  return (((256 & flags) !== 0) ? $as_T(str.toUpperCase()) : str)
}
function $p_ju_Formatter__padAndSendToDestNoZeroPad__I__I__T__V($thiz, flags, width, str) {
  var len = $uI(str.length);
  if ((len >= width)) {
    $p_ju_Formatter__sendToDest__T__V($thiz, str)
  } else if (((1 & flags) !== 0)) {
    $p_ju_Formatter__sendToDest__T__T__V($thiz, str, $p_ju_Formatter__strRepeat__T__I__T($thiz, " ", ((width - len) | 0)))
  } else {
    $p_ju_Formatter__sendToDest__T__T__V($thiz, $p_ju_Formatter__strRepeat__T__I__T($thiz, " ", ((width - len) | 0)), str)
  }
}
function $p_ju_Formatter__padAndSendToDest__ju_Formatter$LocaleInfo__I__I__T__T__V($thiz, localeInfo, flags, width, prefix, str) {
  var len = (($uI(prefix.length) + $uI(str.length)) | 0);
  if ((len >= width)) {
    $p_ju_Formatter__sendToDest__T__T__V($thiz, prefix, str)
  } else if (((16 & flags) !== 0)) {
    $p_ju_Formatter__sendToDest__T__T__T__V($thiz, prefix, $p_ju_Formatter__strRepeat__T__I__T($thiz, "0", ((width - len) | 0)), str)
  } else if (((1 & flags) !== 0)) {
    $p_ju_Formatter__sendToDest__T__T__T__V($thiz, prefix, str, $p_ju_Formatter__strRepeat__T__I__T($thiz, " ", ((width - len) | 0)))
  } else {
    $p_ju_Formatter__sendToDest__T__T__T__V($thiz, $p_ju_Formatter__strRepeat__T__I__T($thiz, " ", ((width - len) | 0)), prefix, str)
  }
}
function $p_ju_Formatter__strRepeat__T__I__T($thiz, s, times) {
  var result = "";
  var i = 0;
  while ((i !== times)) {
    result = (("" + result) + s);
    i = ((1 + i) | 0)
  };
  return result
}
function $p_ju_Formatter__throwDuplicateFormatFlagsException__C__E($thiz, flag) {
  throw new $c_ju_DuplicateFormatFlagsException($as_T(String.fromCharCode(flag)))
}
function $p_ju_Formatter__throwUnknownFormatConversionException__C__E($thiz, conversion) {
  throw new $c_ju_UnknownFormatConversionException($as_T(String.fromCharCode(conversion)))
}
function $p_ju_Formatter__throwIllegalFormatPrecisionException__I__E($thiz, precision) {
  throw new $c_ju_IllegalFormatPrecisionException(precision)
}
function $p_ju_Formatter__throwIllegalFormatWidthException__I__E($thiz, width) {
  throw new $c_ju_IllegalFormatWidthException(width)
}
function $p_ju_Formatter__throwMissingFormatWidthException__T__E($thiz, fullFormatSpecifier) {
  throw new $c_ju_MissingFormatWidthException(fullFormatSpecifier)
}
function $p_ju_Formatter__throwMissingFormatArgumentException__T__E($thiz, fullFormatSpecifier) {
  throw new $c_ju_MissingFormatArgumentException(fullFormatSpecifier)
}
function $p_ju_Formatter__throwIllegalFormatCodePointException__I__E($thiz, arg) {
  throw new $c_ju_IllegalFormatCodePointException(arg)
}
function $p_ju_Formatter__fullFormatSpecifier$1__sjs_js_RegExp$ExecResult__T($thiz, execResult$1) {
  return ("%" + execResult$1[0])
}
function $p_ju_Formatter__formatDecimal$1__ju_Formatter$Decimal__I__I__C__ju_Formatter$LocaleInfo__I__V($thiz, x, flags$1, precision$1, conversionLower$1, localeInfo$1, width$1) {
  var forceDecimalSep = ((2 & flags$1) !== 0);
  var actualPrecision = ((precision$1 >= 0) ? precision$1 : 6);
  switch (conversionLower$1) {
    case 101: {
      var notation = $p_ju_Formatter__computerizedScientificNotation__ju_Formatter$Decimal__I__Z__T($thiz, x, actualPrecision, forceDecimalSep);
      break
    }
    case 102: {
      var notation = $p_ju_Formatter__decimalNotation__ju_Formatter$Decimal__I__Z__T($thiz, x, actualPrecision, forceDecimalSep);
      break
    }
    default: {
      var notation = $p_ju_Formatter__generalScientificNotation__ju_Formatter$Decimal__I__Z__T($thiz, x, actualPrecision, forceDecimalSep)
    }
  };
  $p_ju_Formatter__formatNumericString__ju_Formatter$LocaleInfo__I__I__T__T__V($thiz, localeInfo$1, flags$1, width$1, notation, "")
}
function $ct_ju_Formatter__jl_Appendable__ju_Formatter$LocaleInfo__($thiz, dest, formatterLocaleInfo) {
  $thiz.ju_Formatter__f_dest = dest;
  $thiz.ju_Formatter__f_formatterLocaleInfo = formatterLocaleInfo;
  $thiz.ju_Formatter__f_stringOutput = "";
  $thiz.ju_Formatter__f_java$util$Formatter$$closed = false;
  $thiz.ju_Formatter__f_java$util$Formatter$$lastIOException = null;
  return $thiz
}
function $ct_ju_Formatter__($thiz) {
  $ct_ju_Formatter__jl_Appendable__ju_Formatter$LocaleInfo__($thiz, null, $m_ju_Formatter$RootLocaleInfo$());
  return $thiz
}
/** @constructor */
function $c_ju_Formatter() {
  this.ju_Formatter__f_dest = null;
  this.ju_Formatter__f_formatterLocaleInfo = null;
  this.ju_Formatter__f_stringOutput = null;
  this.ju_Formatter__f_java$util$Formatter$$closed = false;
  this.ju_Formatter__f_java$util$Formatter$$lastIOException = null
}
$c_ju_Formatter.prototype = new $h_O();
$c_ju_Formatter.prototype.constructor = $c_ju_Formatter;
/** @constructor */
function $h_ju_Formatter() {
  /*<skip>*/
}
$h_ju_Formatter.prototype = $c_ju_Formatter.prototype;
$c_ju_Formatter.prototype.format__T__AO__ju_Formatter = (function(format, args) {
  return $p_ju_Formatter__format__ju_Formatter$LocaleInfo__T__AO__ju_Formatter(this, this.ju_Formatter__f_formatterLocaleInfo, format, args)
});
$c_ju_Formatter.prototype.toString__T = (function() {
  if (this.ju_Formatter__f_java$util$Formatter$$closed) {
    throw new $c_ju_FormatterClosedException()
  };
  return ((this.ju_Formatter__f_dest === null) ? this.ju_Formatter__f_stringOutput : this.ju_Formatter__f_dest.toString__T())
});
$c_ju_Formatter.prototype.java$util$Formatter$$throwIllegalFormatFlagsException__I__E = (function(flags) {
  throw new $c_ju_IllegalFormatFlagsException($p_ju_Formatter__flagsToString__I__T(this, flags))
});
$c_ju_Formatter.prototype.java$util$Formatter$$throwFormatFlagsConversionMismatchException__C__I__I__E = (function(conversionLower, flags, illegalFlags) {
  throw new $c_ju_FormatFlagsConversionMismatchException($p_ju_Formatter__flagsToString__I__T(this, (flags & illegalFlags)), conversionLower)
});
$c_ju_Formatter.prototype.java$util$Formatter$$throwIllegalFormatConversionException__C__O__E = (function(conversionLower, arg) {
  throw new $c_ju_IllegalFormatConversionException(conversionLower, $objectGetClass(arg))
});
var $d_ju_Formatter = new $TypeData().initClass({
  ju_Formatter: 0
}, false, "java.util.Formatter", {
  ju_Formatter: 1,
  O: 1,
  Ljava_io_Closeable: 1,
  jl_AutoCloseable: 1,
  Ljava_io_Flushable: 1
});
$c_ju_Formatter.prototype.$classData = $d_ju_Formatter;
/** @constructor */
function $c_ju_concurrent_ExecutionException(message, cause) {
  this.jl_Throwable__f_s = null;
  this.jl_Throwable__f_e = null;
  this.jl_Throwable__f_enableSuppression = false;
  this.jl_Throwable__f_writableStackTrace = false;
  this.jl_Throwable__f_stackTraceStateInternal = null;
  this.jl_Throwable__f_stackTrace = null;
  this.jl_Throwable__f_suppressed = null;
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, message, cause, true, true)
}
$c_ju_concurrent_ExecutionException.prototype = new $h_jl_Exception();
$c_ju_concurrent_ExecutionException.prototype.constructor = $c_ju_concurrent_ExecutionException;
/** @constructor */
function $h_ju_concurrent_ExecutionException() {
  /*<skip>*/
}
$h_ju_concurrent_ExecutionException.prototype = $c_ju_concurrent_ExecutionException.prototype;
var $d_ju_concurrent_ExecutionException = new $TypeData().initClass({
  ju_concurrent_ExecutionException: 0
}, false, "java.util.concurrent.ExecutionException", {
  ju_concurrent_ExecutionException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_ju_concurrent_ExecutionException.prototype.$classData = $d_ju_concurrent_ExecutionException;
/** @constructor */
function $c_ju_concurrent_TimeUnit() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0
}
$c_ju_concurrent_TimeUnit.prototype = new $h_jl_Enum();
$c_ju_concurrent_TimeUnit.prototype.constructor = $c_ju_concurrent_TimeUnit;
/** @constructor */
function $h_ju_concurrent_TimeUnit() {
  /*<skip>*/
}
$h_ju_concurrent_TimeUnit.prototype = $c_ju_concurrent_TimeUnit.prototype;
function $as_ju_concurrent_TimeUnit(obj) {
  return (((obj instanceof $c_ju_concurrent_TimeUnit) || (obj === null)) ? obj : $throwClassCastException(obj, "java.util.concurrent.TimeUnit"))
}
function $isArrayOf_ju_concurrent_TimeUnit(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_concurrent_TimeUnit)))
}
function $asArrayOf_ju_concurrent_TimeUnit(obj, depth) {
  return (($isArrayOf_ju_concurrent_TimeUnit(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.util.concurrent.TimeUnit;", depth))
}
var $d_ju_concurrent_TimeUnit = new $TypeData().initClass({
  ju_concurrent_TimeUnit: 0
}, false, "java.util.concurrent.TimeUnit", {
  ju_concurrent_TimeUnit: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1
});
$c_ju_concurrent_TimeUnit.prototype.$classData = $d_ju_concurrent_TimeUnit;
/** @constructor */
function $c_RTLong(lo, hi) {
  this.RTLong__f_lo = 0;
  this.RTLong__f_hi = 0;
  this.RTLong__f_lo = lo;
  this.RTLong__f_hi = hi
}
$c_RTLong.prototype = new $h_jl_Number();
$c_RTLong.prototype.constructor = $c_RTLong;
/** @constructor */
function $h_RTLong() {
  /*<skip>*/
}
$h_RTLong.prototype = $c_RTLong.prototype;
$c_RTLong.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_RTLong)) {
    var x2 = $as_RTLong(that);
    return ((this.RTLong__f_lo === x2.RTLong__f_lo) && (this.RTLong__f_hi === x2.RTLong__f_hi))
  } else {
    return false
  }
});
$c_RTLong.prototype.hashCode__I = (function() {
  return (this.RTLong__f_lo ^ this.RTLong__f_hi)
});
$c_RTLong.prototype.toString__T = (function() {
  return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toString__I__I__T(this.RTLong__f_lo, this.RTLong__f_hi)
});
$c_RTLong.prototype.toInt__I = (function() {
  return this.RTLong__f_lo
});
$c_RTLong.prototype.toDouble__D = (function() {
  return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toDouble__I__I__D(this.RTLong__f_lo, this.RTLong__f_hi)
});
$c_RTLong.prototype.byteValue__B = (function() {
  return ((this.RTLong__f_lo << 24) >> 24)
});
$c_RTLong.prototype.shortValue__S = (function() {
  return ((this.RTLong__f_lo << 16) >> 16)
});
$c_RTLong.prototype.intValue__I = (function() {
  return this.RTLong__f_lo
});
$c_RTLong.prototype.longValue__J = (function() {
  return $uJ(this)
});
$c_RTLong.prototype.floatValue__F = (function() {
  return $fround($m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toDouble__I__I__D(this.RTLong__f_lo, this.RTLong__f_hi))
});
$c_RTLong.prototype.doubleValue__D = (function() {
  return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toDouble__I__I__D(this.RTLong__f_lo, this.RTLong__f_hi)
});
$c_RTLong.prototype.compareTo__jl_Long__I = (function(that) {
  return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$compare__I__I__I__I__I(this.RTLong__f_lo, this.RTLong__f_hi, that.RTLong__f_lo, that.RTLong__f_hi)
});
$c_RTLong.prototype.equals__RTLong__Z = (function(b) {
  return ((this.RTLong__f_lo === b.RTLong__f_lo) && (this.RTLong__f_hi === b.RTLong__f_hi))
});
$c_RTLong.prototype.notEquals__RTLong__Z = (function(b) {
  return (!((this.RTLong__f_lo === b.RTLong__f_lo) && (this.RTLong__f_hi === b.RTLong__f_hi)))
});
$c_RTLong.prototype.$less__RTLong__Z = (function(b) {
  var ahi = this.RTLong__f_hi;
  var bhi = b.RTLong__f_hi;
  return ((ahi === bhi) ? (((-2147483648) ^ this.RTLong__f_lo) < ((-2147483648) ^ b.RTLong__f_lo)) : (ahi < bhi))
});
$c_RTLong.prototype.$less$eq__RTLong__Z = (function(b) {
  var ahi = this.RTLong__f_hi;
  var bhi = b.RTLong__f_hi;
  return ((ahi === bhi) ? (((-2147483648) ^ this.RTLong__f_lo) <= ((-2147483648) ^ b.RTLong__f_lo)) : (ahi < bhi))
});
$c_RTLong.prototype.$greater__RTLong__Z = (function(b) {
  var ahi = this.RTLong__f_hi;
  var bhi = b.RTLong__f_hi;
  return ((ahi === bhi) ? (((-2147483648) ^ this.RTLong__f_lo) > ((-2147483648) ^ b.RTLong__f_lo)) : (ahi > bhi))
});
$c_RTLong.prototype.$greater$eq__RTLong__Z = (function(b) {
  var ahi = this.RTLong__f_hi;
  var bhi = b.RTLong__f_hi;
  return ((ahi === bhi) ? (((-2147483648) ^ this.RTLong__f_lo) >= ((-2147483648) ^ b.RTLong__f_lo)) : (ahi > bhi))
});
$c_RTLong.prototype.unary_$tilde__RTLong = (function() {
  return new $c_RTLong((~this.RTLong__f_lo), (~this.RTLong__f_hi))
});
$c_RTLong.prototype.$bar__RTLong__RTLong = (function(b) {
  return new $c_RTLong((this.RTLong__f_lo | b.RTLong__f_lo), (this.RTLong__f_hi | b.RTLong__f_hi))
});
$c_RTLong.prototype.$amp__RTLong__RTLong = (function(b) {
  return new $c_RTLong((this.RTLong__f_lo & b.RTLong__f_lo), (this.RTLong__f_hi & b.RTLong__f_hi))
});
$c_RTLong.prototype.$up__RTLong__RTLong = (function(b) {
  return new $c_RTLong((this.RTLong__f_lo ^ b.RTLong__f_lo), (this.RTLong__f_hi ^ b.RTLong__f_hi))
});
$c_RTLong.prototype.$less$less__I__RTLong = (function(n) {
  var lo = this.RTLong__f_lo;
  return new $c_RTLong((((32 & n) === 0) ? (lo << n) : 0), (((32 & n) === 0) ? (((((lo >>> 1) | 0) >>> ((31 - n) | 0)) | 0) | (this.RTLong__f_hi << n)) : (lo << n)))
});
$c_RTLong.prototype.$greater$greater$greater__I__RTLong = (function(n) {
  var hi = this.RTLong__f_hi;
  return new $c_RTLong((((32 & n) === 0) ? (((this.RTLong__f_lo >>> n) | 0) | ((hi << 1) << ((31 - n) | 0))) : ((hi >>> n) | 0)), (((32 & n) === 0) ? ((hi >>> n) | 0) : 0))
});
$c_RTLong.prototype.$greater$greater__I__RTLong = (function(n) {
  var hi = this.RTLong__f_hi;
  return new $c_RTLong((((32 & n) === 0) ? (((this.RTLong__f_lo >>> n) | 0) | ((hi << 1) << ((31 - n) | 0))) : (hi >> n)), (((32 & n) === 0) ? (hi >> n) : (hi >> 31)))
});
$c_RTLong.prototype.unary_$minus__RTLong = (function() {
  var lo = this.RTLong__f_lo;
  var hi = this.RTLong__f_hi;
  return new $c_RTLong(((-lo) | 0), ((lo !== 0) ? (~hi) : ((-hi) | 0)))
});
$c_RTLong.prototype.$plus__RTLong__RTLong = (function(b) {
  var alo = this.RTLong__f_lo;
  var ahi = this.RTLong__f_hi;
  var bhi = b.RTLong__f_hi;
  var lo = ((alo + b.RTLong__f_lo) | 0);
  return new $c_RTLong(lo, ((((-2147483648) ^ lo) < ((-2147483648) ^ alo)) ? ((1 + ((ahi + bhi) | 0)) | 0) : ((ahi + bhi) | 0)))
});
$c_RTLong.prototype.$minus__RTLong__RTLong = (function(b) {
  var alo = this.RTLong__f_lo;
  var ahi = this.RTLong__f_hi;
  var bhi = b.RTLong__f_hi;
  var lo = ((alo - b.RTLong__f_lo) | 0);
  return new $c_RTLong(lo, ((((-2147483648) ^ lo) > ((-2147483648) ^ alo)) ? (((-1) + ((ahi - bhi) | 0)) | 0) : ((ahi - bhi) | 0)))
});
$c_RTLong.prototype.$times__RTLong__RTLong = (function(b) {
  var alo = this.RTLong__f_lo;
  var blo = b.RTLong__f_lo;
  var a0 = (65535 & alo);
  var a1 = ((alo >>> 16) | 0);
  var b0 = (65535 & blo);
  var b1 = ((blo >>> 16) | 0);
  var a0b0 = $imul(a0, b0);
  var a1b0 = $imul(a1, b0);
  var a0b1 = $imul(a0, b1);
  var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi = (((((((($imul(alo, b.RTLong__f_hi) + $imul(this.RTLong__f_hi, blo)) | 0) + $imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  return new $c_RTLong(lo, hi)
});
$c_RTLong.prototype.$div__RTLong__RTLong = (function(b) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(this.RTLong__f_lo, this.RTLong__f_hi, b.RTLong__f_lo, b.RTLong__f_hi);
  return new $c_RTLong(lo, this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn)
});
$c_RTLong.prototype.$percent__RTLong__RTLong = (function(b) {
  var this$1 = $m_RTLong$();
  var lo = this$1.remainderImpl__I__I__I__I__I(this.RTLong__f_lo, this.RTLong__f_hi, b.RTLong__f_lo, b.RTLong__f_hi);
  return new $c_RTLong(lo, this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn)
});
$c_RTLong.prototype.compareTo__O__I = (function(x$1) {
  var that = $as_jl_Long(x$1);
  return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$compare__I__I__I__I__I(this.RTLong__f_lo, this.RTLong__f_hi, that.RTLong__f_lo, that.RTLong__f_hi)
});
function $as_RTLong(obj) {
  return (((obj instanceof $c_RTLong) || (obj === null)) ? obj : $throwClassCastException(obj, "org.scalajs.linker.runtime.RuntimeLong"))
}
function $isArrayOf_RTLong(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.RTLong)))
}
function $asArrayOf_RTLong(obj, depth) {
  return (($isArrayOf_RTLong(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lorg.scalajs.linker.runtime.RuntimeLong;", depth))
}
var $d_RTLong = new $TypeData().initClass({
  RTLong: 0
}, false, "org.scalajs.linker.runtime.RuntimeLong", {
  RTLong: 1,
  jl_Number: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1
});
$c_RTLong.prototype.$classData = $d_RTLong;
/** @constructor */
function $c_Lplay_api_libs_functional_$tilde(_1, _2) {
  this.Lplay_api_libs_functional_$tilde__f__1 = null;
  this.Lplay_api_libs_functional_$tilde__f__2 = null;
  this.Lplay_api_libs_functional_$tilde__f__1 = _1;
  this.Lplay_api_libs_functional_$tilde__f__2 = _2
}
$c_Lplay_api_libs_functional_$tilde.prototype = new $h_O();
$c_Lplay_api_libs_functional_$tilde.prototype.constructor = $c_Lplay_api_libs_functional_$tilde;
/** @constructor */
function $h_Lplay_api_libs_functional_$tilde() {
  /*<skip>*/
}
$h_Lplay_api_libs_functional_$tilde.prototype = $c_Lplay_api_libs_functional_$tilde.prototype;
$c_Lplay_api_libs_functional_$tilde.prototype.productPrefix__T = (function() {
  return "~"
});
$c_Lplay_api_libs_functional_$tilde.prototype.productArity__I = (function() {
  return 2
});
$c_Lplay_api_libs_functional_$tilde.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lplay_api_libs_functional_$tilde__f__1;
      break
    }
    case 1: {
      return this.Lplay_api_libs_functional_$tilde__f__2;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lplay_api_libs_functional_$tilde.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lplay_api_libs_functional_$tilde.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lplay_api_libs_functional_$tilde.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lplay_api_libs_functional_$tilde.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lplay_api_libs_functional_$tilde)) {
    var \u03b4tilde$1 = $as_Lplay_api_libs_functional_$tilde(x$1);
    var x = this.Lplay_api_libs_functional_$tilde__f__1;
    var y = \u03b4tilde$1.Lplay_api_libs_functional_$tilde__f__1;
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      var x$2 = this.Lplay_api_libs_functional_$tilde__f__2;
      var y$1 = \u03b4tilde$1.Lplay_api_libs_functional_$tilde__f__2;
      return $m_sr_BoxesRunTime$().equals__O__O__Z(x$2, y$1)
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lplay_api_libs_functional_$tilde(obj) {
  return (((obj instanceof $c_Lplay_api_libs_functional_$tilde) || (obj === null)) ? obj : $throwClassCastException(obj, "play.api.libs.functional.$tilde"))
}
function $isArrayOf_Lplay_api_libs_functional_$tilde(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lplay_api_libs_functional_$tilde)))
}
function $asArrayOf_Lplay_api_libs_functional_$tilde(obj, depth) {
  return (($isArrayOf_Lplay_api_libs_functional_$tilde(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lplay.api.libs.functional.$tilde;", depth))
}
var $d_Lplay_api_libs_functional_$tilde = new $TypeData().initClass({
  Lplay_api_libs_functional_$tilde: 0
}, false, "play.api.libs.functional.$tilde", {
  Lplay_api_libs_functional_$tilde: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lplay_api_libs_functional_$tilde.prototype.$classData = $d_Lplay_api_libs_functional_$tilde;
/** @constructor */
function $c_Lplay_api_libs_json_DefaultFormat$$anon$7(outer, fjs$2, tjs$2) {
  this.Lplay_api_libs_json_DefaultFormat$$anon$7__f_fjs$2 = null;
  this.Lplay_api_libs_json_DefaultFormat$$anon$7__f_tjs$2 = null;
  this.Lplay_api_libs_json_DefaultFormat$$anon$7__f_fjs$2 = fjs$2;
  this.Lplay_api_libs_json_DefaultFormat$$anon$7__f_tjs$2 = tjs$2
}
$c_Lplay_api_libs_json_DefaultFormat$$anon$7.prototype = new $h_O();
$c_Lplay_api_libs_json_DefaultFormat$$anon$7.prototype.constructor = $c_Lplay_api_libs_json_DefaultFormat$$anon$7;
/** @constructor */
function $h_Lplay_api_libs_json_DefaultFormat$$anon$7() {
  /*<skip>*/
}
$h_Lplay_api_libs_json_DefaultFormat$$anon$7.prototype = $c_Lplay_api_libs_json_DefaultFormat$$anon$7.prototype;
$c_Lplay_api_libs_json_DefaultFormat$$anon$7.prototype.contramap__F1__Lplay_api_libs_json_Writes = (function(f) {
  return $f_Lplay_api_libs_json_Writes__contramap__F1__Lplay_api_libs_json_Writes(this, f)
});
$c_Lplay_api_libs_json_DefaultFormat$$anon$7.prototype.reads__Lplay_api_libs_json_JsValue__Lplay_api_libs_json_JsResult = (function(json) {
  return this.Lplay_api_libs_json_DefaultFormat$$anon$7__f_fjs$2.reads__Lplay_api_libs_json_JsValue__Lplay_api_libs_json_JsResult(json)
});
$c_Lplay_api_libs_json_DefaultFormat$$anon$7.prototype.writes__O__Lplay_api_libs_json_JsValue = (function(o) {
  return this.Lplay_api_libs_json_DefaultFormat$$anon$7__f_tjs$2.writes__O__Lplay_api_libs_json_JsValue(o)
});
var $d_Lplay_api_libs_json_DefaultFormat$$anon$7 = new $TypeData().initClass({
  Lplay_api_libs_json_DefaultFormat$$anon$7: 0
}, false, "play.api.libs.json.DefaultFormat$$anon$7", {
  Lplay_api_libs_json_DefaultFormat$$anon$7: 1,
  O: 1,
  Lplay_api_libs_json_Format: 1,
  Lplay_api_libs_json_Writes: 1,
  Lplay_api_libs_json_Reads: 1
});
$c_Lplay_api_libs_json_DefaultFormat$$anon$7.prototype.$classData = $d_Lplay_api_libs_json_DefaultFormat$$anon$7;
/** @constructor */
function $c_Lplay_api_libs_json_Format$() {
  this.Lplay_api_libs_json_Format$__f_constraints = null;
  this.Lplay_api_libs_json_Format$__f_path = null;
  this.Lplay_api_libs_json_Format$__f_invariantFunctorFormat = null;
  $n_Lplay_api_libs_json_Format$ = this;
  this.Lplay_api_libs_json_Format$__f_constraints = this;
  this.Lplay_api_libs_json_Format$__f_path = this;
  this.Lplay_api_libs_json_Format$__f_invariantFunctorFormat = new $c_Lplay_api_libs_json_Format$$anon$5()
}
$c_Lplay_api_libs_json_Format$.prototype = new $h_O();
$c_Lplay_api_libs_json_Format$.prototype.constructor = $c_Lplay_api_libs_json_Format$;
/** @constructor */
function $h_Lplay_api_libs_json_Format$() {
  /*<skip>*/
}
$h_Lplay_api_libs_json_Format$.prototype = $c_Lplay_api_libs_json_Format$.prototype;
var $d_Lplay_api_libs_json_Format$ = new $TypeData().initClass({
  Lplay_api_libs_json_Format$: 0
}, false, "play.api.libs.json.Format$", {
  Lplay_api_libs_json_Format$: 1,
  O: 1,
  Lplay_api_libs_json_PathFormat: 1,
  Lplay_api_libs_json_ConstraintFormat: 1,
  Lplay_api_libs_json_DefaultFormat: 1
});
$c_Lplay_api_libs_json_Format$.prototype.$classData = $d_Lplay_api_libs_json_Format$;
var $n_Lplay_api_libs_json_Format$;
function $m_Lplay_api_libs_json_Format$() {
  if ((!$n_Lplay_api_libs_json_Format$)) {
    $n_Lplay_api_libs_json_Format$ = new $c_Lplay_api_libs_json_Format$()
  };
  return $n_Lplay_api_libs_json_Format$
}
/** @constructor */
function $c_Lplay_api_libs_json_Format$$anon$6(fjs$1, tjs$1) {
  this.Lplay_api_libs_json_Format$$anon$6__f_fjs$1 = null;
  this.Lplay_api_libs_json_Format$$anon$6__f_tjs$1 = null;
  this.Lplay_api_libs_json_Format$$anon$6__f_fjs$1 = fjs$1;
  this.Lplay_api_libs_json_Format$$anon$6__f_tjs$1 = tjs$1
}
$c_Lplay_api_libs_json_Format$$anon$6.prototype = new $h_O();
$c_Lplay_api_libs_json_Format$$anon$6.prototype.constructor = $c_Lplay_api_libs_json_Format$$anon$6;
/** @constructor */
function $h_Lplay_api_libs_json_Format$$anon$6() {
  /*<skip>*/
}
$h_Lplay_api_libs_json_Format$$anon$6.prototype = $c_Lplay_api_libs_json_Format$$anon$6.prototype;
$c_Lplay_api_libs_json_Format$$anon$6.prototype.contramap__F1__Lplay_api_libs_json_Writes = (function(f) {
  return $f_Lplay_api_libs_json_Writes__contramap__F1__Lplay_api_libs_json_Writes(this, f)
});
$c_Lplay_api_libs_json_Format$$anon$6.prototype.reads__Lplay_api_libs_json_JsValue__Lplay_api_libs_json_JsResult = (function(json) {
  return this.Lplay_api_libs_json_Format$$anon$6__f_fjs$1.reads__Lplay_api_libs_json_JsValue__Lplay_api_libs_json_JsResult(json)
});
$c_Lplay_api_libs_json_Format$$anon$6.prototype.writes__O__Lplay_api_libs_json_JsValue = (function(o) {
  return this.Lplay_api_libs_json_Format$$anon$6__f_tjs$1.writes__O__Lplay_api_libs_json_JsValue(o)
});
var $d_Lplay_api_libs_json_Format$$anon$6 = new $TypeData().initClass({
  Lplay_api_libs_json_Format$$anon$6: 0
}, false, "play.api.libs.json.Format$$anon$6", {
  Lplay_api_libs_json_Format$$anon$6: 1,
  O: 1,
  Lplay_api_libs_json_Format: 1,
  Lplay_api_libs_json_Writes: 1,
  Lplay_api_libs_json_Reads: 1
});
$c_Lplay_api_libs_json_Format$$anon$6.prototype.$classData = $d_Lplay_api_libs_json_Format$$anon$6;
/** @constructor */
function $c_Lplay_api_libs_json_JsDefined$() {
  /*<skip>*/
}
$c_Lplay_api_libs_json_JsDefined$.prototype = new $h_sr_AbstractFunction1();
$c_Lplay_api_libs_json_JsDefined$.prototype.constructor = $c_Lplay_api_libs_json_JsDefined$;
/** @constructor */
function $h_Lplay_api_libs_json_JsDefined$() {
  /*<skip>*/
}
$h_Lplay_api_libs_json_JsDefined$.prototype = $c_Lplay_api_libs_json_JsDefined$.prototype;
$c_Lplay_api_libs_json_JsDefined$.prototype.toString__T = (function() {
  return "JsDefined"
});
$c_Lplay_api_libs_json_JsDefined$.prototype.productElement$extension__Lplay_api_libs_json_JsValue__I__O = (function(this$, x$1) {
  return ((x$1 === 0) ? this$ : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lplay_api_libs_json_JsDefined$.prototype.productIterator$extension__Lplay_api_libs_json_JsValue__sc_Iterator = (function(this$) {
  var x = new $c_Lplay_api_libs_json_JsDefined(this$);
  return new $c_sr_ScalaRunTime$$anon$1(x)
});
$c_Lplay_api_libs_json_JsDefined$.prototype.equals$extension__Lplay_api_libs_json_JsValue__O__Z = (function(this$, x$1) {
  if ((x$1 instanceof $c_Lplay_api_libs_json_JsDefined)) {
    var JsDefined$1 = ((x$1 === null) ? null : $as_Lplay_api_libs_json_JsDefined(x$1).Lplay_api_libs_json_JsDefined__f_value);
    return ((this$ === null) ? (JsDefined$1 === null) : this$.equals__O__Z(JsDefined$1))
  } else {
    return false
  }
});
$c_Lplay_api_libs_json_JsDefined$.prototype.toString$extension__Lplay_api_libs_json_JsValue__T = (function(this$) {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(new $c_Lplay_api_libs_json_JsDefined(this$))
});
$c_Lplay_api_libs_json_JsDefined$.prototype.apply__O__O = (function(v1) {
  var value = $as_Lplay_api_libs_json_JsValue(v1);
  return new $c_Lplay_api_libs_json_JsDefined(value)
});
var $d_Lplay_api_libs_json_JsDefined$ = new $TypeData().initClass({
  Lplay_api_libs_json_JsDefined$: 0
}, false, "play.api.libs.json.JsDefined$", {
  Lplay_api_libs_json_JsDefined$: 1,
  sr_AbstractFunction1: 1,
  O: 1,
  F1: 1,
  Ljava_io_Serializable: 1
});
$c_Lplay_api_libs_json_JsDefined$.prototype.$classData = $d_Lplay_api_libs_json_JsDefined$;
var $n_Lplay_api_libs_json_JsDefined$;
function $m_Lplay_api_libs_json_JsDefined$() {
  if ((!$n_Lplay_api_libs_json_JsDefined$)) {
    $n_Lplay_api_libs_json_JsDefined$ = new $c_Lplay_api_libs_json_JsDefined$()
  };
  return $n_Lplay_api_libs_json_JsDefined$
}
function $p_Lplay_api_libs_json_JsPath__PathMissingError$lzycompute__Lplay_api_libs_json_JsError($thiz) {
  if ((!$thiz.Lplay_api_libs_json_JsPath__f_bitmap$0)) {
    var $$x1 = $m_sci_Seq$();
    var y = $m_Lplay_api_libs_json_JsonValidationError$().Lplay_api_libs_json_JsonValidationError$__f_PathMissing;
    var array = [new $c_T2($thiz, y)];
    $thiz.Lplay_api_libs_json_JsPath__f_PathMissingError = new $c_Lplay_api_libs_json_JsError($as_sc_Seq($$x1.apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))));
    $thiz.Lplay_api_libs_json_JsPath__f_bitmap$0 = true
  };
  return $thiz.Lplay_api_libs_json_JsPath__f_PathMissingError
}
function $p_Lplay_api_libs_json_JsPath__PathMissingError__Lplay_api_libs_json_JsError($thiz) {
  return ((!$thiz.Lplay_api_libs_json_JsPath__f_bitmap$0) ? $p_Lplay_api_libs_json_JsPath__PathMissingError$lzycompute__Lplay_api_libs_json_JsError($thiz) : $thiz.Lplay_api_libs_json_JsPath__f_PathMissingError)
}
function $ct_Lplay_api_libs_json_JsPath__sci_List__($thiz, path) {
  $thiz.Lplay_api_libs_json_JsPath__f_path = path;
  $thiz.Lplay_api_libs_json_JsPath__f_play$api$libs$json$JsPath$$self = $thiz;
  return $thiz
}
/** @constructor */
function $c_Lplay_api_libs_json_JsPath() {
  this.Lplay_api_libs_json_JsPath__f_PathMissingError = null;
  this.Lplay_api_libs_json_JsPath__f_json$module = null;
  this.Lplay_api_libs_json_JsPath__f_path = null;
  this.Lplay_api_libs_json_JsPath__f_play$api$libs$json$JsPath$$self = null;
  this.Lplay_api_libs_json_JsPath__f_bitmap$0 = false
}
$c_Lplay_api_libs_json_JsPath.prototype = new $h_O();
$c_Lplay_api_libs_json_JsPath.prototype.constructor = $c_Lplay_api_libs_json_JsPath;
/** @constructor */
function $h_Lplay_api_libs_json_JsPath() {
  /*<skip>*/
}
$h_Lplay_api_libs_json_JsPath.prototype = $c_Lplay_api_libs_json_JsPath.prototype;
$c_Lplay_api_libs_json_JsPath.prototype.$bslash__T__Lplay_api_libs_json_JsPath = (function(child) {
  var this$1 = this.Lplay_api_libs_json_JsPath__f_path;
  var elem = new $c_Lplay_api_libs_json_KeyPathNode(child);
  return $ct_Lplay_api_libs_json_JsPath__sci_List__(new $c_Lplay_api_libs_json_JsPath(), $as_sci_List($f_sc_StrictOptimizedSeqOps__appended__O__O(this$1, elem)))
});
$c_Lplay_api_libs_json_JsPath.prototype.apply__Lplay_api_libs_json_JsValue__sci_List = (function(json) {
  var this$5 = this.Lplay_api_libs_json_JsPath__f_path;
  $m_sci_List$();
  var array = [json];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  var z = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
  var acc = z;
  var these = this$5;
  while ((!these.isEmpty__Z())) {
    var arg1 = acc;
    var arg2 = these.head__O();
    var s = $as_sci_List(arg1);
    var p = $as_Lplay_api_libs_json_PathNode(arg2);
    var rest = s;
    var h = null;
    var t = null;
    while ((rest !== $m_sci_Nil$())) {
      var arg1$1 = rest.head__O();
      var json$1 = $as_Lplay_api_libs_json_JsValue(arg1$1);
      var it = p.apply__Lplay_api_libs_json_JsValue__sci_List(json$1).iterator__sc_Iterator();
      while (it.hasNext__Z()) {
        var nx = new $c_sci_$colon$colon(it.next__O(), $m_sci_Nil$());
        if ((t === null)) {
          h = nx
        } else {
          t.sci_$colon$colon__f_next = nx
        };
        t = nx
      };
      rest = $as_sci_List(rest.tail__O())
    };
    acc = ((h === null) ? $m_sci_Nil$() : h);
    these = $as_sc_LinearSeq(these.tail__O())
  };
  return $as_sci_List(acc)
});
$c_Lplay_api_libs_json_JsPath.prototype.asSingleJsResult__Lplay_api_libs_json_JsValue__Lplay_api_libs_json_JsResult = (function(json) {
  var x1 = this.Lplay_api_libs_json_JsPath__f_path;
  if ((x1 !== null)) {
    $m_sci_List$();
    if (((new $c_sc_SeqFactory$UnapplySeqWrapper(x1), true) && (x1.lengthCompare__I__I(1) === 0))) {
      var p3 = $as_Lplay_api_libs_json_PathNode($f_sc_LinearSeqOps__apply__I__O(x1, 0));
      if ((p3 instanceof $c_Lplay_api_libs_json_KeyPathNode)) {
        var x4 = $as_Lplay_api_libs_json_KeyPathNode(p3);
        var key = x4.Lplay_api_libs_json_KeyPathNode__f_key;
        if ((json instanceof $c_Lplay_api_libs_json_JsObject)) {
          var x2 = $as_Lplay_api_libs_json_JsObject(json);
          var underlying = x2.Lplay_api_libs_json_JsObject__f_underlying;
          var x1$3 = underlying.get__O__s_Option(key);
          if ((x1$3 instanceof $c_s_Some)) {
            var x2$2 = $as_s_Some(x1$3);
            var value = $as_Lplay_api_libs_json_JsValue(x2$2.s_Some__f_value);
            return new $c_Lplay_api_libs_json_JsSuccess(value, $ct_Lplay_api_libs_json_JsPath__sci_List__(new $c_Lplay_api_libs_json_JsPath(), ($m_Lplay_api_libs_json_JsPath$(), $m_sci_Nil$())))
          } else {
            var x = $m_s_None$();
            if ((x === x1$3)) {
              return $p_Lplay_api_libs_json_JsPath__PathMissingError__Lplay_api_libs_json_JsError(this)
            } else {
              throw new $c_s_MatchError(x1$3)
            }
          }
        } else {
          return $p_Lplay_api_libs_json_JsPath__PathMissingError__Lplay_api_libs_json_JsError(this)
        }
      }
    }
  };
  var x1$4 = this.apply__Lplay_api_libs_json_JsValue__sci_List(json);
  var x$3 = $m_sci_Nil$();
  if (x$3.equals__O__Z(x1$4)) {
    return $p_Lplay_api_libs_json_JsPath__PathMissingError__Lplay_api_libs_json_JsError(this)
  };
  if ((x1$4 !== null)) {
    $m_sci_List$();
    if (((new $c_sc_SeqFactory$UnapplySeqWrapper(x1$4), true) && (x1$4.lengthCompare__I__I(1) === 0))) {
      var js = $as_Lplay_api_libs_json_JsValue($f_sc_LinearSeqOps__apply__I__O(x1$4, 0));
      return new $c_Lplay_api_libs_json_JsSuccess(js, $ct_Lplay_api_libs_json_JsPath__sci_List__(new $c_Lplay_api_libs_json_JsPath(), ($m_Lplay_api_libs_json_JsPath$(), $m_sci_Nil$())))
    }
  };
  if ((x1$4 instanceof $c_sci_$colon$colon)) {
    var $$x3 = $m_sci_Seq$();
    var $$x2 = $m_sci_Seq$();
    var $$x1 = $m_Lplay_api_libs_json_JsonValidationError$();
    var array = [];
    var array$1 = [$$x1.apply__T__sci_Seq__Lplay_api_libs_json_JsonValidationError("error.path.result.multiple", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))];
    var y = $$x2.apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1));
    var array$2 = [new $c_T2(this, y)];
    return new $c_Lplay_api_libs_json_JsError($as_sc_Seq($$x3.apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2))))
  };
  throw new $c_s_MatchError(x1$4)
});
$c_Lplay_api_libs_json_JsPath.prototype.asSingleJson__Lplay_api_libs_json_JsValue__Lplay_api_libs_json_JsLookupResult = (function(json) {
  var x1 = this.Lplay_api_libs_json_JsPath__f_path;
  if ((x1 !== null)) {
    $m_sci_List$();
    if (((new $c_sc_SeqFactory$UnapplySeqWrapper(x1), true) && (x1.lengthCompare__I__I(1) === 0))) {
      var p3 = $as_Lplay_api_libs_json_PathNode($f_sc_LinearSeqOps__apply__I__O(x1, 0));
      if ((p3 instanceof $c_Lplay_api_libs_json_KeyPathNode)) {
        var x4 = $as_Lplay_api_libs_json_KeyPathNode(p3);
        var key = x4.Lplay_api_libs_json_KeyPathNode__f_key;
        if ((json instanceof $c_Lplay_api_libs_json_JsObject)) {
          var x2 = $as_Lplay_api_libs_json_JsObject(json);
          var underlying = x2.Lplay_api_libs_json_JsObject__f_underlying;
          var x1$3 = underlying.get__O__s_Option(key);
          if ((x1$3 instanceof $c_s_Some)) {
            var x2$2 = $as_s_Some(x1$3);
            var value = $as_Lplay_api_libs_json_JsValue(x2$2.s_Some__f_value);
            return new $c_Lplay_api_libs_json_JsDefined(value)
          } else {
            var x = $m_s_None$();
            if ((x === x1$3)) {
              return $m_Lplay_api_libs_json_JsLookupResult$().Lplay_api_libs_json_JsLookupResult$__f_PathMissing
            } else {
              throw new $c_s_MatchError(x1$3)
            }
          }
        } else {
          return $m_Lplay_api_libs_json_JsLookupResult$().Lplay_api_libs_json_JsLookupResult$__f_PathMissing
        }
      }
    }
  };
  var x1$4 = this.apply__Lplay_api_libs_json_JsValue__sci_List(json);
  var x$3 = $m_sci_Nil$();
  if (x$3.equals__O__Z(x1$4)) {
    return $m_Lplay_api_libs_json_JsLookupResult$().Lplay_api_libs_json_JsLookupResult$__f_PathMissing
  };
  if ((x1$4 !== null)) {
    $m_sci_List$();
    if (((new $c_sc_SeqFactory$UnapplySeqWrapper(x1$4), true) && (x1$4.lengthCompare__I__I(1) === 0))) {
      var js = $as_Lplay_api_libs_json_JsValue($f_sc_LinearSeqOps__apply__I__O(x1$4, 0));
      return new $c_Lplay_api_libs_json_JsDefined(js)
    }
  };
  if ((x1$4 instanceof $c_sci_$colon$colon)) {
    var err = new $c_sjsr_AnonFunction0((function(this$13) {
      return (function() {
        return "error.path.result.multiple"
      })
    })(this));
    return new $c_Lplay_api_libs_json_JsUndefined(err)
  };
  throw new $c_s_MatchError(x1$4)
});
$c_Lplay_api_libs_json_JsPath.prototype.toString__T = (function() {
  var this$1 = this.Lplay_api_libs_json_JsPath__f_path;
  return $f_sc_IterableOnceOps__mkString__T__T__T__T(this$1, "", "", "")
});
$c_Lplay_api_libs_json_JsPath.prototype.compose__Lplay_api_libs_json_JsPath__Lplay_api_libs_json_JsPath = (function(other) {
  var this$1 = this.Lplay_api_libs_json_JsPath__f_path;
  var suffix = other.Lplay_api_libs_json_JsPath__f_path;
  return $ct_Lplay_api_libs_json_JsPath__sci_List__(new $c_Lplay_api_libs_json_JsPath(), this$1.appendedAll__sc_IterableOnce__sci_List(suffix))
});
$c_Lplay_api_libs_json_JsPath.prototype.productPrefix__T = (function() {
  return "JsPath"
});
$c_Lplay_api_libs_json_JsPath.prototype.productArity__I = (function() {
  return 1
});
$c_Lplay_api_libs_json_JsPath.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lplay_api_libs_json_JsPath__f_path : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lplay_api_libs_json_JsPath.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lplay_api_libs_json_JsPath.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lplay_api_libs_json_JsPath.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lplay_api_libs_json_JsPath)) {
    var JsPath$1 = $as_Lplay_api_libs_json_JsPath(x$1);
    var x = this.Lplay_api_libs_json_JsPath__f_path;
    var x$2 = JsPath$1.Lplay_api_libs_json_JsPath__f_path;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lplay_api_libs_json_JsPath(obj) {
  return (((obj instanceof $c_Lplay_api_libs_json_JsPath) || (obj === null)) ? obj : $throwClassCastException(obj, "play.api.libs.json.JsPath"))
}
function $isArrayOf_Lplay_api_libs_json_JsPath(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lplay_api_libs_json_JsPath)))
}
function $asArrayOf_Lplay_api_libs_json_JsPath(obj, depth) {
  return (($isArrayOf_Lplay_api_libs_json_JsPath(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lplay.api.libs.json.JsPath;", depth))
}
var $d_Lplay_api_libs_json_JsPath = new $TypeData().initClass({
  Lplay_api_libs_json_JsPath: 0
}, false, "play.api.libs.json.JsPath", {
  Lplay_api_libs_json_JsPath: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lplay_api_libs_json_JsPath.prototype.$classData = $d_Lplay_api_libs_json_JsPath;
/** @constructor */
function $c_Lplay_api_libs_json_JsonValidationError(messages, args) {
  this.Lplay_api_libs_json_JsonValidationError__f_message = null;
  this.Lplay_api_libs_json_JsonValidationError__f_messages = null;
  this.Lplay_api_libs_json_JsonValidationError__f_args = null;
  this.Lplay_api_libs_json_JsonValidationError__f_bitmap$0 = false;
  this.Lplay_api_libs_json_JsonValidationError__f_messages = messages;
  this.Lplay_api_libs_json_JsonValidationError__f_args = args
}
$c_Lplay_api_libs_json_JsonValidationError.prototype = new $h_O();
$c_Lplay_api_libs_json_JsonValidationError.prototype.constructor = $c_Lplay_api_libs_json_JsonValidationError;
/** @constructor */
function $h_Lplay_api_libs_json_JsonValidationError() {
  /*<skip>*/
}
$h_Lplay_api_libs_json_JsonValidationError.prototype = $c_Lplay_api_libs_json_JsonValidationError.prototype;
$c_Lplay_api_libs_json_JsonValidationError.prototype.productPrefix__T = (function() {
  return "JsonValidationError"
});
$c_Lplay_api_libs_json_JsonValidationError.prototype.productArity__I = (function() {
  return 2
});
$c_Lplay_api_libs_json_JsonValidationError.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lplay_api_libs_json_JsonValidationError__f_messages;
      break
    }
    case 1: {
      return this.Lplay_api_libs_json_JsonValidationError__f_args;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lplay_api_libs_json_JsonValidationError.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lplay_api_libs_json_JsonValidationError.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lplay_api_libs_json_JsonValidationError.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lplay_api_libs_json_JsonValidationError.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lplay_api_libs_json_JsonValidationError)) {
    var JsonValidationError$1 = $as_Lplay_api_libs_json_JsonValidationError(x$1);
    var x = this.Lplay_api_libs_json_JsonValidationError__f_messages;
    var x$2 = JsonValidationError$1.Lplay_api_libs_json_JsonValidationError__f_messages;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lplay_api_libs_json_JsonValidationError__f_args;
      var x$4 = JsonValidationError$1.Lplay_api_libs_json_JsonValidationError__f_args;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lplay_api_libs_json_JsonValidationError(obj) {
  return (((obj instanceof $c_Lplay_api_libs_json_JsonValidationError) || (obj === null)) ? obj : $throwClassCastException(obj, "play.api.libs.json.JsonValidationError"))
}
function $isArrayOf_Lplay_api_libs_json_JsonValidationError(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lplay_api_libs_json_JsonValidationError)))
}
function $asArrayOf_Lplay_api_libs_json_JsonValidationError(obj, depth) {
  return (($isArrayOf_Lplay_api_libs_json_JsonValidationError(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lplay.api.libs.json.JsonValidationError;", depth))
}
var $d_Lplay_api_libs_json_JsonValidationError = new $TypeData().initClass({
  Lplay_api_libs_json_JsonValidationError: 0
}, false, "play.api.libs.json.JsonValidationError", {
  Lplay_api_libs_json_JsonValidationError: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lplay_api_libs_json_JsonValidationError.prototype.$classData = $d_Lplay_api_libs_json_JsonValidationError;
/** @constructor */
function $c_Lplay_api_libs_json_OWrites$MergedOWrites$$anon$1(wa$1, wb$1) {
  this.Lplay_api_libs_json_OWrites$MergedOWrites$$anon$1__f_wa$1 = null;
  this.Lplay_api_libs_json_OWrites$MergedOWrites$$anon$1__f_wb$1 = null;
  this.Lplay_api_libs_json_OWrites$MergedOWrites$$anon$1__f_wa$1 = wa$1;
  this.Lplay_api_libs_json_OWrites$MergedOWrites$$anon$1__f_wb$1 = wb$1
}
$c_Lplay_api_libs_json_OWrites$MergedOWrites$$anon$1.prototype = new $h_O();
$c_Lplay_api_libs_json_OWrites$MergedOWrites$$anon$1.prototype.constructor = $c_Lplay_api_libs_json_OWrites$MergedOWrites$$anon$1;
/** @constructor */
function $h_Lplay_api_libs_json_OWrites$MergedOWrites$$anon$1() {
  /*<skip>*/
}
$h_Lplay_api_libs_json_OWrites$MergedOWrites$$anon$1.prototype = $c_Lplay_api_libs_json_OWrites$MergedOWrites$$anon$1.prototype;
$c_Lplay_api_libs_json_OWrites$MergedOWrites$$anon$1.prototype.writes__O__Lplay_api_libs_json_JsObject = (function(a) {
  return $f_Lplay_api_libs_json_OWrites$OWritesFromFields__writes__O__Lplay_api_libs_json_JsObject(this, a)
});
$c_Lplay_api_libs_json_OWrites$MergedOWrites$$anon$1.prototype.writeFields__scm_Map__Lplay_api_libs_functional_$tilde__V = (function(fieldsMap, obj) {
  if ((obj === null)) {
    throw new $c_s_MatchError(obj)
  };
  var a = obj.Lplay_api_libs_functional_$tilde__f__1;
  var b = obj.Lplay_api_libs_functional_$tilde__f__2;
  var this$1 = $m_Lplay_api_libs_json_OWrites$MergedOWrites$();
  var wa = this.Lplay_api_libs_json_OWrites$MergedOWrites$$anon$1__f_wa$1;
  if ($is_Lplay_api_libs_json_OWrites$OWritesFromFields(wa)) {
    var x2 = $as_Lplay_api_libs_json_OWrites$OWritesFromFields(wa);
    x2.writeFields__scm_Map__Lplay_api_libs_functional_$tilde__V(fieldsMap, $as_Lplay_api_libs_functional_$tilde(a))
  } else if ((wa !== null)) {
    wa.writes__O__Lplay_api_libs_json_JsObject(a).Lplay_api_libs_json_JsObject__f_underlying.foreach__F1__V(new $c_sjsr_AnonFunction1((function(this$2, fieldsMap$1) {
      return (function(x0$1$2) {
        var x0$1 = $as_T2(x0$1$2);
        if ((x0$1 !== null)) {
          var key = $as_T(x0$1._1__O());
          var value = $as_Lplay_api_libs_json_JsValue(x0$1._2__O());
          if ((value instanceof $c_Lplay_api_libs_json_JsObject)) {
            var x2$1 = $as_Lplay_api_libs_json_JsObject(value);
            var x1$2 = fieldsMap$1.get__O__s_Option(key);
            matchEnd5: {
              var $$x1;
              if ((x1$2 instanceof $c_s_Some)) {
                var x2$2 = $as_s_Some(x1$2);
                var o = $as_Lplay_api_libs_json_JsValue(x2$2.s_Some__f_value);
                if ((o instanceof $c_Lplay_api_libs_json_JsObject)) {
                  var x3 = $as_Lplay_api_libs_json_JsObject(o);
                  var $$x1 = $p_Lplay_api_libs_json_JsObject__merge$1__Lplay_api_libs_json_JsObject__Lplay_api_libs_json_JsObject__Lplay_api_libs_json_JsObject(x3, x3, x2$1);
                  break matchEnd5
                }
              };
              var $$x1 = x2$1
            };
            return fieldsMap$1.put__O__O__s_Option(key, $$x1)
          }
        };
        if ((x0$1 !== null)) {
          var key$2 = $as_T(x0$1._1__O());
          var value$2 = $as_Lplay_api_libs_json_JsValue(x0$1._2__O());
          return fieldsMap$1.put__O__O__s_Option(key$2, value$2)
        };
        throw new $c_s_MatchError(x0$1)
      })
    })(this$1, fieldsMap)))
  } else {
    throw new $c_s_MatchError(wa)
  };
  var this$3 = $m_Lplay_api_libs_json_OWrites$MergedOWrites$();
  var wa$1 = this.Lplay_api_libs_json_OWrites$MergedOWrites$$anon$1__f_wb$1;
  if ($is_Lplay_api_libs_json_OWrites$OWritesFromFields(wa$1)) {
    var x2$3 = $as_Lplay_api_libs_json_OWrites$OWritesFromFields(wa$1);
    x2$3.writeFields__scm_Map__Lplay_api_libs_functional_$tilde__V(fieldsMap, $as_Lplay_api_libs_functional_$tilde(b))
  } else if ((wa$1 !== null)) {
    wa$1.writes__O__Lplay_api_libs_json_JsObject(b).Lplay_api_libs_json_JsObject__f_underlying.foreach__F1__V(new $c_sjsr_AnonFunction1((function(this$4, fieldsMap$2) {
      return (function(x0$1$2$1) {
        var x0$1$1 = $as_T2(x0$1$2$1);
        if ((x0$1$1 !== null)) {
          var key$1 = $as_T(x0$1$1._1__O());
          var value$1 = $as_Lplay_api_libs_json_JsValue(x0$1$1._2__O());
          if ((value$1 instanceof $c_Lplay_api_libs_json_JsObject)) {
            var x2$4 = $as_Lplay_api_libs_json_JsObject(value$1);
            var x1$2$1 = fieldsMap$2.get__O__s_Option(key$1);
            matchEnd5$1: {
              var $$x2;
              if ((x1$2$1 instanceof $c_s_Some)) {
                var x2$2$1 = $as_s_Some(x1$2$1);
                var o$1 = $as_Lplay_api_libs_json_JsValue(x2$2$1.s_Some__f_value);
                if ((o$1 instanceof $c_Lplay_api_libs_json_JsObject)) {
                  var x3$1 = $as_Lplay_api_libs_json_JsObject(o$1);
                  var $$x2 = $p_Lplay_api_libs_json_JsObject__merge$1__Lplay_api_libs_json_JsObject__Lplay_api_libs_json_JsObject__Lplay_api_libs_json_JsObject(x3$1, x3$1, x2$4);
                  break matchEnd5$1
                }
              };
              var $$x2 = x2$4
            };
            return fieldsMap$2.put__O__O__s_Option(key$1, $$x2)
          }
        };
        if ((x0$1$1 !== null)) {
          var key$2$1 = $as_T(x0$1$1._1__O());
          var value$2$1 = $as_Lplay_api_libs_json_JsValue(x0$1$1._2__O());
          return fieldsMap$2.put__O__O__s_Option(key$2$1, value$2$1)
        };
        throw new $c_s_MatchError(x0$1$1)
      })
    })(this$3, fieldsMap)))
  } else {
    throw new $c_s_MatchError(wa$1)
  }
});
$c_Lplay_api_libs_json_OWrites$MergedOWrites$$anon$1.prototype.contramap__F1__Lplay_api_libs_json_Writes = (function(f) {
  return $f_Lplay_api_libs_json_OWrites__contramap__F1__Lplay_api_libs_json_OWrites(this, f)
});
$c_Lplay_api_libs_json_OWrites$MergedOWrites$$anon$1.prototype.writes__O__Lplay_api_libs_json_JsValue = (function(o) {
  return $f_Lplay_api_libs_json_OWrites$OWritesFromFields__writes__O__Lplay_api_libs_json_JsObject(this, o)
});
var $d_Lplay_api_libs_json_OWrites$MergedOWrites$$anon$1 = new $TypeData().initClass({
  Lplay_api_libs_json_OWrites$MergedOWrites$$anon$1: 0
}, false, "play.api.libs.json.OWrites$MergedOWrites$$anon$1", {
  Lplay_api_libs_json_OWrites$MergedOWrites$$anon$1: 1,
  O: 1,
  Lplay_api_libs_json_OWrites$OWritesFromFields: 1,
  Lplay_api_libs_json_OWrites: 1,
  Lplay_api_libs_json_Writes: 1
});
$c_Lplay_api_libs_json_OWrites$MergedOWrites$$anon$1.prototype.$classData = $d_Lplay_api_libs_json_OWrites$MergedOWrites$$anon$1;
/** @constructor */
function $c_s_$eq$colon$eq() {
  /*<skip>*/
}
$c_s_$eq$colon$eq.prototype = new $h_s_$less$colon$less();
$c_s_$eq$colon$eq.prototype.constructor = $c_s_$eq$colon$eq;
/** @constructor */
function $h_s_$eq$colon$eq() {
  /*<skip>*/
}
$h_s_$eq$colon$eq.prototype = $c_s_$eq$colon$eq.prototype;
/** @constructor */
function $c_s_PartialFunction$$anon$1() {
  this.s_PartialFunction$$anon$1__f_lift = null;
  this.s_PartialFunction$$anon$1__f_lift = new $c_sjsr_AnonFunction1((function(this$1) {
    return (function(x$2) {
      return $m_s_None$()
    })
  })(this))
}
$c_s_PartialFunction$$anon$1.prototype = new $h_O();
$c_s_PartialFunction$$anon$1.prototype.constructor = $c_s_PartialFunction$$anon$1;
/** @constructor */
function $h_s_PartialFunction$$anon$1() {
  /*<skip>*/
}
$h_s_PartialFunction$$anon$1.prototype = $c_s_PartialFunction$$anon$1.prototype;
$c_s_PartialFunction$$anon$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return $f_s_PartialFunction__applyOrElse__O__F1__O(this, x, default$1)
});
$c_s_PartialFunction$$anon$1.prototype.toString__T = (function() {
  return "<function1>"
});
$c_s_PartialFunction$$anon$1.prototype.isDefinedAt__O__Z = (function(x) {
  return false
});
$c_s_PartialFunction$$anon$1.prototype.apply__O__E = (function(x) {
  throw new $c_s_MatchError(x)
});
$c_s_PartialFunction$$anon$1.prototype.apply__O__O = (function(v1) {
  this.apply__O__E(v1)
});
var $d_s_PartialFunction$$anon$1 = new $TypeData().initClass({
  s_PartialFunction$$anon$1: 0
}, false, "scala.PartialFunction$$anon$1", {
  s_PartialFunction$$anon$1: 1,
  O: 1,
  s_PartialFunction: 1,
  F1: 1,
  Ljava_io_Serializable: 1
});
$c_s_PartialFunction$$anon$1.prototype.$classData = $d_s_PartialFunction$$anon$1;
function $as_s_PartialFunction$Lifted(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "scala.PartialFunction$Lifted"))
}
function $isArrayOf_s_PartialFunction$Lifted(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_PartialFunction$Lifted)))
}
function $asArrayOf_s_PartialFunction$Lifted(obj, depth) {
  return (($isArrayOf_s_PartialFunction$Lifted(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.PartialFunction$Lifted;", depth))
}
/** @constructor */
function $c_sc_AbstractIterator() {
  /*<skip>*/
}
$c_sc_AbstractIterator.prototype = new $h_O();
$c_sc_AbstractIterator.prototype.constructor = $c_sc_AbstractIterator;
/** @constructor */
function $h_sc_AbstractIterator() {
  /*<skip>*/
}
$h_sc_AbstractIterator.prototype = $c_sc_AbstractIterator.prototype;
$c_sc_AbstractIterator.prototype.iterator__sc_Iterator = (function() {
  return this
});
$c_sc_AbstractIterator.prototype.isEmpty__Z = (function() {
  return (!this.hasNext__Z())
});
$c_sc_AbstractIterator.prototype.concat__F0__sc_Iterator = (function(xs) {
  return $f_sc_Iterator__concat__F0__sc_Iterator(this, xs)
});
$c_sc_AbstractIterator.prototype.drop__I__sc_Iterator = (function(n) {
  return $f_sc_Iterator__drop__I__sc_Iterator(this, n)
});
$c_sc_AbstractIterator.prototype.toString__T = (function() {
  return "<iterator>"
});
$c_sc_AbstractIterator.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len)
});
$c_sc_AbstractIterator.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end)
});
$c_sc_AbstractIterator.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2)
});
$c_sc_AbstractIterator.prototype.knownSize__I = (function() {
  return (-1)
});
/** @constructor */
function $c_sc_Iterable$() {
  this.sc_IterableFactory$Delegate__f_delegate = null;
  $ct_sc_IterableFactory$Delegate__sc_IterableFactory__(this, $m_sci_Iterable$())
}
$c_sc_Iterable$.prototype = new $h_sc_IterableFactory$Delegate();
$c_sc_Iterable$.prototype.constructor = $c_sc_Iterable$;
/** @constructor */
function $h_sc_Iterable$() {
  /*<skip>*/
}
$h_sc_Iterable$.prototype = $c_sc_Iterable$.prototype;
var $d_sc_Iterable$ = new $TypeData().initClass({
  sc_Iterable$: 0
}, false, "scala.collection.Iterable$", {
  sc_Iterable$: 1,
  sc_IterableFactory$Delegate: 1,
  O: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sc_Iterable$.prototype.$classData = $d_sc_Iterable$;
var $n_sc_Iterable$;
function $m_sc_Iterable$() {
  if ((!$n_sc_Iterable$)) {
    $n_sc_Iterable$ = new $c_sc_Iterable$()
  };
  return $n_sc_Iterable$
}
/** @constructor */
function $c_sc_Map$() {
  this.sc_MapFactory$Delegate__f_delegate = null;
  this.sc_Map$__f_DefaultSentinel = null;
  this.sc_Map$__f_scala$collection$Map$$DefaultSentinelFn = null;
  $ct_sc_MapFactory$Delegate__sc_MapFactory__(this, $m_sci_Map$());
  $n_sc_Map$ = this;
  this.sc_Map$__f_DefaultSentinel = $ct_O__(new $c_O());
  this.sc_Map$__f_scala$collection$Map$$DefaultSentinelFn = new $c_sjsr_AnonFunction0((function(this$1) {
    return (function() {
      return $m_sc_Map$().sc_Map$__f_DefaultSentinel
    })
  })(this))
}
$c_sc_Map$.prototype = new $h_sc_MapFactory$Delegate();
$c_sc_Map$.prototype.constructor = $c_sc_Map$;
/** @constructor */
function $h_sc_Map$() {
  /*<skip>*/
}
$h_sc_Map$.prototype = $c_sc_Map$.prototype;
var $d_sc_Map$ = new $TypeData().initClass({
  sc_Map$: 0
}, false, "scala.collection.Map$", {
  sc_Map$: 1,
  sc_MapFactory$Delegate: 1,
  O: 1,
  sc_MapFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sc_Map$.prototype.$classData = $d_sc_Map$;
var $n_sc_Map$;
function $m_sc_Map$() {
  if ((!$n_sc_Map$)) {
    $n_sc_Map$ = new $c_sc_Map$()
  };
  return $n_sc_Map$
}
/** @constructor */
function $c_sc_MapView$() {
  this.sc_MapView$__f_EmptyMapView = null;
  $n_sc_MapView$ = this;
  this.sc_MapView$__f_EmptyMapView = new $c_sc_MapView$$anon$1()
}
$c_sc_MapView$.prototype = new $h_O();
$c_sc_MapView$.prototype.constructor = $c_sc_MapView$;
/** @constructor */
function $h_sc_MapView$() {
  /*<skip>*/
}
$h_sc_MapView$.prototype = $c_sc_MapView$.prototype;
$c_sc_MapView$.prototype.newBuilder__scm_Builder = (function() {
  var this$3 = new $c_scm_HashMap$$anon$6(16, 0.75);
  var f = new $c_sjsr_AnonFunction1((function(this$2) {
    return (function(x$1$2) {
      var x$1 = $as_scm_HashMap(x$1$2);
      return new $c_sc_MapView$Id(x$1)
    })
  })(this));
  return new $c_scm_Builder$$anon$1(this$3, f)
});
$c_sc_MapView$.prototype.from__sc_IterableOnce__O = (function(it) {
  return $m_sc_View$().from__sc_IterableOnce__sc_View(it)
});
$c_sc_MapView$.prototype.empty__O = (function() {
  return this.sc_MapView$__f_EmptyMapView
});
var $d_sc_MapView$ = new $TypeData().initClass({
  sc_MapView$: 0
}, false, "scala.collection.MapView$", {
  sc_MapView$: 1,
  O: 1,
  sc_MapViewFactory: 1,
  sc_MapFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sc_MapView$.prototype.$classData = $d_sc_MapView$;
var $n_sc_MapView$;
function $m_sc_MapView$() {
  if ((!$n_sc_MapView$)) {
    $n_sc_MapView$ = new $c_sc_MapView$()
  };
  return $n_sc_MapView$
}
function $ct_sc_SeqFactory$Delegate__sc_SeqFactory__($thiz, delegate) {
  $thiz.sc_SeqFactory$Delegate__f_delegate = delegate;
  return $thiz
}
/** @constructor */
function $c_sc_SeqFactory$Delegate() {
  this.sc_SeqFactory$Delegate__f_delegate = null
}
$c_sc_SeqFactory$Delegate.prototype = new $h_O();
$c_sc_SeqFactory$Delegate.prototype.constructor = $c_sc_SeqFactory$Delegate;
/** @constructor */
function $h_sc_SeqFactory$Delegate() {
  /*<skip>*/
}
$h_sc_SeqFactory$Delegate.prototype = $c_sc_SeqFactory$Delegate.prototype;
$c_sc_SeqFactory$Delegate.prototype.apply__sci_Seq__sc_SeqOps = (function(elems) {
  return $as_sc_SeqOps(this.sc_SeqFactory$Delegate__f_delegate.apply__sci_Seq__O(elems))
});
$c_sc_SeqFactory$Delegate.prototype.empty__sc_SeqOps = (function() {
  return $as_sc_SeqOps(this.sc_SeqFactory$Delegate__f_delegate.empty__O())
});
$c_sc_SeqFactory$Delegate.prototype.from__sc_IterableOnce__sc_SeqOps = (function(it) {
  return $as_sc_SeqOps(this.sc_SeqFactory$Delegate__f_delegate.from__sc_IterableOnce__O(it))
});
$c_sc_SeqFactory$Delegate.prototype.newBuilder__scm_Builder = (function() {
  return this.sc_SeqFactory$Delegate__f_delegate.newBuilder__scm_Builder()
});
$c_sc_SeqFactory$Delegate.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__sc_SeqOps(source)
});
$c_sc_SeqFactory$Delegate.prototype.empty__O = (function() {
  return this.empty__sc_SeqOps()
});
$c_sc_SeqFactory$Delegate.prototype.apply__sci_Seq__O = (function(elems) {
  return this.apply__sci_Seq__sc_SeqOps(elems)
});
function $f_sc_SeqOps__isDefinedAt__I__Z($thiz, idx) {
  return ((idx >= 0) && ($thiz.lengthCompare__I__I(idx) > 0))
}
function $f_sc_SeqOps__indexOf__O__I__I($thiz, elem, from) {
  return $thiz.indexWhere__F1__I__I(new $c_sjsr_AnonFunction1((function(this$1, elem$1) {
    return (function(x$1$2) {
      return $m_sr_BoxesRunTime$().equals__O__O__Z(elem$1, x$1$2)
    })
  })($thiz, elem)), from)
}
function $f_sc_SeqOps__contains__O__Z($thiz, elem) {
  return $thiz.exists__F1__Z(new $c_sjsr_AnonFunction1((function(this$1, elem$1) {
    return (function(x$3$2) {
      return $m_sr_BoxesRunTime$().equals__O__O__Z(x$3$2, elem$1)
    })
  })($thiz, elem)))
}
function $f_sc_SeqOps__isEmpty__Z($thiz) {
  return ($thiz.lengthCompare__I__I(0) === 0)
}
function $f_sc_SeqOps__sameElements__sc_IterableOnce__Z($thiz, that) {
  var thisKnownSize = $thiz.knownSize__I();
  if ((thisKnownSize !== (-1))) {
    var thatKnownSize = that.knownSize__I();
    var knownSizeDifference = ((thatKnownSize !== (-1)) && (thisKnownSize !== thatKnownSize))
  } else {
    var knownSizeDifference = false
  };
  if ((!knownSizeDifference)) {
    var this$1 = $thiz.iterator__sc_Iterator();
    return $f_sc_Iterator__sameElements__sc_IterableOnce__Z(this$1, that)
  } else {
    return false
  }
}
function $is_sc_SeqOps(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_SeqOps)))
}
function $as_sc_SeqOps(obj) {
  return (($is_sc_SeqOps(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.SeqOps"))
}
function $isArrayOf_sc_SeqOps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_SeqOps)))
}
function $asArrayOf_sc_SeqOps(obj, depth) {
  return (($isArrayOf_sc_SeqOps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.SeqOps;", depth))
}
function $f_sc_StrictOptimizedIterableOps__map__F1__O($thiz, f) {
  var b = $thiz.iterableFactory__sc_IterableFactory().newBuilder__scm_Builder();
  var it = $thiz.iterator__sc_Iterator();
  while (it.hasNext__Z()) {
    var elem = f.apply__O__O(it.next__O());
    b.addOne__O__scm_Growable(elem)
  };
  return b.result__O()
}
function $f_sc_StrictOptimizedIterableOps__flatMap__F1__O($thiz, f) {
  var b = $thiz.iterableFactory__sc_IterableFactory().newBuilder__scm_Builder();
  var it = $thiz.iterator__sc_Iterator();
  while (it.hasNext__Z()) {
    var xs = $as_sc_IterableOnce(f.apply__O__O(it.next__O()));
    b.addAll__sc_IterableOnce__scm_Growable(xs)
  };
  return b.result__O()
}
function $f_sc_StrictOptimizedIterableOps__zipWithIndex__O($thiz) {
  var b = $thiz.iterableFactory__sc_IterableFactory().newBuilder__scm_Builder();
  var i = 0;
  var it = $thiz.iterator__sc_Iterator();
  while (it.hasNext__Z()) {
    var elem = new $c_T2(it.next__O(), i);
    b.addOne__O__scm_Growable(elem);
    i = ((1 + i) | 0)
  };
  return b.result__O()
}
/** @constructor */
function $c_sci_HashMap$accum$1(outer) {
  this.sci_HashMap$accum$1__f_changed = false;
  this.sci_HashMap$accum$1__f_shallowlyMutableNodeMap = 0;
  this.sci_HashMap$accum$1__f_current = null;
  this.sci_HashMap$accum$1__f_$outer = null;
  if ((outer === null)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(null)
  } else {
    this.sci_HashMap$accum$1__f_$outer = outer
  };
  this.sci_HashMap$accum$1__f_changed = false;
  this.sci_HashMap$accum$1__f_shallowlyMutableNodeMap = 0;
  this.sci_HashMap$accum$1__f_current = outer.sci_HashMap__f_rootNode
}
$c_sci_HashMap$accum$1.prototype = new $h_sr_AbstractFunction2();
$c_sci_HashMap$accum$1.prototype.constructor = $c_sci_HashMap$accum$1;
/** @constructor */
function $h_sci_HashMap$accum$1() {
  /*<skip>*/
}
$h_sci_HashMap$accum$1.prototype = $c_sci_HashMap$accum$1.prototype;
$c_sci_HashMap$accum$1.prototype.toString__T = (function() {
  return "<function1>"
});
$c_sci_HashMap$accum$1.prototype.apply__O__O__V = (function(key, value) {
  var originalHash = $m_sr_Statics$().anyHash__O__I(key);
  var improved = $m_sc_Hashing$().improve__I__I(originalHash);
  if ((!this.sci_HashMap$accum$1__f_changed)) {
    this.sci_HashMap$accum$1__f_current = this.sci_HashMap$accum$1__f_current.updated__O__O__I__I__I__Z__sci_BitmapIndexedMapNode(key, value, originalHash, improved, 0, true);
    if ((this.sci_HashMap$accum$1__f_current !== this.sci_HashMap$accum$1__f_$outer.sci_HashMap__f_rootNode)) {
      this.sci_HashMap$accum$1__f_changed = true;
      this.sci_HashMap$accum$1__f_shallowlyMutableNodeMap = $m_sci_Node$().bitposFrom__I__I($m_sci_Node$().maskFrom__I__I__I(improved, 0))
    }
  } else {
    this.sci_HashMap$accum$1__f_shallowlyMutableNodeMap = this.sci_HashMap$accum$1__f_current.updateWithShallowMutations__O__O__I__I__I__I__I(key, value, originalHash, improved, 0, this.sci_HashMap$accum$1__f_shallowlyMutableNodeMap)
  }
});
$c_sci_HashMap$accum$1.prototype.apply__O__O__O = (function(v1, v2) {
  this.apply__O__O__V(v1, v2)
});
$c_sci_HashMap$accum$1.prototype.apply__O__O = (function(v1) {
  var kv = $as_T2(v1);
  this.apply__O__O__V(kv._1__O(), kv._2__O())
});
var $d_sci_HashMap$accum$1 = new $TypeData().initClass({
  sci_HashMap$accum$1: 0
}, false, "scala.collection.immutable.HashMap$accum$1", {
  sci_HashMap$accum$1: 1,
  sr_AbstractFunction2: 1,
  O: 1,
  F2: 1,
  F1: 1
});
$c_sci_HashMap$accum$1.prototype.$classData = $d_sci_HashMap$accum$1;
/** @constructor */
function $c_sci_Iterable$() {
  this.sc_IterableFactory$Delegate__f_delegate = null;
  $ct_sc_IterableFactory$Delegate__sc_IterableFactory__(this, $m_sci_List$())
}
$c_sci_Iterable$.prototype = new $h_sc_IterableFactory$Delegate();
$c_sci_Iterable$.prototype.constructor = $c_sci_Iterable$;
/** @constructor */
function $h_sci_Iterable$() {
  /*<skip>*/
}
$h_sci_Iterable$.prototype = $c_sci_Iterable$.prototype;
$c_sci_Iterable$.prototype.from__sc_IterableOnce__sci_Iterable = (function(it) {
  if ($is_sci_Iterable(it)) {
    var x2 = $as_sci_Iterable(it);
    return x2
  } else {
    return $as_sci_Iterable($c_sc_IterableFactory$Delegate.prototype.from__sc_IterableOnce__O.call(this, it))
  }
});
$c_sci_Iterable$.prototype.from__sc_IterableOnce__O = (function(it) {
  return this.from__sc_IterableOnce__sci_Iterable(it)
});
var $d_sci_Iterable$ = new $TypeData().initClass({
  sci_Iterable$: 0
}, false, "scala.collection.immutable.Iterable$", {
  sci_Iterable$: 1,
  sc_IterableFactory$Delegate: 1,
  O: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Iterable$.prototype.$classData = $d_sci_Iterable$;
var $n_sci_Iterable$;
function $m_sci_Iterable$() {
  if ((!$n_sci_Iterable$)) {
    $n_sci_Iterable$ = new $c_sci_Iterable$()
  };
  return $n_sci_Iterable$
}
/** @constructor */
function $c_sci_LazyList$() {
  this.sci_LazyList$__f__empty = null;
  this.sci_LazyList$__f_scala$collection$immutable$LazyList$$anyToMarker = null;
  $n_sci_LazyList$ = this;
  var state = new $c_sjsr_AnonFunction0((function(this$1) {
    return (function() {
      return $m_sci_LazyList$State$Empty$()
    })
  })(this));
  this.sci_LazyList$__f__empty = new $c_sci_LazyList(state).force__sci_LazyList();
  this.sci_LazyList$__f_scala$collection$immutable$LazyList$$anyToMarker = new $c_sjsr_AnonFunction1((function(this$2) {
    return (function(x$10$2) {
      return $m_sr_Statics$PFMarker$()
    })
  })(this))
}
$c_sci_LazyList$.prototype = new $h_O();
$c_sci_LazyList$.prototype.constructor = $c_sci_LazyList$;
/** @constructor */
function $h_sci_LazyList$() {
  /*<skip>*/
}
$h_sci_LazyList$.prototype = $c_sci_LazyList$.prototype;
$c_sci_LazyList$.prototype.apply__sci_Seq__O = (function(elems) {
  return this.from__sc_IterableOnce__sci_LazyList(elems)
});
$c_sci_LazyList$.prototype.scala$collection$immutable$LazyList$$flatMapImpl__sci_LazyList__F1__sci_LazyList = (function(ll, f) {
  var restRef = new $c_sr_ObjectRef(ll);
  var state$1 = new $c_sjsr_AnonFunction0((function(this$2, restRef$1, f$1) {
    return (function() {
      var it = new $c_sr_ObjectRef(null);
      var itHasNext = false;
      var elem = $as_sci_LazyList(restRef$1.sr_ObjectRef__f_elem);
      var rest = new $c_sr_ObjectRef(elem);
      while (((!itHasNext) && (!$as_sci_LazyList(rest.sr_ObjectRef__f_elem).isEmpty__Z()))) {
        var this$5 = $as_sci_LazyList(rest.sr_ObjectRef__f_elem);
        it.sr_ObjectRef__f_elem = $as_sc_IterableOnce(f$1.apply__O__O(this$5.scala$collection$immutable$LazyList$$state__sci_LazyList$State().head__O())).iterator__sc_Iterator();
        itHasNext = $as_sc_Iterator(it.sr_ObjectRef__f_elem).hasNext__Z();
        if ((!itHasNext)) {
          var this$6 = $as_sci_LazyList(rest.sr_ObjectRef__f_elem);
          rest.sr_ObjectRef__f_elem = this$6.scala$collection$immutable$LazyList$$state__sci_LazyList$State().tail__sci_LazyList();
          restRef$1.sr_ObjectRef__f_elem = $as_sci_LazyList(rest.sr_ObjectRef__f_elem)
        }
      };
      if (itHasNext) {
        var head = $as_sc_Iterator(it.sr_ObjectRef__f_elem).next__O();
        var this$7 = $as_sci_LazyList(rest.sr_ObjectRef__f_elem);
        rest.sr_ObjectRef__f_elem = this$7.scala$collection$immutable$LazyList$$state__sci_LazyList$State().tail__sci_LazyList();
        restRef$1.sr_ObjectRef__f_elem = $as_sci_LazyList(rest.sr_ObjectRef__f_elem);
        $m_sci_LazyList$();
        $m_sci_LazyList$();
        var state = new $c_sjsr_AnonFunction0((function(this$8, it$1, rest$1, f$3) {
          return (function() {
            return $m_sci_LazyList$().scala$collection$immutable$LazyList$$stateFromIteratorConcatSuffix__sc_Iterator__F0__sci_LazyList$State($as_sc_Iterator(it$1.sr_ObjectRef__f_elem), new $c_sjsr_AnonFunction0((function(this$9, rest$1$1, f$3$1) {
              return (function() {
                return $m_sci_LazyList$().scala$collection$immutable$LazyList$$flatMapImpl__sci_LazyList__F1__sci_LazyList($as_sci_LazyList(rest$1$1.sr_ObjectRef__f_elem), f$3$1).scala$collection$immutable$LazyList$$state__sci_LazyList$State()
              })
            })(this$8, rest$1, f$3)))
          })
        })(this$2, it, rest, f$1));
        var tl = new $c_sci_LazyList(state);
        return new $c_sci_LazyList$State$Cons(head, tl)
      } else {
        return $m_sci_LazyList$State$Empty$()
      }
    })
  })(this, restRef, f));
  return new $c_sci_LazyList(state$1)
});
$c_sci_LazyList$.prototype.scala$collection$immutable$LazyList$$dropImpl__sci_LazyList__I__sci_LazyList = (function(ll, n) {
  var restRef = new $c_sr_ObjectRef(ll);
  var iRef = new $c_sr_IntRef(n);
  var state = new $c_sjsr_AnonFunction0((function(this$3, restRef$1, iRef$1) {
    return (function() {
      var rest = $as_sci_LazyList(restRef$1.sr_ObjectRef__f_elem);
      var i = iRef$1.sr_IntRef__f_elem;
      while (((i > 0) && (!rest.isEmpty__Z()))) {
        var this$4 = rest;
        rest = this$4.scala$collection$immutable$LazyList$$state__sci_LazyList$State().tail__sci_LazyList();
        restRef$1.sr_ObjectRef__f_elem = rest;
        i = (((-1) + i) | 0);
        iRef$1.sr_IntRef__f_elem = i
      };
      return rest.scala$collection$immutable$LazyList$$state__sci_LazyList$State()
    })
  })(this, restRef, iRef));
  return new $c_sci_LazyList(state)
});
$c_sci_LazyList$.prototype.from__sc_IterableOnce__sci_LazyList = (function(coll) {
  if ((coll instanceof $c_sci_LazyList)) {
    var x2 = $as_sci_LazyList(coll);
    return x2
  } else if ((coll.knownSize__I() === 0)) {
    return this.sci_LazyList$__f__empty
  } else {
    var state = new $c_sjsr_AnonFunction0((function(this$1, coll$1) {
      return (function() {
        return $m_sci_LazyList$().scala$collection$immutable$LazyList$$stateFromIterator__sc_Iterator__sci_LazyList$State(coll$1.iterator__sc_Iterator())
      })
    })(this, coll));
    return new $c_sci_LazyList(state)
  }
});
$c_sci_LazyList$.prototype.scala$collection$immutable$LazyList$$stateFromIteratorConcatSuffix__sc_Iterator__F0__sci_LazyList$State = (function(it, suffix) {
  if (it.hasNext__Z()) {
    var hd = it.next__O();
    var state = new $c_sjsr_AnonFunction0((function(this$1, it$1, suffix$1) {
      return (function() {
        return $m_sci_LazyList$().scala$collection$immutable$LazyList$$stateFromIteratorConcatSuffix__sc_Iterator__F0__sci_LazyList$State(it$1, suffix$1)
      })
    })(this, it, suffix));
    var tl = new $c_sci_LazyList(state);
    return new $c_sci_LazyList$State$Cons(hd, tl)
  } else {
    return $as_sci_LazyList$State(suffix.apply__O())
  }
});
$c_sci_LazyList$.prototype.scala$collection$immutable$LazyList$$stateFromIterator__sc_Iterator__sci_LazyList$State = (function(it) {
  if (it.hasNext__Z()) {
    var hd = it.next__O();
    var state = new $c_sjsr_AnonFunction0((function(this$1, it$1) {
      return (function() {
        return $m_sci_LazyList$().scala$collection$immutable$LazyList$$stateFromIterator__sc_Iterator__sci_LazyList$State(it$1)
      })
    })(this, it));
    var tl = new $c_sci_LazyList(state);
    return new $c_sci_LazyList$State$Cons(hd, tl)
  } else {
    return $m_sci_LazyList$State$Empty$()
  }
});
$c_sci_LazyList$.prototype.from__I__I__sci_LazyList = (function(start, step) {
  var state = new $c_sjsr_AnonFunction0((function(this$1, start$1, step$1) {
    return (function() {
      $m_sci_LazyList$();
      var tl = $m_sci_LazyList$().from__I__I__sci_LazyList(((start$1 + step$1) | 0), step$1);
      return new $c_sci_LazyList$State$Cons(start$1, tl)
    })
  })(this, start, step));
  return new $c_sci_LazyList(state)
});
$c_sci_LazyList$.prototype.newBuilder__scm_Builder = (function() {
  return new $c_sci_LazyList$LazyBuilder()
});
$c_sci_LazyList$.prototype.empty__O = (function() {
  return this.sci_LazyList$__f__empty
});
$c_sci_LazyList$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__sci_LazyList(source)
});
var $d_sci_LazyList$ = new $TypeData().initClass({
  sci_LazyList$: 0
}, false, "scala.collection.immutable.LazyList$", {
  sci_LazyList$: 1,
  O: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sci_LazyList$.prototype.$classData = $d_sci_LazyList$;
var $n_sci_LazyList$;
function $m_sci_LazyList$() {
  if ((!$n_sci_LazyList$)) {
    $n_sci_LazyList$ = new $c_sci_LazyList$()
  };
  return $n_sci_LazyList$
}
/** @constructor */
function $c_sci_Stream$() {
  /*<skip>*/
}
$c_sci_Stream$.prototype = new $h_O();
$c_sci_Stream$.prototype.constructor = $c_sci_Stream$;
/** @constructor */
function $h_sci_Stream$() {
  /*<skip>*/
}
$h_sci_Stream$.prototype = $c_sci_Stream$.prototype;
$c_sci_Stream$.prototype.apply__sci_Seq__O = (function(elems) {
  return this.from__sc_IterableOnce__sci_Stream(elems)
});
$c_sci_Stream$.prototype.from__sc_IterableOnce__sci_Stream = (function(coll) {
  if ((coll instanceof $c_sci_Stream)) {
    var x2 = $as_sci_Stream(coll);
    return x2
  } else {
    return this.fromIterator__sc_Iterator__sci_Stream(coll.iterator__sc_Iterator())
  }
});
$c_sci_Stream$.prototype.fromIterator__sc_Iterator__sci_Stream = (function(it) {
  return (it.hasNext__Z() ? new $c_sci_Stream$Cons(it.next__O(), new $c_sjsr_AnonFunction0((function(this$1, it$1) {
    return (function() {
      return $m_sci_Stream$().fromIterator__sc_Iterator__sci_Stream(it$1)
    })
  })(this, it))) : $m_sci_Stream$Empty$())
});
$c_sci_Stream$.prototype.newBuilder__scm_Builder = (function() {
  var this$3 = new $c_scm_ArrayBuffer$$anon$1();
  var f = new $c_sjsr_AnonFunction1((function(this$2) {
    return (function(array$2) {
      var array = $as_scm_ArrayBuffer(array$2);
      return $m_sci_Stream$().from__sc_IterableOnce__sci_Stream(array)
    })
  })(this));
  return new $c_scm_Builder$$anon$1(this$3, f)
});
$c_sci_Stream$.prototype.empty__O = (function() {
  return $m_sci_Stream$Empty$()
});
$c_sci_Stream$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__sci_Stream(source)
});
var $d_sci_Stream$ = new $TypeData().initClass({
  sci_Stream$: 0
}, false, "scala.collection.immutable.Stream$", {
  sci_Stream$: 1,
  O: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Stream$.prototype.$classData = $d_sci_Stream$;
var $n_sci_Stream$;
function $m_sci_Stream$() {
  if ((!$n_sci_Stream$)) {
    $n_sci_Stream$ = new $c_sci_Stream$()
  };
  return $n_sci_Stream$
}
/** @constructor */
function $c_sci_WrappedString$() {
  this.sci_WrappedString$__f_empty = null;
  $n_sci_WrappedString$ = this;
  this.sci_WrappedString$__f_empty = new $c_sci_WrappedString("")
}
$c_sci_WrappedString$.prototype = new $h_O();
$c_sci_WrappedString$.prototype.constructor = $c_sci_WrappedString$;
/** @constructor */
function $h_sci_WrappedString$() {
  /*<skip>*/
}
$h_sci_WrappedString$.prototype = $c_sci_WrappedString$.prototype;
$c_sci_WrappedString$.prototype.fromSpecific__sc_IterableOnce__sci_WrappedString = (function(it) {
  var b = this.newBuilder__scm_Builder();
  var s = it.knownSize__I();
  if ((s >= 0)) {
    b.sizeHint__I__V(s)
  };
  b.addAll__sc_IterableOnce__scm_Growable(it);
  return $as_sci_WrappedString(b.result__O())
});
$c_sci_WrappedString$.prototype.newBuilder__scm_Builder = (function() {
  var this$2 = $ct_scm_StringBuilder__(new $c_scm_StringBuilder());
  var f = new $c_sjsr_AnonFunction1((function(this$1) {
    return (function(x$2) {
      var x = $as_T(x$2);
      return new $c_sci_WrappedString(x)
    })
  })(this));
  return new $c_scm_Builder$$anon$1(this$2, f)
});
var $d_sci_WrappedString$ = new $TypeData().initClass({
  sci_WrappedString$: 0
}, false, "scala.collection.immutable.WrappedString$", {
  sci_WrappedString$: 1,
  O: 1,
  sc_SpecificIterableFactory: 1,
  sc_Factory: 1,
  Ljava_io_Serializable: 1
});
$c_sci_WrappedString$.prototype.$classData = $d_sci_WrappedString$;
var $n_sci_WrappedString$;
function $m_sci_WrappedString$() {
  if ((!$n_sci_WrappedString$)) {
    $n_sci_WrappedString$ = new $c_sci_WrappedString$()
  };
  return $n_sci_WrappedString$
}
/** @constructor */
function $c_scm_Builder$$anon$1(outer, f$1) {
  this.scm_Builder$$anon$1__f_$outer = null;
  this.scm_Builder$$anon$1__f_f$1 = null;
  if ((outer === null)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(null)
  } else {
    this.scm_Builder$$anon$1__f_$outer = outer
  };
  this.scm_Builder$$anon$1__f_f$1 = f$1
}
$c_scm_Builder$$anon$1.prototype = new $h_O();
$c_scm_Builder$$anon$1.prototype.constructor = $c_scm_Builder$$anon$1;
/** @constructor */
function $h_scm_Builder$$anon$1() {
  /*<skip>*/
}
$h_scm_Builder$$anon$1.prototype = $c_scm_Builder$$anon$1.prototype;
$c_scm_Builder$$anon$1.prototype.addOne__O__scm_Builder$$anon$1 = (function(x) {
  var this$1 = this.scm_Builder$$anon$1__f_$outer;
  this$1.addOne__O__scm_Growable(x);
  return this
});
$c_scm_Builder$$anon$1.prototype.addAll__sc_IterableOnce__scm_Builder$$anon$1 = (function(xs) {
  var this$1 = this.scm_Builder$$anon$1__f_$outer;
  this$1.addAll__sc_IterableOnce__scm_Growable(xs);
  return this
});
$c_scm_Builder$$anon$1.prototype.sizeHint__I__V = (function(size) {
  this.scm_Builder$$anon$1__f_$outer.sizeHint__I__V(size)
});
$c_scm_Builder$$anon$1.prototype.result__O = (function() {
  return this.scm_Builder$$anon$1__f_f$1.apply__O__O(this.scm_Builder$$anon$1__f_$outer.result__O())
});
$c_scm_Builder$$anon$1.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return this.addAll__sc_IterableOnce__scm_Builder$$anon$1(xs)
});
$c_scm_Builder$$anon$1.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__scm_Builder$$anon$1(elem)
});
var $d_scm_Builder$$anon$1 = new $TypeData().initClass({
  scm_Builder$$anon$1: 0
}, false, "scala.collection.mutable.Builder$$anon$1", {
  scm_Builder$$anon$1: 1,
  O: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
});
$c_scm_Builder$$anon$1.prototype.$classData = $d_scm_Builder$$anon$1;
function $ct_scm_GrowableBuilder__scm_Growable__($thiz, elems) {
  $thiz.scm_GrowableBuilder__f_elems = elems;
  return $thiz
}
/** @constructor */
function $c_scm_GrowableBuilder() {
  this.scm_GrowableBuilder__f_elems = null
}
$c_scm_GrowableBuilder.prototype = new $h_O();
$c_scm_GrowableBuilder.prototype.constructor = $c_scm_GrowableBuilder;
/** @constructor */
function $h_scm_GrowableBuilder() {
  /*<skip>*/
}
$h_scm_GrowableBuilder.prototype = $c_scm_GrowableBuilder.prototype;
$c_scm_GrowableBuilder.prototype.sizeHint__I__V = (function(size) {
  /*<skip>*/
});
$c_scm_GrowableBuilder.prototype.addOne__O__scm_GrowableBuilder = (function(elem) {
  var this$1 = this.scm_GrowableBuilder__f_elems;
  this$1.addOne__O__scm_Growable(elem);
  return this
});
$c_scm_GrowableBuilder.prototype.addAll__sc_IterableOnce__scm_GrowableBuilder = (function(xs) {
  this.scm_GrowableBuilder__f_elems.addAll__sc_IterableOnce__scm_Growable(xs);
  return this
});
$c_scm_GrowableBuilder.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return this.addAll__sc_IterableOnce__scm_GrowableBuilder(xs)
});
$c_scm_GrowableBuilder.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__scm_GrowableBuilder(elem)
});
$c_scm_GrowableBuilder.prototype.result__O = (function() {
  return this.scm_GrowableBuilder__f_elems
});
var $d_scm_GrowableBuilder = new $TypeData().initClass({
  scm_GrowableBuilder: 0
}, false, "scala.collection.mutable.GrowableBuilder", {
  scm_GrowableBuilder: 1,
  O: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
});
$c_scm_GrowableBuilder.prototype.$classData = $d_scm_GrowableBuilder;
/** @constructor */
function $c_scm_Iterable$() {
  this.sc_IterableFactory$Delegate__f_delegate = null;
  $ct_sc_IterableFactory$Delegate__sc_IterableFactory__(this, $m_scm_ArrayBuffer$())
}
$c_scm_Iterable$.prototype = new $h_sc_IterableFactory$Delegate();
$c_scm_Iterable$.prototype.constructor = $c_scm_Iterable$;
/** @constructor */
function $h_scm_Iterable$() {
  /*<skip>*/
}
$h_scm_Iterable$.prototype = $c_scm_Iterable$.prototype;
var $d_scm_Iterable$ = new $TypeData().initClass({
  scm_Iterable$: 0
}, false, "scala.collection.mutable.Iterable$", {
  scm_Iterable$: 1,
  sc_IterableFactory$Delegate: 1,
  O: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_scm_Iterable$.prototype.$classData = $d_scm_Iterable$;
var $n_scm_Iterable$;
function $m_scm_Iterable$() {
  if ((!$n_scm_Iterable$)) {
    $n_scm_Iterable$ = new $c_scm_Iterable$()
  };
  return $n_scm_Iterable$
}
/** @constructor */
function $c_scm_Map$() {
  this.sc_MapFactory$Delegate__f_delegate = null;
  $ct_sc_MapFactory$Delegate__sc_MapFactory__(this, $m_scm_HashMap$())
}
$c_scm_Map$.prototype = new $h_sc_MapFactory$Delegate();
$c_scm_Map$.prototype.constructor = $c_scm_Map$;
/** @constructor */
function $h_scm_Map$() {
  /*<skip>*/
}
$h_scm_Map$.prototype = $c_scm_Map$.prototype;
var $d_scm_Map$ = new $TypeData().initClass({
  scm_Map$: 0
}, false, "scala.collection.mutable.Map$", {
  scm_Map$: 1,
  sc_MapFactory$Delegate: 1,
  O: 1,
  sc_MapFactory: 1,
  Ljava_io_Serializable: 1
});
$c_scm_Map$.prototype.$classData = $d_scm_Map$;
var $n_scm_Map$;
function $m_scm_Map$() {
  if ((!$n_scm_Map$)) {
    $n_scm_Map$ = new $c_scm_Map$()
  };
  return $n_scm_Map$
}
/** @constructor */
function $c_s_concurrent_Future$$anon$4() {
  this.jl_Throwable__f_s = null;
  this.jl_Throwable__f_e = null;
  this.jl_Throwable__f_enableSuppression = false;
  this.jl_Throwable__f_writableStackTrace = false;
  this.jl_Throwable__f_stackTraceStateInternal = null;
  this.jl_Throwable__f_stackTrace = null;
  this.jl_Throwable__f_suppressed = null;
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true)
}
$c_s_concurrent_Future$$anon$4.prototype = new $h_jl_Throwable();
$c_s_concurrent_Future$$anon$4.prototype.constructor = $c_s_concurrent_Future$$anon$4;
/** @constructor */
function $h_s_concurrent_Future$$anon$4() {
  /*<skip>*/
}
$h_s_concurrent_Future$$anon$4.prototype = $c_s_concurrent_Future$$anon$4.prototype;
$c_s_concurrent_Future$$anon$4.prototype.fillInStackTrace__jl_Throwable = (function() {
  return $f_s_util_control_NoStackTrace__fillInStackTrace__jl_Throwable(this)
});
var $d_s_concurrent_Future$$anon$4 = new $TypeData().initClass({
  s_concurrent_Future$$anon$4: 0
}, false, "scala.concurrent.Future$$anon$4", {
  s_concurrent_Future$$anon$4: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  s_util_control_NoStackTrace: 1
});
$c_s_concurrent_Future$$anon$4.prototype.$classData = $d_s_concurrent_Future$$anon$4;
/** @constructor */
function $c_s_concurrent_duration_Duration() {
  /*<skip>*/
}
$c_s_concurrent_duration_Duration.prototype = new $h_O();
$c_s_concurrent_duration_Duration.prototype.constructor = $c_s_concurrent_duration_Duration;
/** @constructor */
function $h_s_concurrent_duration_Duration() {
  /*<skip>*/
}
$h_s_concurrent_duration_Duration.prototype = $c_s_concurrent_duration_Duration.prototype;
function $as_s_concurrent_duration_Duration(obj) {
  return (((obj instanceof $c_s_concurrent_duration_Duration) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.concurrent.duration.Duration"))
}
function $isArrayOf_s_concurrent_duration_Duration(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_concurrent_duration_Duration)))
}
function $asArrayOf_s_concurrent_duration_Duration(obj, depth) {
  return (($isArrayOf_s_concurrent_duration_Duration(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.concurrent.duration.Duration;", depth))
}
function $as_sr_NonLocalReturnControl(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "scala.runtime.NonLocalReturnControl"))
}
function $isArrayOf_sr_NonLocalReturnControl(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sr_NonLocalReturnControl)))
}
function $asArrayOf_sr_NonLocalReturnControl(obj, depth) {
  return (($isArrayOf_sr_NonLocalReturnControl(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.runtime.NonLocalReturnControl;", depth))
}
/** @constructor */
function $c_sjs_concurrent_QueueExecutionContext$PromisesExecutionContext() {
  this.sjs_concurrent_QueueExecutionContext$PromisesExecutionContext__f_resolvedUnitPromise = null;
  this.sjs_concurrent_QueueExecutionContext$PromisesExecutionContext__f_resolvedUnitPromise = Promise.resolve((void 0))
}
$c_sjs_concurrent_QueueExecutionContext$PromisesExecutionContext.prototype = new $h_O();
$c_sjs_concurrent_QueueExecutionContext$PromisesExecutionContext.prototype.constructor = $c_sjs_concurrent_QueueExecutionContext$PromisesExecutionContext;
/** @constructor */
function $h_sjs_concurrent_QueueExecutionContext$PromisesExecutionContext() {
  /*<skip>*/
}
$h_sjs_concurrent_QueueExecutionContext$PromisesExecutionContext.prototype = $c_sjs_concurrent_QueueExecutionContext$PromisesExecutionContext.prototype;
$c_sjs_concurrent_QueueExecutionContext$PromisesExecutionContext.prototype.execute__jl_Runnable__V = (function(runnable) {
  this.sjs_concurrent_QueueExecutionContext$PromisesExecutionContext__f_resolvedUnitPromise.then((function(arg$outer, runnable$2) {
    return (function(arg1$2) {
      var arg1 = $as_jl_Void(arg1$2);
      return arg$outer.scala$scalajs$concurrent$QueueExecutionContext$PromisesExecutionContext$$$anonfun$execute$2__jl_Void__jl_Runnable__sjs_js_$bar(arg1, runnable$2)
    })
  })(this, runnable))
});
$c_sjs_concurrent_QueueExecutionContext$PromisesExecutionContext.prototype.reportFailure__jl_Throwable__V = (function(t) {
  t.printStackTrace__Ljava_io_PrintStream__V($m_jl_System$Streams$().jl_System$Streams$__f_err)
});
$c_sjs_concurrent_QueueExecutionContext$PromisesExecutionContext.prototype.scala$scalajs$concurrent$QueueExecutionContext$PromisesExecutionContext$$$anonfun$execute$2__jl_Void__jl_Runnable__sjs_js_$bar = (function(x$1, runnable$2) {
  try {
    runnable$2.run__V()
  } catch (e) {
    var e$2 = $m_sjsr_package$().wrapJavaScriptException__O__jl_Throwable(e);
    if ((e$2 !== null)) {
      e$2.printStackTrace__Ljava_io_PrintStream__V($m_jl_System$Streams$().jl_System$Streams$__f_err)
    } else {
      throw e
    }
  }
});
var $d_sjs_concurrent_QueueExecutionContext$PromisesExecutionContext = new $TypeData().initClass({
  sjs_concurrent_QueueExecutionContext$PromisesExecutionContext: 0
}, false, "scala.scalajs.concurrent.QueueExecutionContext$PromisesExecutionContext", {
  sjs_concurrent_QueueExecutionContext$PromisesExecutionContext: 1,
  O: 1,
  s_concurrent_ExecutionContextExecutor: 1,
  s_concurrent_ExecutionContext: 1,
  ju_concurrent_Executor: 1
});
$c_sjs_concurrent_QueueExecutionContext$PromisesExecutionContext.prototype.$classData = $d_sjs_concurrent_QueueExecutionContext$PromisesExecutionContext;
/** @constructor */
function $c_sjs_concurrent_QueueExecutionContext$TimeoutsExecutionContext() {
  /*<skip>*/
}
$c_sjs_concurrent_QueueExecutionContext$TimeoutsExecutionContext.prototype = new $h_O();
$c_sjs_concurrent_QueueExecutionContext$TimeoutsExecutionContext.prototype.constructor = $c_sjs_concurrent_QueueExecutionContext$TimeoutsExecutionContext;
/** @constructor */
function $h_sjs_concurrent_QueueExecutionContext$TimeoutsExecutionContext() {
  /*<skip>*/
}
$h_sjs_concurrent_QueueExecutionContext$TimeoutsExecutionContext.prototype = $c_sjs_concurrent_QueueExecutionContext$TimeoutsExecutionContext.prototype;
$c_sjs_concurrent_QueueExecutionContext$TimeoutsExecutionContext.prototype.execute__jl_Runnable__V = (function(runnable) {
  setTimeout($m_sjs_js_Any$().fromFunction0__F0__sjs_js_Function0(new $c_sjsr_AnonFunction0((function(this$1, runnable$1) {
    return (function() {
      try {
        runnable$1.run__V()
      } catch (e) {
        var e$2 = $m_sjsr_package$().wrapJavaScriptException__O__jl_Throwable(e);
        if ((e$2 !== null)) {
          e$2.printStackTrace__Ljava_io_PrintStream__V($m_jl_System$Streams$().jl_System$Streams$__f_err)
        } else {
          throw e
        }
      }
    })
  })(this, runnable))), 0)
});
$c_sjs_concurrent_QueueExecutionContext$TimeoutsExecutionContext.prototype.reportFailure__jl_Throwable__V = (function(t) {
  t.printStackTrace__Ljava_io_PrintStream__V($m_jl_System$Streams$().jl_System$Streams$__f_err)
});
var $d_sjs_concurrent_QueueExecutionContext$TimeoutsExecutionContext = new $TypeData().initClass({
  sjs_concurrent_QueueExecutionContext$TimeoutsExecutionContext: 0
}, false, "scala.scalajs.concurrent.QueueExecutionContext$TimeoutsExecutionContext", {
  sjs_concurrent_QueueExecutionContext$TimeoutsExecutionContext: 1,
  O: 1,
  s_concurrent_ExecutionContextExecutor: 1,
  s_concurrent_ExecutionContext: 1,
  ju_concurrent_Executor: 1
});
$c_sjs_concurrent_QueueExecutionContext$TimeoutsExecutionContext.prototype.$classData = $d_sjs_concurrent_QueueExecutionContext$TimeoutsExecutionContext;
/** @constructor */
function $c_sjs_js_WrappedDictionary$DictionaryIterator(dict) {
  this.sjs_js_WrappedDictionary$DictionaryIterator__f_dict = null;
  this.sjs_js_WrappedDictionary$DictionaryIterator__f_keys = null;
  this.sjs_js_WrappedDictionary$DictionaryIterator__f_index = 0;
  this.sjs_js_WrappedDictionary$DictionaryIterator__f_dict = dict;
  this.sjs_js_WrappedDictionary$DictionaryIterator__f_keys = Object.keys(dict);
  this.sjs_js_WrappedDictionary$DictionaryIterator__f_index = 0
}
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype = new $h_O();
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.constructor = $c_sjs_js_WrappedDictionary$DictionaryIterator;
/** @constructor */
function $h_sjs_js_WrappedDictionary$DictionaryIterator() {
  /*<skip>*/
}
$h_sjs_js_WrappedDictionary$DictionaryIterator.prototype = $c_sjs_js_WrappedDictionary$DictionaryIterator.prototype;
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.iterator__sc_Iterator = (function() {
  return this
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.isEmpty__Z = (function() {
  return (!this.hasNext__Z())
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.concat__F0__sc_Iterator = (function(xs) {
  return $f_sc_Iterator__concat__F0__sc_Iterator(this, xs)
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.drop__I__sc_Iterator = (function(n) {
  return $f_sc_Iterator__drop__I__sc_Iterator(this, n)
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.toString__T = (function() {
  return "<iterator>"
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len)
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end)
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2)
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.knownSize__I = (function() {
  return (-1)
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.hasNext__Z = (function() {
  return (this.sjs_js_WrappedDictionary$DictionaryIterator__f_index < $uI(this.sjs_js_WrappedDictionary$DictionaryIterator__f_keys.length))
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.next__T2 = (function() {
  var key = $as_T(this.sjs_js_WrappedDictionary$DictionaryIterator__f_keys[this.sjs_js_WrappedDictionary$DictionaryIterator__f_index]);
  this.sjs_js_WrappedDictionary$DictionaryIterator__f_index = ((1 + this.sjs_js_WrappedDictionary$DictionaryIterator__f_index) | 0);
  var dict = this.sjs_js_WrappedDictionary$DictionaryIterator__f_dict;
  if ($uZ($m_sjs_js_WrappedDictionary$Cache$().sjs_js_WrappedDictionary$Cache$__f_safeHasOwnProperty.call(dict, key))) {
    var $$x1 = dict[key]
  } else {
    var $$x1;
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + key))
  };
  return new $c_T2(key, $$x1)
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.next__O = (function() {
  return this.next__T2()
});
var $d_sjs_js_WrappedDictionary$DictionaryIterator = new $TypeData().initClass({
  sjs_js_WrappedDictionary$DictionaryIterator: 0
}, false, "scala.scalajs.js.WrappedDictionary$DictionaryIterator", {
  sjs_js_WrappedDictionary$DictionaryIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.$classData = $d_sjs_js_WrappedDictionary$DictionaryIterator;
/** @constructor */
function $c_sjs_js_WrappedDictionary$WrappedDictionaryBuilder() {
  this.sjs_js_WrappedDictionary$WrappedDictionaryBuilder__f_dict = null;
  this.sjs_js_WrappedDictionary$WrappedDictionaryBuilder__f_dict = {}
}
$c_sjs_js_WrappedDictionary$WrappedDictionaryBuilder.prototype = new $h_O();
$c_sjs_js_WrappedDictionary$WrappedDictionaryBuilder.prototype.constructor = $c_sjs_js_WrappedDictionary$WrappedDictionaryBuilder;
/** @constructor */
function $h_sjs_js_WrappedDictionary$WrappedDictionaryBuilder() {
  /*<skip>*/
}
$h_sjs_js_WrappedDictionary$WrappedDictionaryBuilder.prototype = $c_sjs_js_WrappedDictionary$WrappedDictionaryBuilder.prototype;
$c_sjs_js_WrappedDictionary$WrappedDictionaryBuilder.prototype.sizeHint__I__V = (function(size) {
  /*<skip>*/
});
$c_sjs_js_WrappedDictionary$WrappedDictionaryBuilder.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs)
});
$c_sjs_js_WrappedDictionary$WrappedDictionaryBuilder.prototype.addOne__T2__sjs_js_WrappedDictionary$WrappedDictionaryBuilder = (function(elem) {
  var dict = this.sjs_js_WrappedDictionary$WrappedDictionaryBuilder__f_dict;
  var key = $as_T(elem._1__O());
  var value = elem._2__O();
  dict[key] = value;
  return this
});
$c_sjs_js_WrappedDictionary$WrappedDictionaryBuilder.prototype.result__sjs_js_WrappedDictionary = (function() {
  return new $c_sjs_js_WrappedDictionary(this.sjs_js_WrappedDictionary$WrappedDictionaryBuilder__f_dict)
});
$c_sjs_js_WrappedDictionary$WrappedDictionaryBuilder.prototype.result__O = (function() {
  return this.result__sjs_js_WrappedDictionary()
});
$c_sjs_js_WrappedDictionary$WrappedDictionaryBuilder.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__T2__sjs_js_WrappedDictionary$WrappedDictionaryBuilder($as_T2(elem))
});
var $d_sjs_js_WrappedDictionary$WrappedDictionaryBuilder = new $TypeData().initClass({
  sjs_js_WrappedDictionary$WrappedDictionaryBuilder: 0
}, false, "scala.scalajs.js.WrappedDictionary$WrappedDictionaryBuilder", {
  sjs_js_WrappedDictionary$WrappedDictionaryBuilder: 1,
  O: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
});
$c_sjs_js_WrappedDictionary$WrappedDictionaryBuilder.prototype.$classData = $d_sjs_js_WrappedDictionary$WrappedDictionaryBuilder;
/** @constructor */
function $c_s_util_Try() {
  /*<skip>*/
}
$c_s_util_Try.prototype = new $h_O();
$c_s_util_Try.prototype.constructor = $c_s_util_Try;
/** @constructor */
function $h_s_util_Try() {
  /*<skip>*/
}
$h_s_util_Try.prototype = $c_s_util_Try.prototype;
function $as_s_util_Try(obj) {
  return (((obj instanceof $c_s_util_Try) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.util.Try"))
}
function $isArrayOf_s_util_Try(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_util_Try)))
}
function $asArrayOf_s_util_Try(obj, depth) {
  return (($isArrayOf_s_util_Try(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.util.Try;", depth))
}
/** @constructor */
function $c_Lscommons_api_ApiStatus(code, error, details) {
  this.Lscommons_api_ApiStatus__f_code = 0;
  this.Lscommons_api_ApiStatus__f_error = null;
  this.Lscommons_api_ApiStatus__f_details = null;
  this.Lscommons_api_ApiStatus__f_code = code;
  this.Lscommons_api_ApiStatus__f_error = error;
  this.Lscommons_api_ApiStatus__f_details = details
}
$c_Lscommons_api_ApiStatus.prototype = new $h_O();
$c_Lscommons_api_ApiStatus.prototype.constructor = $c_Lscommons_api_ApiStatus;
/** @constructor */
function $h_Lscommons_api_ApiStatus() {
  /*<skip>*/
}
$h_Lscommons_api_ApiStatus.prototype = $c_Lscommons_api_ApiStatus.prototype;
$c_Lscommons_api_ApiStatus.prototype.successful__Z = (function() {
  return (this.Lscommons_api_ApiStatus__f_code === $m_Lscommons_api_ApiStatus$().Lscommons_api_ApiStatus$__f_Ok.Lscommons_api_ApiStatus__f_code)
});
$c_Lscommons_api_ApiStatus.prototype.productPrefix__T = (function() {
  return "ApiStatus"
});
$c_Lscommons_api_ApiStatus.prototype.productArity__I = (function() {
  return 3
});
$c_Lscommons_api_ApiStatus.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lscommons_api_ApiStatus__f_code;
      break
    }
    case 1: {
      return this.Lscommons_api_ApiStatus__f_error;
      break
    }
    case 2: {
      return this.Lscommons_api_ApiStatus__f_details;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lscommons_api_ApiStatus.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscommons_api_ApiStatus.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("ApiStatus");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = this.Lscommons_api_ApiStatus__f_code;
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x = this.Lscommons_api_ApiStatus__f_error;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x$1 = this.Lscommons_api_ApiStatus__f_details;
  var data$3 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$4, 3)
});
$c_Lscommons_api_ApiStatus.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lscommons_api_ApiStatus.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lscommons_api_ApiStatus)) {
    var ApiStatus$1 = $as_Lscommons_api_ApiStatus(x$1);
    if ((this.Lscommons_api_ApiStatus__f_code === ApiStatus$1.Lscommons_api_ApiStatus__f_code)) {
      var x = this.Lscommons_api_ApiStatus__f_error;
      var x$2 = ApiStatus$1.Lscommons_api_ApiStatus__f_error;
      var $$x1 = ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$3 = this.Lscommons_api_ApiStatus__f_details;
      var x$4 = ApiStatus$1.Lscommons_api_ApiStatus__f_details;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lscommons_api_ApiStatus(obj) {
  return (((obj instanceof $c_Lscommons_api_ApiStatus) || (obj === null)) ? obj : $throwClassCastException(obj, "scommons.api.ApiStatus"))
}
function $isArrayOf_Lscommons_api_ApiStatus(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscommons_api_ApiStatus)))
}
function $asArrayOf_Lscommons_api_ApiStatus(obj, depth) {
  return (($isArrayOf_Lscommons_api_ApiStatus(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscommons.api.ApiStatus;", depth))
}
var $d_Lscommons_api_ApiStatus = new $TypeData().initClass({
  Lscommons_api_ApiStatus: 0
}, false, "scommons.api.ApiStatus", {
  Lscommons_api_ApiStatus: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscommons_api_ApiStatus.prototype.$classData = $d_Lscommons_api_ApiStatus;
/** @constructor */
function $c_Lscommons_react_redux_task_TaskManager$TaskManagerState(taskCount, status, error, errorDetails) {
  this.Lscommons_react_redux_task_TaskManager$TaskManagerState__f_taskCount = 0;
  this.Lscommons_react_redux_task_TaskManager$TaskManagerState__f_status = null;
  this.Lscommons_react_redux_task_TaskManager$TaskManagerState__f_error = null;
  this.Lscommons_react_redux_task_TaskManager$TaskManagerState__f_errorDetails = null;
  this.Lscommons_react_redux_task_TaskManager$TaskManagerState__f_taskCount = taskCount;
  this.Lscommons_react_redux_task_TaskManager$TaskManagerState__f_status = status;
  this.Lscommons_react_redux_task_TaskManager$TaskManagerState__f_error = error;
  this.Lscommons_react_redux_task_TaskManager$TaskManagerState__f_errorDetails = errorDetails
}
$c_Lscommons_react_redux_task_TaskManager$TaskManagerState.prototype = new $h_O();
$c_Lscommons_react_redux_task_TaskManager$TaskManagerState.prototype.constructor = $c_Lscommons_react_redux_task_TaskManager$TaskManagerState;
/** @constructor */
function $h_Lscommons_react_redux_task_TaskManager$TaskManagerState() {
  /*<skip>*/
}
$h_Lscommons_react_redux_task_TaskManager$TaskManagerState.prototype = $c_Lscommons_react_redux_task_TaskManager$TaskManagerState.prototype;
$c_Lscommons_react_redux_task_TaskManager$TaskManagerState.prototype.productPrefix__T = (function() {
  return "TaskManagerState"
});
$c_Lscommons_react_redux_task_TaskManager$TaskManagerState.prototype.productArity__I = (function() {
  return 4
});
$c_Lscommons_react_redux_task_TaskManager$TaskManagerState.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lscommons_react_redux_task_TaskManager$TaskManagerState__f_taskCount;
      break
    }
    case 1: {
      return this.Lscommons_react_redux_task_TaskManager$TaskManagerState__f_status;
      break
    }
    case 2: {
      return this.Lscommons_react_redux_task_TaskManager$TaskManagerState__f_error;
      break
    }
    case 3: {
      return this.Lscommons_react_redux_task_TaskManager$TaskManagerState__f_errorDetails;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lscommons_react_redux_task_TaskManager$TaskManagerState.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscommons_react_redux_task_TaskManager$TaskManagerState.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("TaskManagerState");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = this.Lscommons_react_redux_task_TaskManager$TaskManagerState__f_taskCount;
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x = this.Lscommons_react_redux_task_TaskManager$TaskManagerState__f_status;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x$1 = this.Lscommons_react_redux_task_TaskManager$TaskManagerState__f_error;
  var data$3 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var x$2 = this.Lscommons_react_redux_task_TaskManager$TaskManagerState__f_errorDetails;
  var data$4 = $m_sr_Statics$().anyHash__O__I(x$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$5, 4)
});
$c_Lscommons_react_redux_task_TaskManager$TaskManagerState.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lscommons_react_redux_task_TaskManager$TaskManagerState.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lscommons_react_redux_task_TaskManager$TaskManagerState)) {
    var TaskManagerState$1 = $as_Lscommons_react_redux_task_TaskManager$TaskManagerState(x$1);
    if ((this.Lscommons_react_redux_task_TaskManager$TaskManagerState__f_taskCount === TaskManagerState$1.Lscommons_react_redux_task_TaskManager$TaskManagerState__f_taskCount)) {
      var x = this.Lscommons_react_redux_task_TaskManager$TaskManagerState__f_status;
      var x$2 = TaskManagerState$1.Lscommons_react_redux_task_TaskManager$TaskManagerState__f_status;
      var $$x2 = ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      var x$3 = this.Lscommons_react_redux_task_TaskManager$TaskManagerState__f_error;
      var x$4 = TaskManagerState$1.Lscommons_react_redux_task_TaskManager$TaskManagerState__f_error;
      var $$x1 = ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lscommons_react_redux_task_TaskManager$TaskManagerState__f_errorDetails;
      var x$6 = TaskManagerState$1.Lscommons_react_redux_task_TaskManager$TaskManagerState__f_errorDetails;
      return ((x$5 === null) ? (x$6 === null) : x$5.equals__O__Z(x$6))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lscommons_react_redux_task_TaskManager$TaskManagerState(obj) {
  return (((obj instanceof $c_Lscommons_react_redux_task_TaskManager$TaskManagerState) || (obj === null)) ? obj : $throwClassCastException(obj, "scommons.react.redux.task.TaskManager$TaskManagerState"))
}
function $isArrayOf_Lscommons_react_redux_task_TaskManager$TaskManagerState(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscommons_react_redux_task_TaskManager$TaskManagerState)))
}
function $asArrayOf_Lscommons_react_redux_task_TaskManager$TaskManagerState(obj, depth) {
  return (($isArrayOf_Lscommons_react_redux_task_TaskManager$TaskManagerState(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscommons.react.redux.task.TaskManager$TaskManagerState;", depth))
}
var $d_Lscommons_react_redux_task_TaskManager$TaskManagerState = new $TypeData().initClass({
  Lscommons_react_redux_task_TaskManager$TaskManagerState: 0
}, false, "scommons.react.redux.task.TaskManager$TaskManagerState", {
  Lscommons_react_redux_task_TaskManager$TaskManagerState: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscommons_react_redux_task_TaskManager$TaskManagerState.prototype.$classData = $d_Lscommons_react_redux_task_TaskManager$TaskManagerState;
/** @constructor */
function $c_Lscommons_react_redux_task_TaskManagerProps(startTask) {
  this.Lscommons_react_redux_task_TaskManagerProps__f_startTask = null;
  this.Lscommons_react_redux_task_TaskManagerProps__f_startTask = startTask
}
$c_Lscommons_react_redux_task_TaskManagerProps.prototype = new $h_O();
$c_Lscommons_react_redux_task_TaskManagerProps.prototype.constructor = $c_Lscommons_react_redux_task_TaskManagerProps;
/** @constructor */
function $h_Lscommons_react_redux_task_TaskManagerProps() {
  /*<skip>*/
}
$h_Lscommons_react_redux_task_TaskManagerProps.prototype = $c_Lscommons_react_redux_task_TaskManagerProps.prototype;
$c_Lscommons_react_redux_task_TaskManagerProps.prototype.productPrefix__T = (function() {
  return "TaskManagerProps"
});
$c_Lscommons_react_redux_task_TaskManagerProps.prototype.productArity__I = (function() {
  return 1
});
$c_Lscommons_react_redux_task_TaskManagerProps.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lscommons_react_redux_task_TaskManagerProps__f_startTask : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lscommons_react_redux_task_TaskManagerProps.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscommons_react_redux_task_TaskManagerProps.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lscommons_react_redux_task_TaskManagerProps.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lscommons_react_redux_task_TaskManagerProps.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lscommons_react_redux_task_TaskManagerProps)) {
    var TaskManagerProps$1 = $as_Lscommons_react_redux_task_TaskManagerProps(x$1);
    var x = this.Lscommons_react_redux_task_TaskManagerProps__f_startTask;
    var x$2 = TaskManagerProps$1.Lscommons_react_redux_task_TaskManagerProps__f_startTask;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lscommons_react_redux_task_TaskManagerProps(obj) {
  return (((obj instanceof $c_Lscommons_react_redux_task_TaskManagerProps) || (obj === null)) ? obj : $throwClassCastException(obj, "scommons.react.redux.task.TaskManagerProps"))
}
function $isArrayOf_Lscommons_react_redux_task_TaskManagerProps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscommons_react_redux_task_TaskManagerProps)))
}
function $asArrayOf_Lscommons_react_redux_task_TaskManagerProps(obj, depth) {
  return (($isArrayOf_Lscommons_react_redux_task_TaskManagerProps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscommons.react.redux.task.TaskManagerProps;", depth))
}
var $d_Lscommons_react_redux_task_TaskManagerProps = new $TypeData().initClass({
  Lscommons_react_redux_task_TaskManagerProps: 0
}, false, "scommons.react.redux.task.TaskManagerProps", {
  Lscommons_react_redux_task_TaskManagerProps: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscommons_react_redux_task_TaskManagerProps.prototype.$classData = $d_Lscommons_react_redux_task_TaskManagerProps;
/** @constructor */
function $c_Lscommons_react_redux_task_TaskManagerUiProps(showLoading, status, onHideStatus, error, errorDetails, onCloseErrorPopup) {
  this.Lscommons_react_redux_task_TaskManagerUiProps__f_showLoading = false;
  this.Lscommons_react_redux_task_TaskManagerUiProps__f_status = null;
  this.Lscommons_react_redux_task_TaskManagerUiProps__f_onHideStatus = null;
  this.Lscommons_react_redux_task_TaskManagerUiProps__f_error = null;
  this.Lscommons_react_redux_task_TaskManagerUiProps__f_errorDetails = null;
  this.Lscommons_react_redux_task_TaskManagerUiProps__f_onCloseErrorPopup = null;
  this.Lscommons_react_redux_task_TaskManagerUiProps__f_showLoading = showLoading;
  this.Lscommons_react_redux_task_TaskManagerUiProps__f_status = status;
  this.Lscommons_react_redux_task_TaskManagerUiProps__f_onHideStatus = onHideStatus;
  this.Lscommons_react_redux_task_TaskManagerUiProps__f_error = error;
  this.Lscommons_react_redux_task_TaskManagerUiProps__f_errorDetails = errorDetails;
  this.Lscommons_react_redux_task_TaskManagerUiProps__f_onCloseErrorPopup = onCloseErrorPopup
}
$c_Lscommons_react_redux_task_TaskManagerUiProps.prototype = new $h_O();
$c_Lscommons_react_redux_task_TaskManagerUiProps.prototype.constructor = $c_Lscommons_react_redux_task_TaskManagerUiProps;
/** @constructor */
function $h_Lscommons_react_redux_task_TaskManagerUiProps() {
  /*<skip>*/
}
$h_Lscommons_react_redux_task_TaskManagerUiProps.prototype = $c_Lscommons_react_redux_task_TaskManagerUiProps.prototype;
$c_Lscommons_react_redux_task_TaskManagerUiProps.prototype.productPrefix__T = (function() {
  return "TaskManagerUiProps"
});
$c_Lscommons_react_redux_task_TaskManagerUiProps.prototype.productArity__I = (function() {
  return 6
});
$c_Lscommons_react_redux_task_TaskManagerUiProps.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lscommons_react_redux_task_TaskManagerUiProps__f_showLoading;
      break
    }
    case 1: {
      return this.Lscommons_react_redux_task_TaskManagerUiProps__f_status;
      break
    }
    case 2: {
      return this.Lscommons_react_redux_task_TaskManagerUiProps__f_onHideStatus;
      break
    }
    case 3: {
      return this.Lscommons_react_redux_task_TaskManagerUiProps__f_error;
      break
    }
    case 4: {
      return this.Lscommons_react_redux_task_TaskManagerUiProps__f_errorDetails;
      break
    }
    case 5: {
      return this.Lscommons_react_redux_task_TaskManagerUiProps__f_onCloseErrorPopup;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lscommons_react_redux_task_TaskManagerUiProps.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscommons_react_redux_task_TaskManagerUiProps.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("TaskManagerUiProps");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = (this.Lscommons_react_redux_task_TaskManagerUiProps__f_showLoading ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x = this.Lscommons_react_redux_task_TaskManagerUiProps__f_status;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x$1 = this.Lscommons_react_redux_task_TaskManagerUiProps__f_onHideStatus;
  var data$3 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var x$2 = this.Lscommons_react_redux_task_TaskManagerUiProps__f_error;
  var data$4 = $m_sr_Statics$().anyHash__O__I(x$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  var x$3 = this.Lscommons_react_redux_task_TaskManagerUiProps__f_errorDetails;
  var data$5 = $m_sr_Statics$().anyHash__O__I(x$3);
  acc = $m_sr_Statics$().mix__I__I__I(hash$5, data$5);
  var hash$6 = acc;
  var x$4 = this.Lscommons_react_redux_task_TaskManagerUiProps__f_onCloseErrorPopup;
  var data$6 = $m_sr_Statics$().anyHash__O__I(x$4);
  acc = $m_sr_Statics$().mix__I__I__I(hash$6, data$6);
  var hash$7 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$7, 6)
});
$c_Lscommons_react_redux_task_TaskManagerUiProps.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lscommons_react_redux_task_TaskManagerUiProps.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lscommons_react_redux_task_TaskManagerUiProps)) {
    var TaskManagerUiProps$1 = $as_Lscommons_react_redux_task_TaskManagerUiProps(x$1);
    if ((this.Lscommons_react_redux_task_TaskManagerUiProps__f_showLoading === TaskManagerUiProps$1.Lscommons_react_redux_task_TaskManagerUiProps__f_showLoading)) {
      var x = this.Lscommons_react_redux_task_TaskManagerUiProps__f_status;
      var x$2 = TaskManagerUiProps$1.Lscommons_react_redux_task_TaskManagerUiProps__f_status;
      var $$x4 = ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
    } else {
      var $$x4 = false
    };
    if ($$x4) {
      var x$3 = this.Lscommons_react_redux_task_TaskManagerUiProps__f_onHideStatus;
      var x$4 = TaskManagerUiProps$1.Lscommons_react_redux_task_TaskManagerUiProps__f_onHideStatus;
      var $$x3 = (x$3 === x$4)
    } else {
      var $$x3 = false
    };
    if ($$x3) {
      var x$5 = this.Lscommons_react_redux_task_TaskManagerUiProps__f_error;
      var x$6 = TaskManagerUiProps$1.Lscommons_react_redux_task_TaskManagerUiProps__f_error;
      var $$x2 = ((x$5 === null) ? (x$6 === null) : x$5.equals__O__Z(x$6))
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      var x$7 = this.Lscommons_react_redux_task_TaskManagerUiProps__f_errorDetails;
      var x$8 = TaskManagerUiProps$1.Lscommons_react_redux_task_TaskManagerUiProps__f_errorDetails;
      var $$x1 = ((x$7 === null) ? (x$8 === null) : x$7.equals__O__Z(x$8))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$9 = this.Lscommons_react_redux_task_TaskManagerUiProps__f_onCloseErrorPopup;
      var x$10 = TaskManagerUiProps$1.Lscommons_react_redux_task_TaskManagerUiProps__f_onCloseErrorPopup;
      return (x$9 === x$10)
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lscommons_react_redux_task_TaskManagerUiProps(obj) {
  return (((obj instanceof $c_Lscommons_react_redux_task_TaskManagerUiProps) || (obj === null)) ? obj : $throwClassCastException(obj, "scommons.react.redux.task.TaskManagerUiProps"))
}
function $isArrayOf_Lscommons_react_redux_task_TaskManagerUiProps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscommons_react_redux_task_TaskManagerUiProps)))
}
function $asArrayOf_Lscommons_react_redux_task_TaskManagerUiProps(obj, depth) {
  return (($isArrayOf_Lscommons_react_redux_task_TaskManagerUiProps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscommons.react.redux.task.TaskManagerUiProps;", depth))
}
var $d_Lscommons_react_redux_task_TaskManagerUiProps = new $TypeData().initClass({
  Lscommons_react_redux_task_TaskManagerUiProps: 0
}, false, "scommons.react.redux.task.TaskManagerUiProps", {
  Lscommons_react_redux_task_TaskManagerUiProps: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscommons_react_redux_task_TaskManagerUiProps.prototype.$classData = $d_Lscommons_react_redux_task_TaskManagerUiProps;
/** @constructor */
function $c_Lscommons_reactnative_Alert$AlertButton(text, onPress, style) {
  this.Lscommons_reactnative_Alert$AlertButton__f_text = null;
  this.Lscommons_reactnative_Alert$AlertButton__f_onPress = null;
  this.Lscommons_reactnative_Alert$AlertButton__f_style = null;
  this.Lscommons_reactnative_Alert$AlertButton__f_text = text;
  this.Lscommons_reactnative_Alert$AlertButton__f_onPress = onPress;
  this.Lscommons_reactnative_Alert$AlertButton__f_style = style
}
$c_Lscommons_reactnative_Alert$AlertButton.prototype = new $h_O();
$c_Lscommons_reactnative_Alert$AlertButton.prototype.constructor = $c_Lscommons_reactnative_Alert$AlertButton;
/** @constructor */
function $h_Lscommons_reactnative_Alert$AlertButton() {
  /*<skip>*/
}
$h_Lscommons_reactnative_Alert$AlertButton.prototype = $c_Lscommons_reactnative_Alert$AlertButton.prototype;
$c_Lscommons_reactnative_Alert$AlertButton.prototype.productPrefix__T = (function() {
  return "AlertButton"
});
$c_Lscommons_reactnative_Alert$AlertButton.prototype.productArity__I = (function() {
  return 3
});
$c_Lscommons_reactnative_Alert$AlertButton.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lscommons_reactnative_Alert$AlertButton__f_text;
      break
    }
    case 1: {
      return this.Lscommons_reactnative_Alert$AlertButton__f_onPress;
      break
    }
    case 2: {
      return this.Lscommons_reactnative_Alert$AlertButton__f_style;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lscommons_reactnative_Alert$AlertButton.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscommons_reactnative_Alert$AlertButton.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lscommons_reactnative_Alert$AlertButton.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lscommons_reactnative_Alert$AlertButton.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lscommons_reactnative_Alert$AlertButton)) {
    var AlertButton$1 = $as_Lscommons_reactnative_Alert$AlertButton(x$1);
    if ((this.Lscommons_reactnative_Alert$AlertButton__f_text === AlertButton$1.Lscommons_reactnative_Alert$AlertButton__f_text)) {
      var x = this.Lscommons_reactnative_Alert$AlertButton__f_onPress;
      var x$2 = AlertButton$1.Lscommons_reactnative_Alert$AlertButton__f_onPress;
      var $$x1 = (x === x$2)
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$3 = this.Lscommons_reactnative_Alert$AlertButton__f_style;
      var x$4 = AlertButton$1.Lscommons_reactnative_Alert$AlertButton__f_style;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lscommons_reactnative_Alert$AlertButton(obj) {
  return (((obj instanceof $c_Lscommons_reactnative_Alert$AlertButton) || (obj === null)) ? obj : $throwClassCastException(obj, "scommons.reactnative.Alert$AlertButton"))
}
function $isArrayOf_Lscommons_reactnative_Alert$AlertButton(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscommons_reactnative_Alert$AlertButton)))
}
function $asArrayOf_Lscommons_reactnative_Alert$AlertButton(obj, depth) {
  return (($isArrayOf_Lscommons_reactnative_Alert$AlertButton(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscommons.reactnative.Alert$AlertButton;", depth))
}
var $d_Lscommons_reactnative_Alert$AlertButton = new $TypeData().initClass({
  Lscommons_reactnative_Alert$AlertButton: 0
}, false, "scommons.reactnative.Alert$AlertButton", {
  Lscommons_reactnative_Alert$AlertButton: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscommons_reactnative_Alert$AlertButton.prototype.$classData = $d_Lscommons_reactnative_Alert$AlertButton;
/** @constructor */
function $c_Lscommons_reactnative_app_TaskLoggerProps(text) {
  this.Lscommons_reactnative_app_TaskLoggerProps__f_text = null;
  this.Lscommons_reactnative_app_TaskLoggerProps__f_text = text
}
$c_Lscommons_reactnative_app_TaskLoggerProps.prototype = new $h_O();
$c_Lscommons_reactnative_app_TaskLoggerProps.prototype.constructor = $c_Lscommons_reactnative_app_TaskLoggerProps;
/** @constructor */
function $h_Lscommons_reactnative_app_TaskLoggerProps() {
  /*<skip>*/
}
$h_Lscommons_reactnative_app_TaskLoggerProps.prototype = $c_Lscommons_reactnative_app_TaskLoggerProps.prototype;
$c_Lscommons_reactnative_app_TaskLoggerProps.prototype.productPrefix__T = (function() {
  return "TaskLoggerProps"
});
$c_Lscommons_reactnative_app_TaskLoggerProps.prototype.productArity__I = (function() {
  return 1
});
$c_Lscommons_reactnative_app_TaskLoggerProps.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lscommons_reactnative_app_TaskLoggerProps__f_text : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lscommons_reactnative_app_TaskLoggerProps.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscommons_reactnative_app_TaskLoggerProps.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lscommons_reactnative_app_TaskLoggerProps.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lscommons_reactnative_app_TaskLoggerProps.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lscommons_reactnative_app_TaskLoggerProps)) {
    var TaskLoggerProps$1 = $as_Lscommons_reactnative_app_TaskLoggerProps(x$1);
    return (this.Lscommons_reactnative_app_TaskLoggerProps__f_text === TaskLoggerProps$1.Lscommons_reactnative_app_TaskLoggerProps__f_text)
  } else {
    return false
  }
});
function $as_Lscommons_reactnative_app_TaskLoggerProps(obj) {
  return (((obj instanceof $c_Lscommons_reactnative_app_TaskLoggerProps) || (obj === null)) ? obj : $throwClassCastException(obj, "scommons.reactnative.app.TaskLoggerProps"))
}
function $isArrayOf_Lscommons_reactnative_app_TaskLoggerProps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscommons_reactnative_app_TaskLoggerProps)))
}
function $asArrayOf_Lscommons_reactnative_app_TaskLoggerProps(obj, depth) {
  return (($isArrayOf_Lscommons_reactnative_app_TaskLoggerProps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscommons.reactnative.app.TaskLoggerProps;", depth))
}
var $d_Lscommons_reactnative_app_TaskLoggerProps = new $TypeData().initClass({
  Lscommons_reactnative_app_TaskLoggerProps: 0
}, false, "scommons.reactnative.app.TaskLoggerProps", {
  Lscommons_reactnative_app_TaskLoggerProps: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscommons_reactnative_app_TaskLoggerProps.prototype.$classData = $d_Lscommons_reactnative_app_TaskLoggerProps;
function $p_Lscommons_reactnative_ui_ChoiceGroup$__styles$lzycompute__Lscommons_reactnative_ui_ChoiceGroup$Styles($thiz) {
  if ((!$thiz.Lscommons_reactnative_ui_ChoiceGroup$__f_bitmap$0)) {
    $thiz.Lscommons_reactnative_ui_ChoiceGroup$__f_styles = $m_Lscommons_reactnative_StyleSheet$().create__sjs_js_Object__sjs_js_Object(new ($a_Lscommons_reactnative_ui_ChoiceGroup$Styles())());
    $thiz.Lscommons_reactnative_ui_ChoiceGroup$__f_bitmap$0 = true
  };
  return $thiz.Lscommons_reactnative_ui_ChoiceGroup$__f_styles
}
/** @constructor */
function $c_Lscommons_reactnative_ui_ChoiceGroup$() {
  this.Lscommons_reactnative_ui_ChoiceGroup__f_scommons$react$UiComponent$$reactClass = null;
  this.Lscommons_reactnative_ui_ChoiceGroup__f_bitmap$0 = false;
  this.Lscommons_reactnative_ui_ChoiceGroup$__f_styles = null;
  this.Lscommons_reactnative_ui_ChoiceGroup$__f_bitmap$0 = false
}
$c_Lscommons_reactnative_ui_ChoiceGroup$.prototype = new $h_Lscommons_reactnative_ui_ChoiceGroup();
$c_Lscommons_reactnative_ui_ChoiceGroup$.prototype.constructor = $c_Lscommons_reactnative_ui_ChoiceGroup$;
/** @constructor */
function $h_Lscommons_reactnative_ui_ChoiceGroup$() {
  /*<skip>*/
}
$h_Lscommons_reactnative_ui_ChoiceGroup$.prototype = $c_Lscommons_reactnative_ui_ChoiceGroup$.prototype;
$c_Lscommons_reactnative_ui_ChoiceGroup$.prototype.styles__Lscommons_reactnative_ui_ChoiceGroup$Styles = (function() {
  return ((!this.Lscommons_reactnative_ui_ChoiceGroup$__f_bitmap$0) ? $p_Lscommons_reactnative_ui_ChoiceGroup$__styles$lzycompute__Lscommons_reactnative_ui_ChoiceGroup$Styles(this) : this.Lscommons_reactnative_ui_ChoiceGroup$__f_styles)
});
var $d_Lscommons_reactnative_ui_ChoiceGroup$ = new $TypeData().initClass({
  Lscommons_reactnative_ui_ChoiceGroup$: 0
}, false, "scommons.reactnative.ui.ChoiceGroup$", {
  Lscommons_reactnative_ui_ChoiceGroup$: 1,
  Lscommons_reactnative_ui_ChoiceGroup: 1,
  O: 1,
  Lscommons_react_FunctionComponent: 1,
  Lscommons_react_UiComponent: 1
});
$c_Lscommons_reactnative_ui_ChoiceGroup$.prototype.$classData = $d_Lscommons_reactnative_ui_ChoiceGroup$;
var $n_Lscommons_reactnative_ui_ChoiceGroup$;
function $m_Lscommons_reactnative_ui_ChoiceGroup$() {
  if ((!$n_Lscommons_reactnative_ui_ChoiceGroup$)) {
    $n_Lscommons_reactnative_ui_ChoiceGroup$ = new $c_Lscommons_reactnative_ui_ChoiceGroup$()
  };
  return $n_Lscommons_reactnative_ui_ChoiceGroup$
}
/** @constructor */
function $c_Lscommons_reactnative_ui_ChoiceGroupProps(items, keyExtractor, iconRenderer, labelRenderer, selectedIds, onSelectChange, multiSelect, style) {
  this.Lscommons_reactnative_ui_ChoiceGroupProps__f_items = null;
  this.Lscommons_reactnative_ui_ChoiceGroupProps__f_keyExtractor = null;
  this.Lscommons_reactnative_ui_ChoiceGroupProps__f_iconRenderer = null;
  this.Lscommons_reactnative_ui_ChoiceGroupProps__f_labelRenderer = null;
  this.Lscommons_reactnative_ui_ChoiceGroupProps__f_selectedIds = null;
  this.Lscommons_reactnative_ui_ChoiceGroupProps__f_onSelectChange = null;
  this.Lscommons_reactnative_ui_ChoiceGroupProps__f_multiSelect = false;
  this.Lscommons_reactnative_ui_ChoiceGroupProps__f_style = null;
  this.Lscommons_reactnative_ui_ChoiceGroupProps__f_items = items;
  this.Lscommons_reactnative_ui_ChoiceGroupProps__f_keyExtractor = keyExtractor;
  this.Lscommons_reactnative_ui_ChoiceGroupProps__f_iconRenderer = iconRenderer;
  this.Lscommons_reactnative_ui_ChoiceGroupProps__f_labelRenderer = labelRenderer;
  this.Lscommons_reactnative_ui_ChoiceGroupProps__f_selectedIds = selectedIds;
  this.Lscommons_reactnative_ui_ChoiceGroupProps__f_onSelectChange = onSelectChange;
  this.Lscommons_reactnative_ui_ChoiceGroupProps__f_multiSelect = multiSelect;
  this.Lscommons_reactnative_ui_ChoiceGroupProps__f_style = style
}
$c_Lscommons_reactnative_ui_ChoiceGroupProps.prototype = new $h_O();
$c_Lscommons_reactnative_ui_ChoiceGroupProps.prototype.constructor = $c_Lscommons_reactnative_ui_ChoiceGroupProps;
/** @constructor */
function $h_Lscommons_reactnative_ui_ChoiceGroupProps() {
  /*<skip>*/
}
$h_Lscommons_reactnative_ui_ChoiceGroupProps.prototype = $c_Lscommons_reactnative_ui_ChoiceGroupProps.prototype;
$c_Lscommons_reactnative_ui_ChoiceGroupProps.prototype.productPrefix__T = (function() {
  return "ChoiceGroupProps"
});
$c_Lscommons_reactnative_ui_ChoiceGroupProps.prototype.productArity__I = (function() {
  return 8
});
$c_Lscommons_reactnative_ui_ChoiceGroupProps.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lscommons_reactnative_ui_ChoiceGroupProps__f_items;
      break
    }
    case 1: {
      return this.Lscommons_reactnative_ui_ChoiceGroupProps__f_keyExtractor;
      break
    }
    case 2: {
      return this.Lscommons_reactnative_ui_ChoiceGroupProps__f_iconRenderer;
      break
    }
    case 3: {
      return this.Lscommons_reactnative_ui_ChoiceGroupProps__f_labelRenderer;
      break
    }
    case 4: {
      return this.Lscommons_reactnative_ui_ChoiceGroupProps__f_selectedIds;
      break
    }
    case 5: {
      return this.Lscommons_reactnative_ui_ChoiceGroupProps__f_onSelectChange;
      break
    }
    case 6: {
      return this.Lscommons_reactnative_ui_ChoiceGroupProps__f_multiSelect;
      break
    }
    case 7: {
      return this.Lscommons_reactnative_ui_ChoiceGroupProps__f_style;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lscommons_reactnative_ui_ChoiceGroupProps.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscommons_reactnative_ui_ChoiceGroupProps.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("ChoiceGroupProps");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lscommons_reactnative_ui_ChoiceGroupProps__f_items;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x$1 = this.Lscommons_reactnative_ui_ChoiceGroupProps__f_keyExtractor;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x$2 = this.Lscommons_reactnative_ui_ChoiceGroupProps__f_iconRenderer;
  var data$3 = $m_sr_Statics$().anyHash__O__I(x$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var x$3 = this.Lscommons_reactnative_ui_ChoiceGroupProps__f_labelRenderer;
  var data$4 = $m_sr_Statics$().anyHash__O__I(x$3);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  var x$4 = this.Lscommons_reactnative_ui_ChoiceGroupProps__f_selectedIds;
  var data$5 = $m_sr_Statics$().anyHash__O__I(x$4);
  acc = $m_sr_Statics$().mix__I__I__I(hash$5, data$5);
  var hash$6 = acc;
  var x$5 = this.Lscommons_reactnative_ui_ChoiceGroupProps__f_onSelectChange;
  var data$6 = $m_sr_Statics$().anyHash__O__I(x$5);
  acc = $m_sr_Statics$().mix__I__I__I(hash$6, data$6);
  var hash$7 = acc;
  var data$7 = (this.Lscommons_reactnative_ui_ChoiceGroupProps__f_multiSelect ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$7, data$7);
  var hash$8 = acc;
  var x$6 = this.Lscommons_reactnative_ui_ChoiceGroupProps__f_style;
  var data$8 = $m_sr_Statics$().anyHash__O__I(x$6);
  acc = $m_sr_Statics$().mix__I__I__I(hash$8, data$8);
  var hash$9 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$9, 8)
});
$c_Lscommons_reactnative_ui_ChoiceGroupProps.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lscommons_reactnative_ui_ChoiceGroupProps.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lscommons_reactnative_ui_ChoiceGroupProps)) {
    var ChoiceGroupProps$1 = $as_Lscommons_reactnative_ui_ChoiceGroupProps(x$1);
    if ((this.Lscommons_reactnative_ui_ChoiceGroupProps__f_multiSelect === ChoiceGroupProps$1.Lscommons_reactnative_ui_ChoiceGroupProps__f_multiSelect)) {
      var x = this.Lscommons_reactnative_ui_ChoiceGroupProps__f_items;
      var x$2 = ChoiceGroupProps$1.Lscommons_reactnative_ui_ChoiceGroupProps__f_items;
      var $$x6 = ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
    } else {
      var $$x6 = false
    };
    if ($$x6) {
      var x$3 = this.Lscommons_reactnative_ui_ChoiceGroupProps__f_keyExtractor;
      var x$4 = ChoiceGroupProps$1.Lscommons_reactnative_ui_ChoiceGroupProps__f_keyExtractor;
      var $$x5 = ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4))
    } else {
      var $$x5 = false
    };
    if ($$x5) {
      var x$5 = this.Lscommons_reactnative_ui_ChoiceGroupProps__f_iconRenderer;
      var x$6 = ChoiceGroupProps$1.Lscommons_reactnative_ui_ChoiceGroupProps__f_iconRenderer;
      var $$x4 = (x$5 === x$6)
    } else {
      var $$x4 = false
    };
    if ($$x4) {
      var x$7 = this.Lscommons_reactnative_ui_ChoiceGroupProps__f_labelRenderer;
      var x$8 = ChoiceGroupProps$1.Lscommons_reactnative_ui_ChoiceGroupProps__f_labelRenderer;
      var $$x3 = (x$7 === x$8)
    } else {
      var $$x3 = false
    };
    if ($$x3) {
      var x$9 = this.Lscommons_reactnative_ui_ChoiceGroupProps__f_selectedIds;
      var x$10 = ChoiceGroupProps$1.Lscommons_reactnative_ui_ChoiceGroupProps__f_selectedIds;
      var $$x2 = ((x$9 === null) ? (x$10 === null) : x$9.equals__O__Z(x$10))
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      var x$11 = this.Lscommons_reactnative_ui_ChoiceGroupProps__f_onSelectChange;
      var x$12 = ChoiceGroupProps$1.Lscommons_reactnative_ui_ChoiceGroupProps__f_onSelectChange;
      var $$x1 = ((x$11 === null) ? (x$12 === null) : x$11.equals__O__Z(x$12))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$13 = this.Lscommons_reactnative_ui_ChoiceGroupProps__f_style;
      var x$14 = ChoiceGroupProps$1.Lscommons_reactnative_ui_ChoiceGroupProps__f_style;
      return ((x$13 === null) ? (x$14 === null) : x$13.equals__O__Z(x$14))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lscommons_reactnative_ui_ChoiceGroupProps(obj) {
  return (((obj instanceof $c_Lscommons_reactnative_ui_ChoiceGroupProps) || (obj === null)) ? obj : $throwClassCastException(obj, "scommons.reactnative.ui.ChoiceGroupProps"))
}
function $isArrayOf_Lscommons_reactnative_ui_ChoiceGroupProps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscommons_reactnative_ui_ChoiceGroupProps)))
}
function $asArrayOf_Lscommons_reactnative_ui_ChoiceGroupProps(obj, depth) {
  return (($isArrayOf_Lscommons_reactnative_ui_ChoiceGroupProps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscommons.reactnative.ui.ChoiceGroupProps;", depth))
}
var $d_Lscommons_reactnative_ui_ChoiceGroupProps = new $TypeData().initClass({
  Lscommons_reactnative_ui_ChoiceGroupProps: 0
}, false, "scommons.reactnative.ui.ChoiceGroupProps", {
  Lscommons_reactnative_ui_ChoiceGroupProps: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscommons_reactnative_ui_ChoiceGroupProps.prototype.$classData = $d_Lscommons_reactnative_ui_ChoiceGroupProps;
/** @constructor */
function $c_Lscommons_reactnative_ui_ChoiceItemData(id, text) {
  this.Lscommons_reactnative_ui_ChoiceItemData__f_id = null;
  this.Lscommons_reactnative_ui_ChoiceItemData__f_text = null;
  this.Lscommons_reactnative_ui_ChoiceItemData__f_id = id;
  this.Lscommons_reactnative_ui_ChoiceItemData__f_text = text
}
$c_Lscommons_reactnative_ui_ChoiceItemData.prototype = new $h_O();
$c_Lscommons_reactnative_ui_ChoiceItemData.prototype.constructor = $c_Lscommons_reactnative_ui_ChoiceItemData;
/** @constructor */
function $h_Lscommons_reactnative_ui_ChoiceItemData() {
  /*<skip>*/
}
$h_Lscommons_reactnative_ui_ChoiceItemData.prototype = $c_Lscommons_reactnative_ui_ChoiceItemData.prototype;
$c_Lscommons_reactnative_ui_ChoiceItemData.prototype.productPrefix__T = (function() {
  return "ChoiceItemData"
});
$c_Lscommons_reactnative_ui_ChoiceItemData.prototype.productArity__I = (function() {
  return 2
});
$c_Lscommons_reactnative_ui_ChoiceItemData.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lscommons_reactnative_ui_ChoiceItemData__f_id;
      break
    }
    case 1: {
      return this.Lscommons_reactnative_ui_ChoiceItemData__f_text;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lscommons_reactnative_ui_ChoiceItemData.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscommons_reactnative_ui_ChoiceItemData.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lscommons_reactnative_ui_ChoiceItemData.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lscommons_reactnative_ui_ChoiceItemData.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lscommons_reactnative_ui_ChoiceItemData)) {
    var ChoiceItemData$1 = $as_Lscommons_reactnative_ui_ChoiceItemData(x$1);
    return ((this.Lscommons_reactnative_ui_ChoiceItemData__f_id === ChoiceItemData$1.Lscommons_reactnative_ui_ChoiceItemData__f_id) && (this.Lscommons_reactnative_ui_ChoiceItemData__f_text === ChoiceItemData$1.Lscommons_reactnative_ui_ChoiceItemData__f_text))
  } else {
    return false
  }
});
function $as_Lscommons_reactnative_ui_ChoiceItemData(obj) {
  return (((obj instanceof $c_Lscommons_reactnative_ui_ChoiceItemData) || (obj === null)) ? obj : $throwClassCastException(obj, "scommons.reactnative.ui.ChoiceItemData"))
}
function $isArrayOf_Lscommons_reactnative_ui_ChoiceItemData(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscommons_reactnative_ui_ChoiceItemData)))
}
function $asArrayOf_Lscommons_reactnative_ui_ChoiceItemData(obj, depth) {
  return (($isArrayOf_Lscommons_reactnative_ui_ChoiceItemData(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscommons.reactnative.ui.ChoiceItemData;", depth))
}
var $d_Lscommons_reactnative_ui_ChoiceItemData = new $TypeData().initClass({
  Lscommons_reactnative_ui_ChoiceItemData: 0
}, false, "scommons.reactnative.ui.ChoiceItemData", {
  Lscommons_reactnative_ui_ChoiceItemData: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscommons_reactnative_ui_ChoiceItemData.prototype.$classData = $d_Lscommons_reactnative_ui_ChoiceItemData;
/** @constructor */
function $c_Lscommons_reactnative_ui_popup_ErrorPopupProps(error, onClose, details) {
  this.Lscommons_reactnative_ui_popup_ErrorPopupProps__f_error = null;
  this.Lscommons_reactnative_ui_popup_ErrorPopupProps__f_onClose = null;
  this.Lscommons_reactnative_ui_popup_ErrorPopupProps__f_details = null;
  this.Lscommons_reactnative_ui_popup_ErrorPopupProps__f_error = error;
  this.Lscommons_reactnative_ui_popup_ErrorPopupProps__f_onClose = onClose;
  this.Lscommons_reactnative_ui_popup_ErrorPopupProps__f_details = details
}
$c_Lscommons_reactnative_ui_popup_ErrorPopupProps.prototype = new $h_O();
$c_Lscommons_reactnative_ui_popup_ErrorPopupProps.prototype.constructor = $c_Lscommons_reactnative_ui_popup_ErrorPopupProps;
/** @constructor */
function $h_Lscommons_reactnative_ui_popup_ErrorPopupProps() {
  /*<skip>*/
}
$h_Lscommons_reactnative_ui_popup_ErrorPopupProps.prototype = $c_Lscommons_reactnative_ui_popup_ErrorPopupProps.prototype;
$c_Lscommons_reactnative_ui_popup_ErrorPopupProps.prototype.productPrefix__T = (function() {
  return "ErrorPopupProps"
});
$c_Lscommons_reactnative_ui_popup_ErrorPopupProps.prototype.productArity__I = (function() {
  return 3
});
$c_Lscommons_reactnative_ui_popup_ErrorPopupProps.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lscommons_reactnative_ui_popup_ErrorPopupProps__f_error;
      break
    }
    case 1: {
      return this.Lscommons_reactnative_ui_popup_ErrorPopupProps__f_onClose;
      break
    }
    case 2: {
      return this.Lscommons_reactnative_ui_popup_ErrorPopupProps__f_details;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lscommons_reactnative_ui_popup_ErrorPopupProps.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscommons_reactnative_ui_popup_ErrorPopupProps.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lscommons_reactnative_ui_popup_ErrorPopupProps.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lscommons_reactnative_ui_popup_ErrorPopupProps.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lscommons_reactnative_ui_popup_ErrorPopupProps)) {
    var ErrorPopupProps$1 = $as_Lscommons_reactnative_ui_popup_ErrorPopupProps(x$1);
    if ((this.Lscommons_reactnative_ui_popup_ErrorPopupProps__f_error === ErrorPopupProps$1.Lscommons_reactnative_ui_popup_ErrorPopupProps__f_error)) {
      var x = this.Lscommons_reactnative_ui_popup_ErrorPopupProps__f_onClose;
      var x$2 = ErrorPopupProps$1.Lscommons_reactnative_ui_popup_ErrorPopupProps__f_onClose;
      var $$x1 = (x === x$2)
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$3 = this.Lscommons_reactnative_ui_popup_ErrorPopupProps__f_details;
      var x$4 = ErrorPopupProps$1.Lscommons_reactnative_ui_popup_ErrorPopupProps__f_details;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lscommons_reactnative_ui_popup_ErrorPopupProps(obj) {
  return (((obj instanceof $c_Lscommons_reactnative_ui_popup_ErrorPopupProps) || (obj === null)) ? obj : $throwClassCastException(obj, "scommons.reactnative.ui.popup.ErrorPopupProps"))
}
function $isArrayOf_Lscommons_reactnative_ui_popup_ErrorPopupProps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscommons_reactnative_ui_popup_ErrorPopupProps)))
}
function $asArrayOf_Lscommons_reactnative_ui_popup_ErrorPopupProps(obj, depth) {
  return (($isArrayOf_Lscommons_reactnative_ui_popup_ErrorPopupProps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscommons.reactnative.ui.popup.ErrorPopupProps;", depth))
}
var $d_Lscommons_reactnative_ui_popup_ErrorPopupProps = new $TypeData().initClass({
  Lscommons_reactnative_ui_popup_ErrorPopupProps: 0
}, false, "scommons.reactnative.ui.popup.ErrorPopupProps", {
  Lscommons_reactnative_ui_popup_ErrorPopupProps: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscommons_reactnative_ui_popup_ErrorPopupProps.prototype.$classData = $d_Lscommons_reactnative_ui_popup_ErrorPopupProps;
/** @constructor */
function $c_Lscommons_reactnative_ui_popup_LoadingPopupProps(size, color) {
  this.Lscommons_reactnative_ui_popup_LoadingPopupProps__f_size = null;
  this.Lscommons_reactnative_ui_popup_LoadingPopupProps__f_color = null;
  this.Lscommons_reactnative_ui_popup_LoadingPopupProps__f_size = size;
  this.Lscommons_reactnative_ui_popup_LoadingPopupProps__f_color = color
}
$c_Lscommons_reactnative_ui_popup_LoadingPopupProps.prototype = new $h_O();
$c_Lscommons_reactnative_ui_popup_LoadingPopupProps.prototype.constructor = $c_Lscommons_reactnative_ui_popup_LoadingPopupProps;
/** @constructor */
function $h_Lscommons_reactnative_ui_popup_LoadingPopupProps() {
  /*<skip>*/
}
$h_Lscommons_reactnative_ui_popup_LoadingPopupProps.prototype = $c_Lscommons_reactnative_ui_popup_LoadingPopupProps.prototype;
$c_Lscommons_reactnative_ui_popup_LoadingPopupProps.prototype.productPrefix__T = (function() {
  return "LoadingPopupProps"
});
$c_Lscommons_reactnative_ui_popup_LoadingPopupProps.prototype.productArity__I = (function() {
  return 2
});
$c_Lscommons_reactnative_ui_popup_LoadingPopupProps.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lscommons_reactnative_ui_popup_LoadingPopupProps__f_size;
      break
    }
    case 1: {
      return this.Lscommons_reactnative_ui_popup_LoadingPopupProps__f_color;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lscommons_reactnative_ui_popup_LoadingPopupProps.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscommons_reactnative_ui_popup_LoadingPopupProps.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lscommons_reactnative_ui_popup_LoadingPopupProps.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lscommons_reactnative_ui_popup_LoadingPopupProps.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lscommons_reactnative_ui_popup_LoadingPopupProps)) {
    var LoadingPopupProps$1 = $as_Lscommons_reactnative_ui_popup_LoadingPopupProps(x$1);
    var x = this.Lscommons_reactnative_ui_popup_LoadingPopupProps__f_size;
    var y = LoadingPopupProps$1.Lscommons_reactnative_ui_popup_LoadingPopupProps__f_size;
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      return (this.Lscommons_reactnative_ui_popup_LoadingPopupProps__f_color === LoadingPopupProps$1.Lscommons_reactnative_ui_popup_LoadingPopupProps__f_color)
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lscommons_reactnative_ui_popup_LoadingPopupProps(obj) {
  return (((obj instanceof $c_Lscommons_reactnative_ui_popup_LoadingPopupProps) || (obj === null)) ? obj : $throwClassCastException(obj, "scommons.reactnative.ui.popup.LoadingPopupProps"))
}
function $isArrayOf_Lscommons_reactnative_ui_popup_LoadingPopupProps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscommons_reactnative_ui_popup_LoadingPopupProps)))
}
function $asArrayOf_Lscommons_reactnative_ui_popup_LoadingPopupProps(obj, depth) {
  return (($isArrayOf_Lscommons_reactnative_ui_popup_LoadingPopupProps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscommons.reactnative.ui.popup.LoadingPopupProps;", depth))
}
var $d_Lscommons_reactnative_ui_popup_LoadingPopupProps = new $TypeData().initClass({
  Lscommons_reactnative_ui_popup_LoadingPopupProps: 0
}, false, "scommons.reactnative.ui.popup.LoadingPopupProps", {
  Lscommons_reactnative_ui_popup_LoadingPopupProps: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscommons_reactnative_ui_popup_LoadingPopupProps.prototype.$classData = $d_Lscommons_reactnative_ui_popup_LoadingPopupProps;
/** @constructor */
function $c_Lshowcase_FlatListDemo$Data(id, title) {
  this.Lshowcase_FlatListDemo$Data__f_id = null;
  this.Lshowcase_FlatListDemo$Data__f_title = null;
  this.Lshowcase_FlatListDemo$Data__f_id = id;
  this.Lshowcase_FlatListDemo$Data__f_title = title
}
$c_Lshowcase_FlatListDemo$Data.prototype = new $h_O();
$c_Lshowcase_FlatListDemo$Data.prototype.constructor = $c_Lshowcase_FlatListDemo$Data;
/** @constructor */
function $h_Lshowcase_FlatListDemo$Data() {
  /*<skip>*/
}
$h_Lshowcase_FlatListDemo$Data.prototype = $c_Lshowcase_FlatListDemo$Data.prototype;
$c_Lshowcase_FlatListDemo$Data.prototype.productPrefix__T = (function() {
  return "Data"
});
$c_Lshowcase_FlatListDemo$Data.prototype.productArity__I = (function() {
  return 2
});
$c_Lshowcase_FlatListDemo$Data.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lshowcase_FlatListDemo$Data__f_id;
      break
    }
    case 1: {
      return this.Lshowcase_FlatListDemo$Data__f_title;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lshowcase_FlatListDemo$Data.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lshowcase_FlatListDemo$Data.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lshowcase_FlatListDemo$Data.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lshowcase_FlatListDemo$Data.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lshowcase_FlatListDemo$Data)) {
    var Data$1 = $as_Lshowcase_FlatListDemo$Data(x$1);
    return ((this.Lshowcase_FlatListDemo$Data__f_id === Data$1.Lshowcase_FlatListDemo$Data__f_id) && (this.Lshowcase_FlatListDemo$Data__f_title === Data$1.Lshowcase_FlatListDemo$Data__f_title))
  } else {
    return false
  }
});
function $as_Lshowcase_FlatListDemo$Data(obj) {
  return (((obj instanceof $c_Lshowcase_FlatListDemo$Data) || (obj === null)) ? obj : $throwClassCastException(obj, "showcase.FlatListDemo$Data"))
}
function $isArrayOf_Lshowcase_FlatListDemo$Data(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lshowcase_FlatListDemo$Data)))
}
function $asArrayOf_Lshowcase_FlatListDemo$Data(obj, depth) {
  return (($isArrayOf_Lshowcase_FlatListDemo$Data(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lshowcase.FlatListDemo$Data;", depth))
}
var $d_Lshowcase_FlatListDemo$Data = new $TypeData().initClass({
  Lshowcase_FlatListDemo$Data: 0
}, false, "showcase.FlatListDemo$Data", {
  Lshowcase_FlatListDemo$Data: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lshowcase_FlatListDemo$Data.prototype.$classData = $d_Lshowcase_FlatListDemo$Data;
/** @constructor */
function $c_Lshowcase_FlatListDemo$ItemProps(title, selected, onPress) {
  this.Lshowcase_FlatListDemo$ItemProps__f_title = null;
  this.Lshowcase_FlatListDemo$ItemProps__f_selected = false;
  this.Lshowcase_FlatListDemo$ItemProps__f_onPress = null;
  this.Lshowcase_FlatListDemo$ItemProps__f_title = title;
  this.Lshowcase_FlatListDemo$ItemProps__f_selected = selected;
  this.Lshowcase_FlatListDemo$ItemProps__f_onPress = onPress
}
$c_Lshowcase_FlatListDemo$ItemProps.prototype = new $h_O();
$c_Lshowcase_FlatListDemo$ItemProps.prototype.constructor = $c_Lshowcase_FlatListDemo$ItemProps;
/** @constructor */
function $h_Lshowcase_FlatListDemo$ItemProps() {
  /*<skip>*/
}
$h_Lshowcase_FlatListDemo$ItemProps.prototype = $c_Lshowcase_FlatListDemo$ItemProps.prototype;
$c_Lshowcase_FlatListDemo$ItemProps.prototype.productPrefix__T = (function() {
  return "ItemProps"
});
$c_Lshowcase_FlatListDemo$ItemProps.prototype.productArity__I = (function() {
  return 3
});
$c_Lshowcase_FlatListDemo$ItemProps.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lshowcase_FlatListDemo$ItemProps__f_title;
      break
    }
    case 1: {
      return this.Lshowcase_FlatListDemo$ItemProps__f_selected;
      break
    }
    case 2: {
      return this.Lshowcase_FlatListDemo$ItemProps__f_onPress;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lshowcase_FlatListDemo$ItemProps.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lshowcase_FlatListDemo$ItemProps.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("ItemProps");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lshowcase_FlatListDemo$ItemProps__f_title;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var data$2 = (this.Lshowcase_FlatListDemo$ItemProps__f_selected ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x$1 = this.Lshowcase_FlatListDemo$ItemProps__f_onPress;
  var data$3 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$4, 3)
});
$c_Lshowcase_FlatListDemo$ItemProps.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lshowcase_FlatListDemo$ItemProps.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lshowcase_FlatListDemo$ItemProps)) {
    var ItemProps$1 = $as_Lshowcase_FlatListDemo$ItemProps(x$1);
    if (((this.Lshowcase_FlatListDemo$ItemProps__f_selected === ItemProps$1.Lshowcase_FlatListDemo$ItemProps__f_selected) && (this.Lshowcase_FlatListDemo$ItemProps__f_title === ItemProps$1.Lshowcase_FlatListDemo$ItemProps__f_title))) {
      var x = this.Lshowcase_FlatListDemo$ItemProps__f_onPress;
      var x$2 = ItemProps$1.Lshowcase_FlatListDemo$ItemProps__f_onPress;
      return (x === x$2)
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lshowcase_FlatListDemo$ItemProps(obj) {
  return (((obj instanceof $c_Lshowcase_FlatListDemo$ItemProps) || (obj === null)) ? obj : $throwClassCastException(obj, "showcase.FlatListDemo$ItemProps"))
}
function $isArrayOf_Lshowcase_FlatListDemo$ItemProps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lshowcase_FlatListDemo$ItemProps)))
}
function $asArrayOf_Lshowcase_FlatListDemo$ItemProps(obj, depth) {
  return (($isArrayOf_Lshowcase_FlatListDemo$ItemProps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lshowcase.FlatListDemo$ItemProps;", depth))
}
var $d_Lshowcase_FlatListDemo$ItemProps = new $TypeData().initClass({
  Lshowcase_FlatListDemo$ItemProps: 0
}, false, "showcase.FlatListDemo$ItemProps", {
  Lshowcase_FlatListDemo$ItemProps: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lshowcase_FlatListDemo$ItemProps.prototype.$classData = $d_Lshowcase_FlatListDemo$ItemProps;
/** @constructor */
function $c_Lshowcase_SwitchDemoProps(dispatch, actions, darkTheme) {
  this.Lshowcase_SwitchDemoProps__f_dispatch = null;
  this.Lshowcase_SwitchDemoProps__f_actions = null;
  this.Lshowcase_SwitchDemoProps__f_darkTheme = false;
  this.Lshowcase_SwitchDemoProps__f_dispatch = dispatch;
  this.Lshowcase_SwitchDemoProps__f_actions = actions;
  this.Lshowcase_SwitchDemoProps__f_darkTheme = darkTheme
}
$c_Lshowcase_SwitchDemoProps.prototype = new $h_O();
$c_Lshowcase_SwitchDemoProps.prototype.constructor = $c_Lshowcase_SwitchDemoProps;
/** @constructor */
function $h_Lshowcase_SwitchDemoProps() {
  /*<skip>*/
}
$h_Lshowcase_SwitchDemoProps.prototype = $c_Lshowcase_SwitchDemoProps.prototype;
$c_Lshowcase_SwitchDemoProps.prototype.productPrefix__T = (function() {
  return "SwitchDemoProps"
});
$c_Lshowcase_SwitchDemoProps.prototype.productArity__I = (function() {
  return 3
});
$c_Lshowcase_SwitchDemoProps.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lshowcase_SwitchDemoProps__f_dispatch;
      break
    }
    case 1: {
      return this.Lshowcase_SwitchDemoProps__f_actions;
      break
    }
    case 2: {
      return this.Lshowcase_SwitchDemoProps__f_darkTheme;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lshowcase_SwitchDemoProps.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lshowcase_SwitchDemoProps.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("SwitchDemoProps");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lshowcase_SwitchDemoProps__f_dispatch;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x$1 = this.Lshowcase_SwitchDemoProps__f_actions;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var data$3 = (this.Lshowcase_SwitchDemoProps__f_darkTheme ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$4, 3)
});
$c_Lshowcase_SwitchDemoProps.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lshowcase_SwitchDemoProps.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lshowcase_SwitchDemoProps)) {
    var SwitchDemoProps$1 = $as_Lshowcase_SwitchDemoProps(x$1);
    if ((this.Lshowcase_SwitchDemoProps__f_darkTheme === SwitchDemoProps$1.Lshowcase_SwitchDemoProps__f_darkTheme)) {
      var x = this.Lshowcase_SwitchDemoProps__f_dispatch;
      var x$2 = SwitchDemoProps$1.Lshowcase_SwitchDemoProps__f_dispatch;
      var $$x1 = ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$3 = this.Lshowcase_SwitchDemoProps__f_actions;
      var x$4 = SwitchDemoProps$1.Lshowcase_SwitchDemoProps__f_actions;
      return (x$3 === x$4)
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lshowcase_SwitchDemoProps(obj) {
  return (((obj instanceof $c_Lshowcase_SwitchDemoProps) || (obj === null)) ? obj : $throwClassCastException(obj, "showcase.SwitchDemoProps"))
}
function $isArrayOf_Lshowcase_SwitchDemoProps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lshowcase_SwitchDemoProps)))
}
function $asArrayOf_Lshowcase_SwitchDemoProps(obj, depth) {
  return (($isArrayOf_Lshowcase_SwitchDemoProps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lshowcase.SwitchDemoProps;", depth))
}
var $d_Lshowcase_SwitchDemoProps = new $TypeData().initClass({
  Lshowcase_SwitchDemoProps: 0
}, false, "showcase.SwitchDemoProps", {
  Lshowcase_SwitchDemoProps: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lshowcase_SwitchDemoProps.prototype.$classData = $d_Lshowcase_SwitchDemoProps;
/** @constructor */
function $c_Lshowcase_app_ReactNativeDemoScreenProps(navigate) {
  this.Lshowcase_app_ReactNativeDemoScreenProps__f_navigate = null;
  this.Lshowcase_app_ReactNativeDemoScreenProps__f_navigate = navigate
}
$c_Lshowcase_app_ReactNativeDemoScreenProps.prototype = new $h_O();
$c_Lshowcase_app_ReactNativeDemoScreenProps.prototype.constructor = $c_Lshowcase_app_ReactNativeDemoScreenProps;
/** @constructor */
function $h_Lshowcase_app_ReactNativeDemoScreenProps() {
  /*<skip>*/
}
$h_Lshowcase_app_ReactNativeDemoScreenProps.prototype = $c_Lshowcase_app_ReactNativeDemoScreenProps.prototype;
$c_Lshowcase_app_ReactNativeDemoScreenProps.prototype.productPrefix__T = (function() {
  return "ReactNativeDemoScreenProps"
});
$c_Lshowcase_app_ReactNativeDemoScreenProps.prototype.productArity__I = (function() {
  return 1
});
$c_Lshowcase_app_ReactNativeDemoScreenProps.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lshowcase_app_ReactNativeDemoScreenProps__f_navigate : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lshowcase_app_ReactNativeDemoScreenProps.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lshowcase_app_ReactNativeDemoScreenProps.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lshowcase_app_ReactNativeDemoScreenProps.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lshowcase_app_ReactNativeDemoScreenProps.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lshowcase_app_ReactNativeDemoScreenProps)) {
    var ReactNativeDemoScreenProps$1 = $as_Lshowcase_app_ReactNativeDemoScreenProps(x$1);
    var x = this.Lshowcase_app_ReactNativeDemoScreenProps__f_navigate;
    var x$2 = ReactNativeDemoScreenProps$1.Lshowcase_app_ReactNativeDemoScreenProps__f_navigate;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lshowcase_app_ReactNativeDemoScreenProps(obj) {
  return (((obj instanceof $c_Lshowcase_app_ReactNativeDemoScreenProps) || (obj === null)) ? obj : $throwClassCastException(obj, "showcase.app.ReactNativeDemoScreenProps"))
}
function $isArrayOf_Lshowcase_app_ReactNativeDemoScreenProps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lshowcase_app_ReactNativeDemoScreenProps)))
}
function $asArrayOf_Lshowcase_app_ReactNativeDemoScreenProps(obj, depth) {
  return (($isArrayOf_Lshowcase_app_ReactNativeDemoScreenProps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lshowcase.app.ReactNativeDemoScreenProps;", depth))
}
var $d_Lshowcase_app_ReactNativeDemoScreenProps = new $TypeData().initClass({
  Lshowcase_app_ReactNativeDemoScreenProps: 0
}, false, "showcase.app.ReactNativeDemoScreenProps", {
  Lshowcase_app_ReactNativeDemoScreenProps: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lshowcase_app_ReactNativeDemoScreenProps.prototype.$classData = $d_Lshowcase_app_ReactNativeDemoScreenProps;
/** @constructor */
function $c_Lshowcase_app_ShowcaseListViewProps(items, navigate) {
  this.Lshowcase_app_ShowcaseListViewProps__f_items = null;
  this.Lshowcase_app_ShowcaseListViewProps__f_navigate = null;
  this.Lshowcase_app_ShowcaseListViewProps__f_items = items;
  this.Lshowcase_app_ShowcaseListViewProps__f_navigate = navigate
}
$c_Lshowcase_app_ShowcaseListViewProps.prototype = new $h_O();
$c_Lshowcase_app_ShowcaseListViewProps.prototype.constructor = $c_Lshowcase_app_ShowcaseListViewProps;
/** @constructor */
function $h_Lshowcase_app_ShowcaseListViewProps() {
  /*<skip>*/
}
$h_Lshowcase_app_ShowcaseListViewProps.prototype = $c_Lshowcase_app_ShowcaseListViewProps.prototype;
$c_Lshowcase_app_ShowcaseListViewProps.prototype.productPrefix__T = (function() {
  return "ShowcaseListViewProps"
});
$c_Lshowcase_app_ShowcaseListViewProps.prototype.productArity__I = (function() {
  return 2
});
$c_Lshowcase_app_ShowcaseListViewProps.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lshowcase_app_ShowcaseListViewProps__f_items;
      break
    }
    case 1: {
      return this.Lshowcase_app_ShowcaseListViewProps__f_navigate;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lshowcase_app_ShowcaseListViewProps.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lshowcase_app_ShowcaseListViewProps.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lshowcase_app_ShowcaseListViewProps.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lshowcase_app_ShowcaseListViewProps.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lshowcase_app_ShowcaseListViewProps)) {
    var ShowcaseListViewProps$1 = $as_Lshowcase_app_ShowcaseListViewProps(x$1);
    var x = this.Lshowcase_app_ShowcaseListViewProps__f_items;
    var x$2 = ShowcaseListViewProps$1.Lshowcase_app_ShowcaseListViewProps__f_items;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lshowcase_app_ShowcaseListViewProps__f_navigate;
      var x$4 = ShowcaseListViewProps$1.Lshowcase_app_ShowcaseListViewProps__f_navigate;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lshowcase_app_ShowcaseListViewProps(obj) {
  return (((obj instanceof $c_Lshowcase_app_ShowcaseListViewProps) || (obj === null)) ? obj : $throwClassCastException(obj, "showcase.app.ShowcaseListViewProps"))
}
function $isArrayOf_Lshowcase_app_ShowcaseListViewProps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lshowcase_app_ShowcaseListViewProps)))
}
function $asArrayOf_Lshowcase_app_ShowcaseListViewProps(obj, depth) {
  return (($isArrayOf_Lshowcase_app_ShowcaseListViewProps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lshowcase.app.ShowcaseListViewProps;", depth))
}
var $d_Lshowcase_app_ShowcaseListViewProps = new $TypeData().initClass({
  Lshowcase_app_ShowcaseListViewProps: 0
}, false, "showcase.app.ShowcaseListViewProps", {
  Lshowcase_app_ShowcaseListViewProps: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lshowcase_app_ShowcaseListViewProps.prototype.$classData = $d_Lshowcase_app_ShowcaseListViewProps;
/** @constructor */
function $c_Lshowcase_app_ShowcaseRootProps(darkTheme) {
  this.Lshowcase_app_ShowcaseRootProps__f_darkTheme = false;
  this.Lshowcase_app_ShowcaseRootProps__f_darkTheme = darkTheme
}
$c_Lshowcase_app_ShowcaseRootProps.prototype = new $h_O();
$c_Lshowcase_app_ShowcaseRootProps.prototype.constructor = $c_Lshowcase_app_ShowcaseRootProps;
/** @constructor */
function $h_Lshowcase_app_ShowcaseRootProps() {
  /*<skip>*/
}
$h_Lshowcase_app_ShowcaseRootProps.prototype = $c_Lshowcase_app_ShowcaseRootProps.prototype;
$c_Lshowcase_app_ShowcaseRootProps.prototype.productPrefix__T = (function() {
  return "ShowcaseRootProps"
});
$c_Lshowcase_app_ShowcaseRootProps.prototype.productArity__I = (function() {
  return 1
});
$c_Lshowcase_app_ShowcaseRootProps.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lshowcase_app_ShowcaseRootProps__f_darkTheme : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lshowcase_app_ShowcaseRootProps.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lshowcase_app_ShowcaseRootProps.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("ShowcaseRootProps");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = (this.Lshowcase_app_ShowcaseRootProps__f_darkTheme ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$2, 1)
});
$c_Lshowcase_app_ShowcaseRootProps.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lshowcase_app_ShowcaseRootProps.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lshowcase_app_ShowcaseRootProps)) {
    var ShowcaseRootProps$1 = $as_Lshowcase_app_ShowcaseRootProps(x$1);
    return (this.Lshowcase_app_ShowcaseRootProps__f_darkTheme === ShowcaseRootProps$1.Lshowcase_app_ShowcaseRootProps__f_darkTheme)
  } else {
    return false
  }
});
function $as_Lshowcase_app_ShowcaseRootProps(obj) {
  return (((obj instanceof $c_Lshowcase_app_ShowcaseRootProps) || (obj === null)) ? obj : $throwClassCastException(obj, "showcase.app.ShowcaseRootProps"))
}
function $isArrayOf_Lshowcase_app_ShowcaseRootProps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lshowcase_app_ShowcaseRootProps)))
}
function $asArrayOf_Lshowcase_app_ShowcaseRootProps(obj, depth) {
  return (($isArrayOf_Lshowcase_app_ShowcaseRootProps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lshowcase.app.ShowcaseRootProps;", depth))
}
var $d_Lshowcase_app_ShowcaseRootProps = new $TypeData().initClass({
  Lshowcase_app_ShowcaseRootProps: 0
}, false, "showcase.app.ShowcaseRootProps", {
  Lshowcase_app_ShowcaseRootProps: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lshowcase_app_ShowcaseRootProps.prototype.$classData = $d_Lshowcase_app_ShowcaseRootProps;
/** @constructor */
function $c_Lshowcase_app_ShowcaseScreenProps(navigate) {
  this.Lshowcase_app_ShowcaseScreenProps__f_navigate = null;
  this.Lshowcase_app_ShowcaseScreenProps__f_navigate = navigate
}
$c_Lshowcase_app_ShowcaseScreenProps.prototype = new $h_O();
$c_Lshowcase_app_ShowcaseScreenProps.prototype.constructor = $c_Lshowcase_app_ShowcaseScreenProps;
/** @constructor */
function $h_Lshowcase_app_ShowcaseScreenProps() {
  /*<skip>*/
}
$h_Lshowcase_app_ShowcaseScreenProps.prototype = $c_Lshowcase_app_ShowcaseScreenProps.prototype;
$c_Lshowcase_app_ShowcaseScreenProps.prototype.productPrefix__T = (function() {
  return "ShowcaseScreenProps"
});
$c_Lshowcase_app_ShowcaseScreenProps.prototype.productArity__I = (function() {
  return 1
});
$c_Lshowcase_app_ShowcaseScreenProps.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lshowcase_app_ShowcaseScreenProps__f_navigate : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lshowcase_app_ShowcaseScreenProps.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lshowcase_app_ShowcaseScreenProps.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lshowcase_app_ShowcaseScreenProps.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lshowcase_app_ShowcaseScreenProps.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lshowcase_app_ShowcaseScreenProps)) {
    var ShowcaseScreenProps$1 = $as_Lshowcase_app_ShowcaseScreenProps(x$1);
    var x = this.Lshowcase_app_ShowcaseScreenProps__f_navigate;
    var x$2 = ShowcaseScreenProps$1.Lshowcase_app_ShowcaseScreenProps__f_navigate;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lshowcase_app_ShowcaseScreenProps(obj) {
  return (((obj instanceof $c_Lshowcase_app_ShowcaseScreenProps) || (obj === null)) ? obj : $throwClassCastException(obj, "showcase.app.ShowcaseScreenProps"))
}
function $isArrayOf_Lshowcase_app_ShowcaseScreenProps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lshowcase_app_ShowcaseScreenProps)))
}
function $asArrayOf_Lshowcase_app_ShowcaseScreenProps(obj, depth) {
  return (($isArrayOf_Lshowcase_app_ShowcaseScreenProps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lshowcase.app.ShowcaseScreenProps;", depth))
}
var $d_Lshowcase_app_ShowcaseScreenProps = new $TypeData().initClass({
  Lshowcase_app_ShowcaseScreenProps: 0
}, false, "showcase.app.ShowcaseScreenProps", {
  Lshowcase_app_ShowcaseScreenProps: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lshowcase_app_ShowcaseScreenProps.prototype.$classData = $d_Lshowcase_app_ShowcaseScreenProps;
/** @constructor */
function $c_Lshowcase_app_community_CommunityDemoScreenProps(navigate) {
  this.Lshowcase_app_community_CommunityDemoScreenProps__f_navigate = null;
  this.Lshowcase_app_community_CommunityDemoScreenProps__f_navigate = navigate
}
$c_Lshowcase_app_community_CommunityDemoScreenProps.prototype = new $h_O();
$c_Lshowcase_app_community_CommunityDemoScreenProps.prototype.constructor = $c_Lshowcase_app_community_CommunityDemoScreenProps;
/** @constructor */
function $h_Lshowcase_app_community_CommunityDemoScreenProps() {
  /*<skip>*/
}
$h_Lshowcase_app_community_CommunityDemoScreenProps.prototype = $c_Lshowcase_app_community_CommunityDemoScreenProps.prototype;
$c_Lshowcase_app_community_CommunityDemoScreenProps.prototype.productPrefix__T = (function() {
  return "CommunityDemoScreenProps"
});
$c_Lshowcase_app_community_CommunityDemoScreenProps.prototype.productArity__I = (function() {
  return 1
});
$c_Lshowcase_app_community_CommunityDemoScreenProps.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lshowcase_app_community_CommunityDemoScreenProps__f_navigate : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lshowcase_app_community_CommunityDemoScreenProps.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lshowcase_app_community_CommunityDemoScreenProps.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lshowcase_app_community_CommunityDemoScreenProps.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lshowcase_app_community_CommunityDemoScreenProps.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lshowcase_app_community_CommunityDemoScreenProps)) {
    var CommunityDemoScreenProps$1 = $as_Lshowcase_app_community_CommunityDemoScreenProps(x$1);
    var x = this.Lshowcase_app_community_CommunityDemoScreenProps__f_navigate;
    var x$2 = CommunityDemoScreenProps$1.Lshowcase_app_community_CommunityDemoScreenProps__f_navigate;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lshowcase_app_community_CommunityDemoScreenProps(obj) {
  return (((obj instanceof $c_Lshowcase_app_community_CommunityDemoScreenProps) || (obj === null)) ? obj : $throwClassCastException(obj, "showcase.app.community.CommunityDemoScreenProps"))
}
function $isArrayOf_Lshowcase_app_community_CommunityDemoScreenProps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lshowcase_app_community_CommunityDemoScreenProps)))
}
function $asArrayOf_Lshowcase_app_community_CommunityDemoScreenProps(obj, depth) {
  return (($isArrayOf_Lshowcase_app_community_CommunityDemoScreenProps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lshowcase.app.community.CommunityDemoScreenProps;", depth))
}
var $d_Lshowcase_app_community_CommunityDemoScreenProps = new $TypeData().initClass({
  Lshowcase_app_community_CommunityDemoScreenProps: 0
}, false, "showcase.app.community.CommunityDemoScreenProps", {
  Lshowcase_app_community_CommunityDemoScreenProps: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lshowcase_app_community_CommunityDemoScreenProps.prototype.$classData = $d_Lshowcase_app_community_CommunityDemoScreenProps;
/** @constructor */
function $c_Lshowcase_app_config_ShowcaseConfig(darkTheme) {
  this.Lshowcase_app_config_ShowcaseConfig__f_darkTheme = false;
  this.Lshowcase_app_config_ShowcaseConfig__f_darkTheme = darkTheme
}
$c_Lshowcase_app_config_ShowcaseConfig.prototype = new $h_O();
$c_Lshowcase_app_config_ShowcaseConfig.prototype.constructor = $c_Lshowcase_app_config_ShowcaseConfig;
/** @constructor */
function $h_Lshowcase_app_config_ShowcaseConfig() {
  /*<skip>*/
}
$h_Lshowcase_app_config_ShowcaseConfig.prototype = $c_Lshowcase_app_config_ShowcaseConfig.prototype;
$c_Lshowcase_app_config_ShowcaseConfig.prototype.productPrefix__T = (function() {
  return "ShowcaseConfig"
});
$c_Lshowcase_app_config_ShowcaseConfig.prototype.productArity__I = (function() {
  return 1
});
$c_Lshowcase_app_config_ShowcaseConfig.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lshowcase_app_config_ShowcaseConfig__f_darkTheme : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lshowcase_app_config_ShowcaseConfig.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lshowcase_app_config_ShowcaseConfig.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("ShowcaseConfig");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = (this.Lshowcase_app_config_ShowcaseConfig__f_darkTheme ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$2, 1)
});
$c_Lshowcase_app_config_ShowcaseConfig.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lshowcase_app_config_ShowcaseConfig.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lshowcase_app_config_ShowcaseConfig)) {
    var ShowcaseConfig$1 = $as_Lshowcase_app_config_ShowcaseConfig(x$1);
    return (this.Lshowcase_app_config_ShowcaseConfig__f_darkTheme === ShowcaseConfig$1.Lshowcase_app_config_ShowcaseConfig__f_darkTheme)
  } else {
    return false
  }
});
function $as_Lshowcase_app_config_ShowcaseConfig(obj) {
  return (((obj instanceof $c_Lshowcase_app_config_ShowcaseConfig) || (obj === null)) ? obj : $throwClassCastException(obj, "showcase.app.config.ShowcaseConfig"))
}
function $isArrayOf_Lshowcase_app_config_ShowcaseConfig(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lshowcase_app_config_ShowcaseConfig)))
}
function $asArrayOf_Lshowcase_app_config_ShowcaseConfig(obj, depth) {
  return (($isArrayOf_Lshowcase_app_config_ShowcaseConfig(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lshowcase.app.config.ShowcaseConfig;", depth))
}
var $d_Lshowcase_app_config_ShowcaseConfig = new $TypeData().initClass({
  Lshowcase_app_config_ShowcaseConfig: 0
}, false, "showcase.app.config.ShowcaseConfig", {
  Lshowcase_app_config_ShowcaseConfig: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lshowcase_app_config_ShowcaseConfig.prototype.$classData = $d_Lshowcase_app_config_ShowcaseConfig;
/** @constructor */
function $c_Lshowcase_app_expo_ExpoDemoScreenProps(navigate) {
  this.Lshowcase_app_expo_ExpoDemoScreenProps__f_navigate = null;
  this.Lshowcase_app_expo_ExpoDemoScreenProps__f_navigate = navigate
}
$c_Lshowcase_app_expo_ExpoDemoScreenProps.prototype = new $h_O();
$c_Lshowcase_app_expo_ExpoDemoScreenProps.prototype.constructor = $c_Lshowcase_app_expo_ExpoDemoScreenProps;
/** @constructor */
function $h_Lshowcase_app_expo_ExpoDemoScreenProps() {
  /*<skip>*/
}
$h_Lshowcase_app_expo_ExpoDemoScreenProps.prototype = $c_Lshowcase_app_expo_ExpoDemoScreenProps.prototype;
$c_Lshowcase_app_expo_ExpoDemoScreenProps.prototype.productPrefix__T = (function() {
  return "ExpoDemoScreenProps"
});
$c_Lshowcase_app_expo_ExpoDemoScreenProps.prototype.productArity__I = (function() {
  return 1
});
$c_Lshowcase_app_expo_ExpoDemoScreenProps.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lshowcase_app_expo_ExpoDemoScreenProps__f_navigate : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lshowcase_app_expo_ExpoDemoScreenProps.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lshowcase_app_expo_ExpoDemoScreenProps.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lshowcase_app_expo_ExpoDemoScreenProps.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lshowcase_app_expo_ExpoDemoScreenProps.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lshowcase_app_expo_ExpoDemoScreenProps)) {
    var ExpoDemoScreenProps$1 = $as_Lshowcase_app_expo_ExpoDemoScreenProps(x$1);
    var x = this.Lshowcase_app_expo_ExpoDemoScreenProps__f_navigate;
    var x$2 = ExpoDemoScreenProps$1.Lshowcase_app_expo_ExpoDemoScreenProps__f_navigate;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lshowcase_app_expo_ExpoDemoScreenProps(obj) {
  return (((obj instanceof $c_Lshowcase_app_expo_ExpoDemoScreenProps) || (obj === null)) ? obj : $throwClassCastException(obj, "showcase.app.expo.ExpoDemoScreenProps"))
}
function $isArrayOf_Lshowcase_app_expo_ExpoDemoScreenProps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lshowcase_app_expo_ExpoDemoScreenProps)))
}
function $asArrayOf_Lshowcase_app_expo_ExpoDemoScreenProps(obj, depth) {
  return (($isArrayOf_Lshowcase_app_expo_ExpoDemoScreenProps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lshowcase.app.expo.ExpoDemoScreenProps;", depth))
}
var $d_Lshowcase_app_expo_ExpoDemoScreenProps = new $TypeData().initClass({
  Lshowcase_app_expo_ExpoDemoScreenProps: 0
}, false, "showcase.app.expo.ExpoDemoScreenProps", {
  Lshowcase_app_expo_ExpoDemoScreenProps: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lshowcase_app_expo_ExpoDemoScreenProps.prototype.$classData = $d_Lshowcase_app_expo_ExpoDemoScreenProps;
/** @constructor */
function $c_Lshowcase_app_style_StylesScreenProps(navigate) {
  this.Lshowcase_app_style_StylesScreenProps__f_navigate = null;
  this.Lshowcase_app_style_StylesScreenProps__f_navigate = navigate
}
$c_Lshowcase_app_style_StylesScreenProps.prototype = new $h_O();
$c_Lshowcase_app_style_StylesScreenProps.prototype.constructor = $c_Lshowcase_app_style_StylesScreenProps;
/** @constructor */
function $h_Lshowcase_app_style_StylesScreenProps() {
  /*<skip>*/
}
$h_Lshowcase_app_style_StylesScreenProps.prototype = $c_Lshowcase_app_style_StylesScreenProps.prototype;
$c_Lshowcase_app_style_StylesScreenProps.prototype.productPrefix__T = (function() {
  return "StylesScreenProps"
});
$c_Lshowcase_app_style_StylesScreenProps.prototype.productArity__I = (function() {
  return 1
});
$c_Lshowcase_app_style_StylesScreenProps.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lshowcase_app_style_StylesScreenProps__f_navigate : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lshowcase_app_style_StylesScreenProps.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lshowcase_app_style_StylesScreenProps.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lshowcase_app_style_StylesScreenProps.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lshowcase_app_style_StylesScreenProps.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lshowcase_app_style_StylesScreenProps)) {
    var StylesScreenProps$1 = $as_Lshowcase_app_style_StylesScreenProps(x$1);
    var x = this.Lshowcase_app_style_StylesScreenProps__f_navigate;
    var x$2 = StylesScreenProps$1.Lshowcase_app_style_StylesScreenProps__f_navigate;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lshowcase_app_style_StylesScreenProps(obj) {
  return (((obj instanceof $c_Lshowcase_app_style_StylesScreenProps) || (obj === null)) ? obj : $throwClassCastException(obj, "showcase.app.style.StylesScreenProps"))
}
function $isArrayOf_Lshowcase_app_style_StylesScreenProps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lshowcase_app_style_StylesScreenProps)))
}
function $asArrayOf_Lshowcase_app_style_StylesScreenProps(obj, depth) {
  return (($isArrayOf_Lshowcase_app_style_StylesScreenProps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lshowcase.app.style.StylesScreenProps;", depth))
}
var $d_Lshowcase_app_style_StylesScreenProps = new $TypeData().initClass({
  Lshowcase_app_style_StylesScreenProps: 0
}, false, "showcase.app.style.StylesScreenProps", {
  Lshowcase_app_style_StylesScreenProps: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lshowcase_app_style_StylesScreenProps.prototype.$classData = $d_Lshowcase_app_style_StylesScreenProps;
/** @constructor */
function $c_Lshowcase_app_task_DemoTaskScreenProps(dispatch, actions) {
  this.Lshowcase_app_task_DemoTaskScreenProps__f_dispatch = null;
  this.Lshowcase_app_task_DemoTaskScreenProps__f_actions = null;
  this.Lshowcase_app_task_DemoTaskScreenProps__f_dispatch = dispatch;
  this.Lshowcase_app_task_DemoTaskScreenProps__f_actions = actions
}
$c_Lshowcase_app_task_DemoTaskScreenProps.prototype = new $h_O();
$c_Lshowcase_app_task_DemoTaskScreenProps.prototype.constructor = $c_Lshowcase_app_task_DemoTaskScreenProps;
/** @constructor */
function $h_Lshowcase_app_task_DemoTaskScreenProps() {
  /*<skip>*/
}
$h_Lshowcase_app_task_DemoTaskScreenProps.prototype = $c_Lshowcase_app_task_DemoTaskScreenProps.prototype;
$c_Lshowcase_app_task_DemoTaskScreenProps.prototype.productPrefix__T = (function() {
  return "DemoTaskScreenProps"
});
$c_Lshowcase_app_task_DemoTaskScreenProps.prototype.productArity__I = (function() {
  return 2
});
$c_Lshowcase_app_task_DemoTaskScreenProps.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lshowcase_app_task_DemoTaskScreenProps__f_dispatch;
      break
    }
    case 1: {
      return this.Lshowcase_app_task_DemoTaskScreenProps__f_actions;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lshowcase_app_task_DemoTaskScreenProps.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lshowcase_app_task_DemoTaskScreenProps.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lshowcase_app_task_DemoTaskScreenProps.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lshowcase_app_task_DemoTaskScreenProps.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lshowcase_app_task_DemoTaskScreenProps)) {
    var DemoTaskScreenProps$1 = $as_Lshowcase_app_task_DemoTaskScreenProps(x$1);
    var x = this.Lshowcase_app_task_DemoTaskScreenProps__f_dispatch;
    var x$2 = DemoTaskScreenProps$1.Lshowcase_app_task_DemoTaskScreenProps__f_dispatch;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lshowcase_app_task_DemoTaskScreenProps__f_actions;
      var x$4 = DemoTaskScreenProps$1.Lshowcase_app_task_DemoTaskScreenProps__f_actions;
      return (x$3 === x$4)
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lshowcase_app_task_DemoTaskScreenProps(obj) {
  return (((obj instanceof $c_Lshowcase_app_task_DemoTaskScreenProps) || (obj === null)) ? obj : $throwClassCastException(obj, "showcase.app.task.DemoTaskScreenProps"))
}
function $isArrayOf_Lshowcase_app_task_DemoTaskScreenProps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lshowcase_app_task_DemoTaskScreenProps)))
}
function $asArrayOf_Lshowcase_app_task_DemoTaskScreenProps(obj, depth) {
  return (($isArrayOf_Lshowcase_app_task_DemoTaskScreenProps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lshowcase.app.task.DemoTaskScreenProps;", depth))
}
var $d_Lshowcase_app_task_DemoTaskScreenProps = new $TypeData().initClass({
  Lshowcase_app_task_DemoTaskScreenProps: 0
}, false, "showcase.app.task.DemoTaskScreenProps", {
  Lshowcase_app_task_DemoTaskScreenProps: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lshowcase_app_task_DemoTaskScreenProps.prototype.$classData = $d_Lshowcase_app_task_DemoTaskScreenProps;
/** @constructor */
function $c_Lshowcase_app_ui_ChoiceGroupDemo$ChoiceData(id, name, info) {
  this.Lshowcase_app_ui_ChoiceGroupDemo$ChoiceData__f_id = 0;
  this.Lshowcase_app_ui_ChoiceGroupDemo$ChoiceData__f_name = null;
  this.Lshowcase_app_ui_ChoiceGroupDemo$ChoiceData__f_info = 0.0;
  this.Lshowcase_app_ui_ChoiceGroupDemo$ChoiceData__f_id = id;
  this.Lshowcase_app_ui_ChoiceGroupDemo$ChoiceData__f_name = name;
  this.Lshowcase_app_ui_ChoiceGroupDemo$ChoiceData__f_info = info
}
$c_Lshowcase_app_ui_ChoiceGroupDemo$ChoiceData.prototype = new $h_O();
$c_Lshowcase_app_ui_ChoiceGroupDemo$ChoiceData.prototype.constructor = $c_Lshowcase_app_ui_ChoiceGroupDemo$ChoiceData;
/** @constructor */
function $h_Lshowcase_app_ui_ChoiceGroupDemo$ChoiceData() {
  /*<skip>*/
}
$h_Lshowcase_app_ui_ChoiceGroupDemo$ChoiceData.prototype = $c_Lshowcase_app_ui_ChoiceGroupDemo$ChoiceData.prototype;
$c_Lshowcase_app_ui_ChoiceGroupDemo$ChoiceData.prototype.productPrefix__T = (function() {
  return "ChoiceData"
});
$c_Lshowcase_app_ui_ChoiceGroupDemo$ChoiceData.prototype.productArity__I = (function() {
  return 3
});
$c_Lshowcase_app_ui_ChoiceGroupDemo$ChoiceData.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lshowcase_app_ui_ChoiceGroupDemo$ChoiceData__f_id;
      break
    }
    case 1: {
      return this.Lshowcase_app_ui_ChoiceGroupDemo$ChoiceData__f_name;
      break
    }
    case 2: {
      return this.Lshowcase_app_ui_ChoiceGroupDemo$ChoiceData__f_info;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lshowcase_app_ui_ChoiceGroupDemo$ChoiceData.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lshowcase_app_ui_ChoiceGroupDemo$ChoiceData.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("ChoiceData");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = this.Lshowcase_app_ui_ChoiceGroupDemo$ChoiceData__f_id;
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x = this.Lshowcase_app_ui_ChoiceGroupDemo$ChoiceData__f_name;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var dv = this.Lshowcase_app_ui_ChoiceGroupDemo$ChoiceData__f_info;
  var data$3 = $m_sr_Statics$().doubleHash__D__I(dv);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$4, 3)
});
$c_Lshowcase_app_ui_ChoiceGroupDemo$ChoiceData.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lshowcase_app_ui_ChoiceGroupDemo$ChoiceData.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lshowcase_app_ui_ChoiceGroupDemo$ChoiceData)) {
    var ChoiceData$1 = $as_Lshowcase_app_ui_ChoiceGroupDemo$ChoiceData(x$1);
    return (((this.Lshowcase_app_ui_ChoiceGroupDemo$ChoiceData__f_id === ChoiceData$1.Lshowcase_app_ui_ChoiceGroupDemo$ChoiceData__f_id) && (this.Lshowcase_app_ui_ChoiceGroupDemo$ChoiceData__f_info === ChoiceData$1.Lshowcase_app_ui_ChoiceGroupDemo$ChoiceData__f_info)) && (this.Lshowcase_app_ui_ChoiceGroupDemo$ChoiceData__f_name === ChoiceData$1.Lshowcase_app_ui_ChoiceGroupDemo$ChoiceData__f_name))
  } else {
    return false
  }
});
function $as_Lshowcase_app_ui_ChoiceGroupDemo$ChoiceData(obj) {
  return (((obj instanceof $c_Lshowcase_app_ui_ChoiceGroupDemo$ChoiceData) || (obj === null)) ? obj : $throwClassCastException(obj, "showcase.app.ui.ChoiceGroupDemo$ChoiceData"))
}
function $isArrayOf_Lshowcase_app_ui_ChoiceGroupDemo$ChoiceData(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lshowcase_app_ui_ChoiceGroupDemo$ChoiceData)))
}
function $asArrayOf_Lshowcase_app_ui_ChoiceGroupDemo$ChoiceData(obj, depth) {
  return (($isArrayOf_Lshowcase_app_ui_ChoiceGroupDemo$ChoiceData(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lshowcase.app.ui.ChoiceGroupDemo$ChoiceData;", depth))
}
var $d_Lshowcase_app_ui_ChoiceGroupDemo$ChoiceData = new $TypeData().initClass({
  Lshowcase_app_ui_ChoiceGroupDemo$ChoiceData: 0
}, false, "showcase.app.ui.ChoiceGroupDemo$ChoiceData", {
  Lshowcase_app_ui_ChoiceGroupDemo$ChoiceData: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lshowcase_app_ui_ChoiceGroupDemo$ChoiceData.prototype.$classData = $d_Lshowcase_app_ui_ChoiceGroupDemo$ChoiceData;
/** @constructor */
function $c_Lshowcase_app_ui_UiDemoScreenProps(navigate) {
  this.Lshowcase_app_ui_UiDemoScreenProps__f_navigate = null;
  this.Lshowcase_app_ui_UiDemoScreenProps__f_navigate = navigate
}
$c_Lshowcase_app_ui_UiDemoScreenProps.prototype = new $h_O();
$c_Lshowcase_app_ui_UiDemoScreenProps.prototype.constructor = $c_Lshowcase_app_ui_UiDemoScreenProps;
/** @constructor */
function $h_Lshowcase_app_ui_UiDemoScreenProps() {
  /*<skip>*/
}
$h_Lshowcase_app_ui_UiDemoScreenProps.prototype = $c_Lshowcase_app_ui_UiDemoScreenProps.prototype;
$c_Lshowcase_app_ui_UiDemoScreenProps.prototype.productPrefix__T = (function() {
  return "UiDemoScreenProps"
});
$c_Lshowcase_app_ui_UiDemoScreenProps.prototype.productArity__I = (function() {
  return 1
});
$c_Lshowcase_app_ui_UiDemoScreenProps.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lshowcase_app_ui_UiDemoScreenProps__f_navigate : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lshowcase_app_ui_UiDemoScreenProps.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lshowcase_app_ui_UiDemoScreenProps.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lshowcase_app_ui_UiDemoScreenProps.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lshowcase_app_ui_UiDemoScreenProps.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lshowcase_app_ui_UiDemoScreenProps)) {
    var UiDemoScreenProps$1 = $as_Lshowcase_app_ui_UiDemoScreenProps(x$1);
    var x = this.Lshowcase_app_ui_UiDemoScreenProps__f_navigate;
    var x$2 = UiDemoScreenProps$1.Lshowcase_app_ui_UiDemoScreenProps__f_navigate;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lshowcase_app_ui_UiDemoScreenProps(obj) {
  return (((obj instanceof $c_Lshowcase_app_ui_UiDemoScreenProps) || (obj === null)) ? obj : $throwClassCastException(obj, "showcase.app.ui.UiDemoScreenProps"))
}
function $isArrayOf_Lshowcase_app_ui_UiDemoScreenProps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lshowcase_app_ui_UiDemoScreenProps)))
}
function $asArrayOf_Lshowcase_app_ui_UiDemoScreenProps(obj, depth) {
  return (($isArrayOf_Lshowcase_app_ui_UiDemoScreenProps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lshowcase.app.ui.UiDemoScreenProps;", depth))
}
var $d_Lshowcase_app_ui_UiDemoScreenProps = new $TypeData().initClass({
  Lshowcase_app_ui_UiDemoScreenProps: 0
}, false, "showcase.app.ui.UiDemoScreenProps", {
  Lshowcase_app_ui_UiDemoScreenProps: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lshowcase_app_ui_UiDemoScreenProps.prototype.$classData = $d_Lshowcase_app_ui_UiDemoScreenProps;
/** @constructor */
function $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$AS\uff3fIS$(outer) {
  /*<skip>*/
}
$c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$AS\uff3fIS$.prototype = new $h_O();
$c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$AS\uff3fIS$.prototype.constructor = $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$AS\uff3fIS$;
/** @constructor */
function $h_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$AS\uff3fIS$() {
  /*<skip>*/
}
$h_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$AS\uff3fIS$.prototype = $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$AS\uff3fIS$.prototype;
$c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$AS\uff3fIS$.prototype.productPrefix__T = (function() {
  return "AS_IS"
});
$c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$AS\uff3fIS$.prototype.productArity__I = (function() {
  return 0
});
$c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$AS\uff3fIS$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$AS\uff3fIS$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$AS\uff3fIS$.prototype.hashCode__I = (function() {
  return 62595159
});
$c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$AS\uff3fIS$.prototype.toString__T = (function() {
  return "AS_IS"
});
var $d_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$AS\uff3fIS$ = new $TypeData().initClass({
  Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$AS\uff3fIS$: 0
}, false, "io.github.shogowada.scalajs.reactjs.VirtualDOM$VirtualDOMAttributes$Type$AS_IS$", {
  Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$AS\uff3fIS$: 1,
  O: 1,
  Lio_github_shogowada_statictags_AttributeValueType$AttributeValueType: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$AS\uff3fIS$.prototype.$classData = $d_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$AS\uff3fIS$;
/** @constructor */
function $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$WrappedPropsAttributeSpec(outer, name) {
  this.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$WrappedPropsAttributeSpec__f_name = null;
  this.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$WrappedPropsAttributeSpec__f_$outer = null;
  this.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$WrappedPropsAttributeSpec__f_name = name;
  if ((outer === null)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(null)
  } else {
    this.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$WrappedPropsAttributeSpec__f_$outer = outer
  }
}
$c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$WrappedPropsAttributeSpec.prototype = new $h_O();
$c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$WrappedPropsAttributeSpec.prototype.constructor = $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$WrappedPropsAttributeSpec;
/** @constructor */
function $h_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$WrappedPropsAttributeSpec() {
  /*<skip>*/
}
$h_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$WrappedPropsAttributeSpec.prototype = $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$WrappedPropsAttributeSpec.prototype;
$c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$WrappedPropsAttributeSpec.prototype.$colon$eq__O__Lio_github_shogowada_statictags_Attribute = (function(wrappedProps) {
  return new $c_Lio_github_shogowada_statictags_Attribute(this.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$WrappedPropsAttributeSpec__f_name, wrappedProps, $m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMAttributes__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$().Type__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$().AS_IS__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$AS\uff3fIS$())
});
$c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$WrappedPropsAttributeSpec.prototype.productPrefix__T = (function() {
  return "WrappedPropsAttributeSpec"
});
$c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$WrappedPropsAttributeSpec.prototype.productArity__I = (function() {
  return 1
});
$c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$WrappedPropsAttributeSpec.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$WrappedPropsAttributeSpec__f_name : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$WrappedPropsAttributeSpec.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$WrappedPropsAttributeSpec.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$WrappedPropsAttributeSpec.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$WrappedPropsAttributeSpec.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if (((x$1 instanceof $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$WrappedPropsAttributeSpec) && ($as_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$WrappedPropsAttributeSpec(x$1).Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$WrappedPropsAttributeSpec__f_$outer === this.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$WrappedPropsAttributeSpec__f_$outer))) {
    var WrappedPropsAttributeSpec$1 = $as_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$WrappedPropsAttributeSpec(x$1);
    return (this.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$WrappedPropsAttributeSpec__f_name === WrappedPropsAttributeSpec$1.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$WrappedPropsAttributeSpec__f_name)
  } else {
    return false
  }
});
function $as_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$WrappedPropsAttributeSpec(obj) {
  return (((obj instanceof $c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$WrappedPropsAttributeSpec) || (obj === null)) ? obj : $throwClassCastException(obj, "io.github.shogowada.scalajs.reactjs.VirtualDOM$VirtualDOMAttributes$WrappedPropsAttributeSpec"))
}
function $isArrayOf_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$WrappedPropsAttributeSpec(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$WrappedPropsAttributeSpec)))
}
function $asArrayOf_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$WrappedPropsAttributeSpec(obj, depth) {
  return (($isArrayOf_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$WrappedPropsAttributeSpec(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.github.shogowada.scalajs.reactjs.VirtualDOM$VirtualDOMAttributes$WrappedPropsAttributeSpec;", depth))
}
var $d_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$WrappedPropsAttributeSpec = new $TypeData().initClass({
  Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$WrappedPropsAttributeSpec: 0
}, false, "io.github.shogowada.scalajs.reactjs.VirtualDOM$VirtualDOMAttributes$WrappedPropsAttributeSpec", {
  Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$WrappedPropsAttributeSpec: 1,
  O: 1,
  Lio_github_shogowada_statictags_AttributeSpec: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$WrappedPropsAttributeSpec.prototype.$classData = $d_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$WrappedPropsAttributeSpec;
/** @constructor */
function $c_Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMAttributes$StoreAttributeSpec(name) {
  this.Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMAttributes$StoreAttributeSpec__f_name = null;
  this.Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMAttributes$StoreAttributeSpec__f_name = name
}
$c_Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMAttributes$StoreAttributeSpec.prototype = new $h_O();
$c_Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMAttributes$StoreAttributeSpec.prototype.constructor = $c_Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMAttributes$StoreAttributeSpec;
/** @constructor */
function $h_Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMAttributes$StoreAttributeSpec() {
  /*<skip>*/
}
$h_Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMAttributes$StoreAttributeSpec.prototype = $c_Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMAttributes$StoreAttributeSpec.prototype;
$c_Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMAttributes$StoreAttributeSpec.prototype.$colon$eq__Lio_github_shogowada_scalajs_reactjs_redux_Store__Lio_github_shogowada_statictags_Attribute = (function(store) {
  return new $c_Lio_github_shogowada_statictags_Attribute(this.Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMAttributes$StoreAttributeSpec__f_name, store.Lio_github_shogowada_scalajs_reactjs_redux_Store__f_native, $m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMAttributes__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$().Type__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$().AS_IS__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$AS\uff3fIS$())
});
$c_Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMAttributes$StoreAttributeSpec.prototype.productPrefix__T = (function() {
  return "StoreAttributeSpec"
});
$c_Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMAttributes$StoreAttributeSpec.prototype.productArity__I = (function() {
  return 1
});
$c_Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMAttributes$StoreAttributeSpec.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMAttributes$StoreAttributeSpec__f_name : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMAttributes$StoreAttributeSpec.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMAttributes$StoreAttributeSpec.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMAttributes$StoreAttributeSpec.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMAttributes$StoreAttributeSpec.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMAttributes$StoreAttributeSpec)) {
    var StoreAttributeSpec$1 = $as_Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMAttributes$StoreAttributeSpec(x$1);
    return (this.Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMAttributes$StoreAttributeSpec__f_name === StoreAttributeSpec$1.Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMAttributes$StoreAttributeSpec__f_name)
  } else {
    return false
  }
});
function $as_Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMAttributes$StoreAttributeSpec(obj) {
  return (((obj instanceof $c_Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMAttributes$StoreAttributeSpec) || (obj === null)) ? obj : $throwClassCastException(obj, "io.github.shogowada.scalajs.reactjs.redux.ReactRedux$ReactReduxVirtualDOMAttributes$StoreAttributeSpec"))
}
function $isArrayOf_Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMAttributes$StoreAttributeSpec(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMAttributes$StoreAttributeSpec)))
}
function $asArrayOf_Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMAttributes$StoreAttributeSpec(obj, depth) {
  return (($isArrayOf_Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMAttributes$StoreAttributeSpec(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.github.shogowada.scalajs.reactjs.redux.ReactRedux$ReactReduxVirtualDOMAttributes$StoreAttributeSpec;", depth))
}
var $d_Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMAttributes$StoreAttributeSpec = new $TypeData().initClass({
  Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMAttributes$StoreAttributeSpec: 0
}, false, "io.github.shogowada.scalajs.reactjs.redux.ReactRedux$ReactReduxVirtualDOMAttributes$StoreAttributeSpec", {
  Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMAttributes$StoreAttributeSpec: 1,
  O: 1,
  Lio_github_shogowada_statictags_AttributeSpec: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMAttributes$StoreAttributeSpec.prototype.$classData = $d_Lio_github_shogowada_scalajs_reactjs_redux_ReactRedux$ReactReduxVirtualDOMAttributes$StoreAttributeSpec;
/** @constructor */
function $c_Lio_github_shogowada_statictags_AttributeValueType$COMMA\uff3fSEPARATED$() {
  /*<skip>*/
}
$c_Lio_github_shogowada_statictags_AttributeValueType$COMMA\uff3fSEPARATED$.prototype = new $h_O();
$c_Lio_github_shogowada_statictags_AttributeValueType$COMMA\uff3fSEPARATED$.prototype.constructor = $c_Lio_github_shogowada_statictags_AttributeValueType$COMMA\uff3fSEPARATED$;
/** @constructor */
function $h_Lio_github_shogowada_statictags_AttributeValueType$COMMA\uff3fSEPARATED$() {
  /*<skip>*/
}
$h_Lio_github_shogowada_statictags_AttributeValueType$COMMA\uff3fSEPARATED$.prototype = $c_Lio_github_shogowada_statictags_AttributeValueType$COMMA\uff3fSEPARATED$.prototype;
$c_Lio_github_shogowada_statictags_AttributeValueType$COMMA\uff3fSEPARATED$.prototype.productPrefix__T = (function() {
  return "COMMA_SEPARATED"
});
$c_Lio_github_shogowada_statictags_AttributeValueType$COMMA\uff3fSEPARATED$.prototype.productArity__I = (function() {
  return 0
});
$c_Lio_github_shogowada_statictags_AttributeValueType$COMMA\uff3fSEPARATED$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lio_github_shogowada_statictags_AttributeValueType$COMMA\uff3fSEPARATED$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lio_github_shogowada_statictags_AttributeValueType$COMMA\uff3fSEPARATED$.prototype.hashCode__I = (function() {
  return (-932640649)
});
$c_Lio_github_shogowada_statictags_AttributeValueType$COMMA\uff3fSEPARATED$.prototype.toString__T = (function() {
  return "COMMA_SEPARATED"
});
var $d_Lio_github_shogowada_statictags_AttributeValueType$COMMA\uff3fSEPARATED$ = new $TypeData().initClass({
  Lio_github_shogowada_statictags_AttributeValueType$COMMA\uff3fSEPARATED$: 0
}, false, "io.github.shogowada.statictags.AttributeValueType$COMMA_SEPARATED$", {
  Lio_github_shogowada_statictags_AttributeValueType$COMMA\uff3fSEPARATED$: 1,
  O: 1,
  Lio_github_shogowada_statictags_AttributeValueType$AttributeValueType: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_github_shogowada_statictags_AttributeValueType$COMMA\uff3fSEPARATED$.prototype.$classData = $d_Lio_github_shogowada_statictags_AttributeValueType$COMMA\uff3fSEPARATED$;
var $n_Lio_github_shogowada_statictags_AttributeValueType$COMMA\uff3fSEPARATED$;
function $m_Lio_github_shogowada_statictags_AttributeValueType$COMMA\uff3fSEPARATED$() {
  if ((!$n_Lio_github_shogowada_statictags_AttributeValueType$COMMA\uff3fSEPARATED$)) {
    $n_Lio_github_shogowada_statictags_AttributeValueType$COMMA\uff3fSEPARATED$ = new $c_Lio_github_shogowada_statictags_AttributeValueType$COMMA\uff3fSEPARATED$()
  };
  return $n_Lio_github_shogowada_statictags_AttributeValueType$COMMA\uff3fSEPARATED$
}
/** @constructor */
function $c_Lio_github_shogowada_statictags_AttributeValueType$CSS$() {
  /*<skip>*/
}
$c_Lio_github_shogowada_statictags_AttributeValueType$CSS$.prototype = new $h_O();
$c_Lio_github_shogowada_statictags_AttributeValueType$CSS$.prototype.constructor = $c_Lio_github_shogowada_statictags_AttributeValueType$CSS$;
/** @constructor */
function $h_Lio_github_shogowada_statictags_AttributeValueType$CSS$() {
  /*<skip>*/
}
$h_Lio_github_shogowada_statictags_AttributeValueType$CSS$.prototype = $c_Lio_github_shogowada_statictags_AttributeValueType$CSS$.prototype;
$c_Lio_github_shogowada_statictags_AttributeValueType$CSS$.prototype.productPrefix__T = (function() {
  return "CSS"
});
$c_Lio_github_shogowada_statictags_AttributeValueType$CSS$.prototype.productArity__I = (function() {
  return 0
});
$c_Lio_github_shogowada_statictags_AttributeValueType$CSS$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lio_github_shogowada_statictags_AttributeValueType$CSS$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lio_github_shogowada_statictags_AttributeValueType$CSS$.prototype.hashCode__I = (function() {
  return 67043
});
$c_Lio_github_shogowada_statictags_AttributeValueType$CSS$.prototype.toString__T = (function() {
  return "CSS"
});
var $d_Lio_github_shogowada_statictags_AttributeValueType$CSS$ = new $TypeData().initClass({
  Lio_github_shogowada_statictags_AttributeValueType$CSS$: 0
}, false, "io.github.shogowada.statictags.AttributeValueType$CSS$", {
  Lio_github_shogowada_statictags_AttributeValueType$CSS$: 1,
  O: 1,
  Lio_github_shogowada_statictags_AttributeValueType$AttributeValueType: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_github_shogowada_statictags_AttributeValueType$CSS$.prototype.$classData = $d_Lio_github_shogowada_statictags_AttributeValueType$CSS$;
var $n_Lio_github_shogowada_statictags_AttributeValueType$CSS$;
function $m_Lio_github_shogowada_statictags_AttributeValueType$CSS$() {
  if ((!$n_Lio_github_shogowada_statictags_AttributeValueType$CSS$)) {
    $n_Lio_github_shogowada_statictags_AttributeValueType$CSS$ = new $c_Lio_github_shogowada_statictags_AttributeValueType$CSS$()
  };
  return $n_Lio_github_shogowada_statictags_AttributeValueType$CSS$
}
/** @constructor */
function $c_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$() {
  /*<skip>*/
}
$c_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$.prototype = new $h_O();
$c_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$.prototype.constructor = $c_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$;
/** @constructor */
function $h_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$() {
  /*<skip>*/
}
$h_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$.prototype = $c_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$.prototype;
$c_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$.prototype.productPrefix__T = (function() {
  return "DEFAULT"
});
$c_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$.prototype.productArity__I = (function() {
  return 0
});
$c_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$.prototype.hashCode__I = (function() {
  return (-2032180703)
});
$c_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$.prototype.toString__T = (function() {
  return "DEFAULT"
});
var $d_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$ = new $TypeData().initClass({
  Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$: 0
}, false, "io.github.shogowada.statictags.AttributeValueType$DEFAULT$", {
  Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$: 1,
  O: 1,
  Lio_github_shogowada_statictags_AttributeValueType$AttributeValueType: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$.prototype.$classData = $d_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$;
var $n_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$;
function $m_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$() {
  if ((!$n_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$)) {
    $n_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$ = new $c_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$()
  };
  return $n_Lio_github_shogowada_statictags_AttributeValueType$DEFAULT$
}
/** @constructor */
function $c_Lio_github_shogowada_statictags_AttributeValueType$ON\uff3fOR\uff3fOFF$() {
  /*<skip>*/
}
$c_Lio_github_shogowada_statictags_AttributeValueType$ON\uff3fOR\uff3fOFF$.prototype = new $h_O();
$c_Lio_github_shogowada_statictags_AttributeValueType$ON\uff3fOR\uff3fOFF$.prototype.constructor = $c_Lio_github_shogowada_statictags_AttributeValueType$ON\uff3fOR\uff3fOFF$;
/** @constructor */
function $h_Lio_github_shogowada_statictags_AttributeValueType$ON\uff3fOR\uff3fOFF$() {
  /*<skip>*/
}
$h_Lio_github_shogowada_statictags_AttributeValueType$ON\uff3fOR\uff3fOFF$.prototype = $c_Lio_github_shogowada_statictags_AttributeValueType$ON\uff3fOR\uff3fOFF$.prototype;
$c_Lio_github_shogowada_statictags_AttributeValueType$ON\uff3fOR\uff3fOFF$.prototype.productPrefix__T = (function() {
  return "ON_OR_OFF"
});
$c_Lio_github_shogowada_statictags_AttributeValueType$ON\uff3fOR\uff3fOFF$.prototype.productArity__I = (function() {
  return 0
});
$c_Lio_github_shogowada_statictags_AttributeValueType$ON\uff3fOR\uff3fOFF$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lio_github_shogowada_statictags_AttributeValueType$ON\uff3fOR\uff3fOFF$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lio_github_shogowada_statictags_AttributeValueType$ON\uff3fOR\uff3fOFF$.prototype.hashCode__I = (function() {
  return (-1800885421)
});
$c_Lio_github_shogowada_statictags_AttributeValueType$ON\uff3fOR\uff3fOFF$.prototype.toString__T = (function() {
  return "ON_OR_OFF"
});
var $d_Lio_github_shogowada_statictags_AttributeValueType$ON\uff3fOR\uff3fOFF$ = new $TypeData().initClass({
  Lio_github_shogowada_statictags_AttributeValueType$ON\uff3fOR\uff3fOFF$: 0
}, false, "io.github.shogowada.statictags.AttributeValueType$ON_OR_OFF$", {
  Lio_github_shogowada_statictags_AttributeValueType$ON\uff3fOR\uff3fOFF$: 1,
  O: 1,
  Lio_github_shogowada_statictags_AttributeValueType$AttributeValueType: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_github_shogowada_statictags_AttributeValueType$ON\uff3fOR\uff3fOFF$.prototype.$classData = $d_Lio_github_shogowada_statictags_AttributeValueType$ON\uff3fOR\uff3fOFF$;
var $n_Lio_github_shogowada_statictags_AttributeValueType$ON\uff3fOR\uff3fOFF$;
function $m_Lio_github_shogowada_statictags_AttributeValueType$ON\uff3fOR\uff3fOFF$() {
  if ((!$n_Lio_github_shogowada_statictags_AttributeValueType$ON\uff3fOR\uff3fOFF$)) {
    $n_Lio_github_shogowada_statictags_AttributeValueType$ON\uff3fOR\uff3fOFF$ = new $c_Lio_github_shogowada_statictags_AttributeValueType$ON\uff3fOR\uff3fOFF$()
  };
  return $n_Lio_github_shogowada_statictags_AttributeValueType$ON\uff3fOR\uff3fOFF$
}
/** @constructor */
function $c_Lio_github_shogowada_statictags_AttributeValueType$SPACE\uff3fSEPARATED$() {
  /*<skip>*/
}
$c_Lio_github_shogowada_statictags_AttributeValueType$SPACE\uff3fSEPARATED$.prototype = new $h_O();
$c_Lio_github_shogowada_statictags_AttributeValueType$SPACE\uff3fSEPARATED$.prototype.constructor = $c_Lio_github_shogowada_statictags_AttributeValueType$SPACE\uff3fSEPARATED$;
/** @constructor */
function $h_Lio_github_shogowada_statictags_AttributeValueType$SPACE\uff3fSEPARATED$() {
  /*<skip>*/
}
$h_Lio_github_shogowada_statictags_AttributeValueType$SPACE\uff3fSEPARATED$.prototype = $c_Lio_github_shogowada_statictags_AttributeValueType$SPACE\uff3fSEPARATED$.prototype;
$c_Lio_github_shogowada_statictags_AttributeValueType$SPACE\uff3fSEPARATED$.prototype.productPrefix__T = (function() {
  return "SPACE_SEPARATED"
});
$c_Lio_github_shogowada_statictags_AttributeValueType$SPACE\uff3fSEPARATED$.prototype.productArity__I = (function() {
  return 0
});
$c_Lio_github_shogowada_statictags_AttributeValueType$SPACE\uff3fSEPARATED$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lio_github_shogowada_statictags_AttributeValueType$SPACE\uff3fSEPARATED$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lio_github_shogowada_statictags_AttributeValueType$SPACE\uff3fSEPARATED$.prototype.hashCode__I = (function() {
  return 544963944
});
$c_Lio_github_shogowada_statictags_AttributeValueType$SPACE\uff3fSEPARATED$.prototype.toString__T = (function() {
  return "SPACE_SEPARATED"
});
var $d_Lio_github_shogowada_statictags_AttributeValueType$SPACE\uff3fSEPARATED$ = new $TypeData().initClass({
  Lio_github_shogowada_statictags_AttributeValueType$SPACE\uff3fSEPARATED$: 0
}, false, "io.github.shogowada.statictags.AttributeValueType$SPACE_SEPARATED$", {
  Lio_github_shogowada_statictags_AttributeValueType$SPACE\uff3fSEPARATED$: 1,
  O: 1,
  Lio_github_shogowada_statictags_AttributeValueType$AttributeValueType: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_github_shogowada_statictags_AttributeValueType$SPACE\uff3fSEPARATED$.prototype.$classData = $d_Lio_github_shogowada_statictags_AttributeValueType$SPACE\uff3fSEPARATED$;
var $n_Lio_github_shogowada_statictags_AttributeValueType$SPACE\uff3fSEPARATED$;
function $m_Lio_github_shogowada_statictags_AttributeValueType$SPACE\uff3fSEPARATED$() {
  if ((!$n_Lio_github_shogowada_statictags_AttributeValueType$SPACE\uff3fSEPARATED$)) {
    $n_Lio_github_shogowada_statictags_AttributeValueType$SPACE\uff3fSEPARATED$ = new $c_Lio_github_shogowada_statictags_AttributeValueType$SPACE\uff3fSEPARATED$()
  };
  return $n_Lio_github_shogowada_statictags_AttributeValueType$SPACE\uff3fSEPARATED$
}
/** @constructor */
function $c_Lio_github_shogowada_statictags_AttributeValueType$TRUE\uff3fOR\uff3fFALSE$() {
  /*<skip>*/
}
$c_Lio_github_shogowada_statictags_AttributeValueType$TRUE\uff3fOR\uff3fFALSE$.prototype = new $h_O();
$c_Lio_github_shogowada_statictags_AttributeValueType$TRUE\uff3fOR\uff3fFALSE$.prototype.constructor = $c_Lio_github_shogowada_statictags_AttributeValueType$TRUE\uff3fOR\uff3fFALSE$;
/** @constructor */
function $h_Lio_github_shogowada_statictags_AttributeValueType$TRUE\uff3fOR\uff3fFALSE$() {
  /*<skip>*/
}
$h_Lio_github_shogowada_statictags_AttributeValueType$TRUE\uff3fOR\uff3fFALSE$.prototype = $c_Lio_github_shogowada_statictags_AttributeValueType$TRUE\uff3fOR\uff3fFALSE$.prototype;
$c_Lio_github_shogowada_statictags_AttributeValueType$TRUE\uff3fOR\uff3fFALSE$.prototype.productPrefix__T = (function() {
  return "TRUE_OR_FALSE"
});
$c_Lio_github_shogowada_statictags_AttributeValueType$TRUE\uff3fOR\uff3fFALSE$.prototype.productArity__I = (function() {
  return 0
});
$c_Lio_github_shogowada_statictags_AttributeValueType$TRUE\uff3fOR\uff3fFALSE$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lio_github_shogowada_statictags_AttributeValueType$TRUE\uff3fOR\uff3fFALSE$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lio_github_shogowada_statictags_AttributeValueType$TRUE\uff3fOR\uff3fFALSE$.prototype.hashCode__I = (function() {
  return (-1386841288)
});
$c_Lio_github_shogowada_statictags_AttributeValueType$TRUE\uff3fOR\uff3fFALSE$.prototype.toString__T = (function() {
  return "TRUE_OR_FALSE"
});
var $d_Lio_github_shogowada_statictags_AttributeValueType$TRUE\uff3fOR\uff3fFALSE$ = new $TypeData().initClass({
  Lio_github_shogowada_statictags_AttributeValueType$TRUE\uff3fOR\uff3fFALSE$: 0
}, false, "io.github.shogowada.statictags.AttributeValueType$TRUE_OR_FALSE$", {
  Lio_github_shogowada_statictags_AttributeValueType$TRUE\uff3fOR\uff3fFALSE$: 1,
  O: 1,
  Lio_github_shogowada_statictags_AttributeValueType$AttributeValueType: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_github_shogowada_statictags_AttributeValueType$TRUE\uff3fOR\uff3fFALSE$.prototype.$classData = $d_Lio_github_shogowada_statictags_AttributeValueType$TRUE\uff3fOR\uff3fFALSE$;
var $n_Lio_github_shogowada_statictags_AttributeValueType$TRUE\uff3fOR\uff3fFALSE$;
function $m_Lio_github_shogowada_statictags_AttributeValueType$TRUE\uff3fOR\uff3fFALSE$() {
  if ((!$n_Lio_github_shogowada_statictags_AttributeValueType$TRUE\uff3fOR\uff3fFALSE$)) {
    $n_Lio_github_shogowada_statictags_AttributeValueType$TRUE\uff3fOR\uff3fFALSE$ = new $c_Lio_github_shogowada_statictags_AttributeValueType$TRUE\uff3fOR\uff3fFALSE$()
  };
  return $n_Lio_github_shogowada_statictags_AttributeValueType$TRUE\uff3fOR\uff3fFALSE$
}
/** @constructor */
function $c_Lio_github_shogowada_statictags_AttributeValueType$YES\uff3fOR\uff3fNO$() {
  /*<skip>*/
}
$c_Lio_github_shogowada_statictags_AttributeValueType$YES\uff3fOR\uff3fNO$.prototype = new $h_O();
$c_Lio_github_shogowada_statictags_AttributeValueType$YES\uff3fOR\uff3fNO$.prototype.constructor = $c_Lio_github_shogowada_statictags_AttributeValueType$YES\uff3fOR\uff3fNO$;
/** @constructor */
function $h_Lio_github_shogowada_statictags_AttributeValueType$YES\uff3fOR\uff3fNO$() {
  /*<skip>*/
}
$h_Lio_github_shogowada_statictags_AttributeValueType$YES\uff3fOR\uff3fNO$.prototype = $c_Lio_github_shogowada_statictags_AttributeValueType$YES\uff3fOR\uff3fNO$.prototype;
$c_Lio_github_shogowada_statictags_AttributeValueType$YES\uff3fOR\uff3fNO$.prototype.productPrefix__T = (function() {
  return "YES_OR_NO"
});
$c_Lio_github_shogowada_statictags_AttributeValueType$YES\uff3fOR\uff3fNO$.prototype.productArity__I = (function() {
  return 0
});
$c_Lio_github_shogowada_statictags_AttributeValueType$YES\uff3fOR\uff3fNO$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lio_github_shogowada_statictags_AttributeValueType$YES\uff3fOR\uff3fNO$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lio_github_shogowada_statictags_AttributeValueType$YES\uff3fOR\uff3fNO$.prototype.hashCode__I = (function() {
  return 1488797221
});
$c_Lio_github_shogowada_statictags_AttributeValueType$YES\uff3fOR\uff3fNO$.prototype.toString__T = (function() {
  return "YES_OR_NO"
});
var $d_Lio_github_shogowada_statictags_AttributeValueType$YES\uff3fOR\uff3fNO$ = new $TypeData().initClass({
  Lio_github_shogowada_statictags_AttributeValueType$YES\uff3fOR\uff3fNO$: 0
}, false, "io.github.shogowada.statictags.AttributeValueType$YES_OR_NO$", {
  Lio_github_shogowada_statictags_AttributeValueType$YES\uff3fOR\uff3fNO$: 1,
  O: 1,
  Lio_github_shogowada_statictags_AttributeValueType$AttributeValueType: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_github_shogowada_statictags_AttributeValueType$YES\uff3fOR\uff3fNO$.prototype.$classData = $d_Lio_github_shogowada_statictags_AttributeValueType$YES\uff3fOR\uff3fNO$;
var $n_Lio_github_shogowada_statictags_AttributeValueType$YES\uff3fOR\uff3fNO$;
function $m_Lio_github_shogowada_statictags_AttributeValueType$YES\uff3fOR\uff3fNO$() {
  if ((!$n_Lio_github_shogowada_statictags_AttributeValueType$YES\uff3fOR\uff3fNO$)) {
    $n_Lio_github_shogowada_statictags_AttributeValueType$YES\uff3fOR\uff3fNO$ = new $c_Lio_github_shogowada_statictags_AttributeValueType$YES\uff3fOR\uff3fNO$()
  };
  return $n_Lio_github_shogowada_statictags_AttributeValueType$YES\uff3fOR\uff3fNO$
}
/** @constructor */
function $c_Lio_github_shogowada_statictags_BooleanAttributeSpec(name) {
  this.Lio_github_shogowada_statictags_BooleanAttributeSpec__f_name = null;
  this.Lio_github_shogowada_statictags_BooleanAttributeSpec__f_name = name
}
$c_Lio_github_shogowada_statictags_BooleanAttributeSpec.prototype = new $h_O();
$c_Lio_github_shogowada_statictags_BooleanAttributeSpec.prototype.constructor = $c_Lio_github_shogowada_statictags_BooleanAttributeSpec;
/** @constructor */
function $h_Lio_github_shogowada_statictags_BooleanAttributeSpec() {
  /*<skip>*/
}
$h_Lio_github_shogowada_statictags_BooleanAttributeSpec.prototype = $c_Lio_github_shogowada_statictags_BooleanAttributeSpec.prototype;
$c_Lio_github_shogowada_statictags_BooleanAttributeSpec.prototype.productPrefix__T = (function() {
  return "BooleanAttributeSpec"
});
$c_Lio_github_shogowada_statictags_BooleanAttributeSpec.prototype.productArity__I = (function() {
  return 1
});
$c_Lio_github_shogowada_statictags_BooleanAttributeSpec.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lio_github_shogowada_statictags_BooleanAttributeSpec__f_name : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lio_github_shogowada_statictags_BooleanAttributeSpec.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lio_github_shogowada_statictags_BooleanAttributeSpec.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lio_github_shogowada_statictags_BooleanAttributeSpec.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lio_github_shogowada_statictags_BooleanAttributeSpec.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lio_github_shogowada_statictags_BooleanAttributeSpec)) {
    var BooleanAttributeSpec$1 = $as_Lio_github_shogowada_statictags_BooleanAttributeSpec(x$1);
    return (this.Lio_github_shogowada_statictags_BooleanAttributeSpec__f_name === BooleanAttributeSpec$1.Lio_github_shogowada_statictags_BooleanAttributeSpec__f_name)
  } else {
    return false
  }
});
function $as_Lio_github_shogowada_statictags_BooleanAttributeSpec(obj) {
  return (((obj instanceof $c_Lio_github_shogowada_statictags_BooleanAttributeSpec) || (obj === null)) ? obj : $throwClassCastException(obj, "io.github.shogowada.statictags.BooleanAttributeSpec"))
}
function $isArrayOf_Lio_github_shogowada_statictags_BooleanAttributeSpec(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_github_shogowada_statictags_BooleanAttributeSpec)))
}
function $asArrayOf_Lio_github_shogowada_statictags_BooleanAttributeSpec(obj, depth) {
  return (($isArrayOf_Lio_github_shogowada_statictags_BooleanAttributeSpec(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.github.shogowada.statictags.BooleanAttributeSpec;", depth))
}
var $d_Lio_github_shogowada_statictags_BooleanAttributeSpec = new $TypeData().initClass({
  Lio_github_shogowada_statictags_BooleanAttributeSpec: 0
}, false, "io.github.shogowada.statictags.BooleanAttributeSpec", {
  Lio_github_shogowada_statictags_BooleanAttributeSpec: 1,
  O: 1,
  Lio_github_shogowada_statictags_AttributeSpec: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_github_shogowada_statictags_BooleanAttributeSpec.prototype.$classData = $d_Lio_github_shogowada_statictags_BooleanAttributeSpec;
/** @constructor */
function $c_Lio_github_shogowada_statictags_DynamicAttributeSpec(name) {
  this.Lio_github_shogowada_statictags_DynamicAttributeSpec__f_name = null;
  this.Lio_github_shogowada_statictags_DynamicAttributeSpec__f_name = name
}
$c_Lio_github_shogowada_statictags_DynamicAttributeSpec.prototype = new $h_O();
$c_Lio_github_shogowada_statictags_DynamicAttributeSpec.prototype.constructor = $c_Lio_github_shogowada_statictags_DynamicAttributeSpec;
/** @constructor */
function $h_Lio_github_shogowada_statictags_DynamicAttributeSpec() {
  /*<skip>*/
}
$h_Lio_github_shogowada_statictags_DynamicAttributeSpec.prototype = $c_Lio_github_shogowada_statictags_DynamicAttributeSpec.prototype;
$c_Lio_github_shogowada_statictags_DynamicAttributeSpec.prototype.productPrefix__T = (function() {
  return "DynamicAttributeSpec"
});
$c_Lio_github_shogowada_statictags_DynamicAttributeSpec.prototype.productArity__I = (function() {
  return 1
});
$c_Lio_github_shogowada_statictags_DynamicAttributeSpec.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lio_github_shogowada_statictags_DynamicAttributeSpec__f_name : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lio_github_shogowada_statictags_DynamicAttributeSpec.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lio_github_shogowada_statictags_DynamicAttributeSpec.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lio_github_shogowada_statictags_DynamicAttributeSpec.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lio_github_shogowada_statictags_DynamicAttributeSpec.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lio_github_shogowada_statictags_DynamicAttributeSpec)) {
    var DynamicAttributeSpec$1 = $as_Lio_github_shogowada_statictags_DynamicAttributeSpec(x$1);
    return (this.Lio_github_shogowada_statictags_DynamicAttributeSpec__f_name === DynamicAttributeSpec$1.Lio_github_shogowada_statictags_DynamicAttributeSpec__f_name)
  } else {
    return false
  }
});
function $as_Lio_github_shogowada_statictags_DynamicAttributeSpec(obj) {
  return (((obj instanceof $c_Lio_github_shogowada_statictags_DynamicAttributeSpec) || (obj === null)) ? obj : $throwClassCastException(obj, "io.github.shogowada.statictags.DynamicAttributeSpec"))
}
function $isArrayOf_Lio_github_shogowada_statictags_DynamicAttributeSpec(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_github_shogowada_statictags_DynamicAttributeSpec)))
}
function $asArrayOf_Lio_github_shogowada_statictags_DynamicAttributeSpec(obj, depth) {
  return (($isArrayOf_Lio_github_shogowada_statictags_DynamicAttributeSpec(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.github.shogowada.statictags.DynamicAttributeSpec;", depth))
}
var $d_Lio_github_shogowada_statictags_DynamicAttributeSpec = new $TypeData().initClass({
  Lio_github_shogowada_statictags_DynamicAttributeSpec: 0
}, false, "io.github.shogowada.statictags.DynamicAttributeSpec", {
  Lio_github_shogowada_statictags_DynamicAttributeSpec: 1,
  O: 1,
  Lio_github_shogowada_statictags_AttributeSpec: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_github_shogowada_statictags_DynamicAttributeSpec.prototype.$classData = $d_Lio_github_shogowada_statictags_DynamicAttributeSpec;
/** @constructor */
function $c_Lio_github_shogowada_statictags_IntegerAttributeSpec(name) {
  this.Lio_github_shogowada_statictags_IntegerAttributeSpec__f_name = null;
  this.Lio_github_shogowada_statictags_IntegerAttributeSpec__f_name = name
}
$c_Lio_github_shogowada_statictags_IntegerAttributeSpec.prototype = new $h_O();
$c_Lio_github_shogowada_statictags_IntegerAttributeSpec.prototype.constructor = $c_Lio_github_shogowada_statictags_IntegerAttributeSpec;
/** @constructor */
function $h_Lio_github_shogowada_statictags_IntegerAttributeSpec() {
  /*<skip>*/
}
$h_Lio_github_shogowada_statictags_IntegerAttributeSpec.prototype = $c_Lio_github_shogowada_statictags_IntegerAttributeSpec.prototype;
$c_Lio_github_shogowada_statictags_IntegerAttributeSpec.prototype.productPrefix__T = (function() {
  return "IntegerAttributeSpec"
});
$c_Lio_github_shogowada_statictags_IntegerAttributeSpec.prototype.productArity__I = (function() {
  return 1
});
$c_Lio_github_shogowada_statictags_IntegerAttributeSpec.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lio_github_shogowada_statictags_IntegerAttributeSpec__f_name : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lio_github_shogowada_statictags_IntegerAttributeSpec.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lio_github_shogowada_statictags_IntegerAttributeSpec.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lio_github_shogowada_statictags_IntegerAttributeSpec.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lio_github_shogowada_statictags_IntegerAttributeSpec.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lio_github_shogowada_statictags_IntegerAttributeSpec)) {
    var IntegerAttributeSpec$1 = $as_Lio_github_shogowada_statictags_IntegerAttributeSpec(x$1);
    return (this.Lio_github_shogowada_statictags_IntegerAttributeSpec__f_name === IntegerAttributeSpec$1.Lio_github_shogowada_statictags_IntegerAttributeSpec__f_name)
  } else {
    return false
  }
});
function $as_Lio_github_shogowada_statictags_IntegerAttributeSpec(obj) {
  return (((obj instanceof $c_Lio_github_shogowada_statictags_IntegerAttributeSpec) || (obj === null)) ? obj : $throwClassCastException(obj, "io.github.shogowada.statictags.IntegerAttributeSpec"))
}
function $isArrayOf_Lio_github_shogowada_statictags_IntegerAttributeSpec(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_github_shogowada_statictags_IntegerAttributeSpec)))
}
function $asArrayOf_Lio_github_shogowada_statictags_IntegerAttributeSpec(obj, depth) {
  return (($isArrayOf_Lio_github_shogowada_statictags_IntegerAttributeSpec(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.github.shogowada.statictags.IntegerAttributeSpec;", depth))
}
var $d_Lio_github_shogowada_statictags_IntegerAttributeSpec = new $TypeData().initClass({
  Lio_github_shogowada_statictags_IntegerAttributeSpec: 0
}, false, "io.github.shogowada.statictags.IntegerAttributeSpec", {
  Lio_github_shogowada_statictags_IntegerAttributeSpec: 1,
  O: 1,
  Lio_github_shogowada_statictags_AttributeSpec: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_github_shogowada_statictags_IntegerAttributeSpec.prototype.$classData = $d_Lio_github_shogowada_statictags_IntegerAttributeSpec;
/** @constructor */
function $c_Lio_github_shogowada_statictags_StringAttributeSpec(name) {
  this.Lio_github_shogowada_statictags_StringAttributeSpec__f_name = null;
  this.Lio_github_shogowada_statictags_StringAttributeSpec__f_name = name
}
$c_Lio_github_shogowada_statictags_StringAttributeSpec.prototype = new $h_O();
$c_Lio_github_shogowada_statictags_StringAttributeSpec.prototype.constructor = $c_Lio_github_shogowada_statictags_StringAttributeSpec;
/** @constructor */
function $h_Lio_github_shogowada_statictags_StringAttributeSpec() {
  /*<skip>*/
}
$h_Lio_github_shogowada_statictags_StringAttributeSpec.prototype = $c_Lio_github_shogowada_statictags_StringAttributeSpec.prototype;
$c_Lio_github_shogowada_statictags_StringAttributeSpec.prototype.productPrefix__T = (function() {
  return "StringAttributeSpec"
});
$c_Lio_github_shogowada_statictags_StringAttributeSpec.prototype.productArity__I = (function() {
  return 1
});
$c_Lio_github_shogowada_statictags_StringAttributeSpec.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lio_github_shogowada_statictags_StringAttributeSpec__f_name : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lio_github_shogowada_statictags_StringAttributeSpec.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lio_github_shogowada_statictags_StringAttributeSpec.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lio_github_shogowada_statictags_StringAttributeSpec.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lio_github_shogowada_statictags_StringAttributeSpec.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lio_github_shogowada_statictags_StringAttributeSpec)) {
    var StringAttributeSpec$1 = $as_Lio_github_shogowada_statictags_StringAttributeSpec(x$1);
    return (this.Lio_github_shogowada_statictags_StringAttributeSpec__f_name === StringAttributeSpec$1.Lio_github_shogowada_statictags_StringAttributeSpec__f_name)
  } else {
    return false
  }
});
function $as_Lio_github_shogowada_statictags_StringAttributeSpec(obj) {
  return (((obj instanceof $c_Lio_github_shogowada_statictags_StringAttributeSpec) || (obj === null)) ? obj : $throwClassCastException(obj, "io.github.shogowada.statictags.StringAttributeSpec"))
}
function $isArrayOf_Lio_github_shogowada_statictags_StringAttributeSpec(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_github_shogowada_statictags_StringAttributeSpec)))
}
function $asArrayOf_Lio_github_shogowada_statictags_StringAttributeSpec(obj, depth) {
  return (($isArrayOf_Lio_github_shogowada_statictags_StringAttributeSpec(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.github.shogowada.statictags.StringAttributeSpec;", depth))
}
var $d_Lio_github_shogowada_statictags_StringAttributeSpec = new $TypeData().initClass({
  Lio_github_shogowada_statictags_StringAttributeSpec: 0
}, false, "io.github.shogowada.statictags.StringAttributeSpec", {
  Lio_github_shogowada_statictags_StringAttributeSpec: 1,
  O: 1,
  Lio_github_shogowada_statictags_AttributeSpec: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_github_shogowada_statictags_StringAttributeSpec.prototype.$classData = $d_Lio_github_shogowada_statictags_StringAttributeSpec;
/** @constructor */
function $c_Lio_github_shogowada_statictags_ValueAttributeSpec(name) {
  this.Lio_github_shogowada_statictags_ValueAttributeSpec__f_name = null;
  this.Lio_github_shogowada_statictags_ValueAttributeSpec__f_name = name
}
$c_Lio_github_shogowada_statictags_ValueAttributeSpec.prototype = new $h_O();
$c_Lio_github_shogowada_statictags_ValueAttributeSpec.prototype.constructor = $c_Lio_github_shogowada_statictags_ValueAttributeSpec;
/** @constructor */
function $h_Lio_github_shogowada_statictags_ValueAttributeSpec() {
  /*<skip>*/
}
$h_Lio_github_shogowada_statictags_ValueAttributeSpec.prototype = $c_Lio_github_shogowada_statictags_ValueAttributeSpec.prototype;
$c_Lio_github_shogowada_statictags_ValueAttributeSpec.prototype.productPrefix__T = (function() {
  return "ValueAttributeSpec"
});
$c_Lio_github_shogowada_statictags_ValueAttributeSpec.prototype.productArity__I = (function() {
  return 1
});
$c_Lio_github_shogowada_statictags_ValueAttributeSpec.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lio_github_shogowada_statictags_ValueAttributeSpec__f_name : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lio_github_shogowada_statictags_ValueAttributeSpec.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lio_github_shogowada_statictags_ValueAttributeSpec.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lio_github_shogowada_statictags_ValueAttributeSpec.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lio_github_shogowada_statictags_ValueAttributeSpec.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lio_github_shogowada_statictags_ValueAttributeSpec)) {
    var ValueAttributeSpec$1 = $as_Lio_github_shogowada_statictags_ValueAttributeSpec(x$1);
    return (this.Lio_github_shogowada_statictags_ValueAttributeSpec__f_name === ValueAttributeSpec$1.Lio_github_shogowada_statictags_ValueAttributeSpec__f_name)
  } else {
    return false
  }
});
function $as_Lio_github_shogowada_statictags_ValueAttributeSpec(obj) {
  return (((obj instanceof $c_Lio_github_shogowada_statictags_ValueAttributeSpec) || (obj === null)) ? obj : $throwClassCastException(obj, "io.github.shogowada.statictags.ValueAttributeSpec"))
}
function $isArrayOf_Lio_github_shogowada_statictags_ValueAttributeSpec(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_github_shogowada_statictags_ValueAttributeSpec)))
}
function $asArrayOf_Lio_github_shogowada_statictags_ValueAttributeSpec(obj, depth) {
  return (($isArrayOf_Lio_github_shogowada_statictags_ValueAttributeSpec(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lio.github.shogowada.statictags.ValueAttributeSpec;", depth))
}
var $d_Lio_github_shogowada_statictags_ValueAttributeSpec = new $TypeData().initClass({
  Lio_github_shogowada_statictags_ValueAttributeSpec: 0
}, false, "io.github.shogowada.statictags.ValueAttributeSpec", {
  Lio_github_shogowada_statictags_ValueAttributeSpec: 1,
  O: 1,
  Lio_github_shogowada_statictags_AttributeSpec: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lio_github_shogowada_statictags_ValueAttributeSpec.prototype.$classData = $d_Lio_github_shogowada_statictags_ValueAttributeSpec;
function $ct_Ljava_io_FilterOutputStream__Ljava_io_OutputStream__($thiz, out) {
  $thiz.Ljava_io_FilterOutputStream__f_out = out;
  return $thiz
}
/** @constructor */
function $c_Ljava_io_FilterOutputStream() {
  this.Ljava_io_FilterOutputStream__f_out = null
}
$c_Ljava_io_FilterOutputStream.prototype = new $h_Ljava_io_OutputStream();
$c_Ljava_io_FilterOutputStream.prototype.constructor = $c_Ljava_io_FilterOutputStream;
/** @constructor */
function $h_Ljava_io_FilterOutputStream() {
  /*<skip>*/
}
$h_Ljava_io_FilterOutputStream.prototype = $c_Ljava_io_FilterOutputStream.prototype;
/** @constructor */
function $c_jl_ArithmeticException(s) {
  this.jl_Throwable__f_s = null;
  this.jl_Throwable__f_e = null;
  this.jl_Throwable__f_enableSuppression = false;
  this.jl_Throwable__f_writableStackTrace = false;
  this.jl_Throwable__f_stackTraceStateInternal = null;
  this.jl_Throwable__f_stackTrace = null;
  this.jl_Throwable__f_suppressed = null;
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, s, null, true, true)
}
$c_jl_ArithmeticException.prototype = new $h_jl_RuntimeException();
$c_jl_ArithmeticException.prototype.constructor = $c_jl_ArithmeticException;
/** @constructor */
function $h_jl_ArithmeticException() {
  /*<skip>*/
}
$h_jl_ArithmeticException.prototype = $c_jl_ArithmeticException.prototype;
function $as_jl_ArithmeticException(obj) {
  return (((obj instanceof $c_jl_ArithmeticException) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.ArithmeticException"))
}
function $isArrayOf_jl_ArithmeticException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_ArithmeticException)))
}
function $asArrayOf_jl_ArithmeticException(obj, depth) {
  return (($isArrayOf_jl_ArithmeticException(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.ArithmeticException;", depth))
}
var $d_jl_ArithmeticException = new $TypeData().initClass({
  jl_ArithmeticException: 0
}, false, "java.lang.ArithmeticException", {
  jl_ArithmeticException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_ArithmeticException.prototype.$classData = $d_jl_ArithmeticException;
/** @constructor */
function $c_jl_ClassCastException(s) {
  this.jl_Throwable__f_s = null;
  this.jl_Throwable__f_e = null;
  this.jl_Throwable__f_enableSuppression = false;
  this.jl_Throwable__f_writableStackTrace = false;
  this.jl_Throwable__f_stackTraceStateInternal = null;
  this.jl_Throwable__f_stackTrace = null;
  this.jl_Throwable__f_suppressed = null;
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, s, null, true, true)
}
$c_jl_ClassCastException.prototype = new $h_jl_RuntimeException();
$c_jl_ClassCastException.prototype.constructor = $c_jl_ClassCastException;
/** @constructor */
function $h_jl_ClassCastException() {
  /*<skip>*/
}
$h_jl_ClassCastException.prototype = $c_jl_ClassCastException.prototype;
var $d_jl_ClassCastException = new $TypeData().initClass({
  jl_ClassCastException: 0
}, false, "java.lang.ClassCastException", {
  jl_ClassCastException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_ClassCastException.prototype.$classData = $d_jl_ClassCastException;
function $ct_jl_IllegalArgumentException__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz
}
function $ct_jl_IllegalArgumentException__($thiz) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, null, null, true, true);
  return $thiz
}
/** @constructor */
function $c_jl_IllegalArgumentException() {
  this.jl_Throwable__f_s = null;
  this.jl_Throwable__f_e = null;
  this.jl_Throwable__f_enableSuppression = false;
  this.jl_Throwable__f_writableStackTrace = false;
  this.jl_Throwable__f_stackTraceStateInternal = null;
  this.jl_Throwable__f_stackTrace = null;
  this.jl_Throwable__f_suppressed = null
}
$c_jl_IllegalArgumentException.prototype = new $h_jl_RuntimeException();
$c_jl_IllegalArgumentException.prototype.constructor = $c_jl_IllegalArgumentException;
/** @constructor */
function $h_jl_IllegalArgumentException() {
  /*<skip>*/
}
$h_jl_IllegalArgumentException.prototype = $c_jl_IllegalArgumentException.prototype;
var $d_jl_IllegalArgumentException = new $TypeData().initClass({
  jl_IllegalArgumentException: 0
}, false, "java.lang.IllegalArgumentException", {
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_IllegalArgumentException.prototype.$classData = $d_jl_IllegalArgumentException;
function $ct_jl_IllegalStateException__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz
}
function $ct_jl_IllegalStateException__($thiz) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, null, null, true, true);
  return $thiz
}
/** @constructor */
function $c_jl_IllegalStateException() {
  this.jl_Throwable__f_s = null;
  this.jl_Throwable__f_e = null;
  this.jl_Throwable__f_enableSuppression = false;
  this.jl_Throwable__f_writableStackTrace = false;
  this.jl_Throwable__f_stackTraceStateInternal = null;
  this.jl_Throwable__f_stackTrace = null;
  this.jl_Throwable__f_suppressed = null
}
$c_jl_IllegalStateException.prototype = new $h_jl_RuntimeException();
$c_jl_IllegalStateException.prototype.constructor = $c_jl_IllegalStateException;
/** @constructor */
function $h_jl_IllegalStateException() {
  /*<skip>*/
}
$h_jl_IllegalStateException.prototype = $c_jl_IllegalStateException.prototype;
var $d_jl_IllegalStateException = new $TypeData().initClass({
  jl_IllegalStateException: 0
}, false, "java.lang.IllegalStateException", {
  jl_IllegalStateException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_IllegalStateException.prototype.$classData = $d_jl_IllegalStateException;
function $ct_jl_IndexOutOfBoundsException__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz
}
function $ct_jl_IndexOutOfBoundsException__($thiz) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, null, null, true, true);
  return $thiz
}
/** @constructor */
function $c_jl_IndexOutOfBoundsException() {
  this.jl_Throwable__f_s = null;
  this.jl_Throwable__f_e = null;
  this.jl_Throwable__f_enableSuppression = false;
  this.jl_Throwable__f_writableStackTrace = false;
  this.jl_Throwable__f_stackTraceStateInternal = null;
  this.jl_Throwable__f_stackTrace = null;
  this.jl_Throwable__f_suppressed = null
}
$c_jl_IndexOutOfBoundsException.prototype = new $h_jl_RuntimeException();
$c_jl_IndexOutOfBoundsException.prototype.constructor = $c_jl_IndexOutOfBoundsException;
/** @constructor */
function $h_jl_IndexOutOfBoundsException() {
  /*<skip>*/
}
$h_jl_IndexOutOfBoundsException.prototype = $c_jl_IndexOutOfBoundsException.prototype;
var $d_jl_IndexOutOfBoundsException = new $TypeData().initClass({
  jl_IndexOutOfBoundsException: 0
}, false, "java.lang.IndexOutOfBoundsException", {
  jl_IndexOutOfBoundsException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_IndexOutOfBoundsException.prototype.$classData = $d_jl_IndexOutOfBoundsException;
/** @constructor */
function $c_jl_JSConsoleBasedPrintStream$DummyOutputStream() {
  /*<skip>*/
}
$c_jl_JSConsoleBasedPrintStream$DummyOutputStream.prototype = new $h_Ljava_io_OutputStream();
$c_jl_JSConsoleBasedPrintStream$DummyOutputStream.prototype.constructor = $c_jl_JSConsoleBasedPrintStream$DummyOutputStream;
/** @constructor */
function $h_jl_JSConsoleBasedPrintStream$DummyOutputStream() {
  /*<skip>*/
}
$h_jl_JSConsoleBasedPrintStream$DummyOutputStream.prototype = $c_jl_JSConsoleBasedPrintStream$DummyOutputStream.prototype;
var $d_jl_JSConsoleBasedPrintStream$DummyOutputStream = new $TypeData().initClass({
  jl_JSConsoleBasedPrintStream$DummyOutputStream: 0
}, false, "java.lang.JSConsoleBasedPrintStream$DummyOutputStream", {
  jl_JSConsoleBasedPrintStream$DummyOutputStream: 1,
  Ljava_io_OutputStream: 1,
  O: 1,
  Ljava_io_Closeable: 1,
  jl_AutoCloseable: 1,
  Ljava_io_Flushable: 1
});
$c_jl_JSConsoleBasedPrintStream$DummyOutputStream.prototype.$classData = $d_jl_JSConsoleBasedPrintStream$DummyOutputStream;
/** @constructor */
function $c_jl_NegativeArraySizeException() {
  this.jl_Throwable__f_s = null;
  this.jl_Throwable__f_e = null;
  this.jl_Throwable__f_enableSuppression = false;
  this.jl_Throwable__f_writableStackTrace = false;
  this.jl_Throwable__f_stackTraceStateInternal = null;
  this.jl_Throwable__f_stackTrace = null;
  this.jl_Throwable__f_suppressed = null;
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true)
}
$c_jl_NegativeArraySizeException.prototype = new $h_jl_RuntimeException();
$c_jl_NegativeArraySizeException.prototype.constructor = $c_jl_NegativeArraySizeException;
/** @constructor */
function $h_jl_NegativeArraySizeException() {
  /*<skip>*/
}
$h_jl_NegativeArraySizeException.prototype = $c_jl_NegativeArraySizeException.prototype;
var $d_jl_NegativeArraySizeException = new $TypeData().initClass({
  jl_NegativeArraySizeException: 0
}, false, "java.lang.NegativeArraySizeException", {
  jl_NegativeArraySizeException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_NegativeArraySizeException.prototype.$classData = $d_jl_NegativeArraySizeException;
function $ct_jl_NullPointerException__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz
}
function $ct_jl_NullPointerException__($thiz) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, null, null, true, true);
  return $thiz
}
/** @constructor */
function $c_jl_NullPointerException() {
  this.jl_Throwable__f_s = null;
  this.jl_Throwable__f_e = null;
  this.jl_Throwable__f_enableSuppression = false;
  this.jl_Throwable__f_writableStackTrace = false;
  this.jl_Throwable__f_stackTraceStateInternal = null;
  this.jl_Throwable__f_stackTrace = null;
  this.jl_Throwable__f_suppressed = null
}
$c_jl_NullPointerException.prototype = new $h_jl_RuntimeException();
$c_jl_NullPointerException.prototype.constructor = $c_jl_NullPointerException;
/** @constructor */
function $h_jl_NullPointerException() {
  /*<skip>*/
}
$h_jl_NullPointerException.prototype = $c_jl_NullPointerException.prototype;
var $d_jl_NullPointerException = new $TypeData().initClass({
  jl_NullPointerException: 0
}, false, "java.lang.NullPointerException", {
  jl_NullPointerException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_NullPointerException.prototype.$classData = $d_jl_NullPointerException;
function $as_jl_SecurityException(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.SecurityException"))
}
function $isArrayOf_jl_SecurityException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_SecurityException)))
}
function $asArrayOf_jl_SecurityException(obj, depth) {
  return (($isArrayOf_jl_SecurityException(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.SecurityException;", depth))
}
/** @constructor */
function $c_jl_StackOverflowError(s) {
  this.jl_Throwable__f_s = null;
  this.jl_Throwable__f_e = null;
  this.jl_Throwable__f_enableSuppression = false;
  this.jl_Throwable__f_writableStackTrace = false;
  this.jl_Throwable__f_stackTraceStateInternal = null;
  this.jl_Throwable__f_stackTrace = null;
  this.jl_Throwable__f_suppressed = null;
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, s, null, true, true)
}
$c_jl_StackOverflowError.prototype = new $h_jl_VirtualMachineError();
$c_jl_StackOverflowError.prototype.constructor = $c_jl_StackOverflowError;
/** @constructor */
function $h_jl_StackOverflowError() {
  /*<skip>*/
}
$h_jl_StackOverflowError.prototype = $c_jl_StackOverflowError.prototype;
var $d_jl_StackOverflowError = new $TypeData().initClass({
  jl_StackOverflowError: 0
}, false, "java.lang.StackOverflowError", {
  jl_StackOverflowError: 1,
  jl_VirtualMachineError: 1,
  jl_Error: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_StackOverflowError.prototype.$classData = $d_jl_StackOverflowError;
function $ct_jl_UnsupportedOperationException__($thiz) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, null, null, true, true);
  return $thiz
}
function $ct_jl_UnsupportedOperationException__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz
}
/** @constructor */
function $c_jl_UnsupportedOperationException() {
  this.jl_Throwable__f_s = null;
  this.jl_Throwable__f_e = null;
  this.jl_Throwable__f_enableSuppression = false;
  this.jl_Throwable__f_writableStackTrace = false;
  this.jl_Throwable__f_stackTraceStateInternal = null;
  this.jl_Throwable__f_stackTrace = null;
  this.jl_Throwable__f_suppressed = null
}
$c_jl_UnsupportedOperationException.prototype = new $h_jl_RuntimeException();
$c_jl_UnsupportedOperationException.prototype.constructor = $c_jl_UnsupportedOperationException;
/** @constructor */
function $h_jl_UnsupportedOperationException() {
  /*<skip>*/
}
$h_jl_UnsupportedOperationException.prototype = $c_jl_UnsupportedOperationException.prototype;
var $d_jl_UnsupportedOperationException = new $TypeData().initClass({
  jl_UnsupportedOperationException: 0
}, false, "java.lang.UnsupportedOperationException", {
  jl_UnsupportedOperationException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_UnsupportedOperationException.prototype.$classData = $d_jl_UnsupportedOperationException;
/** @constructor */
function $c_Ljava_nio_BufferOverflowException() {
  this.jl_Throwable__f_s = null;
  this.jl_Throwable__f_e = null;
  this.jl_Throwable__f_enableSuppression = false;
  this.jl_Throwable__f_writableStackTrace = false;
  this.jl_Throwable__f_stackTraceStateInternal = null;
  this.jl_Throwable__f_stackTrace = null;
  this.jl_Throwable__f_suppressed = null;
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true)
}
$c_Ljava_nio_BufferOverflowException.prototype = new $h_jl_RuntimeException();
$c_Ljava_nio_BufferOverflowException.prototype.constructor = $c_Ljava_nio_BufferOverflowException;
/** @constructor */
function $h_Ljava_nio_BufferOverflowException() {
  /*<skip>*/
}
$h_Ljava_nio_BufferOverflowException.prototype = $c_Ljava_nio_BufferOverflowException.prototype;
function $as_Ljava_nio_BufferOverflowException(obj) {
  return (((obj instanceof $c_Ljava_nio_BufferOverflowException) || (obj === null)) ? obj : $throwClassCastException(obj, "java.nio.BufferOverflowException"))
}
function $isArrayOf_Ljava_nio_BufferOverflowException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_nio_BufferOverflowException)))
}
function $asArrayOf_Ljava_nio_BufferOverflowException(obj, depth) {
  return (($isArrayOf_Ljava_nio_BufferOverflowException(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.nio.BufferOverflowException;", depth))
}
var $d_Ljava_nio_BufferOverflowException = new $TypeData().initClass({
  Ljava_nio_BufferOverflowException: 0
}, false, "java.nio.BufferOverflowException", {
  Ljava_nio_BufferOverflowException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_nio_BufferOverflowException.prototype.$classData = $d_Ljava_nio_BufferOverflowException;
/** @constructor */
function $c_Ljava_nio_BufferUnderflowException() {
  this.jl_Throwable__f_s = null;
  this.jl_Throwable__f_e = null;
  this.jl_Throwable__f_enableSuppression = false;
  this.jl_Throwable__f_writableStackTrace = false;
  this.jl_Throwable__f_stackTraceStateInternal = null;
  this.jl_Throwable__f_stackTrace = null;
  this.jl_Throwable__f_suppressed = null;
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true)
}
$c_Ljava_nio_BufferUnderflowException.prototype = new $h_jl_RuntimeException();
$c_Ljava_nio_BufferUnderflowException.prototype.constructor = $c_Ljava_nio_BufferUnderflowException;
/** @constructor */
function $h_Ljava_nio_BufferUnderflowException() {
  /*<skip>*/
}
$h_Ljava_nio_BufferUnderflowException.prototype = $c_Ljava_nio_BufferUnderflowException.prototype;
function $as_Ljava_nio_BufferUnderflowException(obj) {
  return (((obj instanceof $c_Ljava_nio_BufferUnderflowException) || (obj === null)) ? obj : $throwClassCastException(obj, "java.nio.BufferUnderflowException"))
}
function $isArrayOf_Ljava_nio_BufferUnderflowException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_nio_BufferUnderflowException)))
}
function $asArrayOf_Ljava_nio_BufferUnderflowException(obj, depth) {
  return (($isArrayOf_Ljava_nio_BufferUnderflowException(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.nio.BufferUnderflowException;", depth))
}
var $d_Ljava_nio_BufferUnderflowException = new $TypeData().initClass({
  Ljava_nio_BufferUnderflowException: 0
}, false, "java.nio.BufferUnderflowException", {
  Ljava_nio_BufferUnderflowException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_nio_BufferUnderflowException.prototype.$classData = $d_Ljava_nio_BufferUnderflowException;
/** @constructor */
function $c_Ljava_nio_charset_CharacterCodingException() {
  this.jl_Throwable__f_s = null;
  this.jl_Throwable__f_e = null;
  this.jl_Throwable__f_enableSuppression = false;
  this.jl_Throwable__f_writableStackTrace = false;
  this.jl_Throwable__f_stackTraceStateInternal = null;
  this.jl_Throwable__f_stackTrace = null;
  this.jl_Throwable__f_suppressed = null
}
$c_Ljava_nio_charset_CharacterCodingException.prototype = new $h_Ljava_io_IOException();
$c_Ljava_nio_charset_CharacterCodingException.prototype.constructor = $c_Ljava_nio_charset_CharacterCodingException;
/** @constructor */
function $h_Ljava_nio_charset_CharacterCodingException() {
  /*<skip>*/
}
$h_Ljava_nio_charset_CharacterCodingException.prototype = $c_Ljava_nio_charset_CharacterCodingException.prototype;
/** @constructor */
function $c_ju_AbstractSet() {
  /*<skip>*/
}
$c_ju_AbstractSet.prototype = new $h_ju_AbstractCollection();
$c_ju_AbstractSet.prototype.constructor = $c_ju_AbstractSet;
/** @constructor */
function $h_ju_AbstractSet() {
  /*<skip>*/
}
$h_ju_AbstractSet.prototype = $c_ju_AbstractSet.prototype;
$c_ju_AbstractSet.prototype.equals__O__Z = (function(that) {
  if ((that === this)) {
    return true
  } else if ($is_ju_Collection(that)) {
    var x2 = $as_ju_Collection(that);
    return ((x2.size__I() === this.size__I()) && this.containsAll__ju_Collection__Z(x2))
  } else {
    return false
  }
});
$c_ju_AbstractSet.prototype.hashCode__I = (function() {
  var _\uff3fself = this.iterator__ju_Iterator();
  var result = 0;
  while (_\uff3fself.hasNext__Z()) {
    var arg1 = result;
    var arg2 = _\uff3fself.next__O();
    var prev = $uI(arg1);
    result = (($dp_hashCode__I(arg2) + prev) | 0)
  };
  return $uI(result)
});
/** @constructor */
function $c_ju_ConcurrentModificationException(s) {
  this.jl_Throwable__f_s = null;
  this.jl_Throwable__f_e = null;
  this.jl_Throwable__f_enableSuppression = false;
  this.jl_Throwable__f_writableStackTrace = false;
  this.jl_Throwable__f_stackTraceStateInternal = null;
  this.jl_Throwable__f_stackTrace = null;
  this.jl_Throwable__f_suppressed = null;
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, s, null, true, true)
}
$c_ju_ConcurrentModificationException.prototype = new $h_jl_RuntimeException();
$c_ju_ConcurrentModificationException.prototype.constructor = $c_ju_ConcurrentModificationException;
/** @constructor */
function $h_ju_ConcurrentModificationException() {
  /*<skip>*/
}
$h_ju_ConcurrentModificationException.prototype = $c_ju_ConcurrentModificationException.prototype;
var $d_ju_ConcurrentModificationException = new $TypeData().initClass({
  ju_ConcurrentModificationException: 0
}, false, "java.util.ConcurrentModificationException", {
  ju_ConcurrentModificationException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_ju_ConcurrentModificationException.prototype.$classData = $d_ju_ConcurrentModificationException;
function $p_ju_HashMap__getOrDefaultImpl__O__O__O($thiz, key, defaultValue) {
  if ((key === null)) {
    var hash = 0
  } else {
    var originalHash = $dp_hashCode__I(key);
    var hash = (originalHash ^ ((originalHash >>> 16) | 0))
  };
  var node = $thiz.java$util$HashMap$$findNode0__O__I__I__ju_HashMap$Node(key, hash, (hash & (((-1) + $thiz.ju_HashMap__f_java$util$HashMap$$table.u.length) | 0)));
  return ((node === null) ? defaultValue : ($thiz.nodeWasAccessed__ju_HashMap$Node__V(node), node.ju_HashMap$Node__f_value))
}
function $p_ju_HashMap__growTable__V($thiz) {
  var oldTable = $thiz.ju_HashMap__f_java$util$HashMap$$table;
  var oldlen = oldTable.u.length;
  var newlen = (oldlen << 1);
  var newTable = new ($d_ju_HashMap$Node.getArrayOf().constr)(newlen);
  $thiz.ju_HashMap__f_java$util$HashMap$$table = newTable;
  $thiz.ju_HashMap__f_threshold = $doubleToInt((newlen * $thiz.ju_HashMap__f_java$util$HashMap$$loadFactor));
  var i = 0;
  while ((i < oldlen)) {
    var lastLow = null;
    var lastHigh = null;
    var node = oldTable.get(i);
    while ((node !== null)) {
      if (((node.ju_HashMap$Node__f_hash & oldlen) === 0)) {
        node.ju_HashMap$Node__f_previous = lastLow;
        if ((lastLow === null)) {
          newTable.set(i, node)
        } else {
          lastLow.ju_HashMap$Node__f_next = node
        };
        lastLow = node
      } else {
        node.ju_HashMap$Node__f_previous = lastHigh;
        if ((lastHigh === null)) {
          newTable.set(((oldlen + i) | 0), node)
        } else {
          lastHigh.ju_HashMap$Node__f_next = node
        };
        lastHigh = node
      };
      node = node.ju_HashMap$Node__f_next
    };
    if ((lastLow !== null)) {
      lastLow.ju_HashMap$Node__f_next = null
    };
    if ((lastHigh !== null)) {
      lastHigh.ju_HashMap$Node__f_next = null
    };
    i = ((1 + i) | 0)
  }
}
function $ct_ju_HashMap__I__F__($thiz, initialCapacity, loadFactor) {
  $thiz.ju_HashMap__f_java$util$HashMap$$loadFactor = loadFactor;
  if ((initialCapacity < 0)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "initialCapacity < 0")
  };
  if ((loadFactor <= 0.0)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "loadFactor <= 0.0")
  };
  var a = (((-1) + initialCapacity) | 0);
  var i = ((a > 4) ? a : 4);
  var a$1 = ((((-2147483648) >> $clz32(i)) & i) << 1);
  $thiz.ju_HashMap__f_java$util$HashMap$$table = new ($d_ju_HashMap$Node.getArrayOf().constr)(((a$1 < 1073741824) ? a$1 : 1073741824));
  var size = $thiz.ju_HashMap__f_java$util$HashMap$$table.u.length;
  $thiz.ju_HashMap__f_threshold = $doubleToInt((size * $thiz.ju_HashMap__f_java$util$HashMap$$loadFactor));
  $thiz.ju_HashMap__f_contentSize = 0;
  return $thiz
}
/** @constructor */
function $c_ju_HashMap() {
  this.ju_HashMap__f_java$util$HashMap$$loadFactor = 0.0;
  this.ju_HashMap__f_java$util$HashMap$$table = null;
  this.ju_HashMap__f_threshold = 0;
  this.ju_HashMap__f_contentSize = 0
}
$c_ju_HashMap.prototype = new $h_ju_AbstractMap();
$c_ju_HashMap.prototype.constructor = $c_ju_HashMap;
/** @constructor */
function $h_ju_HashMap() {
  /*<skip>*/
}
$h_ju_HashMap.prototype = $c_ju_HashMap.prototype;
$c_ju_HashMap.prototype.isEmpty__Z = (function() {
  return (this.ju_HashMap__f_contentSize === 0)
});
$c_ju_HashMap.prototype.containsKey__O__Z = (function(key) {
  if ((key === null)) {
    var hash = 0
  } else {
    var originalHash = $dp_hashCode__I(key);
    var hash = (originalHash ^ ((originalHash >>> 16) | 0))
  };
  return (this.java$util$HashMap$$findNode0__O__I__I__ju_HashMap$Node(key, hash, (hash & (((-1) + this.ju_HashMap__f_java$util$HashMap$$table.u.length) | 0))) !== null)
});
$c_ju_HashMap.prototype.java$util$HashMap$$findNode0__O__I__I__ju_HashMap$Node = (function(key, hash, idx) {
  var node = this.ju_HashMap__f_java$util$HashMap$$table.get(idx);
  while (true) {
    if ((node === null)) {
      return null
    } else {
      if ((hash === node.ju_HashMap$Node__f_hash)) {
        var b = node.ju_HashMap$Node__f_key;
        var $$x1 = ((key === null) ? (b === null) : $dp_equals__O__Z(key, b))
      } else {
        var $$x1 = false
      };
      if ($$x1) {
        return node
      } else if ((hash < node.ju_HashMap$Node__f_hash)) {
        return null
      } else {
        node = node.ju_HashMap$Node__f_next
      }
    }
  }
});
$c_ju_HashMap.prototype.java$util$HashMap$$put0__O__O__I__Z__O = (function(key, value, hash, ifAbsent) {
  var newContentSize = ((1 + this.ju_HashMap__f_contentSize) | 0);
  if ((newContentSize >= this.ju_HashMap__f_threshold)) {
    $p_ju_HashMap__growTable__V(this)
  };
  var idx = (hash & (((-1) + this.ju_HashMap__f_java$util$HashMap$$table.u.length) | 0));
  var x1 = this.ju_HashMap__f_java$util$HashMap$$table.get(idx);
  if ((x1 === null)) {
    var newNode = new $c_ju_LinkedHashMap$Node(key, hash, value, null, null, null, null);
    this.ju_HashMap__f_java$util$HashMap$$table.set(idx, newNode);
    var newNode$3 = newNode
  } else {
    var prev = null;
    var n = x1;
    while (((n !== null) && (n.ju_HashMap$Node__f_hash <= hash))) {
      if ((n.ju_HashMap$Node__f_hash === hash)) {
        var b = n.ju_HashMap$Node__f_key;
        var $$x1 = ((key === null) ? (b === null) : $dp_equals__O__Z(key, b))
      } else {
        var $$x1 = false
      };
      if ($$x1) {
        this.nodeWasAccessed__ju_HashMap$Node__V(n);
        var old = n.ju_HashMap$Node__f_value;
        if (((!ifAbsent) || (old === null))) {
          n.ju_HashMap$Node__f_value = value
        };
        return old
      };
      prev = n;
      n = n.ju_HashMap$Node__f_next
    };
    var previous = prev;
    var next = n;
    var newNode$2 = new $c_ju_LinkedHashMap$Node(key, hash, value, previous, next, null, null);
    if ((prev === null)) {
      this.ju_HashMap__f_java$util$HashMap$$table.set(idx, newNode$2)
    } else {
      prev.ju_HashMap$Node__f_next = newNode$2
    };
    if ((n !== null)) {
      n.ju_HashMap$Node__f_previous = newNode$2
    };
    var newNode$3 = newNode$2
  };
  this.ju_HashMap__f_contentSize = newContentSize;
  this.nodeWasAdded__ju_HashMap$Node__V(newNode$3);
  return null
});
function $ct_ju_NoSuchElementException__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz
}
function $ct_ju_NoSuchElementException__($thiz) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, null, null, true, true);
  return $thiz
}
/** @constructor */
function $c_ju_NoSuchElementException() {
  this.jl_Throwable__f_s = null;
  this.jl_Throwable__f_e = null;
  this.jl_Throwable__f_enableSuppression = false;
  this.jl_Throwable__f_writableStackTrace = false;
  this.jl_Throwable__f_stackTraceStateInternal = null;
  this.jl_Throwable__f_stackTrace = null;
  this.jl_Throwable__f_suppressed = null
}
$c_ju_NoSuchElementException.prototype = new $h_jl_RuntimeException();
$c_ju_NoSuchElementException.prototype.constructor = $c_ju_NoSuchElementException;
/** @constructor */
function $h_ju_NoSuchElementException() {
  /*<skip>*/
}
$h_ju_NoSuchElementException.prototype = $c_ju_NoSuchElementException.prototype;
var $d_ju_NoSuchElementException = new $TypeData().initClass({
  ju_NoSuchElementException: 0
}, false, "java.util.NoSuchElementException", {
  ju_NoSuchElementException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_ju_NoSuchElementException.prototype.$classData = $d_ju_NoSuchElementException;
/** @constructor */
function $c_ju_concurrent_TimeUnit$$anon$1() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  $ct_jl_Enum__T__I__(this, "NANOSECONDS", 0)
}
$c_ju_concurrent_TimeUnit$$anon$1.prototype = new $h_ju_concurrent_TimeUnit();
$c_ju_concurrent_TimeUnit$$anon$1.prototype.constructor = $c_ju_concurrent_TimeUnit$$anon$1;
/** @constructor */
function $h_ju_concurrent_TimeUnit$$anon$1() {
  /*<skip>*/
}
$h_ju_concurrent_TimeUnit$$anon$1.prototype = $c_ju_concurrent_TimeUnit$$anon$1.prototype;
$c_ju_concurrent_TimeUnit$$anon$1.prototype.convert__J__ju_concurrent_TimeUnit__J = (function(a, u) {
  return u.toNanos__J__J(a)
});
$c_ju_concurrent_TimeUnit$$anon$1.prototype.toNanos__J__J = (function(a) {
  return a
});
$c_ju_concurrent_TimeUnit$$anon$1.prototype.toMicros__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 1000, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi)
});
$c_ju_concurrent_TimeUnit$$anon$1.prototype.toMillis__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 1000000, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi)
});
$c_ju_concurrent_TimeUnit$$anon$1.prototype.toSeconds__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 1000000000, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi)
});
$c_ju_concurrent_TimeUnit$$anon$1.prototype.toMinutes__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, (-129542144), 13);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi)
});
$c_ju_concurrent_TimeUnit$$anon$1.prototype.toHours__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 817405952, 838);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi)
});
$c_ju_concurrent_TimeUnit$$anon$1.prototype.toDays__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, (-1857093632), 20116);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi)
});
var $d_ju_concurrent_TimeUnit$$anon$1 = new $TypeData().initClass({
  ju_concurrent_TimeUnit$$anon$1: 0
}, false, "java.util.concurrent.TimeUnit$$anon$1", {
  ju_concurrent_TimeUnit$$anon$1: 1,
  ju_concurrent_TimeUnit: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1
});
$c_ju_concurrent_TimeUnit$$anon$1.prototype.$classData = $d_ju_concurrent_TimeUnit$$anon$1;
/** @constructor */
function $c_ju_concurrent_TimeUnit$$anon$2() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  $ct_jl_Enum__T__I__(this, "MICROSECONDS", 1)
}
$c_ju_concurrent_TimeUnit$$anon$2.prototype = new $h_ju_concurrent_TimeUnit();
$c_ju_concurrent_TimeUnit$$anon$2.prototype.constructor = $c_ju_concurrent_TimeUnit$$anon$2;
/** @constructor */
function $h_ju_concurrent_TimeUnit$$anon$2() {
  /*<skip>*/
}
$h_ju_concurrent_TimeUnit$$anon$2.prototype = $c_ju_concurrent_TimeUnit$$anon$2.prototype;
$c_ju_concurrent_TimeUnit$$anon$2.prototype.convert__J__ju_concurrent_TimeUnit__J = (function(a, u) {
  return u.toMicros__J__J(a)
});
$c_ju_concurrent_TimeUnit$$anon$2.prototype.toNanos__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(1000, 0), new $c_RTLong((-1511828489), 2147483))
});
$c_ju_concurrent_TimeUnit$$anon$2.prototype.toMicros__J__J = (function(a) {
  return a
});
$c_ju_concurrent_TimeUnit$$anon$2.prototype.toMillis__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 1000, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi)
});
$c_ju_concurrent_TimeUnit$$anon$2.prototype.toSeconds__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 1000000, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi)
});
$c_ju_concurrent_TimeUnit$$anon$2.prototype.toMinutes__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 60000000, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi)
});
$c_ju_concurrent_TimeUnit$$anon$2.prototype.toHours__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, (-694967296), 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi)
});
$c_ju_concurrent_TimeUnit$$anon$2.prototype.toDays__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 500654080, 20);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi)
});
var $d_ju_concurrent_TimeUnit$$anon$2 = new $TypeData().initClass({
  ju_concurrent_TimeUnit$$anon$2: 0
}, false, "java.util.concurrent.TimeUnit$$anon$2", {
  ju_concurrent_TimeUnit$$anon$2: 1,
  ju_concurrent_TimeUnit: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1
});
$c_ju_concurrent_TimeUnit$$anon$2.prototype.$classData = $d_ju_concurrent_TimeUnit$$anon$2;
/** @constructor */
function $c_ju_concurrent_TimeUnit$$anon$3() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  $ct_jl_Enum__T__I__(this, "MILLISECONDS", 2)
}
$c_ju_concurrent_TimeUnit$$anon$3.prototype = new $h_ju_concurrent_TimeUnit();
$c_ju_concurrent_TimeUnit$$anon$3.prototype.constructor = $c_ju_concurrent_TimeUnit$$anon$3;
/** @constructor */
function $h_ju_concurrent_TimeUnit$$anon$3() {
  /*<skip>*/
}
$h_ju_concurrent_TimeUnit$$anon$3.prototype = $c_ju_concurrent_TimeUnit$$anon$3.prototype;
$c_ju_concurrent_TimeUnit$$anon$3.prototype.convert__J__ju_concurrent_TimeUnit__J = (function(a, u) {
  return u.toMillis__J__J(a)
});
$c_ju_concurrent_TimeUnit$$anon$3.prototype.toNanos__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(1000000, 0), new $c_RTLong(2077252342, 2147))
});
$c_ju_concurrent_TimeUnit$$anon$3.prototype.toMicros__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(1000, 0), new $c_RTLong((-1511828489), 2147483))
});
$c_ju_concurrent_TimeUnit$$anon$3.prototype.toMillis__J__J = (function(a) {
  return a
});
$c_ju_concurrent_TimeUnit$$anon$3.prototype.toSeconds__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 1000, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi)
});
$c_ju_concurrent_TimeUnit$$anon$3.prototype.toMinutes__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 60000, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi)
});
$c_ju_concurrent_TimeUnit$$anon$3.prototype.toHours__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 3600000, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi)
});
$c_ju_concurrent_TimeUnit$$anon$3.prototype.toDays__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 86400000, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi)
});
var $d_ju_concurrent_TimeUnit$$anon$3 = new $TypeData().initClass({
  ju_concurrent_TimeUnit$$anon$3: 0
}, false, "java.util.concurrent.TimeUnit$$anon$3", {
  ju_concurrent_TimeUnit$$anon$3: 1,
  ju_concurrent_TimeUnit: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1
});
$c_ju_concurrent_TimeUnit$$anon$3.prototype.$classData = $d_ju_concurrent_TimeUnit$$anon$3;
/** @constructor */
function $c_ju_concurrent_TimeUnit$$anon$4() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  $ct_jl_Enum__T__I__(this, "SECONDS", 3)
}
$c_ju_concurrent_TimeUnit$$anon$4.prototype = new $h_ju_concurrent_TimeUnit();
$c_ju_concurrent_TimeUnit$$anon$4.prototype.constructor = $c_ju_concurrent_TimeUnit$$anon$4;
/** @constructor */
function $h_ju_concurrent_TimeUnit$$anon$4() {
  /*<skip>*/
}
$h_ju_concurrent_TimeUnit$$anon$4.prototype = $c_ju_concurrent_TimeUnit$$anon$4.prototype;
$c_ju_concurrent_TimeUnit$$anon$4.prototype.convert__J__ju_concurrent_TimeUnit__J = (function(a, u) {
  return u.toSeconds__J__J(a)
});
$c_ju_concurrent_TimeUnit$$anon$4.prototype.toNanos__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(1000000000, 0), new $c_RTLong(633437444, 2))
});
$c_ju_concurrent_TimeUnit$$anon$4.prototype.toMicros__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(1000000, 0), new $c_RTLong(2077252342, 2147))
});
$c_ju_concurrent_TimeUnit$$anon$4.prototype.toMillis__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(1000, 0), new $c_RTLong((-1511828489), 2147483))
});
$c_ju_concurrent_TimeUnit$$anon$4.prototype.toSeconds__J__J = (function(a) {
  return a
});
$c_ju_concurrent_TimeUnit$$anon$4.prototype.toMinutes__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 60, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi)
});
$c_ju_concurrent_TimeUnit$$anon$4.prototype.toHours__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 3600, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi)
});
$c_ju_concurrent_TimeUnit$$anon$4.prototype.toDays__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 86400, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi)
});
var $d_ju_concurrent_TimeUnit$$anon$4 = new $TypeData().initClass({
  ju_concurrent_TimeUnit$$anon$4: 0
}, false, "java.util.concurrent.TimeUnit$$anon$4", {
  ju_concurrent_TimeUnit$$anon$4: 1,
  ju_concurrent_TimeUnit: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1
});
$c_ju_concurrent_TimeUnit$$anon$4.prototype.$classData = $d_ju_concurrent_TimeUnit$$anon$4;
/** @constructor */
function $c_ju_concurrent_TimeUnit$$anon$5() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  $ct_jl_Enum__T__I__(this, "MINUTES", 4)
}
$c_ju_concurrent_TimeUnit$$anon$5.prototype = new $h_ju_concurrent_TimeUnit();
$c_ju_concurrent_TimeUnit$$anon$5.prototype.constructor = $c_ju_concurrent_TimeUnit$$anon$5;
/** @constructor */
function $h_ju_concurrent_TimeUnit$$anon$5() {
  /*<skip>*/
}
$h_ju_concurrent_TimeUnit$$anon$5.prototype = $c_ju_concurrent_TimeUnit$$anon$5.prototype;
$c_ju_concurrent_TimeUnit$$anon$5.prototype.convert__J__ju_concurrent_TimeUnit__J = (function(a, u) {
  return u.toMinutes__J__J(a)
});
$c_ju_concurrent_TimeUnit$$anon$5.prototype.toNanos__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong((-129542144), 13), new $c_RTLong(153722867, 0))
});
$c_ju_concurrent_TimeUnit$$anon$5.prototype.toMicros__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(60000000, 0), new $c_RTLong((-895955376), 35))
});
$c_ju_concurrent_TimeUnit$$anon$5.prototype.toMillis__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(60000, 0), new $c_RTLong(1692789776, 35791))
});
$c_ju_concurrent_TimeUnit$$anon$5.prototype.toSeconds__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(60, 0), new $c_RTLong(572662306, 35791394))
});
$c_ju_concurrent_TimeUnit$$anon$5.prototype.toMinutes__J__J = (function(a) {
  return a
});
$c_ju_concurrent_TimeUnit$$anon$5.prototype.toHours__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 60, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi)
});
$c_ju_concurrent_TimeUnit$$anon$5.prototype.toDays__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 1440, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi)
});
var $d_ju_concurrent_TimeUnit$$anon$5 = new $TypeData().initClass({
  ju_concurrent_TimeUnit$$anon$5: 0
}, false, "java.util.concurrent.TimeUnit$$anon$5", {
  ju_concurrent_TimeUnit$$anon$5: 1,
  ju_concurrent_TimeUnit: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1
});
$c_ju_concurrent_TimeUnit$$anon$5.prototype.$classData = $d_ju_concurrent_TimeUnit$$anon$5;
/** @constructor */
function $c_ju_concurrent_TimeUnit$$anon$6() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  $ct_jl_Enum__T__I__(this, "HOURS", 5)
}
$c_ju_concurrent_TimeUnit$$anon$6.prototype = new $h_ju_concurrent_TimeUnit();
$c_ju_concurrent_TimeUnit$$anon$6.prototype.constructor = $c_ju_concurrent_TimeUnit$$anon$6;
/** @constructor */
function $h_ju_concurrent_TimeUnit$$anon$6() {
  /*<skip>*/
}
$h_ju_concurrent_TimeUnit$$anon$6.prototype = $c_ju_concurrent_TimeUnit$$anon$6.prototype;
$c_ju_concurrent_TimeUnit$$anon$6.prototype.convert__J__ju_concurrent_TimeUnit__J = (function(a, u) {
  return u.toHours__J__J(a)
});
$c_ju_concurrent_TimeUnit$$anon$6.prototype.toNanos__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(817405952, 838), new $c_RTLong(2562047, 0))
});
$c_ju_concurrent_TimeUnit$$anon$6.prototype.toMicros__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong((-694967296), 0), new $c_RTLong((-1732919508), 0))
});
$c_ju_concurrent_TimeUnit$$anon$6.prototype.toMillis__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(3600000, 0), new $c_RTLong((-2047687697), 596))
});
$c_ju_concurrent_TimeUnit$$anon$6.prototype.toSeconds__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(3600, 0), new $c_RTLong(1011703407, 596523))
});
$c_ju_concurrent_TimeUnit$$anon$6.prototype.toMinutes__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(60, 0), new $c_RTLong(572662306, 35791394))
});
$c_ju_concurrent_TimeUnit$$anon$6.prototype.toHours__J__J = (function(a) {
  return a
});
$c_ju_concurrent_TimeUnit$$anon$6.prototype.toDays__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 24, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi)
});
var $d_ju_concurrent_TimeUnit$$anon$6 = new $TypeData().initClass({
  ju_concurrent_TimeUnit$$anon$6: 0
}, false, "java.util.concurrent.TimeUnit$$anon$6", {
  ju_concurrent_TimeUnit$$anon$6: 1,
  ju_concurrent_TimeUnit: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1
});
$c_ju_concurrent_TimeUnit$$anon$6.prototype.$classData = $d_ju_concurrent_TimeUnit$$anon$6;
/** @constructor */
function $c_ju_concurrent_TimeUnit$$anon$7() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  $ct_jl_Enum__T__I__(this, "DAYS", 6)
}
$c_ju_concurrent_TimeUnit$$anon$7.prototype = new $h_ju_concurrent_TimeUnit();
$c_ju_concurrent_TimeUnit$$anon$7.prototype.constructor = $c_ju_concurrent_TimeUnit$$anon$7;
/** @constructor */
function $h_ju_concurrent_TimeUnit$$anon$7() {
  /*<skip>*/
}
$h_ju_concurrent_TimeUnit$$anon$7.prototype = $c_ju_concurrent_TimeUnit$$anon$7.prototype;
$c_ju_concurrent_TimeUnit$$anon$7.prototype.convert__J__ju_concurrent_TimeUnit__J = (function(a, u) {
  return u.toDays__J__J(a)
});
$c_ju_concurrent_TimeUnit$$anon$7.prototype.toNanos__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong((-1857093632), 20116), new $c_RTLong(106751, 0))
});
$c_ju_concurrent_TimeUnit$$anon$7.prototype.toMicros__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(500654080, 20), new $c_RTLong(106751991, 0))
});
$c_ju_concurrent_TimeUnit$$anon$7.prototype.toMillis__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(86400000, 0), new $c_RTLong((-622191233), 24))
});
$c_ju_concurrent_TimeUnit$$anon$7.prototype.toSeconds__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(86400, 0), new $c_RTLong(579025220, 24855))
});
$c_ju_concurrent_TimeUnit$$anon$7.prototype.toMinutes__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(1440, 0), new $c_RTLong(381774870, 1491308))
});
$c_ju_concurrent_TimeUnit$$anon$7.prototype.toHours__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(24, 0), new $c_RTLong(1431655765, 89478485))
});
$c_ju_concurrent_TimeUnit$$anon$7.prototype.toDays__J__J = (function(a) {
  return a
});
var $d_ju_concurrent_TimeUnit$$anon$7 = new $TypeData().initClass({
  ju_concurrent_TimeUnit$$anon$7: 0
}, false, "java.util.concurrent.TimeUnit$$anon$7", {
  ju_concurrent_TimeUnit$$anon$7: 1,
  ju_concurrent_TimeUnit: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1
});
$c_ju_concurrent_TimeUnit$$anon$7.prototype.$classData = $d_ju_concurrent_TimeUnit$$anon$7;
/** @constructor */
function $c_Lorg_scalajs_linker_runtime_UndefinedBehaviorError(cause) {
  this.jl_Throwable__f_s = null;
  this.jl_Throwable__f_e = null;
  this.jl_Throwable__f_enableSuppression = false;
  this.jl_Throwable__f_writableStackTrace = false;
  this.jl_Throwable__f_stackTraceStateInternal = null;
  this.jl_Throwable__f_stackTrace = null;
  this.jl_Throwable__f_suppressed = null;
  var message = ((cause === null) ? null : cause.toString__T());
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, message, cause, true, true)
}
$c_Lorg_scalajs_linker_runtime_UndefinedBehaviorError.prototype = new $h_jl_VirtualMachineError();
$c_Lorg_scalajs_linker_runtime_UndefinedBehaviorError.prototype.constructor = $c_Lorg_scalajs_linker_runtime_UndefinedBehaviorError;
/** @constructor */
function $h_Lorg_scalajs_linker_runtime_UndefinedBehaviorError() {
  /*<skip>*/
}
$h_Lorg_scalajs_linker_runtime_UndefinedBehaviorError.prototype = $c_Lorg_scalajs_linker_runtime_UndefinedBehaviorError.prototype;
var $d_Lorg_scalajs_linker_runtime_UndefinedBehaviorError = new $TypeData().initClass({
  Lorg_scalajs_linker_runtime_UndefinedBehaviorError: 0
}, false, "org.scalajs.linker.runtime.UndefinedBehaviorError", {
  Lorg_scalajs_linker_runtime_UndefinedBehaviorError: 1,
  jl_VirtualMachineError: 1,
  jl_Error: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lorg_scalajs_linker_runtime_UndefinedBehaviorError.prototype.$classData = $d_Lorg_scalajs_linker_runtime_UndefinedBehaviorError;
/** @constructor */
function $c_Lplay_api_libs_json_JsError(errors) {
  this.Lplay_api_libs_json_JsError__f_errors = null;
  this.Lplay_api_libs_json_JsError__f_isSuccess = false;
  this.Lplay_api_libs_json_JsError__f_isError = false;
  this.Lplay_api_libs_json_JsError__f_asOpt = null;
  this.Lplay_api_libs_json_JsError__f_errors = errors;
  this.Lplay_api_libs_json_JsError__f_isSuccess = false;
  this.Lplay_api_libs_json_JsError__f_isError = true;
  this.Lplay_api_libs_json_JsError__f_asOpt = $m_s_None$()
}
$c_Lplay_api_libs_json_JsError.prototype = new $h_O();
$c_Lplay_api_libs_json_JsError.prototype.constructor = $c_Lplay_api_libs_json_JsError;
/** @constructor */
function $h_Lplay_api_libs_json_JsError() {
  /*<skip>*/
}
$h_Lplay_api_libs_json_JsError.prototype = $c_Lplay_api_libs_json_JsError.prototype;
$c_Lplay_api_libs_json_JsError.prototype.map__F1__Lplay_api_libs_json_JsResult = (function(f) {
  return this
});
$c_Lplay_api_libs_json_JsError.prototype.flatMap__F1__Lplay_api_libs_json_JsResult = (function(f) {
  return this
});
$c_Lplay_api_libs_json_JsError.prototype.repath__Lplay_api_libs_json_JsPath__Lplay_api_libs_json_JsResult = (function(path) {
  return new $c_Lplay_api_libs_json_JsError($m_Lplay_api_libs_json_JsResult$().repath__sc_Seq__Lplay_api_libs_json_JsPath__sc_Seq(this.Lplay_api_libs_json_JsError__f_errors, path))
});
$c_Lplay_api_libs_json_JsError.prototype.productPrefix__T = (function() {
  return "JsError"
});
$c_Lplay_api_libs_json_JsError.prototype.productArity__I = (function() {
  return 1
});
$c_Lplay_api_libs_json_JsError.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lplay_api_libs_json_JsError__f_errors : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lplay_api_libs_json_JsError.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lplay_api_libs_json_JsError.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lplay_api_libs_json_JsError.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lplay_api_libs_json_JsError.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lplay_api_libs_json_JsError)) {
    var JsError$1 = $as_Lplay_api_libs_json_JsError(x$1);
    var x = this.Lplay_api_libs_json_JsError__f_errors;
    var x$2 = JsError$1.Lplay_api_libs_json_JsError__f_errors;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lplay_api_libs_json_JsError(obj) {
  return (((obj instanceof $c_Lplay_api_libs_json_JsError) || (obj === null)) ? obj : $throwClassCastException(obj, "play.api.libs.json.JsError"))
}
function $isArrayOf_Lplay_api_libs_json_JsError(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lplay_api_libs_json_JsError)))
}
function $asArrayOf_Lplay_api_libs_json_JsError(obj, depth) {
  return (($isArrayOf_Lplay_api_libs_json_JsError(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lplay.api.libs.json.JsError;", depth))
}
var $d_Lplay_api_libs_json_JsError = new $TypeData().initClass({
  Lplay_api_libs_json_JsError: 0
}, false, "play.api.libs.json.JsError", {
  Lplay_api_libs_json_JsError: 1,
  O: 1,
  Lplay_api_libs_json_JsResult: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lplay_api_libs_json_JsError.prototype.$classData = $d_Lplay_api_libs_json_JsError;
function $p_Lplay_api_libs_json_JsPath$__step$1__sci_List__Lplay_api_libs_json_JsValue__Lplay_api_libs_json_JsObject($thiz, path, value) {
  if ((path !== null)) {
    $m_sci_List$();
    if (((new $c_sc_SeqFactory$UnapplySeqWrapper(path), true) && (path.lengthCompare__I__I(0) === 0))) {
      if ((value instanceof $c_Lplay_api_libs_json_JsObject)) {
        var x2 = $as_Lplay_api_libs_json_JsObject(value);
        return x2
      } else {
        throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O($ct_jl_RuntimeException__T__(new $c_jl_RuntimeException(), "when empty JsPath, expecting JsObject"))
      }
    }
  };
  if ((path !== null)) {
    $m_sci_List$();
    if (((new $c_sc_SeqFactory$UnapplySeqWrapper(path), true) && (path.lengthCompare__I__I(1) === 0))) {
      var p = $as_Lplay_api_libs_json_PathNode($f_sc_LinearSeqOps__apply__I__O(path, 0));
      if ((p instanceof $c_Lplay_api_libs_json_KeyPathNode)) {
        var x2$2 = $as_Lplay_api_libs_json_KeyPathNode(p);
        var key = x2$2.Lplay_api_libs_json_KeyPathNode__f_key;
        var $$x2 = $m_Lplay_api_libs_json_JsObject$();
        var $$x1 = $m_sci_Seq$();
        var array = [new $c_T2(key, value)];
        return $$x2.apply__sc_Seq__Lplay_api_libs_json_JsObject($as_sc_Seq($$x1.apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array))))
      } else {
        throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O($ct_jl_RuntimeException__T__(new $c_jl_RuntimeException(), "expected KeyPathNode"))
      }
    }
  };
  if ((path instanceof $c_sci_$colon$colon)) {
    var x4 = $as_sci_$colon$colon(path);
    var head = $as_Lplay_api_libs_json_PathNode(x4.sci_$colon$colon__f_head);
    var tail = x4.sci_$colon$colon__f_next;
    if ((head instanceof $c_Lplay_api_libs_json_KeyPathNode)) {
      var x2$3 = $as_Lplay_api_libs_json_KeyPathNode(head);
      var key$2 = x2$3.Lplay_api_libs_json_KeyPathNode__f_key;
      var $$x4 = $m_Lplay_api_libs_json_JsObject$();
      var $$x3 = $m_sci_Seq$();
      var y = $p_Lplay_api_libs_json_JsPath$__step$1__sci_List__Lplay_api_libs_json_JsValue__Lplay_api_libs_json_JsObject($thiz, tail, value);
      var array$1 = [new $c_T2(key$2, y)];
      return $$x4.apply__sc_Seq__Lplay_api_libs_json_JsObject($as_sc_Seq($$x3.apply__sci_Seq__sc_SeqOps($ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1))))
    } else {
      throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O($ct_jl_RuntimeException__T__(new $c_jl_RuntimeException(), "expected KeyPathNode"))
    }
  };
  throw new $c_s_MatchError(path)
}
/** @constructor */
function $c_Lplay_api_libs_json_JsPath$() {
  this.Lplay_api_libs_json_JsPath__f_PathMissingError = null;
  this.Lplay_api_libs_json_JsPath__f_json$module = null;
  this.Lplay_api_libs_json_JsPath__f_path = null;
  this.Lplay_api_libs_json_JsPath__f_play$api$libs$json$JsPath$$self = null;
  this.Lplay_api_libs_json_JsPath__f_bitmap$0 = false;
  $ct_Lplay_api_libs_json_JsPath__sci_List__(this, ($m_sci_List$(), $m_sci_Nil$()))
}
$c_Lplay_api_libs_json_JsPath$.prototype = new $h_Lplay_api_libs_json_JsPath();
$c_Lplay_api_libs_json_JsPath$.prototype.constructor = $c_Lplay_api_libs_json_JsPath$;
/** @constructor */
function $h_Lplay_api_libs_json_JsPath$() {
  /*<skip>*/
}
$h_Lplay_api_libs_json_JsPath$.prototype = $c_Lplay_api_libs_json_JsPath$.prototype;
$c_Lplay_api_libs_json_JsPath$.prototype.createObj__sci_Seq__Lplay_api_libs_json_JsObject = (function(pathValues) {
  var objectMap = $m_Lplay_api_libs_json_JsObject$().createFieldsMap__sc_Iterable__scm_Map($as_sc_Iterable($m_sc_Seq$().empty__sc_SeqOps()));
  var isSimpleObject = pathValues.forall__F1__Z(new $c_sjsr_AnonFunction1((function(this$2, objectMap$1) {
    return (function(x0$1$2) {
      var x0$1 = $as_T2(x0$1$2);
      if ((x0$1 !== null)) {
        var p2 = $as_Lplay_api_libs_json_JsPath(x0$1._1__O());
        var value = $as_Lplay_api_libs_json_JsValue(x0$1._2__O());
        if ((p2 !== null)) {
          var p3 = p2.Lplay_api_libs_json_JsPath__f_path;
          if ((p3 instanceof $c_sci_$colon$colon)) {
            var x4 = $as_sci_$colon$colon(p3);
            var p5 = $as_Lplay_api_libs_json_PathNode(x4.sci_$colon$colon__f_head);
            var p6 = x4.sci_$colon$colon__f_next;
            if ((p5 instanceof $c_Lplay_api_libs_json_KeyPathNode)) {
              var x7 = $as_Lplay_api_libs_json_KeyPathNode(p5);
              var key = x7.Lplay_api_libs_json_KeyPathNode__f_key;
              var x = $m_sci_Nil$();
              if (x.equals__O__Z(p6)) {
                objectMap$1.put__O__O__s_Option(key, value);
                return true
              }
            }
          }
        }
      };
      return false
    })
  })(this, objectMap)));
  return (isSimpleObject ? new $c_Lplay_api_libs_json_JsObject(objectMap) : $as_Lplay_api_libs_json_JsObject(pathValues.foldLeft__O__F2__O($m_Lplay_api_libs_json_JsObject$().apply__sc_Seq__Lplay_api_libs_json_JsObject($as_sc_Seq($m_sc_Seq$().empty__sc_SeqOps())), new $c_sjsr_AnonFunction2((function(this$2$1) {
    return (function(x0$2$2, x1$1$2) {
      var x0$2 = $as_Lplay_api_libs_json_JsObject(x0$2$2);
      var x1$1 = $as_T2(x1$1$2);
      var x1 = new $c_T2(x0$2, x1$1);
      var obj = $as_Lplay_api_libs_json_JsObject(x1.T2__f__1);
      var p2$1 = $as_T2(x1.T2__f__2);
      if ((p2$1 !== null)) {
        var path = $as_Lplay_api_libs_json_JsPath(p2$1._1__O());
        var value$1 = $as_Lplay_api_libs_json_JsValue(p2$1._2__O());
        var other = $p_Lplay_api_libs_json_JsPath$__step$1__sci_List__Lplay_api_libs_json_JsValue__Lplay_api_libs_json_JsObject(this$2$1, path.Lplay_api_libs_json_JsPath__f_path, value$1);
        return $p_Lplay_api_libs_json_JsObject__merge$1__Lplay_api_libs_json_JsObject__Lplay_api_libs_json_JsObject__Lplay_api_libs_json_JsObject(obj, obj, other)
      };
      throw new $c_s_MatchError(x1)
    })
  })(this)))))
});
var $d_Lplay_api_libs_json_JsPath$ = new $TypeData().initClass({
  Lplay_api_libs_json_JsPath$: 0
}, false, "play.api.libs.json.JsPath$", {
  Lplay_api_libs_json_JsPath$: 1,
  Lplay_api_libs_json_JsPath: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lplay_api_libs_json_JsPath$.prototype.$classData = $d_Lplay_api_libs_json_JsPath$;
var $n_Lplay_api_libs_json_JsPath$;
function $m_Lplay_api_libs_json_JsPath$() {
  if ((!$n_Lplay_api_libs_json_JsPath$)) {
    $n_Lplay_api_libs_json_JsPath$ = new $c_Lplay_api_libs_json_JsPath$()
  };
  return $n_Lplay_api_libs_json_JsPath$
}
/** @constructor */
function $c_Lplay_api_libs_json_JsSuccess(value, path) {
  this.Lplay_api_libs_json_JsSuccess__f_value = null;
  this.Lplay_api_libs_json_JsSuccess__f_path = null;
  this.Lplay_api_libs_json_JsSuccess__f_isSuccess = false;
  this.Lplay_api_libs_json_JsSuccess__f_isError = false;
  this.Lplay_api_libs_json_JsSuccess__f_value = value;
  this.Lplay_api_libs_json_JsSuccess__f_path = path;
  this.Lplay_api_libs_json_JsSuccess__f_isSuccess = true;
  this.Lplay_api_libs_json_JsSuccess__f_isError = false
}
$c_Lplay_api_libs_json_JsSuccess.prototype = new $h_O();
$c_Lplay_api_libs_json_JsSuccess.prototype.constructor = $c_Lplay_api_libs_json_JsSuccess;
/** @constructor */
function $h_Lplay_api_libs_json_JsSuccess() {
  /*<skip>*/
}
$h_Lplay_api_libs_json_JsSuccess.prototype = $c_Lplay_api_libs_json_JsSuccess.prototype;
$c_Lplay_api_libs_json_JsSuccess.prototype.map__F1__Lplay_api_libs_json_JsResult = (function(f) {
  var value = f.apply__O__O(this.Lplay_api_libs_json_JsSuccess__f_value);
  var path = this.Lplay_api_libs_json_JsSuccess__f_path;
  return new $c_Lplay_api_libs_json_JsSuccess(value, path)
});
$c_Lplay_api_libs_json_JsSuccess.prototype.flatMap__F1__Lplay_api_libs_json_JsResult = (function(f) {
  return $as_Lplay_api_libs_json_JsResult(f.apply__O__O(this.Lplay_api_libs_json_JsSuccess__f_value)).repath__Lplay_api_libs_json_JsPath__Lplay_api_libs_json_JsResult(this.Lplay_api_libs_json_JsSuccess__f_path)
});
$c_Lplay_api_libs_json_JsSuccess.prototype.repath__Lplay_api_libs_json_JsPath__Lplay_api_libs_json_JsResult = (function(path) {
  var $$x1 = this.Lplay_api_libs_json_JsSuccess__f_value;
  var other = this.Lplay_api_libs_json_JsSuccess__f_path;
  return new $c_Lplay_api_libs_json_JsSuccess($$x1, path.compose__Lplay_api_libs_json_JsPath__Lplay_api_libs_json_JsPath(other))
});
$c_Lplay_api_libs_json_JsSuccess.prototype.productPrefix__T = (function() {
  return "JsSuccess"
});
$c_Lplay_api_libs_json_JsSuccess.prototype.productArity__I = (function() {
  return 2
});
$c_Lplay_api_libs_json_JsSuccess.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lplay_api_libs_json_JsSuccess__f_value;
      break
    }
    case 1: {
      return this.Lplay_api_libs_json_JsSuccess__f_path;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lplay_api_libs_json_JsSuccess.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lplay_api_libs_json_JsSuccess.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lplay_api_libs_json_JsSuccess.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lplay_api_libs_json_JsSuccess.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lplay_api_libs_json_JsSuccess)) {
    var JsSuccess$1 = $as_Lplay_api_libs_json_JsSuccess(x$1);
    var x = this.Lplay_api_libs_json_JsSuccess__f_value;
    var y = JsSuccess$1.Lplay_api_libs_json_JsSuccess__f_value;
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      var x$2 = this.Lplay_api_libs_json_JsSuccess__f_path;
      var x$2$1 = JsSuccess$1.Lplay_api_libs_json_JsSuccess__f_path;
      return ((x$2 === null) ? (x$2$1 === null) : x$2.equals__O__Z(x$2$1))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lplay_api_libs_json_JsSuccess(obj) {
  return (((obj instanceof $c_Lplay_api_libs_json_JsSuccess) || (obj === null)) ? obj : $throwClassCastException(obj, "play.api.libs.json.JsSuccess"))
}
function $isArrayOf_Lplay_api_libs_json_JsSuccess(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lplay_api_libs_json_JsSuccess)))
}
function $asArrayOf_Lplay_api_libs_json_JsSuccess(obj, depth) {
  return (($isArrayOf_Lplay_api_libs_json_JsSuccess(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lplay.api.libs.json.JsSuccess;", depth))
}
var $d_Lplay_api_libs_json_JsSuccess = new $TypeData().initClass({
  Lplay_api_libs_json_JsSuccess: 0
}, false, "play.api.libs.json.JsSuccess", {
  Lplay_api_libs_json_JsSuccess: 1,
  O: 1,
  Lplay_api_libs_json_JsResult: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lplay_api_libs_json_JsSuccess.prototype.$classData = $d_Lplay_api_libs_json_JsSuccess;
/** @constructor */
function $c_Lplay_api_libs_json_KeyPathNode(key) {
  this.Lplay_api_libs_json_KeyPathNode__f_key = null;
  this.Lplay_api_libs_json_KeyPathNode__f_key = key
}
$c_Lplay_api_libs_json_KeyPathNode.prototype = new $h_O();
$c_Lplay_api_libs_json_KeyPathNode.prototype.constructor = $c_Lplay_api_libs_json_KeyPathNode;
/** @constructor */
function $h_Lplay_api_libs_json_KeyPathNode() {
  /*<skip>*/
}
$h_Lplay_api_libs_json_KeyPathNode.prototype = $c_Lplay_api_libs_json_KeyPathNode.prototype;
$c_Lplay_api_libs_json_KeyPathNode.prototype.apply__Lplay_api_libs_json_JsValue__sci_List = (function(json) {
  if ((json instanceof $c_Lplay_api_libs_json_JsObject)) {
    var x2 = $as_Lplay_api_libs_json_JsObject(json);
    return x2.Lplay_api_libs_json_JsObject__f_underlying.get__O__s_Option(this.Lplay_api_libs_json_KeyPathNode__f_key).toList__sci_List()
  } else {
    return $m_sci_Nil$()
  }
});
$c_Lplay_api_libs_json_KeyPathNode.prototype.toString__T = (function() {
  return ("/" + this.Lplay_api_libs_json_KeyPathNode__f_key)
});
$c_Lplay_api_libs_json_KeyPathNode.prototype.productPrefix__T = (function() {
  return "KeyPathNode"
});
$c_Lplay_api_libs_json_KeyPathNode.prototype.productArity__I = (function() {
  return 1
});
$c_Lplay_api_libs_json_KeyPathNode.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lplay_api_libs_json_KeyPathNode__f_key : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lplay_api_libs_json_KeyPathNode.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lplay_api_libs_json_KeyPathNode.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lplay_api_libs_json_KeyPathNode.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lplay_api_libs_json_KeyPathNode)) {
    var KeyPathNode$1 = $as_Lplay_api_libs_json_KeyPathNode(x$1);
    return (this.Lplay_api_libs_json_KeyPathNode__f_key === KeyPathNode$1.Lplay_api_libs_json_KeyPathNode__f_key)
  } else {
    return false
  }
});
function $as_Lplay_api_libs_json_KeyPathNode(obj) {
  return (((obj instanceof $c_Lplay_api_libs_json_KeyPathNode) || (obj === null)) ? obj : $throwClassCastException(obj, "play.api.libs.json.KeyPathNode"))
}
function $isArrayOf_Lplay_api_libs_json_KeyPathNode(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lplay_api_libs_json_KeyPathNode)))
}
function $asArrayOf_Lplay_api_libs_json_KeyPathNode(obj, depth) {
  return (($isArrayOf_Lplay_api_libs_json_KeyPathNode(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lplay.api.libs.json.KeyPathNode;", depth))
}
var $d_Lplay_api_libs_json_KeyPathNode = new $TypeData().initClass({
  Lplay_api_libs_json_KeyPathNode: 0
}, false, "play.api.libs.json.KeyPathNode", {
  Lplay_api_libs_json_KeyPathNode: 1,
  O: 1,
  Lplay_api_libs_json_PathNode: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lplay_api_libs_json_KeyPathNode.prototype.$classData = $d_Lplay_api_libs_json_KeyPathNode;
function $is_Lplay_api_libs_json_OFormat(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lplay_api_libs_json_OFormat)))
}
function $as_Lplay_api_libs_json_OFormat(obj) {
  return (($is_Lplay_api_libs_json_OFormat(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "play.api.libs.json.OFormat"))
}
function $isArrayOf_Lplay_api_libs_json_OFormat(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lplay_api_libs_json_OFormat)))
}
function $asArrayOf_Lplay_api_libs_json_OFormat(obj, depth) {
  return (($isArrayOf_Lplay_api_libs_json_OFormat(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lplay.api.libs.json.OFormat;", depth))
}
/** @constructor */
function $c_s_$less$colon$less$$anon$1() {
  /*<skip>*/
}
$c_s_$less$colon$less$$anon$1.prototype = new $h_s_$eq$colon$eq();
$c_s_$less$colon$less$$anon$1.prototype.constructor = $c_s_$less$colon$less$$anon$1;
/** @constructor */
function $h_s_$less$colon$less$$anon$1() {
  /*<skip>*/
}
$h_s_$less$colon$less$$anon$1.prototype = $c_s_$less$colon$less$$anon$1.prototype;
$c_s_$less$colon$less$$anon$1.prototype.apply__O__O = (function(x) {
  return x
});
$c_s_$less$colon$less$$anon$1.prototype.toString__T = (function() {
  return "generalized constraint"
});
var $d_s_$less$colon$less$$anon$1 = new $TypeData().initClass({
  s_$less$colon$less$$anon$1: 0
}, false, "scala.$less$colon$less$$anon$1", {
  s_$less$colon$less$$anon$1: 1,
  s_$eq$colon$eq: 1,
  s_$less$colon$less: 1,
  O: 1,
  F1: 1,
  Ljava_io_Serializable: 1
});
$c_s_$less$colon$less$$anon$1.prototype.$classData = $d_s_$less$colon$less$$anon$1;
function $p_s_MatchError__objString$lzycompute__T($thiz) {
  if ((!$thiz.s_MatchError__f_bitmap$0)) {
    $thiz.s_MatchError__f_objString = (($thiz.s_MatchError__f_obj === null) ? "null" : $p_s_MatchError__liftedTree1$1__T($thiz));
    $thiz.s_MatchError__f_bitmap$0 = true
  };
  return $thiz.s_MatchError__f_objString
}
function $p_s_MatchError__objString__T($thiz) {
  return ((!$thiz.s_MatchError__f_bitmap$0) ? $p_s_MatchError__objString$lzycompute__T($thiz) : $thiz.s_MatchError__f_objString)
}
function $p_s_MatchError__ofClass$1__T($thiz) {
  var this$1 = $thiz.s_MatchError__f_obj;
  return ("of class " + $objectClassName(this$1))
}
function $p_s_MatchError__liftedTree1$1__T($thiz) {
  try {
    return ((($dp_toString__T($thiz.s_MatchError__f_obj) + " (") + $p_s_MatchError__ofClass$1__T($thiz)) + ")")
  } catch (e) {
    var e$2 = $m_sjsr_package$().wrapJavaScriptException__O__jl_Throwable(e);
    if ((e$2 !== null)) {
      return ("an instance " + $p_s_MatchError__ofClass$1__T($thiz))
    } else {
      throw e
    }
  }
}
/** @constructor */
function $c_s_MatchError(obj) {
  this.jl_Throwable__f_s = null;
  this.jl_Throwable__f_e = null;
  this.jl_Throwable__f_enableSuppression = false;
  this.jl_Throwable__f_writableStackTrace = false;
  this.jl_Throwable__f_stackTraceStateInternal = null;
  this.jl_Throwable__f_stackTrace = null;
  this.jl_Throwable__f_suppressed = null;
  this.s_MatchError__f_objString = null;
  this.s_MatchError__f_obj = null;
  this.s_MatchError__f_bitmap$0 = false;
  this.s_MatchError__f_obj = obj;
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true)
}
$c_s_MatchError.prototype = new $h_jl_RuntimeException();
$c_s_MatchError.prototype.constructor = $c_s_MatchError;
/** @constructor */
function $h_s_MatchError() {
  /*<skip>*/
}
$h_s_MatchError.prototype = $c_s_MatchError.prototype;
$c_s_MatchError.prototype.getMessage__T = (function() {
  return $p_s_MatchError__objString__T(this)
});
var $d_s_MatchError = new $TypeData().initClass({
  s_MatchError: 0
}, false, "scala.MatchError", {
  s_MatchError: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_s_MatchError.prototype.$classData = $d_s_MatchError;
/** @constructor */
function $c_s_Option() {
  /*<skip>*/
}
$c_s_Option.prototype = new $h_O();
$c_s_Option.prototype.constructor = $c_s_Option;
/** @constructor */
function $h_s_Option() {
  /*<skip>*/
}
$h_s_Option.prototype = $c_s_Option.prototype;
$c_s_Option.prototype.isEmpty__Z = (function() {
  return (this === $m_s_None$())
});
$c_s_Option.prototype.knownSize__I = (function() {
  return (this.isEmpty__Z() ? 0 : 1)
});
$c_s_Option.prototype.iterator__sc_Iterator = (function() {
  if (this.isEmpty__Z()) {
    return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty
  } else {
    $m_sc_Iterator$();
    var a = this.get__O();
    return new $c_sc_Iterator$$anon$20(a)
  }
});
$c_s_Option.prototype.toList__sci_List = (function() {
  if (this.isEmpty__Z()) {
    $m_s_package$();
    var elems = $m_sci_Nil$();
    return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)
  } else {
    return new $c_sci_$colon$colon(this.get__O(), $m_s_package$().s_package$__f_Nil)
  }
});
function $as_s_Option(obj) {
  return (((obj instanceof $c_s_Option) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Option"))
}
function $isArrayOf_s_Option(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_Option)))
}
function $asArrayOf_s_Option(obj, depth) {
  return (($isArrayOf_s_Option(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Option;", depth))
}
/** @constructor */
function $c_s_PartialFunction$Unlifted(f) {
  this.s_PartialFunction$Unlifted__f_f = null;
  this.s_PartialFunction$Unlifted__f_f = f
}
$c_s_PartialFunction$Unlifted.prototype = new $h_sr_AbstractPartialFunction();
$c_s_PartialFunction$Unlifted.prototype.constructor = $c_s_PartialFunction$Unlifted;
/** @constructor */
function $h_s_PartialFunction$Unlifted() {
  /*<skip>*/
}
$h_s_PartialFunction$Unlifted.prototype = $c_s_PartialFunction$Unlifted.prototype;
$c_s_PartialFunction$Unlifted.prototype.isDefinedAt__O__Z = (function(x) {
  var this$1 = $as_s_Option(this.s_PartialFunction$Unlifted__f_f.apply__O__O(x));
  return (!this$1.isEmpty__Z())
});
$c_s_PartialFunction$Unlifted.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  var this$1 = $as_s_Option(this.s_PartialFunction$Unlifted__f_f.apply__O__O(x));
  return (this$1.isEmpty__Z() ? default$1.apply__O__O(x) : this$1.get__O())
});
var $d_s_PartialFunction$Unlifted = new $TypeData().initClass({
  s_PartialFunction$Unlifted: 0
}, false, "scala.PartialFunction$Unlifted", {
  s_PartialFunction$Unlifted: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_s_PartialFunction$Unlifted.prototype.$classData = $d_s_PartialFunction$Unlifted;
/** @constructor */
function $c_T2(_1, _2) {
  this.T2__f__1 = null;
  this.T2__f__2 = null;
  this.T2__f__1 = _1;
  this.T2__f__2 = _2
}
$c_T2.prototype = new $h_O();
$c_T2.prototype.constructor = $c_T2;
/** @constructor */
function $h_T2() {
  /*<skip>*/
}
$h_T2.prototype = $c_T2.prototype;
$c_T2.prototype.productArity__I = (function() {
  return 2
});
$c_T2.prototype.productElement__I__O = (function(n) {
  return $f_s_Product2__productElement__I__O(this, n)
});
$c_T2.prototype._1__O = (function() {
  return this.T2__f__1
});
$c_T2.prototype._2__O = (function() {
  return this.T2__f__2
});
$c_T2.prototype.toString__T = (function() {
  return (((("(" + this._1__O()) + ",") + this._2__O()) + ")")
});
$c_T2.prototype.productPrefix__T = (function() {
  return "Tuple2"
});
$c_T2.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_T2.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_T2.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_T2)) {
    var Tuple2$1 = $as_T2(x$1);
    return ($m_sr_BoxesRunTime$().equals__O__O__Z(this._1__O(), Tuple2$1._1__O()) && $m_sr_BoxesRunTime$().equals__O__O__Z(this._2__O(), Tuple2$1._2__O()))
  } else {
    return false
  }
});
function $as_T2(obj) {
  return (((obj instanceof $c_T2) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Tuple2"))
}
function $isArrayOf_T2(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T2)))
}
function $asArrayOf_T2(obj, depth) {
  return (($isArrayOf_T2(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Tuple2;", depth))
}
var $d_T2 = new $TypeData().initClass({
  T2: 0
}, false, "scala.Tuple2", {
  T2: 1,
  O: 1,
  s_Product2: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_T2.prototype.$classData = $d_T2;
/** @constructor */
function $c_T3(_1, _2, _3) {
  this.T3__f__1 = null;
  this.T3__f__2 = null;
  this.T3__f__3 = null;
  this.T3__f__1 = _1;
  this.T3__f__2 = _2;
  this.T3__f__3 = _3
}
$c_T3.prototype = new $h_O();
$c_T3.prototype.constructor = $c_T3;
/** @constructor */
function $h_T3() {
  /*<skip>*/
}
$h_T3.prototype = $c_T3.prototype;
$c_T3.prototype.productArity__I = (function() {
  return 3
});
$c_T3.prototype.productElement__I__O = (function(n) {
  return $f_s_Product3__productElement__I__O(this, n)
});
$c_T3.prototype.toString__T = (function() {
  return (((((("(" + this.T3__f__1) + ",") + this.T3__f__2) + ",") + this.T3__f__3) + ")")
});
$c_T3.prototype.productPrefix__T = (function() {
  return "Tuple3"
});
$c_T3.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_T3.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_T3.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_T3)) {
    var Tuple3$1 = $as_T3(x$1);
    return (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T3__f__1, Tuple3$1.T3__f__1) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T3__f__2, Tuple3$1.T3__f__2)) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T3__f__3, Tuple3$1.T3__f__3))
  } else {
    return false
  }
});
function $as_T3(obj) {
  return (((obj instanceof $c_T3) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Tuple3"))
}
function $isArrayOf_T3(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T3)))
}
function $asArrayOf_T3(obj, depth) {
  return (($isArrayOf_T3(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Tuple3;", depth))
}
var $d_T3 = new $TypeData().initClass({
  T3: 0
}, false, "scala.Tuple3", {
  T3: 1,
  O: 1,
  s_Product3: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_T3.prototype.$classData = $d_T3;
/** @constructor */
function $c_sc_ClassTagSeqFactory$AnySeqDelegate(delegate) {
  this.sc_ClassTagIterableFactory$AnyIterableDelegate__f_delegate = null;
  $ct_sc_ClassTagIterableFactory$AnyIterableDelegate__sc_ClassTagIterableFactory__(this, delegate)
}
$c_sc_ClassTagSeqFactory$AnySeqDelegate.prototype = new $h_sc_ClassTagIterableFactory$AnyIterableDelegate();
$c_sc_ClassTagSeqFactory$AnySeqDelegate.prototype.constructor = $c_sc_ClassTagSeqFactory$AnySeqDelegate;
/** @constructor */
function $h_sc_ClassTagSeqFactory$AnySeqDelegate() {
  /*<skip>*/
}
$h_sc_ClassTagSeqFactory$AnySeqDelegate.prototype = $c_sc_ClassTagSeqFactory$AnySeqDelegate.prototype;
var $d_sc_ClassTagSeqFactory$AnySeqDelegate = new $TypeData().initClass({
  sc_ClassTagSeqFactory$AnySeqDelegate: 0
}, false, "scala.collection.ClassTagSeqFactory$AnySeqDelegate", {
  sc_ClassTagSeqFactory$AnySeqDelegate: 1,
  sc_ClassTagIterableFactory$AnyIterableDelegate: 1,
  O: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1,
  sc_SeqFactory: 1
});
$c_sc_ClassTagSeqFactory$AnySeqDelegate.prototype.$classData = $d_sc_ClassTagSeqFactory$AnySeqDelegate;
function $f_sc_IndexedSeqOps__drop__I__O($thiz, n) {
  return $thiz.fromSpecific__sc_IterableOnce__O(new $c_sc_IndexedSeqView$Drop($thiz, n))
}
function $f_sc_IndexedSeqOps__map__F1__O($thiz, f) {
  return $thiz.iterableFactory__sc_IterableFactory().from__sc_IterableOnce__O(new $c_sc_IndexedSeqView$Map($thiz, f))
}
/** @constructor */
function $c_sc_IndexedSeqOps$$anon$1(outer) {
  this.sc_IndexedSeqOps$$anon$1__f_i = 0;
  this.sc_IndexedSeqOps$$anon$1__f_$outer = null;
  if ((outer === null)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(null)
  } else {
    this.sc_IndexedSeqOps$$anon$1__f_$outer = outer
  };
  this.sc_IndexedSeqOps$$anon$1__f_i = outer.length__I()
}
$c_sc_IndexedSeqOps$$anon$1.prototype = new $h_sc_AbstractIterator();
$c_sc_IndexedSeqOps$$anon$1.prototype.constructor = $c_sc_IndexedSeqOps$$anon$1;
/** @constructor */
function $h_sc_IndexedSeqOps$$anon$1() {
  /*<skip>*/
}
$h_sc_IndexedSeqOps$$anon$1.prototype = $c_sc_IndexedSeqOps$$anon$1.prototype;
$c_sc_IndexedSeqOps$$anon$1.prototype.hasNext__Z = (function() {
  return (this.sc_IndexedSeqOps$$anon$1__f_i > 0)
});
$c_sc_IndexedSeqOps$$anon$1.prototype.next__O = (function() {
  if ((this.sc_IndexedSeqOps$$anon$1__f_i > 0)) {
    this.sc_IndexedSeqOps$$anon$1__f_i = (((-1) + this.sc_IndexedSeqOps$$anon$1__f_i) | 0);
    return this.sc_IndexedSeqOps$$anon$1__f_$outer.apply__I__O(this.sc_IndexedSeqOps$$anon$1__f_i)
  } else {
    return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O()
  }
});
var $d_sc_IndexedSeqOps$$anon$1 = new $TypeData().initClass({
  sc_IndexedSeqOps$$anon$1: 0
}, false, "scala.collection.IndexedSeqOps$$anon$1", {
  sc_IndexedSeqOps$$anon$1: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sc_IndexedSeqOps$$anon$1.prototype.$classData = $d_sc_IndexedSeqOps$$anon$1;
function $f_sc_Iterable__toString__T($thiz) {
  var start = ($thiz.className__T() + "(");
  return $f_sc_IterableOnceOps__mkString__T__T__T__T($thiz, start, ", ", ")")
}
function $is_sc_Iterable(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_Iterable)))
}
function $as_sc_Iterable(obj) {
  return (($is_sc_Iterable(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.Iterable"))
}
function $isArrayOf_sc_Iterable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_Iterable)))
}
function $asArrayOf_sc_Iterable(obj, depth) {
  return (($isArrayOf_sc_Iterable(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.Iterable;", depth))
}
function $p_sc_Iterator$$anon$10__nextCur__V($thiz) {
  $thiz.sc_Iterator$$anon$10__f_cur = null;
  $thiz.sc_Iterator$$anon$10__f_cur = $as_sc_IterableOnce($thiz.sc_Iterator$$anon$10__f_f$3.apply__O__O($thiz.sc_Iterator$$anon$10__f_$outer.next__O())).iterator__sc_Iterator();
  $thiz.sc_Iterator$$anon$10__f__hasNext = (-1)
}
/** @constructor */
function $c_sc_Iterator$$anon$10(outer, f$3) {
  this.sc_Iterator$$anon$10__f_cur = null;
  this.sc_Iterator$$anon$10__f__hasNext = 0;
  this.sc_Iterator$$anon$10__f_$outer = null;
  this.sc_Iterator$$anon$10__f_f$3 = null;
  if ((outer === null)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(null)
  } else {
    this.sc_Iterator$$anon$10__f_$outer = outer
  };
  this.sc_Iterator$$anon$10__f_f$3 = f$3;
  this.sc_Iterator$$anon$10__f_cur = $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
  this.sc_Iterator$$anon$10__f__hasNext = (-1)
}
$c_sc_Iterator$$anon$10.prototype = new $h_sc_AbstractIterator();
$c_sc_Iterator$$anon$10.prototype.constructor = $c_sc_Iterator$$anon$10;
/** @constructor */
function $h_sc_Iterator$$anon$10() {
  /*<skip>*/
}
$h_sc_Iterator$$anon$10.prototype = $c_sc_Iterator$$anon$10.prototype;
$c_sc_Iterator$$anon$10.prototype.hasNext__Z = (function() {
  if ((this.sc_Iterator$$anon$10__f__hasNext === (-1))) {
    while ((!this.sc_Iterator$$anon$10__f_cur.hasNext__Z())) {
      if ((!this.sc_Iterator$$anon$10__f_$outer.hasNext__Z())) {
        this.sc_Iterator$$anon$10__f__hasNext = 0;
        this.sc_Iterator$$anon$10__f_cur = $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
        return false
      };
      $p_sc_Iterator$$anon$10__nextCur__V(this)
    };
    this.sc_Iterator$$anon$10__f__hasNext = 1;
    return true
  } else {
    return (this.sc_Iterator$$anon$10__f__hasNext === 1)
  }
});
$c_sc_Iterator$$anon$10.prototype.next__O = (function() {
  if (this.hasNext__Z()) {
    this.sc_Iterator$$anon$10__f__hasNext = (-1)
  };
  return this.sc_Iterator$$anon$10__f_cur.next__O()
});
var $d_sc_Iterator$$anon$10 = new $TypeData().initClass({
  sc_Iterator$$anon$10: 0
}, false, "scala.collection.Iterator$$anon$10", {
  sc_Iterator$$anon$10: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sc_Iterator$$anon$10.prototype.$classData = $d_sc_Iterator$$anon$10;
/** @constructor */
function $c_sc_Iterator$$anon$16(outer) {
  this.sc_Iterator$$anon$16__f_idx = 0;
  this.sc_Iterator$$anon$16__f_$outer = null;
  if ((outer === null)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(null)
  } else {
    this.sc_Iterator$$anon$16__f_$outer = outer
  };
  this.sc_Iterator$$anon$16__f_idx = 0
}
$c_sc_Iterator$$anon$16.prototype = new $h_sc_AbstractIterator();
$c_sc_Iterator$$anon$16.prototype.constructor = $c_sc_Iterator$$anon$16;
/** @constructor */
function $h_sc_Iterator$$anon$16() {
  /*<skip>*/
}
$h_sc_Iterator$$anon$16.prototype = $c_sc_Iterator$$anon$16.prototype;
$c_sc_Iterator$$anon$16.prototype.knownSize__I = (function() {
  return this.sc_Iterator$$anon$16__f_$outer.knownSize__I()
});
$c_sc_Iterator$$anon$16.prototype.hasNext__Z = (function() {
  return this.sc_Iterator$$anon$16__f_$outer.hasNext__Z()
});
$c_sc_Iterator$$anon$16.prototype.next__T2 = (function() {
  var ret = new $c_T2(this.sc_Iterator$$anon$16__f_$outer.next__O(), this.sc_Iterator$$anon$16__f_idx);
  this.sc_Iterator$$anon$16__f_idx = ((1 + this.sc_Iterator$$anon$16__f_idx) | 0);
  return ret
});
$c_sc_Iterator$$anon$16.prototype.next__O = (function() {
  return this.next__T2()
});
var $d_sc_Iterator$$anon$16 = new $TypeData().initClass({
  sc_Iterator$$anon$16: 0
}, false, "scala.collection.Iterator$$anon$16", {
  sc_Iterator$$anon$16: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sc_Iterator$$anon$16.prototype.$classData = $d_sc_Iterator$$anon$16;
/** @constructor */
function $c_sc_Iterator$$anon$19() {
  /*<skip>*/
}
$c_sc_Iterator$$anon$19.prototype = new $h_sc_AbstractIterator();
$c_sc_Iterator$$anon$19.prototype.constructor = $c_sc_Iterator$$anon$19;
/** @constructor */
function $h_sc_Iterator$$anon$19() {
  /*<skip>*/
}
$h_sc_Iterator$$anon$19.prototype = $c_sc_Iterator$$anon$19.prototype;
$c_sc_Iterator$$anon$19.prototype.hasNext__Z = (function() {
  return false
});
$c_sc_Iterator$$anon$19.prototype.next__E = (function() {
  throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "next on empty iterator")
});
$c_sc_Iterator$$anon$19.prototype.knownSize__I = (function() {
  return 0
});
$c_sc_Iterator$$anon$19.prototype.next__O = (function() {
  this.next__E()
});
var $d_sc_Iterator$$anon$19 = new $TypeData().initClass({
  sc_Iterator$$anon$19: 0
}, false, "scala.collection.Iterator$$anon$19", {
  sc_Iterator$$anon$19: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sc_Iterator$$anon$19.prototype.$classData = $d_sc_Iterator$$anon$19;
/** @constructor */
function $c_sc_Iterator$$anon$20(a$1) {
  this.sc_Iterator$$anon$20__f_consumed = false;
  this.sc_Iterator$$anon$20__f_a$1 = null;
  this.sc_Iterator$$anon$20__f_a$1 = a$1;
  this.sc_Iterator$$anon$20__f_consumed = false
}
$c_sc_Iterator$$anon$20.prototype = new $h_sc_AbstractIterator();
$c_sc_Iterator$$anon$20.prototype.constructor = $c_sc_Iterator$$anon$20;
/** @constructor */
function $h_sc_Iterator$$anon$20() {
  /*<skip>*/
}
$h_sc_Iterator$$anon$20.prototype = $c_sc_Iterator$$anon$20.prototype;
$c_sc_Iterator$$anon$20.prototype.hasNext__Z = (function() {
  return (!this.sc_Iterator$$anon$20__f_consumed)
});
$c_sc_Iterator$$anon$20.prototype.next__O = (function() {
  if (this.sc_Iterator$$anon$20__f_consumed) {
    return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O()
  } else {
    this.sc_Iterator$$anon$20__f_consumed = true;
    return this.sc_Iterator$$anon$20__f_a$1
  }
});
var $d_sc_Iterator$$anon$20 = new $TypeData().initClass({
  sc_Iterator$$anon$20: 0
}, false, "scala.collection.Iterator$$anon$20", {
  sc_Iterator$$anon$20: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sc_Iterator$$anon$20.prototype.$classData = $d_sc_Iterator$$anon$20;
/** @constructor */
function $c_sc_Iterator$$anon$9(outer, f$2) {
  this.sc_Iterator$$anon$9__f_$outer = null;
  this.sc_Iterator$$anon$9__f_f$2 = null;
  if ((outer === null)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(null)
  } else {
    this.sc_Iterator$$anon$9__f_$outer = outer
  };
  this.sc_Iterator$$anon$9__f_f$2 = f$2
}
$c_sc_Iterator$$anon$9.prototype = new $h_sc_AbstractIterator();
$c_sc_Iterator$$anon$9.prototype.constructor = $c_sc_Iterator$$anon$9;
/** @constructor */
function $h_sc_Iterator$$anon$9() {
  /*<skip>*/
}
$h_sc_Iterator$$anon$9.prototype = $c_sc_Iterator$$anon$9.prototype;
$c_sc_Iterator$$anon$9.prototype.knownSize__I = (function() {
  return this.sc_Iterator$$anon$9__f_$outer.knownSize__I()
});
$c_sc_Iterator$$anon$9.prototype.hasNext__Z = (function() {
  return this.sc_Iterator$$anon$9__f_$outer.hasNext__Z()
});
$c_sc_Iterator$$anon$9.prototype.next__O = (function() {
  return this.sc_Iterator$$anon$9__f_f$2.apply__O__O(this.sc_Iterator$$anon$9__f_$outer.next__O())
});
var $d_sc_Iterator$$anon$9 = new $TypeData().initClass({
  sc_Iterator$$anon$9: 0
}, false, "scala.collection.Iterator$$anon$9", {
  sc_Iterator$$anon$9: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sc_Iterator$$anon$9.prototype.$classData = $d_sc_Iterator$$anon$9;
function $p_sc_Iterator$ConcatIterator__merge$1__V($thiz) {
  while (($thiz.sc_Iterator$ConcatIterator__f_current instanceof $c_sc_Iterator$ConcatIterator)) {
    var c = $as_sc_Iterator$ConcatIterator($thiz.sc_Iterator$ConcatIterator__f_current);
    $thiz.sc_Iterator$ConcatIterator__f_current = c.sc_Iterator$ConcatIterator__f_current;
    $thiz.sc_Iterator$ConcatIterator__f_currentHasNextChecked = c.sc_Iterator$ConcatIterator__f_currentHasNextChecked;
    if ((c.sc_Iterator$ConcatIterator__f_tail !== null)) {
      if (($thiz.sc_Iterator$ConcatIterator__f_last === null)) {
        $thiz.sc_Iterator$ConcatIterator__f_last = c.sc_Iterator$ConcatIterator__f_last
      };
      c.sc_Iterator$ConcatIterator__f_last.sc_Iterator$ConcatIteratorCell__f_tail = $thiz.sc_Iterator$ConcatIterator__f_tail;
      $thiz.sc_Iterator$ConcatIterator__f_tail = c.sc_Iterator$ConcatIterator__f_tail
    }
  }
}
function $p_sc_Iterator$ConcatIterator__advance$1__Z($thiz) {
  while (true) {
    if (($thiz.sc_Iterator$ConcatIterator__f_tail === null)) {
      $thiz.sc_Iterator$ConcatIterator__f_current = null;
      $thiz.sc_Iterator$ConcatIterator__f_last = null;
      return false
    } else {
      $thiz.sc_Iterator$ConcatIterator__f_current = $thiz.sc_Iterator$ConcatIterator__f_tail.headIterator__sc_Iterator();
      if (($thiz.sc_Iterator$ConcatIterator__f_last === $thiz.sc_Iterator$ConcatIterator__f_tail)) {
        $thiz.sc_Iterator$ConcatIterator__f_last = $thiz.sc_Iterator$ConcatIterator__f_last.sc_Iterator$ConcatIteratorCell__f_tail
      };
      $thiz.sc_Iterator$ConcatIterator__f_tail = $thiz.sc_Iterator$ConcatIterator__f_tail.sc_Iterator$ConcatIteratorCell__f_tail;
      $p_sc_Iterator$ConcatIterator__merge$1__V($thiz);
      if ($thiz.sc_Iterator$ConcatIterator__f_currentHasNextChecked) {
        return true
      } else if ((($thiz.sc_Iterator$ConcatIterator__f_current !== null) && $thiz.sc_Iterator$ConcatIterator__f_current.hasNext__Z())) {
        $thiz.sc_Iterator$ConcatIterator__f_currentHasNextChecked = true;
        return true
      }
    }
  }
}
/** @constructor */
function $c_sc_Iterator$ConcatIterator(current) {
  this.sc_Iterator$ConcatIterator__f_current = null;
  this.sc_Iterator$ConcatIterator__f_tail = null;
  this.sc_Iterator$ConcatIterator__f_last = null;
  this.sc_Iterator$ConcatIterator__f_currentHasNextChecked = false;
  this.sc_Iterator$ConcatIterator__f_current = current;
  this.sc_Iterator$ConcatIterator__f_tail = null;
  this.sc_Iterator$ConcatIterator__f_last = null;
  this.sc_Iterator$ConcatIterator__f_currentHasNextChecked = false
}
$c_sc_Iterator$ConcatIterator.prototype = new $h_sc_AbstractIterator();
$c_sc_Iterator$ConcatIterator.prototype.constructor = $c_sc_Iterator$ConcatIterator;
/** @constructor */
function $h_sc_Iterator$ConcatIterator() {
  /*<skip>*/
}
$h_sc_Iterator$ConcatIterator.prototype = $c_sc_Iterator$ConcatIterator.prototype;
$c_sc_Iterator$ConcatIterator.prototype.hasNext__Z = (function() {
  if (this.sc_Iterator$ConcatIterator__f_currentHasNextChecked) {
    return true
  } else if ((this.sc_Iterator$ConcatIterator__f_current !== null)) {
    if (this.sc_Iterator$ConcatIterator__f_current.hasNext__Z()) {
      this.sc_Iterator$ConcatIterator__f_currentHasNextChecked = true;
      return true
    } else {
      return $p_sc_Iterator$ConcatIterator__advance$1__Z(this)
    }
  } else {
    return false
  }
});
$c_sc_Iterator$ConcatIterator.prototype.next__O = (function() {
  if (this.hasNext__Z()) {
    this.sc_Iterator$ConcatIterator__f_currentHasNextChecked = false;
    return this.sc_Iterator$ConcatIterator__f_current.next__O()
  } else {
    return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O()
  }
});
$c_sc_Iterator$ConcatIterator.prototype.concat__F0__sc_Iterator = (function(that) {
  var c = new $c_sc_Iterator$ConcatIteratorCell(that, null);
  if ((this.sc_Iterator$ConcatIterator__f_tail === null)) {
    this.sc_Iterator$ConcatIterator__f_tail = c;
    this.sc_Iterator$ConcatIterator__f_last = c
  } else {
    this.sc_Iterator$ConcatIterator__f_last.sc_Iterator$ConcatIteratorCell__f_tail = c;
    this.sc_Iterator$ConcatIterator__f_last = c
  };
  if ((this.sc_Iterator$ConcatIterator__f_current === null)) {
    this.sc_Iterator$ConcatIterator__f_current = $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty
  };
  return this
});
function $as_sc_Iterator$ConcatIterator(obj) {
  return (((obj instanceof $c_sc_Iterator$ConcatIterator) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.Iterator$ConcatIterator"))
}
function $isArrayOf_sc_Iterator$ConcatIterator(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_Iterator$ConcatIterator)))
}
function $asArrayOf_sc_Iterator$ConcatIterator(obj, depth) {
  return (($isArrayOf_sc_Iterator$ConcatIterator(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.Iterator$ConcatIterator;", depth))
}
var $d_sc_Iterator$ConcatIterator = new $TypeData().initClass({
  sc_Iterator$ConcatIterator: 0
}, false, "scala.collection.Iterator$ConcatIterator", {
  sc_Iterator$ConcatIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sc_Iterator$ConcatIterator.prototype.$classData = $d_sc_Iterator$ConcatIterator;
/** @constructor */
function $c_sc_LinearSeqIterator(coll) {
  this.sc_LinearSeqIterator__f_coll = null;
  this.sc_LinearSeqIterator__f_these = null;
  this.sc_LinearSeqIterator__f_coll = coll;
  this.sc_LinearSeqIterator__f_these = new $c_sc_LinearSeqIterator$LazyCell(this, new $c_sjsr_AnonFunction0((function(this$1) {
    return (function() {
      return this$1.sc_LinearSeqIterator__f_coll
    })
  })(this)))
}
$c_sc_LinearSeqIterator.prototype = new $h_sc_AbstractIterator();
$c_sc_LinearSeqIterator.prototype.constructor = $c_sc_LinearSeqIterator;
/** @constructor */
function $h_sc_LinearSeqIterator() {
  /*<skip>*/
}
$h_sc_LinearSeqIterator.prototype = $c_sc_LinearSeqIterator.prototype;
$c_sc_LinearSeqIterator.prototype.hasNext__Z = (function() {
  var this$1 = this.sc_LinearSeqIterator__f_these.v__sc_LinearSeqOps();
  return (!this$1.isEmpty__Z())
});
$c_sc_LinearSeqIterator.prototype.next__O = (function() {
  if ((!this.hasNext__Z())) {
    return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O()
  } else {
    var cur = this.sc_LinearSeqIterator__f_these.v__sc_LinearSeqOps();
    var result = cur.head__O();
    this.sc_LinearSeqIterator__f_these = new $c_sc_LinearSeqIterator$LazyCell(this, new $c_sjsr_AnonFunction0((function(this$1, cur$1) {
      return (function() {
        return $as_sc_LinearSeq(cur$1.tail__O())
      })
    })(this, cur)));
    return result
  }
});
var $d_sc_LinearSeqIterator = new $TypeData().initClass({
  sc_LinearSeqIterator: 0
}, false, "scala.collection.LinearSeqIterator", {
  sc_LinearSeqIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sc_LinearSeqIterator.prototype.$classData = $d_sc_LinearSeqIterator;
function $f_sc_LinearSeqOps__iterator__sc_Iterator($thiz) {
  return (($thiz.knownSize__I() === 0) ? $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty : new $c_sc_LinearSeqIterator($thiz))
}
function $f_sc_LinearSeqOps__length__I($thiz) {
  var these = $as_sc_LinearSeq($thiz);
  var len = 0;
  while (true) {
    var this$1 = these;
    if ((!this$1.isEmpty__Z())) {
      len = ((1 + len) | 0);
      these = $as_sc_LinearSeq(these.tail__O())
    } else {
      break
    }
  };
  return len
}
function $f_sc_LinearSeqOps__lengthCompare__I__I($thiz, len) {
  return ((len < 0) ? 1 : $p_sc_LinearSeqOps__loop$1__I__sc_LinearSeq__I__I($thiz, 0, $as_sc_LinearSeq($thiz), len))
}
function $f_sc_LinearSeqOps__isDefinedAt__I__Z($thiz, x) {
  return ((x >= 0) && ($thiz.lengthCompare__I__I(x) > 0))
}
function $f_sc_LinearSeqOps__apply__I__O($thiz, n) {
  if ((n < 0)) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
  };
  var skipped = $as_sc_LinearSeq($thiz.drop__I__O(n));
  if (skipped.isEmpty__Z()) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
  };
  return skipped.head__O()
}
function $f_sc_LinearSeqOps__forall__F1__Z($thiz, p) {
  var these = $as_sc_LinearSeq($thiz);
  while ((!these.isEmpty__Z())) {
    if ((!$uZ(p.apply__O__O(these.head__O())))) {
      return false
    };
    these = $as_sc_LinearSeq(these.tail__O())
  };
  return true
}
function $f_sc_LinearSeqOps__exists__F1__Z($thiz, p) {
  var these = $as_sc_LinearSeq($thiz);
  while ((!these.isEmpty__Z())) {
    if ($uZ(p.apply__O__O(these.head__O()))) {
      return true
    };
    these = $as_sc_LinearSeq(these.tail__O())
  };
  return false
}
function $f_sc_LinearSeqOps__foldLeft__O__F2__O($thiz, z, op) {
  var acc = z;
  var these = $as_sc_LinearSeq($thiz);
  while ((!these.isEmpty__Z())) {
    acc = op.apply__O__O__O(acc, these.head__O());
    these = $as_sc_LinearSeq(these.tail__O())
  };
  return acc
}
function $f_sc_LinearSeqOps__sameElements__sc_IterableOnce__Z($thiz, that) {
  if ($is_sc_LinearSeq(that)) {
    var x2 = $as_sc_LinearSeq(that);
    return $p_sc_LinearSeqOps__linearSeqEq$1__sc_LinearSeq__sc_LinearSeq__Z($thiz, $as_sc_LinearSeq($thiz), x2)
  } else {
    return $f_sc_SeqOps__sameElements__sc_IterableOnce__Z($thiz, that)
  }
}
function $f_sc_LinearSeqOps__indexWhere__F1__I__I($thiz, p, from) {
  var i = ((from > 0) ? from : 0);
  var these = $as_sc_LinearSeq($thiz.drop__I__O(from));
  while (true) {
    var this$3 = these;
    if ((!this$3.isEmpty__Z())) {
      if ($uZ(p.apply__O__O(these.head__O()))) {
        return i
      };
      i = ((1 + i) | 0);
      these = $as_sc_LinearSeq(these.tail__O())
    } else {
      break
    }
  };
  return (-1)
}
function $p_sc_LinearSeqOps__loop$1__I__sc_LinearSeq__I__I($thiz, i, xs, len$1) {
  while (true) {
    if ((i === len$1)) {
      return (xs.isEmpty__Z() ? 0 : 1)
    } else if (xs.isEmpty__Z()) {
      return (-1)
    } else {
      var temp$i = ((1 + i) | 0);
      var temp$xs = $as_sc_LinearSeq(xs.tail__O());
      i = temp$i;
      xs = temp$xs
    }
  }
}
function $p_sc_LinearSeqOps__linearSeqEq$1__sc_LinearSeq__sc_LinearSeq__Z($thiz, a, b) {
  while (true) {
    if ((a === b)) {
      return true
    } else {
      var this$1 = a;
      if ((!this$1.isEmpty__Z())) {
        var this$2 = b;
        var $$x1 = (!this$2.isEmpty__Z())
      } else {
        var $$x1 = false
      };
      if (($$x1 && $m_sr_BoxesRunTime$().equals__O__O__Z(a.head__O(), b.head__O()))) {
        var temp$a = $as_sc_LinearSeq(a.tail__O());
        var temp$b = $as_sc_LinearSeq(b.tail__O());
        a = temp$a;
        b = temp$b
      } else {
        return (a.isEmpty__Z() && b.isEmpty__Z())
      }
    }
  }
}
function $is_sc_LinearSeqOps(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_LinearSeqOps)))
}
function $as_sc_LinearSeqOps(obj) {
  return (($is_sc_LinearSeqOps(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.LinearSeqOps"))
}
function $isArrayOf_sc_LinearSeqOps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_LinearSeqOps)))
}
function $asArrayOf_sc_LinearSeqOps(obj, depth) {
  return (($isArrayOf_sc_LinearSeqOps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.LinearSeqOps;", depth))
}
/** @constructor */
function $c_sc_Seq$() {
  this.sc_SeqFactory$Delegate__f_delegate = null;
  $ct_sc_SeqFactory$Delegate__sc_SeqFactory__(this, $m_sci_Seq$())
}
$c_sc_Seq$.prototype = new $h_sc_SeqFactory$Delegate();
$c_sc_Seq$.prototype.constructor = $c_sc_Seq$;
/** @constructor */
function $h_sc_Seq$() {
  /*<skip>*/
}
$h_sc_Seq$.prototype = $c_sc_Seq$.prototype;
var $d_sc_Seq$ = new $TypeData().initClass({
  sc_Seq$: 0
}, false, "scala.collection.Seq$", {
  sc_Seq$: 1,
  sc_SeqFactory$Delegate: 1,
  O: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sc_Seq$.prototype.$classData = $d_sc_Seq$;
var $n_sc_Seq$;
function $m_sc_Seq$() {
  if ((!$n_sc_Seq$)) {
    $n_sc_Seq$ = new $c_sc_Seq$()
  };
  return $n_sc_Seq$
}
/** @constructor */
function $c_sc_StrictOptimizedLinearSeqOps$$anon$1(outer) {
  this.sc_StrictOptimizedLinearSeqOps$$anon$1__f_current = null;
  this.sc_StrictOptimizedLinearSeqOps$$anon$1__f_current = outer
}
$c_sc_StrictOptimizedLinearSeqOps$$anon$1.prototype = new $h_sc_AbstractIterator();
$c_sc_StrictOptimizedLinearSeqOps$$anon$1.prototype.constructor = $c_sc_StrictOptimizedLinearSeqOps$$anon$1;
/** @constructor */
function $h_sc_StrictOptimizedLinearSeqOps$$anon$1() {
  /*<skip>*/
}
$h_sc_StrictOptimizedLinearSeqOps$$anon$1.prototype = $c_sc_StrictOptimizedLinearSeqOps$$anon$1.prototype;
$c_sc_StrictOptimizedLinearSeqOps$$anon$1.prototype.hasNext__Z = (function() {
  return (!this.sc_StrictOptimizedLinearSeqOps$$anon$1__f_current.isEmpty__Z())
});
$c_sc_StrictOptimizedLinearSeqOps$$anon$1.prototype.next__O = (function() {
  var r = this.sc_StrictOptimizedLinearSeqOps$$anon$1__f_current.head__O();
  this.sc_StrictOptimizedLinearSeqOps$$anon$1__f_current = $as_sc_Iterable(this.sc_StrictOptimizedLinearSeqOps$$anon$1__f_current.tail__O());
  return r
});
var $d_sc_StrictOptimizedLinearSeqOps$$anon$1 = new $TypeData().initClass({
  sc_StrictOptimizedLinearSeqOps$$anon$1: 0
}, false, "scala.collection.StrictOptimizedLinearSeqOps$$anon$1", {
  sc_StrictOptimizedLinearSeqOps$$anon$1: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sc_StrictOptimizedLinearSeqOps$$anon$1.prototype.$classData = $d_sc_StrictOptimizedLinearSeqOps$$anon$1;
function $p_sc_StringOps$$anon$1__advance__T($thiz) {
  var start = $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index;
  while (true) {
    if (($thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index < $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$len)) {
      var this$ = $thiz.sc_StringOps$$anon$1__f_$this$2;
      var i = $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index;
      var c = (65535 & $uI(this$.charCodeAt(i)));
      var $$x1 = (!((c === 13) || (c === 10)))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index = ((1 + $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index) | 0)
    } else {
      break
    }
  };
  var end = $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index;
  if (($thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index < $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$len)) {
    var this$$2 = $thiz.sc_StringOps$$anon$1__f_$this$2;
    var i$1 = $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index;
    var c$1 = (65535 & $uI(this$$2.charCodeAt(i$1)));
    $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index = ((1 + $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index) | 0);
    if (($thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index < $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$len)) {
      var this$$3 = $thiz.sc_StringOps$$anon$1__f_$this$2;
      var i$2 = $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index;
      var c$2 = (65535 & $uI(this$$3.charCodeAt(i$2)));
      var $$x2 = ((c$1 === 13) && (c$2 === 10))
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index = ((1 + $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index) | 0)
    };
    if ((!$thiz.sc_StringOps$$anon$1__f_stripped$1)) {
      end = $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index
    }
  };
  var this$6 = $thiz.sc_StringOps$$anon$1__f_$this$2;
  var endIndex = end;
  return $as_T(this$6.substring(start, endIndex))
}
/** @constructor */
function $c_sc_StringOps$$anon$1(\u03b4this$2, stripped$1) {
  this.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$len = 0;
  this.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index = 0;
  this.sc_StringOps$$anon$1__f_$this$2 = null;
  this.sc_StringOps$$anon$1__f_stripped$1 = false;
  this.sc_StringOps$$anon$1__f_$this$2 = \u03b4this$2;
  this.sc_StringOps$$anon$1__f_stripped$1 = stripped$1;
  this.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$len = $uI(\u03b4this$2.length);
  this.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index = 0
}
$c_sc_StringOps$$anon$1.prototype = new $h_sc_AbstractIterator();
$c_sc_StringOps$$anon$1.prototype.constructor = $c_sc_StringOps$$anon$1;
/** @constructor */
function $h_sc_StringOps$$anon$1() {
  /*<skip>*/
}
$h_sc_StringOps$$anon$1.prototype = $c_sc_StringOps$$anon$1.prototype;
$c_sc_StringOps$$anon$1.prototype.hasNext__Z = (function() {
  return (this.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index < this.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$len)
});
$c_sc_StringOps$$anon$1.prototype.next__T = (function() {
  return ((this.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index >= this.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$len) ? $as_T($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O()) : $p_sc_StringOps$$anon$1__advance__T(this))
});
$c_sc_StringOps$$anon$1.prototype.next__O = (function() {
  return this.next__T()
});
var $d_sc_StringOps$$anon$1 = new $TypeData().initClass({
  sc_StringOps$$anon$1: 0
}, false, "scala.collection.StringOps$$anon$1", {
  sc_StringOps$$anon$1: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sc_StringOps$$anon$1.prototype.$classData = $d_sc_StringOps$$anon$1;
/** @constructor */
function $c_sc_convert_JavaCollectionWrappers$JMapWrapperLike$$anon$5(outer) {
  this.sc_convert_JavaCollectionWrappers$JMapWrapperLike$$anon$5__f_ui = null;
  var this$1 = outer.sc_convert_JavaCollectionWrappers$JMapWrapper__f_underlying;
  this.sc_convert_JavaCollectionWrappers$JMapWrapperLike$$anon$5__f_ui = new $c_ju_HashMap$EntrySet(this$1).iterator__ju_Iterator()
}
$c_sc_convert_JavaCollectionWrappers$JMapWrapperLike$$anon$5.prototype = new $h_sc_AbstractIterator();
$c_sc_convert_JavaCollectionWrappers$JMapWrapperLike$$anon$5.prototype.constructor = $c_sc_convert_JavaCollectionWrappers$JMapWrapperLike$$anon$5;
/** @constructor */
function $h_sc_convert_JavaCollectionWrappers$JMapWrapperLike$$anon$5() {
  /*<skip>*/
}
$h_sc_convert_JavaCollectionWrappers$JMapWrapperLike$$anon$5.prototype = $c_sc_convert_JavaCollectionWrappers$JMapWrapperLike$$anon$5.prototype;
$c_sc_convert_JavaCollectionWrappers$JMapWrapperLike$$anon$5.prototype.hasNext__Z = (function() {
  return this.sc_convert_JavaCollectionWrappers$JMapWrapperLike$$anon$5__f_ui.hasNext__Z()
});
$c_sc_convert_JavaCollectionWrappers$JMapWrapperLike$$anon$5.prototype.next__T2 = (function() {
  var e = $as_ju_Map$Entry(this.sc_convert_JavaCollectionWrappers$JMapWrapperLike$$anon$5__f_ui.next__O());
  return new $c_T2(e.ju_HashMap$Node__f_key, e.ju_HashMap$Node__f_value)
});
$c_sc_convert_JavaCollectionWrappers$JMapWrapperLike$$anon$5.prototype.next__O = (function() {
  return this.next__T2()
});
var $d_sc_convert_JavaCollectionWrappers$JMapWrapperLike$$anon$5 = new $TypeData().initClass({
  sc_convert_JavaCollectionWrappers$JMapWrapperLike$$anon$5: 0
}, false, "scala.collection.convert.JavaCollectionWrappers$JMapWrapperLike$$anon$5", {
  sc_convert_JavaCollectionWrappers$JMapWrapperLike$$anon$5: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sc_convert_JavaCollectionWrappers$JMapWrapperLike$$anon$5.prototype.$classData = $d_sc_convert_JavaCollectionWrappers$JMapWrapperLike$$anon$5;
function $p_sci_HashMapBuilder__isAliased__Z($thiz) {
  return ($thiz.sci_HashMapBuilder__f_aliased !== null)
}
function $p_sci_HashMapBuilder__insertElement__AI__I__I__AI($thiz, as, ix, elem) {
  if ((ix < 0)) {
    throw $ct_jl_ArrayIndexOutOfBoundsException__(new $c_jl_ArrayIndexOutOfBoundsException())
  };
  if ((ix > as.u.length)) {
    throw $ct_jl_ArrayIndexOutOfBoundsException__(new $c_jl_ArrayIndexOutOfBoundsException())
  };
  var result = new $ac_I(((1 + as.u.length) | 0));
  $systemArraycopy(as, 0, result, 0, ix);
  result.set(ix, elem);
  var destPos = ((1 + ix) | 0);
  var length = ((as.u.length - ix) | 0);
  $systemArraycopy(as, ix, result, destPos, length);
  return result
}
function $p_sci_HashMapBuilder__insertValue__sci_BitmapIndexedMapNode__I__O__I__I__O__V($thiz, bm, bitpos, key, originalHash, keyHash, value) {
  var dataIx = bm.dataIndex__I__I(bitpos);
  var idx = (dataIx << 1);
  var src = bm.sci_BitmapIndexedMapNode__f_content;
  var dst = new $ac_O(((2 + src.u.length) | 0));
  $systemArraycopy(src, 0, dst, 0, idx);
  dst.set(idx, key);
  dst.set(((1 + idx) | 0), value);
  var destPos = ((2 + idx) | 0);
  var length = ((src.u.length - idx) | 0);
  $systemArraycopy(src, idx, dst, destPos, length);
  var dstHashes = $p_sci_HashMapBuilder__insertElement__AI__I__I__AI($thiz, bm.sci_BitmapIndexedMapNode__f_originalHashes, dataIx, originalHash);
  bm.sci_BitmapIndexedMapNode__f_dataMap = (bm.sci_BitmapIndexedMapNode__f_dataMap | bitpos);
  bm.sci_BitmapIndexedMapNode__f_content = dst;
  bm.sci_BitmapIndexedMapNode__f_originalHashes = dstHashes;
  bm.sci_BitmapIndexedMapNode__f_size = ((1 + bm.sci_BitmapIndexedMapNode__f_size) | 0);
  bm.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode = ((bm.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode + keyHash) | 0)
}
function $p_sci_HashMapBuilder__ensureUnaliased__V($thiz) {
  if ($p_sci_HashMapBuilder__isAliased__Z($thiz)) {
    $p_sci_HashMapBuilder__copyElems__V($thiz)
  };
  $thiz.sci_HashMapBuilder__f_aliased = null
}
function $p_sci_HashMapBuilder__copyElems__V($thiz) {
  $thiz.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode = $thiz.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode.copy__sci_BitmapIndexedMapNode()
}
/** @constructor */
function $c_sci_HashMapBuilder() {
  this.sci_HashMapBuilder__f_aliased = null;
  this.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode = null;
  this.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode = new $c_sci_BitmapIndexedMapNode(0, 0, $m_s_Array$EmptyArrays$().s_Array$EmptyArrays$__f_emptyObjectArray, $m_s_Array$EmptyArrays$().s_Array$EmptyArrays$__f_emptyIntArray, 0, 0)
}
$c_sci_HashMapBuilder.prototype = new $h_O();
$c_sci_HashMapBuilder.prototype.constructor = $c_sci_HashMapBuilder;
/** @constructor */
function $h_sci_HashMapBuilder() {
  /*<skip>*/
}
$h_sci_HashMapBuilder.prototype = $c_sci_HashMapBuilder.prototype;
$c_sci_HashMapBuilder.prototype.sizeHint__I__V = (function(size) {
  /*<skip>*/
});
$c_sci_HashMapBuilder.prototype.update__sci_MapNode__O__O__I__I__I__V = (function(mapNode, key, value, originalHash, keyHash, shift) {
  if ((mapNode instanceof $c_sci_BitmapIndexedMapNode)) {
    var x2 = $as_sci_BitmapIndexedMapNode(mapNode);
    var mask = $m_sci_Node$().maskFrom__I__I__I(keyHash, shift);
    var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
    if (((x2.sci_BitmapIndexedMapNode__f_dataMap & bitpos) !== 0)) {
      var index = $m_sci_Node$().indexFrom__I__I__I__I(x2.sci_BitmapIndexedMapNode__f_dataMap, mask, bitpos);
      var key0 = x2.getKey__I__O(index);
      var key0UnimprovedHash = x2.getHash__I__I(index);
      if (((key0UnimprovedHash === originalHash) && $m_sr_BoxesRunTime$().equals__O__O__Z(key0, key))) {
        x2.sci_BitmapIndexedMapNode__f_content.set(((1 + (index << 1)) | 0), value)
      } else {
        var value0 = x2.getValue__I__O(index);
        var key0Hash = $m_sc_Hashing$().improve__I__I(key0UnimprovedHash);
        var subNodeNew = x2.mergeTwoKeyValPairs__O__O__I__I__O__O__I__I__I__sci_MapNode(key0, value0, key0UnimprovedHash, key0Hash, key, value, originalHash, keyHash, ((5 + shift) | 0));
        x2.migrateFromInlineToNodeInPlace__I__I__sci_MapNode__sci_BitmapIndexedMapNode(bitpos, key0Hash, subNodeNew)
      }
    } else if (((x2.sci_BitmapIndexedMapNode__f_nodeMap & bitpos) !== 0)) {
      var index$2 = $m_sci_Node$().indexFrom__I__I__I__I(x2.sci_BitmapIndexedMapNode__f_nodeMap, mask, bitpos);
      var subNode = x2.getNode__I__sci_MapNode(index$2);
      var beforeSize = subNode.size__I();
      var beforeHash = subNode.cachedJavaKeySetHashCode__I();
      this.update__sci_MapNode__O__O__I__I__I__V(subNode, key, value, originalHash, keyHash, ((5 + shift) | 0));
      x2.sci_BitmapIndexedMapNode__f_size = ((x2.sci_BitmapIndexedMapNode__f_size + ((subNode.size__I() - beforeSize) | 0)) | 0);
      x2.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode = ((x2.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode + ((subNode.cachedJavaKeySetHashCode__I() - beforeHash) | 0)) | 0)
    } else {
      $p_sci_HashMapBuilder__insertValue__sci_BitmapIndexedMapNode__I__O__I__I__O__V(this, x2, bitpos, key, originalHash, keyHash, value)
    }
  } else if ((mapNode instanceof $c_sci_HashCollisionMapNode)) {
    var x3 = $as_sci_HashCollisionMapNode(mapNode);
    var index$3 = x3.indexOf__O__I(key);
    if ((index$3 < 0)) {
      x3.sci_HashCollisionMapNode__f_content = x3.sci_HashCollisionMapNode__f_content.appended__O__sci_Vector(new $c_T2(key, value))
    } else {
      x3.sci_HashCollisionMapNode__f_content = x3.sci_HashCollisionMapNode__f_content.updated__I__O__sci_Vector(index$3, new $c_T2(key, value))
    }
  } else {
    throw new $c_s_MatchError(mapNode)
  }
});
$c_sci_HashMapBuilder.prototype.result__sci_HashMap = (function() {
  if ((this.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode.sci_BitmapIndexedMapNode__f_size === 0)) {
    var this$1 = $m_sci_HashMap$();
    return this$1.sci_HashMap$__f_EmptyMap
  } else if ((this.sci_HashMapBuilder__f_aliased !== null)) {
    return this.sci_HashMapBuilder__f_aliased
  } else {
    this.sci_HashMapBuilder__f_aliased = new $c_sci_HashMap(this.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode);
    return this.sci_HashMapBuilder__f_aliased
  }
});
$c_sci_HashMapBuilder.prototype.addOne__T2__sci_HashMapBuilder = (function(elem) {
  $p_sci_HashMapBuilder__ensureUnaliased__V(this);
  var x = elem._1__O();
  var h = $m_sr_Statics$().anyHash__O__I(x);
  var im = $m_sc_Hashing$().improve__I__I(h);
  this.update__sci_MapNode__O__O__I__I__I__V(this.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode, elem._1__O(), elem._2__O(), h, im, 0);
  return this
});
$c_sci_HashMapBuilder.prototype.addOne__O__O__sci_HashMapBuilder = (function(key, value) {
  $p_sci_HashMapBuilder__ensureUnaliased__V(this);
  var originalHash = $m_sr_Statics$().anyHash__O__I(key);
  this.update__sci_MapNode__O__O__I__I__I__V(this.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode, key, value, originalHash, $m_sc_Hashing$().improve__I__I(originalHash), 0);
  return this
});
$c_sci_HashMapBuilder.prototype.addAll__sc_IterableOnce__sci_HashMapBuilder = (function(xs) {
  $p_sci_HashMapBuilder__ensureUnaliased__V(this);
  if ((xs instanceof $c_sci_HashMap)) {
    var x2 = $as_sci_HashMap(xs);
    new $c_sci_HashMapBuilder$$anon$1(this, x2)
  } else if ((xs instanceof $c_scm_HashMap)) {
    var x3 = $as_scm_HashMap(xs);
    var iter = x3.nodeIterator__sc_Iterator();
    while (iter.hasNext__Z()) {
      var next = $as_scm_HashMap$Node(iter.next__O());
      var improvedHash = next.scm_HashMap$Node__f__hash;
      var originalHash = (improvedHash ^ ((improvedHash >>> 16) | 0));
      var hash = $m_sc_Hashing$().improve__I__I(originalHash);
      this.update__sci_MapNode__O__O__I__I__I__V(this.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode, next.scm_HashMap$Node__f__key, next.scm_HashMap$Node__f__value, originalHash, hash, 0)
    }
  } else if ($is_sci_Map(xs)) {
    var x4 = $as_sci_Map(xs);
    x4.foreachEntry__F2__V(new $c_sjsr_AnonFunction2((function(this$1) {
      return (function(key$2, value$2) {
        return this$1.addOne__O__O__sci_HashMapBuilder(key$2, value$2)
      })
    })(this)))
  } else {
    var it = xs.iterator__sc_Iterator();
    while (it.hasNext__Z()) {
      this.addOne__T2__sci_HashMapBuilder($as_T2(it.next__O()))
    }
  };
  return this
});
$c_sci_HashMapBuilder.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return this.addAll__sc_IterableOnce__sci_HashMapBuilder(xs)
});
$c_sci_HashMapBuilder.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__T2__sci_HashMapBuilder($as_T2(elem))
});
$c_sci_HashMapBuilder.prototype.result__O = (function() {
  return this.result__sci_HashMap()
});
var $d_sci_HashMapBuilder = new $TypeData().initClass({
  sci_HashMapBuilder: 0
}, false, "scala.collection.immutable.HashMapBuilder", {
  sci_HashMapBuilder: 1,
  O: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
});
$c_sci_HashMapBuilder.prototype.$classData = $d_sci_HashMapBuilder;
function $p_sci_HashSetBuilder__isAliased__Z($thiz) {
  return ($thiz.sci_HashSetBuilder__f_aliased !== null)
}
function $p_sci_HashSetBuilder__insertElement__AI__I__I__AI($thiz, as, ix, elem) {
  if ((ix < 0)) {
    throw $ct_jl_ArrayIndexOutOfBoundsException__(new $c_jl_ArrayIndexOutOfBoundsException())
  };
  if ((ix > as.u.length)) {
    throw $ct_jl_ArrayIndexOutOfBoundsException__(new $c_jl_ArrayIndexOutOfBoundsException())
  };
  var result = new $ac_I(((1 + as.u.length) | 0));
  $systemArraycopy(as, 0, result, 0, ix);
  result.set(ix, elem);
  var destPos = ((1 + ix) | 0);
  var length = ((as.u.length - ix) | 0);
  $systemArraycopy(as, ix, result, destPos, length);
  return result
}
function $p_sci_HashSetBuilder__insertValue__sci_BitmapIndexedSetNode__I__O__I__I__V($thiz, bm, bitpos, key, originalHash, keyHash) {
  var dataIx = bm.dataIndex__I__I(bitpos);
  var src = bm.sci_BitmapIndexedSetNode__f_content;
  var dst = new $ac_O(((1 + src.u.length) | 0));
  $systemArraycopy(src, 0, dst, 0, dataIx);
  dst.set(dataIx, key);
  var destPos = ((1 + dataIx) | 0);
  var length = ((src.u.length - dataIx) | 0);
  $systemArraycopy(src, dataIx, dst, destPos, length);
  var dstHashes = $p_sci_HashSetBuilder__insertElement__AI__I__I__AI($thiz, bm.sci_BitmapIndexedSetNode__f_originalHashes, dataIx, originalHash);
  bm.sci_BitmapIndexedSetNode__f_dataMap = (bm.sci_BitmapIndexedSetNode__f_dataMap | bitpos);
  bm.sci_BitmapIndexedSetNode__f_content = dst;
  bm.sci_BitmapIndexedSetNode__f_originalHashes = dstHashes;
  bm.sci_BitmapIndexedSetNode__f_size = ((1 + bm.sci_BitmapIndexedSetNode__f_size) | 0);
  bm.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode = ((bm.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode + keyHash) | 0)
}
function $p_sci_HashSetBuilder__setValue__sci_BitmapIndexedSetNode__I__O__V($thiz, bm, bitpos, elem) {
  var dataIx = bm.dataIndex__I__I(bitpos);
  bm.sci_BitmapIndexedSetNode__f_content.set(dataIx, elem)
}
function $p_sci_HashSetBuilder__ensureUnaliased__V($thiz) {
  if ($p_sci_HashSetBuilder__isAliased__Z($thiz)) {
    $p_sci_HashSetBuilder__copyElems__V($thiz)
  };
  $thiz.sci_HashSetBuilder__f_aliased = null
}
function $p_sci_HashSetBuilder__copyElems__V($thiz) {
  $thiz.sci_HashSetBuilder__f_scala$collection$immutable$HashSetBuilder$$rootNode = $thiz.sci_HashSetBuilder__f_scala$collection$immutable$HashSetBuilder$$rootNode.copy__sci_BitmapIndexedSetNode()
}
/** @constructor */
function $c_sci_HashSetBuilder() {
  this.sci_HashSetBuilder__f_aliased = null;
  this.sci_HashSetBuilder__f_scala$collection$immutable$HashSetBuilder$$rootNode = null;
  this.sci_HashSetBuilder__f_scala$collection$immutable$HashSetBuilder$$rootNode = new $c_sci_BitmapIndexedSetNode(0, 0, $m_s_Array$EmptyArrays$().s_Array$EmptyArrays$__f_emptyObjectArray, $m_s_Array$EmptyArrays$().s_Array$EmptyArrays$__f_emptyIntArray, 0, 0)
}
$c_sci_HashSetBuilder.prototype = new $h_O();
$c_sci_HashSetBuilder.prototype.constructor = $c_sci_HashSetBuilder;
/** @constructor */
function $h_sci_HashSetBuilder() {
  /*<skip>*/
}
$h_sci_HashSetBuilder.prototype = $c_sci_HashSetBuilder.prototype;
$c_sci_HashSetBuilder.prototype.sizeHint__I__V = (function(size) {
  /*<skip>*/
});
$c_sci_HashSetBuilder.prototype.update__sci_SetNode__O__I__I__I__V = (function(setNode, element, originalHash, elementHash, shift) {
  if ((setNode instanceof $c_sci_BitmapIndexedSetNode)) {
    var x2 = $as_sci_BitmapIndexedSetNode(setNode);
    var mask = $m_sci_Node$().maskFrom__I__I__I(elementHash, shift);
    var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
    if (((x2.sci_BitmapIndexedSetNode__f_dataMap & bitpos) !== 0)) {
      var index = $m_sci_Node$().indexFrom__I__I__I__I(x2.sci_BitmapIndexedSetNode__f_dataMap, mask, bitpos);
      var element0 = x2.getPayload__I__O(index);
      var element0UnimprovedHash = x2.getHash__I__I(index);
      if (((element0UnimprovedHash === originalHash) && $m_sr_BoxesRunTime$().equals__O__O__Z(element0, element))) {
        $p_sci_HashSetBuilder__setValue__sci_BitmapIndexedSetNode__I__O__V(this, x2, bitpos, element0)
      } else {
        var element0Hash = $m_sc_Hashing$().improve__I__I(element0UnimprovedHash);
        var subNodeNew = x2.mergeTwoKeyValPairs__O__I__I__O__I__I__I__sci_SetNode(element0, element0UnimprovedHash, element0Hash, element, originalHash, elementHash, ((5 + shift) | 0));
        x2.migrateFromInlineToNodeInPlace__I__I__sci_SetNode__sci_BitmapIndexedSetNode(bitpos, element0Hash, subNodeNew)
      }
    } else if (((x2.sci_BitmapIndexedSetNode__f_nodeMap & bitpos) !== 0)) {
      var index$2 = $m_sci_Node$().indexFrom__I__I__I__I(x2.sci_BitmapIndexedSetNode__f_nodeMap, mask, bitpos);
      var subNode = x2.getNode__I__sci_SetNode(index$2);
      var beforeSize = subNode.size__I();
      var beforeHashCode = subNode.cachedJavaKeySetHashCode__I();
      this.update__sci_SetNode__O__I__I__I__V(subNode, element, originalHash, elementHash, ((5 + shift) | 0));
      x2.sci_BitmapIndexedSetNode__f_size = ((x2.sci_BitmapIndexedSetNode__f_size + ((subNode.size__I() - beforeSize) | 0)) | 0);
      x2.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode = ((x2.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode + ((subNode.cachedJavaKeySetHashCode__I() - beforeHashCode) | 0)) | 0)
    } else {
      $p_sci_HashSetBuilder__insertValue__sci_BitmapIndexedSetNode__I__O__I__I__V(this, x2, bitpos, element, originalHash, elementHash)
    }
  } else if ((setNode instanceof $c_sci_HashCollisionSetNode)) {
    var x3 = $as_sci_HashCollisionSetNode(setNode);
    var this$1 = x3.sci_HashCollisionSetNode__f_content;
    var index$3 = $f_sc_SeqOps__indexOf__O__I__I(this$1, element, 0);
    if ((index$3 < 0)) {
      x3.sci_HashCollisionSetNode__f_content = x3.sci_HashCollisionSetNode__f_content.appended__O__sci_Vector(element)
    } else {
      x3.sci_HashCollisionSetNode__f_content = x3.sci_HashCollisionSetNode__f_content.updated__I__O__sci_Vector(index$3, element)
    }
  } else {
    throw new $c_s_MatchError(setNode)
  }
});
$c_sci_HashSetBuilder.prototype.result__sci_HashSet = (function() {
  if ((this.sci_HashSetBuilder__f_scala$collection$immutable$HashSetBuilder$$rootNode.sci_BitmapIndexedSetNode__f_size === 0)) {
    var this$1 = $m_sci_HashSet$();
    return this$1.sci_HashSet$__f_EmptySet
  } else if ((this.sci_HashSetBuilder__f_aliased !== null)) {
    return this.sci_HashSetBuilder__f_aliased
  } else {
    this.sci_HashSetBuilder__f_aliased = new $c_sci_HashSet(this.sci_HashSetBuilder__f_scala$collection$immutable$HashSetBuilder$$rootNode);
    return this.sci_HashSetBuilder__f_aliased
  }
});
$c_sci_HashSetBuilder.prototype.addOne__O__sci_HashSetBuilder = (function(elem) {
  $p_sci_HashSetBuilder__ensureUnaliased__V(this);
  var h = $m_sr_Statics$().anyHash__O__I(elem);
  var im = $m_sc_Hashing$().improve__I__I(h);
  this.update__sci_SetNode__O__I__I__I__V(this.sci_HashSetBuilder__f_scala$collection$immutable$HashSetBuilder$$rootNode, elem, h, im, 0);
  return this
});
$c_sci_HashSetBuilder.prototype.addAll__sc_IterableOnce__sci_HashSetBuilder = (function(xs) {
  $p_sci_HashSetBuilder__ensureUnaliased__V(this);
  if ((xs instanceof $c_sci_HashSet)) {
    var x2 = $as_sci_HashSet(xs);
    new $c_sci_HashSetBuilder$$anon$1(this, x2)
  } else {
    var it = xs.iterator__sc_Iterator();
    while (it.hasNext__Z()) {
      this.addOne__O__sci_HashSetBuilder(it.next__O())
    }
  };
  return this
});
$c_sci_HashSetBuilder.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return this.addAll__sc_IterableOnce__sci_HashSetBuilder(xs)
});
$c_sci_HashSetBuilder.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__sci_HashSetBuilder(elem)
});
$c_sci_HashSetBuilder.prototype.result__O = (function() {
  return this.result__sci_HashSet()
});
var $d_sci_HashSetBuilder = new $TypeData().initClass({
  sci_HashSetBuilder: 0
}, false, "scala.collection.immutable.HashSetBuilder", {
  sci_HashSetBuilder: 1,
  O: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
});
$c_sci_HashSetBuilder.prototype.$classData = $d_sci_HashSetBuilder;
/** @constructor */
function $c_sci_IndexedSeq$() {
  this.sc_SeqFactory$Delegate__f_delegate = null;
  $ct_sc_SeqFactory$Delegate__sc_SeqFactory__(this, $m_sci_Vector$())
}
$c_sci_IndexedSeq$.prototype = new $h_sc_SeqFactory$Delegate();
$c_sci_IndexedSeq$.prototype.constructor = $c_sci_IndexedSeq$;
/** @constructor */
function $h_sci_IndexedSeq$() {
  /*<skip>*/
}
$h_sci_IndexedSeq$.prototype = $c_sci_IndexedSeq$.prototype;
$c_sci_IndexedSeq$.prototype.from__sc_IterableOnce__sci_IndexedSeq = (function(it) {
  if ($is_sci_IndexedSeq(it)) {
    var x2 = $as_sci_IndexedSeq(it);
    return x2
  } else {
    return $as_sci_IndexedSeq($c_sc_SeqFactory$Delegate.prototype.from__sc_IterableOnce__sc_SeqOps.call(this, it))
  }
});
$c_sci_IndexedSeq$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__sci_IndexedSeq(source)
});
$c_sci_IndexedSeq$.prototype.from__sc_IterableOnce__sc_SeqOps = (function(it) {
  return this.from__sc_IterableOnce__sci_IndexedSeq(it)
});
var $d_sci_IndexedSeq$ = new $TypeData().initClass({
  sci_IndexedSeq$: 0
}, false, "scala.collection.immutable.IndexedSeq$", {
  sci_IndexedSeq$: 1,
  sc_SeqFactory$Delegate: 1,
  O: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sci_IndexedSeq$.prototype.$classData = $d_sci_IndexedSeq$;
var $n_sci_IndexedSeq$;
function $m_sci_IndexedSeq$() {
  if ((!$n_sci_IndexedSeq$)) {
    $n_sci_IndexedSeq$ = new $c_sci_IndexedSeq$()
  };
  return $n_sci_IndexedSeq$
}
/** @constructor */
function $c_sci_LazyList$LazyBuilder() {
  this.sci_LazyList$LazyBuilder__f_next = null;
  this.sci_LazyList$LazyBuilder__f_list = null;
  this.clear__V()
}
$c_sci_LazyList$LazyBuilder.prototype = new $h_O();
$c_sci_LazyList$LazyBuilder.prototype.constructor = $c_sci_LazyList$LazyBuilder;
/** @constructor */
function $h_sci_LazyList$LazyBuilder() {
  /*<skip>*/
}
$h_sci_LazyList$LazyBuilder.prototype = $c_sci_LazyList$LazyBuilder.prototype;
$c_sci_LazyList$LazyBuilder.prototype.sizeHint__I__V = (function(size) {
  /*<skip>*/
});
$c_sci_LazyList$LazyBuilder.prototype.clear__V = (function() {
  var deferred = new $c_sci_LazyList$LazyBuilder$DeferredState();
  $m_sci_LazyList$();
  var state = new $c_sjsr_AnonFunction0((function(this$1, deferred$1) {
    return (function() {
      return deferred$1.eval__sci_LazyList$State()
    })
  })(this, deferred));
  this.sci_LazyList$LazyBuilder__f_list = new $c_sci_LazyList(state);
  this.sci_LazyList$LazyBuilder__f_next = deferred
});
$c_sci_LazyList$LazyBuilder.prototype.result__sci_LazyList = (function() {
  this.sci_LazyList$LazyBuilder__f_next.init__F0__V(new $c_sjsr_AnonFunction0((function(this$1) {
    return (function() {
      return $m_sci_LazyList$State$Empty$()
    })
  })(this)));
  return this.sci_LazyList$LazyBuilder__f_list
});
$c_sci_LazyList$LazyBuilder.prototype.addOne__O__sci_LazyList$LazyBuilder = (function(elem) {
  var deferred = new $c_sci_LazyList$LazyBuilder$DeferredState();
  this.sci_LazyList$LazyBuilder__f_next.init__F0__V(new $c_sjsr_AnonFunction0((function(this$1, elem$1, deferred$1) {
    return (function() {
      $m_sci_LazyList$();
      $m_sci_LazyList$();
      var state = new $c_sjsr_AnonFunction0((function(this$2, deferred$2) {
        return (function() {
          return deferred$2.eval__sci_LazyList$State()
        })
      })(this$1, deferred$1));
      var tl = new $c_sci_LazyList(state);
      return new $c_sci_LazyList$State$Cons(elem$1, tl)
    })
  })(this, elem, deferred)));
  this.sci_LazyList$LazyBuilder__f_next = deferred;
  return this
});
$c_sci_LazyList$LazyBuilder.prototype.addAll__sc_IterableOnce__sci_LazyList$LazyBuilder = (function(xs) {
  if ((xs.knownSize__I() !== 0)) {
    var deferred = new $c_sci_LazyList$LazyBuilder$DeferredState();
    this.sci_LazyList$LazyBuilder__f_next.init__F0__V(new $c_sjsr_AnonFunction0((function(this$1, xs$1, deferred$1) {
      return (function() {
        return $m_sci_LazyList$().scala$collection$immutable$LazyList$$stateFromIteratorConcatSuffix__sc_Iterator__F0__sci_LazyList$State(xs$1.iterator__sc_Iterator(), new $c_sjsr_AnonFunction0((function(this$2, deferred$3) {
          return (function() {
            return deferred$3.eval__sci_LazyList$State()
          })
        })(this$1, deferred$1)))
      })
    })(this, xs, deferred)));
    this.sci_LazyList$LazyBuilder__f_next = deferred
  };
  return this
});
$c_sci_LazyList$LazyBuilder.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return this.addAll__sc_IterableOnce__sci_LazyList$LazyBuilder(xs)
});
$c_sci_LazyList$LazyBuilder.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__sci_LazyList$LazyBuilder(elem)
});
$c_sci_LazyList$LazyBuilder.prototype.result__O = (function() {
  return this.result__sci_LazyList()
});
var $d_sci_LazyList$LazyBuilder = new $TypeData().initClass({
  sci_LazyList$LazyBuilder: 0
}, false, "scala.collection.immutable.LazyList$LazyBuilder", {
  sci_LazyList$LazyBuilder: 1,
  O: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
});
$c_sci_LazyList$LazyBuilder.prototype.$classData = $d_sci_LazyList$LazyBuilder;
/** @constructor */
function $c_sci_LazyList$LazyIterator(lazyList) {
  this.sci_LazyList$LazyIterator__f_lazyList = null;
  this.sci_LazyList$LazyIterator__f_lazyList = lazyList
}
$c_sci_LazyList$LazyIterator.prototype = new $h_sc_AbstractIterator();
$c_sci_LazyList$LazyIterator.prototype.constructor = $c_sci_LazyList$LazyIterator;
/** @constructor */
function $h_sci_LazyList$LazyIterator() {
  /*<skip>*/
}
$h_sci_LazyList$LazyIterator.prototype = $c_sci_LazyList$LazyIterator.prototype;
$c_sci_LazyList$LazyIterator.prototype.hasNext__Z = (function() {
  return (!this.sci_LazyList$LazyIterator__f_lazyList.isEmpty__Z())
});
$c_sci_LazyList$LazyIterator.prototype.next__O = (function() {
  if (this.sci_LazyList$LazyIterator__f_lazyList.isEmpty__Z()) {
    return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O()
  } else {
    var this$1 = this.sci_LazyList$LazyIterator__f_lazyList;
    var res = this$1.scala$collection$immutable$LazyList$$state__sci_LazyList$State().head__O();
    var this$2 = this.sci_LazyList$LazyIterator__f_lazyList;
    this.sci_LazyList$LazyIterator__f_lazyList = this$2.scala$collection$immutable$LazyList$$state__sci_LazyList$State().tail__sci_LazyList();
    return res
  }
});
var $d_sci_LazyList$LazyIterator = new $TypeData().initClass({
  sci_LazyList$LazyIterator: 0
}, false, "scala.collection.immutable.LazyList$LazyIterator", {
  sci_LazyList$LazyIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sci_LazyList$LazyIterator.prototype.$classData = $d_sci_LazyList$LazyIterator;
/** @constructor */
function $c_sci_List$() {
  this.sci_List$__f_scala$collection$immutable$List$$TupleOfNil = null;
  this.sci_List$__f_partialNotApplied = null;
  $n_sci_List$ = this;
  this.sci_List$__f_scala$collection$immutable$List$$TupleOfNil = new $c_T2($m_sci_Nil$(), $m_sci_Nil$());
  this.sci_List$__f_partialNotApplied = new $c_sci_List$$anon$1()
}
$c_sci_List$.prototype = new $h_O();
$c_sci_List$.prototype.constructor = $c_sci_List$;
/** @constructor */
function $h_sci_List$() {
  /*<skip>*/
}
$h_sci_List$.prototype = $c_sci_List$.prototype;
$c_sci_List$.prototype.apply__sci_Seq__O = (function(elems) {
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)
});
$c_sci_List$.prototype.newBuilder__scm_Builder = (function() {
  return new $c_scm_ListBuffer()
});
$c_sci_List$.prototype.empty__O = (function() {
  return $m_sci_Nil$()
});
$c_sci_List$.prototype.from__sc_IterableOnce__O = (function(source) {
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(source)
});
var $d_sci_List$ = new $TypeData().initClass({
  sci_List$: 0
}, false, "scala.collection.immutable.List$", {
  sci_List$: 1,
  O: 1,
  sc_StrictOptimizedSeqFactory: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sci_List$.prototype.$classData = $d_sci_List$;
var $n_sci_List$;
function $m_sci_List$() {
  if ((!$n_sci_List$)) {
    $n_sci_List$ = new $c_sci_List$()
  };
  return $n_sci_List$
}
function $ct_sci_Map$Map2$Map2Iterator__sci_Map$Map2__($thiz, outer) {
  if ((outer === null)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(null)
  } else {
    $thiz.sci_Map$Map2$Map2Iterator__f_$outer = outer
  };
  $thiz.sci_Map$Map2$Map2Iterator__f_i = 0;
  return $thiz
}
/** @constructor */
function $c_sci_Map$Map2$Map2Iterator() {
  this.sci_Map$Map2$Map2Iterator__f_i = 0;
  this.sci_Map$Map2$Map2Iterator__f_$outer = null
}
$c_sci_Map$Map2$Map2Iterator.prototype = new $h_sc_AbstractIterator();
$c_sci_Map$Map2$Map2Iterator.prototype.constructor = $c_sci_Map$Map2$Map2Iterator;
/** @constructor */
function $h_sci_Map$Map2$Map2Iterator() {
  /*<skip>*/
}
$h_sci_Map$Map2$Map2Iterator.prototype = $c_sci_Map$Map2$Map2Iterator.prototype;
$c_sci_Map$Map2$Map2Iterator.prototype.hasNext__Z = (function() {
  return (this.sci_Map$Map2$Map2Iterator__f_i < 2)
});
$c_sci_Map$Map2$Map2Iterator.prototype.next__O = (function() {
  var x1 = this.sci_Map$Map2$Map2Iterator__f_i;
  switch (x1) {
    case 0: {
      var k = this.sci_Map$Map2$Map2Iterator__f_$outer.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1;
      var v = this.sci_Map$Map2$Map2Iterator__f_$outer.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1;
      var result = new $c_T2(k, v);
      break
    }
    case 1: {
      var k$1 = this.sci_Map$Map2$Map2Iterator__f_$outer.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2;
      var v$1 = this.sci_Map$Map2$Map2Iterator__f_$outer.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2;
      var result = new $c_T2(k$1, v$1);
      break
    }
    default: {
      var result = $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O()
    }
  };
  this.sci_Map$Map2$Map2Iterator__f_i = ((1 + this.sci_Map$Map2$Map2Iterator__f_i) | 0);
  return result
});
$c_sci_Map$Map2$Map2Iterator.prototype.drop__I__sc_Iterator = (function(n) {
  this.sci_Map$Map2$Map2Iterator__f_i = ((this.sci_Map$Map2$Map2Iterator__f_i + n) | 0);
  return this
});
function $ct_sci_Map$Map3$Map3Iterator__sci_Map$Map3__($thiz, outer) {
  if ((outer === null)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(null)
  } else {
    $thiz.sci_Map$Map3$Map3Iterator__f_$outer = outer
  };
  $thiz.sci_Map$Map3$Map3Iterator__f_i = 0;
  return $thiz
}
/** @constructor */
function $c_sci_Map$Map3$Map3Iterator() {
  this.sci_Map$Map3$Map3Iterator__f_i = 0;
  this.sci_Map$Map3$Map3Iterator__f_$outer = null
}
$c_sci_Map$Map3$Map3Iterator.prototype = new $h_sc_AbstractIterator();
$c_sci_Map$Map3$Map3Iterator.prototype.constructor = $c_sci_Map$Map3$Map3Iterator;
/** @constructor */
function $h_sci_Map$Map3$Map3Iterator() {
  /*<skip>*/
}
$h_sci_Map$Map3$Map3Iterator.prototype = $c_sci_Map$Map3$Map3Iterator.prototype;
$c_sci_Map$Map3$Map3Iterator.prototype.hasNext__Z = (function() {
  return (this.sci_Map$Map3$Map3Iterator__f_i < 3)
});
$c_sci_Map$Map3$Map3Iterator.prototype.next__O = (function() {
  var x1 = this.sci_Map$Map3$Map3Iterator__f_i;
  switch (x1) {
    case 0: {
      var k = this.sci_Map$Map3$Map3Iterator__f_$outer.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1;
      var v = this.sci_Map$Map3$Map3Iterator__f_$outer.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1;
      var result = new $c_T2(k, v);
      break
    }
    case 1: {
      var k$1 = this.sci_Map$Map3$Map3Iterator__f_$outer.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2;
      var v$1 = this.sci_Map$Map3$Map3Iterator__f_$outer.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2;
      var result = new $c_T2(k$1, v$1);
      break
    }
    case 2: {
      var k$2 = this.sci_Map$Map3$Map3Iterator__f_$outer.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3;
      var v$2 = this.sci_Map$Map3$Map3Iterator__f_$outer.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3;
      var result = new $c_T2(k$2, v$2);
      break
    }
    default: {
      var result = $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O()
    }
  };
  this.sci_Map$Map3$Map3Iterator__f_i = ((1 + this.sci_Map$Map3$Map3Iterator__f_i) | 0);
  return result
});
$c_sci_Map$Map3$Map3Iterator.prototype.drop__I__sc_Iterator = (function(n) {
  this.sci_Map$Map3$Map3Iterator__f_i = ((this.sci_Map$Map3$Map3Iterator__f_i + n) | 0);
  return this
});
function $ct_sci_Map$Map4$Map4Iterator__sci_Map$Map4__($thiz, outer) {
  if ((outer === null)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(null)
  } else {
    $thiz.sci_Map$Map4$Map4Iterator__f_$outer = outer
  };
  $thiz.sci_Map$Map4$Map4Iterator__f_i = 0;
  return $thiz
}
/** @constructor */
function $c_sci_Map$Map4$Map4Iterator() {
  this.sci_Map$Map4$Map4Iterator__f_i = 0;
  this.sci_Map$Map4$Map4Iterator__f_$outer = null
}
$c_sci_Map$Map4$Map4Iterator.prototype = new $h_sc_AbstractIterator();
$c_sci_Map$Map4$Map4Iterator.prototype.constructor = $c_sci_Map$Map4$Map4Iterator;
/** @constructor */
function $h_sci_Map$Map4$Map4Iterator() {
  /*<skip>*/
}
$h_sci_Map$Map4$Map4Iterator.prototype = $c_sci_Map$Map4$Map4Iterator.prototype;
$c_sci_Map$Map4$Map4Iterator.prototype.hasNext__Z = (function() {
  return (this.sci_Map$Map4$Map4Iterator__f_i < 4)
});
$c_sci_Map$Map4$Map4Iterator.prototype.next__O = (function() {
  var x1 = this.sci_Map$Map4$Map4Iterator__f_i;
  switch (x1) {
    case 0: {
      var k = this.sci_Map$Map4$Map4Iterator__f_$outer.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1;
      var v = this.sci_Map$Map4$Map4Iterator__f_$outer.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1;
      var result = new $c_T2(k, v);
      break
    }
    case 1: {
      var k$1 = this.sci_Map$Map4$Map4Iterator__f_$outer.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2;
      var v$1 = this.sci_Map$Map4$Map4Iterator__f_$outer.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2;
      var result = new $c_T2(k$1, v$1);
      break
    }
    case 2: {
      var k$2 = this.sci_Map$Map4$Map4Iterator__f_$outer.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3;
      var v$2 = this.sci_Map$Map4$Map4Iterator__f_$outer.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3;
      var result = new $c_T2(k$2, v$2);
      break
    }
    case 3: {
      var k$3 = this.sci_Map$Map4$Map4Iterator__f_$outer.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4;
      var v$3 = this.sci_Map$Map4$Map4Iterator__f_$outer.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4;
      var result = new $c_T2(k$3, v$3);
      break
    }
    default: {
      var result = $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O()
    }
  };
  this.sci_Map$Map4$Map4Iterator__f_i = ((1 + this.sci_Map$Map4$Map4Iterator__f_i) | 0);
  return result
});
$c_sci_Map$Map4$Map4Iterator.prototype.drop__I__sc_Iterator = (function(n) {
  this.sci_Map$Map4$Map4Iterator__f_i = ((this.sci_Map$Map4$Map4Iterator__f_i + n) | 0);
  return this
});
/** @constructor */
function $c_sci_MapBuilderImpl() {
  this.sci_MapBuilderImpl__f_elems = null;
  this.sci_MapBuilderImpl__f_switchedToHashMapBuilder = false;
  this.sci_MapBuilderImpl__f_hashMapBuilder = null;
  this.sci_MapBuilderImpl__f_elems = $m_sci_Map$EmptyMap$();
  this.sci_MapBuilderImpl__f_switchedToHashMapBuilder = false
}
$c_sci_MapBuilderImpl.prototype = new $h_O();
$c_sci_MapBuilderImpl.prototype.constructor = $c_sci_MapBuilderImpl;
/** @constructor */
function $h_sci_MapBuilderImpl() {
  /*<skip>*/
}
$h_sci_MapBuilderImpl.prototype = $c_sci_MapBuilderImpl.prototype;
$c_sci_MapBuilderImpl.prototype.sizeHint__I__V = (function(size) {
  /*<skip>*/
});
$c_sci_MapBuilderImpl.prototype.result__sci_Map = (function() {
  return (this.sci_MapBuilderImpl__f_switchedToHashMapBuilder ? this.sci_MapBuilderImpl__f_hashMapBuilder.result__sci_HashMap() : this.sci_MapBuilderImpl__f_elems)
});
$c_sci_MapBuilderImpl.prototype.addOne__O__O__sci_MapBuilderImpl = (function(key, value) {
  if (this.sci_MapBuilderImpl__f_switchedToHashMapBuilder) {
    this.sci_MapBuilderImpl__f_hashMapBuilder.addOne__O__O__sci_HashMapBuilder(key, value)
  } else if ((this.sci_MapBuilderImpl__f_elems.size__I() < 4)) {
    this.sci_MapBuilderImpl__f_elems = $as_sci_Map(this.sci_MapBuilderImpl__f_elems.updated__O__O__sci_MapOps(key, value))
  } else if (this.sci_MapBuilderImpl__f_elems.contains__O__Z(key)) {
    this.sci_MapBuilderImpl__f_elems = $as_sci_Map(this.sci_MapBuilderImpl__f_elems.updated__O__O__sci_MapOps(key, value))
  } else {
    this.sci_MapBuilderImpl__f_switchedToHashMapBuilder = true;
    if ((this.sci_MapBuilderImpl__f_hashMapBuilder === null)) {
      this.sci_MapBuilderImpl__f_hashMapBuilder = new $c_sci_HashMapBuilder()
    };
    $as_sci_Map$Map4(this.sci_MapBuilderImpl__f_elems).buildTo__sci_HashMapBuilder__sci_HashMapBuilder(this.sci_MapBuilderImpl__f_hashMapBuilder);
    this.sci_MapBuilderImpl__f_hashMapBuilder.addOne__O__O__sci_HashMapBuilder(key, value)
  };
  return this
});
$c_sci_MapBuilderImpl.prototype.addAll__sc_IterableOnce__sci_MapBuilderImpl = (function(xs) {
  return (this.sci_MapBuilderImpl__f_switchedToHashMapBuilder ? (this.sci_MapBuilderImpl__f_hashMapBuilder.addAll__sc_IterableOnce__sci_HashMapBuilder(xs), this) : $as_sci_MapBuilderImpl($f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs)))
});
$c_sci_MapBuilderImpl.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return this.addAll__sc_IterableOnce__sci_MapBuilderImpl(xs)
});
$c_sci_MapBuilderImpl.prototype.addOne__O__scm_Growable = (function(elem) {
  var elem$1 = $as_T2(elem);
  return this.addOne__O__O__sci_MapBuilderImpl(elem$1._1__O(), elem$1._2__O())
});
$c_sci_MapBuilderImpl.prototype.result__O = (function() {
  return this.result__sci_Map()
});
function $as_sci_MapBuilderImpl(obj) {
  return (((obj instanceof $c_sci_MapBuilderImpl) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.MapBuilderImpl"))
}
function $isArrayOf_sci_MapBuilderImpl(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_MapBuilderImpl)))
}
function $asArrayOf_sci_MapBuilderImpl(obj, depth) {
  return (($isArrayOf_sci_MapBuilderImpl(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.MapBuilderImpl;", depth))
}
var $d_sci_MapBuilderImpl = new $TypeData().initClass({
  sci_MapBuilderImpl: 0
}, false, "scala.collection.immutable.MapBuilderImpl", {
  sci_MapBuilderImpl: 1,
  O: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
});
$c_sci_MapBuilderImpl.prototype.$classData = $d_sci_MapBuilderImpl;
/** @constructor */
function $c_sci_MapKeyValueTupleHashIterator(rootNode) {
  this.sci_ChampBaseReverseIterator__f_currentValueCursor = 0;
  this.sci_ChampBaseReverseIterator__f_currentValueNode = null;
  this.sci_ChampBaseReverseIterator__f_currentStackLevel = 0;
  this.sci_ChampBaseReverseIterator__f_nodeIndex = null;
  this.sci_ChampBaseReverseIterator__f_nodeStack = null;
  this.sci_MapKeyValueTupleHashIterator__f_hash = 0;
  this.sci_MapKeyValueTupleHashIterator__f_value = null;
  $ct_sci_ChampBaseReverseIterator__sci_Node__(this, rootNode);
  this.sci_MapKeyValueTupleHashIterator__f_hash = 0
}
$c_sci_MapKeyValueTupleHashIterator.prototype = new $h_sci_ChampBaseReverseIterator();
$c_sci_MapKeyValueTupleHashIterator.prototype.constructor = $c_sci_MapKeyValueTupleHashIterator;
/** @constructor */
function $h_sci_MapKeyValueTupleHashIterator() {
  /*<skip>*/
}
$h_sci_MapKeyValueTupleHashIterator.prototype = $c_sci_MapKeyValueTupleHashIterator.prototype;
$c_sci_MapKeyValueTupleHashIterator.prototype.iterator__sc_Iterator = (function() {
  return this
});
$c_sci_MapKeyValueTupleHashIterator.prototype.isEmpty__Z = (function() {
  return (!this.hasNext__Z())
});
$c_sci_MapKeyValueTupleHashIterator.prototype.concat__F0__sc_Iterator = (function(xs) {
  return $f_sc_Iterator__concat__F0__sc_Iterator(this, xs)
});
$c_sci_MapKeyValueTupleHashIterator.prototype.drop__I__sc_Iterator = (function(n) {
  return $f_sc_Iterator__drop__I__sc_Iterator(this, n)
});
$c_sci_MapKeyValueTupleHashIterator.prototype.toString__T = (function() {
  return "<iterator>"
});
$c_sci_MapKeyValueTupleHashIterator.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len)
});
$c_sci_MapKeyValueTupleHashIterator.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end)
});
$c_sci_MapKeyValueTupleHashIterator.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2)
});
$c_sci_MapKeyValueTupleHashIterator.prototype.knownSize__I = (function() {
  return (-1)
});
$c_sci_MapKeyValueTupleHashIterator.prototype.hashCode__I = (function() {
  var $$x2 = $m_s_util_hashing_MurmurHash3$();
  var $$x1 = this.sci_MapKeyValueTupleHashIterator__f_hash;
  var x = this.sci_MapKeyValueTupleHashIterator__f_value;
  return $$x2.tuple2Hash__I__I__I__I($$x1, $m_sr_Statics$().anyHash__O__I(x), (-889275714))
});
$c_sci_MapKeyValueTupleHashIterator.prototype.next__sci_MapKeyValueTupleHashIterator = (function() {
  if ((!this.hasNext__Z())) {
    throw $ct_ju_NoSuchElementException__(new $c_ju_NoSuchElementException())
  };
  this.sci_MapKeyValueTupleHashIterator__f_hash = this.sci_ChampBaseReverseIterator__f_currentValueNode.getHash__I__I(this.sci_ChampBaseReverseIterator__f_currentValueCursor);
  this.sci_MapKeyValueTupleHashIterator__f_value = $as_sci_MapNode(this.sci_ChampBaseReverseIterator__f_currentValueNode).getValue__I__O(this.sci_ChampBaseReverseIterator__f_currentValueCursor);
  this.sci_ChampBaseReverseIterator__f_currentValueCursor = (((-1) + this.sci_ChampBaseReverseIterator__f_currentValueCursor) | 0);
  return this
});
$c_sci_MapKeyValueTupleHashIterator.prototype.next__O = (function() {
  return this.next__sci_MapKeyValueTupleHashIterator()
});
var $d_sci_MapKeyValueTupleHashIterator = new $TypeData().initClass({
  sci_MapKeyValueTupleHashIterator: 0
}, false, "scala.collection.immutable.MapKeyValueTupleHashIterator", {
  sci_MapKeyValueTupleHashIterator: 1,
  sci_ChampBaseReverseIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sci_MapKeyValueTupleHashIterator.prototype.$classData = $d_sci_MapKeyValueTupleHashIterator;
/** @constructor */
function $c_sci_MapKeyValueTupleIterator(rootNode) {
  this.sci_ChampBaseIterator__f_currentValueCursor = 0;
  this.sci_ChampBaseIterator__f_currentValueLength = 0;
  this.sci_ChampBaseIterator__f_currentValueNode = null;
  this.sci_ChampBaseIterator__f_currentStackLevel = 0;
  this.sci_ChampBaseIterator__f_nodeCursorsAndLengths = null;
  this.sci_ChampBaseIterator__f_nodes = null;
  $ct_sci_ChampBaseIterator__sci_Node__(this, rootNode)
}
$c_sci_MapKeyValueTupleIterator.prototype = new $h_sci_ChampBaseIterator();
$c_sci_MapKeyValueTupleIterator.prototype.constructor = $c_sci_MapKeyValueTupleIterator;
/** @constructor */
function $h_sci_MapKeyValueTupleIterator() {
  /*<skip>*/
}
$h_sci_MapKeyValueTupleIterator.prototype = $c_sci_MapKeyValueTupleIterator.prototype;
$c_sci_MapKeyValueTupleIterator.prototype.iterator__sc_Iterator = (function() {
  return this
});
$c_sci_MapKeyValueTupleIterator.prototype.isEmpty__Z = (function() {
  return (!this.hasNext__Z())
});
$c_sci_MapKeyValueTupleIterator.prototype.concat__F0__sc_Iterator = (function(xs) {
  return $f_sc_Iterator__concat__F0__sc_Iterator(this, xs)
});
$c_sci_MapKeyValueTupleIterator.prototype.drop__I__sc_Iterator = (function(n) {
  return $f_sc_Iterator__drop__I__sc_Iterator(this, n)
});
$c_sci_MapKeyValueTupleIterator.prototype.toString__T = (function() {
  return "<iterator>"
});
$c_sci_MapKeyValueTupleIterator.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len)
});
$c_sci_MapKeyValueTupleIterator.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end)
});
$c_sci_MapKeyValueTupleIterator.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2)
});
$c_sci_MapKeyValueTupleIterator.prototype.knownSize__I = (function() {
  return (-1)
});
$c_sci_MapKeyValueTupleIterator.prototype.next__T2 = (function() {
  if ((!this.hasNext__Z())) {
    throw $ct_ju_NoSuchElementException__(new $c_ju_NoSuchElementException())
  };
  var payload = $as_sci_MapNode(this.sci_ChampBaseIterator__f_currentValueNode).getPayload__I__T2(this.sci_ChampBaseIterator__f_currentValueCursor);
  this.sci_ChampBaseIterator__f_currentValueCursor = ((1 + this.sci_ChampBaseIterator__f_currentValueCursor) | 0);
  return payload
});
$c_sci_MapKeyValueTupleIterator.prototype.next__O = (function() {
  return this.next__T2()
});
var $d_sci_MapKeyValueTupleIterator = new $TypeData().initClass({
  sci_MapKeyValueTupleIterator: 0
}, false, "scala.collection.immutable.MapKeyValueTupleIterator", {
  sci_MapKeyValueTupleIterator: 1,
  sci_ChampBaseIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sci_MapKeyValueTupleIterator.prototype.$classData = $d_sci_MapKeyValueTupleIterator;
function $p_sci_NewVectorIterator__advanceSlice__V($thiz) {
  if (($thiz.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 <= $thiz.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1)) {
    $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O()
  };
  $thiz.sci_NewVectorIterator__f_sliceIdx = ((1 + $thiz.sci_NewVectorIterator__f_sliceIdx) | 0);
  var slice = $thiz.sci_NewVectorIterator__f_v.vectorSlice__I__AO($thiz.sci_NewVectorIterator__f_sliceIdx);
  while ((slice.u.length === 0)) {
    $thiz.sci_NewVectorIterator__f_sliceIdx = ((1 + $thiz.sci_NewVectorIterator__f_sliceIdx) | 0);
    slice = $thiz.sci_NewVectorIterator__f_v.vectorSlice__I__AO($thiz.sci_NewVectorIterator__f_sliceIdx)
  };
  $thiz.sci_NewVectorIterator__f_sliceStart = $thiz.sci_NewVectorIterator__f_sliceEnd;
  var count = $thiz.sci_NewVectorIterator__f_sliceCount;
  var idx = $thiz.sci_NewVectorIterator__f_sliceIdx;
  var c = ((count / 2) | 0);
  var a = ((idx - c) | 0);
  $thiz.sci_NewVectorIterator__f_sliceDim = ((((1 + c) | 0) - ((a < 0) ? ((-a) | 0) : a)) | 0);
  var x1 = $thiz.sci_NewVectorIterator__f_sliceDim;
  switch (x1) {
    case 1: {
      $thiz.sci_NewVectorIterator__f_a1 = slice;
      break
    }
    case 2: {
      $thiz.sci_NewVectorIterator__f_a2 = $asArrayOf_O(slice, 2);
      break
    }
    case 3: {
      $thiz.sci_NewVectorIterator__f_a3 = $asArrayOf_O(slice, 3);
      break
    }
    case 4: {
      $thiz.sci_NewVectorIterator__f_a4 = $asArrayOf_O(slice, 4);
      break
    }
    case 5: {
      $thiz.sci_NewVectorIterator__f_a5 = $asArrayOf_O(slice, 5);
      break
    }
    case 6: {
      $thiz.sci_NewVectorIterator__f_a6 = $asArrayOf_O(slice, 6);
      break
    }
    default: {
      throw new $c_s_MatchError(x1)
    }
  };
  $thiz.sci_NewVectorIterator__f_sliceEnd = (($thiz.sci_NewVectorIterator__f_sliceStart + $imul(slice.u.length, (1 << $imul(5, (((-1) + $thiz.sci_NewVectorIterator__f_sliceDim) | 0))))) | 0);
  if (($thiz.sci_NewVectorIterator__f_sliceEnd > $thiz.sci_NewVectorIterator__f_totalLength)) {
    $thiz.sci_NewVectorIterator__f_sliceEnd = $thiz.sci_NewVectorIterator__f_totalLength
  };
  if (($thiz.sci_NewVectorIterator__f_sliceDim > 1)) {
    $thiz.sci_NewVectorIterator__f_oldPos = (((-1) + (1 << $imul(5, $thiz.sci_NewVectorIterator__f_sliceDim))) | 0)
  }
}
function $p_sci_NewVectorIterator__advance__V($thiz) {
  var pos = (((($thiz.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 - $thiz.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1) | 0) + $thiz.sci_NewVectorIterator__f_totalLength) | 0);
  if ((pos === $thiz.sci_NewVectorIterator__f_sliceEnd)) {
    $p_sci_NewVectorIterator__advanceSlice__V($thiz)
  };
  if (($thiz.sci_NewVectorIterator__f_sliceDim > 1)) {
    var io = ((pos - $thiz.sci_NewVectorIterator__f_sliceStart) | 0);
    var xor = ($thiz.sci_NewVectorIterator__f_oldPos ^ io);
    $p_sci_NewVectorIterator__advanceA__I__I__V($thiz, io, xor);
    $thiz.sci_NewVectorIterator__f_oldPos = io
  };
  $thiz.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 = (($thiz.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 - $thiz.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1) | 0);
  var a = $thiz.sci_NewVectorIterator__f_a1.u.length;
  var b = $thiz.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1;
  $thiz.sci_NewVectorIterator__f_a1len = ((a < b) ? a : b);
  $thiz.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 = 0
}
function $p_sci_NewVectorIterator__advanceA__I__I__V($thiz, io, xor) {
  if ((xor < 1024)) {
    $thiz.sci_NewVectorIterator__f_a1 = $thiz.sci_NewVectorIterator__f_a2.get((31 & ((io >>> 5) | 0)))
  } else if ((xor < 32768)) {
    $thiz.sci_NewVectorIterator__f_a2 = $thiz.sci_NewVectorIterator__f_a3.get((31 & ((io >>> 10) | 0)));
    $thiz.sci_NewVectorIterator__f_a1 = $thiz.sci_NewVectorIterator__f_a2.get(0)
  } else if ((xor < 1048576)) {
    $thiz.sci_NewVectorIterator__f_a3 = $thiz.sci_NewVectorIterator__f_a4.get((31 & ((io >>> 15) | 0)));
    $thiz.sci_NewVectorIterator__f_a2 = $thiz.sci_NewVectorIterator__f_a3.get(0);
    $thiz.sci_NewVectorIterator__f_a1 = $thiz.sci_NewVectorIterator__f_a2.get(0)
  } else if ((xor < 33554432)) {
    $thiz.sci_NewVectorIterator__f_a4 = $thiz.sci_NewVectorIterator__f_a5.get((31 & ((io >>> 20) | 0)));
    $thiz.sci_NewVectorIterator__f_a3 = $thiz.sci_NewVectorIterator__f_a4.get(0);
    $thiz.sci_NewVectorIterator__f_a2 = $thiz.sci_NewVectorIterator__f_a3.get(0);
    $thiz.sci_NewVectorIterator__f_a1 = $thiz.sci_NewVectorIterator__f_a2.get(0)
  } else {
    $thiz.sci_NewVectorIterator__f_a5 = $thiz.sci_NewVectorIterator__f_a6.get(((io >>> 25) | 0));
    $thiz.sci_NewVectorIterator__f_a4 = $thiz.sci_NewVectorIterator__f_a5.get(0);
    $thiz.sci_NewVectorIterator__f_a3 = $thiz.sci_NewVectorIterator__f_a4.get(0);
    $thiz.sci_NewVectorIterator__f_a2 = $thiz.sci_NewVectorIterator__f_a3.get(0);
    $thiz.sci_NewVectorIterator__f_a1 = $thiz.sci_NewVectorIterator__f_a2.get(0)
  }
}
function $p_sci_NewVectorIterator__setA__I__I__V($thiz, io, xor) {
  if ((xor < 1024)) {
    $thiz.sci_NewVectorIterator__f_a1 = $thiz.sci_NewVectorIterator__f_a2.get((31 & ((io >>> 5) | 0)))
  } else if ((xor < 32768)) {
    $thiz.sci_NewVectorIterator__f_a2 = $thiz.sci_NewVectorIterator__f_a3.get((31 & ((io >>> 10) | 0)));
    $thiz.sci_NewVectorIterator__f_a1 = $thiz.sci_NewVectorIterator__f_a2.get((31 & ((io >>> 5) | 0)))
  } else if ((xor < 1048576)) {
    $thiz.sci_NewVectorIterator__f_a3 = $thiz.sci_NewVectorIterator__f_a4.get((31 & ((io >>> 15) | 0)));
    $thiz.sci_NewVectorIterator__f_a2 = $thiz.sci_NewVectorIterator__f_a3.get((31 & ((io >>> 10) | 0)));
    $thiz.sci_NewVectorIterator__f_a1 = $thiz.sci_NewVectorIterator__f_a2.get((31 & ((io >>> 5) | 0)))
  } else if ((xor < 33554432)) {
    $thiz.sci_NewVectorIterator__f_a4 = $thiz.sci_NewVectorIterator__f_a5.get((31 & ((io >>> 20) | 0)));
    $thiz.sci_NewVectorIterator__f_a3 = $thiz.sci_NewVectorIterator__f_a4.get((31 & ((io >>> 15) | 0)));
    $thiz.sci_NewVectorIterator__f_a2 = $thiz.sci_NewVectorIterator__f_a3.get((31 & ((io >>> 10) | 0)));
    $thiz.sci_NewVectorIterator__f_a1 = $thiz.sci_NewVectorIterator__f_a2.get((31 & ((io >>> 5) | 0)))
  } else {
    $thiz.sci_NewVectorIterator__f_a5 = $thiz.sci_NewVectorIterator__f_a6.get(((io >>> 25) | 0));
    $thiz.sci_NewVectorIterator__f_a4 = $thiz.sci_NewVectorIterator__f_a5.get((31 & ((io >>> 20) | 0)));
    $thiz.sci_NewVectorIterator__f_a3 = $thiz.sci_NewVectorIterator__f_a4.get((31 & ((io >>> 15) | 0)));
    $thiz.sci_NewVectorIterator__f_a2 = $thiz.sci_NewVectorIterator__f_a3.get((31 & ((io >>> 10) | 0)));
    $thiz.sci_NewVectorIterator__f_a1 = $thiz.sci_NewVectorIterator__f_a2.get((31 & ((io >>> 5) | 0)))
  }
}
/** @constructor */
function $c_sci_NewVectorIterator(v, totalLength, sliceCount) {
  this.sci_NewVectorIterator__f_v = null;
  this.sci_NewVectorIterator__f_totalLength = 0;
  this.sci_NewVectorIterator__f_sliceCount = 0;
  this.sci_NewVectorIterator__f_a1 = null;
  this.sci_NewVectorIterator__f_a2 = null;
  this.sci_NewVectorIterator__f_a3 = null;
  this.sci_NewVectorIterator__f_a4 = null;
  this.sci_NewVectorIterator__f_a5 = null;
  this.sci_NewVectorIterator__f_a6 = null;
  this.sci_NewVectorIterator__f_a1len = 0;
  this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 = 0;
  this.sci_NewVectorIterator__f_oldPos = 0;
  this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 = 0;
  this.sci_NewVectorIterator__f_sliceIdx = 0;
  this.sci_NewVectorIterator__f_sliceDim = 0;
  this.sci_NewVectorIterator__f_sliceStart = 0;
  this.sci_NewVectorIterator__f_sliceEnd = 0;
  this.sci_NewVectorIterator__f_v = v;
  this.sci_NewVectorIterator__f_totalLength = totalLength;
  this.sci_NewVectorIterator__f_sliceCount = sliceCount;
  this.sci_NewVectorIterator__f_a1 = v.sci_Vector__f_prefix1;
  this.sci_NewVectorIterator__f_a1len = this.sci_NewVectorIterator__f_a1.u.length;
  this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 = 0;
  this.sci_NewVectorIterator__f_oldPos = 0;
  this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 = this.sci_NewVectorIterator__f_totalLength;
  this.sci_NewVectorIterator__f_sliceIdx = 0;
  this.sci_NewVectorIterator__f_sliceDim = 1;
  this.sci_NewVectorIterator__f_sliceStart = 0;
  this.sci_NewVectorIterator__f_sliceEnd = this.sci_NewVectorIterator__f_a1len
}
$c_sci_NewVectorIterator.prototype = new $h_O();
$c_sci_NewVectorIterator.prototype.constructor = $c_sci_NewVectorIterator;
/** @constructor */
function $h_sci_NewVectorIterator() {
  /*<skip>*/
}
$h_sci_NewVectorIterator.prototype = $c_sci_NewVectorIterator.prototype;
$c_sci_NewVectorIterator.prototype.iterator__sc_Iterator = (function() {
  return this
});
$c_sci_NewVectorIterator.prototype.isEmpty__Z = (function() {
  return (this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 <= this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1)
});
$c_sci_NewVectorIterator.prototype.concat__F0__sc_Iterator = (function(xs) {
  return $f_sc_Iterator__concat__F0__sc_Iterator(this, xs)
});
$c_sci_NewVectorIterator.prototype.toString__T = (function() {
  return "<iterator>"
});
$c_sci_NewVectorIterator.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end)
});
$c_sci_NewVectorIterator.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2)
});
$c_sci_NewVectorIterator.prototype.knownSize__I = (function() {
  return ((this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 - this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1) | 0)
});
$c_sci_NewVectorIterator.prototype.hasNext__Z = (function() {
  return (this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 > this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1)
});
$c_sci_NewVectorIterator.prototype.next__O = (function() {
  if ((this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 === this.sci_NewVectorIterator__f_a1len)) {
    $p_sci_NewVectorIterator__advance__V(this)
  };
  var r = this.sci_NewVectorIterator__f_a1.get(this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1);
  this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 = ((1 + this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1) | 0);
  return r
});
$c_sci_NewVectorIterator.prototype.drop__I__sc_Iterator = (function(n) {
  if ((n > 0)) {
    var oldpos = ((((this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 - this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1) | 0) + this.sci_NewVectorIterator__f_totalLength) | 0);
    var a = ((oldpos + n) | 0);
    var b = this.sci_NewVectorIterator__f_totalLength;
    var newpos = ((a < b) ? a : b);
    if ((newpos === this.sci_NewVectorIterator__f_totalLength)) {
      this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 = 0;
      this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 = 0;
      this.sci_NewVectorIterator__f_a1len = 0
    } else {
      while ((newpos >= this.sci_NewVectorIterator__f_sliceEnd)) {
        $p_sci_NewVectorIterator__advanceSlice__V(this)
      };
      var io = ((newpos - this.sci_NewVectorIterator__f_sliceStart) | 0);
      if ((this.sci_NewVectorIterator__f_sliceDim > 1)) {
        var xor = (this.sci_NewVectorIterator__f_oldPos ^ io);
        $p_sci_NewVectorIterator__setA__I__I__V(this, io, xor);
        this.sci_NewVectorIterator__f_oldPos = io
      };
      this.sci_NewVectorIterator__f_a1len = this.sci_NewVectorIterator__f_a1.u.length;
      this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 = (31 & io);
      this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 = ((this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 + ((this.sci_NewVectorIterator__f_totalLength - newpos) | 0)) | 0);
      if ((this.sci_NewVectorIterator__f_a1len > this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1)) {
        this.sci_NewVectorIterator__f_a1len = this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1
      }
    }
  };
  return this
});
$c_sci_NewVectorIterator.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  var xsLen = $m_sr_ScalaRunTime$().array_length__O__I(xs);
  var srcLen = ((this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 - this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1) | 0);
  var x = ((len < srcLen) ? len : srcLen);
  var y = ((xsLen - start) | 0);
  var x$1 = ((x < y) ? x : y);
  var total = ((x$1 > 0) ? x$1 : 0);
  var copied = 0;
  var isBoxed = (xs instanceof $ac_O);
  while ((copied < total)) {
    if ((this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 === this.sci_NewVectorIterator__f_a1len)) {
      $p_sci_NewVectorIterator__advance__V(this)
    };
    var a = ((total - copied) | 0);
    var b = ((this.sci_NewVectorIterator__f_a1.u.length - this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1) | 0);
    var count = ((a < b) ? a : b);
    if (isBoxed) {
      var src = this.sci_NewVectorIterator__f_a1;
      var srcPos = this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1;
      var destPos = ((start + copied) | 0);
      $systemArraycopy(src, srcPos, xs, destPos, count)
    } else {
      $m_s_Array$().copy__O__I__O__I__I__V(this.sci_NewVectorIterator__f_a1, this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1, xs, ((start + copied) | 0), count)
    };
    this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 = ((this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 + count) | 0);
    copied = ((copied + count) | 0)
  };
  return total
});
var $d_sci_NewVectorIterator = new $TypeData().initClass({
  sci_NewVectorIterator: 0
}, false, "scala.collection.immutable.NewVectorIterator", {
  sci_NewVectorIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  jl_Cloneable: 1
});
$c_sci_NewVectorIterator.prototype.$classData = $d_sci_NewVectorIterator;
/** @constructor */
function $c_sci_Seq$() {
  this.sc_SeqFactory$Delegate__f_delegate = null;
  $ct_sc_SeqFactory$Delegate__sc_SeqFactory__(this, $m_sci_List$())
}
$c_sci_Seq$.prototype = new $h_sc_SeqFactory$Delegate();
$c_sci_Seq$.prototype.constructor = $c_sci_Seq$;
/** @constructor */
function $h_sci_Seq$() {
  /*<skip>*/
}
$h_sci_Seq$.prototype = $c_sci_Seq$.prototype;
$c_sci_Seq$.prototype.from__sc_IterableOnce__sci_Seq = (function(it) {
  if ($is_sci_Seq(it)) {
    var x2 = $as_sci_Seq(it);
    return x2
  } else {
    return $as_sci_Seq($c_sc_SeqFactory$Delegate.prototype.from__sc_IterableOnce__sc_SeqOps.call(this, it))
  }
});
$c_sci_Seq$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__sci_Seq(source)
});
$c_sci_Seq$.prototype.from__sc_IterableOnce__sc_SeqOps = (function(it) {
  return this.from__sc_IterableOnce__sci_Seq(it)
});
var $d_sci_Seq$ = new $TypeData().initClass({
  sci_Seq$: 0
}, false, "scala.collection.immutable.Seq$", {
  sci_Seq$: 1,
  sc_SeqFactory$Delegate: 1,
  O: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Seq$.prototype.$classData = $d_sci_Seq$;
var $n_sci_Seq$;
function $m_sci_Seq$() {
  if ((!$n_sci_Seq$)) {
    $n_sci_Seq$ = new $c_sci_Seq$()
  };
  return $n_sci_Seq$
}
/** @constructor */
function $c_sci_SetBuilderImpl() {
  this.sci_SetBuilderImpl__f_elems = null;
  this.sci_SetBuilderImpl__f_switchedToHashSetBuilder = false;
  this.sci_SetBuilderImpl__f_hashSetBuilder = null;
  this.sci_SetBuilderImpl__f_elems = $m_sci_Set$EmptySet$();
  this.sci_SetBuilderImpl__f_switchedToHashSetBuilder = false
}
$c_sci_SetBuilderImpl.prototype = new $h_O();
$c_sci_SetBuilderImpl.prototype.constructor = $c_sci_SetBuilderImpl;
/** @constructor */
function $h_sci_SetBuilderImpl() {
  /*<skip>*/
}
$h_sci_SetBuilderImpl.prototype = $c_sci_SetBuilderImpl.prototype;
$c_sci_SetBuilderImpl.prototype.sizeHint__I__V = (function(size) {
  /*<skip>*/
});
$c_sci_SetBuilderImpl.prototype.result__sci_Set = (function() {
  return (this.sci_SetBuilderImpl__f_switchedToHashSetBuilder ? this.sci_SetBuilderImpl__f_hashSetBuilder.result__sci_HashSet() : this.sci_SetBuilderImpl__f_elems)
});
$c_sci_SetBuilderImpl.prototype.addOne__O__sci_SetBuilderImpl = (function(elem) {
  if (this.sci_SetBuilderImpl__f_switchedToHashSetBuilder) {
    this.sci_SetBuilderImpl__f_hashSetBuilder.addOne__O__sci_HashSetBuilder(elem)
  } else if ((this.sci_SetBuilderImpl__f_elems.size__I() < 4)) {
    var this$1 = this.sci_SetBuilderImpl__f_elems;
    this.sci_SetBuilderImpl__f_elems = $as_sci_Set(this$1.incl__O__sci_SetOps(elem))
  } else if ((!this.sci_SetBuilderImpl__f_elems.contains__O__Z(elem))) {
    this.sci_SetBuilderImpl__f_switchedToHashSetBuilder = true;
    if ((this.sci_SetBuilderImpl__f_hashSetBuilder === null)) {
      this.sci_SetBuilderImpl__f_hashSetBuilder = new $c_sci_HashSetBuilder()
    };
    $as_sci_Set$Set4(this.sci_SetBuilderImpl__f_elems).buildTo__scm_Builder__scm_Builder(this.sci_SetBuilderImpl__f_hashSetBuilder);
    this.sci_SetBuilderImpl__f_hashSetBuilder.addOne__O__sci_HashSetBuilder(elem)
  };
  return this
});
$c_sci_SetBuilderImpl.prototype.addAll__sc_IterableOnce__sci_SetBuilderImpl = (function(xs) {
  return (this.sci_SetBuilderImpl__f_switchedToHashSetBuilder ? (this.sci_SetBuilderImpl__f_hashSetBuilder.addAll__sc_IterableOnce__sci_HashSetBuilder(xs), this) : $as_sci_SetBuilderImpl($f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs)))
});
$c_sci_SetBuilderImpl.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return this.addAll__sc_IterableOnce__sci_SetBuilderImpl(xs)
});
$c_sci_SetBuilderImpl.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__sci_SetBuilderImpl(elem)
});
$c_sci_SetBuilderImpl.prototype.result__O = (function() {
  return this.result__sci_Set()
});
function $as_sci_SetBuilderImpl(obj) {
  return (((obj instanceof $c_sci_SetBuilderImpl) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.SetBuilderImpl"))
}
function $isArrayOf_sci_SetBuilderImpl(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_SetBuilderImpl)))
}
function $asArrayOf_sci_SetBuilderImpl(obj, depth) {
  return (($isArrayOf_sci_SetBuilderImpl(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.SetBuilderImpl;", depth))
}
var $d_sci_SetBuilderImpl = new $TypeData().initClass({
  sci_SetBuilderImpl: 0
}, false, "scala.collection.immutable.SetBuilderImpl", {
  sci_SetBuilderImpl: 1,
  O: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
});
$c_sci_SetBuilderImpl.prototype.$classData = $d_sci_SetBuilderImpl;
/** @constructor */
function $c_sci_SetHashIterator(rootNode) {
  this.sci_ChampBaseIterator__f_currentValueCursor = 0;
  this.sci_ChampBaseIterator__f_currentValueLength = 0;
  this.sci_ChampBaseIterator__f_currentValueNode = null;
  this.sci_ChampBaseIterator__f_currentStackLevel = 0;
  this.sci_ChampBaseIterator__f_nodeCursorsAndLengths = null;
  this.sci_ChampBaseIterator__f_nodes = null;
  this.sci_SetHashIterator__f_hash = 0;
  $ct_sci_ChampBaseIterator__sci_Node__(this, rootNode);
  this.sci_SetHashIterator__f_hash = 0
}
$c_sci_SetHashIterator.prototype = new $h_sci_ChampBaseIterator();
$c_sci_SetHashIterator.prototype.constructor = $c_sci_SetHashIterator;
/** @constructor */
function $h_sci_SetHashIterator() {
  /*<skip>*/
}
$h_sci_SetHashIterator.prototype = $c_sci_SetHashIterator.prototype;
$c_sci_SetHashIterator.prototype.iterator__sc_Iterator = (function() {
  return this
});
$c_sci_SetHashIterator.prototype.isEmpty__Z = (function() {
  return (!this.hasNext__Z())
});
$c_sci_SetHashIterator.prototype.concat__F0__sc_Iterator = (function(xs) {
  return $f_sc_Iterator__concat__F0__sc_Iterator(this, xs)
});
$c_sci_SetHashIterator.prototype.drop__I__sc_Iterator = (function(n) {
  return $f_sc_Iterator__drop__I__sc_Iterator(this, n)
});
$c_sci_SetHashIterator.prototype.toString__T = (function() {
  return "<iterator>"
});
$c_sci_SetHashIterator.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len)
});
$c_sci_SetHashIterator.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end)
});
$c_sci_SetHashIterator.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2)
});
$c_sci_SetHashIterator.prototype.knownSize__I = (function() {
  return (-1)
});
$c_sci_SetHashIterator.prototype.hashCode__I = (function() {
  return this.sci_SetHashIterator__f_hash
});
$c_sci_SetHashIterator.prototype.next__O = (function() {
  if ((!this.hasNext__Z())) {
    throw $ct_ju_NoSuchElementException__(new $c_ju_NoSuchElementException())
  };
  this.sci_SetHashIterator__f_hash = this.sci_ChampBaseIterator__f_currentValueNode.getHash__I__I(this.sci_ChampBaseIterator__f_currentValueCursor);
  this.sci_ChampBaseIterator__f_currentValueCursor = ((1 + this.sci_ChampBaseIterator__f_currentValueCursor) | 0);
  return this
});
var $d_sci_SetHashIterator = new $TypeData().initClass({
  sci_SetHashIterator: 0
}, false, "scala.collection.immutable.SetHashIterator", {
  sci_SetHashIterator: 1,
  sci_ChampBaseIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sci_SetHashIterator.prototype.$classData = $d_sci_SetHashIterator;
/** @constructor */
function $c_sci_SetIterator(rootNode) {
  this.sci_ChampBaseIterator__f_currentValueCursor = 0;
  this.sci_ChampBaseIterator__f_currentValueLength = 0;
  this.sci_ChampBaseIterator__f_currentValueNode = null;
  this.sci_ChampBaseIterator__f_currentStackLevel = 0;
  this.sci_ChampBaseIterator__f_nodeCursorsAndLengths = null;
  this.sci_ChampBaseIterator__f_nodes = null;
  $ct_sci_ChampBaseIterator__sci_Node__(this, rootNode)
}
$c_sci_SetIterator.prototype = new $h_sci_ChampBaseIterator();
$c_sci_SetIterator.prototype.constructor = $c_sci_SetIterator;
/** @constructor */
function $h_sci_SetIterator() {
  /*<skip>*/
}
$h_sci_SetIterator.prototype = $c_sci_SetIterator.prototype;
$c_sci_SetIterator.prototype.iterator__sc_Iterator = (function() {
  return this
});
$c_sci_SetIterator.prototype.isEmpty__Z = (function() {
  return (!this.hasNext__Z())
});
$c_sci_SetIterator.prototype.concat__F0__sc_Iterator = (function(xs) {
  return $f_sc_Iterator__concat__F0__sc_Iterator(this, xs)
});
$c_sci_SetIterator.prototype.drop__I__sc_Iterator = (function(n) {
  return $f_sc_Iterator__drop__I__sc_Iterator(this, n)
});
$c_sci_SetIterator.prototype.toString__T = (function() {
  return "<iterator>"
});
$c_sci_SetIterator.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len)
});
$c_sci_SetIterator.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end)
});
$c_sci_SetIterator.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2)
});
$c_sci_SetIterator.prototype.knownSize__I = (function() {
  return (-1)
});
$c_sci_SetIterator.prototype.next__O = (function() {
  if ((!this.hasNext__Z())) {
    throw $ct_ju_NoSuchElementException__(new $c_ju_NoSuchElementException())
  };
  var payload = $as_sci_SetNode(this.sci_ChampBaseIterator__f_currentValueNode).getPayload__I__O(this.sci_ChampBaseIterator__f_currentValueCursor);
  this.sci_ChampBaseIterator__f_currentValueCursor = ((1 + this.sci_ChampBaseIterator__f_currentValueCursor) | 0);
  return payload
});
var $d_sci_SetIterator = new $TypeData().initClass({
  sci_SetIterator: 0
}, false, "scala.collection.immutable.SetIterator", {
  sci_SetIterator: 1,
  sci_ChampBaseIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sci_SetIterator.prototype.$classData = $d_sci_SetIterator;
function $p_sci_Vector$__liftedTree1$1__I($thiz) {
  try {
    var x = $m_jl_System$SystemProperties$().getProperty__T__T__T("scala.collection.immutable.Vector.defaultApplyPreferredMaxLength", "250");
    var this$4 = $m_jl_Integer$();
    return this$4.parseInt__T__I__I(x, 10)
  } catch (e) {
    if (false) {
      return 250
    } else {
      throw e
    }
  }
}
/** @constructor */
function $c_sci_Vector$() {
  this.sci_Vector$__f_scala$collection$immutable$Vector$$defaultApplyPreferredMaxLength = 0;
  this.sci_Vector$__f_scala$collection$immutable$Vector$$emptyIterator = null;
  $n_sci_Vector$ = this;
  this.sci_Vector$__f_scala$collection$immutable$Vector$$defaultApplyPreferredMaxLength = $p_sci_Vector$__liftedTree1$1__I(this);
  this.sci_Vector$__f_scala$collection$immutable$Vector$$emptyIterator = new $c_sci_NewVectorIterator($m_sci_Vector0$(), 0, 0)
}
$c_sci_Vector$.prototype = new $h_O();
$c_sci_Vector$.prototype.constructor = $c_sci_Vector$;
/** @constructor */
function $h_sci_Vector$() {
  /*<skip>*/
}
$h_sci_Vector$.prototype = $c_sci_Vector$.prototype;
$c_sci_Vector$.prototype.apply__sci_Seq__O = (function(elems) {
  return this.from__sc_IterableOnce__sci_Vector(elems)
});
$c_sci_Vector$.prototype.from__sc_IterableOnce__sci_Vector = (function(it) {
  if ((it instanceof $c_sci_Vector)) {
    var x2 = $as_sci_Vector(it);
    return x2
  } else {
    var knownSize = it.knownSize__I();
    if ((knownSize === 0)) {
      return $m_sci_Vector0$()
    } else if (((knownSize > 0) && (knownSize <= 32))) {
      matchEnd5: {
        var a1$3;
        if (false) {
          var x2$2 = $as_sci_ArraySeq$ofRef(it);
          var x = x2$2.elemTag__s_reflect_ClassTag();
          if (((x !== null) && x.equals__O__Z($d_O.getClassOf()))) {
            var a1$3 = x2$2.unsafeArray__AO();
            break matchEnd5
          }
        };
        if ($is_sci_Iterable(it)) {
          var x3 = $as_sci_Iterable(it);
          var a1 = new $ac_O(knownSize);
          x3.copyToArray__O__I__I__I(a1, 0, 2147483647);
          var a1$3 = a1;
          break matchEnd5
        };
        var a1$2 = new $ac_O(knownSize);
        var this$1 = it.iterator__sc_Iterator();
        this$1.copyToArray__O__I__I__I(a1$2, 0, 2147483647);
        var a1$3 = a1$2
      };
      return new $c_sci_Vector1(a1$3)
    } else {
      var this$2 = new $c_sci_VectorBuilder();
      var this$3 = this$2.addAll__sc_IterableOnce__sci_VectorBuilder(it);
      return this$3.result__sci_Vector()
    }
  }
});
$c_sci_Vector$.prototype.newBuilder__scm_Builder = (function() {
  return new $c_sci_VectorBuilder()
});
$c_sci_Vector$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__sci_Vector(source)
});
$c_sci_Vector$.prototype.empty__O = (function() {
  return $m_sci_Vector0$()
});
var $d_sci_Vector$ = new $TypeData().initClass({
  sci_Vector$: 0
}, false, "scala.collection.immutable.Vector$", {
  sci_Vector$: 1,
  O: 1,
  sc_StrictOptimizedSeqFactory: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Vector$.prototype.$classData = $d_sci_Vector$;
var $n_sci_Vector$;
function $m_sci_Vector$() {
  if ((!$n_sci_Vector$)) {
    $n_sci_Vector$ = new $c_sci_Vector$()
  };
  return $n_sci_Vector$
}
function $p_sci_VectorBuilder__addArr1__AO__V($thiz, data) {
  var dl = data.u.length;
  if ((dl > 0)) {
    if (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 === 32)) {
      $p_sci_VectorBuilder__advance__V($thiz)
    };
    var a = ((32 - $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1) | 0);
    var copy1 = ((a < dl) ? a : dl);
    var copy2 = ((dl - copy1) | 0);
    var dest = $thiz.sci_VectorBuilder__f_a1;
    var destPos = $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1;
    $systemArraycopy(data, 0, dest, destPos, copy1);
    $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 + copy1) | 0);
    if ((copy2 > 0)) {
      $p_sci_VectorBuilder__advance__V($thiz);
      var dest$1 = $thiz.sci_VectorBuilder__f_a1;
      $systemArraycopy(data, copy1, dest$1, 0, copy2);
      $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 + copy2) | 0)
    }
  }
}
function $p_sci_VectorBuilder__addVector__sci_Vector__sci_VectorBuilder($thiz, xs) {
  var sliceCount = xs.vectorSliceCount__I();
  var sliceIdx = 0;
  while ((sliceIdx < sliceCount)) {
    var slice = xs.vectorSlice__I__AO(sliceIdx);
    var idx = sliceIdx;
    var c = ((sliceCount / 2) | 0);
    var a = ((idx - c) | 0);
    var x1 = ((((1 + c) | 0) - ((a < 0) ? ((-a) | 0) : a)) | 0);
    if ((x1 === 1)) {
      $p_sci_VectorBuilder__addArr1__AO__V($thiz, slice)
    } else {
      $m_sci_VectorStatics$().foreachRec__I__AO__F1__V((((-2) + x1) | 0), slice, new $c_sjsr_AnonFunction1((function(this$3) {
        return (function(data$2) {
          var data = $asArrayOf_O(data$2, 1);
          $p_sci_VectorBuilder__addArr1__AO__V(this$3, data)
        })
      })($thiz)))
    };
    sliceIdx = ((1 + sliceIdx) | 0)
  };
  return $thiz
}
function $p_sci_VectorBuilder__advance__V($thiz) {
  var idx = ((32 + $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest) | 0);
  var xor = (idx ^ $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest);
  $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = idx;
  $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = 0;
  $p_sci_VectorBuilder__advance1__I__I__V($thiz, idx, xor)
}
function $p_sci_VectorBuilder__advance1__I__I__V($thiz, idx, xor) {
  if ((xor < 1024)) {
    if (($thiz.sci_VectorBuilder__f_depth === 1)) {
      $thiz.sci_VectorBuilder__f_a2 = new ($d_O.getArrayOf().getArrayOf().constr)(32);
      $thiz.sci_VectorBuilder__f_a2.set(0, $thiz.sci_VectorBuilder__f_a1);
      $thiz.sci_VectorBuilder__f_depth = ((1 + $thiz.sci_VectorBuilder__f_depth) | 0)
    };
    $thiz.sci_VectorBuilder__f_a1 = new $ac_O(32);
    $thiz.sci_VectorBuilder__f_a2.set((31 & ((idx >>> 5) | 0)), $thiz.sci_VectorBuilder__f_a1)
  } else if ((xor < 32768)) {
    if (($thiz.sci_VectorBuilder__f_depth === 2)) {
      $thiz.sci_VectorBuilder__f_a3 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().constr)(32);
      $thiz.sci_VectorBuilder__f_a3.set(0, $thiz.sci_VectorBuilder__f_a2);
      $thiz.sci_VectorBuilder__f_depth = ((1 + $thiz.sci_VectorBuilder__f_depth) | 0)
    };
    $thiz.sci_VectorBuilder__f_a1 = new $ac_O(32);
    $thiz.sci_VectorBuilder__f_a2 = new ($d_O.getArrayOf().getArrayOf().constr)(32);
    $thiz.sci_VectorBuilder__f_a2.set((31 & ((idx >>> 5) | 0)), $thiz.sci_VectorBuilder__f_a1);
    $thiz.sci_VectorBuilder__f_a3.set((31 & ((idx >>> 10) | 0)), $thiz.sci_VectorBuilder__f_a2)
  } else if ((xor < 1048576)) {
    if (($thiz.sci_VectorBuilder__f_depth === 3)) {
      $thiz.sci_VectorBuilder__f_a4 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(32);
      $thiz.sci_VectorBuilder__f_a4.set(0, $thiz.sci_VectorBuilder__f_a3);
      $thiz.sci_VectorBuilder__f_depth = ((1 + $thiz.sci_VectorBuilder__f_depth) | 0)
    };
    $thiz.sci_VectorBuilder__f_a1 = new $ac_O(32);
    $thiz.sci_VectorBuilder__f_a2 = new ($d_O.getArrayOf().getArrayOf().constr)(32);
    $thiz.sci_VectorBuilder__f_a3 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().constr)(32);
    $thiz.sci_VectorBuilder__f_a2.set((31 & ((idx >>> 5) | 0)), $thiz.sci_VectorBuilder__f_a1);
    $thiz.sci_VectorBuilder__f_a3.set((31 & ((idx >>> 10) | 0)), $thiz.sci_VectorBuilder__f_a2);
    $thiz.sci_VectorBuilder__f_a4.set((31 & ((idx >>> 15) | 0)), $thiz.sci_VectorBuilder__f_a3)
  } else if ((xor < 33554432)) {
    if (($thiz.sci_VectorBuilder__f_depth === 4)) {
      $thiz.sci_VectorBuilder__f_a5 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(32);
      $thiz.sci_VectorBuilder__f_a5.set(0, $thiz.sci_VectorBuilder__f_a4);
      $thiz.sci_VectorBuilder__f_depth = ((1 + $thiz.sci_VectorBuilder__f_depth) | 0)
    };
    $thiz.sci_VectorBuilder__f_a1 = new $ac_O(32);
    $thiz.sci_VectorBuilder__f_a2 = new ($d_O.getArrayOf().getArrayOf().constr)(32);
    $thiz.sci_VectorBuilder__f_a3 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().constr)(32);
    $thiz.sci_VectorBuilder__f_a4 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(32);
    $thiz.sci_VectorBuilder__f_a2.set((31 & ((idx >>> 5) | 0)), $thiz.sci_VectorBuilder__f_a1);
    $thiz.sci_VectorBuilder__f_a3.set((31 & ((idx >>> 10) | 0)), $thiz.sci_VectorBuilder__f_a2);
    $thiz.sci_VectorBuilder__f_a4.set((31 & ((idx >>> 15) | 0)), $thiz.sci_VectorBuilder__f_a3);
    $thiz.sci_VectorBuilder__f_a5.set((31 & ((idx >>> 20) | 0)), $thiz.sci_VectorBuilder__f_a4)
  } else if ((xor < 1073741824)) {
    if (($thiz.sci_VectorBuilder__f_depth === 5)) {
      $thiz.sci_VectorBuilder__f_a6 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(64);
      $thiz.sci_VectorBuilder__f_a6.set(0, $thiz.sci_VectorBuilder__f_a5);
      $thiz.sci_VectorBuilder__f_depth = ((1 + $thiz.sci_VectorBuilder__f_depth) | 0)
    };
    $thiz.sci_VectorBuilder__f_a1 = new $ac_O(32);
    $thiz.sci_VectorBuilder__f_a2 = new ($d_O.getArrayOf().getArrayOf().constr)(32);
    $thiz.sci_VectorBuilder__f_a3 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().constr)(32);
    $thiz.sci_VectorBuilder__f_a4 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(32);
    $thiz.sci_VectorBuilder__f_a5 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(32);
    $thiz.sci_VectorBuilder__f_a2.set((31 & ((idx >>> 5) | 0)), $thiz.sci_VectorBuilder__f_a1);
    $thiz.sci_VectorBuilder__f_a3.set((31 & ((idx >>> 10) | 0)), $thiz.sci_VectorBuilder__f_a2);
    $thiz.sci_VectorBuilder__f_a4.set((31 & ((idx >>> 15) | 0)), $thiz.sci_VectorBuilder__f_a3);
    $thiz.sci_VectorBuilder__f_a5.set((31 & ((idx >>> 20) | 0)), $thiz.sci_VectorBuilder__f_a4);
    $thiz.sci_VectorBuilder__f_a6.set((31 & ((idx >>> 25) | 0)), $thiz.sci_VectorBuilder__f_a5)
  } else {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((((((((((((((((("advance1(" + idx) + ", ") + xor) + "): a1=") + $thiz.sci_VectorBuilder__f_a1) + ", a2=") + $thiz.sci_VectorBuilder__f_a2) + ", a3=") + $thiz.sci_VectorBuilder__f_a3) + ", a4=") + $thiz.sci_VectorBuilder__f_a4) + ", a5=") + $thiz.sci_VectorBuilder__f_a5) + ", a6=") + $thiz.sci_VectorBuilder__f_a6) + ", depth=") + $thiz.sci_VectorBuilder__f_depth))
  }
}
/** @constructor */
function $c_sci_VectorBuilder() {
  this.sci_VectorBuilder__f_a6 = null;
  this.sci_VectorBuilder__f_a5 = null;
  this.sci_VectorBuilder__f_a4 = null;
  this.sci_VectorBuilder__f_a3 = null;
  this.sci_VectorBuilder__f_a2 = null;
  this.sci_VectorBuilder__f_a1 = null;
  this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = 0;
  this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = 0;
  this.sci_VectorBuilder__f_offset = 0;
  this.sci_VectorBuilder__f_depth = 0;
  this.sci_VectorBuilder__f_a1 = new $ac_O(32);
  this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = 0;
  this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = 0;
  this.sci_VectorBuilder__f_offset = 0;
  this.sci_VectorBuilder__f_depth = 1
}
$c_sci_VectorBuilder.prototype = new $h_O();
$c_sci_VectorBuilder.prototype.constructor = $c_sci_VectorBuilder;
/** @constructor */
function $h_sci_VectorBuilder() {
  /*<skip>*/
}
$h_sci_VectorBuilder.prototype = $c_sci_VectorBuilder.prototype;
$c_sci_VectorBuilder.prototype.sizeHint__I__V = (function(size) {
  /*<skip>*/
});
$c_sci_VectorBuilder.prototype.initFrom__AO__V = (function(prefix1) {
  this.sci_VectorBuilder__f_depth = 1;
  var i = prefix1.u.length;
  this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = (31 & i);
  this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = ((i - this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1) | 0);
  this.sci_VectorBuilder__f_a1 = ((prefix1.u.length === 32) ? prefix1 : $m_ju_Arrays$().copyOfRange__AO__I__I__AO(prefix1, 0, 32));
  if (((this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 === 0) && (this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest > 0))) {
    this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = 32;
    this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = (((-32) + this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest) | 0)
  }
});
$c_sci_VectorBuilder.prototype.initFrom__sci_Vector__sci_VectorBuilder = (function(v) {
  var x1 = v.vectorSliceCount__I();
  switch (x1) {
    case 0: {
      break
    }
    case 1: {
      var v1 = $as_sci_Vector1(v);
      this.sci_VectorBuilder__f_depth = 1;
      var i = v1.sci_Vector__f_prefix1.u.length;
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = (31 & i);
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = ((i - this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1) | 0);
      var a = v1.sci_Vector__f_prefix1;
      this.sci_VectorBuilder__f_a1 = ((a.u.length === 32) ? a : $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a, 0, 32));
      break
    }
    case 3: {
      var v2 = $as_sci_Vector2(v);
      var d2 = v2.sci_Vector2__f_data2;
      var a$1 = v2.sci_BigVector__f_suffix1;
      this.sci_VectorBuilder__f_a1 = ((a$1.u.length === 32) ? a$1 : $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$1, 0, 32));
      this.sci_VectorBuilder__f_depth = 2;
      this.sci_VectorBuilder__f_offset = ((32 - v2.sci_Vector2__f_len1) | 0);
      var i$1 = ((v2.sci_BigVector__f_length0 + this.sci_VectorBuilder__f_offset) | 0);
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = (31 & i$1);
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = ((i$1 - this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1) | 0);
      this.sci_VectorBuilder__f_a2 = new ($d_O.getArrayOf().getArrayOf().constr)(32);
      this.sci_VectorBuilder__f_a2.set(0, v2.sci_Vector__f_prefix1);
      var dest = this.sci_VectorBuilder__f_a2;
      var length = d2.u.length;
      $systemArraycopy(d2, 0, dest, 1, length);
      this.sci_VectorBuilder__f_a2.set(((1 + d2.u.length) | 0), this.sci_VectorBuilder__f_a1);
      break
    }
    case 5: {
      var v3 = $as_sci_Vector3(v);
      var d3 = v3.sci_Vector3__f_data3;
      var s2 = v3.sci_Vector3__f_suffix2;
      var a$2 = v3.sci_BigVector__f_suffix1;
      this.sci_VectorBuilder__f_a1 = ((a$2.u.length === 32) ? a$2 : $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$2, 0, 32));
      this.sci_VectorBuilder__f_depth = 3;
      this.sci_VectorBuilder__f_offset = ((1024 - v3.sci_Vector3__f_len12) | 0);
      var i$2 = ((v3.sci_BigVector__f_length0 + this.sci_VectorBuilder__f_offset) | 0);
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = (31 & i$2);
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = ((i$2 - this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1) | 0);
      this.sci_VectorBuilder__f_a3 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().constr)(32);
      this.sci_VectorBuilder__f_a3.set(0, $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO(v3.sci_Vector__f_prefix1, v3.sci_Vector3__f_prefix2), 2));
      var dest$1 = this.sci_VectorBuilder__f_a3;
      var length$1 = d3.u.length;
      $systemArraycopy(d3, 0, dest$1, 1, length$1);
      this.sci_VectorBuilder__f_a2 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(s2, 32), 2);
      this.sci_VectorBuilder__f_a3.set(((1 + d3.u.length) | 0), this.sci_VectorBuilder__f_a2);
      this.sci_VectorBuilder__f_a2.set(s2.u.length, this.sci_VectorBuilder__f_a1);
      break
    }
    case 7: {
      var v4 = $as_sci_Vector4(v);
      var d4 = v4.sci_Vector4__f_data4;
      var s3 = v4.sci_Vector4__f_suffix3;
      var s2$2 = v4.sci_Vector4__f_suffix2;
      var a$3 = v4.sci_BigVector__f_suffix1;
      this.sci_VectorBuilder__f_a1 = ((a$3.u.length === 32) ? a$3 : $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$3, 0, 32));
      this.sci_VectorBuilder__f_depth = 4;
      this.sci_VectorBuilder__f_offset = ((32768 - v4.sci_Vector4__f_len123) | 0);
      var i$3 = ((v4.sci_BigVector__f_length0 + this.sci_VectorBuilder__f_offset) | 0);
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = (31 & i$3);
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = ((i$3 - this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1) | 0);
      this.sci_VectorBuilder__f_a4 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(32);
      this.sci_VectorBuilder__f_a4.set(0, $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(v4.sci_Vector__f_prefix1, v4.sci_Vector4__f_prefix2), v4.sci_Vector4__f_prefix3), 3));
      var dest$2 = this.sci_VectorBuilder__f_a4;
      var length$2 = d4.u.length;
      $systemArraycopy(d4, 0, dest$2, 1, length$2);
      this.sci_VectorBuilder__f_a3 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(s3, 32), 3);
      this.sci_VectorBuilder__f_a2 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(s2$2, 32), 2);
      this.sci_VectorBuilder__f_a4.set(((1 + d4.u.length) | 0), this.sci_VectorBuilder__f_a3);
      this.sci_VectorBuilder__f_a3.set(s3.u.length, this.sci_VectorBuilder__f_a2);
      this.sci_VectorBuilder__f_a2.set(s2$2.u.length, this.sci_VectorBuilder__f_a1);
      break
    }
    case 9: {
      var v5 = $as_sci_Vector5(v);
      var d5 = v5.sci_Vector5__f_data5;
      var s4 = v5.sci_Vector5__f_suffix4;
      var s3$2 = v5.sci_Vector5__f_suffix3;
      var s2$3 = v5.sci_Vector5__f_suffix2;
      var a$4 = v5.sci_BigVector__f_suffix1;
      this.sci_VectorBuilder__f_a1 = ((a$4.u.length === 32) ? a$4 : $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$4, 0, 32));
      this.sci_VectorBuilder__f_depth = 5;
      this.sci_VectorBuilder__f_offset = ((1048576 - v5.sci_Vector5__f_len1234) | 0);
      var i$4 = ((v5.sci_BigVector__f_length0 + this.sci_VectorBuilder__f_offset) | 0);
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = (31 & i$4);
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = ((i$4 - this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1) | 0);
      this.sci_VectorBuilder__f_a5 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(32);
      this.sci_VectorBuilder__f_a5.set(0, $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(v5.sci_Vector__f_prefix1, v5.sci_Vector5__f_prefix2), v5.sci_Vector5__f_prefix3), v5.sci_Vector5__f_prefix4), 4));
      var dest$3 = this.sci_VectorBuilder__f_a5;
      var length$3 = d5.u.length;
      $systemArraycopy(d5, 0, dest$3, 1, length$3);
      this.sci_VectorBuilder__f_a4 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(s4, 32), 4);
      this.sci_VectorBuilder__f_a3 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(s3$2, 32), 3);
      this.sci_VectorBuilder__f_a2 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(s2$3, 32), 2);
      this.sci_VectorBuilder__f_a5.set(((1 + d5.u.length) | 0), this.sci_VectorBuilder__f_a4);
      this.sci_VectorBuilder__f_a4.set(s4.u.length, this.sci_VectorBuilder__f_a3);
      this.sci_VectorBuilder__f_a3.set(s3$2.u.length, this.sci_VectorBuilder__f_a2);
      this.sci_VectorBuilder__f_a2.set(s2$3.u.length, this.sci_VectorBuilder__f_a1);
      break
    }
    case 11: {
      var v6 = $as_sci_Vector6(v);
      var d6 = v6.sci_Vector6__f_data6;
      var s5 = v6.sci_Vector6__f_suffix5;
      var s4$2 = v6.sci_Vector6__f_suffix4;
      var s3$3 = v6.sci_Vector6__f_suffix3;
      var s2$4 = v6.sci_Vector6__f_suffix2;
      var a$5 = v6.sci_BigVector__f_suffix1;
      this.sci_VectorBuilder__f_a1 = ((a$5.u.length === 32) ? a$5 : $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$5, 0, 32));
      this.sci_VectorBuilder__f_depth = 6;
      this.sci_VectorBuilder__f_offset = ((33554432 - v6.sci_Vector6__f_len12345) | 0);
      var i$5 = ((v6.sci_BigVector__f_length0 + this.sci_VectorBuilder__f_offset) | 0);
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = (31 & i$5);
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = ((i$5 - this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1) | 0);
      this.sci_VectorBuilder__f_a6 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(32);
      this.sci_VectorBuilder__f_a6.set(0, $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(v6.sci_Vector__f_prefix1, v6.sci_Vector6__f_prefix2), v6.sci_Vector6__f_prefix3), v6.sci_Vector6__f_prefix4), v6.sci_Vector6__f_prefix5), 5));
      var dest$4 = this.sci_VectorBuilder__f_a6;
      var length$4 = d6.u.length;
      $systemArraycopy(d6, 0, dest$4, 1, length$4);
      this.sci_VectorBuilder__f_a5 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(s5, 32), 5);
      this.sci_VectorBuilder__f_a4 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(s4$2, 32), 4);
      this.sci_VectorBuilder__f_a3 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(s3$3, 32), 3);
      this.sci_VectorBuilder__f_a2 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(s2$4, 32), 2);
      this.sci_VectorBuilder__f_a6.set(((1 + d6.u.length) | 0), this.sci_VectorBuilder__f_a5);
      this.sci_VectorBuilder__f_a5.set(s5.u.length, this.sci_VectorBuilder__f_a4);
      this.sci_VectorBuilder__f_a4.set(s4$2.u.length, this.sci_VectorBuilder__f_a3);
      this.sci_VectorBuilder__f_a3.set(s3$3.u.length, this.sci_VectorBuilder__f_a2);
      this.sci_VectorBuilder__f_a2.set(s2$4.u.length, this.sci_VectorBuilder__f_a1);
      break
    }
    default: {
      throw new $c_s_MatchError(x1)
    }
  };
  if (((this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 === 0) && (this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest > 0))) {
    this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = 32;
    this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = (((-32) + this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest) | 0)
  };
  return this
});
$c_sci_VectorBuilder.prototype.addOne__O__sci_VectorBuilder = (function(elem) {
  if ((this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 === 32)) {
    $p_sci_VectorBuilder__advance__V(this)
  };
  this.sci_VectorBuilder__f_a1.set(this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1, elem);
  this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = ((1 + this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1) | 0);
  return this
});
$c_sci_VectorBuilder.prototype.addAll__sc_IterableOnce__sci_VectorBuilder = (function(xs) {
  if ((xs instanceof $c_sci_Vector)) {
    var x2 = $as_sci_Vector(xs);
    return (((this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 === 0) && (this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest === 0)) ? this.initFrom__sci_Vector__sci_VectorBuilder(x2) : $p_sci_VectorBuilder__addVector__sci_Vector__sci_VectorBuilder(this, x2))
  } else {
    return $as_sci_VectorBuilder($f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs))
  }
});
$c_sci_VectorBuilder.prototype.result__sci_Vector = (function() {
  var len = ((this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 + this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest) | 0);
  var realLen = ((len - this.sci_VectorBuilder__f_offset) | 0);
  if ((realLen === 0)) {
    $m_sci_Vector$();
    return $m_sci_Vector0$()
  } else if ((len <= 32)) {
    if ((realLen === 32)) {
      return new $c_sci_Vector1(this.sci_VectorBuilder__f_a1)
    } else {
      var original = this.sci_VectorBuilder__f_a1;
      return new $c_sci_Vector1($m_ju_Arrays$().copyOf__AO__I__AO(original, realLen))
    }
  } else if ((len <= 1024)) {
    var i1 = (31 & (((-1) + len) | 0));
    var i2 = (((((-1) + len) | 0) >>> 5) | 0);
    var original$1 = this.sci_VectorBuilder__f_a2;
    var data = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(original$1, 1, i2), 2);
    var prefix1 = this.sci_VectorBuilder__f_a2.get(0);
    var a = this.sci_VectorBuilder__f_a2.get(i2);
    var len$1 = ((1 + i1) | 0);
    var suffix1 = ((a.u.length === len$1) ? a : $m_ju_Arrays$().copyOf__AO__I__AO(a, len$1));
    return new $c_sci_Vector2(prefix1, ((32 - this.sci_VectorBuilder__f_offset) | 0), data, suffix1, realLen)
  } else if ((len <= 32768)) {
    var i1$2 = (31 & (((-1) + len) | 0));
    var i2$2 = (31 & (((((-1) + len) | 0) >>> 5) | 0));
    var i3 = (((((-1) + len) | 0) >>> 10) | 0);
    var original$2 = this.sci_VectorBuilder__f_a3;
    var data$2 = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(original$2, 1, i3), 3);
    var a$1 = this.sci_VectorBuilder__f_a3.get(0);
    var to = a$1.u.length;
    var prefix2 = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$1, 1, to), 2);
    var prefix1$2 = this.sci_VectorBuilder__f_a3.get(0).get(0);
    var original$3 = this.sci_VectorBuilder__f_a3.get(i3);
    var suffix2 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(original$3, i2$2), 2);
    var a$2 = this.sci_VectorBuilder__f_a3.get(i3).get(i2$2);
    var len$2 = ((1 + i1$2) | 0);
    var suffix1$2 = ((a$2.u.length === len$2) ? a$2 : $m_ju_Arrays$().copyOf__AO__I__AO(a$2, len$2));
    var len1 = prefix1$2.u.length;
    var len12 = ((len1 + (prefix2.u.length << 5)) | 0);
    return new $c_sci_Vector3(prefix1$2, len1, prefix2, len12, data$2, suffix2, suffix1$2, realLen)
  } else if ((len <= 1048576)) {
    var i1$3 = (31 & (((-1) + len) | 0));
    var i2$3 = (31 & (((((-1) + len) | 0) >>> 5) | 0));
    var i3$2 = (31 & (((((-1) + len) | 0) >>> 10) | 0));
    var i4 = (((((-1) + len) | 0) >>> 15) | 0);
    var original$4 = this.sci_VectorBuilder__f_a4;
    var data$3 = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(original$4, 1, i4), 4);
    var a$3 = this.sci_VectorBuilder__f_a4.get(0);
    var to$1 = a$3.u.length;
    var prefix3 = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$3, 1, to$1), 3);
    var a$4 = this.sci_VectorBuilder__f_a4.get(0).get(0);
    var to$2 = a$4.u.length;
    var prefix2$2 = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$4, 1, to$2), 2);
    var prefix1$3 = this.sci_VectorBuilder__f_a4.get(0).get(0).get(0);
    var original$5 = this.sci_VectorBuilder__f_a4.get(i4);
    var suffix3 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(original$5, i3$2), 3);
    var original$6 = this.sci_VectorBuilder__f_a4.get(i4).get(i3$2);
    var suffix2$2 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(original$6, i2$3), 2);
    var a$5 = this.sci_VectorBuilder__f_a4.get(i4).get(i3$2).get(i2$3);
    var len$3 = ((1 + i1$3) | 0);
    var suffix1$3 = ((a$5.u.length === len$3) ? a$5 : $m_ju_Arrays$().copyOf__AO__I__AO(a$5, len$3));
    var len1$2 = prefix1$3.u.length;
    var len12$2 = ((len1$2 + (prefix2$2.u.length << 5)) | 0);
    var len123 = ((len12$2 + (prefix3.u.length << 10)) | 0);
    return new $c_sci_Vector4(prefix1$3, len1$2, prefix2$2, len12$2, prefix3, len123, data$3, suffix3, suffix2$2, suffix1$3, realLen)
  } else if ((len <= 33554432)) {
    var i1$4 = (31 & (((-1) + len) | 0));
    var i2$4 = (31 & (((((-1) + len) | 0) >>> 5) | 0));
    var i3$3 = (31 & (((((-1) + len) | 0) >>> 10) | 0));
    var i4$2 = (31 & (((((-1) + len) | 0) >>> 15) | 0));
    var i5 = (((((-1) + len) | 0) >>> 20) | 0);
    var original$7 = this.sci_VectorBuilder__f_a5;
    var data$4 = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(original$7, 1, i5), 5);
    var a$6 = this.sci_VectorBuilder__f_a5.get(0);
    var to$3 = a$6.u.length;
    var prefix4 = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$6, 1, to$3), 4);
    var a$7 = this.sci_VectorBuilder__f_a5.get(0).get(0);
    var to$4 = a$7.u.length;
    var prefix3$2 = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$7, 1, to$4), 3);
    var a$8 = this.sci_VectorBuilder__f_a5.get(0).get(0).get(0);
    var to$5 = a$8.u.length;
    var prefix2$3 = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$8, 1, to$5), 2);
    var prefix1$4 = this.sci_VectorBuilder__f_a5.get(0).get(0).get(0).get(0);
    var original$8 = this.sci_VectorBuilder__f_a5.get(i5);
    var suffix4 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(original$8, i4$2), 4);
    var original$9 = this.sci_VectorBuilder__f_a5.get(i5).get(i4$2);
    var suffix3$2 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(original$9, i3$3), 3);
    var original$10 = this.sci_VectorBuilder__f_a5.get(i5).get(i4$2).get(i3$3);
    var suffix2$3 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(original$10, i2$4), 2);
    var a$9 = this.sci_VectorBuilder__f_a5.get(i5).get(i4$2).get(i3$3).get(i2$4);
    var len$4 = ((1 + i1$4) | 0);
    var suffix1$4 = ((a$9.u.length === len$4) ? a$9 : $m_ju_Arrays$().copyOf__AO__I__AO(a$9, len$4));
    var len1$3 = prefix1$4.u.length;
    var len12$3 = ((len1$3 + (prefix2$3.u.length << 5)) | 0);
    var len123$2 = ((len12$3 + (prefix3$2.u.length << 10)) | 0);
    var len1234 = ((len123$2 + (prefix4.u.length << 15)) | 0);
    return new $c_sci_Vector5(prefix1$4, len1$3, prefix2$3, len12$3, prefix3$2, len123$2, prefix4, len1234, data$4, suffix4, suffix3$2, suffix2$3, suffix1$4, realLen)
  } else {
    var i1$5 = (31 & (((-1) + len) | 0));
    var i2$5 = (31 & (((((-1) + len) | 0) >>> 5) | 0));
    var i3$4 = (31 & (((((-1) + len) | 0) >>> 10) | 0));
    var i4$3 = (31 & (((((-1) + len) | 0) >>> 15) | 0));
    var i5$2 = (31 & (((((-1) + len) | 0) >>> 20) | 0));
    var i6 = (((((-1) + len) | 0) >>> 25) | 0);
    var original$11 = this.sci_VectorBuilder__f_a6;
    var data$5 = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(original$11, 1, i6), 6);
    var a$10 = this.sci_VectorBuilder__f_a6.get(0);
    var to$6 = a$10.u.length;
    var prefix5 = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$10, 1, to$6), 5);
    var a$11 = this.sci_VectorBuilder__f_a6.get(0).get(0);
    var to$7 = a$11.u.length;
    var prefix4$2 = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$11, 1, to$7), 4);
    var a$12 = this.sci_VectorBuilder__f_a6.get(0).get(0).get(0);
    var to$8 = a$12.u.length;
    var prefix3$3 = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$12, 1, to$8), 3);
    var a$13 = this.sci_VectorBuilder__f_a6.get(0).get(0).get(0).get(0);
    var to$9 = a$13.u.length;
    var prefix2$4 = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$13, 1, to$9), 2);
    var prefix1$5 = this.sci_VectorBuilder__f_a6.get(0).get(0).get(0).get(0).get(0);
    var original$12 = this.sci_VectorBuilder__f_a6.get(i6);
    var suffix5 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(original$12, i5$2), 5);
    var original$13 = this.sci_VectorBuilder__f_a6.get(i6).get(i5$2);
    var suffix4$2 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(original$13, i4$3), 4);
    var original$14 = this.sci_VectorBuilder__f_a6.get(i6).get(i5$2).get(i4$3);
    var suffix3$3 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(original$14, i3$4), 3);
    var original$15 = this.sci_VectorBuilder__f_a6.get(i6).get(i5$2).get(i4$3).get(i3$4);
    var suffix2$4 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(original$15, i2$5), 2);
    var a$14 = this.sci_VectorBuilder__f_a6.get(i6).get(i5$2).get(i4$3).get(i3$4).get(i2$5);
    var len$5 = ((1 + i1$5) | 0);
    var suffix1$5 = ((a$14.u.length === len$5) ? a$14 : $m_ju_Arrays$().copyOf__AO__I__AO(a$14, len$5));
    var len1$4 = prefix1$5.u.length;
    var len12$4 = ((len1$4 + (prefix2$4.u.length << 5)) | 0);
    var len123$3 = ((len12$4 + (prefix3$3.u.length << 10)) | 0);
    var len1234$2 = ((len123$3 + (prefix4$2.u.length << 15)) | 0);
    var len12345 = ((len1234$2 + (prefix5.u.length << 20)) | 0);
    return new $c_sci_Vector6(prefix1$5, len1$4, prefix2$4, len12$4, prefix3$3, len123$3, prefix4$2, len1234$2, prefix5, len12345, data$5, suffix5, suffix4$2, suffix3$3, suffix2$4, suffix1$5, realLen)
  }
});
$c_sci_VectorBuilder.prototype.toString__T = (function() {
  return (((((((("VectorBuilder(len1=" + this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1) + ", lenRest=") + this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest) + ", offset=") + this.sci_VectorBuilder__f_offset) + ", depth=") + this.sci_VectorBuilder__f_depth) + ")")
});
$c_sci_VectorBuilder.prototype.result__O = (function() {
  return this.result__sci_Vector()
});
$c_sci_VectorBuilder.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return this.addAll__sc_IterableOnce__sci_VectorBuilder(xs)
});
$c_sci_VectorBuilder.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__sci_VectorBuilder(elem)
});
function $as_sci_VectorBuilder(obj) {
  return (((obj instanceof $c_sci_VectorBuilder) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.VectorBuilder"))
}
function $isArrayOf_sci_VectorBuilder(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_VectorBuilder)))
}
function $asArrayOf_sci_VectorBuilder(obj, depth) {
  return (($isArrayOf_sci_VectorBuilder(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.VectorBuilder;", depth))
}
var $d_sci_VectorBuilder = new $TypeData().initClass({
  sci_VectorBuilder: 0
}, false, "scala.collection.immutable.VectorBuilder", {
  sci_VectorBuilder: 1,
  O: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
});
$c_sci_VectorBuilder.prototype.$classData = $d_sci_VectorBuilder;
function $p_scm_ArrayBuffer$__growArray$1__J__I__I__AO__AO($thiz, arrayLength$1, n$1, end$1, array$1) {
  var lo = arrayLength$1.RTLong__f_lo;
  var lo$1 = (lo << 1);
  var hi = (((lo >>> 31) | 0) | (arrayLength$1.RTLong__f_hi << 1));
  var t = (((hi === 0) ? (((-2147483648) ^ lo$1) > (-2147483632)) : (hi > 0)) ? new $c_RTLong(lo$1, hi) : new $c_RTLong(16, 0));
  var lo$2 = t.RTLong__f_lo;
  var hi$1 = t.RTLong__f_hi;
  var newSize__lo = lo$2;
  var newSize__hi = hi$1;
  while (true) {
    var hi$2 = (n$1 >> 31);
    var b__lo = newSize__lo;
    var b__hi = newSize__hi;
    var bhi = b__hi;
    if (((hi$2 === bhi) ? (((-2147483648) ^ n$1) > ((-2147483648) ^ b__lo)) : (hi$2 > bhi))) {
      var this$4__lo = newSize__lo;
      var this$4__hi = newSize__hi;
      var lo$3 = this$4__lo;
      var lo$4 = (lo$3 << 1);
      var hi$3 = (((lo$3 >>> 31) | 0) | (this$4__hi << 1));
      var $$x1__lo = lo$4;
      var $$x1__hi = hi$3;
      newSize__lo = $$x1__lo;
      newSize__hi = $$x1__hi
    } else {
      break
    }
  };
  var this$5__lo = newSize__lo;
  var this$5__hi = newSize__hi;
  var ahi = this$5__hi;
  if (((ahi === 0) ? (((-2147483648) ^ this$5__lo) > (-1)) : (ahi > 0))) {
    if ((end$1 === 2147483647)) {
      throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O($ct_jl_Exception__T__(new $c_jl_Exception(), "Collections can not have more than 2147483647 elements"))
    };
    var $$x2__lo = 2147483647;
    var $$x2__hi = 0;
    newSize__lo = $$x2__lo;
    newSize__hi = $$x2__hi
  };
  var this$6__lo = newSize__lo;
  var this$6__hi = newSize__hi;
  var newArray = new $ac_O(this$6__lo);
  $m_s_Array$().copy__O__I__O__I__I__V(array$1, 0, newArray, 0, end$1);
  return newArray
}
/** @constructor */
function $c_scm_ArrayBuffer$() {
  /*<skip>*/
}
$c_scm_ArrayBuffer$.prototype = new $h_O();
$c_scm_ArrayBuffer$.prototype.constructor = $c_scm_ArrayBuffer$;
/** @constructor */
function $h_scm_ArrayBuffer$() {
  /*<skip>*/
}
$h_scm_ArrayBuffer$.prototype = $c_scm_ArrayBuffer$.prototype;
$c_scm_ArrayBuffer$.prototype.apply__sci_Seq__O = (function(elems) {
  return this.from__sc_IterableOnce__scm_ArrayBuffer(elems)
});
$c_scm_ArrayBuffer$.prototype.from__sc_IterableOnce__scm_ArrayBuffer = (function(coll) {
  var k = coll.knownSize__I();
  if ((k >= 0)) {
    var array = new $ac_O(((k > 16) ? k : 16));
    if ($is_sc_Iterable(coll)) {
      var x2 = $as_sc_Iterable(coll);
      x2.copyToArray__O__I__I__I(array, 0, 2147483647)
    } else {
      coll.iterator__sc_Iterator().copyToArray__O__I__I__I(array, 0, 2147483647)
    };
    return $ct_scm_ArrayBuffer__AO__I__(new $c_scm_ArrayBuffer(), array, k)
  } else {
    var this$6 = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
    return this$6.addAll__sc_IterableOnce__scm_ArrayBuffer(coll)
  }
});
$c_scm_ArrayBuffer$.prototype.newBuilder__scm_Builder = (function() {
  return new $c_scm_ArrayBuffer$$anon$1()
});
$c_scm_ArrayBuffer$.prototype.scala$collection$mutable$ArrayBuffer$$ensureSize__AO__I__I__AO = (function(array, end, n) {
  var value = array.u.length;
  var hi = (value >> 31);
  var hi$1 = (n >> 31);
  if (((hi$1 === hi) ? (((-2147483648) ^ n) <= ((-2147483648) ^ value)) : (hi$1 < hi))) {
    return array
  } else {
    return $p_scm_ArrayBuffer$__growArray$1__J__I__I__AO__AO(this, new $c_RTLong(value, hi), n, end, array)
  }
});
$c_scm_ArrayBuffer$.prototype.empty__O = (function() {
  return $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer())
});
$c_scm_ArrayBuffer$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__scm_ArrayBuffer(source)
});
var $d_scm_ArrayBuffer$ = new $TypeData().initClass({
  scm_ArrayBuffer$: 0
}, false, "scala.collection.mutable.ArrayBuffer$", {
  scm_ArrayBuffer$: 1,
  O: 1,
  sc_StrictOptimizedSeqFactory: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_scm_ArrayBuffer$.prototype.$classData = $d_scm_ArrayBuffer$;
var $n_scm_ArrayBuffer$;
function $m_scm_ArrayBuffer$() {
  if ((!$n_scm_ArrayBuffer$)) {
    $n_scm_ArrayBuffer$ = new $c_scm_ArrayBuffer$()
  };
  return $n_scm_ArrayBuffer$
}
/** @constructor */
function $c_scm_ArrayBuffer$$anon$1() {
  this.scm_GrowableBuilder__f_elems = null;
  $ct_scm_GrowableBuilder__scm_Growable__(this, $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer()))
}
$c_scm_ArrayBuffer$$anon$1.prototype = new $h_scm_GrowableBuilder();
$c_scm_ArrayBuffer$$anon$1.prototype.constructor = $c_scm_ArrayBuffer$$anon$1;
/** @constructor */
function $h_scm_ArrayBuffer$$anon$1() {
  /*<skip>*/
}
$h_scm_ArrayBuffer$$anon$1.prototype = $c_scm_ArrayBuffer$$anon$1.prototype;
$c_scm_ArrayBuffer$$anon$1.prototype.sizeHint__I__V = (function(size) {
  $as_scm_ArrayBuffer(this.scm_GrowableBuilder__f_elems).ensureSize__I__V(size)
});
var $d_scm_ArrayBuffer$$anon$1 = new $TypeData().initClass({
  scm_ArrayBuffer$$anon$1: 0
}, false, "scala.collection.mutable.ArrayBuffer$$anon$1", {
  scm_ArrayBuffer$$anon$1: 1,
  scm_GrowableBuilder: 1,
  O: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
});
$c_scm_ArrayBuffer$$anon$1.prototype.$classData = $d_scm_ArrayBuffer$$anon$1;
/** @constructor */
function $c_scm_Buffer$() {
  this.sc_SeqFactory$Delegate__f_delegate = null;
  $ct_sc_SeqFactory$Delegate__sc_SeqFactory__(this, $m_sjs_js_WrappedArray$())
}
$c_scm_Buffer$.prototype = new $h_sc_SeqFactory$Delegate();
$c_scm_Buffer$.prototype.constructor = $c_scm_Buffer$;
/** @constructor */
function $h_scm_Buffer$() {
  /*<skip>*/
}
$h_scm_Buffer$.prototype = $c_scm_Buffer$.prototype;
var $d_scm_Buffer$ = new $TypeData().initClass({
  scm_Buffer$: 0
}, false, "scala.collection.mutable.Buffer$", {
  scm_Buffer$: 1,
  sc_SeqFactory$Delegate: 1,
  O: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_scm_Buffer$.prototype.$classData = $d_scm_Buffer$;
var $n_scm_Buffer$;
function $m_scm_Buffer$() {
  if ((!$n_scm_Buffer$)) {
    $n_scm_Buffer$ = new $c_scm_Buffer$()
  };
  return $n_scm_Buffer$
}
/** @constructor */
function $c_scm_HashMap$$anon$6(initialCapacity$1, loadFactor$1) {
  this.scm_GrowableBuilder__f_elems = null;
  $ct_scm_GrowableBuilder__scm_Growable__(this, $ct_scm_HashMap__I__D__(new $c_scm_HashMap(), initialCapacity$1, loadFactor$1))
}
$c_scm_HashMap$$anon$6.prototype = new $h_scm_GrowableBuilder();
$c_scm_HashMap$$anon$6.prototype.constructor = $c_scm_HashMap$$anon$6;
/** @constructor */
function $h_scm_HashMap$$anon$6() {
  /*<skip>*/
}
$h_scm_HashMap$$anon$6.prototype = $c_scm_HashMap$$anon$6.prototype;
$c_scm_HashMap$$anon$6.prototype.sizeHint__I__V = (function(size) {
  $as_scm_HashMap(this.scm_GrowableBuilder__f_elems).sizeHint__I__V(size)
});
var $d_scm_HashMap$$anon$6 = new $TypeData().initClass({
  scm_HashMap$$anon$6: 0
}, false, "scala.collection.mutable.HashMap$$anon$6", {
  scm_HashMap$$anon$6: 1,
  scm_GrowableBuilder: 1,
  O: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
});
$c_scm_HashMap$$anon$6.prototype.$classData = $d_scm_HashMap$$anon$6;
function $ct_scm_HashMap$HashMapIterator__scm_HashMap__($thiz, outer) {
  if ((outer === null)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(null)
  } else {
    $thiz.scm_HashMap$HashMapIterator__f_$outer = outer
  };
  $thiz.scm_HashMap$HashMapIterator__f_i = 0;
  $thiz.scm_HashMap$HashMapIterator__f_node = null;
  $thiz.scm_HashMap$HashMapIterator__f_len = outer.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u.length;
  return $thiz
}
/** @constructor */
function $c_scm_HashMap$HashMapIterator() {
  this.scm_HashMap$HashMapIterator__f_i = 0;
  this.scm_HashMap$HashMapIterator__f_node = null;
  this.scm_HashMap$HashMapIterator__f_len = 0;
  this.scm_HashMap$HashMapIterator__f_$outer = null
}
$c_scm_HashMap$HashMapIterator.prototype = new $h_sc_AbstractIterator();
$c_scm_HashMap$HashMapIterator.prototype.constructor = $c_scm_HashMap$HashMapIterator;
/** @constructor */
function $h_scm_HashMap$HashMapIterator() {
  /*<skip>*/
}
$h_scm_HashMap$HashMapIterator.prototype = $c_scm_HashMap$HashMapIterator.prototype;
$c_scm_HashMap$HashMapIterator.prototype.hasNext__Z = (function() {
  if ((this.scm_HashMap$HashMapIterator__f_node !== null)) {
    return true
  } else {
    while ((this.scm_HashMap$HashMapIterator__f_i < this.scm_HashMap$HashMapIterator__f_len)) {
      var n = this.scm_HashMap$HashMapIterator__f_$outer.scm_HashMap__f_scala$collection$mutable$HashMap$$table.get(this.scm_HashMap$HashMapIterator__f_i);
      this.scm_HashMap$HashMapIterator__f_i = ((1 + this.scm_HashMap$HashMapIterator__f_i) | 0);
      if ((n !== null)) {
        this.scm_HashMap$HashMapIterator__f_node = n;
        return true
      }
    };
    return false
  }
});
$c_scm_HashMap$HashMapIterator.prototype.next__O = (function() {
  if ((!this.hasNext__Z())) {
    return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O()
  } else {
    var r = this.extract__scm_HashMap$Node__O(this.scm_HashMap$HashMapIterator__f_node);
    this.scm_HashMap$HashMapIterator__f_node = this.scm_HashMap$HashMapIterator__f_node.scm_HashMap$Node__f__next;
    return r
  }
});
function $ct_scm_ImmutableBuilder__sc_IterableOnce__($thiz, empty) {
  $thiz.scm_ImmutableBuilder__f_empty = empty;
  $thiz.scm_ImmutableBuilder__f_elems = empty;
  return $thiz
}
/** @constructor */
function $c_scm_ImmutableBuilder() {
  this.scm_ImmutableBuilder__f_empty = null;
  this.scm_ImmutableBuilder__f_elems = null
}
$c_scm_ImmutableBuilder.prototype = new $h_O();
$c_scm_ImmutableBuilder.prototype.constructor = $c_scm_ImmutableBuilder;
/** @constructor */
function $h_scm_ImmutableBuilder() {
  /*<skip>*/
}
$h_scm_ImmutableBuilder.prototype = $c_scm_ImmutableBuilder.prototype;
$c_scm_ImmutableBuilder.prototype.sizeHint__I__V = (function(size) {
  /*<skip>*/
});
$c_scm_ImmutableBuilder.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs)
});
$c_scm_ImmutableBuilder.prototype.result__O = (function() {
  return this.scm_ImmutableBuilder__f_elems
});
/** @constructor */
function $c_scm_IndexedSeq$() {
  this.sc_SeqFactory$Delegate__f_delegate = null;
  $ct_sc_SeqFactory$Delegate__sc_SeqFactory__(this, $m_scm_ArrayBuffer$())
}
$c_scm_IndexedSeq$.prototype = new $h_sc_SeqFactory$Delegate();
$c_scm_IndexedSeq$.prototype.constructor = $c_scm_IndexedSeq$;
/** @constructor */
function $h_scm_IndexedSeq$() {
  /*<skip>*/
}
$h_scm_IndexedSeq$.prototype = $c_scm_IndexedSeq$.prototype;
var $d_scm_IndexedSeq$ = new $TypeData().initClass({
  scm_IndexedSeq$: 0
}, false, "scala.collection.mutable.IndexedSeq$", {
  scm_IndexedSeq$: 1,
  sc_SeqFactory$Delegate: 1,
  O: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_scm_IndexedSeq$.prototype.$classData = $d_scm_IndexedSeq$;
var $n_scm_IndexedSeq$;
function $m_scm_IndexedSeq$() {
  if ((!$n_scm_IndexedSeq$)) {
    $n_scm_IndexedSeq$ = new $c_scm_IndexedSeq$()
  };
  return $n_scm_IndexedSeq$
}
/** @constructor */
function $c_scm_ListBuffer$() {
  /*<skip>*/
}
$c_scm_ListBuffer$.prototype = new $h_O();
$c_scm_ListBuffer$.prototype.constructor = $c_scm_ListBuffer$;
/** @constructor */
function $h_scm_ListBuffer$() {
  /*<skip>*/
}
$h_scm_ListBuffer$.prototype = $c_scm_ListBuffer$.prototype;
$c_scm_ListBuffer$.prototype.apply__sci_Seq__O = (function(elems) {
  var this$1 = new $c_scm_ListBuffer();
  return this$1.addAll__sc_IterableOnce__scm_ListBuffer(elems)
});
$c_scm_ListBuffer$.prototype.newBuilder__scm_Builder = (function() {
  return $ct_scm_GrowableBuilder__scm_Growable__(new $c_scm_GrowableBuilder(), new $c_scm_ListBuffer())
});
$c_scm_ListBuffer$.prototype.empty__O = (function() {
  return new $c_scm_ListBuffer()
});
$c_scm_ListBuffer$.prototype.from__sc_IterableOnce__O = (function(source) {
  var this$1 = new $c_scm_ListBuffer();
  return this$1.addAll__sc_IterableOnce__scm_ListBuffer(source)
});
var $d_scm_ListBuffer$ = new $TypeData().initClass({
  scm_ListBuffer$: 0
}, false, "scala.collection.mutable.ListBuffer$", {
  scm_ListBuffer$: 1,
  O: 1,
  sc_StrictOptimizedSeqFactory: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_scm_ListBuffer$.prototype.$classData = $d_scm_ListBuffer$;
var $n_scm_ListBuffer$;
function $m_scm_ListBuffer$() {
  if ((!$n_scm_ListBuffer$)) {
    $n_scm_ListBuffer$ = new $c_scm_ListBuffer$()
  };
  return $n_scm_ListBuffer$
}
/** @constructor */
function $c_scm_MutationTracker$CheckedIterator(underlying, mutationCount) {
  this.scm_MutationTracker$CheckedIterator__f_underlying = null;
  this.scm_MutationTracker$CheckedIterator__f_mutationCount = null;
  this.scm_MutationTracker$CheckedIterator__f_expectedCount = 0;
  this.scm_MutationTracker$CheckedIterator__f_underlying = underlying;
  this.scm_MutationTracker$CheckedIterator__f_mutationCount = mutationCount;
  this.scm_MutationTracker$CheckedIterator__f_expectedCount = $uI(mutationCount.apply__O())
}
$c_scm_MutationTracker$CheckedIterator.prototype = new $h_sc_AbstractIterator();
$c_scm_MutationTracker$CheckedIterator.prototype.constructor = $c_scm_MutationTracker$CheckedIterator;
/** @constructor */
function $h_scm_MutationTracker$CheckedIterator() {
  /*<skip>*/
}
$h_scm_MutationTracker$CheckedIterator.prototype = $c_scm_MutationTracker$CheckedIterator.prototype;
$c_scm_MutationTracker$CheckedIterator.prototype.hasNext__Z = (function() {
  var this$2 = $m_scm_MutationTracker$();
  var expectedCount = this.scm_MutationTracker$CheckedIterator__f_expectedCount;
  var this$1 = this.scm_MutationTracker$CheckedIterator__f_mutationCount;
  var actualCount = $uI(this$1.apply__O());
  this$2.checkMutations__I__I__T__V(expectedCount, actualCount, "mutation occurred during iteration");
  return this.scm_MutationTracker$CheckedIterator__f_underlying.hasNext__Z()
});
$c_scm_MutationTracker$CheckedIterator.prototype.next__O = (function() {
  return this.scm_MutationTracker$CheckedIterator__f_underlying.next__O()
});
var $d_scm_MutationTracker$CheckedIterator = new $TypeData().initClass({
  scm_MutationTracker$CheckedIterator: 0
}, false, "scala.collection.mutable.MutationTracker$CheckedIterator", {
  scm_MutationTracker$CheckedIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_scm_MutationTracker$CheckedIterator.prototype.$classData = $d_scm_MutationTracker$CheckedIterator;
/** @constructor */
function $c_s_concurrent_ExecutionContext$parasitic$() {
  this.s_concurrent_ExecutionContext$parasitic$__f_scala$concurrent$BatchingExecutor$$_tasksLocal = null;
  $n_s_concurrent_ExecutionContext$parasitic$ = this;
  this.s_concurrent_ExecutionContext$parasitic$__f_scala$concurrent$BatchingExecutor$$_tasksLocal = new $c_jl_ThreadLocal()
}
$c_s_concurrent_ExecutionContext$parasitic$.prototype = new $h_O();
$c_s_concurrent_ExecutionContext$parasitic$.prototype.constructor = $c_s_concurrent_ExecutionContext$parasitic$;
/** @constructor */
function $h_s_concurrent_ExecutionContext$parasitic$() {
  /*<skip>*/
}
$h_s_concurrent_ExecutionContext$parasitic$.prototype = $c_s_concurrent_ExecutionContext$parasitic$.prototype;
$c_s_concurrent_ExecutionContext$parasitic$.prototype.execute__jl_Runnable__V = (function(runnable) {
  $f_s_concurrent_BatchingExecutor__submitSyncBatched__jl_Runnable__V(this, runnable)
});
$c_s_concurrent_ExecutionContext$parasitic$.prototype.reportFailure__jl_Throwable__V = (function(t) {
  $m_s_concurrent_ExecutionContext$().s_concurrent_ExecutionContext$__f_defaultReporter.apply__O__O(t)
});
var $d_s_concurrent_ExecutionContext$parasitic$ = new $TypeData().initClass({
  s_concurrent_ExecutionContext$parasitic$: 0
}, false, "scala.concurrent.ExecutionContext$parasitic$", {
  s_concurrent_ExecutionContext$parasitic$: 1,
  O: 1,
  s_concurrent_ExecutionContextExecutor: 1,
  s_concurrent_ExecutionContext: 1,
  ju_concurrent_Executor: 1,
  s_concurrent_BatchingExecutor: 1
});
$c_s_concurrent_ExecutionContext$parasitic$.prototype.$classData = $d_s_concurrent_ExecutionContext$parasitic$;
var $n_s_concurrent_ExecutionContext$parasitic$;
function $m_s_concurrent_ExecutionContext$parasitic$() {
  if ((!$n_s_concurrent_ExecutionContext$parasitic$)) {
    $n_s_concurrent_ExecutionContext$parasitic$ = new $c_s_concurrent_ExecutionContext$parasitic$()
  };
  return $n_s_concurrent_ExecutionContext$parasitic$
}
/** @constructor */
function $c_s_concurrent_duration_Duration$Infinite() {
  /*<skip>*/
}
$c_s_concurrent_duration_Duration$Infinite.prototype = new $h_s_concurrent_duration_Duration();
$c_s_concurrent_duration_Duration$Infinite.prototype.constructor = $c_s_concurrent_duration_Duration$Infinite;
/** @constructor */
function $h_s_concurrent_duration_Duration$Infinite() {
  /*<skip>*/
}
$h_s_concurrent_duration_Duration$Infinite.prototype = $c_s_concurrent_duration_Duration$Infinite.prototype;
function $p_s_concurrent_duration_FiniteDuration__bounded__J__Z($thiz, max) {
  var lo = max.RTLong__f_lo;
  var hi = max.RTLong__f_hi;
  var lo$1 = ((-lo) | 0);
  var hi$1 = ((lo !== 0) ? (~hi) : ((-hi) | 0));
  var b = $thiz.s_concurrent_duration_FiniteDuration__f_length;
  var bhi = b.RTLong__f_hi;
  if (((hi$1 === bhi) ? (((-2147483648) ^ lo$1) <= ((-2147483648) ^ b.RTLong__f_lo)) : (hi$1 < bhi))) {
    var this$3 = $thiz.s_concurrent_duration_FiniteDuration__f_length;
    var ahi = this$3.RTLong__f_hi;
    var bhi$1 = max.RTLong__f_hi;
    return ((ahi === bhi$1) ? (((-2147483648) ^ this$3.RTLong__f_lo) <= ((-2147483648) ^ max.RTLong__f_lo)) : (ahi < bhi$1))
  } else {
    return false
  }
}
function $p_s_concurrent_duration_FiniteDuration__unitString__T($thiz) {
  var $$x1 = $as_T($m_s_concurrent_duration_Duration$().s_concurrent_duration_Duration$__f_timeUnitName.apply__O__O($thiz.s_concurrent_duration_FiniteDuration__f_unit));
  var this$1 = $thiz.s_concurrent_duration_FiniteDuration__f_length;
  return ($$x1 + (((this$1.RTLong__f_lo === 1) && (this$1.RTLong__f_hi === 0)) ? "" : "s"))
}
/** @constructor */
function $c_s_concurrent_duration_FiniteDuration(length, unit) {
  this.s_concurrent_duration_FiniteDuration__f_length = $L0;
  this.s_concurrent_duration_FiniteDuration__f_unit = null;
  this.s_concurrent_duration_FiniteDuration__f_length = length;
  this.s_concurrent_duration_FiniteDuration__f_unit = unit;
  var x = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_NANOSECONDS;
  if ((x === unit)) {
    var requirement = $p_s_concurrent_duration_FiniteDuration__bounded__J__Z(this, new $c_RTLong((-1), 2147483647))
  } else {
    var x$3 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MICROSECONDS;
    if ((x$3 === unit)) {
      var requirement = $p_s_concurrent_duration_FiniteDuration__bounded__J__Z(this, new $c_RTLong((-1511828489), 2147483))
    } else {
      var x$5 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MILLISECONDS;
      if ((x$5 === unit)) {
        var requirement = $p_s_concurrent_duration_FiniteDuration__bounded__J__Z(this, new $c_RTLong(2077252342, 2147))
      } else {
        var x$7 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_SECONDS;
        if ((x$7 === unit)) {
          var requirement = $p_s_concurrent_duration_FiniteDuration__bounded__J__Z(this, new $c_RTLong(633437444, 2))
        } else {
          var x$9 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MINUTES;
          if ((x$9 === unit)) {
            var requirement = $p_s_concurrent_duration_FiniteDuration__bounded__J__Z(this, new $c_RTLong(153722867, 0))
          } else {
            var x$11 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_HOURS;
            if ((x$11 === unit)) {
              var requirement = $p_s_concurrent_duration_FiniteDuration__bounded__J__Z(this, new $c_RTLong(2562047, 0))
            } else {
              var x$13 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_DAYS;
              if ((x$13 === unit)) {
                var requirement = $p_s_concurrent_duration_FiniteDuration__bounded__J__Z(this, new $c_RTLong(106751, 0))
              } else {
                var t = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_DAYS.convert__J__ju_concurrent_TimeUnit__J(length, unit);
                var lo = t.RTLong__f_lo;
                var hi = t.RTLong__f_hi;
                var requirement = (((hi === (-1)) ? (((-2147483648) ^ lo) >= 2147376897) : (hi > (-1))) && ((hi === 0) ? (((-2147483648) ^ lo) <= (-2147376897)) : (hi < 0)))
              }
            }
          }
        }
      }
    }
  };
  if ((!requirement)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "requirement failed: Duration is limited to +-(2^63-1)ns (ca. 292 years)")
  }
}
$c_s_concurrent_duration_FiniteDuration.prototype = new $h_s_concurrent_duration_Duration();
$c_s_concurrent_duration_FiniteDuration.prototype.constructor = $c_s_concurrent_duration_FiniteDuration;
/** @constructor */
function $h_s_concurrent_duration_FiniteDuration() {
  /*<skip>*/
}
$h_s_concurrent_duration_FiniteDuration.prototype = $c_s_concurrent_duration_FiniteDuration.prototype;
$c_s_concurrent_duration_FiniteDuration.prototype.toString__T = (function() {
  return ((this.s_concurrent_duration_FiniteDuration__f_length + " ") + $p_s_concurrent_duration_FiniteDuration__unitString__T(this))
});
$c_s_concurrent_duration_FiniteDuration.prototype.compare__s_concurrent_duration_Duration__I = (function(other) {
  if ((other instanceof $c_s_concurrent_duration_FiniteDuration)) {
    var x2 = $as_s_concurrent_duration_FiniteDuration(other);
    var t = this.s_concurrent_duration_FiniteDuration__f_unit.toNanos__J__J(this.s_concurrent_duration_FiniteDuration__f_length);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var this$2 = new $c_sr_RichLong(new $c_RTLong(lo, hi));
    var t$1 = x2.s_concurrent_duration_FiniteDuration__f_unit.toNanos__J__J(x2.s_concurrent_duration_FiniteDuration__f_length);
    var lo$1 = t$1.RTLong__f_lo;
    var hi$1 = t$1.RTLong__f_hi;
    var t$3 = this$2.sr_RichLong__f_self;
    var lo$3 = t$3.RTLong__f_lo;
    var hi$3 = t$3.RTLong__f_hi;
    var t$4 = $uJ(new $c_RTLong(lo$3, hi$3));
    var lo$4 = t$4.RTLong__f_lo;
    var hi$4 = t$4.RTLong__f_hi;
    var t$5 = $uJ(new $c_RTLong(lo$1, hi$1));
    var lo$5 = t$5.RTLong__f_lo;
    var hi$5 = t$5.RTLong__f_hi;
    return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$compare__I__I__I__I__I(lo$4, hi$4, lo$5, hi$5)
  } else {
    return ((-other.compare__s_concurrent_duration_Duration__I(this)) | 0)
  }
});
$c_s_concurrent_duration_FiniteDuration.prototype.equals__O__Z = (function(other) {
  if ((other instanceof $c_s_concurrent_duration_FiniteDuration)) {
    var x2 = $as_s_concurrent_duration_FiniteDuration(other);
    var this$1 = this.s_concurrent_duration_FiniteDuration__f_unit.toNanos__J__J(this.s_concurrent_duration_FiniteDuration__f_length);
    var b = x2.s_concurrent_duration_FiniteDuration__f_unit.toNanos__J__J(x2.s_concurrent_duration_FiniteDuration__f_length);
    return ((this$1.RTLong__f_lo === b.RTLong__f_lo) && (this$1.RTLong__f_hi === b.RTLong__f_hi))
  } else {
    return (this === other)
  }
});
$c_s_concurrent_duration_FiniteDuration.prototype.hashCode__I = (function() {
  var this$1 = this.s_concurrent_duration_FiniteDuration__f_unit.toNanos__J__J(this.s_concurrent_duration_FiniteDuration__f_length);
  return this$1.RTLong__f_lo
});
$c_s_concurrent_duration_FiniteDuration.prototype.compare__O__I = (function(that) {
  return this.compare__s_concurrent_duration_Duration__I($as_s_concurrent_duration_Duration(that))
});
function $as_s_concurrent_duration_FiniteDuration(obj) {
  return (((obj instanceof $c_s_concurrent_duration_FiniteDuration) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.concurrent.duration.FiniteDuration"))
}
function $isArrayOf_s_concurrent_duration_FiniteDuration(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_concurrent_duration_FiniteDuration)))
}
function $asArrayOf_s_concurrent_duration_FiniteDuration(obj, depth) {
  return (($isArrayOf_s_concurrent_duration_FiniteDuration(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.concurrent.duration.FiniteDuration;", depth))
}
var $d_s_concurrent_duration_FiniteDuration = new $TypeData().initClass({
  s_concurrent_duration_FiniteDuration: 0
}, false, "scala.concurrent.duration.FiniteDuration", {
  s_concurrent_duration_FiniteDuration: 1,
  s_concurrent_duration_Duration: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  s_math_Ordered: 1,
  jl_Comparable: 1
});
$c_s_concurrent_duration_FiniteDuration.prototype.$classData = $d_s_concurrent_duration_FiniteDuration;
function $f_s_reflect_ClassTag__equals__O__Z($thiz, x) {
  if ($is_s_reflect_ClassTag(x)) {
    var x$2 = $thiz.runtimeClass__jl_Class();
    var x$3 = $as_s_reflect_ClassTag(x).runtimeClass__jl_Class();
    return (x$2 === x$3)
  } else {
    return false
  }
}
function $p_s_reflect_ClassTag__prettyprint$1__jl_Class__T($thiz, clazz) {
  return (clazz.isArray__Z() ? (("Array[" + $p_s_reflect_ClassTag__prettyprint$1__jl_Class__T($thiz, clazz.getComponentType__jl_Class())) + "]") : clazz.getName__T())
}
function $is_s_reflect_ClassTag(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.s_reflect_ClassTag)))
}
function $as_s_reflect_ClassTag(obj) {
  return (($is_s_reflect_ClassTag(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.reflect.ClassTag"))
}
function $isArrayOf_s_reflect_ClassTag(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_reflect_ClassTag)))
}
function $asArrayOf_s_reflect_ClassTag(obj, depth) {
  return (($isArrayOf_s_reflect_ClassTag(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.reflect.ClassTag;", depth))
}
/** @constructor */
function $c_sr_ScalaRunTime$$anon$1(x$2) {
  this.sr_ScalaRunTime$$anon$1__f_c = 0;
  this.sr_ScalaRunTime$$anon$1__f_cmax = 0;
  this.sr_ScalaRunTime$$anon$1__f_x$2 = null;
  this.sr_ScalaRunTime$$anon$1__f_x$2 = x$2;
  this.sr_ScalaRunTime$$anon$1__f_c = 0;
  this.sr_ScalaRunTime$$anon$1__f_cmax = x$2.productArity__I()
}
$c_sr_ScalaRunTime$$anon$1.prototype = new $h_sc_AbstractIterator();
$c_sr_ScalaRunTime$$anon$1.prototype.constructor = $c_sr_ScalaRunTime$$anon$1;
/** @constructor */
function $h_sr_ScalaRunTime$$anon$1() {
  /*<skip>*/
}
$h_sr_ScalaRunTime$$anon$1.prototype = $c_sr_ScalaRunTime$$anon$1.prototype;
$c_sr_ScalaRunTime$$anon$1.prototype.hasNext__Z = (function() {
  return (this.sr_ScalaRunTime$$anon$1__f_c < this.sr_ScalaRunTime$$anon$1__f_cmax)
});
$c_sr_ScalaRunTime$$anon$1.prototype.next__O = (function() {
  var result = this.sr_ScalaRunTime$$anon$1__f_x$2.productElement__I__O(this.sr_ScalaRunTime$$anon$1__f_c);
  this.sr_ScalaRunTime$$anon$1__f_c = ((1 + this.sr_ScalaRunTime$$anon$1__f_c) | 0);
  return result
});
var $d_sr_ScalaRunTime$$anon$1 = new $TypeData().initClass({
  sr_ScalaRunTime$$anon$1: 0
}, false, "scala.runtime.ScalaRunTime$$anon$1", {
  sr_ScalaRunTime$$anon$1: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sr_ScalaRunTime$$anon$1.prototype.$classData = $d_sr_ScalaRunTime$$anon$1;
/** @constructor */
function $c_sjs_js_WrappedArray$() {
  /*<skip>*/
}
$c_sjs_js_WrappedArray$.prototype = new $h_O();
$c_sjs_js_WrappedArray$.prototype.constructor = $c_sjs_js_WrappedArray$;
/** @constructor */
function $h_sjs_js_WrappedArray$() {
  /*<skip>*/
}
$h_sjs_js_WrappedArray$.prototype = $c_sjs_js_WrappedArray$.prototype;
$c_sjs_js_WrappedArray$.prototype.apply__sci_Seq__O = (function(elems) {
  return this.from__sc_IterableOnce__sjs_js_WrappedArray(elems)
});
$c_sjs_js_WrappedArray$.prototype.newBuilder__scm_Builder = (function() {
  return $ct_sjs_js_WrappedArray__(new $c_sjs_js_WrappedArray())
});
$c_sjs_js_WrappedArray$.prototype.from__sc_IterableOnce__sjs_js_WrappedArray = (function(source) {
  var this$1 = $ct_sjs_js_WrappedArray__(new $c_sjs_js_WrappedArray());
  return $as_sjs_js_WrappedArray($as_scm_Builder($f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this$1, source)).result__O())
});
$c_sjs_js_WrappedArray$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__sjs_js_WrappedArray(source)
});
$c_sjs_js_WrappedArray$.prototype.empty__O = (function() {
  return $ct_sjs_js_WrappedArray__(new $c_sjs_js_WrappedArray())
});
var $d_sjs_js_WrappedArray$ = new $TypeData().initClass({
  sjs_js_WrappedArray$: 0
}, false, "scala.scalajs.js.WrappedArray$", {
  sjs_js_WrappedArray$: 1,
  O: 1,
  sc_StrictOptimizedSeqFactory: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sjs_js_WrappedArray$.prototype.$classData = $d_sjs_js_WrappedArray$;
var $n_sjs_js_WrappedArray$;
function $m_sjs_js_WrappedArray$() {
  if ((!$n_sjs_js_WrappedArray$)) {
    $n_sjs_js_WrappedArray$ = new $c_sjs_js_WrappedArray$()
  };
  return $n_sjs_js_WrappedArray$
}
/** @constructor */
function $c_sjsr_WrappedVarArgs$() {
  /*<skip>*/
}
$c_sjsr_WrappedVarArgs$.prototype = new $h_O();
$c_sjsr_WrappedVarArgs$.prototype.constructor = $c_sjsr_WrappedVarArgs$;
/** @constructor */
function $h_sjsr_WrappedVarArgs$() {
  /*<skip>*/
}
$h_sjsr_WrappedVarArgs$.prototype = $c_sjsr_WrappedVarArgs$.prototype;
$c_sjsr_WrappedVarArgs$.prototype.apply__sci_Seq__O = (function(elems) {
  return this.from__sc_IterableOnce__sjsr_WrappedVarArgs(elems)
});
$c_sjsr_WrappedVarArgs$.prototype.from__sc_IterableOnce__sjsr_WrappedVarArgs = (function(source) {
  var this$1 = this.newBuilder__scm_Builder();
  return $as_sjsr_WrappedVarArgs($as_scm_Builder(this$1.addAll__sc_IterableOnce__scm_Growable(source)).result__O())
});
$c_sjsr_WrappedVarArgs$.prototype.newBuilder__scm_Builder = (function() {
  var array = [];
  var this$4 = $ct_sjs_js_WrappedArray__sjs_js_Array__(new $c_sjs_js_WrappedArray(), array);
  var f = new $c_sjsr_AnonFunction1((function(this$2) {
    return (function(x$1$2) {
      var x$1 = $as_sjs_js_WrappedArray(x$1$2);
      return $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), x$1.sjs_js_WrappedArray__f_scala$scalajs$js$WrappedArray$$array)
    })
  })(this));
  return new $c_scm_Builder$$anon$1(this$4, f)
});
$c_sjsr_WrappedVarArgs$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__sjsr_WrappedVarArgs(source)
});
$c_sjsr_WrappedVarArgs$.prototype.empty__O = (function() {
  return $ct_sjsr_WrappedVarArgs__(new $c_sjsr_WrappedVarArgs())
});
var $d_sjsr_WrappedVarArgs$ = new $TypeData().initClass({
  sjsr_WrappedVarArgs$: 0
}, false, "scala.scalajs.runtime.WrappedVarArgs$", {
  sjsr_WrappedVarArgs$: 1,
  O: 1,
  sc_StrictOptimizedSeqFactory: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sjsr_WrappedVarArgs$.prototype.$classData = $d_sjsr_WrappedVarArgs$;
var $n_sjsr_WrappedVarArgs$;
function $m_sjsr_WrappedVarArgs$() {
  if ((!$n_sjsr_WrappedVarArgs$)) {
    $n_sjsr_WrappedVarArgs$ = new $c_sjsr_WrappedVarArgs$()
  };
  return $n_sjsr_WrappedVarArgs$
}
/** @constructor */
function $c_s_util_Failure(exception) {
  this.s_util_Failure__f_exception = null;
  this.s_util_Failure__f_exception = exception
}
$c_s_util_Failure.prototype = new $h_s_util_Try();
$c_s_util_Failure.prototype.constructor = $c_s_util_Failure;
/** @constructor */
function $h_s_util_Failure() {
  /*<skip>*/
}
$h_s_util_Failure.prototype = $c_s_util_Failure.prototype;
$c_s_util_Failure.prototype.get__O = (function() {
  throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(this.s_util_Failure__f_exception)
});
$c_s_util_Failure.prototype.foreach__F1__V = (function(f) {
  /*<skip>*/
});
$c_s_util_Failure.prototype.recover__s_PartialFunction__s_util_Try = (function(pf) {
  var marker = $m_sr_Statics$PFMarker$();
  try {
    var v = pf.applyOrElse__O__F1__O(this.s_util_Failure__f_exception, new $c_sjsr_AnonFunction1((function(this$2, marker$1) {
      return (function(x$2) {
        $as_jl_Throwable(x$2);
        return marker$1
      })
    })(this, marker)));
    return ((marker !== v) ? new $c_s_util_Success(v) : this)
  } catch (e) {
    var e$2 = $m_sjsr_package$().wrapJavaScriptException__O__jl_Throwable(e);
    if ((e$2 !== null)) {
      if ((e$2 !== null)) {
        var o11 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
        if ((!o11.isEmpty__Z())) {
          var e$3 = $as_jl_Throwable(o11.get__O());
          return new $c_s_util_Failure(e$3)
        }
      };
      throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(e$2)
    } else {
      throw e
    }
  }
});
$c_s_util_Failure.prototype.toOption__s_Option = (function() {
  return $m_s_None$()
});
$c_s_util_Failure.prototype.fold__F1__F1__O = (function(fa, fb) {
  return fa.apply__O__O(this.s_util_Failure__f_exception)
});
$c_s_util_Failure.prototype.productPrefix__T = (function() {
  return "Failure"
});
$c_s_util_Failure.prototype.productArity__I = (function() {
  return 1
});
$c_s_util_Failure.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.s_util_Failure__f_exception : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_s_util_Failure.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_s_util_Failure.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_s_util_Failure.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_s_util_Failure.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_s_util_Failure)) {
    var Failure$1 = $as_s_util_Failure(x$1);
    var x = this.s_util_Failure__f_exception;
    var x$2 = Failure$1.s_util_Failure__f_exception;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_s_util_Failure(obj) {
  return (((obj instanceof $c_s_util_Failure) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.util.Failure"))
}
function $isArrayOf_s_util_Failure(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_util_Failure)))
}
function $asArrayOf_s_util_Failure(obj, depth) {
  return (($isArrayOf_s_util_Failure(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.util.Failure;", depth))
}
var $d_s_util_Failure = new $TypeData().initClass({
  s_util_Failure: 0
}, false, "scala.util.Failure", {
  s_util_Failure: 1,
  s_util_Try: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_s_util_Failure.prototype.$classData = $d_s_util_Failure;
/** @constructor */
function $c_s_util_Success(value) {
  this.s_util_Success__f_value = null;
  this.s_util_Success__f_value = value
}
$c_s_util_Success.prototype = new $h_s_util_Try();
$c_s_util_Success.prototype.constructor = $c_s_util_Success;
/** @constructor */
function $h_s_util_Success() {
  /*<skip>*/
}
$h_s_util_Success.prototype = $c_s_util_Success.prototype;
$c_s_util_Success.prototype.get__O = (function() {
  return this.s_util_Success__f_value
});
$c_s_util_Success.prototype.foreach__F1__V = (function(f) {
  f.apply__O__O(this.s_util_Success__f_value)
});
$c_s_util_Success.prototype.recover__s_PartialFunction__s_util_Try = (function(pf) {
  return this
});
$c_s_util_Success.prototype.toOption__s_Option = (function() {
  return new $c_s_Some(this.s_util_Success__f_value)
});
$c_s_util_Success.prototype.fold__F1__F1__O = (function(fa, fb) {
  try {
    return fb.apply__O__O(this.s_util_Success__f_value)
  } catch (e) {
    var e$2 = $m_sjsr_package$().wrapJavaScriptException__O__jl_Throwable(e);
    if ((e$2 !== null)) {
      if ((e$2 !== null)) {
        var o11 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
        if ((!o11.isEmpty__Z())) {
          var e$3 = $as_jl_Throwable(o11.get__O());
          return fa.apply__O__O(e$3)
        }
      };
      throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(e$2)
    } else {
      throw e
    }
  }
});
$c_s_util_Success.prototype.productPrefix__T = (function() {
  return "Success"
});
$c_s_util_Success.prototype.productArity__I = (function() {
  return 1
});
$c_s_util_Success.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.s_util_Success__f_value : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_s_util_Success.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_s_util_Success.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_s_util_Success.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_s_util_Success.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_s_util_Success)) {
    var Success$1 = $as_s_util_Success(x$1);
    return $m_sr_BoxesRunTime$().equals__O__O__Z(this.s_util_Success__f_value, Success$1.s_util_Success__f_value)
  } else {
    return false
  }
});
function $as_s_util_Success(obj) {
  return (((obj instanceof $c_s_util_Success) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.util.Success"))
}
function $isArrayOf_s_util_Success(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_util_Success)))
}
function $asArrayOf_s_util_Success(obj, depth) {
  return (($isArrayOf_s_util_Success(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.util.Success;", depth))
}
var $d_s_util_Success = new $TypeData().initClass({
  s_util_Success: 0
}, false, "scala.util.Success", {
  s_util_Success: 1,
  s_util_Try: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_s_util_Success.prototype.$classData = $d_s_util_Success;
/** @constructor */
function $c_s_util_control_Exception$$anonfun$pfFromExceptions$1(exceptions$3) {
  this.s_util_control_Exception$$anonfun$pfFromExceptions$1__f_exceptions$3 = null;
  this.s_util_control_Exception$$anonfun$pfFromExceptions$1__f_exceptions$3 = exceptions$3
}
$c_s_util_control_Exception$$anonfun$pfFromExceptions$1.prototype = new $h_sr_AbstractPartialFunction();
$c_s_util_control_Exception$$anonfun$pfFromExceptions$1.prototype.constructor = $c_s_util_control_Exception$$anonfun$pfFromExceptions$1;
/** @constructor */
function $h_s_util_control_Exception$$anonfun$pfFromExceptions$1() {
  /*<skip>*/
}
$h_s_util_control_Exception$$anonfun$pfFromExceptions$1.prototype = $c_s_util_control_Exception$$anonfun$pfFromExceptions$1.prototype;
$c_s_util_control_Exception$$anonfun$pfFromExceptions$1.prototype.applyOrElse__jl_Throwable__F1__O = (function(x1, default$1) {
  if ($m_s_util_control_Exception$().scala$util$control$Exception$$wouldMatch__jl_Throwable__sc_Seq__Z(x1, this.s_util_control_Exception$$anonfun$pfFromExceptions$1__f_exceptions$3)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(x1)
  } else {
    return default$1.apply__O__O(x1)
  }
});
$c_s_util_control_Exception$$anonfun$pfFromExceptions$1.prototype.isDefinedAt__jl_Throwable__Z = (function(x1) {
  return $m_s_util_control_Exception$().scala$util$control$Exception$$wouldMatch__jl_Throwable__sc_Seq__Z(x1, this.s_util_control_Exception$$anonfun$pfFromExceptions$1__f_exceptions$3)
});
$c_s_util_control_Exception$$anonfun$pfFromExceptions$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__jl_Throwable__Z($as_jl_Throwable(x))
});
$c_s_util_control_Exception$$anonfun$pfFromExceptions$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__jl_Throwable__F1__O($as_jl_Throwable(x), default$1)
});
var $d_s_util_control_Exception$$anonfun$pfFromExceptions$1 = new $TypeData().initClass({
  s_util_control_Exception$$anonfun$pfFromExceptions$1: 0
}, false, "scala.util.control.Exception$$anonfun$pfFromExceptions$1", {
  s_util_control_Exception$$anonfun$pfFromExceptions$1: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_s_util_control_Exception$$anonfun$pfFromExceptions$1.prototype.$classData = $d_s_util_control_Exception$$anonfun$pfFromExceptions$1;
/** @constructor */
function $c_Lscommons_api_StatusResponse(status) {
  this.Lscommons_api_StatusResponse__f_status = null;
  this.Lscommons_api_StatusResponse__f_status = status
}
$c_Lscommons_api_StatusResponse.prototype = new $h_O();
$c_Lscommons_api_StatusResponse.prototype.constructor = $c_Lscommons_api_StatusResponse;
/** @constructor */
function $h_Lscommons_api_StatusResponse() {
  /*<skip>*/
}
$h_Lscommons_api_StatusResponse.prototype = $c_Lscommons_api_StatusResponse.prototype;
$c_Lscommons_api_StatusResponse.prototype.productPrefix__T = (function() {
  return "StatusResponse"
});
$c_Lscommons_api_StatusResponse.prototype.productArity__I = (function() {
  return 1
});
$c_Lscommons_api_StatusResponse.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lscommons_api_StatusResponse__f_status : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lscommons_api_StatusResponse.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscommons_api_StatusResponse.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lscommons_api_StatusResponse.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lscommons_api_StatusResponse.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lscommons_api_StatusResponse)) {
    var StatusResponse$1 = $as_Lscommons_api_StatusResponse(x$1);
    var x = this.Lscommons_api_StatusResponse__f_status;
    var x$2 = StatusResponse$1.Lscommons_api_StatusResponse__f_status;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lscommons_api_StatusResponse(obj) {
  return (((obj instanceof $c_Lscommons_api_StatusResponse) || (obj === null)) ? obj : $throwClassCastException(obj, "scommons.api.StatusResponse"))
}
function $isArrayOf_Lscommons_api_StatusResponse(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscommons_api_StatusResponse)))
}
function $asArrayOf_Lscommons_api_StatusResponse(obj, depth) {
  return (($isArrayOf_Lscommons_api_StatusResponse(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscommons.api.StatusResponse;", depth))
}
var $d_Lscommons_api_StatusResponse = new $TypeData().initClass({
  Lscommons_api_StatusResponse: 0
}, false, "scommons.api.StatusResponse", {
  Lscommons_api_StatusResponse: 1,
  O: 1,
  Lscommons_api_ApiResponse: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscommons_api_StatusResponse.prototype.$classData = $d_Lscommons_api_StatusResponse;
/** @constructor */
function $c_Lscommons_expo_av_package$ExpoAVAttributes$ExpoAVSourceAttributeSpec(name) {
  this.Lscommons_expo_av_package$ExpoAVAttributes$ExpoAVSourceAttributeSpec__f_name = null;
  this.Lscommons_expo_av_package$ExpoAVAttributes$ExpoAVSourceAttributeSpec__f_name = name
}
$c_Lscommons_expo_av_package$ExpoAVAttributes$ExpoAVSourceAttributeSpec.prototype = new $h_O();
$c_Lscommons_expo_av_package$ExpoAVAttributes$ExpoAVSourceAttributeSpec.prototype.constructor = $c_Lscommons_expo_av_package$ExpoAVAttributes$ExpoAVSourceAttributeSpec;
/** @constructor */
function $h_Lscommons_expo_av_package$ExpoAVAttributes$ExpoAVSourceAttributeSpec() {
  /*<skip>*/
}
$h_Lscommons_expo_av_package$ExpoAVAttributes$ExpoAVSourceAttributeSpec.prototype = $c_Lscommons_expo_av_package$ExpoAVAttributes$ExpoAVSourceAttributeSpec.prototype;
$c_Lscommons_expo_av_package$ExpoAVAttributes$ExpoAVSourceAttributeSpec.prototype.$colon$eq__Lscommons_expo_av_raw_ExpoAVSource__Lio_github_shogowada_statictags_Attribute = (function(value) {
  return new $c_Lio_github_shogowada_statictags_Attribute(this.Lscommons_expo_av_package$ExpoAVAttributes$ExpoAVSourceAttributeSpec__f_name, value, $m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMAttributes__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$().Type__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$().AS_IS__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$AS\uff3fIS$())
});
$c_Lscommons_expo_av_package$ExpoAVAttributes$ExpoAVSourceAttributeSpec.prototype.productPrefix__T = (function() {
  return "ExpoAVSourceAttributeSpec"
});
$c_Lscommons_expo_av_package$ExpoAVAttributes$ExpoAVSourceAttributeSpec.prototype.productArity__I = (function() {
  return 1
});
$c_Lscommons_expo_av_package$ExpoAVAttributes$ExpoAVSourceAttributeSpec.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lscommons_expo_av_package$ExpoAVAttributes$ExpoAVSourceAttributeSpec__f_name : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lscommons_expo_av_package$ExpoAVAttributes$ExpoAVSourceAttributeSpec.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscommons_expo_av_package$ExpoAVAttributes$ExpoAVSourceAttributeSpec.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lscommons_expo_av_package$ExpoAVAttributes$ExpoAVSourceAttributeSpec.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lscommons_expo_av_package$ExpoAVAttributes$ExpoAVSourceAttributeSpec.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lscommons_expo_av_package$ExpoAVAttributes$ExpoAVSourceAttributeSpec)) {
    var ExpoAVSourceAttributeSpec$1 = $as_Lscommons_expo_av_package$ExpoAVAttributes$ExpoAVSourceAttributeSpec(x$1);
    return (this.Lscommons_expo_av_package$ExpoAVAttributes$ExpoAVSourceAttributeSpec__f_name === ExpoAVSourceAttributeSpec$1.Lscommons_expo_av_package$ExpoAVAttributes$ExpoAVSourceAttributeSpec__f_name)
  } else {
    return false
  }
});
function $as_Lscommons_expo_av_package$ExpoAVAttributes$ExpoAVSourceAttributeSpec(obj) {
  return (((obj instanceof $c_Lscommons_expo_av_package$ExpoAVAttributes$ExpoAVSourceAttributeSpec) || (obj === null)) ? obj : $throwClassCastException(obj, "scommons.expo.av.package$ExpoAVAttributes$ExpoAVSourceAttributeSpec"))
}
function $isArrayOf_Lscommons_expo_av_package$ExpoAVAttributes$ExpoAVSourceAttributeSpec(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscommons_expo_av_package$ExpoAVAttributes$ExpoAVSourceAttributeSpec)))
}
function $asArrayOf_Lscommons_expo_av_package$ExpoAVAttributes$ExpoAVSourceAttributeSpec(obj, depth) {
  return (($isArrayOf_Lscommons_expo_av_package$ExpoAVAttributes$ExpoAVSourceAttributeSpec(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscommons.expo.av.package$ExpoAVAttributes$ExpoAVSourceAttributeSpec;", depth))
}
var $d_Lscommons_expo_av_package$ExpoAVAttributes$ExpoAVSourceAttributeSpec = new $TypeData().initClass({
  Lscommons_expo_av_package$ExpoAVAttributes$ExpoAVSourceAttributeSpec: 0
}, false, "scommons.expo.av.package$ExpoAVAttributes$ExpoAVSourceAttributeSpec", {
  Lscommons_expo_av_package$ExpoAVAttributes$ExpoAVSourceAttributeSpec: 1,
  O: 1,
  Lio_github_shogowada_statictags_AttributeSpec: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscommons_expo_av_package$ExpoAVAttributes$ExpoAVSourceAttributeSpec.prototype.$classData = $d_Lscommons_expo_av_package$ExpoAVAttributes$ExpoAVSourceAttributeSpec;
/** @constructor */
function $c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenComponentAttributeSpec(name) {
  this.Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenComponentAttributeSpec__f_name = null;
  this.Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenComponentAttributeSpec__f_name = name
}
$c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenComponentAttributeSpec.prototype = new $h_O();
$c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenComponentAttributeSpec.prototype.constructor = $c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenComponentAttributeSpec;
/** @constructor */
function $h_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenComponentAttributeSpec() {
  /*<skip>*/
}
$h_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenComponentAttributeSpec.prototype = $c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenComponentAttributeSpec.prototype;
$c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenComponentAttributeSpec.prototype.$colon$eq__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass__Lio_github_shogowada_statictags_Attribute = (function(value) {
  return new $c_Lio_github_shogowada_statictags_Attribute(this.Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenComponentAttributeSpec__f_name, value, $m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMAttributes__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$().Type__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$().AS_IS__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$AS\uff3fIS$())
});
$c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenComponentAttributeSpec.prototype.productPrefix__T = (function() {
  return "ScreenComponentAttributeSpec"
});
$c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenComponentAttributeSpec.prototype.productArity__I = (function() {
  return 1
});
$c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenComponentAttributeSpec.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenComponentAttributeSpec__f_name : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenComponentAttributeSpec.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenComponentAttributeSpec.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenComponentAttributeSpec.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenComponentAttributeSpec.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenComponentAttributeSpec)) {
    var ScreenComponentAttributeSpec$1 = $as_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenComponentAttributeSpec(x$1);
    return (this.Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenComponentAttributeSpec__f_name === ScreenComponentAttributeSpec$1.Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenComponentAttributeSpec__f_name)
  } else {
    return false
  }
});
function $as_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenComponentAttributeSpec(obj) {
  return (((obj instanceof $c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenComponentAttributeSpec) || (obj === null)) ? obj : $throwClassCastException(obj, "scommons.react.navigation.package$NavigatorVirtualDOMAttributes$ScreenComponentAttributeSpec"))
}
function $isArrayOf_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenComponentAttributeSpec(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenComponentAttributeSpec)))
}
function $asArrayOf_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenComponentAttributeSpec(obj, depth) {
  return (($isArrayOf_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenComponentAttributeSpec(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscommons.react.navigation.package$NavigatorVirtualDOMAttributes$ScreenComponentAttributeSpec;", depth))
}
var $d_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenComponentAttributeSpec = new $TypeData().initClass({
  Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenComponentAttributeSpec: 0
}, false, "scommons.react.navigation.package$NavigatorVirtualDOMAttributes$ScreenComponentAttributeSpec", {
  Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenComponentAttributeSpec: 1,
  O: 1,
  Lio_github_shogowada_statictags_AttributeSpec: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenComponentAttributeSpec.prototype.$classData = $d_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenComponentAttributeSpec;
/** @constructor */
function $c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenOptionsAttributeSpec(name) {
  this.Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenOptionsAttributeSpec__f_name = null;
  this.Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenOptionsAttributeSpec__f_name = name
}
$c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenOptionsAttributeSpec.prototype = new $h_O();
$c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenOptionsAttributeSpec.prototype.constructor = $c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenOptionsAttributeSpec;
/** @constructor */
function $h_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenOptionsAttributeSpec() {
  /*<skip>*/
}
$h_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenOptionsAttributeSpec.prototype = $c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenOptionsAttributeSpec.prototype;
$c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenOptionsAttributeSpec.prototype.$colon$eq__Lscommons_react_navigation_raw_NavigatorScreenOptions__Lio_github_shogowada_statictags_Attribute = (function(value) {
  return new $c_Lio_github_shogowada_statictags_Attribute(this.Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenOptionsAttributeSpec__f_name, value, $m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMAttributes__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$().Type__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$().AS_IS__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$AS\uff3fIS$())
});
$c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenOptionsAttributeSpec.prototype.$colon$eq__sjs_js_Function1__Lio_github_shogowada_statictags_Attribute = (function(value) {
  return new $c_Lio_github_shogowada_statictags_Attribute(this.Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenOptionsAttributeSpec__f_name, value, $m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMAttributes__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$().Type__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$().AS_IS__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$AS\uff3fIS$())
});
$c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenOptionsAttributeSpec.prototype.productPrefix__T = (function() {
  return "ScreenOptionsAttributeSpec"
});
$c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenOptionsAttributeSpec.prototype.productArity__I = (function() {
  return 1
});
$c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenOptionsAttributeSpec.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenOptionsAttributeSpec__f_name : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenOptionsAttributeSpec.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenOptionsAttributeSpec.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenOptionsAttributeSpec.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenOptionsAttributeSpec.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenOptionsAttributeSpec)) {
    var ScreenOptionsAttributeSpec$1 = $as_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenOptionsAttributeSpec(x$1);
    return (this.Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenOptionsAttributeSpec__f_name === ScreenOptionsAttributeSpec$1.Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenOptionsAttributeSpec__f_name)
  } else {
    return false
  }
});
function $as_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenOptionsAttributeSpec(obj) {
  return (((obj instanceof $c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenOptionsAttributeSpec) || (obj === null)) ? obj : $throwClassCastException(obj, "scommons.react.navigation.package$NavigatorVirtualDOMAttributes$ScreenOptionsAttributeSpec"))
}
function $isArrayOf_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenOptionsAttributeSpec(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenOptionsAttributeSpec)))
}
function $asArrayOf_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenOptionsAttributeSpec(obj, depth) {
  return (($isArrayOf_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenOptionsAttributeSpec(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscommons.react.navigation.package$NavigatorVirtualDOMAttributes$ScreenOptionsAttributeSpec;", depth))
}
var $d_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenOptionsAttributeSpec = new $TypeData().initClass({
  Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenOptionsAttributeSpec: 0
}, false, "scommons.react.navigation.package$NavigatorVirtualDOMAttributes$ScreenOptionsAttributeSpec", {
  Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenOptionsAttributeSpec: 1,
  O: 1,
  Lio_github_shogowada_statictags_AttributeSpec: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenOptionsAttributeSpec.prototype.$classData = $d_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ScreenOptionsAttributeSpec;
/** @constructor */
function $c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ThemeAttributeSpec(name) {
  this.Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ThemeAttributeSpec__f_name = null;
  this.Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ThemeAttributeSpec__f_name = name
}
$c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ThemeAttributeSpec.prototype = new $h_O();
$c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ThemeAttributeSpec.prototype.constructor = $c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ThemeAttributeSpec;
/** @constructor */
function $h_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ThemeAttributeSpec() {
  /*<skip>*/
}
$h_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ThemeAttributeSpec.prototype = $c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ThemeAttributeSpec.prototype;
$c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ThemeAttributeSpec.prototype.$colon$eq__Lscommons_react_navigation_raw_Theme__Lio_github_shogowada_statictags_Attribute = (function(value) {
  return new $c_Lio_github_shogowada_statictags_Attribute(this.Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ThemeAttributeSpec__f_name, value, $m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMAttributes__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$().Type__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$().AS_IS__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$AS\uff3fIS$())
});
$c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ThemeAttributeSpec.prototype.productPrefix__T = (function() {
  return "ThemeAttributeSpec"
});
$c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ThemeAttributeSpec.prototype.productArity__I = (function() {
  return 1
});
$c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ThemeAttributeSpec.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ThemeAttributeSpec__f_name : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ThemeAttributeSpec.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ThemeAttributeSpec.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ThemeAttributeSpec.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ThemeAttributeSpec.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ThemeAttributeSpec)) {
    var ThemeAttributeSpec$1 = $as_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ThemeAttributeSpec(x$1);
    return (this.Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ThemeAttributeSpec__f_name === ThemeAttributeSpec$1.Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ThemeAttributeSpec__f_name)
  } else {
    return false
  }
});
function $as_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ThemeAttributeSpec(obj) {
  return (((obj instanceof $c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ThemeAttributeSpec) || (obj === null)) ? obj : $throwClassCastException(obj, "scommons.react.navigation.package$NavigatorVirtualDOMAttributes$ThemeAttributeSpec"))
}
function $isArrayOf_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ThemeAttributeSpec(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ThemeAttributeSpec)))
}
function $asArrayOf_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ThemeAttributeSpec(obj, depth) {
  return (($isArrayOf_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ThemeAttributeSpec(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscommons.react.navigation.package$NavigatorVirtualDOMAttributes$ThemeAttributeSpec;", depth))
}
var $d_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ThemeAttributeSpec = new $TypeData().initClass({
  Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ThemeAttributeSpec: 0
}, false, "scommons.react.navigation.package$NavigatorVirtualDOMAttributes$ThemeAttributeSpec", {
  Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ThemeAttributeSpec: 1,
  O: 1,
  Lio_github_shogowada_statictags_AttributeSpec: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ThemeAttributeSpec.prototype.$classData = $d_Lscommons_react_navigation_package$NavigatorVirtualDOMAttributes$ThemeAttributeSpec;
/** @constructor */
function $c_Lscommons_react_redux_task_FutureTask(message, future) {
  this.Lscommons_react_redux_task_FutureTask__f_message = null;
  this.Lscommons_react_redux_task_FutureTask__f_future = null;
  this.Lscommons_react_redux_task_FutureTask__f_startTime = $L0;
  this.Lscommons_react_redux_task_FutureTask__f_message = message;
  this.Lscommons_react_redux_task_FutureTask__f_future = future;
  var this$2 = $m_RTLong$();
  var value = $uD(new Date().getTime());
  var lo = this$2.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value);
  var hi = this$2.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  this.Lscommons_react_redux_task_FutureTask__f_startTime = new $c_RTLong(lo, hi)
}
$c_Lscommons_react_redux_task_FutureTask.prototype = new $h_O();
$c_Lscommons_react_redux_task_FutureTask.prototype.constructor = $c_Lscommons_react_redux_task_FutureTask;
/** @constructor */
function $h_Lscommons_react_redux_task_FutureTask() {
  /*<skip>*/
}
$h_Lscommons_react_redux_task_FutureTask.prototype = $c_Lscommons_react_redux_task_FutureTask.prototype;
$c_Lscommons_react_redux_task_FutureTask.prototype.productPrefix__T = (function() {
  return "FutureTask"
});
$c_Lscommons_react_redux_task_FutureTask.prototype.productArity__I = (function() {
  return 2
});
$c_Lscommons_react_redux_task_FutureTask.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lscommons_react_redux_task_FutureTask__f_message;
      break
    }
    case 1: {
      return this.Lscommons_react_redux_task_FutureTask__f_future;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lscommons_react_redux_task_FutureTask.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscommons_react_redux_task_FutureTask.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lscommons_react_redux_task_FutureTask.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lscommons_react_redux_task_FutureTask.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lscommons_react_redux_task_FutureTask)) {
    var FutureTask$1 = $as_Lscommons_react_redux_task_FutureTask(x$1);
    if ((this.Lscommons_react_redux_task_FutureTask__f_message === FutureTask$1.Lscommons_react_redux_task_FutureTask__f_message)) {
      var x = this.Lscommons_react_redux_task_FutureTask__f_future;
      var x$2 = FutureTask$1.Lscommons_react_redux_task_FutureTask__f_future;
      return (x === x$2)
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lscommons_react_redux_task_FutureTask(obj) {
  return (((obj instanceof $c_Lscommons_react_redux_task_FutureTask) || (obj === null)) ? obj : $throwClassCastException(obj, "scommons.react.redux.task.FutureTask"))
}
function $isArrayOf_Lscommons_react_redux_task_FutureTask(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscommons_react_redux_task_FutureTask)))
}
function $asArrayOf_Lscommons_react_redux_task_FutureTask(obj, depth) {
  return (($isArrayOf_Lscommons_react_redux_task_FutureTask(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscommons.react.redux.task.FutureTask;", depth))
}
var $d_Lscommons_react_redux_task_FutureTask = new $TypeData().initClass({
  Lscommons_react_redux_task_FutureTask: 0
}, false, "scommons.react.redux.task.FutureTask", {
  Lscommons_react_redux_task_FutureTask: 1,
  O: 1,
  Lscommons_react_redux_task_AbstractTask: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscommons_react_redux_task_FutureTask.prototype.$classData = $d_Lscommons_react_redux_task_FutureTask;
/** @constructor */
function $c_Lscommons_reactnative_ActivityIndicator$ActivityIndicatorAttributes$ActivityIndicatorSizeAttributeSpec(name) {
  this.Lscommons_reactnative_ActivityIndicator$ActivityIndicatorAttributes$ActivityIndicatorSizeAttributeSpec__f_name = null;
  this.Lscommons_reactnative_ActivityIndicator$ActivityIndicatorAttributes$ActivityIndicatorSizeAttributeSpec__f_name = name
}
$c_Lscommons_reactnative_ActivityIndicator$ActivityIndicatorAttributes$ActivityIndicatorSizeAttributeSpec.prototype = new $h_O();
$c_Lscommons_reactnative_ActivityIndicator$ActivityIndicatorAttributes$ActivityIndicatorSizeAttributeSpec.prototype.constructor = $c_Lscommons_reactnative_ActivityIndicator$ActivityIndicatorAttributes$ActivityIndicatorSizeAttributeSpec;
/** @constructor */
function $h_Lscommons_reactnative_ActivityIndicator$ActivityIndicatorAttributes$ActivityIndicatorSizeAttributeSpec() {
  /*<skip>*/
}
$h_Lscommons_reactnative_ActivityIndicator$ActivityIndicatorAttributes$ActivityIndicatorSizeAttributeSpec.prototype = $c_Lscommons_reactnative_ActivityIndicator$ActivityIndicatorAttributes$ActivityIndicatorSizeAttributeSpec.prototype;
$c_Lscommons_reactnative_ActivityIndicator$ActivityIndicatorAttributes$ActivityIndicatorSizeAttributeSpec.prototype.$colon$eq__Lscommons_reactnative_ActivityIndicator$ActivityIndicatorSize__Lio_github_shogowada_statictags_Attribute = (function(value) {
  return new $c_Lio_github_shogowada_statictags_Attribute(this.Lscommons_reactnative_ActivityIndicator$ActivityIndicatorAttributes$ActivityIndicatorSizeAttributeSpec__f_name, value, $m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMAttributes__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$().Type__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$().AS_IS__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$AS\uff3fIS$())
});
$c_Lscommons_reactnative_ActivityIndicator$ActivityIndicatorAttributes$ActivityIndicatorSizeAttributeSpec.prototype.productPrefix__T = (function() {
  return "ActivityIndicatorSizeAttributeSpec"
});
$c_Lscommons_reactnative_ActivityIndicator$ActivityIndicatorAttributes$ActivityIndicatorSizeAttributeSpec.prototype.productArity__I = (function() {
  return 1
});
$c_Lscommons_reactnative_ActivityIndicator$ActivityIndicatorAttributes$ActivityIndicatorSizeAttributeSpec.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lscommons_reactnative_ActivityIndicator$ActivityIndicatorAttributes$ActivityIndicatorSizeAttributeSpec__f_name : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lscommons_reactnative_ActivityIndicator$ActivityIndicatorAttributes$ActivityIndicatorSizeAttributeSpec.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscommons_reactnative_ActivityIndicator$ActivityIndicatorAttributes$ActivityIndicatorSizeAttributeSpec.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lscommons_reactnative_ActivityIndicator$ActivityIndicatorAttributes$ActivityIndicatorSizeAttributeSpec.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lscommons_reactnative_ActivityIndicator$ActivityIndicatorAttributes$ActivityIndicatorSizeAttributeSpec.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lscommons_reactnative_ActivityIndicator$ActivityIndicatorAttributes$ActivityIndicatorSizeAttributeSpec)) {
    var ActivityIndicatorSizeAttributeSpec$1 = $as_Lscommons_reactnative_ActivityIndicator$ActivityIndicatorAttributes$ActivityIndicatorSizeAttributeSpec(x$1);
    return (this.Lscommons_reactnative_ActivityIndicator$ActivityIndicatorAttributes$ActivityIndicatorSizeAttributeSpec__f_name === ActivityIndicatorSizeAttributeSpec$1.Lscommons_reactnative_ActivityIndicator$ActivityIndicatorAttributes$ActivityIndicatorSizeAttributeSpec__f_name)
  } else {
    return false
  }
});
function $as_Lscommons_reactnative_ActivityIndicator$ActivityIndicatorAttributes$ActivityIndicatorSizeAttributeSpec(obj) {
  return (((obj instanceof $c_Lscommons_reactnative_ActivityIndicator$ActivityIndicatorAttributes$ActivityIndicatorSizeAttributeSpec) || (obj === null)) ? obj : $throwClassCastException(obj, "scommons.reactnative.ActivityIndicator$ActivityIndicatorAttributes$ActivityIndicatorSizeAttributeSpec"))
}
function $isArrayOf_Lscommons_reactnative_ActivityIndicator$ActivityIndicatorAttributes$ActivityIndicatorSizeAttributeSpec(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscommons_reactnative_ActivityIndicator$ActivityIndicatorAttributes$ActivityIndicatorSizeAttributeSpec)))
}
function $asArrayOf_Lscommons_reactnative_ActivityIndicator$ActivityIndicatorAttributes$ActivityIndicatorSizeAttributeSpec(obj, depth) {
  return (($isArrayOf_Lscommons_reactnative_ActivityIndicator$ActivityIndicatorAttributes$ActivityIndicatorSizeAttributeSpec(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscommons.reactnative.ActivityIndicator$ActivityIndicatorAttributes$ActivityIndicatorSizeAttributeSpec;", depth))
}
var $d_Lscommons_reactnative_ActivityIndicator$ActivityIndicatorAttributes$ActivityIndicatorSizeAttributeSpec = new $TypeData().initClass({
  Lscommons_reactnative_ActivityIndicator$ActivityIndicatorAttributes$ActivityIndicatorSizeAttributeSpec: 0
}, false, "scommons.reactnative.ActivityIndicator$ActivityIndicatorAttributes$ActivityIndicatorSizeAttributeSpec", {
  Lscommons_reactnative_ActivityIndicator$ActivityIndicatorAttributes$ActivityIndicatorSizeAttributeSpec: 1,
  O: 1,
  Lio_github_shogowada_statictags_AttributeSpec: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscommons_reactnative_ActivityIndicator$ActivityIndicatorAttributes$ActivityIndicatorSizeAttributeSpec.prototype.$classData = $d_Lscommons_reactnative_ActivityIndicator$ActivityIndicatorAttributes$ActivityIndicatorSizeAttributeSpec;
/** @constructor */
function $c_Lscommons_reactnative_FlatList$FlatListAttributes$DataAttributeSpec(name) {
  this.Lscommons_reactnative_FlatList$FlatListAttributes$DataAttributeSpec__f_name = null;
  this.Lscommons_reactnative_FlatList$FlatListAttributes$DataAttributeSpec__f_name = name
}
$c_Lscommons_reactnative_FlatList$FlatListAttributes$DataAttributeSpec.prototype = new $h_O();
$c_Lscommons_reactnative_FlatList$FlatListAttributes$DataAttributeSpec.prototype.constructor = $c_Lscommons_reactnative_FlatList$FlatListAttributes$DataAttributeSpec;
/** @constructor */
function $h_Lscommons_reactnative_FlatList$FlatListAttributes$DataAttributeSpec() {
  /*<skip>*/
}
$h_Lscommons_reactnative_FlatList$FlatListAttributes$DataAttributeSpec.prototype = $c_Lscommons_reactnative_FlatList$FlatListAttributes$DataAttributeSpec.prototype;
$c_Lscommons_reactnative_FlatList$FlatListAttributes$DataAttributeSpec.prototype.$colon$eq__sjs_js_Array__Lio_github_shogowada_statictags_Attribute = (function(value) {
  return new $c_Lio_github_shogowada_statictags_Attribute(this.Lscommons_reactnative_FlatList$FlatListAttributes$DataAttributeSpec__f_name, value, $m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMAttributes__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$().Type__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$().AS_IS__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$AS\uff3fIS$())
});
$c_Lscommons_reactnative_FlatList$FlatListAttributes$DataAttributeSpec.prototype.productPrefix__T = (function() {
  return "DataAttributeSpec"
});
$c_Lscommons_reactnative_FlatList$FlatListAttributes$DataAttributeSpec.prototype.productArity__I = (function() {
  return 1
});
$c_Lscommons_reactnative_FlatList$FlatListAttributes$DataAttributeSpec.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lscommons_reactnative_FlatList$FlatListAttributes$DataAttributeSpec__f_name : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lscommons_reactnative_FlatList$FlatListAttributes$DataAttributeSpec.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscommons_reactnative_FlatList$FlatListAttributes$DataAttributeSpec.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lscommons_reactnative_FlatList$FlatListAttributes$DataAttributeSpec.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lscommons_reactnative_FlatList$FlatListAttributes$DataAttributeSpec.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lscommons_reactnative_FlatList$FlatListAttributes$DataAttributeSpec)) {
    var DataAttributeSpec$1 = $as_Lscommons_reactnative_FlatList$FlatListAttributes$DataAttributeSpec(x$1);
    return (this.Lscommons_reactnative_FlatList$FlatListAttributes$DataAttributeSpec__f_name === DataAttributeSpec$1.Lscommons_reactnative_FlatList$FlatListAttributes$DataAttributeSpec__f_name)
  } else {
    return false
  }
});
function $as_Lscommons_reactnative_FlatList$FlatListAttributes$DataAttributeSpec(obj) {
  return (((obj instanceof $c_Lscommons_reactnative_FlatList$FlatListAttributes$DataAttributeSpec) || (obj === null)) ? obj : $throwClassCastException(obj, "scommons.reactnative.FlatList$FlatListAttributes$DataAttributeSpec"))
}
function $isArrayOf_Lscommons_reactnative_FlatList$FlatListAttributes$DataAttributeSpec(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscommons_reactnative_FlatList$FlatListAttributes$DataAttributeSpec)))
}
function $asArrayOf_Lscommons_reactnative_FlatList$FlatListAttributes$DataAttributeSpec(obj, depth) {
  return (($isArrayOf_Lscommons_reactnative_FlatList$FlatListAttributes$DataAttributeSpec(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscommons.reactnative.FlatList$FlatListAttributes$DataAttributeSpec;", depth))
}
var $d_Lscommons_reactnative_FlatList$FlatListAttributes$DataAttributeSpec = new $TypeData().initClass({
  Lscommons_reactnative_FlatList$FlatListAttributes$DataAttributeSpec: 0
}, false, "scommons.reactnative.FlatList$FlatListAttributes$DataAttributeSpec", {
  Lscommons_reactnative_FlatList$FlatListAttributes$DataAttributeSpec: 1,
  O: 1,
  Lio_github_shogowada_statictags_AttributeSpec: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscommons_reactnative_FlatList$FlatListAttributes$DataAttributeSpec.prototype.$classData = $d_Lscommons_reactnative_FlatList$FlatListAttributes$DataAttributeSpec;
/** @constructor */
function $c_Lscommons_reactnative_FlatList$FlatListAttributes$ExtraDataAttributeSpec(name) {
  this.Lscommons_reactnative_FlatList$FlatListAttributes$ExtraDataAttributeSpec__f_name = null;
  this.Lscommons_reactnative_FlatList$FlatListAttributes$ExtraDataAttributeSpec__f_name = name
}
$c_Lscommons_reactnative_FlatList$FlatListAttributes$ExtraDataAttributeSpec.prototype = new $h_O();
$c_Lscommons_reactnative_FlatList$FlatListAttributes$ExtraDataAttributeSpec.prototype.constructor = $c_Lscommons_reactnative_FlatList$FlatListAttributes$ExtraDataAttributeSpec;
/** @constructor */
function $h_Lscommons_reactnative_FlatList$FlatListAttributes$ExtraDataAttributeSpec() {
  /*<skip>*/
}
$h_Lscommons_reactnative_FlatList$FlatListAttributes$ExtraDataAttributeSpec.prototype = $c_Lscommons_reactnative_FlatList$FlatListAttributes$ExtraDataAttributeSpec.prototype;
$c_Lscommons_reactnative_FlatList$FlatListAttributes$ExtraDataAttributeSpec.prototype.$colon$eq__O__Lio_github_shogowada_statictags_Attribute = (function(value) {
  return new $c_Lio_github_shogowada_statictags_Attribute(this.Lscommons_reactnative_FlatList$FlatListAttributes$ExtraDataAttributeSpec__f_name, value, $m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMAttributes__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$().Type__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$().AS_IS__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$AS\uff3fIS$())
});
$c_Lscommons_reactnative_FlatList$FlatListAttributes$ExtraDataAttributeSpec.prototype.productPrefix__T = (function() {
  return "ExtraDataAttributeSpec"
});
$c_Lscommons_reactnative_FlatList$FlatListAttributes$ExtraDataAttributeSpec.prototype.productArity__I = (function() {
  return 1
});
$c_Lscommons_reactnative_FlatList$FlatListAttributes$ExtraDataAttributeSpec.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lscommons_reactnative_FlatList$FlatListAttributes$ExtraDataAttributeSpec__f_name : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lscommons_reactnative_FlatList$FlatListAttributes$ExtraDataAttributeSpec.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscommons_reactnative_FlatList$FlatListAttributes$ExtraDataAttributeSpec.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lscommons_reactnative_FlatList$FlatListAttributes$ExtraDataAttributeSpec.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lscommons_reactnative_FlatList$FlatListAttributes$ExtraDataAttributeSpec.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lscommons_reactnative_FlatList$FlatListAttributes$ExtraDataAttributeSpec)) {
    var ExtraDataAttributeSpec$1 = $as_Lscommons_reactnative_FlatList$FlatListAttributes$ExtraDataAttributeSpec(x$1);
    return (this.Lscommons_reactnative_FlatList$FlatListAttributes$ExtraDataAttributeSpec__f_name === ExtraDataAttributeSpec$1.Lscommons_reactnative_FlatList$FlatListAttributes$ExtraDataAttributeSpec__f_name)
  } else {
    return false
  }
});
function $as_Lscommons_reactnative_FlatList$FlatListAttributes$ExtraDataAttributeSpec(obj) {
  return (((obj instanceof $c_Lscommons_reactnative_FlatList$FlatListAttributes$ExtraDataAttributeSpec) || (obj === null)) ? obj : $throwClassCastException(obj, "scommons.reactnative.FlatList$FlatListAttributes$ExtraDataAttributeSpec"))
}
function $isArrayOf_Lscommons_reactnative_FlatList$FlatListAttributes$ExtraDataAttributeSpec(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscommons_reactnative_FlatList$FlatListAttributes$ExtraDataAttributeSpec)))
}
function $asArrayOf_Lscommons_reactnative_FlatList$FlatListAttributes$ExtraDataAttributeSpec(obj, depth) {
  return (($isArrayOf_Lscommons_reactnative_FlatList$FlatListAttributes$ExtraDataAttributeSpec(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscommons.reactnative.FlatList$FlatListAttributes$ExtraDataAttributeSpec;", depth))
}
var $d_Lscommons_reactnative_FlatList$FlatListAttributes$ExtraDataAttributeSpec = new $TypeData().initClass({
  Lscommons_reactnative_FlatList$FlatListAttributes$ExtraDataAttributeSpec: 0
}, false, "scommons.reactnative.FlatList$FlatListAttributes$ExtraDataAttributeSpec", {
  Lscommons_reactnative_FlatList$FlatListAttributes$ExtraDataAttributeSpec: 1,
  O: 1,
  Lio_github_shogowada_statictags_AttributeSpec: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscommons_reactnative_FlatList$FlatListAttributes$ExtraDataAttributeSpec.prototype.$classData = $d_Lscommons_reactnative_FlatList$FlatListAttributes$ExtraDataAttributeSpec;
/** @constructor */
function $c_Lscommons_reactnative_FlatList$FlatListAttributes$KeyExtractorAttributeSpec(name) {
  this.Lscommons_reactnative_FlatList$FlatListAttributes$KeyExtractorAttributeSpec__f_name = null;
  this.Lscommons_reactnative_FlatList$FlatListAttributes$KeyExtractorAttributeSpec__f_name = name
}
$c_Lscommons_reactnative_FlatList$FlatListAttributes$KeyExtractorAttributeSpec.prototype = new $h_O();
$c_Lscommons_reactnative_FlatList$FlatListAttributes$KeyExtractorAttributeSpec.prototype.constructor = $c_Lscommons_reactnative_FlatList$FlatListAttributes$KeyExtractorAttributeSpec;
/** @constructor */
function $h_Lscommons_reactnative_FlatList$FlatListAttributes$KeyExtractorAttributeSpec() {
  /*<skip>*/
}
$h_Lscommons_reactnative_FlatList$FlatListAttributes$KeyExtractorAttributeSpec.prototype = $c_Lscommons_reactnative_FlatList$FlatListAttributes$KeyExtractorAttributeSpec.prototype;
$c_Lscommons_reactnative_FlatList$FlatListAttributes$KeyExtractorAttributeSpec.prototype.$colon$eq__sjs_js_Function1__Lio_github_shogowada_statictags_Attribute = (function(value) {
  return new $c_Lio_github_shogowada_statictags_Attribute(this.Lscommons_reactnative_FlatList$FlatListAttributes$KeyExtractorAttributeSpec__f_name, value, $m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMAttributes__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$().Type__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$().AS_IS__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$AS\uff3fIS$())
});
$c_Lscommons_reactnative_FlatList$FlatListAttributes$KeyExtractorAttributeSpec.prototype.productPrefix__T = (function() {
  return "KeyExtractorAttributeSpec"
});
$c_Lscommons_reactnative_FlatList$FlatListAttributes$KeyExtractorAttributeSpec.prototype.productArity__I = (function() {
  return 1
});
$c_Lscommons_reactnative_FlatList$FlatListAttributes$KeyExtractorAttributeSpec.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lscommons_reactnative_FlatList$FlatListAttributes$KeyExtractorAttributeSpec__f_name : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lscommons_reactnative_FlatList$FlatListAttributes$KeyExtractorAttributeSpec.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscommons_reactnative_FlatList$FlatListAttributes$KeyExtractorAttributeSpec.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lscommons_reactnative_FlatList$FlatListAttributes$KeyExtractorAttributeSpec.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lscommons_reactnative_FlatList$FlatListAttributes$KeyExtractorAttributeSpec.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lscommons_reactnative_FlatList$FlatListAttributes$KeyExtractorAttributeSpec)) {
    var KeyExtractorAttributeSpec$1 = $as_Lscommons_reactnative_FlatList$FlatListAttributes$KeyExtractorAttributeSpec(x$1);
    return (this.Lscommons_reactnative_FlatList$FlatListAttributes$KeyExtractorAttributeSpec__f_name === KeyExtractorAttributeSpec$1.Lscommons_reactnative_FlatList$FlatListAttributes$KeyExtractorAttributeSpec__f_name)
  } else {
    return false
  }
});
function $as_Lscommons_reactnative_FlatList$FlatListAttributes$KeyExtractorAttributeSpec(obj) {
  return (((obj instanceof $c_Lscommons_reactnative_FlatList$FlatListAttributes$KeyExtractorAttributeSpec) || (obj === null)) ? obj : $throwClassCastException(obj, "scommons.reactnative.FlatList$FlatListAttributes$KeyExtractorAttributeSpec"))
}
function $isArrayOf_Lscommons_reactnative_FlatList$FlatListAttributes$KeyExtractorAttributeSpec(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscommons_reactnative_FlatList$FlatListAttributes$KeyExtractorAttributeSpec)))
}
function $asArrayOf_Lscommons_reactnative_FlatList$FlatListAttributes$KeyExtractorAttributeSpec(obj, depth) {
  return (($isArrayOf_Lscommons_reactnative_FlatList$FlatListAttributes$KeyExtractorAttributeSpec(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscommons.reactnative.FlatList$FlatListAttributes$KeyExtractorAttributeSpec;", depth))
}
var $d_Lscommons_reactnative_FlatList$FlatListAttributes$KeyExtractorAttributeSpec = new $TypeData().initClass({
  Lscommons_reactnative_FlatList$FlatListAttributes$KeyExtractorAttributeSpec: 0
}, false, "scommons.reactnative.FlatList$FlatListAttributes$KeyExtractorAttributeSpec", {
  Lscommons_reactnative_FlatList$FlatListAttributes$KeyExtractorAttributeSpec: 1,
  O: 1,
  Lio_github_shogowada_statictags_AttributeSpec: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscommons_reactnative_FlatList$FlatListAttributes$KeyExtractorAttributeSpec.prototype.$classData = $d_Lscommons_reactnative_FlatList$FlatListAttributes$KeyExtractorAttributeSpec;
/** @constructor */
function $c_Lscommons_reactnative_FlatList$FlatListAttributes$OnRefreshAttributeSpec(name) {
  this.Lscommons_reactnative_FlatList$FlatListAttributes$OnRefreshAttributeSpec__f_name = null;
  this.Lscommons_reactnative_FlatList$FlatListAttributes$OnRefreshAttributeSpec__f_name = name
}
$c_Lscommons_reactnative_FlatList$FlatListAttributes$OnRefreshAttributeSpec.prototype = new $h_O();
$c_Lscommons_reactnative_FlatList$FlatListAttributes$OnRefreshAttributeSpec.prototype.constructor = $c_Lscommons_reactnative_FlatList$FlatListAttributes$OnRefreshAttributeSpec;
/** @constructor */
function $h_Lscommons_reactnative_FlatList$FlatListAttributes$OnRefreshAttributeSpec() {
  /*<skip>*/
}
$h_Lscommons_reactnative_FlatList$FlatListAttributes$OnRefreshAttributeSpec.prototype = $c_Lscommons_reactnative_FlatList$FlatListAttributes$OnRefreshAttributeSpec.prototype;
$c_Lscommons_reactnative_FlatList$FlatListAttributes$OnRefreshAttributeSpec.prototype.$colon$eq__sjs_js_Function0__Lio_github_shogowada_statictags_Attribute = (function(onRefresh) {
  return new $c_Lio_github_shogowada_statictags_Attribute(this.Lscommons_reactnative_FlatList$FlatListAttributes$OnRefreshAttributeSpec__f_name, onRefresh, $m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMAttributes__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$().Type__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$().AS_IS__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$AS\uff3fIS$())
});
$c_Lscommons_reactnative_FlatList$FlatListAttributes$OnRefreshAttributeSpec.prototype.productPrefix__T = (function() {
  return "OnRefreshAttributeSpec"
});
$c_Lscommons_reactnative_FlatList$FlatListAttributes$OnRefreshAttributeSpec.prototype.productArity__I = (function() {
  return 1
});
$c_Lscommons_reactnative_FlatList$FlatListAttributes$OnRefreshAttributeSpec.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lscommons_reactnative_FlatList$FlatListAttributes$OnRefreshAttributeSpec__f_name : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lscommons_reactnative_FlatList$FlatListAttributes$OnRefreshAttributeSpec.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscommons_reactnative_FlatList$FlatListAttributes$OnRefreshAttributeSpec.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lscommons_reactnative_FlatList$FlatListAttributes$OnRefreshAttributeSpec.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lscommons_reactnative_FlatList$FlatListAttributes$OnRefreshAttributeSpec.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lscommons_reactnative_FlatList$FlatListAttributes$OnRefreshAttributeSpec)) {
    var OnRefreshAttributeSpec$1 = $as_Lscommons_reactnative_FlatList$FlatListAttributes$OnRefreshAttributeSpec(x$1);
    return (this.Lscommons_reactnative_FlatList$FlatListAttributes$OnRefreshAttributeSpec__f_name === OnRefreshAttributeSpec$1.Lscommons_reactnative_FlatList$FlatListAttributes$OnRefreshAttributeSpec__f_name)
  } else {
    return false
  }
});
function $as_Lscommons_reactnative_FlatList$FlatListAttributes$OnRefreshAttributeSpec(obj) {
  return (((obj instanceof $c_Lscommons_reactnative_FlatList$FlatListAttributes$OnRefreshAttributeSpec) || (obj === null)) ? obj : $throwClassCastException(obj, "scommons.reactnative.FlatList$FlatListAttributes$OnRefreshAttributeSpec"))
}
function $isArrayOf_Lscommons_reactnative_FlatList$FlatListAttributes$OnRefreshAttributeSpec(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscommons_reactnative_FlatList$FlatListAttributes$OnRefreshAttributeSpec)))
}
function $asArrayOf_Lscommons_reactnative_FlatList$FlatListAttributes$OnRefreshAttributeSpec(obj, depth) {
  return (($isArrayOf_Lscommons_reactnative_FlatList$FlatListAttributes$OnRefreshAttributeSpec(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscommons.reactnative.FlatList$FlatListAttributes$OnRefreshAttributeSpec;", depth))
}
var $d_Lscommons_reactnative_FlatList$FlatListAttributes$OnRefreshAttributeSpec = new $TypeData().initClass({
  Lscommons_reactnative_FlatList$FlatListAttributes$OnRefreshAttributeSpec: 0
}, false, "scommons.reactnative.FlatList$FlatListAttributes$OnRefreshAttributeSpec", {
  Lscommons_reactnative_FlatList$FlatListAttributes$OnRefreshAttributeSpec: 1,
  O: 1,
  Lio_github_shogowada_statictags_AttributeSpec: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscommons_reactnative_FlatList$FlatListAttributes$OnRefreshAttributeSpec.prototype.$classData = $d_Lscommons_reactnative_FlatList$FlatListAttributes$OnRefreshAttributeSpec;
/** @constructor */
function $c_Lscommons_reactnative_FlatList$FlatListAttributes$RenderItemAttributeSpec(name) {
  this.Lscommons_reactnative_FlatList$FlatListAttributes$RenderItemAttributeSpec__f_name = null;
  this.Lscommons_reactnative_FlatList$FlatListAttributes$RenderItemAttributeSpec__f_name = name
}
$c_Lscommons_reactnative_FlatList$FlatListAttributes$RenderItemAttributeSpec.prototype = new $h_O();
$c_Lscommons_reactnative_FlatList$FlatListAttributes$RenderItemAttributeSpec.prototype.constructor = $c_Lscommons_reactnative_FlatList$FlatListAttributes$RenderItemAttributeSpec;
/** @constructor */
function $h_Lscommons_reactnative_FlatList$FlatListAttributes$RenderItemAttributeSpec() {
  /*<skip>*/
}
$h_Lscommons_reactnative_FlatList$FlatListAttributes$RenderItemAttributeSpec.prototype = $c_Lscommons_reactnative_FlatList$FlatListAttributes$RenderItemAttributeSpec.prototype;
$c_Lscommons_reactnative_FlatList$FlatListAttributes$RenderItemAttributeSpec.prototype.$colon$eq__sjs_js_Function1__Lio_github_shogowada_statictags_Attribute = (function(value) {
  return new $c_Lio_github_shogowada_statictags_Attribute(this.Lscommons_reactnative_FlatList$FlatListAttributes$RenderItemAttributeSpec__f_name, value, $m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMAttributes__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$().Type__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$().AS_IS__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$AS\uff3fIS$())
});
$c_Lscommons_reactnative_FlatList$FlatListAttributes$RenderItemAttributeSpec.prototype.productPrefix__T = (function() {
  return "RenderItemAttributeSpec"
});
$c_Lscommons_reactnative_FlatList$FlatListAttributes$RenderItemAttributeSpec.prototype.productArity__I = (function() {
  return 1
});
$c_Lscommons_reactnative_FlatList$FlatListAttributes$RenderItemAttributeSpec.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lscommons_reactnative_FlatList$FlatListAttributes$RenderItemAttributeSpec__f_name : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lscommons_reactnative_FlatList$FlatListAttributes$RenderItemAttributeSpec.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscommons_reactnative_FlatList$FlatListAttributes$RenderItemAttributeSpec.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lscommons_reactnative_FlatList$FlatListAttributes$RenderItemAttributeSpec.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lscommons_reactnative_FlatList$FlatListAttributes$RenderItemAttributeSpec.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lscommons_reactnative_FlatList$FlatListAttributes$RenderItemAttributeSpec)) {
    var RenderItemAttributeSpec$1 = $as_Lscommons_reactnative_FlatList$FlatListAttributes$RenderItemAttributeSpec(x$1);
    return (this.Lscommons_reactnative_FlatList$FlatListAttributes$RenderItemAttributeSpec__f_name === RenderItemAttributeSpec$1.Lscommons_reactnative_FlatList$FlatListAttributes$RenderItemAttributeSpec__f_name)
  } else {
    return false
  }
});
function $as_Lscommons_reactnative_FlatList$FlatListAttributes$RenderItemAttributeSpec(obj) {
  return (((obj instanceof $c_Lscommons_reactnative_FlatList$FlatListAttributes$RenderItemAttributeSpec) || (obj === null)) ? obj : $throwClassCastException(obj, "scommons.reactnative.FlatList$FlatListAttributes$RenderItemAttributeSpec"))
}
function $isArrayOf_Lscommons_reactnative_FlatList$FlatListAttributes$RenderItemAttributeSpec(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscommons_reactnative_FlatList$FlatListAttributes$RenderItemAttributeSpec)))
}
function $asArrayOf_Lscommons_reactnative_FlatList$FlatListAttributes$RenderItemAttributeSpec(obj, depth) {
  return (($isArrayOf_Lscommons_reactnative_FlatList$FlatListAttributes$RenderItemAttributeSpec(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscommons.reactnative.FlatList$FlatListAttributes$RenderItemAttributeSpec;", depth))
}
var $d_Lscommons_reactnative_FlatList$FlatListAttributes$RenderItemAttributeSpec = new $TypeData().initClass({
  Lscommons_reactnative_FlatList$FlatListAttributes$RenderItemAttributeSpec: 0
}, false, "scommons.reactnative.FlatList$FlatListAttributes$RenderItemAttributeSpec", {
  Lscommons_reactnative_FlatList$FlatListAttributes$RenderItemAttributeSpec: 1,
  O: 1,
  Lio_github_shogowada_statictags_AttributeSpec: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscommons_reactnative_FlatList$FlatListAttributes$RenderItemAttributeSpec.prototype.$classData = $d_Lscommons_reactnative_FlatList$FlatListAttributes$RenderItemAttributeSpec;
/** @constructor */
function $c_Lscommons_reactnative_Image$ImageAttributes$ImageSourceAttributeSpec(name) {
  this.Lscommons_reactnative_Image$ImageAttributes$ImageSourceAttributeSpec__f_name = null;
  this.Lscommons_reactnative_Image$ImageAttributes$ImageSourceAttributeSpec__f_name = name
}
$c_Lscommons_reactnative_Image$ImageAttributes$ImageSourceAttributeSpec.prototype = new $h_O();
$c_Lscommons_reactnative_Image$ImageAttributes$ImageSourceAttributeSpec.prototype.constructor = $c_Lscommons_reactnative_Image$ImageAttributes$ImageSourceAttributeSpec;
/** @constructor */
function $h_Lscommons_reactnative_Image$ImageAttributes$ImageSourceAttributeSpec() {
  /*<skip>*/
}
$h_Lscommons_reactnative_Image$ImageAttributes$ImageSourceAttributeSpec.prototype = $c_Lscommons_reactnative_Image$ImageAttributes$ImageSourceAttributeSpec.prototype;
$c_Lscommons_reactnative_Image$ImageAttributes$ImageSourceAttributeSpec.prototype.$colon$eq__Lscommons_reactnative_raw_StaticResource__Lio_github_shogowada_statictags_Attribute = (function(value) {
  return new $c_Lio_github_shogowada_statictags_Attribute(this.Lscommons_reactnative_Image$ImageAttributes$ImageSourceAttributeSpec__f_name, value, $m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMAttributes__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$().Type__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$().AS_IS__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$AS\uff3fIS$())
});
$c_Lscommons_reactnative_Image$ImageAttributes$ImageSourceAttributeSpec.prototype.$colon$eq__Lscommons_reactnative_raw_UriResource__Lio_github_shogowada_statictags_Attribute = (function(value) {
  return new $c_Lio_github_shogowada_statictags_Attribute(this.Lscommons_reactnative_Image$ImageAttributes$ImageSourceAttributeSpec__f_name, value, $m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMAttributes__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$().Type__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$().AS_IS__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$AS\uff3fIS$())
});
$c_Lscommons_reactnative_Image$ImageAttributes$ImageSourceAttributeSpec.prototype.productPrefix__T = (function() {
  return "ImageSourceAttributeSpec"
});
$c_Lscommons_reactnative_Image$ImageAttributes$ImageSourceAttributeSpec.prototype.productArity__I = (function() {
  return 1
});
$c_Lscommons_reactnative_Image$ImageAttributes$ImageSourceAttributeSpec.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lscommons_reactnative_Image$ImageAttributes$ImageSourceAttributeSpec__f_name : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lscommons_reactnative_Image$ImageAttributes$ImageSourceAttributeSpec.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscommons_reactnative_Image$ImageAttributes$ImageSourceAttributeSpec.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lscommons_reactnative_Image$ImageAttributes$ImageSourceAttributeSpec.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lscommons_reactnative_Image$ImageAttributes$ImageSourceAttributeSpec.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lscommons_reactnative_Image$ImageAttributes$ImageSourceAttributeSpec)) {
    var ImageSourceAttributeSpec$1 = $as_Lscommons_reactnative_Image$ImageAttributes$ImageSourceAttributeSpec(x$1);
    return (this.Lscommons_reactnative_Image$ImageAttributes$ImageSourceAttributeSpec__f_name === ImageSourceAttributeSpec$1.Lscommons_reactnative_Image$ImageAttributes$ImageSourceAttributeSpec__f_name)
  } else {
    return false
  }
});
function $as_Lscommons_reactnative_Image$ImageAttributes$ImageSourceAttributeSpec(obj) {
  return (((obj instanceof $c_Lscommons_reactnative_Image$ImageAttributes$ImageSourceAttributeSpec) || (obj === null)) ? obj : $throwClassCastException(obj, "scommons.reactnative.Image$ImageAttributes$ImageSourceAttributeSpec"))
}
function $isArrayOf_Lscommons_reactnative_Image$ImageAttributes$ImageSourceAttributeSpec(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscommons_reactnative_Image$ImageAttributes$ImageSourceAttributeSpec)))
}
function $asArrayOf_Lscommons_reactnative_Image$ImageAttributes$ImageSourceAttributeSpec(obj, depth) {
  return (($isArrayOf_Lscommons_reactnative_Image$ImageAttributes$ImageSourceAttributeSpec(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscommons.reactnative.Image$ImageAttributes$ImageSourceAttributeSpec;", depth))
}
var $d_Lscommons_reactnative_Image$ImageAttributes$ImageSourceAttributeSpec = new $TypeData().initClass({
  Lscommons_reactnative_Image$ImageAttributes$ImageSourceAttributeSpec: 0
}, false, "scommons.reactnative.Image$ImageAttributes$ImageSourceAttributeSpec", {
  Lscommons_reactnative_Image$ImageAttributes$ImageSourceAttributeSpec: 1,
  O: 1,
  Lio_github_shogowada_statictags_AttributeSpec: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscommons_reactnative_Image$ImageAttributes$ImageSourceAttributeSpec.prototype.$classData = $d_Lscommons_reactnative_Image$ImageAttributes$ImageSourceAttributeSpec;
/** @constructor */
function $c_Lscommons_reactnative_Modal$ModalAttributes$AnimationTypeAttributeSpec(name) {
  this.Lscommons_reactnative_Modal$ModalAttributes$AnimationTypeAttributeSpec__f_name = null;
  this.Lscommons_reactnative_Modal$ModalAttributes$AnimationTypeAttributeSpec__f_name = name
}
$c_Lscommons_reactnative_Modal$ModalAttributes$AnimationTypeAttributeSpec.prototype = new $h_O();
$c_Lscommons_reactnative_Modal$ModalAttributes$AnimationTypeAttributeSpec.prototype.constructor = $c_Lscommons_reactnative_Modal$ModalAttributes$AnimationTypeAttributeSpec;
/** @constructor */
function $h_Lscommons_reactnative_Modal$ModalAttributes$AnimationTypeAttributeSpec() {
  /*<skip>*/
}
$h_Lscommons_reactnative_Modal$ModalAttributes$AnimationTypeAttributeSpec.prototype = $c_Lscommons_reactnative_Modal$ModalAttributes$AnimationTypeAttributeSpec.prototype;
$c_Lscommons_reactnative_Modal$ModalAttributes$AnimationTypeAttributeSpec.prototype.$colon$eq__Lscommons_reactnative_Modal$AnimationType__Lio_github_shogowada_statictags_Attribute = (function(value) {
  return new $c_Lio_github_shogowada_statictags_Attribute(this.Lscommons_reactnative_Modal$ModalAttributes$AnimationTypeAttributeSpec__f_name, value, $m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMAttributes__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$().Type__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$().AS_IS__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$AS\uff3fIS$())
});
$c_Lscommons_reactnative_Modal$ModalAttributes$AnimationTypeAttributeSpec.prototype.productPrefix__T = (function() {
  return "AnimationTypeAttributeSpec"
});
$c_Lscommons_reactnative_Modal$ModalAttributes$AnimationTypeAttributeSpec.prototype.productArity__I = (function() {
  return 1
});
$c_Lscommons_reactnative_Modal$ModalAttributes$AnimationTypeAttributeSpec.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lscommons_reactnative_Modal$ModalAttributes$AnimationTypeAttributeSpec__f_name : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lscommons_reactnative_Modal$ModalAttributes$AnimationTypeAttributeSpec.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscommons_reactnative_Modal$ModalAttributes$AnimationTypeAttributeSpec.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lscommons_reactnative_Modal$ModalAttributes$AnimationTypeAttributeSpec.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lscommons_reactnative_Modal$ModalAttributes$AnimationTypeAttributeSpec.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lscommons_reactnative_Modal$ModalAttributes$AnimationTypeAttributeSpec)) {
    var AnimationTypeAttributeSpec$1 = $as_Lscommons_reactnative_Modal$ModalAttributes$AnimationTypeAttributeSpec(x$1);
    return (this.Lscommons_reactnative_Modal$ModalAttributes$AnimationTypeAttributeSpec__f_name === AnimationTypeAttributeSpec$1.Lscommons_reactnative_Modal$ModalAttributes$AnimationTypeAttributeSpec__f_name)
  } else {
    return false
  }
});
function $as_Lscommons_reactnative_Modal$ModalAttributes$AnimationTypeAttributeSpec(obj) {
  return (((obj instanceof $c_Lscommons_reactnative_Modal$ModalAttributes$AnimationTypeAttributeSpec) || (obj === null)) ? obj : $throwClassCastException(obj, "scommons.reactnative.Modal$ModalAttributes$AnimationTypeAttributeSpec"))
}
function $isArrayOf_Lscommons_reactnative_Modal$ModalAttributes$AnimationTypeAttributeSpec(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscommons_reactnative_Modal$ModalAttributes$AnimationTypeAttributeSpec)))
}
function $asArrayOf_Lscommons_reactnative_Modal$ModalAttributes$AnimationTypeAttributeSpec(obj, depth) {
  return (($isArrayOf_Lscommons_reactnative_Modal$ModalAttributes$AnimationTypeAttributeSpec(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscommons.reactnative.Modal$ModalAttributes$AnimationTypeAttributeSpec;", depth))
}
var $d_Lscommons_reactnative_Modal$ModalAttributes$AnimationTypeAttributeSpec = new $TypeData().initClass({
  Lscommons_reactnative_Modal$ModalAttributes$AnimationTypeAttributeSpec: 0
}, false, "scommons.reactnative.Modal$ModalAttributes$AnimationTypeAttributeSpec", {
  Lscommons_reactnative_Modal$ModalAttributes$AnimationTypeAttributeSpec: 1,
  O: 1,
  Lio_github_shogowada_statictags_AttributeSpec: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscommons_reactnative_Modal$ModalAttributes$AnimationTypeAttributeSpec.prototype.$classData = $d_Lscommons_reactnative_Modal$ModalAttributes$AnimationTypeAttributeSpec;
/** @constructor */
function $c_Lscommons_reactnative_Modal$ModalAttributes$Function0AttributeSpec(name) {
  this.Lscommons_reactnative_Modal$ModalAttributes$Function0AttributeSpec__f_name = null;
  this.Lscommons_reactnative_Modal$ModalAttributes$Function0AttributeSpec__f_name = name
}
$c_Lscommons_reactnative_Modal$ModalAttributes$Function0AttributeSpec.prototype = new $h_O();
$c_Lscommons_reactnative_Modal$ModalAttributes$Function0AttributeSpec.prototype.constructor = $c_Lscommons_reactnative_Modal$ModalAttributes$Function0AttributeSpec;
/** @constructor */
function $h_Lscommons_reactnative_Modal$ModalAttributes$Function0AttributeSpec() {
  /*<skip>*/
}
$h_Lscommons_reactnative_Modal$ModalAttributes$Function0AttributeSpec.prototype = $c_Lscommons_reactnative_Modal$ModalAttributes$Function0AttributeSpec.prototype;
$c_Lscommons_reactnative_Modal$ModalAttributes$Function0AttributeSpec.prototype.$colon$eq__sjs_js_Function0__Lio_github_shogowada_statictags_Attribute = (function(value) {
  return new $c_Lio_github_shogowada_statictags_Attribute(this.Lscommons_reactnative_Modal$ModalAttributes$Function0AttributeSpec__f_name, value, $m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMAttributes__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$().Type__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$().AS_IS__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$AS\uff3fIS$())
});
$c_Lscommons_reactnative_Modal$ModalAttributes$Function0AttributeSpec.prototype.productPrefix__T = (function() {
  return "Function0AttributeSpec"
});
$c_Lscommons_reactnative_Modal$ModalAttributes$Function0AttributeSpec.prototype.productArity__I = (function() {
  return 1
});
$c_Lscommons_reactnative_Modal$ModalAttributes$Function0AttributeSpec.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lscommons_reactnative_Modal$ModalAttributes$Function0AttributeSpec__f_name : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lscommons_reactnative_Modal$ModalAttributes$Function0AttributeSpec.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscommons_reactnative_Modal$ModalAttributes$Function0AttributeSpec.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lscommons_reactnative_Modal$ModalAttributes$Function0AttributeSpec.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lscommons_reactnative_Modal$ModalAttributes$Function0AttributeSpec.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lscommons_reactnative_Modal$ModalAttributes$Function0AttributeSpec)) {
    var Function0AttributeSpec$1 = $as_Lscommons_reactnative_Modal$ModalAttributes$Function0AttributeSpec(x$1);
    return (this.Lscommons_reactnative_Modal$ModalAttributes$Function0AttributeSpec__f_name === Function0AttributeSpec$1.Lscommons_reactnative_Modal$ModalAttributes$Function0AttributeSpec__f_name)
  } else {
    return false
  }
});
function $as_Lscommons_reactnative_Modal$ModalAttributes$Function0AttributeSpec(obj) {
  return (((obj instanceof $c_Lscommons_reactnative_Modal$ModalAttributes$Function0AttributeSpec) || (obj === null)) ? obj : $throwClassCastException(obj, "scommons.reactnative.Modal$ModalAttributes$Function0AttributeSpec"))
}
function $isArrayOf_Lscommons_reactnative_Modal$ModalAttributes$Function0AttributeSpec(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscommons_reactnative_Modal$ModalAttributes$Function0AttributeSpec)))
}
function $asArrayOf_Lscommons_reactnative_Modal$ModalAttributes$Function0AttributeSpec(obj, depth) {
  return (($isArrayOf_Lscommons_reactnative_Modal$ModalAttributes$Function0AttributeSpec(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscommons.reactnative.Modal$ModalAttributes$Function0AttributeSpec;", depth))
}
var $d_Lscommons_reactnative_Modal$ModalAttributes$Function0AttributeSpec = new $TypeData().initClass({
  Lscommons_reactnative_Modal$ModalAttributes$Function0AttributeSpec: 0
}, false, "scommons.reactnative.Modal$ModalAttributes$Function0AttributeSpec", {
  Lscommons_reactnative_Modal$ModalAttributes$Function0AttributeSpec: 1,
  O: 1,
  Lio_github_shogowada_statictags_AttributeSpec: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscommons_reactnative_Modal$ModalAttributes$Function0AttributeSpec.prototype.$classData = $d_Lscommons_reactnative_Modal$ModalAttributes$Function0AttributeSpec;
/** @constructor */
function $c_Lscommons_reactnative_Platform$android$() {
  /*<skip>*/
}
$c_Lscommons_reactnative_Platform$android$.prototype = new $h_O();
$c_Lscommons_reactnative_Platform$android$.prototype.constructor = $c_Lscommons_reactnative_Platform$android$;
/** @constructor */
function $h_Lscommons_reactnative_Platform$android$() {
  /*<skip>*/
}
$h_Lscommons_reactnative_Platform$android$.prototype = $c_Lscommons_reactnative_Platform$android$.prototype;
$c_Lscommons_reactnative_Platform$android$.prototype.productPrefix__T = (function() {
  return "android"
});
$c_Lscommons_reactnative_Platform$android$.prototype.productArity__I = (function() {
  return 0
});
$c_Lscommons_reactnative_Platform$android$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lscommons_reactnative_Platform$android$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscommons_reactnative_Platform$android$.prototype.hashCode__I = (function() {
  return (-861391249)
});
$c_Lscommons_reactnative_Platform$android$.prototype.toString__T = (function() {
  return "android"
});
var $d_Lscommons_reactnative_Platform$android$ = new $TypeData().initClass({
  Lscommons_reactnative_Platform$android$: 0
}, false, "scommons.reactnative.Platform$android$", {
  Lscommons_reactnative_Platform$android$: 1,
  O: 1,
  Lscommons_reactnative_Platform: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscommons_reactnative_Platform$android$.prototype.$classData = $d_Lscommons_reactnative_Platform$android$;
var $n_Lscommons_reactnative_Platform$android$;
function $m_Lscommons_reactnative_Platform$android$() {
  if ((!$n_Lscommons_reactnative_Platform$android$)) {
    $n_Lscommons_reactnative_Platform$android$ = new $c_Lscommons_reactnative_Platform$android$()
  };
  return $n_Lscommons_reactnative_Platform$android$
}
/** @constructor */
function $c_Lscommons_reactnative_Platform$ios$() {
  /*<skip>*/
}
$c_Lscommons_reactnative_Platform$ios$.prototype = new $h_O();
$c_Lscommons_reactnative_Platform$ios$.prototype.constructor = $c_Lscommons_reactnative_Platform$ios$;
/** @constructor */
function $h_Lscommons_reactnative_Platform$ios$() {
  /*<skip>*/
}
$h_Lscommons_reactnative_Platform$ios$.prototype = $c_Lscommons_reactnative_Platform$ios$.prototype;
$c_Lscommons_reactnative_Platform$ios$.prototype.productPrefix__T = (function() {
  return "ios"
});
$c_Lscommons_reactnative_Platform$ios$.prototype.productArity__I = (function() {
  return 0
});
$c_Lscommons_reactnative_Platform$ios$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lscommons_reactnative_Platform$ios$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscommons_reactnative_Platform$ios$.prototype.hashCode__I = (function() {
  return 104461
});
$c_Lscommons_reactnative_Platform$ios$.prototype.toString__T = (function() {
  return "ios"
});
var $d_Lscommons_reactnative_Platform$ios$ = new $TypeData().initClass({
  Lscommons_reactnative_Platform$ios$: 0
}, false, "scommons.reactnative.Platform$ios$", {
  Lscommons_reactnative_Platform$ios$: 1,
  O: 1,
  Lscommons_reactnative_Platform: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscommons_reactnative_Platform$ios$.prototype.$classData = $d_Lscommons_reactnative_Platform$ios$;
var $n_Lscommons_reactnative_Platform$ios$;
function $m_Lscommons_reactnative_Platform$ios$() {
  if ((!$n_Lscommons_reactnative_Platform$ios$)) {
    $n_Lscommons_reactnative_Platform$ios$ = new $c_Lscommons_reactnative_Platform$ios$()
  };
  return $n_Lscommons_reactnative_Platform$ios$
}
/** @constructor */
function $c_Lscommons_reactnative_Platform$web$() {
  /*<skip>*/
}
$c_Lscommons_reactnative_Platform$web$.prototype = new $h_O();
$c_Lscommons_reactnative_Platform$web$.prototype.constructor = $c_Lscommons_reactnative_Platform$web$;
/** @constructor */
function $h_Lscommons_reactnative_Platform$web$() {
  /*<skip>*/
}
$h_Lscommons_reactnative_Platform$web$.prototype = $c_Lscommons_reactnative_Platform$web$.prototype;
$c_Lscommons_reactnative_Platform$web$.prototype.productPrefix__T = (function() {
  return "web"
});
$c_Lscommons_reactnative_Platform$web$.prototype.productArity__I = (function() {
  return 0
});
$c_Lscommons_reactnative_Platform$web$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lscommons_reactnative_Platform$web$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscommons_reactnative_Platform$web$.prototype.hashCode__I = (function() {
  return 117588
});
$c_Lscommons_reactnative_Platform$web$.prototype.toString__T = (function() {
  return "web"
});
var $d_Lscommons_reactnative_Platform$web$ = new $TypeData().initClass({
  Lscommons_reactnative_Platform$web$: 0
}, false, "scommons.reactnative.Platform$web$", {
  Lscommons_reactnative_Platform$web$: 1,
  O: 1,
  Lscommons_reactnative_Platform: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscommons_reactnative_Platform$web$.prototype.$classData = $d_Lscommons_reactnative_Platform$web$;
var $n_Lscommons_reactnative_Platform$web$;
function $m_Lscommons_reactnative_Platform$web$() {
  if ((!$n_Lscommons_reactnative_Platform$web$)) {
    $n_Lscommons_reactnative_Platform$web$ = new $c_Lscommons_reactnative_Platform$web$()
  };
  return $n_Lscommons_reactnative_Platform$web$
}
/** @constructor */
function $c_Lscommons_reactnative_ScrollView$ScrollViewAttributes$KeyboardShouldPersistTapsAttribute(name) {
  this.Lscommons_reactnative_ScrollView$ScrollViewAttributes$KeyboardShouldPersistTapsAttribute__f_name = null;
  this.Lscommons_reactnative_ScrollView$ScrollViewAttributes$KeyboardShouldPersistTapsAttribute__f_name = name
}
$c_Lscommons_reactnative_ScrollView$ScrollViewAttributes$KeyboardShouldPersistTapsAttribute.prototype = new $h_O();
$c_Lscommons_reactnative_ScrollView$ScrollViewAttributes$KeyboardShouldPersistTapsAttribute.prototype.constructor = $c_Lscommons_reactnative_ScrollView$ScrollViewAttributes$KeyboardShouldPersistTapsAttribute;
/** @constructor */
function $h_Lscommons_reactnative_ScrollView$ScrollViewAttributes$KeyboardShouldPersistTapsAttribute() {
  /*<skip>*/
}
$h_Lscommons_reactnative_ScrollView$ScrollViewAttributes$KeyboardShouldPersistTapsAttribute.prototype = $c_Lscommons_reactnative_ScrollView$ScrollViewAttributes$KeyboardShouldPersistTapsAttribute.prototype;
$c_Lscommons_reactnative_ScrollView$ScrollViewAttributes$KeyboardShouldPersistTapsAttribute.prototype.$colon$eq__Lscommons_reactnative_ScrollView$KeyboardShouldPersistTaps__Lio_github_shogowada_statictags_Attribute = (function(value) {
  return new $c_Lio_github_shogowada_statictags_Attribute(this.Lscommons_reactnative_ScrollView$ScrollViewAttributes$KeyboardShouldPersistTapsAttribute__f_name, value, $m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMAttributes__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$().Type__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$().AS_IS__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$AS\uff3fIS$())
});
$c_Lscommons_reactnative_ScrollView$ScrollViewAttributes$KeyboardShouldPersistTapsAttribute.prototype.productPrefix__T = (function() {
  return "KeyboardShouldPersistTapsAttribute"
});
$c_Lscommons_reactnative_ScrollView$ScrollViewAttributes$KeyboardShouldPersistTapsAttribute.prototype.productArity__I = (function() {
  return 1
});
$c_Lscommons_reactnative_ScrollView$ScrollViewAttributes$KeyboardShouldPersistTapsAttribute.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lscommons_reactnative_ScrollView$ScrollViewAttributes$KeyboardShouldPersistTapsAttribute__f_name : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lscommons_reactnative_ScrollView$ScrollViewAttributes$KeyboardShouldPersistTapsAttribute.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscommons_reactnative_ScrollView$ScrollViewAttributes$KeyboardShouldPersistTapsAttribute.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lscommons_reactnative_ScrollView$ScrollViewAttributes$KeyboardShouldPersistTapsAttribute.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lscommons_reactnative_ScrollView$ScrollViewAttributes$KeyboardShouldPersistTapsAttribute.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lscommons_reactnative_ScrollView$ScrollViewAttributes$KeyboardShouldPersistTapsAttribute)) {
    var KeyboardShouldPersistTapsAttribute$1 = $as_Lscommons_reactnative_ScrollView$ScrollViewAttributes$KeyboardShouldPersistTapsAttribute(x$1);
    return (this.Lscommons_reactnative_ScrollView$ScrollViewAttributes$KeyboardShouldPersistTapsAttribute__f_name === KeyboardShouldPersistTapsAttribute$1.Lscommons_reactnative_ScrollView$ScrollViewAttributes$KeyboardShouldPersistTapsAttribute__f_name)
  } else {
    return false
  }
});
function $as_Lscommons_reactnative_ScrollView$ScrollViewAttributes$KeyboardShouldPersistTapsAttribute(obj) {
  return (((obj instanceof $c_Lscommons_reactnative_ScrollView$ScrollViewAttributes$KeyboardShouldPersistTapsAttribute) || (obj === null)) ? obj : $throwClassCastException(obj, "scommons.reactnative.ScrollView$ScrollViewAttributes$KeyboardShouldPersistTapsAttribute"))
}
function $isArrayOf_Lscommons_reactnative_ScrollView$ScrollViewAttributes$KeyboardShouldPersistTapsAttribute(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscommons_reactnative_ScrollView$ScrollViewAttributes$KeyboardShouldPersistTapsAttribute)))
}
function $asArrayOf_Lscommons_reactnative_ScrollView$ScrollViewAttributes$KeyboardShouldPersistTapsAttribute(obj, depth) {
  return (($isArrayOf_Lscommons_reactnative_ScrollView$ScrollViewAttributes$KeyboardShouldPersistTapsAttribute(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscommons.reactnative.ScrollView$ScrollViewAttributes$KeyboardShouldPersistTapsAttribute;", depth))
}
var $d_Lscommons_reactnative_ScrollView$ScrollViewAttributes$KeyboardShouldPersistTapsAttribute = new $TypeData().initClass({
  Lscommons_reactnative_ScrollView$ScrollViewAttributes$KeyboardShouldPersistTapsAttribute: 0
}, false, "scommons.reactnative.ScrollView$ScrollViewAttributes$KeyboardShouldPersistTapsAttribute", {
  Lscommons_reactnative_ScrollView$ScrollViewAttributes$KeyboardShouldPersistTapsAttribute: 1,
  O: 1,
  Lio_github_shogowada_statictags_AttributeSpec: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscommons_reactnative_ScrollView$ScrollViewAttributes$KeyboardShouldPersistTapsAttribute.prototype.$classData = $d_Lscommons_reactnative_ScrollView$ScrollViewAttributes$KeyboardShouldPersistTapsAttribute;
/** @constructor */
function $c_Lscommons_reactnative_StatusBar$StatusBarAttributes$BarStyleAttributeSpec(name) {
  this.Lscommons_reactnative_StatusBar$StatusBarAttributes$BarStyleAttributeSpec__f_name = null;
  this.Lscommons_reactnative_StatusBar$StatusBarAttributes$BarStyleAttributeSpec__f_name = name
}
$c_Lscommons_reactnative_StatusBar$StatusBarAttributes$BarStyleAttributeSpec.prototype = new $h_O();
$c_Lscommons_reactnative_StatusBar$StatusBarAttributes$BarStyleAttributeSpec.prototype.constructor = $c_Lscommons_reactnative_StatusBar$StatusBarAttributes$BarStyleAttributeSpec;
/** @constructor */
function $h_Lscommons_reactnative_StatusBar$StatusBarAttributes$BarStyleAttributeSpec() {
  /*<skip>*/
}
$h_Lscommons_reactnative_StatusBar$StatusBarAttributes$BarStyleAttributeSpec.prototype = $c_Lscommons_reactnative_StatusBar$StatusBarAttributes$BarStyleAttributeSpec.prototype;
$c_Lscommons_reactnative_StatusBar$StatusBarAttributes$BarStyleAttributeSpec.prototype.$colon$eq__Lscommons_reactnative_StatusBar$BarStyle__Lio_github_shogowada_statictags_Attribute = (function(value) {
  return new $c_Lio_github_shogowada_statictags_Attribute(this.Lscommons_reactnative_StatusBar$StatusBarAttributes$BarStyleAttributeSpec__f_name, value, $m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMAttributes__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$().Type__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$().AS_IS__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$AS\uff3fIS$())
});
$c_Lscommons_reactnative_StatusBar$StatusBarAttributes$BarStyleAttributeSpec.prototype.productPrefix__T = (function() {
  return "BarStyleAttributeSpec"
});
$c_Lscommons_reactnative_StatusBar$StatusBarAttributes$BarStyleAttributeSpec.prototype.productArity__I = (function() {
  return 1
});
$c_Lscommons_reactnative_StatusBar$StatusBarAttributes$BarStyleAttributeSpec.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lscommons_reactnative_StatusBar$StatusBarAttributes$BarStyleAttributeSpec__f_name : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lscommons_reactnative_StatusBar$StatusBarAttributes$BarStyleAttributeSpec.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscommons_reactnative_StatusBar$StatusBarAttributes$BarStyleAttributeSpec.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lscommons_reactnative_StatusBar$StatusBarAttributes$BarStyleAttributeSpec.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lscommons_reactnative_StatusBar$StatusBarAttributes$BarStyleAttributeSpec.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lscommons_reactnative_StatusBar$StatusBarAttributes$BarStyleAttributeSpec)) {
    var BarStyleAttributeSpec$1 = $as_Lscommons_reactnative_StatusBar$StatusBarAttributes$BarStyleAttributeSpec(x$1);
    return (this.Lscommons_reactnative_StatusBar$StatusBarAttributes$BarStyleAttributeSpec__f_name === BarStyleAttributeSpec$1.Lscommons_reactnative_StatusBar$StatusBarAttributes$BarStyleAttributeSpec__f_name)
  } else {
    return false
  }
});
function $as_Lscommons_reactnative_StatusBar$StatusBarAttributes$BarStyleAttributeSpec(obj) {
  return (((obj instanceof $c_Lscommons_reactnative_StatusBar$StatusBarAttributes$BarStyleAttributeSpec) || (obj === null)) ? obj : $throwClassCastException(obj, "scommons.reactnative.StatusBar$StatusBarAttributes$BarStyleAttributeSpec"))
}
function $isArrayOf_Lscommons_reactnative_StatusBar$StatusBarAttributes$BarStyleAttributeSpec(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscommons_reactnative_StatusBar$StatusBarAttributes$BarStyleAttributeSpec)))
}
function $asArrayOf_Lscommons_reactnative_StatusBar$StatusBarAttributes$BarStyleAttributeSpec(obj, depth) {
  return (($isArrayOf_Lscommons_reactnative_StatusBar$StatusBarAttributes$BarStyleAttributeSpec(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscommons.reactnative.StatusBar$StatusBarAttributes$BarStyleAttributeSpec;", depth))
}
var $d_Lscommons_reactnative_StatusBar$StatusBarAttributes$BarStyleAttributeSpec = new $TypeData().initClass({
  Lscommons_reactnative_StatusBar$StatusBarAttributes$BarStyleAttributeSpec: 0
}, false, "scommons.reactnative.StatusBar$StatusBarAttributes$BarStyleAttributeSpec", {
  Lscommons_reactnative_StatusBar$StatusBarAttributes$BarStyleAttributeSpec: 1,
  O: 1,
  Lio_github_shogowada_statictags_AttributeSpec: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscommons_reactnative_StatusBar$StatusBarAttributes$BarStyleAttributeSpec.prototype.$classData = $d_Lscommons_reactnative_StatusBar$StatusBarAttributes$BarStyleAttributeSpec;
/** @constructor */
function $c_Lscommons_reactnative_Switch$SwitchAttributes$OnValueChangeAttributeSpec(name) {
  this.Lscommons_reactnative_Switch$SwitchAttributes$OnValueChangeAttributeSpec__f_name = null;
  this.Lscommons_reactnative_Switch$SwitchAttributes$OnValueChangeAttributeSpec__f_name = name
}
$c_Lscommons_reactnative_Switch$SwitchAttributes$OnValueChangeAttributeSpec.prototype = new $h_O();
$c_Lscommons_reactnative_Switch$SwitchAttributes$OnValueChangeAttributeSpec.prototype.constructor = $c_Lscommons_reactnative_Switch$SwitchAttributes$OnValueChangeAttributeSpec;
/** @constructor */
function $h_Lscommons_reactnative_Switch$SwitchAttributes$OnValueChangeAttributeSpec() {
  /*<skip>*/
}
$h_Lscommons_reactnative_Switch$SwitchAttributes$OnValueChangeAttributeSpec.prototype = $c_Lscommons_reactnative_Switch$SwitchAttributes$OnValueChangeAttributeSpec.prototype;
$c_Lscommons_reactnative_Switch$SwitchAttributes$OnValueChangeAttributeSpec.prototype.$colon$eq__sjs_js_Function1__Lio_github_shogowada_statictags_Attribute = (function(value) {
  return new $c_Lio_github_shogowada_statictags_Attribute(this.Lscommons_reactnative_Switch$SwitchAttributes$OnValueChangeAttributeSpec__f_name, value, $m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMAttributes__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$().Type__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$().AS_IS__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$AS\uff3fIS$())
});
$c_Lscommons_reactnative_Switch$SwitchAttributes$OnValueChangeAttributeSpec.prototype.productPrefix__T = (function() {
  return "OnValueChangeAttributeSpec"
});
$c_Lscommons_reactnative_Switch$SwitchAttributes$OnValueChangeAttributeSpec.prototype.productArity__I = (function() {
  return 1
});
$c_Lscommons_reactnative_Switch$SwitchAttributes$OnValueChangeAttributeSpec.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lscommons_reactnative_Switch$SwitchAttributes$OnValueChangeAttributeSpec__f_name : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lscommons_reactnative_Switch$SwitchAttributes$OnValueChangeAttributeSpec.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscommons_reactnative_Switch$SwitchAttributes$OnValueChangeAttributeSpec.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lscommons_reactnative_Switch$SwitchAttributes$OnValueChangeAttributeSpec.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lscommons_reactnative_Switch$SwitchAttributes$OnValueChangeAttributeSpec.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lscommons_reactnative_Switch$SwitchAttributes$OnValueChangeAttributeSpec)) {
    var OnValueChangeAttributeSpec$1 = $as_Lscommons_reactnative_Switch$SwitchAttributes$OnValueChangeAttributeSpec(x$1);
    return (this.Lscommons_reactnative_Switch$SwitchAttributes$OnValueChangeAttributeSpec__f_name === OnValueChangeAttributeSpec$1.Lscommons_reactnative_Switch$SwitchAttributes$OnValueChangeAttributeSpec__f_name)
  } else {
    return false
  }
});
function $as_Lscommons_reactnative_Switch$SwitchAttributes$OnValueChangeAttributeSpec(obj) {
  return (((obj instanceof $c_Lscommons_reactnative_Switch$SwitchAttributes$OnValueChangeAttributeSpec) || (obj === null)) ? obj : $throwClassCastException(obj, "scommons.reactnative.Switch$SwitchAttributes$OnValueChangeAttributeSpec"))
}
function $isArrayOf_Lscommons_reactnative_Switch$SwitchAttributes$OnValueChangeAttributeSpec(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscommons_reactnative_Switch$SwitchAttributes$OnValueChangeAttributeSpec)))
}
function $asArrayOf_Lscommons_reactnative_Switch$SwitchAttributes$OnValueChangeAttributeSpec(obj, depth) {
  return (($isArrayOf_Lscommons_reactnative_Switch$SwitchAttributes$OnValueChangeAttributeSpec(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscommons.reactnative.Switch$SwitchAttributes$OnValueChangeAttributeSpec;", depth))
}
var $d_Lscommons_reactnative_Switch$SwitchAttributes$OnValueChangeAttributeSpec = new $TypeData().initClass({
  Lscommons_reactnative_Switch$SwitchAttributes$OnValueChangeAttributeSpec: 0
}, false, "scommons.reactnative.Switch$SwitchAttributes$OnValueChangeAttributeSpec", {
  Lscommons_reactnative_Switch$SwitchAttributes$OnValueChangeAttributeSpec: 1,
  O: 1,
  Lio_github_shogowada_statictags_AttributeSpec: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscommons_reactnative_Switch$SwitchAttributes$OnValueChangeAttributeSpec.prototype.$classData = $d_Lscommons_reactnative_Switch$SwitchAttributes$OnValueChangeAttributeSpec;
/** @constructor */
function $c_Lscommons_reactnative_Switch$SwitchAttributes$TrackColorAttributeSpec(name) {
  this.Lscommons_reactnative_Switch$SwitchAttributes$TrackColorAttributeSpec__f_name = null;
  this.Lscommons_reactnative_Switch$SwitchAttributes$TrackColorAttributeSpec__f_name = name
}
$c_Lscommons_reactnative_Switch$SwitchAttributes$TrackColorAttributeSpec.prototype = new $h_O();
$c_Lscommons_reactnative_Switch$SwitchAttributes$TrackColorAttributeSpec.prototype.constructor = $c_Lscommons_reactnative_Switch$SwitchAttributes$TrackColorAttributeSpec;
/** @constructor */
function $h_Lscommons_reactnative_Switch$SwitchAttributes$TrackColorAttributeSpec() {
  /*<skip>*/
}
$h_Lscommons_reactnative_Switch$SwitchAttributes$TrackColorAttributeSpec.prototype = $c_Lscommons_reactnative_Switch$SwitchAttributes$TrackColorAttributeSpec.prototype;
$c_Lscommons_reactnative_Switch$SwitchAttributes$TrackColorAttributeSpec.prototype.$colon$eq__Lscommons_reactnative_Switch$TrackColor__Lio_github_shogowada_statictags_Attribute = (function(value) {
  return new $c_Lio_github_shogowada_statictags_Attribute(this.Lscommons_reactnative_Switch$SwitchAttributes$TrackColorAttributeSpec__f_name, value, $m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMAttributes__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$().Type__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$().AS_IS__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$AS\uff3fIS$())
});
$c_Lscommons_reactnative_Switch$SwitchAttributes$TrackColorAttributeSpec.prototype.productPrefix__T = (function() {
  return "TrackColorAttributeSpec"
});
$c_Lscommons_reactnative_Switch$SwitchAttributes$TrackColorAttributeSpec.prototype.productArity__I = (function() {
  return 1
});
$c_Lscommons_reactnative_Switch$SwitchAttributes$TrackColorAttributeSpec.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lscommons_reactnative_Switch$SwitchAttributes$TrackColorAttributeSpec__f_name : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lscommons_reactnative_Switch$SwitchAttributes$TrackColorAttributeSpec.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscommons_reactnative_Switch$SwitchAttributes$TrackColorAttributeSpec.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lscommons_reactnative_Switch$SwitchAttributes$TrackColorAttributeSpec.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lscommons_reactnative_Switch$SwitchAttributes$TrackColorAttributeSpec.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lscommons_reactnative_Switch$SwitchAttributes$TrackColorAttributeSpec)) {
    var TrackColorAttributeSpec$1 = $as_Lscommons_reactnative_Switch$SwitchAttributes$TrackColorAttributeSpec(x$1);
    return (this.Lscommons_reactnative_Switch$SwitchAttributes$TrackColorAttributeSpec__f_name === TrackColorAttributeSpec$1.Lscommons_reactnative_Switch$SwitchAttributes$TrackColorAttributeSpec__f_name)
  } else {
    return false
  }
});
function $as_Lscommons_reactnative_Switch$SwitchAttributes$TrackColorAttributeSpec(obj) {
  return (((obj instanceof $c_Lscommons_reactnative_Switch$SwitchAttributes$TrackColorAttributeSpec) || (obj === null)) ? obj : $throwClassCastException(obj, "scommons.reactnative.Switch$SwitchAttributes$TrackColorAttributeSpec"))
}
function $isArrayOf_Lscommons_reactnative_Switch$SwitchAttributes$TrackColorAttributeSpec(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscommons_reactnative_Switch$SwitchAttributes$TrackColorAttributeSpec)))
}
function $asArrayOf_Lscommons_reactnative_Switch$SwitchAttributes$TrackColorAttributeSpec(obj, depth) {
  return (($isArrayOf_Lscommons_reactnative_Switch$SwitchAttributes$TrackColorAttributeSpec(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscommons.reactnative.Switch$SwitchAttributes$TrackColorAttributeSpec;", depth))
}
var $d_Lscommons_reactnative_Switch$SwitchAttributes$TrackColorAttributeSpec = new $TypeData().initClass({
  Lscommons_reactnative_Switch$SwitchAttributes$TrackColorAttributeSpec: 0
}, false, "scommons.reactnative.Switch$SwitchAttributes$TrackColorAttributeSpec", {
  Lscommons_reactnative_Switch$SwitchAttributes$TrackColorAttributeSpec: 1,
  O: 1,
  Lio_github_shogowada_statictags_AttributeSpec: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscommons_reactnative_Switch$SwitchAttributes$TrackColorAttributeSpec.prototype.$classData = $d_Lscommons_reactnative_Switch$SwitchAttributes$TrackColorAttributeSpec;
/** @constructor */
function $c_Lscommons_reactnative_Touchable$TouchableAttributes$OnPressEventAttribute(name) {
  this.Lscommons_reactnative_Touchable$TouchableAttributes$OnPressEventAttribute__f_name = null;
  this.Lscommons_reactnative_Touchable$TouchableAttributes$OnPressEventAttribute__f_name = name
}
$c_Lscommons_reactnative_Touchable$TouchableAttributes$OnPressEventAttribute.prototype = new $h_O();
$c_Lscommons_reactnative_Touchable$TouchableAttributes$OnPressEventAttribute.prototype.constructor = $c_Lscommons_reactnative_Touchable$TouchableAttributes$OnPressEventAttribute;
/** @constructor */
function $h_Lscommons_reactnative_Touchable$TouchableAttributes$OnPressEventAttribute() {
  /*<skip>*/
}
$h_Lscommons_reactnative_Touchable$TouchableAttributes$OnPressEventAttribute.prototype = $c_Lscommons_reactnative_Touchable$TouchableAttributes$OnPressEventAttribute.prototype;
$c_Lscommons_reactnative_Touchable$TouchableAttributes$OnPressEventAttribute.prototype.$colon$eq__sjs_js_Function0__Lio_github_shogowada_statictags_Attribute = (function(onEvent) {
  return new $c_Lio_github_shogowada_statictags_Attribute(this.Lscommons_reactnative_Touchable$TouchableAttributes$OnPressEventAttribute__f_name, onEvent, $m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMAttributes__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$().Type__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$().AS_IS__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$AS\uff3fIS$())
});
$c_Lscommons_reactnative_Touchable$TouchableAttributes$OnPressEventAttribute.prototype.productPrefix__T = (function() {
  return "OnPressEventAttribute"
});
$c_Lscommons_reactnative_Touchable$TouchableAttributes$OnPressEventAttribute.prototype.productArity__I = (function() {
  return 1
});
$c_Lscommons_reactnative_Touchable$TouchableAttributes$OnPressEventAttribute.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lscommons_reactnative_Touchable$TouchableAttributes$OnPressEventAttribute__f_name : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lscommons_reactnative_Touchable$TouchableAttributes$OnPressEventAttribute.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscommons_reactnative_Touchable$TouchableAttributes$OnPressEventAttribute.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lscommons_reactnative_Touchable$TouchableAttributes$OnPressEventAttribute.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lscommons_reactnative_Touchable$TouchableAttributes$OnPressEventAttribute.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lscommons_reactnative_Touchable$TouchableAttributes$OnPressEventAttribute)) {
    var OnPressEventAttribute$1 = $as_Lscommons_reactnative_Touchable$TouchableAttributes$OnPressEventAttribute(x$1);
    return (this.Lscommons_reactnative_Touchable$TouchableAttributes$OnPressEventAttribute__f_name === OnPressEventAttribute$1.Lscommons_reactnative_Touchable$TouchableAttributes$OnPressEventAttribute__f_name)
  } else {
    return false
  }
});
function $as_Lscommons_reactnative_Touchable$TouchableAttributes$OnPressEventAttribute(obj) {
  return (((obj instanceof $c_Lscommons_reactnative_Touchable$TouchableAttributes$OnPressEventAttribute) || (obj === null)) ? obj : $throwClassCastException(obj, "scommons.reactnative.Touchable$TouchableAttributes$OnPressEventAttribute"))
}
function $isArrayOf_Lscommons_reactnative_Touchable$TouchableAttributes$OnPressEventAttribute(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscommons_reactnative_Touchable$TouchableAttributes$OnPressEventAttribute)))
}
function $asArrayOf_Lscommons_reactnative_Touchable$TouchableAttributes$OnPressEventAttribute(obj, depth) {
  return (($isArrayOf_Lscommons_reactnative_Touchable$TouchableAttributes$OnPressEventAttribute(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscommons.reactnative.Touchable$TouchableAttributes$OnPressEventAttribute;", depth))
}
var $d_Lscommons_reactnative_Touchable$TouchableAttributes$OnPressEventAttribute = new $TypeData().initClass({
  Lscommons_reactnative_Touchable$TouchableAttributes$OnPressEventAttribute: 0
}, false, "scommons.reactnative.Touchable$TouchableAttributes$OnPressEventAttribute", {
  Lscommons_reactnative_Touchable$TouchableAttributes$OnPressEventAttribute: 1,
  O: 1,
  Lio_github_shogowada_statictags_AttributeSpec: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscommons_reactnative_Touchable$TouchableAttributes$OnPressEventAttribute.prototype.$classData = $d_Lscommons_reactnative_Touchable$TouchableAttributes$OnPressEventAttribute;
/** @constructor */
function $c_Lscommons_reactnative_app_AppTaskManagerUi$$anonfun$1() {
  /*<skip>*/
}
$c_Lscommons_reactnative_app_AppTaskManagerUi$$anonfun$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lscommons_reactnative_app_AppTaskManagerUi$$anonfun$1.prototype.constructor = $c_Lscommons_reactnative_app_AppTaskManagerUi$$anonfun$1;
/** @constructor */
function $h_Lscommons_reactnative_app_AppTaskManagerUi$$anonfun$1() {
  /*<skip>*/
}
$h_Lscommons_reactnative_app_AppTaskManagerUi$$anonfun$1.prototype = $c_Lscommons_reactnative_app_AppTaskManagerUi$$anonfun$1.prototype;
$c_Lscommons_reactnative_app_AppTaskManagerUi$$anonfun$1.prototype.applyOrElse__s_util_Try__F1__O = (function(x1, default$1) {
  if ((x1 instanceof $c_s_util_Success)) {
    var x2 = $as_s_util_Success(x1);
    var res = x2.s_util_Success__f_value;
    if ($is_Lscommons_api_ApiResponse(res)) {
      var this$1 = $as_Lscommons_api_ApiResponse(res).Lscommons_api_StatusResponse__f_status;
      if ((!this$1.successful__Z())) {
        var this$2 = $as_Lscommons_api_ApiResponse(res).Lscommons_api_StatusResponse__f_status.Lscommons_api_ApiStatus__f_error;
        return new $c_T2(new $c_s_Some((this$2.isEmpty__Z() ? "Non-successful response" : this$2.get__O())), $as_Lscommons_api_ApiResponse(res).Lscommons_api_StatusResponse__f_status.Lscommons_api_ApiStatus__f_details)
      }
    }
  };
  if ((x1 instanceof $c_s_util_Failure)) {
    var x3 = $as_s_util_Failure(x1);
    var e = x3.s_util_Failure__f_exception;
    if (false) {
      var x5 = $as_Lscommons_api_http_ApiHttpStatusException(e);
      return new $c_T2(new $c_s_Some(x5.error__T()), $m_s_Option$().apply__O__s_Option(x5.getMessage__T()))
    }
  };
  return default$1.apply__O__O(x1)
});
$c_Lscommons_reactnative_app_AppTaskManagerUi$$anonfun$1.prototype.isDefinedAt__s_util_Try__Z = (function(x1) {
  if ((x1 instanceof $c_s_util_Success)) {
    var x2 = $as_s_util_Success(x1);
    var res = x2.s_util_Success__f_value;
    if ($is_Lscommons_api_ApiResponse(res)) {
      var this$1 = $as_Lscommons_api_ApiResponse(res).Lscommons_api_StatusResponse__f_status;
      if ((!this$1.successful__Z())) {
        return true
      }
    }
  };
  if ((x1 instanceof $c_s_util_Failure)) {
    var x3 = $as_s_util_Failure(x1);
    var e = x3.s_util_Failure__f_exception;
    if (false) {
      return true
    }
  };
  return false
});
$c_Lscommons_reactnative_app_AppTaskManagerUi$$anonfun$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__s_util_Try__Z($as_s_util_Try(x))
});
$c_Lscommons_reactnative_app_AppTaskManagerUi$$anonfun$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__s_util_Try__F1__O($as_s_util_Try(x), default$1)
});
var $d_Lscommons_reactnative_app_AppTaskManagerUi$$anonfun$1 = new $TypeData().initClass({
  Lscommons_reactnative_app_AppTaskManagerUi$$anonfun$1: 0
}, false, "scommons.reactnative.app.AppTaskManagerUi$$anonfun$1", {
  Lscommons_reactnative_app_AppTaskManagerUi$$anonfun$1: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lscommons_reactnative_app_AppTaskManagerUi$$anonfun$1.prototype.$classData = $d_Lscommons_reactnative_app_AppTaskManagerUi$$anonfun$1;
/** @constructor */
function $c_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$CustomStyleAttributeSpec(name) {
  this.Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$CustomStyleAttributeSpec__f_name = null;
  this.Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$CustomStyleAttributeSpec__f_name = name
}
$c_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$CustomStyleAttributeSpec.prototype = new $h_O();
$c_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$CustomStyleAttributeSpec.prototype.constructor = $c_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$CustomStyleAttributeSpec;
/** @constructor */
function $h_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$CustomStyleAttributeSpec() {
  /*<skip>*/
}
$h_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$CustomStyleAttributeSpec.prototype = $c_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$CustomStyleAttributeSpec.prototype;
$c_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$CustomStyleAttributeSpec.prototype.$colon$eq__sjs_js_Object__Lio_github_shogowada_statictags_Attribute = (function(style) {
  return new $c_Lio_github_shogowada_statictags_Attribute(this.Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$CustomStyleAttributeSpec__f_name, style, $m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMAttributes__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$().Type__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$().AS_IS__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$AS\uff3fIS$())
});
$c_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$CustomStyleAttributeSpec.prototype.productPrefix__T = (function() {
  return "CustomStyleAttributeSpec"
});
$c_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$CustomStyleAttributeSpec.prototype.productArity__I = (function() {
  return 1
});
$c_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$CustomStyleAttributeSpec.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$CustomStyleAttributeSpec__f_name : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$CustomStyleAttributeSpec.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$CustomStyleAttributeSpec.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$CustomStyleAttributeSpec.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$CustomStyleAttributeSpec.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$CustomStyleAttributeSpec)) {
    var CustomStyleAttributeSpec$1 = $as_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$CustomStyleAttributeSpec(x$1);
    return (this.Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$CustomStyleAttributeSpec__f_name === CustomStyleAttributeSpec$1.Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$CustomStyleAttributeSpec__f_name)
  } else {
    return false
  }
});
function $as_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$CustomStyleAttributeSpec(obj) {
  return (((obj instanceof $c_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$CustomStyleAttributeSpec) || (obj === null)) ? obj : $throwClassCastException(obj, "scommons.reactnative.highlighter.package$SyntaxHighlighterVirtualDOMAttributes$CustomStyleAttributeSpec"))
}
function $isArrayOf_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$CustomStyleAttributeSpec(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$CustomStyleAttributeSpec)))
}
function $asArrayOf_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$CustomStyleAttributeSpec(obj, depth) {
  return (($isArrayOf_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$CustomStyleAttributeSpec(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscommons.reactnative.highlighter.package$SyntaxHighlighterVirtualDOMAttributes$CustomStyleAttributeSpec;", depth))
}
var $d_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$CustomStyleAttributeSpec = new $TypeData().initClass({
  Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$CustomStyleAttributeSpec: 0
}, false, "scommons.reactnative.highlighter.package$SyntaxHighlighterVirtualDOMAttributes$CustomStyleAttributeSpec", {
  Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$CustomStyleAttributeSpec: 1,
  O: 1,
  Lio_github_shogowada_statictags_AttributeSpec: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$CustomStyleAttributeSpec.prototype.$classData = $d_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$CustomStyleAttributeSpec;
/** @constructor */
function $c_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$HighlighterStyleAttribute(name) {
  this.Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$HighlighterStyleAttribute__f_name = null;
  this.Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$HighlighterStyleAttribute__f_name = name
}
$c_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$HighlighterStyleAttribute.prototype = new $h_O();
$c_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$HighlighterStyleAttribute.prototype.constructor = $c_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$HighlighterStyleAttribute;
/** @constructor */
function $h_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$HighlighterStyleAttribute() {
  /*<skip>*/
}
$h_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$HighlighterStyleAttribute.prototype = $c_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$HighlighterStyleAttribute.prototype;
$c_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$HighlighterStyleAttribute.prototype.$colon$eq__Lscommons_reactnative_highlighter_raw_HighlighterStyle__Lio_github_shogowada_statictags_Attribute = (function(value) {
  return new $c_Lio_github_shogowada_statictags_Attribute(this.Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$HighlighterStyleAttribute__f_name, value, $m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMAttributes__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$().Type__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$().AS_IS__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$AS\uff3fIS$())
});
$c_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$HighlighterStyleAttribute.prototype.productPrefix__T = (function() {
  return "HighlighterStyleAttribute"
});
$c_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$HighlighterStyleAttribute.prototype.productArity__I = (function() {
  return 1
});
$c_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$HighlighterStyleAttribute.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$HighlighterStyleAttribute__f_name : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$HighlighterStyleAttribute.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$HighlighterStyleAttribute.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$HighlighterStyleAttribute.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$HighlighterStyleAttribute.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$HighlighterStyleAttribute)) {
    var HighlighterStyleAttribute$1 = $as_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$HighlighterStyleAttribute(x$1);
    return (this.Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$HighlighterStyleAttribute__f_name === HighlighterStyleAttribute$1.Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$HighlighterStyleAttribute__f_name)
  } else {
    return false
  }
});
function $as_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$HighlighterStyleAttribute(obj) {
  return (((obj instanceof $c_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$HighlighterStyleAttribute) || (obj === null)) ? obj : $throwClassCastException(obj, "scommons.reactnative.highlighter.package$SyntaxHighlighterVirtualDOMAttributes$HighlighterStyleAttribute"))
}
function $isArrayOf_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$HighlighterStyleAttribute(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$HighlighterStyleAttribute)))
}
function $asArrayOf_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$HighlighterStyleAttribute(obj, depth) {
  return (($isArrayOf_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$HighlighterStyleAttribute(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscommons.reactnative.highlighter.package$SyntaxHighlighterVirtualDOMAttributes$HighlighterStyleAttribute;", depth))
}
var $d_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$HighlighterStyleAttribute = new $TypeData().initClass({
  Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$HighlighterStyleAttribute: 0
}, false, "scommons.reactnative.highlighter.package$SyntaxHighlighterVirtualDOMAttributes$HighlighterStyleAttribute", {
  Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$HighlighterStyleAttribute: 1,
  O: 1,
  Lio_github_shogowada_statictags_AttributeSpec: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$HighlighterStyleAttribute.prototype.$classData = $d_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$HighlighterStyleAttribute;
/** @constructor */
function $c_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$ReactClassAttribute(name) {
  this.Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$ReactClassAttribute__f_name = null;
  this.Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$ReactClassAttribute__f_name = name
}
$c_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$ReactClassAttribute.prototype = new $h_O();
$c_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$ReactClassAttribute.prototype.constructor = $c_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$ReactClassAttribute;
/** @constructor */
function $h_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$ReactClassAttribute() {
  /*<skip>*/
}
$h_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$ReactClassAttribute.prototype = $c_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$ReactClassAttribute.prototype;
$c_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$ReactClassAttribute.prototype.$colon$eq__Lio_github_shogowada_scalajs_reactjs_classes_ReactClass__Lio_github_shogowada_statictags_Attribute = (function(value) {
  return new $c_Lio_github_shogowada_statictags_Attribute(this.Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$ReactClassAttribute__f_name, value, $m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMAttributes__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$().Type__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$().AS_IS__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$AS\uff3fIS$())
});
$c_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$ReactClassAttribute.prototype.productPrefix__T = (function() {
  return "ReactClassAttribute"
});
$c_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$ReactClassAttribute.prototype.productArity__I = (function() {
  return 1
});
$c_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$ReactClassAttribute.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$ReactClassAttribute__f_name : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$ReactClassAttribute.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$ReactClassAttribute.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$ReactClassAttribute.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$ReactClassAttribute.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$ReactClassAttribute)) {
    var ReactClassAttribute$1 = $as_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$ReactClassAttribute(x$1);
    return (this.Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$ReactClassAttribute__f_name === ReactClassAttribute$1.Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$ReactClassAttribute__f_name)
  } else {
    return false
  }
});
function $as_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$ReactClassAttribute(obj) {
  return (((obj instanceof $c_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$ReactClassAttribute) || (obj === null)) ? obj : $throwClassCastException(obj, "scommons.reactnative.highlighter.package$SyntaxHighlighterVirtualDOMAttributes$ReactClassAttribute"))
}
function $isArrayOf_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$ReactClassAttribute(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$ReactClassAttribute)))
}
function $asArrayOf_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$ReactClassAttribute(obj, depth) {
  return (($isArrayOf_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$ReactClassAttribute(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscommons.reactnative.highlighter.package$SyntaxHighlighterVirtualDOMAttributes$ReactClassAttribute;", depth))
}
var $d_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$ReactClassAttribute = new $TypeData().initClass({
  Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$ReactClassAttribute: 0
}, false, "scommons.reactnative.highlighter.package$SyntaxHighlighterVirtualDOMAttributes$ReactClassAttribute", {
  Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$ReactClassAttribute: 1,
  O: 1,
  Lio_github_shogowada_statictags_AttributeSpec: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$ReactClassAttribute.prototype.$classData = $d_Lscommons_reactnative_highlighter_package$SyntaxHighlighterVirtualDOMAttributes$ReactClassAttribute;
/** @constructor */
function $c_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes$JsObjectAttribute(name) {
  this.Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes$JsObjectAttribute__f_name = null;
  this.Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes$JsObjectAttribute__f_name = name
}
$c_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes$JsObjectAttribute.prototype = new $h_O();
$c_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes$JsObjectAttribute.prototype.constructor = $c_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes$JsObjectAttribute;
/** @constructor */
function $h_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes$JsObjectAttribute() {
  /*<skip>*/
}
$h_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes$JsObjectAttribute.prototype = $c_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes$JsObjectAttribute.prototype;
$c_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes$JsObjectAttribute.prototype.$colon$eq__sjs_js_Object__Lio_github_shogowada_statictags_Attribute = (function(value) {
  return new $c_Lio_github_shogowada_statictags_Attribute(this.Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes$JsObjectAttribute__f_name, value, $m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMAttributes__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$().Type__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$().AS_IS__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$AS\uff3fIS$())
});
$c_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes$JsObjectAttribute.prototype.productPrefix__T = (function() {
  return "JsObjectAttribute"
});
$c_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes$JsObjectAttribute.prototype.productArity__I = (function() {
  return 1
});
$c_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes$JsObjectAttribute.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes$JsObjectAttribute__f_name : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes$JsObjectAttribute.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes$JsObjectAttribute.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes$JsObjectAttribute.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes$JsObjectAttribute.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes$JsObjectAttribute)) {
    var JsObjectAttribute$1 = $as_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes$JsObjectAttribute(x$1);
    return (this.Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes$JsObjectAttribute__f_name === JsObjectAttribute$1.Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes$JsObjectAttribute__f_name)
  } else {
    return false
  }
});
function $as_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes$JsObjectAttribute(obj) {
  return (((obj instanceof $c_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes$JsObjectAttribute) || (obj === null)) ? obj : $throwClassCastException(obj, "scommons.reactnative.htmlview.package$HTMLViewVirtualDOMAttributes$JsObjectAttribute"))
}
function $isArrayOf_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes$JsObjectAttribute(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes$JsObjectAttribute)))
}
function $asArrayOf_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes$JsObjectAttribute(obj, depth) {
  return (($isArrayOf_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes$JsObjectAttribute(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscommons.reactnative.htmlview.package$HTMLViewVirtualDOMAttributes$JsObjectAttribute;", depth))
}
var $d_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes$JsObjectAttribute = new $TypeData().initClass({
  Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes$JsObjectAttribute: 0
}, false, "scommons.reactnative.htmlview.package$HTMLViewVirtualDOMAttributes$JsObjectAttribute", {
  Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes$JsObjectAttribute: 1,
  O: 1,
  Lio_github_shogowada_statictags_AttributeSpec: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes$JsObjectAttribute.prototype.$classData = $d_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes$JsObjectAttribute;
/** @constructor */
function $c_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes$RenderNodeAttribute(name) {
  this.Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes$RenderNodeAttribute__f_name = null;
  this.Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes$RenderNodeAttribute__f_name = name
}
$c_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes$RenderNodeAttribute.prototype = new $h_O();
$c_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes$RenderNodeAttribute.prototype.constructor = $c_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes$RenderNodeAttribute;
/** @constructor */
function $h_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes$RenderNodeAttribute() {
  /*<skip>*/
}
$h_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes$RenderNodeAttribute.prototype = $c_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes$RenderNodeAttribute.prototype;
$c_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes$RenderNodeAttribute.prototype.$colon$eq__sjs_js_Function5__Lio_github_shogowada_statictags_Attribute = (function(value) {
  return new $c_Lio_github_shogowada_statictags_Attribute(this.Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes$RenderNodeAttribute__f_name, value, $m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMAttributes__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$().Type__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$().AS_IS__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$AS\uff3fIS$())
});
$c_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes$RenderNodeAttribute.prototype.productPrefix__T = (function() {
  return "RenderNodeAttribute"
});
$c_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes$RenderNodeAttribute.prototype.productArity__I = (function() {
  return 1
});
$c_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes$RenderNodeAttribute.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes$RenderNodeAttribute__f_name : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes$RenderNodeAttribute.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes$RenderNodeAttribute.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes$RenderNodeAttribute.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes$RenderNodeAttribute.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes$RenderNodeAttribute)) {
    var RenderNodeAttribute$1 = $as_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes$RenderNodeAttribute(x$1);
    return (this.Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes$RenderNodeAttribute__f_name === RenderNodeAttribute$1.Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes$RenderNodeAttribute__f_name)
  } else {
    return false
  }
});
function $as_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes$RenderNodeAttribute(obj) {
  return (((obj instanceof $c_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes$RenderNodeAttribute) || (obj === null)) ? obj : $throwClassCastException(obj, "scommons.reactnative.htmlview.package$HTMLViewVirtualDOMAttributes$RenderNodeAttribute"))
}
function $isArrayOf_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes$RenderNodeAttribute(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes$RenderNodeAttribute)))
}
function $asArrayOf_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes$RenderNodeAttribute(obj, depth) {
  return (($isArrayOf_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes$RenderNodeAttribute(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscommons.reactnative.htmlview.package$HTMLViewVirtualDOMAttributes$RenderNodeAttribute;", depth))
}
var $d_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes$RenderNodeAttribute = new $TypeData().initClass({
  Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes$RenderNodeAttribute: 0
}, false, "scommons.reactnative.htmlview.package$HTMLViewVirtualDOMAttributes$RenderNodeAttribute", {
  Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes$RenderNodeAttribute: 1,
  O: 1,
  Lio_github_shogowada_statictags_AttributeSpec: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes$RenderNodeAttribute.prototype.$classData = $d_Lscommons_reactnative_htmlview_package$HTMLViewVirtualDOMAttributes$RenderNodeAttribute;
/** @constructor */
function $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeSizeAttributeSpec(name) {
  this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeSizeAttributeSpec__f_name = null;
  this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeSizeAttributeSpec__f_name = name
}
$c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeSizeAttributeSpec.prototype = new $h_O();
$c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeSizeAttributeSpec.prototype.constructor = $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeSizeAttributeSpec;
/** @constructor */
function $h_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeSizeAttributeSpec() {
  /*<skip>*/
}
$h_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeSizeAttributeSpec.prototype = $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeSizeAttributeSpec.prototype;
$c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeSizeAttributeSpec.prototype.$colon$eq__I__Lio_github_shogowada_statictags_Attribute = (function(style) {
  return new $c_Lio_github_shogowada_statictags_Attribute(this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeSizeAttributeSpec__f_name, style, $m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMAttributes__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$().Type__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$().AS_IS__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$AS\uff3fIS$())
});
$c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeSizeAttributeSpec.prototype.productPrefix__T = (function() {
  return "ReactNativeSizeAttributeSpec"
});
$c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeSizeAttributeSpec.prototype.productArity__I = (function() {
  return 1
});
$c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeSizeAttributeSpec.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeSizeAttributeSpec__f_name : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeSizeAttributeSpec.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeSizeAttributeSpec.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeSizeAttributeSpec.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeSizeAttributeSpec.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeSizeAttributeSpec)) {
    var ReactNativeSizeAttributeSpec$1 = $as_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeSizeAttributeSpec(x$1);
    return (this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeSizeAttributeSpec__f_name === ReactNativeSizeAttributeSpec$1.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeSizeAttributeSpec__f_name)
  } else {
    return false
  }
});
function $as_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeSizeAttributeSpec(obj) {
  return (((obj instanceof $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeSizeAttributeSpec) || (obj === null)) ? obj : $throwClassCastException(obj, "scommons.reactnative.package$ReactNativeVirtualDOMAttributes$ReactNativeSizeAttributeSpec"))
}
function $isArrayOf_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeSizeAttributeSpec(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeSizeAttributeSpec)))
}
function $asArrayOf_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeSizeAttributeSpec(obj, depth) {
  return (($isArrayOf_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeSizeAttributeSpec(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscommons.reactnative.package$ReactNativeVirtualDOMAttributes$ReactNativeSizeAttributeSpec;", depth))
}
var $d_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeSizeAttributeSpec = new $TypeData().initClass({
  Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeSizeAttributeSpec: 0
}, false, "scommons.reactnative.package$ReactNativeVirtualDOMAttributes$ReactNativeSizeAttributeSpec", {
  Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeSizeAttributeSpec: 1,
  O: 1,
  Lio_github_shogowada_statictags_AttributeSpec: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeSizeAttributeSpec.prototype.$classData = $d_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeSizeAttributeSpec;
/** @constructor */
function $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec(name) {
  this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec__f_name = null;
  this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec__f_name = name
}
$c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec.prototype = new $h_O();
$c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec.prototype.constructor = $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec;
/** @constructor */
function $h_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec() {
  /*<skip>*/
}
$h_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec.prototype = $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec.prototype;
$c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec.prototype.$colon$eq__Lscommons_reactnative_Style__Lio_github_shogowada_statictags_Attribute = (function(style) {
  return new $c_Lio_github_shogowada_statictags_Attribute(this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec__f_name, style, $m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMAttributes__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$().Type__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$().AS_IS__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$AS\uff3fIS$())
});
$c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec.prototype.$colon$eq__sjs_js_Array__Lio_github_shogowada_statictags_Attribute = (function(style) {
  return new $c_Lio_github_shogowada_statictags_Attribute(this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec__f_name, style, $m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMAttributes__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$().Type__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$().AS_IS__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$AS\uff3fIS$())
});
$c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec.prototype.productPrefix__T = (function() {
  return "ReactNativeStyleAttributeSpec"
});
$c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec.prototype.productArity__I = (function() {
  return 1
});
$c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec__f_name : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec)) {
    var ReactNativeStyleAttributeSpec$1 = $as_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec(x$1);
    return (this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec__f_name === ReactNativeStyleAttributeSpec$1.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec__f_name)
  } else {
    return false
  }
});
function $as_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec(obj) {
  return (((obj instanceof $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec) || (obj === null)) ? obj : $throwClassCastException(obj, "scommons.reactnative.package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec"))
}
function $isArrayOf_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec)))
}
function $asArrayOf_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec(obj, depth) {
  return (($isArrayOf_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscommons.reactnative.package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec;", depth))
}
var $d_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec = new $TypeData().initClass({
  Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec: 0
}, false, "scommons.reactnative.package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec", {
  Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec: 1,
  O: 1,
  Lio_github_shogowada_statictags_AttributeSpec: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec.prototype.$classData = $d_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec;
/** @constructor */
function $c_Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes$OnValueChangeAttributeSpec(name) {
  this.Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes$OnValueChangeAttributeSpec__f_name = null;
  this.Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes$OnValueChangeAttributeSpec__f_name = name
}
$c_Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes$OnValueChangeAttributeSpec.prototype = new $h_O();
$c_Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes$OnValueChangeAttributeSpec.prototype.constructor = $c_Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes$OnValueChangeAttributeSpec;
/** @constructor */
function $h_Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes$OnValueChangeAttributeSpec() {
  /*<skip>*/
}
$h_Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes$OnValueChangeAttributeSpec.prototype = $c_Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes$OnValueChangeAttributeSpec.prototype;
$c_Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes$OnValueChangeAttributeSpec.prototype.$colon$eq__sjs_js_Function2__Lio_github_shogowada_statictags_Attribute = (function(value) {
  return new $c_Lio_github_shogowada_statictags_Attribute(this.Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes$OnValueChangeAttributeSpec__f_name, value, $m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMAttributes__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$().Type__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$().AS_IS__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$AS\uff3fIS$())
});
$c_Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes$OnValueChangeAttributeSpec.prototype.productPrefix__T = (function() {
  return "OnValueChangeAttributeSpec"
});
$c_Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes$OnValueChangeAttributeSpec.prototype.productArity__I = (function() {
  return 1
});
$c_Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes$OnValueChangeAttributeSpec.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes$OnValueChangeAttributeSpec__f_name : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes$OnValueChangeAttributeSpec.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes$OnValueChangeAttributeSpec.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes$OnValueChangeAttributeSpec.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes$OnValueChangeAttributeSpec.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes$OnValueChangeAttributeSpec)) {
    var OnValueChangeAttributeSpec$1 = $as_Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes$OnValueChangeAttributeSpec(x$1);
    return (this.Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes$OnValueChangeAttributeSpec__f_name === OnValueChangeAttributeSpec$1.Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes$OnValueChangeAttributeSpec__f_name)
  } else {
    return false
  }
});
function $as_Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes$OnValueChangeAttributeSpec(obj) {
  return (((obj instanceof $c_Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes$OnValueChangeAttributeSpec) || (obj === null)) ? obj : $throwClassCastException(obj, "scommons.reactnative.picker.package$PickerVirtualDOMAttributes$OnValueChangeAttributeSpec"))
}
function $isArrayOf_Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes$OnValueChangeAttributeSpec(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes$OnValueChangeAttributeSpec)))
}
function $asArrayOf_Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes$OnValueChangeAttributeSpec(obj, depth) {
  return (($isArrayOf_Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes$OnValueChangeAttributeSpec(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscommons.reactnative.picker.package$PickerVirtualDOMAttributes$OnValueChangeAttributeSpec;", depth))
}
var $d_Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes$OnValueChangeAttributeSpec = new $TypeData().initClass({
  Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes$OnValueChangeAttributeSpec: 0
}, false, "scommons.reactnative.picker.package$PickerVirtualDOMAttributes$OnValueChangeAttributeSpec", {
  Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes$OnValueChangeAttributeSpec: 1,
  O: 1,
  Lio_github_shogowada_statictags_AttributeSpec: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes$OnValueChangeAttributeSpec.prototype.$classData = $d_Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes$OnValueChangeAttributeSpec;
/** @constructor */
function $c_Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes$SelectedValueAttributeSpec(name) {
  this.Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes$SelectedValueAttributeSpec__f_name = null;
  this.Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes$SelectedValueAttributeSpec__f_name = name
}
$c_Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes$SelectedValueAttributeSpec.prototype = new $h_O();
$c_Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes$SelectedValueAttributeSpec.prototype.constructor = $c_Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes$SelectedValueAttributeSpec;
/** @constructor */
function $h_Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes$SelectedValueAttributeSpec() {
  /*<skip>*/
}
$h_Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes$SelectedValueAttributeSpec.prototype = $c_Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes$SelectedValueAttributeSpec.prototype;
$c_Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes$SelectedValueAttributeSpec.prototype.$colon$eq__sjs_js_$bar__Lio_github_shogowada_statictags_Attribute = (function(value) {
  return new $c_Lio_github_shogowada_statictags_Attribute(this.Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes$SelectedValueAttributeSpec__f_name, value, $m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMAttributes__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$().Type__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$().AS_IS__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$AS\uff3fIS$())
});
$c_Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes$SelectedValueAttributeSpec.prototype.productPrefix__T = (function() {
  return "SelectedValueAttributeSpec"
});
$c_Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes$SelectedValueAttributeSpec.prototype.productArity__I = (function() {
  return 1
});
$c_Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes$SelectedValueAttributeSpec.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes$SelectedValueAttributeSpec__f_name : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes$SelectedValueAttributeSpec.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes$SelectedValueAttributeSpec.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes$SelectedValueAttributeSpec.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes$SelectedValueAttributeSpec.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes$SelectedValueAttributeSpec)) {
    var SelectedValueAttributeSpec$1 = $as_Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes$SelectedValueAttributeSpec(x$1);
    return (this.Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes$SelectedValueAttributeSpec__f_name === SelectedValueAttributeSpec$1.Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes$SelectedValueAttributeSpec__f_name)
  } else {
    return false
  }
});
function $as_Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes$SelectedValueAttributeSpec(obj) {
  return (((obj instanceof $c_Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes$SelectedValueAttributeSpec) || (obj === null)) ? obj : $throwClassCastException(obj, "scommons.reactnative.picker.package$PickerVirtualDOMAttributes$SelectedValueAttributeSpec"))
}
function $isArrayOf_Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes$SelectedValueAttributeSpec(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes$SelectedValueAttributeSpec)))
}
function $asArrayOf_Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes$SelectedValueAttributeSpec(obj, depth) {
  return (($isArrayOf_Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes$SelectedValueAttributeSpec(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscommons.reactnative.picker.package$PickerVirtualDOMAttributes$SelectedValueAttributeSpec;", depth))
}
var $d_Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes$SelectedValueAttributeSpec = new $TypeData().initClass({
  Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes$SelectedValueAttributeSpec: 0
}, false, "scommons.reactnative.picker.package$PickerVirtualDOMAttributes$SelectedValueAttributeSpec", {
  Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes$SelectedValueAttributeSpec: 1,
  O: 1,
  Lio_github_shogowada_statictags_AttributeSpec: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes$SelectedValueAttributeSpec.prototype.$classData = $d_Lscommons_reactnative_picker_package$PickerVirtualDOMAttributes$SelectedValueAttributeSpec;
/** @constructor */
function $c_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes$EdgesAttributeSpec(name) {
  this.Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes$EdgesAttributeSpec__f_name = null;
  this.Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes$EdgesAttributeSpec__f_name = name
}
$c_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes$EdgesAttributeSpec.prototype = new $h_O();
$c_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes$EdgesAttributeSpec.prototype.constructor = $c_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes$EdgesAttributeSpec;
/** @constructor */
function $h_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes$EdgesAttributeSpec() {
  /*<skip>*/
}
$h_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes$EdgesAttributeSpec.prototype = $c_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes$EdgesAttributeSpec.prototype;
$c_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes$EdgesAttributeSpec.prototype.$colon$eq__sci_Seq__Lio_github_shogowada_statictags_Attribute = (function(values) {
  var $$x2 = this.Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes$EdgesAttributeSpec__f_name;
  var $$x1 = $m_sjsr_Compat$().toJSVarArgsImpl__sci_Seq__sjs_js_Array(values);
  return new $c_Lio_github_shogowada_statictags_Attribute($$x2, $$x1, $m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMAttributes__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$().Type__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$().AS_IS__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$AS\uff3fIS$())
});
$c_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes$EdgesAttributeSpec.prototype.productPrefix__T = (function() {
  return "EdgesAttributeSpec"
});
$c_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes$EdgesAttributeSpec.prototype.productArity__I = (function() {
  return 1
});
$c_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes$EdgesAttributeSpec.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes$EdgesAttributeSpec__f_name : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes$EdgesAttributeSpec.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes$EdgesAttributeSpec.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes$EdgesAttributeSpec.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes$EdgesAttributeSpec.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes$EdgesAttributeSpec)) {
    var EdgesAttributeSpec$1 = $as_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes$EdgesAttributeSpec(x$1);
    return (this.Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes$EdgesAttributeSpec__f_name === EdgesAttributeSpec$1.Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes$EdgesAttributeSpec__f_name)
  } else {
    return false
  }
});
function $as_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes$EdgesAttributeSpec(obj) {
  return (((obj instanceof $c_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes$EdgesAttributeSpec) || (obj === null)) ? obj : $throwClassCastException(obj, "scommons.reactnative.safearea.package$SafeAreaVirtualDOMAttributes$EdgesAttributeSpec"))
}
function $isArrayOf_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes$EdgesAttributeSpec(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes$EdgesAttributeSpec)))
}
function $asArrayOf_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes$EdgesAttributeSpec(obj, depth) {
  return (($isArrayOf_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes$EdgesAttributeSpec(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscommons.reactnative.safearea.package$SafeAreaVirtualDOMAttributes$EdgesAttributeSpec;", depth))
}
var $d_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes$EdgesAttributeSpec = new $TypeData().initClass({
  Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes$EdgesAttributeSpec: 0
}, false, "scommons.reactnative.safearea.package$SafeAreaVirtualDOMAttributes$EdgesAttributeSpec", {
  Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes$EdgesAttributeSpec: 1,
  O: 1,
  Lio_github_shogowada_statictags_AttributeSpec: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes$EdgesAttributeSpec.prototype.$classData = $d_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes$EdgesAttributeSpec;
/** @constructor */
function $c_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes$ModeAttributeSpec(name) {
  this.Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes$ModeAttributeSpec__f_name = null;
  this.Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes$ModeAttributeSpec__f_name = name
}
$c_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes$ModeAttributeSpec.prototype = new $h_O();
$c_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes$ModeAttributeSpec.prototype.constructor = $c_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes$ModeAttributeSpec;
/** @constructor */
function $h_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes$ModeAttributeSpec() {
  /*<skip>*/
}
$h_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes$ModeAttributeSpec.prototype = $c_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes$ModeAttributeSpec.prototype;
$c_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes$ModeAttributeSpec.prototype.$colon$eq__Lscommons_reactnative_safearea_SafeArea$SafeAreaMode__Lio_github_shogowada_statictags_Attribute = (function(value) {
  return new $c_Lio_github_shogowada_statictags_Attribute(this.Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes$ModeAttributeSpec__f_name, value, $m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMAttributes__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$().Type__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$().AS_IS__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$AS\uff3fIS$())
});
$c_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes$ModeAttributeSpec.prototype.productPrefix__T = (function() {
  return "ModeAttributeSpec"
});
$c_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes$ModeAttributeSpec.prototype.productArity__I = (function() {
  return 1
});
$c_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes$ModeAttributeSpec.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes$ModeAttributeSpec__f_name : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes$ModeAttributeSpec.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes$ModeAttributeSpec.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes$ModeAttributeSpec.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes$ModeAttributeSpec.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes$ModeAttributeSpec)) {
    var ModeAttributeSpec$1 = $as_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes$ModeAttributeSpec(x$1);
    return (this.Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes$ModeAttributeSpec__f_name === ModeAttributeSpec$1.Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes$ModeAttributeSpec__f_name)
  } else {
    return false
  }
});
function $as_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes$ModeAttributeSpec(obj) {
  return (((obj instanceof $c_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes$ModeAttributeSpec) || (obj === null)) ? obj : $throwClassCastException(obj, "scommons.reactnative.safearea.package$SafeAreaVirtualDOMAttributes$ModeAttributeSpec"))
}
function $isArrayOf_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes$ModeAttributeSpec(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes$ModeAttributeSpec)))
}
function $asArrayOf_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes$ModeAttributeSpec(obj, depth) {
  return (($isArrayOf_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes$ModeAttributeSpec(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscommons.reactnative.safearea.package$SafeAreaVirtualDOMAttributes$ModeAttributeSpec;", depth))
}
var $d_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes$ModeAttributeSpec = new $TypeData().initClass({
  Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes$ModeAttributeSpec: 0
}, false, "scommons.reactnative.safearea.package$SafeAreaVirtualDOMAttributes$ModeAttributeSpec", {
  Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes$ModeAttributeSpec: 1,
  O: 1,
  Lio_github_shogowada_statictags_AttributeSpec: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes$ModeAttributeSpec.prototype.$classData = $d_Lscommons_reactnative_safearea_package$SafeAreaVirtualDOMAttributes$ModeAttributeSpec;
/** @constructor */
function $c_Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes$HtmlSourceAttribute(name) {
  this.Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes$HtmlSourceAttribute__f_name = null;
  this.Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes$HtmlSourceAttribute__f_name = name
}
$c_Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes$HtmlSourceAttribute.prototype = new $h_O();
$c_Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes$HtmlSourceAttribute.prototype.constructor = $c_Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes$HtmlSourceAttribute;
/** @constructor */
function $h_Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes$HtmlSourceAttribute() {
  /*<skip>*/
}
$h_Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes$HtmlSourceAttribute.prototype = $c_Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes$HtmlSourceAttribute.prototype;
$c_Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes$HtmlSourceAttribute.prototype.$colon$eq__Lscommons_reactnative_webview_raw_HtmlResource__Lio_github_shogowada_statictags_Attribute = (function(value) {
  return new $c_Lio_github_shogowada_statictags_Attribute(this.Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes$HtmlSourceAttribute__f_name, value, $m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMAttributes__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$().Type__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$().AS_IS__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$AS\uff3fIS$())
});
$c_Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes$HtmlSourceAttribute.prototype.productPrefix__T = (function() {
  return "HtmlSourceAttribute"
});
$c_Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes$HtmlSourceAttribute.prototype.productArity__I = (function() {
  return 1
});
$c_Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes$HtmlSourceAttribute.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes$HtmlSourceAttribute__f_name : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes$HtmlSourceAttribute.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes$HtmlSourceAttribute.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes$HtmlSourceAttribute.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes$HtmlSourceAttribute.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes$HtmlSourceAttribute)) {
    var HtmlSourceAttribute$1 = $as_Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes$HtmlSourceAttribute(x$1);
    return (this.Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes$HtmlSourceAttribute__f_name === HtmlSourceAttribute$1.Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes$HtmlSourceAttribute__f_name)
  } else {
    return false
  }
});
function $as_Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes$HtmlSourceAttribute(obj) {
  return (((obj instanceof $c_Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes$HtmlSourceAttribute) || (obj === null)) ? obj : $throwClassCastException(obj, "scommons.reactnative.webview.package$WebViewVirtualDOMAttributes$HtmlSourceAttribute"))
}
function $isArrayOf_Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes$HtmlSourceAttribute(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes$HtmlSourceAttribute)))
}
function $asArrayOf_Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes$HtmlSourceAttribute(obj, depth) {
  return (($isArrayOf_Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes$HtmlSourceAttribute(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscommons.reactnative.webview.package$WebViewVirtualDOMAttributes$HtmlSourceAttribute;", depth))
}
var $d_Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes$HtmlSourceAttribute = new $TypeData().initClass({
  Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes$HtmlSourceAttribute: 0
}, false, "scommons.reactnative.webview.package$WebViewVirtualDOMAttributes$HtmlSourceAttribute", {
  Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes$HtmlSourceAttribute: 1,
  O: 1,
  Lio_github_shogowada_statictags_AttributeSpec: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes$HtmlSourceAttribute.prototype.$classData = $d_Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes$HtmlSourceAttribute;
/** @constructor */
function $c_Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes$OriginWhiteListAttribute(name) {
  this.Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes$OriginWhiteListAttribute__f_name = null;
  this.Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes$OriginWhiteListAttribute__f_name = name
}
$c_Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes$OriginWhiteListAttribute.prototype = new $h_O();
$c_Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes$OriginWhiteListAttribute.prototype.constructor = $c_Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes$OriginWhiteListAttribute;
/** @constructor */
function $h_Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes$OriginWhiteListAttribute() {
  /*<skip>*/
}
$h_Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes$OriginWhiteListAttribute.prototype = $c_Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes$OriginWhiteListAttribute.prototype;
$c_Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes$OriginWhiteListAttribute.prototype.$colon$eq__sci_Seq__Lio_github_shogowada_statictags_Attribute = (function(value) {
  var $$x2 = this.Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes$OriginWhiteListAttribute__f_name;
  var $$x1 = $m_sjsr_Compat$().toJSVarArgsImpl__sci_Seq__sjs_js_Array(value);
  return new $c_Lio_github_shogowada_statictags_Attribute($$x2, $$x1, $m_Lio_github_shogowada_scalajs_reactjs_VirtualDOM$().VirtualDOMAttributes__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$().Type__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$().AS_IS__Lio_github_shogowada_scalajs_reactjs_VirtualDOM$VirtualDOMAttributes$Type$AS\uff3fIS$())
});
$c_Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes$OriginWhiteListAttribute.prototype.productPrefix__T = (function() {
  return "OriginWhiteListAttribute"
});
$c_Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes$OriginWhiteListAttribute.prototype.productArity__I = (function() {
  return 1
});
$c_Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes$OriginWhiteListAttribute.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes$OriginWhiteListAttribute__f_name : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes$OriginWhiteListAttribute.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes$OriginWhiteListAttribute.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes$OriginWhiteListAttribute.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes$OriginWhiteListAttribute.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes$OriginWhiteListAttribute)) {
    var OriginWhiteListAttribute$1 = $as_Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes$OriginWhiteListAttribute(x$1);
    return (this.Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes$OriginWhiteListAttribute__f_name === OriginWhiteListAttribute$1.Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes$OriginWhiteListAttribute__f_name)
  } else {
    return false
  }
});
function $as_Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes$OriginWhiteListAttribute(obj) {
  return (((obj instanceof $c_Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes$OriginWhiteListAttribute) || (obj === null)) ? obj : $throwClassCastException(obj, "scommons.reactnative.webview.package$WebViewVirtualDOMAttributes$OriginWhiteListAttribute"))
}
function $isArrayOf_Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes$OriginWhiteListAttribute(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes$OriginWhiteListAttribute)))
}
function $asArrayOf_Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes$OriginWhiteListAttribute(obj, depth) {
  return (($isArrayOf_Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes$OriginWhiteListAttribute(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscommons.reactnative.webview.package$WebViewVirtualDOMAttributes$OriginWhiteListAttribute;", depth))
}
var $d_Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes$OriginWhiteListAttribute = new $TypeData().initClass({
  Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes$OriginWhiteListAttribute: 0
}, false, "scommons.reactnative.webview.package$WebViewVirtualDOMAttributes$OriginWhiteListAttribute", {
  Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes$OriginWhiteListAttribute: 1,
  O: 1,
  Lio_github_shogowada_statictags_AttributeSpec: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes$OriginWhiteListAttribute.prototype.$classData = $d_Lscommons_reactnative_webview_package$WebViewVirtualDOMAttributes$OriginWhiteListAttribute;
/** @constructor */
function $c_Lshowcase_app_ShowcaseApp$$anonfun$cacheFonts$1$1(outer) {
  /*<skip>*/
}
$c_Lshowcase_app_ShowcaseApp$$anonfun$cacheFonts$1$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lshowcase_app_ShowcaseApp$$anonfun$cacheFonts$1$1.prototype.constructor = $c_Lshowcase_app_ShowcaseApp$$anonfun$cacheFonts$1$1;
/** @constructor */
function $h_Lshowcase_app_ShowcaseApp$$anonfun$cacheFonts$1$1() {
  /*<skip>*/
}
$h_Lshowcase_app_ShowcaseApp$$anonfun$cacheFonts$1$1.prototype = $c_Lshowcase_app_ShowcaseApp$$anonfun$cacheFonts$1$1.prototype;
$c_Lshowcase_app_ShowcaseApp$$anonfun$cacheFonts$1$1.prototype.applyOrElse__jl_Throwable__F1__O = (function(x1, default$1) {
  $m_s_Console$().err__Ljava_io_PrintStream().println__T__V("Failed to cache fonts");
  var value = (void 0);
  return value
});
$c_Lshowcase_app_ShowcaseApp$$anonfun$cacheFonts$1$1.prototype.isDefinedAt__jl_Throwable__Z = (function(x1) {
  return true
});
$c_Lshowcase_app_ShowcaseApp$$anonfun$cacheFonts$1$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__jl_Throwable__Z($as_jl_Throwable(x))
});
$c_Lshowcase_app_ShowcaseApp$$anonfun$cacheFonts$1$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__jl_Throwable__F1__O($as_jl_Throwable(x), default$1)
});
var $d_Lshowcase_app_ShowcaseApp$$anonfun$cacheFonts$1$1 = new $TypeData().initClass({
  Lshowcase_app_ShowcaseApp$$anonfun$cacheFonts$1$1: 0
}, false, "showcase.app.ShowcaseApp$$anonfun$cacheFonts$1$1", {
  Lshowcase_app_ShowcaseApp$$anonfun$cacheFonts$1$1: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lshowcase_app_ShowcaseApp$$anonfun$cacheFonts$1$1.prototype.$classData = $d_Lshowcase_app_ShowcaseApp$$anonfun$cacheFonts$1$1;
/** @constructor */
function $c_Lshowcase_app_ShowcaseApp$$anonfun$cacheIcons$1$1(outer) {
  /*<skip>*/
}
$c_Lshowcase_app_ShowcaseApp$$anonfun$cacheIcons$1$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lshowcase_app_ShowcaseApp$$anonfun$cacheIcons$1$1.prototype.constructor = $c_Lshowcase_app_ShowcaseApp$$anonfun$cacheIcons$1$1;
/** @constructor */
function $h_Lshowcase_app_ShowcaseApp$$anonfun$cacheIcons$1$1() {
  /*<skip>*/
}
$h_Lshowcase_app_ShowcaseApp$$anonfun$cacheIcons$1$1.prototype = $c_Lshowcase_app_ShowcaseApp$$anonfun$cacheIcons$1$1.prototype;
$c_Lshowcase_app_ShowcaseApp$$anonfun$cacheIcons$1$1.prototype.applyOrElse__jl_Throwable__F1__O = (function(x1, default$1) {
  $m_s_Console$().err__Ljava_io_PrintStream().println__T__V("Failed to cache icons");
  var value = (void 0);
  return value
});
$c_Lshowcase_app_ShowcaseApp$$anonfun$cacheIcons$1$1.prototype.isDefinedAt__jl_Throwable__Z = (function(x1) {
  return true
});
$c_Lshowcase_app_ShowcaseApp$$anonfun$cacheIcons$1$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__jl_Throwable__Z($as_jl_Throwable(x))
});
$c_Lshowcase_app_ShowcaseApp$$anonfun$cacheIcons$1$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__jl_Throwable__F1__O($as_jl_Throwable(x), default$1)
});
var $d_Lshowcase_app_ShowcaseApp$$anonfun$cacheIcons$1$1 = new $TypeData().initClass({
  Lshowcase_app_ShowcaseApp$$anonfun$cacheIcons$1$1: 0
}, false, "showcase.app.ShowcaseApp$$anonfun$cacheIcons$1$1", {
  Lshowcase_app_ShowcaseApp$$anonfun$cacheIcons$1$1: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lshowcase_app_ShowcaseApp$$anonfun$cacheIcons$1$1.prototype.$classData = $d_Lshowcase_app_ShowcaseApp$$anonfun$cacheIcons$1$1;
/** @constructor */
function $c_Lshowcase_app_ShowcaseApp$$anonfun$cacheImages$1$1(outer) {
  /*<skip>*/
}
$c_Lshowcase_app_ShowcaseApp$$anonfun$cacheImages$1$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lshowcase_app_ShowcaseApp$$anonfun$cacheImages$1$1.prototype.constructor = $c_Lshowcase_app_ShowcaseApp$$anonfun$cacheImages$1$1;
/** @constructor */
function $h_Lshowcase_app_ShowcaseApp$$anonfun$cacheImages$1$1() {
  /*<skip>*/
}
$h_Lshowcase_app_ShowcaseApp$$anonfun$cacheImages$1$1.prototype = $c_Lshowcase_app_ShowcaseApp$$anonfun$cacheImages$1$1.prototype;
$c_Lshowcase_app_ShowcaseApp$$anonfun$cacheImages$1$1.prototype.applyOrElse__jl_Throwable__F1__O = (function(x1, default$1) {
  $m_s_Console$().err__Ljava_io_PrintStream().println__T__V("Failed to cache images");
  var value = (void 0);
  return value
});
$c_Lshowcase_app_ShowcaseApp$$anonfun$cacheImages$1$1.prototype.isDefinedAt__jl_Throwable__Z = (function(x1) {
  return true
});
$c_Lshowcase_app_ShowcaseApp$$anonfun$cacheImages$1$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__jl_Throwable__Z($as_jl_Throwable(x))
});
$c_Lshowcase_app_ShowcaseApp$$anonfun$cacheImages$1$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__jl_Throwable__F1__O($as_jl_Throwable(x), default$1)
});
var $d_Lshowcase_app_ShowcaseApp$$anonfun$cacheImages$1$1 = new $TypeData().initClass({
  Lshowcase_app_ShowcaseApp$$anonfun$cacheImages$1$1: 0
}, false, "showcase.app.ShowcaseApp$$anonfun$cacheImages$1$1", {
  Lshowcase_app_ShowcaseApp$$anonfun$cacheImages$1$1: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lshowcase_app_ShowcaseApp$$anonfun$cacheImages$1$1.prototype.$classData = $d_Lshowcase_app_ShowcaseApp$$anonfun$cacheImages$1$1;
/** @constructor */
function $c_Lshowcase_app_ShowcaseApp$$anonfun$preloadAssets$1(outer, onFinish$1) {
  this.Lshowcase_app_ShowcaseApp$$anonfun$preloadAssets$1__f_onFinish$1 = null;
  this.Lshowcase_app_ShowcaseApp$$anonfun$preloadAssets$1__f_onFinish$1 = onFinish$1
}
$c_Lshowcase_app_ShowcaseApp$$anonfun$preloadAssets$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lshowcase_app_ShowcaseApp$$anonfun$preloadAssets$1.prototype.constructor = $c_Lshowcase_app_ShowcaseApp$$anonfun$preloadAssets$1;
/** @constructor */
function $h_Lshowcase_app_ShowcaseApp$$anonfun$preloadAssets$1() {
  /*<skip>*/
}
$h_Lshowcase_app_ShowcaseApp$$anonfun$preloadAssets$1.prototype = $c_Lshowcase_app_ShowcaseApp$$anonfun$preloadAssets$1.prototype;
$c_Lshowcase_app_ShowcaseApp$$anonfun$preloadAssets$1.prototype.applyOrElse__s_util_Try__F1__O = (function(x1, default$1) {
  var this$1 = this.Lshowcase_app_ShowcaseApp$$anonfun$preloadAssets$1__f_onFinish$1;
  this$1.apply__O()
});
$c_Lshowcase_app_ShowcaseApp$$anonfun$preloadAssets$1.prototype.isDefinedAt__s_util_Try__Z = (function(x1) {
  return true
});
$c_Lshowcase_app_ShowcaseApp$$anonfun$preloadAssets$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__s_util_Try__Z($as_s_util_Try(x))
});
$c_Lshowcase_app_ShowcaseApp$$anonfun$preloadAssets$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__s_util_Try__F1__O($as_s_util_Try(x), default$1)
});
var $d_Lshowcase_app_ShowcaseApp$$anonfun$preloadAssets$1 = new $TypeData().initClass({
  Lshowcase_app_ShowcaseApp$$anonfun$preloadAssets$1: 0
}, false, "showcase.app.ShowcaseApp$$anonfun$preloadAssets$1", {
  Lshowcase_app_ShowcaseApp$$anonfun$preloadAssets$1: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lshowcase_app_ShowcaseApp$$anonfun$preloadAssets$1.prototype.$classData = $d_Lshowcase_app_ShowcaseApp$$anonfun$preloadAssets$1;
/** @constructor */
function $c_Lshowcase_app_ShowcaseState(currentTask, config) {
  this.Lshowcase_app_ShowcaseState__f_currentTask = null;
  this.Lshowcase_app_ShowcaseState__f_config = null;
  this.Lshowcase_app_ShowcaseState__f_currentTask = currentTask;
  this.Lshowcase_app_ShowcaseState__f_config = config
}
$c_Lshowcase_app_ShowcaseState.prototype = new $h_O();
$c_Lshowcase_app_ShowcaseState.prototype.constructor = $c_Lshowcase_app_ShowcaseState;
/** @constructor */
function $h_Lshowcase_app_ShowcaseState() {
  /*<skip>*/
}
$h_Lshowcase_app_ShowcaseState.prototype = $c_Lshowcase_app_ShowcaseState.prototype;
$c_Lshowcase_app_ShowcaseState.prototype.productPrefix__T = (function() {
  return "ShowcaseState"
});
$c_Lshowcase_app_ShowcaseState.prototype.productArity__I = (function() {
  return 2
});
$c_Lshowcase_app_ShowcaseState.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.Lshowcase_app_ShowcaseState__f_currentTask;
      break
    }
    case 1: {
      return this.Lshowcase_app_ShowcaseState__f_config;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_Lshowcase_app_ShowcaseState.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lshowcase_app_ShowcaseState.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lshowcase_app_ShowcaseState.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lshowcase_app_ShowcaseState.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lshowcase_app_ShowcaseState)) {
    var ShowcaseState$1 = $as_Lshowcase_app_ShowcaseState(x$1);
    var x = this.Lshowcase_app_ShowcaseState__f_currentTask;
    var x$2 = ShowcaseState$1.Lshowcase_app_ShowcaseState__f_currentTask;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lshowcase_app_ShowcaseState__f_config;
      var x$4 = ShowcaseState$1.Lshowcase_app_ShowcaseState__f_config;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
function $as_Lshowcase_app_ShowcaseState(obj) {
  return (((obj instanceof $c_Lshowcase_app_ShowcaseState) || (obj === null)) ? obj : $throwClassCastException(obj, "showcase.app.ShowcaseState"))
}
function $isArrayOf_Lshowcase_app_ShowcaseState(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lshowcase_app_ShowcaseState)))
}
function $asArrayOf_Lshowcase_app_ShowcaseState(obj, depth) {
  return (($isArrayOf_Lshowcase_app_ShowcaseState(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lshowcase.app.ShowcaseState;", depth))
}
var $d_Lshowcase_app_ShowcaseState = new $TypeData().initClass({
  Lshowcase_app_ShowcaseState: 0
}, false, "showcase.app.ShowcaseState", {
  Lshowcase_app_ShowcaseState: 1,
  O: 1,
  Lshowcase_app_ShowcaseStateDef: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lshowcase_app_ShowcaseState.prototype.$classData = $d_Lshowcase_app_ShowcaseState;
/** @constructor */
function $c_Lshowcase_app_config_ShowcaseConfigActions$ShowcaseThemeChangedAction(darkTheme) {
  this.Lshowcase_app_config_ShowcaseConfigActions$ShowcaseThemeChangedAction__f_darkTheme = false;
  this.Lshowcase_app_config_ShowcaseConfigActions$ShowcaseThemeChangedAction__f_darkTheme = darkTheme
}
$c_Lshowcase_app_config_ShowcaseConfigActions$ShowcaseThemeChangedAction.prototype = new $h_O();
$c_Lshowcase_app_config_ShowcaseConfigActions$ShowcaseThemeChangedAction.prototype.constructor = $c_Lshowcase_app_config_ShowcaseConfigActions$ShowcaseThemeChangedAction;
/** @constructor */
function $h_Lshowcase_app_config_ShowcaseConfigActions$ShowcaseThemeChangedAction() {
  /*<skip>*/
}
$h_Lshowcase_app_config_ShowcaseConfigActions$ShowcaseThemeChangedAction.prototype = $c_Lshowcase_app_config_ShowcaseConfigActions$ShowcaseThemeChangedAction.prototype;
$c_Lshowcase_app_config_ShowcaseConfigActions$ShowcaseThemeChangedAction.prototype.productPrefix__T = (function() {
  return "ShowcaseThemeChangedAction"
});
$c_Lshowcase_app_config_ShowcaseConfigActions$ShowcaseThemeChangedAction.prototype.productArity__I = (function() {
  return 1
});
$c_Lshowcase_app_config_ShowcaseConfigActions$ShowcaseThemeChangedAction.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lshowcase_app_config_ShowcaseConfigActions$ShowcaseThemeChangedAction__f_darkTheme : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lshowcase_app_config_ShowcaseConfigActions$ShowcaseThemeChangedAction.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lshowcase_app_config_ShowcaseConfigActions$ShowcaseThemeChangedAction.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("ShowcaseThemeChangedAction");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = (this.Lshowcase_app_config_ShowcaseConfigActions$ShowcaseThemeChangedAction__f_darkTheme ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$2, 1)
});
$c_Lshowcase_app_config_ShowcaseConfigActions$ShowcaseThemeChangedAction.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lshowcase_app_config_ShowcaseConfigActions$ShowcaseThemeChangedAction.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lshowcase_app_config_ShowcaseConfigActions$ShowcaseThemeChangedAction)) {
    var ShowcaseThemeChangedAction$1 = $as_Lshowcase_app_config_ShowcaseConfigActions$ShowcaseThemeChangedAction(x$1);
    return (this.Lshowcase_app_config_ShowcaseConfigActions$ShowcaseThemeChangedAction__f_darkTheme === ShowcaseThemeChangedAction$1.Lshowcase_app_config_ShowcaseConfigActions$ShowcaseThemeChangedAction__f_darkTheme)
  } else {
    return false
  }
});
function $as_Lshowcase_app_config_ShowcaseConfigActions$ShowcaseThemeChangedAction(obj) {
  return (((obj instanceof $c_Lshowcase_app_config_ShowcaseConfigActions$ShowcaseThemeChangedAction) || (obj === null)) ? obj : $throwClassCastException(obj, "showcase.app.config.ShowcaseConfigActions$ShowcaseThemeChangedAction"))
}
function $isArrayOf_Lshowcase_app_config_ShowcaseConfigActions$ShowcaseThemeChangedAction(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lshowcase_app_config_ShowcaseConfigActions$ShowcaseThemeChangedAction)))
}
function $asArrayOf_Lshowcase_app_config_ShowcaseConfigActions$ShowcaseThemeChangedAction(obj, depth) {
  return (($isArrayOf_Lshowcase_app_config_ShowcaseConfigActions$ShowcaseThemeChangedAction(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lshowcase.app.config.ShowcaseConfigActions$ShowcaseThemeChangedAction;", depth))
}
var $d_Lshowcase_app_config_ShowcaseConfigActions$ShowcaseThemeChangedAction = new $TypeData().initClass({
  Lshowcase_app_config_ShowcaseConfigActions$ShowcaseThemeChangedAction: 0
}, false, "showcase.app.config.ShowcaseConfigActions$ShowcaseThemeChangedAction", {
  Lshowcase_app_config_ShowcaseConfigActions$ShowcaseThemeChangedAction: 1,
  O: 1,
  Lio_github_shogowada_scalajs_reactjs_redux_Action: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lshowcase_app_config_ShowcaseConfigActions$ShowcaseThemeChangedAction.prototype.$classData = $d_Lshowcase_app_config_ShowcaseConfigActions$ShowcaseThemeChangedAction;
/** @constructor */
function $c_Lshowcase_app_expo_sqlite_SQLiteDemo$$anonfun$$nestedInanonfun$render$2$1(msgLog$1) {
  this.Lshowcase_app_expo_sqlite_SQLiteDemo$$anonfun$$nestedInanonfun$render$2$1__f_msgLog$1 = null;
  this.Lshowcase_app_expo_sqlite_SQLiteDemo$$anonfun$$nestedInanonfun$render$2$1__f_msgLog$1 = msgLog$1
}
$c_Lshowcase_app_expo_sqlite_SQLiteDemo$$anonfun$$nestedInanonfun$render$2$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lshowcase_app_expo_sqlite_SQLiteDemo$$anonfun$$nestedInanonfun$render$2$1.prototype.constructor = $c_Lshowcase_app_expo_sqlite_SQLiteDemo$$anonfun$$nestedInanonfun$render$2$1;
/** @constructor */
function $h_Lshowcase_app_expo_sqlite_SQLiteDemo$$anonfun$$nestedInanonfun$render$2$1() {
  /*<skip>*/
}
$h_Lshowcase_app_expo_sqlite_SQLiteDemo$$anonfun$$nestedInanonfun$render$2$1.prototype = $c_Lshowcase_app_expo_sqlite_SQLiteDemo$$anonfun$$nestedInanonfun$render$2$1.prototype;
$c_Lshowcase_app_expo_sqlite_SQLiteDemo$$anonfun$$nestedInanonfun$render$2$1.prototype.applyOrElse__jl_Throwable__F1__O = (function(x1, default$1) {
  if ((x1 !== null)) {
    var o7 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(x1);
    if ((!o7.isEmpty__Z())) {
      var error = $as_jl_Throwable(o7.get__O());
      var msg = ("tx error: " + error);
      var msgLog$1 = this.Lshowcase_app_expo_sqlite_SQLiteDemo$$anonfun$$nestedInanonfun$render$2$1__f_msgLog$1;
      msgLog$1.addOne__O__scm_ListBuffer(msg);
      return (void 0)
    }
  };
  return default$1.apply__O__O(x1)
});
$c_Lshowcase_app_expo_sqlite_SQLiteDemo$$anonfun$$nestedInanonfun$render$2$1.prototype.isDefinedAt__jl_Throwable__Z = (function(x1) {
  if ((x1 !== null)) {
    var o7 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(x1);
    if ((!o7.isEmpty__Z())) {
      return true
    }
  };
  return false
});
$c_Lshowcase_app_expo_sqlite_SQLiteDemo$$anonfun$$nestedInanonfun$render$2$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__jl_Throwable__Z($as_jl_Throwable(x))
});
$c_Lshowcase_app_expo_sqlite_SQLiteDemo$$anonfun$$nestedInanonfun$render$2$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__jl_Throwable__F1__O($as_jl_Throwable(x), default$1)
});
var $d_Lshowcase_app_expo_sqlite_SQLiteDemo$$anonfun$$nestedInanonfun$render$2$1 = new $TypeData().initClass({
  Lshowcase_app_expo_sqlite_SQLiteDemo$$anonfun$$nestedInanonfun$render$2$1: 0
}, false, "showcase.app.expo.sqlite.SQLiteDemo$$anonfun$$nestedInanonfun$render$2$1", {
  Lshowcase_app_expo_sqlite_SQLiteDemo$$anonfun$$nestedInanonfun$render$2$1: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lshowcase_app_expo_sqlite_SQLiteDemo$$anonfun$$nestedInanonfun$render$2$1.prototype.$classData = $d_Lshowcase_app_expo_sqlite_SQLiteDemo$$anonfun$$nestedInanonfun$render$2$1;
/** @constructor */
function $c_Lshowcase_app_task_DemoTaskActions$$anonfun$1(outer, dispatch$1) {
  this.Lshowcase_app_task_DemoTaskActions$$anonfun$1__f_dispatch$1 = null;
  this.Lshowcase_app_task_DemoTaskActions$$anonfun$1__f_dispatch$1 = dispatch$1
}
$c_Lshowcase_app_task_DemoTaskActions$$anonfun$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lshowcase_app_task_DemoTaskActions$$anonfun$1.prototype.constructor = $c_Lshowcase_app_task_DemoTaskActions$$anonfun$1;
/** @constructor */
function $h_Lshowcase_app_task_DemoTaskActions$$anonfun$1() {
  /*<skip>*/
}
$h_Lshowcase_app_task_DemoTaskActions$$anonfun$1.prototype = $c_Lshowcase_app_task_DemoTaskActions$$anonfun$1.prototype;
$c_Lshowcase_app_task_DemoTaskActions$$anonfun$1.prototype.applyOrElse__s_util_Try__F1__O = (function(x1, default$1) {
  if ((x1 instanceof $c_s_util_Success)) {
    var x2 = $as_s_util_Success(x1);
    var data = $as_T(x2.s_util_Success__f_value);
    return this.Lshowcase_app_task_DemoTaskActions$$anonfun$1__f_dispatch$1.apply__O__O(new $c_Lshowcase_app_task_DemoTaskActions$SuccessfulFetchedAction(data))
  } else {
    return default$1.apply__O__O(x1)
  }
});
$c_Lshowcase_app_task_DemoTaskActions$$anonfun$1.prototype.isDefinedAt__s_util_Try__Z = (function(x1) {
  return (x1 instanceof $c_s_util_Success)
});
$c_Lshowcase_app_task_DemoTaskActions$$anonfun$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__s_util_Try__Z($as_s_util_Try(x))
});
$c_Lshowcase_app_task_DemoTaskActions$$anonfun$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__s_util_Try__F1__O($as_s_util_Try(x), default$1)
});
var $d_Lshowcase_app_task_DemoTaskActions$$anonfun$1 = new $TypeData().initClass({
  Lshowcase_app_task_DemoTaskActions$$anonfun$1: 0
}, false, "showcase.app.task.DemoTaskActions$$anonfun$1", {
  Lshowcase_app_task_DemoTaskActions$$anonfun$1: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lshowcase_app_task_DemoTaskActions$$anonfun$1.prototype.$classData = $d_Lshowcase_app_task_DemoTaskActions$$anonfun$1;
/** @constructor */
function $c_Lshowcase_app_task_DemoTaskActions$SuccessfulFetchedAction(data) {
  this.Lshowcase_app_task_DemoTaskActions$SuccessfulFetchedAction__f_data = null;
  this.Lshowcase_app_task_DemoTaskActions$SuccessfulFetchedAction__f_data = data
}
$c_Lshowcase_app_task_DemoTaskActions$SuccessfulFetchedAction.prototype = new $h_O();
$c_Lshowcase_app_task_DemoTaskActions$SuccessfulFetchedAction.prototype.constructor = $c_Lshowcase_app_task_DemoTaskActions$SuccessfulFetchedAction;
/** @constructor */
function $h_Lshowcase_app_task_DemoTaskActions$SuccessfulFetchedAction() {
  /*<skip>*/
}
$h_Lshowcase_app_task_DemoTaskActions$SuccessfulFetchedAction.prototype = $c_Lshowcase_app_task_DemoTaskActions$SuccessfulFetchedAction.prototype;
$c_Lshowcase_app_task_DemoTaskActions$SuccessfulFetchedAction.prototype.productPrefix__T = (function() {
  return "SuccessfulFetchedAction"
});
$c_Lshowcase_app_task_DemoTaskActions$SuccessfulFetchedAction.prototype.productArity__I = (function() {
  return 1
});
$c_Lshowcase_app_task_DemoTaskActions$SuccessfulFetchedAction.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lshowcase_app_task_DemoTaskActions$SuccessfulFetchedAction__f_data : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lshowcase_app_task_DemoTaskActions$SuccessfulFetchedAction.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lshowcase_app_task_DemoTaskActions$SuccessfulFetchedAction.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lshowcase_app_task_DemoTaskActions$SuccessfulFetchedAction.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lshowcase_app_task_DemoTaskActions$SuccessfulFetchedAction.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lshowcase_app_task_DemoTaskActions$SuccessfulFetchedAction)) {
    var SuccessfulFetchedAction$1 = $as_Lshowcase_app_task_DemoTaskActions$SuccessfulFetchedAction(x$1);
    return (this.Lshowcase_app_task_DemoTaskActions$SuccessfulFetchedAction__f_data === SuccessfulFetchedAction$1.Lshowcase_app_task_DemoTaskActions$SuccessfulFetchedAction__f_data)
  } else {
    return false
  }
});
function $as_Lshowcase_app_task_DemoTaskActions$SuccessfulFetchedAction(obj) {
  return (((obj instanceof $c_Lshowcase_app_task_DemoTaskActions$SuccessfulFetchedAction) || (obj === null)) ? obj : $throwClassCastException(obj, "showcase.app.task.DemoTaskActions$SuccessfulFetchedAction"))
}
function $isArrayOf_Lshowcase_app_task_DemoTaskActions$SuccessfulFetchedAction(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lshowcase_app_task_DemoTaskActions$SuccessfulFetchedAction)))
}
function $asArrayOf_Lshowcase_app_task_DemoTaskActions$SuccessfulFetchedAction(obj, depth) {
  return (($isArrayOf_Lshowcase_app_task_DemoTaskActions$SuccessfulFetchedAction(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lshowcase.app.task.DemoTaskActions$SuccessfulFetchedAction;", depth))
}
var $d_Lshowcase_app_task_DemoTaskActions$SuccessfulFetchedAction = new $TypeData().initClass({
  Lshowcase_app_task_DemoTaskActions$SuccessfulFetchedAction: 0
}, false, "showcase.app.task.DemoTaskActions$SuccessfulFetchedAction", {
  Lshowcase_app_task_DemoTaskActions$SuccessfulFetchedAction: 1,
  O: 1,
  Lio_github_shogowada_scalajs_reactjs_redux_Action: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lshowcase_app_task_DemoTaskActions$SuccessfulFetchedAction.prototype.$classData = $d_Lshowcase_app_task_DemoTaskActions$SuccessfulFetchedAction;
/** @constructor */
function $c_Lshowcase_app_task_DemoTaskScreen$$anonfun$showcase$app$task$DemoTaskScreen$$$nestedInanonfun$render$1$1() {
  /*<skip>*/
}
$c_Lshowcase_app_task_DemoTaskScreen$$anonfun$showcase$app$task$DemoTaskScreen$$$nestedInanonfun$render$1$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lshowcase_app_task_DemoTaskScreen$$anonfun$showcase$app$task$DemoTaskScreen$$$nestedInanonfun$render$1$1.prototype.constructor = $c_Lshowcase_app_task_DemoTaskScreen$$anonfun$showcase$app$task$DemoTaskScreen$$$nestedInanonfun$render$1$1;
/** @constructor */
function $h_Lshowcase_app_task_DemoTaskScreen$$anonfun$showcase$app$task$DemoTaskScreen$$$nestedInanonfun$render$1$1() {
  /*<skip>*/
}
$h_Lshowcase_app_task_DemoTaskScreen$$anonfun$showcase$app$task$DemoTaskScreen$$$nestedInanonfun$render$1$1.prototype = $c_Lshowcase_app_task_DemoTaskScreen$$anonfun$showcase$app$task$DemoTaskScreen$$$nestedInanonfun$render$1$1.prototype;
$c_Lshowcase_app_task_DemoTaskScreen$$anonfun$showcase$app$task$DemoTaskScreen$$$nestedInanonfun$render$1$1.prototype.applyOrElse__s_util_Try__F1__O = (function(x1, default$1) {
  if ((x1 instanceof $c_s_util_Success)) {
    var x2 = $as_s_util_Success(x1);
    var resp = $as_T(x2.s_util_Success__f_value);
    var $$x2 = $m_Lscommons_reactnative_Alert$();
    var $$x1 = $m_s_package$().s_package$__f_Nil;
    var this$2 = $m_Lscommons_reactnative_Alert$();
    $$x2.alert__T__T__sci_List__Lscommons_reactnative_raw_AlertOptions__V("Successful Request", resp, $$x1, $p_Lscommons_reactnative_Alert$__defaultOptions__Lscommons_reactnative_raw_AlertOptions(this$2));
    return (void 0)
  } else {
    return default$1.apply__O__O(x1)
  }
});
$c_Lshowcase_app_task_DemoTaskScreen$$anonfun$showcase$app$task$DemoTaskScreen$$$nestedInanonfun$render$1$1.prototype.isDefinedAt__s_util_Try__Z = (function(x1) {
  return (x1 instanceof $c_s_util_Success)
});
$c_Lshowcase_app_task_DemoTaskScreen$$anonfun$showcase$app$task$DemoTaskScreen$$$nestedInanonfun$render$1$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__s_util_Try__Z($as_s_util_Try(x))
});
$c_Lshowcase_app_task_DemoTaskScreen$$anonfun$showcase$app$task$DemoTaskScreen$$$nestedInanonfun$render$1$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__s_util_Try__F1__O($as_s_util_Try(x), default$1)
});
var $d_Lshowcase_app_task_DemoTaskScreen$$anonfun$showcase$app$task$DemoTaskScreen$$$nestedInanonfun$render$1$1 = new $TypeData().initClass({
  Lshowcase_app_task_DemoTaskScreen$$anonfun$showcase$app$task$DemoTaskScreen$$$nestedInanonfun$render$1$1: 0
}, false, "showcase.app.task.DemoTaskScreen$$anonfun$showcase$app$task$DemoTaskScreen$$$nestedInanonfun$render$1$1", {
  Lshowcase_app_task_DemoTaskScreen$$anonfun$showcase$app$task$DemoTaskScreen$$$nestedInanonfun$render$1$1: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lshowcase_app_task_DemoTaskScreen$$anonfun$showcase$app$task$DemoTaskScreen$$$nestedInanonfun$render$1$1.prototype.$classData = $d_Lshowcase_app_task_DemoTaskScreen$$anonfun$showcase$app$task$DemoTaskScreen$$$nestedInanonfun$render$1$1;
function $ct_jl_ArrayIndexOutOfBoundsException__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz
}
function $ct_jl_ArrayIndexOutOfBoundsException__($thiz) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, null, null, true, true);
  return $thiz
}
/** @constructor */
function $c_jl_ArrayIndexOutOfBoundsException() {
  this.jl_Throwable__f_s = null;
  this.jl_Throwable__f_e = null;
  this.jl_Throwable__f_enableSuppression = false;
  this.jl_Throwable__f_writableStackTrace = false;
  this.jl_Throwable__f_stackTraceStateInternal = null;
  this.jl_Throwable__f_stackTrace = null;
  this.jl_Throwable__f_suppressed = null
}
$c_jl_ArrayIndexOutOfBoundsException.prototype = new $h_jl_IndexOutOfBoundsException();
$c_jl_ArrayIndexOutOfBoundsException.prototype.constructor = $c_jl_ArrayIndexOutOfBoundsException;
/** @constructor */
function $h_jl_ArrayIndexOutOfBoundsException() {
  /*<skip>*/
}
$h_jl_ArrayIndexOutOfBoundsException.prototype = $c_jl_ArrayIndexOutOfBoundsException.prototype;
function $as_jl_ArrayIndexOutOfBoundsException(obj) {
  return (((obj instanceof $c_jl_ArrayIndexOutOfBoundsException) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.ArrayIndexOutOfBoundsException"))
}
function $isArrayOf_jl_ArrayIndexOutOfBoundsException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_ArrayIndexOutOfBoundsException)))
}
function $asArrayOf_jl_ArrayIndexOutOfBoundsException(obj, depth) {
  return (($isArrayOf_jl_ArrayIndexOutOfBoundsException(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.ArrayIndexOutOfBoundsException;", depth))
}
var $d_jl_ArrayIndexOutOfBoundsException = new $TypeData().initClass({
  jl_ArrayIndexOutOfBoundsException: 0
}, false, "java.lang.ArrayIndexOutOfBoundsException", {
  jl_ArrayIndexOutOfBoundsException: 1,
  jl_IndexOutOfBoundsException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_ArrayIndexOutOfBoundsException.prototype.$classData = $d_jl_ArrayIndexOutOfBoundsException;
/** @constructor */
function $c_jl_NumberFormatException(s) {
  this.jl_Throwable__f_s = null;
  this.jl_Throwable__f_e = null;
  this.jl_Throwable__f_enableSuppression = false;
  this.jl_Throwable__f_writableStackTrace = false;
  this.jl_Throwable__f_stackTraceStateInternal = null;
  this.jl_Throwable__f_stackTrace = null;
  this.jl_Throwable__f_suppressed = null;
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, s, null, true, true)
}
$c_jl_NumberFormatException.prototype = new $h_jl_IllegalArgumentException();
$c_jl_NumberFormatException.prototype.constructor = $c_jl_NumberFormatException;
/** @constructor */
function $h_jl_NumberFormatException() {
  /*<skip>*/
}
$h_jl_NumberFormatException.prototype = $c_jl_NumberFormatException.prototype;
function $as_jl_NumberFormatException(obj) {
  return (((obj instanceof $c_jl_NumberFormatException) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.NumberFormatException"))
}
function $isArrayOf_jl_NumberFormatException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_NumberFormatException)))
}
function $asArrayOf_jl_NumberFormatException(obj, depth) {
  return (($isArrayOf_jl_NumberFormatException(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.NumberFormatException;", depth))
}
var $d_jl_NumberFormatException = new $TypeData().initClass({
  jl_NumberFormatException: 0
}, false, "java.lang.NumberFormatException", {
  jl_NumberFormatException: 1,
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_NumberFormatException.prototype.$classData = $d_jl_NumberFormatException;
function $ct_jl_StringIndexOutOfBoundsException__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz
}
function $ct_jl_StringIndexOutOfBoundsException__($thiz) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, null, null, true, true);
  return $thiz
}
/** @constructor */
function $c_jl_StringIndexOutOfBoundsException() {
  this.jl_Throwable__f_s = null;
  this.jl_Throwable__f_e = null;
  this.jl_Throwable__f_enableSuppression = false;
  this.jl_Throwable__f_writableStackTrace = false;
  this.jl_Throwable__f_stackTraceStateInternal = null;
  this.jl_Throwable__f_stackTrace = null;
  this.jl_Throwable__f_suppressed = null
}
$c_jl_StringIndexOutOfBoundsException.prototype = new $h_jl_IndexOutOfBoundsException();
$c_jl_StringIndexOutOfBoundsException.prototype.constructor = $c_jl_StringIndexOutOfBoundsException;
/** @constructor */
function $h_jl_StringIndexOutOfBoundsException() {
  /*<skip>*/
}
$h_jl_StringIndexOutOfBoundsException.prototype = $c_jl_StringIndexOutOfBoundsException.prototype;
var $d_jl_StringIndexOutOfBoundsException = new $TypeData().initClass({
  jl_StringIndexOutOfBoundsException: 0
}, false, "java.lang.StringIndexOutOfBoundsException", {
  jl_StringIndexOutOfBoundsException: 1,
  jl_IndexOutOfBoundsException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_StringIndexOutOfBoundsException.prototype.$classData = $d_jl_StringIndexOutOfBoundsException;
function $ct_Ljava_nio_CharBuffer__I__AC__I__($thiz, _capacity, _array, _arrayOffset) {
  $thiz.Ljava_nio_CharBuffer__f__array = _array;
  $thiz.Ljava_nio_CharBuffer__f__arrayOffset = _arrayOffset;
  $ct_Ljava_nio_Buffer__I__($thiz, _capacity);
  return $thiz
}
/** @constructor */
function $c_Ljava_nio_CharBuffer() {
  this.Ljava_nio_Buffer__f__capacity = 0;
  this.Ljava_nio_Buffer__f__limit = 0;
  this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position = 0;
  this.Ljava_nio_Buffer__f__mark = 0;
  this.Ljava_nio_CharBuffer__f__array = null;
  this.Ljava_nio_CharBuffer__f__arrayOffset = 0
}
$c_Ljava_nio_CharBuffer.prototype = new $h_Ljava_nio_Buffer();
$c_Ljava_nio_CharBuffer.prototype.constructor = $c_Ljava_nio_CharBuffer;
/** @constructor */
function $h_Ljava_nio_CharBuffer() {
  /*<skip>*/
}
$h_Ljava_nio_CharBuffer.prototype = $c_Ljava_nio_CharBuffer.prototype;
$c_Ljava_nio_CharBuffer.prototype.put__Ljava_nio_CharBuffer__Ljava_nio_CharBuffer = (function(src) {
  if ((src === this)) {
    throw $ct_jl_IllegalArgumentException__(new $c_jl_IllegalArgumentException())
  };
  throw new $c_Ljava_nio_ReadOnlyBufferException()
});
$c_Ljava_nio_CharBuffer.prototype.put__T__I__I__Ljava_nio_CharBuffer = (function(src, start, end) {
  return this.put__Ljava_nio_CharBuffer__Ljava_nio_CharBuffer($m_Ljava_nio_CharBuffer$().wrap__jl_CharSequence__I__I__Ljava_nio_CharBuffer(src, start, end))
});
$c_Ljava_nio_CharBuffer.prototype.hashCode__I = (function() {
  var start = this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position;
  var end = this.Ljava_nio_Buffer__f__limit;
  var h = (-182887236);
  var i = start;
  while ((i !== end)) {
    var $$x2 = $m_s_util_hashing_MurmurHash3$();
    var $$x1 = h;
    var index = i;
    var x = $dp_charAt__I__C(this.Ljava_nio_StringCharBuffer__f_java$nio$StringCharBuffer$$_csq, ((this.Ljava_nio_StringCharBuffer__f_java$nio$StringCharBuffer$$_csqOffset + index) | 0));
    h = $$x2.mix__I__I__I($$x1, $m_sr_Statics$().anyHash__O__I($bC(x)));
    i = ((1 + i) | 0)
  };
  return $m_s_util_hashing_MurmurHash3$().finalizeHash__I__I__I(h, ((end - start) | 0))
});
$c_Ljava_nio_CharBuffer.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_Ljava_nio_CharBuffer)) {
    var x2 = $as_Ljava_nio_CharBuffer(that);
    return (this.compareTo__Ljava_nio_CharBuffer__I(x2) === 0)
  } else {
    return false
  }
});
$c_Ljava_nio_CharBuffer.prototype.compareTo__Ljava_nio_CharBuffer__I = (function(that) {
  if ((this === that)) {
    return 0
  } else {
    var thisStart = this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position;
    var thisRemaining = ((this.Ljava_nio_Buffer__f__limit - thisStart) | 0);
    var thatStart = that.Ljava_nio_Buffer__f_java$nio$Buffer$$_position;
    var thatRemaining = ((that.Ljava_nio_Buffer__f__limit - thatStart) | 0);
    var shortestLength = ((thisRemaining < thatRemaining) ? thisRemaining : thatRemaining);
    var i = 0;
    while ((i !== shortestLength)) {
      var index = ((thisStart + i) | 0);
      var arg1 = $dp_charAt__I__C(this.Ljava_nio_StringCharBuffer__f_java$nio$StringCharBuffer$$_csq, ((this.Ljava_nio_StringCharBuffer__f_java$nio$StringCharBuffer$$_csqOffset + index) | 0));
      var index$1 = ((thatStart + i) | 0);
      var arg2 = $dp_charAt__I__C(that.Ljava_nio_StringCharBuffer__f_java$nio$StringCharBuffer$$_csq, ((that.Ljava_nio_StringCharBuffer__f_java$nio$StringCharBuffer$$_csqOffset + index$1) | 0));
      var cmp = ((arg1 - arg2) | 0);
      if ((cmp !== 0)) {
        return cmp
      };
      i = ((1 + i) | 0)
    };
    return ((thisRemaining === thatRemaining) ? 0 : ((thisRemaining < thatRemaining) ? (-1) : 1))
  }
});
$c_Ljava_nio_CharBuffer.prototype.length__I = (function() {
  return ((this.Ljava_nio_Buffer__f__limit - this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0)
});
$c_Ljava_nio_CharBuffer.prototype.charAt__I__C = (function(index) {
  return this.get__I__C(((this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position + index) | 0))
});
$c_Ljava_nio_CharBuffer.prototype.append__jl_CharSequence__jl_Appendable = (function(x$1) {
  var src = $dp_toString__T(x$1);
  return this.put__T__I__I__Ljava_nio_CharBuffer(src, 0, $uI(src.length))
});
function $as_Ljava_nio_CharBuffer(obj) {
  return (((obj instanceof $c_Ljava_nio_CharBuffer) || (obj === null)) ? obj : $throwClassCastException(obj, "java.nio.CharBuffer"))
}
function $isArrayOf_Ljava_nio_CharBuffer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_nio_CharBuffer)))
}
function $asArrayOf_Ljava_nio_CharBuffer(obj, depth) {
  return (($isArrayOf_Ljava_nio_CharBuffer(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.nio.CharBuffer;", depth))
}
/** @constructor */
function $c_Ljava_nio_ReadOnlyBufferException() {
  this.jl_Throwable__f_s = null;
  this.jl_Throwable__f_e = null;
  this.jl_Throwable__f_enableSuppression = false;
  this.jl_Throwable__f_writableStackTrace = false;
  this.jl_Throwable__f_stackTraceStateInternal = null;
  this.jl_Throwable__f_stackTrace = null;
  this.jl_Throwable__f_suppressed = null;
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true)
}
$c_Ljava_nio_ReadOnlyBufferException.prototype = new $h_jl_UnsupportedOperationException();
$c_Ljava_nio_ReadOnlyBufferException.prototype.constructor = $c_Ljava_nio_ReadOnlyBufferException;
/** @constructor */
function $h_Ljava_nio_ReadOnlyBufferException() {
  /*<skip>*/
}
$h_Ljava_nio_ReadOnlyBufferException.prototype = $c_Ljava_nio_ReadOnlyBufferException.prototype;
var $d_Ljava_nio_ReadOnlyBufferException = new $TypeData().initClass({
  Ljava_nio_ReadOnlyBufferException: 0
}, false, "java.nio.ReadOnlyBufferException", {
  Ljava_nio_ReadOnlyBufferException: 1,
  jl_UnsupportedOperationException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_nio_ReadOnlyBufferException.prototype.$classData = $d_Ljava_nio_ReadOnlyBufferException;
/** @constructor */
function $c_Ljava_nio_charset_MalformedInputException(inputLength) {
  this.jl_Throwable__f_s = null;
  this.jl_Throwable__f_e = null;
  this.jl_Throwable__f_enableSuppression = false;
  this.jl_Throwable__f_writableStackTrace = false;
  this.jl_Throwable__f_stackTraceStateInternal = null;
  this.jl_Throwable__f_stackTrace = null;
  this.jl_Throwable__f_suppressed = null;
  this.Ljava_nio_charset_MalformedInputException__f_inputLength = 0;
  this.Ljava_nio_charset_MalformedInputException__f_inputLength = inputLength;
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true)
}
$c_Ljava_nio_charset_MalformedInputException.prototype = new $h_Ljava_nio_charset_CharacterCodingException();
$c_Ljava_nio_charset_MalformedInputException.prototype.constructor = $c_Ljava_nio_charset_MalformedInputException;
/** @constructor */
function $h_Ljava_nio_charset_MalformedInputException() {
  /*<skip>*/
}
$h_Ljava_nio_charset_MalformedInputException.prototype = $c_Ljava_nio_charset_MalformedInputException.prototype;
$c_Ljava_nio_charset_MalformedInputException.prototype.getMessage__T = (function() {
  return ("Input length = " + this.Ljava_nio_charset_MalformedInputException__f_inputLength)
});
var $d_Ljava_nio_charset_MalformedInputException = new $TypeData().initClass({
  Ljava_nio_charset_MalformedInputException: 0
}, false, "java.nio.charset.MalformedInputException", {
  Ljava_nio_charset_MalformedInputException: 1,
  Ljava_nio_charset_CharacterCodingException: 1,
  Ljava_io_IOException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_nio_charset_MalformedInputException.prototype.$classData = $d_Ljava_nio_charset_MalformedInputException;
/** @constructor */
function $c_Ljava_nio_charset_UnmappableCharacterException(inputLength) {
  this.jl_Throwable__f_s = null;
  this.jl_Throwable__f_e = null;
  this.jl_Throwable__f_enableSuppression = false;
  this.jl_Throwable__f_writableStackTrace = false;
  this.jl_Throwable__f_stackTraceStateInternal = null;
  this.jl_Throwable__f_stackTrace = null;
  this.jl_Throwable__f_suppressed = null;
  this.Ljava_nio_charset_UnmappableCharacterException__f_inputLength = 0;
  this.Ljava_nio_charset_UnmappableCharacterException__f_inputLength = inputLength;
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true)
}
$c_Ljava_nio_charset_UnmappableCharacterException.prototype = new $h_Ljava_nio_charset_CharacterCodingException();
$c_Ljava_nio_charset_UnmappableCharacterException.prototype.constructor = $c_Ljava_nio_charset_UnmappableCharacterException;
/** @constructor */
function $h_Ljava_nio_charset_UnmappableCharacterException() {
  /*<skip>*/
}
$h_Ljava_nio_charset_UnmappableCharacterException.prototype = $c_Ljava_nio_charset_UnmappableCharacterException.prototype;
$c_Ljava_nio_charset_UnmappableCharacterException.prototype.getMessage__T = (function() {
  return ("Input length = " + this.Ljava_nio_charset_UnmappableCharacterException__f_inputLength)
});
var $d_Ljava_nio_charset_UnmappableCharacterException = new $TypeData().initClass({
  Ljava_nio_charset_UnmappableCharacterException: 0
}, false, "java.nio.charset.UnmappableCharacterException", {
  Ljava_nio_charset_UnmappableCharacterException: 1,
  Ljava_nio_charset_CharacterCodingException: 1,
  Ljava_io_IOException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_nio_charset_UnmappableCharacterException.prototype.$classData = $d_Ljava_nio_charset_UnmappableCharacterException;
/** @constructor */
function $c_ju_FormatterClosedException() {
  this.jl_Throwable__f_s = null;
  this.jl_Throwable__f_e = null;
  this.jl_Throwable__f_enableSuppression = false;
  this.jl_Throwable__f_writableStackTrace = false;
  this.jl_Throwable__f_stackTraceStateInternal = null;
  this.jl_Throwable__f_stackTrace = null;
  this.jl_Throwable__f_suppressed = null;
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true)
}
$c_ju_FormatterClosedException.prototype = new $h_jl_IllegalStateException();
$c_ju_FormatterClosedException.prototype.constructor = $c_ju_FormatterClosedException;
/** @constructor */
function $h_ju_FormatterClosedException() {
  /*<skip>*/
}
$h_ju_FormatterClosedException.prototype = $c_ju_FormatterClosedException.prototype;
var $d_ju_FormatterClosedException = new $TypeData().initClass({
  ju_FormatterClosedException: 0
}, false, "java.util.FormatterClosedException", {
  ju_FormatterClosedException: 1,
  jl_IllegalStateException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_ju_FormatterClosedException.prototype.$classData = $d_ju_FormatterClosedException;
/** @constructor */
function $c_ju_HashMap$EntrySet(outer) {
  this.ju_HashMap$EntrySet__f_$outer = null;
  if ((outer === null)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(null)
  } else {
    this.ju_HashMap$EntrySet__f_$outer = outer
  }
}
$c_ju_HashMap$EntrySet.prototype = new $h_ju_AbstractSet();
$c_ju_HashMap$EntrySet.prototype.constructor = $c_ju_HashMap$EntrySet;
/** @constructor */
function $h_ju_HashMap$EntrySet() {
  /*<skip>*/
}
$h_ju_HashMap$EntrySet.prototype = $c_ju_HashMap$EntrySet.prototype;
$c_ju_HashMap$EntrySet.prototype.iterator__ju_Iterator = (function() {
  var this$1 = this.ju_HashMap$EntrySet__f_$outer;
  return new $c_ju_LinkedHashMap$NodeIterator(this$1)
});
$c_ju_HashMap$EntrySet.prototype.size__I = (function() {
  return this.ju_HashMap$EntrySet__f_$outer.ju_HashMap__f_contentSize
});
$c_ju_HashMap$EntrySet.prototype.contains__O__Z = (function(o) {
  if ($is_ju_Map$Entry(o)) {
    var x2 = $as_ju_Map$Entry(o);
    var this$1 = this.ju_HashMap$EntrySet__f_$outer;
    var key = x2.ju_HashMap$Node__f_key;
    if ((key === null)) {
      var hash = 0
    } else {
      var originalHash = $dp_hashCode__I(key);
      var hash = (originalHash ^ ((originalHash >>> 16) | 0))
    };
    var node = this$1.java$util$HashMap$$findNode0__O__I__I__ju_HashMap$Node(key, hash, (hash & (((-1) + this$1.ju_HashMap__f_java$util$HashMap$$table.u.length) | 0)));
    if ((node !== null)) {
      var a = node.ju_HashMap$Node__f_value;
      var b = x2.ju_HashMap$Node__f_value;
      return ((a === null) ? (b === null) : $dp_equals__O__Z(a, b))
    } else {
      return false
    }
  } else {
    return false
  }
});
var $d_ju_HashMap$EntrySet = new $TypeData().initClass({
  ju_HashMap$EntrySet: 0
}, false, "java.util.HashMap$EntrySet", {
  ju_HashMap$EntrySet: 1,
  ju_AbstractSet: 1,
  ju_AbstractCollection: 1,
  O: 1,
  ju_Collection: 1,
  jl_Iterable: 1,
  ju_Set: 1
});
$c_ju_HashMap$EntrySet.prototype.$classData = $d_ju_HashMap$EntrySet;
/** @constructor */
function $c_ju_IllegalFormatException() {
  this.jl_Throwable__f_s = null;
  this.jl_Throwable__f_e = null;
  this.jl_Throwable__f_enableSuppression = false;
  this.jl_Throwable__f_writableStackTrace = false;
  this.jl_Throwable__f_stackTraceStateInternal = null;
  this.jl_Throwable__f_stackTrace = null;
  this.jl_Throwable__f_suppressed = null
}
$c_ju_IllegalFormatException.prototype = new $h_jl_IllegalArgumentException();
$c_ju_IllegalFormatException.prototype.constructor = $c_ju_IllegalFormatException;
/** @constructor */
function $h_ju_IllegalFormatException() {
  /*<skip>*/
}
$h_ju_IllegalFormatException.prototype = $c_ju_IllegalFormatException.prototype;
function $p_ju_LinkedHashMap__appendToOrderedList__ju_LinkedHashMap$Node__V($thiz, node) {
  var older = $thiz.ju_LinkedHashMap__f_youngest;
  if ((older !== null)) {
    older.ju_LinkedHashMap$Node__f_younger = node
  } else {
    $thiz.ju_LinkedHashMap__f_java$util$LinkedHashMap$$eldest = node
  };
  node.ju_LinkedHashMap$Node__f_older = older;
  node.ju_LinkedHashMap$Node__f_younger = null;
  $thiz.ju_LinkedHashMap__f_youngest = node
}
function $p_ju_LinkedHashMap__removeFromOrderedList__ju_LinkedHashMap$Node__V($thiz, node) {
  var older = node.ju_LinkedHashMap$Node__f_older;
  var younger = node.ju_LinkedHashMap$Node__f_younger;
  if ((older === null)) {
    $thiz.ju_LinkedHashMap__f_java$util$LinkedHashMap$$eldest = younger
  } else {
    older.ju_LinkedHashMap$Node__f_younger = younger
  };
  if ((younger === null)) {
    $thiz.ju_LinkedHashMap__f_youngest = older
  } else {
    younger.ju_LinkedHashMap$Node__f_older = older
  }
}
function $ct_ju_LinkedHashMap__I__F__Z__($thiz, initialCapacity, loadFactor, accessOrder) {
  $thiz.ju_LinkedHashMap__f_loadFactor = loadFactor;
  $thiz.ju_LinkedHashMap__f_accessOrder = accessOrder;
  $ct_ju_HashMap__I__F__($thiz, initialCapacity, loadFactor);
  return $thiz
}
function $ct_ju_LinkedHashMap__($thiz) {
  $ct_ju_LinkedHashMap__I__F__Z__($thiz, 16, 0.75, false);
  return $thiz
}
/** @constructor */
function $c_ju_LinkedHashMap() {
  this.ju_HashMap__f_java$util$HashMap$$loadFactor = 0.0;
  this.ju_HashMap__f_java$util$HashMap$$table = null;
  this.ju_HashMap__f_threshold = 0;
  this.ju_HashMap__f_contentSize = 0;
  this.ju_LinkedHashMap__f_loadFactor = 0.0;
  this.ju_LinkedHashMap__f_accessOrder = false;
  this.ju_LinkedHashMap__f_java$util$LinkedHashMap$$eldest = null;
  this.ju_LinkedHashMap__f_youngest = null
}
$c_ju_LinkedHashMap.prototype = new $h_ju_HashMap();
$c_ju_LinkedHashMap.prototype.constructor = $c_ju_LinkedHashMap;
/** @constructor */
function $h_ju_LinkedHashMap() {
  /*<skip>*/
}
$h_ju_LinkedHashMap.prototype = $c_ju_LinkedHashMap.prototype;
$c_ju_LinkedHashMap.prototype.nodeWasAccessed__ju_HashMap$Node__V = (function(node) {
  if (this.ju_LinkedHashMap__f_accessOrder) {
    var myNode = $as_ju_LinkedHashMap$Node(node);
    if ((myNode.ju_LinkedHashMap$Node__f_younger !== null)) {
      $p_ju_LinkedHashMap__removeFromOrderedList__ju_LinkedHashMap$Node__V(this, myNode);
      $p_ju_LinkedHashMap__appendToOrderedList__ju_LinkedHashMap$Node__V(this, myNode)
    }
  }
});
$c_ju_LinkedHashMap.prototype.nodeWasAdded__ju_HashMap$Node__V = (function(node) {
  $p_ju_LinkedHashMap__appendToOrderedList__ju_LinkedHashMap$Node__V(this, $as_ju_LinkedHashMap$Node(node))
});
var $d_ju_LinkedHashMap = new $TypeData().initClass({
  ju_LinkedHashMap: 0
}, false, "java.util.LinkedHashMap", {
  ju_LinkedHashMap: 1,
  ju_HashMap: 1,
  ju_AbstractMap: 1,
  O: 1,
  ju_Map: 1,
  Ljava_io_Serializable: 1,
  jl_Cloneable: 1
});
$c_ju_LinkedHashMap.prototype.$classData = $d_ju_LinkedHashMap;
/** @constructor */
function $c_Lplay_api_libs_json_JsArray(value) {
  this.Lplay_api_libs_json_JsArray__f_value = null;
  this.Lplay_api_libs_json_JsArray__f_value = value
}
$c_Lplay_api_libs_json_JsArray.prototype = new $h_O();
$c_Lplay_api_libs_json_JsArray.prototype.constructor = $c_Lplay_api_libs_json_JsArray;
/** @constructor */
function $h_Lplay_api_libs_json_JsArray() {
  /*<skip>*/
}
$h_Lplay_api_libs_json_JsArray.prototype = $c_Lplay_api_libs_json_JsArray.prototype;
$c_Lplay_api_libs_json_JsArray.prototype.toString__T = (function() {
  return $m_Lplay_api_libs_json_StaticBinding$().generateFromJsValue__Lplay_api_libs_json_JsValue__Z__T(this, false)
});
$c_Lplay_api_libs_json_JsArray.prototype.productPrefix__T = (function() {
  return "JsArray"
});
$c_Lplay_api_libs_json_JsArray.prototype.productArity__I = (function() {
  return 1
});
$c_Lplay_api_libs_json_JsArray.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lplay_api_libs_json_JsArray__f_value : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lplay_api_libs_json_JsArray.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lplay_api_libs_json_JsArray.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lplay_api_libs_json_JsArray.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lplay_api_libs_json_JsArray)) {
    var JsArray$1 = $as_Lplay_api_libs_json_JsArray(x$1);
    var x = this.Lplay_api_libs_json_JsArray__f_value;
    var x$2 = JsArray$1.Lplay_api_libs_json_JsArray__f_value;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lplay_api_libs_json_JsArray(obj) {
  return (((obj instanceof $c_Lplay_api_libs_json_JsArray) || (obj === null)) ? obj : $throwClassCastException(obj, "play.api.libs.json.JsArray"))
}
function $isArrayOf_Lplay_api_libs_json_JsArray(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lplay_api_libs_json_JsArray)))
}
function $asArrayOf_Lplay_api_libs_json_JsArray(obj, depth) {
  return (($isArrayOf_Lplay_api_libs_json_JsArray(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lplay.api.libs.json.JsArray;", depth))
}
var $d_Lplay_api_libs_json_JsArray = new $TypeData().initClass({
  Lplay_api_libs_json_JsArray: 0
}, false, "play.api.libs.json.JsArray", {
  Lplay_api_libs_json_JsArray: 1,
  O: 1,
  Lplay_api_libs_json_JsValue: 1,
  Lplay_api_libs_json_JsReadable: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lplay_api_libs_json_JsArray.prototype.$classData = $d_Lplay_api_libs_json_JsArray;
function $ct_Lplay_api_libs_json_JsBoolean__Z__($thiz, value) {
  $thiz.Lplay_api_libs_json_JsBoolean__f_value = value;
  $thiz.Lplay_api_libs_json_JsBoolean__f_productArity = 1;
  return $thiz
}
/** @constructor */
function $c_Lplay_api_libs_json_JsBoolean() {
  this.Lplay_api_libs_json_JsBoolean__f_value = false;
  this.Lplay_api_libs_json_JsBoolean__f_productArity = 0
}
$c_Lplay_api_libs_json_JsBoolean.prototype = new $h_O();
$c_Lplay_api_libs_json_JsBoolean.prototype.constructor = $c_Lplay_api_libs_json_JsBoolean;
/** @constructor */
function $h_Lplay_api_libs_json_JsBoolean() {
  /*<skip>*/
}
$h_Lplay_api_libs_json_JsBoolean.prototype = $c_Lplay_api_libs_json_JsBoolean.prototype;
$c_Lplay_api_libs_json_JsBoolean.prototype.toString__T = (function() {
  return $m_Lplay_api_libs_json_StaticBinding$().generateFromJsValue__Lplay_api_libs_json_JsValue__Z__T(this, false)
});
$c_Lplay_api_libs_json_JsBoolean.prototype.productArity__I = (function() {
  return this.Lplay_api_libs_json_JsBoolean__f_productArity
});
$c_Lplay_api_libs_json_JsBoolean.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lplay_api_libs_json_JsBoolean__f_value
  } else {
    throw new $c_s_MatchError(n)
  }
});
$c_Lplay_api_libs_json_JsBoolean.prototype.equals__O__Z = (function(that) {
  return ((that instanceof $c_Lplay_api_libs_json_JsBoolean) && (this.Lplay_api_libs_json_JsBoolean__f_value === $as_Lplay_api_libs_json_JsBoolean(that).Lplay_api_libs_json_JsBoolean__f_value))
});
$c_Lplay_api_libs_json_JsBoolean.prototype.hashCode__I = (function() {
  var this$1 = this.Lplay_api_libs_json_JsBoolean__f_value;
  return (this$1 ? 1231 : 1237)
});
function $as_Lplay_api_libs_json_JsBoolean(obj) {
  return (((obj instanceof $c_Lplay_api_libs_json_JsBoolean) || (obj === null)) ? obj : $throwClassCastException(obj, "play.api.libs.json.JsBoolean"))
}
function $isArrayOf_Lplay_api_libs_json_JsBoolean(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lplay_api_libs_json_JsBoolean)))
}
function $asArrayOf_Lplay_api_libs_json_JsBoolean(obj, depth) {
  return (($isArrayOf_Lplay_api_libs_json_JsBoolean(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lplay.api.libs.json.JsBoolean;", depth))
}
/** @constructor */
function $c_Lplay_api_libs_json_JsDefined(value) {
  this.Lplay_api_libs_json_JsDefined__f_value = null;
  this.Lplay_api_libs_json_JsDefined__f_value = value
}
$c_Lplay_api_libs_json_JsDefined.prototype = new $h_O();
$c_Lplay_api_libs_json_JsDefined.prototype.constructor = $c_Lplay_api_libs_json_JsDefined;
/** @constructor */
function $h_Lplay_api_libs_json_JsDefined() {
  /*<skip>*/
}
$h_Lplay_api_libs_json_JsDefined.prototype = $c_Lplay_api_libs_json_JsDefined.prototype;
$c_Lplay_api_libs_json_JsDefined.prototype.productPrefix__T = (function() {
  return "JsDefined"
});
$c_Lplay_api_libs_json_JsDefined.prototype.productArity__I = (function() {
  return 1
});
$c_Lplay_api_libs_json_JsDefined.prototype.productElement__I__O = (function(x$1) {
  return $m_Lplay_api_libs_json_JsDefined$().productElement$extension__Lplay_api_libs_json_JsValue__I__O(this.Lplay_api_libs_json_JsDefined__f_value, x$1)
});
$c_Lplay_api_libs_json_JsDefined.prototype.productIterator__sc_Iterator = (function() {
  return $m_Lplay_api_libs_json_JsDefined$().productIterator$extension__Lplay_api_libs_json_JsValue__sc_Iterator(this.Lplay_api_libs_json_JsDefined__f_value)
});
$c_Lplay_api_libs_json_JsDefined.prototype.hashCode__I = (function() {
  var this$ = this.Lplay_api_libs_json_JsDefined__f_value;
  return this$.hashCode__I()
});
$c_Lplay_api_libs_json_JsDefined.prototype.equals__O__Z = (function(x$1) {
  return $m_Lplay_api_libs_json_JsDefined$().equals$extension__Lplay_api_libs_json_JsValue__O__Z(this.Lplay_api_libs_json_JsDefined__f_value, x$1)
});
$c_Lplay_api_libs_json_JsDefined.prototype.toString__T = (function() {
  return $m_Lplay_api_libs_json_JsDefined$().toString$extension__Lplay_api_libs_json_JsValue__T(this.Lplay_api_libs_json_JsDefined__f_value)
});
function $as_Lplay_api_libs_json_JsDefined(obj) {
  return (((obj instanceof $c_Lplay_api_libs_json_JsDefined) || (obj === null)) ? obj : $throwClassCastException(obj, "play.api.libs.json.JsDefined"))
}
function $isArrayOf_Lplay_api_libs_json_JsDefined(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lplay_api_libs_json_JsDefined)))
}
function $asArrayOf_Lplay_api_libs_json_JsDefined(obj, depth) {
  return (($isArrayOf_Lplay_api_libs_json_JsDefined(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lplay.api.libs.json.JsDefined;", depth))
}
var $d_Lplay_api_libs_json_JsDefined = new $TypeData().initClass({
  Lplay_api_libs_json_JsDefined: 0
}, false, "play.api.libs.json.JsDefined", {
  Lplay_api_libs_json_JsDefined: 1,
  O: 1,
  Lplay_api_libs_json_JsLookupResult: 1,
  Lplay_api_libs_json_JsReadable: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lplay_api_libs_json_JsDefined.prototype.$classData = $d_Lplay_api_libs_json_JsDefined;
/** @constructor */
function $c_Lplay_api_libs_json_JsNull$() {
  this.Lplay_api_libs_json_JsNull$__f_reads = null;
  $n_Lplay_api_libs_json_JsNull$ = this;
  $m_Lplay_api_libs_json_Reads$();
  var f = new $c_sjsr_AnonFunction1((function(this$1) {
    return (function(x0$1$2) {
      var x0$1 = $as_Lplay_api_libs_json_JsValue(x0$1$2);
      var x = $m_Lplay_api_libs_json_JsNull$();
      if ((x === x0$1)) {
        return new $c_Lplay_api_libs_json_JsSuccess($m_Lplay_api_libs_json_JsNull$(), $ct_Lplay_api_libs_json_JsPath__sci_List__(new $c_Lplay_api_libs_json_JsPath(), ($m_Lplay_api_libs_json_JsPath$(), $m_sci_Nil$())))
      } else {
        return $m_Lplay_api_libs_json_JsError$().apply__T__Lplay_api_libs_json_JsError("error.expected.null")
      }
    })
  })(this));
  this.Lplay_api_libs_json_JsNull$__f_reads = new $c_Lplay_api_libs_json_Reads$$anon$6(f)
}
$c_Lplay_api_libs_json_JsNull$.prototype = new $h_O();
$c_Lplay_api_libs_json_JsNull$.prototype.constructor = $c_Lplay_api_libs_json_JsNull$;
/** @constructor */
function $h_Lplay_api_libs_json_JsNull$() {
  /*<skip>*/
}
$h_Lplay_api_libs_json_JsNull$.prototype = $c_Lplay_api_libs_json_JsNull$.prototype;
$c_Lplay_api_libs_json_JsNull$.prototype.toString__T = (function() {
  return $m_Lplay_api_libs_json_StaticBinding$().generateFromJsValue__Lplay_api_libs_json_JsValue__Z__T(this, false)
});
$c_Lplay_api_libs_json_JsNull$.prototype.productPrefix__T = (function() {
  return "JsNull"
});
$c_Lplay_api_libs_json_JsNull$.prototype.productArity__I = (function() {
  return 0
});
$c_Lplay_api_libs_json_JsNull$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_Lplay_api_libs_json_JsNull$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lplay_api_libs_json_JsNull$.prototype.hashCode__I = (function() {
  return (-2067765616)
});
var $d_Lplay_api_libs_json_JsNull$ = new $TypeData().initClass({
  Lplay_api_libs_json_JsNull$: 0
}, false, "play.api.libs.json.JsNull$", {
  Lplay_api_libs_json_JsNull$: 1,
  O: 1,
  Lplay_api_libs_json_JsValue: 1,
  Lplay_api_libs_json_JsReadable: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lplay_api_libs_json_JsNull$.prototype.$classData = $d_Lplay_api_libs_json_JsNull$;
var $n_Lplay_api_libs_json_JsNull$;
function $m_Lplay_api_libs_json_JsNull$() {
  if ((!$n_Lplay_api_libs_json_JsNull$)) {
    $n_Lplay_api_libs_json_JsNull$ = new $c_Lplay_api_libs_json_JsNull$()
  };
  return $n_Lplay_api_libs_json_JsNull$
}
/** @constructor */
function $c_Lplay_api_libs_json_JsNumber(value) {
  this.Lplay_api_libs_json_JsNumber__f_value = null;
  this.Lplay_api_libs_json_JsNumber__f_value = value
}
$c_Lplay_api_libs_json_JsNumber.prototype = new $h_O();
$c_Lplay_api_libs_json_JsNumber.prototype.constructor = $c_Lplay_api_libs_json_JsNumber;
/** @constructor */
function $h_Lplay_api_libs_json_JsNumber() {
  /*<skip>*/
}
$h_Lplay_api_libs_json_JsNumber.prototype = $c_Lplay_api_libs_json_JsNumber.prototype;
$c_Lplay_api_libs_json_JsNumber.prototype.toString__T = (function() {
  return $m_Lplay_api_libs_json_StaticBinding$().generateFromJsValue__Lplay_api_libs_json_JsValue__Z__T(this, false)
});
$c_Lplay_api_libs_json_JsNumber.prototype.productPrefix__T = (function() {
  return "JsNumber"
});
$c_Lplay_api_libs_json_JsNumber.prototype.productArity__I = (function() {
  return 1
});
$c_Lplay_api_libs_json_JsNumber.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lplay_api_libs_json_JsNumber__f_value : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lplay_api_libs_json_JsNumber.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lplay_api_libs_json_JsNumber.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lplay_api_libs_json_JsNumber.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lplay_api_libs_json_JsNumber)) {
    var JsNumber$1 = $as_Lplay_api_libs_json_JsNumber(x$1);
    var x = this.Lplay_api_libs_json_JsNumber__f_value;
    var x$2 = JsNumber$1.Lplay_api_libs_json_JsNumber__f_value;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lplay_api_libs_json_JsNumber(obj) {
  return (((obj instanceof $c_Lplay_api_libs_json_JsNumber) || (obj === null)) ? obj : $throwClassCastException(obj, "play.api.libs.json.JsNumber"))
}
function $isArrayOf_Lplay_api_libs_json_JsNumber(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lplay_api_libs_json_JsNumber)))
}
function $asArrayOf_Lplay_api_libs_json_JsNumber(obj, depth) {
  return (($isArrayOf_Lplay_api_libs_json_JsNumber(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lplay.api.libs.json.JsNumber;", depth))
}
var $d_Lplay_api_libs_json_JsNumber = new $TypeData().initClass({
  Lplay_api_libs_json_JsNumber: 0
}, false, "play.api.libs.json.JsNumber", {
  Lplay_api_libs_json_JsNumber: 1,
  O: 1,
  Lplay_api_libs_json_JsValue: 1,
  Lplay_api_libs_json_JsReadable: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lplay_api_libs_json_JsNumber.prototype.$classData = $d_Lplay_api_libs_json_JsNumber;
function $p_Lplay_api_libs_json_JsObject__fields$lzycompute__sc_Seq($thiz) {
  if (((((1 & $thiz.Lplay_api_libs_json_JsObject__f_bitmap$0) << 24) >> 24) === 0)) {
    var this$1 = $thiz.Lplay_api_libs_json_JsObject__f_underlying;
    $thiz.Lplay_api_libs_json_JsObject__f_fields = $m_sci_Seq$().from__sc_IterableOnce__sci_Seq(this$1);
    $thiz.Lplay_api_libs_json_JsObject__f_bitmap$0 = (((1 | $thiz.Lplay_api_libs_json_JsObject__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.Lplay_api_libs_json_JsObject__f_fields
}
function $p_Lplay_api_libs_json_JsObject__merge$1__Lplay_api_libs_json_JsObject__Lplay_api_libs_json_JsObject__Lplay_api_libs_json_JsObject($thiz, existingObject, otherObject) {
  var this$4 = existingObject.Lplay_api_libs_json_JsObject__f_underlying;
  var xs = otherObject.Lplay_api_libs_json_JsObject__f_underlying.map__F1__sc_IterableOps(new $c_sjsr_AnonFunction1((function(this$1, existingObject$1) {
    return (function(x0$1$2) {
      var x0$1 = $as_T2(x0$1$2);
      if ((x0$1 !== null)) {
        var otherKey = $as_T(x0$1._1__O());
        var otherValue = $as_Lplay_api_libs_json_JsValue(x0$1._2__O());
        var maybeExistingValue = existingObject$1.Lplay_api_libs_json_JsObject__f_underlying.get__O__s_Option(otherKey);
        matchEnd7: {
          var newValue;
          if ((maybeExistingValue instanceof $c_s_Some)) {
            var x3 = $as_s_Some(maybeExistingValue);
            var e = $as_Lplay_api_libs_json_JsValue(x3.s_Some__f_value);
            if ((e instanceof $c_Lplay_api_libs_json_JsObject)) {
              var x4 = $as_Lplay_api_libs_json_JsObject(e);
              if ((otherValue instanceof $c_Lplay_api_libs_json_JsObject)) {
                var x5 = $as_Lplay_api_libs_json_JsObject(otherValue);
                var newValue = $p_Lplay_api_libs_json_JsObject__merge$1__Lplay_api_libs_json_JsObject__Lplay_api_libs_json_JsObject__Lplay_api_libs_json_JsObject(this$1, x4, x5);
                break matchEnd7
              }
            }
          };
          var newValue = otherValue
        };
        return new $c_T2(otherKey, newValue)
      } else {
        throw new $c_s_MatchError(x0$1)
      }
    })
  })($thiz, existingObject)));
  var result = $as_sc_Map(this$4.concat__sc_IterableOnce__sc_IterableOps(xs));
  return new $c_Lplay_api_libs_json_JsObject(result)
}
/** @constructor */
function $c_Lplay_api_libs_json_JsObject(underlying) {
  this.Lplay_api_libs_json_JsObject__f_fields = null;
  this.Lplay_api_libs_json_JsObject__f_value = null;
  this.Lplay_api_libs_json_JsObject__f_underlying = null;
  this.Lplay_api_libs_json_JsObject__f_bitmap$0 = 0;
  this.Lplay_api_libs_json_JsObject__f_underlying = underlying
}
$c_Lplay_api_libs_json_JsObject.prototype = new $h_O();
$c_Lplay_api_libs_json_JsObject.prototype.constructor = $c_Lplay_api_libs_json_JsObject;
/** @constructor */
function $h_Lplay_api_libs_json_JsObject() {
  /*<skip>*/
}
$h_Lplay_api_libs_json_JsObject.prototype = $c_Lplay_api_libs_json_JsObject.prototype;
$c_Lplay_api_libs_json_JsObject.prototype.toString__T = (function() {
  return $m_Lplay_api_libs_json_StaticBinding$().generateFromJsValue__Lplay_api_libs_json_JsValue__Z__T(this, false)
});
$c_Lplay_api_libs_json_JsObject.prototype.fields__sc_Seq = (function() {
  return (((((1 & this.Lplay_api_libs_json_JsObject__f_bitmap$0) << 24) >> 24) === 0) ? $p_Lplay_api_libs_json_JsObject__fields$lzycompute__sc_Seq(this) : this.Lplay_api_libs_json_JsObject__f_fields)
});
$c_Lplay_api_libs_json_JsObject.prototype.equals__O__Z = (function(other) {
  if ((other instanceof $c_Lplay_api_libs_json_JsObject)) {
    var x2 = $as_Lplay_api_libs_json_JsObject(other);
    var this$1 = this.fields__sc_Seq();
    var x = $m_sci_Set$().from__sc_IterableOnce__sci_Set(this$1);
    var this$2 = x2.fields__sc_Seq();
    var x$2 = $m_sci_Set$().from__sc_IterableOnce__sci_Set(this$2);
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
  } else {
    return false
  }
});
$c_Lplay_api_libs_json_JsObject.prototype.hashCode__I = (function() {
  var this$1 = this.fields__sc_Seq();
  return $m_sci_Set$().from__sc_IterableOnce__sci_Set(this$1).hashCode__I()
});
$c_Lplay_api_libs_json_JsObject.prototype.productPrefix__T = (function() {
  return "JsObject"
});
$c_Lplay_api_libs_json_JsObject.prototype.productArity__I = (function() {
  return 1
});
$c_Lplay_api_libs_json_JsObject.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lplay_api_libs_json_JsObject__f_underlying : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lplay_api_libs_json_JsObject.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
function $as_Lplay_api_libs_json_JsObject(obj) {
  return (((obj instanceof $c_Lplay_api_libs_json_JsObject) || (obj === null)) ? obj : $throwClassCastException(obj, "play.api.libs.json.JsObject"))
}
function $isArrayOf_Lplay_api_libs_json_JsObject(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lplay_api_libs_json_JsObject)))
}
function $asArrayOf_Lplay_api_libs_json_JsObject(obj, depth) {
  return (($isArrayOf_Lplay_api_libs_json_JsObject(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lplay.api.libs.json.JsObject;", depth))
}
var $d_Lplay_api_libs_json_JsObject = new $TypeData().initClass({
  Lplay_api_libs_json_JsObject: 0
}, false, "play.api.libs.json.JsObject", {
  Lplay_api_libs_json_JsObject: 1,
  O: 1,
  Lplay_api_libs_json_JsValue: 1,
  Lplay_api_libs_json_JsReadable: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lplay_api_libs_json_JsObject.prototype.$classData = $d_Lplay_api_libs_json_JsObject;
/** @constructor */
function $c_Lplay_api_libs_json_JsString(value) {
  this.Lplay_api_libs_json_JsString__f_value = null;
  this.Lplay_api_libs_json_JsString__f_value = value
}
$c_Lplay_api_libs_json_JsString.prototype = new $h_O();
$c_Lplay_api_libs_json_JsString.prototype.constructor = $c_Lplay_api_libs_json_JsString;
/** @constructor */
function $h_Lplay_api_libs_json_JsString() {
  /*<skip>*/
}
$h_Lplay_api_libs_json_JsString.prototype = $c_Lplay_api_libs_json_JsString.prototype;
$c_Lplay_api_libs_json_JsString.prototype.toString__T = (function() {
  return $m_Lplay_api_libs_json_StaticBinding$().generateFromJsValue__Lplay_api_libs_json_JsValue__Z__T(this, false)
});
$c_Lplay_api_libs_json_JsString.prototype.productPrefix__T = (function() {
  return "JsString"
});
$c_Lplay_api_libs_json_JsString.prototype.productArity__I = (function() {
  return 1
});
$c_Lplay_api_libs_json_JsString.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lplay_api_libs_json_JsString__f_value : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lplay_api_libs_json_JsString.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lplay_api_libs_json_JsString.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lplay_api_libs_json_JsString.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lplay_api_libs_json_JsString)) {
    var JsString$1 = $as_Lplay_api_libs_json_JsString(x$1);
    return (this.Lplay_api_libs_json_JsString__f_value === JsString$1.Lplay_api_libs_json_JsString__f_value)
  } else {
    return false
  }
});
function $as_Lplay_api_libs_json_JsString(obj) {
  return (((obj instanceof $c_Lplay_api_libs_json_JsString) || (obj === null)) ? obj : $throwClassCastException(obj, "play.api.libs.json.JsString"))
}
function $isArrayOf_Lplay_api_libs_json_JsString(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lplay_api_libs_json_JsString)))
}
function $asArrayOf_Lplay_api_libs_json_JsString(obj, depth) {
  return (($isArrayOf_Lplay_api_libs_json_JsString(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lplay.api.libs.json.JsString;", depth))
}
var $d_Lplay_api_libs_json_JsString = new $TypeData().initClass({
  Lplay_api_libs_json_JsString: 0
}, false, "play.api.libs.json.JsString", {
  Lplay_api_libs_json_JsString: 1,
  O: 1,
  Lplay_api_libs_json_JsValue: 1,
  Lplay_api_libs_json_JsReadable: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lplay_api_libs_json_JsString.prototype.$classData = $d_Lplay_api_libs_json_JsString;
/** @constructor */
function $c_Lplay_api_libs_json_OFormat$$anon$3(read$1, write$1) {
  this.Lplay_api_libs_json_OFormat$$anon$3__f_read$1 = null;
  this.Lplay_api_libs_json_OFormat$$anon$3__f_write$1 = null;
  this.Lplay_api_libs_json_OFormat$$anon$3__f_read$1 = read$1;
  this.Lplay_api_libs_json_OFormat$$anon$3__f_write$1 = write$1
}
$c_Lplay_api_libs_json_OFormat$$anon$3.prototype = new $h_O();
$c_Lplay_api_libs_json_OFormat$$anon$3.prototype.constructor = $c_Lplay_api_libs_json_OFormat$$anon$3;
/** @constructor */
function $h_Lplay_api_libs_json_OFormat$$anon$3() {
  /*<skip>*/
}
$h_Lplay_api_libs_json_OFormat$$anon$3.prototype = $c_Lplay_api_libs_json_OFormat$$anon$3.prototype;
$c_Lplay_api_libs_json_OFormat$$anon$3.prototype.reads__Lplay_api_libs_json_JsValue__Lplay_api_libs_json_JsResult = (function(js) {
  return $as_Lplay_api_libs_json_JsResult(this.Lplay_api_libs_json_OFormat$$anon$3__f_read$1.apply__O__O(js))
});
$c_Lplay_api_libs_json_OFormat$$anon$3.prototype.writes__O__Lplay_api_libs_json_JsObject = (function(a) {
  return $as_Lplay_api_libs_json_JsObject(this.Lplay_api_libs_json_OFormat$$anon$3__f_write$1.apply__O__O(a))
});
$c_Lplay_api_libs_json_OFormat$$anon$3.prototype.contramap__F1__Lplay_api_libs_json_Writes = (function(f) {
  return $f_Lplay_api_libs_json_OWrites__contramap__F1__Lplay_api_libs_json_OWrites(this, f)
});
$c_Lplay_api_libs_json_OFormat$$anon$3.prototype.writes__O__Lplay_api_libs_json_JsValue = (function(o) {
  return this.writes__O__Lplay_api_libs_json_JsObject(o)
});
var $d_Lplay_api_libs_json_OFormat$$anon$3 = new $TypeData().initClass({
  Lplay_api_libs_json_OFormat$$anon$3: 0
}, false, "play.api.libs.json.OFormat$$anon$3", {
  Lplay_api_libs_json_OFormat$$anon$3: 1,
  O: 1,
  Lplay_api_libs_json_OFormat: 1,
  Lplay_api_libs_json_OWrites: 1,
  Lplay_api_libs_json_Writes: 1,
  Lplay_api_libs_json_Reads: 1,
  Lplay_api_libs_json_Format: 1
});
$c_Lplay_api_libs_json_OFormat$$anon$3.prototype.$classData = $d_Lplay_api_libs_json_OFormat$$anon$3;
/** @constructor */
function $c_Lplay_api_libs_json_OFormat$$anon$4(r$1, w$1) {
  this.Lplay_api_libs_json_OFormat$$anon$4__f_r$1 = null;
  this.Lplay_api_libs_json_OFormat$$anon$4__f_w$1 = null;
  this.Lplay_api_libs_json_OFormat$$anon$4__f_r$1 = r$1;
  this.Lplay_api_libs_json_OFormat$$anon$4__f_w$1 = w$1
}
$c_Lplay_api_libs_json_OFormat$$anon$4.prototype = new $h_O();
$c_Lplay_api_libs_json_OFormat$$anon$4.prototype.constructor = $c_Lplay_api_libs_json_OFormat$$anon$4;
/** @constructor */
function $h_Lplay_api_libs_json_OFormat$$anon$4() {
  /*<skip>*/
}
$h_Lplay_api_libs_json_OFormat$$anon$4.prototype = $c_Lplay_api_libs_json_OFormat$$anon$4.prototype;
$c_Lplay_api_libs_json_OFormat$$anon$4.prototype.reads__Lplay_api_libs_json_JsValue__Lplay_api_libs_json_JsResult = (function(js) {
  return this.Lplay_api_libs_json_OFormat$$anon$4__f_r$1.reads__Lplay_api_libs_json_JsValue__Lplay_api_libs_json_JsResult(js)
});
$c_Lplay_api_libs_json_OFormat$$anon$4.prototype.writes__O__Lplay_api_libs_json_JsObject = (function(a) {
  return this.Lplay_api_libs_json_OFormat$$anon$4__f_w$1.writes__O__Lplay_api_libs_json_JsObject(a)
});
$c_Lplay_api_libs_json_OFormat$$anon$4.prototype.contramap__F1__Lplay_api_libs_json_Writes = (function(f) {
  return $f_Lplay_api_libs_json_OWrites__contramap__F1__Lplay_api_libs_json_OWrites(this, f)
});
$c_Lplay_api_libs_json_OFormat$$anon$4.prototype.writes__O__Lplay_api_libs_json_JsValue = (function(o) {
  return this.writes__O__Lplay_api_libs_json_JsObject(o)
});
var $d_Lplay_api_libs_json_OFormat$$anon$4 = new $TypeData().initClass({
  Lplay_api_libs_json_OFormat$$anon$4: 0
}, false, "play.api.libs.json.OFormat$$anon$4", {
  Lplay_api_libs_json_OFormat$$anon$4: 1,
  O: 1,
  Lplay_api_libs_json_OFormat: 1,
  Lplay_api_libs_json_OWrites: 1,
  Lplay_api_libs_json_Writes: 1,
  Lplay_api_libs_json_Reads: 1,
  Lplay_api_libs_json_Format: 1
});
$c_Lplay_api_libs_json_OFormat$$anon$4.prototype.$classData = $d_Lplay_api_libs_json_OFormat$$anon$4;
/** @constructor */
function $c_s_None$() {
  /*<skip>*/
}
$c_s_None$.prototype = new $h_s_Option();
$c_s_None$.prototype.constructor = $c_s_None$;
/** @constructor */
function $h_s_None$() {
  /*<skip>*/
}
$h_s_None$.prototype = $c_s_None$.prototype;
$c_s_None$.prototype.get__E = (function() {
  throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "None.get")
});
$c_s_None$.prototype.productPrefix__T = (function() {
  return "None"
});
$c_s_None$.prototype.productArity__I = (function() {
  return 0
});
$c_s_None$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_s_None$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_s_None$.prototype.hashCode__I = (function() {
  return 2433880
});
$c_s_None$.prototype.toString__T = (function() {
  return "None"
});
$c_s_None$.prototype.get__O = (function() {
  this.get__E()
});
function $as_s_None$(obj) {
  return (((obj instanceof $c_s_None$) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.None$"))
}
function $isArrayOf_s_None$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_None$)))
}
function $asArrayOf_s_None$(obj, depth) {
  return (($isArrayOf_s_None$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.None$;", depth))
}
var $d_s_None$ = new $TypeData().initClass({
  s_None$: 0
}, false, "scala.None$", {
  s_None$: 1,
  s_Option: 1,
  O: 1,
  sc_IterableOnce: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_s_None$.prototype.$classData = $d_s_None$;
var $n_s_None$;
function $m_s_None$() {
  if ((!$n_s_None$)) {
    $n_s_None$ = new $c_s_None$()
  };
  return $n_s_None$
}
/** @constructor */
function $c_s_Some(value) {
  this.s_Some__f_value = null;
  this.s_Some__f_value = value
}
$c_s_Some.prototype = new $h_s_Option();
$c_s_Some.prototype.constructor = $c_s_Some;
/** @constructor */
function $h_s_Some() {
  /*<skip>*/
}
$h_s_Some.prototype = $c_s_Some.prototype;
$c_s_Some.prototype.get__O = (function() {
  return this.s_Some__f_value
});
$c_s_Some.prototype.productPrefix__T = (function() {
  return "Some"
});
$c_s_Some.prototype.productArity__I = (function() {
  return 1
});
$c_s_Some.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.s_Some__f_value : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_s_Some.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_s_Some.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_s_Some.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_s_Some.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_s_Some)) {
    var Some$1 = $as_s_Some(x$1);
    return $m_sr_BoxesRunTime$().equals__O__O__Z(this.s_Some__f_value, Some$1.s_Some__f_value)
  } else {
    return false
  }
});
function $as_s_Some(obj) {
  return (((obj instanceof $c_s_Some) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Some"))
}
function $isArrayOf_s_Some(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_Some)))
}
function $asArrayOf_s_Some(obj, depth) {
  return (($isArrayOf_s_Some(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Some;", depth))
}
var $d_s_Some = new $TypeData().initClass({
  s_Some: 0
}, false, "scala.Some", {
  s_Some: 1,
  s_Option: 1,
  O: 1,
  sc_IterableOnce: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_s_Some.prototype.$classData = $d_s_Some;
/** @constructor */
function $c_sc_AbstractIterable() {
  /*<skip>*/
}
$c_sc_AbstractIterable.prototype = new $h_O();
$c_sc_AbstractIterable.prototype.constructor = $c_sc_AbstractIterable;
/** @constructor */
function $h_sc_AbstractIterable() {
  /*<skip>*/
}
$h_sc_AbstractIterable.prototype = $c_sc_AbstractIterable.prototype;
$c_sc_AbstractIterable.prototype.className__T = (function() {
  return this.stringPrefix__T()
});
$c_sc_AbstractIterable.prototype.fromSpecific__sc_IterableOnce__sc_IterableOps = (function(coll) {
  return $as_sc_IterableOps(this.iterableFactory__sc_IterableFactory().from__sc_IterableOnce__O(coll))
});
$c_sc_AbstractIterable.prototype.newSpecificBuilder__scm_Builder = (function() {
  return this.iterableFactory__sc_IterableFactory().newBuilder__scm_Builder()
});
$c_sc_AbstractIterable.prototype.head__O = (function() {
  return this.iterator__sc_Iterator().next__O()
});
$c_sc_AbstractIterable.prototype.sizeCompare__I__I = (function(otherSize) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, otherSize)
});
$c_sc_AbstractIterable.prototype.drop__I__O = (function(n) {
  return $f_sc_IterableOps__drop__I__O(this, n)
});
$c_sc_AbstractIterable.prototype.tail__O = (function() {
  return $f_sc_IterableOps__tail__O(this)
});
$c_sc_AbstractIterable.prototype.map__F1__O = (function(f) {
  return $f_sc_IterableOps__map__F1__O(this, f)
});
$c_sc_AbstractIterable.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_IterableOps__flatMap__F1__O(this, f)
});
$c_sc_AbstractIterable.prototype.concat__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix)
});
$c_sc_AbstractIterable.prototype.zipWithIndex__O = (function() {
  return $f_sc_IterableOps__zipWithIndex__O(this)
});
$c_sc_AbstractIterable.prototype.foreach__F1__V = (function(f) {
  $f_sc_IterableOnceOps__foreach__F1__V(this, f)
});
$c_sc_AbstractIterable.prototype.forall__F1__Z = (function(p) {
  return $f_sc_IterableOnceOps__forall__F1__Z(this, p)
});
$c_sc_AbstractIterable.prototype.exists__F1__Z = (function(p) {
  return $f_sc_IterableOnceOps__exists__F1__Z(this, p)
});
$c_sc_AbstractIterable.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op)
});
$c_sc_AbstractIterable.prototype.isEmpty__Z = (function() {
  return $f_sc_IterableOnceOps__isEmpty__Z(this)
});
$c_sc_AbstractIterable.prototype.size__I = (function() {
  return $f_sc_IterableOnceOps__size__I(this)
});
$c_sc_AbstractIterable.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len)
});
$c_sc_AbstractIterable.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end)
});
$c_sc_AbstractIterable.prototype.toSeq__sci_Seq = (function() {
  return $m_sci_Seq$().from__sc_IterableOnce__sci_Seq(this)
});
$c_sc_AbstractIterable.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2)
});
$c_sc_AbstractIterable.prototype.knownSize__I = (function() {
  return (-1)
});
$c_sc_AbstractIterable.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  return this.fromSpecific__sc_IterableOnce__sc_IterableOps(coll)
});
function $ct_sc_ArrayOps$ArrayIterator__O__($thiz, xs) {
  $thiz.sc_ArrayOps$ArrayIterator__f_xs = xs;
  $thiz.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = 0;
  $thiz.sc_ArrayOps$ArrayIterator__f_len = $m_sr_ScalaRunTime$().array_length__O__I($thiz.sc_ArrayOps$ArrayIterator__f_xs);
  return $thiz
}
/** @constructor */
function $c_sc_ArrayOps$ArrayIterator() {
  this.sc_ArrayOps$ArrayIterator__f_xs = null;
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = 0;
  this.sc_ArrayOps$ArrayIterator__f_len = 0
}
$c_sc_ArrayOps$ArrayIterator.prototype = new $h_sc_AbstractIterator();
$c_sc_ArrayOps$ArrayIterator.prototype.constructor = $c_sc_ArrayOps$ArrayIterator;
/** @constructor */
function $h_sc_ArrayOps$ArrayIterator() {
  /*<skip>*/
}
$h_sc_ArrayOps$ArrayIterator.prototype = $c_sc_ArrayOps$ArrayIterator.prototype;
$c_sc_ArrayOps$ArrayIterator.prototype.knownSize__I = (function() {
  return ((this.sc_ArrayOps$ArrayIterator__f_len - this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos) | 0)
});
$c_sc_ArrayOps$ArrayIterator.prototype.hasNext__Z = (function() {
  return (this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos < this.sc_ArrayOps$ArrayIterator__f_len)
});
$c_sc_ArrayOps$ArrayIterator.prototype.next__O = (function() {
  try {
    var r = $m_sr_ScalaRunTime$().array_apply__O__I__O(this.sc_ArrayOps$ArrayIterator__f_xs, this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos);
    this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = ((1 + this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos) | 0);
    return r
  } catch (e) {
    if ((e instanceof $c_jl_ArrayIndexOutOfBoundsException)) {
      return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O()
    } else {
      throw e
    }
  }
});
$c_sc_ArrayOps$ArrayIterator.prototype.drop__I__sc_Iterator = (function(n) {
  if ((n > 0)) {
    var a = $m_sr_ScalaRunTime$().array_length__O__I(this.sc_ArrayOps$ArrayIterator__f_xs);
    var b = ((this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos + n) | 0);
    this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = ((a < b) ? a : b)
  };
  return this
});
var $d_sc_ArrayOps$ArrayIterator = new $TypeData().initClass({
  sc_ArrayOps$ArrayIterator: 0
}, false, "scala.collection.ArrayOps$ArrayIterator", {
  sc_ArrayOps$ArrayIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
});
$c_sc_ArrayOps$ArrayIterator.prototype.$classData = $d_sc_ArrayOps$ArrayIterator;
/** @constructor */
function $c_sc_IndexedSeqView$IndexedSeqViewIterator(self) {
  this.sc_IndexedSeqView$IndexedSeqViewIterator__f_self = null;
  this.sc_IndexedSeqView$IndexedSeqViewIterator__f_current = 0;
  this.sc_IndexedSeqView$IndexedSeqViewIterator__f_remainder = 0;
  this.sc_IndexedSeqView$IndexedSeqViewIterator__f_self = self;
  this.sc_IndexedSeqView$IndexedSeqViewIterator__f_current = 0;
  this.sc_IndexedSeqView$IndexedSeqViewIterator__f_remainder = self.length__I()
}
$c_sc_IndexedSeqView$IndexedSeqViewIterator.prototype = new $h_sc_AbstractIterator();
$c_sc_IndexedSeqView$IndexedSeqViewIterator.prototype.constructor = $c_sc_IndexedSeqView$IndexedSeqViewIterator;
/** @constructor */
function $h_sc_IndexedSeqView$IndexedSeqViewIterator() {
  /*<skip>*/
}
$h_sc_IndexedSeqView$IndexedSeqViewIterator.prototype = $c_sc_IndexedSeqView$IndexedSeqViewIterator.prototype;
$c_sc_IndexedSeqView$IndexedSeqViewIterator.prototype.knownSize__I = (function() {
  return this.sc_IndexedSeqView$IndexedSeqViewIterator__f_remainder
});
$c_sc_IndexedSeqView$IndexedSeqViewIterator.prototype.hasNext__Z = (function() {
  return (this.sc_IndexedSeqView$IndexedSeqViewIterator__f_remainder > 0)
});
$c_sc_IndexedSeqView$IndexedSeqViewIterator.prototype.next__O = (function() {
  if (this.hasNext__Z()) {
    var r = this.sc_IndexedSeqView$IndexedSeqViewIterator__f_self.apply__I__O(this.sc_IndexedSeqView$IndexedSeqViewIterator__f_current);
    this.sc_IndexedSeqView$IndexedSeqViewIterator__f_current = ((1 + this.sc_IndexedSeqView$IndexedSeqViewIterator__f_current) | 0);
    this.sc_IndexedSeqView$IndexedSeqViewIterator__f_remainder = (((-1) + this.sc_IndexedSeqView$IndexedSeqViewIterator__f_remainder) | 0);
    return r
  } else {
    return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O()
  }
});
$c_sc_IndexedSeqView$IndexedSeqViewIterator.prototype.drop__I__sc_Iterator = (function(n) {
  if ((n > 0)) {
    this.sc_IndexedSeqView$IndexedSeqViewIterator__f_current = ((this.sc_IndexedSeqView$IndexedSeqViewIterator__f_current + n) | 0);
    var b = ((this.sc_IndexedSeqView$IndexedSeqViewIterator__f_remainder - n) | 0);
    this.sc_IndexedSeqView$IndexedSeqViewIterator__f_remainder = ((b < 0) ? 0 : b)
  };
  return this
});
var $d_sc_IndexedSeqView$IndexedSeqViewIterator = new $TypeData().initClass({
  sc_IndexedSeqView$IndexedSeqViewIterator: 0
}, false, "scala.collection.IndexedSeqView$IndexedSeqViewIterator", {
  sc_IndexedSeqView$IndexedSeqViewIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
});
$c_sc_IndexedSeqView$IndexedSeqViewIterator.prototype.$classData = $d_sc_IndexedSeqView$IndexedSeqViewIterator;
/** @constructor */
function $c_sc_Iterator$$anon$21() {
  this.scm_ImmutableBuilder__f_empty = null;
  this.scm_ImmutableBuilder__f_elems = null;
  $ct_scm_ImmutableBuilder__sc_IterableOnce__(this, $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty)
}
$c_sc_Iterator$$anon$21.prototype = new $h_scm_ImmutableBuilder();
$c_sc_Iterator$$anon$21.prototype.constructor = $c_sc_Iterator$$anon$21;
/** @constructor */
function $h_sc_Iterator$$anon$21() {
  /*<skip>*/
}
$h_sc_Iterator$$anon$21.prototype = $c_sc_Iterator$$anon$21.prototype;
$c_sc_Iterator$$anon$21.prototype.addOne__O__sc_Iterator$$anon$21 = (function(elem) {
  var this$3 = $as_sc_Iterator(this.scm_ImmutableBuilder__f_elems);
  var xs = new $c_sjsr_AnonFunction0((function(this$1, elem$1) {
    return (function() {
      $m_sc_Iterator$();
      return new $c_sc_Iterator$$anon$20(elem$1)
    })
  })(this, elem));
  this.scm_ImmutableBuilder__f_elems = this$3.concat__F0__sc_Iterator(xs);
  return this
});
$c_sc_Iterator$$anon$21.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__sc_Iterator$$anon$21(elem)
});
var $d_sc_Iterator$$anon$21 = new $TypeData().initClass({
  sc_Iterator$$anon$21: 0
}, false, "scala.collection.Iterator$$anon$21", {
  sc_Iterator$$anon$21: 1,
  scm_ImmutableBuilder: 1,
  O: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
});
$c_sc_Iterator$$anon$21.prototype.$classData = $d_sc_Iterator$$anon$21;
function $f_sc_MapOps__getOrElse__O__F0__O($thiz, key, default$1) {
  var x1 = $thiz.get__O__s_Option(key);
  if ((x1 instanceof $c_s_Some)) {
    var x2 = $as_s_Some(x1);
    var v = x2.s_Some__f_value;
    return v
  } else {
    var x = $m_s_None$();
    if ((x === x1)) {
      return default$1.apply__O()
    } else {
      throw new $c_s_MatchError(x1)
    }
  }
}
function $f_sc_MapOps__apply__O__O($thiz, key) {
  var x1 = $thiz.get__O__s_Option(key);
  var x = $m_s_None$();
  if ((x === x1)) {
    return $f_sc_MapOps__default__O__O($thiz, key)
  } else if ((x1 instanceof $c_s_Some)) {
    var x2 = $as_s_Some(x1);
    var value = x2.s_Some__f_value;
    return value
  } else {
    throw new $c_s_MatchError(x1)
  }
}
function $f_sc_MapOps__applyOrElse__O__F1__O($thiz, x, default$1) {
  return $thiz.getOrElse__O__F0__O(x, new $c_sjsr_AnonFunction0((function(this$1, default$2, x$1) {
    return (function() {
      return default$2.apply__O__O(x$1)
    })
  })($thiz, default$1, x)))
}
function $f_sc_MapOps__foreachEntry__F2__V($thiz, f) {
  var it = $thiz.iterator__sc_Iterator();
  while (it.hasNext__Z()) {
    var next = $as_T2(it.next__O());
    f.apply__O__O__O(next._1__O(), next._2__O())
  }
}
function $f_sc_MapOps__default__O__O($thiz, key) {
  throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + key))
}
function $f_sc_MapOps__contains__O__Z($thiz, key) {
  var this$1 = $thiz.get__O__s_Option(key);
  return (!this$1.isEmpty__Z())
}
function $f_sc_MapOps__map__F1__sc_IterableOps($thiz, f) {
  return $as_sc_IterableOps($thiz.mapFactory__sc_MapFactory().from__sc_IterableOnce__O($ct_sc_View$Map__sc_IterableOps__F1__(new $c_sc_View$Map(), $thiz, f)))
}
function $f_sc_MapOps__concat__sc_IterableOnce__sc_IterableOps($thiz, suffix) {
  var $$x2 = $thiz.mapFactory__sc_MapFactory();
  if ($is_sc_Iterable(suffix)) {
    var x2 = $as_sc_Iterable(suffix);
    var $$x1 = new $c_sc_View$Concat($thiz, x2)
  } else {
    var $$x1 = $thiz.iterator__sc_Iterator().concat__F0__sc_Iterator(new $c_sjsr_AnonFunction0((function(this$1, suffix$1) {
      return (function() {
        return suffix$1.iterator__sc_Iterator()
      })
    })($thiz, suffix)))
  };
  return $as_sc_IterableOps($$x2.from__sc_IterableOnce__O($$x1))
}
function $f_sc_MapOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder($thiz, sb, start, sep, end) {
  var this$2 = $thiz.iterator__sc_Iterator();
  var f = new $c_sjsr_AnonFunction1((function(this$1) {
    return (function(x0$1$2) {
      var x0$1 = $as_T2(x0$1$2);
      if ((x0$1 !== null)) {
        var k = x0$1._1__O();
        var v = x0$1._2__O();
        return ((k + " -> ") + v)
      } else {
        throw new $c_s_MatchError(x0$1)
      }
    })
  })($thiz));
  var this$3 = new $c_sc_Iterator$$anon$9(this$2, f);
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this$3, sb, start, sep, end)
}
function $f_sc_StrictOptimizedSeqOps__appended__O__O($thiz, elem) {
  var b = $thiz.iterableFactory__sc_SeqFactory().newBuilder__scm_Builder();
  if (($thiz.knownSize__I() >= 0)) {
    b.sizeHint__I__V(((1 + $thiz.length__I()) | 0))
  };
  b.addAll__sc_IterableOnce__scm_Growable($thiz);
  b.addOne__O__scm_Growable(elem);
  return b.result__O()
}
function $f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O($thiz, suffix) {
  var b = $thiz.iterableFactory__sc_SeqFactory().newBuilder__scm_Builder();
  b.addAll__sc_IterableOnce__scm_Growable($thiz);
  b.addAll__sc_IterableOnce__scm_Growable(suffix);
  return b.result__O()
}
function $is_sci_Iterable(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sci_Iterable)))
}
function $as_sci_Iterable(obj) {
  return (($is_sci_Iterable(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Iterable"))
}
function $isArrayOf_sci_Iterable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Iterable)))
}
function $asArrayOf_sci_Iterable(obj, depth) {
  return (($isArrayOf_sci_Iterable(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Iterable;", depth))
}
/** @constructor */
function $c_sci_Map$Map2$$anon$1(outer) {
  this.sci_Map$Map2$Map2Iterator__f_i = 0;
  this.sci_Map$Map2$Map2Iterator__f_$outer = null;
  $ct_sci_Map$Map2$Map2Iterator__sci_Map$Map2__(this, outer)
}
$c_sci_Map$Map2$$anon$1.prototype = new $h_sci_Map$Map2$Map2Iterator();
$c_sci_Map$Map2$$anon$1.prototype.constructor = $c_sci_Map$Map2$$anon$1;
/** @constructor */
function $h_sci_Map$Map2$$anon$1() {
  /*<skip>*/
}
$h_sci_Map$Map2$$anon$1.prototype = $c_sci_Map$Map2$$anon$1.prototype;
var $d_sci_Map$Map2$$anon$1 = new $TypeData().initClass({
  sci_Map$Map2$$anon$1: 0
}, false, "scala.collection.immutable.Map$Map2$$anon$1", {
  sci_Map$Map2$$anon$1: 1,
  sci_Map$Map2$Map2Iterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sci_Map$Map2$$anon$1.prototype.$classData = $d_sci_Map$Map2$$anon$1;
/** @constructor */
function $c_sci_Map$Map3$$anon$4(outer) {
  this.sci_Map$Map3$Map3Iterator__f_i = 0;
  this.sci_Map$Map3$Map3Iterator__f_$outer = null;
  $ct_sci_Map$Map3$Map3Iterator__sci_Map$Map3__(this, outer)
}
$c_sci_Map$Map3$$anon$4.prototype = new $h_sci_Map$Map3$Map3Iterator();
$c_sci_Map$Map3$$anon$4.prototype.constructor = $c_sci_Map$Map3$$anon$4;
/** @constructor */
function $h_sci_Map$Map3$$anon$4() {
  /*<skip>*/
}
$h_sci_Map$Map3$$anon$4.prototype = $c_sci_Map$Map3$$anon$4.prototype;
var $d_sci_Map$Map3$$anon$4 = new $TypeData().initClass({
  sci_Map$Map3$$anon$4: 0
}, false, "scala.collection.immutable.Map$Map3$$anon$4", {
  sci_Map$Map3$$anon$4: 1,
  sci_Map$Map3$Map3Iterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sci_Map$Map3$$anon$4.prototype.$classData = $d_sci_Map$Map3$$anon$4;
/** @constructor */
function $c_sci_Map$Map4$$anon$7(outer) {
  this.sci_Map$Map4$Map4Iterator__f_i = 0;
  this.sci_Map$Map4$Map4Iterator__f_$outer = null;
  $ct_sci_Map$Map4$Map4Iterator__sci_Map$Map4__(this, outer)
}
$c_sci_Map$Map4$$anon$7.prototype = new $h_sci_Map$Map4$Map4Iterator();
$c_sci_Map$Map4$$anon$7.prototype.constructor = $c_sci_Map$Map4$$anon$7;
/** @constructor */
function $h_sci_Map$Map4$$anon$7() {
  /*<skip>*/
}
$h_sci_Map$Map4$$anon$7.prototype = $c_sci_Map$Map4$$anon$7.prototype;
var $d_sci_Map$Map4$$anon$7 = new $TypeData().initClass({
  sci_Map$Map4$$anon$7: 0
}, false, "scala.collection.immutable.Map$Map4$$anon$7", {
  sci_Map$Map4$$anon$7: 1,
  sci_Map$Map4$Map4Iterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sci_Map$Map4$$anon$7.prototype.$classData = $d_sci_Map$Map4$$anon$7;
function $ct_sci_Set$SetNIterator__I__($thiz, n) {
  $thiz.sci_Set$SetNIterator__f_current = 0;
  $thiz.sci_Set$SetNIterator__f_remainder = n;
  return $thiz
}
/** @constructor */
function $c_sci_Set$SetNIterator() {
  this.sci_Set$SetNIterator__f_current = 0;
  this.sci_Set$SetNIterator__f_remainder = 0
}
$c_sci_Set$SetNIterator.prototype = new $h_sc_AbstractIterator();
$c_sci_Set$SetNIterator.prototype.constructor = $c_sci_Set$SetNIterator;
/** @constructor */
function $h_sci_Set$SetNIterator() {
  /*<skip>*/
}
$h_sci_Set$SetNIterator.prototype = $c_sci_Set$SetNIterator.prototype;
$c_sci_Set$SetNIterator.prototype.knownSize__I = (function() {
  return this.sci_Set$SetNIterator__f_remainder
});
$c_sci_Set$SetNIterator.prototype.hasNext__Z = (function() {
  return (this.sci_Set$SetNIterator__f_remainder > 0)
});
$c_sci_Set$SetNIterator.prototype.next__O = (function() {
  if (this.hasNext__Z()) {
    var r = this.apply__I__O(this.sci_Set$SetNIterator__f_current);
    this.sci_Set$SetNIterator__f_current = ((1 + this.sci_Set$SetNIterator__f_current) | 0);
    this.sci_Set$SetNIterator__f_remainder = (((-1) + this.sci_Set$SetNIterator__f_remainder) | 0);
    return r
  } else {
    return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O()
  }
});
$c_sci_Set$SetNIterator.prototype.drop__I__sc_Iterator = (function(n) {
  if ((n > 0)) {
    this.sci_Set$SetNIterator__f_current = ((this.sci_Set$SetNIterator__f_current + n) | 0);
    var b = ((this.sci_Set$SetNIterator__f_remainder - n) | 0);
    this.sci_Set$SetNIterator__f_remainder = ((b < 0) ? 0 : b)
  };
  return this
});
function $ct_scm_ArrayBuilder__($thiz) {
  $thiz.scm_ArrayBuilder__f_capacity = 0;
  $thiz.scm_ArrayBuilder__f_size = 0;
  return $thiz
}
/** @constructor */
function $c_scm_ArrayBuilder() {
  this.scm_ArrayBuilder__f_capacity = 0;
  this.scm_ArrayBuilder__f_size = 0
}
$c_scm_ArrayBuilder.prototype = new $h_O();
$c_scm_ArrayBuilder.prototype.constructor = $c_scm_ArrayBuilder;
/** @constructor */
function $h_scm_ArrayBuilder() {
  /*<skip>*/
}
$h_scm_ArrayBuilder.prototype = $c_scm_ArrayBuilder.prototype;
$c_scm_ArrayBuilder.prototype.sizeHint__I__V = (function(size) {
  /*<skip>*/
});
/** @constructor */
function $c_scm_ArraySeq$() {
  this.scm_ArraySeq$__f_untagged = null;
  this.scm_ArraySeq$__f_EmptyArraySeq = null;
  $n_scm_ArraySeq$ = this;
  this.scm_ArraySeq$__f_untagged = new $c_sc_ClassTagSeqFactory$AnySeqDelegate(this);
  this.scm_ArraySeq$__f_EmptyArraySeq = new $c_scm_ArraySeq$ofRef(new $ac_O(0))
}
$c_scm_ArraySeq$.prototype = new $h_O();
$c_scm_ArraySeq$.prototype.constructor = $c_scm_ArraySeq$;
/** @constructor */
function $h_scm_ArraySeq$() {
  /*<skip>*/
}
$h_scm_ArraySeq$.prototype = $c_scm_ArraySeq$.prototype;
$c_scm_ArraySeq$.prototype.newBuilder__s_reflect_ClassTag__scm_Builder = (function(evidence$3) {
  var this$4 = new $c_scm_ArrayBuilder$generic(evidence$3.runtimeClass__jl_Class());
  var f = new $c_sjsr_AnonFunction1((function(this$3) {
    return (function(x$2) {
      return $m_scm_ArraySeq$().make__O__scm_ArraySeq(x$2)
    })
  })(this));
  return new $c_scm_Builder$$anon$1(this$4, f)
});
$c_scm_ArraySeq$.prototype.make__O__scm_ArraySeq = (function(x) {
  if ((x === null)) {
    return null
  } else if ((x instanceof $ac_O)) {
    var x3 = $asArrayOf_O(x, 1);
    return new $c_scm_ArraySeq$ofRef(x3)
  } else if ((x instanceof $ac_I)) {
    var x4 = $asArrayOf_I(x, 1);
    return new $c_scm_ArraySeq$ofInt(x4)
  } else if ((x instanceof $ac_D)) {
    var x5 = $asArrayOf_D(x, 1);
    return new $c_scm_ArraySeq$ofDouble(x5)
  } else if ((x instanceof $ac_J)) {
    var x6 = $asArrayOf_J(x, 1);
    return new $c_scm_ArraySeq$ofLong(x6)
  } else if ((x instanceof $ac_F)) {
    var x7 = $asArrayOf_F(x, 1);
    return new $c_scm_ArraySeq$ofFloat(x7)
  } else if ((x instanceof $ac_C)) {
    var x8 = $asArrayOf_C(x, 1);
    return new $c_scm_ArraySeq$ofChar(x8)
  } else if ((x instanceof $ac_B)) {
    var x9 = $asArrayOf_B(x, 1);
    return new $c_scm_ArraySeq$ofByte(x9)
  } else if ((x instanceof $ac_S)) {
    var x10 = $asArrayOf_S(x, 1);
    return new $c_scm_ArraySeq$ofShort(x10)
  } else if ((x instanceof $ac_Z)) {
    var x11 = $asArrayOf_Z(x, 1);
    return new $c_scm_ArraySeq$ofBoolean(x11)
  } else if ($isArrayOf_jl_Void(x, 1)) {
    var x12 = $asArrayOf_jl_Void(x, 1);
    return new $c_scm_ArraySeq$ofUnit(x12)
  } else {
    throw new $c_s_MatchError(x)
  }
});
var $d_scm_ArraySeq$ = new $TypeData().initClass({
  scm_ArraySeq$: 0
}, false, "scala.collection.mutable.ArraySeq$", {
  scm_ArraySeq$: 1,
  O: 1,
  sc_StrictOptimizedClassTagSeqFactory: 1,
  sc_ClassTagSeqFactory: 1,
  sc_ClassTagIterableFactory: 1,
  sc_EvidenceIterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_scm_ArraySeq$.prototype.$classData = $d_scm_ArraySeq$;
var $n_scm_ArraySeq$;
function $m_scm_ArraySeq$() {
  if ((!$n_scm_ArraySeq$)) {
    $n_scm_ArraySeq$ = new $c_scm_ArraySeq$()
  };
  return $n_scm_ArraySeq$
}
/** @constructor */
function $c_scm_HashMap$$anon$1(outer) {
  this.scm_HashMap$HashMapIterator__f_i = 0;
  this.scm_HashMap$HashMapIterator__f_node = null;
  this.scm_HashMap$HashMapIterator__f_len = 0;
  this.scm_HashMap$HashMapIterator__f_$outer = null;
  $ct_scm_HashMap$HashMapIterator__scm_HashMap__(this, outer)
}
$c_scm_HashMap$$anon$1.prototype = new $h_scm_HashMap$HashMapIterator();
$c_scm_HashMap$$anon$1.prototype.constructor = $c_scm_HashMap$$anon$1;
/** @constructor */
function $h_scm_HashMap$$anon$1() {
  /*<skip>*/
}
$h_scm_HashMap$$anon$1.prototype = $c_scm_HashMap$$anon$1.prototype;
$c_scm_HashMap$$anon$1.prototype.extract__scm_HashMap$Node__O = (function(nd) {
  return new $c_T2(nd.scm_HashMap$Node__f__key, nd.scm_HashMap$Node__f__value)
});
var $d_scm_HashMap$$anon$1 = new $TypeData().initClass({
  scm_HashMap$$anon$1: 0
}, false, "scala.collection.mutable.HashMap$$anon$1", {
  scm_HashMap$$anon$1: 1,
  scm_HashMap$HashMapIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_scm_HashMap$$anon$1.prototype.$classData = $d_scm_HashMap$$anon$1;
/** @constructor */
function $c_scm_HashMap$$anon$4(outer) {
  this.scm_HashMap$HashMapIterator__f_i = 0;
  this.scm_HashMap$HashMapIterator__f_node = null;
  this.scm_HashMap$HashMapIterator__f_len = 0;
  this.scm_HashMap$HashMapIterator__f_$outer = null;
  $ct_scm_HashMap$HashMapIterator__scm_HashMap__(this, outer)
}
$c_scm_HashMap$$anon$4.prototype = new $h_scm_HashMap$HashMapIterator();
$c_scm_HashMap$$anon$4.prototype.constructor = $c_scm_HashMap$$anon$4;
/** @constructor */
function $h_scm_HashMap$$anon$4() {
  /*<skip>*/
}
$h_scm_HashMap$$anon$4.prototype = $c_scm_HashMap$$anon$4.prototype;
$c_scm_HashMap$$anon$4.prototype.extract__scm_HashMap$Node__O = (function(nd) {
  return nd
});
var $d_scm_HashMap$$anon$4 = new $TypeData().initClass({
  scm_HashMap$$anon$4: 0
}, false, "scala.collection.mutable.HashMap$$anon$4", {
  scm_HashMap$$anon$4: 1,
  scm_HashMap$HashMapIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_scm_HashMap$$anon$4.prototype.$classData = $d_scm_HashMap$$anon$4;
/** @constructor */
function $c_scm_HashMap$$anon$5(outer) {
  this.scm_HashMap$HashMapIterator__f_i = 0;
  this.scm_HashMap$HashMapIterator__f_node = null;
  this.scm_HashMap$HashMapIterator__f_len = 0;
  this.scm_HashMap$HashMapIterator__f_$outer = null;
  this.scm_HashMap$$anon$5__f_hash = 0;
  this.scm_HashMap$$anon$5__f_$outer = null;
  if ((outer === null)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(null)
  } else {
    this.scm_HashMap$$anon$5__f_$outer = outer
  };
  $ct_scm_HashMap$HashMapIterator__scm_HashMap__(this, outer);
  this.scm_HashMap$$anon$5__f_hash = 0
}
$c_scm_HashMap$$anon$5.prototype = new $h_scm_HashMap$HashMapIterator();
$c_scm_HashMap$$anon$5.prototype.constructor = $c_scm_HashMap$$anon$5;
/** @constructor */
function $h_scm_HashMap$$anon$5() {
  /*<skip>*/
}
$h_scm_HashMap$$anon$5.prototype = $c_scm_HashMap$$anon$5.prototype;
$c_scm_HashMap$$anon$5.prototype.hashCode__I = (function() {
  return this.scm_HashMap$$anon$5__f_hash
});
$c_scm_HashMap$$anon$5.prototype.extract__scm_HashMap$Node__O = (function(nd) {
  var $$x1 = $m_s_util_hashing_MurmurHash3$();
  var improvedHash = nd.scm_HashMap$Node__f__hash;
  var x = nd.scm_HashMap$Node__f__value;
  this.scm_HashMap$$anon$5__f_hash = $$x1.tuple2Hash__O__O__I((improvedHash ^ ((improvedHash >>> 16) | 0)), $m_sr_Statics$().anyHash__O__I(x));
  return this
});
var $d_scm_HashMap$$anon$5 = new $TypeData().initClass({
  scm_HashMap$$anon$5: 0
}, false, "scala.collection.mutable.HashMap$$anon$5", {
  scm_HashMap$$anon$5: 1,
  scm_HashMap$HashMapIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_scm_HashMap$$anon$5.prototype.$classData = $d_scm_HashMap$$anon$5;
/** @constructor */
function $c_s_concurrent_duration_Duration$$anon$1() {
  /*<skip>*/
}
$c_s_concurrent_duration_Duration$$anon$1.prototype = new $h_s_concurrent_duration_Duration$Infinite();
$c_s_concurrent_duration_Duration$$anon$1.prototype.constructor = $c_s_concurrent_duration_Duration$$anon$1;
/** @constructor */
function $h_s_concurrent_duration_Duration$$anon$1() {
  /*<skip>*/
}
$h_s_concurrent_duration_Duration$$anon$1.prototype = $c_s_concurrent_duration_Duration$$anon$1.prototype;
$c_s_concurrent_duration_Duration$$anon$1.prototype.toString__T = (function() {
  return "Duration.Undefined"
});
$c_s_concurrent_duration_Duration$$anon$1.prototype.equals__O__Z = (function(other) {
  return false
});
$c_s_concurrent_duration_Duration$$anon$1.prototype.compare__s_concurrent_duration_Duration__I = (function(other) {
  return ((other === this) ? 0 : 1)
});
$c_s_concurrent_duration_Duration$$anon$1.prototype.compare__O__I = (function(that) {
  return this.compare__s_concurrent_duration_Duration__I($as_s_concurrent_duration_Duration(that))
});
var $d_s_concurrent_duration_Duration$$anon$1 = new $TypeData().initClass({
  s_concurrent_duration_Duration$$anon$1: 0
}, false, "scala.concurrent.duration.Duration$$anon$1", {
  s_concurrent_duration_Duration$$anon$1: 1,
  s_concurrent_duration_Duration$Infinite: 1,
  s_concurrent_duration_Duration: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  s_math_Ordered: 1,
  jl_Comparable: 1
});
$c_s_concurrent_duration_Duration$$anon$1.prototype.$classData = $d_s_concurrent_duration_Duration$$anon$1;
/** @constructor */
function $c_s_concurrent_duration_Duration$$anon$2() {
  /*<skip>*/
}
$c_s_concurrent_duration_Duration$$anon$2.prototype = new $h_s_concurrent_duration_Duration$Infinite();
$c_s_concurrent_duration_Duration$$anon$2.prototype.constructor = $c_s_concurrent_duration_Duration$$anon$2;
/** @constructor */
function $h_s_concurrent_duration_Duration$$anon$2() {
  /*<skip>*/
}
$h_s_concurrent_duration_Duration$$anon$2.prototype = $c_s_concurrent_duration_Duration$$anon$2.prototype;
$c_s_concurrent_duration_Duration$$anon$2.prototype.toString__T = (function() {
  return "Duration.Inf"
});
$c_s_concurrent_duration_Duration$$anon$2.prototype.compare__s_concurrent_duration_Duration__I = (function(other) {
  return ((other === $m_s_concurrent_duration_Duration$().s_concurrent_duration_Duration$__f_Undefined) ? (-1) : ((other === this) ? 0 : 1))
});
$c_s_concurrent_duration_Duration$$anon$2.prototype.compare__O__I = (function(that) {
  return this.compare__s_concurrent_duration_Duration__I($as_s_concurrent_duration_Duration(that))
});
var $d_s_concurrent_duration_Duration$$anon$2 = new $TypeData().initClass({
  s_concurrent_duration_Duration$$anon$2: 0
}, false, "scala.concurrent.duration.Duration$$anon$2", {
  s_concurrent_duration_Duration$$anon$2: 1,
  s_concurrent_duration_Duration$Infinite: 1,
  s_concurrent_duration_Duration: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  s_math_Ordered: 1,
  jl_Comparable: 1
});
$c_s_concurrent_duration_Duration$$anon$2.prototype.$classData = $d_s_concurrent_duration_Duration$$anon$2;
/** @constructor */
function $c_s_concurrent_duration_Duration$$anon$3() {
  /*<skip>*/
}
$c_s_concurrent_duration_Duration$$anon$3.prototype = new $h_s_concurrent_duration_Duration$Infinite();
$c_s_concurrent_duration_Duration$$anon$3.prototype.constructor = $c_s_concurrent_duration_Duration$$anon$3;
/** @constructor */
function $h_s_concurrent_duration_Duration$$anon$3() {
  /*<skip>*/
}
$h_s_concurrent_duration_Duration$$anon$3.prototype = $c_s_concurrent_duration_Duration$$anon$3.prototype;
$c_s_concurrent_duration_Duration$$anon$3.prototype.toString__T = (function() {
  return "Duration.MinusInf"
});
$c_s_concurrent_duration_Duration$$anon$3.prototype.compare__s_concurrent_duration_Duration__I = (function(other) {
  return ((other === this) ? 0 : (-1))
});
$c_s_concurrent_duration_Duration$$anon$3.prototype.compare__O__I = (function(that) {
  return this.compare__s_concurrent_duration_Duration__I($as_s_concurrent_duration_Duration(that))
});
var $d_s_concurrent_duration_Duration$$anon$3 = new $TypeData().initClass({
  s_concurrent_duration_Duration$$anon$3: 0
}, false, "scala.concurrent.duration.Duration$$anon$3", {
  s_concurrent_duration_Duration$$anon$3: 1,
  s_concurrent_duration_Duration$Infinite: 1,
  s_concurrent_duration_Duration: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  s_math_Ordered: 1,
  jl_Comparable: 1
});
$c_s_concurrent_duration_Duration$$anon$3.prototype.$classData = $d_s_concurrent_duration_Duration$$anon$3;
/** @constructor */
function $c_s_reflect_ClassTag$GenericClassTag(runtimeClass) {
  this.s_reflect_ClassTag$GenericClassTag__f_runtimeClass = null;
  this.s_reflect_ClassTag$GenericClassTag__f_runtimeClass = runtimeClass
}
$c_s_reflect_ClassTag$GenericClassTag.prototype = new $h_O();
$c_s_reflect_ClassTag$GenericClassTag.prototype.constructor = $c_s_reflect_ClassTag$GenericClassTag;
/** @constructor */
function $h_s_reflect_ClassTag$GenericClassTag() {
  /*<skip>*/
}
$h_s_reflect_ClassTag$GenericClassTag.prototype = $c_s_reflect_ClassTag$GenericClassTag.prototype;
$c_s_reflect_ClassTag$GenericClassTag.prototype.equals__O__Z = (function(x) {
  return $f_s_reflect_ClassTag__equals__O__Z(this, x)
});
$c_s_reflect_ClassTag$GenericClassTag.prototype.hashCode__I = (function() {
  var x = this.s_reflect_ClassTag$GenericClassTag__f_runtimeClass;
  return $m_sr_Statics$().anyHash__O__I(x)
});
$c_s_reflect_ClassTag$GenericClassTag.prototype.toString__T = (function() {
  return $p_s_reflect_ClassTag__prettyprint$1__jl_Class__T(this, this.s_reflect_ClassTag$GenericClassTag__f_runtimeClass)
});
$c_s_reflect_ClassTag$GenericClassTag.prototype.runtimeClass__jl_Class = (function() {
  return this.s_reflect_ClassTag$GenericClassTag__f_runtimeClass
});
$c_s_reflect_ClassTag$GenericClassTag.prototype.newArray__I__O = (function(len) {
  var componentType = this.s_reflect_ClassTag$GenericClassTag__f_runtimeClass;
  return $m_jl_reflect_Array$().newInstance__jl_Class__I__O(componentType, len)
});
var $d_s_reflect_ClassTag$GenericClassTag = new $TypeData().initClass({
  s_reflect_ClassTag$GenericClassTag: 0
}, false, "scala.reflect.ClassTag$GenericClassTag", {
  s_reflect_ClassTag$GenericClassTag: 1,
  O: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
});
$c_s_reflect_ClassTag$GenericClassTag.prototype.$classData = $d_s_reflect_ClassTag$GenericClassTag;
/** @constructor */
function $c_Lshowcase_app_task_DemoTaskActions$FailingApiAction(task) {
  this.Lshowcase_app_task_DemoTaskActions$FailingApiAction__f_task = null;
  this.Lshowcase_app_task_DemoTaskActions$FailingApiAction__f_task = task
}
$c_Lshowcase_app_task_DemoTaskActions$FailingApiAction.prototype = new $h_O();
$c_Lshowcase_app_task_DemoTaskActions$FailingApiAction.prototype.constructor = $c_Lshowcase_app_task_DemoTaskActions$FailingApiAction;
/** @constructor */
function $h_Lshowcase_app_task_DemoTaskActions$FailingApiAction() {
  /*<skip>*/
}
$h_Lshowcase_app_task_DemoTaskActions$FailingApiAction.prototype = $c_Lshowcase_app_task_DemoTaskActions$FailingApiAction.prototype;
$c_Lshowcase_app_task_DemoTaskActions$FailingApiAction.prototype.task__Lscommons_react_redux_task_FutureTask = (function() {
  return this.Lshowcase_app_task_DemoTaskActions$FailingApiAction__f_task
});
$c_Lshowcase_app_task_DemoTaskActions$FailingApiAction.prototype.productPrefix__T = (function() {
  return "FailingApiAction"
});
$c_Lshowcase_app_task_DemoTaskActions$FailingApiAction.prototype.productArity__I = (function() {
  return 1
});
$c_Lshowcase_app_task_DemoTaskActions$FailingApiAction.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lshowcase_app_task_DemoTaskActions$FailingApiAction__f_task : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lshowcase_app_task_DemoTaskActions$FailingApiAction.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lshowcase_app_task_DemoTaskActions$FailingApiAction.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lshowcase_app_task_DemoTaskActions$FailingApiAction.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lshowcase_app_task_DemoTaskActions$FailingApiAction.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lshowcase_app_task_DemoTaskActions$FailingApiAction)) {
    var FailingApiAction$1 = $as_Lshowcase_app_task_DemoTaskActions$FailingApiAction(x$1);
    var x = this.Lshowcase_app_task_DemoTaskActions$FailingApiAction__f_task;
    var x$2 = FailingApiAction$1.Lshowcase_app_task_DemoTaskActions$FailingApiAction__f_task;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lshowcase_app_task_DemoTaskActions$FailingApiAction(obj) {
  return (((obj instanceof $c_Lshowcase_app_task_DemoTaskActions$FailingApiAction) || (obj === null)) ? obj : $throwClassCastException(obj, "showcase.app.task.DemoTaskActions$FailingApiAction"))
}
function $isArrayOf_Lshowcase_app_task_DemoTaskActions$FailingApiAction(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lshowcase_app_task_DemoTaskActions$FailingApiAction)))
}
function $asArrayOf_Lshowcase_app_task_DemoTaskActions$FailingApiAction(obj, depth) {
  return (($isArrayOf_Lshowcase_app_task_DemoTaskActions$FailingApiAction(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lshowcase.app.task.DemoTaskActions$FailingApiAction;", depth))
}
var $d_Lshowcase_app_task_DemoTaskActions$FailingApiAction = new $TypeData().initClass({
  Lshowcase_app_task_DemoTaskActions$FailingApiAction: 0
}, false, "showcase.app.task.DemoTaskActions$FailingApiAction", {
  Lshowcase_app_task_DemoTaskActions$FailingApiAction: 1,
  O: 1,
  Lscommons_react_redux_task_TaskAction: 1,
  Lio_github_shogowada_scalajs_reactjs_redux_Action: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lshowcase_app_task_DemoTaskActions$FailingApiAction.prototype.$classData = $d_Lshowcase_app_task_DemoTaskActions$FailingApiAction;
/** @constructor */
function $c_Lshowcase_app_task_DemoTaskActions$SuccessfulFetchAction(task) {
  this.Lshowcase_app_task_DemoTaskActions$SuccessfulFetchAction__f_task = null;
  this.Lshowcase_app_task_DemoTaskActions$SuccessfulFetchAction__f_task = task
}
$c_Lshowcase_app_task_DemoTaskActions$SuccessfulFetchAction.prototype = new $h_O();
$c_Lshowcase_app_task_DemoTaskActions$SuccessfulFetchAction.prototype.constructor = $c_Lshowcase_app_task_DemoTaskActions$SuccessfulFetchAction;
/** @constructor */
function $h_Lshowcase_app_task_DemoTaskActions$SuccessfulFetchAction() {
  /*<skip>*/
}
$h_Lshowcase_app_task_DemoTaskActions$SuccessfulFetchAction.prototype = $c_Lshowcase_app_task_DemoTaskActions$SuccessfulFetchAction.prototype;
$c_Lshowcase_app_task_DemoTaskActions$SuccessfulFetchAction.prototype.task__Lscommons_react_redux_task_FutureTask = (function() {
  return this.Lshowcase_app_task_DemoTaskActions$SuccessfulFetchAction__f_task
});
$c_Lshowcase_app_task_DemoTaskActions$SuccessfulFetchAction.prototype.productPrefix__T = (function() {
  return "SuccessfulFetchAction"
});
$c_Lshowcase_app_task_DemoTaskActions$SuccessfulFetchAction.prototype.productArity__I = (function() {
  return 1
});
$c_Lshowcase_app_task_DemoTaskActions$SuccessfulFetchAction.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.Lshowcase_app_task_DemoTaskActions$SuccessfulFetchAction__f_task : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_Lshowcase_app_task_DemoTaskActions$SuccessfulFetchAction.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_Lshowcase_app_task_DemoTaskActions$SuccessfulFetchAction.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lshowcase_app_task_DemoTaskActions$SuccessfulFetchAction.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lshowcase_app_task_DemoTaskActions$SuccessfulFetchAction.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_Lshowcase_app_task_DemoTaskActions$SuccessfulFetchAction)) {
    var SuccessfulFetchAction$1 = $as_Lshowcase_app_task_DemoTaskActions$SuccessfulFetchAction(x$1);
    var x = this.Lshowcase_app_task_DemoTaskActions$SuccessfulFetchAction__f_task;
    var x$2 = SuccessfulFetchAction$1.Lshowcase_app_task_DemoTaskActions$SuccessfulFetchAction__f_task;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_Lshowcase_app_task_DemoTaskActions$SuccessfulFetchAction(obj) {
  return (((obj instanceof $c_Lshowcase_app_task_DemoTaskActions$SuccessfulFetchAction) || (obj === null)) ? obj : $throwClassCastException(obj, "showcase.app.task.DemoTaskActions$SuccessfulFetchAction"))
}
function $isArrayOf_Lshowcase_app_task_DemoTaskActions$SuccessfulFetchAction(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lshowcase_app_task_DemoTaskActions$SuccessfulFetchAction)))
}
function $asArrayOf_Lshowcase_app_task_DemoTaskActions$SuccessfulFetchAction(obj, depth) {
  return (($isArrayOf_Lshowcase_app_task_DemoTaskActions$SuccessfulFetchAction(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lshowcase.app.task.DemoTaskActions$SuccessfulFetchAction;", depth))
}
var $d_Lshowcase_app_task_DemoTaskActions$SuccessfulFetchAction = new $TypeData().initClass({
  Lshowcase_app_task_DemoTaskActions$SuccessfulFetchAction: 0
}, false, "showcase.app.task.DemoTaskActions$SuccessfulFetchAction", {
  Lshowcase_app_task_DemoTaskActions$SuccessfulFetchAction: 1,
  O: 1,
  Lscommons_react_redux_task_TaskAction: 1,
  Lio_github_shogowada_scalajs_reactjs_redux_Action: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lshowcase_app_task_DemoTaskActions$SuccessfulFetchAction.prototype.$classData = $d_Lshowcase_app_task_DemoTaskActions$SuccessfulFetchAction;
function $ct_Ljava_io_PrintStream__Ljava_io_OutputStream__Z__Ljava_nio_charset_Charset__($thiz, _out, autoFlush, charset) {
  $thiz.Ljava_io_PrintStream__f_autoFlush = autoFlush;
  $thiz.Ljava_io_PrintStream__f_charset = charset;
  $ct_Ljava_io_FilterOutputStream__Ljava_io_OutputStream__($thiz, _out);
  $thiz.Ljava_io_PrintStream__f_closing = false;
  $thiz.Ljava_io_PrintStream__f_java$io$PrintStream$$closed = false;
  $thiz.Ljava_io_PrintStream__f_errorFlag = false;
  return $thiz
}
/** @constructor */
function $c_Ljava_io_PrintStream() {
  this.Ljava_io_FilterOutputStream__f_out = null;
  this.Ljava_io_PrintStream__f_encoder = null;
  this.Ljava_io_PrintStream__f_autoFlush = false;
  this.Ljava_io_PrintStream__f_charset = null;
  this.Ljava_io_PrintStream__f_closing = false;
  this.Ljava_io_PrintStream__f_java$io$PrintStream$$closed = false;
  this.Ljava_io_PrintStream__f_errorFlag = false;
  this.Ljava_io_PrintStream__f_bitmap$0 = false
}
$c_Ljava_io_PrintStream.prototype = new $h_Ljava_io_FilterOutputStream();
$c_Ljava_io_PrintStream.prototype.constructor = $c_Ljava_io_PrintStream;
/** @constructor */
function $h_Ljava_io_PrintStream() {
  /*<skip>*/
}
$h_Ljava_io_PrintStream.prototype = $c_Ljava_io_PrintStream.prototype;
$c_Ljava_io_PrintStream.prototype.println__T__V = (function(s) {
  this.print__T__V(s);
  this.java$lang$JSConsoleBasedPrintStream$$printString__T__V("\n")
});
$c_Ljava_io_PrintStream.prototype.append__jl_CharSequence__Ljava_io_PrintStream = (function(csq) {
  this.print__T__V(((csq === null) ? "null" : $dp_toString__T(csq)));
  return this
});
$c_Ljava_io_PrintStream.prototype.append__jl_CharSequence__jl_Appendable = (function(x$1) {
  return this.append__jl_CharSequence__Ljava_io_PrintStream(x$1)
});
function $as_Ljava_io_PrintStream(obj) {
  return (((obj instanceof $c_Ljava_io_PrintStream) || (obj === null)) ? obj : $throwClassCastException(obj, "java.io.PrintStream"))
}
function $isArrayOf_Ljava_io_PrintStream(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_io_PrintStream)))
}
function $asArrayOf_Ljava_io_PrintStream(obj, depth) {
  return (($isArrayOf_Ljava_io_PrintStream(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.io.PrintStream;", depth))
}
/** @constructor */
function $c_Ljava_nio_StringCharBuffer(_capacity, _csq, _csqOffset, _initialPosition, _initialLimit) {
  this.Ljava_nio_Buffer__f__capacity = 0;
  this.Ljava_nio_Buffer__f__limit = 0;
  this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position = 0;
  this.Ljava_nio_Buffer__f__mark = 0;
  this.Ljava_nio_CharBuffer__f__array = null;
  this.Ljava_nio_CharBuffer__f__arrayOffset = 0;
  this.Ljava_nio_StringCharBuffer__f_java$nio$StringCharBuffer$$_csq = null;
  this.Ljava_nio_StringCharBuffer__f_java$nio$StringCharBuffer$$_csqOffset = 0;
  this.Ljava_nio_StringCharBuffer__f_java$nio$StringCharBuffer$$_csq = _csq;
  this.Ljava_nio_StringCharBuffer__f_java$nio$StringCharBuffer$$_csqOffset = _csqOffset;
  $ct_Ljava_nio_CharBuffer__I__AC__I__(this, _capacity, null, (-1));
  $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(this, _initialPosition);
  $c_Ljava_nio_Buffer.prototype.limit__I__Ljava_nio_Buffer.call(this, _initialLimit)
}
$c_Ljava_nio_StringCharBuffer.prototype = new $h_Ljava_nio_CharBuffer();
$c_Ljava_nio_StringCharBuffer.prototype.constructor = $c_Ljava_nio_StringCharBuffer;
/** @constructor */
function $h_Ljava_nio_StringCharBuffer() {
  /*<skip>*/
}
$h_Ljava_nio_StringCharBuffer.prototype = $c_Ljava_nio_StringCharBuffer.prototype;
$c_Ljava_nio_StringCharBuffer.prototype.subSequence__I__I__Ljava_nio_CharBuffer = (function(start, end) {
  if ((((start < 0) || (end < start)) || (end > ((this.Ljava_nio_Buffer__f__limit - this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0)))) {
    throw $ct_jl_IndexOutOfBoundsException__(new $c_jl_IndexOutOfBoundsException())
  };
  return new $c_Ljava_nio_StringCharBuffer(this.Ljava_nio_Buffer__f__capacity, this.Ljava_nio_StringCharBuffer__f_java$nio$StringCharBuffer$$_csq, this.Ljava_nio_StringCharBuffer__f_java$nio$StringCharBuffer$$_csqOffset, ((this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position + start) | 0), ((this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position + end) | 0))
});
$c_Ljava_nio_StringCharBuffer.prototype.get__C = (function() {
  var p = this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position;
  if ((p === this.Ljava_nio_Buffer__f__limit)) {
    throw new $c_Ljava_nio_BufferUnderflowException()
  };
  this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position = ((1 + p) | 0);
  return $dp_charAt__I__C(this.Ljava_nio_StringCharBuffer__f_java$nio$StringCharBuffer$$_csq, ((this.Ljava_nio_StringCharBuffer__f_java$nio$StringCharBuffer$$_csqOffset + p) | 0))
});
$c_Ljava_nio_StringCharBuffer.prototype.get__I__C = (function(index) {
  if (((index < 0) || (index >= this.Ljava_nio_Buffer__f__limit))) {
    throw $ct_jl_IndexOutOfBoundsException__(new $c_jl_IndexOutOfBoundsException())
  };
  return $dp_charAt__I__C(this.Ljava_nio_StringCharBuffer__f_java$nio$StringCharBuffer$$_csq, ((this.Ljava_nio_StringCharBuffer__f_java$nio$StringCharBuffer$$_csqOffset + index) | 0))
});
$c_Ljava_nio_StringCharBuffer.prototype.toString__T = (function() {
  var offset = this.Ljava_nio_StringCharBuffer__f_java$nio$StringCharBuffer$$_csqOffset;
  return $dp_toString__T($dp_subSequence__I__I__jl_CharSequence(this.Ljava_nio_StringCharBuffer__f_java$nio$StringCharBuffer$$_csq, ((this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position + offset) | 0), ((this.Ljava_nio_Buffer__f__limit + offset) | 0)))
});
$c_Ljava_nio_StringCharBuffer.prototype.subSequence__I__I__jl_CharSequence = (function(start, end) {
  return this.subSequence__I__I__Ljava_nio_CharBuffer(start, end)
});
var $d_Ljava_nio_StringCharBuffer = new $TypeData().initClass({
  Ljava_nio_StringCharBuffer: 0
}, false, "java.nio.StringCharBuffer", {
  Ljava_nio_StringCharBuffer: 1,
  Ljava_nio_CharBuffer: 1,
  Ljava_nio_Buffer: 1,
  O: 1,
  jl_Comparable: 1,
  jl_CharSequence: 1,
  jl_Appendable: 1,
  jl_Readable: 1
});
$c_Ljava_nio_StringCharBuffer.prototype.$classData = $d_Ljava_nio_StringCharBuffer;
/** @constructor */
function $c_ju_DuplicateFormatFlagsException(f) {
  this.jl_Throwable__f_s = null;
  this.jl_Throwable__f_e = null;
  this.jl_Throwable__f_enableSuppression = false;
  this.jl_Throwable__f_writableStackTrace = false;
  this.jl_Throwable__f_stackTraceStateInternal = null;
  this.jl_Throwable__f_stackTrace = null;
  this.jl_Throwable__f_suppressed = null;
  this.ju_DuplicateFormatFlagsException__f_f = null;
  this.ju_DuplicateFormatFlagsException__f_f = f;
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  if ((f === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  }
}
$c_ju_DuplicateFormatFlagsException.prototype = new $h_ju_IllegalFormatException();
$c_ju_DuplicateFormatFlagsException.prototype.constructor = $c_ju_DuplicateFormatFlagsException;
/** @constructor */
function $h_ju_DuplicateFormatFlagsException() {
  /*<skip>*/
}
$h_ju_DuplicateFormatFlagsException.prototype = $c_ju_DuplicateFormatFlagsException.prototype;
$c_ju_DuplicateFormatFlagsException.prototype.getMessage__T = (function() {
  return (("Flags = '" + this.ju_DuplicateFormatFlagsException__f_f) + "'")
});
var $d_ju_DuplicateFormatFlagsException = new $TypeData().initClass({
  ju_DuplicateFormatFlagsException: 0
}, false, "java.util.DuplicateFormatFlagsException", {
  ju_DuplicateFormatFlagsException: 1,
  ju_IllegalFormatException: 1,
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_ju_DuplicateFormatFlagsException.prototype.$classData = $d_ju_DuplicateFormatFlagsException;
/** @constructor */
function $c_ju_FormatFlagsConversionMismatchException(f, c) {
  this.jl_Throwable__f_s = null;
  this.jl_Throwable__f_e = null;
  this.jl_Throwable__f_enableSuppression = false;
  this.jl_Throwable__f_writableStackTrace = false;
  this.jl_Throwable__f_stackTraceStateInternal = null;
  this.jl_Throwable__f_stackTrace = null;
  this.jl_Throwable__f_suppressed = null;
  this.ju_FormatFlagsConversionMismatchException__f_f = null;
  this.ju_FormatFlagsConversionMismatchException__f_c = 0;
  this.ju_FormatFlagsConversionMismatchException__f_f = f;
  this.ju_FormatFlagsConversionMismatchException__f_c = c;
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  if ((f === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  }
}
$c_ju_FormatFlagsConversionMismatchException.prototype = new $h_ju_IllegalFormatException();
$c_ju_FormatFlagsConversionMismatchException.prototype.constructor = $c_ju_FormatFlagsConversionMismatchException;
/** @constructor */
function $h_ju_FormatFlagsConversionMismatchException() {
  /*<skip>*/
}
$h_ju_FormatFlagsConversionMismatchException.prototype = $c_ju_FormatFlagsConversionMismatchException.prototype;
$c_ju_FormatFlagsConversionMismatchException.prototype.getMessage__T = (function() {
  return ((("Conversion = " + $bC(this.ju_FormatFlagsConversionMismatchException__f_c)) + ", Flags = ") + this.ju_FormatFlagsConversionMismatchException__f_f)
});
var $d_ju_FormatFlagsConversionMismatchException = new $TypeData().initClass({
  ju_FormatFlagsConversionMismatchException: 0
}, false, "java.util.FormatFlagsConversionMismatchException", {
  ju_FormatFlagsConversionMismatchException: 1,
  ju_IllegalFormatException: 1,
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_ju_FormatFlagsConversionMismatchException.prototype.$classData = $d_ju_FormatFlagsConversionMismatchException;
/** @constructor */
function $c_ju_IllegalFormatCodePointException(c) {
  this.jl_Throwable__f_s = null;
  this.jl_Throwable__f_e = null;
  this.jl_Throwable__f_enableSuppression = false;
  this.jl_Throwable__f_writableStackTrace = false;
  this.jl_Throwable__f_stackTraceStateInternal = null;
  this.jl_Throwable__f_stackTrace = null;
  this.jl_Throwable__f_suppressed = null;
  this.ju_IllegalFormatCodePointException__f_c = 0;
  this.ju_IllegalFormatCodePointException__f_c = c;
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true)
}
$c_ju_IllegalFormatCodePointException.prototype = new $h_ju_IllegalFormatException();
$c_ju_IllegalFormatCodePointException.prototype.constructor = $c_ju_IllegalFormatCodePointException;
/** @constructor */
function $h_ju_IllegalFormatCodePointException() {
  /*<skip>*/
}
$h_ju_IllegalFormatCodePointException.prototype = $c_ju_IllegalFormatCodePointException.prototype;
$c_ju_IllegalFormatCodePointException.prototype.getMessage__T = (function() {
  var i = this.ju_IllegalFormatCodePointException__f_c;
  return ("Code point = 0x" + $as_T($uD((i >>> 0)).toString(16)))
});
var $d_ju_IllegalFormatCodePointException = new $TypeData().initClass({
  ju_IllegalFormatCodePointException: 0
}, false, "java.util.IllegalFormatCodePointException", {
  ju_IllegalFormatCodePointException: 1,
  ju_IllegalFormatException: 1,
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_ju_IllegalFormatCodePointException.prototype.$classData = $d_ju_IllegalFormatCodePointException;
/** @constructor */
function $c_ju_IllegalFormatConversionException(c, arg) {
  this.jl_Throwable__f_s = null;
  this.jl_Throwable__f_e = null;
  this.jl_Throwable__f_enableSuppression = false;
  this.jl_Throwable__f_writableStackTrace = false;
  this.jl_Throwable__f_stackTraceStateInternal = null;
  this.jl_Throwable__f_stackTrace = null;
  this.jl_Throwable__f_suppressed = null;
  this.ju_IllegalFormatConversionException__f_c = 0;
  this.ju_IllegalFormatConversionException__f_arg = null;
  this.ju_IllegalFormatConversionException__f_c = c;
  this.ju_IllegalFormatConversionException__f_arg = arg;
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  if ((arg === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  }
}
$c_ju_IllegalFormatConversionException.prototype = new $h_ju_IllegalFormatException();
$c_ju_IllegalFormatConversionException.prototype.constructor = $c_ju_IllegalFormatConversionException;
/** @constructor */
function $h_ju_IllegalFormatConversionException() {
  /*<skip>*/
}
$h_ju_IllegalFormatConversionException.prototype = $c_ju_IllegalFormatConversionException.prototype;
$c_ju_IllegalFormatConversionException.prototype.getMessage__T = (function() {
  var this$1 = this.ju_IllegalFormatConversionException__f_c;
  return (($as_T(String.fromCharCode(this$1)) + " != ") + this.ju_IllegalFormatConversionException__f_arg.getName__T())
});
var $d_ju_IllegalFormatConversionException = new $TypeData().initClass({
  ju_IllegalFormatConversionException: 0
}, false, "java.util.IllegalFormatConversionException", {
  ju_IllegalFormatConversionException: 1,
  ju_IllegalFormatException: 1,
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_ju_IllegalFormatConversionException.prototype.$classData = $d_ju_IllegalFormatConversionException;
/** @constructor */
function $c_ju_IllegalFormatFlagsException(f) {
  this.jl_Throwable__f_s = null;
  this.jl_Throwable__f_e = null;
  this.jl_Throwable__f_enableSuppression = false;
  this.jl_Throwable__f_writableStackTrace = false;
  this.jl_Throwable__f_stackTraceStateInternal = null;
  this.jl_Throwable__f_stackTrace = null;
  this.jl_Throwable__f_suppressed = null;
  this.ju_IllegalFormatFlagsException__f_f = null;
  this.ju_IllegalFormatFlagsException__f_f = f;
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  if ((f === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  }
}
$c_ju_IllegalFormatFlagsException.prototype = new $h_ju_IllegalFormatException();
$c_ju_IllegalFormatFlagsException.prototype.constructor = $c_ju_IllegalFormatFlagsException;
/** @constructor */
function $h_ju_IllegalFormatFlagsException() {
  /*<skip>*/
}
$h_ju_IllegalFormatFlagsException.prototype = $c_ju_IllegalFormatFlagsException.prototype;
$c_ju_IllegalFormatFlagsException.prototype.getMessage__T = (function() {
  return (("Flags = '" + this.ju_IllegalFormatFlagsException__f_f) + "'")
});
var $d_ju_IllegalFormatFlagsException = new $TypeData().initClass({
  ju_IllegalFormatFlagsException: 0
}, false, "java.util.IllegalFormatFlagsException", {
  ju_IllegalFormatFlagsException: 1,
  ju_IllegalFormatException: 1,
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_ju_IllegalFormatFlagsException.prototype.$classData = $d_ju_IllegalFormatFlagsException;
/** @constructor */
function $c_ju_IllegalFormatPrecisionException(p) {
  this.jl_Throwable__f_s = null;
  this.jl_Throwable__f_e = null;
  this.jl_Throwable__f_enableSuppression = false;
  this.jl_Throwable__f_writableStackTrace = false;
  this.jl_Throwable__f_stackTraceStateInternal = null;
  this.jl_Throwable__f_stackTrace = null;
  this.jl_Throwable__f_suppressed = null;
  this.ju_IllegalFormatPrecisionException__f_p = 0;
  this.ju_IllegalFormatPrecisionException__f_p = p;
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true)
}
$c_ju_IllegalFormatPrecisionException.prototype = new $h_ju_IllegalFormatException();
$c_ju_IllegalFormatPrecisionException.prototype.constructor = $c_ju_IllegalFormatPrecisionException;
/** @constructor */
function $h_ju_IllegalFormatPrecisionException() {
  /*<skip>*/
}
$h_ju_IllegalFormatPrecisionException.prototype = $c_ju_IllegalFormatPrecisionException.prototype;
$c_ju_IllegalFormatPrecisionException.prototype.getMessage__T = (function() {
  var i = this.ju_IllegalFormatPrecisionException__f_p;
  return ("" + i)
});
var $d_ju_IllegalFormatPrecisionException = new $TypeData().initClass({
  ju_IllegalFormatPrecisionException: 0
}, false, "java.util.IllegalFormatPrecisionException", {
  ju_IllegalFormatPrecisionException: 1,
  ju_IllegalFormatException: 1,
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_ju_IllegalFormatPrecisionException.prototype.$classData = $d_ju_IllegalFormatPrecisionException;
/** @constructor */
function $c_ju_IllegalFormatWidthException(w) {
  this.jl_Throwable__f_s = null;
  this.jl_Throwable__f_e = null;
  this.jl_Throwable__f_enableSuppression = false;
  this.jl_Throwable__f_writableStackTrace = false;
  this.jl_Throwable__f_stackTraceStateInternal = null;
  this.jl_Throwable__f_stackTrace = null;
  this.jl_Throwable__f_suppressed = null;
  this.ju_IllegalFormatWidthException__f_w = 0;
  this.ju_IllegalFormatWidthException__f_w = w;
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true)
}
$c_ju_IllegalFormatWidthException.prototype = new $h_ju_IllegalFormatException();
$c_ju_IllegalFormatWidthException.prototype.constructor = $c_ju_IllegalFormatWidthException;
/** @constructor */
function $h_ju_IllegalFormatWidthException() {
  /*<skip>*/
}
$h_ju_IllegalFormatWidthException.prototype = $c_ju_IllegalFormatWidthException.prototype;
$c_ju_IllegalFormatWidthException.prototype.getMessage__T = (function() {
  var i = this.ju_IllegalFormatWidthException__f_w;
  return ("" + i)
});
var $d_ju_IllegalFormatWidthException = new $TypeData().initClass({
  ju_IllegalFormatWidthException: 0
}, false, "java.util.IllegalFormatWidthException", {
  ju_IllegalFormatWidthException: 1,
  ju_IllegalFormatException: 1,
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_ju_IllegalFormatWidthException.prototype.$classData = $d_ju_IllegalFormatWidthException;
/** @constructor */
function $c_ju_MissingFormatArgumentException(s) {
  this.jl_Throwable__f_s = null;
  this.jl_Throwable__f_e = null;
  this.jl_Throwable__f_enableSuppression = false;
  this.jl_Throwable__f_writableStackTrace = false;
  this.jl_Throwable__f_stackTraceStateInternal = null;
  this.jl_Throwable__f_stackTrace = null;
  this.jl_Throwable__f_suppressed = null;
  this.ju_MissingFormatArgumentException__f_s = null;
  this.ju_MissingFormatArgumentException__f_s = s;
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  if ((s === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  }
}
$c_ju_MissingFormatArgumentException.prototype = new $h_ju_IllegalFormatException();
$c_ju_MissingFormatArgumentException.prototype.constructor = $c_ju_MissingFormatArgumentException;
/** @constructor */
function $h_ju_MissingFormatArgumentException() {
  /*<skip>*/
}
$h_ju_MissingFormatArgumentException.prototype = $c_ju_MissingFormatArgumentException.prototype;
$c_ju_MissingFormatArgumentException.prototype.getMessage__T = (function() {
  return (("Format specifier '" + this.ju_MissingFormatArgumentException__f_s) + "'")
});
var $d_ju_MissingFormatArgumentException = new $TypeData().initClass({
  ju_MissingFormatArgumentException: 0
}, false, "java.util.MissingFormatArgumentException", {
  ju_MissingFormatArgumentException: 1,
  ju_IllegalFormatException: 1,
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_ju_MissingFormatArgumentException.prototype.$classData = $d_ju_MissingFormatArgumentException;
/** @constructor */
function $c_ju_MissingFormatWidthException(s) {
  this.jl_Throwable__f_s = null;
  this.jl_Throwable__f_e = null;
  this.jl_Throwable__f_enableSuppression = false;
  this.jl_Throwable__f_writableStackTrace = false;
  this.jl_Throwable__f_stackTraceStateInternal = null;
  this.jl_Throwable__f_stackTrace = null;
  this.jl_Throwable__f_suppressed = null;
  this.ju_MissingFormatWidthException__f_s = null;
  this.ju_MissingFormatWidthException__f_s = s;
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  if ((s === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  }
}
$c_ju_MissingFormatWidthException.prototype = new $h_ju_IllegalFormatException();
$c_ju_MissingFormatWidthException.prototype.constructor = $c_ju_MissingFormatWidthException;
/** @constructor */
function $h_ju_MissingFormatWidthException() {
  /*<skip>*/
}
$h_ju_MissingFormatWidthException.prototype = $c_ju_MissingFormatWidthException.prototype;
$c_ju_MissingFormatWidthException.prototype.getMessage__T = (function() {
  return this.ju_MissingFormatWidthException__f_s
});
var $d_ju_MissingFormatWidthException = new $TypeData().initClass({
  ju_MissingFormatWidthException: 0
}, false, "java.util.MissingFormatWidthException", {
  ju_MissingFormatWidthException: 1,
  ju_IllegalFormatException: 1,
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_ju_MissingFormatWidthException.prototype.$classData = $d_ju_MissingFormatWidthException;
/** @constructor */
function $c_ju_UnknownFormatConversionException(s) {
  this.jl_Throwable__f_s = null;
  this.jl_Throwable__f_e = null;
  this.jl_Throwable__f_enableSuppression = false;
  this.jl_Throwable__f_writableStackTrace = false;
  this.jl_Throwable__f_stackTraceStateInternal = null;
  this.jl_Throwable__f_stackTrace = null;
  this.jl_Throwable__f_suppressed = null;
  this.ju_UnknownFormatConversionException__f_s = null;
  this.ju_UnknownFormatConversionException__f_s = s;
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  if ((s === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  }
}
$c_ju_UnknownFormatConversionException.prototype = new $h_ju_IllegalFormatException();
$c_ju_UnknownFormatConversionException.prototype.constructor = $c_ju_UnknownFormatConversionException;
/** @constructor */
function $h_ju_UnknownFormatConversionException() {
  /*<skip>*/
}
$h_ju_UnknownFormatConversionException.prototype = $c_ju_UnknownFormatConversionException.prototype;
$c_ju_UnknownFormatConversionException.prototype.getMessage__T = (function() {
  return (("Conversion = '" + this.ju_UnknownFormatConversionException__f_s) + "'")
});
var $d_ju_UnknownFormatConversionException = new $TypeData().initClass({
  ju_UnknownFormatConversionException: 0
}, false, "java.util.UnknownFormatConversionException", {
  ju_UnknownFormatConversionException: 1,
  ju_IllegalFormatException: 1,
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_ju_UnknownFormatConversionException.prototype.$classData = $d_ju_UnknownFormatConversionException;
/** @constructor */
function $c_Lplay_api_libs_json_JsFalse$() {
  this.Lplay_api_libs_json_JsBoolean__f_value = false;
  this.Lplay_api_libs_json_JsBoolean__f_productArity = 0;
  $ct_Lplay_api_libs_json_JsBoolean__Z__(this, false)
}
$c_Lplay_api_libs_json_JsFalse$.prototype = new $h_Lplay_api_libs_json_JsBoolean();
$c_Lplay_api_libs_json_JsFalse$.prototype.constructor = $c_Lplay_api_libs_json_JsFalse$;
/** @constructor */
function $h_Lplay_api_libs_json_JsFalse$() {
  /*<skip>*/
}
$h_Lplay_api_libs_json_JsFalse$.prototype = $c_Lplay_api_libs_json_JsFalse$.prototype;
$c_Lplay_api_libs_json_JsFalse$.prototype.productPrefix__T = (function() {
  return "JsFalse"
});
$c_Lplay_api_libs_json_JsFalse$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
var $d_Lplay_api_libs_json_JsFalse$ = new $TypeData().initClass({
  Lplay_api_libs_json_JsFalse$: 0
}, false, "play.api.libs.json.JsFalse$", {
  Lplay_api_libs_json_JsFalse$: 1,
  Lplay_api_libs_json_JsBoolean: 1,
  O: 1,
  Lplay_api_libs_json_JsValue: 1,
  Lplay_api_libs_json_JsReadable: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lplay_api_libs_json_JsFalse$.prototype.$classData = $d_Lplay_api_libs_json_JsFalse$;
var $n_Lplay_api_libs_json_JsFalse$;
function $m_Lplay_api_libs_json_JsFalse$() {
  if ((!$n_Lplay_api_libs_json_JsFalse$)) {
    $n_Lplay_api_libs_json_JsFalse$ = new $c_Lplay_api_libs_json_JsFalse$()
  };
  return $n_Lplay_api_libs_json_JsFalse$
}
/** @constructor */
function $c_Lplay_api_libs_json_JsTrue$() {
  this.Lplay_api_libs_json_JsBoolean__f_value = false;
  this.Lplay_api_libs_json_JsBoolean__f_productArity = 0;
  $ct_Lplay_api_libs_json_JsBoolean__Z__(this, true)
}
$c_Lplay_api_libs_json_JsTrue$.prototype = new $h_Lplay_api_libs_json_JsBoolean();
$c_Lplay_api_libs_json_JsTrue$.prototype.constructor = $c_Lplay_api_libs_json_JsTrue$;
/** @constructor */
function $h_Lplay_api_libs_json_JsTrue$() {
  /*<skip>*/
}
$h_Lplay_api_libs_json_JsTrue$.prototype = $c_Lplay_api_libs_json_JsTrue$.prototype;
$c_Lplay_api_libs_json_JsTrue$.prototype.productPrefix__T = (function() {
  return "JsTrue"
});
$c_Lplay_api_libs_json_JsTrue$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
var $d_Lplay_api_libs_json_JsTrue$ = new $TypeData().initClass({
  Lplay_api_libs_json_JsTrue$: 0
}, false, "play.api.libs.json.JsTrue$", {
  Lplay_api_libs_json_JsTrue$: 1,
  Lplay_api_libs_json_JsBoolean: 1,
  O: 1,
  Lplay_api_libs_json_JsValue: 1,
  Lplay_api_libs_json_JsReadable: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_Lplay_api_libs_json_JsTrue$.prototype.$classData = $d_Lplay_api_libs_json_JsTrue$;
var $n_Lplay_api_libs_json_JsTrue$;
function $m_Lplay_api_libs_json_JsTrue$() {
  if ((!$n_Lplay_api_libs_json_JsTrue$)) {
    $n_Lplay_api_libs_json_JsTrue$ = new $c_Lplay_api_libs_json_JsTrue$()
  };
  return $n_Lplay_api_libs_json_JsTrue$
}
function $p_Lplay_api_libs_json_Reads$__IntReads$lzycompute$1__V($thiz) {
  if (($m_Lplay_api_libs_json_Reads$().Lplay_api_libs_json_Reads$__f_IntReads$module === null)) {
    $m_Lplay_api_libs_json_Reads$().Lplay_api_libs_json_Reads$__f_IntReads$module = new $c_Lplay_api_libs_json_DefaultReads$IntReads$($thiz)
  }
}
function $p_Lplay_api_libs_json_Reads$__StringReads$lzycompute$1__V($thiz) {
  if (($m_Lplay_api_libs_json_Reads$().Lplay_api_libs_json_Reads$__f_StringReads$module === null)) {
    $m_Lplay_api_libs_json_Reads$().Lplay_api_libs_json_Reads$__f_StringReads$module = new $c_Lplay_api_libs_json_DefaultReads$StringReads$($thiz)
  }
}
/** @constructor */
function $c_Lplay_api_libs_json_Reads$() {
  this.Lplay_api_libs_json_Reads$__f_constraints = null;
  this.Lplay_api_libs_json_Reads$__f_path = null;
  this.Lplay_api_libs_json_Reads$__f_JsObjectReducer = null;
  this.Lplay_api_libs_json_Reads$__f_JsArrayReducer = null;
  this.Lplay_api_libs_json_Reads$__f_IntReads$module = null;
  this.Lplay_api_libs_json_Reads$__f_ShortReads$module = null;
  this.Lplay_api_libs_json_Reads$__f_ByteReads$module = null;
  this.Lplay_api_libs_json_Reads$__f_LongReads$module = null;
  this.Lplay_api_libs_json_Reads$__f_FloatReads$module = null;
  this.Lplay_api_libs_json_Reads$__f_DoubleReads$module = null;
  this.Lplay_api_libs_json_Reads$__f_bigDecReads = null;
  this.Lplay_api_libs_json_Reads$__f_javaBigDecReads = null;
  this.Lplay_api_libs_json_Reads$__f_BigIntReads$module = null;
  this.Lplay_api_libs_json_Reads$__f_BigIntegerReads$module = null;
  this.Lplay_api_libs_json_Reads$__f_BooleanReads$module = null;
  this.Lplay_api_libs_json_Reads$__f_StringReads$module = null;
  this.Lplay_api_libs_json_Reads$__f_JsObjectReads$module = null;
  this.Lplay_api_libs_json_Reads$__f_JsArrayReads$module = null;
  this.Lplay_api_libs_json_Reads$__f_JsValueReads$module = null;
  this.Lplay_api_libs_json_Reads$__f_JsStringReads$module = null;
  this.Lplay_api_libs_json_Reads$__f_JsNumberReads$module = null;
  this.Lplay_api_libs_json_Reads$__f_JsBooleanReads$module = null;
  this.Lplay_api_libs_json_Reads$__f_uriReads = null;
  this.Lplay_api_libs_json_Reads$__f_uuidReads = null;
  $n_Lplay_api_libs_json_Reads$ = this;
  $f_Lplay_api_libs_json_DefaultReads__$init$__V(this);
  this.Lplay_api_libs_json_Reads$__f_constraints = this;
  this.Lplay_api_libs_json_Reads$__f_path = this;
  var f = new $c_sjsr_AnonFunction1((function(this$1) {
    return (function(o$2) {
      var o = $as_Lplay_api_libs_json_JsObject(o$2);
      return o
    })
  })(this));
  var m = $m_Lplay_api_libs_json_Reads$JsObjectMonoid$();
  this.Lplay_api_libs_json_Reads$__f_JsObjectReducer = new $c_Lplay_api_libs_functional_Reducer$$anon$2(f, m);
  var f$1 = new $c_sjsr_AnonFunction1((function(this$2$1) {
    return (function(js$2) {
      var js = $as_Lplay_api_libs_json_JsValue(js$2);
      return new $c_Lplay_api_libs_json_JsArray($m_s_Predef$().wrapRefArray__AO__scm_ArraySeq$ofRef(new ($d_Lplay_api_libs_json_JsValue.getArrayOf().constr)([js])))
    })
  })(this));
  var m$1 = $m_Lplay_api_libs_json_Reads$JsArrayMonoid$();
  this.Lplay_api_libs_json_Reads$__f_JsArrayReducer = new $c_Lplay_api_libs_functional_Reducer$$anon$2(f$1, m$1)
}
$c_Lplay_api_libs_json_Reads$.prototype = new $h_O();
$c_Lplay_api_libs_json_Reads$.prototype.constructor = $c_Lplay_api_libs_json_Reads$;
/** @constructor */
function $h_Lplay_api_libs_json_Reads$() {
  /*<skip>*/
}
$h_Lplay_api_libs_json_Reads$.prototype = $c_Lplay_api_libs_json_Reads$.prototype;
$c_Lplay_api_libs_json_Reads$.prototype.IntReads__Lplay_api_libs_json_DefaultReads$IntReads$ = (function() {
  if (($m_Lplay_api_libs_json_Reads$().Lplay_api_libs_json_Reads$__f_IntReads$module === null)) {
    $p_Lplay_api_libs_json_Reads$__IntReads$lzycompute$1__V(this)
  };
  return $m_Lplay_api_libs_json_Reads$().Lplay_api_libs_json_Reads$__f_IntReads$module
});
$c_Lplay_api_libs_json_Reads$.prototype.StringReads__Lplay_api_libs_json_DefaultReads$StringReads$ = (function() {
  if (($m_Lplay_api_libs_json_Reads$().Lplay_api_libs_json_Reads$__f_StringReads$module === null)) {
    $p_Lplay_api_libs_json_Reads$__StringReads$lzycompute$1__V(this)
  };
  return $m_Lplay_api_libs_json_Reads$().Lplay_api_libs_json_Reads$__f_StringReads$module
});
var $d_Lplay_api_libs_json_Reads$ = new $TypeData().initClass({
  Lplay_api_libs_json_Reads$: 0
}, false, "play.api.libs.json.Reads$", {
  Lplay_api_libs_json_Reads$: 1,
  O: 1,
  Lplay_api_libs_json_ConstraintReads: 1,
  Lplay_api_libs_json_PathReads: 1,
  Lplay_api_libs_json_DefaultReads: 1,
  Lplay_api_libs_json_LowPriorityDefaultReads: 1,
  Lplay_api_libs_json_EnvReads: 1,
  Lplay_api_libs_json_GeneratedReads: 1
});
$c_Lplay_api_libs_json_Reads$.prototype.$classData = $d_Lplay_api_libs_json_Reads$;
var $n_Lplay_api_libs_json_Reads$;
function $m_Lplay_api_libs_json_Reads$() {
  if ((!$n_Lplay_api_libs_json_Reads$)) {
    $n_Lplay_api_libs_json_Reads$ = new $c_Lplay_api_libs_json_Reads$()
  };
  return $n_Lplay_api_libs_json_Reads$
}
function $p_Lplay_api_libs_json_Writes$__IntWrites$lzycompute$1__V($thiz) {
  if (($m_Lplay_api_libs_json_Writes$().Lplay_api_libs_json_Writes$__f_IntWrites$module === null)) {
    $m_Lplay_api_libs_json_Writes$().Lplay_api_libs_json_Writes$__f_IntWrites$module = new $c_Lplay_api_libs_json_DefaultWrites$IntWrites$($thiz)
  }
}
function $p_Lplay_api_libs_json_Writes$__StringWrites$lzycompute$1__V($thiz) {
  if (($m_Lplay_api_libs_json_Writes$().Lplay_api_libs_json_Writes$__f_StringWrites$module === null)) {
    $m_Lplay_api_libs_json_Writes$().Lplay_api_libs_json_Writes$__f_StringWrites$module = new $c_Lplay_api_libs_json_DefaultWrites$StringWrites$($thiz)
  }
}
/** @constructor */
function $c_Lplay_api_libs_json_Writes$() {
  this.Lplay_api_libs_json_Writes$__f_constraints = null;
  this.Lplay_api_libs_json_Writes$__f_path = null;
  this.Lplay_api_libs_json_Writes$__f_contravariantfunctorWrites = null;
  this.Lplay_api_libs_json_Writes$__f_IntWrites$module = null;
  this.Lplay_api_libs_json_Writes$__f_ShortWrites$module = null;
  this.Lplay_api_libs_json_Writes$__f_ByteWrites$module = null;
  this.Lplay_api_libs_json_Writes$__f_LongWrites$module = null;
  this.Lplay_api_libs_json_Writes$__f_FloatWrites$module = null;
  this.Lplay_api_libs_json_Writes$__f_DoubleWrites$module = null;
  this.Lplay_api_libs_json_Writes$__f_BigDecimalWrites$module = null;
  this.Lplay_api_libs_json_Writes$__f_BigIntWrites$module = null;
  this.Lplay_api_libs_json_Writes$__f_BigIntegerWrites$module = null;
  this.Lplay_api_libs_json_Writes$__f_BooleanWrites$module = null;
  this.Lplay_api_libs_json_Writes$__f_StringWrites$module = null;
  this.Lplay_api_libs_json_Writes$__f_JsValueWrites$module = null;
  this.Lplay_api_libs_json_Writes$__f_NoneWrites = null;
  this.Lplay_api_libs_json_Writes$__f_DefaultDateWrites$module = null;
  this.Lplay_api_libs_json_Writes$__f_UuidWrites$module = null;
  this.Lplay_api_libs_json_Writes$__f_uriWrites = null;
  $n_Lplay_api_libs_json_Writes$ = this;
  $f_Lplay_api_libs_json_LowPriorityWrites__$init$__V(this);
  $f_Lplay_api_libs_json_DefaultWrites__$init$__V(this);
  this.Lplay_api_libs_json_Writes$__f_constraints = this;
  this.Lplay_api_libs_json_Writes$__f_path = this;
  this.Lplay_api_libs_json_Writes$__f_contravariantfunctorWrites = new $c_Lplay_api_libs_json_Writes$$anon$5()
}
$c_Lplay_api_libs_json_Writes$.prototype = new $h_O();
$c_Lplay_api_libs_json_Writes$.prototype.constructor = $c_Lplay_api_libs_json_Writes$;
/** @constructor */
function $h_Lplay_api_libs_json_Writes$() {
  /*<skip>*/
}
$h_Lplay_api_libs_json_Writes$.prototype = $c_Lplay_api_libs_json_Writes$.prototype;
$c_Lplay_api_libs_json_Writes$.prototype.IntWrites__Lplay_api_libs_json_DefaultWrites$IntWrites$ = (function() {
  if (($m_Lplay_api_libs_json_Writes$().Lplay_api_libs_json_Writes$__f_IntWrites$module === null)) {
    $p_Lplay_api_libs_json_Writes$__IntWrites$lzycompute$1__V(this)
  };
  return $m_Lplay_api_libs_json_Writes$().Lplay_api_libs_json_Writes$__f_IntWrites$module
});
$c_Lplay_api_libs_json_Writes$.prototype.StringWrites__Lplay_api_libs_json_DefaultWrites$StringWrites$ = (function() {
  if (($m_Lplay_api_libs_json_Writes$().Lplay_api_libs_json_Writes$__f_StringWrites$module === null)) {
    $p_Lplay_api_libs_json_Writes$__StringWrites$lzycompute$1__V(this)
  };
  return $m_Lplay_api_libs_json_Writes$().Lplay_api_libs_json_Writes$__f_StringWrites$module
});
var $d_Lplay_api_libs_json_Writes$ = new $TypeData().initClass({
  Lplay_api_libs_json_Writes$: 0
}, false, "play.api.libs.json.Writes$", {
  Lplay_api_libs_json_Writes$: 1,
  O: 1,
  Lplay_api_libs_json_PathWrites: 1,
  Lplay_api_libs_json_ConstraintWrites: 1,
  Lplay_api_libs_json_DefaultWrites: 1,
  Lplay_api_libs_json_LowPriorityWrites: 1,
  Lplay_api_libs_json_EnvWrites: 1,
  Lplay_api_libs_json_GeneratedWrites: 1
});
$c_Lplay_api_libs_json_Writes$.prototype.$classData = $d_Lplay_api_libs_json_Writes$;
var $n_Lplay_api_libs_json_Writes$;
function $m_Lplay_api_libs_json_Writes$() {
  if ((!$n_Lplay_api_libs_json_Writes$)) {
    $n_Lplay_api_libs_json_Writes$ = new $c_Lplay_api_libs_json_Writes$()
  };
  return $n_Lplay_api_libs_json_Writes$
}
/** @constructor */
function $c_s_UninitializedFieldError(msg) {
  this.jl_Throwable__f_s = null;
  this.jl_Throwable__f_e = null;
  this.jl_Throwable__f_enableSuppression = false;
  this.jl_Throwable__f_writableStackTrace = false;
  this.jl_Throwable__f_stackTraceStateInternal = null;
  this.jl_Throwable__f_stackTrace = null;
  this.jl_Throwable__f_suppressed = null;
  this.s_UninitializedFieldError__f_msg = null;
  this.s_UninitializedFieldError__f_msg = msg;
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, msg, null, true, true)
}
$c_s_UninitializedFieldError.prototype = new $h_jl_RuntimeException();
$c_s_UninitializedFieldError.prototype.constructor = $c_s_UninitializedFieldError;
/** @constructor */
function $h_s_UninitializedFieldError() {
  /*<skip>*/
}
$h_s_UninitializedFieldError.prototype = $c_s_UninitializedFieldError.prototype;
$c_s_UninitializedFieldError.prototype.productPrefix__T = (function() {
  return "UninitializedFieldError"
});
$c_s_UninitializedFieldError.prototype.productArity__I = (function() {
  return 1
});
$c_s_UninitializedFieldError.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.s_UninitializedFieldError__f_msg : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_s_UninitializedFieldError.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_s_UninitializedFieldError.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_s_UninitializedFieldError.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_s_UninitializedFieldError)) {
    var UninitializedFieldError$1 = $as_s_UninitializedFieldError(x$1);
    return (this.s_UninitializedFieldError__f_msg === UninitializedFieldError$1.s_UninitializedFieldError__f_msg)
  } else {
    return false
  }
});
function $as_s_UninitializedFieldError(obj) {
  return (((obj instanceof $c_s_UninitializedFieldError) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.UninitializedFieldError"))
}
function $isArrayOf_s_UninitializedFieldError(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_UninitializedFieldError)))
}
function $asArrayOf_s_UninitializedFieldError(obj, depth) {
  return (($isArrayOf_s_UninitializedFieldError(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.UninitializedFieldError;", depth))
}
var $d_s_UninitializedFieldError = new $TypeData().initClass({
  s_UninitializedFieldError: 0
}, false, "scala.UninitializedFieldError", {
  s_UninitializedFieldError: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  s_Product: 1,
  s_Equals: 1
});
$c_s_UninitializedFieldError.prototype.$classData = $d_s_UninitializedFieldError;
/** @constructor */
function $c_sc_ArrayOps$ArrayIterator$mcB$sp(xs$mcB$sp) {
  this.sc_ArrayOps$ArrayIterator__f_xs = null;
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = 0;
  this.sc_ArrayOps$ArrayIterator__f_len = 0;
  this.sc_ArrayOps$ArrayIterator$mcB$sp__f_xs$mcB$sp = null;
  this.sc_ArrayOps$ArrayIterator$mcB$sp__f_xs$mcB$sp = xs$mcB$sp;
  $ct_sc_ArrayOps$ArrayIterator__O__(this, xs$mcB$sp)
}
$c_sc_ArrayOps$ArrayIterator$mcB$sp.prototype = new $h_sc_ArrayOps$ArrayIterator();
$c_sc_ArrayOps$ArrayIterator$mcB$sp.prototype.constructor = $c_sc_ArrayOps$ArrayIterator$mcB$sp;
/** @constructor */
function $h_sc_ArrayOps$ArrayIterator$mcB$sp() {
  /*<skip>*/
}
$h_sc_ArrayOps$ArrayIterator$mcB$sp.prototype = $c_sc_ArrayOps$ArrayIterator$mcB$sp.prototype;
$c_sc_ArrayOps$ArrayIterator$mcB$sp.prototype.next$mcB$sp__B = (function() {
  try {
    var r = this.sc_ArrayOps$ArrayIterator$mcB$sp__f_xs$mcB$sp.get(this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos);
    this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = ((1 + this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos) | 0);
    return r
  } catch (e) {
    if ((e instanceof $c_jl_ArrayIndexOutOfBoundsException)) {
      return $uB($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O())
    } else {
      throw e
    }
  }
});
$c_sc_ArrayOps$ArrayIterator$mcB$sp.prototype.next__O = (function() {
  return this.next$mcB$sp__B()
});
var $d_sc_ArrayOps$ArrayIterator$mcB$sp = new $TypeData().initClass({
  sc_ArrayOps$ArrayIterator$mcB$sp: 0
}, false, "scala.collection.ArrayOps$ArrayIterator$mcB$sp", {
  sc_ArrayOps$ArrayIterator$mcB$sp: 1,
  sc_ArrayOps$ArrayIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
});
$c_sc_ArrayOps$ArrayIterator$mcB$sp.prototype.$classData = $d_sc_ArrayOps$ArrayIterator$mcB$sp;
/** @constructor */
function $c_sc_ArrayOps$ArrayIterator$mcC$sp(xs$mcC$sp) {
  this.sc_ArrayOps$ArrayIterator__f_xs = null;
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = 0;
  this.sc_ArrayOps$ArrayIterator__f_len = 0;
  this.sc_ArrayOps$ArrayIterator$mcC$sp__f_xs$mcC$sp = null;
  this.sc_ArrayOps$ArrayIterator$mcC$sp__f_xs$mcC$sp = xs$mcC$sp;
  $ct_sc_ArrayOps$ArrayIterator__O__(this, xs$mcC$sp)
}
$c_sc_ArrayOps$ArrayIterator$mcC$sp.prototype = new $h_sc_ArrayOps$ArrayIterator();
$c_sc_ArrayOps$ArrayIterator$mcC$sp.prototype.constructor = $c_sc_ArrayOps$ArrayIterator$mcC$sp;
/** @constructor */
function $h_sc_ArrayOps$ArrayIterator$mcC$sp() {
  /*<skip>*/
}
$h_sc_ArrayOps$ArrayIterator$mcC$sp.prototype = $c_sc_ArrayOps$ArrayIterator$mcC$sp.prototype;
$c_sc_ArrayOps$ArrayIterator$mcC$sp.prototype.next$mcC$sp__C = (function() {
  try {
    var r = this.sc_ArrayOps$ArrayIterator$mcC$sp__f_xs$mcC$sp.get(this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos);
    this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = ((1 + this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos) | 0);
    return r
  } catch (e) {
    if ((e instanceof $c_jl_ArrayIndexOutOfBoundsException)) {
      return $uC($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O())
    } else {
      throw e
    }
  }
});
$c_sc_ArrayOps$ArrayIterator$mcC$sp.prototype.next__O = (function() {
  return $bC(this.next$mcC$sp__C())
});
var $d_sc_ArrayOps$ArrayIterator$mcC$sp = new $TypeData().initClass({
  sc_ArrayOps$ArrayIterator$mcC$sp: 0
}, false, "scala.collection.ArrayOps$ArrayIterator$mcC$sp", {
  sc_ArrayOps$ArrayIterator$mcC$sp: 1,
  sc_ArrayOps$ArrayIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
});
$c_sc_ArrayOps$ArrayIterator$mcC$sp.prototype.$classData = $d_sc_ArrayOps$ArrayIterator$mcC$sp;
/** @constructor */
function $c_sc_ArrayOps$ArrayIterator$mcD$sp(xs$mcD$sp) {
  this.sc_ArrayOps$ArrayIterator__f_xs = null;
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = 0;
  this.sc_ArrayOps$ArrayIterator__f_len = 0;
  this.sc_ArrayOps$ArrayIterator$mcD$sp__f_xs$mcD$sp = null;
  this.sc_ArrayOps$ArrayIterator$mcD$sp__f_xs$mcD$sp = xs$mcD$sp;
  $ct_sc_ArrayOps$ArrayIterator__O__(this, xs$mcD$sp)
}
$c_sc_ArrayOps$ArrayIterator$mcD$sp.prototype = new $h_sc_ArrayOps$ArrayIterator();
$c_sc_ArrayOps$ArrayIterator$mcD$sp.prototype.constructor = $c_sc_ArrayOps$ArrayIterator$mcD$sp;
/** @constructor */
function $h_sc_ArrayOps$ArrayIterator$mcD$sp() {
  /*<skip>*/
}
$h_sc_ArrayOps$ArrayIterator$mcD$sp.prototype = $c_sc_ArrayOps$ArrayIterator$mcD$sp.prototype;
$c_sc_ArrayOps$ArrayIterator$mcD$sp.prototype.next$mcD$sp__D = (function() {
  try {
    var r = this.sc_ArrayOps$ArrayIterator$mcD$sp__f_xs$mcD$sp.get(this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos);
    this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = ((1 + this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos) | 0);
    return r
  } catch (e) {
    if ((e instanceof $c_jl_ArrayIndexOutOfBoundsException)) {
      return $uD($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O())
    } else {
      throw e
    }
  }
});
$c_sc_ArrayOps$ArrayIterator$mcD$sp.prototype.next__O = (function() {
  return this.next$mcD$sp__D()
});
var $d_sc_ArrayOps$ArrayIterator$mcD$sp = new $TypeData().initClass({
  sc_ArrayOps$ArrayIterator$mcD$sp: 0
}, false, "scala.collection.ArrayOps$ArrayIterator$mcD$sp", {
  sc_ArrayOps$ArrayIterator$mcD$sp: 1,
  sc_ArrayOps$ArrayIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
});
$c_sc_ArrayOps$ArrayIterator$mcD$sp.prototype.$classData = $d_sc_ArrayOps$ArrayIterator$mcD$sp;
/** @constructor */
function $c_sc_ArrayOps$ArrayIterator$mcF$sp(xs$mcF$sp) {
  this.sc_ArrayOps$ArrayIterator__f_xs = null;
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = 0;
  this.sc_ArrayOps$ArrayIterator__f_len = 0;
  this.sc_ArrayOps$ArrayIterator$mcF$sp__f_xs$mcF$sp = null;
  this.sc_ArrayOps$ArrayIterator$mcF$sp__f_xs$mcF$sp = xs$mcF$sp;
  $ct_sc_ArrayOps$ArrayIterator__O__(this, xs$mcF$sp)
}
$c_sc_ArrayOps$ArrayIterator$mcF$sp.prototype = new $h_sc_ArrayOps$ArrayIterator();
$c_sc_ArrayOps$ArrayIterator$mcF$sp.prototype.constructor = $c_sc_ArrayOps$ArrayIterator$mcF$sp;
/** @constructor */
function $h_sc_ArrayOps$ArrayIterator$mcF$sp() {
  /*<skip>*/
}
$h_sc_ArrayOps$ArrayIterator$mcF$sp.prototype = $c_sc_ArrayOps$ArrayIterator$mcF$sp.prototype;
$c_sc_ArrayOps$ArrayIterator$mcF$sp.prototype.next$mcF$sp__F = (function() {
  try {
    var r = this.sc_ArrayOps$ArrayIterator$mcF$sp__f_xs$mcF$sp.get(this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos);
    this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = ((1 + this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos) | 0);
    return r
  } catch (e) {
    if ((e instanceof $c_jl_ArrayIndexOutOfBoundsException)) {
      return $uF($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O())
    } else {
      throw e
    }
  }
});
$c_sc_ArrayOps$ArrayIterator$mcF$sp.prototype.next__O = (function() {
  return this.next$mcF$sp__F()
});
var $d_sc_ArrayOps$ArrayIterator$mcF$sp = new $TypeData().initClass({
  sc_ArrayOps$ArrayIterator$mcF$sp: 0
}, false, "scala.collection.ArrayOps$ArrayIterator$mcF$sp", {
  sc_ArrayOps$ArrayIterator$mcF$sp: 1,
  sc_ArrayOps$ArrayIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
});
$c_sc_ArrayOps$ArrayIterator$mcF$sp.prototype.$classData = $d_sc_ArrayOps$ArrayIterator$mcF$sp;
/** @constructor */
function $c_sc_ArrayOps$ArrayIterator$mcI$sp(xs$mcI$sp) {
  this.sc_ArrayOps$ArrayIterator__f_xs = null;
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = 0;
  this.sc_ArrayOps$ArrayIterator__f_len = 0;
  this.sc_ArrayOps$ArrayIterator$mcI$sp__f_xs$mcI$sp = null;
  this.sc_ArrayOps$ArrayIterator$mcI$sp__f_xs$mcI$sp = xs$mcI$sp;
  $ct_sc_ArrayOps$ArrayIterator__O__(this, xs$mcI$sp)
}
$c_sc_ArrayOps$ArrayIterator$mcI$sp.prototype = new $h_sc_ArrayOps$ArrayIterator();
$c_sc_ArrayOps$ArrayIterator$mcI$sp.prototype.constructor = $c_sc_ArrayOps$ArrayIterator$mcI$sp;
/** @constructor */
function $h_sc_ArrayOps$ArrayIterator$mcI$sp() {
  /*<skip>*/
}
$h_sc_ArrayOps$ArrayIterator$mcI$sp.prototype = $c_sc_ArrayOps$ArrayIterator$mcI$sp.prototype;
$c_sc_ArrayOps$ArrayIterator$mcI$sp.prototype.next$mcI$sp__I = (function() {
  try {
    var r = this.sc_ArrayOps$ArrayIterator$mcI$sp__f_xs$mcI$sp.get(this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos);
    this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = ((1 + this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos) | 0);
    return r
  } catch (e) {
    if ((e instanceof $c_jl_ArrayIndexOutOfBoundsException)) {
      return $uI($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O())
    } else {
      throw e
    }
  }
});
$c_sc_ArrayOps$ArrayIterator$mcI$sp.prototype.next__O = (function() {
  return this.next$mcI$sp__I()
});
var $d_sc_ArrayOps$ArrayIterator$mcI$sp = new $TypeData().initClass({
  sc_ArrayOps$ArrayIterator$mcI$sp: 0
}, false, "scala.collection.ArrayOps$ArrayIterator$mcI$sp", {
  sc_ArrayOps$ArrayIterator$mcI$sp: 1,
  sc_ArrayOps$ArrayIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
});
$c_sc_ArrayOps$ArrayIterator$mcI$sp.prototype.$classData = $d_sc_ArrayOps$ArrayIterator$mcI$sp;
/** @constructor */
function $c_sc_ArrayOps$ArrayIterator$mcJ$sp(xs$mcJ$sp) {
  this.sc_ArrayOps$ArrayIterator__f_xs = null;
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = 0;
  this.sc_ArrayOps$ArrayIterator__f_len = 0;
  this.sc_ArrayOps$ArrayIterator$mcJ$sp__f_xs$mcJ$sp = null;
  this.sc_ArrayOps$ArrayIterator$mcJ$sp__f_xs$mcJ$sp = xs$mcJ$sp;
  $ct_sc_ArrayOps$ArrayIterator__O__(this, xs$mcJ$sp)
}
$c_sc_ArrayOps$ArrayIterator$mcJ$sp.prototype = new $h_sc_ArrayOps$ArrayIterator();
$c_sc_ArrayOps$ArrayIterator$mcJ$sp.prototype.constructor = $c_sc_ArrayOps$ArrayIterator$mcJ$sp;
/** @constructor */
function $h_sc_ArrayOps$ArrayIterator$mcJ$sp() {
  /*<skip>*/
}
$h_sc_ArrayOps$ArrayIterator$mcJ$sp.prototype = $c_sc_ArrayOps$ArrayIterator$mcJ$sp.prototype;
$c_sc_ArrayOps$ArrayIterator$mcJ$sp.prototype.next$mcJ$sp__J = (function() {
  try {
    var t = this.sc_ArrayOps$ArrayIterator$mcJ$sp__f_xs$mcJ$sp.get(this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = ((1 + this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos) | 0);
    return new $c_RTLong(lo, hi)
  } catch (e) {
    if ((e instanceof $c_jl_ArrayIndexOutOfBoundsException)) {
      return $uJ($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O())
    } else {
      throw e
    }
  }
});
$c_sc_ArrayOps$ArrayIterator$mcJ$sp.prototype.next__O = (function() {
  return this.next$mcJ$sp__J()
});
var $d_sc_ArrayOps$ArrayIterator$mcJ$sp = new $TypeData().initClass({
  sc_ArrayOps$ArrayIterator$mcJ$sp: 0
}, false, "scala.collection.ArrayOps$ArrayIterator$mcJ$sp", {
  sc_ArrayOps$ArrayIterator$mcJ$sp: 1,
  sc_ArrayOps$ArrayIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
});
$c_sc_ArrayOps$ArrayIterator$mcJ$sp.prototype.$classData = $d_sc_ArrayOps$ArrayIterator$mcJ$sp;
/** @constructor */
function $c_sc_ArrayOps$ArrayIterator$mcS$sp(xs$mcS$sp) {
  this.sc_ArrayOps$ArrayIterator__f_xs = null;
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = 0;
  this.sc_ArrayOps$ArrayIterator__f_len = 0;
  this.sc_ArrayOps$ArrayIterator$mcS$sp__f_xs$mcS$sp = null;
  this.sc_ArrayOps$ArrayIterator$mcS$sp__f_xs$mcS$sp = xs$mcS$sp;
  $ct_sc_ArrayOps$ArrayIterator__O__(this, xs$mcS$sp)
}
$c_sc_ArrayOps$ArrayIterator$mcS$sp.prototype = new $h_sc_ArrayOps$ArrayIterator();
$c_sc_ArrayOps$ArrayIterator$mcS$sp.prototype.constructor = $c_sc_ArrayOps$ArrayIterator$mcS$sp;
/** @constructor */
function $h_sc_ArrayOps$ArrayIterator$mcS$sp() {
  /*<skip>*/
}
$h_sc_ArrayOps$ArrayIterator$mcS$sp.prototype = $c_sc_ArrayOps$ArrayIterator$mcS$sp.prototype;
$c_sc_ArrayOps$ArrayIterator$mcS$sp.prototype.next$mcS$sp__S = (function() {
  try {
    var r = this.sc_ArrayOps$ArrayIterator$mcS$sp__f_xs$mcS$sp.get(this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos);
    this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = ((1 + this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos) | 0);
    return r
  } catch (e) {
    if ((e instanceof $c_jl_ArrayIndexOutOfBoundsException)) {
      return $uS($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O())
    } else {
      throw e
    }
  }
});
$c_sc_ArrayOps$ArrayIterator$mcS$sp.prototype.next__O = (function() {
  return this.next$mcS$sp__S()
});
var $d_sc_ArrayOps$ArrayIterator$mcS$sp = new $TypeData().initClass({
  sc_ArrayOps$ArrayIterator$mcS$sp: 0
}, false, "scala.collection.ArrayOps$ArrayIterator$mcS$sp", {
  sc_ArrayOps$ArrayIterator$mcS$sp: 1,
  sc_ArrayOps$ArrayIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
});
$c_sc_ArrayOps$ArrayIterator$mcS$sp.prototype.$classData = $d_sc_ArrayOps$ArrayIterator$mcS$sp;
/** @constructor */
function $c_sc_ArrayOps$ArrayIterator$mcV$sp(xs$mcV$sp) {
  this.sc_ArrayOps$ArrayIterator__f_xs = null;
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = 0;
  this.sc_ArrayOps$ArrayIterator__f_len = 0;
  this.sc_ArrayOps$ArrayIterator$mcV$sp__f_xs$mcV$sp = null;
  this.sc_ArrayOps$ArrayIterator$mcV$sp__f_xs$mcV$sp = xs$mcV$sp;
  $ct_sc_ArrayOps$ArrayIterator__O__(this, xs$mcV$sp)
}
$c_sc_ArrayOps$ArrayIterator$mcV$sp.prototype = new $h_sc_ArrayOps$ArrayIterator();
$c_sc_ArrayOps$ArrayIterator$mcV$sp.prototype.constructor = $c_sc_ArrayOps$ArrayIterator$mcV$sp;
/** @constructor */
function $h_sc_ArrayOps$ArrayIterator$mcV$sp() {
  /*<skip>*/
}
$h_sc_ArrayOps$ArrayIterator$mcV$sp.prototype = $c_sc_ArrayOps$ArrayIterator$mcV$sp.prototype;
$c_sc_ArrayOps$ArrayIterator$mcV$sp.prototype.next$mcV$sp__V = (function() {
  try {
    this.sc_ArrayOps$ArrayIterator$mcV$sp__f_xs$mcV$sp.get(this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos);
    this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = ((1 + this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos) | 0)
  } catch (e) {
    if ((e instanceof $c_jl_ArrayIndexOutOfBoundsException)) {
      $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O()
    } else {
      throw e
    }
  }
});
$c_sc_ArrayOps$ArrayIterator$mcV$sp.prototype.next__O = (function() {
  this.next$mcV$sp__V()
});
var $d_sc_ArrayOps$ArrayIterator$mcV$sp = new $TypeData().initClass({
  sc_ArrayOps$ArrayIterator$mcV$sp: 0
}, false, "scala.collection.ArrayOps$ArrayIterator$mcV$sp", {
  sc_ArrayOps$ArrayIterator$mcV$sp: 1,
  sc_ArrayOps$ArrayIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
});
$c_sc_ArrayOps$ArrayIterator$mcV$sp.prototype.$classData = $d_sc_ArrayOps$ArrayIterator$mcV$sp;
/** @constructor */
function $c_sc_ArrayOps$ArrayIterator$mcZ$sp(xs$mcZ$sp) {
  this.sc_ArrayOps$ArrayIterator__f_xs = null;
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = 0;
  this.sc_ArrayOps$ArrayIterator__f_len = 0;
  this.sc_ArrayOps$ArrayIterator$mcZ$sp__f_xs$mcZ$sp = null;
  this.sc_ArrayOps$ArrayIterator$mcZ$sp__f_xs$mcZ$sp = xs$mcZ$sp;
  $ct_sc_ArrayOps$ArrayIterator__O__(this, xs$mcZ$sp)
}
$c_sc_ArrayOps$ArrayIterator$mcZ$sp.prototype = new $h_sc_ArrayOps$ArrayIterator();
$c_sc_ArrayOps$ArrayIterator$mcZ$sp.prototype.constructor = $c_sc_ArrayOps$ArrayIterator$mcZ$sp;
/** @constructor */
function $h_sc_ArrayOps$ArrayIterator$mcZ$sp() {
  /*<skip>*/
}
$h_sc_ArrayOps$ArrayIterator$mcZ$sp.prototype = $c_sc_ArrayOps$ArrayIterator$mcZ$sp.prototype;
$c_sc_ArrayOps$ArrayIterator$mcZ$sp.prototype.next$mcZ$sp__Z = (function() {
  try {
    var r = this.sc_ArrayOps$ArrayIterator$mcZ$sp__f_xs$mcZ$sp.get(this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos);
    this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = ((1 + this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos) | 0);
    return r
  } catch (e) {
    if ((e instanceof $c_jl_ArrayIndexOutOfBoundsException)) {
      return $uZ($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O())
    } else {
      throw e
    }
  }
});
$c_sc_ArrayOps$ArrayIterator$mcZ$sp.prototype.next__O = (function() {
  return this.next$mcZ$sp__Z()
});
var $d_sc_ArrayOps$ArrayIterator$mcZ$sp = new $TypeData().initClass({
  sc_ArrayOps$ArrayIterator$mcZ$sp: 0
}, false, "scala.collection.ArrayOps$ArrayIterator$mcZ$sp", {
  sc_ArrayOps$ArrayIterator$mcZ$sp: 1,
  sc_ArrayOps$ArrayIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
});
$c_sc_ArrayOps$ArrayIterator$mcZ$sp.prototype.$classData = $d_sc_ArrayOps$ArrayIterator$mcZ$sp;
function $f_sc_View__toString__T($thiz) {
  return ($thiz.className__T() + "(<not computed>)")
}
function $is_sc_View(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_View)))
}
function $as_sc_View(obj) {
  return (($is_sc_View(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.View"))
}
function $isArrayOf_sc_View(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_View)))
}
function $asArrayOf_sc_View(obj, depth) {
  return (($isArrayOf_sc_View(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.View;", depth))
}
function $as_sc_convert_JavaCollectionWrappers$MutableMapWrapper(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.convert.JavaCollectionWrappers$MutableMapWrapper"))
}
function $isArrayOf_sc_convert_JavaCollectionWrappers$MutableMapWrapper(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_convert_JavaCollectionWrappers$MutableMapWrapper)))
}
function $asArrayOf_sc_convert_JavaCollectionWrappers$MutableMapWrapper(obj, depth) {
  return (($isArrayOf_sc_convert_JavaCollectionWrappers$MutableMapWrapper(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.convert.JavaCollectionWrappers$MutableMapWrapper;", depth))
}
/** @constructor */
function $c_sci_Set$Set2$$anon$1(outer) {
  this.sci_Set$SetNIterator__f_current = 0;
  this.sci_Set$SetNIterator__f_remainder = 0;
  this.sci_Set$Set2$$anon$1__f_$outer = null;
  if ((outer === null)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(null)
  } else {
    this.sci_Set$Set2$$anon$1__f_$outer = outer
  };
  $ct_sci_Set$SetNIterator__I__(this, 2)
}
$c_sci_Set$Set2$$anon$1.prototype = new $h_sci_Set$SetNIterator();
$c_sci_Set$Set2$$anon$1.prototype.constructor = $c_sci_Set$Set2$$anon$1;
/** @constructor */
function $h_sci_Set$Set2$$anon$1() {
  /*<skip>*/
}
$h_sci_Set$Set2$$anon$1.prototype = $c_sci_Set$Set2$$anon$1.prototype;
$c_sci_Set$Set2$$anon$1.prototype.apply__I__O = (function(i) {
  return this.sci_Set$Set2$$anon$1__f_$outer.scala$collection$immutable$Set$Set2$$getElem__I__O(i)
});
var $d_sci_Set$Set2$$anon$1 = new $TypeData().initClass({
  sci_Set$Set2$$anon$1: 0
}, false, "scala.collection.immutable.Set$Set2$$anon$1", {
  sci_Set$Set2$$anon$1: 1,
  sci_Set$SetNIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Set$Set2$$anon$1.prototype.$classData = $d_sci_Set$Set2$$anon$1;
/** @constructor */
function $c_sci_Set$Set3$$anon$2(outer) {
  this.sci_Set$SetNIterator__f_current = 0;
  this.sci_Set$SetNIterator__f_remainder = 0;
  this.sci_Set$Set3$$anon$2__f_$outer = null;
  if ((outer === null)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(null)
  } else {
    this.sci_Set$Set3$$anon$2__f_$outer = outer
  };
  $ct_sci_Set$SetNIterator__I__(this, 3)
}
$c_sci_Set$Set3$$anon$2.prototype = new $h_sci_Set$SetNIterator();
$c_sci_Set$Set3$$anon$2.prototype.constructor = $c_sci_Set$Set3$$anon$2;
/** @constructor */
function $h_sci_Set$Set3$$anon$2() {
  /*<skip>*/
}
$h_sci_Set$Set3$$anon$2.prototype = $c_sci_Set$Set3$$anon$2.prototype;
$c_sci_Set$Set3$$anon$2.prototype.apply__I__O = (function(i) {
  return this.sci_Set$Set3$$anon$2__f_$outer.scala$collection$immutable$Set$Set3$$getElem__I__O(i)
});
var $d_sci_Set$Set3$$anon$2 = new $TypeData().initClass({
  sci_Set$Set3$$anon$2: 0
}, false, "scala.collection.immutable.Set$Set3$$anon$2", {
  sci_Set$Set3$$anon$2: 1,
  sci_Set$SetNIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Set$Set3$$anon$2.prototype.$classData = $d_sci_Set$Set3$$anon$2;
/** @constructor */
function $c_sci_Set$Set4$$anon$3(outer) {
  this.sci_Set$SetNIterator__f_current = 0;
  this.sci_Set$SetNIterator__f_remainder = 0;
  this.sci_Set$Set4$$anon$3__f_$outer = null;
  if ((outer === null)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(null)
  } else {
    this.sci_Set$Set4$$anon$3__f_$outer = outer
  };
  $ct_sci_Set$SetNIterator__I__(this, 4)
}
$c_sci_Set$Set4$$anon$3.prototype = new $h_sci_Set$SetNIterator();
$c_sci_Set$Set4$$anon$3.prototype.constructor = $c_sci_Set$Set4$$anon$3;
/** @constructor */
function $h_sci_Set$Set4$$anon$3() {
  /*<skip>*/
}
$h_sci_Set$Set4$$anon$3.prototype = $c_sci_Set$Set4$$anon$3.prototype;
$c_sci_Set$Set4$$anon$3.prototype.apply__I__O = (function(i) {
  return this.sci_Set$Set4$$anon$3__f_$outer.scala$collection$immutable$Set$Set4$$getElem__I__O(i)
});
var $d_sci_Set$Set4$$anon$3 = new $TypeData().initClass({
  sci_Set$Set4$$anon$3: 0
}, false, "scala.collection.immutable.Set$Set4$$anon$3", {
  sci_Set$Set4$$anon$3: 1,
  sci_Set$SetNIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Set$Set4$$anon$3.prototype.$classData = $d_sci_Set$Set4$$anon$3;
/** @constructor */
function $c_scm_ArrayBuilder$generic(elementClass) {
  this.scm_ArrayBuilder__f_capacity = 0;
  this.scm_ArrayBuilder__f_size = 0;
  this.scm_ArrayBuilder$generic__f_elementClass = null;
  this.scm_ArrayBuilder$generic__f_isCharArrayBuilder = false;
  this.scm_ArrayBuilder$generic__f_jsElems = null;
  this.scm_ArrayBuilder$generic__f_elementClass = elementClass;
  $ct_scm_ArrayBuilder__(this);
  this.scm_ArrayBuilder$generic__f_isCharArrayBuilder = (elementClass === $d_C.getClassOf());
  this.scm_ArrayBuilder$generic__f_jsElems = []
}
$c_scm_ArrayBuilder$generic.prototype = new $h_scm_ArrayBuilder();
$c_scm_ArrayBuilder$generic.prototype.constructor = $c_scm_ArrayBuilder$generic;
/** @constructor */
function $h_scm_ArrayBuilder$generic() {
  /*<skip>*/
}
$h_scm_ArrayBuilder$generic.prototype = $c_scm_ArrayBuilder$generic.prototype;
$c_scm_ArrayBuilder$generic.prototype.addOne__O__scm_ArrayBuilder$generic = (function(elem) {
  var unboxedElem = (this.scm_ArrayBuilder$generic__f_isCharArrayBuilder ? $uC(elem) : ((elem === null) ? this.scm_ArrayBuilder$generic__f_elementClass.jl_Class__f_data.zero : elem));
  this.scm_ArrayBuilder$generic__f_jsElems.push(unboxedElem);
  return this
});
$c_scm_ArrayBuilder$generic.prototype.addAll__sc_IterableOnce__scm_ArrayBuilder$generic = (function(xs) {
  var it = xs.iterator__sc_Iterator();
  while (it.hasNext__Z()) {
    var elem = it.next__O();
    this.addOne__O__scm_ArrayBuilder$generic(elem)
  };
  return this
});
$c_scm_ArrayBuilder$generic.prototype.result__O = (function() {
  var x$2 = this.scm_ArrayBuilder$generic__f_elementClass;
  if ((x$2 === $d_V.getClassOf())) {
    var elemRuntimeClass = $d_jl_Void.getClassOf()
  } else {
    var x$4 = this.scm_ArrayBuilder$generic__f_elementClass;
    if ((x$4 === $d_sr_Null$.getClassOf())) {
      var $$x1 = true
    } else {
      var x$6 = this.scm_ArrayBuilder$generic__f_elementClass;
      var $$x1 = (x$6 === $d_sr_Nothing$.getClassOf())
    };
    if ($$x1) {
      var elemRuntimeClass = $d_O.getClassOf()
    } else {
      var elemRuntimeClass = this.scm_ArrayBuilder$generic__f_elementClass
    }
  };
  return elemRuntimeClass.jl_Class__f_data.getArrayOf().wrapArray(this.scm_ArrayBuilder$generic__f_jsElems)
});
$c_scm_ArrayBuilder$generic.prototype.toString__T = (function() {
  return "ArrayBuilder.generic"
});
$c_scm_ArrayBuilder$generic.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return this.addAll__sc_IterableOnce__scm_ArrayBuilder$generic(xs)
});
$c_scm_ArrayBuilder$generic.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__scm_ArrayBuilder$generic(elem)
});
var $d_scm_ArrayBuilder$generic = new $TypeData().initClass({
  scm_ArrayBuilder$generic: 0
}, false, "scala.collection.mutable.ArrayBuilder$generic", {
  scm_ArrayBuilder$generic: 1,
  scm_ArrayBuilder: 1,
  O: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  Ljava_io_Serializable: 1
});
$c_scm_ArrayBuilder$generic.prototype.$classData = $d_scm_ArrayBuilder$generic;
/** @constructor */
function $c_s_concurrent_Future$$anon$1(t$2) {
  this.jl_Throwable__f_s = null;
  this.jl_Throwable__f_e = null;
  this.jl_Throwable__f_enableSuppression = false;
  this.jl_Throwable__f_writableStackTrace = false;
  this.jl_Throwable__f_stackTraceStateInternal = null;
  this.jl_Throwable__f_stackTrace = null;
  this.jl_Throwable__f_suppressed = null;
  var s = ("Future.collect partial function is not defined at: " + t$2);
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, s, null, true, true)
}
$c_s_concurrent_Future$$anon$1.prototype = new $h_ju_NoSuchElementException();
$c_s_concurrent_Future$$anon$1.prototype.constructor = $c_s_concurrent_Future$$anon$1;
/** @constructor */
function $h_s_concurrent_Future$$anon$1() {
  /*<skip>*/
}
$h_s_concurrent_Future$$anon$1.prototype = $c_s_concurrent_Future$$anon$1.prototype;
$c_s_concurrent_Future$$anon$1.prototype.fillInStackTrace__jl_Throwable = (function() {
  return $f_s_util_control_NoStackTrace__fillInStackTrace__jl_Throwable(this)
});
var $d_s_concurrent_Future$$anon$1 = new $TypeData().initClass({
  s_concurrent_Future$$anon$1: 0
}, false, "scala.concurrent.Future$$anon$1", {
  s_concurrent_Future$$anon$1: 1,
  ju_NoSuchElementException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  s_util_control_NoStackTrace: 1
});
$c_s_concurrent_Future$$anon$1.prototype.$classData = $d_s_concurrent_Future$$anon$1;
/** @constructor */
function $c_s_concurrent_Future$$anon$2() {
  this.jl_Throwable__f_s = null;
  this.jl_Throwable__f_e = null;
  this.jl_Throwable__f_enableSuppression = false;
  this.jl_Throwable__f_writableStackTrace = false;
  this.jl_Throwable__f_stackTraceStateInternal = null;
  this.jl_Throwable__f_stackTrace = null;
  this.jl_Throwable__f_suppressed = null;
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, "Future.filter predicate is not satisfied", null, true, true)
}
$c_s_concurrent_Future$$anon$2.prototype = new $h_ju_NoSuchElementException();
$c_s_concurrent_Future$$anon$2.prototype.constructor = $c_s_concurrent_Future$$anon$2;
/** @constructor */
function $h_s_concurrent_Future$$anon$2() {
  /*<skip>*/
}
$h_s_concurrent_Future$$anon$2.prototype = $c_s_concurrent_Future$$anon$2.prototype;
$c_s_concurrent_Future$$anon$2.prototype.fillInStackTrace__jl_Throwable = (function() {
  return $f_s_util_control_NoStackTrace__fillInStackTrace__jl_Throwable(this)
});
var $d_s_concurrent_Future$$anon$2 = new $TypeData().initClass({
  s_concurrent_Future$$anon$2: 0
}, false, "scala.concurrent.Future$$anon$2", {
  s_concurrent_Future$$anon$2: 1,
  ju_NoSuchElementException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  s_util_control_NoStackTrace: 1
});
$c_s_concurrent_Future$$anon$2.prototype.$classData = $d_s_concurrent_Future$$anon$2;
/** @constructor */
function $c_s_concurrent_Future$$anon$3() {
  this.jl_Throwable__f_s = null;
  this.jl_Throwable__f_e = null;
  this.jl_Throwable__f_enableSuppression = false;
  this.jl_Throwable__f_writableStackTrace = false;
  this.jl_Throwable__f_stackTraceStateInternal = null;
  this.jl_Throwable__f_stackTrace = null;
  this.jl_Throwable__f_suppressed = null;
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, "Future.failed not completed with a throwable.", null, true, true)
}
$c_s_concurrent_Future$$anon$3.prototype = new $h_ju_NoSuchElementException();
$c_s_concurrent_Future$$anon$3.prototype.constructor = $c_s_concurrent_Future$$anon$3;
/** @constructor */
function $h_s_concurrent_Future$$anon$3() {
  /*<skip>*/
}
$h_s_concurrent_Future$$anon$3.prototype = $c_s_concurrent_Future$$anon$3.prototype;
$c_s_concurrent_Future$$anon$3.prototype.fillInStackTrace__jl_Throwable = (function() {
  return $f_s_util_control_NoStackTrace__fillInStackTrace__jl_Throwable(this)
});
var $d_s_concurrent_Future$$anon$3 = new $TypeData().initClass({
  s_concurrent_Future$$anon$3: 0
}, false, "scala.concurrent.Future$$anon$3", {
  s_concurrent_Future$$anon$3: 1,
  ju_NoSuchElementException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  s_util_control_NoStackTrace: 1
});
$c_s_concurrent_Future$$anon$3.prototype.$classData = $d_s_concurrent_Future$$anon$3;
function $p_s_concurrent_impl_Promise$DefaultPromise__value0__s_util_Try($thiz) {
  var _$this = $thiz;
  while (true) {
    var state = _$this.ju_concurrent_atomic_AtomicReference__f_value;
    if ((state instanceof $c_s_util_Try)) {
      return $as_s_util_Try(state)
    } else if ((state instanceof $c_s_concurrent_impl_Promise$Link)) {
      _$this = $as_s_concurrent_impl_Promise$Link(state).promise__s_concurrent_impl_Promise$DefaultPromise__s_concurrent_impl_Promise$DefaultPromise(_$this)
    } else {
      return null
    }
  }
}
function $p_s_concurrent_impl_Promise$DefaultPromise__dispatchOrAddCallbacks__O__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks($thiz, state, callbacks) {
  var _$this = $thiz;
  while (true) {
    if ((state instanceof $c_s_util_Try)) {
      $p_s_concurrent_impl_Promise$DefaultPromise__submitWithValue__s_concurrent_impl_Promise$Callbacks__s_util_Try__V(_$this, callbacks, $as_s_util_Try(state));
      return callbacks
    } else if ($is_s_concurrent_impl_Promise$Callbacks(state)) {
      if (_$this.compareAndSet__O__O__Z(state, ((state !== $m_s_concurrent_impl_Promise$().s_concurrent_impl_Promise$__f_scala$concurrent$impl$Promise$$Noop) ? $p_s_concurrent_impl_Promise$DefaultPromise__concatCallbacks__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks(_$this, callbacks, $as_s_concurrent_impl_Promise$Callbacks(state)) : callbacks))) {
        return callbacks
      } else {
        state = _$this.ju_concurrent_atomic_AtomicReference__f_value
      }
    } else {
      var p = $as_s_concurrent_impl_Promise$Link(state).promise__s_concurrent_impl_Promise$DefaultPromise__s_concurrent_impl_Promise$DefaultPromise(_$this);
      var temp$state$2 = p.ju_concurrent_atomic_AtomicReference__f_value;
      _$this = p;
      state = temp$state$2
    }
  }
}
function $p_s_concurrent_impl_Promise$DefaultPromise__concatCallbacks__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks($thiz, left, right) {
  while (true) {
    if ((left instanceof $c_s_concurrent_impl_Promise$Transformation)) {
      return new $c_s_concurrent_impl_Promise$ManyCallbacks($as_s_concurrent_impl_Promise$Transformation(left), right)
    } else {
      var m = $as_s_concurrent_impl_Promise$ManyCallbacks(left);
      var temp$left = m.s_concurrent_impl_Promise$ManyCallbacks__f_rest;
      var temp$right = new $c_s_concurrent_impl_Promise$ManyCallbacks(m.s_concurrent_impl_Promise$ManyCallbacks__f_first, right);
      left = temp$left;
      right = temp$right
    }
  }
}
function $p_s_concurrent_impl_Promise$DefaultPromise__submitWithValue__s_concurrent_impl_Promise$Callbacks__s_util_Try__V($thiz, callbacks, resolved) {
  while ((callbacks instanceof $c_s_concurrent_impl_Promise$ManyCallbacks)) {
    var m = $as_s_concurrent_impl_Promise$ManyCallbacks(callbacks);
    m.s_concurrent_impl_Promise$ManyCallbacks__f_first.submitWithValue__s_util_Try__s_concurrent_impl_Promise$Transformation(resolved);
    callbacks = m.s_concurrent_impl_Promise$ManyCallbacks__f_rest
  };
  $as_s_concurrent_impl_Promise$Transformation(callbacks).submitWithValue__s_util_Try__s_concurrent_impl_Promise$Transformation(resolved)
}
function $ct_s_concurrent_impl_Promise$DefaultPromise__O__($thiz, initial) {
  $ct_ju_concurrent_atomic_AtomicReference__O__($thiz, initial);
  return $thiz
}
function $ct_s_concurrent_impl_Promise$DefaultPromise__s_util_Try__($thiz, result) {
  $ct_s_concurrent_impl_Promise$DefaultPromise__O__($thiz, $m_s_concurrent_impl_Promise$().scala$concurrent$impl$Promise$$resolve__s_util_Try__s_util_Try(result));
  return $thiz
}
function $ct_s_concurrent_impl_Promise$DefaultPromise__($thiz) {
  $ct_s_concurrent_impl_Promise$DefaultPromise__O__($thiz, $m_s_concurrent_impl_Promise$().s_concurrent_impl_Promise$__f_scala$concurrent$impl$Promise$$Noop);
  return $thiz
}
/** @constructor */
function $c_s_concurrent_impl_Promise$DefaultPromise() {
  this.ju_concurrent_atomic_AtomicReference__f_value = null
}
$c_s_concurrent_impl_Promise$DefaultPromise.prototype = new $h_ju_concurrent_atomic_AtomicReference();
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.constructor = $c_s_concurrent_impl_Promise$DefaultPromise;
/** @constructor */
function $h_s_concurrent_impl_Promise$DefaultPromise() {
  /*<skip>*/
}
$h_s_concurrent_impl_Promise$DefaultPromise.prototype = $c_s_concurrent_impl_Promise$DefaultPromise.prototype;
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.transform__F1__s_concurrent_ExecutionContext__s_concurrent_Future = (function(f, executor) {
  return $as_s_concurrent_Future($p_s_concurrent_impl_Promise$DefaultPromise__dispatchOrAddCallbacks__O__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks(this, this.ju_concurrent_atomic_AtomicReference__f_value, $ct_s_concurrent_impl_Promise$Transformation__I__F1__s_concurrent_ExecutionContext__(new $c_s_concurrent_impl_Promise$Transformation(), 3, f, executor)))
});
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.foreach__F1__s_concurrent_ExecutionContext__V = (function(f, executor) {
  var state = this.ju_concurrent_atomic_AtomicReference__f_value;
  if ((!(state instanceof $c_s_util_Failure))) {
    $p_s_concurrent_impl_Promise$DefaultPromise__dispatchOrAddCallbacks__O__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks(this, state, $ct_s_concurrent_impl_Promise$Transformation__I__F1__s_concurrent_ExecutionContext__(new $c_s_concurrent_impl_Promise$Transformation(), 5, f, executor))
  }
});
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.flatMap__F1__s_concurrent_ExecutionContext__s_concurrent_Future = (function(f, executor) {
  var state = this.ju_concurrent_atomic_AtomicReference__f_value;
  return ((!(state instanceof $c_s_util_Failure)) ? $as_s_concurrent_Future($p_s_concurrent_impl_Promise$DefaultPromise__dispatchOrAddCallbacks__O__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks(this, state, $ct_s_concurrent_impl_Promise$Transformation__I__F1__s_concurrent_ExecutionContext__(new $c_s_concurrent_impl_Promise$Transformation(), 2, f, executor))) : this)
});
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.map__F1__s_concurrent_ExecutionContext__s_concurrent_Future = (function(f, executor) {
  var state = this.ju_concurrent_atomic_AtomicReference__f_value;
  return ((!(state instanceof $c_s_util_Failure)) ? $as_s_concurrent_Future($p_s_concurrent_impl_Promise$DefaultPromise__dispatchOrAddCallbacks__O__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks(this, state, $ct_s_concurrent_impl_Promise$Transformation__I__F1__s_concurrent_ExecutionContext__(new $c_s_concurrent_impl_Promise$Transformation(), 1, f, executor))) : this)
});
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.recover__s_PartialFunction__s_concurrent_ExecutionContext__s_concurrent_Future = (function(pf, executor) {
  var state = this.ju_concurrent_atomic_AtomicReference__f_value;
  return ((!(state instanceof $c_s_util_Success)) ? $as_s_concurrent_Future($p_s_concurrent_impl_Promise$DefaultPromise__dispatchOrAddCallbacks__O__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks(this, state, $ct_s_concurrent_impl_Promise$Transformation__I__F1__s_concurrent_ExecutionContext__(new $c_s_concurrent_impl_Promise$Transformation(), 7, pf, executor))) : this)
});
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.onComplete__F1__s_concurrent_ExecutionContext__V = (function(func, executor) {
  $p_s_concurrent_impl_Promise$DefaultPromise__dispatchOrAddCallbacks__O__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks(this, this.ju_concurrent_atomic_AtomicReference__f_value, $ct_s_concurrent_impl_Promise$Transformation__I__F1__s_concurrent_ExecutionContext__(new $c_s_concurrent_impl_Promise$Transformation(), 6, func, executor))
});
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.toString__T = (function() {
  var _$this = this;
  while (true) {
    var state = _$this.ju_concurrent_atomic_AtomicReference__f_value;
    if ((state instanceof $c_s_util_Try)) {
      return (("Future(" + state) + ")")
    } else if ((state instanceof $c_s_concurrent_impl_Promise$Link)) {
      _$this = $as_s_concurrent_impl_Promise$Link(state).promise__s_concurrent_impl_Promise$DefaultPromise__s_concurrent_impl_Promise$DefaultPromise(_$this)
    } else {
      return "Future(<not completed>)"
    }
  }
});
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.tryComplete__s_util_Try__Z = (function(value) {
  var state = this.ju_concurrent_atomic_AtomicReference__f_value;
  return ((!(state instanceof $c_s_util_Try)) && this.tryComplete0__O__s_util_Try__Z(state, $m_s_concurrent_impl_Promise$().scala$concurrent$impl$Promise$$resolve__s_util_Try__s_util_Try(value)))
});
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.tryComplete0__O__s_util_Try__Z = (function(state, resolved) {
  var _$this = this;
  while (true) {
    if ($is_s_concurrent_impl_Promise$Callbacks(state)) {
      if (_$this.compareAndSet__O__O__Z(state, resolved)) {
        if ((state !== $m_s_concurrent_impl_Promise$().s_concurrent_impl_Promise$__f_scala$concurrent$impl$Promise$$Noop)) {
          $p_s_concurrent_impl_Promise$DefaultPromise__submitWithValue__s_concurrent_impl_Promise$Callbacks__s_util_Try__V(_$this, $as_s_concurrent_impl_Promise$Callbacks(state), resolved)
        };
        return true
      } else {
        state = _$this.ju_concurrent_atomic_AtomicReference__f_value
      }
    } else if ((state instanceof $c_s_concurrent_impl_Promise$Link)) {
      var p = $as_s_concurrent_impl_Promise$Link(state).promise__s_concurrent_impl_Promise$DefaultPromise__s_concurrent_impl_Promise$DefaultPromise(_$this);
      if ((p !== _$this)) {
        var temp$state$2 = p.ju_concurrent_atomic_AtomicReference__f_value;
        _$this = p;
        state = temp$state$2
      } else {
        return false
      }
    } else {
      return false
    }
  }
});
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.completeWith__s_concurrent_Future__s_concurrent_impl_Promise$DefaultPromise = (function(other) {
  if ((other !== this)) {
    var state = this.ju_concurrent_atomic_AtomicReference__f_value;
    if ((!(state instanceof $c_s_util_Try))) {
      if ((other instanceof $c_s_concurrent_impl_Promise$DefaultPromise)) {
        var resolved = $p_s_concurrent_impl_Promise$DefaultPromise__value0__s_util_Try($as_s_concurrent_impl_Promise$DefaultPromise(other))
      } else {
        var this$2 = $m_s_Option$().apply__O__s_Option($p_s_concurrent_impl_Promise$DefaultPromise__value0__s_util_Try(other));
        $m_s_$less$colon$less$();
        var resolved = $as_s_util_Try((this$2.isEmpty__Z() ? null : this$2.get__O()))
      };
      if ((resolved !== null)) {
        this.tryComplete0__O__s_util_Try__Z(state, resolved)
      } else {
        other.onComplete__F1__s_concurrent_ExecutionContext__V(this, $m_s_concurrent_ExecutionContext$parasitic$())
      }
    }
  };
  return this
});
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.linkRootOf__s_concurrent_impl_Promise$DefaultPromise__s_concurrent_impl_Promise$Link__V = (function(target, link) {
  var _$this = this;
  while (true) {
    if ((_$this !== target)) {
      var state = _$this.ju_concurrent_atomic_AtomicReference__f_value;
      if ((state instanceof $c_s_util_Try)) {
        if ((!target.tryComplete0__O__s_util_Try__Z(target.ju_concurrent_atomic_AtomicReference__f_value, $as_s_util_Try(state)))) {
          throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "Cannot link completed promises together")
        }
      } else if ($is_s_concurrent_impl_Promise$Callbacks(state)) {
        var l = ((link !== null) ? link : new $c_s_concurrent_impl_Promise$Link(target));
        var p = l.promise__s_concurrent_impl_Promise$DefaultPromise__s_concurrent_impl_Promise$DefaultPromise(_$this);
        if (((_$this !== p) && _$this.compareAndSet__O__O__Z(state, l))) {
          if ((state !== $m_s_concurrent_impl_Promise$().s_concurrent_impl_Promise$__f_scala$concurrent$impl$Promise$$Noop)) {
            $p_s_concurrent_impl_Promise$DefaultPromise__dispatchOrAddCallbacks__O__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks(p, p.ju_concurrent_atomic_AtomicReference__f_value, $as_s_concurrent_impl_Promise$Callbacks(state))
          }
        } else {
          target = p;
          link = l;
          continue
        }
      } else {
        _$this = $as_s_concurrent_impl_Promise$Link(state).promise__s_concurrent_impl_Promise$DefaultPromise__s_concurrent_impl_Promise$DefaultPromise(_$this);
        continue
      }
    };
    break
  }
});
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.unlink__s_util_Try__V = (function(resolved) {
  var _$this = this;
  while (true) {
    var state = _$this.ju_concurrent_atomic_AtomicReference__f_value;
    if ((state instanceof $c_s_concurrent_impl_Promise$Link)) {
      var next = (_$this.compareAndSet__O__O__Z(state, resolved) ? $as_s_concurrent_impl_Promise$DefaultPromise($as_s_concurrent_impl_Promise$Link(state).ju_concurrent_atomic_AtomicReference__f_value) : _$this);
      _$this = next;
      continue
    } else {
      _$this.tryComplete0__O__s_util_Try__Z(state, resolved)
    };
    break
  }
});
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.apply__O__O = (function(v1) {
  var resolved = $as_s_util_Try(v1);
  this.tryComplete0__O__s_util_Try__Z(this.ju_concurrent_atomic_AtomicReference__f_value, resolved)
});
function $as_s_concurrent_impl_Promise$DefaultPromise(obj) {
  return (((obj instanceof $c_s_concurrent_impl_Promise$DefaultPromise) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.concurrent.impl.Promise$DefaultPromise"))
}
function $isArrayOf_s_concurrent_impl_Promise$DefaultPromise(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_concurrent_impl_Promise$DefaultPromise)))
}
function $asArrayOf_s_concurrent_impl_Promise$DefaultPromise(obj, depth) {
  return (($isArrayOf_s_concurrent_impl_Promise$DefaultPromise(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.concurrent.impl.Promise$DefaultPromise;", depth))
}
var $d_s_concurrent_impl_Promise$DefaultPromise = new $TypeData().initClass({
  s_concurrent_impl_Promise$DefaultPromise: 0
}, false, "scala.concurrent.impl.Promise$DefaultPromise", {
  s_concurrent_impl_Promise$DefaultPromise: 1,
  ju_concurrent_atomic_AtomicReference: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  s_concurrent_Promise: 1,
  s_concurrent_Future: 1,
  s_concurrent_Awaitable: 1,
  F1: 1
});
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.$classData = $d_s_concurrent_impl_Promise$DefaultPromise;
/** @constructor */
function $c_s_reflect_AnyValManifest() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_hashCode = 0
}
$c_s_reflect_AnyValManifest.prototype = new $h_O();
$c_s_reflect_AnyValManifest.prototype.constructor = $c_s_reflect_AnyValManifest;
/** @constructor */
function $h_s_reflect_AnyValManifest() {
  /*<skip>*/
}
$h_s_reflect_AnyValManifest.prototype = $c_s_reflect_AnyValManifest.prototype;
$c_s_reflect_AnyValManifest.prototype.toString__T = (function() {
  return this.s_reflect_AnyValManifest__f_toString
});
$c_s_reflect_AnyValManifest.prototype.equals__O__Z = (function(that) {
  return (this === that)
});
$c_s_reflect_AnyValManifest.prototype.hashCode__I = (function() {
  return this.s_reflect_AnyValManifest__f_hashCode
});
/** @constructor */
function $c_s_reflect_ManifestFactory$ClassTypeManifest() {
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_prefix = null;
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_runtimeClass1 = null;
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_typeArguments = null
}
$c_s_reflect_ManifestFactory$ClassTypeManifest.prototype = new $h_O();
$c_s_reflect_ManifestFactory$ClassTypeManifest.prototype.constructor = $c_s_reflect_ManifestFactory$ClassTypeManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$ClassTypeManifest() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$ClassTypeManifest.prototype = $c_s_reflect_ManifestFactory$ClassTypeManifest.prototype;
/** @constructor */
function $c_sjs_js_JavaScriptException(exception) {
  this.jl_Throwable__f_s = null;
  this.jl_Throwable__f_e = null;
  this.jl_Throwable__f_enableSuppression = false;
  this.jl_Throwable__f_writableStackTrace = false;
  this.jl_Throwable__f_stackTraceStateInternal = null;
  this.jl_Throwable__f_stackTrace = null;
  this.jl_Throwable__f_suppressed = null;
  this.sjs_js_JavaScriptException__f_exception = null;
  this.sjs_js_JavaScriptException__f_exception = exception;
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true)
}
$c_sjs_js_JavaScriptException.prototype = new $h_jl_RuntimeException();
$c_sjs_js_JavaScriptException.prototype.constructor = $c_sjs_js_JavaScriptException;
/** @constructor */
function $h_sjs_js_JavaScriptException() {
  /*<skip>*/
}
$h_sjs_js_JavaScriptException.prototype = $c_sjs_js_JavaScriptException.prototype;
$c_sjs_js_JavaScriptException.prototype.getMessage__T = (function() {
  return $dp_toString__T(this.sjs_js_JavaScriptException__f_exception)
});
$c_sjs_js_JavaScriptException.prototype.fillInStackTrace__jl_Throwable = (function() {
  this.setStackTraceStateInternal__O__(this.sjs_js_JavaScriptException__f_exception);
  return this
});
$c_sjs_js_JavaScriptException.prototype.productPrefix__T = (function() {
  return "JavaScriptException"
});
$c_sjs_js_JavaScriptException.prototype.productArity__I = (function() {
  return 1
});
$c_sjs_js_JavaScriptException.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.sjs_js_JavaScriptException__f_exception : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_sjs_js_JavaScriptException.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_sjs_js_JavaScriptException.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_sjs_js_JavaScriptException.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_sjs_js_JavaScriptException)) {
    var JavaScriptException$1 = $as_sjs_js_JavaScriptException(x$1);
    var x = this.sjs_js_JavaScriptException__f_exception;
    var y = JavaScriptException$1.sjs_js_JavaScriptException__f_exception;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y)
  } else {
    return false
  }
});
$c_sjs_js_JavaScriptException.prototype.setStackTraceStateInternal__O__ = (function(e) {
  this.jl_Throwable__f_stackTraceStateInternal = e
});
function $as_sjs_js_JavaScriptException(obj) {
  return (((obj instanceof $c_sjs_js_JavaScriptException) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.scalajs.js.JavaScriptException"))
}
function $isArrayOf_sjs_js_JavaScriptException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sjs_js_JavaScriptException)))
}
function $asArrayOf_sjs_js_JavaScriptException(obj, depth) {
  return (($isArrayOf_sjs_js_JavaScriptException(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.scalajs.js.JavaScriptException;", depth))
}
var $d_sjs_js_JavaScriptException = new $TypeData().initClass({
  sjs_js_JavaScriptException: 0
}, false, "scala.scalajs.js.JavaScriptException", {
  sjs_js_JavaScriptException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  s_Product: 1,
  s_Equals: 1
});
$c_sjs_js_JavaScriptException.prototype.$classData = $d_sjs_js_JavaScriptException;
function $as_Lscommons_api_http_ApiHttpStatusException(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "scommons.api.http.ApiHttpStatusException"))
}
function $isArrayOf_Lscommons_api_http_ApiHttpStatusException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscommons_api_http_ApiHttpStatusException)))
}
function $asArrayOf_Lscommons_api_http_ApiHttpStatusException(obj, depth) {
  return (($isArrayOf_Lscommons_api_http_ApiHttpStatusException(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscommons.api.http.ApiHttpStatusException;", depth))
}
function $p_jl_JSConsoleBasedPrintStream__doWriteLine__T__V($thiz, line) {
  if (($as_T((typeof console)) !== "undefined")) {
    if ($thiz.jl_JSConsoleBasedPrintStream__f_isErr) {
      var x = console.error;
      var $$x1 = $uZ((!(!x)))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      console.error(line)
    } else {
      console.log(line)
    }
  }
}
/** @constructor */
function $c_jl_JSConsoleBasedPrintStream(isErr) {
  this.Ljava_io_FilterOutputStream__f_out = null;
  this.Ljava_io_PrintStream__f_encoder = null;
  this.Ljava_io_PrintStream__f_autoFlush = false;
  this.Ljava_io_PrintStream__f_charset = null;
  this.Ljava_io_PrintStream__f_closing = false;
  this.Ljava_io_PrintStream__f_java$io$PrintStream$$closed = false;
  this.Ljava_io_PrintStream__f_errorFlag = false;
  this.Ljava_io_PrintStream__f_bitmap$0 = false;
  this.jl_JSConsoleBasedPrintStream__f_isErr = false;
  this.jl_JSConsoleBasedPrintStream__f_flushed = false;
  this.jl_JSConsoleBasedPrintStream__f_buffer = null;
  this.jl_JSConsoleBasedPrintStream__f_isErr = isErr;
  var out = new $c_jl_JSConsoleBasedPrintStream$DummyOutputStream();
  $ct_Ljava_io_PrintStream__Ljava_io_OutputStream__Z__Ljava_nio_charset_Charset__(this, out, false, null);
  this.jl_JSConsoleBasedPrintStream__f_flushed = true;
  this.jl_JSConsoleBasedPrintStream__f_buffer = ""
}
$c_jl_JSConsoleBasedPrintStream.prototype = new $h_Ljava_io_PrintStream();
$c_jl_JSConsoleBasedPrintStream.prototype.constructor = $c_jl_JSConsoleBasedPrintStream;
/** @constructor */
function $h_jl_JSConsoleBasedPrintStream() {
  /*<skip>*/
}
$h_jl_JSConsoleBasedPrintStream.prototype = $c_jl_JSConsoleBasedPrintStream.prototype;
$c_jl_JSConsoleBasedPrintStream.prototype.print__T__V = (function(s) {
  this.java$lang$JSConsoleBasedPrintStream$$printString__T__V(((s === null) ? "null" : s))
});
$c_jl_JSConsoleBasedPrintStream.prototype.java$lang$JSConsoleBasedPrintStream$$printString__T__V = (function(s) {
  var rest = s;
  while ((rest !== "")) {
    var this$1 = rest;
    var nlPos = $uI(this$1.indexOf("\n"));
    if ((nlPos < 0)) {
      this.jl_JSConsoleBasedPrintStream__f_buffer = (("" + this.jl_JSConsoleBasedPrintStream__f_buffer) + rest);
      this.jl_JSConsoleBasedPrintStream__f_flushed = false;
      rest = ""
    } else {
      var $$x1 = this.jl_JSConsoleBasedPrintStream__f_buffer;
      var this$3 = rest;
      $p_jl_JSConsoleBasedPrintStream__doWriteLine__T__V(this, (("" + $$x1) + $as_T(this$3.substring(0, nlPos))));
      this.jl_JSConsoleBasedPrintStream__f_buffer = "";
      this.jl_JSConsoleBasedPrintStream__f_flushed = true;
      var this$4 = rest;
      var beginIndex = ((1 + nlPos) | 0);
      rest = $as_T(this$4.substring(beginIndex))
    }
  }
});
var $d_jl_JSConsoleBasedPrintStream = new $TypeData().initClass({
  jl_JSConsoleBasedPrintStream: 0
}, false, "java.lang.JSConsoleBasedPrintStream", {
  jl_JSConsoleBasedPrintStream: 1,
  Ljava_io_PrintStream: 1,
  Ljava_io_FilterOutputStream: 1,
  Ljava_io_OutputStream: 1,
  O: 1,
  Ljava_io_Closeable: 1,
  jl_AutoCloseable: 1,
  Ljava_io_Flushable: 1,
  jl_Appendable: 1
});
$c_jl_JSConsoleBasedPrintStream.prototype.$classData = $d_jl_JSConsoleBasedPrintStream;
function $p_sc_StrictOptimizedLinearSeqOps__loop$2__I__sc_LinearSeq__sc_LinearSeq($thiz, n, s) {
  while (true) {
    if (((n <= 0) || s.isEmpty__Z())) {
      return s
    } else {
      var temp$n = (((-1) + n) | 0);
      var temp$s = $as_sc_LinearSeq(s.tail__O());
      n = temp$n;
      s = temp$s
    }
  }
}
function $f_sc_StrictOptimizedMapOps__map__F1__sc_IterableOps($thiz, f) {
  var b = $thiz.mapFactory__sc_MapFactory().newBuilder__scm_Builder();
  var it = $thiz.iterator__sc_Iterator();
  while (it.hasNext__Z()) {
    var elem = f.apply__O__O(it.next__O());
    b.addOne__O__scm_Growable(elem)
  };
  return $as_sc_IterableOps(b.result__O())
}
function $f_sc_StrictOptimizedMapOps__concat__sc_IterableOnce__sc_IterableOps($thiz, suffix) {
  var b = $thiz.mapFactory__sc_MapFactory().newBuilder__scm_Builder();
  b.addAll__sc_IterableOnce__scm_Growable($thiz);
  b.addAll__sc_IterableOnce__scm_Growable(suffix);
  return $as_sc_IterableOps(b.result__O())
}
function $p_s_math_BigDecimal__computeHashCode__V($thiz) {
  if ($thiz.isWhole__Z()) {
    var $$x3 = $thiz.s_math_BigDecimal__f_bigDecimal.precision__I();
    var this$1 = $thiz.s_math_BigDecimal__f_bigDecimal;
    var $$x2 = ((($$x3 - this$1.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale) | 0) < 4934)
  } else {
    var $$x2 = false
  };
  if ($$x2) {
    var $$x1 = $thiz.toBigInt__s_math_BigInt().hashCode__I()
  } else if ($thiz.isDecimalDouble__Z()) {
    var dv = $thiz.s_math_BigDecimal__f_bigDecimal.doubleValue__D();
    var $$x1 = $m_sr_Statics$().doubleHash__D__I(dv)
  } else {
    var temp = $thiz.s_math_BigDecimal__f_bigDecimal.stripTrailingZeros__Ljava_math_BigDecimal();
    var $$x1 = $m_s_util_hashing_MurmurHash3$().mixLast__I__I__I(temp.scaleByPowerOfTen__I__Ljava_math_BigDecimal(temp.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale).toBigInteger__Ljava_math_BigInteger().hashCode__I(), temp.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale)
  };
  $thiz.s_math_BigDecimal__f_computedHashCode = $$x1
}
/** @constructor */
function $c_s_math_BigDecimal(bigDecimal, mc) {
  this.s_math_BigDecimal__f_bigDecimal = null;
  this.s_math_BigDecimal__f_mc = null;
  this.s_math_BigDecimal__f_computedHashCode = 0;
  this.s_math_BigDecimal__f_bigDecimal = bigDecimal;
  this.s_math_BigDecimal__f_mc = mc;
  if ((bigDecimal === null)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "null value for BigDecimal")
  };
  if ((mc === null)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "null MathContext for BigDecimal")
  };
  this.s_math_BigDecimal__f_computedHashCode = 1565550863
}
$c_s_math_BigDecimal.prototype = new $h_s_math_ScalaNumber();
$c_s_math_BigDecimal.prototype.constructor = $c_s_math_BigDecimal;
/** @constructor */
function $h_s_math_BigDecimal() {
  /*<skip>*/
}
$h_s_math_BigDecimal.prototype = $c_s_math_BigDecimal.prototype;
$c_s_math_BigDecimal.prototype.hashCode__I = (function() {
  if ((this.s_math_BigDecimal__f_computedHashCode === 1565550863)) {
    $p_s_math_BigDecimal__computeHashCode__V(this)
  };
  return this.s_math_BigDecimal__f_computedHashCode
});
$c_s_math_BigDecimal.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_s_math_BigDecimal)) {
    var x2 = $as_s_math_BigDecimal(that);
    return this.equals__s_math_BigDecimal__Z(x2)
  } else if ((that instanceof $c_s_math_BigInt)) {
    var x3 = $as_s_math_BigInt(that);
    var this$1 = x3.s_math_BigInt__f_bigInteger;
    var $$x2 = $m_Ljava_math_BitLevel$().bitLength__Ljava_math_BigInteger__I(this$1);
    var $$x1 = this.s_math_BigDecimal__f_bigDecimal.precision__I();
    var this$2 = this.s_math_BigDecimal__f_bigDecimal;
    if (($$x2 > (3.3219280948873626 * (((-2) + (($$x1 - this$2.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale) | 0)) | 0)))) {
      var this$3 = this.toBigIntExact__s_Option();
      if ((!this$3.isEmpty__Z())) {
        var arg1 = this$3.get__O();
        var x$1 = $as_s_math_BigInt(arg1);
        return x3.equals__s_math_BigInt__Z(x$1)
      } else {
        return false
      }
    } else {
      return false
    }
  } else if (((typeof that) === "number")) {
    var x4 = $uD(that);
    if ((!((x4 === Infinity) || (x4 === (-Infinity))))) {
      var d = this.s_math_BigDecimal__f_bigDecimal.doubleValue__D();
      if (((!((d === Infinity) || (d === (-Infinity)))) && (d === x4))) {
        var this$10 = $m_s_math_BigDecimal$();
        return this.equals__s_math_BigDecimal__Z(this$10.decimal__D__Ljava_math_MathContext__s_math_BigDecimal(d, this$10.s_math_BigDecimal$__f_defaultMathContext))
      } else {
        return false
      }
    } else {
      return false
    }
  } else if (((typeof that) === "number")) {
    var x5 = $uF(that);
    if ((!((x5 === Infinity) || (x5 === (-Infinity))))) {
      var f = this.s_math_BigDecimal__f_bigDecimal.floatValue__F();
      if (((!((f === Infinity) || (f === (-Infinity)))) && (f === x5))) {
        var this$17 = $m_s_math_BigDecimal$();
        var d$1 = f;
        return this.equals__s_math_BigDecimal__Z(this$17.decimal__D__Ljava_math_MathContext__s_math_BigDecimal(d$1, this$17.s_math_BigDecimal$__f_defaultMathContext))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return (this.isValidLong__Z() && $f_s_math_ScalaNumericAnyConversions__unifiedPrimitiveEquals__O__Z(this, that))
  }
});
$c_s_math_BigDecimal.prototype.isValidByte__Z = (function() {
  try {
    this.s_math_BigDecimal__f_bigDecimal.byteValueExact__B();
    return true
  } catch (e) {
    if ((e instanceof $c_jl_ArithmeticException)) {
      return false
    } else {
      throw e
    }
  }
});
$c_s_math_BigDecimal.prototype.isValidShort__Z = (function() {
  try {
    this.s_math_BigDecimal__f_bigDecimal.shortValueExact__S();
    return true
  } catch (e) {
    if ((e instanceof $c_jl_ArithmeticException)) {
      return false
    } else {
      throw e
    }
  }
});
$c_s_math_BigDecimal.prototype.isValidChar__Z = (function() {
  return ((this.isValidInt__Z() && (this.s_math_BigDecimal__f_bigDecimal.intValueExact__I() >= 0)) && (this.s_math_BigDecimal__f_bigDecimal.intValueExact__I() <= 65535))
});
$c_s_math_BigDecimal.prototype.isValidInt__Z = (function() {
  try {
    this.s_math_BigDecimal__f_bigDecimal.intValueExact__I();
    return true
  } catch (e) {
    if ((e instanceof $c_jl_ArithmeticException)) {
      return false
    } else {
      throw e
    }
  }
});
$c_s_math_BigDecimal.prototype.isValidLong__Z = (function() {
  try {
    var this$1 = this.s_math_BigDecimal__f_bigDecimal;
    $p_Ljava_math_BigDecimal__valueExact__I__J(this$1, 64);
    return true
  } catch (e) {
    if ((e instanceof $c_jl_ArithmeticException)) {
      return false
    } else {
      throw e
    }
  }
});
$c_s_math_BigDecimal.prototype.isDecimalDouble__Z = (function() {
  var d = this.s_math_BigDecimal__f_bigDecimal.doubleValue__D();
  if ((!((d === Infinity) || (d === (-Infinity))))) {
    var this$4 = $m_s_math_BigDecimal$();
    return this.equals__s_math_BigDecimal__Z(this$4.decimal__D__Ljava_math_MathContext__s_math_BigDecimal(d, this$4.s_math_BigDecimal$__f_defaultMathContext))
  } else {
    return false
  }
});
$c_s_math_BigDecimal.prototype.isWhole__Z = (function() {
  var this$1 = this.s_math_BigDecimal__f_bigDecimal;
  if ((this$1.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale <= 0)) {
    return true
  } else {
    var this$2 = this.s_math_BigDecimal__f_bigDecimal.stripTrailingZeros__Ljava_math_BigDecimal();
    return (this$2.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale <= 0)
  }
});
$c_s_math_BigDecimal.prototype.equals__s_math_BigDecimal__Z = (function(that) {
  return (this.s_math_BigDecimal__f_bigDecimal.compareTo__Ljava_math_BigDecimal__I(that.s_math_BigDecimal__f_bigDecimal) === 0)
});
$c_s_math_BigDecimal.prototype.byteValue__B = (function() {
  return ((this.s_math_BigDecimal__f_bigDecimal.intValue__I() << 24) >> 24)
});
$c_s_math_BigDecimal.prototype.shortValue__S = (function() {
  return ((this.s_math_BigDecimal__f_bigDecimal.intValue__I() << 16) >> 16)
});
$c_s_math_BigDecimal.prototype.intValue__I = (function() {
  return this.s_math_BigDecimal__f_bigDecimal.intValue__I()
});
$c_s_math_BigDecimal.prototype.longValue__J = (function() {
  return this.s_math_BigDecimal__f_bigDecimal.longValue__J()
});
$c_s_math_BigDecimal.prototype.floatValue__F = (function() {
  return this.s_math_BigDecimal__f_bigDecimal.floatValue__F()
});
$c_s_math_BigDecimal.prototype.doubleValue__D = (function() {
  return this.s_math_BigDecimal__f_bigDecimal.doubleValue__D()
});
$c_s_math_BigDecimal.prototype.toBigInt__s_math_BigInt = (function() {
  return new $c_s_math_BigInt(this.s_math_BigDecimal__f_bigDecimal.toBigInteger__Ljava_math_BigInteger())
});
$c_s_math_BigDecimal.prototype.toBigIntExact__s_Option = (function() {
  if (this.isWhole__Z()) {
    try {
      return new $c_s_Some(new $c_s_math_BigInt(this.s_math_BigDecimal__f_bigDecimal.toBigIntegerExact__Ljava_math_BigInteger()))
    } catch (e) {
      if ((e instanceof $c_jl_ArithmeticException)) {
        return $m_s_None$()
      } else {
        throw e
      }
    }
  } else {
    return $m_s_None$()
  }
});
$c_s_math_BigDecimal.prototype.toString__T = (function() {
  return this.s_math_BigDecimal__f_bigDecimal.toString__T()
});
$c_s_math_BigDecimal.prototype.compare__O__I = (function(that) {
  var that$1 = $as_s_math_BigDecimal(that);
  return this.s_math_BigDecimal__f_bigDecimal.compareTo__Ljava_math_BigDecimal__I(that$1.s_math_BigDecimal__f_bigDecimal)
});
$c_s_math_BigDecimal.prototype.underlying__O = (function() {
  return this.s_math_BigDecimal__f_bigDecimal
});
function $as_s_math_BigDecimal(obj) {
  return (((obj instanceof $c_s_math_BigDecimal) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.math.BigDecimal"))
}
function $isArrayOf_s_math_BigDecimal(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_math_BigDecimal)))
}
function $asArrayOf_s_math_BigDecimal(obj, depth) {
  return (($isArrayOf_s_math_BigDecimal(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.math.BigDecimal;", depth))
}
var $d_s_math_BigDecimal = new $TypeData().initClass({
  s_math_BigDecimal: 0
}, false, "scala.math.BigDecimal", {
  s_math_BigDecimal: 1,
  s_math_ScalaNumber: 1,
  jl_Number: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  s_math_ScalaNumericConversions: 1,
  s_math_ScalaNumericAnyConversions: 1,
  s_math_Ordered: 1,
  jl_Comparable: 1
});
$c_s_math_BigDecimal.prototype.$classData = $d_s_math_BigDecimal;
function $p_s_math_BigInt__bitLengthOverflow__Z($thiz) {
  var shifted = $thiz.s_math_BigInt__f_bigInteger.shiftRight__I__Ljava_math_BigInteger(2147483647);
  return ((shifted.Ljava_math_BigInteger__f_sign !== 0) && (!shifted.equals__O__Z($m_s_math_BigInt$().s_math_BigInt$__f_scala$math$BigInt$$minusOne)))
}
/** @constructor */
function $c_s_math_BigInt(bigInteger) {
  this.s_math_BigInt__f_bigInteger = null;
  this.s_math_BigInt__f_bigInteger = bigInteger
}
$c_s_math_BigInt.prototype = new $h_s_math_ScalaNumber();
$c_s_math_BigInt.prototype.constructor = $c_s_math_BigInt;
/** @constructor */
function $h_s_math_BigInt() {
  /*<skip>*/
}
$h_s_math_BigInt.prototype = $c_s_math_BigInt.prototype;
$c_s_math_BigInt.prototype.hashCode__I = (function() {
  if (this.isValidLong__Z()) {
    return $f_s_math_ScalaNumericAnyConversions__unifiedPrimitiveHashcode__I(this)
  } else {
    var x = this.s_math_BigInt__f_bigInteger;
    return $m_sr_Statics$().anyHash__O__I(x)
  }
});
$c_s_math_BigInt.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_s_math_BigInt)) {
    var x2 = $as_s_math_BigInt(that);
    return this.equals__s_math_BigInt__Z(x2)
  } else if ((that instanceof $c_s_math_BigDecimal)) {
    var x3 = $as_s_math_BigDecimal(that);
    return x3.equals__O__Z(this)
  } else if (((typeof that) === "number")) {
    var x4 = $uD(that);
    if (this.isValidDouble__Z()) {
      var this$1 = this.s_math_BigInt__f_bigInteger;
      var s = $m_Ljava_math_Conversion$().toDecimalScaledString__Ljava_math_BigInteger__T(this$1);
      return ($m_jl_Double$().parseDouble__T__D(s) === x4)
    } else {
      return false
    }
  } else if (((typeof that) === "number")) {
    var x5 = $uF(that);
    if (this.isValidFloat__Z()) {
      var this$2 = this.s_math_BigInt__f_bigInteger;
      var s$1 = $m_Ljava_math_Conversion$().toDecimalScaledString__Ljava_math_BigInteger__T(this$2);
      return ($m_jl_Float$().parseFloat__T__F(s$1) === x5)
    } else {
      return false
    }
  } else {
    return (this.isValidLong__Z() && $f_s_math_ScalaNumericAnyConversions__unifiedPrimitiveEquals__O__Z(this, that))
  }
});
$c_s_math_BigInt.prototype.isValidByte__Z = (function() {
  var this$1 = $m_s_math_BigInt$();
  var that = this$1.apply__I__s_math_BigInt((-128));
  if ($f_s_math_Ordered__$greater$eq__O__Z(this, that)) {
    var this$2 = $m_s_math_BigInt$();
    var that$1 = this$2.apply__I__s_math_BigInt(127);
    return $f_s_math_Ordered__$less$eq__O__Z(this, that$1)
  } else {
    return false
  }
});
$c_s_math_BigInt.prototype.isValidShort__Z = (function() {
  var this$1 = $m_s_math_BigInt$();
  var that = this$1.apply__I__s_math_BigInt((-32768));
  if ($f_s_math_Ordered__$greater$eq__O__Z(this, that)) {
    var this$2 = $m_s_math_BigInt$();
    var that$1 = this$2.apply__I__s_math_BigInt(32767);
    return $f_s_math_Ordered__$less$eq__O__Z(this, that$1)
  } else {
    return false
  }
});
$c_s_math_BigInt.prototype.isValidChar__Z = (function() {
  var this$1 = $m_s_math_BigInt$();
  var that = this$1.apply__I__s_math_BigInt(0);
  if ($f_s_math_Ordered__$greater$eq__O__Z(this, that)) {
    var this$2 = $m_s_math_BigInt$();
    var that$1 = this$2.apply__I__s_math_BigInt(65535);
    return $f_s_math_Ordered__$less$eq__O__Z(this, that$1)
  } else {
    return false
  }
});
$c_s_math_BigInt.prototype.isValidInt__Z = (function() {
  var this$1 = $m_s_math_BigInt$();
  var that = this$1.apply__I__s_math_BigInt((-2147483648));
  if ($f_s_math_Ordered__$greater$eq__O__Z(this, that)) {
    var this$2 = $m_s_math_BigInt$();
    var that$1 = this$2.apply__I__s_math_BigInt(2147483647);
    return $f_s_math_Ordered__$less$eq__O__Z(this, that$1)
  } else {
    return false
  }
});
$c_s_math_BigInt.prototype.isValidLong__Z = (function() {
  var this$1 = $m_s_math_BigInt$();
  var that = this$1.apply__J__s_math_BigInt(new $c_RTLong(0, (-2147483648)));
  if ($f_s_math_Ordered__$greater$eq__O__Z(this, that)) {
    var this$2 = $m_s_math_BigInt$();
    var that$1 = this$2.apply__J__s_math_BigInt(new $c_RTLong((-1), 2147483647));
    return $f_s_math_Ordered__$less$eq__O__Z(this, that$1)
  } else {
    return false
  }
});
$c_s_math_BigInt.prototype.isValidFloat__Z = (function() {
  var this$1 = this.s_math_BigInt__f_bigInteger;
  var bitLen = $m_Ljava_math_BitLevel$().bitLength__Ljava_math_BigInteger__I(this$1);
  if ((bitLen <= 24)) {
    var $$x1 = true
  } else {
    var lowest = this.s_math_BigInt__f_bigInteger.getLowestSetBit__I();
    var $$x1 = (((bitLen <= 128) && (lowest >= (((-24) + bitLen) | 0))) && (lowest < 128))
  };
  if ($$x1) {
    return (!$p_s_math_BigInt__bitLengthOverflow__Z(this))
  } else {
    return false
  }
});
$c_s_math_BigInt.prototype.isValidDouble__Z = (function() {
  var this$1 = this.s_math_BigInt__f_bigInteger;
  var bitLen = $m_Ljava_math_BitLevel$().bitLength__Ljava_math_BigInteger__I(this$1);
  if ((bitLen <= 53)) {
    var $$x1 = true
  } else {
    var lowest = this.s_math_BigInt__f_bigInteger.getLowestSetBit__I();
    var $$x1 = (((bitLen <= 1024) && (lowest >= (((-53) + bitLen) | 0))) && (lowest < 1024))
  };
  if ($$x1) {
    return (!$p_s_math_BigInt__bitLengthOverflow__Z(this))
  } else {
    return false
  }
});
$c_s_math_BigInt.prototype.equals__s_math_BigInt__Z = (function(that) {
  return (this.s_math_BigInt__f_bigInteger.compareTo__Ljava_math_BigInteger__I(that.s_math_BigInt__f_bigInteger) === 0)
});
$c_s_math_BigInt.prototype.byteValue__B = (function() {
  return ((this.s_math_BigInt__f_bigInteger.intValue__I() << 24) >> 24)
});
$c_s_math_BigInt.prototype.shortValue__S = (function() {
  return ((this.s_math_BigInt__f_bigInteger.intValue__I() << 16) >> 16)
});
$c_s_math_BigInt.prototype.intValue__I = (function() {
  return this.s_math_BigInt__f_bigInteger.intValue__I()
});
$c_s_math_BigInt.prototype.longValue__J = (function() {
  return this.s_math_BigInt__f_bigInteger.longValue__J()
});
$c_s_math_BigInt.prototype.floatValue__F = (function() {
  var this$1 = this.s_math_BigInt__f_bigInteger;
  var s = $m_Ljava_math_Conversion$().toDecimalScaledString__Ljava_math_BigInteger__T(this$1);
  return $m_jl_Float$().parseFloat__T__F(s)
});
$c_s_math_BigInt.prototype.doubleValue__D = (function() {
  var this$1 = this.s_math_BigInt__f_bigInteger;
  var s = $m_Ljava_math_Conversion$().toDecimalScaledString__Ljava_math_BigInteger__T(this$1);
  return $m_jl_Double$().parseDouble__T__D(s)
});
$c_s_math_BigInt.prototype.toString__T = (function() {
  var this$1 = this.s_math_BigInt__f_bigInteger;
  return $m_Ljava_math_Conversion$().toDecimalScaledString__Ljava_math_BigInteger__T(this$1)
});
$c_s_math_BigInt.prototype.compare__O__I = (function(that) {
  var that$1 = $as_s_math_BigInt(that);
  return this.s_math_BigInt__f_bigInteger.compareTo__Ljava_math_BigInteger__I(that$1.s_math_BigInt__f_bigInteger)
});
$c_s_math_BigInt.prototype.underlying__O = (function() {
  return this.s_math_BigInt__f_bigInteger
});
function $as_s_math_BigInt(obj) {
  return (((obj instanceof $c_s_math_BigInt) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.math.BigInt"))
}
function $isArrayOf_s_math_BigInt(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_math_BigInt)))
}
function $asArrayOf_s_math_BigInt(obj, depth) {
  return (($isArrayOf_s_math_BigInt(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.math.BigInt;", depth))
}
var $d_s_math_BigInt = new $TypeData().initClass({
  s_math_BigInt: 0
}, false, "scala.math.BigInt", {
  s_math_BigInt: 1,
  s_math_ScalaNumber: 1,
  jl_Number: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  s_math_ScalaNumericConversions: 1,
  s_math_ScalaNumericAnyConversions: 1,
  s_math_Ordered: 1,
  jl_Comparable: 1
});
$c_s_math_BigInt.prototype.$classData = $d_s_math_BigInt;
/** @constructor */
function $c_s_reflect_ManifestFactory$BooleanManifest() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_hashCode = 0
}
$c_s_reflect_ManifestFactory$BooleanManifest.prototype = new $h_s_reflect_AnyValManifest();
$c_s_reflect_ManifestFactory$BooleanManifest.prototype.constructor = $c_s_reflect_ManifestFactory$BooleanManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$BooleanManifest() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$BooleanManifest.prototype = $c_s_reflect_ManifestFactory$BooleanManifest.prototype;
$c_s_reflect_ManifestFactory$BooleanManifest.prototype.runtimeClass__jl_Class = (function() {
  return $d_Z.getClassOf()
});
$c_s_reflect_ManifestFactory$BooleanManifest.prototype.newArray__I__O = (function(len) {
  return new $ac_Z(len)
});
/** @constructor */
function $c_s_reflect_ManifestFactory$ByteManifest() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_hashCode = 0
}
$c_s_reflect_ManifestFactory$ByteManifest.prototype = new $h_s_reflect_AnyValManifest();
$c_s_reflect_ManifestFactory$ByteManifest.prototype.constructor = $c_s_reflect_ManifestFactory$ByteManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$ByteManifest() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$ByteManifest.prototype = $c_s_reflect_ManifestFactory$ByteManifest.prototype;
$c_s_reflect_ManifestFactory$ByteManifest.prototype.runtimeClass__jl_Class = (function() {
  return $d_B.getClassOf()
});
$c_s_reflect_ManifestFactory$ByteManifest.prototype.newArray__I__O = (function(len) {
  return new $ac_B(len)
});
/** @constructor */
function $c_s_reflect_ManifestFactory$CharManifest() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_hashCode = 0
}
$c_s_reflect_ManifestFactory$CharManifest.prototype = new $h_s_reflect_AnyValManifest();
$c_s_reflect_ManifestFactory$CharManifest.prototype.constructor = $c_s_reflect_ManifestFactory$CharManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$CharManifest() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$CharManifest.prototype = $c_s_reflect_ManifestFactory$CharManifest.prototype;
$c_s_reflect_ManifestFactory$CharManifest.prototype.runtimeClass__jl_Class = (function() {
  return $d_C.getClassOf()
});
$c_s_reflect_ManifestFactory$CharManifest.prototype.newArray__I__O = (function(len) {
  return new $ac_C(len)
});
/** @constructor */
function $c_s_reflect_ManifestFactory$DoubleManifest() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_hashCode = 0
}
$c_s_reflect_ManifestFactory$DoubleManifest.prototype = new $h_s_reflect_AnyValManifest();
$c_s_reflect_ManifestFactory$DoubleManifest.prototype.constructor = $c_s_reflect_ManifestFactory$DoubleManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$DoubleManifest() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$DoubleManifest.prototype = $c_s_reflect_ManifestFactory$DoubleManifest.prototype;
$c_s_reflect_ManifestFactory$DoubleManifest.prototype.runtimeClass__jl_Class = (function() {
  return $d_D.getClassOf()
});
$c_s_reflect_ManifestFactory$DoubleManifest.prototype.newArray__I__O = (function(len) {
  return new $ac_D(len)
});
/** @constructor */
function $c_s_reflect_ManifestFactory$FloatManifest() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_hashCode = 0
}
$c_s_reflect_ManifestFactory$FloatManifest.prototype = new $h_s_reflect_AnyValManifest();
$c_s_reflect_ManifestFactory$FloatManifest.prototype.constructor = $c_s_reflect_ManifestFactory$FloatManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$FloatManifest() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$FloatManifest.prototype = $c_s_reflect_ManifestFactory$FloatManifest.prototype;
$c_s_reflect_ManifestFactory$FloatManifest.prototype.runtimeClass__jl_Class = (function() {
  return $d_F.getClassOf()
});
$c_s_reflect_ManifestFactory$FloatManifest.prototype.newArray__I__O = (function(len) {
  return new $ac_F(len)
});
/** @constructor */
function $c_s_reflect_ManifestFactory$IntManifest() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_hashCode = 0
}
$c_s_reflect_ManifestFactory$IntManifest.prototype = new $h_s_reflect_AnyValManifest();
$c_s_reflect_ManifestFactory$IntManifest.prototype.constructor = $c_s_reflect_ManifestFactory$IntManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$IntManifest() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$IntManifest.prototype = $c_s_reflect_ManifestFactory$IntManifest.prototype;
$c_s_reflect_ManifestFactory$IntManifest.prototype.runtimeClass__jl_Class = (function() {
  return $d_I.getClassOf()
});
$c_s_reflect_ManifestFactory$IntManifest.prototype.newArray__I__O = (function(len) {
  return new $ac_I(len)
});
/** @constructor */
function $c_s_reflect_ManifestFactory$LongManifest() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_hashCode = 0
}
$c_s_reflect_ManifestFactory$LongManifest.prototype = new $h_s_reflect_AnyValManifest();
$c_s_reflect_ManifestFactory$LongManifest.prototype.constructor = $c_s_reflect_ManifestFactory$LongManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$LongManifest() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$LongManifest.prototype = $c_s_reflect_ManifestFactory$LongManifest.prototype;
$c_s_reflect_ManifestFactory$LongManifest.prototype.runtimeClass__jl_Class = (function() {
  return $d_J.getClassOf()
});
$c_s_reflect_ManifestFactory$LongManifest.prototype.newArray__I__O = (function(len) {
  return new $ac_J(len)
});
/** @constructor */
function $c_s_reflect_ManifestFactory$PhantomManifest() {
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_prefix = null;
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_runtimeClass1 = null;
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_typeArguments = null;
  this.s_reflect_ManifestFactory$PhantomManifest__f_toString = null;
  this.s_reflect_ManifestFactory$PhantomManifest__f_hashCode = 0
}
$c_s_reflect_ManifestFactory$PhantomManifest.prototype = new $h_s_reflect_ManifestFactory$ClassTypeManifest();
$c_s_reflect_ManifestFactory$PhantomManifest.prototype.constructor = $c_s_reflect_ManifestFactory$PhantomManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$PhantomManifest() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$PhantomManifest.prototype = $c_s_reflect_ManifestFactory$PhantomManifest.prototype;
$c_s_reflect_ManifestFactory$PhantomManifest.prototype.toString__T = (function() {
  return this.s_reflect_ManifestFactory$PhantomManifest__f_toString
});
$c_s_reflect_ManifestFactory$PhantomManifest.prototype.equals__O__Z = (function(that) {
  return (this === that)
});
$c_s_reflect_ManifestFactory$PhantomManifest.prototype.hashCode__I = (function() {
  return this.s_reflect_ManifestFactory$PhantomManifest__f_hashCode
});
/** @constructor */
function $c_s_reflect_ManifestFactory$ShortManifest() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_hashCode = 0
}
$c_s_reflect_ManifestFactory$ShortManifest.prototype = new $h_s_reflect_AnyValManifest();
$c_s_reflect_ManifestFactory$ShortManifest.prototype.constructor = $c_s_reflect_ManifestFactory$ShortManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$ShortManifest() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$ShortManifest.prototype = $c_s_reflect_ManifestFactory$ShortManifest.prototype;
$c_s_reflect_ManifestFactory$ShortManifest.prototype.runtimeClass__jl_Class = (function() {
  return $d_S.getClassOf()
});
$c_s_reflect_ManifestFactory$ShortManifest.prototype.newArray__I__O = (function(len) {
  return new $ac_S(len)
});
/** @constructor */
function $c_s_reflect_ManifestFactory$UnitManifest() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_hashCode = 0
}
$c_s_reflect_ManifestFactory$UnitManifest.prototype = new $h_s_reflect_AnyValManifest();
$c_s_reflect_ManifestFactory$UnitManifest.prototype.constructor = $c_s_reflect_ManifestFactory$UnitManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$UnitManifest() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$UnitManifest.prototype = $c_s_reflect_ManifestFactory$UnitManifest.prototype;
$c_s_reflect_ManifestFactory$UnitManifest.prototype.runtimeClass__jl_Class = (function() {
  return $d_V.getClassOf()
});
$c_s_reflect_ManifestFactory$UnitManifest.prototype.newArray__I__O = (function(len) {
  return new ($d_jl_Void.getArrayOf().constr)(len)
});
/** @constructor */
function $c_Lscommons_react_hooks_package$() {
  /*<skip>*/
}
$c_Lscommons_react_hooks_package$.prototype = new $h_O();
$c_Lscommons_react_hooks_package$.prototype.constructor = $c_Lscommons_react_hooks_package$;
/** @constructor */
function $h_Lscommons_react_hooks_package$() {
  /*<skip>*/
}
$h_Lscommons_react_hooks_package$.prototype = $c_Lscommons_react_hooks_package$.prototype;
var $d_Lscommons_react_hooks_package$ = new $TypeData().initClass({
  Lscommons_react_hooks_package$: 0
}, false, "scommons.react.hooks.package$", {
  Lscommons_react_hooks_package$: 1,
  O: 1,
  Lscommons_react_hooks_UseState: 1,
  Lscommons_react_hooks_UseReducer: 1,
  Lscommons_react_hooks_UseMemo: 1,
  Lscommons_react_hooks_UseContext: 1,
  Lscommons_react_hooks_UseRef: 1,
  Lscommons_react_hooks_UseEffect: 1,
  Lscommons_react_hooks_UseLayoutEffect: 1
});
$c_Lscommons_react_hooks_package$.prototype.$classData = $d_Lscommons_react_hooks_package$;
var $n_Lscommons_react_hooks_package$;
function $m_Lscommons_react_hooks_package$() {
  if ((!$n_Lscommons_react_hooks_package$)) {
    $n_Lscommons_react_hooks_package$ = new $c_Lscommons_react_hooks_package$()
  };
  return $n_Lscommons_react_hooks_package$
}
/** @constructor */
function $c_sc_AbstractView() {
  /*<skip>*/
}
$c_sc_AbstractView.prototype = new $h_sc_AbstractIterable();
$c_sc_AbstractView.prototype.constructor = $c_sc_AbstractView;
/** @constructor */
function $h_sc_AbstractView() {
  /*<skip>*/
}
$h_sc_AbstractView.prototype = $c_sc_AbstractView.prototype;
$c_sc_AbstractView.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sc_View$()
});
$c_sc_AbstractView.prototype.toString__T = (function() {
  return $f_sc_View__toString__T(this)
});
$c_sc_AbstractView.prototype.stringPrefix__T = (function() {
  return "View"
});
function $f_sc_Set__equals__O__Z($thiz, that) {
  if (($thiz === that)) {
    return true
  } else if ($is_sc_Set(that)) {
    var x2 = $as_sc_Set(that);
    return (($thiz.size__I() === x2.size__I()) && $thiz.subsetOf__sc_Set__Z(x2))
  } else {
    return false
  }
}
function $is_sc_Set(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_Set)))
}
function $as_sc_Set(obj) {
  return (($is_sc_Set(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.Set"))
}
function $isArrayOf_sc_Set(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_Set)))
}
function $asArrayOf_sc_Set(obj, depth) {
  return (($isArrayOf_sc_Set(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.Set;", depth))
}
/** @constructor */
function $c_s_reflect_ManifestFactory$AnyManifest$() {
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_prefix = null;
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_runtimeClass1 = null;
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_typeArguments = null;
  this.s_reflect_ManifestFactory$PhantomManifest__f_toString = null;
  this.s_reflect_ManifestFactory$PhantomManifest__f_hashCode = 0;
  this.s_reflect_ManifestFactory$PhantomManifest__f_toString = "Any";
  var prefix = $m_s_None$();
  var typeArguments = $m_s_package$().s_package$__f_Nil;
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_prefix = prefix;
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_runtimeClass1 = $d_O.getClassOf();
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_typeArguments = typeArguments;
  this.s_reflect_ManifestFactory$PhantomManifest__f_hashCode = $systemIdentityHashCode(this)
}
$c_s_reflect_ManifestFactory$AnyManifest$.prototype = new $h_s_reflect_ManifestFactory$PhantomManifest();
$c_s_reflect_ManifestFactory$AnyManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$AnyManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$AnyManifest$() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$AnyManifest$.prototype = $c_s_reflect_ManifestFactory$AnyManifest$.prototype;
$c_s_reflect_ManifestFactory$AnyManifest$.prototype.runtimeClass__jl_Class = (function() {
  return $d_O.getClassOf()
});
$c_s_reflect_ManifestFactory$AnyManifest$.prototype.newArray__I__O = (function(len) {
  return new $ac_O(len)
});
var $d_s_reflect_ManifestFactory$AnyManifest$ = new $TypeData().initClass({
  s_reflect_ManifestFactory$AnyManifest$: 0
}, false, "scala.reflect.ManifestFactory$AnyManifest$", {
  s_reflect_ManifestFactory$AnyManifest$: 1,
  s_reflect_ManifestFactory$PhantomManifest: 1,
  s_reflect_ManifestFactory$ClassTypeManifest: 1,
  O: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
});
$c_s_reflect_ManifestFactory$AnyManifest$.prototype.$classData = $d_s_reflect_ManifestFactory$AnyManifest$;
var $n_s_reflect_ManifestFactory$AnyManifest$;
function $m_s_reflect_ManifestFactory$AnyManifest$() {
  if ((!$n_s_reflect_ManifestFactory$AnyManifest$)) {
    $n_s_reflect_ManifestFactory$AnyManifest$ = new $c_s_reflect_ManifestFactory$AnyManifest$()
  };
  return $n_s_reflect_ManifestFactory$AnyManifest$
}
/** @constructor */
function $c_s_reflect_ManifestFactory$AnyValManifest$() {
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_prefix = null;
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_runtimeClass1 = null;
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_typeArguments = null;
  this.s_reflect_ManifestFactory$PhantomManifest__f_toString = null;
  this.s_reflect_ManifestFactory$PhantomManifest__f_hashCode = 0;
  this.s_reflect_ManifestFactory$PhantomManifest__f_toString = "AnyVal";
  var prefix = $m_s_None$();
  var typeArguments = $m_s_package$().s_package$__f_Nil;
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_prefix = prefix;
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_runtimeClass1 = $d_O.getClassOf();
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_typeArguments = typeArguments;
  this.s_reflect_ManifestFactory$PhantomManifest__f_hashCode = $systemIdentityHashCode(this)
}
$c_s_reflect_ManifestFactory$AnyValManifest$.prototype = new $h_s_reflect_ManifestFactory$PhantomManifest();
$c_s_reflect_ManifestFactory$AnyValManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$AnyValManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$AnyValManifest$() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$AnyValManifest$.prototype = $c_s_reflect_ManifestFactory$AnyValManifest$.prototype;
$c_s_reflect_ManifestFactory$AnyValManifest$.prototype.runtimeClass__jl_Class = (function() {
  return $d_O.getClassOf()
});
$c_s_reflect_ManifestFactory$AnyValManifest$.prototype.newArray__I__O = (function(len) {
  return new $ac_O(len)
});
var $d_s_reflect_ManifestFactory$AnyValManifest$ = new $TypeData().initClass({
  s_reflect_ManifestFactory$AnyValManifest$: 0
}, false, "scala.reflect.ManifestFactory$AnyValManifest$", {
  s_reflect_ManifestFactory$AnyValManifest$: 1,
  s_reflect_ManifestFactory$PhantomManifest: 1,
  s_reflect_ManifestFactory$ClassTypeManifest: 1,
  O: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
});
$c_s_reflect_ManifestFactory$AnyValManifest$.prototype.$classData = $d_s_reflect_ManifestFactory$AnyValManifest$;
var $n_s_reflect_ManifestFactory$AnyValManifest$;
function $m_s_reflect_ManifestFactory$AnyValManifest$() {
  if ((!$n_s_reflect_ManifestFactory$AnyValManifest$)) {
    $n_s_reflect_ManifestFactory$AnyValManifest$ = new $c_s_reflect_ManifestFactory$AnyValManifest$()
  };
  return $n_s_reflect_ManifestFactory$AnyValManifest$
}
/** @constructor */
function $c_s_reflect_ManifestFactory$BooleanManifest$() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_hashCode = 0;
  this.s_reflect_AnyValManifest__f_toString = "Boolean";
  this.s_reflect_AnyValManifest__f_hashCode = $systemIdentityHashCode(this)
}
$c_s_reflect_ManifestFactory$BooleanManifest$.prototype = new $h_s_reflect_ManifestFactory$BooleanManifest();
$c_s_reflect_ManifestFactory$BooleanManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$BooleanManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$BooleanManifest$() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$BooleanManifest$.prototype = $c_s_reflect_ManifestFactory$BooleanManifest$.prototype;
var $d_s_reflect_ManifestFactory$BooleanManifest$ = new $TypeData().initClass({
  s_reflect_ManifestFactory$BooleanManifest$: 0
}, false, "scala.reflect.ManifestFactory$BooleanManifest$", {
  s_reflect_ManifestFactory$BooleanManifest$: 1,
  s_reflect_ManifestFactory$BooleanManifest: 1,
  s_reflect_AnyValManifest: 1,
  O: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
});
$c_s_reflect_ManifestFactory$BooleanManifest$.prototype.$classData = $d_s_reflect_ManifestFactory$BooleanManifest$;
var $n_s_reflect_ManifestFactory$BooleanManifest$;
function $m_s_reflect_ManifestFactory$BooleanManifest$() {
  if ((!$n_s_reflect_ManifestFactory$BooleanManifest$)) {
    $n_s_reflect_ManifestFactory$BooleanManifest$ = new $c_s_reflect_ManifestFactory$BooleanManifest$()
  };
  return $n_s_reflect_ManifestFactory$BooleanManifest$
}
/** @constructor */
function $c_s_reflect_ManifestFactory$ByteManifest$() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_hashCode = 0;
  this.s_reflect_AnyValManifest__f_toString = "Byte";
  this.s_reflect_AnyValManifest__f_hashCode = $systemIdentityHashCode(this)
}
$c_s_reflect_ManifestFactory$ByteManifest$.prototype = new $h_s_reflect_ManifestFactory$ByteManifest();
$c_s_reflect_ManifestFactory$ByteManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$ByteManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$ByteManifest$() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$ByteManifest$.prototype = $c_s_reflect_ManifestFactory$ByteManifest$.prototype;
var $d_s_reflect_ManifestFactory$ByteManifest$ = new $TypeData().initClass({
  s_reflect_ManifestFactory$ByteManifest$: 0
}, false, "scala.reflect.ManifestFactory$ByteManifest$", {
  s_reflect_ManifestFactory$ByteManifest$: 1,
  s_reflect_ManifestFactory$ByteManifest: 1,
  s_reflect_AnyValManifest: 1,
  O: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
});
$c_s_reflect_ManifestFactory$ByteManifest$.prototype.$classData = $d_s_reflect_ManifestFactory$ByteManifest$;
var $n_s_reflect_ManifestFactory$ByteManifest$;
function $m_s_reflect_ManifestFactory$ByteManifest$() {
  if ((!$n_s_reflect_ManifestFactory$ByteManifest$)) {
    $n_s_reflect_ManifestFactory$ByteManifest$ = new $c_s_reflect_ManifestFactory$ByteManifest$()
  };
  return $n_s_reflect_ManifestFactory$ByteManifest$
}
/** @constructor */
function $c_s_reflect_ManifestFactory$CharManifest$() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_hashCode = 0;
  this.s_reflect_AnyValManifest__f_toString = "Char";
  this.s_reflect_AnyValManifest__f_hashCode = $systemIdentityHashCode(this)
}
$c_s_reflect_ManifestFactory$CharManifest$.prototype = new $h_s_reflect_ManifestFactory$CharManifest();
$c_s_reflect_ManifestFactory$CharManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$CharManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$CharManifest$() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$CharManifest$.prototype = $c_s_reflect_ManifestFactory$CharManifest$.prototype;
var $d_s_reflect_ManifestFactory$CharManifest$ = new $TypeData().initClass({
  s_reflect_ManifestFactory$CharManifest$: 0
}, false, "scala.reflect.ManifestFactory$CharManifest$", {
  s_reflect_ManifestFactory$CharManifest$: 1,
  s_reflect_ManifestFactory$CharManifest: 1,
  s_reflect_AnyValManifest: 1,
  O: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
});
$c_s_reflect_ManifestFactory$CharManifest$.prototype.$classData = $d_s_reflect_ManifestFactory$CharManifest$;
var $n_s_reflect_ManifestFactory$CharManifest$;
function $m_s_reflect_ManifestFactory$CharManifest$() {
  if ((!$n_s_reflect_ManifestFactory$CharManifest$)) {
    $n_s_reflect_ManifestFactory$CharManifest$ = new $c_s_reflect_ManifestFactory$CharManifest$()
  };
  return $n_s_reflect_ManifestFactory$CharManifest$
}
/** @constructor */
function $c_s_reflect_ManifestFactory$DoubleManifest$() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_hashCode = 0;
  this.s_reflect_AnyValManifest__f_toString = "Double";
  this.s_reflect_AnyValManifest__f_hashCode = $systemIdentityHashCode(this)
}
$c_s_reflect_ManifestFactory$DoubleManifest$.prototype = new $h_s_reflect_ManifestFactory$DoubleManifest();
$c_s_reflect_ManifestFactory$DoubleManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$DoubleManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$DoubleManifest$() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$DoubleManifest$.prototype = $c_s_reflect_ManifestFactory$DoubleManifest$.prototype;
var $d_s_reflect_ManifestFactory$DoubleManifest$ = new $TypeData().initClass({
  s_reflect_ManifestFactory$DoubleManifest$: 0
}, false, "scala.reflect.ManifestFactory$DoubleManifest$", {
  s_reflect_ManifestFactory$DoubleManifest$: 1,
  s_reflect_ManifestFactory$DoubleManifest: 1,
  s_reflect_AnyValManifest: 1,
  O: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
});
$c_s_reflect_ManifestFactory$DoubleManifest$.prototype.$classData = $d_s_reflect_ManifestFactory$DoubleManifest$;
var $n_s_reflect_ManifestFactory$DoubleManifest$;
function $m_s_reflect_ManifestFactory$DoubleManifest$() {
  if ((!$n_s_reflect_ManifestFactory$DoubleManifest$)) {
    $n_s_reflect_ManifestFactory$DoubleManifest$ = new $c_s_reflect_ManifestFactory$DoubleManifest$()
  };
  return $n_s_reflect_ManifestFactory$DoubleManifest$
}
/** @constructor */
function $c_s_reflect_ManifestFactory$FloatManifest$() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_hashCode = 0;
  this.s_reflect_AnyValManifest__f_toString = "Float";
  this.s_reflect_AnyValManifest__f_hashCode = $systemIdentityHashCode(this)
}
$c_s_reflect_ManifestFactory$FloatManifest$.prototype = new $h_s_reflect_ManifestFactory$FloatManifest();
$c_s_reflect_ManifestFactory$FloatManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$FloatManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$FloatManifest$() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$FloatManifest$.prototype = $c_s_reflect_ManifestFactory$FloatManifest$.prototype;
var $d_s_reflect_ManifestFactory$FloatManifest$ = new $TypeData().initClass({
  s_reflect_ManifestFactory$FloatManifest$: 0
}, false, "scala.reflect.ManifestFactory$FloatManifest$", {
  s_reflect_ManifestFactory$FloatManifest$: 1,
  s_reflect_ManifestFactory$FloatManifest: 1,
  s_reflect_AnyValManifest: 1,
  O: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
});
$c_s_reflect_ManifestFactory$FloatManifest$.prototype.$classData = $d_s_reflect_ManifestFactory$FloatManifest$;
var $n_s_reflect_ManifestFactory$FloatManifest$;
function $m_s_reflect_ManifestFactory$FloatManifest$() {
  if ((!$n_s_reflect_ManifestFactory$FloatManifest$)) {
    $n_s_reflect_ManifestFactory$FloatManifest$ = new $c_s_reflect_ManifestFactory$FloatManifest$()
  };
  return $n_s_reflect_ManifestFactory$FloatManifest$
}
/** @constructor */
function $c_s_reflect_ManifestFactory$IntManifest$() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_hashCode = 0;
  this.s_reflect_AnyValManifest__f_toString = "Int";
  this.s_reflect_AnyValManifest__f_hashCode = $systemIdentityHashCode(this)
}
$c_s_reflect_ManifestFactory$IntManifest$.prototype = new $h_s_reflect_ManifestFactory$IntManifest();
$c_s_reflect_ManifestFactory$IntManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$IntManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$IntManifest$() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$IntManifest$.prototype = $c_s_reflect_ManifestFactory$IntManifest$.prototype;
var $d_s_reflect_ManifestFactory$IntManifest$ = new $TypeData().initClass({
  s_reflect_ManifestFactory$IntManifest$: 0
}, false, "scala.reflect.ManifestFactory$IntManifest$", {
  s_reflect_ManifestFactory$IntManifest$: 1,
  s_reflect_ManifestFactory$IntManifest: 1,
  s_reflect_AnyValManifest: 1,
  O: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
});
$c_s_reflect_ManifestFactory$IntManifest$.prototype.$classData = $d_s_reflect_ManifestFactory$IntManifest$;
var $n_s_reflect_ManifestFactory$IntManifest$;
function $m_s_reflect_ManifestFactory$IntManifest$() {
  if ((!$n_s_reflect_ManifestFactory$IntManifest$)) {
    $n_s_reflect_ManifestFactory$IntManifest$ = new $c_s_reflect_ManifestFactory$IntManifest$()
  };
  return $n_s_reflect_ManifestFactory$IntManifest$
}
/** @constructor */
function $c_s_reflect_ManifestFactory$LongManifest$() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_hashCode = 0;
  this.s_reflect_AnyValManifest__f_toString = "Long";
  this.s_reflect_AnyValManifest__f_hashCode = $systemIdentityHashCode(this)
}
$c_s_reflect_ManifestFactory$LongManifest$.prototype = new $h_s_reflect_ManifestFactory$LongManifest();
$c_s_reflect_ManifestFactory$LongManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$LongManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$LongManifest$() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$LongManifest$.prototype = $c_s_reflect_ManifestFactory$LongManifest$.prototype;
var $d_s_reflect_ManifestFactory$LongManifest$ = new $TypeData().initClass({
  s_reflect_ManifestFactory$LongManifest$: 0
}, false, "scala.reflect.ManifestFactory$LongManifest$", {
  s_reflect_ManifestFactory$LongManifest$: 1,
  s_reflect_ManifestFactory$LongManifest: 1,
  s_reflect_AnyValManifest: 1,
  O: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
});
$c_s_reflect_ManifestFactory$LongManifest$.prototype.$classData = $d_s_reflect_ManifestFactory$LongManifest$;
var $n_s_reflect_ManifestFactory$LongManifest$;
function $m_s_reflect_ManifestFactory$LongManifest$() {
  if ((!$n_s_reflect_ManifestFactory$LongManifest$)) {
    $n_s_reflect_ManifestFactory$LongManifest$ = new $c_s_reflect_ManifestFactory$LongManifest$()
  };
  return $n_s_reflect_ManifestFactory$LongManifest$
}
/** @constructor */
function $c_s_reflect_ManifestFactory$NothingManifest$() {
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_prefix = null;
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_runtimeClass1 = null;
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_typeArguments = null;
  this.s_reflect_ManifestFactory$PhantomManifest__f_toString = null;
  this.s_reflect_ManifestFactory$PhantomManifest__f_hashCode = 0;
  this.s_reflect_ManifestFactory$PhantomManifest__f_toString = "Nothing";
  var prefix = $m_s_None$();
  var typeArguments = $m_s_package$().s_package$__f_Nil;
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_prefix = prefix;
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_runtimeClass1 = $d_sr_Nothing$.getClassOf();
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_typeArguments = typeArguments;
  this.s_reflect_ManifestFactory$PhantomManifest__f_hashCode = $systemIdentityHashCode(this)
}
$c_s_reflect_ManifestFactory$NothingManifest$.prototype = new $h_s_reflect_ManifestFactory$PhantomManifest();
$c_s_reflect_ManifestFactory$NothingManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$NothingManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$NothingManifest$() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$NothingManifest$.prototype = $c_s_reflect_ManifestFactory$NothingManifest$.prototype;
$c_s_reflect_ManifestFactory$NothingManifest$.prototype.runtimeClass__jl_Class = (function() {
  return $d_sr_Nothing$.getClassOf()
});
$c_s_reflect_ManifestFactory$NothingManifest$.prototype.newArray__I__O = (function(len) {
  return new $ac_O(len)
});
var $d_s_reflect_ManifestFactory$NothingManifest$ = new $TypeData().initClass({
  s_reflect_ManifestFactory$NothingManifest$: 0
}, false, "scala.reflect.ManifestFactory$NothingManifest$", {
  s_reflect_ManifestFactory$NothingManifest$: 1,
  s_reflect_ManifestFactory$PhantomManifest: 1,
  s_reflect_ManifestFactory$ClassTypeManifest: 1,
  O: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
});
$c_s_reflect_ManifestFactory$NothingManifest$.prototype.$classData = $d_s_reflect_ManifestFactory$NothingManifest$;
var $n_s_reflect_ManifestFactory$NothingManifest$;
function $m_s_reflect_ManifestFactory$NothingManifest$() {
  if ((!$n_s_reflect_ManifestFactory$NothingManifest$)) {
    $n_s_reflect_ManifestFactory$NothingManifest$ = new $c_s_reflect_ManifestFactory$NothingManifest$()
  };
  return $n_s_reflect_ManifestFactory$NothingManifest$
}
/** @constructor */
function $c_s_reflect_ManifestFactory$NullManifest$() {
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_prefix = null;
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_runtimeClass1 = null;
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_typeArguments = null;
  this.s_reflect_ManifestFactory$PhantomManifest__f_toString = null;
  this.s_reflect_ManifestFactory$PhantomManifest__f_hashCode = 0;
  this.s_reflect_ManifestFactory$PhantomManifest__f_toString = "Null";
  var prefix = $m_s_None$();
  var typeArguments = $m_s_package$().s_package$__f_Nil;
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_prefix = prefix;
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_runtimeClass1 = $d_sr_Null$.getClassOf();
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_typeArguments = typeArguments;
  this.s_reflect_ManifestFactory$PhantomManifest__f_hashCode = $systemIdentityHashCode(this)
}
$c_s_reflect_ManifestFactory$NullManifest$.prototype = new $h_s_reflect_ManifestFactory$PhantomManifest();
$c_s_reflect_ManifestFactory$NullManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$NullManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$NullManifest$() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$NullManifest$.prototype = $c_s_reflect_ManifestFactory$NullManifest$.prototype;
$c_s_reflect_ManifestFactory$NullManifest$.prototype.runtimeClass__jl_Class = (function() {
  return $d_sr_Null$.getClassOf()
});
$c_s_reflect_ManifestFactory$NullManifest$.prototype.newArray__I__O = (function(len) {
  return new $ac_O(len)
});
var $d_s_reflect_ManifestFactory$NullManifest$ = new $TypeData().initClass({
  s_reflect_ManifestFactory$NullManifest$: 0
}, false, "scala.reflect.ManifestFactory$NullManifest$", {
  s_reflect_ManifestFactory$NullManifest$: 1,
  s_reflect_ManifestFactory$PhantomManifest: 1,
  s_reflect_ManifestFactory$ClassTypeManifest: 1,
  O: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
});
$c_s_reflect_ManifestFactory$NullManifest$.prototype.$classData = $d_s_reflect_ManifestFactory$NullManifest$;
var $n_s_reflect_ManifestFactory$NullManifest$;
function $m_s_reflect_ManifestFactory$NullManifest$() {
  if ((!$n_s_reflect_ManifestFactory$NullManifest$)) {
    $n_s_reflect_ManifestFactory$NullManifest$ = new $c_s_reflect_ManifestFactory$NullManifest$()
  };
  return $n_s_reflect_ManifestFactory$NullManifest$
}
/** @constructor */
function $c_s_reflect_ManifestFactory$ObjectManifest$() {
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_prefix = null;
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_runtimeClass1 = null;
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_typeArguments = null;
  this.s_reflect_ManifestFactory$PhantomManifest__f_toString = null;
  this.s_reflect_ManifestFactory$PhantomManifest__f_hashCode = 0;
  this.s_reflect_ManifestFactory$PhantomManifest__f_toString = "Object";
  var prefix = $m_s_None$();
  var typeArguments = $m_s_package$().s_package$__f_Nil;
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_prefix = prefix;
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_runtimeClass1 = $d_O.getClassOf();
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_typeArguments = typeArguments;
  this.s_reflect_ManifestFactory$PhantomManifest__f_hashCode = $systemIdentityHashCode(this)
}
$c_s_reflect_ManifestFactory$ObjectManifest$.prototype = new $h_s_reflect_ManifestFactory$PhantomManifest();
$c_s_reflect_ManifestFactory$ObjectManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$ObjectManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$ObjectManifest$() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$ObjectManifest$.prototype = $c_s_reflect_ManifestFactory$ObjectManifest$.prototype;
$c_s_reflect_ManifestFactory$ObjectManifest$.prototype.runtimeClass__jl_Class = (function() {
  return $d_O.getClassOf()
});
$c_s_reflect_ManifestFactory$ObjectManifest$.prototype.newArray__I__O = (function(len) {
  return new $ac_O(len)
});
var $d_s_reflect_ManifestFactory$ObjectManifest$ = new $TypeData().initClass({
  s_reflect_ManifestFactory$ObjectManifest$: 0
}, false, "scala.reflect.ManifestFactory$ObjectManifest$", {
  s_reflect_ManifestFactory$ObjectManifest$: 1,
  s_reflect_ManifestFactory$PhantomManifest: 1,
  s_reflect_ManifestFactory$ClassTypeManifest: 1,
  O: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
});
$c_s_reflect_ManifestFactory$ObjectManifest$.prototype.$classData = $d_s_reflect_ManifestFactory$ObjectManifest$;
var $n_s_reflect_ManifestFactory$ObjectManifest$;
function $m_s_reflect_ManifestFactory$ObjectManifest$() {
  if ((!$n_s_reflect_ManifestFactory$ObjectManifest$)) {
    $n_s_reflect_ManifestFactory$ObjectManifest$ = new $c_s_reflect_ManifestFactory$ObjectManifest$()
  };
  return $n_s_reflect_ManifestFactory$ObjectManifest$
}
/** @constructor */
function $c_s_reflect_ManifestFactory$ShortManifest$() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_hashCode = 0;
  this.s_reflect_AnyValManifest__f_toString = "Short";
  this.s_reflect_AnyValManifest__f_hashCode = $systemIdentityHashCode(this)
}
$c_s_reflect_ManifestFactory$ShortManifest$.prototype = new $h_s_reflect_ManifestFactory$ShortManifest();
$c_s_reflect_ManifestFactory$ShortManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$ShortManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$ShortManifest$() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$ShortManifest$.prototype = $c_s_reflect_ManifestFactory$ShortManifest$.prototype;
var $d_s_reflect_ManifestFactory$ShortManifest$ = new $TypeData().initClass({
  s_reflect_ManifestFactory$ShortManifest$: 0
}, false, "scala.reflect.ManifestFactory$ShortManifest$", {
  s_reflect_ManifestFactory$ShortManifest$: 1,
  s_reflect_ManifestFactory$ShortManifest: 1,
  s_reflect_AnyValManifest: 1,
  O: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
});
$c_s_reflect_ManifestFactory$ShortManifest$.prototype.$classData = $d_s_reflect_ManifestFactory$ShortManifest$;
var $n_s_reflect_ManifestFactory$ShortManifest$;
function $m_s_reflect_ManifestFactory$ShortManifest$() {
  if ((!$n_s_reflect_ManifestFactory$ShortManifest$)) {
    $n_s_reflect_ManifestFactory$ShortManifest$ = new $c_s_reflect_ManifestFactory$ShortManifest$()
  };
  return $n_s_reflect_ManifestFactory$ShortManifest$
}
/** @constructor */
function $c_s_reflect_ManifestFactory$UnitManifest$() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_hashCode = 0;
  this.s_reflect_AnyValManifest__f_toString = "Unit";
  this.s_reflect_AnyValManifest__f_hashCode = $systemIdentityHashCode(this)
}
$c_s_reflect_ManifestFactory$UnitManifest$.prototype = new $h_s_reflect_ManifestFactory$UnitManifest();
$c_s_reflect_ManifestFactory$UnitManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$UnitManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$UnitManifest$() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$UnitManifest$.prototype = $c_s_reflect_ManifestFactory$UnitManifest$.prototype;
var $d_s_reflect_ManifestFactory$UnitManifest$ = new $TypeData().initClass({
  s_reflect_ManifestFactory$UnitManifest$: 0
}, false, "scala.reflect.ManifestFactory$UnitManifest$", {
  s_reflect_ManifestFactory$UnitManifest$: 1,
  s_reflect_ManifestFactory$UnitManifest: 1,
  s_reflect_AnyValManifest: 1,
  O: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
});
$c_s_reflect_ManifestFactory$UnitManifest$.prototype.$classData = $d_s_reflect_ManifestFactory$UnitManifest$;
var $n_s_reflect_ManifestFactory$UnitManifest$;
function $m_s_reflect_ManifestFactory$UnitManifest$() {
  if ((!$n_s_reflect_ManifestFactory$UnitManifest$)) {
    $n_s_reflect_ManifestFactory$UnitManifest$ = new $c_s_reflect_ManifestFactory$UnitManifest$()
  };
  return $n_s_reflect_ManifestFactory$UnitManifest$
}
function $f_sc_Seq__equals__O__Z($thiz, o) {
  if (($thiz === o)) {
    return true
  } else {
    if ($is_sc_Seq(o)) {
      var x2 = $as_sc_Seq(o);
      if (x2.canEqual__O__Z($thiz)) {
        return $thiz.sameElements__sc_IterableOnce__Z(x2)
      }
    };
    return false
  }
}
function $is_sc_Seq(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_Seq)))
}
function $as_sc_Seq(obj) {
  return (($is_sc_Seq(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.Seq"))
}
function $isArrayOf_sc_Seq(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_Seq)))
}
function $asArrayOf_sc_Seq(obj, depth) {
  return (($isArrayOf_sc_Seq(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.Seq;", depth))
}
/** @constructor */
function $c_sc_View$$anon$1(it$1) {
  this.sc_View$$anon$1__f_it$1 = null;
  this.sc_View$$anon$1__f_it$1 = it$1
}
$c_sc_View$$anon$1.prototype = new $h_sc_AbstractView();
$c_sc_View$$anon$1.prototype.constructor = $c_sc_View$$anon$1;
/** @constructor */
function $h_sc_View$$anon$1() {
  /*<skip>*/
}
$h_sc_View$$anon$1.prototype = $c_sc_View$$anon$1.prototype;
$c_sc_View$$anon$1.prototype.iterator__sc_Iterator = (function() {
  return $as_sc_Iterator(this.sc_View$$anon$1__f_it$1.apply__O())
});
var $d_sc_View$$anon$1 = new $TypeData().initClass({
  sc_View$$anon$1: 0
}, false, "scala.collection.View$$anon$1", {
  sc_View$$anon$1: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1
});
$c_sc_View$$anon$1.prototype.$classData = $d_sc_View$$anon$1;
/** @constructor */
function $c_sc_View$Concat(prefix, suffix) {
  this.sc_View$Concat__f_prefix = null;
  this.sc_View$Concat__f_suffix = null;
  this.sc_View$Concat__f_prefix = prefix;
  this.sc_View$Concat__f_suffix = suffix
}
$c_sc_View$Concat.prototype = new $h_sc_AbstractView();
$c_sc_View$Concat.prototype.constructor = $c_sc_View$Concat;
/** @constructor */
function $h_sc_View$Concat() {
  /*<skip>*/
}
$h_sc_View$Concat.prototype = $c_sc_View$Concat.prototype;
$c_sc_View$Concat.prototype.iterator__sc_Iterator = (function() {
  var this$2 = this.sc_View$Concat__f_prefix.iterator__sc_Iterator();
  var xs = new $c_sjsr_AnonFunction0((function(this$1) {
    return (function() {
      return this$1.sc_View$Concat__f_suffix.iterator__sc_Iterator()
    })
  })(this));
  return this$2.concat__F0__sc_Iterator(xs)
});
$c_sc_View$Concat.prototype.knownSize__I = (function() {
  var prefixSize = this.sc_View$Concat__f_prefix.knownSize__I();
  if ((prefixSize >= 0)) {
    var suffixSize = this.sc_View$Concat__f_suffix.knownSize__I();
    return ((suffixSize >= 0) ? ((prefixSize + suffixSize) | 0) : (-1))
  } else {
    return (-1)
  }
});
$c_sc_View$Concat.prototype.isEmpty__Z = (function() {
  return (this.sc_View$Concat__f_prefix.isEmpty__Z() && this.sc_View$Concat__f_suffix.isEmpty__Z())
});
var $d_sc_View$Concat = new $TypeData().initClass({
  sc_View$Concat: 0
}, false, "scala.collection.View$Concat", {
  sc_View$Concat: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1
});
$c_sc_View$Concat.prototype.$classData = $d_sc_View$Concat;
function $ct_sc_View$Drop__sc_IterableOps__I__($thiz, underlying, n) {
  $thiz.sc_View$Drop__f_underlying = underlying;
  $thiz.sc_View$Drop__f_n = n;
  $thiz.sc_View$Drop__f_normN = ((n > 0) ? n : 0);
  return $thiz
}
/** @constructor */
function $c_sc_View$Drop() {
  this.sc_View$Drop__f_underlying = null;
  this.sc_View$Drop__f_n = 0;
  this.sc_View$Drop__f_normN = 0
}
$c_sc_View$Drop.prototype = new $h_sc_AbstractView();
$c_sc_View$Drop.prototype.constructor = $c_sc_View$Drop;
/** @constructor */
function $h_sc_View$Drop() {
  /*<skip>*/
}
$h_sc_View$Drop.prototype = $c_sc_View$Drop.prototype;
$c_sc_View$Drop.prototype.iterator__sc_Iterator = (function() {
  return this.sc_View$Drop__f_underlying.iterator__sc_Iterator().drop__I__sc_Iterator(this.sc_View$Drop__f_n)
});
$c_sc_View$Drop.prototype.knownSize__I = (function() {
  var size = this.sc_View$Drop__f_underlying.knownSize__I();
  if ((size >= 0)) {
    var x = ((size - this.sc_View$Drop__f_normN) | 0);
    return ((x > 0) ? x : 0)
  } else {
    return (-1)
  }
});
$c_sc_View$Drop.prototype.isEmpty__Z = (function() {
  var this$1 = this.iterator__sc_Iterator();
  return (!this$1.hasNext__Z())
});
var $d_sc_View$Drop = new $TypeData().initClass({
  sc_View$Drop: 0
}, false, "scala.collection.View$Drop", {
  sc_View$Drop: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1
});
$c_sc_View$Drop.prototype.$classData = $d_sc_View$Drop;
/** @constructor */
function $c_sc_View$FlatMap(underlying, f) {
  this.sc_View$FlatMap__f_underlying = null;
  this.sc_View$FlatMap__f_f = null;
  this.sc_View$FlatMap__f_underlying = underlying;
  this.sc_View$FlatMap__f_f = f
}
$c_sc_View$FlatMap.prototype = new $h_sc_AbstractView();
$c_sc_View$FlatMap.prototype.constructor = $c_sc_View$FlatMap;
/** @constructor */
function $h_sc_View$FlatMap() {
  /*<skip>*/
}
$h_sc_View$FlatMap.prototype = $c_sc_View$FlatMap.prototype;
$c_sc_View$FlatMap.prototype.iterator__sc_Iterator = (function() {
  var this$1 = this.sc_View$FlatMap__f_underlying.iterator__sc_Iterator();
  var f = this.sc_View$FlatMap__f_f;
  return new $c_sc_Iterator$$anon$10(this$1, f)
});
$c_sc_View$FlatMap.prototype.knownSize__I = (function() {
  return ((this.sc_View$FlatMap__f_underlying.knownSize__I() === 0) ? 0 : (-1))
});
$c_sc_View$FlatMap.prototype.isEmpty__Z = (function() {
  var this$1 = this.iterator__sc_Iterator();
  return (!this$1.hasNext__Z())
});
var $d_sc_View$FlatMap = new $TypeData().initClass({
  sc_View$FlatMap: 0
}, false, "scala.collection.View$FlatMap", {
  sc_View$FlatMap: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1
});
$c_sc_View$FlatMap.prototype.$classData = $d_sc_View$FlatMap;
function $ct_sc_View$Map__sc_IterableOps__F1__($thiz, underlying, f) {
  $thiz.sc_View$Map__f_underlying = underlying;
  $thiz.sc_View$Map__f_f = f;
  return $thiz
}
/** @constructor */
function $c_sc_View$Map() {
  this.sc_View$Map__f_underlying = null;
  this.sc_View$Map__f_f = null
}
$c_sc_View$Map.prototype = new $h_sc_AbstractView();
$c_sc_View$Map.prototype.constructor = $c_sc_View$Map;
/** @constructor */
function $h_sc_View$Map() {
  /*<skip>*/
}
$h_sc_View$Map.prototype = $c_sc_View$Map.prototype;
$c_sc_View$Map.prototype.iterator__sc_Iterator = (function() {
  var this$1 = this.sc_View$Map__f_underlying.iterator__sc_Iterator();
  var f = this.sc_View$Map__f_f;
  return new $c_sc_Iterator$$anon$9(this$1, f)
});
$c_sc_View$Map.prototype.knownSize__I = (function() {
  return this.sc_View$Map__f_underlying.knownSize__I()
});
$c_sc_View$Map.prototype.isEmpty__Z = (function() {
  return this.sc_View$Map__f_underlying.isEmpty__Z()
});
var $d_sc_View$Map = new $TypeData().initClass({
  sc_View$Map: 0
}, false, "scala.collection.View$Map", {
  sc_View$Map: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1
});
$c_sc_View$Map.prototype.$classData = $d_sc_View$Map;
/** @constructor */
function $c_sc_View$ZipWithIndex(underlying) {
  this.sc_View$ZipWithIndex__f_underlying = null;
  this.sc_View$ZipWithIndex__f_underlying = underlying
}
$c_sc_View$ZipWithIndex.prototype = new $h_sc_AbstractView();
$c_sc_View$ZipWithIndex.prototype.constructor = $c_sc_View$ZipWithIndex;
/** @constructor */
function $h_sc_View$ZipWithIndex() {
  /*<skip>*/
}
$h_sc_View$ZipWithIndex.prototype = $c_sc_View$ZipWithIndex.prototype;
$c_sc_View$ZipWithIndex.prototype.iterator__sc_Iterator = (function() {
  var this$1 = this.sc_View$ZipWithIndex__f_underlying.iterator__sc_Iterator();
  return new $c_sc_Iterator$$anon$16(this$1)
});
$c_sc_View$ZipWithIndex.prototype.knownSize__I = (function() {
  return this.sc_View$ZipWithIndex__f_underlying.knownSize__I()
});
$c_sc_View$ZipWithIndex.prototype.isEmpty__Z = (function() {
  return this.sc_View$ZipWithIndex__f_underlying.isEmpty__Z()
});
var $d_sc_View$ZipWithIndex = new $TypeData().initClass({
  sc_View$ZipWithIndex: 0
}, false, "scala.collection.View$ZipWithIndex", {
  sc_View$ZipWithIndex: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1
});
$c_sc_View$ZipWithIndex.prototype.$classData = $d_sc_View$ZipWithIndex;
/** @constructor */
function $c_sc_AbstractSet() {
  /*<skip>*/
}
$c_sc_AbstractSet.prototype = new $h_sc_AbstractIterable();
$c_sc_AbstractSet.prototype.constructor = $c_sc_AbstractSet;
/** @constructor */
function $h_sc_AbstractSet() {
  /*<skip>*/
}
$h_sc_AbstractSet.prototype = $c_sc_AbstractSet.prototype;
$c_sc_AbstractSet.prototype.equals__O__Z = (function(that) {
  return $f_sc_Set__equals__O__Z(this, that)
});
$c_sc_AbstractSet.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  return this$1.unorderedHash__sc_IterableOnce__I__I(this, this$1.s_util_hashing_MurmurHash3$__f_setSeed)
});
$c_sc_AbstractSet.prototype.stringPrefix__T = (function() {
  return "Set"
});
$c_sc_AbstractSet.prototype.toString__T = (function() {
  return $f_sc_Iterable__toString__T(this)
});
$c_sc_AbstractSet.prototype.subsetOf__sc_Set__Z = (function(that) {
  return this.forall__F1__Z(that)
});
$c_sc_AbstractSet.prototype.apply__O__O = (function(v1) {
  return this.contains__O__Z(v1)
});
function $f_sc_Map__equals__O__Z($thiz, o) {
  if (($thiz === o)) {
    return true
  } else if ($is_sc_Map(o)) {
    var x2 = $as_sc_Map(o);
    return (($thiz.size__I() === x2.size__I()) && $thiz.forall__F1__Z(new $c_sjsr_AnonFunction1((function(this$1, x2$1) {
      return (function(kv$2) {
        var kv = $as_T2(kv$2);
        return $m_sr_BoxesRunTime$().equals__O__O__Z(x2$1.getOrElse__O__F0__O(kv._1__O(), $m_sc_Map$().sc_Map$__f_scala$collection$Map$$DefaultSentinelFn), kv._2__O())
      })
    })($thiz, x2))))
  } else {
    return false
  }
}
function $is_sc_Map(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_Map)))
}
function $as_sc_Map(obj) {
  return (($is_sc_Map(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.Map"))
}
function $isArrayOf_sc_Map(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_Map)))
}
function $asArrayOf_sc_Map(obj, depth) {
  return (($isArrayOf_sc_Map(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.Map;", depth))
}
function $p_s_concurrent_impl_Promise$Transformation__handleFailure__jl_Throwable__s_concurrent_ExecutionContext__V($thiz, t, e) {
  var wasInterrupted = false;
  if ((wasInterrupted || $m_s_util_control_NonFatal$().apply__jl_Throwable__Z(t))) {
    var completed = $thiz.tryComplete0__O__s_util_Try__Z($thiz.ju_concurrent_atomic_AtomicReference__f_value, $m_s_concurrent_impl_Promise$().scala$concurrent$impl$Promise$$resolve__s_util_Try__s_util_Try(new $c_s_util_Failure(t)));
    if ((completed && wasInterrupted)) {
      var this$1 = $m_jl_Thread$().jl_Thread$__f_SingleThread;
      this$1.jl_Thread__f_java$lang$Thread$$interruptedState = true
    };
    if (((($thiz.s_concurrent_impl_Promise$Transformation__f__xform === 5) || ($thiz.s_concurrent_impl_Promise$Transformation__f__xform === 6)) || (!completed))) {
      e.reportFailure__jl_Throwable__V(t)
    }
  } else {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(t)
  }
}
function $ct_s_concurrent_impl_Promise$Transformation__F1__s_concurrent_ExecutionContext__s_util_Try__I__($thiz, _fun, _ec, _arg, _xform) {
  $thiz.s_concurrent_impl_Promise$Transformation__f__fun = _fun;
  $thiz.s_concurrent_impl_Promise$Transformation__f__ec = _ec;
  $thiz.s_concurrent_impl_Promise$Transformation__f__arg = _arg;
  $thiz.s_concurrent_impl_Promise$Transformation__f__xform = _xform;
  $ct_s_concurrent_impl_Promise$DefaultPromise__($thiz);
  return $thiz
}
function $ct_s_concurrent_impl_Promise$Transformation__I__F1__s_concurrent_ExecutionContext__($thiz, xform, f, ec) {
  $ct_s_concurrent_impl_Promise$Transformation__F1__s_concurrent_ExecutionContext__s_util_Try__I__($thiz, f, ec, null, xform);
  return $thiz
}
/** @constructor */
function $c_s_concurrent_impl_Promise$Transformation() {
  this.ju_concurrent_atomic_AtomicReference__f_value = null;
  this.s_concurrent_impl_Promise$Transformation__f__fun = null;
  this.s_concurrent_impl_Promise$Transformation__f__ec = null;
  this.s_concurrent_impl_Promise$Transformation__f__arg = null;
  this.s_concurrent_impl_Promise$Transformation__f__xform = 0
}
$c_s_concurrent_impl_Promise$Transformation.prototype = new $h_s_concurrent_impl_Promise$DefaultPromise();
$c_s_concurrent_impl_Promise$Transformation.prototype.constructor = $c_s_concurrent_impl_Promise$Transformation;
/** @constructor */
function $h_s_concurrent_impl_Promise$Transformation() {
  /*<skip>*/
}
$h_s_concurrent_impl_Promise$Transformation.prototype = $c_s_concurrent_impl_Promise$Transformation.prototype;
$c_s_concurrent_impl_Promise$Transformation.prototype.submitWithValue__s_util_Try__s_concurrent_impl_Promise$Transformation = (function(resolved) {
  this.s_concurrent_impl_Promise$Transformation__f__arg = resolved;
  var e = this.s_concurrent_impl_Promise$Transformation__f__ec;
  try {
    e.execute__jl_Runnable__V(this)
  } catch (e$2) {
    var e$3 = $m_sjsr_package$().wrapJavaScriptException__O__jl_Throwable(e$2);
    if ((e$3 !== null)) {
      this.s_concurrent_impl_Promise$Transformation__f__fun = null;
      this.s_concurrent_impl_Promise$Transformation__f__arg = null;
      this.s_concurrent_impl_Promise$Transformation__f__ec = null;
      $p_s_concurrent_impl_Promise$Transformation__handleFailure__jl_Throwable__s_concurrent_ExecutionContext__V(this, e$3, e)
    } else {
      throw e$2
    }
  };
  return this
});
$c_s_concurrent_impl_Promise$Transformation.prototype.run__V = (function() {
  var v = this.s_concurrent_impl_Promise$Transformation__f__arg;
  var fun = this.s_concurrent_impl_Promise$Transformation__f__fun;
  var ec = this.s_concurrent_impl_Promise$Transformation__f__ec;
  this.s_concurrent_impl_Promise$Transformation__f__fun = null;
  this.s_concurrent_impl_Promise$Transformation__f__arg = null;
  this.s_concurrent_impl_Promise$Transformation__f__ec = null;
  try {
    var x1 = this.s_concurrent_impl_Promise$Transformation__f__xform;
    switch (x1) {
      case 0: {
        var resolvedResult = null;
        break
      }
      case 1: {
        var resolvedResult = ((v instanceof $c_s_util_Success) ? new $c_s_util_Success(fun.apply__O__O(v.get__O())) : v);
        break
      }
      case 2: {
        if ((v instanceof $c_s_util_Success)) {
          var f = fun.apply__O__O(v.get__O());
          if ((f instanceof $c_s_concurrent_impl_Promise$DefaultPromise)) {
            $as_s_concurrent_impl_Promise$DefaultPromise(f).linkRootOf__s_concurrent_impl_Promise$DefaultPromise__s_concurrent_impl_Promise$Link__V(this, null)
          } else {
            this.completeWith__s_concurrent_Future__s_concurrent_impl_Promise$DefaultPromise($as_s_concurrent_Future(f))
          };
          var resolvedResult = null
        } else {
          var resolvedResult = v
        };
        break
      }
      case 3: {
        var resolvedResult = $m_s_concurrent_impl_Promise$().scala$concurrent$impl$Promise$$resolve__s_util_Try__s_util_Try($as_s_util_Try(fun.apply__O__O(v)));
        break
      }
      case 4: {
        var f$2 = fun.apply__O__O(v);
        if ((f$2 instanceof $c_s_concurrent_impl_Promise$DefaultPromise)) {
          $as_s_concurrent_impl_Promise$DefaultPromise(f$2).linkRootOf__s_concurrent_impl_Promise$DefaultPromise__s_concurrent_impl_Promise$Link__V(this, null)
        } else {
          this.completeWith__s_concurrent_Future__s_concurrent_impl_Promise$DefaultPromise($as_s_concurrent_Future(f$2))
        };
        var resolvedResult = null;
        break
      }
      case 5: {
        v.foreach__F1__V(fun);
        var resolvedResult = null;
        break
      }
      case 6: {
        fun.apply__O__O(v);
        var resolvedResult = null;
        break
      }
      case 7: {
        var resolvedResult = ((v instanceof $c_s_util_Failure) ? $m_s_concurrent_impl_Promise$().scala$concurrent$impl$Promise$$resolve__s_util_Try__s_util_Try(v.recover__s_PartialFunction__s_util_Try($as_s_PartialFunction(fun))) : v);
        break
      }
      case 8: {
        if ((v instanceof $c_s_util_Failure)) {
          var f$3 = $as_s_concurrent_Future($as_s_PartialFunction(fun).applyOrElse__O__F1__O($as_s_util_Failure(v).s_util_Failure__f_exception, $m_s_concurrent_Future$().s_concurrent_Future$__f_recoverWithFailed));
          var resolvedResult = ((f$3 !== $m_s_concurrent_Future$().s_concurrent_Future$__f_recoverWithFailedMarker) ? (((f$3 instanceof $c_s_concurrent_impl_Promise$DefaultPromise) ? $as_s_concurrent_impl_Promise$DefaultPromise(f$3).linkRootOf__s_concurrent_impl_Promise$DefaultPromise__s_concurrent_impl_Promise$Link__V(this, null) : this.completeWith__s_concurrent_Future__s_concurrent_impl_Promise$DefaultPromise(f$3)), null) : v)
        } else {
          var resolvedResult = v
        };
        break
      }
      case 9: {
        var resolvedResult = (((v instanceof $c_s_util_Failure) || $uZ(fun.apply__O__O(v.get__O()))) ? v : $m_s_concurrent_Future$().s_concurrent_Future$__f_filterFailure);
        break
      }
      case 10: {
        var resolvedResult = ((v instanceof $c_s_util_Success) ? new $c_s_util_Success($as_s_PartialFunction(fun).applyOrElse__O__F1__O(v.get__O(), $m_s_concurrent_Future$().s_concurrent_Future$__f_collectFailed)) : v);
        break
      }
      default: {
        var resolvedResult = new $c_s_util_Failure($ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), ("BUG: encountered transformation promise with illegal type: " + this.s_concurrent_impl_Promise$Transformation__f__xform)))
      }
    };
    if ((resolvedResult !== null)) {
      this.tryComplete0__O__s_util_Try__Z(this.ju_concurrent_atomic_AtomicReference__f_value, resolvedResult)
    }
  } catch (e) {
    var e$2 = $m_sjsr_package$().wrapJavaScriptException__O__jl_Throwable(e);
    if ((e$2 !== null)) {
      $p_s_concurrent_impl_Promise$Transformation__handleFailure__jl_Throwable__s_concurrent_ExecutionContext__V(this, e$2, ec)
    } else {
      throw e
    }
  }
});
function $as_s_concurrent_impl_Promise$Transformation(obj) {
  return (((obj instanceof $c_s_concurrent_impl_Promise$Transformation) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.concurrent.impl.Promise$Transformation"))
}
function $isArrayOf_s_concurrent_impl_Promise$Transformation(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_concurrent_impl_Promise$Transformation)))
}
function $asArrayOf_s_concurrent_impl_Promise$Transformation(obj, depth) {
  return (($isArrayOf_s_concurrent_impl_Promise$Transformation(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.concurrent.impl.Promise$Transformation;", depth))
}
var $d_s_concurrent_impl_Promise$Transformation = new $TypeData().initClass({
  s_concurrent_impl_Promise$Transformation: 0
}, false, "scala.concurrent.impl.Promise$Transformation", {
  s_concurrent_impl_Promise$Transformation: 1,
  s_concurrent_impl_Promise$DefaultPromise: 1,
  ju_concurrent_atomic_AtomicReference: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  s_concurrent_Promise: 1,
  s_concurrent_Future: 1,
  s_concurrent_Awaitable: 1,
  F1: 1,
  s_concurrent_impl_Promise$Callbacks: 1,
  jl_Runnable: 1,
  s_concurrent_Batchable: 1
});
$c_s_concurrent_impl_Promise$Transformation.prototype.$classData = $d_s_concurrent_impl_Promise$Transformation;
/** @constructor */
function $c_sr_RichLong(self) {
  this.sr_RichLong__f_self = $L0;
  this.sr_RichLong__f_self = self
}
$c_sr_RichLong.prototype = new $h_O();
$c_sr_RichLong.prototype.constructor = $c_sr_RichLong;
/** @constructor */
function $h_sr_RichLong() {
  /*<skip>*/
}
$h_sr_RichLong.prototype = $c_sr_RichLong.prototype;
$c_sr_RichLong.prototype.compare__O__I = (function(y) {
  var t$1 = this.sr_RichLong__f_self;
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  var t$2 = $uJ(new $c_RTLong(lo$1, hi$1));
  var lo$2 = t$2.RTLong__f_lo;
  var hi$2 = t$2.RTLong__f_hi;
  var t$3 = $uJ(y);
  var lo$3 = t$3.RTLong__f_lo;
  var hi$3 = t$3.RTLong__f_hi;
  return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$compare__I__I__I__I__I(lo$2, hi$2, lo$3, hi$3)
});
$c_sr_RichLong.prototype.toString__T = (function() {
  return $f_s_Proxy__toString__T(this)
});
$c_sr_RichLong.prototype.doubleValue__D = (function() {
  var t = this.sr_RichLong__f_self;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toDouble__I__I__D(lo, hi)
});
$c_sr_RichLong.prototype.floatValue__F = (function() {
  var t = this.sr_RichLong__f_self;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  return $fround($m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toDouble__I__I__D(lo, hi))
});
$c_sr_RichLong.prototype.longValue__J = (function() {
  var t = this.sr_RichLong__f_self;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  return new $c_RTLong(lo, hi)
});
$c_sr_RichLong.prototype.intValue__I = (function() {
  var t = this.sr_RichLong__f_self;
  var lo = t.RTLong__f_lo;
  return lo
});
$c_sr_RichLong.prototype.byteValue__B = (function() {
  var t = this.sr_RichLong__f_self;
  var lo = t.RTLong__f_lo;
  return ((lo << 24) >> 24)
});
$c_sr_RichLong.prototype.shortValue__S = (function() {
  var t = this.sr_RichLong__f_self;
  var lo = t.RTLong__f_lo;
  return ((lo << 16) >> 16)
});
$c_sr_RichLong.prototype.isValidByte__Z = (function() {
  return $m_sr_RichLong$().isValidByte$extension__J__Z(this.sr_RichLong__f_self)
});
$c_sr_RichLong.prototype.isValidShort__Z = (function() {
  return $m_sr_RichLong$().isValidShort$extension__J__Z(this.sr_RichLong__f_self)
});
$c_sr_RichLong.prototype.isValidChar__Z = (function() {
  return $m_sr_RichLong$().isValidChar$extension__J__Z(this.sr_RichLong__f_self)
});
$c_sr_RichLong.prototype.isValidInt__Z = (function() {
  return $m_sr_RichLong$().isValidInt$extension__J__Z(this.sr_RichLong__f_self)
});
$c_sr_RichLong.prototype.hashCode__I = (function() {
  var t = this.sr_RichLong__f_self;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  return (lo ^ hi)
});
$c_sr_RichLong.prototype.equals__O__Z = (function(x$1) {
  return $m_sr_RichLong$().equals$extension__J__O__Z(this.sr_RichLong__f_self, x$1)
});
function $as_sr_RichLong(obj) {
  return (((obj instanceof $c_sr_RichLong) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.runtime.RichLong"))
}
function $isArrayOf_sr_RichLong(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sr_RichLong)))
}
function $asArrayOf_sr_RichLong(obj, depth) {
  return (($isArrayOf_sr_RichLong(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.runtime.RichLong;", depth))
}
var $d_sr_RichLong = new $TypeData().initClass({
  sr_RichLong: 0
}, false, "scala.runtime.RichLong", {
  sr_RichLong: 1,
  O: 1,
  sr_IntegralProxy: 1,
  sr_ScalaWholeNumberProxy: 1,
  sr_ScalaNumberProxy: 1,
  s_math_ScalaNumericAnyConversions: 1,
  s_Proxy$Typed: 1,
  s_Proxy: 1,
  sr_OrderedProxy: 1,
  s_math_Ordered: 1,
  jl_Comparable: 1,
  sr_RangedProxy: 1
});
$c_sr_RichLong.prototype.$classData = $d_sr_RichLong;
/** @constructor */
function $c_sc_AbstractSeq() {
  /*<skip>*/
}
$c_sc_AbstractSeq.prototype = new $h_sc_AbstractIterable();
$c_sc_AbstractSeq.prototype.constructor = $c_sc_AbstractSeq;
/** @constructor */
function $h_sc_AbstractSeq() {
  /*<skip>*/
}
$h_sc_AbstractSeq.prototype = $c_sc_AbstractSeq.prototype;
$c_sc_AbstractSeq.prototype.canEqual__O__Z = (function(that) {
  return true
});
$c_sc_AbstractSeq.prototype.equals__O__Z = (function(o) {
  return $f_sc_Seq__equals__O__Z(this, o)
});
$c_sc_AbstractSeq.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().seqHash__sc_Seq__I(this)
});
$c_sc_AbstractSeq.prototype.toString__T = (function() {
  return $f_sc_Iterable__toString__T(this)
});
$c_sc_AbstractSeq.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix)
});
$c_sc_AbstractSeq.prototype.concat__sc_IterableOnce__O = (function(suffix) {
  return this.appendedAll__sc_IterableOnce__O(suffix)
});
$c_sc_AbstractSeq.prototype.size__I = (function() {
  return this.length__I()
});
$c_sc_AbstractSeq.prototype.isDefinedAt__I__Z = (function(idx) {
  return $f_sc_SeqOps__isDefinedAt__I__Z(this, idx)
});
$c_sc_AbstractSeq.prototype.indexWhere__F1__I__I = (function(p, from) {
  var this$1 = this.iterator__sc_Iterator();
  return $f_sc_Iterator__indexWhere__F1__I__I(this$1, p, from)
});
$c_sc_AbstractSeq.prototype.sizeCompare__I__I = (function(otherSize) {
  return this.lengthCompare__I__I(otherSize)
});
$c_sc_AbstractSeq.prototype.lengthCompare__I__I = (function(len) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, len)
});
$c_sc_AbstractSeq.prototype.isEmpty__Z = (function() {
  return $f_sc_SeqOps__isEmpty__Z(this)
});
$c_sc_AbstractSeq.prototype.sameElements__sc_IterableOnce__Z = (function(that) {
  return $f_sc_SeqOps__sameElements__sc_IterableOnce__Z(this, that)
});
$c_sc_AbstractSeq.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return $f_s_PartialFunction__applyOrElse__O__F1__O(this, x, default$1)
});
$c_sc_AbstractSeq.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__I__Z($uI(x))
});
/** @constructor */
function $c_sc_AbstractSeqView() {
  /*<skip>*/
}
$c_sc_AbstractSeqView.prototype = new $h_sc_AbstractView();
$c_sc_AbstractSeqView.prototype.constructor = $c_sc_AbstractSeqView;
/** @constructor */
function $h_sc_AbstractSeqView() {
  /*<skip>*/
}
$h_sc_AbstractSeqView.prototype = $c_sc_AbstractSeqView.prototype;
$c_sc_AbstractSeqView.prototype.map__F1__sc_SeqView = (function(f) {
  return $ct_sc_SeqView$Map__sc_SeqOps__F1__(new $c_sc_SeqView$Map(), this, f)
});
$c_sc_AbstractSeqView.prototype.drop__I__sc_SeqView = (function(n) {
  return $ct_sc_SeqView$Drop__sc_SeqOps__I__(new $c_sc_SeqView$Drop(), this, n)
});
$c_sc_AbstractSeqView.prototype.stringPrefix__T = (function() {
  return "SeqView"
});
$c_sc_AbstractSeqView.prototype.concat__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix)
});
$c_sc_AbstractSeqView.prototype.indexWhere__F1__I__I = (function(p, from) {
  var this$1 = this.iterator__sc_Iterator();
  return $f_sc_Iterator__indexWhere__F1__I__I(this$1, p, from)
});
$c_sc_AbstractSeqView.prototype.lengthCompare__I__I = (function(len) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, len)
});
$c_sc_AbstractSeqView.prototype.isEmpty__Z = (function() {
  return $f_sc_SeqOps__isEmpty__Z(this)
});
$c_sc_AbstractSeqView.prototype.drop__I__O = (function(n) {
  return this.drop__I__sc_SeqView(n)
});
$c_sc_AbstractSeqView.prototype.map__F1__O = (function(f) {
  return this.map__F1__sc_SeqView(f)
});
function $is_sc_IndexedSeq(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_IndexedSeq)))
}
function $as_sc_IndexedSeq(obj) {
  return (($is_sc_IndexedSeq(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.IndexedSeq"))
}
function $isArrayOf_sc_IndexedSeq(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_IndexedSeq)))
}
function $asArrayOf_sc_IndexedSeq(obj, depth) {
  return (($isArrayOf_sc_IndexedSeq(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.IndexedSeq;", depth))
}
function $is_sc_LinearSeq(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_LinearSeq)))
}
function $as_sc_LinearSeq(obj) {
  return (($is_sc_LinearSeq(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.LinearSeq"))
}
function $isArrayOf_sc_LinearSeq(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_LinearSeq)))
}
function $asArrayOf_sc_LinearSeq(obj, depth) {
  return (($isArrayOf_sc_LinearSeq(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.LinearSeq;", depth))
}
function $is_sci_Set(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sci_Set)))
}
function $as_sci_Set(obj) {
  return (($is_sci_Set(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Set"))
}
function $isArrayOf_sci_Set(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Set)))
}
function $asArrayOf_sci_Set(obj, depth) {
  return (($isArrayOf_sci_Set(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Set;", depth))
}
/** @constructor */
function $c_sc_AbstractMap() {
  /*<skip>*/
}
$c_sc_AbstractMap.prototype = new $h_sc_AbstractIterable();
$c_sc_AbstractMap.prototype.constructor = $c_sc_AbstractMap;
/** @constructor */
function $h_sc_AbstractMap() {
  /*<skip>*/
}
$h_sc_AbstractMap.prototype = $c_sc_AbstractMap.prototype;
$c_sc_AbstractMap.prototype.equals__O__Z = (function(o) {
  return $f_sc_Map__equals__O__Z(this, o)
});
$c_sc_AbstractMap.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().mapHash__sc_Map__I(this)
});
$c_sc_AbstractMap.prototype.stringPrefix__T = (function() {
  return "Map"
});
$c_sc_AbstractMap.prototype.toString__T = (function() {
  return $f_sc_Iterable__toString__T(this)
});
$c_sc_AbstractMap.prototype.fromSpecific__sc_IterableOnce__sc_IterableOps = (function(coll) {
  return $as_sc_IterableOps(this.mapFactory__sc_MapFactory().from__sc_IterableOnce__O(coll))
});
$c_sc_AbstractMap.prototype.newSpecificBuilder__scm_Builder = (function() {
  return this.mapFactory__sc_MapFactory().newBuilder__scm_Builder()
});
$c_sc_AbstractMap.prototype.getOrElse__O__F0__O = (function(key, default$1) {
  return $f_sc_MapOps__getOrElse__O__F0__O(this, key, default$1)
});
$c_sc_AbstractMap.prototype.apply__O__O = (function(key) {
  return $f_sc_MapOps__apply__O__O(this, key)
});
$c_sc_AbstractMap.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return $f_sc_MapOps__applyOrElse__O__F1__O(this, x, default$1)
});
$c_sc_AbstractMap.prototype.foreachEntry__F2__V = (function(f) {
  $f_sc_MapOps__foreachEntry__F2__V(this, f)
});
$c_sc_AbstractMap.prototype.contains__O__Z = (function(key) {
  return $f_sc_MapOps__contains__O__Z(this, key)
});
$c_sc_AbstractMap.prototype.isDefinedAt__O__Z = (function(key) {
  return this.contains__O__Z(key)
});
$c_sc_AbstractMap.prototype.map__F1__sc_IterableOps = (function(f) {
  return $f_sc_MapOps__map__F1__sc_IterableOps(this, f)
});
$c_sc_AbstractMap.prototype.concat__sc_IterableOnce__sc_IterableOps = (function(suffix) {
  return $f_sc_MapOps__concat__sc_IterableOnce__sc_IterableOps(this, suffix)
});
$c_sc_AbstractMap.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(sb, start, sep, end) {
  return $f_sc_MapOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, sb, start, sep, end)
});
$c_sc_AbstractMap.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  return this.fromSpecific__sc_IterableOnce__sc_IterableOps(coll)
});
function $ct_sc_SeqView$Drop__sc_SeqOps__I__($thiz, underlying, n) {
  $thiz.sc_SeqView$Drop__f_underlying = underlying;
  $thiz.sc_SeqView$Drop__f_n = n;
  $ct_sc_View$Drop__sc_IterableOps__I__($thiz, underlying, n);
  return $thiz
}
/** @constructor */
function $c_sc_SeqView$Drop() {
  this.sc_View$Drop__f_underlying = null;
  this.sc_View$Drop__f_n = 0;
  this.sc_View$Drop__f_normN = 0;
  this.sc_SeqView$Drop__f_underlying = null;
  this.sc_SeqView$Drop__f_n = 0
}
$c_sc_SeqView$Drop.prototype = new $h_sc_View$Drop();
$c_sc_SeqView$Drop.prototype.constructor = $c_sc_SeqView$Drop;
/** @constructor */
function $h_sc_SeqView$Drop() {
  /*<skip>*/
}
$h_sc_SeqView$Drop.prototype = $c_sc_SeqView$Drop.prototype;
$c_sc_SeqView$Drop.prototype.map__F1__sc_SeqView = (function(f) {
  return $ct_sc_SeqView$Map__sc_SeqOps__F1__(new $c_sc_SeqView$Map(), this, f)
});
$c_sc_SeqView$Drop.prototype.stringPrefix__T = (function() {
  return "SeqView"
});
$c_sc_SeqView$Drop.prototype.concat__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix)
});
$c_sc_SeqView$Drop.prototype.indexWhere__F1__I__I = (function(p, from) {
  var this$1 = this.iterator__sc_Iterator();
  return $f_sc_Iterator__indexWhere__F1__I__I(this$1, p, from)
});
$c_sc_SeqView$Drop.prototype.lengthCompare__I__I = (function(len) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, len)
});
$c_sc_SeqView$Drop.prototype.isEmpty__Z = (function() {
  return $f_sc_SeqOps__isEmpty__Z(this)
});
$c_sc_SeqView$Drop.prototype.length__I = (function() {
  var this$1 = this.sc_SeqView$Drop__f_underlying;
  var x = ((this$1.length__I() - this.sc_View$Drop__f_normN) | 0);
  return ((x > 0) ? x : 0)
});
$c_sc_SeqView$Drop.prototype.apply__I__O = (function(i) {
  return this.sc_SeqView$Drop__f_underlying.apply__I__O(((i + this.sc_View$Drop__f_normN) | 0))
});
$c_sc_SeqView$Drop.prototype.drop__I__sc_SeqView = (function(n) {
  return $ct_sc_SeqView$Drop__sc_SeqOps__I__(new $c_sc_SeqView$Drop(), this.sc_SeqView$Drop__f_underlying, ((this.sc_SeqView$Drop__f_n + n) | 0))
});
$c_sc_SeqView$Drop.prototype.map__F1__O = (function(f) {
  return this.map__F1__sc_SeqView(f)
});
$c_sc_SeqView$Drop.prototype.drop__I__O = (function(n) {
  return this.drop__I__sc_SeqView(n)
});
var $d_sc_SeqView$Drop = new $TypeData().initClass({
  sc_SeqView$Drop: 0
}, false, "scala.collection.SeqView$Drop", {
  sc_SeqView$Drop: 1,
  sc_View$Drop: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1
});
$c_sc_SeqView$Drop.prototype.$classData = $d_sc_SeqView$Drop;
function $ct_sc_SeqView$Id__sc_SeqOps__($thiz, underlying) {
  $thiz.sc_SeqView$Id__f_underlying = underlying;
  return $thiz
}
/** @constructor */
function $c_sc_SeqView$Id() {
  this.sc_SeqView$Id__f_underlying = null
}
$c_sc_SeqView$Id.prototype = new $h_sc_AbstractSeqView();
$c_sc_SeqView$Id.prototype.constructor = $c_sc_SeqView$Id;
/** @constructor */
function $h_sc_SeqView$Id() {
  /*<skip>*/
}
$h_sc_SeqView$Id.prototype = $c_sc_SeqView$Id.prototype;
$c_sc_SeqView$Id.prototype.apply__I__O = (function(idx) {
  return this.sc_SeqView$Id__f_underlying.apply__I__O(idx)
});
$c_sc_SeqView$Id.prototype.length__I = (function() {
  return this.sc_SeqView$Id__f_underlying.length__I()
});
$c_sc_SeqView$Id.prototype.iterator__sc_Iterator = (function() {
  return this.sc_SeqView$Id__f_underlying.iterator__sc_Iterator()
});
$c_sc_SeqView$Id.prototype.knownSize__I = (function() {
  return this.sc_SeqView$Id__f_underlying.knownSize__I()
});
$c_sc_SeqView$Id.prototype.isEmpty__Z = (function() {
  return this.sc_SeqView$Id__f_underlying.isEmpty__Z()
});
var $d_sc_SeqView$Id = new $TypeData().initClass({
  sc_SeqView$Id: 0
}, false, "scala.collection.SeqView$Id", {
  sc_SeqView$Id: 1,
  sc_AbstractSeqView: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1
});
$c_sc_SeqView$Id.prototype.$classData = $d_sc_SeqView$Id;
function $ct_sc_SeqView$Map__sc_SeqOps__F1__($thiz, underlying, f) {
  $thiz.sc_SeqView$Map__f_underlying = underlying;
  $thiz.sc_SeqView$Map__f_f = f;
  $ct_sc_View$Map__sc_IterableOps__F1__($thiz, underlying, f);
  return $thiz
}
/** @constructor */
function $c_sc_SeqView$Map() {
  this.sc_View$Map__f_underlying = null;
  this.sc_View$Map__f_f = null;
  this.sc_SeqView$Map__f_underlying = null;
  this.sc_SeqView$Map__f_f = null
}
$c_sc_SeqView$Map.prototype = new $h_sc_View$Map();
$c_sc_SeqView$Map.prototype.constructor = $c_sc_SeqView$Map;
/** @constructor */
function $h_sc_SeqView$Map() {
  /*<skip>*/
}
$h_sc_SeqView$Map.prototype = $c_sc_SeqView$Map.prototype;
$c_sc_SeqView$Map.prototype.map__F1__sc_SeqView = (function(f) {
  return $ct_sc_SeqView$Map__sc_SeqOps__F1__(new $c_sc_SeqView$Map(), this, f)
});
$c_sc_SeqView$Map.prototype.drop__I__sc_SeqView = (function(n) {
  return $ct_sc_SeqView$Drop__sc_SeqOps__I__(new $c_sc_SeqView$Drop(), this, n)
});
$c_sc_SeqView$Map.prototype.stringPrefix__T = (function() {
  return "SeqView"
});
$c_sc_SeqView$Map.prototype.concat__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix)
});
$c_sc_SeqView$Map.prototype.indexWhere__F1__I__I = (function(p, from) {
  var this$1 = this.iterator__sc_Iterator();
  return $f_sc_Iterator__indexWhere__F1__I__I(this$1, p, from)
});
$c_sc_SeqView$Map.prototype.lengthCompare__I__I = (function(len) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, len)
});
$c_sc_SeqView$Map.prototype.isEmpty__Z = (function() {
  return $f_sc_SeqOps__isEmpty__Z(this)
});
$c_sc_SeqView$Map.prototype.apply__I__O = (function(idx) {
  return this.sc_SeqView$Map__f_f.apply__O__O(this.sc_SeqView$Map__f_underlying.apply__I__O(idx))
});
$c_sc_SeqView$Map.prototype.length__I = (function() {
  return this.sc_SeqView$Map__f_underlying.length__I()
});
$c_sc_SeqView$Map.prototype.drop__I__O = (function(n) {
  return this.drop__I__sc_SeqView(n)
});
$c_sc_SeqView$Map.prototype.map__F1__O = (function(f) {
  return this.map__F1__sc_SeqView(f)
});
var $d_sc_SeqView$Map = new $TypeData().initClass({
  sc_SeqView$Map: 0
}, false, "scala.collection.SeqView$Map", {
  sc_SeqView$Map: 1,
  sc_View$Map: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1
});
$c_sc_SeqView$Map.prototype.$classData = $d_sc_SeqView$Map;
function $is_sci_Seq(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sci_Seq)))
}
function $as_sci_Seq(obj) {
  return (($is_sci_Seq(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Seq"))
}
function $isArrayOf_sci_Seq(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Seq)))
}
function $asArrayOf_sci_Seq(obj, depth) {
  return (($isArrayOf_sci_Seq(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Seq;", depth))
}
function $f_scm_MapOps__put__O__O__s_Option($thiz, key, value) {
  var r = $thiz.get__O__s_Option(key);
  $thiz.update__O__O__V(key, value);
  return r
}
function $f_scm_MapOps__getOrElseUpdate__O__F0__O($thiz, key, op) {
  var x1 = $thiz.get__O__s_Option(key);
  if ((x1 instanceof $c_s_Some)) {
    var x2 = $as_s_Some(x1);
    var v = x2.s_Some__f_value;
    return v
  } else {
    var x = $m_s_None$();
    if ((x === x1)) {
      var d = op.apply__O();
      $thiz.update__O__O__V(key, d);
      return d
    } else {
      throw new $c_s_MatchError(x1)
    }
  }
}
/** @constructor */
function $c_sc_AbstractMapView() {
  /*<skip>*/
}
$c_sc_AbstractMapView.prototype = new $h_sc_AbstractView();
$c_sc_AbstractMapView.prototype.constructor = $c_sc_AbstractMapView;
/** @constructor */
function $h_sc_AbstractMapView() {
  /*<skip>*/
}
$h_sc_AbstractMapView.prototype = $c_sc_AbstractMapView.prototype;
$c_sc_AbstractMapView.prototype.toString__T = (function() {
  return $f_sc_View__toString__T(this)
});
$c_sc_AbstractMapView.prototype.stringPrefix__T = (function() {
  return "MapView"
});
$c_sc_AbstractMapView.prototype.getOrElse__O__F0__O = (function(key, default$1) {
  return $f_sc_MapOps__getOrElse__O__F0__O(this, key, default$1)
});
$c_sc_AbstractMapView.prototype.apply__O__O = (function(key) {
  return $f_sc_MapOps__apply__O__O(this, key)
});
$c_sc_AbstractMapView.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return $f_sc_MapOps__applyOrElse__O__F1__O(this, x, default$1)
});
$c_sc_AbstractMapView.prototype.isDefinedAt__O__Z = (function(key) {
  return $f_sc_MapOps__contains__O__Z(this, key)
});
$c_sc_AbstractMapView.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(sb, start, sep, end) {
  return $f_sc_MapOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, sb, start, sep, end)
});
$c_sc_AbstractMapView.prototype.mapFactory__sc_MapFactory = (function() {
  return $m_sc_MapView$()
});
function $is_sci_Map(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sci_Map)))
}
function $as_sci_Map(obj) {
  return (($is_sci_Map(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Map"))
}
function $isArrayOf_sci_Map(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Map)))
}
function $asArrayOf_sci_Map(obj, depth) {
  return (($isArrayOf_sci_Map(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Map;", depth))
}
function $p_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__onPress$lzycompute__Lscommons_reactnative_Touchable$TouchableAttributes$OnPressEventAttribute($thiz) {
  var b = $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0;
  var lo = (64 & b.RTLong__f_lo);
  if ((lo === 0)) {
    $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_onPress = new $c_Lscommons_reactnative_Touchable$TouchableAttributes$OnPressEventAttribute("onPress");
    var b$1 = $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0;
    var lo$1 = (64 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_onPress
}
function $p_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__thumbColor$lzycompute__Lio_github_shogowada_statictags_StringAttributeSpec($thiz) {
  var b = $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0;
  var lo = (131072 & b.RTLong__f_lo);
  if ((lo === 0)) {
    $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_thumbColor = new $c_Lio_github_shogowada_statictags_StringAttributeSpec("thumbColor");
    var b$1 = $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0;
    var lo$1 = (131072 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_thumbColor
}
function $p_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__trackColor$lzycompute__Lscommons_reactnative_Switch$SwitchAttributes$TrackColorAttributeSpec($thiz) {
  var b = $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0;
  var lo = (262144 & b.RTLong__f_lo);
  if ((lo === 0)) {
    $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_trackColor = new $c_Lscommons_reactnative_Switch$SwitchAttributes$TrackColorAttributeSpec("trackColor");
    var b$1 = $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0;
    var lo$1 = (262144 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_trackColor
}
function $p_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__switchOnValueChange$lzycompute__Lscommons_reactnative_Switch$SwitchAttributes$OnValueChangeAttributeSpec($thiz) {
  var b = $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0;
  var lo = (524288 & b.RTLong__f_lo);
  if ((lo === 0)) {
    $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_switchOnValueChange = new $c_Lscommons_reactnative_Switch$SwitchAttributes$OnValueChangeAttributeSpec("onValueChange");
    var b$1 = $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0;
    var lo$1 = (524288 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_switchOnValueChange
}
function $p_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__switchValue$lzycompute__Lio_github_shogowada_statictags_BooleanAttributeSpec($thiz) {
  var b = $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0;
  var lo = (1048576 & b.RTLong__f_lo);
  if ((lo === 0)) {
    $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_switchValue = new $c_Lio_github_shogowada_statictags_BooleanAttributeSpec("value");
    var b$1 = $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0;
    var lo$1 = (1048576 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_switchValue
}
function $p_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__barStyle$lzycompute__Lscommons_reactnative_StatusBar$StatusBarAttributes$BarStyleAttributeSpec($thiz) {
  var b = $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0;
  var lo = (8388608 & b.RTLong__f_lo);
  if ((lo === 0)) {
    $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_barStyle = new $c_Lscommons_reactnative_StatusBar$StatusBarAttributes$BarStyleAttributeSpec("barStyle");
    var b$1 = $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0;
    var lo$1 = (8388608 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_barStyle
}
function $p_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__keyboardShouldPersistTaps$lzycompute__Lscommons_reactnative_ScrollView$ScrollViewAttributes$KeyboardShouldPersistTapsAttribute($thiz) {
  var b = $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0;
  var lo = (33554432 & b.RTLong__f_lo);
  if ((lo === 0)) {
    $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_keyboardShouldPersistTaps = new $c_Lscommons_reactnative_ScrollView$ScrollViewAttributes$KeyboardShouldPersistTapsAttribute("keyboardShouldPersistTaps");
    var b$1 = $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0;
    var lo$1 = (33554432 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_keyboardShouldPersistTaps
}
function $p_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__visible$lzycompute__Lio_github_shogowada_statictags_BooleanAttributeSpec($thiz) {
  var b = $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0;
  var lo = (67108864 & b.RTLong__f_lo);
  if ((lo === 0)) {
    $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_visible = new $c_Lio_github_shogowada_statictags_BooleanAttributeSpec("visible");
    var b$1 = $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0;
    var lo$1 = (67108864 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_visible
}
function $p_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__onRequestClose$lzycompute__Lscommons_reactnative_Modal$ModalAttributes$Function0AttributeSpec($thiz) {
  var b = $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0;
  var lo = (134217728 & b.RTLong__f_lo);
  if ((lo === 0)) {
    $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_onRequestClose = new $c_Lscommons_reactnative_Modal$ModalAttributes$Function0AttributeSpec("onRequestClose");
    var b$1 = $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0;
    var lo$1 = (134217728 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_onRequestClose
}
function $p_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__onShow$lzycompute__Lscommons_reactnative_Modal$ModalAttributes$Function0AttributeSpec($thiz) {
  var b = $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0;
  var lo = (268435456 & b.RTLong__f_lo);
  if ((lo === 0)) {
    $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_onShow = new $c_Lscommons_reactnative_Modal$ModalAttributes$Function0AttributeSpec("onShow");
    var b$1 = $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0;
    var lo$1 = (268435456 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_onShow
}
function $p_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__transparent$lzycompute__Lio_github_shogowada_statictags_BooleanAttributeSpec($thiz) {
  var b = $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0;
  var lo = (536870912 & b.RTLong__f_lo);
  if ((lo === 0)) {
    $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_transparent = new $c_Lio_github_shogowada_statictags_BooleanAttributeSpec("transparent");
    var b$1 = $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0;
    var lo$1 = (536870912 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_transparent
}
function $p_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__animationType$lzycompute__Lscommons_reactnative_Modal$ModalAttributes$AnimationTypeAttributeSpec($thiz) {
  var b = $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0;
  var lo = (1073741824 & b.RTLong__f_lo);
  if ((lo === 0)) {
    $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_animationType = new $c_Lscommons_reactnative_Modal$ModalAttributes$AnimationTypeAttributeSpec("animationType");
    var b$1 = $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0;
    var lo$1 = (1073741824 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_animationType
}
function $p_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__source$lzycompute__Lscommons_reactnative_Image$ImageAttributes$ImageSourceAttributeSpec($thiz) {
  var b = $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0;
  var hi = (1 & b.RTLong__f_hi);
  if ((hi === 0)) {
    $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_source = new $c_Lscommons_reactnative_Image$ImageAttributes$ImageSourceAttributeSpec("source");
    var b$1 = $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0;
    var lo = b$1.RTLong__f_lo;
    var hi$1 = (1 | b$1.RTLong__f_hi);
    $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0 = new $c_RTLong(lo, hi$1)
  };
  return $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_source
}
function $p_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__renderItem$lzycompute__Lscommons_reactnative_FlatList$FlatListAttributes$RenderItemAttributeSpec($thiz) {
  var b = $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0;
  var hi = (2 & b.RTLong__f_hi);
  if ((hi === 0)) {
    $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_renderItem = new $c_Lscommons_reactnative_FlatList$FlatListAttributes$RenderItemAttributeSpec("renderItem");
    var b$1 = $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0;
    var lo = b$1.RTLong__f_lo;
    var hi$1 = (2 | b$1.RTLong__f_hi);
    $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0 = new $c_RTLong(lo, hi$1)
  };
  return $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_renderItem
}
function $p_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__flatListData$lzycompute__Lscommons_reactnative_FlatList$FlatListAttributes$DataAttributeSpec($thiz) {
  var b = $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0;
  var hi = (4 & b.RTLong__f_hi);
  if ((hi === 0)) {
    $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_flatListData = new $c_Lscommons_reactnative_FlatList$FlatListAttributes$DataAttributeSpec("data");
    var b$1 = $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0;
    var lo = b$1.RTLong__f_lo;
    var hi$1 = (4 | b$1.RTLong__f_hi);
    $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0 = new $c_RTLong(lo, hi$1)
  };
  return $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_flatListData
}
function $p_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__keyExtractor$lzycompute__Lscommons_reactnative_FlatList$FlatListAttributes$KeyExtractorAttributeSpec($thiz) {
  var b = $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0;
  var hi = (8 & b.RTLong__f_hi);
  if ((hi === 0)) {
    $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_keyExtractor = new $c_Lscommons_reactnative_FlatList$FlatListAttributes$KeyExtractorAttributeSpec("keyExtractor");
    var b$1 = $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0;
    var lo = b$1.RTLong__f_lo;
    var hi$1 = (8 | b$1.RTLong__f_hi);
    $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0 = new $c_RTLong(lo, hi$1)
  };
  return $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_keyExtractor
}
function $p_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__extraData$lzycompute__Lscommons_reactnative_FlatList$FlatListAttributes$ExtraDataAttributeSpec($thiz) {
  var b = $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0;
  var hi = (16 & b.RTLong__f_hi);
  if ((hi === 0)) {
    $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_extraData = new $c_Lscommons_reactnative_FlatList$FlatListAttributes$ExtraDataAttributeSpec("extraData");
    var b$1 = $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0;
    var lo = b$1.RTLong__f_lo;
    var hi$1 = (16 | b$1.RTLong__f_hi);
    $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0 = new $c_RTLong(lo, hi$1)
  };
  return $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_extraData
}
function $p_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__onRefresh$lzycompute__Lscommons_reactnative_FlatList$FlatListAttributes$OnRefreshAttributeSpec($thiz) {
  var b = $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0;
  var hi = (32 & b.RTLong__f_hi);
  if ((hi === 0)) {
    $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_onRefresh = new $c_Lscommons_reactnative_FlatList$FlatListAttributes$OnRefreshAttributeSpec("onRefresh");
    var b$1 = $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0;
    var lo = b$1.RTLong__f_lo;
    var hi$1 = (32 | b$1.RTLong__f_hi);
    $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0 = new $c_RTLong(lo, hi$1)
  };
  return $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_onRefresh
}
function $p_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__refreshing$lzycompute__Lio_github_shogowada_statictags_BooleanAttributeSpec($thiz) {
  var b = $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0;
  var hi = (64 & b.RTLong__f_hi);
  if ((hi === 0)) {
    $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_refreshing = new $c_Lio_github_shogowada_statictags_BooleanAttributeSpec("refreshing");
    var b$1 = $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0;
    var lo = b$1.RTLong__f_lo;
    var hi$1 = (64 | b$1.RTLong__f_hi);
    $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0 = new $c_RTLong(lo, hi$1)
  };
  return $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_refreshing
}
function $p_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__aiSize$lzycompute__Lscommons_reactnative_ActivityIndicator$ActivityIndicatorAttributes$ActivityIndicatorSizeAttributeSpec($thiz) {
  var b = $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0;
  var hi = (512 & b.RTLong__f_hi);
  if ((hi === 0)) {
    $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_aiSize = new $c_Lscommons_reactnative_ActivityIndicator$ActivityIndicatorAttributes$ActivityIndicatorSizeAttributeSpec("size");
    var b$1 = $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0;
    var lo = b$1.RTLong__f_lo;
    var hi$1 = (512 | b$1.RTLong__f_hi);
    $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0 = new $c_RTLong(lo, hi$1)
  };
  return $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_aiSize
}
function $p_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__rnStyle$lzycompute__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec($thiz) {
  var b = $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0;
  var lo = (2 & b.RTLong__f_lo);
  if ((lo === 0)) {
    $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_rnStyle = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec("style");
    var b$1 = $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0;
    var lo$1 = (2 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_rnStyle
}
function $p_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__rnSize$lzycompute__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeSizeAttributeSpec($thiz) {
  var b = $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0;
  var lo = (4 & b.RTLong__f_lo);
  if ((lo === 0)) {
    $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_rnSize = new $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeSizeAttributeSpec("size");
    var b$1 = $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0;
    var lo$1 = (4 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_rnSize
}
function $p_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__color$lzycompute__Lio_github_shogowada_statictags_StringAttributeSpec($thiz) {
  var b = $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0;
  var lo = (8 & b.RTLong__f_lo);
  if ((lo === 0)) {
    $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_color = new $c_Lio_github_shogowada_statictags_StringAttributeSpec("color");
    var b$1 = $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0;
    var lo$1 = (8 | b$1.RTLong__f_lo);
    var hi = b$1.RTLong__f_hi;
    $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0 = new $c_RTLong(lo$1, hi)
  };
  return $thiz.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_color
}
/** @constructor */
function $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes(attributes) {
  this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_contentContainerStyle = null;
  this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_rnStyle = null;
  this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_rnSize = null;
  this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_color = null;
  this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_activeOpacity = null;
  this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_underlayColor = null;
  this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_onPress = null;
  this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_allowFontScaling = null;
  this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_autoCapitalize = null;
  this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_autoCompleteType = null;
  this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_autoCorrect = null;
  this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_autoFocus = null;
  this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_placeholderTextColor = null;
  this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_selectionColor = null;
  this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_secureTextEntry = null;
  this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_keyboardType = null;
  this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_onChangeText = null;
  this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_thumbColor = null;
  this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_trackColor = null;
  this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_switchOnValueChange = null;
  this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_switchValue = null;
  this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_animated = null;
  this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_hidden = null;
  this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_barStyle = null;
  this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_keyboardDismissMode = null;
  this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_keyboardShouldPersistTaps = null;
  this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_visible = null;
  this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_onRequestClose = null;
  this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_onShow = null;
  this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_transparent = null;
  this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_animationType = null;
  this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_behavior = null;
  this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_source = null;
  this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_renderItem = null;
  this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_flatListData = null;
  this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_keyExtractor = null;
  this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_extraData = null;
  this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_onRefresh = null;
  this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_refreshing = null;
  this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_accessibilityLabel = null;
  this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_animating = null;
  this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_aiSize = null;
  this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0 = $L0
}
$c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes.prototype = new $h_O();
$c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes.prototype.constructor = $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes;
/** @constructor */
function $h_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes() {
  /*<skip>*/
}
$h_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes.prototype = $c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes.prototype;
$c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes.prototype.onPress__Lscommons_reactnative_Touchable$TouchableAttributes$OnPressEventAttribute = (function() {
  var b = this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0;
  var lo = (64 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__onPress$lzycompute__Lscommons_reactnative_Touchable$TouchableAttributes$OnPressEventAttribute(this)
  } else {
    return this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_onPress
  }
});
$c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes.prototype.thumbColor__Lio_github_shogowada_statictags_StringAttributeSpec = (function() {
  var b = this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0;
  var lo = (131072 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__thumbColor$lzycompute__Lio_github_shogowada_statictags_StringAttributeSpec(this)
  } else {
    return this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_thumbColor
  }
});
$c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes.prototype.trackColor__Lscommons_reactnative_Switch$SwitchAttributes$TrackColorAttributeSpec = (function() {
  var b = this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0;
  var lo = (262144 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__trackColor$lzycompute__Lscommons_reactnative_Switch$SwitchAttributes$TrackColorAttributeSpec(this)
  } else {
    return this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_trackColor
  }
});
$c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes.prototype.switchOnValueChange__Lscommons_reactnative_Switch$SwitchAttributes$OnValueChangeAttributeSpec = (function() {
  var b = this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0;
  var lo = (524288 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__switchOnValueChange$lzycompute__Lscommons_reactnative_Switch$SwitchAttributes$OnValueChangeAttributeSpec(this)
  } else {
    return this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_switchOnValueChange
  }
});
$c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes.prototype.switchValue__Lio_github_shogowada_statictags_BooleanAttributeSpec = (function() {
  var b = this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0;
  var lo = (1048576 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__switchValue$lzycompute__Lio_github_shogowada_statictags_BooleanAttributeSpec(this)
  } else {
    return this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_switchValue
  }
});
$c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes.prototype.barStyle__Lscommons_reactnative_StatusBar$StatusBarAttributes$BarStyleAttributeSpec = (function() {
  var b = this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0;
  var lo = (8388608 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__barStyle$lzycompute__Lscommons_reactnative_StatusBar$StatusBarAttributes$BarStyleAttributeSpec(this)
  } else {
    return this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_barStyle
  }
});
$c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes.prototype.keyboardShouldPersistTaps__Lscommons_reactnative_ScrollView$ScrollViewAttributes$KeyboardShouldPersistTapsAttribute = (function() {
  var b = this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0;
  var lo = (33554432 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__keyboardShouldPersistTaps$lzycompute__Lscommons_reactnative_ScrollView$ScrollViewAttributes$KeyboardShouldPersistTapsAttribute(this)
  } else {
    return this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_keyboardShouldPersistTaps
  }
});
$c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes.prototype.visible__Lio_github_shogowada_statictags_BooleanAttributeSpec = (function() {
  var b = this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0;
  var lo = (67108864 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__visible$lzycompute__Lio_github_shogowada_statictags_BooleanAttributeSpec(this)
  } else {
    return this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_visible
  }
});
$c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes.prototype.onRequestClose__Lscommons_reactnative_Modal$ModalAttributes$Function0AttributeSpec = (function() {
  var b = this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0;
  var lo = (134217728 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__onRequestClose$lzycompute__Lscommons_reactnative_Modal$ModalAttributes$Function0AttributeSpec(this)
  } else {
    return this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_onRequestClose
  }
});
$c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes.prototype.onShow__Lscommons_reactnative_Modal$ModalAttributes$Function0AttributeSpec = (function() {
  var b = this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0;
  var lo = (268435456 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__onShow$lzycompute__Lscommons_reactnative_Modal$ModalAttributes$Function0AttributeSpec(this)
  } else {
    return this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_onShow
  }
});
$c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes.prototype.transparent__Lio_github_shogowada_statictags_BooleanAttributeSpec = (function() {
  var b = this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0;
  var lo = (536870912 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__transparent$lzycompute__Lio_github_shogowada_statictags_BooleanAttributeSpec(this)
  } else {
    return this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_transparent
  }
});
$c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes.prototype.animationType__Lscommons_reactnative_Modal$ModalAttributes$AnimationTypeAttributeSpec = (function() {
  var b = this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0;
  var lo = (1073741824 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__animationType$lzycompute__Lscommons_reactnative_Modal$ModalAttributes$AnimationTypeAttributeSpec(this)
  } else {
    return this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_animationType
  }
});
$c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes.prototype.source__Lscommons_reactnative_Image$ImageAttributes$ImageSourceAttributeSpec = (function() {
  var b = this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0;
  var hi = (1 & b.RTLong__f_hi);
  if ((hi === 0)) {
    return $p_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__source$lzycompute__Lscommons_reactnative_Image$ImageAttributes$ImageSourceAttributeSpec(this)
  } else {
    return this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_source
  }
});
$c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes.prototype.renderItem__Lscommons_reactnative_FlatList$FlatListAttributes$RenderItemAttributeSpec = (function() {
  var b = this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0;
  var hi = (2 & b.RTLong__f_hi);
  if ((hi === 0)) {
    return $p_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__renderItem$lzycompute__Lscommons_reactnative_FlatList$FlatListAttributes$RenderItemAttributeSpec(this)
  } else {
    return this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_renderItem
  }
});
$c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes.prototype.flatListData__Lscommons_reactnative_FlatList$FlatListAttributes$DataAttributeSpec = (function() {
  var b = this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0;
  var hi = (4 & b.RTLong__f_hi);
  if ((hi === 0)) {
    return $p_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__flatListData$lzycompute__Lscommons_reactnative_FlatList$FlatListAttributes$DataAttributeSpec(this)
  } else {
    return this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_flatListData
  }
});
$c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes.prototype.keyExtractor__Lscommons_reactnative_FlatList$FlatListAttributes$KeyExtractorAttributeSpec = (function() {
  var b = this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0;
  var hi = (8 & b.RTLong__f_hi);
  if ((hi === 0)) {
    return $p_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__keyExtractor$lzycompute__Lscommons_reactnative_FlatList$FlatListAttributes$KeyExtractorAttributeSpec(this)
  } else {
    return this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_keyExtractor
  }
});
$c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes.prototype.extraData__Lscommons_reactnative_FlatList$FlatListAttributes$ExtraDataAttributeSpec = (function() {
  var b = this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0;
  var hi = (16 & b.RTLong__f_hi);
  if ((hi === 0)) {
    return $p_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__extraData$lzycompute__Lscommons_reactnative_FlatList$FlatListAttributes$ExtraDataAttributeSpec(this)
  } else {
    return this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_extraData
  }
});
$c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes.prototype.onRefresh__Lscommons_reactnative_FlatList$FlatListAttributes$OnRefreshAttributeSpec = (function() {
  var b = this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0;
  var hi = (32 & b.RTLong__f_hi);
  if ((hi === 0)) {
    return $p_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__onRefresh$lzycompute__Lscommons_reactnative_FlatList$FlatListAttributes$OnRefreshAttributeSpec(this)
  } else {
    return this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_onRefresh
  }
});
$c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes.prototype.refreshing__Lio_github_shogowada_statictags_BooleanAttributeSpec = (function() {
  var b = this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0;
  var hi = (64 & b.RTLong__f_hi);
  if ((hi === 0)) {
    return $p_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__refreshing$lzycompute__Lio_github_shogowada_statictags_BooleanAttributeSpec(this)
  } else {
    return this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_refreshing
  }
});
$c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes.prototype.aiSize__Lscommons_reactnative_ActivityIndicator$ActivityIndicatorAttributes$ActivityIndicatorSizeAttributeSpec = (function() {
  var b = this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0;
  var hi = (512 & b.RTLong__f_hi);
  if ((hi === 0)) {
    return $p_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__aiSize$lzycompute__Lscommons_reactnative_ActivityIndicator$ActivityIndicatorAttributes$ActivityIndicatorSizeAttributeSpec(this)
  } else {
    return this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_aiSize
  }
});
$c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes.prototype.rnStyle__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec = (function() {
  var b = this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0;
  var lo = (2 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__rnStyle$lzycompute__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeStyleAttributeSpec(this)
  } else {
    return this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_rnStyle
  }
});
$c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes.prototype.rnSize__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeSizeAttributeSpec = (function() {
  var b = this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0;
  var lo = (4 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__rnSize$lzycompute__Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes$ReactNativeSizeAttributeSpec(this)
  } else {
    return this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_rnSize
  }
});
$c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes.prototype.color__Lio_github_shogowada_statictags_StringAttributeSpec = (function() {
  var b = this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_bitmap$0;
  var lo = (8 & b.RTLong__f_lo);
  if ((lo === 0)) {
    return $p_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__color$lzycompute__Lio_github_shogowada_statictags_StringAttributeSpec(this)
  } else {
    return this.Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes__f_color
  }
});
var $d_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes = new $TypeData().initClass({
  Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes: 0
}, false, "scommons.reactnative.package$ReactNativeVirtualDOMAttributes", {
  Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes: 1,
  O: 1,
  Lscommons_reactnative_ActivityIndicator$ActivityIndicatorAttributes: 1,
  Lscommons_reactnative_Button$ButtonAttributes: 1,
  Lscommons_reactnative_FlatList$FlatListAttributes: 1,
  Lscommons_reactnative_Image$ImageAttributes: 1,
  Lscommons_reactnative_KeyboardAvoidingView$KeyboardAvoidingViewAttributes: 1,
  Lscommons_reactnative_Modal$ModalAttributes: 1,
  Lscommons_reactnative_ScrollView$ScrollViewAttributes: 1,
  Lscommons_reactnative_StatusBar$StatusBarAttributes: 1,
  Lscommons_reactnative_Switch$SwitchAttributes: 1,
  Lscommons_reactnative_TextInput$TextInputAttributes: 1,
  Lscommons_reactnative_Touchable$TouchableAttributes: 1,
  Lscommons_reactnative_TouchableHighlight$TouchableHighlightAttributes: 1,
  Lscommons_reactnative_TouchableOpacity$TouchableOpacityAttributes: 1
});
$c_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes.prototype.$classData = $d_Lscommons_reactnative_package$ReactNativeVirtualDOMAttributes;
/** @constructor */
function $c_sc_AbstractIndexedSeqView() {
  /*<skip>*/
}
$c_sc_AbstractIndexedSeqView.prototype = new $h_sc_AbstractSeqView();
$c_sc_AbstractIndexedSeqView.prototype.constructor = $c_sc_AbstractIndexedSeqView;
/** @constructor */
function $h_sc_AbstractIndexedSeqView() {
  /*<skip>*/
}
$h_sc_AbstractIndexedSeqView.prototype = $c_sc_AbstractIndexedSeqView.prototype;
$c_sc_AbstractIndexedSeqView.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_IndexedSeqView$IndexedSeqViewIterator(this)
});
$c_sc_AbstractIndexedSeqView.prototype.stringPrefix__T = (function() {
  return "IndexedSeqView"
});
$c_sc_AbstractIndexedSeqView.prototype.head__O = (function() {
  return this.apply__I__O(0)
});
$c_sc_AbstractIndexedSeqView.prototype.lengthCompare__I__I = (function(len) {
  var x = this.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1))
});
$c_sc_AbstractIndexedSeqView.prototype.knownSize__I = (function() {
  return this.length__I()
});
$c_sc_AbstractIndexedSeqView.prototype.map__F1__sc_SeqView = (function(f) {
  return new $c_sc_IndexedSeqView$Map(this, f)
});
$c_sc_AbstractIndexedSeqView.prototype.map__F1__O = (function(f) {
  return new $c_sc_IndexedSeqView$Map(this, f)
});
$c_sc_AbstractIndexedSeqView.prototype.drop__I__sc_SeqView = (function(n) {
  return new $c_sc_IndexedSeqView$Drop(this, n)
});
$c_sc_AbstractIndexedSeqView.prototype.drop__I__O = (function(n) {
  return new $c_sc_IndexedSeqView$Drop(this, n)
});
/** @constructor */
function $c_sc_MapView$$anon$1() {
  /*<skip>*/
}
$c_sc_MapView$$anon$1.prototype = new $h_sc_AbstractMapView();
$c_sc_MapView$$anon$1.prototype.constructor = $c_sc_MapView$$anon$1;
/** @constructor */
function $h_sc_MapView$$anon$1() {
  /*<skip>*/
}
$h_sc_MapView$$anon$1.prototype = $c_sc_MapView$$anon$1.prototype;
$c_sc_MapView$$anon$1.prototype.get__O__s_Option = (function(key) {
  return $m_s_None$()
});
$c_sc_MapView$$anon$1.prototype.iterator__sc_Iterator = (function() {
  return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty
});
$c_sc_MapView$$anon$1.prototype.knownSize__I = (function() {
  return 0
});
$c_sc_MapView$$anon$1.prototype.isEmpty__Z = (function() {
  return true
});
var $d_sc_MapView$$anon$1 = new $TypeData().initClass({
  sc_MapView$$anon$1: 0
}, false, "scala.collection.MapView$$anon$1", {
  sc_MapView$$anon$1: 1,
  sc_AbstractMapView: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_MapView: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1
});
$c_sc_MapView$$anon$1.prototype.$classData = $d_sc_MapView$$anon$1;
/** @constructor */
function $c_sc_MapView$Id(underlying) {
  this.sc_MapView$Id__f_underlying = null;
  this.sc_MapView$Id__f_underlying = underlying
}
$c_sc_MapView$Id.prototype = new $h_sc_AbstractMapView();
$c_sc_MapView$Id.prototype.constructor = $c_sc_MapView$Id;
/** @constructor */
function $h_sc_MapView$Id() {
  /*<skip>*/
}
$h_sc_MapView$Id.prototype = $c_sc_MapView$Id.prototype;
$c_sc_MapView$Id.prototype.get__O__s_Option = (function(key) {
  return this.sc_MapView$Id__f_underlying.get__O__s_Option(key)
});
$c_sc_MapView$Id.prototype.iterator__sc_Iterator = (function() {
  return this.sc_MapView$Id__f_underlying.iterator__sc_Iterator()
});
$c_sc_MapView$Id.prototype.knownSize__I = (function() {
  return this.sc_MapView$Id__f_underlying.knownSize__I()
});
$c_sc_MapView$Id.prototype.isEmpty__Z = (function() {
  return this.sc_MapView$Id__f_underlying.isEmpty__Z()
});
var $d_sc_MapView$Id = new $TypeData().initClass({
  sc_MapView$Id: 0
}, false, "scala.collection.MapView$Id", {
  sc_MapView$Id: 1,
  sc_AbstractMapView: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_MapView: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1
});
$c_sc_MapView$Id.prototype.$classData = $d_sc_MapView$Id;
/** @constructor */
function $c_sc_MapView$MapValues(underlying, f) {
  this.sc_MapView$MapValues__f_underlying = null;
  this.sc_MapView$MapValues__f_f = null;
  this.sc_MapView$MapValues__f_underlying = underlying;
  this.sc_MapView$MapValues__f_f = f
}
$c_sc_MapView$MapValues.prototype = new $h_sc_AbstractMapView();
$c_sc_MapView$MapValues.prototype.constructor = $c_sc_MapView$MapValues;
/** @constructor */
function $h_sc_MapView$MapValues() {
  /*<skip>*/
}
$h_sc_MapView$MapValues.prototype = $c_sc_MapView$MapValues.prototype;
$c_sc_MapView$MapValues.prototype.iterator__sc_Iterator = (function() {
  var this$2 = this.sc_MapView$MapValues__f_underlying.iterator__sc_Iterator();
  var f = new $c_sjsr_AnonFunction1((function(this$1) {
    return (function(kv$2) {
      var kv = $as_T2(kv$2);
      return new $c_T2(kv._1__O(), this$1.sc_MapView$MapValues__f_f.apply__O__O(kv._2__O()))
    })
  })(this));
  return new $c_sc_Iterator$$anon$9(this$2, f)
});
$c_sc_MapView$MapValues.prototype.get__O__s_Option = (function(key) {
  var this$1 = this.sc_MapView$MapValues__f_underlying.get__O__s_Option(key);
  var f = this.sc_MapView$MapValues__f_f;
  return (this$1.isEmpty__Z() ? $m_s_None$() : new $c_s_Some(f.apply__O__O(this$1.get__O())))
});
$c_sc_MapView$MapValues.prototype.knownSize__I = (function() {
  return this.sc_MapView$MapValues__f_underlying.knownSize__I()
});
$c_sc_MapView$MapValues.prototype.isEmpty__Z = (function() {
  return this.sc_MapView$MapValues__f_underlying.isEmpty__Z()
});
var $d_sc_MapView$MapValues = new $TypeData().initClass({
  sc_MapView$MapValues: 0
}, false, "scala.collection.MapView$MapValues", {
  sc_MapView$MapValues: 1,
  sc_AbstractMapView: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_MapView: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1
});
$c_sc_MapView$MapValues.prototype.$classData = $d_sc_MapView$MapValues;
/** @constructor */
function $c_sci_AbstractSet() {
  /*<skip>*/
}
$c_sci_AbstractSet.prototype = new $h_sc_AbstractSet();
$c_sci_AbstractSet.prototype.constructor = $c_sci_AbstractSet;
/** @constructor */
function $h_sci_AbstractSet() {
  /*<skip>*/
}
$h_sci_AbstractSet.prototype = $c_sci_AbstractSet.prototype;
$c_sci_AbstractSet.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sci_Set$()
});
/** @constructor */
function $c_sc_IndexedSeqView$Drop(underlying, n) {
  this.sc_View$Drop__f_underlying = null;
  this.sc_View$Drop__f_n = 0;
  this.sc_View$Drop__f_normN = 0;
  this.sc_SeqView$Drop__f_underlying = null;
  this.sc_SeqView$Drop__f_n = 0;
  $ct_sc_SeqView$Drop__sc_SeqOps__I__(this, underlying, n)
}
$c_sc_IndexedSeqView$Drop.prototype = new $h_sc_SeqView$Drop();
$c_sc_IndexedSeqView$Drop.prototype.constructor = $c_sc_IndexedSeqView$Drop;
/** @constructor */
function $h_sc_IndexedSeqView$Drop() {
  /*<skip>*/
}
$h_sc_IndexedSeqView$Drop.prototype = $c_sc_IndexedSeqView$Drop.prototype;
$c_sc_IndexedSeqView$Drop.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_IndexedSeqView$IndexedSeqViewIterator(this)
});
$c_sc_IndexedSeqView$Drop.prototype.stringPrefix__T = (function() {
  return "IndexedSeqView"
});
$c_sc_IndexedSeqView$Drop.prototype.head__O = (function() {
  return this.apply__I__O(0)
});
$c_sc_IndexedSeqView$Drop.prototype.lengthCompare__I__I = (function(len) {
  var x = this.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1))
});
$c_sc_IndexedSeqView$Drop.prototype.knownSize__I = (function() {
  return this.length__I()
});
$c_sc_IndexedSeqView$Drop.prototype.map__F1__sc_SeqView = (function(f) {
  return new $c_sc_IndexedSeqView$Map(this, f)
});
$c_sc_IndexedSeqView$Drop.prototype.map__F1__O = (function(f) {
  return new $c_sc_IndexedSeqView$Map(this, f)
});
$c_sc_IndexedSeqView$Drop.prototype.drop__I__sc_SeqView = (function(n) {
  return new $c_sc_IndexedSeqView$Drop(this, n)
});
$c_sc_IndexedSeqView$Drop.prototype.drop__I__O = (function(n) {
  return new $c_sc_IndexedSeqView$Drop(this, n)
});
var $d_sc_IndexedSeqView$Drop = new $TypeData().initClass({
  sc_IndexedSeqView$Drop: 0
}, false, "scala.collection.IndexedSeqView$Drop", {
  sc_IndexedSeqView$Drop: 1,
  sc_SeqView$Drop: 1,
  sc_View$Drop: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IndexedSeqView: 1,
  sc_IndexedSeqOps: 1
});
$c_sc_IndexedSeqView$Drop.prototype.$classData = $d_sc_IndexedSeqView$Drop;
/** @constructor */
function $c_sc_IndexedSeqView$Id(underlying) {
  this.sc_SeqView$Id__f_underlying = null;
  $ct_sc_SeqView$Id__sc_SeqOps__(this, underlying)
}
$c_sc_IndexedSeqView$Id.prototype = new $h_sc_SeqView$Id();
$c_sc_IndexedSeqView$Id.prototype.constructor = $c_sc_IndexedSeqView$Id;
/** @constructor */
function $h_sc_IndexedSeqView$Id() {
  /*<skip>*/
}
$h_sc_IndexedSeqView$Id.prototype = $c_sc_IndexedSeqView$Id.prototype;
$c_sc_IndexedSeqView$Id.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_IndexedSeqView$IndexedSeqViewIterator(this)
});
$c_sc_IndexedSeqView$Id.prototype.stringPrefix__T = (function() {
  return "IndexedSeqView"
});
$c_sc_IndexedSeqView$Id.prototype.head__O = (function() {
  return this.apply__I__O(0)
});
$c_sc_IndexedSeqView$Id.prototype.lengthCompare__I__I = (function(len) {
  var x = this.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1))
});
$c_sc_IndexedSeqView$Id.prototype.knownSize__I = (function() {
  return this.length__I()
});
$c_sc_IndexedSeqView$Id.prototype.map__F1__sc_SeqView = (function(f) {
  return new $c_sc_IndexedSeqView$Map(this, f)
});
$c_sc_IndexedSeqView$Id.prototype.map__F1__O = (function(f) {
  return new $c_sc_IndexedSeqView$Map(this, f)
});
$c_sc_IndexedSeqView$Id.prototype.drop__I__sc_SeqView = (function(n) {
  return new $c_sc_IndexedSeqView$Drop(this, n)
});
$c_sc_IndexedSeqView$Id.prototype.drop__I__O = (function(n) {
  return new $c_sc_IndexedSeqView$Drop(this, n)
});
var $d_sc_IndexedSeqView$Id = new $TypeData().initClass({
  sc_IndexedSeqView$Id: 0
}, false, "scala.collection.IndexedSeqView$Id", {
  sc_IndexedSeqView$Id: 1,
  sc_SeqView$Id: 1,
  sc_AbstractSeqView: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IndexedSeqView: 1,
  sc_IndexedSeqOps: 1
});
$c_sc_IndexedSeqView$Id.prototype.$classData = $d_sc_IndexedSeqView$Id;
/** @constructor */
function $c_sc_IndexedSeqView$Map(underlying, f) {
  this.sc_View$Map__f_underlying = null;
  this.sc_View$Map__f_f = null;
  this.sc_SeqView$Map__f_underlying = null;
  this.sc_SeqView$Map__f_f = null;
  $ct_sc_SeqView$Map__sc_SeqOps__F1__(this, underlying, f)
}
$c_sc_IndexedSeqView$Map.prototype = new $h_sc_SeqView$Map();
$c_sc_IndexedSeqView$Map.prototype.constructor = $c_sc_IndexedSeqView$Map;
/** @constructor */
function $h_sc_IndexedSeqView$Map() {
  /*<skip>*/
}
$h_sc_IndexedSeqView$Map.prototype = $c_sc_IndexedSeqView$Map.prototype;
$c_sc_IndexedSeqView$Map.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_IndexedSeqView$IndexedSeqViewIterator(this)
});
$c_sc_IndexedSeqView$Map.prototype.stringPrefix__T = (function() {
  return "IndexedSeqView"
});
$c_sc_IndexedSeqView$Map.prototype.head__O = (function() {
  return this.apply__I__O(0)
});
$c_sc_IndexedSeqView$Map.prototype.lengthCompare__I__I = (function(len) {
  var x = this.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1))
});
$c_sc_IndexedSeqView$Map.prototype.knownSize__I = (function() {
  return this.length__I()
});
$c_sc_IndexedSeqView$Map.prototype.map__F1__sc_SeqView = (function(f) {
  return new $c_sc_IndexedSeqView$Map(this, f)
});
$c_sc_IndexedSeqView$Map.prototype.map__F1__O = (function(f) {
  return new $c_sc_IndexedSeqView$Map(this, f)
});
$c_sc_IndexedSeqView$Map.prototype.drop__I__sc_SeqView = (function(n) {
  return new $c_sc_IndexedSeqView$Drop(this, n)
});
$c_sc_IndexedSeqView$Map.prototype.drop__I__O = (function(n) {
  return new $c_sc_IndexedSeqView$Drop(this, n)
});
var $d_sc_IndexedSeqView$Map = new $TypeData().initClass({
  sc_IndexedSeqView$Map: 0
}, false, "scala.collection.IndexedSeqView$Map", {
  sc_IndexedSeqView$Map: 1,
  sc_SeqView$Map: 1,
  sc_View$Map: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IndexedSeqView: 1,
  sc_IndexedSeqOps: 1
});
$c_sc_IndexedSeqView$Map.prototype.$classData = $d_sc_IndexedSeqView$Map;
function $f_sc_convert_JavaCollectionWrappers$JMapWrapperLike__get__O__s_Option($thiz, k) {
  var this$1 = $thiz.sc_convert_JavaCollectionWrappers$JMapWrapper__f_underlying;
  var v = $p_ju_HashMap__getOrDefaultImpl__O__O__O(this$1, k, null);
  return ((v !== null) ? new $c_s_Some(v) : ($thiz.sc_convert_JavaCollectionWrappers$JMapWrapper__f_underlying.containsKey__O__Z(k) ? new $c_s_Some(null) : $m_s_None$()))
}
function $f_sc_convert_JavaCollectionWrappers$JMapWrapperLike__addOne__T2__sc_convert_JavaCollectionWrappers$JMapWrapperLike($thiz, kv) {
  var this$1 = $thiz.sc_convert_JavaCollectionWrappers$JMapWrapper__f_underlying;
  var key = kv._1__O();
  var value = kv._2__O();
  if ((key === null)) {
    var $$x1 = 0
  } else {
    var originalHash = $dp_hashCode__I(key);
    var $$x1 = (originalHash ^ ((originalHash >>> 16) | 0))
  };
  this$1.java$util$HashMap$$put0__O__O__I__Z__O(key, value, $$x1, false);
  return $thiz
}
function $f_sc_convert_JavaCollectionWrappers$JMapWrapperLike__put__O__O__s_Option($thiz, k, v) {
  var $$x2 = $m_s_Option$();
  var this$1 = $thiz.sc_convert_JavaCollectionWrappers$JMapWrapper__f_underlying;
  if ((k === null)) {
    var $$x1 = 0
  } else {
    var originalHash = $dp_hashCode__I(k);
    var $$x1 = (originalHash ^ ((originalHash >>> 16) | 0))
  };
  return $$x2.apply__O__s_Option(this$1.java$util$HashMap$$put0__O__O__I__Z__O(k, v, $$x1, false))
}
function $f_sc_convert_JavaCollectionWrappers$JMapWrapperLike__foreachEntry__F2__V($thiz, f) {
  var this$1 = $thiz.sc_convert_JavaCollectionWrappers$JMapWrapper__f_underlying;
  var i = new $c_ju_HashMap$EntrySet(this$1).iterator__ju_Iterator();
  while (i.hasNext__Z()) {
    var entry = $as_ju_Map$Entry(i.next__O());
    f.apply__O__O__O(entry.ju_HashMap$Node__f_key, entry.ju_HashMap$Node__f_value)
  }
}
/** @constructor */
function $c_sci_AbstractSeq() {
  /*<skip>*/
}
$c_sci_AbstractSeq.prototype = new $h_sc_AbstractSeq();
$c_sci_AbstractSeq.prototype.constructor = $c_sci_AbstractSeq;
/** @constructor */
function $h_sci_AbstractSeq() {
  /*<skip>*/
}
$h_sci_AbstractSeq.prototype = $c_sci_AbstractSeq.prototype;
$c_sci_AbstractSeq.prototype.toSeq__sci_Seq = (function() {
  return this
});
/** @constructor */
function $c_scm_ArrayBufferView(array, length) {
  this.scm_ArrayBufferView__f_array = null;
  this.scm_ArrayBufferView__f_length = 0;
  this.scm_ArrayBufferView__f_array = array;
  this.scm_ArrayBufferView__f_length = length
}
$c_scm_ArrayBufferView.prototype = new $h_sc_AbstractIndexedSeqView();
$c_scm_ArrayBufferView.prototype.constructor = $c_scm_ArrayBufferView;
/** @constructor */
function $h_scm_ArrayBufferView() {
  /*<skip>*/
}
$h_scm_ArrayBufferView.prototype = $c_scm_ArrayBufferView.prototype;
$c_scm_ArrayBufferView.prototype.length__I = (function() {
  return this.scm_ArrayBufferView__f_length
});
$c_scm_ArrayBufferView.prototype.apply__I__O = (function(n) {
  if ((n < this.scm_ArrayBufferView__f_length)) {
    return this.scm_ArrayBufferView__f_array.get(n)
  } else {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (((n + " is out of bounds (min 0, max ") + (((-1) + this.scm_ArrayBufferView__f_length) | 0)) + ")"))
  }
});
$c_scm_ArrayBufferView.prototype.className__T = (function() {
  return "ArrayBufferView"
});
var $d_scm_ArrayBufferView = new $TypeData().initClass({
  scm_ArrayBufferView: 0
}, false, "scala.collection.mutable.ArrayBufferView", {
  scm_ArrayBufferView: 1,
  sc_AbstractIndexedSeqView: 1,
  sc_AbstractSeqView: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IndexedSeqView: 1,
  sc_IndexedSeqOps: 1
});
$c_scm_ArrayBufferView.prototype.$classData = $d_scm_ArrayBufferView;
/** @constructor */
function $c_sci_AbstractMap() {
  /*<skip>*/
}
$c_sci_AbstractMap.prototype = new $h_sc_AbstractMap();
$c_sci_AbstractMap.prototype.constructor = $c_sci_AbstractMap;
/** @constructor */
function $h_sci_AbstractMap() {
  /*<skip>*/
}
$h_sci_AbstractMap.prototype = $c_sci_AbstractMap.prototype;
$c_sci_AbstractMap.prototype.mapFactory__sc_MapFactory = (function() {
  return $m_sci_Map$()
});
$c_sci_AbstractMap.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sci_Iterable$()
});
function $f_sci_IndexedSeq__canEqual__O__Z($thiz, that) {
  if ((!$is_sci_IndexedSeq(that))) {
    return true
  } else {
    var x2 = $as_sci_IndexedSeq(that);
    return ($thiz.length__I() === x2.length__I())
  }
}
function $f_sci_IndexedSeq__sameElements__sc_IterableOnce__Z($thiz, o) {
  if ($is_sci_IndexedSeq(o)) {
    var x2 = $as_sci_IndexedSeq(o);
    if (($thiz === x2)) {
      return true
    } else {
      var length = $thiz.length__I();
      var equal = (length === x2.length__I());
      if (equal) {
        var index = 0;
        var a = $thiz.applyPreferredMaxLength__I();
        var b = x2.applyPreferredMaxLength__I();
        var preferredLength = ((a < b) ? a : b);
        var hi = (length >> 31);
        var hi$1 = (preferredLength >> 31);
        var lo = (preferredLength << 1);
        var hi$2 = (((preferredLength >>> 31) | 0) | (hi$1 << 1));
        if (((hi === hi$2) ? (((-2147483648) ^ length) > ((-2147483648) ^ lo)) : (hi > hi$2))) {
          var maxApplyCompare = preferredLength
        } else {
          var maxApplyCompare = length
        };
        while (((index < maxApplyCompare) && equal)) {
          equal = $m_sr_BoxesRunTime$().equals__O__O__Z($thiz.apply__I__O(index), x2.apply__I__O(index));
          index = ((1 + index) | 0)
        };
        if (((index < length) && equal)) {
          var thisIt = $thiz.iterator__sc_Iterator().drop__I__sc_Iterator(index);
          var thatIt = x2.iterator__sc_Iterator().drop__I__sc_Iterator(index);
          while ((equal && thisIt.hasNext__Z())) {
            equal = $m_sr_BoxesRunTime$().equals__O__O__Z(thisIt.next__O(), thatIt.next__O())
          }
        }
      };
      return equal
    }
  } else {
    return $f_sc_SeqOps__sameElements__sc_IterableOnce__Z($thiz, o)
  }
}
function $is_sci_IndexedSeq(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sci_IndexedSeq)))
}
function $as_sci_IndexedSeq(obj) {
  return (($is_sci_IndexedSeq(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.IndexedSeq"))
}
function $isArrayOf_sci_IndexedSeq(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_IndexedSeq)))
}
function $asArrayOf_sci_IndexedSeq(obj, depth) {
  return (($isArrayOf_sci_IndexedSeq(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.IndexedSeq;", depth))
}
/** @constructor */
function $c_sci_Set$EmptySet$() {
  /*<skip>*/
}
$c_sci_Set$EmptySet$.prototype = new $h_sci_AbstractSet();
$c_sci_Set$EmptySet$.prototype.constructor = $c_sci_Set$EmptySet$;
/** @constructor */
function $h_sci_Set$EmptySet$() {
  /*<skip>*/
}
$h_sci_Set$EmptySet$.prototype = $c_sci_Set$EmptySet$.prototype;
$c_sci_Set$EmptySet$.prototype.size__I = (function() {
  return 0
});
$c_sci_Set$EmptySet$.prototype.isEmpty__Z = (function() {
  return true
});
$c_sci_Set$EmptySet$.prototype.knownSize__I = (function() {
  return 0
});
$c_sci_Set$EmptySet$.prototype.subsetOf__sc_Set__Z = (function(that) {
  return true
});
$c_sci_Set$EmptySet$.prototype.contains__O__Z = (function(elem) {
  return false
});
$c_sci_Set$EmptySet$.prototype.iterator__sc_Iterator = (function() {
  return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty
});
$c_sci_Set$EmptySet$.prototype.foreach__F1__V = (function(f) {
  /*<skip>*/
});
$c_sci_Set$EmptySet$.prototype.excl__O__sci_SetOps = (function(elem) {
  return this
});
$c_sci_Set$EmptySet$.prototype.incl__O__sci_SetOps = (function(elem) {
  return new $c_sci_Set$Set1(elem)
});
var $d_sci_Set$EmptySet$ = new $TypeData().initClass({
  sci_Set$EmptySet$: 0
}, false, "scala.collection.immutable.Set$EmptySet$", {
  sci_Set$EmptySet$: 1,
  sci_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  sci_Set: 1,
  sci_Iterable: 1,
  sci_SetOps: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Set$EmptySet$.prototype.$classData = $d_sci_Set$EmptySet$;
var $n_sci_Set$EmptySet$;
function $m_sci_Set$EmptySet$() {
  if ((!$n_sci_Set$EmptySet$)) {
    $n_sci_Set$EmptySet$ = new $c_sci_Set$EmptySet$()
  };
  return $n_sci_Set$EmptySet$
}
/** @constructor */
function $c_sc_StringView(s) {
  this.sc_StringView__f_s = null;
  this.sc_StringView__f_s = s
}
$c_sc_StringView.prototype = new $h_sc_AbstractIndexedSeqView();
$c_sc_StringView.prototype.constructor = $c_sc_StringView;
/** @constructor */
function $h_sc_StringView() {
  /*<skip>*/
}
$h_sc_StringView.prototype = $c_sc_StringView.prototype;
$c_sc_StringView.prototype.length__I = (function() {
  var this$1 = this.sc_StringView__f_s;
  return $uI(this$1.length)
});
$c_sc_StringView.prototype.toString__T = (function() {
  return (("StringView(" + this.sc_StringView__f_s) + ")")
});
$c_sc_StringView.prototype.productPrefix__T = (function() {
  return "StringView"
});
$c_sc_StringView.prototype.productArity__I = (function() {
  return 1
});
$c_sc_StringView.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.sc_StringView__f_s : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_sc_StringView.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_sc_StringView.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_sc_StringView.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_sc_StringView)) {
    var StringView$1 = $as_sc_StringView(x$1);
    return (this.sc_StringView__f_s === StringView$1.sc_StringView__f_s)
  } else {
    return false
  }
});
$c_sc_StringView.prototype.apply__I__O = (function(i) {
  var this$1 = this.sc_StringView__f_s;
  return $bC((65535 & $uI(this$1.charCodeAt(i))))
});
function $as_sc_StringView(obj) {
  return (((obj instanceof $c_sc_StringView) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.StringView"))
}
function $isArrayOf_sc_StringView(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_StringView)))
}
function $asArrayOf_sc_StringView(obj, depth) {
  return (($isArrayOf_sc_StringView(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.StringView;", depth))
}
var $d_sc_StringView = new $TypeData().initClass({
  sc_StringView: 0
}, false, "scala.collection.StringView", {
  sc_StringView: 1,
  sc_AbstractIndexedSeqView: 1,
  sc_AbstractSeqView: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IndexedSeqView: 1,
  sc_IndexedSeqOps: 1,
  s_Product: 1,
  s_Equals: 1
});
$c_sc_StringView.prototype.$classData = $d_sc_StringView;
/** @constructor */
function $c_sci_Set$Set1(elem1) {
  this.sci_Set$Set1__f_elem1 = null;
  this.sci_Set$Set1__f_elem1 = elem1
}
$c_sci_Set$Set1.prototype = new $h_sci_AbstractSet();
$c_sci_Set$Set1.prototype.constructor = $c_sci_Set$Set1;
/** @constructor */
function $h_sci_Set$Set1() {
  /*<skip>*/
}
$h_sci_Set$Set1.prototype = $c_sci_Set$Set1.prototype;
$c_sci_Set$Set1.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f)
});
$c_sci_Set$Set1.prototype.size__I = (function() {
  return 1
});
$c_sci_Set$Set1.prototype.isEmpty__Z = (function() {
  return false
});
$c_sci_Set$Set1.prototype.knownSize__I = (function() {
  return 1
});
$c_sci_Set$Set1.prototype.contains__O__Z = (function(elem) {
  return $m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set1__f_elem1)
});
$c_sci_Set$Set1.prototype.incl__O__sci_Set = (function(elem) {
  return (this.contains__O__Z(elem) ? this : new $c_sci_Set$Set2(this.sci_Set$Set1__f_elem1, elem))
});
$c_sci_Set$Set1.prototype.excl__O__sci_Set = (function(elem) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set1__f_elem1) ? $m_sci_Set$EmptySet$() : this)
});
$c_sci_Set$Set1.prototype.iterator__sc_Iterator = (function() {
  $m_sc_Iterator$();
  var a = this.sci_Set$Set1__f_elem1;
  return new $c_sc_Iterator$$anon$20(a)
});
$c_sci_Set$Set1.prototype.foreach__F1__V = (function(f) {
  f.apply__O__O(this.sci_Set$Set1__f_elem1)
});
$c_sci_Set$Set1.prototype.forall__F1__Z = (function(p) {
  return $uZ(p.apply__O__O(this.sci_Set$Set1__f_elem1))
});
$c_sci_Set$Set1.prototype.head__O = (function() {
  return this.sci_Set$Set1__f_elem1
});
$c_sci_Set$Set1.prototype.tail__O = (function() {
  return $m_sci_Set$EmptySet$()
});
$c_sci_Set$Set1.prototype.excl__O__sci_SetOps = (function(elem) {
  return this.excl__O__sci_Set(elem)
});
$c_sci_Set$Set1.prototype.incl__O__sci_SetOps = (function(elem) {
  return this.incl__O__sci_Set(elem)
});
var $d_sci_Set$Set1 = new $TypeData().initClass({
  sci_Set$Set1: 0
}, false, "scala.collection.immutable.Set$Set1", {
  sci_Set$Set1: 1,
  sci_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  sci_Set: 1,
  sci_Iterable: 1,
  sci_SetOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Set$Set1.prototype.$classData = $d_sci_Set$Set1;
/** @constructor */
function $c_sci_Set$Set2(elem1, elem2) {
  this.sci_Set$Set2__f_elem1 = null;
  this.sci_Set$Set2__f_elem2 = null;
  this.sci_Set$Set2__f_elem1 = elem1;
  this.sci_Set$Set2__f_elem2 = elem2
}
$c_sci_Set$Set2.prototype = new $h_sci_AbstractSet();
$c_sci_Set$Set2.prototype.constructor = $c_sci_Set$Set2;
/** @constructor */
function $h_sci_Set$Set2() {
  /*<skip>*/
}
$h_sci_Set$Set2.prototype = $c_sci_Set$Set2.prototype;
$c_sci_Set$Set2.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f)
});
$c_sci_Set$Set2.prototype.size__I = (function() {
  return 2
});
$c_sci_Set$Set2.prototype.isEmpty__Z = (function() {
  return false
});
$c_sci_Set$Set2.prototype.knownSize__I = (function() {
  return 2
});
$c_sci_Set$Set2.prototype.contains__O__Z = (function(elem) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set2__f_elem1) || $m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set2__f_elem2))
});
$c_sci_Set$Set2.prototype.incl__O__sci_Set = (function(elem) {
  return (this.contains__O__Z(elem) ? this : new $c_sci_Set$Set3(this.sci_Set$Set2__f_elem1, this.sci_Set$Set2__f_elem2, elem))
});
$c_sci_Set$Set2.prototype.excl__O__sci_Set = (function(elem) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set2__f_elem1) ? new $c_sci_Set$Set1(this.sci_Set$Set2__f_elem2) : ($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set2__f_elem2) ? new $c_sci_Set$Set1(this.sci_Set$Set2__f_elem1) : this))
});
$c_sci_Set$Set2.prototype.iterator__sc_Iterator = (function() {
  return new $c_sci_Set$Set2$$anon$1(this)
});
$c_sci_Set$Set2.prototype.scala$collection$immutable$Set$Set2$$getElem__I__O = (function(i) {
  switch (i) {
    case 0: {
      return this.sci_Set$Set2__f_elem1;
      break
    }
    case 1: {
      return this.sci_Set$Set2__f_elem2;
      break
    }
    default: {
      throw new $c_s_MatchError(i)
    }
  }
});
$c_sci_Set$Set2.prototype.foreach__F1__V = (function(f) {
  f.apply__O__O(this.sci_Set$Set2__f_elem1);
  f.apply__O__O(this.sci_Set$Set2__f_elem2)
});
$c_sci_Set$Set2.prototype.forall__F1__Z = (function(p) {
  return ($uZ(p.apply__O__O(this.sci_Set$Set2__f_elem1)) && $uZ(p.apply__O__O(this.sci_Set$Set2__f_elem2)))
});
$c_sci_Set$Set2.prototype.head__O = (function() {
  return this.sci_Set$Set2__f_elem1
});
$c_sci_Set$Set2.prototype.tail__sci_Set = (function() {
  return new $c_sci_Set$Set1(this.sci_Set$Set2__f_elem2)
});
$c_sci_Set$Set2.prototype.tail__O = (function() {
  return this.tail__sci_Set()
});
$c_sci_Set$Set2.prototype.excl__O__sci_SetOps = (function(elem) {
  return this.excl__O__sci_Set(elem)
});
$c_sci_Set$Set2.prototype.incl__O__sci_SetOps = (function(elem) {
  return this.incl__O__sci_Set(elem)
});
var $d_sci_Set$Set2 = new $TypeData().initClass({
  sci_Set$Set2: 0
}, false, "scala.collection.immutable.Set$Set2", {
  sci_Set$Set2: 1,
  sci_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  sci_Set: 1,
  sci_Iterable: 1,
  sci_SetOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Set$Set2.prototype.$classData = $d_sci_Set$Set2;
/** @constructor */
function $c_sci_Set$Set3(elem1, elem2, elem3) {
  this.sci_Set$Set3__f_elem1 = null;
  this.sci_Set$Set3__f_elem2 = null;
  this.sci_Set$Set3__f_elem3 = null;
  this.sci_Set$Set3__f_elem1 = elem1;
  this.sci_Set$Set3__f_elem2 = elem2;
  this.sci_Set$Set3__f_elem3 = elem3
}
$c_sci_Set$Set3.prototype = new $h_sci_AbstractSet();
$c_sci_Set$Set3.prototype.constructor = $c_sci_Set$Set3;
/** @constructor */
function $h_sci_Set$Set3() {
  /*<skip>*/
}
$h_sci_Set$Set3.prototype = $c_sci_Set$Set3.prototype;
$c_sci_Set$Set3.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f)
});
$c_sci_Set$Set3.prototype.size__I = (function() {
  return 3
});
$c_sci_Set$Set3.prototype.isEmpty__Z = (function() {
  return false
});
$c_sci_Set$Set3.prototype.knownSize__I = (function() {
  return 3
});
$c_sci_Set$Set3.prototype.contains__O__Z = (function(elem) {
  return (($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set3__f_elem1) || $m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set3__f_elem2)) || $m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set3__f_elem3))
});
$c_sci_Set$Set3.prototype.incl__O__sci_Set = (function(elem) {
  return (this.contains__O__Z(elem) ? this : new $c_sci_Set$Set4(this.sci_Set$Set3__f_elem1, this.sci_Set$Set3__f_elem2, this.sci_Set$Set3__f_elem3, elem))
});
$c_sci_Set$Set3.prototype.excl__O__sci_Set = (function(elem) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set3__f_elem1) ? new $c_sci_Set$Set2(this.sci_Set$Set3__f_elem2, this.sci_Set$Set3__f_elem3) : ($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set3__f_elem2) ? new $c_sci_Set$Set2(this.sci_Set$Set3__f_elem1, this.sci_Set$Set3__f_elem3) : ($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set3__f_elem3) ? new $c_sci_Set$Set2(this.sci_Set$Set3__f_elem1, this.sci_Set$Set3__f_elem2) : this)))
});
$c_sci_Set$Set3.prototype.iterator__sc_Iterator = (function() {
  return new $c_sci_Set$Set3$$anon$2(this)
});
$c_sci_Set$Set3.prototype.scala$collection$immutable$Set$Set3$$getElem__I__O = (function(i) {
  switch (i) {
    case 0: {
      return this.sci_Set$Set3__f_elem1;
      break
    }
    case 1: {
      return this.sci_Set$Set3__f_elem2;
      break
    }
    case 2: {
      return this.sci_Set$Set3__f_elem3;
      break
    }
    default: {
      throw new $c_s_MatchError(i)
    }
  }
});
$c_sci_Set$Set3.prototype.foreach__F1__V = (function(f) {
  f.apply__O__O(this.sci_Set$Set3__f_elem1);
  f.apply__O__O(this.sci_Set$Set3__f_elem2);
  f.apply__O__O(this.sci_Set$Set3__f_elem3)
});
$c_sci_Set$Set3.prototype.forall__F1__Z = (function(p) {
  return (($uZ(p.apply__O__O(this.sci_Set$Set3__f_elem1)) && $uZ(p.apply__O__O(this.sci_Set$Set3__f_elem2))) && $uZ(p.apply__O__O(this.sci_Set$Set3__f_elem3)))
});
$c_sci_Set$Set3.prototype.head__O = (function() {
  return this.sci_Set$Set3__f_elem1
});
$c_sci_Set$Set3.prototype.tail__sci_Set = (function() {
  return new $c_sci_Set$Set2(this.sci_Set$Set3__f_elem2, this.sci_Set$Set3__f_elem3)
});
$c_sci_Set$Set3.prototype.tail__O = (function() {
  return this.tail__sci_Set()
});
$c_sci_Set$Set3.prototype.excl__O__sci_SetOps = (function(elem) {
  return this.excl__O__sci_Set(elem)
});
$c_sci_Set$Set3.prototype.incl__O__sci_SetOps = (function(elem) {
  return this.incl__O__sci_Set(elem)
});
var $d_sci_Set$Set3 = new $TypeData().initClass({
  sci_Set$Set3: 0
}, false, "scala.collection.immutable.Set$Set3", {
  sci_Set$Set3: 1,
  sci_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  sci_Set: 1,
  sci_Iterable: 1,
  sci_SetOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Set$Set3.prototype.$classData = $d_sci_Set$Set3;
/** @constructor */
function $c_sci_Set$Set4(elem1, elem2, elem3, elem4) {
  this.sci_Set$Set4__f_elem1 = null;
  this.sci_Set$Set4__f_elem2 = null;
  this.sci_Set$Set4__f_elem3 = null;
  this.sci_Set$Set4__f_elem4 = null;
  this.sci_Set$Set4__f_elem1 = elem1;
  this.sci_Set$Set4__f_elem2 = elem2;
  this.sci_Set$Set4__f_elem3 = elem3;
  this.sci_Set$Set4__f_elem4 = elem4
}
$c_sci_Set$Set4.prototype = new $h_sci_AbstractSet();
$c_sci_Set$Set4.prototype.constructor = $c_sci_Set$Set4;
/** @constructor */
function $h_sci_Set$Set4() {
  /*<skip>*/
}
$h_sci_Set$Set4.prototype = $c_sci_Set$Set4.prototype;
$c_sci_Set$Set4.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f)
});
$c_sci_Set$Set4.prototype.size__I = (function() {
  return 4
});
$c_sci_Set$Set4.prototype.isEmpty__Z = (function() {
  return false
});
$c_sci_Set$Set4.prototype.knownSize__I = (function() {
  return 4
});
$c_sci_Set$Set4.prototype.contains__O__Z = (function(elem) {
  return ((($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set4__f_elem1) || $m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set4__f_elem2)) || $m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set4__f_elem3)) || $m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set4__f_elem4))
});
$c_sci_Set$Set4.prototype.incl__O__sci_Set = (function(elem) {
  if (this.contains__O__Z(elem)) {
    return this
  } else {
    var this$1 = $m_sci_HashSet$();
    var this$2 = this$1.sci_HashSet$__f_EmptySet;
    var elem$1 = this.sci_Set$Set4__f_elem1;
    var this$3 = this$2.incl__O__sci_HashSet(elem$1);
    var elem$2 = this.sci_Set$Set4__f_elem2;
    var this$4 = this$3.incl__O__sci_HashSet(elem$2);
    var elem$3 = this.sci_Set$Set4__f_elem3;
    var this$5 = this$4.incl__O__sci_HashSet(elem$3);
    var elem$4 = this.sci_Set$Set4__f_elem4;
    var this$6 = this$5.incl__O__sci_HashSet(elem$4);
    return this$6.incl__O__sci_HashSet(elem)
  }
});
$c_sci_Set$Set4.prototype.excl__O__sci_Set = (function(elem) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set4__f_elem1) ? new $c_sci_Set$Set3(this.sci_Set$Set4__f_elem2, this.sci_Set$Set4__f_elem3, this.sci_Set$Set4__f_elem4) : ($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set4__f_elem2) ? new $c_sci_Set$Set3(this.sci_Set$Set4__f_elem1, this.sci_Set$Set4__f_elem3, this.sci_Set$Set4__f_elem4) : ($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set4__f_elem3) ? new $c_sci_Set$Set3(this.sci_Set$Set4__f_elem1, this.sci_Set$Set4__f_elem2, this.sci_Set$Set4__f_elem4) : ($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set4__f_elem4) ? new $c_sci_Set$Set3(this.sci_Set$Set4__f_elem1, this.sci_Set$Set4__f_elem2, this.sci_Set$Set4__f_elem3) : this))))
});
$c_sci_Set$Set4.prototype.iterator__sc_Iterator = (function() {
  return new $c_sci_Set$Set4$$anon$3(this)
});
$c_sci_Set$Set4.prototype.scala$collection$immutable$Set$Set4$$getElem__I__O = (function(i) {
  switch (i) {
    case 0: {
      return this.sci_Set$Set4__f_elem1;
      break
    }
    case 1: {
      return this.sci_Set$Set4__f_elem2;
      break
    }
    case 2: {
      return this.sci_Set$Set4__f_elem3;
      break
    }
    case 3: {
      return this.sci_Set$Set4__f_elem4;
      break
    }
    default: {
      throw new $c_s_MatchError(i)
    }
  }
});
$c_sci_Set$Set4.prototype.foreach__F1__V = (function(f) {
  f.apply__O__O(this.sci_Set$Set4__f_elem1);
  f.apply__O__O(this.sci_Set$Set4__f_elem2);
  f.apply__O__O(this.sci_Set$Set4__f_elem3);
  f.apply__O__O(this.sci_Set$Set4__f_elem4)
});
$c_sci_Set$Set4.prototype.forall__F1__Z = (function(p) {
  return ((($uZ(p.apply__O__O(this.sci_Set$Set4__f_elem1)) && $uZ(p.apply__O__O(this.sci_Set$Set4__f_elem2))) && $uZ(p.apply__O__O(this.sci_Set$Set4__f_elem3))) && $uZ(p.apply__O__O(this.sci_Set$Set4__f_elem4)))
});
$c_sci_Set$Set4.prototype.head__O = (function() {
  return this.sci_Set$Set4__f_elem1
});
$c_sci_Set$Set4.prototype.tail__sci_Set = (function() {
  return new $c_sci_Set$Set3(this.sci_Set$Set4__f_elem2, this.sci_Set$Set4__f_elem3, this.sci_Set$Set4__f_elem4)
});
$c_sci_Set$Set4.prototype.buildTo__scm_Builder__scm_Builder = (function(builder) {
  return $as_scm_Builder(builder.addOne__O__scm_Growable(this.sci_Set$Set4__f_elem1).addOne__O__scm_Growable(this.sci_Set$Set4__f_elem2).addOne__O__scm_Growable(this.sci_Set$Set4__f_elem3).addOne__O__scm_Growable(this.sci_Set$Set4__f_elem4))
});
$c_sci_Set$Set4.prototype.tail__O = (function() {
  return this.tail__sci_Set()
});
$c_sci_Set$Set4.prototype.excl__O__sci_SetOps = (function(elem) {
  return this.excl__O__sci_Set(elem)
});
$c_sci_Set$Set4.prototype.incl__O__sci_SetOps = (function(elem) {
  return this.incl__O__sci_Set(elem)
});
function $as_sci_Set$Set4(obj) {
  return (((obj instanceof $c_sci_Set$Set4) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Set$Set4"))
}
function $isArrayOf_sci_Set$Set4(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Set$Set4)))
}
function $asArrayOf_sci_Set$Set4(obj, depth) {
  return (($isArrayOf_sci_Set$Set4(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Set$Set4;", depth))
}
var $d_sci_Set$Set4 = new $TypeData().initClass({
  sci_Set$Set4: 0
}, false, "scala.collection.immutable.Set$Set4", {
  sci_Set$Set4: 1,
  sci_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  sci_Set: 1,
  sci_Iterable: 1,
  sci_SetOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Set$Set4.prototype.$classData = $d_sci_Set$Set4;
function $is_sci_SortedSet(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sci_SortedSet)))
}
function $as_sci_SortedSet(obj) {
  return (($is_sci_SortedSet(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.SortedSet"))
}
function $isArrayOf_sci_SortedSet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_SortedSet)))
}
function $asArrayOf_sci_SortedSet(obj, depth) {
  return (($isArrayOf_sci_SortedSet(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.SortedSet;", depth))
}
/** @constructor */
function $c_scm_AbstractSeq() {
  /*<skip>*/
}
$c_scm_AbstractSeq.prototype = new $h_sc_AbstractSeq();
$c_scm_AbstractSeq.prototype.constructor = $c_scm_AbstractSeq;
/** @constructor */
function $h_scm_AbstractSeq() {
  /*<skip>*/
}
$h_scm_AbstractSeq.prototype = $c_scm_AbstractSeq.prototype;
/** @constructor */
function $c_sci_Map$EmptyMap$() {
  /*<skip>*/
}
$c_sci_Map$EmptyMap$.prototype = new $h_sci_AbstractMap();
$c_sci_Map$EmptyMap$.prototype.constructor = $c_sci_Map$EmptyMap$;
/** @constructor */
function $h_sci_Map$EmptyMap$() {
  /*<skip>*/
}
$h_sci_Map$EmptyMap$.prototype = $c_sci_Map$EmptyMap$.prototype;
$c_sci_Map$EmptyMap$.prototype.size__I = (function() {
  return 0
});
$c_sci_Map$EmptyMap$.prototype.knownSize__I = (function() {
  return 0
});
$c_sci_Map$EmptyMap$.prototype.isEmpty__Z = (function() {
  return true
});
$c_sci_Map$EmptyMap$.prototype.apply__O__E = (function(key) {
  throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + key))
});
$c_sci_Map$EmptyMap$.prototype.contains__O__Z = (function(key) {
  return false
});
$c_sci_Map$EmptyMap$.prototype.get__O__s_Option = (function(key) {
  return $m_s_None$()
});
$c_sci_Map$EmptyMap$.prototype.getOrElse__O__F0__O = (function(key, default$1) {
  return default$1.apply__O()
});
$c_sci_Map$EmptyMap$.prototype.iterator__sc_Iterator = (function() {
  return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty
});
$c_sci_Map$EmptyMap$.prototype.concat__sc_IterableOnce__sci_Map = (function(suffix) {
  if ($is_sci_Map(suffix)) {
    var x2 = $as_sci_Map(suffix);
    return x2
  } else {
    return $as_sci_Map($f_sc_MapOps__concat__sc_IterableOnce__sc_IterableOps(this, suffix))
  }
});
$c_sci_Map$EmptyMap$.prototype.concat__sc_IterableOnce__sc_IterableOps = (function(suffix) {
  return this.concat__sc_IterableOnce__sci_Map(suffix)
});
$c_sci_Map$EmptyMap$.prototype.updated__O__O__sci_MapOps = (function(key, value) {
  return new $c_sci_Map$Map1(key, value)
});
$c_sci_Map$EmptyMap$.prototype.apply__O__O = (function(key) {
  this.apply__O__E(key)
});
var $d_sci_Map$EmptyMap$ = new $TypeData().initClass({
  sci_Map$EmptyMap$: 0
}, false, "scala.collection.immutable.Map$EmptyMap$", {
  sci_Map$EmptyMap$: 1,
  sci_AbstractMap: 1,
  sc_AbstractMap: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Map: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_MapFactoryDefaults: 1,
  s_Equals: 1,
  sci_Map: 1,
  sci_Iterable: 1,
  sci_MapOps: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Map$EmptyMap$.prototype.$classData = $d_sci_Map$EmptyMap$;
var $n_sci_Map$EmptyMap$;
function $m_sci_Map$EmptyMap$() {
  if ((!$n_sci_Map$EmptyMap$)) {
    $n_sci_Map$EmptyMap$ = new $c_sci_Map$EmptyMap$()
  };
  return $n_sci_Map$EmptyMap$
}
/** @constructor */
function $c_sci_Map$Map1(key1, value1) {
  this.sci_Map$Map1__f_key1 = null;
  this.sci_Map$Map1__f_value1 = null;
  this.sci_Map$Map1__f_key1 = key1;
  this.sci_Map$Map1__f_value1 = value1
}
$c_sci_Map$Map1.prototype = new $h_sci_AbstractMap();
$c_sci_Map$Map1.prototype.constructor = $c_sci_Map$Map1;
/** @constructor */
function $h_sci_Map$Map1() {
  /*<skip>*/
}
$h_sci_Map$Map1.prototype = $c_sci_Map$Map1.prototype;
$c_sci_Map$Map1.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f)
});
$c_sci_Map$Map1.prototype.size__I = (function() {
  return 1
});
$c_sci_Map$Map1.prototype.knownSize__I = (function() {
  return 1
});
$c_sci_Map$Map1.prototype.isEmpty__Z = (function() {
  return false
});
$c_sci_Map$Map1.prototype.apply__O__O = (function(key) {
  if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map1__f_key1)) {
    return this.sci_Map$Map1__f_value1
  } else {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + key))
  }
});
$c_sci_Map$Map1.prototype.contains__O__Z = (function(key) {
  return $m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map1__f_key1)
});
$c_sci_Map$Map1.prototype.get__O__s_Option = (function(key) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map1__f_key1) ? new $c_s_Some(this.sci_Map$Map1__f_value1) : $m_s_None$())
});
$c_sci_Map$Map1.prototype.getOrElse__O__F0__O = (function(key, default$1) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map1__f_key1) ? this.sci_Map$Map1__f_value1 : default$1.apply__O())
});
$c_sci_Map$Map1.prototype.iterator__sc_Iterator = (function() {
  $m_sc_Iterator$();
  var a = new $c_T2(this.sci_Map$Map1__f_key1, this.sci_Map$Map1__f_value1);
  return new $c_sc_Iterator$$anon$20(a)
});
$c_sci_Map$Map1.prototype.updated__O__O__sci_Map = (function(key, value) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map1__f_key1) ? new $c_sci_Map$Map1(this.sci_Map$Map1__f_key1, value) : new $c_sci_Map$Map2(this.sci_Map$Map1__f_key1, this.sci_Map$Map1__f_value1, key, value))
});
$c_sci_Map$Map1.prototype.foreach__F1__V = (function(f) {
  f.apply__O__O(new $c_T2(this.sci_Map$Map1__f_key1, this.sci_Map$Map1__f_value1))
});
$c_sci_Map$Map1.prototype.forall__F1__Z = (function(p) {
  return $uZ(p.apply__O__O(new $c_T2(this.sci_Map$Map1__f_key1, this.sci_Map$Map1__f_value1)))
});
$c_sci_Map$Map1.prototype.hashCode__I = (function() {
  var a = 0;
  var b = 0;
  var c = 1;
  var h = $m_s_util_hashing_MurmurHash3$().tuple2Hash__O__O__I(this.sci_Map$Map1__f_key1, this.sci_Map$Map1__f_value1);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = $imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().s_util_hashing_MurmurHash3$__f_mapSeed;
  h = $m_s_util_hashing_MurmurHash3$().mix__I__I__I(h, a);
  h = $m_s_util_hashing_MurmurHash3$().mix__I__I__I(h, b);
  h = $m_s_util_hashing_MurmurHash3$().mixLast__I__I__I(h, c);
  return $m_s_util_hashing_MurmurHash3$().finalizeHash__I__I__I(h, 1)
});
$c_sci_Map$Map1.prototype.updated__O__O__sci_MapOps = (function(key, value) {
  return this.updated__O__O__sci_Map(key, value)
});
var $d_sci_Map$Map1 = new $TypeData().initClass({
  sci_Map$Map1: 0
}, false, "scala.collection.immutable.Map$Map1", {
  sci_Map$Map1: 1,
  sci_AbstractMap: 1,
  sc_AbstractMap: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Map: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_MapFactoryDefaults: 1,
  s_Equals: 1,
  sci_Map: 1,
  sci_Iterable: 1,
  sci_MapOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Map$Map1.prototype.$classData = $d_sci_Map$Map1;
/** @constructor */
function $c_sci_Map$Map2(key1, value1, key2, value2) {
  this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1 = null;
  this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1 = null;
  this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2 = null;
  this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2 = null;
  this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1 = key1;
  this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1 = value1;
  this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2 = key2;
  this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2 = value2
}
$c_sci_Map$Map2.prototype = new $h_sci_AbstractMap();
$c_sci_Map$Map2.prototype.constructor = $c_sci_Map$Map2;
/** @constructor */
function $h_sci_Map$Map2() {
  /*<skip>*/
}
$h_sci_Map$Map2.prototype = $c_sci_Map$Map2.prototype;
$c_sci_Map$Map2.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f)
});
$c_sci_Map$Map2.prototype.size__I = (function() {
  return 2
});
$c_sci_Map$Map2.prototype.knownSize__I = (function() {
  return 2
});
$c_sci_Map$Map2.prototype.isEmpty__Z = (function() {
  return false
});
$c_sci_Map$Map2.prototype.apply__O__O = (function(key) {
  if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1)) {
    return this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1
  } else if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2)) {
    return this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2
  } else {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + key))
  }
});
$c_sci_Map$Map2.prototype.contains__O__Z = (function(key) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1) || $m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2))
});
$c_sci_Map$Map2.prototype.get__O__s_Option = (function(key) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1) ? new $c_s_Some(this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2) ? new $c_s_Some(this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2) : $m_s_None$()))
});
$c_sci_Map$Map2.prototype.getOrElse__O__F0__O = (function(key, default$1) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1) ? this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1 : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2) ? this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2 : default$1.apply__O()))
});
$c_sci_Map$Map2.prototype.iterator__sc_Iterator = (function() {
  return new $c_sci_Map$Map2$$anon$1(this)
});
$c_sci_Map$Map2.prototype.updated__O__O__sci_Map = (function(key, value) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1) ? new $c_sci_Map$Map2(this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1, value, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2) ? new $c_sci_Map$Map2(this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2, value) : new $c_sci_Map$Map3(this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2, key, value)))
});
$c_sci_Map$Map2.prototype.foreach__F1__V = (function(f) {
  f.apply__O__O(new $c_T2(this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1));
  f.apply__O__O(new $c_T2(this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2))
});
$c_sci_Map$Map2.prototype.forall__F1__Z = (function(p) {
  return ($uZ(p.apply__O__O(new $c_T2(this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1))) && $uZ(p.apply__O__O(new $c_T2(this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2))))
});
$c_sci_Map$Map2.prototype.hashCode__I = (function() {
  var a = 0;
  var b = 0;
  var c = 1;
  var h = $m_s_util_hashing_MurmurHash3$().tuple2Hash__O__O__I(this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = $imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().tuple2Hash__O__O__I(this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = $imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().s_util_hashing_MurmurHash3$__f_mapSeed;
  h = $m_s_util_hashing_MurmurHash3$().mix__I__I__I(h, a);
  h = $m_s_util_hashing_MurmurHash3$().mix__I__I__I(h, b);
  h = $m_s_util_hashing_MurmurHash3$().mixLast__I__I__I(h, c);
  return $m_s_util_hashing_MurmurHash3$().finalizeHash__I__I__I(h, 2)
});
$c_sci_Map$Map2.prototype.updated__O__O__sci_MapOps = (function(key, value) {
  return this.updated__O__O__sci_Map(key, value)
});
var $d_sci_Map$Map2 = new $TypeData().initClass({
  sci_Map$Map2: 0
}, false, "scala.collection.immutable.Map$Map2", {
  sci_Map$Map2: 1,
  sci_AbstractMap: 1,
  sc_AbstractMap: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Map: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_MapFactoryDefaults: 1,
  s_Equals: 1,
  sci_Map: 1,
  sci_Iterable: 1,
  sci_MapOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Map$Map2.prototype.$classData = $d_sci_Map$Map2;
/** @constructor */
function $c_sci_Map$Map3(key1, value1, key2, value2, key3, value3) {
  this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1 = null;
  this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1 = null;
  this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2 = null;
  this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2 = null;
  this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3 = null;
  this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3 = null;
  this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1 = key1;
  this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1 = value1;
  this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2 = key2;
  this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2 = value2;
  this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3 = key3;
  this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3 = value3
}
$c_sci_Map$Map3.prototype = new $h_sci_AbstractMap();
$c_sci_Map$Map3.prototype.constructor = $c_sci_Map$Map3;
/** @constructor */
function $h_sci_Map$Map3() {
  /*<skip>*/
}
$h_sci_Map$Map3.prototype = $c_sci_Map$Map3.prototype;
$c_sci_Map$Map3.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f)
});
$c_sci_Map$Map3.prototype.size__I = (function() {
  return 3
});
$c_sci_Map$Map3.prototype.knownSize__I = (function() {
  return 3
});
$c_sci_Map$Map3.prototype.isEmpty__Z = (function() {
  return false
});
$c_sci_Map$Map3.prototype.apply__O__O = (function(key) {
  if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1)) {
    return this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1
  } else if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2)) {
    return this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2
  } else if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3)) {
    return this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3
  } else {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + key))
  }
});
$c_sci_Map$Map3.prototype.contains__O__Z = (function(key) {
  return (($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1) || $m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2)) || $m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3))
});
$c_sci_Map$Map3.prototype.get__O__s_Option = (function(key) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1) ? new $c_s_Some(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2) ? new $c_s_Some(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3) ? new $c_s_Some(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3) : $m_s_None$())))
});
$c_sci_Map$Map3.prototype.getOrElse__O__F0__O = (function(key, default$1) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1) ? this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1 : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2) ? this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2 : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3) ? this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3 : default$1.apply__O())))
});
$c_sci_Map$Map3.prototype.iterator__sc_Iterator = (function() {
  return new $c_sci_Map$Map3$$anon$4(this)
});
$c_sci_Map$Map3.prototype.updated__O__O__sci_Map = (function(key, value) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1) ? new $c_sci_Map$Map3(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1, value, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2) ? new $c_sci_Map$Map3(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2, value, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3) ? new $c_sci_Map$Map3(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3, value) : new $c_sci_Map$Map4(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3, key, value))))
});
$c_sci_Map$Map3.prototype.foreach__F1__V = (function(f) {
  f.apply__O__O(new $c_T2(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1));
  f.apply__O__O(new $c_T2(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2));
  f.apply__O__O(new $c_T2(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3))
});
$c_sci_Map$Map3.prototype.forall__F1__Z = (function(p) {
  return (($uZ(p.apply__O__O(new $c_T2(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1))) && $uZ(p.apply__O__O(new $c_T2(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2)))) && $uZ(p.apply__O__O(new $c_T2(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3))))
});
$c_sci_Map$Map3.prototype.hashCode__I = (function() {
  var a = 0;
  var b = 0;
  var c = 1;
  var h = $m_s_util_hashing_MurmurHash3$().tuple2Hash__O__O__I(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = $imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().tuple2Hash__O__O__I(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = $imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().tuple2Hash__O__O__I(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = $imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().s_util_hashing_MurmurHash3$__f_mapSeed;
  h = $m_s_util_hashing_MurmurHash3$().mix__I__I__I(h, a);
  h = $m_s_util_hashing_MurmurHash3$().mix__I__I__I(h, b);
  h = $m_s_util_hashing_MurmurHash3$().mixLast__I__I__I(h, c);
  return $m_s_util_hashing_MurmurHash3$().finalizeHash__I__I__I(h, 3)
});
$c_sci_Map$Map3.prototype.updated__O__O__sci_MapOps = (function(key, value) {
  return this.updated__O__O__sci_Map(key, value)
});
var $d_sci_Map$Map3 = new $TypeData().initClass({
  sci_Map$Map3: 0
}, false, "scala.collection.immutable.Map$Map3", {
  sci_Map$Map3: 1,
  sci_AbstractMap: 1,
  sc_AbstractMap: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Map: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_MapFactoryDefaults: 1,
  s_Equals: 1,
  sci_Map: 1,
  sci_Iterable: 1,
  sci_MapOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Map$Map3.prototype.$classData = $d_sci_Map$Map3;
/** @constructor */
function $c_sci_Map$Map4(key1, value1, key2, value2, key3, value3, key4, value4) {
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1 = null;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1 = null;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2 = null;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2 = null;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3 = null;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3 = null;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4 = null;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4 = null;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1 = key1;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1 = value1;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2 = key2;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2 = value2;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3 = key3;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3 = value3;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4 = key4;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4 = value4
}
$c_sci_Map$Map4.prototype = new $h_sci_AbstractMap();
$c_sci_Map$Map4.prototype.constructor = $c_sci_Map$Map4;
/** @constructor */
function $h_sci_Map$Map4() {
  /*<skip>*/
}
$h_sci_Map$Map4.prototype = $c_sci_Map$Map4.prototype;
$c_sci_Map$Map4.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f)
});
$c_sci_Map$Map4.prototype.size__I = (function() {
  return 4
});
$c_sci_Map$Map4.prototype.knownSize__I = (function() {
  return 4
});
$c_sci_Map$Map4.prototype.isEmpty__Z = (function() {
  return false
});
$c_sci_Map$Map4.prototype.apply__O__O = (function(key) {
  if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1)) {
    return this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1
  } else if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2)) {
    return this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2
  } else if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3)) {
    return this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3
  } else if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4)) {
    return this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4
  } else {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + key))
  }
});
$c_sci_Map$Map4.prototype.contains__O__Z = (function(key) {
  return ((($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1) || $m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2)) || $m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3)) || $m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4))
});
$c_sci_Map$Map4.prototype.get__O__s_Option = (function(key) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1) ? new $c_s_Some(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2) ? new $c_s_Some(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3) ? new $c_s_Some(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4) ? new $c_s_Some(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4) : $m_s_None$()))))
});
$c_sci_Map$Map4.prototype.getOrElse__O__F0__O = (function(key, default$1) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1) ? this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1 : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2) ? this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2 : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3) ? this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3 : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4) ? this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4 : default$1.apply__O()))))
});
$c_sci_Map$Map4.prototype.iterator__sc_Iterator = (function() {
  return new $c_sci_Map$Map4$$anon$7(this)
});
$c_sci_Map$Map4.prototype.updated__O__O__sci_Map = (function(key, value) {
  if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1)) {
    return new $c_sci_Map$Map4(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, value, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4)
  } else if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2)) {
    return new $c_sci_Map$Map4(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, value, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4)
  } else if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3)) {
    return new $c_sci_Map$Map4(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, value, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4)
  } else if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4)) {
    return new $c_sci_Map$Map4(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, value)
  } else {
    var this$1 = $m_sci_HashMap$();
    return this$1.sci_HashMap$__f_EmptyMap.updated__O__O__sci_HashMap(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1).updated__O__O__sci_HashMap(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2).updated__O__O__sci_HashMap(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3).updated__O__O__sci_HashMap(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4).updated__O__O__sci_HashMap(key, value)
  }
});
$c_sci_Map$Map4.prototype.foreach__F1__V = (function(f) {
  f.apply__O__O(new $c_T2(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1));
  f.apply__O__O(new $c_T2(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2));
  f.apply__O__O(new $c_T2(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3));
  f.apply__O__O(new $c_T2(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4))
});
$c_sci_Map$Map4.prototype.forall__F1__Z = (function(p) {
  return ((($uZ(p.apply__O__O(new $c_T2(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1))) && $uZ(p.apply__O__O(new $c_T2(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2)))) && $uZ(p.apply__O__O(new $c_T2(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3)))) && $uZ(p.apply__O__O(new $c_T2(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4))))
});
$c_sci_Map$Map4.prototype.buildTo__sci_HashMapBuilder__sci_HashMapBuilder = (function(builder) {
  return builder.addOne__O__O__sci_HashMapBuilder(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1).addOne__O__O__sci_HashMapBuilder(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2).addOne__O__O__sci_HashMapBuilder(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3).addOne__O__O__sci_HashMapBuilder(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4)
});
$c_sci_Map$Map4.prototype.hashCode__I = (function() {
  var a = 0;
  var b = 0;
  var c = 1;
  var h = $m_s_util_hashing_MurmurHash3$().tuple2Hash__O__O__I(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = $imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().tuple2Hash__O__O__I(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = $imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().tuple2Hash__O__O__I(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = $imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().tuple2Hash__O__O__I(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = $imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().s_util_hashing_MurmurHash3$__f_mapSeed;
  h = $m_s_util_hashing_MurmurHash3$().mix__I__I__I(h, a);
  h = $m_s_util_hashing_MurmurHash3$().mix__I__I__I(h, b);
  h = $m_s_util_hashing_MurmurHash3$().mixLast__I__I__I(h, c);
  return $m_s_util_hashing_MurmurHash3$().finalizeHash__I__I__I(h, 4)
});
$c_sci_Map$Map4.prototype.updated__O__O__sci_MapOps = (function(key, value) {
  return this.updated__O__O__sci_Map(key, value)
});
function $as_sci_Map$Map4(obj) {
  return (((obj instanceof $c_sci_Map$Map4) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Map$Map4"))
}
function $isArrayOf_sci_Map$Map4(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Map$Map4)))
}
function $asArrayOf_sci_Map$Map4(obj, depth) {
  return (($isArrayOf_sci_Map$Map4(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Map$Map4;", depth))
}
var $d_sci_Map$Map4 = new $TypeData().initClass({
  sci_Map$Map4: 0
}, false, "scala.collection.immutable.Map$Map4", {
  sci_Map$Map4: 1,
  sci_AbstractMap: 1,
  sc_AbstractMap: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Map: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_MapFactoryDefaults: 1,
  s_Equals: 1,
  sci_Map: 1,
  sci_Iterable: 1,
  sci_MapOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Map$Map4.prototype.$classData = $d_sci_Map$Map4;
function $is_scm_Map(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.scm_Map)))
}
function $as_scm_Map(obj) {
  return (($is_scm_Map(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.Map"))
}
function $isArrayOf_scm_Map(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_Map)))
}
function $asArrayOf_scm_Map(obj, depth) {
  return (($isArrayOf_scm_Map(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.Map;", depth))
}
function $p_sci_HashSet__newHashSetOrThis__sci_BitmapIndexedSetNode__sci_HashSet($thiz, newRootNode) {
  return (($thiz.sci_HashSet__f_rootNode === newRootNode) ? $thiz : new $c_sci_HashSet(newRootNode))
}
/** @constructor */
function $c_sci_HashSet(rootNode) {
  this.sci_HashSet__f_rootNode = null;
  this.sci_HashSet__f_rootNode = rootNode
}
$c_sci_HashSet.prototype = new $h_sci_AbstractSet();
$c_sci_HashSet.prototype.constructor = $c_sci_HashSet;
/** @constructor */
function $h_sci_HashSet() {
  /*<skip>*/
}
$h_sci_HashSet.prototype = $c_sci_HashSet.prototype;
$c_sci_HashSet.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f)
});
$c_sci_HashSet.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sci_HashSet$()
});
$c_sci_HashSet.prototype.knownSize__I = (function() {
  return this.sci_HashSet__f_rootNode.sci_BitmapIndexedSetNode__f_size
});
$c_sci_HashSet.prototype.size__I = (function() {
  return this.sci_HashSet__f_rootNode.sci_BitmapIndexedSetNode__f_size
});
$c_sci_HashSet.prototype.isEmpty__Z = (function() {
  return (this.sci_HashSet__f_rootNode.sci_BitmapIndexedSetNode__f_size === 0)
});
$c_sci_HashSet.prototype.iterator__sc_Iterator = (function() {
  return (this.isEmpty__Z() ? $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty : new $c_sci_SetIterator(this.sci_HashSet__f_rootNode))
});
$c_sci_HashSet.prototype.contains__O__Z = (function(element) {
  var elementUnimprovedHash = $m_sr_Statics$().anyHash__O__I(element);
  var elementHash = $m_sc_Hashing$().improve__I__I(elementUnimprovedHash);
  return this.sci_HashSet__f_rootNode.contains__O__I__I__I__Z(element, elementUnimprovedHash, elementHash, 0)
});
$c_sci_HashSet.prototype.incl__O__sci_HashSet = (function(element) {
  var elementUnimprovedHash = $m_sr_Statics$().anyHash__O__I(element);
  var elementHash = $m_sc_Hashing$().improve__I__I(elementUnimprovedHash);
  var newRootNode = this.sci_HashSet__f_rootNode.updated__O__I__I__I__sci_BitmapIndexedSetNode(element, elementUnimprovedHash, elementHash, 0);
  return $p_sci_HashSet__newHashSetOrThis__sci_BitmapIndexedSetNode__sci_HashSet(this, newRootNode)
});
$c_sci_HashSet.prototype.excl__O__sci_HashSet = (function(element) {
  var elementUnimprovedHash = $m_sr_Statics$().anyHash__O__I(element);
  var elementHash = $m_sc_Hashing$().improve__I__I(elementUnimprovedHash);
  var newRootNode = this.sci_HashSet__f_rootNode.removed__O__I__I__I__sci_BitmapIndexedSetNode(element, elementUnimprovedHash, elementHash, 0);
  return $p_sci_HashSet__newHashSetOrThis__sci_BitmapIndexedSetNode__sci_HashSet(this, newRootNode)
});
$c_sci_HashSet.prototype.head__O = (function() {
  return this.iterator__sc_Iterator().next__O()
});
$c_sci_HashSet.prototype.foreach__F1__V = (function(f) {
  this.sci_HashSet__f_rootNode.foreach__F1__V(f)
});
$c_sci_HashSet.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_HashSet)) {
    var x2 = $as_sci_HashSet(that);
    if ((this === x2)) {
      return true
    } else {
      var x = this.sci_HashSet__f_rootNode;
      var x$2 = x2.sci_HashSet__f_rootNode;
      return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
    }
  } else {
    return $f_sc_Set__equals__O__Z(this, that)
  }
});
$c_sci_HashSet.prototype.className__T = (function() {
  return "HashSet"
});
$c_sci_HashSet.prototype.hashCode__I = (function() {
  var it = new $c_sci_SetHashIterator(this.sci_HashSet__f_rootNode);
  var hash = $m_s_util_hashing_MurmurHash3$().unorderedHash__sc_IterableOnce__I__I(it, $m_s_util_hashing_MurmurHash3$().s_util_hashing_MurmurHash3$__f_setSeed);
  return hash
});
$c_sci_HashSet.prototype.drop__I__O = (function(n) {
  return $as_sci_HashSet($f_sc_IterableOps__drop__I__O(this, n))
});
$c_sci_HashSet.prototype.tail__O = (function() {
  var elem = this.iterator__sc_Iterator().next__O();
  return this.excl__O__sci_HashSet(elem)
});
$c_sci_HashSet.prototype.excl__O__sci_SetOps = (function(elem) {
  return this.excl__O__sci_HashSet(elem)
});
$c_sci_HashSet.prototype.incl__O__sci_SetOps = (function(elem) {
  return this.incl__O__sci_HashSet(elem)
});
function $as_sci_HashSet(obj) {
  return (((obj instanceof $c_sci_HashSet) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.HashSet"))
}
function $isArrayOf_sci_HashSet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_HashSet)))
}
function $asArrayOf_sci_HashSet(obj, depth) {
  return (($isArrayOf_sci_HashSet(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.HashSet;", depth))
}
var $d_sci_HashSet = new $TypeData().initClass({
  sci_HashSet: 0
}, false, "scala.collection.immutable.HashSet", {
  sci_HashSet: 1,
  sci_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  sci_Set: 1,
  sci_Iterable: 1,
  sci_SetOps: 1,
  sci_StrictOptimizedSetOps: 1,
  sc_StrictOptimizedSetOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
});
$c_sci_HashSet.prototype.$classData = $d_sci_HashSet;
function $p_sci_LazyList__scala$collection$immutable$LazyList$$state$lzycompute__sci_LazyList$State($thiz) {
  if ((!$thiz.sci_LazyList__f_bitmap$0)) {
    if ($thiz.sci_LazyList__f_midEvaluation) {
      throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O($ct_jl_RuntimeException__T__(new $c_jl_RuntimeException(), "self-referential LazyList or a derivation thereof has no more elements"))
    };
    $thiz.sci_LazyList__f_midEvaluation = true;
    try {
      var res = $as_sci_LazyList$State($thiz.sci_LazyList__f_lazyState.apply__O())
    } finally {
      $thiz.sci_LazyList__f_midEvaluation = false
    };
    $thiz.sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated = true;
    $thiz.sci_LazyList__f_lazyState = null;
    $thiz.sci_LazyList__f_scala$collection$immutable$LazyList$$state = res;
    $thiz.sci_LazyList__f_bitmap$0 = true
  };
  return $thiz.sci_LazyList__f_scala$collection$immutable$LazyList$$state
}
function $p_sci_LazyList__mapImpl__F1__sci_LazyList($thiz, f) {
  $m_sci_LazyList$();
  var state = new $c_sjsr_AnonFunction0((function(this$1, f$1) {
    return (function() {
      if (this$1.isEmpty__Z()) {
        return $m_sci_LazyList$State$Empty$()
      } else {
        $m_sci_LazyList$();
        var hd = f$1.apply__O__O(this$1.scala$collection$immutable$LazyList$$state__sci_LazyList$State().head__O());
        var tl = $p_sci_LazyList__mapImpl__F1__sci_LazyList(this$1.scala$collection$immutable$LazyList$$state__sci_LazyList$State().tail__sci_LazyList(), f$1);
        return new $c_sci_LazyList$State$Cons(hd, tl)
      }
    })
  })($thiz, f));
  return new $c_sci_LazyList(state)
}
function $p_sci_LazyList__zipState__sc_Iterator__sci_LazyList$State($thiz, it) {
  if (($thiz.isEmpty__Z() || (!it.hasNext__Z()))) {
    return $m_sci_LazyList$State$Empty$()
  } else {
    $m_sci_LazyList$();
    var hd = new $c_T2($thiz.scala$collection$immutable$LazyList$$state__sci_LazyList$State().head__O(), it.next__O());
    $m_sci_LazyList$();
    var state = new $c_sjsr_AnonFunction0((function(this$1, it$1) {
      return (function() {
        return $p_sci_LazyList__zipState__sc_Iterator__sci_LazyList$State(this$1.scala$collection$immutable$LazyList$$state__sci_LazyList$State().tail__sci_LazyList(), it$1)
      })
    })($thiz, it));
    var tl = new $c_sci_LazyList(state);
    return new $c_sci_LazyList$State$Cons(hd, tl)
  }
}
function $p_sci_LazyList__addStringNoForce__jl_StringBuilder__T__T__T__jl_StringBuilder($thiz, b, start, sep, end) {
  b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + start);
  if ((!$thiz.sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated)) {
    b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (b.jl_StringBuilder__f_java$lang$StringBuilder$$content + "<not computed>")
  } else if ((!$thiz.isEmpty__Z())) {
    var obj = $thiz.scala$collection$immutable$LazyList$$state__sci_LazyList$State().head__O();
    b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj);
    var elem = null;
    elem = $thiz;
    var elem$1 = $thiz.scala$collection$immutable$LazyList$$state__sci_LazyList$State().tail__sci_LazyList();
    var elem$2 = null;
    elem$2 = elem$1;
    if ((($as_sci_LazyList(elem) !== $as_sci_LazyList(elem$2)) && ((!$as_sci_LazyList(elem$2).sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated) || ($as_sci_LazyList(elem).scala$collection$immutable$LazyList$$state__sci_LazyList$State() !== $as_sci_LazyList(elem$2).scala$collection$immutable$LazyList$$state__sci_LazyList$State())))) {
      elem = $as_sci_LazyList(elem$2);
      if (($as_sci_LazyList(elem$2).sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated && (!$as_sci_LazyList(elem$2).isEmpty__Z()))) {
        var this$3 = $as_sci_LazyList(elem$2);
        elem$2 = this$3.scala$collection$immutable$LazyList$$state__sci_LazyList$State().tail__sci_LazyList();
        while (((($as_sci_LazyList(elem) !== $as_sci_LazyList(elem$2)) && ($as_sci_LazyList(elem$2).sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated && (!$as_sci_LazyList(elem$2).isEmpty__Z()))) && ($as_sci_LazyList(elem).scala$collection$immutable$LazyList$$state__sci_LazyList$State() !== $as_sci_LazyList(elem$2).scala$collection$immutable$LazyList$$state__sci_LazyList$State()))) {
          b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
          var this$4 = $as_sci_LazyList(elem);
          var obj$1 = this$4.scala$collection$immutable$LazyList$$state__sci_LazyList$State().head__O();
          b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj$1);
          var this$5 = $as_sci_LazyList(elem);
          elem = this$5.scala$collection$immutable$LazyList$$state__sci_LazyList$State().tail__sci_LazyList();
          var this$6 = $as_sci_LazyList(elem$2);
          elem$2 = this$6.scala$collection$immutable$LazyList$$state__sci_LazyList$State().tail__sci_LazyList();
          if (($as_sci_LazyList(elem$2).sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated && (!$as_sci_LazyList(elem$2).isEmpty__Z()))) {
            var this$7 = $as_sci_LazyList(elem$2);
            elem$2 = this$7.scala$collection$immutable$LazyList$$state__sci_LazyList$State().tail__sci_LazyList()
          }
        }
      }
    };
    if ((!($as_sci_LazyList(elem$2).sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated && (!$as_sci_LazyList(elem$2).isEmpty__Z())))) {
      while (($as_sci_LazyList(elem) !== $as_sci_LazyList(elem$2))) {
        b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
        var this$8 = $as_sci_LazyList(elem);
        var obj$2 = this$8.scala$collection$immutable$LazyList$$state__sci_LazyList$State().head__O();
        b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj$2);
        var this$9 = $as_sci_LazyList(elem);
        elem = this$9.scala$collection$immutable$LazyList$$state__sci_LazyList$State().tail__sci_LazyList()
      };
      if ((!$as_sci_LazyList(elem).sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated)) {
        b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
        b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (b.jl_StringBuilder__f_java$lang$StringBuilder$$content + "<not computed>")
      }
    } else {
      var runner = $thiz;
      var k = 0;
      while (true) {
        var a = runner;
        var b$1 = $as_sci_LazyList(elem$2);
        if ((!((a === b$1) || (a.scala$collection$immutable$LazyList$$state__sci_LazyList$State() === b$1.scala$collection$immutable$LazyList$$state__sci_LazyList$State())))) {
          var this$10 = runner;
          runner = this$10.scala$collection$immutable$LazyList$$state__sci_LazyList$State().tail__sci_LazyList();
          var this$11 = $as_sci_LazyList(elem$2);
          elem$2 = this$11.scala$collection$immutable$LazyList$$state__sci_LazyList$State().tail__sci_LazyList();
          k = ((1 + k) | 0)
        } else {
          break
        }
      };
      var a$1 = $as_sci_LazyList(elem);
      var b$2 = $as_sci_LazyList(elem$2);
      if ((((a$1 === b$2) || (a$1.scala$collection$immutable$LazyList$$state__sci_LazyList$State() === b$2.scala$collection$immutable$LazyList$$state__sci_LazyList$State())) && (k > 0))) {
        b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
        var this$12 = $as_sci_LazyList(elem);
        var obj$3 = this$12.scala$collection$immutable$LazyList$$state__sci_LazyList$State().head__O();
        b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj$3);
        var this$13 = $as_sci_LazyList(elem);
        elem = this$13.scala$collection$immutable$LazyList$$state__sci_LazyList$State().tail__sci_LazyList()
      };
      while (true) {
        var a$2 = $as_sci_LazyList(elem);
        var b$3 = $as_sci_LazyList(elem$2);
        if ((!((a$2 === b$3) || (a$2.scala$collection$immutable$LazyList$$state__sci_LazyList$State() === b$3.scala$collection$immutable$LazyList$$state__sci_LazyList$State())))) {
          b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
          var this$14 = $as_sci_LazyList(elem);
          var obj$4 = this$14.scala$collection$immutable$LazyList$$state__sci_LazyList$State().head__O();
          b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj$4);
          var this$15 = $as_sci_LazyList(elem);
          elem = this$15.scala$collection$immutable$LazyList$$state__sci_LazyList$State().tail__sci_LazyList()
        } else {
          break
        }
      };
      b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
      b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (b.jl_StringBuilder__f_java$lang$StringBuilder$$content + "<cycle>")
    }
  };
  b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + end);
  return b
}
/** @constructor */
function $c_sci_LazyList(lazyState) {
  this.sci_LazyList__f_scala$collection$immutable$LazyList$$state = null;
  this.sci_LazyList__f_lazyState = null;
  this.sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated = false;
  this.sci_LazyList__f_midEvaluation = false;
  this.sci_LazyList__f_bitmap$0 = false;
  this.sci_LazyList__f_lazyState = lazyState;
  this.sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated = false;
  this.sci_LazyList__f_midEvaluation = false
}
$c_sci_LazyList.prototype = new $h_sci_AbstractSeq();
$c_sci_LazyList.prototype.constructor = $c_sci_LazyList;
/** @constructor */
function $h_sci_LazyList() {
  /*<skip>*/
}
$h_sci_LazyList.prototype = $c_sci_LazyList.prototype;
$c_sci_LazyList.prototype.stringPrefix__T = (function() {
  return "LinearSeq"
});
$c_sci_LazyList.prototype.length__I = (function() {
  return $f_sc_LinearSeqOps__length__I(this)
});
$c_sci_LazyList.prototype.lengthCompare__I__I = (function(len) {
  return $f_sc_LinearSeqOps__lengthCompare__I__I(this, len)
});
$c_sci_LazyList.prototype.isDefinedAt__I__Z = (function(x) {
  return $f_sc_LinearSeqOps__isDefinedAt__I__Z(this, x)
});
$c_sci_LazyList.prototype.apply__I__O = (function(n) {
  return $f_sc_LinearSeqOps__apply__I__O(this, n)
});
$c_sci_LazyList.prototype.forall__F1__Z = (function(p) {
  return $f_sc_LinearSeqOps__forall__F1__Z(this, p)
});
$c_sci_LazyList.prototype.exists__F1__Z = (function(p) {
  return $f_sc_LinearSeqOps__exists__F1__Z(this, p)
});
$c_sci_LazyList.prototype.sameElements__sc_IterableOnce__Z = (function(that) {
  return $f_sc_LinearSeqOps__sameElements__sc_IterableOnce__Z(this, that)
});
$c_sci_LazyList.prototype.indexWhere__F1__I__I = (function(p, from) {
  return $f_sc_LinearSeqOps__indexWhere__F1__I__I(this, p, from)
});
$c_sci_LazyList.prototype.scala$collection$immutable$LazyList$$state__sci_LazyList$State = (function() {
  return ((!this.sci_LazyList__f_bitmap$0) ? $p_sci_LazyList__scala$collection$immutable$LazyList$$state$lzycompute__sci_LazyList$State(this) : this.sci_LazyList__f_scala$collection$immutable$LazyList$$state)
});
$c_sci_LazyList.prototype.isEmpty__Z = (function() {
  return (this.scala$collection$immutable$LazyList$$state__sci_LazyList$State() === $m_sci_LazyList$State$Empty$())
});
$c_sci_LazyList.prototype.knownSize__I = (function() {
  return ((this.sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated && this.isEmpty__Z()) ? 0 : (-1))
});
$c_sci_LazyList.prototype.head__O = (function() {
  return this.scala$collection$immutable$LazyList$$state__sci_LazyList$State().head__O()
});
$c_sci_LazyList.prototype.force__sci_LazyList = (function() {
  var these = this;
  var those = this;
  if ((!these.isEmpty__Z())) {
    var this$1 = these;
    these = this$1.scala$collection$immutable$LazyList$$state__sci_LazyList$State().tail__sci_LazyList()
  };
  while ((those !== these)) {
    if (these.isEmpty__Z()) {
      return this
    };
    var this$2 = these;
    these = this$2.scala$collection$immutable$LazyList$$state__sci_LazyList$State().tail__sci_LazyList();
    if (these.isEmpty__Z()) {
      return this
    };
    var this$3 = these;
    these = this$3.scala$collection$immutable$LazyList$$state__sci_LazyList$State().tail__sci_LazyList();
    if ((these === those)) {
      return this
    };
    var this$4 = those;
    those = this$4.scala$collection$immutable$LazyList$$state__sci_LazyList$State().tail__sci_LazyList()
  };
  return this
});
$c_sci_LazyList.prototype.iterator__sc_Iterator = (function() {
  return ((this.sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated && this.isEmpty__Z()) ? $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty : new $c_sci_LazyList$LazyIterator(this))
});
$c_sci_LazyList.prototype.foreach__F1__V = (function(f) {
  var _$this = this;
  while ((!_$this.isEmpty__Z())) {
    var this$1 = _$this;
    f.apply__O__O(this$1.scala$collection$immutable$LazyList$$state__sci_LazyList$State().head__O());
    var this$2 = _$this;
    _$this = this$2.scala$collection$immutable$LazyList$$state__sci_LazyList$State().tail__sci_LazyList()
  }
});
$c_sci_LazyList.prototype.foldLeft__O__F2__O = (function(z, op) {
  var _$this = this;
  while (true) {
    if (_$this.isEmpty__Z()) {
      return z
    } else {
      var this$1 = _$this;
      var temp$_$this = this$1.scala$collection$immutable$LazyList$$state__sci_LazyList$State().tail__sci_LazyList();
      var $$x1 = z;
      var this$2 = _$this;
      var temp$z = op.apply__O__O__O($$x1, this$2.scala$collection$immutable$LazyList$$state__sci_LazyList$State().head__O());
      _$this = temp$_$this;
      z = temp$z
    }
  }
});
$c_sci_LazyList.prototype.className__T = (function() {
  return "LazyList"
});
$c_sci_LazyList.prototype.lazyAppendedAll__F0__sci_LazyList = (function(suffix) {
  $m_sci_LazyList$();
  var state = new $c_sjsr_AnonFunction0((function(this$1, suffix$1) {
    return (function() {
      if (this$1.isEmpty__Z()) {
        var x1 = $as_sc_IterableOnce(suffix$1.apply__O());
        if ((x1 instanceof $c_sci_LazyList)) {
          var x2 = $as_sci_LazyList(x1);
          return x2.scala$collection$immutable$LazyList$$state__sci_LazyList$State()
        } else {
          return ((x1.knownSize__I() === 0) ? $m_sci_LazyList$State$Empty$() : $m_sci_LazyList$().scala$collection$immutable$LazyList$$stateFromIterator__sc_Iterator__sci_LazyList$State(x1.iterator__sc_Iterator()))
        }
      } else {
        $m_sci_LazyList$();
        var hd = this$1.scala$collection$immutable$LazyList$$state__sci_LazyList$State().head__O();
        var tl = this$1.scala$collection$immutable$LazyList$$state__sci_LazyList$State().tail__sci_LazyList().lazyAppendedAll__F0__sci_LazyList(suffix$1);
        return new $c_sci_LazyList$State$Cons(hd, tl)
      }
    })
  })(this, suffix));
  return new $c_sci_LazyList(state)
});
$c_sci_LazyList.prototype.appendedAll__sc_IterableOnce__sci_LazyList = (function(suffix) {
  return ((this.sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated && this.isEmpty__Z()) ? $m_sci_LazyList$().from__sc_IterableOnce__sci_LazyList(suffix) : this.lazyAppendedAll__F0__sci_LazyList(new $c_sjsr_AnonFunction0((function(this$1, suffix$1) {
    return (function() {
      return suffix$1
    })
  })(this, suffix))))
});
$c_sci_LazyList.prototype.map__F1__sci_LazyList = (function(f) {
  return ((this.sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated && this.isEmpty__Z()) ? $m_sci_LazyList$().sci_LazyList$__f__empty : $p_sci_LazyList__mapImpl__F1__sci_LazyList(this, f))
});
$c_sci_LazyList.prototype.flatMap__F1__sci_LazyList = (function(f) {
  return ((this.sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated && this.isEmpty__Z()) ? $m_sci_LazyList$().sci_LazyList$__f__empty : $m_sci_LazyList$().scala$collection$immutable$LazyList$$flatMapImpl__sci_LazyList__F1__sci_LazyList(this, f))
});
$c_sci_LazyList.prototype.zip__sc_IterableOnce__sci_LazyList = (function(that) {
  if (((this.sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated && this.isEmpty__Z()) || (that.knownSize__I() === 0))) {
    return $m_sci_LazyList$().sci_LazyList$__f__empty
  } else {
    $m_sci_LazyList$();
    var state = new $c_sjsr_AnonFunction0((function(this$1, that$1) {
      return (function() {
        return $p_sci_LazyList__zipState__sc_Iterator__sci_LazyList$State(this$1, that$1.iterator__sc_Iterator())
      })
    })(this, that));
    return new $c_sci_LazyList(state)
  }
});
$c_sci_LazyList.prototype.zipWithIndex__sci_LazyList = (function() {
  var this$1 = $m_sci_LazyList$();
  return this.zip__sc_IterableOnce__sci_LazyList(this$1.from__I__I__sci_LazyList(0, 1))
});
$c_sci_LazyList.prototype.drop__I__sci_LazyList = (function(n) {
  return ((n <= 0) ? this : ((this.sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated && this.isEmpty__Z()) ? $m_sci_LazyList$().sci_LazyList$__f__empty : $m_sci_LazyList$().scala$collection$immutable$LazyList$$dropImpl__sci_LazyList__I__sci_LazyList(this, n)))
});
$c_sci_LazyList.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(sb, start, sep, end) {
  this.force__sci_LazyList();
  $p_sci_LazyList__addStringNoForce__jl_StringBuilder__T__T__T__jl_StringBuilder(this, sb.scm_StringBuilder__f_underlying, start, sep, end);
  return sb
});
$c_sci_LazyList.prototype.toString__T = (function() {
  return $p_sci_LazyList__addStringNoForce__jl_StringBuilder__T__T__T__jl_StringBuilder(this, $ct_jl_StringBuilder__T__(new $c_jl_StringBuilder(), "LazyList"), "(", ", ", ")").jl_StringBuilder__f_java$lang$StringBuilder$$content
});
$c_sci_LazyList.prototype.apply__O__O = (function(v1) {
  var n = $uI(v1);
  return $f_sc_LinearSeqOps__apply__I__O(this, n)
});
$c_sci_LazyList.prototype.isDefinedAt__O__Z = (function(x) {
  var x$1 = $uI(x);
  return $f_sc_LinearSeqOps__isDefinedAt__I__Z(this, x$1)
});
$c_sci_LazyList.prototype.drop__I__O = (function(n) {
  return this.drop__I__sci_LazyList(n)
});
$c_sci_LazyList.prototype.zipWithIndex__O = (function() {
  return this.zipWithIndex__sci_LazyList()
});
$c_sci_LazyList.prototype.flatMap__F1__O = (function(f) {
  return this.flatMap__F1__sci_LazyList(f)
});
$c_sci_LazyList.prototype.map__F1__O = (function(f) {
  return this.map__F1__sci_LazyList(f)
});
$c_sci_LazyList.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return this.appendedAll__sc_IterableOnce__sci_LazyList(suffix)
});
$c_sci_LazyList.prototype.tail__O = (function() {
  return this.scala$collection$immutable$LazyList$$state__sci_LazyList$State().tail__sci_LazyList()
});
$c_sci_LazyList.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sci_LazyList$()
});
function $as_sci_LazyList(obj) {
  return (((obj instanceof $c_sci_LazyList) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.LazyList"))
}
function $isArrayOf_sci_LazyList(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_LazyList)))
}
function $asArrayOf_sci_LazyList(obj, depth) {
  return (($isArrayOf_sci_LazyList(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.LazyList;", depth))
}
var $d_sci_LazyList = new $TypeData().initClass({
  sci_LazyList: 0
}, false, "scala.collection.immutable.LazyList", {
  sci_LazyList: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_LinearSeq: 1,
  sc_LinearSeq: 1,
  sc_LinearSeqOps: 1,
  sci_LinearSeqOps: 1,
  Ljava_io_Serializable: 1
});
$c_sci_LazyList.prototype.$classData = $d_sci_LazyList;
function $p_sci_Stream__addStringNoForce__jl_StringBuilder__T__T__T__jl_StringBuilder($thiz, b, start, sep, end) {
  b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + start);
  if ((!$thiz.isEmpty__Z())) {
    var obj = $thiz.head__O();
    b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj);
    var elem = null;
    elem = $thiz;
    if ($thiz.tailDefined__Z()) {
      var scout = $as_sci_Stream($thiz.tail__O());
      if (($as_sci_Stream(elem) !== scout)) {
        elem = scout;
        if (scout.tailDefined__Z()) {
          scout = $as_sci_Stream(scout.tail__O());
          while ((($as_sci_Stream(elem) !== scout) && scout.tailDefined__Z())) {
            b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
            var obj$1 = $as_sci_Stream(elem).head__O();
            b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj$1);
            elem = $as_sci_Stream($as_sci_Stream(elem).tail__O());
            scout = $as_sci_Stream(scout.tail__O());
            if (scout.tailDefined__Z()) {
              scout = $as_sci_Stream(scout.tail__O())
            }
          }
        }
      };
      if ((!scout.tailDefined__Z())) {
        while (($as_sci_Stream(elem) !== scout)) {
          b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
          var obj$2 = $as_sci_Stream(elem).head__O();
          b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj$2);
          elem = $as_sci_Stream($as_sci_Stream(elem).tail__O())
        };
        var this$2 = $as_sci_Stream(elem);
        if ((!this$2.isEmpty__Z())) {
          b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
          var obj$3 = $as_sci_Stream(elem).head__O();
          b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj$3)
        }
      } else {
        var runner = $thiz;
        var k = 0;
        while ((runner !== scout)) {
          runner = $as_sci_Stream(runner.tail__O());
          scout = $as_sci_Stream(scout.tail__O());
          k = ((1 + k) | 0)
        };
        if ((($as_sci_Stream(elem) === scout) && (k > 0))) {
          b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
          var obj$4 = $as_sci_Stream(elem).head__O();
          b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj$4);
          elem = $as_sci_Stream($as_sci_Stream(elem).tail__O())
        };
        while (($as_sci_Stream(elem) !== scout)) {
          b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
          var obj$5 = $as_sci_Stream(elem).head__O();
          b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj$5);
          elem = $as_sci_Stream($as_sci_Stream(elem).tail__O())
        }
      }
    };
    var this$3 = $as_sci_Stream(elem);
    if ((!this$3.isEmpty__Z())) {
      if ((!$as_sci_Stream(elem).tailDefined__Z())) {
        b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
        b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (b.jl_StringBuilder__f_java$lang$StringBuilder$$content + "<not computed>")
      } else {
        b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
        b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (b.jl_StringBuilder__f_java$lang$StringBuilder$$content + "<cycle>")
      }
    }
  };
  b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + end);
  return b
}
/** @constructor */
function $c_sci_Stream() {
  /*<skip>*/
}
$c_sci_Stream.prototype = new $h_sci_AbstractSeq();
$c_sci_Stream.prototype.constructor = $c_sci_Stream;
/** @constructor */
function $h_sci_Stream() {
  /*<skip>*/
}
$h_sci_Stream.prototype = $c_sci_Stream.prototype;
$c_sci_Stream.prototype.stringPrefix__T = (function() {
  return "LinearSeq"
});
$c_sci_Stream.prototype.iterator__sc_Iterator = (function() {
  return $f_sc_LinearSeqOps__iterator__sc_Iterator(this)
});
$c_sci_Stream.prototype.length__I = (function() {
  return $f_sc_LinearSeqOps__length__I(this)
});
$c_sci_Stream.prototype.lengthCompare__I__I = (function(len) {
  return $f_sc_LinearSeqOps__lengthCompare__I__I(this, len)
});
$c_sci_Stream.prototype.isDefinedAt__I__Z = (function(x) {
  return $f_sc_LinearSeqOps__isDefinedAt__I__Z(this, x)
});
$c_sci_Stream.prototype.apply__I__O = (function(n) {
  return $f_sc_LinearSeqOps__apply__I__O(this, n)
});
$c_sci_Stream.prototype.forall__F1__Z = (function(p) {
  return $f_sc_LinearSeqOps__forall__F1__Z(this, p)
});
$c_sci_Stream.prototype.exists__F1__Z = (function(p) {
  return $f_sc_LinearSeqOps__exists__F1__Z(this, p)
});
$c_sci_Stream.prototype.sameElements__sc_IterableOnce__Z = (function(that) {
  return $f_sc_LinearSeqOps__sameElements__sc_IterableOnce__Z(this, that)
});
$c_sci_Stream.prototype.indexWhere__F1__I__I = (function(p, from) {
  return $f_sc_LinearSeqOps__indexWhere__F1__I__I(this, p, from)
});
$c_sci_Stream.prototype.className__T = (function() {
  return "Stream"
});
$c_sci_Stream.prototype.foreach__F1__V = (function(f) {
  var _$this = this;
  while ((!_$this.isEmpty__Z())) {
    f.apply__O__O(_$this.head__O());
    _$this = $as_sci_Stream(_$this.tail__O())
  }
});
$c_sci_Stream.prototype.foldLeft__O__F2__O = (function(z, op) {
  var _$this = this;
  while (true) {
    if (_$this.isEmpty__Z()) {
      return z
    } else {
      var temp$_$this = $as_sci_Stream(_$this.tail__O());
      var temp$z = op.apply__O__O__O(z, _$this.head__O());
      _$this = temp$_$this;
      z = temp$z
    }
  }
});
$c_sci_Stream.prototype.lazyAppendedAll__F0__sci_Stream = (function(suffix) {
  if (this.isEmpty__Z()) {
    var this$1 = $m_sci_Stream$();
    var source = $as_sc_IterableOnce(suffix.apply__O());
    return this$1.from__sc_IterableOnce__sci_Stream(source)
  } else {
    var hd = this.head__O();
    var tl = new $c_sjsr_AnonFunction0((function(this$2, suffix$1) {
      return (function() {
        return $as_sci_Stream(this$2.tail__O()).lazyAppendedAll__F0__sci_Stream(suffix$1)
      })
    })(this, suffix));
    return new $c_sci_Stream$Cons(hd, tl)
  }
});
$c_sci_Stream.prototype.map__F1__sci_Stream = (function(f) {
  if (this.isEmpty__Z()) {
    return $m_sci_Stream$Empty$()
  } else {
    var hd = f.apply__O__O(this.head__O());
    var tl = new $c_sjsr_AnonFunction0((function(this$2, f$1) {
      return (function() {
        return $as_sci_Stream(this$2.tail__O()).map__F1__sci_Stream(f$1)
      })
    })(this, f));
    return new $c_sci_Stream$Cons(hd, tl)
  }
});
$c_sci_Stream.prototype.flatMap__F1__sci_Stream = (function(f) {
  if (this.isEmpty__Z()) {
    return $m_sci_Stream$Empty$()
  } else {
    var nonEmptyPrefix = new $c_sr_ObjectRef(this);
    var this$3 = $m_sci_Stream$();
    var source = $as_sc_IterableOnce(f.apply__O__O($as_sci_Stream(nonEmptyPrefix.sr_ObjectRef__f_elem).head__O()));
    var prefix = this$3.from__sc_IterableOnce__sci_Stream(source);
    while (((!$as_sci_Stream(nonEmptyPrefix.sr_ObjectRef__f_elem).isEmpty__Z()) && prefix.isEmpty__Z())) {
      nonEmptyPrefix.sr_ObjectRef__f_elem = $as_sci_Stream($as_sci_Stream(nonEmptyPrefix.sr_ObjectRef__f_elem).tail__O());
      if ((!$as_sci_Stream(nonEmptyPrefix.sr_ObjectRef__f_elem).isEmpty__Z())) {
        var this$4 = $m_sci_Stream$();
        var source$1 = $as_sc_IterableOnce(f.apply__O__O($as_sci_Stream(nonEmptyPrefix.sr_ObjectRef__f_elem).head__O()));
        prefix = this$4.from__sc_IterableOnce__sci_Stream(source$1)
      }
    };
    return ($as_sci_Stream(nonEmptyPrefix.sr_ObjectRef__f_elem).isEmpty__Z() ? $m_sci_Stream$Empty$() : prefix.lazyAppendedAll__F0__sci_Stream(new $c_sjsr_AnonFunction0((function(this$6, nonEmptyPrefix$1, f$1) {
      return (function() {
        return $as_sci_Stream($as_sci_Stream(nonEmptyPrefix$1.sr_ObjectRef__f_elem).tail__O()).flatMap__F1__sci_Stream(f$1)
      })
    })(this, nonEmptyPrefix, f))))
  }
});
$c_sci_Stream.prototype.zip__sc_IterableOnce__sci_Stream = (function(that) {
  if ((this.isEmpty__Z() || $m_sc_IterableOnceExtensionMethods$().isEmpty$extension__sc_IterableOnce__Z(that))) {
    return $m_sci_Stream$Empty$()
  } else {
    if ($is_sc_Iterable(that)) {
      var x2 = $as_sc_Iterable(that);
      var thatIterable = x2
    } else {
      var thatIterable = $m_sci_LazyList$().from__sc_IterableOnce__sci_LazyList(that)
    };
    var hd = new $c_T2(this.head__O(), thatIterable.head__O());
    var tl = new $c_sjsr_AnonFunction0((function(this$3, thatIterable$1) {
      return (function() {
        return $as_sci_Stream(this$3.tail__O()).zip__sc_IterableOnce__sci_Stream($as_sc_IterableOnce(thatIterable$1.tail__O()))
      })
    })(this, thatIterable));
    return new $c_sci_Stream$Cons(hd, tl)
  }
});
$c_sci_Stream.prototype.zipWithIndex__sci_Stream = (function() {
  var this$1 = $m_sci_LazyList$();
  return this.zip__sc_IterableOnce__sci_Stream(this$1.from__I__I__sci_LazyList(0, 1))
});
$c_sci_Stream.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(sb, start, sep, end) {
  this.force__sci_Stream();
  $p_sci_Stream__addStringNoForce__jl_StringBuilder__T__T__T__jl_StringBuilder(this, sb.scm_StringBuilder__f_underlying, start, sep, end);
  return sb
});
$c_sci_Stream.prototype.toString__T = (function() {
  return $p_sci_Stream__addStringNoForce__jl_StringBuilder__T__T__T__jl_StringBuilder(this, $ct_jl_StringBuilder__T__(new $c_jl_StringBuilder(), "Stream"), "(", ", ", ")").jl_StringBuilder__f_java$lang$StringBuilder$$content
});
$c_sci_Stream.prototype.apply__O__O = (function(v1) {
  var n = $uI(v1);
  return $f_sc_LinearSeqOps__apply__I__O(this, n)
});
$c_sci_Stream.prototype.isDefinedAt__O__Z = (function(x) {
  var x$1 = $uI(x);
  return $f_sc_LinearSeqOps__isDefinedAt__I__Z(this, x$1)
});
$c_sci_Stream.prototype.zipWithIndex__O = (function() {
  return this.zipWithIndex__sci_Stream()
});
$c_sci_Stream.prototype.flatMap__F1__O = (function(f) {
  return this.flatMap__F1__sci_Stream(f)
});
$c_sci_Stream.prototype.map__F1__O = (function(f) {
  return this.map__F1__sci_Stream(f)
});
$c_sci_Stream.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sci_Stream$()
});
function $as_sci_Stream(obj) {
  return (((obj instanceof $c_sci_Stream) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Stream"))
}
function $isArrayOf_sci_Stream(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Stream)))
}
function $asArrayOf_sci_Stream(obj, depth) {
  return (($isArrayOf_sci_Stream(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Stream;", depth))
}
/** @constructor */
function $c_sci_WrappedString(self) {
  this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self = null;
  this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self = self
}
$c_sci_WrappedString.prototype = new $h_sci_AbstractSeq();
$c_sci_WrappedString.prototype.constructor = $c_sci_WrappedString;
/** @constructor */
function $h_sci_WrappedString() {
  /*<skip>*/
}
$h_sci_WrappedString.prototype = $c_sci_WrappedString.prototype;
$c_sci_WrappedString.prototype.canEqual__O__Z = (function(that) {
  return $f_sci_IndexedSeq__canEqual__O__Z(this, that)
});
$c_sci_WrappedString.prototype.stringPrefix__T = (function() {
  return "IndexedSeq"
});
$c_sci_WrappedString.prototype.iterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_StringView(this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self);
  return new $c_sc_IndexedSeqView$IndexedSeqViewIterator(this$1)
});
$c_sci_WrappedString.prototype.drop__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__drop__I__O(this, n)
});
$c_sci_WrappedString.prototype.map__F1__O = (function(f) {
  return $f_sc_IndexedSeqOps__map__F1__O(this, f)
});
$c_sci_WrappedString.prototype.head__O = (function() {
  var this$1 = this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self;
  return $bC((65535 & $uI(this$1.charCodeAt(0))))
});
$c_sci_WrappedString.prototype.lengthCompare__I__I = (function(len) {
  var this$1 = this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self;
  var x = $uI(this$1.length);
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1))
});
$c_sci_WrappedString.prototype.knownSize__I = (function() {
  var this$1 = this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self;
  return $uI(this$1.length)
});
$c_sci_WrappedString.prototype.newSpecificBuilder__scm_Builder = (function() {
  return $m_sci_WrappedString$().newBuilder__scm_Builder()
});
$c_sci_WrappedString.prototype.length__I = (function() {
  var this$1 = this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self;
  return $uI(this$1.length)
});
$c_sci_WrappedString.prototype.toString__T = (function() {
  return this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self
});
$c_sci_WrappedString.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  if ((xs instanceof $ac_C)) {
    var x2 = $asArrayOf_C(xs, 1);
    var this$1 = this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self;
    var srcLen = $uI(this$1.length);
    var destLen = x2.u.length;
    var x = ((len < srcLen) ? len : srcLen);
    var y = ((destLen - start) | 0);
    var x$1 = ((x < y) ? x : y);
    var copied = ((x$1 > 0) ? x$1 : 0);
    $f_T__getChars__I__I__AC__I__V(this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self, 0, copied, x2, start);
    return copied
  } else {
    return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len)
  }
});
$c_sci_WrappedString.prototype.appendedAll__sc_IterableOnce__sci_IndexedSeq = (function(suffix) {
  if ((suffix instanceof $c_sci_WrappedString)) {
    var x2 = $as_sci_WrappedString(suffix);
    var this$1 = this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self;
    var s = x2.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self;
    return new $c_sci_WrappedString((("" + this$1) + s))
  } else {
    return $as_sci_IndexedSeq($f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix))
  }
});
$c_sci_WrappedString.prototype.sameElements__sc_IterableOnce__Z = (function(o) {
  if ((o instanceof $c_sci_WrappedString)) {
    var x2 = $as_sci_WrappedString(o);
    return (this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self === x2.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self)
  } else {
    return $f_sci_IndexedSeq__sameElements__sc_IterableOnce__Z(this, o)
  }
});
$c_sci_WrappedString.prototype.className__T = (function() {
  return "WrappedString"
});
$c_sci_WrappedString.prototype.applyPreferredMaxLength__I = (function() {
  return 2147483647
});
$c_sci_WrappedString.prototype.equals__O__Z = (function(other) {
  if ((other instanceof $c_sci_WrappedString)) {
    var x2 = $as_sci_WrappedString(other);
    return (this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self === x2.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self)
  } else {
    return $f_sc_Seq__equals__O__Z(this, other)
  }
});
$c_sci_WrappedString.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sci_IndexedSeq$()
});
$c_sci_WrappedString.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return this.appendedAll__sc_IterableOnce__sci_IndexedSeq(suffix)
});
$c_sci_WrappedString.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  return $m_sci_WrappedString$().fromSpecific__sc_IterableOnce__sci_WrappedString(coll)
});
$c_sci_WrappedString.prototype.fromSpecific__sc_IterableOnce__sc_IterableOps = (function(coll) {
  return $m_sci_WrappedString$().fromSpecific__sc_IterableOnce__sci_WrappedString(coll)
});
$c_sci_WrappedString.prototype.apply__O__O = (function(v1) {
  var i = $uI(v1);
  var this$1 = this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self;
  return $bC((65535 & $uI(this$1.charCodeAt(i))))
});
$c_sci_WrappedString.prototype.apply__I__O = (function(i) {
  var this$1 = this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self;
  return $bC((65535 & $uI(this$1.charCodeAt(i))))
});
function $as_sci_WrappedString(obj) {
  return (((obj instanceof $c_sci_WrappedString) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.WrappedString"))
}
function $isArrayOf_sci_WrappedString(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_WrappedString)))
}
function $asArrayOf_sci_WrappedString(obj, depth) {
  return (($isArrayOf_sci_WrappedString(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.WrappedString;", depth))
}
var $d_sci_WrappedString = new $TypeData().initClass({
  sci_WrappedString: 0
}, false, "scala.collection.immutable.WrappedString", {
  sci_WrappedString: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  Ljava_io_Serializable: 1
});
$c_sci_WrappedString.prototype.$classData = $d_sci_WrappedString;
function $ct_sjsr_WrappedVarArgs__sjs_js_Array__($thiz, array) {
  $thiz.sjsr_WrappedVarArgs__f_scala$scalajs$runtime$WrappedVarArgs$$array = array;
  return $thiz
}
function $ct_sjsr_WrappedVarArgs__($thiz) {
  $ct_sjsr_WrappedVarArgs__sjs_js_Array__($thiz, []);
  return $thiz
}
/** @constructor */
function $c_sjsr_WrappedVarArgs() {
  this.sjsr_WrappedVarArgs__f_scala$scalajs$runtime$WrappedVarArgs$$array = null
}
$c_sjsr_WrappedVarArgs.prototype = new $h_O();
$c_sjsr_WrappedVarArgs.prototype.constructor = $c_sjsr_WrappedVarArgs;
/** @constructor */
function $h_sjsr_WrappedVarArgs() {
  /*<skip>*/
}
$h_sjsr_WrappedVarArgs.prototype = $c_sjsr_WrappedVarArgs.prototype;
$c_sjsr_WrappedVarArgs.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O(this, suffix)
});
$c_sjsr_WrappedVarArgs.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f)
});
$c_sjsr_WrappedVarArgs.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f)
});
$c_sjsr_WrappedVarArgs.prototype.zipWithIndex__O = (function() {
  return $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this)
});
$c_sjsr_WrappedVarArgs.prototype.canEqual__O__Z = (function(that) {
  return $f_sci_IndexedSeq__canEqual__O__Z(this, that)
});
$c_sjsr_WrappedVarArgs.prototype.sameElements__sc_IterableOnce__Z = (function(o) {
  return $f_sci_IndexedSeq__sameElements__sc_IterableOnce__Z(this, o)
});
$c_sjsr_WrappedVarArgs.prototype.applyPreferredMaxLength__I = (function() {
  return $m_sci_IndexedSeqDefaults$().sci_IndexedSeqDefaults$__f_defaultApplyPreferredMaxLength
});
$c_sjsr_WrappedVarArgs.prototype.iterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_IndexedSeqView$Id(this);
  return new $c_sc_IndexedSeqView$IndexedSeqViewIterator(this$1)
});
$c_sjsr_WrappedVarArgs.prototype.drop__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__drop__I__O(this, n)
});
$c_sjsr_WrappedVarArgs.prototype.head__O = (function() {
  return this.apply__I__O(0)
});
$c_sjsr_WrappedVarArgs.prototype.lengthCompare__I__I = (function(len) {
  var x = this.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1))
});
$c_sjsr_WrappedVarArgs.prototype.knownSize__I = (function() {
  return this.length__I()
});
$c_sjsr_WrappedVarArgs.prototype.toSeq__sci_Seq = (function() {
  return this
});
$c_sjsr_WrappedVarArgs.prototype.equals__O__Z = (function(o) {
  return $f_sc_Seq__equals__O__Z(this, o)
});
$c_sjsr_WrappedVarArgs.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().seqHash__sc_Seq__I(this)
});
$c_sjsr_WrappedVarArgs.prototype.toString__T = (function() {
  return $f_sc_Iterable__toString__T(this)
});
$c_sjsr_WrappedVarArgs.prototype.concat__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O(this, suffix)
});
$c_sjsr_WrappedVarArgs.prototype.size__I = (function() {
  return this.length__I()
});
$c_sjsr_WrappedVarArgs.prototype.indexWhere__F1__I__I = (function(p, from) {
  var this$1 = new $c_sc_IndexedSeqView$Id(this);
  var this$2 = new $c_sc_IndexedSeqView$IndexedSeqViewIterator(this$1);
  return $f_sc_Iterator__indexWhere__F1__I__I(this$2, p, from)
});
$c_sjsr_WrappedVarArgs.prototype.sizeCompare__I__I = (function(otherSize) {
  var x = this.length__I();
  return ((x === otherSize) ? 0 : ((x < otherSize) ? (-1) : 1))
});
$c_sjsr_WrappedVarArgs.prototype.isEmpty__Z = (function() {
  return $f_sc_SeqOps__isEmpty__Z(this)
});
$c_sjsr_WrappedVarArgs.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return $f_s_PartialFunction__applyOrElse__O__F1__O(this, x, default$1)
});
$c_sjsr_WrappedVarArgs.prototype.newSpecificBuilder__scm_Builder = (function() {
  return $m_sjsr_WrappedVarArgs$().newBuilder__scm_Builder()
});
$c_sjsr_WrappedVarArgs.prototype.tail__O = (function() {
  return $f_sc_IterableOps__tail__O(this)
});
$c_sjsr_WrappedVarArgs.prototype.foreach__F1__V = (function(f) {
  $f_sc_IterableOnceOps__foreach__F1__V(this, f)
});
$c_sjsr_WrappedVarArgs.prototype.forall__F1__Z = (function(p) {
  return $f_sc_IterableOnceOps__forall__F1__Z(this, p)
});
$c_sjsr_WrappedVarArgs.prototype.exists__F1__Z = (function(p) {
  return $f_sc_IterableOnceOps__exists__F1__Z(this, p)
});
$c_sjsr_WrappedVarArgs.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op)
});
$c_sjsr_WrappedVarArgs.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len)
});
$c_sjsr_WrappedVarArgs.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end)
});
$c_sjsr_WrappedVarArgs.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2)
});
$c_sjsr_WrappedVarArgs.prototype.iterableFactory__sc_SeqFactory = (function() {
  return $m_sjsr_WrappedVarArgs$()
});
$c_sjsr_WrappedVarArgs.prototype.length__I = (function() {
  return $uI(this.sjsr_WrappedVarArgs__f_scala$scalajs$runtime$WrappedVarArgs$$array.length)
});
$c_sjsr_WrappedVarArgs.prototype.apply__I__O = (function(idx) {
  return this.sjsr_WrappedVarArgs__f_scala$scalajs$runtime$WrappedVarArgs$$array[idx]
});
$c_sjsr_WrappedVarArgs.prototype.className__T = (function() {
  return "WrappedVarArgs"
});
$c_sjsr_WrappedVarArgs.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  var this$1 = $m_sjsr_WrappedVarArgs$();
  return this$1.from__sc_IterableOnce__sjsr_WrappedVarArgs(coll)
});
$c_sjsr_WrappedVarArgs.prototype.isDefinedAt__O__Z = (function(x) {
  var idx = $uI(x);
  return $f_sc_SeqOps__isDefinedAt__I__Z(this, idx)
});
$c_sjsr_WrappedVarArgs.prototype.apply__O__O = (function(v1) {
  return this.apply__I__O($uI(v1))
});
$c_sjsr_WrappedVarArgs.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sjsr_WrappedVarArgs$()
});
function $as_sjsr_WrappedVarArgs(obj) {
  return (((obj instanceof $c_sjsr_WrappedVarArgs) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.scalajs.runtime.WrappedVarArgs"))
}
function $isArrayOf_sjsr_WrappedVarArgs(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sjsr_WrappedVarArgs)))
}
function $asArrayOf_sjsr_WrappedVarArgs(obj, depth) {
  return (($isArrayOf_sjsr_WrappedVarArgs(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.scalajs.runtime.WrappedVarArgs;", depth))
}
var $d_sjsr_WrappedVarArgs = new $TypeData().initClass({
  sjsr_WrappedVarArgs: 0
}, false, "scala.scalajs.runtime.WrappedVarArgs", {
  sjsr_WrappedVarArgs: 1,
  O: 1,
  sci_IndexedSeq: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_SeqOps: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
});
$c_sjsr_WrappedVarArgs.prototype.$classData = $d_sjsr_WrappedVarArgs;
/** @constructor */
function $c_sci_HashMap(rootNode) {
  this.sci_HashMap__f_rootNode = null;
  this.sci_HashMap__f_rootNode = rootNode
}
$c_sci_HashMap.prototype = new $h_sci_AbstractMap();
$c_sci_HashMap.prototype.constructor = $c_sci_HashMap;
/** @constructor */
function $h_sci_HashMap() {
  /*<skip>*/
}
$h_sci_HashMap.prototype = $c_sci_HashMap.prototype;
$c_sci_HashMap.prototype.map__F1__sc_IterableOps = (function(f) {
  return $f_sc_StrictOptimizedMapOps__map__F1__sc_IterableOps(this, f)
});
$c_sci_HashMap.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f)
});
$c_sci_HashMap.prototype.mapFactory__sc_MapFactory = (function() {
  return $m_sci_HashMap$()
});
$c_sci_HashMap.prototype.knownSize__I = (function() {
  return this.sci_HashMap__f_rootNode.sci_BitmapIndexedMapNode__f_size
});
$c_sci_HashMap.prototype.size__I = (function() {
  return this.sci_HashMap__f_rootNode.sci_BitmapIndexedMapNode__f_size
});
$c_sci_HashMap.prototype.isEmpty__Z = (function() {
  return (this.sci_HashMap__f_rootNode.sci_BitmapIndexedMapNode__f_size === 0)
});
$c_sci_HashMap.prototype.iterator__sc_Iterator = (function() {
  return (this.isEmpty__Z() ? $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty : new $c_sci_MapKeyValueTupleIterator(this.sci_HashMap__f_rootNode))
});
$c_sci_HashMap.prototype.contains__O__Z = (function(key) {
  var keyUnimprovedHash = $m_sr_Statics$().anyHash__O__I(key);
  var keyHash = $m_sc_Hashing$().improve__I__I(keyUnimprovedHash);
  return this.sci_HashMap__f_rootNode.containsKey__O__I__I__I__Z(key, keyUnimprovedHash, keyHash, 0)
});
$c_sci_HashMap.prototype.apply__O__O = (function(key) {
  var keyUnimprovedHash = $m_sr_Statics$().anyHash__O__I(key);
  var keyHash = $m_sc_Hashing$().improve__I__I(keyUnimprovedHash);
  return this.sci_HashMap__f_rootNode.apply__O__I__I__I__O(key, keyUnimprovedHash, keyHash, 0)
});
$c_sci_HashMap.prototype.get__O__s_Option = (function(key) {
  var keyUnimprovedHash = $m_sr_Statics$().anyHash__O__I(key);
  var keyHash = $m_sc_Hashing$().improve__I__I(keyUnimprovedHash);
  return this.sci_HashMap__f_rootNode.get__O__I__I__I__s_Option(key, keyUnimprovedHash, keyHash, 0)
});
$c_sci_HashMap.prototype.getOrElse__O__F0__O = (function(key, default$1) {
  var keyUnimprovedHash = $m_sr_Statics$().anyHash__O__I(key);
  var keyHash = $m_sc_Hashing$().improve__I__I(keyUnimprovedHash);
  return this.sci_HashMap__f_rootNode.getOrElse__O__I__I__I__F0__O(key, keyUnimprovedHash, keyHash, 0, default$1)
});
$c_sci_HashMap.prototype.updated__O__O__sci_HashMap = (function(key, value) {
  var keyUnimprovedHash = $m_sr_Statics$().anyHash__O__I(key);
  var newRootNode = this.sci_HashMap__f_rootNode.updated__O__O__I__I__I__Z__sci_BitmapIndexedMapNode(key, value, keyUnimprovedHash, $m_sc_Hashing$().improve__I__I(keyUnimprovedHash), 0, true);
  return ((newRootNode === this.sci_HashMap__f_rootNode) ? this : new $c_sci_HashMap(newRootNode))
});
$c_sci_HashMap.prototype.removed__O__sci_HashMap = (function(key) {
  var keyUnimprovedHash = $m_sr_Statics$().anyHash__O__I(key);
  var newRootNode = this.sci_HashMap__f_rootNode.removed__O__I__I__I__sci_BitmapIndexedMapNode(key, keyUnimprovedHash, $m_sc_Hashing$().improve__I__I(keyUnimprovedHash), 0);
  return ((newRootNode === this.sci_HashMap__f_rootNode) ? this : new $c_sci_HashMap(newRootNode))
});
$c_sci_HashMap.prototype.concat__sc_IterableOnce__sci_HashMap = (function(that) {
  if ((that instanceof $c_sci_HashMap)) {
    var x2 = $as_sci_HashMap(that);
    if (this.isEmpty__Z()) {
      return x2
    } else {
      var newNode = this.sci_HashMap__f_rootNode.concat__sci_MapNode__I__sci_BitmapIndexedMapNode(x2.sci_HashMap__f_rootNode, 0);
      if ((newNode === x2.sci_HashMap__f_rootNode)) {
        return x2
      } else {
        var newRootNode = this.sci_HashMap__f_rootNode.concat__sci_MapNode__I__sci_BitmapIndexedMapNode(x2.sci_HashMap__f_rootNode, 0);
        return ((newRootNode === this.sci_HashMap__f_rootNode) ? this : new $c_sci_HashMap(newRootNode))
      }
    }
  } else if ((that instanceof $c_scm_HashMap)) {
    var x3 = $as_scm_HashMap(that);
    var iter = x3.nodeIterator__sc_Iterator();
    var current = this.sci_HashMap__f_rootNode;
    while (iter.hasNext__Z()) {
      var next = $as_scm_HashMap$Node(iter.next__O());
      var improvedHash = next.scm_HashMap$Node__f__hash;
      var originalHash = (improvedHash ^ ((improvedHash >>> 16) | 0));
      var improved = $m_sc_Hashing$().improve__I__I(originalHash);
      current = current.updated__O__O__I__I__I__Z__sci_BitmapIndexedMapNode(next.scm_HashMap$Node__f__key, next.scm_HashMap$Node__f__value, originalHash, improved, 0, true);
      if ((current !== this.sci_HashMap__f_rootNode)) {
        var shallowlyMutableNodeMap = $m_sci_Node$().bitposFrom__I__I($m_sci_Node$().maskFrom__I__I__I(improved, 0));
        while (iter.hasNext__Z()) {
          var next$2 = $as_scm_HashMap$Node(iter.next__O());
          var improvedHash$1 = next$2.scm_HashMap$Node__f__hash;
          var originalHash$2 = (improvedHash$1 ^ ((improvedHash$1 >>> 16) | 0));
          shallowlyMutableNodeMap = current.updateWithShallowMutations__O__O__I__I__I__I__I(next$2.scm_HashMap$Node__f__key, next$2.scm_HashMap$Node__f__value, originalHash$2, $m_sc_Hashing$().improve__I__I(originalHash$2), 0, shallowlyMutableNodeMap)
        };
        return new $c_sci_HashMap(current)
      }
    };
    return this
  } else if ($is_sci_Map(that)) {
    var x2$2 = $as_sci_Map(that);
    if (x2$2.isEmpty__Z()) {
      return this
    } else {
      var accum = new $c_sci_HashMap$accum$1(this);
      x2$2.foreachEntry__F2__V(accum);
      var newRootNode$1 = accum.sci_HashMap$accum$1__f_current;
      return ((newRootNode$1 === this.sci_HashMap__f_rootNode) ? this : new $c_sci_HashMap(newRootNode$1))
    }
  } else {
    var it = that.iterator__sc_Iterator();
    if ((!it.hasNext__Z())) {
      return this
    } else {
      var accum$2 = new $c_sci_HashMap$accum$1(this);
      $f_sc_IterableOnceOps__foreach__F1__V(it, accum$2);
      var newRootNode$2 = accum$2.sci_HashMap$accum$1__f_current;
      return ((newRootNode$2 === this.sci_HashMap__f_rootNode) ? this : new $c_sci_HashMap(newRootNode$2))
    }
  }
});
$c_sci_HashMap.prototype.tail__sci_HashMap = (function() {
  var key = $as_T2(this.iterator__sc_Iterator().next__O())._1__O();
  return this.removed__O__sci_HashMap(key)
});
$c_sci_HashMap.prototype.foreach__F1__V = (function(f) {
  this.sci_HashMap__f_rootNode.foreach__F1__V(f)
});
$c_sci_HashMap.prototype.foreachEntry__F2__V = (function(f) {
  this.sci_HashMap__f_rootNode.foreachEntry__F2__V(f)
});
$c_sci_HashMap.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_HashMap)) {
    var x2 = $as_sci_HashMap(that);
    if ((this === x2)) {
      return true
    } else {
      var x = this.sci_HashMap__f_rootNode;
      var x$2 = x2.sci_HashMap__f_rootNode;
      return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
    }
  } else {
    return $f_sc_Map__equals__O__Z(this, that)
  }
});
$c_sci_HashMap.prototype.hashCode__I = (function() {
  if (this.isEmpty__Z()) {
    return $m_s_util_hashing_MurmurHash3$().s_util_hashing_MurmurHash3$__f_emptyMapHash
  } else {
    var hashIterator = new $c_sci_MapKeyValueTupleHashIterator(this.sci_HashMap__f_rootNode);
    var hash = $m_s_util_hashing_MurmurHash3$().unorderedHash__sc_IterableOnce__I__I(hashIterator, $m_s_util_hashing_MurmurHash3$().s_util_hashing_MurmurHash3$__f_mapSeed);
    return hash
  }
});
$c_sci_HashMap.prototype.className__T = (function() {
  return "HashMap"
});
$c_sci_HashMap.prototype.drop__I__O = (function(n) {
  return $as_sci_HashMap($f_sc_IterableOps__drop__I__O(this, n))
});
$c_sci_HashMap.prototype.head__O = (function() {
  return $as_T2(this.iterator__sc_Iterator().next__O())
});
$c_sci_HashMap.prototype.tail__O = (function() {
  return this.tail__sci_HashMap()
});
$c_sci_HashMap.prototype.concat__sc_IterableOnce__sc_IterableOps = (function(suffix) {
  return this.concat__sc_IterableOnce__sci_HashMap(suffix)
});
$c_sci_HashMap.prototype.updated__O__O__sci_MapOps = (function(key, value) {
  return this.updated__O__O__sci_HashMap(key, value)
});
function $as_sci_HashMap(obj) {
  return (((obj instanceof $c_sci_HashMap) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.HashMap"))
}
function $isArrayOf_sci_HashMap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_HashMap)))
}
function $asArrayOf_sci_HashMap(obj, depth) {
  return (($isArrayOf_sci_HashMap(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.HashMap;", depth))
}
var $d_sci_HashMap = new $TypeData().initClass({
  sci_HashMap: 0
}, false, "scala.collection.immutable.HashMap", {
  sci_HashMap: 1,
  sci_AbstractMap: 1,
  sc_AbstractMap: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Map: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_MapFactoryDefaults: 1,
  s_Equals: 1,
  sci_Map: 1,
  sci_Iterable: 1,
  sci_MapOps: 1,
  sci_StrictOptimizedMapOps: 1,
  sc_StrictOptimizedMapOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
});
$c_sci_HashMap.prototype.$classData = $d_sci_HashMap;
/** @constructor */
function $c_sci_Stream$Cons(head, tl) {
  this.sci_Stream$Cons__f_head = null;
  this.sci_Stream$Cons__f_tlVal = null;
  this.sci_Stream$Cons__f_tlGen = null;
  this.sci_Stream$Cons__f_head = head;
  this.sci_Stream$Cons__f_tlGen = tl
}
$c_sci_Stream$Cons.prototype = new $h_sci_Stream();
$c_sci_Stream$Cons.prototype.constructor = $c_sci_Stream$Cons;
/** @constructor */
function $h_sci_Stream$Cons() {
  /*<skip>*/
}
$h_sci_Stream$Cons.prototype = $c_sci_Stream$Cons.prototype;
$c_sci_Stream$Cons.prototype.head__O = (function() {
  return this.sci_Stream$Cons__f_head
});
$c_sci_Stream$Cons.prototype.isEmpty__Z = (function() {
  return false
});
$c_sci_Stream$Cons.prototype.tailDefined__Z = (function() {
  return (this.sci_Stream$Cons__f_tlGen === null)
});
$c_sci_Stream$Cons.prototype.tail__sci_Stream = (function() {
  if ((!this.tailDefined__Z())) {
    if ((!this.tailDefined__Z())) {
      this.sci_Stream$Cons__f_tlVal = $as_sci_Stream(this.sci_Stream$Cons__f_tlGen.apply__O());
      this.sci_Stream$Cons__f_tlGen = null
    }
  };
  return this.sci_Stream$Cons__f_tlVal
});
$c_sci_Stream$Cons.prototype.force__sci_Stream$Cons = (function() {
  var these = this;
  var those = this;
  if ((!these.isEmpty__Z())) {
    these = $as_sci_Stream(these.tail__O())
  };
  while ((those !== these)) {
    if (these.isEmpty__Z()) {
      return this
    };
    these = $as_sci_Stream(these.tail__O());
    if (these.isEmpty__Z()) {
      return this
    };
    these = $as_sci_Stream(these.tail__O());
    if ((these === those)) {
      return this
    };
    those = $as_sci_Stream(those.tail__O())
  };
  return this
});
$c_sci_Stream$Cons.prototype.force__sci_Stream = (function() {
  return this.force__sci_Stream$Cons()
});
$c_sci_Stream$Cons.prototype.tail__O = (function() {
  return this.tail__sci_Stream()
});
var $d_sci_Stream$Cons = new $TypeData().initClass({
  sci_Stream$Cons: 0
}, false, "scala.collection.immutable.Stream$Cons", {
  sci_Stream$Cons: 1,
  sci_Stream: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_LinearSeq: 1,
  sc_LinearSeq: 1,
  sc_LinearSeqOps: 1,
  sci_LinearSeqOps: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Stream$Cons.prototype.$classData = $d_sci_Stream$Cons;
/** @constructor */
function $c_sci_Stream$Empty$() {
  /*<skip>*/
}
$c_sci_Stream$Empty$.prototype = new $h_sci_Stream();
$c_sci_Stream$Empty$.prototype.constructor = $c_sci_Stream$Empty$;
/** @constructor */
function $h_sci_Stream$Empty$() {
  /*<skip>*/
}
$h_sci_Stream$Empty$.prototype = $c_sci_Stream$Empty$.prototype;
$c_sci_Stream$Empty$.prototype.isEmpty__Z = (function() {
  return true
});
$c_sci_Stream$Empty$.prototype.head__E = (function() {
  throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "head of empty stream")
});
$c_sci_Stream$Empty$.prototype.tail__sci_Stream = (function() {
  throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "tail of empty stream")
});
$c_sci_Stream$Empty$.prototype.knownSize__I = (function() {
  return 0
});
$c_sci_Stream$Empty$.prototype.tailDefined__Z = (function() {
  return false
});
$c_sci_Stream$Empty$.prototype.force__sci_Stream = (function() {
  return this
});
$c_sci_Stream$Empty$.prototype.tail__O = (function() {
  return this.tail__sci_Stream()
});
$c_sci_Stream$Empty$.prototype.head__O = (function() {
  this.head__E()
});
var $d_sci_Stream$Empty$ = new $TypeData().initClass({
  sci_Stream$Empty$: 0
}, false, "scala.collection.immutable.Stream$Empty$", {
  sci_Stream$Empty$: 1,
  sci_Stream: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_LinearSeq: 1,
  sc_LinearSeq: 1,
  sc_LinearSeqOps: 1,
  sci_LinearSeqOps: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Stream$Empty$.prototype.$classData = $d_sci_Stream$Empty$;
var $n_sci_Stream$Empty$;
function $m_sci_Stream$Empty$() {
  if ((!$n_sci_Stream$Empty$)) {
    $n_sci_Stream$Empty$ = new $c_sci_Stream$Empty$()
  };
  return $n_sci_Stream$Empty$
}
/** @constructor */
function $c_scm_AbstractBuffer() {
  /*<skip>*/
}
$c_scm_AbstractBuffer.prototype = new $h_scm_AbstractSeq();
$c_scm_AbstractBuffer.prototype.constructor = $c_scm_AbstractBuffer;
/** @constructor */
function $h_scm_AbstractBuffer() {
  /*<skip>*/
}
$h_scm_AbstractBuffer.prototype = $c_scm_AbstractBuffer.prototype;
$c_scm_AbstractBuffer.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs)
});
/** @constructor */
function $c_scm_AbstractMap() {
  /*<skip>*/
}
$c_scm_AbstractMap.prototype = new $h_sc_AbstractMap();
$c_scm_AbstractMap.prototype.constructor = $c_scm_AbstractMap;
/** @constructor */
function $h_scm_AbstractMap() {
  /*<skip>*/
}
$h_scm_AbstractMap.prototype = $c_scm_AbstractMap.prototype;
$c_scm_AbstractMap.prototype.mapFactory__sc_MapFactory = (function() {
  return $m_scm_Map$()
});
$c_scm_AbstractMap.prototype.put__O__O__s_Option = (function(key, value) {
  return $f_scm_MapOps__put__O__O__s_Option(this, key, value)
});
$c_scm_AbstractMap.prototype.getOrElseUpdate__O__F0__O = (function(key, op) {
  return $f_scm_MapOps__getOrElseUpdate__O__F0__O(this, key, op)
});
$c_scm_AbstractMap.prototype.knownSize__I = (function() {
  return (-1)
});
$c_scm_AbstractMap.prototype.sizeHint__I__V = (function(size) {
  /*<skip>*/
});
$c_scm_AbstractMap.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs)
});
$c_scm_AbstractMap.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_scm_Iterable$()
});
$c_scm_AbstractMap.prototype.result__O = (function() {
  return this
});
/** @constructor */
function $c_sjs_js_WrappedDictionary(dict) {
  this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict = null;
  this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict = dict
}
$c_sjs_js_WrappedDictionary.prototype = new $h_scm_AbstractMap();
$c_sjs_js_WrappedDictionary.prototype.constructor = $c_sjs_js_WrappedDictionary;
/** @constructor */
function $h_sjs_js_WrappedDictionary() {
  /*<skip>*/
}
$h_sjs_js_WrappedDictionary.prototype = $c_sjs_js_WrappedDictionary.prototype;
$c_sjs_js_WrappedDictionary.prototype.fromSpecific__sc_IterableOnce__sjs_js_WrappedDictionary = (function(coll) {
  var d = new $c_sjs_js_WrappedDictionary({});
  $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(d, coll);
  return d
});
$c_sjs_js_WrappedDictionary.prototype.newSpecificBuilder__scm_Builder = (function() {
  return new $c_sjs_js_WrappedDictionary$WrappedDictionaryBuilder()
});
$c_sjs_js_WrappedDictionary.prototype.get__T__s_Option = (function(key) {
  var dict = this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict;
  if ($uZ($m_sjs_js_WrappedDictionary$Cache$().sjs_js_WrappedDictionary$Cache$__f_safeHasOwnProperty.call(dict, key))) {
    return new $c_s_Some(this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict[key])
  } else {
    return $m_s_None$()
  }
});
$c_sjs_js_WrappedDictionary.prototype.apply__T__O = (function(key) {
  var dict = this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict;
  if ($uZ($m_sjs_js_WrappedDictionary$Cache$().sjs_js_WrappedDictionary$Cache$__f_safeHasOwnProperty.call(dict, key))) {
    return this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict[key]
  } else {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + key))
  }
});
$c_sjs_js_WrappedDictionary.prototype.update__T__O__V = (function(key, value) {
  this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict[key] = value
});
$c_sjs_js_WrappedDictionary.prototype.addOne__T2__sjs_js_WrappedDictionary = (function(kv) {
  var dict = this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict;
  var key = $as_T(kv._1__O());
  var value = kv._2__O();
  dict[key] = value;
  return this
});
$c_sjs_js_WrappedDictionary.prototype.iterator__sc_Iterator = (function() {
  return new $c_sjs_js_WrappedDictionary$DictionaryIterator(this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict)
});
$c_sjs_js_WrappedDictionary.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__T2__sjs_js_WrappedDictionary($as_T2(elem))
});
$c_sjs_js_WrappedDictionary.prototype.update__O__O__V = (function(key, value) {
  this.update__T__O__V($as_T(key), value)
});
$c_sjs_js_WrappedDictionary.prototype.contains__O__Z = (function(key) {
  var key$1 = $as_T(key);
  var dict = this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict;
  return $uZ($m_sjs_js_WrappedDictionary$Cache$().sjs_js_WrappedDictionary$Cache$__f_safeHasOwnProperty.call(dict, key$1))
});
$c_sjs_js_WrappedDictionary.prototype.apply__O__O = (function(key) {
  return this.apply__T__O($as_T(key))
});
$c_sjs_js_WrappedDictionary.prototype.get__O__s_Option = (function(key) {
  return this.get__T__s_Option($as_T(key))
});
$c_sjs_js_WrappedDictionary.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  return this.fromSpecific__sc_IterableOnce__sjs_js_WrappedDictionary(coll)
});
$c_sjs_js_WrappedDictionary.prototype.fromSpecific__sc_IterableOnce__sc_IterableOps = (function(coll) {
  return this.fromSpecific__sc_IterableOnce__sjs_js_WrappedDictionary(coll)
});
var $d_sjs_js_WrappedDictionary = new $TypeData().initClass({
  sjs_js_WrappedDictionary: 0
}, false, "scala.scalajs.js.WrappedDictionary", {
  sjs_js_WrappedDictionary: 1,
  scm_AbstractMap: 1,
  sc_AbstractMap: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Map: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_MapFactoryDefaults: 1,
  s_Equals: 1,
  scm_Map: 1,
  scm_Iterable: 1,
  scm_MapOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  scm_Shrinkable: 1
});
$c_sjs_js_WrappedDictionary.prototype.$classData = $d_sjs_js_WrappedDictionary;
function $ct_sci_Vector__AO__($thiz, prefix1) {
  $thiz.sci_Vector__f_prefix1 = prefix1;
  return $thiz
}
/** @constructor */
function $c_sci_Vector() {
  this.sci_Vector__f_prefix1 = null
}
$c_sci_Vector.prototype = new $h_sci_AbstractSeq();
$c_sci_Vector.prototype.constructor = $c_sci_Vector;
/** @constructor */
function $h_sci_Vector() {
  /*<skip>*/
}
$h_sci_Vector.prototype = $c_sci_Vector.prototype;
$c_sci_Vector.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f)
});
$c_sci_Vector.prototype.zipWithIndex__O = (function() {
  return $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this)
});
$c_sci_Vector.prototype.canEqual__O__Z = (function(that) {
  return $f_sci_IndexedSeq__canEqual__O__Z(this, that)
});
$c_sci_Vector.prototype.sameElements__sc_IterableOnce__Z = (function(o) {
  return $f_sci_IndexedSeq__sameElements__sc_IterableOnce__Z(this, o)
});
$c_sci_Vector.prototype.stringPrefix__T = (function() {
  return "IndexedSeq"
});
$c_sci_Vector.prototype.lengthCompare__I__I = (function(len) {
  var x = this.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1))
});
$c_sci_Vector.prototype.knownSize__I = (function() {
  return this.length__I()
});
$c_sci_Vector.prototype.iterableFactory__sc_SeqFactory = (function() {
  return $m_sci_Vector$()
});
$c_sci_Vector.prototype.length__I = (function() {
  return ((this instanceof $c_sci_BigVector) ? $as_sci_BigVector(this).sci_BigVector__f_length0 : this.sci_Vector__f_prefix1.u.length)
});
$c_sci_Vector.prototype.iterator__sc_Iterator = (function() {
  return (($m_sci_Vector0$() === this) ? $m_sci_Vector$().sci_Vector$__f_scala$collection$immutable$Vector$$emptyIterator : new $c_sci_NewVectorIterator(this, this.length__I(), this.vectorSliceCount__I()))
});
$c_sci_Vector.prototype.filterImpl__F1__Z__sci_Vector = (function(pred, isFlipped) {
  var i = 0;
  var len = this.sci_Vector__f_prefix1.u.length;
  while ((i !== len)) {
    if (($uZ(pred.apply__O__O(this.sci_Vector__f_prefix1.get(i))) === isFlipped)) {
      var bitmap = 0;
      var j = ((1 + i) | 0);
      while ((j < len)) {
        if (($uZ(pred.apply__O__O(this.sci_Vector__f_prefix1.get(j))) !== isFlipped)) {
          bitmap = (bitmap | (1 << j))
        };
        j = ((1 + j) | 0)
      };
      var $$x1 = i;
      var i$1 = bitmap;
      var newLen = (($$x1 + $m_jl_Integer$().bitCount__I__I(i$1)) | 0);
      if ((this instanceof $c_sci_BigVector)) {
        var b = new $c_sci_VectorBuilder();
        var k = 0;
        while ((k < i)) {
          b.addOne__O__sci_VectorBuilder(this.sci_Vector__f_prefix1.get(k));
          k = ((1 + k) | 0)
        };
        k = ((1 + i) | 0);
        while ((i !== newLen)) {
          if ((((1 << k) & bitmap) !== 0)) {
            b.addOne__O__sci_VectorBuilder(this.sci_Vector__f_prefix1.get(k));
            i = ((1 + i) | 0)
          };
          k = ((1 + k) | 0)
        };
        $as_sci_BigVector(this).foreachRest__F1__V(new $c_sjsr_AnonFunction1((function(this$1, pred$1, isFlipped$1, b$1) {
          return (function(v$2) {
            return (($uZ(pred$1.apply__O__O(v$2)) !== isFlipped$1) ? b$1.addOne__O__sci_VectorBuilder(v$2) : (void 0))
          })
        })(this, pred, isFlipped, b)));
        return b.result__sci_Vector()
      } else {
        if ((newLen === 0)) {
          return $m_sci_Vector0$()
        };
        var newData = new $ac_O(newLen);
        var src = this.sci_Vector__f_prefix1;
        var length = i;
        $systemArraycopy(src, 0, newData, 0, length);
        var k$2 = ((1 + i) | 0);
        while ((i !== newLen)) {
          if ((((1 << k$2) & bitmap) !== 0)) {
            newData.set(i, this.sci_Vector__f_prefix1.get(k$2));
            i = ((1 + i) | 0)
          };
          k$2 = ((1 + k$2) | 0)
        };
        return new $c_sci_Vector1(newData)
      }
    };
    i = ((1 + i) | 0)
  };
  if ((this instanceof $c_sci_BigVector)) {
    var b$2 = new $c_sci_VectorBuilder();
    b$2.initFrom__AO__V(this.sci_Vector__f_prefix1);
    $as_sci_BigVector(this).foreachRest__F1__V(new $c_sjsr_AnonFunction1((function(this$2, pred$2, isFlipped$2, b$2$1) {
      return (function(v$3$2) {
        return (($uZ(pred$2.apply__O__O(v$3$2)) !== isFlipped$2) ? b$2$1.addOne__O__sci_VectorBuilder(v$3$2) : (void 0))
      })
    })(this, pred, isFlipped, b$2)));
    return b$2.result__sci_Vector()
  } else {
    return this
  }
});
$c_sci_Vector.prototype.appendedAll__sc_IterableOnce__sci_Vector = (function(suffix) {
  var k = suffix.knownSize__I();
  return ((k === 0) ? this : this.appendedAll0__sc_IterableOnce__I__sci_Vector(suffix, k))
});
$c_sci_Vector.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector = (function(suffix, k) {
  var tinyAppendLimit = ((4 + this.vectorSliceCount__I()) | 0);
  if (((k > 0) && (k < tinyAppendLimit))) {
    var v = new $c_sr_ObjectRef(this);
    if ($is_sci_Iterable(suffix)) {
      var x2 = $as_sci_Iterable(suffix);
      x2.foreach__F1__V(new $c_sjsr_AnonFunction1((function(this$2, v$1) {
        return (function(x$2) {
          v$1.sr_ObjectRef__f_elem = $as_sci_Vector(v$1.sr_ObjectRef__f_elem).appended__O__sci_Vector(x$2)
        })
      })(this, v)))
    } else {
      var this$3 = suffix.iterator__sc_Iterator();
      while (this$3.hasNext__Z()) {
        var arg1 = this$3.next__O();
        v.sr_ObjectRef__f_elem = $as_sci_Vector(v.sr_ObjectRef__f_elem).appended__O__sci_Vector(arg1)
      }
    };
    return $as_sci_Vector(v.sr_ObjectRef__f_elem)
  } else if (((this.length__I() < ((k >>> 5) | 0)) && (suffix instanceof $c_sci_Vector))) {
    var v$2 = $as_sci_Vector(suffix);
    var ri = new $c_sc_IndexedSeqOps$$anon$1(this);
    while (ri.hasNext__Z()) {
      v$2 = v$2.prepended__O__sci_Vector(ri.next__O())
    };
    return v$2
  } else {
    return new $c_sci_VectorBuilder().initFrom__sci_Vector__sci_VectorBuilder(this).addAll__sc_IterableOnce__sci_VectorBuilder(suffix).result__sci_Vector()
  }
});
$c_sci_Vector.prototype.className__T = (function() {
  return "Vector"
});
$c_sci_Vector.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return this.iterator__sc_Iterator().copyToArray__O__I__I__I(xs, start, len)
});
$c_sci_Vector.prototype.applyPreferredMaxLength__I = (function() {
  return $m_sci_Vector$().sci_Vector$__f_scala$collection$immutable$Vector$$defaultApplyPreferredMaxLength
});
$c_sci_Vector.prototype.ioob__I__jl_IndexOutOfBoundsException = (function(index) {
  return $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (((index + " is out of bounds (min 0, max ") + (((-1) + this.length__I()) | 0)) + ")"))
});
$c_sci_Vector.prototype.head__O = (function() {
  if ((this.sci_Vector__f_prefix1.u.length === 0)) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "empty.head")
  } else {
    return this.sci_Vector__f_prefix1.get(0)
  }
});
$c_sci_Vector.prototype.foreach__F1__V = (function(f) {
  var c = this.vectorSliceCount__I();
  var i = 0;
  while ((i < c)) {
    var $$x1 = $m_sci_VectorStatics$();
    var idx = i;
    var c$1 = ((c / 2) | 0);
    var a = ((idx - c$1) | 0);
    $$x1.foreachRec__I__AO__F1__V((((-1) + ((((1 + c$1) | 0) - ((a < 0) ? ((-a) | 0) : a)) | 0)) | 0), this.vectorSlice__I__AO(i), f);
    i = ((1 + i) | 0)
  }
});
$c_sci_Vector.prototype.drop__I__O = (function(n) {
  var until = this.length__I();
  return this.slice__I__I__sci_Vector(n, until)
});
$c_sci_Vector.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return this.appendedAll__sc_IterableOnce__sci_Vector(suffix)
});
$c_sci_Vector.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sci_Vector$()
});
function $as_sci_Vector(obj) {
  return (((obj instanceof $c_sci_Vector) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Vector"))
}
function $isArrayOf_sci_Vector(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Vector)))
}
function $asArrayOf_sci_Vector(obj, depth) {
  return (($isArrayOf_sci_Vector(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Vector;", depth))
}
/** @constructor */
function $c_scm_ArraySeq() {
  /*<skip>*/
}
$c_scm_ArraySeq.prototype = new $h_scm_AbstractSeq();
$c_scm_ArraySeq.prototype.constructor = $c_scm_ArraySeq;
/** @constructor */
function $h_scm_ArraySeq() {
  /*<skip>*/
}
$h_scm_ArraySeq.prototype = $c_scm_ArraySeq.prototype;
$c_scm_ArraySeq.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O(this, suffix)
});
$c_scm_ArraySeq.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f)
});
$c_scm_ArraySeq.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f)
});
$c_scm_ArraySeq.prototype.stringPrefix__T = (function() {
  return "IndexedSeq"
});
$c_scm_ArraySeq.prototype.drop__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__drop__I__O(this, n)
});
$c_scm_ArraySeq.prototype.head__O = (function() {
  return this.apply__I__O(0)
});
$c_scm_ArraySeq.prototype.lengthCompare__I__I = (function(len) {
  var x = this.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1))
});
$c_scm_ArraySeq.prototype.knownSize__I = (function() {
  return this.length__I()
});
$c_scm_ArraySeq.prototype.iterableFactory__sc_SeqFactory = (function() {
  return $m_scm_ArraySeq$().scm_ArraySeq$__f_untagged
});
$c_scm_ArraySeq.prototype.fromSpecific__sc_IterableOnce__scm_ArraySeq = (function(coll) {
  var evidence$1 = this.elemTag__s_reflect_ClassTag();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1.runtimeClass__jl_Class();
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.getClassOf());
  jsElems = [];
  var s = coll.knownSize__I();
  var it = coll.iterator__sc_Iterator();
  while (it.hasNext__Z()) {
    var elem = it.next__O();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? elementClass.jl_Class__f_data.zero : elem));
    jsElems.push(unboxedElem)
  };
  var $$x1 = $m_scm_ArraySeq$();
  var elemRuntimeClass = ((elementClass === $d_V.getClassOf()) ? $d_jl_Void.getClassOf() : (((elementClass === $d_sr_Null$.getClassOf()) || (elementClass === $d_sr_Nothing$.getClassOf())) ? $d_O.getClassOf() : elementClass));
  return $$x1.make__O__scm_ArraySeq(elemRuntimeClass.jl_Class__f_data.getArrayOf().wrapArray(jsElems))
});
$c_scm_ArraySeq.prototype.newSpecificBuilder__scm_Builder = (function() {
  return $m_scm_ArraySeq$().newBuilder__s_reflect_ClassTag__scm_Builder(this.elemTag__s_reflect_ClassTag())
});
$c_scm_ArraySeq.prototype.className__T = (function() {
  return "ArraySeq"
});
$c_scm_ArraySeq.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  var srcLen = this.length__I();
  var destLen = $m_sr_ScalaRunTime$().array_length__O__I(xs);
  var x = ((len < srcLen) ? len : srcLen);
  var y = ((destLen - start) | 0);
  var x$1 = ((x < y) ? x : y);
  var copied = ((x$1 > 0) ? x$1 : 0);
  if ((copied > 0)) {
    $m_s_Array$().copy__O__I__O__I__I__V(this.array__O(), 0, xs, start, copied)
  };
  return copied
});
$c_scm_ArraySeq.prototype.equals__O__Z = (function(other) {
  if ((other instanceof $c_scm_ArraySeq)) {
    var x2 = $as_scm_ArraySeq(other);
    if (($m_sr_ScalaRunTime$().array_length__O__I(this.array__O()) !== $m_sr_ScalaRunTime$().array_length__O__I(x2.array__O()))) {
      return false
    }
  };
  return $f_sc_Seq__equals__O__Z(this, other)
});
$c_scm_ArraySeq.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  return this.fromSpecific__sc_IterableOnce__scm_ArraySeq(coll)
});
$c_scm_ArraySeq.prototype.fromSpecific__sc_IterableOnce__sc_IterableOps = (function(coll) {
  return this.fromSpecific__sc_IterableOnce__scm_ArraySeq(coll)
});
$c_scm_ArraySeq.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_scm_ArraySeq$().scm_ArraySeq$__f_untagged
});
function $as_scm_ArraySeq(obj) {
  return (((obj instanceof $c_scm_ArraySeq) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.ArraySeq"))
}
function $isArrayOf_scm_ArraySeq(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArraySeq)))
}
function $asArrayOf_scm_ArraySeq(obj, depth) {
  return (($isArrayOf_scm_ArraySeq(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.ArraySeq;", depth))
}
function $as_sci_ArraySeq$ofRef(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.ArraySeq$ofRef"))
}
function $isArrayOf_sci_ArraySeq$ofRef(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_ArraySeq$ofRef)))
}
function $asArrayOf_sci_ArraySeq$ofRef(obj, depth) {
  return (($isArrayOf_sci_ArraySeq$ofRef(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.ArraySeq$ofRef;", depth))
}
function $p_sci_List__loop$2__I__sci_List__I__I($thiz, i, xs, len$1) {
  while (true) {
    if ((i === len$1)) {
      return (xs.isEmpty__Z() ? 0 : 1)
    } else if (xs.isEmpty__Z()) {
      return (-1)
    } else {
      var temp$i = ((1 + i) | 0);
      var temp$xs = $as_sci_List(xs.tail__O());
      i = temp$i;
      xs = temp$xs
    }
  }
}
function $p_sci_List__listEq$1__sci_List__sci_List__Z($thiz, a, b) {
  while (true) {
    if ((a === b)) {
      return true
    } else {
      var aEmpty = a.isEmpty__Z();
      var bEmpty = b.isEmpty__Z();
      if (((!(aEmpty || bEmpty)) && $m_sr_BoxesRunTime$().equals__O__O__Z(a.head__O(), b.head__O()))) {
        var temp$a = $as_sci_List(a.tail__O());
        var temp$b = $as_sci_List(b.tail__O());
        a = temp$a;
        b = temp$b
      } else {
        return (aEmpty && bEmpty)
      }
    }
  }
}
/** @constructor */
function $c_sci_List() {
  /*<skip>*/
}
$c_sci_List.prototype = new $h_sci_AbstractSeq();
$c_sci_List.prototype.constructor = $c_sci_List;
/** @constructor */
function $h_sci_List() {
  /*<skip>*/
}
$h_sci_List.prototype = $c_sci_List.prototype;
$c_sci_List.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this)
});
$c_sci_List.prototype.zipWithIndex__O = (function() {
  return $f_sc_StrictOptimizedIterableOps__zipWithIndex__O(this)
});
$c_sci_List.prototype.stringPrefix__T = (function() {
  return "LinearSeq"
});
$c_sci_List.prototype.isDefinedAt__I__Z = (function(x) {
  return $f_sc_LinearSeqOps__isDefinedAt__I__Z(this, x)
});
$c_sci_List.prototype.apply__I__O = (function(n) {
  return $f_sc_LinearSeqOps__apply__I__O(this, n)
});
$c_sci_List.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_LinearSeqOps__foldLeft__O__F2__O(this, z, op)
});
$c_sci_List.prototype.sameElements__sc_IterableOnce__Z = (function(that) {
  return $f_sc_LinearSeqOps__sameElements__sc_IterableOnce__Z(this, that)
});
$c_sci_List.prototype.indexWhere__F1__I__I = (function(p, from) {
  return $f_sc_LinearSeqOps__indexWhere__F1__I__I(this, p, from)
});
$c_sci_List.prototype.iterableFactory__sc_SeqFactory = (function() {
  return $m_sci_List$()
});
$c_sci_List.prototype.$colon$colon$colon__sci_List__sci_List = (function(prefix) {
  if (this.isEmpty__Z()) {
    return prefix
  } else if (prefix.isEmpty__Z()) {
    return this
  } else {
    var result = new $c_sci_$colon$colon(prefix.head__O(), this);
    var curr = result;
    var that = $as_sci_List(prefix.tail__O());
    while ((!that.isEmpty__Z())) {
      var temp = new $c_sci_$colon$colon(that.head__O(), this);
      curr.sci_$colon$colon__f_next = temp;
      curr = temp;
      that = $as_sci_List(that.tail__O())
    };
    return result
  }
});
$c_sci_List.prototype.isEmpty__Z = (function() {
  return (this === $m_sci_Nil$())
});
$c_sci_List.prototype.prependedAll__sc_IterableOnce__sci_List = (function(prefix) {
  if ((prefix instanceof $c_sci_List)) {
    var x2 = $as_sci_List(prefix);
    return this.$colon$colon$colon__sci_List__sci_List(x2)
  };
  if ((prefix.knownSize__I() === 0)) {
    return this
  };
  if ((prefix instanceof $c_scm_ListBuffer)) {
    var x3 = $as_scm_ListBuffer(prefix);
    if (this.isEmpty__Z()) {
      return x3.toList__sci_List()
    }
  };
  var iter = prefix.iterator__sc_Iterator();
  if (iter.hasNext__Z()) {
    var result = new $c_sci_$colon$colon(iter.next__O(), this);
    var curr = result;
    while (iter.hasNext__Z()) {
      var temp = new $c_sci_$colon$colon(iter.next__O(), this);
      curr.sci_$colon$colon__f_next = temp;
      curr = temp
    };
    return result
  } else {
    return this
  }
});
$c_sci_List.prototype.appendedAll__sc_IterableOnce__sci_List = (function(suffix) {
  if ((suffix instanceof $c_sci_List)) {
    var x2 = $as_sci_List(suffix);
    return x2.$colon$colon$colon__sci_List__sci_List(this)
  } else {
    return $as_sci_List($f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O(this, suffix))
  }
});
$c_sci_List.prototype.map__F1__sci_List = (function(f) {
  if ((this === $m_sci_Nil$())) {
    return $m_sci_Nil$()
  } else {
    var h = new $c_sci_$colon$colon(f.apply__O__O(this.head__O()), $m_sci_Nil$());
    var t = h;
    var rest = $as_sci_List(this.tail__O());
    while ((rest !== $m_sci_Nil$())) {
      var nx = new $c_sci_$colon$colon(f.apply__O__O(rest.head__O()), $m_sci_Nil$());
      t.sci_$colon$colon__f_next = nx;
      t = nx;
      rest = $as_sci_List(rest.tail__O())
    };
    return h
  }
});
$c_sci_List.prototype.flatMap__F1__sci_List = (function(f) {
  var rest = this;
  var h = null;
  var t = null;
  while ((rest !== $m_sci_Nil$())) {
    var it = $as_sc_IterableOnce(f.apply__O__O(rest.head__O())).iterator__sc_Iterator();
    while (it.hasNext__Z()) {
      var nx = new $c_sci_$colon$colon(it.next__O(), $m_sci_Nil$());
      if ((t === null)) {
        h = nx
      } else {
        t.sci_$colon$colon__f_next = nx
      };
      t = nx
    };
    rest = $as_sci_List(rest.tail__O())
  };
  return ((h === null) ? $m_sci_Nil$() : h)
});
$c_sci_List.prototype.foreach__F1__V = (function(f) {
  var these = this;
  while ((!these.isEmpty__Z())) {
    f.apply__O__O(these.head__O());
    these = $as_sci_List(these.tail__O())
  }
});
$c_sci_List.prototype.length__I = (function() {
  var these = this;
  var len = 0;
  while ((!these.isEmpty__Z())) {
    len = ((1 + len) | 0);
    these = $as_sci_List(these.tail__O())
  };
  return len
});
$c_sci_List.prototype.lengthCompare__I__I = (function(len) {
  return ((len < 0) ? 1 : $p_sci_List__loop$2__I__sci_List__I__I(this, 0, this, len))
});
$c_sci_List.prototype.forall__F1__Z = (function(p) {
  var these = this;
  while ((!these.isEmpty__Z())) {
    if ((!$uZ(p.apply__O__O(these.head__O())))) {
      return false
    };
    these = $as_sci_List(these.tail__O())
  };
  return true
});
$c_sci_List.prototype.exists__F1__Z = (function(p) {
  var these = this;
  while ((!these.isEmpty__Z())) {
    if ($uZ(p.apply__O__O(these.head__O()))) {
      return true
    };
    these = $as_sci_List(these.tail__O())
  };
  return false
});
$c_sci_List.prototype.last__O = (function() {
  if (this.isEmpty__Z()) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "List.last")
  } else {
    var these = this;
    var scout = $as_sci_List(this.tail__O());
    while ((!scout.isEmpty__Z())) {
      these = scout;
      scout = $as_sci_List(scout.tail__O())
    };
    return these.head__O()
  }
});
$c_sci_List.prototype.className__T = (function() {
  return "List"
});
$c_sci_List.prototype.equals__O__Z = (function(o) {
  if ((o instanceof $c_sci_List)) {
    var x2 = $as_sci_List(o);
    return $p_sci_List__listEq$1__sci_List__sci_List__Z(this, this, x2)
  } else {
    return $f_sc_Seq__equals__O__Z(this, o)
  }
});
$c_sci_List.prototype.apply__O__O = (function(v1) {
  var n = $uI(v1);
  return $f_sc_LinearSeqOps__apply__I__O(this, n)
});
$c_sci_List.prototype.isDefinedAt__O__Z = (function(x) {
  var x$1 = $uI(x);
  return $f_sc_LinearSeqOps__isDefinedAt__I__Z(this, x$1)
});
$c_sci_List.prototype.drop__I__O = (function(n) {
  return $p_sc_StrictOptimizedLinearSeqOps__loop$2__I__sc_LinearSeq__sc_LinearSeq(this, n, this)
});
$c_sci_List.prototype.flatMap__F1__O = (function(f) {
  return this.flatMap__F1__sci_List(f)
});
$c_sci_List.prototype.map__F1__O = (function(f) {
  return this.map__F1__sci_List(f)
});
$c_sci_List.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return this.appendedAll__sc_IterableOnce__sci_List(suffix)
});
$c_sci_List.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sci_List$()
});
function $as_sci_List(obj) {
  return (((obj instanceof $c_sci_List) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.List"))
}
function $isArrayOf_sci_List(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_List)))
}
function $asArrayOf_sci_List(obj, depth) {
  return (($isArrayOf_sci_List(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.List;", depth))
}
/** @constructor */
function $c_sci_VectorImpl() {
  this.sci_Vector__f_prefix1 = null
}
$c_sci_VectorImpl.prototype = new $h_sci_Vector();
$c_sci_VectorImpl.prototype.constructor = $c_sci_VectorImpl;
/** @constructor */
function $h_sci_VectorImpl() {
  /*<skip>*/
}
$h_sci_VectorImpl.prototype = $c_sci_VectorImpl.prototype;
$c_sci_VectorImpl.prototype.slice__I__I__sci_Vector = (function(from, until) {
  var lo = ((from > 0) ? from : 0);
  var b = this.length__I();
  var hi = ((until < b) ? until : b);
  var newlen = ((hi - lo) | 0);
  return ((newlen === this.length__I()) ? this : ((hi <= lo) ? $m_sci_Vector0$() : this.slice0__I__I__sci_Vector(lo, hi)))
});
/** @constructor */
function $c_scm_ArraySeq$ofBoolean(array) {
  this.scm_ArraySeq$ofBoolean__f_array = null;
  this.scm_ArraySeq$ofBoolean__f_array = array
}
$c_scm_ArraySeq$ofBoolean.prototype = new $h_scm_ArraySeq();
$c_scm_ArraySeq$ofBoolean.prototype.constructor = $c_scm_ArraySeq$ofBoolean;
/** @constructor */
function $h_scm_ArraySeq$ofBoolean() {
  /*<skip>*/
}
$h_scm_ArraySeq$ofBoolean.prototype = $c_scm_ArraySeq$ofBoolean.prototype;
$c_scm_ArraySeq$ofBoolean.prototype.length__I = (function() {
  return this.scm_ArraySeq$ofBoolean__f_array.u.length
});
$c_scm_ArraySeq$ofBoolean.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.scm_ArraySeq$ofBoolean__f_array;
  return this$1.arrayHash$mZc$sp__AZ__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed)
});
$c_scm_ArraySeq$ofBoolean.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_scm_ArraySeq$ofBoolean)) {
    var x2 = $as_scm_ArraySeq$ofBoolean(that);
    var a = this.scm_ArraySeq$ofBoolean__f_array;
    var b = x2.scm_ArraySeq$ofBoolean__f_array;
    return $m_ju_Arrays$().equals__AZ__AZ__Z(a, b)
  } else {
    return $c_scm_ArraySeq.prototype.equals__O__Z.call(this, that)
  }
});
$c_scm_ArraySeq$ofBoolean.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcZ$sp(this.scm_ArraySeq$ofBoolean__f_array)
});
$c_scm_ArraySeq$ofBoolean.prototype.apply$mcZI$sp__I__Z = (function(index) {
  return this.scm_ArraySeq$ofBoolean__f_array.get(index)
});
$c_scm_ArraySeq$ofBoolean.prototype.apply__O__O = (function(v1) {
  var index = $uI(v1);
  return this.apply$mcZI$sp__I__Z(index)
});
$c_scm_ArraySeq$ofBoolean.prototype.apply__I__O = (function(i) {
  return this.apply$mcZI$sp__I__Z(i)
});
$c_scm_ArraySeq$ofBoolean.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$BooleanManifest$()
});
$c_scm_ArraySeq$ofBoolean.prototype.array__O = (function() {
  return this.scm_ArraySeq$ofBoolean__f_array
});
function $as_scm_ArraySeq$ofBoolean(obj) {
  return (((obj instanceof $c_scm_ArraySeq$ofBoolean) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.ArraySeq$ofBoolean"))
}
function $isArrayOf_scm_ArraySeq$ofBoolean(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArraySeq$ofBoolean)))
}
function $asArrayOf_scm_ArraySeq$ofBoolean(obj, depth) {
  return (($isArrayOf_scm_ArraySeq$ofBoolean(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.ArraySeq$ofBoolean;", depth))
}
var $d_scm_ArraySeq$ofBoolean = new $TypeData().initClass({
  scm_ArraySeq$ofBoolean: 0
}, false, "scala.collection.mutable.ArraySeq$ofBoolean", {
  scm_ArraySeq$ofBoolean: 1,
  scm_ArraySeq: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
});
$c_scm_ArraySeq$ofBoolean.prototype.$classData = $d_scm_ArraySeq$ofBoolean;
/** @constructor */
function $c_scm_ArraySeq$ofByte(array) {
  this.scm_ArraySeq$ofByte__f_array = null;
  this.scm_ArraySeq$ofByte__f_array = array
}
$c_scm_ArraySeq$ofByte.prototype = new $h_scm_ArraySeq();
$c_scm_ArraySeq$ofByte.prototype.constructor = $c_scm_ArraySeq$ofByte;
/** @constructor */
function $h_scm_ArraySeq$ofByte() {
  /*<skip>*/
}
$h_scm_ArraySeq$ofByte.prototype = $c_scm_ArraySeq$ofByte.prototype;
$c_scm_ArraySeq$ofByte.prototype.length__I = (function() {
  return this.scm_ArraySeq$ofByte__f_array.u.length
});
$c_scm_ArraySeq$ofByte.prototype.apply__I__B = (function(index) {
  return this.scm_ArraySeq$ofByte__f_array.get(index)
});
$c_scm_ArraySeq$ofByte.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.scm_ArraySeq$ofByte__f_array;
  return this$1.arrayHash$mBc$sp__AB__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed)
});
$c_scm_ArraySeq$ofByte.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_scm_ArraySeq$ofByte)) {
    var x2 = $as_scm_ArraySeq$ofByte(that);
    var a = this.scm_ArraySeq$ofByte__f_array;
    var b = x2.scm_ArraySeq$ofByte__f_array;
    return $m_ju_Arrays$().equals__AB__AB__Z(a, b)
  } else {
    return $c_scm_ArraySeq.prototype.equals__O__Z.call(this, that)
  }
});
$c_scm_ArraySeq$ofByte.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcB$sp(this.scm_ArraySeq$ofByte__f_array)
});
$c_scm_ArraySeq$ofByte.prototype.apply__O__O = (function(v1) {
  return this.apply__I__B($uI(v1))
});
$c_scm_ArraySeq$ofByte.prototype.apply__I__O = (function(i) {
  return this.apply__I__B(i)
});
$c_scm_ArraySeq$ofByte.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$ByteManifest$()
});
$c_scm_ArraySeq$ofByte.prototype.array__O = (function() {
  return this.scm_ArraySeq$ofByte__f_array
});
function $as_scm_ArraySeq$ofByte(obj) {
  return (((obj instanceof $c_scm_ArraySeq$ofByte) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.ArraySeq$ofByte"))
}
function $isArrayOf_scm_ArraySeq$ofByte(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArraySeq$ofByte)))
}
function $asArrayOf_scm_ArraySeq$ofByte(obj, depth) {
  return (($isArrayOf_scm_ArraySeq$ofByte(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.ArraySeq$ofByte;", depth))
}
var $d_scm_ArraySeq$ofByte = new $TypeData().initClass({
  scm_ArraySeq$ofByte: 0
}, false, "scala.collection.mutable.ArraySeq$ofByte", {
  scm_ArraySeq$ofByte: 1,
  scm_ArraySeq: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
});
$c_scm_ArraySeq$ofByte.prototype.$classData = $d_scm_ArraySeq$ofByte;
/** @constructor */
function $c_scm_ArraySeq$ofChar(array) {
  this.scm_ArraySeq$ofChar__f_array = null;
  this.scm_ArraySeq$ofChar__f_array = array
}
$c_scm_ArraySeq$ofChar.prototype = new $h_scm_ArraySeq();
$c_scm_ArraySeq$ofChar.prototype.constructor = $c_scm_ArraySeq$ofChar;
/** @constructor */
function $h_scm_ArraySeq$ofChar() {
  /*<skip>*/
}
$h_scm_ArraySeq$ofChar.prototype = $c_scm_ArraySeq$ofChar.prototype;
$c_scm_ArraySeq$ofChar.prototype.length__I = (function() {
  return this.scm_ArraySeq$ofChar__f_array.u.length
});
$c_scm_ArraySeq$ofChar.prototype.apply__I__C = (function(index) {
  return this.scm_ArraySeq$ofChar__f_array.get(index)
});
$c_scm_ArraySeq$ofChar.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.scm_ArraySeq$ofChar__f_array;
  return this$1.arrayHash$mCc$sp__AC__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed)
});
$c_scm_ArraySeq$ofChar.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_scm_ArraySeq$ofChar)) {
    var x2 = $as_scm_ArraySeq$ofChar(that);
    var a = this.scm_ArraySeq$ofChar__f_array;
    var b = x2.scm_ArraySeq$ofChar__f_array;
    return $m_ju_Arrays$().equals__AC__AC__Z(a, b)
  } else {
    return $c_scm_ArraySeq.prototype.equals__O__Z.call(this, that)
  }
});
$c_scm_ArraySeq$ofChar.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcC$sp(this.scm_ArraySeq$ofChar__f_array)
});
$c_scm_ArraySeq$ofChar.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(sb, start, sep, end) {
  var jsb = sb.scm_StringBuilder__f_underlying;
  if (($uI(start.length) !== 0)) {
    jsb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + jsb.jl_StringBuilder__f_java$lang$StringBuilder$$content) + start)
  };
  var len = this.scm_ArraySeq$ofChar__f_array.u.length;
  if ((len !== 0)) {
    if ((sep === "")) {
      jsb.append__AC__jl_StringBuilder(this.scm_ArraySeq$ofChar__f_array)
    } else {
      jsb.length__I();
      $uI(end.length);
      $uI(sep.length);
      var c = this.scm_ArraySeq$ofChar__f_array.get(0);
      var str = $as_T(String.fromCharCode(c));
      jsb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + jsb.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str);
      var i = 1;
      while ((i < len)) {
        jsb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + jsb.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
        var c$1 = this.scm_ArraySeq$ofChar__f_array.get(i);
        var str$1 = $as_T(String.fromCharCode(c$1));
        jsb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + jsb.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str$1);
        i = ((1 + i) | 0)
      }
    }
  };
  if (($uI(end.length) !== 0)) {
    jsb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + jsb.jl_StringBuilder__f_java$lang$StringBuilder$$content) + end)
  };
  return sb
});
$c_scm_ArraySeq$ofChar.prototype.apply__O__O = (function(v1) {
  return $bC(this.apply__I__C($uI(v1)))
});
$c_scm_ArraySeq$ofChar.prototype.apply__I__O = (function(i) {
  return $bC(this.apply__I__C(i))
});
$c_scm_ArraySeq$ofChar.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$CharManifest$()
});
$c_scm_ArraySeq$ofChar.prototype.array__O = (function() {
  return this.scm_ArraySeq$ofChar__f_array
});
function $as_scm_ArraySeq$ofChar(obj) {
  return (((obj instanceof $c_scm_ArraySeq$ofChar) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.ArraySeq$ofChar"))
}
function $isArrayOf_scm_ArraySeq$ofChar(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArraySeq$ofChar)))
}
function $asArrayOf_scm_ArraySeq$ofChar(obj, depth) {
  return (($isArrayOf_scm_ArraySeq$ofChar(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.ArraySeq$ofChar;", depth))
}
var $d_scm_ArraySeq$ofChar = new $TypeData().initClass({
  scm_ArraySeq$ofChar: 0
}, false, "scala.collection.mutable.ArraySeq$ofChar", {
  scm_ArraySeq$ofChar: 1,
  scm_ArraySeq: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
});
$c_scm_ArraySeq$ofChar.prototype.$classData = $d_scm_ArraySeq$ofChar;
/** @constructor */
function $c_scm_ArraySeq$ofDouble(array) {
  this.scm_ArraySeq$ofDouble__f_array = null;
  this.scm_ArraySeq$ofDouble__f_array = array
}
$c_scm_ArraySeq$ofDouble.prototype = new $h_scm_ArraySeq();
$c_scm_ArraySeq$ofDouble.prototype.constructor = $c_scm_ArraySeq$ofDouble;
/** @constructor */
function $h_scm_ArraySeq$ofDouble() {
  /*<skip>*/
}
$h_scm_ArraySeq$ofDouble.prototype = $c_scm_ArraySeq$ofDouble.prototype;
$c_scm_ArraySeq$ofDouble.prototype.length__I = (function() {
  return this.scm_ArraySeq$ofDouble__f_array.u.length
});
$c_scm_ArraySeq$ofDouble.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.scm_ArraySeq$ofDouble__f_array;
  return this$1.arrayHash$mDc$sp__AD__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed)
});
$c_scm_ArraySeq$ofDouble.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_scm_ArraySeq$ofDouble)) {
    var x2 = $as_scm_ArraySeq$ofDouble(that);
    var a = this.scm_ArraySeq$ofDouble__f_array;
    var b = x2.scm_ArraySeq$ofDouble__f_array;
    return $m_ju_Arrays$().equals__AD__AD__Z(a, b)
  } else {
    return $c_scm_ArraySeq.prototype.equals__O__Z.call(this, that)
  }
});
$c_scm_ArraySeq$ofDouble.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcD$sp(this.scm_ArraySeq$ofDouble__f_array)
});
$c_scm_ArraySeq$ofDouble.prototype.apply$mcDI$sp__I__D = (function(index) {
  return this.scm_ArraySeq$ofDouble__f_array.get(index)
});
$c_scm_ArraySeq$ofDouble.prototype.apply__O__O = (function(v1) {
  var index = $uI(v1);
  return this.apply$mcDI$sp__I__D(index)
});
$c_scm_ArraySeq$ofDouble.prototype.apply__I__O = (function(i) {
  return this.apply$mcDI$sp__I__D(i)
});
$c_scm_ArraySeq$ofDouble.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$DoubleManifest$()
});
$c_scm_ArraySeq$ofDouble.prototype.array__O = (function() {
  return this.scm_ArraySeq$ofDouble__f_array
});
function $as_scm_ArraySeq$ofDouble(obj) {
  return (((obj instanceof $c_scm_ArraySeq$ofDouble) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.ArraySeq$ofDouble"))
}
function $isArrayOf_scm_ArraySeq$ofDouble(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArraySeq$ofDouble)))
}
function $asArrayOf_scm_ArraySeq$ofDouble(obj, depth) {
  return (($isArrayOf_scm_ArraySeq$ofDouble(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.ArraySeq$ofDouble;", depth))
}
var $d_scm_ArraySeq$ofDouble = new $TypeData().initClass({
  scm_ArraySeq$ofDouble: 0
}, false, "scala.collection.mutable.ArraySeq$ofDouble", {
  scm_ArraySeq$ofDouble: 1,
  scm_ArraySeq: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
});
$c_scm_ArraySeq$ofDouble.prototype.$classData = $d_scm_ArraySeq$ofDouble;
/** @constructor */
function $c_scm_ArraySeq$ofFloat(array) {
  this.scm_ArraySeq$ofFloat__f_array = null;
  this.scm_ArraySeq$ofFloat__f_array = array
}
$c_scm_ArraySeq$ofFloat.prototype = new $h_scm_ArraySeq();
$c_scm_ArraySeq$ofFloat.prototype.constructor = $c_scm_ArraySeq$ofFloat;
/** @constructor */
function $h_scm_ArraySeq$ofFloat() {
  /*<skip>*/
}
$h_scm_ArraySeq$ofFloat.prototype = $c_scm_ArraySeq$ofFloat.prototype;
$c_scm_ArraySeq$ofFloat.prototype.length__I = (function() {
  return this.scm_ArraySeq$ofFloat__f_array.u.length
});
$c_scm_ArraySeq$ofFloat.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.scm_ArraySeq$ofFloat__f_array;
  return this$1.arrayHash$mFc$sp__AF__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed)
});
$c_scm_ArraySeq$ofFloat.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_scm_ArraySeq$ofFloat)) {
    var x2 = $as_scm_ArraySeq$ofFloat(that);
    var a = this.scm_ArraySeq$ofFloat__f_array;
    var b = x2.scm_ArraySeq$ofFloat__f_array;
    return $m_ju_Arrays$().equals__AF__AF__Z(a, b)
  } else {
    return $c_scm_ArraySeq.prototype.equals__O__Z.call(this, that)
  }
});
$c_scm_ArraySeq$ofFloat.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcF$sp(this.scm_ArraySeq$ofFloat__f_array)
});
$c_scm_ArraySeq$ofFloat.prototype.apply$mcFI$sp__I__F = (function(index) {
  return this.scm_ArraySeq$ofFloat__f_array.get(index)
});
$c_scm_ArraySeq$ofFloat.prototype.apply__O__O = (function(v1) {
  var index = $uI(v1);
  return this.apply$mcFI$sp__I__F(index)
});
$c_scm_ArraySeq$ofFloat.prototype.apply__I__O = (function(i) {
  return this.apply$mcFI$sp__I__F(i)
});
$c_scm_ArraySeq$ofFloat.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$FloatManifest$()
});
$c_scm_ArraySeq$ofFloat.prototype.array__O = (function() {
  return this.scm_ArraySeq$ofFloat__f_array
});
function $as_scm_ArraySeq$ofFloat(obj) {
  return (((obj instanceof $c_scm_ArraySeq$ofFloat) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.ArraySeq$ofFloat"))
}
function $isArrayOf_scm_ArraySeq$ofFloat(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArraySeq$ofFloat)))
}
function $asArrayOf_scm_ArraySeq$ofFloat(obj, depth) {
  return (($isArrayOf_scm_ArraySeq$ofFloat(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.ArraySeq$ofFloat;", depth))
}
var $d_scm_ArraySeq$ofFloat = new $TypeData().initClass({
  scm_ArraySeq$ofFloat: 0
}, false, "scala.collection.mutable.ArraySeq$ofFloat", {
  scm_ArraySeq$ofFloat: 1,
  scm_ArraySeq: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
});
$c_scm_ArraySeq$ofFloat.prototype.$classData = $d_scm_ArraySeq$ofFloat;
/** @constructor */
function $c_scm_ArraySeq$ofInt(array) {
  this.scm_ArraySeq$ofInt__f_array = null;
  this.scm_ArraySeq$ofInt__f_array = array
}
$c_scm_ArraySeq$ofInt.prototype = new $h_scm_ArraySeq();
$c_scm_ArraySeq$ofInt.prototype.constructor = $c_scm_ArraySeq$ofInt;
/** @constructor */
function $h_scm_ArraySeq$ofInt() {
  /*<skip>*/
}
$h_scm_ArraySeq$ofInt.prototype = $c_scm_ArraySeq$ofInt.prototype;
$c_scm_ArraySeq$ofInt.prototype.length__I = (function() {
  return this.scm_ArraySeq$ofInt__f_array.u.length
});
$c_scm_ArraySeq$ofInt.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.scm_ArraySeq$ofInt__f_array;
  return this$1.arrayHash$mIc$sp__AI__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed)
});
$c_scm_ArraySeq$ofInt.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_scm_ArraySeq$ofInt)) {
    var x2 = $as_scm_ArraySeq$ofInt(that);
    var a = this.scm_ArraySeq$ofInt__f_array;
    var b = x2.scm_ArraySeq$ofInt__f_array;
    return $m_ju_Arrays$().equals__AI__AI__Z(a, b)
  } else {
    return $c_scm_ArraySeq.prototype.equals__O__Z.call(this, that)
  }
});
$c_scm_ArraySeq$ofInt.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcI$sp(this.scm_ArraySeq$ofInt__f_array)
});
$c_scm_ArraySeq$ofInt.prototype.apply$mcII$sp__I__I = (function(index) {
  return this.scm_ArraySeq$ofInt__f_array.get(index)
});
$c_scm_ArraySeq$ofInt.prototype.apply__O__O = (function(v1) {
  var index = $uI(v1);
  return this.apply$mcII$sp__I__I(index)
});
$c_scm_ArraySeq$ofInt.prototype.apply__I__O = (function(i) {
  return this.apply$mcII$sp__I__I(i)
});
$c_scm_ArraySeq$ofInt.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$IntManifest$()
});
$c_scm_ArraySeq$ofInt.prototype.array__O = (function() {
  return this.scm_ArraySeq$ofInt__f_array
});
function $as_scm_ArraySeq$ofInt(obj) {
  return (((obj instanceof $c_scm_ArraySeq$ofInt) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.ArraySeq$ofInt"))
}
function $isArrayOf_scm_ArraySeq$ofInt(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArraySeq$ofInt)))
}
function $asArrayOf_scm_ArraySeq$ofInt(obj, depth) {
  return (($isArrayOf_scm_ArraySeq$ofInt(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.ArraySeq$ofInt;", depth))
}
var $d_scm_ArraySeq$ofInt = new $TypeData().initClass({
  scm_ArraySeq$ofInt: 0
}, false, "scala.collection.mutable.ArraySeq$ofInt", {
  scm_ArraySeq$ofInt: 1,
  scm_ArraySeq: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
});
$c_scm_ArraySeq$ofInt.prototype.$classData = $d_scm_ArraySeq$ofInt;
/** @constructor */
function $c_scm_ArraySeq$ofLong(array) {
  this.scm_ArraySeq$ofLong__f_array = null;
  this.scm_ArraySeq$ofLong__f_array = array
}
$c_scm_ArraySeq$ofLong.prototype = new $h_scm_ArraySeq();
$c_scm_ArraySeq$ofLong.prototype.constructor = $c_scm_ArraySeq$ofLong;
/** @constructor */
function $h_scm_ArraySeq$ofLong() {
  /*<skip>*/
}
$h_scm_ArraySeq$ofLong.prototype = $c_scm_ArraySeq$ofLong.prototype;
$c_scm_ArraySeq$ofLong.prototype.length__I = (function() {
  return this.scm_ArraySeq$ofLong__f_array.u.length
});
$c_scm_ArraySeq$ofLong.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.scm_ArraySeq$ofLong__f_array;
  return this$1.arrayHash$mJc$sp__AJ__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed)
});
$c_scm_ArraySeq$ofLong.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_scm_ArraySeq$ofLong)) {
    var x2 = $as_scm_ArraySeq$ofLong(that);
    var a = this.scm_ArraySeq$ofLong__f_array;
    var b = x2.scm_ArraySeq$ofLong__f_array;
    return $m_ju_Arrays$().equals__AJ__AJ__Z(a, b)
  } else {
    return $c_scm_ArraySeq.prototype.equals__O__Z.call(this, that)
  }
});
$c_scm_ArraySeq$ofLong.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcJ$sp(this.scm_ArraySeq$ofLong__f_array)
});
$c_scm_ArraySeq$ofLong.prototype.apply$mcJI$sp__I__J = (function(index) {
  return this.scm_ArraySeq$ofLong__f_array.get(index)
});
$c_scm_ArraySeq$ofLong.prototype.apply__O__O = (function(v1) {
  var index = $uI(v1);
  return this.apply$mcJI$sp__I__J(index)
});
$c_scm_ArraySeq$ofLong.prototype.apply__I__O = (function(i) {
  return this.apply$mcJI$sp__I__J(i)
});
$c_scm_ArraySeq$ofLong.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$LongManifest$()
});
$c_scm_ArraySeq$ofLong.prototype.array__O = (function() {
  return this.scm_ArraySeq$ofLong__f_array
});
function $as_scm_ArraySeq$ofLong(obj) {
  return (((obj instanceof $c_scm_ArraySeq$ofLong) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.ArraySeq$ofLong"))
}
function $isArrayOf_scm_ArraySeq$ofLong(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArraySeq$ofLong)))
}
function $asArrayOf_scm_ArraySeq$ofLong(obj, depth) {
  return (($isArrayOf_scm_ArraySeq$ofLong(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.ArraySeq$ofLong;", depth))
}
var $d_scm_ArraySeq$ofLong = new $TypeData().initClass({
  scm_ArraySeq$ofLong: 0
}, false, "scala.collection.mutable.ArraySeq$ofLong", {
  scm_ArraySeq$ofLong: 1,
  scm_ArraySeq: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
});
$c_scm_ArraySeq$ofLong.prototype.$classData = $d_scm_ArraySeq$ofLong;
/** @constructor */
function $c_scm_ArraySeq$ofRef(array) {
  this.scm_ArraySeq$ofRef__f_array = null;
  this.scm_ArraySeq$ofRef__f_array = array
}
$c_scm_ArraySeq$ofRef.prototype = new $h_scm_ArraySeq();
$c_scm_ArraySeq$ofRef.prototype.constructor = $c_scm_ArraySeq$ofRef;
/** @constructor */
function $h_scm_ArraySeq$ofRef() {
  /*<skip>*/
}
$h_scm_ArraySeq$ofRef.prototype = $c_scm_ArraySeq$ofRef.prototype;
$c_scm_ArraySeq$ofRef.prototype.elemTag__s_reflect_ClassTag = (function() {
  var $$x1 = $m_s_reflect_ClassTag$();
  var this$1 = this.scm_ArraySeq$ofRef__f_array;
  return $$x1.apply__jl_Class__s_reflect_ClassTag($objectGetClass(this$1).getComponentType__jl_Class())
});
$c_scm_ArraySeq$ofRef.prototype.length__I = (function() {
  return this.scm_ArraySeq$ofRef__f_array.u.length
});
$c_scm_ArraySeq$ofRef.prototype.apply__I__O = (function(index) {
  return this.scm_ArraySeq$ofRef__f_array.get(index)
});
$c_scm_ArraySeq$ofRef.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.scm_ArraySeq$ofRef__f_array;
  return this$1.arrayHash__O__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed)
});
$c_scm_ArraySeq$ofRef.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_scm_ArraySeq$ofRef)) {
    var x2 = $as_scm_ArraySeq$ofRef(that);
    return $m_s_Array$().equals__AO__AO__Z(this.scm_ArraySeq$ofRef__f_array, x2.scm_ArraySeq$ofRef__f_array)
  } else {
    return $c_scm_ArraySeq.prototype.equals__O__Z.call(this, that)
  }
});
$c_scm_ArraySeq$ofRef.prototype.iterator__sc_Iterator = (function() {
  return $ct_sc_ArrayOps$ArrayIterator__O__(new $c_sc_ArrayOps$ArrayIterator(), this.scm_ArraySeq$ofRef__f_array)
});
$c_scm_ArraySeq$ofRef.prototype.apply__O__O = (function(v1) {
  return this.apply__I__O($uI(v1))
});
$c_scm_ArraySeq$ofRef.prototype.array__O = (function() {
  return this.scm_ArraySeq$ofRef__f_array
});
function $as_scm_ArraySeq$ofRef(obj) {
  return (((obj instanceof $c_scm_ArraySeq$ofRef) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.ArraySeq$ofRef"))
}
function $isArrayOf_scm_ArraySeq$ofRef(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArraySeq$ofRef)))
}
function $asArrayOf_scm_ArraySeq$ofRef(obj, depth) {
  return (($isArrayOf_scm_ArraySeq$ofRef(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.ArraySeq$ofRef;", depth))
}
var $d_scm_ArraySeq$ofRef = new $TypeData().initClass({
  scm_ArraySeq$ofRef: 0
}, false, "scala.collection.mutable.ArraySeq$ofRef", {
  scm_ArraySeq$ofRef: 1,
  scm_ArraySeq: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
});
$c_scm_ArraySeq$ofRef.prototype.$classData = $d_scm_ArraySeq$ofRef;
/** @constructor */
function $c_scm_ArraySeq$ofShort(array) {
  this.scm_ArraySeq$ofShort__f_array = null;
  this.scm_ArraySeq$ofShort__f_array = array
}
$c_scm_ArraySeq$ofShort.prototype = new $h_scm_ArraySeq();
$c_scm_ArraySeq$ofShort.prototype.constructor = $c_scm_ArraySeq$ofShort;
/** @constructor */
function $h_scm_ArraySeq$ofShort() {
  /*<skip>*/
}
$h_scm_ArraySeq$ofShort.prototype = $c_scm_ArraySeq$ofShort.prototype;
$c_scm_ArraySeq$ofShort.prototype.length__I = (function() {
  return this.scm_ArraySeq$ofShort__f_array.u.length
});
$c_scm_ArraySeq$ofShort.prototype.apply__I__S = (function(index) {
  return this.scm_ArraySeq$ofShort__f_array.get(index)
});
$c_scm_ArraySeq$ofShort.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.scm_ArraySeq$ofShort__f_array;
  return this$1.arrayHash$mSc$sp__AS__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed)
});
$c_scm_ArraySeq$ofShort.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_scm_ArraySeq$ofShort)) {
    var x2 = $as_scm_ArraySeq$ofShort(that);
    var a = this.scm_ArraySeq$ofShort__f_array;
    var b = x2.scm_ArraySeq$ofShort__f_array;
    return $m_ju_Arrays$().equals__AS__AS__Z(a, b)
  } else {
    return $c_scm_ArraySeq.prototype.equals__O__Z.call(this, that)
  }
});
$c_scm_ArraySeq$ofShort.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcS$sp(this.scm_ArraySeq$ofShort__f_array)
});
$c_scm_ArraySeq$ofShort.prototype.apply__O__O = (function(v1) {
  return this.apply__I__S($uI(v1))
});
$c_scm_ArraySeq$ofShort.prototype.apply__I__O = (function(i) {
  return this.apply__I__S(i)
});
$c_scm_ArraySeq$ofShort.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$ShortManifest$()
});
$c_scm_ArraySeq$ofShort.prototype.array__O = (function() {
  return this.scm_ArraySeq$ofShort__f_array
});
function $as_scm_ArraySeq$ofShort(obj) {
  return (((obj instanceof $c_scm_ArraySeq$ofShort) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.ArraySeq$ofShort"))
}
function $isArrayOf_scm_ArraySeq$ofShort(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArraySeq$ofShort)))
}
function $asArrayOf_scm_ArraySeq$ofShort(obj, depth) {
  return (($isArrayOf_scm_ArraySeq$ofShort(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.ArraySeq$ofShort;", depth))
}
var $d_scm_ArraySeq$ofShort = new $TypeData().initClass({
  scm_ArraySeq$ofShort: 0
}, false, "scala.collection.mutable.ArraySeq$ofShort", {
  scm_ArraySeq$ofShort: 1,
  scm_ArraySeq: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
});
$c_scm_ArraySeq$ofShort.prototype.$classData = $d_scm_ArraySeq$ofShort;
/** @constructor */
function $c_scm_ArraySeq$ofUnit(array) {
  this.scm_ArraySeq$ofUnit__f_array = null;
  this.scm_ArraySeq$ofUnit__f_array = array
}
$c_scm_ArraySeq$ofUnit.prototype = new $h_scm_ArraySeq();
$c_scm_ArraySeq$ofUnit.prototype.constructor = $c_scm_ArraySeq$ofUnit;
/** @constructor */
function $h_scm_ArraySeq$ofUnit() {
  /*<skip>*/
}
$h_scm_ArraySeq$ofUnit.prototype = $c_scm_ArraySeq$ofUnit.prototype;
$c_scm_ArraySeq$ofUnit.prototype.length__I = (function() {
  return this.scm_ArraySeq$ofUnit__f_array.u.length
});
$c_scm_ArraySeq$ofUnit.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.scm_ArraySeq$ofUnit__f_array;
  return this$1.arrayHash$mVc$sp__Ajl_Void__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed)
});
$c_scm_ArraySeq$ofUnit.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_scm_ArraySeq$ofUnit)) {
    var x2 = $as_scm_ArraySeq$ofUnit(that);
    return (this.scm_ArraySeq$ofUnit__f_array.u.length === x2.scm_ArraySeq$ofUnit__f_array.u.length)
  } else {
    return $c_scm_ArraySeq.prototype.equals__O__Z.call(this, that)
  }
});
$c_scm_ArraySeq$ofUnit.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcV$sp(this.scm_ArraySeq$ofUnit__f_array)
});
$c_scm_ArraySeq$ofUnit.prototype.apply$mcVI$sp__I__V = (function(index) {
  this.scm_ArraySeq$ofUnit__f_array.get(index)
});
$c_scm_ArraySeq$ofUnit.prototype.apply__O__O = (function(v1) {
  var index = $uI(v1);
  this.apply$mcVI$sp__I__V(index)
});
$c_scm_ArraySeq$ofUnit.prototype.apply__I__O = (function(i) {
  this.apply$mcVI$sp__I__V(i)
});
$c_scm_ArraySeq$ofUnit.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$UnitManifest$()
});
$c_scm_ArraySeq$ofUnit.prototype.array__O = (function() {
  return this.scm_ArraySeq$ofUnit__f_array
});
function $as_scm_ArraySeq$ofUnit(obj) {
  return (((obj instanceof $c_scm_ArraySeq$ofUnit) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.ArraySeq$ofUnit"))
}
function $isArrayOf_scm_ArraySeq$ofUnit(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArraySeq$ofUnit)))
}
function $asArrayOf_scm_ArraySeq$ofUnit(obj, depth) {
  return (($isArrayOf_scm_ArraySeq$ofUnit(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.ArraySeq$ofUnit;", depth))
}
var $d_scm_ArraySeq$ofUnit = new $TypeData().initClass({
  scm_ArraySeq$ofUnit: 0
}, false, "scala.collection.mutable.ArraySeq$ofUnit", {
  scm_ArraySeq$ofUnit: 1,
  scm_ArraySeq: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
});
$c_scm_ArraySeq$ofUnit.prototype.$classData = $d_scm_ArraySeq$ofUnit;
function $p_scm_HashMap__put0__O__O__I__Z__s_Some($thiz, key, value, hash, getOld) {
  if ((((1 + $thiz.scm_HashMap__f_contentSize) | 0) >= $thiz.scm_HashMap__f_threshold)) {
    $p_scm_HashMap__growTable__I__V($thiz, ($thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u.length << 1))
  };
  var idx = (hash & (((-1) + $thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u.length) | 0));
  return $p_scm_HashMap__put0__O__O__Z__I__I__s_Some($thiz, key, value, getOld, hash, idx)
}
function $p_scm_HashMap__put0__O__O__Z__s_Some($thiz, key, value, getOld) {
  if ((((1 + $thiz.scm_HashMap__f_contentSize) | 0) >= $thiz.scm_HashMap__f_threshold)) {
    $p_scm_HashMap__growTable__I__V($thiz, ($thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u.length << 1))
  };
  var originalHash = $m_sr_Statics$().anyHash__O__I(key);
  var hash = (originalHash ^ ((originalHash >>> 16) | 0));
  var idx = (hash & (((-1) + $thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u.length) | 0));
  return $p_scm_HashMap__put0__O__O__Z__I__I__s_Some($thiz, key, value, getOld, hash, idx)
}
function $p_scm_HashMap__put0__O__O__Z__I__I__s_Some($thiz, key, value, getOld, hash, idx) {
  var x1 = $thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table.get(idx);
  if ((x1 === null)) {
    $thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table.set(idx, new $c_scm_HashMap$Node(key, hash, value, null))
  } else {
    var prev = null;
    var n = x1;
    while (((n !== null) && (n.scm_HashMap$Node__f__hash <= hash))) {
      if (((n.scm_HashMap$Node__f__hash === hash) && $m_sr_BoxesRunTime$().equals__O__O__Z(key, n.scm_HashMap$Node__f__key))) {
        var old = n.scm_HashMap$Node__f__value;
        n.scm_HashMap$Node__f__value = value;
        return (getOld ? new $c_s_Some(old) : null)
      };
      prev = n;
      n = n.scm_HashMap$Node__f__next
    };
    if ((prev === null)) {
      $thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table.set(idx, new $c_scm_HashMap$Node(key, hash, value, x1))
    } else {
      prev.scm_HashMap$Node__f__next = new $c_scm_HashMap$Node(key, hash, value, prev.scm_HashMap$Node__f__next)
    }
  };
  $thiz.scm_HashMap__f_contentSize = ((1 + $thiz.scm_HashMap__f_contentSize) | 0);
  return null
}
function $p_scm_HashMap__growTable__I__V($thiz, newlen) {
  if ((newlen < 0)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O($ct_jl_RuntimeException__T__(new $c_jl_RuntimeException(), (("new HashMap table size " + newlen) + " exceeds maximum")))
  };
  var oldlen = $thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u.length;
  $thiz.scm_HashMap__f_threshold = $p_scm_HashMap__newThreshold__I__I($thiz, newlen);
  if (($thiz.scm_HashMap__f_contentSize === 0)) {
    $thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table = new ($d_scm_HashMap$Node.getArrayOf().constr)(newlen)
  } else {
    var original = $thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table;
    $thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table = $asArrayOf_scm_HashMap$Node($m_ju_Arrays$().copyOf__AO__I__AO(original, newlen), 1);
    var preLow = new $c_scm_HashMap$Node(null, 0, null, null);
    var preHigh = new $c_scm_HashMap$Node(null, 0, null, null);
    while ((oldlen < newlen)) {
      var i = 0;
      while ((i < oldlen)) {
        var old = $thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table.get(i);
        if ((old !== null)) {
          preLow.scm_HashMap$Node__f__next = null;
          preHigh.scm_HashMap$Node__f__next = null;
          var lastLow = preLow;
          var lastHigh = preHigh;
          var n = old;
          while ((n !== null)) {
            var next = n.scm_HashMap$Node__f__next;
            if (((n.scm_HashMap$Node__f__hash & oldlen) === 0)) {
              lastLow.scm_HashMap$Node__f__next = n;
              lastLow = n
            } else {
              lastHigh.scm_HashMap$Node__f__next = n;
              lastHigh = n
            };
            n = next
          };
          lastLow.scm_HashMap$Node__f__next = null;
          if ((old !== preLow.scm_HashMap$Node__f__next)) {
            $thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table.set(i, preLow.scm_HashMap$Node__f__next)
          };
          if ((preHigh.scm_HashMap$Node__f__next !== null)) {
            $thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table.set(((i + oldlen) | 0), preHigh.scm_HashMap$Node__f__next);
            lastHigh.scm_HashMap$Node__f__next = null
          }
        };
        i = ((1 + i) | 0)
      };
      oldlen = (oldlen << 1)
    }
  }
}
function $p_scm_HashMap__tableSizeFor__I__I($thiz, capacity) {
  var x = (((-1) + capacity) | 0);
  var i = ((x > 4) ? x : 4);
  var x$1 = ((((-2147483648) >> $clz32(i)) & i) << 1);
  return ((x$1 < 1073741824) ? x$1 : 1073741824)
}
function $p_scm_HashMap__newThreshold__I__I($thiz, size) {
  return $doubleToInt((size * $thiz.scm_HashMap__f_loadFactor))
}
function $ct_scm_HashMap__I__D__($thiz, initialCapacity, loadFactor) {
  $thiz.scm_HashMap__f_loadFactor = loadFactor;
  $thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table = new ($d_scm_HashMap$Node.getArrayOf().constr)($p_scm_HashMap__tableSizeFor__I__I($thiz, initialCapacity));
  $thiz.scm_HashMap__f_threshold = $p_scm_HashMap__newThreshold__I__I($thiz, $thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u.length);
  $thiz.scm_HashMap__f_contentSize = 0;
  return $thiz
}
function $ct_scm_HashMap__($thiz) {
  $ct_scm_HashMap__I__D__($thiz, 16, 0.75);
  return $thiz
}
/** @constructor */
function $c_scm_HashMap() {
  this.scm_HashMap__f_loadFactor = 0.0;
  this.scm_HashMap__f_scala$collection$mutable$HashMap$$table = null;
  this.scm_HashMap__f_threshold = 0;
  this.scm_HashMap__f_contentSize = 0
}
$c_scm_HashMap.prototype = new $h_scm_AbstractMap();
$c_scm_HashMap.prototype.constructor = $c_scm_HashMap;
/** @constructor */
function $h_scm_HashMap() {
  /*<skip>*/
}
$h_scm_HashMap.prototype = $c_scm_HashMap.prototype;
$c_scm_HashMap.prototype.map__F1__sc_IterableOps = (function(f) {
  return $f_sc_StrictOptimizedMapOps__map__F1__sc_IterableOps(this, f)
});
$c_scm_HashMap.prototype.concat__sc_IterableOnce__sc_IterableOps = (function(suffix) {
  return $f_sc_StrictOptimizedMapOps__concat__sc_IterableOnce__sc_IterableOps(this, suffix)
});
$c_scm_HashMap.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f)
});
$c_scm_HashMap.prototype.size__I = (function() {
  return this.scm_HashMap__f_contentSize
});
$c_scm_HashMap.prototype.contains__O__Z = (function(key) {
  var originalHash = $m_sr_Statics$().anyHash__O__I(key);
  var hash = (originalHash ^ ((originalHash >>> 16) | 0));
  var x1 = this.scm_HashMap__f_scala$collection$mutable$HashMap$$table.get((hash & (((-1) + this.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u.length) | 0)));
  return (((x1 === null) ? null : x1.findNode__O__I__scm_HashMap$Node(key, hash)) !== null)
});
$c_scm_HashMap.prototype.sizeHint__I__V = (function(size) {
  var target = $p_scm_HashMap__tableSizeFor__I__I(this, $doubleToInt((((1 + size) | 0) / this.scm_HashMap__f_loadFactor)));
  if ((target > this.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u.length)) {
    $p_scm_HashMap__growTable__I__V(this, target)
  }
});
$c_scm_HashMap.prototype.addAll__sc_IterableOnce__scm_HashMap = (function(xs) {
  this.sizeHint__I__V(xs.knownSize__I());
  if ((xs instanceof $c_sci_HashMap)) {
    var x2 = $as_sci_HashMap(xs);
    var f = new $c_sjsr_AnonFunction3((function(this$1) {
      return (function(k$2, v$2, h$2) {
        var h = $uI(h$2);
        $p_scm_HashMap__put0__O__O__I__Z__s_Some(this$1, k$2, v$2, (h ^ ((h >>> 16) | 0)), false)
      })
    })(this));
    x2.sci_HashMap__f_rootNode.foreachWithHash__F3__V(f);
    return this
  } else if ((xs instanceof $c_scm_HashMap)) {
    var x3 = $as_scm_HashMap(xs);
    var iter = x3.nodeIterator__sc_Iterator();
    while (iter.hasNext__Z()) {
      var next = $as_scm_HashMap$Node(iter.next__O());
      $p_scm_HashMap__put0__O__O__I__Z__s_Some(this, next.scm_HashMap$Node__f__key, next.scm_HashMap$Node__f__value, next.scm_HashMap$Node__f__hash, false)
    };
    return this
  } else if ($is_scm_Map(xs)) {
    var x4 = $as_scm_Map(xs);
    x4.foreachEntry__F2__V(new $c_sjsr_AnonFunction2((function(this$2) {
      return (function(key$2, value$2) {
        var originalHash = $m_sr_Statics$().anyHash__O__I(key$2);
        return $p_scm_HashMap__put0__O__O__I__Z__s_Some(this$2, key$2, value$2, (originalHash ^ ((originalHash >>> 16) | 0)), false)
      })
    })(this)));
    return this
  } else {
    return $as_scm_HashMap($f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs))
  }
});
$c_scm_HashMap.prototype.iterator__sc_Iterator = (function() {
  return ((this.scm_HashMap__f_contentSize === 0) ? $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty : new $c_scm_HashMap$$anon$1(this))
});
$c_scm_HashMap.prototype.nodeIterator__sc_Iterator = (function() {
  return ((this.scm_HashMap__f_contentSize === 0) ? $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty : new $c_scm_HashMap$$anon$4(this))
});
$c_scm_HashMap.prototype.get__O__s_Option = (function(key) {
  var originalHash = $m_sr_Statics$().anyHash__O__I(key);
  var hash = (originalHash ^ ((originalHash >>> 16) | 0));
  var x1 = this.scm_HashMap__f_scala$collection$mutable$HashMap$$table.get((hash & (((-1) + this.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u.length) | 0)));
  var x1$1 = ((x1 === null) ? null : x1.findNode__O__I__scm_HashMap$Node(key, hash));
  return ((x1$1 === null) ? $m_s_None$() : new $c_s_Some(x1$1.scm_HashMap$Node__f__value))
});
$c_scm_HashMap.prototype.apply__O__O = (function(key) {
  var originalHash = $m_sr_Statics$().anyHash__O__I(key);
  var hash = (originalHash ^ ((originalHash >>> 16) | 0));
  var x1 = this.scm_HashMap__f_scala$collection$mutable$HashMap$$table.get((hash & (((-1) + this.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u.length) | 0)));
  var x1$1 = ((x1 === null) ? null : x1.findNode__O__I__scm_HashMap$Node(key, hash));
  return ((x1$1 === null) ? $f_sc_MapOps__default__O__O(this, key) : x1$1.scm_HashMap$Node__f__value)
});
$c_scm_HashMap.prototype.getOrElse__O__F0__O = (function(key, default$1) {
  var x = $objectGetClass(this);
  if ((!(x === $d_scm_HashMap.getClassOf()))) {
    return $f_sc_MapOps__getOrElse__O__F0__O(this, key, default$1)
  } else {
    var originalHash = $m_sr_Statics$().anyHash__O__I(key);
    var hash = (originalHash ^ ((originalHash >>> 16) | 0));
    var x1 = this.scm_HashMap__f_scala$collection$mutable$HashMap$$table.get((hash & (((-1) + this.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u.length) | 0)));
    var nd = ((x1 === null) ? null : x1.findNode__O__I__scm_HashMap$Node(key, hash));
    return ((nd === null) ? default$1.apply__O() : nd.scm_HashMap$Node__f__value)
  }
});
$c_scm_HashMap.prototype.getOrElseUpdate__O__F0__O = (function(key, defaultValue) {
  var x = $objectGetClass(this);
  if ((!(x === $d_scm_HashMap.getClassOf()))) {
    return $f_scm_MapOps__getOrElseUpdate__O__F0__O(this, key, defaultValue)
  } else {
    var originalHash = $m_sr_Statics$().anyHash__O__I(key);
    var hash = (originalHash ^ ((originalHash >>> 16) | 0));
    var idx = (hash & (((-1) + this.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u.length) | 0));
    var x1 = this.scm_HashMap__f_scala$collection$mutable$HashMap$$table.get(idx);
    var nd = ((x1 === null) ? null : x1.findNode__O__I__scm_HashMap$Node(key, hash));
    if ((nd !== null)) {
      return nd.scm_HashMap$Node__f__value
    } else {
      var table0 = this.scm_HashMap__f_scala$collection$mutable$HashMap$$table;
      var default$1 = defaultValue.apply__O();
      if ((((1 + this.scm_HashMap__f_contentSize) | 0) >= this.scm_HashMap__f_threshold)) {
        $p_scm_HashMap__growTable__I__V(this, (this.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u.length << 1))
      };
      var newIdx = ((table0 === this.scm_HashMap__f_scala$collection$mutable$HashMap$$table) ? idx : (hash & (((-1) + this.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u.length) | 0)));
      $p_scm_HashMap__put0__O__O__Z__I__I__s_Some(this, key, default$1, false, hash, newIdx);
      return default$1
    }
  }
});
$c_scm_HashMap.prototype.put__O__O__s_Option = (function(key, value) {
  var x1 = $p_scm_HashMap__put0__O__O__Z__s_Some(this, key, value, true);
  return ((x1 === null) ? $m_s_None$() : x1)
});
$c_scm_HashMap.prototype.update__O__O__V = (function(key, value) {
  $p_scm_HashMap__put0__O__O__Z__s_Some(this, key, value, false)
});
$c_scm_HashMap.prototype.addOne__T2__scm_HashMap = (function(elem) {
  $p_scm_HashMap__put0__O__O__Z__s_Some(this, elem._1__O(), elem._2__O(), false);
  return this
});
$c_scm_HashMap.prototype.knownSize__I = (function() {
  return this.scm_HashMap__f_contentSize
});
$c_scm_HashMap.prototype.isEmpty__Z = (function() {
  return (this.scm_HashMap__f_contentSize === 0)
});
$c_scm_HashMap.prototype.foreach__F1__V = (function(f) {
  var len = this.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u.length;
  var i = 0;
  while ((i < len)) {
    var n = this.scm_HashMap__f_scala$collection$mutable$HashMap$$table.get(i);
    if ((n !== null)) {
      n.foreach__F1__V(f)
    };
    i = ((1 + i) | 0)
  }
});
$c_scm_HashMap.prototype.mapFactory__sc_MapFactory = (function() {
  return $m_scm_HashMap$()
});
$c_scm_HashMap.prototype.stringPrefix__T = (function() {
  return "HashMap"
});
$c_scm_HashMap.prototype.hashCode__I = (function() {
  if (this.isEmpty__Z()) {
    return $m_s_util_hashing_MurmurHash3$().s_util_hashing_MurmurHash3$__f_emptyMapHash
  } else {
    var tupleHashIterator = new $c_scm_HashMap$$anon$5(this);
    return $m_s_util_hashing_MurmurHash3$().unorderedHash__sc_IterableOnce__I__I(tupleHashIterator, $m_s_util_hashing_MurmurHash3$().s_util_hashing_MurmurHash3$__f_mapSeed)
  }
});
$c_scm_HashMap.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__T2__scm_HashMap($as_T2(elem))
});
$c_scm_HashMap.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return this.addAll__sc_IterableOnce__scm_HashMap(xs)
});
function $as_scm_HashMap(obj) {
  return (((obj instanceof $c_scm_HashMap) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.HashMap"))
}
function $isArrayOf_scm_HashMap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_HashMap)))
}
function $asArrayOf_scm_HashMap(obj, depth) {
  return (($isArrayOf_scm_HashMap(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.HashMap;", depth))
}
var $d_scm_HashMap = new $TypeData().initClass({
  scm_HashMap: 0
}, false, "scala.collection.mutable.HashMap", {
  scm_HashMap: 1,
  scm_AbstractMap: 1,
  sc_AbstractMap: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Map: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_MapFactoryDefaults: 1,
  s_Equals: 1,
  scm_Map: 1,
  scm_Iterable: 1,
  scm_MapOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  scm_Shrinkable: 1,
  sc_StrictOptimizedIterableOps: 1,
  sc_StrictOptimizedMapOps: 1,
  Ljava_io_Serializable: 1
});
$c_scm_HashMap.prototype.$classData = $d_scm_HashMap;
/** @constructor */
function $c_sc_convert_JavaCollectionWrappers$AbstractJMapWrapper() {
  /*<skip>*/
}
$c_sc_convert_JavaCollectionWrappers$AbstractJMapWrapper.prototype = new $h_scm_AbstractMap();
$c_sc_convert_JavaCollectionWrappers$AbstractJMapWrapper.prototype.constructor = $c_sc_convert_JavaCollectionWrappers$AbstractJMapWrapper;
/** @constructor */
function $h_sc_convert_JavaCollectionWrappers$AbstractJMapWrapper() {
  /*<skip>*/
}
$h_sc_convert_JavaCollectionWrappers$AbstractJMapWrapper.prototype = $c_sc_convert_JavaCollectionWrappers$AbstractJMapWrapper.prototype;
$c_sc_convert_JavaCollectionWrappers$AbstractJMapWrapper.prototype.size__I = (function() {
  return this.sc_convert_JavaCollectionWrappers$JMapWrapper__f_underlying.ju_HashMap__f_contentSize
});
$c_sc_convert_JavaCollectionWrappers$AbstractJMapWrapper.prototype.get__O__s_Option = (function(k) {
  return $f_sc_convert_JavaCollectionWrappers$JMapWrapperLike__get__O__s_Option(this, k)
});
$c_sc_convert_JavaCollectionWrappers$AbstractJMapWrapper.prototype.put__O__O__s_Option = (function(k, v) {
  return $f_sc_convert_JavaCollectionWrappers$JMapWrapperLike__put__O__O__s_Option(this, k, v)
});
$c_sc_convert_JavaCollectionWrappers$AbstractJMapWrapper.prototype.update__O__O__V = (function(k, v) {
  var this$1 = this.sc_convert_JavaCollectionWrappers$JMapWrapper__f_underlying;
  if ((k === null)) {
    var $$x1 = 0
  } else {
    var originalHash = $dp_hashCode__I(k);
    var $$x1 = (originalHash ^ ((originalHash >>> 16) | 0))
  };
  this$1.java$util$HashMap$$put0__O__O__I__Z__O(k, v, $$x1, false)
});
$c_sc_convert_JavaCollectionWrappers$AbstractJMapWrapper.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_convert_JavaCollectionWrappers$JMapWrapperLike$$anon$5(this)
});
$c_sc_convert_JavaCollectionWrappers$AbstractJMapWrapper.prototype.foreachEntry__F2__V = (function(f) {
  $f_sc_convert_JavaCollectionWrappers$JMapWrapperLike__foreachEntry__F2__V(this, f)
});
$c_sc_convert_JavaCollectionWrappers$AbstractJMapWrapper.prototype.map__F1__sc_IterableOps = (function(f) {
  return $f_sc_StrictOptimizedMapOps__map__F1__sc_IterableOps(this, f)
});
$c_sc_convert_JavaCollectionWrappers$AbstractJMapWrapper.prototype.concat__sc_IterableOnce__sc_IterableOps = (function(suffix) {
  return $f_sc_StrictOptimizedMapOps__concat__sc_IterableOnce__sc_IterableOps(this, suffix)
});
$c_sc_convert_JavaCollectionWrappers$AbstractJMapWrapper.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f)
});
$c_sc_convert_JavaCollectionWrappers$AbstractJMapWrapper.prototype.addOne__O__scm_Growable = (function(elem) {
  var kv = $as_T2(elem);
  return $f_sc_convert_JavaCollectionWrappers$JMapWrapperLike__addOne__T2__sc_convert_JavaCollectionWrappers$JMapWrapperLike(this, kv)
});
function $ct_sci_BigVector__AO__AO__I__($thiz, _prefix1, suffix1, length0) {
  $thiz.sci_BigVector__f_suffix1 = suffix1;
  $thiz.sci_BigVector__f_length0 = length0;
  $ct_sci_Vector__AO__($thiz, _prefix1);
  return $thiz
}
/** @constructor */
function $c_sci_BigVector() {
  this.sci_Vector__f_prefix1 = null;
  this.sci_BigVector__f_suffix1 = null;
  this.sci_BigVector__f_length0 = 0
}
$c_sci_BigVector.prototype = new $h_sci_VectorImpl();
$c_sci_BigVector.prototype.constructor = $c_sci_BigVector;
/** @constructor */
function $h_sci_BigVector() {
  /*<skip>*/
}
$h_sci_BigVector.prototype = $c_sci_BigVector.prototype;
$c_sci_BigVector.prototype.foreachRest__F1__V = (function(f) {
  var c = this.vectorSliceCount__I();
  var i = 1;
  while ((i < c)) {
    var $$x1 = $m_sci_VectorStatics$();
    var idx = i;
    var c$1 = ((c / 2) | 0);
    var a = ((idx - c$1) | 0);
    $$x1.foreachRec__I__AO__F1__V((((-1) + ((((1 + c$1) | 0) - ((a < 0) ? ((-a) | 0) : a)) | 0)) | 0), this.vectorSlice__I__AO(i), f);
    i = ((1 + i) | 0)
  }
});
function $as_sci_BigVector(obj) {
  return (((obj instanceof $c_sci_BigVector) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.BigVector"))
}
function $isArrayOf_sci_BigVector(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_BigVector)))
}
function $asArrayOf_sci_BigVector(obj, depth) {
  return (($isArrayOf_sci_BigVector(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.BigVector;", depth))
}
/** @constructor */
function $c_sci_Vector1(_data1) {
  this.sci_Vector__f_prefix1 = null;
  $ct_sci_Vector__AO__(this, _data1)
}
$c_sci_Vector1.prototype = new $h_sci_VectorImpl();
$c_sci_Vector1.prototype.constructor = $c_sci_Vector1;
/** @constructor */
function $h_sci_Vector1() {
  /*<skip>*/
}
$h_sci_Vector1.prototype = $c_sci_Vector1.prototype;
$c_sci_Vector1.prototype.apply__I__O = (function(index) {
  if (((index >= 0) && (index < this.sci_Vector__f_prefix1.u.length))) {
    return this.sci_Vector__f_prefix1.get(index)
  } else {
    throw this.ioob__I__jl_IndexOutOfBoundsException(index)
  }
});
$c_sci_Vector1.prototype.updated__I__O__sci_Vector = (function(index, elem) {
  if (((index >= 0) && (index < this.sci_Vector__f_prefix1.u.length))) {
    var a1 = this.sci_Vector__f_prefix1;
    var a1c = a1.clone__O();
    a1c.set(index, elem);
    return new $c_sci_Vector1(a1c)
  } else {
    throw this.ioob__I__jl_IndexOutOfBoundsException(index)
  }
});
$c_sci_Vector1.prototype.appended__O__sci_Vector = (function(elem) {
  var len1 = this.sci_Vector__f_prefix1.u.length;
  if ((len1 < 32)) {
    return new $c_sci_Vector1($m_sci_VectorStatics$().copyAppend1__AO__O__AO(this.sci_Vector__f_prefix1, elem))
  } else {
    var $$x2 = this.sci_Vector__f_prefix1;
    var $$x1 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a = new $ac_O(1);
    a.set(0, elem);
    return new $c_sci_Vector2($$x2, 32, $$x1, a, 33)
  }
});
$c_sci_Vector1.prototype.prepended__O__sci_Vector = (function(elem) {
  var len1 = this.sci_Vector__f_prefix1.u.length;
  if ((len1 < 32)) {
    return new $c_sci_Vector1($m_sci_VectorStatics$().copyPrepend1__O__AO__AO(elem, this.sci_Vector__f_prefix1))
  } else {
    var a = new $ac_O(1);
    a.set(0, elem);
    return new $c_sci_Vector2(a, 1, $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2, this.sci_Vector__f_prefix1, ((1 + len1) | 0))
  }
});
$c_sci_Vector1.prototype.map__F1__sci_Vector = (function(f) {
  return new $c_sci_Vector1($m_sci_VectorStatics$().mapElems1__AO__F1__AO(this.sci_Vector__f_prefix1, f))
});
$c_sci_Vector1.prototype.slice0__I__I__sci_Vector = (function(lo, hi) {
  var original = this.sci_Vector__f_prefix1;
  return new $c_sci_Vector1($m_ju_Arrays$().copyOfRange__AO__I__I__AO(original, lo, hi))
});
$c_sci_Vector1.prototype.tail__sci_Vector = (function() {
  if ((this.sci_Vector__f_prefix1.u.length === 1)) {
    return $m_sci_Vector0$()
  } else {
    var a = this.sci_Vector__f_prefix1;
    var to = a.u.length;
    return new $c_sci_Vector1($m_ju_Arrays$().copyOfRange__AO__I__I__AO(a, 1, to))
  }
});
$c_sci_Vector1.prototype.vectorSliceCount__I = (function() {
  return 1
});
$c_sci_Vector1.prototype.vectorSlice__I__AO = (function(idx) {
  return this.sci_Vector__f_prefix1
});
$c_sci_Vector1.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector = (function(suffix, k) {
  var data1b = $m_sci_VectorStatics$().append1IfSpace__AO__sc_IterableOnce__AO(this.sci_Vector__f_prefix1, suffix);
  return ((data1b !== null) ? new $c_sci_Vector1(data1b) : $c_sci_Vector.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector.call(this, suffix, k))
});
$c_sci_Vector1.prototype.tail__O = (function() {
  return this.tail__sci_Vector()
});
$c_sci_Vector1.prototype.map__F1__O = (function(f) {
  return this.map__F1__sci_Vector(f)
});
$c_sci_Vector1.prototype.apply__O__O = (function(v1) {
  var index = $uI(v1);
  if (((index >= 0) && (index < this.sci_Vector__f_prefix1.u.length))) {
    return this.sci_Vector__f_prefix1.get(index)
  } else {
    throw this.ioob__I__jl_IndexOutOfBoundsException(index)
  }
});
function $as_sci_Vector1(obj) {
  return (((obj instanceof $c_sci_Vector1) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Vector1"))
}
function $isArrayOf_sci_Vector1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Vector1)))
}
function $asArrayOf_sci_Vector1(obj, depth) {
  return (($isArrayOf_sci_Vector1(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Vector1;", depth))
}
var $d_sci_Vector1 = new $TypeData().initClass({
  sci_Vector1: 0
}, false, "scala.collection.immutable.Vector1", {
  sci_Vector1: 1,
  sci_VectorImpl: 1,
  sci_Vector: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Vector1.prototype.$classData = $d_sci_Vector1;
/** @constructor */
function $c_sc_convert_JavaCollectionWrappers$JMapWrapper(underlying) {
  this.sc_convert_JavaCollectionWrappers$JMapWrapper__f_underlying = null;
  this.sc_convert_JavaCollectionWrappers$JMapWrapper__f_underlying = underlying
}
$c_sc_convert_JavaCollectionWrappers$JMapWrapper.prototype = new $h_sc_convert_JavaCollectionWrappers$AbstractJMapWrapper();
$c_sc_convert_JavaCollectionWrappers$JMapWrapper.prototype.constructor = $c_sc_convert_JavaCollectionWrappers$JMapWrapper;
/** @constructor */
function $h_sc_convert_JavaCollectionWrappers$JMapWrapper() {
  /*<skip>*/
}
$h_sc_convert_JavaCollectionWrappers$JMapWrapper.prototype = $c_sc_convert_JavaCollectionWrappers$JMapWrapper.prototype;
$c_sc_convert_JavaCollectionWrappers$JMapWrapper.prototype.isEmpty__Z = (function() {
  return this.sc_convert_JavaCollectionWrappers$JMapWrapper__f_underlying.isEmpty__Z()
});
$c_sc_convert_JavaCollectionWrappers$JMapWrapper.prototype.knownSize__I = (function() {
  return (this.sc_convert_JavaCollectionWrappers$JMapWrapper__f_underlying.isEmpty__Z() ? 0 : (-1))
});
var $d_sc_convert_JavaCollectionWrappers$JMapWrapper = new $TypeData().initClass({
  sc_convert_JavaCollectionWrappers$JMapWrapper: 0
}, false, "scala.collection.convert.JavaCollectionWrappers$JMapWrapper", {
  sc_convert_JavaCollectionWrappers$JMapWrapper: 1,
  sc_convert_JavaCollectionWrappers$AbstractJMapWrapper: 1,
  scm_AbstractMap: 1,
  sc_AbstractMap: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Map: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_MapFactoryDefaults: 1,
  s_Equals: 1,
  scm_Map: 1,
  scm_Iterable: 1,
  scm_MapOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  scm_Shrinkable: 1,
  sc_convert_JavaCollectionWrappers$JMapWrapperLike: 1,
  sc_StrictOptimizedMapOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
});
$c_sc_convert_JavaCollectionWrappers$JMapWrapper.prototype.$classData = $d_sc_convert_JavaCollectionWrappers$JMapWrapper;
/** @constructor */
function $c_sci_$colon$colon(head, next) {
  this.sci_$colon$colon__f_head = null;
  this.sci_$colon$colon__f_next = null;
  this.sci_$colon$colon__f_head = head;
  this.sci_$colon$colon__f_next = next
}
$c_sci_$colon$colon.prototype = new $h_sci_List();
$c_sci_$colon$colon.prototype.constructor = $c_sci_$colon$colon;
/** @constructor */
function $h_sci_$colon$colon() {
  /*<skip>*/
}
$h_sci_$colon$colon.prototype = $c_sci_$colon$colon.prototype;
$c_sci_$colon$colon.prototype.head__O = (function() {
  return this.sci_$colon$colon__f_head
});
$c_sci_$colon$colon.prototype.productPrefix__T = (function() {
  return "::"
});
$c_sci_$colon$colon.prototype.productArity__I = (function() {
  return 2
});
$c_sci_$colon$colon.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.sci_$colon$colon__f_head;
      break
    }
    case 1: {
      return this.sci_$colon$colon__f_next;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_sci_$colon$colon.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_sci_$colon$colon.prototype.tail__O = (function() {
  return this.sci_$colon$colon__f_next
});
function $as_sci_$colon$colon(obj) {
  return (((obj instanceof $c_sci_$colon$colon) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.$colon$colon"))
}
function $isArrayOf_sci_$colon$colon(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_$colon$colon)))
}
function $asArrayOf_sci_$colon$colon(obj, depth) {
  return (($isArrayOf_sci_$colon$colon(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.$colon$colon;", depth))
}
var $d_sci_$colon$colon = new $TypeData().initClass({
  sci_$colon$colon: 0
}, false, "scala.collection.immutable.$colon$colon", {
  sci_$colon$colon: 1,
  sci_List: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_LinearSeq: 1,
  sc_LinearSeq: 1,
  sc_LinearSeqOps: 1,
  sci_LinearSeqOps: 1,
  sc_StrictOptimizedLinearSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1,
  s_Product: 1
});
$c_sci_$colon$colon.prototype.$classData = $d_sci_$colon$colon;
/** @constructor */
function $c_sci_Nil$() {
  this.sci_Nil$__f_EmptyUnzip = null;
  $n_sci_Nil$ = this;
  this.sci_Nil$__f_EmptyUnzip = new $c_T2($m_sci_Nil$(), $m_sci_Nil$())
}
$c_sci_Nil$.prototype = new $h_sci_List();
$c_sci_Nil$.prototype.constructor = $c_sci_Nil$;
/** @constructor */
function $h_sci_Nil$() {
  /*<skip>*/
}
$h_sci_Nil$.prototype = $c_sci_Nil$.prototype;
$c_sci_Nil$.prototype.head__E = (function() {
  throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "head of empty list")
});
$c_sci_Nil$.prototype.tail__E = (function() {
  throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "tail of empty list")
});
$c_sci_Nil$.prototype.last__E = (function() {
  throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "last of empty list")
});
$c_sci_Nil$.prototype.knownSize__I = (function() {
  return 0
});
$c_sci_Nil$.prototype.iterator__sc_Iterator = (function() {
  return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty
});
$c_sci_Nil$.prototype.productPrefix__T = (function() {
  return "Nil"
});
$c_sci_Nil$.prototype.productArity__I = (function() {
  return 0
});
$c_sci_Nil$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_sci_Nil$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_sci_Nil$.prototype.last__O = (function() {
  this.last__E()
});
$c_sci_Nil$.prototype.tail__O = (function() {
  this.tail__E()
});
$c_sci_Nil$.prototype.head__O = (function() {
  this.head__E()
});
var $d_sci_Nil$ = new $TypeData().initClass({
  sci_Nil$: 0
}, false, "scala.collection.immutable.Nil$", {
  sci_Nil$: 1,
  sci_List: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_LinearSeq: 1,
  sc_LinearSeq: 1,
  sc_LinearSeqOps: 1,
  sci_LinearSeqOps: 1,
  sc_StrictOptimizedLinearSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1,
  s_Product: 1
});
$c_sci_Nil$.prototype.$classData = $d_sci_Nil$;
var $n_sci_Nil$;
function $m_sci_Nil$() {
  if ((!$n_sci_Nil$)) {
    $n_sci_Nil$ = new $c_sci_Nil$()
  };
  return $n_sci_Nil$
}
/** @constructor */
function $c_sci_Vector0$() {
  this.sci_Vector__f_prefix1 = null;
  this.sci_BigVector__f_suffix1 = null;
  this.sci_BigVector__f_length0 = 0;
  $ct_sci_BigVector__AO__AO__I__(this, $m_sci_VectorStatics$().sci_VectorStatics$__f_empty1, $m_sci_VectorStatics$().sci_VectorStatics$__f_empty1, 0)
}
$c_sci_Vector0$.prototype = new $h_sci_BigVector();
$c_sci_Vector0$.prototype.constructor = $c_sci_Vector0$;
/** @constructor */
function $h_sci_Vector0$() {
  /*<skip>*/
}
$h_sci_Vector0$.prototype = $c_sci_Vector0$.prototype;
$c_sci_Vector0$.prototype.apply__I__E = (function(index) {
  throw this.ioob__I__jl_IndexOutOfBoundsException(index)
});
$c_sci_Vector0$.prototype.updated__I__O__sci_Vector = (function(index, elem) {
  throw this.ioob__I__jl_IndexOutOfBoundsException(index)
});
$c_sci_Vector0$.prototype.appended__O__sci_Vector = (function(elem) {
  var a = new $ac_O(1);
  a.set(0, elem);
  return new $c_sci_Vector1(a)
});
$c_sci_Vector0$.prototype.prepended__O__sci_Vector = (function(elem) {
  var a = new $ac_O(1);
  a.set(0, elem);
  return new $c_sci_Vector1(a)
});
$c_sci_Vector0$.prototype.tail__sci_Vector = (function() {
  throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.tail")
});
$c_sci_Vector0$.prototype.slice0__I__I__sci_Vector = (function(lo, hi) {
  return this
});
$c_sci_Vector0$.prototype.vectorSliceCount__I = (function() {
  return 0
});
$c_sci_Vector0$.prototype.vectorSlice__I__AO = (function(idx) {
  return null
});
$c_sci_Vector0$.prototype.equals__O__Z = (function(o) {
  return ((this === o) || ((!(o instanceof $c_sci_Vector)) && $f_sc_Seq__equals__O__Z(this, o)))
});
$c_sci_Vector0$.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector = (function(suffix, k) {
  return $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(suffix)
});
$c_sci_Vector0$.prototype.ioob__I__jl_IndexOutOfBoundsException = (function(index) {
  return $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (index + " is out of bounds (empty vector)"))
});
$c_sci_Vector0$.prototype.tail__O = (function() {
  return this.tail__sci_Vector()
});
$c_sci_Vector0$.prototype.map__F1__O = (function(f) {
  return this
});
$c_sci_Vector0$.prototype.apply__O__O = (function(v1) {
  this.apply__I__E($uI(v1))
});
$c_sci_Vector0$.prototype.apply__I__O = (function(i) {
  this.apply__I__E(i)
});
var $d_sci_Vector0$ = new $TypeData().initClass({
  sci_Vector0$: 0
}, false, "scala.collection.immutable.Vector0$", {
  sci_Vector0$: 1,
  sci_BigVector: 1,
  sci_VectorImpl: 1,
  sci_Vector: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Vector0$.prototype.$classData = $d_sci_Vector0$;
var $n_sci_Vector0$;
function $m_sci_Vector0$() {
  if ((!$n_sci_Vector0$)) {
    $n_sci_Vector0$ = new $c_sci_Vector0$()
  };
  return $n_sci_Vector0$
}
/** @constructor */
function $c_sci_Vector2(_prefix1, len1, data2, _suffix1, _length0) {
  this.sci_Vector__f_prefix1 = null;
  this.sci_BigVector__f_suffix1 = null;
  this.sci_BigVector__f_length0 = 0;
  this.sci_Vector2__f_len1 = 0;
  this.sci_Vector2__f_data2 = null;
  this.sci_Vector2__f_len1 = len1;
  this.sci_Vector2__f_data2 = data2;
  $ct_sci_BigVector__AO__AO__I__(this, _prefix1, _suffix1, _length0)
}
$c_sci_Vector2.prototype = new $h_sci_BigVector();
$c_sci_Vector2.prototype.constructor = $c_sci_Vector2;
/** @constructor */
function $h_sci_Vector2() {
  /*<skip>*/
}
$h_sci_Vector2.prototype = $c_sci_Vector2.prototype;
$c_sci_Vector2.prototype.apply__I__O = (function(index) {
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    var io = ((index - this.sci_Vector2__f_len1) | 0);
    if ((io >= 0)) {
      var i2 = ((io >>> 5) | 0);
      var i1 = (31 & io);
      return ((i2 < this.sci_Vector2__f_data2.u.length) ? this.sci_Vector2__f_data2.get(i2).get(i1) : this.sci_BigVector__f_suffix1.get((31 & io)))
    } else {
      return this.sci_Vector__f_prefix1.get(index)
    }
  } else {
    throw this.ioob__I__jl_IndexOutOfBoundsException(index)
  }
});
$c_sci_Vector2.prototype.updated__I__O__sci_Vector = (function(index, elem) {
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    if ((index >= this.sci_Vector2__f_len1)) {
      var io = ((index - this.sci_Vector2__f_len1) | 0);
      var i2 = ((io >>> 5) | 0);
      var i1 = (31 & io);
      if ((i2 < this.sci_Vector2__f_data2.u.length)) {
        var a2 = this.sci_Vector2__f_data2;
        var a2c = a2.clone__O();
        var a1 = a2c.get(i2);
        var a1c = a1.clone__O();
        a1c.set(i1, elem);
        a2c.set(i2, a1c);
        var x$2 = this.sci_Vector__f_prefix1;
        var x$3 = this.sci_Vector2__f_len1;
        var x$4 = this.sci_BigVector__f_suffix1;
        var x$5 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector2(x$2, x$3, a2c, x$4, x$5)
      } else {
        var a1$1 = this.sci_BigVector__f_suffix1;
        var a1c$1 = a1$1.clone__O();
        a1c$1.set(i1, elem);
        var x$7 = this.sci_Vector__f_prefix1;
        var x$8 = this.sci_Vector2__f_len1;
        var x$9 = this.sci_Vector2__f_data2;
        var x$10 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector2(x$7, x$8, x$9, a1c$1, x$10)
      }
    } else {
      var a1$2 = this.sci_Vector__f_prefix1;
      var a1c$2 = a1$2.clone__O();
      a1c$2.set(index, elem);
      var len1 = this.sci_Vector2__f_len1;
      var data2 = this.sci_Vector2__f_data2;
      var suffix1 = this.sci_BigVector__f_suffix1;
      var length0 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector2(a1c$2, len1, data2, suffix1, length0)
    }
  } else {
    throw this.ioob__I__jl_IndexOutOfBoundsException(index)
  }
});
$c_sci_Vector2.prototype.appended__O__sci_Vector = (function(elem) {
  if ((this.sci_BigVector__f_suffix1.u.length < 32)) {
    var x$1 = $m_sci_VectorStatics$().copyAppend1__AO__O__AO(this.sci_BigVector__f_suffix1, elem);
    var x$2 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector2__f_len1;
    var x$5 = this.sci_Vector2__f_data2;
    return new $c_sci_Vector2(x$3, x$4, x$5, x$1, x$2)
  } else if ((this.sci_Vector2__f_data2.u.length < 30)) {
    var x$6 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector2__f_data2, this.sci_BigVector__f_suffix1), 2);
    var a = new $ac_O(1);
    a.set(0, elem);
    var x$8 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$9 = this.sci_Vector__f_prefix1;
    var x$10 = this.sci_Vector2__f_len1;
    return new $c_sci_Vector2(x$9, x$10, x$6, a, x$8)
  } else {
    var $$x5 = this.sci_Vector__f_prefix1;
    var $$x4 = this.sci_Vector2__f_len1;
    var $$x3 = this.sci_Vector2__f_data2;
    var $$x2 = this.sci_Vector2__f_len1;
    var $$x1 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x = this.sci_BigVector__f_suffix1;
    var a$1 = new ($d_O.getArrayOf().getArrayOf().constr)(1);
    a$1.set(0, x);
    var a$2 = new $ac_O(1);
    a$2.set(0, elem);
    return new $c_sci_Vector3($$x5, $$x4, $$x3, ((960 + $$x2) | 0), $$x1, a$1, a$2, ((1 + this.sci_BigVector__f_length0) | 0))
  }
});
$c_sci_Vector2.prototype.prepended__O__sci_Vector = (function(elem) {
  if ((this.sci_Vector2__f_len1 < 32)) {
    var x$1 = $m_sci_VectorStatics$().copyPrepend1__O__AO__AO(elem, this.sci_Vector__f_prefix1);
    var x$2 = ((1 + this.sci_Vector2__f_len1) | 0);
    var x$3 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$4 = this.sci_Vector2__f_data2;
    var x$5 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector2(x$1, x$2, x$4, x$5, x$3)
  } else if ((this.sci_Vector2__f_data2.u.length < 30)) {
    var a = new $ac_O(1);
    a.set(0, elem);
    var x$8 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector2__f_data2), 2);
    var x$9 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$10 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector2(a, 1, x$8, x$10, x$9)
  } else {
    var a$1 = new $ac_O(1);
    a$1.set(0, elem);
    var x = this.sci_Vector__f_prefix1;
    var a$2 = new ($d_O.getArrayOf().getArrayOf().constr)(1);
    a$2.set(0, x);
    return new $c_sci_Vector3(a$1, 1, a$2, ((1 + this.sci_Vector2__f_len1) | 0), $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3, this.sci_Vector2__f_data2, this.sci_BigVector__f_suffix1, ((1 + this.sci_BigVector__f_length0) | 0))
  }
});
$c_sci_Vector2.prototype.map__F1__sci_Vector = (function(f) {
  var x$1 = $m_sci_VectorStatics$().mapElems1__AO__F1__AO(this.sci_Vector__f_prefix1, f);
  var x$2 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(2, this.sci_Vector2__f_data2, f), 2);
  var x$3 = $m_sci_VectorStatics$().mapElems1__AO__F1__AO(this.sci_BigVector__f_suffix1, f);
  var x$4 = this.sci_Vector2__f_len1;
  var x$5 = this.sci_BigVector__f_length0;
  return new $c_sci_Vector2(x$1, x$4, x$2, x$3, x$5)
});
$c_sci_Vector2.prototype.slice0__I__I__sci_Vector = (function(lo, hi) {
  var b = new $c_sci_VectorSliceBuilder(lo, hi);
  b.consider__I__AO__V(1, this.sci_Vector__f_prefix1);
  b.consider__I__AO__V(2, this.sci_Vector2__f_data2);
  b.consider__I__AO__V(1, this.sci_BigVector__f_suffix1);
  return b.result__sci_Vector()
});
$c_sci_Vector2.prototype.tail__sci_Vector = (function() {
  if ((this.sci_Vector2__f_len1 > 1)) {
    var a = this.sci_Vector__f_prefix1;
    var to = a.u.length;
    var x$1 = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a, 1, to);
    var x$2 = (((-1) + this.sci_Vector2__f_len1) | 0);
    var x$3 = (((-1) + this.sci_BigVector__f_length0) | 0);
    var x$4 = this.sci_Vector2__f_data2;
    var x$5 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector2(x$1, x$2, x$4, x$5, x$3)
  } else {
    return this.slice0__I__I__sci_Vector(1, this.sci_BigVector__f_length0)
  }
});
$c_sci_Vector2.prototype.vectorSliceCount__I = (function() {
  return 3
});
$c_sci_Vector2.prototype.vectorSlice__I__AO = (function(idx) {
  switch (idx) {
    case 0: {
      return this.sci_Vector__f_prefix1;
      break
    }
    case 1: {
      return this.sci_Vector2__f_data2;
      break
    }
    case 2: {
      return this.sci_BigVector__f_suffix1;
      break
    }
    default: {
      throw new $c_s_MatchError(idx)
    }
  }
});
$c_sci_Vector2.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector = (function(suffix, k) {
  var suffix1b = $m_sci_VectorStatics$().append1IfSpace__AO__sc_IterableOnce__AO(this.sci_BigVector__f_suffix1, suffix);
  if ((suffix1b !== null)) {
    var x$2 = ((((this.sci_BigVector__f_length0 - this.sci_BigVector__f_suffix1.u.length) | 0) + suffix1b.u.length) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector2__f_len1;
    var x$5 = this.sci_Vector2__f_data2;
    return new $c_sci_Vector2(x$3, x$4, x$5, suffix1b, x$2)
  } else {
    return $c_sci_Vector.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector.call(this, suffix, k)
  }
});
$c_sci_Vector2.prototype.tail__O = (function() {
  return this.tail__sci_Vector()
});
$c_sci_Vector2.prototype.map__F1__O = (function(f) {
  return this.map__F1__sci_Vector(f)
});
$c_sci_Vector2.prototype.apply__O__O = (function(v1) {
  var index = $uI(v1);
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    var io = ((index - this.sci_Vector2__f_len1) | 0);
    if ((io >= 0)) {
      var i2 = ((io >>> 5) | 0);
      var i1 = (31 & io);
      return ((i2 < this.sci_Vector2__f_data2.u.length) ? this.sci_Vector2__f_data2.get(i2).get(i1) : this.sci_BigVector__f_suffix1.get((31 & io)))
    } else {
      return this.sci_Vector__f_prefix1.get(index)
    }
  } else {
    throw this.ioob__I__jl_IndexOutOfBoundsException(index)
  }
});
function $as_sci_Vector2(obj) {
  return (((obj instanceof $c_sci_Vector2) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Vector2"))
}
function $isArrayOf_sci_Vector2(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Vector2)))
}
function $asArrayOf_sci_Vector2(obj, depth) {
  return (($isArrayOf_sci_Vector2(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Vector2;", depth))
}
var $d_sci_Vector2 = new $TypeData().initClass({
  sci_Vector2: 0
}, false, "scala.collection.immutable.Vector2", {
  sci_Vector2: 1,
  sci_BigVector: 1,
  sci_VectorImpl: 1,
  sci_Vector: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Vector2.prototype.$classData = $d_sci_Vector2;
/** @constructor */
function $c_sci_Vector3(_prefix1, len1, prefix2, len12, data3, suffix2, _suffix1, _length0) {
  this.sci_Vector__f_prefix1 = null;
  this.sci_BigVector__f_suffix1 = null;
  this.sci_BigVector__f_length0 = 0;
  this.sci_Vector3__f_len1 = 0;
  this.sci_Vector3__f_prefix2 = null;
  this.sci_Vector3__f_len12 = 0;
  this.sci_Vector3__f_data3 = null;
  this.sci_Vector3__f_suffix2 = null;
  this.sci_Vector3__f_len1 = len1;
  this.sci_Vector3__f_prefix2 = prefix2;
  this.sci_Vector3__f_len12 = len12;
  this.sci_Vector3__f_data3 = data3;
  this.sci_Vector3__f_suffix2 = suffix2;
  $ct_sci_BigVector__AO__AO__I__(this, _prefix1, _suffix1, _length0)
}
$c_sci_Vector3.prototype = new $h_sci_BigVector();
$c_sci_Vector3.prototype.constructor = $c_sci_Vector3;
/** @constructor */
function $h_sci_Vector3() {
  /*<skip>*/
}
$h_sci_Vector3.prototype = $c_sci_Vector3.prototype;
$c_sci_Vector3.prototype.apply__I__O = (function(index) {
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    var io = ((index - this.sci_Vector3__f_len12) | 0);
    if ((io >= 0)) {
      var i3 = ((io >>> 10) | 0);
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      return ((i3 < this.sci_Vector3__f_data3.u.length) ? this.sci_Vector3__f_data3.get(i3).get(i2).get(i1) : ((i2 < this.sci_Vector3__f_suffix2.u.length) ? this.sci_Vector3__f_suffix2.get(i2).get(i1) : this.sci_BigVector__f_suffix1.get(i1)))
    } else if ((index >= this.sci_Vector3__f_len1)) {
      var io$2 = ((index - this.sci_Vector3__f_len1) | 0);
      return this.sci_Vector3__f_prefix2.get(((io$2 >>> 5) | 0)).get((31 & io$2))
    } else {
      return this.sci_Vector__f_prefix1.get(index)
    }
  } else {
    throw this.ioob__I__jl_IndexOutOfBoundsException(index)
  }
});
$c_sci_Vector3.prototype.updated__I__O__sci_Vector = (function(index, elem) {
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    if ((index >= this.sci_Vector3__f_len12)) {
      var io = ((index - this.sci_Vector3__f_len12) | 0);
      var i3 = ((io >>> 10) | 0);
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      if ((i3 < this.sci_Vector3__f_data3.u.length)) {
        var a3 = this.sci_Vector3__f_data3;
        var a3c = a3.clone__O();
        var a2 = a3c.get(i3);
        var a2c = a2.clone__O();
        var a1 = a2c.get(i2);
        var a1c = a1.clone__O();
        a1c.set(i1, elem);
        a2c.set(i2, a1c);
        a3c.set(i3, a2c);
        var x$2 = this.sci_Vector__f_prefix1;
        var x$3 = this.sci_Vector3__f_len1;
        var x$4 = this.sci_Vector3__f_prefix2;
        var x$5 = this.sci_Vector3__f_len12;
        var x$6 = this.sci_Vector3__f_suffix2;
        var x$7 = this.sci_BigVector__f_suffix1;
        var x$8 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector3(x$2, x$3, x$4, x$5, a3c, x$6, x$7, x$8)
      } else if ((i2 < this.sci_Vector3__f_suffix2.u.length)) {
        var a2$1 = this.sci_Vector3__f_suffix2;
        var a2c$1 = a2$1.clone__O();
        var a1$1 = a2c$1.get(i2);
        var a1c$1 = a1$1.clone__O();
        a1c$1.set(i1, elem);
        a2c$1.set(i2, a1c$1);
        var x$10 = this.sci_Vector__f_prefix1;
        var x$11 = this.sci_Vector3__f_len1;
        var x$12 = this.sci_Vector3__f_prefix2;
        var x$13 = this.sci_Vector3__f_len12;
        var x$14 = this.sci_Vector3__f_data3;
        var x$15 = this.sci_BigVector__f_suffix1;
        var x$16 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector3(x$10, x$11, x$12, x$13, x$14, a2c$1, x$15, x$16)
      } else {
        var a1$2 = this.sci_BigVector__f_suffix1;
        var a1c$2 = a1$2.clone__O();
        a1c$2.set(i1, elem);
        var x$18 = this.sci_Vector__f_prefix1;
        var x$19 = this.sci_Vector3__f_len1;
        var x$20 = this.sci_Vector3__f_prefix2;
        var x$21 = this.sci_Vector3__f_len12;
        var x$22 = this.sci_Vector3__f_data3;
        var x$23 = this.sci_Vector3__f_suffix2;
        var x$24 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector3(x$18, x$19, x$20, x$21, x$22, x$23, a1c$2, x$24)
      }
    } else if ((index >= this.sci_Vector3__f_len1)) {
      var io$2 = ((index - this.sci_Vector3__f_len1) | 0);
      var a2$2 = this.sci_Vector3__f_prefix2;
      var idx2 = ((io$2 >>> 5) | 0);
      var idx1 = (31 & io$2);
      var a2c$2 = a2$2.clone__O();
      var a1$3 = a2c$2.get(idx2);
      var a1c$3 = a1$3.clone__O();
      a1c$3.set(idx1, elem);
      a2c$2.set(idx2, a1c$3);
      var x$26 = this.sci_Vector__f_prefix1;
      var x$27 = this.sci_Vector3__f_len1;
      var x$28 = this.sci_Vector3__f_len12;
      var x$29 = this.sci_Vector3__f_data3;
      var x$30 = this.sci_Vector3__f_suffix2;
      var x$31 = this.sci_BigVector__f_suffix1;
      var x$32 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector3(x$26, x$27, a2c$2, x$28, x$29, x$30, x$31, x$32)
    } else {
      var a1$4 = this.sci_Vector__f_prefix1;
      var a1c$4 = a1$4.clone__O();
      a1c$4.set(index, elem);
      var len1 = this.sci_Vector3__f_len1;
      var prefix2 = this.sci_Vector3__f_prefix2;
      var len12 = this.sci_Vector3__f_len12;
      var data3 = this.sci_Vector3__f_data3;
      var suffix2 = this.sci_Vector3__f_suffix2;
      var suffix1 = this.sci_BigVector__f_suffix1;
      var length0 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector3(a1c$4, len1, prefix2, len12, data3, suffix2, suffix1, length0)
    }
  } else {
    throw this.ioob__I__jl_IndexOutOfBoundsException(index)
  }
});
$c_sci_Vector3.prototype.appended__O__sci_Vector = (function(elem) {
  if ((this.sci_BigVector__f_suffix1.u.length < 32)) {
    var x$1 = $m_sci_VectorStatics$().copyAppend1__AO__O__AO(this.sci_BigVector__f_suffix1, elem);
    var x$2 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector3__f_len1;
    var x$5 = this.sci_Vector3__f_prefix2;
    var x$6 = this.sci_Vector3__f_len12;
    var x$7 = this.sci_Vector3__f_data3;
    var x$8 = this.sci_Vector3__f_suffix2;
    return new $c_sci_Vector3(x$3, x$4, x$5, x$6, x$7, x$8, x$1, x$2)
  } else if ((this.sci_Vector3__f_suffix2.u.length < 31)) {
    var x$9 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector3__f_suffix2, this.sci_BigVector__f_suffix1), 2);
    var a = new $ac_O(1);
    a.set(0, elem);
    var x$11 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$12 = this.sci_Vector__f_prefix1;
    var x$13 = this.sci_Vector3__f_len1;
    var x$14 = this.sci_Vector3__f_prefix2;
    var x$15 = this.sci_Vector3__f_len12;
    var x$16 = this.sci_Vector3__f_data3;
    return new $c_sci_Vector3(x$12, x$13, x$14, x$15, x$16, x$9, a, x$11)
  } else if ((this.sci_Vector3__f_data3.u.length < 30)) {
    var x$17 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector3__f_data3, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector3__f_suffix2, this.sci_BigVector__f_suffix1)), 3);
    var x$18 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$1 = new $ac_O(1);
    a$1.set(0, elem);
    var x$20 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$21 = this.sci_Vector__f_prefix1;
    var x$22 = this.sci_Vector3__f_len1;
    var x$23 = this.sci_Vector3__f_prefix2;
    var x$24 = this.sci_Vector3__f_len12;
    return new $c_sci_Vector3(x$21, x$22, x$23, x$24, x$17, x$18, a$1, x$20)
  } else {
    var $$x8 = this.sci_Vector__f_prefix1;
    var $$x7 = this.sci_Vector3__f_len1;
    var $$x6 = this.sci_Vector3__f_prefix2;
    var $$x5 = this.sci_Vector3__f_len12;
    var $$x4 = this.sci_Vector3__f_data3;
    var $$x3 = this.sci_Vector3__f_len12;
    var $$x2 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
    var x = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector3__f_suffix2, this.sci_BigVector__f_suffix1), 2);
    var a$2 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().constr)(1);
    a$2.set(0, x);
    var $$x1 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$3 = new $ac_O(1);
    a$3.set(0, elem);
    return new $c_sci_Vector4($$x8, $$x7, $$x6, $$x5, $$x4, ((30720 + $$x3) | 0), $$x2, a$2, $$x1, a$3, ((1 + this.sci_BigVector__f_length0) | 0))
  }
});
$c_sci_Vector3.prototype.prepended__O__sci_Vector = (function(elem) {
  if ((this.sci_Vector3__f_len1 < 32)) {
    var x$1 = $m_sci_VectorStatics$().copyPrepend1__O__AO__AO(elem, this.sci_Vector__f_prefix1);
    var x$2 = ((1 + this.sci_Vector3__f_len1) | 0);
    var x$3 = ((1 + this.sci_Vector3__f_len12) | 0);
    var x$4 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$5 = this.sci_Vector3__f_prefix2;
    var x$6 = this.sci_Vector3__f_data3;
    var x$7 = this.sci_Vector3__f_suffix2;
    var x$8 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector3(x$1, x$2, x$5, x$3, x$6, x$7, x$8, x$4)
  } else if ((this.sci_Vector3__f_len12 < 1024)) {
    var a = new $ac_O(1);
    a.set(0, elem);
    var x$11 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector3__f_prefix2), 2);
    var x$12 = ((1 + this.sci_Vector3__f_len12) | 0);
    var x$13 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$14 = this.sci_Vector3__f_data3;
    var x$15 = this.sci_Vector3__f_suffix2;
    var x$16 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector3(a, 1, x$11, x$12, x$14, x$15, x$16, x$13)
  } else if ((this.sci_Vector3__f_data3.u.length < 30)) {
    var a$1 = new $ac_O(1);
    a$1.set(0, elem);
    var x$19 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var x$21 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector3__f_prefix2), this.sci_Vector3__f_data3), 3);
    var x$22 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$23 = this.sci_Vector3__f_suffix2;
    var x$24 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector3(a$1, 1, x$19, 1, x$21, x$23, x$24, x$22)
  } else {
    var a$2 = new $ac_O(1);
    a$2.set(0, elem);
    var $$x1 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var x = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector3__f_prefix2), 2);
    var a$3 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().constr)(1);
    a$3.set(0, x);
    return new $c_sci_Vector4(a$2, 1, $$x1, 1, a$3, ((1 + this.sci_Vector3__f_len12) | 0), $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4, this.sci_Vector3__f_data3, this.sci_Vector3__f_suffix2, this.sci_BigVector__f_suffix1, ((1 + this.sci_BigVector__f_length0) | 0))
  }
});
$c_sci_Vector3.prototype.map__F1__sci_Vector = (function(f) {
  var x$1 = $m_sci_VectorStatics$().mapElems1__AO__F1__AO(this.sci_Vector__f_prefix1, f);
  var x$2 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(2, this.sci_Vector3__f_prefix2, f), 2);
  var x$3 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(3, this.sci_Vector3__f_data3, f), 3);
  var x$4 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(2, this.sci_Vector3__f_suffix2, f), 2);
  var x$5 = $m_sci_VectorStatics$().mapElems1__AO__F1__AO(this.sci_BigVector__f_suffix1, f);
  var x$6 = this.sci_Vector3__f_len1;
  var x$7 = this.sci_Vector3__f_len12;
  var x$8 = this.sci_BigVector__f_length0;
  return new $c_sci_Vector3(x$1, x$6, x$2, x$7, x$3, x$4, x$5, x$8)
});
$c_sci_Vector3.prototype.slice0__I__I__sci_Vector = (function(lo, hi) {
  var b = new $c_sci_VectorSliceBuilder(lo, hi);
  b.consider__I__AO__V(1, this.sci_Vector__f_prefix1);
  b.consider__I__AO__V(2, this.sci_Vector3__f_prefix2);
  b.consider__I__AO__V(3, this.sci_Vector3__f_data3);
  b.consider__I__AO__V(2, this.sci_Vector3__f_suffix2);
  b.consider__I__AO__V(1, this.sci_BigVector__f_suffix1);
  return b.result__sci_Vector()
});
$c_sci_Vector3.prototype.tail__sci_Vector = (function() {
  if ((this.sci_Vector3__f_len1 > 1)) {
    var a = this.sci_Vector__f_prefix1;
    var to = a.u.length;
    var x$1 = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a, 1, to);
    var x$2 = (((-1) + this.sci_Vector3__f_len1) | 0);
    var x$3 = (((-1) + this.sci_Vector3__f_len12) | 0);
    var x$4 = (((-1) + this.sci_BigVector__f_length0) | 0);
    var x$5 = this.sci_Vector3__f_prefix2;
    var x$6 = this.sci_Vector3__f_data3;
    var x$7 = this.sci_Vector3__f_suffix2;
    var x$8 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector3(x$1, x$2, x$5, x$3, x$6, x$7, x$8, x$4)
  } else {
    return this.slice0__I__I__sci_Vector(1, this.sci_BigVector__f_length0)
  }
});
$c_sci_Vector3.prototype.vectorSliceCount__I = (function() {
  return 5
});
$c_sci_Vector3.prototype.vectorSlice__I__AO = (function(idx) {
  switch (idx) {
    case 0: {
      return this.sci_Vector__f_prefix1;
      break
    }
    case 1: {
      return this.sci_Vector3__f_prefix2;
      break
    }
    case 2: {
      return this.sci_Vector3__f_data3;
      break
    }
    case 3: {
      return this.sci_Vector3__f_suffix2;
      break
    }
    case 4: {
      return this.sci_BigVector__f_suffix1;
      break
    }
    default: {
      throw new $c_s_MatchError(idx)
    }
  }
});
$c_sci_Vector3.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector = (function(suffix, k) {
  var suffix1b = $m_sci_VectorStatics$().append1IfSpace__AO__sc_IterableOnce__AO(this.sci_BigVector__f_suffix1, suffix);
  if ((suffix1b !== null)) {
    var x$2 = ((((this.sci_BigVector__f_length0 - this.sci_BigVector__f_suffix1.u.length) | 0) + suffix1b.u.length) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector3__f_len1;
    var x$5 = this.sci_Vector3__f_prefix2;
    var x$6 = this.sci_Vector3__f_len12;
    var x$7 = this.sci_Vector3__f_data3;
    var x$8 = this.sci_Vector3__f_suffix2;
    return new $c_sci_Vector3(x$3, x$4, x$5, x$6, x$7, x$8, suffix1b, x$2)
  } else {
    return $c_sci_Vector.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector.call(this, suffix, k)
  }
});
$c_sci_Vector3.prototype.tail__O = (function() {
  return this.tail__sci_Vector()
});
$c_sci_Vector3.prototype.map__F1__O = (function(f) {
  return this.map__F1__sci_Vector(f)
});
$c_sci_Vector3.prototype.apply__O__O = (function(v1) {
  var index = $uI(v1);
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    var io = ((index - this.sci_Vector3__f_len12) | 0);
    if ((io >= 0)) {
      var i3 = ((io >>> 10) | 0);
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      return ((i3 < this.sci_Vector3__f_data3.u.length) ? this.sci_Vector3__f_data3.get(i3).get(i2).get(i1) : ((i2 < this.sci_Vector3__f_suffix2.u.length) ? this.sci_Vector3__f_suffix2.get(i2).get(i1) : this.sci_BigVector__f_suffix1.get(i1)))
    } else if ((index >= this.sci_Vector3__f_len1)) {
      var io$2 = ((index - this.sci_Vector3__f_len1) | 0);
      return this.sci_Vector3__f_prefix2.get(((io$2 >>> 5) | 0)).get((31 & io$2))
    } else {
      return this.sci_Vector__f_prefix1.get(index)
    }
  } else {
    throw this.ioob__I__jl_IndexOutOfBoundsException(index)
  }
});
function $as_sci_Vector3(obj) {
  return (((obj instanceof $c_sci_Vector3) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Vector3"))
}
function $isArrayOf_sci_Vector3(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Vector3)))
}
function $asArrayOf_sci_Vector3(obj, depth) {
  return (($isArrayOf_sci_Vector3(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Vector3;", depth))
}
var $d_sci_Vector3 = new $TypeData().initClass({
  sci_Vector3: 0
}, false, "scala.collection.immutable.Vector3", {
  sci_Vector3: 1,
  sci_BigVector: 1,
  sci_VectorImpl: 1,
  sci_Vector: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Vector3.prototype.$classData = $d_sci_Vector3;
/** @constructor */
function $c_sci_Vector4(_prefix1, len1, prefix2, len12, prefix3, len123, data4, suffix3, suffix2, _suffix1, _length0) {
  this.sci_Vector__f_prefix1 = null;
  this.sci_BigVector__f_suffix1 = null;
  this.sci_BigVector__f_length0 = 0;
  this.sci_Vector4__f_len1 = 0;
  this.sci_Vector4__f_prefix2 = null;
  this.sci_Vector4__f_len12 = 0;
  this.sci_Vector4__f_prefix3 = null;
  this.sci_Vector4__f_len123 = 0;
  this.sci_Vector4__f_data4 = null;
  this.sci_Vector4__f_suffix3 = null;
  this.sci_Vector4__f_suffix2 = null;
  this.sci_Vector4__f_len1 = len1;
  this.sci_Vector4__f_prefix2 = prefix2;
  this.sci_Vector4__f_len12 = len12;
  this.sci_Vector4__f_prefix3 = prefix3;
  this.sci_Vector4__f_len123 = len123;
  this.sci_Vector4__f_data4 = data4;
  this.sci_Vector4__f_suffix3 = suffix3;
  this.sci_Vector4__f_suffix2 = suffix2;
  $ct_sci_BigVector__AO__AO__I__(this, _prefix1, _suffix1, _length0)
}
$c_sci_Vector4.prototype = new $h_sci_BigVector();
$c_sci_Vector4.prototype.constructor = $c_sci_Vector4;
/** @constructor */
function $h_sci_Vector4() {
  /*<skip>*/
}
$h_sci_Vector4.prototype = $c_sci_Vector4.prototype;
$c_sci_Vector4.prototype.apply__I__O = (function(index) {
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    var io = ((index - this.sci_Vector4__f_len123) | 0);
    if ((io >= 0)) {
      var i4 = ((io >>> 15) | 0);
      var i3 = (31 & ((io >>> 10) | 0));
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      return ((i4 < this.sci_Vector4__f_data4.u.length) ? this.sci_Vector4__f_data4.get(i4).get(i3).get(i2).get(i1) : ((i3 < this.sci_Vector4__f_suffix3.u.length) ? this.sci_Vector4__f_suffix3.get(i3).get(i2).get(i1) : ((i2 < this.sci_Vector4__f_suffix2.u.length) ? this.sci_Vector4__f_suffix2.get(i2).get(i1) : this.sci_BigVector__f_suffix1.get(i1))))
    } else if ((index >= this.sci_Vector4__f_len12)) {
      var io$2 = ((index - this.sci_Vector4__f_len12) | 0);
      return this.sci_Vector4__f_prefix3.get(((io$2 >>> 10) | 0)).get((31 & ((io$2 >>> 5) | 0))).get((31 & io$2))
    } else if ((index >= this.sci_Vector4__f_len1)) {
      var io$3 = ((index - this.sci_Vector4__f_len1) | 0);
      return this.sci_Vector4__f_prefix2.get(((io$3 >>> 5) | 0)).get((31 & io$3))
    } else {
      return this.sci_Vector__f_prefix1.get(index)
    }
  } else {
    throw this.ioob__I__jl_IndexOutOfBoundsException(index)
  }
});
$c_sci_Vector4.prototype.updated__I__O__sci_Vector = (function(index, elem) {
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    if ((index >= this.sci_Vector4__f_len123)) {
      var io = ((index - this.sci_Vector4__f_len123) | 0);
      var i4 = ((io >>> 15) | 0);
      var i3 = (31 & ((io >>> 10) | 0));
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      if ((i4 < this.sci_Vector4__f_data4.u.length)) {
        var a4 = this.sci_Vector4__f_data4;
        var a4c = a4.clone__O();
        var a3 = a4c.get(i4);
        var a3c = a3.clone__O();
        var a2 = a3c.get(i3);
        var a2c = a2.clone__O();
        var a1 = a2c.get(i2);
        var a1c = a1.clone__O();
        a1c.set(i1, elem);
        a2c.set(i2, a1c);
        a3c.set(i3, a2c);
        a4c.set(i4, a3c);
        var x$2 = this.sci_Vector__f_prefix1;
        var x$3 = this.sci_Vector4__f_len1;
        var x$4 = this.sci_Vector4__f_prefix2;
        var x$5 = this.sci_Vector4__f_len12;
        var x$6 = this.sci_Vector4__f_prefix3;
        var x$7 = this.sci_Vector4__f_len123;
        var x$8 = this.sci_Vector4__f_suffix3;
        var x$9 = this.sci_Vector4__f_suffix2;
        var x$10 = this.sci_BigVector__f_suffix1;
        var x$11 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector4(x$2, x$3, x$4, x$5, x$6, x$7, a4c, x$8, x$9, x$10, x$11)
      } else if ((i3 < this.sci_Vector4__f_suffix3.u.length)) {
        var a3$1 = this.sci_Vector4__f_suffix3;
        var a3c$1 = a3$1.clone__O();
        var a2$1 = a3c$1.get(i3);
        var a2c$1 = a2$1.clone__O();
        var a1$1 = a2c$1.get(i2);
        var a1c$1 = a1$1.clone__O();
        a1c$1.set(i1, elem);
        a2c$1.set(i2, a1c$1);
        a3c$1.set(i3, a2c$1);
        var x$13 = this.sci_Vector__f_prefix1;
        var x$14 = this.sci_Vector4__f_len1;
        var x$15 = this.sci_Vector4__f_prefix2;
        var x$16 = this.sci_Vector4__f_len12;
        var x$17 = this.sci_Vector4__f_prefix3;
        var x$18 = this.sci_Vector4__f_len123;
        var x$19 = this.sci_Vector4__f_data4;
        var x$20 = this.sci_Vector4__f_suffix2;
        var x$21 = this.sci_BigVector__f_suffix1;
        var x$22 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector4(x$13, x$14, x$15, x$16, x$17, x$18, x$19, a3c$1, x$20, x$21, x$22)
      } else if ((i2 < this.sci_Vector4__f_suffix2.u.length)) {
        var a2$2 = this.sci_Vector4__f_suffix2;
        var a2c$2 = a2$2.clone__O();
        var a1$2 = a2c$2.get(i2);
        var a1c$2 = a1$2.clone__O();
        a1c$2.set(i1, elem);
        a2c$2.set(i2, a1c$2);
        var x$24 = this.sci_Vector__f_prefix1;
        var x$25 = this.sci_Vector4__f_len1;
        var x$26 = this.sci_Vector4__f_prefix2;
        var x$27 = this.sci_Vector4__f_len12;
        var x$28 = this.sci_Vector4__f_prefix3;
        var x$29 = this.sci_Vector4__f_len123;
        var x$30 = this.sci_Vector4__f_data4;
        var x$31 = this.sci_Vector4__f_suffix3;
        var x$32 = this.sci_BigVector__f_suffix1;
        var x$33 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector4(x$24, x$25, x$26, x$27, x$28, x$29, x$30, x$31, a2c$2, x$32, x$33)
      } else {
        var a1$3 = this.sci_BigVector__f_suffix1;
        var a1c$3 = a1$3.clone__O();
        a1c$3.set(i1, elem);
        var x$35 = this.sci_Vector__f_prefix1;
        var x$36 = this.sci_Vector4__f_len1;
        var x$37 = this.sci_Vector4__f_prefix2;
        var x$38 = this.sci_Vector4__f_len12;
        var x$39 = this.sci_Vector4__f_prefix3;
        var x$40 = this.sci_Vector4__f_len123;
        var x$41 = this.sci_Vector4__f_data4;
        var x$42 = this.sci_Vector4__f_suffix3;
        var x$43 = this.sci_Vector4__f_suffix2;
        var x$44 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector4(x$35, x$36, x$37, x$38, x$39, x$40, x$41, x$42, x$43, a1c$3, x$44)
      }
    } else if ((index >= this.sci_Vector4__f_len12)) {
      var io$2 = ((index - this.sci_Vector4__f_len12) | 0);
      var a3$2 = this.sci_Vector4__f_prefix3;
      var idx3 = ((io$2 >>> 10) | 0);
      var idx2 = (31 & ((io$2 >>> 5) | 0));
      var idx1 = (31 & io$2);
      var a3c$2 = a3$2.clone__O();
      var a2$3 = a3c$2.get(idx3);
      var a2c$3 = a2$3.clone__O();
      var a1$4 = a2c$3.get(idx2);
      var a1c$4 = a1$4.clone__O();
      a1c$4.set(idx1, elem);
      a2c$3.set(idx2, a1c$4);
      a3c$2.set(idx3, a2c$3);
      var x$46 = this.sci_Vector__f_prefix1;
      var x$47 = this.sci_Vector4__f_len1;
      var x$48 = this.sci_Vector4__f_prefix2;
      var x$49 = this.sci_Vector4__f_len12;
      var x$50 = this.sci_Vector4__f_len123;
      var x$51 = this.sci_Vector4__f_data4;
      var x$52 = this.sci_Vector4__f_suffix3;
      var x$53 = this.sci_Vector4__f_suffix2;
      var x$54 = this.sci_BigVector__f_suffix1;
      var x$55 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector4(x$46, x$47, x$48, x$49, a3c$2, x$50, x$51, x$52, x$53, x$54, x$55)
    } else if ((index >= this.sci_Vector4__f_len1)) {
      var io$3 = ((index - this.sci_Vector4__f_len1) | 0);
      var a2$4 = this.sci_Vector4__f_prefix2;
      var idx2$1 = ((io$3 >>> 5) | 0);
      var idx1$1 = (31 & io$3);
      var a2c$4 = a2$4.clone__O();
      var a1$5 = a2c$4.get(idx2$1);
      var a1c$5 = a1$5.clone__O();
      a1c$5.set(idx1$1, elem);
      a2c$4.set(idx2$1, a1c$5);
      var x$57 = this.sci_Vector__f_prefix1;
      var x$58 = this.sci_Vector4__f_len1;
      var x$59 = this.sci_Vector4__f_len12;
      var x$60 = this.sci_Vector4__f_prefix3;
      var x$61 = this.sci_Vector4__f_len123;
      var x$62 = this.sci_Vector4__f_data4;
      var x$63 = this.sci_Vector4__f_suffix3;
      var x$64 = this.sci_Vector4__f_suffix2;
      var x$65 = this.sci_BigVector__f_suffix1;
      var x$66 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector4(x$57, x$58, a2c$4, x$59, x$60, x$61, x$62, x$63, x$64, x$65, x$66)
    } else {
      var a1$6 = this.sci_Vector__f_prefix1;
      var a1c$6 = a1$6.clone__O();
      a1c$6.set(index, elem);
      var len1 = this.sci_Vector4__f_len1;
      var prefix2 = this.sci_Vector4__f_prefix2;
      var len12 = this.sci_Vector4__f_len12;
      var prefix3 = this.sci_Vector4__f_prefix3;
      var len123 = this.sci_Vector4__f_len123;
      var data4 = this.sci_Vector4__f_data4;
      var suffix3 = this.sci_Vector4__f_suffix3;
      var suffix2 = this.sci_Vector4__f_suffix2;
      var suffix1 = this.sci_BigVector__f_suffix1;
      var length0 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector4(a1c$6, len1, prefix2, len12, prefix3, len123, data4, suffix3, suffix2, suffix1, length0)
    }
  } else {
    throw this.ioob__I__jl_IndexOutOfBoundsException(index)
  }
});
$c_sci_Vector4.prototype.appended__O__sci_Vector = (function(elem) {
  if ((this.sci_BigVector__f_suffix1.u.length < 32)) {
    var x$1 = $m_sci_VectorStatics$().copyAppend1__AO__O__AO(this.sci_BigVector__f_suffix1, elem);
    var x$2 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector4__f_len1;
    var x$5 = this.sci_Vector4__f_prefix2;
    var x$6 = this.sci_Vector4__f_len12;
    var x$7 = this.sci_Vector4__f_prefix3;
    var x$8 = this.sci_Vector4__f_len123;
    var x$9 = this.sci_Vector4__f_data4;
    var x$10 = this.sci_Vector4__f_suffix3;
    var x$11 = this.sci_Vector4__f_suffix2;
    return new $c_sci_Vector4(x$3, x$4, x$5, x$6, x$7, x$8, x$9, x$10, x$11, x$1, x$2)
  } else if ((this.sci_Vector4__f_suffix2.u.length < 31)) {
    var x$12 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector4__f_suffix2, this.sci_BigVector__f_suffix1), 2);
    var a = new $ac_O(1);
    a.set(0, elem);
    var x$14 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$15 = this.sci_Vector__f_prefix1;
    var x$16 = this.sci_Vector4__f_len1;
    var x$17 = this.sci_Vector4__f_prefix2;
    var x$18 = this.sci_Vector4__f_len12;
    var x$19 = this.sci_Vector4__f_prefix3;
    var x$20 = this.sci_Vector4__f_len123;
    var x$21 = this.sci_Vector4__f_data4;
    var x$22 = this.sci_Vector4__f_suffix3;
    return new $c_sci_Vector4(x$15, x$16, x$17, x$18, x$19, x$20, x$21, x$22, x$12, a, x$14)
  } else if ((this.sci_Vector4__f_suffix3.u.length < 31)) {
    var x$23 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector4__f_suffix3, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector4__f_suffix2, this.sci_BigVector__f_suffix1)), 3);
    var x$24 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$1 = new $ac_O(1);
    a$1.set(0, elem);
    var x$26 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$27 = this.sci_Vector__f_prefix1;
    var x$28 = this.sci_Vector4__f_len1;
    var x$29 = this.sci_Vector4__f_prefix2;
    var x$30 = this.sci_Vector4__f_len12;
    var x$31 = this.sci_Vector4__f_prefix3;
    var x$32 = this.sci_Vector4__f_len123;
    var x$33 = this.sci_Vector4__f_data4;
    return new $c_sci_Vector4(x$27, x$28, x$29, x$30, x$31, x$32, x$33, x$23, x$24, a$1, x$26)
  } else if ((this.sci_Vector4__f_data4.u.length < 30)) {
    var x$34 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector4__f_data4, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector4__f_suffix3, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector4__f_suffix2, this.sci_BigVector__f_suffix1))), 4);
    var x$35 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x$36 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$2 = new $ac_O(1);
    a$2.set(0, elem);
    var x$38 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$39 = this.sci_Vector__f_prefix1;
    var x$40 = this.sci_Vector4__f_len1;
    var x$41 = this.sci_Vector4__f_prefix2;
    var x$42 = this.sci_Vector4__f_len12;
    var x$43 = this.sci_Vector4__f_prefix3;
    var x$44 = this.sci_Vector4__f_len123;
    return new $c_sci_Vector4(x$39, x$40, x$41, x$42, x$43, x$44, x$34, x$35, x$36, a$2, x$38)
  } else {
    var $$x11 = this.sci_Vector__f_prefix1;
    var $$x10 = this.sci_Vector4__f_len1;
    var $$x9 = this.sci_Vector4__f_prefix2;
    var $$x8 = this.sci_Vector4__f_len12;
    var $$x7 = this.sci_Vector4__f_prefix3;
    var $$x6 = this.sci_Vector4__f_len123;
    var $$x5 = this.sci_Vector4__f_data4;
    var $$x4 = this.sci_Vector4__f_len123;
    var $$x3 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty5;
    var x = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector4__f_suffix3, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector4__f_suffix2, this.sci_BigVector__f_suffix1)), 3);
    var a$3 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(1);
    a$3.set(0, x);
    var $$x2 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var $$x1 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$4 = new $ac_O(1);
    a$4.set(0, elem);
    return new $c_sci_Vector5($$x11, $$x10, $$x9, $$x8, $$x7, $$x6, $$x5, ((983040 + $$x4) | 0), $$x3, a$3, $$x2, $$x1, a$4, ((1 + this.sci_BigVector__f_length0) | 0))
  }
});
$c_sci_Vector4.prototype.prepended__O__sci_Vector = (function(elem) {
  if ((this.sci_Vector4__f_len1 < 32)) {
    var x$1 = $m_sci_VectorStatics$().copyPrepend1__O__AO__AO(elem, this.sci_Vector__f_prefix1);
    var x$2 = ((1 + this.sci_Vector4__f_len1) | 0);
    var x$3 = ((1 + this.sci_Vector4__f_len12) | 0);
    var x$4 = ((1 + this.sci_Vector4__f_len123) | 0);
    var x$5 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$6 = this.sci_Vector4__f_prefix2;
    var x$7 = this.sci_Vector4__f_prefix3;
    var x$8 = this.sci_Vector4__f_data4;
    var x$9 = this.sci_Vector4__f_suffix3;
    var x$10 = this.sci_Vector4__f_suffix2;
    var x$11 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector4(x$1, x$2, x$6, x$3, x$7, x$4, x$8, x$9, x$10, x$11, x$5)
  } else if ((this.sci_Vector4__f_len12 < 1024)) {
    var a = new $ac_O(1);
    a.set(0, elem);
    var x$14 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector4__f_prefix2), 2);
    var x$15 = ((1 + this.sci_Vector4__f_len12) | 0);
    var x$16 = ((1 + this.sci_Vector4__f_len123) | 0);
    var x$17 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$18 = this.sci_Vector4__f_prefix3;
    var x$19 = this.sci_Vector4__f_data4;
    var x$20 = this.sci_Vector4__f_suffix3;
    var x$21 = this.sci_Vector4__f_suffix2;
    var x$22 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector4(a, 1, x$14, x$15, x$18, x$16, x$19, x$20, x$21, x$22, x$17)
  } else if ((this.sci_Vector4__f_len123 < 32768)) {
    var a$1 = new $ac_O(1);
    a$1.set(0, elem);
    var x$25 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var x$27 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector4__f_prefix2), this.sci_Vector4__f_prefix3), 3);
    var x$28 = ((1 + this.sci_Vector4__f_len123) | 0);
    var x$29 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$30 = this.sci_Vector4__f_data4;
    var x$31 = this.sci_Vector4__f_suffix3;
    var x$32 = this.sci_Vector4__f_suffix2;
    var x$33 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector4(a$1, 1, x$25, 1, x$27, x$28, x$30, x$31, x$32, x$33, x$29)
  } else if ((this.sci_Vector4__f_data4.u.length < 30)) {
    var a$2 = new $ac_O(1);
    a$2.set(0, elem);
    var x$36 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var x$38 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x$40 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector4__f_prefix2), this.sci_Vector4__f_prefix3), this.sci_Vector4__f_data4), 4);
    var x$41 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$42 = this.sci_Vector4__f_suffix3;
    var x$43 = this.sci_Vector4__f_suffix2;
    var x$44 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector4(a$2, 1, x$36, 1, x$38, 1, x$40, x$42, x$43, x$44, x$41)
  } else {
    var a$3 = new $ac_O(1);
    a$3.set(0, elem);
    var $$x2 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var $$x1 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector4__f_prefix2), this.sci_Vector4__f_prefix3), 3);
    var a$4 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(1);
    a$4.set(0, x);
    return new $c_sci_Vector5(a$3, 1, $$x2, 1, $$x1, 1, a$4, ((1 + this.sci_Vector4__f_len123) | 0), $m_sci_VectorStatics$().sci_VectorStatics$__f_empty5, this.sci_Vector4__f_data4, this.sci_Vector4__f_suffix3, this.sci_Vector4__f_suffix2, this.sci_BigVector__f_suffix1, ((1 + this.sci_BigVector__f_length0) | 0))
  }
});
$c_sci_Vector4.prototype.map__F1__sci_Vector = (function(f) {
  var x$1 = $m_sci_VectorStatics$().mapElems1__AO__F1__AO(this.sci_Vector__f_prefix1, f);
  var x$2 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(2, this.sci_Vector4__f_prefix2, f), 2);
  var x$3 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(3, this.sci_Vector4__f_prefix3, f), 3);
  var x$4 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(4, this.sci_Vector4__f_data4, f), 4);
  var x$5 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(3, this.sci_Vector4__f_suffix3, f), 3);
  var x$6 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(2, this.sci_Vector4__f_suffix2, f), 2);
  var x$7 = $m_sci_VectorStatics$().mapElems1__AO__F1__AO(this.sci_BigVector__f_suffix1, f);
  var x$8 = this.sci_Vector4__f_len1;
  var x$9 = this.sci_Vector4__f_len12;
  var x$10 = this.sci_Vector4__f_len123;
  var x$11 = this.sci_BigVector__f_length0;
  return new $c_sci_Vector4(x$1, x$8, x$2, x$9, x$3, x$10, x$4, x$5, x$6, x$7, x$11)
});
$c_sci_Vector4.prototype.slice0__I__I__sci_Vector = (function(lo, hi) {
  var b = new $c_sci_VectorSliceBuilder(lo, hi);
  b.consider__I__AO__V(1, this.sci_Vector__f_prefix1);
  b.consider__I__AO__V(2, this.sci_Vector4__f_prefix2);
  b.consider__I__AO__V(3, this.sci_Vector4__f_prefix3);
  b.consider__I__AO__V(4, this.sci_Vector4__f_data4);
  b.consider__I__AO__V(3, this.sci_Vector4__f_suffix3);
  b.consider__I__AO__V(2, this.sci_Vector4__f_suffix2);
  b.consider__I__AO__V(1, this.sci_BigVector__f_suffix1);
  return b.result__sci_Vector()
});
$c_sci_Vector4.prototype.tail__sci_Vector = (function() {
  if ((this.sci_Vector4__f_len1 > 1)) {
    var a = this.sci_Vector__f_prefix1;
    var to = a.u.length;
    var x$1 = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a, 1, to);
    var x$2 = (((-1) + this.sci_Vector4__f_len1) | 0);
    var x$3 = (((-1) + this.sci_Vector4__f_len12) | 0);
    var x$4 = (((-1) + this.sci_Vector4__f_len123) | 0);
    var x$5 = (((-1) + this.sci_BigVector__f_length0) | 0);
    var x$6 = this.sci_Vector4__f_prefix2;
    var x$7 = this.sci_Vector4__f_prefix3;
    var x$8 = this.sci_Vector4__f_data4;
    var x$9 = this.sci_Vector4__f_suffix3;
    var x$10 = this.sci_Vector4__f_suffix2;
    var x$11 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector4(x$1, x$2, x$6, x$3, x$7, x$4, x$8, x$9, x$10, x$11, x$5)
  } else {
    return this.slice0__I__I__sci_Vector(1, this.sci_BigVector__f_length0)
  }
});
$c_sci_Vector4.prototype.vectorSliceCount__I = (function() {
  return 7
});
$c_sci_Vector4.prototype.vectorSlice__I__AO = (function(idx) {
  switch (idx) {
    case 0: {
      return this.sci_Vector__f_prefix1;
      break
    }
    case 1: {
      return this.sci_Vector4__f_prefix2;
      break
    }
    case 2: {
      return this.sci_Vector4__f_prefix3;
      break
    }
    case 3: {
      return this.sci_Vector4__f_data4;
      break
    }
    case 4: {
      return this.sci_Vector4__f_suffix3;
      break
    }
    case 5: {
      return this.sci_Vector4__f_suffix2;
      break
    }
    case 6: {
      return this.sci_BigVector__f_suffix1;
      break
    }
    default: {
      throw new $c_s_MatchError(idx)
    }
  }
});
$c_sci_Vector4.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector = (function(suffix, k) {
  var suffix1b = $m_sci_VectorStatics$().append1IfSpace__AO__sc_IterableOnce__AO(this.sci_BigVector__f_suffix1, suffix);
  if ((suffix1b !== null)) {
    var x$2 = ((((this.sci_BigVector__f_length0 - this.sci_BigVector__f_suffix1.u.length) | 0) + suffix1b.u.length) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector4__f_len1;
    var x$5 = this.sci_Vector4__f_prefix2;
    var x$6 = this.sci_Vector4__f_len12;
    var x$7 = this.sci_Vector4__f_prefix3;
    var x$8 = this.sci_Vector4__f_len123;
    var x$9 = this.sci_Vector4__f_data4;
    var x$10 = this.sci_Vector4__f_suffix3;
    var x$11 = this.sci_Vector4__f_suffix2;
    return new $c_sci_Vector4(x$3, x$4, x$5, x$6, x$7, x$8, x$9, x$10, x$11, suffix1b, x$2)
  } else {
    return $c_sci_Vector.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector.call(this, suffix, k)
  }
});
$c_sci_Vector4.prototype.tail__O = (function() {
  return this.tail__sci_Vector()
});
$c_sci_Vector4.prototype.map__F1__O = (function(f) {
  return this.map__F1__sci_Vector(f)
});
$c_sci_Vector4.prototype.apply__O__O = (function(v1) {
  var index = $uI(v1);
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    var io = ((index - this.sci_Vector4__f_len123) | 0);
    if ((io >= 0)) {
      var i4 = ((io >>> 15) | 0);
      var i3 = (31 & ((io >>> 10) | 0));
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      return ((i4 < this.sci_Vector4__f_data4.u.length) ? this.sci_Vector4__f_data4.get(i4).get(i3).get(i2).get(i1) : ((i3 < this.sci_Vector4__f_suffix3.u.length) ? this.sci_Vector4__f_suffix3.get(i3).get(i2).get(i1) : ((i2 < this.sci_Vector4__f_suffix2.u.length) ? this.sci_Vector4__f_suffix2.get(i2).get(i1) : this.sci_BigVector__f_suffix1.get(i1))))
    } else if ((index >= this.sci_Vector4__f_len12)) {
      var io$2 = ((index - this.sci_Vector4__f_len12) | 0);
      return this.sci_Vector4__f_prefix3.get(((io$2 >>> 10) | 0)).get((31 & ((io$2 >>> 5) | 0))).get((31 & io$2))
    } else if ((index >= this.sci_Vector4__f_len1)) {
      var io$3 = ((index - this.sci_Vector4__f_len1) | 0);
      return this.sci_Vector4__f_prefix2.get(((io$3 >>> 5) | 0)).get((31 & io$3))
    } else {
      return this.sci_Vector__f_prefix1.get(index)
    }
  } else {
    throw this.ioob__I__jl_IndexOutOfBoundsException(index)
  }
});
function $as_sci_Vector4(obj) {
  return (((obj instanceof $c_sci_Vector4) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Vector4"))
}
function $isArrayOf_sci_Vector4(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Vector4)))
}
function $asArrayOf_sci_Vector4(obj, depth) {
  return (($isArrayOf_sci_Vector4(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Vector4;", depth))
}
var $d_sci_Vector4 = new $TypeData().initClass({
  sci_Vector4: 0
}, false, "scala.collection.immutable.Vector4", {
  sci_Vector4: 1,
  sci_BigVector: 1,
  sci_VectorImpl: 1,
  sci_Vector: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Vector4.prototype.$classData = $d_sci_Vector4;
/** @constructor */
function $c_sci_Vector5(_prefix1, len1, prefix2, len12, prefix3, len123, prefix4, len1234, data5, suffix4, suffix3, suffix2, _suffix1, _length0) {
  this.sci_Vector__f_prefix1 = null;
  this.sci_BigVector__f_suffix1 = null;
  this.sci_BigVector__f_length0 = 0;
  this.sci_Vector5__f_len1 = 0;
  this.sci_Vector5__f_prefix2 = null;
  this.sci_Vector5__f_len12 = 0;
  this.sci_Vector5__f_prefix3 = null;
  this.sci_Vector5__f_len123 = 0;
  this.sci_Vector5__f_prefix4 = null;
  this.sci_Vector5__f_len1234 = 0;
  this.sci_Vector5__f_data5 = null;
  this.sci_Vector5__f_suffix4 = null;
  this.sci_Vector5__f_suffix3 = null;
  this.sci_Vector5__f_suffix2 = null;
  this.sci_Vector5__f_len1 = len1;
  this.sci_Vector5__f_prefix2 = prefix2;
  this.sci_Vector5__f_len12 = len12;
  this.sci_Vector5__f_prefix3 = prefix3;
  this.sci_Vector5__f_len123 = len123;
  this.sci_Vector5__f_prefix4 = prefix4;
  this.sci_Vector5__f_len1234 = len1234;
  this.sci_Vector5__f_data5 = data5;
  this.sci_Vector5__f_suffix4 = suffix4;
  this.sci_Vector5__f_suffix3 = suffix3;
  this.sci_Vector5__f_suffix2 = suffix2;
  $ct_sci_BigVector__AO__AO__I__(this, _prefix1, _suffix1, _length0)
}
$c_sci_Vector5.prototype = new $h_sci_BigVector();
$c_sci_Vector5.prototype.constructor = $c_sci_Vector5;
/** @constructor */
function $h_sci_Vector5() {
  /*<skip>*/
}
$h_sci_Vector5.prototype = $c_sci_Vector5.prototype;
$c_sci_Vector5.prototype.apply__I__O = (function(index) {
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    var io = ((index - this.sci_Vector5__f_len1234) | 0);
    if ((io >= 0)) {
      var i5 = ((io >>> 20) | 0);
      var i4 = (31 & ((io >>> 15) | 0));
      var i3 = (31 & ((io >>> 10) | 0));
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      return ((i5 < this.sci_Vector5__f_data5.u.length) ? this.sci_Vector5__f_data5.get(i5).get(i4).get(i3).get(i2).get(i1) : ((i4 < this.sci_Vector5__f_suffix4.u.length) ? this.sci_Vector5__f_suffix4.get(i4).get(i3).get(i2).get(i1) : ((i3 < this.sci_Vector5__f_suffix3.u.length) ? this.sci_Vector5__f_suffix3.get(i3).get(i2).get(i1) : ((i2 < this.sci_Vector5__f_suffix2.u.length) ? this.sci_Vector5__f_suffix2.get(i2).get(i1) : this.sci_BigVector__f_suffix1.get(i1)))))
    } else if ((index >= this.sci_Vector5__f_len123)) {
      var io$2 = ((index - this.sci_Vector5__f_len123) | 0);
      return this.sci_Vector5__f_prefix4.get(((io$2 >>> 15) | 0)).get((31 & ((io$2 >>> 10) | 0))).get((31 & ((io$2 >>> 5) | 0))).get((31 & io$2))
    } else if ((index >= this.sci_Vector5__f_len12)) {
      var io$3 = ((index - this.sci_Vector5__f_len12) | 0);
      return this.sci_Vector5__f_prefix3.get(((io$3 >>> 10) | 0)).get((31 & ((io$3 >>> 5) | 0))).get((31 & io$3))
    } else if ((index >= this.sci_Vector5__f_len1)) {
      var io$4 = ((index - this.sci_Vector5__f_len1) | 0);
      return this.sci_Vector5__f_prefix2.get(((io$4 >>> 5) | 0)).get((31 & io$4))
    } else {
      return this.sci_Vector__f_prefix1.get(index)
    }
  } else {
    throw this.ioob__I__jl_IndexOutOfBoundsException(index)
  }
});
$c_sci_Vector5.prototype.updated__I__O__sci_Vector = (function(index, elem) {
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    if ((index >= this.sci_Vector5__f_len1234)) {
      var io = ((index - this.sci_Vector5__f_len1234) | 0);
      var i5 = ((io >>> 20) | 0);
      var i4 = (31 & ((io >>> 15) | 0));
      var i3 = (31 & ((io >>> 10) | 0));
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      if ((i5 < this.sci_Vector5__f_data5.u.length)) {
        var a5 = this.sci_Vector5__f_data5;
        var a5c = a5.clone__O();
        var a4 = a5c.get(i5);
        var a4c = a4.clone__O();
        var a3 = a4c.get(i4);
        var a3c = a3.clone__O();
        var a2 = a3c.get(i3);
        var a2c = a2.clone__O();
        var a1 = a2c.get(i2);
        var a1c = a1.clone__O();
        a1c.set(i1, elem);
        a2c.set(i2, a1c);
        a3c.set(i3, a2c);
        a4c.set(i4, a3c);
        a5c.set(i5, a4c);
        var x$2 = this.sci_Vector__f_prefix1;
        var x$3 = this.sci_Vector5__f_len1;
        var x$4 = this.sci_Vector5__f_prefix2;
        var x$5 = this.sci_Vector5__f_len12;
        var x$6 = this.sci_Vector5__f_prefix3;
        var x$7 = this.sci_Vector5__f_len123;
        var x$8 = this.sci_Vector5__f_prefix4;
        var x$9 = this.sci_Vector5__f_len1234;
        var x$10 = this.sci_Vector5__f_suffix4;
        var x$11 = this.sci_Vector5__f_suffix3;
        var x$12 = this.sci_Vector5__f_suffix2;
        var x$13 = this.sci_BigVector__f_suffix1;
        var x$14 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector5(x$2, x$3, x$4, x$5, x$6, x$7, x$8, x$9, a5c, x$10, x$11, x$12, x$13, x$14)
      } else if ((i4 < this.sci_Vector5__f_suffix4.u.length)) {
        var a4$1 = this.sci_Vector5__f_suffix4;
        var a4c$1 = a4$1.clone__O();
        var a3$1 = a4c$1.get(i4);
        var a3c$1 = a3$1.clone__O();
        var a2$1 = a3c$1.get(i3);
        var a2c$1 = a2$1.clone__O();
        var a1$1 = a2c$1.get(i2);
        var a1c$1 = a1$1.clone__O();
        a1c$1.set(i1, elem);
        a2c$1.set(i2, a1c$1);
        a3c$1.set(i3, a2c$1);
        a4c$1.set(i4, a3c$1);
        var x$16 = this.sci_Vector__f_prefix1;
        var x$17 = this.sci_Vector5__f_len1;
        var x$18 = this.sci_Vector5__f_prefix2;
        var x$19 = this.sci_Vector5__f_len12;
        var x$20 = this.sci_Vector5__f_prefix3;
        var x$21 = this.sci_Vector5__f_len123;
        var x$22 = this.sci_Vector5__f_prefix4;
        var x$23 = this.sci_Vector5__f_len1234;
        var x$24 = this.sci_Vector5__f_data5;
        var x$25 = this.sci_Vector5__f_suffix3;
        var x$26 = this.sci_Vector5__f_suffix2;
        var x$27 = this.sci_BigVector__f_suffix1;
        var x$28 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector5(x$16, x$17, x$18, x$19, x$20, x$21, x$22, x$23, x$24, a4c$1, x$25, x$26, x$27, x$28)
      } else if ((i3 < this.sci_Vector5__f_suffix3.u.length)) {
        var a3$2 = this.sci_Vector5__f_suffix3;
        var a3c$2 = a3$2.clone__O();
        var a2$2 = a3c$2.get(i3);
        var a2c$2 = a2$2.clone__O();
        var a1$2 = a2c$2.get(i2);
        var a1c$2 = a1$2.clone__O();
        a1c$2.set(i1, elem);
        a2c$2.set(i2, a1c$2);
        a3c$2.set(i3, a2c$2);
        var x$30 = this.sci_Vector__f_prefix1;
        var x$31 = this.sci_Vector5__f_len1;
        var x$32 = this.sci_Vector5__f_prefix2;
        var x$33 = this.sci_Vector5__f_len12;
        var x$34 = this.sci_Vector5__f_prefix3;
        var x$35 = this.sci_Vector5__f_len123;
        var x$36 = this.sci_Vector5__f_prefix4;
        var x$37 = this.sci_Vector5__f_len1234;
        var x$38 = this.sci_Vector5__f_data5;
        var x$39 = this.sci_Vector5__f_suffix4;
        var x$40 = this.sci_Vector5__f_suffix2;
        var x$41 = this.sci_BigVector__f_suffix1;
        var x$42 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector5(x$30, x$31, x$32, x$33, x$34, x$35, x$36, x$37, x$38, x$39, a3c$2, x$40, x$41, x$42)
      } else if ((i2 < this.sci_Vector5__f_suffix2.u.length)) {
        var a2$3 = this.sci_Vector5__f_suffix2;
        var a2c$3 = a2$3.clone__O();
        var a1$3 = a2c$3.get(i2);
        var a1c$3 = a1$3.clone__O();
        a1c$3.set(i1, elem);
        a2c$3.set(i2, a1c$3);
        var x$44 = this.sci_Vector__f_prefix1;
        var x$45 = this.sci_Vector5__f_len1;
        var x$46 = this.sci_Vector5__f_prefix2;
        var x$47 = this.sci_Vector5__f_len12;
        var x$48 = this.sci_Vector5__f_prefix3;
        var x$49 = this.sci_Vector5__f_len123;
        var x$50 = this.sci_Vector5__f_prefix4;
        var x$51 = this.sci_Vector5__f_len1234;
        var x$52 = this.sci_Vector5__f_data5;
        var x$53 = this.sci_Vector5__f_suffix4;
        var x$54 = this.sci_Vector5__f_suffix3;
        var x$55 = this.sci_BigVector__f_suffix1;
        var x$56 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector5(x$44, x$45, x$46, x$47, x$48, x$49, x$50, x$51, x$52, x$53, x$54, a2c$3, x$55, x$56)
      } else {
        var a1$4 = this.sci_BigVector__f_suffix1;
        var a1c$4 = a1$4.clone__O();
        a1c$4.set(i1, elem);
        var x$58 = this.sci_Vector__f_prefix1;
        var x$59 = this.sci_Vector5__f_len1;
        var x$60 = this.sci_Vector5__f_prefix2;
        var x$61 = this.sci_Vector5__f_len12;
        var x$62 = this.sci_Vector5__f_prefix3;
        var x$63 = this.sci_Vector5__f_len123;
        var x$64 = this.sci_Vector5__f_prefix4;
        var x$65 = this.sci_Vector5__f_len1234;
        var x$66 = this.sci_Vector5__f_data5;
        var x$67 = this.sci_Vector5__f_suffix4;
        var x$68 = this.sci_Vector5__f_suffix3;
        var x$69 = this.sci_Vector5__f_suffix2;
        var x$70 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector5(x$58, x$59, x$60, x$61, x$62, x$63, x$64, x$65, x$66, x$67, x$68, x$69, a1c$4, x$70)
      }
    } else if ((index >= this.sci_Vector5__f_len123)) {
      var io$2 = ((index - this.sci_Vector5__f_len123) | 0);
      var a4$2 = this.sci_Vector5__f_prefix4;
      var idx4 = ((io$2 >>> 15) | 0);
      var idx3 = (31 & ((io$2 >>> 10) | 0));
      var idx2 = (31 & ((io$2 >>> 5) | 0));
      var idx1 = (31 & io$2);
      var a4c$2 = a4$2.clone__O();
      var a3$3 = a4c$2.get(idx4);
      var a3c$3 = a3$3.clone__O();
      var a2$4 = a3c$3.get(idx3);
      var a2c$4 = a2$4.clone__O();
      var a1$5 = a2c$4.get(idx2);
      var a1c$5 = a1$5.clone__O();
      a1c$5.set(idx1, elem);
      a2c$4.set(idx2, a1c$5);
      a3c$3.set(idx3, a2c$4);
      a4c$2.set(idx4, a3c$3);
      var x$72 = this.sci_Vector__f_prefix1;
      var x$73 = this.sci_Vector5__f_len1;
      var x$74 = this.sci_Vector5__f_prefix2;
      var x$75 = this.sci_Vector5__f_len12;
      var x$76 = this.sci_Vector5__f_prefix3;
      var x$77 = this.sci_Vector5__f_len123;
      var x$78 = this.sci_Vector5__f_len1234;
      var x$79 = this.sci_Vector5__f_data5;
      var x$80 = this.sci_Vector5__f_suffix4;
      var x$81 = this.sci_Vector5__f_suffix3;
      var x$82 = this.sci_Vector5__f_suffix2;
      var x$83 = this.sci_BigVector__f_suffix1;
      var x$84 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector5(x$72, x$73, x$74, x$75, x$76, x$77, a4c$2, x$78, x$79, x$80, x$81, x$82, x$83, x$84)
    } else if ((index >= this.sci_Vector5__f_len12)) {
      var io$3 = ((index - this.sci_Vector5__f_len12) | 0);
      var a3$4 = this.sci_Vector5__f_prefix3;
      var idx3$1 = ((io$3 >>> 10) | 0);
      var idx2$1 = (31 & ((io$3 >>> 5) | 0));
      var idx1$1 = (31 & io$3);
      var a3c$4 = a3$4.clone__O();
      var a2$5 = a3c$4.get(idx3$1);
      var a2c$5 = a2$5.clone__O();
      var a1$6 = a2c$5.get(idx2$1);
      var a1c$6 = a1$6.clone__O();
      a1c$6.set(idx1$1, elem);
      a2c$5.set(idx2$1, a1c$6);
      a3c$4.set(idx3$1, a2c$5);
      var x$86 = this.sci_Vector__f_prefix1;
      var x$87 = this.sci_Vector5__f_len1;
      var x$88 = this.sci_Vector5__f_prefix2;
      var x$89 = this.sci_Vector5__f_len12;
      var x$90 = this.sci_Vector5__f_len123;
      var x$91 = this.sci_Vector5__f_prefix4;
      var x$92 = this.sci_Vector5__f_len1234;
      var x$93 = this.sci_Vector5__f_data5;
      var x$94 = this.sci_Vector5__f_suffix4;
      var x$95 = this.sci_Vector5__f_suffix3;
      var x$96 = this.sci_Vector5__f_suffix2;
      var x$97 = this.sci_BigVector__f_suffix1;
      var x$98 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector5(x$86, x$87, x$88, x$89, a3c$4, x$90, x$91, x$92, x$93, x$94, x$95, x$96, x$97, x$98)
    } else if ((index >= this.sci_Vector5__f_len1)) {
      var io$4 = ((index - this.sci_Vector5__f_len1) | 0);
      var a2$6 = this.sci_Vector5__f_prefix2;
      var idx2$2 = ((io$4 >>> 5) | 0);
      var idx1$2 = (31 & io$4);
      var a2c$6 = a2$6.clone__O();
      var a1$7 = a2c$6.get(idx2$2);
      var a1c$7 = a1$7.clone__O();
      a1c$7.set(idx1$2, elem);
      a2c$6.set(idx2$2, a1c$7);
      var x$100 = this.sci_Vector__f_prefix1;
      var x$101 = this.sci_Vector5__f_len1;
      var x$102 = this.sci_Vector5__f_len12;
      var x$103 = this.sci_Vector5__f_prefix3;
      var x$104 = this.sci_Vector5__f_len123;
      var x$105 = this.sci_Vector5__f_prefix4;
      var x$106 = this.sci_Vector5__f_len1234;
      var x$107 = this.sci_Vector5__f_data5;
      var x$108 = this.sci_Vector5__f_suffix4;
      var x$109 = this.sci_Vector5__f_suffix3;
      var x$110 = this.sci_Vector5__f_suffix2;
      var x$111 = this.sci_BigVector__f_suffix1;
      var x$112 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector5(x$100, x$101, a2c$6, x$102, x$103, x$104, x$105, x$106, x$107, x$108, x$109, x$110, x$111, x$112)
    } else {
      var a1$8 = this.sci_Vector__f_prefix1;
      var a1c$8 = a1$8.clone__O();
      a1c$8.set(index, elem);
      var len1 = this.sci_Vector5__f_len1;
      var prefix2 = this.sci_Vector5__f_prefix2;
      var len12 = this.sci_Vector5__f_len12;
      var prefix3 = this.sci_Vector5__f_prefix3;
      var len123 = this.sci_Vector5__f_len123;
      var prefix4 = this.sci_Vector5__f_prefix4;
      var len1234 = this.sci_Vector5__f_len1234;
      var data5 = this.sci_Vector5__f_data5;
      var suffix4 = this.sci_Vector5__f_suffix4;
      var suffix3 = this.sci_Vector5__f_suffix3;
      var suffix2 = this.sci_Vector5__f_suffix2;
      var suffix1 = this.sci_BigVector__f_suffix1;
      var length0 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector5(a1c$8, len1, prefix2, len12, prefix3, len123, prefix4, len1234, data5, suffix4, suffix3, suffix2, suffix1, length0)
    }
  } else {
    throw this.ioob__I__jl_IndexOutOfBoundsException(index)
  }
});
$c_sci_Vector5.prototype.appended__O__sci_Vector = (function(elem) {
  if ((this.sci_BigVector__f_suffix1.u.length < 32)) {
    var x$1 = $m_sci_VectorStatics$().copyAppend1__AO__O__AO(this.sci_BigVector__f_suffix1, elem);
    var x$2 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector5__f_len1;
    var x$5 = this.sci_Vector5__f_prefix2;
    var x$6 = this.sci_Vector5__f_len12;
    var x$7 = this.sci_Vector5__f_prefix3;
    var x$8 = this.sci_Vector5__f_len123;
    var x$9 = this.sci_Vector5__f_prefix4;
    var x$10 = this.sci_Vector5__f_len1234;
    var x$11 = this.sci_Vector5__f_data5;
    var x$12 = this.sci_Vector5__f_suffix4;
    var x$13 = this.sci_Vector5__f_suffix3;
    var x$14 = this.sci_Vector5__f_suffix2;
    return new $c_sci_Vector5(x$3, x$4, x$5, x$6, x$7, x$8, x$9, x$10, x$11, x$12, x$13, x$14, x$1, x$2)
  } else if ((this.sci_Vector5__f_suffix2.u.length < 31)) {
    var x$15 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_suffix2, this.sci_BigVector__f_suffix1), 2);
    var a = new $ac_O(1);
    a.set(0, elem);
    var x$17 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$18 = this.sci_Vector__f_prefix1;
    var x$19 = this.sci_Vector5__f_len1;
    var x$20 = this.sci_Vector5__f_prefix2;
    var x$21 = this.sci_Vector5__f_len12;
    var x$22 = this.sci_Vector5__f_prefix3;
    var x$23 = this.sci_Vector5__f_len123;
    var x$24 = this.sci_Vector5__f_prefix4;
    var x$25 = this.sci_Vector5__f_len1234;
    var x$26 = this.sci_Vector5__f_data5;
    var x$27 = this.sci_Vector5__f_suffix4;
    var x$28 = this.sci_Vector5__f_suffix3;
    return new $c_sci_Vector5(x$18, x$19, x$20, x$21, x$22, x$23, x$24, x$25, x$26, x$27, x$28, x$15, a, x$17)
  } else if ((this.sci_Vector5__f_suffix3.u.length < 31)) {
    var x$29 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_suffix3, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_suffix2, this.sci_BigVector__f_suffix1)), 3);
    var x$30 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$1 = new $ac_O(1);
    a$1.set(0, elem);
    var x$32 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$33 = this.sci_Vector__f_prefix1;
    var x$34 = this.sci_Vector5__f_len1;
    var x$35 = this.sci_Vector5__f_prefix2;
    var x$36 = this.sci_Vector5__f_len12;
    var x$37 = this.sci_Vector5__f_prefix3;
    var x$38 = this.sci_Vector5__f_len123;
    var x$39 = this.sci_Vector5__f_prefix4;
    var x$40 = this.sci_Vector5__f_len1234;
    var x$41 = this.sci_Vector5__f_data5;
    var x$42 = this.sci_Vector5__f_suffix4;
    return new $c_sci_Vector5(x$33, x$34, x$35, x$36, x$37, x$38, x$39, x$40, x$41, x$42, x$29, x$30, a$1, x$32)
  } else if ((this.sci_Vector5__f_suffix4.u.length < 31)) {
    var x$43 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_suffix4, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_suffix3, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_suffix2, this.sci_BigVector__f_suffix1))), 4);
    var x$44 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x$45 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$2 = new $ac_O(1);
    a$2.set(0, elem);
    var x$47 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$48 = this.sci_Vector__f_prefix1;
    var x$49 = this.sci_Vector5__f_len1;
    var x$50 = this.sci_Vector5__f_prefix2;
    var x$51 = this.sci_Vector5__f_len12;
    var x$52 = this.sci_Vector5__f_prefix3;
    var x$53 = this.sci_Vector5__f_len123;
    var x$54 = this.sci_Vector5__f_prefix4;
    var x$55 = this.sci_Vector5__f_len1234;
    var x$56 = this.sci_Vector5__f_data5;
    return new $c_sci_Vector5(x$48, x$49, x$50, x$51, x$52, x$53, x$54, x$55, x$56, x$43, x$44, x$45, a$2, x$47)
  } else if ((this.sci_Vector5__f_data5.u.length < 30)) {
    var x$57 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_data5, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_suffix4, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_suffix3, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_suffix2, this.sci_BigVector__f_suffix1)))), 5);
    var x$58 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
    var x$59 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x$60 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$3 = new $ac_O(1);
    a$3.set(0, elem);
    var x$62 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$63 = this.sci_Vector__f_prefix1;
    var x$64 = this.sci_Vector5__f_len1;
    var x$65 = this.sci_Vector5__f_prefix2;
    var x$66 = this.sci_Vector5__f_len12;
    var x$67 = this.sci_Vector5__f_prefix3;
    var x$68 = this.sci_Vector5__f_len123;
    var x$69 = this.sci_Vector5__f_prefix4;
    var x$70 = this.sci_Vector5__f_len1234;
    return new $c_sci_Vector5(x$63, x$64, x$65, x$66, x$67, x$68, x$69, x$70, x$57, x$58, x$59, x$60, a$3, x$62)
  } else {
    var $$x14 = this.sci_Vector__f_prefix1;
    var $$x13 = this.sci_Vector5__f_len1;
    var $$x12 = this.sci_Vector5__f_prefix2;
    var $$x11 = this.sci_Vector5__f_len12;
    var $$x10 = this.sci_Vector5__f_prefix3;
    var $$x9 = this.sci_Vector5__f_len123;
    var $$x8 = this.sci_Vector5__f_prefix4;
    var $$x7 = this.sci_Vector5__f_len1234;
    var $$x6 = this.sci_Vector5__f_data5;
    var $$x5 = this.sci_Vector5__f_len1234;
    var $$x4 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty6;
    var x = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_suffix4, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_suffix3, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_suffix2, this.sci_BigVector__f_suffix1))), 4);
    var a$4 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(1);
    a$4.set(0, x);
    var $$x3 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
    var $$x2 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var $$x1 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$5 = new $ac_O(1);
    a$5.set(0, elem);
    return new $c_sci_Vector6($$x14, $$x13, $$x12, $$x11, $$x10, $$x9, $$x8, $$x7, $$x6, ((31457280 + $$x5) | 0), $$x4, a$4, $$x3, $$x2, $$x1, a$5, ((1 + this.sci_BigVector__f_length0) | 0))
  }
});
$c_sci_Vector5.prototype.prepended__O__sci_Vector = (function(elem) {
  if ((this.sci_Vector5__f_len1 < 32)) {
    var x$1 = $m_sci_VectorStatics$().copyPrepend1__O__AO__AO(elem, this.sci_Vector__f_prefix1);
    var x$2 = ((1 + this.sci_Vector5__f_len1) | 0);
    var x$3 = ((1 + this.sci_Vector5__f_len12) | 0);
    var x$4 = ((1 + this.sci_Vector5__f_len123) | 0);
    var x$5 = ((1 + this.sci_Vector5__f_len1234) | 0);
    var x$6 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$7 = this.sci_Vector5__f_prefix2;
    var x$8 = this.sci_Vector5__f_prefix3;
    var x$9 = this.sci_Vector5__f_prefix4;
    var x$10 = this.sci_Vector5__f_data5;
    var x$11 = this.sci_Vector5__f_suffix4;
    var x$12 = this.sci_Vector5__f_suffix3;
    var x$13 = this.sci_Vector5__f_suffix2;
    var x$14 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector5(x$1, x$2, x$7, x$3, x$8, x$4, x$9, x$5, x$10, x$11, x$12, x$13, x$14, x$6)
  } else if ((this.sci_Vector5__f_len12 < 1024)) {
    var a = new $ac_O(1);
    a.set(0, elem);
    var x$17 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector5__f_prefix2), 2);
    var x$18 = ((1 + this.sci_Vector5__f_len12) | 0);
    var x$19 = ((1 + this.sci_Vector5__f_len123) | 0);
    var x$20 = ((1 + this.sci_Vector5__f_len1234) | 0);
    var x$21 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$22 = this.sci_Vector5__f_prefix3;
    var x$23 = this.sci_Vector5__f_prefix4;
    var x$24 = this.sci_Vector5__f_data5;
    var x$25 = this.sci_Vector5__f_suffix4;
    var x$26 = this.sci_Vector5__f_suffix3;
    var x$27 = this.sci_Vector5__f_suffix2;
    var x$28 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector5(a, 1, x$17, x$18, x$22, x$19, x$23, x$20, x$24, x$25, x$26, x$27, x$28, x$21)
  } else if ((this.sci_Vector5__f_len123 < 32768)) {
    var a$1 = new $ac_O(1);
    a$1.set(0, elem);
    var x$31 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var x$33 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector5__f_prefix2), this.sci_Vector5__f_prefix3), 3);
    var x$34 = ((1 + this.sci_Vector5__f_len123) | 0);
    var x$35 = ((1 + this.sci_Vector5__f_len1234) | 0);
    var x$36 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$37 = this.sci_Vector5__f_prefix4;
    var x$38 = this.sci_Vector5__f_data5;
    var x$39 = this.sci_Vector5__f_suffix4;
    var x$40 = this.sci_Vector5__f_suffix3;
    var x$41 = this.sci_Vector5__f_suffix2;
    var x$42 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector5(a$1, 1, x$31, 1, x$33, x$34, x$37, x$35, x$38, x$39, x$40, x$41, x$42, x$36)
  } else if ((this.sci_Vector5__f_len1234 < 1048576)) {
    var a$2 = new $ac_O(1);
    a$2.set(0, elem);
    var x$45 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var x$47 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x$49 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector5__f_prefix2), this.sci_Vector5__f_prefix3), this.sci_Vector5__f_prefix4), 4);
    var x$50 = ((1 + this.sci_Vector5__f_len1234) | 0);
    var x$51 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$52 = this.sci_Vector5__f_data5;
    var x$53 = this.sci_Vector5__f_suffix4;
    var x$54 = this.sci_Vector5__f_suffix3;
    var x$55 = this.sci_Vector5__f_suffix2;
    var x$56 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector5(a$2, 1, x$45, 1, x$47, 1, x$49, x$50, x$52, x$53, x$54, x$55, x$56, x$51)
  } else if ((this.sci_Vector5__f_data5.u.length < 30)) {
    var a$3 = new $ac_O(1);
    a$3.set(0, elem);
    var x$59 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var x$61 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x$63 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
    var x$65 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector5__f_prefix2), this.sci_Vector5__f_prefix3), this.sci_Vector5__f_prefix4), this.sci_Vector5__f_data5), 5);
    var x$66 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$67 = this.sci_Vector5__f_suffix4;
    var x$68 = this.sci_Vector5__f_suffix3;
    var x$69 = this.sci_Vector5__f_suffix2;
    var x$70 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector5(a$3, 1, x$59, 1, x$61, 1, x$63, 1, x$65, x$67, x$68, x$69, x$70, x$66)
  } else {
    var a$4 = new $ac_O(1);
    a$4.set(0, elem);
    var $$x3 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var $$x2 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var $$x1 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
    var x = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector5__f_prefix2), this.sci_Vector5__f_prefix3), this.sci_Vector5__f_prefix4), 4);
    var a$5 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(1);
    a$5.set(0, x);
    return new $c_sci_Vector6(a$4, 1, $$x3, 1, $$x2, 1, $$x1, 1, a$5, ((1 + this.sci_Vector5__f_len1234) | 0), $m_sci_VectorStatics$().sci_VectorStatics$__f_empty6, this.sci_Vector5__f_data5, this.sci_Vector5__f_suffix4, this.sci_Vector5__f_suffix3, this.sci_Vector5__f_suffix2, this.sci_BigVector__f_suffix1, ((1 + this.sci_BigVector__f_length0) | 0))
  }
});
$c_sci_Vector5.prototype.map__F1__sci_Vector = (function(f) {
  var x$1 = $m_sci_VectorStatics$().mapElems1__AO__F1__AO(this.sci_Vector__f_prefix1, f);
  var x$2 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(2, this.sci_Vector5__f_prefix2, f), 2);
  var x$3 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(3, this.sci_Vector5__f_prefix3, f), 3);
  var x$4 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(4, this.sci_Vector5__f_prefix4, f), 4);
  var x$5 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(5, this.sci_Vector5__f_data5, f), 5);
  var x$6 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(4, this.sci_Vector5__f_suffix4, f), 4);
  var x$7 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(3, this.sci_Vector5__f_suffix3, f), 3);
  var x$8 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(2, this.sci_Vector5__f_suffix2, f), 2);
  var x$9 = $m_sci_VectorStatics$().mapElems1__AO__F1__AO(this.sci_BigVector__f_suffix1, f);
  var x$10 = this.sci_Vector5__f_len1;
  var x$11 = this.sci_Vector5__f_len12;
  var x$12 = this.sci_Vector5__f_len123;
  var x$13 = this.sci_Vector5__f_len1234;
  var x$14 = this.sci_BigVector__f_length0;
  return new $c_sci_Vector5(x$1, x$10, x$2, x$11, x$3, x$12, x$4, x$13, x$5, x$6, x$7, x$8, x$9, x$14)
});
$c_sci_Vector5.prototype.slice0__I__I__sci_Vector = (function(lo, hi) {
  var b = new $c_sci_VectorSliceBuilder(lo, hi);
  b.consider__I__AO__V(1, this.sci_Vector__f_prefix1);
  b.consider__I__AO__V(2, this.sci_Vector5__f_prefix2);
  b.consider__I__AO__V(3, this.sci_Vector5__f_prefix3);
  b.consider__I__AO__V(4, this.sci_Vector5__f_prefix4);
  b.consider__I__AO__V(5, this.sci_Vector5__f_data5);
  b.consider__I__AO__V(4, this.sci_Vector5__f_suffix4);
  b.consider__I__AO__V(3, this.sci_Vector5__f_suffix3);
  b.consider__I__AO__V(2, this.sci_Vector5__f_suffix2);
  b.consider__I__AO__V(1, this.sci_BigVector__f_suffix1);
  return b.result__sci_Vector()
});
$c_sci_Vector5.prototype.tail__sci_Vector = (function() {
  if ((this.sci_Vector5__f_len1 > 1)) {
    var a = this.sci_Vector__f_prefix1;
    var to = a.u.length;
    var x$1 = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a, 1, to);
    var x$2 = (((-1) + this.sci_Vector5__f_len1) | 0);
    var x$3 = (((-1) + this.sci_Vector5__f_len12) | 0);
    var x$4 = (((-1) + this.sci_Vector5__f_len123) | 0);
    var x$5 = (((-1) + this.sci_Vector5__f_len1234) | 0);
    var x$6 = (((-1) + this.sci_BigVector__f_length0) | 0);
    var x$7 = this.sci_Vector5__f_prefix2;
    var x$8 = this.sci_Vector5__f_prefix3;
    var x$9 = this.sci_Vector5__f_prefix4;
    var x$10 = this.sci_Vector5__f_data5;
    var x$11 = this.sci_Vector5__f_suffix4;
    var x$12 = this.sci_Vector5__f_suffix3;
    var x$13 = this.sci_Vector5__f_suffix2;
    var x$14 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector5(x$1, x$2, x$7, x$3, x$8, x$4, x$9, x$5, x$10, x$11, x$12, x$13, x$14, x$6)
  } else {
    return this.slice0__I__I__sci_Vector(1, this.sci_BigVector__f_length0)
  }
});
$c_sci_Vector5.prototype.vectorSliceCount__I = (function() {
  return 9
});
$c_sci_Vector5.prototype.vectorSlice__I__AO = (function(idx) {
  switch (idx) {
    case 0: {
      return this.sci_Vector__f_prefix1;
      break
    }
    case 1: {
      return this.sci_Vector5__f_prefix2;
      break
    }
    case 2: {
      return this.sci_Vector5__f_prefix3;
      break
    }
    case 3: {
      return this.sci_Vector5__f_prefix4;
      break
    }
    case 4: {
      return this.sci_Vector5__f_data5;
      break
    }
    case 5: {
      return this.sci_Vector5__f_suffix4;
      break
    }
    case 6: {
      return this.sci_Vector5__f_suffix3;
      break
    }
    case 7: {
      return this.sci_Vector5__f_suffix2;
      break
    }
    case 8: {
      return this.sci_BigVector__f_suffix1;
      break
    }
    default: {
      throw new $c_s_MatchError(idx)
    }
  }
});
$c_sci_Vector5.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector = (function(suffix, k) {
  var suffix1b = $m_sci_VectorStatics$().append1IfSpace__AO__sc_IterableOnce__AO(this.sci_BigVector__f_suffix1, suffix);
  if ((suffix1b !== null)) {
    var x$2 = ((((this.sci_BigVector__f_length0 - this.sci_BigVector__f_suffix1.u.length) | 0) + suffix1b.u.length) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector5__f_len1;
    var x$5 = this.sci_Vector5__f_prefix2;
    var x$6 = this.sci_Vector5__f_len12;
    var x$7 = this.sci_Vector5__f_prefix3;
    var x$8 = this.sci_Vector5__f_len123;
    var x$9 = this.sci_Vector5__f_prefix4;
    var x$10 = this.sci_Vector5__f_len1234;
    var x$11 = this.sci_Vector5__f_data5;
    var x$12 = this.sci_Vector5__f_suffix4;
    var x$13 = this.sci_Vector5__f_suffix3;
    var x$14 = this.sci_Vector5__f_suffix2;
    return new $c_sci_Vector5(x$3, x$4, x$5, x$6, x$7, x$8, x$9, x$10, x$11, x$12, x$13, x$14, suffix1b, x$2)
  } else {
    return $c_sci_Vector.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector.call(this, suffix, k)
  }
});
$c_sci_Vector5.prototype.tail__O = (function() {
  return this.tail__sci_Vector()
});
$c_sci_Vector5.prototype.map__F1__O = (function(f) {
  return this.map__F1__sci_Vector(f)
});
$c_sci_Vector5.prototype.apply__O__O = (function(v1) {
  var index = $uI(v1);
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    var io = ((index - this.sci_Vector5__f_len1234) | 0);
    if ((io >= 0)) {
      var i5 = ((io >>> 20) | 0);
      var i4 = (31 & ((io >>> 15) | 0));
      var i3 = (31 & ((io >>> 10) | 0));
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      return ((i5 < this.sci_Vector5__f_data5.u.length) ? this.sci_Vector5__f_data5.get(i5).get(i4).get(i3).get(i2).get(i1) : ((i4 < this.sci_Vector5__f_suffix4.u.length) ? this.sci_Vector5__f_suffix4.get(i4).get(i3).get(i2).get(i1) : ((i3 < this.sci_Vector5__f_suffix3.u.length) ? this.sci_Vector5__f_suffix3.get(i3).get(i2).get(i1) : ((i2 < this.sci_Vector5__f_suffix2.u.length) ? this.sci_Vector5__f_suffix2.get(i2).get(i1) : this.sci_BigVector__f_suffix1.get(i1)))))
    } else if ((index >= this.sci_Vector5__f_len123)) {
      var io$2 = ((index - this.sci_Vector5__f_len123) | 0);
      return this.sci_Vector5__f_prefix4.get(((io$2 >>> 15) | 0)).get((31 & ((io$2 >>> 10) | 0))).get((31 & ((io$2 >>> 5) | 0))).get((31 & io$2))
    } else if ((index >= this.sci_Vector5__f_len12)) {
      var io$3 = ((index - this.sci_Vector5__f_len12) | 0);
      return this.sci_Vector5__f_prefix3.get(((io$3 >>> 10) | 0)).get((31 & ((io$3 >>> 5) | 0))).get((31 & io$3))
    } else if ((index >= this.sci_Vector5__f_len1)) {
      var io$4 = ((index - this.sci_Vector5__f_len1) | 0);
      return this.sci_Vector5__f_prefix2.get(((io$4 >>> 5) | 0)).get((31 & io$4))
    } else {
      return this.sci_Vector__f_prefix1.get(index)
    }
  } else {
    throw this.ioob__I__jl_IndexOutOfBoundsException(index)
  }
});
function $as_sci_Vector5(obj) {
  return (((obj instanceof $c_sci_Vector5) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Vector5"))
}
function $isArrayOf_sci_Vector5(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Vector5)))
}
function $asArrayOf_sci_Vector5(obj, depth) {
  return (($isArrayOf_sci_Vector5(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Vector5;", depth))
}
var $d_sci_Vector5 = new $TypeData().initClass({
  sci_Vector5: 0
}, false, "scala.collection.immutable.Vector5", {
  sci_Vector5: 1,
  sci_BigVector: 1,
  sci_VectorImpl: 1,
  sci_Vector: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Vector5.prototype.$classData = $d_sci_Vector5;
/** @constructor */
function $c_sci_Vector6(_prefix1, len1, prefix2, len12, prefix3, len123, prefix4, len1234, prefix5, len12345, data6, suffix5, suffix4, suffix3, suffix2, _suffix1, _length0) {
  this.sci_Vector__f_prefix1 = null;
  this.sci_BigVector__f_suffix1 = null;
  this.sci_BigVector__f_length0 = 0;
  this.sci_Vector6__f_len1 = 0;
  this.sci_Vector6__f_prefix2 = null;
  this.sci_Vector6__f_len12 = 0;
  this.sci_Vector6__f_prefix3 = null;
  this.sci_Vector6__f_len123 = 0;
  this.sci_Vector6__f_prefix4 = null;
  this.sci_Vector6__f_len1234 = 0;
  this.sci_Vector6__f_prefix5 = null;
  this.sci_Vector6__f_len12345 = 0;
  this.sci_Vector6__f_data6 = null;
  this.sci_Vector6__f_suffix5 = null;
  this.sci_Vector6__f_suffix4 = null;
  this.sci_Vector6__f_suffix3 = null;
  this.sci_Vector6__f_suffix2 = null;
  this.sci_Vector6__f_len1 = len1;
  this.sci_Vector6__f_prefix2 = prefix2;
  this.sci_Vector6__f_len12 = len12;
  this.sci_Vector6__f_prefix3 = prefix3;
  this.sci_Vector6__f_len123 = len123;
  this.sci_Vector6__f_prefix4 = prefix4;
  this.sci_Vector6__f_len1234 = len1234;
  this.sci_Vector6__f_prefix5 = prefix5;
  this.sci_Vector6__f_len12345 = len12345;
  this.sci_Vector6__f_data6 = data6;
  this.sci_Vector6__f_suffix5 = suffix5;
  this.sci_Vector6__f_suffix4 = suffix4;
  this.sci_Vector6__f_suffix3 = suffix3;
  this.sci_Vector6__f_suffix2 = suffix2;
  $ct_sci_BigVector__AO__AO__I__(this, _prefix1, _suffix1, _length0)
}
$c_sci_Vector6.prototype = new $h_sci_BigVector();
$c_sci_Vector6.prototype.constructor = $c_sci_Vector6;
/** @constructor */
function $h_sci_Vector6() {
  /*<skip>*/
}
$h_sci_Vector6.prototype = $c_sci_Vector6.prototype;
$c_sci_Vector6.prototype.apply__I__O = (function(index) {
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    var io = ((index - this.sci_Vector6__f_len12345) | 0);
    if ((io >= 0)) {
      var i6 = ((io >>> 25) | 0);
      var i5 = (31 & ((io >>> 20) | 0));
      var i4 = (31 & ((io >>> 15) | 0));
      var i3 = (31 & ((io >>> 10) | 0));
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      return ((i6 < this.sci_Vector6__f_data6.u.length) ? this.sci_Vector6__f_data6.get(i6).get(i5).get(i4).get(i3).get(i2).get(i1) : ((i5 < this.sci_Vector6__f_suffix5.u.length) ? this.sci_Vector6__f_suffix5.get(i5).get(i4).get(i3).get(i2).get(i1) : ((i4 < this.sci_Vector6__f_suffix4.u.length) ? this.sci_Vector6__f_suffix4.get(i4).get(i3).get(i2).get(i1) : ((i3 < this.sci_Vector6__f_suffix3.u.length) ? this.sci_Vector6__f_suffix3.get(i3).get(i2).get(i1) : ((i2 < this.sci_Vector6__f_suffix2.u.length) ? this.sci_Vector6__f_suffix2.get(i2).get(i1) : this.sci_BigVector__f_suffix1.get(i1))))))
    } else if ((index >= this.sci_Vector6__f_len1234)) {
      var io$2 = ((index - this.sci_Vector6__f_len1234) | 0);
      return this.sci_Vector6__f_prefix5.get(((io$2 >>> 20) | 0)).get((31 & ((io$2 >>> 15) | 0))).get((31 & ((io$2 >>> 10) | 0))).get((31 & ((io$2 >>> 5) | 0))).get((31 & io$2))
    } else if ((index >= this.sci_Vector6__f_len123)) {
      var io$3 = ((index - this.sci_Vector6__f_len123) | 0);
      return this.sci_Vector6__f_prefix4.get(((io$3 >>> 15) | 0)).get((31 & ((io$3 >>> 10) | 0))).get((31 & ((io$3 >>> 5) | 0))).get((31 & io$3))
    } else if ((index >= this.sci_Vector6__f_len12)) {
      var io$4 = ((index - this.sci_Vector6__f_len12) | 0);
      return this.sci_Vector6__f_prefix3.get(((io$4 >>> 10) | 0)).get((31 & ((io$4 >>> 5) | 0))).get((31 & io$4))
    } else if ((index >= this.sci_Vector6__f_len1)) {
      var io$5 = ((index - this.sci_Vector6__f_len1) | 0);
      return this.sci_Vector6__f_prefix2.get(((io$5 >>> 5) | 0)).get((31 & io$5))
    } else {
      return this.sci_Vector__f_prefix1.get(index)
    }
  } else {
    throw this.ioob__I__jl_IndexOutOfBoundsException(index)
  }
});
$c_sci_Vector6.prototype.updated__I__O__sci_Vector = (function(index, elem) {
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    if ((index >= this.sci_Vector6__f_len12345)) {
      var io = ((index - this.sci_Vector6__f_len12345) | 0);
      var i6 = ((io >>> 25) | 0);
      var i5 = (31 & ((io >>> 20) | 0));
      var i4 = (31 & ((io >>> 15) | 0));
      var i3 = (31 & ((io >>> 10) | 0));
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      if ((i6 < this.sci_Vector6__f_data6.u.length)) {
        var a6 = this.sci_Vector6__f_data6;
        var a6c = a6.clone__O();
        var a5 = a6c.get(i6);
        var a5c = a5.clone__O();
        var a4 = a5c.get(i5);
        var a4c = a4.clone__O();
        var a3 = a4c.get(i4);
        var a3c = a3.clone__O();
        var a2 = a3c.get(i3);
        var a2c = a2.clone__O();
        var a1 = a2c.get(i2);
        var a1c = a1.clone__O();
        a1c.set(i1, elem);
        a2c.set(i2, a1c);
        a3c.set(i3, a2c);
        a4c.set(i4, a3c);
        a5c.set(i5, a4c);
        a6c.set(i6, a5c);
        var x$2 = this.sci_Vector__f_prefix1;
        var x$3 = this.sci_Vector6__f_len1;
        var x$4 = this.sci_Vector6__f_prefix2;
        var x$5 = this.sci_Vector6__f_len12;
        var x$6 = this.sci_Vector6__f_prefix3;
        var x$7 = this.sci_Vector6__f_len123;
        var x$8 = this.sci_Vector6__f_prefix4;
        var x$9 = this.sci_Vector6__f_len1234;
        var x$10 = this.sci_Vector6__f_prefix5;
        var x$11 = this.sci_Vector6__f_len12345;
        var x$12 = this.sci_Vector6__f_suffix5;
        var x$13 = this.sci_Vector6__f_suffix4;
        var x$14 = this.sci_Vector6__f_suffix3;
        var x$15 = this.sci_Vector6__f_suffix2;
        var x$16 = this.sci_BigVector__f_suffix1;
        var x$17 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector6(x$2, x$3, x$4, x$5, x$6, x$7, x$8, x$9, x$10, x$11, a6c, x$12, x$13, x$14, x$15, x$16, x$17)
      } else if ((i5 < this.sci_Vector6__f_suffix5.u.length)) {
        var a5$1 = this.sci_Vector6__f_suffix5;
        var a5c$1 = a5$1.clone__O();
        var a4$1 = a5c$1.get(i5);
        var a4c$1 = a4$1.clone__O();
        var a3$1 = a4c$1.get(i4);
        var a3c$1 = a3$1.clone__O();
        var a2$1 = a3c$1.get(i3);
        var a2c$1 = a2$1.clone__O();
        var a1$1 = a2c$1.get(i2);
        var a1c$1 = a1$1.clone__O();
        a1c$1.set(i1, elem);
        a2c$1.set(i2, a1c$1);
        a3c$1.set(i3, a2c$1);
        a4c$1.set(i4, a3c$1);
        a5c$1.set(i5, a4c$1);
        var x$19 = this.sci_Vector__f_prefix1;
        var x$20 = this.sci_Vector6__f_len1;
        var x$21 = this.sci_Vector6__f_prefix2;
        var x$22 = this.sci_Vector6__f_len12;
        var x$23 = this.sci_Vector6__f_prefix3;
        var x$24 = this.sci_Vector6__f_len123;
        var x$25 = this.sci_Vector6__f_prefix4;
        var x$26 = this.sci_Vector6__f_len1234;
        var x$27 = this.sci_Vector6__f_prefix5;
        var x$28 = this.sci_Vector6__f_len12345;
        var x$29 = this.sci_Vector6__f_data6;
        var x$30 = this.sci_Vector6__f_suffix4;
        var x$31 = this.sci_Vector6__f_suffix3;
        var x$32 = this.sci_Vector6__f_suffix2;
        var x$33 = this.sci_BigVector__f_suffix1;
        var x$34 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector6(x$19, x$20, x$21, x$22, x$23, x$24, x$25, x$26, x$27, x$28, x$29, a5c$1, x$30, x$31, x$32, x$33, x$34)
      } else if ((i4 < this.sci_Vector6__f_suffix4.u.length)) {
        var a4$2 = this.sci_Vector6__f_suffix4;
        var a4c$2 = a4$2.clone__O();
        var a3$2 = a4c$2.get(i4);
        var a3c$2 = a3$2.clone__O();
        var a2$2 = a3c$2.get(i3);
        var a2c$2 = a2$2.clone__O();
        var a1$2 = a2c$2.get(i2);
        var a1c$2 = a1$2.clone__O();
        a1c$2.set(i1, elem);
        a2c$2.set(i2, a1c$2);
        a3c$2.set(i3, a2c$2);
        a4c$2.set(i4, a3c$2);
        var x$36 = this.sci_Vector__f_prefix1;
        var x$37 = this.sci_Vector6__f_len1;
        var x$38 = this.sci_Vector6__f_prefix2;
        var x$39 = this.sci_Vector6__f_len12;
        var x$40 = this.sci_Vector6__f_prefix3;
        var x$41 = this.sci_Vector6__f_len123;
        var x$42 = this.sci_Vector6__f_prefix4;
        var x$43 = this.sci_Vector6__f_len1234;
        var x$44 = this.sci_Vector6__f_prefix5;
        var x$45 = this.sci_Vector6__f_len12345;
        var x$46 = this.sci_Vector6__f_data6;
        var x$47 = this.sci_Vector6__f_suffix5;
        var x$48 = this.sci_Vector6__f_suffix3;
        var x$49 = this.sci_Vector6__f_suffix2;
        var x$50 = this.sci_BigVector__f_suffix1;
        var x$51 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector6(x$36, x$37, x$38, x$39, x$40, x$41, x$42, x$43, x$44, x$45, x$46, x$47, a4c$2, x$48, x$49, x$50, x$51)
      } else if ((i3 < this.sci_Vector6__f_suffix3.u.length)) {
        var a3$3 = this.sci_Vector6__f_suffix3;
        var a3c$3 = a3$3.clone__O();
        var a2$3 = a3c$3.get(i3);
        var a2c$3 = a2$3.clone__O();
        var a1$3 = a2c$3.get(i2);
        var a1c$3 = a1$3.clone__O();
        a1c$3.set(i1, elem);
        a2c$3.set(i2, a1c$3);
        a3c$3.set(i3, a2c$3);
        var x$53 = this.sci_Vector__f_prefix1;
        var x$54 = this.sci_Vector6__f_len1;
        var x$55 = this.sci_Vector6__f_prefix2;
        var x$56 = this.sci_Vector6__f_len12;
        var x$57 = this.sci_Vector6__f_prefix3;
        var x$58 = this.sci_Vector6__f_len123;
        var x$59 = this.sci_Vector6__f_prefix4;
        var x$60 = this.sci_Vector6__f_len1234;
        var x$61 = this.sci_Vector6__f_prefix5;
        var x$62 = this.sci_Vector6__f_len12345;
        var x$63 = this.sci_Vector6__f_data6;
        var x$64 = this.sci_Vector6__f_suffix5;
        var x$65 = this.sci_Vector6__f_suffix4;
        var x$66 = this.sci_Vector6__f_suffix2;
        var x$67 = this.sci_BigVector__f_suffix1;
        var x$68 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector6(x$53, x$54, x$55, x$56, x$57, x$58, x$59, x$60, x$61, x$62, x$63, x$64, x$65, a3c$3, x$66, x$67, x$68)
      } else if ((i2 < this.sci_Vector6__f_suffix2.u.length)) {
        var a2$4 = this.sci_Vector6__f_suffix2;
        var a2c$4 = a2$4.clone__O();
        var a1$4 = a2c$4.get(i2);
        var a1c$4 = a1$4.clone__O();
        a1c$4.set(i1, elem);
        a2c$4.set(i2, a1c$4);
        var x$70 = this.sci_Vector__f_prefix1;
        var x$71 = this.sci_Vector6__f_len1;
        var x$72 = this.sci_Vector6__f_prefix2;
        var x$73 = this.sci_Vector6__f_len12;
        var x$74 = this.sci_Vector6__f_prefix3;
        var x$75 = this.sci_Vector6__f_len123;
        var x$76 = this.sci_Vector6__f_prefix4;
        var x$77 = this.sci_Vector6__f_len1234;
        var x$78 = this.sci_Vector6__f_prefix5;
        var x$79 = this.sci_Vector6__f_len12345;
        var x$80 = this.sci_Vector6__f_data6;
        var x$81 = this.sci_Vector6__f_suffix5;
        var x$82 = this.sci_Vector6__f_suffix4;
        var x$83 = this.sci_Vector6__f_suffix3;
        var x$84 = this.sci_BigVector__f_suffix1;
        var x$85 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector6(x$70, x$71, x$72, x$73, x$74, x$75, x$76, x$77, x$78, x$79, x$80, x$81, x$82, x$83, a2c$4, x$84, x$85)
      } else {
        var a1$5 = this.sci_BigVector__f_suffix1;
        var a1c$5 = a1$5.clone__O();
        a1c$5.set(i1, elem);
        var x$87 = this.sci_Vector__f_prefix1;
        var x$88 = this.sci_Vector6__f_len1;
        var x$89 = this.sci_Vector6__f_prefix2;
        var x$90 = this.sci_Vector6__f_len12;
        var x$91 = this.sci_Vector6__f_prefix3;
        var x$92 = this.sci_Vector6__f_len123;
        var x$93 = this.sci_Vector6__f_prefix4;
        var x$94 = this.sci_Vector6__f_len1234;
        var x$95 = this.sci_Vector6__f_prefix5;
        var x$96 = this.sci_Vector6__f_len12345;
        var x$97 = this.sci_Vector6__f_data6;
        var x$98 = this.sci_Vector6__f_suffix5;
        var x$99 = this.sci_Vector6__f_suffix4;
        var x$100 = this.sci_Vector6__f_suffix3;
        var x$101 = this.sci_Vector6__f_suffix2;
        var x$102 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector6(x$87, x$88, x$89, x$90, x$91, x$92, x$93, x$94, x$95, x$96, x$97, x$98, x$99, x$100, x$101, a1c$5, x$102)
      }
    } else if ((index >= this.sci_Vector6__f_len1234)) {
      var io$2 = ((index - this.sci_Vector6__f_len1234) | 0);
      var a5$2 = this.sci_Vector6__f_prefix5;
      var idx5 = ((io$2 >>> 20) | 0);
      var idx4 = (31 & ((io$2 >>> 15) | 0));
      var idx3 = (31 & ((io$2 >>> 10) | 0));
      var idx2 = (31 & ((io$2 >>> 5) | 0));
      var idx1 = (31 & io$2);
      var a5c$2 = a5$2.clone__O();
      var a4$3 = a5c$2.get(idx5);
      var a4c$3 = a4$3.clone__O();
      var a3$4 = a4c$3.get(idx4);
      var a3c$4 = a3$4.clone__O();
      var a2$5 = a3c$4.get(idx3);
      var a2c$5 = a2$5.clone__O();
      var a1$6 = a2c$5.get(idx2);
      var a1c$6 = a1$6.clone__O();
      a1c$6.set(idx1, elem);
      a2c$5.set(idx2, a1c$6);
      a3c$4.set(idx3, a2c$5);
      a4c$3.set(idx4, a3c$4);
      a5c$2.set(idx5, a4c$3);
      var x$104 = this.sci_Vector__f_prefix1;
      var x$105 = this.sci_Vector6__f_len1;
      var x$106 = this.sci_Vector6__f_prefix2;
      var x$107 = this.sci_Vector6__f_len12;
      var x$108 = this.sci_Vector6__f_prefix3;
      var x$109 = this.sci_Vector6__f_len123;
      var x$110 = this.sci_Vector6__f_prefix4;
      var x$111 = this.sci_Vector6__f_len1234;
      var x$112 = this.sci_Vector6__f_len12345;
      var x$113 = this.sci_Vector6__f_data6;
      var x$114 = this.sci_Vector6__f_suffix5;
      var x$115 = this.sci_Vector6__f_suffix4;
      var x$116 = this.sci_Vector6__f_suffix3;
      var x$117 = this.sci_Vector6__f_suffix2;
      var x$118 = this.sci_BigVector__f_suffix1;
      var x$119 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector6(x$104, x$105, x$106, x$107, x$108, x$109, x$110, x$111, a5c$2, x$112, x$113, x$114, x$115, x$116, x$117, x$118, x$119)
    } else if ((index >= this.sci_Vector6__f_len123)) {
      var io$3 = ((index - this.sci_Vector6__f_len123) | 0);
      var a4$4 = this.sci_Vector6__f_prefix4;
      var idx4$1 = ((io$3 >>> 15) | 0);
      var idx3$1 = (31 & ((io$3 >>> 10) | 0));
      var idx2$1 = (31 & ((io$3 >>> 5) | 0));
      var idx1$1 = (31 & io$3);
      var a4c$4 = a4$4.clone__O();
      var a3$5 = a4c$4.get(idx4$1);
      var a3c$5 = a3$5.clone__O();
      var a2$6 = a3c$5.get(idx3$1);
      var a2c$6 = a2$6.clone__O();
      var a1$7 = a2c$6.get(idx2$1);
      var a1c$7 = a1$7.clone__O();
      a1c$7.set(idx1$1, elem);
      a2c$6.set(idx2$1, a1c$7);
      a3c$5.set(idx3$1, a2c$6);
      a4c$4.set(idx4$1, a3c$5);
      var x$121 = this.sci_Vector__f_prefix1;
      var x$122 = this.sci_Vector6__f_len1;
      var x$123 = this.sci_Vector6__f_prefix2;
      var x$124 = this.sci_Vector6__f_len12;
      var x$125 = this.sci_Vector6__f_prefix3;
      var x$126 = this.sci_Vector6__f_len123;
      var x$127 = this.sci_Vector6__f_len1234;
      var x$128 = this.sci_Vector6__f_prefix5;
      var x$129 = this.sci_Vector6__f_len12345;
      var x$130 = this.sci_Vector6__f_data6;
      var x$131 = this.sci_Vector6__f_suffix5;
      var x$132 = this.sci_Vector6__f_suffix4;
      var x$133 = this.sci_Vector6__f_suffix3;
      var x$134 = this.sci_Vector6__f_suffix2;
      var x$135 = this.sci_BigVector__f_suffix1;
      var x$136 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector6(x$121, x$122, x$123, x$124, x$125, x$126, a4c$4, x$127, x$128, x$129, x$130, x$131, x$132, x$133, x$134, x$135, x$136)
    } else if ((index >= this.sci_Vector6__f_len12)) {
      var io$4 = ((index - this.sci_Vector6__f_len12) | 0);
      var a3$6 = this.sci_Vector6__f_prefix3;
      var idx3$2 = ((io$4 >>> 10) | 0);
      var idx2$2 = (31 & ((io$4 >>> 5) | 0));
      var idx1$2 = (31 & io$4);
      var a3c$6 = a3$6.clone__O();
      var a2$7 = a3c$6.get(idx3$2);
      var a2c$7 = a2$7.clone__O();
      var a1$8 = a2c$7.get(idx2$2);
      var a1c$8 = a1$8.clone__O();
      a1c$8.set(idx1$2, elem);
      a2c$7.set(idx2$2, a1c$8);
      a3c$6.set(idx3$2, a2c$7);
      var x$138 = this.sci_Vector__f_prefix1;
      var x$139 = this.sci_Vector6__f_len1;
      var x$140 = this.sci_Vector6__f_prefix2;
      var x$141 = this.sci_Vector6__f_len12;
      var x$142 = this.sci_Vector6__f_len123;
      var x$143 = this.sci_Vector6__f_prefix4;
      var x$144 = this.sci_Vector6__f_len1234;
      var x$145 = this.sci_Vector6__f_prefix5;
      var x$146 = this.sci_Vector6__f_len12345;
      var x$147 = this.sci_Vector6__f_data6;
      var x$148 = this.sci_Vector6__f_suffix5;
      var x$149 = this.sci_Vector6__f_suffix4;
      var x$150 = this.sci_Vector6__f_suffix3;
      var x$151 = this.sci_Vector6__f_suffix2;
      var x$152 = this.sci_BigVector__f_suffix1;
      var x$153 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector6(x$138, x$139, x$140, x$141, a3c$6, x$142, x$143, x$144, x$145, x$146, x$147, x$148, x$149, x$150, x$151, x$152, x$153)
    } else if ((index >= this.sci_Vector6__f_len1)) {
      var io$5 = ((index - this.sci_Vector6__f_len1) | 0);
      var a2$8 = this.sci_Vector6__f_prefix2;
      var idx2$3 = ((io$5 >>> 5) | 0);
      var idx1$3 = (31 & io$5);
      var a2c$8 = a2$8.clone__O();
      var a1$9 = a2c$8.get(idx2$3);
      var a1c$9 = a1$9.clone__O();
      a1c$9.set(idx1$3, elem);
      a2c$8.set(idx2$3, a1c$9);
      var x$155 = this.sci_Vector__f_prefix1;
      var x$156 = this.sci_Vector6__f_len1;
      var x$157 = this.sci_Vector6__f_len12;
      var x$158 = this.sci_Vector6__f_prefix3;
      var x$159 = this.sci_Vector6__f_len123;
      var x$160 = this.sci_Vector6__f_prefix4;
      var x$161 = this.sci_Vector6__f_len1234;
      var x$162 = this.sci_Vector6__f_prefix5;
      var x$163 = this.sci_Vector6__f_len12345;
      var x$164 = this.sci_Vector6__f_data6;
      var x$165 = this.sci_Vector6__f_suffix5;
      var x$166 = this.sci_Vector6__f_suffix4;
      var x$167 = this.sci_Vector6__f_suffix3;
      var x$168 = this.sci_Vector6__f_suffix2;
      var x$169 = this.sci_BigVector__f_suffix1;
      var x$170 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector6(x$155, x$156, a2c$8, x$157, x$158, x$159, x$160, x$161, x$162, x$163, x$164, x$165, x$166, x$167, x$168, x$169, x$170)
    } else {
      var a1$10 = this.sci_Vector__f_prefix1;
      var a1c$10 = a1$10.clone__O();
      a1c$10.set(index, elem);
      var len1 = this.sci_Vector6__f_len1;
      var prefix2 = this.sci_Vector6__f_prefix2;
      var len12 = this.sci_Vector6__f_len12;
      var prefix3 = this.sci_Vector6__f_prefix3;
      var len123 = this.sci_Vector6__f_len123;
      var prefix4 = this.sci_Vector6__f_prefix4;
      var len1234 = this.sci_Vector6__f_len1234;
      var prefix5 = this.sci_Vector6__f_prefix5;
      var len12345 = this.sci_Vector6__f_len12345;
      var data6 = this.sci_Vector6__f_data6;
      var suffix5 = this.sci_Vector6__f_suffix5;
      var suffix4 = this.sci_Vector6__f_suffix4;
      var suffix3 = this.sci_Vector6__f_suffix3;
      var suffix2 = this.sci_Vector6__f_suffix2;
      var suffix1 = this.sci_BigVector__f_suffix1;
      var length0 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector6(a1c$10, len1, prefix2, len12, prefix3, len123, prefix4, len1234, prefix5, len12345, data6, suffix5, suffix4, suffix3, suffix2, suffix1, length0)
    }
  } else {
    throw this.ioob__I__jl_IndexOutOfBoundsException(index)
  }
});
$c_sci_Vector6.prototype.appended__O__sci_Vector = (function(elem) {
  if ((this.sci_BigVector__f_suffix1.u.length < 32)) {
    var x$1 = $m_sci_VectorStatics$().copyAppend1__AO__O__AO(this.sci_BigVector__f_suffix1, elem);
    var x$2 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector6__f_len1;
    var x$5 = this.sci_Vector6__f_prefix2;
    var x$6 = this.sci_Vector6__f_len12;
    var x$7 = this.sci_Vector6__f_prefix3;
    var x$8 = this.sci_Vector6__f_len123;
    var x$9 = this.sci_Vector6__f_prefix4;
    var x$10 = this.sci_Vector6__f_len1234;
    var x$11 = this.sci_Vector6__f_prefix5;
    var x$12 = this.sci_Vector6__f_len12345;
    var x$13 = this.sci_Vector6__f_data6;
    var x$14 = this.sci_Vector6__f_suffix5;
    var x$15 = this.sci_Vector6__f_suffix4;
    var x$16 = this.sci_Vector6__f_suffix3;
    var x$17 = this.sci_Vector6__f_suffix2;
    return new $c_sci_Vector6(x$3, x$4, x$5, x$6, x$7, x$8, x$9, x$10, x$11, x$12, x$13, x$14, x$15, x$16, x$17, x$1, x$2)
  } else if ((this.sci_Vector6__f_suffix2.u.length < 31)) {
    var x$18 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix2, this.sci_BigVector__f_suffix1), 2);
    var a = new $ac_O(1);
    a.set(0, elem);
    var x$20 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$21 = this.sci_Vector__f_prefix1;
    var x$22 = this.sci_Vector6__f_len1;
    var x$23 = this.sci_Vector6__f_prefix2;
    var x$24 = this.sci_Vector6__f_len12;
    var x$25 = this.sci_Vector6__f_prefix3;
    var x$26 = this.sci_Vector6__f_len123;
    var x$27 = this.sci_Vector6__f_prefix4;
    var x$28 = this.sci_Vector6__f_len1234;
    var x$29 = this.sci_Vector6__f_prefix5;
    var x$30 = this.sci_Vector6__f_len12345;
    var x$31 = this.sci_Vector6__f_data6;
    var x$32 = this.sci_Vector6__f_suffix5;
    var x$33 = this.sci_Vector6__f_suffix4;
    var x$34 = this.sci_Vector6__f_suffix3;
    return new $c_sci_Vector6(x$21, x$22, x$23, x$24, x$25, x$26, x$27, x$28, x$29, x$30, x$31, x$32, x$33, x$34, x$18, a, x$20)
  } else if ((this.sci_Vector6__f_suffix3.u.length < 31)) {
    var x$35 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix3, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix2, this.sci_BigVector__f_suffix1)), 3);
    var x$36 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$1 = new $ac_O(1);
    a$1.set(0, elem);
    var x$38 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$39 = this.sci_Vector__f_prefix1;
    var x$40 = this.sci_Vector6__f_len1;
    var x$41 = this.sci_Vector6__f_prefix2;
    var x$42 = this.sci_Vector6__f_len12;
    var x$43 = this.sci_Vector6__f_prefix3;
    var x$44 = this.sci_Vector6__f_len123;
    var x$45 = this.sci_Vector6__f_prefix4;
    var x$46 = this.sci_Vector6__f_len1234;
    var x$47 = this.sci_Vector6__f_prefix5;
    var x$48 = this.sci_Vector6__f_len12345;
    var x$49 = this.sci_Vector6__f_data6;
    var x$50 = this.sci_Vector6__f_suffix5;
    var x$51 = this.sci_Vector6__f_suffix4;
    return new $c_sci_Vector6(x$39, x$40, x$41, x$42, x$43, x$44, x$45, x$46, x$47, x$48, x$49, x$50, x$51, x$35, x$36, a$1, x$38)
  } else if ((this.sci_Vector6__f_suffix4.u.length < 31)) {
    var x$52 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix4, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix3, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix2, this.sci_BigVector__f_suffix1))), 4);
    var x$53 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x$54 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$2 = new $ac_O(1);
    a$2.set(0, elem);
    var x$56 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$57 = this.sci_Vector__f_prefix1;
    var x$58 = this.sci_Vector6__f_len1;
    var x$59 = this.sci_Vector6__f_prefix2;
    var x$60 = this.sci_Vector6__f_len12;
    var x$61 = this.sci_Vector6__f_prefix3;
    var x$62 = this.sci_Vector6__f_len123;
    var x$63 = this.sci_Vector6__f_prefix4;
    var x$64 = this.sci_Vector6__f_len1234;
    var x$65 = this.sci_Vector6__f_prefix5;
    var x$66 = this.sci_Vector6__f_len12345;
    var x$67 = this.sci_Vector6__f_data6;
    var x$68 = this.sci_Vector6__f_suffix5;
    return new $c_sci_Vector6(x$57, x$58, x$59, x$60, x$61, x$62, x$63, x$64, x$65, x$66, x$67, x$68, x$52, x$53, x$54, a$2, x$56)
  } else if ((this.sci_Vector6__f_suffix5.u.length < 31)) {
    var x$69 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix5, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix4, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix3, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix2, this.sci_BigVector__f_suffix1)))), 5);
    var x$70 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
    var x$71 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x$72 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$3 = new $ac_O(1);
    a$3.set(0, elem);
    var x$74 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$75 = this.sci_Vector__f_prefix1;
    var x$76 = this.sci_Vector6__f_len1;
    var x$77 = this.sci_Vector6__f_prefix2;
    var x$78 = this.sci_Vector6__f_len12;
    var x$79 = this.sci_Vector6__f_prefix3;
    var x$80 = this.sci_Vector6__f_len123;
    var x$81 = this.sci_Vector6__f_prefix4;
    var x$82 = this.sci_Vector6__f_len1234;
    var x$83 = this.sci_Vector6__f_prefix5;
    var x$84 = this.sci_Vector6__f_len12345;
    var x$85 = this.sci_Vector6__f_data6;
    return new $c_sci_Vector6(x$75, x$76, x$77, x$78, x$79, x$80, x$81, x$82, x$83, x$84, x$85, x$69, x$70, x$71, x$72, a$3, x$74)
  } else if ((this.sci_Vector6__f_data6.u.length < 62)) {
    var x$86 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_data6, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix5, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix4, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix3, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix2, this.sci_BigVector__f_suffix1))))), 6);
    var x$87 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty5;
    var x$88 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
    var x$89 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x$90 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$4 = new $ac_O(1);
    a$4.set(0, elem);
    var x$92 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$93 = this.sci_Vector__f_prefix1;
    var x$94 = this.sci_Vector6__f_len1;
    var x$95 = this.sci_Vector6__f_prefix2;
    var x$96 = this.sci_Vector6__f_len12;
    var x$97 = this.sci_Vector6__f_prefix3;
    var x$98 = this.sci_Vector6__f_len123;
    var x$99 = this.sci_Vector6__f_prefix4;
    var x$100 = this.sci_Vector6__f_len1234;
    var x$101 = this.sci_Vector6__f_prefix5;
    var x$102 = this.sci_Vector6__f_len12345;
    return new $c_sci_Vector6(x$93, x$94, x$95, x$96, x$97, x$98, x$99, x$100, x$101, x$102, x$86, x$87, x$88, x$89, x$90, a$4, x$92)
  } else {
    throw $ct_jl_IllegalArgumentException__(new $c_jl_IllegalArgumentException())
  }
});
$c_sci_Vector6.prototype.prepended__O__sci_Vector = (function(elem) {
  if ((this.sci_Vector6__f_len1 < 32)) {
    var x$1 = $m_sci_VectorStatics$().copyPrepend1__O__AO__AO(elem, this.sci_Vector__f_prefix1);
    var x$2 = ((1 + this.sci_Vector6__f_len1) | 0);
    var x$3 = ((1 + this.sci_Vector6__f_len12) | 0);
    var x$4 = ((1 + this.sci_Vector6__f_len123) | 0);
    var x$5 = ((1 + this.sci_Vector6__f_len1234) | 0);
    var x$6 = ((1 + this.sci_Vector6__f_len12345) | 0);
    var x$7 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$8 = this.sci_Vector6__f_prefix2;
    var x$9 = this.sci_Vector6__f_prefix3;
    var x$10 = this.sci_Vector6__f_prefix4;
    var x$11 = this.sci_Vector6__f_prefix5;
    var x$12 = this.sci_Vector6__f_data6;
    var x$13 = this.sci_Vector6__f_suffix5;
    var x$14 = this.sci_Vector6__f_suffix4;
    var x$15 = this.sci_Vector6__f_suffix3;
    var x$16 = this.sci_Vector6__f_suffix2;
    var x$17 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector6(x$1, x$2, x$8, x$3, x$9, x$4, x$10, x$5, x$11, x$6, x$12, x$13, x$14, x$15, x$16, x$17, x$7)
  } else if ((this.sci_Vector6__f_len12 < 1024)) {
    var a = new $ac_O(1);
    a.set(0, elem);
    var x$20 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector6__f_prefix2), 2);
    var x$21 = ((1 + this.sci_Vector6__f_len12) | 0);
    var x$22 = ((1 + this.sci_Vector6__f_len123) | 0);
    var x$23 = ((1 + this.sci_Vector6__f_len1234) | 0);
    var x$24 = ((1 + this.sci_Vector6__f_len12345) | 0);
    var x$25 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$26 = this.sci_Vector6__f_prefix3;
    var x$27 = this.sci_Vector6__f_prefix4;
    var x$28 = this.sci_Vector6__f_prefix5;
    var x$29 = this.sci_Vector6__f_data6;
    var x$30 = this.sci_Vector6__f_suffix5;
    var x$31 = this.sci_Vector6__f_suffix4;
    var x$32 = this.sci_Vector6__f_suffix3;
    var x$33 = this.sci_Vector6__f_suffix2;
    var x$34 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector6(a, 1, x$20, x$21, x$26, x$22, x$27, x$23, x$28, x$24, x$29, x$30, x$31, x$32, x$33, x$34, x$25)
  } else if ((this.sci_Vector6__f_len123 < 32768)) {
    var a$1 = new $ac_O(1);
    a$1.set(0, elem);
    var x$37 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var x$39 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector6__f_prefix2), this.sci_Vector6__f_prefix3), 3);
    var x$40 = ((1 + this.sci_Vector6__f_len123) | 0);
    var x$41 = ((1 + this.sci_Vector6__f_len1234) | 0);
    var x$42 = ((1 + this.sci_Vector6__f_len12345) | 0);
    var x$43 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$44 = this.sci_Vector6__f_prefix4;
    var x$45 = this.sci_Vector6__f_prefix5;
    var x$46 = this.sci_Vector6__f_data6;
    var x$47 = this.sci_Vector6__f_suffix5;
    var x$48 = this.sci_Vector6__f_suffix4;
    var x$49 = this.sci_Vector6__f_suffix3;
    var x$50 = this.sci_Vector6__f_suffix2;
    var x$51 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector6(a$1, 1, x$37, 1, x$39, x$40, x$44, x$41, x$45, x$42, x$46, x$47, x$48, x$49, x$50, x$51, x$43)
  } else if ((this.sci_Vector6__f_len1234 < 1048576)) {
    var a$2 = new $ac_O(1);
    a$2.set(0, elem);
    var x$54 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var x$56 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x$58 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector6__f_prefix2), this.sci_Vector6__f_prefix3), this.sci_Vector6__f_prefix4), 4);
    var x$59 = ((1 + this.sci_Vector6__f_len1234) | 0);
    var x$60 = ((1 + this.sci_Vector6__f_len12345) | 0);
    var x$61 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$62 = this.sci_Vector6__f_prefix5;
    var x$63 = this.sci_Vector6__f_data6;
    var x$64 = this.sci_Vector6__f_suffix5;
    var x$65 = this.sci_Vector6__f_suffix4;
    var x$66 = this.sci_Vector6__f_suffix3;
    var x$67 = this.sci_Vector6__f_suffix2;
    var x$68 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector6(a$2, 1, x$54, 1, x$56, 1, x$58, x$59, x$62, x$60, x$63, x$64, x$65, x$66, x$67, x$68, x$61)
  } else if ((this.sci_Vector6__f_len12345 < 33554432)) {
    var a$3 = new $ac_O(1);
    a$3.set(0, elem);
    var x$71 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var x$73 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x$75 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
    var x$77 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector6__f_prefix2), this.sci_Vector6__f_prefix3), this.sci_Vector6__f_prefix4), this.sci_Vector6__f_prefix5), 5);
    var x$78 = ((1 + this.sci_Vector6__f_len12345) | 0);
    var x$79 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$80 = this.sci_Vector6__f_data6;
    var x$81 = this.sci_Vector6__f_suffix5;
    var x$82 = this.sci_Vector6__f_suffix4;
    var x$83 = this.sci_Vector6__f_suffix3;
    var x$84 = this.sci_Vector6__f_suffix2;
    var x$85 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector6(a$3, 1, x$71, 1, x$73, 1, x$75, 1, x$77, x$78, x$80, x$81, x$82, x$83, x$84, x$85, x$79)
  } else if ((this.sci_Vector6__f_data6.u.length < 62)) {
    var a$4 = new $ac_O(1);
    a$4.set(0, elem);
    var x$88 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var x$90 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x$92 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
    var x$94 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty5;
    var x$96 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector6__f_prefix2), this.sci_Vector6__f_prefix3), this.sci_Vector6__f_prefix4), this.sci_Vector6__f_prefix5), this.sci_Vector6__f_data6), 6);
    var x$97 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$98 = this.sci_Vector6__f_suffix5;
    var x$99 = this.sci_Vector6__f_suffix4;
    var x$100 = this.sci_Vector6__f_suffix3;
    var x$101 = this.sci_Vector6__f_suffix2;
    var x$102 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector6(a$4, 1, x$88, 1, x$90, 1, x$92, 1, x$94, 1, x$96, x$98, x$99, x$100, x$101, x$102, x$97)
  } else {
    throw $ct_jl_IllegalArgumentException__(new $c_jl_IllegalArgumentException())
  }
});
$c_sci_Vector6.prototype.map__F1__sci_Vector = (function(f) {
  var x$1 = $m_sci_VectorStatics$().mapElems1__AO__F1__AO(this.sci_Vector__f_prefix1, f);
  var x$2 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(2, this.sci_Vector6__f_prefix2, f), 2);
  var x$3 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(3, this.sci_Vector6__f_prefix3, f), 3);
  var x$4 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(4, this.sci_Vector6__f_prefix4, f), 4);
  var x$5 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(5, this.sci_Vector6__f_prefix5, f), 5);
  var x$6 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(6, this.sci_Vector6__f_data6, f), 6);
  var x$7 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(5, this.sci_Vector6__f_suffix5, f), 5);
  var x$8 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(4, this.sci_Vector6__f_suffix4, f), 4);
  var x$9 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(3, this.sci_Vector6__f_suffix3, f), 3);
  var x$10 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(2, this.sci_Vector6__f_suffix2, f), 2);
  var x$11 = $m_sci_VectorStatics$().mapElems1__AO__F1__AO(this.sci_BigVector__f_suffix1, f);
  var x$12 = this.sci_Vector6__f_len1;
  var x$13 = this.sci_Vector6__f_len12;
  var x$14 = this.sci_Vector6__f_len123;
  var x$15 = this.sci_Vector6__f_len1234;
  var x$16 = this.sci_Vector6__f_len12345;
  var x$17 = this.sci_BigVector__f_length0;
  return new $c_sci_Vector6(x$1, x$12, x$2, x$13, x$3, x$14, x$4, x$15, x$5, x$16, x$6, x$7, x$8, x$9, x$10, x$11, x$17)
});
$c_sci_Vector6.prototype.slice0__I__I__sci_Vector = (function(lo, hi) {
  var b = new $c_sci_VectorSliceBuilder(lo, hi);
  b.consider__I__AO__V(1, this.sci_Vector__f_prefix1);
  b.consider__I__AO__V(2, this.sci_Vector6__f_prefix2);
  b.consider__I__AO__V(3, this.sci_Vector6__f_prefix3);
  b.consider__I__AO__V(4, this.sci_Vector6__f_prefix4);
  b.consider__I__AO__V(5, this.sci_Vector6__f_prefix5);
  b.consider__I__AO__V(6, this.sci_Vector6__f_data6);
  b.consider__I__AO__V(5, this.sci_Vector6__f_suffix5);
  b.consider__I__AO__V(4, this.sci_Vector6__f_suffix4);
  b.consider__I__AO__V(3, this.sci_Vector6__f_suffix3);
  b.consider__I__AO__V(2, this.sci_Vector6__f_suffix2);
  b.consider__I__AO__V(1, this.sci_BigVector__f_suffix1);
  return b.result__sci_Vector()
});
$c_sci_Vector6.prototype.tail__sci_Vector = (function() {
  if ((this.sci_Vector6__f_len1 > 1)) {
    var a = this.sci_Vector__f_prefix1;
    var to = a.u.length;
    var x$1 = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a, 1, to);
    var x$2 = (((-1) + this.sci_Vector6__f_len1) | 0);
    var x$3 = (((-1) + this.sci_Vector6__f_len12) | 0);
    var x$4 = (((-1) + this.sci_Vector6__f_len123) | 0);
    var x$5 = (((-1) + this.sci_Vector6__f_len1234) | 0);
    var x$6 = (((-1) + this.sci_Vector6__f_len12345) | 0);
    var x$7 = (((-1) + this.sci_BigVector__f_length0) | 0);
    var x$8 = this.sci_Vector6__f_prefix2;
    var x$9 = this.sci_Vector6__f_prefix3;
    var x$10 = this.sci_Vector6__f_prefix4;
    var x$11 = this.sci_Vector6__f_prefix5;
    var x$12 = this.sci_Vector6__f_data6;
    var x$13 = this.sci_Vector6__f_suffix5;
    var x$14 = this.sci_Vector6__f_suffix4;
    var x$15 = this.sci_Vector6__f_suffix3;
    var x$16 = this.sci_Vector6__f_suffix2;
    var x$17 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector6(x$1, x$2, x$8, x$3, x$9, x$4, x$10, x$5, x$11, x$6, x$12, x$13, x$14, x$15, x$16, x$17, x$7)
  } else {
    return this.slice0__I__I__sci_Vector(1, this.sci_BigVector__f_length0)
  }
});
$c_sci_Vector6.prototype.vectorSliceCount__I = (function() {
  return 11
});
$c_sci_Vector6.prototype.vectorSlice__I__AO = (function(idx) {
  switch (idx) {
    case 0: {
      return this.sci_Vector__f_prefix1;
      break
    }
    case 1: {
      return this.sci_Vector6__f_prefix2;
      break
    }
    case 2: {
      return this.sci_Vector6__f_prefix3;
      break
    }
    case 3: {
      return this.sci_Vector6__f_prefix4;
      break
    }
    case 4: {
      return this.sci_Vector6__f_prefix5;
      break
    }
    case 5: {
      return this.sci_Vector6__f_data6;
      break
    }
    case 6: {
      return this.sci_Vector6__f_suffix5;
      break
    }
    case 7: {
      return this.sci_Vector6__f_suffix4;
      break
    }
    case 8: {
      return this.sci_Vector6__f_suffix3;
      break
    }
    case 9: {
      return this.sci_Vector6__f_suffix2;
      break
    }
    case 10: {
      return this.sci_BigVector__f_suffix1;
      break
    }
    default: {
      throw new $c_s_MatchError(idx)
    }
  }
});
$c_sci_Vector6.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector = (function(suffix, k) {
  var suffix1b = $m_sci_VectorStatics$().append1IfSpace__AO__sc_IterableOnce__AO(this.sci_BigVector__f_suffix1, suffix);
  if ((suffix1b !== null)) {
    var x$2 = ((((this.sci_BigVector__f_length0 - this.sci_BigVector__f_suffix1.u.length) | 0) + suffix1b.u.length) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector6__f_len1;
    var x$5 = this.sci_Vector6__f_prefix2;
    var x$6 = this.sci_Vector6__f_len12;
    var x$7 = this.sci_Vector6__f_prefix3;
    var x$8 = this.sci_Vector6__f_len123;
    var x$9 = this.sci_Vector6__f_prefix4;
    var x$10 = this.sci_Vector6__f_len1234;
    var x$11 = this.sci_Vector6__f_prefix5;
    var x$12 = this.sci_Vector6__f_len12345;
    var x$13 = this.sci_Vector6__f_data6;
    var x$14 = this.sci_Vector6__f_suffix5;
    var x$15 = this.sci_Vector6__f_suffix4;
    var x$16 = this.sci_Vector6__f_suffix3;
    var x$17 = this.sci_Vector6__f_suffix2;
    return new $c_sci_Vector6(x$3, x$4, x$5, x$6, x$7, x$8, x$9, x$10, x$11, x$12, x$13, x$14, x$15, x$16, x$17, suffix1b, x$2)
  } else {
    return $c_sci_Vector.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector.call(this, suffix, k)
  }
});
$c_sci_Vector6.prototype.tail__O = (function() {
  return this.tail__sci_Vector()
});
$c_sci_Vector6.prototype.map__F1__O = (function(f) {
  return this.map__F1__sci_Vector(f)
});
$c_sci_Vector6.prototype.apply__O__O = (function(v1) {
  var index = $uI(v1);
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    var io = ((index - this.sci_Vector6__f_len12345) | 0);
    if ((io >= 0)) {
      var i6 = ((io >>> 25) | 0);
      var i5 = (31 & ((io >>> 20) | 0));
      var i4 = (31 & ((io >>> 15) | 0));
      var i3 = (31 & ((io >>> 10) | 0));
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      return ((i6 < this.sci_Vector6__f_data6.u.length) ? this.sci_Vector6__f_data6.get(i6).get(i5).get(i4).get(i3).get(i2).get(i1) : ((i5 < this.sci_Vector6__f_suffix5.u.length) ? this.sci_Vector6__f_suffix5.get(i5).get(i4).get(i3).get(i2).get(i1) : ((i4 < this.sci_Vector6__f_suffix4.u.length) ? this.sci_Vector6__f_suffix4.get(i4).get(i3).get(i2).get(i1) : ((i3 < this.sci_Vector6__f_suffix3.u.length) ? this.sci_Vector6__f_suffix3.get(i3).get(i2).get(i1) : ((i2 < this.sci_Vector6__f_suffix2.u.length) ? this.sci_Vector6__f_suffix2.get(i2).get(i1) : this.sci_BigVector__f_suffix1.get(i1))))))
    } else if ((index >= this.sci_Vector6__f_len1234)) {
      var io$2 = ((index - this.sci_Vector6__f_len1234) | 0);
      return this.sci_Vector6__f_prefix5.get(((io$2 >>> 20) | 0)).get((31 & ((io$2 >>> 15) | 0))).get((31 & ((io$2 >>> 10) | 0))).get((31 & ((io$2 >>> 5) | 0))).get((31 & io$2))
    } else if ((index >= this.sci_Vector6__f_len123)) {
      var io$3 = ((index - this.sci_Vector6__f_len123) | 0);
      return this.sci_Vector6__f_prefix4.get(((io$3 >>> 15) | 0)).get((31 & ((io$3 >>> 10) | 0))).get((31 & ((io$3 >>> 5) | 0))).get((31 & io$3))
    } else if ((index >= this.sci_Vector6__f_len12)) {
      var io$4 = ((index - this.sci_Vector6__f_len12) | 0);
      return this.sci_Vector6__f_prefix3.get(((io$4 >>> 10) | 0)).get((31 & ((io$4 >>> 5) | 0))).get((31 & io$4))
    } else if ((index >= this.sci_Vector6__f_len1)) {
      var io$5 = ((index - this.sci_Vector6__f_len1) | 0);
      return this.sci_Vector6__f_prefix2.get(((io$5 >>> 5) | 0)).get((31 & io$5))
    } else {
      return this.sci_Vector__f_prefix1.get(index)
    }
  } else {
    throw this.ioob__I__jl_IndexOutOfBoundsException(index)
  }
});
function $as_sci_Vector6(obj) {
  return (((obj instanceof $c_sci_Vector6) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Vector6"))
}
function $isArrayOf_sci_Vector6(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Vector6)))
}
function $asArrayOf_sci_Vector6(obj, depth) {
  return (($isArrayOf_sci_Vector6(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Vector6;", depth))
}
var $d_sci_Vector6 = new $TypeData().initClass({
  sci_Vector6: 0
}, false, "scala.collection.immutable.Vector6", {
  sci_Vector6: 1,
  sci_BigVector: 1,
  sci_VectorImpl: 1,
  sci_Vector: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Vector6.prototype.$classData = $d_sci_Vector6;
function $ct_scm_StringBuilder__jl_StringBuilder__($thiz, underlying) {
  $thiz.scm_StringBuilder__f_underlying = underlying;
  return $thiz
}
function $ct_scm_StringBuilder__($thiz) {
  $ct_scm_StringBuilder__jl_StringBuilder__($thiz, $ct_jl_StringBuilder__(new $c_jl_StringBuilder()));
  return $thiz
}
function $ct_scm_StringBuilder__T__($thiz, str) {
  $ct_scm_StringBuilder__jl_StringBuilder__($thiz, $ct_jl_StringBuilder__T__(new $c_jl_StringBuilder(), str));
  return $thiz
}
/** @constructor */
function $c_scm_StringBuilder() {
  this.scm_StringBuilder__f_underlying = null
}
$c_scm_StringBuilder.prototype = new $h_scm_AbstractSeq();
$c_scm_StringBuilder.prototype.constructor = $c_scm_StringBuilder;
/** @constructor */
function $h_scm_StringBuilder() {
  /*<skip>*/
}
$h_scm_StringBuilder.prototype = $c_scm_StringBuilder.prototype;
$c_scm_StringBuilder.prototype.stringPrefix__T = (function() {
  return "IndexedSeq"
});
$c_scm_StringBuilder.prototype.iterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_IndexedSeqView$Id(this);
  return new $c_sc_IndexedSeqView$IndexedSeqViewIterator(this$1)
});
$c_scm_StringBuilder.prototype.drop__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__drop__I__O(this, n)
});
$c_scm_StringBuilder.prototype.map__F1__O = (function(f) {
  return $f_sc_IndexedSeqOps__map__F1__O(this, f)
});
$c_scm_StringBuilder.prototype.head__O = (function() {
  return $bC(this.scm_StringBuilder__f_underlying.charAt__I__C(0))
});
$c_scm_StringBuilder.prototype.lengthCompare__I__I = (function(len) {
  var x = this.scm_StringBuilder__f_underlying.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1))
});
$c_scm_StringBuilder.prototype.sizeHint__I__V = (function(size) {
  /*<skip>*/
});
$c_scm_StringBuilder.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs)
});
$c_scm_StringBuilder.prototype.newSpecificBuilder__scm_Builder = (function() {
  return $ct_scm_GrowableBuilder__scm_Growable__(new $c_scm_GrowableBuilder(), $ct_scm_StringBuilder__(new $c_scm_StringBuilder()))
});
$c_scm_StringBuilder.prototype.length__I = (function() {
  return this.scm_StringBuilder__f_underlying.length__I()
});
$c_scm_StringBuilder.prototype.knownSize__I = (function() {
  return this.scm_StringBuilder__f_underlying.length__I()
});
$c_scm_StringBuilder.prototype.addOne__C__scm_StringBuilder = (function(x) {
  var this$1 = this.scm_StringBuilder__f_underlying;
  var str = $as_T(String.fromCharCode(x));
  this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str);
  return this
});
$c_scm_StringBuilder.prototype.toString__T = (function() {
  return this.scm_StringBuilder__f_underlying.jl_StringBuilder__f_java$lang$StringBuilder$$content
});
$c_scm_StringBuilder.prototype.toArray__s_reflect_ClassTag__O = (function(ct) {
  var x1 = ct.runtimeClass__jl_Class();
  return ((x1 === $d_C.getClassOf()) ? this.toCharArray__AC() : $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, ct))
});
$c_scm_StringBuilder.prototype.toCharArray__AC = (function() {
  var len = this.scm_StringBuilder__f_underlying.length__I();
  var arr = new $ac_C(len);
  this.scm_StringBuilder__f_underlying.getChars__I__I__AC__I__V(0, len, arr, 0);
  return arr
});
$c_scm_StringBuilder.prototype.append__O__scm_StringBuilder = (function(x) {
  var this$2 = this.scm_StringBuilder__f_underlying;
  var str = ("" + x);
  this$2.jl_StringBuilder__f_java$lang$StringBuilder$$content = (this$2.jl_StringBuilder__f_java$lang$StringBuilder$$content + str);
  return this
});
$c_scm_StringBuilder.prototype.append__T__scm_StringBuilder = (function(s) {
  var this$1 = this.scm_StringBuilder__f_underlying;
  this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content) + s);
  return this
});
$c_scm_StringBuilder.prototype.appendAll__sc_IterableOnce__scm_StringBuilder = (function(xs) {
  if ((xs instanceof $c_sci_WrappedString)) {
    var x2 = $as_sci_WrappedString(xs);
    var this$3 = this.scm_StringBuilder__f_underlying;
    $m_sci_WrappedString$();
    var str = x2.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self;
    this$3.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$3.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str)
  } else if ((xs instanceof $c_scm_ArraySeq$ofChar)) {
    var x3 = $as_scm_ArraySeq$ofChar(xs);
    this.scm_StringBuilder__f_underlying.append__AC__jl_StringBuilder(x3.scm_ArraySeq$ofChar__f_array)
  } else if ((xs instanceof $c_scm_StringBuilder)) {
    var x4 = $as_scm_StringBuilder(xs);
    var this$4 = this.scm_StringBuilder__f_underlying;
    var s = x4.scm_StringBuilder__f_underlying;
    this$4.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$4.jl_StringBuilder__f_java$lang$StringBuilder$$content) + s)
  } else {
    var ks = xs.knownSize__I();
    if ((ks !== 0)) {
      var b = this.scm_StringBuilder__f_underlying;
      if ((ks > 0)) {
        b.length__I()
      };
      var it = xs.iterator__sc_Iterator();
      while (it.hasNext__Z()) {
        var c = $uC(it.next__O());
        var str$1 = $as_T(String.fromCharCode(c));
        b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str$1)
      }
    }
  };
  return this
});
$c_scm_StringBuilder.prototype.append__I__scm_StringBuilder = (function(x) {
  var this$1 = this.scm_StringBuilder__f_underlying;
  var str = ("" + x);
  this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content = (this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content + str);
  return this
});
$c_scm_StringBuilder.prototype.charAt__I__C = (function(index) {
  return this.scm_StringBuilder__f_underlying.charAt__I__C(index)
});
$c_scm_StringBuilder.prototype.subSequence__I__I__jl_CharSequence = (function(start, end) {
  return this.scm_StringBuilder__f_underlying.substring__I__I__T(start, end)
});
$c_scm_StringBuilder.prototype.isEmpty__Z = (function() {
  return (this.scm_StringBuilder__f_underlying.length__I() === 0)
});
$c_scm_StringBuilder.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_scm_IndexedSeq$()
});
$c_scm_StringBuilder.prototype.result__O = (function() {
  return this.scm_StringBuilder__f_underlying.jl_StringBuilder__f_java$lang$StringBuilder$$content
});
$c_scm_StringBuilder.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__C__scm_StringBuilder($uC(elem))
});
$c_scm_StringBuilder.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  return $ct_scm_StringBuilder__(new $c_scm_StringBuilder()).appendAll__sc_IterableOnce__scm_StringBuilder(coll)
});
$c_scm_StringBuilder.prototype.fromSpecific__sc_IterableOnce__sc_IterableOps = (function(coll) {
  return $ct_scm_StringBuilder__(new $c_scm_StringBuilder()).appendAll__sc_IterableOnce__scm_StringBuilder(coll)
});
$c_scm_StringBuilder.prototype.apply__O__O = (function(v1) {
  var i = $uI(v1);
  return $bC(this.scm_StringBuilder__f_underlying.charAt__I__C(i))
});
$c_scm_StringBuilder.prototype.apply__I__O = (function(i) {
  return $bC(this.scm_StringBuilder__f_underlying.charAt__I__C(i))
});
function $as_scm_StringBuilder(obj) {
  return (((obj instanceof $c_scm_StringBuilder) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.StringBuilder"))
}
function $isArrayOf_scm_StringBuilder(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_StringBuilder)))
}
function $asArrayOf_scm_StringBuilder(obj, depth) {
  return (($isArrayOf_scm_StringBuilder(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.StringBuilder;", depth))
}
var $d_scm_StringBuilder = new $TypeData().initClass({
  scm_StringBuilder: 0
}, false, "scala.collection.mutable.StringBuilder", {
  scm_StringBuilder: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  jl_CharSequence: 1,
  Ljava_io_Serializable: 1
});
$c_scm_StringBuilder.prototype.$classData = $d_scm_StringBuilder;
function $p_scm_ListBuffer__copyElems__V($thiz) {
  var this$2 = new $c_scm_ListBuffer();
  var buf = this$2.addAll__sc_IterableOnce__scm_ListBuffer($thiz);
  $thiz.scm_ListBuffer__f_first = buf.scm_ListBuffer__f_first;
  $thiz.scm_ListBuffer__f_last0 = buf.scm_ListBuffer__f_last0;
  $thiz.scm_ListBuffer__f_aliased = false
}
function $p_scm_ListBuffer__ensureUnaliased__V($thiz) {
  $thiz.scm_ListBuffer__f_mutationCount = ((1 + $thiz.scm_ListBuffer__f_mutationCount) | 0);
  if ($thiz.scm_ListBuffer__f_aliased) {
    $p_scm_ListBuffer__copyElems__V($thiz)
  }
}
/** @constructor */
function $c_scm_ListBuffer() {
  this.scm_ListBuffer__f_mutationCount = 0;
  this.scm_ListBuffer__f_first = null;
  this.scm_ListBuffer__f_last0 = null;
  this.scm_ListBuffer__f_aliased = false;
  this.scm_ListBuffer__f_len = 0;
  this.scm_ListBuffer__f_mutationCount = 0;
  this.scm_ListBuffer__f_first = $m_sci_Nil$();
  this.scm_ListBuffer__f_last0 = null;
  this.scm_ListBuffer__f_aliased = false;
  this.scm_ListBuffer__f_len = 0
}
$c_scm_ListBuffer.prototype = new $h_scm_AbstractBuffer();
$c_scm_ListBuffer.prototype.constructor = $c_scm_ListBuffer;
/** @constructor */
function $h_scm_ListBuffer() {
  /*<skip>*/
}
$h_scm_ListBuffer.prototype = $c_scm_ListBuffer.prototype;
$c_scm_ListBuffer.prototype.sizeHint__I__V = (function(size) {
  /*<skip>*/
});
$c_scm_ListBuffer.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O(this, suffix)
});
$c_scm_ListBuffer.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f)
});
$c_scm_ListBuffer.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f)
});
$c_scm_ListBuffer.prototype.iterator__sc_Iterator = (function() {
  return new $c_scm_MutationTracker$CheckedIterator(this.scm_ListBuffer__f_first.iterator__sc_Iterator(), new $c_sjsr_AnonFunction0((function(this$1) {
    return (function() {
      return this$1.scm_ListBuffer__f_mutationCount
    })
  })(this)))
});
$c_scm_ListBuffer.prototype.iterableFactory__sc_SeqFactory = (function() {
  return $m_scm_ListBuffer$()
});
$c_scm_ListBuffer.prototype.apply__I__O = (function(i) {
  var this$1 = this.scm_ListBuffer__f_first;
  return $f_sc_LinearSeqOps__apply__I__O(this$1, i)
});
$c_scm_ListBuffer.prototype.length__I = (function() {
  return this.scm_ListBuffer__f_len
});
$c_scm_ListBuffer.prototype.knownSize__I = (function() {
  return this.scm_ListBuffer__f_len
});
$c_scm_ListBuffer.prototype.isEmpty__Z = (function() {
  return (this.scm_ListBuffer__f_len === 0)
});
$c_scm_ListBuffer.prototype.toList__sci_List = (function() {
  this.scm_ListBuffer__f_aliased = (!this.isEmpty__Z());
  return this.scm_ListBuffer__f_first
});
$c_scm_ListBuffer.prototype.addOne__O__scm_ListBuffer = (function(elem) {
  $p_scm_ListBuffer__ensureUnaliased__V(this);
  var last1 = new $c_sci_$colon$colon(elem, $m_sci_Nil$());
  if ((this.scm_ListBuffer__f_len === 0)) {
    this.scm_ListBuffer__f_first = last1
  } else {
    this.scm_ListBuffer__f_last0.sci_$colon$colon__f_next = last1
  };
  this.scm_ListBuffer__f_last0 = last1;
  this.scm_ListBuffer__f_len = ((1 + this.scm_ListBuffer__f_len) | 0);
  return this
});
$c_scm_ListBuffer.prototype.addAll__sc_IterableOnce__scm_ListBuffer = (function(xs) {
  if ((xs === this)) {
    if ((this.scm_ListBuffer__f_len > 0)) {
      $p_scm_ListBuffer__ensureUnaliased__V(this);
      var this$2 = new $c_scm_ListBuffer();
      var copy = this$2.addAll__sc_IterableOnce__scm_ListBuffer(this);
      this.scm_ListBuffer__f_last0.sci_$colon$colon__f_next = copy.scm_ListBuffer__f_first;
      this.scm_ListBuffer__f_last0 = copy.scm_ListBuffer__f_last0;
      this.scm_ListBuffer__f_len = (this.scm_ListBuffer__f_len << 1)
    }
  } else {
    var it = xs.iterator__sc_Iterator();
    if (it.hasNext__Z()) {
      $p_scm_ListBuffer__ensureUnaliased__V(this);
      var last1 = new $c_sci_$colon$colon(it.next__O(), $m_sci_Nil$());
      if ((this.scm_ListBuffer__f_len === 0)) {
        this.scm_ListBuffer__f_first = last1
      } else {
        this.scm_ListBuffer__f_last0.sci_$colon$colon__f_next = last1
      };
      this.scm_ListBuffer__f_last0 = last1;
      this.scm_ListBuffer__f_len = ((1 + this.scm_ListBuffer__f_len) | 0);
      while (it.hasNext__Z()) {
        var last1$2 = new $c_sci_$colon$colon(it.next__O(), $m_sci_Nil$());
        this.scm_ListBuffer__f_last0.sci_$colon$colon__f_next = last1$2;
        this.scm_ListBuffer__f_last0 = last1$2;
        this.scm_ListBuffer__f_len = ((1 + this.scm_ListBuffer__f_len) | 0)
      }
    }
  };
  return this
});
$c_scm_ListBuffer.prototype.stringPrefix__T = (function() {
  return "ListBuffer"
});
$c_scm_ListBuffer.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return this.addAll__sc_IterableOnce__scm_ListBuffer(xs)
});
$c_scm_ListBuffer.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__scm_ListBuffer(elem)
});
$c_scm_ListBuffer.prototype.result__O = (function() {
  return this.toList__sci_List()
});
$c_scm_ListBuffer.prototype.apply__O__O = (function(v1) {
  var i = $uI(v1);
  var this$1 = this.scm_ListBuffer__f_first;
  return $f_sc_LinearSeqOps__apply__I__O(this$1, i)
});
$c_scm_ListBuffer.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_scm_ListBuffer$()
});
function $as_scm_ListBuffer(obj) {
  return (((obj instanceof $c_scm_ListBuffer) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.ListBuffer"))
}
function $isArrayOf_scm_ListBuffer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ListBuffer)))
}
function $asArrayOf_scm_ListBuffer(obj, depth) {
  return (($isArrayOf_scm_ListBuffer(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.ListBuffer;", depth))
}
var $d_scm_ListBuffer = new $TypeData().initClass({
  scm_ListBuffer: 0
}, false, "scala.collection.mutable.ListBuffer", {
  scm_ListBuffer: 1,
  scm_AbstractBuffer: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_Buffer: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  scm_Shrinkable: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
});
$c_scm_ListBuffer.prototype.$classData = $d_scm_ListBuffer;
function $ct_scm_ArrayBuffer__AO__I__($thiz, initialElements, initialSize) {
  $thiz.scm_ArrayBuffer__f_array = initialElements;
  $thiz.scm_ArrayBuffer__f_size0 = initialSize;
  return $thiz
}
function $ct_scm_ArrayBuffer__($thiz) {
  $ct_scm_ArrayBuffer__AO__I__($thiz, new $ac_O(16), 0);
  return $thiz
}
/** @constructor */
function $c_scm_ArrayBuffer() {
  this.scm_ArrayBuffer__f_array = null;
  this.scm_ArrayBuffer__f_size0 = 0
}
$c_scm_ArrayBuffer.prototype = new $h_scm_AbstractBuffer();
$c_scm_ArrayBuffer.prototype.constructor = $c_scm_ArrayBuffer;
/** @constructor */
function $h_scm_ArrayBuffer() {
  /*<skip>*/
}
$h_scm_ArrayBuffer.prototype = $c_scm_ArrayBuffer.prototype;
$c_scm_ArrayBuffer.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O(this, suffix)
});
$c_scm_ArrayBuffer.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f)
});
$c_scm_ArrayBuffer.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f)
});
$c_scm_ArrayBuffer.prototype.iterator__sc_Iterator = (function() {
  var this$1 = new $c_scm_ArrayBufferView(this.scm_ArrayBuffer__f_array, this.scm_ArrayBuffer__f_size0);
  return new $c_sc_IndexedSeqView$IndexedSeqViewIterator(this$1)
});
$c_scm_ArrayBuffer.prototype.drop__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__drop__I__O(this, n)
});
$c_scm_ArrayBuffer.prototype.head__O = (function() {
  return this.apply__I__O(0)
});
$c_scm_ArrayBuffer.prototype.lengthCompare__I__I = (function(len) {
  var x = this.scm_ArrayBuffer__f_size0;
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1))
});
$c_scm_ArrayBuffer.prototype.knownSize__I = (function() {
  return this.scm_ArrayBuffer__f_size0
});
$c_scm_ArrayBuffer.prototype.ensureSize__I__V = (function(n) {
  this.scm_ArrayBuffer__f_array = $m_scm_ArrayBuffer$().scala$collection$mutable$ArrayBuffer$$ensureSize__AO__I__I__AO(this.scm_ArrayBuffer__f_array, this.scm_ArrayBuffer__f_size0, n)
});
$c_scm_ArrayBuffer.prototype.apply__I__O = (function(n) {
  var hi = ((1 + n) | 0);
  if ((n < 0)) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (((n + " is out of bounds (min 0, max ") + (((-1) + this.scm_ArrayBuffer__f_size0) | 0)) + ")"))
  };
  if ((hi > this.scm_ArrayBuffer__f_size0)) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ((((((-1) + hi) | 0) + " is out of bounds (min 0, max ") + (((-1) + this.scm_ArrayBuffer__f_size0) | 0)) + ")"))
  };
  return this.scm_ArrayBuffer__f_array.get(n)
});
$c_scm_ArrayBuffer.prototype.update__I__O__V = (function(index, elem) {
  var hi = ((1 + index) | 0);
  if ((index < 0)) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (((index + " is out of bounds (min 0, max ") + (((-1) + this.scm_ArrayBuffer__f_size0) | 0)) + ")"))
  };
  if ((hi > this.scm_ArrayBuffer__f_size0)) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ((((((-1) + hi) | 0) + " is out of bounds (min 0, max ") + (((-1) + this.scm_ArrayBuffer__f_size0) | 0)) + ")"))
  };
  this.scm_ArrayBuffer__f_array.set(index, elem)
});
$c_scm_ArrayBuffer.prototype.length__I = (function() {
  return this.scm_ArrayBuffer__f_size0
});
$c_scm_ArrayBuffer.prototype.iterableFactory__sc_SeqFactory = (function() {
  return $m_scm_ArrayBuffer$()
});
$c_scm_ArrayBuffer.prototype.addOne__O__scm_ArrayBuffer = (function(elem) {
  var i = this.scm_ArrayBuffer__f_size0;
  this.ensureSize__I__V(((1 + this.scm_ArrayBuffer__f_size0) | 0));
  this.scm_ArrayBuffer__f_size0 = ((1 + this.scm_ArrayBuffer__f_size0) | 0);
  this.update__I__O__V(i, elem);
  return this
});
$c_scm_ArrayBuffer.prototype.addAll__sc_IterableOnce__scm_ArrayBuffer = (function(elems) {
  if ((elems instanceof $c_scm_ArrayBuffer)) {
    var x2 = $as_scm_ArrayBuffer(elems);
    this.ensureSize__I__V(((this.scm_ArrayBuffer__f_size0 + x2.scm_ArrayBuffer__f_size0) | 0));
    $m_s_Array$().copy__O__I__O__I__I__V(x2.scm_ArrayBuffer__f_array, 0, this.scm_ArrayBuffer__f_array, this.scm_ArrayBuffer__f_size0, x2.scm_ArrayBuffer__f_size0);
    this.scm_ArrayBuffer__f_size0 = ((this.scm_ArrayBuffer__f_size0 + x2.scm_ArrayBuffer__f_size0) | 0)
  } else {
    $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, elems)
  };
  return this
});
$c_scm_ArrayBuffer.prototype.stringPrefix__T = (function() {
  return "ArrayBuffer"
});
$c_scm_ArrayBuffer.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  var srcLen = this.scm_ArrayBuffer__f_size0;
  var destLen = $m_sr_ScalaRunTime$().array_length__O__I(xs);
  var x = ((len < srcLen) ? len : srcLen);
  var y = ((destLen - start) | 0);
  var x$1 = ((x < y) ? x : y);
  var copied = ((x$1 > 0) ? x$1 : 0);
  if ((copied > 0)) {
    $m_s_Array$().copy__O__I__O__I__I__V(this.scm_ArrayBuffer__f_array, 0, xs, start, copied)
  };
  return copied
});
$c_scm_ArrayBuffer.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return this.addAll__sc_IterableOnce__scm_ArrayBuffer(xs)
});
$c_scm_ArrayBuffer.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__scm_ArrayBuffer(elem)
});
$c_scm_ArrayBuffer.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_scm_ArrayBuffer$()
});
$c_scm_ArrayBuffer.prototype.apply__O__O = (function(v1) {
  return this.apply__I__O($uI(v1))
});
function $as_scm_ArrayBuffer(obj) {
  return (((obj instanceof $c_scm_ArrayBuffer) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.ArrayBuffer"))
}
function $isArrayOf_scm_ArrayBuffer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArrayBuffer)))
}
function $asArrayOf_scm_ArrayBuffer(obj, depth) {
  return (($isArrayOf_scm_ArrayBuffer(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.ArrayBuffer;", depth))
}
var $d_scm_ArrayBuffer = new $TypeData().initClass({
  scm_ArrayBuffer: 0
}, false, "scala.collection.mutable.ArrayBuffer", {
  scm_ArrayBuffer: 1,
  scm_AbstractBuffer: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_Buffer: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  scm_Shrinkable: 1,
  scm_IndexedBuffer: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
});
$c_scm_ArrayBuffer.prototype.$classData = $d_scm_ArrayBuffer;
function $ct_sjs_js_WrappedArray__sjs_js_Array__($thiz, array) {
  $thiz.sjs_js_WrappedArray__f_scala$scalajs$js$WrappedArray$$array = array;
  return $thiz
}
function $ct_sjs_js_WrappedArray__($thiz) {
  $ct_sjs_js_WrappedArray__sjs_js_Array__($thiz, []);
  return $thiz
}
/** @constructor */
function $c_sjs_js_WrappedArray() {
  this.sjs_js_WrappedArray__f_scala$scalajs$js$WrappedArray$$array = null
}
$c_sjs_js_WrappedArray.prototype = new $h_scm_AbstractBuffer();
$c_sjs_js_WrappedArray.prototype.constructor = $c_sjs_js_WrappedArray;
/** @constructor */
function $h_sjs_js_WrappedArray() {
  /*<skip>*/
}
$h_sjs_js_WrappedArray.prototype = $c_sjs_js_WrappedArray.prototype;
$c_sjs_js_WrappedArray.prototype.sizeHint__I__V = (function(size) {
  /*<skip>*/
});
$c_sjs_js_WrappedArray.prototype.stringPrefix__T = (function() {
  return "IndexedSeq"
});
$c_sjs_js_WrappedArray.prototype.iterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_IndexedSeqView$Id(this);
  return new $c_sc_IndexedSeqView$IndexedSeqViewIterator(this$1)
});
$c_sjs_js_WrappedArray.prototype.drop__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__drop__I__O(this, n)
});
$c_sjs_js_WrappedArray.prototype.map__F1__O = (function(f) {
  return $f_sc_IndexedSeqOps__map__F1__O(this, f)
});
$c_sjs_js_WrappedArray.prototype.head__O = (function() {
  return this.sjs_js_WrappedArray__f_scala$scalajs$js$WrappedArray$$array[0]
});
$c_sjs_js_WrappedArray.prototype.lengthCompare__I__I = (function(len) {
  var x = $uI(this.sjs_js_WrappedArray__f_scala$scalajs$js$WrappedArray$$array.length);
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1))
});
$c_sjs_js_WrappedArray.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O(this, suffix)
});
$c_sjs_js_WrappedArray.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f)
});
$c_sjs_js_WrappedArray.prototype.iterableFactory__sc_SeqFactory = (function() {
  return $m_sjs_js_WrappedArray$()
});
$c_sjs_js_WrappedArray.prototype.apply__I__O = (function(index) {
  return this.sjs_js_WrappedArray__f_scala$scalajs$js$WrappedArray$$array[index]
});
$c_sjs_js_WrappedArray.prototype.length__I = (function() {
  return $uI(this.sjs_js_WrappedArray__f_scala$scalajs$js$WrappedArray$$array.length)
});
$c_sjs_js_WrappedArray.prototype.knownSize__I = (function() {
  return $uI(this.sjs_js_WrappedArray__f_scala$scalajs$js$WrappedArray$$array.length)
});
$c_sjs_js_WrappedArray.prototype.className__T = (function() {
  return "WrappedArray"
});
$c_sjs_js_WrappedArray.prototype.result__O = (function() {
  return this
});
$c_sjs_js_WrappedArray.prototype.addOne__O__scm_Growable = (function(elem) {
  this.sjs_js_WrappedArray__f_scala$scalajs$js$WrappedArray$$array.push(elem);
  return this
});
$c_sjs_js_WrappedArray.prototype.apply__O__O = (function(v1) {
  var index = $uI(v1);
  return this.sjs_js_WrappedArray__f_scala$scalajs$js$WrappedArray$$array[index]
});
$c_sjs_js_WrappedArray.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sjs_js_WrappedArray$()
});
function $as_sjs_js_WrappedArray(obj) {
  return (((obj instanceof $c_sjs_js_WrappedArray) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.scalajs.js.WrappedArray"))
}
function $isArrayOf_sjs_js_WrappedArray(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sjs_js_WrappedArray)))
}
function $asArrayOf_sjs_js_WrappedArray(obj, depth) {
  return (($isArrayOf_sjs_js_WrappedArray(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.scalajs.js.WrappedArray;", depth))
}
var $d_sjs_js_WrappedArray = new $TypeData().initClass({
  sjs_js_WrappedArray: 0
}, false, "scala.scalajs.js.WrappedArray", {
  sjs_js_WrappedArray: 1,
  scm_AbstractBuffer: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_Buffer: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  scm_Shrinkable: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  scm_IndexedBuffer: 1,
  scm_Builder: 1,
  Ljava_io_Serializable: 1
});
$c_sjs_js_WrappedArray.prototype.$classData = $d_sjs_js_WrappedArray;
$L0 = new $c_RTLong(0, 0);
$d_J.zero = $L0;
exports.ShowcaseApp = (function(arg) {
  var prep0 = arg;
  return new $c_Lshowcase_app_ShowcaseApp(prep0)
});
